(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2888],{

/***/ 44642:
/***/ (function(module, exports, __webpack_require__) {

// Save global object in a variable
var __global__ =
(typeof globalThis !== 'undefined' && globalThis) ||
(typeof self !== 'undefined' && self) ||
(typeof __webpack_require__.g !== 'undefined' && __webpack_require__.g);
// Create an object that extends from __global__ without the fetch function
var __globalThis__ = (function () {
function F() {
this.fetch = false;
this.DOMException = __global__.DOMException
}
F.prototype = __global__; // Needed for feature detection on whatwg-fetch's code
return new F();
})();
// Wraps whatwg-fetch with a function scope to hijack the global object
// "globalThis" that's going to be patched
(function(globalThis) {

var irrelevant = (function (exports) {

  /* eslint-disable no-prototype-builtins */
  var g =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof self !== 'undefined' && self) ||
    // eslint-disable-next-line no-undef
    (typeof __webpack_require__.g !== 'undefined' && __webpack_require__.g) ||
    {};

  var support = {
    searchParams: 'URLSearchParams' in g,
    iterable: 'Symbol' in g && 'iterator' in Symbol,
    blob:
      'FileReader' in g &&
      'Blob' in g &&
      (function() {
        try {
          new Blob();
          return true
        } catch (e) {
          return false
        }
      })(),
    formData: 'FormData' in g,
    arrayBuffer: 'ArrayBuffer' in g
  };

  function isDataView(obj) {
    return obj && DataView.prototype.isPrototypeOf(obj)
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ];

    var isArrayBufferView =
      ArrayBuffer.isView ||
      function(obj) {
        return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
      };
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name);
    }
    if (/[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(name) || name === '') {
      throw new TypeError('Invalid character in header field name: "' + name + '"')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value);
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift();
        return {done: value === undefined, value: value}
      }
    };

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      };
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {};

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value);
      }, this);
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        if (header.length != 2) {
          throw new TypeError('Headers constructor: expected name/value pair to be length 2, found' + header.length)
        }
        this.append(header[0], header[1]);
      }, this);
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name]);
      }, this);
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name);
    value = normalizeValue(value);
    var oldValue = this.map[name];
    this.map[name] = oldValue ? oldValue + ', ' + value : value;
  };

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)];
  };

  Headers.prototype.get = function(name) {
    name = normalizeName(name);
    return this.has(name) ? this.map[name] : null
  };

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  };

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value);
  };

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this);
      }
    }
  };

  Headers.prototype.keys = function() {
    var items = [];
    this.forEach(function(value, name) {
      items.push(name);
    });
    return iteratorFor(items)
  };

  Headers.prototype.values = function() {
    var items = [];
    this.forEach(function(value) {
      items.push(value);
    });
    return iteratorFor(items)
  };

  Headers.prototype.entries = function() {
    var items = [];
    this.forEach(function(value, name) {
      items.push([name, value]);
    });
    return iteratorFor(items)
  };

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
  }

  function consumed(body) {
    if (body._noBody) return
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true;
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result);
      };
      reader.onerror = function() {
        reject(reader.error);
      };
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsArrayBuffer(blob);
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    var match = /charset=([A-Za-z0-9_-]+)/.exec(blob.type);
    var encoding = match ? match[1] : 'utf-8';
    reader.readAsText(blob, encoding);
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf);
    var chars = new Array(view.length);

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i]);
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength);
      view.set(new Uint8Array(buf));
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false;

    this._initBody = function(body) {
      /*
        fetch-mock wraps the Response object in an ES6 Proxy to
        provide useful test harness features such as flush. However, on
        ES5 browsers without fetch or Proxy support pollyfills must be used;
        the proxy-pollyfill is unable to proxy an attribute unless it exists
        on the object before the Proxy is created. This change ensures
        Response.bodyUsed exists on the instance, while maintaining the
        semantic of setting Request.bodyUsed in the constructor before
        _initBody is called.
      */
      // eslint-disable-next-line no-self-assign
      this.bodyUsed = this.bodyUsed;
      this._bodyInit = body;
      if (!body) {
        this._noBody = true;
        this._bodyText = '';
      } else if (typeof body === 'string') {
        this._bodyText = body;
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body;
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body;
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString();
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer);
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer]);
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body);
      } else {
        this._bodyText = body = Object.prototype.toString.call(body);
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8');
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type);
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
      }
    };

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this);
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      };
    }

    this.arrayBuffer = function() {
      if (this._bodyArrayBuffer) {
        var isConsumed = consumed(this);
        if (isConsumed) {
          return isConsumed
        } else if (ArrayBuffer.isView(this._bodyArrayBuffer)) {
          return Promise.resolve(
            this._bodyArrayBuffer.buffer.slice(
              this._bodyArrayBuffer.byteOffset,
              this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength
            )
          )
        } else {
          return Promise.resolve(this._bodyArrayBuffer)
        }
      } else if (support.blob) {
        return this.blob().then(readBlobAsArrayBuffer)
      } else {
        throw new Error('could not read as ArrayBuffer')
      }
    };

    this.text = function() {
      var rejected = consumed(this);
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    };

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      };
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    };

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['CONNECT', 'DELETE', 'GET', 'HEAD', 'OPTIONS', 'PATCH', 'POST', 'PUT', 'TRACE'];

  function normalizeMethod(method) {
    var upcased = method.toUpperCase();
    return methods.indexOf(upcased) > -1 ? upcased : method
  }

  function Request(input, options) {
    if (!(this instanceof Request)) {
      throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.')
    }

    options = options || {};
    var body = options.body;

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url;
      this.credentials = input.credentials;
      if (!options.headers) {
        this.headers = new Headers(input.headers);
      }
      this.method = input.method;
      this.mode = input.mode;
      this.signal = input.signal;
      if (!body && input._bodyInit != null) {
        body = input._bodyInit;
        input.bodyUsed = true;
      }
    } else {
      this.url = String(input);
    }

    this.credentials = options.credentials || this.credentials || 'same-origin';
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers);
    }
    this.method = normalizeMethod(options.method || this.method || 'GET');
    this.mode = options.mode || this.mode || null;
    this.signal = options.signal || this.signal || (function () {
      if ('AbortController' in g) {
        var ctrl = new AbortController();
        return ctrl.signal;
      }
    }());
    this.referrer = null;

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body);

    if (this.method === 'GET' || this.method === 'HEAD') {
      if (options.cache === 'no-store' || options.cache === 'no-cache') {
        // Search for a '_' parameter in the query string
        var reParamSearch = /([?&])_=[^&]*/;
        if (reParamSearch.test(this.url)) {
          // If it already exists then set the value with the current time
          this.url = this.url.replace(reParamSearch, '$1_=' + new Date().getTime());
        } else {
          // Otherwise add a new '_' parameter to the end with the current time
          var reQueryString = /\?/;
          this.url += (reQueryString.test(this.url) ? '&' : '?') + '_=' + new Date().getTime();
        }
      }
    }
  }

  Request.prototype.clone = function() {
    return new Request(this, {body: this._bodyInit})
  };

  function decode(body) {
    var form = new FormData();
    body
      .trim()
      .split('&')
      .forEach(function(bytes) {
        if (bytes) {
          var split = bytes.split('=');
          var name = split.shift().replace(/\+/g, ' ');
          var value = split.join('=').replace(/\+/g, ' ');
          form.append(decodeURIComponent(name), decodeURIComponent(value));
        }
      });
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers();
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
    // Avoiding split via regex to work around a common IE11 bug with the core-js 3.6.0 regex polyfill
    // https://github.com/github/fetch/issues/748
    // https://github.com/zloirock/core-js/issues/751
    preProcessedHeaders
      .split('\r')
      .map(function(header) {
        return header.indexOf('\n') === 0 ? header.substr(1, header.length) : header
      })
      .forEach(function(line) {
        var parts = line.split(':');
        var key = parts.shift().trim();
        if (key) {
          var value = parts.join(':').trim();
          try {
            headers.append(key, value);
          } catch (error) {
            console.warn('Response ' + error.message);
          }
        }
      });
    return headers
  }

  Body.call(Request.prototype);

  function Response(bodyInit, options) {
    if (!(this instanceof Response)) {
      throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.')
    }
    if (!options) {
      options = {};
    }

    this.type = 'default';
    this.status = options.status === undefined ? 200 : options.status;
    if (this.status < 200 || this.status > 599) {
      throw new RangeError("Failed to construct 'Response': The status provided (0) is outside the range [200, 599].")
    }
    this.ok = this.status >= 200 && this.status < 300;
    this.statusText = options.statusText === undefined ? '' : '' + options.statusText;
    this.headers = new Headers(options.headers);
    this.url = options.url || '';
    this._initBody(bodyInit);
  }

  Body.call(Response.prototype);

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  };

  Response.error = function() {
    var response = new Response(null, {status: 200, statusText: ''});
    response.ok = false;
    response.status = 0;
    response.type = 'error';
    return response
  };

  var redirectStatuses = [301, 302, 303, 307, 308];

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  };

  exports.DOMException = g.DOMException;
  try {
    new exports.DOMException();
  } catch (err) {
    exports.DOMException = function(message, name) {
      this.message = message;
      this.name = name;
      var error = Error(message);
      this.stack = error.stack;
    };
    exports.DOMException.prototype = Object.create(Error.prototype);
    exports.DOMException.prototype.constructor = exports.DOMException;
  }

  function fetch(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init);

      if (request.signal && request.signal.aborted) {
        return reject(new exports.DOMException('Aborted', 'AbortError'))
      }

      var xhr = new XMLHttpRequest();

      function abortXhr() {
        xhr.abort();
      }

      xhr.onload = function() {
        var options = {
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        };
        // This check if specifically for when a user fetches a file locally from the file system
        // Only if the status is out of a normal range
        if (request.url.indexOf('file://') === 0 && (xhr.status < 200 || xhr.status > 599)) {
          options.status = 200;
        } else {
          options.status = xhr.status;
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
        var body = 'response' in xhr ? xhr.response : xhr.responseText;
        setTimeout(function() {
          resolve(new Response(body, options));
        }, 0);
      };

      xhr.onerror = function() {
        setTimeout(function() {
          reject(new TypeError('Network request failed'));
        }, 0);
      };

      xhr.ontimeout = function() {
        setTimeout(function() {
          reject(new TypeError('Network request timed out'));
        }, 0);
      };

      xhr.onabort = function() {
        setTimeout(function() {
          reject(new exports.DOMException('Aborted', 'AbortError'));
        }, 0);
      };

      function fixUrl(url) {
        try {
          return url === '' && g.location.href ? g.location.href : url
        } catch (e) {
          return url
        }
      }

      xhr.open(request.method, fixUrl(request.url), true);

      if (request.credentials === 'include') {
        xhr.withCredentials = true;
      } else if (request.credentials === 'omit') {
        xhr.withCredentials = false;
      }

      if ('responseType' in xhr) {
        if (support.blob) {
          xhr.responseType = 'blob';
        } else if (
          support.arrayBuffer
        ) {
          xhr.responseType = 'arraybuffer';
        }
      }

      if (init && typeof init.headers === 'object' && !(init.headers instanceof Headers || (g.Headers && init.headers instanceof g.Headers))) {
        var names = [];
        Object.getOwnPropertyNames(init.headers).forEach(function(name) {
          names.push(normalizeName(name));
          xhr.setRequestHeader(name, normalizeValue(init.headers[name]));
        });
        request.headers.forEach(function(value, name) {
          if (names.indexOf(name) === -1) {
            xhr.setRequestHeader(name, value);
          }
        });
      } else {
        request.headers.forEach(function(value, name) {
          xhr.setRequestHeader(name, value);
        });
      }

      if (request.signal) {
        request.signal.addEventListener('abort', abortXhr);

        xhr.onreadystatechange = function() {
          // DONE (success or failure)
          if (xhr.readyState === 4) {
            request.signal.removeEventListener('abort', abortXhr);
          }
        };
      }

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
    })
  }

  fetch.polyfill = true;

  if (!g.fetch) {
    g.fetch = fetch;
    g.Headers = Headers;
    g.Request = Request;
    g.Response = Response;
  }

  exports.Headers = Headers;
  exports.Request = Request;
  exports.Response = Response;
  exports.fetch = fetch;

  Object.defineProperty(exports, '__esModule', { value: true });

  return exports;

})({});
})(__globalThis__);
// This is a ponyfill, so...
__globalThis__.fetch.ponyfill = true;
delete __globalThis__.fetch.polyfill;
// Choose between native implementation (__global__) or custom implementation (__globalThis__)
var ctx = __global__.fetch ? __global__ : __globalThis__;
exports = ctx.fetch // To enable: import fetch from 'cross-fetch'
exports["default"] = ctx.fetch // For TypeScript consumers without esModuleInterop.
exports.fetch = ctx.fetch // To enable: import {fetch} from 'cross-fetch'
exports.Headers = ctx.Headers
exports.Request = ctx.Request
exports.Response = ctx.Response
module.exports = exports


/***/ }),

/***/ 45704:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "kZ": function() { return /* binding */ popperGenerator; }
});

// UNUSED EXPORTS: createPopper, detectOverflow

// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getBoundingClientRect.js
var getBoundingClientRect = __webpack_require__(50400);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getWindowScroll.js
var getWindowScroll = __webpack_require__(82163);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getWindow.js
var getWindow = __webpack_require__(62057);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/dom-utils/instanceOf.js
var instanceOf = __webpack_require__(62556);
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getHTMLElementScroll.js
function getHTMLElementScroll(element) {
  return {
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop
  };
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getNodeScroll.js




function getNodeScroll(node) {
  if (node === (0,getWindow/* default */.Z)(node) || !(0,instanceOf/* isHTMLElement */.Re)(node)) {
    return (0,getWindowScroll/* default */.Z)(node);
  } else {
    return getHTMLElementScroll(node);
  }
}
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getNodeName.js
var getNodeName = __webpack_require__(96333);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getWindowScrollBarX.js
var getWindowScrollBarX = __webpack_require__(4063);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getDocumentElement.js
var getDocumentElement = __webpack_require__(67252);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/dom-utils/isScrollParent.js
var isScrollParent = __webpack_require__(60611);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/utils/math.js
var math = __webpack_require__(138);
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getCompositeRect.js









function isElementScaled(element) {
  var rect = element.getBoundingClientRect();
  var scaleX = (0,math/* round */.NM)(rect.width) / element.offsetWidth || 1;
  var scaleY = (0,math/* round */.NM)(rect.height) / element.offsetHeight || 1;
  return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
// Composite means it takes into account transforms as well as layout.


function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
  if (isFixed === void 0) {
    isFixed = false;
  }

  var isOffsetParentAnElement = (0,instanceOf/* isHTMLElement */.Re)(offsetParent);
  var offsetParentIsScaled = (0,instanceOf/* isHTMLElement */.Re)(offsetParent) && isElementScaled(offsetParent);
  var documentElement = (0,getDocumentElement/* default */.Z)(offsetParent);
  var rect = (0,getBoundingClientRect/* default */.Z)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
  var scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var offsets = {
    x: 0,
    y: 0
  };

  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if ((0,getNodeName/* default */.Z)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
    (0,isScrollParent/* default */.Z)(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }

    if ((0,instanceOf/* isHTMLElement */.Re)(offsetParent)) {
      offsets = (0,getBoundingClientRect/* default */.Z)(offsetParent, true);
      offsets.x += offsetParent.clientLeft;
      offsets.y += offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = (0,getWindowScrollBarX/* default */.Z)(documentElement);
    }
  }

  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getLayoutRect.js
var getLayoutRect = __webpack_require__(40583);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/dom-utils/listScrollParents.js + 1 modules
var listScrollParents = __webpack_require__(31492);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getOffsetParent.js + 1 modules
var getOffsetParent = __webpack_require__(98552);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/enums.js
var enums = __webpack_require__(87701);
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/orderModifiers.js
 // source: https://stackoverflow.com/questions/49875255

function order(modifiers) {
  var map = new Map();
  var visited = new Set();
  var result = [];
  modifiers.forEach(function (modifier) {
    map.set(modifier.name, modifier);
  }); // On visiting object, check for its dependencies and visit them recursively

  function sort(modifier) {
    visited.add(modifier.name);
    var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
    requires.forEach(function (dep) {
      if (!visited.has(dep)) {
        var depModifier = map.get(dep);

        if (depModifier) {
          sort(depModifier);
        }
      }
    });
    result.push(modifier);
  }

  modifiers.forEach(function (modifier) {
    if (!visited.has(modifier.name)) {
      // check for visited object
      sort(modifier);
    }
  });
  return result;
}

function orderModifiers(modifiers) {
  // order based on dependencies
  var orderedModifiers = order(modifiers); // order based on phase

  return enums/* modifierPhases.reduce */.xs.reduce(function (acc, phase) {
    return acc.concat(orderedModifiers.filter(function (modifier) {
      return modifier.phase === phase;
    }));
  }, []);
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/debounce.js
function debounce(fn) {
  var pending;
  return function () {
    if (!pending) {
      pending = new Promise(function (resolve) {
        Promise.resolve().then(function () {
          pending = undefined;
          resolve(fn());
        });
      });
    }

    return pending;
  };
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/mergeByName.js
function mergeByName(modifiers) {
  var merged = modifiers.reduce(function (merged, current) {
    var existing = merged[current.name];
    merged[current.name] = existing ? Object.assign({}, existing, current, {
      options: Object.assign({}, existing.options, current.options),
      data: Object.assign({}, existing.data, current.data)
    }) : current;
    return merged;
  }, {}); // IE11 does not support Object.values

  return Object.keys(merged).map(function (key) {
    return merged[key];
  });
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/createPopper.js









var DEFAULT_OPTIONS = {
  placement: 'bottom',
  modifiers: [],
  strategy: 'absolute'
};

function areValidElements() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return !args.some(function (element) {
    return !(element && typeof element.getBoundingClientRect === 'function');
  });
}

function popperGenerator(generatorOptions) {
  if (generatorOptions === void 0) {
    generatorOptions = {};
  }

  var _generatorOptions = generatorOptions,
      _generatorOptions$def = _generatorOptions.defaultModifiers,
      defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def,
      _generatorOptions$def2 = _generatorOptions.defaultOptions,
      defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
  return function createPopper(reference, popper, options) {
    if (options === void 0) {
      options = defaultOptions;
    }

    var state = {
      placement: 'bottom',
      orderedModifiers: [],
      options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
      modifiersData: {},
      elements: {
        reference: reference,
        popper: popper
      },
      attributes: {},
      styles: {}
    };
    var effectCleanupFns = [];
    var isDestroyed = false;
    var instance = {
      state: state,
      setOptions: function setOptions(setOptionsAction) {
        var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
        cleanupModifierEffects();
        state.options = Object.assign({}, defaultOptions, state.options, options);
        state.scrollParents = {
          reference: (0,instanceOf/* isElement */.kK)(reference) ? (0,listScrollParents/* default */.Z)(reference) : reference.contextElement ? (0,listScrollParents/* default */.Z)(reference.contextElement) : [],
          popper: (0,listScrollParents/* default */.Z)(popper)
        }; // Orders the modifiers based on their dependencies and `phase`
        // properties

        var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers

        state.orderedModifiers = orderedModifiers.filter(function (m) {
          return m.enabled;
        });
        runModifierEffects();
        return instance.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function forceUpdate() {
        if (isDestroyed) {
          return;
        }

        var _state$elements = state.elements,
            reference = _state$elements.reference,
            popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
        // anymore

        if (!areValidElements(reference, popper)) {
          return;
        } // Store the reference and popper rects to be read by modifiers


        state.rects = {
          reference: getCompositeRect(reference, (0,getOffsetParent/* default */.Z)(popper), state.options.strategy === 'fixed'),
          popper: (0,getLayoutRect/* default */.Z)(popper)
        }; // Modifiers have the ability to reset the current update cycle. The
        // most common use case for this is the `flip` modifier changing the
        // placement, which then needs to re-run all the modifiers, because the
        // logic was previously ran for the previous placement and is therefore
        // stale/incorrect

        state.reset = false;
        state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
        // is filled with the initial data specified by the modifier. This means
        // it doesn't persist and is fresh on each update.
        // To ensure persistent data, use `${name}#persistent`

        state.orderedModifiers.forEach(function (modifier) {
          return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
        });

        for (var index = 0; index < state.orderedModifiers.length; index++) {
          if (state.reset === true) {
            state.reset = false;
            index = -1;
            continue;
          }

          var _state$orderedModifie = state.orderedModifiers[index],
              fn = _state$orderedModifie.fn,
              _state$orderedModifie2 = _state$orderedModifie.options,
              _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2,
              name = _state$orderedModifie.name;

          if (typeof fn === 'function') {
            state = fn({
              state: state,
              options: _options,
              name: name,
              instance: instance
            }) || state;
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: debounce(function () {
        return new Promise(function (resolve) {
          instance.forceUpdate();
          resolve(state);
        });
      }),
      destroy: function destroy() {
        cleanupModifierEffects();
        isDestroyed = true;
      }
    };

    if (!areValidElements(reference, popper)) {
      return instance;
    }

    instance.setOptions(options).then(function (state) {
      if (!isDestroyed && options.onFirstUpdate) {
        options.onFirstUpdate(state);
      }
    }); // Modifiers have the ability to execute arbitrary code before the first
    // update cycle runs. They will be executed in the same order as the update
    // cycle. This is useful when a modifier adds some persistent data that
    // other modifiers need to use, but the modifier is run after the dependent
    // one.

    function runModifierEffects() {
      state.orderedModifiers.forEach(function (_ref) {
        var name = _ref.name,
            _ref$options = _ref.options,
            options = _ref$options === void 0 ? {} : _ref$options,
            effect = _ref.effect;

        if (typeof effect === 'function') {
          var cleanupFn = effect({
            state: state,
            name: name,
            instance: instance,
            options: options
          });

          var noopFn = function noopFn() {};

          effectCleanupFns.push(cleanupFn || noopFn);
        }
      });
    }

    function cleanupModifierEffects() {
      effectCleanupFns.forEach(function (fn) {
        return fn();
      });
      effectCleanupFns = [];
    }

    return instance;
  };
}
var createPopper = /*#__PURE__*/(/* unused pure expression or super */ null && (popperGenerator())); // eslint-disable-next-line import/no-unused-modules



/***/ }),

/***/ 94985:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ contains; }
/* harmony export */ });
/* harmony import */ var _instanceOf_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62556);

function contains(parent, child) {
  var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method

  if (parent.contains(child)) {
    return true;
  } // then fallback to custom implementation with Shadow DOM support
  else if (rootNode && (0,_instanceOf_js__WEBPACK_IMPORTED_MODULE_0__/* .isShadowRoot */ .Zq)(rootNode)) {
      var next = child;

      do {
        if (next && parent.isSameNode(next)) {
          return true;
        } // $FlowFixMe[prop-missing]: need a better way to handle this...


        next = next.parentNode || next.host;
      } while (next);
    } // Give up, the result is false


  return false;
}

/***/ }),

/***/ 50400:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getBoundingClientRect; }
/* harmony export */ });
/* harmony import */ var _instanceOf_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62556);
/* harmony import */ var _utils_math_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(138);
/* harmony import */ var _getWindow_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62057);
/* harmony import */ var _isLayoutViewport_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67977);




function getBoundingClientRect(element, includeScale, isFixedStrategy) {
  if (includeScale === void 0) {
    includeScale = false;
  }

  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }

  var clientRect = element.getBoundingClientRect();
  var scaleX = 1;
  var scaleY = 1;

  if (includeScale && (0,_instanceOf_js__WEBPACK_IMPORTED_MODULE_0__/* .isHTMLElement */ .Re)(element)) {
    scaleX = element.offsetWidth > 0 ? (0,_utils_math_js__WEBPACK_IMPORTED_MODULE_1__/* .round */ .NM)(clientRect.width) / element.offsetWidth || 1 : 1;
    scaleY = element.offsetHeight > 0 ? (0,_utils_math_js__WEBPACK_IMPORTED_MODULE_1__/* .round */ .NM)(clientRect.height) / element.offsetHeight || 1 : 1;
  }

  var _ref = (0,_instanceOf_js__WEBPACK_IMPORTED_MODULE_0__/* .isElement */ .kK)(element) ? (0,_getWindow_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(element) : window,
      visualViewport = _ref.visualViewport;

  var addVisualOffsets = !(0,_isLayoutViewport_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)() && isFixedStrategy;
  var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
  var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
  var width = clientRect.width / scaleX;
  var height = clientRect.height / scaleY;
  return {
    width: width,
    height: height,
    top: y,
    right: x + width,
    bottom: y + height,
    left: x,
    x: x,
    y: y
  };
}

/***/ }),

/***/ 43062:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getComputedStyle; }
/* harmony export */ });
/* harmony import */ var _getWindow_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62057);

function getComputedStyle(element) {
  return (0,_getWindow_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(element).getComputedStyle(element);
}

/***/ }),

/***/ 67252:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getDocumentElement; }
/* harmony export */ });
/* harmony import */ var _instanceOf_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62556);

function getDocumentElement(element) {
  // $FlowFixMe[incompatible-return]: assume body is always available
  return (((0,_instanceOf_js__WEBPACK_IMPORTED_MODULE_0__/* .isElement */ .kK)(element) ? element.ownerDocument : // $FlowFixMe[prop-missing]
  element.document) || window.document).documentElement;
}

/***/ }),

/***/ 40583:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getLayoutRect; }
/* harmony export */ });
/* harmony import */ var _getBoundingClientRect_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50400);
 // Returns the layout rect of an element relative to its offsetParent. Layout
// means it doesn't take into account transforms.

function getLayoutRect(element) {
  var clientRect = (0,_getBoundingClientRect_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(element); // Use the clientRect sizes if it's not been transformed.
  // Fixes https://github.com/popperjs/popper-core/issues/1223

  var width = element.offsetWidth;
  var height = element.offsetHeight;

  if (Math.abs(clientRect.width - width) <= 1) {
    width = clientRect.width;
  }

  if (Math.abs(clientRect.height - height) <= 1) {
    height = clientRect.height;
  }

  return {
    x: element.offsetLeft,
    y: element.offsetTop,
    width: width,
    height: height
  };
}

/***/ }),

/***/ 96333:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getNodeName; }
/* harmony export */ });
function getNodeName(element) {
  return element ? (element.nodeName || '').toLowerCase() : null;
}

/***/ }),

/***/ 98552:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ getOffsetParent; }
});

// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getWindow.js
var getWindow = __webpack_require__(62057);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getNodeName.js
var getNodeName = __webpack_require__(96333);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getComputedStyle.js
var getComputedStyle = __webpack_require__(43062);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/dom-utils/instanceOf.js
var instanceOf = __webpack_require__(62556);
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/isTableElement.js

function isTableElement(element) {
  return ['table', 'td', 'th'].indexOf((0,getNodeName/* default */.Z)(element)) >= 0;
}
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getParentNode.js
var getParentNode = __webpack_require__(95923);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/utils/userAgent.js
var userAgent = __webpack_require__(85918);
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getOffsetParent.js








function getTrueOffsetParent(element) {
  if (!(0,instanceOf/* isHTMLElement */.Re)(element) || // https://github.com/popperjs/popper-core/issues/837
  (0,getComputedStyle/* default */.Z)(element).position === 'fixed') {
    return null;
  }

  return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block


function getContainingBlock(element) {
  var isFirefox = /firefox/i.test((0,userAgent/* default */.Z)());
  var isIE = /Trident/i.test((0,userAgent/* default */.Z)());

  if (isIE && (0,instanceOf/* isHTMLElement */.Re)(element)) {
    // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
    var elementCss = (0,getComputedStyle/* default */.Z)(element);

    if (elementCss.position === 'fixed') {
      return null;
    }
  }

  var currentNode = (0,getParentNode/* default */.Z)(element);

  if ((0,instanceOf/* isShadowRoot */.Zq)(currentNode)) {
    currentNode = currentNode.host;
  }

  while ((0,instanceOf/* isHTMLElement */.Re)(currentNode) && ['html', 'body'].indexOf((0,getNodeName/* default */.Z)(currentNode)) < 0) {
    var css = (0,getComputedStyle/* default */.Z)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
    // create a containing block.
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block

    if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || ['transform', 'perspective'].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') {
      return currentNode;
    } else {
      currentNode = currentNode.parentNode;
    }
  }

  return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.


function getOffsetParent(element) {
  var window = (0,getWindow/* default */.Z)(element);
  var offsetParent = getTrueOffsetParent(element);

  while (offsetParent && isTableElement(offsetParent) && (0,getComputedStyle/* default */.Z)(offsetParent).position === 'static') {
    offsetParent = getTrueOffsetParent(offsetParent);
  }

  if (offsetParent && ((0,getNodeName/* default */.Z)(offsetParent) === 'html' || (0,getNodeName/* default */.Z)(offsetParent) === 'body' && (0,getComputedStyle/* default */.Z)(offsetParent).position === 'static')) {
    return window;
  }

  return offsetParent || getContainingBlock(element) || window;
}

/***/ }),

/***/ 95923:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getParentNode; }
/* harmony export */ });
/* harmony import */ var _getNodeName_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96333);
/* harmony import */ var _getDocumentElement_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67252);
/* harmony import */ var _instanceOf_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62556);



function getParentNode(element) {
  if ((0,_getNodeName_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(element) === 'html') {
    return element;
  }

  return (// this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ( // DOM Element detected
    (0,_instanceOf_js__WEBPACK_IMPORTED_MODULE_1__/* .isShadowRoot */ .Zq)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0,_getDocumentElement_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(element) // fallback

  );
}

/***/ }),

/***/ 62057:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getWindow; }
/* harmony export */ });
function getWindow(node) {
  if (node == null) {
    return window;
  }

  if (node.toString() !== '[object Window]') {
    var ownerDocument = node.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView || window : window;
  }

  return node;
}

/***/ }),

/***/ 82163:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getWindowScroll; }
/* harmony export */ });
/* harmony import */ var _getWindow_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62057);

function getWindowScroll(node) {
  var win = (0,_getWindow_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(node);
  var scrollLeft = win.pageXOffset;
  var scrollTop = win.pageYOffset;
  return {
    scrollLeft: scrollLeft,
    scrollTop: scrollTop
  };
}

/***/ }),

/***/ 4063:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getWindowScrollBarX; }
/* harmony export */ });
/* harmony import */ var _getBoundingClientRect_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50400);
/* harmony import */ var _getDocumentElement_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67252);
/* harmony import */ var _getWindowScroll_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82163);



function getWindowScrollBarX(element) {
  // If <html> has a CSS width greater than the viewport, then this will be
  // incorrect for RTL.
  // Popper 1 is broken in this case and never had a bug report so let's assume
  // it's not an issue. I don't think anyone ever specifies width on <html>
  // anyway.
  // Browsers where the left scrollbar doesn't cause an issue report `0` for
  // this (e.g. Edge 2019, IE11, Safari)
  return (0,_getBoundingClientRect_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_getDocumentElement_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(element)).left + (0,_getWindowScroll_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(element).scrollLeft;
}

/***/ }),

/***/ 62556:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Re": function() { return /* binding */ isHTMLElement; },
/* harmony export */   "Zq": function() { return /* binding */ isShadowRoot; },
/* harmony export */   "kK": function() { return /* binding */ isElement; }
/* harmony export */ });
/* harmony import */ var _getWindow_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62057);


function isElement(node) {
  var OwnElement = (0,_getWindow_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(node).Element;
  return node instanceof OwnElement || node instanceof Element;
}

function isHTMLElement(node) {
  var OwnElement = (0,_getWindow_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(node).HTMLElement;
  return node instanceof OwnElement || node instanceof HTMLElement;
}

function isShadowRoot(node) {
  // IE 11 has no ShadowRoot
  if (typeof ShadowRoot === 'undefined') {
    return false;
  }

  var OwnElement = (0,_getWindow_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(node).ShadowRoot;
  return node instanceof OwnElement || node instanceof ShadowRoot;
}



/***/ }),

/***/ 67977:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ isLayoutViewport; }
/* harmony export */ });
/* harmony import */ var _utils_userAgent_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85918);

function isLayoutViewport() {
  return !/^((?!chrome|android).)*safari/i.test((0,_utils_userAgent_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)());
}

/***/ }),

/***/ 60611:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ isScrollParent; }
/* harmony export */ });
/* harmony import */ var _getComputedStyle_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43062);

function isScrollParent(element) {
  // Firefox wants us to check `-x` and `-y` variations as well
  var _getComputedStyle = (0,_getComputedStyle_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(element),
      overflow = _getComputedStyle.overflow,
      overflowX = _getComputedStyle.overflowX,
      overflowY = _getComputedStyle.overflowY;

  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

/***/ }),

/***/ 31492:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ listScrollParents; }
});

// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getParentNode.js
var getParentNode = __webpack_require__(95923);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/dom-utils/isScrollParent.js
var isScrollParent = __webpack_require__(60611);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getNodeName.js
var getNodeName = __webpack_require__(96333);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/dom-utils/instanceOf.js
var instanceOf = __webpack_require__(62556);
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getScrollParent.js




function getScrollParent(node) {
  if (['html', 'body', '#document'].indexOf((0,getNodeName/* default */.Z)(node)) >= 0) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
  }

  if ((0,instanceOf/* isHTMLElement */.Re)(node) && (0,isScrollParent/* default */.Z)(node)) {
    return node;
  }

  return getScrollParent((0,getParentNode/* default */.Z)(node));
}
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getWindow.js
var getWindow = __webpack_require__(62057);
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/listScrollParents.js




/*
given a DOM element, return the list of all scroll parents, up the list of ancesors
until we get to the top window object. This list is what we attach scroll listeners
to, because if any of these parent elements scroll, we'll need to re-calculate the
reference element's position.
*/

function listScrollParents(element, list) {
  var _element$ownerDocumen;

  if (list === void 0) {
    list = [];
  }

  var scrollParent = getScrollParent(element);
  var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
  var win = (0,getWindow/* default */.Z)(scrollParent);
  var target = isBody ? [win].concat(win.visualViewport || [], (0,isScrollParent/* default */.Z)(scrollParent) ? scrollParent : []) : scrollParent;
  var updatedList = list.concat(target);
  return isBody ? updatedList : // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
  updatedList.concat(listScrollParents((0,getParentNode/* default */.Z)(target)));
}

/***/ }),

/***/ 87701:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BL": function() { return /* binding */ start; },
/* harmony export */   "Ct": function() { return /* binding */ placements; },
/* harmony export */   "F2": function() { return /* binding */ right; },
/* harmony export */   "I": function() { return /* binding */ bottom; },
/* harmony export */   "Pj": function() { return /* binding */ viewport; },
/* harmony export */   "YP": function() { return /* binding */ reference; },
/* harmony export */   "bw": function() { return /* binding */ variationPlacements; },
/* harmony export */   "d7": function() { return /* binding */ auto; },
/* harmony export */   "k5": function() { return /* binding */ popper; },
/* harmony export */   "mv": function() { return /* binding */ basePlacements; },
/* harmony export */   "t$": function() { return /* binding */ left; },
/* harmony export */   "ut": function() { return /* binding */ end; },
/* harmony export */   "we": function() { return /* binding */ top; },
/* harmony export */   "xs": function() { return /* binding */ modifierPhases; },
/* harmony export */   "zV": function() { return /* binding */ clippingParents; }
/* harmony export */ });
/* unused harmony exports beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite */
var top = 'top';
var bottom = 'bottom';
var right = 'right';
var left = 'left';
var auto = 'auto';
var basePlacements = [top, bottom, right, left];
var start = 'start';
var end = 'end';
var clippingParents = 'clippingParents';
var viewport = 'viewport';
var popper = 'popper';
var reference = 'reference';
var variationPlacements = /*#__PURE__*/basePlacements.reduce(function (acc, placement) {
  return acc.concat([placement + "-" + start, placement + "-" + end]);
}, []);
var placements = /*#__PURE__*/[].concat(basePlacements, [auto]).reduce(function (acc, placement) {
  return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
}, []); // modifiers that need to read the DOM

var beforeRead = 'beforeRead';
var read = 'read';
var afterRead = 'afterRead'; // pure-logic modifiers

var beforeMain = 'beforeMain';
var main = 'main';
var afterMain = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)

var beforeWrite = 'beforeWrite';
var write = 'write';
var afterWrite = 'afterWrite';
var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];

/***/ }),

/***/ 66896:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _utils_getBasePlacement_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6206);
/* harmony import */ var _dom_utils_getLayoutRect_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(40583);
/* harmony import */ var _dom_utils_contains_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(94985);
/* harmony import */ var _dom_utils_getOffsetParent_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(98552);
/* harmony import */ var _utils_getMainAxisFromPlacement_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11516);
/* harmony import */ var _utils_within_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(57516);
/* harmony import */ var _utils_mergePaddingObject_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63293);
/* harmony import */ var _utils_expandToHashMap_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33706);
/* harmony import */ var _enums_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87701);








 // eslint-disable-next-line import/no-unused-modules

var toPaddingObject = function toPaddingObject(padding, state) {
  padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
    placement: state.placement
  })) : padding;
  return (0,_utils_mergePaddingObject_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(typeof padding !== 'number' ? padding : (0,_utils_expandToHashMap_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(padding, _enums_js__WEBPACK_IMPORTED_MODULE_2__/* .basePlacements */ .mv));
};

function arrow(_ref) {
  var _state$modifiersData$;

  var state = _ref.state,
      name = _ref.name,
      options = _ref.options;
  var arrowElement = state.elements.arrow;
  var popperOffsets = state.modifiersData.popperOffsets;
  var basePlacement = (0,_utils_getBasePlacement_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(state.placement);
  var axis = (0,_utils_getMainAxisFromPlacement_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(basePlacement);
  var isVertical = [_enums_js__WEBPACK_IMPORTED_MODULE_2__/* .left */ .t$, _enums_js__WEBPACK_IMPORTED_MODULE_2__/* .right */ .F2].indexOf(basePlacement) >= 0;
  var len = isVertical ? 'height' : 'width';

  if (!arrowElement || !popperOffsets) {
    return;
  }

  var paddingObject = toPaddingObject(options.padding, state);
  var arrowRect = (0,_dom_utils_getLayoutRect_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(arrowElement);
  var minProp = axis === 'y' ? _enums_js__WEBPACK_IMPORTED_MODULE_2__/* .top */ .we : _enums_js__WEBPACK_IMPORTED_MODULE_2__/* .left */ .t$;
  var maxProp = axis === 'y' ? _enums_js__WEBPACK_IMPORTED_MODULE_2__/* .bottom */ .I : _enums_js__WEBPACK_IMPORTED_MODULE_2__/* .right */ .F2;
  var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
  var startDiff = popperOffsets[axis] - state.rects.reference[axis];
  var arrowOffsetParent = (0,_dom_utils_getOffsetParent_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(arrowElement);
  var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
  var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
  // outside of the popper bounds

  var min = paddingObject[minProp];
  var max = clientSize - arrowRect[len] - paddingObject[maxProp];
  var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
  var offset = (0,_utils_within_js__WEBPACK_IMPORTED_MODULE_7__/* .within */ .u)(min, center, max); // Prevents breaking syntax highlighting...

  var axisProp = axis;
  state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}

function effect(_ref2) {
  var state = _ref2.state,
      options = _ref2.options;
  var _options$element = options.element,
      arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;

  if (arrowElement == null) {
    return;
  } // CSS selector


  if (typeof arrowElement === 'string') {
    arrowElement = state.elements.popper.querySelector(arrowElement);

    if (!arrowElement) {
      return;
    }
  }

  if (!(0,_dom_utils_contains_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(state.elements.popper, arrowElement)) {
    return;
  }

  state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ __webpack_exports__["Z"] = ({
  name: 'arrow',
  enabled: true,
  phase: 'main',
  fn: arrow,
  effect: effect,
  requires: ['popperOffsets'],
  requiresIfExists: ['preventOverflow']
});

/***/ }),

/***/ 36531:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export mapToStyles */
/* harmony import */ var _enums_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87701);
/* harmony import */ var _dom_utils_getOffsetParent_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98552);
/* harmony import */ var _dom_utils_getWindow_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62057);
/* harmony import */ var _dom_utils_getDocumentElement_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67252);
/* harmony import */ var _dom_utils_getComputedStyle_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(43062);
/* harmony import */ var _utils_getBasePlacement_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6206);
/* harmony import */ var _utils_getVariation_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(14943);
/* harmony import */ var _utils_math_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(138);







 // eslint-disable-next-line import/no-unused-modules

var unsetSides = {
  top: 'auto',
  right: 'auto',
  bottom: 'auto',
  left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.

function roundOffsetsByDPR(_ref, win) {
  var x = _ref.x,
      y = _ref.y;
  var dpr = win.devicePixelRatio || 1;
  return {
    x: (0,_utils_math_js__WEBPACK_IMPORTED_MODULE_0__/* .round */ .NM)(x * dpr) / dpr || 0,
    y: (0,_utils_math_js__WEBPACK_IMPORTED_MODULE_0__/* .round */ .NM)(y * dpr) / dpr || 0
  };
}

function mapToStyles(_ref2) {
  var _Object$assign2;

  var popper = _ref2.popper,
      popperRect = _ref2.popperRect,
      placement = _ref2.placement,
      variation = _ref2.variation,
      offsets = _ref2.offsets,
      position = _ref2.position,
      gpuAcceleration = _ref2.gpuAcceleration,
      adaptive = _ref2.adaptive,
      roundOffsets = _ref2.roundOffsets,
      isFixed = _ref2.isFixed;
  var _offsets$x = offsets.x,
      x = _offsets$x === void 0 ? 0 : _offsets$x,
      _offsets$y = offsets.y,
      y = _offsets$y === void 0 ? 0 : _offsets$y;

  var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
    x: x,
    y: y
  }) : {
    x: x,
    y: y
  };

  x = _ref3.x;
  y = _ref3.y;
  var hasX = offsets.hasOwnProperty('x');
  var hasY = offsets.hasOwnProperty('y');
  var sideX = _enums_js__WEBPACK_IMPORTED_MODULE_1__/* .left */ .t$;
  var sideY = _enums_js__WEBPACK_IMPORTED_MODULE_1__/* .top */ .we;
  var win = window;

  if (adaptive) {
    var offsetParent = (0,_dom_utils_getOffsetParent_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(popper);
    var heightProp = 'clientHeight';
    var widthProp = 'clientWidth';

    if (offsetParent === (0,_dom_utils_getWindow_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(popper)) {
      offsetParent = (0,_dom_utils_getDocumentElement_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(popper);

      if ((0,_dom_utils_getComputedStyle_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(offsetParent).position !== 'static' && position === 'absolute') {
        heightProp = 'scrollHeight';
        widthProp = 'scrollWidth';
      }
    } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it


    offsetParent = offsetParent;

    if (placement === _enums_js__WEBPACK_IMPORTED_MODULE_1__/* .top */ .we || (placement === _enums_js__WEBPACK_IMPORTED_MODULE_1__/* .left */ .t$ || placement === _enums_js__WEBPACK_IMPORTED_MODULE_1__/* .right */ .F2) && variation === _enums_js__WEBPACK_IMPORTED_MODULE_1__/* .end */ .ut) {
      sideY = _enums_js__WEBPACK_IMPORTED_MODULE_1__/* .bottom */ .I;
      var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : // $FlowFixMe[prop-missing]
      offsetParent[heightProp];
      y -= offsetY - popperRect.height;
      y *= gpuAcceleration ? 1 : -1;
    }

    if (placement === _enums_js__WEBPACK_IMPORTED_MODULE_1__/* .left */ .t$ || (placement === _enums_js__WEBPACK_IMPORTED_MODULE_1__/* .top */ .we || placement === _enums_js__WEBPACK_IMPORTED_MODULE_1__/* .bottom */ .I) && variation === _enums_js__WEBPACK_IMPORTED_MODULE_1__/* .end */ .ut) {
      sideX = _enums_js__WEBPACK_IMPORTED_MODULE_1__/* .right */ .F2;
      var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : // $FlowFixMe[prop-missing]
      offsetParent[widthProp];
      x -= offsetX - popperRect.width;
      x *= gpuAcceleration ? 1 : -1;
    }
  }

  var commonStyles = Object.assign({
    position: position
  }, adaptive && unsetSides);

  var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
    x: x,
    y: y
  }, (0,_dom_utils_getWindow_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(popper)) : {
    x: x,
    y: y
  };

  x = _ref4.x;
  y = _ref4.y;

  if (gpuAcceleration) {
    var _Object$assign;

    return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
  }

  return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}

function computeStyles(_ref5) {
  var state = _ref5.state,
      options = _ref5.options;
  var _options$gpuAccelerat = options.gpuAcceleration,
      gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat,
      _options$adaptive = options.adaptive,
      adaptive = _options$adaptive === void 0 ? true : _options$adaptive,
      _options$roundOffsets = options.roundOffsets,
      roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
  var commonStyles = {
    placement: (0,_utils_getBasePlacement_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(state.placement),
    variation: (0,_utils_getVariation_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(state.placement),
    popper: state.elements.popper,
    popperRect: state.rects.popper,
    gpuAcceleration: gpuAcceleration,
    isFixed: state.options.strategy === 'fixed'
  };

  if (state.modifiersData.popperOffsets != null) {
    state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.popperOffsets,
      position: state.options.strategy,
      adaptive: adaptive,
      roundOffsets: roundOffsets
    })));
  }

  if (state.modifiersData.arrow != null) {
    state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.arrow,
      position: 'absolute',
      adaptive: false,
      roundOffsets: roundOffsets
    })));
  }

  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-placement': state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ __webpack_exports__["Z"] = ({
  name: 'computeStyles',
  enabled: true,
  phase: 'beforeWrite',
  fn: computeStyles,
  data: {}
});

/***/ }),

/***/ 82372:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _dom_utils_getWindow_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62057);
 // eslint-disable-next-line import/no-unused-modules

var passive = {
  passive: true
};

function effect(_ref) {
  var state = _ref.state,
      instance = _ref.instance,
      options = _ref.options;
  var _options$scroll = options.scroll,
      scroll = _options$scroll === void 0 ? true : _options$scroll,
      _options$resize = options.resize,
      resize = _options$resize === void 0 ? true : _options$resize;
  var window = (0,_dom_utils_getWindow_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(state.elements.popper);
  var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);

  if (scroll) {
    scrollParents.forEach(function (scrollParent) {
      scrollParent.addEventListener('scroll', instance.update, passive);
    });
  }

  if (resize) {
    window.addEventListener('resize', instance.update, passive);
  }

  return function () {
    if (scroll) {
      scrollParents.forEach(function (scrollParent) {
        scrollParent.removeEventListener('scroll', instance.update, passive);
      });
    }

    if (resize) {
      window.removeEventListener('resize', instance.update, passive);
    }
  };
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ __webpack_exports__["Z"] = ({
  name: 'eventListeners',
  enabled: true,
  phase: 'write',
  fn: function fn() {},
  effect: effect,
  data: {}
});

/***/ }),

/***/ 68855:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ modifiers_flip; }
});

;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/getOppositePlacement.js
var hash = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom'
};
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/utils/getBasePlacement.js
var getBasePlacement = __webpack_require__(6206);
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/getOppositeVariationPlacement.js
var getOppositeVariationPlacement_hash = {
  start: 'end',
  end: 'start'
};
function getOppositeVariationPlacement(placement) {
  return placement.replace(/start|end/g, function (matched) {
    return getOppositeVariationPlacement_hash[matched];
  });
}
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/utils/detectOverflow.js + 4 modules
var detectOverflow = __webpack_require__(6486);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/utils/getVariation.js
var getVariation = __webpack_require__(14943);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/enums.js
var enums = __webpack_require__(87701);
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/computeAutoPlacement.js




function computeAutoPlacement(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      placement = _options.placement,
      boundary = _options.boundary,
      rootBoundary = _options.rootBoundary,
      padding = _options.padding,
      flipVariations = _options.flipVariations,
      _options$allowedAutoP = _options.allowedAutoPlacements,
      allowedAutoPlacements = _options$allowedAutoP === void 0 ? enums/* placements */.Ct : _options$allowedAutoP;
  var variation = (0,getVariation/* default */.Z)(placement);
  var placements = variation ? flipVariations ? enums/* variationPlacements */.bw : enums/* variationPlacements.filter */.bw.filter(function (placement) {
    return (0,getVariation/* default */.Z)(placement) === variation;
  }) : enums/* basePlacements */.mv;
  var allowedPlacements = placements.filter(function (placement) {
    return allowedAutoPlacements.indexOf(placement) >= 0;
  });

  if (allowedPlacements.length === 0) {
    allowedPlacements = placements;
  } // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...


  var overflows = allowedPlacements.reduce(function (acc, placement) {
    acc[placement] = (0,detectOverflow/* default */.Z)(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding
    })[(0,getBasePlacement/* default */.Z)(placement)];
    return acc;
  }, {});
  return Object.keys(overflows).sort(function (a, b) {
    return overflows[a] - overflows[b];
  });
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/flip.js






 // eslint-disable-next-line import/no-unused-modules

function getExpandedFallbackPlacements(placement) {
  if ((0,getBasePlacement/* default */.Z)(placement) === enums/* auto */.d7) {
    return [];
  }

  var oppositePlacement = getOppositePlacement(placement);
  return [getOppositeVariationPlacement(placement), oppositePlacement, getOppositeVariationPlacement(oppositePlacement)];
}

function flip(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;

  if (state.modifiersData[name]._skip) {
    return;
  }

  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis,
      specifiedFallbackPlacements = options.fallbackPlacements,
      padding = options.padding,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      _options$flipVariatio = options.flipVariations,
      flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio,
      allowedAutoPlacements = options.allowedAutoPlacements;
  var preferredPlacement = state.options.placement;
  var basePlacement = (0,getBasePlacement/* default */.Z)(preferredPlacement);
  var isBasePlacement = basePlacement === preferredPlacement;
  var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
  var placements = [preferredPlacement].concat(fallbackPlacements).reduce(function (acc, placement) {
    return acc.concat((0,getBasePlacement/* default */.Z)(placement) === enums/* auto */.d7 ? computeAutoPlacement(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding,
      flipVariations: flipVariations,
      allowedAutoPlacements: allowedAutoPlacements
    }) : placement);
  }, []);
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var checksMap = new Map();
  var makeFallbackChecks = true;
  var firstFittingPlacement = placements[0];

  for (var i = 0; i < placements.length; i++) {
    var placement = placements[i];

    var _basePlacement = (0,getBasePlacement/* default */.Z)(placement);

    var isStartVariation = (0,getVariation/* default */.Z)(placement) === enums/* start */.BL;
    var isVertical = [enums/* top */.we, enums/* bottom */.I].indexOf(_basePlacement) >= 0;
    var len = isVertical ? 'width' : 'height';
    var overflow = (0,detectOverflow/* default */.Z)(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      altBoundary: altBoundary,
      padding: padding
    });
    var mainVariationSide = isVertical ? isStartVariation ? enums/* right */.F2 : enums/* left */.t$ : isStartVariation ? enums/* bottom */.I : enums/* top */.we;

    if (referenceRect[len] > popperRect[len]) {
      mainVariationSide = getOppositePlacement(mainVariationSide);
    }

    var altVariationSide = getOppositePlacement(mainVariationSide);
    var checks = [];

    if (checkMainAxis) {
      checks.push(overflow[_basePlacement] <= 0);
    }

    if (checkAltAxis) {
      checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
    }

    if (checks.every(function (check) {
      return check;
    })) {
      firstFittingPlacement = placement;
      makeFallbackChecks = false;
      break;
    }

    checksMap.set(placement, checks);
  }

  if (makeFallbackChecks) {
    // `2` may be desired in some cases – research later
    var numberOfChecks = flipVariations ? 3 : 1;

    var _loop = function _loop(_i) {
      var fittingPlacement = placements.find(function (placement) {
        var checks = checksMap.get(placement);

        if (checks) {
          return checks.slice(0, _i).every(function (check) {
            return check;
          });
        }
      });

      if (fittingPlacement) {
        firstFittingPlacement = fittingPlacement;
        return "break";
      }
    };

    for (var _i = numberOfChecks; _i > 0; _i--) {
      var _ret = _loop(_i);

      if (_ret === "break") break;
    }
  }

  if (state.placement !== firstFittingPlacement) {
    state.modifiersData[name]._skip = true;
    state.placement = firstFittingPlacement;
    state.reset = true;
  }
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_flip = ({
  name: 'flip',
  enabled: true,
  phase: 'main',
  fn: flip,
  requiresIfExists: ['offset'],
  data: {
    _skip: false
  }
});

/***/ }),

/***/ 19892:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _enums_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87701);
/* harmony import */ var _utils_detectOverflow_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6486);



function getSideOffsets(overflow, rect, preventedOffsets) {
  if (preventedOffsets === void 0) {
    preventedOffsets = {
      x: 0,
      y: 0
    };
  }

  return {
    top: overflow.top - rect.height - preventedOffsets.y,
    right: overflow.right - rect.width + preventedOffsets.x,
    bottom: overflow.bottom - rect.height + preventedOffsets.y,
    left: overflow.left - rect.width - preventedOffsets.x
  };
}

function isAnySideFullyClipped(overflow) {
  return [_enums_js__WEBPACK_IMPORTED_MODULE_0__/* .top */ .we, _enums_js__WEBPACK_IMPORTED_MODULE_0__/* .right */ .F2, _enums_js__WEBPACK_IMPORTED_MODULE_0__/* .bottom */ .I, _enums_js__WEBPACK_IMPORTED_MODULE_0__/* .left */ .t$].some(function (side) {
    return overflow[side] >= 0;
  });
}

function hide(_ref) {
  var state = _ref.state,
      name = _ref.name;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var preventedOffsets = state.modifiersData.preventOverflow;
  var referenceOverflow = (0,_utils_detectOverflow_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(state, {
    elementContext: 'reference'
  });
  var popperAltOverflow = (0,_utils_detectOverflow_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(state, {
    altBoundary: true
  });
  var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
  var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
  var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
  var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
  state.modifiersData[name] = {
    referenceClippingOffsets: referenceClippingOffsets,
    popperEscapeOffsets: popperEscapeOffsets,
    isReferenceHidden: isReferenceHidden,
    hasPopperEscaped: hasPopperEscaped
  };
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-reference-hidden': isReferenceHidden,
    'data-popper-escaped': hasPopperEscaped
  });
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ __webpack_exports__["Z"] = ({
  name: 'hide',
  enabled: true,
  phase: 'main',
  requiresIfExists: ['preventOverflow'],
  fn: hide
});

/***/ }),

/***/ 82122:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export distanceAndSkiddingToXY */
/* harmony import */ var _utils_getBasePlacement_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6206);
/* harmony import */ var _enums_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87701);

 // eslint-disable-next-line import/no-unused-modules

function distanceAndSkiddingToXY(placement, rects, offset) {
  var basePlacement = (0,_utils_getBasePlacement_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(placement);
  var invertDistance = [_enums_js__WEBPACK_IMPORTED_MODULE_1__/* .left */ .t$, _enums_js__WEBPACK_IMPORTED_MODULE_1__/* .top */ .we].indexOf(basePlacement) >= 0 ? -1 : 1;

  var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
    placement: placement
  })) : offset,
      skidding = _ref[0],
      distance = _ref[1];

  skidding = skidding || 0;
  distance = (distance || 0) * invertDistance;
  return [_enums_js__WEBPACK_IMPORTED_MODULE_1__/* .left */ .t$, _enums_js__WEBPACK_IMPORTED_MODULE_1__/* .right */ .F2].indexOf(basePlacement) >= 0 ? {
    x: distance,
    y: skidding
  } : {
    x: skidding,
    y: distance
  };
}

function offset(_ref2) {
  var state = _ref2.state,
      options = _ref2.options,
      name = _ref2.name;
  var _options$offset = options.offset,
      offset = _options$offset === void 0 ? [0, 0] : _options$offset;
  var data = _enums_js__WEBPACK_IMPORTED_MODULE_1__/* .placements.reduce */ .Ct.reduce(function (acc, placement) {
    acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
    return acc;
  }, {});
  var _data$state$placement = data[state.placement],
      x = _data$state$placement.x,
      y = _data$state$placement.y;

  if (state.modifiersData.popperOffsets != null) {
    state.modifiersData.popperOffsets.x += x;
    state.modifiersData.popperOffsets.y += y;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ __webpack_exports__["Z"] = ({
  name: 'offset',
  enabled: true,
  phase: 'main',
  requires: ['popperOffsets'],
  fn: offset
});

/***/ }),

/***/ 77421:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _utils_computeOffsets_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72581);


function popperOffsets(_ref) {
  var state = _ref.state,
      name = _ref.name;
  // Offsets are the actual position the popper needs to have to be
  // properly positioned near its reference element
  // This is the most basic placement, and will be adjusted by
  // the modifiers in the next step
  state.modifiersData[name] = (0,_utils_computeOffsets_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
    reference: state.rects.reference,
    element: state.rects.popper,
    strategy: 'absolute',
    placement: state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ __webpack_exports__["Z"] = ({
  name: 'popperOffsets',
  enabled: true,
  phase: 'read',
  fn: popperOffsets,
  data: {}
});

/***/ }),

/***/ 394:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ modifiers_preventOverflow; }
});

// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/enums.js
var enums = __webpack_require__(87701);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/utils/getBasePlacement.js
var getBasePlacement = __webpack_require__(6206);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/utils/getMainAxisFromPlacement.js
var getMainAxisFromPlacement = __webpack_require__(11516);
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/getAltAxis.js
function getAltAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/utils/within.js
var within = __webpack_require__(57516);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getLayoutRect.js
var getLayoutRect = __webpack_require__(40583);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getOffsetParent.js + 1 modules
var getOffsetParent = __webpack_require__(98552);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/utils/detectOverflow.js + 4 modules
var detectOverflow = __webpack_require__(6486);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/utils/getVariation.js
var getVariation = __webpack_require__(14943);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/utils/getFreshSideObject.js
var getFreshSideObject = __webpack_require__(23607);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/utils/math.js
var math = __webpack_require__(138);
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/preventOverflow.js












function preventOverflow(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;
  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      padding = options.padding,
      _options$tether = options.tether,
      tether = _options$tether === void 0 ? true : _options$tether,
      _options$tetherOffset = options.tetherOffset,
      tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
  var overflow = (0,detectOverflow/* default */.Z)(state, {
    boundary: boundary,
    rootBoundary: rootBoundary,
    padding: padding,
    altBoundary: altBoundary
  });
  var basePlacement = (0,getBasePlacement/* default */.Z)(state.placement);
  var variation = (0,getVariation/* default */.Z)(state.placement);
  var isBasePlacement = !variation;
  var mainAxis = (0,getMainAxisFromPlacement/* default */.Z)(basePlacement);
  var altAxis = getAltAxis(mainAxis);
  var popperOffsets = state.modifiersData.popperOffsets;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
    placement: state.placement
  })) : tetherOffset;
  var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
    mainAxis: tetherOffsetValue,
    altAxis: tetherOffsetValue
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, tetherOffsetValue);
  var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
  var data = {
    x: 0,
    y: 0
  };

  if (!popperOffsets) {
    return;
  }

  if (checkMainAxis) {
    var _offsetModifierState$;

    var mainSide = mainAxis === 'y' ? enums/* top */.we : enums/* left */.t$;
    var altSide = mainAxis === 'y' ? enums/* bottom */.I : enums/* right */.F2;
    var len = mainAxis === 'y' ? 'height' : 'width';
    var offset = popperOffsets[mainAxis];
    var min = offset + overflow[mainSide];
    var max = offset - overflow[altSide];
    var additive = tether ? -popperRect[len] / 2 : 0;
    var minLen = variation === enums/* start */.BL ? referenceRect[len] : popperRect[len];
    var maxLen = variation === enums/* start */.BL ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
    // outside the reference bounds

    var arrowElement = state.elements.arrow;
    var arrowRect = tether && arrowElement ? (0,getLayoutRect/* default */.Z)(arrowElement) : {
      width: 0,
      height: 0
    };
    var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0,getFreshSideObject/* default */.Z)();
    var arrowPaddingMin = arrowPaddingObject[mainSide];
    var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
    // to include its full size in the calculation. If the reference is small
    // and near the edge of a boundary, the popper can overflow even if the
    // reference is not overflowing as well (e.g. virtual elements with no
    // width or height)

    var arrowLen = (0,within/* within */.u)(0, referenceRect[len], arrowRect[len]);
    var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
    var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
    var arrowOffsetParent = state.elements.arrow && (0,getOffsetParent/* default */.Z)(state.elements.arrow);
    var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
    var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
    var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
    var tetherMax = offset + maxOffset - offsetModifierValue;
    var preventedOffset = (0,within/* within */.u)(tether ? (0,math/* min */.VV)(min, tetherMin) : min, offset, tether ? (0,math/* max */.Fp)(max, tetherMax) : max);
    popperOffsets[mainAxis] = preventedOffset;
    data[mainAxis] = preventedOffset - offset;
  }

  if (checkAltAxis) {
    var _offsetModifierState$2;

    var _mainSide = mainAxis === 'x' ? enums/* top */.we : enums/* left */.t$;

    var _altSide = mainAxis === 'x' ? enums/* bottom */.I : enums/* right */.F2;

    var _offset = popperOffsets[altAxis];

    var _len = altAxis === 'y' ? 'height' : 'width';

    var _min = _offset + overflow[_mainSide];

    var _max = _offset - overflow[_altSide];

    var isOriginSide = [enums/* top */.we, enums/* left */.t$].indexOf(basePlacement) !== -1;

    var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;

    var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;

    var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;

    var _preventedOffset = tether && isOriginSide ? (0,within/* withinMaxClamp */.q)(_tetherMin, _offset, _tetherMax) : (0,within/* within */.u)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);

    popperOffsets[altAxis] = _preventedOffset;
    data[altAxis] = _preventedOffset - _offset;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_preventOverflow = ({
  name: 'preventOverflow',
  enabled: true,
  phase: 'main',
  fn: preventOverflow,
  requiresIfExists: ['offset']
});

/***/ }),

/***/ 72581:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ computeOffsets; }
/* harmony export */ });
/* harmony import */ var _getBasePlacement_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6206);
/* harmony import */ var _getVariation_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14943);
/* harmony import */ var _getMainAxisFromPlacement_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11516);
/* harmony import */ var _enums_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87701);




function computeOffsets(_ref) {
  var reference = _ref.reference,
      element = _ref.element,
      placement = _ref.placement;
  var basePlacement = placement ? (0,_getBasePlacement_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(placement) : null;
  var variation = placement ? (0,_getVariation_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(placement) : null;
  var commonX = reference.x + reference.width / 2 - element.width / 2;
  var commonY = reference.y + reference.height / 2 - element.height / 2;
  var offsets;

  switch (basePlacement) {
    case _enums_js__WEBPACK_IMPORTED_MODULE_2__/* .top */ .we:
      offsets = {
        x: commonX,
        y: reference.y - element.height
      };
      break;

    case _enums_js__WEBPACK_IMPORTED_MODULE_2__/* .bottom */ .I:
      offsets = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;

    case _enums_js__WEBPACK_IMPORTED_MODULE_2__/* .right */ .F2:
      offsets = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;

    case _enums_js__WEBPACK_IMPORTED_MODULE_2__/* .left */ .t$:
      offsets = {
        x: reference.x - element.width,
        y: commonY
      };
      break;

    default:
      offsets = {
        x: reference.x,
        y: reference.y
      };
  }

  var mainAxis = basePlacement ? (0,_getMainAxisFromPlacement_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(basePlacement) : null;

  if (mainAxis != null) {
    var len = mainAxis === 'y' ? 'height' : 'width';

    switch (variation) {
      case _enums_js__WEBPACK_IMPORTED_MODULE_2__/* .start */ .BL:
        offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
        break;

      case _enums_js__WEBPACK_IMPORTED_MODULE_2__/* .end */ .ut:
        offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
        break;

      default:
    }
  }

  return offsets;
}

/***/ }),

/***/ 6486:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ detectOverflow; }
});

// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/enums.js
var enums = __webpack_require__(87701);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getWindow.js
var getWindow = __webpack_require__(62057);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getDocumentElement.js
var getDocumentElement = __webpack_require__(67252);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getWindowScrollBarX.js
var getWindowScrollBarX = __webpack_require__(4063);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/dom-utils/isLayoutViewport.js
var isLayoutViewport = __webpack_require__(67977);
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getViewportRect.js




function getViewportRect(element, strategy) {
  var win = (0,getWindow/* default */.Z)(element);
  var html = (0,getDocumentElement/* default */.Z)(element);
  var visualViewport = win.visualViewport;
  var width = html.clientWidth;
  var height = html.clientHeight;
  var x = 0;
  var y = 0;

  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    var layoutViewport = (0,isLayoutViewport/* default */.Z)();

    if (layoutViewport || !layoutViewport && strategy === 'fixed') {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }

  return {
    width: width,
    height: height,
    x: x + (0,getWindowScrollBarX/* default */.Z)(element),
    y: y
  };
}
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getComputedStyle.js
var getComputedStyle = __webpack_require__(43062);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getWindowScroll.js
var getWindowScroll = __webpack_require__(82163);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/utils/math.js
var math = __webpack_require__(138);
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getDocumentRect.js




 // Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable

function getDocumentRect(element) {
  var _element$ownerDocumen;

  var html = (0,getDocumentElement/* default */.Z)(element);
  var winScroll = (0,getWindowScroll/* default */.Z)(element);
  var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
  var width = (0,math/* max */.Fp)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
  var height = (0,math/* max */.Fp)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
  var x = -winScroll.scrollLeft + (0,getWindowScrollBarX/* default */.Z)(element);
  var y = -winScroll.scrollTop;

  if ((0,getComputedStyle/* default */.Z)(body || html).direction === 'rtl') {
    x += (0,math/* max */.Fp)(html.clientWidth, body ? body.clientWidth : 0) - width;
  }

  return {
    width: width,
    height: height,
    x: x,
    y: y
  };
}
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/dom-utils/listScrollParents.js + 1 modules
var listScrollParents = __webpack_require__(31492);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getOffsetParent.js + 1 modules
var getOffsetParent = __webpack_require__(98552);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/dom-utils/instanceOf.js
var instanceOf = __webpack_require__(62556);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getBoundingClientRect.js
var getBoundingClientRect = __webpack_require__(50400);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getParentNode.js
var getParentNode = __webpack_require__(95923);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/dom-utils/contains.js
var contains = __webpack_require__(94985);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getNodeName.js
var getNodeName = __webpack_require__(96333);
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/rectToClientRect.js
function rectToClientRect(rect) {
  return Object.assign({}, rect, {
    left: rect.x,
    top: rect.y,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  });
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getClippingRect.js















function getInnerBoundingClientRect(element, strategy) {
  var rect = (0,getBoundingClientRect/* default */.Z)(element, false, strategy === 'fixed');
  rect.top = rect.top + element.clientTop;
  rect.left = rect.left + element.clientLeft;
  rect.bottom = rect.top + element.clientHeight;
  rect.right = rect.left + element.clientWidth;
  rect.width = element.clientWidth;
  rect.height = element.clientHeight;
  rect.x = rect.left;
  rect.y = rect.top;
  return rect;
}

function getClientRectFromMixedType(element, clippingParent, strategy) {
  return clippingParent === enums/* viewport */.Pj ? rectToClientRect(getViewportRect(element, strategy)) : (0,instanceOf/* isElement */.kK)(clippingParent) ? getInnerBoundingClientRect(clippingParent, strategy) : rectToClientRect(getDocumentRect((0,getDocumentElement/* default */.Z)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`


function getClippingParents(element) {
  var clippingParents = (0,listScrollParents/* default */.Z)((0,getParentNode/* default */.Z)(element));
  var canEscapeClipping = ['absolute', 'fixed'].indexOf((0,getComputedStyle/* default */.Z)(element).position) >= 0;
  var clipperElement = canEscapeClipping && (0,instanceOf/* isHTMLElement */.Re)(element) ? (0,getOffsetParent/* default */.Z)(element) : element;

  if (!(0,instanceOf/* isElement */.kK)(clipperElement)) {
    return [];
  } // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414


  return clippingParents.filter(function (clippingParent) {
    return (0,instanceOf/* isElement */.kK)(clippingParent) && (0,contains/* default */.Z)(clippingParent, clipperElement) && (0,getNodeName/* default */.Z)(clippingParent) !== 'body';
  });
} // Gets the maximum area that the element is visible in due to any number of
// clipping parents


function getClippingRect(element, boundary, rootBoundary, strategy) {
  var mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
  var clippingParents = [].concat(mainClippingParents, [rootBoundary]);
  var firstClippingParent = clippingParents[0];
  var clippingRect = clippingParents.reduce(function (accRect, clippingParent) {
    var rect = getClientRectFromMixedType(element, clippingParent, strategy);
    accRect.top = (0,math/* max */.Fp)(rect.top, accRect.top);
    accRect.right = (0,math/* min */.VV)(rect.right, accRect.right);
    accRect.bottom = (0,math/* min */.VV)(rect.bottom, accRect.bottom);
    accRect.left = (0,math/* max */.Fp)(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromMixedType(element, firstClippingParent, strategy));
  clippingRect.width = clippingRect.right - clippingRect.left;
  clippingRect.height = clippingRect.bottom - clippingRect.top;
  clippingRect.x = clippingRect.left;
  clippingRect.y = clippingRect.top;
  return clippingRect;
}
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/utils/computeOffsets.js
var computeOffsets = __webpack_require__(72581);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/utils/mergePaddingObject.js
var mergePaddingObject = __webpack_require__(63293);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/utils/expandToHashMap.js
var expandToHashMap = __webpack_require__(33706);
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/detectOverflow.js








 // eslint-disable-next-line import/no-unused-modules

function detectOverflow(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      _options$placement = _options.placement,
      placement = _options$placement === void 0 ? state.placement : _options$placement,
      _options$strategy = _options.strategy,
      strategy = _options$strategy === void 0 ? state.strategy : _options$strategy,
      _options$boundary = _options.boundary,
      boundary = _options$boundary === void 0 ? enums/* clippingParents */.zV : _options$boundary,
      _options$rootBoundary = _options.rootBoundary,
      rootBoundary = _options$rootBoundary === void 0 ? enums/* viewport */.Pj : _options$rootBoundary,
      _options$elementConte = _options.elementContext,
      elementContext = _options$elementConte === void 0 ? enums/* popper */.k5 : _options$elementConte,
      _options$altBoundary = _options.altBoundary,
      altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary,
      _options$padding = _options.padding,
      padding = _options$padding === void 0 ? 0 : _options$padding;
  var paddingObject = (0,mergePaddingObject/* default */.Z)(typeof padding !== 'number' ? padding : (0,expandToHashMap/* default */.Z)(padding, enums/* basePlacements */.mv));
  var altContext = elementContext === enums/* popper */.k5 ? enums/* reference */.YP : enums/* popper */.k5;
  var popperRect = state.rects.popper;
  var element = state.elements[altBoundary ? altContext : elementContext];
  var clippingClientRect = getClippingRect((0,instanceOf/* isElement */.kK)(element) ? element : element.contextElement || (0,getDocumentElement/* default */.Z)(state.elements.popper), boundary, rootBoundary, strategy);
  var referenceClientRect = (0,getBoundingClientRect/* default */.Z)(state.elements.reference);
  var popperOffsets = (0,computeOffsets/* default */.Z)({
    reference: referenceClientRect,
    element: popperRect,
    strategy: 'absolute',
    placement: placement
  });
  var popperClientRect = rectToClientRect(Object.assign({}, popperRect, popperOffsets));
  var elementClientRect = elementContext === enums/* popper */.k5 ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
  // 0 or negative = within the clipping rect

  var overflowOffsets = {
    top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
    bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
    left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
    right: elementClientRect.right - clippingClientRect.right + paddingObject.right
  };
  var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element

  if (elementContext === enums/* popper */.k5 && offsetData) {
    var offset = offsetData[placement];
    Object.keys(overflowOffsets).forEach(function (key) {
      var multiply = [enums/* right */.F2, enums/* bottom */.I].indexOf(key) >= 0 ? 1 : -1;
      var axis = [enums/* top */.we, enums/* bottom */.I].indexOf(key) >= 0 ? 'y' : 'x';
      overflowOffsets[key] += offset[axis] * multiply;
    });
  }

  return overflowOffsets;
}

/***/ }),

/***/ 33706:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ expandToHashMap; }
/* harmony export */ });
function expandToHashMap(value, keys) {
  return keys.reduce(function (hashMap, key) {
    hashMap[key] = value;
    return hashMap;
  }, {});
}

/***/ }),

/***/ 6206:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getBasePlacement; }
/* harmony export */ });

function getBasePlacement(placement) {
  return placement.split('-')[0];
}

/***/ }),

/***/ 23607:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getFreshSideObject; }
/* harmony export */ });
function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}

/***/ }),

/***/ 11516:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getMainAxisFromPlacement; }
/* harmony export */ });
function getMainAxisFromPlacement(placement) {
  return ['top', 'bottom'].indexOf(placement) >= 0 ? 'x' : 'y';
}

/***/ }),

/***/ 14943:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getVariation; }
/* harmony export */ });
function getVariation(placement) {
  return placement.split('-')[1];
}

/***/ }),

/***/ 138:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fp": function() { return /* binding */ max; },
/* harmony export */   "NM": function() { return /* binding */ round; },
/* harmony export */   "VV": function() { return /* binding */ min; }
/* harmony export */ });
var max = Math.max;
var min = Math.min;
var round = Math.round;

/***/ }),

/***/ 63293:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ mergePaddingObject; }
/* harmony export */ });
/* harmony import */ var _getFreshSideObject_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23607);

function mergePaddingObject(paddingObject) {
  return Object.assign({}, (0,_getFreshSideObject_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(), paddingObject);
}

/***/ }),

/***/ 85918:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getUAString; }
/* harmony export */ });
function getUAString() {
  var uaData = navigator.userAgentData;

  if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) {
    return uaData.brands.map(function (item) {
      return item.brand + "/" + item.version;
    }).join(' ');
  }

  return navigator.userAgent;
}

/***/ }),

/***/ 57516:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ withinMaxClamp; },
/* harmony export */   "u": function() { return /* binding */ within; }
/* harmony export */ });
/* harmony import */ var _math_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(138);

function within(min, value, max) {
  return (0,_math_js__WEBPACK_IMPORTED_MODULE_0__/* .max */ .Fp)(min, (0,_math_js__WEBPACK_IMPORTED_MODULE_0__/* .min */ .VV)(value, max));
}
function withinMaxClamp(min, value, max) {
  var v = within(min, value, max);
  return v > max ? max : v;
}

/***/ }),

/***/ 77236:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "xC": function() { return /* binding */ configureStore; },
  "hg": function() { return /* binding */ createAsyncThunk; },
  "oM": function() { return /* binding */ createSlice; },
  "SI": function() { return /* binding */ unwrapResult; }
});

// UNUSED EXPORTS: MiddlewareArray, TaskAbortError, __DO_NOT_USE__ActionTypes, addListener, applyMiddleware, bindActionCreators, clearAllListeners, combineReducers, compose, createAction, createDraftSafeSelector, createEntityAdapter, createImmutableStateInvariantMiddleware, createListenerMiddleware, createNextState, createReducer, createSelector, createSerializableStateInvariantMiddleware, createStore, current, findNonSerializableValue, freeze, getDefaultMiddleware, getType, isAllOf, isAnyOf, isAsyncThunkAction, isDraft, isFulfilled, isImmutableDefault, isPending, isPlain, isPlainObject, isRejected, isRejectedWithValue, legacy_createStore, miniSerializeError, nanoid, original, removeListener

;// CONCATENATED MODULE: ./node_modules/immer/dist/immer.esm.mjs
function n(n){for(var r=arguments.length,t=Array(r>1?r-1:0),e=1;e<r;e++)t[e-1]=arguments[e];if(false){ var i, o; }throw Error("[Immer] minified error nr: "+n+(t.length?" "+t.map((function(n){return"'"+n+"'"})).join(","):"")+". Find the full error at: https://bit.ly/3cXEKWf")}function r(n){return!!n&&!!n[Q]}function t(n){var r;return!!n&&(function(n){if(!n||"object"!=typeof n)return!1;var r=Object.getPrototypeOf(n);if(null===r)return!0;var t=Object.hasOwnProperty.call(r,"constructor")&&r.constructor;return t===Object||"function"==typeof t&&Function.toString.call(t)===Z}(n)||Array.isArray(n)||!!n[L]||!!(null===(r=n.constructor)||void 0===r?void 0:r[L])||s(n)||v(n))}function e(t){return r(t)||n(23,t),t[Q].t}function i(n,r,t){void 0===t&&(t=!1),0===o(n)?(t?Object.keys:nn)(n).forEach((function(e){t&&"symbol"==typeof e||r(e,n[e],n)})):n.forEach((function(t,e){return r(e,t,n)}))}function o(n){var r=n[Q];return r?r.i>3?r.i-4:r.i:Array.isArray(n)?1:s(n)?2:v(n)?3:0}function u(n,r){return 2===o(n)?n.has(r):Object.prototype.hasOwnProperty.call(n,r)}function a(n,r){return 2===o(n)?n.get(r):n[r]}function f(n,r,t){var e=o(n);2===e?n.set(r,t):3===e?n.add(t):n[r]=t}function c(n,r){return n===r?0!==n||1/n==1/r:n!=n&&r!=r}function s(n){return X&&n instanceof Map}function v(n){return q&&n instanceof Set}function p(n){return n.o||n.t}function l(n){if(Array.isArray(n))return Array.prototype.slice.call(n);var r=rn(n);delete r[Q];for(var t=nn(r),e=0;e<t.length;e++){var i=t[e],o=r[i];!1===o.writable&&(o.writable=!0,o.configurable=!0),(o.get||o.set)&&(r[i]={configurable:!0,writable:!0,enumerable:o.enumerable,value:n[i]})}return Object.create(Object.getPrototypeOf(n),r)}function d(n,e){return void 0===e&&(e=!1),y(n)||r(n)||!t(n)||(o(n)>1&&(n.set=n.add=n.clear=n.delete=h),Object.freeze(n),e&&i(n,(function(n,r){return d(r,!0)}),!0)),n}function h(){n(2)}function y(n){return null==n||"object"!=typeof n||Object.isFrozen(n)}function b(r){var t=tn[r];return t||n(18,r),t}function m(n,r){tn[n]||(tn[n]=r)}function _(){return true||0,U}function j(n,r){r&&(b("Patches"),n.u=[],n.s=[],n.v=r)}function g(n){O(n),n.p.forEach(S),n.p=null}function O(n){n===U&&(U=n.l)}function w(n){return U={p:[],l:U,h:n,m:!0,_:0}}function S(n){var r=n[Q];0===r.i||1===r.i?r.j():r.g=!0}function P(r,e){e._=e.p.length;var i=e.p[0],o=void 0!==r&&r!==i;return e.h.O||b("ES5").S(e,r,o),o?(i[Q].P&&(g(e),n(4)),t(r)&&(r=M(e,r),e.l||x(e,r)),e.u&&b("Patches").M(i[Q].t,r,e.u,e.s)):r=M(e,i,[]),g(e),e.u&&e.v(e.u,e.s),r!==H?r:void 0}function M(n,r,t){if(y(r))return r;var e=r[Q];if(!e)return i(r,(function(i,o){return A(n,e,r,i,o,t)}),!0),r;if(e.A!==n)return r;if(!e.P)return x(n,e.t,!0),e.t;if(!e.I){e.I=!0,e.A._--;var o=4===e.i||5===e.i?e.o=l(e.k):e.o,u=o,a=!1;3===e.i&&(u=new Set(o),o.clear(),a=!0),i(u,(function(r,i){return A(n,e,o,r,i,t,a)})),x(n,o,!1),t&&n.u&&b("Patches").N(e,t,n.u,n.s)}return e.o}function A(e,i,o,a,c,s,v){if( false&&0,r(c)){var p=M(e,c,s&&i&&3!==i.i&&!u(i.R,a)?s.concat(a):void 0);if(f(o,a,p),!r(p))return;e.m=!1}else v&&o.add(c);if(t(c)&&!y(c)){if(!e.h.D&&e._<1)return;M(e,c),i&&i.A.l||x(e,c)}}function x(n,r,t){void 0===t&&(t=!1),!n.l&&n.h.D&&n.m&&d(r,t)}function z(n,r){var t=n[Q];return(t?p(t):n)[r]}function I(n,r){if(r in n)for(var t=Object.getPrototypeOf(n);t;){var e=Object.getOwnPropertyDescriptor(t,r);if(e)return e;t=Object.getPrototypeOf(t)}}function k(n){n.P||(n.P=!0,n.l&&k(n.l))}function E(n){n.o||(n.o=l(n.t))}function N(n,r,t){var e=s(r)?b("MapSet").F(r,t):v(r)?b("MapSet").T(r,t):n.O?function(n,r){var t=Array.isArray(n),e={i:t?1:0,A:r?r.A:_(),P:!1,I:!1,R:{},l:r,t:n,k:null,o:null,j:null,C:!1},i=e,o=en;t&&(i=[e],o=on);var u=Proxy.revocable(i,o),a=u.revoke,f=u.proxy;return e.k=f,e.j=a,f}(r,t):b("ES5").J(r,t);return(t?t.A:_()).p.push(e),e}function R(e){return r(e)||n(22,e),function n(r){if(!t(r))return r;var e,u=r[Q],c=o(r);if(u){if(!u.P&&(u.i<4||!b("ES5").K(u)))return u.t;u.I=!0,e=D(r,c),u.I=!1}else e=D(r,c);return i(e,(function(r,t){u&&a(u.t,r)===t||f(e,r,n(t))})),3===c?new Set(e):e}(e)}function D(n,r){switch(r){case 2:return new Map(n);case 3:return Array.from(n)}return l(n)}function F(){function t(n,r){var t=s[n];return t?t.enumerable=r:s[n]=t={configurable:!0,enumerable:r,get:function(){var r=this[Q];return false&&0,en.get(r,n)},set:function(r){var t=this[Q]; false&&0,en.set(t,n,r)}},t}function e(n){for(var r=n.length-1;r>=0;r--){var t=n[r][Q];if(!t.P)switch(t.i){case 5:a(t)&&k(t);break;case 4:o(t)&&k(t)}}}function o(n){for(var r=n.t,t=n.k,e=nn(t),i=e.length-1;i>=0;i--){var o=e[i];if(o!==Q){var a=r[o];if(void 0===a&&!u(r,o))return!0;var f=t[o],s=f&&f[Q];if(s?s.t!==a:!c(f,a))return!0}}var v=!!r[Q];return e.length!==nn(r).length+(v?0:1)}function a(n){var r=n.k;if(r.length!==n.t.length)return!0;var t=Object.getOwnPropertyDescriptor(r,r.length-1);if(t&&!t.get)return!0;for(var e=0;e<r.length;e++)if(!r.hasOwnProperty(e))return!0;return!1}function f(r){r.g&&n(3,JSON.stringify(p(r)))}var s={};m("ES5",{J:function(n,r){var e=Array.isArray(n),i=function(n,r){if(n){for(var e=Array(r.length),i=0;i<r.length;i++)Object.defineProperty(e,""+i,t(i,!0));return e}var o=rn(r);delete o[Q];for(var u=nn(o),a=0;a<u.length;a++){var f=u[a];o[f]=t(f,n||!!o[f].enumerable)}return Object.create(Object.getPrototypeOf(r),o)}(e,n),o={i:e?5:4,A:r?r.A:_(),P:!1,I:!1,R:{},l:r,t:n,k:i,o:null,g:!1,C:!1};return Object.defineProperty(i,Q,{value:o,writable:!0}),i},S:function(n,t,o){o?r(t)&&t[Q].A===n&&e(n.p):(n.u&&function n(r){if(r&&"object"==typeof r){var t=r[Q];if(t){var e=t.t,o=t.k,f=t.R,c=t.i;if(4===c)i(o,(function(r){r!==Q&&(void 0!==e[r]||u(e,r)?f[r]||n(o[r]):(f[r]=!0,k(t)))})),i(e,(function(n){void 0!==o[n]||u(o,n)||(f[n]=!1,k(t))}));else if(5===c){if(a(t)&&(k(t),f.length=!0),o.length<e.length)for(var s=o.length;s<e.length;s++)f[s]=!1;else for(var v=e.length;v<o.length;v++)f[v]=!0;for(var p=Math.min(o.length,e.length),l=0;l<p;l++)o.hasOwnProperty(l)||(f[l]=!0),void 0===f[l]&&n(o[l])}}}}(n.p[0]),e(n.p))},K:function(n){return 4===n.i?o(n):a(n)}})}function T(){function e(n){if(!t(n))return n;if(Array.isArray(n))return n.map(e);if(s(n))return new Map(Array.from(n.entries()).map((function(n){return[n[0],e(n[1])]})));if(v(n))return new Set(Array.from(n).map(e));var r=Object.create(Object.getPrototypeOf(n));for(var i in n)r[i]=e(n[i]);return u(n,L)&&(r[L]=n[L]),r}function f(n){return r(n)?e(n):n}var c="add";m("Patches",{$:function(r,t){return t.forEach((function(t){for(var i=t.path,u=t.op,f=r,s=0;s<i.length-1;s++){var v=o(f),p=i[s];"string"!=typeof p&&"number"!=typeof p&&(p=""+p),0!==v&&1!==v||"__proto__"!==p&&"constructor"!==p||n(24),"function"==typeof f&&"prototype"===p&&n(24),"object"!=typeof(f=a(f,p))&&n(15,i.join("/"))}var l=o(f),d=e(t.value),h=i[i.length-1];switch(u){case"replace":switch(l){case 2:return f.set(h,d);case 3:n(16);default:return f[h]=d}case c:switch(l){case 1:return"-"===h?f.push(d):f.splice(h,0,d);case 2:return f.set(h,d);case 3:return f.add(d);default:return f[h]=d}case"remove":switch(l){case 1:return f.splice(h,1);case 2:return f.delete(h);case 3:return f.delete(t.value);default:return delete f[h]}default:n(17,u)}})),r},N:function(n,r,t,e){switch(n.i){case 0:case 4:case 2:return function(n,r,t,e){var o=n.t,s=n.o;i(n.R,(function(n,i){var v=a(o,n),p=a(s,n),l=i?u(o,n)?"replace":c:"remove";if(v!==p||"replace"!==l){var d=r.concat(n);t.push("remove"===l?{op:l,path:d}:{op:l,path:d,value:p}),e.push(l===c?{op:"remove",path:d}:"remove"===l?{op:c,path:d,value:f(v)}:{op:"replace",path:d,value:f(v)})}}))}(n,r,t,e);case 5:case 1:return function(n,r,t,e){var i=n.t,o=n.R,u=n.o;if(u.length<i.length){var a=[u,i];i=a[0],u=a[1];var s=[e,t];t=s[0],e=s[1]}for(var v=0;v<i.length;v++)if(o[v]&&u[v]!==i[v]){var p=r.concat([v]);t.push({op:"replace",path:p,value:f(u[v])}),e.push({op:"replace",path:p,value:f(i[v])})}for(var l=i.length;l<u.length;l++){var d=r.concat([l]);t.push({op:c,path:d,value:f(u[l])})}i.length<u.length&&e.push({op:"replace",path:r.concat(["length"]),value:i.length})}(n,r,t,e);case 3:return function(n,r,t,e){var i=n.t,o=n.o,u=0;i.forEach((function(n){if(!o.has(n)){var i=r.concat([u]);t.push({op:"remove",path:i,value:n}),e.unshift({op:c,path:i,value:n})}u++})),u=0,o.forEach((function(n){if(!i.has(n)){var o=r.concat([u]);t.push({op:c,path:o,value:n}),e.unshift({op:"remove",path:o,value:n})}u++}))}(n,r,t,e)}},M:function(n,r,t,e){t.push({op:"replace",path:[],value:r===H?void 0:r}),e.push({op:"replace",path:[],value:n})}})}function C(){function r(n,r){function t(){this.constructor=n}a(n,r),n.prototype=(t.prototype=r.prototype,new t)}function e(n){n.o||(n.R=new Map,n.o=new Map(n.t))}function o(n){n.o||(n.o=new Set,n.t.forEach((function(r){if(t(r)){var e=N(n.A.h,r,n);n.p.set(r,e),n.o.add(e)}else n.o.add(r)})))}function u(r){r.g&&n(3,JSON.stringify(p(r)))}var a=function(n,r){return(a=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(n,r){n.__proto__=r}||function(n,r){for(var t in r)r.hasOwnProperty(t)&&(n[t]=r[t])})(n,r)},f=function(){function n(n,r){return this[Q]={i:2,l:r,A:r?r.A:_(),P:!1,I:!1,o:void 0,R:void 0,t:n,k:this,C:!1,g:!1},this}r(n,Map);var o=n.prototype;return Object.defineProperty(o,"size",{get:function(){return p(this[Q]).size}}),o.has=function(n){return p(this[Q]).has(n)},o.set=function(n,r){var t=this[Q];return u(t),p(t).has(n)&&p(t).get(n)===r||(e(t),k(t),t.R.set(n,!0),t.o.set(n,r),t.R.set(n,!0)),this},o.delete=function(n){if(!this.has(n))return!1;var r=this[Q];return u(r),e(r),k(r),r.t.has(n)?r.R.set(n,!1):r.R.delete(n),r.o.delete(n),!0},o.clear=function(){var n=this[Q];u(n),p(n).size&&(e(n),k(n),n.R=new Map,i(n.t,(function(r){n.R.set(r,!1)})),n.o.clear())},o.forEach=function(n,r){var t=this;p(this[Q]).forEach((function(e,i){n.call(r,t.get(i),i,t)}))},o.get=function(n){var r=this[Q];u(r);var i=p(r).get(n);if(r.I||!t(i))return i;if(i!==r.t.get(n))return i;var o=N(r.A.h,i,r);return e(r),r.o.set(n,o),o},o.keys=function(){return p(this[Q]).keys()},o.values=function(){var n,r=this,t=this.keys();return(n={})[V]=function(){return r.values()},n.next=function(){var n=t.next();return n.done?n:{done:!1,value:r.get(n.value)}},n},o.entries=function(){var n,r=this,t=this.keys();return(n={})[V]=function(){return r.entries()},n.next=function(){var n=t.next();if(n.done)return n;var e=r.get(n.value);return{done:!1,value:[n.value,e]}},n},o[V]=function(){return this.entries()},n}(),c=function(){function n(n,r){return this[Q]={i:3,l:r,A:r?r.A:_(),P:!1,I:!1,o:void 0,t:n,k:this,p:new Map,g:!1,C:!1},this}r(n,Set);var t=n.prototype;return Object.defineProperty(t,"size",{get:function(){return p(this[Q]).size}}),t.has=function(n){var r=this[Q];return u(r),r.o?!!r.o.has(n)||!(!r.p.has(n)||!r.o.has(r.p.get(n))):r.t.has(n)},t.add=function(n){var r=this[Q];return u(r),this.has(n)||(o(r),k(r),r.o.add(n)),this},t.delete=function(n){if(!this.has(n))return!1;var r=this[Q];return u(r),o(r),k(r),r.o.delete(n)||!!r.p.has(n)&&r.o.delete(r.p.get(n))},t.clear=function(){var n=this[Q];u(n),p(n).size&&(o(n),k(n),n.o.clear())},t.values=function(){var n=this[Q];return u(n),o(n),n.o.values()},t.entries=function(){var n=this[Q];return u(n),o(n),n.o.entries()},t.keys=function(){return this.values()},t[V]=function(){return this.values()},t.forEach=function(n,r){for(var t=this.values(),e=t.next();!e.done;)n.call(r,e.value,e.value,this),e=t.next()},n}();m("MapSet",{F:function(n,r){return new f(n,r)},T:function(n,r){return new c(n,r)}})}function J(){F(),C(),T()}function K(n){return n}function $(n){return n}var G,U,W="undefined"!=typeof Symbol&&"symbol"==typeof Symbol("x"),X="undefined"!=typeof Map,q="undefined"!=typeof Set,B="undefined"!=typeof Proxy&&void 0!==Proxy.revocable&&"undefined"!=typeof Reflect,H=W?Symbol.for("immer-nothing"):((G={})["immer-nothing"]=!0,G),L=W?Symbol.for("immer-draftable"):"__$immer_draftable",Q=W?Symbol.for("immer-state"):"__$immer_state",V="undefined"!=typeof Symbol&&Symbol.iterator||"@@iterator",Y={0:"Illegal state",1:"Immer drafts cannot have computed properties",2:"This object has been frozen and should not be mutated",3:function(n){return"Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? "+n},4:"An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",5:"Immer forbids circular references",6:"The first or second argument to `produce` must be a function",7:"The third argument to `produce` must be a function or undefined",8:"First argument to `createDraft` must be a plain object, an array, or an immerable object",9:"First argument to `finishDraft` must be a draft returned by `createDraft`",10:"The given draft is already finalized",11:"Object.defineProperty() cannot be used on an Immer draft",12:"Object.setPrototypeOf() cannot be used on an Immer draft",13:"Immer only supports deleting array indices",14:"Immer only supports setting array indices and the 'length' property",15:function(n){return"Cannot apply patch, path doesn't resolve: "+n},16:'Sets cannot have "replace" patches.',17:function(n){return"Unsupported patch operation: "+n},18:function(n){return"The plugin for '"+n+"' has not been loaded into Immer. To enable the plugin, import and call `enable"+n+"()` when initializing your application."},20:"Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",21:function(n){return"produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '"+n+"'"},22:function(n){return"'current' expects a draft, got: "+n},23:function(n){return"'original' expects a draft, got: "+n},24:"Patching reserved attributes like __proto__, prototype and constructor is not allowed"},Z=""+Object.prototype.constructor,nn="undefined"!=typeof Reflect&&Reflect.ownKeys?Reflect.ownKeys:void 0!==Object.getOwnPropertySymbols?function(n){return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n))}:Object.getOwnPropertyNames,rn=Object.getOwnPropertyDescriptors||function(n){var r={};return nn(n).forEach((function(t){r[t]=Object.getOwnPropertyDescriptor(n,t)})),r},tn={},en={get:function(n,r){if(r===Q)return n;var e=p(n);if(!u(e,r))return function(n,r,t){var e,i=I(r,t);return i?"value"in i?i.value:null===(e=i.get)||void 0===e?void 0:e.call(n.k):void 0}(n,e,r);var i=e[r];return n.I||!t(i)?i:i===z(n.t,r)?(E(n),n.o[r]=N(n.A.h,i,n)):i},has:function(n,r){return r in p(n)},ownKeys:function(n){return Reflect.ownKeys(p(n))},set:function(n,r,t){var e=I(p(n),r);if(null==e?void 0:e.set)return e.set.call(n.k,t),!0;if(!n.P){var i=z(p(n),r),o=null==i?void 0:i[Q];if(o&&o.t===t)return n.o[r]=t,n.R[r]=!1,!0;if(c(t,i)&&(void 0!==t||u(n.t,r)))return!0;E(n),k(n)}return n.o[r]===t&&(void 0!==t||r in n.o)||Number.isNaN(t)&&Number.isNaN(n.o[r])||(n.o[r]=t,n.R[r]=!0),!0},deleteProperty:function(n,r){return void 0!==z(n.t,r)||r in n.t?(n.R[r]=!1,E(n),k(n)):delete n.R[r],n.o&&delete n.o[r],!0},getOwnPropertyDescriptor:function(n,r){var t=p(n),e=Reflect.getOwnPropertyDescriptor(t,r);return e?{writable:!0,configurable:1!==n.i||"length"!==r,enumerable:e.enumerable,value:t[r]}:e},defineProperty:function(){n(11)},getPrototypeOf:function(n){return Object.getPrototypeOf(n.t)},setPrototypeOf:function(){n(12)}},on={};i(en,(function(n,r){on[n]=function(){return arguments[0]=arguments[0][0],r.apply(this,arguments)}})),on.deleteProperty=function(r,t){return false&&0,on.set.call(this,r,t,void 0)},on.set=function(r,t,e){return false&&0,en.set.call(this,r[0],t,e,r[0])};var un=function(){function e(r){var e=this;this.O=B,this.D=!0,this.produce=function(r,i,o){if("function"==typeof r&&"function"!=typeof i){var u=i;i=r;var a=e;return function(n){var r=this;void 0===n&&(n=u);for(var t=arguments.length,e=Array(t>1?t-1:0),o=1;o<t;o++)e[o-1]=arguments[o];return a.produce(n,(function(n){var t;return(t=i).call.apply(t,[r,n].concat(e))}))}}var f;if("function"!=typeof i&&n(6),void 0!==o&&"function"!=typeof o&&n(7),t(r)){var c=w(e),s=N(e,r,void 0),v=!0;try{f=i(s),v=!1}finally{v?g(c):O(c)}return"undefined"!=typeof Promise&&f instanceof Promise?f.then((function(n){return j(c,o),P(n,c)}),(function(n){throw g(c),n})):(j(c,o),P(f,c))}if(!r||"object"!=typeof r){if(void 0===(f=i(r))&&(f=r),f===H&&(f=void 0),e.D&&d(f,!0),o){var p=[],l=[];b("Patches").M(r,f,p,l),o(p,l)}return f}n(21,r)},this.produceWithPatches=function(n,r){if("function"==typeof n)return function(r){for(var t=arguments.length,i=Array(t>1?t-1:0),o=1;o<t;o++)i[o-1]=arguments[o];return e.produceWithPatches(r,(function(r){return n.apply(void 0,[r].concat(i))}))};var t,i,o=e.produce(n,r,(function(n,r){t=n,i=r}));return"undefined"!=typeof Promise&&o instanceof Promise?o.then((function(n){return[n,t,i]})):[o,t,i]},"boolean"==typeof(null==r?void 0:r.useProxies)&&this.setUseProxies(r.useProxies),"boolean"==typeof(null==r?void 0:r.autoFreeze)&&this.setAutoFreeze(r.autoFreeze)}var i=e.prototype;return i.createDraft=function(e){t(e)||n(8),r(e)&&(e=R(e));var i=w(this),o=N(this,e,void 0);return o[Q].C=!0,O(i),o},i.finishDraft=function(r,t){var e=r&&r[Q]; false&&(0);var i=e.A;return j(i,t),P(void 0,i)},i.setAutoFreeze=function(n){this.D=n},i.setUseProxies=function(r){r&&!B&&n(20),this.O=r},i.applyPatches=function(n,t){var e;for(e=t.length-1;e>=0;e--){var i=t[e];if(0===i.path.length&&"replace"===i.op){n=i.value;break}}e>-1&&(t=t.slice(e+1));var o=b("Patches").$;return r(n)?o(n,t):this.produce(n,(function(n){return o(n,t)}))},e}(),an=new un,fn=an.produce,cn=an.produceWithPatches.bind(an),sn=an.setAutoFreeze.bind(an),vn=an.setUseProxies.bind(an),pn=an.applyPatches.bind(an),ln=an.createDraft.bind(an),dn=an.finishDraft.bind(an);/* harmony default export */ var immer_esm = (fn);
//# sourceMappingURL=immer.esm.js.map

// EXTERNAL MODULE: ./node_modules/redux/es/redux.js + 1 modules
var redux = __webpack_require__(45217);
;// CONCATENATED MODULE: ./node_modules/redux-thunk/es/index.js
/** A function that accepts a potential "extra argument" value to be injected later,
 * and returns an instance of the thunk middleware that uses that value
 */
function createThunkMiddleware(extraArgument) {
  // Standard Redux middleware definition pattern:
  // See: https://redux.js.org/tutorials/fundamentals/part-4-store#writing-custom-middleware
  var middleware = function middleware(_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        // The thunk middleware looks for any functions that were passed to `store.dispatch`.
        // If this "action" is really a function, call it and return the result.
        if (typeof action === 'function') {
          // Inject the store's `dispatch` and `getState` methods, as well as any "extra arg"
          return action(dispatch, getState, extraArgument);
        } // Otherwise, pass the action down the middleware chain as usual


        return next(action);
      };
    };
  };

  return middleware;
}

var thunk = createThunkMiddleware(); // Attach the factory function so users can create a customized version
// with whatever "extra arg" they want to inject into their thunks

thunk.withExtraArgument = createThunkMiddleware;
/* harmony default export */ var es = (thunk);
;// CONCATENATED MODULE: ./node_modules/@reduxjs/toolkit/dist/redux-toolkit.esm.js
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (undefined && undefined.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function (obj, key, value) { return key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value: value }) : obj[key] = value; };
var __spreadValues = function (a, b) {
    for (var prop in b || (b = {}))
        if (__hasOwnProp.call(b, prop))
            __defNormalProp(a, prop, b[prop]);
    if (__getOwnPropSymbols)
        for (var _i = 0, _c = __getOwnPropSymbols(b); _i < _c.length; _i++) {
            var prop = _c[_i];
            if (__propIsEnum.call(b, prop))
                __defNormalProp(a, prop, b[prop]);
        }
    return a;
};
var __spreadProps = function (a, b) { return __defProps(a, __getOwnPropDescs(b)); };
var __async = function (__this, __arguments, generator) {
    return new Promise(function (resolve, reject) {
        var fulfilled = function (value) {
            try {
                step(generator.next(value));
            }
            catch (e) {
                reject(e);
            }
        };
        var rejected = function (value) {
            try {
                step(generator.throw(value));
            }
            catch (e) {
                reject(e);
            }
        };
        var step = function (x) { return x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected); };
        step((generator = generator.apply(__this, __arguments)).next());
    });
};
// src/index.ts




// src/createDraftSafeSelector.ts


var createDraftSafeSelector = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var selector = createSelector.apply(void 0, args);
    var wrappedSelector = function (value) {
        var rest = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            rest[_i - 1] = arguments[_i];
        }
        return selector.apply(void 0, __spreadArray([isDraft(value) ? current(value) : value], rest));
    };
    return wrappedSelector;
};
// src/configureStore.ts

// src/devtoolsExtension.ts

var composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function () {
    if (arguments.length === 0)
        return void 0;
    if (typeof arguments[0] === "object")
        return redux/* compose */.qC;
    return redux/* compose.apply */.qC.apply(null, arguments);
};
var devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function () {
    return function (noop2) {
        return noop2;
    };
};
// src/isPlainObject.ts
function isPlainObject(value) {
    if (typeof value !== "object" || value === null)
        return false;
    var proto = Object.getPrototypeOf(value);
    if (proto === null)
        return true;
    var baseProto = proto;
    while (Object.getPrototypeOf(baseProto) !== null) {
        baseProto = Object.getPrototypeOf(baseProto);
    }
    return proto === baseProto;
}
// src/getDefaultMiddleware.ts

// src/utils.ts
function getTimeMeasureUtils(maxDelay, fnName) {
    var elapsed = 0;
    return {
        measureTime: function (fn) {
            var started = Date.now();
            try {
                return fn();
            }
            finally {
                var finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded: function () {
            if (elapsed > maxDelay) {
                console.warn(fnName + " took " + elapsed + "ms, which is more than the warning threshold of " + maxDelay + "ms. \nIf your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.\nIt is disabled in production builds, so you don't need to worry about that.");
            }
        }
    };
}
var MiddlewareArray = /** @class */ (function (_super) {
    __extends(MiddlewareArray, _super);
    function MiddlewareArray() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var _this = _super.apply(this, args) || this;
        Object.setPrototypeOf(_this, MiddlewareArray.prototype);
        return _this;
    }
    Object.defineProperty(MiddlewareArray, Symbol.species, {
        get: function () {
            return MiddlewareArray;
        },
        enumerable: false,
        configurable: true
    });
    MiddlewareArray.prototype.concat = function () {
        var arr = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            arr[_i] = arguments[_i];
        }
        return _super.prototype.concat.apply(this, arr);
    };
    MiddlewareArray.prototype.prepend = function () {
        var arr = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            arr[_i] = arguments[_i];
        }
        if (arr.length === 1 && Array.isArray(arr[0])) {
            return new (MiddlewareArray.bind.apply(MiddlewareArray, __spreadArray([void 0], arr[0].concat(this))))();
        }
        return new (MiddlewareArray.bind.apply(MiddlewareArray, __spreadArray([void 0], arr.concat(this))))();
    };
    return MiddlewareArray;
}(Array));
// src/immutableStateInvariantMiddleware.ts
var isProduction = (/* unused pure expression or super */ null && ("production" === "production"));
var prefix = "Invariant failed";
function invariant(condition, message) {
    if (condition) {
        return;
    }
    if (isProduction) {
        throw new Error(prefix);
    }
    throw new Error(prefix + ": " + (message || ""));
}
function stringify(obj, serializer, indent, decycler) {
    return JSON.stringify(obj, getSerialize(serializer, decycler), indent);
}
function getSerialize(serializer, decycler) {
    var stack = [], keys = [];
    if (!decycler)
        decycler = function (_, value) {
            if (stack[0] === value)
                return "[Circular ~]";
            return "[Circular ~." + keys.slice(0, stack.indexOf(value)).join(".") + "]";
        };
    return function (key, value) {
        if (stack.length > 0) {
            var thisPos = stack.indexOf(this);
            ~thisPos ? stack.splice(thisPos + 1) : stack.push(this);
            ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key);
            if (~stack.indexOf(value))
                value = decycler.call(this, key, value);
        }
        else
            stack.push(value);
        return serializer == null ? value : serializer.call(this, key, value);
    };
}
function isImmutableDefault(value) {
    return typeof value !== "object" || value === null || typeof value === "undefined" || Object.isFrozen(value);
}
function trackForMutations(isImmutable, ignorePaths, obj) {
    var trackedProperties = trackProperties(isImmutable, ignorePaths, obj);
    return {
        detectMutations: function () {
            return detectMutations(isImmutable, ignorePaths, trackedProperties, obj);
        }
    };
}
function trackProperties(isImmutable, ignorePaths, obj, path) {
    if (ignorePaths === void 0) { ignorePaths = []; }
    if (path === void 0) { path = ""; }
    var tracked = { value: obj };
    if (!isImmutable(obj)) {
        tracked.children = {};
        for (var key in obj) {
            var childPath = path ? path + "." + key : key;
            if (ignorePaths.length && ignorePaths.indexOf(childPath) !== -1) {
                continue;
            }
            tracked.children[key] = trackProperties(isImmutable, ignorePaths, obj[key], childPath);
        }
    }
    return tracked;
}
function detectMutations(isImmutable, ignorePaths, trackedProperty, obj, sameParentRef, path) {
    if (ignorePaths === void 0) { ignorePaths = []; }
    if (sameParentRef === void 0) { sameParentRef = false; }
    if (path === void 0) { path = ""; }
    var prevObj = trackedProperty ? trackedProperty.value : void 0;
    var sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) {
        return { wasMutated: true, path: path };
    }
    if (isImmutable(prevObj) || isImmutable(obj)) {
        return { wasMutated: false };
    }
    var keysToDetect = {};
    for (var key in trackedProperty.children) {
        keysToDetect[key] = true;
    }
    for (var key in obj) {
        keysToDetect[key] = true;
    }
    for (var key in keysToDetect) {
        var childPath = path ? path + "." + key : key;
        if (ignorePaths.length && ignorePaths.indexOf(childPath) !== -1) {
            continue;
        }
        var result = detectMutations(isImmutable, ignorePaths, trackedProperty.children[key], obj[key], sameRef, childPath);
        if (result.wasMutated) {
            return result;
        }
    }
    return { wasMutated: false };
}
function createImmutableStateInvariantMiddleware(options) {
    if (options === void 0) { options = {}; }
    if (true) {
        return function () { return function (next) { return function (action) { return next(action); }; }; };
    }
    var _c = options.isImmutable, isImmutable = _c === void 0 ? isImmutableDefault : _c, ignoredPaths = options.ignoredPaths, _d = options.warnAfter, warnAfter = _d === void 0 ? 32 : _d, ignore = options.ignore;
    ignoredPaths = ignoredPaths || ignore;
    var track = trackForMutations.bind(null, isImmutable, ignoredPaths);
    return function (_c) {
        var getState = _c.getState;
        var state = getState();
        var tracker = track(state);
        var result;
        return function (next) { return function (action) {
            var measureUtils = getTimeMeasureUtils(warnAfter, "ImmutableStateInvariantMiddleware");
            measureUtils.measureTime(function () {
                state = getState();
                result = tracker.detectMutations();
                tracker = track(state);
                invariant(!result.wasMutated, "A state mutation was detected between dispatches, in the path '" + (result.path || "") + "'.  This may cause incorrect behavior. (https://redux.js.org/style-guide/style-guide#do-not-mutate-state)");
            });
            var dispatchedAction = next(action);
            measureUtils.measureTime(function () {
                state = getState();
                result = tracker.detectMutations();
                tracker = track(state);
                result.wasMutated && invariant(!result.wasMutated, "A state mutation was detected inside a dispatch, in the path: " + (result.path || "") + ". Take a look at the reducer(s) handling the action " + stringify(action) + ". (https://redux.js.org/style-guide/style-guide#do-not-mutate-state)");
            });
            measureUtils.warnIfExceeded();
            return dispatchedAction;
        }; };
    };
}
// src/serializableStateInvariantMiddleware.ts
function isPlain(val) {
    var type = typeof val;
    return type === "undefined" || val === null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || isPlainObject(val);
}
function findNonSerializableValue(value, path, isSerializable, getEntries, ignoredPaths) {
    if (path === void 0) { path = ""; }
    if (isSerializable === void 0) { isSerializable = isPlain; }
    if (ignoredPaths === void 0) { ignoredPaths = []; }
    var foundNestedSerializable;
    if (!isSerializable(value)) {
        return {
            keyPath: path || "<root>",
            value: value
        };
    }
    if (typeof value !== "object" || value === null) {
        return false;
    }
    var entries = getEntries != null ? getEntries(value) : Object.entries(value);
    var hasIgnoredPaths = ignoredPaths.length > 0;
    for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
        var _c = entries_1[_i], key = _c[0], nestedValue = _c[1];
        var nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths && ignoredPaths.indexOf(nestedPath) >= 0) {
            continue;
        }
        if (!isSerializable(nestedValue)) {
            return {
                keyPath: nestedPath,
                value: nestedValue
            };
        }
        if (typeof nestedValue === "object") {
            foundNestedSerializable = findNonSerializableValue(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths);
            if (foundNestedSerializable) {
                return foundNestedSerializable;
            }
        }
    }
    return false;
}
function createSerializableStateInvariantMiddleware(options) {
    if (options === void 0) { options = {}; }
    if (true) {
        return function () { return function (next) { return function (action) { return next(action); }; }; };
    }
    var _c = options.isSerializable, isSerializable = _c === void 0 ? isPlain : _c, getEntries = options.getEntries, _d = options.ignoredActions, ignoredActions = _d === void 0 ? [] : _d, _e = options.ignoredActionPaths, ignoredActionPaths = _e === void 0 ? ["meta.arg", "meta.baseQueryMeta"] : _e, _f = options.ignoredPaths, ignoredPaths = _f === void 0 ? [] : _f, _g = options.warnAfter, warnAfter = _g === void 0 ? 32 : _g, _h = options.ignoreState, ignoreState = _h === void 0 ? false : _h, _j = options.ignoreActions, ignoreActions = _j === void 0 ? false : _j;
    return function (storeAPI) { return function (next) { return function (action) {
        var result = next(action);
        var measureUtils = getTimeMeasureUtils(warnAfter, "SerializableStateInvariantMiddleware");
        if (!ignoreActions && !(ignoredActions.length && ignoredActions.indexOf(action.type) !== -1)) {
            measureUtils.measureTime(function () {
                var foundActionNonSerializableValue = findNonSerializableValue(action, "", isSerializable, getEntries, ignoredActionPaths);
                if (foundActionNonSerializableValue) {
                    var keyPath = foundActionNonSerializableValue.keyPath, value = foundActionNonSerializableValue.value;
                    console.error("A non-serializable value was detected in an action, in the path: `" + keyPath + "`. Value:", value, "\nTake a look at the logic that dispatched this action: ", action, "\n(See https://redux.js.org/faq/actions#why-should-type-be-a-string-or-at-least-serializable-why-should-my-action-types-be-constants)", "\n(To allow non-serializable values see: https://redux-toolkit.js.org/usage/usage-guide#working-with-non-serializable-data)");
                }
            });
        }
        if (!ignoreState) {
            measureUtils.measureTime(function () {
                var state = storeAPI.getState();
                var foundStateNonSerializableValue = findNonSerializableValue(state, "", isSerializable, getEntries, ignoredPaths);
                if (foundStateNonSerializableValue) {
                    var keyPath = foundStateNonSerializableValue.keyPath, value = foundStateNonSerializableValue.value;
                    console.error("A non-serializable value was detected in the state, in the path: `" + keyPath + "`. Value:", value, "\nTake a look at the reducer(s) handling this action type: " + action.type + ".\n(See https://redux.js.org/faq/organizing-state#can-i-put-functions-promises-or-other-non-serializable-items-in-my-store-state)");
                }
            });
            measureUtils.warnIfExceeded();
        }
        return result;
    }; }; };
}
// src/getDefaultMiddleware.ts
function isBoolean(x) {
    return typeof x === "boolean";
}
function curryGetDefaultMiddleware() {
    return function curriedGetDefaultMiddleware(options) {
        return getDefaultMiddleware(options);
    };
}
function getDefaultMiddleware(options) {
    if (options === void 0) { options = {}; }
    var _c = options.thunk, thunk = _c === void 0 ? true : _c, _d = options.immutableCheck, immutableCheck = _d === void 0 ? true : _d, _e = options.serializableCheck, serializableCheck = _e === void 0 ? true : _e;
    var middlewareArray = new MiddlewareArray();
    if (thunk) {
        if (isBoolean(thunk)) {
            middlewareArray.push(es);
        }
        else {
            middlewareArray.push(es.withExtraArgument(thunk.extraArgument));
        }
    }
    if (false) { var serializableOptions, immutableOptions; }
    return middlewareArray;
}
// src/configureStore.ts
var IS_PRODUCTION = "production" === "production";
function configureStore(options) {
    var curriedGetDefaultMiddleware = curryGetDefaultMiddleware();
    var _c = options || {}, _d = _c.reducer, reducer = _d === void 0 ? void 0 : _d, _e = _c.middleware, middleware = _e === void 0 ? curriedGetDefaultMiddleware() : _e, _f = _c.devTools, devTools = _f === void 0 ? true : _f, _g = _c.preloadedState, preloadedState = _g === void 0 ? void 0 : _g, _h = _c.enhancers, enhancers = _h === void 0 ? void 0 : _h;
    var rootReducer;
    if (typeof reducer === "function") {
        rootReducer = reducer;
    }
    else if (isPlainObject(reducer)) {
        rootReducer = (0,redux/* combineReducers */.UY)(reducer);
    }
    else {
        throw new Error('"reducer" is a required argument, and must be a function or an object of functions that can be passed to combineReducers');
    }
    var finalMiddleware = middleware;
    if (typeof finalMiddleware === "function") {
        finalMiddleware = finalMiddleware(curriedGetDefaultMiddleware);
        if (!IS_PRODUCTION && !Array.isArray(finalMiddleware)) {
            throw new Error("when using a middleware builder function, an array of middleware must be returned");
        }
    }
    if (!IS_PRODUCTION && finalMiddleware.some(function (item) { return typeof item !== "function"; })) {
        throw new Error("each middleware provided to configureStore must be a function");
    }
    var middlewareEnhancer = redux/* applyMiddleware.apply */.md.apply(void 0, finalMiddleware);
    var finalCompose = redux/* compose */.qC;
    if (devTools) {
        finalCompose = composeWithDevTools(__spreadValues({
            trace: !IS_PRODUCTION
        }, typeof devTools === "object" && devTools));
    }
    var storeEnhancers = [middlewareEnhancer];
    if (Array.isArray(enhancers)) {
        storeEnhancers = __spreadArray([middlewareEnhancer], enhancers);
    }
    else if (typeof enhancers === "function") {
        storeEnhancers = enhancers(storeEnhancers);
    }
    var composedEnhancer = finalCompose.apply(void 0, storeEnhancers);
    return (0,redux/* createStore */.MT)(rootReducer, preloadedState, composedEnhancer);
}
// src/createAction.ts
function createAction(type, prepareAction) {
    function actionCreator() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (prepareAction) {
            var prepared = prepareAction.apply(void 0, args);
            if (!prepared) {
                throw new Error("prepareAction did not return an object");
            }
            return __spreadValues(__spreadValues({
                type: type,
                payload: prepared.payload
            }, "meta" in prepared && { meta: prepared.meta }), "error" in prepared && { error: prepared.error });
        }
        return { type: type, payload: args[0] };
    }
    actionCreator.toString = function () { return "" + type; };
    actionCreator.type = type;
    actionCreator.match = function (action) { return action.type === type; };
    return actionCreator;
}
function isFSA(action) {
    return isPlainObject(action) && typeof action.type === "string" && Object.keys(action).every(isValidKey);
}
function isValidKey(key) {
    return ["type", "payload", "error", "meta"].indexOf(key) > -1;
}
function getType(actionCreator) {
    return "" + actionCreator;
}
// src/createReducer.ts

// src/mapBuilders.ts
function executeReducerBuilderCallback(builderCallback) {
    var actionsMap = {};
    var actionMatchers = [];
    var defaultCaseReducer;
    var builder = {
        addCase: function (typeOrActionCreator, reducer) {
            if (false) {}
            var type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (type in actionsMap) {
                throw new Error("addCase cannot be called with two reducers for the same action type");
            }
            actionsMap[type] = reducer;
            return builder;
        },
        addMatcher: function (matcher, reducer) {
            if (false) {}
            actionMatchers.push({ matcher: matcher, reducer: reducer });
            return builder;
        },
        addDefaultCase: function (reducer) {
            if (false) {}
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [actionsMap, actionMatchers, defaultCaseReducer];
}
// src/createReducer.ts
function isStateFunction(x) {
    return typeof x === "function";
}
function createReducer(initialState, mapOrBuilderCallback, actionMatchers, defaultCaseReducer) {
    if (actionMatchers === void 0) { actionMatchers = []; }
    var _c = typeof mapOrBuilderCallback === "function" ? executeReducerBuilderCallback(mapOrBuilderCallback) : [mapOrBuilderCallback, actionMatchers, defaultCaseReducer], actionsMap = _c[0], finalActionMatchers = _c[1], finalDefaultCaseReducer = _c[2];
    var getInitialState;
    if (isStateFunction(initialState)) {
        getInitialState = function () { return immer_esm(initialState(), function () {
        }); };
    }
    else {
        var frozenInitialState_1 = immer_esm(initialState, function () {
        });
        getInitialState = function () { return frozenInitialState_1; };
    }
    function reducer(state, action) {
        if (state === void 0) { state = getInitialState(); }
        var caseReducers = __spreadArray([
            actionsMap[action.type]
        ], finalActionMatchers.filter(function (_c) {
            var matcher = _c.matcher;
            return matcher(action);
        }).map(function (_c) {
            var reducer2 = _c.reducer;
            return reducer2;
        }));
        if (caseReducers.filter(function (cr) { return !!cr; }).length === 0) {
            caseReducers = [finalDefaultCaseReducer];
        }
        return caseReducers.reduce(function (previousState, caseReducer) {
            if (caseReducer) {
                if (r(previousState)) {
                    var draft = previousState;
                    var result = caseReducer(draft, action);
                    if (typeof result === "undefined") {
                        return previousState;
                    }
                    return result;
                }
                else if (!t(previousState)) {
                    var result = caseReducer(previousState, action);
                    if (typeof result === "undefined") {
                        if (previousState === null) {
                            return previousState;
                        }
                        throw Error("A case reducer on a non-draftable value must not return undefined");
                    }
                    return result;
                }
                else {
                    return immer_esm(previousState, function (draft) {
                        return caseReducer(draft, action);
                    });
                }
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/createSlice.ts
function getType2(slice, actionKey) {
    return slice + "/" + actionKey;
}
function createSlice(options) {
    var name = options.name;
    if (!name) {
        throw new Error("`name` is a required option for createSlice");
    }
    var initialState = typeof options.initialState == "function" ? options.initialState : immer_esm(options.initialState, function () {
    });
    var reducers = options.reducers || {};
    var reducerNames = Object.keys(reducers);
    var sliceCaseReducersByName = {};
    var sliceCaseReducersByType = {};
    var actionCreators = {};
    reducerNames.forEach(function (reducerName) {
        var maybeReducerWithPrepare = reducers[reducerName];
        var type = getType2(name, reducerName);
        var caseReducer;
        var prepareCallback;
        if ("reducer" in maybeReducerWithPrepare) {
            caseReducer = maybeReducerWithPrepare.reducer;
            prepareCallback = maybeReducerWithPrepare.prepare;
        }
        else {
            caseReducer = maybeReducerWithPrepare;
        }
        sliceCaseReducersByName[reducerName] = caseReducer;
        sliceCaseReducersByType[type] = caseReducer;
        actionCreators[reducerName] = prepareCallback ? createAction(type, prepareCallback) : createAction(type);
    });
    function buildReducer() {
        var _c = typeof options.extraReducers === "function" ? executeReducerBuilderCallback(options.extraReducers) : [options.extraReducers], _d = _c[0], extraReducers = _d === void 0 ? {} : _d, _e = _c[1], actionMatchers = _e === void 0 ? [] : _e, _f = _c[2], defaultCaseReducer = _f === void 0 ? void 0 : _f;
        var finalCaseReducers = __spreadValues(__spreadValues({}, extraReducers), sliceCaseReducersByType);
        return createReducer(initialState, finalCaseReducers, actionMatchers, defaultCaseReducer);
    }
    var _reducer;
    return {
        name: name,
        reducer: function (state, action) {
            if (!_reducer)
                _reducer = buildReducer();
            return _reducer(state, action);
        },
        actions: actionCreators,
        caseReducers: sliceCaseReducersByName,
        getInitialState: function () {
            if (!_reducer)
                _reducer = buildReducer();
            return _reducer.getInitialState();
        }
    };
}
// src/entities/entity_state.ts
function getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function createInitialStateFactory() {
    function getInitialState(additionalState) {
        if (additionalState === void 0) { additionalState = {}; }
        return Object.assign(getInitialEntityState(), additionalState);
    }
    return { getInitialState: getInitialState };
}
// src/entities/state_selectors.ts
function createSelectorsFactory() {
    function getSelectors(selectState) {
        var selectIds = function (state) { return state.ids; };
        var selectEntities = function (state) { return state.entities; };
        var selectAll = createDraftSafeSelector(selectIds, selectEntities, function (ids, entities) { return ids.map(function (id) { return entities[id]; }); });
        var selectId = function (_, id) { return id; };
        var selectById = function (entities, id) { return entities[id]; };
        var selectTotal = createDraftSafeSelector(selectIds, function (ids) { return ids.length; });
        if (!selectState) {
            return {
                selectIds: selectIds,
                selectEntities: selectEntities,
                selectAll: selectAll,
                selectTotal: selectTotal,
                selectById: createDraftSafeSelector(selectEntities, selectId, selectById)
            };
        }
        var selectGlobalizedEntities = createDraftSafeSelector(selectState, selectEntities);
        return {
            selectIds: createDraftSafeSelector(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: createDraftSafeSelector(selectState, selectAll),
            selectTotal: createDraftSafeSelector(selectState, selectTotal),
            selectById: createDraftSafeSelector(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return { getSelectors: getSelectors };
}
// src/entities/state_adapter.ts

function createSingleArgumentStateOperator(mutator) {
    var operator = createStateOperator(function (_, state) { return mutator(state); });
    return function operation(state) {
        return operator(state, void 0);
    };
}
function createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return isFSA(arg2);
        }
        var runMutator = function (draft) {
            if (isPayloadActionArgument(arg)) {
                mutator(arg.payload, draft);
            }
            else {
                mutator(arg, draft);
            }
        };
        if (isDraft3(state)) {
            runMutator(state);
            return state;
        }
        else {
            return createNextState2(state, runMutator);
        }
    };
}
// src/entities/utils.ts
function selectIdValue(entity, selectId) {
    var key = selectId(entity);
    if (false) {}
    return key;
}
function ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) {
        entities = Object.values(entities);
    }
    return entities;
}
function splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = ensureEntitiesArray(newEntities);
    var added = [];
    var updated = [];
    for (var _i = 0, newEntities_1 = newEntities; _i < newEntities_1.length; _i++) {
        var entity = newEntities_1[_i];
        var id = selectIdValue(entity, selectId);
        if (id in state.entities) {
            updated.push({ id: id, changes: entity });
        }
        else {
            added.push(entity);
        }
    }
    return [added, updated];
}
// src/entities/unsorted_state_adapter.ts
function createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        var key = selectIdValue(entity, selectId);
        if (key in state.entities) {
            return;
        }
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = ensureEntitiesArray(newEntities);
        for (var _i = 0, newEntities_2 = newEntities; _i < newEntities_2.length; _i++) {
            var entity = newEntities_2[_i];
            addOneMutably(entity, state);
        }
    }
    function setOneMutably(entity, state) {
        var key = selectIdValue(entity, selectId);
        if (!(key in state.entities)) {
            state.ids.push(key);
        }
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = ensureEntitiesArray(newEntities);
        for (var _i = 0, newEntities_3 = newEntities; _i < newEntities_3.length; _i++) {
            var entity = newEntities_3[_i];
            setOneMutably(entity, state);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([key], state);
    }
    function removeManyMutably(keys, state) {
        var didMutate = false;
        keys.forEach(function (key) {
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) {
            state.ids = state.ids.filter(function (id) { return id in state.entities; });
        }
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        var original2 = state.entities[update.id];
        var updated = Object.assign({}, original2, update.changes);
        var newKey = selectIdValue(updated, selectId);
        var hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([update], state);
    }
    function updateManyMutably(updates, state) {
        var newKeys = {};
        var updatesPerEntity = {};
        updates.forEach(function (update) {
            if (update.id in state.entities) {
                updatesPerEntity[update.id] = {
                    id: update.id,
                    changes: __spreadValues(__spreadValues({}, updatesPerEntity[update.id] ? updatesPerEntity[update.id].changes : null), update.changes)
                };
            }
        });
        updates = Object.values(updatesPerEntity);
        var didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            var didMutateIds = updates.filter(function (update) { return takeNewKey(newKeys, update, state); }).length > 0;
            if (didMutateIds) {
                state.ids = state.ids.map(function (id) { return newKeys[id] || id; });
            }
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([entity], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _c = splitAddedUpdatedEntities(newEntities, selectId, state), added = _c[0], updated = _c[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    return {
        removeAll: createSingleArgumentStateOperator(removeAllMutably),
        addOne: createStateOperator(addOneMutably),
        addMany: createStateOperator(addManyMutably),
        setOne: createStateOperator(setOneMutably),
        setMany: createStateOperator(setManyMutably),
        setAll: createStateOperator(setAllMutably),
        updateOne: createStateOperator(updateOneMutably),
        updateMany: createStateOperator(updateManyMutably),
        upsertOne: createStateOperator(upsertOneMutably),
        upsertMany: createStateOperator(upsertManyMutably),
        removeOne: createStateOperator(removeOneMutably),
        removeMany: createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function createSortedStateAdapter(selectId, sort) {
    var _c = createUnsortedStateAdapter(selectId), removeOne = _c.removeOne, removeMany = _c.removeMany, removeAll = _c.removeAll;
    function addOneMutably(entity, state) {
        return addManyMutably([entity], state);
    }
    function addManyMutably(newEntities, state) {
        newEntities = ensureEntitiesArray(newEntities);
        var models = newEntities.filter(function (model) { return !(selectIdValue(model, selectId) in state.entities); });
        if (models.length !== 0) {
            merge(models, state);
        }
    }
    function setOneMutably(entity, state) {
        return setManyMutably([entity], state);
    }
    function setManyMutably(newEntities, state) {
        newEntities = ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) {
            merge(newEntities, state);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([update], state);
    }
    function takeUpdatedModel(models, update, state) {
        if (!(update.id in state.entities)) {
            return false;
        }
        var original2 = state.entities[update.id];
        var updated = Object.assign({}, original2, update.changes);
        var newKey = selectIdValue(updated, selectId);
        delete state.entities[update.id];
        models.push(updated);
        return newKey !== update.id;
    }
    function updateManyMutably(updates, state) {
        var models = [];
        updates.forEach(function (update) { return takeUpdatedModel(models, update, state); });
        if (models.length !== 0) {
            merge(models, state);
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([entity], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _c = splitAddedUpdatedEntities(newEntities, selectId, state), added = _c[0], updated = _c[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) {
            return false;
        }
        for (var i = 0; i < a.length && i < b.length; i++) {
            if (a[i] === b[i]) {
                continue;
            }
            return false;
        }
        return true;
    }
    function merge(models, state) {
        models.forEach(function (model) {
            state.entities[selectId(model)] = model;
        });
        var allEntities = Object.values(state.entities);
        allEntities.sort(sort);
        var newSortedIds = allEntities.map(selectId);
        var ids = state.ids;
        if (!areArraysEqual(ids, newSortedIds)) {
            state.ids = newSortedIds;
        }
    }
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: createStateOperator(addOneMutably),
        updateOne: createStateOperator(updateOneMutably),
        upsertOne: createStateOperator(upsertOneMutably),
        setOne: createStateOperator(setOneMutably),
        setMany: createStateOperator(setManyMutably),
        setAll: createStateOperator(setAllMutably),
        addMany: createStateOperator(addManyMutably),
        updateMany: createStateOperator(updateManyMutably),
        upsertMany: createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function createEntityAdapter(options) {
    if (options === void 0) { options = {}; }
    var _c = __spreadValues({
        sortComparer: false,
        selectId: function (instance) { return instance.id; }
    }, options), selectId = _c.selectId, sortComparer = _c.sortComparer;
    var stateFactory = createInitialStateFactory();
    var selectorsFactory = createSelectorsFactory();
    var stateAdapter = sortComparer ? createSortedStateAdapter(selectId, sortComparer) : createUnsortedStateAdapter(selectId);
    return __spreadValues(__spreadValues(__spreadValues({
        selectId: selectId,
        sortComparer: sortComparer
    }, stateFactory), selectorsFactory), stateAdapter);
}
// src/nanoid.ts
var urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var nanoid = function (size) {
    if (size === void 0) { size = 21; }
    var id = "";
    var i = size;
    while (i--) {
        id += urlAlphabet[Math.random() * 64 | 0];
    }
    return id;
};
// src/createAsyncThunk.ts
var commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var RejectWithValue = /** @class */ (function () {
    function RejectWithValue(payload, meta) {
        this.payload = payload;
        this.meta = meta;
    }
    return RejectWithValue;
}());
var FulfillWithMeta = /** @class */ (function () {
    function FulfillWithMeta(payload, meta) {
        this.payload = payload;
        this.meta = meta;
    }
    return FulfillWithMeta;
}());
var miniSerializeError = function (value) {
    if (typeof value === "object" && value !== null) {
        var simpleError = {};
        for (var _i = 0, commonProperties_1 = commonProperties; _i < commonProperties_1.length; _i++) {
            var property = commonProperties_1[_i];
            if (typeof value[property] === "string") {
                simpleError[property] = value[property];
            }
        }
        return simpleError;
    }
    return { message: String(value) };
};
function createAsyncThunk(typePrefix, payloadCreator, options) {
    var fulfilled = createAction(typePrefix + "/fulfilled", function (payload, requestId, arg, meta) { return ({
        payload: payload,
        meta: __spreadProps(__spreadValues({}, meta || {}), {
            arg: arg,
            requestId: requestId,
            requestStatus: "fulfilled"
        })
    }); });
    var pending = createAction(typePrefix + "/pending", function (requestId, arg, meta) { return ({
        payload: void 0,
        meta: __spreadProps(__spreadValues({}, meta || {}), {
            arg: arg,
            requestId: requestId,
            requestStatus: "pending"
        })
    }); });
    var rejected = createAction(typePrefix + "/rejected", function (error, requestId, arg, payload, meta) { return ({
        payload: payload,
        error: (options && options.serializeError || miniSerializeError)(error || "Rejected"),
        meta: __spreadProps(__spreadValues({}, meta || {}), {
            arg: arg,
            requestId: requestId,
            rejectedWithValue: !!payload,
            requestStatus: "rejected",
            aborted: (error == null ? void 0 : error.name) === "AbortError",
            condition: (error == null ? void 0 : error.name) === "ConditionError"
        })
    }); });
    var displayedWarning = false;
    var AC = typeof AbortController !== "undefined" ? AbortController : /** @class */ (function () {
        function class_1() {
            this.signal = {
                aborted: false,
                addEventListener: function () {
                },
                dispatchEvent: function () {
                    return false;
                },
                onabort: function () {
                },
                removeEventListener: function () {
                }
            };
        }
        class_1.prototype.abort = function () {
            if (false) {}
        };
        return class_1;
    }());
    function actionCreator(arg) {
        return function (dispatch, getState, extra) {
            var requestId = (options == null ? void 0 : options.idGenerator) ? options.idGenerator(arg) : nanoid();
            var abortController = new AC();
            var abortReason;
            var abortedPromise = new Promise(function (_, reject) { return abortController.signal.addEventListener("abort", function () { return reject({ name: "AbortError", message: abortReason || "Aborted" }); }); });
            var started = false;
            function abort(reason) {
                if (started) {
                    abortReason = reason;
                    abortController.abort();
                }
            }
            var promise = function () {
                return __async(this, null, function () {
                    var _a, _b, finalAction, conditionResult, err_1, skipDispatch;
                    return __generator(this, function (_c) {
                        switch (_c.label) {
                            case 0:
                                _c.trys.push([0, 4, , 5]);
                                conditionResult = (_a = options == null ? void 0 : options.condition) == null ? void 0 : _a.call(options, arg, { getState: getState, extra: extra });
                                if (!isThenable(conditionResult)) return [3 /*break*/, 2];
                                return [4 /*yield*/, conditionResult];
                            case 1:
                                conditionResult = _c.sent();
                                _c.label = 2;
                            case 2:
                                if (conditionResult === false) {
                                    throw {
                                        name: "ConditionError",
                                        message: "Aborted due to condition callback returning false."
                                    };
                                }
                                started = true;
                                dispatch(pending(requestId, arg, (_b = options == null ? void 0 : options.getPendingMeta) == null ? void 0 : _b.call(options, { requestId: requestId, arg: arg }, { getState: getState, extra: extra })));
                                return [4 /*yield*/, Promise.race([
                                        abortedPromise,
                                        Promise.resolve(payloadCreator(arg, {
                                            dispatch: dispatch,
                                            getState: getState,
                                            extra: extra,
                                            requestId: requestId,
                                            signal: abortController.signal,
                                            rejectWithValue: function (value, meta) {
                                                return new RejectWithValue(value, meta);
                                            },
                                            fulfillWithValue: function (value, meta) {
                                                return new FulfillWithMeta(value, meta);
                                            }
                                        })).then(function (result) {
                                            if (result instanceof RejectWithValue) {
                                                throw result;
                                            }
                                            if (result instanceof FulfillWithMeta) {
                                                return fulfilled(result.payload, requestId, arg, result.meta);
                                            }
                                            return fulfilled(result, requestId, arg);
                                        })
                                    ])];
                            case 3:
                                finalAction = _c.sent();
                                return [3 /*break*/, 5];
                            case 4:
                                err_1 = _c.sent();
                                finalAction = err_1 instanceof RejectWithValue ? rejected(null, requestId, arg, err_1.payload, err_1.meta) : rejected(err_1, requestId, arg);
                                return [3 /*break*/, 5];
                            case 5:
                                skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                                if (!skipDispatch) {
                                    dispatch(finalAction);
                                }
                                return [2 /*return*/, finalAction];
                        }
                    });
                });
            }();
            return Object.assign(promise, {
                abort: abort,
                requestId: requestId,
                arg: arg,
                unwrap: function () {
                    return promise.then(unwrapResult);
                }
            });
        };
    }
    return Object.assign(actionCreator, {
        pending: pending,
        rejected: rejected,
        fulfilled: fulfilled,
        typePrefix: typePrefix
    });
}
function unwrapResult(action) {
    if (action.meta && action.meta.rejectedWithValue) {
        throw action.payload;
    }
    if (action.error) {
        throw action.error;
    }
    return action.payload;
}
function isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
// src/tsHelpers.ts
var hasMatchFunction = function (v) {
    return v && typeof v.match === "function";
};
// src/matchers.ts
var matches = function (matcher, action) {
    if (hasMatchFunction(matcher)) {
        return matcher.match(action);
    }
    else {
        return matcher(action);
    }
};
function isAnyOf() {
    var matchers = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        matchers[_i] = arguments[_i];
    }
    return function (action) {
        return matchers.some(function (matcher) { return matches(matcher, action); });
    };
}
function isAllOf() {
    var matchers = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        matchers[_i] = arguments[_i];
    }
    return function (action) {
        return matchers.every(function (matcher) { return matches(matcher, action); });
    };
}
function hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta)
        return false;
    var hasValidRequestId = typeof action.meta.requestId === "string";
    var hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function isPending() {
    var asyncThunks = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        asyncThunks[_i] = arguments[_i];
    }
    if (asyncThunks.length === 0) {
        return function (action) { return hasExpectedRequestMetadata(action, ["pending"]); };
    }
    if (!isAsyncThunkArray(asyncThunks)) {
        return isPending()(asyncThunks[0]);
    }
    return function (action) {
        var matchers = asyncThunks.map(function (asyncThunk) { return asyncThunk.pending; });
        var combinedMatcher = isAnyOf.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function isRejected() {
    var asyncThunks = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        asyncThunks[_i] = arguments[_i];
    }
    if (asyncThunks.length === 0) {
        return function (action) { return hasExpectedRequestMetadata(action, ["rejected"]); };
    }
    if (!isAsyncThunkArray(asyncThunks)) {
        return isRejected()(asyncThunks[0]);
    }
    return function (action) {
        var matchers = asyncThunks.map(function (asyncThunk) { return asyncThunk.rejected; });
        var combinedMatcher = isAnyOf.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function isRejectedWithValue() {
    var asyncThunks = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        asyncThunks[_i] = arguments[_i];
    }
    var hasFlag = function (action) {
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) {
        return function (action) {
            var combinedMatcher = isAllOf(isRejected.apply(void 0, asyncThunks), hasFlag);
            return combinedMatcher(action);
        };
    }
    if (!isAsyncThunkArray(asyncThunks)) {
        return isRejectedWithValue()(asyncThunks[0]);
    }
    return function (action) {
        var combinedMatcher = isAllOf(isRejected.apply(void 0, asyncThunks), hasFlag);
        return combinedMatcher(action);
    };
}
function isFulfilled() {
    var asyncThunks = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        asyncThunks[_i] = arguments[_i];
    }
    if (asyncThunks.length === 0) {
        return function (action) { return hasExpectedRequestMetadata(action, ["fulfilled"]); };
    }
    if (!isAsyncThunkArray(asyncThunks)) {
        return isFulfilled()(asyncThunks[0]);
    }
    return function (action) {
        var matchers = asyncThunks.map(function (asyncThunk) { return asyncThunk.fulfilled; });
        var combinedMatcher = isAnyOf.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function isAsyncThunkAction() {
    var asyncThunks = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        asyncThunks[_i] = arguments[_i];
    }
    if (asyncThunks.length === 0) {
        return function (action) { return hasExpectedRequestMetadata(action, ["pending", "fulfilled", "rejected"]); };
    }
    if (!isAsyncThunkArray(asyncThunks)) {
        return isAsyncThunkAction()(asyncThunks[0]);
    }
    return function (action) {
        var matchers = [];
        for (var _i = 0, asyncThunks_1 = asyncThunks; _i < asyncThunks_1.length; _i++) {
            var asyncThunk = asyncThunks_1[_i];
            matchers.push(asyncThunk.pending, asyncThunk.rejected, asyncThunk.fulfilled);
        }
        var combinedMatcher = isAnyOf.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
// src/listenerMiddleware/utils.ts
var assertFunction = function (func, expected) {
    if (typeof func !== "function") {
        throw new TypeError(expected + " is not a function");
    }
};
var noop = function () {
};
var catchRejection = function (promise, onError) {
    if (onError === void 0) { onError = noop; }
    promise.catch(onError);
    return promise;
};
var addAbortSignalListener = function (abortSignal, callback) {
    abortSignal.addEventListener("abort", callback, { once: true });
};
var abortControllerWithReason = function (abortController, reason) {
    var signal = abortController.signal;
    if (signal.aborted) {
        return;
    }
    if (!("reason" in signal)) {
        Object.defineProperty(signal, "reason", {
            enumerable: true,
            value: reason,
            configurable: true,
            writable: true
        });
    }
    ;
    abortController.abort(reason);
};
// src/listenerMiddleware/exceptions.ts
var task = "task";
var listener = "listener";
var completed = "completed";
var cancelled = "cancelled";
var taskCancelled = "task-" + cancelled;
var taskCompleted = "task-" + completed;
var listenerCancelled = listener + "-" + cancelled;
var listenerCompleted = listener + "-" + completed;
var TaskAbortError = /** @class */ (function () {
    function TaskAbortError(code) {
        this.code = code;
        this.name = "TaskAbortError";
        this.message = task + " " + cancelled + " (reason: " + code + ")";
    }
    return TaskAbortError;
}());
// src/listenerMiddleware/task.ts
var validateActive = function (signal) {
    if (signal.aborted) {
        throw new TaskAbortError(signal.reason);
    }
};
var promisifyAbortSignal = function (signal) {
    return catchRejection(new Promise(function (_, reject) {
        var notifyRejection = function () { return reject(new TaskAbortError(signal.reason)); };
        if (signal.aborted) {
            notifyRejection();
        }
        else {
            addAbortSignalListener(signal, notifyRejection);
        }
    }));
};
var runTask = function (task2, cleanUp) { return __async(void 0, null, function () {
    var value, error_1;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 3, 4, 5]);
                return [4 /*yield*/, Promise.resolve()];
            case 1:
                _c.sent();
                return [4 /*yield*/, task2()];
            case 2:
                value = _c.sent();
                return [2 /*return*/, {
                        status: "ok",
                        value: value
                    }];
            case 3:
                error_1 = _c.sent();
                return [2 /*return*/, {
                        status: error_1 instanceof TaskAbortError ? "cancelled" : "rejected",
                        error: error_1
                    }];
            case 4:
                cleanUp == null ? void 0 : cleanUp();
                return [7 /*endfinally*/];
            case 5: return [2 /*return*/];
        }
    });
}); };
var createPause = function (signal) {
    return function (promise) {
        return catchRejection(Promise.race([promisifyAbortSignal(signal), promise]).then(function (output) {
            validateActive(signal);
            return output;
        }));
    };
};
var createDelay = function (signal) {
    var pause = createPause(signal);
    return function (timeoutMs) {
        return pause(new Promise(function (resolve) { return setTimeout(resolve, timeoutMs); }));
    };
};
// src/listenerMiddleware/index.ts
var redux_toolkit_esm_assign = Object.assign;
var INTERNAL_NIL_TOKEN = {};
var alm = "listenerMiddleware";
var createFork = function (parentAbortSignal) {
    var linkControllers = function (controller) { return addAbortSignalListener(parentAbortSignal, function () { return abortControllerWithReason(controller, parentAbortSignal.reason); }); };
    return function (taskExecutor) {
        assertFunction(taskExecutor, "taskExecutor");
        var childAbortController = new AbortController();
        linkControllers(childAbortController);
        var result = runTask(function () { return __async(void 0, null, function () {
            var result2;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        validateActive(parentAbortSignal);
                        validateActive(childAbortController.signal);
                        return [4 /*yield*/, taskExecutor({
                                pause: createPause(childAbortController.signal),
                                delay: createDelay(childAbortController.signal),
                                signal: childAbortController.signal
                            })];
                    case 1:
                        result2 = _c.sent();
                        validateActive(childAbortController.signal);
                        return [2 /*return*/, result2];
                }
            });
        }); }, function () { return abortControllerWithReason(childAbortController, taskCompleted); });
        return {
            result: createPause(parentAbortSignal)(result),
            cancel: function () {
                abortControllerWithReason(childAbortController, taskCancelled);
            }
        };
    };
};
var createTakePattern = function (startListening, signal) {
    var take = function (predicate, timeout) { return __async(void 0, null, function () {
        var unsubscribe, tuplePromise, promises, output;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    validateActive(signal);
                    unsubscribe = function () {
                    };
                    tuplePromise = new Promise(function (resolve) {
                        unsubscribe = startListening({
                            predicate: predicate,
                            effect: function (action, listenerApi) {
                                listenerApi.unsubscribe();
                                resolve([
                                    action,
                                    listenerApi.getState(),
                                    listenerApi.getOriginalState()
                                ]);
                            }
                        });
                    });
                    promises = [
                        promisifyAbortSignal(signal),
                        tuplePromise
                    ];
                    if (timeout != null) {
                        promises.push(new Promise(function (resolve) { return setTimeout(resolve, timeout, null); }));
                    }
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, , 3, 4]);
                    return [4 /*yield*/, Promise.race(promises)];
                case 2:
                    output = _c.sent();
                    validateActive(signal);
                    return [2 /*return*/, output];
                case 3:
                    unsubscribe();
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return function (predicate, timeout) { return catchRejection(take(predicate, timeout)); };
};
var getListenerEntryPropsFrom = function (options) {
    var type = options.type, actionCreator = options.actionCreator, matcher = options.matcher, predicate = options.predicate, effect = options.effect;
    if (type) {
        predicate = createAction(type).match;
    }
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    }
    else if (matcher) {
        predicate = matcher;
    }
    else if (predicate) {
    }
    else {
        throw new Error("Creating or removing a listener requires one of the known fields for matching an action");
    }
    assertFunction(effect, "options.listener");
    return { predicate: predicate, type: type, effect: effect };
};
var createListenerEntry = function (options) {
    var _c = getListenerEntryPropsFrom(options), type = _c.type, predicate = _c.predicate, effect = _c.effect;
    var id = nanoid();
    var entry = {
        id: id,
        effect: effect,
        type: type,
        predicate: predicate,
        pending: new Set(),
        unsubscribe: function () {
            throw new Error("Unsubscribe not initialized");
        }
    };
    return entry;
};
var createClearListenerMiddleware = function (listenerMap) {
    return function () {
        listenerMap.forEach(cancelActiveListeners);
        listenerMap.clear();
    };
};
var safelyNotifyError = function (errorHandler, errorToNotify, errorInfo) {
    try {
        errorHandler(errorToNotify, errorInfo);
    }
    catch (errorHandlerError) {
        setTimeout(function () {
            throw errorHandlerError;
        }, 0);
    }
};
var addListener = createAction(alm + "/add");
var clearAllListeners = createAction(alm + "/removeAll");
var removeListener = createAction(alm + "/remove");
var defaultErrorHandler = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    console.error.apply(console, __spreadArray([alm + "/error"], args));
};
var cancelActiveListeners = function (entry) {
    entry.pending.forEach(function (controller) {
        abortControllerWithReason(controller, listenerCancelled);
    });
};
function createListenerMiddleware(middlewareOptions) {
    var _this = this;
    if (middlewareOptions === void 0) { middlewareOptions = {}; }
    var listenerMap = new Map();
    var extra = middlewareOptions.extra, _c = middlewareOptions.onError, onError = _c === void 0 ? defaultErrorHandler : _c;
    assertFunction(onError, "onError");
    var insertEntry = function (entry) {
        entry.unsubscribe = function () { return listenerMap.delete(entry.id); };
        listenerMap.set(entry.id, entry);
        return function (cancelOptions) {
            entry.unsubscribe();
            if (cancelOptions == null ? void 0 : cancelOptions.cancelActive) {
                cancelActiveListeners(entry);
            }
        };
    };
    var findListenerEntry = function (comparator) {
        for (var _i = 0, _c = Array.from(listenerMap.values()); _i < _c.length; _i++) {
            var entry = _c[_i];
            if (comparator(entry)) {
                return entry;
            }
        }
        return void 0;
    };
    var startListening = function (options) {
        var entry = findListenerEntry(function (existingEntry) { return existingEntry.effect === options.effect; });
        if (!entry) {
            entry = createListenerEntry(options);
        }
        return insertEntry(entry);
    };
    var stopListening = function (options) {
        var _c = getListenerEntryPropsFrom(options), type = _c.type, effect = _c.effect, predicate = _c.predicate;
        var entry = findListenerEntry(function (entry2) {
            var matchPredicateOrType = typeof type === "string" ? entry2.type === type : entry2.predicate === predicate;
            return matchPredicateOrType && entry2.effect === effect;
        });
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) {
                cancelActiveListeners(entry);
            }
        }
        return !!entry;
    };
    var notifyListener = function (entry, action, api, getOriginalState) { return __async(_this, null, function () {
        var internalTaskController, take, listenerError_1;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    internalTaskController = new AbortController();
                    take = createTakePattern(startListening, internalTaskController.signal);
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, 4, 5]);
                    entry.pending.add(internalTaskController);
                    return [4 /*yield*/, Promise.resolve(entry.effect(action, redux_toolkit_esm_assign({}, api, {
                            getOriginalState: getOriginalState,
                            condition: function (predicate, timeout) { return take(predicate, timeout).then(Boolean); },
                            take: take,
                            delay: createDelay(internalTaskController.signal),
                            pause: createPause(internalTaskController.signal),
                            extra: extra,
                            signal: internalTaskController.signal,
                            fork: createFork(internalTaskController.signal),
                            unsubscribe: entry.unsubscribe,
                            subscribe: function () {
                                listenerMap.set(entry.id, entry);
                            },
                            cancelActiveListeners: function () {
                                entry.pending.forEach(function (controller, _, set) {
                                    if (controller !== internalTaskController) {
                                        abortControllerWithReason(controller, listenerCancelled);
                                        set.delete(controller);
                                    }
                                });
                            }
                        })))];
                case 2:
                    _c.sent();
                    return [3 /*break*/, 5];
                case 3:
                    listenerError_1 = _c.sent();
                    if (!(listenerError_1 instanceof TaskAbortError)) {
                        safelyNotifyError(onError, listenerError_1, {
                            raisedBy: "effect"
                        });
                    }
                    return [3 /*break*/, 5];
                case 4:
                    abortControllerWithReason(internalTaskController, listenerCompleted);
                    entry.pending.delete(internalTaskController);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var clearListenerMiddleware = createClearListenerMiddleware(listenerMap);
    var middleware = function (api) { return function (next) { return function (action) {
        if (addListener.match(action)) {
            return startListening(action.payload);
        }
        if (clearAllListeners.match(action)) {
            clearListenerMiddleware();
            return;
        }
        if (removeListener.match(action)) {
            return stopListening(action.payload);
        }
        var originalState = api.getState();
        var getOriginalState = function () {
            if (originalState === INTERNAL_NIL_TOKEN) {
                throw new Error(alm + ": getOriginalState can only be called synchronously");
            }
            return originalState;
        };
        var result;
        try {
            result = next(action);
            if (listenerMap.size > 0) {
                var currentState = api.getState();
                var listenerEntries = Array.from(listenerMap.values());
                for (var _i = 0, listenerEntries_1 = listenerEntries; _i < listenerEntries_1.length; _i++) {
                    var entry = listenerEntries_1[_i];
                    var runListener = false;
                    try {
                        runListener = entry.predicate(action, currentState, originalState);
                    }
                    catch (predicateError) {
                        runListener = false;
                        safelyNotifyError(onError, predicateError, {
                            raisedBy: "predicate"
                        });
                    }
                    if (!runListener) {
                        continue;
                    }
                    notifyListener(entry, action, api, getOriginalState);
                }
            }
        }
        finally {
            originalState = INTERNAL_NIL_TOKEN;
        }
        return result;
    }; }; };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
}
// src/index.ts
F();

//# sourceMappingURL=redux-toolkit.esm.js.map

/***/ }),

/***/ 58363:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = true;

exports.Z = function (file, acceptedFiles) {
  if (file && acceptedFiles) {
    var acceptedFilesArray = Array.isArray(acceptedFiles) ? acceptedFiles : acceptedFiles.split(',');

    if (acceptedFilesArray.length === 0) {
      return true;
    }

    var fileName = file.name || '';
    var mimeType = (file.type || '').toLowerCase();
    var baseMimeType = mimeType.replace(/\/.*$/, '');
    return acceptedFilesArray.some(function (type) {
      var validType = type.trim().toLowerCase();

      if (validType.charAt(0) === '.') {
        return fileName.toLowerCase().endsWith(validType);
      } else if (validType.endsWith('/*')) {
        // This is something like a image/* mime type
        return baseMimeType === validType.replace(/\/.*$/, '');
      }

      return mimeType === validType;
    });
  }

  return true;
};

/***/ }),

/***/ 9669:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(51609);

/***/ }),

/***/ 55448:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);
var settle = __webpack_require__(36026);
var cookies = __webpack_require__(4372);
var buildURL = __webpack_require__(15327);
var buildFullPath = __webpack_require__(94097);
var parseHeaders = __webpack_require__(84109);
var isURLSameOrigin = __webpack_require__(67985);
var transitionalDefaults = __webpack_require__(77874);
var AxiosError = __webpack_require__(82648);
var CanceledError = __webpack_require__(60644);
var parseProtocol = __webpack_require__(90205);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;
    var responseType = config.responseType;
    var onCanceled;
    function done() {
      if (config.cancelToken) {
        config.cancelToken.unsubscribe(onCanceled);
      }

      if (config.signal) {
        config.signal.removeEventListener('abort', onCanceled);
      }
    }

    if (utils.isFormData(requestData) && utils.isStandardBrowserEnv()) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);

    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !responseType || responseType === 'text' ||  responseType === 'json' ?
        request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(function _resolve(value) {
        resolve(value);
        done();
      }, function _reject(err) {
        reject(err);
        done();
      }, response);

      // Clean up request
      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(new AxiosError('Request aborted', AxiosError.ECONNABORTED, config, request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(new AxiosError('Network Error', AxiosError.ERR_NETWORK, config, request, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = config.timeout ? 'timeout of ' + config.timeout + 'ms exceeded' : 'timeout exceeded';
      var transitional = config.transitional || transitionalDefaults;
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(new AxiosError(
        timeoutErrorMessage,
        transitional.clarifyTimeoutError ? AxiosError.ETIMEDOUT : AxiosError.ECONNABORTED,
        config,
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = config.responseType;
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken || config.signal) {
      // Handle cancellation
      // eslint-disable-next-line func-names
      onCanceled = function(cancel) {
        if (!request) {
          return;
        }
        reject(!cancel || (cancel && cancel.type) ? new CanceledError() : cancel);
        request.abort();
        request = null;
      };

      config.cancelToken && config.cancelToken.subscribe(onCanceled);
      if (config.signal) {
        config.signal.aborted ? onCanceled() : config.signal.addEventListener('abort', onCanceled);
      }
    }

    if (!requestData) {
      requestData = null;
    }

    var protocol = parseProtocol(fullPath);

    if (protocol && [ 'http', 'https', 'file' ].indexOf(protocol) === -1) {
      reject(new AxiosError('Unsupported protocol ' + protocol + ':', AxiosError.ERR_BAD_REQUEST, config));
      return;
    }


    // Send the request
    request.send(requestData);
  });
};


/***/ }),

/***/ 51609:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);
var bind = __webpack_require__(91849);
var Axios = __webpack_require__(30321);
var mergeConfig = __webpack_require__(47185);
var defaults = __webpack_require__(45546);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  // Factory for creating new instances
  instance.create = function create(instanceConfig) {
    return createInstance(mergeConfig(defaultConfig, instanceConfig));
  };

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Expose Cancel & CancelToken
axios.CanceledError = __webpack_require__(60644);
axios.CancelToken = __webpack_require__(14972);
axios.isCancel = __webpack_require__(26502);
axios.VERSION = (__webpack_require__(97288).version);
axios.toFormData = __webpack_require__(47675);

// Expose AxiosError class
axios.AxiosError = __webpack_require__(82648);

// alias for CanceledError for backward compatibility
axios.Cancel = axios.CanceledError;

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(8713);

// Expose isAxiosError
axios.isAxiosError = __webpack_require__(16268);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports["default"] = axios;


/***/ }),

/***/ 14972:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var CanceledError = __webpack_require__(60644);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;

  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;

  // eslint-disable-next-line func-names
  this.promise.then(function(cancel) {
    if (!token._listeners) return;

    var i;
    var l = token._listeners.length;

    for (i = 0; i < l; i++) {
      token._listeners[i](cancel);
    }
    token._listeners = null;
  });

  // eslint-disable-next-line func-names
  this.promise.then = function(onfulfilled) {
    var _resolve;
    // eslint-disable-next-line func-names
    var promise = new Promise(function(resolve) {
      token.subscribe(resolve);
      _resolve = resolve;
    }).then(onfulfilled);

    promise.cancel = function reject() {
      token.unsubscribe(_resolve);
    };

    return promise;
  };

  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new CanceledError(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `CanceledError` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Subscribe to the cancel signal
 */

CancelToken.prototype.subscribe = function subscribe(listener) {
  if (this.reason) {
    listener(this.reason);
    return;
  }

  if (this._listeners) {
    this._listeners.push(listener);
  } else {
    this._listeners = [listener];
  }
};

/**
 * Unsubscribe from the cancel signal
 */

CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
  if (!this._listeners) {
    return;
  }
  var index = this._listeners.indexOf(listener);
  if (index !== -1) {
    this._listeners.splice(index, 1);
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),

/***/ 60644:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var AxiosError = __webpack_require__(82648);
var utils = __webpack_require__(64867);

/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function CanceledError(message) {
  // eslint-disable-next-line no-eq-null,eqeqeq
  AxiosError.call(this, message == null ? 'canceled' : message, AxiosError.ERR_CANCELED);
  this.name = 'CanceledError';
}

utils.inherits(CanceledError, AxiosError, {
  __CANCEL__: true
});

module.exports = CanceledError;


/***/ }),

/***/ 26502:
/***/ (function(module) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),

/***/ 30321:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);
var buildURL = __webpack_require__(15327);
var InterceptorManager = __webpack_require__(80782);
var dispatchRequest = __webpack_require__(13572);
var mergeConfig = __webpack_require__(47185);
var buildFullPath = __webpack_require__(94097);
var validator = __webpack_require__(54875);

var validators = validator.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(configOrUrl, config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof configOrUrl === 'string') {
    config = config || {};
    config.url = configOrUrl;
  } else {
    config = configOrUrl || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  var transitional = config.transitional;

  if (transitional !== undefined) {
    validator.assertOptions(transitional, {
      silentJSONParsing: validators.transitional(validators.boolean),
      forcedJSONParsing: validators.transitional(validators.boolean),
      clarifyTimeoutError: validators.transitional(validators.boolean)
    }, false);
  }

  // filter out skipped interceptors
  var requestInterceptorChain = [];
  var synchronousRequestInterceptors = true;
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
      return;
    }

    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  var responseInterceptorChain = [];
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
  });

  var promise;

  if (!synchronousRequestInterceptors) {
    var chain = [dispatchRequest, undefined];

    Array.prototype.unshift.apply(chain, requestInterceptorChain);
    chain = chain.concat(responseInterceptorChain);

    promise = Promise.resolve(config);
    while (chain.length) {
      promise = promise.then(chain.shift(), chain.shift());
    }

    return promise;
  }


  var newConfig = config;
  while (requestInterceptorChain.length) {
    var onFulfilled = requestInterceptorChain.shift();
    var onRejected = requestInterceptorChain.shift();
    try {
      newConfig = onFulfilled(newConfig);
    } catch (error) {
      onRejected(error);
      break;
    }
  }

  try {
    promise = dispatchRequest(newConfig);
  } catch (error) {
    return Promise.reject(error);
  }

  while (responseInterceptorChain.length) {
    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  var fullPath = buildFullPath(config.baseURL, config.url);
  return buildURL(fullPath, config.params, config.paramsSerializer);
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: (config || {}).data
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/

  function generateHTTPMethod(isForm) {
    return function httpMethod(url, data, config) {
      return this.request(mergeConfig(config || {}, {
        method: method,
        headers: isForm ? {
          'Content-Type': 'multipart/form-data'
        } : {},
        url: url,
        data: data
      }));
    };
  }

  Axios.prototype[method] = generateHTTPMethod();

  Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});

module.exports = Axios;


/***/ }),

/***/ 82648:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
function AxiosError(message, code, config, request, response) {
  Error.call(this);
  this.message = message;
  this.name = 'AxiosError';
  code && (this.code = code);
  config && (this.config = config);
  request && (this.request = request);
  response && (this.response = response);
}

utils.inherits(AxiosError, Error, {
  toJSON: function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});

var prototype = AxiosError.prototype;
var descriptors = {};

[
  'ERR_BAD_OPTION_VALUE',
  'ERR_BAD_OPTION',
  'ECONNABORTED',
  'ETIMEDOUT',
  'ERR_NETWORK',
  'ERR_FR_TOO_MANY_REDIRECTS',
  'ERR_DEPRECATED',
  'ERR_BAD_RESPONSE',
  'ERR_BAD_REQUEST',
  'ERR_CANCELED'
// eslint-disable-next-line func-names
].forEach(function(code) {
  descriptors[code] = {value: code};
});

Object.defineProperties(AxiosError, descriptors);
Object.defineProperty(prototype, 'isAxiosError', {value: true});

// eslint-disable-next-line func-names
AxiosError.from = function(error, code, config, request, response, customProps) {
  var axiosError = Object.create(prototype);

  utils.toFlatObject(error, axiosError, function filter(obj) {
    return obj !== Error.prototype;
  });

  AxiosError.call(axiosError, error.message, code, config, request, response);

  axiosError.name = error.name;

  customProps && Object.assign(axiosError, customProps);

  return axiosError;
};

module.exports = AxiosError;


/***/ }),

/***/ 80782:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected,
    synchronous: options ? options.synchronous : false,
    runWhen: options ? options.runWhen : null
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),

/***/ 94097:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(91793);
var combineURLs = __webpack_require__(7303);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),

/***/ 13572:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);
var transformData = __webpack_require__(18527);
var isCancel = __webpack_require__(26502);
var defaults = __webpack_require__(45546);
var CanceledError = __webpack_require__(60644);

/**
 * Throws a `CanceledError` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }

  if (config.signal && config.signal.aborted) {
    throw new CanceledError();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData.call(
    config,
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(
      config,
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),

/***/ 47185:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  function getMergedValue(target, source) {
    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
      return utils.merge(target, source);
    } else if (utils.isPlainObject(source)) {
      return utils.merge({}, source);
    } else if (utils.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  // eslint-disable-next-line consistent-return
  function mergeDeepProperties(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function valueFromConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(undefined, config2[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function defaultToConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(undefined, config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function mergeDirectKeys(prop) {
    if (prop in config2) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  var mergeMap = {
    'url': valueFromConfig2,
    'method': valueFromConfig2,
    'data': valueFromConfig2,
    'baseURL': defaultToConfig2,
    'transformRequest': defaultToConfig2,
    'transformResponse': defaultToConfig2,
    'paramsSerializer': defaultToConfig2,
    'timeout': defaultToConfig2,
    'timeoutMessage': defaultToConfig2,
    'withCredentials': defaultToConfig2,
    'adapter': defaultToConfig2,
    'responseType': defaultToConfig2,
    'xsrfCookieName': defaultToConfig2,
    'xsrfHeaderName': defaultToConfig2,
    'onUploadProgress': defaultToConfig2,
    'onDownloadProgress': defaultToConfig2,
    'decompress': defaultToConfig2,
    'maxContentLength': defaultToConfig2,
    'maxBodyLength': defaultToConfig2,
    'beforeRedirect': defaultToConfig2,
    'transport': defaultToConfig2,
    'httpAgent': defaultToConfig2,
    'httpsAgent': defaultToConfig2,
    'cancelToken': defaultToConfig2,
    'socketPath': defaultToConfig2,
    'responseEncoding': defaultToConfig2,
    'validateStatus': mergeDirectKeys
  };

  utils.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
    var merge = mergeMap[prop] || mergeDeepProperties;
    var configValue = merge(prop);
    (utils.isUndefined(configValue) && merge !== mergeDirectKeys) || (config[prop] = configValue);
  });

  return config;
};


/***/ }),

/***/ 36026:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var AxiosError = __webpack_require__(82648);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(new AxiosError(
      'Request failed with status code ' + response.status,
      [AxiosError.ERR_BAD_REQUEST, AxiosError.ERR_BAD_RESPONSE][Math.floor(response.status / 100) - 4],
      response.config,
      response.request,
      response
    ));
  }
};


/***/ }),

/***/ 18527:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);
var defaults = __webpack_require__(45546);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  var context = this || defaults;
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn.call(context, data, headers);
  });

  return data;
};


/***/ }),

/***/ 45546:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(83454);


var utils = __webpack_require__(64867);
var normalizeHeaderName = __webpack_require__(16016);
var AxiosError = __webpack_require__(82648);
var transitionalDefaults = __webpack_require__(77874);
var toFormData = __webpack_require__(47675);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(55448);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(55448);
  }
  return adapter;
}

function stringifySafely(rawValue, parser, encoder) {
  if (utils.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

var defaults = {

  transitional: transitionalDefaults,

  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');

    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }

    var isObjectPayload = utils.isObject(data);
    var contentType = headers && headers['Content-Type'];

    var isFileList;

    if ((isFileList = utils.isFileList(data)) || (isObjectPayload && contentType === 'multipart/form-data')) {
      var _FormData = this.env && this.env.FormData;
      return toFormData(isFileList ? {'files[]': data} : data, _FormData && new _FormData());
    } else if (isObjectPayload || contentType === 'application/json') {
      setContentTypeIfUnset(headers, 'application/json');
      return stringifySafely(data);
    }

    return data;
  }],

  transformResponse: [function transformResponse(data) {
    var transitional = this.transitional || defaults.transitional;
    var silentJSONParsing = transitional && transitional.silentJSONParsing;
    var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';

    if (strictJSONParsing || (forcedJSONParsing && utils.isString(data) && data.length)) {
      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw AxiosError.from(e, AxiosError.ERR_BAD_RESPONSE, this, null, this.response);
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  env: {
    FormData: __webpack_require__(91623)
  },

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },

  headers: {
    common: {
      'Accept': 'application/json, text/plain, */*'
    }
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;


/***/ }),

/***/ 77874:
/***/ (function(module) {

"use strict";


module.exports = {
  silentJSONParsing: true,
  forcedJSONParsing: true,
  clarifyTimeoutError: false
};


/***/ }),

/***/ 97288:
/***/ (function(module) {

module.exports = {
  "version": "0.27.2"
};

/***/ }),

/***/ 91849:
/***/ (function(module) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),

/***/ 15327:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),

/***/ 7303:
/***/ (function(module) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),

/***/ 4372:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),

/***/ 91793:
/***/ (function(module) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
};


/***/ }),

/***/ 16268:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
module.exports = function isAxiosError(payload) {
  return utils.isObject(payload) && (payload.isAxiosError === true);
};


/***/ }),

/***/ 67985:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),

/***/ 16016:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),

/***/ 91623:
/***/ (function(module) {

// eslint-disable-next-line strict
module.exports = null;


/***/ }),

/***/ 84109:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),

/***/ 90205:
/***/ (function(module) {

"use strict";


module.exports = function parseProtocol(url) {
  var match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
  return match && match[1] || '';
};


/***/ }),

/***/ 8713:
/***/ (function(module) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),

/***/ 47675:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* provided dependency */ var Buffer = __webpack_require__(48764)["Buffer"];


var utils = __webpack_require__(64867);

/**
 * Convert a data object to FormData
 * @param {Object} obj
 * @param {?Object} [formData]
 * @returns {Object}
 **/

function toFormData(obj, formData) {
  // eslint-disable-next-line no-param-reassign
  formData = formData || new FormData();

  var stack = [];

  function convertValue(value) {
    if (value === null) return '';

    if (utils.isDate(value)) {
      return value.toISOString();
    }

    if (utils.isArrayBuffer(value) || utils.isTypedArray(value)) {
      return typeof Blob === 'function' ? new Blob([value]) : Buffer.from(value);
    }

    return value;
  }

  function build(data, parentKey) {
    if (utils.isPlainObject(data) || utils.isArray(data)) {
      if (stack.indexOf(data) !== -1) {
        throw Error('Circular reference detected in ' + parentKey);
      }

      stack.push(data);

      utils.forEach(data, function each(value, key) {
        if (utils.isUndefined(value)) return;
        var fullKey = parentKey ? parentKey + '.' + key : key;
        var arr;

        if (value && !parentKey && typeof value === 'object') {
          if (utils.endsWith(key, '{}')) {
            // eslint-disable-next-line no-param-reassign
            value = JSON.stringify(value);
          } else if (utils.endsWith(key, '[]') && (arr = utils.toArray(value))) {
            // eslint-disable-next-line func-names
            arr.forEach(function(el) {
              !utils.isUndefined(el) && formData.append(fullKey, convertValue(el));
            });
            return;
          }
        }

        build(value, fullKey);
      });

      stack.pop();
    } else {
      formData.append(parentKey, convertValue(data));
    }
  }

  build(obj);

  return formData;
}

module.exports = toFormData;


/***/ }),

/***/ 54875:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var VERSION = (__webpack_require__(97288).version);
var AxiosError = __webpack_require__(82648);

var validators = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach(function(type, i) {
  validators[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

var deprecatedWarnings = {};

/**
 * Transitional option validator
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 * @returns {function}
 */
validators.transitional = function transitional(validator, version, message) {
  function formatMessage(opt, desc) {
    return '[Axios v' + VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return function(value, opt, opts) {
    if (validator === false) {
      throw new AxiosError(
        formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')),
        AxiosError.ERR_DEPRECATED
      );
    }

    if (version && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new AxiosError('options must be an object', AxiosError.ERR_BAD_OPTION_VALUE);
  }
  var keys = Object.keys(options);
  var i = keys.length;
  while (i-- > 0) {
    var opt = keys[i];
    var validator = schema[opt];
    if (validator) {
      var value = options[opt];
      var result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new AxiosError('option ' + opt + ' must be ' + result, AxiosError.ERR_BAD_OPTION_VALUE);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw new AxiosError('Unknown option ' + opt, AxiosError.ERR_BAD_OPTION);
    }
  }
}

module.exports = {
  assertOptions: assertOptions,
  validators: validators
};


/***/ }),

/***/ 64867:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(91849);

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

// eslint-disable-next-line func-names
var kindOf = (function(cache) {
  // eslint-disable-next-line func-names
  return function(thing) {
    var str = toString.call(thing);
    return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
  };
})(Object.create(null));

function kindOfTest(type) {
  type = type.toLowerCase();
  return function isKindOf(thing) {
    return kindOf(thing) === type;
  };
}

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return Array.isArray(val);
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
var isArrayBuffer = kindOfTest('ArrayBuffer');


/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (isArrayBuffer(val.buffer));
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */
function isPlainObject(val) {
  if (kindOf(val) !== 'object') {
    return false;
  }

  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}

/**
 * Determine if a value is a Date
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
var isDate = kindOfTest('Date');

/**
 * Determine if a value is a File
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
var isFile = kindOfTest('File');

/**
 * Determine if a value is a Blob
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
var isBlob = kindOfTest('Blob');

/**
 * Determine if a value is a FileList
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
var isFileList = kindOfTest('FileList');

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} thing The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(thing) {
  var pattern = '[object FormData]';
  return thing && (
    (typeof FormData === 'function' && thing instanceof FormData) ||
    toString.call(thing) === pattern ||
    (isFunction(thing.toString) && thing.toString() === pattern)
  );
}

/**
 * Determine if a value is a URLSearchParams object
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
var isURLSearchParams = kindOfTest('URLSearchParams');

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge({}, val);
    } else if (isArray(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */
function stripBOM(content) {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 */

function inherits(constructor, superConstructor, props, descriptors) {
  constructor.prototype = Object.create(superConstructor.prototype, descriptors);
  constructor.prototype.constructor = constructor;
  props && Object.assign(constructor.prototype, props);
}

/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function} [filter]
 * @returns {Object}
 */

function toFlatObject(sourceObj, destObj, filter) {
  var props;
  var i;
  var prop;
  var merged = {};

  destObj = destObj || {};

  do {
    props = Object.getOwnPropertyNames(sourceObj);
    i = props.length;
    while (i-- > 0) {
      prop = props[i];
      if (!merged[prop]) {
        destObj[prop] = sourceObj[prop];
        merged[prop] = true;
      }
    }
    sourceObj = Object.getPrototypeOf(sourceObj);
  } while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);

  return destObj;
}

/*
 * determines whether a string ends with the characters of a specified string
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 * @returns {boolean}
 */
function endsWith(str, searchString, position) {
  str = String(str);
  if (position === undefined || position > str.length) {
    position = str.length;
  }
  position -= searchString.length;
  var lastIndex = str.indexOf(searchString, position);
  return lastIndex !== -1 && lastIndex === position;
}


/**
 * Returns new array from array like object
 * @param {*} [thing]
 * @returns {Array}
 */
function toArray(thing) {
  if (!thing) return null;
  var i = thing.length;
  if (isUndefined(i)) return null;
  var arr = new Array(i);
  while (i-- > 0) {
    arr[i] = thing[i];
  }
  return arr;
}

// eslint-disable-next-line func-names
var isTypedArray = (function(TypedArray) {
  // eslint-disable-next-line func-names
  return function(thing) {
    return TypedArray && thing instanceof TypedArray;
  };
})(typeof Uint8Array !== 'undefined' && Object.getPrototypeOf(Uint8Array));

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isPlainObject: isPlainObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim,
  stripBOM: stripBOM,
  inherits: inherits,
  toFlatObject: toFlatObject,
  kindOf: kindOf,
  kindOfTest: kindOfTest,
  endsWith: endsWith,
  toArray: toArray,
  isTypedArray: isTypedArray,
  isFileList: isFileList
};


/***/ }),

/***/ 79742:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),

/***/ 48764:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(79742)
var ieee754 = __webpack_require__(80645)
var customInspectSymbol =
  (typeof Symbol === 'function' && typeof Symbol['for'] === 'function') // eslint-disable-line dot-notation
    ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
    : null

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

var K_MAX_LENGTH = 0x7fffffff
exports.kMaxLength = K_MAX_LENGTH

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */
Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport()

if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' &&
    typeof console.error === 'function') {
  console.error(
    'This browser lacks typed array (Uint8Array) support which is required by ' +
    '`buffer` v5.x. Use `buffer` v4.x if you require old browser support.'
  )
}

function typedArraySupport () {
  // Can typed array instances can be augmented?
  try {
    var arr = new Uint8Array(1)
    var proto = { foo: function () { return 42 } }
    Object.setPrototypeOf(proto, Uint8Array.prototype)
    Object.setPrototypeOf(arr, proto)
    return arr.foo() === 42
  } catch (e) {
    return false
  }
}

Object.defineProperty(Buffer.prototype, 'parent', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.buffer
  }
})

Object.defineProperty(Buffer.prototype, 'offset', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.byteOffset
  }
})

function createBuffer (length) {
  if (length > K_MAX_LENGTH) {
    throw new RangeError('The value "' + length + '" is invalid for option "size"')
  }
  // Return an augmented `Uint8Array` instance
  var buf = new Uint8Array(length)
  Object.setPrototypeOf(buf, Buffer.prototype)
  return buf
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new TypeError(
        'The "string" argument must be of type string. Received type number'
      )
    }
    return allocUnsafe(arg)
  }
  return from(arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

function from (value, encodingOrOffset, length) {
  if (typeof value === 'string') {
    return fromString(value, encodingOrOffset)
  }

  if (ArrayBuffer.isView(value)) {
    return fromArrayView(value)
  }

  if (value == null) {
    throw new TypeError(
      'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
      'or Array-like Object. Received type ' + (typeof value)
    )
  }

  if (isInstance(value, ArrayBuffer) ||
      (value && isInstance(value.buffer, ArrayBuffer))) {
    return fromArrayBuffer(value, encodingOrOffset, length)
  }

  if (typeof SharedArrayBuffer !== 'undefined' &&
      (isInstance(value, SharedArrayBuffer) ||
      (value && isInstance(value.buffer, SharedArrayBuffer)))) {
    return fromArrayBuffer(value, encodingOrOffset, length)
  }

  if (typeof value === 'number') {
    throw new TypeError(
      'The "value" argument must not be of type number. Received type number'
    )
  }

  var valueOf = value.valueOf && value.valueOf()
  if (valueOf != null && valueOf !== value) {
    return Buffer.from(valueOf, encodingOrOffset, length)
  }

  var b = fromObject(value)
  if (b) return b

  if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null &&
      typeof value[Symbol.toPrimitive] === 'function') {
    return Buffer.from(
      value[Symbol.toPrimitive]('string'), encodingOrOffset, length
    )
  }

  throw new TypeError(
    'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
    'or Array-like Object. Received type ' + (typeof value)
  )
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(value, encodingOrOffset, length)
}

// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype)
Object.setPrototypeOf(Buffer, Uint8Array)

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be of type number')
  } else if (size < 0) {
    throw new RangeError('The value "' + size + '" is invalid for option "size"')
  }
}

function alloc (size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(size).fill(fill, encoding)
      : createBuffer(size).fill(fill)
  }
  return createBuffer(size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(size, fill, encoding)
}

function allocUnsafe (size) {
  assertSize(size)
  return createBuffer(size < 0 ? 0 : checked(size) | 0)
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(size)
}

function fromString (string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('Unknown encoding: ' + encoding)
  }

  var length = byteLength(string, encoding) | 0
  var buf = createBuffer(length)

  var actual = buf.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual)
  }

  return buf
}

function fromArrayLike (array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  var buf = createBuffer(length)
  for (var i = 0; i < length; i += 1) {
    buf[i] = array[i] & 255
  }
  return buf
}

function fromArrayView (arrayView) {
  if (isInstance(arrayView, Uint8Array)) {
    var copy = new Uint8Array(arrayView)
    return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength)
  }
  return fromArrayLike(arrayView)
}

function fromArrayBuffer (array, byteOffset, length) {
  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('"offset" is outside of buffer bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('"length" is outside of buffer bounds')
  }

  var buf
  if (byteOffset === undefined && length === undefined) {
    buf = new Uint8Array(array)
  } else if (length === undefined) {
    buf = new Uint8Array(array, byteOffset)
  } else {
    buf = new Uint8Array(array, byteOffset, length)
  }

  // Return an augmented `Uint8Array` instance
  Object.setPrototypeOf(buf, Buffer.prototype)

  return buf
}

function fromObject (obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    var buf = createBuffer(len)

    if (buf.length === 0) {
      return buf
    }

    obj.copy(buf, 0, 0, len)
    return buf
  }

  if (obj.length !== undefined) {
    if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) {
      return createBuffer(0)
    }
    return fromArrayLike(obj)
  }

  if (obj.type === 'Buffer' && Array.isArray(obj.data)) {
    return fromArrayLike(obj.data)
  }
}

function checked (length) {
  // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= K_MAX_LENGTH) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + K_MAX_LENGTH.toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return b != null && b._isBuffer === true &&
    b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
}

Buffer.compare = function compare (a, b) {
  if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength)
  if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength)
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError(
      'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
    )
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!Array.isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (isInstance(buf, Uint8Array)) {
      if (pos + buf.length > buffer.length) {
        Buffer.from(buf).copy(buffer, pos)
      } else {
        Uint8Array.prototype.set.call(
          buffer,
          buf,
          pos
        )
      }
    } else if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    } else {
      buf.copy(buffer, pos)
    }
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    throw new TypeError(
      'The "string" argument must be one of type string, Buffer, or ArrayBuffer. ' +
      'Received type ' + typeof string
    )
  }

  var len = string.length
  var mustMatch = (arguments.length > 2 && arguments[2] === true)
  if (!mustMatch && len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) {
          return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
        }
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.toLocaleString = Buffer.prototype.toString

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim()
  if (this.length > max) str += ' ... '
  return '<Buffer ' + str + '>'
}
if (customInspectSymbol) {
  Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (isInstance(target, Uint8Array)) {
    target = Buffer.from(target, target.offset, target.byteLength)
  }
  if (!Buffer.isBuffer(target)) {
    throw new TypeError(
      'The "target" argument must be one of type Buffer or Uint8Array. ' +
      'Received type ' + (typeof target)
    )
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset // Coerce to Number.
  if (numberIsNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [val], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  var strLen = string.length

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (numberIsNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset >>> 0
    if (isFinite(length)) {
      length = length >>> 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
      case 'latin1':
      case 'binary':
        return asciiWrite(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF)
      ? 4
      : (firstByte > 0xDF)
          ? 3
          : (firstByte > 0xBF)
              ? 2
              : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += hexSliceLookupTable[buf[i]]
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
  for (var i = 0; i < bytes.length - 1; i += 2) {
    res += String.fromCharCode(bytes[i] + (bytes[i + 1] * 256))
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf = this.subarray(start, end)
  // Return an augmented `Uint8Array` instance
  Object.setPrototypeOf(newBuf, Buffer.prototype)

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUintLE =
Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUintBE =
Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUint8 =
Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUint16LE =
Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUint16BE =
Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUint32LE =
Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUint32BE =
Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUintLE =
Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUintBE =
Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUint8 =
Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeUint16LE =
Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeUint16BE =
Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeUint32LE =
Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset + 3] = (value >>> 24)
  this[offset + 2] = (value >>> 16)
  this[offset + 1] = (value >>> 8)
  this[offset] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeUint32BE =
Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    var limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    var limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  this[offset + 2] = (value >>> 16)
  this[offset + 3] = (value >>> 24)
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer')
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('Index out of range')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start

  if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') {
    // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end)
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, end),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if ((encoding === 'utf8' && code < 128) ||
          encoding === 'latin1') {
        // Fast path: If `val` fits into a single byte, use that numeric value.
        val = code
      }
    }
  } else if (typeof val === 'number') {
    val = val & 255
  } else if (typeof val === 'boolean') {
    val = Number(val)
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : Buffer.from(val, encoding)
    var len = bytes.length
    if (len === 0) {
      throw new TypeError('The value "' + val +
        '" is invalid for argument "value"')
    }
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node takes equal signs as end of the Base64 encoding
  str = str.split('=')[0]
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = str.trim().replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function isInstance (obj, type) {
  return obj instanceof type ||
    (obj != null && obj.constructor != null && obj.constructor.name != null &&
      obj.constructor.name === type.name)
}
function numberIsNaN (obj) {
  // For IE11 support
  return obj !== obj // eslint-disable-line no-self-compare
}

// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var hexSliceLookupTable = (function () {
  var alphabet = '0123456789abcdef'
  var table = new Array(256)
  for (var i = 0; i < 16; ++i) {
    var i16 = i * 16
    for (var j = 0; j < 16; ++j) {
      table[i16 + j] = alphabet[i] + alphabet[j]
    }
  }
  return table
})()


/***/ }),

/***/ 25730:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(58612);

var $apply = __webpack_require__(1768);
var $call = __webpack_require__(68928);
var $reflectApply = __webpack_require__(59770);

/** @type {import('./actualApply')} */
module.exports = $reflectApply || bind.call($call, $apply);


/***/ }),

/***/ 1768:
/***/ (function(module) {

"use strict";


/** @type {import('./functionApply')} */
module.exports = Function.prototype.apply;


/***/ }),

/***/ 68928:
/***/ (function(module) {

"use strict";


/** @type {import('./functionCall')} */
module.exports = Function.prototype.call;


/***/ }),

/***/ 40319:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(58612);
var $TypeError = __webpack_require__(14453);

var $call = __webpack_require__(68928);
var $actualApply = __webpack_require__(25730);

/** @type {(args: [Function, thisArg?: unknown, ...args: unknown[]]) => Function} TODO FIXME, find a way to use import('.') */
module.exports = function callBindBasic(args) {
	if (args.length < 1 || typeof args[0] !== 'function') {
		throw new $TypeError('a function is required');
	}
	return $actualApply(bind, $call, args);
};


/***/ }),

/***/ 59770:
/***/ (function(module) {

"use strict";


/** @type {import('./reflectApply')} */
module.exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;


/***/ }),

/***/ 17379:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(40210);

var callBindBasic = __webpack_require__(40319);

/** @type {(thisArg: string, searchString: string, position?: number) => number} */
var $indexOf = callBindBasic([GetIntrinsic('%String.prototype.indexOf%')]);

/** @type {import('.')} */
module.exports = function callBoundIntrinsic(name, allowMissing) {
	/* eslint no-extra-parens: 0 */

	var intrinsic = /** @type {(this: unknown, ...args: unknown[]) => unknown} */ (GetIntrinsic(name, !!allowMissing));
	if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
		return callBindBasic(/** @type {const} */ ([intrinsic]));
	}
	return intrinsic;
};


/***/ }),

/***/ 2350:
/***/ (function() {



/***/ }),

/***/ 67389:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/*!
 * content-disposition
 * Copyright(c) 2014-2017 Douglas Christopher Wilson
 * MIT Licensed
 */



/**
 * Module exports.
 * @public
 */

module.exports = contentDisposition
module.exports.parse = parse

/**
 * Module dependencies.
 * @private
 */

var basename = (__webpack_require__(1864).basename)
var Buffer = (__webpack_require__(89509).Buffer)

/**
 * RegExp to match non attr-char, *after* encodeURIComponent (i.e. not including "%")
 * @private
 */

var ENCODE_URL_ATTR_CHAR_REGEXP = /[\x00-\x20"'()*,/:;<=>?@[\\\]{}\x7f]/g // eslint-disable-line no-control-regex

/**
 * RegExp to match percent encoding escape.
 * @private
 */

var HEX_ESCAPE_REGEXP = /%[0-9A-Fa-f]{2}/
var HEX_ESCAPE_REPLACE_REGEXP = /%([0-9A-Fa-f]{2})/g

/**
 * RegExp to match non-latin1 characters.
 * @private
 */

var NON_LATIN1_REGEXP = /[^\x20-\x7e\xa0-\xff]/g

/**
 * RegExp to match quoted-pair in RFC 2616
 *
 * quoted-pair = "\" CHAR
 * CHAR        = <any US-ASCII character (octets 0 - 127)>
 * @private
 */

var QESC_REGEXP = /\\([\u0000-\u007f])/g // eslint-disable-line no-control-regex

/**
 * RegExp to match chars that must be quoted-pair in RFC 2616
 * @private
 */

var QUOTE_REGEXP = /([\\"])/g

/**
 * RegExp for various RFC 2616 grammar
 *
 * parameter     = token "=" ( token | quoted-string )
 * token         = 1*<any CHAR except CTLs or separators>
 * separators    = "(" | ")" | "<" | ">" | "@"
 *               | "," | ";" | ":" | "\" | <">
 *               | "/" | "[" | "]" | "?" | "="
 *               | "{" | "}" | SP | HT
 * quoted-string = ( <"> *(qdtext | quoted-pair ) <"> )
 * qdtext        = <any TEXT except <">>
 * quoted-pair   = "\" CHAR
 * CHAR          = <any US-ASCII character (octets 0 - 127)>
 * TEXT          = <any OCTET except CTLs, but including LWS>
 * LWS           = [CRLF] 1*( SP | HT )
 * CRLF          = CR LF
 * CR            = <US-ASCII CR, carriage return (13)>
 * LF            = <US-ASCII LF, linefeed (10)>
 * SP            = <US-ASCII SP, space (32)>
 * HT            = <US-ASCII HT, horizontal-tab (9)>
 * CTL           = <any US-ASCII control character (octets 0 - 31) and DEL (127)>
 * OCTET         = <any 8-bit sequence of data>
 * @private
 */

var PARAM_REGEXP = /;[\x09\x20]*([!#$%&'*+.0-9A-Z^_`a-z|~-]+)[\x09\x20]*=[\x09\x20]*("(?:[\x20!\x23-\x5b\x5d-\x7e\x80-\xff]|\\[\x20-\x7e])*"|[!#$%&'*+.0-9A-Z^_`a-z|~-]+)[\x09\x20]*/g // eslint-disable-line no-control-regex
var TEXT_REGEXP = /^[\x20-\x7e\x80-\xff]+$/
var TOKEN_REGEXP = /^[!#$%&'*+.0-9A-Z^_`a-z|~-]+$/

/**
 * RegExp for various RFC 5987 grammar
 *
 * ext-value     = charset  "'" [ language ] "'" value-chars
 * charset       = "UTF-8" / "ISO-8859-1" / mime-charset
 * mime-charset  = 1*mime-charsetc
 * mime-charsetc = ALPHA / DIGIT
 *               / "!" / "#" / "$" / "%" / "&"
 *               / "+" / "-" / "^" / "_" / "`"
 *               / "{" / "}" / "~"
 * language      = ( 2*3ALPHA [ extlang ] )
 *               / 4ALPHA
 *               / 5*8ALPHA
 * extlang       = *3( "-" 3ALPHA )
 * value-chars   = *( pct-encoded / attr-char )
 * pct-encoded   = "%" HEXDIG HEXDIG
 * attr-char     = ALPHA / DIGIT
 *               / "!" / "#" / "$" / "&" / "+" / "-" / "."
 *               / "^" / "_" / "`" / "|" / "~"
 * @private
 */

var EXT_VALUE_REGEXP = /^([A-Za-z0-9!#$%&+\-^_`{}~]+)'(?:[A-Za-z]{2,3}(?:-[A-Za-z]{3}){0,3}|[A-Za-z]{4,8}|)'((?:%[0-9A-Fa-f]{2}|[A-Za-z0-9!#$&+.^_`|~-])+)$/

/**
 * RegExp for various RFC 6266 grammar
 *
 * disposition-type = "inline" | "attachment" | disp-ext-type
 * disp-ext-type    = token
 * disposition-parm = filename-parm | disp-ext-parm
 * filename-parm    = "filename" "=" value
 *                  | "filename*" "=" ext-value
 * disp-ext-parm    = token "=" value
 *                  | ext-token "=" ext-value
 * ext-token        = <the characters in token, followed by "*">
 * @private
 */

var DISPOSITION_TYPE_REGEXP = /^([!#$%&'*+.0-9A-Z^_`a-z|~-]+)[\x09\x20]*(?:$|;)/ // eslint-disable-line no-control-regex

/**
 * Create an attachment Content-Disposition header.
 *
 * @param {string} [filename]
 * @param {object} [options]
 * @param {string} [options.type=attachment]
 * @param {string|boolean} [options.fallback=true]
 * @return {string}
 * @public
 */

function contentDisposition (filename, options) {
  var opts = options || {}

  // get type
  var type = opts.type || 'attachment'

  // get parameters
  var params = createparams(filename, opts.fallback)

  // format into string
  return format(new ContentDisposition(type, params))
}

/**
 * Create parameters object from filename and fallback.
 *
 * @param {string} [filename]
 * @param {string|boolean} [fallback=true]
 * @return {object}
 * @private
 */

function createparams (filename, fallback) {
  if (filename === undefined) {
    return
  }

  var params = {}

  if (typeof filename !== 'string') {
    throw new TypeError('filename must be a string')
  }

  // fallback defaults to true
  if (fallback === undefined) {
    fallback = true
  }

  if (typeof fallback !== 'string' && typeof fallback !== 'boolean') {
    throw new TypeError('fallback must be a string or boolean')
  }

  if (typeof fallback === 'string' && NON_LATIN1_REGEXP.test(fallback)) {
    throw new TypeError('fallback must be ISO-8859-1 string')
  }

  // restrict to file base name
  var name = basename(filename)

  // determine if name is suitable for quoted string
  var isQuotedString = TEXT_REGEXP.test(name)

  // generate fallback name
  var fallbackName = typeof fallback !== 'string'
    ? fallback && getlatin1(name)
    : basename(fallback)
  var hasFallback = typeof fallbackName === 'string' && fallbackName !== name

  // set extended filename parameter
  if (hasFallback || !isQuotedString || HEX_ESCAPE_REGEXP.test(name)) {
    params['filename*'] = name
  }

  // set filename parameter
  if (isQuotedString || hasFallback) {
    params.filename = hasFallback
      ? fallbackName
      : name
  }

  return params
}

/**
 * Format object to Content-Disposition header.
 *
 * @param {object} obj
 * @param {string} obj.type
 * @param {object} [obj.parameters]
 * @return {string}
 * @private
 */

function format (obj) {
  var parameters = obj.parameters
  var type = obj.type

  if (!type || typeof type !== 'string' || !TOKEN_REGEXP.test(type)) {
    throw new TypeError('invalid type')
  }

  // start with normalized type
  var string = String(type).toLowerCase()

  // append parameters
  if (parameters && typeof parameters === 'object') {
    var param
    var params = Object.keys(parameters).sort()

    for (var i = 0; i < params.length; i++) {
      param = params[i]

      var val = param.substr(-1) === '*'
        ? ustring(parameters[param])
        : qstring(parameters[param])

      string += '; ' + param + '=' + val
    }
  }

  return string
}

/**
 * Decode a RFC 5987 field value (gracefully).
 *
 * @param {string} str
 * @return {string}
 * @private
 */

function decodefield (str) {
  var match = EXT_VALUE_REGEXP.exec(str)

  if (!match) {
    throw new TypeError('invalid extended field value')
  }

  var charset = match[1].toLowerCase()
  var encoded = match[2]
  var value

  // to binary string
  var binary = encoded.replace(HEX_ESCAPE_REPLACE_REGEXP, pdecode)

  switch (charset) {
    case 'iso-8859-1':
      value = getlatin1(binary)
      break
    case 'utf-8':
      value = Buffer.from(binary, 'binary').toString('utf8')
      break
    default:
      throw new TypeError('unsupported charset in extended field')
  }

  return value
}

/**
 * Get ISO-8859-1 version of string.
 *
 * @param {string} val
 * @return {string}
 * @private
 */

function getlatin1 (val) {
  // simple Unicode -> ISO-8859-1 transformation
  return String(val).replace(NON_LATIN1_REGEXP, '?')
}

/**
 * Parse Content-Disposition header string.
 *
 * @param {string} string
 * @return {object}
 * @public
 */

function parse (string) {
  if (!string || typeof string !== 'string') {
    throw new TypeError('argument string is required')
  }

  var match = DISPOSITION_TYPE_REGEXP.exec(string)

  if (!match) {
    throw new TypeError('invalid type format')
  }

  // normalize type
  var index = match[0].length
  var type = match[1].toLowerCase()

  var key
  var names = []
  var params = {}
  var value

  // calculate index to start at
  index = PARAM_REGEXP.lastIndex = match[0].substr(-1) === ';'
    ? index - 1
    : index

  // match parameters
  while ((match = PARAM_REGEXP.exec(string))) {
    if (match.index !== index) {
      throw new TypeError('invalid parameter format')
    }

    index += match[0].length
    key = match[1].toLowerCase()
    value = match[2]

    if (names.indexOf(key) !== -1) {
      throw new TypeError('invalid duplicate parameter')
    }

    names.push(key)

    if (key.indexOf('*') + 1 === key.length) {
      // decode extended value
      key = key.slice(0, -1)
      value = decodefield(value)

      // overwrite existing value
      params[key] = value
      continue
    }

    if (typeof params[key] === 'string') {
      continue
    }

    if (value[0] === '"') {
      // remove quotes and escapes
      value = value
        .substr(1, value.length - 2)
        .replace(QESC_REGEXP, '$1')
    }

    params[key] = value
  }

  if (index !== -1 && index !== string.length) {
    throw new TypeError('invalid parameter format')
  }

  return new ContentDisposition(type, params)
}

/**
 * Percent decode a single character.
 *
 * @param {string} str
 * @param {string} hex
 * @return {string}
 * @private
 */

function pdecode (str, hex) {
  return String.fromCharCode(parseInt(hex, 16))
}

/**
 * Percent encode a single character.
 *
 * @param {string} char
 * @return {string}
 * @private
 */

function pencode (char) {
  return '%' + String(char)
    .charCodeAt(0)
    .toString(16)
    .toUpperCase()
}

/**
 * Quote a string for HTTP.
 *
 * @param {string} val
 * @return {string}
 * @private
 */

function qstring (val) {
  var str = String(val)

  return '"' + str.replace(QUOTE_REGEXP, '\\$1') + '"'
}

/**
 * Encode a Unicode string for HTTP (RFC 5987).
 *
 * @param {string} val
 * @return {string}
 * @private
 */

function ustring (val) {
  var str = String(val)

  // percent encode as UTF-8
  var encoded = encodeURIComponent(str)
    .replace(ENCODE_URL_ATTR_CHAR_REGEXP, pencode)

  return 'UTF-8\'\'' + encoded
}

/**
 * Class for parsed Content-Disposition header for v8 optimization
 *
 * @public
 * @param {string} type
 * @param {object} parameters
 * @constructor
 */

function ContentDisposition (type, parameters) {
  this.type = type
  this.parameters = parameters
}


/***/ }),

/***/ 76489:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */



/**
 * Module exports.
 * @public
 */

exports.Q = parse;
exports.q = serialize;

/**
 * Module variables.
 * @private
 */

var decode = decodeURIComponent;
var encode = encodeURIComponent;

/**
 * RegExp to match field-content in RFC 7230 sec 3.2
 *
 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
 * field-vchar   = VCHAR / obs-text
 * obs-text      = %x80-FF
 */

var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;

/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 *
 * @param {string} str
 * @param {object} [options]
 * @return {object}
 * @public
 */

function parse(str, options) {
  if (typeof str !== 'string') {
    throw new TypeError('argument str must be a string');
  }

  var obj = {}
  var opt = options || {};
  var pairs = str.split(';')
  var dec = opt.decode || decode;

  for (var i = 0; i < pairs.length; i++) {
    var pair = pairs[i];
    var index = pair.indexOf('=')

    // skip things that don't look like key=value
    if (index < 0) {
      continue;
    }

    var key = pair.substring(0, index).trim()

    // only assign once
    if (undefined == obj[key]) {
      var val = pair.substring(index + 1, pair.length).trim()

      // quoted values
      if (val[0] === '"') {
        val = val.slice(1, -1)
      }

      obj[key] = tryDecode(val, dec);
    }
  }

  return obj;
}

/**
 * Serialize data into a cookie header.
 *
 * Serialize the a name value pair into a cookie string suitable for
 * http headers. An optional options object specified cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 *
 * @param {string} name
 * @param {string} val
 * @param {object} [options]
 * @return {string}
 * @public
 */

function serialize(name, val, options) {
  var opt = options || {};
  var enc = opt.encode || encode;

  if (typeof enc !== 'function') {
    throw new TypeError('option encode is invalid');
  }

  if (!fieldContentRegExp.test(name)) {
    throw new TypeError('argument name is invalid');
  }

  var value = enc(val);

  if (value && !fieldContentRegExp.test(value)) {
    throw new TypeError('argument val is invalid');
  }

  var str = name + '=' + value;

  if (null != opt.maxAge) {
    var maxAge = opt.maxAge - 0;

    if (isNaN(maxAge) || !isFinite(maxAge)) {
      throw new TypeError('option maxAge is invalid')
    }

    str += '; Max-Age=' + Math.floor(maxAge);
  }

  if (opt.domain) {
    if (!fieldContentRegExp.test(opt.domain)) {
      throw new TypeError('option domain is invalid');
    }

    str += '; Domain=' + opt.domain;
  }

  if (opt.path) {
    if (!fieldContentRegExp.test(opt.path)) {
      throw new TypeError('option path is invalid');
    }

    str += '; Path=' + opt.path;
  }

  if (opt.expires) {
    if (typeof opt.expires.toUTCString !== 'function') {
      throw new TypeError('option expires is invalid');
    }

    str += '; Expires=' + opt.expires.toUTCString();
  }

  if (opt.httpOnly) {
    str += '; HttpOnly';
  }

  if (opt.secure) {
    str += '; Secure';
  }

  if (opt.sameSite) {
    var sameSite = typeof opt.sameSite === 'string'
      ? opt.sameSite.toLowerCase() : opt.sameSite;

    switch (sameSite) {
      case true:
        str += '; SameSite=Strict';
        break;
      case 'lax':
        str += '; SameSite=Lax';
        break;
      case 'strict':
        str += '; SameSite=Strict';
        break;
      case 'none':
        str += '; SameSite=None';
        break;
      default:
        throw new TypeError('option sameSite is invalid');
    }
  }

  return str;
}

/**
 * Try decoding a string using a decoding function.
 *
 * @param {string} str
 * @param {function} decode
 * @private
 */

function tryDecode(str, decode) {
  try {
    return decode(str);
  } catch (e) {
    return str;
  }
}


/***/ }),

/***/ 54098:
/***/ (function(module, exports, __webpack_require__) {

// Save global object in a variable
var __global__ =
(typeof globalThis !== 'undefined' && globalThis) ||
(typeof self !== 'undefined' && self) ||
(typeof __webpack_require__.g !== 'undefined' && __webpack_require__.g);
// Create an object that extends from __global__ without the fetch function
var __globalThis__ = (function () {
function F() {
this.fetch = false;
this.DOMException = __global__.DOMException
}
F.prototype = __global__; // Needed for feature detection on whatwg-fetch's code
return new F();
})();
// Wraps whatwg-fetch with a function scope to hijack the global object
// "globalThis" that's going to be patched
(function(globalThis) {

var irrelevant = (function (exports) {

  var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof self !== 'undefined' && self) ||
    (typeof global !== 'undefined' && global);

  var support = {
    searchParams: 'URLSearchParams' in global,
    iterable: 'Symbol' in global && 'iterator' in Symbol,
    blob:
      'FileReader' in global &&
      'Blob' in global &&
      (function() {
        try {
          new Blob();
          return true
        } catch (e) {
          return false
        }
      })(),
    formData: 'FormData' in global,
    arrayBuffer: 'ArrayBuffer' in global
  };

  function isDataView(obj) {
    return obj && DataView.prototype.isPrototypeOf(obj)
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ];

    var isArrayBufferView =
      ArrayBuffer.isView ||
      function(obj) {
        return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
      };
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name);
    }
    if (/[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(name) || name === '') {
      throw new TypeError('Invalid character in header field name: "' + name + '"')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value);
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift();
        return {done: value === undefined, value: value}
      }
    };

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      };
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {};

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value);
      }, this);
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1]);
      }, this);
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name]);
      }, this);
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name);
    value = normalizeValue(value);
    var oldValue = this.map[name];
    this.map[name] = oldValue ? oldValue + ', ' + value : value;
  };

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)];
  };

  Headers.prototype.get = function(name) {
    name = normalizeName(name);
    return this.has(name) ? this.map[name] : null
  };

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  };

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value);
  };

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this);
      }
    }
  };

  Headers.prototype.keys = function() {
    var items = [];
    this.forEach(function(value, name) {
      items.push(name);
    });
    return iteratorFor(items)
  };

  Headers.prototype.values = function() {
    var items = [];
    this.forEach(function(value) {
      items.push(value);
    });
    return iteratorFor(items)
  };

  Headers.prototype.entries = function() {
    var items = [];
    this.forEach(function(value, name) {
      items.push([name, value]);
    });
    return iteratorFor(items)
  };

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true;
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result);
      };
      reader.onerror = function() {
        reject(reader.error);
      };
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsArrayBuffer(blob);
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsText(blob);
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf);
    var chars = new Array(view.length);

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i]);
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength);
      view.set(new Uint8Array(buf));
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false;

    this._initBody = function(body) {
      /*
        fetch-mock wraps the Response object in an ES6 Proxy to
        provide useful test harness features such as flush. However, on
        ES5 browsers without fetch or Proxy support pollyfills must be used;
        the proxy-pollyfill is unable to proxy an attribute unless it exists
        on the object before the Proxy is created. This change ensures
        Response.bodyUsed exists on the instance, while maintaining the
        semantic of setting Request.bodyUsed in the constructor before
        _initBody is called.
      */
      this.bodyUsed = this.bodyUsed;
      this._bodyInit = body;
      if (!body) {
        this._bodyText = '';
      } else if (typeof body === 'string') {
        this._bodyText = body;
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body;
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body;
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString();
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer);
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer]);
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body);
      } else {
        this._bodyText = body = Object.prototype.toString.call(body);
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8');
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type);
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
      }
    };

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this);
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      };

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          var isConsumed = consumed(this);
          if (isConsumed) {
            return isConsumed
          }
          if (ArrayBuffer.isView(this._bodyArrayBuffer)) {
            return Promise.resolve(
              this._bodyArrayBuffer.buffer.slice(
                this._bodyArrayBuffer.byteOffset,
                this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength
              )
            )
          } else {
            return Promise.resolve(this._bodyArrayBuffer)
          }
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      };
    }

    this.text = function() {
      var rejected = consumed(this);
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    };

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      };
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    };

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];

  function normalizeMethod(method) {
    var upcased = method.toUpperCase();
    return methods.indexOf(upcased) > -1 ? upcased : method
  }

  function Request(input, options) {
    if (!(this instanceof Request)) {
      throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.')
    }

    options = options || {};
    var body = options.body;

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url;
      this.credentials = input.credentials;
      if (!options.headers) {
        this.headers = new Headers(input.headers);
      }
      this.method = input.method;
      this.mode = input.mode;
      this.signal = input.signal;
      if (!body && input._bodyInit != null) {
        body = input._bodyInit;
        input.bodyUsed = true;
      }
    } else {
      this.url = String(input);
    }

    this.credentials = options.credentials || this.credentials || 'same-origin';
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers);
    }
    this.method = normalizeMethod(options.method || this.method || 'GET');
    this.mode = options.mode || this.mode || null;
    this.signal = options.signal || this.signal;
    this.referrer = null;

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body);

    if (this.method === 'GET' || this.method === 'HEAD') {
      if (options.cache === 'no-store' || options.cache === 'no-cache') {
        // Search for a '_' parameter in the query string
        var reParamSearch = /([?&])_=[^&]*/;
        if (reParamSearch.test(this.url)) {
          // If it already exists then set the value with the current time
          this.url = this.url.replace(reParamSearch, '$1_=' + new Date().getTime());
        } else {
          // Otherwise add a new '_' parameter to the end with the current time
          var reQueryString = /\?/;
          this.url += (reQueryString.test(this.url) ? '&' : '?') + '_=' + new Date().getTime();
        }
      }
    }
  }

  Request.prototype.clone = function() {
    return new Request(this, {body: this._bodyInit})
  };

  function decode(body) {
    var form = new FormData();
    body
      .trim()
      .split('&')
      .forEach(function(bytes) {
        if (bytes) {
          var split = bytes.split('=');
          var name = split.shift().replace(/\+/g, ' ');
          var value = split.join('=').replace(/\+/g, ' ');
          form.append(decodeURIComponent(name), decodeURIComponent(value));
        }
      });
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers();
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
    // Avoiding split via regex to work around a common IE11 bug with the core-js 3.6.0 regex polyfill
    // https://github.com/github/fetch/issues/748
    // https://github.com/zloirock/core-js/issues/751
    preProcessedHeaders
      .split('\r')
      .map(function(header) {
        return header.indexOf('\n') === 0 ? header.substr(1, header.length) : header
      })
      .forEach(function(line) {
        var parts = line.split(':');
        var key = parts.shift().trim();
        if (key) {
          var value = parts.join(':').trim();
          headers.append(key, value);
        }
      });
    return headers
  }

  Body.call(Request.prototype);

  function Response(bodyInit, options) {
    if (!(this instanceof Response)) {
      throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.')
    }
    if (!options) {
      options = {};
    }

    this.type = 'default';
    this.status = options.status === undefined ? 200 : options.status;
    this.ok = this.status >= 200 && this.status < 300;
    this.statusText = options.statusText === undefined ? '' : '' + options.statusText;
    this.headers = new Headers(options.headers);
    this.url = options.url || '';
    this._initBody(bodyInit);
  }

  Body.call(Response.prototype);

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  };

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''});
    response.type = 'error';
    return response
  };

  var redirectStatuses = [301, 302, 303, 307, 308];

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  };

  exports.DOMException = global.DOMException;
  try {
    new exports.DOMException();
  } catch (err) {
    exports.DOMException = function(message, name) {
      this.message = message;
      this.name = name;
      var error = Error(message);
      this.stack = error.stack;
    };
    exports.DOMException.prototype = Object.create(Error.prototype);
    exports.DOMException.prototype.constructor = exports.DOMException;
  }

  function fetch(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init);

      if (request.signal && request.signal.aborted) {
        return reject(new exports.DOMException('Aborted', 'AbortError'))
      }

      var xhr = new XMLHttpRequest();

      function abortXhr() {
        xhr.abort();
      }

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        };
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
        var body = 'response' in xhr ? xhr.response : xhr.responseText;
        setTimeout(function() {
          resolve(new Response(body, options));
        }, 0);
      };

      xhr.onerror = function() {
        setTimeout(function() {
          reject(new TypeError('Network request failed'));
        }, 0);
      };

      xhr.ontimeout = function() {
        setTimeout(function() {
          reject(new TypeError('Network request failed'));
        }, 0);
      };

      xhr.onabort = function() {
        setTimeout(function() {
          reject(new exports.DOMException('Aborted', 'AbortError'));
        }, 0);
      };

      function fixUrl(url) {
        try {
          return url === '' && global.location.href ? global.location.href : url
        } catch (e) {
          return url
        }
      }

      xhr.open(request.method, fixUrl(request.url), true);

      if (request.credentials === 'include') {
        xhr.withCredentials = true;
      } else if (request.credentials === 'omit') {
        xhr.withCredentials = false;
      }

      if ('responseType' in xhr) {
        if (support.blob) {
          xhr.responseType = 'blob';
        } else if (
          support.arrayBuffer &&
          request.headers.get('Content-Type') &&
          request.headers.get('Content-Type').indexOf('application/octet-stream') !== -1
        ) {
          xhr.responseType = 'arraybuffer';
        }
      }

      if (init && typeof init.headers === 'object' && !(init.headers instanceof Headers)) {
        Object.getOwnPropertyNames(init.headers).forEach(function(name) {
          xhr.setRequestHeader(name, normalizeValue(init.headers[name]));
        });
      } else {
        request.headers.forEach(function(value, name) {
          xhr.setRequestHeader(name, value);
        });
      }

      if (request.signal) {
        request.signal.addEventListener('abort', abortXhr);

        xhr.onreadystatechange = function() {
          // DONE (success or failure)
          if (xhr.readyState === 4) {
            request.signal.removeEventListener('abort', abortXhr);
          }
        };
      }

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
    })
  }

  fetch.polyfill = true;

  if (!global.fetch) {
    global.fetch = fetch;
    global.Headers = Headers;
    global.Request = Request;
    global.Response = Response;
  }

  exports.Headers = Headers;
  exports.Request = Request;
  exports.Response = Response;
  exports.fetch = fetch;

  return exports;

})({});
})(__globalThis__);
// This is a ponyfill, so...
__globalThis__.fetch.ponyfill = true;
delete __globalThis__.fetch.polyfill;
// Choose between native implementation (__global__) or custom implementation (__globalThis__)
var ctx = __global__.fetch ? __global__ : __globalThis__;
exports = ctx.fetch // To enable: import fetch from 'cross-fetch'
exports["default"] = ctx.fetch // For TypeScript consumers without esModuleInterop.
exports.fetch = ctx.fetch // To enable: import {fetch} from 'cross-fetch'
exports.Headers = ctx.Headers
exports.Request = ctx.Request
exports.Response = ctx.Response
module.exports = exports


/***/ }),

/***/ 25643:
/***/ (function(module) {

module.exports = false;



/***/ }),

/***/ 99960:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Doctype = exports.CDATA = exports.Tag = exports.Style = exports.Script = exports.Comment = exports.Directive = exports.Text = exports.Root = exports.isTag = exports.ElementType = void 0;
/** Types of elements found in htmlparser2's DOM */
var ElementType;
(function (ElementType) {
    /** Type for the root element of a document */
    ElementType["Root"] = "root";
    /** Type for Text */
    ElementType["Text"] = "text";
    /** Type for <? ... ?> */
    ElementType["Directive"] = "directive";
    /** Type for <!-- ... --> */
    ElementType["Comment"] = "comment";
    /** Type for <script> tags */
    ElementType["Script"] = "script";
    /** Type for <style> tags */
    ElementType["Style"] = "style";
    /** Type for Any tag */
    ElementType["Tag"] = "tag";
    /** Type for <![CDATA[ ... ]]> */
    ElementType["CDATA"] = "cdata";
    /** Type for <!doctype ...> */
    ElementType["Doctype"] = "doctype";
})(ElementType = exports.ElementType || (exports.ElementType = {}));
/**
 * Tests whether an element is a tag or not.
 *
 * @param elem Element to test
 */
function isTag(elem) {
    return (elem.type === ElementType.Tag ||
        elem.type === ElementType.Script ||
        elem.type === ElementType.Style);
}
exports.isTag = isTag;
// Exports for backwards compatibility
/** Type for the root element of a document */
exports.Root = ElementType.Root;
/** Type for Text */
exports.Text = ElementType.Text;
/** Type for <? ... ?> */
exports.Directive = ElementType.Directive;
/** Type for <!-- ... --> */
exports.Comment = ElementType.Comment;
/** Type for <script> tags */
exports.Script = ElementType.Script;
/** Type for <style> tags */
exports.Style = ElementType.Style;
/** Type for Any tag */
exports.Tag = ElementType.Tag;
/** Type for <![CDATA[ ... ]]> */
exports.CDATA = ElementType.CDATA;
/** Type for <!doctype ...> */
exports.Doctype = ElementType.Doctype;


/***/ }),

/***/ 47915:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.DomHandler = void 0;
var domelementtype_1 = __webpack_require__(99960);
var node_js_1 = __webpack_require__(97790);
__exportStar(__webpack_require__(97790), exports);
// Default options
var defaultOpts = {
    withStartIndices: false,
    withEndIndices: false,
    xmlMode: false,
};
var DomHandler = /** @class */ (function () {
    /**
     * @param callback Called once parsing has completed.
     * @param options Settings for the handler.
     * @param elementCB Callback whenever a tag is closed.
     */
    function DomHandler(callback, options, elementCB) {
        /** The elements of the DOM */
        this.dom = [];
        /** The root element for the DOM */
        this.root = new node_js_1.Document(this.dom);
        /** Indicated whether parsing has been completed. */
        this.done = false;
        /** Stack of open tags. */
        this.tagStack = [this.root];
        /** A data node that is still being written to. */
        this.lastNode = null;
        /** Reference to the parser instance. Used for location information. */
        this.parser = null;
        // Make it possible to skip arguments, for backwards-compatibility
        if (typeof options === "function") {
            elementCB = options;
            options = defaultOpts;
        }
        if (typeof callback === "object") {
            options = callback;
            callback = undefined;
        }
        this.callback = callback !== null && callback !== void 0 ? callback : null;
        this.options = options !== null && options !== void 0 ? options : defaultOpts;
        this.elementCB = elementCB !== null && elementCB !== void 0 ? elementCB : null;
    }
    DomHandler.prototype.onparserinit = function (parser) {
        this.parser = parser;
    };
    // Resets the handler back to starting state
    DomHandler.prototype.onreset = function () {
        this.dom = [];
        this.root = new node_js_1.Document(this.dom);
        this.done = false;
        this.tagStack = [this.root];
        this.lastNode = null;
        this.parser = null;
    };
    // Signals the handler that parsing is done
    DomHandler.prototype.onend = function () {
        if (this.done)
            return;
        this.done = true;
        this.parser = null;
        this.handleCallback(null);
    };
    DomHandler.prototype.onerror = function (error) {
        this.handleCallback(error);
    };
    DomHandler.prototype.onclosetag = function () {
        this.lastNode = null;
        var elem = this.tagStack.pop();
        if (this.options.withEndIndices) {
            elem.endIndex = this.parser.endIndex;
        }
        if (this.elementCB)
            this.elementCB(elem);
    };
    DomHandler.prototype.onopentag = function (name, attribs) {
        var type = this.options.xmlMode ? domelementtype_1.ElementType.Tag : undefined;
        var element = new node_js_1.Element(name, attribs, undefined, type);
        this.addNode(element);
        this.tagStack.push(element);
    };
    DomHandler.prototype.ontext = function (data) {
        var lastNode = this.lastNode;
        if (lastNode && lastNode.type === domelementtype_1.ElementType.Text) {
            lastNode.data += data;
            if (this.options.withEndIndices) {
                lastNode.endIndex = this.parser.endIndex;
            }
        }
        else {
            var node = new node_js_1.Text(data);
            this.addNode(node);
            this.lastNode = node;
        }
    };
    DomHandler.prototype.oncomment = function (data) {
        if (this.lastNode && this.lastNode.type === domelementtype_1.ElementType.Comment) {
            this.lastNode.data += data;
            return;
        }
        var node = new node_js_1.Comment(data);
        this.addNode(node);
        this.lastNode = node;
    };
    DomHandler.prototype.oncommentend = function () {
        this.lastNode = null;
    };
    DomHandler.prototype.oncdatastart = function () {
        var text = new node_js_1.Text("");
        var node = new node_js_1.CDATA([text]);
        this.addNode(node);
        text.parent = node;
        this.lastNode = text;
    };
    DomHandler.prototype.oncdataend = function () {
        this.lastNode = null;
    };
    DomHandler.prototype.onprocessinginstruction = function (name, data) {
        var node = new node_js_1.ProcessingInstruction(name, data);
        this.addNode(node);
    };
    DomHandler.prototype.handleCallback = function (error) {
        if (typeof this.callback === "function") {
            this.callback(error, this.dom);
        }
        else if (error) {
            throw error;
        }
    };
    DomHandler.prototype.addNode = function (node) {
        var parent = this.tagStack[this.tagStack.length - 1];
        var previousSibling = parent.children[parent.children.length - 1];
        if (this.options.withStartIndices) {
            node.startIndex = this.parser.startIndex;
        }
        if (this.options.withEndIndices) {
            node.endIndex = this.parser.endIndex;
        }
        parent.children.push(node);
        if (previousSibling) {
            node.prev = previousSibling;
            previousSibling.next = node;
        }
        node.parent = parent;
        this.lastNode = null;
    };
    return DomHandler;
}());
exports.DomHandler = DomHandler;
exports["default"] = DomHandler;


/***/ }),

/***/ 97790:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.cloneNode = exports.hasChildren = exports.isDocument = exports.isDirective = exports.isComment = exports.isText = exports.isCDATA = exports.isTag = exports.Element = exports.Document = exports.CDATA = exports.NodeWithChildren = exports.ProcessingInstruction = exports.Comment = exports.Text = exports.DataNode = exports.Node = void 0;
var domelementtype_1 = __webpack_require__(99960);
/**
 * This object will be used as the prototype for Nodes when creating a
 * DOM-Level-1-compliant structure.
 */
var Node = /** @class */ (function () {
    function Node() {
        /** Parent of the node */
        this.parent = null;
        /** Previous sibling */
        this.prev = null;
        /** Next sibling */
        this.next = null;
        /** The start index of the node. Requires `withStartIndices` on the handler to be `true. */
        this.startIndex = null;
        /** The end index of the node. Requires `withEndIndices` on the handler to be `true. */
        this.endIndex = null;
    }
    Object.defineProperty(Node.prototype, "parentNode", {
        // Read-write aliases for properties
        /**
         * Same as {@link parent}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function () {
            return this.parent;
        },
        set: function (parent) {
            this.parent = parent;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Node.prototype, "previousSibling", {
        /**
         * Same as {@link prev}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function () {
            return this.prev;
        },
        set: function (prev) {
            this.prev = prev;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Node.prototype, "nextSibling", {
        /**
         * Same as {@link next}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function () {
            return this.next;
        },
        set: function (next) {
            this.next = next;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Clone this node, and optionally its children.
     *
     * @param recursive Clone child nodes as well.
     * @returns A clone of the node.
     */
    Node.prototype.cloneNode = function (recursive) {
        if (recursive === void 0) { recursive = false; }
        return cloneNode(this, recursive);
    };
    return Node;
}());
exports.Node = Node;
/**
 * A node that contains some data.
 */
var DataNode = /** @class */ (function (_super) {
    __extends(DataNode, _super);
    /**
     * @param data The content of the data node
     */
    function DataNode(data) {
        var _this = _super.call(this) || this;
        _this.data = data;
        return _this;
    }
    Object.defineProperty(DataNode.prototype, "nodeValue", {
        /**
         * Same as {@link data}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function () {
            return this.data;
        },
        set: function (data) {
            this.data = data;
        },
        enumerable: false,
        configurable: true
    });
    return DataNode;
}(Node));
exports.DataNode = DataNode;
/**
 * Text within the document.
 */
var Text = /** @class */ (function (_super) {
    __extends(Text, _super);
    function Text() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = domelementtype_1.ElementType.Text;
        return _this;
    }
    Object.defineProperty(Text.prototype, "nodeType", {
        get: function () {
            return 3;
        },
        enumerable: false,
        configurable: true
    });
    return Text;
}(DataNode));
exports.Text = Text;
/**
 * Comments within the document.
 */
var Comment = /** @class */ (function (_super) {
    __extends(Comment, _super);
    function Comment() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = domelementtype_1.ElementType.Comment;
        return _this;
    }
    Object.defineProperty(Comment.prototype, "nodeType", {
        get: function () {
            return 8;
        },
        enumerable: false,
        configurable: true
    });
    return Comment;
}(DataNode));
exports.Comment = Comment;
/**
 * Processing instructions, including doc types.
 */
var ProcessingInstruction = /** @class */ (function (_super) {
    __extends(ProcessingInstruction, _super);
    function ProcessingInstruction(name, data) {
        var _this = _super.call(this, data) || this;
        _this.name = name;
        _this.type = domelementtype_1.ElementType.Directive;
        return _this;
    }
    Object.defineProperty(ProcessingInstruction.prototype, "nodeType", {
        get: function () {
            return 1;
        },
        enumerable: false,
        configurable: true
    });
    return ProcessingInstruction;
}(DataNode));
exports.ProcessingInstruction = ProcessingInstruction;
/**
 * A `Node` that can have children.
 */
var NodeWithChildren = /** @class */ (function (_super) {
    __extends(NodeWithChildren, _super);
    /**
     * @param children Children of the node. Only certain node types can have children.
     */
    function NodeWithChildren(children) {
        var _this = _super.call(this) || this;
        _this.children = children;
        return _this;
    }
    Object.defineProperty(NodeWithChildren.prototype, "firstChild", {
        // Aliases
        /** First child of the node. */
        get: function () {
            var _a;
            return (_a = this.children[0]) !== null && _a !== void 0 ? _a : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NodeWithChildren.prototype, "lastChild", {
        /** Last child of the node. */
        get: function () {
            return this.children.length > 0
                ? this.children[this.children.length - 1]
                : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NodeWithChildren.prototype, "childNodes", {
        /**
         * Same as {@link children}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function () {
            return this.children;
        },
        set: function (children) {
            this.children = children;
        },
        enumerable: false,
        configurable: true
    });
    return NodeWithChildren;
}(Node));
exports.NodeWithChildren = NodeWithChildren;
var CDATA = /** @class */ (function (_super) {
    __extends(CDATA, _super);
    function CDATA() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = domelementtype_1.ElementType.CDATA;
        return _this;
    }
    Object.defineProperty(CDATA.prototype, "nodeType", {
        get: function () {
            return 4;
        },
        enumerable: false,
        configurable: true
    });
    return CDATA;
}(NodeWithChildren));
exports.CDATA = CDATA;
/**
 * The root node of the document.
 */
var Document = /** @class */ (function (_super) {
    __extends(Document, _super);
    function Document() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = domelementtype_1.ElementType.Root;
        return _this;
    }
    Object.defineProperty(Document.prototype, "nodeType", {
        get: function () {
            return 9;
        },
        enumerable: false,
        configurable: true
    });
    return Document;
}(NodeWithChildren));
exports.Document = Document;
/**
 * An element within the DOM.
 */
var Element = /** @class */ (function (_super) {
    __extends(Element, _super);
    /**
     * @param name Name of the tag, eg. `div`, `span`.
     * @param attribs Object mapping attribute names to attribute values.
     * @param children Children of the node.
     */
    function Element(name, attribs, children, type) {
        if (children === void 0) { children = []; }
        if (type === void 0) { type = name === "script"
            ? domelementtype_1.ElementType.Script
            : name === "style"
                ? domelementtype_1.ElementType.Style
                : domelementtype_1.ElementType.Tag; }
        var _this = _super.call(this, children) || this;
        _this.name = name;
        _this.attribs = attribs;
        _this.type = type;
        return _this;
    }
    Object.defineProperty(Element.prototype, "nodeType", {
        get: function () {
            return 1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Element.prototype, "tagName", {
        // DOM Level 1 aliases
        /**
         * Same as {@link name}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function () {
            return this.name;
        },
        set: function (name) {
            this.name = name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Element.prototype, "attributes", {
        get: function () {
            var _this = this;
            return Object.keys(this.attribs).map(function (name) {
                var _a, _b;
                return ({
                    name: name,
                    value: _this.attribs[name],
                    namespace: (_a = _this["x-attribsNamespace"]) === null || _a === void 0 ? void 0 : _a[name],
                    prefix: (_b = _this["x-attribsPrefix"]) === null || _b === void 0 ? void 0 : _b[name],
                });
            });
        },
        enumerable: false,
        configurable: true
    });
    return Element;
}(NodeWithChildren));
exports.Element = Element;
/**
 * @param node Node to check.
 * @returns `true` if the node is a `Element`, `false` otherwise.
 */
function isTag(node) {
    return (0, domelementtype_1.isTag)(node);
}
exports.isTag = isTag;
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `CDATA`, `false` otherwise.
 */
function isCDATA(node) {
    return node.type === domelementtype_1.ElementType.CDATA;
}
exports.isCDATA = isCDATA;
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `Text`, `false` otherwise.
 */
function isText(node) {
    return node.type === domelementtype_1.ElementType.Text;
}
exports.isText = isText;
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `Comment`, `false` otherwise.
 */
function isComment(node) {
    return node.type === domelementtype_1.ElementType.Comment;
}
exports.isComment = isComment;
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `ProcessingInstruction`, `false` otherwise.
 */
function isDirective(node) {
    return node.type === domelementtype_1.ElementType.Directive;
}
exports.isDirective = isDirective;
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `ProcessingInstruction`, `false` otherwise.
 */
function isDocument(node) {
    return node.type === domelementtype_1.ElementType.Root;
}
exports.isDocument = isDocument;
/**
 * @param node Node to check.
 * @returns `true` if the node has children, `false` otherwise.
 */
function hasChildren(node) {
    return Object.prototype.hasOwnProperty.call(node, "children");
}
exports.hasChildren = hasChildren;
/**
 * Clone a node, and optionally its children.
 *
 * @param recursive Clone child nodes as well.
 * @returns A clone of the node.
 */
function cloneNode(node, recursive) {
    if (recursive === void 0) { recursive = false; }
    var result;
    if (isText(node)) {
        result = new Text(node.data);
    }
    else if (isComment(node)) {
        result = new Comment(node.data);
    }
    else if (isTag(node)) {
        var children = recursive ? cloneChildren(node.children) : [];
        var clone_1 = new Element(node.name, __assign({}, node.attribs), children);
        children.forEach(function (child) { return (child.parent = clone_1); });
        if (node.namespace != null) {
            clone_1.namespace = node.namespace;
        }
        if (node["x-attribsNamespace"]) {
            clone_1["x-attribsNamespace"] = __assign({}, node["x-attribsNamespace"]);
        }
        if (node["x-attribsPrefix"]) {
            clone_1["x-attribsPrefix"] = __assign({}, node["x-attribsPrefix"]);
        }
        result = clone_1;
    }
    else if (isCDATA(node)) {
        var children = recursive ? cloneChildren(node.children) : [];
        var clone_2 = new CDATA(children);
        children.forEach(function (child) { return (child.parent = clone_2); });
        result = clone_2;
    }
    else if (isDocument(node)) {
        var children = recursive ? cloneChildren(node.children) : [];
        var clone_3 = new Document(children);
        children.forEach(function (child) { return (child.parent = clone_3); });
        if (node["x-mode"]) {
            clone_3["x-mode"] = node["x-mode"];
        }
        result = clone_3;
    }
    else if (isDirective(node)) {
        var instruction = new ProcessingInstruction(node.name, node.data);
        if (node["x-name"] != null) {
            instruction["x-name"] = node["x-name"];
            instruction["x-publicId"] = node["x-publicId"];
            instruction["x-systemId"] = node["x-systemId"];
        }
        result = instruction;
    }
    else {
        throw new Error("Not implemented yet: ".concat(node.type));
    }
    result.startIndex = node.startIndex;
    result.endIndex = node.endIndex;
    if (node.sourceCodeLocation != null) {
        result.sourceCodeLocation = node.sourceCodeLocation;
    }
    return result;
}
exports.cloneNode = cloneNode;
function cloneChildren(childs) {
    var children = childs.map(function (child) { return cloneNode(child, true); });
    for (var i = 1; i < children.length; i++) {
        children[i].prev = children[i - 1];
        children[i - 1].next = children[i];
    }
    return children;
}


/***/ }),

/***/ 27856:
/***/ (function(module) {

/*! @license DOMPurify 2.5.8 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/2.5.8/LICENSE */

(function (global, factory) {
   true ? module.exports = factory() :
  0;
})(this, (function () { 'use strict';

  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }
  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
    return _setPrototypeOf(o, p);
  }
  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }
  function _construct(Parent, args, Class) {
    if (_isNativeReflectConstruct()) {
      _construct = Reflect.construct;
    } else {
      _construct = function _construct(Parent, args, Class) {
        var a = [null];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) _setPrototypeOf(instance, Class.prototype);
        return instance;
      };
    }
    return _construct.apply(null, arguments);
  }
  function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
  }
  function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
  }
  function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
  }
  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }
  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
    return arr2;
  }
  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var hasOwnProperty = Object.hasOwnProperty,
    setPrototypeOf = Object.setPrototypeOf,
    isFrozen = Object.isFrozen,
    getPrototypeOf = Object.getPrototypeOf,
    getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
  var freeze = Object.freeze,
    seal = Object.seal,
    create = Object.create; // eslint-disable-line import/no-mutable-exports
  var _ref = typeof Reflect !== 'undefined' && Reflect,
    apply = _ref.apply,
    construct = _ref.construct;
  if (!apply) {
    apply = function apply(fun, thisValue, args) {
      return fun.apply(thisValue, args);
    };
  }
  if (!freeze) {
    freeze = function freeze(x) {
      return x;
    };
  }
  if (!seal) {
    seal = function seal(x) {
      return x;
    };
  }
  if (!construct) {
    construct = function construct(Func, args) {
      return _construct(Func, _toConsumableArray(args));
    };
  }
  var arrayForEach = unapply(Array.prototype.forEach);
  var arrayPop = unapply(Array.prototype.pop);
  var arrayPush = unapply(Array.prototype.push);
  var stringToLowerCase = unapply(String.prototype.toLowerCase);
  var stringToString = unapply(String.prototype.toString);
  var stringMatch = unapply(String.prototype.match);
  var stringReplace = unapply(String.prototype.replace);
  var stringIndexOf = unapply(String.prototype.indexOf);
  var stringTrim = unapply(String.prototype.trim);
  var regExpTest = unapply(RegExp.prototype.test);
  var typeErrorCreate = unconstruct(TypeError);
  function unapply(func) {
    return function (thisArg) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      return apply(func, thisArg, args);
    };
  }
  function unconstruct(func) {
    return function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      return construct(func, args);
    };
  }

  /* Add properties to a lookup table */
  function addToSet(set, array, transformCaseFunc) {
    var _transformCaseFunc;
    transformCaseFunc = (_transformCaseFunc = transformCaseFunc) !== null && _transformCaseFunc !== void 0 ? _transformCaseFunc : stringToLowerCase;
    if (setPrototypeOf) {
      // Make 'in' and truthy checks like Boolean(set.constructor)
      // independent of any properties defined on Object.prototype.
      // Prevent prototype setters from intercepting set as a this value.
      setPrototypeOf(set, null);
    }
    var l = array.length;
    while (l--) {
      var element = array[l];
      if (typeof element === 'string') {
        var lcElement = transformCaseFunc(element);
        if (lcElement !== element) {
          // Config presets (e.g. tags.js, attrs.js) are immutable.
          if (!isFrozen(array)) {
            array[l] = lcElement;
          }
          element = lcElement;
        }
      }
      set[element] = true;
    }
    return set;
  }

  /* Shallow clone an object */
  function clone(object) {
    var newObject = create(null);
    var property;
    for (property in object) {
      if (apply(hasOwnProperty, object, [property]) === true) {
        newObject[property] = object[property];
      }
    }
    return newObject;
  }

  /* IE10 doesn't support __lookupGetter__ so lets'
   * simulate it. It also automatically checks
   * if the prop is function or getter and behaves
   * accordingly. */
  function lookupGetter(object, prop) {
    while (object !== null) {
      var desc = getOwnPropertyDescriptor(object, prop);
      if (desc) {
        if (desc.get) {
          return unapply(desc.get);
        }
        if (typeof desc.value === 'function') {
          return unapply(desc.value);
        }
      }
      object = getPrototypeOf(object);
    }
    function fallbackValue(element) {
      console.warn('fallback value for', element);
      return null;
    }
    return fallbackValue;
  }

  var html$1 = freeze(['a', 'abbr', 'acronym', 'address', 'area', 'article', 'aside', 'audio', 'b', 'bdi', 'bdo', 'big', 'blink', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'center', 'cite', 'code', 'col', 'colgroup', 'content', 'data', 'datalist', 'dd', 'decorator', 'del', 'details', 'dfn', 'dialog', 'dir', 'div', 'dl', 'dt', 'element', 'em', 'fieldset', 'figcaption', 'figure', 'font', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'img', 'input', 'ins', 'kbd', 'label', 'legend', 'li', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meter', 'nav', 'nobr', 'ol', 'optgroup', 'option', 'output', 'p', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'section', 'select', 'shadow', 'small', 'source', 'spacer', 'span', 'strike', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'time', 'tr', 'track', 'tt', 'u', 'ul', 'var', 'video', 'wbr']);

  // SVG
  var svg$1 = freeze(['svg', 'a', 'altglyph', 'altglyphdef', 'altglyphitem', 'animatecolor', 'animatemotion', 'animatetransform', 'circle', 'clippath', 'defs', 'desc', 'ellipse', 'filter', 'font', 'g', 'glyph', 'glyphref', 'hkern', 'image', 'line', 'lineargradient', 'marker', 'mask', 'metadata', 'mpath', 'path', 'pattern', 'polygon', 'polyline', 'radialgradient', 'rect', 'stop', 'style', 'switch', 'symbol', 'text', 'textpath', 'title', 'tref', 'tspan', 'view', 'vkern']);
  var svgFilters = freeze(['feBlend', 'feColorMatrix', 'feComponentTransfer', 'feComposite', 'feConvolveMatrix', 'feDiffuseLighting', 'feDisplacementMap', 'feDistantLight', 'feFlood', 'feFuncA', 'feFuncB', 'feFuncG', 'feFuncR', 'feGaussianBlur', 'feImage', 'feMerge', 'feMergeNode', 'feMorphology', 'feOffset', 'fePointLight', 'feSpecularLighting', 'feSpotLight', 'feTile', 'feTurbulence']);

  // List of SVG elements that are disallowed by default.
  // We still need to know them so that we can do namespace
  // checks properly in case one wants to add them to
  // allow-list.
  var svgDisallowed = freeze(['animate', 'color-profile', 'cursor', 'discard', 'fedropshadow', 'font-face', 'font-face-format', 'font-face-name', 'font-face-src', 'font-face-uri', 'foreignobject', 'hatch', 'hatchpath', 'mesh', 'meshgradient', 'meshpatch', 'meshrow', 'missing-glyph', 'script', 'set', 'solidcolor', 'unknown', 'use']);
  var mathMl$1 = freeze(['math', 'menclose', 'merror', 'mfenced', 'mfrac', 'mglyph', 'mi', 'mlabeledtr', 'mmultiscripts', 'mn', 'mo', 'mover', 'mpadded', 'mphantom', 'mroot', 'mrow', 'ms', 'mspace', 'msqrt', 'mstyle', 'msub', 'msup', 'msubsup', 'mtable', 'mtd', 'mtext', 'mtr', 'munder', 'munderover']);

  // Similarly to SVG, we want to know all MathML elements,
  // even those that we disallow by default.
  var mathMlDisallowed = freeze(['maction', 'maligngroup', 'malignmark', 'mlongdiv', 'mscarries', 'mscarry', 'msgroup', 'mstack', 'msline', 'msrow', 'semantics', 'annotation', 'annotation-xml', 'mprescripts', 'none']);
  var text = freeze(['#text']);

  var html = freeze(['accept', 'action', 'align', 'alt', 'autocapitalize', 'autocomplete', 'autopictureinpicture', 'autoplay', 'background', 'bgcolor', 'border', 'capture', 'cellpadding', 'cellspacing', 'checked', 'cite', 'class', 'clear', 'color', 'cols', 'colspan', 'controls', 'controlslist', 'coords', 'crossorigin', 'datetime', 'decoding', 'default', 'dir', 'disabled', 'disablepictureinpicture', 'disableremoteplayback', 'download', 'draggable', 'enctype', 'enterkeyhint', 'face', 'for', 'headers', 'height', 'hidden', 'high', 'href', 'hreflang', 'id', 'inputmode', 'integrity', 'ismap', 'kind', 'label', 'lang', 'list', 'loading', 'loop', 'low', 'max', 'maxlength', 'media', 'method', 'min', 'minlength', 'multiple', 'muted', 'name', 'nonce', 'noshade', 'novalidate', 'nowrap', 'open', 'optimum', 'pattern', 'placeholder', 'playsinline', 'poster', 'preload', 'pubdate', 'radiogroup', 'readonly', 'rel', 'required', 'rev', 'reversed', 'role', 'rows', 'rowspan', 'spellcheck', 'scope', 'selected', 'shape', 'size', 'sizes', 'span', 'srclang', 'start', 'src', 'srcset', 'step', 'style', 'summary', 'tabindex', 'title', 'translate', 'type', 'usemap', 'valign', 'value', 'width', 'xmlns', 'slot']);
  var svg = freeze(['accent-height', 'accumulate', 'additive', 'alignment-baseline', 'ascent', 'attributename', 'attributetype', 'azimuth', 'basefrequency', 'baseline-shift', 'begin', 'bias', 'by', 'class', 'clip', 'clippathunits', 'clip-path', 'clip-rule', 'color', 'color-interpolation', 'color-interpolation-filters', 'color-profile', 'color-rendering', 'cx', 'cy', 'd', 'dx', 'dy', 'diffuseconstant', 'direction', 'display', 'divisor', 'dur', 'edgemode', 'elevation', 'end', 'fill', 'fill-opacity', 'fill-rule', 'filter', 'filterunits', 'flood-color', 'flood-opacity', 'font-family', 'font-size', 'font-size-adjust', 'font-stretch', 'font-style', 'font-variant', 'font-weight', 'fx', 'fy', 'g1', 'g2', 'glyph-name', 'glyphref', 'gradientunits', 'gradienttransform', 'height', 'href', 'id', 'image-rendering', 'in', 'in2', 'k', 'k1', 'k2', 'k3', 'k4', 'kerning', 'keypoints', 'keysplines', 'keytimes', 'lang', 'lengthadjust', 'letter-spacing', 'kernelmatrix', 'kernelunitlength', 'lighting-color', 'local', 'marker-end', 'marker-mid', 'marker-start', 'markerheight', 'markerunits', 'markerwidth', 'maskcontentunits', 'maskunits', 'max', 'mask', 'media', 'method', 'mode', 'min', 'name', 'numoctaves', 'offset', 'operator', 'opacity', 'order', 'orient', 'orientation', 'origin', 'overflow', 'paint-order', 'path', 'pathlength', 'patterncontentunits', 'patterntransform', 'patternunits', 'points', 'preservealpha', 'preserveaspectratio', 'primitiveunits', 'r', 'rx', 'ry', 'radius', 'refx', 'refy', 'repeatcount', 'repeatdur', 'restart', 'result', 'rotate', 'scale', 'seed', 'shape-rendering', 'specularconstant', 'specularexponent', 'spreadmethod', 'startoffset', 'stddeviation', 'stitchtiles', 'stop-color', 'stop-opacity', 'stroke-dasharray', 'stroke-dashoffset', 'stroke-linecap', 'stroke-linejoin', 'stroke-miterlimit', 'stroke-opacity', 'stroke', 'stroke-width', 'style', 'surfacescale', 'systemlanguage', 'tabindex', 'targetx', 'targety', 'transform', 'transform-origin', 'text-anchor', 'text-decoration', 'text-rendering', 'textlength', 'type', 'u1', 'u2', 'unicode', 'values', 'viewbox', 'visibility', 'version', 'vert-adv-y', 'vert-origin-x', 'vert-origin-y', 'width', 'word-spacing', 'wrap', 'writing-mode', 'xchannelselector', 'ychannelselector', 'x', 'x1', 'x2', 'xmlns', 'y', 'y1', 'y2', 'z', 'zoomandpan']);
  var mathMl = freeze(['accent', 'accentunder', 'align', 'bevelled', 'close', 'columnsalign', 'columnlines', 'columnspan', 'denomalign', 'depth', 'dir', 'display', 'displaystyle', 'encoding', 'fence', 'frame', 'height', 'href', 'id', 'largeop', 'length', 'linethickness', 'lspace', 'lquote', 'mathbackground', 'mathcolor', 'mathsize', 'mathvariant', 'maxsize', 'minsize', 'movablelimits', 'notation', 'numalign', 'open', 'rowalign', 'rowlines', 'rowspacing', 'rowspan', 'rspace', 'rquote', 'scriptlevel', 'scriptminsize', 'scriptsizemultiplier', 'selection', 'separator', 'separators', 'stretchy', 'subscriptshift', 'supscriptshift', 'symmetric', 'voffset', 'width', 'xmlns']);
  var xml = freeze(['xlink:href', 'xml:id', 'xlink:title', 'xml:space', 'xmlns:xlink']);

  // eslint-disable-next-line unicorn/better-regex
  var MUSTACHE_EXPR = seal(/\{\{[\w\W]*|[\w\W]*\}\}/gm); // Specify template detection regex for SAFE_FOR_TEMPLATES mode
  var ERB_EXPR = seal(/<%[\w\W]*|[\w\W]*%>/gm);
  var TMPLIT_EXPR = seal(/\${[\w\W]*}/gm);
  var DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]+$/); // eslint-disable-line no-useless-escape
  var ARIA_ATTR = seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape
  var IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
  );
  var IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
  var ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g // eslint-disable-line no-control-regex
  );
  var DOCTYPE_NAME = seal(/^html$/i);
  var CUSTOM_ELEMENT = seal(/^[a-z][.\w]*(-[.\w]+)+$/i);

  var getGlobal = function getGlobal() {
    return typeof window === 'undefined' ? null : window;
  };

  /**
   * Creates a no-op policy for internal use only.
   * Don't export this function outside this module!
   * @param {?TrustedTypePolicyFactory} trustedTypes The policy factory.
   * @param {Document} document The document object (to determine policy name suffix)
   * @return {?TrustedTypePolicy} The policy created (or null, if Trusted Types
   * are not supported).
   */
  var _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, document) {
    if (_typeof(trustedTypes) !== 'object' || typeof trustedTypes.createPolicy !== 'function') {
      return null;
    }

    // Allow the callers to control the unique policy name
    // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
    // Policy creation with duplicate names throws in Trusted Types.
    var suffix = null;
    var ATTR_NAME = 'data-tt-policy-suffix';
    if (document.currentScript && document.currentScript.hasAttribute(ATTR_NAME)) {
      suffix = document.currentScript.getAttribute(ATTR_NAME);
    }
    var policyName = 'dompurify' + (suffix ? '#' + suffix : '');
    try {
      return trustedTypes.createPolicy(policyName, {
        createHTML: function createHTML(html) {
          return html;
        },
        createScriptURL: function createScriptURL(scriptUrl) {
          return scriptUrl;
        }
      });
    } catch (_) {
      // Policy creation failed (most likely another DOMPurify script has
      // already run). Skip creating the policy, as this will only cause errors
      // if TT are enforced.
      console.warn('TrustedTypes policy ' + policyName + ' could not be created.');
      return null;
    }
  };
  function createDOMPurify() {
    var window = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getGlobal();
    var DOMPurify = function DOMPurify(root) {
      return createDOMPurify(root);
    };

    /**
     * Version label, exposed for easier checks
     * if DOMPurify is up to date or not
     */
    DOMPurify.version = '2.5.8';

    /**
     * Array of elements that DOMPurify removed during sanitation.
     * Empty if nothing was removed.
     */
    DOMPurify.removed = [];
    if (!window || !window.document || window.document.nodeType !== 9) {
      // Not running in a browser, provide a factory function
      // so that you can pass your own Window
      DOMPurify.isSupported = false;
      return DOMPurify;
    }
    var originalDocument = window.document;
    var document = window.document;
    var DocumentFragment = window.DocumentFragment,
      HTMLTemplateElement = window.HTMLTemplateElement,
      Node = window.Node,
      Element = window.Element,
      NodeFilter = window.NodeFilter,
      _window$NamedNodeMap = window.NamedNodeMap,
      NamedNodeMap = _window$NamedNodeMap === void 0 ? window.NamedNodeMap || window.MozNamedAttrMap : _window$NamedNodeMap,
      HTMLFormElement = window.HTMLFormElement,
      DOMParser = window.DOMParser,
      trustedTypes = window.trustedTypes;
    var ElementPrototype = Element.prototype;
    var cloneNode = lookupGetter(ElementPrototype, 'cloneNode');
    var getNextSibling = lookupGetter(ElementPrototype, 'nextSibling');
    var getChildNodes = lookupGetter(ElementPrototype, 'childNodes');
    var getParentNode = lookupGetter(ElementPrototype, 'parentNode');

    // As per issue #47, the web-components registry is inherited by a
    // new document created via createHTMLDocument. As per the spec
    // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
    // a new empty registry is used when creating a template contents owner
    // document, so we use that as our parent document to ensure nothing
    // is inherited.
    if (typeof HTMLTemplateElement === 'function') {
      var template = document.createElement('template');
      if (template.content && template.content.ownerDocument) {
        document = template.content.ownerDocument;
      }
    }
    var trustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, originalDocument);
    var emptyHTML = trustedTypesPolicy ? trustedTypesPolicy.createHTML('') : '';
    var _document = document,
      implementation = _document.implementation,
      createNodeIterator = _document.createNodeIterator,
      createDocumentFragment = _document.createDocumentFragment,
      getElementsByTagName = _document.getElementsByTagName;
    var importNode = originalDocument.importNode;
    var documentMode = {};
    try {
      documentMode = clone(document).documentMode ? document.documentMode : {};
    } catch (_) {}
    var hooks = {};

    /**
     * Expose whether this browser supports running the full DOMPurify.
     */
    DOMPurify.isSupported = typeof getParentNode === 'function' && implementation && implementation.createHTMLDocument !== undefined && documentMode !== 9;
    var MUSTACHE_EXPR$1 = MUSTACHE_EXPR,
      ERB_EXPR$1 = ERB_EXPR,
      TMPLIT_EXPR$1 = TMPLIT_EXPR,
      DATA_ATTR$1 = DATA_ATTR,
      ARIA_ATTR$1 = ARIA_ATTR,
      IS_SCRIPT_OR_DATA$1 = IS_SCRIPT_OR_DATA,
      ATTR_WHITESPACE$1 = ATTR_WHITESPACE,
      CUSTOM_ELEMENT$1 = CUSTOM_ELEMENT;
    var IS_ALLOWED_URI$1 = IS_ALLOWED_URI;

    /**
     * We consider the elements and attributes below to be safe. Ideally
     * don't add any new ones but feel free to remove unwanted ones.
     */

    /* allowed element names */
    var ALLOWED_TAGS = null;
    var DEFAULT_ALLOWED_TAGS = addToSet({}, [].concat(_toConsumableArray(html$1), _toConsumableArray(svg$1), _toConsumableArray(svgFilters), _toConsumableArray(mathMl$1), _toConsumableArray(text)));

    /* Allowed attribute names */
    var ALLOWED_ATTR = null;
    var DEFAULT_ALLOWED_ATTR = addToSet({}, [].concat(_toConsumableArray(html), _toConsumableArray(svg), _toConsumableArray(mathMl), _toConsumableArray(xml)));

    /*
     * Configure how DOMPUrify should handle custom elements and their attributes as well as customized built-in elements.
     * @property {RegExp|Function|null} tagNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any custom elements)
     * @property {RegExp|Function|null} attributeNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any attributes not on the allow list)
     * @property {boolean} allowCustomizedBuiltInElements allow custom elements derived from built-ins if they pass CUSTOM_ELEMENT_HANDLING.tagNameCheck. Default: `false`.
     */
    var CUSTOM_ELEMENT_HANDLING = Object.seal(Object.create(null, {
      tagNameCheck: {
        writable: true,
        configurable: false,
        enumerable: true,
        value: null
      },
      attributeNameCheck: {
        writable: true,
        configurable: false,
        enumerable: true,
        value: null
      },
      allowCustomizedBuiltInElements: {
        writable: true,
        configurable: false,
        enumerable: true,
        value: false
      }
    }));

    /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */
    var FORBID_TAGS = null;

    /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */
    var FORBID_ATTR = null;

    /* Decide if ARIA attributes are okay */
    var ALLOW_ARIA_ATTR = true;

    /* Decide if custom data attributes are okay */
    var ALLOW_DATA_ATTR = true;

    /* Decide if unknown protocols are okay */
    var ALLOW_UNKNOWN_PROTOCOLS = false;

    /* Decide if self-closing tags in attributes are allowed.
     * Usually removed due to a mXSS issue in jQuery 3.0 */
    var ALLOW_SELF_CLOSE_IN_ATTR = true;

    /* Output should be safe for common template engines.
     * This means, DOMPurify removes data attributes, mustaches and ERB
     */
    var SAFE_FOR_TEMPLATES = false;

    /* Output should be safe even for XML used within HTML and alike.
     * This means, DOMPurify removes comments when containing risky content.
     */
    var SAFE_FOR_XML = true;

    /* Decide if document with <html>... should be returned */
    var WHOLE_DOCUMENT = false;

    /* Track whether config is already set on this instance of DOMPurify. */
    var SET_CONFIG = false;

    /* Decide if all elements (e.g. style, script) must be children of
     * document.body. By default, browsers might move them to document.head */
    var FORCE_BODY = false;

    /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
     * string (or a TrustedHTML object if Trusted Types are supported).
     * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
     */
    var RETURN_DOM = false;

    /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
     * string  (or a TrustedHTML object if Trusted Types are supported) */
    var RETURN_DOM_FRAGMENT = false;

    /* Try to return a Trusted Type object instead of a string, return a string in
     * case Trusted Types are not supported  */
    var RETURN_TRUSTED_TYPE = false;

    /* Output should be free from DOM clobbering attacks?
     * This sanitizes markups named with colliding, clobberable built-in DOM APIs.
     */
    var SANITIZE_DOM = true;

    /* Achieve full DOM Clobbering protection by isolating the namespace of named
     * properties and JS variables, mitigating attacks that abuse the HTML/DOM spec rules.
     *
     * HTML/DOM spec rules that enable DOM Clobbering:
     *   - Named Access on Window (§7.3.3)
     *   - DOM Tree Accessors (§3.1.5)
     *   - Form Element Parent-Child Relations (§4.10.3)
     *   - Iframe srcdoc / Nested WindowProxies (§4.8.5)
     *   - HTMLCollection (§4.2.10.2)
     *
     * Namespace isolation is implemented by prefixing `id` and `name` attributes
     * with a constant string, i.e., `user-content-`
     */
    var SANITIZE_NAMED_PROPS = false;
    var SANITIZE_NAMED_PROPS_PREFIX = 'user-content-';

    /* Keep element content when removing element? */
    var KEEP_CONTENT = true;

    /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
     * of importing it into a new Document and returning a sanitized copy */
    var IN_PLACE = false;

    /* Allow usage of profiles like html, svg and mathMl */
    var USE_PROFILES = {};

    /* Tags to ignore content of when KEEP_CONTENT is true */
    var FORBID_CONTENTS = null;
    var DEFAULT_FORBID_CONTENTS = addToSet({}, ['annotation-xml', 'audio', 'colgroup', 'desc', 'foreignobject', 'head', 'iframe', 'math', 'mi', 'mn', 'mo', 'ms', 'mtext', 'noembed', 'noframes', 'noscript', 'plaintext', 'script', 'style', 'svg', 'template', 'thead', 'title', 'video', 'xmp']);

    /* Tags that are safe for data: URIs */
    var DATA_URI_TAGS = null;
    var DEFAULT_DATA_URI_TAGS = addToSet({}, ['audio', 'video', 'img', 'source', 'image', 'track']);

    /* Attributes safe for values like "javascript:" */
    var URI_SAFE_ATTRIBUTES = null;
    var DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, ['alt', 'class', 'for', 'id', 'label', 'name', 'pattern', 'placeholder', 'role', 'summary', 'title', 'value', 'style', 'xmlns']);
    var MATHML_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
    var SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
    var HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
    /* Document namespace */
    var NAMESPACE = HTML_NAMESPACE;
    var IS_EMPTY_INPUT = false;

    /* Allowed XHTML+XML namespaces */
    var ALLOWED_NAMESPACES = null;
    var DEFAULT_ALLOWED_NAMESPACES = addToSet({}, [MATHML_NAMESPACE, SVG_NAMESPACE, HTML_NAMESPACE], stringToString);

    /* Parsing of strict XHTML documents */
    var PARSER_MEDIA_TYPE;
    var SUPPORTED_PARSER_MEDIA_TYPES = ['application/xhtml+xml', 'text/html'];
    var DEFAULT_PARSER_MEDIA_TYPE = 'text/html';
    var transformCaseFunc;

    /* Keep a reference to config to pass to hooks */
    var CONFIG = null;

    /* Ideally, do not touch anything below this line */
    /* ______________________________________________ */

    var formElement = document.createElement('form');
    var isRegexOrFunction = function isRegexOrFunction(testValue) {
      return testValue instanceof RegExp || testValue instanceof Function;
    };

    /**
     * _parseConfig
     *
     * @param  {Object} cfg optional config literal
     */
    // eslint-disable-next-line complexity
    var _parseConfig = function _parseConfig(cfg) {
      if (CONFIG && CONFIG === cfg) {
        return;
      }

      /* Shield configuration object from tampering */
      if (!cfg || _typeof(cfg) !== 'object') {
        cfg = {};
      }

      /* Shield configuration object from prototype pollution */
      cfg = clone(cfg);
      PARSER_MEDIA_TYPE =
      // eslint-disable-next-line unicorn/prefer-includes
      SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? PARSER_MEDIA_TYPE = DEFAULT_PARSER_MEDIA_TYPE : PARSER_MEDIA_TYPE = cfg.PARSER_MEDIA_TYPE;

      // HTML tags and attributes are not case-sensitive, converting to lowercase. Keeping XHTML as is.
      transformCaseFunc = PARSER_MEDIA_TYPE === 'application/xhtml+xml' ? stringToString : stringToLowerCase;

      /* Set configuration parameters */
      ALLOWED_TAGS = 'ALLOWED_TAGS' in cfg ? addToSet({}, cfg.ALLOWED_TAGS, transformCaseFunc) : DEFAULT_ALLOWED_TAGS;
      ALLOWED_ATTR = 'ALLOWED_ATTR' in cfg ? addToSet({}, cfg.ALLOWED_ATTR, transformCaseFunc) : DEFAULT_ALLOWED_ATTR;
      ALLOWED_NAMESPACES = 'ALLOWED_NAMESPACES' in cfg ? addToSet({}, cfg.ALLOWED_NAMESPACES, stringToString) : DEFAULT_ALLOWED_NAMESPACES;
      URI_SAFE_ATTRIBUTES = 'ADD_URI_SAFE_ATTR' in cfg ? addToSet(clone(DEFAULT_URI_SAFE_ATTRIBUTES),
      // eslint-disable-line indent
      cfg.ADD_URI_SAFE_ATTR,
      // eslint-disable-line indent
      transformCaseFunc // eslint-disable-line indent
      ) // eslint-disable-line indent
      : DEFAULT_URI_SAFE_ATTRIBUTES;
      DATA_URI_TAGS = 'ADD_DATA_URI_TAGS' in cfg ? addToSet(clone(DEFAULT_DATA_URI_TAGS),
      // eslint-disable-line indent
      cfg.ADD_DATA_URI_TAGS,
      // eslint-disable-line indent
      transformCaseFunc // eslint-disable-line indent
      ) // eslint-disable-line indent
      : DEFAULT_DATA_URI_TAGS;
      FORBID_CONTENTS = 'FORBID_CONTENTS' in cfg ? addToSet({}, cfg.FORBID_CONTENTS, transformCaseFunc) : DEFAULT_FORBID_CONTENTS;
      FORBID_TAGS = 'FORBID_TAGS' in cfg ? addToSet({}, cfg.FORBID_TAGS, transformCaseFunc) : {};
      FORBID_ATTR = 'FORBID_ATTR' in cfg ? addToSet({}, cfg.FORBID_ATTR, transformCaseFunc) : {};
      USE_PROFILES = 'USE_PROFILES' in cfg ? cfg.USE_PROFILES : false;
      ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true
      ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true
      ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false
      ALLOW_SELF_CLOSE_IN_ATTR = cfg.ALLOW_SELF_CLOSE_IN_ATTR !== false; // Default true
      SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false
      SAFE_FOR_XML = cfg.SAFE_FOR_XML !== false; // Default true
      WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false
      RETURN_DOM = cfg.RETURN_DOM || false; // Default false
      RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false
      RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false
      FORCE_BODY = cfg.FORCE_BODY || false; // Default false
      SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true
      SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false; // Default false
      KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true
      IN_PLACE = cfg.IN_PLACE || false; // Default false
      IS_ALLOWED_URI$1 = cfg.ALLOWED_URI_REGEXP || IS_ALLOWED_URI$1;
      NAMESPACE = cfg.NAMESPACE || HTML_NAMESPACE;
      CUSTOM_ELEMENT_HANDLING = cfg.CUSTOM_ELEMENT_HANDLING || {};
      if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck)) {
        CUSTOM_ELEMENT_HANDLING.tagNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck;
      }
      if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck)) {
        CUSTOM_ELEMENT_HANDLING.attributeNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck;
      }
      if (cfg.CUSTOM_ELEMENT_HANDLING && typeof cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements === 'boolean') {
        CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements;
      }
      if (SAFE_FOR_TEMPLATES) {
        ALLOW_DATA_ATTR = false;
      }
      if (RETURN_DOM_FRAGMENT) {
        RETURN_DOM = true;
      }

      /* Parse profile info */
      if (USE_PROFILES) {
        ALLOWED_TAGS = addToSet({}, _toConsumableArray(text));
        ALLOWED_ATTR = [];
        if (USE_PROFILES.html === true) {
          addToSet(ALLOWED_TAGS, html$1);
          addToSet(ALLOWED_ATTR, html);
        }
        if (USE_PROFILES.svg === true) {
          addToSet(ALLOWED_TAGS, svg$1);
          addToSet(ALLOWED_ATTR, svg);
          addToSet(ALLOWED_ATTR, xml);
        }
        if (USE_PROFILES.svgFilters === true) {
          addToSet(ALLOWED_TAGS, svgFilters);
          addToSet(ALLOWED_ATTR, svg);
          addToSet(ALLOWED_ATTR, xml);
        }
        if (USE_PROFILES.mathMl === true) {
          addToSet(ALLOWED_TAGS, mathMl$1);
          addToSet(ALLOWED_ATTR, mathMl);
          addToSet(ALLOWED_ATTR, xml);
        }
      }

      /* Merge configuration parameters */
      if (cfg.ADD_TAGS) {
        if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) {
          ALLOWED_TAGS = clone(ALLOWED_TAGS);
        }
        addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
      }
      if (cfg.ADD_ATTR) {
        if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) {
          ALLOWED_ATTR = clone(ALLOWED_ATTR);
        }
        addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
      }
      if (cfg.ADD_URI_SAFE_ATTR) {
        addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR, transformCaseFunc);
      }
      if (cfg.FORBID_CONTENTS) {
        if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) {
          FORBID_CONTENTS = clone(FORBID_CONTENTS);
        }
        addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS, transformCaseFunc);
      }

      /* Add #text in case KEEP_CONTENT is set to true */
      if (KEEP_CONTENT) {
        ALLOWED_TAGS['#text'] = true;
      }

      /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */
      if (WHOLE_DOCUMENT) {
        addToSet(ALLOWED_TAGS, ['html', 'head', 'body']);
      }

      /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */
      if (ALLOWED_TAGS.table) {
        addToSet(ALLOWED_TAGS, ['tbody']);
        delete FORBID_TAGS.tbody;
      }

      // Prevent further manipulation of configuration.
      // Not available in IE8, Safari 5, etc.
      if (freeze) {
        freeze(cfg);
      }
      CONFIG = cfg;
    };
    var MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, ['mi', 'mo', 'mn', 'ms', 'mtext']);
    var HTML_INTEGRATION_POINTS = addToSet({}, ['annotation-xml']);

    // Certain elements are allowed in both SVG and HTML
    // namespace. We need to specify them explicitly
    // so that they don't get erroneously deleted from
    // HTML namespace.
    var COMMON_SVG_AND_HTML_ELEMENTS = addToSet({}, ['title', 'style', 'font', 'a', 'script']);

    /* Keep track of all possible SVG and MathML tags
     * so that we can perform the namespace checks
     * correctly. */
    var ALL_SVG_TAGS = addToSet({}, svg$1);
    addToSet(ALL_SVG_TAGS, svgFilters);
    addToSet(ALL_SVG_TAGS, svgDisallowed);
    var ALL_MATHML_TAGS = addToSet({}, mathMl$1);
    addToSet(ALL_MATHML_TAGS, mathMlDisallowed);

    /**
     *
     *
     * @param  {Element} element a DOM element whose namespace is being checked
     * @returns {boolean} Return false if the element has a
     *  namespace that a spec-compliant parser would never
     *  return. Return true otherwise.
     */
    var _checkValidNamespace = function _checkValidNamespace(element) {
      var parent = getParentNode(element);

      // In JSDOM, if we're inside shadow DOM, then parentNode
      // can be null. We just simulate parent in this case.
      if (!parent || !parent.tagName) {
        parent = {
          namespaceURI: NAMESPACE,
          tagName: 'template'
        };
      }
      var tagName = stringToLowerCase(element.tagName);
      var parentTagName = stringToLowerCase(parent.tagName);
      if (!ALLOWED_NAMESPACES[element.namespaceURI]) {
        return false;
      }
      if (element.namespaceURI === SVG_NAMESPACE) {
        // The only way to switch from HTML namespace to SVG
        // is via <svg>. If it happens via any other tag, then
        // it should be killed.
        if (parent.namespaceURI === HTML_NAMESPACE) {
          return tagName === 'svg';
        }

        // The only way to switch from MathML to SVG is via`
        // svg if parent is either <annotation-xml> or MathML
        // text integration points.
        if (parent.namespaceURI === MATHML_NAMESPACE) {
          return tagName === 'svg' && (parentTagName === 'annotation-xml' || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
        }

        // We only allow elements that are defined in SVG
        // spec. All others are disallowed in SVG namespace.
        return Boolean(ALL_SVG_TAGS[tagName]);
      }
      if (element.namespaceURI === MATHML_NAMESPACE) {
        // The only way to switch from HTML namespace to MathML
        // is via <math>. If it happens via any other tag, then
        // it should be killed.
        if (parent.namespaceURI === HTML_NAMESPACE) {
          return tagName === 'math';
        }

        // The only way to switch from SVG to MathML is via
        // <math> and HTML integration points
        if (parent.namespaceURI === SVG_NAMESPACE) {
          return tagName === 'math' && HTML_INTEGRATION_POINTS[parentTagName];
        }

        // We only allow elements that are defined in MathML
        // spec. All others are disallowed in MathML namespace.
        return Boolean(ALL_MATHML_TAGS[tagName]);
      }
      if (element.namespaceURI === HTML_NAMESPACE) {
        // The only way to switch from SVG to HTML is via
        // HTML integration points, and from MathML to HTML
        // is via MathML text integration points
        if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) {
          return false;
        }
        if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) {
          return false;
        }

        // We disallow tags that are specific for MathML
        // or SVG and should never appear in HTML namespace
        return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
      }

      // For XHTML and XML documents that support custom namespaces
      if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && ALLOWED_NAMESPACES[element.namespaceURI]) {
        return true;
      }

      // The code should never reach this place (this means
      // that the element somehow got namespace that is not
      // HTML, SVG, MathML or allowed via ALLOWED_NAMESPACES).
      // Return false just in case.
      return false;
    };

    /**
     * _forceRemove
     *
     * @param  {Node} node a DOM node
     */
    var _forceRemove = function _forceRemove(node) {
      arrayPush(DOMPurify.removed, {
        element: node
      });
      try {
        // eslint-disable-next-line unicorn/prefer-dom-node-remove
        node.parentNode.removeChild(node);
      } catch (_) {
        try {
          node.outerHTML = emptyHTML;
        } catch (_) {
          node.remove();
        }
      }
    };

    /**
     * _removeAttribute
     *
     * @param  {String} name an Attribute name
     * @param  {Node} node a DOM node
     */
    var _removeAttribute = function _removeAttribute(name, node) {
      try {
        arrayPush(DOMPurify.removed, {
          attribute: node.getAttributeNode(name),
          from: node
        });
      } catch (_) {
        arrayPush(DOMPurify.removed, {
          attribute: null,
          from: node
        });
      }
      node.removeAttribute(name);

      // We void attribute values for unremovable "is"" attributes
      if (name === 'is' && !ALLOWED_ATTR[name]) {
        if (RETURN_DOM || RETURN_DOM_FRAGMENT) {
          try {
            _forceRemove(node);
          } catch (_) {}
        } else {
          try {
            node.setAttribute(name, '');
          } catch (_) {}
        }
      }
    };

    /**
     * _initDocument
     *
     * @param  {String} dirty a string of dirty markup
     * @return {Document} a DOM, filled with the dirty markup
     */
    var _initDocument = function _initDocument(dirty) {
      /* Create a HTML document */
      var doc;
      var leadingWhitespace;
      if (FORCE_BODY) {
        dirty = '<remove></remove>' + dirty;
      } else {
        /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */
        var matches = stringMatch(dirty, /^[\r\n\t ]+/);
        leadingWhitespace = matches && matches[0];
      }
      if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && NAMESPACE === HTML_NAMESPACE) {
        // Root of XHTML doc must contain xmlns declaration (see https://www.w3.org/TR/xhtml1/normative.html#strict)
        dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + '</body></html>';
      }
      var dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
      /*
       * Use the DOMParser API by default, fallback later if needs be
       * DOMParser not work for svg when has multiple root element.
       */
      if (NAMESPACE === HTML_NAMESPACE) {
        try {
          doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
        } catch (_) {}
      }

      /* Use createHTMLDocument in case DOMParser is not available */
      if (!doc || !doc.documentElement) {
        doc = implementation.createDocument(NAMESPACE, 'template', null);
        try {
          doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
        } catch (_) {
          // Syntax error if dirtyPayload is invalid xml
        }
      }
      var body = doc.body || doc.documentElement;
      if (dirty && leadingWhitespace) {
        body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
      }

      /* Work on whole document or just its body */
      if (NAMESPACE === HTML_NAMESPACE) {
        return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? 'html' : 'body')[0];
      }
      return WHOLE_DOCUMENT ? doc.documentElement : body;
    };

    /**
     * _createIterator
     *
     * @param  {Document} root document/fragment to create iterator for
     * @return {Iterator} iterator instance
     */
    var _createIterator = function _createIterator(root) {
      return createNodeIterator.call(root.ownerDocument || root, root,
      // eslint-disable-next-line no-bitwise
      NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT | NodeFilter.SHOW_PROCESSING_INSTRUCTION | NodeFilter.SHOW_CDATA_SECTION, null, false);
    };

    /**
     * _isClobbered
     *
     * @param  {Node} elm element to check for clobbering attacks
     * @return {Boolean} true if clobbered, false if safe
     */
    var _isClobbered = function _isClobbered(elm) {
      return elm instanceof HTMLFormElement && (typeof elm.nodeName !== 'string' || typeof elm.textContent !== 'string' || typeof elm.removeChild !== 'function' || !(elm.attributes instanceof NamedNodeMap) || typeof elm.removeAttribute !== 'function' || typeof elm.setAttribute !== 'function' || typeof elm.namespaceURI !== 'string' || typeof elm.insertBefore !== 'function' || typeof elm.hasChildNodes !== 'function');
    };

    /**
     * _isNode
     *
     * @param  {Node} obj object to check whether it's a DOM node
     * @return {Boolean} true is object is a DOM node
     */
    var _isNode = function _isNode(object) {
      return _typeof(Node) === 'object' ? object instanceof Node : object && _typeof(object) === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string';
    };

    /**
     * _executeHook
     * Execute user configurable hooks
     *
     * @param  {String} entryPoint  Name of the hook's entry point
     * @param  {Node} currentNode node to work on with the hook
     * @param  {Object} data additional hook parameters
     */
    var _executeHook = function _executeHook(entryPoint, currentNode, data) {
      if (!hooks[entryPoint]) {
        return;
      }
      arrayForEach(hooks[entryPoint], function (hook) {
        hook.call(DOMPurify, currentNode, data, CONFIG);
      });
    };

    /**
     * _sanitizeElements
     *
     * @protect nodeName
     * @protect textContent
     * @protect removeChild
     *
     * @param   {Node} currentNode to check for permission to exist
     * @return  {Boolean} true if node was killed, false if left alive
     */
    var _sanitizeElements = function _sanitizeElements(currentNode) {
      var content;

      /* Execute a hook if present */
      _executeHook('beforeSanitizeElements', currentNode, null);

      /* Check if element is clobbered or can clobber */
      if (_isClobbered(currentNode)) {
        _forceRemove(currentNode);
        return true;
      }

      /* Check if tagname contains Unicode */
      if (regExpTest(/[\u0080-\uFFFF]/, currentNode.nodeName)) {
        _forceRemove(currentNode);
        return true;
      }

      /* Now let's check the element's type and name */
      var tagName = transformCaseFunc(currentNode.nodeName);

      /* Execute a hook if present */
      _executeHook('uponSanitizeElement', currentNode, {
        tagName: tagName,
        allowedTags: ALLOWED_TAGS
      });

      /* Detect mXSS attempts abusing namespace confusion */
      if (currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && (!_isNode(currentNode.content) || !_isNode(currentNode.content.firstElementChild)) && regExpTest(/<[/\w]/g, currentNode.innerHTML) && regExpTest(/<[/\w]/g, currentNode.textContent)) {
        _forceRemove(currentNode);
        return true;
      }

      /* Mitigate a problem with templates inside select */
      if (tagName === 'select' && regExpTest(/<template/i, currentNode.innerHTML)) {
        _forceRemove(currentNode);
        return true;
      }

      /* Remove any ocurrence of processing instructions */
      if (currentNode.nodeType === 7) {
        _forceRemove(currentNode);
        return true;
      }

      /* Remove any kind of possibly harmful comments */
      if (SAFE_FOR_XML && currentNode.nodeType === 8 && regExpTest(/<[/\w]/g, currentNode.data)) {
        _forceRemove(currentNode);
        return true;
      }

      /* Remove element if anything forbids its presence */
      if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
        /* Check if we have a custom element to handle */
        if (!FORBID_TAGS[tagName] && _basicCustomElementTest(tagName)) {
          if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) return false;
          if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(tagName)) return false;
        }

        /* Keep content except for bad-listed elements */
        if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
          var parentNode = getParentNode(currentNode) || currentNode.parentNode;
          var childNodes = getChildNodes(currentNode) || currentNode.childNodes;
          if (childNodes && parentNode) {
            var childCount = childNodes.length;
            for (var i = childCount - 1; i >= 0; --i) {
              var childClone = cloneNode(childNodes[i], true);
              childClone.__removalCount = (currentNode.__removalCount || 0) + 1;
              parentNode.insertBefore(childClone, getNextSibling(currentNode));
            }
          }
        }
        _forceRemove(currentNode);
        return true;
      }

      /* Check whether element has a valid namespace */
      if (currentNode instanceof Element && !_checkValidNamespace(currentNode)) {
        _forceRemove(currentNode);
        return true;
      }

      /* Make sure that older browsers don't get fallback-tag mXSS */
      if ((tagName === 'noscript' || tagName === 'noembed' || tagName === 'noframes') && regExpTest(/<\/no(script|embed|frames)/i, currentNode.innerHTML)) {
        _forceRemove(currentNode);
        return true;
      }

      /* Sanitize element content to be template-safe */
      if (SAFE_FOR_TEMPLATES && currentNode.nodeType === 3) {
        /* Get the element's text content */
        content = currentNode.textContent;
        content = stringReplace(content, MUSTACHE_EXPR$1, ' ');
        content = stringReplace(content, ERB_EXPR$1, ' ');
        content = stringReplace(content, TMPLIT_EXPR$1, ' ');
        if (currentNode.textContent !== content) {
          arrayPush(DOMPurify.removed, {
            element: currentNode.cloneNode()
          });
          currentNode.textContent = content;
        }
      }

      /* Execute a hook if present */
      _executeHook('afterSanitizeElements', currentNode, null);
      return false;
    };

    /**
     * _isValidAttribute
     *
     * @param  {string} lcTag Lowercase tag name of containing element.
     * @param  {string} lcName Lowercase attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid, otherwise false.
     */
    // eslint-disable-next-line complexity
    var _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
      /* Make sure attribute cannot clobber */
      if (SANITIZE_DOM && (lcName === 'id' || lcName === 'name') && (value in document || value in formElement)) {
        return false;
      }

      /* Allow valid data-* attributes: At least one character after "-"
          (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
          XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
          We don't need to check the value; it's always URI safe. */
      if (ALLOW_DATA_ATTR && !FORBID_ATTR[lcName] && regExpTest(DATA_ATTR$1, lcName)) ; else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR$1, lcName)) ; else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
        if (
        // First condition does a very basic check if a) it's basically a valid custom element tagname AND
        // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
        // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
        _basicCustomElementTest(lcTag) && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(lcTag)) && (CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName) || CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.attributeNameCheck(lcName)) ||
        // Alternative, second condition checks if it's an `is`-attribute, AND
        // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
        lcName === 'is' && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(value))) ; else {
          return false;
        }
        /* Check value is safe. First, is attr inert? If so, is safe */
      } else if (URI_SAFE_ATTRIBUTES[lcName]) ; else if (regExpTest(IS_ALLOWED_URI$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) ; else if ((lcName === 'src' || lcName === 'xlink:href' || lcName === 'href') && lcTag !== 'script' && stringIndexOf(value, 'data:') === 0 && DATA_URI_TAGS[lcTag]) ; else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) ; else if (value) {
        return false;
      } else ;
      return true;
    };

    /**
     * _basicCustomElementCheck
     * checks if at least one dash is included in tagName, and it's not the first char
     * for more sophisticated checking see https://github.com/sindresorhus/validate-element-name
     * @param {string} tagName name of the tag of the node to sanitize
     */
    var _basicCustomElementTest = function _basicCustomElementTest(tagName) {
      return tagName !== 'annotation-xml' && stringMatch(tagName, CUSTOM_ELEMENT$1);
    };

    /**
     * _sanitizeAttributes
     *
     * @protect attributes
     * @protect nodeName
     * @protect removeAttribute
     * @protect setAttribute
     *
     * @param  {Node} currentNode to sanitize
     */
    var _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
      var attr;
      var value;
      var lcName;
      var l;
      /* Execute a hook if present */
      _executeHook('beforeSanitizeAttributes', currentNode, null);
      var attributes = currentNode.attributes;

      /* Check if we have attributes; if not we might have a text node */
      if (!attributes || _isClobbered(currentNode)) {
        return;
      }
      var hookEvent = {
        attrName: '',
        attrValue: '',
        keepAttr: true,
        allowedAttributes: ALLOWED_ATTR
      };
      l = attributes.length;

      /* Go backwards over all attributes; safely remove bad ones */
      while (l--) {
        attr = attributes[l];
        var _attr = attr,
          name = _attr.name,
          namespaceURI = _attr.namespaceURI;
        value = name === 'value' ? attr.value : stringTrim(attr.value);
        lcName = transformCaseFunc(name);

        /* Execute a hook if present */
        hookEvent.attrName = lcName;
        hookEvent.attrValue = value;
        hookEvent.keepAttr = true;
        hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set
        _executeHook('uponSanitizeAttribute', currentNode, hookEvent);
        value = hookEvent.attrValue;

        /* Did the hooks approve of the attribute? */
        if (hookEvent.forceKeepAttr) {
          continue;
        }

        /* Remove attribute */
        _removeAttribute(name, currentNode);

        /* Did the hooks approve of the attribute? */
        if (!hookEvent.keepAttr) {
          continue;
        }

        /* Work around a security issue in jQuery 3.0 */
        if (!ALLOW_SELF_CLOSE_IN_ATTR && regExpTest(/\/>/i, value)) {
          _removeAttribute(name, currentNode);
          continue;
        }

        /* Sanitize attribute content to be template-safe */
        if (SAFE_FOR_TEMPLATES) {
          value = stringReplace(value, MUSTACHE_EXPR$1, ' ');
          value = stringReplace(value, ERB_EXPR$1, ' ');
          value = stringReplace(value, TMPLIT_EXPR$1, ' ');
        }

        /* Is `value` valid for this attribute? */
        var lcTag = transformCaseFunc(currentNode.nodeName);
        if (!_isValidAttribute(lcTag, lcName, value)) {
          continue;
        }

        /* Full DOM Clobbering protection via namespace isolation,
         * Prefix id and name attributes with `user-content-`
         */
        if (SANITIZE_NAMED_PROPS && (lcName === 'id' || lcName === 'name')) {
          // Remove the attribute with this value
          _removeAttribute(name, currentNode);

          // Prefix the value and later re-create the attribute with the sanitized value
          value = SANITIZE_NAMED_PROPS_PREFIX + value;
        }

        /* Work around a security issue with comments inside attributes */
        if (SAFE_FOR_XML && regExpTest(/((--!?|])>)|<\/(style|title)/i, value)) {
          _removeAttribute(name, currentNode);
          continue;
        }

        /* Handle attributes that require Trusted Types */
        if (trustedTypesPolicy && _typeof(trustedTypes) === 'object' && typeof trustedTypes.getAttributeType === 'function') {
          if (namespaceURI) ; else {
            switch (trustedTypes.getAttributeType(lcTag, lcName)) {
              case 'TrustedHTML':
                {
                  value = trustedTypesPolicy.createHTML(value);
                  break;
                }
              case 'TrustedScriptURL':
                {
                  value = trustedTypesPolicy.createScriptURL(value);
                  break;
                }
            }
          }
        }

        /* Handle invalid data-* attribute set by try-catching it */
        try {
          if (namespaceURI) {
            currentNode.setAttributeNS(namespaceURI, name, value);
          } else {
            /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */
            currentNode.setAttribute(name, value);
          }
          if (_isClobbered(currentNode)) {
            _forceRemove(currentNode);
          } else {
            arrayPop(DOMPurify.removed);
          }
        } catch (_) {}
      }

      /* Execute a hook if present */
      _executeHook('afterSanitizeAttributes', currentNode, null);
    };

    /**
     * _sanitizeShadowDOM
     *
     * @param  {DocumentFragment} fragment to iterate over recursively
     */
    var _sanitizeShadowDOM = function _sanitizeShadowDOM(fragment) {
      var shadowNode;
      var shadowIterator = _createIterator(fragment);

      /* Execute a hook if present */
      _executeHook('beforeSanitizeShadowDOM', fragment, null);
      while (shadowNode = shadowIterator.nextNode()) {
        /* Execute a hook if present */
        _executeHook('uponSanitizeShadowNode', shadowNode, null);
        /* Sanitize tags and elements */
        _sanitizeElements(shadowNode);

        /* Check attributes next */
        _sanitizeAttributes(shadowNode);

        /* Deep shadow DOM detected */
        if (shadowNode.content instanceof DocumentFragment) {
          _sanitizeShadowDOM(shadowNode.content);
        }
      }

      /* Execute a hook if present */
      _executeHook('afterSanitizeShadowDOM', fragment, null);
    };

    /**
     * Sanitize
     * Public method providing core sanitation functionality
     *
     * @param {String|Node} dirty string or DOM node
     * @param {Object} configuration object
     */
    // eslint-disable-next-line complexity
    DOMPurify.sanitize = function (dirty) {
      var cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var body;
      var importedNode;
      var currentNode;
      var oldNode;
      var returnNode;
      /* Make sure we have a string to sanitize.
        DO NOT return early, as this will return the wrong type if
        the user has requested a DOM object rather than a string */
      IS_EMPTY_INPUT = !dirty;
      if (IS_EMPTY_INPUT) {
        dirty = '<!-->';
      }

      /* Stringify, in case dirty is an object */
      if (typeof dirty !== 'string' && !_isNode(dirty)) {
        if (typeof dirty.toString === 'function') {
          dirty = dirty.toString();
          if (typeof dirty !== 'string') {
            throw typeErrorCreate('dirty is not a string, aborting');
          }
        } else {
          throw typeErrorCreate('toString is not a function');
        }
      }

      /* Check we can run. Otherwise fall back or ignore */
      if (!DOMPurify.isSupported) {
        if (_typeof(window.toStaticHTML) === 'object' || typeof window.toStaticHTML === 'function') {
          if (typeof dirty === 'string') {
            return window.toStaticHTML(dirty);
          }
          if (_isNode(dirty)) {
            return window.toStaticHTML(dirty.outerHTML);
          }
        }
        return dirty;
      }

      /* Assign config vars */
      if (!SET_CONFIG) {
        _parseConfig(cfg);
      }

      /* Clean up removed elements */
      DOMPurify.removed = [];

      /* Check if dirty is correctly typed for IN_PLACE */
      if (typeof dirty === 'string') {
        IN_PLACE = false;
      }
      if (IN_PLACE) {
        /* Do some early pre-sanitization to avoid unsafe root nodes */
        if (dirty.nodeName) {
          var tagName = transformCaseFunc(dirty.nodeName);
          if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
            throw typeErrorCreate('root node is forbidden and cannot be sanitized in-place');
          }
        }
      } else if (dirty instanceof Node) {
        /* If dirty is a DOM element, append to an empty document to avoid
           elements being stripped by the parser */
        body = _initDocument('<!---->');
        importedNode = body.ownerDocument.importNode(dirty, true);
        if (importedNode.nodeType === 1 && importedNode.nodeName === 'BODY') {
          /* Node is already a body, use as is */
          body = importedNode;
        } else if (importedNode.nodeName === 'HTML') {
          body = importedNode;
        } else {
          // eslint-disable-next-line unicorn/prefer-dom-node-append
          body.appendChild(importedNode);
        }
      } else {
        /* Exit directly if we have nothing to do */
        if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT &&
        // eslint-disable-next-line unicorn/prefer-includes
        dirty.indexOf('<') === -1) {
          return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
        }

        /* Initialize the document to work on */
        body = _initDocument(dirty);

        /* Check we have a DOM node from the data */
        if (!body) {
          return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : '';
        }
      }

      /* Remove first element node (ours) if FORCE_BODY is set */
      if (body && FORCE_BODY) {
        _forceRemove(body.firstChild);
      }

      /* Get node iterator */
      var nodeIterator = _createIterator(IN_PLACE ? dirty : body);

      /* Now start iterating over the created document */
      while (currentNode = nodeIterator.nextNode()) {
        /* Fix IE's strange behavior with manipulated textNodes #89 */
        if (currentNode.nodeType === 3 && currentNode === oldNode) {
          continue;
        }

        /* Sanitize tags and elements */
        _sanitizeElements(currentNode);

        /* Check attributes next */
        _sanitizeAttributes(currentNode);

        /* Shadow DOM detected, sanitize it */
        if (currentNode.content instanceof DocumentFragment) {
          _sanitizeShadowDOM(currentNode.content);
        }
        oldNode = currentNode;
      }
      oldNode = null;

      /* If we sanitized `dirty` in-place, return it. */
      if (IN_PLACE) {
        return dirty;
      }

      /* Return sanitized string or DOM */
      if (RETURN_DOM) {
        if (RETURN_DOM_FRAGMENT) {
          returnNode = createDocumentFragment.call(body.ownerDocument);
          while (body.firstChild) {
            // eslint-disable-next-line unicorn/prefer-dom-node-append
            returnNode.appendChild(body.firstChild);
          }
        } else {
          returnNode = body;
        }
        if (ALLOWED_ATTR.shadowroot || ALLOWED_ATTR.shadowrootmod) {
          /*
            AdoptNode() is not used because internal state is not reset
            (e.g. the past names map of a HTMLFormElement), this is safe
            in theory but we would rather not risk another attack vector.
            The state that is cloned by importNode() is explicitly defined
            by the specs.
          */
          returnNode = importNode.call(originalDocument, returnNode, true);
        }
        return returnNode;
      }
      var serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;

      /* Serialize doctype if allowed */
      if (WHOLE_DOCUMENT && ALLOWED_TAGS['!doctype'] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && regExpTest(DOCTYPE_NAME, body.ownerDocument.doctype.name)) {
        serializedHTML = '<!DOCTYPE ' + body.ownerDocument.doctype.name + '>\n' + serializedHTML;
      }

      /* Sanitize final string template-safe */
      if (SAFE_FOR_TEMPLATES) {
        serializedHTML = stringReplace(serializedHTML, MUSTACHE_EXPR$1, ' ');
        serializedHTML = stringReplace(serializedHTML, ERB_EXPR$1, ' ');
        serializedHTML = stringReplace(serializedHTML, TMPLIT_EXPR$1, ' ');
      }
      return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
    };

    /**
     * Public method to set the configuration once
     * setConfig
     *
     * @param {Object} cfg configuration object
     */
    DOMPurify.setConfig = function (cfg) {
      _parseConfig(cfg);
      SET_CONFIG = true;
    };

    /**
     * Public method to remove the configuration
     * clearConfig
     *
     */
    DOMPurify.clearConfig = function () {
      CONFIG = null;
      SET_CONFIG = false;
    };

    /**
     * Public method to check if an attribute value is valid.
     * Uses last set config, if any. Otherwise, uses config defaults.
     * isValidAttribute
     *
     * @param  {string} tag Tag name of containing element.
     * @param  {string} attr Attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid. Otherwise, returns false.
     */
    DOMPurify.isValidAttribute = function (tag, attr, value) {
      /* Initialize shared config vars if necessary. */
      if (!CONFIG) {
        _parseConfig({});
      }
      var lcTag = transformCaseFunc(tag);
      var lcName = transformCaseFunc(attr);
      return _isValidAttribute(lcTag, lcName, value);
    };

    /**
     * AddHook
     * Public method to add DOMPurify hooks
     *
     * @param {String} entryPoint entry point for the hook to add
     * @param {Function} hookFunction function to execute
     */
    DOMPurify.addHook = function (entryPoint, hookFunction) {
      if (typeof hookFunction !== 'function') {
        return;
      }
      hooks[entryPoint] = hooks[entryPoint] || [];
      arrayPush(hooks[entryPoint], hookFunction);
    };

    /**
     * RemoveHook
     * Public method to remove a DOMPurify hook at a given entryPoint
     * (pops it from the stack of hooks if more are present)
     *
     * @param {String} entryPoint entry point for the hook to remove
     * @return {Function} removed(popped) hook
     */
    DOMPurify.removeHook = function (entryPoint) {
      if (hooks[entryPoint]) {
        return arrayPop(hooks[entryPoint]);
      }
    };

    /**
     * RemoveHooks
     * Public method to remove all DOMPurify hooks at a given entryPoint
     *
     * @param  {String} entryPoint entry point for the hooks to remove
     */
    DOMPurify.removeHooks = function (entryPoint) {
      if (hooks[entryPoint]) {
        hooks[entryPoint] = [];
      }
    };

    /**
     * RemoveAllHooks
     * Public method to remove all DOMPurify hooks
     *
     */
    DOMPurify.removeAllHooks = function () {
      hooks = {};
    };
    return DOMPurify;
  }
  var purify = createDOMPurify();

  return purify;

}));
//# sourceMappingURL=purify.js.map


/***/ }),

/***/ 96504:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var callBind = __webpack_require__(40319);
var gOPD = __webpack_require__(27296);

var hasProtoAccessor;
try {
	// eslint-disable-next-line no-extra-parens, no-proto
	hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */ ([]).__proto__ === Array.prototype;
} catch (e) {
	if (!e || typeof e !== 'object' || !('code' in e) || e.code !== 'ERR_PROTO_ACCESS') {
		throw e;
	}
}

// eslint-disable-next-line no-extra-parens
var desc = !!hasProtoAccessor && gOPD && gOPD(Object.prototype, /** @type {keyof typeof Object.prototype} */ ('__proto__'));

var $Object = Object;
var $getPrototypeOf = $Object.getPrototypeOf;

/** @type {import('./get')} */
module.exports = desc && typeof desc.get === 'function'
	? callBind([desc.get])
	: typeof $getPrototypeOf === 'function'
		? /** @type {import('./get')} */ function getDunder(value) {
			// eslint-disable-next-line eqeqeq
			return $getPrototypeOf(value == null ? value : $Object(value));
		}
		: false;


/***/ }),

/***/ 62988:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var QueryHandler = __webpack_require__(61755);
var each = (__webpack_require__(26665).each);

/**
 * Represents a single media query, manages it's state and registered handlers for this query
 *
 * @constructor
 * @param {string} query the media query string
 * @param {boolean} [isUnconditional=false] whether the media query should run regardless of whether the conditions are met. Primarily for helping older browsers deal with mobile-first design
 */
function MediaQuery(query, isUnconditional) {
    this.query = query;
    this.isUnconditional = isUnconditional;
    this.handlers = [];
    this.mql = window.matchMedia(query);

    var self = this;
    this.listener = function(mql) {
        // Chrome passes an MediaQueryListEvent object, while other browsers pass MediaQueryList directly
        self.mql = mql.currentTarget || mql;
        self.assess();
    };
    this.mql.addListener(this.listener);
}

MediaQuery.prototype = {

    constuctor : MediaQuery,

    /**
     * add a handler for this query, triggering if already active
     *
     * @param {object} handler
     * @param {function} handler.match callback for when query is activated
     * @param {function} [handler.unmatch] callback for when query is deactivated
     * @param {function} [handler.setup] callback for immediate execution when a query handler is registered
     * @param {boolean} [handler.deferSetup=false] should the setup callback be deferred until the first time the handler is matched?
     */
    addHandler : function(handler) {
        var qh = new QueryHandler(handler);
        this.handlers.push(qh);

        this.matches() && qh.on();
    },

    /**
     * removes the given handler from the collection, and calls it's destroy methods
     *
     * @param {object || function} handler the handler to remove
     */
    removeHandler : function(handler) {
        var handlers = this.handlers;
        each(handlers, function(h, i) {
            if(h.equals(handler)) {
                h.destroy();
                return !handlers.splice(i,1); //remove from array and exit each early
            }
        });
    },

    /**
     * Determine whether the media query should be considered a match
     *
     * @return {Boolean} true if media query can be considered a match, false otherwise
     */
    matches : function() {
        return this.mql.matches || this.isUnconditional;
    },

    /**
     * Clears all handlers and unbinds events
     */
    clear : function() {
        each(this.handlers, function(handler) {
            handler.destroy();
        });
        this.mql.removeListener(this.listener);
        this.handlers.length = 0; //clear array
    },

    /*
        * Assesses the query, turning on all handlers if it matches, turning them off if it doesn't match
        */
    assess : function() {
        var action = this.matches() ? 'on' : 'off';

        each(this.handlers, function(handler) {
            handler[action]();
        });
    }
};

module.exports = MediaQuery;


/***/ }),

/***/ 38177:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var MediaQuery = __webpack_require__(62988);
var Util = __webpack_require__(26665);
var each = Util.each;
var isFunction = Util.isFunction;
var isArray = Util.isArray;

/**
 * Allows for registration of query handlers.
 * Manages the query handler's state and is responsible for wiring up browser events
 *
 * @constructor
 */
function MediaQueryDispatch () {
    if(!window.matchMedia) {
        throw new Error('matchMedia not present, legacy browsers require a polyfill');
    }

    this.queries = {};
    this.browserIsIncapable = !window.matchMedia('only all').matches;
}

MediaQueryDispatch.prototype = {

    constructor : MediaQueryDispatch,

    /**
     * Registers a handler for the given media query
     *
     * @param {string} q the media query
     * @param {object || Array || Function} options either a single query handler object, a function, or an array of query handlers
     * @param {function} options.match fired when query matched
     * @param {function} [options.unmatch] fired when a query is no longer matched
     * @param {function} [options.setup] fired when handler first triggered
     * @param {boolean} [options.deferSetup=false] whether setup should be run immediately or deferred until query is first matched
     * @param {boolean} [shouldDegrade=false] whether this particular media query should always run on incapable browsers
     */
    register : function(q, options, shouldDegrade) {
        var queries         = this.queries,
            isUnconditional = shouldDegrade && this.browserIsIncapable;

        if(!queries[q]) {
            queries[q] = new MediaQuery(q, isUnconditional);
        }

        //normalise to object in an array
        if(isFunction(options)) {
            options = { match : options };
        }
        if(!isArray(options)) {
            options = [options];
        }
        each(options, function(handler) {
            if (isFunction(handler)) {
                handler = { match : handler };
            }
            queries[q].addHandler(handler);
        });

        return this;
    },

    /**
     * unregisters a query and all it's handlers, or a specific handler for a query
     *
     * @param {string} q the media query to target
     * @param {object || function} [handler] specific handler to unregister
     */
    unregister : function(q, handler) {
        var query = this.queries[q];

        if(query) {
            if(handler) {
                query.removeHandler(handler);
            }
            else {
                query.clear();
                delete this.queries[q];
            }
        }

        return this;
    }
};

module.exports = MediaQueryDispatch;


/***/ }),

/***/ 61755:
/***/ (function(module) {

/**
 * Delegate to handle a media query being matched and unmatched.
 *
 * @param {object} options
 * @param {function} options.match callback for when the media query is matched
 * @param {function} [options.unmatch] callback for when the media query is unmatched
 * @param {function} [options.setup] one-time callback triggered the first time a query is matched
 * @param {boolean} [options.deferSetup=false] should the setup callback be run immediately, rather than first time query is matched?
 * @constructor
 */
function QueryHandler(options) {
    this.options = options;
    !options.deferSetup && this.setup();
}

QueryHandler.prototype = {

    constructor : QueryHandler,

    /**
     * coordinates setup of the handler
     *
     * @function
     */
    setup : function() {
        if(this.options.setup) {
            this.options.setup();
        }
        this.initialised = true;
    },

    /**
     * coordinates setup and triggering of the handler
     *
     * @function
     */
    on : function() {
        !this.initialised && this.setup();
        this.options.match && this.options.match();
    },

    /**
     * coordinates the unmatch event for the handler
     *
     * @function
     */
    off : function() {
        this.options.unmatch && this.options.unmatch();
    },

    /**
     * called when a handler is to be destroyed.
     * delegates to the destroy or unmatch callbacks, depending on availability.
     *
     * @function
     */
    destroy : function() {
        this.options.destroy ? this.options.destroy() : this.off();
    },

    /**
     * determines equality by reference.
     * if object is supplied compare options, if function, compare match callback
     *
     * @function
     * @param {object || function} [target] the target for comparison
     */
    equals : function(target) {
        return this.options === target || this.options.match === target;
    }

};

module.exports = QueryHandler;


/***/ }),

/***/ 26665:
/***/ (function(module) {

/**
 * Helper function for iterating over a collection
 *
 * @param collection
 * @param fn
 */
function each(collection, fn) {
    var i      = 0,
        length = collection.length,
        cont;

    for(i; i < length; i++) {
        cont = fn(collection[i], i);
        if(cont === false) {
            break; //allow early exit
        }
    }
}

/**
 * Helper function for determining whether target object is an array
 *
 * @param target the object under test
 * @return {Boolean} true if array, false otherwise
 */
function isArray(target) {
    return Object.prototype.toString.apply(target) === '[object Array]';
}

/**
 * Helper function for determining whether target object is a function
 *
 * @param target the object under test
 * @return {Boolean} true if function, false otherwise
 */
function isFunction(target) {
    return typeof target === 'function';
}

module.exports = {
    isFunction : isFunction,
    isArray : isArray,
    each : each
};


/***/ }),

/***/ 24974:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var MediaQueryDispatch = __webpack_require__(38177);
module.exports = new MediaQueryDispatch();


/***/ }),

/***/ 24429:
/***/ (function(module) {

"use strict";


/** @type {import('.')} */
var $defineProperty = Object.defineProperty || false;
if ($defineProperty) {
	try {
		$defineProperty({}, 'a', { value: 1 });
	} catch (e) {
		// IE 8 has a broken defineProperty
		$defineProperty = false;
	}
}

module.exports = $defineProperty;


/***/ }),

/***/ 53981:
/***/ (function(module) {

"use strict";


/** @type {import('./eval')} */
module.exports = EvalError;


/***/ }),

/***/ 81648:
/***/ (function(module) {

"use strict";


/** @type {import('.')} */
module.exports = Error;


/***/ }),

/***/ 24726:
/***/ (function(module) {

"use strict";


/** @type {import('./range')} */
module.exports = RangeError;


/***/ }),

/***/ 26712:
/***/ (function(module) {

"use strict";


/** @type {import('./ref')} */
module.exports = ReferenceError;


/***/ }),

/***/ 33464:
/***/ (function(module) {

"use strict";


/** @type {import('./syntax')} */
module.exports = SyntaxError;


/***/ }),

/***/ 14453:
/***/ (function(module) {

"use strict";


/** @type {import('./type')} */
module.exports = TypeError;


/***/ }),

/***/ 43915:
/***/ (function(module) {

"use strict";


/** @type {import('./uri')} */
module.exports = URIError;


/***/ }),

/***/ 68892:
/***/ (function(module) {

"use strict";


/** @type {import('.')} */
module.exports = Object;


/***/ }),

/***/ 17648:
/***/ (function(module) {

"use strict";


/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var toStr = Object.prototype.toString;
var max = Math.max;
var funcType = '[object Function]';

var concatty = function concatty(a, b) {
    var arr = [];

    for (var i = 0; i < a.length; i += 1) {
        arr[i] = a[i];
    }
    for (var j = 0; j < b.length; j += 1) {
        arr[j + a.length] = b[j];
    }

    return arr;
};

var slicy = function slicy(arrLike, offset) {
    var arr = [];
    for (var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1) {
        arr[j] = arrLike[i];
    }
    return arr;
};

var joiny = function (arr, joiner) {
    var str = '';
    for (var i = 0; i < arr.length; i += 1) {
        str += arr[i];
        if (i + 1 < arr.length) {
            str += joiner;
        }
    }
    return str;
};

module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.apply(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slicy(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                concatty(args, arguments)
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        }
        return target.apply(
            that,
            concatty(args, arguments)
        );

    };

    var boundLength = max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs[i] = '$' + i;
    }

    bound = Function('binder', 'return function (' + joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};


/***/ }),

/***/ 58612:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(17648);

module.exports = Function.prototype.bind || implementation;


/***/ }),

/***/ 40210:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var undefined;

var $Object = __webpack_require__(68892);

var $Error = __webpack_require__(81648);
var $EvalError = __webpack_require__(53981);
var $RangeError = __webpack_require__(24726);
var $ReferenceError = __webpack_require__(26712);
var $SyntaxError = __webpack_require__(33464);
var $TypeError = __webpack_require__(14453);
var $URIError = __webpack_require__(43915);

var abs = __webpack_require__(59738);
var floor = __webpack_require__(76329);
var max = __webpack_require__(52264);
var min = __webpack_require__(55730);
var pow = __webpack_require__(20707);
var round = __webpack_require__(63862);
var sign = __webpack_require__(29550);

var $Function = Function;

// eslint-disable-next-line consistent-return
var getEvalledConstructor = function (expressionSyntax) {
	try {
		return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
	} catch (e) {}
};

var $gOPD = __webpack_require__(27296);
var $defineProperty = __webpack_require__(24429);

var throwTypeError = function () {
	throw new $TypeError();
};
var ThrowTypeError = $gOPD
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError;
			}
		}
	}())
	: throwTypeError;

var hasSymbols = __webpack_require__(41405)();

var getProto = __webpack_require__(81618);
var $ObjectGPO = __webpack_require__(68899);
var $ReflectGPO = __webpack_require__(10443);

var $apply = __webpack_require__(1768);
var $call = __webpack_require__(68928);

var needsEval = {};

var TypedArray = typeof Uint8Array === 'undefined' || !getProto ? undefined : getProto(Uint8Array);

var INTRINSICS = {
	__proto__: null,
	'%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
	'%ArrayIteratorPrototype%': hasSymbols && getProto ? getProto([][Symbol.iterator]()) : undefined,
	'%AsyncFromSyncIteratorPrototype%': undefined,
	'%AsyncFunction%': needsEval,
	'%AsyncGenerator%': needsEval,
	'%AsyncGeneratorFunction%': needsEval,
	'%AsyncIteratorPrototype%': needsEval,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
	'%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
	'%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
	'%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
	'%Boolean%': Boolean,
	'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
	'%Date%': Date,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': $Error,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': $EvalError,
	'%Float16Array%': typeof Float16Array === 'undefined' ? undefined : Float16Array,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
	'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
	'%Function%': $Function,
	'%GeneratorFunction%': needsEval,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols && getProto ? getProto(getProto([][Symbol.iterator]())) : undefined,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined,
	'%Map%': typeof Map === 'undefined' ? undefined : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Map()[Symbol.iterator]()),
	'%Math%': Math,
	'%Number%': Number,
	'%Object%': $Object,
	'%Object.getOwnPropertyDescriptor%': $gOPD,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
	'%RangeError%': $RangeError,
	'%ReferenceError%': $ReferenceError,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
	'%RegExp%': RegExp,
	'%Set%': typeof Set === 'undefined' ? undefined : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Set()[Symbol.iterator]()),
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols && getProto ? getProto(''[Symbol.iterator]()) : undefined,
	'%Symbol%': hasSymbols ? Symbol : undefined,
	'%SyntaxError%': $SyntaxError,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypeError%': $TypeError,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
	'%URIError%': $URIError,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
	'%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,

	'%Function.prototype.call%': $call,
	'%Function.prototype.apply%': $apply,
	'%Object.defineProperty%': $defineProperty,
	'%Object.getPrototypeOf%': $ObjectGPO,
	'%Math.abs%': abs,
	'%Math.floor%': floor,
	'%Math.max%': max,
	'%Math.min%': min,
	'%Math.pow%': pow,
	'%Math.round%': round,
	'%Math.sign%': sign,
	'%Reflect.getPrototypeOf%': $ReflectGPO
};

if (getProto) {
	try {
		null.error; // eslint-disable-line no-unused-expressions
	} catch (e) {
		// https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
		var errorProto = getProto(getProto(e));
		INTRINSICS['%Error.prototype%'] = errorProto;
	}
}

var doEval = function doEval(name) {
	var value;
	if (name === '%AsyncFunction%') {
		value = getEvalledConstructor('async function () {}');
	} else if (name === '%GeneratorFunction%') {
		value = getEvalledConstructor('function* () {}');
	} else if (name === '%AsyncGeneratorFunction%') {
		value = getEvalledConstructor('async function* () {}');
	} else if (name === '%AsyncGenerator%') {
		var fn = doEval('%AsyncGeneratorFunction%');
		if (fn) {
			value = fn.prototype;
		}
	} else if (name === '%AsyncIteratorPrototype%') {
		var gen = doEval('%AsyncGenerator%');
		if (gen && getProto) {
			value = getProto(gen.prototype);
		}
	}

	INTRINSICS[name] = value;

	return value;
};

var LEGACY_ALIASES = {
	__proto__: null,
	'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
	'%ArrayPrototype%': ['Array', 'prototype'],
	'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
	'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
	'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
	'%ArrayProto_values%': ['Array', 'prototype', 'values'],
	'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
	'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
	'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
	'%BooleanPrototype%': ['Boolean', 'prototype'],
	'%DataViewPrototype%': ['DataView', 'prototype'],
	'%DatePrototype%': ['Date', 'prototype'],
	'%ErrorPrototype%': ['Error', 'prototype'],
	'%EvalErrorPrototype%': ['EvalError', 'prototype'],
	'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
	'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
	'%FunctionPrototype%': ['Function', 'prototype'],
	'%Generator%': ['GeneratorFunction', 'prototype'],
	'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
	'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
	'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
	'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
	'%JSONParse%': ['JSON', 'parse'],
	'%JSONStringify%': ['JSON', 'stringify'],
	'%MapPrototype%': ['Map', 'prototype'],
	'%NumberPrototype%': ['Number', 'prototype'],
	'%ObjectPrototype%': ['Object', 'prototype'],
	'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
	'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
	'%PromisePrototype%': ['Promise', 'prototype'],
	'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
	'%Promise_all%': ['Promise', 'all'],
	'%Promise_reject%': ['Promise', 'reject'],
	'%Promise_resolve%': ['Promise', 'resolve'],
	'%RangeErrorPrototype%': ['RangeError', 'prototype'],
	'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
	'%RegExpPrototype%': ['RegExp', 'prototype'],
	'%SetPrototype%': ['Set', 'prototype'],
	'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
	'%StringPrototype%': ['String', 'prototype'],
	'%SymbolPrototype%': ['Symbol', 'prototype'],
	'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
	'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
	'%TypeErrorPrototype%': ['TypeError', 'prototype'],
	'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
	'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
	'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
	'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
	'%URIErrorPrototype%': ['URIError', 'prototype'],
	'%WeakMapPrototype%': ['WeakMap', 'prototype'],
	'%WeakSetPrototype%': ['WeakSet', 'prototype']
};

var bind = __webpack_require__(58612);
var hasOwn = __webpack_require__(48824);
var $concat = bind.call($call, Array.prototype.concat);
var $spliceApply = bind.call($apply, Array.prototype.splice);
var $replace = bind.call($call, String.prototype.replace);
var $strSlice = bind.call($call, String.prototype.slice);
var $exec = bind.call($call, RegExp.prototype.exec);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var first = $strSlice(string, 0, 1);
	var last = $strSlice(string, -1);
	if (first === '%' && last !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
	} else if (last === '%' && first !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
	}
	var result = [];
	$replace(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	var intrinsicName = name;
	var alias;
	if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
		alias = LEGACY_ALIASES[intrinsicName];
		intrinsicName = '%' + alias[0] + '%';
	}

	if (hasOwn(INTRINSICS, intrinsicName)) {
		var value = INTRINSICS[intrinsicName];
		if (value === needsEval) {
			value = doEval(intrinsicName);
		}
		if (typeof value === 'undefined' && !allowMissing) {
			throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}

		return {
			alias: alias,
			name: intrinsicName,
			value: value
		};
	}

	throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
};

module.exports = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new $TypeError('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new $TypeError('"allowMissing" argument must be a boolean');
	}

	if ($exec(/^%?[^%]*%?$/, name) === null) {
		throw new $SyntaxError('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
	}
	var parts = stringToPath(name);
	var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

	var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
	var intrinsicRealName = intrinsic.name;
	var value = intrinsic.value;
	var skipFurtherCaching = false;

	var alias = intrinsic.alias;
	if (alias) {
		intrinsicBaseName = alias[0];
		$spliceApply(parts, $concat([0, 1], alias));
	}

	for (var i = 1, isOwn = true; i < parts.length; i += 1) {
		var part = parts[i];
		var first = $strSlice(part, 0, 1);
		var last = $strSlice(part, -1);
		if (
			(
				(first === '"' || first === "'" || first === '`')
				|| (last === '"' || last === "'" || last === '`')
			)
			&& first !== last
		) {
			throw new $SyntaxError('property names with quotes must have matching quotes');
		}
		if (part === 'constructor' || !isOwn) {
			skipFurtherCaching = true;
		}

		intrinsicBaseName += '.' + part;
		intrinsicRealName = '%' + intrinsicBaseName + '%';

		if (hasOwn(INTRINSICS, intrinsicRealName)) {
			value = INTRINSICS[intrinsicRealName];
		} else if (value != null) {
			if (!(part in value)) {
				if (!allowMissing) {
					throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				return void undefined;
			}
			if ($gOPD && (i + 1) >= parts.length) {
				var desc = $gOPD(value, part);
				isOwn = !!desc;

				// By convention, when a data property is converted to an accessor
				// property to emulate a data property that does not suffer from
				// the override mistake, that accessor's getter is marked with
				// an `originalValue` property. Here, when we detect this, we
				// uphold the illusion by pretending to see that original data
				// property, i.e., returning the value rather than the getter
				// itself.
				if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
					value = desc.get;
				} else {
					value = value[part];
				}
			} else {
				isOwn = hasOwn(value, part);
				value = value[part];
			}

			if (isOwn && !skipFurtherCaching) {
				INTRINSICS[intrinsicRealName] = value;
			}
		}
	}
	return value;
};


/***/ }),

/***/ 68899:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var $Object = __webpack_require__(68892);

/** @type {import('./Object.getPrototypeOf')} */
module.exports = $Object.getPrototypeOf || null;


/***/ }),

/***/ 10443:
/***/ (function(module) {

"use strict";


/** @type {import('./Reflect.getPrototypeOf')} */
module.exports = (typeof Reflect !== 'undefined' && Reflect.getPrototypeOf) || null;


/***/ }),

/***/ 81618:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var reflectGetProto = __webpack_require__(10443);
var originalGetProto = __webpack_require__(68899);

var getDunderProto = __webpack_require__(96504);

/** @type {import('.')} */
module.exports = reflectGetProto
	? function getProto(O) {
		// @ts-expect-error TS can't narrow inside a closure, for some reason
		return reflectGetProto(O);
	}
	: originalGetProto
		? function getProto(O) {
			if (!O || (typeof O !== 'object' && typeof O !== 'function')) {
				throw new TypeError('getProto: not an object');
			}
			// @ts-expect-error TS can't narrow inside a closure, for some reason
			return originalGetProto(O);
		}
		: getDunderProto
			? function getProto(O) {
				// @ts-expect-error TS can't narrow inside a closure, for some reason
				return getDunderProto(O);
			}
			: null;


/***/ }),

/***/ 40690:
/***/ (function(module) {

"use strict";


/** @type {import('./gOPD')} */
module.exports = Object.getOwnPropertyDescriptor;


/***/ }),

/***/ 27296:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


/** @type {import('.')} */
var $gOPD = __webpack_require__(40690);

if ($gOPD) {
	try {
		$gOPD([], 'length');
	} catch (e) {
		// IE 8 has a broken gOPD
		$gOPD = null;
	}
}

module.exports = $gOPD;


/***/ }),

/***/ 41405:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var origSymbol = typeof Symbol !== 'undefined' && Symbol;
var hasSymbolSham = __webpack_require__(55419);

/** @type {import('.')} */
module.exports = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return hasSymbolSham();
};


/***/ }),

/***/ 55419:
/***/ (function(module) {

"use strict";


/** @type {import('./shams')} */
/* eslint complexity: [2, 18], max-statements: [2, 33] */
module.exports = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	/** @type {{ [k in symbol]?: unknown }} */
	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (var _ in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		// eslint-disable-next-line no-extra-parens
		var descriptor = /** @type {PropertyDescriptor} */ (Object.getOwnPropertyDescriptor(obj, sym));
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};


/***/ }),

/***/ 48824:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var call = Function.prototype.call;
var $hasOwn = Object.prototype.hasOwnProperty;
var bind = __webpack_require__(58612);

/** @type {import('.')} */
module.exports = bind.call(call, $hasOwn);


/***/ }),

/***/ 8679:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(21296);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),

/***/ 96103:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),

/***/ 21296:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(96103);
} else {}


/***/ }),

/***/ 60885:
/***/ (function(__unused_webpack_module, exports) {

/**
 * SVG elements are case-sensitive.
 *
 * @see {@link https://developer.mozilla.org/docs/Web/SVG/Element#svg_elements_a_to_z}
 */
exports.CASE_SENSITIVE_TAG_NAMES = [
  'animateMotion',
  'animateTransform',
  'clipPath',
  'feBlend',
  'feColorMatrix',
  'feComponentTransfer',
  'feComposite',
  'feConvolveMatrix',
  'feDiffuseLighting',
  'feDisplacementMap',
  'feDropShadow',
  'feFlood',
  'feFuncA',
  'feFuncB',
  'feFuncG',
  'feFuncR',
  'feGaussianBlur',
  'feImage',
  'feMerge',
  'feMergeNode',
  'feMorphology',
  'feOffset',
  'fePointLight',
  'feSpecularLighting',
  'feSpotLight',
  'feTile',
  'feTurbulence',
  'foreignObject',
  'linearGradient',
  'radialGradient',
  'textPath'
];


/***/ }),

/***/ 38276:
/***/ (function(module) {

// constants
var HTML = 'html';
var HEAD = 'head';
var BODY = 'body';
var FIRST_TAG_REGEX = /<([a-zA-Z]+[0-9]?)/; // e.g., <h1>
// match-all-characters in case of newlines (DOTALL)
var HEAD_TAG_REGEX = /<head[^]*>/i;
var BODY_TAG_REGEX = /<body[^]*>/i;

// falls back to `parseFromString` if `createHTMLDocument` cannot be used
var parseFromDocument = function () {
  throw new Error(
    'This browser does not support `document.implementation.createHTMLDocument`'
  );
};

var parseFromString = function () {
  throw new Error(
    'This browser does not support `DOMParser.prototype.parseFromString`'
  );
};

var DOMParser = typeof window === 'object' && window.DOMParser;

/**
 * DOMParser (performance: slow).
 *
 * @see https://developer.mozilla.org/docs/Web/API/DOMParser#Parsing_an_SVG_or_HTML_document
 */
if (typeof DOMParser === 'function') {
  var domParser = new DOMParser();
  var mimeType = 'text/html';

  /**
   * Creates an HTML document using `DOMParser.parseFromString`.
   *
   * @param  {string} html      - The HTML string.
   * @param  {string} [tagName] - The element to render the HTML (with 'body' as fallback).
   * @return {HTMLDocument}
   */
  parseFromString = function (html, tagName) {
    if (tagName) {
      html = '<' + tagName + '>' + html + '</' + tagName + '>';
    }

    return domParser.parseFromString(html, mimeType);
  };

  parseFromDocument = parseFromString;
}

/**
 * DOMImplementation (performance: fair).
 *
 * @see https://developer.mozilla.org/docs/Web/API/DOMImplementation/createHTMLDocument
 */
if (typeof document === 'object' && document.implementation) {
  var doc = document.implementation.createHTMLDocument();

  /**
   * Use HTML document created by `document.implementation.createHTMLDocument`.
   *
   * @param  {string} html      - The HTML string.
   * @param  {string} [tagName] - The element to render the HTML (with 'body' as fallback).
   * @return {HTMLDocument}
   */
  parseFromDocument = function (html, tagName) {
    if (tagName) {
      var element = doc.documentElement.querySelector(tagName);
      element.innerHTML = html;
      return doc;
    }

    doc.documentElement.innerHTML = html;
    return doc;
  };
}

/**
 * Template (performance: fast).
 *
 * @see https://developer.mozilla.org/docs/Web/HTML/Element/template
 */
var template =
  typeof document === 'object' ? document.createElement('template') : {};

var parseFromTemplate;

if (template.content) {
  /**
   * Uses a template element (content fragment) to parse HTML.
   *
   * @param  {string} html - The HTML string.
   * @return {NodeList}
   */
  parseFromTemplate = function (html) {
    template.innerHTML = html;
    return template.content.childNodes;
  };
}

/**
 * Parses HTML string to DOM nodes.
 *
 * @param  {string}   html - HTML markup.
 * @return {NodeList}
 */
function domparser(html) {
  var firstTagName;
  var match = html.match(FIRST_TAG_REGEX);

  if (match && match[1]) {
    firstTagName = match[1].toLowerCase();
  }

  var doc;
  var element;
  var elements;

  switch (firstTagName) {
    case HTML:
      doc = parseFromString(html);

      // the created document may come with filler head/body elements,
      // so make sure to remove them if they don't actually exist
      if (!HEAD_TAG_REGEX.test(html)) {
        element = doc.querySelector(HEAD);
        if (element) {
          element.parentNode.removeChild(element);
        }
      }

      if (!BODY_TAG_REGEX.test(html)) {
        element = doc.querySelector(BODY);
        if (element) {
          element.parentNode.removeChild(element);
        }
      }

      return doc.querySelectorAll(HTML);

    case HEAD:
    case BODY:
      doc = parseFromDocument(html);
      elements = doc.querySelectorAll(firstTagName);

      // if there's a sibling element, then return both elements
      if (BODY_TAG_REGEX.test(html) && HEAD_TAG_REGEX.test(html)) {
        return elements[0].parentNode.childNodes;
      }
      return elements;

    // low-level tag or text
    default:
      if (parseFromTemplate) {
        return parseFromTemplate(html);
      }
      element = parseFromDocument(html, BODY).querySelector(BODY);
      return element.childNodes;
  }
}

module.exports = domparser;


/***/ }),

/***/ 14152:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var domparser = __webpack_require__(38276);
var utilities = __webpack_require__(1507);

var formatDOM = utilities.formatDOM;

var DIRECTIVE_REGEX = /<(![a-zA-Z\s]+)>/; // e.g., <!doctype html>

/**
 * Parses HTML string to DOM nodes in browser.
 *
 * @param  {string} html  - HTML markup.
 * @return {DomElement[]} - DOM elements.
 */
function HTMLDOMParser(html) {
  if (typeof html !== 'string') {
    throw new TypeError('First argument must be a string');
  }

  if (html === '') {
    return [];
  }

  // match directive
  var match = html.match(DIRECTIVE_REGEX);
  var directive;

  if (match && match[1]) {
    directive = match[1];
  }

  return formatDOM(domparser(html), null, directive);
}

module.exports = HTMLDOMParser;


/***/ }),

/***/ 1507:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var domhandler = __webpack_require__(47915);
var constants = __webpack_require__(60885);

var CASE_SENSITIVE_TAG_NAMES = constants.CASE_SENSITIVE_TAG_NAMES;

var Comment = domhandler.Comment;
var Element = domhandler.Element;
var ProcessingInstruction = domhandler.ProcessingInstruction;
var Text = domhandler.Text;

var caseSensitiveTagNamesMap = {};
var tagName;

for (var i = 0, len = CASE_SENSITIVE_TAG_NAMES.length; i < len; i++) {
  tagName = CASE_SENSITIVE_TAG_NAMES[i];
  caseSensitiveTagNamesMap[tagName.toLowerCase()] = tagName;
}

/**
 * Gets case-sensitive tag name.
 *
 * @param {string} tagName - Tag name in lowercase.
 * @returns {string|undefined} - Case-sensitive tag name.
 */
function getCaseSensitiveTagName(tagName) {
  return caseSensitiveTagNamesMap[tagName];
}

/**
 * Formats DOM attributes to a hash map.
 *
 * @param {NamedNodeMap} attributes - List of attributes.
 * @returns {object} - Map of attribute name to value.
 */
function formatAttributes(attributes) {
  var result = {};
  var attribute;
  // `NamedNodeMap` is array-like
  for (var i = 0, len = attributes.length; i < len; i++) {
    attribute = attributes[i];
    result[attribute.name] = attribute.value;
  }
  return result;
}

/**
 * Corrects the tag name if it is case-sensitive (SVG).
 * Otherwise, returns the lowercase tag name (HTML).
 *
 * @param {string} tagName - Lowercase tag name.
 * @returns {string} - Formatted tag name.
 */
function formatTagName(tagName) {
  tagName = tagName.toLowerCase();
  var caseSensitiveTagName = getCaseSensitiveTagName(tagName);
  if (caseSensitiveTagName) {
    return caseSensitiveTagName;
  }
  return tagName;
}

/**
 * Transforms DOM nodes to `domhandler` nodes.
 *
 * @param {NodeList} nodes - DOM nodes.
 * @param {Element|null} [parent=null] - Parent node.
 * @param {string} [directive] - Directive.
 * @returns {Array<Comment|Element|ProcessingInstruction|Text>}
 */
function formatDOM(nodes, parent, directive) {
  parent = parent || null;
  var result = [];
  var tagName;

  for (var index = 0, len = nodes.length; index < len; index++) {
    var node = nodes[index];
    var current;

    // set the node data given the type
    switch (node.nodeType) {
      case 1:
        tagName = formatTagName(node.nodeName);
        // script, style, or tag
        current = new Element(tagName, formatAttributes(node.attributes));
        current.children = formatDOM(
          // template children are on content
          tagName === 'template' ? node.content.childNodes : node.childNodes,
          current
        );
        break;

      case 3:
        current = new Text(node.nodeValue);
        break;

      case 8:
        current = new Comment(node.nodeValue);
        break;

      default:
        continue;
    }

    // set previous node next
    var prev = result[index - 1] || null;
    if (prev) {
      prev.next = current;
    }

    // set properties for current node
    current.parent = parent;
    current.prev = prev;
    current.next = null;

    result.push(current);
  }

  if (directive) {
    current = new ProcessingInstruction(
      directive.substring(0, directive.indexOf(' ')).toLowerCase(),
      directive
    );
    current.next = result[0] || null;
    current.parent = parent;
    result.unshift(current);

    if (result[1]) {
      result[1].prev = result[0];
    }
  }

  return result;
}

exports.formatAttributes = formatAttributes;
exports.formatDOM = formatDOM;


/***/ }),

/***/ 30488:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var domhandler = __webpack_require__(47915);
var htmlToDOM = __webpack_require__(14152);

var attributesToProps = __webpack_require__(50484);
var domToReact = __webpack_require__(53670);

// support backwards compatibility for ES Module
htmlToDOM =
  /* istanbul ignore next */
  typeof htmlToDOM.default === 'function' ? htmlToDOM.default : htmlToDOM;

var domParserOptions = { lowerCaseAttributeNames: false };

/**
 * Converts HTML string to React elements.
 *
 * @param {string} html - HTML string.
 * @param {object} [options] - Parser options.
 * @param {object} [options.htmlparser2] - htmlparser2 options.
 * @param {object} [options.library] - Library for React, Preact, etc.
 * @param {Function} [options.replace] - Replace method.
 * @returns {JSX.Element|JSX.Element[]|string} - React element(s), empty array, or string.
 */
function HTMLReactParser(html, options) {
  if (typeof html !== 'string') {
    throw new TypeError('First argument must be a string');
  }
  if (html === '') {
    return [];
  }
  options = options || {};
  return domToReact(
    htmlToDOM(html, options.htmlparser2 || domParserOptions),
    options
  );
}

HTMLReactParser.domToReact = domToReact;
HTMLReactParser.htmlToDOM = htmlToDOM;
HTMLReactParser.attributesToProps = attributesToProps;

// domhandler
HTMLReactParser.Comment = domhandler.Comment;
HTMLReactParser.Element = domhandler.Element;
HTMLReactParser.ProcessingInstruction = domhandler.ProcessingInstruction;
HTMLReactParser.Text = domhandler.Text;

// support CommonJS and ES Modules
module.exports = HTMLReactParser;
HTMLReactParser.default = HTMLReactParser;


/***/ }),

/***/ 50484:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var reactProperty = __webpack_require__(83);
var utilities = __webpack_require__(74606);

// https://reactjs.org/docs/uncontrolled-components.html
// https://developer.mozilla.org/docs/Web/HTML/Attributes
var UNCONTROLLED_COMPONENT_ATTRIBUTES = ['checked', 'value'];
var UNCONTROLLED_COMPONENT_NAMES = ['input', 'select', 'textarea'];

var VALUE_ONLY_INPUTS = {
  reset: true,
  submit: true
};

/**
 * Converts HTML/SVG DOM attributes to React props.
 *
 * @param {object} [attributes={}] - HTML/SVG DOM attributes.
 * @param {string} [nodeName] - DOM node name.
 * @returns - React props.
 */
module.exports = function attributesToProps(attributes, nodeName) {
  attributes = attributes || {};

  var attributeName;
  var attributeNameLowerCased;
  var attributeValue;
  var propName;
  var propertyInfo;
  var props = {};
  var inputIsValueOnly = attributes.type && VALUE_ONLY_INPUTS[attributes.type];

  for (attributeName in attributes) {
    attributeValue = attributes[attributeName];

    // ARIA (aria-*) or custom data (data-*) attribute
    if (reactProperty.isCustomAttribute(attributeName)) {
      props[attributeName] = attributeValue;
      continue;
    }

    // convert HTML/SVG attribute to React prop
    attributeNameLowerCased = attributeName.toLowerCase();
    propName = getPropName(attributeNameLowerCased);

    if (propName) {
      propertyInfo = reactProperty.getPropertyInfo(propName);

      // convert attribute to uncontrolled component prop (e.g., `value` to `defaultValue`)
      if (
        UNCONTROLLED_COMPONENT_ATTRIBUTES.indexOf(propName) !== -1 &&
        UNCONTROLLED_COMPONENT_NAMES.indexOf(nodeName) !== -1 &&
        !inputIsValueOnly
      ) {
        propName = getPropName('default' + attributeNameLowerCased);
      }

      props[propName] = attributeValue;

      switch (propertyInfo && propertyInfo.type) {
        case reactProperty.BOOLEAN:
          props[propName] = true;
          break;
        case reactProperty.OVERLOADED_BOOLEAN:
          if (attributeValue === '') {
            props[propName] = true;
          }
          break;
      }
      continue;
    }

    // preserve custom attribute if React >=16
    if (utilities.PRESERVE_CUSTOM_ATTRIBUTES) {
      props[attributeName] = attributeValue;
    }
  }

  // transform inline style to object
  utilities.setStyleProp(attributes.style, props);

  return props;
};

/**
 * Gets prop name from lowercased attribute name.
 *
 * @param {string} attributeName - Lowercased attribute name.
 * @returns - Prop name.
 */
function getPropName(attributeName) {
  return reactProperty.possibleStandardNames[attributeName];
}


/***/ }),

/***/ 53670:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var React = __webpack_require__(67294);
var attributesToProps = __webpack_require__(50484);
var utilities = __webpack_require__(74606);

var setStyleProp = utilities.setStyleProp;
var canTextBeChildOfNode = utilities.canTextBeChildOfNode;

/**
 * Converts DOM nodes to JSX element(s).
 *
 * @param {DomElement[]} nodes - DOM nodes.
 * @param {object} [options={}] - Options.
 * @param {Function} [options.replace] - Replacer.
 * @param {object} [options.library] - Library (React, Preact, etc.).
 * @returns - String or JSX element(s).
 */
function domToReact(nodes, options) {
  options = options || {};

  var library = options.library || React;
  var cloneElement = library.cloneElement;
  var createElement = library.createElement;
  var isValidElement = library.isValidElement;

  var result = [];
  var node;
  var isWhitespace;
  var hasReplace = typeof options.replace === 'function';
  var replaceElement;
  var props;
  var children;
  var trim = options.trim;

  for (var i = 0, len = nodes.length; i < len; i++) {
    node = nodes[i];

    // replace with custom React element (if present)
    if (hasReplace) {
      replaceElement = options.replace(node);

      if (isValidElement(replaceElement)) {
        // set "key" prop for sibling elements
        // https://fb.me/react-warning-keys
        if (len > 1) {
          replaceElement = cloneElement(replaceElement, {
            key: replaceElement.key || i
          });
        }
        result.push(replaceElement);
        continue;
      }
    }

    if (node.type === 'text') {
      isWhitespace = !node.data.trim().length;

      if (isWhitespace && node.parent && !canTextBeChildOfNode(node.parent)) {
        // We have a whitespace node that can't be nested in its parent
        // so skip it
        continue;
      }

      if (trim && isWhitespace) {
        // Trim is enabled and we have a whitespace node
        // so skip it
        continue;
      }

      // We have a text node that's not whitespace and it can be nested
      // in its parent so add it to the results
      result.push(node.data);
      continue;
    }

    props = node.attribs;
    if (skipAttributesToProps(node)) {
      setStyleProp(props.style, props);
    } else if (props) {
      props = attributesToProps(props, node.name);
    }

    children = null;

    switch (node.type) {
      case 'script':
      case 'style':
        // prevent text in <script> or <style> from being escaped
        // https://reactjs.org/docs/dom-elements.html#dangerouslysetinnerhtml
        if (node.children[0]) {
          props.dangerouslySetInnerHTML = {
            __html: node.children[0].data
          };
        }
        break;

      case 'tag':
        // setting textarea value in children is an antipattern in React
        // https://reactjs.org/docs/forms.html#the-textarea-tag
        if (node.name === 'textarea' && node.children[0]) {
          props.defaultValue = node.children[0].data;
        } else if (node.children && node.children.length) {
          // continue recursion of creating React elements (if applicable)
          children = domToReact(node.children, options);
        }
        break;

      // skip all other cases (e.g., comment)
      default:
        continue;
    }

    // set "key" prop for sibling elements
    // https://fb.me/react-warning-keys
    if (len > 1) {
      props.key = i;
    }

    result.push(createElement(node.name, props, children));
  }

  return result.length === 1 ? result[0] : result;
}

/**
 * Determines whether DOM element attributes should be transformed to props.
 * Web Components should not have their attributes transformed except for `style`.
 *
 * @param {DomElement} node
 * @returns - Whether node attributes should be converted to props.
 */
function skipAttributesToProps(node) {
  return (
    utilities.PRESERVE_CUSTOM_ATTRIBUTES &&
    node.type === 'tag' &&
    utilities.isCustomComponent(node.name, node.attribs)
  );
}

module.exports = domToReact;


/***/ }),

/***/ 74606:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var React = __webpack_require__(67294);
var styleToJS = (__webpack_require__(41476)["default"]);

/**
 * Swap key with value in an object.
 *
 * @param {object} obj - The object.
 * @param {Function} [override] - The override method.
 * @returns - The inverted object.
 */
function invertObject(obj, override) {
  if (!obj || typeof obj !== 'object') {
    throw new TypeError('First argument must be an object');
  }

  var key;
  var value;
  var isOverridePresent = typeof override === 'function';
  var overrides = {};
  var result = {};

  for (key in obj) {
    value = obj[key];

    if (isOverridePresent) {
      overrides = override(key, value);
      if (overrides && overrides.length === 2) {
        result[overrides[0]] = overrides[1];
        continue;
      }
    }

    if (typeof value === 'string') {
      result[value] = key;
    }
  }

  return result;
}

/**
 * Check if a given tag is a custom component.
 *
 * @see {@link https://github.com/facebook/react/blob/v16.6.3/packages/react-dom/src/shared/isCustomComponent.js}
 *
 * @param {string} tagName - The name of the html tag.
 * @param {object} props - The props being passed to the element.
 * @returns - Whether tag is custom component.
 */
function isCustomComponent(tagName, props) {
  if (tagName.indexOf('-') === -1) {
    return props && typeof props.is === 'string';
  }

  switch (tagName) {
    // These are reserved SVG and MathML elements.
    // We don't mind this whitelist too much because we expect it to never grow.
    // The alternative is to track the namespace in a few places which is convoluted.
    // https://w3c.github.io/webcomponents/spec/custom/#custom-elements-core-concepts
    case 'annotation-xml':
    case 'color-profile':
    case 'font-face':
    case 'font-face-src':
    case 'font-face-uri':
    case 'font-face-format':
    case 'font-face-name':
    case 'missing-glyph':
      return false;
    default:
      return true;
  }
}

var styleToJSOptions = { reactCompat: true };

/**
 * Sets style prop.
 *
 * @param {null|undefined|string} style
 * @param {object} props
 */
function setStyleProp(style, props) {
  if (style === null || style === undefined) {
    return;
  }
  try {
    props.style = styleToJS(style, styleToJSOptions);
  } catch (err) {
    props.style = {};
  }
}

/**
 * @constant {boolean}
 * @see {@link https://reactjs.org/blog/2017/09/08/dom-attributes-in-react-16.html}
 */
var PRESERVE_CUSTOM_ATTRIBUTES = React.version.split('.')[0] >= 16;

// Taken from
// https://github.com/facebook/react/blob/cae635054e17a6f107a39d328649137b83f25972/packages/react-dom/src/client/validateDOMNesting.js#L213
var elementsWithNoTextChildren = new Set([
  'tr',
  'tbody',
  'thead',
  'tfoot',
  'colgroup',
  'table',
  'head',
  'html',
  'frameset'
]);

/**
 * Checks if the given node can contain text nodes
 *
 * @param {DomElement} node - Node.
 * @returns - Whether node can contain text nodes.
 */
function canTextBeChildOfNode(node) {
  return !elementsWithNoTextChildren.has(node.name);
}

module.exports = {
  PRESERVE_CUSTOM_ATTRIBUTES: PRESERVE_CUSTOM_ATTRIBUTES,
  invertObject: invertObject,
  isCustomComponent: isCustomComponent,
  setStyleProp: setStyleProp,
  canTextBeChildOfNode: canTextBeChildOfNode,
  elementsWithNoTextChildren: elementsWithNoTextChildren
};


/***/ }),

/***/ 81580:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Backend; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(15671);
/* harmony import */ var _babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43144);



var arr = [];
var each = arr.forEach;
var slice = arr.slice;
function defaults(obj) {
  each.call(slice.call(arguments, 1), function (source) {
    if (source) {
      for (var prop in source) {
        if (obj[prop] === undefined) obj[prop] = source[prop];
      }
    }
  });
  return obj;
}
function createClassOnDemand(ClassOrObject) {
  if (!ClassOrObject) return null;
  if (typeof ClassOrObject === 'function') return new ClassOrObject();
  return ClassOrObject;
}

function getDefaults() {
  return {
    handleEmptyResourcesAsFailed: true,
    cacheHitMode: 'none'
    // reloadInterval: typeof window !== 'undefined' ? false : 60 * 60 * 1000
    // refreshExpirationTime: 60 * 60 * 1000
  };
}

function handleCorrectReadFunction(backend, language, namespace, resolver) {
  var fc = backend.read.bind(backend);
  if (fc.length === 2) {
    // no callback
    try {
      var r = fc(language, namespace);
      if (r && typeof r.then === 'function') {
        // promise
        r.then(function (data) {
          return resolver(null, data);
        })["catch"](resolver);
      } else {
        // sync
        resolver(null, r);
      }
    } catch (err) {
      resolver(err);
    }
    return;
  }

  // normal with callback
  fc(language, namespace, resolver);
}
var Backend = /*#__PURE__*/function () {
  function Backend(services) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var i18nextOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    (0,_babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, Backend);
    this.backends = [];
    this.type = 'backend';
    this.allOptions = i18nextOptions;
    this.init(services, options);
  }
  (0,_babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(Backend, [{
    key: "init",
    value: function init(services) {
      var _this = this;
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var i18nextOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      this.services = services;
      this.options = defaults(options, this.options || {}, getDefaults());
      this.allOptions = i18nextOptions;
      this.options.backends && this.options.backends.forEach(function (b, i) {
        _this.backends[i] = _this.backends[i] || createClassOnDemand(b);
        _this.backends[i].init(services, _this.options.backendOptions && _this.options.backendOptions[i] || {}, i18nextOptions);
      });
      if (this.services && this.options.reloadInterval) {
        setInterval(function () {
          return _this.reload();
        }, this.options.reloadInterval);
      }
    }
  }, {
    key: "read",
    value: function read(language, namespace, callback) {
      var _this2 = this;
      var bLen = this.backends.length;
      var loadPosition = function loadPosition(pos) {
        if (pos >= bLen) return callback(new Error('non of the backend loaded data', true)); // failed pass retry flag
        var isLastBackend = pos === bLen - 1;
        var lengthCheckAmount = _this2.options.handleEmptyResourcesAsFailed && !isLastBackend ? 0 : -1;
        var backend = _this2.backends[pos];
        if (backend.read) {
          handleCorrectReadFunction(backend, language, namespace, function (err, data, savedAt) {
            if (!err && data && Object.keys(data).length > lengthCheckAmount) {
              callback(null, data, pos);
              savePosition(pos - 1, data); // save one in front
              if (backend.save && _this2.options.cacheHitMode && ['refresh', 'refreshAndUpdateStore'].indexOf(_this2.options.cacheHitMode) > -1) {
                if (savedAt && _this2.options.refreshExpirationTime && savedAt + _this2.options.refreshExpirationTime > Date.now()) return;
                var nextBackend = _this2.backends[pos + 1];
                if (nextBackend && nextBackend.read) {
                  handleCorrectReadFunction(nextBackend, language, namespace, function (err, data) {
                    if (err) return;
                    if (!data) return;
                    if (Object.keys(data).length <= lengthCheckAmount) return;
                    savePosition(pos, data);
                    if (_this2.options.cacheHitMode !== 'refreshAndUpdateStore') return;
                    if (_this2.services && _this2.services.resourceStore) {
                      _this2.services.resourceStore.addResourceBundle(language, namespace, data);
                    }
                  });
                }
              }
            } else {
              loadPosition(pos + 1); // try load from next
            }
          });
        } else {
          loadPosition(pos + 1); // try load from next
        }
      };

      var savePosition = function savePosition(pos, data) {
        if (pos < 0) return;
        var backend = _this2.backends[pos];
        if (backend.save) {
          backend.save(language, namespace, data);
          savePosition(pos - 1, data);
        } else {
          savePosition(pos - 1, data);
        }
      };
      loadPosition(0);
    }
  }, {
    key: "create",
    value: function create(languages, namespace, key, fallbackValue) {
      var clb = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function () {};
      var opts = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
      this.backends.forEach(function (b) {
        if (!b.create) return;
        var fc = b.create.bind(b);
        if (fc.length < 6) {
          // no callback
          try {
            var r;
            if (fc.length === 5) {
              // future callback-less api for i18next-locize-backend
              r = fc(languages, namespace, key, fallbackValue, opts);
            } else {
              r = fc(languages, namespace, key, fallbackValue);
            }
            if (r && typeof r.then === 'function') {
              // promise
              r.then(function (data) {
                return clb(null, data);
              })["catch"](clb);
            } else {
              // sync
              clb(null, r);
            }
          } catch (err) {
            clb(err);
          }
          return;
        }

        // normal with callback
        fc(languages, namespace, key, fallbackValue, clb /* unused callback */, opts);
      });
    }
  }, {
    key: "reload",
    value: function reload() {
      var _this3 = this;
      var _this$services = this.services,
        backendConnector = _this$services.backendConnector,
        languageUtils = _this$services.languageUtils,
        logger = _this$services.logger;
      var currentLanguage = backendConnector.language;
      if (currentLanguage && currentLanguage.toLowerCase() === 'cimode') return; // avoid loading resources for cimode

      var toLoad = [];
      var append = function append(lng) {
        var lngs = languageUtils.toResolveHierarchy(lng);
        lngs.forEach(function (l) {
          if (toLoad.indexOf(l) < 0) toLoad.push(l);
        });
      };
      append(currentLanguage);
      if (this.allOptions.preload) this.allOptions.preload.forEach(function (l) {
        return append(l);
      });
      toLoad.forEach(function (lng) {
        _this3.allOptions.ns.forEach(function (ns) {
          backendConnector.read(lng, ns, 'read', null, null, function (err, data) {
            if (err) logger.warn("loading namespace ".concat(ns, " for language ").concat(lng, " failed"), err);
            if (!err && data) logger.log("loaded namespace ".concat(ns, " for language ").concat(lng), data);
            backendConnector.loaded("".concat(lng, "|").concat(ns), err, data);
          });
        });
      });
    }
  }]);
  return Backend;
}();
Backend.type = 'backend';




/***/ }),

/***/ 70660:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Cache; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4942);
/* harmony import */ var _babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15671);
/* harmony import */ var _babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43144);




function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-classes-per-file */
var Storage = /*#__PURE__*/function () {
  function Storage(options) {
    (0,_babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, Storage);
    this.store = options.store;
  }
  (0,_babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(Storage, [{
    key: "setItem",
    value: function setItem(key, value) {
      if (this.store) {
        try {
          this.store.setItem(key, value);
        } catch (e) {
          // f.log('failed to set value for key "' + key + '" to localStorage.');
        }
      }
    }
  }, {
    key: "getItem",
    value: function getItem(key, value) {
      if (this.store) {
        try {
          return this.store.getItem(key, value);
        } catch (e) {
          // f.log('failed to get value for key "' + key + '" from localStorage.');
        }
      }
      return undefined;
    }
  }]);
  return Storage;
}();
function getDefaults() {
  var store = null;
  try {
    store = window.localStorage;
  } catch (e) {
    if (typeof window !== 'undefined') {
      console.log('Failed to load local storage.', e);
    }
  }
  return {
    prefix: 'i18next_res_',
    expirationTime: 7 * 24 * 60 * 60 * 1000,
    defaultVersion: undefined,
    versions: {},
    store: store
  };
}
var Cache = /*#__PURE__*/function () {
  function Cache(services) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    (0,_babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, Cache);
    this.init(services, options);
    this.type = 'backend';
  }
  (0,_babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(Cache, [{
    key: "init",
    value: function init(services) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.services = services;
      this.options = _objectSpread(_objectSpread(_objectSpread({}, getDefaults()), this.options), options);
      this.storage = new Storage(this.options);
    }
  }, {
    key: "read",
    value: function read(language, namespace, callback) {
      var nowMS = Date.now();
      if (!this.storage.store) {
        return callback(null, null);
      }
      var local = this.storage.getItem("".concat(this.options.prefix).concat(language, "-").concat(namespace));
      if (local) {
        local = JSON.parse(local);
        var version = this.getVersion(language);
        if (
        // expiration field is mandatory, and should not be expired
        local.i18nStamp && local.i18nStamp + this.options.expirationTime > nowMS &&
        // there should be no language version set, or if it is, it should match the one in translation
        version === local.i18nVersion) {
          var i18nStamp = local.i18nStamp;
          delete local.i18nVersion;
          delete local.i18nStamp;
          return callback(null, local, i18nStamp);
        }
      }
      return callback(null, null);
    }
  }, {
    key: "save",
    value: function save(language, namespace, data) {
      if (this.storage.store) {
        data.i18nStamp = Date.now();

        // language version (if set)
        var version = this.getVersion(language);
        if (version) {
          data.i18nVersion = version;
        }

        // save
        this.storage.setItem("".concat(this.options.prefix).concat(language, "-").concat(namespace), JSON.stringify(data));
      }
    }
  }, {
    key: "getVersion",
    value: function getVersion(language) {
      return this.options.versions[language] || this.options.defaultVersion;
    }
  }]);
  return Cache;
}();
Cache.type = 'backend';




/***/ }),

/***/ 80645:
/***/ (function(__unused_webpack_module, exports) {

/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),

/***/ 18139:
/***/ (function(module) {

// http://www.w3.org/TR/CSS21/grammar.html
// https://github.com/visionmedia/css-parse/pull/49#issuecomment-30088027
var COMMENT_REGEX = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g;

var NEWLINE_REGEX = /\n/g;
var WHITESPACE_REGEX = /^\s*/;

// declaration
var PROPERTY_REGEX = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/;
var COLON_REGEX = /^:\s*/;
var VALUE_REGEX = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/;
var SEMICOLON_REGEX = /^[;\s]*/;

// https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim#Polyfill
var TRIM_REGEX = /^\s+|\s+$/g;

// strings
var NEWLINE = '\n';
var FORWARD_SLASH = '/';
var ASTERISK = '*';
var EMPTY_STRING = '';

// types
var TYPE_COMMENT = 'comment';
var TYPE_DECLARATION = 'declaration';

/**
 * @param {String} style
 * @param {Object} [options]
 * @return {Object[]}
 * @throws {TypeError}
 * @throws {Error}
 */
module.exports = function(style, options) {
  if (typeof style !== 'string') {
    throw new TypeError('First argument must be a string');
  }

  if (!style) return [];

  options = options || {};

  /**
   * Positional.
   */
  var lineno = 1;
  var column = 1;

  /**
   * Update lineno and column based on `str`.
   *
   * @param {String} str
   */
  function updatePosition(str) {
    var lines = str.match(NEWLINE_REGEX);
    if (lines) lineno += lines.length;
    var i = str.lastIndexOf(NEWLINE);
    column = ~i ? str.length - i : column + str.length;
  }

  /**
   * Mark position and patch `node.position`.
   *
   * @return {Function}
   */
  function position() {
    var start = { line: lineno, column: column };
    return function(node) {
      node.position = new Position(start);
      whitespace();
      return node;
    };
  }

  /**
   * Store position information for a node.
   *
   * @constructor
   * @property {Object} start
   * @property {Object} end
   * @property {undefined|String} source
   */
  function Position(start) {
    this.start = start;
    this.end = { line: lineno, column: column };
    this.source = options.source;
  }

  /**
   * Non-enumerable source string.
   */
  Position.prototype.content = style;

  var errorsList = [];

  /**
   * Error `msg`.
   *
   * @param {String} msg
   * @throws {Error}
   */
  function error(msg) {
    var err = new Error(
      options.source + ':' + lineno + ':' + column + ': ' + msg
    );
    err.reason = msg;
    err.filename = options.source;
    err.line = lineno;
    err.column = column;
    err.source = style;

    if (options.silent) {
      errorsList.push(err);
    } else {
      throw err;
    }
  }

  /**
   * Match `re` and return captures.
   *
   * @param {RegExp} re
   * @return {undefined|Array}
   */
  function match(re) {
    var m = re.exec(style);
    if (!m) return;
    var str = m[0];
    updatePosition(str);
    style = style.slice(str.length);
    return m;
  }

  /**
   * Parse whitespace.
   */
  function whitespace() {
    match(WHITESPACE_REGEX);
  }

  /**
   * Parse comments.
   *
   * @param {Object[]} [rules]
   * @return {Object[]}
   */
  function comments(rules) {
    var c;
    rules = rules || [];
    while ((c = comment())) {
      if (c !== false) {
        rules.push(c);
      }
    }
    return rules;
  }

  /**
   * Parse comment.
   *
   * @return {Object}
   * @throws {Error}
   */
  function comment() {
    var pos = position();
    if (FORWARD_SLASH != style.charAt(0) || ASTERISK != style.charAt(1)) return;

    var i = 2;
    while (
      EMPTY_STRING != style.charAt(i) &&
      (ASTERISK != style.charAt(i) || FORWARD_SLASH != style.charAt(i + 1))
    ) {
      ++i;
    }
    i += 2;

    if (EMPTY_STRING === style.charAt(i - 1)) {
      return error('End of comment missing');
    }

    var str = style.slice(2, i - 2);
    column += 2;
    updatePosition(str);
    style = style.slice(i);
    column += 2;

    return pos({
      type: TYPE_COMMENT,
      comment: str
    });
  }

  /**
   * Parse declaration.
   *
   * @return {Object}
   * @throws {Error}
   */
  function declaration() {
    var pos = position();

    // prop
    var prop = match(PROPERTY_REGEX);
    if (!prop) return;
    comment();

    // :
    if (!match(COLON_REGEX)) return error("property missing ':'");

    // val
    var val = match(VALUE_REGEX);

    var ret = pos({
      type: TYPE_DECLARATION,
      property: trim(prop[0].replace(COMMENT_REGEX, EMPTY_STRING)),
      value: val
        ? trim(val[0].replace(COMMENT_REGEX, EMPTY_STRING))
        : EMPTY_STRING
    });

    // ;
    match(SEMICOLON_REGEX);

    return ret;
  }

  /**
   * Parse declarations.
   *
   * @return {Object[]}
   */
  function declarations() {
    var decls = [];

    comments(decls);

    // declarations
    var decl;
    while ((decl = declaration())) {
      if (decl !== false) {
        decls.push(decl);
        comments(decls);
      }
    }

    return decls;
  }

  whitespace();
  return declarations();
};

/**
 * Trim `str`.
 *
 * @param {String} str
 * @return {String}
 */
function trim(str) {
  return str ? str.replace(TRIM_REGEX, EMPTY_STRING) : EMPTY_STRING;
}


/***/ }),

/***/ 41143:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {}

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),

/***/ 29238:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = window.DOMPurify || (window.DOMPurify = (__webpack_require__(27856)["default"]) || __webpack_require__(27856));

/***/ }),

/***/ 35823:
/***/ (function(module) {

module.exports = function(data, filename, mime, bom) {
    var blobData = (typeof bom !== 'undefined') ? [bom, data] : [data]
    var blob = new Blob(blobData, {type: mime || 'application/octet-stream'});
    if (typeof window.navigator.msSaveBlob !== 'undefined') {
        // IE workaround for "HTML7007: One or more blob URLs were
        // revoked by closing the blob for which they were created.
        // These URLs will no longer resolve as the data backing
        // the URL has been freed."
        window.navigator.msSaveBlob(blob, filename);
    }
    else {
        var blobURL = (window.URL && window.URL.createObjectURL) ? window.URL.createObjectURL(blob) : window.webkitURL.createObjectURL(blob);
        var tempLink = document.createElement('a');
        tempLink.style.display = 'none';
        tempLink.href = blobURL;
        tempLink.setAttribute('download', filename);

        // Safari thinks _blank anchor are pop ups. We only want to set _blank
        // target if the browser does not support the HTML5 download attribute.
        // This allows you to download files in desktop safari if pop up blocking
        // is enabled.
        if (typeof tempLink.download === 'undefined') {
            tempLink.setAttribute('target', '_blank');
        }

        document.body.appendChild(tempLink);
        tempLink.click();

        // Fixes "webkit blob resource error 1"
        setTimeout(function() {
            document.body.removeChild(tempLink);
            window.URL.revokeObjectURL(blobURL);
        }, 200)
    }
}


/***/ }),

/***/ 80973:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var camel2hyphen = __webpack_require__(71169);

var isDimension = function (feature) {
  var re = /[height|width]$/;
  return re.test(feature);
};

var obj2mq = function (obj) {
  var mq = '';
  var features = Object.keys(obj);
  features.forEach(function (feature, index) {
    var value = obj[feature];
    feature = camel2hyphen(feature);
    // Add px to dimension features
    if (isDimension(feature) && typeof value === 'number') {
      value = value + 'px';
    }
    if (value === true) {
      mq += feature;
    } else if (value === false) {
      mq += 'not ' + feature;
    } else {
      mq += '(' + feature + ': ' + value + ')';
    }
    if (index < features.length-1) {
      mq += ' and '
    }
  });
  return mq;
};

var json2mq = function (query) {
  var mq = '';
  if (typeof query === 'string') {
    return query;
  }
  // Handling array of media queries
  if (query instanceof Array) {
    query.forEach(function (q, index) {
      mq += obj2mq(q);
      if (index < query.length-1) {
        mq += ', '
      }
    });
    return mq;
  }
  // Handling single media query
  return obj2mq(query);
};

module.exports = json2mq;

/***/ }),

/***/ 83465:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/**
 * Adds the key-value `pair` to `map`.
 *
 * @private
 * @param {Object} map The map to modify.
 * @param {Array} pair The key-value pair to add.
 * @returns {Object} Returns `map`.
 */
function addMapEntry(map, pair) {
  // Don't return `map.set` because it's not chainable in IE 11.
  map.set(pair[0], pair[1]);
  return map;
}

/**
 * Adds `value` to `set`.
 *
 * @private
 * @param {Object} set The set to modify.
 * @param {*} value The value to add.
 * @returns {Object} Returns `set`.
 */
function addSetEntry(set, value) {
  // Don't return `set.add` because it's not chainable in IE 11.
  set.add(value);
  return set;
}

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array ? array.length : 0;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array ? array.length : 0;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    Symbol = root.Symbol,
    Uint8Array = root.Uint8Array,
    getPrototype = overArg(Object.getPrototypeOf, Object),
    objectCreate = Object.create,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols,
    nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
    nativeKeys = overArg(Object.keys, Object);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView'),
    Map = getNative(root, 'Map'),
    Promise = getNative(root, 'Promise'),
    Set = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap'),
    nativeCreate = getNative(Object, 'create');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  this.__data__ = new ListCache(entries);
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  return this.__data__['delete'](key);
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var cache = this.__data__;
  if (cache instanceof ListCache) {
    var pairs = cache.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      return this;
    }
    cache = this.__data__ = new MapCache(pairs);
  }
  cache.set(key, value);
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    object[key] = value;
  }
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @param {boolean} [isFull] Specify a clone including symbols.
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, isDeep, isFull, customizer, key, object, stack) {
  var result;
  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      if (isHostObject(value)) {
        return object ? value : {};
      }
      result = initCloneObject(isFunc ? {} : value);
      if (!isDeep) {
        return copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, baseClone, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (!isArr) {
    var props = isFull ? getAllKeys(value) : keys(value);
  }
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, isDeep, isFull, customizer, key, value, stack));
  });
  return result;
}

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} prototype The object to inherit from.
 * @returns {Object} Returns the new object.
 */
function baseCreate(proto) {
  return isObject(proto) ? objectCreate(proto) : {};
}

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  return objectToString.call(value);
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var result = new buffer.constructor(buffer.length);
  buffer.copy(result);
  return result;
}

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

/**
 * Creates a clone of `map`.
 *
 * @private
 * @param {Object} map The map to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned map.
 */
function cloneMap(map, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(mapToArray(map), true) : mapToArray(map);
  return arrayReduce(array, addMapEntry, new map.constructor);
}

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

/**
 * Creates a clone of `set`.
 *
 * @private
 * @param {Object} set The set to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned set.
 */
function cloneSet(set, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(setToArray(set), true) : setToArray(set);
  return arrayReduce(array, addSetEntry, new set.constructor);
}

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    assignValue(object, key, newValue === undefined ? source[key] : newValue);
  }
  return object;
}

/**
 * Copies own symbol properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Creates an array of the own enumerable symbol properties of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = objectToString.call(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : undefined;

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, cloneFunc, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return cloneMap(object, isDeep, cloneFunc);

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return cloneSet(object, isDeep, cloneFunc);

    case symbolTag:
      return cloneSymbol(object);
  }
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
  return baseClone(value, true, true);
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = cloneDeep;


/***/ }),

/***/ 91296:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = debounce;


/***/ }),

/***/ 60790:
/***/ (function(module) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Iterates over own and inherited enumerable string keyed properties of an
 * object and invokes `iteratee` for each property. The iteratee is invoked
 * with three arguments: (value, key, object). Iteratee functions may exit
 * iteration early by explicitly returning `false`.
 *
 * @static
 * @memberOf _
 * @since 0.3.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns `object`.
 * @see _.forInRight
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.forIn(new Foo, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
 */
function forIn(object, iteratee) {
  return object == null
    ? object
    : baseFor(object, typeof iteratee == 'function' ? iteratee : identity, keysIn);
}

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = forIn;


/***/ }),

/***/ 29208:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    symbolTag = '[object Symbol]';

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/,
    reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Symbol = root.Symbol,
    splice = arrayProto.splice;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = isKey(path, object) ? [path] : castPath(path);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value) {
  return isArray(value) ? value : stringToPath(value);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoize(function(string) {
  string = toString(string);

  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result);
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Assign cache to `_.memoize`.
memoize.Cache = MapCache;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),

/***/ 99245:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
    nativeKeys = overArg(Object.keys, Object);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView'),
    Map = getNative(root, 'Map'),
    Promise = getNative(root, 'Promise'),
    Set = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap');

/** Detect if properties shadowing those on `Object.prototype` are non-enumerable. */
var nonEnumShadows = !propertyIsEnumerable.call({ 'valueOf': 1 }, 'valueOf');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  return objectToString.call(value);
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = objectToString.call(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : undefined;

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (isArrayLike(value) &&
      (isArray(value) || typeof value == 'string' ||
        typeof value.splice == 'function' || isBuffer(value) || isArguments(value))) {
    return !value.length;
  }
  var tag = getTag(value);
  if (tag == mapTag || tag == setTag) {
    return !value.size;
  }
  if (nonEnumShadows || isPrototype(value)) {
    return !nativeKeys(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = isEmpty;


/***/ }),

/***/ 16040:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used to compose bitmasks for comparison styles. */
var UNORDERED_COMPARE_FLAG = 1,
    PARTIAL_COMPARE_FLAG = 2;

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/,
    reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding('util');
  } catch (e) {}
}());

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array ? array.length : 0;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Symbol = root.Symbol,
    Uint8Array = root.Uint8Array,
    getPrototype = overArg(Object.getPrototypeOf, Object),
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols,
    nativeKeys = overArg(Object.keys, Object);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView'),
    Map = getNative(root, 'Map'),
    Promise = getNative(root, 'Promise'),
    Set = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap'),
    nativeCreate = getNative(Object, 'create');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values ? values.length : 0;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  this.__data__ = new ListCache(entries);
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  return this.__data__['delete'](key);
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var cache = this.__data__;
  if (cache instanceof ListCache) {
    var pairs = cache.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      return this;
    }
    cache = this.__data__ = new MapCache(pairs);
  }
  cache.set(key, value);
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = isKey(path, object) ? [path] : castPath(path);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  return objectToString.call(value);
}

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {boolean} [bitmask] The bitmask of comparison flags.
 *  The bitmask may be composed of the following flags:
 *     1 - Unordered comparison
 *     2 - Partial comparison
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, customizer, bitmask, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
}

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = arrayTag,
      othTag = arrayTag;

  if (!objIsArr) {
    objTag = getTag(object);
    objTag = objTag == argsTag ? objectTag : objTag;
  }
  if (!othIsArr) {
    othTag = getTag(other);
    othTag = othTag == argsTag ? objectTag : othTag;
  }
  var objIsObj = objTag == objectTag && !isHostObject(object),
      othIsObj = othTag == objectTag && !isHostObject(other),
      isSameTag = objTag == othTag;

  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, equalFunc, customizer, bitmask, stack)
      : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
  }
  if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, customizer, bitmask, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
}

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, customizer, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
}

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, undefined, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG);
  };
}

/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} props The property identifiers to pick from.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */
function basePickBy(object, props, predicate) {
  var index = -1,
      length = props.length,
      result = {};

  while (++index < length) {
    var key = props[index],
        value = object[key];

    if (predicate(value, key)) {
      result[key] = value;
    }
  }
  return result;
}

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value) {
  return isArray(value) ? value : stringToPath(value);
}

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & UNORDERED_COMPARE_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!seen.has(othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
              return seen.add(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, customizer, bitmask, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= UNORDERED_COMPARE_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
      objProps = keys(object),
      objLength = objProps.length,
      othProps = keys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Creates an array of the own enumerable symbol properties of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;

/**
 * Creates an array of the own and inherited enumerable symbol properties
 * of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = objectToString.call(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : undefined;

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = isKey(path, object) ? [path] : castPath(path);

  var result,
      index = -1,
      length = path.length;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result) {
    return result;
  }
  var length = object ? object.length : 0;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoize(function(string) {
  string = toString(string);

  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result);
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Assign cache to `_.memoize`.
memoize.Cache = MapCache;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

/**
 * Creates an object composed of the `object` properties `predicate` returns
 * truthy for. The predicate is invoked with two arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pickBy(object, _.isNumber);
 * // => { 'a': 1, 'c': 3 }
 */
function pickBy(object, predicate) {
  return object == null ? {} : basePickBy(object, getAllKeysIn(object), baseIteratee(predicate));
}

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = pickBy;


/***/ }),

/***/ 31468:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    symbolTag = '[object Symbol]';

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/,
    reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Symbol = root.Symbol,
    splice = arrayProto.splice;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    object[key] = value;
  }
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet(object, path, value, customizer) {
  if (!isObject(object)) {
    return object;
  }
  path = isKey(path, object) ? [path] : castPath(path);

  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = toKey(path[index]),
        newValue = value;

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = isObject(objValue)
          ? objValue
          : (isIndex(path[index + 1]) ? [] : {});
      }
    }
    assignValue(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value) {
  return isArray(value) ? value : stringToPath(value);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoize(function(string) {
  string = toString(string);

  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result);
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Assign cache to `_.memoize`.
memoize.Cache = MapCache;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */
function set(object, path, value) {
  return object == null ? object : baseSet(object, path, value);
}

module.exports = set;


/***/ }),

/***/ 93096:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = throttle;


/***/ }),

/***/ 96633:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    symbolTag = '[object Symbol]';

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/,
    reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Symbol = root.Symbol,
    splice = arrayProto.splice;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = isKey(path, object) ? [path] : castPath(path);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */
function baseUnset(object, path) {
  path = isKey(path, object) ? [path] : castPath(path);
  object = parent(object, path);

  var key = toKey(last(path));
  return !(object != null && hasOwnProperty.call(object, key)) || delete object[key];
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value) {
  return isArray(value) ? value : stringToPath(value);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */
function parent(object, path) {
  return path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
}

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoize(function(string) {
  string = toString(string);

  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array ? array.length : 0;
  return length ? array[length - 1] : undefined;
}

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result);
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Assign cache to `_.memoize`.
memoize.Cache = MapCache;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Removes the property at `path` of `object`.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 7 } }] };
 * _.unset(object, 'a[0].b.c');
 * // => true
 *
 * console.log(object);
 * // => { 'a': [{ 'b': {} }] };
 *
 * _.unset(object, ['a', '0', 'b', 'c']);
 * // => true
 *
 * console.log(object);
 * // => { 'a': [{ 'b': {} }] };
 */
function unset(object, path) {
  return object == null ? true : baseUnset(object, path);
}

module.exports = unset;


/***/ }),

/***/ 18552:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(10852),
    root = __webpack_require__(55639);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),

/***/ 1989:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var hashClear = __webpack_require__(51789),
    hashDelete = __webpack_require__(80401),
    hashGet = __webpack_require__(57667),
    hashHas = __webpack_require__(21327),
    hashSet = __webpack_require__(81866);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),

/***/ 38407:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var listCacheClear = __webpack_require__(27040),
    listCacheDelete = __webpack_require__(14125),
    listCacheGet = __webpack_require__(82117),
    listCacheHas = __webpack_require__(67518),
    listCacheSet = __webpack_require__(54705);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),

/***/ 57071:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(10852),
    root = __webpack_require__(55639);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),

/***/ 83369:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(24785),
    mapCacheDelete = __webpack_require__(11285),
    mapCacheGet = __webpack_require__(96000),
    mapCacheHas = __webpack_require__(49916),
    mapCacheSet = __webpack_require__(95265);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),

/***/ 53818:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(10852),
    root = __webpack_require__(55639);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),

/***/ 58525:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(10852),
    root = __webpack_require__(55639);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),

/***/ 88668:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var MapCache = __webpack_require__(83369),
    setCacheAdd = __webpack_require__(90619),
    setCacheHas = __webpack_require__(72385);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),

/***/ 46384:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(38407),
    stackClear = __webpack_require__(37465),
    stackDelete = __webpack_require__(63779),
    stackGet = __webpack_require__(67599),
    stackHas = __webpack_require__(44758),
    stackSet = __webpack_require__(34309);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),

/***/ 62705:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(55639);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),

/***/ 11149:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(55639);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),

/***/ 70577:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(10852),
    root = __webpack_require__(55639);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),

/***/ 34963:
/***/ (function(module) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),

/***/ 14636:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseTimes = __webpack_require__(22545),
    isArguments = __webpack_require__(35694),
    isArray = __webpack_require__(1469),
    isBuffer = __webpack_require__(44144),
    isIndex = __webpack_require__(65776),
    isTypedArray = __webpack_require__(36719);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),

/***/ 29932:
/***/ (function(module) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),

/***/ 62488:
/***/ (function(module) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),

/***/ 82908:
/***/ (function(module) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),

/***/ 18470:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var eq = __webpack_require__(77813);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),

/***/ 97786:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var castPath = __webpack_require__(71811),
    toKey = __webpack_require__(40327);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),

/***/ 68866:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayPush = __webpack_require__(62488),
    isArray = __webpack_require__(1469);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),

/***/ 44239:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(62705),
    getRawTag = __webpack_require__(89607),
    objectToString = __webpack_require__(2333);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),

/***/ 9454:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(44239),
    isObjectLike = __webpack_require__(37005);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),

/***/ 90939:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(2492),
    isObjectLike = __webpack_require__(37005);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),

/***/ 2492:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Stack = __webpack_require__(46384),
    equalArrays = __webpack_require__(67114),
    equalByTag = __webpack_require__(18351),
    equalObjects = __webpack_require__(16096),
    getTag = __webpack_require__(64160),
    isArray = __webpack_require__(1469),
    isBuffer = __webpack_require__(44144),
    isTypedArray = __webpack_require__(36719);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),

/***/ 28458:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isFunction = __webpack_require__(23560),
    isMasked = __webpack_require__(15346),
    isObject = __webpack_require__(13218),
    toSource = __webpack_require__(80346);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),

/***/ 38749:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(44239),
    isLength = __webpack_require__(41780),
    isObjectLike = __webpack_require__(37005);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),

/***/ 280:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isPrototype = __webpack_require__(25726),
    nativeKeys = __webpack_require__(86916);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),

/***/ 22545:
/***/ (function(module) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),

/***/ 80531:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(62705),
    arrayMap = __webpack_require__(29932),
    isArray = __webpack_require__(1469),
    isSymbol = __webpack_require__(33448);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),

/***/ 27561:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var trimmedEndIndex = __webpack_require__(67990);

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

module.exports = baseTrim;


/***/ }),

/***/ 7518:
/***/ (function(module) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),

/***/ 74757:
/***/ (function(module) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),

/***/ 71811:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArray = __webpack_require__(1469),
    isKey = __webpack_require__(15403),
    stringToPath = __webpack_require__(55514),
    toString = __webpack_require__(79833);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),

/***/ 14429:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(55639);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),

/***/ 67114:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var SetCache = __webpack_require__(88668),
    arraySome = __webpack_require__(82908),
    cacheHas = __webpack_require__(74757);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),

/***/ 18351:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(62705),
    Uint8Array = __webpack_require__(11149),
    eq = __webpack_require__(77813),
    equalArrays = __webpack_require__(67114),
    mapToArray = __webpack_require__(68776),
    setToArray = __webpack_require__(21814);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),

/***/ 16096:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getAllKeys = __webpack_require__(58234);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),

/***/ 31957:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

module.exports = freeGlobal;


/***/ }),

/***/ 58234:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(68866),
    getSymbols = __webpack_require__(99551),
    keys = __webpack_require__(3674);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),

/***/ 45050:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isKeyable = __webpack_require__(37019);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),

/***/ 10852:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsNative = __webpack_require__(28458),
    getValue = __webpack_require__(47801);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),

/***/ 89607:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(62705);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),

/***/ 99551:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayFilter = __webpack_require__(34963),
    stubArray = __webpack_require__(70479);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),

/***/ 64160:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var DataView = __webpack_require__(18552),
    Map = __webpack_require__(57071),
    Promise = __webpack_require__(53818),
    Set = __webpack_require__(58525),
    WeakMap = __webpack_require__(70577),
    baseGetTag = __webpack_require__(44239),
    toSource = __webpack_require__(80346);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),

/***/ 47801:
/***/ (function(module) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),

/***/ 51789:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(94536);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),

/***/ 80401:
/***/ (function(module) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),

/***/ 57667:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(94536);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),

/***/ 21327:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(94536);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),

/***/ 81866:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(94536);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),

/***/ 65776:
/***/ (function(module) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),

/***/ 15403:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArray = __webpack_require__(1469),
    isSymbol = __webpack_require__(33448);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),

/***/ 37019:
/***/ (function(module) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),

/***/ 15346:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var coreJsData = __webpack_require__(14429);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),

/***/ 25726:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),

/***/ 27040:
/***/ (function(module) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),

/***/ 14125:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(18470);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),

/***/ 82117:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(18470);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),

/***/ 67518:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(18470);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),

/***/ 54705:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(18470);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),

/***/ 24785:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Hash = __webpack_require__(1989),
    ListCache = __webpack_require__(38407),
    Map = __webpack_require__(57071);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),

/***/ 11285:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(45050);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),

/***/ 96000:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(45050);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),

/***/ 49916:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(45050);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),

/***/ 95265:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(45050);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),

/***/ 68776:
/***/ (function(module) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),

/***/ 24523:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var memoize = __webpack_require__(88306);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),

/***/ 94536:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(10852);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),

/***/ 86916:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var overArg = __webpack_require__(5569);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),

/***/ 31167:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var freeGlobal = __webpack_require__(31957);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;


/***/ }),

/***/ 2333:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),

/***/ 5569:
/***/ (function(module) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),

/***/ 55639:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var freeGlobal = __webpack_require__(31957);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),

/***/ 90619:
/***/ (function(module) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),

/***/ 72385:
/***/ (function(module) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),

/***/ 21814:
/***/ (function(module) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),

/***/ 37465:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(38407);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),

/***/ 63779:
/***/ (function(module) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),

/***/ 67599:
/***/ (function(module) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),

/***/ 44758:
/***/ (function(module) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),

/***/ 34309:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(38407),
    Map = __webpack_require__(57071),
    MapCache = __webpack_require__(83369);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),

/***/ 55514:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(24523);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),

/***/ 40327:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isSymbol = __webpack_require__(33448);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),

/***/ 80346:
/***/ (function(module) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),

/***/ 67990:
/***/ (function(module) {

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

module.exports = trimmedEndIndex;


/***/ }),

/***/ 23279:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(13218),
    now = __webpack_require__(7771),
    toNumber = __webpack_require__(14841);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),

/***/ 77813:
/***/ (function(module) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),

/***/ 3522:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toString = __webpack_require__(79833);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
    reHasRegExpChar = RegExp(reRegExpChar.source);

/**
 * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
 * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to escape.
 * @returns {string} Returns the escaped string.
 * @example
 *
 * _.escapeRegExp('[lodash](https://lodash.com/)');
 * // => '\[lodash\]\(https://lodash\.com/\)'
 */
function escapeRegExp(string) {
  string = toString(string);
  return (string && reHasRegExpChar.test(string))
    ? string.replace(reRegExpChar, '\\$&')
    : string;
}

module.exports = escapeRegExp;


/***/ }),

/***/ 27361:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGet = __webpack_require__(97786);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),

/***/ 35694:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(9454),
    isObjectLike = __webpack_require__(37005);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),

/***/ 1469:
/***/ (function(module) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),

/***/ 98612:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isFunction = __webpack_require__(23560),
    isLength = __webpack_require__(41780);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),

/***/ 44144:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var root = __webpack_require__(55639),
    stubFalse = __webpack_require__(95062);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;


/***/ }),

/***/ 41609:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseKeys = __webpack_require__(280),
    getTag = __webpack_require__(64160),
    isArguments = __webpack_require__(35694),
    isArray = __webpack_require__(1469),
    isArrayLike = __webpack_require__(98612),
    isBuffer = __webpack_require__(44144),
    isPrototype = __webpack_require__(25726),
    isTypedArray = __webpack_require__(36719);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (isArrayLike(value) &&
      (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
        isBuffer(value) || isTypedArray(value) || isArguments(value))) {
    return !value.length;
  }
  var tag = getTag(value);
  if (tag == mapTag || tag == setTag) {
    return !value.size;
  }
  if (isPrototype(value)) {
    return !baseKeys(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}

module.exports = isEmpty;


/***/ }),

/***/ 18446:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(90939);

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;


/***/ }),

/***/ 23560:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(44239),
    isObject = __webpack_require__(13218);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),

/***/ 41780:
/***/ (function(module) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),

/***/ 13218:
/***/ (function(module) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),

/***/ 37005:
/***/ (function(module) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),

/***/ 33448:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(44239),
    isObjectLike = __webpack_require__(37005);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),

/***/ 36719:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(38749),
    baseUnary = __webpack_require__(7518),
    nodeUtil = __webpack_require__(31167);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),

/***/ 3674:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(14636),
    baseKeys = __webpack_require__(280),
    isArrayLike = __webpack_require__(98612);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),

/***/ 88306:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var MapCache = __webpack_require__(83369);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),

/***/ 7771:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(55639);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),

/***/ 70479:
/***/ (function(module) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),

/***/ 95062:
/***/ (function(module) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),

/***/ 23493:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var debounce = __webpack_require__(23279),
    isObject = __webpack_require__(13218);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

module.exports = throttle;


/***/ }),

/***/ 14841:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseTrim = __webpack_require__(27561),
    isObject = __webpack_require__(13218),
    isSymbol = __webpack_require__(33448);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),

/***/ 79833:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseToString = __webpack_require__(80531);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),

/***/ 59738:
/***/ (function(module) {

"use strict";


/** @type {import('./abs')} */
module.exports = Math.abs;


/***/ }),

/***/ 76329:
/***/ (function(module) {

"use strict";


/** @type {import('./floor')} */
module.exports = Math.floor;


/***/ }),

/***/ 43678:
/***/ (function(module) {

"use strict";


/** @type {import('./isNaN')} */
module.exports = Number.isNaN || function isNaN(a) {
	return a !== a;
};


/***/ }),

/***/ 52264:
/***/ (function(module) {

"use strict";


/** @type {import('./max')} */
module.exports = Math.max;


/***/ }),

/***/ 55730:
/***/ (function(module) {

"use strict";


/** @type {import('./min')} */
module.exports = Math.min;


/***/ }),

/***/ 20707:
/***/ (function(module) {

"use strict";


/** @type {import('./pow')} */
module.exports = Math.pow;


/***/ }),

/***/ 63862:
/***/ (function(module) {

"use strict";


/** @type {import('./round')} */
module.exports = Math.round;


/***/ }),

/***/ 29550:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var $isNaN = __webpack_require__(43678);

/** @type {import('./sign')} */
module.exports = function sign(number) {
	if ($isNaN(number) || number === 0) {
		return number;
	}
	return number < 0 ? -1 : +1;
};


/***/ }),

/***/ 30381:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
     true ? module.exports = factory() :
    0
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks() {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return (
            input instanceof Array ||
            Object.prototype.toString.call(input) === '[object Array]'
        );
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return (
            input != null &&
            Object.prototype.toString.call(input) === '[object Object]'
        );
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return Object.getOwnPropertyNames(obj).length === 0;
        } else {
            var k;
            for (k in obj) {
                if (hasOwnProp(obj, k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return (
            typeof input === 'number' ||
            Object.prototype.toString.call(input) === '[object Number]'
        );
    }

    function isDate(input) {
        return (
            input instanceof Date ||
            Object.prototype.toString.call(input) === '[object Date]'
        );
    }

    function map(arr, fn) {
        var res = [],
            i,
            arrLen = arr.length;
        for (i = 0; i < arrLen; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false,
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this),
                len = t.length >>> 0,
                i;

            for (i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        var flags = null,
            parsedParts = false,
            isNowValid = m._d && !isNaN(m._d.getTime());
        if (isNowValid) {
            flags = getParsingFlags(m);
            parsedParts = some.call(flags.parsedDateParts, function (i) {
                return i != null;
            });
            isNowValid =
                flags.overflow < 0 &&
                !flags.empty &&
                !flags.invalidEra &&
                !flags.invalidMonth &&
                !flags.invalidWeekday &&
                !flags.weekdayMismatch &&
                !flags.nullInput &&
                !flags.invalidFormat &&
                !flags.userInvalidated &&
                (!flags.meridiem || (flags.meridiem && parsedParts));
            if (m._strict) {
                isNowValid =
                    isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) {
            m._isValid = isNowValid;
        } else {
            return isNowValid;
        }
        return m._isValid;
    }

    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        } else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = (hooks.momentProperties = []),
        updateInProgress = false;

    function copyConfig(to, from) {
        var i,
            prop,
            val,
            momentPropertiesLen = momentProperties.length;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentPropertiesLen > 0) {
            for (i = 0; i < momentPropertiesLen; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment(obj) {
        return (
            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
        );
    }

    function warn(msg) {
        if (
            hooks.suppressDeprecationWarnings === false &&
            typeof console !== 'undefined' &&
            console.warn
        ) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [],
                    arg,
                    i,
                    key,
                    argLen = arguments.length;
                for (i = 0; i < argLen; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (key in arguments[0]) {
                            if (hasOwnProp(arguments[0], key)) {
                                arg += key + ': ' + arguments[0][key] + ', ';
                            }
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(
                    msg +
                        '\nArguments: ' +
                        Array.prototype.slice.call(args).join('') +
                        '\n' +
                        new Error().stack
                );
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    function set(config) {
        var prop, i;
        for (i in config) {
            if (hasOwnProp(config, i)) {
                prop = config[i];
                if (isFunction(prop)) {
                    this[i] = prop;
                } else {
                    this['_' + i] = prop;
                }
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' +
                /\d{1,2}/.source
        );
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig),
            prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (
                hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])
            ) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i,
                res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L',
    };

    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (
            (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
            absNumber
        );
    }

    var formattingTokens =
            /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
        formatFunctions = {},
        formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(
                    func.apply(this, arguments),
                    token
                );
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens),
            i,
            length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '',
                i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i])
                    ? array[i].call(mom, format)
                    : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] =
            formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(
                localFormattingTokens,
                replaceLongDateFormatTokens
            );
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A',
    };

    function longDateFormat(key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper
            .match(formattingTokens)
            .map(function (tok) {
                if (
                    tok === 'MMMM' ||
                    tok === 'MM' ||
                    tok === 'DD' ||
                    tok === 'dddd'
                ) {
                    return tok.slice(1);
                }
                return tok;
            })
            .join('');

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate() {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d',
        defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years',
    };

    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output)
            ? output(number, withoutSuffix, string, isFuture)
            : output.replace(/%d/i, number);
    }

    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {
        D: 'date',
        dates: 'date',
        date: 'date',
        d: 'day',
        days: 'day',
        day: 'day',
        e: 'weekday',
        weekdays: 'weekday',
        weekday: 'weekday',
        E: 'isoWeekday',
        isoweekdays: 'isoWeekday',
        isoweekday: 'isoWeekday',
        DDD: 'dayOfYear',
        dayofyears: 'dayOfYear',
        dayofyear: 'dayOfYear',
        h: 'hour',
        hours: 'hour',
        hour: 'hour',
        ms: 'millisecond',
        milliseconds: 'millisecond',
        millisecond: 'millisecond',
        m: 'minute',
        minutes: 'minute',
        minute: 'minute',
        M: 'month',
        months: 'month',
        month: 'month',
        Q: 'quarter',
        quarters: 'quarter',
        quarter: 'quarter',
        s: 'second',
        seconds: 'second',
        second: 'second',
        gg: 'weekYear',
        weekyears: 'weekYear',
        weekyear: 'weekYear',
        GG: 'isoWeekYear',
        isoweekyears: 'isoWeekYear',
        isoweekyear: 'isoWeekYear',
        w: 'week',
        weeks: 'week',
        week: 'week',
        W: 'isoWeek',
        isoweeks: 'isoWeek',
        isoweek: 'isoWeek',
        y: 'year',
        years: 'year',
        year: 'year',
    };

    function normalizeUnits(units) {
        return typeof units === 'string'
            ? aliases[units] || aliases[units.toLowerCase()]
            : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1,
    };

    function getPrioritizedUnits(unitsObj) {
        var units = [],
            u;
        for (u in unitsObj) {
            if (hasOwnProp(unitsObj, u)) {
                units.push({ unit: u, priority: priorities[u] });
            }
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    var match1 = /\d/, //       0 - 9
        match2 = /\d\d/, //      00 - 99
        match3 = /\d{3}/, //     000 - 999
        match4 = /\d{4}/, //    0000 - 9999
        match6 = /[+-]?\d{6}/, // -999999 - 999999
        match1to2 = /\d\d?/, //       0 - 99
        match3to4 = /\d\d\d\d?/, //     999 - 9999
        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
        match1to3 = /\d{1,3}/, //       0 - 999
        match1to4 = /\d{1,4}/, //       0 - 9999
        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
        matchUnsigned = /\d+/, //       0 - inf
        matchSigned = /[+-]?\d+/, //    -inf - inf
        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
        // any word (or two) characters or numbers including two/three word month in arabic.
        // includes scottish gaelic two word and hyphenated months
        matchWord =
            /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
        match1to2NoLeadingZero = /^[1-9]\d?/, //         1-99
        match1to2HasZero = /^([1-9]\d|\d)/, //           0-99
        regexes;

    regexes = {};

    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex)
            ? regex
            : function (isStrict, localeData) {
                  return isStrict && strictRegex ? strictRegex : regex;
              };
    }

    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(
            s
                .replace('\\', '')
                .replace(
                    /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
                    function (matched, p1, p2, p3, p4) {
                        return p1 || p2 || p3 || p4;
                    }
                )
        );
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    function absFloor(number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    var tokens = {};

    function addParseToken(token, callback) {
        var i,
            func = callback,
            tokenLen;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        tokenLen = token.length;
        for (i = 0; i < tokenLen; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken(token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    var YEAR = 0,
        MONTH = 1,
        DATE = 2,
        HOUR = 3,
        MINUTE = 4,
        SECOND = 5,
        MILLISECOND = 6,
        WEEK = 7,
        WEEKDAY = 8;

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // PARSING

    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] =
            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear() {
        return isLeapYear(this.year());
    }

    function makeGetSet(unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get(mom, unit) {
        if (!mom.isValid()) {
            return NaN;
        }

        var d = mom._d,
            isUTC = mom._isUTC;

        switch (unit) {
            case 'Milliseconds':
                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
            case 'Seconds':
                return isUTC ? d.getUTCSeconds() : d.getSeconds();
            case 'Minutes':
                return isUTC ? d.getUTCMinutes() : d.getMinutes();
            case 'Hours':
                return isUTC ? d.getUTCHours() : d.getHours();
            case 'Date':
                return isUTC ? d.getUTCDate() : d.getDate();
            case 'Day':
                return isUTC ? d.getUTCDay() : d.getDay();
            case 'Month':
                return isUTC ? d.getUTCMonth() : d.getMonth();
            case 'FullYear':
                return isUTC ? d.getUTCFullYear() : d.getFullYear();
            default:
                return NaN; // Just in case
        }
    }

    function set$1(mom, unit, value) {
        var d, isUTC, year, month, date;

        if (!mom.isValid() || isNaN(value)) {
            return;
        }

        d = mom._d;
        isUTC = mom._isUTC;

        switch (unit) {
            case 'Milliseconds':
                return void (isUTC
                    ? d.setUTCMilliseconds(value)
                    : d.setMilliseconds(value));
            case 'Seconds':
                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
            case 'Minutes':
                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
            case 'Hours':
                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
            case 'Date':
                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
            // case 'Day': // Not real
            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
            // case 'Month': // Not used because we need to pass two variables
            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
            case 'FullYear':
                break; // See below ...
            default:
                return; // Just in case
        }

        year = value;
        month = mom.month();
        date = mom.date();
        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
        void (isUTC
            ? d.setUTCFullYear(year, month, date)
            : d.setFullYear(year, month, date));
    }

    // MOMENTS

    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }

    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units),
                i,
                prioritizedLen = prioritized.length;
            for (i = 0; i < prioritizedLen; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1
            ? isLeapYear(year)
                ? 29
                : 28
            : 31 - ((modMonth % 7) % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // PARSING

    addRegexToken('M', match1to2, match1to2NoLeadingZero);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var defaultLocaleMonths =
            'January_February_March_April_May_June_July_August_September_October_November_December'.split(
                '_'
            ),
        defaultLocaleMonthsShort =
            'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
        defaultMonthsShortRegex = matchWord,
        defaultMonthsRegex = matchWord;

    function localeMonths(m, format) {
        if (!m) {
            return isArray(this._months)
                ? this._months
                : this._months['standalone'];
        }
        return isArray(this._months)
            ? this._months[m.month()]
            : this._months[
                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
                      ? 'format'
                      : 'standalone'
              ][m.month()];
    }

    function localeMonthsShort(m, format) {
        if (!m) {
            return isArray(this._monthsShort)
                ? this._monthsShort
                : this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort)
            ? this._monthsShort[m.month()]
            : this._monthsShort[
                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
              ][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i,
            ii,
            mom,
            llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp(
                    '^' + this.months(mom, '').replace('.', '') + '$',
                    'i'
                );
                this._shortMonthsParse[i] = new RegExp(
                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
                    'i'
                );
            }
            if (!strict && !this._monthsParse[i]) {
                regex =
                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'MMMM' &&
                this._longMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'MMM' &&
                this._shortMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth(mom, value) {
        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        var month = value,
            date = mom.date();

        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
        void (mom._isUTC
            ? mom._d.setUTCMonth(month, date)
            : mom._d.setMonth(month, date));
        return mom;
    }

    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }

    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict
                ? this._monthsShortStrictRegex
                : this._monthsShortRegex;
        }
    }

    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict
                ? this._monthsStrictRegex
                : this._monthsRegex;
        }
    }

    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            shortP,
            longP;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortP = regexEscape(this.monthsShort(mom, ''));
            longP = regexEscape(this.months(mom, ''));
            shortPieces.push(shortP);
            longPieces.push(longP);
            mixedPieces.push(longP);
            mixedPieces.push(shortP);
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._monthsShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
    }

    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear,
            resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear,
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek,
            resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear,
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // PARSING

    addRegexToken('w', match1to2, match1to2NoLeadingZero);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2, match1to2NoLeadingZero);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(
        ['w', 'ww', 'W', 'WW'],
        function (input, week, config, token) {
            week[token.substr(0, 1)] = toInt(input);
        }
    );

    // HELPERS

    // LOCALES

    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow: 0, // Sunday is the first day of the week.
        doy: 6, // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek() {
        return this._week.dow;
    }

    function localeFirstDayOfYear() {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // PARSING

    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays =
            'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        defaultWeekdaysRegex = matchWord,
        defaultWeekdaysShortRegex = matchWord,
        defaultWeekdaysMinRegex = matchWord;

    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays)
            ? this._weekdays
            : this._weekdays[
                  m && m !== true && this._weekdays.isFormat.test(format)
                      ? 'format'
                      : 'standalone'
              ];
        return m === true
            ? shiftWeekdays(weekdays, this._week.dow)
            : m
              ? weekdays[m.day()]
              : weekdays;
    }

    function localeWeekdaysShort(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : m
              ? this._weekdaysShort[m.day()]
              : this._weekdaysShort;
    }

    function localeWeekdaysMin(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : m
              ? this._weekdaysMin[m.day()]
              : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i,
            ii,
            mom,
            llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._shortWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._minWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
            }
            if (!this._weekdaysParse[i]) {
                regex =
                    '^' +
                    this.weekdays(mom, '') +
                    '|^' +
                    this.weekdaysShort(mom, '') +
                    '|^' +
                    this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'dddd' &&
                this._fullWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'ddd' &&
                this._shortWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'dd' &&
                this._minWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        var day = get(this, 'Day');
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict
                ? this._weekdaysStrictRegex
                : this._weekdaysRegex;
        }
    }

    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict
                ? this._weekdaysShortStrictRegex
                : this._weekdaysShortRegex;
        }
    }

    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict
                ? this._weekdaysMinStrictRegex
                : this._weekdaysMinRegex;
        }
    }

    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [],
            shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            minp,
            shortp,
            longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._weekdaysShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
        this._weekdaysMinStrictRegex = new RegExp(
            '^(' + minPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return (
            '' +
            hFormat.apply(this) +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return (
            '' +
            this.hours() +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(
                this.hours(),
                this.minutes(),
                lowercase
            );
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // PARSING

    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2, match1to2HasZero);
    addRegexToken('h', match1to2, match1to2NoLeadingZero);
    addRegexToken('k', match1to2, match1to2NoLeadingZero);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
        // Setting the hour should keep the time, because the user explicitly
        // specified which hour they want. So trying to maintain the same hour (in
        // a new timezone) makes sense. Adding/subtracting hours does not follow
        // this rule.
        getSetHour = makeGetSet('Hours', true);

    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse,
    };

    // internal storage for locale config files
    var locales = {},
        localeFamilies = {},
        globalLocale;

    function commonPrefix(arr1, arr2) {
        var i,
            minl = Math.min(arr1.length, arr2.length);
        for (i = 0; i < minl; i += 1) {
            if (arr1[i] !== arr2[i]) {
                return i;
            }
        }
        return minl;
    }

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0,
            j,
            next,
            locale,
            split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (
                    next &&
                    next.length >= j &&
                    commonPrefix(split, next) >= j - 1
                ) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        // Ensure name is available and function returns boolean
        return !!(name && name.match('^[^/\\\\]*$'));
    }

    function loadLocale(name) {
        var oldLocale = null,
            aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (
            locales[name] === undefined &&
            "object" !== 'undefined' &&
            module &&
            module.exports &&
            isLocaleNameSane(name)
        ) {
            try {
                oldLocale = globalLocale._abbr;
                aliasedRequire = undefined;
                Object(function webpackMissingModule() { var e = new Error("Cannot find module 'undefined'"); e.code = 'MODULE_NOT_FOUND'; throw e; }());
                getSetGlobalLocale(oldLocale);
            } catch (e) {
                // mark as not found to avoid repeating expensive file require call causing high CPU
                // when trying to find en-US, en_US, en-us for every format call
                locales[name] = null; // null means not found
            }
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            } else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            } else {
                if (typeof console !== 'undefined' && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn(
                        'Locale ' + key + ' not found. Did you forget to load it?'
                    );
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale(name, config) {
        if (config !== null) {
            var locale,
                parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple(
                    'defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
                );
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config,
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);

            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale,
                tmpLocale,
                parentConfig = baseConfig;

            if (locales[name] != null && locales[name].parentLocale != null) {
                // Update existing child locale in-place to avoid memory-leaks
                locales[name].set(mergeConfigs(locales[name]._config, config));
            } else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) {
                    parentConfig = tmpLocale._config;
                }
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) {
                    // updateLocale is called for creating a new locale
                    // Set abbr so it will have a name (getters return
                    // undefined otherwise).
                    config.abbr = name;
                }
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                    if (name === getSetGlobalLocale()) {
                        getSetGlobalLocale(name);
                    }
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale(key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow(m) {
        var overflow,
            a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH] < 0 || a[MONTH] > 11
                    ? MONTH
                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
                      ? DATE
                      : a[HOUR] < 0 ||
                          a[HOUR] > 24 ||
                          (a[HOUR] === 24 &&
                              (a[MINUTE] !== 0 ||
                                  a[SECOND] !== 0 ||
                                  a[MILLISECOND] !== 0))
                        ? HOUR
                        : a[MINUTE] < 0 || a[MINUTE] > 59
                          ? MINUTE
                          : a[SECOND] < 0 || a[SECOND] > 59
                            ? SECOND
                            : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
                              ? MILLISECOND
                              : -1;

            if (
                getParsingFlags(m)._overflowDayOfYear &&
                (overflow < YEAR || overflow > DATE)
            ) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex =
            /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        basicIsoRegex =
            /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
        isoDates = [
            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
            ['YYYY-DDD', /\d{4}-\d{3}/],
            ['YYYY-MM', /\d{4}-\d\d/, false],
            ['YYYYYYMMDD', /[+-]\d{10}/],
            ['YYYYMMDD', /\d{8}/],
            ['GGGG[W]WWE', /\d{4}W\d{3}/],
            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
            ['YYYYDDD', /\d{7}/],
            ['YYYYMM', /\d{6}/, false],
            ['YYYY', /\d{4}/, false],
        ],
        // iso time formats and regexes
        isoTimes = [
            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
            ['HH:mm', /\d\d:\d\d/],
            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
            ['HHmmss', /\d\d\d\d\d\d/],
            ['HHmm', /\d\d\d\d/],
            ['HH', /\d\d/],
        ],
        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
        rfc2822 =
            /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
        obsOffsets = {
            UT: 0,
            GMT: 0,
            EDT: -4 * 60,
            EST: -5 * 60,
            CDT: -5 * 60,
            CST: -6 * 60,
            MDT: -6 * 60,
            MST: -7 * 60,
            PDT: -7 * 60,
            PST: -8 * 60,
        };

    // date from iso format
    function configFromISO(config) {
        var i,
            l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime,
            dateFormat,
            timeFormat,
            tzFormat,
            isoDatesLen = isoDates.length,
            isoTimesLen = isoTimes.length;

        if (match) {
            getParsingFlags(config).iso = true;
            for (i = 0, l = isoDatesLen; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimesLen; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    function extractFromRFC2822Strings(
        yearStr,
        monthStr,
        dayStr,
        hourStr,
        minuteStr,
        secondStr
    ) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10),
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s
            .replace(/\([^()]*\)|[\n\t]/g, ' ')
            .replace(/(\s\s+)/g, ' ')
            .replace(/^\s\s*/, '')
            .replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(
                    parsedInput[0],
                    parsedInput[1],
                    parsedInput[2]
                ).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10),
                m = hm % 100,
                h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)),
            parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(
                match[4],
                match[3],
                match[2],
                match[5],
                match[6],
                match[7]
            );
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        if (config._strict) {
            config._isValid = false;
        } else {
            // Final attempt, use Input Fallback
            hooks.createFromInputFallback(config);
        }
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [
                nowValue.getUTCFullYear(),
                nowValue.getUTCMonth(),
                nowValue.getUTCDate(),
            ];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i,
            date,
            input = [],
            currentDate,
            expectedWeekday,
            yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (
                config._dayOfYear > daysInYear(yearToUse) ||
                config._dayOfYear === 0
            ) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] =
                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (
            config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0
        ) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(
            null,
            input
        );
        expectedWeekday = config._useUTC
            ? config._d.getUTCDay()
            : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (
            config._w &&
            typeof config._w.d !== 'undefined' &&
            config._w.d !== expectedWeekday
        ) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(
                w.GG,
                config._a[YEAR],
                weekOfYear(createLocal(), 1, 4).year
            );
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i,
            parsedInput,
            tokens,
            token,
            skipped,
            stringLength = string.length,
            totalParsedInputLength = 0,
            era,
            tokenLen;

        tokens =
            expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for (i = 0; i < tokenLen; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
                [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(
                    string.indexOf(parsedInput) + parsedInput.length
                );
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                } else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver =
            stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (
            config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0
        ) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(
            config._locale,
            config._a[HOUR],
            config._meridiem
        );

        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) {
            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        }

        configFromArray(config);
        checkOverflow(config);
    }

    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,
            scoreToBeat,
            i,
            currentScore,
            validFormatFound,
            bestFormatIsValid = false,
            configfLen = config._f.length;

        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < configfLen; i++) {
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (isValid(tempConfig)) {
                validFormatFound = true;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (!bestFormatIsValid) {
                if (
                    scoreToBeat == null ||
                    currentScore < scoreToBeat ||
                    validFormatFound
                ) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) {
                        bestFormatIsValid = true;
                    }
                }
            } else {
                if (currentScore < scoreToBeat) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                }
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i),
            dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map(
            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
            function (obj) {
                return obj && parseInt(obj, 10);
            }
        );

        configFromArray(config);
    }

    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig(config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({ nullInput: true });
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        } else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};

        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if (
            (isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)
        ) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other < this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        ),
        prototypeMax = deprecate(
            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other > this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +new Date();
    };

    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond',
    ];

    function isDurationValid(m) {
        var key,
            unitHasDecimal = false,
            i,
            orderLen = ordering.length;
        for (key in m) {
            if (
                hasOwnProp(m, key) &&
                !(
                    indexOf.call(ordering, key) !== -1 &&
                    (m[key] == null || !isNaN(m[key]))
                )
            ) {
                return false;
            }
        }

        for (i = 0; i < orderLen; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds =
            +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration(obj) {
        return obj instanceof Duration;
    }

    function absRound(number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if (
                (dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
            ) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    // FORMATTING

    function offset(token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset(),
                sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return (
                sign +
                zeroFill(~~(offset / 60), 2) +
                separator +
                zeroFill(~~offset % 60, 2)
            );
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher),
            chunk,
            parts,
            minutes;

        if (matches === null) {
            return null;
        }

        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff =
                (isMoment(input) || isDate(input)
                    ? input.valueOf()
                    : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(
                        this,
                        createDuration(input - offset, 'm'),
                        1,
                        false
                    );
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset() {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            } else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset(input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime() {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {},
            other;

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted =
                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
        // and further modified to allow for strings containing both week and day
        isoRegex =
            /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration(input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms: input._milliseconds,
                d: input._days,
                M: input._months,
            };
        } else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) {
                duration[key] = +input;
            } else {
                duration.milliseconds = +input;
            }
        } else if ((match = aspNetRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
            };
        } else if ((match = isoRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign),
            };
        } else if (duration == null) {
            // checks for null or undefined
            duration = {};
        } else if (
            typeof duration === 'object' &&
            ('from' in duration || 'to' in duration)
        ) {
            diffRes = momentsDifference(
                createLocal(duration.from),
                createLocal(duration.to)
            );

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
            ret._isValid = input._isValid;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months =
            other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +base.clone().add(res.months, 'M');

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return { milliseconds: 0, months: 0 };
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(
                    name,
                    'moment().' +
                        name +
                        '(period, number) is deprecated. Please use moment().' +
                        name +
                        '(number, period). ' +
                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
                );
                tmp = val;
                val = period;
                period = tmp;
            }

            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add = createAdder(1, 'add'),
        subtract = createAdder(-1, 'subtract');

    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }

    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return (
            isMoment(input) ||
            isDate(input) ||
            isString(input) ||
            isNumber(input) ||
            isNumberOrStringArray(input) ||
            isMomentInputObject(input) ||
            input === null ||
            input === undefined
        );
    }

    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'years',
                'year',
                'y',
                'months',
                'month',
                'M',
                'days',
                'day',
                'd',
                'dates',
                'date',
                'D',
                'hours',
                'hour',
                'h',
                'minutes',
                'minute',
                'm',
                'seconds',
                'second',
                's',
                'milliseconds',
                'millisecond',
                'ms',
            ],
            i,
            property,
            propertyLen = properties.length;

        for (i = 0; i < propertyLen; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input),
            dataTypeTest = false;
        if (arrayTest) {
            dataTypeTest =
                input.filter(function (item) {
                    return !isNumber(item) && isString(input);
                }).length === 0;
        }
        return arrayTest && dataTypeTest;
    }

    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'sameDay',
                'nextDay',
                'lastDay',
                'nextWeek',
                'lastWeek',
                'sameElse',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6
            ? 'sameElse'
            : diff < -1
              ? 'lastWeek'
              : diff < 0
                ? 'lastDay'
                : diff < 1
                  ? 'sameDay'
                  : diff < 2
                    ? 'nextDay'
                    : diff < 7
                      ? 'nextWeek'
                      : 'sameElse';
    }

    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse',
            output =
                formats &&
                (isFunction(formats[format])
                    ? formats[format].call(this, now)
                    : formats[format]);

        return this.format(
            output || this.localeData().calendar(format, this, createLocal(now))
        );
    }

    function clone() {
        return new Moment(this);
    }

    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (
            (inclusivity[0] === '('
                ? this.isAfter(localFrom, units)
                : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')'
                ? this.isBefore(localTo, units)
                : !this.isAfter(localTo, units))
        );
    }

    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return (
                this.clone().startOf(units).valueOf() <= inputMs &&
                inputMs <= this.clone().endOf(units).valueOf()
            );
        }
    }

    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff(input, units, asFloat) {
        var that, zoneDelta, output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff(a, b) {
        if (a.date() < b.date()) {
            // end-of-month calculations work correct when the start month has more
            // days than the end month.
            return -monthDiff(b, a);
        }
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2,
            adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true,
            m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(
                m,
                utc
                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
            );
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
                    .toISOString()
                    .replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(
            m,
            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
        );
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect() {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment',
            zone = '',
            prefix,
            year,
            datetime,
            suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format(inputString) {
        if (!inputString) {
            inputString = this.isUtc()
                ? hooks.defaultFormatUtc
                : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ to: this, from: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ from: this, to: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData() {
        return this._locale;
    }

    var MS_PER_SECOND = 1000,
        MS_PER_MINUTE = 60 * MS_PER_SECOND,
        MS_PER_HOUR = 60 * MS_PER_MINUTE,
        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return ((dividend % divisor) + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(
                    this.year(),
                    this.month() - (this.month() % 3),
                    1
                );
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - this.weekday()
                );
                break;
            case 'isoWeek':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - (this.isoWeekday() - 1)
                );
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(
                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                    MS_PER_HOUR
                );
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time =
                    startOfDate(
                        this.year(),
                        this.month() - (this.month() % 3) + 3,
                        1
                    ) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - this.weekday() + 7
                    ) - 1;
                break;
            case 'isoWeek':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - (this.isoWeekday() - 1) + 7
                    ) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time +=
                    MS_PER_HOUR -
                    mod$1(
                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                        MS_PER_HOUR
                    ) -
                    1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }

    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate() {
        return new Date(this.valueOf());
    }

    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond(),
        ];
    }

    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds(),
        };
    }

    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2() {
        return isValid(this);
    }

    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt() {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict,
        };
    }

    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');

    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
    addFormatToken('y', ['yy', 2], 0, 'eraYear');
    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');

    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);

    addParseToken(
        ['N', 'NN', 'NNN', 'NNNN', 'NNNNN'],
        function (input, array, config, token) {
            var era = config._locale.erasParse(input, token, config._strict);
            if (era) {
                getParsingFlags(config).era = era;
            } else {
                getParsingFlags(config).invalidEra = input;
            }
        }
    );

    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);

    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
    addParseToken(['yo'], function (input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) {
            match = input.match(config._locale._eraYearOrdinalRegex);
        }

        if (config._locale.eraYearOrdinalParse) {
            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        } else {
            array[YEAR] = parseInt(input, 10);
        }
    });

    function localeEras(m, format) {
        var i,
            l,
            date,
            eras = this._eras || getLocale('en')._eras;
        for (i = 0, l = eras.length; i < l; ++i) {
            switch (typeof eras[i].since) {
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }

            switch (typeof eras[i].until) {
                case 'undefined':
                    eras[i].until = +Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }

    function localeErasParse(eraName, format, strict) {
        var i,
            l,
            eras = this.eras(),
            name,
            abbr,
            narrow;
        eraName = eraName.toUpperCase();

        for (i = 0, l = eras.length; i < l; ++i) {
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();

            if (strict) {
                switch (format) {
                    case 'N':
                    case 'NN':
                    case 'NNN':
                        if (abbr === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNN':
                        if (name === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNNN':
                        if (narrow === eraName) {
                            return eras[i];
                        }
                        break;
                }
            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
                return eras[i];
            }
        }
    }

    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? +1 : -1;
        if (year === undefined) {
            return hooks(era.since).year();
        } else {
            return hooks(era.since).year() + (year - era.offset) * dir;
        }
    }

    function getEraName() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].name;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].name;
            }
        }

        return '';
    }

    function getEraNarrow() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].narrow;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].narrow;
            }
        }

        return '';
    }

    function getEraAbbr() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].abbr;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].abbr;
            }
        }

        return '';
    }

    function getEraYear() {
        var i,
            l,
            dir,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            dir = eras[i].since <= eras[i].until ? +1 : -1;

            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (
                (eras[i].since <= val && val <= eras[i].until) ||
                (eras[i].until <= val && val <= eras[i].since)
            ) {
                return (
                    (this.year() - hooks(eras[i].since).year()) * dir +
                    eras[i].offset
                );
            }
        }

        return this.year();
    }

    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }

    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }

    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }

    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }

    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }

    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }

    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }

    function computeErasParse() {
        var abbrPieces = [],
            namePieces = [],
            narrowPieces = [],
            mixedPieces = [],
            i,
            l,
            erasName,
            erasAbbr,
            erasNarrow,
            eras = this.eras();

        for (i = 0, l = eras.length; i < l; ++i) {
            erasName = regexEscape(eras[i].name);
            erasAbbr = regexEscape(eras[i].abbr);
            erasNarrow = regexEscape(eras[i].narrow);

            namePieces.push(erasName);
            abbrPieces.push(erasAbbr);
            narrowPieces.push(erasNarrow);
            mixedPieces.push(erasName);
            mixedPieces.push(erasAbbr);
            mixedPieces.push(erasNarrow);
        }

        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp(
            '^(' + narrowPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    // PARSING

    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);

    addWeekParseToken(
        ['gggg', 'ggggg', 'GGGG', 'GGGGG'],
        function (input, week, config, token) {
            week[token.substr(0, 2)] = toInt(input);
        }
    );

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.week(),
            this.weekday() + this.localeData()._week.dow,
            this.localeData()._week.dow,
            this.localeData()._week.doy
        );
    }

    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.isoWeek(),
            this.isoWeekday(),
            1,
            4
        );
    }

    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }

    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }

    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter(input) {
        return input == null
            ? Math.ceil((this.month() + 1) / 3)
            : this.month((input - 1) * 3 + (this.month() % 3));
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // PARSING

    addRegexToken('D', match1to2, match1to2NoLeadingZero);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict
            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
            : locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // PARSING

    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear(input) {
        var dayOfYear =
            Math.round(
                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
            ) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // PARSING

    addRegexToken('m', match1to2, match1to2HasZero);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // PARSING

    addRegexToken('s', match1to2, match1to2HasZero);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });

    // PARSING

    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);

    var token, getSetMillisecond;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }

    getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
            return 'Moment<' + this.format() + '>';
        };
    }
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate(
        'dates accessor is deprecated. Use date instead.',
        getSetDayOfMonth
    );
    proto.months = deprecate(
        'months accessor is deprecated. Use month instead',
        getSetMonth
    );
    proto.years = deprecate(
        'years accessor is deprecated. Use year instead',
        getSetYear
    );
    proto.zone = deprecate(
        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
        getSetZone
    );
    proto.isDSTShifted = deprecate(
        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
        isDaylightSavingTimeShifted
    );

    function createUnix(input) {
        return createLocal(input * 1000);
    }

    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat(string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;

    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;

    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1(format, index, field, setter) {
        var locale = getLocale(),
            utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i,
            out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0,
            i,
            out = [];

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: +Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    toInt((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                          ? 'st'
                          : b === 2
                            ? 'nd'
                            : b === 3
                              ? 'rd'
                              : 'th';
            return number + output;
        },
    });

    // Side effect imports

    hooks.lang = deprecate(
        'moment.lang is deprecated. Use moment.locale instead.',
        getSetGlobalLocale
    );
    hooks.langData = deprecate(
        'moment.langData is deprecated. Use moment.localeData instead.',
        getLocale
    );

    var mathAbs = Math.abs;

    function abs() {
        var data = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);

        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);

        return this;
    }

    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil(number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble() {
        var milliseconds = this._milliseconds,
            days = this._days,
            months = this._months,
            data = this._data,
            seconds,
            minutes,
            hours,
            years,
            monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (
            !(
                (milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0)
            )
        ) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;

        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;

        hours = absFloor(minutes / 60);
        data.hours = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days = days;
        data.months = months;
        data.years = years;

        return this;
    }

    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return (days * 4800) / 146097;
    }

    function monthsToDays(months) {
        // the reverse of daysToMonths
        return (months * 146097) / 4800;
    }

    function as(units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days,
            months,
            milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }

    function makeAs(alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms'),
        asSeconds = makeAs('s'),
        asMinutes = makeAs('m'),
        asHours = makeAs('h'),
        asDays = makeAs('d'),
        asWeeks = makeAs('w'),
        asMonths = makeAs('M'),
        asQuarters = makeAs('Q'),
        asYears = makeAs('y'),
        valueOf$1 = asMilliseconds;

    function clone$1() {
        return createDuration(this);
    }

    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds'),
        seconds = makeGetter('seconds'),
        minutes = makeGetter('minutes'),
        hours = makeGetter('hours'),
        days = makeGetter('days'),
        months = makeGetter('months'),
        years = makeGetter('years');

    function weeks() {
        return absFloor(this.days() / 7);
    }

    var round = Math.round,
        thresholds = {
            ss: 44, // a few seconds to seconds
            s: 45, // seconds to minute
            m: 45, // minutes to hour
            h: 22, // hours to day
            d: 26, // days to month/week
            w: null, // weeks to month
            M: 11, // months to year
        };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(),
            seconds = round(duration.as('s')),
            minutes = round(duration.as('m')),
            hours = round(duration.as('h')),
            days = round(duration.as('d')),
            months = round(duration.as('M')),
            weeks = round(duration.as('w')),
            years = round(duration.as('y')),
            a =
                (seconds <= thresholds.ss && ['s', seconds]) ||
                (seconds < thresholds.s && ['ss', seconds]) ||
                (minutes <= 1 && ['m']) ||
                (minutes < thresholds.m && ['mm', minutes]) ||
                (hours <= 1 && ['h']) ||
                (hours < thresholds.h && ['hh', hours]) ||
                (days <= 1 && ['d']) ||
                (days < thresholds.d && ['dd', days]);

        if (thresholds.w != null) {
            a =
                a ||
                (weeks <= 1 && ['w']) ||
                (weeks < thresholds.w && ['ww', weeks]);
        }
        a = a ||
            (months <= 1 && ['M']) ||
            (months < thresholds.M && ['MM', months]) ||
            (years <= 1 && ['y']) || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var withSuffix = false,
            th = thresholds,
            locale,
            output;

        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') {
            withSuffix = argWithSuffix;
        }
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) {
                th.ss = argThresholds.s - 1;
            }
        }

        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000,
            days = abs$1(this._days),
            months = abs$1(this._months),
            minutes,
            hours,
            years,
            s,
            total = this.asSeconds(),
            totalSign,
            ymSign,
            daysSign,
            hmsSign;

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';

        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return (
            totalSign +
            'P' +
            (years ? ymSign + years + 'Y' : '') +
            (months ? ymSign + months + 'M' : '') +
            (days ? daysSign + days + 'D' : '') +
            (hours || minutes || seconds ? 'T' : '') +
            (hours ? hmsSign + hours + 'H' : '') +
            (minutes ? hmsSign + minutes + 'M' : '') +
            (seconds ? hmsSign + s + 'S' : '')
        );
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;

    proto$2.toIsoString = deprecate(
        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
        toISOString$1
    );
    proto$2.lang = lang;

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    //! moment.js

    hooks.version = '2.30.1';

    setHookCallback(createLocal);

    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD', // <input type="date" />
        TIME: 'HH:mm', // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW', // <input type="week" />
        MONTH: 'YYYY-MM', // <input type="month" />
    };

    return hooks;

})));


/***/ }),

/***/ 24400:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Jc": function() { return /* reexport */ appWithTranslation; },
  "$G": function() { return /* reexport */ useTranslation; }
});

// UNUSED EXPORTS: I18nContext, Trans, Translation, i18n, withTranslation

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(97685);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(4942);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(15671);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(43144);
;// CONCATENATED MODULE: ./node_modules/next-i18next/node_modules/react-i18next/dist/es/unescape.js
var matchHtmlEntity = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g;
var htmlEntities = {
  '&amp;': '&',
  '&#38;': '&',
  '&lt;': '<',
  '&#60;': '<',
  '&gt;': '>',
  '&#62;': '>',
  '&apos;': "'",
  '&#39;': "'",
  '&quot;': '"',
  '&#34;': '"',
  '&nbsp;': ' ',
  '&#160;': ' ',
  '&copy;': '©',
  '&#169;': '©',
  '&reg;': '®',
  '&#174;': '®',
  '&hellip;': '…',
  '&#8230;': '…',
  '&#x2F;': '/',
  '&#47;': '/'
};

var unescapeHtmlEntity = function unescapeHtmlEntity(m) {
  return htmlEntities[m];
};

var unescape_unescape = function unescape(text) {
  return text.replace(matchHtmlEntity, unescapeHtmlEntity);
};
;// CONCATENATED MODULE: ./node_modules/next-i18next/node_modules/react-i18next/dist/es/context.js




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }



var defaultOptions = {
  bindI18n: 'languageChanged',
  bindI18nStore: '',
  transEmptyNodeValue: '',
  transSupportBasicHtmlNodes: true,
  transWrapTextNodes: '',
  transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p'],
  useSuspense: true,
  unescape: unescape_unescape
};
var i18nInstance;
var I18nContext = (0,react.createContext)();
function setDefaults() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  defaultOptions = _objectSpread(_objectSpread({}, defaultOptions), options);
}
function getDefaults() {
  return defaultOptions;
}
var ReportNamespaces = function () {
  function ReportNamespaces() {
    (0,classCallCheck/* default */.Z)(this, ReportNamespaces);

    this.usedNamespaces = {};
  }

  (0,createClass/* default */.Z)(ReportNamespaces, [{
    key: "addUsedNamespaces",
    value: function addUsedNamespaces(namespaces) {
      var _this = this;

      namespaces.forEach(function (ns) {
        if (!_this.usedNamespaces[ns]) _this.usedNamespaces[ns] = true;
      });
    }
  }, {
    key: "getUsedNamespaces",
    value: function getUsedNamespaces() {
      return Object.keys(this.usedNamespaces);
    }
  }]);

  return ReportNamespaces;
}();
function setI18n(instance) {
  i18nInstance = instance;
}
function getI18n() {
  return i18nInstance;
}
var initReactI18next = {
  type: '3rdParty',
  init: function init(instance) {
    setDefaults(instance.options.react);
    setI18n(instance);
  }
};
function composeInitialProps(ForComponent) {
  return function (ctx) {
    return new Promise(function (resolve) {
      var i18nInitialProps = getInitialProps();

      if (ForComponent.getInitialProps) {
        ForComponent.getInitialProps(ctx).then(function (componentsInitialProps) {
          resolve(_objectSpread(_objectSpread({}, componentsInitialProps), i18nInitialProps));
        });
      } else {
        resolve(i18nInitialProps);
      }
    });
  };
}
function getInitialProps() {
  var i18n = getI18n();
  var namespaces = i18n.reportNamespaces ? i18n.reportNamespaces.getUsedNamespaces() : [];
  var ret = {};
  var initialI18nStore = {};
  i18n.languages.forEach(function (l) {
    initialI18nStore[l] = {};
    namespaces.forEach(function (ns) {
      initialI18nStore[l][ns] = i18n.getResourceBundle(l, ns) || {};
    });
  });
  ret.initialI18nStore = initialI18nStore;
  ret.initialLanguage = i18n.language;
  return ret;
}
;// CONCATENATED MODULE: ./node_modules/next-i18next/node_modules/react-i18next/dist/es/utils.js
function warn() {
  if (console && console.warn) {
    var _console;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (typeof args[0] === 'string') args[0] = "react-i18next:: ".concat(args[0]);

    (_console = console).warn.apply(_console, args);
  }
}
var alreadyWarned = {};
function warnOnce() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  if (typeof args[0] === 'string' && alreadyWarned[args[0]]) return;
  if (typeof args[0] === 'string') alreadyWarned[args[0]] = new Date();
  warn.apply(void 0, args);
}
function loadNamespaces(i18n, ns, cb) {
  i18n.loadNamespaces(ns, function () {
    if (i18n.isInitialized) {
      cb();
    } else {
      var initialized = function initialized() {
        setTimeout(function () {
          i18n.off('initialized', initialized);
        }, 0);
        cb();
      };

      i18n.on('initialized', initialized);
    }
  });
}

function oldI18nextHasLoadedNamespace(ns, i18n) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var lng = i18n.languages[0];
  var fallbackLng = i18n.options ? i18n.options.fallbackLng : false;
  var lastLng = i18n.languages[i18n.languages.length - 1];
  if (lng.toLowerCase() === 'cimode') return true;

  var loadNotPending = function loadNotPending(l, n) {
    var loadState = i18n.services.backendConnector.state["".concat(l, "|").concat(n)];
    return loadState === -1 || loadState === 2;
  };

  if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18n.services.backendConnector.backend && i18n.isLanguageChangingTo && !loadNotPending(i18n.isLanguageChangingTo, ns)) return false;
  if (i18n.hasResourceBundle(lng, ns)) return true;
  if (!i18n.services.backendConnector.backend || i18n.options.resources && !i18n.options.partialBundledLanguages) return true;
  if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
  return false;
}

function hasLoadedNamespace(ns, i18n) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (!i18n.languages || !i18n.languages.length) {
    warnOnce('i18n.languages were undefined or empty', i18n.languages);
    return true;
  }

  var isNewerI18next = i18n.options.ignoreJSONStructure !== undefined;

  if (!isNewerI18next) {
    return oldI18nextHasLoadedNamespace(ns, i18n, options);
  }

  return i18n.hasLoadedNamespace(ns, {
    precheck: function precheck(i18nInstance, loadNotPending) {
      if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18nInstance.services.backendConnector.backend && i18nInstance.isLanguageChangingTo && !loadNotPending(i18nInstance.isLanguageChangingTo, ns)) return false;
    }
  });
}
function getDisplayName(Component) {
  return Component.displayName || Component.name || (typeof Component === 'string' && Component.length > 0 ? Component : 'Unknown');
}
;// CONCATENATED MODULE: ./node_modules/next-i18next/node_modules/react-i18next/dist/es/useTranslation.js



function useTranslation_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function useTranslation_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { useTranslation_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { useTranslation_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var usePrevious = function usePrevious(value, ignore) {
  var ref = (0,react.useRef)();
  (0,react.useEffect)(function () {
    ref.current = ignore ? ref.current : value;
  }, [value, ignore]);
  return ref.current;
};

function useTranslation(ns) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var i18nFromProps = props.i18n;

  var _ref = (0,react.useContext)(I18nContext) || {},
      i18nFromContext = _ref.i18n,
      defaultNSFromContext = _ref.defaultNS;

  var i18n = i18nFromProps || i18nFromContext || getI18n();
  if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new ReportNamespaces();

  if (!i18n) {
    warnOnce('You will need to pass in an i18next instance by using initReactI18next');

    var notReadyT = function notReadyT(k) {
      return Array.isArray(k) ? k[k.length - 1] : k;
    };

    var retNotReady = [notReadyT, {}, false];
    retNotReady.t = notReadyT;
    retNotReady.i18n = {};
    retNotReady.ready = false;
    return retNotReady;
  }

  if (i18n.options.react && i18n.options.react.wait !== undefined) warnOnce('It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.');

  var i18nOptions = useTranslation_objectSpread(useTranslation_objectSpread(useTranslation_objectSpread({}, getDefaults()), i18n.options.react), props);

  var useSuspense = i18nOptions.useSuspense,
      keyPrefix = i18nOptions.keyPrefix;
  var namespaces = ns || defaultNSFromContext || i18n.options && i18n.options.defaultNS;
  namespaces = typeof namespaces === 'string' ? [namespaces] : namespaces || ['translation'];
  if (i18n.reportNamespaces.addUsedNamespaces) i18n.reportNamespaces.addUsedNamespaces(namespaces);
  var ready = (i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every(function (n) {
    return hasLoadedNamespace(n, i18n, i18nOptions);
  });

  function getT() {
    return i18n.getFixedT(null, i18nOptions.nsMode === 'fallback' ? namespaces : namespaces[0], keyPrefix);
  }

  var _useState = (0,react.useState)(getT),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      t = _useState2[0],
      setT = _useState2[1];

  var joinedNS = namespaces.join();
  var previousJoinedNS = usePrevious(joinedNS);
  var isMounted = (0,react.useRef)(true);
  (0,react.useEffect)(function () {
    var bindI18n = i18nOptions.bindI18n,
        bindI18nStore = i18nOptions.bindI18nStore;
    isMounted.current = true;

    if (!ready && !useSuspense) {
      loadNamespaces(i18n, namespaces, function () {
        if (isMounted.current) setT(getT);
      });
    }

    if (ready && previousJoinedNS && previousJoinedNS !== joinedNS && isMounted.current) {
      setT(getT);
    }

    function boundReset() {
      if (isMounted.current) setT(getT);
    }

    if (bindI18n && i18n) i18n.on(bindI18n, boundReset);
    if (bindI18nStore && i18n) i18n.store.on(bindI18nStore, boundReset);
    return function () {
      isMounted.current = false;
      if (bindI18n && i18n) bindI18n.split(' ').forEach(function (e) {
        return i18n.off(e, boundReset);
      });
      if (bindI18nStore && i18n) bindI18nStore.split(' ').forEach(function (e) {
        return i18n.store.off(e, boundReset);
      });
    };
  }, [i18n, joinedNS]);
  var isInitial = (0,react.useRef)(true);
  (0,react.useEffect)(function () {
    if (isMounted.current && !isInitial.current) {
      setT(getT);
    }

    isInitial.current = false;
  }, [i18n, keyPrefix]);
  var ret = [t, i18n, ready];
  ret.t = t;
  ret.i18n = i18n;
  ret.ready = ready;
  if (ready) return ret;
  if (!ready && !useSuspense) return ret;
  throw new Promise(function (resolve) {
    loadNamespaces(i18n, namespaces, function () {
      resolve();
    });
  });
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(8679);
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);
;// CONCATENATED MODULE: ./node_modules/next-i18next/node_modules/react-i18next/dist/es/I18nextProvider.js


function I18nextProvider(_ref) {
  var i18n = _ref.i18n,
      defaultNS = _ref.defaultNS,
      children = _ref.children;
  var value = (0,react.useMemo)(function () {
    return {
      i18n: i18n,
      defaultNS: defaultNS
    };
  }, [i18n, defaultNS]);
  return (0,react.createElement)(I18nContext.Provider, {
    value: value
  }, children);
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js
var arrayLikeToArray = __webpack_require__(30907);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithoutHoles.js

function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return (0,arrayLikeToArray/* default */.Z)(r);
}

;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArray.js
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(40181);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableSpread.js
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js




function toConsumableArray_toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || (0,unsupportedIterableToArray/* default */.Z)(r) || _nonIterableSpread();
}

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(71002);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(45987);
;// CONCATENATED MODULE: ./node_modules/next-i18next/dist/esm/config/defaultConfig.js
var DEFAULT_LOCALE = 'en';
var LOCALES = ['en'];
var DEFAULT_NAMESPACE = 'common';
var LOCALE_PATH = './public/locales';
var LOCALE_STRUCTURE = '{{lng}}/{{ns}}';
var LOCALE_EXTENSION = 'json';
var defaultConfig = {
  defaultNS: DEFAULT_NAMESPACE,
  errorStackTraceLimit: 0,
  i18n: {
    defaultLocale: DEFAULT_LOCALE,
    locales: LOCALES
  },

  get initImmediate() {
    return  true && typeof window !== 'undefined';
  },

  interpolation: {
    escapeValue: false
  },
  load: 'currentOnly',
  localeExtension: LOCALE_EXTENSION,
  localePath: LOCALE_PATH,
  localeStructure: LOCALE_STRUCTURE,
  react: {
    useSuspense: false
  },
  reloadOnPrerender: false,
  serializeConfig: true,
  use: []
};
;// CONCATENATED MODULE: ./node_modules/next-i18next/dist/esm/utils.js


var getFallbackForLng = function getFallbackForLng(lng, fallbackLng) {
  if (typeof fallbackLng === 'string') {
    return [fallbackLng];
  }

  if (Array.isArray(fallbackLng)) {
    return fallbackLng;
  }

  if (_typeof(fallbackLng) === 'object') {
    var fallbackList = fallbackLng[lng];
    var fallbackDefault = fallbackLng["default"];
    return [].concat(_toConsumableArray(fallbackList !== null && fallbackList !== void 0 ? fallbackList : []), _toConsumableArray(fallbackDefault !== null && fallbackDefault !== void 0 ? fallbackDefault : []));
  }

  if (typeof fallbackLng === 'function') {
    return getFallbackForLng(lng, fallbackLng(lng));
  }

  return [];
};
var unique = function unique(list) {
  return Array.from(new Set(list));
};
;// CONCATENATED MODULE: ./node_modules/next-i18next/dist/esm/config/createConfig.js





var _excluded = ["i18n"],
    _excluded2 = ["i18n"];

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function createConfig_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function createConfig_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? createConfig_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : createConfig_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var deepMergeObjects = ['backend', 'detection'];
var createConfig = function createConfig(userConfig) {
  var _userConfig$use;

  if (typeof (userConfig === null || userConfig === void 0 ? void 0 : userConfig.lng) !== 'string') {
    throw new Error('config.lng was not passed into createConfig');
  } //
  // Initial merge of default and user-provided config
  //


  var userI18n = userConfig.i18n,
      userConfigStripped = (0,objectWithoutProperties/* default */.Z)(userConfig, _excluded);

  var defaultI18n = defaultConfig.i18n,
      defaultConfigStripped = (0,objectWithoutProperties/* default */.Z)(defaultConfig, _excluded2);

  var combinedConfig = createConfig_objectSpread(createConfig_objectSpread(createConfig_objectSpread(createConfig_objectSpread({}, defaultConfigStripped), userConfigStripped), defaultI18n), userI18n);

  var defaultNS = combinedConfig.defaultNS,
      lng = combinedConfig.lng,
      localeExtension = combinedConfig.localeExtension,
      localePath = combinedConfig.localePath,
      localeStructure = combinedConfig.localeStructure,
      nonExplicitSupportedLngs = combinedConfig.nonExplicitSupportedLngs;
  var locales = combinedConfig.locales.filter(function (l) {
    return l !== 'default';
  });
  /**
   * Skips translation file resolution while in cimode
   * https://github.com/i18next/next-i18next/pull/851#discussion_r503113620
  */

  if (lng === 'cimode') {
    return combinedConfig;
  }

  if (typeof combinedConfig.fallbackLng === 'undefined') {
    combinedConfig.fallbackLng = combinedConfig.defaultLocale;

    if (combinedConfig.fallbackLng === 'default') {
      var _locales = (0,slicedToArray/* default */.Z)(locales, 1);

      combinedConfig.fallbackLng = _locales[0];
    }
  }

  var fallbackLng = combinedConfig.fallbackLng;

  if (nonExplicitSupportedLngs) {
    var createFallbackObject = function createFallbackObject(acc, l) {
      var _l$split = l.split('-'),
          _l$split2 = (0,slicedToArray/* default */.Z)(_l$split, 1),
          locale = _l$split2[0];

      acc[l] = [locale];
      return acc;
    };

    if (typeof fallbackLng === 'string') {
      combinedConfig.fallbackLng = combinedConfig.locales.filter(function (l) {
        return l.includes('-');
      }).reduce(createFallbackObject, {
        "default": [fallbackLng]
      });
    } else if (Array.isArray(fallbackLng)) {
      combinedConfig.fallbackLng = combinedConfig.locales.filter(function (l) {
        return l.includes('-');
      }).reduce(createFallbackObject, {
        "default": fallbackLng
      });
    } else if ((0,esm_typeof/* default */.Z)(fallbackLng) === 'object') {
      combinedConfig.fallbackLng = Object.entries(combinedConfig.fallbackLng).reduce(function (acc, _ref) {
        var _ref2 = (0,slicedToArray/* default */.Z)(_ref, 2),
            l = _ref2[0],
            f = _ref2[1];

        acc[l] = l.includes('-') ? unique([l.split('-')[0]].concat(toConsumableArray_toConsumableArray(f))) : f;
        return acc;
      }, fallbackLng);
    } else if (typeof fallbackLng === 'function') {
      throw new Error('If nonExplicitSupportedLngs is true, no functions are allowed for fallbackLng');
    }
  }

  var hasCustomBackend = userConfig === null || userConfig === void 0 ? void 0 : (_userConfig$use = userConfig.use) === null || _userConfig$use === void 0 ? void 0 : _userConfig$use.some(function (b) {
    return b.type === 'backend';
  });

  if (false) { var getNamespaces, _defaultFallbackNSExists, _fallback, _defaultNSExists, _defaultNSPath, defaultFallbackNSExists, fallback, defaultNSExists, defaultNSPath, defaultFile, defaultLocaleStructure, suffix, prefix, _userConfig$interpola, _userConfig$interpola2, _userConfig$interpola3, _userConfig$interpola4, path, fs; } else {
    //
    // Set client side backend, if there is no custom backend
    //
    if (!hasCustomBackend) {
      if (typeof localePath === 'string') {
        combinedConfig.backend = {
          addPath: "".concat(localePath, "/").concat(localeStructure, ".missing.").concat(localeExtension),
          loadPath: "".concat(localePath, "/").concat(localeStructure, ".").concat(localeExtension)
        };
      } else if (typeof localePath === 'function') {
        combinedConfig.backend = {
          addPath: function addPath(locale, namespace) {
            return localePath(locale, namespace, true);
          },
          loadPath: function loadPath(locale, namespace) {
            return localePath(locale, namespace, false);
          }
        };
      }
    }

    if (typeof combinedConfig.ns !== 'string' && !Array.isArray(combinedConfig.ns)) {
      combinedConfig.ns = [defaultNS];
    }
  } //
  // Deep merge with overwrite - goes last
  //


  deepMergeObjects.forEach(function (obj) {
    if (userConfig[obj]) {
      combinedConfig[obj] = createConfig_objectSpread(createConfig_objectSpread({}, combinedConfig[obj]), userConfig[obj]);
    }
  });
  return combinedConfig;
};
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__(97326);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__(60136);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__(82963);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__(61120);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js
var arrayWithHoles = __webpack_require__(83878);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableRest.js
var nonIterableRest = __webpack_require__(25267);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toArray.js




function _toArray(r) {
  return (0,arrayWithHoles/* default */.Z)(r) || _iterableToArray(r) || (0,unsupportedIterableToArray/* default */.Z)(r) || (0,nonIterableRest/* default */.Z)();
}

;// CONCATENATED MODULE: ./node_modules/next-i18next/node_modules/i18next/dist/esm/i18next.js










function i18next_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function i18next_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { i18next_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { i18next_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var consoleLogger = {
  type: 'logger',
  log: function log(args) {
    this.output('log', args);
  },
  warn: function warn(args) {
    this.output('warn', args);
  },
  error: function error(args) {
    this.output('error', args);
  },
  output: function output(type, args) {
    if (console && console[type]) console[type].apply(console, args);
  }
};

var Logger = function () {
  function Logger(concreteLogger) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    (0,classCallCheck/* default */.Z)(this, Logger);

    this.init(concreteLogger, options);
  }

  (0,createClass/* default */.Z)(Logger, [{
    key: "init",
    value: function init(concreteLogger) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.prefix = options.prefix || 'i18next:';
      this.logger = concreteLogger || consoleLogger;
      this.options = options;
      this.debug = options.debug;
    }
  }, {
    key: "setDebug",
    value: function setDebug(bool) {
      this.debug = bool;
    }
  }, {
    key: "log",
    value: function log() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return this.forward(args, 'log', '', true);
    }
  }, {
    key: "warn",
    value: function warn() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return this.forward(args, 'warn', '', true);
    }
  }, {
    key: "error",
    value: function error() {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return this.forward(args, 'error', '');
    }
  }, {
    key: "deprecate",
    value: function deprecate() {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
    }
  }, {
    key: "forward",
    value: function forward(args, lvl, prefix, debugOnly) {
      if (debugOnly && !this.debug) return null;
      if (typeof args[0] === 'string') args[0] = "".concat(prefix).concat(this.prefix, " ").concat(args[0]);
      return this.logger[lvl](args);
    }
  }, {
    key: "create",
    value: function create(moduleName) {
      return new Logger(this.logger, i18next_objectSpread(i18next_objectSpread({}, {
        prefix: "".concat(this.prefix, ":").concat(moduleName, ":")
      }), this.options));
    }
  }, {
    key: "clone",
    value: function clone(options) {
      options = options || this.options;
      options.prefix = options.prefix || this.prefix;
      return new Logger(this.logger, options);
    }
  }]);

  return Logger;
}();

var baseLogger = new Logger();

var EventEmitter = function () {
  function EventEmitter() {
    (0,classCallCheck/* default */.Z)(this, EventEmitter);

    this.observers = {};
  }

  (0,createClass/* default */.Z)(EventEmitter, [{
    key: "on",
    value: function on(events, listener) {
      var _this = this;

      events.split(' ').forEach(function (event) {
        _this.observers[event] = _this.observers[event] || [];

        _this.observers[event].push(listener);
      });
      return this;
    }
  }, {
    key: "off",
    value: function off(event, listener) {
      if (!this.observers[event]) return;

      if (!listener) {
        delete this.observers[event];
        return;
      }

      this.observers[event] = this.observers[event].filter(function (l) {
        return l !== listener;
      });
    }
  }, {
    key: "emit",
    value: function emit(event) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      if (this.observers[event]) {
        var cloned = [].concat(this.observers[event]);
        cloned.forEach(function (observer) {
          observer.apply(void 0, args);
        });
      }

      if (this.observers['*']) {
        var _cloned = [].concat(this.observers['*']);

        _cloned.forEach(function (observer) {
          observer.apply(observer, [event].concat(args));
        });
      }
    }
  }]);

  return EventEmitter;
}();

function defer() {
  var res;
  var rej;
  var promise = new Promise(function (resolve, reject) {
    res = resolve;
    rej = reject;
  });
  promise.resolve = res;
  promise.reject = rej;
  return promise;
}
function makeString(object) {
  if (object == null) return '';
  return '' + object;
}
function copy(a, s, t) {
  a.forEach(function (m) {
    if (s[m]) t[m] = s[m];
  });
}

function getLastOfPath(object, path, Empty) {
  function cleanKey(key) {
    return key && key.indexOf('###') > -1 ? key.replace(/###/g, '.') : key;
  }

  function canNotTraverseDeeper() {
    return !object || typeof object === 'string';
  }

  var stack = typeof path !== 'string' ? [].concat(path) : path.split('.');

  while (stack.length > 1) {
    if (canNotTraverseDeeper()) return {};
    var key = cleanKey(stack.shift());
    if (!object[key] && Empty) object[key] = new Empty();

    if (Object.prototype.hasOwnProperty.call(object, key)) {
      object = object[key];
    } else {
      object = {};
    }
  }

  if (canNotTraverseDeeper()) return {};
  return {
    obj: object,
    k: cleanKey(stack.shift())
  };
}

function setPath(object, path, newValue) {
  var _getLastOfPath = getLastOfPath(object, path, Object),
      obj = _getLastOfPath.obj,
      k = _getLastOfPath.k;

  obj[k] = newValue;
}
function pushPath(object, path, newValue, concat) {
  var _getLastOfPath2 = getLastOfPath(object, path, Object),
      obj = _getLastOfPath2.obj,
      k = _getLastOfPath2.k;

  obj[k] = obj[k] || [];
  if (concat) obj[k] = obj[k].concat(newValue);
  if (!concat) obj[k].push(newValue);
}
function getPath(object, path) {
  var _getLastOfPath3 = getLastOfPath(object, path),
      obj = _getLastOfPath3.obj,
      k = _getLastOfPath3.k;

  if (!obj) return undefined;
  return obj[k];
}
function getPathWithDefaults(data, defaultData, key) {
  var value = getPath(data, key);

  if (value !== undefined) {
    return value;
  }

  return getPath(defaultData, key);
}
function deepExtend(target, source, overwrite) {
  for (var prop in source) {
    if (prop !== '__proto__' && prop !== 'constructor') {
      if (prop in target) {
        if (typeof target[prop] === 'string' || target[prop] instanceof String || typeof source[prop] === 'string' || source[prop] instanceof String) {
          if (overwrite) target[prop] = source[prop];
        } else {
          deepExtend(target[prop], source[prop], overwrite);
        }
      } else {
        target[prop] = source[prop];
      }
    }
  }

  return target;
}
function regexEscape(str) {
  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
}
var _entityMap = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
  '/': '&#x2F;'
};
function i18next_escape(data) {
  if (typeof data === 'string') {
    return data.replace(/[&<>"'\/]/g, function (s) {
      return _entityMap[s];
    });
  }

  return data;
}
var isIE10 = typeof window !== 'undefined' && window.navigator && typeof window.navigator.userAgentData === 'undefined' && window.navigator.userAgent && window.navigator.userAgent.indexOf('MSIE') > -1;
var chars = [' ', ',', '?', '!', ';'];
function looksLikeObjectPath(key, nsSeparator, keySeparator) {
  nsSeparator = nsSeparator || '';
  keySeparator = keySeparator || '';
  var possibleChars = chars.filter(function (c) {
    return nsSeparator.indexOf(c) < 0 && keySeparator.indexOf(c) < 0;
  });
  if (possibleChars.length === 0) return true;
  var r = new RegExp("(".concat(possibleChars.map(function (c) {
    return c === '?' ? '\\?' : c;
  }).join('|'), ")"));
  var matched = !r.test(key);

  if (!matched) {
    var ki = key.indexOf(keySeparator);

    if (ki > 0 && !r.test(key.substring(0, ki))) {
      matched = true;
    }
  }

  return matched;
}

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function deepFind(obj, path) {
  var keySeparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '.';
  if (!obj) return undefined;
  if (obj[path]) return obj[path];
  var paths = path.split(keySeparator);
  var current = obj;

  for (var i = 0; i < paths.length; ++i) {
    if (!current) return undefined;

    if (typeof current[paths[i]] === 'string' && i + 1 < paths.length) {
      return undefined;
    }

    if (current[paths[i]] === undefined) {
      var j = 2;
      var p = paths.slice(i, i + j).join(keySeparator);
      var mix = current[p];

      while (mix === undefined && paths.length > i + j) {
        j++;
        p = paths.slice(i, i + j).join(keySeparator);
        mix = current[p];
      }

      if (mix === undefined) return undefined;
      if (mix === null) return null;

      if (path.endsWith(p)) {
        if (typeof mix === 'string') return mix;
        if (p && typeof mix[p] === 'string') return mix[p];
      }

      var joinedPath = paths.slice(i + j).join(keySeparator);
      if (joinedPath) return deepFind(mix, joinedPath, keySeparator);
      return undefined;
    }

    current = current[paths[i]];
  }

  return current;
}

var ResourceStore = function (_EventEmitter) {
  (0,inherits/* default */.Z)(ResourceStore, _EventEmitter);

  var _super = _createSuper(ResourceStore);

  function ResourceStore(data) {
    var _this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      ns: ['translation'],
      defaultNS: 'translation'
    };

    (0,classCallCheck/* default */.Z)(this, ResourceStore);

    _this = _super.call(this);

    if (isIE10) {
      EventEmitter.call((0,assertThisInitialized/* default */.Z)(_this));
    }

    _this.data = data || {};
    _this.options = options;

    if (_this.options.keySeparator === undefined) {
      _this.options.keySeparator = '.';
    }

    if (_this.options.ignoreJSONStructure === undefined) {
      _this.options.ignoreJSONStructure = true;
    }

    return _this;
  }

  (0,createClass/* default */.Z)(ResourceStore, [{
    key: "addNamespaces",
    value: function addNamespaces(ns) {
      if (this.options.ns.indexOf(ns) < 0) {
        this.options.ns.push(ns);
      }
    }
  }, {
    key: "removeNamespaces",
    value: function removeNamespaces(ns) {
      var index = this.options.ns.indexOf(ns);

      if (index > -1) {
        this.options.ns.splice(index, 1);
      }
    }
  }, {
    key: "getResource",
    value: function getResource(lng, ns, key) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
      var ignoreJSONStructure = options.ignoreJSONStructure !== undefined ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
      var path = [lng, ns];
      if (key && typeof key !== 'string') path = path.concat(key);
      if (key && typeof key === 'string') path = path.concat(keySeparator ? key.split(keySeparator) : key);

      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
      }

      var result = getPath(this.data, path);
      if (result || !ignoreJSONStructure || typeof key !== 'string') return result;
      return deepFind(this.data && this.data[lng] && this.data[lng][ns], key, keySeparator);
    }
  }, {
    key: "addResource",
    value: function addResource(lng, ns, key, value) {
      var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
        silent: false
      };
      var keySeparator = this.options.keySeparator;
      if (keySeparator === undefined) keySeparator = '.';
      var path = [lng, ns];
      if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);

      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
        value = ns;
        ns = path[1];
      }

      this.addNamespaces(ns);
      setPath(this.data, path, value);
      if (!options.silent) this.emit('added', lng, ns, key, value);
    }
  }, {
    key: "addResources",
    value: function addResources(lng, ns, resources) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
        silent: false
      };

      for (var m in resources) {
        if (typeof resources[m] === 'string' || Object.prototype.toString.apply(resources[m]) === '[object Array]') this.addResource(lng, ns, m, resources[m], {
          silent: true
        });
      }

      if (!options.silent) this.emit('added', lng, ns, resources);
    }
  }, {
    key: "addResourceBundle",
    value: function addResourceBundle(lng, ns, resources, deep, overwrite) {
      var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {
        silent: false
      };
      var path = [lng, ns];

      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
        deep = resources;
        resources = ns;
        ns = path[1];
      }

      this.addNamespaces(ns);
      var pack = getPath(this.data, path) || {};

      if (deep) {
        deepExtend(pack, resources, overwrite);
      } else {
        pack = _objectSpread$1(_objectSpread$1({}, pack), resources);
      }

      setPath(this.data, path, pack);
      if (!options.silent) this.emit('added', lng, ns, resources);
    }
  }, {
    key: "removeResourceBundle",
    value: function removeResourceBundle(lng, ns) {
      if (this.hasResourceBundle(lng, ns)) {
        delete this.data[lng][ns];
      }

      this.removeNamespaces(ns);
      this.emit('removed', lng, ns);
    }
  }, {
    key: "hasResourceBundle",
    value: function hasResourceBundle(lng, ns) {
      return this.getResource(lng, ns) !== undefined;
    }
  }, {
    key: "getResourceBundle",
    value: function getResourceBundle(lng, ns) {
      if (!ns) ns = this.options.defaultNS;
      if (this.options.compatibilityAPI === 'v1') return _objectSpread$1(_objectSpread$1({}, {}), this.getResource(lng, ns));
      return this.getResource(lng, ns);
    }
  }, {
    key: "getDataByLanguage",
    value: function getDataByLanguage(lng) {
      return this.data[lng];
    }
  }, {
    key: "hasLanguageSomeTranslations",
    value: function hasLanguageSomeTranslations(lng) {
      var data = this.getDataByLanguage(lng);
      var n = data && Object.keys(data) || [];
      return !!n.find(function (v) {
        return data[v] && Object.keys(data[v]).length > 0;
      });
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return this.data;
    }
  }]);

  return ResourceStore;
}(EventEmitter);

var postProcessor = {
  processors: {},
  addPostProcessor: function addPostProcessor(module) {
    this.processors[module.name] = module;
  },
  handle: function handle(processors, value, key, options, translator) {
    var _this = this;

    processors.forEach(function (processor) {
      if (_this.processors[processor]) value = _this.processors[processor].process(value, key, options, translator);
    });
    return value;
  }
};

function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$2(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper$1(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$1(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function _isNativeReflectConstruct$1() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var checkedLoadedFor = {};

var Translator = function (_EventEmitter) {
  (0,inherits/* default */.Z)(Translator, _EventEmitter);

  var _super = _createSuper$1(Translator);

  function Translator(services) {
    var _this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    (0,classCallCheck/* default */.Z)(this, Translator);

    _this = _super.call(this);

    if (isIE10) {
      EventEmitter.call((0,assertThisInitialized/* default */.Z)(_this));
    }

    copy(['resourceStore', 'languageUtils', 'pluralResolver', 'interpolator', 'backendConnector', 'i18nFormat', 'utils'], services, (0,assertThisInitialized/* default */.Z)(_this));
    _this.options = options;

    if (_this.options.keySeparator === undefined) {
      _this.options.keySeparator = '.';
    }

    _this.logger = baseLogger.create('translator');
    return _this;
  }

  (0,createClass/* default */.Z)(Translator, [{
    key: "changeLanguage",
    value: function changeLanguage(lng) {
      if (lng) this.language = lng;
    }
  }, {
    key: "exists",
    value: function exists(key) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        interpolation: {}
      };

      if (key === undefined || key === null) {
        return false;
      }

      var resolved = this.resolve(key, options);
      return resolved && resolved.res !== undefined;
    }
  }, {
    key: "extractFromKey",
    value: function extractFromKey(key, options) {
      var nsSeparator = options.nsSeparator !== undefined ? options.nsSeparator : this.options.nsSeparator;
      if (nsSeparator === undefined) nsSeparator = ':';
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
      var namespaces = options.ns || this.options.defaultNS || [];
      var wouldCheckForNsInKey = nsSeparator && key.indexOf(nsSeparator) > -1;
      var seemsNaturalLanguage = !this.options.userDefinedKeySeparator && !options.keySeparator && !this.options.userDefinedNsSeparator && !options.nsSeparator && !looksLikeObjectPath(key, nsSeparator, keySeparator);

      if (wouldCheckForNsInKey && !seemsNaturalLanguage) {
        var m = key.match(this.interpolator.nestingRegexp);

        if (m && m.length > 0) {
          return {
            key: key,
            namespaces: namespaces
          };
        }

        var parts = key.split(nsSeparator);
        if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
        key = parts.join(keySeparator);
      }

      if (typeof namespaces === 'string') namespaces = [namespaces];
      return {
        key: key,
        namespaces: namespaces
      };
    }
  }, {
    key: "translate",
    value: function translate(keys, options, lastKey) {
      var _this2 = this;

      if ((0,esm_typeof/* default */.Z)(options) !== 'object' && this.options.overloadTranslationOptionHandler) {
        options = this.options.overloadTranslationOptionHandler(arguments);
      }

      if (!options) options = {};
      if (keys === undefined || keys === null) return '';
      if (!Array.isArray(keys)) keys = [String(keys)];
      var returnDetails = options.returnDetails !== undefined ? options.returnDetails : this.options.returnDetails;
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;

      var _this$extractFromKey = this.extractFromKey(keys[keys.length - 1], options),
          key = _this$extractFromKey.key,
          namespaces = _this$extractFromKey.namespaces;

      var namespace = namespaces[namespaces.length - 1];
      var lng = options.lng || this.language;
      var appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;

      if (lng && lng.toLowerCase() === 'cimode') {
        if (appendNamespaceToCIMode) {
          var nsSeparator = options.nsSeparator || this.options.nsSeparator;

          if (returnDetails) {
            resolved.res = "".concat(namespace).concat(nsSeparator).concat(key);
            return resolved;
          }

          return "".concat(namespace).concat(nsSeparator).concat(key);
        }

        if (returnDetails) {
          resolved.res = key;
          return resolved;
        }

        return key;
      }

      var resolved = this.resolve(keys, options);
      var res = resolved && resolved.res;
      var resUsedKey = resolved && resolved.usedKey || key;
      var resExactUsedKey = resolved && resolved.exactUsedKey || key;
      var resType = Object.prototype.toString.apply(res);
      var noObject = ['[object Number]', '[object Function]', '[object RegExp]'];
      var joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;
      var handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
      var handleAsObject = typeof res !== 'string' && typeof res !== 'boolean' && typeof res !== 'number';

      if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !(typeof joinArrays === 'string' && resType === '[object Array]')) {
        if (!options.returnObjects && !this.options.returnObjects) {
          if (!this.options.returnedObjectHandler) {
            this.logger.warn('accessing an object - but returnObjects options is not enabled!');
          }

          var r = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, _objectSpread$2(_objectSpread$2({}, options), {}, {
            ns: namespaces
          })) : "key '".concat(key, " (").concat(this.language, ")' returned an object instead of string.");

          if (returnDetails) {
            resolved.res = r;
            return resolved;
          }

          return r;
        }

        if (keySeparator) {
          var resTypeIsArray = resType === '[object Array]';
          var copy = resTypeIsArray ? [] : {};
          var newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;

          for (var m in res) {
            if (Object.prototype.hasOwnProperty.call(res, m)) {
              var deepKey = "".concat(newKeyToUse).concat(keySeparator).concat(m);
              copy[m] = this.translate(deepKey, _objectSpread$2(_objectSpread$2({}, options), {
                joinArrays: false,
                ns: namespaces
              }));
              if (copy[m] === deepKey) copy[m] = res[m];
            }
          }

          res = copy;
        }
      } else if (handleAsObjectInI18nFormat && typeof joinArrays === 'string' && resType === '[object Array]') {
        res = res.join(joinArrays);
        if (res) res = this.extendTranslation(res, keys, options, lastKey);
      } else {
        var usedDefault = false;
        var usedKey = false;
        var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
        var hasDefaultValue = Translator.hasDefaultValue(options);
        var defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, options) : '';
        var defaultValue = options["defaultValue".concat(defaultValueSuffix)] || options.defaultValue;

        if (!this.isValidLookup(res) && hasDefaultValue) {
          usedDefault = true;
          res = defaultValue;
        }

        if (!this.isValidLookup(res)) {
          usedKey = true;
          res = key;
        }

        var missingKeyNoValueFallbackToKey = options.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
        var resForMissing = missingKeyNoValueFallbackToKey && usedKey ? undefined : res;
        var updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;

        if (usedKey || usedDefault || updateMissing) {
          this.logger.log(updateMissing ? 'updateKey' : 'missingKey', lng, namespace, key, updateMissing ? defaultValue : res);

          if (keySeparator) {
            var fk = this.resolve(key, _objectSpread$2(_objectSpread$2({}, options), {}, {
              keySeparator: false
            }));
            if (fk && fk.res) this.logger.warn('Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.');
          }

          var lngs = [];
          var fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);

          if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) {
            for (var i = 0; i < fallbackLngs.length; i++) {
              lngs.push(fallbackLngs[i]);
            }
          } else if (this.options.saveMissingTo === 'all') {
            lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
          } else {
            lngs.push(options.lng || this.language);
          }

          var send = function send(l, k, specificDefaultValue) {
            var defaultForMissing = hasDefaultValue && specificDefaultValue !== res ? specificDefaultValue : resForMissing;

            if (_this2.options.missingKeyHandler) {
              _this2.options.missingKeyHandler(l, namespace, k, defaultForMissing, updateMissing, options);
            } else if (_this2.backendConnector && _this2.backendConnector.saveMissing) {
              _this2.backendConnector.saveMissing(l, namespace, k, defaultForMissing, updateMissing, options);
            }

            _this2.emit('missingKey', l, namespace, k, res);
          };

          if (this.options.saveMissing) {
            if (this.options.saveMissingPlurals && needsPluralHandling) {
              lngs.forEach(function (language) {
                _this2.pluralResolver.getSuffixes(language, options).forEach(function (suffix) {
                  send([language], key + suffix, options["defaultValue".concat(suffix)] || defaultValue);
                });
              });
            } else {
              send(lngs, key, defaultValue);
            }
          }
        }

        res = this.extendTranslation(res, keys, options, resolved, lastKey);
        if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = "".concat(namespace, ":").concat(key);

        if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) {
          if (this.options.compatibilityAPI !== 'v1') {
            res = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? "".concat(namespace, ":").concat(key) : key, usedDefault ? res : undefined);
          } else {
            res = this.options.parseMissingKeyHandler(res);
          }
        }
      }

      if (returnDetails) {
        resolved.res = res;
        return resolved;
      }

      return res;
    }
  }, {
    key: "extendTranslation",
    value: function extendTranslation(res, key, options, resolved, lastKey) {
      var _this3 = this;

      if (this.i18nFormat && this.i18nFormat.parse) {
        res = this.i18nFormat.parse(res, _objectSpread$2(_objectSpread$2({}, this.options.interpolation.defaultVariables), options), resolved.usedLng, resolved.usedNS, resolved.usedKey, {
          resolved: resolved
        });
      } else if (!options.skipInterpolation) {
        if (options.interpolation) this.interpolator.init(_objectSpread$2(_objectSpread$2({}, options), {
          interpolation: _objectSpread$2(_objectSpread$2({}, this.options.interpolation), options.interpolation)
        }));
        var skipOnVariables = typeof res === 'string' && (options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
        var nestBef;

        if (skipOnVariables) {
          var nb = res.match(this.interpolator.nestingRegexp);
          nestBef = nb && nb.length;
        }

        var data = options.replace && typeof options.replace !== 'string' ? options.replace : options;
        if (this.options.interpolation.defaultVariables) data = _objectSpread$2(_objectSpread$2({}, this.options.interpolation.defaultVariables), data);
        res = this.interpolator.interpolate(res, data, options.lng || this.language, options);

        if (skipOnVariables) {
          var na = res.match(this.interpolator.nestingRegexp);
          var nestAft = na && na.length;
          if (nestBef < nestAft) options.nest = false;
        }

        if (options.nest !== false) res = this.interpolator.nest(res, function () {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          if (lastKey && lastKey[0] === args[0] && !options.context) {
            _this3.logger.warn("It seems you are nesting recursively key: ".concat(args[0], " in key: ").concat(key[0]));

            return null;
          }

          return _this3.translate.apply(_this3, args.concat([key]));
        }, options);
        if (options.interpolation) this.interpolator.reset();
      }

      var postProcess = options.postProcess || this.options.postProcess;
      var postProcessorNames = typeof postProcess === 'string' ? [postProcess] : postProcess;

      if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) {
        res = postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? _objectSpread$2({
          i18nResolved: resolved
        }, options) : options, this);
      }

      return res;
    }
  }, {
    key: "resolve",
    value: function resolve(keys) {
      var _this4 = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var found;
      var usedKey;
      var exactUsedKey;
      var usedLng;
      var usedNS;
      if (typeof keys === 'string') keys = [keys];
      keys.forEach(function (k) {
        if (_this4.isValidLookup(found)) return;

        var extracted = _this4.extractFromKey(k, options);

        var key = extracted.key;
        usedKey = key;
        var namespaces = extracted.namespaces;
        if (_this4.options.fallbackNS) namespaces = namespaces.concat(_this4.options.fallbackNS);
        var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';

        var needsZeroSuffixLookup = needsPluralHandling && !options.ordinal && options.count === 0 && _this4.pluralResolver.shouldUseIntlApi();

        var needsContextHandling = options.context !== undefined && (typeof options.context === 'string' || typeof options.context === 'number') && options.context !== '';
        var codes = options.lngs ? options.lngs : _this4.languageUtils.toResolveHierarchy(options.lng || _this4.language, options.fallbackLng);
        namespaces.forEach(function (ns) {
          if (_this4.isValidLookup(found)) return;
          usedNS = ns;

          if (!checkedLoadedFor["".concat(codes[0], "-").concat(ns)] && _this4.utils && _this4.utils.hasLoadedNamespace && !_this4.utils.hasLoadedNamespace(usedNS)) {
            checkedLoadedFor["".concat(codes[0], "-").concat(ns)] = true;

            _this4.logger.warn("key \"".concat(usedKey, "\" for languages \"").concat(codes.join(', '), "\" won't get resolved as namespace \"").concat(usedNS, "\" was not yet loaded"), 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
          }

          codes.forEach(function (code) {
            if (_this4.isValidLookup(found)) return;
            usedLng = code;
            var finalKeys = [key];

            if (_this4.i18nFormat && _this4.i18nFormat.addLookupKeys) {
              _this4.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
            } else {
              var pluralSuffix;
              if (needsPluralHandling) pluralSuffix = _this4.pluralResolver.getSuffix(code, options.count, options);
              var zeroSuffix = "".concat(_this4.options.pluralSeparator, "zero");

              if (needsPluralHandling) {
                finalKeys.push(key + pluralSuffix);

                if (needsZeroSuffixLookup) {
                  finalKeys.push(key + zeroSuffix);
                }
              }

              if (needsContextHandling) {
                var contextKey = "".concat(key).concat(_this4.options.contextSeparator).concat(options.context);
                finalKeys.push(contextKey);

                if (needsPluralHandling) {
                  finalKeys.push(contextKey + pluralSuffix);

                  if (needsZeroSuffixLookup) {
                    finalKeys.push(contextKey + zeroSuffix);
                  }
                }
              }
            }

            var possibleKey;

            while (possibleKey = finalKeys.pop()) {
              if (!_this4.isValidLookup(found)) {
                exactUsedKey = possibleKey;
                found = _this4.getResource(code, ns, possibleKey, options);
              }
            }
          });
        });
      });
      return {
        res: found,
        usedKey: usedKey,
        exactUsedKey: exactUsedKey,
        usedLng: usedLng,
        usedNS: usedNS
      };
    }
  }, {
    key: "isValidLookup",
    value: function isValidLookup(res) {
      return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
    }
  }, {
    key: "getResource",
    value: function getResource(code, ns, key) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      if (this.i18nFormat && this.i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
      return this.resourceStore.getResource(code, ns, key, options);
    }
  }], [{
    key: "hasDefaultValue",
    value: function hasDefaultValue(options) {
      var prefix = 'defaultValue';

      for (var option in options) {
        if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && undefined !== options[option]) {
          return true;
        }
      }

      return false;
    }
  }]);

  return Translator;
}(EventEmitter);

function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

var LanguageUtil = function () {
  function LanguageUtil(options) {
    (0,classCallCheck/* default */.Z)(this, LanguageUtil);

    this.options = options;
    this.supportedLngs = this.options.supportedLngs || false;
    this.logger = baseLogger.create('languageUtils');
  }

  (0,createClass/* default */.Z)(LanguageUtil, [{
    key: "getScriptPartFromCode",
    value: function getScriptPartFromCode(code) {
      if (!code || code.indexOf('-') < 0) return null;
      var p = code.split('-');
      if (p.length === 2) return null;
      p.pop();
      if (p[p.length - 1].toLowerCase() === 'x') return null;
      return this.formatLanguageCode(p.join('-'));
    }
  }, {
    key: "getLanguagePartFromCode",
    value: function getLanguagePartFromCode(code) {
      if (!code || code.indexOf('-') < 0) return code;
      var p = code.split('-');
      return this.formatLanguageCode(p[0]);
    }
  }, {
    key: "formatLanguageCode",
    value: function formatLanguageCode(code) {
      if (typeof code === 'string' && code.indexOf('-') > -1) {
        var specialCases = ['hans', 'hant', 'latn', 'cyrl', 'cans', 'mong', 'arab'];
        var p = code.split('-');

        if (this.options.lowerCaseLng) {
          p = p.map(function (part) {
            return part.toLowerCase();
          });
        } else if (p.length === 2) {
          p[0] = p[0].toLowerCase();
          p[1] = p[1].toUpperCase();
          if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
        } else if (p.length === 3) {
          p[0] = p[0].toLowerCase();
          if (p[1].length === 2) p[1] = p[1].toUpperCase();
          if (p[0] !== 'sgn' && p[2].length === 2) p[2] = p[2].toUpperCase();
          if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
          if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = capitalize(p[2].toLowerCase());
        }

        return p.join('-');
      }

      return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
    }
  }, {
    key: "isSupportedCode",
    value: function isSupportedCode(code) {
      if (this.options.load === 'languageOnly' || this.options.nonExplicitSupportedLngs) {
        code = this.getLanguagePartFromCode(code);
      }

      return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
    }
  }, {
    key: "getBestMatchFromCodes",
    value: function getBestMatchFromCodes(codes) {
      var _this = this;

      if (!codes) return null;
      var found;
      codes.forEach(function (code) {
        if (found) return;

        var cleanedLng = _this.formatLanguageCode(code);

        if (!_this.options.supportedLngs || _this.isSupportedCode(cleanedLng)) found = cleanedLng;
      });

      if (!found && this.options.supportedLngs) {
        codes.forEach(function (code) {
          if (found) return;

          var lngOnly = _this.getLanguagePartFromCode(code);

          if (_this.isSupportedCode(lngOnly)) return found = lngOnly;
          found = _this.options.supportedLngs.find(function (supportedLng) {
            if (supportedLng.indexOf(lngOnly) === 0) return supportedLng;
          });
        });
      }

      if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
      return found;
    }
  }, {
    key: "getFallbackCodes",
    value: function getFallbackCodes(fallbacks, code) {
      if (!fallbacks) return [];
      if (typeof fallbacks === 'function') fallbacks = fallbacks(code);
      if (typeof fallbacks === 'string') fallbacks = [fallbacks];
      if (Object.prototype.toString.apply(fallbacks) === '[object Array]') return fallbacks;
      if (!code) return fallbacks["default"] || [];
      var found = fallbacks[code];
      if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
      if (!found) found = fallbacks[this.formatLanguageCode(code)];
      if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
      if (!found) found = fallbacks["default"];
      return found || [];
    }
  }, {
    key: "toResolveHierarchy",
    value: function toResolveHierarchy(code, fallbackCode) {
      var _this2 = this;

      var fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
      var codes = [];

      var addCode = function addCode(c) {
        if (!c) return;

        if (_this2.isSupportedCode(c)) {
          codes.push(c);
        } else {
          _this2.logger.warn("rejecting language code not found in supportedLngs: ".concat(c));
        }
      };

      if (typeof code === 'string' && code.indexOf('-') > -1) {
        if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
        if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
        if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
      } else if (typeof code === 'string') {
        addCode(this.formatLanguageCode(code));
      }

      fallbackCodes.forEach(function (fc) {
        if (codes.indexOf(fc) < 0) addCode(_this2.formatLanguageCode(fc));
      });
      return codes;
    }
  }]);

  return LanguageUtil;
}();

var sets = [{
  lngs: ['ach', 'ak', 'am', 'arn', 'br', 'fil', 'gun', 'ln', 'mfe', 'mg', 'mi', 'oc', 'pt', 'pt-BR', 'tg', 'tl', 'ti', 'tr', 'uz', 'wa'],
  nr: [1, 2],
  fc: 1
}, {
  lngs: ['af', 'an', 'ast', 'az', 'bg', 'bn', 'ca', 'da', 'de', 'dev', 'el', 'en', 'eo', 'es', 'et', 'eu', 'fi', 'fo', 'fur', 'fy', 'gl', 'gu', 'ha', 'hi', 'hu', 'hy', 'ia', 'it', 'kk', 'kn', 'ku', 'lb', 'mai', 'ml', 'mn', 'mr', 'nah', 'nap', 'nb', 'ne', 'nl', 'nn', 'no', 'nso', 'pa', 'pap', 'pms', 'ps', 'pt-PT', 'rm', 'sco', 'se', 'si', 'so', 'son', 'sq', 'sv', 'sw', 'ta', 'te', 'tk', 'ur', 'yo'],
  nr: [1, 2],
  fc: 2
}, {
  lngs: ['ay', 'bo', 'cgg', 'fa', 'ht', 'id', 'ja', 'jbo', 'ka', 'km', 'ko', 'ky', 'lo', 'ms', 'sah', 'su', 'th', 'tt', 'ug', 'vi', 'wo', 'zh'],
  nr: [1],
  fc: 3
}, {
  lngs: ['be', 'bs', 'cnr', 'dz', 'hr', 'ru', 'sr', 'uk'],
  nr: [1, 2, 5],
  fc: 4
}, {
  lngs: ['ar'],
  nr: [0, 1, 2, 3, 11, 100],
  fc: 5
}, {
  lngs: ['cs', 'sk'],
  nr: [1, 2, 5],
  fc: 6
}, {
  lngs: ['csb', 'pl'],
  nr: [1, 2, 5],
  fc: 7
}, {
  lngs: ['cy'],
  nr: [1, 2, 3, 8],
  fc: 8
}, {
  lngs: ['fr'],
  nr: [1, 2],
  fc: 9
}, {
  lngs: ['ga'],
  nr: [1, 2, 3, 7, 11],
  fc: 10
}, {
  lngs: ['gd'],
  nr: [1, 2, 3, 20],
  fc: 11
}, {
  lngs: ['is'],
  nr: [1, 2],
  fc: 12
}, {
  lngs: ['jv'],
  nr: [0, 1],
  fc: 13
}, {
  lngs: ['kw'],
  nr: [1, 2, 3, 4],
  fc: 14
}, {
  lngs: ['lt'],
  nr: [1, 2, 10],
  fc: 15
}, {
  lngs: ['lv'],
  nr: [1, 2, 0],
  fc: 16
}, {
  lngs: ['mk'],
  nr: [1, 2],
  fc: 17
}, {
  lngs: ['mnk'],
  nr: [0, 1, 2],
  fc: 18
}, {
  lngs: ['mt'],
  nr: [1, 2, 11, 20],
  fc: 19
}, {
  lngs: ['or'],
  nr: [2, 1],
  fc: 2
}, {
  lngs: ['ro'],
  nr: [1, 2, 20],
  fc: 20
}, {
  lngs: ['sl'],
  nr: [5, 1, 2, 3],
  fc: 21
}, {
  lngs: ['he', 'iw'],
  nr: [1, 2, 20, 21],
  fc: 22
}];
var _rulesPluralsTypes = {
  1: function _(n) {
    return Number(n > 1);
  },
  2: function _(n) {
    return Number(n != 1);
  },
  3: function _(n) {
    return 0;
  },
  4: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  5: function _(n) {
    return Number(n == 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
  },
  6: function _(n) {
    return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
  },
  7: function _(n) {
    return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  8: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
  },
  9: function _(n) {
    return Number(n >= 2);
  },
  10: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
  },
  11: function _(n) {
    return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
  },
  12: function _(n) {
    return Number(n % 10 != 1 || n % 100 == 11);
  },
  13: function _(n) {
    return Number(n !== 0);
  },
  14: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
  },
  15: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  16: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
  },
  17: function _(n) {
    return Number(n == 1 || n % 10 == 1 && n % 100 != 11 ? 0 : 1);
  },
  18: function _(n) {
    return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
  },
  19: function _(n) {
    return Number(n == 1 ? 0 : n == 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
  },
  20: function _(n) {
    return Number(n == 1 ? 0 : n == 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
  },
  21: function _(n) {
    return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
  },
  22: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3);
  }
};
var deprecatedJsonVersions = ['v1', 'v2', 'v3'];
var suffixesOrder = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
};

function createRules() {
  var rules = {};
  sets.forEach(function (set) {
    set.lngs.forEach(function (l) {
      rules[l] = {
        numbers: set.nr,
        plurals: _rulesPluralsTypes[set.fc]
      };
    });
  });
  return rules;
}

var PluralResolver = function () {
  function PluralResolver(languageUtils) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    (0,classCallCheck/* default */.Z)(this, PluralResolver);

    this.languageUtils = languageUtils;
    this.options = options;
    this.logger = baseLogger.create('pluralResolver');

    if ((!this.options.compatibilityJSON || this.options.compatibilityJSON === 'v4') && (typeof Intl === 'undefined' || !Intl.PluralRules)) {
      this.options.compatibilityJSON = 'v3';
      this.logger.error('Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.');
    }

    this.rules = createRules();
  }

  (0,createClass/* default */.Z)(PluralResolver, [{
    key: "addRule",
    value: function addRule(lng, obj) {
      this.rules[lng] = obj;
    }
  }, {
    key: "getRule",
    value: function getRule(code) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (this.shouldUseIntlApi()) {
        try {
          return new Intl.PluralRules(code, {
            type: options.ordinal ? 'ordinal' : 'cardinal'
          });
        } catch (_unused) {
          return;
        }
      }

      return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
    }
  }, {
    key: "needsPlural",
    value: function needsPlural(code) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var rule = this.getRule(code, options);

      if (this.shouldUseIntlApi()) {
        return rule && rule.resolvedOptions().pluralCategories.length > 1;
      }

      return rule && rule.numbers.length > 1;
    }
  }, {
    key: "getPluralFormsOfKey",
    value: function getPluralFormsOfKey(code, key) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return this.getSuffixes(code, options).map(function (suffix) {
        return "".concat(key).concat(suffix);
      });
    }
  }, {
    key: "getSuffixes",
    value: function getSuffixes(code) {
      var _this = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var rule = this.getRule(code, options);

      if (!rule) {
        return [];
      }

      if (this.shouldUseIntlApi()) {
        return rule.resolvedOptions().pluralCategories.sort(function (pluralCategory1, pluralCategory2) {
          return suffixesOrder[pluralCategory1] - suffixesOrder[pluralCategory2];
        }).map(function (pluralCategory) {
          return "".concat(_this.options.prepend).concat(pluralCategory);
        });
      }

      return rule.numbers.map(function (number) {
        return _this.getSuffix(code, number, options);
      });
    }
  }, {
    key: "getSuffix",
    value: function getSuffix(code, count) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var rule = this.getRule(code, options);

      if (rule) {
        if (this.shouldUseIntlApi()) {
          return "".concat(this.options.prepend).concat(rule.select(count));
        }

        return this.getSuffixRetroCompatible(rule, count);
      }

      this.logger.warn("no plural rule found for: ".concat(code));
      return '';
    }
  }, {
    key: "getSuffixRetroCompatible",
    value: function getSuffixRetroCompatible(rule, count) {
      var _this2 = this;

      var idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
      var suffix = rule.numbers[idx];

      if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
        if (suffix === 2) {
          suffix = 'plural';
        } else if (suffix === 1) {
          suffix = '';
        }
      }

      var returnSuffix = function returnSuffix() {
        return _this2.options.prepend && suffix.toString() ? _this2.options.prepend + suffix.toString() : suffix.toString();
      };

      if (this.options.compatibilityJSON === 'v1') {
        if (suffix === 1) return '';
        if (typeof suffix === 'number') return "_plural_".concat(suffix.toString());
        return returnSuffix();
      } else if (this.options.compatibilityJSON === 'v2') {
        return returnSuffix();
      } else if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
        return returnSuffix();
      }

      return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
    }
  }, {
    key: "shouldUseIntlApi",
    value: function shouldUseIntlApi() {
      return !deprecatedJsonVersions.includes(this.options.compatibilityJSON);
    }
  }]);

  return PluralResolver;
}();

function ownKeys$3(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$3(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$3(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$3(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var Interpolator = function () {
  function Interpolator() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0,classCallCheck/* default */.Z)(this, Interpolator);

    this.logger = baseLogger.create('interpolator');
    this.options = options;

    this.format = options.interpolation && options.interpolation.format || function (value) {
      return value;
    };

    this.init(options);
  }

  (0,createClass/* default */.Z)(Interpolator, [{
    key: "init",
    value: function init() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (!options.interpolation) options.interpolation = {
        escapeValue: true
      };
      var iOpts = options.interpolation;
      this.escape = iOpts.escape !== undefined ? iOpts.escape : i18next_escape;
      this.escapeValue = iOpts.escapeValue !== undefined ? iOpts.escapeValue : true;
      this.useRawValueToEscape = iOpts.useRawValueToEscape !== undefined ? iOpts.useRawValueToEscape : false;
      this.prefix = iOpts.prefix ? regexEscape(iOpts.prefix) : iOpts.prefixEscaped || '{{';
      this.suffix = iOpts.suffix ? regexEscape(iOpts.suffix) : iOpts.suffixEscaped || '}}';
      this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ',';
      this.unescapePrefix = iOpts.unescapeSuffix ? '' : iOpts.unescapePrefix || '-';
      this.unescapeSuffix = this.unescapePrefix ? '' : iOpts.unescapeSuffix || '';
      this.nestingPrefix = iOpts.nestingPrefix ? regexEscape(iOpts.nestingPrefix) : iOpts.nestingPrefixEscaped || regexEscape('$t(');
      this.nestingSuffix = iOpts.nestingSuffix ? regexEscape(iOpts.nestingSuffix) : iOpts.nestingSuffixEscaped || regexEscape(')');
      this.nestingOptionsSeparator = iOpts.nestingOptionsSeparator ? iOpts.nestingOptionsSeparator : iOpts.nestingOptionsSeparator || ',';
      this.maxReplaces = iOpts.maxReplaces ? iOpts.maxReplaces : 1000;
      this.alwaysFormat = iOpts.alwaysFormat !== undefined ? iOpts.alwaysFormat : false;
      this.resetRegExp();
    }
  }, {
    key: "reset",
    value: function reset() {
      if (this.options) this.init(this.options);
    }
  }, {
    key: "resetRegExp",
    value: function resetRegExp() {
      var regexpStr = "".concat(this.prefix, "(.+?)").concat(this.suffix);
      this.regexp = new RegExp(regexpStr, 'g');
      var regexpUnescapeStr = "".concat(this.prefix).concat(this.unescapePrefix, "(.+?)").concat(this.unescapeSuffix).concat(this.suffix);
      this.regexpUnescape = new RegExp(regexpUnescapeStr, 'g');
      var nestingRegexpStr = "".concat(this.nestingPrefix, "(.+?)").concat(this.nestingSuffix);
      this.nestingRegexp = new RegExp(nestingRegexpStr, 'g');
    }
  }, {
    key: "interpolate",
    value: function interpolate(str, data, lng, options) {
      var _this = this;

      var match;
      var value;
      var replaces;
      var defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};

      function regexSafe(val) {
        return val.replace(/\$/g, '$$$$');
      }

      var handleFormat = function handleFormat(key) {
        if (key.indexOf(_this.formatSeparator) < 0) {
          var path = getPathWithDefaults(data, defaultData, key);
          return _this.alwaysFormat ? _this.format(path, undefined, lng, _objectSpread$3(_objectSpread$3(_objectSpread$3({}, options), data), {}, {
            interpolationkey: key
          })) : path;
        }

        var p = key.split(_this.formatSeparator);
        var k = p.shift().trim();
        var f = p.join(_this.formatSeparator).trim();
        return _this.format(getPathWithDefaults(data, defaultData, k), f, lng, _objectSpread$3(_objectSpread$3(_objectSpread$3({}, options), data), {}, {
          interpolationkey: k
        }));
      };

      this.resetRegExp();
      var missingInterpolationHandler = options && options.missingInterpolationHandler || this.options.missingInterpolationHandler;
      var skipOnVariables = options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
      var todos = [{
        regex: this.regexpUnescape,
        safeValue: function safeValue(val) {
          return regexSafe(val);
        }
      }, {
        regex: this.regexp,
        safeValue: function safeValue(val) {
          return _this.escapeValue ? regexSafe(_this.escape(val)) : regexSafe(val);
        }
      }];
      todos.forEach(function (todo) {
        replaces = 0;

        while (match = todo.regex.exec(str)) {
          var matchedVar = match[1].trim();
          value = handleFormat(matchedVar);

          if (value === undefined) {
            if (typeof missingInterpolationHandler === 'function') {
              var temp = missingInterpolationHandler(str, match, options);
              value = typeof temp === 'string' ? temp : '';
            } else if (options && options.hasOwnProperty(matchedVar)) {
              value = '';
            } else if (skipOnVariables) {
              value = match[0];
              continue;
            } else {
              _this.logger.warn("missed to pass in variable ".concat(matchedVar, " for interpolating ").concat(str));

              value = '';
            }
          } else if (typeof value !== 'string' && !_this.useRawValueToEscape) {
            value = makeString(value);
          }

          var safeValue = todo.safeValue(value);
          str = str.replace(match[0], safeValue);

          if (skipOnVariables) {
            todo.regex.lastIndex += value.length;
            todo.regex.lastIndex -= match[0].length;
          } else {
            todo.regex.lastIndex = 0;
          }

          replaces++;

          if (replaces >= _this.maxReplaces) {
            break;
          }
        }
      });
      return str;
    }
  }, {
    key: "nest",
    value: function nest(str, fc) {
      var _this2 = this;

      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var match;
      var value;

      var clonedOptions = _objectSpread$3({}, options);

      clonedOptions.applyPostProcessor = false;
      delete clonedOptions.defaultValue;

      function handleHasOptions(key, inheritedOptions) {
        var sep = this.nestingOptionsSeparator;
        if (key.indexOf(sep) < 0) return key;
        var c = key.split(new RegExp("".concat(sep, "[ ]*{")));
        var optionsString = "{".concat(c[1]);
        key = c[0];
        optionsString = this.interpolate(optionsString, clonedOptions);
        var matchedSingleQuotes = optionsString.match(/'/g);
        var matchedDoubleQuotes = optionsString.match(/"/g);

        if (matchedSingleQuotes && matchedSingleQuotes.length % 2 === 0 && !matchedDoubleQuotes || matchedDoubleQuotes.length % 2 !== 0) {
          optionsString = optionsString.replace(/'/g, '"');
        }

        try {
          clonedOptions = JSON.parse(optionsString);
          if (inheritedOptions) clonedOptions = _objectSpread$3(_objectSpread$3({}, inheritedOptions), clonedOptions);
        } catch (e) {
          this.logger.warn("failed parsing options string in nesting for key ".concat(key), e);
          return "".concat(key).concat(sep).concat(optionsString);
        }

        delete clonedOptions.defaultValue;
        return key;
      }

      while (match = this.nestingRegexp.exec(str)) {
        var formatters = [];
        var doReduce = false;

        if (match[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(match[1])) {
          var r = match[1].split(this.formatSeparator).map(function (elem) {
            return elem.trim();
          });
          match[1] = r.shift();
          formatters = r;
          doReduce = true;
        }

        value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
        if (value && match[0] === str && typeof value !== 'string') return value;
        if (typeof value !== 'string') value = makeString(value);

        if (!value) {
          this.logger.warn("missed to resolve ".concat(match[1], " for nesting ").concat(str));
          value = '';
        }

        if (doReduce) {
          value = formatters.reduce(function (v, f) {
            return _this2.format(v, f, options.lng, _objectSpread$3(_objectSpread$3({}, options), {}, {
              interpolationkey: match[1].trim()
            }));
          }, value.trim());
        }

        str = str.replace(match[0], value);
        this.regexp.lastIndex = 0;
      }

      return str;
    }
  }]);

  return Interpolator;
}();

function ownKeys$4(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$4(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$4(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$4(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function parseFormatStr(formatStr) {
  var formatName = formatStr.toLowerCase().trim();
  var formatOptions = {};

  if (formatStr.indexOf('(') > -1) {
    var p = formatStr.split('(');
    formatName = p[0].toLowerCase().trim();
    var optStr = p[1].substring(0, p[1].length - 1);

    if (formatName === 'currency' && optStr.indexOf(':') < 0) {
      if (!formatOptions.currency) formatOptions.currency = optStr.trim();
    } else if (formatName === 'relativetime' && optStr.indexOf(':') < 0) {
      if (!formatOptions.range) formatOptions.range = optStr.trim();
    } else {
      var opts = optStr.split(';');
      opts.forEach(function (opt) {
        if (!opt) return;

        var _opt$split = opt.split(':'),
            _opt$split2 = _toArray(_opt$split),
            key = _opt$split2[0],
            rest = _opt$split2.slice(1);

        var val = rest.join(':').trim().replace(/^'+|'+$/g, '');
        if (!formatOptions[key.trim()]) formatOptions[key.trim()] = val;
        if (val === 'false') formatOptions[key.trim()] = false;
        if (val === 'true') formatOptions[key.trim()] = true;
        if (!isNaN(val)) formatOptions[key.trim()] = parseInt(val, 10);
      });
    }
  }

  return {
    formatName: formatName,
    formatOptions: formatOptions
  };
}

function createCachedFormatter(fn) {
  var cache = {};
  return function invokeFormatter(val, lng, options) {
    var key = lng + JSON.stringify(options);
    var formatter = cache[key];

    if (!formatter) {
      formatter = fn(lng, options);
      cache[key] = formatter;
    }

    return formatter(val);
  };
}

var Formatter = function () {
  function Formatter() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0,classCallCheck/* default */.Z)(this, Formatter);

    this.logger = baseLogger.create('formatter');
    this.options = options;
    this.formats = {
      number: createCachedFormatter(function (lng, options) {
        var formatter = new Intl.NumberFormat(lng, options);
        return function (val) {
          return formatter.format(val);
        };
      }),
      currency: createCachedFormatter(function (lng, options) {
        var formatter = new Intl.NumberFormat(lng, _objectSpread$4(_objectSpread$4({}, options), {}, {
          style: 'currency'
        }));
        return function (val) {
          return formatter.format(val);
        };
      }),
      datetime: createCachedFormatter(function (lng, options) {
        var formatter = new Intl.DateTimeFormat(lng, _objectSpread$4({}, options));
        return function (val) {
          return formatter.format(val);
        };
      }),
      relativetime: createCachedFormatter(function (lng, options) {
        var formatter = new Intl.RelativeTimeFormat(lng, _objectSpread$4({}, options));
        return function (val) {
          return formatter.format(val, options.range || 'day');
        };
      }),
      list: createCachedFormatter(function (lng, options) {
        var formatter = new Intl.ListFormat(lng, _objectSpread$4({}, options));
        return function (val) {
          return formatter.format(val);
        };
      })
    };
    this.init(options);
  }

  (0,createClass/* default */.Z)(Formatter, [{
    key: "init",
    value: function init(services) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        interpolation: {}
      };
      var iOpts = options.interpolation;
      this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ',';
    }
  }, {
    key: "add",
    value: function add(name, fc) {
      this.formats[name.toLowerCase().trim()] = fc;
    }
  }, {
    key: "addCached",
    value: function addCached(name, fc) {
      this.formats[name.toLowerCase().trim()] = createCachedFormatter(fc);
    }
  }, {
    key: "format",
    value: function format(value, _format, lng, options) {
      var _this = this;

      var formats = _format.split(this.formatSeparator);

      var result = formats.reduce(function (mem, f) {
        var _parseFormatStr = parseFormatStr(f),
            formatName = _parseFormatStr.formatName,
            formatOptions = _parseFormatStr.formatOptions;

        if (_this.formats[formatName]) {
          var formatted = mem;

          try {
            var valOptions = options && options.formatParams && options.formatParams[options.interpolationkey] || {};
            var l = valOptions.locale || valOptions.lng || options.locale || options.lng || lng;
            formatted = _this.formats[formatName](mem, l, _objectSpread$4(_objectSpread$4(_objectSpread$4({}, formatOptions), options), valOptions));
          } catch (error) {
            _this.logger.warn(error);
          }

          return formatted;
        } else {
          _this.logger.warn("there was no format function for ".concat(formatName));
        }

        return mem;
      }, value);
      return result;
    }
  }]);

  return Formatter;
}();

function ownKeys$5(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$5(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$5(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$5(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper$2(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$2(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function _isNativeReflectConstruct$2() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function removePending(q, name) {
  if (q.pending[name] !== undefined) {
    delete q.pending[name];
    q.pendingCount--;
  }
}

var Connector = function (_EventEmitter) {
  (0,inherits/* default */.Z)(Connector, _EventEmitter);

  var _super = _createSuper$2(Connector);

  function Connector(backend, store, services) {
    var _this;

    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    (0,classCallCheck/* default */.Z)(this, Connector);

    _this = _super.call(this);

    if (isIE10) {
      EventEmitter.call((0,assertThisInitialized/* default */.Z)(_this));
    }

    _this.backend = backend;
    _this.store = store;
    _this.services = services;
    _this.languageUtils = services.languageUtils;
    _this.options = options;
    _this.logger = baseLogger.create('backendConnector');
    _this.waitingReads = [];
    _this.maxParallelReads = options.maxParallelReads || 10;
    _this.readingCalls = 0;
    _this.maxRetries = options.maxRetries >= 0 ? options.maxRetries : 5;
    _this.retryTimeout = options.retryTimeout >= 1 ? options.retryTimeout : 350;
    _this.state = {};
    _this.queue = [];

    if (_this.backend && _this.backend.init) {
      _this.backend.init(services, options.backend, options);
    }

    return _this;
  }

  (0,createClass/* default */.Z)(Connector, [{
    key: "queueLoad",
    value: function queueLoad(languages, namespaces, options, callback) {
      var _this2 = this;

      var toLoad = {};
      var pending = {};
      var toLoadLanguages = {};
      var toLoadNamespaces = {};
      languages.forEach(function (lng) {
        var hasAllNamespaces = true;
        namespaces.forEach(function (ns) {
          var name = "".concat(lng, "|").concat(ns);

          if (!options.reload && _this2.store.hasResourceBundle(lng, ns)) {
            _this2.state[name] = 2;
          } else if (_this2.state[name] < 0) ; else if (_this2.state[name] === 1) {
            if (pending[name] === undefined) pending[name] = true;
          } else {
            _this2.state[name] = 1;
            hasAllNamespaces = false;
            if (pending[name] === undefined) pending[name] = true;
            if (toLoad[name] === undefined) toLoad[name] = true;
            if (toLoadNamespaces[ns] === undefined) toLoadNamespaces[ns] = true;
          }
        });
        if (!hasAllNamespaces) toLoadLanguages[lng] = true;
      });

      if (Object.keys(toLoad).length || Object.keys(pending).length) {
        this.queue.push({
          pending: pending,
          pendingCount: Object.keys(pending).length,
          loaded: {},
          errors: [],
          callback: callback
        });
      }

      return {
        toLoad: Object.keys(toLoad),
        pending: Object.keys(pending),
        toLoadLanguages: Object.keys(toLoadLanguages),
        toLoadNamespaces: Object.keys(toLoadNamespaces)
      };
    }
  }, {
    key: "loaded",
    value: function loaded(name, err, data) {
      var s = name.split('|');
      var lng = s[0];
      var ns = s[1];
      if (err) this.emit('failedLoading', lng, ns, err);

      if (data) {
        this.store.addResourceBundle(lng, ns, data);
      }

      this.state[name] = err ? -1 : 2;
      var loaded = {};
      this.queue.forEach(function (q) {
        pushPath(q.loaded, [lng], ns);
        removePending(q, name);
        if (err) q.errors.push(err);

        if (q.pendingCount === 0 && !q.done) {
          Object.keys(q.loaded).forEach(function (l) {
            if (!loaded[l]) loaded[l] = {};
            var loadedKeys = q.loaded[l];

            if (loadedKeys.length) {
              loadedKeys.forEach(function (ns) {
                if (loaded[l][ns] === undefined) loaded[l][ns] = true;
              });
            }
          });
          q.done = true;

          if (q.errors.length) {
            q.callback(q.errors);
          } else {
            q.callback();
          }
        }
      });
      this.emit('loaded', loaded);
      this.queue = this.queue.filter(function (q) {
        return !q.done;
      });
    }
  }, {
    key: "read",
    value: function read(lng, ns, fcName) {
      var _this3 = this;

      var tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      var wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : this.retryTimeout;
      var callback = arguments.length > 5 ? arguments[5] : undefined;
      if (!lng.length) return callback(null, {});

      if (this.readingCalls >= this.maxParallelReads) {
        this.waitingReads.push({
          lng: lng,
          ns: ns,
          fcName: fcName,
          tried: tried,
          wait: wait,
          callback: callback
        });
        return;
      }

      this.readingCalls++;
      return this.backend[fcName](lng, ns, function (err, data) {
        _this3.readingCalls--;

        if (_this3.waitingReads.length > 0) {
          var next = _this3.waitingReads.shift();

          _this3.read(next.lng, next.ns, next.fcName, next.tried, next.wait, next.callback);
        }

        if (err && data && tried < _this3.maxRetries) {
          setTimeout(function () {
            _this3.read.call(_this3, lng, ns, fcName, tried + 1, wait * 2, callback);
          }, wait);
          return;
        }

        callback(err, data);
      });
    }
  }, {
    key: "prepareLoading",
    value: function prepareLoading(languages, namespaces) {
      var _this4 = this;

      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var callback = arguments.length > 3 ? arguments[3] : undefined;

      if (!this.backend) {
        this.logger.warn('No backend was added via i18next.use. Will not load resources.');
        return callback && callback();
      }

      if (typeof languages === 'string') languages = this.languageUtils.toResolveHierarchy(languages);
      if (typeof namespaces === 'string') namespaces = [namespaces];
      var toLoad = this.queueLoad(languages, namespaces, options, callback);

      if (!toLoad.toLoad.length) {
        if (!toLoad.pending.length) callback();
        return null;
      }

      toLoad.toLoad.forEach(function (name) {
        _this4.loadOne(name);
      });
    }
  }, {
    key: "load",
    value: function load(languages, namespaces, callback) {
      this.prepareLoading(languages, namespaces, {}, callback);
    }
  }, {
    key: "reload",
    value: function reload(languages, namespaces, callback) {
      this.prepareLoading(languages, namespaces, {
        reload: true
      }, callback);
    }
  }, {
    key: "loadOne",
    value: function loadOne(name) {
      var _this5 = this;

      var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var s = name.split('|');
      var lng = s[0];
      var ns = s[1];
      this.read(lng, ns, 'read', undefined, undefined, function (err, data) {
        if (err) _this5.logger.warn("".concat(prefix, "loading namespace ").concat(ns, " for language ").concat(lng, " failed"), err);
        if (!err && data) _this5.logger.log("".concat(prefix, "loaded namespace ").concat(ns, " for language ").concat(lng), data);

        _this5.loaded(name, err, data);
      });
    }
  }, {
    key: "saveMissing",
    value: function saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
      var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};

      if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(namespace)) {
        this.logger.warn("did not save key \"".concat(key, "\" as the namespace \"").concat(namespace, "\" was not yet loaded"), 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
        return;
      }

      if (key === undefined || key === null || key === '') return;

      if (this.backend && this.backend.create) {
        this.backend.create(languages, namespace, key, fallbackValue, null, _objectSpread$5(_objectSpread$5({}, options), {}, {
          isUpdate: isUpdate
        }));
      }

      if (!languages || !languages[0]) return;
      this.store.addResource(languages[0], namespace, key, fallbackValue);
    }
  }]);

  return Connector;
}(EventEmitter);

function get() {
  return {
    debug: false,
    initImmediate: true,
    ns: ['translation'],
    defaultNS: ['translation'],
    fallbackLng: ['dev'],
    fallbackNS: false,
    supportedLngs: false,
    nonExplicitSupportedLngs: false,
    load: 'all',
    preload: false,
    simplifyPluralSuffix: true,
    keySeparator: '.',
    nsSeparator: ':',
    pluralSeparator: '_',
    contextSeparator: '_',
    partialBundledLanguages: false,
    saveMissing: false,
    updateMissing: false,
    saveMissingTo: 'fallback',
    saveMissingPlurals: true,
    missingKeyHandler: false,
    missingInterpolationHandler: false,
    postProcess: false,
    postProcessPassResolved: false,
    returnNull: true,
    returnEmptyString: true,
    returnObjects: false,
    joinArrays: false,
    returnedObjectHandler: false,
    parseMissingKeyHandler: false,
    appendNamespaceToMissingKey: false,
    appendNamespaceToCIMode: false,
    overloadTranslationOptionHandler: function handle(args) {
      var ret = {};
      if ((0,esm_typeof/* default */.Z)(args[1]) === 'object') ret = args[1];
      if (typeof args[1] === 'string') ret.defaultValue = args[1];
      if (typeof args[2] === 'string') ret.tDescription = args[2];

      if ((0,esm_typeof/* default */.Z)(args[2]) === 'object' || (0,esm_typeof/* default */.Z)(args[3]) === 'object') {
        var options = args[3] || args[2];
        Object.keys(options).forEach(function (key) {
          ret[key] = options[key];
        });
      }

      return ret;
    },
    interpolation: {
      escapeValue: true,
      format: function format(value, _format, lng, options) {
        return value;
      },
      prefix: '{{',
      suffix: '}}',
      formatSeparator: ',',
      unescapePrefix: '-',
      nestingPrefix: '$t(',
      nestingSuffix: ')',
      nestingOptionsSeparator: ',',
      maxReplaces: 1000,
      skipOnVariables: true
    }
  };
}
function transformOptions(options) {
  if (typeof options.ns === 'string') options.ns = [options.ns];
  if (typeof options.fallbackLng === 'string') options.fallbackLng = [options.fallbackLng];
  if (typeof options.fallbackNS === 'string') options.fallbackNS = [options.fallbackNS];

  if (options.supportedLngs && options.supportedLngs.indexOf('cimode') < 0) {
    options.supportedLngs = options.supportedLngs.concat(['cimode']);
  }

  return options;
}

function ownKeys$6(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$6(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$6(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$6(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper$3(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$3(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function _isNativeReflectConstruct$3() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function noop() {}

function bindMemberFunctions(inst) {
  var mems = Object.getOwnPropertyNames(Object.getPrototypeOf(inst));
  mems.forEach(function (mem) {
    if (typeof inst[mem] === 'function') {
      inst[mem] = inst[mem].bind(inst);
    }
  });
}

var I18n = function (_EventEmitter) {
  (0,inherits/* default */.Z)(I18n, _EventEmitter);

  var _super = _createSuper$3(I18n);

  function I18n() {
    var _this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments.length > 1 ? arguments[1] : undefined;

    (0,classCallCheck/* default */.Z)(this, I18n);

    _this = _super.call(this);

    if (isIE10) {
      EventEmitter.call((0,assertThisInitialized/* default */.Z)(_this));
    }

    _this.options = transformOptions(options);
    _this.services = {};
    _this.logger = baseLogger;
    _this.modules = {
      external: []
    };
    bindMemberFunctions((0,assertThisInitialized/* default */.Z)(_this));

    if (callback && !_this.isInitialized && !options.isClone) {
      if (!_this.options.initImmediate) {
        _this.init(options, callback);

        return (0,possibleConstructorReturn/* default */.Z)(_this, (0,assertThisInitialized/* default */.Z)(_this));
      }

      setTimeout(function () {
        _this.init(options, callback);
      }, 0);
    }

    return _this;
  }

  (0,createClass/* default */.Z)(I18n, [{
    key: "init",
    value: function init() {
      var _this2 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 ? arguments[1] : undefined;

      if (typeof options === 'function') {
        callback = options;
        options = {};
      }

      if (!options.defaultNS && options.defaultNS !== false && options.ns) {
        if (typeof options.ns === 'string') {
          options.defaultNS = options.ns;
        } else if (options.ns.indexOf('translation') < 0) {
          options.defaultNS = options.ns[0];
        }
      }

      var defOpts = get();
      this.options = _objectSpread$6(_objectSpread$6(_objectSpread$6({}, defOpts), this.options), transformOptions(options));

      if (this.options.compatibilityAPI !== 'v1') {
        this.options.interpolation = _objectSpread$6(_objectSpread$6({}, defOpts.interpolation), this.options.interpolation);
      }

      if (options.keySeparator !== undefined) {
        this.options.userDefinedKeySeparator = options.keySeparator;
      }

      if (options.nsSeparator !== undefined) {
        this.options.userDefinedNsSeparator = options.nsSeparator;
      }

      function createClassOnDemand(ClassOrObject) {
        if (!ClassOrObject) return null;
        if (typeof ClassOrObject === 'function') return new ClassOrObject();
        return ClassOrObject;
      }

      if (!this.options.isClone) {
        if (this.modules.logger) {
          baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
        } else {
          baseLogger.init(null, this.options);
        }

        var formatter;

        if (this.modules.formatter) {
          formatter = this.modules.formatter;
        } else if (typeof Intl !== 'undefined') {
          formatter = Formatter;
        }

        var lu = new LanguageUtil(this.options);
        this.store = new ResourceStore(this.options.resources, this.options);
        var s = this.services;
        s.logger = baseLogger;
        s.resourceStore = this.store;
        s.languageUtils = lu;
        s.pluralResolver = new PluralResolver(lu, {
          prepend: this.options.pluralSeparator,
          compatibilityJSON: this.options.compatibilityJSON,
          simplifyPluralSuffix: this.options.simplifyPluralSuffix
        });

        if (formatter && (!this.options.interpolation.format || this.options.interpolation.format === defOpts.interpolation.format)) {
          s.formatter = createClassOnDemand(formatter);
          s.formatter.init(s, this.options);
          this.options.interpolation.format = s.formatter.format.bind(s.formatter);
        }

        s.interpolator = new Interpolator(this.options);
        s.utils = {
          hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
        };
        s.backendConnector = new Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
        s.backendConnector.on('*', function (event) {
          for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
          }

          _this2.emit.apply(_this2, [event].concat(args));
        });

        if (this.modules.languageDetector) {
          s.languageDetector = createClassOnDemand(this.modules.languageDetector);
          s.languageDetector.init(s, this.options.detection, this.options);
        }

        if (this.modules.i18nFormat) {
          s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
          if (s.i18nFormat.init) s.i18nFormat.init(this);
        }

        this.translator = new Translator(this.services, this.options);
        this.translator.on('*', function (event) {
          for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            args[_key2 - 1] = arguments[_key2];
          }

          _this2.emit.apply(_this2, [event].concat(args));
        });
        this.modules.external.forEach(function (m) {
          if (m.init) m.init(_this2);
        });
      }

      this.format = this.options.interpolation.format;
      if (!callback) callback = noop;

      if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
        var codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
        if (codes.length > 0 && codes[0] !== 'dev') this.options.lng = codes[0];
      }

      if (!this.services.languageDetector && !this.options.lng) {
        this.logger.warn('init: no languageDetector is used and no lng is defined');
      }

      var storeApi = ['getResource', 'hasResourceBundle', 'getResourceBundle', 'getDataByLanguage'];
      storeApi.forEach(function (fcName) {
        _this2[fcName] = function () {
          var _this2$store;

          return (_this2$store = _this2.store)[fcName].apply(_this2$store, arguments);
        };
      });
      var storeApiChained = ['addResource', 'addResources', 'addResourceBundle', 'removeResourceBundle'];
      storeApiChained.forEach(function (fcName) {
        _this2[fcName] = function () {
          var _this2$store2;

          (_this2$store2 = _this2.store)[fcName].apply(_this2$store2, arguments);

          return _this2;
        };
      });
      var deferred = defer();

      var load = function load() {
        var finish = function finish(err, t) {
          if (_this2.isInitialized && !_this2.initializedStoreOnce) _this2.logger.warn('init: i18next is already initialized. You should call init just once!');
          _this2.isInitialized = true;
          if (!_this2.options.isClone) _this2.logger.log('initialized', _this2.options);

          _this2.emit('initialized', _this2.options);

          deferred.resolve(t);
          callback(err, t);
        };

        if (_this2.languages && _this2.options.compatibilityAPI !== 'v1' && !_this2.isInitialized) return finish(null, _this2.t.bind(_this2));

        _this2.changeLanguage(_this2.options.lng, finish);
      };

      if (this.options.resources || !this.options.initImmediate) {
        load();
      } else {
        setTimeout(load, 0);
      }

      return deferred;
    }
  }, {
    key: "loadResources",
    value: function loadResources(language) {
      var _this3 = this;

      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
      var usedCallback = callback;
      var usedLng = typeof language === 'string' ? language : this.language;
      if (typeof language === 'function') usedCallback = language;

      if (!this.options.resources || this.options.partialBundledLanguages) {
        if (usedLng && usedLng.toLowerCase() === 'cimode') return usedCallback();
        var toLoad = [];

        var append = function append(lng) {
          if (!lng) return;

          var lngs = _this3.services.languageUtils.toResolveHierarchy(lng);

          lngs.forEach(function (l) {
            if (toLoad.indexOf(l) < 0) toLoad.push(l);
          });
        };

        if (!usedLng) {
          var fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
          fallbacks.forEach(function (l) {
            return append(l);
          });
        } else {
          append(usedLng);
        }

        if (this.options.preload) {
          this.options.preload.forEach(function (l) {
            return append(l);
          });
        }

        this.services.backendConnector.load(toLoad, this.options.ns, function (e) {
          if (!e && !_this3.resolvedLanguage && _this3.language) _this3.setResolvedLanguage(_this3.language);
          usedCallback(e);
        });
      } else {
        usedCallback(null);
      }
    }
  }, {
    key: "reloadResources",
    value: function reloadResources(lngs, ns, callback) {
      var deferred = defer();
      if (!lngs) lngs = this.languages;
      if (!ns) ns = this.options.ns;
      if (!callback) callback = noop;
      this.services.backendConnector.reload(lngs, ns, function (err) {
        deferred.resolve();
        callback(err);
      });
      return deferred;
    }
  }, {
    key: "use",
    value: function use(module) {
      if (!module) throw new Error('You are passing an undefined module! Please check the object you are passing to i18next.use()');
      if (!module.type) throw new Error('You are passing a wrong module! Please check the object you are passing to i18next.use()');

      if (module.type === 'backend') {
        this.modules.backend = module;
      }

      if (module.type === 'logger' || module.log && module.warn && module.error) {
        this.modules.logger = module;
      }

      if (module.type === 'languageDetector') {
        this.modules.languageDetector = module;
      }

      if (module.type === 'i18nFormat') {
        this.modules.i18nFormat = module;
      }

      if (module.type === 'postProcessor') {
        postProcessor.addPostProcessor(module);
      }

      if (module.type === 'formatter') {
        this.modules.formatter = module;
      }

      if (module.type === '3rdParty') {
        this.modules.external.push(module);
      }

      return this;
    }
  }, {
    key: "setResolvedLanguage",
    value: function setResolvedLanguage(l) {
      if (!l || !this.languages) return;
      if (['cimode', 'dev'].indexOf(l) > -1) return;

      for (var li = 0; li < this.languages.length; li++) {
        var lngInLngs = this.languages[li];
        if (['cimode', 'dev'].indexOf(lngInLngs) > -1) continue;

        if (this.store.hasLanguageSomeTranslations(lngInLngs)) {
          this.resolvedLanguage = lngInLngs;
          break;
        }
      }
    }
  }, {
    key: "changeLanguage",
    value: function changeLanguage(lng, callback) {
      var _this4 = this;

      this.isLanguageChangingTo = lng;
      var deferred = defer();
      this.emit('languageChanging', lng);

      var setLngProps = function setLngProps(l) {
        _this4.language = l;
        _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l);
        _this4.resolvedLanguage = undefined;

        _this4.setResolvedLanguage(l);
      };

      var done = function done(err, l) {
        if (l) {
          setLngProps(l);

          _this4.translator.changeLanguage(l);

          _this4.isLanguageChangingTo = undefined;

          _this4.emit('languageChanged', l);

          _this4.logger.log('languageChanged', l);
        } else {
          _this4.isLanguageChangingTo = undefined;
        }

        deferred.resolve(function () {
          return _this4.t.apply(_this4, arguments);
        });
        if (callback) callback(err, function () {
          return _this4.t.apply(_this4, arguments);
        });
      };

      var setLng = function setLng(lngs) {
        if (!lng && !lngs && _this4.services.languageDetector) lngs = [];
        var l = typeof lngs === 'string' ? lngs : _this4.services.languageUtils.getBestMatchFromCodes(lngs);

        if (l) {
          if (!_this4.language) {
            setLngProps(l);
          }

          if (!_this4.translator.language) _this4.translator.changeLanguage(l);
          if (_this4.services.languageDetector) _this4.services.languageDetector.cacheUserLanguage(l);
        }

        _this4.loadResources(l, function (err) {
          done(err, l);
        });
      };

      if (!lng && this.services.languageDetector && !this.services.languageDetector.async) {
        setLng(this.services.languageDetector.detect());
      } else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
        this.services.languageDetector.detect(setLng);
      } else {
        setLng(lng);
      }

      return deferred;
    }
  }, {
    key: "getFixedT",
    value: function getFixedT(lng, ns, keyPrefix) {
      var _this5 = this;

      var fixedT = function fixedT(key, opts) {
        var options;

        if ((0,esm_typeof/* default */.Z)(opts) !== 'object') {
          for (var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
            rest[_key3 - 2] = arguments[_key3];
          }

          options = _this5.options.overloadTranslationOptionHandler([key, opts].concat(rest));
        } else {
          options = _objectSpread$6({}, opts);
        }

        options.lng = options.lng || fixedT.lng;
        options.lngs = options.lngs || fixedT.lngs;
        options.ns = options.ns || fixedT.ns;
        options.keyPrefix = options.keyPrefix || keyPrefix || fixedT.keyPrefix;
        var keySeparator = _this5.options.keySeparator || '.';
        var resultKey = options.keyPrefix ? "".concat(options.keyPrefix).concat(keySeparator).concat(key) : key;
        return _this5.t(resultKey, options);
      };

      if (typeof lng === 'string') {
        fixedT.lng = lng;
      } else {
        fixedT.lngs = lng;
      }

      fixedT.ns = ns;
      fixedT.keyPrefix = keyPrefix;
      return fixedT;
    }
  }, {
    key: "t",
    value: function t() {
      var _this$translator;

      return this.translator && (_this$translator = this.translator).translate.apply(_this$translator, arguments);
    }
  }, {
    key: "exists",
    value: function exists() {
      var _this$translator2;

      return this.translator && (_this$translator2 = this.translator).exists.apply(_this$translator2, arguments);
    }
  }, {
    key: "setDefaultNamespace",
    value: function setDefaultNamespace(ns) {
      this.options.defaultNS = ns;
    }
  }, {
    key: "hasLoadedNamespace",
    value: function hasLoadedNamespace(ns) {
      var _this6 = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (!this.isInitialized) {
        this.logger.warn('hasLoadedNamespace: i18next was not initialized', this.languages);
        return false;
      }

      if (!this.languages || !this.languages.length) {
        this.logger.warn('hasLoadedNamespace: i18n.languages were undefined or empty', this.languages);
        return false;
      }

      var lng = this.resolvedLanguage || this.languages[0];
      var fallbackLng = this.options ? this.options.fallbackLng : false;
      var lastLng = this.languages[this.languages.length - 1];
      if (lng.toLowerCase() === 'cimode') return true;

      var loadNotPending = function loadNotPending(l, n) {
        var loadState = _this6.services.backendConnector.state["".concat(l, "|").concat(n)];

        return loadState === -1 || loadState === 2;
      };

      if (options.precheck) {
        var preResult = options.precheck(this, loadNotPending);
        if (preResult !== undefined) return preResult;
      }

      if (this.hasResourceBundle(lng, ns)) return true;
      if (!this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages) return true;
      if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
      return false;
    }
  }, {
    key: "loadNamespaces",
    value: function loadNamespaces(ns, callback) {
      var _this7 = this;

      var deferred = defer();

      if (!this.options.ns) {
        callback && callback();
        return Promise.resolve();
      }

      if (typeof ns === 'string') ns = [ns];
      ns.forEach(function (n) {
        if (_this7.options.ns.indexOf(n) < 0) _this7.options.ns.push(n);
      });
      this.loadResources(function (err) {
        deferred.resolve();
        if (callback) callback(err);
      });
      return deferred;
    }
  }, {
    key: "loadLanguages",
    value: function loadLanguages(lngs, callback) {
      var deferred = defer();
      if (typeof lngs === 'string') lngs = [lngs];
      var preloaded = this.options.preload || [];
      var newLngs = lngs.filter(function (lng) {
        return preloaded.indexOf(lng) < 0;
      });

      if (!newLngs.length) {
        if (callback) callback();
        return Promise.resolve();
      }

      this.options.preload = preloaded.concat(newLngs);
      this.loadResources(function (err) {
        deferred.resolve();
        if (callback) callback(err);
      });
      return deferred;
    }
  }, {
    key: "dir",
    value: function dir(lng) {
      if (!lng) lng = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language);
      if (!lng) return 'rtl';
      var rtlLngs = ['ar', 'shu', 'sqr', 'ssh', 'xaa', 'yhd', 'yud', 'aao', 'abh', 'abv', 'acm', 'acq', 'acw', 'acx', 'acy', 'adf', 'ads', 'aeb', 'aec', 'afb', 'ajp', 'apc', 'apd', 'arb', 'arq', 'ars', 'ary', 'arz', 'auz', 'avl', 'ayh', 'ayl', 'ayn', 'ayp', 'bbz', 'pga', 'he', 'iw', 'ps', 'pbt', 'pbu', 'pst', 'prp', 'prd', 'ug', 'ur', 'ydd', 'yds', 'yih', 'ji', 'yi', 'hbo', 'men', 'xmn', 'fa', 'jpr', 'peo', 'pes', 'prs', 'dv', 'sam', 'ckb'];
      return rtlLngs.indexOf(this.services.languageUtils.getLanguagePartFromCode(lng)) > -1 || lng.toLowerCase().indexOf('-arab') > 1 ? 'rtl' : 'ltr';
    }
  }, {
    key: "cloneInstance",
    value: function cloneInstance() {
      var _this8 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;

      var mergedOptions = _objectSpread$6(_objectSpread$6(_objectSpread$6({}, this.options), options), {
        isClone: true
      });

      var clone = new I18n(mergedOptions);

      if (options.debug !== undefined || options.prefix !== undefined) {
        clone.logger = clone.logger.clone(options);
      }

      var membersToCopy = ['store', 'services', 'language'];
      membersToCopy.forEach(function (m) {
        clone[m] = _this8[m];
      });
      clone.services = _objectSpread$6({}, this.services);
      clone.services.utils = {
        hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
      };
      clone.translator = new Translator(clone.services, clone.options);
      clone.translator.on('*', function (event) {
        for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
          args[_key4 - 1] = arguments[_key4];
        }

        clone.emit.apply(clone, [event].concat(args));
      });
      clone.init(mergedOptions, callback);
      clone.translator.options = clone.options;
      clone.translator.backendConnector.services.utils = {
        hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
      };
      return clone;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        options: this.options,
        store: this.store,
        language: this.language,
        languages: this.languages,
        resolvedLanguage: this.resolvedLanguage
      };
    }
  }]);

  return I18n;
}(EventEmitter);

(0,defineProperty/* default */.Z)(I18n, "createInstance", function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var callback = arguments.length > 1 ? arguments[1] : undefined;
  return new I18n(options, callback);
});

var instance = I18n.createInstance();
instance.createInstance = I18n.createInstance;

var createInstance = instance.createInstance;
var init = instance.init;
var loadResources = instance.loadResources;
var reloadResources = instance.reloadResources;
var use = instance.use;
var changeLanguage = instance.changeLanguage;
var getFixedT = instance.getFixedT;
var t = instance.t;
var exists = instance.exists;
var setDefaultNamespace = instance.setDefaultNamespace;
var i18next_hasLoadedNamespace = instance.hasLoadedNamespace;
var i18next_loadNamespaces = instance.loadNamespaces;
var loadLanguages = instance.loadLanguages;

/* harmony default export */ var i18next = (instance);


;// CONCATENATED MODULE: ./node_modules/next-i18next/dist/esm/createClient/browser.js

/* harmony default export */ var browser = (function (config) {
  if (config.ns === undefined) config.ns = [];
  var instance = i18next.createInstance(config);
  var initPromise;

  if (!instance.isInitialized) {
    var _config$use;

    config === null || config === void 0 ? void 0 : (_config$use = config.use) === null || _config$use === void 0 ? void 0 : _config$use.forEach(function (x) {
      return instance.use(x);
    });

    if (typeof config.onPreInitI18next === 'function') {
      config.onPreInitI18next(instance);
    }

    initPromise = instance.init(config);
  } else {
    initPromise = Promise.resolve(i18next.t);
  }

  return {
    i18n: instance,
    initPromise: initPromise
  };
});
;// CONCATENATED MODULE: ./node_modules/next-i18next/dist/esm/appWithTranslation.js


var __jsx = react.createElement;

function appWithTranslation_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function appWithTranslation_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? appWithTranslation_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : appWithTranslation_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var globalI18n = null;
var appWithTranslation = function appWithTranslation(WrappedComponent) {
  var configOverride = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  var AppWithTranslation = function AppWithTranslation(props) {
    var _nextI18Next$initialL, _props$router;

    var _ref = props.pageProps,
        _nextI18Next = _ref._nextI18Next;
    var locale = (_nextI18Next$initialL = _nextI18Next === null || _nextI18Next === void 0 ? void 0 : _nextI18Next.initialLocale) !== null && _nextI18Next$initialL !== void 0 ? _nextI18Next$initialL : props === null || props === void 0 ? void 0 : (_props$router = props.router) === null || _props$router === void 0 ? void 0 : _props$router.locale;
    var ns = _nextI18Next === null || _nextI18Next === void 0 ? void 0 : _nextI18Next.ns; // Memoize the instance and only re-initialize when either:
    // 1. The route changes (non-shallowly)
    // 2. Router locale changes
    // 3. UserConfig override changes

    var i18n = (0,react.useMemo)(function () {
      var _userConfig, _userConfig2, _userConfig2$i18n;

      if (!_nextI18Next && !configOverride) return null;
      var userConfig = configOverride !== null && configOverride !== void 0 ? configOverride : _nextI18Next === null || _nextI18Next === void 0 ? void 0 : _nextI18Next.userConfig;

      if (!userConfig && configOverride === null) {
        throw new Error('appWithTranslation was called without a next-i18next config');
      }

      if (configOverride !== null) {
        userConfig = configOverride;
      }

      if (!((_userConfig = userConfig) !== null && _userConfig !== void 0 && _userConfig.i18n)) {
        throw new Error('appWithTranslation was called without config.i18n');
      }

      if (!((_userConfig2 = userConfig) !== null && _userConfig2 !== void 0 && (_userConfig2$i18n = _userConfig2.i18n) !== null && _userConfig2$i18n !== void 0 && _userConfig2$i18n.defaultLocale)) {
        throw new Error('config.i18n does not include a defaultLocale property');
      }

      var _ref2 = _nextI18Next || {},
          initialI18nStore = _ref2.initialI18nStore;

      var resources = configOverride !== null && configOverride !== void 0 && configOverride.resources ? configOverride.resources : initialI18nStore;
      if (!locale) locale = userConfig.i18n.defaultLocale;
      var instance = browser(appWithTranslation_objectSpread(appWithTranslation_objectSpread({}, createConfig(appWithTranslation_objectSpread(appWithTranslation_objectSpread({}, userConfig), {}, {
        lng: locale
      }))), {}, {
        lng: locale,
        ns: ns,
        resources: resources
      })).i18n;
      globalI18n = instance;
      return instance;
    }, [_nextI18Next, locale, configOverride, ns]);
    return i18n !== null ? __jsx(I18nextProvider, {
      i18n: i18n
    }, __jsx(WrappedComponent, props)) : __jsx(WrappedComponent, (0,esm_extends/* default */.Z)({
      key: locale
    }, props));
  };

  return hoist_non_react_statics_cjs_default()(AppWithTranslation, WrappedComponent);
};
;// CONCATENATED MODULE: ./node_modules/next-i18next/dist/esm/index.js



/***/ }),

/***/ 28858:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "KV": function() { return /* binding */ createWrapper; },
/* harmony export */   "ju": function() { return /* binding */ HYDRATE; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9473);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};


/**
 * Quick note on Next.js return types:
 *
 * Page.getInitialProps https://nextjs.org/docs/api-reference/data-fetching/getInitialProps
 * as-is
 *
 * App.getInitialProps: AppInitialProps https://nextjs.org/docs/advanced-features/custom-app
 * {pageProps: any}
 *
 * getStaticProps https://nextjs.org/docs/basic-features/data-fetching#getstaticprops-static-generation
 * {props: any}
 *
 * getServerSideProps https://nextjs.org/docs/basic-features/data-fetching#getserversideprops-server-side-rendering
 * {props: any}
 */
var HYDRATE = '__NEXT_REDUX_WRAPPER_HYDRATE__';
var getIsServer = function () { return typeof window === 'undefined'; };
var getDeserializedState = function (initialState, _a) {
    var _b = _a === void 0 ? {} : _a, deserializeState = _b.deserializeState;
    return deserializeState ? deserializeState(initialState) : initialState;
};
var getSerializedState = function (state, _a) {
    var _b = _a === void 0 ? {} : _a, serializeState = _b.serializeState;
    return serializeState ? serializeState(state) : state;
};
var store;
var initStore = function (_a) {
    var makeStore = _a.makeStore, context = _a.context;
    var createStore = function () { return makeStore(context); };
    if (getIsServer()) {
        var c = context;
        var req = void 0;
        if (c.req)
            req = c.req;
        if (c.ctx && c.ctx.req)
            req = c.ctx.req;
        if (req) {
            // ATTENTION! THIS IS INTERNAL, DO NOT ACCESS DIRECTLY ANYWHERE ELSE
            // @see https://github.com/kirill-konshin/next-redux-wrapper/pull/196#issuecomment-611673546
            if (!req.__nextReduxWrapperStore)
                req.__nextReduxWrapperStore = createStore();
            return req.__nextReduxWrapperStore;
        }
        return createStore();
    }
    // Memoize store if client
    if (!store) {
        store = createStore();
    }
    return store;
};
var createWrapper = function (makeStore, config) {
    if (config === void 0) { config = {}; }
    var makeProps = function (_a) {
        var callback = _a.callback, context = _a.context;
        return __awaiter(void 0, void 0, void 0, function () {
            var store, nextCallback, initialProps, _b, state;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        store = initStore({ context: context, makeStore: makeStore });
                        if (config.debug)
                            console.log("1. getProps created store with state", store.getState());
                        nextCallback = callback && callback(store);
                        _b = nextCallback;
                        if (!_b) return [3 /*break*/, 2];
                        return [4 /*yield*/, nextCallback(context)];
                    case 1:
                        _b = (_c.sent());
                        _c.label = 2;
                    case 2:
                        initialProps = (_b) || {};
                        if (config.debug)
                            console.log("3. getProps after dispatches has store state", store.getState());
                        state = store.getState();
                        return [2 /*return*/, {
                                initialProps: initialProps,
                                initialState: getIsServer() ? getSerializedState(state, config) : state,
                            }];
                }
            });
        });
    };
    var getInitialPageProps = function (callback) { return function (context) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if ('getState' in context) {
                return [2 /*return*/, callback && callback(context)];
            }
            return [2 /*return*/, makeProps({ callback: callback, context: context })];
        });
    }); }; };
    var getInitialAppProps = function (callback) { return function (context) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, initialProps, initialState;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, makeProps({ callback: callback, context: context })];
                case 1:
                    _a = _b.sent(), initialProps = _a.initialProps, initialState = _a.initialState;
                    return [2 /*return*/, __assign(__assign({}, initialProps), { initialState: initialState })];
            }
        });
    }); }; };
    var getStaticProps = function (callback) { return function (context) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, initialProps, initialState;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, makeProps({ callback: callback, context: context })];
                case 1:
                    _a = _b.sent(), initialProps = _a.initialProps, initialState = _a.initialState;
                    return [2 /*return*/, __assign(__assign({}, initialProps), { props: __assign(__assign({}, initialProps.props), { initialState: initialState }) })];
            }
        });
    }); }; };
    var getServerSideProps = function (callback) { return function (context) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getStaticProps(callback)(context)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    }); }); }; }; // just not to repeat myself
    var withRedux = function (Component) {
        var _a;
        var displayName = "withRedux(" + (Component.displayName || Component.name || 'Component') + ")";
        var hasInitialProps = 'getInitialProps' in Component;
        //TODO Check if pages/_app was wrapped so there's no need to wrap a page itself
        return _a = /** @class */ (function (_super) {
                __extends(Wrapper, _super);
                function Wrapper(props, context) {
                    var _this = _super.call(this, props, context) || this;
                    _this.store = null;
                    _this.hydrate(props, context);
                    return _this;
                }
                Wrapper.prototype.hydrate = function (_a, context) {
                    var _b;
                    var initialState = _a.initialState, initialProps = _a.initialProps, props = __rest(_a, ["initialState", "initialProps"]);
                    // this happens when App has page with getServerSideProps/getStaticProps, initialState will be dumped twice:
                    // one incomplete and one complete
                    var initialStateFromGSPorGSSR = (_b = props === null || props === void 0 ? void 0 : props.pageProps) === null || _b === void 0 ? void 0 : _b.initialState;
                    if (!this.store) {
                        this.store = initStore({ makeStore: makeStore, context: context });
                        if (config.debug)
                            console.log('4. WrappedApp created new store with', displayName, {
                                initialState: initialState,
                                initialStateFromGSPorGSSR: initialStateFromGSPorGSSR,
                            });
                    }
                    if (initialState)
                        this.store.dispatch({
                            type: HYDRATE,
                            payload: getDeserializedState(initialState, config),
                        });
                    // ATTENTION! This code assumes that Page's getServerSideProps is executed after App.getInitialProps
                    // so we dispatch in this order
                    if (initialStateFromGSPorGSSR)
                        this.store.dispatch({
                            type: HYDRATE,
                            payload: getDeserializedState(initialStateFromGSPorGSSR, config),
                        });
                };
                Wrapper.prototype.shouldComponentUpdate = function (nextProps, nextState, nextContext) {
                    var _a, _b, _c, _d;
                    if (((_a = nextProps === null || nextProps === void 0 ? void 0 : nextProps.pageProps) === null || _a === void 0 ? void 0 : _a.initialState) !== ((_c = (_b = this.props) === null || _b === void 0 ? void 0 : _b.pageProps) === null || _c === void 0 ? void 0 : _c.initialState) ||
                        (nextProps === null || nextProps === void 0 ? void 0 : nextProps.initialState) !== ((_d = this.props) === null || _d === void 0 ? void 0 : _d.initialState)) {
                        this.hydrate(nextProps, nextContext);
                    }
                    return true;
                };
                Wrapper.prototype.render = function () {
                    var _a, _b;
                    var _c = this.props, initialState = _c.initialState, initialProps = _c.initialProps, props = __rest(_c, ["initialState", "initialProps"]);
                    var resultProps = props;
                    // order is important! Next.js overwrites props from pages/_app with getStaticProps from page
                    // @see https://github.com/zeit/next.js/issues/11648
                    if (initialProps && initialProps.pageProps)
                        resultProps.pageProps = __assign(__assign({}, initialProps.pageProps), props.pageProps);
                    var initialStateFromGSPorGSSR = (_a = props === null || props === void 0 ? void 0 : props.pageProps) === null || _a === void 0 ? void 0 : _a.initialState;
                    // just some cleanup to prevent passing it as props, we need to clone props to safely delete initialState
                    if (initialStateFromGSPorGSSR) {
                        resultProps = __assign(__assign({}, props), { pageProps: __assign({}, props.pageProps) });
                        delete resultProps.pageProps.initialState;
                    }
                    // unwrap getInitialPageProps
                    if ((_b = resultProps === null || resultProps === void 0 ? void 0 : resultProps.pageProps) === null || _b === void 0 ? void 0 : _b.initialProps) {
                        resultProps.pageProps = __assign(__assign({}, resultProps.pageProps), resultProps.pageProps.initialProps);
                        delete resultProps.pageProps.initialProps;
                    }
                    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(react_redux__WEBPACK_IMPORTED_MODULE_1__/* .Provider */ .zt, { store: this.store },
                        react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, __assign({}, initialProps, resultProps))));
                };
                return Wrapper;
            }(react__WEBPACK_IMPORTED_MODULE_0__.Component)),
            _a.displayName = displayName,
            _a.getInitialProps = hasInitialProps ? Component.getInitialProps : undefined,
            _a;
    };
    return {
        getServerSideProps: getServerSideProps,
        getStaticProps: getStaticProps,
        getInitialAppProps: getInitialAppProps,
        getInitialPageProps: getInitialPageProps,
        withRedux: withRedux,
    };
};
// Legacy
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = (function (makeStore, config) {
    if (config === void 0) { config = {}; }
    console.warn('/!\\ You are using legacy implementaion. Please update your code: use createWrapper() and wrapper.withRedux().');
    return createWrapper(makeStore, config).withRedux;
});
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 83454:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var ref, ref1;
module.exports = ((ref = __webpack_require__.g.process) == null ? void 0 : ref.env) && typeof ((ref1 = __webpack_require__.g.process) == null ? void 0 : ref1.env) === "object" ? __webpack_require__.g.process : __webpack_require__(77663);

//# sourceMappingURL=process.js.map

/***/ }),

/***/ 23837:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_app",
      function () {
        return __webpack_require__(30146);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 65110:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/calendar.3ccff5e2.svg","height":19,"width":19});

/***/ }),

/***/ 26693:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/close-white.d3f1a0ed.svg","height":17,"width":17});

/***/ }),

/***/ 653:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/close.8c2dae8d.svg","height":17,"width":17});

/***/ }),

/***/ 91883:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/download-dark-gray.44fffa51.svg","height":16,"width":14});

/***/ }),

/***/ 39306:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/email.b2f119d5.svg","height":20,"width":28});

/***/ }),

/***/ 23896:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/left-arrow.1d5a986e.svg","height":17,"width":10});

/***/ }),

/***/ 55619:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/modal-close.5d34d298.svg","height":29,"width":28});

/***/ }),

/***/ 52324:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/phone-icon.92125abd.svg","height":22,"width":19});

/***/ }),

/***/ 14074:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/right-arrow.94e30f19.svg","height":17,"width":10});

/***/ }),

/***/ 83790:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/search.9197ce09.svg","height":19,"width":18});

/***/ }),

/***/ 66773:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/share.c1bcda3a.svg","height":17,"width":14});

/***/ }),

/***/ 29875:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/wish.b0a7483e.svg","height":14,"width":15});

/***/ }),

/***/ 62084:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/wishlist-gray-filled.091dca10.svg","height":20,"width":23});

/***/ }),

/***/ 36513:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/image-missing.e5ede0fc.png","height":1200,"width":1310,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAMAAAACh/xsAAAABlBMVEX////19fVC0XEuAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAEUlEQVQImWNgwAYYGXEyUAEAAPwAB/jM1CkAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":7});

/***/ }),

/***/ 59001:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/spinner.3693c331.svg","height":100,"width":100});

/***/ }),

/***/ 36562:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/swatch-missing.457436f1.jpeg","height":368,"width":368,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAIAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAf/xAAcEAABAwUAAAAAAAAAAAAAAAAAARIUBBETIWH/xAAUAQEAAAAAAAAAAAAAAAAAAAAA/8QAFBEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEQMRAD8AraT5m8K07uusAAP/2Q==","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 66564:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_AemGrid; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./hooks/useIsSsr.js
var useIsSsr = __webpack_require__(2595);
// EXTERNAL MODULE: ./constants/index.js
var constants = __webpack_require__(96301);
// EXTERNAL MODULE: ./utils/index.js
var utils = __webpack_require__(20558);
// EXTERNAL MODULE: ./node_modules/react-scroll/modules/index.js
var modules = __webpack_require__(66261);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./components/Shared/ContainerComponent.jsx




const ContainerComponent = (param)=>{
    let { children , extraProps , item , count  } = param;
    const isTargetModule = (item === null || item === void 0 ? void 0 : item.contentType) === "target";
    const router = (0,next_router.useRouter)();
    (0,react.useEffect)(()=>{
        const timeOut = setTimeout(()=>{
            var ref;
            var ref1;
            const hashValue = (ref1 = router === null || router === void 0 ? void 0 : (ref = router.asPath) === null || ref === void 0 ? void 0 : ref.split("#")[1]) !== null && ref1 !== void 0 ? ref1 : "";
            if (hashValue) {
                var ref2;
                var ref3;
                const element = (ref3 = document.querySelector("[id='".concat(hashValue, "']"))) !== null && ref3 !== void 0 ? ref3 : {};
                var ref4;
                const offsetTop = (ref4 = element === null || element === void 0 ? void 0 : (ref2 = element.parentNode) === null || ref2 === void 0 ? void 0 : ref2.offsetTop) !== null && ref4 !== void 0 ? ref4 : 0;
                window.scrollTo({
                    top: offsetTop,
                    behavior: "smooth"
                });
            }
        }, 1000);
        return ()=>{
            clearTimeout(timeOut);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "cmp-container".concat((extraProps === null || extraProps === void 0 ? void 0 : extraProps.fragment) === constants.FRAGMENT_TYPES.HEADER && (extraProps === null || extraProps === void 0 ? void 0 : extraProps.hasGlobalNavigation) && count === 0 ? " desk-header-height" : "").concat(isTargetModule ? " hidden" : ""),
        id: item === null || item === void 0 ? void 0 : item.containerId,
        children: children
    });
};
/* harmony default export */ var Shared_ContainerComponent = (ContainerComponent);

// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/factory/factory.utils.mjs
var factory_utils = __webpack_require__(99347);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Other/Box/Box.mjs + 1 modules
var Box = __webpack_require__(3253);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Layout/Spacer/Spacer.mjs + 2 modules
var Spacer = __webpack_require__(38466);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Layout/Grid/Grid.mjs + 1 modules
var Grid = __webpack_require__(40697);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Layout/Grid/GridColumn/GridColumn.mjs + 1 modules
var GridColumn = __webpack_require__(57237);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Layout/Flex/Flex.mjs + 2 modules
var Flex = __webpack_require__(54112);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Foundations/Typography/Typography.mjs + 2 modules
var Typography = __webpack_require__(72905);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/utils/helpers.mjs
var helpers = __webpack_require__(37892);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Buttons/Button/Button.mjs + 2 modules
var Button = __webpack_require__(58510);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Layout/AspectRatioKeeper/AspectRatioKeeper.mjs + 2 modules
var AspectRatioKeeper = __webpack_require__(66737);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/DataDisplay/Image/Image.mjs + 2 modules
var Image_Image = __webpack_require__(28879);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Buttons/Link/Link.mjs + 2 modules
var Link = __webpack_require__(3171);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/MultiColumnContent/TwoUpContent/subcomponents/ContentCard/ContentCard.module.css.mjs
var classes = {
    "contentCard": "_0eu4F",
    "contentCardFigure": "cdz-Z",
    "contentCardTitle": "OYi-t",
    "contentCardDescription": "iau9k",
    "contentCardLink": "ALFoY"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/MultiColumnContent/TwoUpContent/subcomponents/ContentCard/ContentCard.mjs



const ContentCard = (param)=>{
    let { aspectRatio , image , title , description , CTA , isPortrait =false  } = param;
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement("div", {
        className: classes.contentCard
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(AspectRatioKeeper/* AspectRatioKeeper */.y, {
        aspectRatio,
        className: classes.contentCardFigure
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Image_Image/* Image */.E, {
        ...image,
        position: "absolute",
        inset: "0"
    })), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        component: title.component || "h3",
        size: "h5",
        className: classes.contentCardTitle
    }, title.text), !isPortrait && description && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        component: /*#__PURE__*/ (0,react.isValidElement)(description.text) ? "div" : description.component || "p",
        size: "paragraph-medium",
        className: classes.contentCardDescription
    }, description.text), !isPortrait && CTA && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Link/* Link */.r, {
        size: "medium",
        className: classes.contentCardLink,
        ...(0,helpers/* omitText */.rW)(CTA)
    }, CTA.text));
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/MultiColumnContent/TwoUpContent/TwoUpContent.module.css.mjs
var TwoUpContent_module_css_classes = {
    "twoUpContentWrapper": "Dxtl2",
    "twoUpContentHeaderContainer": "_75dML",
    "twoUpContentHeaderContentContainer": "BxGxe",
    "twoUpContentEyebrow": "_2FmbC",
    "twoUpContentHeader": "nRB9Q",
    "twoUpContentDescription": "Am2YV",
    "twoUpContentButtonContainer": "a0iMq",
    "twoUpContentButtonBottomContainer": "oGhsw",
    "twoUpContentCardsContainer": "JbJix",
    "twoUpContentCardsContainerLandscape": "dA-TT",
    "twoUpContentCardsContainer50": "_8W5y-",
    "twoUpContentCardsContainer40": "-icHa",
    "twoUpContentCardsContainer60": "yyOjg"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/MultiColumnContent/TwoUpContent/TwoUpContent.utils.mjs

const imagesAspectRatio = {
    "50-50": {
        landscape: [
            "4:3",
            "4:3"
        ],
        portrait: [
            "3:4",
            "3:4"
        ]
    },
    "60-40": {
        landscape: [
            "4:3",
            "1:1"
        ],
        portrait: [
            "4:3",
            "1:1"
        ]
    },
    "40-60": {
        landscape: [
            "1:1",
            "4:3"
        ],
        portrait: [
            "1:1",
            "4:3"
        ]
    }
};
const twoUpContentCardsWrapperClassName = {
    "50-50": TwoUpContent_module_css_classes.twoUpContentCardsContainer50,
    "60-40": TwoUpContent_module_css_classes.twoUpContentCardsContainer60,
    "40-60": TwoUpContent_module_css_classes.twoUpContentCardsContainer40
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/MultiColumnContent/TwoUpContent/TwoUpContent.mjs






const TwoUpContent = (0,factory_utils/* polymorphicFactory */.bq)((props, ref)=>{
    const { component ="div" , CTA , type ="50-50" , imageOrientation ="landscape" , eyebrow , description , heading , mod , cards , topSpacer , bottomSpacer , className , ...rest } = props;
    const aspectRatio = imagesAspectRatio[type][imageOrientation];
    const isLandscape5050 = imageOrientation === "landscape" && type === "50-50";
    const isPortrait = imageOrientation === "portrait";
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        mod,
        ...rest,
        className: (0,clsx/* default */.Z)("kohler-two-up-content-root", TwoUpContent_module_css_classes.twoUpContentWrapper, className),
        component,
        ...rest,
        ref
    }, topSpacer && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Spacer/* Spacer */.L, {
        ...topSpacer
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Grid/* Grid */.r, {
        className: "center-grid"
    }, isLandscape5050 && (eyebrow || heading || description || CTA) && /* @__PURE__ */ /*#__PURE__*/ react.createElement(GridColumn/* GridColumn */.C, {
        className: TwoUpContent_module_css_classes.twoUpContentHeaderContainer
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        className: TwoUpContent_module_css_classes.twoUpContentHeaderContentContainer
    }, eyebrow && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        className: TwoUpContent_module_css_classes.twoUpContentEyebrow,
        component: /*#__PURE__*/ (0,react.isValidElement)(eyebrow.text) ? "div" : eyebrow.component || "p",
        size: "label-medium-m",
        ...(0,helpers/* omitText */.rW)(eyebrow)
    }, eyebrow.text), heading && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        className: TwoUpContent_module_css_classes.twoUpContentHeader,
        component: heading.component || "h3",
        size: "h2",
        ...(0,helpers/* omitText */.rW)(heading)
    }, heading.text), description && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        className: TwoUpContent_module_css_classes.twoUpContentDescription,
        component: /*#__PURE__*/ (0,react.isValidElement)(description.text) ? "div" : description.component || "p",
        size: "paragraph-large",
        ...(0,helpers/* omitText */.rW)(description)
    }, description.text)), CTA && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        className: TwoUpContent_module_css_classes.twoUpContentButtonContainer
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Button/* Button */.z, {
        component: "a",
        ...(0,helpers/* omitText */.rW)(CTA),
        variant: "secondary",
        size: "large"
    }, CTA.text))), /* @__PURE__ */ /*#__PURE__*/ react.createElement(GridColumn/* GridColumn */.C, {
        className: (0,clsx/* default */.Z)(twoUpContentCardsWrapperClassName[type], TwoUpContent_module_css_classes.twoUpContentCardsContainer, isLandscape5050 && TwoUpContent_module_css_classes.twoUpContentCardsContainerLandscape)
    }, cards && cards.slice(0, 2).map((card, index)=>{
        var ref;
        /* @__PURE__ */ /*#__PURE__*/ return react.createElement(ContentCard, {
            key: ((ref = card.title) === null || ref === void 0 ? void 0 : ref.text) || index,
            ...card,
            aspectRatio: aspectRatio[index],
            isPortrait
        });
    })), isLandscape5050 && CTA && /* @__PURE__ */ /*#__PURE__*/ react.createElement(GridColumn/* GridColumn */.C, {
        className: TwoUpContent_module_css_classes.twoUpContentButtonBottomContainer
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Button/* Button */.z, {
        component: "a",
        ...(0,helpers/* omitText */.rW)(CTA),
        fullWidth: true,
        variant: "secondary",
        size: "large"
    }, CTA.text))), bottomSpacer && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Spacer/* Spacer */.L, {
        ...bottomSpacer
    }));
});


// EXTERNAL MODULE: ./components/Shared/HeaderNavTabs/utils.js
var HeaderNavTabs_utils = __webpack_require__(68446);
// EXTERNAL MODULE: ./utils/helper.js + 1 modules
var helper = __webpack_require__(55760);
;// CONCATENATED MODULE: ./components/DesignSystem/utils/teaserHelper.js
// Utilities for extracting and normalizing teaser data for DS mapping


/**
 * Strips HTML tags from a string.
 *
 * @param {string} html - The HTML string to strip.
 * @return {string} The plain text with HTML tags removed.
 */ function stripHtml(html) {
    if (!html) return "";
    return html.replace(/<[^>]+>/g, "").trim();
}
/**
 * Determines if an item is a teaser.
 *
 * Supports both `slingResourceType` and `:type` properties.
 *
 * @param {Object} item - The item to check.
 * @return {boolean} True if the item is a teaser, false otherwise.
 */ function isTeaser(item) {
    var ref;
    // Ensure a boolean is always returned
    return !!((item === null || item === void 0 ? void 0 : item.slingResourceType) === "teaser" || (item === null || item === void 0 ? void 0 : (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes("teaser")));
}
/**
 * Extracts and normalizes teaser data for Design System consumption.
 *
 * @param {Object} teaser - The teaser object to extract data from.
 * @param {string} [teaser.mainTitle] - The main title of the teaser.
 * @param {string} [teaser.title] - The title of the teaser.
 * @param {string} [teaser.description] - The description of the teaser.
 * @param {string} [teaser.fileReference] - The image file reference.
 * @param {Object} [teaser.imageResource] - The image resource object.
 * @param {string} [teaser.imageResource.fileReference] - The image file reference from imageResource.
 * @param {string} [teaser.imageResource.alt] - The alt text for the image.
 * @param {Array} [teaser.actions] - The array of CTA actions.
 * @param {string} [teaser.linkCTA] - The CTA link.
 * @param {string} [teaser.linkURL] - The fallback link URL.
 * @return {Object} The normalized teaser data:
 *
 */ function extractTeaserData(teaser) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    const imageUrl = teaser.fileReference || ((ref = teaser.imageResource) === null || ref === void 0 ? void 0 : ref.fileReference) || "";
    const imageserverurl = (teaser === null || teaser === void 0 ? void 0 : (ref1 = teaser.imageResource) === null || ref1 === void 0 ? void 0 : ref1.imageServerUrl) || "";
    const imageID = (teaser === null || teaser === void 0 ? void 0 : (ref2 = teaser.imageResource) === null || ref2 === void 0 ? void 0 : ref2.assetID) || "";
    // Get CTA link
    let linkUrl = "";
    if (Array.isArray(teaser.actions) && teaser.actions.length > 0) {
        const action = teaser.actions.find((a)=>a.url || a.link);
        if (action) linkUrl = action.url || action.link;
    }
    if (!linkUrl) linkUrl = teaser.linkCTA || teaser.linkURL || "";
    return {
        title: stripHtml(teaser.title || teaser.mainTitle || ""),
        description: stripHtml(teaser.description || ""),
        imageUrl,
        linkUrl,
        alt: ((ref3 = teaser.imageResource) === null || ref3 === void 0 ? void 0 : ref3.alt) || "",
        ctaLabel: ((ref4 = teaser.actions) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[0]) === null || ref5 === void 0 ? void 0 : ref5.title) || ((ref6 = teaser.actions) === null || ref6 === void 0 ? void 0 : (ref7 = ref6[0]) === null || ref7 === void 0 ? void 0 : ref7.text) || "",
        tryimageUrl: "".concat(imageserverurl).concat(imageID)
    };
}
/**
 * Maps an array of card data to the required card object structure for rendering.
 *
 * @param {Array<Object>} cards - The array of card data objects (from extractTeaserData).
 * @param {string} [pageType=""] - The page type string, used for tracking attributes in analytics.
 * @return {Array<Object>} The mapped array of card objects, each containing image, CTA, title, and description.
 */ function mapCards(cards) {
    let pageType = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    return cards.slice(0, 2).map((card)=>{
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
        const base = {
            image: {
                src: "".concat(card.tryimageUrl),
                alt: card === null || card === void 0 ? void 0 : card.alt,
                "data-mode": "smartcrop"
            },
            CTA: {
                text: (0,helper/* sanitizeInnerHtml */.KD0)(card === null || card === void 0 ? void 0 : card.ctaLabel),
                href: (0,HeaderNavTabs_utils/* modifyHref */.L9)(card === null || card === void 0 ? void 0 : card.linkUrl),
                trackingAttributes: {
                    "data-datalayer-id": "kds-element-navigation",
                    "data-datalayer-data": JSON.stringify({
                        clickInternalLinks: "true",
                        eventAction: "".concat(pageType, ":").concat((ref = (0,helper/* sanitizeInnerHtml */.KD0)(card === null || card === void 0 ? void 0 : card.title)) === null || ref === void 0 ? void 0 : ref.toLowerCase(), ":").concat((ref1 = (0,helper/* sanitizeInnerHtml */.KD0)(card === null || card === void 0 ? void 0 : card.ctaLabel)) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase()),
                        eventName: "".concat(pageType, ":").concat((ref2 = (0,helper/* sanitizeInnerHtml */.KD0)(card === null || card === void 0 ? void 0 : card.title)) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase(), ":").concat((ref3 = (0,helper/* sanitizeInnerHtml */.KD0)(card === null || card === void 0 ? void 0 : card.ctaLabel)) === null || ref3 === void 0 ? void 0 : ref3.toLowerCase()),
                        eventType: "navigation",
                        internalLinkName: (ref4 = (0,helper/* sanitizeInnerHtml */.KD0)(card === null || card === void 0 ? void 0 : card.ctaLabel)) === null || ref4 === void 0 ? void 0 : ref4.toLowerCase(),
                        internalLinkPosition: "".concat(pageType, ":teaser"),
                        internalLinkType: "".concat(pageType, ":").concat((ref5 = (0,helper/* sanitizeInnerHtml */.KD0)(card === null || card === void 0 ? void 0 : card.title)) === null || ref5 === void 0 ? void 0 : ref5.toLowerCase()),
                        internalLinkURL: (card === null || card === void 0 ? void 0 : card.linkUrl) && "object" !== "undefined" ? "".concat(window.location.origin).concat(card === null || card === void 0 ? void 0 : (ref6 = card.linkUrl) === null || ref6 === void 0 ? void 0 : ref6.split("/content/kohler/us").join("").replace(".html", "")) : "n/a",
                        internalLinkZoneName: "".concat(pageType, ":").concat((ref7 = (0,helper/* sanitizeInnerHtml */.KD0)(card === null || card === void 0 ? void 0 : card.title)) === null || ref7 === void 0 ? void 0 : ref7.toLowerCase())
                    })
                }
            },
            title: {
                text: (0,helper/* sanitizeInnerHtml */.KD0)(card === null || card === void 0 ? void 0 : card.title),
                component: "h3"
            },
            description: {
                text: (0,helper/* sanitizeInnerHtml */.KD0)(card === null || card === void 0 ? void 0 : card.description)
            }
        };
        return base;
    });
}

;// CONCATENATED MODULE: ./components/DesignSystem/mappers/twoUpContentMapper.js




/**
 * Maps two-up content container and its teaser children to props for the component.
 *
 * @param {Object} container - The container object, possibly with style/class info.
 * @param {Array} children - The child components, expected to include teasers.
 * @return {Object} Mapped props including heading, description, cards, and background.
 */ function mapTwoUpContentProps(container, children) {
    var ref, ref1, ref2, ref3, ref4, ref5;
    // Defensive: filter only valid teasers
    const teasers = children.filter(isTeaser);
    // Explicitly identify main and card teasers
    const mainTeaser = teasers.length > 0 ? teasers[0] : {};
    const potentialCardTeasers = teasers.slice(1);
    if (teasers.length < 3) {
        // Correctly include the count in the warning
        console.warn("[TwoUpContent Mapper] Expected at least 3 teasers (1 main + 2 cards), got ".concat(teasers.length, ". Container:"), container.containerId || container);
    }
    // Take the first two potential cards
    const cardTeasers = potentialCardTeasers.slice(0, 2);
    // If less than 2 card teasers found, fill with empty objects
    while(cardTeasers.length < 2)cardTeasers.push({});
    // Map data using the identified teasers
    const mainTeaserData = extractTeaserData(mainTeaser);
    const { ctaLabel ="" , description ="" , linkUrl ="" , title =""  } = mainTeaserData;
    const cards = cardTeasers.map(extractTeaserData);
    // Optionally, map container-level styles
    const colors = container.appliedCssClassNames ? container.appliedCssClassNames.match(/\bbg-([a-z]+)\b/) : null;
    const background = colors ? colors[1] : null;
    const pageType = (mainTeaser === null || mainTeaser === void 0 ? void 0 : mainTeaser.pageType) || "";
    const cardsArray = mapCards(cards, pageType, constants.authorBaseUrl);
    return {
        mod: background,
        type: "50-50",
        imageOrientation: "landscape",
        heading: {
            text: title
        },
        description: {
            text: description
        },
        CTA: {
            href: (0,HeaderNavTabs_utils/* modifyHref */.L9)(linkUrl),
            text: ctaLabel,
            trackingAttributes: {
                "data-datalayer-id": "kds-element-navigation",
                "data-datalayer-data": JSON.stringify({
                    clickInternalLinks: "true",
                    eventAction: "".concat(pageType, ":").concat((0,helper/* sanitizeInnerHtml */.KD0)(title).toLowerCase(), ":").concat((ref = (0,helper/* sanitizeInnerHtml */.KD0)(ctaLabel)) === null || ref === void 0 ? void 0 : ref.toLowerCase()),
                    eventName: "".concat(pageType, ":").concat((ref1 = (0,helper/* sanitizeInnerHtml */.KD0)(title)) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase(), ":").concat((ref2 = (0,helper/* sanitizeInnerHtml */.KD0)(ctaLabel)) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase()),
                    eventType: "navigation",
                    internalLinkName: (ref3 = (0,helper/* sanitizeInnerHtml */.KD0)(ctaLabel)) === null || ref3 === void 0 ? void 0 : ref3.toLowerCase(),
                    internalLinkPosition: "".concat(pageType, ":teaser"),
                    internalLinkType: "".concat(pageType, ":").concat((ref4 = (0,helper/* sanitizeInnerHtml */.KD0)(title)) === null || ref4 === void 0 ? void 0 : ref4.toLowerCase()),
                    internalLinkURL: linkUrl && "object" !== "undefined" ? "".concat(window.location.origin).concat(linkUrl === null || linkUrl === void 0 ? void 0 : linkUrl.split("/content/kohler/us").join("").replace(".html", "")) : "n/a",
                    internalLinkZoneName: "".concat(pageType, ":").concat((ref5 = (0,helper/* sanitizeInnerHtml */.KD0)(title)) === null || ref5 === void 0 ? void 0 : ref5.toLowerCase())
                })
            }
        },
        cards: cardsArray
    };
}

;// CONCATENATED MODULE: ./components/DesignSystem/registry.js
 // TODO: Replace with actual DS import

/**
 * Design System Component Registry
 *
 * Maps dsComponentType strings to their corresponding React components and
 * prop mappers. Used by getDSComponentForContainer to dynamically render
 * design system containers.
 *
 * @type {Object.<string, {component: React.ComponentType, mapper: Function}>}
 *
 */ const dsComponentRegistry = {
    twoUpContent: {
        component: TwoUpContent,
        mapper: mapTwoUpContentProps
    }
};

;// CONCATENATED MODULE: ./components/DesignSystem/utils/getDSComponentForContainer.js


/**
 * Returns a React component for a given design system container.
 *
 * Looks up the container's dsComponentType in the registry, maps its children and props,
 * and returns the corresponding React element.
 *
 * @param {Object} container - The container object, expected to have dsComponentType, :itemsOrder, and :items.
 * @return {React.ReactElement|null} The mapped React component, or null if not found or not mappable.
 */ function getDSComponentForContainer(container) {
    var ref;
    if (!(container === null || container === void 0 ? void 0 : container.dsComponentType)) return null;
    const mapping = dsComponentRegistry[container.dsComponentType];
    if (!mapping) return null;
    const { component: DSComponent , mapper  } = mapping;
    // Return null if mapper is missing or not a function
    if (typeof mapper !== "function") return null;
    const children = ((ref = container[":itemsOrder"]) === null || ref === void 0 ? void 0 : ref.map((key)=>container[":items"][key]).filter(Boolean)) || [];
    const props = mapper(container, children);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DSComponent, {
        ...props
    });
}

;// CONCATENATED MODULE: ./components/AemGridColumn.jsx








const AemGridColumn = (props)=>{
    const { data , itemKey , count , eventHandler , containerId , ...extraProps } = props;
    const Element = modules/* default.Element */.ZP.Element;
    const scrollElementCondition = (item, key)=>{
        return (data === null || data === void 0 ? void 0 : data.columnClassNames) && (data === null || data === void 0 ? void 0 : data.columnClassNames[key]) && !(0,utils/* isTeaser */.j$)(item) && !(0,utils/* isBreadcrumb */.Z3)(item) && !(0,utils/* isCarousel */.C2)(item) && !(0,utils/* isAemForm */.np)(item) && !(0,utils/* isProductAccordion */.eq)(item) && !(0,utils/* isVideo */.Wv)(item) && !(0,utils/* isImage */.Or)(item) && !(0,utils/* isInPageSearch */.L8)(item) && !(0,utils/* isText */.Gs)(item) && !(0,utils/* isShopTheRoomCard */.ck)(item) && !(0,utils/* isProductcardV3 */.DN)(item);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: data[":itemsOrder"] && data[":itemsOrder"].map((key, index)=>{
            const item = data[":items"][key];
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                children: getDSComponentForContainer(item) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components_AemGrid, {
                    fullData: data[":items"] && data[":items"],
                    data: item,
                    itemKey: key ? key : itemKey,
                    count: count + 1,
                    containerId: (item === null || item === void 0 ? void 0 : item.containerId) || containerId,
                    eventHandler: eventHandler,
                    ...extraProps
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(utils/* ConditionalWrapper */.M2, {
                    condition: scrollElementCondition(item, key),
                    wrapper: (children)=>{
                        var ref;
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(Element, {
                            className: "".concat((0,utils/* isImageV3 */.EE)(item) ? "image-v3 image" : "").concat((0,utils/* isContainer */.Nm)(item) ? constants.staticClasses.CONTAINER : "").concat((item === null || item === void 0 ? void 0 : item.appliedCssClassNames) && ((0,utils/* isContainer */.Nm)(item) || (0,utils/* isTab */.wR)(item)) ? " ".concat(item === null || item === void 0 ? void 0 : item.appliedCssClassNames) : "").concat((item === null || item === void 0 ? void 0 : item.appliedCssClassNamesCustom) ? " ".concat(item === null || item === void 0 ? void 0 : item.appliedCssClassNamesCustom) : "").concat((0,utils/* isSlick */.bd)(item) ? "carousel-slick carousel ".concat((ref = item["carouselComponentProperties"]) === null || ref === void 0 ? void 0 : ref.appliedCssClassNames, " ") : "").concat((data === null || data === void 0 ? void 0 : data.columnClassNames[key]) ? !(0,utils/* isSlick */.bd)(item) ? " ".concat(data === null || data === void 0 ? void 0 : data.columnClassNames[key], " ") : "" : "").concat((0,utils/* isSpacer */.MW)(item) ? "spacer separator" : "", " ").concat((0,utils/* isTab */.wR)(item) ? "tabs" : ""),
                            children: children
                        });
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(utils/* ConditionalWrapper */.M2, {
                        condition: (0,utils/* isContainer */.Nm)(item) && key !== constants.COMPONENT_TYPES.ROOT_CONTAINER,
                        wrapper: (children)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Shared_ContainerComponent, {
                                item: item,
                                extraProps: extraProps,
                                count: count,
                                children: children
                            }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_AemGrid, {
                            fullData: data[":items"] && data[":items"],
                            data: item,
                            itemKey: key ? key : itemKey,
                            count: count + 1,
                            containerId: (item === null || item === void 0 ? void 0 : item.containerId) || containerId,
                            eventHandler: eventHandler,
                            ...extraProps
                        })
                    })
                })
            }, item.id ? item.id : index);
        })
    });
};
/* harmony default export */ var components_AemGridColumn = (AemGridColumn);

;// CONCATENATED MODULE: ./components/Shared/BrandSwitcher/analytics.js


const addDataLayerOnClick = function() {
    let datalayerPageName = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", item = arguments.length > 1 ? arguments[1] : void 0;
    var ref;
    const eventInfo = {
        clickInternalLinks: "".concat(item.linkToNewTab || constants.BRAND_NAME.annSacks || constants.BRAND_NAME.sterling || constants.BRAND_NAME.homeEnergy ? "false" : "true"),
        internalLinkPosition: "global header",
        internalLinkZoneName: "".concat(datalayerPageName).concat(datalayerPageName ? ":" : "", "global header"),
        internalLinkURL: "".concat((ref = item.link) === null || ref === void 0 ? void 0 : ref.split("/content/kohler/us").join("").replace(".html", "")),
        internalLinkName: "brand sync:".concat(item.brandName.toLowerCase()),
        eventName: "brand sync",
        internalLinkType: "global header:navigation",
        eventType: "click",
        eventAction: "brand sync"
    };
    (0,helper/* pushAnalyticsObjToDataLayer */.zYT)(eventInfo);
};

;// CONCATENATED MODULE: ./components/Shared/BrandSwitcher/index.jsx



const BrandSwitcher = (props)=>{
    const { data , datalayerPageName  } = props;
    const handleOnClick = (e, item)=>{
        var ref;
        addDataLayerOnClick(datalayerPageName, item);
        window.open((ref = item.link) === null || ref === void 0 ? void 0 : ref.split("/content/kohler/us").join("").replace(".html", ""), "".concat((0,helper/* convertStringToBoolean */.mUs)(item.linkToNewTab) ? "_blank" : "_self"), item.linkRef ? "noreferrer" : "");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "brand-switcher ".concat(datalayerPageName === "checkout" ? "checkout-brand" : ""),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "gbh-nav-panel",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                className: "gbh-nav navbar navbar-xpand-sm navbar-dark justify-content-between",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    className: "gbh-nav__list navbar-nav",
                    children: data.items.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "gbh-nav__item",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: "gbh-data-layer gbh-nav--link ".concat(item.highlight && item.highlight === "true" ? "gbh-nav__link--active" : ""),
                                "aria-label": "".concat(item.brandName, ". Go to ").concat(item.brandName, "'s Home Page"),
                                onClick: (e)=>handleOnClick(e, item),
                                role: "link",
                                children: item.brandName
                            })
                        }, "brand-".concat(index)))
                })
            })
        })
    });
};
/* harmony default export */ var Shared_BrandSwitcher = (BrandSwitcher);

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 16 modules
var esm = __webpack_require__(24400);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./constants/config.js
var constants_config = __webpack_require__(19514);
// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(85518);
// EXTERNAL MODULE: ./utils/location.js
var utils_location = __webpack_require__(97433);
// EXTERNAL MODULE: ./store/features/locationSlice.js
var locationSlice = __webpack_require__(56608);
// EXTERNAL MODULE: ./components/core/Checkbox/Checkbox.jsx + 1 modules
var Checkbox = __webpack_require__(65764);
// EXTERNAL MODULE: ./public/icons/close-white.svg
var close_white = __webpack_require__(26693);
;// CONCATENATED MODULE: ./public/icons/left-arrow-white.svg
/* harmony default export */ var left_arrow_white = ({"src":"/_next/static/media/left-arrow-white.9ff895f4.svg","height":17,"width":10});
// EXTERNAL MODULE: ./components/FindStoreUtilNav/v1/index.module.scss
var index_module = __webpack_require__(4201);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./components/core/Modal/ZipCodeInfoModal.jsx
var ZipCodeInfoModal = __webpack_require__(96352);
// EXTERNAL MODULE: ./components/core/AutoSuggestion/v1/AutoSuggestion.jsx
var AutoSuggestion = __webpack_require__(36130);
// EXTERNAL MODULE: ./components/FindStoreUtilNav/analytics.js
var analytics = __webpack_require__(90062);
// EXTERNAL MODULE: ./components/FindStore/v1/api.js
var api = __webpack_require__(2182);
;// CONCATENATED MODULE: ./components/FindStoreUtilNav/v1/FindStoreUtilNav.view.jsx






















const configInitialState = {
    browseAllStoreUrl: "",
    brand: "",
    findStores: ""
};
const FindStoreUtilNavView = (props)=>{
    var ref;
    const { findAStoreActive  } = (0,es/* useSelector */.v9)(locationSlice/* locationState */._n);
    const [zipCodeValue, setZipcodeValue] = (0,react.useState)("");
    const [isSubmit, setIsSubmit] = (0,react.useState)(false);
    const [zipCodeError, setZipCodeError] = (0,react.useState)({
        show: false,
        message: ""
    });
    const [configState, setConfigState] = (0,react.useState)(configInitialState);
    const [browseAllStoreUrl, setbrowseAllStoreUrl] = (0,react.useState)("");
    const [myStoreUrl, setMyStoreUrl] = (0,react.useState)("/");
    const [optionList, setOptionList] = (0,react.useState)([]);
    const { utilityStoreDetails , utilityData , myStoreId , eventHandler: { callbacks: { toggleFindAStore =()=>{} , closeMenu =()=>{}  }  }  } = props;
    const [infoModalErrror, setInfoModalErrror] = (0,react.useState)({});
    const [infoModal, setInfoModal] = (0,react.useState)();
    const dispatch = (0,es/* useDispatch */.I0)();
    (0,react.useEffect)(()=>{
        (0,constants_config/* getConfig */.i)().then(async (config)=>{
            const { general  } = config;
            var _allStoresPagePath;
            const url = await (0,utils_location/* getShortenedUrl */.Pp)((_allStoresPagePath = general.allStoresPagePath) !== null && _allStoresPagePath !== void 0 ? _allStoresPagePath : "/");
            const findStores = get_default()(config, "apiEndpoints.findStores", "");
            const brand = get_default()(config, "general.siteName", "");
            setConfigState({
                browseAllStoreUrl: url,
                findStores,
                brand
            });
            localStorage.getItem("currentZipCode") && setZipcodeValue(localStorage.getItem("currentZipCode"));
            setbrowseAllStoreUrl(url);
        }).catch((err)=>console.log(err));
        props.getUtilityGeolocation();
    }, []);
    (0,react.useEffect)(()=>{
        (props === null || props === void 0 ? void 0 : props.active) ? (0,helper/* removeMavenoidChat */.N9B)() : (0,helper/* addMavenoidChat */.dVG)();
    }, [
        props === null || props === void 0 ? void 0 : props.active
    ]);
    (0,react.useEffect)(()=>{
        var ref;
        (ref = window.wow) === null || ref === void 0 ? void 0 : ref.sync();
        if (isSubmit === true) {
            props.redirect(zipCodeValue);
        }
    }, [
        isSubmit
    ]);
    (0,react.useEffect)(()=>{
        if (zipCodeValue.length > 2) {
            fetchListOfCities();
        }
    }, [
        zipCodeValue
    ]);
    (0,react.useEffect)(()=>{
        if (myStoreId === 0) {
            nearestStoreAddress();
        } else {
            dispatch((0,locationSlice/* setStoreAddress */.wf)(utilityData));
        }
    }, [
        zipCodeValue,
        myStoreId
    ]);
    const nearestStoreAddress = async ()=>{
        const { findStores , brand  } = configState;
        const nearestStore = await (0,api/* getFindAStoresResult */.R)(findStores, zipCodeValue, brand, 100, 1, "kohler store", 1);
        if (nearestStore !== undefined) {
            var ref;
            var ref1;
            const nearestStoreData = (ref1 = nearestStore === null || nearestStore === void 0 ? void 0 : (ref = nearestStore.data) === null || ref === void 0 ? void 0 : ref.info[0]) !== null && ref1 !== void 0 ? ref1 : {};
            var ref2;
            const utilityData = {
                ...nearestStoreData,
                EntityID: (ref2 = nearestStoreData === null || nearestStoreData === void 0 ? void 0 : nearestStoreData.BPnumber) !== null && ref2 !== void 0 ? ref2 : null
            };
            dispatch((0,locationSlice/* setStoreAddress */.wf)(utilityData));
        } else {
            const utilityData1 = {};
            dispatch((0,locationSlice/* setStoreAddress */.wf)(utilityData1));
        }
    };
    const fetchListOfCities = async ()=>{
        const { findStores , brand  } = configState;
        const responseData = await (0,helper/* getCityList */.vzx)(findStores, brand, zipCodeValue);
        const { data: { d: { results =[]  } = {}  } = {}  } = responseData;
        const cities = results.map((city)=>city.Locality);
        setOptionList([
            ...new Set(cities)
        ]);
    };
    (0,react.useEffect)(()=>{
        if (!isEmpty_default()(utilityStoreDetails) && (utilityData === null || utilityData === void 0 ? void 0 : utilityData.BPnumber)) {
            (0,utils_location/* getShortenedUrl */.Pp)(utilityStoreDetails[utilityData.BPnumber]).then((myStoreUrl)=>{
                setMyStoreUrl(myStoreUrl);
            });
        }
    }, [
        utilityStoreDetails,
        utilityData
    ]);
    const handleChange = (value)=>{
        setZipcodeValue(value);
    };
    const getGeoLocation = ()=>{
        (0,helper/* getMyLocation */.fPm)().then((getLocation)=>{
            var _zipcode;
            setZipcodeValue((_zipcode = getLocation.zipcode) !== null && _zipcode !== void 0 ? _zipcode : "");
            (0,analytics/* headerFindStoreUseLocationAnalytics */.Pj)({
                eventStatus: "success"
            });
        }).catch((param)=>{
            let { cause  } = param;
            setInfoModalErrror(cause !== null && cause !== void 0 ? cause : {});
            setInfoModal(true);
            var ref;
            (0,analytics/* headerFindStoreUseLocationAnalytics */.Pj)({
                errorMessage: (ref = cause === null || cause === void 0 ? void 0 : cause.message) !== null && ref !== void 0 ? ref : "",
                staticTexts,
                eventStatus: "failure"
            });
        });
    };
    const onSubmit = async ()=>{
        let valid = true;
        const zipCodeErrObj = {
            show: false,
            message: ""
        };
        const { staticTexts: { validZipcode  }  } = props;
        const isValid = await (0,utils_location/* validateField */.OP)("zipCodeNumeric", zipCodeValue);
        if (isValid && zipCodeValue.length < 5) {
            dispatch((0,locationSlice/* setUtilityLocation */.NL)({
                utilityLocation: zipCodeValue
            }));
            zipCodeErrObj.show = true;
            zipCodeErrObj.message = validZipcode;
            valid = false;
        }
        if (valid) {
            setIsSubmit(true);
            toggleFindAStore();
            closeMenu();
        }
        if (findAStoreActive) {
            dispatch((0,locationSlice/* setFindAStoreActive */.I_)(false));
        }
        setZipCodeError({
            ...zipCodeErrObj
        });
        (0,analytics/* addFindStoreAnalytics */.cY)(zipCodeValue, zipCodeErrObj);
    };
    const getStoreAnalytics = (action)=>{
        var ref;
        const href = utilityStoreDetails && utilityStoreDetails[utilityData === null || utilityData === void 0 ? void 0 : utilityData.BPnumber] ? utilityStoreDetails[utilityData === null || utilityData === void 0 ? void 0 : utilityData.BPnumber] : "/";
        const internalLinkName = action === "unset as my store" ? "unset as preferred store" : "store details";
        return JSON.stringify({
            eventAction: "find a store:utility nav​:" + action,
            eventName: "find a store:utility nav​:" + action,
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName,
            internalLinkPosition: "find a store",
            internalLinkType: "find a store:" + ((ref = (utilityData === null || utilityData === void 0 ? void 0 : utilityData.LocationName) + ", " + (utilityData === null || utilityData === void 0 ? void 0 : utilityData.AddressLine) + (!isEmpty_default()(utilityData === null || utilityData === void 0 ? void 0 : utilityData.AddressLine2) ? ", " + (utilityData === null || utilityData === void 0 ? void 0 : utilityData.AddressLine2) : "") + ", " + (0,helper/* formatPhoneNumber */.unW)(utilityData === null || utilityData === void 0 ? void 0 : utilityData.Phone)) === null || ref === void 0 ? void 0 : ref.toLowerCase()),
            internalLinkZoneName: "find a store:utility nav",
            internalLinkURL: action === "view store details" ? href.indexOf("http") === -1 ? window.location.origin + href : href : "n/a",
            clickInternalLinks: "true"
        });
    };
    const viewStoreAnalytics = getStoreAnalytics("view store details");
    const unsetMyStoreAnalytics = getStoreAnalytics("unset as my store");
    const { staticTexts  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (index_module_default()).findAStoreUtilNavWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "gbh-find-a-store ".concat(props.active ? "active" : ""),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "findstore-util-nav".concat(isSubmit ? "__activeMap" : ""),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ZipCodeInfoModal/* default */.Z, {
                        handleModalClose: ()=>{
                            setInfoModal(false);
                        },
                        show: infoModal,
                        data: infoModalErrror,
                        labelledBy: "Geo-Location-error-message",
                        className: "message-modal",
                        staticTexts: staticTexts,
                        dataLayerPosition: "global header"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "findstore-util-nav__container findstore-util-nav__show-container",
                            children: [
                                lib/* isMobile */.tq && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "findstore-util-nav__mobile-container",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            role: "button",
                                            tabIndex: "0",
                                            src: close_white/* default.src */.Z.src,
                                            alt: staticTexts.close,
                                            className: "findstore-util-nav__close",
                                            onClick: ()=>{
                                                (0,helper/* addMavenoidChat */.dVG)();
                                                toggleFindAStore(), closeMenu(), (0,helper/* toggeleBodyScroll */.wA4)(false);
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "findstore-util-nav__menu",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: left_arrow_white.src,
                                                    alt: staticTexts.leftArrow
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    role: "button",
                                                    onClick: ()=>toggleFindAStore(),
                                                    children: staticTexts.menu
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "findstore-util-nav__content ".concat(!isEmpty_default()(utilityData) && "findstore-util-nav__content-text"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "container kf-react-container",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "row ml-0 mr-0",
                                            children: [
                                                !isEmpty_default()(utilityData && utilityData.EntityID) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "col-12 col-lg-7 findstore-util-nav__access-utility-container",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "row",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "col-12 col-lg-7 findstore-util-nav__supply-section",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: "findstore-util-nav__store",
                                                                        children: myStoreId !== 0 ? staticTexts.myStoreText : staticTexts.closestStore
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: "findstore-util-nav__signStore",
                                                                        children: utilityData.LocationName
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "col-12 col-lg-5 findstore-util-nav__address-container",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                        children: utilityData.OpenUntil
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                children: utilityData.AddressLine
                                                                            }),
                                                                            !isEmpty_default()(utilityData.AddressLine2) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                children: utilityData.AddressLine2
                                                                            }) : "",
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                children: utilityData.Locality + ", " + utilityData.AdminDistrict + " " + utilityData.PostalCode
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                        children: (0,helper/* formatPhoneNumber */.unW)(utilityData.Phone)
                                                                    }),
                                                                    myStoreUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                        href: myStoreUrl,
                                                                        className: "findstore-util-nav__view-store-detail gbh-data-layer",
                                                                        "data-gbh-data-layer": viewStoreAnalytics,
                                                                        onClick: ()=>{
                                                                            lib/* isMobile */.tq ? closeMenu() : "";
                                                                        },
                                                                        children: lib/* isMobile */.tq ? staticTexts.storeDetail : staticTexts.viewStoreDetail
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                                                        analyticsData: unsetMyStoreAnalytics,
                                                                        checked: myStoreId === utilityData.EntityID ? true : false,
                                                                        value: myStoreId === utilityData.EntityID ? staticTexts.myStore : staticTexts.setAsMyStore,
                                                                        id: "findstore-util-nav__my-store",
                                                                        onChange: (e)=>props.handleUtilityStoreCheck(e.target.checked ? utilityData.EntityID : 0)
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "col-12 col-lg-6 findstore-util-nav__search-utility-container",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "findstore-util-nav__location-content",
                                                            children: (0,helper/* sanitizeInnerHtml */.KD0)(staticTexts.locationDescription)
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "findstore-util-nav__zipcode-content",
                                                            children: (0,helper/* sanitizeInnerHtml */.KD0)(staticTexts.zipCodeContent)
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "col-12 findstore-util-nav__loc-search-container ".concat(!isEmpty_default()(utilityData) ? "col-lg-5" : "col-lg-6"),
                                                    children: [
                                                        !isEmpty_default()(utilityData) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "findstore-util-nav__not-your-store",
                                                            children: staticTexts.NotYourStore + "?"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: classnames_default()({
                                                                "findstore-util-nav__input-container": true,
                                                                "findstore-util-nav__input-container-text": !isEmpty_default()(utilityData),
                                                                "findstore-util-nav__input-disabled-state": !zipCodeValue
                                                            }),
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoSuggestion/* default */.Z, {
                                                                    placeholderLabel: staticTexts.enterCityStateZip,
                                                                    selectedValue: zipCodeValue,
                                                                    handleChange: (selectedVal)=>handleChange(selectedVal),
                                                                    handleSelect: (selectedVal)=>handleChange(selectedVal),
                                                                    optionList: optionList,
                                                                    borderValue: "bottom"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                    className: "findstore-util-nav__submit",
                                                                    onClick: ()=>onSubmit(),
                                                                    disabled: zipCodeValue.length < 3,
                                                                    "aria-label": staticTexts === null || staticTexts === void 0 ? void 0 : (ref = staticTexts.ariaLabel) === null || ref === void 0 ? void 0 : ref.submit,
                                                                    children: staticTexts.submit
                                                                })
                                                            ]
                                                        }),
                                                        zipCodeError.show && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "findstore-util-nav__zipcode-error",
                                                            children: zipCodeError.message
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "findstore-util-nav__link-container ".concat(!isEmpty_default()(utilityData) && "findstore-util-nav__link-container-text"),
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "findstore-util-nav__location-link-container",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: "findstore-util-nav__location-link",
                                                                        "aria-label": staticTexts.useLocation,
                                                                        role: "button",
                                                                        tabIndex: "0",
                                                                        onClick: getGeoLocation,
                                                                        children: staticTexts.useLocation
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "findstore-util-nav__view-link-container",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                        href: browseAllStoreUrl,
                                                                        className: "findstore-util-nav__view-store-link ".concat(lib/* isMobile */.tq ? "view-all-stores-mobile" : "", " gbh-data-layer"),
                                                                        onClick: ()=>{
                                                                            (0,analytics/* headerViewAllStoreAnalytics */.Zj)(browseAllStoreUrl);
                                                                        },
                                                                        onClickCapture: ()=>{
                                                                            toggleFindAStore();
                                                                            closeMenu();
                                                                        },
                                                                        children: staticTexts.viewAllStore
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};
FindStoreUtilNavView.defaultProps = {
    staticTexts: {}
};
FindStoreUtilNavView.propTypes = {
    staticTexts: (prop_types_default()).object
};
/* harmony default export */ var FindStoreUtilNav_view = (FindStoreUtilNavView);

// EXTERNAL MODULE: ./components/FindStoreUtilNav/v1/localization.js
var localization = __webpack_require__(26977);
;// CONCATENATED MODULE: ./components/FindStoreUtilNav/v1/FindStoreUtilNav.jsx













const FindStoreUtilNav = (param)=>{
    let { show , active , eventHandler , zipCodeContent  } = param;
    const dispatch = (0,es/* useDispatch */.I0)();
    const { utilityStoreDetails , utilityData , userCity , myStoreId  } = (0,es/* useSelector */.v9)(locationSlice/* locationState */._n);
    const initialState = {
        userCity: "",
        utilityLocation: "",
        utilityData: {},
        utilityStoreDetails: {},
        findStores: "",
        reverseGeo: "",
        myStoreId: typeof Window !== "undefined" ? localStorage.getItem("myStoreId") : 0,
        siteName: "",
        findStoreUrl: "",
        utilityStoreDetailsUrl: ""
    };
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const router = (0,next_router.useRouter)();
    const [staticTexts, setStaticTexts] = (0,react.useState)({});
    const [state, setState] = (0,react.useState)(initialState);
    (0,react.useEffect)(()=>{
        setStaticTexts((prevVal)=>{
            let translations = (0,localization/* getTranslations */.F)(t);
            if (zipCodeContent && zipCodeContent.length) {
                translations = {
                    ...translations,
                    zipCodeContent
                };
            }
            return translations;
        });
        setInitalState();
    }, []);
    // useEffect(() => {
    //   document.querySelector(
    //     ".gbh-nav__findStore a.gbh-nav__findStore--link"
    //   ).innerText = "staticTexts.findStore"
    // }, [userCity, staticTexts.findStore])
    (0,react.useEffect)(()=>{
        if (state.myStoreId !== 0) getUtilityDataById();
        else if (state.userCity !== "") getUtilityDataByDistance();
    }, [
        state.utilityLocation,
        state.userCity
    ]);
    (0,react.useEffect)(()=>{
        if (state.utilityStoreDetailsUrl !== "") setUtilityStoreDetailsUrl();
    }, [
        state.utilityStoreDetailsUrl
    ]);
    const setInitalState = async ()=>{
        const config = await (0,constants_config/* getConfig */.i)();
        getFindStoreUrl(config).then((url)=>{
            setState({
                ...state,
                findStores: get_default()(config, "apiEndpoints.findStores", ""),
                reverseGeo: get_default()(config, "apiEndpoints.reverseGeo", ""),
                siteName: get_default()(config, "general.siteName", ""),
                utilityStoreDetailsUrl: get_default()(config, "general.storeDetailsServletPath"),
                findStoreUrl: url
            });
        });
    };
    const getFindStoreUrl = async (config)=>{
        const findStoreUrl = await (0,utils_location/* getShortenedUrl */.Pp)(get_default()(config, "general.findStorePagePath", ""));
        return findStoreUrl;
    };
    const setUtilityStoreDetailsUrl = async ()=>{
        const utilityStoreDetails = await (0,utils_location/* getUtilityStoreDetails */.BO)(state);
        dispatch((0,locationSlice/* setUtilityStoreDetails */.Hm)(utilityStoreDetails));
        setState({
            ...state,
            utilityStoreDetails
        });
    };
    const getUtilityDataByDistance = async ()=>{
        const utilityData = await (0,utils_location/* getStoreDataByDistance */.zO)(state);
        dispatch((0,locationSlice/* setStoreAddress */.wf)(utilityData));
        setState({
            ...state,
            utilityData
        });
    };
    const getUtilityDataById = async ()=>{
        const utilityData = await (0,utils_location/* getStoreDataById */.e)(state);
        dispatch((0,locationSlice/* setStoreAddress */.wf)(utilityData));
        setState({
            ...state,
            utilityData
        });
    };
    const getUtilityGeolocation = function() {
        let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        (0,helper/* getMyLocation */.fPm)().then((getLocation)=>{
            const { zipcode: utilityLocation = "" , city: userCity = ""  } = getLocation;
            const details = {
                utilityLocation,
                userCity
            };
            if (utilityLocation && userCity) {
                dispatch((0,locationSlice/* setCityLocation */.OX)(details));
                setState({
                    ...state,
                    ...details
                });
            }
        }).catch((err)=>{
            (0,helper/* getMyLocationByUserIP */.SAL)().then((getLocation)=>{
                const { zipcode: utilityLocation = "" , city: userCity = ""  } = getLocation;
                const details = {
                    utilityLocation,
                    userCity
                };
                if (utilityLocation && userCity) {
                    dispatch((0,locationSlice/* setCityLocation */.OX)(details));
                    setState({
                        ...state,
                        ...details
                    });
                }
            }).catch((error)=>{
                console.log(error);
            });
        });
    };
    const handleUtilityStoreCheck = (entity)=>{
        localStorage.setItem("myStoreId", entity);
        dispatch((0,locationSlice/* setMyStore */.h9)(entity));
        setState({
            ...state,
            myStoreId: entity
        });
    };
    const redirect = (zipCodeValue)=>{
        const path = "".concat(state.findStoreUrl, "?q=").concat(zipCodeValue, "&queryAspath=").concat(state.findStoreUrl);
        const asPath = "".concat(state.findStoreUrl, "?q=").concat(zipCodeValue);
        router.push(path, asPath);
    };
    const { findStoreUrl  } = state;
    if (!show) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FindStoreUtilNav_view, {
        staticTexts: staticTexts,
        getUtilityGeolocation: getUtilityGeolocation,
        redirect: (zipCodeValue)=>redirect(zipCodeValue),
        redirectUrl: (0,utils_location/* getShortenedUrl */.Pp)(findStoreUrl),
        handleUtilityStoreCheck: (entity)=>handleUtilityStoreCheck(entity),
        active: active,
        utilityStoreDetails: utilityStoreDetails,
        utilityData: utilityData,
        userCity: userCity,
        myStoreId: myStoreId,
        eventHandler: eventHandler
    });
};
/* harmony default export */ var v1_FindStoreUtilNav = (FindStoreUtilNav);

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./store/features/authSlice.js
var authSlice = __webpack_require__(24899);
// EXTERNAL MODULE: ./hooks/useWindowDimensions.js
var useWindowDimensions = __webpack_require__(30394);
// EXTERNAL MODULE: ./components/Shared/HeaderNavTabs/analytics/index.js
var HeaderNavTabs_analytics = __webpack_require__(24897);
;// CONCATENATED MODULE: ./components/Default/AuthUtilityNav/v1/AuthUtilityNav.view/index.jsx










const MegaMenu = dynamic_default()(()=>__webpack_require__.e(/* import() */ 7437).then(__webpack_require__.bind(__webpack_require__, 67437)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(67437)
            ]
    },
    suspense: true
});
const AuthUtilityNavView = (props)=>{
    const avatarIcon = "/icons/avatar.svg";
    const rightArrow = "/icons/right-white.svg";
    const iconUserSignin = "/icons/user-signin.svg";
    const { active , i18n , userMenuFragment , guestMenuFragment , isLoggedIn , logout , toggleAuthNav , setAuthNav , onAuthMenuClick  } = props;
    const { user  } = (0,es/* useSelector */.v9)(authSlice/* selectAuthState */._9);
    const { winWidth  } = (0,useWindowDimensions/* default */.Z)();
    const styleClass = classnames_default()({
        "auth-nav": true,
        "auth-nav--active": active
    });
    const dispatch = (0,es/* useDispatch */.I0)();
    const onClickSignIn = ()=>{
        dispatch((0,authSlice/* setAuthModalVisibility */.LY)({
            show: true
        }));
        (0,HeaderNavTabs_analytics/* newdatalayerforSignIn */.UY)(themeChange);
    };
    const onClickSignUp = ()=>{
        dispatch((0,authSlice/* setAuthModalVisibility */.LY)({
            show: true,
            active: 1
        }));
        (0,HeaderNavTabs_analytics/* newdataLayerForCreateAccount */.Lz)(themeChange);
    };
    const showMenuNav = ()=>{
        toggleAuthNav();
    };
    const themeChange =  true && winWidth <= 1200 && (document.body.classList.contains("nav-light-theme") || document.body.classList.contains("nav-dark-theme"));
    const signInEventInfo = JSON.stringify({
        eventName: "sign in start",
        eventAction: "sign in start",
        internalLinkName: "sign in start",
        internalLinkType: "global header:navigation",
        internalLinkZoneName: "global header",
        clickInternalLinks: "true",
        eventType: "global header",
        internalLinkURL: "n/a",
        internalLinkPosition: "global header:sign in start",
        eventMsg: "n/a",
        eventStatus: "n/a"
    });
    const signedInEventInfo = JSON.stringify({
        eventName: "global header:your kohler account",
        eventAction: "global header:your kohler account",
        internalLinkName: "your kohler account",
        internalLinkType: "global header: welcome back to your kohler",
        internalLinkZoneName: "global header",
        clickInternalLinks: "true",
        eventType: "navigation",
        internalLinkURL: "n/a",
        internalLinkPosition: "global header:my account",
        eventMsg: "n/a",
        eventStatus: "n/a"
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: styleClass,
        "aria-expanded": active,
        children: [
            winWidth <= 1200 ? isLoggedIn ? /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    tabIndex: "0",
                    "aria-label": "".concat(i18n.hi, " ").concat((0,helper/* capitalizeFirstName */.MyB)(user === null || user === void 0 ? void 0 : user.firstName)),
                    role: "button",
                    className: "auth-nav__sign-in-mobile",
                    onClick: ()=>{
                        toggleAuthNav();
                        onAuthMenuClick(!active);
                        setAuthNav(!active);
                        (0,helper/* toggeleBodyClass */.wMR)(true);
                        (0,HeaderNavTabs_analytics/* onclickForSignedFun */.Jm)(themeChange);
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            name: "avatarIcon",
                            src: themeChange ? iconUserSignin : avatarIcon,
                            alt: i18n.signIn,
                            className: "gbh-data-layer auth-nav__sign-in-avatar",
                            "data-gbh-data-layer": signInEventInfo
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            name: "loggedInUser",
                            className: "auth-nav__user",
                            children: [
                                i18n.hi,
                                ", ",
                                (0,helper/* capitalizeFirstName */.MyB)(user === null || user === void 0 ? void 0 : user.firstName)
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: rightArrow,
                            alt: i18n.rightArrowAlt,
                            className: "auth-nav__sign-in-right-arrow"
                        })
                    ]
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
                fallback: "Loading...",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenu, {
                    userMenuFragment: userMenuFragment,
                    guestMenuFragment: guestMenuFragment,
                    isLoggedIn: isLoggedIn,
                    i18n: i18n,
                    user: user,
                    logout: logout,
                    toggleAuthNav: toggleAuthNav,
                    active: active,
                    handleSignin: onClickSignIn,
                    handleCreateAccount: onClickSignUp
                })
            }) : isLoggedIn ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                tabIndex: "0",
                role: "button",
                "aria-label": active ? "".concat(i18n.user, " ").concat(i18n.expanded) : "".concat(i18n.user, " ").concat(i18n.collapsed),
                name: "loggedInUser",
                className: "auth-nav__user gbh-data-layer",
                onClick: showMenuNav,
                "data-gbh-data-layer": signedInEventInfo,
                children: [
                    i18n.hi,
                    ", ",
                    (0,helper/* capitalizeFirstName */.MyB)(user === null || user === void 0 ? void 0 : user.firstName)
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                tabIndex: "0",
                role: "button",
                name: "avatarIcon",
                "aria-label": active ? "".concat(i18n.signIn, " ").concat(i18n.expanded) : "".concat(i18n.signIn, " ").concat(i18n.collapsed),
                src: avatarIcon,
                alt: i18n.signIn,
                onClick: showMenuNav,
                className: "gbh-data-layer",
                "data-gbh-data-layer": signInEventInfo
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "auth-nav__menu ".concat(isLoggedIn ? "auth-nav__menu-expand" : "", " ").concat(active ? "auth-nav__menu-open" : ""),
                "aria-hidden": !active,
                children: active ? /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
                    fallback: "Loading...",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenu, {
                        userMenuFragment: userMenuFragment,
                        guestMenuFragment: guestMenuFragment,
                        isLoggedIn: isLoggedIn,
                        i18n: i18n,
                        user: user,
                        logout: logout,
                        toggleAuthNav: toggleAuthNav,
                        handleSignin: onClickSignIn,
                        handleCreateAccount: onClickSignUp,
                        onAuthMenuClick: onAuthMenuClick
                    })
                }) : null
            })
        ]
    });
};
AuthUtilityNavView.displayName = "AuthUtilityNavView";
/* harmony default export */ var AuthUtilityNav_view = (AuthUtilityNavView);

// EXTERNAL MODULE: ./i18n/useAuthUtilityNavi18n.js
var useAuthUtilityNavi18n = __webpack_require__(46967);
// EXTERNAL MODULE: ./components/Default/AuthUtilityNav/v1/AuthUtilityNav/index.module.scss
var AuthUtilityNav_index_module = __webpack_require__(50238);
var AuthUtilityNav_index_module_default = /*#__PURE__*/__webpack_require__.n(AuthUtilityNav_index_module);
// EXTERNAL MODULE: ./store/features/genericSlice.js
var genericSlice = __webpack_require__(88751);
;// CONCATENATED MODULE: ./components/Default/AuthUtilityNav/v1/AuthUtilityNav/index.jsx










// import useOnClickOutside from "@/hooks/useOnClickOutside"

const AuthUtilityNav = (props)=>{
    const { show , active , toggleAuthNav , setAuthNav , onAuthMenuClick  } = props;
    const dispatch = (0,es/* useDispatch */.I0)();
    const authNavMenuRef = (0,react.useRef)(null);
    const { isAuth  } = (0,es/* useSelector */.v9)(authSlice/* selectAuthState */._9);
    const { guestMenuFragment , userMenuFragment  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    // useOnClickOutside(authNavMenuRef, toggleAuthNav)
    (0,react.useEffect)(()=>{
        if (show || lib/* isMobile */.tq) {
            (0,constants_config/* getConfig */.i)().then((CONFIG)=>{
                const userFragment = get_default()(CONFIG, "general.signInFragment", "");
                const guestFragment = get_default()(CONFIG, "general.signUpFragment", "");
                const guestMenuPayload = {
                    reload: false,
                    path: guestFragment,
                    fragmentName: "guestMenuFragment"
                };
                dispatch((0,genericSlice/* getAuthMenuFragment */.T8)(guestMenuPayload));
                const userMenuPayload = {
                    reload: false,
                    path: userFragment,
                    fragmentName: "userMenuFragment"
                };
                dispatch((0,genericSlice/* getAuthMenuFragment */.T8)(userMenuPayload));
            });
        }
    }, [
        show
    ]);
    const staticTexts = (0,useAuthUtilityNavi18n/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        role: "listitem",
        className: "auth-widget auth-widget__menu position_unset ".concat((AuthUtilityNav_index_module_default()).authUtilityNavWrapper),
        ref: authNavMenuRef,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthUtilityNav_view, {
            show: show,
            active: active,
            toggleAuthNav: toggleAuthNav,
            i18n: staticTexts,
            userMenuFragment: userMenuFragment,
            guestMenuFragment: guestMenuFragment,
            isLoggedIn: isAuth,
            logout: ()=>dispatch((0,authSlice/* logout */.kS)()),
            setAuthNav: setAuthNav,
            onAuthMenuClick: onAuthMenuClick
        })
    });
};
/* harmony default export */ var v1_AuthUtilityNav = (AuthUtilityNav);

// EXTERNAL MODULE: ./constants/routes.js
var routes = __webpack_require__(64757);
// EXTERNAL MODULE: ./node_modules/isomorphic-dompurify/browser.js
var browser = __webpack_require__(29238);
var browser_default = /*#__PURE__*/__webpack_require__.n(browser);
;// CONCATENATED MODULE: ./components/Default/CountryUtilNav/v1/CountryUtilNavLink.jsx


const CountryUtilNavLink = (props)=>{
    const { languageLink , language , countryName , languageAbbreviation , isMobile , datalayerPageName  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
        href: languageLink,
        "aria-label": "".concat(countryName, " ").concat(language),
        className: "gbh-data-layer lang ".concat(isMobile && "mobile"),
        "data-gbh-data-layer": '{"clickInternalLinks":"true","internalLinkPosition":"languageselector","internalLinkZoneName":"'.concat(datalayerPageName).concat(datalayerPageName ? ":" : "", 'global header","internalLinkURL":"').concat(languageLink, '","internalLinkName":"language select:').concat(isMobile ? language.toLowerCase() : languageAbbreviation.toLowerCase(), '","eventName":"language selector","internalLinkType":"homepage:navigation","eventType":"language selector","eventAction":"language selector"}'),
        rel: "noreferrer",
        children: isMobile ? language : languageAbbreviation
    });
};
/* harmony default export */ var v1_CountryUtilNavLink = (CountryUtilNavLink);

;// CONCATENATED MODULE: ./components/Default/CountryUtilNav/v1/CountryUtilNavLinks.jsx



const CountryUtilNavLinks = (props)=>{
    const { languageLink , language , countryName , languageAbbreviation , datalayerPageName  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_CountryUtilNavLink, {
                    languageLink: languageLink,
                    language: language,
                    countryName: countryName,
                    languageAbbreviation: languageAbbreviation,
                    isMobile: false,
                    datalayerPageName: datalayerPageName
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_CountryUtilNavLink, {
                    languageLink: languageLink,
                    language: language,
                    countryName: countryName,
                    languageAbbreviation: languageAbbreviation,
                    isMobile: true,
                    datalayerPageName: datalayerPageName
                })
            ]
        })
    });
};
/* harmony default export */ var v1_CountryUtilNavLinks = (CountryUtilNavLinks);

;// CONCATENATED MODULE: ./components/Default/CountryUtilNav/v1/CountryUtilContainer.jsx





const CountryUtilContainer = (props)=>{
    const { countryarea , activeTab , title , description , countryselectorItems , datalayerPageName  } = props;
    const { winWidth  } = (0,useWindowDimensions/* default */.Z)();
    const [expanded, setExpanded] = (0,react.useState)([]);
    const handleExpand = (url, country)=>{
        if (!url) {
            if (expanded.includes(country)) {
                const exp = [
                    ...expanded
                ].filter((item)=>item !== country);
                setExpanded(exp);
            } else {
                const exp1 = [
                    ...expanded
                ];
                exp1.push(country);
                setExpanded(exp1);
            }
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        id: countryarea,
        className: "gbh-tab__content ".concat(activeTab === countryarea ? "gbh-tab__content--active" : "", " "),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "container",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "row",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "col-12 col-lg-4 left d-none d-lg-block",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                children: title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                dangerouslySetInnerHTML: {
                                    __html: browser_default().sanitize(description)
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-12 col-lg-8 right",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "row",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-lg-12 col-12 p-0",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                    className: "gbh-tab__list",
                                    role: "list",
                                    children: countryselectorItems && countryselectorItems.map(function(item, index) {
                                        var ref;
                                        if (!item.country) return null;
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                            role: "listitem",
                                            className: "".concat(item.country).concat(winWidth <= 1200 && !item.countryLink ? " arrowdropdown" : ""),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                    href: (ref = item.countryLink) === null || ref === void 0 ? void 0 : ref.split("/content/kohler/us").join("").replace(".html", ""),
                                                    className: "gbh-data-layer gbh-tab__item--link",
                                                    role: "link",
                                                    "data-gbh-data-layer": '{"clickInternalLinks":"true","internalLinkPosition":"global header","internalLinkZoneName":"'.concat(datalayerPageName).concat(datalayerPageName ? ":" : "", 'global header","internalLinkURL":"n/a","internalLinkName":"country select:').concat(item.countryName.toLowerCase(), '","eventName":"country selector","internalLinkType":"homepage:navigation","eventType":"country selector","eventAction":"country selector"}'),
                                                    "aria-current": "page",
                                                    onClick: ()=>handleExpand(item.countryLink, item.country),
                                                    children: [
                                                        item.countryName,
                                                        " "
                                                    ]
                                                }),
                                                (item.languageOneAbbreviation || item.languageTwoAbbreviation || item.languageThreeAbbreviation) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                    style: expanded.includes(item.country) ? {
                                                        display: "block"
                                                    } : {},
                                                    children: [
                                                        item.languageOneAbbreviation && /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_CountryUtilNavLinks, {
                                                            languageLink: item.languageOneLink,
                                                            language: item.languageOne,
                                                            countryName: item.countryName,
                                                            languageAbbreviation: item.languageOneAbbreviation,
                                                            datalayerPageName: datalayerPageName
                                                        }),
                                                        item.languageTwoAbbreviation && /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_CountryUtilNavLinks, {
                                                            languageLink: item.languageTwoLink,
                                                            language: item.languageTwo,
                                                            countryName: item.countryName,
                                                            languageAbbreviation: item.languageTwoAbbreviation,
                                                            datalayerPageName: datalayerPageName
                                                        }),
                                                        item.languageThreeAbbreviation && /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_CountryUtilNavLinks, {
                                                            languageLink: item.languageThreeLink,
                                                            language: item.languageThree,
                                                            countryName: item.countryName,
                                                            languageAbbreviation: item.languageThreeAbbreviation,
                                                            datalayerPageName: datalayerPageName
                                                        })
                                                    ]
                                                })
                                            ]
                                        }, "".concat(item.country, "+").concat(index));
                                    })
                                })
                            })
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var v1_CountryUtilContainer = (CountryUtilContainer);

;// CONCATENATED MODULE: ./components/Default/CountryUtilNav/v1/CountryUtilNavTabLink.jsx


const CountryUtilNavTabLink = (props)=>{
    const { activeTab , countryArea , onclickVal , countryAreaValue  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
        onClick: ()=>{
            onclickVal(countryArea);
        },
        "data-tab": countryArea,
        role: "tab",
        tabIndex: "0",
        "data-region": "#".concat(countryArea),
        "aria-label": countryArea,
        className: "gbh-tabs__tab ".concat(activeTab === countryArea ? "gbh-tabs__tab--active" : ""),
        "data-testid": "countrySelectorSection_tabLink",
        children: countryAreaValue
    });
};
/* harmony default export */ var v1_CountryUtilNavTabLink = (CountryUtilNavTabLink);

// EXTERNAL MODULE: ./components/Default/CountryUtilNav/v1/CountryUtilNav.module.scss
var CountryUtilNav_module = __webpack_require__(19371);
var CountryUtilNav_module_default = /*#__PURE__*/__webpack_require__.n(CountryUtilNav_module);
;// CONCATENATED MODULE: ./components/Default/CountryUtilNav/v1/CountryUtilNav.jsx






const CountryUtilNav = (props)=>{
    const { show , active , toggleCountryNav , eventHandler , countryselector , datalayerPageName , v3  } = props;
    const { callbacks: { setRegionNav =()=>console.log("Event Not Defined")  }  } = eventHandler;
    const { winWidth  } = (0,useWindowDimensions/* default */.Z)();
    const [activeTab, setActiveTab] = (0,react.useState)("");
    const addCountrySelectorAnalytics = (type)=>{
        let eventInfo;
        if (type === "Americas") {
            eventInfo = getAmericaTabEventInfo(type);
        } else if (type === "Africa") {
            eventInfo = getAfricaTabEventInfo(type);
        } else if (type === "Asia") {
            eventInfo = getAsiaTabEventInfo(type);
        } else if (type === "Australasia") {
            eventInfo = getAustralasiaTabEventInfo(type);
        } else if (type === "Middle East") {
            eventInfo = getMiddleEastTabEventInfo(type);
        } else if (type === "Europe") {
            eventInfo = getEuropeTabEventInfo(type);
        }
        const page = window.pageObj || {};
        window.adobeDataLayer.push({
            event: "cmp:click",
            eventInfo,
            page
        });
    };
    const getAmericaTabEventInfo = (type)=>{
        if (type === "Americas") {
            return {
                clickInternalLinks: "true",
                eventAction: "country select:americas",
                eventName: "country select:americas",
                eventType: "navigation",
                internalLinkName: "americas",
                internalLinkPosition: "countryselector",
                internalLinkType: "global header : navigation",
                internalLinkZoneName: "global header",
                internalLinkURL: "n/a"
            };
        }
    };
    const getAfricaTabEventInfo = (type)=>{
        if (type === "Africa") {
            return {
                clickInternalLinks: "true",
                eventAction: "country select:africa",
                eventName: "country select:africa",
                eventType: "navigation",
                internalLinkName: "africa",
                internalLinkPosition: "countryselector",
                internalLinkType: "global header : navigation",
                internalLinkZoneName: "global header",
                internalLinkURL: "n/a"
            };
        }
    };
    const getAsiaTabEventInfo = (type)=>{
        if (type === "Asia") {
            return {
                clickInternalLinks: "true",
                eventAction: "country select:asia",
                eventName: "country select:asia",
                eventType: "navigation",
                internalLinkName: "asia",
                internalLinkPosition: "countryselector",
                internalLinkType: "global header : navigation",
                internalLinkZoneName: "global header",
                internalLinkURL: "n/a"
            };
        }
    };
    const getAustralasiaTabEventInfo = (type)=>{
        if (type === "Australasia") {
            return {
                clickInternalLinks: "true",
                eventAction: "country select:australasia",
                eventName: "country select:australasia",
                eventType: "navigation",
                internalLinkName: "australasia",
                internalLinkPosition: "countryselector",
                internalLinkType: "global header : navigation",
                internalLinkZoneName: "global header",
                internalLinkURL: "n/a"
            };
        }
    };
    const getMiddleEastTabEventInfo = (type)=>{
        if (type === "Middle East") {
            return {
                clickInternalLinks: "true",
                eventAction: "country select:middle east",
                eventName: "country select:middle east",
                eventType: "navigation",
                internalLinkName: "middle east",
                internalLinkPosition: "countryselector",
                internalLinkType: "global header : navigation",
                internalLinkZoneName: "global header",
                internalLinkURL: "n/a"
            };
        }
    };
    const getEuropeTabEventInfo = (type)=>{
        if (type === "Europe") {
            return {
                clickInternalLinks: "true",
                eventAction: "country select:europe",
                eventName: "country select:europe",
                eventType: "navigation",
                internalLinkName: "europe",
                internalLinkPosition: "countryselector",
                internalLinkType: "global header : navigation",
                internalLinkZoneName: "global header",
                internalLinkURL: "n/a"
            };
        }
    };
    (0,react.useEffect)(()=>{
        if (winWidth <= 1200) {
            setActiveTab("");
        } else {
            setActiveTab("america");
        }
    }, [
        winWidth
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (CountryUtilNav_module_default()).countrySelectorMain,
        "data-testid": "countrySelectorSection",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            id: "gbh_utheader",
            className: "gbh-countryselector ".concat(active ? "active" : ""),
            style: show ? {
                left: 0,
                display: "block"
            } : {
                display: "block"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "gbh-tab",
                    children: [
                        !v3 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            role: "button",
                            className: "gbh-hamber-menu gbh-close icon-Close-Medium"
                        }) : null,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            role: "button",
                            tabIndex: "0",
                            "data-testid": "countrySelectorSection_menu",
                            className: "gbh-close-btn d-block d-lg-none pl-4 mb-2",
                            onClick: ()=>{
                                toggleCountryNav(), setRegionNav(false);
                            },
                            children: "Menu"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                            role: "tablist",
                            "aria-multiselectable": "false",
                            className: "tablist",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "selection-bar"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    onClick: ()=>addCountrySelectorAnalytics("Americas"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_CountryUtilNavTabLink, {
                                        activeTab: activeTab,
                                        countryArea: "america",
                                        countryAreaValue: "Americas",
                                        onclickVal: setActiveTab
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    onClick: ()=>addCountrySelectorAnalytics("Africa"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_CountryUtilNavTabLink, {
                                        activeTab: activeTab,
                                        countryArea: "africa",
                                        countryAreaValue: "Africa",
                                        onclickVal: setActiveTab
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    onClick: ()=>addCountrySelectorAnalytics("Asia"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_CountryUtilNavTabLink, {
                                        activeTab: activeTab,
                                        countryArea: "asia",
                                        countryAreaValue: "Asia",
                                        onclickVal: setActiveTab
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    onClick: ()=>addCountrySelectorAnalytics("Australasia"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_CountryUtilNavTabLink, {
                                        activeTab: activeTab,
                                        countryArea: "australia",
                                        countryAreaValue: "Australasia",
                                        onclickVal: setActiveTab
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    onClick: ()=>addCountrySelectorAnalytics("Middle East"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_CountryUtilNavTabLink, {
                                        activeTab: activeTab,
                                        countryArea: "middleEast",
                                        countryAreaValue: "Middle East",
                                        onclickVal: setActiveTab
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    onClick: ()=>addCountrySelectorAnalytics("Europe"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_CountryUtilNavTabLink, {
                                        activeTab: activeTab,
                                        countryArea: "europe",
                                        countryAreaValue: "Europe",
                                        onclickVal: setActiveTab
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "gbh-tab__panels",
                    style: winWidth <= 1200 && activeTab ? {
                        display: "block"
                    } : {},
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            role: "button",
                            className: "gbh-hamber-menu gbh-close icon-Close-Medium"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            role: "button",
                            tabIndex: "0",
                            className: "gbh-back-btn d-block d-lg-none pl-4 mb-2",
                            onClick: ()=>setActiveTab(""),
                            children: "Region"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_CountryUtilContainer, {
                            countryarea: "america",
                            activeTab: activeTab,
                            title: countryselector === null || countryselector === void 0 ? void 0 : countryselector.title,
                            description: countryselector === null || countryselector === void 0 ? void 0 : countryselector.description,
                            countryselectorItems: countryselector === null || countryselector === void 0 ? void 0 : countryselector.americasItems,
                            datalayerPageName: datalayerPageName
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_CountryUtilContainer, {
                            countryarea: "africa",
                            activeTab: activeTab,
                            title: countryselector === null || countryselector === void 0 ? void 0 : countryselector.title,
                            description: countryselector === null || countryselector === void 0 ? void 0 : countryselector.description,
                            countryselectorItems: countryselector === null || countryselector === void 0 ? void 0 : countryselector.africaItems,
                            datalayerPageName: datalayerPageName
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_CountryUtilContainer, {
                            countryarea: "asia",
                            activeTab: activeTab,
                            title: countryselector === null || countryselector === void 0 ? void 0 : countryselector.title,
                            description: countryselector === null || countryselector === void 0 ? void 0 : countryselector.description,
                            countryselectorItems: countryselector === null || countryselector === void 0 ? void 0 : countryselector.asiaItems,
                            datalayerPageName: datalayerPageName
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_CountryUtilContainer, {
                            countryarea: "australia",
                            activeTab: activeTab,
                            title: countryselector === null || countryselector === void 0 ? void 0 : countryselector.title,
                            description: countryselector === null || countryselector === void 0 ? void 0 : countryselector.description,
                            countryselectorItems: countryselector === null || countryselector === void 0 ? void 0 : countryselector.oceaniaItems,
                            datalayerPageName: datalayerPageName
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_CountryUtilContainer, {
                            countryarea: "middleEast",
                            activeTab: activeTab,
                            title: countryselector === null || countryselector === void 0 ? void 0 : countryselector.title,
                            description: countryselector === null || countryselector === void 0 ? void 0 : countryselector.description,
                            countryselectorItems: countryselector === null || countryselector === void 0 ? void 0 : countryselector.middleEastItems,
                            datalayerPageName: datalayerPageName
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_CountryUtilContainer, {
                            countryarea: "europe",
                            activeTab: activeTab,
                            title: countryselector === null || countryselector === void 0 ? void 0 : countryselector.title,
                            description: countryselector === null || countryselector === void 0 ? void 0 : countryselector.description,
                            countryselectorItems: countryselector === null || countryselector === void 0 ? void 0 : countryselector.europeItems,
                            datalayerPageName: datalayerPageName
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var v1_CountryUtilNav = (CountryUtilNav);

// EXTERNAL MODULE: ./utils/cart.js
var cart = __webpack_require__(11763);
;// CONCATENATED MODULE: ./public/icons/cart-icon.svg
/* harmony default export */ var cart_icon = ({"src":"/_next/static/media/cart-icon.9accb288.svg","height":25,"width":25});
;// CONCATENATED MODULE: ./public/icons/cart-icon-empty.svg
/* harmony default export */ var cart_icon_empty = ({"src":"/_next/static/media/cart-icon-empty.02db72e9.svg","height":20,"width":26});
;// CONCATENATED MODULE: ./public/icons/cart-gray.svg
/* harmony default export */ var cart_gray = ({"src":"/_next/static/media/cart-gray.abab88ab.svg","height":20,"width":25});
;// CONCATENATED MODULE: ./public/icons/cart-filled.svg
/* harmony default export */ var cart_filled = ({"src":"/_next/static/media/cart-filled.4aa11106.svg","height":20,"width":25});
// EXTERNAL MODULE: ./hooks/useWindowResize.js
var useWindowResize = __webpack_require__(11859);
;// CONCATENATED MODULE: ./components/Shared/MiniCart/v1/MiniCart.jsx











const MiniCart = (param)=>{
    let { eventHandler: { store: { cartCount , ariaLabel  } , callbacks: { onClick  }  } , checkoutPage  } = param;
    const [width] = (0,useWindowResize/* default */.Z)();
    const getWidth = window.outerWidth === 0 ? window.innerWidth : lib/* isSafari */.G6 ? window.innerWidth : window.outerWidth;
    const [isMobile, setIsMobile] = (0,react.useState)((getWidth || width) <= 1200);
    const [cartUrl, setCartUrl] = (0,react.useState)("");
    const cartGrayFilledIconV3 = "/icons/cart-empty.svg";
    (0,react.useEffect)(()=>{
        !checkoutPage ? setIsMobile((getWidth && width) <= 1200) : setIsMobile(false);
    }, [
        getWidth,
        width,
        checkoutPage
    ]);
    (0,react.useEffect)(()=>{
        (0,cart/* getCartLandingPagePath */.dZ)().then((res)=>{
            setCartUrl(res);
        });
    }, []);
    const { winWidth  } = (0,useWindowDimensions/* default */.Z)();
    const themeChange =  true && winWidth <= 1200 && (document.body.classList.contains("nav-light-theme") || document.body.classList.contains("nav-dark-theme"));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "cart-indicator ".concat(cartCount > 0 && "cart-indicator__with-count"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: cartUrl,
            "aria-label": ariaLabel,
            role: "link",
            className: "gbh-data-layer",
            "data-gbh-data-layer": '{"clickInternalLinks":"true","internalLinkPosition":"global header","internalLinkZoneName":"global header","internalLinkURL":"'.concat(cartUrl, '","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"cart icon","eventName":"cart icon","internalLinkType":"global header:navigation","eventType":"global header","eventAction":"cart icon"}'),
            children: cartCount ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "cart-indicator__count ".concat(cartCount < 100 && "cart-indicator__count--center"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: isMobile ? cart_filled === null || cart_filled === void 0 ? void 0 : cart_filled.src : cart_icon === null || cart_icon === void 0 ? void 0 : cart_icon.src,
                        alt: "Cart"
                    }),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: cartCount
                    })
                ]
            }) : themeChange ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: isMobile ? cartGrayFilledIconV3 : cart_icon_empty.src,
                alt: "Cart"
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: isMobile ? cart_gray === null || cart_gray === void 0 ? void 0 : cart_gray.src : cart_icon_empty.src,
                alt: "Cart"
            })
        })
    });
};
const checkForRerender = (prevProps, nextProps)=>{
    return nextProps.eventHandler.store.cartCount === prevProps.eventHandler.store.cartCount;
};
/* harmony default export */ var v1_MiniCart = (/*#__PURE__*/(0,react.memo)(MiniCart, checkForRerender));

// EXTERNAL MODULE: ./components/Shared/index.module.scss
var Shared_index_module = __webpack_require__(3738);
var Shared_index_module_default = /*#__PURE__*/__webpack_require__.n(Shared_index_module);
// EXTERNAL MODULE: ./store/features/favoritesSlice.js + 1 modules
var favoritesSlice = __webpack_require__(7737);
// EXTERNAL MODULE: ./constants/api.js
var constants_api = __webpack_require__(73350);
// EXTERNAL MODULE: ./components/Shared/UtilityWidgets/v1/UtilityWidgets.module.scss
var UtilityWidgets_module = __webpack_require__(84181);
var UtilityWidgets_module_default = /*#__PURE__*/__webpack_require__.n(UtilityWidgets_module);
;// CONCATENATED MODULE: ./components/Shared/helper.js
const getSrc = (themeChange, favoritesPage, iconFavoriteBlack, iconFavorite)=>{
    if (!themeChange) {
        return favoritesPage && favoritesPage.length > 0 ? "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTVweCIgaGVpZ2h0PSIxNHB4IiB2aWV3Qm94PSIwIDAgMTUgMTQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+SWNvbi9XaXNobGlzdDwvdGl0bGU+CiAgICA8ZyBpZD0iQjEtQ29tcGFyZSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9Ikljb24vV2lzaGxpc3QiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAuMDAwMDAwLCAtOC4wMDAwMDApIiBmaWxsPSIjRkZGRkZGIj4KICAgICAgICAgICAgPHBhdGggZD0iTTguMTQwNjA3MTQsOS42ODg0ODE5NyBMNy41MDEsMTAuMzM0IEw2Ljg2MTU5MzY5LDkuNjg4NDgxOTcgQzUuMjkyNDIzNTIsOC4xMDM4MzkzNCAyLjc0NjI0NDc5LDguMTAzODM5MzQgMS4xNzcwNzQ2Myw5LjY4ODQ4MTk3IEMtMC4zNDg3ODE5NTgsMTEuMjI5MzgzOSAtMC4zOTYyNTE5NTksMTMuNzE4NTgzNCAxLjA2NDMyMjM2LDE1LjI5NzA0NDIgTDEuMTcwNzE4NTIsMTUuNDA4NTcwNyBMNy41MDExMTM0NCwyMS44MDE1MDMzIEwxMy44MDg0ODM5LDE1LjQzMjE5OTggTDEzLjkxNTE4NzgsMTUuMzIxMTQwOCBDMTUuMzk1NTk2OCwxMy43MjE3MTI1IDE1LjM1Mzk3MDMsMTEuMjMyNDAxIDEzLjgyNTEyNjIsOS42ODg0ODE5NyBDMTIuMjU1OTU2LDguMTAzODM5MzQgOS43MDk3NzczMSw4LjEwMzgzOTM0IDguMTQwNjA3MTQsOS42ODg0ODE5NyBaIiBpZD0iUGF0aCI+PC9wYXRoPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+" : "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4NCjxzdmcgd2lkdGg9IjE1cHgiIGhlaWdodD0iMTRweCIgdmlld0JveD0iMCAwIDE1IDE0IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPg0KICAgIDx0aXRsZT5JY29uL1dpc2hsaXN0PC90aXRsZT4NCiAgICA8ZyBpZD0iU3ltYm9scyIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+DQogICAgICAgIDxnIGlkPSJCdXR0b24vSW1hZ2UtSWNvbnMvV2lzaGxpc3QtRW1wdHkvRGFyay1HcmF5LUJHIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTEuMDAwMDAwLCAtMTEuMDAwMDAwKSIgZmlsbD0iI0ZGRkZGRiI+DQogICAgICAgICAgICA8ZyBpZD0iSWNvbi9XaXNobGlzdCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTEuMDAwMDAwLCAzLjAwMDAwMCkiPg0KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik04LjE0MDYwNzE0LDkuNjg4NDgxOTcgTDcuNTAxLDEwLjMzNCBMNi44NjE1OTM2OSw5LjY4ODQ4MTk3IEM1LjI5MjQyMzUyLDguMTAzODM5MzQgMi43NDYyNDQ3OSw4LjEwMzgzOTM0IDEuMTc3MDc0NjMsOS42ODg0ODE5NyBDLTAuMzQ4NzgxOTU4LDExLjIyOTM4MzkgLTAuMzk2MjUxOTU5LDEzLjcxODU4MzQgMS4wNjQzMjIzNiwxNS4yOTcwNDQyIEwxLjE3MDcxODUyLDE1LjQwODU3MDcgTDcuNTAxMTEzNDQsMjEuODAxNTAzMyBMMTMuODA4NDgzOSwxNS40MzIxOTk4IEwxMy45MTUxODc4LDE1LjMyMTE0MDggQzE1LjM5NTU5NjgsMTMuNzIxNzEyNSAxNS4zNTM5NzAzLDExLjIzMjQwMSAxMy44MjUxMjYyLDkuNjg4NDgxOTcgQzEyLjI1NTk1Niw4LjEwMzgzOTM0IDkuNzA5Nzc3MzEsOC4xMDM4MzkzNCA4LjE0MDYwNzE0LDkuNjg4NDgxOTcgWiBNMTMuMTE0NTU4OSwxMC4zOTIxMTEzIEMxNC4yNjY2NjkyLDExLjU1NTU4MTYgMTQuMjk4MTAyMiwxMy40MzUzMTE1IDEzLjE4NzU0NTEsMTQuNjM1MjQ1MyBMMTMuMDkyNTIwMiwxNC43MzQxMDUzIEw3LjUwMSwyMC4zOCBMMS44ODc2NDE4OSwxNC43MTE0NzgzIEwxLjc5Mjk1NDA5LDE0LjYxMjE4MzEgQzAuNzAxOTMzNDQxLDEzLjQzMzAxMzYgMC43Mzc3ODAxMDEsMTEuNTUzMzExIDEuODg3NjQxODksMTAuMzkyMTExMyBDMy4wNjU1MDk0NSw5LjIwMjYyOTU4IDQuOTczMTU4ODcsOS4yMDI2Mjk1OCA2LjE1MTAyNjQyLDEwLjM5MjExMTMgTDcuNTAxMTAwNDIsMTEuNzU1NDk3NCBMOC44NTExNzQ0MSwxMC4zOTIxMTEzIEMxMC4wMjkwNDIsOS4yMDI2Mjk1OCAxMS45MzY2OTE0LDkuMjAyNjI5NTggMTMuMTE0NTU4OSwxMC4zOTIxMTEzIFoiIGlkPSJQYXRoIj48L3BhdGg+DQogICAgICAgICAgICA8L2c+DQogICAgICAgIDwvZz4NCiAgICA8L2c+DQo8L3N2Zz4=";
    } else {
        return favoritesPage && favoritesPage.length > 0 ? iconFavoriteBlack : iconFavorite;
    }
};

;// CONCATENATED MODULE: ./components/Shared/UtilityNavHeader.jsx

























const UtilityNavHeader = (param)=>{
    let { data , eventHandler , toggleMenu =()=>{}  } = param;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21;
    const [favoritesPagePath, setFavoritesPagePath] = (0,react.useState)("/");
    const { ":items": { store: { zipCodeContent =""  } = {}  } = {}  } = data;
    const { findAStoreShow , findAStoreActive  } = (0,es/* useSelector */.v9)(locationSlice/* locationState */._n);
    const { store: { isOpen , mainCategoryActive , isRegionOpen , isAuthNavOpen  } , callbacks: { // eslint-disable-next-line no-console
    setRegionNav =()=>console.log("Event Not Defined") , // eslint-disable-next-line no-console
    setAuthNav =()=>console.log("Event Not Defined")  }  } = eventHandler;
    const [languageUrl, setLanguageUrl] = (0,react.useState)("");
    const { winWidth  } = (0,useWindowDimensions/* default */.Z)();
    const { datalayerPageName , featureFlags ={} , globalConfig: { internationalization: { language ="en" , locale =constants.LOCALE_ENGLISH  } = {}  } = {}  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const isMobile =  true && window.innerWidth <= 1200;
    const { isAuth  } = (0,es/* useSelector */.v9)(authSlice/* selectAuthState */._9);
    const { MYSQLCONNSTR_ENABLE_SHOPPING_LISTS_V2: isSaveProductToList = false  } = featureFlags;
    const { favorites , saveToListLineItems  } = (0,es/* useSelector */.v9)(favoritesSlice/* selectFavoritesState */.Qx);
    const [authNavShow, setAuthNavShow] = (0,react.useState)(false);
    const [authNavActive, setAuthNavActive] = (0,react.useState)(false);
    const [favoritesPage, setFavoritesPage] = (0,react.useState)([]);
    const [countryNavShow, setCountryNavShow] = (0,react.useState)(false);
    const [countryNavActive, setCountryNavActive] = (0,react.useState)(false);
    const [findAStoreMob, setFindAStoreMob] = (0,react.useState)([]);
    const [languageSwitcherUrl, setLanguageSwitcherUrl] = (0,react.useState)(false);
    const [loginFavouriteCallback, setLoginFavouriteCallback] = (0,react.useState)(null);
    const [myListsPagePath, setMyListsPagePath] = (0,react.useState)("/");
    eventHandler.callbacks.toggleFindAStore = ()=>{
        dispatch((0,locationSlice/* setFindAStoreActive */.I_)(false));
    };
    (0,react.useEffect)(()=>{
        if (findAStoreShow) {
            dispatch((0,locationSlice/* setFindAStoreActive */.I_)(true));
        }
        if (authNavShow) {
            setAuthNavActive(true);
        }
        if (countryNavShow) {
            setCountryNavActive(true);
        }
    }, [
        findAStoreShow,
        authNavShow,
        countryNavShow
    ]);
    (0,react.useEffect)(()=>{
        if (isSaveProductToList) {
            setFavoritesPagePath("/".concat(language).concat(routes/* MY_LISTS_PAGE_PATH */.PN));
        } else {
            (0,constants_config/* getConfig */.i)().then(async (config)=>{
                const myFavPath = get_default()(config, "general.myFavoritesPagePath", "");
                setFavoritesPagePath(await (0,helper/* getShortenedUrl */.Ppy)(myFavPath !== null && myFavPath !== void 0 ? myFavPath : "/"));
            });
        }
        const shortenUrl = async ()=>{
            if (data === null || data === void 0 ? void 0 : data.enableLanguageSwitcher) {
                const shortendUrl = await (0,helper/* getShortenedUrl */.Ppy)(data === null || data === void 0 ? void 0 : data.languageUrl);
                setLanguageUrl(shortendUrl);
            }
        };
        shortenUrl();
    }, [
        isSaveProductToList
    ]);
    (0,react.useEffect)(()=>{
        const shortenUrlLang = async ()=>{
            var ref, ref1;
            if ((ref = findAStoreMob[4]) === null || ref === void 0 ? void 0 : (ref1 = ref.utilitynavheader) === null || ref1 === void 0 ? void 0 : ref1.enableLanguageSwitcher) {
                var ref2, ref3;
                const shortenUrlLang = await (0,helper/* getShortenedUrl */.Ppy)((ref2 = findAStoreMob[4]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.utilitynavheader) === null || ref3 === void 0 ? void 0 : ref3.languageUrl);
                setLanguageUrl(shortenUrlLang);
            }
        };
        shortenUrlLang();
    }, [
        languageSwitcherUrl
    ]);
    (0,react.useEffect)(()=>{
        if (isAuth) {
            dispatch((0,favoritesSlice/* getFavorites */._l)()).unwrap().then((rsp)=>{
                if (rsp && rsp !== null) {
                    setFavoritesPage(rsp.lineItems);
                } else {
                    setFavoritesPage([]);
                }
            });
            if (isSaveProductToList) {
                dispatch((0,favoritesSlice/* getMyAccountListsWithLineItems */.WQ)()).unwrap().then((res)=>{
                    if (Object.keys(res[1]).length) {
                        setFavoritesPage(Object.keys(res[1]));
                    } else {
                        setFavoritesPage([]);
                    }
                });
            }
        }
    }, [
        isAuth,
        isSaveProductToList
    ]);
    (0,react.useEffect)(()=>{
        if ((favorites === null || favorites === void 0 ? void 0 : favorites.lineItems) && (favorites === null || favorites === void 0 ? void 0 : favorites.lineItems.length) > 0) {
            setFavoritesPage(favorites === null || favorites === void 0 ? void 0 : favorites.lineItems);
        } else {
            setFavoritesPage([]);
        }
    }, [
        favorites
    ]);
    (0,react.useEffect)(()=>{
        if (!findAStoreActive) {
            setTimeout(()=>{
                dispatch((0,locationSlice/* setFindAStoreShow */.T7)(false));
            }, 1000);
        }
        if (!authNavActive) {
            setTimeout(()=>{
                setAuthNavShow(false);
            }, 1000);
        }
        if (!countryNavActive) {
            if (winWidth <= 1200) {
                setCountryNavShow(false);
            } else {
                setTimeout(()=>{
                    setCountryNavShow(false);
                }, 1000);
            }
        }
    }, [
        findAStoreActive,
        authNavActive,
        countryNavActive
    ]);
    (0,react.useEffect)(()=>{
        if (Object.keys(saveToListLineItems).length && isAuth) {
            setFavoritesPage(Object.keys(saveToListLineItems));
        } else {
            setFavoritesPage([]);
        }
    }, [
        Object.keys(saveToListLineItems).length
    ]);
    const toggleFindAStore = ()=>{
        var ref, ref1;
        (0,HeaderNavTabs_analytics/* dataLayerForUtilityClicks */.ue)(((ref = data[":items"]) === null || ref === void 0 ? void 0 : (ref1 = ref.store) === null || ref1 === void 0 ? void 0 : ref1.findStore) || "Find a Store", themeChange);
        if (!findAStoreShow) {
            dispatch((0,locationSlice/* setFindAStoreShow */.T7)(true));
            (0,helper/* toggeleBodyScroll */.wA4)(true);
        } else {
            if (findAStoreActive) {
                dispatch((0,locationSlice/* setFindAStoreActive */.I_)(false));
                (0,helper/* toggeleBodyScroll */.wA4)(false);
            } else {
                dispatch((0,locationSlice/* setFindAStoreShow */.T7)(false));
                (0,helper/* toggeleBodyScroll */.wA4)(false);
            }
        }
    };
    const themeChange =  true && winWidth <= 1200 && (document.body.classList.contains("nav-light-theme") || document.body.classList.contains("nav-dark-theme"));
    const iconFavorite = "/icons/favorites-icon.svg";
    const iconFavoriteBlack = "/icons/favorites-full-black.svg";
    const iconLocation = "/icons/location-icon.svg";
    const staticTexts = (0,useAuthUtilityNavi18n/* default */.Z)();
    const toggleAuthNav = ()=>{
        setAuthNavShow(!authNavActive);
        (0,helper/* toggeleBodyScroll */.wA4)(!authNavActive);
        setAuthNavActive(!authNavActive);
    };
    const toggleCountryNav = ()=>{
        if (!countryNavActive) {
            setCountryNavShow(true);
            (0,helper/* toggeleBodyScroll */.wA4)(true);
        } else {
            setCountryNavActive(false);
            (0,helper/* toggeleBodyScroll */.wA4)(false);
        }
    };
    const clickEvent = (e)=>{
        if (!(0,helper/* isElementExcluded */.G_Z)(e, [
            "header-container",
            "modal-popup",
            "auth-modal"
        ])) {
            !isMobile && !setAuthNavActive(false);
            !isMobile && dispatch((0,locationSlice/* setFindAStoreActive */.I_)(false));
            !isMobile && setCountryNavActive(false);
            (0,helper/* toggeleBodyScroll */.wA4)(false);
        }
    };
    (0,react.useEffect)(()=>{
        if (findAStoreActive) {
            setAuthNavActive(false);
            setCountryNavActive(false);
            document.addEventListener("click", clickEvent);
        } else {
            document.removeEventListener("click", clickEvent);
        }
        return ()=>document.removeEventListener("click", clickEvent);
    }, [
        findAStoreActive
    ]);
    (0,react.useEffect)(()=>{
        if (authNavActive) {
            dispatch((0,locationSlice/* setFindAStoreActive */.I_)(false));
            setCountryNavActive(false);
            document.addEventListener("click", clickEvent);
        } else {
            document.removeEventListener("click", clickEvent);
        }
        return ()=>document.removeEventListener("click", clickEvent);
    }, [
        authNavActive
    ]);
    (0,react.useEffect)(()=>{
        if (countryNavActive) {
            setAuthNavActive(false);
            dispatch((0,locationSlice/* setFindAStoreActive */.I_)(false));
            document.addEventListener("click", clickEvent);
        } else {
            document.removeEventListener("click", clickEvent);
        }
        return ()=>document.removeEventListener("click", clickEvent);
    }, [
        countryNavActive
    ]);
    const style = {
        display: "list-item"
    };
    const displayNone = {
        display: "none"
    };
    const dispatch = (0,es/* useDispatch */.I0)();
    const onClickSignIn = function(e) {
        let path = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
        if (!isAuth) {
            window.loginFavouriteCallback = ()=>{
                setLoginFavouriteCallback(e);
            };
            if (path) setMyListsPagePath(path);
            dispatch((0,authSlice/* setAuthModalVisibility */.LY)({
                show: true
            }));
            e.stopPropagation();
            e.preventDefault();
        }
        (0,HeaderNavTabs_analytics/* dataLayerForUtilityClicks */.ue)(staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.favorites, themeChange, favoritesPagePath);
        if (path && isAuth) {
            toggleMenu();
        }
    };
    (0,react.useEffect)(()=>{
        if (loginFavouriteCallback && isAuth) {
            window.loginFavouriteCallback = null;
            setLoginFavouriteCallback(null);
            window.location.href = myListsPagePath;
        }
    }, [
        loginFavouriteCallback,
        isAuth
    ]);
    const onAuthMenuClick = (payload)=>{
        setAuthNavActive(payload);
        setAuthNav(payload);
    };
    const { globalConfig  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const getNavMobileData = async ()=>{
        const result = await (0,constants_api/* aemAxiosInstance */.Gb)({
            url: "".concat(constants.GLOBAL_CONFIGURATION_ENDPOINT, "?path=").concat(globalConfig.contentFragmentListConfig.map.mobileNavigationFooterLinks),
            method: "GET"
        });
        const commonTopics = JSON.parse(result.data.commonTopics);
        setFindAStoreMob(commonTopics);
    };
    const { contentFragmentListConfig: { map: fragmentList = {}  } = {}  } = globalConfig;
    (0,react.useEffect)(()=>{
        if (Object.keys(fragmentList).length) getNavMobileData();
    }, [
        fragmentList
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Shared_index_module_default()).utilityNavHeaderWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "utilitynavheader",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "gbh-utility-nav",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "gbh-utility-navbar",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                        role: "list",
                        children: [
                            isMobile && findAStoreMob.length ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: "gbh-nav__signin",
                                        ...isOpen && !mainCategoryActive && !isRegionOpen ? {
                                            style: style
                                        } : {},
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (UtilityWidgets_module_default()).utilityWidgetsWrapper,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                role: "list",
                                                className: "utility-widgets utility-widgets__brand-switcher",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_AuthUtilityNav, {
                                                    show: authNavShow,
                                                    active: authNavActive,
                                                    toggleAuthNav: toggleAuthNav,
                                                    setAuthNav: setAuthNav,
                                                    onAuthMenuClick: onAuthMenuClick
                                                })
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        className: "gbh-nav__findStore position_unset",
                                        ...isOpen && !mainCategoryActive && !isRegionOpen && !isAuthNavOpen ? {
                                            style: style
                                        } : {},
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                role: "button",
                                                tabIndex: "0",
                                                "aria-live": "polite",
                                                "aria-labelledby": "find-ada",
                                                className: "gbh-data-layer gbh-nav__findStore--link cmp-find-place",
                                                onClick: ()=>toggleFindAStore(),
                                                children: [
                                                    themeChange ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: iconLocation,
                                                        alt: ""
                                                    }) : null,
                                                    ((ref = findAStoreMob[2]) === null || ref === void 0 ? void 0 : ref.label) || "Find a Store"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_FindStoreUtilNav, {
                                                show: findAStoreShow,
                                                active: findAStoreActive,
                                                eventHandler: eventHandler,
                                                zipCodeContent: zipCodeContent
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        role: "listitem",
                                        className: "wishlist-widget mobile_block position_unset",
                                        ...isOpen && !mainCategoryActive && !isRegionOpen ? {
                                            style: style
                                        } : {},
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                                            href: favoritesPagePath,
                                            "aria-label": "View your wishlist",
                                            className: "gbh-data-layer",
                                            onClick: (e)=>{
                                                onClickSignIn(e, favoritesPagePath);
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    alt: "View your wishlist",
                                                    "aria-hidden": "true",
                                                    role: "presentation",
                                                    src: getSrc(themeChange, favoritesPage, iconFavoriteBlack, iconFavorite)
                                                }),
                                                themeChange ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: (ref1 = findAStoreMob[3]) === null || ref1 === void 0 ? void 0 : ref1.label
                                                }) : null
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        id: "country-ada",
                                        style: displayNone,
                                        children: [
                                            "Country Selector",
                                            " ",
                                            "United States" || (0),
                                            " -",
                                            " "
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        className: "gbh-nav__region region_arrowdropdown",
                                        id: "United States".toLowerCase().split(" ").join("_") || (data === null || data === void 0 ? void 0 : data.country.toLowerCase().split(" ").join("_")),
                                        ...isOpen && !mainCategoryActive ? {
                                            style: style
                                        } : {},
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                role: "button",
                                                tabIndex: "0",
                                                "aria-labelledby": "country-ada",
                                                "aria-expanded": countryNavActive,
                                                onClick: ()=>{
                                                    setRegionNav(true);
                                                    toggleCountryNav();
                                                },
                                                className: "gbh-data-layer gbh-nav__region--link active-country ".concat(data.enableLanguageSwitcher ? "selected-country" : "", " ").concat(countryNavActive ? "expand" : ""),
                                                "data-gbh-data-layer": '{"clickInternalLinks":"true","internalLinkPosition":"global header","internalLinkZoneName":"'.concat(datalayerPageName, ':global header","internalLinkURL":"n/a","internalLinkName":"').concat((ref2 = "United States" || (0)) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase(), " - ").concat((ref3 = (data === null || data === void 0 ? void 0 : data.language) || "EN") === null || ref3 === void 0 ? void 0 : ref3.toLowerCase(), '","eventName":"country select","internalLinkType":"global header : navigation","eventType":"click","eventAction":"country select"}'),
                                                children: [
                                                    "United States" || (0),
                                                    " -",
                                                    " ",
                                                    ((ref4 = findAStoreMob[4]) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.utilitynavheader) === null || ref5 === void 0 ? void 0 : ref5.language) || "EN"
                                                ]
                                            }),
                                            ((ref6 = findAStoreMob[4]) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.utilitynavheader) === null || ref7 === void 0 ? void 0 : ref7.enableLanguageSwitcher) && locale !== constants.LOCALE_ENGLISH ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                role: "button",
                                                href: languageUrl,
                                                rel: "noreferrer",
                                                "aria-label": (ref8 = findAStoreMob[4]) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.utilitynavheader) === null || ref9 === void 0 ? void 0 : ref9.languageLabel,
                                                className: "country-selector",
                                                onClick: ()=>{
                                                    setLanguageSwitcherUrl(true);
                                                },
                                                children: (ref10 = findAStoreMob[4]) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.utilitynavheader) === null || ref11 === void 0 ? void 0 : ref11.languageLabel
                                            }) : null,
                                            ((ref13 = findAStoreMob === null || findAStoreMob === void 0 ? void 0 : (ref12 = findAStoreMob[4]) === null || ref12 === void 0 ? void 0 : ref12.utilitynavheader[":items"]) === null || ref13 === void 0 ? void 0 : ref13.countryselector) && countryNavShow && /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_CountryUtilNav, {
                                                show: true,
                                                countryselector: (ref15 = (ref14 = findAStoreMob[4]) === null || ref14 === void 0 ? void 0 : ref14.utilitynavheader[":items"]) === null || ref15 === void 0 ? void 0 : ref15.countryselector,
                                                active: countryNavActive,
                                                eventHandler: eventHandler,
                                                toggleCountryNav: toggleCountryNav,
                                                datalayerPageName: datalayerPageName
                                            })
                                        ]
                                    })
                                ]
                            }) : null,
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                className: "gbh-nav__findStore mobile_none",
                                ...isOpen && !mainCategoryActive && !isRegionOpen && !isAuthNavOpen ? {
                                    style: style
                                } : {},
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                        role: "button",
                                        tabIndex: "0",
                                        "aria-live": "polite",
                                        "aria-labelledby": "find-ada",
                                        className: "gbh-data-layer gbh-nav__findStore--link cmp-find-place",
                                        onClick: ()=>toggleFindAStore(),
                                        children: [
                                            themeChange ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: iconLocation,
                                                alt: ""
                                            }) : null,
                                            ((ref16 = data[":items"]) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.store) === null || ref17 === void 0 ? void 0 : ref17.findStore) || "Find a Store"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_FindStoreUtilNav, {
                                        show: findAStoreShow,
                                        active: findAStoreActive,
                                        eventHandler: eventHandler,
                                        zipCodeContent: zipCodeContent
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                id: "country-ada",
                                style: displayNone,
                                children: [
                                    "Country Selector",
                                    " ",
                                    "United States" || (0),
                                    " -",
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                className: "gbh-nav__region region_arrowdropdown mobile_none",
                                id: "United States".toLowerCase().split(" ").join("_") || (data === null || data === void 0 ? void 0 : data.country.toLowerCase().split(" ").join("_")),
                                ...isOpen && !mainCategoryActive ? {
                                    style: style
                                } : {},
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                        role: "button",
                                        tabIndex: "0",
                                        "aria-labelledby": "country-ada",
                                        "aria-expanded": countryNavActive,
                                        onClick: ()=>{
                                            setRegionNav(true);
                                            toggleCountryNav();
                                        },
                                        className: "gbh-data-layer gbh-nav__region--link active-country ".concat(data.enableLanguageSwitcher ? "selected-country" : "", " ").concat(countryNavActive ? "expand" : ""),
                                        "data-gbh-data-layer": '{"clickInternalLinks":"true","internalLinkPosition":"global header","internalLinkZoneName":"'.concat(datalayerPageName, ':global header","internalLinkURL":"n/a","internalLinkName":"').concat((ref18 = "United States" || (0)) === null || ref18 === void 0 ? void 0 : ref18.toLowerCase(), " - ").concat((ref19 = (data === null || data === void 0 ? void 0 : data.language) || "EN") === null || ref19 === void 0 ? void 0 : ref19.toLowerCase(), '","eventName":"country select","internalLinkType":"global header : navigation","eventType":"click","eventAction":"country select"}'),
                                        children: [
                                            "United States" || (0),
                                            " -",
                                            " ",
                                            (data === null || data === void 0 ? void 0 : data.language) || "EN"
                                        ]
                                    }),
                                    data.enableLanguageSwitcher && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        role: "button",
                                        href: languageUrl,
                                        rel: "noreferrer",
                                        "aria-label": data.languageLabel,
                                        className: "country-selector",
                                        children: data.languageLabel
                                    }),
                                    ((ref20 = data[":items"]) === null || ref20 === void 0 ? void 0 : ref20.countryselector) && /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_CountryUtilNav, {
                                        show: countryNavShow,
                                        countryselector: (ref21 = data[":items"]) === null || ref21 === void 0 ? void 0 : ref21.countryselector,
                                        active: countryNavActive,
                                        eventHandler: eventHandler,
                                        toggleCountryNav: toggleCountryNav,
                                        datalayerPageName: datalayerPageName
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: "gbh-nav__signin mobile_none",
                                ...isOpen && !mainCategoryActive && !isRegionOpen ? {
                                    style: style
                                } : {},
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (UtilityWidgets_module_default()).utilityWidgetsWrapper,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        role: "list",
                                        className: "utility-widgets utility-widgets__brand-switcher",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_AuthUtilityNav, {
                                                show: authNavShow,
                                                active: authNavActive,
                                                toggleAuthNav: toggleAuthNav,
                                                setAuthNav: setAuthNav,
                                                onAuthMenuClick: onAuthMenuClick
                                            }),
                                            (winWidth > 1200 || themeChange) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        role: "listitem",
                                                        className: "wishlist-widget",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                                                            href: favoritesPagePath,
                                                            "aria-label": "View your wishlist",
                                                            className: "gbh-data-layer",
                                                            onClick: onClickSignIn,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                    alt: "View your wishlist",
                                                                    "aria-hidden": "true",
                                                                    role: "presentation",
                                                                    src: getSrc(themeChange, favoritesPage, iconFavoriteBlack, iconFavorite)
                                                                }),
                                                                themeChange ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    children: isSaveProductToList ? staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.myLists : staticTexts.favorites
                                                                }) : null
                                                            ]
                                                        })
                                                    }),
                                                    (data === null || data === void 0 ? void 0 : data.linkCart) && !themeChange && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        role: "listitem",
                                                        className: "cart-indicator-widget",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_MiniCart, {
                                                            eventHandler: eventHandler,
                                                            source: "from desk"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                })
            })
        })
    });
};
/* harmony default export */ var Shared_UtilityNavHeader = (UtilityNavHeader);

;// CONCATENATED MODULE: ./components/Shared/BrandHeaderFiller.jsx
/* provided dependency */ var process = __webpack_require__(83454);



// import cartEmptyIcon from "/icons/cart-icon-empty.svg"
const BrandHeaderFiller = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Shared_index_module_default()).utilityNavHeaderWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "utilitynavheader",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "gbh-utility-nav",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "gbh-utility-navbar",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                        role: "list",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: "gbh-nav__findStore",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    role: "button",
                                    tabIndex: 0,
                                    "aria-live": "polite",
                                    "aria-labelledby": "find-ada",
                                    className: "gbh-nav__findStore--link cmp-find-place",
                                    children: process.env.NEXT_PUBLIC_FIND_STORE_LABEL || "Find a Store"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: "gbh-nav__region region_arrowdropdown",
                                id: "United States" || 0,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                    role: "button",
                                    tabIndex: 0,
                                    "aria-labelledby": "country-ada",
                                    "aria-expanded": "false",
                                    className: "gbh-nav__region--link active-country ",
                                    children: [
                                        "United States" || 0,
                                        " -",
                                        " ",
                                        "EN" || 0
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: "gbh-nav__signin",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "UtilityWidgets_utilityWidgetsWrapper__Wz0ZS",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        role: "list",
                                        className: "utility-widgets utility-widgets__brand-switcher",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                role: "listitem",
                                                className: "auth-widget auth-widget__menu AuthUtilityNav_authUtilityNavWrapper__iJgYU",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "auth-nav",
                                                    "aria-expanded": "false",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            tabIndex: 0,
                                                            role: "button",
                                                            name: "avatarIcon",
                                                            "aria-label": "Sign In Collapsed",
                                                            src: "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTlweCIgaGVpZ2h0PSIyMHB4IiB2aWV3Qm94PSIwIDAgMTkgMjAiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+U2lnbiBJbiBJY29uPC90aXRsZT4KICAgIDxnIGlkPSJTeW1ib2xzIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0iTmF2aWdhdGlvbi9EZXNrdG9wL1V0aWxpdHktQmFyL0xvZ2dlZC1PdXQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMzkxLjAwMDAwMCwgLTEzLjAwMDAwMCkiIGZpbGw9IiNGRkZGRkYiPgogICAgICAgICAgICA8ZyBpZD0iVXRpbGl0eS1MaW5rcyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTExOC4wMDAwMDAsIDguMDAwMDAwKSI+CiAgICAgICAgICAgICAgICA8ZyBpZD0iU2lnbi1Jbi1JY29uIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyNzEuMDAwMDAwLCAwLjAwMDAwMCkiPgogICAgICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0xNiwxNy41IEMxOC40MTQyNzMzLDE3LjUgMjAuMzg0NDg5MSwxOS40MDEyMzY1IDIwLjQ5NTEwMiwyMS43ODgxNjQzIEwyMC41LDIyIEwyMC41LDI1IEwxOS41LDI1IEwxOS41LDIyIEMxOS41LDIwLjEzMTQzNjYgMTguMDM1NzIyNCwxOC42MDQ4NzM2IDE2LjE5MjAzNTIsMTguNTA1MTc4OSBMMTYsMTguNSBMNywxOC41IEM1LjEzMTQzNjYsMTguNSAzLjYwNDg3MzU1LDE5Ljk2NDI3NzYgMy41MDUxNzg4NiwyMS44MDc5NjQ4IEwzLjUsMjIgTDMuNSwyNSBMMi41LDI1IEwyLjUsMjIgQzIuNSwxOS41ODU3MjY3IDQuNDAxMjM2NTIsMTcuNjE1NTEwOSA2Ljc4ODE2NDMsMTcuNTA0ODk4IEw3LDE3LjUgTDE2LDE3LjUgWiBNMTEuNSw1LjUgQzE0LjI2MTQyMzcsNS41IDE2LjUsNy43Mzg1NzYyNSAxNi41LDEwLjUgQzE2LjUsMTMuMjYxNDIzNyAxNC4yNjE0MjM3LDE1LjUgMTEuNSwxNS41IEM4LjczODU3NjI1LDE1LjUgNi41LDEzLjI2MTQyMzcgNi41LDEwLjUgQzYuNSw3LjczODU3NjI1IDguNzM4NTc2MjUsNS41IDExLjUsNS41IFogTTExLjUsNi41IEM5LjI5MDg2MSw2LjUgNy41LDguMjkwODYxIDcuNSwxMC41IEM3LjUsMTIuNzA5MTM5IDkuMjkwODYxLDE0LjUgMTEuNSwxNC41IEMxMy43MDkxMzksMTQuNSAxNS41LDEyLjcwOTEzOSAxNS41LDEwLjUgQzE1LjUsOC4yOTA4NjEgMTMuNzA5MTM5LDYuNSAxMS41LDYuNSBaIj48L3BhdGg+CiAgICAgICAgICAgICAgICA8L2c+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPiA=",
                                                            alt: "Sign In"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "auth-nav__menu ",
                                                            "aria-hidden": "true"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                role: "listitem",
                                                className: "wishlist-widget",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    "aria-label": "View your wishlist",
                                                    className: "gbh-data-layer",
                                                    href: "",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        alt: "View your wishlist",
                                                        "aria-hidden": "true",
                                                        role: "presentation",
                                                        src: "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4NCjxzdmcgd2lkdGg9IjE1cHgiIGhlaWdodD0iMTRweCIgdmlld0JveD0iMCAwIDE1IDE0IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPg0KICAgIDx0aXRsZT5JY29uL1dpc2hsaXN0PC90aXRsZT4NCiAgICA8ZyBpZD0iU3ltYm9scyIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+DQogICAgICAgIDxnIGlkPSJCdXR0b24vSW1hZ2UtSWNvbnMvV2lzaGxpc3QtRW1wdHkvRGFyay1HcmF5LUJHIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTEuMDAwMDAwLCAtMTEuMDAwMDAwKSIgZmlsbD0iI0ZGRkZGRiI+DQogICAgICAgICAgICA8ZyBpZD0iSWNvbi9XaXNobGlzdCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTEuMDAwMDAwLCAzLjAwMDAwMCkiPg0KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik04LjE0MDYwNzE0LDkuNjg4NDgxOTcgTDcuNTAxLDEwLjMzNCBMNi44NjE1OTM2OSw5LjY4ODQ4MTk3IEM1LjI5MjQyMzUyLDguMTAzODM5MzQgMi43NDYyNDQ3OSw4LjEwMzgzOTM0IDEuMTc3MDc0NjMsOS42ODg0ODE5NyBDLTAuMzQ4NzgxOTU4LDExLjIyOTM4MzkgLTAuMzk2MjUxOTU5LDEzLjcxODU4MzQgMS4wNjQzMjIzNiwxNS4yOTcwNDQyIEwxLjE3MDcxODUyLDE1LjQwODU3MDcgTDcuNTAxMTEzNDQsMjEuODAxNTAzMyBMMTMuODA4NDgzOSwxNS40MzIxOTk4IEwxMy45MTUxODc4LDE1LjMyMTE0MDggQzE1LjM5NTU5NjgsMTMuNzIxNzEyNSAxNS4zNTM5NzAzLDExLjIzMjQwMSAxMy44MjUxMjYyLDkuNjg4NDgxOTcgQzEyLjI1NTk1Niw4LjEwMzgzOTM0IDkuNzA5Nzc3MzEsOC4xMDM4MzkzNCA4LjE0MDYwNzE0LDkuNjg4NDgxOTcgWiBNMTMuMTE0NTU4OSwxMC4zOTIxMTEzIEMxNC4yNjY2NjkyLDExLjU1NTU4MTYgMTQuMjk4MTAyMiwxMy40MzUzMTE1IDEzLjE4NzU0NTEsMTQuNjM1MjQ1MyBMMTMuMDkyNTIwMiwxNC43MzQxMDUzIEw3LjUwMSwyMC4zOCBMMS44ODc2NDE4OSwxNC43MTE0NzgzIEwxLjc5Mjk1NDA5LDE0LjYxMjE4MzEgQzAuNzAxOTMzNDQxLDEzLjQzMzAxMzYgMC43Mzc3ODAxMDEsMTEuNTUzMzExIDEuODg3NjQxODksMTAuMzkyMTExMyBDMy4wNjU1MDk0NSw5LjIwMjYyOTU4IDQuOTczMTU4ODcsOS4yMDI2Mjk1OCA2LjE1MTAyNjQyLDEwLjM5MjExMTMgTDcuNTAxMTAwNDIsMTEuNzU1NDk3NCBMOC44NTExNzQ0MSwxMC4zOTIxMTEzIEMxMC4wMjkwNDIsOS4yMDI2Mjk1OCAxMS45MzY2OTE0LDkuMjAyNjI5NTggMTMuMTE0NTU4OSwxMC4zOTIxMTEzIFoiIGlkPSJQYXRoIj48L3BhdGg+DQogICAgICAgICAgICA8L2c+DQogICAgICAgIDwvZz4NCiAgICA8L2c+DQo8L3N2Zz4="
                                                    })
                                                })
                                            }),
                                            process.env.NEXT_PUBLIC_DISABLE_CART_ICON === "true" ? "" : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                role: "listitem",
                                                className: "cart-indicator-widget",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "cart-indicator false",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        "aria-label": "View your cart containing 0 item",
                                                        role: "link",
                                                        className: "gbh-data-layer",
                                                        href: "/en/cart",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: "/icons/cart-icon-empty.svg",
                                                            alt: "Cart"
                                                        })
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                })
            })
        })
    });
};
/* harmony default export */ var Shared_BrandHeaderFiller = (BrandHeaderFiller);

;// CONCATENATED MODULE: ./components/Shared/CheckoutUtilityNavheader.jsx


const CheckoutUtilityNavHeader = (param)=>{
    let { data , eventHandler  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            role: "listitem",
            className: "cart-indicator-widget__checkout",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_MiniCart, {
                checkoutPage: data === null || data === void 0 ? void 0 : data.linkCart,
                eventHandler: eventHandler,
                source: "from desk"
            })
        })
    });
};
/* harmony default export */ var CheckoutUtilityNavheader = (CheckoutUtilityNavHeader);

;// CONCATENATED MODULE: ./components/Shared/BrandHeader.jsx









const BrandHeader = (props)=>{
    const { data , eventHandler  } = props;
    const { datalayerPageName  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const isSsr = (0,useIsSsr/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: data[":itemsOrder"].map((key, index)=>{
                const item = data[":items"][key];
                if (key === "brand_switcher" || key === "brand_switcher_copy") {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Shared_BrandSwitcher, {
                        data: item,
                        datalayerPageName: datalayerPageName
                    }, key);
                }
                if (key === "utilitynavheader" || key === "utilitynavheader_v2") {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                        children: isSsr ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Shared_BrandHeaderFiller, {}) : key === "utilitynavheader_v2" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckoutUtilityNavheader, {
                            data: item,
                            eventHandler: eventHandler
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Shared_UtilityNavHeader, {
                            data: item,
                            eventHandler: eventHandler
                        })
                    }, key);
                }
                return null;
            })
        })
    });
};
/* harmony default export */ var Shared_BrandHeader = (BrandHeader);

;// CONCATENATED MODULE: ./public/icons/BLOK_LOGO.svg
/* harmony default export */ var BLOK_LOGO = ({"src":"/_next/static/media/BLOK_LOGO.00edf835.svg","height":35,"width":115});
;// CONCATENATED MODULE: ./components/Shared/HeaderNavLogo.jsx






const HeaderNavLogo = (props)=>{
    var ref;
    const { data ={} , columnClassNames ="" , eventHandler: { store: { brandLogoImg =""  } = {} , callbacks: { setBrandLogoImg =()=>{} , toggleMenu =()=>{}  }  } , v3 , isOpen , ariaControls =""  } = props;
    const hamburgericon = "/icons/icon-Hamburger.svg";
    (0,react.useEffect)(()=>{
        setBrandLogoImg(BLOK_LOGO === null || BLOK_LOGO === void 0 ? void 0 : BLOK_LOGO.src);
    }, []);
    const toggleMenuCall = ()=>{
        (0,helper/* removeMavenoidChat */.N9B)();
        toggleMenu();
        (0,HeaderNavTabs_analytics/* hamburgerMenuDatalayer */.w_)();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "gbh-hamber-menu icon-Hamburger",
                tabIndex: "0",
                "aria-label": "Hamburger-menu",
                role: "button",
                onClick: toggleMenuCall,
                "aria-expanded": isOpen,
                "aria-controls": ariaControls,
                children: v3 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: hamburgericon,
                    alt: ""
                }) : null
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                role: "img",
                "aria-label": "The Bold Look of Kohler logo",
                tabIndex: "0",
                className: "cmp cmp-image ".concat((data === null || data === void 0 ? void 0 : data.appliedCssClassNames) ? data === null || data === void 0 ? void 0 : data.appliedCssClassNames : "", " ").concat(columnClassNames ? columnClassNames : ""),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    tabIndex: "-1",
                    href: data === null || data === void 0 ? void 0 : (ref = data.link) === null || ref === void 0 ? void 0 : ref.split("/content/kohler/us").join("").replace(".html", ""),
                    title: data === null || data === void 0 ? void 0 : data.alt,
                    className: "cmp-image--link",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                        children: brandLogoImg && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "".concat(brandLogoImg),
                            alt: data === null || data === void 0 ? void 0 : data.alt
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Shared_HeaderNavLogo = (HeaderNavLogo);

// EXTERNAL MODULE: ./components/core/Image/DynamicImage.jsx
var DynamicImage = __webpack_require__(18377);
// EXTERNAL MODULE: ./hooks/useSmartCrop.js
var useSmartCrop = __webpack_require__(83886);
;// CONCATENATED MODULE: ./components/Shared/ProductsNavTab.jsx












const ProductsNavTab = (props)=>{
    const { t  } = (0,esm/* useTranslation */.$G)();
    const { navOpen , setNavOpen , productNavigationItems , onClickNav , eventHandler: { store: { isOpen  }  } , datalayerPageName , selectedTab , hideMobImages , showMobileImages  } = props;
    const { locale , asPath  } = (0,next_router.useRouter)();
    const routerAsPath = "/" + locale + asPath;
    const [changePath, setChangePath] = (0,react.useState)();
    const [activeMainCategory, setActiveMainCategory] = (0,react.useState)("");
    const [activeSubCategory, setActiveSubCategory] = (0,react.useState)("");
    const isSsr = (0,useIsSsr/* default */.Z)();
    const smartCrop = (0,useSmartCrop/* default */.Z)();
    const onHoverMainCategory = (name)=>{
        setActiveMainCategory(name);
    };
    const onHoverSubCategory = (name)=>{
        setActiveSubCategory(name);
    };
    (0,react.useEffect)(()=>{
        setChangePath(routerAsPath);
    }, []);
    (0,react.useEffect)(()=>{
        if (!isOpen || !navOpen) {
            setActiveSubCategory("");
            setActiveMainCategory("");
        }
    }, [
        isOpen,
        navOpen
    ]);
    (0,react.useEffect)(()=>{
        if (changePath !== routerAsPath) {
            setNavOpen("");
            setChangePath(routerAsPath);
        }
    }, [
        routerAsPath
    ]);
    (0,react.useEffect)(()=>{
        if (productNavigationItems && activeMainCategory) {
            productNavigationItems.map((mainCategory, i)=>{
                if ((mainCategory === null || mainCategory === void 0 ? void 0 : mainCategory.categoryName) === activeMainCategory) {
                    const subCategoryDetails = mainCategory === null || mainCategory === void 0 ? void 0 : mainCategory.subCategoryDetails;
                    if (subCategoryDetails) {
                        const childItem = (subCategoryDetails === null || subCategoryDetails === void 0 ? void 0 : subCategoryDetails.childItems[0]) || null;
                        if (childItem) {
                            const activeSubCategory = (childItem === null || childItem === void 0 ? void 0 : childItem.subCategory) || null;
                            if (activeSubCategory) {
                                setActiveSubCategory(activeSubCategory);
                            }
                        }
                    }
                }
            });
        }
    }, [
        activeMainCategory,
        productNavigationItems
    ]);
    const handleOnClick = (item)=>{
        onHoverMainCategory(!(!(item === null || item === void 0 ? void 0 : item.categoryLinkRef) && (item === null || item === void 0 ? void 0 : item.categoryLink)) ? item === null || item === void 0 ? void 0 : item.categoryName : "");
        const prodnavsubmenu = document.querySelector(".gbh-global-tab .cmp-tabs");
        prodnavsubmenu === null || prodnavsubmenu === void 0 ? void 0 : prodnavsubmenu.scroll(0, 0);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        role: "tabpanel",
        tabIndex: "-1",
        className: "cmp-tabs__tabpanel ".concat(navOpen === t("kf.nav.label.products") ? "cmp-tabs__tabpanel--active" : ""),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "".concat(constants.staticClasses.CONTAINER),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "cmp-container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "aem-Grid aem-Grid--11 aem-Grid--default--11 ",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "globalnavigation aem-GridColumn aem-GridColumn--default--12",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "gbh-product-menu ".concat(hideMobImages ? "hide-mobile-images" : "", " ").concat(navOpen === t("kf.nav.label.products") ? "open" : ""),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "gbh-pro-menu__inner",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                            className: "flex-column gbh-pro-menu__list nav",
                                            role: "tablist",
                                            "aria-label": "list of 6",
                                            tabIndex: "0",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                    className: "gbh-mob-back-btn",
                                                    onClick: ()=>onClickNav({
                                                            "cq:panelTitle": navOpen
                                                        }),
                                                    children: "Menu"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "global-menu-selected",
                                                    children: t("kf.nav.label.products")
                                                }),
                                                productNavigationItems && productNavigationItems.map((item, index)=>{
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        className: "nav-item",
                                                        "data-tab": item === null || item === void 0 ? void 0 : item.categoryName,
                                                        role: "tab",
                                                        onClick: ()=>handleOnClick(item),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            className: "gbh-data-layer nav-link ".concat((item === null || item === void 0 ? void 0 : item.categoryName) === activeMainCategory ? "link-active" : ""),
                                                            "aria-hidden": "false",
                                                            "aria-label": item === null || item === void 0 ? void 0 : item.categoryName,
                                                            "data-gbh-data-layer": '{"clickInternalLinks":"true","internalLinkPosition":"global header","internalLinkZoneName":"'.concat(datalayerPageName).concat(datalayerPageName ? ":" : "", 'global header","internalLinkURL":"","internalLinkName":"products > ').concat(item === null || item === void 0 ? void 0 : item.categoryName.toLowerCase(), '","eventName":"main dropdown menu","internalLinkType":"global header:navigation","eventType":"global navigation","eventAction":"main dropdown menu"}'),
                                                            "data-hover": "tab",
                                                            "data-target": "#submenu".concat(item === null || item === void 0 ? void 0 : item.categoryName.toLowerCase().split(" ").join("-")),
                                                            "aria-controls": "submenu".concat(item === null || item === void 0 ? void 0 : item.categoryName.toLowerCase().split(" ").join("-")),
                                                            rel: "noreferrer",
                                                            role: "tab",
                                                            tabIndex: "0",
                                                            href: !(item === null || item === void 0 ? void 0 : item.categoryLinkRef) && (item === null || item === void 0 ? void 0 : item.categoryLink) ? (0,helper/* removeAndCleanLink */.xEh)(item === null || item === void 0 ? void 0 : item.categoryLink) : null,
                                                            "aria-selected": (item === null || item === void 0 ? void 0 : item.categoryLinkRef) ? "true" : "",
                                                            "aria-expanded": (item === null || item === void 0 ? void 0 : item.categoryLinkRef) ? "true" : "",
                                                            children: item === null || item === void 0 ? void 0 : item.categoryName
                                                        })
                                                    }, "productNavigation-".concat(index));
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "tab-content gbh-pro-menu__cont",
                                            children: productNavigationItems && productNavigationItems.map((mainCategory, i)=>{
                                                var ref, ref1;
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "tab-pane fade ".concat((mainCategory === null || mainCategory === void 0 ? void 0 : mainCategory.categoryName) === activeMainCategory ? "active show" : ""),
                                                    role: "tabpanel",
                                                    "aria-labelledby": mainCategory === null || mainCategory === void 0 ? void 0 : mainCategory.categoryName,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "cmp-container",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "aem-Grid aem-Grid--12 aem-Grid--default--12 ",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "globalnavigation-subcategory aem-GridColumn aem-GridColumn--default--12",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                                        className: "nav gbh-pro-collection gbh-two-column",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                                className: "gbh-mob-back-btn",
                                                                                onClick: ()=>onHoverMainCategory(""),
                                                                                children: t("kf.nav.label.products")
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                className: "global-menu-selected sub-cat-select",
                                                                                children: mainCategory === null || mainCategory === void 0 ? void 0 : mainCategory.categoryName
                                                                            }),
                                                                            (mainCategory === null || mainCategory === void 0 ? void 0 : mainCategory.subCategoryDetails) && (mainCategory === null || mainCategory === void 0 ? void 0 : (ref = mainCategory.subCategoryDetails) === null || ref === void 0 ? void 0 : ref.childItems.map((subCategory, j)=>{
                                                                                var ref, ref1;
                                                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                                    className: "nav-item gbh-pro-collection__category-link",
                                                                                    onMouseOver: ()=>{
                                                                                        return onHoverSubCategory(subCategory === null || subCategory === void 0 ? void 0 : subCategory.subCategory);
                                                                                    },
                                                                                    children: routerAsPath === (0,helper/* removeAndCleanLink */.xEh)(subCategory === null || subCategory === void 0 ? void 0 : subCategory.subLink) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                        "data-purelink": "true",
                                                                                        href: (0,helper/* removeAndCleanLink */.xEh)(subCategory === null || subCategory === void 0 ? void 0 : subCategory.subLink),
                                                                                        className: "gbh-data-layer nav-link",
                                                                                        id: "pills-".concat(mainCategory === null || mainCategory === void 0 ? void 0 : mainCategory.categoryName.split(" ").join("-"), "-").concat(subCategory === null || subCategory === void 0 ? void 0 : subCategory.subCategory.split(" ").join("-"), "-tab"),
                                                                                        "aria-hidden": "false",
                                                                                        "aria-label": "tab ".concat(j, " of ").concat(mainCategory === null || mainCategory === void 0 ? void 0 : (ref = mainCategory.subCategoryDetails) === null || ref === void 0 ? void 0 : ref.childItems.length, " Collections"),
                                                                                        "data-hover": "tab",
                                                                                        tabIndex: "0",
                                                                                        target: "_self",
                                                                                        "data-target": "#".concat(subCategory === null || subCategory === void 0 ? void 0 : subCategory.subCategory.split(" ").join("-")).concat(mainCategory === null || mainCategory === void 0 ? void 0 : mainCategory.categoryName.toLowerCase().split(" ").join("-")),
                                                                                        role: "link",
                                                                                        "aria-controls": "pills-".concat(subCategory === null || subCategory === void 0 ? void 0 : subCategory.subCategory.split(" ").join("-")),
                                                                                        "data-gbh-data-layer": '{"clickInternalLinks":"true","internalLinkPosition":"global header","internalLinkZoneName":"'.concat(datalayerPageName).concat(datalayerPageName ? ":" : "", 'global header","internalLinkURL":"').concat((0,helper/* removeAndCleanLink */.xEh)(subCategory === null || subCategory === void 0 ? void 0 : subCategory.subLink), '","internalLinkName":" ').concat(selectedTab, " > ").concat(mainCategory === null || mainCategory === void 0 ? void 0 : mainCategory.categoryName.toLowerCase().split(" ").join("-"), " > ").concat(subCategory === null || subCategory === void 0 ? void 0 : subCategory.subCategory.split(" ").join("-"), '","eventName":"main dropdown menu","internalLinkType":"global header:navigation","eventType":"global navigation","eventAction":"main dropdown menu"}'),
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                            className: "nav-link",
                                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                                dangerouslySetInnerHTML: {
                                                                                                    __html: browser_default().sanitize(subCategory === null || subCategory === void 0 ? void 0 : subCategory.subCategory)
                                                                                                }
                                                                                            })
                                                                                        })
                                                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                                        href: (0,helper/* removeAndCleanLink */.xEh)(subCategory === null || subCategory === void 0 ? void 0 : subCategory.subLink),
                                                                                        className: "gbh-data-layer nav-link",
                                                                                        id: "pills-".concat(mainCategory === null || mainCategory === void 0 ? void 0 : mainCategory.categoryName.split(" ").join("-"), "-").concat(subCategory === null || subCategory === void 0 ? void 0 : subCategory.subCategory.split(" ").join("-"), "-tab"),
                                                                                        "aria-hidden": "false",
                                                                                        "aria-label": "tab ".concat(j, " of ").concat(mainCategory === null || mainCategory === void 0 ? void 0 : (ref1 = mainCategory.subCategoryDetails) === null || ref1 === void 0 ? void 0 : ref1.childItems.length, " Collections"),
                                                                                        "data-hover": "tab",
                                                                                        tabIndex: "0",
                                                                                        target: "_self",
                                                                                        "data-target": "#".concat(subCategory === null || subCategory === void 0 ? void 0 : subCategory.subCategory.split(" ").join("-")).concat(mainCategory === null || mainCategory === void 0 ? void 0 : mainCategory.categoryName.toLowerCase().split(" ").join("-")),
                                                                                        role: "link",
                                                                                        "aria-controls": "pills-".concat(subCategory === null || subCategory === void 0 ? void 0 : subCategory.subCategory.split(" ").join("-")),
                                                                                        "data-gbh-data-layer": '{"clickInternalLinks":"true","internalLinkPosition":"global header","internalLinkZoneName":"'.concat(datalayerPageName).concat(datalayerPageName ? ":" : "", 'global header","internalLinkURL":"').concat((0,helper/* removeAndCleanLink */.xEh)(subCategory === null || subCategory === void 0 ? void 0 : subCategory.subLink), '","internalLinkName":" ').concat(selectedTab, " > ").concat(mainCategory === null || mainCategory === void 0 ? void 0 : mainCategory.categoryName.toLowerCase().split(" ").join("-"), " > ").concat(subCategory === null || subCategory === void 0 ? void 0 : subCategory.subCategory.split(" ").join("-"), '","eventName":"main dropdown menu","internalLinkType":"global header:navigation","eventType":"global navigation","eventAction":"main dropdown menu"}'),
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                            className: "nav-link",
                                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                                dangerouslySetInnerHTML: {
                                                                                                    __html: browser_default().sanitize(subCategory === null || subCategory === void 0 ? void 0 : subCategory.subCategory)
                                                                                                }
                                                                                            })
                                                                                        })
                                                                                    })
                                                                                }, "subCategory-".concat(j));
                                                                            }))
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "tab-content gbh-pro-collection-cont gbh-two-column",
                                                                        children: (mainCategory === null || mainCategory === void 0 ? void 0 : mainCategory.subCategoryDetails) && (mainCategory === null || mainCategory === void 0 ? void 0 : (ref1 = mainCategory.subCategoryDetails) === null || ref1 === void 0 ? void 0 : ref1.childItems.map((subCategory, j)=>{
                                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                className: "tab-pane fade gbh-mob-col ".concat((subCategory === null || subCategory === void 0 ? void 0 : subCategory.subCategory) === activeSubCategory ? "active show" : ""),
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                                    href: (0,helper/* removeAndCleanLink */.xEh)(subCategory === null || subCategory === void 0 ? void 0 : subCategory.subLink),
                                                                                    className: "gbh-data-layer",
                                                                                    "data-gbh-data-layer": '{"clickInternalLinks":"true","internalLinkPosition":"global header","internalLinkZoneName":"'.concat(datalayerPageName).concat(datalayerPageName ? ":" : "", 'global header","internalLinkURL":"').concat((0,helper/* removeAndCleanLink */.xEh)(subCategory === null || subCategory === void 0 ? void 0 : subCategory.subLink), '","internalLinkName":" > ').concat(mainCategory === null || mainCategory === void 0 ? void 0 : mainCategory.categoryName.toLowerCase().split(" ").join("-"), " > ").concat(subCategory === null || subCategory === void 0 ? void 0 : subCategory.subCategory.split(" ").join("-"), '","eventName":"main dropdown menu","internalLinkType":"global header:navigation","eventType":"global navigation","eventAction":"main dropdown menu"}'),
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                            className: "hello gbh-subcattext",
                                                                                            children: (0,helper/* sanitizeInnerHtml */.KD0)(subCategory === null || subCategory === void 0 ? void 0 : subCategory.subCategory)
                                                                                        }),
                                                                                        showMobileImages && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                            className: "cmp-image",
                                                                                            children: [
                                                                                                smartCrop.scriptStatus && !isSsr ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicImage["default"], {
                                                                                                    imgUrl: subCategory === null || subCategory === void 0 ? void 0 : subCategory.sceneSevenImage,
                                                                                                    alt: subCategory === null || subCategory === void 0 ? void 0 : subCategory.imageAlt,
                                                                                                    className: "cmp-image__image with-crop",
                                                                                                    uniqueId: "subcatImage-".concat(j)
                                                                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                                                    src: subCategory === null || subCategory === void 0 ? void 0 : subCategory.sceneSevenImage,
                                                                                                    alt: subCategory === null || subCategory === void 0 ? void 0 : subCategory.imageAlt,
                                                                                                    className: "cmp-image__image without-crop"
                                                                                                }, "subcatImage-".concat(j)),
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                                    dangerouslySetInnerHTML: {
                                                                                                        __html: browser_default().sanitize(subCategory === null || subCategory === void 0 ? void 0 : subCategory.description)
                                                                                                    }
                                                                                                })
                                                                                            ]
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            }, "subcatInfo-".concat(j));
                                                                        }))
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    })
                                                }, "mainCategory-".concat(i));
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "gbh-promenu-close-btn icon-Close-Large",
                                            "aria-label": "close",
                                            role: "button",
                                            tabIndex: "0",
                                            onClick: ()=>{
                                                setNavOpen("");
                                                setActiveMainCategory("");
                                                setActiveSubCategory();
                                                (0,helper/* preventBodyScrollTab */.aCP)(false);
                                                (0,HeaderNavTabs_analytics/* addAnalyticsOnClose */.hJ)();
                                            }
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "productbg ".concat(navOpen === t("kf.nav.label.products") ? "open" : "")
                            })
                        ]
                    })
                })
            })
        })
    });
};
/* harmony default export */ var Shared_ProductsNavTab = (ProductsNavTab);

;// CONCATENATED MODULE: ./components/Shared/HeaderNavTabs/index.jsx











const HeaderNavTabs = (props)=>{
    const { data , columnClassNames , eventHandler , eventHandler: { store: { isOpen  } , callbacks: { toggleMenu =()=>{} , setMainCategory =()=>{}  }  } , wrapperId =""  } = props;
    const { pageIsInteractive , datalayerPageName  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const [productNavigationItems, setProductNavigationItems] = (0,react.useState)(null);
    const [hideMobImages, setHideMobImages] = (0,react.useState)(false);
    const [navOpen, setNavOpen] = (0,react.useState)("");
    const [selectedTab, setTab] = (0,react.useState)("");
    const menuVisible = (0,react.useRef)(0);
    const [showMobileImages, setShowMobileImages] = (0,react.useState)(true);
    const dataRecursion = (0,react.useCallback)((data)=>{
        const { mainNavigation , categoryItems , hideMobileImages  } = data;
        if (data && mainNavigation === "Products") {
            setProductNavigationItems(categoryItems);
            setHideMobImages(hideMobileImages);
        }
        if (data && data[":itemsOrder"]) {
            data[":itemsOrder"].map((key, index)=>{
                const item = data[":items"][key];
                return dataRecursion(item);
            });
        }
    }, []);
    (0,react.useEffect)(()=>{
        if (lib/* isMobile */.tq && hideMobImages) {
            setShowMobileImages(false);
        } else {
            setShowMobileImages(true);
        }
    }, [
        hideMobImages,
        lib/* isMobile */.tq
    ]);
    const onClickNav = (data)=>{
        if (selectedTab !== data["cq:panelTitle"]) {
            setTab(data["cq:panelTitle"]);
        }
        if (navOpen !== data["cq:panelTitle"]) {
            setNavOpen(data["cq:panelTitle"]);
            if (!lib/* isMobile */.tq) {
                setNavOpen(data["cq:panelTitle"]);
            }
            setMainCategory({
                item: data["cq:panelTitle"]
            });
            menuVisible.current = 1;
            (0,helper/* preventBodyScrollTab */.aCP)(true);
            addHeaderNavTabAnalytics(data);
        } else {
            setNavOpen("");
            setTab("");
            setMainCategory({
                item: ""
            });
            menuVisible.current = 0;
            (0,helper/* preventBodyScrollTab */.aCP)(false);
        }
    };
    const addHeaderNavTabAnalytics = (data)=>{
        const eventInfo = {
            eventAction: "global header:".concat(data["cq:panelTitle"].toLowerCase()),
            eventName: "global header:".concat(data["cq:panelTitle"].toLowerCase()),
            eventType: "tab",
            internalLinkName: data["cq:panelTitle"].toLowerCase(),
            internalLinkPosition: "global header",
            internalLinkType: "global navigation",
            internalLinkZoneName: "global header",
            internalLinkURL: "n/a",
            clickInternalLinks: "true"
        };
        const page = window.pageObj || {};
        window.adobeDataLayer.push({
            event: "cmp:click",
            page,
            eventInfo
        });
    };
    const onMenuClickEvent = (e)=>{
        var ref, ref1, ref2, ref3, ref4;
        if (((e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : (ref1 = ref.classList) === null || ref1 === void 0 ? void 0 : ref1.contains("gbh-pro-menu__inner")) || (e === null || e === void 0 ? void 0 : (ref2 = e.target) === null || ref2 === void 0 ? void 0 : ref2.closest(".gbh-pro-menu__inner")) === null && (e === null || e === void 0 ? void 0 : (ref3 = e.target) === null || ref3 === void 0 ? void 0 : ref3.closest(".gbh-full-w-menu__inner")) === null && (e === null || e === void 0 ? void 0 : (ref4 = e.target) === null || ref4 === void 0 ? void 0 : ref4.closest(".cmp-tabs__tablist")) === null && !lib/* isMobile */.tq) && menuVisible.current) {
            setNavOpen("");
            setTab("");
            setMainCategory({
                item: ""
            });
            menuVisible.current = 0;
            (0,helper/* preventBodyScrollTab */.aCP)(false);
        }
    };
    (0,react.useEffect)(()=>{
        if (navOpen) {
            document.addEventListener("click", onMenuClickEvent);
        } else {
            document.removeEventListener("click", onMenuClickEvent);
        }
        return ()=>document.removeEventListener("click", onMenuClickEvent);
    }, [
        navOpen
    ]);
    (0,react.useEffect)(()=>{
        dataRecursion(data);
    }, [
        data,
        dataRecursion
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "tabs ".concat((data === null || data === void 0 ? void 0 : data.appliedCssClassNames) ? data === null || data === void 0 ? void 0 : data.appliedCssClassNames : "", " ").concat(columnClassNames ? columnClassNames : "", " ").concat(isOpen ? "open" : ""),
        id: wrapperId,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "cmp-tabs",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: "gbh-hamber-menu gbh-close icon-Close-Medium",
                    "aria-label": "close button",
                    tabIndex: "0",
                    onClick: ()=>{
                        toggleMenu();
                        onClickNav({
                            "cq:panelTitle": navOpen
                        });
                        (0,HeaderNavTabs_analytics/* addAnalyticsOnClose */.hJ)();
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ol", {
                    role: "tablist",
                    className: "cmp-tabs__tablist",
                    "aria-multiselectable": "false",
                    children: [
                        data[":itemsOrder"] && data[":itemsOrder"].map((key, index)=>{
                            const item = data[":items"][key];
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                role: "tab",
                                className: "cmp-tabs__tab ".concat(selectedTab === item["cq:panelTitle"] ? "cmp-tabs__tab--active" : ""),
                                tabIndex: "0",
                                onClick: ()=>onClickNav(item),
                                children: item["cq:panelTitle"]
                            }, "navItem-".concat(index));
                        }),
                        (data === null || data === void 0 ? void 0 : data.mainTabId) && Object.keys(data === null || data === void 0 ? void 0 : data.mainTabId).map((key, index)=>{
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                role: "tab",
                                className: "cmp-tabs__tab",
                                tabIndex: "0",
                                children: key
                            }, "navItem-".concat(index));
                        })
                    ]
                }),
                pageIsInteractive && /*#__PURE__*/ (0,jsx_runtime.jsx)(Shared_ProductsNavTab, {
                    productNavigationItems: productNavigationItems,
                    navOpen: navOpen,
                    setNavOpen: (data)=>setNavOpen(data),
                    onClickNav: onClickNav,
                    isOpen: isOpen,
                    eventHandler: eventHandler,
                    datalayerPageName: datalayerPageName,
                    selectedTab: selectedTab,
                    hideMobImages: hideMobImages,
                    showMobileImages: showMobileImages
                }),
                data[":itemsOrder"] && data[":itemsOrder"].map((key, index)=>{
                    var ref;
                    const items = data[":items"][key];
                    const item = (ref = items[":items"]) === null || ref === void 0 ? void 0 : ref.globalnavigation;
                    if ((item === null || item === void 0 ? void 0 : item.mainNavigation) === "drawer" && navOpen === items["cq:panelTitle"]) {
                        var ref1, ref2, ref3, ref4;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            role: "tabpanel",
                            tabIndex: "-1",
                            className: "cmp-tabs__tabpanel ".concat(navOpen === items["cq:panelTitle"] ? "cmp-tabs__tabpanel--active" : ""),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat(constants.staticClasses.CONTAINER),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "cmp-container",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "aem-Grid aem-Grid--11 aem-Grid--default--11 ",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "globalnavigation aem-GridColumn aem-GridColumn--default--11",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "gbh-full-w-menu",
                                                    style: {
                                                        transition: "all 2s ease 0s"
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "bg-dim",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "gbh-full-w-menu__inner",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "gbh-full-max-width",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "gbh-full-w-menu__left-cont",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "gbh-full-w-menu__left-cont__top",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                    className: "gbh-full-w-menu__left-cont__top__cont",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                            dangerouslySetInnerHTML: {
                                                                                                __html: browser_default().sanitize(item.mainTitle)
                                                                                            }
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                            className: "gbh-full-w-menu__left-cont__description",
                                                                                            style: {
                                                                                                transition: "none 0s ease 0s"
                                                                                            },
                                                                                            dangerouslySetInnerHTML: {
                                                                                                __html: browser_default().sanitize(item.description)
                                                                                            }
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                                                    className: "nav flex-column gbh-full-w-menu__left-cont__menu-list",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                                            className: "gbh-mob-back-btn",
                                                                                            onClick: ()=>onClickNav({
                                                                                                    "cq:panelTitle": navOpen
                                                                                                }),
                                                                                            children: "Menu"
                                                                                        }),
                                                                                        item === null || item === void 0 ? void 0 : (ref1 = item.drawerItems) === null || ref1 === void 0 ? void 0 : ref1.map((navItem, index)=>{
                                                                                            var ref, ref1, ref2;
                                                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                                                className: "nav-item ",
                                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                                                    className: "gbh-data-layer nav-link".concat((navItem === null || navItem === void 0 ? void 0 : navItem.subNavLinkRef) ? " extranal-sub-nav" : "", " "),
                                                                                                    target: "".concat(navItem.newTab ? "_blank" : "_self"),
                                                                                                    href: (ref = navItem.subNavLink) === null || ref === void 0 ? void 0 : ref.split("/content/kohler/us").join("").replace(".html", ""),
                                                                                                    "data-gbh-data-layer": '{"clickInternalLinks":"'.concat((navItem === null || navItem === void 0 ? void 0 : navItem.subNavLinkRef) ? "false" : "true", '","internalLinkPosition":"global header","internalLinkZoneName":"').concat(datalayerPageName).concat(datalayerPageName ? ":" : "", 'global header","internalLinkURL":"').concat(navItem === null || navItem === void 0 ? void 0 : (ref1 = navItem.subNavLink) === null || ref1 === void 0 ? void 0 : ref1.split("/content/kohler/us").join("").replace(".html", ""), '","internalLinkName":"').concat((ref2 = items["cq:panelTitle"]) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase(), " > ").concat(navItem === null || navItem === void 0 ? void 0 : navItem.subNavName.toLowerCase(), '","eventName":"main dropdown  menu","internalLinkType":"global header:navigation","eventType":"global navigation","eventAction":"main dropdown menu"}'),
                                                                                                    rel: "".concat((navItem === null || navItem === void 0 ? void 0 : navItem.subNavLinkRef) ? "noreferrer" : ""),
                                                                                                    "data-hover": "tab",
                                                                                                    role: "link",
                                                                                                    children: [
                                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                                            dangerouslySetInnerHTML: {
                                                                                                                __html: browser_default().sanitize(navItem.subNavName)
                                                                                                            }
                                                                                                        }),
                                                                                                        (navItem === null || navItem === void 0 ? void 0 : navItem.subNavLinkRef) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                                            className: "sub-cat-img",
                                                                                                            children: (item === null || item === void 0 ? void 0 : item.externalIconCheckbox) && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                                                                src: item === null || item === void 0 ? void 0 : item.externalIcon,
                                                                                                                alt: "external link",
                                                                                                                href: navItem.subNavLink
                                                                                                            })
                                                                                                        })
                                                                                                    ]
                                                                                                })
                                                                                            }, "navItem-".concat(index));
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "gbh-full-w-menu__right-img",
                                                                        children: (item === null || item === void 0 ? void 0 : (ref2 = item.drawerImage) === null || ref2 === void 0 ? void 0 : ref2.imageUrl) && /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicImage["default"], {
                                                                            imgUrl: item === null || item === void 0 ? void 0 : (ref3 = item.drawerImage) === null || ref3 === void 0 ? void 0 : ref3.imageUrl,
                                                                            className: "cmp-image__image",
                                                                            alt: item === null || item === void 0 ? void 0 : (ref4 = item.drawerImage) === null || ref4 === void 0 ? void 0 : ref4.imageAlt
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "productbg"
                                                })
                                            ]
                                        })
                                    })
                                })
                            })
                        }, "navTabs-".concat(index));
                    }
                })
            ]
        })
    });
};
/* harmony default export */ var Shared_HeaderNavTabs = (HeaderNavTabs);

// EXTERNAL MODULE: ./components/Shared/UtilityWidgets/v1/UtilityWidgets.jsx
var UtilityWidgets = __webpack_require__(55938);
// EXTERNAL MODULE: ./node_modules/lodash/throttle.js
var throttle = __webpack_require__(23493);
var throttle_default = /*#__PURE__*/__webpack_require__.n(throttle);
// EXTERNAL MODULE: ./components/Shared/HeaderNavTabs/index.module.scss
var HeaderNavTabs_index_module = __webpack_require__(52498);
var HeaderNavTabs_index_module_default = /*#__PURE__*/__webpack_require__.n(HeaderNavTabs_index_module);
;// CONCATENATED MODULE: ./components/Shared/HeaderNavTabs/HeaderNavTabsV3/index.jsx












const TabPanel = dynamic_default()(()=>__webpack_require__.e(/* import() */ 2183).then(__webpack_require__.bind(__webpack_require__, 32183)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(32183)
            ]
    },
    ssr: false
});
const HeaderNavTabsV3 = (props)=>{
    const { data , columnClassNames ="" , eventHandler: { store: { isOpen  } , callbacks: { toggleMenu =()=>{} , setMainCategory =()=>{}  }  } , wrapperId =""  } = props || {};
    const element = data[":items"];
    const isMobile =  true && window.innerWidth <= 1200;
    const iconCloseMedium = "/icons/close-medium.svg";
    const [navOpen, setNavOpen] = (0,react.useState)("");
    const smartCrop = (0,useSmartCrop/* default */.Z)();
    const [selectedTab, setSelectedTab] = (0,react.useState)("");
    const [darkThemeFlag, setDarkThemeFlag] = (0,react.useState)(false);
    const [activeIndex, setActiveIndex] = (0,react.useState)(null);
    const [selectedId, setSelectedId] = (0,react.useState)(null);
    const [selectedNavTabIndex, setSelectedNavTabIndex] = (0,react.useState)(null);
    const [showTab, setShowTab] = (0,react.useState)(false);
    const { globalConfig ={}  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const { general: { navigationHoverTiming =""  } = {}  } = globalConfig;
    let timerout;
    let timerout2;
    const menuVisible = (0,react.useRef)(0);
    const dataRecursion = (0,react.useCallback)((data)=>{
        if (data === null || data === void 0 ? void 0 : data[":itemsOrder"]) {
            var ref;
            data === null || data === void 0 ? void 0 : (ref = data[":itemsOrder"]) === null || ref === void 0 ? void 0 : ref.map((key, index)=>{
                const item = element[key];
                return dataRecursion(item);
            });
        }
    }, []);
    const onClickNav = (data, str, navTabIndex)=>{
        if (data) {
            if (selectedTab !== data["cq:panelTitle"]) {
                setSelectedTab(data["cq:panelTitle"]);
            }
            if (navOpen !== data["cq:panelTitle"]) {
                setNavOpen(data["cq:panelTitle"]);
                if (!isMobile) {
                    setNavOpen(data["cq:panelTitle"]);
                }
                setMainCategory({
                    item: data["cq:panelTitle"]
                });
                menuVisible.current = 1;
                (0,helper/* preventBodyScrollTab */.aCP)(true);
                // setSelectedNavTabIndex(null)
                setActiveIndex(null);
                setSelectedId(null);
                if (str === "title click") {
                    setShowTab(true);
                    setSelectedNavTabIndex(navTabIndex);
                }
                isMobile && str === "title click mob" && (0,HeaderNavTabs_analytics/* l1DatalayerclickMobile */.bL)(data["cq:panelTitle"]);
            } else {
                str === "mobile back btn" && (0,HeaderNavTabs_analytics/* backClickForMobile */.Ps)(selectedTab);
                setShowTab(false);
                setNavOpen("");
                setSelectedTab("");
                setMainCategory({
                    item: ""
                });
                menuVisible.current = 0;
                (0,helper/* preventBodyScrollTab */.aCP)(false);
            }
        }
    };
    const handleEnterClickForTab = (e)=>{
        if (e.keyCode === 13) {
            setTimeout(()=>onClickNav(element[e.target.id]), 50);
        }
    };
    const handleAccordionClick = (index, id, navTabIndex)=>{
        setActiveIndex(activeIndex === index && selectedId === id ? null : index);
        setSelectedId(selectedId === id && activeIndex === index ? null : id);
        setSelectedNavTabIndex(selectedNavTabIndex === navTabIndex ? null : navTabIndex);
    };
    const levelOneLengthsArray = [];
    const handleMouseLeave = ()=>{
        setNavOpen("");
        setSelectedTab("");
        setMainCategory({
            item: ""
        });
        menuVisible.current = 0;
        (0,helper/* preventBodyScrollTab */.aCP)(false);
    };
    const onMenuClickEvent = (e)=>{
        var ref, ref1, ref2, ref3, ref4;
        if (((e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : (ref1 = ref.classList) === null || ref1 === void 0 ? void 0 : ref1.contains("gbh-pro-menu__inner")) || (e === null || e === void 0 ? void 0 : (ref2 = e.target) === null || ref2 === void 0 ? void 0 : ref2.closest(".gbh-pro-menu__inner")) === null && (e === null || e === void 0 ? void 0 : (ref3 = e.target) === null || ref3 === void 0 ? void 0 : ref3.closest(".gbh-full-w-menu__inner")) === null && (e === null || e === void 0 ? void 0 : (ref4 = e.target) === null || ref4 === void 0 ? void 0 : ref4.closest(".cmp-tabs__tablist")) === null && !isMobile) && menuVisible.current) {
            setNavOpen("");
            setSelectedTab("");
            setMainCategory({
                item: ""
            });
            menuVisible.current = 0;
            (0,helper/* preventBodyScrollTab */.aCP)(false);
        }
    };
    (0,react.useEffect)(()=>{
        const anchorElements = document.querySelectorAll(".gbh-full-w-menu__inner a:not([href])");
        anchorElements === null || anchorElements === void 0 ? void 0 : anchorElements.forEach((anchor)=>{
            anchor.style.textDecoration = "none";
            anchor.style.cursor = "default";
        });
        if (levelOneLengthsArray[selectedNavTabIndex] !== -1) {
            setActiveIndex(levelOneLengthsArray[selectedNavTabIndex]);
            setSelectedId(levelOneLengthsArray[selectedNavTabIndex]);
        }
    }, []);
    (0,react.useEffect)(()=>{
        var ref, ref1, ref2, ref3;
        if (document === null || document === void 0 ? void 0 : (ref = document.getElementsByTagName) === null || ref === void 0 ? void 0 : (ref1 = ref.call(document, "body")) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.className) === null || ref3 === void 0 ? void 0 : ref3.includes("nav-dark-theme")) {
            setDarkThemeFlag(true);
        }
    }, []);
    (0,react.useEffect)(()=>{
        if (navOpen) {
            document.addEventListener("click", onMenuClickEvent);
        } else {
            document.removeEventListener("click", onMenuClickEvent);
        }
        return ()=>document.removeEventListener("click", onMenuClickEvent);
    }, [
        navOpen
    ]);
    (0,react.useEffect)(()=>{
        dataRecursion(data);
    }, [
        data,
        dataRecursion
    ]);
    const getInternalLinkURLS = (url)=>{
        if (true) {
            return !((url === null || url === void 0 ? void 0 : url.startsWith("/")) || (url === null || url === void 0 ? void 0 : url.includes(window.location.hostname)) || url === null);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        id: "HEADER ID",
        className: (HeaderNavTabs_index_module_default()).headerNavV3Wrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "tabs ".concat((data === null || data === void 0 ? void 0 : data.appliedCssClassNames) ? data === null || data === void 0 ? void 0 : data.appliedCssClassNames : "gbh-global-tab", " ").concat(columnClassNames, " ").concat(isOpen ? "open" : ""),
            id: wrapperId,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "cmp-tabs ".concat(darkThemeFlag ? "dark-theme" : "light-theme"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "gbh-hamber-menu gbh-close icon-Close-Medium",
                        "aria-label": "close button",
                        tabIndex: "0",
                        onClick: ()=>{
                            toggleMenu();
                            isMobile && (0,HeaderNavTabs_analytics/* closeButtonDatalayer */.zw)(selectedTab);
                            onClickNav({
                                "cq:panelTitle": navOpen
                            });
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: iconCloseMedium,
                            alt: ""
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ol", {
                        onMouseOver: (timerout)=>{
                            timerout = setTimeout(()=>{
                                !isMobile ? (event)=>{
                                    onClickNav(element[event.target.id]);
                                } : null;
                            }, navigationHoverTiming);
                        },
                        onClick: !isMobile ? (event)=>{
                            onClickNav(element[event.target.id]);
                        } : null,
                        onMouseLeave: ()=>{
                            clearTimeout(timerout);
                            !isMobile ? handleMouseLeave : null;
                        },
                        role: "tablist",
                        className: "cmp-tabs__tablist",
                        "aria-multiselectable": "false",
                        children: [
                            data[":itemsOrder"] && data[":itemsOrder"].map((key, navTabIndex)=>{
                                var ref, ref1;
                                const itemType = element[key];
                                const item = ((ref = itemType[":items"]) === null || ref === void 0 ? void 0 : ref.globalnavigation) || itemType[":items"][(ref1 = Object.keys(itemType[":items"])) === null || ref1 === void 0 ? void 0 : ref1.find((key)=>key.includes("globalnavigation_v3"))];
                                const { firstImagesblock ={} , secondImagesblock ={} , navigationMenuType: menuType = "" , navTitle ="" , levelOneNavMulti =[] , multiCTA =[]  } = item || {};
                                levelOneLengthsArray.push((0,HeaderNavTabs_utils/* checkSingleNonEmptyLevelThreeNavMulti */.JI)(levelOneNavMulti));
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "tab-panel-container ".concat((0,HeaderNavTabs_utils/* pureTextWithoutSpace */.TX)(itemType["cq:panelTitle"])),
                                    "aria-expanded": navOpen === itemType["cq:panelTitle"],
                                    style: {
                                        display: "flex",
                                        flexDirection: "column"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            onMouseOver: (event)=>{
                                                timerout2 = setTimeout(()=>{
                                                    !isMobile ? onClickNav(element[event.target.id], "title click mob") : null;
                                                }, navigationHoverTiming);
                                            },
                                            onMouseLeave: ()=>{
                                                clearTimeout(timerout2);
                                            },
                                            "aria-label": "Tab for ".concat(itemType["cq:panelTitle"], "  ").concat(navOpen === itemType["cq:panelTitle"] ? "expanded" : "collapsed"),
                                            id: key,
                                            onClick: (event)=>onClickNav(element[event.target.id], "title click", navTabIndex),
                                            onFocus: !isMobile ? ()=>{
                                                setNavOpen("");
                                            } : null,
                                            onFocusCapture: !isMobile ? ()=>setNavOpen("") : null,
                                            onKeyDown: (e)=>handleEnterClickForTab(e),
                                            role: "link",
                                            className: "cmp-tabs__tab ".concat(navOpen === itemType["cq:panelTitle"] ? "cmp-tabs__tab--active" : ""),
                                            tabIndex: "0",
                                            children: itemType["cq:panelTitle"]
                                        }, "navItem-".concat(navTabIndex)),
                                        !isMobile || isMobile && showTab ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TabPanel, {
                                            firstImagesblock: firstImagesblock,
                                            secondImagesblock: secondImagesblock,
                                            itemType: itemType,
                                            staticClasses: constants.staticClasses,
                                            handleMouseLeave: handleMouseLeave,
                                            onClickNav: onClickNav,
                                            navOpen: navOpen,
                                            darkThemeFlag: darkThemeFlag,
                                            menuType: menuType,
                                            selectedTab: selectedTab,
                                            navTitle: navTitle,
                                            levelOneNavMulti: levelOneNavMulti,
                                            activeIndex: activeIndex,
                                            getInternalLinkURLS: getInternalLinkURLS,
                                            multiCTA: multiCTA,
                                            handleAccordionClick: handleAccordionClick,
                                            smartCrop: smartCrop,
                                            navTabIndex: navTabIndex,
                                            levelOneLengthsArray: levelOneLengthsArray,
                                            selectedNavTabIndex: selectedNavTabIndex,
                                            setActiveIndex: setActiveIndex,
                                            setSelectedId: setSelectedId,
                                            selectedId: selectedId
                                        }) : null
                                    ]
                                }, key + navTabIndex);
                            }),
                            (data === null || data === void 0 ? void 0 : data.mainTabId) && Object.keys(data === null || data === void 0 ? void 0 : data.mainTabId).map((key, index)=>{
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    role: "tab",
                                    className: "cmp-tabs__tab",
                                    tabIndex: "0",
                                    children: key
                                }, "navItem-".concat(index));
                            })
                        ]
                    }),
                    isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Shared_UtilityNavHeader, {
                        data: element,
                        toggleMenu: toggleMenu,
                        eventHandler: props === null || props === void 0 ? void 0 : props.eventHandler
                    }) : null
                ]
            })
        })
    });
};
/* harmony default export */ var HeaderNavTabs_HeaderNavTabsV3 = (HeaderNavTabsV3);

;// CONCATENATED MODULE: ./components/Shared/HeaderNav.jsx













const HeaderNav = (props)=>{
    const dispatch = (0,es/* useDispatch */.I0)();
    const isSsr = (0,useIsSsr/* default */.Z)();
    const { menu: { isOpen  }  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const { data ={} , eventHandler , v3 =false  } = props;
    const toggleMenu = ()=>{
        isOpen ? dispatch((0,genericSlice/* closeMenu */.Wj)()) : dispatch((0,genericSlice/* openMenu */.qn)());
    };
    const [scrollDir, setScrollDir] = (0,react.useState)("scrolling down");
    const [lastScrollY, setLastScrollY] = (0,react.useState)(0);
    const router = (0,next_router.useRouter)();
    (0,react.useEffect)(()=>{
        const threshold = 0;
        let lastScrollY = window.pageYOffset;
        let ticking = false;
        const updateScrollDir = ()=>{
            const scrollY = window.pageYOffset;
            if (Math.abs(scrollY - lastScrollY) < threshold) {
                ticking = false;
                return;
            }
            if (!document.body.classList.contains("gbh-of-scroll")) setScrollDir(scrollY > lastScrollY ? "scrolling down" : "scrolling up");
            lastScrollY = scrollY > 0 ? scrollY : 1;
            ticking = false;
            setLastScrollY(lastScrollY);
        };
        const onScroll = ()=>{
            if (!ticking) {
                window.requestAnimationFrame(updateScrollDir);
                ticking = true;
            }
        };
        const onScrollThrottle = throttle_default()(onScroll, 1000);
        if ((router === null || router === void 0 ? void 0 : router.pathname) !== "/checkout") {
            window.removeEventListener("scroll", onScrollThrottle);
            window.addEventListener("scroll", onScrollThrottle);
        }
        return ()=>window.removeEventListener("scroll", onScrollThrottle);
    }, [
        router
    ]);
    (0,react.useEffect)(()=>{
        if (scrollDir === "scrolling down") {
            (0,utils/* alterClass */.bU)("gbh-header-logo-menu", "nav-down", "nav-up");
            (0,utils/* alterClass */.bU)("sticky-plp-listing", "nav-down", "nav-up");
            (0,utils/* alterClass */.bU)("sticky-pdp-page", "nav-down", "nav-up");
        } else if (scrollDir === "scrolling up") {
            (0,utils/* alterClass */.bU)("gbh-header-logo-menu", "nav-up", "nav-down");
            (0,utils/* alterClass */.bU)("sticky-plp-listing", "nav-up", "nav-down");
            (0,utils/* alterClass */.bU)("sticky-pdp-page", "nav-up", "nav-down");
        } else return;
    }, [
        scrollDir,
        lastScrollY
    ]);
    (0,react.useEffect)(()=>{
        if (lastScrollY < 200) {
            (0,utils/* alterClass */.bU)("gbh-header-logo-menu", null, "nav-down");
            (0,utils/* alterClass */.bU)("gbh-header-logo-menu", null, "nav-up");
        }
    }, [
        lastScrollY,
        router
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat(data === null || data === void 0 ? void 0 : data.gridClassNames),
        children: data[":itemsOrder"].map((key, index)=>{
            const item = data[":items"][key];
            if (key.includes("image")) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Shared_HeaderNavLogo, {
                    v3: v3,
                    data: item,
                    columnClassNames: "".concat(data.columnClassNames[key]),
                    eventHandler: eventHandler,
                    isOpen: isOpen,
                    ariaControls: constants.HEADER_NAV_TABS_WRAPPER_ID
                }, "logo-".concat(index));
            }
            if (key === null || key === void 0 ? void 0 : key.includes("tabs")) {
                if (v3) {
                    var ref;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderNavTabs_HeaderNavTabsV3, {
                        data: item,
                        columnClassNames: "".concat(data === null || data === void 0 ? void 0 : (ref = data.columnClassNames) === null || ref === void 0 ? void 0 : ref.key),
                        isOpen: isOpen,
                        toggleMenu: toggleMenu,
                        eventHandler: eventHandler,
                        wrapperId: constants.HEADER_NAV_TABS_WRAPPER_ID
                    }, "tabs-".concat(index));
                } else {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Shared_HeaderNavTabs, {
                        data: item,
                        columnClassNames: "".concat(data.columnClassNames[key]),
                        isOpen: isOpen,
                        toggleMenu: toggleMenu,
                        eventHandler: eventHandler,
                        wrapperId: constants.HEADER_NAV_TABS_WRAPPER_ID
                    }, "tabs-".concat(index));
                }
            }
            if (key === null || key === void 0 ? void 0 : key.includes("utilitywidgets")) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                    children: !isSsr ? /*#__PURE__*/ (0,jsx_runtime.jsx)(UtilityWidgets/* default */.Z, {
                        data: item,
                        columnClassNames: "".concat(data.columnClassNames[key]),
                        eventHandler: eventHandler
                    }) : null
                }, "utilitywidgets-".concat(index));
            }
            return null;
        })
    });
};
/* harmony default export */ var Shared_HeaderNav = (HeaderNav);

;// CONCATENATED MODULE: ./components/Default/Video/videoAnalytics.js


let analyticsTimer;
const pushClickEvent = (eventInfo)=>{
    var ref;
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    if (isEmpty_default()(page)) {
        analyticsTimer = setTimeout(()=>pushClickEvent(eventInfo), 500);
        return;
    }
    if (analyticsTimer) {
        clearTimeout(analyticsTimer);
    }
    Object.keys(eventInfo).forEach((key)=>{
        if (eventInfo[key].includes(":rm")) {
            let _eventInfo$key;
            eventInfo[key] = (_eventInfo$key = eventInfo[key]) === null || _eventInfo$key === void 0 ? void 0 : _eventInfo$key.replace(/:rm/g, "");
        }
    });
    const { productInfo: tempInfo  } = page;
    (page === null || page === void 0 ? void 0 : (ref = page.pageInfo) === null || ref === void 0 ? void 0 : ref.pageId) === "home" ? delete page.productInfo : tempInfo;
    if (eventInfo) {
        window.adobeDataLayer.push({
            event: "cmp:click",
            eventInfo: eventInfo,
            page: page
        });
    }
};
const getComponentZone = (element)=>{
    const container = (0,utils/* closest */.oq)(element, (el)=>el.className === "cmp-container");
    const zoneName = container === null || container === void 0 ? void 0 : container.getAttribute("id");
    if (zoneName) {
        return zoneName.toLowerCase().replaceAll("-", " ");
    } else {
        return "";
    }
};
const shareVideoDatalayer = (eventPageType, componentZone, componentLinkType, videoTitle)=>{
    var ref;
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const eventTypeTittle = page === null || page === void 0 ? void 0 : (ref = page.pageInfo) === null || ref === void 0 ? void 0 : ref.contentType;
    const eventtitle = eventTypeTittle === "locations" ? "location:kohler stores" : eventPageType;
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(eventtitle === null || eventtitle === void 0 ? void 0 : eventtitle.toLowerCase(), ":share"),
        eventMsg: "n/a",
        eventName: "".concat(eventtitle === null || eventtitle === void 0 ? void 0 : eventtitle.toLowerCase(), ":share"),
        eventStatus: "n/a",
        eventType: "navigation",
        internalLinkName: "share",
        internalLinkPosition: "".concat(eventtitle === null || eventtitle === void 0 ? void 0 : eventtitle.toLowerCase()),
        internalLinkType: "".concat(eventtitle === null || eventtitle === void 0 ? void 0 : eventtitle.toLowerCase(), ":share"),
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(eventtitle === null || eventtitle === void 0 ? void 0 : eventtitle.toLowerCase(), ":").concat(videoTitle)
    };
    window.adobeDataLayer.push({
        event: "cmp:click",
        page,
        eventInfo
    });
};
const playVideoDatalayer = (element, video, setFavVideoIdCb, videoModalClose)=>{
    var ref;
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const container = (0,utils/* closest */.oq)(element, (el)=>el.className.includes("cmp-teaser__image"));
    const nearestDatalayerAttribute = container === null || container === void 0 ? void 0 : container.getAttribute("data-gbh-data-layer");
    const videoIdAttribute = video;
    const jsonObject = nearestDatalayerAttribute ? JSON.parse(nearestDatalayerAttribute === null || nearestDatalayerAttribute === void 0 ? void 0 : nearestDatalayerAttribute.replaceAll(/(\r\n|\n|\r)/gm, "")) : {};
    if ((page === null || page === void 0 ? void 0 : (ref = page.pageInfo) === null || ref === void 0 ? void 0 : ref.contentType) === "locations") {
        const pageType = "locations:kohler stores";
        jsonObject["internalLinkZoneName"] = pageType + ":" + getComponentZone(element);
        jsonObject["eventName"] = pageType + ":" + getComponentZone(element);
        jsonObject["internalLinkType"] = pageType + ":" + getComponentZone(element);
        jsonObject["internalLinkPosition"] = pageType + ":" + "teaser";
    } else {
        jsonObject["eventMsg"] = "n/a";
        jsonObject["eventStatus"] = "n/a";
        jsonObject["internalLinkZoneName"] = window.eventPageType + ":" + getComponentZone(element);
        jsonObject["eventName"] = jsonObject["eventName"].replaceAll("zoneForVideo", getComponentZone(element));
    }
    // splitting video id from URL
    const splitVideoId = decodeURI(videoIdAttribute).split("PAWEB/")[1];
    if (videoIdAttribute && undefined !== splitVideoId && null !== splitVideoId) {
        jsonObject["videoId"] = splitVideoId.toLowerCase();
        const favVideoId = splitVideoId.toLowerCase();
        setFavVideoIdCb && setFavVideoIdCb(favVideoId);
    }
    // condition to check when the video ends
    if (videoModalClose) {
        const { eventName =""  } = jsonObject;
        const closeEvent = "".concat(eventName, ":close");
        const videoJsonObject = {
            ...jsonObject,
            eventAction: closeEvent,
            eventName: closeEvent,
            internalLinkName: "close"
        };
        pushClickEvent(videoJsonObject);
    } else {
        jsonObject["eventName"] = jsonObject["eventAction"] = jsonObject["eventName"] + ":" + "video play";
        pushClickEvent(jsonObject);
    }
};
const getVideoFullScreenEventInfo = (eventPageType, videoName, videoId, componentPosition, enter)=>{
    return {
        clickInternalLinks: "true",
        eventAction: "".concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(videoName, ":full screen"),
        eventMsg: "n/a",
        eventName: "".concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(videoName, ":full screen"),
        eventStatus: "n/a",
        eventType: "navigation",
        internalLinkName: "full screen".concat(enter === "fullscreenEnter" ? "" : " minimize"),
        internalLinkPosition: "".concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(componentPosition || "teaser"),
        internalLinkType: "".concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(videoName),
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(videoName),
        videoId: videoId,
        videoName: videoName
    };
};
const addVideoFullScreenDatalayer = (enter, eventPageType, videoName, videoId, componentPosition)=>{
    var ref;
    const eventInfo = getVideoFullScreenEventInfo(eventPageType, videoName, videoId, componentPosition, enter);
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const { productInfo: tempInfo  } = page;
    (page === null || page === void 0 ? void 0 : (ref = page.pageInfo) === null || ref === void 0 ? void 0 : ref.pageId) === "home" ? delete page.productInfo : tempInfo;
    window.adobeDataLayer.push({
        event: "cmp:click",
        page,
        eventInfo
    });
};

// EXTERNAL MODULE: ./node_modules/lodash/debounce.js
var debounce = __webpack_require__(23279);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);
;// CONCATENATED MODULE: ./hooks/useScreenOrientation.js



/**
 *
 * @return {String}
 */ const useScreenOrientation = ()=>{
    const isSsr = (0,useIsSsr/* default */.Z)();
    const [orientation, setOrientation] = (0,react.useState)("");
    (0,react.useEffect)(()=>{
        const getOrientation = ()=>{
            var ref, ref1;
            return (ref = window.screen) === null || ref === void 0 ? void 0 : (ref1 = ref.orientation) === null || ref1 === void 0 ? void 0 : ref1.type;
        };
        setOrientation(getOrientation());
        const updateOrientation = debounce_default()(()=>{
            setOrientation(getOrientation());
        }, 300);
        if (!isSsr) {
            window.addEventListener("resize", updateOrientation);
        }
        return ()=>{
            window.removeEventListener("resize", updateOrientation);
        };
    }, [
        isSsr
    ]);
    return orientation;
};
/* harmony default export */ var hooks_useScreenOrientation = (useScreenOrientation);

// EXTERNAL MODULE: ./constants/regex.js
var regex = __webpack_require__(49139);
;// CONCATENATED MODULE: ./components/Default/Teaser/v1/analytics.js




const getEventInfo = function() {
    let pageType = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", componentPosition = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", mainTitle = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", eventLabel = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", dataLayerLinkType = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "", eventType = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : "", zone = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : "", parseJson = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : false;
    const zoneName = zone ? zone === null || zone === void 0 ? void 0 : zone.replace(regex/* SPECIAL_CHAR_REGEX */.FU, " ") : "zone";
    let internalLinkType = "";
    if (eventLabel === "print") {
        internalLinkType = "".concat(pageType.toLowerCase(), ":").concat(mainTitle.toLowerCase(), ":print");
    } else {
        internalLinkType = "".concat(dataLayerLinkType);
    }
    const internalLinkZoneName = zone ? "".concat(pageType.toLowerCase(), ":").concat(zoneName) : "teaser";
    const eventInfo = {
        clickInternalLinks: "true",
        internalLinkPosition: "".concat(pageType.toLowerCase(), ":").concat(componentPosition ? componentPosition : "teaser"),
        internalLinkZoneName,
        internalLinkURL: "n/a",
        internalLinkName: "".concat(eventLabel),
        eventName: "".concat(pageType.toLowerCase(), ":").concat(eventLabel === "print" ? eventLabel : "".concat(zoneName, ":share")),
        internalLinkType: internalLinkType,
        eventType: eventType,
        eventAction: "".concat(pageType.toLowerCase(), ":").concat(eventLabel === "print" ? eventLabel : "".concat(zoneName, ":share"))
    };
    if (parseJson) {
        return eventInfo;
    }
    return JSON.stringify(eventInfo);
};
const addDatalayerShare = function() {
    let data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "{}", isPdp = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    const page = window.pageObj || {};
    const eventInfo = JSON.parse(data);
    const dataLayerObj = {
        event: "cmp:click",
        page,
        eventInfo
    };
    if (isPdp) {
        const { productInfo  } = page;
        dataLayerObj["productInfo"] = productInfo;
    }
    window.adobeDataLayer.push(dataLayerObj);
};
const getDownloadEventInfo = function() {
    let downLoadLink = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", pageType = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", componentPosition = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", mainTitle = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", dataLayerLinkType = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "";
    let eventInfo = {};
    if (downLoadLink) {
        eventInfo = {
            clickInternalLinks: "true",
            internalLinkPosition: "".concat(pageType.toLowerCase(), ":").concat(componentPosition ? componentPosition : "teaser"),
            internalLinkZoneName: "teaser",
            internalLinkURL: "".concat(downLoadLink),
            internalLinkName: "download",
            eventName: "".concat(pageType.toLowerCase(), ":download"),
            internalLinkType: "".concat(pageType.toLowerCase(), ":").concat(mainTitle.toLowerCase(), ":download"),
            eventType: "teaser",
            eventAction: "".concat(pageType.toLowerCase(), ":download")
        };
    } else {
        eventInfo = {
            clickInternalLinks: "true",
            internalLinkPosition: "".concat(pageType.toLowerCase(), ":").concat(componentPosition || "teaser"),
            internalLinkZoneName: "teaser",
            internalLinkURL: "n/a",
            internalLinkName: "download",
            eventName: "".concat(pageType.toLowerCase(), ":download"),
            internalLinkType: "".concat(dataLayerLinkType),
            eventType: "teaser",
            eventAction: "".concat(pageType.toLowerCase(), ":download")
        };
    }
    return JSON.stringify(eventInfo);
};
const getTitleEventInfo = function() {
    let linkNewTab = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, componentPosition = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", linkURL = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", mainTitle = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", pageType = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "", componentLinkType = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : "", title = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : "";
    return '{"clickInternalLinks":"'.concat(linkNewTab || mainTitle.toLowerCase().includes("kohler canada") ? "false" : "true", '","internalLinkPosition":"').concat(pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase(), ":").concat(componentPosition || "teaser", '","internalLinkZoneName":"teaser","internalLinkURL":"').concat(linkURL || (0,helper/* getLinkFromHref */.OWN)(title), '","internalLinkName":"').concat(mainTitle.toLowerCase(), '","eventName":"').concat(pageType.toLowerCase(), ":zone:").concat(mainTitle.toLowerCase(), '","internalLinkType":"').concat(pageType, ":").concat(componentLinkType ? componentLinkType : mainTitle.toLowerCase(), '","eventType":"teaser","eventAction":"').concat(pageType.toLowerCase(), ":zone:").concat(mainTitle.toLowerCase(), '"}');
};
const addTeaserActionAnalytics = (param)=>{
    let { pageType ="" , componentPosition ="" , videoTitle ="" , link ="" , text ="" , eventName: eventNameDatalayer , dataLayerLinkType ="" , eventAction: eventActionDataLayer , productCategory ="" , productCollectionsName ="" , productRoom ="" , datalayerPageType ="" , mainTitle ="" , componentInfo =""  } = param;
    const eventTitle = (0,helper/* makingTextDatalayerReady */.S$e)(mainTitle);
    let internalLinkZoneName;
    const eventPageType = pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase();
    const linkText = text === null || text === void 0 ? void 0 : text.toLowerCase();
    let eventAction = eventPageType ? "".concat(eventPageType, ":").concat((eventActionDataLayer === null || eventActionDataLayer === void 0 ? void 0 : eventActionDataLayer.toLowerCase()) || eventTitle || "zone", ":").concat(linkText) : "".concat((eventActionDataLayer === null || eventActionDataLayer === void 0 ? void 0 : eventActionDataLayer.toLowerCase()) || eventTitle || "zone", ":").concat(linkText);
    let eventName = eventAction;
    if (videoTitle || eventPageType === "plp") {
        eventAction = "".concat(eventPageType, ":").concat(videoTitle, ":").concat(linkText);
        eventName = "".concat(eventPageType, ":").concat(videoTitle, ":").concat(linkText);
        internalLinkZoneName = "".concat(eventPageType, ":").concat(videoTitle);
    } else if (eventTitle) {
        internalLinkZoneName = "".concat(eventPageType, ":").concat(eventTitle);
    } else {
        internalLinkZoneName = "teaser";
    }
    let internalLinkPosition = eventPageType ? "".concat(eventPageType, ":").concat(componentPosition || "teaser") : componentPosition || "teaser";
    let internalLinkType = videoTitle.replace(regex/* PURE_DATA_FOR_STRING_REGEX */.YN, "") ? "".concat("".concat(eventPageType, ":").concat(videoTitle.replace(regex/* PURE_DATA_FOR_STRING_REGEX */.YN, ""))) : eventPageType ? "".concat(eventPageType, ":").concat(eventTitle) : "navigation";
    if (dataLayerLinkType.includes("social impact")) {
        eventName = "".concat(dataLayerLinkType.substring(0, dataLayerLinkType.lastIndexOf(":")), ":").concat(text === null || text === void 0 ? void 0 : text.toLowerCase());
        eventAction = "".concat(dataLayerLinkType.substring(0, dataLayerLinkType.lastIndexOf(":")), ":").concat(text === null || text === void 0 ? void 0 : text.toLowerCase());
        internalLinkZoneName = "".concat(dataLayerLinkType.substring(0, dataLayerLinkType.lastIndexOf(":")));
    }
    let eventType = "navigation";
    if (datalayerPageType.includes("locations")) {
        pageType = "locations:kohler stores";
        eventName = "".concat(eventPageType, ":").concat(linkText);
        eventAction = "".concat(eventPageType, ":").concat(linkText);
        internalLinkZoneName = eventPageType;
        internalLinkPosition = "".concat(eventPageType, ":teaser");
        internalLinkType = "".concat(eventPageType, ":").concat(eventTitle);
    }
    const page = window.pageObj || {};
    if ((text === "Get Started" || text === "Apply Now") && eventActionDataLayer === null) {
        var ref, ref1;
        const datalayerPageType1 = page === null || page === void 0 ? void 0 : (ref = page.category) === null || ref === void 0 ? void 0 : ref.pageType;
        const NewDatalayerPageType = datalayerPageType1 === "services" ? page === null || page === void 0 ? void 0 : (ref1 = page.category) === null || ref1 === void 0 ? void 0 : ref1.subCategoryID : datalayerPageType1;
        eventAction = linkText;
        eventName = linkText;
        eventType = "promo banner";
        internalLinkPosition = "".concat(NewDatalayerPageType === null || NewDatalayerPageType === void 0 ? void 0 : NewDatalayerPageType.toLowerCase(), ":promo banner");
        internalLinkType = eventPageType ? "".concat(eventPageType, ":").concat(eventTitle) : "navigation";
        internalLinkZoneName = "".concat(NewDatalayerPageType === null || NewDatalayerPageType === void 0 ? void 0 : NewDatalayerPageType.toLowerCase(), ":promo details");
    }
    if ((linkText === constants.BROWSE_ALL_KOHLER_STORES || text === constants.MORE_OPTIONS.LEARN_MORE) && datalayerPageType === "locations") {
        pageType = "".concat(constants.FIND_A_STORE, ":").concat(constants.PAGE_TYPES.LOCATION_LANDING_PAGE);
        eventName = "".concat(pageType, ":").concat(linkText);
        eventAction = "".concat(pageType, ":").concat(linkText);
        internalLinkPosition = constants.FIND_A_STORE;
        internalLinkType = "".concat(constants.FIND_A_STORE, ":").concat(text === constants.MORE_OPTIONS.LEARN_MORE && eventTitle || eventType);
        internalLinkZoneName = "".concat(pageType).concat(text === constants.MORE_OPTIONS.LEARN_MORE && ":" + eventTitle || "");
    }
    if (eventPageType === constants.HOW_TO_BECOME_A_KPN) {
        eventName = "".concat(eventPageType, ":").concat(text === constants.JOIN_NOW ? constants.TWO_WAYS_TO_BE_A_KPN : mainTitle === null || mainTitle === void 0 ? void 0 : mainTitle.toLowerCase(), ":").concat(linkText);
        eventAction = "".concat(eventPageType, ":").concat(text === constants.JOIN_NOW ? constants.TWO_WAYS_TO_BE_A_KPN : mainTitle === null || mainTitle === void 0 ? void 0 : mainTitle.toLowerCase(), ":").concat(linkText);
        internalLinkZoneName = "".concat(eventPageType, ":").concat(text === constants.JOIN_NOW ? constants.TWO_WAYS_TO_BE_A_KPN : mainTitle === null || mainTitle === void 0 ? void 0 : mainTitle.toLowerCase());
        eventType = "teaser";
        internalLinkPosition = "".concat(eventPageType, ":teaser");
    }
    if (window.eventPageType === "pdp" && text === "Shop Farmstead") {
        var ref2, ref3;
        eventName = "".concat((ref2 = window.eventPageType) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase(), ":farmstead sink:").concat(linkText);
        eventAction = "".concat((ref3 = window.eventPageType) === null || ref3 === void 0 ? void 0 : ref3.toLowerCase(), ":farmstead sink:").concat(linkText);
        eventType = "navigation";
        internalLinkPosition = "pdp:".concat(pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase());
        internalLinkType = "pdp:".concat(pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase());
        internalLinkZoneName = constants.PDP_DETAILS;
    }
    const eventInfo = {
        clickInternalLinks: (link === null || link === void 0 ? void 0 : link.startsWith("/")) || (link === null || link === void 0 ? void 0 : link.startsWith("#")) || (link === null || link === void 0 ? void 0 : link.includes(window.location.hostname)) ? "true" : "false",
        internalLinkPosition,
        internalLinkZoneName,
        internalLinkURL: link ? "".concat(link.indexOf("http") === -1 ? window.location.origin : "").concat((0,helper/* removeAndCleanLink */.xEh)(link)) : "n/a",
        internalLinkName: "".concat(!text ? "explore more arrow" : linkText),
        eventName,
        internalLinkType,
        eventType,
        eventAction,
        eventMsg: "n/a",
        eventStatus: "n/a"
    };
    const customDataLayer = {
        ...componentInfo ? {
            componentInfo: JSON.parse(componentInfo)
        } : {},
        productInfo: {
            productCategory: productCategory || "n/a",
            productCollectionsName: productCollectionsName || "n/a",
            productRoom: productRoom || "n/a"
        }
    };
    (0,helper/* pushAnalyticsObjToDataLayer */.zYT)(eventInfo, "cmp:click", {}, customDataLayer);
};
const addTeaserDescriptionAnalytic = function() {
    let target = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", isPdp = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", isPlp = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", pageType = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", internalLinkPositionNotPdp = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "", preTitle = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : "", mainTitle = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : "", linkURL = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : "", internalLinkTypeNotPdp = arguments.length > 8 && arguments[8] !== void 0 ? arguments[8] : "", sanitizeDescription = arguments.length > 9 && arguments[9] !== void 0 ? arguments[9] : "";
    return JSON.stringify({
        clickInternalLinks: target === "_blank" ? "false" : "true",
        internalLinkPosition: isPdp || isPlp ? pageType.toLowerCase() : internalLinkPositionNotPdp,
        internalLinkZoneName: isPlp ? "".concat(pageType.toLowerCase(), ":").concat(preTitle, ":rm") : mainTitle ? "".concat(pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase(), ":").concat(mainTitle) : "teaser",
        internalLinkURL: linkURL,
        eventName: isPlp ? "".concat(pageType.toLowerCase(), ":").concat(preTitle, ":rm") : "".concat(pageType.toLowerCase(), ":").concat(mainTitle, ":").concat(sanitizeDescription),
        internalLinkType: isPdp ? "".concat(pageType.toLowerCase(), ":teaser") : isPlp ? "".concat(pageType.toLowerCase(), ":navigation") : internalLinkTypeNotPdp,
        eventType: isPdp || isPlp ? "navigation" : "teaser",
        internalLinkName: sanitizeDescription,
        eventMsg: "n/a",
        eventStatus: "n/a",
        eventAction: isPlp ? "".concat(pageType.toLowerCase(), ":").concat(preTitle, ":rm") : "".concat(pageType.toLowerCase(), ":").concat(mainTitle, ":").concat(sanitizeDescription)
    });
};
const addTeaserAnalytic = function(e) {
    let linkNewTab = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, componentPosition = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", linkURL = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", mainTitle = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "", pageType = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : "", componentLinkType = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : "", title = arguments.length > 7 ? arguments[7] : void 0, datalayerLinkName = arguments.length > 8 && arguments[8] !== void 0 ? arguments[8] : "", containerIdName = arguments.length > 9 && arguments[9] !== void 0 ? arguments[9] : "", eventName = arguments.length > 10 && arguments[10] !== void 0 ? arguments[10] : "", eventAction = arguments.length > 11 && arguments[11] !== void 0 ? arguments[11] : "";
    e.preventDefault();
    return '{"clickInternalLinks":"'.concat(linkNewTab ? "false" : "true", '","internalLinkPosition":"').concat(pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase(), ":").concat(componentPosition || "teaser", '","internalLinkZoneName":"teaser","internalLinkURL":"').concat(linkURL, '","internalLinkName":"').concat(datalayerLinkName, '","eventName":"').concat(pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase(), ":").concat(containerIdName, ":").concat(eventName || datalayerLinkName || "rm", '","internalLinkType":"').concat(pageType, ":").concat(componentLinkType || mainTitle, '","eventType":"teaser","eventAction":"').concat(pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase(), ":").concat(containerIdName, ":").concat(eventAction || datalayerLinkName || "rm", '"}');
};
const addTeaserLinkAnalytics = (teaserFullData, link, bodytitle, containerId, data, datalayerPageName, linkURL)=>{
    const { datalayerLinkName , fullData , mainTitle , eventAction , eventName , linkNewTab  } = data;
    const { teaser: { pretitle: teaserPretitle = ""  } = {}  } = teaserFullData || {};
    const page = window.pageObj || {};
    const { pageInfo: { pageUrl  } , productInfo  } = page;
    const pageType = window.eventPageType;
    const internalLinkName = (0,utils/* sanitizedTextAndEntities */.wq)(datalayerLinkName);
    if (pageType === "pdp") {
        var ref, ref1, ref2, ref3, ref4;
        const eventInfo = {
            eventAction: "pdp:".concat((fullData === null || fullData === void 0 ? void 0 : (ref = fullData.teaser) === null || ref === void 0 ? void 0 : ref.mainTitle) ? fullData === null || fullData === void 0 ? void 0 : (ref1 = fullData.teaser) === null || ref1 === void 0 ? void 0 : ref1.mainTitle : "product details", ":").concat((0,utils/* sanitizedTextAndEntities */.wq)(eventAction || mainTitle).toLowerCase().trim()),
            eventName: "pdp:".concat((fullData === null || fullData === void 0 ? void 0 : (ref2 = fullData.teaser) === null || ref2 === void 0 ? void 0 : ref2.mainTitle) ? fullData === null || fullData === void 0 ? void 0 : (ref3 = fullData.teaser) === null || ref3 === void 0 ? void 0 : ref3.mainTitle : "product details", ":").concat((0,utils/* sanitizedTextAndEntities */.wq)(eventName || mainTitle).toLowerCase().trim()),
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName,
            internalLinkPosition: "pdp",
            internalLinkType: "pdp:teaser",
            internalLinkZoneName: "pdp:".concat((0,utils/* sanitizedTextAndEntities */.wq)((fullData === null || fullData === void 0 ? void 0 : (ref4 = fullData.teaser) === null || ref4 === void 0 ? void 0 : ref4.mainTitle) || bodytitle).toLowerCase().trim()),
            internalLinkURL: "".concat(window.location.href || link || pageUrl || "n/a"),
            clickInternalLinks: "".concat(linkNewTab ? "false" : "true")
        };
        const dataLayerObj = {
            event: "cmp:click",
            page,
            eventInfo,
            productInfo
        };
        window.adobeDataLayer.push(dataLayerObj);
    } else if (pageType === constants.INSPIRATION_PAGE_NAME.KIPS_BAY_DECORATOR) {
        var ref5, ref6, ref7, ref8, ref9;
        const eventInfo1 = {
            eventAction: "".concat(pageType, ":").concat((fullData === null || fullData === void 0 ? void 0 : (ref5 = fullData.teaser) === null || ref5 === void 0 ? void 0 : ref5.mainTitle) ? fullData === null || fullData === void 0 ? void 0 : (ref6 = fullData.teaser) === null || ref6 === void 0 ? void 0 : ref6.mainTitle : containerId.replaceAll("-", " "), ":").concat(eventAction || mainTitle),
            eventName: "".concat(pageType, ":").concat((fullData === null || fullData === void 0 ? void 0 : (ref7 = fullData.teaser) === null || ref7 === void 0 ? void 0 : ref7.mainTitle) ? fullData === null || fullData === void 0 ? void 0 : (ref8 = fullData.teaser) === null || ref8 === void 0 ? void 0 : ref8.mainTitle : containerId.replaceAll("-", " "), ":").concat(eventName || mainTitle),
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: "".concat(datalayerLinkName),
            internalLinkPosition: "".concat(pageType, ":teaser"),
            internalLinkType: "".concat(pageType, ":").concat(containerId.replaceAll("-", " ")),
            internalLinkZoneName: "".concat(pageType, ":").concat((fullData === null || fullData === void 0 ? void 0 : (ref9 = fullData.teaser) === null || ref9 === void 0 ? void 0 : ref9.mainTitle) || containerId.replaceAll("-", " ")),
            internalLinkURL: "".concat(window.location.href || link || pageUrl || "n/a"),
            clickInternalLinks: "".concat(linkNewTab ? "false" : "true")
        };
        const dataLayerObj1 = {
            event: "cmp:click",
            page,
            eventInfo: eventInfo1
        };
        window.adobeDataLayer.push(dataLayerObj1);
    } else if (pageType === "home with shea mcgee") {
        const linkPosition = datalayerPageName.split(":")[0];
        const eventInfo2 = {
            clickInternalLinks: "".concat(linkNewTab ? "false" : "true"),
            internalLinkPosition: linkPosition,
            eventMsg: "n/a",
            internalLinkZoneName: "".concat(pageType, ":").concat(linkURL),
            internalLinkURL: "".concat(linkURL),
            internalLinkName: mainTitle,
            internalLinkType: "".concat(linkPosition, ":").concat(pageType),
            eventType: "navigation",
            eventAction: "".concat(pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase(), ":").concat(linkURL, ":").concat(mainTitle),
            eventName: "".concat(pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase(), ":").concat(linkURL, ":").concat(mainTitle)
        };
        const dataLayerObj2 = {
            event: "cmp:click",
            page,
            eventInfo: eventInfo2
        };
        window.adobeDataLayer.push(dataLayerObj2);
    } else if ((pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase()) === constants.INSPIRATION_PAGE_NAME.PROJECT_GALLERY) {
        addProjectGalleryAnalytics(linkNewTab, pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase(), linkURL === null || linkURL === void 0 ? void 0 : linkURL.toLowerCase(), link, mainTitle === null || mainTitle === void 0 ? void 0 : mainTitle.toLowerCase(), teaserPretitle === null || teaserPretitle === void 0 ? void 0 : teaserPretitle.toLowerCase());
    } else if (pageType === "plp") {
        var ref10;
        const preTitle = (ref10 = document.querySelector(".cmp-teaser__pretitle p")) === null || ref10 === void 0 ? void 0 : ref10.textContent.toLowerCase();
        const eventInfo3 = {
            clickInternalLinks: "".concat(linkNewTab ? "false" : "true"),
            internalLinkPosition: pageType,
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkZoneName: "".concat(pageType, ":").concat(linkURL),
            internalLinkURL: "".concat(window.location.origin).concat(link),
            internalLinkName: mainTitle,
            internalLinkType: "".concat(pageType, ":").concat(preTitle, ":").concat(linkURL),
            eventType: "carousel",
            eventAction: "".concat(pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase(), ":").concat(linkURL, ":").concat(mainTitle),
            eventName: "".concat(pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase(), ":").concat(linkURL, ":").concat(mainTitle)
        };
        const dataLayerObj3 = {
            event: "cmp:click",
            page,
            eventInfo: eventInfo3
        };
        window.adobeDataLayer.push(dataLayerObj3);
    } else {
        var ref11, ref12, ref13;
        const eventNameAction = "".concat(pageType, ":").concat((fullData === null || fullData === void 0 ? void 0 : (ref11 = fullData.teaser) === null || ref11 === void 0 ? void 0 : ref11.mainTitle) ? fullData === null || fullData === void 0 ? void 0 : (ref12 = fullData.teaser) === null || ref12 === void 0 ? void 0 : ref12.mainTitle : containerId.replaceAll("-", " "), ":").concat(eventAction || mainTitle);
        const eventInfo4 = {
            eventAction: eventNameAction.replace(regex/* QUOT_REGEX */.RR, ""),
            eventName: eventNameAction.replace(regex/* QUOT_REGEX */.RR, ""),
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: "".concat(datalayerLinkName).replace(regex/* QUOT_REGEX */.RR, ""),
            internalLinkPosition: "".concat(pageType, ":teaser"),
            internalLinkType: "".concat(pageType, ":").concat(containerId.replaceAll("-", " ")),
            internalLinkZoneName: "".concat(pageType, ":").concat((fullData === null || fullData === void 0 ? void 0 : (ref13 = fullData.teaser) === null || ref13 === void 0 ? void 0 : ref13.mainTitle) || containerId.replaceAll("-", " ")),
            internalLinkURL: "".concat(window.location.href || link || pageUrl || "n/a"),
            clickInternalLinks: "".concat(linkNewTab ? "false" : "true")
        };
        const dataLayerObj4 = {
            event: "cmp:click",
            page,
            eventInfo: eventInfo4
        };
        window.adobeDataLayer.push(dataLayerObj4);
    }
};
const addProjectGalleryAnalytics = (linkNewTab, page, teaserTitle, linkUrl, mainTitle, teaserPretitle)=>{
    const title = (0,helper/* makingTextDatalayerReady */.S$e)(mainTitle);
    const eventInfo = {
        clickInternalLinks: "".concat(linkNewTab ? "false" : "true"),
        internalLinkPosition: "".concat(page, ":teaser"),
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkZoneName: "".concat(page, ":").concat(teaserPretitle || teaserTitle),
        internalLinkURL: "".concat(window.location.origin).concat(linkUrl),
        internalLinkName: title,
        internalLinkType: "".concat(page, ":").concat(teaserTitle),
        eventType: "navigation",
        eventAction: "".concat(page, ":").concat(teaserPretitle || teaserTitle, ":").concat(title),
        eventName: "".concat(page, ":").concat(teaserPretitle || teaserTitle, ":").concat(title)
    };
    (0,helper/* pushAnalyticsObjToDataLayer */.zYT)(eventInfo, "cmp:click");
};

;// CONCATENATED MODULE: ./components/Default/Teaser/v1/Action.jsx











const Action = (props)=>{
    const { primaryCTA ="" , secondaryCTA ="" , playVideoCTA ="" , videoTitle ="" , mainTitle ="" , link ="" , text ="" , newTab ="" , urlRef ="" , id ="" , pageType ="" , linkAll ="" , componentPosition =null , eventName =null , eventAction =null , dataLayerLinkType ="".concat(pageType, ":").concat(mainTitle) , productCategory =null , productCollectionsName =null , productRoom =null , propertiesPageType ="" , playVideoCTAcb =()=>"" , index =0 , activeIndex =0 , setActive =()=>"" , item , bannerIndex =-1  } = props;
    const { scroll , findAPro , installationServices  } = constants.DEFAULT_SCROLL;
    const [general, setGeneral] = (0,react.useState)(null);
    const dispatch = (0,es/* useDispatch */.I0)();
    const router = (0,next_router.useRouter)();
    const { isAuth  } = (0,es/* useSelector */.v9)(authSlice/* selectAuthState */._9);
    const { pageType: datalayerPageType  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const [actionLink, setActionLink] = (0,react.useState)("");
    const [target, setTarget] = (0,react.useState)("");
    const [loginRegisterCallback, setLoginRegisterCallback] = (0,react.useState)(null);
    (0,react.useEffect)(()=>{
        if (loginRegisterCallback && isAuth && router.pathname.includes(constants.MY_ACCOUNT_PATH)) {
            handleOnLinkClick(loginRegisterCallback);
        }
    }, [
        loginRegisterCallback,
        isAuth
    ]);
    (0,react.useEffect)(()=>{
        (0,constants_config/* getConfig */.i)().then(async (config)=>{
            setGeneral(config === null || config === void 0 ? void 0 : config.general);
        });
    }, []);
    (0,react.useEffect)(()=>{
        if (!isEmpty_default()(link) && !isEmpty_default()(general)) {
            const actLink = (0,helper/* getShortenedUrlwithGeneral */.vu1)(link, general);
            setActionLink(actLink);
        }
    }, [
        link,
        general
    ]);
    const handleLogin = (e)=>{
        if (router.pathname.includes(constants.MY_ACCOUNT_PATH)) {
            e.preventDefault();
            e.stopPropagation();
            window.loginRegisterCallback = ()=>{
                setLoginRegisterCallback(e);
                if (actionLink) router.push(actionLink);
            };
            dispatch((0,authSlice/* setAuthModalVisibility */.LY)({
                show: true
            }));
        } else {
            handleOnLinkClick();
        }
    };
    const handleOnLinkClick = (event)=>{
        return propertiesPageType === "modalWindow" && playVideoCTA ? playVideoCTAcb(event) : undefined;
    };
    const handleOnClick = (event)=>{
        var ref;
        var ref1;
        const actionLink = (ref1 = event === null || event === void 0 ? void 0 : (ref = event.target) === null || ref === void 0 ? void 0 : ref.getAttribute("href")) !== null && ref1 !== void 0 ? ref1 : "";
        if (actionLink === null || actionLink === void 0 ? void 0 : actionLink.startsWith("#KPN")) {
            event.preventDefault();
            event.stopPropagation();
            const link1 = actionLink.split("::");
            const id = link1[0];
            const url = link1[1];
            if (link1) {
                dispatch((0,authSlice/* setHideCustomerSignupCTA */.n$)(true));
                if (id === null || id === void 0 ? void 0 : id.includes("signIn")) {
                    window.KPNSignIn = true;
                    (0,helper/* isAuthenticated */.$8e)(url, 0, true);
                } else if (id === null || id === void 0 ? void 0 : id.includes("createAccount")) {
                    window.KPNSignIn = false;
                    (0,helper/* isAuthenticated */.$8e)(url, 1, true);
                } else {
                    (0,helper/* isAuthenticated */.$8e)(url);
                }
            }
        }
        const currentIndex = Number(event.target.getAttribute("data-index")) || 0;
        const componentInfo = event.target.getAttribute("data-gbh-component");
        setActive(currentIndex);
        if (event.target.getAttribute("href").startsWith("#") && Object.values(constants.MORE_OPTIONS).includes(event.target.text)) {
            exploreMoreScroll(event);
        } else if (router.pathname.includes(constants.MY_ACCOUNT_PATH) && !isAuth) {
            handleLogin(event);
        } else {
            handleOnLinkClick(event);
        }
        addTeaserActionAnalytics({
            pageType,
            componentPosition,
            videoTitle,
            link,
            text,
            eventName,
            dataLayerLinkType,
            eventAction,
            productCategory,
            productCollectionsName,
            productRoom,
            datalayerPageType,
            mainTitle,
            componentInfo
        });
    };
    // global explore more scroll
    const exploreMoreScroll = (e)=>{
        e.preventDefault();
        const hash = e.target.hash;
        if (hash === "") return;
        const element = document.querySelector(hash);
        if (!element) return;
        const offsetTop = (0,helper/* getOffsetTop */.oJS)(element) - (hash === constants.FIND_A_PRO_HASH ? findAPro : hash === constants.INSTALLATION_SERVICES_HASH ? installationServices : scroll);
        window.scrollTo({
            top: offsetTop,
            behavior: "smooth"
        });
    };
    // Added to fix eslint error Disallow target="_blank" attribute without rel="noreferrer" (react/jsx-no-target-blank)
    (0,react.useEffect)(()=>{
        if (newTab === false || newTab === "false") {
            setTarget("_self");
        } else {
            setTarget("_blank");
        }
    }, [
        newTab
    ]);
    const getComponentMessage = function() {
        let message = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
        if (message && bannerIndex > -1) {
            const obj = JSON.parse(message);
            obj.componentInfo.componentMessage = "".concat(obj.componentInfo.componentMessage).concat(bannerIndex + 1);
            return JSON.stringify(obj);
        }
    };
    if (!linkAll) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            className: "cmp-teaser__action-link ".concat((0,helper/* convertStringToBoolean */.mUs)(primaryCTA) ? "gbh-primary-button " : "").concat((0,helper/* convertStringToBoolean */.mUs)(secondaryCTA) ? "gbh-secondary-button " : "").concat(propertiesPageType === "modalWindow" && playVideoCTA ? "video-play-button " : "", " ").concat(index === activeIndex ? "active" : ""),
            role: actionLink ? "link" : "button",
            "aria-describedby": id,
            href: actionLink,
            "aria-label": text,
            target: target,
            rel: urlRef ? "noreferrer" : "",
            onClick: handleOnClick,
            "data-index": index,
            "data-gbh-component": getComponentMessage(item === null || item === void 0 ? void 0 : item.componentInfos),
            children: text
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "cmp-teaser__action-link ".concat((0,helper/* convertStringToBoolean */.mUs)(primaryCTA) ? "gbh-primary-button " : "").concat((0,helper/* convertStringToBoolean */.mUs)(secondaryCTA) ? "gbh-secondary-button " : "").concat(pageType === "modalWindow" && playVideoCTA ? "video-play-button " : ""),
        role: "button",
        "aria-describedby": id || "",
        rel: urlRef ? "noreferrer" : "",
        "aria-label": text,
        children: text
    });
};
/* harmony default export */ var v1_Action = (Action);

;// CONCATENATED MODULE: ./components/Default/Teaser/v1/Description.jsx






const Description = (props)=>{
    const { linkURL ="" , linkURLRef ="" , linkNewTab ="" , description ="" , mainTitle ="" , componentPosition =null , componentLinkType =null , pageType: serverPageType = "" , linkDescription =false , general ={} , expandText ="" , collapseText ="" , disableExpandCollapse ="" , preTitle =""  } = props;
    const [shortenedLinkUrl, setShortenedLinkUrl] = (0,react.useState)("");
    const [pageType, setPageType] = (0,react.useState)(serverPageType);
    const [target, setTarget] = (0,react.useState)("");
    const [details, setDetails] = (0,react.useState)(description);
    const [isPdp, setIsPdp] = (0,react.useState)("");
    const [linkText, setLinkText] = (0,react.useState)("");
    const isPlp = pageType === "plp";
    (0,react.useEffect)(()=>{
        window.expandText = expandText;
        window.collapseText = collapseText;
        window.disableExpandCollapse = disableExpandCollapse;
    }, [
        expandText,
        collapseText,
        disableExpandCollapse
    ]);
    (0,react.useEffect)(()=>{
        var ref, ref1, ref2;
        const pageInfoDetails = window === null || window === void 0 ? void 0 : (ref = window.adobeDataLayer) === null || ref === void 0 ? void 0 : ref.getState("page");
        if (serverPageType !== (pageInfoDetails === null || pageInfoDetails === void 0 ? void 0 : (ref1 = pageInfoDetails.pageInfo) === null || ref1 === void 0 ? void 0 : ref1.contentType) && (pageInfoDetails === null || pageInfoDetails === void 0 ? void 0 : (ref2 = pageInfoDetails.pageInfo) === null || ref2 === void 0 ? void 0 : ref2.contentType) === "pdp") {
            var ref3;
            setPageType(pageInfoDetails === null || pageInfoDetails === void 0 ? void 0 : (ref3 = pageInfoDetails.pageInfo) === null || ref3 === void 0 ? void 0 : ref3.contentType);
            setIsPdp(true);
        }
    }, []);
    const internalLinkPositionNotPdp = "".concat(pageType.toLowerCase(), ":").concat(componentPosition ? componentPosition : "teaser");
    const internalLinkTypeNotPdp = "".concat(pageType, ":").concat(componentLinkType ? componentLinkType : mainTitle.toLowerCase());
    let sanitizeDescription = (0,helper/* sanitizeTextArticle */.pkm)(description).toLowerCase();
    (0,react.useEffect)(()=>{
        if (!isEmpty_default()(general)) {
            if (linkURL) {
                setShortenedLinkUrl((0,helper/* getShortenedUrlwithGeneral */.vu1)(linkURL, general));
            }
            if (description) {
                setDetails((0,helper/* getShortenedUrlwithGeneral */.vu1)(description, general));
                if (description.includes("href")) {
                    const tempElement = document.createElement("div");
                    tempElement.innerHTML = description;
                    const text = tempElement.querySelector("a").textContent;
                    setLinkText(text);
                }
            }
        }
    }, [
        linkURL,
        description,
        general
    ]);
    sanitizeDescription = details.includes("href") ? linkText.toLowerCase() : sanitizeDescription;
    // Added to fix eslint error Disallow target="_blank" attribute without rel="noreferrer" (react/jsx-no-target-blank)
    (0,react.useEffect)(()=>{
        if (linkNewTab) {
            setTarget("_blank");
        } else {
            setTarget("_self");
        }
    }, [
        linkNewTab
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "cmp-teaser__description",
        "data-gbh-data-layer": addTeaserDescriptionAnalytic(target, isPdp, isPlp, pageType, internalLinkPositionNotPdp, preTitle, mainTitle, linkURL, internalLinkTypeNotPdp, sanitizeDescription),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(utils/* ConditionalWrapper */.M2, {
            condition: linkDescription,
            wrapper: (children)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: shortenedLinkUrl,
                    rel: linkURLRef ? "noreferrer" : "",
                    target: target,
                    children: children
                }),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: (0,helper/* sanitizeInnerHtml */.KD0)(details)
            })
        })
    });
};
/* harmony default export */ var v1_Description = (Description);

;// CONCATENATED MODULE: ./node_modules/react-intersection-observer/dist/index.mjs
"use client";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);

// src/InView.tsx


// src/observe.ts
var observerMap = /* @__PURE__ */ new Map();
var RootIds = /* @__PURE__ */ new WeakMap();
var rootId = 0;
var unsupportedValue = void 0;
function defaultFallbackInView(inView) {
  unsupportedValue = inView;
}
function getRootId(root) {
  if (!root) return "0";
  if (RootIds.has(root)) return RootIds.get(root);
  rootId += 1;
  RootIds.set(root, rootId.toString());
  return RootIds.get(root);
}
function optionsToId(options) {
  return Object.keys(options).sort().filter(
    (key) => options[key] !== void 0
  ).map((key) => {
    return `${key}_${key === "root" ? getRootId(options.root) : options[key]}`;
  }).toString();
}
function createObserver(options) {
  const id = optionsToId(options);
  let instance = observerMap.get(id);
  if (!instance) {
    const elements = /* @__PURE__ */ new Map();
    let thresholds;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        var _a;
        const inView = entry.isIntersecting && thresholds.some((threshold) => entry.intersectionRatio >= threshold);
        if (options.trackVisibility && typeof entry.isVisible === "undefined") {
          entry.isVisible = inView;
        }
        (_a = elements.get(entry.target)) == null ? void 0 : _a.forEach((callback) => {
          callback(inView, entry);
        });
      });
    }, options);
    thresholds = observer.thresholds || (Array.isArray(options.threshold) ? options.threshold : [options.threshold || 0]);
    instance = {
      id,
      observer,
      elements
    };
    observerMap.set(id, instance);
  }
  return instance;
}
function observe(element, callback, options = {}, fallbackInView = unsupportedValue) {
  if (typeof window.IntersectionObserver === "undefined" && fallbackInView !== void 0) {
    const bounds = element.getBoundingClientRect();
    callback(fallbackInView, {
      isIntersecting: fallbackInView,
      target: element,
      intersectionRatio: typeof options.threshold === "number" ? options.threshold : 0,
      time: 0,
      boundingClientRect: bounds,
      intersectionRect: bounds,
      rootBounds: bounds
    });
    return () => {
    };
  }
  const { id, observer, elements } = createObserver(options);
  const callbacks = elements.get(element) || [];
  if (!elements.has(element)) {
    elements.set(element, callbacks);
  }
  callbacks.push(callback);
  observer.observe(element);
  return function unobserve() {
    callbacks.splice(callbacks.indexOf(callback), 1);
    if (callbacks.length === 0) {
      elements.delete(element);
      observer.unobserve(element);
    }
    if (elements.size === 0) {
      observer.disconnect();
      observerMap.delete(id);
    }
  };
}

// src/InView.tsx
function isPlainChildren(props) {
  return typeof props.children !== "function";
}
var InView = class extends react.Component {
  constructor(props) {
    super(props);
    __publicField(this, "node", null);
    __publicField(this, "_unobserveCb", null);
    __publicField(this, "handleNode", (node) => {
      if (this.node) {
        this.unobserve();
        if (!node && !this.props.triggerOnce && !this.props.skip) {
          this.setState({ inView: !!this.props.initialInView, entry: void 0 });
        }
      }
      this.node = node ? node : null;
      this.observeNode();
    });
    __publicField(this, "handleChange", (inView, entry) => {
      if (inView && this.props.triggerOnce) {
        this.unobserve();
      }
      if (!isPlainChildren(this.props)) {
        this.setState({ inView, entry });
      }
      if (this.props.onChange) {
        this.props.onChange(inView, entry);
      }
    });
    this.state = {
      inView: !!props.initialInView,
      entry: void 0
    };
  }
  componentDidMount() {
    this.unobserve();
    this.observeNode();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.rootMargin !== this.props.rootMargin || prevProps.root !== this.props.root || prevProps.threshold !== this.props.threshold || prevProps.skip !== this.props.skip || prevProps.trackVisibility !== this.props.trackVisibility || prevProps.delay !== this.props.delay) {
      this.unobserve();
      this.observeNode();
    }
  }
  componentWillUnmount() {
    this.unobserve();
  }
  observeNode() {
    if (!this.node || this.props.skip) return;
    const {
      threshold,
      root,
      rootMargin,
      trackVisibility,
      delay,
      fallbackInView
    } = this.props;
    this._unobserveCb = observe(
      this.node,
      this.handleChange,
      {
        threshold,
        root,
        rootMargin,
        // @ts-ignore
        trackVisibility,
        // @ts-ignore
        delay
      },
      fallbackInView
    );
  }
  unobserve() {
    if (this._unobserveCb) {
      this._unobserveCb();
      this._unobserveCb = null;
    }
  }
  render() {
    const { children } = this.props;
    if (typeof children === "function") {
      const { inView, entry } = this.state;
      return children({ inView, entry, ref: this.handleNode });
    }
    const {
      as,
      triggerOnce,
      threshold,
      root,
      rootMargin,
      onChange,
      skip,
      trackVisibility,
      delay,
      initialInView,
      fallbackInView,
      ...props
    } = this.props;
    return React.createElement(
      as || "div",
      { ref: this.handleNode, ...props },
      children
    );
  }
};

// src/useInView.tsx

function useInView({
  threshold,
  delay,
  trackVisibility,
  rootMargin,
  root,
  triggerOnce,
  skip,
  initialInView,
  fallbackInView,
  onChange
} = {}) {
  var _a;
  const [ref, setRef] = react.useState(null);
  const callback = react.useRef(onChange);
  const [state, setState] = react.useState({
    inView: !!initialInView,
    entry: void 0
  });
  callback.current = onChange;
  react.useEffect(
    () => {
      if (skip || !ref) return;
      let unobserve;
      unobserve = observe(
        ref,
        (inView, entry) => {
          setState({
            inView,
            entry
          });
          if (callback.current) callback.current(inView, entry);
          if (entry.isIntersecting && triggerOnce && unobserve) {
            unobserve();
            unobserve = void 0;
          }
        },
        {
          root,
          rootMargin,
          threshold,
          // @ts-ignore
          trackVisibility,
          // @ts-ignore
          delay
        },
        fallbackInView
      );
      return () => {
        if (unobserve) {
          unobserve();
        }
      };
    },
    // We break the rule here, because we aren't including the actual `threshold` variable
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      // If the threshold is an array, convert it to a string, so it won't change between renders.
      Array.isArray(threshold) ? threshold.toString() : threshold,
      ref,
      root,
      rootMargin,
      triggerOnce,
      skip,
      trackVisibility,
      fallbackInView,
      delay
    ]
  );
  const entryTarget = (_a = state.entry) == null ? void 0 : _a.target;
  const previousEntryTarget = react.useRef(void 0);
  if (!ref && entryTarget && !triggerOnce && !skip && previousEntryTarget.current !== entryTarget) {
    previousEntryTarget.current = entryTarget;
    setState({
      inView: !!initialInView,
      entry: void 0
    });
  }
  const result = [setRef, state.inView, state.entry];
  result.ref = result[0];
  result.inView = result[1];
  result.entry = result[2];
  return result;
}

//# sourceMappingURL=index.mjs.map
;// CONCATENATED MODULE: ./utils/videoHelper.js



const onVolumeChange = (ref)=>{
    if (ref) {
        const { muted , volume  } = ref;
        if (volume === 0 && muted) {
            ref.setAttribute("volume", 1);
            ref.setAttribute("muted", false);
        }
    }
};
// will not work as the element is stacked behind. existing code also have same behavior
const onClickHeroVideo = (event, ref)=>{
    event.preventDefault();
    (ref === null || ref === void 0 ? void 0 : ref.paused) ? ref === null || ref === void 0 ? void 0 : ref.play() : ref === null || ref === void 0 ? void 0 : ref.pause();
};
const onVideoInteraction = (action, cbVideoPlayed, cbVideoPlaying, ref, video, autoPlay, setFavVideoIdCb, flagState)=>{
    cbVideoPlayed();
    if (action === constants.VIDEO_EVENTS.PLAY) {
        cbVideoPlaying(true);
        if (!autoPlay && !(flagState === null || flagState === void 0 ? void 0 : flagState.flag100)) {
            playVideoDatalayer(ref, video, setFavVideoIdCb);
        }
    }
    if (action === constants.VIDEO_EVENTS.PAUSE) {
        cbVideoPlaying(false);
    }
    if (action === constants.VIDEO_EVENTS.ENDED) {
        if (!autoPlay && !(flagState === null || flagState === void 0 ? void 0 : flagState.flag100)) {
            playVideoDatalayer(ref, video, setFavVideoIdCb);
        }
        ref.play();
    }
};
const onPlayVideoInModal = (event, pageType, videoContainerRef, videoRef)=>{
    if (pageType === "modalWindow") {
        var ref;
        event.preventDefault();
        if (videoContainerRef && !(videoContainerRef === null || videoContainerRef === void 0 ? void 0 : (ref = videoContainerRef.classList) === null || ref === void 0 ? void 0 : ref.contains("open-video-module"))) {
            videoContainerRef.classList.add("open-video-module");
            document.body.classList.add("modal-open");
            videoRef === null || videoRef === void 0 ? void 0 : videoRef.play();
        }
    }
};
const onPlayVideo = function() {
    let videoRef = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, callbackFunction = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ()=>{}, videoDesktopPoster = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", videoMobilePoster = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", video = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "", isVideoPlaying = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : false;
    if (videoRef === null || videoRef === void 0 ? void 0 : videoRef.paused) {
        videoRef === null || videoRef === void 0 ? void 0 : videoRef.play();
    } else {
        videoRef === null || videoRef === void 0 ? void 0 : videoRef.pause();
    }
    if (video) {
        const callbackResponse = (videoRef === null || videoRef === void 0 ? void 0 : videoRef.paused) ? true : false;
        callbackFunction && callbackFunction(callbackResponse);
    } else if (videoDesktopPoster || videoMobilePoster) {
        const callbackResponse1 = !isVideoPlaying;
        callbackFunction && callbackFunction(callbackResponse1);
    }
};
const onVideoPopupClose = (videoContainerRef, videoRef, video)=>{
    videoContainerRef.classList.remove("open-video-module");
    document.body.classList.remove("modal-open");
    videoRef === null || videoRef === void 0 ? void 0 : videoRef.pause();
    playVideoDatalayer(videoRef, video, null, true);
};
const onShareVideo = (e, shareVideoCallback, eventPageType, componentZone, componentLinkType, videoTitle)=>{
    shareVideoCallback && shareVideoCallback();
    if (window.shareSrcElement === undefined || window.shareSrcElement === null) {
        window.shareSrcElement = e.target.children[0];
    }
    shareVideoDatalayer(eventPageType, componentZone, componentLinkType, videoTitle);
};
const onFavVideo = function(event) {
    let asset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", url = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", title = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", caption = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "", videoname = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : "", favVideoId = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : "", favRef = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : {}, toasterContent = arguments.length > 8 && arguments[8] !== void 0 ? arguments[8] : {};
    const { successMessage ="" , unfavoriteSuccessMessage =""  } = toasterContent;
    let _$$closest;
    const id = event.target.getAttribute("data-id");
    const sharedZoneName = (_$$closest = $(void 0).closest(".cmp-container")) === null || _$$closest === void 0 ? void 0 : _$$closest.attr("id");
    if (id) {
        (0,helper/* removeFavorites */.NgF)([
            id
        ], favRef, unfavoriteSuccessMessage);
    } else {
        const assetUrl = asset;
        let _assetUrl;
        const url1 = (_assetUrl = assetUrl) !== null && _assetUrl !== void 0 && _assetUrl.startsWith("/") ? window.location.origin + assetUrl : assetUrl;
        (0,helper/* addMediaToFavorites */.iZV)("video", title, url1, successMessage, "", caption, sharedZoneName, videoname, favVideoId);
    }
};
const onPlayInspireVideo = function() {
    let inpageVideo = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, inspireVideo = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, closeBtnRef = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, addVideoDataLayer = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : ()=>{};
    addVideoDataLayer("videoClick");
    addVideoDataLayer("videoPlay");
    inpageVideo === null || inpageVideo === void 0 ? void 0 : inpageVideo.pause();
    document.body.classList.add("modal-open");
    inspireVideo.style.display = "block";
    inspireVideo === null || inspireVideo === void 0 ? void 0 : inspireVideo.play();
    inspireVideo.muted = false;
    closeBtnRef.style.display = "block";
};
const onPlayInspireVideoClose = function() {
    let inpageVideo = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, inspireVideo = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, closeBtnRef = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, addVideoDataLayer = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : ()=>{};
    addVideoDataLayer("videoClose");
    inspireVideo === null || inspireVideo === void 0 ? void 0 : inspireVideo.pause();
    document.body.classList.remove("modal-open");
    inspireVideo.muted = true;
    inspireVideo.style.display = "none";
    inpageVideo === null || inpageVideo === void 0 ? void 0 : inpageVideo.play();
    closeBtnRef.style.display = "none";
};

// EXTERNAL MODULE: ./components/cart/OrderSummary/SocialShare.jsx
var SocialShare = __webpack_require__(22006);
;// CONCATENATED MODULE: ./components/Default/Video/v1/Video.jsx


















const Video = (props)=>{
    const { data: { videoTitle ="" , videoMobile ="" , videoMobileLandscape ="" , videoMobilePoster ="" , videoDesktopPoster ="" , videoDesktop ="" , muteEnableAutoPlay ="false" , hideEnableAutoPlay ="false" , alt ="" , appliedCssClassNames ="" , items =[] , teaserProperties: { title ="" , description ="" , linkURLRef =false , linkCTA ="" , linkNewTab =false , videoPosterMobileLandscape ="" , controlType ="" , pageType ="" , componentPosition ="" , componentZone ="" , componentLinkType ="" , playsAboveFold ="false" , eventName ="" , dynamicTabName ="" , eventAction ="" , caption ="" , pretitle ="" , actionsEnabled =false , actions =[] , linkAll =false , dataLayerLinkType ="" , mainTitle ="" , enableFav =false , enableShare =false , linkDescription =false , propertiesPageType =""  } = {}  } = {}  } = props;
    const { eventPageType , toaster: { content  }  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const { winWidth  } = (0,useWindowDimensions/* default */.Z)();
    const screenOrientation = hooks_useScreenOrientation();
    const [video, setVideo] = (0,react.useState)("");
    const [dynamicId, setDynamicId] = (0,react.useState)("");
    const [videoPlayed, setVideoPlayed] = (0,react.useState)(false);
    const [isVideoPlaying, setIsVideoPlaying] = (0,react.useState)(false);
    const [showSocialShare, setShowSocialShare] = (0,react.useState)(false);
    const [interactionState, setInteractionState] = (0,react.useState)("");
    const { ref: inViewRef , inView  } = useInView({
        threshold: 0.5
    });
    const videoContainerRef = (0,react.useRef)(null);
    const videoRef = (0,react.useRef)(null);
    const favEle = (0,react.useRef)(null);
    const [general, setGeneral] = (0,react.useState)(null);
    const [toasterContent, setToasterContent] = (0,react.useState)({
        successMessage: "",
        unfavoriteSuccessMessage: ""
    });
    const [flagState, setFlagState] = (0,react.useState)({
        flag25: false,
        flag75: false,
        flag50: false,
        flag100: false
    });
    const getVideoId = (video)=>{
        var ref, ref1;
        return (ref1 = (ref = decodeURI(video)) === null || ref === void 0 ? void 0 : ref.split(regex/* VIDEO_ID_REGEX */.JY)[1]) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase();
    };
    const videoId = getVideoId(video);
    (0,react.useEffect)(()=>{
        (0,constants_config/* getConfig */.i)().then((config)=>{
            setGeneral(config === null || config === void 0 ? void 0 : config.general);
        });
    }, []);
    const videoName = "".concat(videoTitle.replace(regex/* PURE_DATA_FOR_STRING_REGEX */.YN, "") || componentLinkType.toLowerCase().replace(regex/* PURE_DATA_FOR_STRING_REGEX */.YN, "") || "hero video");
    (0,react.useEffect)(()=>{
        const handleFullscreenChange = ()=>{
            if (document.fullscreenElement === (videoRef === null || videoRef === void 0 ? void 0 : videoRef.current)) {
                addVideoFullScreenDatalayer("fullscreenEnter", eventPageType, videoName, videoId, componentPosition);
            } else {
                addVideoFullScreenDatalayer("fullscreenExit", eventPageType, videoName, videoId, componentPosition);
            }
        };
        document.addEventListener("fullscreenchange", handleFullscreenChange);
        return ()=>{
            document.removeEventListener("fullscreenchange", handleFullscreenChange);
        };
    }, [
        eventPageType,
        videoId,
        videoName,
        componentPosition
    ]);
    (0,react.useEffect)(()=>{
        if (videoTitle) {
            const dynamicId = (0,helper/* createIdFromString */.ZT_)(videoTitle);
            setDynamicId(dynamicId);
        }
    }, [
        videoTitle
    ]);
    (0,react.useEffect)(()=>{
        if (content) {
            setToasterMessage();
        }
    }, [
        content
    ]);
    const onTimeUpdate = (event)=>{
        const videoDuration = videoRef.current.duration;
        const percent25 = Math.floor(videoDuration * 0.25);
        const percent50 = Math.floor(videoDuration * 0.5);
        const percent75 = Math.floor(videoDuration * 0.75);
        const percent100 = Math.floor(videoDuration);
        const progressTime = Math.floor(videoRef.current.currentTime);
        if ((muteEnableAutoPlay === "true" ? percent100 - 1 : percent100) === progressTime && flagState.flag100 === false && !(0,helper/* convertStringToBoolean */.mUs)(muteEnableAutoPlay)) {
            setFlagState((prevState)=>({
                    ...prevState,
                    flag100: true
                }));
            addVideoDataLayer(100);
        } else if (percent75 <= progressTime && flagState.flag75 === false && !(0,helper/* convertStringToBoolean */.mUs)(muteEnableAutoPlay)) {
            setFlagState((prevState)=>({
                    ...prevState,
                    flag75: true
                }));
            addVideoDataLayer(75);
        } else if (percent50 <= progressTime && flagState.flag50 === false && !(0,helper/* convertStringToBoolean */.mUs)(muteEnableAutoPlay)) {
            setFlagState((prevState)=>({
                    ...prevState,
                    flag50: true
                }));
            addVideoDataLayer(50);
        } else if (percent25 <= progressTime && flagState.flag25 === false && !(0,helper/* convertStringToBoolean */.mUs)(muteEnableAutoPlay)) {
            setFlagState((prevState)=>({
                    ...prevState,
                    flag25: true
                }));
            addVideoDataLayer(25);
        }
    };
    const addVideoDataLayer = (percentViewed)=>{
        var ref;
        const { VIDEO_VIEWED , VIDEO_COMPLETE  } = constants.VIDEO_EVENTS;
        const eventInfo = {
            clickInternalLinks: "true",
            eventAction: "".concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(percentViewed === 100 ? "".concat(videoTitle, ":").concat(VIDEO_COMPLETE) : "".concat(percentViewed, "% ").concat(VIDEO_VIEWED)),
            eventMsg: "n/a",
            eventName: "".concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(percentViewed === 100 ? "".concat(videoTitle, ":").concat(VIDEO_COMPLETE) : "".concat(percentViewed, "% ").concat(VIDEO_VIEWED)),
            eventStatus: "n/a",
            eventType: "navigation",
            internalLinkName: "".concat(percentViewed === 100 ? VIDEO_COMPLETE : "".concat(percentViewed, "% ").concat(VIDEO_VIEWED)),
            internalLinkPosition: "".concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(componentPosition || "teaser"),
            internalLinkType: "".concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(percentViewed === 100 ? videoTitle : componentPosition || "teaser"),
            internalLinkURL: "n/a",
            internalLinkZoneName: "".concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase()).concat(percentViewed === 100 ? ":" + videoTitle : ""),
            videoId: videoId,
            videoName: videoName,
            videoType: "".concat(muteEnableAutoPlay === "true" ? "auto play" : "user initiated")
        };
        const page = window.pageObj || {};
        const { productInfo: tempInfo  } = page;
        (page === null || page === void 0 ? void 0 : (ref = page.pageInfo) === null || ref === void 0 ? void 0 : ref.pageId) === "home" ? delete page.productInfo : tempInfo;
        window.adobeDataLayer.push({
            event: "cmp:click",
            page,
            eventInfo
        });
    };
    const setToasterMessage = async ()=>{
        const { successMessage , unfavoriteSuccessMessage  } = content;
        setToasterContent({
            successMessage: await (0,utils_location/* getShortenedUrl */.Pp)(successMessage),
            unfavoriteSuccessMessage: await (0,utils_location/* getShortenedUrl */.Pp)(unfavoriteSuccessMessage)
        });
    };
    const setVideoSource = (0,react.useCallback)(()=>{
        if (winWidth > 1023) {
            setVideo(videoDesktop);
        } else {
            if (screenOrientation === null || screenOrientation === void 0 ? void 0 : screenOrientation.includes("landscape")) {
                setVideo(videoMobileLandscape);
            } else {
                setVideo(videoMobile);
            }
        }
    }, [
        videoMobile,
        videoMobileLandscape,
        videoDesktop,
        screenOrientation,
        winWidth
    ]);
    (0,react.useEffect)(()=>{
        if (inView) {
            setVideoSource();
            if ((0,helper/* convertStringToBoolean */.mUs)(muteEnableAutoPlay) || videoPlayed && interactionState === constants.VIDEO_EVENTS.PLAY) {
                var ref;
                videoRef === null || videoRef === void 0 ? void 0 : (ref = videoRef.current) === null || ref === void 0 ? void 0 : ref.play();
            }
        } else {
            var ref1;
            videoRef === null || videoRef === void 0 ? void 0 : (ref1 = videoRef.current) === null || ref1 === void 0 ? void 0 : ref1.pause();
        }
    }, [
        setVideoSource,
        inView
    ]);
    (0,react.useEffect)(()=>{
        if (isVideoPlaying) setVideoPlayed(true);
    }, [
        isVideoPlaying
    ]);
    const eventActionTabName = dynamicTabName || "zoneForVideo";
    const eventActionName = "".concat(dynamicTabName || "rm", ":video:rm");
    const [favVideoId, setFavVideoId] = (0,react.useState)("");
    const analyticEventData = {
        clickInternalLinks: true,
        internalLinkPosition: "".concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(componentPosition || "teaser"),
        internalLinkZoneName: "".concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(componentZone || "teaser"),
        internalLinkURL: "n/a",
        internalLinkName: "n/a",
        eventName: "".concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":share"),
        internalLinkType: "".concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":share"),
        eventType: "informative",
        eventAction: "".concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":share"),
        videoName: "".concat(videoTitle || componentLinkType.toLowerCase() || "hero video"),
        videoId: "".concat(getVideoId(video)),
        eventMsg: "n/a",
        eventStatus: "n/a"
    };
    const checkVideoTitle = videoTitle || componentLinkType.toLowerCase() || "hero video";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "video teaser ".concat(appliedCssClassNames),
        ref: inViewRef,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "cmp-teaser".concat(controlType === "customControl" ? " gbh-custom-control" : "").concat(propertiesPageType === "modalWindow" ? " gbh-model-window" : "").concat((0,helper/* convertStringToBoolean */.mUs)(hideEnableAutoPlay) ? " gbh-hide-mute" : ""),
            ref: videoContainerRef,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "cmp-teaser__image video_poster_height".concat(videoPlayed ? " video-played" : ""),
                    "data-gbh-data-layer": '{"clickInternalLinks":"true","internalLinkPosition":"'.concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(componentPosition || "teaser", '","internalLinkZoneName":"').concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ':\'hero banner\' ","internalLinkURL":"n/a","internalLinkName":"video play","eventName":"').concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(eventActionTabName, '",\n             "internalLinkType":"').concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(videoTitle ? videoTitle : componentLinkType.toLowerCase() || "teaser", '","eventType":"navigation","eventAction":"').concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(eventActionTabName, '","videoName":"').concat(videoTitle || componentLinkType.toLowerCase() || "hero video", '","videoId":"').concat(videoId, '","videoType": "').concat(muteEnableAutoPlay === "true" ? "auto play" : "user initiated", '"}'),
                    style: showSocialShare ? {
                        overflow: "visible"
                    } : {},
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "gbh-play-video desktop".concat(isVideoPlaying ? " active" : ""),
                            onClick: (event)=>{
                                return onPlayVideoInModal(event, propertiesPageType, videoContainerRef === null || videoContainerRef === void 0 ? void 0 : videoContainerRef.current, videoRef === null || videoRef === void 0 ? void 0 : videoRef.current);
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: "playinside desktop",
                                id: "videoinnerbtn-".concat(dynamicId),
                                "aria-label": "play video",
                                onClick: ()=>{
                                    return onPlayVideo(videoRef === null || videoRef === void 0 ? void 0 : videoRef.current, (res)=>{
                                        setIsVideoPlaying(res);
                                        setInteractionState(res ? constants.VIDEO_EVENTS.PAUSE : constants.VIDEO_EVENTS.PLAY);
                                    }, videoDesktopPoster, videoMobilePoster, video, isVideoPlaying);
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("picture", {
                            className: "poster-img",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                    media: "(min-width:1025)",
                                    srcSet: "".concat(videoDesktopPoster)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                    media: "(min-width:640px) and (max-width:1024px)",
                                    srcSet: "".concat(videoPosterMobileLandscape)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                    media: "(max-width:639px)",
                                    srcSet: "".concat(videoMobilePoster)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "".concat(videoDesktopPoster),
                                    alt: "",
                                    className: "desktop-poster"
                                })
                            ]
                        }),
                        video && /*#__PURE__*/ (0,jsx_runtime.jsxs)("video", {
                            ref: videoRef,
                            id: "video-desktop-".concat(dynamicId),
                            width: "100%",
                            muted: (0,helper/* convertStringToBoolean */.mUs)(muteEnableAutoPlay),
                            autoPlay: (0,helper/* convertStringToBoolean */.mUs)(muteEnableAutoPlay),
                            loop: (0,helper/* convertStringToBoolean */.mUs)(muteEnableAutoPlay),
                            playsInline: true,
                            preload: "metadata",
                            onLoadedData: ()=>{
                                (0,helper/* convertStringToBoolean */.mUs)(muteEnableAutoPlay) ? playVideoDatalayer(videoRef === null || videoRef === void 0 ? void 0 : videoRef.current, video, (id)=>setFavVideoId(id)) : {};
                            },
                            className: "hero-video videoelement".concat((0,helper/* convertStringToBoolean */.mUs)(muteEnableAutoPlay) ? " muted" : "").concat((0,helper/* convertStringToBoolean */.mUs)(playsAboveFold) ? "" : " lazy-video"),
                            onVolumeChange: ()=>{
                                return onVolumeChange(videoRef === null || videoRef === void 0 ? void 0 : videoRef.current);
                            },
                            onClick: (event)=>{
                                return onClickHeroVideo(event, videoRef === null || videoRef === void 0 ? void 0 : videoRef.current);
                            },
                            ...controlType === "defaultControl" && !(0,helper/* convertStringToBoolean */.mUs)(hideEnableAutoPlay) ? {
                                controls: true
                            } : {},
                            onPlay: ()=>{
                                return onVideoInteraction(constants.VIDEO_EVENTS.PLAY, ()=>setVideoPlayed(true), (res)=>setIsVideoPlaying(res), videoRef === null || videoRef === void 0 ? void 0 : videoRef.current, video, (0,helper/* convertStringToBoolean */.mUs)(muteEnableAutoPlay), (id)=>setFavVideoId(id), flagState);
                            },
                            onPause: ()=>{
                                return onVideoInteraction(constants.VIDEO_EVENTS.PAUSE, ()=>setVideoPlayed(true), (res)=>setIsVideoPlaying(res), videoRef === null || videoRef === void 0 ? void 0 : videoRef.current, video, (0,helper/* convertStringToBoolean */.mUs)(muteEnableAutoPlay), flagState);
                            },
                            onEnded: ()=>{
                                return onVideoInteraction(constants.VIDEO_EVENTS.ENDED, ()=>setVideoPlayed(true), (res)=>setIsVideoPlaying(res), videoRef === null || videoRef === void 0 ? void 0 : videoRef.current, video, (0,helper/* convertStringToBoolean */.mUs)(muteEnableAutoPlay), flagState);
                            },
                            onTimeUpdate: onTimeUpdate,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                    src: video,
                                    type: "video/mp4"
                                }),
                                items.map((transcript, index)=>{
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("track", {
                                        label: transcript === null || transcript === void 0 ? void 0 : transcript.languageLabel,
                                        kind: "subtitles",
                                        srcLang: transcript === null || transcript === void 0 ? void 0 : transcript.languageCode,
                                        src: transcript === null || transcript === void 0 ? void 0 : transcript.transcriptSrcPath,
                                        default: (items === null || items === void 0 ? void 0 : items.length) ? true : false
                                    }, "video-track-".concat(dynamicId, "-").concat(index));
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "cmp-img-caption",
                            "data-gbh-data-layer": '{"clickInternalLinks":"true","internalLinkPosition":"'.concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(componentPosition || "teaser", '","internalLinkZoneName":"').concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(componentZone || "teaser", '","internalLinkURL":"n/a","internalLinkName":"n/a","eventName":"').concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(eventName || eventActionName, '","internalLinkType":"').concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(videoTitle || componentLinkType || "teaser", '","eventType":"navigation","eventAction":"').concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(eventAction || eventActionName, '"}'),
                            dangerouslySetInnerHTML: {
                                __html: browser_default().sanitize(caption)
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "vidio_popup_close_button",
                            onClick: ()=>{
                                return onVideoPopupClose(videoContainerRef === null || videoContainerRef === void 0 ? void 0 : videoContainerRef.current, videoRef === null || videoRef === void 0 ? void 0 : videoRef.current, video);
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                role: "button",
                                "aria-label": "close",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    "aria-hidden": "true",
                                    children: "\xd7"
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "cmp-teaser__content",
                    children: [
                        pretitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "cmp-teaser__pretitle",
                            children: (0,helper/* sanitizeInnerHtml */.KD0)(pretitle)
                        }),
                        title && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "cmp-teaser__title",
                            children: (0,helper/* sanitizeInnerHtml */.KD0)(title)
                        }),
                        description && /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_Description, {
                            general: general,
                            linkURL: linkCTA,
                            linkURLRef: linkURLRef,
                            linkNewTab: linkNewTab,
                            description: description,
                            mainTitle: mainTitle,
                            componentPosition: componentPosition,
                            componentLinkType: componentLinkType,
                            pageType: pageType,
                            linkDescription: linkDescription
                        }),
                        actionsEnabled && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "cmp-teaser__action-container",
                            children: actions.map((action, index)=>{
                                const { playVideoCTA =false , primaryCTA =false , secondaryCTA =false , url ="" , title ="" , newTab ="" , urlRef =""  } = action;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_Action, {
                                    primaryCTA: (0,helper/* convertStringToBoolean */.mUs)(primaryCTA),
                                    secondaryCTA: (0,helper/* convertStringToBoolean */.mUs)(secondaryCTA),
                                    playVideoCTA: (0,helper/* convertStringToBoolean */.mUs)(playVideoCTA),
                                    link: url,
                                    text: title,
                                    newTab: (0,helper/* convertStringToBoolean */.mUs)(newTab),
                                    urlRef: urlRef,
                                    id: dynamicId,
                                    pageType: pageType,
                                    videoTitle: videoTitle,
                                    linkAll: (0,helper/* convertStringToBoolean */.mUs)(linkAll),
                                    mainTitle: mainTitle,
                                    dataLayerLinkType: dataLayerLinkType,
                                    eventName: eventName,
                                    eventAction: eventAction,
                                    componentPosition: componentPosition,
                                    propertiesPageType: propertiesPageType,
                                    playVideoCTAcb: (event)=>{
                                        return onPlayVideoInModal(event, propertiesPageType, videoContainerRef === null || videoContainerRef === void 0 ? void 0 : videoContainerRef.current, videoRef === null || videoRef === void 0 ? void 0 : videoRef.current);
                                    }
                                }, "video-action-".concat(index + 1, "-").concat((0,helper/* getRandom */.sZz)()));
                            })
                        }),
                        (enableFav || enableShare) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "cmp-teaser__icons",
                            children: [
                                enableFav && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    ref: favEle,
                                    className: "favorite fav-video-trigger",
                                    tabIndex: "0",
                                    "data-asset": videoDesktop,
                                    "data-url": videoDesktop,
                                    onClick: (event)=>onFavVideo(event, videoDesktop, alt, componentLinkType || caption, videoTitle || componentLinkType.toLowerCase() || "hero video", checkVideoTitle, favVideoId, favEle, toasterContent)
                                }),
                                enableShare && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "share share-video-trigger",
                                    tabIndex: "0",
                                    "aria-label": "share",
                                    onClick: (e)=>onShareVideo(e, ()=>setShowSocialShare(!showSocialShare), eventPageType, componentZone, componentLinkType, videoTitle),
                                    children: showSocialShare && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "share-cmp",
                                        style: {
                                            display: "block"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialShare/* default */.Z, {
                                            analyticEventData: analyticEventData,
                                            componentProp: {
                                                assetUrl: videoDesktop
                                            },
                                            enableDownload: false,
                                            videoComp: true
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var v1_Video = (/*#__PURE__*/react.memo(Video));

// EXTERNAL MODULE: ./node_modules/overlayscrollbars/js/OverlayScrollbars.js
var OverlayScrollbars = __webpack_require__(45432);
var OverlayScrollbars_default = /*#__PURE__*/__webpack_require__.n(OverlayScrollbars);
;// CONCATENATED MODULE: ./node_modules/overlayscrollbars-react/dist/overlayscrollbars-react.esm.js



/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

class OverlayScrollbarsComponent extends react.Component {
    constructor(props) {
        super(props);
        this._osInstance = null;
        this._osTargetRef = react.createRef();
    }
    osInstance() {
        return this._osInstance;
    }
    osTarget() {
        return this._osTargetRef.current || null;
    }
    componentDidMount() {
        this._osInstance = OverlayScrollbars_default()(this.osTarget(), this.props.options || {}, this.props.extensions);
        mergeHostClassNames(this._osInstance, this.props.className);
    }
    componentWillUnmount() {
        if (OverlayScrollbars_default().valid(this._osInstance)) {
            this._osInstance.destroy();
            this._osInstance = null;
        }
    }
    componentDidUpdate(prevProps) {
        if (OverlayScrollbars_default().valid(this._osInstance)) {
            this._osInstance.options(this.props.options);
            if (prevProps.className !== this.props.className) {
                mergeHostClassNames(this._osInstance, this.props.className);
            }
        }
    }
    render() {
        const _a = this.props, divProps = __rest(_a, ["options", "extensions", "children", "className"]);
        return (react.createElement("div", Object.assign({ className: "os-host" }, divProps, { ref: this._osTargetRef }),
            react.createElement("div", { className: "os-resize-observer-host" }),
            react.createElement("div", { className: "os-padding" },
                react.createElement("div", { className: "os-viewport" },
                    react.createElement("div", { className: "os-content" }, this.props.children))),
            react.createElement("div", { className: "os-scrollbar os-scrollbar-horizontal " },
                react.createElement("div", { className: "os-scrollbar-track" },
                    react.createElement("div", { className: "os-scrollbar-handle" }))),
            react.createElement("div", { className: "os-scrollbar os-scrollbar-vertical" },
                react.createElement("div", { className: "os-scrollbar-track" },
                    react.createElement("div", { className: "os-scrollbar-handle" }))),
            react.createElement("div", { className: "os-scrollbar-corner" })));
    }
}
function mergeHostClassNames(osInstance, className) {
    if (OverlayScrollbars_default().valid(osInstance)) {
        const { host } = osInstance.getElements();
        const regex = new RegExp(`(^os-host([-_].+|)$)|${osInstance.options().className.replace(/\s/g, "$|")}$`, 'g');
        const osClassNames = host.className.split(' ')
            .filter(name => name.match(regex))
            .join(' ');
        host.className = `${osClassNames} ${className || ''}`;
    }
}


//# sourceMappingURL=overlayscrollbars-react.esm.js.map

// EXTERNAL MODULE: ./components/core/Image/ImagePlaceHolder.jsx
var ImagePlaceHolder = __webpack_require__(61319);
// EXTERNAL MODULE: ./i18n/useSearchi18n.js
var useSearchi18n = __webpack_require__(81294);
;// CONCATENATED MODULE: ./components/Default/Teaser/v1/FavouritesUtility.jsx










const FavouritesUtility = (param)=>{
    let { title ="" , assetID ="" , imageServerUrl ="" , alt ="" , containerId: zone = ""  } = param;
    const isTriggeredRef = (0,react.useRef)(true);
    const dispatch = (0,es/* useDispatch */.I0)();
    const [isFavourite, setIsFavourite] = (0,react.useState)(false);
    const [pageUrl, setPageUrl] = (0,react.useState)("");
    const [toasterContent, setToasterContent] = (0,react.useState)({
        successMessage: "",
        unfavoriteSuccessMessage: ""
    });
    const favEle = (0,react.useRef)(null);
    const { favorites: favoritesLabel , favSuccessMsg , favErrorMsg , removeItem  } = (0,useSearchi18n/* default */.Z)({});
    const { isAuth  } = (0,es/* useSelector */.v9)(authSlice/* selectAuthState */._9);
    const dataUrl = assetID ? "".concat(imageServerUrl).concat(assetID) : "";
    const [isCallback, setIsCallback] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        var ref;
        const ogUrl = document.querySelector('meta[property="og:url"]') ? (ref = document.querySelector('meta[property="og:url"]')) === null || ref === void 0 ? void 0 : ref.content : "";
        const url = ogUrl ? ogUrl.replace(constants.publicWebsiteUrl, constants.baseUrl) : "/".concat(window.location.pathname.split(".")[0]);
        setPageUrl(url);
    }, []);
    const { toaster: { content  }  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    (0,react.useEffect)(()=>{
        if (content) {
            setToasterMessage();
        }
    }, [
        content
    ]);
    (0,react.useEffect)(()=>{
        if (!isTriggeredRef.current && isCallback && isAuth) {
            isTriggeredRef.current = true;
            setIsCallback(false);
            onFavClick({});
        }
    }, [
        isCallback,
        isAuth,
        isTriggeredRef
    ]);
    const setToasterMessage = async ()=>{
        const { successMessage , unfavoriteSuccessMessage  } = content;
        setToasterContent({
            successMessage: await (0,utils_location/* getShortenedUrl */.Pp)(successMessage),
            unfavoriteSuccessMessage: await (0,utils_location/* getShortenedUrl */.Pp)(unfavoriteSuccessMessage)
        });
    };
    const onFavClick = (event)=>{
        (event === null || event === void 0 ? void 0 : event.preventDefault) && (event === null || event === void 0 ? void 0 : event.preventDefault());
        (event === null || event === void 0 ? void 0 : event.stopPropagation) && (event === null || event === void 0 ? void 0 : event.stopPropagation());
        let payload = {};
        const id = favEle.current.getAttribute("data-id");
        window.zoneName = zone;
        window.internalLinkType = title;
        if (!isAuth) {
            handleLogin();
            return;
        }
        // For images
        if (assetID) {
            payload = getPayload({
                type: "image"
            });
            if (!id) {
                postData(payload);
            }
        } else {
            Promise.all([
                (0,constants_api/* aemAxiosInstance */.Gb)({
                    url: constants.GLOBAL_CONFIGURATION_ENDPOINT,
                    params: {
                        path: "".concat(pageUrl).concat(constants.ARTICLE_CONTENT_END_POINT)
                    }
                }),
                (0,constants_api/* aemAxiosInstance */.Gb)({
                    url: constants.GLOBAL_CONFIGURATION_ENDPOINT,
                    params: {
                        path: "".concat(pageUrl).concat(constants.ARTICLE_IMG_END_POINT)
                    }
                })
            ]).then((response)=>{
                const [{ data  } = {}, { data: { fileReference  } = {}  }] = response;
                payload = getPayload({
                    type: "article",
                    content: data,
                    thumbnail: fileReference
                });
                !id && postData(payload);
            }).catch((error)=>{
                // eslint disable next-line no-console
                console.error(error);
            });
        }
        if (id) {
            dispatch((0,favoritesSlice/* removeItems */.Er)({
                ids: [
                    id
                ],
                section: payload === null || payload === void 0 ? void 0 : payload.section,
                imageName: payload === null || payload === void 0 ? void 0 : payload.imageName,
                isDataLayerNeeded: true
            })).unwrap().then((response)=>{
                dispatch((0,genericSlice/* showToast */.CF)({
                    message: toasterContent.unfavoriteSuccessMessage || removeItem,
                    isVisible: true
                }));
                favEle.current.removeAttribute("data-id");
                favEle.current.classList.remove("favorite-filled");
            }).catch((error)=>{
                // eslint disable next-line no-console
                console.error(error);
            });
            return;
        }
    };
    const postData = (payload)=>{
        if (isAuth) {
            dispatch((0,favoritesSlice/* addMedia */.rA)(payload));
        } else {
            handleLogin();
        }
    };
    const getPayload = (param)=>{
        let { type , content , thumbnail  } = param;
        const payload = {
            type,
            content,
            thumbnail,
            successCallback,
            errorCallback,
            section: zone
        };
        if (type === "image") {
            payload["name"] = alt;
            payload["url"] = dataUrl;
            payload["section"] = "main content area";
            payload["imageName"] = assetID.includes("/") ? "".concat(assetID.split("/").at(1)).toLowerCase() : "".concat(assetID).toLowerCase();
        } else if (type === "article") {
            payload["caption"] = title;
            payload["name"] = content["jcr:title"];
            payload["description"] = content["searchDescription"];
            payload["articleType"] = content["eyeBrowText"];
            payload["thumbnail"] = thumbnail;
            payload["url"] = window.location.href;
        }
        return payload;
    };
    const handleLogin = ()=>{
        setIsCallback(true);
        isTriggeredRef.current = false;
        dispatch((0,authSlice/* setAuthModalVisibility */.LY)({
            show: true
        }));
    };
    const successCallback = ()=>{
        dispatch((0,genericSlice/* showToast */.CF)({
            message: toasterContent.successMessage || favSuccessMsg,
            isVisible: true
        }));
        setIsFavourite(true);
    };
    const errorCallback = ()=>{
        dispatch((0,genericSlice/* showToast */.CF)({
            message: favErrorMsg,
            isVisible: true
        }));
        setIsFavourite(true);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "favorite fav-trigger ".concat(isFavourite ? "favorite-filled" : ""),
        "aria-label": "favorite",
        "data-asset": assetID,
        "data-url": dataUrl,
        "data-title": alt,
        "data-internal-link-type": title,
        ref: favEle,
        onClick: (event)=>onFavClick(event),
        children: [
            "\xa0",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: favoritesLabel
            })
        ]
    });
};
/* harmony default export */ var v1_FavouritesUtility = (FavouritesUtility);

// EXTERNAL MODULE: ./components/Shared/ProductSocialShare/v1/ProductSocialShare.jsx
var ProductSocialShare = __webpack_require__(13678);
;// CONCATENATED MODULE: ./components/Default/Teaser/v1/ShareUtility.jsx








const ShareUtility = (param)=>{
    let { pageType ="" , componentPosition ="" , dataLayerLinkType ="" , containerId: zone = ""  } = param;
    const [showShare, setShowShare] = (0,react.useState)(false);
    const [pageUrl, setPageUrl] = (0,react.useState)("");
    const { pageIsInteractive  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const { share  } = (0,useSearchi18n/* default */.Z)({});
    const isSsr = (0,useIsSsr/* default */.Z)();
    (0,react.useEffect)(()=>{
        if (pageIsInteractive) setPageUrl(window.location.href);
    }, [
        pageIsInteractive
    ]);
    const handleShare = (e)=>{
        e.stopPropagation();
        e.preventDefault();
        setShowShare(!showShare);
        const { adobeDataLayer: { getState  } = {}  } = window;
        const { pageInfo: { contentType  }  } = getState && getState("page") || {};
        let eventInfo = getEventInfo(pageType, componentPosition, "", "share", dataLayerLinkType, "informative");
        const isPdp = contentType === "pdp";
        if (isPdp) {
            const { internalLinkType , internalLinkZoneName , internalLinkURL  } = getEventInfo(pageType, componentPosition, "", "share", dataLayerLinkType, "informative", zone, true);
            const eventInfoObj = {
                clickInternalLinks: "true",
                eventAction: "pdp:product details:zone:share",
                eventName: "pdp:product details:zone:share",
                eventType: "navigation",
                eventMsg: "n/a",
                eventStatus: "n/a",
                internalLinkName: "share",
                internalLinkPosition: "pdp",
                internalLinkType: "pdp:".concat(internalLinkType.split(":")[1] || ""),
                internalLinkZoneName: "pdp:".concat(internalLinkZoneName.split(":")[1] || ""),
                internalLinkURL: internalLinkURL || "n/a"
            };
            eventInfo = JSON.stringify(eventInfoObj);
        }
        addDatalayerShare(eventInfo, isPdp);
    };
    return !isSsr ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "share share-trigger",
                "aria-label": "share",
                tabIndex: "0",
                onClick: handleShare,
                children: [
                    "\xa0",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: share
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "share-cmp",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductSocialShare/* default */.Z, {
                        showModal: showShare,
                        url: pageUrl,
                        onClose: ()=>setShowShare(false),
                        disableInstagram: true,
                        analyticData: getEventInfo(pageType, componentPosition, "", "share", dataLayerLinkType, "informative", zone, true)
                    })
                })
            })
        ]
    }) : null;
};
/* harmony default export */ var v1_ShareUtility = (ShareUtility);

;// CONCATENATED MODULE: ./components/Default/Teaser/v1/PrintUtility.jsx




const PrintUtility = (param)=>{
    let { pageType ="" , componentPosition ="" , mainTitle =""  } = param;
    const { print  } = (0,useSearchi18n/* default */.Z)({});
    const handlePrint = ()=>{
        window.print();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        class: "print",
        onClick: ()=>handlePrint(),
        tabIndex: "0",
        "data-gbh-data-layer": getEventInfo(pageType, componentPosition, mainTitle, "print", "", "teaser"),
        "data-gbh-clickable": "true",
        children: [
            "\xa0",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: print
            })
        ]
    });
};
/* harmony default export */ var v1_PrintUtility = (PrintUtility);

;// CONCATENATED MODULE: ./components/Default/Teaser/v1/DownloadUtility.jsx






const DownloadUtility = (param)=>{
    let { pageType ="" , componentPosition ="" , dataLayerLinkType ="" , downLoadLink =null , mainTitle =""  } = param;
    const { download , downloadSuccess , downloadFailure  } = (0,useSearchi18n/* default */.Z)({});
    const [downloadUrl, setUrl] = (0,react.useState)("");
    (0,react.useEffect)(()=>{
        if (downLoadLink) {
            updateUrl();
        }
    }, [
        downLoadLink
    ]);
    const updateUrl = async ()=>{
        const url = await (0,helper/* getShortenedUrl */.Ppy)(downLoadLink);
        setUrl("".concat(constants.authorBaseUrl).concat(url));
    };
    const downloadHandle = (event)=>{
        event === null || event === void 0 ? void 0 : event.preventDefault();
        event === null || event === void 0 ? void 0 : event.stopPropagation();
        const getDownloadUrl = downloadUrl ? downloadUrl : window.location.href;
        (0,helper/* downloadArticle */.vIr)(getDownloadUrl, event, "", downloadSuccess, downloadFailure);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "download",
        "aria-label": "download",
        tabIndex: "0",
        children: downLoadLink ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
            href: downLoadLink,
            className: "download-trigger",
            "data-gbh-data-layer": getDownloadEventInfo(downLoadLink, pageType, componentPosition, mainTitle, dataLayerLinkType),
            "data-gbh-clickable": "true",
            onClick: downloadHandle,
            children: [
                "\xa0",
                download
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                "\xa0",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "download-trigger",
                    "data-gbh-data-layer": getDownloadEventInfo(downLoadLink, pageType, componentPosition, mainTitle, dataLayerLinkType),
                    "data-gbh-clickable": "true",
                    onClick: downloadHandle,
                    children: download
                })
            ]
        })
    });
};
/* harmony default export */ var v1_DownloadUtility = (DownloadUtility);

;// CONCATENATED MODULE: ./components/Default/Teaser/v1/Utilities.jsx







const Utilities = (param)=>{
    let { utilities =[] , title ="" , assetID ="" , imageServerUrl ="" , alt ="" , pageType ="" , dataLayerLinkType ="" , mainTitle ="" , downLoadLink ="" , containerId =""  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "cmp-teaser__icons",
        children: utilities.map((item, index)=>{
            switch(item === null || item === void 0 ? void 0 : item.utilitiesType){
                case constants.UTILITY_CONSTANTS.FAVOURITES:
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_FavouritesUtility, {
                        title: title,
                        assetID: assetID,
                        imageServerUrl: imageServerUrl,
                        alt: alt,
                        containerId: containerId
                    }, "".concat(item === null || item === void 0 ? void 0 : item.utilitiesType, "-").concat(index));
                case constants.UTILITY_CONSTANTS.SHARE:
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_ShareUtility, {
                        title: title,
                        assetID: assetID,
                        imageServerUrl: imageServerUrl,
                        alt: alt,
                        pageType: pageType,
                        dataLayerLinkType: dataLayerLinkType,
                        containerId: containerId
                    }, "".concat(item === null || item === void 0 ? void 0 : item.utilitiesType, "-").concat(index));
                case constants.UTILITY_CONSTANTS.PRINT:
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_PrintUtility, {
                        title: title,
                        assetID: assetID,
                        imageServerUrl: imageServerUrl,
                        alt: alt,
                        pageType: pageType,
                        dataLayerLinkType: dataLayerLinkType,
                        mainTitle: mainTitle
                    }, "".concat(item === null || item === void 0 ? void 0 : item.utilitiesType, "-").concat(index));
                case constants.UTILITY_CONSTANTS.DOWNLOAD:
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_DownloadUtility, {
                        title: title,
                        assetID: assetID,
                        imageServerUrl: imageServerUrl,
                        alt: alt,
                        pageType: pageType,
                        dataLayerLinkType: dataLayerLinkType,
                        mainTitle: mainTitle,
                        downLoadLink: downLoadLink
                    }, "".concat(item === null || item === void 0 ? void 0 : item.utilitiesType, "-").concat(index));
                default:
                    return null;
            }
        })
    });
};
/* harmony default export */ var v1_Utilities = (Utilities);

// EXTERNAL MODULE: ./components/Default/CarouselSlick/v1/SlickSettings.js + 1 modules
var SlickSettings = __webpack_require__(42426);
;// CONCATENATED MODULE: ./components/FindAProResults/v1/utils.js
const getDimensions = (ele)=>{
    const { height  } = ele.getBoundingClientRect();
    const offsetTop = ele.offsetTop;
    const offsetBottom = offsetTop + height;
    return {
        height,
        offsetTop,
        offsetBottom
    };
};
const FIND_A_PRO_RESULTS_PAGENAME = "kohler:services:find a pro results";

;// CONCATENATED MODULE: ./components/Default/Teaser/v1/helper.js

const isPageNameFindAProResults = (pageType)=>{
    return FIND_A_PRO_RESULTS_PAGENAME.includes(pageType);
};

;// CONCATENATED MODULE: ./components/Default/Teaser/v1/Teaser.jsx
/* eslint-disable react/jsx-no-target-blank */ 

















const Teaser = (props)=>{
    const [dynamicId, setDynamicId] = (0,react.useState)("");
    const { pageIsInteractive , datalayerPageName  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const { data: { id ="" , appliedCssClassNamesCustom ="" , linkURLRef =false , linkNewTab =false , linkAll =false , linkTitle =false , linkImage =false , title ="" , description ="" , enableFav =false , enableShare =false , mainTitle ="" , componentPosition ="" , pageType ="" , linkDescription ="" , linkURL ="" , caption ="" , datalayerLinkName ="" , componentLinkType ="" , eventName ="" , eventAction ="" , actions =[] , downLoadLink =null , expandText ="" , collapseText ="" , disableExpandCollapse ="" , imageResource: { imageServerUrl ="" , assetID ="" , pretitle: preTitle = "" , urlModifiers ="" , alt =""  } = {} , utilities =[] , utilitiesEnabled =false , dataLayerLinkType =""  } = {} , fullData ={} , showEmptyPlaceholder =false , maxHeight ="" , containerId ="" , pageName ="" , bodytitle =""  } = props;
    const [parentActionLink, setParentActionLink] = (0,react.useState)(linkURL);
    const [componentGroup, setComponentGroup] = (0,react.useState)([]);
    const [appliedCssClassNamesCustoms, setAppliedCssClassNamesCustoms] = (0,react.useState)([]);
    const [columnClassNames, setColumnClassNames] = (0,react.useState)("");
    const [general, setGeneral] = (0,react.useState)(null);
    const [innerCaption, setInnerCaption] = (0,react.useState)(false);
    const [isInsideImage, setIsInsideImage] = (0,react.useState)(false);
    const [activeIndex, setActive] = (0,react.useState)(0);
    const isSsr = (0,useIsSsr/* default */.Z)();
    const isCaptionOnly = Boolean(title || description || (actions === null || actions === void 0 ? void 0 : actions.length) || preTitle || assetID || showEmptyPlaceholder);
    const containerIdName = containerId ? containerId.replace(/-/g, " ") : "zone";
    (0,react.useEffect)(()=>{
        (0,constants_config/* getConfig */.i)().then((config)=>{
            setGeneral(config === null || config === void 0 ? void 0 : config.general);
        });
    }, []);
    (0,react.useEffect)(()=>{
        if (assetID) {
            const dynamicId = (0,helper/* createIdFromString */.ZT_)(assetID);
            setDynamicId(dynamicId);
        } else {
            const dynamicId1 = (0,helper/* createIdFromString */.ZT_)((0,helper/* getRandom */.sZz)() + "");
            setDynamicId(dynamicId1);
        }
    }, [
        assetID
    ]);
    (0,react.useEffect)(()=>{
        if (linkURL) {
            (0,helper/* getShortenedUrl */.Ppy)(linkURL).then((res)=>{
                const resBeforeHash = res === null || res === void 0 ? void 0 : res.split("#")[0];
                const resAfterHash = res === null || res === void 0 ? void 0 : res.split("#")[1];
                setParentActionLink(resBeforeHash && resAfterHash ? resBeforeHash + "#" + encodeURIComponent(resAfterHash) : res);
            });
        }
    }, [
        linkURL
    ]);
    (0,react.useEffect)(()=>{
        if (!isEmpty_default()(fullData)) {
            Object.keys(fullData).forEach((key)=>{
                setAppliedCssClassNamesCustoms((appliedCssClassNamesCustom)=>[
                        ...appliedCssClassNamesCustom,
                        fullData[key]["appliedCssClassNamesCustom"]
                    ]);
                setComponentGroup((cmpGroup)=>[
                        ...cmpGroup,
                        fullData[key][":type"]
                    ]);
            });
        }
    }, [
        fullData
    ]);
    (0,react.useEffect)(()=>{
        let classNameCustom = "";
        if (componentGroup.length > 0) {
            if (componentGroup.findIndex((a)=>{
                return a === null || a === void 0 ? void 0 : a.includes(constants.COMPONENT_TYPES.TEASER);
            }) > -1 && appliedCssClassNamesCustoms.findIndex((a)=>{
                return a === null || a === void 0 ? void 0 : a.includes("hero-banner-article-top");
            }) > -1 && appliedCssClassNamesCustoms.findIndex((a)=>{
                return a === null || a === void 0 ? void 0 : a.includes("hero-banner-article-bottom");
            }) === -1) {
                if (!(columnClassNames === null || columnClassNames === void 0 ? void 0 : columnClassNames.includes("hero-banner-top-only"))) {
                    classNameCustom += " hero-banner-top-only ";
                }
                if (!(columnClassNames === null || columnClassNames === void 0 ? void 0 : columnClassNames.includes("paddingbasedbreadcrum")) && componentGroup.findIndex((a)=>{
                    return a === null || a === void 0 ? void 0 : a.includes(constants.COMPONENT_TYPES.BREADCRUMB);
                }) > -1) {
                    classNameCustom += " paddingbasedbreadcrum ";
                }
                if (!(columnClassNames === null || columnClassNames === void 0 ? void 0 : columnClassNames.includes("without-breadcrumb")) && componentGroup.findIndex((a)=>{
                    return a === null || a === void 0 ? void 0 : a.includes(constants.COMPONENT_TYPES.BREADCRUMB);
                }) === -1) {
                    classNameCustom += " without-breadcrumb ";
                }
            }
        }
        setColumnClassNames((className)=>className += classNameCustom);
    }, [
        componentGroup
    ]);
    (0,react.useEffect)(()=>{
        if (!isSsr && pageIsInteractive) {
            if (constants.TEASER_CAPTION_CLASSES_LIST.some((classNames)=>{
                return classNames.split(" ").every((className)=>{
                    var ref;
                    return (ref = appliedCssClassNamesCustom === null || appliedCssClassNamesCustom === void 0 ? void 0 : appliedCssClassNamesCustom.trim()) === null || ref === void 0 ? void 0 : ref.includes(className);
                });
            })) {
                setInnerCaption(true);
            }
        }
    }, [
        isSsr,
        pageIsInteractive
    ]);
    (0,react.useEffect)(()=>{
        if (appliedCssClassNamesCustom) {
            checkUtilityPosition();
        }
    }, [
        appliedCssClassNamesCustom
    ]);
    let isMobile;
    if (true) {
        isMobile = window.innerWidth <= 639;
    }
    const checkUtilityPosition = ()=>{
        let isInsideImage = false;
        constants.TEASER_CLASSES.forEach((item)=>{
            isInsideImage = appliedCssClassNamesCustom.includes(item);
            if (isInsideImage) {
                setIsInsideImage(isInsideImage);
                return;
            }
        });
    };
    const getDataLayerLinkType = ()=>{
        if (mainTitle || title) {
            return "".concat(pageType, ":").concat(mainTitle || title);
        }
        return dataLayerLinkType;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "teaser ".concat(appliedCssClassNamesCustom ? appliedCssClassNamesCustom : "").concat(columnClassNames),
        children: [
            isCaptionOnly ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "cmp-teaser",
                "data-gbh-data-layer": (e)=>addTeaserAnalytic(e, linkNewTab, pageType, linkURL, datalayerLinkName, containerIdName, mainTitle, eventName, eventAction),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(utils/* ConditionalWrapper */.M2, {
                    condition: linkAll,
                    wrapper: (children)=>{
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("a", {
                            href: parentActionLink,
                            target: linkNewTab ? "_blank" : "_self",
                            "data-gbh-clickable": "true",
                            rel: "noreferrer",
                            onClick: ()=>{
                                var ref;
                                return addTeaserLinkAnalytics(fullData, parentActionLink, bodytitle, containerId, props.data, datalayerPageName, fullData === null || fullData === void 0 ? void 0 : (ref = fullData.teaser) === null || ref === void 0 ? void 0 : ref.datalayerLinkName);
                            },
                            children: children
                        });
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "cq-dd-image cmp-teaser__image",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "cmp-image",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "s7responsiveContainer cmp-teaser__image cmp-image__image",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(utils/* ConditionalWrapper */.M2, {
                                            condition: linkImage,
                                            wrapper: (children)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: parentActionLink,
                                                    target: linkNewTab ? "_blank" : "_self",
                                                    "data-gbh-clickable": "true",
                                                    rel: "noreferrer",
                                                    children: children
                                                }),
                                            children: !isSsr ? assetID || showEmptyPlaceholder ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicImage["default"], {
                                                style: maxHeight && showEmptyPlaceholder && !assetID ? {
                                                    maxHeight
                                                } : {},
                                                className: "fluidimage cmp-image__image",
                                                imgUrl: "".concat(assetID ? "".concat(imageServerUrl).concat(assetID) : constants.EMPTY_PIXEL),
                                                alt: alt,
                                                itemProp: "contentUrl",
                                                uniqueId: dynamicId,
                                                urlModifiers: urlModifiers
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ImagePlaceHolder/* default */.Z, {
                                                assetID: assetID
                                            }) : null
                                        })
                                    })
                                }),
                                isInsideImage && utilitiesEnabled && (utilities === null || utilities === void 0 ? void 0 : utilities.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_Utilities, {
                                    utilities: utilities,
                                    title: title,
                                    assetID: assetID,
                                    imageServerUrl: imageServerUrl,
                                    alt: alt,
                                    pageType: pageType,
                                    dataLayerLinkType: getDataLayerLinkType(),
                                    mainTitle: mainTitle,
                                    downLoadLink: downLoadLink,
                                    containerId: containerId
                                }) : null,
                                innerCaption && caption ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "cmp-img-caption",
                                    children: (0,helper/* sanitizeInnerHtml */.KD0)(caption)
                                }) : null
                            ]
                        }),
                        title || description || enableFav || enableShare || actions && actions.length || preTitle ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "cmp-teaser__content",
                            style: isMobile && !(0,SlickSettings/* isProductFeatureLandscapeCarouselUpdatePage */.UD)(pageName) && !isPageNameFindAProResults(pageName) ? {
                                width: "100%"
                            } : {},
                            children: [
                                preTitle ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "cmp-teaser__pretitle",
                                    children: (0,helper/* sanitizeInnerHtml */.KD0)(preTitle)
                                }) : null,
                                title ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "cmp-teaser__title",
                                    id: id,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(utils/* ConditionalWrapper */.M2, {
                                        condition: linkTitle,
                                        wrapper: (children)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: linkURL,
                                                rel: linkURLRef ? "noreferrer" : "",
                                                target: linkNewTab ? "_blank" : "_self",
                                                "data-gbh-data-layer": getTitleEventInfo(linkNewTab, componentPosition, linkURL, mainTitle, pageType, componentLinkType, title),
                                                "data-gbh-clickable": "true",
                                                children: children
                                            }),
                                        children: (0,helper/* sanitizeInnerHtml */.KD0)(title)
                                    })
                                }) : null,
                                description ? /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_Description, {
                                    linkURLRef: linkURLRef,
                                    general: general,
                                    linkNewTab: linkNewTab,
                                    description: description,
                                    mainTitle: mainTitle,
                                    componentPosition: componentPosition,
                                    pageType: pageType,
                                    linkDescription: linkDescription,
                                    expandText: expandText,
                                    collapseText: collapseText,
                                    disableExpandCollapse: disableExpandCollapse,
                                    preTitle: preTitle
                                }) : null,
                                actions && (actions === null || actions === void 0 ? void 0 : actions.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "cmp-teaser__action-container",
                                    children: actions.map((action, index)=>{
                                        const { playVideoCTA =false , primaryCTA =false , secondaryCTA =false , url ="" , title ="" , newTab ="" , urlRef =""  } = action;
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_Action, {
                                            playVideoCTA: (0,helper/* convertStringToBoolean */.mUs)(playVideoCTA),
                                            primaryCTA: (0,helper/* convertStringToBoolean */.mUs)(primaryCTA),
                                            secondaryCTA: (0,helper/* convertStringToBoolean */.mUs)(secondaryCTA),
                                            link: url,
                                            text: title,
                                            newTab: (0,helper/* convertStringToBoolean */.mUs)(newTab),
                                            urlRef: urlRef,
                                            id: id,
                                            dataLayerLinkType: dataLayerLinkType,
                                            pageType: pageType,
                                            linkAll: (0,helper/* convertStringToBoolean */.mUs)(linkAll),
                                            mainTitle: mainTitle,
                                            index: index,
                                            activeIndex: activeIndex,
                                            setActive: setActive
                                        }, "teaser-action-".concat(index + 1, "-").concat((0,helper/* getRandom */.sZz)()));
                                    })
                                }) : null,
                                !isInsideImage && utilitiesEnabled && (utilities === null || utilities === void 0 ? void 0 : utilities.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_Utilities, {
                                    utilities: utilities,
                                    title: title,
                                    assetID: assetID,
                                    imageServerUrl: imageServerUrl,
                                    alt: alt,
                                    pageType: pageType,
                                    dataLayerLinkType: getDataLayerLinkType(),
                                    mainTitle: mainTitle,
                                    downLoadLink: downLoadLink,
                                    containerId: containerId
                                }) : null
                            ]
                        }) : null
                    ]
                })
            }) : null,
            !innerCaption && caption ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "cmp-img-caption",
                children: (0,helper/* sanitizeInnerHtml */.KD0)(caption)
            }) : null
        ]
    });
};
/* harmony default export */ var v1_Teaser = (Teaser);

;// CONCATENATED MODULE: ./components/Default/Carousel/v1/CarouselFiller.jsx



const CarouselFiller = (param)=>{
    let { itemsOrder =[] , items =[]  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "cmp-carousel__whole",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "cmp-carousel__content",
            children: itemsOrder.map((itemOrder, i)=>{
                const item = items[itemOrder];
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "cmp-carousel__item".concat(i === 0 ? " cmp-carousel__item--active" : ""),
                    role: "tabpanel",
                    "aria-label": "Slide ".concat(i + 1, " of ").concat(itemsOrder === null || itemsOrder === void 0 ? void 0 : itemsOrder.length),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_Teaser, {
                        data: item
                    })
                }, "carousel-".concat(i));
            })
        })
    });
};
/* harmony default export */ var v1_CarouselFiller = (CarouselFiller);

;// CONCATENATED MODULE: ./components/Default/Carousel/v1/Carousel.jsx










const Carousel = (props)=>{
    const { data: { carouselComponentProperties: { appliedCssClassNames ="" , ":itemsOrder": itemsOrder = [] , ":items": items = [] , autoplay =false  } = {} , bodytitle ="" , texttitle ="" , description ="" , showSlideIndicators =true , slidertype =""  } = {} , fullData ={}  } = props;
    const isSsr = (0,useIsSsr/* default */.Z)();
    const [isOverlayScrollbar, setIsOverlayScrollbar] = (0,react.useState)(false);
    const [componentGroup, setComponentGroup] = (0,react.useState)([]);
    const [customClassNames, setCustomClassNames] = (0,react.useState)("");
    const [cmpCarouselCustomClass, setCmpCarouselCustomClass] = (0,react.useState)("");
    const [activeBanner, setActiveBanner] = (0,react.useState)(0);
    const scrollOptions = {
        className: "os-theme-dark cmp-carousel__whole",
        style: {
            height: "auto"
        },
        scrollbars: {
            visibility: "auto",
            autoHide: "never",
            clickScrolling: true,
            touchSupport: true,
            dragScrolling: true
        }
    };
    const showCarouselText = bodytitle || texttitle || description;
    const scrollerRef = (0,react.useRef)();
    (0,react.useEffect)(()=>{
        if (scrollerRef.current) {
            setTimeout(()=>{
                document.querySelectorAll(".carousel-bottom-scroll").forEach((scrollDiv, index)=>{
                    let heightToSet = 0;
                    scrollDiv === null || scrollDiv === void 0 ? void 0 : scrollDiv.querySelectorAll(".cmp-carousel__content").forEach((scrollDivContent, index)=>{
                        if (scrollDivContent && heightToSet < (scrollDivContent === null || scrollDivContent === void 0 ? void 0 : scrollDivContent.offsetHeight)) {
                            heightToSet = scrollDivContent === null || scrollDivContent === void 0 ? void 0 : scrollDivContent.offsetHeight;
                        }
                    });
                    scrollDiv === null || scrollDiv === void 0 ? void 0 : scrollDiv.querySelectorAll(".os-content-glue").forEach((scrollDivglu, index)=>{
                        if (scrollDivglu && heightToSet > 0) {
                            scrollDivglu.style.height = heightToSet + "px";
                        }
                    });
                });
            }, 2000);
        }
    }, [
        scrollerRef.current
    ]);
    (0,react.useEffect)(()=>{
        if ((appliedCssClassNames === null || appliedCssClassNames === void 0 ? void 0 : appliedCssClassNames.includes("carousel-bottom-scroll")) || (appliedCssClassNames === null || appliedCssClassNames === void 0 ? void 0 : appliedCssClassNames.includes("carousel-btm-scroll-title-small"))) {
            setIsOverlayScrollbar(true);
        }
    }, []);
    (0,react.useEffect)(()=>{
        const style = document.createElement("style");
        style.innerHTML = "\n    .os-scrollbar-track {\n      background-color: #888 !important;\n    }\n    .os-scrollbar-handle {\n      background-color: #fff !important;\n    }\n  ";
        document.head.appendChild(style);
        return ()=>{
            document.head.removeChild(style);
        };
    }, []);
    (0,react.useEffect)(()=>{
        if (!isEmpty_default()(fullData)) {
            Object.keys(fullData).forEach((key)=>{
                setComponentGroup((cmpGroup)=>[
                        ...cmpGroup,
                        fullData[key][":type"]
                    ]);
            });
        }
    }, [
        fullData
    ]);
    (0,react.useEffect)(()=>{
        itemsOrder.forEach((key, i)=>{
            var ref;
            const item = items[key];
            if ((item === null || item === void 0 ? void 0 : (ref = item.appliedCssClassNamesCustom) === null || ref === void 0 ? void 0 : ref.includes("hero-banner-des-medium-center")) && i === 0 && !(customClassNames === null || customClassNames === void 0 ? void 0 : customClassNames.includes("center-double-btn"))) {
                setCustomClassNames((className)=>className += " center-double-btn");
            }
        });
    }, [
        itemsOrder
    ]);
    (0,react.useEffect)(()=>{
        if (componentGroup.length > 0) {
            if (componentGroup.find((a)=>{
                return a === null || a === void 0 ? void 0 : a.includes(constants.COMPONENT_TYPES.BREADCRUMB);
            }) && componentGroup.find((a)=>{
                return a === null || a === void 0 ? void 0 : a.includes(constants.COMPONENT_TYPES.CAROUSEL);
            }) && !(customClassNames === null || customClassNames === void 0 ? void 0 : customClassNames.includes("breadcrums-withcarosel paddingbasedbreadcrum"))) {
                setCustomClassNames((className)=>className += " breadcrums-withcarosel paddingbasedbreadcrum");
            }
            if (componentGroup.find((a)=>{
                return a === null || a === void 0 ? void 0 : a.includes(constants.COMPONENT_TYPES.BREADCRUMB);
            }) && componentGroup.find((a)=>{
                return a === null || a === void 0 ? void 0 : a.includes(constants.COMPONENT_TYPES.CAROUSEL);
            }) && !(customClassNames === null || customClassNames === void 0 ? void 0 : customClassNames.includes("aem-GridColumn aem-GridColumn--default--12"))) {
                setCustomClassNames((className)=>className += " aem-GridColumn aem-GridColumn--default--12");
            }
        }
    }, [
        componentGroup
    ]);
    (0,react.useEffect)(()=>{
        if ((appliedCssClassNames === null || appliedCssClassNames === void 0 ? void 0 : appliedCssClassNames.includes("carousel-btm-scroll-title-small")) && !(cmpCarouselCustomClass === null || cmpCarouselCustomClass === void 0 ? void 0 : cmpCarouselCustomClass.includes("carousel-btm-scroll-title-small"))) {
            setCmpCarouselCustomClass((className)=>className += " slide-scrollbar");
        }
    }, [
        appliedCssClassNames
    ]);
    const getNextBanner = ()=>{
        const nextBanner = activeBanner + 1;
        if (nextBanner < itemsOrder.length) {
            setActiveBanner(nextBanner);
        } else {
            setActiveBanner(0);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "carousel ".concat(appliedCssClassNames ? appliedCssClassNames : "").concat(customClassNames),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "cmp-carousel".concat(cmpCarouselCustomClass),
            children: [
                showCarouselText ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "cmp-carousel-text",
                    children: [
                        bodytitle ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "cmp-carousel__pretitle",
                            role: "heading",
                            dangerouslySetInnerHTML: {
                                __html: browser_default().sanitize(bodytitle)
                            }
                        }) : null,
                        texttitle ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "cmp-carousel__title",
                            dangerouslySetInnerHTML: {
                                __html: browser_default().sanitize(texttitle)
                            }
                        }) : null,
                        description ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "cmp-carousel__description",
                            dangerouslySetInnerHTML: {
                                __html: browser_default().sanitize(description)
                            }
                        }) : null
                    ]
                }) : null,
                !isSsr ? /*#__PURE__*/ (0,jsx_runtime.jsx)(utils/* ConditionalWrapper */.M2, {
                    condition: isOverlayScrollbar,
                    wrapper: (children)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(OverlayScrollbarsComponent, {
                            options: scrollOptions,
                            ref: scrollerRef,
                            defer: true,
                            children: children
                        }),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "cmp-carousel__content",
                        children: [
                            itemsOrder && itemsOrder.map((key, i)=>{
                                const item = items[key];
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "cmp-carousel__item".concat(i === activeBanner ? " cmp-carousel__item--active" : ""),
                                    role: "tabpanel",
                                    "aria-label": "Slide ".concat(i + 1, " of ").concat(itemsOrder === null || itemsOrder === void 0 ? void 0 : itemsOrder.length),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_AemGrid, {
                                        data: item,
                                        bodytitle: bodytitle
                                    })
                                }, "carousel-".concat(i));
                            }),
                            (itemsOrder === null || itemsOrder === void 0 ? void 0 : itemsOrder.length) > 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "cmp-carousel__actions",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                        className: "cmp-carousel__action cmp-carousel__action--previous",
                                        type: "button",
                                        "aria-label": "Previous",
                                        "data-cmp-hook-carousel": "previous",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "cmp-carousel__action-icon"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "cmp-carousel__action-text",
                                                children: "Previous"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                        className: "cmp-carousel__action cmp-carousel__action--next",
                                        type: "button",
                                        "aria-label": "Next",
                                        "data-cmp-hook-carousel": "next",
                                        onClick: getNextBanner,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "cmp-carousel__action-icon"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "cmp-carousel__action-text",
                                                children: "Next"
                                            })
                                        ]
                                    }),
                                    autoplay && /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                        className: "cmp-carousel__action cmp-carousel__action--pause",
                                        type: "button",
                                        "aria-label": "Pause",
                                        "data-cmp-hook-carousel": "pause",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "cmp-carousel__action-icon"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "cmp-carousel__action-text",
                                                children: "Pause"
                                            })
                                        ]
                                    }),
                                    autoplay && /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                        className: "cmp-carousel__action cmp-carousel__action--play cmp-carousel__action--disabled",
                                        type: "button",
                                        "aria-label": "Play",
                                        "data-cmp-hook-carousel": "play",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "cmp-carousel__action-icon"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "cmp-carousel__action-text",
                                                children: "Play"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            (slidertype === "slideindicator" || showSlideIndicators) && /*#__PURE__*/ (0,jsx_runtime.jsx)("ol", {
                                className: "".concat(slidertype === "slideindicator" || showSlideIndicators ? "cmp-carousel__indicators" : "cmp-carousel__hyphen"),
                                role: "tablist",
                                "aria-label": "Choose a slide to display",
                                "data-cmp-hook-carousel": "indicators",
                                children: itemsOrder && (itemsOrder === null || itemsOrder === void 0 ? void 0 : itemsOrder.length) > 1 && itemsOrder.map((key, i, arr)=>{
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        className: "cmp-carousel__indicator".concat(i === 0 ? " cmp-carousel__indicator--active" : ""),
                                        role: "tab",
                                        "aria-label": "Slide ".concat(i + 1),
                                        "data-cmp-hook-carousel": "indicator",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "cmp-carousel__indicator--activeNum",
                                                children: i + 1
                                            }),
                                            "/ ".concat(arr === null || arr === void 0 ? void 0 : arr.length)
                                        ]
                                    }, "carousel-".concat(i));
                                })
                            })
                        ]
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_CarouselFiller, {
                    itemsOrder: itemsOrder,
                    items: items
                })
            ]
        })
    });
};
/* harmony default export */ var v1_Carousel = (Carousel);

// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var react_slick_lib = __webpack_require__(46066);
// EXTERNAL MODULE: ./node_modules/lodash/isEqual.js
var isEqual = __webpack_require__(18446);
var isEqual_default = /*#__PURE__*/__webpack_require__.n(isEqual);
// EXTERNAL MODULE: ./components/Default/CarouselSlick/v1/CarouselSlick.module.scss
var CarouselSlick_module = __webpack_require__(43419);
var CarouselSlick_module_default = /*#__PURE__*/__webpack_require__.n(CarouselSlick_module);
// EXTERNAL MODULE: ./public/images/image-missing.png
var image_missing = __webpack_require__(36513);
;// CONCATENATED MODULE: ./components/Default/Image/v1/Image.jsx



const v1_Image_Image = (props)=>{
    const { data: { id: uniqueId = "" , alt ="" , src: imgUrl = "" , imageComponentProperties ={
        src: "",
        alt: ""
    } , enableNoImage =false  } = {}  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "image",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "eaem-bounding-div",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "cmp-image",
                children: !enableNoImage ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicImage["default"], {
                    uniqueId,
                    imgUrl: imgUrl || imageComponentProperties.src,
                    alt: alt || imageComponentProperties.alt,
                    className: "cmp-image__image transition"
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: image_missing/* default */.Z === null || image_missing/* default */.Z === void 0 ? void 0 : image_missing/* default.src */.Z.src,
                    alt: "image coming soon",
                    className: "no-image"
                })
            })
        })
    });
};
/* harmony default export */ var v1_Image = (v1_Image_Image);

;// CONCATENATED MODULE: ./components/Default/CarouselSlick/v1/AnalyticCarouselSlick.js
const getDataLayerValues = function(isSSR) {
    let pageName = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", link = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", title = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", linkName = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "";
    if (!isSSR && window) {
        var ref;
        const dataLayer = (ref = window === null || window === void 0 ? void 0 : window.adobeDataLayer) !== null && ref !== void 0 ? ref : {};
        var _page;
        const page = (_page = dataLayer === null || dataLayer === void 0 ? void 0 : dataLayer.getState().page) !== null && _page !== void 0 ? _page : {};
        if (Object.keys(page).length) {
            const eventInfo = {
                clickInternalLinks: "true",
                eventAction: "".concat(pageName, ":").concat(title.toLowerCase(), ":").concat(linkName.toLowerCase()),
                eventMsg: "n/a",
                eventName: "".concat(pageName, ":").concat(title.toLowerCase(), ":").concat(linkName.toLowerCase()),
                eventStatus: "n/a",
                eventType: "teaser",
                internalLinkName: "".concat(linkName.toLowerCase()),
                internalLinkPosition: "".concat(title.toLowerCase()),
                internalLinkType: "".concat(pageName, ":").concat(linkName.toLowerCase()),
                internalLinkURL: "".concat(link),
                internalLinkZoneName: "".concat(pageName, ":").concat(title.toLowerCase())
            };
            return JSON.stringify(eventInfo);
        }
    }
    return "";
};
const addAnalyticsSlic = function(event) {
    let pageName = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", datalayerTitleText = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", componentLinkType = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", componentPosition = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "", link = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : "";
    const titleOptions = [
        "showerheads",
        "handshowers",
        "body sprays",
        "rainheads"
    ];
    event.stopPropagation();
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const { productInfo  } = page;
    let eventInfo = {};
    if (titleOptions.some((title)=>datalayerTitleText === title)) {
        eventInfo = {
            eventAction: "pdp:complete the experience:".concat(datalayerTitleText),
            eventName: "pdp:complete the experience:".concat(datalayerTitleText),
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: datalayerTitleText,
            internalLinkPosition: "pdp:teaser",
            internalLinkType: "pdp:".concat(datalayerTitleText),
            internalLinkZoneName: "pdp:complete the experience",
            internalLinkURL: link || "na",
            clickInternalLinks: "true"
        };
    } else {
        eventInfo = {
            eventName: "".concat(pageName, ":carousel:interaction"),
            eventAction: "".concat(pageName, ":carousel:interaction"),
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: "carousel:".concat(datalayerTitleText || "rm"),
            internalLinkType: "".concat(pageName, ":").concat((componentLinkType === null || componentLinkType === void 0 ? void 0 : componentLinkType.toLowerCase()) || datalayerTitleText || "rm"),
            internalLinkZoneName: "".concat(pageName, ":carousel"),
            clickInternalLinks: "true",
            eventType: "carousel",
            internalLinkURL: link || "na",
            internalLinkPosition: "".concat(pageName, ":").concat(componentPosition || "carousel")
        };
    }
    pushAnalyticsObjToDataLayer(eventInfo, productInfo);
};
const pushAnalyticsObjToDataLayer = function() {
    let eventInfo = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, productInfo = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const event = "cmp:click";
    window.adobeDataLayer.push({
        event,
        eventInfo,
        page,
        productInfo
    });
};

;// CONCATENATED MODULE: ./components/Default/CarouselSlick/v1/CarouselSlick.jsx
















const CarouselSlick = (props)=>{
    var ref;
    const isSsr = (0,useIsSsr/* default */.Z)();
    const { data , data: { carouselComponentProperties: { id ="" , autoplay =false , delay =constants["default"].SLICK.DEFAULT_DELAY , appliedCssClassNames ="" , ":itemsOrder": itemsOrder = [] , ":items": items = [] , accessibilityLabel =""  } = {} , pageName ="" , datalayerTitleText ="" , componentLinkType ="" , link: linkUrl = "" , componentPosition ="" , linkAll =false , isNewTab =false , bodytitle ="" , texttitle ="" , description ="" , actionsEnabled =false , text ="" , showSlideIndicators =false , centerMode =false  } = {} , fullData ={}  } = props;
    const { winWidth  } = (0,useWindowDimensions/* default */.Z)();
    const sliderDelay = 1500;
    const [slickSettings, setSlickSettings] = (0,react.useState)({});
    const [cardIndex, setCardIndex] = (0,react.useState)(0);
    const [sliderKey, setSliderKey] = (0,react.useState)("");
    const [cardCount, setCardCount] = (0,react.useState)(0);
    const [isDoubleFeatureContentCard, setIsDoubleFeatureContentCard] = (0,react.useState)(false);
    const [isSingleSlider, setIsSingleSlider] = (0,react.useState)(false);
    const [isSingleItemsSlider, setIsSingleItemsSlider] = (0,react.useState)(false);
    const [isFeatureContentSlider, setIsFeatureContentSlider] = (0,react.useState)(false);
    const [carouselVertical, setCarouselVertical] = (0,react.useState)(false);
    const [isInspiredThemeCarouselSlider, setIsInspiredThemeCarouselSlider] = (0,react.useState)(false);
    const [activeSlide, setActiveSlide] = (0,react.useState)(1);
    const [link, setLink] = (0,react.useState)(linkUrl);
    const carouselHeaderInfoRef = (0,react.useRef)(null);
    const sliderRef = (0,react.useRef)(null);
    const [topContentHeight, setTopContentHeight] = (0,react.useState)(0);
    const [sliderImageHeight, setSliderImageHeight] = (0,react.useState)(0);
    const [countHeight, setCountHeight] = (0,react.useState)(0);
    const [arrowHeight, setArrowHeight] = (0,react.useState)(0);
    const [sliderRerenderKey, setSliderRerenderKey] = (0,react.useState)("");
    const [teaserImagePosition, setTeaserImagePosition] = (0,react.useState)({});
    let dynamicMediaTimer;
    const getImageHeight = (list)=>{
        if (dynamicMediaTimer) {
            clearTimeout(dynamicMediaTimer);
            dynamicMediaTimer = undefined;
        }
        // using query selector as s7responsiveImage is invoking functions on real dom elements ans was unable to get updated data using useRef
        const teaserImages = list.querySelectorAll(".slick-active .teaser .cmp-teaser__image .cmp-image");
        var ref;
        const teaserImageComponent = (ref = teaserImages[0]) !== null && ref !== void 0 ? ref : null;
        let teaserImage = null;
        if (teaserImageComponent) {
            teaserImage = teaserImageComponent.querySelector("img");
        }
        let imageUrl = null;
        if (teaserImage) {
            imageUrl = teaserImage === null || teaserImage === void 0 ? void 0 : teaserImage.currentSrc;
        }
        if (!window.s7responsiveImage || !imageUrl || imageUrl && imageUrl.startsWith("data:")) {
            dynamicMediaTimer = setTimeout(()=>getImageHeight(list), 200);
            return;
        }
        const imageHeight = teaserImageComponent === null || teaserImageComponent === void 0 ? void 0 : teaserImageComponent.offsetHeight;
        if (carouselVertical) {
            const teaserContent = list.querySelector(".cmp-teaser__content");
            const teaserContectHeight = teaserContent ? teaserContent.offsetHeight : 0;
            setTeaserImagePosition({
                imgHeight: imageHeight,
                ctHeight: teaserContectHeight
            });
        }
        if (imageHeight) setSliderImageHeight(imageHeight);
    };
    (0,react.useEffect)(()=>{
        const { current: { offsetHeight =0  } = {}  } = carouselHeaderInfoRef;
        if (offsetHeight > 0) {
            setTopContentHeight(offsetHeight);
        }
    }, [
        carouselHeaderInfoRef
    ]);
    (0,react.useEffect)(()=>{
        const { current: { innerSlider: { list  }  } = {}  } = sliderRef;
        if (list && sliderRerenderKey) {
            getImageHeight(list);
        }
    }, [
        sliderRef,
        sliderRerenderKey
    ]);
    (0,react.useEffect)(()=>{
        const handleWindowResize = ()=>{
            const { current: { innerSlider: { list  }  } = {}  } = sliderRef;
            getImageHeight(list);
            setCounterPosition();
        };
        window.addEventListener("resize", handleWindowResize);
        return ()=>{
            window.removeEventListener("resize", handleWindowResize);
        };
    }, []);
    const setCounterPosition = ()=>{
        let countHeight = parseInt(topContentHeight) + parseInt(sliderImageHeight) + constants["default"].SLICK.COUNT_OFFSET;
        if (carouselVertical) {
            const ctHeight = teaserImagePosition === null || teaserImagePosition === void 0 ? void 0 : teaserImagePosition.ctHeight;
            const imgHeight = teaserImagePosition === null || teaserImagePosition === void 0 ? void 0 : teaserImagePosition.imgHeight;
            countHeight = ctHeight && imgHeight ? imgHeight - ctHeight - 70 : 0;
            if (lib/* isMobile */.tq) {
                countHeight = imgHeight ? imgHeight + topContentHeight - 80 : 0;
            }
            if ((window === null || window === void 0 ? void 0 : window.innerWidth) > 767) {
                countHeight = ctHeight && imgHeight ? imgHeight - ctHeight - 70 : 0;
            }
        }
        setCountHeight(countHeight);
        if (winWidth <= 1023) {
            const arrowHeight = parseInt(sliderImageHeight) + constants["default"].SLICK.ARROW_OFFSET;
            setArrowHeight(arrowHeight);
        }
    };
    (0,react.useEffect)(()=>{
        setCounterPosition();
    }, [
        topContentHeight,
        sliderImageHeight,
        carouselVertical,
        teaserImagePosition,
        winWidth
    ]);
    (0,react.useEffect)(()=>{
        if (!isEmpty_default()(fullData) && (isDoubleFeatureContentCard || carouselVertical)) {
            const cardCount = Object.keys(fullData).length - 1;
            setCardCount(cardCount);
            Object.keys(fullData).forEach((key, index)=>{
                if (isEqual_default()(fullData[key], data)) {
                    setCardIndex(index + 1);
                }
            });
        }
    }, [
        fullData,
        isDoubleFeatureContentCard
    ]);
    (0,react.useEffect)(()=>{
        let timer;
        if (isDoubleFeatureContentCard) {
            if (cardIndex > 0 && cardCount > 0) {
                const delay = 1500 * (cardIndex - 1);
                timer = setTimeout(()=>{
                    setSlickSettings(()=>({
                            ...SlickSettings/* doubleFeatureContentCardSettings */.Cu,
                            autoplay: true,
                            speed: 2 * sliderDelay,
                            autoplaySpeed: cardCount * sliderDelay
                        }));
                    setSliderKey(cardIndex);
                }, delay);
            }
        }
        return ()=>{
            if (timer) {
                clearTimeout(timer);
            }
        };
    }, [
        cardIndex,
        cardCount,
        isDoubleFeatureContentCard
    ]);
    const getSliderCount = ()=>{
        if (window) {
            return window.innerWidth > 1140 ? 4 : window.innerWidth > 640 ? 2 : 1;
        } else {
            return winWidth > 1140 ? 4 : winWidth > 640 ? 2 : 1;
        }
    };
    (0,react.useEffect)(()=>{
        if (isSingleSlider) {
            const slickSettings = (0,SlickSettings/* singleSliderSettings */.NW)(setActiveSlide, arrowHeight, autoplay, delay);
            setSlickSettings(slickSettings);
        }
        if (isSingleItemsSlider || isFeatureContentSlider) {
            const settings = (0,SlickSettings/* singleSliderSettings */.NW)(setActiveSlide, arrowHeight, autoplay, delay);
            const slickSettings1 = ()=>({
                    ...settings,
                    ...isSingleItemsSlider ? {
                        centerPadding: window.innerWidth > 1600 ? window.innerWidth / 8 : 72
                    } : {},
                    centerMode: (0,SlickSettings/* isProductFeatureLandscapeCarouselUpdatePage */.UD)(pageName) ? centerMode : window.innerWidth >= 640
                });
            setSlickSettings(slickSettings1());
        }
        if (isInspiredThemeCarouselSlider) {
            const settings1 = (0,SlickSettings/* singleSliderSettings */.NW)();
            const slickSettings2 = ()=>({
                    ...settings1,
                    autoplay: false,
                    autoplaySpeed: 5000,
                    slidesToScroll: 1,
                    slidesToShow: getSliderCount()
                });
            setSlickSettings(slickSettings2());
        }
        if (carouselVertical) {
            const settings2 = (0,SlickSettings/* singleSliderSettings */.NW)(setActiveSlide);
            const slickSettings3 = ()=>({
                    ...settings2,
                    autoplay: true,
                    fade: true,
                    autoplaySpeed: 5000,
                    arrows: false
                });
            setSlickSettings(slickSettings3());
        }
    }, [
        isSingleSlider,
        isSingleItemsSlider,
        isFeatureContentSlider,
        isInspiredThemeCarouselSlider,
        carouselVertical,
        arrowHeight
    ]);
    (0,react.useEffect)(()=>{
        if (appliedCssClassNames === null || appliedCssClassNames === void 0 ? void 0 : appliedCssClassNames.includes("two-column-layout")) {
            setIsDoubleFeatureContentCard(true);
        }
        if ((appliedCssClassNames === null || appliedCssClassNames === void 0 ? void 0 : appliedCssClassNames.includes("feature-collection-carousel")) || (appliedCssClassNames === null || appliedCssClassNames === void 0 ? void 0 : appliedCssClassNames.includes("room-inspiration-carousel"))) {
            setIsSingleSlider(true);
        }
        if ((appliedCssClassNames === null || appliedCssClassNames === void 0 ? void 0 : appliedCssClassNames.includes("carousel-text-left-overlap")) || (appliedCssClassNames === null || appliedCssClassNames === void 0 ? void 0 : appliedCssClassNames.includes("full-bleed-image-hover"))) {
            setIsSingleItemsSlider(true);
        }
        if (appliedCssClassNames === null || appliedCssClassNames === void 0 ? void 0 : appliedCssClassNames.includes("featured-content-carousel")) {
            setIsFeatureContentSlider(true);
        }
        if (appliedCssClassNames === null || appliedCssClassNames === void 0 ? void 0 : appliedCssClassNames.includes("inspired-theme-carousel")) {
            setIsInspiredThemeCarouselSlider(true);
        }
        if (appliedCssClassNames === null || appliedCssClassNames === void 0 ? void 0 : appliedCssClassNames.includes("carousel-vertical")) {
            setCarouselVertical(true);
        }
    }, [
        data
    ]);
    (0,react.useEffect)(()=>{
        if (linkUrl) {
            (0,helper/* getShortenedUrl */.Ppy)(linkUrl).then((res)=>{
                setLink(res);
            });
        }
    }, [
        linkUrl
    ]);
    (0,react.useEffect)(()=>{
        let key = "slider-default";
        if (sliderKey) {
            key = "slider-".concat(sliderKey);
        }
        if (isSingleItemsSlider || isSingleSlider || isFeatureContentSlider || isInspiredThemeCarouselSlider || carouselVertical) {
            key = "slider-".concat(id ? id : appliedCssClassNames);
        }
        setSliderRerenderKey(key);
    }, [
        sliderKey,
        isSingleItemsSlider,
        isSingleSlider,
        isFeatureContentSlider,
        isInspiredThemeCarouselSlider,
        carouselVertical
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "cmp-carousel cmp-carousel-slick ".concat(carouselVertical ? (CarouselSlick_module_default()).CarouselSlickVertical : ""),
                role: "group",
                "aria-label": accessibilityLabel || undefined,
                "aria-roledescription": "carousel",
                "data-gbh-data-layer": '{"eventName":"'.concat(pageName, ':carousel:interaction","eventAction":"').concat(pageName, ':carousel:interaction","internalLinkName":"carousel:').concat(datalayerTitleText || "rm", '","internalLinkType":"').concat(pageName, ":").concat((componentLinkType === null || componentLinkType === void 0 ? void 0 : componentLinkType.toLowerCase()) || datalayerTitleText || "rm", '","clickInternalLinks":"true","eventType":"carousel","internalLinkPosition":"').concat(pageName, ":").concat(componentPosition || "carousel", '"}'),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(utils/* ConditionalWrapper */.M2, {
                    condition: (0,helper/* convertStringToBoolean */.mUs)(linkAll),
                    wrapper: (children)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: link,
                            onClick: (event)=>{
                                addAnalyticsSlic(event, pageName, datalayerTitleText, componentLinkType, componentPosition, link);
                            },
                            target: "".concat((0,helper/* convertStringToBoolean */.mUs)(isNewTab) ? "_blank" : "_self"),
                            children: children
                        }),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "carousel-header-info",
                                ref: carouselHeaderInfoRef,
                                children: [
                                    bodytitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "cmp-carousel__pretitle",
                                        dangerouslySetInnerHTML: {
                                            __html: bodytitle
                                        }
                                    }),
                                    texttitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "cmp-carousel__title ".concat(carouselVertical ? "verticalCarouselTitle" : ""),
                                        dangerouslySetInnerHTML: {
                                            __html: texttitle
                                        }
                                    }),
                                    description && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "cmp-carousel__description ".concat(carouselVertical ? "verticalCarouselTitleDescription" : ""),
                                        dangerouslySetInnerHTML: {
                                            __html: description
                                        }
                                    }),
                                    (0,helper/* convertStringToBoolean */.mUs)(actionsEnabled) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "cmp-carousel__action-container",
                                        children: [
                                            !(0,helper/* convertStringToBoolean */.mUs)(linkAll) && link && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: link,
                                                className: "cmp-carousel__action-link",
                                                target: "".concat((0,helper/* convertStringToBoolean */.mUs)(isNewTab) ? "_blank" : "_self"),
                                                "data-gbh-data-layer": getDataLayerValues(isSsr, pageName, link, (0,helper/* sanitizeTextArticle */.pkm)(texttitle), (0,helper/* sanitizeTextArticle */.pkm)(text)),
                                                children: (0,helper/* sanitizeInnerHtml */.KD0)(text)
                                            }),
                                            ((0,helper/* convertStringToBoolean */.mUs)(linkAll) || !link) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "cmp-carousel__action-link",
                                                dangerouslySetInnerHTML: {
                                                    __html: text
                                                }
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_slick_lib/* default */.Z, {
                                ...slickSettings,
                                className: "cmp-carousel-slick__content",
                                ref: sliderRef,
                                children: itemsOrder && (itemsOrder === null || itemsOrder === void 0 ? void 0 : itemsOrder.map((key, index, arr)=>{
                                    const item = items[key];
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            isDoubleFeatureContentCard && !isSsr ? /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_Image, {
                                                data: item
                                            }) : null,
                                            isSingleItemsSlider || isSingleSlider || isFeatureContentSlider || isInspiredThemeCarouselSlider || carouselVertical ? /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_Teaser, {
                                                fullData: fullData,
                                                data: item,
                                                showEmptyPlaceholder: showSlideIndicators,
                                                maxHeight: sliderImageHeight,
                                                pageName: pageName
                                            }) : null
                                        ]
                                    }, (item === null || item === void 0 ? void 0 : item.id) ? item === null || item === void 0 ? void 0 : item.id : "cpm-carousel-".concat(index, "-").concat((0,helper/* getRandom */.sZz)()));
                                }))
                            }, "".concat(sliderRerenderKey)),
                            showSlideIndicators && !isDoubleFeatureContentCard ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "slider__counter",
                                style: {
                                    top: countHeight + "px"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "current-count",
                                        children: activeSlide
                                    }),
                                    "/",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "total-count",
                                        children: data["carouselComponentProperties"] && ((ref = data["carouselComponentProperties"][":itemsOrder"]) === null || ref === void 0 ? void 0 : ref.length)
                                    })
                                ]
                            }) : null
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "hide",
                children: showSlideIndicators
            })
        ]
    });
};
/* harmony default export */ var v1_CarouselSlick = (CarouselSlick);

;// CONCATENATED MODULE: ./components/Shared/MainFooter/analytics.js

const addAnalyticsOnClick = function(eventInfoKey, item) {
    let quadrantTitle = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", url = arguments.length > 3 ? arguments[3] : void 0;
    var ref;
    const internalLinkPosition = (0,helper/* sanitizeTextArticle */.pkm)(quadrantTitle.toLowerCase());
    let eventInfo;
    var ref1;
    const brandName = (ref1 = item === null || item === void 0 ? void 0 : (ref = item.brandNameOne) === null || ref === void 0 ? void 0 : ref.toLowerCase()) !== null && ref1 !== void 0 ? ref1 : "";
    switch(eventInfoKey){
        case "firstLink":
            eventInfo = {
                clickInternalLinks: "".concat((item === null || item === void 0 ? void 0 : item.newTabOne) ? "false" : "true"),
                internalLinkPosition: "".concat(internalLinkPosition),
                internalLinkZoneName: "global footer",
                internalLinkURL: url ? "".concat(url.indexOf("http") === -1 ? window.location.origin : "").concat((0,helper/* removeAndCleanLink */.xEh)(url)) : "n/a",
                internalLinkName: "".concat(brandName),
                eventName: "footer menu:".concat(brandName),
                internalLinkType: "global footer:navigation",
                eventType: "footer submenu",
                eventAction: "footer menu:".concat(brandName)
            };
            break;
        case "linkThree":
            var ref2, ref3, ref4;
            eventInfo = {
                clickInternalLinks: "".concat((item === null || item === void 0 ? void 0 : item.newTabFour) ? "false" : "true"),
                internalLinkPosition: "".concat(internalLinkPosition),
                internalLinkZoneName: "global footer",
                internalLinkURL: url ? "".concat(url.indexOf("http") === -1 ? window.location.origin : "").concat((0,helper/* removeAndCleanLink */.xEh)(url)) : "n/a",
                internalLinkName: "".concat(item === null || item === void 0 ? void 0 : (ref2 = item.brandNameFour) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase()),
                eventName: "footer menu:".concat(item === null || item === void 0 ? void 0 : (ref3 = item.brandNameFour) === null || ref3 === void 0 ? void 0 : ref3.toLowerCase()),
                internalLinkType: "global footer:navigation",
                eventType: "footer submenu",
                eventAction: "footer menu:".concat(item === null || item === void 0 ? void 0 : (ref4 = item.brandNameFour) === null || ref4 === void 0 ? void 0 : ref4.toLowerCase())
            };
            break;
        case "oddEven":
            var ref5, ref6, ref7;
            eventInfo = {
                clickInternalLinks: "".concat((item === null || item === void 0 ? void 0 : item.newTabTwo) ? "false" : "true"),
                internalLinkPosition: "".concat(internalLinkPosition),
                internalLinkZoneName: "global footer",
                internalLinkURL: url ? "".concat(url.indexOf("http") === -1 ? window.location.origin : "").concat((0,helper/* removeAndCleanLink */.xEh)(url)) : "n/a",
                internalLinkName: "".concat(item === null || item === void 0 ? void 0 : (ref5 = item.brandNameTwo) === null || ref5 === void 0 ? void 0 : ref5.toLowerCase()),
                eventName: "footer menu:".concat(item === null || item === void 0 ? void 0 : (ref6 = item.brandNameTwo) === null || ref6 === void 0 ? void 0 : ref6.toLowerCase()),
                internalLinkType: "global footer:navigation",
                eventType: "footer submenu",
                eventAction: "footer menu:".concat(item === null || item === void 0 ? void 0 : (ref7 = item.brandNameTwo) === null || ref7 === void 0 ? void 0 : ref7.toLowerCase())
            };
            break;
        default:
            eventInfo = null;
    }
    (0,helper/* pushAnalyticsObjToDataLayer */.zYT)(eventInfo !== null && eventInfo !== void 0 ? eventInfo : null);
};

;// CONCATENATED MODULE: ./components/Shared/MainFooter/index.jsx






const MainFooter = (props)=>{
    const { data , columnClassNames  } = props;
    const [gbhExpand, setGbhExpand] = (0,react.useState)([]);
    const { winWidth  } = (0,useWindowDimensions/* default */.Z)();
    const footerTitleRole = winWidth < 1024 ? "button" : "heading";
    const isExpanded = (key)=>gbhExpand.includes(key);
    const getExpandedClassname = (key)=>isExpanded(key) ? "gbh-expand" : "";
    const handleGbhExpand = (key)=>{
        if (!isExpanded(key)) {
            const newGbhExpand = [
                ...gbhExpand
            ];
            newGbhExpand.push(key);
            setGbhExpand(newGbhExpand);
        } else {
            const newGbhExpand1 = [
                ...gbhExpand
            ];
            const idx = gbhExpand.indexOf(key);
            newGbhExpand1.splice(idx, 1);
            setGbhExpand(newGbhExpand1);
        }
    };
    const handleOnLinkClick = (param)=>{
        let { linkName , item , quadrantTitle , windowFeature ="" , target , url =""  } = param;
        addAnalyticsOnClick(linkName, item, quadrantTitle, url);
        url && window.open(url, target, windowFeature);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat(columnClassNames ? columnClassNames : "", " ").concat((Shared_index_module_default()).mainFooterWrapper),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("footer", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "gbh-footer-main-nav main-footer",
                "aria-label": "Footer",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                    className: "gbh-container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "row",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "col",
                                "aria-label": data === null || data === void 0 ? void 0 : data.quadrantTitleOne,
                                role: "list",
                                children: [
                                    (data === null || data === void 0 ? void 0 : data.radioNavigationOne) === "descriptionOne" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                children: data === null || data === void 0 ? void 0 : data.quadrantTitleOne
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "gbh-find-store",
                                                role: "listitem",
                                                dangerouslySetInnerHTML: {
                                                    __html: browser_default().sanitize(data === null || data === void 0 ? void 0 : data.quadrantDescOne)
                                                }
                                            })
                                        ]
                                    }),
                                    (data === null || data === void 0 ? void 0 : data.radioNavigationOne) === "linksOne" && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "gbh-footer-main-nav-link",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "footer-inner-head ".concat(getExpandedClassname("linksOne")),
                                                    role: footerTitleRole,
                                                    "aria-level": "2",
                                                    onClick: ()=>handleGbhExpand("linksOne"),
                                                    tabIndex: 0,
                                                    "aria-expanded": isExpanded("linksOne"),
                                                    "aria-controls": "footer-inner-links-linksOne",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            dangerouslySetInnerHTML: {
                                                                __html: browser_default().sanitize(data === null || data === void 0 ? void 0 : data.quadrantTitleOne)
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "accordion",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "line line-1"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "line line-2"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                    style: !isExpanded("linksOne") ? {
                                                        display: "none"
                                                    } : {},
                                                    id: "footer-inner-links-linksOne",
                                                    children: data === null || data === void 0 ? void 0 : data.items.map((item, index)=>{
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                    className: "gbh-data-layer",
                                                                    "aria-label": "".concat(item === null || item === void 0 ? void 0 : item.brandNameOne).concat((item === null || item === void 0 ? void 0 : item.newTabOne) ? " external link opens in a new tab" : ""),
                                                                    onClick: ()=>{
                                                                        var ref;
                                                                        return handleOnLinkClick({
                                                                            linkName: "firstLink",
                                                                            item,
                                                                            quadrantTitle: data === null || data === void 0 ? void 0 : data.quadrantTitleOne,
                                                                            target: "".concat((item === null || item === void 0 ? void 0 : item.newTabOne) ? "_blank" : "_self"),
                                                                            windowFeature: "noreferrer",
                                                                            url: item === null || item === void 0 ? void 0 : (ref = item.brandLinkOne) === null || ref === void 0 ? void 0 : ref.split("/content/kohler/us").join("").replace(".html", "")
                                                                        });
                                                                    },
                                                                    tabIndex: "0",
                                                                    children: item === null || item === void 0 ? void 0 : item.brandNameOne
                                                                })
                                                            })
                                                        }, "gbh-footer-main-nav-link-".concat(index));
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "col",
                                "aria-label": data === null || data === void 0 ? void 0 : data.quadrantTitleTwo,
                                children: [
                                    (data === null || data === void 0 ? void 0 : data.radioNavigationTwo) === "descriptionTwo" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "footer-inner-head",
                                                role: "heading",
                                                "aria-level": "2",
                                                children: data === null || data === void 0 ? void 0 : data.quadrantTitleTwo
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                dangerouslySetInnerHTML: {
                                                    __html: browser_default().sanitize(data === null || data === void 0 ? void 0 : data.quadrantDescTwo)
                                                }
                                            })
                                        ]
                                    }),
                                    data.radioNavigationTwo === "linksTwo" && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "gbh-footer-main-nav-link",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "footer-inner-head ".concat(getExpandedClassname("linksTwo")),
                                                    role: footerTitleRole,
                                                    "aria-level": "2",
                                                    onClick: ()=>handleGbhExpand("linksTwo"),
                                                    tabIndex: 0,
                                                    "aria-expanded": isExpanded("linksTwo"),
                                                    "aria-controls": "footer-inner-links-linksTwo",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            dangerouslySetInnerHTML: {
                                                                __html: browser_default().sanitize(data === null || data === void 0 ? void 0 : data.quadrantTitleTwo)
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "accordion",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "line line-1"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "line line-2"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                    style: !isExpanded("linksTwo") ? {
                                                        display: "none"
                                                    } : {},
                                                    className: (data === null || data === void 0 ? void 0 : data.itemsOne.length) > 4 ? "odd-even" : "",
                                                    id: "footer-inner-links-linksTwo",
                                                    children: data === null || data === void 0 ? void 0 : data.itemsOne.map((item, index)=>{
                                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                className: "gbh-data-layer",
                                                                "aria-label": "".concat(item === null || item === void 0 ? void 0 : item.brandNameTwo).concat((item === null || item === void 0 ? void 0 : item.newTabTwo) ? " external link opens in a new tab" : ""),
                                                                onClick: ()=>{
                                                                    var ref;
                                                                    return handleOnLinkClick({
                                                                        url: item === null || item === void 0 ? void 0 : (ref = item.brandLinkTwo) === null || ref === void 0 ? void 0 : ref.split("/content/kohler/us").join("").replace(".html", ""),
                                                                        linkName: "oddEven",
                                                                        quadrantTitle: data === null || data === void 0 ? void 0 : data.quadrantTitleTwo,
                                                                        item,
                                                                        windowFeature: "noreferrer",
                                                                        target: (item === null || item === void 0 ? void 0 : item.newTabTwo) ? "_blank" : "_self"
                                                                    });
                                                                },
                                                                tabIndex: "0",
                                                                children: (item === null || item === void 0 ? void 0 : item.brandNameTwo) && (item === null || item === void 0 ? void 0 : item.brandNameTwo)
                                                            })
                                                        }, "linksTwo-".concat(index));
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "col",
                                "aria-label": data === null || data === void 0 ? void 0 : data.quadrantTitleThree,
                                children: [
                                    (data === null || data === void 0 ? void 0 : data.descriptionThree) === "descriptionThree" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                children: data === null || data === void 0 ? void 0 : data.quadrantTitleThree
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                dangerouslySetInnerHTML: {
                                                    __html: browser_default().sanitize(data === null || data === void 0 ? void 0 : data.quadrantDescThree)
                                                }
                                            })
                                        ]
                                    }),
                                    (data === null || data === void 0 ? void 0 : data.radioNavigationThree) === "linksThree" && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "gbh-footer-main-nav-link",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "footer-inner-head ".concat(getExpandedClassname("linksThree")),
                                                    role: footerTitleRole,
                                                    "aria-level": "2",
                                                    onClick: ()=>handleGbhExpand("linksThree"),
                                                    tabIndex: 0,
                                                    "aria-expanded": isExpanded("linksThree"),
                                                    "aria-controls": "footer-inner-links-linksThree",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            dangerouslySetInnerHTML: {
                                                                __html: browser_default().sanitize(data === null || data === void 0 ? void 0 : data.quadrantTitleThree)
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "accordion",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "line line-1"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "line line-2"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                    style: !isExpanded("linksThree") ? {
                                                        display: "none"
                                                    } : {},
                                                    className: (data === null || data === void 0 ? void 0 : data.itemsTwo.length) > 4 ? "odd-even" : "",
                                                    id: "footer-inner-links-linksThree",
                                                    children: data === null || data === void 0 ? void 0 : data.itemsTwo.map((item, index)=>{
                                                        var ref, ref1, ref2, ref3, ref4;
                                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                className: "gbh-data-layer",
                                                                href: item === null || item === void 0 ? void 0 : (ref = item.brandLinkThree) === null || ref === void 0 ? void 0 : ref.split("/content/kohler/us").join("").replace(".html", ""),
                                                                target: (item === null || item === void 0 ? void 0 : item.newTabThree) ? "_blank" : "",
                                                                rel: "noreferrer",
                                                                "aria-label": "".concat(item === null || item === void 0 ? void 0 : item.brandNameThree).concat((item === null || item === void 0 ? void 0 : item.newTabThree) ? " external link opens in a new tab" : ""),
                                                                "data-gbh-data-layer": '{"clickInternalLinks":"'.concat((item === null || item === void 0 ? void 0 : item.newTabThree) ? "false" : "true", '","internalLinkPosition":"').concat(data === null || data === void 0 ? void 0 : data.quadrantTitleThree.toLowerCase(), '","internalLinkZoneName":"global footer","internalLinkURL":"').concat(item === null || item === void 0 ? void 0 : (ref1 = item.brandLinkThree) === null || ref1 === void 0 ? void 0 : ref1.split("/content/kohler/us").join("").replace(".html", ""), '","internalLinkName":"').concat(item === null || item === void 0 ? void 0 : (ref2 = item.brandNameThree) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase(), '","eventName":"footer menu:').concat(item === null || item === void 0 ? void 0 : (ref3 = item.brandNameThree) === null || ref3 === void 0 ? void 0 : ref3.toLowerCase(), '","internalLinkType":"global footer:navigation","eventType":"footer submenu","eventAction":"footer menu:').concat(item === null || item === void 0 ? void 0 : (ref4 = item.brandNameThree) === null || ref4 === void 0 ? void 0 : ref4.toLowerCase(), '"}'),
                                                                tabIndex: "0",
                                                                children: (item === null || item === void 0 ? void 0 : item.brandNameThree) && (item === null || item === void 0 ? void 0 : item.brandNameThree)
                                                            })
                                                        }, "linksThree-".concat(index));
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "col",
                                "aria-label": data === null || data === void 0 ? void 0 : data.quadrantTitleFour,
                                children: [
                                    (data === null || data === void 0 ? void 0 : data.radioNavigationFour) === "descriptionFour" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                children: data === null || data === void 0 ? void 0 : data.quadrantTitleFour
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                dangerouslySetInnerHTML: {
                                                    __html: browser_default().sanitize(data === null || data === void 0 ? void 0 : data.quadrantDescFour)
                                                }
                                            })
                                        ]
                                    }),
                                    (data === null || data === void 0 ? void 0 : data.radioNavigationFour) === "linksFour" && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "gbh-footer-main-nav-link",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "footer-inner-head ".concat(getExpandedClassname("linksFour")),
                                                    role: footerTitleRole,
                                                    "aria-level": "2",
                                                    onClick: ()=>handleGbhExpand("linksFour"),
                                                    tabIndex: 0,
                                                    "aria-expanded": isExpanded("linksFour"),
                                                    "aria-controls": "footer-inner-links-linksFour",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            dangerouslySetInnerHTML: {
                                                                __html: browser_default().sanitize(data === null || data === void 0 ? void 0 : data.quadrantTitleFour)
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "accordion",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "line line-1"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "line line-2"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                    style: !isExpanded("linksFour") ? {
                                                        display: "none"
                                                    } : {},
                                                    className: (data === null || data === void 0 ? void 0 : data.itemsThree.length) > 4 ? "odd-even" : "",
                                                    id: "footer-inner-links-linksFour",
                                                    children: data === null || data === void 0 ? void 0 : data.itemsThree.map((item, index)=>{
                                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                className: "gbh-data-layer",
                                                                "aria-label": "".concat(item === null || item === void 0 ? void 0 : item.brandNameFour).concat((item === null || item === void 0 ? void 0 : item.newTabFour) ? " external link opens in a new tab" : ""),
                                                                onClick: ()=>{
                                                                    var ref;
                                                                    return handleOnLinkClick({
                                                                        url: item === null || item === void 0 ? void 0 : (ref = item.brandLinkFour) === null || ref === void 0 ? void 0 : ref.split("/content/kohler/us").join("").replace(".html", ""),
                                                                        linkName: "linkThree",
                                                                        item,
                                                                        quadrantTitle: data === null || data === void 0 ? void 0 : data.quadrantTitleFour,
                                                                        windowFeature: "noreferrer",
                                                                        target: (item === null || item === void 0 ? void 0 : item.newTabFour) ? "_blank" : "_self"
                                                                    });
                                                                },
                                                                tabIndex: "0",
                                                                children: (item === null || item === void 0 ? void 0 : item.brandNameFour) && (item === null || item === void 0 ? void 0 : item.brandNameFour)
                                                            })
                                                        }, "linksThree-".concat(index));
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        })
    });
};
/* harmony default export */ var Shared_MainFooter = (MainFooter);

// EXTERNAL MODULE: ./components/core/ReCaptcha/ReCaptcha.jsx + 1 modules
var ReCaptcha = __webpack_require__(46394);
// EXTERNAL MODULE: ./components/core/Button/Button.jsx + 1 modules
var Button_Button = __webpack_require__(7872);
// EXTERNAL MODULE: ./components/core/Modal/Modal.jsx + 1 modules
var Modal = __webpack_require__(78145);
;// CONCATENATED MODULE: ./components/Shared/NewsletterFooter/SubscribeInfoModal.jsx






const SubscribeInfoModal = (props)=>{
    var ref, ref1, ref2;
    const { show , handleModalClose , handleModalMsg , homePagePath , className , staticTexts , modalContent: modalContent  } = props;
    (0,react.useEffect)(()=>{
        setTimeout(()=>{
            const newsContent = document.querySelector(".newsletter__success");
            if (newsContent !== null) {
                var ref;
                const hrefLink = (ref = newsContent.childNodes[0]) === null || ref === void 0 ? void 0 : ref.childNodes[5];
                if (hrefLink !== null || hrefLink !== undefined) {
                    hrefLink.addEventListener("click", (e)=>{
                        handleModalMsg(hrefLink.getAttribute("href"));
                    });
                }
            }
        }, 200);
    }, [
        show
    ]);
    (0,react.useEffect)(()=>{
        return ()=>{
            var ref, ref1, ref2;
            (ref2 = (ref1 = (ref = document.querySelector(".newsletter__success")) === null || ref === void 0 ? void 0 : ref.childNodes[0]) === null || ref1 === void 0 ? void 0 : ref1.childNodes[5]) === null || ref2 === void 0 ? void 0 : ref2.removeEventListener("click");
        };
    }, []);
    const { getReady , signupSuccess , getStarted  } = staticTexts;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal["default"], {
        showModal: show,
        onModalClose: handleModalClose,
        modalTitle: getReady !== null && getReady !== void 0 ? getReady : "",
        describedBy: "newsletter-description",
        labelledBy: "newsletter-title",
        className: "".concat(className ? className : "", " newsletter"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "newsletter",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "newsletter__content",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "newsletter__thanks test-class",
                        id: "newsletter-title",
                        children: !isEmpty_default()(modalContent) ? (0,helper/* sanitizeInnerHtml */.KD0)(modalContent === null || modalContent === void 0 ? void 0 : (ref = modalContent.modalContent) === null || ref === void 0 ? void 0 : ref.title) : /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            children: (0,helper/* sanitizeInnerHtml */.KD0)(getReady)
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "newsletter__success",
                        id: "newsletter-description",
                        children: !isEmpty_default()(modalContent) ? (0,helper/* sanitizeInnerHtml */.KD0)(modalContent === null || modalContent === void 0 ? void 0 : (ref1 = modalContent.modalContent) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.description) === null || ref2 === void 0 ? void 0 : ref2.split("/content/kohler/us").join("").replace(".html", "")) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: (0,helper/* sanitizeInnerHtml */.KD0)(signupSuccess)
                        })
                    }),
                     false && /*#__PURE__*/ 0
                ]
            })
        })
    });
};
/* harmony default export */ var NewsletterFooter_SubscribeInfoModal = (SubscribeInfoModal);

// EXTERNAL MODULE: ./components/Shared/NewsletterFooter/index.module.scss
var NewsletterFooter_index_module = __webpack_require__(62582);
var NewsletterFooter_index_module_default = /*#__PURE__*/__webpack_require__.n(NewsletterFooter_index_module);
;// CONCATENATED MODULE: ./components/Shared/NewsletterFooter/localization.js
const getTranslations = (t)=>{
    return {
        thanks: t("kf.newsletter.label.thanks"),
        getReady: t("kf.newsletter.label.getReady"),
        signupSuccess: t("kf.newsletter.label.signupSuccess"),
        signUp: t("kf.newsletter.label.signUp"),
        getStarted: t("kf.newsletter.label.getStarted"),
        enterEmail: t("kf.newsletter.label.enterEmail"),
        validEmail: t("kf.newsletter.label.validEmail"),
        genError: t("kf.error.message.genericError"),
        alreadySubscribed: t("kf.newsletter.label.alreadySubscribed")
    };
};

;// CONCATENATED MODULE: ./components/Shared/NewsletterFooter/newsLetterBody.js
const newsLetterBody = function(sBrandName, sEmailAddress) {
    let language = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "en", additionalValues = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
    const aValues = {
        AnnSacks: {
            "Subscribe Ann Sacks": "TRUE",
            "Interiors Recent Source": "Website Footer Email Signup_Ann Sacks"
        },
        Sterling: {
            "Subscribe Sterling Plumbing": "TRUE",
            "Interiors Recent Source": "Website Footer Email Signup_Sterling"
        },
        Kohler: {
            "Subscribe Kohler Kitchen and Bath": "TRUE",
            "Subscribe Kohler KB Website Interaction": "TRUE",
            "Kitchen Bath Recent Source": "Website Footer Email Signup_Kohler"
        },
        "kohler-canada": {
            "Subscribe Kohler Canada": "TRUE",
            "Kitchen Bath Recent Source": "Website Footer Email Signup_Canada_English",
            LanguagePref: language
        },
        Kallista: {
            "Subscribe Kallista": "TRUE",
            "Interiors Recent Source": "Website Footer Email Signup_Kallista"
        },
        Robern: {
            "Subscribe Sterling Plumbing": "TRUE",
            "Interiors Recent Source": "Website Footer Email Signup_Sterling"
        }
    };
    if (aValues[sBrandName]) {
        aValues[sBrandName]["EmailAddress"] = sEmailAddress;
        aValues[sBrandName]["Date Updated"] = new Date().toISOString();
    }
    if (additionalValues) {
        aValues[sBrandName] = {
            ...aValues[sBrandName],
            ...additionalValues
        };
    }
    const body = {
        keys: {
            SubscriberKey: sEmailAddress
        },
        values: aValues[sBrandName] || []
    };
    return [
        body
    ];
};
/* harmony default export */ var NewsletterFooter_newsLetterBody = (newsLetterBody);

;// CONCATENATED MODULE: ./components/Shared/NewsletterFooter/NewsletterFooter.jsx















const NewsletterFooter = (props)=>{
    const dispatch = (0,es/* useDispatch */.I0)();
    const [validationError, setValidationError] = (0,react.useState)("");
    const [email, setEmail] = (0,react.useState)("");
    const [captchaActive, setCaptchaActive] = (0,react.useState)(false);
    const submitButton = (0,react.useRef)(null);
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const [staticTexts, setStaticTexts] = (0,react.useState)({});
    const [siteName, setSiteName] = (0,react.useState)("");
    const [language, setLanguage] = (0,react.useState)("en");
    const [homePagePath, setHomePagePath] = (0,react.useState)("/");
    const [isShowModal, setIsShowModal] = (0,react.useState)(false);
    const [isResetForm, setIsResetForm] = (0,react.useState)(false);
    const [isAlreadyExist, setIsAlreadyExist] = (0,react.useState)(false);
    const { subscribeModal  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const { data , columnClassNames  } = props;
    const addNewsletterSignupAnalytics = (status, message)=>{
        if (window.adobeDataLayer) {
            const eventInfo = {
                "@type": (siteName === null || siteName === void 0 ? void 0 : siteName.toLowerCase()) + "/components/newslettersignin",
                eventMsg: message || "n/a",
                eventStatus: status,
                clickInternalLinks: "true",
                internalLinkPosition: "newslettersignin",
                internalLinkZoneName: "global footer",
                internalLinkURL: "n/a",
                internalLinkName: "newsletter submit",
                eventName: "newsletter submit",
                internalLinkType: "global footer:submit",
                eventType: "click",
                eventAction: "newsletter submit"
            };
            const page = window.pageObj || {};
            window.adobeDataLayer.push({
                event: "cmp:click",
                eventInfo: eventInfo,
                page: page
            });
        }
    };
    const subModalAnalytics = (msg, hreflink)=>{
        if (window.adobeDataLayer) {
            const { adobeDataLayer: { getState  } = {}  } = window;
            const eventInfo = {
                eventMsg: "n/a",
                eventStatus: "n/a",
                clickInternalLinks: "true",
                internalLinkPosition: "newsletter:signin complete",
                internalLinkZoneName: "newsletter submit:get ready",
                internalLinkURL: hreflink ? msg + hreflink : "n/a",
                internalLinkName: msg,
                eventName: "newsletter submit:get ready:".concat(msg),
                internalLinkType: "newsletter submit:get ready",
                eventType: "navigation",
                eventAction: "newsletter submit:get ready:".concat(msg)
            };
            const page = getState && getState("page") || {};
            window.adobeDataLayer.push({
                event: "cmp:click",
                eventInfo: eventInfo,
                page: page
            });
        }
    };
    (0,react.useEffect)(()=>{
        if (isResetForm) setEmail("");
        if (isAlreadyExist) setValidationError(staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.alreadySubscribed);
    }, [
        isResetForm,
        isAlreadyExist
    ]);
    (0,react.useEffect)(()=>{
        setCaptchaActive(false);
        setStaticTexts(getTranslations(t));
        setInitalData();
    }, []);
    const handleModalClose = ()=>{
        subModalAnalytics("close");
        setIsShowModal(false);
    };
    const handleModalMsg = (hreflink)=>{
        subModalAnalytics("".concat(siteName === null || siteName === void 0 ? void 0 : siteName.toLowerCase(), ".com"), hreflink);
    };
    const setInitalData = async ()=>{
        const config = await (0,constants_config/* getConfig */.i)();
        setSiteName(get_default()(config, "general.siteName", ""));
        setLanguage(get_default()(config, "internationalization.language", "en"));
        setHomePagePath(await (0,helper/* getShortenedUrl */.Ppy)(get_default()(config, "general.homepageUrl", "/")));
    };
    const getSubscriptionData = (email)=>{
        const body = NewsletterFooter_newsLetterBody(siteName, email, language);
        (0,ReCaptcha/* validateRecaptcha */.L)().then((res)=>{
            if (res.success) {
                constants_api/* apim.post */.TH.post(constants.emailSubscribeEndPoint, body, {
                    params: {
                        brand: siteName
                    }
                }).then((response)=>{
                    if (response && response.data) {
                        var _resultMessages;
                        const isSuccess = (_resultMessages = response.data.resultMessages) !== null && _resultMessages !== void 0 ? _resultMessages : [];
                        if (isSuccess) {
                            setIsShowModal(true);
                            setIsResetForm(true);
                        }
                        setEmail("");
                        addNewsletterSignupAnalytics("success");
                    } else {
                        addNewsletterSignupAnalytics("failure", "news letter subscription api: error occured while fetching data from get url property");
                    // log.error(
                    //   "News letter subscription API: Error occured while fetching data from Get URL Property"
                    // )
                    }
                }).catch((err)=>{
                    var ref, ref1;
                    if (((ref = err.response) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.error) === "Email address already subscribed") {
                        setIsAlreadyExist(true);
                        addNewsletterSignupAnalytics("failure", staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.alreadySubscribed.toLowerCase());
                    } else {
                        console.log(staticTexts.genError);
                        dispatch((0,genericSlice/* showToast */.CF)({
                            message: staticTexts.genError,
                            isVisible: true
                        }));
                        addNewsletterSignupAnalytics("failure", staticTexts.genError.toLowerCase());
                    }
                });
            } else {
                dispatch((0,genericSlice/* showToast */.CF)({
                    message: staticTexts.genError,
                    isVisible: true
                }));
                addNewsletterSignupAnalytics("failure", staticTexts.genError.toLowerCase());
            }
        }).catch(()=>{
            dispatch((0,genericSlice/* showToast */.CF)({
                message: staticTexts.genError,
                isVisible: true
            }));
            addNewsletterSignupAnalytics("failure", staticTexts.genError.toLowerCase());
        });
    };
    const onSubmit = async ()=>{
        if (email === "" || email == null || (email === null || email === void 0 ? void 0 : email.length) === 0) {
            setValidationError(staticTexts.enterEmail);
            addNewsletterSignupAnalytics("failure", staticTexts.enterEmail.toLowerCase());
        }
        if ((email === null || email === void 0 ? void 0 : email.length) > 0) {
            const isValid = await (0,helper/* validateField */.OP$)("email", email);
            if (!isValid) {
                addNewsletterSignupAnalytics("failure", staticTexts.enterEmail.toLowerCase());
                setValidationError(staticTexts.validEmail);
            } else {
                setValidationError("");
                getSubscriptionData(email);
            }
        }
        handleFocus();
    };
    const handleFocus = ()=>{
        // removing focus
        submitButton.current.blur();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat(columnClassNames ? columnClassNames : "", " ").concat((NewsletterFooter_index_module_default()).wrapper),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("footer", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        className: "gbh-footer-newsletter-nav",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                                className: "gbh-container",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                                    className: "gbh-footer-news-letter",
                                    "aria-label": data === null || data === void 0 ? void 0 : data.title,
                                    role: "list",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                            children: data === null || data === void 0 ? void 0 : data.title
                                        }),
                                        (0,helper/* sanitizeInnerHtml */.KD0)(data === null || data === void 0 ? void 0 : data.description),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "form-group newsletter-form-group",
                                            role: "listitem",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                    htmlFor: "newsletter_input",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                        className: "form-control",
                                                        type: "text",
                                                        "aria-label": data === null || data === void 0 ? void 0 : data.placeholder,
                                                        placeholder: data === null || data === void 0 ? void 0 : data.placeholder,
                                                        maxLength: "60",
                                                        id: "newsletter_input",
                                                        onChange: (e)=>setEmail(e.target.value),
                                                        value: email,
                                                        title: data === null || data === void 0 ? void 0 : data.placeholder,
                                                        "data-testid": "newsletter-input"
                                                    })
                                                }),
                                                (data === null || data === void 0 ? void 0 : data.submit) && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                    "aria-label": "Submit button. Tap or click here to subscribe for Koher newsletter to receive news and promotions.",
                                                    className: "btn btn-secondary ".concat(email.length ? "active-btn" : ""),
                                                    id: "newsletter_submit",
                                                    onClick: ()=>onSubmit(),
                                                    ref: submitButton,
                                                    "data-testid": "newsletter-submit",
                                                    children: data === null || data === void 0 ? void 0 : data.submit
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            role: "listitem",
                                            className: "subsribe-error-container",
                                            children: validationError && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                id: "subsribe-mail-error",
                                                tabIndex: "0",
                                                "data-testid": "email-error",
                                                children: (0,helper/* sanitizeDOMString */.TRt)(validationError)
                                            })
                                        })
                                    ]
                                })
                            }),
                            captchaActive && /*#__PURE__*/ (0,jsx_runtime.jsx)(ReCaptcha/* default */.Z, {})
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsletterFooter_SubscribeInfoModal, {
                show: isShowModal,
                handleModalClose: handleModalClose,
                handleModalMsg: handleModalMsg,
                staticTexts: staticTexts,
                homePagePath: homePagePath,
                className: (NewsletterFooter_index_module_default()).wrapper,
                setEmail: setEmail,
                modalContent: subscribeModal
            })
        ]
    });
};
/* harmony default export */ var NewsletterFooter_NewsletterFooter = (NewsletterFooter);

;// CONCATENATED MODULE: ./components/Shared/AdditionalFooter.jsx





const AdditionalFooter = (props)=>{
    var ref, ref1;
    const { data , columnClassNames  } = props;
    const router = (0,next_router.useRouter)();
    const [location, setLocation] = (0,react.useState)("");
    const [docTitle, setDocTitle] = (0,react.useState)("");
    (0,react.useEffect)(()=>{
        setLocation(window.location.href);
        setDocTitle(document.title);
    }, [
        router.pathname
    ]);
    const getHref = (item)=>{
        var ref;
        return item.link !== "#" ? {
            href: (ref = item.link) === null || ref === void 0 ? void 0 : ref.split("/content/kohler/us").join("").replace(".html", "")
        } : "";
    };
    const getRole = (item)=>item.link !== "#" ? "link" : "button";
    const getDomLocation = (item)=>{
        if ((item === null || item === void 0 ? void 0 : item.link) === "#") {
            return "n/a";
        } else if (item === null || item === void 0 ? void 0 : item.link.includes("https")) {
            return item === null || item === void 0 ? void 0 : item.link.split("/content/kohler/us").join("").replace(".html", "");
        } else {
            if (true) return "".concat(window.location.origin).concat(item === null || item === void 0 ? void 0 : item.link.split("/content/kohler/us").join("").replace(".html", ""));
        }
    };
    const pushAnalyticsObjToDataLayer = function() {
        let eventInfo = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        const page = window.pageObj || {};
        const event = "cmp:click";
        window.adobeDataLayer.push({
            event,
            eventInfo,
            page
        });
    };
    const handleDataLayerForFooter = (e, title, item)=>{
        const titleName = title === "Cookies Settings" ? e.target.innerText.toLowerCase() : title.toLowerCase();
        const eventInfo = {
            clickInternalLinks: "true",
            eventAction: "global footer:".concat(browser_default().sanitize(titleName)),
            eventMsg: "n/a",
            eventName: "global footer:".concat(browser_default().sanitize(titleName)),
            eventStatus: "n/a",
            eventType: "footer menu-2",
            internalLinkName: "".concat(browser_default().sanitize(titleName)),
            internalLinkPosition: "global footer",
            internalLinkType: "global footer:navigation",
            internalLinkURL: "".concat(getDomLocation(item)),
            internalLinkZoneName: "global footer"
        };
        pushAnalyticsObjToDataLayer(eventInfo);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat(columnClassNames ? columnClassNames : "", " ").concat((Shared_index_module_default()).additionalFooterWrapper),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "additional-footer",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("footer", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                    className: "gbh-footer-add-nav",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                        className: "gbh-container",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                            className: "gbh-footer-add-panel",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                    className: "gbh-footer-nav__links",
                                    children: (data === null || data === void 0 ? void 0 : data.items) && (data === null || data === void 0 ? void 0 : data.items.map((item, index)=>{
                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                id: item === null || item === void 0 ? void 0 : item.idLabel,
                                                className: item === null || item === void 0 ? void 0 : item.classLabel,
                                                "aria-label": item.linkLabel,
                                                target: item.newTab ? "_blank" : "_self",
                                                ...getHref(item),
                                                rel: "noreferrer",
                                                onClick: (e)=>handleDataLayerForFooter(e, item.linkLabel, item),
                                                role: getRole(item),
                                                tabIndex: 0,
                                                children: item.linkLabel
                                            })
                                        }, "additionalfooteritem-".concat(index));
                                    }))
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "gbh-copy__rights",
                                    children: data.copyright
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                    className: "gbh-social__links",
                                    children: [
                                        (data === null || data === void 0 ? void 0 : data.email) === "email" && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: "gbh-social__email",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                target: "_blank",
                                                className: "gbh-data-layer",
                                                "aria-label": "Email corporate page link opens in a new tab",
                                                href: "mailto:?body=".concat(location, "&subject=").concat(docTitle),
                                                rel: "noreferrer noopener",
                                                title: data.linkLabelEmail,
                                                "data-gbh-data-layer": '{"clickInternalLinks":"false","internalLinkPosition":"global footer","internalLinkZoneName":"global footer","internalLinkURL":"'.concat(data === null || data === void 0 ? void 0 : data.linkEmail, '","internalLinkName":"social media:').concat(data === null || data === void 0 ? void 0 : (ref = data.linkLabelEmail) === null || ref === void 0 ? void 0 : ref.toLowerCase(), '","eventName":"social media:').concat(data === null || data === void 0 ? void 0 : (ref1 = data.linkLabelEmail) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase(), '","internalLinkType":"global footer:"navigation","eventType":"social icon","eventAction":"social media icon"}'),
                                                "data-link-type": "social media"
                                            })
                                        }),
                                        (data === null || data === void 0 ? void 0 : data.facebook) === "facebook" && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: "gbh-social__facebook",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                target: "_blank",
                                                "aria-label": "Facebook corporate page link opens in a new tab",
                                                href: data.linkFacebook,
                                                rel: "noreferrer noopener",
                                                title: data === null || data === void 0 ? void 0 : data.linkLabelFacebook,
                                                "data-gbh-data-layer": '{"clickInternalLinks":"false","internalLinkPosition":"global footer","internalLinkZoneName":"global footer","internalLinkURL":"'.concat(data === null || data === void 0 ? void 0 : data.linkFacebook, '","internalLinkName":"social media:').concat(data === null || data === void 0 ? void 0 : data.linkLabelFacebook.toLowerCase(), '","eventName":"social media:').concat(data === null || data === void 0 ? void 0 : data.linkLabelFacebook.toLowerCase(), '","internalLinkType":"global footer:navigation","eventType":"social icon","eventAction":"social media icon"}'),
                                                className: "gbh-data-layer",
                                                "data-link-type": "social media"
                                            })
                                        }),
                                        (data === null || data === void 0 ? void 0 : data.twitter) === "twitter" && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: "gbh-social__twitter",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                target: "_blank",
                                                "aria-label": "Twitter corporate page link opens in a new tab",
                                                href: data.linkTwitter,
                                                rel: "noreferrer noopener",
                                                title: data.linkLabelTwitter,
                                                "data-gbh-data-layer": '{"clickInternalLinks":"false","internalLinkPosition":"global footer","internalLinkZoneName":"global footer","internalLinkURL":"'.concat(data === null || data === void 0 ? void 0 : data.linkTwitter, '","internalLinkName":"social media:').concat(data === null || data === void 0 ? void 0 : data.linkLabelTwitter.toLowerCase(), '","eventName":"social media:').concat(data === null || data === void 0 ? void 0 : data.linkLabelTwitter.toLowerCase(), '","internalLinkType":"global footer:navigation","eventType":"social icon","eventAction":"social media icon"}'),
                                                className: "gbh-data-layer",
                                                "data-link-type": "social media"
                                            })
                                        }),
                                        (data === null || data === void 0 ? void 0 : data.instagram) === "instagram" && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: "gbh-social__insta",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                target: "_blank",
                                                "aria-label": "Instagram corporate page link opens in a new tab",
                                                href: data.linkInstagram,
                                                rel: "noreferrer noopener",
                                                title: data.linkLabelInstagram,
                                                "data-gbh-data-layer": '{"clickInternalLinks":"false","internalLinkPosition":"global footer","internalLinkZoneName":"global footer","internalLinkURL":"'.concat(data === null || data === void 0 ? void 0 : data.linkInstagram, '","internalLinkName":"social media:').concat(data === null || data === void 0 ? void 0 : data.linkLabelInstagram.toLowerCase(), '","eventName":"social media:').concat(data === null || data === void 0 ? void 0 : data.linkLabelInstagram.toLowerCase(), '","internalLinkType":"global footer:navigation","eventType":"social icon","eventAction":"social media icon"}'),
                                                className: "gbh-data-layer",
                                                "data-link-type": "social media"
                                            })
                                        }),
                                        (data === null || data === void 0 ? void 0 : data.pinterest) === "pinterest" && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: "gbh-social__pintrest",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                target: "_blank",
                                                "aria-label": "Pinterest corporate page link opens in a new tab",
                                                href: data.linkPinterest,
                                                rel: "noreferrer noopener",
                                                title: data.linkLabelPinterest,
                                                "data-gbh-data-layer": '{"clickInternalLinks":"false","internalLinkPosition":"global footer","internalLinkZoneName":"global footer","internalLinkURL":"'.concat(data === null || data === void 0 ? void 0 : data.linkPinterest, '","internalLinkName":"social media:').concat(data === null || data === void 0 ? void 0 : data.linkLabelPinterest.toLowerCase(), '","eventName":"social media:').concat(data === null || data === void 0 ? void 0 : data.linkLabelPinterest.toLowerCase(), '","internalLinkType":"global footer:navigation","eventType":"social icon","eventAction":"social media icon"}'),
                                                className: "gbh-data-layer",
                                                "data-link-type": "social media"
                                            })
                                        }),
                                        (data === null || data === void 0 ? void 0 : data.youtube) === "youtube" && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: "gbh-social__youtube",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                target: "_blank",
                                                "aria-label": "Youtube corporate page link opens in a new tab",
                                                href: data.linkYoutube,
                                                rel: "noreferrer noopener",
                                                title: data.linkLabelYoutube,
                                                "data-gbh-data-layer": '{"clickInternalLinks":"false","internalLinkPosition":"global footer","internalLinkZoneName":"global footer","internalLinkURL":"'.concat(data === null || data === void 0 ? void 0 : data.linkYoutube, '","internalLinkName":"social media:').concat(data === null || data === void 0 ? void 0 : data.linkLabelYoutube.toLowerCase(), '","eventName":"social media:').concat(data === null || data === void 0 ? void 0 : data.linkLabelYoutube.toLowerCase(), '","internalLinkType":"global footer:navigation","eventType":"social icon","eventAction":"social media icon"}'),
                                                className: "gbh-data-layer",
                                                "data-link-type": "social media"
                                            })
                                        }),
                                        (data === null || data === void 0 ? void 0 : data.houzz) === "houzz" && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: "gbh-social__houzz",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                target: "_blank",
                                                "aria-label": "Houzz corporate page link opens in a new tab",
                                                href: data.linkHouzz,
                                                rel: "noreferrer noopener",
                                                title: data.linkLabelHouzz,
                                                "data-gbh-data-layer": '{"clickInternalLinks":"false","internalLinkPosition":"global footer","internalLinkZoneName":"global footer","internalLinkURL":"'.concat(data === null || data === void 0 ? void 0 : data.linkHouzz, '","internalLinkName":"social media:').concat(data === null || data === void 0 ? void 0 : data.linkLabelHouzz.toLowerCase(), '","eventName":"social media:').concat(data === null || data === void 0 ? void 0 : data.linkLabelHouzz.toLowerCase(), '","internalLinkType":"global footer:navigation","eventType":"social icon","eventAction":"social media icon"}'),
                                                className: "gbh-data-layer",
                                                "data-link-type": "social media"
                                            })
                                        }),
                                        (data === null || data === void 0 ? void 0 : data.linkedin) === "linkedin" && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: "gbh-social__linkedin",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                target: "_blank",
                                                "aria-label": "Linkedin corporate page link opens in a new tab",
                                                href: data.linkLinkedin,
                                                rel: "noreferrer noopener",
                                                title: data.linkLabelLinkedin,
                                                "data-gbh-data-layer": '{"clickInternalLinks":"false","internalLinkPosition":"global footer","internalLinkZoneName":"global footer","internalLinkURL":"'.concat(data === null || data === void 0 ? void 0 : data.linkLinkedin, '","internalLinkName":"social media:').concat(data === null || data === void 0 ? void 0 : data.linkLabelLinkedin.toLowerCase(), '","eventName":"social media:').concat(data === null || data === void 0 ? void 0 : data.linkLabelLinkedin.toLowerCase(), '","internalLinkType":"global footer:navigation","eventType":"social icon","eventAction":"social media icon"}'),
                                                className: "gbh-data-layer",
                                                "data-link-type": "social media"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            })
        })
    });
};
/* harmony default export */ var Shared_AdditionalFooter = (AdditionalFooter);

;// CONCATENATED MODULE: ./components/Default/Text/v1/analytics/constant.js
const PAGELOAD = "bathroom design services";
const DESIGNSERVICES = "design services credit details";

;// CONCATENATED MODULE: ./components/Default/Text/v1/analytics/index.js


const datalayerForLinkEvent = (e)=>{
    const { target: { href ="" , textContent =""  } = {}  } = e;
    const eventInfo = {
        clickInternalLinks: "false",
        eventAction: "".concat(PAGELOAD, ":").concat(DESIGNSERVICES, ":").concat(textContent),
        eventMsg: " n/a",
        eventName: "".concat(PAGELOAD, ":").concat(DESIGNSERVICES, ":").concat(textContent),
        eventStatus: " n/a",
        eventType: "help support",
        internalLinkName: textContent,
        internalLinkPosition: DESIGNSERVICES,
        internalLinkType: "".concat(PAGELOAD, ":email us"),
        internalLinkURL: href,
        internalLinkZoneName: "".concat(PAGELOAD, ":").concat(DESIGNSERVICES)
    };
    textContent === "services@kohler.com" ? (0,helper/* pushAnalyticsObjToDataLayer */.zYT)(eventInfo) : null;
};

;// CONCATENATED MODULE: ./components/Default/Text/v1/Text.jsx




const Text = (props)=>{
    const [dataVal, setDataVal] = (0,react.useState)("");
    const linkTextRef = (0,react.useRef)();
    const { data: { text ="" , appliedCssClassNames ="" , richText =false  } = {}  } = props;
    const removeHtmlExtension = async ()=>{
        const newData = await (0,helper/* getShortenedUrl */.Ppy)(text);
        setDataVal(newData);
    };
    (0,react.useEffect)(()=>{
        if (richText) {
            removeHtmlExtension();
        }
    }, [
        richText
    ]);
    (0,react.useEffect)(()=>{
        if (linkTextRef === null || linkTextRef === void 0 ? void 0 : linkTextRef.current) {
            var ref;
            linkTextRef === null || linkTextRef === void 0 ? void 0 : (ref = linkTextRef.current) === null || ref === void 0 ? void 0 : ref.querySelectorAll("a").forEach((item)=>{
                item === null || item === void 0 ? void 0 : item.addEventListener("click", (e)=>{
                    datalayerForLinkEvent(e);
                });
            });
            return ()=>{
                var ref;
                linkTextRef === null || linkTextRef === void 0 ? void 0 : (ref = linkTextRef.current) === null || ref === void 0 ? void 0 : ref.querySelectorAll("a").forEach((item)=>{
                    item === null || item === void 0 ? void 0 : item.removeEventListener("click", (e)=>{
                        datalayerForLinkEvent(e);
                    });
                });
            };
        }
    }, [
        dataVal,
        text
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "text ".concat(appliedCssClassNames ? appliedCssClassNames : ""),
        ref: linkTextRef,
        children: richText ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "cmp-text",
            children: (0,helper/* sanitizeInnerHtml */.KD0)(dataVal)
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "cmp-text",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "cmp-text__paragraph",
                "aria-label": text,
                children: text
            })
        })
    });
};
/* harmony default export */ var v1_Text = (Text);

;// CONCATENATED MODULE: ./components/Shared/Footer.jsx










const SitewideWarning = dynamic_default()(()=>__webpack_require__.e(/* import() */ 7171).then(__webpack_require__.bind(__webpack_require__, 37171)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(37171)
            ]
    },
    ssr: false
});
const Footer = (props)=>{
    const { data  } = props;
    const { siteWideWarning  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: data[":itemsOrder"].map((key, index)=>{
            var ref;
            const item = data[":items"][key];
            if (key === "mainfooter") {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Shared_MainFooter, {
                            data: item,
                            columnClassNames: "".concat(key, " ").concat(data.columnClassNames[key])
                        }, "".concat(key, "-").concat(index)),
                        (siteWideWarning === null || siteWideWarning === void 0 ? void 0 : siteWideWarning.content) && /*#__PURE__*/ (0,jsx_runtime.jsx)(SitewideWarning, {
                            isRendered: siteWideWarning.isRendered,
                            siteWideWarning: siteWideWarning === null || siteWideWarning === void 0 ? void 0 : siteWideWarning.content
                        }, "".concat(key, "-").concat(index, "-SitewideWarning"))
                    ]
                }, "".concat(key, "-").concat(index));
            }
            if (key.includes("newslettersignin")) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsletterFooter_NewsletterFooter, {
                    data: item,
                    columnClassNames: "".concat(key, " ").concat(data.columnClassNames[key])
                }, "".concat(key, "-").concat(index));
            }
            if (key.includes("additionalfooter")) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Shared_AdditionalFooter, {
                    data: item,
                    columnClassNames: "".concat(data[":items"][key]["appliedCssClassNames"], " ").concat(key, " ").concat(data.columnClassNames[key])
                }, "".concat(key, "-").concat(index));
            }
            if ((ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(constants.COMPONENT_TYPES.TEXT)) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_Text, {
                    data: item,
                    columnClassNames: "".concat(data[":items"][key]["appliedCssClassNames"], " ").concat(key, " ").concat(data.columnClassNames[key])
                }, "".concat(key, "-").concat(index));
            }
        })
    });
};
/* harmony default export */ var Shared_Footer = (Footer);

;// CONCATENATED MODULE: ./utils/lazyLoadImage.js
const loadLazyImage = (srcRef, imgRef)=>{
    const newSourceRef = Array.isArray(srcRef === null || srcRef === void 0 ? void 0 : srcRef.current) ? srcRef === null || srcRef === void 0 ? void 0 : srcRef.current : [
        srcRef === null || srcRef === void 0 ? void 0 : srcRef.current
    ];
    if ((newSourceRef === null || newSourceRef === void 0 ? void 0 : newSourceRef.length) > 0) {
        newSourceRef.forEach((src, index)=>{
            if (src === null || src === void 0 ? void 0 : src.hasAttribute("data-srcset")) {
                var ref;
                (ref = newSourceRef[index]) === null || ref === void 0 ? void 0 : ref.setAttribute("srcset", src === null || src === void 0 ? void 0 : src.getAttribute("data-srcset"));
                src === null || src === void 0 ? void 0 : src.removeAttribute("data-srcset");
            }
        });
    }
    const newImageRef = Array.isArray(imgRef === null || imgRef === void 0 ? void 0 : imgRef.current) ? imgRef === null || imgRef === void 0 ? void 0 : imgRef.current : [
        imgRef === null || imgRef === void 0 ? void 0 : imgRef.current
    ];
    if ((newImageRef === null || newImageRef === void 0 ? void 0 : newImageRef.length) > 0) {
        newImageRef.forEach((img, index)=>{
            if (img === null || img === void 0 ? void 0 : img.hasAttribute("data-src")) {
                var ref;
                (ref = newImageRef[index]) === null || ref === void 0 ? void 0 : ref.setAttribute("src", img === null || img === void 0 ? void 0 : img.getAttribute("data-src"));
                img === null || img === void 0 ? void 0 : img.removeAttribute("data-src");
            }
        });
    }
};

;// CONCATENATED MODULE: ./components/Default/Image/v3/Image.jsx






const CustomImage = (props)=>{
    const { data  } = props;
    const { linkURL , newTab , fileReference , imageLazyLoad , defaultRenditions: imageModifiersScene7 , defaultImageURL , imageURLWithoutCrop , displayPopupTitle , imageComponentProperties: { alt , title  } , description , items  } = data;
    const pictureRef = (0,react.useRef)(null);
    const sourcesRef = (0,react.useRef)([]);
    const imageRef = (0,react.useRef)(null);
    const { ref: inViewRef , inView  } = useInView({
        threshold: 0
    });
    const placeholderImage = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
    const lazyLoadValue = (0,helper/* convertStringToBoolean */.mUs)(imageLazyLoad) ? "false" : "true";
    const finalSrcValue = "".concat(defaultImageURL ? defaultImageURL : imageURLWithoutCrop).concat(imageModifiersScene7 ? "?" : "").concat(imageModifiersScene7 ? imageModifiersScene7 : "");
    const content = (0,helper/* convertStringToBoolean */.mUs)(imageLazyLoad) && fileReference ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("picture", {
        ref: pictureRef,
        lazyload: lazyLoadValue,
        children: [
            items.map((obj, index)=>{
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                    ref: (el)=>sourcesRef.current[index] = el,
                    media: "(min-width: ".concat(obj.deviceSize, ")"),
                    alt: alt || "true",
                    srcSet: placeholderImage,
                    "data-srcset": "".concat(obj.imageURL).concat(imageModifiersScene7 ? "?" : "").concat(imageModifiersScene7 ? imageModifiersScene7 : "")
                }, index);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                ref: imageRef,
                className: "cmp-image__image",
                src: placeholderImage,
                "data-src": finalSrcValue,
                alt: alt || "true",
                style: {
                    width: "100%"
                }
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("picture", {
        lazyload: lazyLoadValue,
        children: [
            items.map((obj, index)=>{
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                    ref: (el)=>sourcesRef.current[index] = el,
                    media: "(min-width: ".concat(obj.deviceSize, ")"),
                    alt: alt || "true",
                    srcSet: "".concat(obj.imageURL).concat(imageModifiersScene7 ? "?" : "").concat(imageModifiersScene7 ? imageModifiersScene7 : "")
                }, index);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                ref: imageRef,
                className: "cmp-image__image",
                src: finalSrcValue,
                alt: alt || "true",
                style: {
                    width: "100%"
                }
            })
        ]
    });
    (0,react.useEffect)(()=>{
        if (inView) {
            if ((0,helper/* convertStringToBoolean */.mUs)(imageLazyLoad)) {
                loadLazyImage(sourcesRef, imageRef);
            }
        }
    }, [
        inView
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "cmp-image",
        itemScope: true,
        itemType: "https://schema.org/ImageObject",
        ref: inViewRef,
        children: [
            linkURL ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                className: "cmp-image__link",
                href: linkURL,
                target: (0,helper/* convertStringToBoolean */.mUs)(newTab) ? "_blank" : "_self",
                rel: "noreferrer",
                children: content
            }) : content,
            !(0,helper/* convertStringToBoolean */.mUs)(displayPopupTitle) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "cmp-image__title",
                itemProp: "caption",
                dangerouslySetInnerHTML: {
                    __html: browser_default().sanitize(description)
                }
            }),
            (0,helper/* convertStringToBoolean */.mUs)(displayPopupTitle) && title && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                itemProp: "caption",
                content: title
            })
        ]
    });
};
/* harmony default export */ var v3_Image = (CustomImage);

// EXTERNAL MODULE: ./components/HelpSupport/v1/index.module.scss
var v1_index_module = __webpack_require__(95816);
var v1_index_module_default = /*#__PURE__*/__webpack_require__.n(v1_index_module);
;// CONCATENATED MODULE: ./components/HelpSupport/v1/helpSupportAnalytics.js

const helpSupportAnalytics = (pageName, phoneNumber)=>{
    return JSON.stringify({
        clickInternalLinks: "true",
        internalLinkPosition: constants.HELP_SUPPORT,
        internalLinkZoneName: "".concat(pageName, ":").concat(constants.HELP_AND_SUPPORT),
        internalLinkURL: "tel:".concat(phoneNumber),
        internalLinkName: "".concat(phoneNumber),
        eventName: "".concat(pageName, ":").concat(constants.HELP_AND_SUPPORT, ":").concat(phoneNumber),
        internalLinkType: "".concat(pageName, ":").concat(constants.CALL_OUR_TEAM),
        eventType: "navigation",
        eventAction: "".concat(pageName, ":").concat(constants.HELP_AND_SUPPORT, ":").concat(phoneNumber),
        eventMsg: "n/a",
        eventStatus: "n/a"
    });
};

;// CONCATENATED MODULE: ./components/HelpSupport/v1/HelpSupport.jsx






const HelpSupport = (param)=>{
    let { data  } = param;
    const { helpTitle ="" , helpDescription ="" , chatTitle ="" , chatDescription ="" , chatLink ="" , chatLinkRef =false , contactTitle ="" , contactDescription ="" , prodSupportTitle ="" , prodSupportDescription ="" , prodSupportItems =[] , chatText ="" , contactItems =[] , pageName ="" , enableChat =false  } = data;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (v1_index_module_default()).helpSupportWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "help-support ",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "gbh-container",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "help-support-left",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "help-support-left-title",
                                dangerouslySetInnerHTML: {
                                    __html: browser_default().sanitize(helpTitle)
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "help-support-left-description",
                                dangerouslySetInnerHTML: {
                                    __html: browser_default().sanitize(helpDescription)
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "help-support-right",
                        children: [
                            chatTitle && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "chat",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "chat-title",
                                        dangerouslySetInnerHTML: {
                                            __html: browser_default().sanitize(chatTitle)
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "chat-description",
                                        dangerouslySetInnerHTML: {
                                            __html: browser_default().sanitize(chatDescription)
                                        }
                                    }),
                                    chatLink && enableChat && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: (0,helper/* removeAndCleanLink */.xEh)(chatLink),
                                        target: chatLinkRef ? "_blank" : "_self",
                                        rel: "noopener noreferrer",
                                        "data-gbh-data-layer": '{"clickInternalLinks":"'.concat(!chatLinkRef, '","internalLinkPosition":"help support","internalLinkZoneName":"').concat(pageName, ':help and support","internalLinkURL":"').concat((0,helper/* removeAndCleanLink */.xEh)(chatLink), '","internalLinkName":"').concat(chatTitle, '","eventName":"').concat(pageName, ":help and support:").concat(chatTitle, '","internalLinkType":"').concat(pageName, ':navigation","eventType":"help support","eventAction":"').concat(pageName, ":help and support:").concat(chatTitle, '"}'),
                                        className: "gbh-data-layer",
                                        children: chatText
                                    })
                                ]
                            }),
                            contactTitle && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "chat",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "chat-title",
                                        dangerouslySetInnerHTML: {
                                            __html: browser_default().sanitize(contactTitle)
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "chat-description",
                                        dangerouslySetInnerHTML: {
                                            __html: browser_default().sanitize(contactDescription)
                                        }
                                    }),
                                    contactItems && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "contact-number",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                            children: contactItems.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        href: "tel:".concat(item.phoneNumber),
                                                        "data-gbh-data-layer": helpSupportAnalytics(pageName, item.phoneNumber),
                                                        className: "gbh-data-layer",
                                                        children: item.phoneNumber
                                                    })
                                                }, "".concat(item.phoneNumber, "+").concat(index)))
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "chat",
                                children: [
                                    prodSupportTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "chat-title",
                                        dangerouslySetInnerHTML: {
                                            __html: browser_default().sanitize(prodSupportTitle)
                                        }
                                    }),
                                    prodSupportDescription && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "chat-description",
                                        dangerouslySetInnerHTML: {
                                            __html: browser_default().sanitize((0,helper/* removeAndCleanLink */.xEh)(prodSupportDescription))
                                        }
                                    }),
                                    prodSupportItems && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "support-links",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                            children: prodSupportItems.map((item)=>{
                                                /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                                                    className: item.isDisplayButton ? "chat-button" : "",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        href: (0,helper/* removeAndCleanLink */.xEh)(item === null || item === void 0 ? void 0 : item.linkProdSup),
                                                        target: item.isNewTabProd ? "_blank" : "_self",
                                                        rel: "noopener noreferrer",
                                                        "data-gbh-data-layer": '{"clickInternalLinks": "'.concat(item.isNewTabProd ? "false" : "true", '", "internalLinkPosition": "help support", "internalLinkZoneName": "').concat(pageName, ':help and support", "internalLinkURL": "').concat((0,helper/* removeAndCleanLink */.xEh)(item === null || item === void 0 ? void 0 : item.linkProdSup), '", "internalLinkName": "').concat(item.labelProdSup, '", "eventName": "').concat(pageName, ":help and support:").concat(item.labelProdSup, '", "internalLinkType": "').concat(pageName, ':product support", "eventType": "help support", "eventAction": "').concat(pageName, ":help and support:").concat(item.labelProdSup, '"}'),
                                                        className: "gbh-data-layer",
                                                        children: item.labelProdSup
                                                    })
                                                }, item.labelProdSup);
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var v1_HelpSupport = (HelpSupport);

;// CONCATENATED MODULE: ./components/Default/Tab/v1/TabHelper.js


const that = {};
let dataLayerEnabled;
let dataLayer;
const getDataLayerId = (componentDataLayer)=>{
    return Object.keys(JSON.parse(componentDataLayer))[0];
};
const readData = function() {
    let element = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var ref;
    const { dataset: data = {}  } = element;
    const options = [];
    let capitalized = constants.IS;
    capitalized = ((ref = capitalized === null || capitalized === void 0 ? void 0 : capitalized.charAt(0)) === null || ref === void 0 ? void 0 : ref.toUpperCase()) + (capitalized === null || capitalized === void 0 ? void 0 : capitalized.slice(1));
    const reserved = [
        "is",
        "hook" + capitalized
    ];
    for(const key in data){
        if (data && Object.prototype.hasOwnProperty.call(data, key)) {
            const value = data[key];
            if ((key === null || key === void 0 ? void 0 : key.indexOf(constants.NS)) === 0) {
                var ref1;
                const newKey = key === null || key === void 0 ? void 0 : key.slice(constants.NS.length);
                const finalKey = ((ref1 = newKey === null || newKey === void 0 ? void 0 : newKey.charAt(0)) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase()) + (newKey === null || newKey === void 0 ? void 0 : newKey.substring(1));
                if ((reserved === null || reserved === void 0 ? void 0 : reserved.indexOf(finalKey)) === -1) {
                    options[finalKey] = value;
                }
            }
        }
    }
    return options;
};
const getActiveIndex = function() {
    let tabs = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    if (tabs) {
        return tabs === null || tabs === void 0 ? void 0 : tabs.findIndex((tab)=>{
            var ref, ref1;
            return tab === null || tab === void 0 ? void 0 : (ref = tab.classList) === null || ref === void 0 ? void 0 : ref.contains(constants.selectors === null || constants.selectors === void 0 ? void 0 : (ref1 = constants.selectors.active) === null || ref1 === void 0 ? void 0 : ref1.tab);
        });
    }
    return 0;
};
const cacheElements = function() {
    let wrapper = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var ref, ref1;
    that._elements = {};
    that._elements.self = wrapper;
    const hooks = that === null || that === void 0 ? void 0 : (ref = that._elements) === null || ref === void 0 ? void 0 : (ref1 = ref.self) === null || ref1 === void 0 ? void 0 : ref1.querySelectorAll("[data-" + constants.NS + "-hook-" + constants.IS + "]");
    for (const hook of hooks){
        var ref2;
        if ((hook === null || hook === void 0 ? void 0 : hook.closest("." + constants.NS + "-" + constants.IS)) === (that === null || that === void 0 ? void 0 : (ref2 = that._elements) === null || ref2 === void 0 ? void 0 : ref2.self)) {
            var ref3;
            // only process own tab elements
            let capitalized = constants.IS;
            capitalized = ((ref3 = capitalized === null || capitalized === void 0 ? void 0 : capitalized.charAt(0)) === null || ref3 === void 0 ? void 0 : ref3.toUpperCase()) + (capitalized === null || capitalized === void 0 ? void 0 : capitalized.slice(1));
            const key = hook === null || hook === void 0 ? void 0 : hook.dataset[constants.NS + "Hook" + capitalized];
            if (that === null || that === void 0 ? void 0 : that._elements[key]) {
                var ref4;
                if (!(Array === null || Array === void 0 ? void 0 : Array.isArray(that === null || that === void 0 ? void 0 : that._elements[key]))) {
                    const tmp = that === null || that === void 0 ? void 0 : that._elements[key];
                    that._elements[key] = [
                        tmp
                    ];
                }
                (ref4 = that === null || that === void 0 ? void 0 : that._elements[key]) === null || ref4 === void 0 ? void 0 : ref4.push(hook);
            } else {
                that._elements[key] = hook;
            }
        }
    }
};
const focusWithoutScroll = function() {
    let element = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const x = (window === null || window === void 0 ? void 0 : window.scrollX) || (window === null || window === void 0 ? void 0 : window.pageXOffset);
    const y = (window === null || window === void 0 ? void 0 : window.scrollY) || (window === null || window === void 0 ? void 0 : window.pageYOffset);
    element === null || element === void 0 ? void 0 : element.focus();
    window === null || window === void 0 ? void 0 : window.scrollTo(x, y);
};
const refreshActive = ()=>{
    const tabpanels = that === null || that === void 0 ? void 0 : that._elements["tabpanel"];
    const tabs = that === null || that === void 0 ? void 0 : that._elements["tab"];
    const headerTabs = document === null || document === void 0 ? void 0 : document.querySelectorAll(".header-mega-menu-container .cmp-tabs div.cmp-tabs__tabpanel");
    if (tabpanels) {
        if (Array.isArray(tabpanels)) {
            tabpanels === null || tabpanels === void 0 ? void 0 : tabpanels.forEach((tabpanel, i)=>{
                var ref, ref1;
                if (i === parseInt(that === null || that === void 0 ? void 0 : that._active) && !((ref = headerTabs[that === null || that === void 0 ? void 0 : that._active]) === null || ref === void 0 ? void 0 : (ref1 = ref.classList) === null || ref1 === void 0 ? void 0 : ref1.contains("cmp-tabs__tabpanel--active"))) {
                    var ref2, ref3, ref4, ref5, ref6, ref7, ref8;
                    tabpanel === null || tabpanel === void 0 ? void 0 : (ref2 = tabpanel.classList) === null || ref2 === void 0 ? void 0 : ref2.add(constants.selectors === null || constants.selectors === void 0 ? void 0 : (ref3 = constants.selectors.active) === null || ref3 === void 0 ? void 0 : ref3.tabpanel);
                    tabpanel === null || tabpanel === void 0 ? void 0 : tabpanel.removeAttribute("aria-hidden");
                    (ref4 = tabs[i]) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.classList) === null || ref5 === void 0 ? void 0 : ref5.add(constants.selectors === null || constants.selectors === void 0 ? void 0 : (ref6 = constants.selectors.active) === null || ref6 === void 0 ? void 0 : ref6.tab);
                    (ref7 = tabs[i]) === null || ref7 === void 0 ? void 0 : ref7.setAttribute("aria-selected", true);
                    (ref8 = tabs[i]) === null || ref8 === void 0 ? void 0 : ref8.setAttribute("tabindex", "0");
                } else {
                    var ref9, ref10, ref11, ref12, ref13, ref14;
                    tabpanel === null || tabpanel === void 0 ? void 0 : (ref9 = tabpanel.classList) === null || ref9 === void 0 ? void 0 : ref9.remove(constants.selectors === null || constants.selectors === void 0 ? void 0 : (ref10 = constants.selectors.active) === null || ref10 === void 0 ? void 0 : ref10.tabpanel);
                    tabpanel === null || tabpanel === void 0 ? void 0 : tabpanel.setAttribute("aria-hidden", true);
                    (ref11 = tabs[i]) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.classList) === null || ref12 === void 0 ? void 0 : ref12.remove(constants.selectors === null || constants.selectors === void 0 ? void 0 : (ref13 = constants.selectors.active) === null || ref13 === void 0 ? void 0 : ref13.tab);
                    (ref14 = tabs[i]) === null || ref14 === void 0 ? void 0 : ref14.setAttribute("aria-selected", false);
                }
            });
        } else {
            var // only one tab
            ref, ref1, ref2, ref3;
            tabpanels === null || tabpanels === void 0 ? void 0 : (ref = tabpanels.classList) === null || ref === void 0 ? void 0 : ref.add(constants.selectors === null || constants.selectors === void 0 ? void 0 : (ref1 = constants.selectors.active) === null || ref1 === void 0 ? void 0 : ref1.tabpanel);
            tabs === null || tabs === void 0 ? void 0 : (ref2 = tabs.classList) === null || ref2 === void 0 ? void 0 : ref2.add(constants.selectors === null || constants.selectors === void 0 ? void 0 : (ref3 = constants.selectors.active) === null || ref3 === void 0 ? void 0 : ref3.tab);
        }
    }
};
const TabHelper_navigate = function() {
    let index = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    that._active = index;
    refreshActive();
};
const navigateAndFocusTab = function() {
    let index = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    const exActive = that === null || that === void 0 ? void 0 : that._active;
    TabHelper_navigate(index);
    focusWithoutScroll(that === null || that === void 0 ? void 0 : that._elements["tab"][index]);
    if (dataLayerEnabled) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
        const activeItem = getDataLayerId((ref1 = that === null || that === void 0 ? void 0 : (ref = that._elements) === null || ref === void 0 ? void 0 : ref.tabpanel[index]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.dataset) === null || ref2 === void 0 ? void 0 : ref2.gbhDataLayer);
        const exActiveItem = getDataLayerId((ref4 = that === null || that === void 0 ? void 0 : (ref3 = that._elements) === null || ref3 === void 0 ? void 0 : ref3.tabpanel[exActive]) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.dataset) === null || ref5 === void 0 ? void 0 : ref5.gbhDataLayer);
        dataLayer === null || dataLayer === void 0 ? void 0 : dataLayer.push({
            event: "cmp:show",
            eventInfo: {
                path: "component." + activeItem
            }
        });
        dataLayer === null || dataLayer === void 0 ? void 0 : dataLayer.push({
            event: "cmp:hide",
            eventInfo: {
                path: "component." + exActiveItem
            }
        });
        const tabsId = that === null || that === void 0 ? void 0 : (ref6 = that._elements) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.self) === null || ref7 === void 0 ? void 0 : ref7.id;
        const uploadPayload = {
            component: {}
        };
        uploadPayload.component[tabsId] = {
            shownItems: [
                activeItem
            ]
        };
        const removePayload = {
            component: {}
        };
        removePayload.component[tabsId] = {
            shownItems: undefined
        };
        dataLayer.push(removePayload);
        dataLayer.push(uploadPayload);
    }
};
const onKeyDown = function() {
    let event = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var ref;
    const index = that === null || that === void 0 ? void 0 : that._active;
    const lastIndex = ((ref = that === null || that === void 0 ? void 0 : that._elements["tab"]) === null || ref === void 0 ? void 0 : ref.length) - 1;
    const { ARROW_LEFT , ARROW_UP , ARROW_RIGHT , ARROW_DOWN , HOME , END  } = constants.keyCodes;
    const { keyCode =""  } = event;
    switch(keyCode){
        case ARROW_LEFT:
        case ARROW_UP:
            event === null || event === void 0 ? void 0 : event.preventDefault();
            if (index > 0) {
                navigateAndFocusTab(index - 1);
            }
            break;
        case ARROW_RIGHT:
        case ARROW_DOWN:
            event === null || event === void 0 ? void 0 : event.preventDefault();
            if (index < lastIndex) {
                navigateAndFocusTab(index + 1);
            }
            break;
        case HOME:
            event === null || event === void 0 ? void 0 : event.preventDefault();
            navigateAndFocusTab(0);
            break;
        case END:
            event === null || event === void 0 ? void 0 : event.preventDefault();
            navigateAndFocusTab(lastIndex);
            break;
        default:
            return;
    }
};
const bindEvents = ()=>{
    const tabs = that === null || that === void 0 ? void 0 : that._elements["tab"];
    if (tabs) {
        tabs === null || tabs === void 0 ? void 0 : tabs.forEach((tab, index)=>{
            tab.addEventListener("click", ()=>{
                navigateAndFocusTab(index);
            });
            tab.addEventListener("keydown", (event)=>{
                onKeyDown(event);
            });
        });
    }
};
const init = function() {
    let config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var // prevents multiple initialization
    ref, ref1;
    that._config = config;
    config === null || config === void 0 ? void 0 : (ref = config.element) === null || ref === void 0 ? void 0 : ref.removeAttribute("data-" + constants.NS + "-is");
    cacheElements(config === null || config === void 0 ? void 0 : config.element);
    that._active = getActiveIndex(that === null || that === void 0 ? void 0 : that._elements["tab"]);
    if (that === null || that === void 0 ? void 0 : (ref1 = that._elements) === null || ref1 === void 0 ? void 0 : ref1.tabpanel) {
        refreshActive();
        bindEvents();
    }
};
const tabs = function() {
    let config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (config === null || config === void 0 ? void 0 : config.element) {
        init(config);
    }
};
const onDocumentReady = ()=>{
    dataLayerEnabled = false;
    dataLayer = dataLayerEnabled ? (window === null || window === void 0 ? void 0 : window.adobeDataLayer) || [] : undefined;
    const elements = document === null || document === void 0 ? void 0 : document.querySelectorAll(constants.selectors === null || constants.selectors === void 0 ? void 0 : constants.selectors.self);
    elements === null || elements === void 0 ? void 0 : elements.forEach(function() {
        let element = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        tabs({
            element: element,
            options: readData(element)
        });
    });
    const MutationObserver = (window === null || window === void 0 ? void 0 : window.MutationObserver) || (window === null || window === void 0 ? void 0 : window.WebKitMutationObserver) || (window === null || window === void 0 ? void 0 : window.MozMutationObserver);
    const body = document === null || document === void 0 ? void 0 : document.querySelector("body");
    const observer = new MutationObserver((mutations)=>{
        mutations.forEach((mutation)=>{
            var ref, ref1;
            // needed for IE
            const nodesArray = (ref = []) === null || ref === void 0 ? void 0 : (ref1 = ref.slice) === null || ref1 === void 0 ? void 0 : ref1.call(mutation.addedNodes);
            if ((nodesArray === null || nodesArray === void 0 ? void 0 : nodesArray.length) > 0) {
                nodesArray === null || nodesArray === void 0 ? void 0 : nodesArray.forEach((addedNode)=>{
                    if (addedNode === null || addedNode === void 0 ? void 0 : addedNode.querySelectorAll) {
                        var ref, ref1;
                        const elementsArray = (ref = []) === null || ref === void 0 ? void 0 : (ref1 = ref.slice) === null || ref1 === void 0 ? void 0 : ref1.call(addedNode === null || addedNode === void 0 ? void 0 : addedNode.querySelectorAll(constants.selectors === null || constants.selectors === void 0 ? void 0 : constants.selectors.self));
                        elementsArray === null || elementsArray === void 0 ? void 0 : elementsArray.forEach((element)=>{
                            tabs({
                                element: element,
                                options: readData(element)
                            });
                        });
                    }
                });
            }
        });
    });
    observer === null || observer === void 0 ? void 0 : observer.observe(body, {
        subtree: true,
        childList: true,
        characterData: true
    });
};
const getActiveHash = (cb)=>{
    var ref;
    const url = new URL(window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : ref.href);
    const hashed = (browser_default()) === null || (browser_default()) === void 0 ? void 0 : browser_default().sanitize(url === null || url === void 0 ? void 0 : url.hash);
    if ((hashed === null || hashed === void 0 ? void 0 : hashed.length) === 0) {
        return false;
    }
    const hashValue = decodeURIComponent(hashed === null || hashed === void 0 ? void 0 : hashed.slice(1));
    if (hashValue !== "") {
        const tabElements = document === null || document === void 0 ? void 0 : document.querySelectorAll(".cmp-tabs .cmp-tabs__tablist .cmp-tabs__tab");
        tabElements === null || tabElements === void 0 ? void 0 : tabElements.forEach(function() {
            let child = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            const attr = child === null || child === void 0 ? void 0 : child.getAttribute("id");
            if (attr !== null) {
                var ref;
                child === null || child === void 0 ? void 0 : (ref = child.classList) === null || ref === void 0 ? void 0 : ref.remove("cmp-tabs__tab--active");
            }
            if (attr === hashValue) {
                var ref1;
                child === null || child === void 0 ? void 0 : (ref1 = child.classList) === null || ref1 === void 0 ? void 0 : ref1.add("cmp-tabs__tab--active");
            }
        });
        const tabPanelElements = document === null || document === void 0 ? void 0 : document.querySelectorAll(".cmp-tabs .cmp-tabs__tabpanel");
        tabPanelElements === null || tabPanelElements === void 0 ? void 0 : tabPanelElements.forEach(function() {
            let child = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            var ref;
            const attr = (ref = child === null || child === void 0 ? void 0 : child.getAttribute("data-hashid")) === null || ref === void 0 ? void 0 : ref.replaceAll("-", " ");
            if (attr !== null) {
                var ref1;
                child === null || child === void 0 ? void 0 : (ref1 = child.classList) === null || ref1 === void 0 ? void 0 : ref1.remove("cmp-tabs__tabpanel--active");
            }
            if (attr === hashValue) {
                var ref2;
                child === null || child === void 0 ? void 0 : (ref2 = child.classList) === null || ref2 === void 0 ? void 0 : ref2.add("cmp-tabs__tabpanel--active");
                cb && cb(hashValue);
            }
        });
    }
};
const setTabAnimation = function() {
    let tab = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, isTransitionDurationRemove = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    const parent = tab === null || tab === void 0 ? void 0 : tab.closest(".tabs");
    const vertical = (parent === null || parent === void 0 ? void 0 : (ref = parent.classList) === null || ref === void 0 ? void 0 : ref.contains("vertical-tabs")) && ((ref1 = window === null || window === void 0 ? void 0 : window.matchMedia("(min-width: 1024px)")) === null || ref1 === void 0 ? void 0 : ref1.matches);
    const borderClr = (parent === null || parent === void 0 ? void 0 : (ref2 = parent.classList) === null || ref2 === void 0 ? void 0 : ref2.contains("bg-charcoal")) || (parent === null || parent === void 0 ? void 0 : (ref3 = parent.classList) === null || ref3 === void 0 ? void 0 : ref3.contains("bg-slate")) || ((ref4 = parent === null || parent === void 0 ? void 0 : parent.closest(".container")) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.classList) === null || ref5 === void 0 ? void 0 : ref5.contains("bg-charcoal")) || ((ref6 = parent === null || parent === void 0 ? void 0 : parent.closest(".container")) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.classList) === null || ref7 === void 0 ? void 0 : ref7.contains("bg-slate")) ? "#FFF" : "#212121";
    const tabList = tab === null || tab === void 0 ? void 0 : tab.parentElement;
    const selectionBar = tabList === null || tabList === void 0 ? void 0 : tabList.querySelector(".selectionBarcss");
    selectionBar.style.borderColor = borderClr;
    selectionBar.style.transitionDuration = isTransitionDurationRemove ? "0s" : ".5s";
    (ref8 = document === null || document === void 0 ? void 0 : document.querySelectorAll(".cmp-tabs__tablist")) === null || ref8 === void 0 ? void 0 : ref8.forEach(function() {
        let element = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        element.style.position = "relative";
    });
    const rectTargetTab = tab === null || tab === void 0 ? void 0 : tab.getBoundingClientRect();
    const rectTabList = tabList === null || tabList === void 0 ? void 0 : tabList.getBoundingClientRect();
    if (vertical) {
        const selectionBarWidth = (rectTargetTab === null || rectTargetTab === void 0 ? void 0 : rectTargetTab.height) / (rectTabList === null || rectTabList === void 0 ? void 0 : rectTabList.height);
        const selectionBarPosition = (rectTargetTab === null || rectTargetTab === void 0 ? void 0 : rectTargetTab.bottom) - (rectTabList === null || rectTabList === void 0 ? void 0 : rectTabList.bottom);
        selectionBar.style.height = (rectTabList === null || rectTabList === void 0 ? void 0 : rectTabList.height) + "px";
        selectionBar.style.transform = "matrix(1, 0, 0, ".concat(selectionBarWidth + (tabList === null || tabList === void 0 ? void 0 : tabList.scrollTop), ", 0, ").concat(selectionBarPosition, ")");
    } else {
        const selectionBarWidth1 = (rectTargetTab === null || rectTargetTab === void 0 ? void 0 : rectTargetTab.width) / (rectTabList === null || rectTabList === void 0 ? void 0 : rectTabList.width);
        const selectionBarPosition1 = (rectTargetTab === null || rectTargetTab === void 0 ? void 0 : rectTargetTab.left) - (rectTabList === null || rectTabList === void 0 ? void 0 : rectTabList.left);
        selectionBar.style.transform = "matrix(".concat(selectionBarWidth1, ", 0, 0, 1, ").concat(selectionBarPosition1 + (tabList === null || tabList === void 0 ? void 0 : tabList.scrollLeft), ", -1)");
    }
};
const handleResizeEvent = ()=>{
    const tabContainer = document === null || document === void 0 ? void 0 : document.querySelectorAll(".tabs");
    tabContainer === null || tabContainer === void 0 ? void 0 : tabContainer.forEach(function() {
        let tabs = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        var ref;
        if (!(tabs === null || tabs === void 0 ? void 0 : (ref = tabs.classList) === null || ref === void 0 ? void 0 : ref.contains("gbh-global-tab"))) {
            const activeTab = tabs === null || tabs === void 0 ? void 0 : tabs.querySelector(".cmp-tabs__tab.cmp-tabs__tab--active");
            if (activeTab) {
                setTabAnimation(activeTab, true);
            }
        }
    });
};
const handleHashchangeEvent = ()=>{
    getActiveHash();
    const tabContainer = document === null || document === void 0 ? void 0 : document.querySelectorAll(".tabs");
    tabContainer === null || tabContainer === void 0 ? void 0 : tabContainer.forEach(function() {
        let tabs = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        var ref;
        if (!(tabs === null || tabs === void 0 ? void 0 : (ref = tabs.classList) === null || ref === void 0 ? void 0 : ref.contains("gbh-global-tab"))) {
            const activeTab = tabs === null || tabs === void 0 ? void 0 : tabs.querySelector(".cmp-tabs__tab.cmp-tabs__tab--active");
            if (activeTab) {
                setTabAnimation(activeTab, false);
            }
        }
    });
};

;// CONCATENATED MODULE: ./components/Default/Tab/v1/TabAnalytics.js



const TabAnalytics_getComponentZone = (element)=>{
    const container = (0,utils/* closest */.oq)(element, (el)=>el.className === "cmp-container");
    const zoneName = container === null || container === void 0 ? void 0 : container.getAttribute("id");
    if (zoneName) {
        if (zoneName === "color-material-finish" || zoneName === "colors-materials-finishes") {
            return "colors-materials-finishes";
        }
        return zoneName.toLowerCase().replaceAll("-", " ");
    } else {
        return "";
    }
};
const getSubMenuValue = (baseValue, isSupportPage, panelTitle)=>{
    if (baseValue) {
        return baseValue;
    }
    if (isSupportPage) {
        return "submenu";
    }
    return panelTitle || "submenu navigation link";
};
const TabAnalytics_getEventInfo = function() {
    let eventName = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", componentLinkType = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", eventAction = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", eventPageType = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", item = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {};
    var ref;
    const panelTitle = ((ref = item["cq:panelTitle"]) === null || ref === void 0 ? void 0 : ref.toLowerCase()) || "";
    const isSupportPage = eventPageType.includes("support");
    const tabContainer = document === null || document === void 0 ? void 0 : document.querySelectorAll(".tabs");
    const isPageInspiration = eventPageType === constants.INSPIRATION_PAGE_NAME.KIPS_BAY_DECORATOR;
    let zoneVal;
    tabContainer === null || tabContainer === void 0 ? void 0 : tabContainer.forEach((tabs)=>{
        var ref;
        if (!(tabs === null || tabs === void 0 ? void 0 : (ref = tabs.classList) === null || ref === void 0 ? void 0 : ref.contains("gbh-global-tab"))) {
            zoneVal = TabAnalytics_getComponentZone(tabs === null || tabs === void 0 ? void 0 : tabs.parentElement);
        }
    });
    const subMenuValue = getSubMenuValue(eventName, isSupportPage, panelTitle);
    const subMenuAction = getSubMenuValue(eventAction, isSupportPage, panelTitle);
    const eventText = isPageInspiration ? "".concat(eventPageType, ":sub menu") : "".concat(eventPageType, ":").concat(zoneVal, ":sub menu");
    return {
        clickInternalLinks: "true",
        internalLinkPosition: "".concat(eventPageType, ":tab"),
        internalLinkZoneName: eventText,
        internalLinkURL: "n/a",
        internalLinkName: "".concat(panelTitle),
        eventName: "".concat(eventText, ":").concat(subMenuValue),
        internalLinkType: "".concat(eventPageType, ":").concat(componentLinkType || "navigation"),
        eventType: "tab",
        eventAction: "".concat(eventText, ":").concat(subMenuAction),
        eventMsg: "n/a",
        eventStatus: "n/a"
    };
};
const handleTabClickDatalayer = function() {
    let eventName = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", componentLinkType = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", eventAction = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", eventPageType = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", item = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {};
    const eventInfo = TabAnalytics_getEventInfo(eventName, componentLinkType, eventAction, eventPageType, item);
    (0,helper/* pushAnalyticsObjToDataLayer */.zYT)(eventInfo);
};

;// CONCATENATED MODULE: ./components/Default/Tab/v1/Tab.jsx











const Tab = (props)=>{
    var ref, ref1, ref2;
    const { data ={} , itemKey ="" , ...extraProps } = props;
    const [selectedTab, setTab] = (0,react.useState)("");
    const tabElement = (0,react.useRef)(null);
    const tabContainerRef = (0,react.useRef)(null);
    const { eventPageType  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const tabNavigationItems = (0,react.useRef)([]);
    const { winWidth  } = (0,useWindowDimensions/* default */.Z)();
    const getDataLayerProps = (item)=>{
        return (0,utils/* recursiveDataFunction */.Qe)(item, constants.COMPONENT_TYPES === null || constants.COMPONENT_TYPES === void 0 ? void 0 : constants.COMPONENT_TYPES.TEASER);
    };
    const removeHash = ()=>{
        var ref, ref1;
        if (window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : (ref1 = ref.href) === null || ref1 === void 0 ? void 0 : ref1.includes("#")) {
            var ref2;
            history === null || history === void 0 ? void 0 : history.replaceState(history === null || history === void 0 ? void 0 : history.state, "", (ref2 = window.location.href) === null || ref2 === void 0 ? void 0 : ref2.split("#")[0]);
        }
    };
    const onClickTab = (data, event)=>{
        removeHash();
        if (selectedTab !== data["cq:panelTitle"]) {
            setTab(data["cq:panelTitle"]);
        }
        const { currentTarget ={}  } = event;
        const clickedTab = currentTarget;
        // Move the tabbed navigation to the center of viewport when clicking
        clickedTab === null || clickedTab === void 0 ? void 0 : clickedTab.scrollIntoView({
            block: "nearest",
            inline: "center"
        });
    };
    (0,react.useEffect)(()=>{
        const selectedItemKey = data["activeItem"];
        setTab(data[":items"][selectedItemKey]["cq:panelTitle"]);
    }, [
        data
    ]);
    (0,react.useEffect)(()=>{
        var ref, ref1;
        // Extract tab items from the data
        const tabItemTitles = (ref = data[":itemsOrder"]) === null || ref === void 0 ? void 0 : ref.map(function() {
            let key = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
            const item = data[":items"][key];
            return item["cq:panelTitle"];
        });
        // Extract the target tab item from the hash
        let tabItemFromHash = decodeURIComponent((browser_default()) === null || (browser_default()) === void 0 ? void 0 : browser_default().sanitize((ref1 = window.location.hash) === null || ref1 === void 0 ? void 0 : ref1.replace("#", "").replaceAll("-", " ")));
        // Set the tab if it's included in the tab items
        if (tabItemTitles === null || tabItemTitles === void 0 ? void 0 : tabItemTitles.includes(tabItemFromHash)) {
            setTab(tabItemFromHash);
        }
        // Event listener for hash changes
        const onHashChanged = ()=>{
            var ref;
            tabItemFromHash = decodeURIComponent((browser_default()) === null || (browser_default()) === void 0 ? void 0 : browser_default().sanitize((ref = window.location.hash) === null || ref === void 0 ? void 0 : ref.replace("#", "").replaceAll("-", " ")));
            if (tabItemTitles === null || tabItemTitles === void 0 ? void 0 : tabItemTitles.includes(tabItemFromHash)) {
                setTab(tabItemFromHash);
            }
        };
        // Add and remove event listener
        window.addEventListener("hashchange", onHashChanged);
        return ()=>{
            window.removeEventListener("hashchange", onHashChanged);
        };
    }, []);
    (0,react.useEffect)(()=>{
        const selectionBar = document === null || document === void 0 ? void 0 : document.querySelectorAll(".selectionBarcss");
        if (!(selectionBar === null || selectionBar === void 0 ? void 0 : selectionBar.length)) {
            onDocumentReady();
            getActiveHash((hashValue)=>{
                setTab(hashValue);
            });
            window === null || window === void 0 ? void 0 : window.addEventListener("resize", handleResizeEvent);
            window === null || window === void 0 ? void 0 : window.addEventListener("hashchange", handleHashchangeEvent);
        }
        return ()=>{
            window === null || window === void 0 ? void 0 : window.removeEventListener("resize", handleResizeEvent);
            window === null || window === void 0 ? void 0 : window.removeEventListener("hashchange", handleHashchangeEvent);
        };
    }, []);
    const getActiveTabIndex = (data)=>{
        var ref;
        return (ref = data[":itemsOrder"].map((key)=>{
            const item = data[":items"][key];
            const panelTitle = item["cq:panelTitle"] || "";
            return panelTitle;
        }).indexOf(selectedTab)) !== null && ref !== void 0 ? ref : "";
    };
    (0,react.useEffect)(()=>{
        if (data && selectedTab) {
            const activeTabIndex = getActiveTabIndex(data);
            if (activeTabIndex !== "") {
                const tabNavEl = tabNavigationItems === null || tabNavigationItems === void 0 ? void 0 : tabNavigationItems.current[activeTabIndex];
                setTabAnimation(tabNavEl);
            }
        }
    }, [
        data,
        selectedTab
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "cmp-tabs",
        "data-cmp-is": "tabs",
        ref: tabContainerRef,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ol", {
                role: "tablist",
                className: "cmp-tabs__tablist",
                "aria-multiselectable": "false",
                ref: tabElement,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "selectionBarcss".concat((data === null || data === void 0 ? void 0 : (ref = data.appliedCssClassNames) === null || ref === void 0 ? void 0 : ref.includes("vertical-tabs")) && winWidth >= 1024 ? " selectionBar-vertical" : " selectionBar-horizontal")
                    }),
                    data[":itemsOrder"] ? (ref1 = data[":itemsOrder"]) === null || ref1 === void 0 ? void 0 : ref1.map(function() {
                        let key = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", index = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                        const item = data[":items"][key];
                        const panelTitle = item["cq:panelTitle"] || "";
                        const dataLayerProps = getDataLayerProps(item);
                        const { eventName ="" , componentLinkType ="" , eventAction =""  } = dataLayerProps !== null && dataLayerProps !== void 0 ? dataLayerProps : {};
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            ref: (ref)=>{
                                tabNavigationItems.current[index] = ref;
                            },
                            role: "tab",
                            "aria-expanded": "false",
                            className: "cmp-tabs__tab ".concat(selectedTab === "" && index === 0 || selectedTab === panelTitle ? "cmp-tabs__tab--active" : ""),
                            id: panelTitle.replaceAll(" ", "-"),
                            tabIndex: "0",
                            "data-cmp-hook-tabs": "tab",
                            "data-gbh-clickable": "true",
                            onClick: (event)=>{
                                onClickTab(item, event);
                                handleTabClickDatalayer(eventName, componentLinkType, eventAction, eventPageType, item);
                            },
                            children: panelTitle
                        }, panelTitle);
                    }) : null
                ]
            }),
            data[":itemsOrder"] ? (ref2 = data[":itemsOrder"]) === null || ref2 === void 0 ? void 0 : ref2.map(function() {
                let key = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", index = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                var ref;
                const item = data[":items"][key];
                const { id =""  } = item;
                const panelTitle = item["cq:panelTitle"] || "";
                const hashValue = panelTitle === null || panelTitle === void 0 ? void 0 : panelTitle.replaceAll(" ", "-");
                // set for rerendering child component when nested tabs are present for recalculating the active indicator
                const hasNestedTab = item[":itemsOrder"].some((childKey)=>{
                    const obj = item[":items"][childKey];
                    return (0,utils/* isTab */.wR)(obj);
                });
                const isShopTheRoom = item === null || item === void 0 ? void 0 : (ref = item[":itemsOrder"]) === null || ref === void 0 ? void 0 : ref.some((itemKey)=>{
                    const itemData = item[":items"][itemKey];
                    return (0,utils/* isShopTheRoomCard */.ck)(itemData);
                });
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    role: "tabpanel",
                    "aria-label": panelTitle,
                    "data-hashid": hashValue,
                    className: "cmp-tabs__tabpanel ".concat(selectedTab === panelTitle ? "cmp-tabs__tabpanel--active" : ""),
                    "data-cmp-hook-tabs": "tabpanel",
                    "aria-hidden": selectedTab !== panelTitle,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(utils/* ConditionalWrapper */.M2, {
                        condition: isShopTheRoom,
                        wrapper: (children)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: children
                            }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(utils/* ConditionalWrapper */.M2, {
                            condition: (0,utils/* isContainer */.Nm)(item),
                            wrapper: (children)=>{
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                    className: "".concat((0,utils/* isContainer */.Nm)(item) ? constants.staticClasses.CONTAINER : "", " ").concat(item.appliedCssClassNames),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "cmp-container",
                                        children: (item === null || item === void 0 ? void 0 : item.gridClassNames) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: item === null || item === void 0 ? void 0 : item.gridClassNames,
                                            children: children
                                        }) : {
                                            children
                                        }
                                    })
                                });
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_AemGrid, {
                                ...hasNestedTab ? {
                                    key: selectedTab
                                } : {},
                                data: item,
                                containerId: id,
                                itemKey: key ? key : itemKey,
                                ...extraProps
                            })
                        })
                    })
                }, "navItem-".concat(index));
            }) : null
        ]
    });
};
/* harmony default export */ var v1_Tab = (Tab);

;// CONCATENATED MODULE: ./components/Shared/Embed.jsx








const Embed = (props)=>{
    const { data: { script ="" , matterportUrl ="" , visualIcon =false , html ="" , etype =""  } = {}  } = props;
    const isSsr = (0,useIsSsr/* default */.Z)();
    const dispatch = (0,es/* useDispatch */.I0)();
    const [stylesVal, setStylesVal] = (0,react.useState)([]);
    const [reloadStyles, setReloadStyles] = (0,react.useState)(false);
    const { pageIsInteractive  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const etypeUppercase = etype === null || etype === void 0 ? void 0 : etype.toUpperCase();
    const datalayerRef = (0,react.useRef)();
    const servicesClick = (e)=>{
        const { target: { href ="" , textContent =""  } = {}  } = e;
        datalayerForCookie(textContent, href);
        window.open(href);
    };
    const datalayerForCookie = (text, url)=>{
        const textCont = (0,helper/* sanitizeTextForAnalytics */.T68)(text);
        const eventInfo = {
            clickInternalLinks: "true",
            eventAction: "legal:cookie policy:".concat(textCont),
            eventMsg: "n/a",
            eventName: "legal:cookie policy:".concat(textCont),
            eventStatus: "n/a",
            eventType: "navigation",
            internalLinkName: "".concat(textCont),
            internalLinkPosition: "kohler:legal:cookie policy",
            internalLinkType: "kohler:legal:cookie policy:one trust",
            internalLinkURL: url,
            internalLinkZoneName: "kohler:legal:cookie policy:".concat(textCont)
        };
        (0,helper/* pushAnalyticsObjToDataLayer */.zYT)(eventInfo, "cmp:click");
    };
    (0,react.useEffect)(()=>{
        if (!isSsr && pageIsInteractive) {
            const { styles =[]  } = (0,helper/* isEmbeddedStyles */.fM6)(script);
            setStylesVal(styles);
            if (!reloadStyles) {
                // This is to make sure any 3rdParty Component loaded to the page will get styles applied after loading
                setTimeout(function() {
                    setReloadStyles(true);
                    dispatch((0,genericSlice/* toggleSiteWideWarning */.jy)());
                }, 3000);
            }
        }
    }, [
        isSsr,
        pageIsInteractive,
        reloadStyles
    ]);
    (0,react.useEffect)(()=>{
        if (datalayerRef === null || datalayerRef === void 0 ? void 0 : datalayerRef.current) {
            var ref;
            datalayerRef === null || datalayerRef === void 0 ? void 0 : (ref = datalayerRef.current) === null || ref === void 0 ? void 0 : ref.querySelectorAll("a").forEach((item)=>{
                if ((item === null || item === void 0 ? void 0 : item.getAttribute("listener")) !== "true") {
                    item === null || item === void 0 ? void 0 : item.addEventListener("click", (e)=>{
                        servicesClick(e);
                    });
                }
            });
        }
        return ()=>{
            var ref;
            datalayerRef === null || datalayerRef === void 0 ? void 0 : (ref = datalayerRef.current) === null || ref === void 0 ? void 0 : ref.querySelectorAll("a").forEach((item)=>{
                item === null || item === void 0 ? void 0 : item.removeEventListener("click", servicesClick);
            });
        };
    }, [
        isSsr
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: datalayerRef,
        children: [
            !isSsr && visualIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "gbh-visual-icons",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "gbh-visual-icon-area",
                    tabIndex: "0",
                    role: "button",
                    "aria-label": constants.VISUALICON_ARIA_LABEL
                })
            }),
            !isSsr && etypeUppercase === constants.EMBED_TYPE_HTML && html && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "embed",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "cmp-embed",
                    dangerouslySetInnerHTML: {
                        __html: html
                    }
                })
            }),
            !isSsr && etypeUppercase === constants.EMBED_TYPE_SCRIPT && (0,helper/* isEmbeddedElement */.cLX)(script) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "embed",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "cmp-embed",
                    dangerouslySetInnerHTML: {
                        __html: script
                    }
                })
            }),
            pageIsInteractive && etypeUppercase === constants.EMBED_TYPE_SCRIPT && stylesVal.map((style, i)=>{
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("style", {
                        id: "embedStyle-".concat(i, "-").concat((0,helper/* getRandom */.sZz)()),
                        children: style
                    })
                }, "embedStyle-".concat(i, "-").concat((0,helper/* getRandom */.sZz)()));
            }),
            !isSsr && matterportUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "modal fade virtual-tour-popup",
                tabIndex: "-1",
                role: "dialog",
                "aria-labelledby": constants.MATTERPORT_ARIA_LABEL,
                "aria-hidden": "true",
                "data-keyboard": "false",
                "data-backdrop": "static",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "modal-dialog",
                    role: "document",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "modal-content",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "modal-body",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    type: "button",
                                    className: "close",
                                    "data-dismiss": "modal",
                                    "aria-label": "Close",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        "aria-hidden": "true",
                                        children: "\xd7"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                                    src: matterportUrl,
                                    title: "",
                                    style: {
                                        width: "100%",
                                        height: "800px",
                                        border: "0"
                                    },
                                    allowFullScreen: true
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Shared_Embed = (Embed);

;// CONCATENATED MODULE: ./components/Default/Spacer/v1/Spacer.jsx



const Spacer_Spacer = (param)=>{
    let { data  } = param;
    const { backgroundColor ="" , desktopHeight ="" , ipadHeight ="" , mobileHeight =""  } = data;
    const [style, setStyle] = (0,react.useState)({
        backgroundColor: backgroundColor,
        color: backgroundColor,
        height: desktopHeight
    });
    (0,react.useEffect)(()=>{
        if (lib/* isTablet */.Em) {
            setStyle((style)=>{
                return {
                    ...style,
                    height: ipadHeight
                };
            });
        }
        if (lib/* isMobile */.tq) {
            setStyle((style)=>{
                return {
                    ...style,
                    height: mobileHeight
                };
            });
        }
    }, [
        lib/* isTablet */.Em,
        lib/* isMobile */.tq
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "cmp-separator",
        "aria-hidden": "true",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
            className: "cmp-separator__horizontal-rule",
            style: style
        })
    });
};
/* harmony default export */ var v1_Spacer = (Spacer_Spacer);

// EXTERNAL MODULE: ./components/Default/PromoBanner/v1/index.module.scss
var PromoBanner_v1_index_module = __webpack_require__(38326);
var PromoBanner_v1_index_module_default = /*#__PURE__*/__webpack_require__.n(PromoBanner_v1_index_module);
;// CONCATENATED MODULE: ./components/Default/PromoBanner/v1/PromoBanner.jsx









const PromoBanner = (param)=>{
    let { data ={} , properties ={}  } = param;
    var ref, ref1, ref2, ref3;
    const promoBannerSettings = {
        dots: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        swipeToSlide: true,
        swipe: true,
        arrows: true,
        infinite: true,
        centerMode: false
    };
    const { eventPageType  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const dispatch = (0,es/* useDispatch */.I0)();
    const setPromoModal = (data)=>{
        dispatch((0,genericSlice/* showPromoModal */.Wv)(data));
        (0,helper/* preventBodyScroll */.MVu)(true);
    };
    const [bannerIndex, setBannerIndex] = (0,react.useState)(0);
    const getComponentMessage = (message, index)=>{
        if (message && index > -1) {
            const obj = JSON.parse(message);
            obj.componentInfo.componentMessage = "".concat(obj.componentInfo.componentMessage).concat(index + 1);
            return JSON.stringify(obj);
        }
    };
    const afterChangeHandler = (currentIndex)=>{
        setBannerIndex(currentIndex);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (PromoBanner_v1_index_module_default()).promoBannerWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "carousel-slick carousel ".concat(data === null || data === void 0 ? void 0 : (ref = data.carouselComponentProperties) === null || ref === void 0 ? void 0 : ref.appliedCssClassNames),
            role: "group",
            "aria-label": data["carouselComponentProperties"]["accessibilityLabel"] || undefined,
            "aria-roledescription": "carousel",
            "data-gbh-data-layer": '{"clickInternalLinks":"true","internalLinkPosition":"'.concat(eventPageType, ":").concat((properties === null || properties === void 0 ? void 0 : properties.componentPosition) ? properties.componentPosition : "carousel", '","internalLinkZoneName":"').concat(data === null || data === void 0 ? void 0 : data.pageName.toLowerCase(), ":").concat((properties === null || properties === void 0 ? void 0 : properties.componentZone) ? properties.componentZone : "carousel", '","internalLinkURL":"n/a","internalLinkName":"carousel:rm","eventName":"').concat(data === null || data === void 0 ? void 0 : (ref1 = data.pageName) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase(), '","internalLinkType":"').concat((properties === null || properties === void 0 ? void 0 : properties.componentLinkType) ? properties.componentLinkType : "navigation", '","eventType":"carousel","eventAction":"').concat(data === null || data === void 0 ? void 0 : (ref2 = data.pageName) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase(), '"}'),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "cmp-carousel cmp-carousel-slick ",
                role: "group",
                "aria-label": data["carouselComponentProperties"]["accessibilityLabel"] || undefined,
                "aria-roledescription": "carousel",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_slick_lib/* default */.Z, {
                    ...promoBannerSettings,
                    className: "cmp-carousel-slick__content single-slider",
                    afterChange: afterChangeHandler,
                    children: data["carouselComponentProperties"][":itemsOrder"] && ((ref3 = data["carouselComponentProperties"][":itemsOrder"]) === null || ref3 === void 0 ? void 0 : ref3.map((key, index, arr)=>{
                        var ref;
                        const item = data["carouselComponentProperties"][":items"][key];
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "promo-banner",
                                style: {
                                    visibility: "visible"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "cmp-promo__description",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            dangerouslySetInnerHTML: {
                                                __html: browser_default().sanitize(item === null || item === void 0 ? void 0 : item.description)
                                            }
                                        }),
                                        (item === null || item === void 0 ? void 0 : item.actionsEnabled) && (item === null || item === void 0 ? void 0 : (ref = item.actionItems) === null || ref === void 0 ? void 0 : ref.map((action, index)=>{
                                            return action.enablePopup ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                onClick: ()=>setPromoModal({
                                                        show: true,
                                                        modalContent: {
                                                            banner: item,
                                                            item: action,
                                                            count: index
                                                        }
                                                    }),
                                                "data-toggle": "modal",
                                                "data-target": "#".concat(item === null || item === void 0 ? void 0 : item.promoId, "-").concat(index),
                                                className: "cmp-promo__action-link btn promo-banner-fragment",
                                                rel: "".concat(action.linkRef ? "noreferrer" : ""),
                                                "data-gbh-component": getComponentMessage(item === null || item === void 0 ? void 0 : item.componentInfos, bannerIndex),
                                                "data-gbh-data-layer": '{"clickInternalLinks":"true","internalLinkPosition":"'.concat(eventPageType, ":").concat((properties === null || properties === void 0 ? void 0 : properties.componentPosition) ? properties.componentPosition : "promo banner", '","internalLinkZoneName":"').concat(item === null || item === void 0 ? void 0 : item.pageType.toLowerCase(), ":").concat((properties === null || properties === void 0 ? void 0 : properties.componentZone) ? properties.componentZone : "global header", '","internalLinkURL":"n/a","internalLinkName":"').concat(action === null || action === void 0 ? void 0 : action.text, '","eventName":"').concat(action === null || action === void 0 ? void 0 : action.text.toLowerCase(), '","internalLinkType":"').concat((properties === null || properties === void 0 ? void 0 : properties.componentLinkType) ? properties.componentLinkType : "navigation", '","eventMsg":"n/a","eventStatus":"n/a","eventType":"promo banner","eventAction":"').concat(action === null || action === void 0 ? void 0 : action.text.toLowerCase(), '"}'),
                                                "data-gbh-clickable": true,
                                                children: action === null || action === void 0 ? void 0 : action.text
                                            }, "#".concat(item === null || item === void 0 ? void 0 : item.promoId, "-").concat(index)) : /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_Action, {
                                                item: item,
                                                ...action,
                                                link: (action === null || action === void 0 ? void 0 : action.link) || (action === null || action === void 0 ? void 0 : action.ctaLink),
                                                newTab: action === null || action === void 0 ? void 0 : action.isNewTab,
                                                bannerIndex: bannerIndex
                                            }, "promo-banner-action-".concat(bannerIndex + 1, "-").concat((0,helper/* getRandom */.sZz)()));
                                        }))
                                    ]
                                })
                            })
                        }, (item === null || item === void 0 ? void 0 : item.id) ? item === null || item === void 0 ? void 0 : item.id : "cmp-promo-banner-".concat(index, "-").concat((0,helper/* getRandom */.sZz)()));
                    }))
                })
            })
        })
    });
};
/* harmony default export */ var v1_PromoBanner = (PromoBanner);

// EXTERNAL MODULE: ./node_modules/next/script.js
var next_script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(next_script);
;// CONCATENATED MODULE: ./components/Default/AemForm.jsx






const AemForm = (props)=>{
    var ref;
    const { data: { formPath , submitType , thankyouMessage , useiframe , enableFocusOnFirstField , thankyouConfig  }  } = props;
    const [innerHtmlToSet, setInnerHtmlToSet] = (0,react.useState)("");
    const [formScripts, setFormScripts] = (0,react.useState)(null);
    const [noOfScripts, setNoOfScripts] = (0,react.useState)(0);
    (0,react.useEffect)(()=>{
        (0,constants_api/* aemAxiosInstance */.Gb)({
            url: constants.GLOBAL_CONFIGURATION_ENDPOINT,
            params: {
                path: formPath + ".html"
            }
        }).then((res)=>{
            const scriptsList = [];
            let innerHTML = res.data;
            if ((location === null || location === void 0 ? void 0 : location.hostname) === "localhost") {
                innerHTML = innerHTML.split('rel="stylesheet" href="').join('rel="stylesheet" href="'.concat(constants.authorBaseUrl));
                innerHTML = innerHTML.split('<script src="').join('<script src="'.concat(constants.authorBaseUrl));
            }
            const doc = new DOMParser().parseFromString(innerHTML, "text/html");
            (0,helper/* extractScriptsFromDOM */.CZn)(doc, (item)=>scriptsList.push(item));
            setFormScripts(scriptsList);
            setInnerHtmlToSet(doc);
        });
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                id: "aemFormInitialLoadJavascript",
                "data-nscript": "afterInteractive",
                children: 'const onAemFormScriptLoad = evnt => {\n    const formApp = evnt.detail.formApp\n    formApp.initializeAEMForm({\n      form: "true",\n      submitType: "'.concat(submitType, '",\n      thankyouConfig: "').concat(thankyouConfig, '",\n      thankyouMessage: "').concat(encodeURI(thankyouMessage), '",\n      thankyouPage: "",\n      useIframe: "').concat(useiframe, '",\n      height: "auto",\n      aemFormComponentPath: "aemform",\n      enableFocusOnFirstField: "').concat(enableFocusOnFirstField, '",\n    })\n    // remove the event listener after completion\n    window.removeEventListener("aemform-onscript-load", onAemFormScriptLoad)\n  };\n  window.addEventListener("aemform-onscript-load", onAemFormScriptLoad);')
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                src: "/js/formapp.js"
            }),
            formScripts && formScripts.map((script, i)=>{
                if (!script.innerHTML && noOfScripts === i) return /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                    src: script.src,
                    id: "aemform-src-script-".concat(i),
                    onReady: ()=>{
                        setNoOfScripts(i + 1);
                    },
                    onError: ()=>{
                        setNoOfScripts(i + 1);
                    }
                }, "aemform-src-script-".concat(i));
                if (script.innerHTML && noOfScripts === i) return /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                    id: "aemform-innerscript-".concat(i),
                    onReady: ()=>{
                        setNoOfScripts(i + 1);
                    },
                    onError: ()=>{
                        setNoOfScripts(i + 1);
                    },
                    children: "".concat(script.innerHTML)
                }, "aemform-innerscript-".concat(i));
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "aemform aem-genericForm",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "aemformcontainer",
                    "data-form-page-path": formPath,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        dangerouslySetInnerHTML: {
                            __html: innerHtmlToSet === null || innerHtmlToSet === void 0 ? void 0 : (ref = innerHtmlToSet.documentElement) === null || ref === void 0 ? void 0 : ref.innerHTML
                        }
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Default_AemForm = (AemForm);

// EXTERNAL MODULE: ./node_modules/qs/lib/index.js
var qs_lib = __webpack_require__(80129);
var lib_default = /*#__PURE__*/__webpack_require__.n(qs_lib);
// EXTERNAL MODULE: ./components/productCard/v1/ProductCard.view.jsx
var ProductCard_view = __webpack_require__(27221);
// EXTERNAL MODULE: ./components/core/Input/Input.jsx
var Input = __webpack_require__(3372);
// EXTERNAL MODULE: ./components/cart/QuantitySelector.jsx
var QuantitySelector = __webpack_require__(75653);
// EXTERNAL MODULE: ./node_modules/react-number-format/dist/react-number-format.es.js
var react_number_format_es = __webpack_require__(57333);
// EXTERNAL MODULE: ./components/productCard/v1/analytics.js
var v1_analytics = __webpack_require__(76735);
// EXTERNAL MODULE: ./components/productCard/v1/productCardHelper.js
var productCardHelper = __webpack_require__(69442);
// EXTERNAL MODULE: ./components/productCard/v1/index.module.scss
var productCard_v1_index_module = __webpack_require__(53613);
var productCard_v1_index_module_default = /*#__PURE__*/__webpack_require__.n(productCard_v1_index_module);
;// CONCATENATED MODULE: ./components/productCard/v1/ProductCardService.jsx


















const ProductCardService = (props)=>{
    const { staticTexts ={} , imagePosition ="" , narrativeDescription , productFeatures =[] , productCategory ="" , badgeVal ="" , currencySign ="" , isNearestValueUpdated =Boolean , resetNearestValueUpdateFlag =()=>{} , cart ={} , price =Number , skuId ="" , images ="" , userZipCode ="" , slug ="" , getZipCode =()=>{} , customerBrand ="" , name: servicePlanName = ""  } = props;
    const dispatch = (0,es/* useDispatch */.I0)();
    const [quantity, setQuantity] = (0,react.useState)(1);
    const [isNearest, setIsNearest] = (0,react.useState)(false);
    const [isNotNearestError, setIsNotNearestError] = (0,react.useState)(false);
    const [isCheckAvailability, setIsCheckAvailability] = (0,react.useState)(true);
    const [checkZipCode, setCheckZipCode] = (0,react.useState)("");
    const [zipCodeError, setZipCodeError] = (0,react.useState)({
        show: false,
        message: ""
    });
    const [cartUrl, setCartUrl] = (0,react.useState)("");
    const [findaProLandingPagePath, setFindaProLandingPagePath] = (0,react.useState)("");
    const [siteName, setSiteName] = (0,react.useState)("");
    (0,react.useEffect)(()=>{
        (0,constants_config/* getConfig */.i)().then((CONFIG)=>{
            const { general  } = CONFIG;
            var ref;
            (0,helper/* getShortenedUrl */.Ppy)((ref = general === null || general === void 0 ? void 0 : general.findaProLandingPagePath) !== null && ref !== void 0 ? ref : "/").then((url)=>{
                setFindaProLandingPagePath(url);
            });
            var ref1;
            (0,helper/* getShortenedUrl */.Ppy)((ref1 = general === null || general === void 0 ? void 0 : general.cartLandingPagePath) !== null && ref1 !== void 0 ? ref1 : "/").then((url)=>{
                setCartUrl(url);
            });
            setSiteName((general === null || general === void 0 ? void 0 : general.siteName) ? general.siteName[0] : "");
        });
    }, []);
    const showToaster = (msg)=>{
        dispatch((0,genericSlice/* showToast */.CF)({
            message: msg,
            isVisible: true
        }));
    };
    const { altTextForServiceImg ="" , virtualService ="" , virtualTooltip ="" , nearestInPerson ="" , nearestService ="" , change ="" , zipCode ="" , eligibleZipCodeSuccess ="" , eligibleZipCodeError ="" , discountPercentage ="" , off ="" , yourCart , itemAdded , itemsAdded , zipcodeEmptyError ="" , zipodeEmptyError ="" , validZipcode ="" , search =""  } = staticTexts;
    const installServices = productCategory === "Install Services";
    const designServices = productCategory === "Design Services";
    (0,react.useEffect)(()=>{
        if (isNearestValueUpdated && resetNearestValueUpdateFlag) {
            resetNearestValueUpdateFlag();
            if (!isNearest) {
                addZipcodeAnalytics("failure", eligibleZipCodeError.toLowerCase());
            } else {
                addZipcodeAnalytics("success");
            }
        }
    }, [
        isNearestValueUpdated
    ]);
    let discountedPrice = props.discountedPrice;
    let discountPercent = props.discountPercent;
    let discountType = "";
    if ((cart === null || cart === void 0 ? void 0 : cart.lineItems) && cart.lineItems.length > 0) {
        cart.lineItems.filter((item)=>item.productSlug["en-US"] === slug).map((product)=>{
            if (product.discountedPrice) {
                discountedPrice = (Number(get_default()(product.discountedPrice, "value.centAmount", 0)) / 100).toFixed(2);
                discountType = get_default()(product.discountedPrice, "includedDiscounts[0].discount.obj.value.type", "");
                discountPercent = discountType === "absolute" ? Number(get_default()(product.discountedPrice, "includedDiscounts[0].discount.obj.value.money[0].centAmount", 0)) / 100 : Number(get_default()(product.discountedPrice, "includedDiscounts[0].discount.obj.value.permyriad", 0)) / 100;
            }
            if (discountPercent === 0) {
                discountedPrice = Number(get_default()(product.price, "discounted.value.centAmount", 0) / 100).toFixed(2);
                discountType = get_default()(product.price, "discounted.discount.obj.value.type", "");
                discountPercent = discountType === "absolute" ? Number(get_default()(product.price, "discounted.discount.obj.value.money[0].centAmount", 0)) / 100 : Number(get_default()(product.price, "discounted.discount.obj.value.permyriad", 0)) / 100;
            }
        });
    }
    const productPrice = discountPercent > 0 ? discountedPrice : price;
    if (discountType === "") {
        var ref;
        discountType = badgeVal && ((ref = badgeVal === null || badgeVal === void 0 ? void 0 : badgeVal.split(" ")) === null || ref === void 0 ? void 0 : ref.includes("Percent")) ? "relative" : "absolute";
    }
    const getSaleOffer = "<p class='offer-percent'>".concat(discountType === "relative" ? discountPercent + discountPercentage : currencySign + discountPercent + "<span class='offer-percent-text'>" + off + "</span>", "</p>");
    const productAnalyticsData = {
        desc: productFeatures ? (0,helper/* sanitizeTextForAnalytics */.T68)(productFeatures.join(". ")) : "n/a",
        discountPrice: discountPercent > 0 ? discountedPrice : 0,
        discountPriceState: discountPercent > 0 ? "percentOff|" + discountPercent : "regular price",
        unitPrice: price,
        category: (0,helper/* sanitizeTextForAnalytics */.T68)(productCategory),
        color: "n/a",
        sku: skuId,
        name: (0,helper/* sanitizeTextForAnalytics */.T68)(props.name),
        image: images,
        customerFacingSKU: props.customerFacingSKU || (siteName ? siteName[0] + "-" + skuId : ""),
        skuInitials: props.customerFacingSKU ? props.customerFacingSKU.split("-")[0] + "-" : siteName ? siteName[0] + "-" : "",
        discountName: badgeVal,
        superSku: false,
        selectedColor: "n/a",
        productSaleable: true
    };
    const { desc ="n/a" , unitPrice =0 , discountPriceState , category , color , customerFacingSKU , name , discountName  } = productAnalyticsData;
    const serviceName = productCategory === "Design Services" ? "bathroom design services" : (0,helper/* sanitizeTextForAnalytics */.T68)(productCategory);
    let globalDiscount = props.globalDiscount;
    const { productCouponCode , productCoupondiscount , globalDiscountNames , globalDiscountValues  } = (0,helper/* getCurrentSkuCouponDiscounts */.mPk)({
        cart: cart,
        sku: skuId
    });
    let globalOffer = [
        discountName
    ];
    if ((globalDiscountNames === null || globalDiscountNames === void 0 ? void 0 : globalDiscountNames.length) && globalDiscountValues) {
        globalOffer = [
            discountName,
            ...globalDiscountNames
        ];
        globalDiscount += globalDiscountValues;
    }
    const productInfo = {
        description: desc,
        frequency: "n/a",
        globalPromotionPrice: discountedPrice > 0 ? Number((price - globalDiscount).toFixed(2)) : 0,
        globalOffer: globalOffer.join("|") || "n/a",
        globalDiscount: globalDiscount ? Number(globalDiscount.toFixed(2)) : 0,
        isRecommended: "n/a",
        isSendNow: "n/a",
        isSubscription: "n/a",
        priceState: discountPriceState,
        productBasePrice: Number(unitPrice) || "n/a",
        productCategory: category || "n/a",
        productColor: color || "n/a",
        productCoupondiscount: productCoupondiscount || 0,
        productCouponCode: productCouponCode.join("|") || "n/a",
        productID: customerFacingSKU || "n/a",
        productName: name || desc || category || "n/a",
        productPartnerBuyNow: "n/a",
        productRoom: "service" || 0,
        productSalePrice: Number(productPrice),
        productSaleable: true,
        productStatus: "in stock",
        productSuperSku: false,
        productTileName: name || "n/a",
        quantity: quantity || "n/a",
        defaultImageName: productAnalyticsData.image || "n/a",
        ratings: "n/a",
        numberOfReviews: "n/a",
        pdpType: "regular finished goods & service parts",
        productFindingMethod: "n/a",
        productCollectionsName: category || "n/a",
        productBrand: siteName === null || siteName === void 0 ? void 0 : siteName.toLowerCase(),
        itemType: "service" || 0
    };
    const getToasterMsg = (msg)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                msg,
                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: cartUrl,
                    children: yourCart
                }),
                "."
            ]
        });
    const handleCallback = (res, msg)=>{
        if (productCategory === "Install Services") {
            const eventInfoObj = getEventInfoObject("add to cart");
            const { status , message ="n/a"  } = res;
            eventInfoObj.eventStatus = status === 200 ? "success" : "failure";
            if (status !== 200) {
                eventInfoObj.eventMsg = message ? (0,helper/* sanitizeTextForAnalytics */.T68)(message) : "n/a";
            }
            (0,v1_analytics/* callInstallServiceAddToCartAnalytics */.gA)({
                resInfo: res,
                eventInfoObj,
                productInfo,
                cartID: cart === null || cart === void 0 ? void 0 : cart.id
            });
        }
        if (productCategory === "Design Services") {
            (0,v1_analytics/* callDesignServicesAddToCartAnalytics */.__)(res, productInfo, serviceName, cart === null || cart === void 0 ? void 0 : cart.id);
        }
        if (lib/* isMobile */.tq) showToaster(getToasterMsg(msg));
    };
    const addtoCart = (items)=>{
        let totalAdded = 0;
        items.forEach((item)=>totalAdded += item.quantity);
        const msg = totalAdded === 1 ? "".concat(totalAdded, " ").concat(itemAdded, " ") : "".concat(totalAdded, " ").concat(itemsAdded, " ");
        (0,productCardHelper/* productCardAddToCart */.x)([
            ...items
        ], true, "", (res)=>handleCallback(res, msg), false);
    };
    const handleAddToCart = ()=>{
        if (productCategory === "Design Services") {
            addtoCart([
                {
                    sku: skuId,
                    quantity: quantity,
                    brand: customerBrand
                }
            ]);
        } else {
            if (!isEmpty_default()(userZipCode)) {
                addtoCart([
                    {
                        sku: skuId,
                        quantity: quantity,
                        userZipCode: userZipCode,
                        brand: customerBrand
                    }
                ]);
            }
        }
    };
    const handleChange = async (qty)=>{
        if (qty && qty !== 0) {
            setQuantity(qty);
        }
    };
    const handleCheckAvailability = async ()=>{
        setZipCodeError({
            show: false,
            message: ""
        });
        let valid = true;
        let errorMessage = "";
        if (isEmpty_default()(checkZipCode)) {
            setZipCodeError({
                show: true,
                message: zipcodeEmptyError
            });
            valid = false;
            errorMessage = zipodeEmptyError.toLowerCase();
        } else if (!(0,helper/* validateField */.OP$)("zipcode", checkZipCode)) {
            setZipCodeError({
                show: true,
                message: validZipcode
            });
            valid = false;
            errorMessage = validZipcode === null || validZipcode === void 0 ? void 0 : validZipcode.toLowerCase();
        } else if (!await (0,utils_location/* validateZip */.$8)(checkZipCode)) {
            setZipCodeError({
                show: true,
                message: validZipcode
            });
            valid = false;
            errorMessage = validZipcode === null || validZipcode === void 0 ? void 0 : validZipcode.toLowerCase();
        }
        if (valid) {
            getZipCode(checkZipCode, true, callBackZipCode);
        } else {
            addZipcodeAnalytics("failure", errorMessage);
        }
    };
    const handleChangeZipCode = (e)=>{
        const { value  } = e.target;
        if ((0,helper/* validateField */.OP$)("zipCodeNumeric", value) || value === "") {
            setCheckZipCode(value);
        }
        setIsNotNearestError(false);
        setZipCodeError({
            show: false,
            message: ""
        });
    };
    const zipCodeCheck = ()=>{
        if (!(0,helper/* validateField */.OP$)("zipcode", checkZipCode)) {
            setZipCodeError({
                show: true,
                message: validZipcode
            });
        } else {
            setZipCodeError({
                show: false,
                message: ""
            });
        }
    };
    const getEventInfoObject = (eventNameText, buttonName)=>{
        return {
            clickInternalLinks: "true",
            eventAction: "installation services:install service:" + eventNameText,
            eventName: "installation services:install service:" + eventNameText,
            eventType: "navigation",
            internalLinkName: buttonName !== null && buttonName !== void 0 ? buttonName : eventNameText,
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkPosition: "find installation services",
            internalLinkType: "installation services:" + (eventNameText !== "check availability" || !checkZipCode ? "navigation" : checkZipCode),
            internalLinkURL: eventNameText === "find a pro" ? ((findaProLandingPagePath === null || findaProLandingPagePath === void 0 ? void 0 : findaProLandingPagePath.indexOf("http")) === -1 ? window.location.origin : "") + findaProLandingPagePath : "n/a",
            internalLinkZoneName: "installation services:" + productAnalyticsData.name
        };
    };
    const addZipcodeAnalytics = (status, message)=>{
        const eventInfoObj = getEventInfoObject("check availability", "search");
        eventInfoObj.eventMsg = message || "n/a";
        eventInfoObj.eventStatus = status;
        (0,v1_analytics/* callInstallServiceAddToCartAnalytics */.gA)({
            resInfo: {},
            productInfo,
            eventInfoObj,
            cartID: cart === null || cart === void 0 ? void 0 : cart.id
        });
    };
    const callBackZipCode = (isServiceAvailable)=>{
        setIsNearest(isServiceAvailable);
        setIsNotNearestError(!isServiceAvailable);
        setIsCheckAvailability(!isServiceAvailable);
        if (isServiceAvailable) sessionStorage.setItem("verifiedZip", checkZipCode);
    };
    (0,react.useEffect)(()=>{
        const isVerifiedZip = sessionStorage.getItem("verifiedZip");
        if (isVerifiedZip) {
            setIsNearest(true);
            setIsNotNearestError(false);
            setIsCheckAvailability(false);
            setCheckZipCode(isVerifiedZip);
        }
    }, []);
    const handleClickChangeBtn = ()=>{
        setIsCheckAvailability(true);
        setIsNearest(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (productCard_v1_index_module_default()).productCardWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "product-card-service",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "kf-react-container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "row ml-0 mr-0 no-gutters",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col product-card-service__details \n                  ".concat(imagePosition === "left" ? " product-card-service__details-align" : ""),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "".concat(productCategory === "Install Services" ? "product-card-service__details-header" : "product-card-service__service-install"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "row",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "col",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                        className: "product-card-service__name",
                                                        children: servicePlanName
                                                    }),
                                                    productCategory === "Install Services" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "product-card-service__desc",
                                                        children: narrativeDescription
                                                    }) : null,
                                                    productCategory === "Design Services" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "product-card-service__virtual-list",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                            children: productFeatures.map((list, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    children: list
                                                                }, index))
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "product-card-service__img-container \n                              ".concat(imagePosition === "left" ? " product-card-service__img-container-align" : "", " \n                              mobile-landscape-image"),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: images,
                                                    className: "product-card-service__img",
                                                    alt: altTextForServiceImg
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "product-card-service__virtual-service \n                          ".concat(productCategory ? " product-card-service__virtual-service-zip" : ""),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "product-card-service__eligible-service",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "left",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    className: "product-card-service__eligible-service-txt",
                                                                    children: designServices ? virtualService : isNearest ? nearestInPerson : nearestService
                                                                }),
                                                                isNearest && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                            className: "product-card-service__zipcode",
                                                                            children: checkZipCode
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                            tabIndex: "0",
                                                                            role: "link",
                                                                            className: "product-card-service__eligible-service-edit gbh-data-layer",
                                                                            "data-gbh-data-layer": JSON.stringify(getEventInfoObject("edit", "change")),
                                                                            "data-gbh-data-layer-custom": JSON.stringify({
                                                                                productInfo
                                                                            }),
                                                                            onClick: handleClickChangeBtn,
                                                                            children: [
                                                                                " ",
                                                                                change
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        isNearest || designServices ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "product-card-service__price",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                                                    className: "product-card-service__price-value",
                                                                    value: productPrice,
                                                                    displayType: "text",
                                                                    thousandSeparator: true,
                                                                    prefix: currencySign,
                                                                    decimalScale: 2,
                                                                    fixedDecimalScale: true
                                                                }),
                                                                discountPercent > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "product-card-service__discount-price",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: "product-card-service__offer-price",
                                                                            children: (0,helper/* sanitizeInnerHtml */.KD0)(getSaleOffer)
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                                                            className: "strike-through-price",
                                                                            value: price,
                                                                            displayType: "text",
                                                                            thousandSeparator: true,
                                                                            prefix: currencySign,
                                                                            decimalScale: 2,
                                                                            fixedDecimalScale: true
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }) : null
                                                    ]
                                                }),
                                                isCheckAvailability && installServices ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "product-card-service__zipcode-availability",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                                                    id: "zipCode-".concat((0,helper/* getRandom */.sZz)()),
                                                                    type: "text",
                                                                    maxLength: 60,
                                                                    placeholder: "".concat(zipCode),
                                                                    label: "".concat(zipCode),
                                                                    value: checkZipCode,
                                                                    customClass: "".concat(zipCodeError.show ? "product-card-service__zipcode-input-error" : ""),
                                                                    onKeyDown: (e)=>e.key === "Enter" && handleCheckAvailability(),
                                                                    onChange: handleChangeZipCode,
                                                                    onBlur: zipCodeCheck
                                                                }),
                                                                checkZipCode ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                                                    role: "button",
                                                                    className: "product-card-service__check-availability-cta",
                                                                    label: search,
                                                                    size: "small",
                                                                    type: " ",
                                                                    disabled: checkZipCode.length < 5,
                                                                    onClick: handleCheckAvailability
                                                                }) : null
                                                            ]
                                                        }),
                                                        zipCodeError.show && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "product-card-service__zipcode-error",
                                                            children: zipCodeError.message
                                                        })
                                                    ]
                                                }) : null,
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "product-card-service__eligible-service-container",
                                                    children: [
                                                        isNearest || designServices ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "product-card-service__eligible-service-message",
                                                            children: designServices ? virtualTooltip : eligibleZipCodeSuccess
                                                        }) : null,
                                                        isNotNearestError ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                            className: "error",
                                                            children: [
                                                                eligibleZipCodeError,
                                                                " ",
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                    href: findaProLandingPagePath,
                                                                    className: "product-card-service__find-a-pro gbh-data-layer",
                                                                    "data-gbh-data-layer": JSON.stringify(getEventInfoObject("find a pro")),
                                                                    "data-gbh-data-layer-custom": JSON.stringify({
                                                                        productInfo
                                                                    }),
                                                                    children: staticTexts.findaPro
                                                                })
                                                            ]
                                                        }) : null
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    isNearest || designServices ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "product-card-service__price-and-cart",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "product-card-service__cart",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "cartAction mx-0",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "quantity-selector-container",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(QuantitySelector/* default */.Z, {
                                                            doNotRequiredAnalyticsData: true,
                                                            productData: productAnalyticsData,
                                                            value: quantity,
                                                            onChange: handleChange,
                                                            isPDPQuantitySelector: true
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "add-to-cart-container",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                                            role: "button",
                                                            label: staticTexts.addToCart,
                                                            onClick: handleAddToCart,
                                                            size: "large",
                                                            type: "primary",
                                                            flexible: true,
                                                            disabled: productCategory !== "Design Services" ? !isNearest : false
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    }) : null
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "product-card-service__img-container ".concat(imagePosition === "left" ? " product-card-service__img-container-align" : "", " product-card-service-main-image"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: images,
                                className: "product-card-service__img",
                                alt: altTextForServiceImg
                            })
                        })
                    ]
                })
            })
        })
    });
};
ProductCardService.defaultProps = {
    newTab: false,
    staticTexts: {}
};
ProductCardService.propTypes = {
    newTab: (prop_types_default()).bool,
    staticTexts: (prop_types_default()).object
};
/* harmony default export */ var v1_ProductCardService = (ProductCardService);

;// CONCATENATED MODULE: ./i18n/useProductCardi18n.js

const useProductCardi18n = (param)=>{
    let { componentProps  } = param;
    const { t  } = (0,esm/* useTranslation */.$G)();
    const i18n = {
        color: t("kf.productcard.color"),
        colors: t("kf.productcard.colors"),
        altText: t("kf.productCard.altText"),
        altTextForServiceImg: t("kf.productCard.altTextForServiceImg"),
        virtualService: t("kf.productCard.virtualService"),
        virtualTooltip: t("kf.productCard.virtualTooltip"),
        addToCart: t("kf.productCard.addToCart"),
        toolTipAlt: t("kf.productCard.toolTipAlt"),
        nearestService: t("kf.productCard.nearestService"),
        nearestInPerson: t("kf.productCard.nearestInPerson"),
        edit: t("kf.productCard.edit"),
        eligibleZipCodeSuccess: t("kf.productCard.eligibleZipCodeSuccess"),
        eligibleZipCodeError: t("kf.productCard.eligibleZipCodeError"),
        zipcode: t("kf.productCard.zipcode"),
        findaPro: t("kf.productCard.findaPro"),
        checkAvailability: t("kf.productCard.checkAvailability"),
        maxInventory: t("kf.productCard.maxInventory"),
        itemsAdded: t("kf.productCard.itemsAdded"),
        itemAdded: t("kf.productCard.itemAdded"),
        yourCart: t("kf.productCard.yourCart"),
        zipcodeEmptyError: t("kf.productCard.zipcodeEmptyError"),
        validZipcode: t("kf.productCard.validZipcode"),
        ariaLabel: {
            color: t("kf.productCard.aria.colors"),
            tooltip: t("kf.productCard.aria.tooltip"),
            editZip: t("kf.productCard.aria.label.editZip"),
            findPro: t("kf.productCard.aria.label.findPro")
        },
        discountPercentage: t("kf.productCard.discountPercentage"),
        off: t("kf.productCard.off"),
        lfLabel: t("annsacks.pdpTrimCalculator.label.LF"),
        sfLabel: t("annsacks.pdpTrimCalculator.label.SF"),
        boxLabel: t("annsacks.pdpProductSummary.label.perBox"),
        recentlyViewedColor: t("kf.productcard.color"),
        recentlyViewedColors: t("kf.productcard.colors")
    };
    return i18n;
};
/* harmony default export */ var i18n_useProductCardi18n = (useProductCardi18n);

// EXTERNAL MODULE: ./store/features/cartSlice.js
var cartSlice = __webpack_require__(46201);
;// CONCATENATED MODULE: ./components/productCard/v1/ProductCard.jsx
















const ProductCard = (props)=>{
    const { data: authorData , data: { presetConfigs  }  } = props;
    const { cart  } = (0,es/* useSelector */.v9)(cartSlice/* selectCartState */.xw);
    const [state] = (0,react.useState)({
        productSkuId: authorData.type === "productSku" ? get_default()(authorData, "productSkuId", "") : get_default()(authorData, "serviceSkuId", ""),
        newTab: get_default()(authorData, "newTab", false),
        skuType: get_default()(authorData, "type", ""),
        imagePosition: get_default()(authorData, "imagePosition", ""),
        jsonFileUrl: get_default()(authorData, "jsonFilePath", ""),
        swatchUrl: authorData.swatchUrl
    });
    const [productDetailData, setProductDetailData] = (0,react.useState)({});
    const [userZipCode, setUserZipCode] = (0,react.useState)("");
    const [isNearest, setIsNearest] = (0,react.useState)(false);
    const [isNearestValueUpdated, setIsNearestValueUpdated] = (0,react.useState)(false);
    const [zipCodeData, setZipCodeData] = (0,react.useState)([]);
    const [info, setInfo] = (0,react.useState)({});
    const staticTexts = i18n_useProductCardi18n({});
    const persona = (0,helper/* getUserPersona */.shu)();
    (0,react.useEffect)(()=>{
        (0,constants_config/* getConfig */.i)().then(async (config)=>{
            var ref;
            var ref1;
            const brandName = (ref1 = config === null || config === void 0 ? void 0 : (ref = config.general) === null || ref === void 0 ? void 0 : ref.siteName) !== null && ref1 !== void 0 ? ref1 : "";
            const language = get_default()(config, "internationalization.language", "en");
            const locale = get_default()(config, "internationalization.locale", "");
            const currencySign = get_default()(config, "internationalization.currencySign", "");
            const currencyCode = get_default()(config, "internationalization.currencyCode", "");
            const { general: { lwAppName =""  } = {}  } = config !== null && config !== void 0 ? config : {};
            (0,constants_api/* aemAxiosInstance */.Gb)({
                url: constants.GLOBAL_CONFIGURATION_ENDPOINT,
                params: {
                    path: state.jsonFileUrl
                }
            }).then((response)=>{
                if (response && response.data) {
                    var _zipcode;
                    setZipCodeData((_zipcode = response.data.zipcode) !== null && _zipcode !== void 0 ? _zipcode : []);
                }
            }).catch((err)=>{
                console.error("Failed to get compare attributes JSON file", err);
            });
            const info = {
                locale: locale,
                language: language,
                currencySign: currencySign,
                currencyCode: currencyCode,
                brandName: brandName,
                lwAppName
            };
            setInfo(info);
        });
    }, []);
    (0,react.useEffect)(()=>{
        try {
            if (!isEmpty_default()(info)) {
                fetchFromSku();
            }
        } catch (error) {
            console.error(error);
        }
        getUserLocation();
    }, [
        info
    ]);
    const getUserLocation = ()=>{
        (0,helper/* getLocationByCookies */.ngN)().then((getLocation)=>{
            var _zipcode;
            const userZipCode = (_zipcode = getLocation.zipcode) !== null && _zipcode !== void 0 ? _zipcode : "";
            checkUserZipCode(userZipCode);
        });
    };
    const checkUserZipCode = function(userZipCodeVal, callBack) {
        let needAnalytics = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
        const newCodes = [];
        zipCodeData.map((codes)=>{
            Object.keys(codes).forEach((key)=>{
                newCodes.push(codes[key].includes(userZipCodeVal));
            });
        });
        const isNearest = newCodes.find((result)=>result === true) ? true : false;
        setIsNearest(isNearest);
        setIsNearestValueUpdated(needAnalytics);
        callBack && callBack(isNearest);
    };
    const getZipCode = function(zipCodeVal) {
        let needAnalytics = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        setUserZipCode(zipCodeVal);
        checkUserZipCode(zipCodeVal, needAnalytics);
    };
    const fetchFromSku = ()=>{
        const fl = [
            "id",
            "slug_s",
            "productName_s",
            "masterSKU_s",
            "Product_Category",
            "ProductBrandName_s",
            "productImages.url_ss",
            "productImageVariantImages.url_ss",
            "SKUColorSwatchFilename_ss",
            "ProductDescriptionProductShort_s",
            "priceStartingAt.".concat(persona, "_d"),
            "discountedPriceStartingAt.".concat(persona, "_d"),
            "priceList.".concat(persona, ".saleOffer_s"),
            "Color.SKU.Details_ss",
            "ProductWebFeatures_ss",
            "ProductWebFeatures_s",
            "ProductExclusive_s",
            "ProductIsExclusive_s",
            "RegionReleaseforShipment_dt",
            "title_s",
            "ProductNarrativeDescription_s",
            "priceList.".concat(persona, ".finalPrice_d"),
            "CustomerFacingBrand_s",
            "RegionBrandName_s",
            "productImages.labelWithUrl_ss"
        ];
        constants_api/* apim.get */.TH.get("/search/plp", {
            params: {
                fl: fl.join(","),
                q: "*:*",
                fq: [
                    'variantList.sku_ss:("'.concat(state.productSkuId, '")'),
                    'language_s:("'.concat(info.language, '")')
                ],
                collections: info.lwAppName.toLowerCase(),
                profilename: "profile_".concat(info.lwAppName.toLowerCase(), "_General")
            },
            paramsSerializer: (params)=>{
                return lib_default().stringify(params, {
                    arrayFormat: "repeat",
                    encode: false
                });
            }
        }).then((res)=>{
            if (res && res.data) {
                const productData = get_default()(res.data, "response.docs[0]", {});
                setProductDetailData(productData);
            } else {
                console.error("Error occured while fetching product data");
            }
        });
    };
    const productCardProps = {};
    productCardProps.presetConfigs = presetConfigs !== null && presetConfigs !== void 0 ? presetConfigs : "";
    var _swatchUrl;
    productCardProps.swatchUrl = (_swatchUrl = state.swatchUrl) !== null && _swatchUrl !== void 0 ? _swatchUrl : "";
    if (productDetailData) {
        var ref;
        // get product images
        if (productDetailData["modifiedproductImageVariantImages.url_ss"]) {
            var ref1;
            const imageStrig = (ref1 = productDetailData["modifiedproductImageVariantImages.url_ss"]) === null || ref1 === void 0 ? void 0 : ref1.split("|");
            productCardProps.images = imageStrig.length ? imageStrig[imageStrig.length - 1] : "";
        } else if (productDetailData["productImages.url_ss"]) {
            var ref2;
            productCardProps.images = (ref2 = productDetailData["productImages.url_ss"][0]) !== null && ref2 !== void 0 ? ref2 : "";
        } else {
            productCardProps.images = image_missing/* default */.Z === null || image_missing/* default */.Z === void 0 ? void 0 : image_missing/* default.src */.Z.src;
        }
        // get product colors
        if (productDetailData["Color.SKU.Details_ss"]) {
            var ref3;
            const colors = (ref3 = productDetailData["Color.SKU.Details_ss"]) !== null && ref3 !== void 0 ? ref3 : [];
            productCardProps.colors = colors.filter((item)=>{
                const color = item.split("|");
                return color[4] === "false" || Date.parse(color[4]) > Date.now();
            });
        }
        // get product web features
        if (productDetailData["ProductWebFeatures_s"]) {
            var ref4;
            productCardProps.productFeatures = (ref4 = [
                productDetailData["ProductWebFeatures_s"]
            ]) !== null && ref4 !== void 0 ? ref4 : [];
        } else {
            var ref5;
            productCardProps.productFeatures = (ref5 = productDetailData["ProductWebFeatures_ss"]) !== null && ref5 !== void 0 ? ref5 : [];
        }
        productCardProps.currencySign = info.currencySign;
        productCardProps.productCategory = get_default()(productDetailData, "Product_Category", "");
        productCardProps.name = get_default()(productDetailData, "productName_s", "");
        productCardProps.brandName = get_default()(productDetailData, "RegionBrandName_s", "");
        productCardProps.description = get_default()(productDetailData, "title_s", "");
        productCardProps.narrativeDescription = get_default()(productDetailData, "ProductNarrativeDescription_s", "");
        productCardProps.price = get_default()(productDetailData, "priceStartingAt.".concat(persona, "_d"), 0);
        productCardProps.discountedPrice = get_default()(productDetailData, "discountedPriceStartingAt.".concat(persona, "_d"), 0);
        productCardProps.discountPercent = parseInt(get_default()(productDetailData, "priceList.".concat(persona, ".saleOffer_s"), 0));
        productCardProps.slug = get_default()(productDetailData, "slug_s", "");
        productCardProps.customerBrand = get_default()(productDetailData, "CustomerFacingBrand_s", "");
        let tempColorDetails = get_default()(productDetailData, "Color.SKU.Details_ss", null);
        if (tempColorDetails) {
            if (typeof tempColorDetails !== "string" && tempColorDetails[0]) {
                tempColorDetails = tempColorDetails[0];
            }
            productCardProps.customerFacingSKU = tempColorDetails.split("|")[5] || "";
        }
        productCardProps.badgeVal = get_default()(productDetailData, "priceList.".concat(persona, ".saleOffer_s"), "");
        productCardProps.globalDiscount = productCardProps.price - get_default()(productDetailData, "priceList.".concat(persona, ".finalPrice_d"), productCardProps.price);
        const productCategory = productCardProps === null || productCardProps === void 0 ? void 0 : (ref = productCardProps.productCategory) === null || ref === void 0 ? void 0 : ref.toLowerCase();
        productCardProps.priceType = "";
        if (productCategory === "field tiles" || productCategory === "slabs" || productCategory === "mosaics") {
            productCardProps.priceType = "/" + (staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.sfLabel);
        }
        if (productCategory === "trims & moldings") {
            productCardProps.priceType = "/" + (staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.lfLabel);
        }
        if (productCategory === "grout") {
            productCardProps.priceType = staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.boxLabel;
        }
    }
    const resetNearestValueUpdateFlag = ()=>{
        setIsNearestValueUpdated(false);
    };
    return state.skuType !== "productSku" && !isEmpty_default()(state.productSkuId) && !isEmpty_default()(productCardProps) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_ProductCardService, {
        ...productCardProps,
        imagePosition: state.imagePosition,
        newTab: state.newTab,
        staticTexts: staticTexts,
        currencySign: info.currencySign,
        userZipCode: userZipCode,
        isNearest: isNearest,
        skuId: state.productSkuId,
        getZipCode: getZipCode,
        resetNearestValueUpdateFlag: resetNearestValueUpdateFlag,
        isNearestValueUpdated: isNearestValueUpdated,
        cart: cart
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCard_view/* default */.Z, {
        ...productCardProps,
        product: productCardProps,
        i18n: staticTexts,
        currencySign: info.currencySign,
        presetConfigs: presetConfigs,
        title: productCardProps === null || productCardProps === void 0 ? void 0 : productCardProps.brandName,
        skuId: state.productSkuId
    });
};
/* harmony default export */ var v1_ProductCard = (ProductCard);

// EXTERNAL MODULE: ./components/productCard/v3/ProductCard.jsx
var v3_ProductCard = __webpack_require__(44685);
;// CONCATENATED MODULE: ./components/FindingModelNumber/v1/analyticsEventType.js
const getEventFor = (type)=>{
    var ref, ref1, ref2;
    if (type === null || type === void 0 ? void 0 : (ref = type.subCategory1) === null || ref === void 0 ? void 0 : ref.includes("support:contact")) {
        return "support:contact:form";
    }
    if (type === null || type === void 0 ? void 0 : (ref1 = type.subCategory1) === null || ref1 === void 0 ? void 0 : ref1.includes("support:find a service part")) {
        return "support:find-a-service-part";
    }
    if (type === null || type === void 0 ? void 0 : (ref2 = type.subCategory1) === null || ref2 === void 0 ? void 0 : ref2.includes("my account:product registration")) {
        return "my account:register offline kohler products:product information";
    }
    var ref3;
    return (ref3 = type === null || type === void 0 ? void 0 : type.subCategory1) !== null && ref3 !== void 0 ? ref3 : "";
};
const getAnalyticsEventInfo = ()=>{
    var ref;
    const type = window.adobeDataLayer.length ? window.adobeDataLayer[0]["page"]["category"] : {};
    const eventFor = getEventFor(type);
    const internalLinkType = (type === null || type === void 0 ? void 0 : (ref = type.subCategory1) === null || ref === void 0 ? void 0 : ref.includes("my account:product registration")) ? "my account:close" : "".concat(eventFor, ":close");
    return JSON.stringify({
        clickInternalLinks: "true",
        eventAction: "".concat(eventFor, ":modal:where do i find my product model number:close"),
        eventName: "".concat(eventFor, ":modal:where do i find my product model number:close"),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "close",
        internalLinkPosition: (type === null || type === void 0 ? void 0 : type.subCategoryID) || "contact us",
        internalLinkType,
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(eventFor, ":modal:where do i find my product model number")
    });
};
const productInfoNextEventInfo = ()=>{
    return '{"eventAction":"my account:register non kohler products:product information:next","eventName":"my account:register non kohler products:product information:next","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"next","internalLinkPosition":"register products","internalLinkType":"my account:navigation","internalLinkZoneName":"my account:register non kohler products:product information","internalLinkURL":"n/a","clickInternalLinks":"true"}';
};


;// CONCATENATED MODULE: ./components/FindingModelNumber/v1/FindingModelNumber.jsx











const FindingModelNumber = (param)=>{
    let { authorData ={}  } = param;
    var ref;
    const dispatch = (0,es/* useDispatch */.I0)();
    const { FindingModelModal: { show: isShowModelNumberModal  } = {}  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const [findingModelData, setFindingModelData] = (0,react.useState)({});
    (0,react.useEffect)(()=>{
        document.querySelectorAll('a[href="#FindingModelNumber"]').forEach((el)=>{
            el.addEventListener("click", showFindingModelPopupHandler);
        });
        findModelNumber();
        return ()=>{
            document.querySelectorAll('a[href="#FindingModelNumber"]').forEach((el)=>{
                el.removeEventListener("click", showFindingModelPopupHandler);
            });
        };
    }, []);
    const showFindingModelPopupHandler = (e)=>{
        e.preventDefault();
        dispatch((0,genericSlice/* showFindingModelPopup */.RS)());
    };
    const findModelNumber = ()=>{
        if (!isEmpty_default()(authorData.findModelNumber)) {
            (0,constants_api/* aemAxiosInstance */.Gb)({
                url: constants.GLOBAL_CONFIGURATION_ENDPOINT,
                params: {
                    path: authorData.findModelNumber
                }
            }).then((response)=>{
                if (response && response.data) {
                    var _data;
                    setFindingModelData((_data = response.data) !== null && _data !== void 0 ? _data : {});
                } else {
                    console.error("Finding a model number: Error occured while fetching data from Get URL Property");
                }
            }).catch((err)=>console.error(err));
        }
    };
    const compareWidth = (a, b)=>{
        if (Number(a.width) > Number(b.width)) return -1;
        if (Number(a.width) < Number(b.width)) return 1;
        return 0;
    };
    var ref1, ref2, ref3;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "finding-model-number",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal["default"], {
            StickCloseButton: true,
            closeButtonAnalytics: getAnalyticsEventInfo(),
            needAnalyticsOnContentsLink: true,
            onModalClose: ()=>dispatch((0,genericSlice/* hideFindingModelPopup */._W)()),
            showModal: isShowModelNumberModal,
            children: !isEmpty_default()(findingModelData) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "title",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                            children: !isEmpty_default()(findingModelData === null || findingModelData === void 0 ? void 0 : findingModelData.title) ? (0,helper/* sanitizeText */.oOy)(findingModelData === null || findingModelData === void 0 ? void 0 : findingModelData.title) : ""
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "image-explanation",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: (findingModelData === null || findingModelData === void 0 ? void 0 : findingModelData.assetPath) ? findingModelData === null || findingModelData === void 0 ? void 0 : findingModelData.assetPath : findingModelData === null || findingModelData === void 0 ? void 0 : (ref = findingModelData.smartcrop) === null || ref === void 0 ? void 0 : ref.sort(compareWidth),
                            width: "80%",
                            alt: ""
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "finding-model-number__content ".concat((findingModelData === null || findingModelData === void 0 ? void 0 : findingModelData.style) === "des-bg-off-white" ? "finding-model-number__content-bg" : ""),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "description",
                                children: (0,helper/* sanitizeInnerHtml */.KD0)((ref1 = findingModelData === null || findingModelData === void 0 ? void 0 : findingModelData.description) !== null && ref1 !== void 0 ? ref1 : "")
                            }),
                            (findingModelData === null || findingModelData === void 0 ? void 0 : findingModelData.ctaLinkText) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "signUp-text",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                    className: "gbh-data-layer",
                                    "data-gbh-data-layer": productInfoNextEventInfo(),
                                    type: "black",
                                    label: (ref2 = findingModelData === null || findingModelData === void 0 ? void 0 : findingModelData.ctaLinkText) !== null && ref2 !== void 0 ? ref2 : "",
                                    to: (ref3 = findingModelData === null || findingModelData === void 0 ? void 0 : findingModelData.ctaLink) !== null && ref3 !== void 0 ? ref3 : "",
                                    target: (findingModelData === null || findingModelData === void 0 ? void 0 : findingModelData.newTabLink) === "true" ? "_blank" : "_self"
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var v1_FindingModelNumber = (FindingModelNumber);

;// CONCATENATED MODULE: ./components/InPageSearch/v1/analytics.js
const analytics_getEventInfo = function() {
    let linkUrl = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", status = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", type = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", searchString = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "";
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const title = page.category.subCategoryID.replaceAll(" ", "-");
    const findAServicePart = title === "find-a-service-part";
    const eventAction = (findAServicePart ? "".concat(page.category.pageType, ":").concat(title, ":") : "support".concat(type, ":")) + "main content area:search";
    const internalLinkPosition = findAServicePart ? "".concat(page.category.pageType, ":").concat(title) : "support".concat(type);
    const internalLinkType = (findAServicePart ? "".concat(page.category.pageType, ":").concat(title, ":") : "support".concat(type, ":")) + "".concat(searchString);
    const internalLinkZoneName = (findAServicePart ? "".concat(page.category.pageType, ":").concat(title, ":") : "support".concat(type, ":")) + "main content area";
    return JSON.stringify({
        clickInternalLinks: "true",
        eventAction,
        eventName: eventAction,
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: status || "n/a",
        internalLinkName: "search",
        internalLinkPosition,
        internalLinkType,
        internalLinkURL: linkUrl || "n/a",
        internalLinkZoneName,
        searchTerm: searchString
    });
};

// EXTERNAL MODULE: ./components/PartsViewer/v1/PartsViewer.jsx
var PartsViewer = __webpack_require__(17169);
// EXTERNAL MODULE: ./components/PartsViewer/v2/PartsViewer.jsx + 179 modules
var v2_PartsViewer = __webpack_require__(83227);
// EXTERNAL MODULE: ./components/InPageSearch/v1/index.module.scss
var InPageSearch_v1_index_module = __webpack_require__(2145);
var InPageSearch_v1_index_module_default = /*#__PURE__*/__webpack_require__.n(InPageSearch_v1_index_module);
// EXTERNAL MODULE: ./node_modules/react-collapsible/dist/index.js
var dist = __webpack_require__(97893);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
;// CONCATENATED MODULE: ./components/VisualSearch/localization.js
const localization_getTranslations = (t)=>{
    return {
        recognitionCategory: (category)=>t("kf.visualsearch.label.recognitionCategory", {
                category
            }),
        recognitionCategorySubText: (category)=>t("kf.visualsearch.label.recognitionCategorySubText", {
                category
            }),
        faucetGuide: t("kf.visualsearch.label.faucetGuide"),
        toiletGuide: t("kf.visualsearch.label.toiletGuide"),
        volveGuide: t("kf.visualsearch.label.volveGuide"),
        defaultGuide: t("kf.visualsearch.label.defaultGuide"),
        commingSoon: t("kf.visualsearch.label.commingSoon"),
        viewGuidtext: t("kf.visualsearch.button.viewGuid"),
        backOnCategory: t("kf.visualsearch.button.backOnCategory"),
        errorText: t("kf.visualsearch.ErrorPage.errorText"),
        errorSubText: t("kf.visualsearch.ErrorPage.errorSubText"),
        tryAgainBtn: t("kf.visualsearch.ErrorPage.button.tryAgainBtn"),
        QRCodeText: t("kf.visualsearch.QRCode.text"),
        textCommingSoon: t("kf.visualsearch.label.textCommingSoon"),
        imageUploadtext: t("kf.visualsearch.ImageUpload.text"),
        borwseBtn: t("kf.visualsearch.ImageUpload.button.borwse"),
        changeProduct: t("kf.visualsearch.ImageUpload.text.changeProduct"),
        imageUploadSubText: t("kf.visualsearch.ImageUpload.subText"),
        photoGuidelineText: t("kf.visualsearch.ImageUpload.photoGuidelineText"),
        photoText: t("kf.visualsearch.ImageUpload.photoText"),
        wrongAngle: t("kf.visualsearch.ImageUpload.wrongAngle"),
        toClose: t("kf.visualsearch.ImageUpload.toClose"),
        toFar: t("kf.visualsearch.ImageUpload.toFar")
    };
};

;// CONCATENATED MODULE: ./components/VisualSearch/v1/SelectProductCategory/Image/faucets.png
/* harmony default export */ var faucets = ({"src":"/_next/static/media/faucets.ad3d08d9.png","height":275,"width":207,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAMAAADtGH4KAAAAD1BMVEX6+vrn6OnU1NXw8PDg4OLBIzzxAAAAAXRSTlP+GuMHfQAAAAlwSFlzAAALEwAACxMBAJqcGAAAAChJREFUCJk1ysENADAMwkAD2X/mllT9+CQEIEGrAZy4zMPpOPv4KLcHBmsAODJs0ncAAAAASUVORK5CYII=","blurWidth":6,"blurHeight":8});
;// CONCATENATED MODULE: ./components/VisualSearch/v1/SelectProductCategory/Image/toilet.png
/* harmony default export */ var toilet = ({"src":"/_next/static/media/toilet.ef95f71a.png","height":275,"width":207,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAMAAADtGH4KAAAADFBMVEX39/fV1dbr6+vl5eXxU0fQAAAAAXRSTlP+GuMHfQAAAAlwSFlzAAALEwAACxMBAJqcGAAAAB9JREFUCJljYIACJgjFDKUgNBMjI1ickRHMhVJMQEkAAq0AGyEyJQ0AAAAASUVORK5CYII=","blurWidth":6,"blurHeight":8});
;// CONCATENATED MODULE: ./components/VisualSearch/v1/SelectProductCategory/Image/valve.png
/* harmony default export */ var valve = ({"src":"/_next/static/media/valve.81b08023.png","height":275,"width":207,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAMAAADtGH4KAAAAJFBMVEX4+Pi9q5TQxLKukWf5+Pj6+vv+///r5dzX0MaTeVOzm3nl2caQbtQCAAAABHRSTlP8/v7+EEOCdwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAC5JREFUCJkdikkOADEMwtwpJF3+/9+KQbLsA6AMlIDqWwK+08Y99yrw+JVXsKUHFTUAxASKNxQAAAAASUVORK5CYII=","blurWidth":6,"blurHeight":8});
;// CONCATENATED MODULE: ./components/VisualSearch/v1/SelectProductCategory/Image/shower.png
/* harmony default export */ var shower = ({"src":"/_next/static/media/shower.c88ccfe8.png","height":275,"width":207,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAMAAADtGH4KAAAAHlBMVEX5+fn8/Pzp6evx8fJcWl98en/S0dRva2+gn6OioKS29MYpAAAABXRSTlP//v7+/gHW7VsAAAAJcEhZcwAACxMAAAsTAQCanBgAAAAqSURBVAiZVYk3AgAgEINI4ln+/2HLJgMMwId7EAQ7oF5VRrON9W50o+MNB9wAVHjx1IgAAAAASUVORK5CYII=","blurWidth":6,"blurHeight":8});
;// CONCATENATED MODULE: ./components/VisualSearch/v1/SelectProductCategory/Image/bath.png
/* harmony default export */ var bath = ({"src":"/_next/static/media/bath.96b055e3.png","height":275,"width":207,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAMAAADtGH4KAAAAD1BMVEX29vb6+vrT09Ts7Ozd3N7vGlqrAAAAAXRSTlP9g+pWxwAAAAlwSFlzAAALEwAACxMBAJqcGAAAACZJREFUCJkdirENAAAIgyj1/5uNssAA5AAuYCyhoxZ8peoNtPkvWQdUAEWoLD50AAAAAElFTkSuQmCC","blurWidth":6,"blurHeight":8});
;// CONCATENATED MODULE: ./components/VisualSearch/v1/SelectProductCategory/Image/sink.png
/* harmony default export */ var sink = ({"src":"/_next/static/media/sink.8226f798.png","height":275,"width":207,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAMAAADtGH4KAAAADFBMVEX5+fnv7u/a2dvl5eZ3e/xoAAAAAnRSTlP//r+y71EAAAAJcEhZcwAACxMAAAsTAQCanBgAAAAiSURBVAiZY2BAB4wgzMjMzMzIwMjExMTEyMDAyMQMEkUGAANEAB+nJ8u/AAAAAElFTkSuQmCC","blurWidth":6,"blurHeight":8});
;// CONCATENATED MODULE: ./components/VisualSearch/v1/SelectProductCategory/Image/toilet_seat.png
/* harmony default export */ var toilet_seat = ({"src":"/_next/static/media/toilet_seat.83d28ff4.png","height":275,"width":207,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAMAAADtGH4KAAAADFBMVEX5+fny8/Pq6uvb3N53l0vqAAAAAXRSTlP+GuMHfQAAAAlwSFlzAAALEwAACxMBAJqcGAAAAB5JREFUCJljYEADjEyMIIqJGUQxMjMzQUgmhBQYAAADVwAjo2/QnwAAAABJRU5ErkJggg==","blurWidth":6,"blurHeight":8});
;// CONCATENATED MODULE: ./components/VisualSearch/v1/SelectProductCategory/Image/shower_door.png
/* harmony default export */ var shower_door = ({"src":"/_next/static/media/shower_door.cc5a0390.png","height":275,"width":207,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAMAAADtGH4KAAAADFBMVEXs7Ov19PPc3t3k5uWZJUTxAAAAAnRSTlP+/qap3hAAAAAJcEhZcwAACxMAAAsTAQCanBgAAAAkSURBVAiZNcfBDQAACMLASvff2RDjfQpMyQgIgTSazvpnxHAWB9gARmKApS8AAAAASUVORK5CYII=","blurWidth":6,"blurHeight":8});
;// CONCATENATED MODULE: ./components/VisualSearch/v1/SelectProductCategory/constant.js








const imageInformation = [
    {
        imageUrl: faucets,
        imageName: "Faucet"
    },
    {
        imageUrl: toilet,
        imageName: "Toilet"
    },
    {
        imageUrl: valve,
        imageName: "Valve"
    },
    {
        imageUrl: shower,
        imageName: "Shower"
    },
    {
        imageUrl: toilet_seat,
        imageName: "Toilet Seat",
        comingSoon: true
    },
    {
        imageUrl: shower_door,
        imageName: "Shower Door",
        comingSoon: true
    },
    {
        imageUrl: sink,
        imageName: "Sink",
        comingSoon: true
    },
    {
        imageUrl: bath,
        imageName: "Bath",
        comingSoon: true
    }
];
const scrollOptions = {
    className: "os-theme-dark cmp-carousel__whole",
    style: "height:auto",
    scrollbars: {
        visibility: "auto",
        autoHide: "never"
    }
};

;// CONCATENATED MODULE: ./components/VisualSearch/analytics/index.js

const addDataLayerVisualSearch = (analytics)=>{
    var ref;
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page");
    if (page) {
        const { user , category , pageInfo  } = page;
        delete user["encodedEmailId"];
        delete user["profileType"];
        delete page["pageName"];
        delete page["pageUrl"];
        delete pageInfo["thumbnailImageUrl"];
        pageInfo["defaultImage"] = "n/a";
        pageInfo["imageId"] = "n/a";
        pageInfo["resourceType"] = "n/a";
        pageInfo["referrer"] = document.referrer;
        category["subCategory1"] = "".concat(category["pageType"], ":").concat(category["productLocalCategory"]);
    }
    const { eventKey , category: category1 , internalLinkZoneName =false , eventStatus , linkUrl , eventMsg , product  } = analytics;
    const links = linkUrl !== null && linkUrl !== void 0 ? linkUrl : window.location.href;
    const productRoom = page === null || page === void 0 ? void 0 : (ref = page.category) === null || ref === void 0 ? void 0 : ref.room;
    const evtAction = internalLinkZoneName ? "".concat(eventKey, ":").concat(category1) : eventKey;
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "support:find a service part:kohler genuine service parts:".concat(evtAction),
        eventMsg: eventMsg ? (0,helper/* sanitizeTextForAnalytics */.T68)(eventMsg) : "n/a",
        eventName: "support:find a service part:kohler genuine service parts:".concat(evtAction),
        eventStatus: eventStatus !== null && eventStatus !== void 0 ? eventStatus : "n/a",
        eventType: "navigation",
        internalLinkName: internalLinkZoneName ? category1 : eventKey,
        internalLinkPosition: "support:find a service part".concat(category1 ? ":".concat(category1) : ""),
        internalLinkType: "support:find a service part:kohler genuine service parts",
        internalLinkURL: links,
        internalLinkZoneName: "support:find a service part:kohler genuine service parts".concat(internalLinkZoneName || eventStatus ? ":".concat(eventKey) : "")
    };
    const productInfo = product ? getAnalyticProductInfo(product, category1, productRoom) : null;
    window.adobeDataLayer.push({
        event: "cmp:click",
        page,
        eventInfo,
        ...productInfo != null && {
            productInfo
        }
    });
};
const getAnalyticProductInfo = (products, category, productRoom)=>{
    const productInfo = {
        category: category,
        defaultImageName: products === null || products === void 0 ? void 0 : products.isoImageURL,
        description: (0,helper/* sanitizeTextForAnalytics */.T68)(products === null || products === void 0 ? void 0 : products.shortDescription),
        frequency: "n/a",
        globalDiscount: "n/a",
        globalOffer: "n/a",
        globalPromotionPrice: "n/a",
        isRecommended: "n/a",
        isSendNow: "n/a",
        isSubscription: "n/a",
        itemType: (0,helper/* sanitizeTextForAnalytics */.T68)(category),
        numberOfReviews: "n/a",
        pdpType: "regular finished goods",
        priceState: "regular price",
        productBasePrice: "n/a",
        productBrand: "kohler",
        productCategory: (0,helper/* sanitizeTextForAnalytics */.T68)(category),
        productCollectionsName: products === null || products === void 0 ? void 0 : products.name,
        productColor: "n/a",
        productCouponCode: "n/a",
        productCoupondiscount: "n/a",
        productFindingMethod: "n/a",
        productID: products === null || products === void 0 ? void 0 : products.sku,
        productName: (0,helper/* sanitizeTextForAnalytics */.T68)(products === null || products === void 0 ? void 0 : products.name),
        productPartnerBuyNow: "n/a",
        productRoom: productRoom,
        productSalePrice: "n/a",
        productSaleable: "n/a",
        productStatus: "n/a",
        productSuperSku: "n/a",
        productTileName: (0,helper/* sanitizeTextForAnalytics */.T68)(products === null || products === void 0 ? void 0 : products.shortDescription),
        quantity: "n/a",
        ratings: "n/a",
        waterSenseProduct: false
    };
    return productInfo;
};

;// CONCATENATED MODULE: ./components/VisualSearch/v1/SelectProductCategory/SelectProductCategory.view.jsx








const SelectProductCategoryView = (props)=>{
    const { updateCategoryItems , setOpenCam  } = props;
    const scrollerRef = (0,react.useRef)();
    const { t  } = (0,esm/* useTranslation */.$G)();
    const { textCommingSoon  } = localization_getTranslations(t);
    (0,react.useEffect)(()=>{
        let timeId;
        if (scrollerRef.current) {
            timeId = setTimeout(()=>{
                document.querySelectorAll(".carousel-bottom-scroll").forEach((scrollDiv)=>{
                    let heightToSet = 0;
                    scrollDiv === null || scrollDiv === void 0 ? void 0 : scrollDiv.querySelectorAll(".cmp-carousel__content").forEach((scrollDivContent)=>{
                        if (scrollDivContent && heightToSet < (scrollDivContent === null || scrollDivContent === void 0 ? void 0 : scrollDivContent.offsetHeight)) {
                            heightToSet = scrollDivContent === null || scrollDivContent === void 0 ? void 0 : scrollDivContent.offsetHeight;
                        }
                    });
                    scrollDiv === null || scrollDiv === void 0 ? void 0 : scrollDiv.querySelectorAll(".os-content-glue").forEach((scrollDivglu)=>{
                        if (scrollDivglu && heightToSet > 0) {
                            scrollDivglu.style.height = heightToSet + "px";
                        }
                    });
                });
            }, 2000);
        }
        return ()=>clearTimeout(timeId);
    }, [
        scrollerRef.current
    ]);
    const handleCategorySelection = (e, category, item)=>{
        const categorySelected = category.toLowerCase();
        setOpenCam(true);
        const input = [
            {
                category: categorySelected,
                comingSoon: item === null || item === void 0 ? void 0 : item.comingSoon
            }
        ];
        addDataLayerVisualSearch({
            eventKey: "select you product",
            category: categorySelected,
            internalLinkZoneName: true
        });
        updateCategoryItems(input);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "carousel carousel-btm-scroll-title-small product-category",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "cmp-carousel slide-scrollbar",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "cmp-carousel-text",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "cmp-carousel__pretitle",
                        role: "heading",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            children: "Select Your Product"
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(utils/* ConditionalWrapper */.M2, {
                    condition: true,
                    wrapper: (children)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(OverlayScrollbarsComponent, {
                            options: scrollOptions,
                            ref: scrollerRef,
                            defer: true,
                            children: children
                        }),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "cmp-carousel__content",
                        children: [
                            imageInformation ? imageInformation.map((item, i)=>{
                                var ref;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "cmp-carousel__item cmp-carousel__item--active",
                                    role: "tabpanel",
                                    "aria-label": "Slide ".concat(i + 1, " of ").concat(imageInformation === null || imageInformation === void 0 ? void 0 : imageInformation.length),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "image-list d-flex flex-column h-100",
                                        onClick: (e)=>{
                                            handleCategorySelection(e, item === null || item === void 0 ? void 0 : item.imageName, item);
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "image-with-text position-relative d-inline-block",
                                            children: (item === null || item === void 0 ? void 0 : item.imageUrl) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "image-part",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            className: "pia-img",
                                                            src: item === null || item === void 0 ? void 0 : (ref = item.imageUrl) === null || ref === void 0 ? void 0 : ref.src,
                                                            alt: item === null || item === void 0 ? void 0 : item.imageName,
                                                            title: item === null || item === void 0 ? void 0 : item.imageName
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "text-label",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                fontSize: 26,
                                                                className: "image-text",
                                                                children: item === null || item === void 0 ? void 0 : item.imageName
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "comingSoon",
                                                                children: (item === null || item === void 0 ? void 0 : item.comingSoon) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                    fontSize: 16,
                                                                    className: "coming-soon section-Line",
                                                                    children: (item === null || item === void 0 ? void 0 : item.comingSoon) ? textCommingSoon === null || textCommingSoon === void 0 ? void 0 : textCommingSoon.toUpperCase() : null
                                                                }) : null
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }) : null
                                        })
                                    }, i)
                                }, "carousel-".concat(i));
                            }) : null,
                            Array.from({
                                length: 2
                            }, (val, index)=>index + 1).map((val)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "cmp-carousel__item"
                                }, val))
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var SelectProductCategory_view = (SelectProductCategoryView);

// EXTERNAL MODULE: ./node_modules/react-qr-code/lib/index.js
var react_qr_code_lib = __webpack_require__(1653);
// EXTERNAL MODULE: ./components/VisualSearch/v1/QRCode/index.module.scss
var QRCode_index_module = __webpack_require__(9527);
var QRCode_index_module_default = /*#__PURE__*/__webpack_require__.n(QRCode_index_module);
;// CONCATENATED MODULE: ./components/VisualSearch/v1/QRCode/index.jsx






const QRCode = ()=>{
    const baseUrl = window.location.href;
    const currentUrl = "".concat(baseUrl, "#search");
    const { t  } = (0,esm/* useTranslation */.$G)();
    const { QRCodeText  } = localization_getTranslations(t);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((QRCode_index_module_default()).QRCodeWrapper),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "qr-section",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "photo_label",
                    children: QRCodeText
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "qr-part",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_qr_code_lib/* QRCode */.s_, {
                        size: 82.93,
                        value: currentUrl
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var v1_QRCode = (QRCode);

// EXTERNAL MODULE: ./components/VisualSearch/v1/SelectProductCategory/index.module.scss
var SelectProductCategory_index_module = __webpack_require__(71964);
var SelectProductCategory_index_module_default = /*#__PURE__*/__webpack_require__.n(SelectProductCategory_index_module);
// EXTERNAL MODULE: ./hooks/useViewport.js
var useViewport = __webpack_require__(78770);
;// CONCATENATED MODULE: ./components/VisualSearch/v1/SelectProductCategory/index.jsx





const SelectProductCategory = (props)=>{
    const { updateCategoryItems , setOpenCam  } = props;
    const device = (0,useViewport/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((SelectProductCategory_index_module_default()).SelectProductCategoryWrapper),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "inpage-search_category inpage-list-category",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectProductCategory_view, {
                    updateCategoryItems: updateCategoryItems,
                    setOpenCam: setOpenCam
                }),
                !(device === null || device === void 0 ? void 0 : device.isSmallScreen) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_QRCode, {}) : null
            ]
        })
    });
};
/* harmony default export */ var v1_SelectProductCategory = (SelectProductCategory);

// EXTERNAL MODULE: ./components/VisualSearch/v1/UploadImage/uploadImage.module.scss
var uploadImage_module = __webpack_require__(948);
var uploadImage_module_default = /*#__PURE__*/__webpack_require__.n(uploadImage_module);
// EXTERNAL MODULE: ./node_modules/react-dropzone/dist/es/index.js + 5 modules
var dist_es = __webpack_require__(68901);
;// CONCATENATED MODULE: ./public/images/parts/faucets/faucets_main.png
/* harmony default export */ var faucets_main = ({"src":"/_next/static/media/faucets_main.a2906f5f.png","height":572,"width":474,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAMAAAAC2hU0AAAAPFBMVEWDgHt4dnG+u72moZ2cloyjnpbS0dealpOSj4nLytJ1eWOvpZuagWfEwsiaj4VQUyxqamq7sq5ZWDNYYkBGdm5iAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAOklEQVQImR3FURKAIAhAwYeCIJpa3f+uzbQ/izsghzRDBNKqhw5erWpu7PDQOXlW+D0Ke5Wr90b+tQ8srgGfZZbsTwAAAABJRU5ErkJggg==","blurWidth":7,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/parts/faucets/wrong1.png
/* harmony default export */ var wrong1 = ({"src":"/_next/static/media/wrong1.3a6dc656.png","height":158,"width":158,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAARVBMVEWLdmK3qJ/88+5nTTeTfWrj2NDOwLb16+XRxb3BsqaomIprUTvt4djbz8S0ppe5q6CekoWGblvq2tDFubGiinVZPyptVT25oQAFAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAQElEQVQImSXBxwHAMAgEsLMBA+4t2X/UPCIBv4VS6C1ED+7NzLwYO/sJOTmijTlDqmjd+/BgOBJNdCeYRFWt7QNK2AIuzqUpAgAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/parts/faucets/wrong2.png
/* harmony default export */ var wrong2 = ({"src":"/_next/static/media/wrong2.21d3c32c.png","height":158,"width":158,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAOVBMVEWzqKK3r6vRycWak5A+PT2nm5W/ta/Kw78oKCiNhYLWzso0MzJHRkXGvrp1cG3l3NlCQUBkXVqBeXWix00nAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAO0lEQVQImR3GRxKAMAwAsY3jmgb8/7MM6CR8jFYF2F63XNLoMbNbhxLNsyZUaIa4/2nD4XzZGA+aBPYCOtYBj4Ed3WYAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/parts/faucets/wrong3.png
/* harmony default export */ var wrong3 = ({"src":"/_next/static/media/wrong3.1ad2290c.png","height":158,"width":158,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAPFBMVEUaGhoqKSsMDAzQy80iISEUFBTZxbrFrKC6ope0nJHOtam7ur2IdnOenJ40NDbPt62MjpGhjISen6Our7J4gm31AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAOklEQVQImR3GSRLAIAwDMANZHPa2//9rB3QS4iCJoF8g/enVK8wsui1iv19rpQzkrIo0Ew5VkRtA5AdJMAGqrUbp6QAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/parts/faucets/wrong1_mob.png
/* harmony default export */ var wrong1_mob = ({"src":"/_next/static/media/wrong1_mob.707bfc9a.png","height":189,"width":189,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAARVBMVEWrm42kk4SGbVeGe3CxoZXczsWMdF++r6JvVkDPwrrx5t7n29LHvbf37edyW0RlTTd7Y03UzMeTeGKRiYDVyb/Iu63+9/PszyTFAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAP0lEQVQImQXBBwLAIAgAsXMg4Lbr/09tgpnNuWxRrhJ3jBuC56QlIKk7/RaGa0iqD0qGTOZttXttgozvnFHbD0g2AhpZpp/zAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/parts/faucets/wrong2_mob.png
/* harmony default export */ var wrong2_mob = ({"src":"/_next/static/media/wrong2_mob.3729874a.png","height":189,"width":189,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAQlBMVEWwpaFaUk6/tbCilI6ZjIU9PDzNxMCpmpS3r6zIv7y2q6apn5uPhYHo4t9tZmJ6dnPBuLR4cG3d1M/YzMZ+e3pLQj6EGsjDAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAQElEQVQImRXLRxLAMAgEsAWDAVec8v+vZqK7kJFRHQVdqne4QSh1RzMcYqU1gEGuz8UGeaGnmqAs0X03huHfc35HPQH7oVVplAAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/parts/faucets/wrong3_mob.png
/* harmony default export */ var wrong3_mob = ({"src":"/_next/static/media/wrong3_mob.c61165b4.png","height":189,"width":189,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAOVBMVEUZGBg0NjirlIvGtbHKsaayl4wjJCS8o5iafnAREBB8b2vXx8K1qKaLfHp+cW1ERkhXVllWWFqihnmHPXtoAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAOUlEQVQImTXGWw6AMAzEQCdsGlIehftfFrUSI38Y35ckIicRKQ9J+HacM5rZeB+7oKqK6iyN+5/+AThJAWjM6CPhAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/parts/faucets/faucets_image_tab.png
/* harmony default export */ var faucets_image_tab = ({"src":"/_next/static/media/faucets_image_tab.e964b3f3.png","height":377,"width":446,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAMAAAACh/xsAAAAQlBMVEWemZSHg36jn51oZUc9RydwbmuSjobPztXHxcminJibhW6zq6WZlY95emt+gmuqpaBsbFGlkX6pmYq5uLxeZUS5s7XvyHQUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAOUlEQVQImQXBBwLAIAgAsRMRwd31/682YVmkWUrhrB2WDPLcMKSjrzCi3WgmcbWO5pDHvaLnc/dafzVCAbopn1HkAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":7});
;// CONCATENATED MODULE: ./public/images/parts/faucets/faucet_mask_group.png
/* harmony default export */ var faucet_mask_group = ({"src":"/_next/static/media/faucet_mask_group.f66d782b.png","height":612,"width":612,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAARVBMVEWmoZ3PztXBvsK3s7KinZmppaJCTCibmJOIhX7Ix86FhHBpbFO1p5ymmo94dXBramiPfWKlkXqSjINvdlmAdltJUS+FgXfQ/Ty1AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAPklEQVQImRXFxxHAIBAAsQUukQxO/bfqsT6iucRxrEUP8IiL3hTBlfcGRybWxX2eG9saWsbAnlJyrQlr+T99SoEB7zr7SgQAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/parts/toilet/toilet_main.png
/* harmony default export */ var toilet_main = ({"src":"/_next/static/media/toilet_main.dbe17daa.png","height":572,"width":474,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAMAAAAC2hU0AAAANlBMVEXOy8lsY1qsqaRRQzJ1al/HxcNIOipgUUB4cGfBvrm1s7GKhICgmpNfVkxXSjrPycF8c2qNi4rPXFcRAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAOElEQVQImSXFxwHAIAwAsTO4YkjZf9k8oo+4co/iZupYhjJzFBb/Ffhjxg68Wa8GfrpFFI+UE/IBLCgBZatowGIAAAAASUVORK5CYII=","blurWidth":7,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/parts/toilet/toilet_wrong1.png
/* harmony default export */ var toilet_wrong1 = ({"src":"/_next/static/media/toilet_wrong1.2b736f62.png","height":158,"width":158,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAUVBMVEWMhny9s6JVUEuipKZ+d2lMRjxvaWLi18FjYFvNw7I/OjPRyr/Vz8e5s6q1r6eEfnSwqp+Yk4ugmo98b1utpJSXl5jq3spbWFK0sbCjnpE1MSw1p8+DAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAQklEQVQImQXBhwGAMAwDMHcm6d4F/j8UCeZJKcYBbJScSwU299Y6V5jr18vawugr4p0FwjhHBQv9KSJxEz4sIuXmD2cLArILr5VoAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/parts/toilet/toilet_wrong2.png
/* harmony default export */ var toilet_wrong2 = ({"src":"/_next/static/media/toilet_wrong2.5f82926c.png","height":158,"width":158,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAPFBMVEU2KBuxoYuaindIOSy2p5CtnIddTTq9rpVyYkylk3zDtqBVRjWPf2yIeGb56tqBcl4iFw3t3s7bzb1rWEFBUgGeAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAP0lEQVQImR3GRw7AIAwEwMW420DK//8aKXMauL9apYrmoBA78F4hbI55OoaZA2sE/5kkmWMCUOJkAXDVc+/9AUTPAdc7dNsnAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/parts/toilet/toilet_wrong3.png
/* harmony default export */ var toilet_wrong3 = ({"src":"/_next/static/media/toilet_wrong3.d1010512.png","height":189,"width":188,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAUVBMVEVTRDNpYVeQgXGroJZkV0VKOiteUUFuYE9YSzqCcGLV0s05KBsjFgqFfnagkYG/t6qGeGS2s63Jwbk1KRt0XUt+aFaTjomalI2TkHezmoCBaE5lTDSwAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAQ0lEQVQImR3GSRLAIAgEwEFFwF2z5/8PTVX61JCAOO6VIEGj639Acz4eUdnS9TYocFYZHroVIrgOLtlXSEPm3dlh9gFWQAJhdzKsAgAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/parts/toilet/toilet-wrong-mob1.png
/* harmony default export */ var toilet_wrong_mob1 = ({"src":"/_next/static/media/toilet-wrong-mob1.6de26823.png","height":189,"width":188,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAPFBMVEWvqZ/l2820raOjnpOwsLOppJtVUk7Ewb7Dv7bAvLNJRkF6eHOPioLg18heW1WMiH9mY1zAuKplZWKWkIUbwLE+AAAACnRSTlP+////8///8/Pzq9eSRAAAAAlwSFlzAAALEwAACxMBAJqcGAAAAD5JREFUCJkVxlkSgCAMBcEJ8YVdQO9/V8v+aq6cS60FkpnZnInuksTiGQLUiS4S4ybu5f7uINo+x9sfbNpoHzntAcm4/zXjAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/parts/toilet/toilet-wrong-mob2.png
/* harmony default export */ var toilet_wrong_mob2 = ({"src":"/_next/static/media/toilet-wrong-mob2.be9d09ef.png","height":189,"width":188,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAALVBMVEWkk3ypmISZiXJKOy2fj3uSgmxvYVGunYpBMCK3ppN+bVlZSjyEdGPbzLfIuqMn4HcRAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAOUlEQVQImSXGtwHAMAwEseMzKXr/cVUYFaiVkgTr3m8asNukVOD7VGWA7ypPDB9nxp81m2jG8DCzfjAAAUmmuQWJAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/parts/toilet/toilet_Ideal_Tab.png
/* harmony default export */ var toilet_Ideal_Tab = ({"src":"/_next/static/media/toilet_Ideal_Tab.cc9ead07.png","height":612,"width":612,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAS1BMVEVWSDnT0M2rpZ9xZFa6t7OUj4tGOSlQQzLLycZfUUJ9c2jCwL5mWkyShnmmjHBnYVt1bGKFfXKJhYGmn5UrHhOvraqhnJnPuaR/Z0+F6aI7AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAQElEQVQImRXGRxKAMAwAsU21nU7n/y9l0Elg2xHVPcB+VdcHkKK6MJA/Gl5EvFZvhSx3TLN1srQybXnOHNIyKx9KRwIlU9aJRQAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/parts/valve/valve_main.png
/* harmony default export */ var valve_main = ({"src":"/_next/static/media/valve_main.bd08bb89.png","height":572,"width":474,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAMAAAAC2hU0AAAASFBMVEXRxsDX1NSCgH5waWGroJaPhXvEubHUy8fHvbh5c2xMR0K8sKiJiYiBeHDOwbRlX1uCcGBkY19DOC/b085VVVOYkYgeGha0qqGj6ewyAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAOUlEQVQImQXBhwGAIBAAsQO+Uuy6/6gmlHKDQwnNOhxfddY0JOfTTkWO/bt6w1R7W4KPt6ds4GGB/TN3AbZR7sv+AAAAAElFTkSuQmCC","blurWidth":7,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/parts/valve/valve_wrong1.png
/* harmony default export */ var valve_wrong1 = ({"src":"/_next/static/media/valve_wrong1.d97d1d32.png","height":188,"width":188,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAV1BMVEVxaWG/sqtHRUB/eXSdk4rEvbleVkzn1s3h0ciHgn25sq15c2xnYltSSUCVh3rZyb+/rp7VwraMeWuEc2etpJ2rpJ43MClBFg7KuKuMak5iRTiljnRiLiNwruYiAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAQklEQVQImQXBBwLAIAgEsBNRwG33+v87m0B6sswqEBe4YFNo2LmtFqDWkBckXKBYAI/xnBRj9Xjvj45qijFnd07lB1OVAoL4dkTNAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/parts/valve/valve_wrong2.png
/* harmony default export */ var valve_wrong2 = ({"src":"/_next/static/media/valve_wrong2.81ba2886.png","height":188,"width":188,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAP1BMVEUcGxYCAgFqY10MCwgUDwspIhtgJydzamNaUUpjWlJ+cmtlST1SRTsxLCh+ZFpsVUlCPTaSZl+Ti4VtXlA9MSQ941H4AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAPklEQVQImQXBCQLAIAgDsKJAwdtt/3/rEtgphZyGEwIFDRR1FxSE7nu9JtLeb7sEOJJLZwBPWz1bhSH7CMUPQHAB5pnYWR0AAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/parts/valve/valve_wrong3.png
/* harmony default export */ var valve_wrong3 = ({"src":"/_next/static/media/valve_wrong3.0794860c.png","height":188,"width":188,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAALVBMVEXKspKzmnzErY2VfV+6ooO/poesk3Y9MB1WRTFlVT+kimxxYEUqIhWKb1B4YEWv/QdPAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAOklEQVQImR3GSRLAMAgDQYEkwM7y/+emnMv0AAAy/9ryOZvDTKTYfYWhPX2vEPi8a1gCuSsiEnUI4QMgeQECwR5YvQAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/parts/valve/valve_Ideal_Tab.png
/* harmony default export */ var valve_Ideal_Tab = ({"src":"/_next/static/media/valve_Ideal_Tab.d590f763.png","height":1224,"width":1227,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAANlBMVEXDuK6flY2Tj4uEfniupJylnJKioZ3OxL9mZGHVzMiPhX7Z1dbKv7e4sKiqrK52dHOai35cVU43uUesAAAACXBIWXMAABJ0AAASdAHeZh94AAAAO0lEQVQImQXBiQGAIAwAsaP0B0T3X9aEtRhyKlh6RaYVu5/HvEHbb3Ya+o78Zg7CjkwXqK0znU1UQAQ/QQ0BrldtlY4AAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/parts/shower/shower_main.png
/* harmony default export */ var shower_main = ({"src":"/_next/static/media/shower_main.1c97b122.png","height":572,"width":474,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAMAAAAC2hU0AAAAPFBMVEW8s6WNhXiSj4hXWFdDREHCu7Ock4StqKG+uK51b2lsaGGXjoK4sqqnn5GBhIU8MzB/e3VVTEY6NzReX1pFq58XAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAO0lEQVQImRXFRxLAIAwEsHUBF0xL/v/XTHQRAHf3BoBzVQNYVNgx8z0rDF1U9T/3s0+hU9ywwqBB0+wDMBYBsMRuKecAAAAASUVORK5CYII=","blurWidth":7,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/parts/shower/shower_wrong1.png
/* harmony default export */ var shower_wrong1 = ({"src":"/_next/static/media/shower_wrong1.d03d8144.png","height":188,"width":188,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAOVBMVEV3alxuYlZ6eHFWRTRlY2F/a1pqW0yJdWNaUkhzYVCGhYGRgHBaXV02IxGPoKp/i5BraGVweHw7LBuWFvRyAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAPElEQVQImRXGRxLAIAwAsTXuQOr/H5uJTqLJ9FxJh4uNdLq69jAIDeZpSnqJXXUAYnv8kbifWS/QuWbpBzebAaBNdsc1AAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/parts/shower/shower_wrong2.png
/* harmony default export */ var shower_wrong2 = ({"src":"/_next/static/media/shower_wrong2.06c698b7.png","height":188,"width":188,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAaVBMVEVzYk9yZlkODQw3LiWdiXRRRjpkUT5EOTCDeW12bF+MdmIiIB5HaHCQiYCJgHK9qpVcZ2K2m4RbeYGBj4/Bs6SckIKghWVaUUl9a1dAanhui5JeW04tGxlFSEtCWmWDhH2mn5RWmrBnZlyuskwNAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAQ0lEQVQImQXBhQHAMAwDMBdT5jH//+QkRHPdvfUXiU5b2/dg4bAljQgvVraHOuBJq/mQGYprVVie4ATpDdJAOlCANT+J+QMyp4Tq+AAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/parts/shower/shower_wrong3.png
/* harmony default export */ var shower_wrong3 = ({"src":"/_next/static/media/shower_wrong3.230c11a7.png","height":188,"width":188,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAS1BMVEWqqa6enJqHiIuHgX+9vsZlW1S3uMGRj45sVUCDe3GfoKR/cmSZl5KtsbV6d3JBSFJaTUNTSkRHPjZvamXGxs1RU1omKjCLl5p5aFg8Ya15AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAQklEQVQImRXJSQ7AIAwEsAECWUige/v/l1bcLBkjW4S74mRYDu6ojDnf8eFg3I+qYGe04kVW0ZW6oGZQW9iKUUsqP1eQAi5KsaiKAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./components/VisualSearch/v1/UploadImage/constant.js

























const imageList = {
    faucetmainImage: faucets_main,
    faucetWrong1: wrong1,
    faucetWrong2: wrong2,
    faucetWrong3: wrong3,
    faucetWrong1Mob: wrong1_mob,
    faucetWrong2Mob: wrong2_mob,
    faucetWrong3Mob: wrong3_mob,
    faucetmainImageTab: faucets_image_tab,
    faucetmainImageMobile: faucet_mask_group,
    toiletmainImage: toilet_main,
    toiletWrong1: toilet_wrong1,
    toiletWrong2: toilet_wrong2,
    toiletWrong3: toilet_wrong3,
    toiletWrongMob1: toilet_wrong_mob1,
    toiletWrongMob2: toilet_wrong_mob2,
    toiletmainImageTab: toilet_Ideal_Tab,
    valvemainImage: valve_main,
    valveWrong1: valve_wrong1,
    valveWrong2: valve_wrong2,
    valveWrong3: valve_wrong3,
    valvemainImageTab: valve_Ideal_Tab,
    showermainImage: shower_main,
    showerWrong1: shower_wrong1,
    showerWrong2: shower_wrong2,
    showerWrong3: shower_wrong3
};
const IMAGE_FILE_TYPE = "image/png, image/jpeg, image/jfif, image/bmp, image/heic, image/heif";

;// CONCATENATED MODULE: ./components/VisualSearch/v1/UploadImage/FileUpload.view.jsx








const FileUpload = (props)=>{
    const { setImage =()=>{} , setSection , setEventType =()=>{} , category  } = props;
    const { t  } = (0,esm/* useTranslation */.$G)();
    const device = (0,useViewport/* default */.Z)();
    const { borwseBtn , imageUploadtext , changeProduct , imageUploadSubText  } = localization_getTranslations(t);
    const onDrop = (0,react.useCallback)((acceptedFiles)=>{
        acceptedFiles["file"] = acceptedFiles[0];
        setImage(acceptedFiles);
    }, []);
    const { getRootProps , getInputProps , isDragActive  } = (0,dist_es/* useDropzone */.uI)({
        onDrop
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: !(device === null || device === void 0 ? void 0 : device.isSmallTabView) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "file-upload ".concat(isDragActive ? "drag-container" : ""),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "drag-wrapper",
                onDrop: ()=>{
                    setEventType("drag an image here");
                    addDataLayerVisualSearch({
                        eventKey: "drag an image here",
                        category: category,
                        eventStatus: "interaction"
                    });
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        ...getRootProps(),
                        className: "file-upload-dropzone" + (isDragActive ? " drag" : ""),
                        children: isDragActive ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "title-hover",
                            children: imageUploadtext
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "title",
                                    children: imageUploadtext
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "seperator",
                                    children: imageUploadSubText
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    className: "browse",
                                    onClick: ()=>{
                                        setEventType("browse");
                                        addDataLayerVisualSearch({
                                            eventKey: "browse",
                                            category: category,
                                            eventStatus: "interaction"
                                        });
                                    },
                                    children: borwseBtn
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    ...getInputProps(),
                                    accept: IMAGE_FILE_TYPE,
                                    "aria-label": "Input Images"
                                })
                            ]
                        })
                    }),
                    !isDragActive ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "product_change",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: "change-button",
                            onClick: ()=>{
                                setSection("category");
                                addDataLayerVisualSearch({
                                    eventKey: "change product",
                                    category: category
                                });
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: changeProduct
                            })
                        })
                    }) : null
                ]
            })
        }) : null
    });
};
/* harmony default export */ var FileUpload_view = (FileUpload);

;// CONCATENATED MODULE: ./components/VisualSearch/v1/UploadImage/icons.js

const CorrectIcon = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "20",
                cy: "20",
                r: "20",
                transform: "matrix(1 0 0 -1 0 40)",
                fill: "#4A9232"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M28.3778 12L29.3307 12.8741L18.1272 26.6667L10.6641 20.3326L11.4366 19.3022L17.9531 24.8337L28.3778 12Z",
                fill: "white"
            })
        ]
    });
};
const IncorrectIcon = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "30",
        height: "30",
        viewBox: "0 0 30 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "15",
                cy: "15",
                r: "15",
                transform: "matrix(1 0 0 -1 0 30)",
                fill: "#D10000"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10.7043 10L19.8599 19.2857L19.1556 20L10 10.7143L10.7043 10Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M19.2957 10L10.1401 19.2857L10.8444 20L20 10.7143L19.2957 10Z",
                fill: "white"
            })
        ]
    });
};
const CloseIconGuide = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        className: "close-big",
        width: "30",
        height: "30",
        viewBox: "0 0 30 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M15.5015 15.4996L28.9365 2.06453L28.2294 1.35742L14.7944 14.7924L2.06648 2.06453L1.35938 2.77164L14.0873 15.4996L1.35938 28.2275L2.06648 28.9346L14.7944 16.2067L28.2294 29.6417L28.9365 28.9346L15.5015 15.4996Z",
            fill: "white"
        })
    });
const CloseIconGuideMob = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        className: "close_small",
        width: "17",
        height: "30",
        viewBox: "0 0 17 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
            id: "close/medium",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                id: "Path",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M7.79181 15.4999L0.367188 22.9245L1.07429 23.6316L8.49892 16.207L15.9235 23.6316L16.6306 22.9245L9.20602 15.4999L16.6306 8.07527L15.9235 7.36816L8.49892 14.7928L1.07429 7.36816L0.367188 8.07527L7.79181 15.4999Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M7.79181 15.4999L0.367188 22.9245L1.07429 23.6316L8.49892 16.207L15.9235 23.6316L16.6306 22.9245L9.20602 15.4999L16.6306 8.07527L15.9235 7.36816L8.49892 14.7928L1.07429 7.36816L0.367188 8.07527L7.79181 15.4999Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M7.79181 15.4999L0.367188 22.9245L1.07429 23.6316L8.49892 16.207L15.9235 23.6316L16.6306 22.9245L9.20602 15.4999L16.6306 8.07527L15.9235 7.36816L8.49892 14.7928L1.07429 7.36816L0.367188 8.07527L7.79181 15.4999Z",
                        stroke: "white",
                        "stroke-width": "0.5"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M7.79181 15.4999L0.367188 22.9245L1.07429 23.6316L8.49892 16.207L15.9235 23.6316L16.6306 22.9245L9.20602 15.4999L16.6306 8.07527L15.9235 7.36816L8.49892 14.7928L1.07429 7.36816L0.367188 8.07527L7.79181 15.4999Z",
                        stroke: "white",
                        "stroke-width": "0.5"
                    })
                ]
            })
        })
    });
const CorrectIconMob = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "30",
        height: "30",
        viewBox: "0 0 30 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "15",
                cy: "15",
                r: "15",
                transform: "matrix(1 0 0 -1 0 30)",
                fill: "#4A9232"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M21.2853 9L22 9.65557L13.5973 20L8 15.2495L8.57941 14.4766L13.4668 18.6253L21.2853 9Z",
                fill: "white"
            })
        ]
    });

;// CONCATENATED MODULE: ./components/VisualSearch/v1/UploadImage/utils.js

const { faucetmainImage , faucetWrong1 , faucetWrong2 , faucetWrong3 , faucetWrong1Mob , faucetWrong2Mob , faucetWrong3Mob , faucetmainImageTab , faucetmainImageMobile , toiletmainImage , toiletWrong1 , toiletWrong2 , toiletWrong3 , toiletWrongMob1 , toiletWrongMob2 , toiletmainImageTab , valvemainImage , valveWrong1 , valveWrong2 , valveWrong3 , valvemainImageTab , showermainImage , showerWrong1 , showerWrong2 , showerWrong3  } = imageList;
const getImageCategory = (value, device)=>{
    const imageForFaucet = (device === null || device === void 0 ? void 0 : device.isSmallScreen) ? faucetmainImageMobile : faucetmainImageTab;
    const defaultItems = {
        idealImage: (device === null || device === void 0 ? void 0 : device.isLargeTabView) ? faucetmainImage : imageForFaucet,
        badAngle: (device === null || device === void 0 ? void 0 : device.isSmallScreen) ? faucetWrong1Mob : faucetWrong1,
        tooClose: (device === null || device === void 0 ? void 0 : device.isSmallScreen) ? faucetWrong2Mob : faucetWrong2,
        tooFar: (device === null || device === void 0 ? void 0 : device.isSmallScreen) ? faucetWrong3Mob : faucetWrong3
    };
    switch(value){
        case "faucet":
            return defaultItems;
        case "toilet":
            return {
                idealImage: (device === null || device === void 0 ? void 0 : device.isLargeTabView) ? toiletmainImage : toiletmainImageTab,
                badAngle: (device === null || device === void 0 ? void 0 : device.isSmallScreen) ? toiletWrongMob1 : toiletWrong1,
                tooClose: (device === null || device === void 0 ? void 0 : device.isSmallScreen) ? toiletWrongMob2 : toiletWrong2,
                tooFar: toiletWrong3,
                text: "Photo should include tank and bowl"
            };
        case "valve":
            return {
                idealImage: (device === null || device === void 0 ? void 0 : device.isLargeTabView) ? valvemainImage : valvemainImageTab,
                badAngle: valveWrong1,
                tooClose: valveWrong2,
                tooFar: valveWrong3
            };
        case "shower":
            return {
                idealImage: showermainImage,
                badAngle: showerWrong1,
                tooClose: showerWrong2,
                tooFar: showerWrong3
            };
        default:
            return defaultItems;
    }
};

;// CONCATENATED MODULE: ./components/VisualSearch/v1/UploadImage/UploadImageSection.view.jsx







const UploadImageSection = (props)=>{
    const { category  } = props;
    const device = (0,useViewport/* default */.Z)();
    const { t  } = (0,esm/* useTranslation */.$G)();
    const { photoText , toFar , toClose , wrongAngle  } = localization_getTranslations(t);
    const [idealImg, setIdeal] = (0,react.useState)({
        idealImage: null,
        badAngle: null,
        tooClose: null,
        tooFar: null,
        text: photoText
    });
    const { idealImage , badAngle , tooClose , tooFar , text  } = idealImg;
    (0,react.useEffect)(()=>{
        if (device === null || device === void 0 ? void 0 : device.isSmallScreen) {
            const timer = setTimeout(()=>{
                const elements = document.getElementsByTagName("mavenoid-assistant");
                if (elements.length > 0) {
                    document.querySelector("mavenoid-assistant").style.display = "none";
                }
            }, 100);
            return ()=>{
                document.querySelector("mavenoid-assistant").style.display = "block";
                clearTimeout(timer);
            };
        }
    }, []);
    (0,react.useEffect)(()=>{
        const selectedCategory = category === null || category === void 0 ? void 0 : category.toLowerCase();
        if (selectedCategory) {
            const selectedCategoryImg = getImageCategory(selectedCategory, device);
            setIdeal((prevstate)=>{
                return {
                    ...prevstate,
                    ...selectedCategoryImg
                };
            });
        }
    }, [
        category
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "main-image-container position-relative ",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "corret-image-container",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            className: "correct-image",
                            src: idealImage === null || idealImage === void 0 ? void 0 : idealImage.src,
                            alt: "Ideal Angle"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "indicator-icon",
                        children: (device === null || device === void 0 ? void 0 : device.isExtraSmallScreen) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CorrectIconMob, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CorrectIcon, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "image-caption",
                        children: text
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "outer-wrapper-wrongImage",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "wrong-image-section",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                alt: "Bad Angle",
                                className: "incorrect-image",
                                src: badAngle === null || badAngle === void 0 ? void 0 : badAngle.src
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "indicator-wrong-icon",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IncorrectIcon, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "image-caption",
                                children: wrongAngle
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "wrong-image-section",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                alt: "Too Close",
                                className: "incorrect-image",
                                src: tooClose === null || tooClose === void 0 ? void 0 : tooClose.src
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "indicator-wrong-icon",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IncorrectIcon, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "image-caption",
                                children: toClose
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "wrong-image-section",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                alt: "Too Far",
                                className: "incorrect-image",
                                src: tooFar === null || tooFar === void 0 ? void 0 : tooFar.src
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "indicator-wrong-icon",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IncorrectIcon, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "image-caption",
                                children: toFar
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var UploadImageSection_view = (UploadImageSection);

;// CONCATENATED MODULE: ./components/VisualSearch/v1/UploadImage/index.jsx










const UploadImage = (props)=>{
    const { setImage =()=>{} , category , setShowInfo , setSection , setEventType =()=>{}  } = props;
    const device = (0,useViewport/* default */.Z)();
    const { t  } = (0,esm/* useTranslation */.$G)();
    const { photoGuidelineText  } = localization_getTranslations(t);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (uploadImage_module_default()).UploadImageContainer,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "outer-wrapper position-relative visualContentwarpper",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FileUpload_view, {
                            setImage: setImage,
                            setSection: setSection,
                            setEventType: setEventType,
                            category: category
                        }),
                        (device === null || device === void 0 ? void 0 : device.isSmallTabView) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mobile-wrapper ",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "close-container d-flex align-items-center justify-content-between",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "close-Icon",
                                        onClick: ()=>setShowInfo ? setShowInfo(false) : setSection("category"),
                                        tabIndex: "0",
                                        role: "button",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIconGuide, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIconGuideMob, {})
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "guide-photo d-flex align-items-center justify-content-center flex-1",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: photoGuidelineText
                                        })
                                    })
                                ]
                            })
                        }) : null,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "how-it-works",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UploadImageSection_view, {
                                category: category
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (uploadImage_module_default()).QrWrapper,
                children: !(device === null || device === void 0 ? void 0 : device.isSmallTabView) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_QRCode, {}) : null
            })
        ]
    });
};
/* harmony default export */ var v1_UploadImage = (UploadImage);

// EXTERNAL MODULE: ./components/VisualSearch/v1/LoadingData/loadingdata.module.scss
var loadingdata_module = __webpack_require__(3856);
var loadingdata_module_default = /*#__PURE__*/__webpack_require__.n(loadingdata_module);
// EXTERNAL MODULE: ./components/core/Heading/Heading.jsx
var Heading = __webpack_require__(22231);
// EXTERNAL MODULE: ./services/ct.service.js
var ct_service = __webpack_require__(13875);
;// CONCATENATED MODULE: ./public/images/animated/uploadImage.svg
/* harmony default export */ var uploadImage = ({"src":"/_next/static/media/uploadImage.f2ce335b.svg","height":650,"width":650});
;// CONCATENATED MODULE: ./public/images/animated/successImage.svg
/* harmony default export */ var successImage = ({"src":"/_next/static/media/successImage.c2b072b2.svg","height":630,"width":630});
;// CONCATENATED MODULE: ./public/images/animated/cricleImage.svg
/* harmony default export */ var cricleImage = ({"src":"/_next/static/media/cricleImage.3320c023.svg","height":1000,"width":1000});
;// CONCATENATED MODULE: ./public/images/animated/downloadData.svg
/* harmony default export */ var downloadData = ({"src":"/_next/static/media/downloadData.213d89ce.svg","height":650,"width":650});
;// CONCATENATED MODULE: ./components/VisualSearch/v1/LoadingData/constant.js




const data = [
    {
        text: "Uploading image...",
        imageUrl: uploadImage.src,
        status: true
    },
    {
        text: "Matching products...",
        imageUrl: cricleImage.src,
        status: true
    },
    {
        text: "Match found.",
        imageUrl: successImage.src,
        status: true
    },
    {
        text: "Retrieving details...",
        imageUrl: downloadData.src,
        status: true
    }
];
const APP_URL = "https://www.kohler.com";

;// CONCATENATED MODULE: ./components/VisualSearch/v1/LoadingData/index.jsx









const LoadingData = (props)=>{
    const { image =[] , category ="" , setSection , setOpenCam , eventType  } = props;
    const [progress, setProgress] = (0,react.useState)(data[0]);
    const [productData, setProductData] = (0,react.useState)(null);
    const device = (0,useViewport/* default */.Z)();
    (0,react.useEffect)(()=>{
        let timeId1;
        let timeId2;
        let timeId3;
        if (image && category) {
            if (device.isSmallTabView) {
                var ref, ref1;
                document === null || document === void 0 ? void 0 : (ref = document.body) === null || ref === void 0 ? void 0 : (ref1 = ref.classList) === null || ref1 === void 0 ? void 0 : ref1.add("overflow-hidden");
            } else {
                document.body.classList.remove("overflow-hidden");
            }
            timeId1 = setTimeout(()=>setProgress(data[1]), 1000);
            timeId2 = setTimeout(()=>setProgress(data[2]), 2500);
            timeId3 = setTimeout(()=>setProgress(data[3]), 4000);
            setOpenCam(false);
            const categoryVal = getValidCategory(category);
            getSkuNumberByImage(image, categoryVal);
        }
        return ()=>{
            clearTimeout(timeId1);
            clearTimeout(timeId2);
            clearTimeout(timeId3);
        };
    }, [
        image,
        category
    ]);
    (0,react.useEffect)(()=>{
        let timeId;
        if (productData !== null) {
            const { pdpUrl  } = productData;
            if (pdpUrl) {
                timeId = setTimeout(()=>{
                    var ref;
                    const url = pdpUrl.replace(APP_URL, window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : ref.origin);
                    window.open(url, "_self");
                    document.body.classList.remove("overflow-hidden");
                }, 3000);
            }
        }
        return ()=>{
            clearTimeout(timeId);
        };
    }, [
        productData
    ]);
    const getSkuNumberByImage = async function(image) {
        let category = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "faucets";
        const { file  } = image;
        try {
            if (file && category) {
                var ref;
                const formdata = new FormData();
                formdata.append("category", category);
                formdata.append("file", file);
                const response = await (0,ct_service/* getProductByImage */.He)(formdata);
                if (response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : ref.result) {
                    var ref1;
                    setProductData(response === null || response === void 0 ? void 0 : (ref1 = response.data) === null || ref1 === void 0 ? void 0 : ref1.result);
                    addDataLayerVisualSearch({
                        eventKey: eventType,
                        eventStatus: "success",
                        product: response.data.result,
                        category: props.category,
                        linkUrl: response.data.result.pdpUrl
                    });
                } else {
                    setProductData(null);
                    addDataLayerVisualSearch({
                        eventKey: eventType,
                        eventStatus: "failure",
                        category: props.category,
                        eventMsg: "sorry something went wrong"
                    });
                    setSection("error");
                }
            }
        } catch (err) {
            setSection("error");
        }
    };
    const getValidCategory = (value)=>{
        if (typeof value !== "string") setSection("error");
        const categoryList = [
            "faucets",
            "toilet",
            "valve",
            "shower"
        ];
        if (categoryList.includes(value.toLowerCase())) {
            return value.toLowerCase();
        } else {
            return categoryList[0];
        }
    };
    if (!category) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (loadingdata_module_default()).LoadingImage,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "image-loading-container visualContentwarpper d-flex justify-content-center align-items-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "upload-image d-flex justify-content-center align-items-center flex-column",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "icon-upload",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: progress === null || progress === void 0 ? void 0 : progress.imageUrl,
                                alt: progress === null || progress === void 0 ? void 0 : progress.text
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                            fontSize: 34,
                            level: 4,
                            className: "loading-text",
                            children: progress === null || progress === void 0 ? void 0 : progress.text
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "qrWrapper",
                children: !(device === null || device === void 0 ? void 0 : device.isSmallScreen) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_QRCode, {}) : null
            })
        ]
    });
};
/* harmony default export */ var v1_LoadingData = (LoadingData);

;// CONCATENATED MODULE: ./components/VisualSearch/v1/utils.js
/**
 * Converts data url to file object
 * @param {String} dataUrl Dataurl text
 * @param {String} fileName FileName
 * @return {File|null} File Object
 */ async function dataUrlToFile(dataUrl, fileName) {
    if (dataUrl) {
        const res = await fetch(dataUrl);
        const blob = await res.blob();
        return new File([
            blob
        ], fileName, {
            type: "image/png"
        });
    }
    return null;
}
/**
 * Crops canvas and return new canvas
 * @param {Canvas} sourceCanvas Canvas to be cropped
 * @param {Number} left left coordinate
 * @param {Number} top top coordinate
 * @param {Number} width Width of crop
 * @param {Number} height Height of the crop
 * @return {Canvas} Canvas
 */ const cropCanvas = (sourceCanvas, left, top, width, height)=>{
    const destCanvas = document.createElement("canvas");
    destCanvas.width = width;
    destCanvas.height = height;
    destCanvas.getContext("2d").drawImage(sourceCanvas, left, top, width, height, 0, 0, width, height);
    return destCanvas;
};
/**
 * Converts to cropped image
 * @param {Image} image
 * @param {Object} crop
 * @param {String} fileName
 * @param {String} type
 * @return {File}
 */ function getCroppedImg(image, crop, fileName, type) {
    const canvas = document.createElement("canvas");
    const scaleX = (image === null || image === void 0 ? void 0 : image.naturalWidth) ? image.naturalWidth / image.width : 1;
    const scaleY = (image === null || image === void 0 ? void 0 : image.naturalHeight) ? image.naturalHeight / image.height : 1;
    canvas.width = crop.width;
    canvas.height = crop.height;
    const ctx = canvas.getContext("2d");
    const pixelRatio = window.devicePixelRatio;
    canvas.width = crop.width * pixelRatio;
    canvas.height = crop.height * pixelRatio;
    ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
    ctx.imageSmoothingQuality = "high";
    ctx.drawImage(image, crop.x * scaleX, crop.y * scaleY, crop.width * scaleX, crop.height * scaleY, 0, 0, crop.width, crop.height);
    const base64Image = canvas.toDataURL(type);
    return dataUrlToFile(base64Image, fileName);
}
const utils_debounce = (func, debounceTime)=>{
    let debounce = true;
    return ()=>{
        if (debounce) {
            debounce = false;
            setTimeout(()=>{
                func();
                debounce = true;
            }, debounceTime);
        }
    };
};
const promiseImageFileReader = (imageFile)=>{
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.onload = (e)=>{
            resolve({
                result: e.target.result,
                readerResult: reader.result
            });
        };
        reader.onerror = (e)=>{
            reject(e);
        };
        reader.readAsDataURL(imageFile);
    });
};
const promiseImageReader = (source)=>{
    return new Promise((resolve, reject)=>{
        const image = new Image();
        image.onload = ()=>{
            resolve(image);
        };
        image.onerror = (e)=>{
            reject(e);
        };
        image.src = source;
    });
};
const imageExtentionCheck = (imageFile)=>{
    var ref, ref1;
    if (imageFile && ((ref1 = (ref = imageFile.name) === null || ref === void 0 ? void 0 : ref.toLowerCase()) === null || ref1 === void 0 ? void 0 : ref1.match(/\.(jpg|jpeg|png|bmp|jfif)$/))) return true;
    return false;
};
const validateImageFileAsync = async (imageFile)=>{
    try {
        if (imageExtentionCheck(imageFile)) {
            const { result , readerResult  } = await promiseImageFileReader(imageFile);
            const image = await promiseImageReader(result);
            return {
                width: image.width,
                height: image.height,
                image: image,
                file: imageFile,
                dataURL: readerResult
            };
        }
    } catch (e) {
        return false;
    }
    return false;
};

;// CONCATENATED MODULE: ./components/VisualSearch/v1/CameraView/WebCam.js

/**
 * Webcam component
 */ class WebCam {
    /**
   * Initialization
   */ async setupCamera() {
        if (navigator.mediaDevices.getUserMedia !== undefined) {
            let width = window.innerWidth;
            width = width - width % 4;
            let height = window.innerHeight;
            height = height - height % 4;
            const mediaStream = await navigator.mediaDevices.getUserMedia({
                audio: false,
                video: {
                    facingMode: "environment",
                    aspectRatio: window.matchMedia("(orientation: landscape)").matches ? width / height : height / width
                }
            });
            if ("srcObject" in this.webcamElement) {
                this.webcamElement.srcObject = mediaStream;
                this.mediaStream = mediaStream;
            } else {
                this.webcamElement.src = window.URL.createObjectURL(mediaStream);
            }
            this.webcamElement.onloadedmetadata = (e)=>{
                this.webcamElement.play();
            };
            this.webcamElement.style.setProperty("width", "auto", "important");
            this.webcamElement.style.setProperty("height", "100%", "important");
            this.webcamElement.style.setProperty("max-width", "none", "important");
        }
    }
    /**
   * Stops Media stream
   */ stopMediaStream() {
        if (this.mediaStream) {
            if (this.mediaStream.getVideoTracks && this.mediaStream.getAudioTracks) {
                this.mediaStream.getVideoTracks().forEach((track)=>{
                    this.mediaStream.removeTrack(track);
                    track.stop();
                });
                this.mediaStream.getAudioTracks().forEach((track)=>{
                    this.mediaStream.removeTrack(track);
                    track.stop();
                });
            } else {
                this.mediaStream.stop();
            }
        }
    }
    /**
   * Renders Captured Image
   * @return {Object} Object with width and height of captured Image
   */ _drawImage() {
        const videoWidth = this.webcamElement.videoWidth;
        const videoHeight = this.webcamElement.videoHeight;
        let imageWidth = this.webcamElement.videoWidth;
        let imageHeight = this.webcamElement.videoHeight;
        const imageAspectRatio = imageWidth / imageHeight;
        let top = 0;
        let left = 0;
        if (this.portAspectRatio < imageAspectRatio) {
            left = imageWidth * (1 - this.portAspectRatio / imageAspectRatio) / 2;
            imageWidth = imageWidth * (this.portAspectRatio / imageAspectRatio);
        } else {
            top = imageHeight * (1 - imageAspectRatio / this.portAspectRatio) / 2;
            imageHeight = imageHeight * imageAspectRatio / this.portAspectRatio;
        }
        const context = this.canvasElement.getContext("2d");
        this.canvasElement.width = videoWidth;
        this.canvasElement.height = videoHeight;
        context.drawImage(this.webcamElement, 0, 0, videoWidth, videoHeight);
        const result = cropCanvas(this.canvasElement, left, top, imageWidth, imageHeight);
        this.canvasElement = result;
        return {
            imageHeight,
            imageWidth
        };
    }
    /**
   * Captures image from canvas
   * @param {Object} param0
   * @return {Object} Object with base64 value
   */ takeBase64Photo() {
        let { type , quality  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
            type: "png",
            quality: 1
        };
        const { imageHeight , imageWidth  } = this._drawImage();
        const base64 = this.canvasElement.toDataURL("image/" + type, quality);
        return {
            base64,
            imageHeight,
            imageWidth
        };
    }
    /**
   * Constructor
   * @param {WebCam} webcamElement
   */ constructor(webcamElement){
        this.canvasElement = document.createElement("canvas");
        this.webcamElement = webcamElement;
        this.mediaStream = null;
        this.facingMode = [
            "environment",
            "user"
        ];
        this.flashLight = null;
        this.autoFocus = null;
        this.portWidth = window.innerWidth;
        this.portHeight = window.innerHeight;
        this.portAspectRatio = this.portWidth / this.portHeight;
    }
}

;// CONCATENATED MODULE: ./components/VisualSearch/v1/CameraView/Camera.js




const Camera = (props)=>{
    const { captureTrigger =false , setCaptureTrigger , handlerResult  } = props;
    let wcstream = null;
    const [webcamStream, setWebcamStream] = (0,react.useState)({});
    const loadWebcam = async ()=>{
        if (wcstream != null) wcstream.stopMediaStream();
        const webCamElement = document.getElementById("webcam");
        if (null == webCamElement) return;
        const webCam = new WebCam(webCamElement);
        webCam.setupCamera().catch(()=>{});
        setWebcamStream(webCam);
        wcstream = webCam;
    };
    (0,react.useEffect)(()=>{
        loadWebcam();
        const debouncedWebcamEvent = utils_debounce(loadWebcam, 200);
        window.addEventListener("resize", debouncedWebcamEvent);
        window.addEventListener("orientationchange", debouncedWebcamEvent);
        const timer = setTimeout(()=>{
            const elements = document.getElementsByTagName("mavenoid-assistant");
            if (elements.length > 0) {
                document.querySelector("mavenoid-assistant").style.display = "none";
            }
        }, 100);
        return ()=>{
            wcstream.stopMediaStream();
            window.removeEventListener("resize", debouncedWebcamEvent);
            window.removeEventListener("orientationchange", debouncedWebcamEvent);
            document.querySelector("mavenoid-assistant").style.display = "block";
            clearTimeout(timer);
        };
    }, []);
    (0,react.useEffect)(()=>{
        if (captureTrigger) {
            takePhoto();
            setCaptureTrigger(false);
        }
    }, [
        captureTrigger
    ]);
    const takePhoto = async ()=>{
        const capturedData = webcamStream.takeBase64Photo({
            type: "jpeg",
            quality: 1
        });
        webcamStream.stopMediaStream();
        const imageFile = await dataUrlToFile(capturedData.base64, "input.jpg");
        handlerResult({
            width: capturedData.imageWidth,
            height: capturedData.imageHeight,
            file: imageFile,
            dataURL: capturedData.base64
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
        id: "webcam",
        className: "video-container",
        autoPlay: true,
        playsInline: true,
        muted: true
    });
};
/* harmony default export */ var CameraView_Camera = (Camera);

// EXTERNAL MODULE: ./components/VisualSearch/v1/CameraView/cameraview.module.scss
var cameraview_module = __webpack_require__(18682);
var cameraview_module_default = /*#__PURE__*/__webpack_require__.n(cameraview_module);
;// CONCATENATED MODULE: ./components/VisualSearch/v1/CameraView/GuildePageMobile.jsx




const GuildePageMobile = (props)=>{
    const { setShowInfo , category ="" , setSection =()=>{}  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (cameraview_module_default()).CameraView,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "cameraview-container",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_UploadImage, {
                setShowInfo: setShowInfo,
                category: category,
                setSection: setSection
            })
        })
    });
};
/* harmony default export */ var CameraView_GuildePageMobile = (GuildePageMobile);

;// CONCATENATED MODULE: ./components/VisualSearch/v1/CameraView/icons.js

const Close = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "17",
        height: "17",
        viewBox: "0 0 17 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.79181 8.49989L0.367188 15.9245L1.07429 16.6316L8.49892 9.207L15.9235 16.6316L16.6306 15.9245L9.20602 8.49989L16.6306 1.07527L15.9235 0.368164L8.49892 7.79278L1.07429 0.368164L0.367188 1.07527L7.79181 8.49989Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.79181 8.49989L0.367188 15.9245L1.07429 16.6316L8.49892 9.207L15.9235 16.6316L16.6306 15.9245L9.20602 8.49989L16.6306 1.07527L15.9235 0.368164L8.49892 7.79278L1.07429 0.368164L0.367188 1.07527L7.79181 8.49989Z",
                fill: "white"
            })
        ]
    });
const GuideValveImage = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "322",
        height: "322",
        viewBox: "0 0 322 322",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                opacity: "0.2",
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M161 320.296C249.447 320.296 321.148 248.596 321.148 160.148C321.148 71.7008 249.447 0 161 0C72.5523 0 0.851562 71.7008 0.851562 160.148C0.851562 248.596 72.5523 320.296 161 320.296ZM161.424 189.962C165.423 189.962 168.665 186.72 168.665 182.721C168.665 178.722 165.423 175.48 161.424 175.48C157.425 175.48 154.184 178.722 154.184 182.721C154.184 186.72 157.425 189.962 161.424 189.962Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "161.421",
                cy: "182.721",
                r: "7.34259",
                stroke: "white",
                "stroke-width": "1.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "161.423",
                cy: "182.728",
                r: "14.1574",
                stroke: "white",
                "stroke-width": "1.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "161.429",
                cy: "178.464",
                r: "31.1944",
                stroke: "white",
                "stroke-width": "1.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "161.429",
                cy: "171.648",
                r: "54.1944",
                stroke: "white",
                "stroke-width": "1.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "161",
                cy: "161",
                r: "90.3981",
                stroke: "white",
                "stroke-width": "1.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "161",
                cy: "161",
                r: "160.25",
                stroke: "white",
                "stroke-width": "1.5"
            })
        ]
    });
const GuideFaucetsOverlay = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "375",
        height: "418",
        viewBox: "0 0 375 418",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                filter: "url(#filter0_d_378_73463)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    "fill-rule": "evenodd",
                    "clip-rule": "evenodd",
                    d: "M211.882 99.6139C212.471 93.0166 215.768 82.1988 225.342 81.6669C231.028 81.351 240.479 99.1304 251.422 119.719C251.701 120.244 251.981 120.771 252.262 121.3C254.816 126.102 257.476 131.015 260.124 135.906C267.397 149.336 274.576 162.594 279.183 172.898C280.429 174.144 285.016 175.739 293.391 172.15C301.766 168.561 304.857 163.177 305.356 160.933C305.356 160.933 260.488 75.6846 256.001 70.4501C255.784 70.1962 255.557 69.9282 255.321 69.6482C250.68 64.1555 242.128 54.0348 219.36 54.7466C187.249 60.7205 183.476 99.5067 183.466 99.6139M211.882 99.6139V300.535C231.272 302.107 232.82 306.752 232.82 306.752V313.483C232.82 313.483 226.09 322.456 197.674 322.456C169.257 322.456 162.527 312.735 162.527 312.735V307.5C162.527 307.5 164.076 302.339 183.466 300.592V99.6139",
                    fill: "white",
                    "fill-opacity": "0.25",
                    "shape-rendering": "crispEdges"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M235.152 57.1885C226.429 54.5817 215.818 54.3737 205.667 61.0248C185.257 74.3964 183.628 98.8997 184.074 110.048L183.34 110.078H184.074V306.107H182.578V282.6C182.389 282.656 182.189 282.686 181.981 282.686C180.827 282.686 179.891 281.751 179.891 280.596V262.694C179.891 261.539 180.827 260.603 181.981 260.603C182.189 260.603 182.389 260.634 182.578 260.69V251.274C182.389 251.33 182.189 251.36 181.981 251.36C180.827 251.36 179.891 250.424 179.891 249.27V246.584C179.891 245.43 180.827 244.494 181.981 244.494C182.189 244.494 182.389 244.524 182.578 244.58V110.078C182.133 98.8342 183.742 73.6014 204.847 59.7738C215.462 52.8192 226.557 53.0589 235.58 55.7556C244.571 58.4427 251.595 63.5943 254.164 66.6296C256.646 69.5627 258.519 72.1587 259.774 74.024C260.402 74.9569 260.875 75.7074 261.192 76.2265C261.293 76.3918 261.378 76.5336 261.447 76.6504L261.492 76.6267L305.574 160.538C305.681 160.691 305.773 160.855 305.849 161.032C306.252 161.97 306.084 163.001 305.619 163.973C305.153 164.948 304.353 165.952 303.322 166.933C301.255 168.899 298.142 170.886 294.476 172.46C290.81 174.034 287.225 174.923 284.376 175.068C282.955 175.14 281.675 175.029 280.648 174.696C279.709 174.391 278.906 173.872 278.468 173.066L278.439 173.081L235.067 90.5089L235.071 90.507C234.973 90.3457 234.863 90.1639 234.744 89.9687C234.307 89.2542 233.755 88.371 233.281 87.6732L233.229 87.596C232.699 86.812 231.347 84.8105 229.191 83.5617C228.089 82.9234 226.787 82.4891 225.28 82.514C223.773 82.5388 222.007 83.0235 219.977 84.3054C216.004 86.8147 214.095 91.6696 213.247 96.8154C212.403 101.933 212.639 107.14 212.788 110.124L212.717 110.128V298.995C218.779 299.688 223.972 300.802 227.708 302.207C229.641 302.934 231.227 303.755 232.342 304.666C233.45 305.57 234.197 306.652 234.198 307.898V307.899V312.821V313.031L234.089 313.21L233.45 312.821C234.089 313.21 234.088 313.211 234.088 313.211L234.087 313.213L234.084 313.217L234.078 313.228L234.07 313.24L234.057 313.26C234.04 313.286 234.016 313.322 233.984 313.367C233.922 313.456 233.83 313.58 233.705 313.734C233.455 314.043 233.072 314.471 232.525 314.978C231.429 315.993 229.677 317.32 227.012 318.638C221.684 321.274 212.725 323.863 198.093 323.863C183.461 323.863 174.502 321.274 169.174 318.638C166.509 317.32 164.757 315.993 163.662 314.978C163.114 314.471 162.731 314.043 162.481 313.734C162.356 313.58 162.264 313.456 162.202 313.367C162.17 313.322 162.146 313.286 162.129 313.26C162.121 313.247 162.114 313.236 162.108 313.228L162.102 313.217L162.099 313.213L162.098 313.211C162.098 313.211 162.097 313.21 162.736 312.821L162.097 313.21L161.988 313.031V312.821V307.899V307.898H161.988C161.989 306.712 162.667 305.674 163.685 304.799C164.707 303.92 166.159 303.127 167.929 302.42C171.476 301.003 176.469 299.866 182.336 299.13L182.522 300.614C176.719 301.341 171.866 302.458 168.484 303.809C166.79 304.486 165.506 305.205 164.66 305.933C163.809 306.664 163.484 307.326 163.484 307.899C163.484 308.733 164.177 309.799 165.93 310.972C167.635 312.112 170.148 313.218 173.31 314.185C179.627 316.115 188.391 317.445 198.093 317.445C207.795 317.445 216.559 316.115 222.876 314.185C226.038 313.218 228.551 312.112 230.256 310.972C232.009 309.799 232.702 308.733 232.702 307.899C232.702 307.297 232.343 306.597 231.397 305.824C230.458 305.058 229.041 304.306 227.182 303.607C223.636 302.274 218.637 301.187 212.717 300.5V306.107H211.222V110.078H211.289C211.139 107.073 210.91 101.793 211.771 96.572C212.639 91.3082 214.648 85.9026 219.179 83.0409C221.401 81.6374 223.431 81.0487 225.255 81.0186C227.08 80.9885 228.646 81.5177 229.941 82.2676C232.401 83.693 233.918 85.9422 234.457 86.7422L234.519 86.8339C235.013 87.5615 235.579 88.4688 236.019 89.1883C236.24 89.5493 236.431 89.8654 236.566 90.0913L236.661 90.2506L236.724 90.3572L236.767 90.429L236.778 90.4478L236.781 90.4527L236.782 90.454L236.782 90.4543L236.782 90.4544C236.782 90.4544 236.782 90.4545 236.74 90.4789L271.871 157.36C273.927 155.062 278.722 150.274 282.755 147.922C285.029 146.595 287.83 145.944 290.406 145.6C292.414 145.332 294.338 145.244 295.819 145.184L260.397 77.7569L260.37 77.7721L260.37 77.7719L260.369 77.7701L260.364 77.7618L260.344 77.7261C260.325 77.6939 260.297 77.645 260.259 77.5802C260.183 77.4505 260.069 77.2571 259.915 77.0062C259.609 76.5043 259.148 75.7722 258.533 74.8588C257.304 73.0316 255.463 70.4806 253.022 67.5957C250.667 64.813 243.907 59.805 235.152 57.1885ZM296.588 146.649C296.433 146.656 296.271 146.663 296.105 146.669C294.594 146.73 292.65 146.809 290.605 147.082C288.102 147.417 285.531 148.034 283.509 149.214C279.406 151.607 274.344 156.767 272.616 158.778L278.525 170.029L278.547 169.982C278.56 169.953 278.573 169.924 278.587 169.895C279.053 168.921 279.853 167.917 280.885 166.936C282.951 164.97 286.064 162.982 289.73 161.408C293.396 159.834 296.981 158.946 299.83 158.801C301.047 158.739 302.16 158.811 303.099 159.043L296.588 146.649ZM304.305 161.337L304.367 161.457L304.383 161.449C304.419 161.506 304.45 161.564 304.475 161.622C304.645 162.02 304.629 162.576 304.27 163.329C303.911 164.08 303.247 164.939 302.291 165.849C300.383 167.664 297.432 169.563 293.886 171.086C290.339 172.609 286.93 173.44 284.3 173.574C282.982 173.641 281.902 173.53 281.11 173.273C280.316 173.015 279.902 172.644 279.731 172.246C279.561 171.849 279.577 171.293 279.936 170.54C280.295 169.789 280.959 168.929 281.915 168.019C283.823 166.205 286.774 164.305 290.32 162.783C293.867 161.26 297.276 160.428 299.906 160.295C301.224 160.228 302.304 160.338 303.096 160.595C303.696 160.79 304.08 161.05 304.305 161.337ZM231.087 312.215C231.694 311.809 232.242 311.376 232.702 310.92V312.588C232.661 312.643 232.609 312.712 232.543 312.793C232.337 313.047 232.003 313.423 231.508 313.881C230.52 314.796 228.888 316.042 226.349 317.298C221.272 319.809 212.552 322.367 198.093 322.367C183.634 322.367 174.914 319.809 169.837 317.298C167.298 316.042 165.666 314.796 164.678 313.881C164.183 313.423 163.849 313.047 163.643 312.793C163.577 312.712 163.525 312.643 163.484 312.588V310.92C163.944 311.376 164.492 311.809 165.099 312.215C166.972 313.468 169.638 314.626 172.873 315.615C179.354 317.596 188.268 318.941 198.093 318.941C207.918 318.941 216.832 317.596 223.313 315.615C226.548 314.626 229.214 313.468 231.087 312.215ZM197.648 308.942C193.736 308.942 190.219 308.544 187.702 307.915C186.438 307.599 185.468 307.235 184.832 306.859C184.146 306.453 184.074 306.176 184.074 306.109H182.578C182.578 307.031 183.307 307.695 184.071 308.146C184.884 308.627 186.012 309.034 187.339 309.366C190.006 310.033 193.65 310.437 197.648 310.437C201.645 310.437 205.29 310.033 207.956 309.366C209.284 309.034 210.411 308.627 211.225 308.146C211.988 307.695 212.717 307.031 212.717 306.109H211.222C211.222 306.176 211.15 306.453 210.464 306.859C209.828 307.235 208.858 307.599 207.593 307.915C205.077 308.544 201.56 308.942 197.648 308.942ZM282.855 170.198C282.517 170.693 282.577 170.883 282.582 170.893C282.586 170.904 282.682 171.078 283.274 171.175C283.824 171.264 284.612 171.25 285.605 171.107C287.58 170.824 290.194 170.061 292.964 168.871C295.734 167.682 298.088 166.312 299.653 165.075C300.44 164.453 300.993 163.892 301.307 163.431C301.645 162.936 301.585 162.747 301.58 162.736C301.575 162.725 301.479 162.551 300.888 162.455C300.338 162.365 299.55 162.38 298.557 162.522C296.582 162.805 293.968 163.569 291.198 164.758C288.427 165.948 286.074 167.317 284.509 168.554C283.722 169.176 283.168 169.737 282.855 170.198ZM283.581 167.381C285.276 166.041 287.752 164.61 290.608 163.384C293.463 162.158 296.206 161.348 298.344 161.042C299.408 160.889 300.365 160.854 301.128 160.979C301.849 161.096 302.633 161.399 302.954 162.146C303.275 162.893 302.954 163.67 302.543 164.274C302.108 164.912 301.423 165.583 300.58 166.249C298.885 167.588 296.409 169.02 293.554 170.246C290.699 171.472 287.956 172.281 285.817 172.588C284.754 172.74 283.796 172.775 283.033 172.651C282.312 172.533 281.528 172.23 281.208 171.484C280.887 170.737 281.207 169.959 281.619 169.356C282.054 168.717 282.738 168.047 283.581 167.381ZM181.386 262.694C181.386 262.365 181.653 262.099 181.981 262.099C182.31 262.099 182.576 262.365 182.576 262.694V280.596C182.576 280.925 182.31 281.191 181.981 281.191C181.653 281.191 181.386 280.925 181.386 280.596V262.694ZM181.981 245.99C181.653 245.99 181.386 246.256 181.386 246.584V249.27C181.386 249.598 181.653 249.865 181.981 249.865C182.31 249.865 182.576 249.598 182.576 249.27V246.584C182.576 246.256 182.31 245.99 181.981 245.99Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                filter: "url(#filter1_d_378_73463)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    "fill-rule": "evenodd",
                    "clip-rule": "evenodd",
                    d: "M73.0586 252.779C73.0586 252.779 78.2931 246.797 93.9968 246.797C109.7 246.797 114.935 252.779 114.935 252.779V323.026C127.298 326.096 131.385 331.297 131.385 331.297V338.775C131.385 338.775 123.16 351.488 94.7434 351.488C66.3273 351.488 58.1016 338.775 58.1016 338.775V331.297C58.1016 331.297 61.857 326.518 73.0586 323.417V271.429L26.6953 282.688V267.733L73.0586 257.798V252.779Z",
                    fill: "white",
                    "fill-opacity": "0.25",
                    "shape-rendering": "crispEdges"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M73.4681 256.397V253.913C74.1289 254.451 75.0586 255.095 76.32 255.745L73.4681 256.397ZM71.9725 256.739V252.185V251.891L72.1723 251.676L72.6886 252.155C72.1724 251.676 72.1727 251.675 72.1731 251.675L72.174 251.674L72.1762 251.671L72.1823 251.665L72.201 251.646C72.2165 251.63 72.2378 251.608 72.2651 251.581C72.3198 251.527 72.3986 251.452 72.5025 251.36C72.7103 251.174 73.0185 250.916 73.435 250.614C74.2682 250.01 75.5337 249.226 77.2943 248.476C80.8189 246.973 86.3052 245.614 94.2457 246.067C102.144 246.519 107.586 247.874 111.072 249.131C112.815 249.76 114.067 250.363 114.892 250.816C115.304 251.042 115.609 251.23 115.815 251.365C115.917 251.432 115.996 251.486 116.05 251.524C116.077 251.544 116.098 251.559 116.113 251.57L116.132 251.584L116.138 251.589L116.14 251.591L116.141 251.591C116.141 251.592 116.142 251.592 115.686 252.185L116.142 251.592L116.434 251.816V252.185V259.343H116.434V265.609V265.803L116.434 265.805V322.529C120.813 323.494 124.485 324.75 127.112 326.226C129.802 327.737 131.648 329.626 131.648 331.866C131.648 332.161 131.615 332.453 131.552 332.742H131.648V338.823V339.002L131.568 339.161L130.9 338.823C131.568 339.161 131.567 339.161 131.567 339.162L131.566 339.164L131.564 339.168L131.558 339.18L131.547 339.2L131.538 339.217C131.529 339.234 131.517 339.255 131.503 339.28C131.492 339.299 131.48 339.32 131.467 339.343C131.405 339.45 131.313 339.6 131.186 339.787C130.934 340.162 130.546 340.686 129.987 341.309C128.87 342.556 127.077 344.194 124.342 345.824C118.871 349.084 109.67 352.287 94.6482 352.287C79.6267 352.287 70.4256 349.084 64.954 345.824C62.2197 344.194 60.4263 342.556 59.3091 341.309C58.7508 340.686 58.3623 340.162 58.11 339.787C57.9838 339.6 57.8918 339.45 57.8296 339.343C57.7986 339.29 57.775 339.247 57.7583 339.217L57.7475 339.197L57.7385 339.18L57.7323 339.168L57.7302 339.164L57.7293 339.162C57.729 339.161 57.7287 339.161 58.3961 338.823L57.7287 339.161L57.6483 339.002V338.823V332.742H57.7406C57.6798 332.453 57.6483 332.161 57.6483 331.866C57.6483 329.697 59.3794 327.859 61.9164 326.379C64.3867 324.938 67.8412 323.7 71.9725 322.732V272.014L26.9342 283.606L26 283.847L26 282.882L26 267.847L26 267.251L26.5811 267.118L71.9725 256.739ZM73.4681 271.629V322.704C73.4964 322.753 73.5325 322.812 73.5769 322.882C73.7178 323.103 73.9419 323.429 74.2646 323.824C74.9097 324.614 75.9496 325.683 77.5085 326.758C80.6185 328.903 85.8386 331.102 94.203 331.102C102.584 331.102 107.814 329.119 110.928 327.186C112.487 326.218 113.525 325.257 114.167 324.55C114.488 324.196 114.71 323.905 114.849 323.708C114.884 323.659 114.913 323.616 114.938 323.579V267.729C114.209 268.474 113.162 269.376 111.717 270.273C108.341 272.368 102.831 274.413 94.2038 274.413C86.4528 274.413 81.2112 272.582 77.7729 270.521L77.6998 270.54L73.4681 271.629ZM78.2682 269.071C81.4425 271.044 86.483 272.918 94.2038 272.918C102.584 272.918 107.815 270.934 110.929 269.002C112.488 268.034 113.526 267.073 114.168 266.366C114.489 266.012 114.711 265.721 114.85 265.524C114.884 265.476 114.914 265.433 114.938 265.396V254.426C114.202 254.969 113.126 255.634 111.622 256.293C108.266 257.763 102.79 259.199 94.203 259.199C86.8728 259.199 81.8042 258.037 78.3848 256.68L78.2682 269.071ZM74.1744 252.554C74.0312 252.43 73.9081 252.317 73.8037 252.216C73.9445 252.101 74.114 251.969 74.3134 251.825C75.0606 251.282 76.2287 250.556 77.8807 249.851C81.1813 248.445 86.4363 247.119 94.1604 247.56C101.926 248.004 107.225 249.334 110.565 250.538C112.235 251.141 113.416 251.712 114.172 252.127C114.471 252.291 114.703 252.43 114.873 252.537C114.737 252.669 114.537 252.849 114.262 253.063C113.626 253.557 112.589 254.236 111.022 254.923C107.889 256.295 102.624 257.703 94.203 257.703C85.7928 257.703 80.5375 256.141 77.4113 254.619C75.8474 253.858 74.8108 253.104 74.1744 252.554ZM116.434 330.059V324.062C120.59 324.998 123.991 326.188 126.38 327.53C128.996 328.999 130.152 330.505 130.152 331.866C130.152 332.991 129.345 334.32 127.524 335.728C125.732 337.113 123.101 338.46 119.807 339.639C113.225 341.994 104.137 343.631 94.2006 343.631C84.2644 343.631 75.4031 341.995 69.05 339.642C65.87 338.464 63.3527 337.12 61.6455 335.738C59.9158 334.339 59.1439 333.008 59.1439 331.866C59.1439 330.551 60.222 329.099 62.6701 327.671C64.8989 326.37 68.0748 325.206 71.9725 324.269V329.164V329.341L72.0515 329.499L72.7203 329.164C72.0515 329.499 72.0517 329.499 72.052 329.5L72.0527 329.501L72.0543 329.504L72.0588 329.513L72.0731 329.54C72.085 329.563 72.1016 329.593 72.1232 329.632C72.1664 329.708 72.2296 329.816 72.3148 329.95C72.4851 330.218 72.7436 330.592 73.1062 331.036C73.8317 331.924 74.9736 333.093 76.6595 334.255C80.039 336.586 85.5604 338.863 94.203 338.863C102.83 338.863 108.34 336.818 111.716 334.723C113.402 333.676 114.546 332.624 115.274 331.82C115.639 331.419 115.899 331.08 116.071 330.837C116.157 330.715 116.221 330.617 116.265 330.546C116.287 330.511 116.304 330.483 116.317 330.462L116.331 330.436L116.336 330.428L116.338 330.425L116.339 330.423C116.339 330.423 116.339 330.422 115.686 330.059L116.339 330.422L116.434 330.253V330.059ZM73.4681 328.97V325.196C74.1931 326.015 75.231 327.004 76.6595 327.99C80.039 330.32 85.5604 332.597 94.203 332.597C102.83 332.597 108.34 330.553 111.716 328.457C113.162 327.56 114.209 326.657 114.938 325.912V329.845L114.909 329.888L114.884 329.924C114.873 329.94 114.862 329.957 114.849 329.974C114.71 330.171 114.488 330.462 114.167 330.815C113.525 331.523 112.487 332.484 110.928 333.452C107.814 335.384 102.584 337.367 94.203 337.367C85.8386 337.367 80.6185 335.169 77.5085 333.024C75.9496 331.949 74.9097 330.88 74.2646 330.09C73.9419 329.695 73.7178 329.369 73.5769 329.148C73.5325 329.078 73.4964 329.018 73.4681 328.97ZM128.439 336.911C129.093 336.405 129.672 335.874 130.152 335.321V338.627C130.106 338.706 130.037 338.816 129.946 338.952C129.73 339.273 129.384 339.742 128.873 340.311C127.854 341.449 126.177 342.989 123.577 344.539C118.379 347.636 109.454 350.792 94.6482 350.792C79.842 350.792 70.9171 347.636 65.7196 344.539C63.1192 342.989 61.4423 341.449 60.4229 340.311C59.9128 339.742 59.5664 339.273 59.3509 338.952C59.259 338.816 59.1908 338.706 59.1439 338.627V335.399C59.5854 335.919 60.1116 336.421 60.7046 336.901C62.5824 338.421 65.2622 339.834 68.5306 341.044C75.0745 343.468 84.1153 345.127 94.2006 345.127C104.286 345.127 113.547 343.468 120.31 341.047C123.688 339.838 126.478 338.427 128.439 336.911ZM27.4956 281.917V268.443L76.8847 257.15L76.771 269.234L27.4956 281.917Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                filter: "url(#filter2_d_378_73463)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    "fill-rule": "evenodd",
                    "clip-rule": "evenodd",
                    d: "M311.823 223.884V275.508C322.776 277.493 325.282 280.715 325.282 280.715L326.03 290.436C326.03 290.436 320.047 301.279 292.005 301.279C263.963 301.279 257.98 291.184 257.98 291.184V282.958C257.98 282.958 260.712 278.276 272.938 275.676V211.637C272.938 211.637 275.181 202.195 292.38 202.195C309.579 202.195 311.823 211.637 311.823 211.637V211.919L348.462 200.703V212.668L311.823 223.884Z",
                    fill: "white",
                    "fill-opacity": "0.25",
                    "shape-rendering": "crispEdges"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M349.957 199.89V198.882L348.992 199.175L312.294 210.308L312.279 210.271C312.251 210.202 312.209 210.108 312.152 209.992C312.037 209.76 311.856 209.444 311.586 209.07C311.043 208.32 310.144 207.349 308.693 206.376C305.789 204.43 300.717 202.504 291.944 202.278C283.154 202.051 278.059 203.977 275.14 206.052C273.682 207.088 272.783 208.15 272.244 208.972C271.975 209.382 271.797 209.73 271.684 209.984C271.627 210.11 271.587 210.213 271.56 210.288C271.546 210.325 271.536 210.356 271.528 210.379L271.519 210.408L271.516 210.418L271.515 210.422L271.515 210.423C271.514 210.424 271.514 210.425 272.231 210.634L271.514 210.425L271.484 210.527V210.634V274.585C267.372 275.511 263.92 276.717 261.446 278.136C258.907 279.593 257.16 281.418 257.16 283.581C257.16 283.734 257.169 283.886 257.186 284.035H257.16V289.853C257.16 291.73 258.317 293.395 260.122 294.799C261.937 296.21 264.516 297.449 267.637 298.476C273.886 300.531 282.472 301.79 291.922 301.79C301.372 301.79 309.958 300.531 316.208 298.476C319.328 297.449 321.908 296.21 323.723 294.799C325.528 293.395 326.684 291.73 326.684 289.853V283.581V283.14H326.66C326.441 281.169 324.763 279.493 322.398 278.136C319.926 276.718 316.476 275.512 312.365 274.586V224.609L349.43 213.136L349.957 212.973V212.422V199.89ZM325.189 283.581C325.189 282.281 324.108 280.841 321.654 279.433C319.422 278.153 316.247 277.017 312.365 276.12V284.928V285.248L312.133 285.469L311.617 284.928C312.133 285.469 312.133 285.47 312.133 285.47L312.132 285.471L312.129 285.473L312.123 285.479L312.106 285.495L312.09 285.509L312.076 285.521L312.049 285.545C312.002 285.586 311.934 285.642 311.845 285.711C311.667 285.849 311.404 286.039 311.045 286.262C310.327 286.71 309.226 287.291 307.655 287.868C304.513 289.021 299.501 290.152 291.925 290.152C284.348 290.152 279.336 289.021 276.194 287.868C274.624 287.291 273.522 286.71 272.804 286.262C272.445 286.039 272.182 285.849 272.004 285.711C271.915 285.642 271.848 285.586 271.8 285.545C271.776 285.524 271.757 285.507 271.743 285.495L271.726 285.479L271.72 285.473L271.718 285.471L271.717 285.47C271.716 285.47 271.716 285.469 272.232 284.928L271.716 285.469L271.484 285.248V284.928V276.119C267.6 277.016 264.423 278.153 262.191 279.433C259.736 280.841 258.656 282.281 258.656 283.581C258.656 284.643 259.37 285.802 261.016 286.98C262.644 288.145 265.049 289.225 268.087 290.144C274.155 291.981 282.582 293.127 291.922 293.127C301.263 293.127 309.69 291.981 315.757 290.144C318.796 289.225 321.2 288.145 322.828 286.98C324.475 285.802 325.189 284.643 325.189 283.581ZM325.189 286.913C324.763 287.366 324.261 287.794 323.699 288.196C321.884 289.494 319.308 290.632 316.191 291.576C309.947 293.465 301.367 294.623 291.922 294.623C282.477 294.623 273.897 293.465 267.654 291.576C264.537 290.632 261.96 289.494 260.146 288.196C259.584 287.794 259.081 287.366 258.656 286.913V289.853C258.656 291.067 259.403 292.345 261.04 293.618C262.668 294.884 265.069 296.057 268.104 297.055C274.166 299.049 282.587 300.295 291.922 300.295C301.258 300.295 309.679 299.049 315.74 297.055C318.775 296.057 321.177 294.884 322.804 293.618C324.442 292.345 325.189 291.067 325.189 289.853V286.913ZM312.365 223.043L348.461 211.87V200.898L312.365 211.849V223.043ZM309.59 212.677L309.594 212.69L310.869 212.303V223.694C310.732 223.791 310.535 223.922 310.272 224.076C309.641 224.446 308.631 224.953 307.153 225.465C304.195 226.489 299.357 227.534 291.925 227.534C284.493 227.534 279.654 226.489 276.697 225.465C275.218 224.953 274.208 224.446 273.578 224.076C273.315 223.922 273.118 223.791 272.98 223.694V212.028C273.698 212.436 274.75 212.944 276.207 213.449C279.345 214.535 284.353 215.6 291.925 215.6C299.497 215.6 304.504 214.535 307.642 213.449C308.396 213.188 309.043 212.925 309.59 212.677ZM272.98 225.458V279.444C273.118 279.541 273.315 279.672 273.578 279.826C274.208 280.196 275.218 280.703 276.697 281.215C279.654 282.239 284.493 283.284 291.925 283.284C299.357 283.284 304.195 282.239 307.153 281.215C308.631 280.703 309.641 280.196 310.272 279.826C310.535 279.672 310.732 279.541 310.869 279.444V225.458C310.152 225.866 309.099 226.374 307.642 226.878C304.504 227.965 299.497 229.029 291.925 229.029C284.353 229.029 279.345 227.965 276.207 226.878C274.75 226.374 273.698 225.866 272.98 225.458ZM310.272 210.647C310.428 210.555 310.561 210.472 310.672 210.399C310.595 210.269 310.497 210.117 310.374 209.946C309.934 209.339 309.163 208.492 307.86 207.619C305.254 205.872 300.481 203.994 291.905 203.773C283.347 203.552 278.596 205.431 276.006 207.271C274.709 208.193 273.938 209.117 273.495 209.792C273.346 210.019 273.234 210.219 273.151 210.381C273.267 210.458 273.409 210.548 273.578 210.647C274.208 211.017 275.218 211.524 276.697 212.035C279.654 213.059 284.493 214.104 291.925 214.104C299.357 214.104 304.195 213.059 307.153 212.035C308.631 211.524 309.641 211.017 310.272 210.647ZM272.98 284.575V281.208C273.698 281.616 274.75 282.124 276.207 282.628C279.345 283.715 284.353 284.779 291.925 284.779C299.497 284.779 304.504 283.715 307.642 282.628C309.099 282.124 310.152 281.616 310.869 281.208V284.575C310.731 284.679 310.529 284.822 310.255 284.993C309.625 285.385 308.616 285.922 307.14 286.464C304.186 287.548 299.352 288.656 291.925 288.656C284.497 288.656 279.663 287.548 276.71 286.464C275.233 285.922 274.224 285.385 273.594 284.993C273.321 284.822 273.118 284.679 272.98 284.575Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("filter", {
                        id: "filter0_d_378_73463",
                        x: "102.704",
                        y: "0.869857",
                        width: "262.475",
                        height: "387.392",
                        filterUnits: "userSpaceOnUse",
                        "color-interpolation-filters": "sRGB",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feFlood", {
                                "flood-opacity": "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feOffset", {
                                dy: "5.98234"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feGaussianBlur", {
                                stdDeviation: "29.9117"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "out"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                                mode: "normal",
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_378_73463"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_378_73463",
                                result: "shape"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("filter", {
                        id: "filter1_d_378_73463",
                        x: "-33.1281",
                        y: "192.956",
                        width: "224.338",
                        height: "224.337",
                        filterUnits: "userSpaceOnUse",
                        "color-interpolation-filters": "sRGB",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feFlood", {
                                "flood-opacity": "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feOffset", {
                                dy: "5.98234"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feGaussianBlur", {
                                stdDeviation: "29.9117"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "out"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                                mode: "normal",
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_378_73463"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_378_73463",
                                result: "shape"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("filter", {
                        id: "filter2_d_378_73463",
                        x: "198.157",
                        y: "146.862",
                        width: "210.127",
                        height: "220.223",
                        filterUnits: "userSpaceOnUse",
                        "color-interpolation-filters": "sRGB",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feFlood", {
                                "flood-opacity": "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feOffset", {
                                dy: "5.98234"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feGaussianBlur", {
                                stdDeviation: "29.9117"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "out"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                                mode: "normal",
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_378_73463"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_378_73463",
                                result: "shape"
                            })
                        ]
                    })
                ]
            })
        ]
    });
const CaptureIcon = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "84",
        height: "84",
        viewBox: "0 0 84 84",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "42",
                cy: "42",
                r: "35",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "42",
                cy: "42",
                r: "40.5",
                stroke: "white",
                "stroke-width": "3"
            })
        ]
    });
const InfoIcon = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "50",
        height: "50",
        viewBox: "0 0 50 50",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M25 50C38.8071 50 50 38.8071 50 25C50 11.1929 38.8071 0 25 0C11.1929 0 0 11.1929 0 25C0 38.8071 11.1929 50 25 50Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M25.8865 20.02V18.148H24.3565V20.02H25.8865Z",
                fill: "#E6E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M25.8865 31V21.694H24.3565V31H25.8865Z",
                fill: "#E6E6E6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M25 10C33.2843 10 40 16.7157 40 25C40 33.2843 33.2843 40 25 40C16.7157 40 10 33.2843 10 25C10 16.7157 16.7157 10 25 10ZM25 11C17.268 11 11 17.268 11 25C11 32.732 17.268 39 25 39C32.732 39 39 32.732 39 25C39 17.268 32.732 11 25 11Z",
                fill: "#E6E6E6"
            })
        ]
    });
const UploadIcon = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "50",
        height: "50",
        viewBox: "0 0 50 50",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M25 50C38.8071 50 50 38.8071 50 25C50 11.1929 38.8071 0 25 0C11.1929 0 0 11.1929 0 25C0 38.8071 11.1929 50 25 50Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                mask: "url(#mask0_413_92298)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M21.3059 27.3381H32.08L28.7341 22.8622L25.5656 26.8447L23.5194 24.4231L21.3059 27.3381ZM17.7403 31.6347V13.75H35.625V31.6347H17.7403ZM18.7981 30.5769H34.5672V14.8078H18.7981V30.5769ZM14.375 35V17.8847H15.4328V33.9422H31.4903V35H14.375Z",
                    fill: "#E6E6E6"
                })
            })
        ]
    });
const GuideFaucet = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "guide",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GuideFaucetsOverlay, {})
    });
const GuideValve = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "guide",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GuideValveImage, {})
    });
const GuideEmpty = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "guide"
    });

;// CONCATENATED MODULE: ./components/VisualSearch/v1/CameraView/utils.js


const getGuide = (category, content)=>{
    const { faucetGuide , toiletGuide , volveGuide , defaultGuide  } = content;
    switch(category){
        case "Faucets":
            return {
                image: /*#__PURE__*/ (0,jsx_runtime.jsx)(GuideFaucet, {}),
                text: faucetGuide
            };
        case "Toilet":
            return {
                image: /*#__PURE__*/ (0,jsx_runtime.jsx)(GuideEmpty, {}),
                text: toiletGuide
            };
        case "Valve":
            return {
                image: /*#__PURE__*/ (0,jsx_runtime.jsx)(GuideValve, {}),
                text: volveGuide
            };
        case "Shower":
            return {
                image: /*#__PURE__*/ (0,jsx_runtime.jsx)(GuideEmpty, {}),
                text: defaultGuide
            };
        default:
            return {
                image: /*#__PURE__*/ (0,jsx_runtime.jsx)(GuideEmpty, {}),
                text: defaultGuide
            };
    }
};

;// CONCATENATED MODULE: ./components/VisualSearch/v1/CameraView/index.jsx











const CameraView = (props)=>{
    const { setImage =()=>{} , back =()=>{} , category ="" , setOpenCam =()=>{} , setSection =()=>{} , setEventType =()=>{}  } = props;
    const [captureTrigger, setCaptureTrigger] = (0,react.useState)(false);
    const [showInfo, setShowInfo] = (0,react.useState)(false);
    const { t  } = (0,esm/* useTranslation */.$G)();
    const data = localization_getTranslations(t);
    const { image , text  } = getGuide(category, data);
    const processImage = (input)=>{
        setImage(input);
    };
    const handlesetResult = async (event)=>{
        if (event === null || event === void 0 ? void 0 : event.target) {
            const file = event.target.files[0];
            const resp = await validateImageFileAsync(file);
            setEventType("browse");
            addDataLayerVisualSearch({
                eventKey: "browse",
                category: category,
                eventStatus: "interaction"
            });
            if (resp) {
                setImage(resp);
            } else {
                setSection("error");
            }
        }
    };
    return showInfo ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CameraView_GuildePageMobile, {
        category: category,
        setShowInfo: setShowInfo,
        setSection: setSection
    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (cameraview_module_default()).CameraView,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                className: "back-button",
                onClick: ()=>{
                    back();
                    setOpenCam(false);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CameraView_Camera, {
                handlerResult: processImage,
                captureTrigger: captureTrigger,
                setCaptureTrigger: setCaptureTrigger
            }),
            image,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "guide-text-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "guide-text",
                    children: text
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "button-group",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        onClick: ()=>{
                            document.querySelector("#upload-input").click();
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                id: "upload-input",
                                className: "upload-input",
                                type: "file",
                                onChange: handlesetResult,
                                hidden: "true"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(UploadIcon, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        onClick: ()=>{
                            setCaptureTrigger(true);
                            setEventType("capture");
                            addDataLayerVisualSearch({
                                eventKey: "capture",
                                category: category,
                                eventStatus: "interaction"
                            });
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CaptureIcon, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        onClick: ()=>setShowInfo(true),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoIcon, {})
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var v1_CameraView = (CameraView);

// EXTERNAL MODULE: ./components/VisualSearch/v1/ComingSoon/comingSoon.module.scss
var comingSoon_module = __webpack_require__(53163);
var comingSoon_module_default = /*#__PURE__*/__webpack_require__.n(comingSoon_module);
;// CONCATENATED MODULE: ./components/VisualSearch/v1/ComingSoon/utils.js

const getCategoryURL = (category)=>{
    var ref;
    const PRODUCT_FAQ_URL = (window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : ref.origin) + constants.HELP_AND_FAQ_SUPPORT;
    switch(category === null || category === void 0 ? void 0 : category.toLowerCase()){
        case "sink":
            return "".concat(PRODUCT_FAQ_URL, "/identifying-your-sink-model");
        case "bath":
            return "".concat(PRODUCT_FAQ_URL, "/identifying-your-bath-or-whirlpool-model");
        case "shower door":
            return "".concat(PRODUCT_FAQ_URL, "/identifying-your-shower-door-model");
        case "toilet seat":
            return "".concat(PRODUCT_FAQ_URL, "/identifying-your-toilet-seat-model");
    }
};

;// CONCATENATED MODULE: ./components/VisualSearch/v1/ComingSoon/index.jsx






const ComingSoon = (props)=>{
    const { setSection , category  } = props;
    const categorySelected = category === null || category === void 0 ? void 0 : category.toLowerCase();
    const { t  } = (0,esm/* useTranslation */.$G)();
    const { recognitionCategory =()=>{} , recognitionCategorySubText =()=>{} , viewGuidtext , backOnCategory , commingSoon  } = localization_getTranslations(t);
    const viewGuide = ()=>{
        const supportUrl = getCategoryURL(category);
        window.open(supportUrl, "_blank");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (comingSoon_module_default()).ComingSoonContainer,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "para-section",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "working-para",
                    children: commingSoon
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "button-section",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "para-two-section",
                            children: [
                                recognitionCategory(categorySelected),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "secong-line",
                                    children: recognitionCategorySubText(categorySelected)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            type: "button",
                            className: "view-button",
                            onClick: viewGuide,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "button-label",
                                children: viewGuidtext
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    className: "back-button",
                    onClick: ()=>setSection("category"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: backOnCategory
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var v1_ComingSoon = (ComingSoon);

// EXTERNAL MODULE: ./components/VisualSearch/v1/ErrorFallBack/index.module.scss
var ErrorFallBack_index_module = __webpack_require__(16899);
var ErrorFallBack_index_module_default = /*#__PURE__*/__webpack_require__.n(ErrorFallBack_index_module);
;// CONCATENATED MODULE: ./components/VisualSearch/v1/ErrorFallBack/index.js







const ErrorFallBack = (props)=>{
    const { setSection , setOpenCam , category  } = props;
    const { t  } = (0,esm/* useTranslation */.$G)();
    const { errorText , tryAgainBtn , errorSubText  } = localization_getTranslations(t);
    (0,react.useEffect)(()=>{
        setOpenCam(false);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (ErrorFallBack_index_module_default()).ErrorContainer,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "error-section",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "sorry-section",
                    children: errorText
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "try-section",
                    children: (0,helper/* sanitizeInnerHtml */.KD0)(errorSubText)
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    className: "back-button",
                    onClick: ()=>{
                        setSection("category");
                        addDataLayerVisualSearch({
                            eventKey: "try again",
                            category
                        });
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: tryAgainBtn
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var v1_ErrorFallBack = (ErrorFallBack);

// EXTERNAL MODULE: ./components/VisualSearch/v1/visualsearch.module.scss
var visualsearch_module = __webpack_require__(26657);
var visualsearch_module_default = /*#__PURE__*/__webpack_require__.n(visualsearch_module);
;// CONCATENATED MODULE: ./components/VisualSearch/v1/index.jsx












const VisualSearch = (props)=>{
    const { showVisualSearch =false  } = props;
    const [category, setCategory] = (0,react.useState)(null);
    const [section, setSection] = (0,react.useState)("category");
    const [image, setImage] = (0,react.useState)(null);
    const [openCam, setOpenCam] = (0,react.useState)(false);
    const [eventType, setEventType] = (0,react.useState)(null);
    const device = (0,useViewport/* default */.Z)();
    (0,react.useEffect)(()=>{
        if (showVisualSearch === true) {
            var ref, ref1;
            (ref = document.querySelector("mavenoid-assistant")) === null || ref === void 0 ? void 0 : (ref1 = ref.classList) === null || ref1 === void 0 ? void 0 : ref1.add("mavenoid-active");
        } else {
            var ref2, ref3;
            (ref2 = document.querySelector("mavenoid-assistant")) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.classList) === null || ref3 === void 0 ? void 0 : ref3.remove("mavenoid-active");
        }
    }, [
        showVisualSearch
    ]);
    (0,react.useEffect)(()=>{
        if (image != null) setSection("loading");
    }, [
        image
    ]);
    (0,react.useEffect)(()=>{
        const inpageSearch = (device === null || device === void 0 ? void 0 : device.isExtraSmallScreen) ? document.querySelector(".kf-react-button") : document.querySelector(".inpage-search__header-section");
        if (openCam && (device === null || device === void 0 ? void 0 : device.isSmallScreen)) {
            document.body.style.overflow = "hidden";
            inpageSearch.scrollIntoView({
                behavior: "smooth"
            });
        } else {
            document.body.style.overflow = "";
        }
        return ()=>{
            document.body.style.overflow = "";
        };
    }, [
        openCam
    ]);
    const updateCategoryItems = (input)=>{
        var ref, ref1;
        setCategory((ref = input[0]) === null || ref === void 0 ? void 0 : ref.category);
        if ((input === null || input === void 0 ? void 0 : (ref1 = input[0]) === null || ref1 === void 0 ? void 0 : ref1.comingSoon) === true) {
            setSection("comingSoon");
            setOpenCam(false);
        } else {
            setSection("upload");
        }
    };
    const selectSection = ()=>{
        switch(section){
            case "category":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_SelectProductCategory, {
                    updateCategoryItems: updateCategoryItems,
                    setOpenCam: setOpenCam
                });
            case "comingSoon":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_ComingSoon, {
                    category: category,
                    setSection: setSection
                });
            case "error":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_ErrorFallBack, {
                    setSection: setSection,
                    category: category,
                    setOpenCam: setOpenCam
                });
            case "upload":
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* BrowserView */.I3, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_UploadImage, {
                                setEventType: setEventType,
                                setImage: setImage,
                                category: category,
                                setSection: setSection
                            })
                        }),
                        (device === null || device === void 0 ? void 0 : device.isSmallTabView) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mobile-container",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_CameraView, {
                                setImage: setImage,
                                setEventType: setEventType,
                                back: ()=>setSection("category"),
                                category: category,
                                setOpenCam: setOpenCam,
                                setSection: setSection
                            })
                        }) : null
                    ]
                });
            case "loading":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_LoadingData, {
                    setSection: setSection,
                    image: image,
                    category: category,
                    setOpenCam: setOpenCam,
                    eventType: eventType
                });
            default:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_SelectProductCategory, {
                    updateCategoryItems: updateCategoryItems,
                    setOpenCam: setOpenCam
                });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (visualsearch_module_default()).VisualSearchContainer,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((dist_default()), {
            open: showVisualSearch,
            children: selectSection()
        })
    });
};
/* harmony default export */ var v1 = (VisualSearch);

;// CONCATENATED MODULE: ./components/InPageSearch/v1/icons.js

const VisualSearchIconDesktop = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "60",
        height: "60",
        viewBox: "0 0 60 60",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
            id: "center_focus_weak",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                    id: "mask0_381_122521",
                    maskUnits: "userSpaceOnUse",
                    x: "0",
                    y: "0",
                    width: "60",
                    height: "60",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        id: "Bounding box",
                        width: "60",
                        height: "60",
                        fill: "#D9D9D9"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                    mask: "url(#mask0_381_122521)",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        id: "center_focus_weak_2",
                        d: "M10 50V37.7113H11.9231V48.0769H22.2888V50H10ZM37.7113 50V48.0769H48.0769V37.7113H50V50H37.7113ZM10 22.2888V10H22.2888V11.9231H11.9231V22.2888H10ZM48.0769 22.2888V11.9231H37.7113V10H50V22.2888H48.0769ZM30 37.0144C27.9983 37.0144 26.329 36.3456 24.9919 35.0081C23.6544 33.671 22.9856 32.0017 22.9856 30C22.9856 27.9983 23.6544 26.329 24.9919 24.9919C26.329 23.6544 27.9983 22.9856 30 22.9856C32.0017 22.9856 33.671 23.6544 35.0081 24.9919C36.3456 26.329 37.0144 27.9983 37.0144 30C37.0144 32.0017 36.3456 33.671 35.0081 35.0081C33.671 36.3456 32.0017 37.0144 30 37.0144ZM29.9937 35.0912C31.4242 35.0912 32.6315 34.6013 33.6156 33.6213C34.5994 32.6413 35.0913 31.4363 35.0913 30.0063C35.0913 28.5758 34.6013 27.3685 33.6213 26.3844C32.6413 25.4006 31.4363 24.9087 30.0063 24.9087C28.5758 24.9087 27.3685 25.3987 26.3844 26.3787C25.4006 27.3587 24.9088 28.5637 24.9088 29.9937C24.9088 31.4242 25.3987 32.6315 26.3787 33.6156C27.3587 34.5994 28.5637 35.0912 29.9937 35.0912Z",
                        fill: "#757575"
                    })
                })
            ]
        })
    });
const VisualSearchIconMobile = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "35",
        height: "36",
        viewBox: "0 0 35 36",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                id: "mask0_242_37200",
                maskUnits: "userSpaceOnUse",
                x: "0",
                y: "0",
                width: "35",
                height: "36",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                    y: "0.5",
                    width: "35",
                    height: "35",
                    fill: "#D9D9D9"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                mask: "url(#mask0_242_37200)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M5.83337 29.6654V22.4969H6.9552V28.5435H13.0018V29.6654H5.83337ZM21.9983 29.6654V28.5435H28.0449V22.4969H29.1667V29.6654H21.9983ZM5.83337 13.5005V6.33203H13.0018V7.45385H6.9552V13.5005H5.83337ZM28.0449 13.5005V7.45385H21.9983V6.33203H29.1667V13.5005H28.0449ZM17.5 22.0904C16.3324 22.0904 15.3586 21.7003 14.5786 20.9201C13.7984 20.1401 13.4083 19.1663 13.4083 17.9987C13.4083 16.8311 13.7984 15.8573 14.5786 15.0773C15.3586 14.2971 16.3324 13.907 17.5 13.907C18.6677 13.907 19.6415 14.2971 20.4214 15.0773C21.2017 15.8573 21.5918 16.8311 21.5918 17.9987C21.5918 19.1663 21.2017 20.1401 20.4214 20.9201C19.6415 21.7003 18.6677 22.0904 17.5 22.0904ZM17.4964 20.9686C18.3308 20.9686 19.0351 20.6828 19.6092 20.1111C20.183 19.5394 20.4699 18.8365 20.4699 18.0023C20.4699 17.1679 20.1841 16.4637 19.6124 15.8896C19.0408 15.3157 18.3379 15.0288 17.5037 15.0288C16.6693 15.0288 15.965 15.3146 15.3909 15.8863C14.8171 16.458 14.5301 17.1609 14.5301 17.9951C14.5301 18.8295 14.816 19.5337 15.3876 20.1078C15.9593 20.6817 16.6622 20.9686 17.4964 20.9686Z",
                    fill: "#757575"
                })
            })
        ]
    });
const VisualSearchIcon = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "60",
        height: "60",
        viewBox: "0 0 60 60",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
            id: "Visual Search Icon",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                id: "center_focus_weak",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                        id: "mask0_355_64216",
                        maskUnits: "userSpaceOnUse",
                        x: "0",
                        y: "0",
                        width: "60",
                        height: "60",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                            id: "Bounding box",
                            width: "60",
                            height: "60",
                            fill: "#D9D9D9"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                        mask: "url(#mask0_355_64216)",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            id: "center_focus_weak_2",
                            d: "M10 50V37.7113H11.9231V48.0769H22.2888V50H10ZM37.7113 50V48.0769H48.0769V37.7113H50V50H37.7113ZM10 22.2888V10H22.2888V11.9231H11.9231V22.2888H10ZM48.0769 22.2888V11.9231H37.7113V10H50V22.2888H48.0769ZM30 37.0144C27.9983 37.0144 26.329 36.3456 24.9919 35.0081C23.6544 33.671 22.9856 32.0017 22.9856 30C22.9856 27.9983 23.6544 26.329 24.9919 24.9919C26.329 23.6544 27.9983 22.9856 30 22.9856C32.0017 22.9856 33.671 23.6544 35.0081 24.9919C36.3456 26.329 37.0144 27.9983 37.0144 30C37.0144 32.0017 36.3456 33.671 35.0081 35.0081C33.671 36.3456 32.0017 37.0144 30 37.0144ZM29.9937 35.0912C31.4242 35.0912 32.6315 34.6013 33.6156 33.6213C34.5994 32.6413 35.0913 31.4363 35.0913 30.0063C35.0913 28.5758 34.6013 27.3685 33.6213 26.3844C32.6413 25.4006 31.4363 24.9087 30.0063 24.9087C28.5758 24.9087 27.3685 25.3987 26.3844 26.3787C25.4006 27.3587 24.9088 28.5637 24.9088 29.9937C24.9088 31.4242 25.3987 32.6315 26.3787 33.6156C27.3587 34.5994 28.5637 35.0912 29.9937 35.0912Z",
                            fill: "#212121"
                        })
                    })
                ]
            })
        })
    });
const VisualSearchIconGreyMobile = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "35",
        height: "36",
        viewBox: "0 0 35 36",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                id: "mask0_218_34843",
                maskUnits: "userSpaceOnUse",
                x: "0",
                y: "0",
                width: "35",
                height: "36",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                    y: "0.5",
                    width: "35",
                    height: "35",
                    fill: "#D9D9D9"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                mask: "url(#mask0_218_34843)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M5.83325 29.6654V22.4969H6.95508V28.5435H13.0017V29.6654H5.83325ZM21.9981 29.6654V28.5435H28.0448V22.4969H29.1666V29.6654H21.9981ZM5.83325 13.5005V6.33203H13.0017V7.45385H6.95508V13.5005H5.83325ZM28.0448 13.5005V7.45385H21.9981V6.33203H29.1666V13.5005H28.0448ZM17.4999 22.0904C16.3323 22.0904 15.3585 21.7003 14.5785 20.9201C13.7983 20.1401 13.4082 19.1663 13.4082 17.9987C13.4082 16.8311 13.7983 15.8573 14.5785 15.0773C15.3585 14.2971 16.3323 13.907 17.4999 13.907C18.6676 13.907 19.6414 14.2971 20.4213 15.0773C21.2015 15.8573 21.5916 16.8311 21.5916 17.9987C21.5916 19.1663 21.2015 20.1401 20.4213 20.9201C19.6414 21.7003 18.6676 22.0904 17.4999 22.0904ZM17.4963 20.9686C18.3307 20.9686 19.0349 20.6828 19.609 20.1111C20.1829 19.5394 20.4698 18.8365 20.4698 18.0023C20.4698 17.1679 20.184 16.4637 19.6123 15.8896C19.0406 15.3157 18.3377 15.0288 17.5036 15.0288C16.6692 15.0288 15.9649 15.3146 15.3908 15.8863C14.8169 16.458 14.53 17.1609 14.53 17.9951C14.53 18.8295 14.8159 19.5337 15.3875 20.1078C15.9592 20.6817 16.6621 20.9686 17.4963 20.9686Z",
                    fill: "#212121"
                })
            })
        ]
    });

;// CONCATENATED MODULE: ./components/InPageSearch/v1/InPageSearch.view.jsx





















const InPageSearchView = (props)=>{
    const { bgColor ="" , loading =false , partId ="" , isSkuSearch =false , productId ="" , searchString ="" , pdfPartsDiagram ="" , ctaLink ="" , ctaLabel ="" , type ="" , onChange =()=>{} , title ="" , lwAppName ="" , language ="en" , svgFileMap =[] , searchType ="" , placeholder =""  } = props;
    const device = (0,useViewport/* default */.Z)();
    const { featureFlags  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const { MYSQLCONNSTR_ENABLE_PARTS_VIEWER_V2: isPartsViewerV2Enabled = false , MYSQLCONNSTR_ENABLE_VISUAL_SEARCH_V1: isVisualSearchEnabled = false  } = featureFlags;
    const [width] = (0,useWindowResize/* default */.Z)();
    const isDarkBg = bgColor === "bgDark";
    const [isShowModal, setIsShowModal] = (0,react.useState)(false);
    const [shortenedUrl, setShortenedUrl] = (0,react.useState)(ctaLink);
    const [showVisualSearch, setShowVisualSearch] = (0,react.useState)(false);
    const VSGreyIcon = device.isSmallScreen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(VisualSearchIconGreyMobile, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(VisualSearchIcon, {});
    const VSBlackIcon = device.isSmallScreen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(VisualSearchIconMobile, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(VisualSearchIconDesktop, {});
    const visualSearchIcon = showVisualSearch ? VSGreyIcon : VSBlackIcon;
    (0,react.useEffect)(()=>{
        if (ctaLink) {
            (0,helper/* getShortenedUrl */.Ppy)(ctaLink).then((url)=>setShortenedUrl(url));
        }
    }, [
        ctaLink
    ]);
    const handleKeyPress = (event)=>{
        const { keyCode ="" , key =""  } = event;
        if (keyCode === constants["default"].KEYCODE.ENTER && key === constants["default"].KEY.ENTER) {
            if (searchString !== "" && searchString.length <= 3) {
                location.href = "".concat(shortenedUrl, "?keyword=").concat(searchString).concat(searchType === "parts" ? "&service=true" : "");
            } else {
                const fl = "id,sku_s,slug_s,ProductResource.InteractiveSVG.resourceName_ss,ProductProductNo_s,ProductResource.InteractiveSVG.resourceTitle_ss,ProductResource.PartsPDFFileName.resourceFullWebURL_ss";
                constants_api/* apim.get */.TH.get(constants.inPageSearchEndPoint, {
                    params: {
                        q: searchString,
                        fl,
                        fq: [
                            'Products:("ct")',
                            'language_s:("'.concat(language, '")')
                        ],
                        collections: lwAppName.toLowerCase(),
                        profilename: "profile_".concat(lwAppName.toLowerCase(), "_Search")
                    },
                    paramsSerializer: (params)=>{
                        return lib_default().stringify(params, {
                            arrayFormat: "repeat",
                            encode: false
                        });
                    }
                }).then((res)=>{
                    const { data: { response: { numFound ="" , docs =[]  } = {} , fusion: { exactMatch =""  } = {}  } = {}  } = res;
                    if (numFound === 1 && exactMatch) {
                        const mResources = get_default()(docs[0], "ProductResource.InteractiveSVG.resourceName_ss", "");
                        const partId = Array.isArray(mResources) ? mResources[0] : mResources;
                        const productId = get_default()(docs[0], "ProductProductNo_s", "");
                        setIsShowModal(Boolean(partId) && Boolean(productId));
                    } else {
                        location.href = "".concat(shortenedUrl, "?keyword=").concat(searchString).concat(searchType === "parts" ? "&service=true" : "");
                    }
                }).catch((err)=>console.log("error occured in fetch search term", err));
            }
        }
    };
    const handleOnClick = (event)=>{
        event === null || event === void 0 ? void 0 : event.preventDefault();
        if (Boolean(partId) && Boolean(productId)) {
            setIsShowModal(true);
        }
        if (pdfPartsDiagram && pdfPartsDiagram[0]) {
            handlePDFDownload(event, pdfPartsDiagram ? pdfPartsDiagram[0] : "");
        }
    };
    const handlePDFDownload = (e, link)=>{
        e.stopPropagation();
        try {
            window.open(link.trim(), "_blank");
        } catch (err) {
            console.log(err);
        }
    };
    const onCloseModal = ()=>{
        setIsShowModal(false);
    };
    const getButton = ()=>{
        if (isSkuSearch) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (InPageSearch_v1_index_module_default()) === null || (InPageSearch_v1_index_module_default()) === void 0 ? void 0 : (InPageSearch_v1_index_module_default()).inPageSearchWrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    className: "kf-react-button button gbh-data-layer large ".concat(isDarkBg ? "secondary" : "ghost", " ").concat(loading ? "disabled" : " ", " ").concat(searchString && searchString !== null && searchString.length > 0 ? "--active" : "--inactive"),
                    "data-gbh-data-layer": analytics_getEventInfo("".concat(ctaLink, "?keyword=").concat(searchString), "success"),
                    onClick: handleOnClick,
                    children: ctaLabel
                })
            });
        } else {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                label: ctaLabel,
                type: isDarkBg ? "secondary" : "ghost",
                to: "".concat(shortenedUrl, "?keyword=").concat(searchString).concat(searchType === "parts" ? "&service=true" : ""),
                className: "gbh-data-layer ".concat(loading ? "disabled" : " ", " ").concat(searchString && searchString !== null && searchString.length > 0 ? "--active" : "--inactive"),
                "data-gbh-data-layer": analytics_getEventInfo("".concat(ctaLink, "?keyword=").concat(searchString), "error", type, searchString)
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "in-page-search ".concat(showVisualSearch ? "show-visualsearch-wrapper" : ""),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()("inpage-search kf-react-container", isDarkBg && "inpage-search--dark"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "row inpage-search-section",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: classnames_default()("col-12 inpage-search__title", isDarkBg && "inpage-search__title--dark"),
                                children: (0,helper/* sanitizeText */.oOy)(title)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "col-12 inpage-search__header",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: classnames_default()("inpage-search__header-section", !isDarkBg && "inpage-search__header-section--light"),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "inpage-search__search-filed ",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                    className: "inpage-search__label",
                                                    htmlFor: "inpage-search__search-control",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                            autoComplete: "off",
                                                            type: "text",
                                                            className: classnames_default()("inpage-search__search-control", isDarkBg && "inpage-search__search-control--dark"),
                                                            id: "inpage-search__search-control",
                                                            placeholder: placeholder,
                                                            "aria-labelledby": "searchBox",
                                                            onChange: (e)=>onChange(e.target.value),
                                                            onKeyUp: (e)=>handleKeyPress(e)
                                                        }),
                                                        isVisualSearchEnabled ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "inpage-search__search-visual-icon ".concat(showVisualSearch ? "inpage-search__search-visual_show" : "inpage-search__search-visual"),
                                                            onClick: (e)=>{
                                                                e.preventDefault();
                                                                e.stopPropagation();
                                                                addDataLayerVisualSearch({
                                                                    eventKey: "search using an image"
                                                                });
                                                                setShowVisualSearch((i)=>!i);
                                                            },
                                                            children: [
                                                                visualSearchIcon,
                                                                (device === null || device === void 0 ? void 0 : device.isLargeTabView) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "tool-tip-custom",
                                                                    children: "Search using an image"
                                                                })
                                                            ]
                                                        }) : null
                                                    ]
                                                })
                                            }),
                                            width > 480 && searchString && searchString !== null && searchString.length > 0 && getButton(),
                                            isPartsViewerV2Enabled ? /*#__PURE__*/ (0,jsx_runtime.jsx)(v2_PartsViewer/* default */.Z, {
                                                page: "search",
                                                onClose: onCloseModal,
                                                showModal: isShowModal,
                                                productId: productId,
                                                partId: partId,
                                                fileMap: svgFileMap.map((val)=>{
                                                    return {
                                                        id: val.url,
                                                        ...val
                                                    };
                                                })
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(PartsViewer/* default */.Z, {
                                                productId: productId,
                                                partId: partId,
                                                showModal: isShowModal,
                                                page: "search",
                                                onClose: onCloseModal
                                            })
                                        ]
                                    }),
                                    width <= 480 && getButton()
                                ]
                            })
                        ]
                    })
                })
            }),
            showVisualSearch ? /*#__PURE__*/ (0,jsx_runtime.jsx)(v1, {
                showVisualSearch: showVisualSearch
            }) : null
        ]
    });
};
/* harmony default export */ var InPageSearch_view = ((0,lib/* withOrientationChange */.Qe)(InPageSearchView));

;// CONCATENATED MODULE: ./components/InPageSearch/v1/InPageSearch.jsx









const InPageSearch = (props)=>{
    const { data: searchProps = {}  } = props;
    const [lwAppName, setLwAppName] = (0,react.useState)("");
    const [language, setLanguage] = (0,react.useState)("en");
    const [searchString, setSearchString] = (0,react.useState)("");
    const [{ loading , partId , productId  }, setState] = (0,react.useState)({
        loading: false,
        partId: "",
        productId: ""
    });
    const [isSkuSearch, setIsSkuSearch] = (0,react.useState)(false);
    const [pdfPartsDiagram, setPdfPartsDiagram] = (0,react.useState)("");
    const [svgFileMap, setSvgFileMap] = (0,react.useState)([]);
    (0,react.useEffect)(()=>{
        (0,constants_config/* getConfig */.i)().then((config)=>{
            const { general: { lwAppName =""  } = {} , internationalization: { language ="en"  } = {}  } = config !== null && config !== void 0 ? config : {};
            setLwAppName(lwAppName);
            setLanguage(language);
        });
    }, []);
    const handleChange = (0,helper/* debounce */.DsO)((searchTerm)=>{
        setSearchString(searchTerm.trim());
    });
    (0,react.useEffect)(()=>{
        if (lwAppName && searchString) {
            getData(searchString);
        }
    }, [
        searchString,
        lwAppName
    ]);
    const getData = (searchString)=>{
        if (searchString.length >= 3) {
            setState((prevState)=>({
                    ...prevState,
                    loading: true
                }));
            const fl = "id,sku_s,slug_s,ProductResource.InteractiveSVG.resourceName_ss,ProductProductNo_s,ProductResource.InteractiveSVG.resourceTitle_ss,ProductResource.PartsPDFFileName.resourceFullWebURL_ss";
            constants_api/* apim.get */.TH.get(constants.inPageSearchEndPoint, {
                params: {
                    q: searchString,
                    fl,
                    fq: [
                        'Products:("ct")',
                        'language_s:("'.concat(language, '")')
                    ],
                    collections: lwAppName.toLowerCase(),
                    profilename: "profile_".concat(lwAppName.toLowerCase(), "_Search")
                },
                paramsSerializer: (params)=>{
                    return lib_default().stringify(params, {
                        arrayFormat: "repeat",
                        encode: false
                    });
                }
            }).then((res)=>{
                const { data: { response: { numFound ="" , docs =[]  } = {} , fusion: { exactMatch =""  } = {}  } = {}  } = res;
                if (numFound === 1 && exactMatch) {
                    const mResources = get_default()(docs[0], "ProductResource.InteractiveSVG.resourceName_ss", "");
                    const mResourceTitles = get_default()(docs[0], "ProductResource.InteractiveSVG.resourceTitle_ss", "");
                    const partLinks = (0,helper/* organizeData */.U2t)(mResources, mResourceTitles, "Service Parts Diagram", "part");
                    setSvgFileMap(partLinks);
                    const pdfPartsDiagram = get_default()(docs[0], "ProductResource.PartsPDFFileName.resourceFullWebURL_ss", "");
                    const partId = Array.isArray(mResources) ? mResources[0] : mResources;
                    const productId = get_default()(docs[0], "ProductProductNo_s", "");
                    setState((prevState)=>({
                            ...prevState,
                            partId: partId !== null && partId !== void 0 ? partId : "",
                            productId,
                            loading: false
                        }));
                    setPdfPartsDiagram(pdfPartsDiagram);
                    const isSkuSearch = Boolean(partId) && Boolean(productId) || Boolean(pdfPartsDiagram) && Boolean(pdfPartsDiagram[0]);
                    setIsSkuSearch(isSkuSearch);
                } else {
                    setIsSkuSearch(false);
                    setState((prevState)=>({
                            ...prevState,
                            loading: false
                        }));
                }
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(InPageSearch_view, {
        loading: loading,
        partId: partId,
        isSkuSearch: isSkuSearch,
        productId: productId,
        searchString: searchString,
        pdfPartsDiagram: pdfPartsDiagram,
        onChange: handleChange,
        lwAppName: lwAppName,
        language: language,
        svgFileMap: svgFileMap,
        ...searchProps
    });
};
/* harmony default export */ var v1_InPageSearch = (InPageSearch);

;// CONCATENATED MODULE: ./components/Default/Title/DynamicTag.jsx

const DynamicTag = (param)=>{
    let { type , children , ...rest } = param;
    const Tag = /*#__PURE__*/ react.createElement(type, {
        ...rest
    }, children);
    return Tag;
};

;// CONCATENATED MODULE: ./components/Default/Title/index.jsx



const Title = (param)=>{
    let { data ={}  } = param;
    const { appliedCssClassNames ="" , text =""  } = data;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "title ".concat(appliedCssClassNames ? appliedCssClassNames : ""),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "cmp-title",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DynamicTag, {
                type: data === null || data === void 0 ? void 0 : data.type,
                className: "cmp-title__text",
                children: [
                    text,
                    " "
                ]
            })
        })
    });
};
/* harmony default export */ var Default_Title = (Title);

// EXTERNAL MODULE: ./utils/product.js
var product = __webpack_require__(29843);
// EXTERNAL MODULE: ./store/features/productListSlice.js
var productListSlice = __webpack_require__(49682);
// EXTERNAL MODULE: ./components/Default/DynamicSearch/v1/SearchPanel/localization.js
var SearchPanel_localization = __webpack_require__(73846);
// EXTERNAL MODULE: ./components/Default/DynamicSearch/v1/DynamicSearch.view/index.module.scss
var DynamicSearch_view_index_module = __webpack_require__(31901);
var DynamicSearch_view_index_module_default = /*#__PURE__*/__webpack_require__.n(DynamicSearch_view_index_module);
// EXTERNAL MODULE: ./public/icons/search.svg
var search = __webpack_require__(83790);
;// CONCATENATED MODULE: ./components/Default/DynamicSearch/v1/DynamicSearch.view/index.jsx






const SearchPanel = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(8787), __webpack_require__.e(1976), __webpack_require__.e(6828), __webpack_require__.e(9562), __webpack_require__.e(3156)]).then(__webpack_require__.bind(__webpack_require__, 46218)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(46218)
            ]
    }
});


const DynamicSearch = (props)=>{
    const { showSearchBar =false , onToggle =()=>{}  } = props;
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const { searchHeader =""  } = (0,SearchPanel_localization/* getTranslations */.F)(t);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (DynamicSearch_view_index_module_default()).dynamicSearchViewWrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                className: "search-button gbh-data-layer",
                id: "search-side-panel__toggle",
                tabIndex: "0",
                role: "button",
                "aria-label": searchHeader,
                "data-gbh-data-layer": '{"eventAction":"internal search","eventName":"internal search","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"internal search magnifying glass button","internalLinkPosition":"global header","internalLinkType":"global navigation","internalLinkZoneName":"global header","internalLinkURL":"n/a","clickInternalLinks":"true"}',
                onClick: onToggle,
                onKeyDown: (e)=>e.key === constants["default"].KEY.ENTER && onToggle(),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "search-text",
                        children: searchHeader
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "search-icon",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            role: "presentation",
                            "aria-hidden": true,
                            src: search/* default */.Z === null || search/* default */.Z === void 0 ? void 0 : search/* default.src */.Z.src,
                            alt: lib/* isMobile */.tq ? "search-icon" : ""
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "search-side-panel__overlay ".concat(showSearchBar ? "search-side-panel__show-overlay" : "")
            }),
            showSearchBar ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchPanel, {
                ...props
            }) : null
        ]
    });
};
/* harmony default export */ var DynamicSearch_view = ((0,lib/* withOrientationChange */.Qe)(DynamicSearch));

// EXTERNAL MODULE: ./components/Default/DynamicSearch/v1/analytics.js
var DynamicSearch_v1_analytics = __webpack_require__(33507);
;// CONCATENATED MODULE: ./components/Default/DynamicSearch/v1/DynamicSearch.jsx












const DynamicSearch_DynamicSearch = (props)=>{
    var ref;
    const { presetConfigs ={} , disableParts =false , enablePotraitTile =false  } = props;
    const dispatch = (0,es/* useDispatch */.I0)();
    const persona = (0,helper/* getUserPersona */.shu)();
    const isSsr = (0,useIsSsr/* default */.Z)();
    const analyticsEventData = {};
    const currencySign = (0,react.useRef)("");
    const currencyCode = (0,react.useRef)("");
    const searchPagePath = (0,react.useRef)("");
    const knowledgeArticleUrl = (0,react.useRef)("");
    const domainListUrl = (0,react.useRef)("");
    const bodyRef = (0,react.useRef)(document.body);
    const htmlRef = (0,react.useRef)(document.getElementsByTagName("html")[0]);
    const [showSearchBar, setShowSearchBar] = (0,react.useState)(false);
    const [selectedData, setSelectedData] = (0,react.useState)({});
    const [searchString, setSearchString] = (0,react.useState)("");
    var ref1;
    const [searchHistory, setSearchHistory] = (0,react.useState)((ref1 = JSON.parse(localStorage.getItem("keyWordList"))) !== null && ref1 !== void 0 ? ref1 : []);
    const [brandName, setBrandName] = (0,react.useState)("");
    const [searchTotal, setSearchTotal] = (0,react.useState)(0);
    const [topSuggestedData, setTopSuggestedData] = (0,react.useState)("");
    const [isCTAClicked, setIsCTAClicked] = (0,react.useState)(false);
    const [redirectUrl, setRedirectUrl] = (0,react.useState)("");
    const [category, setCategory] = (0,react.useState)("");
    const [tilesData, setTilesData] = (0,react.useState)([]);
    const [productsLoaded, setProductsLoaded] = (0,react.useState)(false);
    const [xfLink, setXfLink] = (0,react.useState)("");
    const [promoLayout, setPromoLayout] = (0,react.useState)("one-column");
    const [isGlobalConfigBlank, setIsGlobalConfigBlank] = (0,react.useState)(true);
    const [fusionQueryId, setFusionQueryId] = (0,react.useState)("");
    (0,react.useEffect)(()=>{
        if (showSearchBar) {
            var ref;
            setSearchHistory((ref = JSON.parse(localStorage.getItem("keyWordList"))) !== null && ref !== void 0 ? ref : []);
        }
    }, [
        showSearchBar
    ]);
    (0,react.useEffect)(()=>{
        if (isGlobalConfigBlank) {
            (0,constants_config/* getConfig */.i)().then(async (config)=>{
                let blankConfig = false;
                if (!(config && Object.keys(config).length > 1)) {
                    blankConfig = true;
                    setIsGlobalConfigBlank(true);
                }
                if (!blankConfig) {
                    setIsGlobalConfigBlank(false);
                    const vbrandName = get_default()(config, "general.siteName", "");
                    if (vbrandName) {
                        setBrandName(vbrandName);
                    }
                    currencySign.current = get_default()(config, "internationalization.currencySign", "");
                    currencyCode.current = get_default()(config, "internationalization.currencyCode", "");
                    knowledgeArticleUrl.current = await (0,helper/* getShortenedUrl */.Ppy)(get_default()(config, "general.knowledgeArticlePath", ""));
                    searchPagePath.current = await (0,helper/* getShortenedUrl */.Ppy)(get_default()(config, "general.searchPagePath", ""));
                    domainListUrl.current = get_default()(config, "general.domainMapping", "");
                }
            }).catch((error)=>{
                console.log(error);
            });
        }
    }, [
        isSsr,
        isGlobalConfigBlank
    ]);
    (0,react.useEffect)(()=>{
        if (searchTotal > 0 && selectedData.key) {
            getTilesData(selectedData);
        }
    }, [
        searchTotal,
        selectedData
    ]);
    (0,react.useEffect)(()=>{
        if (brandName) {
            if (searchString.length >= 3) {
                getSearchResult(searchString);
            } else {
                setSearchTotal(0);
            }
            setProductsLoaded(false);
        }
    }, [
        searchString,
        brandName
    ]);
    const handleToggle = ()=>{
        setSearchString("");
        setSearchTotal(0);
        const classNames = [
            "searchbar-open",
            "scroll-lock"
        ];
        classNames.forEach((className)=>{
            var ref, ref1;
            return bodyRef === null || bodyRef === void 0 ? void 0 : (ref = bodyRef.current) === null || ref === void 0 ? void 0 : (ref1 = ref.classList) === null || ref1 === void 0 ? void 0 : ref1.toggle(className);
        });
        classNames.forEach((className)=>{
            var ref, ref1;
            return htmlRef === null || htmlRef === void 0 ? void 0 : (ref = htmlRef.current) === null || ref === void 0 ? void 0 : (ref1 = ref.classList) === null || ref1 === void 0 ? void 0 : ref1.toggle(className);
        });
        setShowSearchBar(!showSearchBar);
    };
    const handleRedirect = (searchTerm, isAnalyticsClick, analyticsEventType)=>{
        setProductsLoaded(false);
        setIsCTAClicked(true);
        if (redirectUrl) {
            isAnalyticsClick && (0,DynamicSearch_v1_analytics/* handleSearchAnalyticsEvent */.e)("success", null, null, analyticsEventType, redirectUrl, analyticsEventData, searchString, searchTotal, topSuggestedData, searchHistory, brandName);
            window.location.href = redirectUrl;
            setRedirectUrl("");
        } else {
            var ref;
            let history = (ref = JSON.parse(window.localStorage.getItem("keyWordList"))) !== null && ref !== void 0 ? ref : [];
            history = history.filter((item)=>item.keyWord.toLowerCase() !== searchTerm.toLowerCase());
            history.unshift({
                keyWord: searchTerm,
                id: Date.now()
            });
            window.localStorage.setItem("keyWordList", JSON.stringify(history));
            dispatch((0,productListSlice/* profileBrandSearch */.R$)([
                searchTerm.trim(),
                brandName.toLowerCase(),
                "sku_s, slug_s, url_s, variantList.sku_ss, Product_Category",
                1,
                ""
            ])).then(async (res)=>{
                const { payload: brandSearchPayload = {} , payload: { fusion: brandFusion = {} , fusion: { redirect: brandFusionRedirect = [] , exactMatch: brandFusionExactMatch = "" , partsCount: partsResponseNumFound = 0 , partsDocs: partsResponseDocs = [] , partsExactMatch: partsFusionExactMatch = ""  } , response: { numFound: brandResponseNumFound = 0 , docs: brandResponseDocs = []  }  } = {}  } = res;
                if (brandSearchPayload) {
                    let redirectUrl = "";
                    // redirect if redirect URL is configured in LW for search keyword
                    if (brandFusion && brandFusionRedirect && brandFusionRedirect[0]) {
                        redirectUrl = brandFusionRedirect[0];
                        isAnalyticsClick && (0,DynamicSearch_v1_analytics/* handleSearchAnalyticsEvent */.e)("success", null, redirectUrl, analyticsEventType, redirectUrl, analyticsEventData, searchString, searchTotal, topSuggestedData, searchHistory, brandName);
                        window.location.href = redirectUrl;
                    } else if (brandResponseNumFound === 1 && brandFusionExactMatch) {
                        const d = brandResponseDocs[0];
                        if (d.slug_s) {
                            const param = d.sku_s ? "?skuId=".concat(d.sku_s) : "";
                            redirectUrl = await (0,helper/* getPDPUrl */.ir5)(d.Product_Category, d.slug_s) + param;
                        } else if (d.url_s) {
                            redirectUrl = d.url_s;
                        }
                        isAnalyticsClick && (0,DynamicSearch_v1_analytics/* handleSearchAnalyticsEvent */.e)("success", null, redirectUrl, analyticsEventType, redirectUrl, analyticsEventData, searchString, searchTotal, topSuggestedData, searchHistory, brandName);
                        window.location.href = redirectUrl;
                    } else if (partsResponseNumFound === 1 && partsFusionExactMatch) {
                        const d1 = partsResponseDocs[0];
                        if (d1.slug_s) {
                            const param1 = d1.sku_s ? "&skuId=".concat(d1.sku_s) : "";
                            redirectUrl = await (0,helper/* getPDPUrl */.ir5)(null, d1.slug_s) + param1;
                        } else if (d1.url_s) {
                            redirectUrl = d1.url_s;
                        }
                        isAnalyticsClick && (0,DynamicSearch_v1_analytics/* handleSearchAnalyticsEvent */.e)("success", null, redirectUrl, analyticsEventType, redirectUrl, analyticsEventData, searchString, searchTotal, topSuggestedData, searchHistory, brandName);
                        window.location.href = redirectUrl;
                    } else {
                        redirectUrl = (0,helper/* sanitizeUrl */.Nmg)(window.location.origin + (0,helper/* removeAndCleanLink */.xEh)(searchPagePath.current) + "?keyword=".concat(searchTerm.trim()));
                        isAnalyticsClick && (0,DynamicSearch_v1_analytics/* handleSearchAnalyticsEvent */.e)("success", null, redirectUrl, analyticsEventType, redirectUrl, analyticsEventData, searchString, searchTotal, topSuggestedData, searchHistory, brandName);
                        window.location.href = redirectUrl;
                    }
                }
            // setProductsLoaded(true)
            }).catch((err)=>{
                console.log("Error occured while fetching Search data", err);
                isAnalyticsClick && (0,DynamicSearch_v1_analytics/* handleSearchAnalyticsEvent */.e)("failure", "error occured while fetching search data", null, analyticsEventType, redirectUrl, analyticsEventData, searchString, searchTotal, topSuggestedData, searchHistory, brandName);
                setProductsLoaded(true);
            });
        }
    };
    const handleChange = (searchTerm)=>{
        setProductsLoaded(false);
        setSearchString(searchTerm.trim());
    };
    const handleDelete = (id)=>{
        var ref;
        let history = (ref = JSON.parse(window.localStorage.getItem("keyWordList"))) !== null && ref !== void 0 ? ref : [];
        history = history.filter((item)=>item.id !== id);
        window.localStorage.setItem("keyWordList", JSON.stringify(history));
        setSearchHistory(history);
    };
    const handleClearAll = ()=>{
        localStorage.removeItem("keyWordList");
        setSearchHistory([]);
    };
    const getSearchResult = (0,react.useCallback)(debounce_default()((searchString)=>getData(searchString), 2000), [
        brandName
    ]);
    const getData = (searchStr)=>{
        if (redirectUrl) setRedirectUrl("");
        if (!isCTAClicked && searchStr.length >= 3) {
            Promise.all([
                dispatch((0,productListSlice/* profileBrandSearch */.R$)([
                    searchStr.trim(),
                    brandName.toLowerCase(),
                    "sku_s, slug_s, url_s, variantList.sku_ss, Product_Category",
                    1,
                    ""
                ])),
                dispatch((0,productListSlice/* profileBrandTypeahead */.zw)([
                    searchStr.trim(),
                    brandName.toLowerCase()
                ]))
            ]).then(async (res)=>{
                const [{ payload: brandSearchPayload = {} , payload: { fusion: brandFusion = {} , fusion: { redirect: brandFusionRedirect = [] , exactMatch: brandFusionExactMatch = "" , fusionQueryId: brandFusionQueryId = "" , partsExactMatch: partsFusionExactMatch = "" , fusionQueryId: partsFusionQueryId = "" , partsCount: partsResponseNumFound = 0 , partsDocs: partsResponseDocs = []  } , response: { numFound: brandResponseNumFound = 0 , docs: brandResponseDocs = []  }  } = {}  }, { payload: brandTypeaheadPayload = {}  }] = res;
                if (brandSearchPayload && brandTypeaheadPayload) {
                    let redirectUrl = "";
                    // redirect if redirect URL is configured in LW for search keyword
                    if (brandFusion && brandFusionRedirect && brandFusionRedirect[0]) {
                        (0,DynamicSearch_v1_analytics/* handleSearchAnalyticsEvent */.e)("success", null, brandFusionRedirect[0], null, redirectUrl, analyticsEventData, searchString, searchTotal, topSuggestedData, searchHistory, brandName);
                        window.location.href = brandFusionRedirect[0];
                    } else if (brandResponseNumFound === 1 && brandFusionExactMatch) {
                        const d = brandResponseDocs[0];
                        if (d.slug_s) {
                            const param = d.sku_s ? "?skuId=".concat(d.sku_s) : "";
                            redirectUrl = await (0,helper/* getPDPUrl */.ir5)(d.Product_Category, d.slug_s) + param;
                        } else if (d.url_s) {
                            redirectUrl = d.url_s;
                        }
                    } else if (partsResponseNumFound === 1 && partsFusionExactMatch) {
                        const d1 = partsResponseDocs[0];
                        if (d1.slug_s) {
                            const param1 = d1.sku_s ? "&skuId=".concat(d1.sku_s) : "";
                            redirectUrl = await (0,helper/* getPDPUrl */.ir5)(null, d1.slug_s) + param1;
                        }
                    }
                    if (!brandFusionRedirect.length) {
                        let groups = [
                            {
                                key: "products",
                                fq: 'Products:("ct")',
                                count: get_default()(brandSearchPayload, "facet_counts.facet_fields.Products[1]", 0)
                            },
                            {
                                key: "parts",
                                count: get_default()(brandSearchPayload.fusion.partsCount, "partsCount", 0)
                            },
                            {
                                key: "technical",
                                fq: 'Technical:("ct")',
                                count: get_default()(brandSearchPayload, "facet_counts.facet_fields.Technical[1]", 0)
                            },
                            {
                                key: "inspiration",
                                fq: 'Inspiration:("Inspiration")',
                                count: get_default()(brandSearchPayload, "facet_counts.facet_fields.Inspiration[1]", 0)
                            },
                            {
                                key: "resource",
                                fq: 'Resource:("Resource")',
                                count: get_default()(brandSearchPayload, "facet_counts.facet_fields.Resource[1]", 0)
                            },
                            {
                                key: "help",
                                fq: 'Help:("sf")',
                                count: get_default()(brandSearchPayload, "facet_counts.facet_fields.Help[1]", 0)
                            }
                        ];
                        if (disableParts) {
                            groups = groups.filter((arr)=>{
                                return arr.key !== "parts";
                            });
                        }
                        // Calculating the total results
                        let total = 0;
                        const selected = groups.find((group)=>group.count > 0);
                        if (brandFusionExactMatch || partsFusionExactMatch) {
                            total = selected.key === "parts" ? partsResponseNumFound : brandResponseNumFound;
                        } else {
                            groups.forEach((group)=>total += group.count);
                        }
                        let sFusionQueryId = brandFusionQueryId !== null && brandFusionQueryId !== void 0 ? brandFusionQueryId : "";
                        sFusionQueryId = sFusionQueryId !== null && sFusionQueryId !== void 0 ? sFusionQueryId : partsFusionQueryId;
                        analyticsEventData.searchTotal = total;
                        analyticsEventData.redirectUrl = redirectUrl;
                        analyticsEventData.topSuggestedData = get_default()(brandTypeaheadPayload, "response.docs", []);
                        analyticsEventData.selectedData = selected;
                        analyticsEventData.searchString = searchStr.trim();
                        setSearchTotal(total);
                        setRedirectUrl(redirectUrl);
                        setTopSuggestedData(get_default()(brandTypeaheadPayload, "response.docs", []));
                        setFusionQueryId(sFusionQueryId);
                        (0,DynamicSearch_v1_analytics/* handleSearchAnalyticsEvent */.e)("success", null, null, null, redirectUrl, analyticsEventData, searchString, searchTotal, topSuggestedData, searchHistory, brandName);
                        setSelectedData(selected);
                    }
                }
            }).catch((err)=>{
                setProductsLoaded(true);
                console.error("Error occured while fetching Search data", err);
            });
        } else {
            setSearchTotal(0);
            setCategory("");
            setTilesData([]);
            setRedirectUrl("");
            setTopSuggestedData([]);
        }
    };
    const getTilesData = (selected)=>{
        const fl = [
            "id",
            "sku_s",
            "slug_s",
            "metaTitle_s",
            "productName_s",
            "masterSKU_s",
            "masterCustomerFacingSKU_s",
            "Product_Category",
            "ProductBrandName_s",
            "productImages.url_ss",
            "displayPriceStartingAt_s",
            "SKUColorSwatchFilename_ss",
            "ProductDescriptionProductShort_s",
            "url_s",
            "urlName_s",
            "title_s",
            "pageTitle_s",
            "eyeBrowText_s",
            "templateType_s",
            "thumbNailImage_s",
            "searchDescription_s",
            "layoutItems.Article_Type__c.value_s",
            "layoutItems.KM_Article_Content__c.value_s",
            "layoutItems.KBNA_3C_Image_Video__c.label_s",
            "layoutItems.KBNA_3C_Image_Video__c.value_s",
            "priceList.".concat(persona, ".price_d"),
            "priceList.".concat(persona, ".finalPrice_d"),
            "priceList.".concat(persona, ".discountedPrice_d"),
            "priceList.".concat(persona, ".saleOffer_s"),
            "priceStartingAt.".concat(persona, "_d"),
            "discountedPriceStartingAt.".concat(persona, "_d"),
            "Color.SKU.Details_ss",
            "Color.".concat(persona, ".Details_ss"),
            "ProductIsExclusive_s",
            "RegionReleaseforShipment_dt",
            "productImages.labelWithUrl_ss",
            "variantList.sku_ss",
            "RegionOnBackOrder_s",
            "RegionBrandName_s",
            "ctId_s",
            "primaryBundleSKU_s"
        ];
        setXfLink("");
        setPromoLayout("one-column");
        setCategory("");
        setTilesData([]);
        dispatch(selected.key === "parts" ? (0,productListSlice/* profileServicePartsSearch */.n7)([
            searchString.trim(),
            fl.join(","),
            6
        ]) : (0,productListSlice/* profileBrandSearch */.R$)([
            searchString.trim(),
            brandName.toLowerCase(),
            fl.join(","),
            6,
            selected.fq
        ])).then((res)=>{
            var ref;
            if (res.payload && ((ref = res.payload.response) === null || ref === void 0 ? void 0 : ref.docs)) {
                var ref1;
                setCategory(selected.key);
                setTilesData((ref1 = res.payload.response) === null || ref1 === void 0 ? void 0 : ref1.docs);
                if (res.payload.fusion && res.payload.fusion.experiment_fragments && res.payload.fusion.experiment_fragments !== undefined) {
                    var ref2, ref3, ref4, ref5;
                    var ref6;
                    setPromoLayout((ref6 = (ref3 = (ref2 = res.payload.fusion) === null || ref2 === void 0 ? void 0 : ref2.experiment_fragments[0]) === null || ref3 === void 0 ? void 0 : ref3.promoLayout_s) !== null && ref6 !== void 0 ? ref6 : "one-column");
                    var ref7;
                    setXfLink((ref7 = (ref5 = (ref4 = res.payload.fusion) === null || ref4 === void 0 ? void 0 : ref4.experiment_fragments[0]) === null || ref5 === void 0 ? void 0 : ref5.url_s) !== null && ref7 !== void 0 ? ref7 : "");
                }
            }
            setProductsLoaded(true);
        }).catch((error)=>{
            console.log(error);
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicSearch_view, {
        xfLink: xfLink,
        promoLayout: promoLayout,
        searchTotal: searchTotal,
        searchString: searchString,
        showSearchBar: showSearchBar,
        onToggle: handleToggle,
        onRedirect: handleRedirect,
        onChange: handleChange,
        onDelete: handleDelete,
        onClearAll: handleClearAll,
        category: category,
        tilesData: tilesData,
        topSuggestedData: topSuggestedData,
        searchHistory: searchHistory,
        comparedProducts: (0,helper/* getCompareData */.p2C)(),
        removeFromCompare: product/* removeFromCompareProduct */.Zj,
        addToCompare: product/* addToCompareProduct */.dX,
        currencySign: currencySign.current,
        brand: brandName,
        favorites: (ref = (0,helper/* getFavouraties */.MqV)()) === null || ref === void 0 ? void 0 : ref.lineItems,
        presetConfigs: presetConfigs,
        knowledgeArticleUrl: knowledgeArticleUrl.current,
        fusionQueryId: fusionQueryId,
        parent: "Dynamic Search",
        enablePotraitTile: enablePotraitTile,
        domainListUrl: domainListUrl.current,
        productsLoaded: productsLoaded
    });
};
/* harmony default export */ var v1_DynamicSearch = (DynamicSearch_DynamicSearch);

;// CONCATENATED MODULE: ./components/Default/Video/v2/Video.jsx














const Video_Video = (props)=>{
    const { data: { videoTitle ="" , videoMobile ="" , videoMobileLandscape ="" , videoMobilePoster ="" , videoDesktopPoster ="" , videoDesktop ="" , muteEnableAutoPlay ="false" , hideEnableAutoPlay ="false" , alt ="" , appliedCssClassNames ="" , items =[] , enableLoop ="false" , blackBgCta ="false" , offWhiteBg ="false" , textLinkCta ="false" , textLinkCtaOffWhite ="false" , enablePopUPVideo ="false" , modalCta ="" , modalVideoDesktop ="" , modalVideoMobile ="" , modalVideoMobileLandscape ="" , actionsEnabled: videoActionsEnabled = "false" , teaserProperties: { title ="" , description ="" , linkURLRef =false , linkCTA ="" , linkNewTab =false , videoPosterMobileLandscape ="" , controlType ="" , pageType ="" , componentPosition ="" , componentZone ="" , componentLinkType ="" , playsAboveFold ="false" , eventName ="" , dynamicTabName ="" , eventAction ="" , caption ="" , pretitle ="" , actionsEnabled =false , actions =[] , linkAll =false , dataLayerLinkType ="" , mainTitle ="" , enableFav =false , enableShare =false , linkDescription =false , propertiesPageType =""  } = {}  } = {}  } = props;
    const { eventPageType  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const { winWidth  } = (0,useWindowDimensions/* default */.Z)();
    const screenOrientation = hooks_useScreenOrientation();
    const [video, setVideo] = (0,react.useState)("");
    const [dynamicId, setDynamicId] = (0,react.useState)("");
    const [videoPlayed, setVideoPlayed] = (0,react.useState)(false);
    const [isVideoPlaying, setIsVideoPlaying] = (0,react.useState)(false);
    const [showSocialShare, setShowSocialShare] = (0,react.useState)(false);
    const [isFavourited, setIsFavourited] = (0,react.useState)(false);
    const [modelVideo, setModalVideo] = (0,react.useState)("");
    const [favVideoId, setFavVideoId] = (0,react.useState)("");
    const [flagState, setFlagState] = (0,react.useState)({
        flag25: false,
        flag50: false,
        flag75: false,
        flag100: false
    });
    const { ref: inViewRef , inView  } = useInView({
        threshold: 0.3
    });
    const videoContainerRef = (0,react.useRef)(null);
    const videoRef = (0,react.useRef)(null);
    const inspireRef = (0,react.useRef)(null);
    const closeBtnRef = (0,react.useRef)(null);
    const [general, setGeneral] = (0,react.useState)(null);
    const getVideoId = (video)=>{
        var ref, ref1;
        return (ref1 = (ref = decodeURI(video)) === null || ref === void 0 ? void 0 : ref.split("PAWEB/")[1]) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase();
    };
    (0,react.useEffect)(()=>{
        (0,constants_config/* getConfig */.i)().then((config)=>{
            setGeneral(config === null || config === void 0 ? void 0 : config.general);
        });
    }, []);
    (0,react.useEffect)(()=>{
        if (videoTitle) {
            const dynamicId = (0,helper/* createIdFromString */.ZT_)(videoTitle);
            setDynamicId(dynamicId);
        }
    }, [
        videoTitle
    ]);
    const setVideoSource = (0,react.useCallback)(()=>{
        if (winWidth > 1023) {
            setVideo(videoDesktop);
            setModalVideo(modalVideoDesktop);
        } else {
            if (screenOrientation === null || screenOrientation === void 0 ? void 0 : screenOrientation.includes("landscape")) {
                setVideo(videoMobileLandscape);
                setModalVideo(modalVideoMobileLandscape);
            } else {
                setVideo(videoMobile);
                setModalVideo(modalVideoMobile);
            }
        }
    }, [
        videoMobile,
        videoMobileLandscape,
        videoDesktop,
        screenOrientation,
        winWidth
    ]);
    (0,react.useEffect)(()=>{
        if (inView) {
            var ref;
            setVideoSource();
            if (muteEnableAutoPlay === "true") videoRef === null || videoRef === void 0 ? void 0 : (ref = videoRef.current) === null || ref === void 0 ? void 0 : ref.play();
        } else {
            var ref1;
            videoRef === null || videoRef === void 0 ? void 0 : (ref1 = videoRef.current) === null || ref1 === void 0 ? void 0 : ref1.pause();
        }
    }, [
        setVideoSource,
        inView
    ]);
    (0,react.useEffect)(()=>{
        if (isVideoPlaying) setVideoPlayed(true);
    }, [
        isVideoPlaying
    ]);
    const eventActionTabName = dynamicTabName || "zoneForVideo";
    const eventActionName = "".concat(dynamicTabName || "rm", ":video:rm");
    const onTimeUpdate = (event)=>{
        const videoDuration = inspireRef.current.duration;
        const percent25 = Math.floor(videoDuration * 0.25);
        const percent50 = Math.floor(videoDuration * 0.5);
        const percent75 = Math.floor(videoDuration * 0.75);
        const percent100 = Math.floor(videoDuration);
        const progressTime = Math.floor(inspireRef.current.currentTime);
        if ((muteEnableAutoPlay === "true" ? percent100 - 1 : percent100) === progressTime && flagState.flag100 === false && !(0,helper/* convertStringToBoolean */.mUs)(muteEnableAutoPlay)) {
            setFlagState((prevState)=>({
                    ...prevState,
                    flag100: true
                }));
            addVideoDataLayer(100);
        } else if (percent75 <= progressTime && flagState.flag75 === false && !(0,helper/* convertStringToBoolean */.mUs)(muteEnableAutoPlay)) {
            setFlagState((prevState)=>({
                    ...prevState,
                    flag75: true
                }));
            addVideoDataLayer(75);
        } else if (percent50 <= progressTime && flagState.flag50 === false && !(0,helper/* convertStringToBoolean */.mUs)(muteEnableAutoPlay)) {
            setFlagState((prevState)=>({
                    ...prevState,
                    flag50: true
                }));
            addVideoDataLayer(50);
        } else if (percent25 <= progressTime && flagState.flag25 === false && !(0,helper/* convertStringToBoolean */.mUs)(muteEnableAutoPlay)) {
            setFlagState((prevState)=>({
                    ...prevState,
                    flag25: true
                }));
            addVideoDataLayer(25);
        }
    };
    const getCurrentVideoProgessPercent = ()=>{
        const videoDuration = inspireRef.current.duration;
        const progressTime = Math.floor(inspireRef.current.currentTime);
        return progressTime / videoDuration * 100;
    };
    const addVideoDataLayer = (percentViewed)=>{
        let eventActionName;
        let viewedPercentage;
        let internalLinkName;
        const { VIDEO_PLAY , VIDEO_PAUSE , VIDEO_VIEWED , VIDEO_COMPLETE , VIDEO_CLICK , PLAY_VIDEO , PAUSE_VIDEO , CLOSE_VIDEO , CLOSE  } = constants.VIDEO_EVENTS;
        if (percentViewed === VIDEO_CLICK) {
            eventActionName = "".concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(videoTitle, ":").concat(modalCta === null || modalCta === void 0 ? void 0 : modalCta.toLowerCase());
            viewedPercentage = getCurrentVideoProgessPercent();
            internalLinkName = modalCta === null || modalCta === void 0 ? void 0 : modalCta.toLowerCase();
        } else if (percentViewed === PLAY_VIDEO) {
            eventActionName = "".concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(videoTitle, ":").concat(VIDEO_PLAY);
            viewedPercentage = getCurrentVideoProgessPercent();
            internalLinkName = VIDEO_PLAY;
        } else if (percentViewed === PAUSE_VIDEO) {
            eventActionName = "".concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(videoTitle, ":").concat(VIDEO_PAUSE);
            viewedPercentage = getCurrentVideoProgessPercent();
            internalLinkName = "".concat(viewedPercentage, "% ").concat(VIDEO_VIEWED);
        } else if (percentViewed === CLOSE_VIDEO) {
            eventActionName = "".concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(videoTitle, ":").concat(CLOSE);
            viewedPercentage = getCurrentVideoProgessPercent();
            internalLinkName = CLOSE;
        } else {
            eventActionName = percentViewed === 100 ? "".concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(videoTitle === null || videoTitle === void 0 ? void 0 : videoTitle.toLowerCase(), ":").concat(VIDEO_COMPLETE) : "".concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(videoTitle === null || videoTitle === void 0 ? void 0 : videoTitle.toLowerCase(), ":").concat(percentViewed, "% ").concat(VIDEO_VIEWED);
            viewedPercentage = percentViewed;
            internalLinkName = viewedPercentage === 100 ? "".concat(VIDEO_COMPLETE) : "".concat(viewedPercentage, "% ").concat(VIDEO_VIEWED);
        }
        const eventInfo = {
            clickInternalLinks: "true",
            eventAction: eventActionName,
            eventMsg: "n/a",
            eventName: eventActionName,
            eventStatus: "n/a",
            eventType: "navigation",
            internalLinkName: internalLinkName,
            internalLinkPosition: "".concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase()),
            internalLinkType: "".concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(componentPosition || "navigation" || 0),
            internalLinkURL: "n/a",
            internalLinkZoneName: "".concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(videoTitle === null || videoTitle === void 0 ? void 0 : videoTitle.toLowerCase()),
            videoId: "".concat(getVideoId(modelVideo)),
            videoName: "".concat(videoTitle || componentLinkType.toLowerCase() || "hero video"),
            videoType: "".concat(muteEnableAutoPlay === "true" ? "auto play" : "user initiated")
        };
        const { adobeDataLayer: { getState  } = {}  } = window;
        const page = getState && getState("page") || {};
        window.adobeDataLayer.push({
            event: "cmp:click",
            page,
            eventInfo
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "inspire-video video teaser ".concat(appliedCssClassNames),
        ref: inViewRef,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "cmp-teaser".concat(controlType === "customControl" ? " gbh-custom-control" : "").concat(propertiesPageType === "modalWindow" ? " gbh-model-window" : "").concat(hideEnableAutoPlay === "true" ? " gbh-hide-mute" : ""),
            ref: videoContainerRef,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "cmp-teaser__image video_poster_height".concat(videoPlayed ? " video-played" : ""),
                    "data-gbh-data-layer": '{"clickInternalLinks":"true","internalLinkPosition":"'.concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(componentPosition || "teaser", '","internalLinkZoneName":"').concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(componentZone || "teaser", '","internalLinkURL":"n/a","internalLinkName":"video play","eventName":"').concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(eventActionTabName, '","internalLinkType":"').concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(componentLinkType || "teaser", '","eventType":"navigation","eventAction":"').concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(eventActionTabName, '","videoName":"').concat(videoTitle || componentLinkType.toLowerCase() || "hero video", '","videoId": "').concat(getVideoId(modelVideo), '","videoType":"').concat(muteEnableAutoPlay === "true" ? "auto play" : "user initiated", '"}'),
                    style: showSocialShare ? {
                        overflow: "visible"
                    } : {},
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "gbh-play-video desktop".concat(isVideoPlaying ? " active" : ""),
                            onClick: (event)=>{
                                return onPlayVideoInModal(event, propertiesPageType, videoContainerRef === null || videoContainerRef === void 0 ? void 0 : videoContainerRef.current, videoRef === null || videoRef === void 0 ? void 0 : videoRef.current);
                            },
                            children: !(hideEnableAutoPlay === "true") ? /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: "playinside desktop",
                                id: "videoinnerbtn-".concat(dynamicId),
                                "aria-label": "play video",
                                onClick: ()=>{
                                    return onPlayVideo(videoRef === null || videoRef === void 0 ? void 0 : videoRef.current, (res)=>setIsVideoPlaying(res), videoDesktopPoster, videoMobilePoster, video, isVideoPlaying);
                                }
                            }) : null
                        }),
                        !video ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("picture", {
                            className: "poster-img",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                    media: "(min-width:1025px)",
                                    srcSet: videoDesktopPoster
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                    media: "(min-width:640px) and (max-width:1024px)",
                                    srcSet: videoPosterMobileLandscape
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                    media: "(max-width:639px)",
                                    srcSet: videoMobilePoster
                                }),
                                videoDesktopPoster ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: videoDesktopPoster,
                                    srcSet: videoDesktopPoster,
                                    alt: "",
                                    className: "desktop-poster"
                                }) : null
                            ]
                        }) : null,
                        video ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("video", {
                            ref: videoRef,
                            id: "video-desktop-".concat(dynamicId),
                            width: "100%",
                            muted: muteEnableAutoPlay === "true" ? true : false,
                            autoPlay: muteEnableAutoPlay === "true" ? true : false,
                            loop: muteEnableAutoPlay === "true" ? true : false,
                            playsInline: true,
                            preload: "metadata",
                            className: "hero-video inpage-video videoelement".concat(muteEnableAutoPlay === "true" ? " muted" : "").concat(playsAboveFold === "true" ? "" : " lazy-video"),
                            onVolumeChange: ()=>{
                                return onVolumeChange(videoRef === null || videoRef === void 0 ? void 0 : videoRef.current);
                            },
                            onClick: (event)=>{
                                return onClickHeroVideo(event, videoRef === null || videoRef === void 0 ? void 0 : videoRef.current);
                            },
                            ...controlType === "defaultControl" && hideEnableAutoPlay === "false" ? {
                                controls: true
                            } : {},
                            onPlay: ()=>{
                                return onVideoInteraction(constants.VIDEO_EVENTS.PLAY, ()=>setVideoPlayed(true), (res)=>setIsVideoPlaying(res), videoRef === null || videoRef === void 0 ? void 0 : videoRef.current, video, (id)=>setFavVideoId(id), flagState);
                            },
                            onPause: ()=>{
                                return onVideoInteraction(constants.VIDEO_EVENTS.PAUSE, ()=>setVideoPlayed(true), (res)=>setIsVideoPlaying(res), videoRef === null || videoRef === void 0 ? void 0 : videoRef.current, video, flagState);
                            },
                            onEnded: ()=>{
                                return onVideoInteraction(constants.VIDEO_EVENTS.ENDED, ()=>setVideoPlayed(true), (res)=>setIsVideoPlaying(res), videoRef === null || videoRef === void 0 ? void 0 : videoRef.current, video, flagState);
                            },
                            onTimeUpdate: onTimeUpdate,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                    src: video,
                                    type: "video/mp4"
                                }),
                                items.map((transcript, index)=>{
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("track", {
                                        label: transcript === null || transcript === void 0 ? void 0 : transcript.languageLabel,
                                        kind: "subtitles",
                                        srcLang: transcript === null || transcript === void 0 ? void 0 : transcript.languageCode,
                                        src: transcript === null || transcript === void 0 ? void 0 : transcript.transcriptSrcPath,
                                        default: (items === null || items === void 0 ? void 0 : items.length) ? true : false
                                    }, "video-track-".concat(dynamicId, "-").concat(index));
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                            className: "hero-video inpage-video videoelement".concat(muteEnableAutoPlay === "true" ? " muted" : "").concat(playsAboveFold === "true" ? "" : " lazy-video")
                        }),
                        enableLoop === "true" && modelVideo ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("video", {
                                    ref: inspireRef,
                                    className: "hero-video videoelement inspirevideo ".concat(muteEnableAutoPlay === "true" ? " muted" : "", " ").concat(playsAboveFold === "true" ? "" : "lazy-video"),
                                    "data-desktop-vid": "".concat(modalVideoDesktop),
                                    "data-mobile-vid": modalVideoMobile,
                                    "data-mobile-lscape-vid": modalVideoMobileLandscape,
                                    onVolumeChange: ()=>{
                                        return onVolumeChange(inspireRef === null || inspireRef === void 0 ? void 0 : inspireRef.current);
                                    },
                                    id: "herovideo-desktop-1",
                                    width: "100%",
                                    playsInline: true,
                                    preload: "metadata",
                                    ...controlType === "defaultControl" && !(hideEnableAutoPlay === "false") ? {
                                        controls: true
                                    } : {},
                                    muted: muteEnableAutoPlay === "true" ? true : false,
                                    autoPlay: muteEnableAutoPlay === "true" ? true : false,
                                    loop: muteEnableAutoPlay === "true" ? true : false,
                                    onTimeUpdate: onTimeUpdate,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                            src: modelVideo,
                                            type: "video/mp4"
                                        }),
                                        items.map((transcript, index)=>{
                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("track", {
                                                label: transcript === null || transcript === void 0 ? void 0 : transcript.languageLabel,
                                                kind: "subtitles",
                                                srcLang: transcript === null || transcript === void 0 ? void 0 : transcript.languageCode,
                                                src: transcript === null || transcript === void 0 ? void 0 : transcript.transcriptSrcPath,
                                                default: (items === null || items === void 0 ? void 0 : items.length) ? true : false
                                            }, "video-track-".concat(dynamicId, "-").concat(index));
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    class: "vidio_popup_close_button inspired-video-popup-close",
                                    ref: closeBtnRef,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        role: "button",
                                        onClick: ()=>{
                                            onPlayInspireVideoClose(videoRef === null || videoRef === void 0 ? void 0 : videoRef.current, inspireRef === null || inspireRef === void 0 ? void 0 : inspireRef.current, closeBtnRef === null || closeBtnRef === void 0 ? void 0 : closeBtnRef.current, addVideoDataLayer);
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            "aria-hidden": "true"
                                        })
                                    })
                                })
                            ]
                        }) : null,
                        enableLoop === "false" && modelVideo ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("video", {
                                    ref: inspireRef,
                                    className: "hero-video videoelement inspirevideo ".concat(muteEnableAutoPlay === "true" ? " muted" : "", " ").concat(playsAboveFold === "true" ? "" : "lazy-video"),
                                    "data-desktop-vid": "".concat(modalVideoDesktop),
                                    "data-mobile-vid": modalVideoMobile,
                                    "data-mobile-lscape-vid": modalVideoMobileLandscape,
                                    onVolumeChange: ()=>{
                                        return onVolumeChange(inspireRef === null || inspireRef === void 0 ? void 0 : inspireRef.current);
                                    },
                                    id: "herovideo-desktop-1",
                                    width: "100%",
                                    playsInline: true,
                                    preload: "metadata",
                                    ...controlType === "defaultControl" && !(hideEnableAutoPlay === "false") ? {
                                        controls: true
                                    } : {},
                                    muted: muteEnableAutoPlay === "true" ? true : false,
                                    autoPlay: muteEnableAutoPlay === "true" ? true : false,
                                    loop: muteEnableAutoPlay === "true" ? true : false,
                                    onTimeUpdate: onTimeUpdate,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                            src: modelVideo,
                                            type: "video/mp4"
                                        }),
                                        items.map((transcript, index)=>{
                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("track", {
                                                label: transcript === null || transcript === void 0 ? void 0 : transcript.languageLabel,
                                                kind: "subtitles",
                                                srcLang: transcript === null || transcript === void 0 ? void 0 : transcript.languageCode,
                                                src: transcript === null || transcript === void 0 ? void 0 : transcript.transcriptSrcPath,
                                                default: (items === null || items === void 0 ? void 0 : items.length) ? true : false
                                            }, "video-track-".concat(dynamicId, "-").concat(index));
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    class: "vidio_popup_close_button inspired-video-popup-close",
                                    ref: closeBtnRef,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        role: "button",
                                        onClick: ()=>{
                                            return onPlayInspireVideoClose(videoRef === null || videoRef === void 0 ? void 0 : videoRef.current, inspireRef === null || inspireRef === void 0 ? void 0 : inspireRef.current, closeBtnRef === null || closeBtnRef === void 0 ? void 0 : closeBtnRef.current, addVideoDataLayer);
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            "aria-hidden": "true"
                                        })
                                    })
                                })
                            ]
                        }) : null,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "cmp-img-caption",
                            "data-gbh-data-layer": '{"clickInternalLinks":"true","internalLinkPosition":"'.concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(componentPosition || "teaser", '","internalLinkZoneName":"').concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(componentZone || "teaser", '","internalLinkURL":"n/a","internalLinkName":"n/a","eventName":"').concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(eventName || eventActionName, '","internalLinkType":"').concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(componentLinkType || "teaser", '","eventType":"navigation","eventAction":"').concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(eventAction || eventActionName, '"}'),
                            children: (0,helper/* sanitizeInnerHtml */.KD0)(caption)
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "cmp-teaser__content",
                    children: [
                        pretitle ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "cmp-teaser__pretitle",
                            children: (0,helper/* sanitizeInnerHtml */.KD0)(pretitle)
                        }) : null,
                        title ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "cmp-teaser__title",
                            children: (0,helper/* sanitizeInnerHtml */.KD0)(title)
                        }) : null,
                        description ? /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_Description, {
                            general: general,
                            linkURL: linkCTA,
                            linkURLRef: linkURLRef,
                            linkNewTab: linkNewTab,
                            description: description,
                            mainTitle: mainTitle,
                            componentPosition: componentPosition,
                            componentLinkType: componentLinkType,
                            pageType: pageType,
                            linkDescription: linkDescription
                        }) : null,
                        videoActionsEnabled === "true" || enablePopUPVideo === "true" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "cmp-teaser__action-container",
                            children: [
                                actionsEnabled ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    class: "cta_link",
                                    children: actions.map((action, index)=>{
                                        const { playVideoCTA =false , primaryCTA =false , secondaryCTA =false , url ="" , title ="" , newTab ="" , urlRef =""  } = action;
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_Action, {
                                            primaryCTA: (0,helper/* convertStringToBoolean */.mUs)(primaryCTA),
                                            secondaryCTA: (0,helper/* convertStringToBoolean */.mUs)(secondaryCTA),
                                            playVideoCTA: (0,helper/* convertStringToBoolean */.mUs)(playVideoCTA),
                                            link: url,
                                            text: title,
                                            newTab: (0,helper/* convertStringToBoolean */.mUs)(newTab),
                                            urlRef: urlRef,
                                            id: dynamicId,
                                            pageType: pageType,
                                            linkAll: (0,helper/* convertStringToBoolean */.mUs)(linkAll),
                                            mainTitle: mainTitle,
                                            dataLayerLinkType: dataLayerLinkType,
                                            eventName: eventName,
                                            eventAction: eventAction,
                                            componentPosition: componentPosition,
                                            propertiesPageType: propertiesPageType,
                                            playVideoCTAcb: (event)=>{
                                                return onPlayVideoInModal(event, propertiesPageType, videoContainerRef === null || videoContainerRef === void 0 ? void 0 : videoContainerRef.current, videoRef === null || videoRef === void 0 ? void 0 : videoRef.current);
                                            }
                                        }, "video-action-".concat(index + 1, "-").concat((0,helper/* getRandom */.sZz)()));
                                    })
                                }) : null,
                                enablePopUPVideo === "true" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "play_modal_video_cta",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: "playVideoCta ".concat(textLinkCta === "true" ? "textLinkCta" : "", " ").concat(textLinkCtaOffWhite === "true" ? "textLinkCtaoffwhite" : "", " ").concat(blackBgCta === "true" ? "blackBgCta" : "", " ").concat(offWhiteBg === "true" ? "offWhiteBg" : ""),
                                        onClick: ()=>{
                                            return onPlayInspireVideo(videoRef === null || videoRef === void 0 ? void 0 : videoRef.current, inspireRef === null || inspireRef === void 0 ? void 0 : inspireRef.current, closeBtnRef === null || closeBtnRef === void 0 ? void 0 : closeBtnRef.current, addVideoDataLayer);
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: modalCta
                                        })
                                    })
                                }) : null
                            ]
                        }) : null,
                        enableFav || enableShare ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "cmp-teaser__icons",
                            children: [
                                enableFav ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "favorite fav-video-trigger".concat(isFavourited ? " favorite-filled" : ""),
                                    tabIndex: "0",
                                    onClick: (event)=>onFavVideo(event, videoDesktop, videoDesktop, alt, componentLinkType || caption, videoTitle || componentLinkType.toLowerCase() || "hero video", "", favVideoId, (res)=>{
                                            setIsFavourited(res);
                                        })
                                }) : null,
                                enableShare ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "share share-video-trigger",
                                    tabIndex: "0",
                                    "aria-label": "share",
                                    "data-gbh-data-layer": '{"clickInternalLinks":"true","internalLinkPosition":"'.concat(pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase(), '","internalLinkZoneName":"').concat(pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase(), ":").concat((componentZone === null || componentZone === void 0 ? void 0 : componentZone.toLowerCase()) || "teaser", '","internalLinkURL":"n/a","internalLinkName":"share","eventName":"').concat(pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase(), ':share", "internalLinkType":"').concat(pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase(), ":").concat((componentLinkType === null || componentLinkType === void 0 ? void 0 : componentLinkType.toLowerCase()) || "share", '","eventType":"navigation","eventAction":"').concat(pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase(), ':share"}'),
                                    "data-gbh-clickable": "true",
                                    onClick: (e)=>onShareVideo(e, ()=>setShowSocialShare(!showSocialShare)),
                                    children: showSocialShare ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "share-cmp",
                                        style: {
                                            display: "block"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialShare/* default */.Z, {
                                            componentProp: {
                                                assetUrl: videoDesktop
                                            },
                                            enableDownload: false
                                        })
                                    }) : null
                                }) : null
                            ]
                        }) : null
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var v2_Video = (/*#__PURE__*/react.memo(Video_Video));

;// CONCATENATED MODULE: ./components/ImageCluster/v1/Image.jsx




const ImageCluster_v1_Image_Image = (param)=>{
    let { imageData ={} , resource ={}  } = param;
    const { imageComponentProperties ={} , description ="" , areas =[] , link ="" , displayPopupTitle ="" , newTab ="false" , lazyThreshold =0 , widths =[]  } = imageData;
    const { id ="" , alt ="" , src ="" , smartCropRendition ="" , fileReference =""  } = imageComponentProperties;
    const DM_IMAGE = "image";
    const EAEM_DM_IMAGE = "eaem-image";
    const EAEM_BOUNDING_DIV_CSS = "eaem-bounding-div";
    const [imageDiv, setImageDiv] = (0,react.useState)(null);
    (0,react.useEffect)(()=>{
        if (imageData) {
            init();
        }
    }, [
        imageData
    ]);
    const handleImageLoad = (event)=>{
        setImageDiv(event.target);
    };
    const init = ()=>{
        const elements = document.querySelectorAll('[data-cmp-is="image"]');
        elements.forEach((element)=>{
            const smatCropRend = element.attributes.getNamedItem("data-cmp-smartcroprendition");
            if (!smatCropRend || smatCropRend.value !== "SmartCrop:Auto") {
                return;
            }
            element.attributes.getNamedItem("data-cmp-is").value = EAEM_DM_IMAGE;
        });
        addImageClusterLazyLoad();
    };
    const addImageClusterLazyLoad = ()=>{
        document.querySelectorAll(".gbh-img-cluster, .image").forEach((component)=>{
            if (isImageInViewport(component) || isImageInViewport(component.querySelector(".gbh-img-left-half__inner"))) {
                const lazyImageDiv = component.querySelectorAll('[data-cmp-is="'.concat(EAEM_DM_IMAGE, '"]'));
                if (lazyImageDiv.length > 0) {
                    lazyImageDiv.forEach((childDiv)=>{
                        setImageDiv(childDiv);
                        showImage();
                    });
                }
            } else {
                addListenerForImageVisibilityCheck(component);
            }
        });
    };
    const showImage = ()=>{
        if (imageDiv.parentNode.classList.contains(EAEM_BOUNDING_DIV_CSS)) {
            return;
        }
        setImageDiv((prevImageDiv)=>({
                ...prevImageDiv,
                attributes: {
                    ...prevImageDiv.attributes,
                    "data-cmp-is": DM_IMAGE
                }
            }));
        const eaemDivWrapper = document.createElement("div");
        eaemDivWrapper.classList.add(EAEM_BOUNDING_DIV_CSS);
        imageDiv.parentNode.appendChild(eaemDivWrapper);
        eaemDivWrapper.appendChild(imageDiv);
    };
    const isImageInViewport = (component)=>{
        if (!component || component.length === 0) {
            return false;
        }
        const LAZY_THRESHOLD = 100;
        const el = component[0];
        const rect = el === null || el === void 0 ? void 0 : el.getBoundingClientRect();
        return (rect === null || rect === void 0 ? void 0 : rect.top) >= 0 && (rect === null || rect === void 0 ? void 0 : rect.left) >= 0 && (rect === null || rect === void 0 ? void 0 : rect.bottom) - LAZY_THRESHOLD <= (window.innerHeight || document.documentElement.clientHeight) && (rect === null || rect === void 0 ? void 0 : rect.right) <= (window.innerWidth || document.documentElement.clientWidth);
    };
    const addListenerForImageVisibilityCheck = (component)=>{
        const scrollListen = ()=>{
            if (!isImageInViewport(component)) {
                return;
            }
            const lazyImageDiv = component.querySelectorAll('[data-cmp-is="'.concat(EAEM_DM_IMAGE, '"]'));
            if (lazyImageDiv.length > 0) {
                lazyImageDiv.forEach((childDiv)=>{
                    setImageDiv(childDiv);
                    showImage();
                });
            }
            document.removeEventListener("scroll", scrollListen);
        };
        document.addEventListener("scroll", scrollListen);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "eaem-bounding-div",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "cmp-image",
            "data-cmp-smartcroprendition": smartCropRendition,
            "data-cmp-lazythreshold": lazyThreshold,
            "data-cmp-src": src,
            "data-cmp-widths": widths,
            "data-title": alt,
            id: id,
            "data-asset": fileReference,
            children: [
                link ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    className: "cmp-image__link",
                    href: link,
                    target: (0,helper/* convertStringToBoolean */.mUs)(newTab) ? "_blank" : "_self",
                    rel: "noreferrer"
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        smartCropRendition !== "SmartCrop:Auto" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "".concat(src),
                            className: "cmp-image__image transition",
                            alt: alt,
                            onLoad: handleImageLoad
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicImage["default"], {
                            imgUrl: src,
                            alt: alt,
                            className: "cmp-image__image transition",
                            uniqueId: "".concat(id),
                            itemProp: "contentUrl",
                            onLoad: handleImageLoad
                        }),
                        areas.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)("map", {
                            children: areas === null || areas === void 0 ? void 0 : areas.map((area, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("area", {
                                    shape: area.shape,
                                    coords: area.coordinates,
                                    href: area.href,
                                    target: area.target,
                                    alt: area.alt,
                                    "data-cmp-relcoords": area.relativeCoordinates
                                }, "key-".concat(id)))
                        }) : null
                    ]
                }),
                !(0,helper/* convertStringToBoolean */.mUs)(displayPopupTitle) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "cmp-image__title",
                            itemProp: "caption"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: (0,helper/* sanitizeInnerHtml */.KD0)(description)
                        })
                    ]
                }) : null
            ]
        })
    });
};
/* harmony default export */ var ImageCluster_v1_Image = (ImageCluster_v1_Image_Image);

;// CONCATENATED MODULE: ./components/ImageCluster/v1/ImageCluster.jsx






const ImageCluster = (props)=>{
    var ref, ref1, ref2, ref3, ref4, ref5;
    const { data: { header ="" , description ="" , ctaLink ="" , ctaLabel ="" , newTab =false , pageType ="" , productCategory ="" , productCollectionsName ="" , productRoom ="" , componentLinkType ="" , tabName ="" , dataHeader ="" , componentPosition ="" , appliedCssClassNames =""  } , data ={}  } = props;
    const [imageData, setImageData] = (0,react.useState)([]);
    const [link, setCtaLink] = (0,react.useState)("");
    const [newappliedCssClassNames, setappliedCssClassNames] = (0,react.useState)("");
    (0,react.useEffect)(()=>{
        if (ctaLink) {
            getUrl();
        }
    }, [
        ctaLink
    ]);
    (0,react.useEffect)(()=>{
        if (appliedCssClassNames) {
            setappliedCssClassNames(appliedCssClassNames);
        } else {
            setappliedCssClassNames("image-right gbh-img-desc-indent font-style-1 bg-off-white");
        }
    }, [
        appliedCssClassNames
    ]);
    (0,react.useEffect)(()=>{
        if (data) {
            fetchDataLayer(data);
        }
    }, [
        data
    ]);
    const getUrl = async ()=>{
        setCtaLink(await (0,helper/* getShortenedUrl */.Ppy)(ctaLink));
    };
    const fetchDataLayer = (data)=>{
        const result = (0,utils/* recursiveDataFunction */.Qe)(data, constants.COMPONENT_TYPES === null || constants.COMPONENT_TYPES === void 0 ? void 0 : constants.COMPONENT_TYPES.IMAGE);
        setImageData(result);
    };
    const getCustomDataLayer = ()=>{
        return JSON.stringify({
            productInfo: '{"productCategory":"'.concat(productCategory || "n/a"),
            productCollectionsName: "".concat(productCollectionsName || "n/a"),
            productRoom: "".concat(productRoom || "n/a")
        });
    };
    const getDataLayer = ()=>{
        return JSON.stringify({
            eventName: "".concat(pageType, ":teaser:").concat(ctaLabel.toLowerCase()),
            eventAction: "".concat(pageType, ":teaser:").concat(ctaLabel.toLowerCase()),
            internalLinkName: "".concat(ctaLabel.toLowerCase()),
            internalLinkType: "".concat(pageType, ":").concat(componentLinkType || tabName || "rm" || 0),
            internalLinkZoneName: "".concat(pageType, ":teaser"),
            clickInternalLinks: "".concat(newTab ? "false" : "true"),
            eventType: "navigation",
            internalLinkURL: "".concat(ctaLink),
            internalLinkPosition: "".concat(pageType, ":").concat(componentPosition || "image cluster")
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "imagecluster container responsivegrid ".concat(newappliedCssClassNames),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "gbh-img-cluster",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "gbh-img-container",
                id: "mainContent",
                role: "main",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "gbh-img-left-half",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "gbh-img-left-half__inner",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "gbh-img-left__full img-pos-rel",
                                        children: ((ref = imageData[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.imageComponentProperties) === null || ref1 === void 0 ? void 0 : ref1.src) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageCluster_v1_Image, {
                                            imageData: imageData[0]
                                        }) : null
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "gbh-img-left__half img-pos-rel",
                                        children: ((ref2 = imageData[1]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.imageComponentProperties) === null || ref3 === void 0 ? void 0 : ref3.src) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageCluster_v1_Image, {
                                            imageData: imageData[1]
                                        }) : null
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "gbh-img-left__half img-pos-rel",
                                children: ((ref4 = imageData[2]) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.imageComponentProperties) === null || ref5 === void 0 ? void 0 : ref5.src) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageCluster_v1_Image, {
                                    imageData: imageData[2]
                                }) : null
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "gbh-img-right-half",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "gbh-imgcluster-title",
                                children: (0,helper/* sanitizeInnerHtml */.KD0)(header)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "gbh-img-right__descrip",
                                children: (0,helper/* sanitizeInnerHtml */.KD0)(description)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: "gbh__btn--link",
                                href: link,
                                target: newTab ? "_blank" : "_self",
                                "data-gbh-clickable": "true",
                                rel: "noreferrer",
                                "data-gbh-data-layer": getDataLayer(),
                                "data-gbh-data-layer-custom": getCustomDataLayer(),
                                children: ctaLabel ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    "aria-label": ctaLabel,
                                    "data-gbh-clickable": "true",
                                    children: ctaLabel
                                }) : null
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var v1_ImageCluster = (ImageCluster);

// EXTERNAL MODULE: ./components/ShopTheRoomCard/v1/ShopTheRoomCard.jsx
var ShopTheRoomCard = __webpack_require__(75781);
;// CONCATENATED MODULE: ./i18n/useVirtuali18n.js

const useVirtuali18n = (param)=>{
    let { authorData  } = param;
    const { t  } = (0,esm/* useTranslation */.$G)();
    const i18n = {
        designers: t("kf.findpro.label.designers"),
        specialtiesTxt: t("kf.findpro.label.specialtiesTxt"),
        contactTxt: t("kf.findpro.label.contactTxt"),
        availableCTA: t("kf.findpro.label.availableCTA"),
        availableInMonths: t("kf.findpro.label.availableInMonths"),
        findaProText: t("kf.findpro.label.findaProText"),
        home: t("kf.findpro.label.home")
    };
    return i18n;
};
/* harmony default export */ var i18n_useVirtuali18n = (useVirtuali18n);

;// CONCATENATED MODULE: ./components/VirtualDesignerDetails/v1/analytics.js
const v1_analytics_getEventInfo = (phone, url, partnerName, isEmail)=>{
    const internalLinkName = isEmail ? "services@kohler.com" : phone || partnerName;
    const type = phone ? "contact ".concat(isEmail ? "email" : "phone") : partnerName;
    return JSON.stringify({
        clickInternalLinks: "true",
        eventAction: "find a pro:designer:main content area:".concat(type),
        eventName: "find a pro:designer:main content area:".concat(type),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName,
        internalLinkPosition: "find a pro results",
        internalLinkType: "find a pro:designer:".concat(partnerName, ":contact"),
        internalLinkURL: url,
        internalLinkZoneName: "find a pro:designer:main content area"
    });
};

;// CONCATENATED MODULE: ./components/VirtualDesignerDetails/v1/VirtualDesignerDetails.view.jsx





const VirtualDesignerDetailsView = (props)=>{
    const { data , staticTexts  } = props;
    const [breadCrumb, setBreadCrumb] = (0,react.useState)("");
    const contactRef = (0,react.useRef)(null);
    const { availableCTA ="" , userAlt ="" , specialtiesTxt ="" , contactTxt =""  } = staticTexts;
    let imageUrl = "";
    if (!imageUrl && data["desktop-banner-image"]) {
        imageUrl = data["desktop-banner-image"];
    } else if (!imageUrl) {
        imageUrl = image_missing/* default */.Z === null || image_missing/* default */.Z === void 0 ? void 0 : image_missing/* default.src */.Z.src;
    }
    (0,react.useEffect)(()=>{
        const element = document.getElementsByClassName("cmp-breadcrumb__list")[0];
        if (typeof element !== "undefined" && element !== null) {
            setBreadCrumb(element.innerHTML);
            document.querySelector(".breadcrumb").style.display = "none";
        }
    }, []);
    (0,react.useEffect)(()=>{
        if (data.contactInfo) {
            if (contactRef.current) {
                const links = contactRef.current.querySelectorAll("a");
                links.forEach((link)=>{
                    link.classList.add("gbh-data-layer");
                    const phone = link.textContent;
                    const url = link.getAttribute("href");
                    const isEmail = url.includes("mailto");
                    link.setAttribute("data-gbh-data-layer", v1_analytics_getEventInfo(phone, url, data === null || data === void 0 ? void 0 : data.proName, isEmail));
                });
            }
        }
    }, [
        data
    ]);
    const computeSocialMediaList = (0,react.useCallback)(()=>{
        const keyData = Object.keys(data);
        const socialMediaList = keyData.map((d)=>{
            const e = !d.match("@LastModified");
            if (e) {
                const matchedObjectKey = d.match("social-media-icon-path-");
                if (matchedObjectKey) {
                    const splitStr = matchedObjectKey["input"].split("-");
                    return {
                        icon: matchedObjectKey["input"],
                        alt: "social-media-alt-".concat(splitStr[4]),
                        redirectionLink: "social-media-redirection-link-".concat(splitStr[4]),
                        newTab: "newtab-".concat(splitStr[4])
                    };
                }
            }
            return null // Return null for non-matching keys
            ;
        }).filter((item)=>item !== null) // Filter out null values
        ;
        return socialMediaList;
    }, [
        data
    ]);
    const socialMediaList = computeSocialMediaList();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "virtual-designer-details",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "row top-section ml-0 mr-0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "col-12",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "virtual-designer-details__breadcrumb",
                            children: (0,helper/* sanitizeInnerHtml */.KD0)(breadCrumb)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "virtual-designer-details__container",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "row",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "virtual-designer-details__profile-section col-12 col-sm-12 col-md-5 col-lg-5 top-left",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "professional-name",
                                                children: data === null || data === void 0 ? void 0 : data.proName
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "profile-details",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "professional-details",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "professional-address",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "partner-address",
                                                                    children: (0,helper/* sanitizeInnerHtml */.KD0)(data === null || data === void 0 ? void 0 : data.address)
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "professional-designation mt-5",
                                                                children: data === null || data === void 0 ? void 0 : data.jobTitle
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "professional-availability",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "availability-days",
                                                                    children: (data === null || data === void 0 ? void 0 : data.available) === true ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: "available-btn",
                                                                        children: availableCTA
                                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "available-month",
                                                                        children: (0,helper/* sanitizeInnerHtml */.KD0)(data === null || data === void 0 ? void 0 : data.duration)
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "partner-photography",
                                                        children: (data === null || data === void 0 ? void 0 : data.image) && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: data === null || data === void 0 ? void 0 : data.image,
                                                            alt: userAlt
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "cover-image-wrapper col-12 col-sm-12 col-md-7 col-lg-7 px-0 top-right",
                                        children: data ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("picture", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                                    srcset: data["mobile-portrait-image"],
                                                    media: "(max-width: 489px)"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                                    srcset: data["mobile-landscape-image"],
                                                    media: "(max-width: 992px)"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    className: "cover-image",
                                                    src: imageUrl,
                                                    alt: data["alt-text-banner"]
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "virtual-designer-details__contact-section",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "kf-react-container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "row",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-12 col-sm-12 col-md-6 col-lg-6",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "profile-description",
                                    children: (0,helper/* sanitizeInnerHtml */.KD0)(data === null || data === void 0 ? void 0 : data.biography)
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-12 col-sm-12 col-md-6 col-lg-6",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "contact-wrapper",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "specialities",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "speciality-title",
                                                    children: specialtiesTxt
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "partner-address",
                                                    children: (0,helper/* sanitizeInnerHtml */.KD0)(data === null || data === void 0 ? void 0 : data.specialties)
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "contacts",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "contact-title",
                                                    children: contactTxt
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "contact-details",
                                                    ref: contactRef,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "partner-address",
                                                        children: (0,helper/* sanitizeInnerHtml */.KD0)(data === null || data === void 0 ? void 0 : data.contactInfo)
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "social-medias",
                                                    children: socialMediaList.map((s, i)=>{
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            href: data[s.redirectionLink],
                                                            className: "social-icon",
                                                            target: "".concat(data[s.newTab] ? "_blank" : ""),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                src: data[s.icon],
                                                                alt: data[s.alt]
                                                            })
                                                        }, i);
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var VirtualDesignerDetails_view = (VirtualDesignerDetailsView);

;// CONCATENATED MODULE: ./components/VirtualDesignerDetails/v1/VirtualDesignerDetails.jsx








const VirtualDesignerDetails = (props)=>{
    const { data: authorData  } = props;
    const staticTexts = i18n_useVirtuali18n({
        authorData
    });
    const [virtualData, setVirtualData] = (0,react.useState)({});
    const virtualDesignerDataUrl = get_default()(authorData, "designerFragLink", "");
    const virtualSanitizeURL = (0,helper/* removeAndCleanLink */.xEh)(virtualDesignerDataUrl);
    (0,react.useEffect)(()=>{
        (0,constants_api/* aemAxiosInstance */.Gb)({
            url: constants.GLOBAL_CONFIGURATION_ENDPOINT,
            params: {
                path: "".concat(virtualSanitizeURL, "/jcr:content/data/master.json")
            }
        }).then((response)=>{
            if (response && (response === null || response === void 0 ? void 0 : response.data)) {
                setVirtualData(response === null || response === void 0 ? void 0 : response.data);
            }
        }).catch((err)=>{
            console.log("Failed to get compare attributes JSON file", err);
        });
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(VirtualDesignerDetails_view, {
        staticTexts: staticTexts,
        data: virtualData
    });
};
/* harmony default export */ var v1_VirtualDesignerDetails = (VirtualDesignerDetails);

;// CONCATENATED MODULE: ./i18n/useFindAProByZipi18n.js

const useFindAProByZipi18n = (componentProp)=>{
    const { t  } = (0,esm/* useTranslation */.$G)();
    const i18n = {
        useMyLocation: t("kf.findpro.label.useMyLocation"),
        zipcodeDesc: (componentProp === null || componentProp === void 0 ? void 0 : componentProp.zipcodeDesc) ? componentProp === null || componentProp === void 0 ? void 0 : componentProp.zipcodeDesc : t("kf.findpro.label.zipcodeDesc"),
        zipcodeInfo: (componentProp === null || componentProp === void 0 ? void 0 : componentProp.zipcodeInfo) ? componentProp === null || componentProp === void 0 ? void 0 : componentProp.zipcodeInfo : t("kf.findpro.label.zipcodeInfo"),
        zipcodeLabel: t("kf.findpro.label.zipcodeLabel"),
        submitCTA: t("kf.findpro.label.submitCTA"),
        validZipcode: t("kf.findStoreUtilNav.validZipcode"),
        ariaLabel: {
            zipcodeLabel: t("kf.findpro.aria.label.zipcodeLabel")
        },
        continue: t("kf.checkout.label.continue")
    };
    return i18n;
};
/* harmony default export */ var i18n_useFindAProByZipi18n = (useFindAProByZipi18n);

// EXTERNAL MODULE: ./components/FindAProByZip/v1/index.module.scss
var FindAProByZip_v1_index_module = __webpack_require__(62271);
var FindAProByZip_v1_index_module_default = /*#__PURE__*/__webpack_require__.n(FindAProByZip_v1_index_module);
;// CONCATENATED MODULE: ./components/FindAProByZip/v1/analytics.js
const addUseMyLocationAnalytics = function() {
    let status = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", message = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", zipcode = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
    const eventInfo = {
        eventAction: "find a pro:see local professionals:use my location",
        eventName: "find a pro:see local professionals:use my location",
        eventType: "navigation",
        eventMsg: zipcode || message || "n/a",
        eventStatus: status,
        internalLinkName: "use my location",
        internalLinkPosition: "find a pro",
        internalLinkType: "find a pro:".concat(zipcode || "use my location"),
        internalLinkZoneName: "find a pro:see local professionals",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    window.adobeDataLayer.push({
        event: "cmp:click",
        page: page,
        eventInfo: eventInfo
    });
};
const getSubmitBtnAnalyticsData = function() {
    let zipcode = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", pageUrl = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    const url = pageUrl === null || pageUrl === void 0 ? void 0 : pageUrl.replace(".html", "");
    return JSON.stringify({
        eventAction: "find a pro:see local professionals:submit",
        eventName: "find a pro:see local professionals:submit",
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "submit",
        internalLinkPosition: "find a pro",
        internalLinkType: "find my pro:".concat(zipcode),
        internalLinkZoneName: "find a pro:see local professionals",
        internalLinkURL: "".concat(url, "?q=").concat(zipcode),
        clickInternalLinks: "true"
    });
};

;// CONCATENATED MODULE: ./components/FindAProByZip/v1/FindAProByZip.jsx










const FindAProByZip = (props)=>{
    var ref;
    const { data: componentProp = {}  } = props;
    const [zipcode, setZipcode] = (0,react.useState)("");
    const [zipCodeError, setZipCodeError] = (0,react.useState)("");
    const [infoModalError, setInfoModalError] = (0,react.useState)({});
    const [infoModal, setInfoModal] = (0,react.useState)(false);
    const [info, setInfo] = (0,react.useState)({});
    const [disableButton, setDisableButton] = (0,react.useState)(true);
    const staticTexts = i18n_useFindAProByZipi18n(JSON.parse((0,helper/* jsonStringEscape */.ASm)(JSON.stringify(componentProp))));
    const { validZipcode ="" , zipcodeInfo ="" , zipcodeDesc ="" , zipcodeLabel ="" , submitCTA ="" , useMyLocation =""  } = staticTexts;
    const handleChange = (e)=>{
        const { target: { value =""  } = {}  } = e !== null && e !== void 0 ? e : {};
        const inputValue = value === null || value === void 0 ? void 0 : value.trim();
        (0,helper/* validateField */.OP$)("zipCodeNumeric", inputValue).then((isValid)=>{
            if (isValid || inputValue === "") {
                setZipcode(inputValue);
            }
        });
    };
    const zipCodeCheck = function() {
        let zipVal = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
        const zipcodeValue = zipVal || zipcode;
        (0,helper/* validateField */.OP$)("zipCodeNumeric", zipcodeValue).then((isValid)=>{
            if (((zipVal === null || zipVal === void 0 ? void 0 : zipVal.length) || (zipcode === null || zipcode === void 0 ? void 0 : zipcode.length)) && !isValid) {
                setZipCodeError(validZipcode);
            } else {
                setZipCodeError("");
            }
        });
    };
    const getGeoLocation = ()=>{
        (0,helper/* getMyLocation */.fPm)().then((getLocation)=>{
            const { zipcode =""  } = getLocation !== null && getLocation !== void 0 ? getLocation : {};
            setZipcode(zipcode);
            zipCodeCheck(zipcode);
            if (zipcode) {
                addUseMyLocationAnalytics("success", "", zipcode);
            } else {
                addUseMyLocationAnalytics("failure", "failed to load zipcode");
            }
        }).catch((param)=>{
            let { cause  } = param;
            setInfoModalError(cause);
            setInfoModal(true);
            var ref;
            addUseMyLocationAnalytics("failure", (ref = cause === null || cause === void 0 ? void 0 : cause.message) !== null && ref !== void 0 ? ref : "");
        });
    };
    (0,react.useEffect)(()=>{
        (0,constants_config/* getConfig */.i)().then(async (config)=>{
            const locale = get_default()(config, "internationalization.locale", "");
            const currencySign = get_default()(config, "internationalization.currencySign", "");
            const currencyCode = get_default()(config, "internationalization.currencyCode", "");
            const findAProPageUrl = await (0,helper/* getShortenedUrl */.Ppy)(get_default()(config, "general.findProPagePath", ""));
            const info = {
                locale,
                currencySign,
                currencyCode,
                findAProPageUrl
            };
            setInfo(info);
        });
    }, []);
    (0,react.useEffect)(()=>{
        (0,helper/* validateField */.OP$)("zipCodeNumeric", zipcode).then((isValid)=>setDisableButton(!isValid));
    }, [
        zipcode
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((FindAProByZip_v1_index_module_default()) === null || (FindAProByZip_v1_index_module_default()) === void 0 ? void 0 : (FindAProByZip_v1_index_module_default()).findAProByZipWrapper),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "zipcode-page",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ZipCodeInfoModal/* default */.Z, {
                    handleModalClose: ()=>{
                        setInfoModal(false);
                    },
                    show: infoModal,
                    data: infoModalError,
                    pro: true,
                    labelledBy: "Geo-Location-pro-error-message",
                    className: "message-modal",
                    staticTexts: staticTexts,
                    dataLayerPosition: "find a pro"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "zipcode-page__main-container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "zipcode-page__inner-container",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "zipcode-page__zipcode-left",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "zipcode-info",
                                    children: (0,helper/* sanitizeInnerHtml */.KD0)(zipcodeInfo)
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "zipcode-page__zipcode-right",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "zipcode-description",
                                        children: (0,helper/* sanitizeInnerHtml */.KD0)(zipcodeDesc)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "zipcode-text-box",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                type: "text",
                                                className: "zipcodeInput",
                                                "aria-label": (ref = staticTexts.ariaLabel) === null || ref === void 0 ? void 0 : ref.zipcodeLabel,
                                                value: zipcode,
                                                onKeyUp: ()=>zipCodeCheck(),
                                                onFocus: ()=>zipCodeCheck(),
                                                placeholder: zipcodeLabel,
                                                onChange: (e)=>handleChange(e)
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                                label: submitCTA,
                                                className: "gbh-data-layer",
                                                "data-gbh-data-layer": getSubmitBtnAnalyticsData(zipcode, info === null || info === void 0 ? void 0 : info.findAProPageUrl),
                                                tag: "anchor",
                                                type: "primary",
                                                customClass: "submitCTA",
                                                to: "".concat(info === null || info === void 0 ? void 0 : info.findAProPageUrl, "?q=").concat(zipcode),
                                                disabled: disableButton,
                                                useDefaultClass: true
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "location-link-container",
                                        children: [
                                            zipCodeError && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "findstore-util-nav__zipcode-error",
                                                children: zipCodeError
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "location-link",
                                                tabIndex: "0",
                                                role: "link",
                                                onClick: ()=>getGeoLocation(),
                                                children: useMyLocation
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var v1_FindAProByZip = (FindAProByZip);

;// CONCATENATED MODULE: ./i18n/useStoreAppointmenti18n.js

const useStoreAppointmenti18n = ()=>{
    const { t  } = (0,esm/* useTranslation */.$G)();
    const i18n = {
        requestAnAppointment: t("kf.reqAppointment.label.requestAnAppointment"),
        reqAppointmentDesc: t("kf.reqAppointment.label.reqAppointmentDesc"),
        location: t("kf.reqAppointment.label.location"),
        stepOne: t("kf.reqAppointment.label.stepOne"),
        selectData: t("kf.reqAppointment.label.selectData"),
        availableTimes: t("kf.reqAppointment.label.availableTimes"),
        stepTwo: t("kf.reqAppointment.label.stepTwo"),
        fillYourContact: t("kf.reqAppointment.label.fillYourContact"),
        requiredFields: t("kf.reqAppointment.label.requiredFields"),
        firstName: t("kf.reqAppointment.label.firstName"),
        lastName: t("kf.reqAppointment.label.lastName"),
        email: t("kf.reqAppointment.label.email"),
        phone: t("kf.reqAppointment.label.phone"),
        fnameError: t("kf.reqAppointment.label.fnameError"),
        lnameError: t("kf.reqAppointment.label.lnameError"),
        validFirstName: t("kf.reqAppointment.label.validFirstName"),
        validLastName: t("kf.reqAppointment.label.validLastName"),
        noEmailError: t("kf.reqAppointment.label.noEmailError"),
        validEmail: t("kf.reqAppointment.label.validEmail"),
        validPhone: t("kf.reqAppointment.label.validPhone"),
        dateError: t("kf.reqAppointment.label.dateError"),
        timeError: t("kf.reqAppointment.label.timeError"),
        submit: t("kf.reqAppointment.label.submit"),
        privacyPolicy: t("kf.reqAppointment.label.privacyPolicy"),
        subjectAccess: t("kf.reqAppointment.label.subjectAccess"),
        termsOfService: t("kf.reqAppointment.label.termsOfService"),
        leftArrowAlt: t("kf.reqAppointment.label.leftArrowAlt"),
        rightArrowAlt: t("kf.reqAppointment.label.rightArrowAlt"),
        thankYouMsg: t("kf.reqAppointment.label.thankYouMsg"),
        thankYouDesc: t("kf.reqAppointment.label.thankYouDesc"),
        dateAndTime: t("kf.reqAppointment.label.dateAndTime"),
        viewStore: t("kf.reqAppointment.label.viewStore"),
        contactInfo: t("kf.reqAppointment.label.contactInfo"),
        done: t("kf.reqAppointment.label.done"),
        noImage: t("kf.reqAppointment.label.noImage"),
        date: t("kf.reqAppointment.label.date"),
        datePlaceholder: t("kf.reqAppointment.label.datePlaceholder"),
        at: t("kf.reqAppointment.label.at"),
        sunday: t("kf.reqAppointment.label.sunday"),
        monday: t("kf.reqAppointment.label.monday"),
        tuesday: t("kf.reqAppointment.label.tuesday"),
        wednesday: t("kf.reqAppointment.label.wednesday"),
        thursday: t("kf.reqAppointment.label.thursday"),
        friday: t("kf.reqAppointment.label.friday"),
        saturday: t("kf.reqAppointment.label.saturday"),
        january: t("kf.reqAppointment.label.january"),
        february: t("kf.reqAppointment.label.february"),
        march: t("kf.reqAppointment.label.march"),
        april: t("kf.reqAppointment.label.april"),
        may: t("kf.reqAppointment.label.may"),
        june: t("kf.reqAppointment.label.june"),
        july: t("kf.reqAppointment.label.july"),
        august: t("kf.reqAppointment.label.august"),
        september: t("kf.reqAppointment.label.september"),
        october: t("kf.reqAppointment.label.october"),
        november: t("kf.reqAppointment.label.november"),
        december: t("kf.reqAppointment.label.december"),
        weekDays: t("kf.reqAppointment.label.weekDays"),
        weekEnds: t("kf.reqAppointment.label.weekEnds"),
        wholeWeek: t("kf.reqAppointment.label.wholeWeek"),
        sat: t("kf.reqAppointment.label.sat"),
        sun: t("kf.reqAppointment.label.sun"),
        ariaLabel: {
            prevMonth: t("kf.reqAppointment.aria.label.prevMonth"),
            nextMonth: t("kf.reqAppointment.aria.label.nextMonth"),
            changeYear: t("kf.reqAppointment.aria.label.changeYear"),
            selectYear: t("kf.reqAppointment.aria.label.selectYear"),
            prevSlots: t("kf.reqAppointment.aria.label.prevSlots"),
            nextSlots: t("kf.reqAppointment.aria.label.nextSlots"),
            sunday: t("kf.reqAppointment.aria.label.sunday"),
            monday: t("kf.reqAppointment.aria.label.monday"),
            tuesday: t("kf.reqAppointment.aria.label.tuesday"),
            wednesday: t("kf.reqAppointment.aria.label.wednesday"),
            thursday: t("kf.reqAppointment.aria.label.thursday"),
            friday: t("kf.reqAppointment.aria.label.friday"),
            saturday: t("kf.reqAppointment.aria.label.saturday"),
            days: t("kf.reqAppointment.label.days"),
            selected: t("kf.reqAppointment.label.selected"),
            notSelected: t("kf.reqAppointment.label.notSelected")
        },
        genError: t("kf.error.message.genericError")
    };
    return i18n;
};
/* harmony default export */ var i18n_useStoreAppointmenti18n = (useStoreAppointmenti18n);

// EXTERNAL MODULE: ./public/icons/right-arrow.svg
var right_arrow = __webpack_require__(14074);
// EXTERNAL MODULE: ./public/icons/left-arrow.svg
var left_arrow = __webpack_require__(23896);
;// CONCATENATED MODULE: ./public/icons/left-arrow-disabled.svg
/* harmony default export */ var left_arrow_disabled = ({"src":"/_next/static/media/left-arrow-disabled.31a0710c.svg","height":17,"width":10});
// EXTERNAL MODULE: ./public/icons/calendar.svg
var calendar = __webpack_require__(65110);
;// CONCATENATED MODULE: ./components/core/DatePicker/DatePicker.jsx









const DatePicker = (props)=>{
    const { daysData =[] , monthsData =[] , isShowModal =false , startFromTomorrow =false , activeDay =""  } = props;
    const todayDate = new Date();
    const nextDayDate = new Date(+new Date() + constants.MILLISECONDSADAY);
    const currentYear = startFromTomorrow ? nextDayDate.getFullYear() : todayDate.getFullYear();
    const currentMonth = startFromTomorrow ? nextDayDate.getMonth() : todayDate.getMonth();
    const currentDate = startFromTomorrow ? nextDayDate.getDate() : todayDate.getDate();
    const [year, setYear] = (0,react.useState)(currentYear);
    const [month, setMonth] = (0,react.useState)(currentMonth);
    const [date, setDate] = (0,react.useState)(currentDate);
    const [selectedValue, setSelectedValue] = (0,react.useState)("".concat(monthsData[currentMonth], " ").concat(currentDate, ", ").concat(currentYear));
    const [selectedDate, setSelectedDate] = (0,react.useState)(!startFromTomorrow ? new Date() : nextDayDate);
    const [yearChange, setYearChange] = (0,react.useState)("static");
    const [isShowcalendar, setIsShowCalendar] = (0,react.useState)(false);
    const options = {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric"
    };
    const [isKeySelect, setIsKeySelect] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        props.getInputValue(currentYear + "/" + (currentMonth + 1) + "/" + currentDate);
    }, []);
    (0,react.useEffect)(()=>{
        if (activeDay !== "") {
            setSelectedDate(activeDay);
            setSelectedValue("".concat(monthsData[activeDay.getMonth()], " ").concat(activeDay.getDate(), ", ").concat(activeDay.getFullYear()));
            props.getInputValue("".concat(activeDay.getFullYear(), "/").concat(activeDay.getMonth() + 1, "/").concat(activeDay.getDate()));
        } else {
            setSelectedDate(!startFromTomorrow ? new Date() : nextDayDate);
        }
    }, [
        isShowModal
    ]);
    (0,react.useEffect)(()=>{
        if (isKeySelect) {
            var ref;
            const elem = (ref = document.getElementsByClassName("date-picker__point-date")) === null || ref === void 0 ? void 0 : ref[0];
            setElementFocus(elem);
            setIsKeySelect(false);
        }
    }, [
        date
    ]);
    const changeValue = (yearSelected, monthSelected, dateSelected)=>{
        setSelectedValue("".concat(monthsData[monthSelected], " ").concat(dateSelected, ", ").concat(yearSelected));
        props.dateValue("".concat(yearSelected, "/").concat(monthSelected + 1, "/").concat(dateSelected));
        props.getDayfromInput(new Date("".concat(monthsData[monthSelected], " ").concat(dateSelected, ", ").concat(yearSelected)).getDay());
    };
    const changeDate = (e)=>{
        setSelectedDate(new Date("".concat(e.target.dataset.year, "/").concat(Number(e.target.dataset.month) + 1, "/").concat(e.target.innerText)));
        changeValue(e.target.dataset.year, Number(e.target.dataset.month), e.target.innerText);
        setYear(Number(e.target.dataset.year));
        setMonth(Number(e.target.dataset.month));
        setDate(Number(e.target.innerText));
    };
    const prevMonth = ()=>{
        const yearData = month === 0 ? year - 1 : year;
        const monthData = month === 0 ? 11 : month - 1;
        setYear(yearData);
        setMonth(monthData);
    };
    const nextMonth = ()=>{
        const checkYear = month === 11 ? year + 1 : year;
        const checkMonth = month === 11 ? 0 : month + 1;
        setYear(checkYear);
        setMonth(checkMonth);
    };
    const classes = function(data) {
        let type = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
        const dataDate = data.getDate();
        const dataMonth = data.getMonth();
        const dataYear = data.getFullYear();
        if (type === "isCurrent" && dataDate === todayDate.getDate() && dataMonth === todayDate.getMonth() && dataYear === todayDate.getFullYear()) {
            return "date-picker__today";
        } else if (dataDate === selectedDate.getDate() && dataMonth === selectedDate.getMonth()) {
            return "date-picker__point-date";
        } else if ((props.hidePast && dataMonth === currentMonth && dataDate < currentDate || dataMonth < currentMonth) && dataYear === currentYear || dataYear < currentYear) {
            return "date-picker__past";
        }
        return "date-picker__inner-date";
    };
    const changeYear = ()=>{
        setYearChange("input");
        setTimeout(()=>{
            const input = document.querySelector(".date-picker__year-input");
            input.focus();
        }, 100);
    };
    const inputChange = ()=>{
        const input = document.querySelector(".date-picker__year-input");
        const year = parseInt(input.value);
        let yearSelected = year;
        if (year < currentYear || !year) {
            yearSelected = currentYear;
        } else if (year > 3000) {
            yearSelected = 2999;
        }
        setYear(yearSelected);
        setYearChange("static");
        setSelectedValue(monthsData[month] + " " + date + ", " + yearSelected);
    };
    const handleKeyup = (e)=>{
        if (e.keyCode === 13) {
            inputChange();
        }
    };
    const firstDay = new Date(year, month).getDay();
    const dates = [];
    for(let i = 1; i <= 42; i++){
        dates.push(new Date(year, month, i - firstDay));
    }
    const hanldeCalendarShow = ()=>setIsShowCalendar(!isShowcalendar);
    const handleKeyDown = (e)=>{
        if (e.key === "ArrowLeft" || e.key === "ArrowRight") {
            const elem = e.key === "ArrowLeft" ? e.target.previousSibling : e.target.nextSibling;
            e.target.tabIndex = -1;
            setElementFocus(elem);
        } else if (e.key === "Enter") {
            e.target.tabIndex = -1;
            setIsKeySelect(true);
        }
    };
    const setElementFocus = (elem)=>{
        if (elem && (elem.className === "date-picker__inner-date" || elem.className === "date-picker__point-date" || elem.className === "date-picker__today")) {
            elem.tabIndex = 0;
            elem.focus();
        }
    };
    const getAriaLabel = (date, classes, props, options)=>{
        switch(classes(date)){
            case "date-picker__point-date":
                return "".concat(props.i18n.ariaLabel.selected, " ").concat(date.toLocaleDateString("en-US", options));
            case "date-picker__out-date":
                return date.toLocaleDateString("en-US", options);
            default:
                return "".concat(props.i18n.ariaLabel.notSelected, " ").concat(date.toLocaleDateString("en-US", options));
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "date-picker",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
            children: [
                props.hideInput && lib/* isMobile */.tq && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "date-picker__show-input",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                        id: "date-picker__input",
                        type: "text",
                        value: selectedValue,
                        maxLength: 60,
                        placeholder: "".concat(props.i18n.datePlaceholder, "*"),
                        label: "".concat(props.i18n.datePlaceholder, "*"),
                        onChange: ()=>props.dateValue(year + "/" + monthsData[month] + "/" + date),
                        onFocus: hanldeCalendarShow,
                        showError: props.error,
                        errorMessage: props.message,
                        prefix: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: calendar/* default */.Z === null || calendar/* default */.Z === void 0 ? void 0 : calendar/* default.src */.Z.src
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "date-picker__calendar  ".concat(!lib/* isMobile */.tq && props.hideInput ? "date-picker__positioning" : "", " ").concat(isShowcalendar ? "date-picker__calendar-show" : ""),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "date-picker__header",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "date-picker__month-and-year",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "date-picker__month",
                                            children: monthsData[month]
                                        }),
                                        yearChange === "static" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "date-picker__change-year",
                                            tabIndex: "0",
                                            onClick: changeYear,
                                            onFocus: changeYear,
                                            children: year
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            className: "date-picker__year-input",
                                            role: "combobox",
                                            type: "number",
                                            "aria-label": props.i18n.ariaLabel.selectYear,
                                            min: currentYear,
                                            max: "2999",
                                            defaultValue: year,
                                            onKeyUp: handleKeyup,
                                            onBlur: inputChange
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "date-picker__month",
                                            role: "alert",
                                            "aria-live": "polite",
                                            "aria-label": "".concat(monthsData[month], " ").concat(year)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "date-picker__change-month",
                                    children: [
                                        props.hidePast && month === currentMonth && year === currentYear ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            "aria-disabled": "true",
                                            tabIndex: "0",
                                            role: "button",
                                            "aria-label": props.i18n.ariaLabel.prevMonth,
                                            src: left_arrow_disabled === null || left_arrow_disabled === void 0 ? void 0 : left_arrow_disabled.src,
                                            alt: props.i18n.leftArrowAlt,
                                            className: "date-picker__prev-month-disabled"
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            tabIndex: "0",
                                            role: "button",
                                            "aria-label": props.i18n.ariaLabel.prevMonth,
                                            src: left_arrow/* default */.Z === null || left_arrow/* default */.Z === void 0 ? void 0 : left_arrow/* default.src */.Z.src,
                                            alt: props.i18n.leftArrowAlt,
                                            className: "date-picker__prev-month",
                                            onClick: prevMonth
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            tabIndex: "0",
                                            role: "button",
                                            "aria-label": props.i18n.ariaLabel.nextMonth,
                                            src: right_arrow/* default */.Z === null || right_arrow/* default */.Z === void 0 ? void 0 : right_arrow/* default.src */.Z.src,
                                            alt: props.i18n.rightArrowAlt,
                                            className: "date-picker__next-month",
                                            onClick: nextMonth
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "date-picker__content",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                    className: "date-picker__nav",
                                    role: "list",
                                    "aria-label": props.i18n.ariaLabel.days,
                                    children: daysData.map((day, i)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                            role: "listitem",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    "aria-hidden": "true",
                                                    children: day.substr(0, 2)
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "sr-only",
                                                    children: day
                                                })
                                            ]
                                        }, i))
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                    className: "date-picker__dates",
                                    children: dates.map((date, i)=>classes(date) === "date-picker__past" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: classes(date),
                                            "aria-disabled": "true",
                                            "aria-hidden": "true",
                                            disabled: true,
                                            children: date.getDate()
                                        }, i) : /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: classes(date),
                                            "data-year": date.getFullYear().toString(),
                                            "data-month": date.getMonth().toString(),
                                            onClick: changeDate,
                                            onKeyDown: handleKeyDown,
                                            "aria-current": classes(date, "isCurrent") === "date-picker__today",
                                            "aria-disabled": classes(date) === "date-picker__out-date",
                                            tabIndex: classes(date) === "date-picker__point-date" ? 0 : -1,
                                            "aria-label": getAriaLabel(date, classes, props, options),
                                            role: "button",
                                            "aria-selected": classes(date) === "date-picker__point-date",
                                            children: date.getDate()
                                        }, i))
                                }),
                                props.hideInput && lib/* isMobile */.tq ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "date-picker__select-done",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        onClick: hanldeCalendarShow,
                                        children: props.i18n.done
                                    })
                                }) : null
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var DatePicker_DatePicker = (DatePicker);

// EXTERNAL MODULE: ./components/RegisterOnlineProduct/v1/RegisterOnlineHelper.js
var RegisterOnlineHelper = __webpack_require__(73058);
;// CONCATENATED MODULE: ./components/StoreAppointment/v1/analytics.js

const getLegalPageAnalytics = function(storeData, title, link) {
    let needJSON = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    const internalLinkType = "find a store:".concat((0,helper/* getInternalLinkTypeForFindStore */.dhb)(storeData.BillingStreet, storeData.BillingCity, storeData.BillingState, storeData.AEM_Microsite_Name__c));
    const eventAction = "find a store:store detail page:store experience:modal:book an appointment:".concat(title);
    const internalLinkZoneName = "find a store:store detail page:store experience:modal:book an appointment";
    let internalLinkName;
    switch(title){
        case "thankyou:done":
            internalLinkName = "done";
            break;
        case "thankyou:view store details":
            internalLinkName = "view store details";
            break;
        case "thankyou:close":
            internalLinkName = "close";
            break;
        default:
            internalLinkName = title;
    }
    let modifiedInternalLinkZoneName = internalLinkZoneName;
    if (title === "thankyou:done" || title === "thankyou:view store details" || title === "thankyou:close") {
        modifiedInternalLinkZoneName += ":thankyou";
    }
    const eventInfo = {
        eventAction,
        eventName: eventAction,
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName,
        internalLinkPosition: "store appointment",
        internalLinkType,
        internalLinkZoneName: modifiedInternalLinkZoneName,
        internalLinkURL: link ? link.indexOf("http") === -1 ? window.location.origin + link : link : "n/a",
        clickInternalLinks: "true"
    };
    if (needJSON) {
        return eventInfo;
    }
    return JSON.stringify(eventInfo);
};
const addBookAppointmentAnalytics = (params)=>{
    const { storeData , status , action , errorMessage , appointmentDate , appointmentTime  } = params;
    let eventMsg = "n/a";
    if (status && status !== "success" && (errorMessage === null || errorMessage === void 0 ? void 0 : errorMessage.length)) {
        eventMsg = errorMessage.join("|").toLowerCase();
    }
    // adding analytics
    const eventInfo = getLegalPageAnalytics(storeData, "submit", null, true);
    eventInfo.eventStatus = status;
    eventInfo.eventMsg = eventMsg;
    eventInfo.appointmentDate = appointmentDate || "n/a";
    eventInfo.appointmentTime = appointmentTime || "n/a";
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = action === "cmp:show" ? window.pageObj : getState && getState("page") || {};
    window.adobeDataLayer.push({
        event: action,
        page,
        eventInfo
    });
    delete window.pageObj;
};
const handleExternalLinkAnalytics = (storeData, title, link)=>{
    // Construct analytics data
    const internalLinkType = "find a store:".concat((0,helper/* getInternalLinkTypeForFindStore */.dhb)(storeData.BillingStreet, storeData.BillingCity, storeData.BillingState, storeData.AEM_Microsite_Name__c));
    const eventAction = "find a store:store detail page:store experience:modal:book an appointment::".concat(title);
    const internalLinkZoneName = "find a store:store detail page:store experience:modal:book an appointment";
    let internalLinkName;
    switch(title){
        case "thankyou:done":
            internalLinkName = "done";
            break;
        case "thankyou:view store details":
            internalLinkName = "view store details";
            break;
        case "thankyou:close":
            internalLinkName = "close";
            break;
        default:
            internalLinkName = title;
    }
    let modifiedInternalLinkZoneName = internalLinkZoneName;
    if (title === "thankyou:done" || title === "thankyou:view store details" || title === "thankyou:close") {
        modifiedInternalLinkZoneName += ":thankyou";
    }
    const internalLink = link ? link.indexOf("http") === -1 ? window.location.origin + link : link : "n/a";
    const analyticsData = {
        event: "cmp:click",
        eventInfo: {
            clickInternalLinks: "true",
            eventAction,
            eventName: eventAction,
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName,
            internalLinkPosition: "store appointment",
            internalLinkType,
            internalLinkZoneName: modifiedInternalLinkZoneName,
            internalLinkURL: internalLink
        }
    };
    // Push analytics data
    if (window.adobeDataLayer) {
        window.adobeDataLayer.push(analyticsData);
    } else {
        window.adobeDataLayer = [
            analyticsData
        ];
    }
    window.open(internalLink);
};
const getRecaptchaBookAppointmentAnalytics = (internalLinkType)=>{
    return {
        pageTitle: "find a store:landing:modal:book appointment",
        componentName: "book an appointment",
        parentComponent1: "find a store",
        parentComponent2: "store detail page",
        internalLinkPosition: "find a store",
        internalLinkType: "".concat(internalLinkType.indexOf("find a store") === -1 ? "find a store:" : "").concat(internalLinkType, ":google")
    };
};

;// CONCATENATED MODULE: ./public/icons/right-arrow-disabled.svg
/* harmony default export */ var right_arrow_disabled = ({"src":"/_next/static/media/right-arrow-disabled.7d4bd102.svg","height":17,"width":10});
// EXTERNAL MODULE: ./public/icons/email.svg
var email = __webpack_require__(39306);
// EXTERNAL MODULE: ./public/icons/phone-icon.svg
var phone_icon = __webpack_require__(52324);
// EXTERNAL MODULE: ./components/StoreAppointment/v1/index.module.scss
var StoreAppointment_v1_index_module = __webpack_require__(72681);
var StoreAppointment_v1_index_module_default = /*#__PURE__*/__webpack_require__.n(StoreAppointment_v1_index_module);
;// CONCATENATED MODULE: ./components/StoreAppointment/v1/StoreAppointmentView.jsx






















const StoreAppointmentView = (props)=>{
    const { bpNumber ="" , daysData =[] , getAppointmentDate =()=>{} , getUrlData ={} , hideInput =false , hidePast =false , i18n ={} , isSuccess =false , legalPathLinks ={} , monthsData =[] , onModalClose =()=>{} , requestAppointment =()=>{} , successData ={} , getStoreData ={} , loading =false , internalLinkType =""  } = props;
    const { isShowAppointmentModal  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const [activeId, setActiveId] = (0,react.useState)(null);
    const [selectedTime, setSelectedTime] = (0,react.useState)("");
    const [currentSlotPage, setCurrentSlotPage] = (0,react.useState)(1);
    const [availableTimeData, setAvailableTimeData] = (0,react.useState)([]);
    const tomorrowFullDate = new Date(+new Date() + 86400000);
    const nextDay = tomorrowFullDate.getFullYear() + "/" + (tomorrowFullDate.getMonth() + 1) + "/" + tomorrowFullDate.getDate();
    const [dateInputVal, setDateInputVal] = (0,react.useState)(nextDay);
    const [dayVal, setDayVal] = (0,react.useState)(tomorrowFullDate.getDay());
    const [data, setData] = (0,react.useState)({
        date: {
            value: "",
            error: false,
            message: ""
        },
        firstName: {
            value: "",
            error: false,
            message: ""
        },
        lastName: {
            value: "",
            error: false,
            message: ""
        },
        email: {
            value: "",
            error: false,
            message: ""
        },
        phone: {
            value: "",
            error: false,
            message: ""
        },
        time: {
            value: selectedTime,
            error: false,
            timeError: ""
        }
    });
    const [activeDay, setActiveDay] = (0,react.useState)(tomorrowFullDate);
    const [isSelectFromPicker, setSelectFromPicker] = (0,react.useState)(false);
    const [isNextDay, setisNextDay] = (0,react.useState)(nextDay === dateInputVal);
    const [storeDetailUrl, setStoreDetailUrl] = (0,react.useState)("");
    const dispatch = (0,es/* useDispatch */.I0)();
    (0,react.useEffect)(()=>{
        setisNextDay(dateInputVal === nextDay);
    }, []);
    (0,react.useEffect)(()=>{
        getAvailableTimes();
    }, [
        getStoreData
    ]);
    (0,react.useEffect)(()=>{
        if (!isEmpty_default()(getStoreData)) {
            getAvailableTimes();
            getAvailableTimeData();
        }
    }, [
        dayVal,
        isNextDay
    ]);
    (0,react.useEffect)(()=>{
        if (successData) {
            (0,helper/* getShortenedUrl */.Ppy)(successData.storeDetailUrl).then((res)=>{
                setStoreDetailUrl(res);
            });
        }
    }, [
        successData
    ]);
    (0,react.useEffect)(()=>{
        setDayVal(activeDay.getDay());
        setDateInputVal("".concat(activeDay.getFullYear(), "/").concat(activeDay.getMonth() + 1, "/").concat(activeDay.getDate()));
    }, [
        activeDay
    ]);
    const clearErrors = ()=>{
        const curData = data;
        if (curData) {
            for(const item in curData){
                if (Object.prototype.hasOwnProperty.call(curData, item)) {
                    curData[item].error = false;
                    curData[item].message = "";
                }
            }
            setData(curData);
        }
    };
    const getAvailableTimes = ()=>{
        const { getStoreData: { Appointment_Hours_Sunday__c: appointmentHoursSunday , Appointment_Hours_Saturday__c: appointmentHoursSat , Appointment_Hours_M_F__c: appointmentHoursMF  }  } = props;
        if (!isEmpty_default()(getStoreData)) {
            const checkDisabledTime = [];
            let splitAppointmentHoursInArr = [];
            if (dayVal === 0) {
                splitAppointmentHoursInArr = appointmentHoursSunday !== "Closed" ? appointmentHoursSunday === null || appointmentHoursSunday === void 0 ? void 0 : appointmentHoursSunday.split(";") : [];
            } else if (dayVal === 6) {
                splitAppointmentHoursInArr = appointmentHoursSat !== "Closed" ? appointmentHoursSat === null || appointmentHoursSat === void 0 ? void 0 : appointmentHoursSat.split(";") : [];
            } else {
                splitAppointmentHoursInArr = appointmentHoursMF === null || appointmentHoursMF === void 0 ? void 0 : appointmentHoursMF.split(";");
            }
            if ((splitAppointmentHoursInArr === null || splitAppointmentHoursInArr === void 0 ? void 0 : splitAppointmentHoursInArr.length) === 0 && !isSelectFromPicker) {
                setActiveDay(new Date(activeDay.setDate(activeDay.getDate() + 1)));
                return;
            }
            splitAppointmentHoursInArr === null || splitAppointmentHoursInArr === void 0 ? void 0 : splitAppointmentHoursInArr.forEach((item)=>checkDisabledTime.push({
                    time: item
                }));
            setAvailableTimeData(checkDisabledTime);
        }
    };
    const getTime = (id, time)=>{
        setActiveId(id);
        setData({
            ...data,
            time: {
                error: false,
                value: time,
                message: ""
            }
        });
        setSelectedTime(time);
    };
    const handleSubmit = ()=>{
        clearErrors();
        setTimeout(async ()=>{
            const obj = {};
            let valid = true;
            const errorMessage = [];
            if (!data.firstName.value) {
                obj.firstName = {
                    ...data.firstName,
                    error: true,
                    message: i18n.fnameError
                };
                valid = false;
                errorMessage.push(i18n.fnameError);
            } else if (!await (0,helper/* validateName */.Olw)(data.firstName.value)) {
                obj.firstName = {
                    ...data.firstName,
                    error: true,
                    message: i18n.validFirstName
                };
                valid = false;
                errorMessage.push(i18n.validFirstName);
            }
            if (!data.lastName.value) {
                obj.lastName = {
                    ...data.lastName,
                    error: true,
                    message: i18n.lnameError
                };
                valid = false;
                errorMessage.push(i18n.lnameError);
            } else if (!await (0,helper/* validateName */.Olw)(data.lastName.value)) {
                obj.lastName = {
                    ...data.lastName,
                    error: true,
                    message: i18n.validLastName
                };
                valid = false;
                errorMessage.push(i18n.validLastName);
            }
            if (!data.email.value) {
                obj.email = {
                    ...data.email,
                    error: true,
                    message: i18n.noEmailError
                };
                valid = false;
                errorMessage.push(i18n.noEmailError);
            } else if (!await (0,helper/* validateField */.OP$)("email", data.email.value)) {
                obj.email = {
                    ...data.email,
                    error: true,
                    message: i18n.validEmail
                };
                valid = false;
                errorMessage.push(i18n.validEmail);
            }
            if (!(0,helper/* validatePhone */.a$Q)(data.phone.value)) {
                obj.phone = {
                    ...data.phone,
                    error: true,
                    message: i18n.validPhone
                };
                valid = false;
                errorMessage.push(i18n.validPhone);
            }
            if (isEmpty_default()(dateInputVal)) {
                obj.date = {
                    ...data.date,
                    error: true,
                    message: i18n.dateError
                };
                valid = false;
                errorMessage.push(i18n.dateError);
            }
            if (isEmpty_default()(selectedTime)) {
                obj.time = {
                    ...data.time,
                    error: true,
                    timeError: i18n.timeError
                };
                valid = false;
                errorMessage.push(i18n.timeError);
            }
            const newData = {
                ...data,
                ...obj
            };
            setData(newData);
            if (valid) {
                const appointmentDate = monthsData[new Date(dateInputVal).getMonth()] + " " + new Date(dateInputVal).getDate() + ", " + new Date(dateInputVal).getFullYear() + " " + i18n.at + " " + selectedTime;
                const body = {
                    Interaction_Type__c: "Appointment",
                    Preferred_Email__c: get_default()(data, "email.value", ""),
                    PreferredPhone: get_default()(data, "phone.value", ""),
                    BP_Number__c: bpNumber,
                    LastName__c: get_default()(data, "lastName.value", ""),
                    FirstName__c: get_default()(data, "firstName.value", ""),
                    Appointment_Date_Time__c: dateInputVal.replaceAll("/", "-") + " " + selectedTime
                };
                (0,ReCaptcha/* validateRecaptcha */.L)().then((res)=>{
                    if (res.success) {
                        getAppointmentDate(appointmentDate);
                        requestAppointment(body, appointmentDate);
                    } else {
                        dispatch((0,genericSlice/* showToast */.CF)({
                            message: i18n === null || i18n === void 0 ? void 0 : i18n.genError,
                            isVisible: true
                        }));
                    }
                });
            } else {
                const appointmentDate1 = monthsData[new Date(dateInputVal).getMonth()] + " " + new Date(dateInputVal).getDate() + ", " + new Date(dateInputVal).getFullYear();
                addBookAppointmentAnalytics({
                    storeData: getStoreData,
                    action: "cmp:click",
                    status: "failure",
                    errorMessage: errorMessage,
                    appointmentDate: appointmentDate1,
                    appointmentTime: selectedTime
                });
            }
        }, 100);
    };
    const handleExternalLinkClick = (e, storeData, title, link)=>{
        e.preventDefault();
        handleExternalLinkAnalytics(storeData, title, link);
    };
    const onBlurInput = async (name, value)=>{
        switch(name){
            case "fname":
                if (!value) {
                    setData({
                        ...data,
                        firstName: {
                            error: true,
                            value: value,
                            message: i18n.fnameError
                        }
                    });
                } else if (!await (0,helper/* validateName */.Olw)(value)) {
                    setData({
                        ...data,
                        firstName: {
                            error: true,
                            value: value,
                            message: i18n.validFirstName
                        }
                    });
                } else {
                    setData({
                        ...data,
                        firstName: {
                            error: false,
                            value: value,
                            message: ""
                        }
                    });
                }
                break;
            case "lname":
                if (!value) {
                    setData({
                        ...data,
                        lastName: {
                            error: true,
                            value: value,
                            message: i18n.lnameError
                        }
                    });
                } else if (!await (0,helper/* validateName */.Olw)(value)) {
                    setData({
                        ...data,
                        lastName: {
                            error: true,
                            value: value,
                            message: i18n.validLastName
                        }
                    });
                } else {
                    setData({
                        ...data,
                        lastName: {
                            error: false,
                            value: value,
                            message: ""
                        }
                    });
                }
                break;
            case "email":
                if (!value) return setData({
                    ...data,
                    email: {
                        error: true,
                        value: value,
                        message: i18n.noEmailError
                    }
                });
                if (!await (0,helper/* validateField */.OP$)("email", value)) setData({
                    ...data,
                    email: {
                        error: true,
                        value: value,
                        message: i18n.validEmail
                    }
                });
                else setData({
                    ...data,
                    email: {
                        error: false,
                        value: value,
                        message: ""
                    }
                });
                break;
            case "phone":
                if (!(0,helper/* validatePhone */.a$Q)(value)) {
                    setData({
                        ...data,
                        phone: {
                            error: true,
                            value: value,
                            message: i18n.validPhone
                        }
                    });
                } else setData({
                    ...data,
                    phone: {
                        error: false,
                        value: value,
                        message: ""
                    }
                });
                break;
            default:
                return;
        }
    };
    const checkDisabled = (data)=>{
        if (data.firstName.value && data.lastName.value && data.email.value && data.phone.value) return false;
        return true;
    };
    const showPrevious = ()=>{
        if (currentSlotPage !== 1) {
            setCurrentSlotPage((currentSlotPage)=>currentSlotPage - 1);
        }
    };
    const showNext = ()=>{
        if (currentSlotPage < Math.ceil(availableTimeData.length / 12)) {
            setCurrentSlotPage((currentSlotPage)=>currentSlotPage + 1);
        }
    };
    const getAvailableTimeData = ()=>{
        let getavailableTimes = [];
        const startIndex = currentSlotPage * 12 - 12;
        const endIndex = startIndex + 12;
        if (!isEmpty_default()(getStoreData)) {
            availableTimeData.sort(function(a, b) {
                return new Date(nextDay + " " + a.time) - new Date(nextDay + " " + b.time);
            });
            getavailableTimes = availableTimeData.slice(startIndex, endIndex);
        }
        return getavailableTimes;
    };
    const getDayVal = (val)=>{
        setSelectFromPicker(true);
        setDayVal(val);
        setCurrentSlotPage(1);
    };
    const getInputValue = (val)=>{
        setDateInputVal(val);
    };
    const handleChangeDatePicker = (val)=>{
        setSelectFromPicker(true);
        setisNextDay(val === nextDay);
        setDateInputVal(val);
        setData({
            ...data,
            date: {
                value: val,
                error: false,
                message: ""
            }
        });
    };
    const modalClose = ()=>{
        onModalClose();
        setActiveId(null);
        setDateInputVal(new Date().getFullYear() + "/" + (new Date().getMonth() + 1) + "/" + new Date().getDate());
        setData({
            date: {
                value: "",
                error: false,
                message: ""
            },
            firstName: {
                value: "",
                error: false,
                message: ""
            },
            lastName: {
                value: "",
                error: false,
                message: ""
            },
            email: {
                value: "",
                error: false,
                message: ""
            },
            phone: {
                value: "",
                error: false,
                message: ""
            },
            time: {
                value: "",
                error: false,
                timeError: ""
            }
        });
        setSelectedTime("");
        setDayVal(tomorrowFullDate.getDay());
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (StoreAppointment_v1_index_module_default()).storeAppointMentWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "store-appointment",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal["default"], {
                onModalClose: modalClose,
                modalTitle: getUrlData.title,
                showModal: isShowAppointmentModal,
                closeButtonAnalytics: getLegalPageAnalytics(getStoreData, isSuccess ? "thankyou:close" : "close"),
                children: !isSuccess ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "row ml-0 mr-0",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "col-12 store-appointment__header",
                                children: [
                                    !isEmpty_default()(getUrlData) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                className: "store-appointment__heading",
                                                children: getUrlData.title
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "store-appointment__desc",
                                                children: (0,helper/* sanitizeInnerHtml */.KD0)(getUrlData.description)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "store-appointment__location",
                                        children: i18n.location
                                    }),
                                    !isEmpty_default()(getStoreData) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "store-appointment__store",
                                                children: getStoreData.AEM_Microsite_Name__c
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "store-appointment__address",
                                                children: getStoreData.BillingStreet + ", " + getStoreData.BillingCity + ", " + getStoreData.BillingState + " " + getStoreData.BillingPostalCode
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "row ml-0 mr-0",
                            role: "group",
                            "aria-label": i18n.stepOne + ": " + i18n.selectData,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-12 store-appointment__select-date",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "store-appointment__step",
                                        children: i18n.stepOne + ": " + i18n.selectData
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-12 store-appointment__select-date-time",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "row",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "col-12 col-md-6",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DatePicker_DatePicker, {
                                                    daysData: daysData,
                                                    monthsData: monthsData,
                                                    hideInput: hideInput,
                                                    i18n: i18n,
                                                    dateValue: (val)=>handleChangeDatePicker(val),
                                                    getInputValue: (val)=>getInputValue(val),
                                                    error: data.date.error,
                                                    data: data,
                                                    getDayfromInput: (value)=>getDayVal(value),
                                                    hidePast: hidePast,
                                                    isShowModal: isShowAppointmentModal,
                                                    startFromTomorrow: true,
                                                    activeDay: activeDay
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "col-12 col-md-6",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "store-appointment__available-time",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "store-appointment__available-txt",
                                                                children: i18n.availableTimes
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "store-appointment__available-arrow",
                                                                children: [
                                                                    currentSlotPage === 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                        "aria-disabled": "true",
                                                                        role: "button",
                                                                        tabIndex: "0",
                                                                        "aria-label": i18n.ariaLabel.prevSlots,
                                                                        src: left_arrow_disabled === null || left_arrow_disabled === void 0 ? void 0 : left_arrow_disabled.src,
                                                                        alt: i18n.leftArrowAlt,
                                                                        className: "store-appointment__left-arrow-disable"
                                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                        role: "button",
                                                                        tabIndex: "0",
                                                                        "aria-label": i18n.ariaLabel.prevSlots,
                                                                        src: left_arrow/* default */.Z === null || left_arrow/* default */.Z === void 0 ? void 0 : left_arrow/* default.src */.Z.src,
                                                                        alt: i18n.leftArrowAlt,
                                                                        onClick: showPrevious,
                                                                        className: "store-appointment__arrow"
                                                                    }),
                                                                    currentSlotPage === Math.ceil(availableTimeData.length / 12) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                        "aria-disabled": "true",
                                                                        role: "button",
                                                                        tabIndex: "0",
                                                                        "aria-label": i18n.ariaLabel.nextSlots,
                                                                        src: right_arrow_disabled === null || right_arrow_disabled === void 0 ? void 0 : right_arrow_disabled.src,
                                                                        alt: i18n.rightArrowAlt,
                                                                        className: "store-appointment__right-arrow-disable"
                                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                        role: "button",
                                                                        tabIndex: "0",
                                                                        "aria-label": i18n.ariaLabel.nextSlots,
                                                                        src: right_arrow/* default */.Z === null || right_arrow/* default */.Z === void 0 ? void 0 : right_arrow/* default.src */.Z.src,
                                                                        alt: i18n.rightArrowAlt,
                                                                        className: "store-appointment__arrow",
                                                                        onClick: showNext
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "store-appointment__available-container",
                                                        role: "listbox",
                                                        children: getAvailableTimeData().map((item, i)=>{
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                tabIndex: "0",
                                                                role: "option",
                                                                "aria-selected": i === activeId,
                                                                className: "store-appointment__available-time-card ".concat(i === activeId ? "--active" : ""),
                                                                onClick: ()=>getTime(i, item.time),
                                                                children: item.time
                                                            }, i);
                                                        })
                                                    }),
                                                    data.time.error && isEmpty_default()(selectedTime) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "input-field__error-message",
                                                        role: "alert",
                                                        children: i18n.timeError
                                                    }) : null
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "row ml-0 mr-0",
                            role: "group",
                            "aria-label": i18n.stepTwo + ": " + i18n.fillYourContact,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "col-12 store-appointment__contact-heading",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "store-appointment__step",
                                            children: i18n.stepTwo + ": " + i18n.fillYourContact
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "store-appointment__required",
                                            children: i18n.requiredFields
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "col-12 store-appointment__contact-details",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "row",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "col-12 col-md-6",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                                        id: "firstname",
                                                        type: "text",
                                                        value: data.firstName.value,
                                                        maxLength: 40,
                                                        placeholder: "".concat(i18n.firstName, "*"),
                                                        label: "".concat(i18n.firstName, "*"),
                                                        onChange: (e)=>setData({
                                                                ...data,
                                                                firstName: {
                                                                    value: e.target.value,
                                                                    error: false,
                                                                    message: ""
                                                                }
                                                            }),
                                                        showError: data.firstName.error,
                                                        errorMessage: data.firstName.message,
                                                        onBlur: ()=>onBlurInput("fname", data.firstName.value)
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "col-12 col-md-6",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                                        id: "lastname",
                                                        type: "text",
                                                        value: data.lastName.value,
                                                        maxLength: 40,
                                                        placeholder: "".concat(i18n.lastName, "*"),
                                                        label: "".concat(i18n.lastName, "*"),
                                                        onChange: (e)=>setData({
                                                                ...data,
                                                                lastName: {
                                                                    value: e.target.value,
                                                                    error: false,
                                                                    message: ""
                                                                }
                                                            }),
                                                        showError: data.lastName.error,
                                                        errorMessage: data.lastName.message,
                                                        onBlur: ()=>onBlurInput("lname", data.lastName.value)
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "row",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "col-12",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                                    id: "email",
                                                    type: "text",
                                                    value: data.email.value,
                                                    maxLength: 60,
                                                    placeholder: "".concat(i18n.email, "*"),
                                                    label: "".concat(i18n.email, "*"),
                                                    onChange: (e)=>setData({
                                                            ...data,
                                                            email: {
                                                                value: e.target.value,
                                                                error: false,
                                                                message: ""
                                                            }
                                                        }),
                                                    showError: data.email.error,
                                                    errorMessage: data.email.message,
                                                    prefix: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: email/* default */.Z === null || email/* default */.Z === void 0 ? void 0 : email/* default.src */.Z.src,
                                                        alt: i18n.email
                                                    }),
                                                    onBlur: ()=>onBlurInput("email", data.email.value)
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "row",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "col-12",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                                    id: "phone",
                                                    type: "text",
                                                    value: data.phone.value,
                                                    maxLength: 60,
                                                    placeholder: "".concat(i18n.phone, "*"),
                                                    label: "".concat(i18n.phone, "*"),
                                                    onChange: (e)=>setData({
                                                            ...data,
                                                            phone: {
                                                                value: (0,RegisterOnlineHelper/* convertToPhoneNumber */["in"])(e.target.value),
                                                                error: false,
                                                                message: ""
                                                            }
                                                        }),
                                                    showError: data.phone.error,
                                                    errorMessage: data.phone.message,
                                                    prefix: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: phone_icon/* default */.Z === null || phone_icon/* default */.Z === void 0 ? void 0 : phone_icon/* default.src */.Z.src,
                                                        alt: i18n.phone
                                                    }),
                                                    onBlur: ()=>onBlurInput("phone", data.phone.value)
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "row",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "col-12",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                                            label: i18n.submit,
                                                            size: "medium",
                                                            type: "primary flexible",
                                                            onClick: handleSubmit,
                                                            disabled: checkDisabled(data),
                                                            loading: loading,
                                                            role: "button"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ReCaptcha/* default */.Z, {
                                                            getAnalyticsData: getRecaptchaBookAppointmentAnalytics(internalLinkType)
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                    className: "col-12 store-appointment__privacy-policy",
                                                    children: !isEmpty_default()(legalPathLinks) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                    href: legalPathLinks === null || legalPathLinks === void 0 ? void 0 : legalPathLinks.privacyPolicy,
                                                                    className: "gbh-data-layer",
                                                                    target: "_blank",
                                                                    rel: "noopener noreferrer",
                                                                    onClick: (e)=>{
                                                                        var ref;
                                                                        return handleExternalLinkClick(e, getStoreData, (ref = i18n.privacyPolicy) === null || ref === void 0 ? void 0 : ref.toLowerCase(), legalPathLinks.privacyPolicy);
                                                                    },
                                                                    children: i18n.privacyPolicy
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                    href: legalPathLinks === null || legalPathLinks === void 0 ? void 0 : legalPathLinks.subjectAccessRequest,
                                                                    className: "gbh-data-layer",
                                                                    target: "_blank",
                                                                    rel: "noopener noreferrer",
                                                                    onClick: (e)=>{
                                                                        var ref;
                                                                        return handleExternalLinkClick(e, getStoreData, (ref = i18n.subjectAccess) === null || ref === void 0 ? void 0 : ref.toLowerCase(), legalPathLinks.subjectAccessRequest);
                                                                    },
                                                                    children: i18n.subjectAccess
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                    href: legalPathLinks === null || legalPathLinks === void 0 ? void 0 : legalPathLinks.termsOfService,
                                                                    className: "gbh-data-layer",
                                                                    target: "_blank",
                                                                    rel: "noopener noreferrer",
                                                                    onClick: (e)=>{
                                                                        var ref;
                                                                        return handleExternalLinkClick(e, getStoreData, (ref = i18n.termsOfService) === null || ref === void 0 ? void 0 : ref.toLowerCase(), legalPathLinks.termsOfService);
                                                                    },
                                                                    children: i18n.termsOfService
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "store-appointment__confirmation",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "store-appointment__thank-you-container",
                                    role: "alert",
                                    children: !isEmpty_default()(getUrlData) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "store-appointment__thank-you",
                                                children: getUrlData.confirmationTitle
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "store-appointment__thank-you-desc",
                                                children: (0,helper/* sanitizeInnerHtml */.KD0)(getUrlData.confirmationDescription)
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: successData && /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "store-appointment__details-container",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "store-appointment__details-left",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "store-appointment__details",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "store-appointment__details-title",
                                                                children: i18n.dateAndTime
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "store-appointment__details-content",
                                                                children: successData.selectedDate
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "store-appointment__details",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "store-appointment__details-title",
                                                                children: i18n.location
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "store-appointment__details-content-main",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                        className: "store-appointment__details-content",
                                                                        children: successData.storeName
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                        className: "store-appointment__details-content",
                                                                        children: successData.address
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "store-appointment__details-content-main",
                                                                children: successData.sameHours ? /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                        className: "store-appointment__details-time",
                                                                        children: i18n.wholeWeek + " " + successData.openingHours
                                                                    })
                                                                }) : isEmpty_default()(successData.saturday) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                            className: "store-appointment__details-time",
                                                                            children: i18n.weekDays + " " + successData.openingHours
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                            className: "store-appointment__details-time",
                                                                            children: i18n.weekEnds + " " + successData.weekendHours
                                                                        })
                                                                    ]
                                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                            className: "store-appointment__details-time",
                                                                            children: i18n.weekDays + " " + successData.openingHours
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                            className: "store-appointment__details-time",
                                                                            children: i18n.sat + " " + successData.saturday
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                            className: "store-appointment__details-time",
                                                                            children: i18n.sun + " " + successData.sunday
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: storeDetailUrl,
                                                                className: "store-appointment__details-content store-appointment__details-store-link gbh-data-layer",
                                                                "data-gbh-data-layer": getLegalPageAnalytics(getStoreData, "thankyou:view store details", storeDetailUrl),
                                                                children: i18n.viewStore
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "store-appointment__details",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "store-appointment__details-title",
                                                                children: i18n.contactInfo
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "store-appointment__details-content",
                                                                children: successData.contactName
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "store-appointment__details-content",
                                                                children: successData.contactEmail
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "store-appointment__details-content",
                                                                children: successData.contactPhone
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "store-appointment__details-right",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("picture", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                                            media: "(min-width: 481px) and (max-width:990px) and (orientation: landscape)",
                                                            srcSet: !isEmpty_default()(successData.storeImgMobileLandscape) ? successData.storeImgMobileLandscape : image_missing/* default */.Z === null || image_missing/* default */.Z === void 0 ? void 0 : image_missing/* default.src */.Z.src
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                                            media: "(max-width:480px)",
                                                            srcSet: !isEmpty_default()(successData.storeImgMobilePortrait) ? successData.storeImgMobilePortrait : image_missing/* default */.Z
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: !isEmpty_default()(successData.storeImgDesktop) ? successData.storeImgDesktop : image_missing/* default */.Z === null || image_missing/* default */.Z === void 0 ? void 0 : image_missing/* default.src */.Z.src,
                                                            alt: i18n.noImage
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "row ml-0 mr-0",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-12 store-appointment__close-container",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                        label: i18n.done,
                                        size: "medium",
                                        type: "primary flexible",
                                        onClick: modalClose,
                                        customClass: "store-appointment__close-btn",
                                        className: "gbh-data-layer",
                                        "data-gbh-data-layer": getLegalPageAnalytics(getStoreData, "thankyou:done"),
                                        useDefaultClass: true,
                                        role: "button"
                                    })
                                })
                            })
                        ]
                    })
                })
            })
        })
    });
};
/* harmony default export */ var v1_StoreAppointmentView = (StoreAppointmentView);

;// CONCATENATED MODULE: ./components/StoreAppointment/v1/StoreAppointment.jsx














const StoreAppointment = (props)=>{
    const { pageIsInteractive  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const { data: authorData = {}  } = props;
    const staticTexts = i18n_useStoreAppointmenti18n();
    const [storeDetails, setStoreDetails] = (0,react.useState)({});
    const [bpNumberState, setBpNumberState] = (0,react.useState)("");
    const [storeData, setStoreData] = (0,react.useState)({});
    const [info, setInfo] = (0,react.useState)({});
    const [appointmentDate, setAppointmentDate] = (0,react.useState)("");
    const [successData, setSuccessData] = (0,react.useState)({});
    const [isSuccess, setIsSuccess] = (0,react.useState)(false);
    const [loading, setLoading] = (0,react.useState)(false);
    const [getUrlData, setGetUrlData] = (0,react.useState)({});
    const dispatch = (0,es/* useDispatch */.I0)();
    const isSsr = (0,useIsSsr/* default */.Z)();
    (0,react.useEffect)(()=>{
        if (!isSsr && pageIsInteractive) {
            document.addEventListener("click", getNodeList);
        }
        return ()=>{
            document.removeEventListener("click", getNodeList);
        };
    }, [
        isSsr,
        pageIsInteractive
    ]);
    const getNodeList = (event)=>{
        const anchor = event.target.closest("a");
        if (!anchor) return;
        const anchorValue = anchor.getAttribute("href");
        if (anchorValue === constants.STORE_APPOINTMENT_ANCHOR_VALUE) {
            event.preventDefault();
            dispatch((0,genericSlice/* showAppointmentModal */.kY)(null));
        }
    };
    (0,react.useEffect)(()=>{
        (0,constants_config/* getConfig */.i)().then(async (config)=>{
            const getStoreURL = get_default()(config, "apiEndpoints.storeBpNumber", "");
            const getStoreAppointmentUrl = get_default()(config, "apiEndpoints.storeAppointment", "");
            const findStoreDetailsUrl = get_default()(config, "general.storeDetailsServletPath", "");
            const shortendPagePath = get_default()(config, "general.shortendPagePath", "");
            const legalPathLinks = get_default()(config, "legalPageData.map", {});
            const general = {
                getStoreURL: getStoreURL,
                getStoreAppointmentUrl: getStoreAppointmentUrl,
                legalPathLinks: legalPathLinks
            };
            setInfo(general);
            (0,constants_api/* aemAxiosInstance */.Gb)({
                url: constants.GLOBAL_CONFIGURATION_ENDPOINT,
                params: {
                    path: findStoreDetailsUrl
                }
            }).then((response)=>{
                if (response && response.data) {
                    setStoreDetails(response.data);
                    const storeDetailsValue = response.data;
                    const shortendPageUrl = shortendPagePath + window.location.pathname + ".html";
                    let bpNumberValue = null;
                    Object.keys(storeDetailsValue).forEach((store)=>{
                        if (storeDetailsValue[store] === window.location.pathname || storeDetailsValue[store] === shortendPageUrl) {
                            bpNumberValue = store;
                        }
                    });
                    if (!bpNumberValue) {
                        setGetUrlData(authorData !== null && authorData !== void 0 ? authorData : {});
                        console.error("Store detail not configured: BP number not found");
                    } else {
                        setGetUrlData(authorData !== null && authorData !== void 0 ? authorData : {});
                        setBpNumberState(bpNumberValue);
                        if (getStoreURL) {
                            getStoreFromBP(bpNumberValue, getStoreURL);
                        }
                    }
                }
            }).catch((err)=>{
                console.log("Failed to get compare attributes JSON file", err);
            });
        });
    }, []);
    const getStoreFromBP = (bpNumberValue, getStoreURL)=>{
        if (!isEmpty_default()(getStoreURL)) {
            constants_api/* apim.get */.TH.get("".concat(getStoreURL, "/").concat(bpNumberValue), {
                headers: {
                    "Content-Type": "application/json; charset=UTF-8",
                    "Access-Control-Allow-Headers": "X-Requested-With",
                    "X-Requested-With": "XMLHttpRequest"
                }
            }).then((response)=>{
                if (response && response.data) {
                    var _data;
                    setStoreData((_data = response.data) !== null && _data !== void 0 ? _data : {});
                } else {
                    dispatch((0,genericSlice/* showToast */.CF)({
                        message: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.genError,
                        isVisible: true
                    }));
                }
            }).catch((err)=>{
                dispatch((0,genericSlice/* showToast */.CF)({
                    message: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.genError,
                    isVisible: true
                }));
            });
        } else {
            console.warn("Store Data: Get URL Property not found");
        }
    };
    const getRequestAppointment = (val, selectedDateSucess)=>{
        // const genericError = authorData.genericError
        setLoading(true);
        getAppointmentData(val, selectedDateSucess);
        constants_api/* apim.post */.TH.post(info.getStoreAppointmentUrl, val, {
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Access-Control-Allow-Headers": "X-Requested-With",
                "X-Requested-With": "XMLHttpRequest"
            }
        }).then((response)=>{
            if (response && response.data) {
                var ref, ref1, ref2, ref3;
                const message = get_default()(response.data, "success", false);
                if (message === true) {
                    setIsSuccess(true);
                }
                const spliteDate = (selectedDateSucess === null || selectedDateSucess === void 0 ? void 0 : selectedDateSucess.split("at")) || (appointmentDate === null || appointmentDate === void 0 ? void 0 : appointmentDate.split("at"));
                const dateSplit = (ref = spliteDate[0]) === null || ref === void 0 ? void 0 : ref.split(",");
                const monthSplit = (ref1 = dateSplit[0]) === null || ref1 === void 0 ? void 0 : ref1.split(" ");
                const getFormatDate = "".concat(monthSplit[1], "-").concat(monthSplit[0], "-").concat((ref2 = dateSplit[1]) === null || ref2 === void 0 ? void 0 : ref2.trim());
                const getFormatTime = (ref3 = spliteDate[1]) === null || ref3 === void 0 ? void 0 : ref3.trim();
                addBookAppointmentAnalytics({
                    storeData: storeData,
                    action: "cmp:click",
                    status: "success",
                    errorMessage: [],
                    appointmentDate: getFormatDate,
                    appointmentTime: getFormatTime
                });
            } else {
                setLoading(false);
                dispatch((0,genericSlice/* showToast */.CF)({
                    message: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.genError,
                    isVisible: true
                }));
                console.log("Fetching data failed");
                addBookAppointmentAnalytics({
                    storeData: storeData,
                    action: "cmp:click",
                    status: "failure",
                    errorMessage: [
                        staticTexts.genError
                    ],
                    appointmentDate: null,
                    appointmentTime: null
                });
            }
        }).catch((err)=>{
            dispatch((0,genericSlice/* showToast */.CF)({
                message: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.genError,
                isVisible: true
            }));
            setLoading(false);
            console.log(err);
        });
    };
    const getAppointmentDate = (val)=>{
        setAppointmentDate(val);
    };
    const getAppointmentData = (val, selectedDateSucess)=>{
        const appointmentData = {};
        let checkWeekdayTime;
        let isAllDay;
        let isWeekend;
        let checkWeekEndTime;
        let saturdayTime;
        let sundayTime;
        const mondayStoreTime = get_default()(storeData, "Monday_Store_Hours__c", "");
        const saturdayStoreTime = get_default()(storeData, "Open_Hours_Saturday__c", "");
        const sundayStoreTime = get_default()(storeData, "Open_Hours_Sunday__c", "");
        const mondayTime = mondayStoreTime === null || mondayStoreTime === void 0 ? void 0 : mondayStoreTime.split(";");
        if (mondayStoreTime === saturdayStoreTime && mondayStoreTime === sundayStoreTime) {
            isAllDay = true;
            checkWeekdayTime = "".concat(mondayTime[0], "-").concat(mondayTime[1]);
        } else {
            isAllDay = false;
            checkWeekdayTime = "".concat(mondayTime[0], "-").concat(mondayTime[1]);
        }
        if (saturdayStoreTime === sundayStoreTime) {
            isWeekend = true;
            const weekEndTime = saturdayStoreTime !== "Closed" ? saturdayStoreTime === null || saturdayStoreTime === void 0 ? void 0 : saturdayStoreTime.split(";") : [];
            checkWeekEndTime = weekEndTime.length > 0 ? "".concat(saturdayStoreTime[0], "-").concat(saturdayStoreTime[1]) : "Closed";
        } else {
            isWeekend = false;
            saturdayTime = saturdayStoreTime === null || saturdayStoreTime === void 0 ? void 0 : saturdayStoreTime.split(";");
            sundayTime = sundayStoreTime === null || sundayStoreTime === void 0 ? void 0 : sundayStoreTime.split(";");
        }
        appointmentData.selectedDate = selectedDateSucess;
        appointmentData.storeName = get_default()(storeData, "AEM_Microsite_Name__c", "");
        var ref;
        appointmentData.address = (ref = "".concat(storeData.BillingStreet, ", ").concat(storeData.BillingCity, ", ").concat(storeData.BillingState, " ").concat(storeData.BillingPostalCode)) !== null && ref !== void 0 ? ref : "";
        var ref1;
        appointmentData.contactName = (ref1 = "".concat(val === null || val === void 0 ? void 0 : val.FirstName__c, " ").concat(val === null || val === void 0 ? void 0 : val.LastName__c)) !== null && ref1 !== void 0 ? ref1 : "";
        appointmentData.contactEmail = get_default()(val, "Preferred_Email__c", "");
        appointmentData.contactPhone = get_default()(val, "PreferredPhone", "");
        appointmentData.storeImgDesktop = get_default()(getUrlData, "imageDesktop", "");
        appointmentData.storeImgMobilePortrait = get_default()(getUrlData, "imageMobilePortrait", "");
        appointmentData.storeImgMobileLandscape = get_default()(getUrlData, "imageMobileLandscape", "");
        appointmentData.sameHours = isAllDay;
        appointmentData.openingHours = checkWeekdayTime;
        appointmentData.saturday = !isWeekend ? "".concat(saturdayTime[0]).concat(saturdayTime[1] ? "-".concat(saturdayTime[1]) : "") : "";
        appointmentData.sunday = !isWeekend ? "".concat(sundayTime[0]).concat(sundayTime[1] ? "-".concat(sundayTime[1]) : "") : "";
        appointmentData.weekendHours = isWeekend ? checkWeekEndTime : "";
        var _bpNumberState;
        appointmentData.storeDetailUrl = (_bpNumberState = storeDetails[bpNumberState]) !== null && _bpNumberState !== void 0 ? _bpNumberState : "/";
        setSuccessData(appointmentData);
    };
    const modalClose = ()=>{
        setIsSuccess(false);
        setLoading(false);
        dispatch((0,genericSlice/* hideAppointmentModal */.AN)());
    };
    const { ariaLabel ={
        sunday: "",
        monday: "",
        tuesday: "",
        wednesday: "",
        thursday: "",
        friday: "",
        saturday: ""
    } , january ="" , february ="" , march ="" , april ="" , may ="" , june ="" , july ="" , august ="" , september ="" , october ="" , november ="" , december =""  } = staticTexts;
    const daysData = [
        ariaLabel.sunday,
        ariaLabel.monday,
        ariaLabel.tuesday,
        ariaLabel.wednesday,
        ariaLabel.thursday,
        ariaLabel.friday,
        ariaLabel.saturday
    ];
    const monthsData = [
        january,
        february,
        march,
        april,
        may,
        june,
        july,
        august,
        september,
        october,
        november,
        december
    ];
    let internalLinkType = "find a store:".concat((0,helper/* getInternalLinkTypeForFindStore */.dhb)(storeData.BillingStreet, storeData.BillingCity, storeData.BillingState));
    if (window.storeLinkType) {
        try {
            internalLinkType = (0,helper/* sanitizeTextForAnalytics */.T68)(window.storeLinkType);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_StoreAppointmentView, {
        i18n: staticTexts,
        daysData: daysData,
        monthsData: monthsData,
        isSuccess: isSuccess,
        successData: successData,
        getStoreData: storeData,
        requestAppointment: (val, selectedDateSucess)=>getRequestAppointment(val, selectedDateSucess),
        hideInput: true,
        getAppointmentDate: (val)=>getAppointmentDate(val),
        hidePast: true,
        bpNumber: bpNumberState,
        onModalClose: ()=>modalClose(),
        legalPathLinks: info.legalPathLinks,
        getUrlData: getUrlData,
        loading: loading,
        internalLinkType: internalLinkType
    });
};
/* harmony default export */ var v1_StoreAppointment = (StoreAppointment);

// EXTERNAL MODULE: ./components/core/SmartCropImage/index.jsx
var SmartCropImage = __webpack_require__(1906);
;// CONCATENATED MODULE: ./components/productCard/Hotspot/utils.js


const getProductInfo = function() {
    let productinfo = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var ref;
    const { productData , sku , needsJSON , cart , config , description , persona  } = productinfo;
    const { productCouponCode , productCoupondiscount  } = (0,helper/* getCurrentSkuCouponDiscounts */.mPk)({
        cart: cart,
        sku: sku
    });
    const colorDetails = get_default()(productData, "Color.SKU.Details_ss", []);
    var ref1;
    const colorDetail = (ref1 = colorDetails.find((colorDetail)=>colorDetail.includes(sku))) !== null && ref1 !== void 0 ? ref1 : "|";
    const color = colorDetail.split("|")[0];
    const productInfo = {
        productInfo: {
            productBrand: (ref = get_default()(config, "general.siteName", "")) === null || ref === void 0 ? void 0 : ref.toLowerCase(),
            description: ((0,helper/* sanitizeTextForAnalytics */.T68)(description) || "n/a").toLowerCase(),
            globalPromotionPrice: Number(get_default()(productData, "priceList.".concat(persona, ".discountedPrice_d"), 0)).toFixed(2),
            productBasePrice: Number(get_default()(productData, "priceList.".concat(persona, ".price_d"), 0)).toFixed(2),
            productCategory: ((0,helper/* sanitizeTextForAnalytics */.T68)(productData["Product_Category"]) || "n/a").toLowerCase(),
            productColor: ((0,helper/* sanitizeTextForAnalytics */.T68)(color) || "n/a").toLowerCase(),
            productName: ((0,helper/* sanitizeTextForAnalytics */.T68)(get_default()(productData, "productName_s", "")) || "n/a").toLowerCase(),
            productFindingMethod: "n/a",
            productCouponCode: productCouponCode.join("|") || "n/a",
            productCoupondiscount: productCoupondiscount,
            frequency: "n/a",
            isRecommended: "n/a",
            isSendNow: "n/a",
            isSubscription: "n/a",
            quantity: "n/a",
            ratings: "n/a",
            numberOfReviews: "n/a"
        }
    };
    if (needsJSON) {
        return productInfo.productInfo;
    }
    return productInfo;
};
const getDescriptionWithElipsis = (isMobile, description)=>{
    const length = isMobile ? 41 : 45;
    if (description.length >= length) {
        if (description.charAt(length) === " ") {
            description = description.slice(0, length) + "...";
        } else {
            description = description.slice(0, length).split(" ");
            description.pop();
            description = description.join(" ") + "...";
        }
    }
    return description;
};
const flags = (persona)=>{
    return [
        "id",
        "slug_s",
        "productName_s",
        "masterSKU_s",
        "Product_Category",
        "ProductBrandName_s",
        "productImages.url_ss",
        "SKUColorSwatchFilename_ss",
        "ProductDescriptionProductShort_s",
        "priceList.".concat(persona, ".price_d"),
        "priceList.".concat(persona, ".finalPrice_d"),
        "priceList.".concat(persona, ".discountedPrice_d"),
        "priceList.".concat(persona, ".saleOffer_s"),
        "Color.SKU.Details_ss",
        "ProductWebFeatures_ss",
        "ProductWebFeatures_s",
        "ProductIsExclusive_s",
        "RegionReleaseforShipment_dt",
        "Color.TPR.Details_ss",
        "RegionBrandName_s",
        "metaTitle_s",
        "ctId_s",
        "CustomerFacingBrand_s"
    ];
};

// EXTERNAL MODULE: ./components/ShopTheRoomCard/analytics.js
var ShopTheRoomCard_analytics = __webpack_require__(59362);
// EXTERNAL MODULE: ./i18n/usePdpi18n.js
var usePdpi18n = __webpack_require__(58886);
// EXTERNAL MODULE: ./public/icons/wish.svg
var wish = __webpack_require__(29875);
// EXTERNAL MODULE: ./public/icons/wishlist-gray-filled.svg
var wishlist_gray_filled = __webpack_require__(62084);
// EXTERNAL MODULE: ./components/productCard/Hotspot/index.module.scss
var Hotspot_index_module = __webpack_require__(5417);
var Hotspot_index_module_default = /*#__PURE__*/__webpack_require__.n(Hotspot_index_module);
;// CONCATENATED MODULE: ./components/productCard/Hotspot/index.jsx























const Hotspot_ProductCard = (props)=>{
    const { authorData: { skewId ="" , presetConfigs ="{}"  } , isDefaultProductCard =true , isFavoriteIcon =true , selectedProduct ="" , hotspotClicked =false  } = props;
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const [width] = (0,useWindowResize/* default */.Z)();
    const dispatch = (0,es/* useDispatch */.I0)();
    const { toaster  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const { cart  } = (0,es/* useSelector */.v9)(cartSlice/* selectCartState */.xw);
    const { favorites  } = (0,es/* useSelector */.v9)(favoritesSlice/* selectFavoritesState */.Qx);
    const { isAuth  } = (0,es/* useSelector */.v9)(authSlice/* selectAuthState */._9);
    const presetConfig = JSON.parse(presetConfigs);
    const myRef = (0,react.useRef)(null);
    const [productData, setProductData] = (0,react.useState)({
        image: "",
        isFavorite: false
    });
    const [config, setConfig] = (0,react.useState)({});
    const [swatchUrl, setSwatchUrl] = (0,react.useState)("");
    const [loginFavouriteCallback, setLoginFavouriteCallback] = (0,react.useState)(null);
    const [toasterContent, setToasterContent] = (0,react.useState)({
        successMessage: "",
        unfavoriteSuccessMessage: ""
    });
    const [pdpUrl, setPdpUrl] = (0,react.useState)("");
    const [badgesProps, setBadgesProps] = (0,react.useState)({});
    const { general ={}  } = config;
    const { newBadgeName ="" , saleBadgeName ="" , exclusiveBadgeName ="" , discontinuedBadgeName =""  } = general;
    const badgeTextObj = {
        new: newBadgeName,
        onSale: saleBadgeName,
        exclusive: exclusiveBadgeName,
        discontinued: discontinuedBadgeName
    };
    const staticTexts = (0,usePdpi18n/* default */.Z)("", badgeTextObj, "");
    (0,react.useEffect)(()=>{
        var ref;
        if (selectedProduct === skewId) myRef === null || myRef === void 0 ? void 0 : (ref = myRef.current) === null || ref === void 0 ? void 0 : ref.scrollIntoView();
    }, [
        selectedProduct,
        skewId,
        myRef,
        hotspotClicked
    ]);
    (0,react.useEffect)(()=>{
        (0,constants_config/* getConfig */.i)().then((config)=>{
            var ref;
            setConfig(config);
            var ref1;
            setSwatchUrl((ref1 = config === null || config === void 0 ? void 0 : (ref = config.general) === null || ref === void 0 ? void 0 : ref.swatchUrl) !== null && ref1 !== void 0 ? ref1 : "");
        });
    }, []);
    (0,react.useEffect)(()=>{
        if (skewId && !isEmpty_default()(config)) {
            const persona = (0,helper/* getUserPersona */.shu)();
            const { siteName: brandName = ""  } = {
                ...config === null || config === void 0 ? void 0 : config.general
            };
            const fl = flags(persona);
            setProductData({
                ...productData
            });
            try {
                var ref;
                var ref1;
                const language = (ref1 = config === null || config === void 0 ? void 0 : (ref = config.internationalization) === null || ref === void 0 ? void 0 : ref.language) !== null && ref1 !== void 0 ? ref1 : "en";
                constants_api/* apim.get */.TH.get("/search/plp", {
                    params: {
                        fl: fl.join(","),
                        q: "*:*",
                        fq: [
                            'sku_s:("'.concat(skewId, '")'),
                            'language_s:("'.concat(language, '")')
                        ],
                        collections: brandName.toLowerCase(),
                        profilename: "profile_".concat(brandName.toLowerCase(), "_General")
                    },
                    paramsSerializer: (params)=>{
                        return lib_default().stringify(params, {
                            arrayFormat: "repeat",
                            encode: false
                        });
                    }
                }).then((res)=>{
                    if (res && res.data) {
                        var ref, ref1, ref2;
                        var ref3;
                        const productData = (ref3 = (ref = res.data) === null || ref === void 0 ? void 0 : (ref1 = ref.response) === null || ref1 === void 0 ? void 0 : ref1.docs[0]) !== null && ref3 !== void 0 ? ref3 : {};
                        const { ctId_s: productId = "" , RegionReleaseforShipment_dt: releaseforShipmentDate = "" , ProductIsExclusive_s: productExclusive = ""  } = productData;
                        let imageId = "";
                        if (skewId.includes("-")) {
                            const skewIdPart = skewId.split("-");
                            const selectedVariant = skewIdPart.at(-1);
                            const imageData = productData["Color.TPR.Details_ss"].find((str)=>str.includes("-".concat(selectedVariant))).split("/");
                            imageId = imageData[imageData.length - 1];
                        }
                        const favoriteItem = favorites === null || favorites === void 0 ? void 0 : (ref2 = favorites.lineItems) === null || ref2 === void 0 ? void 0 : ref2.find((favorite)=>favorite.productId === productId);
                        const isFavorite = favoriteItem ? true : false;
                        const { currencySign =""  } = {
                            ...config === null || config === void 0 ? void 0 : config.internationalization
                        };
                        var ref4;
                        const badgesProps = {
                            isNewProduct: (0,helper/* showNewBadge */.ZTk)(releaseforShipmentDate),
                            badgeVal: (ref4 = productData["priceList.".concat(persona, ".saleOffer_s")]) !== null && ref4 !== void 0 ? ref4 : "",
                            exclusiveBadge: productExclusive
                        };
                        setBadgesProps(badgesProps);
                        setProductData({
                            ...productData,
                            imageId,
                            currencySign,
                            isFavorite
                        });
                    } else {
                        // eslint-disable-next-line no-console
                        console.error("Error occured while fetching product data");
                    }
                });
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error("Error occured while fetching product data", err);
            }
        }
    }, [
        config,
        favorites,
        isAuth
    ]);
    (0,react.useEffect)(()=>{
        if (loginFavouriteCallback && isAuth) {
            handleFavorite(loginFavouriteCallback);
        }
    }, [
        loginFavouriteCallback,
        isAuth
    ]);
    (0,react.useEffect)(()=>{
        setToasterMessage();
    }, [
        toaster
    ]);
    const setToasterMessage = async ()=>{
        if (!isEmpty_default()(toaster === null || toaster === void 0 ? void 0 : toaster.content)) {
            const { successMessage , unfavoriteSuccessMessage  } = toaster.content;
            setToasterContent({
                successMessage: await (0,helper/* getShortenedUrl */.Ppy)(successMessage),
                unfavoriteSuccessMessage: await (0,helper/* getShortenedUrl */.Ppy)(unfavoriteSuccessMessage)
            });
        }
    };
    const handleLogin = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        window.loginFavouriteCallback = ()=>{
            setLoginFavouriteCallback(e);
        };
        dispatch((0,authSlice/* setAuthModalVisibility */.LY)({
            show: true
        }));
    };
    const handleFavorite = (e)=>{
        const { ctId_s: productId = "" , isFavorite =false  } = productData;
        window.preActiveElement = e.target;
        e.stopPropagation();
        e.preventDefault();
        if (isFavorite) {
            var ref;
            const favProduct = favorites === null || favorites === void 0 ? void 0 : (ref = favorites.lineItems) === null || ref === void 0 ? void 0 : ref.find((fav)=>fav.productId === productId);
            if (favProduct) {
                if (!isAuth) {
                    handleLogin(e);
                } else {
                    dispatch((0,favoritesSlice/* removeItems */.Er)([
                        productId
                    ])).unwrap().then(()=>{
                        const productInfo = getProductInfo({
                            productData,
                            skewId,
                            needsJSON: false,
                            cart,
                            config,
                            description,
                            persona
                        });
                        (0,ShopTheRoomCard_analytics/* addAnalyticsEventForFavouriteAddRemove */.Xc)(false, productInfo);
                        dispatch((0,genericSlice/* showToast */.CF)({
                            message: toasterContent.unfavoriteSuccessMessage || t("kf.favorites.removeItem"),
                            isVisible: true
                        }));
                    }).catch((err)=>{
                        dispatch((0,genericSlice/* showToast */.CF)({
                            message: t("kf.favorites.removeItemError"),
                            isVisible: true
                        }));
                    });
                }
            }
        } else {
            if (!isAuth) {
                handleLogin(e);
            } else {
                dispatch((0,favoritesSlice/* addProduct */.gK)(skewId)).unwrap().then(()=>{
                    const productInfo = getProductInfo({
                        productData,
                        skewId,
                        needsJSON: false,
                        cart,
                        config,
                        description,
                        persona
                    });
                    (0,ShopTheRoomCard_analytics/* addAnalyticsEventForFavouriteAddRemove */.Xc)(true, productInfo);
                    dispatch((0,genericSlice/* showToast */.CF)({
                        message: toasterContent.successMessage || t("kf.favorites.success"),
                        isVisible: true
                    }));
                }).catch((err)=>{
                    dispatch((0,genericSlice/* showToast */.CF)({
                        message: t("kf.favorites.error"),
                        isVisible: true
                    }));
                });
            }
        }
    };
    const { slug_s: slug = "" , currencySign ="" , imageId ="" , Product_Category: productCategory = "" , productName_s: productName = "" , isFavorite =false  } = productData;
    let { ProductDescriptionProductShort_s: description = ""  } = productData;
    const name = productName ? productName.split(" ").slice(" ")[0] : "";
    const persona = (0,helper/* getUserPersona */.shu)();
    var ref;
    const price = Number((ref = productData["priceList.".concat(persona, ".price_d")]) !== null && ref !== void 0 ? ref : 0).toLocaleString(undefined, {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2
    });
    const isMobile =  true ? window.matchMedia("(max-width: 1038px)").matches : 0;
    description = getDescriptionWithElipsis(isMobile, description);
    (0,react.useEffect)(()=>{
        if (!isEmpty_default()(productData) && slug) {
            (0,helper/* getPDPUrl */.ir5)(productCategory, slug).then((url)=>setPdpUrl(url));
        }
    }, [
        productData,
        slug
    ]);
    const getBadgeText = ()=>{
        const { isNewProduct ="" , exclusiveBadge ="" , badgeVal =""  } = badgesProps;
        const { new: newItem = "" , newExclusive ="" , exclusive ="" , sale =""  } = staticTexts;
        const badgeTxt = isNewProduct ? exclusiveBadge ? newExclusive : newItem : exclusiveBadge ? exclusive : badgeVal ? sale : "";
        return badgeTxt === null || badgeTxt === void 0 ? void 0 : badgeTxt.toUpperCase();
    };
    var ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: myRef,
        className: (Hotspot_index_module_default()).hotspotProductCardWraper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "hotspotProductCard",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                onClick: ()=>(0,ShopTheRoomCard_analytics/* shopRoomhandleProductClick */.dv)({
                        productData,
                        sku: skewId,
                        url: "".concat(pdpUrl).concat(skewId ? "?skuId=" + skewId : "", "}"),
                        cart,
                        config,
                        description,
                        persona
                    }),
                href: "".concat(pdpUrl).concat(skewId ? "?skuId=" + skewId : ""),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "hotspotProductContainer",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "imageContainer",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    className: "imageCard",
                                    alt: "",
                                    src: (ref1 = (0,utils/* getPresetUrl */.v$)(width, 0, swatchUrl, imageId, presetConfig)) !== null && ref1 !== void 0 ? ref1 : image_missing/* default */.Z,
                                    onError: (e)=>e.target.src = image_missing/* default */.Z
                                }),
                                isFavoriteIcon ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "product-tile__share",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        id: "kf-add-to-fav-".concat(skewId),
                                        className: "product-tile__share-icon",
                                        tabIndex: "0",
                                        onClick: handleFavorite,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            role: "presentation",
                                            src: isFavorite ? wishlist_gray_filled/* default.src */.Z.src : wish/* default.src */.Z.src,
                                            alt: ""
                                        })
                                    })
                                }) : null
                            ]
                        }),
                        isDefaultProductCard ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "detailsContainer",
                            children: [
                                getBadgeText() ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "badgeTextContaoner",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "textStyle",
                                        children: getBadgeText()
                                    })
                                }) : null,
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "titleContainer",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "name",
                                            children: name
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "price",
                                            children: "".concat(currencySign).concat(price)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "descriptionContainer",
                                    children: description
                                })
                            ]
                        }) : null
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var Hotspot = (Hotspot_ProductCard);

;// CONCATENATED MODULE: ./public/icons/plus-button-shop.svg
/* harmony default export */ var plus_button_shop = ({"src":"/_next/static/media/plus-button-shop.96993e9b.svg","height":40,"width":40});
;// CONCATENATED MODULE: ./public/icons/hotspot-button-small.svg
/* harmony default export */ var hotspot_button_small = ({"src":"/_next/static/media/hotspot-button-small.9baab6bb.svg","height":30,"width":30});
// EXTERNAL MODULE: ./components/ShopTheRoomDetail/v1/index.module.scss
var ShopTheRoomDetail_v1_index_module = __webpack_require__(95179);
var ShopTheRoomDetail_v1_index_module_default = /*#__PURE__*/__webpack_require__.n(ShopTheRoomDetail_v1_index_module);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/ShopTheRoomCard/v1/ShopTheRoomCardModalView.jsx
var ShopTheRoomCardModalView = __webpack_require__(90746);
// EXTERNAL MODULE: ./components/ShopTheRoomDetail/v1/modal.module.scss
var modal_module = __webpack_require__(98609);
var modal_module_default = /*#__PURE__*/__webpack_require__.n(modal_module);
// EXTERNAL MODULE: ./public/icons/close.svg
var icons_close = __webpack_require__(653);
// EXTERNAL MODULE: ./node_modules/html-react-parser/index.mjs
var html_react_parser = __webpack_require__(25935);
;// CONCATENATED MODULE: ./components/ShopTheRoomDetail/v1/ShopTheRoomToaster.jsx







const ShopTheRoomToaster = (param)=>{
    let { isOpen , onClose , skuIds , presetConfigs , modalTitle , modalDesc , modalCtaTitle , setIsModalOpen , modalCtaLink , linkNewTabToaster , enableFavorite  } = param;
    const modalElement = (0,react.useRef)();
    (0,react.useEffect)((e)=>{
        const clickHandler = (e)=>{
            if (!modalElement.current) {
                return;
            }
            if (!modalElement.current.contains(e.target)) {
                setIsModalOpen(false);
            }
        };
        document.addEventListener("click", clickHandler, true);
        return ()=>document.removeEventListener("click", clickHandler);
    }, []);
    return isOpen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            ref: modalElement,
            className: (modal_module_default()).modalWrapper,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    className: "close-button",
                    alt: "close",
                    src: icons_close/* default */.Z,
                    onClick: ()=>onClose("modal")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "modal-content",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "modal-content-div",
                        style: {
                            overflow: "auto"
                        },
                        children: [
                            modalTitle ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "modal-title",
                                children: (0,html_react_parser/* default */.ZP)(modalTitle)
                            }) : null,
                            modalCtaTitle ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "cta-wrapper",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    rel: "noreferrer",
                                    target: linkNewTabToaster ? "_blank" : "_self",
                                    href: modalCtaLink,
                                    className: "modal-cta",
                                    children: modalCtaTitle
                                })
                            }) : null,
                            modalDesc ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "modal-description",
                                children: (0,html_react_parser/* default */.ZP)(modalDesc)
                            }) : null,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "modal-products",
                                children: skuIds === null || skuIds === void 0 ? void 0 : skuIds.map((sku, id)=>{
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(v3_ProductCard/* default */.Z, {
                                        isFavoriteIcon: enableFavorite,
                                        isDefaultProductCard: false,
                                        toasterVar: true,
                                        authorData: {
                                            skewId: sku,
                                            presetConfigs: presetConfigs
                                        }
                                    }, sku);
                                })
                            })
                        ]
                    })
                })
            ]
        })
    }) : null;
};
/* harmony default export */ var v1_ShopTheRoomToaster = (ShopTheRoomToaster);

// EXTERNAL MODULE: ./components/ShopTheRoomDetail/v1/overlay.module.scss
var overlay_module = __webpack_require__(31201);
var overlay_module_default = /*#__PURE__*/__webpack_require__.n(overlay_module);
;// CONCATENATED MODULE: ./components/ShopTheRoomDetail/v1/Overlay.jsx



const Overlay = (param)=>{
    let { isOpen  } = param;
    (0,react.useEffect)(()=>{
        document.body.style.overflow = isOpen ? "hidden" : "auto";
    }, [
        isOpen
    ]);
    return isOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (overlay_module_default()).overlayWrapper,
        children: "Overlay"
    });
};
/* harmony default export */ var v1_Overlay = (Overlay);

;// CONCATENATED MODULE: ./components/ShopTheRoomDetail/v1/ShopTheRoomDetail.jsx















const ShopTheRoomDetail = (param)=>{
    let { data: authorData  } = param;
    const { cardTitle ="" , cardDescription ="" , actions =[] , productsLabel ="" , hideProductsLabel ="" , cardFirstImage ="" , cardSecondImage ="" , productsView ="" , skuIds =[] , presetConfigs , modalTitle ="" , modalDesc ="" , modalCTATitle ="" , modalCTALink ="" , linkNewTabToaster ="" , enableFavorite =false  } = authorData;
    const popCardDefaultValues = {
        visible: false,
        top: 0,
        left: 0,
        skuId: "",
        index: -1
    };
    const firstImageHotspots = cardFirstImage === null || cardFirstImage === void 0 ? void 0 : cardFirstImage.hotspots;
    const secondImageHotspots = cardSecondImage === null || cardSecondImage === void 0 ? void 0 : cardSecondImage.hotspots;
    const [viewMoreToggle, setViewMoreToggle] = (0,react.useState)(false);
    const [showHotspots, setShowHotSpots] = (0,react.useState)(false);
    const [invokedFrom, setInvokedFrom] = (0,react.useState)("button");
    const smartCrop = (0,useSmartCrop/* default */.Z)();
    const imageContainer = (0,react.useRef)(null);
    const [i, setI] = (0,react.useState)(0);
    const [x0, setX0] = (0,react.useState)(null);
    const [locked, setLocked] = (0,react.useState)(false);
    const [tx, setTx] = (0,react.useState)("");
    const [N, setN] = (0,react.useState)(1);
    const [toggle, setToggle] = (0,react.useState)(false);
    const [selectedProduct, setSelectedProduct] = (0,react.useState)("");
    const [hotspotClicked, setHotspotClicked] = (0,react.useState)(false);
    const [isModalOpen, setIsModalOpen] = (0,react.useState)(false);
    const [firstImageActive, setFirstImageActive] = (0,react.useState)(null);
    const firstImageContainerRef = (0,react.useRef)(null);
    const secondImageContainerRef = (0,react.useRef)(null);
    const [firstImagePopup, setFirstImagePopup] = (0,react.useState)({
        ...popCardDefaultValues
    });
    const [secondImagePopup, setSecondImagePopup] = (0,react.useState)({
        ...popCardDefaultValues
    });
    const [dataValShop, setDataValShop] = (0,react.useState)("");
    let isMobile;
    if (true) {
        isMobile = window.innerWidth <= 1037;
    }
    const removeHtmlExtension = async ()=>{
        const newDataShop = await (0,helper/* getShortenedUrl */.Ppy)(cardDescription);
        setDataValShop(newDataShop);
    };
    (0,react.useEffect)(()=>{
        if (cardDescription) {
            removeHtmlExtension();
        }
    }, [
        cardDescription
    ]);
    (0,react.useEffect)(()=>{
        if (isMobile) {
            const imageParent = imageContainer.current;
            const actualN = imageParent.children.length;
            setN(actualN);
        }
    }, [
        isMobile
    ]);
    const unify = (e)=>{
        return e.changedTouches ? e.changedTouches[0] : e;
    };
    const hotspotClass = "hotspotsmallimg ".concat(showHotspots ? "" : "hidden");
    (0,react.useEffect)(()=>{
        if (!viewMoreToggle) {
            setSelectedProduct("");
        }
    }, [
        viewMoreToggle
    ]);
    const handleModalToggle = (from)=>{
        if (from === "ViewMore") {
            setIsModalOpen(true);
        } else {
            setIsModalOpen(false);
        }
    };
    const handleMove = (e)=>{
        if (locked) {
            const dx = unify(e).clientX - x0;
            const s = Math.sign(dx);
            let tempI = i;
            if ((tempI > 0 || s < 0) && (tempI < N - 1 || s > 0)) tempI -= s;
            setI(tempI);
            setTx("0px");
            setLocked(false);
            setToggle(true);
            setX0(null);
        }
    };
    const hanldeDrag = (e)=>{
        e.preventDefault();
        if (locked) setTx("".concat(Math.round(unify(e).clientX - x0), "px"));
    };
    const hanldeLock = (e)=>{
        setX0(unify(e).clientX);
        setLocked(true);
        setToggle(false);
    };
    const handleViewMore = ()=>{
        setShowHotSpots(!showHotspots);
        if (productsView !== "cardView") {
            setViewMoreToggle(!viewMoreToggle);
        }
        handleModalToggle("ViewMore");
    };
    const handleHotspotClick = (skuId)=>{
        setHotspotClicked(!hotspotClicked);
        setSelectedProduct(skuId);
    };
    const handleImageIconClick = (e, skuId, index, imageType)=>{
        var ref;
        if (imageType === "first" && (firstImagePopup === null || firstImagePopup === void 0 ? void 0 : firstImagePopup.index) === index) {
            setFirstImagePopup({
                ...firstImagePopup,
                visible: false,
                index: -1
            });
            return;
        }
        if (imageType === "second" && (secondImagePopup === null || secondImagePopup === void 0 ? void 0 : secondImagePopup.index) === index) {
            setSecondImagePopup({
                ...firstImagePopup,
                visible: false,
                index: -1
            });
            return;
        }
        let parentRect;
        if (imageType === "first") {
            var ref1;
            parentRect = (ref1 = firstImageContainerRef.current) === null || ref1 === void 0 ? void 0 : ref1.getBoundingClientRect();
        }
        if (imageType === "second") {
            var ref2;
            parentRect = (ref2 = secondImageContainerRef.current) === null || ref2 === void 0 ? void 0 : ref2.getBoundingClientRect();
        }
        const icon = (ref = e.currentTarget) === null || ref === void 0 ? void 0 : ref.getBoundingClientRect();
        const parentHeight = parentRect.height;
        const parentWidth = parentRect.width;
        const popupWidth = 250;
        const popupHeight = 384;
        const margin = 1;
        const positions = [
            {
                top: icon.top - parentRect.top - popupHeight - margin,
                left: icon.left - parentRect.left
            },
            {
                top: icon.top - parentRect.top,
                left: icon.right - parentRect.left + margin
            },
            {
                top: icon.bottom - parentRect.top + margin,
                left: icon.left - parentRect.left
            },
            {
                top: icon.top - parentRect.top,
                left: icon.left - parentRect.left - popupWidth - margin
            }
        ];
        let finalPosition = positions.find((pos)=>{
            if (pos.top >= 0 && pos.top + popupHeight <= parentHeight && pos.left >= 0 && pos.left + popupWidth <= parentWidth) {
                return true;
            } else {
                return false;
            }
        });
        if (!finalPosition) {
            finalPosition = positions.reduce((bestPos, pos)=>{
                const overflowX = Math.max(0, pos.left + popupWidth - parentWidth) + Math.max(0, -pos.left);
                const overflowY = Math.max(0, pos.top + popupHeight - parentHeight) + Math.max(0, -pos.top);
                const overflow = overflowX + overflowY;
                return overflow < bestPos.overflow ? {
                    ...pos,
                    overflow
                } : bestPos;
            }, {
                overflow: Infinity
            });
        }
        if (Math.sign(finalPosition === null || finalPosition === void 0 ? void 0 : finalPosition.top) === -1) {
            finalPosition.top = 1;
        }
        if (finalPosition.left + 250 > parentWidth) {
            const gap = finalPosition.left + 250 - parentWidth;
            finalPosition.left = finalPosition.left - gap;
        }
        if (Math.sign(finalPosition === null || finalPosition === void 0 ? void 0 : finalPosition.left) === -1) {
            finalPosition.left = 1;
        }
        if (finalPosition.top + 352 > parentHeight) {
            const gap1 = finalPosition.top + 352 - parentHeight;
            finalPosition.top = finalPosition.top - gap1;
        }
        if (imageType === "first") {
            setFirstImagePopup({
                visible: true,
                top: finalPosition === null || finalPosition === void 0 ? void 0 : finalPosition.top,
                left: finalPosition === null || finalPosition === void 0 ? void 0 : finalPosition.left,
                skuId,
                index
            });
        }
        if (imageType === "second") {
            setSecondImagePopup({
                visible: true,
                top: finalPosition === null || finalPosition === void 0 ? void 0 : finalPosition.top,
                left: finalPosition === null || finalPosition === void 0 ? void 0 : finalPosition.left,
                skuId,
                index
            });
        }
    };
    const hadleHotspotImgeOutSideClick = function() {
        let imageTyep = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
        const popObj = {
            visible: false,
            top: 0,
            left: 0,
            skuId: "",
            index: -1
        };
        if (imageTyep === "first") {
            setFirstImagePopup({
                ...popObj
            });
        }
        if (imageTyep === "second") {
            setSecondImagePopup({
                ...popObj
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (ShopTheRoomDetail_v1_index_module_default()).shopTheRoomDetailWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "shop-the-room-detail-container",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "text-images-container",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "shop-the-room-detail-text-container",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "shop-the-room-detail-textbox",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "card-title",
                                        children: cardTitle ? (0,html_react_parser/* default */.ZP)(cardTitle) : null
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "card-description",
                                        children: cardDescription ? (0,html_react_parser/* default */.ZP)(dataValShop) : null
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "ctas-box",
                                        children: actions === null || actions === void 0 ? void 0 : actions.map((item, index)=>{
                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("a", {
                                                rel: "noreferrer",
                                                target: (item === null || item === void 0 ? void 0 : item.newTab) === "true" ? "_blank" : "_self",
                                                href: item === null || item === void 0 ? void 0 : item.url,
                                                children: item === null || item === void 0 ? void 0 : item.title
                                            }, index);
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "shop-the-room-detail-icon-label-container",
                                        children: isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "view-more-products-button",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "view-more-button-text",
                                                role: "button",
                                                onClick: ()=>setViewMoreToggle(!viewMoreToggle),
                                                children: viewMoreToggle ? (0,html_react_parser/* default */.ZP)(hideProductsLabel) : (0,html_react_parser/* default */.ZP)(productsLabel)
                                            })
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "view-more-products-button",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    role: "button",
                                                    onClick: handleViewMore,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        src: plus_button_shop,
                                                        alt: ""
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "view-more-button-text",
                                                    children: viewMoreToggle ? (0,html_react_parser/* default */.ZP)(hideProductsLabel) : (0,html_react_parser/* default */.ZP)(productsLabel)
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "shop-the-room-detail-image-container",
                            children: isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "swipe-image ".concat(toggle ? "smooth" : ""),
                                style: {
                                    "--n": N,
                                    "--i": i,
                                    "--tx": tx
                                },
                                ref: imageContainer,
                                onTouchStart: hanldeLock,
                                onMouseMove: hanldeDrag,
                                onTouchMove: hanldeDrag,
                                onTouchEnd: handleMove,
                                children: [
                                    cardFirstImage && /*#__PURE__*/ (0,jsx_runtime.jsx)(SmartCropImage/* default */.Z, {
                                        url: cardFirstImage.imageLink,
                                        altText: "",
                                        smartCrop: smartCrop
                                    }),
                                    cardSecondImage && /*#__PURE__*/ (0,jsx_runtime.jsx)(SmartCropImage/* default */.Z, {
                                        url: cardSecondImage.imageLink,
                                        altText: "",
                                        smartCrop: smartCrop
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    cardFirstImage && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "first-image-container",
                                        style: {
                                            position: "relative"
                                        },
                                        ref: firstImageContainerRef,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SmartCropImage/* default */.Z, {
                                                url: cardFirstImage.imageLink,
                                                altText: cardFirstImage === null || cardFirstImage === void 0 ? void 0 : cardFirstImage.altText,
                                                smartCrop: smartCrop,
                                                handleImgeClick: ()=>{
                                                    hadleHotspotImgeOutSideClick("first");
                                                }
                                            }),
                                            productsView !== "toasterView" && (firstImageHotspots === null || firstImageHotspots === void 0 ? void 0 : firstImageHotspots.map((hotspot, index)=>{
                                                const xCord = JSON.parse(hotspot === null || hotspot === void 0 ? void 0 : hotspot.coordinates.split(",")[0]);
                                                const width = JSON.parse(cardFirstImage === null || cardFirstImage === void 0 ? void 0 : cardFirstImage.width);
                                                const xCoordinate = xCord / width * 100;
                                                const yCord = JSON.parse(hotspot === null || hotspot === void 0 ? void 0 : hotspot.coordinates.split(",")[1]);
                                                const height = JSON.parse(cardFirstImage === null || cardFirstImage === void 0 ? void 0 : cardFirstImage.height);
                                                const yCoordinate = yCord / height * 100;
                                                const skuId = hotspot === null || hotspot === void 0 ? void 0 : hotspot.skuId;
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    style: {
                                                        position: "absolute",
                                                        left: "calc(".concat(xCoordinate, "% - 20px)"),
                                                        top: "calc(".concat(yCoordinate, "%  - 20px)")
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        src: hotspot_button_small,
                                                        alt: "",
                                                        className: hotspotClass,
                                                        onClick: (e)=>{
                                                            if (productsView === "cardView") {
                                                                handleImageIconClick(e, skuId, index, "first");
                                                            } else {
                                                                handleHotspotClick(skuId);
                                                            }
                                                            setInvokedFrom("");
                                                            setFirstImageActive(firstImageActive === index ? null : index);
                                                        }
                                                    })
                                                }, "".concat(skuId));
                                            })),
                                            (firstImagePopup === null || firstImagePopup === void 0 ? void 0 : firstImagePopup.visible) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "product-popup",
                                                style: {
                                                    left: "".concat(firstImagePopup.left, "px"),
                                                    top: "".concat(firstImagePopup.top, "px")
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Hotspot, {
                                                    authorData: {
                                                        skewId: firstImagePopup === null || firstImagePopup === void 0 ? void 0 : firstImagePopup.skuId,
                                                        presetConfigs: presetConfigs
                                                    },
                                                    selectedProduct: selectedProduct,
                                                    hotspotClicked: hotspotClicked
                                                }, firstImagePopup === null || firstImagePopup === void 0 ? void 0 : firstImagePopup.skuId)
                                            }) : ""
                                        ]
                                    }),
                                    cardSecondImage && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "second-image-container",
                                        style: {
                                            position: "relative"
                                        },
                                        ref: secondImageContainerRef,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SmartCropImage/* default */.Z, {
                                                url: cardSecondImage.imageLink,
                                                altText: cardSecondImage === null || cardSecondImage === void 0 ? void 0 : cardSecondImage.altText,
                                                smartCrop: smartCrop,
                                                handleImgeClick: ()=>{
                                                    hadleHotspotImgeOutSideClick("second");
                                                }
                                            }),
                                            productsView !== "toasterView" ? secondImageHotspots === null || secondImageHotspots === void 0 ? void 0 : secondImageHotspots.map((hotspot, index)=>{
                                                const xCord = JSON.parse(hotspot === null || hotspot === void 0 ? void 0 : hotspot.coordinates.split(",")[0]);
                                                const width = JSON.parse(cardSecondImage === null || cardSecondImage === void 0 ? void 0 : cardSecondImage.width);
                                                const xCoordinate = xCord / width * 100;
                                                const yCord = JSON.parse(hotspot === null || hotspot === void 0 ? void 0 : hotspot.coordinates.split(",")[1]);
                                                const height = JSON.parse(cardSecondImage === null || cardSecondImage === void 0 ? void 0 : cardSecondImage.height);
                                                const yCoordinate = yCord / height * 100;
                                                const skuId = hotspot === null || hotspot === void 0 ? void 0 : hotspot.skuId;
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    style: {
                                                        position: "absolute",
                                                        left: "calc(".concat(xCoordinate, "% - 20px)"),
                                                        top: "calc(".concat(yCoordinate, "%  - 20px)")
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        src: hotspot_button_small,
                                                        alt: "",
                                                        className: hotspotClass,
                                                        onClick: (e)=>{
                                                            if (productsView === "cardView") {
                                                                handleImageIconClick(e, skuId, index, "second");
                                                            } else {
                                                                handleHotspotClick(skuId);
                                                            }
                                                            setInvokedFrom("");
                                                        }
                                                    })
                                                }, "".concat(skuId));
                                            }) : null,
                                            (secondImagePopup === null || secondImagePopup === void 0 ? void 0 : secondImagePopup.visible) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "product-popup",
                                                style: {
                                                    left: "".concat(secondImagePopup.left, "px"),
                                                    top: "".concat(secondImagePopup.top, "px")
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Hotspot, {
                                                    authorData: {
                                                        skewId: secondImagePopup === null || secondImagePopup === void 0 ? void 0 : secondImagePopup.skuId,
                                                        presetConfigs: presetConfigs
                                                    },
                                                    selectedProduct: selectedProduct,
                                                    hotspotClicked: hotspotClicked
                                                }, secondImagePopup === null || secondImagePopup === void 0 ? void 0 : secondImagePopup.skuId)
                                            }) : ""
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                }),
                viewMoreToggle && productsView === "stackView" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "view-more-products-container",
                    children: skuIds.map((sku, id)=>{
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(v3_ProductCard/* default */.Z, {
                            isFavoriteIcon: enableFavorite,
                            authorData: {
                                skewId: sku,
                                presetConfigs: presetConfigs
                            },
                            selectedProduct: selectedProduct,
                            hotspotClicked: hotspotClicked
                        }, sku);
                    })
                }),
                viewMoreToggle && productsView === "carouselView" && /*#__PURE__*/ (0,jsx_runtime.jsx)(ShopTheRoomCardModalView["default"], {
                    skuIds: skuIds,
                    presetConfigs: presetConfigs,
                    isModal: false,
                    selectedProduct: selectedProduct,
                    hotspotClicked: hotspotClicked,
                    setHotspotClicked: setHotspotClicked,
                    invokedFrom: invokedFrom,
                    setInvokedFrom: setInvokedFrom
                }),
                !isMobile && isModalOpen && productsView === "toasterView" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_ShopTheRoomToaster, {
                    enableFavorite: enableFavorite,
                    modalTitle: modalTitle,
                    modalDesc: modalDesc,
                    modalCtaLink: modalCTALink,
                    modalCtaTitle: modalCTATitle,
                    setIsModalOpen: setIsModalOpen,
                    isOpen: isModalOpen,
                    onClose: handleModalToggle,
                    cardTitle: cardTitle,
                    skuIds: skuIds,
                    presetConfigs: presetConfigs,
                    linkNewTabToaster: linkNewTabToaster
                }) : null,
                !isMobile && productsView === "toasterView" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_Overlay, {
                    isOpen: isModalOpen,
                    viewMore: viewMoreToggle
                }) : null
            ]
        })
    });
};
/* harmony default export */ var v1_ShopTheRoomDetail = (ShopTheRoomDetail);

// EXTERNAL MODULE: ./components/RoomDetailPage/v1/index.module.scss
var RoomDetailPage_v1_index_module = __webpack_require__(81881);
var RoomDetailPage_v1_index_module_default = /*#__PURE__*/__webpack_require__.n(RoomDetailPage_v1_index_module);
;// CONCATENATED MODULE: ./components/RoomDetailPage/v1/RoomDetailPage.jsx







const RoomDetailPage = (param)=>{
    let { data: authorData  } = param;
    const { skuIds =[] , imageRight ="false" , landingImageLink ="" , presetConfigs ="{}" , title ="" , description ="" , enableFavorite =false , imageAltText =""  } = authorData;
    const smartCrop = (0,useSmartCrop/* default */.Z)();
    const noOfProducts = skuIds.length;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (RoomDetailPage_v1_index_module_default()).roomDetailWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "room-detail-parent-container",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "room-detail-product-detail".concat(imageRight === "true" ? "__align-right" : ""),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "title-image-container\n             ",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "room-details",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "product-count",
                                        children: [
                                            noOfProducts,
                                            " Products"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        class: "product-info",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                class: "title",
                                                children: title ? (0,html_react_parser/* default */.ZP)(title) : null
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                class: "description",
                                                children: description ? (0,html_react_parser/* default */.ZP)(description) : null
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "image-container",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SmartCropImage/* default */.Z, {
                                    url: landingImageLink,
                                    altText: imageAltText,
                                    smartCrop: smartCrop
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "products-container",
                        children: skuIds.length > 0 ? skuIds.map((skuId, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(v3_ProductCard/* default */.Z, {
                                isFavoriteIcon: enableFavorite,
                                authorData: {
                                    skewId: skuId,
                                    presetConfigs
                                },
                                isDefaultProductCard: false
                            }, "product-tile-".concat(skuId, "-").concat(index))) : null
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var v1_RoomDetailPage = (RoomDetailPage);

// EXTERNAL MODULE: ./components/Shared/UpsellInstallServices/ProductCardForUpsell/index.jsx + 3 modules
var ProductCardForUpsell = __webpack_require__(54075);
// EXTERNAL MODULE: ./utils/ComponentImport.js
var ComponentImport = __webpack_require__(75227);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/index.js + 15 modules
var react_i18next_dist_es = __webpack_require__(67421);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
;// CONCATENATED MODULE: ./components/FindAProResults/v1/analytics/constanst.js
const FIND_A_PRO_RESULTS = "find a pro results";
const FIND_A_PRO_STICKY_NAV = "sticky nav links";

;// CONCATENATED MODULE: ./components/FindAProResults/v1/analytics/index.js

const getProResultListEventInfo = (data)=>{
    const { phone ="" , url ="" , partnerName ="" , isEmail =false , needLocationFinderType =false , isForServiceProvider =false , staticTexts ={} , selectedMenu ="" , serviceProviderType =""  } = data;
    const sleectedMenuName = selectedMenu ? selectedMenu : staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.designers;
    const internalLinkName = isEmail ? "services@kohler.com" : phone || partnerName;
    const type = phone ? "contact " + (isEmail ? "email" : "number") : isForServiceProvider ? "results" : partnerName;
    let internalLinkType = "find a pro results:navigation";
    if (phone) internalLinkType = "find a pro results:contact:".concat(partnerName, ":").concat(sleectedMenuName === null || sleectedMenuName === void 0 ? void 0 : sleectedMenuName.toLowerCase());
    if (needLocationFinderType) internalLinkType = "find a pro results:".concat(sleectedMenuName === null || sleectedMenuName === void 0 ? void 0 : sleectedMenuName.toLowerCase());
    const serviceProviderName = (serviceProviderType === null || serviceProviderType === void 0 ? void 0 : serviceProviderType.toLowerCase()) || "";
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(FIND_A_PRO_RESULTS, ":").concat(FIND_A_PRO_STICKY_NAV, ":").concat(selectedMenu === null || selectedMenu === void 0 ? void 0 : selectedMenu.toLowerCase(), ":").concat(phone || type),
        eventName: "".concat(FIND_A_PRO_RESULTS, ":").concat(FIND_A_PRO_STICKY_NAV, ":").concat(selectedMenu === null || selectedMenu === void 0 ? void 0 : selectedMenu.toLowerCase(), ":").concat(phone || type),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName,
        internalLinkPosition: FIND_A_PRO_RESULTS,
        internalLinkType,
        internalLinkURL: window.eventPageType === "find a pro results" ? "tel:" + phone : url || "n/a",
        internalLinkZoneName: "".concat(FIND_A_PRO_RESULTS, ":").concat(serviceProviderName)
    };
    const page = window.pageObj || {};
    const datalayerObj = {
        event: "cmp:click",
        eventInfo,
        page
    };
    window.adobeDataLayer.push(datalayerObj);
};


;// CONCATENATED MODULE: ./components/FindAProResults/v1/ProfessionalsList/index.jsx




const ProfessionalsList = (props)=>{
    var ref;
    const { data ={} , staticTexts ="" , swatchUrl ="" , selectedMenu ="" , serviceProviderType =""  } = props;
    const { Phone: phone = "" , LocationName: locationName = "" , AddressLine: addressLine , AddressLine2: addressLine2 = "" , Locality: locality = "" , AdminDistrict: adminDistrict = "" , PostalCode: postalCode = "" , __Distance: distance = "" , LogoIMG: logoIMG = "" , SpecGeneral: specGeneral = "" , SpecIntelligentToilets: specIntelligentToilets = "" , SpecDigitalShowering: specDigitalShowering = "" , SpecLighting: specLighting , SpecKohlerConnected: specKohlerConnected = "" , SpecShowerDoors: specShowerDoors = "" , Email: email = ""  } = data;
    const handleConatctDetalisClick = (isEmail, url)=>getProResultListEventInfo({
            phone: phone,
            url: "mailto:".concat(url),
            partnerName: locationName.toLowerCase(),
            isEmail: isEmail,
            needLocationFinderType: false,
            staticTexts: staticTexts,
            selectedMenu: selectedMenu,
            serviceProviderType: serviceProviderType
        });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "find-pro-results__content-section",
        role: "listitem",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "find-pro-results__content-section__space",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "row",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "col-sm-6 col-md-6",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "row",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-6 col-sm-6 col-md-6 col-lg-12 partner-name",
                                        role: "heading",
                                        level: "3",
                                        children: locationName.toLowerCase()
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-6 col-sm-6 col-md-6 col-lg-12 partner-rating"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "profile-details",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "partner-details",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "partner-address",
                                                children: [
                                                    addressLine.toLowerCase(),
                                                    addressLine2 ? ", " + addressLine2.toLowerCase() : ""
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "partner-address",
                                                children: [
                                                    locality ? locality.toLowerCase() + ", " : "",
                                                    adminDistrict,
                                                    " ",
                                                    postalCode
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "miles-away",
                                                children: "(".concat(distance.toFixed(1), " mi away)")
                                            })
                                        ]
                                    }),
                                    logoIMG ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "partner-photography",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: "".concat(swatchUrl, "/").concat(logoIMG),
                                            alt: "logo"
                                        })
                                    }) : null
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-sm-6 col-md-6",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "row mx-0",
                            children: [
                                specGeneral || specIntelligentToilets || specDigitalShowering || specLighting || specKohlerConnected || specShowerDoors ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "col-12 col-sm-12 col-md-12 col-lg-6 speciality",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "speciality-title",
                                            children: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.specialtiesTxt
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "speciality-details",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                children: [
                                                    specGeneral ? /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        children: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.SpecGeneral
                                                    }) : "",
                                                    specIntelligentToilets ? /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        children: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.SpecIntelligentToilets
                                                    }) : "",
                                                    specDigitalShowering ? /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        children: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.SpecDigitalShowering
                                                    }) : "",
                                                    specLighting ? /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        children: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.SpecLighting
                                                    }) : "",
                                                    specKohlerConnected ? /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        children: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.SpecKohlerConnected
                                                    }) : "",
                                                    specShowerDoors ? /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        children: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.SpecShowerDoors
                                                    }) : ""
                                                ]
                                            })
                                        })
                                    ]
                                }) : null,
                                email || phone ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "col-12 col-sm-12 col-md-12 col-lg-6 contact",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "contact-title",
                                            children: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.contactTxt
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "contact-details",
                                            children: [
                                                email ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "email",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        href: "mailto:".concat(email),
                                                        onClick: ()=>handleConatctDetalisClick(true, email),
                                                        "aria-label": staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.ariaLabel.email(locationName, email),
                                                        children: email
                                                    })
                                                }) : null,
                                                phone ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "phone",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        href: "tel:".concat(phone),
                                                        onClick: ()=>handleConatctDetalisClick(false, phone),
                                                        "aria-label": staticTexts === null || staticTexts === void 0 ? void 0 : (ref = staticTexts.ariaLabel) === null || ref === void 0 ? void 0 : ref.phone(locationName, phone),
                                                        children: phone
                                                    })
                                                }) : null
                                            ]
                                        })
                                    ]
                                }) : null
                            ]
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var v1_ProfessionalsList = (ProfessionalsList);

;// CONCATENATED MODULE: ./components/FindAProResults/v1/DesignerList/index.jsx





const DesignerList = (props)=>{
    const contactRef = (0,react.useRef)(null);
    const { data ={} , staticTexts ="" , selectedMenu ="" , serviceProviderType =""  } = props;
    const { proName ="" , address ="" , jobTitle ="" , available ="" , duration ="" , image ="" , specialties ="" , contactInfo =""  } = data;
    (0,react.useEffect)(()=>{
        if (contactInfo) {
            if (contactRef.current) {
                const links = contactRef.current.querySelectorAll("a");
                links.forEach((link)=>{
                    link.classList.add("gbh-data-layer");
                    const phone = link.textContent;
                    const url = link.getAttribute("href");
                    const isEmail = url.includes("mailto");
                    link.setAttribute("data-gbh-data-layer", getProResultListEventInfo({
                        phone: phone,
                        url: url,
                        partnerName: proName,
                        isEmail: isEmail,
                        staticTexts: staticTexts,
                        selectedMenu: selectedMenu,
                        serviceProviderType: serviceProviderType
                    }));
                });
            }
        }
    }, [
        data
    ]);
    const clickHandler = ()=>{
        var ref;
        getProResultListEventInfo({
            phone: null,
            url: (ref = data["detail-page-link"]) !== null && ref !== void 0 ? ref : "/",
            partnerName: proName,
            isEmail: false,
            needLocationFinderType: true,
            isForServiceProvider: true,
            staticTexts: staticTexts,
            selectedMenu: selectedMenu,
            serviceProviderType: serviceProviderType
        });
    };
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        role: "listitem",
        className: "find-pro-results__content-section",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            onClick: clickHandler,
            href: (ref = data["detail-page-link"]) !== null && ref !== void 0 ? ref : "/",
            className: "gbh-data-layer find-pro-results__designer-link ".concat(data["detail-page-link"] ? "link-added" : "link-removed"),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "find-pro-results__content-section__space",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: " row",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-sm-6 col-md-6",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "col-12 col-sm-12 col-md-12 px-0",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "row",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "col-6 col-sm-6 col-md-6 col-lg-12 partner-name",
                                                role: "heading",
                                                level: "3",
                                                children: proName
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "col-6 col-sm-6 col-md-6 col-lg-12 partner-rating"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "profile-details",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "partner-details",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "partner-address",
                                                        children: (0,helper/* sanitizeInnerHtml */.KD0)(address)
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "partner-designation",
                                                        children: (0,helper/* sanitizeInnerHtml */.KD0)(jobTitle)
                                                    }),
                                                    available === true ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "available-btn",
                                                        role: "button",
                                                        tabIndex: "0",
                                                        "aria-label": staticTexts.availableCTA,
                                                        children: (0,helper/* sanitizeInnerHtml */.KD0)(staticTexts.availableCTA)
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "available-duration",
                                                        children: (0,helper/* sanitizeInnerHtml */.KD0)(duration)
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "partner-photography",
                                                children: image ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    src: image,
                                                    alt: staticTexts.userAlt
                                                }) : null
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-sm-6 col-md-6",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "row mx-0",
                                children: [
                                    (specialties === null || specialties === void 0 ? void 0 : specialties.length) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "col-12 col-sm-12 col-md-12 col-lg-6 speciality",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "speciality-title",
                                                children: staticTexts.specialtiesTxt
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "speciality-details",
                                                children: (0,helper/* sanitizeInnerHtml */.KD0)(specialties)
                                            })
                                        ]
                                    }) : null,
                                    (contactInfo === null || contactInfo === void 0 ? void 0 : contactInfo.length) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "col-12 col-sm-12 col-md-12 col-lg-6 contact",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "contact-title",
                                                children: staticTexts.contactTxt
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "contact-details",
                                                ref: contactRef,
                                                children: (0,helper/* sanitizeInnerHtml */.KD0)(contactInfo)
                                            })
                                        ]
                                    }) : null
                                ]
                            })
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var v1_DesignerList = (DesignerList);

// EXTERNAL MODULE: ./node_modules/react-sticky-el/lib/index.js
var react_sticky_el_lib = __webpack_require__(75198);
var react_sticky_el_lib_default = /*#__PURE__*/__webpack_require__.n(react_sticky_el_lib);
;// CONCATENATED MODULE: ./components/FindAProResults/v1/analytics/helper.js
const getStickNavEventInfo = (linkName)=>{
    const menuName = linkName === null || linkName === void 0 ? void 0 : linkName.toLowerCase();
    return {
        eventAction: "find a pro results:sticky nav links:".concat(menuName),
        eventName: "find a pro results:sticky nav links:".concat(menuName),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: menuName,
        internalLinkPosition: "find a pro results",
        internalLinkType: "find a pro results:navigation",
        internalLinkZoneName: "find a pro results:sticky nav links",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
};
const addAnalyticsData = (count, zipcodeVal)=>{
    const eventInfo = {
        searchCount: sessionStorage.getItem("proSearches") ? Number(sessionStorage.getItem("proSearches")) + 1 : 1,
        searchResult: count,
        searchTerm: zipcodeVal
    };
    sessionStorage.setItem("proSearches", eventInfo.searchCount);
    const showEvent = window.adobeDataLayer.find((item)=>item.event === "cmp:show");
    showEvent.eventInfo = eventInfo;
};
const addDataLayerOnMenuItemClick = (linkName)=>{
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const eventInfo = getStickNavEventInfo(linkName);
    window.adobeDataLayer.push({
        event: "cmp:click",
        page,
        eventInfo
    });
};
const getEventInfoForFindAproResultsView = (linkUrl, isForBathroom)=>{
    const type = isForBathroom ? "main content area:bathroom design services" : "hero:change location";
    const internalLinkName = isForBathroom ? "bathroom design services" : "change location";
    const zoneName = isForBathroom ? "main content area​" : "hero";
    const internalLinkType = "find a pro results:navigation";
    return JSON.stringify({
        clickInternalLinks: "true",
        eventAction: "find a pro results:".concat(type),
        eventName: "find a pro results:".concat(type),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName,
        internalLinkPosition: "find a pro results",
        internalLinkType,
        internalLinkURL: linkUrl,
        internalLinkZoneName: "find a pro results:".concat(zoneName)
    });
};

;// CONCATENATED MODULE: ./components/FindAProResults/v1/NoResults/index.jsx



const NoResults = (props)=>{
    const { professionalcount , brandName , findAProbyZipPagePath , zipcodeVal , staticTexts , subMenusRef , dataList , visibleSection , designersRef , handleMenuClick , handleKeyPress , bathroomDesignServiceLinkRef  } = props;
    const bathroomDesignConsultText = staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.bathroomDesignConsultText;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "find-pro-results__local-professional-details",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container kf-react-container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "local-professional-count",
                        children: [
                            "Showing ".concat(professionalcount, " professionals near "),
                            brandName === "sterling" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                tabIndex: "0",
                                className: "local-professional-count",
                                href: findAProbyZipPagePath,
                                children: zipcodeVal
                            }) : zipcodeVal,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                id: "request-change-location",
                                tabIndex: "0",
                                className: "change-location",
                                href: findAProbyZipPagePath,
                                children: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.changeLocationText
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "find-pro-results__sub-navigation",
                ref: subMenusRef,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                    className: "container kf-react-container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                        role: "menubar",
                        children: [
                            dataList.map((smenu, index)=>{
                                var ref;
                                return ((ref = smenu.data) === null || ref === void 0 ? void 0 : ref.length) > 0 && smenu.section !== "Designers" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    className: "header_link ".concat(visibleSection === smenu.menuName ? "selected" : ""),
                                    onClick: ()=>handleMenuClick(smenu.ref.current, smenu.menuName),
                                    onKeyDown: (e)=>handleKeyPress(e, smenu.section),
                                    role: "menuitem",
                                    tabIndex: visibleSection === smenu.menuName ? 0 : -1,
                                    id: "section-".concat(smenu.section.toLowerCase()),
                                    children: smenu.menuName
                                }, index) : null;
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: "header_link ".concat(visibleSection === (staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.designers) ? "selected" : ""),
                                onClick: ()=>{
                                    return handleMenuClick(designersRef.current, staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.designers);
                                },
                                onKeyDown: (e)=>handleKeyPress(e, "Designers"),
                                role: "menuitem",
                                tabIndex: visibleSection === (staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.designers) ? 0 : -1,
                                id: "section-designers",
                                children: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.designers
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "find-pro-results__designer-section",
                id: "Designers",
                ref: designersRef,
                tabIndex: "-1",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container kf-react-container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "find-pro-results__container",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "d-inline-block service-info",
                            ref: bathroomDesignServiceLinkRef,
                            children: (0,helper/* sanitizeInnerHtml */.KD0)(bathroomDesignConsultText)
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var v1_NoResults = (NoResults);

;// CONCATENATED MODULE: ./components/FindAProResults/v1/FindAProResults.view.jsx











const FindAProResultsLanding = (props)=>{
    var ref, ref1;
    const { data ={} , zipcodeVal ="" , staticTexts ="" , designersData =[] , loading =false , findAProbyZipPagePath =""  } = props;
    const [visibleSection, setVisibleSection] = (0,react.useState)();
    const [navSticky, setNavSticky] = (0,react.useState)(false);
    const subMenusRef = (0,react.useRef)(null);
    const remodelersRef = (0,react.useRef)(null);
    const plumbersRef = (0,react.useRef)(null);
    const buildersRef = (0,react.useRef)(null);
    const architectRef = (0,react.useRef)(null);
    const designersRef = (0,react.useRef)(null);
    const bathroomDesignServiceLinkRef = (0,react.useRef)(null);
    const CONFIG = (0,constants_config/* getConfig */.i)();
    var ref2;
    const brandName = (ref2 = (ref = CONFIG.general) === null || ref === void 0 ? void 0 : ref.siteName) !== null && ref2 !== void 0 ? ref2 : "";
    const swatchUrl = CONFIG === null || CONFIG === void 0 ? void 0 : (ref1 = CONFIG.general) === null || ref1 === void 0 ? void 0 : ref1.swatchUrl;
    const bathroomDesServTimeout = 2000;
    const remodelersData = (staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.LocationRemodeler) !== "" && data && data.filter((item)=>item.LocationRemodeler === true);
    const plumbersinstallersData = ((staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.LocationPlumber) !== "" || (staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.LocationInstaller) !== "") && data && data.filter((item)=>item.LocationPlumber === true);
    const buildersData = (staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.LocationBuilder) !== "" && data && data.filter((item)=>item.LocationBuilder === true);
    const architectData = data && data.filter((item)=>item.LocationArchitect === true);
    const designerData = data && data.filter((item)=>item.LocationDesigner === true);
    const dataList = [
        {
            section: "Remodelers",
            ref: remodelersRef,
            data: remodelersData || [],
            menuName: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.remodelers,
            sectionTitle: brandName === "sterling" ? staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.remodelersSterlingTitleText : staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.remodelersTitleText
        },
        {
            section: "Installers & Plumbers",
            ref: plumbersRef,
            data: plumbersinstallersData || [],
            menuName: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.plumbersInstallers,
            sectionTitle: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.plumbersInstallersTitleText
        },
        {
            section: "Builders",
            ref: buildersRef,
            data: buildersData || [],
            menuName: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.builders,
            sectionTitle: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.buildersTitleText
        },
        {
            section: "Architect",
            ref: architectRef,
            data: architectData || [],
            menuName: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.architect,
            sectionTitle: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.architectTitleText
        },
        {
            section: "Designers",
            ref: designersRef,
            data: designerData || [],
            menuName: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.designers,
            sectionTitle: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.designersTitleText
        }
    ];
    (0,react.useEffect)(()=>{
        if (data && (data === null || data === void 0 ? void 0 : data.length) < 1) return;
        const handleScroll = ()=>{
            const { height: headerHeight  } = getDimensions(subMenusRef.current);
            const scrollPosition = window.scrollY + headerHeight;
            const selected = dataList.find((param)=>{
                let { ref  } = param;
                const ele = ref.current;
                if (ele) {
                    const { offsetBottom , offsetTop  } = getDimensions(ele);
                    return scrollPosition > offsetTop && scrollPosition < offsetBottom;
                }
            });
            if (!selected) {
                setVisibleSection(staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.remodelers);
            } else if (selected && selected.menuName !== visibleSection) {
                setVisibleSection(selected.menuName);
            }
        };
        handleScroll();
        window.addEventListener("scroll", handleScroll);
        return ()=>{
            window.removeEventListener("scroll", handleScroll);
        };
    }, [
        staticTexts
    ]);
    const bathroomDesignText = staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.bathroomDesignConsultText;
    const professionalcount = dataList.reduce((sum, curr)=>{
        return sum + curr.data.length;
    }, 0) + (designersData === null || designersData === void 0 ? void 0 : designersData.length);
    (0,react.useEffect)(()=>{
        if (loading === false) {
            addAnalyticsData(professionalcount, zipcodeVal);
        } else if (loading === null) {
            addAnalyticsData(0, zipcodeVal);
        }
    }, [
        loading
    ]);
    (0,react.useEffect)(()=>{
        const timeoutId = setTimeout(()=>{
            var ref;
            const link = (ref = bathroomDesignServiceLinkRef.current) === null || ref === void 0 ? void 0 : ref.querySelector("p > a");
            if (link) {
                link.classList.add("gbh-data-layer");
                link.setAttribute("data-gbh-data-layer", getEventInfoForFindAproResultsView(link.getAttribute("href"), true));
            }
        }, bathroomDesServTimeout);
        return ()=>clearTimeout(timeoutId);
    }, []);
    const scrollTo = (ele)=>{
        ele.scrollIntoView({
            behavior: "smooth",
            block: "start"
        });
    };
    const handleKeyPress = (e, section)=>{
        const menus = dataList.filter((item)=>{
            var ref;
            if (item.section === "Designers") {
                return item;
            } else if (((ref = item.data) === null || ref === void 0 ? void 0 : ref.length) > 0) {
                return item;
            }
        });
        const curMenu = menus.findIndex((item)=>item.section === section);
        if (e.keyCode === 37 || e.keyCode === 39) {
            let tab;
            if (e.keyCode === 37) {
                tab = curMenu - 1;
            } else if (e.keyCode === 39) {
                tab = curMenu + 1;
            }
            if (tab < 0) tab = (menus === null || menus === void 0 ? void 0 : menus.length) - 1;
            if (tab >= (menus === null || menus === void 0 ? void 0 : menus.length)) tab = 0;
            document.getElementById("section-".concat(menus[tab].section.toLowerCase())).focus();
        } else if (e.keyCode === 9 && e.shiftKey && document.activeElement === document.getElementById("section-".concat(menus[0].section.toLowerCase()))) {
            e.preventDefault();
            document.getElementById("request-change-location").focus();
            return;
        }
    };
    const handleMenuClick = (menu, linkName)=>{
        scrollTo(menu);
        addDataLayerOnMenuItemClick(linkName);
    };
    if (loading) return "";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "find-pro-results",
        children: (data === null || data === void 0 ? void 0 : data.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "find-pro-results__local-professional-details",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "container kf-react-container",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "local-professional-count",
                            children: [
                                "Showing ".concat(professionalcount, " professionals near "),
                                brandName === "sterling" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    tabIndex: "0",
                                    className: "local-professional-count",
                                    href: findAProbyZipPagePath,
                                    children: zipcodeVal
                                }) : zipcodeVal,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    "data-gbh-data-layer": getEventInfoForFindAproResultsView(findAProbyZipPagePath),
                                    id: "request-change-location",
                                    tabIndex: "0",
                                    className: "change-location",
                                    href: findAProbyZipPagePath,
                                    children: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.changeLocationText
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)((react_sticky_el_lib_default()), {
                    onFixedToggle: ()=>setNavSticky(!navSticky),
                    className: "product-list__sticky-nav-wrap",
                    stickyStyle: {
                        zIndex: 9
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "find-pro-results__sub-navigation",
                        ref: subMenusRef,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                            className: "container kf-react-container",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                role: "menubar",
                                children: [
                                    dataList.map((smenu, index)=>{
                                        var ref;
                                        return ((ref = smenu.data) === null || ref === void 0 ? void 0 : ref.length) > 0 && smenu.section !== "Designers" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: "header_link ".concat(visibleSection === smenu.menuName ? "selected" : ""),
                                            onClick: ()=>handleMenuClick(smenu.ref.current, smenu.menuName),
                                            onKeyDown: (e)=>handleKeyPress(e, smenu.section),
                                            role: "menuitem",
                                            tabIndex: visibleSection === smenu.menuName ? 0 : -1,
                                            id: "section-".concat(smenu.section.toLowerCase()),
                                            children: smenu === null || smenu === void 0 ? void 0 : smenu.menuName
                                        }, index) : null;
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: "header_link ".concat(visibleSection === (staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.designers) ? "selected" : ""),
                                        onClick: ()=>{
                                            return handleMenuClick(designersRef.current, staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.designers);
                                        },
                                        onKeyDown: (e)=>handleKeyPress(e, "Designers"),
                                        role: "menuitem",
                                        tabIndex: visibleSection === (staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.designers) ? 0 : -1,
                                        id: "section-designers",
                                        children: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.designers
                                    })
                                ]
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: dataList.map((list, index)=>{
                        var ref;
                        return ((ref = list.data) === null || ref === void 0 ? void 0 : ref.length) > 0 && list.data !== designerData ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "find-pro-results__remodelers-section",
                            id: list.section,
                            ref: list.ref,
                            tabIndex: "-1",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "container kf-react-container",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "find-pro-results__container",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "find-pro-results__section-title",
                                            role: "heading",
                                            level: "2",
                                            children: list.sectionTitle
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                                            role: "list",
                                            "aria-label": list.sectionTitle,
                                            children: list.data && list.data.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(v1_ProfessionalsList, {
                                                    staticTexts: staticTexts,
                                                    data: item,
                                                    swatchUrl: swatchUrl,
                                                    selectedMenu: visibleSection,
                                                    serviceProviderType: list.sectionTitle
                                                }, index))
                                        })
                                    ]
                                })
                            })
                        }, index) : null;
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "find-pro-results__designer-section",
                    id: "Designers",
                    ref: designersRef,
                    tabIndex: "-1",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "container kf-react-container",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "find-pro-results__container",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                                    role: "list",
                                    "aria-label": staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.sectionTitle,
                                    children: designersData.map((item, index)=>{
                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(v1_DesignerList, {
                                            staticTexts: staticTexts,
                                            data: item,
                                            selectedMenu: visibleSection,
                                            serviceProviderType: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.designersTitleText
                                        }, index);
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "d-inline-block service-info",
                                    ref: bathroomDesignServiceLinkRef,
                                    children: (0,helper/* sanitizeInnerHtml */.KD0)(bathroomDesignText)
                                })
                            ]
                        })
                    })
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_NoResults, {
            professionalcount: professionalcount,
            brandName: brandName,
            findAProbyZipPagePath: findAProbyZipPagePath,
            zipcodeVal: zipcodeVal,
            staticTexts: staticTexts,
            subMenusRef: subMenusRef,
            dataList: dataList,
            visibleSection: visibleSection,
            designersRef: designersRef,
            handleMenuClick: handleMenuClick,
            handleKeyPress: handleKeyPress,
            designersData: designersData,
            bathroomDesignServiceLinkRef: bathroomDesignServiceLinkRef
        })
    });
};
/* harmony default export */ var FindAProResults_view = ((0,lib/* withOrientationChange */.Qe)(FindAProResultsLanding));

;// CONCATENATED MODULE: ./i18n/useFindAProResultsi18n.js


const useFindAProResultsi18n = function() {
    let componentProp = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    const { t  } = (0,esm/* useTranslation */.$G)();
    const i18n = {
        remodelersTitleText: t("kf.findpro.label.remodelersTitleText"),
        plumbersInstallersTitleText: t("kf.findpro.label.plumbersInstallersTitleBaseText") + t("kf.findpro.label.installers") + " & " + t("kf.findpro.label.plumbers"),
        buildersTitleText: t("kf.findpro.label.buildersTitleText"),
        architectTitleText: t("kf.findpro.label.architectTitleText"),
        designersTitleText: t("kf.findpro.label.designersTitleText"),
        remodelers: t("kf.findpro.label.remodelers"),
        plumbersInstallers: t("kf.findpro.label.plumbers") + " & " + t("kf.findpro.label.installers"),
        builders: t("kf.findpro.label.builders"),
        bathroomDesignConsultText: (componentProp === null || componentProp === void 0 ? void 0 : componentProp.bathroomDesignConsultCopy) ? (0,helper/* getShortenedUrlPath */.mXk)(componentProp === null || componentProp === void 0 ? void 0 : componentProp.bathroomDesignConsultCopy) : t("kf.findpro.label.serviceInfoText"),
        changeLocationText: t("kf.findpro.label.changeLocationText")
    };
    return i18n;
};
/* harmony default export */ var i18n_useFindAProResultsi18n = (useFindAProResultsi18n);

;// CONCATENATED MODULE: ./components/FindAProResults/v1/index.jsx











const FindAProResults = (authorData)=>{
    const [data, setData] = (0,react.useState)([]);
    const [designersData, setDesignersData] = (0,react.useState)([]);
    const [loading, setLoading] = (0,react.useState)(true);
    const { globalConfig: { general: { findAProbyZipPagePath ="" , bathroomDesignServicesPagePath ="" , siteName ="" , findProResults =""  } = {}  } = {}  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const urlParams =  true ? new URLSearchParams(window.location.search) : 0;
    const zipcodeVal = urlParams === null || urlParams === void 0 ? void 0 : urlParams.get("q");
    (0,react.useEffect)(()=>{
        const fetchData = async ()=>{
            if (!isEmpty_default()(findProResults)) {
                const response = await axios_default().get(findProResults);
                if (response && response.data) {
                    var _items;
                    setDesignersData((_items = response.data.items) !== null && _items !== void 0 ? _items : []);
                }
            }
        };
        const fetchPros = async ()=>{
            if (!isEmpty_default()(zipcodeVal)) {
                try {
                    const response = await constants_api/* apim.get */.TH.get("/maps/pro", {
                        params: {
                            spatialFilter: "nearby('".concat(zipcodeVal, "',", 40, ")"),
                            $format: "json",
                            brand: siteName.toLowerCase(),
                            $select: "EntityID,LocationName,AddressLine,AddressLine2,Locality,AdminDistrict,PostalCode,LogoIMG,LocationRemodeler,LocationInstaller,LocationPlumber,LocationBuilder,LocationDesigner,LocationArchitect,Email,Phone,__Distance,SpecGeneral,SpecIntelligentToilets,SpecDigitalShowering,SpecLighting,SpecKohlerConnected,SpecShowerDoors"
                        }
                    });
                    if (response && response.data) {
                        setData(response.data.d.results);
                    }
                    setLoading(false);
                } catch (error) {
                    setLoading(null);
                }
            }
        };
        fetchData();
        fetchPros();
    }, [
        zipcodeVal,
        findProResults
    ]);
    const staticTexts = i18n_useFindAProResultsi18n(authorData === null || authorData === void 0 ? void 0 : authorData.data);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "find-a-pro-resuls-test",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FindAProResults_view, {
                loading: loading,
                data: data,
                zipcodeVal: zipcodeVal,
                staticTexts: staticTexts,
                designersData: designersData,
                findAProbyZipPagePath: (0,helper/* getShortenedUrlPath */.mXk)(findAProbyZipPagePath),
                bathroomDesignServicesPagePath: (0,helper/* getShortenedUrlPath */.mXk)(bathroomDesignServicesPagePath)
            })
        })
    });
};
/* harmony default export */ var FindAProResults_v1 = ((0,react_i18next_dist_es/* withTranslation */.Zh)()(FindAProResults));

// EXTERNAL MODULE: ./components/ChangePassword/index.jsx + 3 modules
var ChangePassword = __webpack_require__(42536);
;// CONCATENATED MODULE: ./components/SiteMap/v1/index.jsx



const SiteMap = (param)=>{
    let { data ={}  } = param;
    const [isHeaderActive, setIsHeaderActive] = (0,react.useState)(true);
    const { siteMapHeading ="" , options =[] , appliedCssClassNames =""  } = data;
    const isMobile =  true && window.innerWidth < 1025;
    (0,react.useEffect)(()=>{
        if (isMobile) {
            setIsHeaderActive(false);
        }
    }, [
        isMobile
    ]);
    const handleHeaderClick = ()=>{
        setIsHeaderActive(isMobile ? !isHeaderActive : true);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "list ".concat((appliedCssClassNames === null || appliedCssClassNames === void 0 ? void 0 : appliedCssClassNames.trim()) === "sitemap-first-list" ? "sitemap-first-list" : ""),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "list-inner",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                    className: "cmp-list__heading ".concat(isHeaderActive ? "active" : ""),
                    onClick: handleHeaderClick,
                    children: siteMapHeading
                }),
                options === null || options === void 0 ? void 0 : options.map((item, i)=>{
                    var ref;
                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("ul", {
                        className: "cmp-list ".concat(isHeaderActive ? "show" : "hide"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: "cmp-list__subhead",
                                children: item === null || item === void 0 ? void 0 : item.subHeader
                            }),
                            item === null || item === void 0 ? void 0 : (ref = item.subHeaderItem) === null || ref === void 0 ? void 0 : ref.map((subItem, j)=>{
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)("ul", {
                                    className: "cmp-page-name",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            target: "".concat((subItem === null || subItem === void 0 ? void 0 : subItem.isNewTab) ? "_blank" : "_self"),
                                            href: (0,HeaderNavTabs_utils/* modifyHref */.L9)(subItem === null || subItem === void 0 ? void 0 : subItem.subPageLink),
                                            children: subItem === null || subItem === void 0 ? void 0 : subItem.subDisplayName
                                        })
                                    })
                                }, "".concat(subItem === null || subItem === void 0 ? void 0 : subItem.subDisplayName, "-").concat(j));
                            })
                        ]
                    }, "".concat(item === null || item === void 0 ? void 0 : item.subHeader, "-").concat(i));
                })
            ]
        })
    });
};
/* harmony default export */ var SiteMap_v1 = (SiteMap);

;// CONCATENATED MODULE: ./components/Shared/VisualNav/analytics/constant.js
const IMAGE_SILDER = "carousel image slider";
const IMAGE_CLICK = "carousel image click";
const LEFT_ARROW = "/icons/visual-nav-left-arrow.svg";
const RIGHT_ARROW = "/icons/visual-nav-right.svg";
const PLP = "plp";

;// CONCATENATED MODULE: ./components/Shared/VisualNav/analytics/index.js




const dataLayerForForArrows = function() {
    let arrow = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(PLP, ":").concat(IMAGE_SILDER, ":").concat(arrow),
        eventMsg: "n/a",
        eventName: "".concat(PLP, ":").concat(IMAGE_SILDER, ":").concat(arrow),
        eventStatus: "n/a",
        eventType: "navigation",
        internalLinkName: "".concat(arrow, " arrow"),
        internalLinkPosition: PLP,
        internalLinkType: "".concat(PLP, ":").concat(IMAGE_SILDER),
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(PLP, ":").concat(IMAGE_SILDER)
    };
    (0,helper/* pushAnalyticsObjToDataLayer */.zYT)(eventInfo);
};
const dataLayerForImageClick = function() {
    let data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { isSlected ="false" , index =-1 , productLength =0 , title ="" , imageUrl ="" , link =""  } = data;
    const selected = !isSlected ? "select" : "remove";
    const IndexReady = index + 1;
    const datalayerRedayLink = link ? (0,HeaderNavTabs_utils/* modifyHref */.L9)(link) : "";
    const linkWithStart = datalayerRedayLink ? (datalayerRedayLink.indexOf("http") === -1 ? window.location.origin : "") + datalayerRedayLink : "n/a";
    const getImageID = (imageUrl)=>{
        if (imageUrl.startsWith("/content/dam")) {
            var ref;
            const imageID = ((ref = imageUrl === null || imageUrl === void 0 ? void 0 : imageUrl.match(regex/* VISUAL_NAV_IMAGEID_FOR_DATALAYER */.ny)) === null || ref === void 0 ? void 0 : ref[1]) || null;
            const datalyerImageID = imageID ? imageID.split("_")[0] : null;
            return datalyerImageID;
        } else {
            const match = imageUrl.match(regex/* IMAGEID_DATALAYER_REGEX */.L3);
            if (match) {
                const extractedString = match[1];
                const datalayeReday = extractedString.split("_")[0];
                return datalayeReday;
            }
        }
    };
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(PLP, ":").concat(IMAGE_CLICK, ":").concat(selected),
        eventMsg: "n/a",
        eventName: "".concat(PLP, ":").concat(IMAGE_CLICK, ":").concat(selected),
        eventStatus: "n/a",
        eventType: "navigation",
        internalLinkName: title.toLowerCase(),
        internalLinkPosition: PLP,
        internalLinkType: "".concat(PLP, ":").concat(IMAGE_SILDER),
        internalLinkURL: linkWithStart,
        internalLinkZoneName: "".concat(PLP, ":").concat(IMAGE_SILDER),
        imageId: getImageID(imageUrl),
        imageName: title.toLowerCase(),
        imageSequence: "".concat(IndexReady, "_").concat(productLength)
    };
    (0,helper/* pushAnalyticsObjToDataLayer */.zYT)(eventInfo);
};

;// CONCATENATED MODULE: ./components/Shared/VisualNav/FilterComponent.jsx







const FilterComponent = (param)=>{
    let { data ={} , index =-1 , productLength =0 , onNavSelection =()=>{} , isSlected =false  } = param;
    const { visualNavType ="" , imageAltText ="" , filterValue ="" , imageUrl ="" , filterName ="" , title ="" , link ="" , newTab =false  } = data;
    const onFilterClick = ()=>{
        onNavSelection(index, filterName, filterValue);
        !isSlected ? sessionStorage.setItem("filterName", filterValue) : sessionStorage.removeItem("filterName");
        dataLayerForImageClick({
            isSlected,
            index,
            productLength,
            title,
            imageUrl
        });
    };
    const readyUrl = (imageUrl === null || imageUrl === void 0 ? void 0 : imageUrl.startsWith("/content/dam")) ? "".concat(constants.authorBaseUrl).concat(imageUrl) : imageUrl;
    const smartCrop = (0,useSmartCrop/* default */.Z)();
    return visualNavType === "plpFilterNav" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "imgesBlock",
        onClick: ()=>onFilterClick(),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "filterImage",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SmartCropImage/* default */.Z, {
                    url: readyUrl,
                    smartCrop: smartCrop,
                    altText: imageAltText
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "imageTitle".concat(isSlected ? "-selected" : ""),
                children: (0,html_react_parser/* default */.ZP)(title)
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
        href: (0,HeaderNavTabs_utils/* modifyHref */.L9)(link),
        target: newTab ? "_blank" : "_self",
        rel: "noreferrer",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "imgesBlock",
            onClick: ()=>dataLayerForImageClick({
                    isSlected,
                    index,
                    productLength,
                    title,
                    imageUrl,
                    link
                }),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "filterImage",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SmartCropImage/* default */.Z, {
                        url: readyUrl,
                        smartCrop: smartCrop,
                        altText: imageAltText
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "imageTitle",
                    children: (0,html_react_parser/* default */.ZP)(title)
                })
            ]
        })
    });
};
/* harmony default export */ var VisualNav_FilterComponent = (FilterComponent);

// EXTERNAL MODULE: ./components/Shared/VisualNav/index.module.scss
var VisualNav_index_module = __webpack_require__(99701);
var VisualNav_index_module_default = /*#__PURE__*/__webpack_require__.n(VisualNav_index_module);
;// CONCATENATED MODULE: ./components/Shared/VisualNav/index.jsx











const VisualNavigation = function() {
    let data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const dispatch = (0,es/* useDispatch */.I0)();
    const productlistState = (0,es/* useSelector */.v9)(productListSlice/* selectProductListState */.rv);
    const { visualNavAppliedFilters =[] , visualNavFiltersInitialLoad =false , plp: { currentAppliedfilters =[]  } = {}  } = productlistState;
    const [width] = (0,useWindowResize/* default */.Z)();
    const myAuthoredData = data === null || data === void 0 ? void 0 : data.data[":items"];
    const listOfFilters = myAuthoredData;
    const [currentIndex, setCurrentIndex] = (0,react.useState)(0);
    const [productsPerView, setProductsPerView] = (0,react.useState)(1);
    const [selectedNav, setSelectedNav] = (0,react.useState)([]);
    const sliderRef = (0,react.useRef)(null);
    const productArray = Object.values(listOfFilters);
    const { visualNavPlp  } = constants.PDP_SLIDER_SIZES;
    const [isMobile, setIsMobile] = (0,react.useState)(width <= constants.PDP_SLIDER_SIZES);
    (0,react.useEffect)(()=>{
        setIsMobile(width <= visualNavPlp);
        const calculateProductsPerView = ()=>{
            if (sliderRef.current) {
                const containerWidth = sliderRef.current.offsetWidth;
                const productWidth = 335;
                if (productWidth) {
                    setProductsPerView(Math.floor(containerWidth / productWidth));
                }
            }
        };
        calculateProductsPerView() // Initial calculation
        ;
        window.addEventListener("resize", calculateProductsPerView) // Recalculate on resize
        ;
        return ()=>{
            window.removeEventListener("resize", calculateProductsPerView);
        };
    }, []);
    const handleNext = ()=>{
        setCurrentIndex((prevIndex)=>prevIndex + 1 >= productArray.length ? 0 : prevIndex + 1);
        dataLayerForForArrows("right");
    };
    const handlePrevious = ()=>{
        setCurrentIndex((prevIndex)=>prevIndex === 0 ? Math.max(0, productArray.length - 1) : prevIndex - 1);
        dataLayerForForArrows("left");
    };
    const clearVisualNavFilterSelection = ()=>{
        setSelectedNav([]);
        sessionStorage.removeItem("filterName");
    };
    const getIsVisualNavAppliedOrSelected = function() {
        let productArray = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
        if (!currentAppliedfilters.length || visualNavFiltersInitialLoad) {
            return;
        }
        let isFilterNavFound = true;
        const newcondition = sessionStorage.getItem("filterName");
        productArray.forEach(function() {
            let navData = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, index = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : -1;
            const { filterName ="" , filterValue =""  } = navData;
            const filteredValue = filterValue === null || filterValue === void 0 ? void 0 : filterValue.replace(regex/* DOUBLE_QUOTE_REGEX */.dq, '\\"');
            if (currentAppliedfilters.length) {
                currentAppliedfilters.forEach((filter)=>{
                    if ((filter === null || filter === void 0 ? void 0 : filter.facet) === filterName && filter.value.indexOf(filteredValue) > -1 && (filter === null || filter === void 0 ? void 0 : filter.value[0]) === filteredValue && (filter === null || filter === void 0 ? void 0 : filter.value[0]) === (newcondition === null || newcondition === void 0 ? void 0 : newcondition.replace(regex/* DOUBLE_QUOTE_REGEX */.dq, '\\"'))) {
                        if (!isFilterNavFound) return;
                        setSelectedNav([
                            index
                        ]);
                        dispatch((0,productListSlice/* setVisualNavAppliedFilters */.ZZ)([
                            {
                                facet: filterName,
                                display: [
                                    filterValue
                                ],
                                value: [
                                    filteredValue
                                ],
                                add: true
                            }
                        ]));
                        isFilterNavFound = false;
                    }
                });
            }
        });
        if (isFilterNavFound) clearVisualNavFilterSelection();
    };
    const handleNavSelection = (index, filterName, filterValue)=>{
        const filteredValue = filterValue === null || filterValue === void 0 ? void 0 : filterValue.replace(regex/* DOUBLE_QUOTE_REGEX */.dq, '\\"');
        if (selectedNav.includes(index)) {
            clearVisualNavFilterSelection();
            dispatch((0,productListSlice/* setVisualNavAppliedFilters */.ZZ)([
                {
                    facet: filterName,
                    display: [
                        filterValue
                    ],
                    value: [
                        filteredValue
                    ],
                    add: false
                }
            ]));
        } else {
            setSelectedNav([
                index
            ]);
            dispatch((0,productListSlice/* setVisualNavAppliedFilters */.ZZ)([
                {
                    facet: filterName,
                    display: [
                        filterValue
                    ],
                    value: [
                        filteredValue
                    ],
                    add: true
                }
            ]));
        }
    };
    (0,react.useEffect)(()=>{
        if (!visualNavAppliedFilters.length) {
            setSelectedNav([]);
        }
    }, [
        visualNavAppliedFilters
    ]);
    (0,react.useEffect)(()=>{
        getIsVisualNavAppliedOrSelected(productArray);
    }, [
        currentAppliedfilters
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (VisualNav_index_module_default()).ProductWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "filter-conatiner",
            ref: sliderRef,
            children: !isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    productsPerView < productArray.length ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "Buttons",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "slider-btn-prev".concat(currentIndex === 0 ? "-disable" : ""),
                                onClick: currentIndex === 0 ? null : handlePrevious,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    alt: "leftarrow",
                                    src: LEFT_ARROW
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "slider-btn-next".concat(currentIndex + productsPerView === productArray.length ? "-disable" : ""),
                                onClick: productArray.length - currentIndex === productsPerView ? null : handleNext,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    alt: "rightarrow",
                                    src: RIGHT_ARROW
                                })
                            })
                        ]
                    }) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "plp-block",
                        style: {
                            transform: "translateX(-".concat(currentIndex / productsPerView * 100, "%)")
                        },
                        children: productArray.map((product, index)=>{
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "display-item",
                                    style: {
                                        flex: "0 0 calc(100% / ".concat(productsPerView, ")")
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VisualNav_FilterComponent, {
                                        data: product,
                                        index: index,
                                        productLength: productArray.length,
                                        onNavSelection: handleNavSelection,
                                        isSlected: selectedNav.includes(index)
                                    })
                                }, index)
                            }, index);
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "plp-block",
                children: productArray.map((product, index)=>{
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                        className: "display-item",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VisualNav_FilterComponent, {
                            data: product,
                            index: index,
                            productLenghth: productArray === null || productArray === void 0 ? void 0 : productArray.length,
                            onNavSelection: handleNavSelection,
                            isSlected: selectedNav.includes(index)
                        })
                    }, index);
                })
            })
        })
    });
};
/* harmony default export */ var VisualNav = (VisualNavigation);

// EXTERNAL MODULE: ./components/core/Highlight/Highlight.jsx
var Highlight = __webpack_require__(15540);
;// CONCATENATED MODULE: ./components/ProductCarousel/SliderProductCard.jsx







const SliderProductCard = (param)=>{
    let { i18n , product , currencySign , presetConfigs , swatchUrl , parent , title , brandName , skuId =""  } = param;
    const [productCardWidth, setProductCardWidth] = (0,react.useState)(0);
    const [pdpNavigationURL, setPdpNavigationURL] = (0,react.useState)("");
    const productCardRef = (0,react.useRef)();
    const presetConfigObject = presetConfigs;
    const newTab = false;
    (0,react.useEffect)(()=>{
        setProductCardWidth(productCardRef.current.clientWidth);
    });
    (0,react.useEffect)(()=>{
        if (product) {
            (0,helper/* getPDPUrl */.ir5)(product === null || product === void 0 ? void 0 : product.productCategory, product === null || product === void 0 ? void 0 : product.slug).then((ret)=>setPdpNavigationURL(ret));
        }
    }, [
        product
    ]);
    const formatUrl = (uUrl, iWidth)=>{
        const sUrlPath = uUrl.split("/");
        const sUrlId = sUrlPath[sUrlPath.length - 1];
        let sPreset = "";
        if (iWidth <= 167) {
            var ref;
            sPreset = (ref = presetConfigObject === null || presetConfigObject === void 0 ? void 0 : presetConfigObject.MobileLandscape) !== null && ref !== void 0 ? ref : "";
        } else if (iWidth <= 458) {
            var ref1;
            sPreset = (ref1 = presetConfigObject === null || presetConfigObject === void 0 ? void 0 : presetConfigObject.Desktop) !== null && ref1 !== void 0 ? ref1 : "";
        } else {
            var ref2;
            sPreset = (ref2 = presetConfigObject === null || presetConfigObject === void 0 ? void 0 : presetConfigObject.MobilePortrait) !== null && ref2 !== void 0 ? ref2 : "";
        }
        return "".concat(swatchUrl).concat(presetConfigObject.PotraitCategory, "?$product_src=is{PAWEB/").concat(sUrlId, "}&?").concat(sPreset);
    };
    const getProductName = ()=>{
        if (!parent && title) {
            return title;
        }
        return product.name || brandName ? product.name || brandName : product.name ? product.name : product.description;
    };
    var _price;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: productCardRef,
        className: "product-card",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
            prefetch: false,
            href: product ? pdpNavigationURL + (skuId ? "?skuId=".concat(skuId) : "") : "",
            target: newTab ? "_blank" : "_self",
            className: "product-card__link",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "product-card__img-container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: product ? presetConfigObject ? formatUrl(product.images, productCardWidth) : product.images : image_missing/* default.src */.Z.src,
                        className: "product-card__img",
                        alt: ""
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "product-card__details",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "product-card__left",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                className: "product-card__name".concat(!parent ? " default" : ""),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Highlight/* default */.Z, {
                                    text: product ? getProductName() : "..."
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "product-card__right",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                className: "product-card__price".concat(!parent ? " default" : ""),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                    value: product ? product.discountedPrice > 0 ? product.discountedPrice : product.price : "0",
                                    displayType: "text",
                                    thousandSeparator: true,
                                    prefix: currencySign,
                                    decimalScale: 2,
                                    fixedDecimalScale: true
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "product-card__details",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "product-card__left",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "product-card-desc",
                                children: product ? product.name || title || brandName ? product.description : "" : ""
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "product-card__right",
                            children: product ? product.discountedPrice !== product.price && product.discountedPrice > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "product-card__discount-price",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                    value: (_price = product.price) !== null && _price !== void 0 ? _price : 0,
                                    displayType: "text",
                                    thousandSeparator: true,
                                    prefix: currencySign,
                                    decimalScale: 2,
                                    fixedDecimalScale: true
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "product-card__details",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "product-card__left",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "product-card__color-text",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: product ? product.colors.length > 1 ? "".concat(product.colors.length, " ").concat(i18n.recentlyViewedColors) : "1 ".concat(i18n.recentlyViewedColor) : "1 Color"
                            })
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var ProductCarousel_SliderProductCard = (SliderProductCard);

;// CONCATENATED MODULE: ./components/ProductCarousel/ProductCarouselLoader.jsx



const ProductCarouselLoader = (props)=>{
    var _productSkus;
    const products = (_productSkus = props.productSkus) !== null && _productSkus !== void 0 ? _productSkus : [];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "product-carousel-wrapper",
        id: "product-carousel-loader",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "product-carousel",
            children: products === null || products === void 0 ? void 0 : products.map((product)=>{
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "product-carousel__card",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "product-card",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCarousel_SliderProductCard, {})
                    })
                }, product.productSkuId);
            })
        })
    });
};
/* harmony default export */ var ProductCarousel_ProductCarouselLoader = (ProductCarouselLoader);

;// CONCATENATED MODULE: ./components/ProductCarousel/ProductCarousel.jsx












const ProductCarousel = (props)=>{
    const [products, setProducts] = (0,react.useState)([]);
    const [loading, setLoading] = (0,react.useState)(true);
    const [info, setInfo] = (0,react.useState)({});
    const persona = (0,helper/* getUserPersona */.shu)();
    const staticTexts = i18n_useProductCardi18n({});
    const presetConfigs = {
        Desktop: "$PDPMoreCollectionDesktop$&fmt=webp",
        MobilePortrait: "$PDPMoreCollectionDesktop$&fmt=webp",
        MobileLandscape: "$PDPMoreCollectionDesktop$",
        PotraitCategory: "GBH_DataDrivenVerticalTemplate"
    };
    const swatchUrlKohler = "https://kohler.scene7.com/is/image/PAWEB/";
    (0,react.useEffect)(()=>{
        (0,constants_config/* getConfig */.i)().then((config)=>{
            var ref;
            var ref1;
            const brandName = (ref1 = config === null || config === void 0 ? void 0 : (ref = config.general) === null || ref === void 0 ? void 0 : ref.siteName) !== null && ref1 !== void 0 ? ref1 : "";
            const language = get_default()(config, "internationalization.language", "en");
            const locale = get_default()(config, "internationalization.locale", "");
            const currencySign = get_default()(config, "internationalization.currencySign", "");
            const currencyCode = get_default()(config, "internationalization.currencyCode", "");
            const { general: { lwAppName =""  } = {}  } = config !== null && config !== void 0 ? config : {};
            setInfo({
                locale,
                language,
                currencySign,
                currencyCode,
                brandName,
                lwAppName
            });
        });
    }, []);
    const fetchProducts = async (info)=>{
        try {
            const fl = [
                "id",
                "slug_s",
                "productName_s",
                "masterSKU_s",
                "Product_Category",
                "ProductBrandName_s",
                "productImages.url_ss",
                "productImageVariantImages.url_ss",
                "SKUColorSwatchFilename_ss",
                "ProductDescriptionProductShort_s",
                "priceStartingAt.".concat(persona, "_d"),
                "discountedPriceStartingAt.".concat(persona, "_d"),
                "priceList.".concat(persona, ".saleOffer_s"),
                "Color.SKU.Details_ss",
                "ProductWebFeatures_ss",
                "ProductWebFeatures_s",
                "ProductExclusive_s",
                "ProductIsExclusive_s",
                "RegionReleaseforShipment_dt",
                "title_s",
                "ProductNarrativeDescription_s",
                "priceList.".concat(persona, ".finalPrice_d"),
                "CustomerFacingBrand_s",
                "RegionBrandName_s",
                "productImages.labelWithUrl_ss"
            ];
            const productSkus = props.data.productSku.map((product)=>'"'.concat(product.productSkuId, '"'));
            const res = await constants_api/* apim.get */.TH.get("/search/plp", {
                params: {
                    fl: fl.join(","),
                    q: "*:*",
                    fq: [
                        "variantList.sku_ss:(".concat(productSkus.join(","), ")"),
                        'language_s:("en")'
                    ],
                    collections: info.lwAppName.toLowerCase(),
                    profilename: "profile_".concat(info.lwAppName.toLowerCase(), "_General")
                },
                paramsSerializer: (params)=>lib_default().stringify(params, {
                        arrayFormat: "repeat",
                        encode: false
                    })
            });
            setProducts(res.data.response.docs);
        } catch (err) {
            console.error("Failed to fetch products:", err);
        } finally{
            setLoading(false);
        }
    };
    (0,react.useEffect)(()=>{
        if (!isEmpty_default()(info)) {
            fetchProducts(info);
        }
    }, [
        info
    ]);
    if (loading) {
        var ref;
        var ref1;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCarousel_ProductCarouselLoader, {
                productSkus: (ref1 = props === null || props === void 0 ? void 0 : (ref = props.data) === null || ref === void 0 ? void 0 : ref.productSku) !== null && ref1 !== void 0 ? ref1 : []
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "product-carousel-wrapper",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "product-carousel",
            children: products.map((product)=>{
                const productCardProps = {};
                productCardProps.presetConfigs = presetConfigs;
                productCardProps.swatchUrl = swatchUrlKohler;
                if (product) {
                    var ref;
                    // get product images
                    if (product["modifiedproductImageVariantImages.url_ss"]) {
                        var ref1;
                        const imageStrig = (ref1 = product["modifiedproductImageVariantImages.url_ss"]) === null || ref1 === void 0 ? void 0 : ref1.split("|");
                        productCardProps.images = imageStrig.length ? imageStrig[imageStrig.length - 1] : "";
                    } else if (product["productImages.url_ss"]) {
                        var ref2;
                        productCardProps.images = (ref2 = product["productImages.url_ss"][0]) !== null && ref2 !== void 0 ? ref2 : "";
                    } else {
                        productCardProps.images = image_missing/* default */.Z === null || image_missing/* default */.Z === void 0 ? void 0 : image_missing/* default.src */.Z.src;
                    }
                    // get product colors
                    if (product["Color.SKU.Details_ss"]) {
                        var ref3;
                        const colors = (ref3 = product["Color.SKU.Details_ss"]) !== null && ref3 !== void 0 ? ref3 : [];
                        productCardProps.colors = colors.filter((item)=>{
                            const color = item.split("|");
                            return color[4] === "false" || Date.parse(color[4]) > Date.now();
                        });
                    }
                    // get product web features
                    if (product["ProductWebFeatures_s"]) {
                        var ref4;
                        productCardProps.productFeatures = (ref4 = [
                            product["ProductWebFeatures_s"]
                        ]) !== null && ref4 !== void 0 ? ref4 : [];
                    } else {
                        var ref5;
                        productCardProps.productFeatures = (ref5 = product["ProductWebFeatures_ss"]) !== null && ref5 !== void 0 ? ref5 : [];
                    }
                    productCardProps.currencySign = info.currencySign;
                    productCardProps.productCategory = get_default()(product, "Product_Category", "");
                    productCardProps.name = get_default()(product, "productName_s", "");
                    productCardProps.brandName = get_default()(product, "RegionBrandName_s", "");
                    productCardProps.description = get_default()(product, "title_s", "");
                    productCardProps.narrativeDescription = get_default()(product, "ProductNarrativeDescription_s", "");
                    productCardProps.price = get_default()(product, "priceStartingAt.".concat(persona, "_d"), 0);
                    productCardProps.discountedPrice = get_default()(product, "discountedPriceStartingAt.".concat(persona, "_d"), 0);
                    productCardProps.discountPercent = parseInt(get_default()(product, "priceList.".concat(persona, ".saleOffer_s"), 0));
                    productCardProps.slug = get_default()(product, "slug_s", "");
                    productCardProps.customerBrand = get_default()(product, "CustomerFacingBrand_s", "");
                    let tempColorDetails = get_default()(product, "Color.SKU.Details_ss", null);
                    if (tempColorDetails) {
                        if (typeof tempColorDetails !== "string" && tempColorDetails[0]) {
                            tempColorDetails = tempColorDetails[0];
                        }
                        productCardProps.customerFacingSKU = tempColorDetails.split("|")[5] || "";
                    }
                    productCardProps.badgeVal = get_default()(product, "priceList.".concat(persona, ".saleOffer_s"), "");
                    productCardProps.globalDiscount = productCardProps.price - get_default()(product, "priceList.".concat(persona, ".finalPrice_d"), productCardProps.price);
                    const productCategory = productCardProps === null || productCardProps === void 0 ? void 0 : (ref = productCardProps.productCategory) === null || ref === void 0 ? void 0 : ref.toLowerCase();
                    productCardProps.priceType = "";
                    if (productCategory === "field tiles" || productCategory === "slabs" || productCategory === "mosaics") {
                        productCardProps.priceType = "/" + (staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.sfLabel);
                    }
                    if (productCategory === "trims & moldings") {
                        productCardProps.priceType = "/" + (staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.lfLabel);
                    }
                    if (productCategory === "grout") {
                        productCardProps.priceType = staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.boxLabel;
                    }
                }
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "product-carousel__card",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCarousel_SliderProductCard, {
                        i18n: staticTexts,
                        product: productCardProps,
                        currencySign: info.currencySign,
                        presetConfigs: presetConfigs,
                        swatchUrl: swatchUrlKohler,
                        title: product.productName_s,
                        brandName: product.ProductBrandName_s
                    })
                }, product.masterSKU_s);
            })
        })
    });
};
/* harmony default export */ var ProductCarousel_ProductCarousel = (ProductCarousel);

;// CONCATENATED MODULE: ./components/AemGrid.jsx
















































const AemGrid = (props)=>{
    const { data ={} , itemKey ="" , count =0 , eventHandler ={} , fullData ={} , containerId ="" , bodytitle ="" , ...extraProps } = props;
    const dispatch = (0,es/* useDispatch */.I0)();
    const isSsr = (0,useIsSsr/* default */.Z)();
    const componentContexts = (0,react.useContext)(ComponentImport/* default */.ZP);
    (0,react.useEffect)(()=>{
        if ((0,utils/* isAuthModal */.S)(data)) {
            dispatch((0,authSlice/* setAuthModalStaticText */.vu)(data));
        }
        if ((0,utils/* isCompareProducts */.Be)(data)) {
            dispatch((0,genericSlice/* setCompareproductsStaticText */.rA)(data));
        }
        if ((0,utils/* isNewsLetter */.C_)(data)) {
            dispatch((0,genericSlice/* setSubscribeModalContent */.ml)(data));
        }
        if ((0,utils/* isSiteWideWarning */.yd)(data)) {
            dispatch((0,genericSlice/* setSitewideWarningContent */.FV)(data));
        }
        if ((0,utils/* isNewsLetterSignUp */.f5)(data)) {
            dispatch((0,genericSlice/* setSitewideNewsLetterContent */._r)(data));
        }
        if ((0,utils/* isToaster */.bu)(data)) {
            dispatch((0,genericSlice/* setToastContent */.Ji)(data));
        }
        if ((0,utils/* isStoreFilter */.Ov)(data)) {
            dispatch((0,locationSlice/* setStoreFilter */.Ey)(data));
        }
        if ((0,utils/* isGatedContent */.Er)(data)) {
            dispatch((0,genericSlice/* setGatedContentData */.wA)(data));
        }
    }, [
        data
    ]);
    const { title ="" , urlNames ="" , knowledgeArticle =()=>{} , technicalSpecifications =()=>{} , myFavorites =()=>{} , myProducts =()=>{} , myGenericFiller =()=>{} , myServices =()=>{} , accountSettings =()=>{} , contactUs =()=>{} , contactUsFiller =()=>{} , pressReleaseLanding =()=>{} , findStore =()=>{} , keySpecifier =()=>{} , associateMembership =()=>{} , friendsAndFamily =()=>{} , installDesignServices =()=>{} , isScrollMarginRequired =false  } = extraProps;
    const itemsOrderValue = data[":itemsOrder"] || [];
    const isWrapperRequired = constants.groupedComponents === null || constants.groupedComponents === void 0 ? void 0 : constants.groupedComponents.every((value)=>{
        return itemsOrderValue === null || itemsOrderValue === void 0 ? void 0 : itemsOrderValue.some((val)=>{
            return val === null || val === void 0 ? void 0 : val.includes(value);
        });
    });
    if ((0,utils/* isContainer */.Nm)(data)) {
        const dsComponent = getDSComponentForContainer(data);
        if (dsComponent) {
            return dsComponent;
        }
    }
    if ((0,utils/* isInspireVideo */._)(data)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(v2_Video, {
            data: data
        });
    }
    if ((0,utils/* isVideo */.Wv)(data)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_Video, {
            data: data
        });
    }
    if ((0,utils/* isSpacer */.MW)(data)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_Spacer, {
            data: data
        });
    }
    if ((0,utils/* isImageCluster */.Tk)(data)) {
        return !isSsr ? /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_ImageCluster, {
            data: data
        }) : null;
    }
    if ((0,utils/* isImage */.Or)(data)) {
        return !isSsr ? /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_Image, {
            data: data
        }) : null;
    }
    if ((0,utils/* isImageV3 */.EE)(data)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(v3_Image, {
            data: data
        });
    }
    if ((0,utils/* isAemForm */.np)(data)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Default_AemForm, {
            data: data,
            fullData: fullData
        });
    }
    if ((0,utils/* isProductCardV4 */.LV)(data)) {
        return !isSsr ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCardForUpsell/* default */.Z, {
            authData: data
        }) : null;
    }
    if ((0,utils/* isProductcardV3 */.DN)(data)) {
        const { skewId ="" , presetConfigs =""  } = data;
        return !isSsr ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "productcard-v3 productcard",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v3_ProductCard/* default */.Z, {
                authorData: {
                    skewId,
                    presetConfigs
                },
                fullData: fullData
            })
        }) : null;
    }
    if ((0,utils/* isProductcard */.po)(data)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_ProductCard, {
            data: data,
            fullData: fullData
        });
    }
    if ((0,utils/* isCarousel */.C2)(data)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_Carousel, {
            data: data,
            fullData: fullData
        });
    }
    if ((0,utils/* isPromoBanner */.e7)(data)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_PromoBanner, {
            data: data
        });
    }
    if ((0,utils/* isSlick */.bd)(data)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_CarouselSlick, {
            fullData: fullData,
            data: data
        });
    }
    if ((0,utils/* isTeaser */.j$)(data)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_Teaser, {
            data: data,
            fullData: fullData,
            containerId: containerId,
            bodytitle: bodytitle
        });
    }
    if ((0,utils/* isText */.Gs)(data)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_Text, {
            data: data
        });
    }
    if ((0,utils/* isInPageSearch */.L8)(data)) {
        return !isSsr ? /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_InPageSearch, {
            data: data
        }) : null;
    }
    if ((0,utils/* isTab */.wR)(data) && data["appliedCssClassNames"]) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_Tab, {
            data: data,
            itemKey: itemKey,
            ...extraProps
        });
    }
    if ((0,utils/* isBrandHeader */.cD)(data)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Shared_BrandHeader, {
            data: data,
            eventHandler: eventHandler
        });
    }
    if ((0,utils/* isHeaderNav */.ZS)(data)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Shared_HeaderNav, {
            data: data,
            eventHandler: eventHandler
        });
    }
    if ((0,utils/* isHeaderNavV3 */.A9)(data)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Shared_HeaderNav, {
            data: data,
            eventHandler: eventHandler,
            v3: true
        });
    }
    if ((0,utils/* isVisualNav */.RU)(data) && data["appliedCssClassNames"]) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(VisualNav, {
            data: data
        });
    }
    if ((0,utils/* isEmbed */.P2)(data)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Shared_Embed, {
            data: data,
            eventHandler: eventHandler
        });
    }
    if ((0,utils/* isFooter */.cl)(data)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Shared_Footer, {
            data: data,
            eventHandler: eventHandler
        });
    }
    if ((0,utils/* isShopTheRoomDetail */.ph)(data)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_ShopTheRoomDetail, {
            data: data
        });
    }
    if ((0,utils/* isRoomDetail */.X7)(data)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_RoomDetailPage, {
            data: data
        });
    }
    if ((0,utils/* isShopTheRoomCard */.ck)(data)) {
        var ref;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ShopTheRoomCard["default"], {
            cardTitle: data === null || data === void 0 ? void 0 : data.cardTitle,
            cardHoverTitle: data === null || data === void 0 ? void 0 : data.cardHoverTitle,
            ctalink: data === null || data === void 0 ? void 0 : data.ctalink,
            landingImageLink: data === null || data === void 0 ? void 0 : data.landingImageLink,
            modelImageLink: data === null || data === void 0 ? void 0 : data.modelImageLink,
            skuIds: data === null || data === void 0 ? void 0 : data.skuIds,
            presetConfigs: (ref = data === null || data === void 0 ? void 0 : data.presetConfigs) !== null && ref !== void 0 ? ref : "{}",
            altModel: data === null || data === void 0 ? void 0 : data.altModel,
            altLanding: data === null || data === void 0 ? void 0 : data.altLanding,
            linkNewTab: data === null || data === void 0 ? void 0 : data.linkNewTab
        });
    }
    if ((0,utils/* isCartLanding */.l1)(data)) {
        if (!isSsr) {
            return extraProps && extraProps.landing && extraProps.landing(data);
        } else {
            return extraProps && extraProps.landingFiller && extraProps.landingFiller(data);
        }
    }
    if ((0,utils/* isUpSellContainer */._4)(data)) {
        return extraProps && extraProps.upSellContainer && extraProps.upSellContainer(data);
    }
    if ((0,utils/* isCheckoutLanding */.Ar)(data) && !isSsr) {
        return extraProps && extraProps.checkoutView && extraProps.checkoutView(data);
    }
    if ((0,utils/* isOrderConfirmation */.Uq)(data)) {
        if (!isSsr) {
            return extraProps && extraProps.orderConfirmation && extraProps.orderConfirmation(data);
        } else {
            return extraProps && extraProps.orderConfirmationTagFiller && extraProps.orderConfirmationTagFiller();
        }
    }
    if ((0,utils/* isOrderStatus */.K0)(data)) {
        if (!isSsr) {
            return extraProps && extraProps.orderStatus && extraProps.orderStatus(data);
        } else {
            return extraProps && extraProps.orderStatusFiller && extraProps.orderStatusFiller();
        }
    }
    if ((0,utils/* isOrderHistory */._$)(data) && !isSsr) {
        return extraProps && extraProps.orderHistory && extraProps.orderHistory(data);
    }
    if ((0,utils/* isOrderDetails */.pv)(data)) {
        if (!isSsr) {
            return extraProps && extraProps.orderDetails && extraProps.orderDetails(data);
        } else {
            return extraProps && extraProps.orderDetailsFiller && extraProps.orderDetailsFiller(data);
        }
    }
    if ((0,utils/* isPairsWellWth */.oC)(data) && !isSsr) {
        return extraProps && extraProps.pairsWellWith && extraProps.pairsWellWith(data);
    }
    if ((0,utils/* isSharedCart */.sL)(data) && !isSsr) {
        return extraProps && extraProps.sharedCart && extraProps.sharedCart(data);
    }
    if ((0,utils/* isShopTheRoomLandingPage */.mI)(data)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: componentContexts.map((param, index)=>/*#__PURE__*/ {
                let { Component , componentProps  } = param;
                return (0,jsx_runtime.jsx)(Component, {
                    data: data,
                    ...componentProps.isFullData ? {
                        ...componentProps,
                        fullData: fullData
                    } : componentProps
                }, "".concat(Component.name, "-").concat(index));
            })
        });
    }
    if ((0,utils/* isBreadcrumb */.Z3)(data)) {
        return extraProps && extraProps.breadCrumb && extraProps.breadCrumb(data, fullData);
    }
    if ((0,utils/* isProductList */.Hx)(data)) {
        if (!isSsr) {
            return extraProps && extraProps.productList && extraProps.productList(data, eventHandler);
        } else {
            return extraProps && extraProps.productListFiller && extraProps.productListFiller(data);
        }
    }
    if ((0,utils/* isSearch */.N)(data)) {
        if (!isSsr) {
            return extraProps && extraProps.searchComponent && extraProps.searchComponent(data, eventHandler);
        } else {
            return extraProps && extraProps.searchFiller && extraProps.searchFiller(data);
        }
    }
    if ((0,utils/* isHelpSupport */.zK)(data) && !isSsr) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_HelpSupport, {
            data: data
        });
    }
    if ((0,utils/* isAccountSettings */.mg)(data)) {
        if (!isSsr) {
            return accountSettings(data);
        } else {
            return myGenericFiller(data, title);
        }
    }
    if ((0,utils/* isMyservice */.U4)(data)) {
        if (!isSsr) {
            return myServices(data);
        } else {
            return myGenericFiller(data, title);
        }
    }
    if ((0,utils/* isMyFavorites */.we)(data)) {
        if (!isSsr) {
            return myFavorites(data);
        } else {
            return myGenericFiller(data, title);
        }
    }
    if ((0,utils/* isChangePassword */.Si)(data)) {
        if (!isSsr) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ChangePassword/* default */.Z, {
                data: data
            });
        } else {
            return "Loading...";
        }
    }
    if ((0,utils/* isMyproducts */.Dx)(data)) {
        if (!isSsr) {
            return myProducts(data);
        } else {
            return myGenericFiller(data, title);
        }
    }
    if ((0,utils/* isLiterature */.ek)(data) && !isSsr) {
        return extraProps && extraProps.literature && extraProps.literature(data);
    }
    if ((0,utils/* isTechnicalSpec */.HR)(data)) {
        return technicalSpecifications && technicalSpecifications(data);
    }
    if ((0,utils/* isProductDetails */.jS)(data)) {
        if (!isSsr) {
            return extraProps && extraProps.productDetail && extraProps.productDetail(data, extraProps === null || extraProps === void 0 ? void 0 : extraProps.slug, extraProps === null || extraProps === void 0 ? void 0 : extraProps.skuId);
        } else {
            return extraProps && extraProps.productDetailFiller && extraProps.productDetailFiller(data);
        }
    }
    if ((0,utils/* isProductAccordion */.eq)(data) && !isSsr) {
        return extraProps && extraProps.productAccordion && extraProps.productAccordion(data);
    }
    if ((0,utils/* isProductExfPdp */.V6)(data) && !isSsr) {
        return extraProps && extraProps.productExf && extraProps.productExf(data);
    }
    if ((0,utils/* isProductReview */.s3)(data) && !isSsr) {
        return extraProps && extraProps.review && extraProps.review(data);
    }
    if ((0,utils/* isRegisterOffline */.hn)(data)) {
        if (!isSsr) {
            return extraProps && extraProps.offlineProducts && extraProps.offlineProducts(data);
        } else {
            return extraProps && extraProps.offlineProducts && extraProps.offlineProductsFiller();
        }
    }
    if ((0,utils/* isRegisterOnline */.L)(data)) {
        if (!isSsr) {
            return extraProps && extraProps.onlineProducts && extraProps.onlineProducts(data);
        } else {
            return extraProps && extraProps.onlineProducts && extraProps.offlineProductsFiller();
        }
    }
    if ((0,utils/* isKnowledgeArticle */.Mc)(data)) {
        return extraProps && knowledgeArticle(data, urlNames);
    }
    if ((0,utils/* isBrowseAllStores */.MN)(data) && !isSsr) {
        return extraProps && extraProps.browseAllStores && extraProps.browseAllStores(data);
    }
    if ((0,utils/* isContactUs */.OL)(data)) {
        if (!isSsr) {
            return contactUs(data);
        } else {
            return contactUsFiller();
        }
    }
    if ((0,utils/* isFindingModelNumber */.iL)(data) && !isSsr) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_FindingModelNumber, {
            data: data
        });
    }
    if ((0,utils/* isPressLanding */.GX)(data) && !isSsr) {
        return pressReleaseLanding(data);
    }
    if ((0,utils/* isFindStore */._H)(data) && !isSsr) {
        return findStore(data);
    }
    if ((0,utils/* isTitle */.Wt)(data) && !isSsr) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Default_Title, {
            data: data
        });
    }
    if ((0,utils/* isKeySpecifier */.z9)(data)) {
        return keySpecifier(data);
    }
    if ((0,utils/* isDynamicSearch */.Lg)(data) && !isSsr) {
        const { presetConfigs: presetConfigs1 = {} , disableParts =false , enablePotraitTile =false  } = data;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_DynamicSearch, {
            presetConfigs: presetConfigs1,
            disableParts: disableParts,
            enablePotraitTile: enablePotraitTile
        });
    }
    if ((0,utils/* isAssociateMembership */.F0)(data)) {
        return associateMembership(data);
    }
    if ((0,utils/* isInstallDesignServices */.kp)(data) && !isSsr) {
        return installDesignServices(data);
    }
    if ((0,utils/* isProfessionalDetail */.Y5)(data) && !isSsr) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_VirtualDesignerDetails, {
            data: data
        });
    }
    if ((0,utils/* isFriendsAndFamily */.jM)(data)) {
        return friendsAndFamily(data);
    }
    if ((0,utils/* isFindAProByZip */.gd)(data)) {
        return !isSsr ? /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_FindAProByZip, {
            data: data
        }) : null;
    }
    if ((0,utils/* isFindAProResults */.U2)(data)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(FindAProResults_v1, {
            data: data
        });
    }
    if ((0,utils/* isStoreAppointment */.xA)(data) && !isSsr) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_StoreAppointment, {
            data: data
        });
    }
    if ((0,utils/* isList */.nq)(data)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(SiteMap_v1, {
            data: data
        });
    }
    if ((0,utils/* isPDPCuratedProducts */.VV)(data)) {
        return extraProps && extraProps.pdpCuratedProduct && extraProps.pdpCuratedProduct(data);
    }
    if ((0,utils/* isProductSlider */._h)(data)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCarousel_ProductCarousel, {
            data: data
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(utils/* ConditionalWrapper */.M2, {
            condition: (0,utils/* isContainer */.Nm)(data) && itemKey === constants.COMPONENT_TYPES.ROOT_CONTAINER || isWrapperRequired,
            wrapper: (children)=>{
                /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                    className: "".concat(data === null || data === void 0 ? void 0 : data.gridClassNames, " ").concat(isScrollMarginRequired ? "unsetPageScrollMargin" : ""),
                    children: children
                });
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_AemGridColumn, {
                data: data,
                itemKey: itemKey,
                count: count,
                eventHandler: eventHandler,
                containerId: containerId,
                ...extraProps
            })
        })
    });
};
/* harmony default export */ var components_AemGrid = (AemGrid);


/***/ }),

/***/ 42536:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_ChangePassword; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 16 modules
var esm = __webpack_require__(24400);
// EXTERNAL MODULE: ./node_modules/qs/lib/index.js
var lib = __webpack_require__(80129);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./services/auth.service.js
var auth_service = __webpack_require__(77932);
// EXTERNAL MODULE: ./constants/api.js
var api = __webpack_require__(73350);
// EXTERNAL MODULE: ./services/ct.service.js
var ct_service = __webpack_require__(13875);
// EXTERNAL MODULE: ./store/features/authSlice.js
var authSlice = __webpack_require__(24899);
// EXTERNAL MODULE: ./utils/helper.js + 1 modules
var helper = __webpack_require__(55760);
;// CONCATENATED MODULE: ./components/ChangePassword/analytics/index.js
const addAnalyticsShowAuthModal = ()=>{
    const eventInfo = {
        eventAction: "my account:password reset:sign in",
        eventName: "my account:password reset:sign in",
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "sign in",
        internalLinkPosition: "my account",
        internalLinkType: "my account:navigation",
        internalLinkZoneName: "my account:password reset:success",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    pushAnalyticsObjToDataLayer(eventInfo);
};
const addAnalyticsShowRequirements = ()=>{
    const eventInfo = {
        eventAction: "my account:password reset:password requirements",
        eventName: "my account:password reset:password requirements",
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "password requirements",
        internalLinkPosition: "my account",
        internalLinkType: "my account:informative",
        internalLinkZoneName: "my account:password reset:create new password form",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    pushAnalyticsObjToDataLayer(eventInfo);
};
const addAnalyticsResetPassword = ()=>{
    const eventInfo = {
        eventAction: "my account:password reset:reset password button",
        eventName: "my account:password reset:reset password button",
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "reset password",
        internalLinkPosition: "my account",
        internalLinkType: "my account:navigation",
        internalLinkZoneName: "my account:password reset:create new password form",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    pushAnalyticsObjToDataLayer(eventInfo);
};
const pushAnalyticsObjToDataLayer = function() {
    let eventInfo = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const event = "cmp:click";
    window.adobeDataLayer.push({
        event,
        eventInfo,
        page
    });
};

// EXTERNAL MODULE: ./store/index.js + 4 modules
var store = __webpack_require__(88032);
;// CONCATENATED MODULE: ./components/ChangePassword/localization.js

const getTranslations = (t)=>{
    const { auth: { authModal: { staticText ={}  } = {}  } = {}  } = store/* store.getState */.h.getState();
    const { passwordlabel =t("kf.changePassword.label.password") , resetpasswordlabel =t("kf.changePassword.label.resetPassword") , passwordrequirementstext =t("kf.changePassword.label.passwordRequirements") , reEnterPassword =t("kf.changePassword.label.reEnterPassword") , createnewpassword =t("kf.changePassword.label.createNewPassword") , resetPassword =t("kf.changePassword.label.resetPassword") , newpassworddescription =t("kf.changePassword.label.createPasswordDesc") , passwordlabelerrormessage =t("kf.changePassword.label.passwordError") , reenterpasswordlabelerrormessage =t("kf.auth.label.provide.reEnterPwdError") , successMessage =t("kf.changePassword.label.successMessage")  } = staticText;
    return {
        passwordSuccessText: t("kf.changePassword.label.success"),
        recentPasswordText: t("kf.account.error.recentPassword"),
        characterCountText: t("kf.changePassword.label.characterCount"),
        pwMustIncludeText: t("kf.changePassword.label.pwMustInclude"),
        signinText: t("kf.changePassword.label.signin"),
        passwordMatchErrorText: t("kf.changePassword.label.passwordMatchError"),
        passwordAuthErrorText: t("kf.auth.error.passwordError"),
        pwdErrorText: t("kf.auth.label.provide.pwdError"),
        passwordUpdatedText: t("kf.changePassword.label.passwordRequirements"),
        passwordLabelText: passwordlabel,
        successMessageText: successMessage,
        reenterPasswordLabelErrorMessage: reenterpasswordlabelerrormessage,
        passwordLabelErrorMessage: passwordlabelerrormessage,
        newPasswordDescriptionText: newpassworddescription,
        reEnterPasswordText: reEnterPassword,
        createNewPasswordText: createnewpassword,
        resetPasswordText: resetPassword,
        resetPasswordLabelText: resetpasswordlabel,
        passwordRequirementsText: passwordrequirementstext,
        uppercaseLetterText: t("kf.changePassword.label.uppercaseLetter"),
        lowercaseLetterText: t("kf.changePassword.label.lowercaseLetter"),
        symbolValidationText: t("kf.changePassword.label.symbolValidation"),
        numberValidationText: t("kf.changePassword.label.numberValidation")
    };
};

// EXTERNAL MODULE: ./components/core/Input/Input.jsx
var Input = __webpack_require__(3372);
// EXTERNAL MODULE: ./components/core/Button/Button.jsx + 1 modules
var Button = __webpack_require__(7872);
// EXTERNAL MODULE: ./components/core/ToolTip/ToolTip.jsx
var ToolTip = __webpack_require__(53683);
;// CONCATENATED MODULE: ./components/ChangePassword/PasswordRequirements/index.js



const PasswordRequirements = (props)=>{
    const { passwordRegExp: { passwordMessage =[]  } = {}  } = props;
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const staticText = getTranslations(t);
    const { passwordRequirementsText ="" , pwMustIncludeText ="" , characterCountText ="" , uppercaseLetterText ="" , lowercaseLetterText ="" , symbolValidationText ="" , numberValidationText =""  } = staticText;
    const i18n = {
        showDialog: true
    };
    if (passwordRequirementsText === pwMustIncludeText) {
        i18n.characterCount = characterCountText;
        i18n.uppercaseLetter = uppercaseLetterText;
        i18n.lowercaseLetter = lowercaseLetterText;
        i18n.symbolValidation = symbolValidationText;
        i18n.numberValidation = numberValidationText;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "password-tooltip",
        children: i18n.showDialog ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: pwMustIncludeText
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    children: passwordMessage.length ? passwordMessage.map((message, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: message
                        }, i)) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: i18n.characterCount
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: i18n.uppercaseLetter
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: i18n.lowercaseLetter
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: i18n.symbolValidation
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: i18n.numberValidation
                            })
                        ]
                    })
                })
            ]
        }) : passwordRequirementsText
    });
};
/* harmony default export */ var ChangePassword_PasswordRequirements = (PasswordRequirements);

// EXTERNAL MODULE: ./components/ChangePassword/index.module.scss
var index_module = __webpack_require__(92186);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
;// CONCATENATED MODULE: ./components/ChangePassword/index.jsx

















const ChangePassword = ()=>{
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const staticText = getTranslations(t);
    const { passwordLabelText ="" , resetPasswordLabelText ="" , passwordRequirementsText ="" , reEnterPasswordText ="" , resetPasswordText ="" , newPasswordDescriptionText ="" , reenterPasswordLabelErrorMessage ="" , successMessageText ="" , passwordSuccessText ="" , signinText ="" , pwdErrorText ="" , passwordAuthErrorText ="" , passwordMatchErrorText ="" , recentPasswordText =""  } = staticText;
    const [showRequirements, setShowRequirements] = (0,react.useState)(false);
    const [showSuccess, setShowSuccess] = (0,react.useState)(false);
    const [loading, setLoading] = (0,react.useState)(false);
    const [password, setPassword] = (0,react.useState)({
        value: "",
        error: false,
        errorMssg: ""
    });
    const [rePassword, setRePassword] = (0,react.useState)({
        value: "",
        error: false,
        errorMssg: ""
    });
    const [passwordRegExp, setPasswordRegExp] = (0,react.useState)({
        regex: "",
        passwordMessage: []
    });
    const dispatch = (0,es/* useDispatch */.I0)();
    (0,react.useEffect)(()=>{
        (0,helper/* getPasswordRegExp */.VzW)().then((getPasswordRegEx)=>{
            var _regex, _passwordMessage;
            setPasswordRegExp({
                regex: (_regex = getPasswordRegEx.regex) !== null && _regex !== void 0 ? _regex : "",
                passwordMessage: (_passwordMessage = getPasswordRegEx.passwordMessage) !== null && _passwordMessage !== void 0 ? _passwordMessage : []
            });
        });
    }, []);
    (0,react.useEffect)(()=>{
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth"
        });
    }, [
        showSuccess
    ]);
    const clearError = ()=>{
        setPassword({
            ...password,
            error: false,
            errorMssg: ""
        });
        setRePassword({
            ...rePassword,
            error: false,
            errorMssg: ""
        });
    };
    const onBlurInput = (name, value)=>{
        switch(name){
            case "pwd":
                {
                    if (!value) return setPassword({
                        ...password,
                        error: true,
                        errorMssg: pwdErrorText
                    });
                    if (!localStorage.getItem("passwordChangeRequired")) {
                        var ref;
                        const email = (ref = new URLSearchParams(window.location.search).get("email")) !== null && ref !== void 0 ? ref : "";
                        const emailVal = email ? email.split(/[@.]/) : [];
                        const passwordData = emailVal === null || emailVal === void 0 ? void 0 : emailVal.filter((el)=>el.length > 1);
                        (0,helper/* validatePassword */.uo4)(value, [
                            ...passwordData
                        ]).then((res)=>{
                            if (!res) setPassword({
                                ...password,
                                error: true,
                                errorMssg: passwordAuthErrorText
                            });
                            else setPassword({
                                ...password,
                                error: false,
                                errorMssg: ""
                            });
                        });
                    }
                    break;
                }
            case "re-pwd":
                if (!value) return setRePassword({
                    ...rePassword,
                    error: true,
                    errorMssg: reenterPasswordLabelErrorMessage
                });
                if (password.value !== rePassword.value) setRePassword({
                    ...rePassword,
                    error: true,
                    errorMssg: passwordMatchErrorText
                });
                else setRePassword({
                    ...rePassword,
                    error: false,
                    errorMssg: ""
                });
                break;
            default:
                return;
        }
    };
    const successCb = ()=>{
        setShowSuccess(true);
        setLoading(false);
        localStorage.removeItem("passwordChangeRequired");
        sessionStorage.removeItem("OTPPassword");
        sessionStorage.removeItem("userIdForOTP");
    };
    const errorCB = (err)=>{
        setLoading(false);
        if ((err === null || err === void 0 ? void 0 : err.errorCode) && (err === null || err === void 0 ? void 0 : err.errorCode) === "E0000014") {
            setPassword({
                ...password,
                error: true,
                errorMssg: recentPasswordText
            });
        } else if (err) setPassword({
            ...password,
            error: true,
            errorMssg: err
        });
    };
    const handleResetPassword = async ()=>{
        clearError();
        let valid = true;
        if (!localStorage.getItem("passwordChangeRequired")) {
            const email = new URLSearchParams(window.location.search).get("email");
            const emailVal = email ? email.split(/[@.]/) : [];
            const passwordData = emailVal === null || emailVal === void 0 ? void 0 : emailVal.filter((el)=>el.length > 1);
            const isValidPassword = await (0,helper/* validatePassword */.uo4)(password.value, [
                ...passwordData
            ]);
            if (!isValidPassword) {
                setPassword({
                    ...password,
                    error: true,
                    errorMssg: passwordAuthErrorText
                });
                valid = false;
            } else {
                setPassword({
                    ...password,
                    error: false,
                    errorMssg: ""
                });
            }
        }
        if (password.value !== rePassword.value) {
            setRePassword({
                ...rePassword,
                error: true,
                errorMssg: passwordMatchErrorText
            });
            valid = false;
        }
        if (valid) {
            setLoading(true);
            const { recoveryToken  } = lib_default().parse(window.location.search, {
                ignoreQueryPrefix: true
            });
            if (localStorage.getItem("passwordChangeRequired")) {
                changePassword(password.value);
                return;
            }
            (0,auth_service/* resetPassword */.c0)(recoveryToken, password.value, successCb, errorCB);
        }
        addAnalyticsResetPassword();
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth"
        });
    };
    const changePassword = async (newPassword)=>{
        await (0,api/* getAnonymousToken */.ab)(true, "change_password");
        const res = await (0,ct_service/* requestForChangePassword */.HB)({
            oldPassword: sessionStorage.getItem("OTPPassword"),
            newPassword,
            id: sessionStorage.getItem("userIdForOTP")
        });
        if (res && res.status === 200) {
            successCb();
        } else {
            errorCB(res.data);
        }
    };
    const handleShowAuthModal = ()=>{
        dispatch((0,authSlice/* setAuthModalVisibility */.LY)({
            show: true
        }));
        addAnalyticsShowAuthModal();
    };
    const handleShowRequirements = ()=>{
        setShowRequirements(!showRequirements);
        addAnalyticsShowRequirements();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (index_module_default()).ChangePassword,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "wrapper",
            children: !showSuccess ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        className: "header",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                children: resetPasswordText
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: newPasswordDescriptionText
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                        id: "kf-change-password",
                        type: "password",
                        value: password.value,
                        maxLength: 40,
                        placeholder: "".concat(passwordLabelText),
                        label: "".concat(passwordLabelText),
                        onChange: (e)=>setPassword({
                                ...password,
                                value: e.target.value
                            }),
                        showError: password.error,
                        errorMessage: password.errorMssg,
                        onBlur: (e)=>onBlurInput("pwd", e.target.value)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "password-requirements",
                        onClick: handleShowRequirements,
                        children: passwordRequirementsText
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "password-requirements__tooltip".concat(showRequirements ? "--show" : "--hide"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "password-requirements__tooltip-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ToolTip/* default */.Z, {
                                message: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChangePassword_PasswordRequirements, {
                                    passwordRegExp: passwordRegExp
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                        id: "kf-change-re-password",
                        type: "password",
                        value: rePassword.value,
                        maxLength: 40,
                        placeholder: "".concat(reEnterPasswordText),
                        label: "".concat(reEnterPasswordText),
                        onChange: (e)=>setRePassword({
                                ...rePassword,
                                value: e.target.value
                            }),
                        showError: rePassword.error,
                        errorMessage: rePassword.errorMssg,
                        onBlur: (e)=>onBlurInput("re-pwd", e.target.value)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        type: "black",
                        flexible: true,
                        label: resetPasswordLabelText,
                        onClick: handleResetPassword,
                        customClass: "reset-button",
                        loading: loading,
                        role: "button"
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        className: "header",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                children: "".concat(passwordSuccessText, "!")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: successMessageText
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        type: "black",
                        flexible: true,
                        label: signinText,
                        onClick: handleShowAuthModal
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var components_ChangePassword = (ChangePassword);


/***/ }),

/***/ 42426:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Cu": function() { return /* binding */ doubleFeatureContentCardSettings; },
  "UD": function() { return /* binding */ isProductFeatureLandscapeCarouselUpdatePage; },
  "NW": function() { return /* binding */ singleSliderSettings; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/Default/CarouselSlick/v1/Arrow.jsx

const Arrow = (props)=>{
    const { className ="" , style ="" , onClick =()=>{} , label ="" , topPosition =0 , addAnalyticsForArrows =()=>{}  } = props;
    const clickHandler = (e, label)=>{
        onClick && onClick(e);
        addAnalyticsForArrows(label);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        className: className,
        type: "button",
        "aria-label": label,
        style: {
            ...style,
            top: topPosition ? topPosition : ""
        },
        onClick: (e)=>clickHandler(e, label)
    });
};
/* harmony default export */ var v1_Arrow = (Arrow);

;// CONCATENATED MODULE: ./components/Default/CarouselSlick/v1/SlickSettings.js


const doubleFeatureContentCardSettings = {
    dots: false,
    infinite: true,
    fade: true,
    autoplay: false,
    cssEase: "ease-in-out",
    arrows: false,
    pauseOnFocus: false,
    pauseOnHover: false
};
const singleSliderSettings = function(cb, topPosition, autoplay, autoplaySpeed, addAnalyticsForArrows) {
    let afterChangeCb = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : ()=>{};
    return {
        autoplay,
        autoplaySpeed,
        dots: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        swipeToSlide: true,
        swipe: true,
        arrows: true,
        infinite: true,
        centerMode: false,
        beforeChange: (_, current)=>cb ? cb(current + 1, current) : undefined,
        afterChange: (a, b)=>afterChangeCb ? afterChangeCb(a, b) : undefined,
        nextArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_Arrow, {
            label: "Next",
            topPosition: topPosition,
            addAnalyticsForArrows: addAnalyticsForArrows
        }),
        prevArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_Arrow, {
            label: "Previous",
            topPosition: topPosition,
            addAnalyticsForArrows: addAnalyticsForArrows
        })
    };
};
const PRODUCT_FEATURE_LANDSCAPE_CAROUSEL_UPDATED = "product feature landscape carousel updated";
const isProductFeatureLandscapeCarouselUpdatePage = (pageName)=>{
    return pageName && (pageName === null || pageName === void 0 ? void 0 : pageName.trim().toLowerCase()) === PRODUCT_FEATURE_LANDSCAPE_CAROUSEL_UPDATED;
};


/***/ }),

/***/ 73846:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ getTranslations; }
/* harmony export */ });
const getTranslations = (t)=>{
    return {
        searchBrand: t("kf.search.label.searchBrand"),
        popularSearchText: t("kf.search.label.popularSearch"),
        topProductResults: (category)=>category !== "products" ? t("kf.search.label.topResults") : t("kf.search.label.topProductResults"),
        recentSearches: t("kf.search.label.recentSearch"),
        clearAll: t("kf.search.label.clearAll"),
        see: t("kf.search.label.see"),
        all: t("kf.search.label.all"),
        resultText: t("kf.search.label.resultsCaps"),
        searchCTA: t("kf.search.label.searchCTA"),
        top: t("kf.search.label.top"),
        product: t("kf.search.label.products"),
        topResult: t("kf.search.label.topResults"),
        saleText: t("kf.search.label.topResults"),
        colors: t("kf.search.label.colors"),
        color: t("kf.search.label.color"),
        brand: t("kf.search.label.brand"),
        new: t("kf.search.label.new"),
        sale: t("kf.search.label.sale"),
        topSuggestions: t("kf.search.label.topSuggestions"),
        yourSearch: t("kf.search.label.yourSearch"),
        seeAll: t("kf.search.label.seeAll"),
        results: t("kf.search.label.resultsCaps"),
        searchHeader: t("kf.search.label.searchHeader"),
        resultsCaps: t("kf.search.label.resultsCaps"),
        favSuccessMsg: t("kf.favorites.success"),
        favErrorMsg: t("kf.favorites.error"),
        favRemoveSuccessMsg: t("kf.favorites.removeItem"),
        favRemoveErrorMsg: t("kf.favorites.removeItemError"),
        sameCategory: t("kf.compare.validation.sameCategory"),
        maxProduct: t("kf.compare.validation.maxProducts"),
        addToCompare: t("kf.plp.label.addToCompare"),
        onSale: t("kf.plp.label.onSale"),
        ariaLabel: {
            close: t("kf.search.aria.label.close"),
            delete: (keyword)=>t("kf.search.aria.label.delete", {
                    keyword
                }),
            continue: t("kf.global.aria.label.continue"),
            addToCompare: (product)=>t("kf.plp.label.aria.addToCompare", {
                    product
                })
        },
        exclusive: t("kf.plp.label.exclusive"),
        newExclusive: t("kf.plp.label.newExclusive"),
        globalHome: t("kf.global.label.home")
    };
};


/***/ }),

/***/ 33507:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ addSearchAnalytics; },
/* harmony export */   "e": function() { return /* binding */ handleSearchAnalyticsEvent; }
/* harmony export */ });
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55760);

const handleSearchAnalyticsEvent = (status, message, internalLinkURL, eventType, redirectUrl, analyticsEventData, searchString, searchTotal, topSuggestedData, searchHistory, brandName)=>{
    if (!internalLinkURL) internalLinkURL = redirectUrl;
    const eventInfo = getEventInfoObj(status, message, internalLinkURL, eventType, analyticsEventData, searchString, searchTotal, topSuggestedData, searchHistory, brandName);
    sessionStorage.setItem("searches", eventInfo.searchCount);
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    window.adobeDataLayer.push({
        event: "cmp:click",
        page,
        eventInfo
    });
};
const getEventInfoObj = (status, message, internalLinkURL, eventType, analyticsEventData, searchString, searchTotal, topSuggestedData, searchHistory, brandName)=>{
    const currDate = new Date();
    const contentType = window.adobeDataLayer && window.adobeDataLayer.getState ? window.adobeDataLayer.getState("page.pageInfo.contentType") || window.adobeDataLayer.getState("page.category.primaryCategory") : "";
    const pageName = contentType ? contentType.split("-")[0] : "";
    const autoSearch = !internalLinkURL ? true : false;
    const searchSuggestedTerm = [];
    if (!analyticsEventData.searchString) {
        analyticsEventData.searchString = searchString;
    }
    if (!analyticsEventData.searchTotal) {
        analyticsEventData.searchTotal = searchTotal;
    }
    if (!analyticsEventData.topSuggestedData) {
        analyticsEventData.topSuggestedData = topSuggestedData;
    }
    const searchSuggestions = searchHistory && searchHistory.length ? searchHistory : analyticsEventData.topSuggestedData && analyticsEventData.topSuggestedData.length ? analyticsEventData.topSuggestedData : [];
    if (searchSuggestions === null || searchSuggestions === void 0 ? void 0 : searchSuggestions.length) {
        searchSuggestions.slice(0, 5).map((item)=>{
            searchSuggestedTerm.push((0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .sanitizeTextForAnalytics */ .T68)(item.productName_s || item.keyWord));
        });
    }
    const eventInfo = {
        eventName: "internal ".concat(autoSearch ? "automatic " : "", "search"),
        eventAction: "internal ".concat(autoSearch ? "automatic " : "", "search"),
        internalLinkName: "internal search icon",
        internalLinkType: "global header:navigation",
        internalLinkZoneName: "global header",
        clickInternalLinks: "true",
        eventType: "global header",
        internalLinkURL: internalLinkURL ? (internalLinkURL.indexOf("http") === -1 ? window.location.origin : "") + internalLinkURL : "n/a",
        internalLinkPosition: "global header",
        eventMsg: status !== "success" ? message === null || message === void 0 ? void 0 : message.toLowerCase() : "n/a",
        eventStatus: status || "n/a",
        searchTerm: analyticsEventData.searchString,
        searchContentType: pageName ? pageName + " page" : "n/a",
        searchSuggestedTerm: searchSuggestedTerm.join("|") || "n/a",
        searchCount: sessionStorage.getItem("searches") ? Number(sessionStorage.getItem("searches")) + 1 : 1,
        searchResult: analyticsEventData.searchTotal,
        internalZoneName: "search:search box",
        pageURL: window.location.href,
        referrer: document.referrer || "n/a",
        previousPage: document.referrer || "n/a",
        timeStamp: currDate.toISOString().split("T")[0] + " " + currDate.toTimeString().split(" ")[0],
        contentType: brandName === null || brandName === void 0 ? void 0 : brandName.toLowerCase()
    };
    if (eventType === null || eventType === void 0 ? void 0 : eventType.type) {
        eventType.term = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .sanitizeTextForAnalytics */ .T68)(eventType.term);
        eventType.type = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .sanitizeTextForAnalytics */ .T68)(eventType.type);
        eventInfo.eventName = "search:" + eventType.type + ":search term";
        eventInfo.eventAction = "search:" + eventType.type + ":search term";
        eventInfo.internalLinkZoneName = "search:" + eventType.type;
        if (eventType.type === "our top suggestions") {
            var ref;
            eventInfo.searchTerm = (ref = analyticsEventData.searchString) === null || ref === void 0 ? void 0 : ref.toLowerCase();
            eventInfo.searchSuggestedTerm = eventType.term;
        } else {
            eventInfo.searchTerm = eventType.term;
        }
        eventInfo.internalLinkName = eventType.term;
        eventInfo.internalZoneName = "search:" + eventType.type;
    }
    analyticsEventData = {};
    return eventInfo;
};
const addSearchAnalytics = (params, general, searchKeyword)=>{
    var ref, ref1, ref2, ref3, ref4, ref5;
    const { total , errorMessage , status , autoSearch , keyword ="" , tabCountObj ={} , isSterlingTemp , searchCountIncreased =true , urlFlag =false  } = params;
    const action = autoSearch ? "cmp:click" : params === null || params === void 0 ? void 0 : params.action;
    const { productTabCount , helpTabCount , resourceTabCount , technicalTabCount , inspireTabCount , partTabCount  } = tabCountObj;
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = action === "cmp:show" ? window === null || window === void 0 ? void 0 : window.pageObj : getState && getState("page") || {};
    const contentType = window.eventPageType || "";
    const pageName = contentType ? contentType.split("-")[0] : "";
    const previousPageNameForSearch = sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.getItem("previousPageNameForSearch");
    const previousUrlNew = sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.getItem("previousUrl");
    sessionStorage.removeItem("previousUrl");
    const currDate = new Date();
    const eventInfo = {
        searchCount: (sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.getItem("searches")) ? Number(sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.getItem("searches")) + (searchCountIncreased ? 1 : 0) : 1,
        searchResult: isSterlingTemp ? "".concat(productTabCount) : total,
        searchResultCategory: isSterlingTemp ? "products>".concat(productTabCount) : "products>".concat(productTabCount, "|parts>").concat(partTabCount, "|inspiration>").concat(inspireTabCount, "|technical>").concat(technicalTabCount, "|resources>").concat(resourceTabCount, "|help>").concat(helpTabCount),
        internalLinkName: "search",
        internalLinkPosition: "search results:search",
        internalLinkType: autoSearch ? "search:automatic search" : "search results:search:navigation",
        searchContentType: pageName ? pageName + " page" : "n/a",
        searchTerm: keyword.length ? keyword : searchKeyword,
        searchSuggestedTerm: "n/a",
        eventAction: "search:search box:".concat(autoSearch ? "automatic " : "", "search"),
        eventName: "search:search box:".concat(autoSearch ? "automatic " : "", "search"),
        eventType: "navigation",
        clickInternalLinks: "true",
        internalLinkURL: action === "cmp:show" ? "n/a" : window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : ref.href,
        internalZoneName: "search:search box",
        eventMsg: errorMessage || "n/a",
        eventStatus: status === "success" ? "success" : "failure",
        pageName: "search result",
        pageURL: urlFlag ? previousUrlNew : window === null || window === void 0 ? void 0 : (ref1 = window.location) === null || ref1 === void 0 ? void 0 : ref1.href,
        referrer: (document === null || document === void 0 ? void 0 : document.referrer) || "n/a",
        previousPage: previousPageNameForSearch || (document === null || document === void 0 ? void 0 : document.referrer) || "n/a",
        timeStamp: ((ref2 = currDate === null || currDate === void 0 ? void 0 : currDate.toISOString()) === null || ref2 === void 0 ? void 0 : ref2.split("T")[0]) + " " + ((ref3 = currDate === null || currDate === void 0 ? void 0 : currDate.toTimeString()) === null || ref3 === void 0 ? void 0 : ref3.split(" ")[0]),
        mktgCampaign: "n/a",
        contentType: general === null || general === void 0 ? void 0 : (ref4 = general.brandName) === null || ref4 === void 0 ? void 0 : ref4.toLowerCase(),
        internalLinkZoneName: "search:search box"
    };
    sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.setItem("searches", eventInfo === null || eventInfo === void 0 ? void 0 : eventInfo.searchCount);
    let { pageInfo: { pageUrl: tempUrl  }  } = page;
    tempUrl = window === null || window === void 0 ? void 0 : (ref5 = window.location) === null || ref5 === void 0 ? void 0 : ref5.href;
    page.pageInfo.pageUrl = urlFlag ? previousUrlNew : tempUrl;
    page.pageInfo.previousPage = previousPageNameForSearch;
    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .pushAnalyticsObjToDataLayer */ .zYT)(eventInfo, action, page);
};



/***/ }),

/***/ 30167:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B8": function() { return /* binding */ getStoreEventInfo; },
/* harmony export */   "CS": function() { return /* binding */ zipCodeInfoModalContinueAnalytics; },
/* harmony export */   "DO": function() { return /* binding */ addFindAStoreAnalytics; },
/* harmony export */   "HS": function() { return /* binding */ locationMessageNavigationAnalytics; },
/* harmony export */   "LX": function() { return /* binding */ setStoreAnalytics; },
/* harmony export */   "OQ": function() { return /* binding */ addAnalyticsData; },
/* harmony export */   "Qq": function() { return /* binding */ pushAnalyticsToDataLayer; },
/* harmony export */   "Us": function() { return /* binding */ getFilterEventInfo; },
/* harmony export */   "X1": function() { return /* binding */ addAnalyticsEvent; },
/* harmony export */   "dm": function() { return /* binding */ getEventClearFilterInfo; },
/* harmony export */   "hE": function() { return /* binding */ getEventStoreFilterInfo; },
/* harmony export */   "pm": function() { return /* binding */ findAStoreLoadMoreAnalytics; },
/* harmony export */   "rt": function() { return /* binding */ getEventStorePhoneInfo; },
/* harmony export */   "wo": function() { return /* binding */ addFilterExpandCollapseAnalytics; }
/* harmony export */ });
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55760);

const pageType = "find a store";
const addFindAStoreAnalytics = (params)=>{
    const { total , errorMessage , status , action , authorData , staticTexts , searchTerm , geolocationEvent  } = params;
    const errMsg = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .sanitizeText */ .oOy)(authorData.locationErrormessage ? authorData.locationErrormessage : staticTexts.locationErrormessage).trim().toLowerCase();
    let eventAction = "find a store:landing:location info:store search";
    let eventName = "find a store:landing:location info:store search";
    const eventStatus = status === "success" && total ? "success" : "failure";
    let internalLinkName = "store search";
    let internalLinkZoneName = "find a store:landing:location info:filters";
    if (geolocationEvent) {
        eventAction = "find a store:utility nav​:view store details:use my location";
        eventName = "find a store:utility nav​:view store details:use my location";
        internalLinkName = "use my location";
        internalLinkZoneName = "find a store:utility nav";
    }
    const currDate = new Date();
    const eventInfo = {
        searchCount: sessionStorage.getItem("findStores") ? Number(sessionStorage.getItem("findStores")) + 1 : 1,
        searchResult: total,
        internalLinkName,
        internalLinkPosition: "find a store",
        internalLinkType: "find a store:navigation",
        searchType: isNaN(searchTerm) || geolocationEvent ? "location" : "zipcode",
        searchTerm: searchTerm,
        eventAction,
        eventName,
        eventType: "navigation",
        clickInternalLinks: "true",
        internalLinkURL: "".concat(window.location.origin).concat(window.location.pathname),
        internalLinkZoneName,
        eventMsg: status === "success" && total ? "n/a" : errorMessage || errMsg || "n/a",
        eventStatus,
        pageName: "find a store result",
        pageURL: window.location.href,
        referrer: document.referrer || "n/a",
        previousPage: document.referrer || "n/a",
        timeStamp: currDate.toISOString().split("T")[0] + " " + currDate.toTimeString().split(" ")[0]
    };
    if (action === "cmp:show" && !(0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .isShowAnalyticsEventLoaded */ .xJ2)() || action !== "cmp:show") {
        sessionStorage.setItem("findStores", eventInfo.searchCount);
        const { adobeDataLayer: { getState  } = {}  } = window;
        const event = !(0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .isShowAnalyticsEventLoaded */ .xJ2)() ? "cmp:show" : action;
        const page = event === "cmp:show" ? window.pageObj : getState && getState("page") || {};
        if ((0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .navigationType */ .UsO)() !== 1 && event === "cmp:show" || event === "cmp:click") {
            (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .pushAnalyticsObjToDataLayer */ .zYT)(eventInfo, event, page);
        }
        delete window.pageObj;
    }
};
const findAStoreLoadMoreAnalytics = ()=>{
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "find a store:landing:location info:load more results",
        eventMsg: "n/a",
        eventName: "find a store:landing:location info:load more results",
        eventStatus: "n/a",
        eventType: "navigation",
        internalLinkName: "load more results",
        internalLinkPosition: "find a store",
        internalLinkType: "find a store:load more results",
        internalLinkURL: "".concat(window.location.origin).concat(window.location.pathname),
        internalLinkZoneName: "find a store:landing:location info"
    };
    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .pushAnalyticsObjToDataLayer */ .zYT)(eventInfo);
};
const getFilterEventInfo = (showFilter)=>{
    const type = showFilter ? "show filter" : "hide filter";
    const internalLinkType = "find a store:".concat(showFilter ? "show" : "hide");
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "find a store:landing:location info:".concat(type),
        eventName: "find a store:landing:location info:".concat(type),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "".concat(type, "s"),
        internalLinkPosition: "find a store",
        internalLinkType,
        internalLinkURL: "".concat(window.location.origin).concat(window.location.pathname),
        internalLinkZoneName: "find a store:landing:filters"
    };
    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .pushAnalyticsObjToDataLayer */ .zYT)(eventInfo);
};
const getStoreEventInfo = (type, internalLinkName, link)=>{
    return JSON.stringify({
        eventAction: "find a store:landing:location info:" + type,
        eventName: "find a store:landing:location info:" + type,
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: internalLinkName ? internalLinkName.toLowerCase() : type,
        internalLinkPosition: "find a store",
        internalLinkType: "find a store:navigation",
        internalLinkZoneName: "find a store:landing:location info",
        internalLinkURL: link ? (link.indexOf("http") === -1 ? window.location.origin : "") + link : "n/a",
        clickInternalLinks: "true"
    });
};
const getEventStoreFilterInfo = (data, type, link)=>{
    let internalLinkName;
    let internalLinkType = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .sanitizeTextForAnalytics */ .T68)(data.LocationName);
    const internalLinkTypeForFindStore = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .getInternalLinkTypeForFindStore */ .dhb)(data.LocationName, data.Locality, data.StateLong);
    if (type === "store name") {
        internalLinkName = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .sanitizeTextForAnalytics */ .T68)(data.LocationName);
        internalLinkType = "find a store:".concat(internalLinkTypeForFindStore);
    } else if (type === "store contact number") {
        internalLinkName = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .formatPhoneNumber */ .unW)(data.Phone);
        internalLinkType = "find a store:navigation";
    } else if (type === "set as preferred store" || type === "unset as preferred store") {
        internalLinkType = "find a store:".concat(internalLinkTypeForFindStore);
    }
    return JSON.stringify({
        eventAction: "find a store:landing:location info:".concat(type),
        eventName: "find a store:landing:location info:".concat(type),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: internalLinkName || type,
        internalLinkPosition: "find a store",
        internalLinkType,
        internalLinkZoneName: "find a store:landing:location info​",
        internalLinkURL: link ? (type !== "store contact number" && link.indexOf("http") === -1 ? window.location.origin : "") + link : "n/a",
        clickInternalLinks: "true"
    });
};
const getEventStorePhoneInfo = (PhoneNumber, tabTitle, link)=>{
    const internalLinkPhoneType = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .formatPhoneNumber */ .unW)(PhoneNumber);
    const eventInfo = {
        eventAction: "find a store:landing:location info:".concat(internalLinkPhoneType),
        eventName: "find a store:landing:location info:".concat(internalLinkPhoneType),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: internalLinkPhoneType,
        internalLinkPosition: "find a store",
        internalLinkType: "find a store:".concat(tabTitle === null || tabTitle === void 0 ? void 0 : tabTitle.toLowerCase()),
        internalLinkZoneName: "find a store:landing:location info​",
        internalLinkURL: internalLinkPhoneType === null ? link || "n/a" : "tel:".concat(PhoneNumber),
        clickInternalLinks: "true"
    };
    window === null || window === void 0 ? void 0 : window.adobeDataLayer.push({
        event: "cmp:click",
        eventInfo
    });
};
const addAnalyticsData = (curFilters, isChecked, obj, isFilterCancel)=>{
    const { facet , value: label  } = obj;
    const filterLabel = label || obj.display;
    const appliedOrRemoved = isFilterCancel ? "cancel" : isChecked ? "applied" : "removed";
    const eventInfo = {
        eventAction: "find a store:landing:filters:".concat(appliedOrRemoved),
        eventName: "find a store:landing:filters:".concat(appliedOrRemoved),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "".concat(filterLabel === null || filterLabel === void 0 ? void 0 : filterLabel.toLowerCase(), ":").concat(appliedOrRemoved),
        internalLinkPosition: "find a store",
        internalLinkType: "find a store:".concat(facet === null || facet === void 0 ? void 0 : facet.toLowerCase()),
        filterArray: "".concat((facet === null || facet === void 0 ? void 0 : facet.toLowerCase()) + ":" + (filterLabel === null || filterLabel === void 0 ? void 0 : filterLabel.toLowerCase())),
        internalLinkZoneName: "find a store:landing:filters",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    let filterArray = "";
    if (curFilters.length > 0) {
        curFilters.forEach((facetObj)=>{
            facetObj.value.forEach((facetValue)=>{
                filterArray += facetObj.facet.toLowerCase() + ":" + facetValue.toLowerCase() + "|";
            });
        });
    }
    eventInfo.filterArray = filterArray === null || filterArray === void 0 ? void 0 : filterArray.slice(0, -1);
    if (window.adobeDataLayer) {
        const { adobeDataLayer: { getState  } = {}  } = window;
        const page = getState && getState("page") || {};
        window.adobeDataLayer.push({
            event: "cmp:click",
            eventInfo,
            page
        });
    }
};
const addFilterExpandCollapseAnalytics = (facet, formatFacetName, collapse)=>{
    const collapseOrExpand = collapse[facet] ? "expand" : "collapse";
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "find a store:landing:filters:".concat(collapseOrExpand),
        eventName: "find a store:landing:filters:".concat(collapseOrExpand),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "".concat(collapseOrExpand),
        internalLinkPosition: "find a store",
        internalLinkType: "find a store:".concat(formatFacetName === null || formatFacetName === void 0 ? void 0 : formatFacetName.toLowerCase()),
        internalLinkURL: "n/a",
        internalLinkZoneName: "find a store:landing:filters​"
    };
    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .pushAnalyticsObjToDataLayer */ .zYT)(eventInfo);
};
const getEventClearFilterInfo = ()=>{
    return JSON.stringify({
        eventAction: "find a store:landing:filters:clear all",
        eventName: "find a store:landing:filters:clear all",
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "clear all",
        internalLinkPosition: "find a store",
        internalLinkType: "find a store:filters",
        internalLinkZoneName: "find a store:landing:filters",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    });
};
const addAnalyticsEvent = function(action) {
    let isForLocateMe = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const type = isForLocateMe ? "" : "zoom ";
    const linkType = isForLocateMe ? "navigation" : "zoom";
    const eventInfo = {
        eventAction: "find a store:landing:map:".concat(type).concat(action),
        eventName: "find a store:landing:map:".concat(type).concat(action),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "".concat(type).concat(action),
        internalLinkPosition: "find a store",
        internalLinkType: "find a store:".concat(linkType),
        internalLinkZoneName: "find a store:landing:map",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    window.adobeDataLayer.push({
        event: "cmp:click",
        eventInfo,
        page
    });
};
const setStoreAnalytics = (checked, locationName)=>{
    const type = checked ? "set as preferred store" : "unset as preferred store";
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "find a store:landing:location info:".concat(type),
        eventMsg: "n/a",
        eventName: "find a store:landing:location info:".concat(type),
        eventStatus: "n/a",
        eventType: "navigation",
        internalLinkName: type,
        internalLinkPosition: "find a store",
        internalLinkType: "find a store:".concat(locationName === null || locationName === void 0 ? void 0 : locationName.toLowerCase()),
        internalLinkURL: "".concat(window.location.origin).concat(window.location.pathname),
        internalLinkZoneName: "find a store:landing:location info"
    };
    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .pushAnalyticsObjToDataLayer */ .zYT)(eventInfo);
};
const zipCodeInfoModalContinueAnalytics = (ctaLabel, dataLayerPosition)=>{
    const label = ctaLabel === null || ctaLabel === void 0 ? void 0 : ctaLabel.toLowerCase();
    let eventName = "find a store:utility nav:view store details:".concat(label);
    let internalLinkPosition = "find a store";
    let internalLinkType = "find a store:navigation";
    let internalLinkZoneName = "find a store:modal:cant access your location";
    if (dataLayerPosition === "global header") {
        eventName = "find a store:utility nav:use my location:".concat(label);
        internalLinkPosition = "global header:find a store";
    }
    if (dataLayerPosition === "find a pro") {
        eventName = "find a pro:see local professionals:use my location:".concat(label);
        internalLinkPosition = "find a pro";
        internalLinkType = "find a pro:use my location";
        internalLinkZoneName = "find a pro:see local professionals";
    }
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: eventName,
        eventMsg: "n/a",
        eventName,
        eventStatus: "n/a",
        eventType: "navigation",
        internalLinkName: "".concat(label),
        internalLinkPosition,
        internalLinkType,
        internalLinkURL: "".concat(window.location.origin).concat(window.location.pathname),
        internalLinkZoneName
    };
    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .pushAnalyticsObjToDataLayer */ .zYT)(eventInfo);
};
const locationMessageNavigationAnalytics = (param)=>{
    let { link ="" , label ="" , zone =""  } = param;
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(pageType, ":").concat(zone, ":").concat(label),
        eventMsg: "n/a",
        eventName: "".concat(pageType, ":").concat(zone, ":").concat(label),
        eventStatus: "n/a",
        eventType: "navigation",
        internalLinkName: label,
        internalLinkPosition: pageType,
        internalLinkType: "".concat(pageType, ":navigation"),
        internalLinkURL: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .getAnalyticsUrl */ .Uho)(link),
        internalLinkZoneName: "".concat(pageType, ":").concat(zone)
    };
    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .pushAnalyticsObjToDataLayer */ .zYT)(eventInfo);
};
const pushAnalyticsToDataLayer = function() {
    let eventInfo = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const page = window.pageObj || {};
    const event = "cmp:click";
    window.adobeDataLayer.push({
        event,
        eventInfo,
        page
    });
};


/***/ }),

/***/ 2182:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ getFindAStoresResult; },
/* harmony export */   "T": function() { return /* binding */ getAutoSuggestionsInputBased; }
/* harmony export */ });
/* harmony import */ var _constants_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73350);

const getFindAStoresResult = function() {
    let url = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", address = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", brand = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", disMiles = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 100, maxStorePerPage = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 10, locationType = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : "", page = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : 1, sku = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : "";
    const params = {
        address,
        brand: brand.toLowerCase(),
        disMiles,
        maxItemPerPage: maxStorePerPage,
        locationType: locationType.toLowerCase(),
        page
    };
    if (sku) params["sku"] = sku;
    return _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.get */ .TH.get(url, {
        params
    });
};
const getAutoSuggestionsInputBased = function() {
    let url = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", brand = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", input = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
    return _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.get */ .TH.get(url, {
        params: {
            $format: "json",
            brand: brand.toLowerCase(),
            $select: "Locality",
            $filter: "StartsWith(Locality,'".concat(input, "') eq true")
        }
    });
};


/***/ }),

/***/ 90062:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Pj": function() { return /* binding */ headerFindStoreUseLocationAnalytics; },
/* harmony export */   "Zj": function() { return /* binding */ headerViewAllStoreAnalytics; },
/* harmony export */   "cY": function() { return /* binding */ addFindStoreAnalytics; }
/* harmony export */ });
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55760);

const addFindStoreAnalytics = (zipCodeValue, zipCodeError)=>{
    const { show , message  } = zipCodeError;
    const eventMsg = show ? message === null || message === void 0 ? void 0 : message.toLowerCase() : "n/a";
    const eventStatus = show ? "failure" : "success";
    const eventInfo = {
        eventAction: "find a store:utility nav:submit",
        eventName: "find a store:utility nav:submit",
        eventType: "navigation",
        eventMsg,
        eventStatus,
        internalLinkName: "submit",
        internalLinkPosition: "find a store",
        internalLinkType: "find a store:".concat(zipCodeValue !== null && zipCodeValue !== void 0 ? zipCodeValue : ""),
        internalLinkZoneName: "find a store:utility nav",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    window.adobeDataLayer.push({
        event: "cmp:click",
        eventInfo,
        page
    });
};
const headerFindStoreUseLocationAnalytics = (param)=>{
    let { errorMessage ="" , staticTexts ={} , eventStatus =""  } = param;
    const eventMsg = errorMessage ? (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .sanitizeTextForAnalytics */ .T68)(errorMessage ? errorMessage : staticTexts.locationErrormessage) : "n/a";
    const eventInfo = {
        eventAction: "find a store:utility nav:use my location",
        eventName: "find a store:utility nav:use my location",
        eventType: "navigation",
        eventMsg,
        eventStatus,
        internalLinkName: "use my location",
        internalLinkPosition: "global header:find a store",
        internalLinkType: "global header:navigation",
        internalLinkZoneName: "global header",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .pushAnalyticsObjToDataLayer */ .zYT)(eventInfo);
};
const headerViewAllStoreAnalytics = (browseAllStoreUrl)=>{
    const eventInfo = {
        eventAction: "find a store:utility nav:view all stores",
        eventName: "find a store:utility nav:view all stores",
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "view all stores",
        internalLinkPosition: "global header:find a store",
        internalLinkType: "find a store:navigation",
        internalLinkZoneName: "find a store:utility nav",
        internalLinkURL: "".concat(window.location.origin).concat(browseAllStoreUrl),
        clickInternalLinks: "true"
    };
    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .pushAnalyticsObjToDataLayer */ .zYT)(eventInfo);
};



/***/ }),

/***/ 26977:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ getTranslations; }
/* harmony export */ });
const getTranslations = (t)=>{
    return {
        useLocation: t("kf.findStoreUtilNav.label.useLocation"),
        viewAllStore: t("kf.findStoreUtilNav.label.viewAllStore"),
        submit: t("kf.global.label.submit"),
        findStore: t("kf.findStoreUtilNav.label.findStore"),
        closestStore: t("kf.findStoreUtilNav.label.closestStore"),
        kohlerText: t("kf.findStoreUtilNav.label.kohler"),
        signStore: t("kf.findStoreUtilNav.label.signStore"),
        NotYourStore: t("kf.findStoreUtilNav.label.NotYourStore"),
        viewStoreDetail: t("kf.findStoreUtilNav.label.viewStoreDetail"),
        storeDetail: t("kf.findStoreUtilNav.label.storeDetail"),
        setAsMyStore: t("kf.findStoreUtilNav.label.setAsMystore"),
        myStore: t("kf.findStoreUtilNav.label.myStore"),
        myStoreText: t("kf.findStoreUtilNav.label.myStoreText"),
        locationDescription: t("kf.findStoreUtilNav.label.locationDescription"),
        zipCodeContent: t("kf.findStoreUtilNav.label.zipCodeContent"),
        closeAlt: t("kf.findStoreUtilNav.label.closeAlt"),
        menu: t("kf.findStoreUtilNav.label.menu"),
        leftArrow: t("kf.findStoreUtilNav.label.leftArrow"),
        enterZipCode: t("kf.findStoreUtilNav.label.enterZipCode"),
        zipcode: t("kf.findStoreUtilNav.zipcode"),
        validZipcode: t("kf.findStoreUtilNav.validZipcode"),
        MessageZipcode: t("kf.findStoreUtilNav.MessageZipcode"),
        infoModalTitle: t("kf.findStoreUtilNav.messageTitleZipcode"),
        zipcodeEmptyError: t("kf.findStoreUtilNav.zipcodeEmptyError"),
        continue: t("kf.checkout.label.continue"),
        ariaLabel: {
            enterZipCode: t("kf.findStoreUtilNav.aria.label.enterZipCode"),
            submit: t("kf.findStoreUtilNav.aria.label.submit")
        },
        enterCityStateZip: t("kf.findStoreUtilNav.label.countryPlaceholder")
    };
};


/***/ }),

/***/ 17169:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73935);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9473);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41609);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _i18n_usePdpi18n__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(58886);
/* harmony import */ var _components_core_Modal_Modal__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(78145);
/* harmony import */ var _components_Shared_ProductSocialShare_v1_ProductSocialShare__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(13678);
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(19514);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(55760);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(20558);
/* harmony import */ var _store_features_genericSlice__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(88751);













const PartsViewer = (param)=>{
    let { page ="" , i18n ={} , productId ="" , partId ="" , analyticsCustomData =null , onClose , showModal =false  } = param;
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useDispatch */ .I0)();
    const iframeRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
    const [svgViewerPath, setSvgViewerPath] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [currencySign, setCurrencySign] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [general, setGeneral] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const [plpServletPath, setPlpServletPath] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const [salesChannelConfig, setSalesChannelConfig] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({});
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        (0,_constants_config__WEBPACK_IMPORTED_MODULE_9__/* .getConfig */ .i)().then(async (config)=>{
            var ref;
            const svgViewerPath = await (0,_utils_helper__WEBPACK_IMPORTED_MODULE_10__/* .getShortenedUrl */ .Ppy)(lodash_get__WEBPACK_IMPORTED_MODULE_4___default()(config, "general.svgViewerPath", ""));
            var ref1;
            setSalesChannelConfig((ref1 = config === null || config === void 0 ? void 0 : (ref = config.salesChannelConfig) === null || ref === void 0 ? void 0 : ref.map) !== null && ref1 !== void 0 ? ref1 : {});
            const currencySign = lodash_get__WEBPACK_IMPORTED_MODULE_4___default()(config, "internationalization.currencySign", "");
            setCurrencySign(currencySign);
            setSvgViewerPath(svgViewerPath);
            setGeneral(config.general);
            setPlpServletPath(config.plpServletPath);
        });
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (showModal) {
            (0,_utils_helper__WEBPACK_IMPORTED_MODULE_10__/* .preventBodyScroll */ .MVu)(true);
        }
    }, [
        showModal
    ]);
    const persona = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_10__/* .getUserPersona */ .shu)();
    const [showShare, setShowShare] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const getPDPUrlForViewer = (category, slug)=>{
        const pdpdUrl = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_10__/* .getPDPUrlWithConfig */ .Upy)(category, slug, plpServletPath, general);
        return pdpdUrl;
    };
    const addToCartTrigger = async (data)=>{
        const actions = [];
        data.forEach((product)=>{
            var ref;
            const fields = {
                salesChannel: (ref = salesChannelConfig[product === null || product === void 0 ? void 0 : product.brand]) !== null && ref !== void 0 ? ref : "KOUS"
            };
            actions.push({
                action: product.isBundle ? "addbundle" : "addLineItem",
                sku: product.sku,
                quantity: product.quantity,
                custom: {
                    type: {
                        key: "lineItemShipping"
                    },
                    fields: fields
                }
            });
        });
        const reqData = {};
        reqData["actions"] = actions;
        const cartObj = dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_12__/* .searchPlp */ .tK)(reqData)).unwrap().then((res)=>{
            const respVal = {};
            respVal.status = 200;
            return respVal;
        }).catch((err)=>{
            const respVal = {};
            respVal.status = 500;
            return respVal;
        }) || {};
        return cartObj;
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (currencySign !== "" && persona && plpServletPath && !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_5___default()(general)) {
            var ref;
            window.partViewer = {
                atc: addToCartTrigger,
                getPDPUrl: getPDPUrlForViewer,
                persona,
                currencySign,
                setShowShare
            };
            (ref = iframeRef.current) === null || ref === void 0 ? void 0 : ref.focus();
            return ()=>(0,_utils_helper__WEBPACK_IMPORTED_MODULE_10__/* .preventBodyScroll */ .MVu)(false);
        }
    }, [
        currencySign,
        persona,
        general
    ]);
    const filename = (0,_utils__WEBPACK_IMPORTED_MODULE_11__/* .getExtention */ .fN)(partId) ? partId : partId + ".svg";
    const closeModal = ()=>{
        (0,_utils_helper__WEBPACK_IMPORTED_MODULE_10__/* .preventBodyScroll */ .MVu)(false);
        onClose();
    };
    const getPartDiagramCloseEventInfo = JSON.stringify({
        eventAction: page + ":modal:interactive parts diagram:close",
        eventName: page + ":modal:interactive parts diagram:close",
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "close",
        internalLinkPosition: page,
        internalLinkType: page + ":close",
        internalLinkZoneName: page + ":modal:interactive parts diagram",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    });
    const i18nTexts = (0,_i18n_usePdpi18n__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, {}, "");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_core_Modal_Modal__WEBPACK_IMPORTED_MODULE_7__["default"], {
        showModal: showModal,
        onModalClose: closeModal,
        closeButtonAnalytics: getPartDiagramCloseEventInfo,
        analyticsCustomData: analyticsCustomData || null,
        className: "part-diagram-custom",
        modalTitle: i18nTexts === null || i18nTexts === void 0 ? void 0 : i18nTexts.serviceParts,
        children: [
            svgViewerPath && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("iframe", {
                id: "svg-viewer-iframe",
                ref: iframeRef,
                allowFullScreen: true,
                scrolling: "auto",
                src: "".concat(svgViewerPath, "?productId=").concat(productId, "&filename=").concat(filename, "&diagram=0&origin=").concat(window.location.href)
            }),
            showShare && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PartSocialShare, {
                showShare: showShare,
                setShowShare: setShowShare,
                iframeId: "svg-viewer-iframe",
                i18n: i18n,
                iframeRef: iframeRef.current
            })
        ]
    });
};
const PartSocialShare = (param)=>{
    let { showShare , setShowShare , iframeId , i18n , iframeRef  } = param;
    return /*#__PURE__*/ react_dom__WEBPACK_IMPORTED_MODULE_2__.createPortal(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Shared_ProductSocialShare_v1_ProductSocialShare__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        showModal: showShare,
        id: "social-share-iframe",
        onClose: ()=>setShowShare(false),
        iframeId: iframeId,
        iframeRef: iframeRef,
        disableInstagram: true,
        mailSubject: i18n.mailSubject,
        mailBody: i18n.mailBody
    }), iframeRef.contentDocument.getElementById("social-share-gbh"));
};
/* harmony default export */ __webpack_exports__["Z"] = (PartsViewer);


/***/ }),

/***/ 83227:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ v2_PartsViewer; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/canUseDOM.js
/* harmony default export */ var canUseDOM = (!!(typeof window !== 'undefined' && window.document && window.document.createElement));
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/addEventListener.js
/* eslint-disable no-return-assign */

var optionsSupported = false;
var onceSupported = false;

try {
  var options = {
    get passive() {
      return optionsSupported = true;
    },

    get once() {
      // eslint-disable-next-line no-multi-assign
      return onceSupported = optionsSupported = true;
    }

  };

  if (canUseDOM) {
    window.addEventListener('test', options, options);
    window.removeEventListener('test', options, true);
  }
} catch (e) {
  /* */
}

/**
 * An `addEventListener` ponyfill, supports the `once` option
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */
function addEventListener(node, eventName, handler, options) {
  if (options && typeof options !== 'boolean' && !onceSupported) {
    var once = options.once,
        capture = options.capture;
    var wrappedHandler = handler;

    if (!onceSupported && once) {
      wrappedHandler = handler.__once || function onceHandler(event) {
        this.removeEventListener(eventName, onceHandler, capture);
        handler.call(this, event);
      };

      handler.__once = wrappedHandler;
    }

    node.addEventListener(eventName, wrappedHandler, optionsSupported ? options : capture);
  }

  node.addEventListener(eventName, handler, options);
}

/* harmony default export */ var esm_addEventListener = (addEventListener);
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/ownerDocument.js
/**
 * Returns the owner document of a given element.
 * 
 * @param node the element
 */
function ownerDocument(node) {
  return node && node.ownerDocument || document;
}
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/removeEventListener.js
/**
 * A `removeEventListener` ponyfill
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */
function removeEventListener(node, eventName, handler, options) {
  var capture = options && typeof options !== 'boolean' ? options.capture : options;
  node.removeEventListener(eventName, handler, capture);

  if (handler.__once) {
    node.removeEventListener(eventName, handler.__once, capture);
  }
}

/* harmony default export */ var esm_removeEventListener = (removeEventListener);
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/scrollbarSize.js

var size;
function scrollbarSize(recalc) {
  if (!size && size !== 0 || recalc) {
    if (canUseDOM) {
      var scrollDiv = document.createElement('div');
      scrollDiv.style.position = 'absolute';
      scrollDiv.style.top = '-9999px';
      scrollDiv.style.width = '50px';
      scrollDiv.style.height = '50px';
      scrollDiv.style.overflow = 'scroll';
      document.body.appendChild(scrollDiv);
      size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
      document.body.removeChild(scrollDiv);
    }
  }

  return size;
}
;// CONCATENATED MODULE: ./node_modules/@restart/hooks/esm/useCallbackRef.js


/**
 * A convenience hook around `useState` designed to be paired with
 * the component [callback ref](https://reactjs.org/docs/refs-and-the-dom.html#callback-refs) api.
 * Callback refs are useful over `useRef()` when you need to respond to the ref being set
 * instead of lazily accessing it in an effect.
 *
 * ```ts
 * const [element, attachRef] = useCallbackRef<HTMLDivElement>()
 *
 * useEffect(() => {
 *   if (!element) return
 *
 *   const calendar = new FullCalendar.Calendar(element)
 *
 *   return () => {
 *     calendar.destroy()
 *   }
 * }, [element])
 *
 * return <div ref={attachRef} />
 * ```
 *
 * @category refs
 */
function useCallbackRef() {
  return (0,react.useState)(null);
}
;// CONCATENATED MODULE: ./node_modules/@restart/hooks/esm/useCommittedRef.js


/**
 * Creates a `Ref` whose value is updated in an effect, ensuring the most recent
 * value is the one rendered with. Generally only required for Concurrent mode usage
 * where previous work in `render()` may be discarded before being used.
 *
 * This is safe to access in an event handler.
 *
 * @param value The `Ref` value
 */
function useCommittedRef_useCommittedRef(value) {
  const ref = (0,react.useRef)(value);
  (0,react.useEffect)(() => {
    ref.current = value;
  }, [value]);
  return ref;
}
/* harmony default export */ var esm_useCommittedRef = (useCommittedRef_useCommittedRef);
;// CONCATENATED MODULE: ./node_modules/@restart/hooks/esm/useEventCallback.js


function useEventCallback_useEventCallback(fn) {
  const ref = esm_useCommittedRef(fn);
  return (0,react.useCallback)(function (...args) {
    return ref.current && ref.current(...args);
  }, [ref]);
}
;// CONCATENATED MODULE: ./node_modules/@restart/hooks/esm/useMergedRefs.js

const toFnRef = ref => !ref || typeof ref === 'function' ? ref : value => {
  ref.current = value;
};
function mergeRefs(refA, refB) {
  const a = toFnRef(refA);
  const b = toFnRef(refB);
  return value => {
    if (a) a(value);
    if (b) b(value);
  };
}

/**
 * Create and returns a single callback ref composed from two other Refs.
 *
 * ```tsx
 * const Button = React.forwardRef((props, ref) => {
 *   const [element, attachRef] = useCallbackRef<HTMLButtonElement>();
 *   const mergedRef = useMergedRefs(ref, attachRef);
 *
 *   return <button ref={mergedRef} {...props}/>
 * })
 * ```
 *
 * @param refA A Callback or mutable Ref
 * @param refB A Callback or mutable Ref
 * @category refs
 */
function useMergedRefs(refA, refB) {
  return (0,react.useMemo)(() => mergeRefs(refA, refB), [refA, refB]);
}
/* harmony default export */ var esm_useMergedRefs = (useMergedRefs);
;// CONCATENATED MODULE: ./node_modules/@restart/hooks/esm/useUpdatedRef.js


/**
 * Returns a ref that is immediately updated with the new value
 *
 * @param value The Ref value
 * @category refs
 */
function useUpdatedRef(value) {
  const valueRef = (0,react.useRef)(value);
  valueRef.current = value;
  return valueRef;
}
;// CONCATENATED MODULE: ./node_modules/@restart/hooks/esm/useWillUnmount.js



/**
 * Attach a callback that fires when a component unmounts
 *
 * @param fn Handler to run when the component unmounts
 * @category effects
 */
function useWillUnmount(fn) {
  const onUnmount = useUpdatedRef(fn);
  (0,react.useEffect)(() => () => onUnmount.current(), []);
}
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/ownerWindow.js

/**
 * Returns the owner window of a given element.
 * 
 * @param node the element
 */

function ownerWindow(node) {
  var doc = ownerDocument(node);
  return doc && doc.defaultView || window;
}
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/getComputedStyle.js

/**
 * Returns one or all computed style properties of an element.
 * 
 * @param node the element
 * @param psuedoElement the style property
 */

function getComputedStyle(node, psuedoElement) {
  return ownerWindow(node).getComputedStyle(node, psuedoElement);
}
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/hyphenate.js
var rUpper = /([A-Z])/g;
function hyphenate(string) {
  return string.replace(rUpper, '-$1').toLowerCase();
}
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/hyphenateStyle.js
/**
 * Copyright 2013-2014, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
 */

var msPattern = /^ms-/;
function hyphenateStyleName(string) {
  return hyphenate(string).replace(msPattern, '-ms-');
}
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/isTransform.js
var supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;
function isTransform(value) {
  return !!(value && supportedTransforms.test(value));
}
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/css.js




function style(node, property) {
  var css = '';
  var transforms = '';

  if (typeof property === 'string') {
    return node.style.getPropertyValue(hyphenateStyleName(property)) || getComputedStyle(node).getPropertyValue(hyphenateStyleName(property));
  }

  Object.keys(property).forEach(function (key) {
    var value = property[key];

    if (!value && value !== 0) {
      node.style.removeProperty(hyphenateStyleName(key));
    } else if (isTransform(key)) {
      transforms += key + "(" + value + ") ";
    } else {
      css += hyphenateStyleName(key) + ": " + value + ";";
    }
  });

  if (transforms) {
    css += "transform: " + transforms + ";";
  }

  node.style.cssText += ";" + css;
}

/* harmony default export */ var css = (style);
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/listen.js



function listen(node, eventName, handler, options) {
  esm_addEventListener(node, eventName, handler, options);
  return function () {
    esm_removeEventListener(node, eventName, handler, options);
  };
}

/* harmony default export */ var esm_listen = (listen);
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/triggerEvent.js
/**
 * Triggers an event on a given element.
 * 
 * @param node the element
 * @param eventName the event name to trigger
 * @param bubbles whether the event should bubble up
 * @param cancelable whether the event should be cancelable
 */
function triggerEvent(node, eventName, bubbles, cancelable) {
  if (bubbles === void 0) {
    bubbles = false;
  }

  if (cancelable === void 0) {
    cancelable = true;
  }

  if (node) {
    var event = document.createEvent('HTMLEvents');
    event.initEvent(eventName, bubbles, cancelable);
    node.dispatchEvent(event);
  }
}
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/transitionEnd.js




function parseDuration(node) {
  var str = css(node, 'transitionDuration') || '';
  var mult = str.indexOf('ms') === -1 ? 1000 : 1;
  return parseFloat(str) * mult;
}

function emulateTransitionEnd(element, duration, padding) {
  if (padding === void 0) {
    padding = 5;
  }

  var called = false;
  var handle = setTimeout(function () {
    if (!called) triggerEvent(element, 'transitionend', true);
  }, duration + padding);
  var remove = esm_listen(element, 'transitionend', function () {
    called = true;
  }, {
    once: true
  });
  return function () {
    clearTimeout(handle);
    remove();
  };
}

function transitionEnd(element, handler, duration, padding) {
  if (duration == null) duration = parseDuration(element) || 0;
  var removeEmulate = emulateTransitionEnd(element, duration, padding);
  var remove = esm_listen(element, 'transitionend', handler);
  return function () {
    removeEmulate();
    remove();
  };
}
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/activeElement.js

/**
 * Returns the actively focused element safely.
 *
 * @param doc the document to check
 */

function activeElement(doc) {
  if (doc === void 0) {
    doc = ownerDocument();
  }

  // Support: IE 9 only
  // IE9 throws an "Unspecified error" accessing document.activeElement from an <iframe>
  try {
    var active = doc.activeElement; // IE11 returns a seemingly empty object in some cases when accessing
    // document.activeElement from an <iframe>

    if (!active || !active.nodeName) return null;
    return active;
  } catch (e) {
    /* ie throws if no active element */
    return doc.body;
  }
}
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/contains.js
/* eslint-disable no-bitwise, no-cond-assign */

/**
 * Checks if an element contains another given element.
 * 
 * @param context the context element
 * @param node the element to check
 */
function contains(context, node) {
  // HTML DOM and SVG DOM may have different support levels,
  // so we need to check on context instead of a document root element.
  if (context.contains) return context.contains(node);
  if (context.compareDocumentPosition) return context === node || !!(context.compareDocumentPosition(node) & 16);
}
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
;// CONCATENATED MODULE: ./node_modules/@restart/ui/node_modules/@restart/hooks/esm/useMounted.js


/**
 * Track whether a component is current mounted. Generally less preferable than
 * properlly canceling effects so they don't run after a component is unmounted,
 * but helpful in cases where that isn't feasible, such as a `Promise` resolution.
 *
 * @returns a function that returns the current isMounted state of the component
 *
 * ```ts
 * const [data, setData] = useState(null)
 * const isMounted = useMounted()
 *
 * useEffect(() => {
 *   fetchdata().then((newData) => {
 *      if (isMounted()) {
 *        setData(newData);
 *      }
 *   })
 * })
 * ```
 */
function useMounted() {
  const mounted = (0,react.useRef)(true);
  const isMounted = (0,react.useRef)(() => mounted.current);
  (0,react.useEffect)(() => {
    mounted.current = true;
    return () => {
      mounted.current = false;
    };
  }, []);
  return isMounted.current;
}
;// CONCATENATED MODULE: ./node_modules/@restart/ui/node_modules/@restart/hooks/esm/useUpdatedRef.js


/**
 * Returns a ref that is immediately updated with the new value
 *
 * @param value The Ref value
 * @category refs
 */
function useUpdatedRef_useUpdatedRef(value) {
  const valueRef = (0,react.useRef)(value);
  valueRef.current = value;
  return valueRef;
}
;// CONCATENATED MODULE: ./node_modules/@restart/ui/node_modules/@restart/hooks/esm/useWillUnmount.js



/**
 * Attach a callback that fires when a component unmounts
 *
 * @param fn Handler to run when the component unmounts
 * @deprecated Use `useMounted` and normal effects, this is not StrictMode safe
 * @category effects
 */
function useWillUnmount_useWillUnmount(fn) {
  const onUnmount = useUpdatedRef_useUpdatedRef(fn);
  (0,react.useEffect)(() => () => onUnmount.current(), []);
}
;// CONCATENATED MODULE: ./node_modules/@restart/ui/node_modules/@restart/hooks/esm/usePrevious.js


/**
 * Store the last of some value. Tracked via a `Ref` only updating it
 * after the component renders.
 *
 * Helpful if you need to compare a prop value to it's previous value during render.
 *
 * ```ts
 * function Component(props) {
 *   const lastProps = usePrevious(props)
 *
 *   if (lastProps.foo !== props.foo)
 *     resetValueFromProps(props.foo)
 * }
 * ```
 *
 * @param value the value to track
 */
function usePrevious(value) {
  const ref = (0,react.useRef)(null);
  (0,react.useEffect)(() => {
    ref.current = value;
  });
  return ref.current;
}
;// CONCATENATED MODULE: ./node_modules/@restart/ui/node_modules/@restart/hooks/esm/useCommittedRef.js


/**
 * Creates a `Ref` whose value is updated in an effect, ensuring the most recent
 * value is the one rendered with. Generally only required for Concurrent mode usage
 * where previous work in `render()` may be discarded before being used.
 *
 * This is safe to access in an event handler.
 *
 * @param value The `Ref` value
 */
function esm_useCommittedRef_useCommittedRef(value) {
  const ref = (0,react.useRef)(value);
  (0,react.useEffect)(() => {
    ref.current = value;
  }, [value]);
  return ref;
}
/* harmony default export */ var hooks_esm_useCommittedRef = (esm_useCommittedRef_useCommittedRef);
;// CONCATENATED MODULE: ./node_modules/@restart/ui/node_modules/@restart/hooks/esm/useEventCallback.js


function esm_useEventCallback_useEventCallback(fn) {
  const ref = hooks_esm_useCommittedRef(fn);
  return (0,react.useCallback)(function (...args) {
    return ref.current && ref.current(...args);
  }, [ref]);
}
;// CONCATENATED MODULE: ./node_modules/@restart/ui/esm/DataKey.js
const ATTRIBUTE_PREFIX = `data-rr-ui-`;
const PROPERTY_PREFIX = `rrUi`;
function dataAttr(property) {
  return `${ATTRIBUTE_PREFIX}${property}`;
}
function dataProp(property) {
  return `${PROPERTY_PREFIX}${property}`;
}
;// CONCATENATED MODULE: ./node_modules/@restart/ui/esm/getScrollbarWidth.js
/**
 * Get the width of the vertical window scrollbar if it's visible
 */
function getBodyScrollbarWidth(ownerDocument = document) {
  const window = ownerDocument.defaultView;
  return Math.abs(window.innerWidth - ownerDocument.documentElement.clientWidth);
}
;// CONCATENATED MODULE: ./node_modules/@restart/ui/esm/ModalManager.js



const OPEN_DATA_ATTRIBUTE = dataAttr('modal-open');

/**
 * Manages a stack of Modals as well as ensuring
 * body scrolling is is disabled and padding accounted for
 */
class ModalManager {
  constructor({
    ownerDocument,
    handleContainerOverflow = true,
    isRTL = false
  } = {}) {
    this.handleContainerOverflow = handleContainerOverflow;
    this.isRTL = isRTL;
    this.modals = [];
    this.ownerDocument = ownerDocument;
  }
  getScrollbarWidth() {
    return getBodyScrollbarWidth(this.ownerDocument);
  }
  getElement() {
    return (this.ownerDocument || document).body;
  }
  setModalAttributes(_modal) {
    // For overriding
  }
  removeModalAttributes(_modal) {
    // For overriding
  }
  setContainerStyle(containerState) {
    const style = {
      overflow: 'hidden'
    };

    // we are only interested in the actual `style` here
    // because we will override it
    const paddingProp = this.isRTL ? 'paddingLeft' : 'paddingRight';
    const container = this.getElement();
    containerState.style = {
      overflow: container.style.overflow,
      [paddingProp]: container.style[paddingProp]
    };
    if (containerState.scrollBarWidth) {
      // use computed style, here to get the real padding
      // to add our scrollbar width
      style[paddingProp] = `${parseInt(css(container, paddingProp) || '0', 10) + containerState.scrollBarWidth}px`;
    }
    container.setAttribute(OPEN_DATA_ATTRIBUTE, '');
    css(container, style);
  }
  reset() {
    [...this.modals].forEach(m => this.remove(m));
  }
  removeContainerStyle(containerState) {
    const container = this.getElement();
    container.removeAttribute(OPEN_DATA_ATTRIBUTE);
    Object.assign(container.style, containerState.style);
  }
  add(modal) {
    let modalIdx = this.modals.indexOf(modal);
    if (modalIdx !== -1) {
      return modalIdx;
    }
    modalIdx = this.modals.length;
    this.modals.push(modal);
    this.setModalAttributes(modal);
    if (modalIdx !== 0) {
      return modalIdx;
    }
    this.state = {
      scrollBarWidth: this.getScrollbarWidth(),
      style: {}
    };
    if (this.handleContainerOverflow) {
      this.setContainerStyle(this.state);
    }
    return modalIdx;
  }
  remove(modal) {
    const modalIdx = this.modals.indexOf(modal);
    if (modalIdx === -1) {
      return;
    }
    this.modals.splice(modalIdx, 1);

    // if that was the last modal in a container,
    // clean up the container
    if (!this.modals.length && this.handleContainerOverflow) {
      this.removeContainerStyle(this.state);
    }
    this.removeModalAttributes(modal);
  }
  isTopModal(modal) {
    return !!this.modals.length && this.modals[this.modals.length - 1] === modal;
  }
}
/* harmony default export */ var esm_ModalManager = (ModalManager);
;// CONCATENATED MODULE: ./node_modules/@restart/ui/esm/useWindow.js


const Context = /*#__PURE__*/(0,react.createContext)(canUseDOM ? window : undefined);
const WindowProvider = Context.Provider;

/**
 * The document "window" placed in React context. Helpful for determining
 * SSR context, or when rendering into an iframe.
 *
 * @returns the current window
 */
function useWindow() {
  return (0,react.useContext)(Context);
}
;// CONCATENATED MODULE: ./node_modules/@restart/ui/esm/useWaitForDOMRef.js




const resolveContainerRef = (ref, document) => {
  if (!canUseDOM) return null;
  if (ref == null) return (document || ownerDocument()).body;
  if (typeof ref === 'function') ref = ref();
  if (ref && 'current' in ref) ref = ref.current;
  if (ref && ('nodeType' in ref || ref.getBoundingClientRect)) return ref;
  return null;
};
function useWaitForDOMRef(ref, onResolved) {
  const window = useWindow();
  const [resolvedRef, setRef] = (0,react.useState)(() => resolveContainerRef(ref, window == null ? void 0 : window.document));
  if (!resolvedRef) {
    const earlyRef = resolveContainerRef(ref);
    if (earlyRef) setRef(earlyRef);
  }
  (0,react.useEffect)(() => {
    if (onResolved && resolvedRef) {
      onResolved(resolvedRef);
    }
  }, [onResolved, resolvedRef]);
  (0,react.useEffect)(() => {
    const nextRef = resolveContainerRef(ref);
    if (nextRef !== resolvedRef) {
      setRef(nextRef);
    }
  }, [ref, resolvedRef]);
  return resolvedRef;
}
;// CONCATENATED MODULE: ./node_modules/@restart/ui/node_modules/@restart/hooks/esm/useMergedRefs.js

const useMergedRefs_toFnRef = ref => !ref || typeof ref === 'function' ? ref : value => {
  ref.current = value;
};
function useMergedRefs_mergeRefs(refA, refB) {
  const a = useMergedRefs_toFnRef(refA);
  const b = useMergedRefs_toFnRef(refB);
  return value => {
    if (a) a(value);
    if (b) b(value);
  };
}

/**
 * Create and returns a single callback ref composed from two other Refs.
 *
 * ```tsx
 * const Button = React.forwardRef((props, ref) => {
 *   const [element, attachRef] = useCallbackRef<HTMLButtonElement>();
 *   const mergedRef = useMergedRefs(ref, attachRef);
 *
 *   return <button ref={mergedRef} {...props}/>
 * })
 * ```
 *
 * @param refA A Callback or mutable Ref
 * @param refB A Callback or mutable Ref
 * @category refs
 */
function useMergedRefs_useMergedRefs(refA, refB) {
  return (0,react.useMemo)(() => useMergedRefs_mergeRefs(refA, refB), [refA, refB]);
}
/* harmony default export */ var hooks_esm_useMergedRefs = (useMergedRefs_useMergedRefs);
;// CONCATENATED MODULE: ./node_modules/@restart/ui/node_modules/@restart/hooks/esm/useIsomorphicEffect.js

const isReactNative = typeof __webpack_require__.g !== 'undefined' &&
// @ts-ignore
__webpack_require__.g.navigator &&
// @ts-ignore
__webpack_require__.g.navigator.product === 'ReactNative';
const isDOM = typeof document !== 'undefined';

/**
 * Is `useLayoutEffect` in a DOM or React Native environment, otherwise resolves to useEffect
 * Only useful to avoid the console warning.
 *
 * PREFER `useEffect` UNLESS YOU KNOW WHAT YOU ARE DOING.
 *
 * @category effects
 */
/* harmony default export */ var useIsomorphicEffect = (isDOM || isReactNative ? react.useLayoutEffect : react.useEffect);
;// CONCATENATED MODULE: ./node_modules/@restart/ui/esm/utils.js

function isEscKey(e) {
  return e.code === 'Escape' || e.keyCode === 27;
}
function getReactVersion() {
  const parts = react.version.split('.');
  return {
    major: +parts[0],
    minor: +parts[1],
    patch: +parts[2]
  };
}
function getChildRef(element) {
  if (!element || typeof element === 'function') {
    return null;
  }
  const {
    major
  } = getReactVersion();
  const childRef = major >= 19 ? element.props.ref : element.ref;
  return childRef;
}
;// CONCATENATED MODULE: ./node_modules/@restart/ui/esm/NoopTransition.js




function NoopTransition({
  children,
  in: inProp,
  onExited,
  mountOnEnter,
  unmountOnExit
}) {
  const ref = (0,react.useRef)(null);
  const hasEnteredRef = (0,react.useRef)(inProp);
  const handleExited = esm_useEventCallback_useEventCallback(onExited);
  (0,react.useEffect)(() => {
    if (inProp) hasEnteredRef.current = true;else {
      handleExited(ref.current);
    }
  }, [inProp, handleExited]);
  const combinedRef = hooks_esm_useMergedRefs(ref, getChildRef(children));
  const child = /*#__PURE__*/(0,react.cloneElement)(children, {
    ref: combinedRef
  });
  if (inProp) return child;
  if (unmountOnExit) {
    return null;
  }
  if (!hasEnteredRef.current && mountOnEnter) {
    return null;
  }
  return child;
}
/* harmony default export */ var esm_NoopTransition = (NoopTransition);
;// CONCATENATED MODULE: ./node_modules/@restart/ui/esm/useRTGTransitionProps.js
const _excluded = ["onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "addEndListener", "children"];
function useRTGTransitionProps_objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }



/**
 * Normalizes RTG transition callbacks with nodeRef to better support
 * strict mode.
 *
 * @param props Transition props.
 * @returns Normalized transition props.
 */
function useRTGTransitionProps(_ref) {
  let {
      onEnter,
      onEntering,
      onEntered,
      onExit,
      onExiting,
      onExited,
      addEndListener,
      children
    } = _ref,
    props = useRTGTransitionProps_objectWithoutPropertiesLoose(_ref, _excluded);
  const nodeRef = (0,react.useRef)(null);
  const mergedRef = hooks_esm_useMergedRefs(nodeRef, getChildRef(children));
  const normalize = callback => param => {
    if (callback && nodeRef.current) {
      callback(nodeRef.current, param);
    }
  };

  /* eslint-disable react-hooks/exhaustive-deps */
  const handleEnter = (0,react.useCallback)(normalize(onEnter), [onEnter]);
  const handleEntering = (0,react.useCallback)(normalize(onEntering), [onEntering]);
  const handleEntered = (0,react.useCallback)(normalize(onEntered), [onEntered]);
  const handleExit = (0,react.useCallback)(normalize(onExit), [onExit]);
  const handleExiting = (0,react.useCallback)(normalize(onExiting), [onExiting]);
  const handleExited = (0,react.useCallback)(normalize(onExited), [onExited]);
  const handleAddEndListener = (0,react.useCallback)(normalize(addEndListener), [addEndListener]);
  /* eslint-enable react-hooks/exhaustive-deps */

  return Object.assign({}, props, {
    nodeRef
  }, onEnter && {
    onEnter: handleEnter
  }, onEntering && {
    onEntering: handleEntering
  }, onEntered && {
    onEntered: handleEntered
  }, onExit && {
    onExit: handleExit
  }, onExiting && {
    onExiting: handleExiting
  }, onExited && {
    onExited: handleExited
  }, addEndListener && {
    addEndListener: handleAddEndListener
  }, {
    children: typeof children === 'function' ? (status, innerProps) =>
    // TODO: Types for RTG missing innerProps, so need to cast.
    children(status, Object.assign({}, innerProps, {
      ref: mergedRef
    })) : /*#__PURE__*/(0,react.cloneElement)(children, {
      ref: mergedRef
    })
  });
}
;// CONCATENATED MODULE: ./node_modules/@restart/ui/esm/RTGTransition.js
const RTGTransition_excluded = ["component"];
function RTGTransition_objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }



// Normalizes Transition callbacks when nodeRef is used.
const RTGTransition = /*#__PURE__*/react.forwardRef((_ref, ref) => {
  let {
      component: Component
    } = _ref,
    props = RTGTransition_objectWithoutPropertiesLoose(_ref, RTGTransition_excluded);
  const transitionProps = useRTGTransitionProps(props);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, Object.assign({
    ref: ref
  }, transitionProps));
});
/* harmony default export */ var esm_RTGTransition = (RTGTransition);
;// CONCATENATED MODULE: ./node_modules/@restart/ui/esm/ImperativeTransition.js








function useTransition({
  in: inProp,
  onTransition
}) {
  const ref = (0,react.useRef)(null);
  const isInitialRef = (0,react.useRef)(true);
  const handleTransition = esm_useEventCallback_useEventCallback(onTransition);
  useIsomorphicEffect(() => {
    if (!ref.current) {
      return undefined;
    }
    let stale = false;
    handleTransition({
      in: inProp,
      element: ref.current,
      initial: isInitialRef.current,
      isStale: () => stale
    });
    return () => {
      stale = true;
    };
  }, [inProp, handleTransition]);
  useIsomorphicEffect(() => {
    isInitialRef.current = false;
    // this is for strict mode
    return () => {
      isInitialRef.current = true;
    };
  }, []);
  return ref;
}
/**
 * Adapts an imperative transition function to a subset of the RTG `<Transition>` component API.
 *
 * ImperativeTransition does not support mounting options or `appear` at the moment, meaning
 * that it always acts like: `mountOnEnter={true} unmountOnExit={true} appear={true}`
 */
function ImperativeTransition({
  children,
  in: inProp,
  onExited,
  onEntered,
  transition
}) {
  const [exited, setExited] = (0,react.useState)(!inProp);

  // TODO: I think this needs to be in an effect
  if (inProp && exited) {
    setExited(false);
  }
  const ref = useTransition({
    in: !!inProp,
    onTransition: options => {
      const onFinish = () => {
        if (options.isStale()) return;
        if (options.in) {
          onEntered == null ? void 0 : onEntered(options.element, options.initial);
        } else {
          setExited(true);
          onExited == null ? void 0 : onExited(options.element);
        }
      };
      Promise.resolve(transition(options)).then(onFinish, error => {
        if (!options.in) setExited(true);
        throw error;
      });
    }
  });
  const combinedRef = hooks_esm_useMergedRefs(ref, getChildRef(children));
  return exited && !inProp ? null : /*#__PURE__*/(0,react.cloneElement)(children, {
    ref: combinedRef
  });
}
function renderTransition(component, runTransition, props) {
  if (component) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(esm_RTGTransition, Object.assign({}, props, {
      component: component
    }));
  }
  if (runTransition) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(ImperativeTransition, Object.assign({}, props, {
      transition: runTransition
    }));
  }
  return /*#__PURE__*/(0,jsx_runtime.jsx)(esm_NoopTransition, Object.assign({}, props));
}
;// CONCATENATED MODULE: ./node_modules/@restart/ui/esm/Modal.js
const Modal_excluded = ["show", "role", "className", "style", "children", "backdrop", "keyboard", "onBackdropClick", "onEscapeKeyDown", "transition", "runTransition", "backdropTransition", "runBackdropTransition", "autoFocus", "enforceFocus", "restoreFocus", "restoreFocusOptions", "renderDialog", "renderBackdrop", "manager", "container", "onShow", "onHide", "onExit", "onExited", "onExiting", "onEnter", "onEntering", "onEntered"];
function Modal_objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
/* eslint-disable @typescript-eslint/no-use-before-define, react/prop-types */


















let manager;

/*
  Modal props are split into a version with and without index signature so that you can fully use them in another projects
  This is due to Typescript not playing well with index signatures e.g. when using Omit
*/

function getManager(window) {
  if (!manager) manager = new esm_ModalManager({
    ownerDocument: window == null ? void 0 : window.document
  });
  return manager;
}
function useModalManager(provided) {
  const window = useWindow();
  const modalManager = provided || getManager(window);
  const modal = (0,react.useRef)({
    dialog: null,
    backdrop: null
  });
  return Object.assign(modal.current, {
    add: () => modalManager.add(modal.current),
    remove: () => modalManager.remove(modal.current),
    isTopModal: () => modalManager.isTopModal(modal.current),
    setDialogRef: (0,react.useCallback)(ref => {
      modal.current.dialog = ref;
    }, []),
    setBackdropRef: (0,react.useCallback)(ref => {
      modal.current.backdrop = ref;
    }, [])
  });
}
const Modal = /*#__PURE__*/(0,react.forwardRef)((_ref, ref) => {
  let {
      show = false,
      role = 'dialog',
      className,
      style,
      children,
      backdrop = true,
      keyboard = true,
      onBackdropClick,
      onEscapeKeyDown,
      transition,
      runTransition,
      backdropTransition,
      runBackdropTransition,
      autoFocus = true,
      enforceFocus = true,
      restoreFocus = true,
      restoreFocusOptions,
      renderDialog,
      renderBackdrop = props => /*#__PURE__*/(0,jsx_runtime.jsx)("div", Object.assign({}, props)),
      manager: providedManager,
      container: containerRef,
      onShow,
      onHide = () => {},
      onExit,
      onExited,
      onExiting,
      onEnter,
      onEntering,
      onEntered
    } = _ref,
    rest = Modal_objectWithoutPropertiesLoose(_ref, Modal_excluded);
  const ownerWindow = useWindow();
  const container = useWaitForDOMRef(containerRef);
  const modal = useModalManager(providedManager);
  const isMounted = useMounted();
  const prevShow = usePrevious(show);
  const [exited, setExited] = (0,react.useState)(!show);
  const lastFocusRef = (0,react.useRef)(null);
  (0,react.useImperativeHandle)(ref, () => modal, [modal]);
  if (canUseDOM && !prevShow && show) {
    lastFocusRef.current = activeElement(ownerWindow == null ? void 0 : ownerWindow.document);
  }

  // TODO: I think this needs to be in an effect
  if (show && exited) {
    setExited(false);
  }
  const handleShow = esm_useEventCallback_useEventCallback(() => {
    modal.add();
    removeKeydownListenerRef.current = esm_listen(document, 'keydown', handleDocumentKeyDown);
    removeFocusListenerRef.current = esm_listen(document, 'focus',
    // the timeout is necessary b/c this will run before the new modal is mounted
    // and so steals focus from it
    () => setTimeout(handleEnforceFocus), true);
    if (onShow) {
      onShow();
    }

    // autofocus after onShow to not trigger a focus event for previous
    // modals before this one is shown.
    if (autoFocus) {
      var _modal$dialog$ownerDo, _modal$dialog;
      const currentActiveElement = activeElement((_modal$dialog$ownerDo = (_modal$dialog = modal.dialog) == null ? void 0 : _modal$dialog.ownerDocument) != null ? _modal$dialog$ownerDo : ownerWindow == null ? void 0 : ownerWindow.document);
      if (modal.dialog && currentActiveElement && !contains(modal.dialog, currentActiveElement)) {
        lastFocusRef.current = currentActiveElement;
        modal.dialog.focus();
      }
    }
  });
  const handleHide = esm_useEventCallback_useEventCallback(() => {
    modal.remove();
    removeKeydownListenerRef.current == null ? void 0 : removeKeydownListenerRef.current();
    removeFocusListenerRef.current == null ? void 0 : removeFocusListenerRef.current();
    if (restoreFocus) {
      var _lastFocusRef$current;
      // Support: <=IE11 doesn't support `focus()` on svg elements (RB: #917)
      (_lastFocusRef$current = lastFocusRef.current) == null ? void 0 : _lastFocusRef$current.focus == null ? void 0 : _lastFocusRef$current.focus(restoreFocusOptions);
      lastFocusRef.current = null;
    }
  });

  // TODO: try and combine these effects: https://github.com/react-bootstrap/react-overlays/pull/794#discussion_r409954120

  // Show logic when:
  //  - show is `true` _and_ `container` has resolved
  (0,react.useEffect)(() => {
    if (!show || !container) return;
    handleShow();
  }, [show, container, /* should never change: */handleShow]);

  // Hide cleanup logic when:
  //  - `exited` switches to true
  //  - component unmounts;
  (0,react.useEffect)(() => {
    if (!exited) return;
    handleHide();
  }, [exited, handleHide]);
  useWillUnmount_useWillUnmount(() => {
    handleHide();
  });

  // --------------------------------

  const handleEnforceFocus = esm_useEventCallback_useEventCallback(() => {
    if (!enforceFocus || !isMounted() || !modal.isTopModal()) {
      return;
    }
    const currentActiveElement = activeElement(ownerWindow == null ? void 0 : ownerWindow.document);
    if (modal.dialog && currentActiveElement && !contains(modal.dialog, currentActiveElement)) {
      modal.dialog.focus();
    }
  });
  const handleBackdropClick = esm_useEventCallback_useEventCallback(e => {
    if (e.target !== e.currentTarget) {
      return;
    }
    onBackdropClick == null ? void 0 : onBackdropClick(e);
    if (backdrop === true) {
      onHide();
    }
  });
  const handleDocumentKeyDown = esm_useEventCallback_useEventCallback(e => {
    if (keyboard && isEscKey(e) && modal.isTopModal()) {
      onEscapeKeyDown == null ? void 0 : onEscapeKeyDown(e);
      if (!e.defaultPrevented) {
        onHide();
      }
    }
  });
  const removeFocusListenerRef = (0,react.useRef)();
  const removeKeydownListenerRef = (0,react.useRef)();
  const handleHidden = (...args) => {
    setExited(true);
    onExited == null ? void 0 : onExited(...args);
  };
  if (!container) {
    return null;
  }
  const dialogProps = Object.assign({
    role,
    ref: modal.setDialogRef,
    // apparently only works on the dialog role element
    'aria-modal': role === 'dialog' ? true : undefined
  }, rest, {
    style,
    className,
    tabIndex: -1
  });
  let dialog = renderDialog ? renderDialog(dialogProps) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", Object.assign({}, dialogProps, {
    children: /*#__PURE__*/react.cloneElement(children, {
      role: 'document'
    })
  }));
  dialog = renderTransition(transition, runTransition, {
    unmountOnExit: true,
    mountOnEnter: true,
    appear: true,
    in: !!show,
    onExit,
    onExiting,
    onExited: handleHidden,
    onEnter,
    onEntering,
    onEntered,
    children: dialog
  });
  let backdropElement = null;
  if (backdrop) {
    backdropElement = renderBackdrop({
      ref: modal.setBackdropRef,
      onClick: handleBackdropClick
    });
    backdropElement = renderTransition(backdropTransition, runBackdropTransition, {
      in: !!show,
      appear: true,
      mountOnEnter: true,
      unmountOnExit: true,
      children: backdropElement
    });
  }
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/react_dom.createPortal( /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [backdropElement, dialog]
    }), container)
  });
});
Modal.displayName = 'Modal';
/* harmony default export */ var esm_Modal = (Object.assign(Modal, {
  Manager: esm_ModalManager
}));
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/hasClass.js
/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */
function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);
  return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/addClass.js

/**
 * Adds a CSS class to a given element.
 * 
 * @param element the element
 * @param className the CSS class name
 */

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!hasClass(element, className)) if (typeof element.className === 'string') element.className = element.className + " " + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
}
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/querySelectorAll.js
var toArray = Function.prototype.bind.call(Function.prototype.call, [].slice);
/**
 * Runs `querySelectorAll` on a given element.
 * 
 * @param element the element
 * @param selector the selector
 */

function qsa(element, selector) {
  return toArray(element.querySelectorAll(selector));
}
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/removeClass.js
function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
/**
 * Removes a CSS class from a given element.
 * 
 * @param element the element
 * @param className the CSS class name
 */


function removeClass(element, className) {
  if (element.classList) {
    element.classList.remove(className);
  } else if (typeof element.className === 'string') {
    element.className = replaceClassName(element.className, className);
  } else {
    element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
  }
}
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/BootstrapModalManager.js





const Selector = {
  FIXED_CONTENT: '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top',
  STICKY_CONTENT: '.sticky-top',
  NAVBAR_TOGGLER: '.navbar-toggler'
};
class BootstrapModalManager extends esm_ModalManager {
  adjustAndStore(prop, element, adjust) {
    const actual = element.style[prop];
    // @ts-expect-error TODO: DOMStringMap and CSSStyleDeclaration aren't strictly compatible
    element.dataset[prop] = actual;
    css(element, {
      [prop]: `${parseFloat(css(element, prop)) + adjust}px`
    });
  }
  restore(prop, element) {
    const value = element.dataset[prop];
    if (value !== undefined) {
      delete element.dataset[prop];
      css(element, {
        [prop]: value
      });
    }
  }
  setContainerStyle(containerState) {
    super.setContainerStyle(containerState);
    const container = this.getElement();
    addClass(container, 'modal-open');
    if (!containerState.scrollBarWidth) return;
    const paddingProp = this.isRTL ? 'paddingLeft' : 'paddingRight';
    const marginProp = this.isRTL ? 'marginLeft' : 'marginRight';
    qsa(container, Selector.FIXED_CONTENT).forEach(el => this.adjustAndStore(paddingProp, el, containerState.scrollBarWidth));
    qsa(container, Selector.STICKY_CONTENT).forEach(el => this.adjustAndStore(marginProp, el, -containerState.scrollBarWidth));
    qsa(container, Selector.NAVBAR_TOGGLER).forEach(el => this.adjustAndStore(marginProp, el, containerState.scrollBarWidth));
  }
  removeContainerStyle(containerState) {
    super.removeContainerStyle(containerState);
    const container = this.getElement();
    removeClass(container, 'modal-open');
    const paddingProp = this.isRTL ? 'paddingLeft' : 'paddingRight';
    const marginProp = this.isRTL ? 'marginLeft' : 'marginRight';
    qsa(container, Selector.FIXED_CONTENT).forEach(el => this.restore(paddingProp, el));
    qsa(container, Selector.STICKY_CONTENT).forEach(el => this.restore(marginProp, el));
    qsa(container, Selector.NAVBAR_TOGGLER).forEach(el => this.restore(marginProp, el));
  }
}
let sharedManager;
function getSharedManager(options) {
  if (!sharedManager) sharedManager = new BootstrapModalManager(options);
  return sharedManager;
}
/* harmony default export */ var esm_BootstrapModalManager = ((/* unused pure expression or super */ null && (BootstrapModalManager)));
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
var setPrototypeOf = __webpack_require__(89611);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/inheritsLoose.js

function inheritsLoose_inheritsLoose(t, o) {
  t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0,setPrototypeOf/* default */.Z)(t, o);
}

;// CONCATENATED MODULE: ./node_modules/react-transition-group/esm/config.js
/* harmony default export */ var config = ({
  disabled: false
});
;// CONCATENATED MODULE: ./node_modules/react-transition-group/esm/TransitionGroupContext.js

/* harmony default export */ var TransitionGroupContext = (react.createContext(null));
;// CONCATENATED MODULE: ./node_modules/react-transition-group/esm/utils/reflow.js
var forceReflow = function forceReflow(node) {
  return node.scrollTop;
};
;// CONCATENATED MODULE: ./node_modules/react-transition-group/esm/Transition.js









var UNMOUNTED = 'unmounted';
var EXITED = 'exited';
var ENTERING = 'entering';
var ENTERED = 'entered';
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

var Transition = /*#__PURE__*/function (_React$Component) {
  inheritsLoose_inheritsLoose(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  } // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }
  ;

  var _proto = Transition.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      if (nextStatus === ENTERING) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var node = this.props.nodeRef ? this.props.nodeRef.current : react_dom.findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
          // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
          // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.

          if (node) forceReflow(node);
        }

        this.performEnter(mounting);
      } else {
        this.performExit();
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context ? this.context.isMounting : mounting;

    var _ref2 = this.props.nodeRef ? [appearing] : [react_dom.findDOMNode(this), appearing],
        maybeNode = _ref2[0],
        maybeAppearing = _ref2[1];

    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter || config.disabled) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(maybeNode);
      });
      return;
    }

    this.props.onEnter(maybeNode, maybeAppearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(maybeNode, maybeAppearing);

      _this2.onTransitionEnd(enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(maybeNode, maybeAppearing);
        });
      });
    });
  };

  _proto.performExit = function performExit() {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts();
    var maybeNode = this.props.nodeRef ? undefined : react_dom.findDOMNode(this); // no exit animation skip right to EXITED

    if (!exit || config.disabled) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(maybeNode);
      });
      return;
    }

    this.props.onExit(maybeNode);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(maybeNode);

      _this3.onTransitionEnd(timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(maybeNode);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
    this.setNextCallback(handler);
    var node = this.props.nodeRef ? this.props.nodeRef.current : react_dom.findDOMNode(this);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      var _ref3 = this.props.nodeRef ? [this.nextCallback] : [node, this.nextCallback],
          maybeNode = _ref3[0],
          maybeNextCallback = _ref3[1];

      this.props.addEndListener(maybeNode, maybeNextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        _in = _this$props.in,
        _mountOnEnter = _this$props.mountOnEnter,
        _unmountOnExit = _this$props.unmountOnExit,
        _appear = _this$props.appear,
        _enter = _this$props.enter,
        _exit = _this$props.exit,
        _timeout = _this$props.timeout,
        _addEndListener = _this$props.addEndListener,
        _onEnter = _this$props.onEnter,
        _onEntering = _this$props.onEntering,
        _onEntered = _this$props.onEntered,
        _onExit = _this$props.onExit,
        _onExiting = _this$props.onExiting,
        _onExited = _this$props.onExited,
        _nodeRef = _this$props.nodeRef,
        childProps = (0,objectWithoutPropertiesLoose/* default */.Z)(_this$props, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);

    return (
      /*#__PURE__*/
      // allows for nested Transitions
      react.createElement(TransitionGroupContext.Provider, {
        value: null
      }, typeof children === 'function' ? children(status, childProps) : react.cloneElement(react.Children.only(children), childProps))
    );
  };

  return Transition;
}(react.Component);

Transition.contextType = TransitionGroupContext;
Transition.propTypes =  false ? 0 : {}; // Name the function so it is clearer in the documentation

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;
/* harmony default export */ var esm_Transition = (Transition);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/transitionEndListener.js


function transitionEndListener_parseDuration(node, property) {
  const str = css(node, property) || '';
  const mult = str.indexOf('ms') === -1 ? 1000 : 1;
  return parseFloat(str) * mult;
}
function transitionEndListener(element, handler) {
  const duration = transitionEndListener_parseDuration(element, 'transitionDuration');
  const delay = transitionEndListener_parseDuration(element, 'transitionDelay');
  const remove = transitionEnd(element, e => {
    if (e.target === element) {
      remove();
      handler(e);
    }
  }, duration + delay);
}
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/triggerBrowserReflow.js
// reading a dimension prop will cause the browser to recalculate,
// which will let our animations work
function triggerBrowserReflow(node) {
  // eslint-disable-next-line @typescript-eslint/no-unused-expressions
  node.offsetHeight;
}
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/safeFindDOMNode.js

function safeFindDOMNode(componentOrElement) {
  if (componentOrElement && 'setState' in componentOrElement) {
    // TODO: Remove in next major.
    // eslint-disable-next-line react/no-find-dom-node
    return react_dom.findDOMNode(componentOrElement);
  }
  return componentOrElement != null ? componentOrElement : null;
}
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/TransitionWrapper.js
"use client";






// Normalizes Transition callbacks when nodeRef is used.
const TransitionWrapper = /*#__PURE__*/react.forwardRef(({
  onEnter,
  onEntering,
  onEntered,
  onExit,
  onExiting,
  onExited,
  addEndListener,
  children,
  childRef,
  ...props
}, ref) => {
  const nodeRef = (0,react.useRef)(null);
  const mergedRef = esm_useMergedRefs(nodeRef, childRef);
  const attachRef = r => {
    mergedRef(safeFindDOMNode(r));
  };
  const normalize = callback => param => {
    if (callback && nodeRef.current) {
      callback(nodeRef.current, param);
    }
  };
  const handleEnter = (0,react.useCallback)(normalize(onEnter), [onEnter]);
  const handleEntering = (0,react.useCallback)(normalize(onEntering), [onEntering]);
  const handleEntered = (0,react.useCallback)(normalize(onEntered), [onEntered]);
  const handleExit = (0,react.useCallback)(normalize(onExit), [onExit]);
  const handleExiting = (0,react.useCallback)(normalize(onExiting), [onExiting]);
  const handleExited = (0,react.useCallback)(normalize(onExited), [onExited]);
  const handleAddEndListener = (0,react.useCallback)(normalize(addEndListener), [addEndListener]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(esm_Transition, {
    ref: ref,
    ...props,
    onEnter: handleEnter,
    onEntered: handleEntered,
    onEntering: handleEntering,
    onExit: handleExit,
    onExited: handleExited,
    onExiting: handleExiting,
    addEndListener: handleAddEndListener,
    nodeRef: nodeRef,
    children: typeof children === 'function' ? (status, innerProps) =>
    // TODO: Types for RTG missing innerProps, so need to cast.
    children(status, {
      ...innerProps,
      ref: attachRef
    }) : /*#__PURE__*/react.cloneElement(children, {
      ref: attachRef
    })
  });
});
TransitionWrapper.displayName = 'TransitionWrapper';
/* harmony default export */ var esm_TransitionWrapper = (TransitionWrapper);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/Fade.js









const fadeStyles = {
  [ENTERING]: 'show',
  [ENTERED]: 'show'
};
const Fade = /*#__PURE__*/react.forwardRef(({
  className,
  children,
  transitionClasses = {},
  onEnter,
  ...rest
}, ref) => {
  const props = {
    in: false,
    timeout: 300,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    ...rest
  };
  const handleEnter = (0,react.useCallback)((node, isAppearing) => {
    triggerBrowserReflow(node);
    onEnter == null || onEnter(node, isAppearing);
  }, [onEnter]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(esm_TransitionWrapper, {
    ref: ref,
    addEndListener: transitionEndListener,
    ...props,
    onEnter: handleEnter,
    childRef: getChildRef(children),
    children: (status, innerProps) => /*#__PURE__*/react.cloneElement(children, {
      ...innerProps,
      className: classnames_default()('fade', className, children.props.className, fadeStyles[status], transitionClasses[status])
    })
  });
});
Fade.displayName = 'Fade';
/* harmony default export */ var esm_Fade = (Fade);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/ThemeProvider.js
"use client";




const DEFAULT_BREAKPOINTS = ['xxl', 'xl', 'lg', 'md', 'sm', 'xs'];
const DEFAULT_MIN_BREAKPOINT = 'xs';
const ThemeContext = /*#__PURE__*/react.createContext({
  prefixes: {},
  breakpoints: DEFAULT_BREAKPOINTS,
  minBreakpoint: DEFAULT_MIN_BREAKPOINT
});
const {
  Consumer,
  Provider
} = ThemeContext;
function ThemeProvider({
  prefixes = {},
  breakpoints = DEFAULT_BREAKPOINTS,
  minBreakpoint = DEFAULT_MIN_BREAKPOINT,
  dir,
  children
}) {
  const contextValue = useMemo(() => ({
    prefixes: {
      ...prefixes
    },
    breakpoints,
    minBreakpoint,
    dir
  }), [prefixes, breakpoints, minBreakpoint, dir]);
  return /*#__PURE__*/_jsx(Provider, {
    value: contextValue,
    children: children
  });
}
function useBootstrapPrefix(prefix, defaultPrefix) {
  const {
    prefixes
  } = (0,react.useContext)(ThemeContext);
  return prefix || prefixes[defaultPrefix] || defaultPrefix;
}
function useBootstrapBreakpoints() {
  const {
    breakpoints
  } = (0,react.useContext)(ThemeContext);
  return breakpoints;
}
function useBootstrapMinBreakpoint() {
  const {
    minBreakpoint
  } = (0,react.useContext)(ThemeContext);
  return minBreakpoint;
}
function useIsRTL() {
  const {
    dir
  } = (0,react.useContext)(ThemeContext);
  return dir === 'rtl';
}
function createBootstrapComponent(Component, opts) {
  if (typeof opts === 'string') opts = {
    prefix: opts
  };
  const isClassy = Component.prototype && Component.prototype.isReactComponent;
  // If it's a functional component make sure we don't break it with a ref
  const {
    prefix,
    forwardRefAs = isClassy ? 'ref' : 'innerRef'
  } = opts;
  const Wrapped = /*#__PURE__*/React.forwardRef(({
    ...props
  }, ref) => {
    props[forwardRefAs] = ref;
    const bsPrefix = useBootstrapPrefix(props.bsPrefix, prefix);
    return /*#__PURE__*/_jsx(Component, {
      ...props,
      bsPrefix: bsPrefix
    });
  });
  Wrapped.displayName = `Bootstrap(${Component.displayName || Component.name})`;
  return Wrapped;
}

/* harmony default export */ var esm_ThemeProvider = ((/* unused pure expression or super */ null && (ThemeProvider)));
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/ModalBody.js
"use client";





const ModalBody = /*#__PURE__*/react.forwardRef(({
  className,
  bsPrefix,
  as: Component = 'div',
  ...props
}, ref) => {
  bsPrefix = useBootstrapPrefix(bsPrefix, 'modal-body');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    ref: ref,
    className: classnames_default()(className, bsPrefix),
    ...props
  });
});
ModalBody.displayName = 'ModalBody';
/* harmony default export */ var esm_ModalBody = (ModalBody);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/ModalContext.js
"use client";


const ModalContext = /*#__PURE__*/react.createContext({
  onHide() {}
});
/* harmony default export */ var esm_ModalContext = (ModalContext);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/ModalDialog.js
"use client";





const ModalDialog = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  className,
  contentClassName,
  centered,
  size,
  fullscreen,
  children,
  scrollable,
  ...props
}, ref) => {
  bsPrefix = useBootstrapPrefix(bsPrefix, 'modal');
  const dialogClass = `${bsPrefix}-dialog`;
  const fullScreenClass = typeof fullscreen === 'string' ? `${bsPrefix}-fullscreen-${fullscreen}` : `${bsPrefix}-fullscreen`;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    ...props,
    ref: ref,
    className: classnames_default()(dialogClass, className, size && `${bsPrefix}-${size}`, centered && `${dialogClass}-centered`, scrollable && `${dialogClass}-scrollable`, fullscreen && fullScreenClass),
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: classnames_default()(`${bsPrefix}-content`, contentClassName),
      children: children
    })
  });
});
ModalDialog.displayName = 'ModalDialog';
/* harmony default export */ var esm_ModalDialog = (ModalDialog);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/ModalFooter.js
"use client";





const ModalFooter = /*#__PURE__*/react.forwardRef(({
  className,
  bsPrefix,
  as: Component = 'div',
  ...props
}, ref) => {
  bsPrefix = useBootstrapPrefix(bsPrefix, 'modal-footer');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    ref: ref,
    className: classnames_default()(className, bsPrefix),
    ...props
  });
});
ModalFooter.displayName = 'ModalFooter';
/* harmony default export */ var esm_ModalFooter = (ModalFooter);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/CloseButton.js




const propTypes = {
  /** An accessible label indicating the relevant information about the Close Button. */
  'aria-label': (prop_types_default()).string,
  /** A callback fired after the Close Button is clicked. */
  onClick: (prop_types_default()).func,
  /**
   * Render different color variant for the button.
   *
   * Omitting this will render the default dark color.
   */
  variant: prop_types_default().oneOf(['white'])
};
const CloseButton = /*#__PURE__*/react.forwardRef(({
  className,
  variant,
  'aria-label': ariaLabel = 'Close',
  ...props
}, ref) => /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
  ref: ref,
  type: "button",
  className: classnames_default()('btn-close', variant && `btn-close-${variant}`, className),
  "aria-label": ariaLabel,
  ...props
}));
CloseButton.displayName = 'CloseButton';
CloseButton.propTypes = propTypes;
/* harmony default export */ var esm_CloseButton = (CloseButton);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/AbstractModalHeader.js
"use client";








const AbstractModalHeader = /*#__PURE__*/react.forwardRef(({
  closeLabel = 'Close',
  closeVariant,
  closeButton = false,
  onHide,
  children,
  ...props
}, ref) => {
  const context = (0,react.useContext)(esm_ModalContext);
  const handleClick = useEventCallback_useEventCallback(() => {
    context == null || context.onHide();
    onHide == null || onHide();
  });
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    ref: ref,
    ...props,
    children: [children, closeButton && /*#__PURE__*/(0,jsx_runtime.jsx)(esm_CloseButton, {
      "aria-label": closeLabel,
      variant: closeVariant,
      onClick: handleClick
    })]
  });
});
AbstractModalHeader.displayName = 'AbstractModalHeader';
/* harmony default export */ var esm_AbstractModalHeader = (AbstractModalHeader);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/ModalHeader.js
"use client";






const ModalHeader = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  className,
  closeLabel = 'Close',
  closeButton = false,
  ...props
}, ref) => {
  bsPrefix = useBootstrapPrefix(bsPrefix, 'modal-header');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(esm_AbstractModalHeader, {
    ref: ref,
    ...props,
    className: classnames_default()(className, bsPrefix),
    closeLabel: closeLabel,
    closeButton: closeButton
  });
});
ModalHeader.displayName = 'ModalHeader';
/* harmony default export */ var esm_ModalHeader = (ModalHeader);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/divWithClassName.js



/* harmony default export */ var divWithClassName = (className =>
/*#__PURE__*/
// eslint-disable-next-line react/display-name
react.forwardRef((p, ref) => /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
  ...p,
  ref: ref,
  className: classnames_default()(p.className, className)
})));
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/ModalTitle.js
"use client";






const DivStyledAsH4 = divWithClassName('h4');
const ModalTitle = /*#__PURE__*/react.forwardRef(({
  className,
  bsPrefix,
  as: Component = DivStyledAsH4,
  ...props
}, ref) => {
  bsPrefix = useBootstrapPrefix(bsPrefix, 'modal-title');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    ref: ref,
    className: classnames_default()(className, bsPrefix),
    ...props
  });
});
ModalTitle.displayName = 'ModalTitle';
/* harmony default export */ var esm_ModalTitle = (ModalTitle);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/Modal.js
"use client";

























function DialogTransition(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(esm_Fade, {
    ...props,
    timeout: null
  });
}
function BackdropTransition(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(esm_Fade, {
    ...props,
    timeout: null
  });
}
const Modal_Modal = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  className,
  style,
  dialogClassName,
  contentClassName,
  children,
  dialogAs: Dialog = esm_ModalDialog,
  'data-bs-theme': dataBsTheme,
  'aria-labelledby': ariaLabelledby,
  'aria-describedby': ariaDescribedby,
  'aria-label': ariaLabel,
  /* BaseModal props */

  show = false,
  animation = true,
  backdrop = true,
  keyboard = true,
  onEscapeKeyDown,
  onShow,
  onHide,
  container,
  autoFocus = true,
  enforceFocus = true,
  restoreFocus = true,
  restoreFocusOptions,
  onEntered,
  onExit,
  onExiting,
  onEnter,
  onEntering,
  onExited,
  backdropClassName,
  manager: propsManager,
  ...props
}, ref) => {
  const [modalStyle, setStyle] = (0,react.useState)({});
  const [animateStaticModal, setAnimateStaticModal] = (0,react.useState)(false);
  const waitingForMouseUpRef = (0,react.useRef)(false);
  const ignoreBackdropClickRef = (0,react.useRef)(false);
  const removeStaticModalAnimationRef = (0,react.useRef)(null);
  const [modal, setModalRef] = useCallbackRef();
  const mergedRef = esm_useMergedRefs(ref, setModalRef);
  const handleHide = useEventCallback_useEventCallback(onHide);
  const isRTL = useIsRTL();
  bsPrefix = useBootstrapPrefix(bsPrefix, 'modal');
  const modalContext = (0,react.useMemo)(() => ({
    onHide: handleHide
  }), [handleHide]);
  function getModalManager() {
    if (propsManager) return propsManager;
    return getSharedManager({
      isRTL
    });
  }
  function updateDialogStyle(node) {
    if (!canUseDOM) return;
    const containerIsOverflowing = getModalManager().getScrollbarWidth() > 0;
    const modalIsOverflowing = node.scrollHeight > ownerDocument(node).documentElement.clientHeight;
    setStyle({
      paddingRight: containerIsOverflowing && !modalIsOverflowing ? scrollbarSize() : undefined,
      paddingLeft: !containerIsOverflowing && modalIsOverflowing ? scrollbarSize() : undefined
    });
  }
  const handleWindowResize = useEventCallback_useEventCallback(() => {
    if (modal) {
      updateDialogStyle(modal.dialog);
    }
  });
  useWillUnmount(() => {
    esm_removeEventListener(window, 'resize', handleWindowResize);
    removeStaticModalAnimationRef.current == null || removeStaticModalAnimationRef.current();
  });

  // We prevent the modal from closing during a drag by detecting where the
  // click originates from. If it starts in the modal and then ends outside
  // don't close.
  const handleDialogMouseDown = () => {
    waitingForMouseUpRef.current = true;
  };
  const handleMouseUp = e => {
    if (waitingForMouseUpRef.current && modal && e.target === modal.dialog) {
      ignoreBackdropClickRef.current = true;
    }
    waitingForMouseUpRef.current = false;
  };
  const handleStaticModalAnimation = () => {
    setAnimateStaticModal(true);
    removeStaticModalAnimationRef.current = transitionEnd(modal.dialog, () => {
      setAnimateStaticModal(false);
    });
  };
  const handleStaticBackdropClick = e => {
    if (e.target !== e.currentTarget) {
      return;
    }
    handleStaticModalAnimation();
  };
  const handleClick = e => {
    if (backdrop === 'static') {
      handleStaticBackdropClick(e);
      return;
    }
    if (ignoreBackdropClickRef.current || e.target !== e.currentTarget) {
      ignoreBackdropClickRef.current = false;
      return;
    }
    onHide == null || onHide();
  };
  const handleEscapeKeyDown = e => {
    if (keyboard) {
      onEscapeKeyDown == null || onEscapeKeyDown(e);
    } else {
      // Call preventDefault to stop modal from closing in @restart/ui.
      e.preventDefault();
      if (backdrop === 'static') {
        // Play static modal animation.
        handleStaticModalAnimation();
      }
    }
  };
  const handleEnter = (node, isAppearing) => {
    if (node) {
      updateDialogStyle(node);
    }
    onEnter == null || onEnter(node, isAppearing);
  };
  const handleExit = node => {
    removeStaticModalAnimationRef.current == null || removeStaticModalAnimationRef.current();
    onExit == null || onExit(node);
  };
  const handleEntering = (node, isAppearing) => {
    onEntering == null || onEntering(node, isAppearing);

    // FIXME: This should work even when animation is disabled.
    esm_addEventListener(window, 'resize', handleWindowResize);
  };
  const handleExited = node => {
    if (node) node.style.display = ''; // RHL removes it sometimes
    onExited == null || onExited(node);

    // FIXME: This should work even when animation is disabled.
    esm_removeEventListener(window, 'resize', handleWindowResize);
  };
  const renderBackdrop = (0,react.useCallback)(backdropProps => /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    ...backdropProps,
    className: classnames_default()(`${bsPrefix}-backdrop`, backdropClassName, !animation && 'show')
  }), [animation, backdropClassName, bsPrefix]);
  const baseModalStyle = {
    ...style,
    ...modalStyle
  };

  // If `display` is not set to block, autoFocus inside the modal fails
  // https://github.com/react-bootstrap/react-bootstrap/issues/5102
  baseModalStyle.display = 'block';
  const renderDialog = dialogProps => /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    role: "dialog",
    ...dialogProps,
    style: baseModalStyle,
    className: classnames_default()(className, bsPrefix, animateStaticModal && `${bsPrefix}-static`, !animation && 'show'),
    onClick: backdrop ? handleClick : undefined,
    onMouseUp: handleMouseUp,
    "data-bs-theme": dataBsTheme,
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabelledby,
    "aria-describedby": ariaDescribedby,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Dialog, {
      ...props,
      onMouseDown: handleDialogMouseDown,
      className: dialogClassName,
      contentClassName: contentClassName,
      children: children
    })
  });
  return /*#__PURE__*/(0,jsx_runtime.jsx)(esm_ModalContext.Provider, {
    value: modalContext,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(esm_Modal, {
      show: show,
      ref: mergedRef,
      backdrop: backdrop,
      container: container,
      keyboard: true // Always set true - see handleEscapeKeyDown
      ,
      autoFocus: autoFocus,
      enforceFocus: enforceFocus,
      restoreFocus: restoreFocus,
      restoreFocusOptions: restoreFocusOptions,
      onEscapeKeyDown: handleEscapeKeyDown,
      onShow: onShow,
      onHide: onHide,
      onEnter: handleEnter,
      onEntering: handleEntering,
      onEntered: onEntered,
      onExit: handleExit,
      onExiting: onExiting,
      onExited: handleExited,
      manager: getModalManager(),
      transition: animation ? DialogTransition : undefined,
      backdropTransition: animation ? BackdropTransition : undefined,
      renderBackdrop: renderBackdrop,
      renderDialog: renderDialog
    })
  });
});
Modal_Modal.displayName = 'Modal';
/* harmony default export */ var react_bootstrap_esm_Modal = (Object.assign(Modal_Modal, {
  Body: esm_ModalBody,
  Header: esm_ModalHeader,
  Title: esm_ModalTitle,
  Footer: esm_ModalFooter,
  Dialog: esm_ModalDialog,
  TRANSITION_DURATION: 300,
  BACKDROP_TRANSITION_DURATION: 150
}));
;// CONCATENATED MODULE: ./hooks/useTrigger.js

const useTrigger = function() {
    let cap = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 3;
    const [value, setValue] = (0,react.useState)(0);
    const triggerAction = ()=>setValue((item)=>{
            return (item + 1) % cap + 1;
        });
    return [
        value,
        triggerAction
    ];
};
/* harmony default export */ var hooks_useTrigger = (useTrigger);

// EXTERNAL MODULE: ./store/features/pdpSlice.js
var pdpSlice = __webpack_require__(44561);
// EXTERNAL MODULE: ./utils/helper.js + 1 modules
var helper = __webpack_require__(55760);
// EXTERNAL MODULE: ./services/ct.service.js
var ct_service = __webpack_require__(13875);
// EXTERNAL MODULE: ./constants/config.js
var constants_config = __webpack_require__(19514);
;// CONCATENATED MODULE: ./utils/ProjectionPartlist.js


const getProjectionPartListData = async (partList)=>{
    try {
        var ref, ref1;
        const response = await (0,constants_config/* getConfig */.i)();
        const currencyCode = response === null || response === void 0 ? void 0 : (ref = response.internationalization) === null || ref === void 0 ? void 0 : ref.currencyCode;
        const currencySign = response === null || response === void 0 ? void 0 : (ref1 = response.internationalization) === null || ref1 === void 0 ? void 0 : ref1.currencySign;
        const itemsCount = 20;
        let startFrom = 0;
        let endTo = itemsCount;
        const initialList = [];
        const groupArrayCount = Math.ceil(partList.length / itemsCount);
        const skus = partList.map((val)=>val.skuId);
        if ((partList === null || partList === void 0 ? void 0 : partList.length) <= itemsCount) {
            const resp = await (0,ct_service/* getProjectionData */.vP)({
                skus
            });
            return getPartsPricebySku(resp, currencyCode, currencySign);
        } else {
            const list = [];
            Array.from({
                length: groupArrayCount
            }, ()=>{
                list.push([
                    partList.slice(startFrom, endTo)
                ]);
                startFrom = endTo;
                endTo = endTo + itemsCount;
                return null;
            });
            list.forEach((val)=>{
                const skus = val[0].map((v)=>v.skuId);
                const resp = (0,ct_service/* getProjectionData */.vP)({
                    skus
                });
                initialList.push(resp);
            });
            const res = await Promise.allSettled(initialList);
            const combineItem = res.flatMap((x)=>x.value);
            return getPartsPricebySku(combineItem, currencyCode, currencySign);
        }
    } catch (err) {
        return err;
    }
};
const getPartsPricebySku = function(list) {
    let currencyCode = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "USD", currencySign = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "$";
    const sortItems = (i)=>{
        return {
            sku: i === null || i === void 0 ? void 0 : i.sku,
            currencySign,
            discountPrices: i === null || i === void 0 ? void 0 : i.prices.filter((i)=>{
                var ref, ref1;
                return (i === null || i === void 0 ? void 0 : (ref = i.discounted) === null || ref === void 0 ? void 0 : (ref1 = ref.value) === null || ref1 === void 0 ? void 0 : ref1.currencyCode) == currencyCode;
            }).reduce((a, i)=>{
                var ref, ref1, ref2;
                var ref3;
                return {
                    ...a,
                    [(ref3 = i === null || i === void 0 ? void 0 : (ref = i.customerGroup) === null || ref === void 0 ? void 0 : (ref1 = ref.obj) === null || ref1 === void 0 ? void 0 : ref1.key) !== null && ref3 !== void 0 ? ref3 : "ANY"]: i === null || i === void 0 ? void 0 : (ref2 = i.discounted) === null || ref2 === void 0 ? void 0 : ref2.value
                };
            }, {}),
            prices: i === null || i === void 0 ? void 0 : i.prices.filter((i)=>{
                var ref;
                return (i === null || i === void 0 ? void 0 : (ref = i.value) === null || ref === void 0 ? void 0 : ref.currencyCode) == currencyCode;
            }).reduce((a, i)=>{
                var ref, ref1;
                var ref2;
                return {
                    ...a,
                    [(ref2 = i === null || i === void 0 ? void 0 : (ref = i.customerGroup) === null || ref === void 0 ? void 0 : (ref1 = ref.obj) === null || ref1 === void 0 ? void 0 : ref1.key) !== null && ref2 !== void 0 ? ref2 : "ANY"]: i === null || i === void 0 ? void 0 : i.value
                };
            }, {})
        };
    };
    return list.reduce((acc, sku)=>{
        var ref;
        return {
            ...acc,
            [sku === null || sku === void 0 ? void 0 : (ref = sku.masterVariant) === null || ref === void 0 ? void 0 : ref.sku]: [
                ...sku.variants.map(sortItems),
                ...[
                    sku.masterVariant
                ].map(sortItems)
            ]
        };
    }, {});
};

// EXTERNAL MODULE: ./hooks/useViewport.js
var useViewport = __webpack_require__(78770);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

;// CONCATENATED MODULE: ./components/PartsViewer/v2/ErrorBoundary/index.js



/**
 * This will catch errors and show alternate view
 */ class ErrorBoundary extends react.Component {
    /**
   * Rejection.
   * @param {Error} error
   * @return {Object}
   */ static getDerivedStateFromError(error) {
        return {
            error: true,
            errorMessage: error.toString()
        };
    }
    /**
   * Adding listner function on mount to the event.
   */ componentDidMount() {
        window.addEventListener("unhandledrejection", this.promiseRejectionHandler);
    }
    /**
   * Remove listner function on unmount.
   */ componentWillUnmount() {
        window.removeEventListener("unhandledrejection", this.promiseRejectionHandler);
    }
    /**
   * @return {React.JSX} Return appropriate component
   */ render() {
        const { error , errorMessage  } = this.state;
        const { FallBackComponent , children , params  } = this.props;
        return error === true ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FallBackComponent, {
            error,
            errorMessage,
            params
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
            children: [
                " ",
                children
            ]
        });
    }
    constructor(...args){
        super(...args);
        _defineProperty(this, "state", {
            error: false,
            errorMessage: ""
        });
        /**
   * This function handles rejection.
   * @param {Event} event
   */ _defineProperty(this, "promiseRejectionHandler", (event)=>{
            this.setState({
                error: event.reason
            }) // eslint-disable-line no-invalid-this
            ;
        });
    }
}
/* harmony default export */ var v2_ErrorBoundary = (ErrorBoundary);

// EXTERNAL MODULE: ./constants/index.js
var constants = __webpack_require__(96301);
;// CONCATENATED MODULE: ./components/PartsViewer/v2/ErrorFallBack/index.js


const ErrorFallbackUI = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "fallback-wrapper d-flex flex-column w-100 h-100",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "error-message",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "text-section",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "line-first",
                        children: "Sorry, this diagram cannot be found"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "questions",
                        children: [
                            "If you have any questions please\xa0",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: constants.CONTACT_US_PAGE_URL_US,
                                target: "_blank",
                                rel: "noreferrer",
                                children: "contact us"
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var ErrorFallBack = (ErrorFallbackUI);

// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 16 modules
var esm = __webpack_require__(24400);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./components/core/Coach/Coach.js



const Coach = (props)=>{
    const { text ="no text" , hide =false , showHeaderCoach =false , panelState , isOverlapping , displayKey =""  } = props;
    const [isShown, setIsShown] = (0,react.useState)(false);
    const [isSeen, setIsSeen] = (0,react.useState)(false);
    const device = (0,useViewport/* default */.Z)();
    const [coachMarkPosition, setCoachMarkPosition] = (0,react.useState)({
        top: 0,
        left: 0,
        zIndex: 1
    });
    (0,react.useEffect)(()=>{
        updateCoachMarkPosition();
        window.addEventListener("resize", updateCoachMarkPosition);
        return ()=>{
            window.removeEventListener("resize", updateCoachMarkPosition);
        };
    }, [
        device
    ]);
    const updateCoachMarkPosition = ()=>{
        let top;
        let left;
        if (showHeaderCoach) {
            var ref, ref1, ref2;
            const addCoachFirstChild = (ref2 = (ref = document === null || document === void 0 ? void 0 : document.querySelector(".add-coach")) === null || ref === void 0 ? void 0 : (ref1 = ref.firstElementChild) === null || ref1 === void 0 ? void 0 : ref1.getBoundingClientRect()) === null || ref2 === void 0 ? void 0 : ref2.right;
            const contentChange = addCoachFirstChild - 85;
            if (device === null || device === void 0 ? void 0 : device.isExtraSmallScreen) {
                top = "110px";
                left = "65px";
            } else if (device === null || device === void 0 ? void 0 : device.isSmallScreen) {
                top = "115px";
                left = "85px";
            } else if (device === null || device === void 0 ? void 0 : device.isMediumScreen) {
                top = "110px";
                left = "".concat(contentChange, "px");
            } else {
                top = isOverlapping ? "115px" : "75px";
                left = "".concat(contentChange, "px");
            }
            setCoachMarkPosition({
                top: top,
                left: left
            });
        }
    };
    (0,react.useEffect)(()=>{
        if (!hide) setIsShown(true);
        else setIsShown(false);
    }, []);
    const conditionalCss = showHeaderCoach ? {
        top: coachMarkPosition.top,
        left: coachMarkPosition.left,
        zIndex: panelState ? 1 : 2
    } : null;
    (0,react.useEffect)(()=>{
        const getCoachKey = window.localStorage.getItem("getCoachKey");
        if (getCoachKey && Object.prototype.hasOwnProperty.call(JSON.parse(getCoachKey), displayKey)) {
            setIsSeen(true);
        }
    }, []);
    const handlerModel = ()=>{
        const getCoachKeyVal = window.localStorage.getItem("getCoachKey");
        let keyVal = {};
        if (getCoachKeyVal) keyVal = JSON.parse(getCoachKeyVal);
        keyVal[displayKey] = "y";
        window.localStorage.setItem("getCoachKey", JSON.stringify(keyVal));
        setIsShown(false);
        setIsSeen(true);
    };
    return !isSeen && isShown && !hide ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "coach-mark",
        "data-testid": "header-back-button",
        style: conditionalCss,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "coach-text",
                children: text
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                className: "close-button-coach mx-2",
                onClick: handlerModel,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                    width: "12",
                    height: "12",
                    viewBox: "0 0 12 12",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M1.52079 11.3239L0.677734 10.4808L5.15773 6.0008L0.677734 1.52079L1.52079 0.677734L6.0008 5.15773L10.4808 0.677734L11.3239 1.52079L6.84386 6.0008L11.3239 10.4808L10.4808 11.3239L6.0008 6.84386L1.52079 11.3239Z",
                        fill: "#17181D"
                    })
                })
            })
        ]
    }) : null;
};
/* harmony default export */ var Coach_Coach = (Coach);

;// CONCATENATED MODULE: ./public/icons/cart-icon-dark-empty.svg
/* harmony default export */ var cart_icon_dark_empty = ({"src":"/_next/static/media/cart-icon-dark-empty.2d6bad3c.svg","height":23,"width":26});
;// CONCATENATED MODULE: ./public/icons/cart-icon-dark-nonempty.svg
/* harmony default export */ var cart_icon_dark_nonempty = ({"src":"/_next/static/media/cart-icon-dark-nonempty.63d9248c.svg","height":22,"width":25});
// EXTERNAL MODULE: ./utils/cart.js
var cart = __webpack_require__(11763);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./components/Shared/MiniCart/v2/MiniCart.jsx






const MiniCart = (param)=>{
    let { eventHandler: { store: { cartCount , ariaLabel  }  } , color ="dark"  } = param;
    const [cartUrl, setCartUrl] = (0,react.useState)("");
    (0,react.useEffect)(()=>{
        (0,cart/* getCartLandingPagePath */.dZ)().then((res)=>{
            setCartUrl(res);
        });
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "cart-indicator v2 ".concat(cartCount > 0 && "cart-indicator__with-count", " ").concat(color === "dark" ? "dark" : "light"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: cartUrl,
            "aria-label": ariaLabel,
            role: "link",
            className: "gbh-data-layer",
            "data-gbh-data-layer": '{"clickInternalLinks":"true","internalLinkPosition":"global header","internalLinkZoneName":"global header","internalLinkURL":"'.concat(cartUrl, '","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"cart icon","eventName":"cart icon","internalLinkType":"homepage:navigation","eventType":"global header","eventAction":"cart icon"}'),
            children: cartCount ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "cart-indicator__count ".concat(cartCount < 10 ? "count-single" : ""),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: cart_icon_dark_nonempty === null || cart_icon_dark_nonempty === void 0 ? void 0 : cart_icon_dark_nonempty.src,
                        alt: "Cart"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: cartCount
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: cart_icon_dark_empty === null || cart_icon_dark_empty === void 0 ? void 0 : cart_icon_dark_empty.src,
                alt: "Cart"
            })
        })
    });
};
const checkForRerender = (prevProps, nextProps)=>{
    return nextProps.eventHandler.store.cartCount === prevProps.eventHandler.store.cartCount;
};
/* harmony default export */ var v2_MiniCart = (/*#__PURE__*/(0,react.memo)(MiniCart, checkForRerender));

// EXTERNAL MODULE: ./store/features/cartSlice.js
var cartSlice = __webpack_require__(46201);
;// CONCATENATED MODULE: ./public/scout_icon/icons/printIcon.svg
/* harmony default export */ var printIcon = ({"src":"/_next/static/media/printIcon.99057120.svg","height":30,"width":30});
;// CONCATENATED MODULE: ./public/scout_icon/icons/shareIcon.svg
/* harmony default export */ var shareIcon = ({"src":"/_next/static/media/shareIcon.773c9ce7.svg","height":30,"width":30});
// EXTERNAL MODULE: ./components/PartsViewer/v2/PrintShareWindow/index.module.scss
var index_module = __webpack_require__(32353);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
;// CONCATENATED MODULE: ./components/PartsViewer/v2/PrintShareWindow/index.js




const PrintAndShare = (props)=>{
    const { showPopup , setShowPopup , contents  } = props;
    if (!showPopup) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (index_module_default()).PrintShareWindow,
        children: [
            showPopup ? /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                className: "bg-overlay-print",
                onClick: ()=>setShowPopup(false)
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "print-modal",
                children: contents
            })
        ]
    });
};
PrintAndShare.propTypes = {
    showPopup: (prop_types_default()).bool.isRequired,
    setShowPopup: (prop_types_default()).func.isRequired,
    contents: (prop_types_default()).any.isRequired
};
/* harmony default export */ var PrintShareWindow = (PrintAndShare);

// EXTERNAL MODULE: ./components/SocialShare/v1/SocialShare.jsx + 3 modules
var SocialShare = __webpack_require__(49019);
// EXTERNAL MODULE: ./components/PartsViewer/v2/localization.js
var localization = __webpack_require__(89676);
// EXTERNAL MODULE: ./components/PartsViewer/v2/SelectedFileView/PrintShare/index.module.scss
var PrintShare_index_module = __webpack_require__(83000);
var PrintShare_index_module_default = /*#__PURE__*/__webpack_require__.n(PrintShare_index_module);
;// CONCATENATED MODULE: ./components/PartsViewer/v2/SelectedFileView/PrintShare/index.js







const PrintShare = (props)=>{
    const { showShareModal =false , setShare , shareBtn , productId  } = props;
    const link = "".concat(window.location.origin, "/parts?number=").concat(productId);
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const { mailBody , description , mailSubjectTextOne , mailSubjectTextTwo  } = (0,localization/* getTranslations */.F)(t);
    const emailSubjecttext = "".concat(mailSubjectTextOne, "-").concat(mailSubjectTextTwo, "-").concat(productId);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (PrintShare_index_module_default()).PrintShare,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "share-widgets",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialShare/* default */.Z, {
                asset: {
                    url: link,
                    description
                },
                id: "kf-my-product-tile-".concat(productId),
                showModal: showShareModal,
                onClose: setShare,
                shareBtn: shareBtn,
                mailSubject: emailSubjecttext,
                mailBody: mailBody,
                url: link
            })
        })
    });
};
PrintShare.propTypes = {
    showShareModal: (prop_types_default()).bool.isRequired,
    setShare: (prop_types_default()).func.isRequired,
    shareBtn: (prop_types_default()).string.isRequired,
    productId: (prop_types_default()).string.isRequired
};
/* harmony default export */ var SelectedFileView_PrintShare = (PrintShare);

;// CONCATENATED MODULE: ./components/PartsViewer/v2/utils.js
const sortOptions = [
    {
        label: "A-Z",
        key: "asc"
    },
    {
        label: "Z-A",
        key: "desc"
    }
];
const LOCAL_PREFIX = "";
const printElement = async function(elementId, uniqueIframeId) {
    const content = document.getElementById(elementId);
    let contentWindow;
    if (document.getElementById(uniqueIframeId)) {
        contentWindow = document.getElementById(uniqueIframeId).contentWindow;
    } else {
        const iframe = document.createElement("iframe");
        iframe.setAttribute("title", uniqueIframeId);
        iframe.setAttribute("id", uniqueIframeId);
        iframe.setAttribute("style", "height: 0px; width: 0px; position: absolute;");
        document.body.appendChild(iframe);
        contentWindow = iframe.contentWindow;
    }
    contentWindow.document.open();
    contentWindow.document.write(content.innerHTML);
    const style = contentWindow.document.createElement("style");
    style.textContent = "body { overflow: visible!important; }.main { display: none; visibility: hidden; }#parent-print { display: block; visibility: visible; height: 100%; min-height: 100%; }html, body, #wrap {height: 100%; margin: 0; padding: 0;}body #parent-print #wrap {min-height: 100%; max-height: 100%; overflow: visible!important; }#main {height: 74.2%; width: 100%; text-align: center;}#main img {height: 97%; width: 100%; margin: 1% auto}#header {height: 20%; border-bottom:solid 1px #ccc; text-align:left;}#header.topPrint svg{height:95%; width:100%;}#footer { bottom: 0;  font-size: 8px; left: 0; padding:3px 0 0 0; width: 100%; height: 5%; position: absolute; border-top: solid 1px #ccc;}#footer .cod-prod{float:left; padding:0 0 0 10px;}#footer #inf-print{float:right; text-align:right; padding:0 10px 0 0; }#footer .date-print{ font-style: italic; color: #333; }#footer #pagination{position:absolute; z-index:1; left:50%; margin:0 0 0 -50px; width:100px; text-align:center; color: #8399B6;}#wrap {page-break-after: always; position: relative;}body.mozilla #main svg { height: 95%; width: 100%; max-height: 95%; }body.safari { height:9in; width: 8.5in; }body.safari #main img {max-height: 99%; max-width: 100%; margin: 5px auto}body.safari #parent-print #wrap #footer { font-size: 8px; left: 0; padding:3px 0 0 0; width: 100%; height: 2%; position: absolute; border-top: solid 1px #ccc;}body.safari #parent-print #wrap #main svg {height: 99%; width: 99%; margin: 5px auto; }";
    contentWindow.document.head.appendChild(style);
    contentWindow.document.close();
    await new Promise((r)=>setTimeout(r, 500));
    contentWindow.focus();
    contentWindow.print();
};

// EXTERNAL MODULE: ./components/PartsViewer/v2/icon.js
var icon = __webpack_require__(7667);
;// CONCATENATED MODULE: ./components/PartsViewer/v2/PrintPage/index.js




const PrintPage = (props)=>{
    const { item , metadata , index , printItems  } = props;
    const getFormatedDate = ()=>{
        const today = new Date();
        return today.toLocaleString("en", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour12: true,
            hour: "2-digit",
            minute: "2-digit"
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        rel: index,
        id: "wrap",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "header",
                className: "topPrint",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* PrintHeader */.Gr, {
                    data: metadata === null || metadata === void 0 ? void 0 : metadata.Info
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                rel: "printDiv",
                className: "container",
                id: "main",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: item === null || item === void 0 ? void 0 : item.URL,
                    alt: "",
                    srcSet: ""
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                id: "footer",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        id: "pagination",
                        children: [
                            "Page ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                id: "actual",
                                children: index + 1
                            }),
                            " - ",
                            "",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                id: "total",
                                children: printItems === null || printItems === void 0 ? void 0 : printItems.length
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        id: "inf-print",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "date-print",
                            children: [
                                "printed on ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "date-print",
                                    children: getFormatedDate()
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
PrintPage.propTypes = {
    item: (prop_types_default()).object.isRequired,
    metadata: (prop_types_default()).object.isRequired,
    index: (prop_types_default()).string.isRequired,
    printItems: (prop_types_default()).array.isRequired
};
/* harmony default export */ var v2_PrintPage = (PrintPage);

// EXTERNAL MODULE: ./components/PartsViewer/v2/PrintWindow/index.module.scss
var PrintWindow_index_module = __webpack_require__(36697);
var PrintWindow_index_module_default = /*#__PURE__*/__webpack_require__.n(PrintWindow_index_module);
;// CONCATENATED MODULE: ./components/PartsViewer/v2/PrintWindow/index.js










const PrintWindow = (props)=>{
    var ref;
    const { files , productId  } = props;
    const dispatch = (0,es/* useDispatch */.I0)();
    const [metadata, setMetadata] = (0,react.useState)(null);
    const [metadataPromise, setMetadataPromise] = (0,react.useState)(null);
    const [printItems, setPrintItems] = (0,react.useState)([]);
    const [selected, setSelected] = (0,react.useState)({});
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const { printDiagrams , printAllText , printSelectedText  } = (0,localization/* getTranslations */.F)(t);
    (0,react.useEffect)(()=>{
        if (files) {
            setMetadataPromise(getPartInfo(files));
        }
    }, [
        files
    ]);
    const getPartInfo = async (arg)=>{
        var ref;
        const resp = await dispatch((0,pdpSlice/* getPartList */.gt)({
            productId
        })).unwrap();
        const blobFileResp = await fetch(resp === null || resp === void 0 ? void 0 : (ref = resp.Info) === null || ref === void 0 ? void 0 : ref.Thumbnail);
        const data = await (blobFileResp === null || blobFileResp === void 0 ? void 0 : blobFileResp.blob());
        const imgFile = new Promise((resolve)=>{
            const reader = new FileReader();
            reader.onload = function(e) {
                resolve(e.target.result);
            };
            return reader.readAsDataURL(data);
        });
        await new Promise((r)=>setTimeout(r, 500));
        resp.Info.uri = await imgFile;
        resp.SVGFiles = arg;
        setMetadata(resp);
        setPrintItems(arg);
    };
    const printHandler = async ()=>{
        setPrintItems(metadata === null || metadata === void 0 ? void 0 : metadata.SVGFiles);
        await metadataPromise;
        printElement("parts-print-content");
    };
    const handleChange = (event)=>{
        const { value , checked  } = event.target;
        setSelected((prevState)=>{
            const key = [
                "key_" + value
            ];
            const data = {
                ...prevState,
                [key]: value
            };
            if (data[key] && !checked) {
                delete data[key];
            }
            return data;
        });
    };
    const selectedPrinthandler = async (activeItem, list)=>{
        const item = Object === null || Object === void 0 ? void 0 : Object.values(activeItem);
        if ((item === null || item === void 0 ? void 0 : item.length) !== 0) {
            const value = list === null || list === void 0 ? void 0 : list.filter((v)=>{
                return item === null || item === void 0 ? void 0 : item.includes(v.FileName);
            });
            setPrintItems(value);
            await metadataPromise;
            printElement("parts-print-content");
        }
    };
    const activeButton = (ref = Object === null || Object === void 0 ? void 0 : Object.values(selected)) === null || ref === void 0 ? void 0 : ref.length;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (PrintWindow_index_module_default()).PrintModal,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "mb-15 print-heading",
                children: printDiagrams
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "print-lists",
                children: files === null || files === void 0 ? void 0 : files.map((val)=>{
                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("label", {
                        className: "print-item",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    " ",
                                    val === null || val === void 0 ? void 0 : val.title
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                type: "checkbox",
                                value: val === null || val === void 0 ? void 0 : val.id,
                                onChange: handleChange
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "checkmark"
                            })
                        ]
                    }, val === null || val === void 0 ? void 0 : val.id);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "print-action-buttons mt-20",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: "print-button fs-18 fw-400 w-100",
                        onClick: ()=>printHandler(),
                        children: printAllText
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: "print-button fs-18 fw-400 w-100 ".concat(activeButton === 0 ? "disabled" : ""),
                        onClick: ()=>{
                            return selectedPrinthandler(selected, metadata === null || metadata === void 0 ? void 0 : metadata.SVGFiles);
                        },
                        children: printSelectedText
                    })
                ]
            }),
            printItems ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "hidden-print-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    id: "parts-print-content",
                    children: printItems === null || printItems === void 0 ? void 0 : printItems.map((item, index)=>{
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(v2_PrintPage, {
                            item: item,
                            metadata: metadata,
                            index: index,
                            printItems: printItems
                        }, item === null || item === void 0 ? void 0 : item.id);
                    })
                })
            }) : null
        ]
    });
};
PrintWindow.propTypes = {
    files: (prop_types_default()).array.isRequired
};
/* harmony default export */ var v2_PrintWindow = (PrintWindow);

;// CONCATENATED MODULE: ./components/PartsViewer/v2/SelectedFileView/FileSelection/index.js

















const FileSelection = (props)=>{
    var ref;
    const { files , isActive , setSelected , setPopupModal , title , sku , skuImage , getFileTitle , setParts , panelState , initialIndex , setPartsHeight , productId , setShowPrint  } = props;
    const [visibleCoach, setVisibleCoach] = (0,react.useState)(false);
    const device = (0,useViewport/* default */.Z)();
    const divRef = (0,react.useRef)(null);
    const tabRefs = (0,react.useRef)([]);
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const cartCount = (0,cart/* getCartCount */.c0)();
    const ariaLabel = (0,cart/* getAriaLabel */.Xw)(t, cartCount);
    const { cartUrl  } = (0,es/* useSelector */.v9)(cartSlice/* selectCartState */.xw);
    const [isOverlapping, setIsOverlapping] = (0,react.useState)(false);
    const [showPopup, setShowPopup] = (0,react.useState)(false);
    const [share, setShare] = (0,react.useState)(false);
    const [showPrintWindow, setShowPrintWindow] = (0,react.useState)(false);
    const shareBtn = (0,react.useRef)();
    const featuresDtl = {
        displayClass: "d-inline",
        floating: (device === null || device === void 0 ? void 0 : device.isSmallScreen) || (device === null || device === void 0 ? void 0 : device.isMediumScreen) ? "" : "float-right",
        heightof: "h-80",
        skuDisplayClass: (device === null || device === void 0 ? void 0 : device.isSmallScreen) || (device === null || device === void 0 ? void 0 : device.isMediumScreen) ? "" : "d-inline"
    };
    const [features, setFeatures] = (0,react.useState)(featuresDtl);
    const router = (0,next_router.useRouter)();
    const redirect = ()=>{
        router.push("".concat(cartUrl));
    };
    const eventHandler = {
        store: {
            cartCount,
            ariaLabel,
            cartUrl
        },
        callbacks: {
            onClick: ()=>{
                redirect();
            }
        }
    };
    const scrollVisible = (index)=>{
        var ref, ref1, ref2;
        const addCoachContainer = document.querySelector(".add-coach");
        const offSetValue = ((ref1 = (ref = tabRefs === null || tabRefs === void 0 ? void 0 : tabRefs.current[index]) === null || ref === void 0 ? void 0 : ref.getBoundingClientRect()) === null || ref1 === void 0 ? void 0 : ref1.left) - ((ref2 = addCoachContainer === null || addCoachContainer === void 0 ? void 0 : addCoachContainer.getBoundingClientRect()) === null || ref2 === void 0 ? void 0 : ref2.left);
        if (tabRefs === null || tabRefs === void 0 ? void 0 : tabRefs.current[index]) {
            var ref3;
            (ref3 = tabRefs === null || tabRefs === void 0 ? void 0 : tabRefs.current[index]) === null || ref3 === void 0 ? void 0 : ref3.scrollIntoView({
                behavior: "smooth",
                block: "nearest",
                inline: "start"
            });
            if (!(device === null || device === void 0 ? void 0 : device.isSmallScreen)) {
                const timer = setTimeout(()=>addCoachContainer.scrollLeft += offSetValue, 100);
                return ()=>clearTimeout(timer);
            }
        }
    };
    const adjustSrcollForView = ()=>{
        const addCoachContainer = document.querySelector(".add-coach");
        const activeTabContent = document.querySelector(".activeTab");
        const addCoachContainerRect = addCoachContainer === null || addCoachContainer === void 0 ? void 0 : addCoachContainer.getBoundingClientRect();
        const activeTabContentRect = activeTabContent === null || activeTabContent === void 0 ? void 0 : activeTabContent.getBoundingClientRect();
        const offset = (activeTabContentRect === null || activeTabContentRect === void 0 ? void 0 : activeTabContentRect.left) - (addCoachContainerRect === null || addCoachContainerRect === void 0 ? void 0 : addCoachContainerRect.left);
        addCoachContainer.scrollLeft += offset;
    };
    (0,react.useEffect)(()=>{
        window.addEventListener("resize", adjustSrcollForView);
        return ()=>{
            window.removeEventListener("resize", adjustSrcollForView);
        };
    }, []);
    (0,react.useEffect)(()=>{
        scrollVisible(initialIndex);
    }, [
        files,
        initialIndex
    ]);
    (0,react.useEffect)(()=>{
        setPartsHeight(features === null || features === void 0 ? void 0 : features.heightof);
        const timer = setTimeout(()=>setVisibleCoach(true), 3000);
        return ()=>clearTimeout(timer);
    }, []);
    const screenWidth = device.isLargeScreen || device.isExtraLargeScreen || device.isMediumScreen;
    const handlerFileSelection = async (e, item, index)=>{
        var ref;
        if (!(item === null || item === void 0 ? void 0 : item.prices) && (item === null || item === void 0 ? void 0 : (ref = item.Parts) === null || ref === void 0 ? void 0 : ref.length) !== 0) {
            const prices = await getProjectionPartListData(item === null || item === void 0 ? void 0 : item.Parts);
            setParts((prevState)=>{
                const { partsInfo: { SVGFiles  }  } = prevState;
                const updatePrice = SVGFiles === null || SVGFiles === void 0 ? void 0 : SVGFiles.filter((val)=>val.FileName === item.FileName);
                updatePrice[0].prices = prices;
                return {
                    ...prevState
                };
            });
        }
        setSelected(item);
        scrollVisible(index);
        setPopupModal(false);
    };
    (0,react.useEffect)(()=>{
        const checkOverlap = ()=>{
            if (device === null || device === void 0 ? void 0 : device.isLargeTabView) {
                var ref, ref1, ref2, ref3, ref4, ref5, ref6;
                let addCoachSpan = 0;
                const childDiv = Array.from((ref = document === null || document === void 0 ? void 0 : document.querySelector(".add-coach")) === null || ref === void 0 ? void 0 : ref.children);
                childDiv.forEach((child)=>{
                    var ref;
                    return addCoachSpan += (ref = child === null || child === void 0 ? void 0 : child.getBoundingClientRect()) === null || ref === void 0 ? void 0 : ref.width;
                });
                if (((ref2 = (ref1 = document === null || document === void 0 ? void 0 : document.querySelector(".sku-title")) === null || ref1 === void 0 ? void 0 : ref1.getBoundingClientRect()) === null || ref2 === void 0 ? void 0 : ref2.width) + ((ref4 = (ref3 = document === null || document === void 0 ? void 0 : document.querySelector(".sku")) === null || ref3 === void 0 ? void 0 : ref3.getBoundingClientRect()) === null || ref4 === void 0 ? void 0 : ref4.width) + addCoachSpan + 200 > ((ref6 = (ref5 = document.querySelector(".section-title-file")) === null || ref5 === void 0 ? void 0 : ref5.getBoundingClientRect()) === null || ref6 === void 0 ? void 0 : ref6.width)) {
                    setIsOverlapping(true);
                } else {
                    setIsOverlapping(false);
                }
            }
        };
        checkOverlap();
        window.addEventListener("resize", checkOverlap);
        return ()=>window.removeEventListener("resize", checkOverlap);
    }, []);
    (0,react.useEffect)(()=>{
        if (isOverlapping) {
            setPartsHeight("h-115");
            setFeatures((prevfeatures)=>({
                    ...prevfeatures,
                    displayClass: "d-inline",
                    floating: "",
                    heightof: "h-115",
                    marginTb: "my-3",
                    skuDisplayClass: ""
                }));
        } else {
            setFeatures(featuresDtl);
            setPartsHeight("h-80");
        }
    }, [
        isOverlapping
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "check-modal d-flex flex-grow-1 ".concat(features.heightof, " ").concat(showPopup ? "show-print-window" : ""),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex-container modal_panel selection",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "only-image image-container",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            className: "image-part",
                            src: skuImage,
                            alt: "skuimage"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "section-title-file ".concat(features.displayClass, " w-100"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "modal_header flex-item ".concat(features.displayClass),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "sku-part ".concat(features.skuDisplayClass),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "sku-title",
                                            children: title
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "sku",
                                            children: sku
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex-container header-content ".concat(features.floating),
                                children: [
                                    files.length !== 1 && visibleCoach ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Coach_Coach, {
                                        text: "",
                                        show: true,
                                        showHeaderCoach: true,
                                        panelState: panelState,
                                        isOverlapping: isOverlapping,
                                        displayKey: "top"
                                    }) : null,
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        ref: divRef,
                                        className: "add-coach",
                                        children: (ref = files === null || files === void 0 ? void 0 : files.filter((files)=>"FileName" in files)) === null || ref === void 0 ? void 0 : ref.map((item, index)=>{
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                ref: (el)=>tabRefs.current[index] = el,
                                                className: "file-tab user-select-none  header-icons header-name" + (isActive(item) ? " activeTab" : ""),
                                                onClick: (e)=>{
                                                    handlerFileSelection(e, item, index);
                                                },
                                                onKeyDown: (val)=>val,
                                                children: getFileTitle(item === null || item === void 0 ? void 0 : item.FileName)
                                            }, "".concat(index + (item === null || item === void 0 ? void 0 : item.FileName)));
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat(!(device.isMediumScreen || device.isSmallScreen) ? "mr-150 print-action" : "mobile-print-section"),
                children: screenWidth ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "print-share-div d-flex",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "header-img d-flex",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: "btn-share-print",
                                onClick: ()=>{
                                    setShowPopup(true);
                                    setShare(false);
                                    setShowPrintWindow(true);
                                    setShowPrint(true);
                                },
                                "aria-label": "Click here to print",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: printIcon === null || printIcon === void 0 ? void 0 : printIcon.src,
                                    alt: "print"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                "aria-label": "Click here to share",
                                className: "share-button",
                                onClick: ()=>{
                                    setShowPopup(true);
                                    setShare(true);
                                    setShowPrintWindow(false);
                                    setShowPrint(true);
                                },
                                ref: shareBtn,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: shareIcon === null || shareIcon === void 0 ? void 0 : shareIcon.src,
                                    alt: "share"
                                })
                            }),
                            share ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PrintShareWindow, {
                                showPopup: showPopup,
                                setShowPopup: setShowPopup,
                                contents: /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectedFileView_PrintShare, {
                                    showShareModal: share,
                                    setShare: setShare,
                                    shareBtn: shareBtn,
                                    productId: productId
                                })
                            }) : null,
                            showPrintWindow ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PrintShareWindow, {
                                showPopup: showPopup,
                                setShowPopup: setShowPopup,
                                contents: /*#__PURE__*/ (0,jsx_runtime.jsx)(v2_PrintWindow, {
                                    files: files,
                                    productId: productId
                                })
                            }) : null
                        ]
                    })
                }) : ""
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "parts-cart-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v2_MiniCart, {
                    eventHandler: eventHandler,
                    source: "from desk"
                })
            })
        ]
    });
};
FileSelection.propTypes = {
    files: (prop_types_default()).array
};
/* harmony default export */ var SelectedFileView_FileSelection = (FileSelection);

;// CONCATENATED MODULE: ./components/PartsViewer/v2/partReducer.js



const partsReducer = (state, action)=>{
    try {
        switch(action.type){
            case "initPartsList":
                {
                    var ref;
                    const pricesReMapped = Object.values(action === null || action === void 0 ? void 0 : (ref = action.payload) === null || ref === void 0 ? void 0 : ref.prices).reduce((a, i)=>{
                        const mappedList = {};
                        i.map((item)=>mappedList[item.sku] = i);
                        return {
                            ...a,
                            ...mappedList
                        };
                    }, {});
                    const newParts = action.payload.Parts.map((item)=>{
                        return {
                            key: item === null || item === void 0 ? void 0 : item.Cod,
                            partApi: item,
                            ctApiPromise: null,
                            prices: (pricesReMapped === null || pricesReMapped === void 0 ? void 0 : pricesReMapped[item === null || item === void 0 ? void 0 : item.skuId]) ? pricesReMapped === null || pricesReMapped === void 0 ? void 0 : pricesReMapped[item === null || item === void 0 ? void 0 : item.skuId] : ""
                        };
                    });
                    state.parts = newParts;
                    const sortAsc = sortByName(state, "asc");
                    return {
                        parts: sortAsc
                    };
                }
            case "fetchCT":
                {
                    const { payload  } = action;
                    const newParts1 = state.parts.map((item)=>{
                        if (payload.includes(item.key) && item.ctApiPromise === null) return {
                            ...item,
                            ctApiPromise: fetchCTRequest(item.partApi, item === null || item === void 0 ? void 0 : item.prices)
                        };
                        return item;
                    });
                    return {
                        parts: newParts1
                    };
                }
            case "fetchCTAny":
                {
                    const { payload: payload1  } = action;
                    const newParts2 = [];
                    let count = 0;
                    for (const item of state.parts){
                        if (item.ctApiPromise === null && count < payload1) {
                            newParts2.push({
                                ...item,
                                ctApiPromise: fetchCTRequest(item.partApi, item === null || item === void 0 ? void 0 : item.prices)
                            });
                            count++;
                        } else newParts2.push(item);
                    }
                    return {
                        parts: newParts2
                    };
                }
            case "filterProduct":
                {
                    const { payload: payload2  } = action;
                    const persona = (0,helper/* getUserPersona */.shu)();
                    let sortedData;
                    switch(payload2){
                        case "asc":
                            sortedData = sortByName(state, "asc");
                            break;
                        case "desc":
                            sortedData = sortByName(state, "desc");
                            break;
                        case "descPrice":
                            sortedData = sortByPriceDesc(state, persona);
                            break;
                        case "ascPrice":
                            sortedData = sortByPrice(state, persona, "asc");
                            break;
                    }
                    return {
                        parts: sortedData
                    };
                }
            case "fetchForCpiPromise":
                {
                    const { payload: payload3  } = action;
                    const newParts3 = [];
                    let arraylength = 0;
                    for (const item1 of state.parts){
                        arraylength = newParts3 === null || newParts3 === void 0 ? void 0 : newParts3.length;
                        if (item1.ctApiPromise === null && arraylength < payload3) {
                            newParts3.push({
                                ...item1,
                                ctApiPromise: fetchCTRequest(item1.partApi, item1 === null || item1 === void 0 ? void 0 : item1.prices)
                            });
                        } else newParts3.push(item1);
                    }
                    return {
                        parts: newParts3
                    };
                }
            default:
                throw new Error("default");
        }
    } catch (e) {
        return e;
    }
};
/* harmony default export */ var partReducer = (partsReducer);
const sortByName = (state, order)=>{
    switch(order){
        case "desc":
            return state.parts.sort((a, b)=>{
                var ref, ref1, ref2, ref3;
                if ((a === null || a === void 0 ? void 0 : (ref = a.partApi) === null || ref === void 0 ? void 0 : ref.Name) < (b === null || b === void 0 ? void 0 : (ref1 = b.partApi) === null || ref1 === void 0 ? void 0 : ref1.Name)) return 1;
                if ((a === null || a === void 0 ? void 0 : (ref2 = a.partApi) === null || ref2 === void 0 ? void 0 : ref2.Name) > (b === null || b === void 0 ? void 0 : (ref3 = b.partApi) === null || ref3 === void 0 ? void 0 : ref3.Name)) return -1;
                return 0;
            });
        case "asc":
            return state.parts.sort((a, b)=>{
                var ref, ref1, ref2, ref3;
                if (((ref = a.partApi) === null || ref === void 0 ? void 0 : ref.Name) > ((ref1 = b.partApi) === null || ref1 === void 0 ? void 0 : ref1.Name)) return 1;
                if (((ref2 = a.partApi) === null || ref2 === void 0 ? void 0 : ref2.Name) < ((ref3 = b.partApi) === null || ref3 === void 0 ? void 0 : ref3.Name)) return -1;
                return 0;
            });
    }
};
const sortByPrice = function(state, persona) {
    let order = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "asc";
    state.parts.map((part)=>{
        return {
            ...part,
            prices: part.prices.sort((a, b)=>{
                var ref, ref1;
                return ((ref = a === null || a === void 0 ? void 0 : a.prices[persona]) === null || ref === void 0 ? void 0 : ref.centAmount) - ((ref1 = b === null || b === void 0 ? void 0 : b.prices[persona]) === null || ref1 === void 0 ? void 0 : ref1.centAmount);
            })
        };
    });
    const sortingPrice = personaPriceSort(persona);
    return state.parts.sort((a, b)=>a.partApi[sortingPrice] - b.partApi[sortingPrice]);
};
const sortByPriceDesc = (state, persona)=>{
    state.parts.map((part)=>{
        return {
            ...part,
            prices: part.prices.sort((a, b)=>{
                var ref, ref1;
                return ((ref = b === null || b === void 0 ? void 0 : b.prices[persona]) === null || ref === void 0 ? void 0 : ref.centAmount) - ((ref1 = a === null || a === void 0 ? void 0 : a.prices[persona]) === null || ref1 === void 0 ? void 0 : ref1.centAmount);
            })
        };
    });
    const sortingPrice = personaPriceSort(persona);
    return state.parts.sort((a, b)=>b.partApi[sortingPrice] - a.partApi[sortingPrice]);
};
const getActions = (state, dispatch)=>{
    return {
        initPartsList: (payload)=>dispatch({
                type: "initPartsList",
                payload
            }),
        fetchCT: (payload)=>dispatch({
                type: "fetchCT",
                payload
            }),
        fetchCTAny: (payload)=>dispatch({
                type: "fetchCTAny",
                payload
            }),
        filterProduct: (payload)=>dispatch({
                type: "filterProduct",
                payload
            }),
        fetchForCpiPromise: (payload)=>dispatch({
                type: "fetchForCpiPromise",
                payload
            }),
        get: {
            readyEntries: ()=>{
                var ref;
                return state === null || state === void 0 ? void 0 : (ref = state.parts) === null || ref === void 0 ? void 0 : ref.filter((item)=>{
                    return (item === null || item === void 0 ? void 0 : item.ctApiPromise) !== null;
                });
            },
            firstEntries: (key)=>{
                var ref;
                var ref1;
                return (ref = ((ref1 = state === null || state === void 0 ? void 0 : state.parts) !== null && ref1 !== void 0 ? ref1 : []).filter((item)=>{
                    return (item === null || item === void 0 ? void 0 : item.ctApiPromise) !== null;
                })) === null || ref === void 0 ? void 0 : ref.splice(0, key);
            },
            entryByKey: (key)=>{
                var ref, ref1;
                const data = (ref1 = state === null || state === void 0 ? void 0 : (ref = state.parts) === null || ref === void 0 ? void 0 : ref.filter((item)=>{
                    return (item === null || item === void 0 ? void 0 : item.key) === key;
                })) === null || ref1 === void 0 ? void 0 : ref1[0];
                if ((data === null || data === void 0 ? void 0 : data.ctApiPromise) === null) {
                    return {
                        ...data,
                        ctApiPromise: fetchCTRequest(data === null || data === void 0 ? void 0 : data.partApi, data === null || data === void 0 ? void 0 : data.prices)
                    };
                }
                return data;
            }
        }
    };
};
const fetchCTRequest = async (args, prices)=>{
    try {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12;
        const docs = await getSearchDetails(args, prices);
        const data = {
            ...args,
            productDiscontinue: Date.parse((ref = docs[0]) === null || ref === void 0 ? void 0 : ref.productDiscontinuedDate_dt) < Date.now(),
            productIdKey: (docs === null || docs === void 0 ? void 0 : (ref1 = docs[0]) === null || ref1 === void 0 ? void 0 : ref1["ProductNoSpecialKeyword"]) ? docs === null || docs === void 0 ? void 0 : (ref2 = docs[0]) === null || ref2 === void 0 ? void 0 : ref2["ProductNoSpecialKeyword"] : docs === null || docs === void 0 ? void 0 : (ref3 = docs[0]) === null || ref3 === void 0 ? void 0 : ref3["CustomerFacingSKU_s"],
            imageUrl: ((ref7 = docs === null || docs === void 0 ? void 0 : (ref4 = docs[0]) === null || ref4 === void 0 ? void 0 : (ref5 = ref4["Color.KEMP.Details_ss"]) === null || ref5 === void 0 ? void 0 : (ref6 = ref5[0]) === null || ref6 === void 0 ? void 0 : ref6.split("||")) === null || ref7 === void 0 ? void 0 : ref7[1]) ? (ref8 = docs[0]["Color.KEMP.Details_ss"][0]) === null || ref8 === void 0 ? void 0 : ref8.split("||")[1] : null,
            activeItem: (ref12 = docs === null || docs === void 0 ? void 0 : (ref9 = docs[0]) === null || ref9 === void 0 ? void 0 : (ref10 = ref9["Color.KEMP.Details_ss"]) === null || ref10 === void 0 ? void 0 : (ref11 = ref10[0]) === null || ref11 === void 0 ? void 0 : ref11.split("||")[0]) === null || ref12 === void 0 ? void 0 : ref12.split("|")[0],
            data: docs[0]
        };
        return data;
    } catch (err) {
        return err;
    }
};
const getSearchDetails = async (args, prices)=>{
    const { slug  } = args;
    const resp = await (0,ct_service/* getSearchPDP */.Do)(slug);
    const persona = (0,helper/* getUserPersona */.shu)();
    const { data: { response: { docs  }  }  } = resp;
    if (docs.length !== 0) {
        var ref, ref1;
        docs[0].prices = prices;
        const varientDetails = getVarientDetails(docs[0]);
        const fieldType = (ref = varientDetails[0]) === null || ref === void 0 ? void 0 : ref.fieldType;
        const swatches = (ref1 = docs[0][fieldType]) === null || ref1 === void 0 ? void 0 : ref1.map((val, i)=>{
            var ref, ref1, ref2, ref3, ref4, ref5;
            let price = 0;
            let pricelist = 0;
            let currencyCode = "USD";
            let currencySign = "$";
            const [label, swatch, id, , , value] = val.split("|");
            const sortPrice = (ref = docs[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.prices) === null || ref1 === void 0 ? void 0 : ref1.filter((val)=>{
                return (val === null || val === void 0 ? void 0 : val.sku) === id;
            })[0];
            currencyCode = (ref2 = sortPrice === null || sortPrice === void 0 ? void 0 : sortPrice.prices[persona]) === null || ref2 === void 0 ? void 0 : ref2.currencyCode;
            currencySign = sortPrice === null || sortPrice === void 0 ? void 0 : sortPrice.currencySign;
            const centPrice = (ref3 = sortPrice === null || sortPrice === void 0 ? void 0 : sortPrice.prices[persona]) === null || ref3 === void 0 ? void 0 : ref3.centAmount;
            const discountedPrice = (sortPrice === null || sortPrice === void 0 ? void 0 : sortPrice.discountPrices) && Object.values(sortPrice.discountPrices).length ? Number(((ref4 = sortPrice === null || sortPrice === void 0 ? void 0 : sortPrice.discountPrices[persona]) === null || ref4 === void 0 ? void 0 : ref4.centAmount) / 100).toFixed(2) : null;
            pricelist = Number(((ref5 = sortPrice === null || sortPrice === void 0 ? void 0 : sortPrice.prices["ANY"]) === null || ref5 === void 0 ? void 0 : ref5.centAmount) / 100).toFixed(2);
            price = Number(centPrice / 100).toFixed(2);
            const colorBaseUrl = constants["default"].COLOR_FILE_URL;
            const colorUrl = colorBaseUrl + swatch;
            const imgUrl = docs[0]["productImages.url_ss"] ? docs[0]["productImages.url_ss"][0] : null;
            return {
                checked: false,
                colorUrl,
                discontinuedColor: false,
                id,
                label,
                name: "product-color",
                notApplicable: false,
                value,
                price,
                pricelist,
                currencyCode,
                currencySign,
                imgUrl,
                centPrice,
                discountedPrice
            };
        });
        docs[0].colorData = swatches;
        docs[0].varientDetails = varientDetails;
        return docs;
    } else return docs;
};
const getVarientDetails = (data)=>{
    if (data["Color.SKU.Details_ss"]) {
        return data["Color.SKU.Details_ss"].map((color)=>{
            const d = color.split("|");
            return {
                name: d[0],
                swatch: d[1],
                sku: d[2],
                isStock: d[3],
                discontinued: !(d[4] === "false" || Date.parse(d[4]) > Date.now()),
                customerSku: d[5],
                fieldType: "Color.SKU.Details_ss"
            };
        });
    }
};
const personaPriceSort = (persona)=>{
    switch(persona){
        case "GST":
            return "guestPrice";
        case "CTR":
            return "ctrPrice";
        case "FF":
            return "ffPrice";
        case "KEMP":
            return "kemprPrice";
        case "TPR":
            return "tprPrice";
        case "TVR":
            return "tvrPrice";
        default:
            return "guestPrice";
    }
};

;// CONCATENATED MODULE: ./node_modules/react-zoom-pan-pinch/dist/index.esm.js


/**
 * Rounds number to given decimal
 * eg. roundNumber(2.34343, 1) => 2.3
 */
var roundNumber = function (num, decimal) {
    return Number(num.toFixed(decimal));
};
/**
 * Checks if value is number, if not it returns default value
 * 1# eg. checkIsNumber(2, 30) => 2
 * 2# eg. checkIsNumber(null, 30) => 30
 */
var checkIsNumber = function (num, defaultValue) {
    return typeof num === "number" ? num : defaultValue;
};

var handleCallback = function (context, event, callback) {
    if (callback && typeof callback === "function") {
        callback(context, event);
    }
};

/* eslint-disable no-plusplus */
/* eslint-disable no-param-reassign */
/**
 * Functions should return denominator of the target value, which is the next animation step.
 * t is a value from 0 to 1, reflecting the percentage of animation status.
 */
var easeOut = function (t) {
    return -Math.cos(t * Math.PI) / 2 + 0.5;
};
// linear
var linear = function (t) {
    return t;
};
// accelerating from zero velocity
var easeInQuad = function (t) {
    return t * t;
};
// decelerating to zero velocity
var easeOutQuad = function (t) {
    return t * (2 - t);
};
// acceleration until halfway, then deceleration
var easeInOutQuad = function (t) {
    return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
};
// accelerating from zero velocity
var easeInCubic = function (t) {
    return t * t * t;
};
// decelerating to zero velocity
var easeOutCubic = function (t) {
    return --t * t * t + 1;
};
// acceleration until halfway, then deceleration
var easeInOutCubic = function (t) {
    return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
};
// accelerating from zero velocity
var easeInQuart = function (t) {
    return t * t * t * t;
};
// decelerating to zero velocity
var easeOutQuart = function (t) {
    return 1 - --t * t * t * t;
};
// acceleration until halfway, then deceleration
var easeInOutQuart = function (t) {
    return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
};
// accelerating from zero velocity
var easeInQuint = function (t) {
    return t * t * t * t * t;
};
// decelerating to zero velocity
var easeOutQuint = function (t) {
    return 1 + --t * t * t * t * t;
};
// acceleration until halfway, then deceleration
var easeInOutQuint = function (t) {
    return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
};
var animations = {
    easeOut: easeOut,
    linear: linear,
    easeInQuad: easeInQuad,
    easeOutQuad: easeOutQuad,
    easeInOutQuad: easeInOutQuad,
    easeInCubic: easeInCubic,
    easeOutCubic: easeOutCubic,
    easeInOutCubic: easeInOutCubic,
    easeInQuart: easeInQuart,
    easeOutQuart: easeOutQuart,
    easeInOutQuart: easeInOutQuart,
    easeInQuint: easeInQuint,
    easeOutQuint: easeOutQuint,
    easeInOutQuint: easeInOutQuint,
};

/* eslint-disable no-param-reassign */
var handleCancelAnimationFrame = function (animation) {
    if (typeof animation === "number") {
        cancelAnimationFrame(animation);
    }
};
var handleCancelAnimation = function (contextInstance) {
    if (!contextInstance.mounted)
        return;
    handleCancelAnimationFrame(contextInstance.animation);
    // Clear animation state
    contextInstance.animate = false;
    contextInstance.animation = null;
    contextInstance.velocity = null;
};
function handleSetupAnimation(contextInstance, animationName, animationTime, callback) {
    if (!contextInstance.mounted)
        return;
    var startTime = new Date().getTime();
    var lastStep = 1;
    // if another animation is active
    handleCancelAnimation(contextInstance);
    // new animation
    contextInstance.animation = function () {
        if (!contextInstance.mounted) {
            return handleCancelAnimationFrame(contextInstance.animation);
        }
        var frameTime = new Date().getTime() - startTime;
        var animationProgress = frameTime / animationTime;
        var animationType = animations[animationName];
        var step = animationType(animationProgress);
        if (frameTime >= animationTime) {
            callback(lastStep);
            contextInstance.animation = null;
        }
        else if (contextInstance.animation) {
            callback(step);
            requestAnimationFrame(contextInstance.animation);
        }
    };
    requestAnimationFrame(contextInstance.animation);
}
function isValidTargetState(targetState) {
    var scale = targetState.scale, positionX = targetState.positionX, positionY = targetState.positionY;
    if (Number.isNaN(scale) ||
        Number.isNaN(positionX) ||
        Number.isNaN(positionY)) {
        return false;
    }
    return true;
}
function animate(contextInstance, targetState, animationTime, animationName) {
    var isValid = isValidTargetState(targetState);
    if (!contextInstance.mounted || !isValid)
        return;
    var setTransformState = contextInstance.setTransformState;
    var _a = contextInstance.transformState, scale = _a.scale, positionX = _a.positionX, positionY = _a.positionY;
    var scaleDiff = targetState.scale - scale;
    var positionXDiff = targetState.positionX - positionX;
    var positionYDiff = targetState.positionY - positionY;
    if (animationTime === 0) {
        setTransformState(targetState.scale, targetState.positionX, targetState.positionY);
    }
    else {
        // animation start timestamp
        handleSetupAnimation(contextInstance, animationName, animationTime, function (step) {
            var newScale = scale + scaleDiff * step;
            var newPositionX = positionX + positionXDiff * step;
            var newPositionY = positionY + positionYDiff * step;
            setTransformState(newScale, newPositionX, newPositionY);
        });
    }
}

/* eslint-disable no-param-reassign */
function getComponentsSizes(wrapperComponent, contentComponent, newScale) {
    var wrapperWidth = wrapperComponent.offsetWidth;
    var wrapperHeight = wrapperComponent.offsetHeight;
    var contentWidth = contentComponent.offsetWidth;
    var contentHeight = contentComponent.offsetHeight;
    var newContentWidth = contentWidth * newScale;
    var newContentHeight = contentHeight * newScale;
    var newDiffWidth = wrapperWidth - newContentWidth;
    var newDiffHeight = wrapperHeight - newContentHeight;
    return {
        wrapperWidth: wrapperWidth,
        wrapperHeight: wrapperHeight,
        newContentWidth: newContentWidth,
        newDiffWidth: newDiffWidth,
        newContentHeight: newContentHeight,
        newDiffHeight: newDiffHeight,
    };
}
var getBounds = function (wrapperWidth, newContentWidth, diffWidth, wrapperHeight, newContentHeight, diffHeight, centerZoomedOut) {
    var scaleWidthFactor = wrapperWidth > newContentWidth
        ? diffWidth * (centerZoomedOut ? 1 : 0.5)
        : 0;
    var scaleHeightFactor = wrapperHeight > newContentHeight
        ? diffHeight * (centerZoomedOut ? 1 : 0.5)
        : 0;
    var minPositionX = wrapperWidth - newContentWidth - scaleWidthFactor;
    var maxPositionX = scaleWidthFactor;
    var minPositionY = wrapperHeight - newContentHeight - scaleHeightFactor;
    var maxPositionY = scaleHeightFactor;
    return { minPositionX: minPositionX, maxPositionX: maxPositionX, minPositionY: minPositionY, maxPositionY: maxPositionY };
};
var calculateBounds = function (contextInstance, newScale) {
    var wrapperComponent = contextInstance.wrapperComponent, contentComponent = contextInstance.contentComponent;
    var centerZoomedOut = contextInstance.setup.centerZoomedOut;
    if (!wrapperComponent || !contentComponent) {
        throw new Error("Components are not mounted");
    }
    var _a = getComponentsSizes(wrapperComponent, contentComponent, newScale), wrapperWidth = _a.wrapperWidth, wrapperHeight = _a.wrapperHeight, newContentWidth = _a.newContentWidth, newDiffWidth = _a.newDiffWidth, newContentHeight = _a.newContentHeight, newDiffHeight = _a.newDiffHeight;
    var bounds = getBounds(wrapperWidth, newContentWidth, newDiffWidth, wrapperHeight, newContentHeight, newDiffHeight, Boolean(centerZoomedOut));
    return bounds;
};
/**
 * Keeps value between given bounds, used for limiting view to given boundaries
 * 1# eg. boundLimiter(2, 0, 3, true) => 2
 * 2# eg. boundLimiter(4, 0, 3, true) => 3
 * 3# eg. boundLimiter(-2, 0, 3, true) => 0
 * 4# eg. boundLimiter(10, 0, 3, false) => 10
 */
var boundLimiter = function (value, minBound, maxBound, isActive) {
    if (!isActive)
        return roundNumber(value, 2);
    if (value < minBound)
        return roundNumber(minBound, 2);
    if (value > maxBound)
        return roundNumber(maxBound, 2);
    return roundNumber(value, 2);
};
var handleCalculateBounds = function (contextInstance, newScale) {
    var bounds = calculateBounds(contextInstance, newScale);
    // Save bounds
    contextInstance.bounds = bounds;
    return bounds;
};
function getMouseBoundedPosition(positionX, positionY, bounds, limitToBounds, paddingValueX, paddingValueY, wrapperComponent) {
    var minPositionX = bounds.minPositionX, minPositionY = bounds.minPositionY, maxPositionX = bounds.maxPositionX, maxPositionY = bounds.maxPositionY;
    var paddingX = 0;
    var paddingY = 0;
    if (wrapperComponent) {
        paddingX = paddingValueX;
        paddingY = paddingValueY;
    }
    var x = boundLimiter(positionX, minPositionX - paddingX, maxPositionX + paddingX, limitToBounds);
    var y = boundLimiter(positionY, minPositionY - paddingY, maxPositionY + paddingY, limitToBounds);
    return { x: x, y: y };
}

function handleCalculateZoomPositions(contextInstance, mouseX, mouseY, newScale, bounds, limitToBounds) {
    var _a = contextInstance.transformState, scale = _a.scale, positionX = _a.positionX, positionY = _a.positionY;
    var scaleDifference = newScale - scale;
    if (typeof mouseX !== "number" || typeof mouseY !== "number") {
        console.error("Mouse X and Y position were not provided!");
        return { x: positionX, y: positionY };
    }
    var calculatedPositionX = positionX - mouseX * scaleDifference;
    var calculatedPositionY = positionY - mouseY * scaleDifference;
    // do not limit to bounds when there is padding animation,
    // it causes animation strange behaviour
    var newPositions = getMouseBoundedPosition(calculatedPositionX, calculatedPositionY, bounds, limitToBounds, 0, 0, null);
    return newPositions;
}
function checkZoomBounds(zoom, minScale, maxScale, zoomPadding, enablePadding) {
    var scalePadding = enablePadding ? zoomPadding : 0;
    var minScaleWithPadding = minScale - scalePadding;
    if (!Number.isNaN(maxScale) && zoom >= maxScale)
        return maxScale;
    if (!Number.isNaN(minScale) && zoom <= minScaleWithPadding)
        return minScaleWithPadding;
    return zoom;
}

var isPanningStartAllowed = function (contextInstance, event) {
    var excluded = contextInstance.setup.panning.excluded;
    var isInitialized = contextInstance.isInitialized, wrapperComponent = contextInstance.wrapperComponent;
    var target = event.target;
    var targetIsShadowDom = "shadowRoot" in target && "composedPath" in event;
    var isWrapperChild = targetIsShadowDom
        ? event.composedPath().some(function (el) {
            if (!(el instanceof Element)) {
                return false;
            }
            return wrapperComponent === null || wrapperComponent === void 0 ? void 0 : wrapperComponent.contains(el);
        })
        : wrapperComponent === null || wrapperComponent === void 0 ? void 0 : wrapperComponent.contains(target);
    var isAllowed = isInitialized && target && isWrapperChild;
    if (!isAllowed)
        return false;
    var isExcluded = isExcludedNode(target, excluded);
    if (isExcluded)
        return false;
    return true;
};
var isPanningAllowed = function (contextInstance) {
    var isInitialized = contextInstance.isInitialized, isPanning = contextInstance.isPanning, setup = contextInstance.setup;
    var disabled = setup.panning.disabled;
    var isAllowed = isInitialized && isPanning && !disabled;
    if (!isAllowed)
        return false;
    return true;
};
var handlePanningSetup = function (contextInstance, event) {
    var _a = contextInstance.transformState, positionX = _a.positionX, positionY = _a.positionY;
    contextInstance.isPanning = true;
    // Panning with mouse
    var x = event.clientX;
    var y = event.clientY;
    contextInstance.startCoords = { x: x - positionX, y: y - positionY };
};
var handleTouchPanningSetup = function (contextInstance, event) {
    var touches = event.touches;
    var _a = contextInstance.transformState, positionX = _a.positionX, positionY = _a.positionY;
    contextInstance.isPanning = true;
    // Panning with touch
    var oneFingerTouch = touches.length === 1;
    if (oneFingerTouch) {
        var x = touches[0].clientX;
        var y = touches[0].clientY;
        contextInstance.startCoords = { x: x - positionX, y: y - positionY };
    }
};
function handlePanToBounds(contextInstance) {
    var _a = contextInstance.transformState, positionX = _a.positionX, positionY = _a.positionY, scale = _a.scale;
    var _b = contextInstance.setup, disabled = _b.disabled, limitToBounds = _b.limitToBounds, centerZoomedOut = _b.centerZoomedOut;
    var wrapperComponent = contextInstance.wrapperComponent;
    if (disabled || !wrapperComponent || !contextInstance.bounds)
        return;
    var _c = contextInstance.bounds, maxPositionX = _c.maxPositionX, minPositionX = _c.minPositionX, maxPositionY = _c.maxPositionY, minPositionY = _c.minPositionY;
    var xChanged = positionX > maxPositionX || positionX < minPositionX;
    var yChanged = positionY > maxPositionY || positionY < minPositionY;
    var mousePosX = positionX > maxPositionX
        ? wrapperComponent.offsetWidth
        : contextInstance.setup.minPositionX || 0;
    var mousePosY = positionY > maxPositionY
        ? wrapperComponent.offsetHeight
        : contextInstance.setup.minPositionY || 0;
    var _d = handleCalculateZoomPositions(contextInstance, mousePosX, mousePosY, scale, contextInstance.bounds, limitToBounds || centerZoomedOut), x = _d.x, y = _d.y;
    return {
        scale: scale,
        positionX: xChanged ? x : positionX,
        positionY: yChanged ? y : positionY,
    };
}
function handleNewPosition(contextInstance, newPositionX, newPositionY, paddingValueX, paddingValueY) {
    var limitToBounds = contextInstance.setup.limitToBounds;
    var wrapperComponent = contextInstance.wrapperComponent, bounds = contextInstance.bounds;
    var _a = contextInstance.transformState, scale = _a.scale, positionX = _a.positionX, positionY = _a.positionY;
    if (wrapperComponent === null ||
        bounds === null ||
        (newPositionX === positionX && newPositionY === positionY)) {
        return;
    }
    var _b = getMouseBoundedPosition(newPositionX, newPositionY, bounds, limitToBounds, paddingValueX, paddingValueY, wrapperComponent), x = _b.x, y = _b.y;
    contextInstance.setTransformState(scale, x, y);
}
var getPanningClientPosition = function (contextInstance, clientX, clientY) {
    var startCoords = contextInstance.startCoords, transformState = contextInstance.transformState;
    var panning = contextInstance.setup.panning;
    var lockAxisX = panning.lockAxisX, lockAxisY = panning.lockAxisY;
    var positionX = transformState.positionX, positionY = transformState.positionY;
    if (!startCoords) {
        return { x: positionX, y: positionY };
    }
    var mouseX = clientX - startCoords.x;
    var mouseY = clientY - startCoords.y;
    var newPositionX = lockAxisX ? positionX : mouseX;
    var newPositionY = lockAxisY ? positionY : mouseY;
    return { x: newPositionX, y: newPositionY };
};
var getPaddingValue = function (contextInstance, size) {
    var setup = contextInstance.setup, transformState = contextInstance.transformState;
    var scale = transformState.scale;
    var minScale = setup.minScale, disablePadding = setup.disablePadding;
    if (size > 0 && scale >= minScale && !disablePadding) {
        return size;
    }
    return 0;
};

var isVelocityCalculationAllowed = function (contextInstance) {
    var mounted = contextInstance.mounted;
    var _a = contextInstance.setup, disabled = _a.disabled, velocityAnimation = _a.velocityAnimation;
    var scale = contextInstance.transformState.scale;
    var disabledVelocity = velocityAnimation.disabled;
    var isAllowed = !disabledVelocity || scale > 1 || !disabled || mounted;
    if (!isAllowed)
        return false;
    return true;
};
var isVelocityAllowed = function (contextInstance) {
    var mounted = contextInstance.mounted, velocity = contextInstance.velocity, bounds = contextInstance.bounds;
    var _a = contextInstance.setup, disabled = _a.disabled, velocityAnimation = _a.velocityAnimation;
    var scale = contextInstance.transformState.scale;
    var disabledVelocity = velocityAnimation.disabled;
    var isAllowed = !disabledVelocity || scale > 1 || !disabled || mounted;
    if (!isAllowed)
        return false;
    if (!velocity || !bounds)
        return false;
    return true;
};
function getVelocityMoveTime(contextInstance, velocity) {
    var velocityAnimation = contextInstance.setup.velocityAnimation;
    var equalToMove = velocityAnimation.equalToMove, animationTime = velocityAnimation.animationTime, sensitivity = velocityAnimation.sensitivity;
    if (equalToMove) {
        return animationTime * velocity * sensitivity;
    }
    return animationTime;
}
function getVelocityPosition(newPosition, startPosition, currentPosition, isLocked, limitToBounds, minPosition, maxPosition, minTarget, maxTarget, step) {
    if (limitToBounds) {
        if (startPosition > maxPosition && currentPosition > maxPosition) {
            var calculatedPosition = maxPosition + (newPosition - maxPosition) * step;
            if (calculatedPosition > maxTarget)
                return maxTarget;
            if (calculatedPosition < maxPosition)
                return maxPosition;
            return calculatedPosition;
        }
        if (startPosition < minPosition && currentPosition < minPosition) {
            var calculatedPosition = minPosition + (newPosition - minPosition) * step;
            if (calculatedPosition < minTarget)
                return minTarget;
            if (calculatedPosition > minPosition)
                return minPosition;
            return calculatedPosition;
        }
    }
    if (isLocked)
        return startPosition;
    return boundLimiter(newPosition, minPosition, maxPosition, limitToBounds);
}

function getSizeMultiplier(wrapperComponent, equalToMove) {
    var defaultMultiplier = 1;
    if (equalToMove) {
        return Math.min(defaultMultiplier, wrapperComponent.offsetWidth / window.innerWidth);
    }
    return defaultMultiplier;
}
function handleCalculateVelocity(contextInstance, position) {
    var isAllowed = isVelocityCalculationAllowed(contextInstance);
    if (!isAllowed) {
        return;
    }
    var lastMousePosition = contextInstance.lastMousePosition, velocityTime = contextInstance.velocityTime, setup = contextInstance.setup;
    var wrapperComponent = contextInstance.wrapperComponent;
    var equalToMove = setup.velocityAnimation.equalToMove;
    var now = Date.now();
    if (lastMousePosition && velocityTime && wrapperComponent) {
        var sizeMultiplier = getSizeMultiplier(wrapperComponent, equalToMove);
        var distanceX = position.x - lastMousePosition.x;
        var distanceY = position.y - lastMousePosition.y;
        var velocityX = distanceX / sizeMultiplier;
        var velocityY = distanceY / sizeMultiplier;
        var interval = now - velocityTime;
        var speed = distanceX * distanceX + distanceY * distanceY;
        var velocity = Math.sqrt(speed) / interval;
        contextInstance.velocity = { velocityX: velocityX, velocityY: velocityY, total: velocity };
    }
    contextInstance.lastMousePosition = position;
    contextInstance.velocityTime = now;
}
function handleVelocityPanning(contextInstance) {
    var velocity = contextInstance.velocity, bounds = contextInstance.bounds, setup = contextInstance.setup, wrapperComponent = contextInstance.wrapperComponent;
    var isAllowed = isVelocityAllowed(contextInstance);
    if (!isAllowed || !velocity || !bounds || !wrapperComponent) {
        return;
    }
    var velocityX = velocity.velocityX, velocityY = velocity.velocityY, total = velocity.total;
    var maxPositionX = bounds.maxPositionX, minPositionX = bounds.minPositionX, maxPositionY = bounds.maxPositionY, minPositionY = bounds.minPositionY;
    var limitToBounds = setup.limitToBounds, alignmentAnimation = setup.alignmentAnimation;
    var zoomAnimation = setup.zoomAnimation, panning = setup.panning;
    var lockAxisY = panning.lockAxisY, lockAxisX = panning.lockAxisX;
    var animationType = zoomAnimation.animationType;
    var sizeX = alignmentAnimation.sizeX, sizeY = alignmentAnimation.sizeY, velocityAlignmentTime = alignmentAnimation.velocityAlignmentTime;
    var alignAnimationTime = velocityAlignmentTime;
    var moveAnimationTime = getVelocityMoveTime(contextInstance, total);
    var finalAnimationTime = Math.max(moveAnimationTime, alignAnimationTime);
    var paddingValueX = getPaddingValue(contextInstance, sizeX);
    var paddingValueY = getPaddingValue(contextInstance, sizeY);
    var paddingX = (paddingValueX * wrapperComponent.offsetWidth) / 100;
    var paddingY = (paddingValueY * wrapperComponent.offsetHeight) / 100;
    var maxTargetX = maxPositionX + paddingX;
    var minTargetX = minPositionX - paddingX;
    var maxTargetY = maxPositionY + paddingY;
    var minTargetY = minPositionY - paddingY;
    var startState = contextInstance.transformState;
    var startTime = new Date().getTime();
    handleSetupAnimation(contextInstance, animationType, finalAnimationTime, function (step) {
        var _a = contextInstance.transformState, scale = _a.scale, positionX = _a.positionX, positionY = _a.positionY;
        var frameTime = new Date().getTime() - startTime;
        var animationProgress = frameTime / alignAnimationTime;
        var alignAnimation = animations[alignmentAnimation.animationType];
        var alignStep = 1 - alignAnimation(Math.min(1, animationProgress));
        var customStep = 1 - step;
        var newPositionX = positionX + velocityX * customStep;
        var newPositionY = positionY + velocityY * customStep;
        var currentPositionX = getVelocityPosition(newPositionX, startState.positionX, positionX, lockAxisX, limitToBounds, minPositionX, maxPositionX, minTargetX, maxTargetX, alignStep);
        var currentPositionY = getVelocityPosition(newPositionY, startState.positionY, positionY, lockAxisY, limitToBounds, minPositionY, maxPositionY, minTargetY, maxTargetY, alignStep);
        if (positionX !== newPositionX || positionY !== newPositionY) {
            contextInstance.setTransformState(scale, currentPositionX, currentPositionY);
        }
    });
}

function handlePanningStart(contextInstance, event) {
    var scale = contextInstance.transformState.scale;
    handleCancelAnimation(contextInstance);
    handleCalculateBounds(contextInstance, scale);
    if (window.TouchEvent !== undefined && event instanceof TouchEvent) {
        handleTouchPanningSetup(contextInstance, event);
    }
    else {
        handlePanningSetup(contextInstance, event);
    }
}
function handleAlignToBounds(contextInstance) {
    var scale = contextInstance.transformState.scale;
    var _a = contextInstance.setup, minScale = _a.minScale, alignmentAnimation = _a.alignmentAnimation;
    var disabled = alignmentAnimation.disabled, sizeX = alignmentAnimation.sizeX, sizeY = alignmentAnimation.sizeY, animationTime = alignmentAnimation.animationTime, animationType = alignmentAnimation.animationType;
    var isDisabled = disabled || scale < minScale || (!sizeX && !sizeY);
    if (isDisabled)
        return;
    var targetState = handlePanToBounds(contextInstance);
    if (targetState) {
        animate(contextInstance, targetState, animationTime, animationType);
    }
}
function handlePanning(contextInstance, clientX, clientY) {
    var startCoords = contextInstance.startCoords, setup = contextInstance.setup;
    var _a = setup.alignmentAnimation, sizeX = _a.sizeX, sizeY = _a.sizeY;
    if (!startCoords)
        return;
    var _b = getPanningClientPosition(contextInstance, clientX, clientY), x = _b.x, y = _b.y;
    var paddingValueX = getPaddingValue(contextInstance, sizeX);
    var paddingValueY = getPaddingValue(contextInstance, sizeY);
    handleCalculateVelocity(contextInstance, { x: x, y: y });
    handleNewPosition(contextInstance, x, y, paddingValueX, paddingValueY);
}
function handlePanningEnd(contextInstance) {
    if (contextInstance.isPanning) {
        var velocityDisabled = contextInstance.setup.panning.velocityDisabled;
        var velocity = contextInstance.velocity, wrapperComponent = contextInstance.wrapperComponent, contentComponent = contextInstance.contentComponent;
        contextInstance.isPanning = false;
        contextInstance.animate = false;
        contextInstance.animation = null;
        var wrapperRect = wrapperComponent === null || wrapperComponent === void 0 ? void 0 : wrapperComponent.getBoundingClientRect();
        var contentRect = contentComponent === null || contentComponent === void 0 ? void 0 : contentComponent.getBoundingClientRect();
        var wrapperWidth = (wrapperRect === null || wrapperRect === void 0 ? void 0 : wrapperRect.width) || 0;
        var wrapperHeight = (wrapperRect === null || wrapperRect === void 0 ? void 0 : wrapperRect.height) || 0;
        var contentWidth = (contentRect === null || contentRect === void 0 ? void 0 : contentRect.width) || 0;
        var contentHeight = (contentRect === null || contentRect === void 0 ? void 0 : contentRect.height) || 0;
        var isZoomed = wrapperWidth < contentWidth || wrapperHeight < contentHeight;
        var shouldAnimate = !velocityDisabled && velocity && (velocity === null || velocity === void 0 ? void 0 : velocity.total) > 0.1 && isZoomed;
        if (shouldAnimate) {
            handleVelocityPanning(contextInstance);
        }
        else {
            handleAlignToBounds(contextInstance);
        }
    }
}

function handleZoomToPoint(contextInstance, scale, mouseX, mouseY) {
    var _a = contextInstance.setup, minScale = _a.minScale, maxScale = _a.maxScale, limitToBounds = _a.limitToBounds;
    var newScale = checkZoomBounds(roundNumber(scale, 2), minScale, maxScale, 0, false);
    var bounds = handleCalculateBounds(contextInstance, newScale);
    var _b = handleCalculateZoomPositions(contextInstance, mouseX, mouseY, newScale, bounds, limitToBounds), x = _b.x, y = _b.y;
    return { scale: newScale, positionX: x, positionY: y };
}
function handleAlignToScaleBounds(contextInstance, mousePositionX, mousePositionY) {
    var scale = contextInstance.transformState.scale;
    var wrapperComponent = contextInstance.wrapperComponent;
    var _a = contextInstance.setup, minScale = _a.minScale, limitToBounds = _a.limitToBounds, zoomAnimation = _a.zoomAnimation;
    var disabled = zoomAnimation.disabled, animationTime = zoomAnimation.animationTime, animationType = zoomAnimation.animationType;
    var isDisabled = disabled || scale >= minScale;
    if (scale >= 1 || limitToBounds) {
        // fire fit to bounds animation
        handleAlignToBounds(contextInstance);
    }
    if (isDisabled || !wrapperComponent || !contextInstance.mounted)
        return;
    var mouseX = mousePositionX || wrapperComponent.offsetWidth / 2;
    var mouseY = mousePositionY || wrapperComponent.offsetHeight / 2;
    var targetState = handleZoomToPoint(contextInstance, minScale, mouseX, mouseY);
    if (targetState) {
        animate(contextInstance, targetState, animationTime, animationType);
    }
}

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

var initialState = {
    previousScale: 1,
    scale: 1,
    positionX: 0,
    positionY: 0,
};
var initialSetup = {
    disabled: false,
    minPositionX: null,
    maxPositionX: null,
    minPositionY: null,
    maxPositionY: null,
    minScale: 1,
    maxScale: 8,
    limitToBounds: true,
    centerZoomedOut: false,
    centerOnInit: false,
    disablePadding: false,
    smooth: true,
    wheel: {
        step: 0.2,
        disabled: false,
        smoothStep: 0.001,
        wheelDisabled: false,
        touchPadDisabled: false,
        activationKeys: [],
        excluded: [],
    },
    panning: {
        disabled: false,
        velocityDisabled: false,
        lockAxisX: false,
        lockAxisY: false,
        allowLeftClickPan: true,
        allowMiddleClickPan: true,
        allowRightClickPan: true,
        wheelPanning: false,
        activationKeys: [],
        excluded: [],
    },
    pinch: {
        step: 5,
        disabled: false,
        excluded: [],
    },
    doubleClick: {
        disabled: false,
        step: 0.7,
        mode: "zoomIn",
        animationType: "easeOut",
        animationTime: 200,
        excluded: [],
    },
    zoomAnimation: {
        disabled: false,
        size: 0.4,
        animationTime: 200,
        animationType: "easeOut",
    },
    alignmentAnimation: {
        disabled: false,
        sizeX: 100,
        sizeY: 100,
        animationTime: 200,
        velocityAlignmentTime: 400,
        animationType: "easeOut",
    },
    velocityAnimation: {
        disabled: false,
        sensitivity: 1,
        animationTime: 400,
        animationType: "easeOut",
        equalToMove: true,
    },
};
var baseClasses = {
    wrapperClass: "react-transform-wrapper",
    contentClass: "react-transform-component",
};

var createState = function (props) {
    var _a, _b, _c, _d;
    return {
        previousScale: (_a = props.initialScale) !== null && _a !== void 0 ? _a : initialState.scale,
        scale: (_b = props.initialScale) !== null && _b !== void 0 ? _b : initialState.scale,
        positionX: (_c = props.initialPositionX) !== null && _c !== void 0 ? _c : initialState.positionX,
        positionY: (_d = props.initialPositionY) !== null && _d !== void 0 ? _d : initialState.positionY,
    };
};
var createSetup = function (props) {
    var newSetup = __assign({}, initialSetup);
    Object.keys(props).forEach(function (key) {
        var validValue = typeof props[key] !== "undefined";
        var validParameter = typeof initialSetup[key] !== "undefined";
        if (validParameter && validValue) {
            var dataType = Object.prototype.toString.call(initialSetup[key]);
            var isObject = dataType === "[object Object]";
            var isArray = dataType === "[object Array]";
            if (isObject) {
                newSetup[key] = __assign(__assign({}, initialSetup[key]), props[key]);
            }
            else if (isArray) {
                newSetup[key] = __spreadArray(__spreadArray([], initialSetup[key], true), props[key], true);
            }
            else {
                newSetup[key] = props[key];
            }
        }
    });
    return newSetup;
};

var handleCalculateButtonZoom = function (contextInstance, delta, step) {
    var scale = contextInstance.transformState.scale;
    var wrapperComponent = contextInstance.wrapperComponent, setup = contextInstance.setup;
    var maxScale = setup.maxScale, minScale = setup.minScale, zoomAnimation = setup.zoomAnimation, smooth = setup.smooth;
    var size = zoomAnimation.size;
    if (!wrapperComponent) {
        throw new Error("Wrapper is not mounted");
    }
    var targetScale = smooth
        ? scale * Math.exp(delta * step)
        : scale + delta * step;
    var newScale = checkZoomBounds(roundNumber(targetScale, 3), minScale, maxScale, size, false);
    return newScale;
};
function handleZoomToViewCenter(contextInstance, delta, step, animationTime, animationType) {
    var wrapperComponent = contextInstance.wrapperComponent;
    var _a = contextInstance.transformState, scale = _a.scale, positionX = _a.positionX, positionY = _a.positionY;
    if (!wrapperComponent)
        return console.error("No WrapperComponent found");
    var wrapperWidth = wrapperComponent.offsetWidth;
    var wrapperHeight = wrapperComponent.offsetHeight;
    var mouseX = (wrapperWidth / 2 - positionX) / scale;
    var mouseY = (wrapperHeight / 2 - positionY) / scale;
    var newScale = handleCalculateButtonZoom(contextInstance, delta, step);
    var targetState = handleZoomToPoint(contextInstance, newScale, mouseX, mouseY);
    if (!targetState) {
        return console.error("Error during zoom event. New transformation state was not calculated.");
    }
    animate(contextInstance, targetState, animationTime, animationType);
}
function resetTransformations(contextInstance, animationTime, animationType, onResetTransformation) {
    var setup = contextInstance.setup, wrapperComponent = contextInstance.wrapperComponent;
    var limitToBounds = setup.limitToBounds;
    var initialTransformation = createState(contextInstance.props);
    var _a = contextInstance.transformState, scale = _a.scale, positionX = _a.positionX, positionY = _a.positionY;
    if (!wrapperComponent)
        return;
    var newBounds = calculateBounds(contextInstance, initialTransformation.scale);
    var boundedPositions = getMouseBoundedPosition(initialTransformation.positionX, initialTransformation.positionY, newBounds, limitToBounds, 0, 0, wrapperComponent);
    var newState = {
        scale: initialTransformation.scale,
        positionX: boundedPositions.x,
        positionY: boundedPositions.y,
    };
    if (scale === initialTransformation.scale &&
        positionX === initialTransformation.positionX &&
        positionY === initialTransformation.positionY) {
        return;
    }
    onResetTransformation === null || onResetTransformation === void 0 ? void 0 : onResetTransformation();
    animate(contextInstance, newState, animationTime, animationType);
}
function getOffset(element, wrapper, content, state) {
    var offset = element.getBoundingClientRect();
    var wrapperOffset = wrapper.getBoundingClientRect();
    var contentOffset = content.getBoundingClientRect();
    var xOff = wrapperOffset.x * state.scale;
    var yOff = wrapperOffset.y * state.scale;
    return {
        x: (offset.x - contentOffset.x + xOff) / state.scale,
        y: (offset.y - contentOffset.y + yOff) / state.scale,
    };
}
function calculateZoomToNode(contextInstance, node, customZoom) {
    var wrapperComponent = contextInstance.wrapperComponent, contentComponent = contextInstance.contentComponent, transformState = contextInstance.transformState;
    var _a = contextInstance.setup, limitToBounds = _a.limitToBounds, minScale = _a.minScale, maxScale = _a.maxScale;
    if (!wrapperComponent || !contentComponent)
        return transformState;
    var wrapperRect = wrapperComponent.getBoundingClientRect();
    var nodeRect = node.getBoundingClientRect();
    var nodeOffset = getOffset(node, wrapperComponent, contentComponent, transformState);
    var nodeLeft = nodeOffset.x;
    var nodeTop = nodeOffset.y;
    var nodeWidth = nodeRect.width / transformState.scale;
    var nodeHeight = nodeRect.height / transformState.scale;
    var scaleX = wrapperComponent.offsetWidth / nodeWidth;
    var scaleY = wrapperComponent.offsetHeight / nodeHeight;
    var newScale = checkZoomBounds(customZoom || Math.min(scaleX, scaleY), minScale, maxScale, 0, false);
    var offsetX = (wrapperRect.width - nodeWidth * newScale) / 2;
    var offsetY = (wrapperRect.height - nodeHeight * newScale) / 2;
    var newPositionX = (wrapperRect.left - nodeLeft) * newScale + offsetX;
    var newPositionY = (wrapperRect.top - nodeTop) * newScale + offsetY;
    var bounds = calculateBounds(contextInstance, newScale);
    var _b = getMouseBoundedPosition(newPositionX, newPositionY, bounds, limitToBounds, 0, 0, wrapperComponent), x = _b.x, y = _b.y;
    return { positionX: x, positionY: y, scale: newScale };
}

var zoomIn = function (contextInstance) {
    return function (step, animationTime, animationType) {
        if (step === void 0) { step = 0.5; }
        if (animationTime === void 0) { animationTime = 300; }
        if (animationType === void 0) { animationType = "easeOut"; }
        handleZoomToViewCenter(contextInstance, 1, step, animationTime, animationType);
    };
};
var zoomOut = function (contextInstance) {
    return function (step, animationTime, animationType) {
        if (step === void 0) { step = 0.5; }
        if (animationTime === void 0) { animationTime = 300; }
        if (animationType === void 0) { animationType = "easeOut"; }
        handleZoomToViewCenter(contextInstance, -1, step, animationTime, animationType);
    };
};
var setTransform = function (contextInstance) {
    return function (newPositionX, newPositionY, newScale, animationTime, animationType) {
        if (animationTime === void 0) { animationTime = 300; }
        if (animationType === void 0) { animationType = "easeOut"; }
        var _a = contextInstance.transformState, positionX = _a.positionX, positionY = _a.positionY, scale = _a.scale;
        var wrapperComponent = contextInstance.wrapperComponent, contentComponent = contextInstance.contentComponent;
        var disabled = contextInstance.setup.disabled;
        if (disabled || !wrapperComponent || !contentComponent)
            return;
        var targetState = {
            positionX: Number.isNaN(newPositionX) ? positionX : newPositionX,
            positionY: Number.isNaN(newPositionY) ? positionY : newPositionY,
            scale: Number.isNaN(newScale) ? scale : newScale,
        };
        animate(contextInstance, targetState, animationTime, animationType);
    };
};
var resetTransform = function (contextInstance) {
    return function (animationTime, animationType) {
        if (animationTime === void 0) { animationTime = 200; }
        if (animationType === void 0) { animationType = "easeOut"; }
        resetTransformations(contextInstance, animationTime, animationType);
    };
};
var centerView = function (contextInstance) {
    return function (scale, animationTime, animationType) {
        if (animationTime === void 0) { animationTime = 200; }
        if (animationType === void 0) { animationType = "easeOut"; }
        var transformState = contextInstance.transformState, wrapperComponent = contextInstance.wrapperComponent, contentComponent = contextInstance.contentComponent;
        if (wrapperComponent && contentComponent) {
            var targetState = getCenterPosition(scale || transformState.scale, wrapperComponent, contentComponent);
            animate(contextInstance, targetState, animationTime, animationType);
        }
    };
};
var zoomToElement = function (contextInstance) {
    return function (node, scale, animationTime, animationType) {
        if (animationTime === void 0) { animationTime = 600; }
        if (animationType === void 0) { animationType = "easeOut"; }
        handleCancelAnimation(contextInstance);
        var wrapperComponent = contextInstance.wrapperComponent;
        var target = typeof node === "string" ? document.getElementById(node) : node;
        if (wrapperComponent && target && wrapperComponent.contains(target)) {
            var targetState = calculateZoomToNode(contextInstance, target, scale);
            animate(contextInstance, targetState, animationTime, animationType);
        }
    };
};

var getControls = function (contextInstance) {
    return {
        instance: contextInstance,
        zoomIn: zoomIn(contextInstance),
        zoomOut: zoomOut(contextInstance),
        setTransform: setTransform(contextInstance),
        resetTransform: resetTransform(contextInstance),
        centerView: centerView(contextInstance),
        zoomToElement: zoomToElement(contextInstance),
    };
};
var getState = function (contextInstance) {
    return {
        instance: contextInstance,
        state: contextInstance.transformState,
    };
};
var getContext = function (contextInstance) {
    var ref = {};
    Object.assign(ref, getState(contextInstance));
    Object.assign(ref, getControls(contextInstance));
    return ref;
};

// We want to make event listeners non-passive, and to do so have to check
// that browsers support EventListenerOptions in the first place.
// https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
var passiveSupported = false;
function makePassiveEventOption() {
    try {
        var options = {
            get passive() {
                // This function will be called when the browser
                //   attempts to access the passive property.
                passiveSupported = true;
                return false;
            },
        };
        return options;
    }
    catch (err) {
        passiveSupported = false;
        return passiveSupported;
    }
}

var matchPrefix = ".".concat(baseClasses.wrapperClass);
var isExcludedNode = function (node, excluded) {
    return excluded.some(function (exclude) {
        return node.matches("".concat(matchPrefix, " ").concat(exclude, ", ").concat(matchPrefix, " .").concat(exclude, ", ").concat(matchPrefix, " ").concat(exclude, " *, ").concat(matchPrefix, " .").concat(exclude, " *"));
    });
};
var cancelTimeout = function (timeout) {
    if (timeout) {
        clearTimeout(timeout);
    }
};

var getTransformStyles = function (x, y, scale) {
    // Standard translate prevents blurry svg on the safari
    return "translate(".concat(x, "px, ").concat(y, "px) scale(").concat(scale, ")");
};
var getMatrixTransformStyles = function (x, y, scale) {
    // The shorthand for matrix does not work for Safari hence the need to explicitly use matrix3d
    // Refer to https://developer.mozilla.org/en-US/docs/Web/CSS/transform-function/matrix
    var a = scale;
    var b = 0;
    var c = 0;
    var d = scale;
    var tx = x;
    var ty = y;
    return "matrix3d(".concat(a, ", ").concat(b, ", 0, 0, ").concat(c, ", ").concat(d, ", 0, 0, 0, 0, 1, 0, ").concat(tx, ", ").concat(ty, ", 0, 1)");
};
var getCenterPosition = function (scale, wrapperComponent, contentComponent) {
    var contentWidth = contentComponent.offsetWidth * scale;
    var contentHeight = contentComponent.offsetHeight * scale;
    var centerPositionX = (wrapperComponent.offsetWidth - contentWidth) / 2;
    var centerPositionY = (wrapperComponent.offsetHeight - contentHeight) / 2;
    return {
        scale: scale,
        positionX: centerPositionX,
        positionY: centerPositionY,
    };
};

function index_esm_mergeRefs(refs) {
    return function (value) {
        refs.forEach(function (ref) {
            if (typeof ref === "function") {
                ref(value);
            }
            else if (ref != null) {
                ref.current = value;
            }
        });
    };
}

var isWheelAllowed = function (contextInstance, event) {
    var _a = contextInstance.setup.wheel, disabled = _a.disabled, wheelDisabled = _a.wheelDisabled, touchPadDisabled = _a.touchPadDisabled, excluded = _a.excluded;
    var isInitialized = contextInstance.isInitialized, isPanning = contextInstance.isPanning;
    var target = event.target;
    var isAllowed = isInitialized && !isPanning && !disabled && target;
    if (!isAllowed)
        return false;
    // Event ctrlKey detects if touchpad action is executing wheel or pinch gesture
    if (wheelDisabled && !event.ctrlKey)
        return false;
    if (touchPadDisabled && event.ctrlKey)
        return false;
    var isExcluded = isExcludedNode(target, excluded);
    if (isExcluded)
        return false;
    return true;
};
var getDeltaY = function (event) {
    if (event) {
        return event.deltaY < 0 ? 1 : -1;
    }
    return 0;
};
function getDelta(event, customDelta) {
    var deltaY = getDeltaY(event);
    var delta = checkIsNumber(customDelta, deltaY);
    return delta;
}
function getMousePosition(event, contentComponent, scale) {
    var contentRect = contentComponent.getBoundingClientRect();
    var mouseX = 0;
    var mouseY = 0;
    if ("clientX" in event) {
        // mouse position x, y over wrapper component
        mouseX = (event.clientX - contentRect.left) / scale;
        mouseY = (event.clientY - contentRect.top) / scale;
    }
    else {
        var touch = event.touches[0];
        mouseX = (touch.clientX - contentRect.left) / scale;
        mouseY = (touch.clientY - contentRect.top) / scale;
    }
    if (Number.isNaN(mouseX) || Number.isNaN(mouseY))
        console.error("No mouse or touch offset found");
    return {
        x: mouseX,
        y: mouseY,
    };
}
var handleCalculateWheelZoom = function (contextInstance, delta, step, disable, getTarget) {
    var scale = contextInstance.transformState.scale;
    var wrapperComponent = contextInstance.wrapperComponent, setup = contextInstance.setup;
    var maxScale = setup.maxScale, minScale = setup.minScale, zoomAnimation = setup.zoomAnimation, disablePadding = setup.disablePadding;
    var size = zoomAnimation.size, disabled = zoomAnimation.disabled;
    if (!wrapperComponent) {
        throw new Error("Wrapper is not mounted");
    }
    var targetScale = scale + delta * step;
    if (getTarget)
        return targetScale;
    var paddingEnabled = disable ? false : !disabled;
    var newScale = checkZoomBounds(roundNumber(targetScale, 3), minScale, maxScale, size, paddingEnabled && !disablePadding);
    return newScale;
};
var handleWheelZoomStop = function (contextInstance, event) {
    var previousWheelEvent = contextInstance.previousWheelEvent;
    var scale = contextInstance.transformState.scale;
    var _a = contextInstance.setup, maxScale = _a.maxScale, minScale = _a.minScale;
    if (!previousWheelEvent)
        return false;
    if (scale < maxScale || scale > minScale)
        return true;
    if (Math.sign(previousWheelEvent.deltaY) !== Math.sign(event.deltaY))
        return true;
    if (previousWheelEvent.deltaY > 0 && previousWheelEvent.deltaY < event.deltaY)
        return true;
    if (previousWheelEvent.deltaY < 0 && previousWheelEvent.deltaY > event.deltaY)
        return true;
    if (Math.sign(previousWheelEvent.deltaY) !== Math.sign(event.deltaY))
        return true;
    return false;
};

var isPinchStartAllowed = function (contextInstance, event) {
    var _a = contextInstance.setup.pinch, disabled = _a.disabled, excluded = _a.excluded;
    var isInitialized = contextInstance.isInitialized;
    var target = event.target;
    var isAllowed = isInitialized && !disabled && target;
    if (!isAllowed)
        return false;
    var isExcluded = isExcludedNode(target, excluded);
    if (isExcluded)
        return false;
    return true;
};
var isPinchAllowed = function (contextInstance) {
    var disabled = contextInstance.setup.pinch.disabled;
    var isInitialized = contextInstance.isInitialized, pinchStartDistance = contextInstance.pinchStartDistance;
    var isAllowed = isInitialized && !disabled && pinchStartDistance;
    if (!isAllowed)
        return false;
    return true;
};
var calculateTouchMidPoint = function (event, scale, contentComponent) {
    var contentRect = contentComponent.getBoundingClientRect();
    var touches = event.touches;
    var firstPointX = roundNumber(touches[0].clientX - contentRect.left, 5);
    var firstPointY = roundNumber(touches[0].clientY - contentRect.top, 5);
    var secondPointX = roundNumber(touches[1].clientX - contentRect.left, 5);
    var secondPointY = roundNumber(touches[1].clientY - contentRect.top, 5);
    return {
        x: (firstPointX + secondPointX) / 2 / scale,
        y: (firstPointY + secondPointY) / 2 / scale,
    };
};
var getTouchDistance = function (event) {
    return Math.sqrt(Math.pow((event.touches[0].pageX - event.touches[1].pageX), 2) +
        Math.pow((event.touches[0].pageY - event.touches[1].pageY), 2));
};
var calculatePinchZoom = function (contextInstance, currentDistance) {
    var pinchStartScale = contextInstance.pinchStartScale, pinchStartDistance = contextInstance.pinchStartDistance, setup = contextInstance.setup;
    var maxScale = setup.maxScale, minScale = setup.minScale, zoomAnimation = setup.zoomAnimation, disablePadding = setup.disablePadding;
    var size = zoomAnimation.size, disabled = zoomAnimation.disabled;
    if (!pinchStartScale || pinchStartDistance === null || !currentDistance) {
        throw new Error("Pinch touches distance was not provided");
    }
    if (currentDistance < 0) {
        return contextInstance.transformState.scale;
    }
    var touchProportion = currentDistance / pinchStartDistance;
    var scaleDifference = touchProportion * pinchStartScale;
    return checkZoomBounds(roundNumber(scaleDifference, 2), minScale, maxScale, size, !disabled && !disablePadding);
};

var wheelStopEventTime = 160;
var wheelAnimationTime = 100;
var handleWheelStart = function (contextInstance, event) {
    var _a = contextInstance.props, onWheelStart = _a.onWheelStart, onZoomStart = _a.onZoomStart;
    if (!contextInstance.wheelStopEventTimer) {
        handleCancelAnimation(contextInstance);
        handleCallback(getContext(contextInstance), event, onWheelStart);
        handleCallback(getContext(contextInstance), event, onZoomStart);
    }
};
var handleWheelZoom = function (contextInstance, event) {
    var _a = contextInstance.props, onWheel = _a.onWheel, onZoom = _a.onZoom;
    var contentComponent = contextInstance.contentComponent, setup = contextInstance.setup, transformState = contextInstance.transformState;
    var scale = transformState.scale;
    var limitToBounds = setup.limitToBounds, centerZoomedOut = setup.centerZoomedOut, zoomAnimation = setup.zoomAnimation, wheel = setup.wheel, disablePadding = setup.disablePadding, smooth = setup.smooth;
    var size = zoomAnimation.size, disabled = zoomAnimation.disabled;
    var step = wheel.step, smoothStep = wheel.smoothStep;
    if (!contentComponent) {
        throw new Error("Component not mounted");
    }
    event.preventDefault();
    event.stopPropagation();
    var delta = getDelta(event, null);
    var zoomStep = smooth ? smoothStep * Math.abs(event.deltaY) : step;
    var newScale = handleCalculateWheelZoom(contextInstance, delta, zoomStep, !event.ctrlKey);
    // if scale not change
    if (scale === newScale)
        return;
    var bounds = handleCalculateBounds(contextInstance, newScale);
    var mousePosition = getMousePosition(event, contentComponent, scale);
    var isPaddingDisabled = disabled || size === 0 || centerZoomedOut || disablePadding;
    var isLimitedToBounds = limitToBounds && isPaddingDisabled;
    var _b = handleCalculateZoomPositions(contextInstance, mousePosition.x, mousePosition.y, newScale, bounds, isLimitedToBounds), x = _b.x, y = _b.y;
    contextInstance.previousWheelEvent = event;
    contextInstance.setTransformState(newScale, x, y);
    handleCallback(getContext(contextInstance), event, onWheel);
    handleCallback(getContext(contextInstance), event, onZoom);
};
var handleWheelStop = function (contextInstance, event) {
    var _a = contextInstance.props, onWheelStop = _a.onWheelStop, onZoomStop = _a.onZoomStop;
    // fire animation
    cancelTimeout(contextInstance.wheelAnimationTimer);
    contextInstance.wheelAnimationTimer = setTimeout(function () {
        if (!contextInstance.mounted)
            return;
        handleAlignToScaleBounds(contextInstance, event.x, event.y);
        contextInstance.wheelAnimationTimer = null;
    }, wheelAnimationTime);
    // Wheel stop event
    var hasStoppedZooming = handleWheelZoomStop(contextInstance, event);
    if (hasStoppedZooming) {
        cancelTimeout(contextInstance.wheelStopEventTimer);
        contextInstance.wheelStopEventTimer = setTimeout(function () {
            if (!contextInstance.mounted)
                return;
            contextInstance.wheelStopEventTimer = null;
            handleCallback(getContext(contextInstance), event, onWheelStop);
            handleCallback(getContext(contextInstance), event, onZoomStop);
        }, wheelStopEventTime);
    }
};

var getTouchCenter = function (event) {
    var totalX = 0;
    var totalY = 0;
    // Sum up the positions of all touches
    for (var i = 0; i < 2; i += 1) {
        totalX += event.touches[i].clientX;
        totalY += event.touches[i].clientY;
    }
    // Calculate the average position
    var x = totalX / 2;
    var y = totalY / 2;
    return { x: x, y: y };
};
var handlePinchStart = function (contextInstance, event) {
    var distance = getTouchDistance(event);
    contextInstance.pinchStartDistance = distance;
    contextInstance.lastDistance = distance;
    contextInstance.pinchStartScale = contextInstance.transformState.scale;
    contextInstance.isPanning = false;
    var center = getTouchCenter(event);
    contextInstance.pinchLastCenterX = center.x;
    contextInstance.pinchLastCenterY = center.y;
    handleCancelAnimation(contextInstance);
};
var handlePinchZoom = function (contextInstance, event) {
    var contentComponent = contextInstance.contentComponent, pinchStartDistance = contextInstance.pinchStartDistance, wrapperComponent = contextInstance.wrapperComponent;
    var scale = contextInstance.transformState.scale;
    var _a = contextInstance.setup, limitToBounds = _a.limitToBounds, centerZoomedOut = _a.centerZoomedOut, zoomAnimation = _a.zoomAnimation, alignmentAnimation = _a.alignmentAnimation;
    var disabled = zoomAnimation.disabled, size = zoomAnimation.size;
    // if one finger starts from outside of wrapper
    if (pinchStartDistance === null || !contentComponent)
        return;
    var midPoint = calculateTouchMidPoint(event, scale, contentComponent);
    // if touches goes off of the wrapper element
    if (!Number.isFinite(midPoint.x) || !Number.isFinite(midPoint.y))
        return;
    var currentDistance = getTouchDistance(event);
    var newScale = calculatePinchZoom(contextInstance, currentDistance);
    var center = getTouchCenter(event);
    // pan should be scale invariant.
    var panX = center.x - (contextInstance.pinchLastCenterX || 0);
    var panY = center.y - (contextInstance.pinchLastCenterY || 0);
    if (newScale === scale && panX === 0 && panY === 0)
        return;
    contextInstance.pinchLastCenterX = center.x;
    contextInstance.pinchLastCenterY = center.y;
    var bounds = handleCalculateBounds(contextInstance, newScale);
    var isPaddingDisabled = disabled || size === 0 || centerZoomedOut;
    var isLimitedToBounds = limitToBounds && isPaddingDisabled;
    var _b = handleCalculateZoomPositions(contextInstance, midPoint.x, midPoint.y, newScale, bounds, isLimitedToBounds), x = _b.x, y = _b.y;
    contextInstance.pinchMidpoint = midPoint;
    contextInstance.lastDistance = currentDistance;
    var sizeX = alignmentAnimation.sizeX, sizeY = alignmentAnimation.sizeY;
    var paddingValueX = getPaddingValue(contextInstance, sizeX);
    var paddingValueY = getPaddingValue(contextInstance, sizeY);
    var newPositionX = x + panX;
    var newPositionY = y + panY;
    var _c = getMouseBoundedPosition(newPositionX, newPositionY, bounds, limitToBounds, paddingValueX, paddingValueY, wrapperComponent), finalX = _c.x, finalY = _c.y;
    contextInstance.setTransformState(newScale, finalX, finalY);
};
var handlePinchStop = function (contextInstance) {
    var pinchMidpoint = contextInstance.pinchMidpoint;
    contextInstance.velocity = null;
    contextInstance.lastDistance = null;
    contextInstance.pinchMidpoint = null;
    contextInstance.pinchStartScale = null;
    contextInstance.pinchStartDistance = null;
    handleAlignToScaleBounds(contextInstance, pinchMidpoint === null || pinchMidpoint === void 0 ? void 0 : pinchMidpoint.x, pinchMidpoint === null || pinchMidpoint === void 0 ? void 0 : pinchMidpoint.y);
};

var handleDoubleClickStop = function (contextInstance, event) {
    var onZoomStop = contextInstance.props.onZoomStop;
    var animationTime = contextInstance.setup.doubleClick.animationTime;
    cancelTimeout(contextInstance.doubleClickStopEventTimer);
    contextInstance.doubleClickStopEventTimer = setTimeout(function () {
        contextInstance.doubleClickStopEventTimer = null;
        handleCallback(getContext(contextInstance), event, onZoomStop);
    }, animationTime);
};
var handleDoubleClickResetMode = function (contextInstance, event) {
    var _a = contextInstance.props, onZoomStart = _a.onZoomStart, onZoom = _a.onZoom;
    var _b = contextInstance.setup.doubleClick, animationTime = _b.animationTime, animationType = _b.animationType;
    handleCallback(getContext(contextInstance), event, onZoomStart);
    resetTransformations(contextInstance, animationTime, animationType, function () {
        return handleCallback(getContext(contextInstance), event, onZoom);
    });
    handleDoubleClickStop(contextInstance, event);
};
function getDoubleClickScale(mode, scale) {
    if (mode === "toggle") {
        return scale === 1 ? 1 : -1;
    }
    return mode === "zoomOut" ? -1 : 1;
}
function handleDoubleClick(contextInstance, event) {
    var setup = contextInstance.setup, doubleClickStopEventTimer = contextInstance.doubleClickStopEventTimer, transformState = contextInstance.transformState, contentComponent = contextInstance.contentComponent;
    var scale = transformState.scale;
    var _a = contextInstance.props, onZoomStart = _a.onZoomStart, onZoom = _a.onZoom;
    var _b = setup.doubleClick, disabled = _b.disabled, mode = _b.mode, step = _b.step, animationTime = _b.animationTime, animationType = _b.animationType;
    if (disabled)
        return;
    if (doubleClickStopEventTimer)
        return;
    if (mode === "reset") {
        return handleDoubleClickResetMode(contextInstance, event);
    }
    if (!contentComponent)
        return console.error("No ContentComponent found");
    var delta = getDoubleClickScale(mode, contextInstance.transformState.scale);
    var newScale = handleCalculateButtonZoom(contextInstance, delta, step);
    // stop execution when scale didn't change
    if (scale === newScale)
        return;
    handleCallback(getContext(contextInstance), event, onZoomStart);
    var mousePosition = getMousePosition(event, contentComponent, scale);
    var targetState = handleZoomToPoint(contextInstance, newScale, mousePosition.x, mousePosition.y);
    if (!targetState) {
        return console.error("Error during zoom event. New transformation state was not calculated.");
    }
    handleCallback(getContext(contextInstance), event, onZoom);
    animate(contextInstance, targetState, animationTime, animationType);
    handleDoubleClickStop(contextInstance, event);
}
var isDoubleClickAllowed = function (contextInstance, event) {
    var isInitialized = contextInstance.isInitialized, setup = contextInstance.setup, wrapperComponent = contextInstance.wrapperComponent;
    var _a = setup.doubleClick, disabled = _a.disabled, excluded = _a.excluded;
    var target = event.target;
    var isWrapperChild = wrapperComponent === null || wrapperComponent === void 0 ? void 0 : wrapperComponent.contains(target);
    var isAllowed = isInitialized && target && isWrapperChild && !disabled;
    if (!isAllowed)
        return false;
    var isExcluded = isExcludedNode(target, excluded);
    if (isExcluded)
        return false;
    return true;
};

var ZoomPanPinch = /** @class */ (function () {
    function ZoomPanPinch(props) {
        var _this = this;
        this.mounted = true;
        this.pinchLastCenterX = null;
        this.pinchLastCenterY = null;
        this.onChangeCallbacks = new Set();
        this.onInitCallbacks = new Set();
        // Components
        this.wrapperComponent = null;
        this.contentComponent = null;
        // Initialization
        this.isInitialized = false;
        this.bounds = null;
        // wheel helpers
        this.previousWheelEvent = null;
        this.wheelStopEventTimer = null;
        this.wheelAnimationTimer = null;
        // panning helpers
        this.isPanning = false;
        this.isWheelPanning = false;
        this.startCoords = null;
        this.lastTouch = null;
        // pinch helpers
        this.distance = null;
        this.lastDistance = null;
        this.pinchStartDistance = null;
        this.pinchStartScale = null;
        this.pinchMidpoint = null;
        // double click helpers
        this.doubleClickStopEventTimer = null;
        // velocity helpers
        this.velocity = null;
        this.velocityTime = null;
        this.lastMousePosition = null;
        // animations helpers
        this.animate = false;
        this.animation = null;
        this.maxBounds = null;
        // key press
        this.pressedKeys = {};
        this.mount = function () {
            _this.initializeWindowEvents();
        };
        this.unmount = function () {
            _this.cleanupWindowEvents();
        };
        this.update = function (newProps) {
            _this.props = newProps;
            handleCalculateBounds(_this, _this.transformState.scale);
            _this.setup = createSetup(newProps);
        };
        this.initializeWindowEvents = function () {
            var _a, _b;
            var passive = makePassiveEventOption();
            var currentDocument = (_a = _this.wrapperComponent) === null || _a === void 0 ? void 0 : _a.ownerDocument;
            var currentWindow = currentDocument === null || currentDocument === void 0 ? void 0 : currentDocument.defaultView;
            (_b = _this.wrapperComponent) === null || _b === void 0 ? void 0 : _b.addEventListener("wheel", _this.onWheelPanning, passive);
            // Panning on window to allow panning when mouse is out of component wrapper
            currentWindow === null || currentWindow === void 0 ? void 0 : currentWindow.addEventListener("mousedown", _this.onPanningStart, passive);
            currentWindow === null || currentWindow === void 0 ? void 0 : currentWindow.addEventListener("mousemove", _this.onPanning, passive);
            currentWindow === null || currentWindow === void 0 ? void 0 : currentWindow.addEventListener("mouseup", _this.onPanningStop, passive);
            currentDocument === null || currentDocument === void 0 ? void 0 : currentDocument.addEventListener("mouseleave", _this.clearPanning, passive);
            currentWindow === null || currentWindow === void 0 ? void 0 : currentWindow.addEventListener("keyup", _this.setKeyUnPressed, passive);
            currentWindow === null || currentWindow === void 0 ? void 0 : currentWindow.addEventListener("keydown", _this.setKeyPressed, passive);
        };
        this.cleanupWindowEvents = function () {
            var _a, _b;
            var passive = makePassiveEventOption();
            var currentDocument = (_a = _this.wrapperComponent) === null || _a === void 0 ? void 0 : _a.ownerDocument;
            var currentWindow = currentDocument === null || currentDocument === void 0 ? void 0 : currentDocument.defaultView;
            currentWindow === null || currentWindow === void 0 ? void 0 : currentWindow.removeEventListener("mousedown", _this.onPanningStart, passive);
            currentWindow === null || currentWindow === void 0 ? void 0 : currentWindow.removeEventListener("mousemove", _this.onPanning, passive);
            currentWindow === null || currentWindow === void 0 ? void 0 : currentWindow.removeEventListener("mouseup", _this.onPanningStop, passive);
            currentDocument === null || currentDocument === void 0 ? void 0 : currentDocument.removeEventListener("mouseleave", _this.clearPanning, passive);
            currentWindow === null || currentWindow === void 0 ? void 0 : currentWindow.removeEventListener("keyup", _this.setKeyUnPressed, passive);
            currentWindow === null || currentWindow === void 0 ? void 0 : currentWindow.removeEventListener("keydown", _this.setKeyPressed, passive);
            document.removeEventListener("mouseleave", _this.clearPanning, passive);
            handleCancelAnimation(_this);
            (_b = _this.observer) === null || _b === void 0 ? void 0 : _b.disconnect();
        };
        this.handleInitializeWrapperEvents = function (wrapper) {
            // Zooming events on wrapper
            var passive = makePassiveEventOption();
            wrapper.addEventListener("wheel", _this.onWheelZoom, passive);
            wrapper.addEventListener("dblclick", _this.onDoubleClick, passive);
            wrapper.addEventListener("touchstart", _this.onTouchPanningStart, passive);
            wrapper.addEventListener("touchmove", _this.onTouchPanning, passive);
            wrapper.addEventListener("touchend", _this.onTouchPanningStop, passive);
        };
        this.handleInitialize = function (contentComponent) {
            var centerOnInit = _this.setup.centerOnInit;
            _this.applyTransformation();
            _this.onInitCallbacks.forEach(function (callback) { return callback(getContext(_this)); });
            if (centerOnInit) {
                _this.setCenter();
                _this.observer = new ResizeObserver(function () {
                    var _a;
                    var currentWidth = contentComponent.offsetWidth;
                    var currentHeight = contentComponent.offsetHeight;
                    if (currentWidth > 0 || currentHeight > 0) {
                        _this.onInitCallbacks.forEach(function (callback) {
                            return callback(getContext(_this));
                        });
                        _this.setCenter();
                        (_a = _this.observer) === null || _a === void 0 ? void 0 : _a.disconnect();
                    }
                });
                // if nothing about the contentComponent has changed after 5 seconds, disconnect the observer
                setTimeout(function () {
                    var _a;
                    (_a = _this.observer) === null || _a === void 0 ? void 0 : _a.disconnect();
                }, 5000);
                // Start observing the target node for configured mutations
                _this.observer.observe(contentComponent);
            }
        };
        /// ///////
        // Zoom
        /// ///////
        this.onWheelZoom = function (event) {
            var disabled = _this.setup.disabled;
            if (disabled)
                return;
            var isAllowed = isWheelAllowed(_this, event);
            if (!isAllowed)
                return;
            var keysPressed = _this.isPressingKeys(_this.setup.wheel.activationKeys);
            if (!keysPressed)
                return;
            handleWheelStart(_this, event);
            handleWheelZoom(_this, event);
            handleWheelStop(_this, event);
        };
        /// ///////
        // Pan
        /// ///////
        this.onWheelPanning = function (event) {
            var _a = _this.setup, disabled = _a.disabled, wheel = _a.wheel, panning = _a.panning;
            if (!_this.wrapperComponent ||
                !_this.contentComponent ||
                disabled ||
                !wheel.wheelDisabled ||
                panning.disabled ||
                !panning.wheelPanning ||
                event.ctrlKey) {
                return;
            }
            event.preventDefault();
            event.stopPropagation();
            var _b = _this.transformState, positionX = _b.positionX, positionY = _b.positionY;
            var mouseX = positionX - event.deltaX;
            var mouseY = positionY - event.deltaY;
            var newPositionX = panning.lockAxisX ? positionX : mouseX;
            var newPositionY = panning.lockAxisY ? positionY : mouseY;
            var _c = _this.setup.alignmentAnimation, sizeX = _c.sizeX, sizeY = _c.sizeY;
            var paddingValueX = getPaddingValue(_this, sizeX);
            var paddingValueY = getPaddingValue(_this, sizeY);
            if (newPositionX === positionX && newPositionY === positionY)
                return;
            handleNewPosition(_this, newPositionX, newPositionY, paddingValueX, paddingValueY);
        };
        this.onPanningStart = function (event) {
            var disabled = _this.setup.disabled;
            var onPanningStart = _this.props.onPanningStart;
            if (disabled)
                return;
            var isAllowed = isPanningStartAllowed(_this, event);
            if (!isAllowed)
                return;
            var keysPressed = _this.isPressingKeys(_this.setup.panning.activationKeys);
            if (!keysPressed)
                return;
            if (event.button === 0 && !_this.setup.panning.allowLeftClickPan)
                return;
            if (event.button === 1 && !_this.setup.panning.allowMiddleClickPan)
                return;
            if (event.button === 2 && !_this.setup.panning.allowRightClickPan)
                return;
            event.preventDefault();
            event.stopPropagation();
            handleCancelAnimation(_this);
            handlePanningStart(_this, event);
            handleCallback(getContext(_this), event, onPanningStart);
        };
        this.onPanning = function (event) {
            var disabled = _this.setup.disabled;
            var onPanning = _this.props.onPanning;
            if (disabled)
                return;
            var isAllowed = isPanningAllowed(_this);
            if (!isAllowed)
                return;
            var keysPressed = _this.isPressingKeys(_this.setup.panning.activationKeys);
            if (!keysPressed)
                return;
            event.preventDefault();
            event.stopPropagation();
            handlePanning(_this, event.clientX, event.clientY);
            handleCallback(getContext(_this), event, onPanning);
        };
        this.onPanningStop = function (event) {
            var onPanningStop = _this.props.onPanningStop;
            if (_this.isPanning) {
                handlePanningEnd(_this);
                handleCallback(getContext(_this), event, onPanningStop);
            }
        };
        /// ///////
        // Pinch
        /// ///////
        this.onPinchStart = function (event) {
            var disabled = _this.setup.disabled;
            var _a = _this.props, onPinchingStart = _a.onPinchingStart, onZoomStart = _a.onZoomStart;
            if (disabled)
                return;
            var isAllowed = isPinchStartAllowed(_this, event);
            if (!isAllowed)
                return;
            handlePinchStart(_this, event);
            handleCancelAnimation(_this);
            handleCallback(getContext(_this), event, onPinchingStart);
            handleCallback(getContext(_this), event, onZoomStart);
        };
        this.onPinch = function (event) {
            var disabled = _this.setup.disabled;
            var _a = _this.props, onPinching = _a.onPinching, onZoom = _a.onZoom;
            if (disabled)
                return;
            var isAllowed = isPinchAllowed(_this);
            if (!isAllowed)
                return;
            event.preventDefault();
            event.stopPropagation();
            handlePinchZoom(_this, event);
            handleCallback(getContext(_this), event, onPinching);
            handleCallback(getContext(_this), event, onZoom);
        };
        this.onPinchStop = function (event) {
            var _a = _this.props, onPinchingStop = _a.onPinchingStop, onZoomStop = _a.onZoomStop;
            if (_this.pinchStartScale) {
                handlePinchStop(_this);
                handleCallback(getContext(_this), event, onPinchingStop);
                handleCallback(getContext(_this), event, onZoomStop);
            }
        };
        /// ///////
        // Touch
        /// ///////
        this.onTouchPanningStart = function (event) {
            var disabled = _this.setup.disabled;
            var onPanningStart = _this.props.onPanningStart;
            if (disabled)
                return;
            var isAllowed = isPanningStartAllowed(_this, event);
            if (!isAllowed)
                return;
            var isDoubleTap = _this.lastTouch && +new Date() - _this.lastTouch < 200;
            if (isDoubleTap && event.touches.length === 1) {
                _this.onDoubleClick(event);
            }
            else {
                _this.lastTouch = +new Date();
                handleCancelAnimation(_this);
                var touches = event.touches;
                var isPanningAction = touches.length === 1;
                var isPinchAction = touches.length === 2;
                if (isPanningAction) {
                    handleCancelAnimation(_this);
                    handlePanningStart(_this, event);
                    handleCallback(getContext(_this), event, onPanningStart);
                }
                if (isPinchAction) {
                    _this.onPinchStart(event);
                }
            }
        };
        this.onTouchPanning = function (event) {
            var disabled = _this.setup.disabled;
            var onPanning = _this.props.onPanning;
            if (_this.isPanning && event.touches.length === 1) {
                if (disabled)
                    return;
                var isAllowed = isPanningAllowed(_this);
                if (!isAllowed)
                    return;
                event.preventDefault();
                event.stopPropagation();
                var touch = event.touches[0];
                handlePanning(_this, touch.clientX, touch.clientY);
                handleCallback(getContext(_this), event, onPanning);
            }
            else if (event.touches.length > 1) {
                _this.onPinch(event);
            }
        };
        this.onTouchPanningStop = function (event) {
            _this.onPanningStop(event);
            _this.onPinchStop(event);
        };
        /// ///////
        // Double Click
        /// ///////
        this.onDoubleClick = function (event) {
            var disabled = _this.setup.disabled;
            if (disabled)
                return;
            var isAllowed = isDoubleClickAllowed(_this, event);
            if (!isAllowed)
                return;
            handleDoubleClick(_this, event);
        };
        /// ///////
        // Helpers
        /// ///////
        this.clearPanning = function (event) {
            if (_this.isPanning) {
                _this.onPanningStop(event);
            }
        };
        this.setKeyPressed = function (e) {
            _this.pressedKeys[e.key] = true;
        };
        this.setKeyUnPressed = function (e) {
            _this.pressedKeys[e.key] = false;
        };
        this.isPressingKeys = function (keys) {
            if (!keys.length) {
                return true;
            }
            return Boolean(keys.find(function (key) { return _this.pressedKeys[key]; }));
        };
        this.setTransformState = function (scale, positionX, positionY) {
            var onTransformed = _this.props.onTransformed;
            if (!Number.isNaN(scale) &&
                !Number.isNaN(positionX) &&
                !Number.isNaN(positionY)) {
                if (scale !== _this.transformState.scale) {
                    _this.transformState.previousScale = _this.transformState.scale;
                    _this.transformState.scale = scale;
                }
                _this.transformState.positionX = positionX;
                _this.transformState.positionY = positionY;
                _this.applyTransformation();
                var ctx_1 = getContext(_this);
                _this.onChangeCallbacks.forEach(function (callback) { return callback(ctx_1); });
                handleCallback(ctx_1, { scale: scale, positionX: positionX, positionY: positionY }, onTransformed);
            }
            else {
                console.error("Detected NaN set state values");
            }
        };
        this.setCenter = function () {
            if (_this.wrapperComponent && _this.contentComponent) {
                var targetState = getCenterPosition(_this.transformState.scale, _this.wrapperComponent, _this.contentComponent);
                _this.setTransformState(targetState.scale, targetState.positionX, targetState.positionY);
            }
        };
        this.handleTransformStyles = function (x, y, scale) {
            if (_this.props.customTransform) {
                return _this.props.customTransform(x, y, scale);
            }
            return getTransformStyles(x, y, scale);
        };
        this.applyTransformation = function () {
            if (!_this.mounted || !_this.contentComponent)
                return;
            var _a = _this.transformState, scale = _a.scale, positionX = _a.positionX, positionY = _a.positionY;
            var transform = _this.handleTransformStyles(positionX, positionY, scale);
            _this.contentComponent.style.transform = transform;
        };
        this.getContext = function () {
            return getContext(_this);
        };
        /**
         * Hooks
         */
        this.onChange = function (callback) {
            if (!_this.onChangeCallbacks.has(callback)) {
                _this.onChangeCallbacks.add(callback);
            }
            return function () {
                _this.onChangeCallbacks.delete(callback);
            };
        };
        this.onInit = function (callback) {
            if (!_this.onInitCallbacks.has(callback)) {
                _this.onInitCallbacks.add(callback);
            }
            return function () {
                _this.onInitCallbacks.delete(callback);
            };
        };
        /**
         * Initialization
         */
        this.init = function (wrapperComponent, contentComponent) {
            _this.cleanupWindowEvents();
            _this.wrapperComponent = wrapperComponent;
            _this.contentComponent = contentComponent;
            handleCalculateBounds(_this, _this.transformState.scale);
            _this.handleInitializeWrapperEvents(wrapperComponent);
            _this.handleInitialize(contentComponent);
            _this.initializeWindowEvents();
            _this.isInitialized = true;
            var ctx = getContext(_this);
            handleCallback(ctx, undefined, _this.props.onInit);
        };
        this.props = props;
        this.setup = createSetup(this.props);
        this.transformState = createState(this.props);
    }
    return ZoomPanPinch;
}());

var index_esm_Context = react.createContext(null);
var getContent = function (children, ctx) {
    if (typeof children === "function") {
        return children(ctx);
    }
    return children;
};
var TransformWrapper = react.forwardRef(function (props, ref) {
    var instance = (0,react.useRef)(new ZoomPanPinch(props)).current;
    var content = getContent(props.children, getControls(instance));
    (0,react.useImperativeHandle)(ref, function () { return getControls(instance); }, [instance]);
    (0,react.useEffect)(function () {
        instance.update(props);
    }, [instance, props]);
    return react.createElement(index_esm_Context.Provider, { value: instance }, content);
});

var KeepScale = react.forwardRef(function (props, ref) {
    var localRef = (0,react.useRef)(null);
    var instance = (0,react.useContext)(index_esm_Context);
    (0,react.useEffect)(function () {
        return instance.onChange(function (ctx) {
            if (localRef.current) {
                var positionX = 0;
                var positionY = 0;
                localRef.current.style.transform = instance.handleTransformStyles(positionX, positionY, 1 / ctx.instance.transformState.scale);
            }
        });
    }, [instance]);
    return react.createElement("div", __assign({}, props, { ref: index_esm_mergeRefs([localRef, ref]) }));
});

var initialElementRect = {
    width: 0,
    height: 0,
    y: 0,
    x: 0,
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
};
var useResize = function (ref, onResize, dependencies) {
    var resizeObserverRef = useRef();
    var rectRef = useRef(initialElementRect);
    var didUnmount = useRef(false);
    useLayoutEffect(function () {
        var _a;
        didUnmount.current = false;
        if (!("ResizeObserver" in window)) {
            return;
        }
        if (ref) {
            resizeObserverRef.current = new ResizeObserver(function (entries) {
                var newSize = ref.getBoundingClientRect();
                if (!Array.isArray(entries) ||
                    !entries.length ||
                    didUnmount.current ||
                    (newSize.width === rectRef.current.width &&
                        newSize.height === rectRef.current.height))
                    return;
                onResize(newSize, ref);
                rectRef.current = newSize;
            });
            (_a = resizeObserverRef.current) === null || _a === void 0 ? void 0 : _a.observe(ref);
        }
        return function () {
            var _a;
            didUnmount.current = true;
            if (ref) {
                (_a = resizeObserverRef.current) === null || _a === void 0 ? void 0 : _a.unobserve(ref);
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, __spreadArray([onResize, ref], dependencies, true));
};

var previewStyles = {
    position: "absolute",
    zIndex: 2,
    top: "0px",
    left: "0px",
    boxSizing: "border-box",
    border: "3px solid red",
    transformOrigin: "0% 0%",
    boxShadow: "rgba(0,0,0,0.2) 0 0 0 10000000px",
};
var MiniMap = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 200 : _b, _c = _a.height, height = _c === void 0 ? 200 : _c, _d = _a.borderColor, borderColor = _d === void 0 ? "red" : _d, children = _a.children, rest = __rest(_a, ["width", "height", "borderColor", "children"]);
    var _e = useState(false), initialized = _e[0], setInitialized = _e[1];
    var instance = useTransformContext();
    var miniMapInstance = useRef(null);
    var mainRef = useRef(null);
    var wrapperRef = useRef(null);
    var previewRef = useRef(null);
    var getViewportSize = useCallback(function () {
        if (instance.wrapperComponent) {
            var rect = instance.wrapperComponent.getBoundingClientRect();
            return {
                width: rect.width,
                height: rect.height
            };
        }
        return {
            width: 0,
            height: 0
        };
    }, [instance.wrapperComponent]);
    var getContentSize = useCallback(function () {
        if (instance.contentComponent) {
            var rect = instance.contentComponent.getBoundingClientRect();
            return {
                width: rect.width / instance.transformState.scale,
                height: rect.height / instance.transformState.scale,
            };
        }
        return {
            width: 0,
            height: 0,
        };
    }, [instance.contentComponent, instance.transformState.scale]);
    var computeMiniMapScale = useCallback(function () {
        var contentSize = getContentSize();
        var scaleX = width / contentSize.width;
        var scaleY = height / contentSize.height;
        var scale = scaleY > scaleX ? scaleX : scaleY;
        return scale;
    }, [getContentSize, height, width]);
    var computeMiniMapSize = function () {
        var contentSize = getContentSize();
        var scaleX = width / contentSize.width;
        var scaleY = height / contentSize.height;
        if (scaleY > scaleX) {
            return { width: width, height: contentSize.height * scaleX };
        }
        return { width: contentSize.width * scaleY, height: height };
    };
    var computeMiniMapStyle = function () {
        var scale = computeMiniMapScale();
        var style = {
            transform: "scale(".concat(scale || 1, ")"),
            transformOrigin: "0% 0%",
            position: "absolute",
            boxSizing: "border-box",
            zIndex: 1,
            overflow: "hidden",
        };
        Object.keys(style).forEach(function (key) {
            if (wrapperRef.current) {
                wrapperRef.current.style[key] = style[key];
            }
        });
    };
    var transformMiniMap = function () {
        computeMiniMapStyle();
        var miniSize = computeMiniMapSize();
        var wrapSize = getContentSize();
        if (wrapperRef.current) {
            wrapperRef.current.style.width = "".concat(wrapSize.width, "px");
            wrapperRef.current.style.height = "".concat(wrapSize.height, "px");
        }
        if (mainRef.current) {
            mainRef.current.style.width = "".concat(miniSize.width, "px");
            mainRef.current.style.height = "".concat(miniSize.height, "px");
        }
        if (previewRef.current) {
            var size = getViewportSize();
            var scale = computeMiniMapScale();
            var previewScale = scale * (1 / instance.transformState.scale);
            var transform = instance.handleTransformStyles(-instance.transformState.positionX * previewScale, -instance.transformState.positionY * previewScale, 1);
            previewRef.current.style.transform = transform;
            previewRef.current.style.width = "".concat(size.width * previewScale, "px");
            previewRef.current.style.height = "".concat(size.height * previewScale, "px");
        }
    };
    var initialize = function () {
        transformMiniMap();
    };
    useTransformEffect(function () {
        transformMiniMap();
    });
    useTransformInit(function () {
        initialize();
        setInitialized(true);
    });
    useResize(instance.contentComponent, initialize, [initialized]);
    useEffect(function () {
        return instance.onChange(function (zpp) {
            var scale = computeMiniMapScale();
            if (miniMapInstance.current) {
                miniMapInstance.current.instance.transformState.scale =
                    zpp.instance.transformState.scale;
                miniMapInstance.current.instance.transformState.positionX =
                    zpp.instance.transformState.positionX * scale;
                miniMapInstance.current.instance.transformState.positionY =
                    zpp.instance.transformState.positionY * scale;
            }
        });
    }, [computeMiniMapScale, instance, miniMapInstance]);
    var wrapperStyle = useMemo(function () {
        return {
            position: "relative",
            zIndex: 2,
            overflow: "hidden",
        };
    }, []);
    return (React.createElement("div", __assign({}, rest, { ref: mainRef, style: wrapperStyle, className: "rzpp-mini-map ".concat(rest.className || "") }),
        React.createElement("div", __assign({}, rest, { ref: wrapperRef, className: "rzpp-wrapper" }), children),
        React.createElement("div", { className: "rzpp-preview", ref: previewRef, style: __assign(__assign({}, previewStyles), { borderColor: borderColor }) })));
};

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".transform-component-module_wrapper__SPB86 {\n  position: relative;\n  width: -moz-fit-content;\n  width: fit-content;\n  height: -moz-fit-content;\n  height: fit-content;\n  overflow: hidden;\n  -webkit-touch-callout: none; /* iOS Safari */\n  -webkit-user-select: none; /* Safari */\n  -khtml-user-select: none; /* Konqueror HTML */\n  -moz-user-select: none; /* Firefox */\n  -ms-user-select: none; /* Internet Explorer/Edge */\n  user-select: none;\n  margin: 0;\n  padding: 0;\n}\n.transform-component-module_content__FBWxo {\n  display: flex;\n  flex-wrap: wrap;\n  width: -moz-fit-content;\n  width: fit-content;\n  height: -moz-fit-content;\n  height: fit-content;\n  margin: 0;\n  padding: 0;\n  transform-origin: 0% 0%;\n}\n.transform-component-module_content__FBWxo img {\n  pointer-events: none;\n}\n";
var styles = {"wrapper":"transform-component-module_wrapper__SPB86","content":"transform-component-module_content__FBWxo"};
styleInject(css_248z);

var TransformComponent = function (_a) {
    var children = _a.children, _b = _a.wrapperClass, wrapperClass = _b === void 0 ? "" : _b, _c = _a.contentClass, contentClass = _c === void 0 ? "" : _c, wrapperStyle = _a.wrapperStyle, contentStyle = _a.contentStyle, _d = _a.wrapperProps, wrapperProps = _d === void 0 ? {} : _d, _e = _a.contentProps, contentProps = _e === void 0 ? {} : _e;
    var _f = (0,react.useContext)(index_esm_Context), init = _f.init, cleanupWindowEvents = _f.cleanupWindowEvents;
    var wrapperRef = (0,react.useRef)(null);
    var contentRef = (0,react.useRef)(null);
    (0,react.useEffect)(function () {
        var wrapper = wrapperRef.current;
        var content = contentRef.current;
        if (wrapper !== null && content !== null && init) {
            init === null || init === void 0 ? void 0 : init(wrapper, content);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
        return function () {
            cleanupWindowEvents === null || cleanupWindowEvents === void 0 ? void 0 : cleanupWindowEvents();
        };
    }, []);
    return (react.createElement("div", __assign({}, wrapperProps, { ref: wrapperRef, className: "".concat(baseClasses.wrapperClass, " ").concat(styles.wrapper, " ").concat(wrapperClass), style: wrapperStyle }),
        react.createElement("div", __assign({}, contentProps, { ref: contentRef, className: "".concat(baseClasses.contentClass, " ").concat(styles.content, " ").concat(contentClass), style: contentStyle }), children)));
};

var useTransformContext = function () {
    var libraryContext = useContext(index_esm_Context);
    if (!libraryContext) {
        throw new Error("Transform context must be placed inside TransformWrapper");
    }
    return libraryContext;
};

var useControls = function () {
    var libraryContext = useTransformContext();
    return getControls(libraryContext);
};

var useTransformInit = function (callback) {
    var libraryContext = useTransformContext();
    useEffect(function () {
        var unmountCallback;
        var unmount;
        if (libraryContext.contentComponent && libraryContext.wrapperComponent) {
            unmountCallback = callback(getState(libraryContext));
        }
        else {
            unmount = libraryContext.onInit(function (ref) {
                unmountCallback = callback(getState(ref.instance));
            });
        }
        return function () {
            unmount === null || unmount === void 0 ? void 0 : unmount();
            unmountCallback === null || unmountCallback === void 0 ? void 0 : unmountCallback();
        };
    }, []);
};

var useTransformEffect = function (callback) {
    var libraryContext = useTransformContext();
    useEffect(function () {
        var unmountCallback;
        var unmount = libraryContext.onChange(function (ref) {
            unmountCallback = callback(getState(ref.instance));
        });
        return function () {
            unmount();
            unmountCallback === null || unmountCallback === void 0 ? void 0 : unmountCallback();
        };
    }, [callback, libraryContext]);
};

function useTransformComponent(callback) {
    var libraryContext = useTransformContext();
    var _a = useState(callback(getState(libraryContext))), transformRender = _a[0], setTransformRender = _a[1];
    useEffect(function () {
        var mounted = true;
        var unmount = libraryContext.onChange(function (ref) {
            if (mounted) {
                setTransformRender(callback(getState(ref.instance)));
            }
        });
        return function () {
            unmount();
            mounted = false;
        };
    }, [callback, libraryContext]);
    return transformRender;
}


//# sourceMappingURL=index.esm.js.map

;// CONCATENATED MODULE: ./components/core/Conditional/Conditional.js
const Conditional = (props)=>{
    const { show , children  } = props;
    return show ? children : null;
};
/* harmony default export */ var Conditional_Conditional = (Conditional);

;// CONCATENATED MODULE: ./components/PartsViewer/v2/PartsDiagramViewer/PopModal/index.js




const PopModal = (props)=>{
    var ref, ref1;
    const { position , setMessage , scale  } = props;
    const { isMobile  } = (0,useViewport/* default */.Z)();
    const { left , top , textWidth , textBounds , textHeight  } = position;
    const normalizeDynamic = isMobile ? 3 : 6;
    const normalizeStatic = isMobile ? 4 : 7;
    const normalizedfactor = normalizeStatic + normalizeDynamic / scale;
    const popUpHeight = 114;
    const popUpWidth = 237;
    const wrapperTop = ((ref1 = (ref = document === null || document === void 0 ? void 0 : document.querySelector(".react-transform-wrapper")) === null || ref === void 0 ? void 0 : ref.getBoundingClientRect()) === null || ref1 === void 0 ? void 0 : ref1.top) || 0;
    const textTop = textBounds === null || textBounds === void 0 ? void 0 : textBounds.top;
    const gap = textTop - wrapperTop;
    const leftStyle = left - popUpWidth / 2 + textWidth / 2;
    const nTop = top - textHeight / 2 + normalizeStatic / 2;
    const topStyle = gap > popUpHeight ? "".concat(nTop - (popUpHeight + normalizedfactor), "px") : "".concat(nTop + normalizedfactor, "px");
    const scaleTransform = "scale(".concat(1 / scale, ")");
    const scaleOrigin = gap > popUpHeight ? "bottom" : "top";
    const stylePosition = {
        left: "".concat(leftStyle, "px"),
        height: "".concat(popUpHeight, "px"),
        top: topStyle,
        transform: scaleTransform,
        transformOrigin: scaleOrigin
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "popup-window",
            style: stylePosition,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "header-popups",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "title-notfound",
                            children: "PART NOT FOUND"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: "button-close",
                            "data-testid": "part-not-found-close",
                            onClick: ()=>setMessage(false),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* CloseIcon */.Tw, {})
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "content-popups",
                    children: "Please contact our customer service team"
                })
            ]
        })
    });
};
/* harmony default export */ var PartsDiagramViewer_PopModal = (PopModal);

;// CONCATENATED MODULE: ./node_modules/@restart/hooks/esm/useMounted.js


/**
 * Track whether a component is current mounted. Generally less preferable than
 * properlly canceling effects so they don't run after a component is unmounted,
 * but helpful in cases where that isn't feasible, such as a `Promise` resolution.
 *
 * @returns a function that returns the current isMounted state of the component
 *
 * ```ts
 * const [data, setData] = useState(null)
 * const isMounted = useMounted()
 *
 * useEffect(() => {
 *   fetchdata().then((newData) => {
 *      if (isMounted()) {
 *        setData(newData);
 *      }
 *   })
 * })
 * ```
 */
function useMounted_useMounted() {
  const mounted = (0,react.useRef)(true);
  const isMounted = (0,react.useRef)(() => mounted.current);
  (0,react.useEffect)(() => {
    mounted.current = true;
    return () => {
      mounted.current = false;
    };
  }, []);
  return isMounted.current;
}
;// CONCATENATED MODULE: ./node_modules/@restart/hooks/esm/useTimeout.js




/*
 * Browsers including Internet Explorer, Chrome, Safari, and Firefox store the
 * delay as a 32-bit signed integer internally. This causes an integer overflow
 * when using delays larger than 2,147,483,647 ms (about 24.8 days),
 * resulting in the timeout being executed immediately.
 *
 * via: https://developer.mozilla.org/en-US/docs/Web/API/WindowOrWorkerGlobalScope/setTimeout
 */
const MAX_DELAY_MS = 2 ** 31 - 1;
function setChainedTimeout(handleRef, fn, timeoutAtMs) {
  const delayMs = timeoutAtMs - Date.now();
  handleRef.current = delayMs <= MAX_DELAY_MS ? setTimeout(fn, delayMs) : setTimeout(() => setChainedTimeout(handleRef, fn, timeoutAtMs), MAX_DELAY_MS);
}

/**
 * Returns a controller object for setting a timeout that is properly cleaned up
 * once the component unmounts. New timeouts cancel and replace existing ones.
 *
 *
 *
 * ```tsx
 * const { set, clear } = useTimeout();
 * const [hello, showHello] = useState(false);
 * //Display hello after 5 seconds
 * set(() => showHello(true), 5000);
 * return (
 *   <div className="App">
 *     {hello ? <h3>Hello</h3> : null}
 *   </div>
 * );
 * ```
 */
function useTimeout() {
  const isMounted = useMounted_useMounted();

  // types are confused between node and web here IDK
  const handleRef = (0,react.useRef)();
  useWillUnmount(() => clearTimeout(handleRef.current));
  return (0,react.useMemo)(() => {
    const clear = () => clearTimeout(handleRef.current);
    function set(fn, delayMs = 0) {
      if (!isMounted()) return;
      clear();
      if (delayMs <= MAX_DELAY_MS) {
        // For simplicity, if the timeout is short, just set a normal timeout.
        handleRef.current = setTimeout(fn, delayMs);
      } else {
        setChainedTimeout(handleRef, fn, Date.now() + delayMs);
      }
    }
    return {
      set,
      clear,
      handleRef
    };
  }, []);
}
// EXTERNAL MODULE: ./node_modules/warning/warning.js
var warning = __webpack_require__(42473);
var warning_default = /*#__PURE__*/__webpack_require__.n(warning);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/invariant/browser.js
var browser = __webpack_require__(41143);
;// CONCATENATED MODULE: ./node_modules/uncontrollable/lib/esm/utils.js


var utils_noop = function noop() {};

function readOnlyPropType(handler, name) {
  return function (props, propName) {
    if (props[propName] !== undefined) {
      if (!props[handler]) {
        return new Error("You have provided a `" + propName + "` prop to `" + name + "` " + ("without an `" + handler + "` handler prop. This will render a read-only field. ") + ("If the field should be mutable use `" + defaultKey(propName) + "`. ") + ("Otherwise, set `" + handler + "`."));
      }
    }
  };
}

function uncontrolledPropTypes(controlledValues, displayName) {
  var propTypes = {};
  Object.keys(controlledValues).forEach(function (prop) {
    // add default propTypes for folks that use runtime checks
    propTypes[defaultKey(prop)] = utils_noop;

    if (false) { var handler; }
  });
  return propTypes;
}
function isProp(props, prop) {
  return props[prop] !== undefined;
}
function defaultKey(key) {
  return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
}
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

function canAcceptRef(component) {
  return !!component && (typeof component !== 'function' || component.prototype && component.prototype.isReactComponent);
}
;// CONCATENATED MODULE: ./node_modules/uncontrollable/lib/esm/hook.js



function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }

function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }




function useUncontrolledProp(propValue, defaultValue, handler) {
  var wasPropRef = (0,react.useRef)(propValue !== undefined);

  var _useState = (0,react.useState)(defaultValue),
      stateValue = _useState[0],
      setState = _useState[1];

  var isProp = propValue !== undefined;
  var wasProp = wasPropRef.current;
  wasPropRef.current = isProp;
  /**
   * If a prop switches from controlled to Uncontrolled
   * reset its value to the defaultValue
   */

  if (!isProp && wasProp && stateValue !== defaultValue) {
    setState(defaultValue);
  }

  return [isProp ? propValue : stateValue, (0,react.useCallback)(function (value) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    if (handler) handler.apply(void 0, [value].concat(args));
    setState(value);
  }, [handler])];
}


function useUncontrolled(props, config) {
  return Object.keys(config).reduce(function (result, fieldName) {
    var _extends2;

    var _ref = result,
        defaultValue = _ref[defaultKey(fieldName)],
        propsValue = _ref[fieldName],
        rest = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, [defaultKey(fieldName), fieldName].map(_toPropertyKey));

    var handlerName = config[fieldName];

    var _useUncontrolledProp = useUncontrolledProp(propsValue, defaultValue, props[handlerName]),
        value = _useUncontrolledProp[0],
        handler = _useUncontrolledProp[1];

    return (0,esm_extends/* default */.Z)({}, rest, (_extends2 = {}, _extends2[fieldName] = value, _extends2[handlerName] = handler, _extends2));
  }, props);
}
;// CONCATENATED MODULE: ./node_modules/react-lifecycles-compat/react-lifecycles-compat.es.js
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function react_lifecycles_compat_es_polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}



;// CONCATENATED MODULE: ./node_modules/uncontrollable/lib/esm/uncontrollable.js



var _jsxFileName = "/Users/jquense/src/uncontrollable/src/uncontrollable.js";




function uncontrollable(Component, controlledValues, methods) {
  if (methods === void 0) {
    methods = [];
  }

  var displayName = Component.displayName || Component.name || 'Component';
  var canAcceptRef = Utils.canAcceptRef(Component);
  var controlledProps = Object.keys(controlledValues);
  var PROPS_TO_OMIT = controlledProps.map(Utils.defaultKey);
  !(canAcceptRef || !methods.length) ?  false ? 0 : invariant(false) : void 0;

  var UncontrolledComponent =
  /*#__PURE__*/
  function (_React$Component) {
    _inheritsLoose(UncontrolledComponent, _React$Component);

    function UncontrolledComponent() {
      var _this;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
      _this.handlers = Object.create(null);
      controlledProps.forEach(function (propName) {
        var handlerName = controlledValues[propName];

        var handleChange = function handleChange(value) {
          if (_this.props[handlerName]) {
            var _this$props;

            _this._notifying = true;

            for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
              args[_key2 - 1] = arguments[_key2];
            }

            (_this$props = _this.props)[handlerName].apply(_this$props, [value].concat(args));

            _this._notifying = false;
          }

          if (!_this.unmounted) _this.setState(function (_ref) {
            var _extends2;

            var values = _ref.values;
            return {
              values: _extends(Object.create(null), values, (_extends2 = {}, _extends2[propName] = value, _extends2))
            };
          });
        };

        _this.handlers[handlerName] = handleChange;
      });
      if (methods.length) _this.attachRef = function (ref) {
        _this.inner = ref;
      };
      var values = Object.create(null);
      controlledProps.forEach(function (key) {
        values[key] = _this.props[Utils.defaultKey(key)];
      });
      _this.state = {
        values: values,
        prevProps: {}
      };
      return _this;
    }

    var _proto = UncontrolledComponent.prototype;

    _proto.shouldComponentUpdate = function shouldComponentUpdate() {
      //let setState trigger the update
      return !this._notifying;
    };

    UncontrolledComponent.getDerivedStateFromProps = function getDerivedStateFromProps(props, _ref2) {
      var values = _ref2.values,
          prevProps = _ref2.prevProps;
      var nextState = {
        values: _extends(Object.create(null), values),
        prevProps: {}
      };
      controlledProps.forEach(function (key) {
        /**
         * If a prop switches from controlled to Uncontrolled
         * reset its value to the defaultValue
         */
        nextState.prevProps[key] = props[key];

        if (!Utils.isProp(props, key) && Utils.isProp(prevProps, key)) {
          nextState.values[key] = props[Utils.defaultKey(key)];
        }
      });
      return nextState;
    };

    _proto.componentWillUnmount = function componentWillUnmount() {
      this.unmounted = true;
    };

    _proto.render = function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          innerRef = _this$props2.innerRef,
          props = _objectWithoutPropertiesLoose(_this$props2, ["innerRef"]);

      PROPS_TO_OMIT.forEach(function (prop) {
        delete props[prop];
      });
      var newProps = {};
      controlledProps.forEach(function (propName) {
        var propValue = _this2.props[propName];
        newProps[propName] = propValue !== undefined ? propValue : _this2.state.values[propName];
      });
      return React.createElement(Component, _extends({}, props, newProps, this.handlers, {
        ref: innerRef || this.attachRef
      }));
    };

    return UncontrolledComponent;
  }(React.Component);

  polyfill(UncontrolledComponent);
  UncontrolledComponent.displayName = "Uncontrolled(" + displayName + ")";
  UncontrolledComponent.propTypes = _extends({
    innerRef: function innerRef() {}
  }, Utils.uncontrolledPropTypes(controlledValues, displayName));
  methods.forEach(function (method) {
    UncontrolledComponent.prototype[method] = function $proxiedMethod() {
      var _this$inner;

      return (_this$inner = this.inner)[method].apply(_this$inner, arguments);
    };
  });
  var WrappedComponent = UncontrolledComponent;

  if (React.forwardRef) {
    WrappedComponent = React.forwardRef(function (props, ref) {
      return React.createElement(UncontrolledComponent, _extends({}, props, {
        innerRef: ref,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 128
        },
        __self: this
      }));
    });
    WrappedComponent.propTypes = UncontrolledComponent.propTypes;
  }

  WrappedComponent.ControlledComponent = Component;
  /**
   * useful when wrapping a Component and you want to control
   * everything
   */

  WrappedComponent.deferControlTo = function (newComponent, additions, nextMethods) {
    if (additions === void 0) {
      additions = {};
    }

    return uncontrollable(newComponent, _extends({}, controlledValues, additions), nextMethods);
  };

  return WrappedComponent;
}
;// CONCATENATED MODULE: ./node_modules/uncontrollable/lib/esm/index.js


;// CONCATENATED MODULE: ./node_modules/@restart/ui/node_modules/@restart/hooks/esm/useCallbackRef.js


/**
 * A convenience hook around `useState` designed to be paired with
 * the component [callback ref](https://reactjs.org/docs/refs-and-the-dom.html#callback-refs) api.
 * Callback refs are useful over `useRef()` when you need to respond to the ref being set
 * instead of lazily accessing it in an effect.
 *
 * ```ts
 * const [element, attachRef] = useCallbackRef<HTMLDivElement>()
 *
 * useEffect(() => {
 *   if (!element) return
 *
 *   const calendar = new FullCalendar.Calendar(element)
 *
 *   return () => {
 *     calendar.destroy()
 *   }
 * }, [element])
 *
 * return <div ref={attachRef} />
 * ```
 *
 * @category refs
 */
function useCallbackRef_useCallbackRef() {
  return (0,react.useState)(null);
}
;// CONCATENATED MODULE: ./node_modules/dequal/dist/index.mjs
var has = Object.prototype.hasOwnProperty;

function find(iter, tar, key) {
	for (key of iter.keys()) {
		if (dequal(key, tar)) return key;
	}
}

function dequal(foo, bar) {
	var ctor, len, tmp;
	if (foo === bar) return true;

	if (foo && bar && (ctor=foo.constructor) === bar.constructor) {
		if (ctor === Date) return foo.getTime() === bar.getTime();
		if (ctor === RegExp) return foo.toString() === bar.toString();

		if (ctor === Array) {
			if ((len=foo.length) === bar.length) {
				while (len-- && dequal(foo[len], bar[len]));
			}
			return len === -1;
		}

		if (ctor === Set) {
			if (foo.size !== bar.size) {
				return false;
			}
			for (len of foo) {
				tmp = len;
				if (tmp && typeof tmp === 'object') {
					tmp = find(bar, tmp);
					if (!tmp) return false;
				}
				if (!bar.has(tmp)) return false;
			}
			return true;
		}

		if (ctor === Map) {
			if (foo.size !== bar.size) {
				return false;
			}
			for (len of foo) {
				tmp = len[0];
				if (tmp && typeof tmp === 'object') {
					tmp = find(bar, tmp);
					if (!tmp) return false;
				}
				if (!dequal(len[1], bar.get(tmp))) {
					return false;
				}
			}
			return true;
		}

		if (ctor === ArrayBuffer) {
			foo = new Uint8Array(foo);
			bar = new Uint8Array(bar);
		} else if (ctor === DataView) {
			if ((len=foo.byteLength) === bar.byteLength) {
				while (len-- && foo.getInt8(len) === bar.getInt8(len));
			}
			return len === -1;
		}

		if (ArrayBuffer.isView(foo)) {
			if ((len=foo.byteLength) === bar.byteLength) {
				while (len-- && foo[len] === bar[len]);
			}
			return len === -1;
		}

		if (!ctor || typeof foo === 'object') {
			len = 0;
			for (ctor in foo) {
				if (has.call(foo, ctor) && ++len && !has.call(bar, ctor)) return false;
				if (!(ctor in bar) || !dequal(foo[ctor], bar[ctor])) return false;
			}
			return Object.keys(bar).length === len;
		}
	}

	return foo !== foo && bar !== bar;
}

;// CONCATENATED MODULE: ./node_modules/@restart/ui/node_modules/@restart/hooks/esm/useSafeState.js



/**
 * `useSafeState` takes the return value of a `useState` hook and wraps the
 * setter to prevent updates onces the component has unmounted. Can used
 * with `useMergeState` and `useStateAsync` as well
 *
 * @param state The return value of a useStateHook
 *
 * ```ts
 * const [show, setShow] = useSafeState(useState(true));
 * ```
 */

function useSafeState(state) {
  const isMounted = useMounted();
  return [state[0], (0,react.useCallback)(nextState => {
    if (!isMounted()) return;
    return state[1](nextState);
  }, [isMounted, state[1]])];
}
/* harmony default export */ var esm_useSafeState = (useSafeState);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/modifiers/arrow.js
var arrow = __webpack_require__(66896);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/modifiers/computeStyles.js
var computeStyles = __webpack_require__(36531);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/modifiers/eventListeners.js
var eventListeners = __webpack_require__(82372);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/modifiers/flip.js + 3 modules
var flip = __webpack_require__(68855);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/modifiers/hide.js
var hide = __webpack_require__(19892);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/modifiers/offset.js
var offset = __webpack_require__(82122);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/modifiers/popperOffsets.js
var popperOffsets = __webpack_require__(77421);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/modifiers/preventOverflow.js + 1 modules
var preventOverflow = __webpack_require__(394);
// EXTERNAL MODULE: ./node_modules/@popperjs/core/lib/createPopper.js + 6 modules
var createPopper = __webpack_require__(45704);
;// CONCATENATED MODULE: ./node_modules/@restart/ui/esm/popper.js











// For the common JS build we will turn this file into a bundle with no imports.
// This is b/c the Popper lib is all esm files, and would break in a common js only environment
const popper_createPopper = (0,createPopper/* popperGenerator */.kZ)({
  defaultModifiers: [hide/* default */.Z, popperOffsets/* default */.Z, computeStyles/* default */.Z, eventListeners/* default */.Z, offset/* default */.Z, flip/* default */.Z, preventOverflow/* default */.Z, arrow/* default */.Z]
});

;// CONCATENATED MODULE: ./node_modules/@restart/ui/esm/usePopper.js
const usePopper_excluded = ["enabled", "placement", "strategy", "modifiers"];
function usePopper_objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }




const disabledApplyStylesModifier = {
  name: 'applyStyles',
  enabled: false,
  phase: 'afterWrite',
  fn: () => undefined
};

// until docjs supports type exports...

const ariaDescribedByModifier = {
  name: 'ariaDescribedBy',
  enabled: true,
  phase: 'afterWrite',
  effect: ({
    state
  }) => () => {
    const {
      reference,
      popper
    } = state.elements;
    if ('removeAttribute' in reference) {
      const ids = (reference.getAttribute('aria-describedby') || '').split(',').filter(id => id.trim() !== popper.id);
      if (!ids.length) reference.removeAttribute('aria-describedby');else reference.setAttribute('aria-describedby', ids.join(','));
    }
  },
  fn: ({
    state
  }) => {
    var _popper$getAttribute;
    const {
      popper,
      reference
    } = state.elements;
    const role = (_popper$getAttribute = popper.getAttribute('role')) == null ? void 0 : _popper$getAttribute.toLowerCase();
    if (popper.id && role === 'tooltip' && 'setAttribute' in reference) {
      const ids = reference.getAttribute('aria-describedby');
      if (ids && ids.split(',').indexOf(popper.id) !== -1) {
        return;
      }
      reference.setAttribute('aria-describedby', ids ? `${ids},${popper.id}` : popper.id);
    }
  }
};
const EMPTY_MODIFIERS = [];
/**
 * Position an element relative some reference element using Popper.js
 *
 * @param referenceElement
 * @param popperElement
 * @param {object}      options
 * @param {object=}     options.modifiers Popper.js modifiers
 * @param {boolean=}    options.enabled toggle the popper functionality on/off
 * @param {string=}     options.placement The popper element placement relative to the reference element
 * @param {string=}     options.strategy the positioning strategy
 * @param {function=}   options.onCreate called when the popper is created
 * @param {function=}   options.onUpdate called when the popper is updated
 *
 * @returns {UsePopperState} The popper state
 */
function usePopper(referenceElement, popperElement, _ref = {}) {
  let {
      enabled = true,
      placement = 'bottom',
      strategy = 'absolute',
      modifiers = EMPTY_MODIFIERS
    } = _ref,
    config = usePopper_objectWithoutPropertiesLoose(_ref, usePopper_excluded);
  const prevModifiers = (0,react.useRef)(modifiers);
  const popperInstanceRef = (0,react.useRef)();
  const update = (0,react.useCallback)(() => {
    var _popperInstanceRef$cu;
    (_popperInstanceRef$cu = popperInstanceRef.current) == null ? void 0 : _popperInstanceRef$cu.update();
  }, []);
  const forceUpdate = (0,react.useCallback)(() => {
    var _popperInstanceRef$cu2;
    (_popperInstanceRef$cu2 = popperInstanceRef.current) == null ? void 0 : _popperInstanceRef$cu2.forceUpdate();
  }, []);
  const [popperState, setState] = esm_useSafeState((0,react.useState)({
    placement,
    update,
    forceUpdate,
    attributes: {},
    styles: {
      popper: {},
      arrow: {}
    }
  }));
  const updateModifier = (0,react.useMemo)(() => ({
    name: 'updateStateModifier',
    enabled: true,
    phase: 'write',
    requires: ['computeStyles'],
    fn: ({
      state
    }) => {
      const styles = {};
      const attributes = {};
      Object.keys(state.elements).forEach(element => {
        styles[element] = state.styles[element];
        attributes[element] = state.attributes[element];
      });
      setState({
        state,
        styles,
        attributes,
        update,
        forceUpdate,
        placement: state.placement
      });
    }
  }), [update, forceUpdate, setState]);
  const nextModifiers = (0,react.useMemo)(() => {
    if (!dequal(prevModifiers.current, modifiers)) {
      prevModifiers.current = modifiers;
    }
    return prevModifiers.current;
  }, [modifiers]);
  (0,react.useEffect)(() => {
    if (!popperInstanceRef.current || !enabled) return;
    popperInstanceRef.current.setOptions({
      placement,
      strategy,
      modifiers: [...nextModifiers, updateModifier, disabledApplyStylesModifier]
    });
  }, [strategy, placement, updateModifier, enabled, nextModifiers]);
  (0,react.useEffect)(() => {
    if (!enabled || referenceElement == null || popperElement == null) {
      return undefined;
    }
    popperInstanceRef.current = popper_createPopper(referenceElement, popperElement, Object.assign({}, config, {
      placement,
      strategy,
      modifiers: [...nextModifiers, ariaDescribedByModifier, updateModifier]
    }));
    return () => {
      if (popperInstanceRef.current != null) {
        popperInstanceRef.current.destroy();
        popperInstanceRef.current = undefined;
        setState(s => Object.assign({}, s, {
          attributes: {},
          styles: {
            popper: {}
          }
        }));
      }
    };
    // This is only run once to _create_ the popper
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enabled, referenceElement, popperElement]);
  return popperState;
}
/* harmony default export */ var esm_usePopper = (usePopper);
;// CONCATENATED MODULE: ./node_modules/@restart/ui/esm/useClickOutside.js






const useClickOutside_noop = () => {};
function isLeftClickEvent(event) {
  return event.button === 0;
}
function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
const getRefTarget = ref => ref && ('current' in ref ? ref.current : ref);
const InitialTriggerEvents = {
  click: 'mousedown',
  mouseup: 'mousedown',
  pointerup: 'pointerdown'
};

/**
 * The `useClickOutside` hook registers your callback on the document that fires
 * when a pointer event is registered outside of the provided ref or element.
 *
 * @param {Ref<HTMLElement>| HTMLElement} ref  The element boundary
 * @param {function} onClickOutside
 * @param {object=}  options
 * @param {boolean=} options.disabled
 * @param {string=}  options.clickTrigger The DOM event name (click, mousedown, etc) to attach listeners on
 */
function useClickOutside(ref, onClickOutside = useClickOutside_noop, {
  disabled,
  clickTrigger = 'click'
} = {}) {
  const preventMouseClickOutsideRef = (0,react.useRef)(false);
  const waitingForTrigger = (0,react.useRef)(false);
  const handleMouseCapture = (0,react.useCallback)(e => {
    const currentTarget = getRefTarget(ref);
    warning_default()(!!currentTarget, 'ClickOutside captured a close event but does not have a ref to compare it to. ' + 'useClickOutside(), should be passed a ref that resolves to a DOM node');
    preventMouseClickOutsideRef.current = !currentTarget || isModifiedEvent(e) || !isLeftClickEvent(e) || !!contains(currentTarget, e.target) || waitingForTrigger.current;
    waitingForTrigger.current = false;
  }, [ref]);
  const handleInitialMouse = esm_useEventCallback_useEventCallback(e => {
    const currentTarget = getRefTarget(ref);
    if (currentTarget && contains(currentTarget, e.target)) {
      waitingForTrigger.current = true;
    } else {
      // When clicking on scrollbars within current target, click events are not triggered, so this ref
      // is never reset inside `handleMouseCapture`. This would cause a bug where it requires 2 clicks
      // to close the overlay.
      waitingForTrigger.current = false;
    }
  });
  const handleMouse = esm_useEventCallback_useEventCallback(e => {
    if (!preventMouseClickOutsideRef.current) {
      onClickOutside(e);
    }
  });
  (0,react.useEffect)(() => {
    var _ownerWindow$event, _ownerWindow$parent;
    if (disabled || ref == null) return undefined;
    const doc = ownerDocument(getRefTarget(ref));
    const ownerWindow = doc.defaultView || window;

    // Store the current event to avoid triggering handlers immediately
    // For things rendered in an iframe, the event might originate on the parent window
    // so we should fall back to that global event if the local one doesn't exist
    // https://github.com/facebook/react/issues/20074
    let currentEvent = (_ownerWindow$event = ownerWindow.event) != null ? _ownerWindow$event : (_ownerWindow$parent = ownerWindow.parent) == null ? void 0 : _ownerWindow$parent.event;
    let removeInitialTriggerListener = null;
    if (InitialTriggerEvents[clickTrigger]) {
      removeInitialTriggerListener = esm_listen(doc, InitialTriggerEvents[clickTrigger], handleInitialMouse, true);
    }

    // Use capture for this listener so it fires before React's listener, to
    // avoid false positives in the contains() check below if the target DOM
    // element is removed in the React mouse callback.
    const removeMouseCaptureListener = esm_listen(doc, clickTrigger, handleMouseCapture, true);
    const removeMouseListener = esm_listen(doc, clickTrigger, e => {
      // skip if this event is the same as the one running when we added the handlers
      if (e === currentEvent) {
        currentEvent = undefined;
        return;
      }
      handleMouse(e);
    });
    let mobileSafariHackListeners = [];
    if ('ontouchstart' in doc.documentElement) {
      mobileSafariHackListeners = [].slice.call(doc.body.children).map(el => esm_listen(el, 'mousemove', useClickOutside_noop));
    }
    return () => {
      removeInitialTriggerListener == null ? void 0 : removeInitialTriggerListener();
      removeMouseCaptureListener();
      removeMouseListener();
      mobileSafariHackListeners.forEach(remove => remove());
    };
  }, [ref, disabled, clickTrigger, handleMouseCapture, handleInitialMouse, handleMouse]);
}
/* harmony default export */ var esm_useClickOutside = (useClickOutside);
;// CONCATENATED MODULE: ./node_modules/@restart/ui/esm/useRootClose.js






const useRootClose_noop = () => {};
/**
 * The `useRootClose` hook registers your callback on the document
 * when rendered. Powers the `<Overlay/>` component. This is used achieve modal
 * style behavior where your callback is triggered when the user tries to
 * interact with the rest of the document or hits the `esc` key.
 *
 * @param {Ref<HTMLElement>| HTMLElement} ref  The element boundary
 * @param {function} onRootClose
 * @param {object=}  options
 * @param {boolean=} options.disabled
 * @param {string=}  options.clickTrigger The DOM event name (click, mousedown, etc) to attach listeners on
 */
function useRootClose(ref, onRootClose, {
  disabled,
  clickTrigger
} = {}) {
  const onClose = onRootClose || useRootClose_noop;
  esm_useClickOutside(ref, onClose, {
    disabled,
    clickTrigger
  });
  const handleKeyUp = esm_useEventCallback_useEventCallback(e => {
    if (isEscKey(e)) {
      onClose(e);
    }
  });
  (0,react.useEffect)(() => {
    if (disabled || ref == null) return undefined;
    const doc = ownerDocument(getRefTarget(ref));

    // Store the current event to avoid triggering handlers immediately
    // https://github.com/facebook/react/issues/20074
    let currentEvent = (doc.defaultView || window).event;
    const removeKeyupListener = esm_listen(doc, 'keyup', e => {
      // skip if this event is the same as the one running when we added the handlers
      if (e === currentEvent) {
        currentEvent = undefined;
        return;
      }
      handleKeyUp(e);
    });
    return () => {
      removeKeyupListener();
    };
  }, [ref, disabled, handleKeyUp]);
}
/* harmony default export */ var esm_useRootClose = (useRootClose);
;// CONCATENATED MODULE: ./node_modules/@restart/ui/esm/mergeOptionsWithPopperConfig.js
function toModifierMap(modifiers) {
  const result = {};
  if (!Array.isArray(modifiers)) {
    return modifiers || result;
  }

  // eslint-disable-next-line no-unused-expressions
  modifiers == null ? void 0 : modifiers.forEach(m => {
    result[m.name] = m;
  });
  return result;
}
function toModifierArray(map = {}) {
  if (Array.isArray(map)) return map;
  return Object.keys(map).map(k => {
    map[k].name = k;
    return map[k];
  });
}
function mergeOptionsWithPopperConfig({
  enabled,
  enableEvents,
  placement,
  flip,
  offset,
  fixed,
  containerPadding,
  arrowElement,
  popperConfig = {}
}) {
  var _modifiers$eventListe, _modifiers$preventOve, _modifiers$preventOve2, _modifiers$offset, _modifiers$arrow;
  const modifiers = toModifierMap(popperConfig.modifiers);
  return Object.assign({}, popperConfig, {
    placement,
    enabled,
    strategy: fixed ? 'fixed' : popperConfig.strategy,
    modifiers: toModifierArray(Object.assign({}, modifiers, {
      eventListeners: {
        enabled: enableEvents,
        options: (_modifiers$eventListe = modifiers.eventListeners) == null ? void 0 : _modifiers$eventListe.options
      },
      preventOverflow: Object.assign({}, modifiers.preventOverflow, {
        options: containerPadding ? Object.assign({
          padding: containerPadding
        }, (_modifiers$preventOve = modifiers.preventOverflow) == null ? void 0 : _modifiers$preventOve.options) : (_modifiers$preventOve2 = modifiers.preventOverflow) == null ? void 0 : _modifiers$preventOve2.options
      }),
      offset: {
        options: Object.assign({
          offset
        }, (_modifiers$offset = modifiers.offset) == null ? void 0 : _modifiers$offset.options)
      },
      arrow: Object.assign({}, modifiers.arrow, {
        enabled: !!arrowElement,
        options: Object.assign({}, (_modifiers$arrow = modifiers.arrow) == null ? void 0 : _modifiers$arrow.options, {
          element: arrowElement
        })
      }),
      flip: Object.assign({
        enabled: !!flip
      }, modifiers.flip)
    }))
  });
}
;// CONCATENATED MODULE: ./node_modules/@restart/ui/esm/Overlay.js










/**
 * Built on top of `Popper.js`, the overlay component is
 * great for custom tooltip overlays.
 */
const Overlay = /*#__PURE__*/react.forwardRef((props, outerRef) => {
  const {
    flip,
    offset,
    placement,
    containerPadding,
    popperConfig = {},
    transition: Transition,
    runTransition
  } = props;
  const [rootElement, attachRef] = useCallbackRef_useCallbackRef();
  const [arrowElement, attachArrowRef] = useCallbackRef_useCallbackRef();
  const mergedRef = hooks_esm_useMergedRefs(attachRef, outerRef);
  const container = useWaitForDOMRef(props.container);
  const target = useWaitForDOMRef(props.target);
  const [exited, setExited] = (0,react.useState)(!props.show);
  const popper = esm_usePopper(target, rootElement, mergeOptionsWithPopperConfig({
    placement,
    enableEvents: !!props.show,
    containerPadding: containerPadding || 5,
    flip,
    offset,
    arrowElement,
    popperConfig
  }));

  // TODO: I think this needs to be in an effect
  if (props.show && exited) {
    setExited(false);
  }
  const handleHidden = (...args) => {
    setExited(true);
    if (props.onExited) {
      props.onExited(...args);
    }
  };

  // Don't un-render the overlay while it's transitioning out.
  const mountOverlay = props.show || !exited;
  esm_useRootClose(rootElement, props.onHide, {
    disabled: !props.rootClose || props.rootCloseDisabled,
    clickTrigger: props.rootCloseEvent
  });
  if (!mountOverlay) {
    // Don't bother showing anything if we don't have to.
    return null;
  }
  const {
    onExit,
    onExiting,
    onEnter,
    onEntering,
    onEntered
  } = props;
  let child = props.children(Object.assign({}, popper.attributes.popper, {
    style: popper.styles.popper,
    ref: mergedRef
  }), {
    popper,
    placement,
    show: !!props.show,
    arrowProps: Object.assign({}, popper.attributes.arrow, {
      style: popper.styles.arrow,
      ref: attachArrowRef
    })
  });
  child = renderTransition(Transition, runTransition, {
    in: !!props.show,
    appear: true,
    mountOnEnter: true,
    unmountOnExit: true,
    children: child,
    onExit,
    onExiting,
    onExited: handleHidden,
    onEnter,
    onEntering,
    onEntered
  });
  return container ? /*#__PURE__*/react_dom.createPortal(child, container) : null;
});
Overlay.displayName = 'Overlay';
/* harmony default export */ var esm_Overlay = (Overlay);
;// CONCATENATED MODULE: ./node_modules/@restart/hooks/esm/useIsomorphicEffect.js

const useIsomorphicEffect_isReactNative = typeof __webpack_require__.g !== 'undefined' &&
// @ts-ignore
__webpack_require__.g.navigator &&
// @ts-ignore
__webpack_require__.g.navigator.product === 'ReactNative';
const useIsomorphicEffect_isDOM = typeof document !== 'undefined';

/**
 * Is `useLayoutEffect` in a DOM or React Native environment, otherwise resolves to useEffect
 * Only useful to avoid the console warning.
 *
 * PREFER `useEffect` UNLESS YOU KNOW WHAT YOU ARE DOING.
 *
 * @category effects
 */
/* harmony default export */ var esm_useIsomorphicEffect = (useIsomorphicEffect_isDOM || useIsomorphicEffect_isReactNative ? react.useLayoutEffect : react.useEffect);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/PopoverHeader.js
"use client";





const PopoverHeader = /*#__PURE__*/react.forwardRef(({
  className,
  bsPrefix,
  as: Component = 'div',
  ...props
}, ref) => {
  bsPrefix = useBootstrapPrefix(bsPrefix, 'popover-header');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    ref: ref,
    className: classnames_default()(className, bsPrefix),
    ...props
  });
});
PopoverHeader.displayName = 'PopoverHeader';
/* harmony default export */ var esm_PopoverHeader = (PopoverHeader);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/PopoverBody.js
"use client";





const PopoverBody = /*#__PURE__*/react.forwardRef(({
  className,
  bsPrefix,
  as: Component = 'div',
  ...props
}, ref) => {
  bsPrefix = useBootstrapPrefix(bsPrefix, 'popover-body');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    ref: ref,
    className: classnames_default()(className, bsPrefix),
    ...props
  });
});
PopoverBody.displayName = 'PopoverBody';
/* harmony default export */ var esm_PopoverBody = (PopoverBody);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/helpers.js

class BsPrefixComponent extends react.Component {}

// Need to use this instead of typeof Component to get proper type checking.

function getOverlayDirection(placement, isRTL) {
  let bsDirection = placement;
  if (placement === 'left') {
    bsDirection = isRTL ? 'end' : 'start';
  } else if (placement === 'right') {
    bsDirection = isRTL ? 'start' : 'end';
  }
  return bsDirection;
}
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/getInitialPopperStyles.js
function getInitialPopperStyles(position = 'absolute') {
  return {
    position,
    top: '0',
    left: '0',
    opacity: '0',
    pointerEvents: 'none'
  };
}
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/Popover.js
"use client";










const Popover = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  placement = 'right',
  className,
  style,
  children,
  body,
  arrowProps,
  hasDoneInitialMeasure,
  popper,
  show,
  ...props
}, ref) => {
  const decoratedBsPrefix = useBootstrapPrefix(bsPrefix, 'popover');
  const isRTL = useIsRTL();
  const [primaryPlacement] = (placement == null ? void 0 : placement.split('-')) || [];
  const bsDirection = getOverlayDirection(primaryPlacement, isRTL);
  let computedStyle = style;
  if (show && !hasDoneInitialMeasure) {
    computedStyle = {
      ...style,
      ...getInitialPopperStyles(popper == null ? void 0 : popper.strategy)
    };
  }
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    ref: ref,
    role: "tooltip",
    style: computedStyle,
    "x-placement": primaryPlacement,
    className: classnames_default()(className, decoratedBsPrefix, primaryPlacement && `bs-popover-${bsDirection}`),
    ...props,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "popover-arrow",
      ...arrowProps
    }), body ? /*#__PURE__*/(0,jsx_runtime.jsx)(esm_PopoverBody, {
      children: children
    }) : children]
  });
});
Popover.displayName = 'Popover';
/* harmony default export */ var esm_Popover = (Object.assign(Popover, {
  Header: esm_PopoverHeader,
  Body: esm_PopoverBody,
  // Default popover offset.
  // https://github.com/twbs/bootstrap/blob/5c32767e0e0dbac2d934bcdee03719a65d3f1187/js/src/popover.js#L28
  POPPER_OFFSET: [0, 8]
}));
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/Tooltip.js
"use client";








const Tooltip = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  placement = 'right',
  className,
  style,
  children,
  arrowProps,
  hasDoneInitialMeasure,
  popper,
  show,
  ...props
}, ref) => {
  bsPrefix = useBootstrapPrefix(bsPrefix, 'tooltip');
  const isRTL = useIsRTL();
  const [primaryPlacement] = (placement == null ? void 0 : placement.split('-')) || [];
  const bsDirection = getOverlayDirection(primaryPlacement, isRTL);
  let computedStyle = style;
  if (show && !hasDoneInitialMeasure) {
    computedStyle = {
      ...style,
      ...getInitialPopperStyles(popper == null ? void 0 : popper.strategy)
    };
  }
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    ref: ref,
    style: computedStyle,
    role: "tooltip",
    "x-placement": primaryPlacement,
    className: classnames_default()(className, bsPrefix, `bs-tooltip-${bsDirection}`),
    ...props,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "tooltip-arrow",
      ...arrowProps
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: `${bsPrefix}-inner`,
      children: children
    })]
  });
});
Tooltip.displayName = 'Tooltip';
/* harmony default export */ var esm_Tooltip = (Object.assign(Tooltip, {
  // Default tooltip offset.
  // https://github.com/twbs/bootstrap/blob/beca2a6c7f6bc88b6449339fc76edcda832c59e5/js/src/tooltip.js#L65
  TOOLTIP_OFFSET: [0, 6]
}));
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/useOverlayOffset.js
"use client";







// This is meant for internal use.
// This applies a custom offset to the overlay if it's a popover or tooltip.
function useOverlayOffset(customOffset) {
  const overlayRef = (0,react.useRef)(null);
  const popoverClass = useBootstrapPrefix(undefined, 'popover');
  const tooltipClass = useBootstrapPrefix(undefined, 'tooltip');
  const offset = (0,react.useMemo)(() => ({
    name: 'offset',
    options: {
      offset: () => {
        if (customOffset) {
          return customOffset;
        }
        if (overlayRef.current) {
          if (hasClass(overlayRef.current, popoverClass)) {
            return esm_Popover.POPPER_OFFSET;
          }
          if (hasClass(overlayRef.current, tooltipClass)) {
            return esm_Tooltip.TOOLTIP_OFFSET;
          }
        }
        return [0, 0];
      }
    }
  }), [customOffset, popoverClass, tooltipClass]);
  return [overlayRef, [offset]];
}
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/Overlay.js
"use client";












function wrapRefs(props, arrowProps) {
  const {
    ref
  } = props;
  const {
    ref: aRef
  } = arrowProps;
  props.ref = ref.__wrapped || (ref.__wrapped = r => ref(safeFindDOMNode(r)));
  arrowProps.ref = aRef.__wrapped || (aRef.__wrapped = r => aRef(safeFindDOMNode(r)));
}
const Overlay_Overlay = /*#__PURE__*/react.forwardRef(({
  children: overlay,
  transition = esm_Fade,
  popperConfig = {},
  rootClose = false,
  placement = 'top',
  show: outerShow = false,
  ...outerProps
}, outerRef) => {
  const popperRef = (0,react.useRef)({});
  const [firstRenderedState, setFirstRenderedState] = (0,react.useState)(null);
  const [ref, modifiers] = useOverlayOffset(outerProps.offset);
  const mergedRef = esm_useMergedRefs(outerRef, ref);
  const actualTransition = transition === true ? esm_Fade : transition || undefined;
  const handleFirstUpdate = useEventCallback_useEventCallback(state => {
    setFirstRenderedState(state);
    popperConfig == null || popperConfig.onFirstUpdate == null || popperConfig.onFirstUpdate(state);
  });
  esm_useIsomorphicEffect(() => {
    if (firstRenderedState && outerProps.target) {
      // Must wait for target element to resolve before updating popper.
      popperRef.current.scheduleUpdate == null || popperRef.current.scheduleUpdate();
    }
  }, [firstRenderedState, outerProps.target]);
  (0,react.useEffect)(() => {
    if (!outerShow) {
      setFirstRenderedState(null);
    }
  }, [outerShow]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(esm_Overlay, {
    ...outerProps,
    ref: mergedRef,
    popperConfig: {
      ...popperConfig,
      modifiers: modifiers.concat(popperConfig.modifiers || []),
      onFirstUpdate: handleFirstUpdate
    },
    transition: actualTransition,
    rootClose: rootClose,
    placement: placement,
    show: outerShow,
    children: (overlayProps, {
      arrowProps,
      popper: popperObj,
      show
    }) => {
      var _popperObj$state;
      wrapRefs(overlayProps, arrowProps);
      // Need to get placement from popper object, handling case when overlay is flipped using 'flip' prop
      const updatedPlacement = popperObj == null ? void 0 : popperObj.placement;
      const popper = Object.assign(popperRef.current, {
        state: popperObj == null ? void 0 : popperObj.state,
        scheduleUpdate: popperObj == null ? void 0 : popperObj.update,
        placement: updatedPlacement,
        outOfBoundaries: (popperObj == null || (_popperObj$state = popperObj.state) == null || (_popperObj$state = _popperObj$state.modifiersData.hide) == null ? void 0 : _popperObj$state.isReferenceHidden) || false,
        strategy: popperConfig.strategy
      });
      const hasDoneInitialMeasure = !!firstRenderedState;
      if (typeof overlay === 'function') return overlay({
        ...overlayProps,
        placement: updatedPlacement,
        show,
        ...(!transition && show && {
          className: 'show'
        }),
        popper,
        arrowProps,
        hasDoneInitialMeasure
      });
      return /*#__PURE__*/react.cloneElement(overlay, {
        ...overlayProps,
        placement: updatedPlacement,
        arrowProps,
        popper,
        hasDoneInitialMeasure,
        className: classnames_default()(overlay.props.className, !transition && show && 'show'),
        style: {
          ...overlay.props.style,
          ...overlayProps.style
        }
      });
    }
  });
});
Overlay_Overlay.displayName = 'Overlay';
/* harmony default export */ var react_bootstrap_esm_Overlay = (Overlay_Overlay);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/OverlayTrigger.js
"use client";















function normalizeDelay(delay) {
  return delay && typeof delay === 'object' ? delay : {
    show: delay,
    hide: delay
  };
}

// Simple implementation of mouseEnter and mouseLeave.
// React's built version is broken: https://github.com/facebook/react/issues/4251
// for cases when the trigger is disabled and mouseOut/Over can cause flicker
// moving from one child element to another.
function handleMouseOverOut(handler, args, relatedNative) {
  const [e] = args;
  const target = e.currentTarget;
  const related = e.relatedTarget || e.nativeEvent[relatedNative];
  if ((!related || related !== target) && !contains(target, related)) {
    handler(...args);
  }
}
const triggerType = prop_types_default().oneOf(['click', 'hover', 'focus']);
const OverlayTrigger = ({
  trigger = ['hover', 'focus'],
  overlay,
  children,
  popperConfig = {},
  show: propsShow,
  defaultShow = false,
  onToggle,
  delay: propsDelay,
  placement,
  flip = placement && placement.indexOf('auto') !== -1,
  ...props
}) => {
  const triggerNodeRef = (0,react.useRef)(null);
  const mergedRef = esm_useMergedRefs(triggerNodeRef, getChildRef(children));
  const timeout = useTimeout();
  const hoverStateRef = (0,react.useRef)('');
  const [show, setShow] = useUncontrolledProp(propsShow, defaultShow, onToggle);
  const delay = normalizeDelay(propsDelay);
  const {
    onFocus,
    onBlur,
    onClick
  } = typeof children !== 'function' ? react.Children.only(children).props : {};
  const attachRef = r => {
    mergedRef(safeFindDOMNode(r));
  };
  const handleShow = (0,react.useCallback)(() => {
    timeout.clear();
    hoverStateRef.current = 'show';
    if (!delay.show) {
      setShow(true);
      return;
    }
    timeout.set(() => {
      if (hoverStateRef.current === 'show') setShow(true);
    }, delay.show);
  }, [delay.show, setShow, timeout]);
  const handleHide = (0,react.useCallback)(() => {
    timeout.clear();
    hoverStateRef.current = 'hide';
    if (!delay.hide) {
      setShow(false);
      return;
    }
    timeout.set(() => {
      if (hoverStateRef.current === 'hide') setShow(false);
    }, delay.hide);
  }, [delay.hide, setShow, timeout]);
  const handleFocus = (0,react.useCallback)((...args) => {
    handleShow();
    onFocus == null || onFocus(...args);
  }, [handleShow, onFocus]);
  const handleBlur = (0,react.useCallback)((...args) => {
    handleHide();
    onBlur == null || onBlur(...args);
  }, [handleHide, onBlur]);
  const handleClick = (0,react.useCallback)((...args) => {
    setShow(!show);
    onClick == null || onClick(...args);
  }, [onClick, setShow, show]);
  const handleMouseOver = (0,react.useCallback)((...args) => {
    handleMouseOverOut(handleShow, args, 'fromElement');
  }, [handleShow]);
  const handleMouseOut = (0,react.useCallback)((...args) => {
    handleMouseOverOut(handleHide, args, 'toElement');
  }, [handleHide]);
  const triggers = trigger == null ? [] : [].concat(trigger);
  const triggerProps = {
    ref: attachRef
  };
  if (triggers.indexOf('click') !== -1) {
    triggerProps.onClick = handleClick;
  }
  if (triggers.indexOf('focus') !== -1) {
    triggerProps.onFocus = handleFocus;
    triggerProps.onBlur = handleBlur;
  }
  if (triggers.indexOf('hover') !== -1) {
     false ? 0 : void 0;
    triggerProps.onMouseOver = handleMouseOver;
    triggerProps.onMouseOut = handleMouseOut;
  }
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [typeof children === 'function' ? children(triggerProps) : /*#__PURE__*/(0,react.cloneElement)(children, triggerProps), /*#__PURE__*/(0,jsx_runtime.jsx)(react_bootstrap_esm_Overlay, {
      ...props,
      show: show,
      onHide: handleHide,
      flip: flip,
      placement: placement,
      popperConfig: popperConfig,
      target: triggerNodeRef.current,
      children: overlay
    })]
  });
};
/* harmony default export */ var esm_OverlayTrigger = (OverlayTrigger);
;// CONCATENATED MODULE: ./components/PartsViewer/v2/ToolTip/index.js



const ToolTip = (props)=>{
    const { children , text ="No text" , placement ="left" , show =true  } = props;
    return show ? /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_OverlayTrigger, {
        placement: placement,
        overlay: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_Tooltip, {
            className: "bg-color",
            children: text
        }),
        delay: {
            show: 0,
            hide: 0
        },
        children: children
    }, placement) : children;
};
/* harmony default export */ var v2_ToolTip = (ToolTip);

;// CONCATENATED MODULE: ./components/PartsViewer/v2/PartsDiagramViewer/PartsControls/index.js






const PartsControls = (props)=>{
    const { zoomIn , zoomOut , expandHandler , fullscreen , scale , initScale , centerView , setMessage  } = props;
    const device = (0,useViewport/* default */.Z)();
    const isDesktop = device.isLargeScreen || device.isExtraLargeScreen || device.isMediumScreen;
    const inMargin = (value, expected, margin)=>expected - margin < value && value < expected + margin;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "viewer-controls ".concat(isDesktop ? "position-absolute" : "position-fixed mobile-controls"),
        children: [
            fullscreen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Coach_Coach, {
                text: "Exit Full Screen",
                displayKey: "bottom",
                hide: false
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                onClick: ()=>{
                    expandHandler();
                    setMessage(false);
                },
                className: "btn-expand",
                "data-testid": "parts-fullscreen",
                children: [
                    fullscreen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* IconCollapse */.bt, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* IconExpand */.qp, {}),
                    isDesktop && !fullscreen ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tool-tip-custom",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            children: [
                                " ",
                                !fullscreen ? "Full screen" : ""
                            ]
                        })
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(v2_ToolTip, {
                text: "Reset",
                show: isDesktop ? true : false,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    className: "".concat(inMargin(scale, initScale, 0.05) ? "" : "acitve"),
                    onClick: ()=>{
                        centerView(initScale);
                    },
                    "data-testid": "parts-center",
                    children: inMargin(scale, initScale, 0.05) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* IconReset */.uN, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* ResetActive */.iK, {})
                })
            }),
            isDesktop ? /*#__PURE__*/ (0,jsx_runtime.jsx)(v2_ToolTip, {
                text: "Zoom",
                show: isDesktop ? true : false,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "groups-buttons",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            onClick: ()=>{
                                zoomIn();
                            },
                            "data-testid": "parts-zoomin",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* IconZoomIn */.WM, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            onClick: ()=>{
                                zoomOut();
                            },
                            "data-testid": "parts-zoomout",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* IconZoomOut */.DS, {})
                        })
                    ]
                })
            }) : ""
        ]
    });
};
/* harmony default export */ var PartsDiagramViewer_PartsControls = (PartsControls);

;// CONCATENATED MODULE: ./components/PartsViewer/v2/PartsDiagramViewer/interactiveSvg.js
const createInteractiveSVGElement = (svgText, actions)=>{
    var ref, ref1, ref2;
    const wrapper = document.createElement("div");
    wrapper.innerHTML = svgText;
    const svg = (ref = wrapper.getElementsByTagName("svg")) === null || ref === void 0 ? void 0 : ref[0];
    const groupNodeList = svg.querySelectorAll("g");
    const groupList = (ref1 = [
        ...groupNodeList
    ]) === null || ref1 === void 0 ? void 0 : ref1.filter((item)=>item.getAttribute("itedo:apstype") === "Part");
    groupList.forEach((item)=>{
        mutateGroupText(item);
    });
    const textNodeList = svg.querySelectorAll("text");
    const itemList = (ref2 = [
        ...textNodeList
    ]) === null || ref2 === void 0 ? void 0 : ref2.filter((item)=>item.getAttribute("itedo:apstype") === "Part");
    itemList.forEach((item)=>bindEvents(item, actions, svg));
    return svg;
};
/* harmony default export */ var interactiveSvg = (createInteractiveSVGElement);
const bindEvents = function(item, actions) {
    let context = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : document;
    item.addEventListener("mouseover", (e)=>{
        const list = getObjectRelations(e.currentTarget);
        const relations = getNodes(list, context);
        addActionMultiple(relations, mouseOver);
    }, false);
    item.addEventListener("mouseout", (e)=>{
        const list = getObjectRelations(e.currentTarget);
        const relations = getNodes(list, context);
        addActionMultiple(relations, mouseOut);
    }, false);
    item.addEventListener("click", (e)=>{
        const list = getObjectRelations(e.currentTarget);
        const relations = getNodes(list, context);
        actions.click(e, relations);
    }, false);
};
const mutateGroupText = (groupNode)=>{
    const textList = [
        ...groupNode.querySelectorAll("text")
    ];
    const hotspotList = groupNode.getAttribute("kohler_illustration:hotspot_list");
    const groupNodeClassList = Array.from(groupNode.classList);
    textList === null || textList === void 0 ? void 0 : textList.forEach((item)=>{
        item.classList.add(...groupNodeClassList);
        item.setAttribute("kohler_illustration:hotspot_list", hotspotList === null || hotspotList === void 0 ? void 0 : hotspotList.trim());
        item.setAttribute("itedo:apstype", "Part");
    });
};
const addActionMultiple = (list, action)=>list.forEach((node)=>action(node));
const getNodes = (list, context)=>list.map((id)=>context.getElementById(id));
const getObjectRelations = (node)=>{
    const listString = node.getAttribute("kohler_illustration:hotspot_list");
    let list = [];
    if (typeof listString === "string") list = listString.split(",");
    return list;
};
const mouseOver = (node)=>node.classList.add("active");
const mouseOut = (node)=>node.classList.remove("active");

;// CONCATENATED MODULE: ./components/PartsViewer/v2/PartsDiagramViewer/index.js









const PartsDiagramViewer = (props)=>{
    const { selectedFile , fullscreen , expandHandler , showPopup , title , sku  } = props;
    const transformComponentRef = (0,react.useRef)(null);
    const wrapper = (0,react.useRef)(null);
    const container = (0,react.useRef)(null);
    const [svgData, setSvgData] = (0,react.useState)();
    const [status, setStatus] = (0,react.useState)("loading");
    const [scale, setScale] = (0,react.useState)(1);
    const [initScale, setInitScale] = (0,react.useState)(1);
    const [message, setMessage] = (0,react.useState)(false);
    const [position, setPosition] = (0,react.useState)({
        left: 0,
        top: 0,
        textWidth: 0,
        textHeight: 0,
        showTop: 0,
        textBounds: {}
    });
    (0,react.useEffect)(()=>{
        const aspect = container.current.offsetHeight / container.current.offsetWidth * 0.85;
        setInitScale(aspect > 0.9 ? aspect : 0.9);
        return ()=>{
            container.current = false;
        };
    }, []);
    (0,react.useEffect)(()=>{
        setMessage(false);
        setStatus("loading");
        const abortController = new AbortController();
        getSelectedFile(abortController);
        return ()=>{
            abortController.abort();
            setMessage(false);
            setStatus("loading");
            setSvgData("");
        };
    }, [
        selectedFile === null || selectedFile === void 0 ? void 0 : selectedFile.URL
    ]);
    (0,react.useEffect)(()=>{
        if (wrapper === null || wrapper === void 0 ? void 0 : wrapper.current) wrapper.current.appendChild(svgData);
    }, [
        svgData,
        position
    ]);
    const getSelectedFile = async (abortController)=>{
        try {
            const response = await fetch(LOCAL_PREFIX + (selectedFile === null || selectedFile === void 0 ? void 0 : selectedFile.URL), {
                signal: abortController === null || abortController === void 0 ? void 0 : abortController.signal
            });
            const svgText = await response.text();
            const svgElement = interactiveSvg(svgText, {
                click: clickAction
            });
            setStatus("loaded");
            setSvgData(svgElement);
        } catch (error) {
            setStatus("error");
        }
    };
    const clickAction = async (e, relations)=>{
        setMessage(false);
        let text = e.currentTarget.getAttribute("class");
        text = text.replaceAll("active", "").replaceAll(" ", "");
        if (selectedFile.Parts.filter((item)=>item.Cod === text).length === 0) {
            partNotFoundMessage(e.currentTarget);
            setMessage(true);
            showPopup(text);
        } else {
            showPopup(text);
        }
    };
    const partNotFoundMessage = (textNode)=>{
        const svgElement = wrapper.current.children[0];
        const viewBox = svgElement.getAttribute("viewBox").split(" ");
        const boxWidth = viewBox === null || viewBox === void 0 ? void 0 : viewBox[2];
        const boxHeight = viewBox === null || viewBox === void 0 ? void 0 : viewBox[3];
        const boxAspect = boxWidth / boxHeight;
        const { top  } = textNode.getBoundingClientRect();
        const svgWidth = svgElement.width.baseVal.value;
        const svgHeight = svgElement.height.baseVal.value;
        const wrapperWidth = wrapper.current.offsetWidth;
        const wrapperHeight = wrapper.current.offsetHeight;
        const wrapperAspect = wrapperWidth / wrapperHeight;
        let leftOffset = 0;
        let topOffset = 0;
        let leftValue = 0;
        let topValue = 0;
        let actualSVGWidth = 0;
        let actualSVGHeight = 0;
        let svgScaleVertical = 1;
        let svgScaleHorizontal = 1;
        if (wrapperAspect > boxAspect) {
            actualSVGWidth = svgHeight * boxAspect;
            actualSVGHeight = svgHeight;
            leftOffset = (svgWidth - actualSVGWidth) / 2;
            topOffset = 0;
        } else {
            actualSVGWidth = svgWidth;
            actualSVGHeight = svgWidth / boxAspect;
            leftOffset = 0;
            topOffset = (svgHeight - actualSVGHeight) / 2;
        }
        svgScaleHorizontal = actualSVGWidth / boxWidth;
        svgScaleVertical = actualSVGHeight / boxHeight;
        leftValue = textNode.getAttribute("x") / boxWidth * actualSVGWidth;
        topValue = textNode.getAttribute("y") / boxHeight * actualSVGHeight;
        setPosition({
            left: leftValue + leftOffset,
            top: topValue + topOffset,
            textWidth: textNode.getComputedTextLength() * svgScaleHorizontal,
            textHeight: textNode.getBBox().height * svgScaleVertical / scale,
            showTop: top,
            textBounds: textNode.getBoundingClientRect()
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Conditional_Conditional, {
                show: status === "loading",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "d-flex w-100 h-100 justify-content-center align-items-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* LoaderSpinner */.cK, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "image-wrapper",
                        ref: container
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Conditional_Conditional, {
                show: status === "loaded",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TransformWrapper, {
                    initialScale: initScale,
                    velocityAnimation: {
                        disabled: true
                    },
                    ref: transformComponentRef,
                    zoomAnimation: {
                        disabled: true
                    },
                    centerOnInit: true,
                    minScale: 0.5,
                    onTransformed: (e)=>{
                        var ref;
                        return setScale(e === null || e === void 0 ? void 0 : (ref = e.state) === null || ref === void 0 ? void 0 : ref.scale);
                    },
                    onInit: ()=>{},
                    pinch: {
                        step: 2
                    },
                    wheel: {
                        step: 0.1
                    },
                    children: (utils)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(TransformComponent, {
                                    children: [
                                        message ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PartsDiagramViewer_PopModal, {
                                            position: position,
                                            setMessage: setMessage,
                                            scale: scale
                                        }) : null,
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "image-wrapper",
                                            ref: wrapper
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PartsDiagramViewer_PartsControls, {
                                    ...utils,
                                    expandHandler: expandHandler,
                                    fullscreen: fullscreen,
                                    scale: scale,
                                    initScale: initScale,
                                    setMessage: setMessage,
                                    title: title,
                                    sku: sku
                                })
                            ]
                        })
                })
            })
        ]
    });
};
/* harmony default export */ var v2_PartsDiagramViewer = (PartsDiagramViewer);

;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/Container.js
"use client";





const Container = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  fluid = false,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  className,
  ...props
}, ref) => {
  const prefix = useBootstrapPrefix(bsPrefix, 'container');
  const suffix = typeof fluid === 'string' ? `-${fluid}` : '-fluid';
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    ref: ref,
    ...props,
    className: classnames_default()(className, fluid ? `${prefix}${suffix}` : prefix)
  });
});
Container.displayName = 'Container';
/* harmony default export */ var esm_Container = (Container);
// EXTERNAL MODULE: ./components/core/Heading/Heading.jsx
var Heading = __webpack_require__(22231);
// EXTERNAL MODULE: ./components/core/ColorSwatch/ColorSwatch.jsx
var ColorSwatch = __webpack_require__(32982);
;// CONCATENATED MODULE: ./components/PartsViewer/v2/SwatchItems/index.js




const SwatchItems = (props)=>{
    const { variantList , setVariant , variant  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "swatch-list d-flex",
        children: variantList === null || variantList === void 0 ? void 0 : variantList.map((val, i)=>{
            var ref;
            const validSwatch = val === null || val === void 0 ? void 0 : (ref = val.colorUrl) === null || ref === void 0 ? void 0 : ref.split("/");
            if (validSwatch[validSwatch.length - 1] === "swatch_NA") {
                return null;
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                role: "radio",
                "aria-label": val.label,
                "aria-checked": val.id === variant ? true : false,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ColorSwatch/* default */.Z, {
                    type: "selector",
                    id: val.id,
                    name: val.name,
                    value: val.value,
                    label: val.label,
                    colorUrl: val.colorUrl,
                    checked: (val === null || val === void 0 ? void 0 : val.id) === variant,
                    onClick: ()=>{
                        return setVariant(val === null || val === void 0 ? void 0 : val.id);
                    }
                }, i)
            }, "".concat(val === null || val === void 0 ? void 0 : val.id, "-").concat(i));
        })
    });
};
SwatchItems.propTypes = {
    variant: (prop_types_default()).string.isRequired,
    setVariant: (prop_types_default()).func.isRequired,
    variantList: (prop_types_default()).array.isRequired
};
/* harmony default export */ var v2_SwatchItems = (SwatchItems);

;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/Row.js
"use client";





const Row = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  className,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  ...props
}, ref) => {
  const decoratedBsPrefix = useBootstrapPrefix(bsPrefix, 'row');
  const breakpoints = useBootstrapBreakpoints();
  const minBreakpoint = useBootstrapMinBreakpoint();
  const sizePrefix = `${decoratedBsPrefix}-cols`;
  const classes = [];
  breakpoints.forEach(brkPoint => {
    const propValue = props[brkPoint];
    delete props[brkPoint];
    let cols;
    if (propValue != null && typeof propValue === 'object') {
      ({
        cols
      } = propValue);
    } else {
      cols = propValue;
    }
    const infix = brkPoint !== minBreakpoint ? `-${brkPoint}` : '';
    if (cols != null) classes.push(`${sizePrefix}${infix}-${cols}`);
  });
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    ref: ref,
    ...props,
    className: classnames_default()(className, decoratedBsPrefix, ...classes)
  });
});
Row.displayName = 'Row';
/* harmony default export */ var esm_Row = (Row);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/Col.js
"use client";





function useCol({
  as,
  bsPrefix,
  className,
  ...props
}) {
  bsPrefix = useBootstrapPrefix(bsPrefix, 'col');
  const breakpoints = useBootstrapBreakpoints();
  const minBreakpoint = useBootstrapMinBreakpoint();
  const spans = [];
  const classes = [];
  breakpoints.forEach(brkPoint => {
    const propValue = props[brkPoint];
    delete props[brkPoint];
    let span;
    let offset;
    let order;
    if (typeof propValue === 'object' && propValue != null) {
      ({
        span,
        offset,
        order
      } = propValue);
    } else {
      span = propValue;
    }
    const infix = brkPoint !== minBreakpoint ? `-${brkPoint}` : '';
    if (span) spans.push(span === true ? `${bsPrefix}${infix}` : `${bsPrefix}${infix}-${span}`);
    if (order != null) classes.push(`order${infix}-${order}`);
    if (offset != null) classes.push(`offset${infix}-${offset}`);
  });
  return [{
    ...props,
    className: classnames_default()(className, ...spans, ...classes)
  }, {
    as,
    bsPrefix,
    spans
  }];
}
const Col = /*#__PURE__*/react.forwardRef(
// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
(props, ref) => {
  const [{
    className,
    ...colProps
  }, {
    as: Component = 'div',
    bsPrefix,
    spans
  }] = useCol(props);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    ...colProps,
    ref: ref,
    className: classnames_default()(className, !spans.length && bsPrefix)
  });
});
Col.displayName = 'Col';
/* harmony default export */ var esm_Col = (Col);
// EXTERNAL MODULE: ./components/ProductDetail/v3/AddToCart/utils.js
var utils = __webpack_require__(29885);
// EXTERNAL MODULE: ./components/core/Input/Input.jsx
var Input = __webpack_require__(3372);
// EXTERNAL MODULE: ./components/PartsViewer/v2/NotifyMe/notify.module.scss
var notify_module = __webpack_require__(35423);
var notify_module_default = /*#__PURE__*/__webpack_require__.n(notify_module);
;// CONCATENATED MODULE: ./components/PartsViewer/v2/NotifyMe/index.js










const NotifyItems = (props)=>{
    const { item , fromCart , isListExtend , gridViewNotify , showStockMessage =true , itemStock =false  } = props;
    const [email, setEmail] = (0,react.useState)("");
    const [emailError, setEmailError] = (0,react.useState)({
        show: false,
        message: ""
    });
    const [showWelcome, setShowWelcome] = (0,react.useState)(false);
    const [enableNotify, setEnableNotify] = (0,react.useState)(false);
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const { notifyText , notifySuccessText , notifyEmailText , successText , notifyOutofStockText , notifyButtonText  } = (0,localization/* getTranslations */.F)(t);
    (0,react.useEffect)(()=>{
        setShowWelcome(false);
        setEmailError({
            show: false,
            message: ""
        });
        setEmail("");
    }, [
        item
    ]);
    const handleEmailChange = async (val)=>{
        const inputValue = val.trim();
        setEmailError({
            show: false,
            message: ""
        });
        setEmail(inputValue);
        if (!await (0,helper/* validateField */.OP$)("email", inputValue)) {
            setEnableNotify(false);
        } else {
            setEnableNotify(true);
        }
    };
    const callBackNotify = (isSuccess)=>{
        if (isSuccess) {
            setShowWelcome(true);
            setEmail("");
            setEnableNotify(false);
        } else {
            setEmailError({
                show: true,
                message: notifyText
            });
        }
    };
    const handleNotification = ()=>{
        var ref;
        const sku = item === null || item === void 0 ? void 0 : (ref = item.currentVarent) === null || ref === void 0 ? void 0 : ref.id;
        if (sku) (0,utils/* callNotification */.jL)({
            email,
            sku,
            callBackNotify
        });
    };
    const handlerSubmit = (event)=>{
        if (event.key === "Enter" && enableNotify) {
            handleNotification();
        }
    };
    const handlerNotify = ()=>{
        if (enableNotify) {
            handleNotification();
        }
    };
    const outofStockVal = !itemStock ? notifyOutofStockText : null;
    const notifytextVal = !itemStock ? notifyEmailText : null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (notify_module_default()) === null || (notify_module_default()) === void 0 ? void 0 : (notify_module_default()).NotifyContianer,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_Row, {
            className: gridViewNotify ? "girdViewNotify" : "",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm_Col, {
                className: "notify-contianer",
                children: [
                    showStockMessage || itemStock ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "notify-message notify-button-margin ".concat(isListExtend ? "notify-button-margin" : ""),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "fs-16 fw-500 notify-heading ",
                                children: showWelcome ? successText : outofStockVal
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "fs-14 fw-400 notify-details ",
                                children: showWelcome ? notifySuccessText : notifytextVal
                            })
                        ]
                    }) : null,
                    !showWelcome ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "".concat(fromCart ? "input-button" : ""),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "email-inputbox",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                    id: "email-notify",
                                    onChange: (e)=>handleEmailChange(e.target.value),
                                    onKeyDown: handlerSubmit,
                                    type: "email",
                                    label: "Email Address",
                                    ariaRequried: true,
                                    maxLength: 60,
                                    value: email,
                                    showError: emailError.show,
                                    errorMessage: emailError.message
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "notify-button-div",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    className: "notify-button ".concat(!isListExtend ? "notify-button-margin" : "notify-button-width", " ").concat(enableNotify ? "" : "disabled-btn"),
                                    onClick: handlerNotify,
                                    disabled: !enableNotify,
                                    children: notifyButtonText
                                })
                            })
                        ]
                    }) : ""
                ]
            })
        })
    });
};
NotifyItems.propTypes = {
    item: (prop_types_default()).object.isRequired,
    fromCart: (prop_types_default()).string.isRequired,
    isListExtend: (prop_types_default()).bool.isRequired,
    gridViewNotify: (prop_types_default()).object.isRequired,
    showStockMessage: (prop_types_default()).string.isRequired,
    itemStock: (prop_types_default()).bool.isRequired
};
/* harmony default export */ var NotifyMe = (NotifyItems);

;// CONCATENATED MODULE: ./components/PartsViewer/v2/DetailPopUp/Loading/index.js





const LoadingPopupection = (props)=>{
    const { setModal , device , popupWidth , fullscreen  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "popup-default loading-popup",
        style: popupWidth && !device.isSmallScreen ? {
            width: (popupWidth === null || popupWidth === void 0 ? void 0 : popupWidth.sidebarWidth) + "px",
            top: !fullscreen ? popupWidth === null || popupWidth === void 0 ? void 0 : popupWidth.headHeight : 0 + "px"
        } : {},
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm_Container, {
            fluid: true,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "d-flex justify-content-start",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: "btn closebtns",
                            onClick: ()=>setModal(false),
                            children: (device === null || device === void 0 ? void 0 : device.isLargeScreen) || device.isExtraLargeScreen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* CloseIcon */.Tw, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* DownIcon */.KL, {})
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex-column",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "d-flex  flex-column align-items-center mt-4 mb-1",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "loading-thumb mb-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* LoaderSpinner */.cK, {})
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "d-flex  flex-column justify-content-start mb-30",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "loading-animation loading-heading mb-4",
                                    children: "new"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "loading-animation mt-4 mb-4 h-16",
                                    children: "Widespread bathroom sink faucet"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "loading-animation loading-heading",
                                    children: "K-5709-7"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "d-flex  flex-column justify-content-start mb-30",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "loading-animation loading-heading",
                                    children: "$800.44"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "loading-animation mt-3 mb-2 h-16 loading-heading",
                                    children: "$1000.44 List Price"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "d-flex  flex-column justify-content-start mb-2",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "loading-animation loading-heading h-16",
                                children: "color/Finish white"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mb-30 w-100",
                            children: Array.from({
                                length: 9
                            }, (v, index)=>index + 1).map((val)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "loading-animation loading-buttons mb-2",
                                    children: "color Finish"
                                }, val))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "w-100 d-flex flex-rows justify-content-between align-content-center mb-2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "loading-animation counter-details",
                                    children: "counter"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "loading-animation addtocart-details",
                                    children: "Add to cart"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
LoadingPopupection.propTypes = {
    fullscreen: (prop_types_default()).bool.isRequired,
    setModal: (prop_types_default()).func.isRequired,
    popupWidth: prop_types_default().shape({
        headHeight: (prop_types_default()).number
    }),
    device: (prop_types_default()).object.isRequired
};
/* harmony default export */ var Loading = (LoadingPopupection);

// EXTERNAL MODULE: ./components/sharedCart/shareCartHelper.js
var shareCartHelper = __webpack_require__(4364);
// EXTERNAL MODULE: ./components/Shared/UpsellInstallServices/api.js
var api = __webpack_require__(9670);
;// CONCATENATED MODULE: ./services/ImageUrlValid.js
const isImgUrlValid = (url)=>{
    try {
        const img = new Image();
        img.src = url;
        return new Promise((resolve)=>{
            img.onerror = ()=>resolve(false);
            img.onload = ()=>resolve(true);
        });
    } catch (err) {
        throw new Error("Invalid Image");
    }
};

;// CONCATENATED MODULE: ./public/scout_icon/coming-soon.jpg
/* harmony default export */ var coming_soon = ({"src":"/_next/static/media/coming-soon.c51c0af8.jpg","height":375,"width":337,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAIAAcDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAf/xAAbEAABBAMAAAAAAAAAAAAAAAAAAQIRMSEkkf/EABQBAQAAAAAAAAAAAAAAAAAAAAD/xAAUEQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIRAxEAPwCwNXZckLVzjgAA/9k=","blurWidth":7,"blurHeight":8});
;// CONCATENATED MODULE: ./components/PartsViewer/v2/analytics.js

const partsAddToCartEvent = (analytics, productInfo)=>{
    const { page ="n/a"  } = analytics;
    const linkUrl = window.location.href;
    const event = "cmp:click";
    const eventInfo = {
        eventAction: page + ":modal:interactive parts diagram:add to cart",
        eventName: page + ":modal:interactive parts diagram:add to cart",
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "add to cart",
        internalLinkPosition: page,
        internalLinkType: page + ":add to cart",
        internalLinkZoneName: page + ":modal:interactive parts diagram",
        internalLinkURL: linkUrl,
        clickInternalLinks: "true"
    };
    const data = getAnalyticProductInfo(productInfo);
    if (data.pageInfo) {
        data.pageInfo["contentType"] = page;
        if (data.pageInfo.pageName.match("::")) {
            const pageName = data.pageInfo.pageName.replaceAll("::", ":".concat(page, ":"));
            data.pageName = pageName;
            data.pageInfo.pageName = pageName;
        }
    }
    (0,helper/* pushAnalyticsObjToDataLayer */.zYT)(eventInfo, event, data);
};
const getAnalyticProductInfo = (pdpInfo)=>{
    var ref, ref1;
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState("page");
    if (page) {
        const { user ={
            encodedEmailId: null,
            profileType: null
        } , category ={
            productLocalCategory: null
        } , pageInfo ={
            thumbnailImageUrl: null
        }  } = page;
        delete category["productLocalCategory"];
        delete user["encodedEmailId"];
        delete user["profileType"];
        delete pageInfo["thumbnailImageUrl"];
    }
    const { Name ="" , quantity =0 , fileTitle ="" , currentVarent: { imgUrl , label , centPrice , value  } , data: { ProductDescriptionProduct_s: productDescription , ProductCategory_s: productCategory  } , pdpDetails: { pdp  }  } = pdpInfo;
    const productInfo = {
        category: pdp === null || pdp === void 0 ? void 0 : (ref = pdp.data) === null || ref === void 0 ? void 0 : ref.category1_s,
        defaultImageName: imgUrl,
        description: (0,helper/* sanitizeTextForAnalytics */.T68)(productDescription || Name),
        frequency: "n/a",
        globalDiscount: 0,
        globalOffer: "n/a",
        globalPromotionPrice: centPrice,
        isRecommended: "n/a",
        isSendNow: "n/a",
        isSubscription: "n/a",
        itemType: (0,helper/* sanitizeTextForAnalytics */.T68)(productCategory),
        numberOfReviews: "n/a",
        pdpType: "regular finished goods & service parts",
        priceState: "regular price",
        productBasePrice: centPrice,
        productBrand: "kohler",
        productCategory: (0,helper/* sanitizeTextForAnalytics */.T68)(productCategory),
        productCollectionsName: pdp === null || pdp === void 0 ? void 0 : pdp.productBrand,
        productColor: (0,helper/* sanitizeTextForAnalytics */.T68)(label),
        productCouponCode: "n/a",
        productCoupondiscount: 0,
        productFindingMethod: "pdp:".concat(fileTitle),
        productID: value,
        productName: (0,helper/* sanitizeTextForAnalytics */.T68)(Name),
        productPartnerBuyNow: false,
        productRoom: page === null || page === void 0 ? void 0 : (ref1 = page.category) === null || ref1 === void 0 ? void 0 : ref1.room,
        productSalePrice: centPrice,
        productSaleable: true,
        productStatus: "in stock",
        productSuperSku: true,
        productTileName: (0,helper/* sanitizeTextForAnalytics */.T68)(Name),
        quantity,
        ratings: "n/a",
        waterSenseProduct: false
    };
    page.productInfo = productInfo;
    return page;
};

;// CONCATENATED MODULE: ./components/PartsViewer/v2/DetailPopUp/index.js


















const DetailPopUp = (props)=>{
    const { productId , setModal , partController , analytics , title , fullscreen , setWidthSize  } = props;
    const [loading, setLoading] = (0,react.useState)("loading");
    const [item, setItem] = (0,react.useState)({});
    const [variant, setVariant] = (0,react.useState)(null);
    const [variantList, setVariantList] = (0,react.useState)([]);
    const [counter, setCounter] = (0,react.useState)(1);
    const [loaded, setLoaded] = (0,react.useState)(false);
    const [inventory, setInventory] = (0,react.useState)("");
    const [inventoryWarn, setInventoryWarn] = (0,react.useState)(false);
    const [cartToast, setCartToast] = (0,react.useState)(false);
    const [popupWidth, setPopupWidth] = (0,react.useState)(null);
    const [isValidImg, setIsValidImg] = (0,react.useState)(false);
    const showStockDiscontinue = null;
    const device = (0,useViewport/* default */.Z)();
    const resizeWidth = (0,useViewport/* useViewportWidth */.j)();
    const pdpDetails = (0,es/* useSelector */.v9)((state)=>state.pdp);
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const { addToCart  } = (0,localization/* getTranslations */.F)(t);
    (0,react.useEffect)(()=>{
        const element = document.getElementsByClassName("product-list-viewer")[0];
        const headElement = document.querySelectorAll(".modal-fullscreen.modal-container")[0];
        if (element) {
            const { width  } = element.getBoundingClientRect();
            const { height  } = headElement.getBoundingClientRect();
            setWidthSize(width);
            setPopupWidth({
                sidebarWidth: width,
                headHeight: height
            });
        }
    }, [
        resizeWidth
    ]);
    (0,react.useEffect)(()=>{
        getItemDetails(productId);
    }, [
        productId
    ]);
    (0,react.useEffect)(()=>{
        let timeId;
        if (inventory && counter > inventory) {
            timeId = setTimeout(()=>{
                setCounter(inventory);
            }, 1000);
            setInventoryWarn(true);
        }
        return ()=>clearTimeout(timeId);
    }, [
        counter
    ]);
    (0,react.useEffect)(()=>{
        getVarientInfo();
    }, [
        variant
    ]);
    const getVarientInfo = async ()=>{
        const currentVarent = variantList === null || variantList === void 0 ? void 0 : variantList.filter((val)=>val.id === variant)[0];
        if (currentVarent) {
            var ref;
            const isImgValid = await isImgUrlValid(item === null || item === void 0 ? void 0 : (ref = item.currentVarent) === null || ref === void 0 ? void 0 : ref.imgUrl);
            setIsValidImg(isImgValid);
            setLoaded(true);
            const productQuantity = await getInventoryBySku(currentVarent === null || currentVarent === void 0 ? void 0 : currentVarent.id);
            setLoaded(false);
            setItem((prevState)=>{
                var ref, ref1;
                const details = prevState === null || prevState === void 0 ? void 0 : (ref = prevState.data) === null || ref === void 0 ? void 0 : (ref1 = ref.varientDetails) === null || ref1 === void 0 ? void 0 : ref1.filter((val)=>{
                    return (val === null || val === void 0 ? void 0 : val.sku) === (currentVarent === null || currentVarent === void 0 ? void 0 : currentVarent.id);
                })[0];
                return {
                    ...prevState,
                    currentVarent: {
                        ...currentVarent,
                        details
                    }
                };
            });
            setInventory(productQuantity);
            setInventoryWarn(false);
            if (productQuantity && counter > productQuantity) {
                setCounter(productQuantity);
                setInventoryWarn(true);
            }
        }
    };
    const getItemDetails = async (id)=>{
        const entry = partController.actions.get.entryByKey(id);
        setLoading("loading");
        if (entry === null || entry === void 0 ? void 0 : entry.ctApiPromise) {
            const ctResponse = await entry.ctApiPromise;
            if (ctResponse) {
                var ref, ref1, ref2, ref3, ref4;
                setLoaded(true);
                const allSwatch = ctResponse === null || ctResponse === void 0 ? void 0 : (ref = ctResponse.data) === null || ref === void 0 ? void 0 : ref.colorData;
                const isImgValid = await isImgUrlValid(allSwatch === null || allSwatch === void 0 ? void 0 : (ref1 = allSwatch[0]) === null || ref1 === void 0 ? void 0 : ref1.imgUrl);
                setIsValidImg(isImgValid);
                const currentSwatch = allSwatch === null || allSwatch === void 0 ? void 0 : (ref2 = allSwatch[0]) === null || ref2 === void 0 ? void 0 : ref2.id;
                const productQuantity = await getInventoryBySku(currentSwatch);
                const details = ctResponse === null || ctResponse === void 0 ? void 0 : (ref3 = ctResponse.data) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.varientDetails) === null || ref4 === void 0 ? void 0 : ref4.filter((val)=>{
                    return (val === null || val === void 0 ? void 0 : val.sku) === currentSwatch;
                })[0];
                setLoaded(false);
                setInventory(productQuantity);
                setVariantList(allSwatch);
                setVariant(currentSwatch);
                setItem({
                    ...ctResponse,
                    currentVarent: {
                        ...allSwatch[0],
                        details
                    }
                });
                setLoading("success");
            }
        }
    };
    const incrementCounter = ()=>{
        setCounter(counter + 1);
    };
    const decrementCounter = ()=>{
        if (counter > 1) setCounter(counter - 1);
    };
    const handlerCounter = (val)=>{
        const count = Number(val);
        if (count && count >= 1) {
            setCounter(count);
        }
    };
    const handlerCart = (productInfo)=>{
        var ref;
        setLoaded(true);
        const data = [
            {
                sku: productInfo === null || productInfo === void 0 ? void 0 : (ref = productInfo.currentVarent) === null || ref === void 0 ? void 0 : ref.id,
                quantity: counter,
                isBundleProduct: false,
                isBundle: false,
                brand: "kohler"
            }
        ];
        (0,shareCartHelper/* shareaddToCart */.J9)(data, "", (res)=>{
            if (res) {
                setCartToast(true);
                setLoaded(false);
                partsAddToCartEvent(analytics, productInfo);
                setTimeout(()=>{
                    setCartToast(false);
                }, 3000);
            }
        });
    };
    const getInventoryBySku = async (sku)=>{
        var ref;
        var ref1;
        const { data: { results: parentProductInventory = []  } = {}  } = (ref1 = await (0,api/* getProductInventory */.o)(sku)) !== null && ref1 !== void 0 ? ref1 : {};
        return parentProductInventory.length ? (ref = parentProductInventory[0]) === null || ref === void 0 ? void 0 : ref.availableQuantity : 0;
    };
    if (popupWidth) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24;
        if (loading === "loading") {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading, {
                setModal: setModal,
                device: device,
                popupWidth: popupWidth,
                fullscreen: fullscreen
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "popup-default",
            style: popupWidth && !device.isSmallScreen ? {
                width: (popupWidth === null || popupWidth === void 0 ? void 0 : popupWidth.sidebarWidth) + "px",
                top: !fullscreen ? popupWidth.headHeight : 0 + "px"
            } : {},
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "popup-wrapper",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_Container, {
                        fluid: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex-column content-dialogs",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "header-fixed",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "d-flex justify-content-start",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            className: "btn closebtns",
                                            onClick: ()=>{
                                                setModal(false);
                                            },
                                            "data-testid": "parts-modal-close",
                                            children: (device === null || device === void 0 ? void 0 : device.isLargeScreen) || device.isExtraLargeScreen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* CloseIcon */.Tw, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* DownIcon */.KL, {})
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "main-image mt-0",
                                    children: loading === "loading" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* LoaderSpinner */.cK, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: isValidImg ? item === null || item === void 0 ? void 0 : (ref = item.currentVarent) === null || ref === void 0 ? void 0 : ref.imgUrl : coming_soon === null || coming_soon === void 0 ? void 0 : coming_soon.src,
                                        alt: "comming soon"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "text-container",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flag-container",
                                            children: [
                                                (item === null || item === void 0 ? void 0 : (ref1 = item.currentVarent) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.details) === null || ref2 === void 0 ? void 0 : ref2.discontinued) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "fs-13 fw-600 tag-discontinue discontinued",
                                                    children: "Discontinued"
                                                }) : null,
                                                ((item === null || item === void 0 ? void 0 : (ref3 = item.currentVarent) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.details) === null || ref4 === void 0 ? void 0 : ref4.isStock) === "false" || inventory === 0) && (item === null || item === void 0 ? void 0 : (ref5 = item.currentVarent) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.details) === null || ref6 === void 0 ? void 0 : ref6.discontinued) === false ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "fs-13 fw-600 tag-discontinue outof-stoke",
                                                    children: "out of stock"
                                                }) : null
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                            level: 2,
                                            className: "label-name fs-28 fw-325 text-capitalize",
                                            children: (item === null || item === void 0 ? void 0 : (ref7 = item.Name) === null || ref7 === void 0 ? void 0 : ref7.toLowerCase()) || "N/A"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "varient-text fs-14 fw-500",
                                            children: (item === null || item === void 0 ? void 0 : (ref8 = item.currentVarent) === null || ref8 === void 0 ? void 0 : ref8.value) || "N/A"
                                        }),
                                        (item === null || item === void 0 ? void 0 : (ref9 = item.currentVarent) === null || ref9 === void 0 ? void 0 : ref9.price) !== "NaN" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                (item === null || item === void 0 ? void 0 : (ref10 = item.currentVarent) === null || ref10 === void 0 ? void 0 : ref10.discountedPrice) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Heading/* default */.Z, {
                                                    level: 2,
                                                    className: "price-text fs-28 fw-325 text-capitalize ",
                                                    children: [
                                                        item === null || item === void 0 ? void 0 : (ref11 = item.currentVarent) === null || ref11 === void 0 ? void 0 : ref11.currencySign,
                                                        item === null || item === void 0 ? void 0 : (ref12 = item.currentVarent) === null || ref12 === void 0 ? void 0 : ref12.discountedPrice
                                                    ]
                                                }) : null,
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    className: "price-text fs-16 fw-400 text-capitalize ".concat((item === null || item === void 0 ? void 0 : (ref13 = item.currentVarent) === null || ref13 === void 0 ? void 0 : ref13.discountedPrice) ? "discount-price" : ""),
                                                    children: [
                                                        item === null || item === void 0 ? void 0 : (ref14 = item.currentVarent) === null || ref14 === void 0 ? void 0 : ref14.currencySign,
                                                        item === null || item === void 0 ? void 0 : (ref15 = item.currentVarent) === null || ref15 === void 0 ? void 0 : ref15.price
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    className: "pricelist-text fs-16 fw-400 product-description mb-2",
                                                    children: [
                                                        item === null || item === void 0 ? void 0 : (ref16 = item.currentVarent) === null || ref16 === void 0 ? void 0 : ref16.currencySign,
                                                        item === null || item === void 0 ? void 0 : (ref17 = item.currentVarent) === null || ref17 === void 0 ? void 0 : ref17.pricelist,
                                                        " ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                            className: "list-text",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    children: " List Price"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                    className: "list-description",
                                                                    children: [
                                                                        "Selling price is valid for ",
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                                            children: "Kohler.com"
                                                                        }),
                                                                        " and United States only. Store and distribution pricing may differ. These prices do not include potential shipping costs. Any sales tax applicable will be added to the price."
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }) : null,
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            className: "fs-16 fw-300 text-color",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "fw-400",
                                                    children: "Color/Finish "
                                                }),
                                                (item === null || item === void 0 ? void 0 : (ref18 = item.currentVarent) === null || ref18 === void 0 ? void 0 : ref18.label) || "N/A"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(v2_SwatchItems, {
                                            variantList: variantList,
                                            setVariant: setVariant,
                                            variant: variant
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "d-flex align-items-center justify-content-center detailpop-up",
                                            children: showStockDiscontinue != null ? /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                className: "fw-400 stock-button mt-5",
                                                disabled: true,
                                                children: showStockDiscontinue
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "button-carts d-flex flex-row justify-content-center align-items-end mt-3",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "d-flex flex-column processing-div ".concat(loaded ? "processing" : ""),
                                                    children: [
                                                        inventoryWarn ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "inventory-warning",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* WarnIcon */.e6, {}),
                                                                " ",
                                                                inventory,
                                                                " item(s) available to ship."
                                                            ]
                                                        }) : "",
                                                        !(item === null || item === void 0 ? void 0 : (ref19 = item.currentVarent) === null || ref19 === void 0 ? void 0 : (ref20 = ref19.details) === null || ref20 === void 0 ? void 0 : ref20.discontinued) && loading === "success" && inventory ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "addtocart-widgets d-flex",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "counter-widgets d-flex",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                            className: "decrement-widgets",
                                                                            onClick: decrementCounter,
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* DecIcon */.Nh, {})
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                            type: "number",
                                                                            onChange: (e)=>{
                                                                                var ref;
                                                                                return handlerCounter(e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : ref.value);
                                                                            },
                                                                            value: counter
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                            className: "increment-widgets",
                                                                            onClick: incrementCounter,
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* IncIcon */.M9, {})
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "button-carts",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                        onClick: ()=>!loaded ? handlerCart({
                                                                                ...item,
                                                                                fileTitle: title,
                                                                                quantity: counter,
                                                                                pdpDetails
                                                                            }) : null,
                                                                        disabled: loaded,
                                                                        type: "button",
                                                                        className: "fs-18 fw-500 add-to-cart d-flex align-items-center justify-content-center ".concat(loaded ? "disabled" : "", "\n                        "),
                                                                        children: loaded ? /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* LoadingIcon */.Ho, {}) : addToCart
                                                                    })
                                                                })
                                                            ]
                                                        }) : "",
                                                        ((item === null || item === void 0 ? void 0 : (ref21 = item.currentVarent) === null || ref21 === void 0 ? void 0 : (ref22 = ref21.details) === null || ref22 === void 0 ? void 0 : ref22.isStock) === "false" || inventory === 0) && !(item === null || item === void 0 ? void 0 : (ref23 = item.currentVarent) === null || ref23 === void 0 ? void 0 : (ref24 = ref23.details) === null || ref24 === void 0 ? void 0 : ref24.discontinued) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(NotifyMe, {
                                                            item: item
                                                        }) : ""
                                                    ]
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                }),
                cartToast ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "cart-toast-text",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            children: [
                                "( ",
                                counter,
                                " ) ",
                                counter > 1 ? "Items" : "Item",
                                " has been added to your cart."
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            onClick: ()=>setCartToast(false),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* CartCloseIcon */.xD, {})
                        })
                    ]
                }) : ""
            ]
        });
    }
};
DetailPopUp.propTypes = {
    productId: (prop_types_default()).string.isRequired,
    setModal: (prop_types_default()).func.isRequired,
    analytics: (prop_types_default()).object.isRequired,
    title: (prop_types_default()).string.isRequired,
    fullscreen: (prop_types_default()).bool.isRequired,
    setWidthSize: (prop_types_default()).func.isRequired,
    partController: prop_types_default().shape({
        actions: prop_types_default().shape({
            get: prop_types_default().shape({
                entryByKey: (prop_types_default()).func.isRequired
            })
        })
    })
};
/* harmony default export */ var v2_DetailPopUp = (DetailPopUp);

// EXTERNAL MODULE: ./components/core/RadioButton/RadioButton.jsx
var RadioButton = __webpack_require__(65131);
;// CONCATENATED MODULE: ./components/PartsViewer/v2/GridAndListPanel/ToggleView/index.js



const ToggleView = (props)=>{
    const { listView , setlistView , device  } = props;
    const isDesktop = device.isExtraLargeScreen || device.isLargeScreen;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "btn-group btn-group-toggle",
            "data-toggle": "buttons",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                    className: "btn-expand grid-btn border-0 ".concat(isDesktop || (device === null || device === void 0 ? void 0 : device.isMediumScreen) ? "pr-15" : "pr-15 pl-20", " ").concat(listView ? "" : "active"),
                    onClick: (event)=>{
                        event.preventDefault();
                        event.stopPropagation();
                        setlistView(false);
                    },
                    "data-testid": "select-grid-view",
                    children: [
                        !listView ? /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* ImageGridViewMobile */.Wz, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* GridViewUnSelected */.PL, {}),
                        isDesktop ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "tool-tip-custom bottom grid-list-view",
                            children: "Grid view"
                        }) : null
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                    className: "btn-expand list-btn border-0 ".concat(listView ? "active" : ""),
                    onClick: (event)=>{
                        event.preventDefault();
                        event.stopPropagation();
                        setlistView(true);
                    },
                    children: [
                        listView ? /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* ListViewSelected */.pS, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* ImageListViewMobile */.Eh, {}),
                        isDesktop ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "tool-tip-custom bottom grid-list-view",
                            children: "List view"
                        }) : null
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var GridAndListPanel_ToggleView = (ToggleView);

;// CONCATENATED MODULE: ./components/PartsViewer/v2/GridAndListPanel/SortDropdown/index.js







const SortDropdown = (props)=>{
    const { partController , visibleData , title , sku , setlistView , listView , isListExtend  } = props;
    const [sort, setSort] = (0,react.useState)("asc");
    const [sortDesc, setSortDesc] = (0,react.useState)("A-Z");
    const device = (0,useViewport/* default */.Z)();
    const [isOpen, setIsOpen] = (0,react.useState)(false);
    const isDesktop = device.isLargeScreen || device.isExtraLargeScreen;
    const toogleDropDown = ()=>{
        setIsOpen((prevOpen)=>!prevOpen);
    };
    const sortBy = (e, order)=>{
        setIsOpen(false);
        partController.actions.filterProduct(order.key);
        partController.actions.fetchForCpiPromise(visibleData);
        setSortDesc(order.label);
        setSort(order.key);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "drop-down",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                    type: "button",
                    id: "dropdown-basic",
                    "aria-expanded": "false",
                    "data-testid": "sort-dropdown",
                    className: "sorting-btn btn btn-expand border-0 ".concat(isListExtend ? "full-screen-view" : "small-screen-view"),
                    onClick: toogleDropDown,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: isDesktop ? "Sort By: ".concat(sortDesc) : "Sort"
                        }),
                        isDesktop ? /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* SortByDropDownIcon */.tR, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* SortByIcon */.rc, {}),
                        device.isSmallScreen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(GridAndListPanel_ToggleView, {
                            listView,
                            setlistView,
                            device,
                            title,
                            sku
                        }) : null
                    ]
                }),
                isOpen ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "drop-down-menu border-0 ".concat(device.isSmallScreen ? "mobile-dropdown" : ""),
                    children: [
                        device.isSmallScreen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "sort-div d-flex justify-content-between align-items-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "sort-by-title",
                                        children: "Sort "
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "close-icon",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            onClick: toogleDropDown,
                                            className: "close-menu",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* IconClose */.bM, {})
                                        })
                                    })
                                ]
                            })
                        }) : null,
                        sortOptions.map((val)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                "data-testid": "sort-".concat(val.key),
                                className: "dropdown-item drop-link ".concat(sort === val.key ? "sort-by" : ""),
                                onClick: (event)=>sortBy(event, val),
                                children: device.isSmallScreen ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "sort__radio-group",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioButton/* default */.Z, {
                                        id: val.key,
                                        name: val.key,
                                        value: val.label,
                                        checked: sort === val.key
                                    })
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: val.label
                                })
                            }, val.key))
                    ]
                }) : null,
                device.isSmallScreen && isOpen ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mobile-overlay"
                }) : null
            ]
        })
    });
};
/* harmony default export */ var GridAndListPanel_SortDropdown = (SortDropdown);

;// CONCATENATED MODULE: ./components/PartsViewer/v2/helper.js

const isObjectEmpty = (objectName)=>{
    return Object.keys(objectName).length === 0;
};
const getPersonaPriceDetails = (priceDtl)=>{
    var ref;
    const persona = (0,helper/* getUserPersona */.shu)();
    const result = [];
    const filerPrice = priceDtl === null || priceDtl === void 0 ? void 0 : (ref = priceDtl.prices) === null || ref === void 0 ? void 0 : ref.filter((elemet)=>{
        return !isObjectEmpty(elemet === null || elemet === void 0 ? void 0 : elemet.prices);
    });
    filerPrice === null || filerPrice === void 0 ? void 0 : filerPrice.map((price)=>{
        if (Object.keys(price === null || price === void 0 ? void 0 : price.prices) !== 0) {
            var ref, ref1, ref2;
            result.push({
                currencySign: (price === null || price === void 0 ? void 0 : price.currencySign) ? price === null || price === void 0 ? void 0 : price.currencySign : $,
                sku: price === null || price === void 0 ? void 0 : price.sku,
                discountedPrice: Object.values(price === null || price === void 0 ? void 0 : price.discountPrices).length ? (((ref = price === null || price === void 0 ? void 0 : price.discountPrices[persona]) === null || ref === void 0 ? void 0 : ref.centAmount) / 100).toFixed(2) : null,
                price: (price === null || price === void 0 ? void 0 : price.prices[persona]) ? (((ref1 = price === null || price === void 0 ? void 0 : price.prices[persona]) === null || ref1 === void 0 ? void 0 : ref1.centAmount) / 100).toFixed(2) : null,
                pricelist: (price === null || price === void 0 ? void 0 : price.prices["ANY"]) ? (((ref2 = price === null || price === void 0 ? void 0 : price.prices["ANY"]) === null || ref2 === void 0 ? void 0 : ref2.centAmount) / 100).toFixed(2) : null
            });
        }
    });
    return result;
};
const getProductCartQuantity = (listColor, cart, productId)=>{
    var ref;
    let mapColor;
    if (listColor) {
        const list = listColor.map((color)=>{
            const d = color.split("|");
            return {
                sku: d[2].split("-")[0]
            };
        });
        mapColor = [
            ...new Set(list.map((item)=>item.sku))
        ];
    }
    const isAdded = cart === null || cart === void 0 ? void 0 : (ref = cart.lineItems) === null || ref === void 0 ? void 0 : ref.filter((item)=>{
        var ref;
        const itemID = (ref = item.variant) === null || ref === void 0 ? void 0 : ref.sku.split("-")[0];
        return (mapColor === null || mapColor === void 0 ? void 0 : mapColor.includes(itemID)) || productId === itemID;
    });
    const totalQunatity = isAdded === null || isAdded === void 0 ? void 0 : isAdded.reduce((sum, item)=>sum + item.quantity, 0);
    const isAddedFlag = (isAdded === null || isAdded === void 0 ? void 0 : isAdded[0]) ? true : false;
    return {
        isAddedFlag,
        totalQunatity
    };
};
const getStockItems = (args)=>{
    var ref;
    let stock = false;
    let discontuned = false;
    let outofStock = false;
    args === null || args === void 0 ? void 0 : args.forEach((val)=>{
        const isDiscontinudItems = val === null || val === void 0 ? void 0 : val.discontinued;
        const isStock = (val === null || val === void 0 ? void 0 : val.isStock) === "true" || (val === null || val === void 0 ? void 0 : val.isStock) === undefined;
        if (isDiscontinudItems) {
            discontuned = true;
        } else if (isStock) {
            stock = true;
        } else {
            outofStock = true;
        }
    });
    return {
        stock,
        discontuned,
        outofStock,
        sku: (ref = args[0]) === null || ref === void 0 ? void 0 : ref.sku
    };
};

;// CONCATENATED MODULE: ./components/PartsViewer/v2/GridAndListPanel/GridView/LoadingGrid/index.js


const GridCardLoading = (param)=>{
    let { isListExtend  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "card d-flex load-widgets flex-column justify-content-start",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                class: "shimmer-loading__image shimmer ".concat(isListExtend ? "grid-fullwidth" : "thumb-size", " ")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "d-flex flex-column justify-content-start",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "width-full",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "d-flex",
                            children: [
                                Array.from({
                                    length: 5
                                }, (val, index)=>index + 1).map((val)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        class: "shimmer-loading__para shimmer width-20"
                                    }, val)),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    class: " width-16 loading-part mx-1 shimmer-loading__para shimmer"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            class: "shimmer-loading__para shimmer width-191 loading-part"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            class: "shimmer-loading__para shimmer width-102 loading-part"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "d-flex",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    class: "shimmer-loading__para shimmer width-15 loading-part"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    class: "shimmer-loading__para shimmer width-15 mx-3 loading-part"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var LoadingGrid = (GridCardLoading);

// EXTERNAL MODULE: ./public/images/swatch-missing.jpeg
var swatch_missing = __webpack_require__(36562);
;// CONCATENATED MODULE: ./components/PartsViewer/v2/ButtonLable/Index.js






const ButtonLabel = (props)=>{
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const { addedText  } = (0,localization/* getTranslations */.F)(t);
    const { cartQuantity , list =false  } = props;
    if (list) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* AddedIcon */.tW, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: "add-label",
                    children: [
                        "(",
                        cartQuantity,
                        ")"
                    ]
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* AddedIcon */.tW, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: "added-label",
                children: [
                    addedText,
                    " (",
                    cartQuantity,
                    ")"
                ]
            })
        ]
    });
};
ButtonLabel.propTypes = {
    cartQuantity: (prop_types_default()).string.isRequired,
    list: (prop_types_default()).bool.isRequired
};
/* harmony default export */ var Index = (ButtonLabel);

;// CONCATENATED MODULE: ./components/PartsViewer/v2/CartButton/Index.js





const CartButton = (props)=>{
    const { isAddedFlag , cartQuantity , handlerButton , swatches , list =false  } = props;
    const [item, setItem] = (0,react.useState)(null);
    (0,react.useEffect)(()=>{
        if (swatches) {
            getSwatchesDetails(swatches);
        }
    }, [
        swatches
    ]);
    const getSwatchesDetails = async (arg)=>{
        const filterItems = arg.filter((v)=>{
            return (v === null || v === void 0 ? void 0 : v.swatch) !== "swatch_NA";
        });
        const updatedList = filterItems.length === 0 ? arg : filterItems;
        const resp = await getStockItems(updatedList);
        if (resp) {
            setItem(resp);
        }
    };
    const buttonClass = isAddedFlag ? "cart-added" : "active-btn";
    const isDisabled = (item === null || item === void 0 ? void 0 : item.discontuned) && !(item === null || item === void 0 ? void 0 : item.outofStock);
    const listViewClass = list ? "grid-button list-button" : "grid-button ";
    const listViewtext = list ? "Notify" : "Notify Me";
    const stockText = (item === null || item === void 0 ? void 0 : item.outofStock) && !(item === null || item === void 0 ? void 0 : item.stock) ? listViewtext : "Add";
    const disabledVal = isDisabled && !(item === null || item === void 0 ? void 0 : item.stock);
    const buttontext = disabledVal ? "Discontinued" : stockText;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "button-groups-".concat(list ? "list-btns" : ""),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: listViewClass + " button-add-carts ".concat(disabledVal ? "disabled-btn" : buttonClass),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                type: "button",
                className: "fs-18 fw-500 add-to-cart d-flex align-items-center justify-content-center ".concat(list ? "list right-screen" : ""),
                onClick: ()=>handlerButton(!disabledVal),
                children: isAddedFlag ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Index, {
                    cartQuantity: cartQuantity,
                    list: list
                }) : buttontext
            })
        })
    });
};
CartButton.propTypes = {
    isAddedFlag: (prop_types_default()).string.isRequired,
    cartQuantity: (prop_types_default()).string.isRequired,
    handlerButton: (prop_types_default()).func.isRequired,
    swatches: (prop_types_default()).object.isRequired,
    list: (prop_types_default()).bool.isRequired
};
/* harmony default export */ var CartButton_Index = (CartButton);

;// CONCATENATED MODULE: ./components/PartsViewer/v2/GridAndListPanel/GridView/index.js













const GridView = (props)=>{
    var ref, ref1, ref2;
    const { dataPromise , showPopup , isListExtend , dataInput , showCart , setShowCart , showCartPopUp  } = props;
    const [validUrl, setValidUrl] = (0,react.useState)({
        status: "loading"
    });
    const [loading, setLoading] = (0,react.useState)("notStarted");
    const [productSwatche, setProductSwatche] = (0,react.useState)({});
    const [colour, setColour] = (0,react.useState)();
    const [selectedVariant, setSelectedVariant] = (0,react.useState)(null);
    const [colorItem, setColorItem] = (0,react.useState)(null);
    const [swatches, setSwatches] = (0,react.useState)(null);
    const device = (0,useViewport/* default */.Z)();
    const { Name: name , productId , imageUrl: image , priceInfo , productInventoryInfo , isAddedFlag , cartQuantity  } = productSwatche;
    const personaPriceList = getPersonaPriceDetails(dataInput);
    const { cart  } = (0,es/* useSelector */.v9)(cartSlice/* selectCartState */.xw);
    (0,react.useEffect)(()=>{
        getGridItems();
        return ()=>{
            setProductSwatche({});
            setLoading("loading");
        };
    }, [
        cart
    ]);
    (0,react.useEffect)(()=>{
        updateImageUrl();
        return ()=>{
            setValidUrl({});
        };
    }, [
        productSwatche === null || productSwatche === void 0 ? void 0 : productSwatche.imageUrl
    ]);
    const updateImageUrl = async ()=>{
        if (productSwatche === null || productSwatche === void 0 ? void 0 : productSwatche.imageUrl) {
            const res = await isImgUrlValid(productSwatche === null || productSwatche === void 0 ? void 0 : productSwatche.imageUrl);
            if (res) {
                setValidUrl({
                    status: "success"
                });
            } else {
                setValidUrl({
                    status: "failed"
                });
            }
        } else {
            setValidUrl({
                status: "failed"
            });
        }
    };
    const getGridItems = async ()=>{
        setLoading("loading");
        const res = await dataPromise;
        if (res) {
            var ref, ref1, ref2, ref3, ref4, ref5;
            const { Name , productId , skuId , data , productIdKey , data: list , activeItem  } = res;
            const imageUrl = data === null || data === void 0 ? void 0 : (ref = data.colorData) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.imgUrl;
            const priceInfo = (ref3 = list === null || list === void 0 ? void 0 : (ref2 = list.colorData) === null || ref2 === void 0 ? void 0 : ref2.filter((item)=>item.id === activeItem)) === null || ref3 === void 0 ? void 0 : ref3[0];
            const productInventoryInfo = (ref5 = list === null || list === void 0 ? void 0 : (ref4 = list.varientDetails) === null || ref4 === void 0 ? void 0 : ref4.filter((item)=>item.sku === activeItem)) === null || ref5 === void 0 ? void 0 : ref5[0];
            const isAddedOne = getProductCartQuantity(list["Color.SKU.Details_ss"], cart, productId, skuId, activeItem);
            const cartQuantity = isAddedOne ? isAddedOne.totalQunatity : "";
            const isAddedFlag = isAddedOne === null || isAddedOne === void 0 ? void 0 : isAddedOne.isAddedFlag;
            setProductSwatche({
                Name,
                productId,
                skuId,
                imageUrl,
                productIdKey,
                priceInfo,
                productInventoryInfo,
                isAddedFlag,
                cartQuantity
            });
            if (list) {
                const getSwatches = list["varientDetails"];
                const filterSwatch = getSwatches === null || getSwatches === void 0 ? void 0 : getSwatches.filter((val)=>val["swatch"] !== "swatch_NA");
                const colorArray = personaPriceList.map((item)=>{
                    const matchItem = Object.values(filterSwatch).find((element)=>item.sku === element.sku);
                    if (matchItem) return {
                        ...item,
                        ...matchItem
                    };
                    else return item;
                });
                setColour(colorArray);
                const activeItems = colorArray === null || colorArray === void 0 ? void 0 : colorArray.filter((v)=>{
                    return (v === null || v === void 0 ? void 0 : v.swatch) ? (v === null || v === void 0 ? void 0 : v.swatch) !== "swatch_NA" : v[0];
                });
                const firstItems = activeItems[0];
                setColorItem(firstItems);
                setSelectedVariant(firstItems);
                setSwatches(getSwatches);
            }
            setLoading("loaded");
        }
    };
    if (loading !== "loaded") return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingGrid, {
        isListExtend: isListExtend
    });
    const colorSwatchDefaultImg = (e)=>{
        e.target.src = swatch_missing/* default.src */.Z.src;
    };
    const colorCount = isListExtend && ((device === null || device === void 0 ? void 0 : device.isLargeScreen) || (device === null || device === void 0 ? void 0 : device.isExtraLargeScreen)) ? 7 : 5;
    let extraColor;
    if ((colour === null || colour === void 0 ? void 0 : colour.length) > colorCount) {
        extraColor = (colour === null || colour === void 0 ? void 0 : colour.length) - colorCount;
    }
    let marginStyle = "";
    if ((colour === null || colour === void 0 ? void 0 : colour.length) > 0) {
        marginStyle = "mb-8";
    }
    const varientPrices = selectedVariant ? selectedVariant : priceInfo;
    const chkDiscontinue = selectedVariant ? selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.discontinued : productInventoryInfo === null || productInventoryInfo === void 0 ? void 0 : productInventoryInfo.discontinued;
    const outOfStock = selectedVariant ? !(selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.discontinued) && (selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.isStock) === "false" : (productInventoryInfo === null || productInventoryInfo === void 0 ? void 0 : productInventoryInfo.isStock) === "false" && (productInventoryInfo === null || productInventoryInfo === void 0 ? void 0 : productInventoryInfo.discontinued) === false;
    const handlerButton = (arg)=>{
        if (arg) {
            setShowCart(!showCart);
            showCartPopUp(productId);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "card",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                onClick: ()=>{
                    showPopup(productId);
                },
                "data-testid": "grid-card",
                onKeyDown: ()=>{
                    showPopup(productId);
                },
                className: "thumb-size ".concat(isListExtend ? "grid-fullwidth" : ""),
                children: (validUrl === null || validUrl === void 0 ? void 0 : validUrl.status) === "loading" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "loading-spinner border-0",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "shimmer-loading__image shimmer"
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    className: "card-img-top",
                    src: validUrl.status === "success" ? image : coming_soon.src,
                    alt: name
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "card-bodys grid ".concat((colour === null || colour === void 0 ? void 0 : colour.length) <= 0 ? "mt-3" : ""),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "product-information",
                        onClick: ()=>{
                            showPopup(productId);
                        },
                        onKeyDown: ()=>{
                            showPopup(productId);
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "color-variants ".concat(marginStyle),
                                children: [
                                    (ref = colour === null || colour === void 0 ? void 0 : colour.slice(0, colorCount)) === null || ref === void 0 ? void 0 : ref.map((item)=>item["swatch"] !== undefined ? /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                            className: "other_color",
                                            onMouseEnter: ()=>setSelectedVariant(item),
                                            onMouseLeave: ()=>setSelectedVariant(colorItem),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                width: "20px",
                                                height: "20px",
                                                className: "img_variant_color",
                                                src: constants["default"].COLOR_FILE_URL + item["swatch"],
                                                alt: item["name"],
                                                onError: (e)=>colorSwatchDefaultImg(e),
                                                title: selectedVariant ? selectedVariant[0] : item["name"]
                                            })
                                        }, item["swatch"]) : null),
                                    extraColor ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                        className: "extra-color",
                                        children: [
                                            "+",
                                            extraColor
                                        ]
                                    }) : null
                                ]
                            }),
                            chkDiscontinue ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "fs-13 fw-600 tag-discontinue discontinued mb-5 label-discontinued",
                                children: "Discontinued"
                            }) : null,
                            outOfStock ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "fs-13 fw-600 tag-discontinue mb-5 outof-stoke label-discontinued ",
                                children: "out of stock"
                            }) : null,
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "card-model",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "card-text fw-400 model-number card-product-title text-capitalize mb-5",
                                        children: name === null || name === void 0 ? void 0 : name.toLowerCase()
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "card-text fw-400 text-capitalize sku_product-description mb-5 ".concat(device.isSmallScreen ? "my-1" : ""),
                                        children: varientPrices ? (varientPrices === null || varientPrices === void 0 ? void 0 : varientPrices.customerSku) || (dataInput === null || dataInput === void 0 ? void 0 : (ref1 = dataInput.partApi) === null || ref1 === void 0 ? void 0 : ref1.skuId) : (varientPrices === null || varientPrices === void 0 ? void 0 : varientPrices.value) || (dataInput === null || dataInput === void 0 ? void 0 : (ref2 = dataInput.partApi) === null || ref2 === void 0 ? void 0 : ref2.skuId)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "card-text fw-400 text-capitalize sku-price",
                                        children: [
                                            (varientPrices === null || varientPrices === void 0 ? void 0 : varientPrices.discountedPrice) ? (varientPrices === null || varientPrices === void 0 ? void 0 : varientPrices.currencySign) + (varientPrices === null || varientPrices === void 0 ? void 0 : varientPrices.discountedPrice) : null,
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "sku-price ".concat((varientPrices === null || varientPrices === void 0 ? void 0 : varientPrices.discountedPrice) ? "mx-1 discount-price" : ""),
                                                children: (varientPrices === null || varientPrices === void 0 ? void 0 : varientPrices.currencySign) + (varientPrices === null || varientPrices === void 0 ? void 0 : varientPrices.price) || null
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CartButton_Index, {
                        isAddedFlag: isAddedFlag,
                        cartQuantity: cartQuantity,
                        handlerButton: handlerButton,
                        swatches: swatches
                    })
                ]
            })
        ]
    });
};
GridView.propTypes = {
    showPopup: (prop_types_default()).bool.isRequired,
    dataPromise: (prop_types_default()).func.isRequired,
    isListExtend: (prop_types_default()).bool.isRequired,
    dataInput: (prop_types_default()).object.isRequired,
    showCart: (prop_types_default()).bool.isRequired,
    setShowCart: (prop_types_default()).func.isRequired,
    showCartPopUp: (prop_types_default()).func.isRequired
};
/* harmony default export */ var GridAndListPanel_GridView = (GridView);

;// CONCATENATED MODULE: ./public/scout_icon/dummy_image.jpg
/* harmony default export */ var dummy_image = ({"src":"/_next/static/media/dummy_image.09e12036.jpg","height":800,"width":800,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAIAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAf/xAAZEAEAAgMAAAAAAAAAAAAAAAAAERIiQYH/xAAUAQEAAAAAAAAAAAAAAAAAAAAA/8QAFBEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEQMRAD8Ared9VjoAP//Z","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./components/PartsViewer/v2/GridAndListPanel/ListView/LoadingCard/index.js



const ListCardLoading = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "card d-flex load-widgets border-active flex-row justify-content-between mt-8",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "d-flex flex-row justify-content-start",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "thumb-list loading-animation shimmer ",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: dummy_image === null || dummy_image === void 0 ? void 0 : dummy_image.src,
                        alt: "loading"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "width-full",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "d-flex",
                            children: [
                                Array.from({
                                    length: 5
                                }, (val, index)=>index + 1).map((val)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        class: "shimmer-loading__para shimmer width-20"
                                    }, val)),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    class: " width-16 loading-part mx-1 shimmer-loading__para shimmer"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "d-flex flex-column justify-content-start pt-5",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    class: "shimmer-loading__para shimmer width-191 loading-part"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    class: "shimmer-loading__para shimmer width-102 loading-part"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "d-flex",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            class: "shimmer-loading__para shimmer width-15 loading-part"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            class: "shimmer-loading__para shimmer width-15 mx-3 loading-part"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var LoadingCard = (ListCardLoading);

;// CONCATENATED MODULE: ./components/PartsViewer/v2/GridAndListPanel/ListView/index.js















const ListView = (props)=>{
    var ref, ref1, ref2;
    const { dataPromise , showPopup , isListExtend , dataInput , showCart , setShowCart , showCartPopUp  } = props;
    const [validUrl, setValidUrl] = (0,react.useState)({
        status: "loading"
    });
    const [loading, setLoading] = (0,react.useState)("notStarted");
    const [productSwatche, setProductSwatche] = (0,react.useState)({});
    const device = (0,useViewport/* default */.Z)();
    const [colour, setColour] = (0,react.useState)();
    const [selectedVariant, setSelectedVariant] = (0,react.useState)(null);
    const [colorItem, setColorItem] = (0,react.useState)(null);
    const [swatches, setSwatches] = (0,react.useState)(null);
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const { outOfStockText , discontinuedText  } = (0,localization/* getTranslations */.F)(t);
    const { Name: name , productId , imageUrl: image , priceInfo , productInventoryInfo , isAddedFlag , cartQuantity  } = productSwatche;
    const personaPriceList = getPersonaPriceDetails(dataInput);
    const { cart  } = (0,es/* useSelector */.v9)(cartSlice/* selectCartState */.xw);
    (0,react.useEffect)(()=>{
        getListData();
    }, [
        cart
    ]);
    (0,react.useEffect)(()=>{
        updateImgUrl();
    }, [
        productSwatche === null || productSwatche === void 0 ? void 0 : productSwatche.imageUrl
    ]);
    const updateImgUrl = async ()=>{
        if (productSwatche === null || productSwatche === void 0 ? void 0 : productSwatche.imageUrl) {
            const res = await isImgUrlValid(productSwatche === null || productSwatche === void 0 ? void 0 : productSwatche.imageUrl);
            if (res) {
                setValidUrl({
                    status: "success"
                });
            } else {
                setValidUrl({
                    status: "failed"
                });
            }
        } else {
            setValidUrl({
                status: "failed"
            });
        }
    };
    const getListData = async ()=>{
        var ref, ref1, ref2, ref3, ref4;
        setLoading("loading");
        const res = await dataPromise;
        const { Name , productId , productIdKey , data: list , activeItem  } = res;
        const imageUrl = (ref = list === null || list === void 0 ? void 0 : list.colorData[0]) === null || ref === void 0 ? void 0 : ref.imgUrl;
        const priceInfo = (ref2 = list === null || list === void 0 ? void 0 : (ref1 = list.colorData) === null || ref1 === void 0 ? void 0 : ref1.filter((item)=>item.id === activeItem)) === null || ref2 === void 0 ? void 0 : ref2[0];
        const productInventoryInfo = (ref4 = list === null || list === void 0 ? void 0 : (ref3 = list.varientDetails) === null || ref3 === void 0 ? void 0 : ref3.filter((item)=>item.sku === activeItem)) === null || ref4 === void 0 ? void 0 : ref4[0];
        const isAddedOne = getProductCartQuantity(list["Color.SKU.Details_ss"], cart, productId, activeItem);
        const cartQuantity = isAddedOne ? isAddedOne.totalQunatity : "";
        const isAddedFlag = isAddedOne === null || isAddedOne === void 0 ? void 0 : isAddedOne.isAddedFlag;
        setProductSwatche({
            Name,
            productId,
            imageUrl,
            productIdKey,
            priceInfo,
            productInventoryInfo,
            isAddedFlag,
            cartQuantity
        });
        if (res === null || res === void 0 ? void 0 : res.data) {
            const getSwatches = list === null || list === void 0 ? void 0 : list.varientDetails;
            const filterSwatch = getSwatches.filter((val)=>val["swatch"] !== "swatch_NA");
            const colorArray = personaPriceList.map((item)=>{
                const matchItem = Object.values(filterSwatch).find((element)=>item.sku === element.sku);
                if (matchItem) return {
                    ...item,
                    ...matchItem
                };
                else return item;
            });
            setColour(colorArray);
            const activeItems = colorArray === null || colorArray === void 0 ? void 0 : colorArray.filter((v)=>{
                return (v === null || v === void 0 ? void 0 : v.swatch) ? (v === null || v === void 0 ? void 0 : v.swatch) !== "swatch_NA" : v[0];
            });
            const firstItems = activeItems[0];
            setColorItem(firstItems);
            setSelectedVariant(firstItems);
            setSwatches(getSwatches);
        }
        setLoading("loaded");
    };
    if (loading !== "loaded") return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingCard, {});
    const colorCount = 5;
    let extraColor;
    if ((colour === null || colour === void 0 ? void 0 : colour.length) > colorCount) {
        extraColor = (colour === null || colour === void 0 ? void 0 : colour.length) - colorCount;
    }
    let marginStyle;
    let flexDirection;
    const forMediumScreen = (device === null || device === void 0 ? void 0 : device.isMediumScreen) && !isListExtend;
    if (forMediumScreen) {
        marginStyle = "mx-0 marginStyle";
        flexDirection = "flex-column";
    } else if ((colour === null || colour === void 0 ? void 0 : colour.length) > 1) {
        if (device === null || device === void 0 ? void 0 : device.isSmallScreen) {
            marginStyle = "marginStyle";
        } else {
            marginStyle = "ml-10 tag-discontinue-position";
        }
    }
    const colorSwatchDefaultImg = (e)=>{
        e.target.src = swatch_missing/* default.src */.Z.src;
    };
    const forAllSmallScreen = device.isMediumScreen || (device === null || device === void 0 ? void 0 : device.isSmallScreen) || (device === null || device === void 0 ? void 0 : device.isExtraSmallScreen);
    const listviewCls = !isListExtend && device.isMediumScreen ? "mx-0 p-0 mt-5" : "sku-cart-margin";
    const skuPriceClass = isListExtend && !device.isMediumScreen ? "justify-content-end w-50" : listviewCls;
    let titleAlignCenter = "";
    if (isListExtend && (device.isExtraLargeScreen || device.isLargeScreen)) {
        if (!(productInventoryInfo === null || productInventoryInfo === void 0 ? void 0 : productInventoryInfo.discontinued) && !((productInventoryInfo === null || productInventoryInfo === void 0 ? void 0 : productInventoryInfo.isStock) === "false" && (productInventoryInfo === null || productInventoryInfo === void 0 ? void 0 : productInventoryInfo.discontinued) === false)) {
            titleAlignCenter = true;
        }
    }
    const varientPrices = selectedVariant ? selectedVariant : priceInfo;
    let showAddTocart = false;
    if (!isListExtend && device.isExtraLargeScreen || (device === null || device === void 0 ? void 0 : device.isLargeTabView) || (device === null || device === void 0 ? void 0 : device.isMediumScreen) && isListExtend) {
        showAddTocart = true;
    }
    const chkDiscontinue = selectedVariant ? selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.discontinued : productInventoryInfo === null || productInventoryInfo === void 0 ? void 0 : productInventoryInfo.discontinued;
    const outOfStock = selectedVariant ? !(selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.discontinued) && (selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.isStock) === "false" : (productInventoryInfo === null || productInventoryInfo === void 0 ? void 0 : productInventoryInfo.isStock) === "false" && (productInventoryInfo === null || productInventoryInfo === void 0 ? void 0 : productInventoryInfo.discontinued) === false;
    const handlerButton = (arg)=>{
        if (arg) {
            setShowCart(!showCart);
            showCartPopUp(productId);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "card border-active list-section",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "card-bodys d-flex justify-content-between",
                onClick: ()=>{
                    showPopup(productId);
                },
                "data-testid": "list-card",
                onKeyDown: ()=>{
                    showPopup(productId);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "d-flex w-100 flex-grow-1",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "thumb-list",
                            children: (validUrl === null || validUrl === void 0 ? void 0 : validUrl.status) === "loading" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "loading-spinner",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "shimmer-loading__image shimmer"
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                width: "60px",
                                height: "60px",
                                className: "card-img",
                                src: validUrl.status === "success" ? image : coming_soon === null || coming_soon === void 0 ? void 0 : coming_soon.src,
                                alt: name
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "d-flex w-100 flex-grow-1",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "d-flex justify-content-between w-100 flex-grow-1 \n                ".concat(forAllSmallScreen ? "flex-column" : "", "\n                ").concat(isListExtend && !(device === null || device === void 0 ? void 0 : device.isMediumScreen) ? "flex-row ms-4" : "flex-column", " pt-2 pb-2"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "d-flex flex-column",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "color-variants list-color ".concat(forMediumScreen ? "d-block" : "color-parts"),
                                                children: [
                                                    (colour === null || colour === void 0 ? void 0 : colour.length) > 1 ? (ref = colour === null || colour === void 0 ? void 0 : colour.slice(0, colorCount)) === null || ref === void 0 ? void 0 : ref.map((item)=>{
                                                        return (item === null || item === void 0 ? void 0 : item.swatch) !== undefined ? /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                            className: "other_color",
                                                            onMouseEnter: ()=>setSelectedVariant(item),
                                                            onMouseLeave: ()=>setSelectedVariant(colorItem),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                width: "20px",
                                                                height: "20px",
                                                                className: "img_variant_color",
                                                                src: constants["default"].COLOR_FILE_URL + item["swatch"],
                                                                alt: item["name"],
                                                                onError: (e)=>colorSwatchDefaultImg(e),
                                                                title: selectedVariant ? selectedVariant[0] : item["name"]
                                                            })
                                                        }, item["swatch"]) : "";
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                        children: titleAlignCenter ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "title-center-align"
                                                        }) : ""
                                                    }),
                                                    extraColor ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                        className: "extra-color",
                                                        children: [
                                                            "+",
                                                            extraColor
                                                        ]
                                                    }) : "",
                                                    chkDiscontinue ? /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                        className: "fs-13 fw-600 tag-discontinue discontinued label-discontinued ".concat(marginStyle),
                                                        children: discontinuedText
                                                    }) : "",
                                                    outOfStock ? /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                        className: "fs-13 fw-600 tag-discontinue outof-stoke label-discontinued ".concat(marginStyle, " "),
                                                        children: outOfStockText
                                                    }) : ""
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "d-flex align-items-center justify-content-between mb-5",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    fontSize: 18,
                                                    className: "card-text fw-400 tablet-view-padding ".concat(isListExtend ? "model-name-list " : "model-name list-items", " text-capitalize"),
                                                    children: name === null || name === void 0 ? void 0 : name.toLowerCase()
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "d-flex card-text fw-400 align-items-center list-details list-fullwidth-tab position-relative ".concat(isListExtend ? "list-fullwidth" : "", " ").concat(!showAddTocart ? "justify-content-between" : "", " "),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "model-name d-flex ".concat(flexDirection, " ").concat(isListExtend && !device.isMediumScreen ? "justify-content-end w-75" : ""),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    fontSize: 14,
                                                    className: "sku-name",
                                                    children: varientPrices ? (varientPrices === null || varientPrices === void 0 ? void 0 : varientPrices.customerSku) || (dataInput === null || dataInput === void 0 ? void 0 : (ref1 = dataInput.partApi) === null || ref1 === void 0 ? void 0 : ref1.skuId) : (varientPrices === null || varientPrices === void 0 ? void 0 : varientPrices.value) || (dataInput === null || dataInput === void 0 ? void 0 : (ref2 = dataInput.partApi) === null || ref2 === void 0 ? void 0 : ref2.skuId)
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    fontSize: 14,
                                                    className: "model-prices d-flex  \n                      ".concat(skuPriceClass),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "sku_product ".concat((varientPrices === null || varientPrices === void 0 ? void 0 : varientPrices.discountedPrice) ? "mx-1 discount-price" : ""),
                                                            children: (varientPrices === null || varientPrices === void 0 ? void 0 : varientPrices.currencySign) + (varientPrices === null || varientPrices === void 0 ? void 0 : varientPrices.price) || null
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "model-name-price px-1",
                                                            children: (varientPrices === null || varientPrices === void 0 ? void 0 : varientPrices.discountedPrice) ? (varientPrices === null || varientPrices === void 0 ? void 0 : varientPrices.currencySign) + (varientPrices === null || varientPrices === void 0 ? void 0 : varientPrices.discountedPrice) : null
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CartButton_Index, {
                isAddedFlag: isAddedFlag,
                cartQuantity: cartQuantity,
                handlerButton: handlerButton,
                swatches: swatches,
                list: true
            })
        ]
    });
};
ListView.propTypes = {
    showPopup: (prop_types_default()).bool.isRequired,
    dataPromise: (prop_types_default()).func.isRequired,
    isListExtend: (prop_types_default()).bool.isRequired,
    dataInput: (prop_types_default()).object.isRequired,
    showCart: (prop_types_default()).bool.isRequired,
    setShowCart: (prop_types_default()).func.isRequired,
    showCartPopUp: (prop_types_default()).func.isRequired
};
/* harmony default export */ var GridAndListPanel_ListView = (ListView);

;// CONCATENATED MODULE: ./components/PartsViewer/v2/GridAndListPanel/ViewController/index.js





const ViewController = (props)=>{
    var ref, ref1, ref2, ref3, ref4, ref5;
    const { partController , isListView , isListExtend , showPopup , visibleData , title , sku , showCart , setShowCart , showCartPopUp  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Conditional_Conditional, {
                show: isListView,
                children: (ref2 = partController === null || partController === void 0 ? void 0 : (ref = partController.actions) === null || ref === void 0 ? void 0 : (ref1 = ref.get) === null || ref1 === void 0 ? void 0 : ref1.firstEntries(visibleData)) === null || ref2 === void 0 ? void 0 : ref2.map((input)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(GridAndListPanel_ListView, {
                        dataInput: input,
                        dataPromise: input.ctApiPromise,
                        showPopup: showPopup,
                        isListExtend: isListExtend,
                        title: title,
                        sku: sku,
                        showCart: showCart,
                        setShowCart: setShowCart,
                        showCartPopUp: showCartPopUp
                    }, input.key))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Conditional_Conditional, {
                show: !isListView,
                children: (ref5 = partController === null || partController === void 0 ? void 0 : (ref3 = partController.actions) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.get) === null || ref4 === void 0 ? void 0 : ref4.firstEntries(visibleData)) === null || ref5 === void 0 ? void 0 : ref5.map((input)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(GridAndListPanel_GridView, {
                        dataInput: input,
                        dataPromise: input.ctApiPromise,
                        showPopup: showPopup,
                        isListExtend: isListExtend,
                        title: title,
                        sku: sku,
                        showCart: showCart,
                        setShowCart: setShowCart,
                        showCartPopUp: showCartPopUp
                    }, input.key))
            })
        ]
    });
};
/* harmony default export */ var GridAndListPanel_ViewController = (ViewController);

;// CONCATENATED MODULE: ./components/PartsViewer/v2/AddCart/PriceLabel/index.js






const PriceLabel = (props)=>{
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const { discontinuedText ="" , outOfStockText  } = (0,localization/* getTranslations */.F)(t);
    const { priceInfo , itemStock  } = props;
    const { currentVarent: { currencySign =null , details =null , discountedPrice =null , value =null , price ="NaN"  } , Name: name  } = priceInfo;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "inner-contents",
        children: [
            itemStock ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "fs-13 fw-600 tag-discontinue mb-5 outof-stoke",
                children: outOfStockText
            }) : null,
            (details === null || details === void 0 ? void 0 : details.discontinued) === false ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "fs-13 fw-600 tag-discontinue discontinued mb-5 label-discontinued",
                children: discontinuedText
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                level: 2,
                className: "label-name fs-28 fw-325 text-capitalize",
                children: (name === null || name === void 0 ? void 0 : name.toLowerCase()) || "N/A"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "product-with-price",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "varient-text fs-14 fw-500",
                        children: value || "N/A"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "price-part d-flex",
                        children: price !== "NaN" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                discountedPrice ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Heading/* default */.Z, {
                                    level: 2,
                                    className: "price-text fs-28 fw-325 text-capitalize ",
                                    children: [
                                        currencySign,
                                        discountedPrice
                                    ]
                                }) : null,
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    className: "price-text fs-16 fw-400 text-capitalize ml-5 ".concat(discountedPrice ? "discount-price" : ""),
                                    children: [
                                        currencySign,
                                        price
                                    ]
                                })
                            ]
                        }) : null
                    })
                ]
            })
        ]
    });
};
PriceLabel.propTypes = {
    priceInfo: prop_types_default().shape({
        currentVarent: prop_types_default().shape({
            currencySign: (prop_types_default()).string.isRequired,
            details: (prop_types_default()).string.isRequired,
            discountedPrice: (prop_types_default()).number.isRequired,
            value: (prop_types_default()).string.isRequired,
            price: (prop_types_default()).number.isRequired
        }),
        Name: (prop_types_default()).string.isRequired
    }),
    itemStock: (prop_types_default()).string.isRequired
};
/* harmony default export */ var AddCart_PriceLabel = (PriceLabel);

// EXTERNAL MODULE: ./components/core/Button/Button.jsx + 1 modules
var Button = __webpack_require__(7872);
// EXTERNAL MODULE: ./components/PartsViewer/v2/AddCart/index.module.scss
var AddCart_index_module = __webpack_require__(16214);
var AddCart_index_module_default = /*#__PURE__*/__webpack_require__.n(AddCart_index_module);
;// CONCATENATED MODULE: ./components/PartsViewer/v2/AddCart/index.js

















const AddCart = (props)=>{
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    const { productId , setShowCart , showCart , partController , analytics , title , isListExtend , setCartToast  } = props;
    const [loading, setLoading] = (0,react.useState)("loading");
    const [item, setItem] = (0,react.useState)({});
    const [variant, setVariant] = (0,react.useState)(null);
    const [variantList, setVariantList] = (0,react.useState)([]);
    const [counter, setCounter] = (0,react.useState)(1);
    const [loaded, setLoaded] = (0,react.useState)(false);
    const [inventory, setInventory] = (0,react.useState)("");
    const [inventoryWarn, setInventoryWarn] = (0,react.useState)(false);
    const [isAdding, setIsAdding] = (0,react.useState)("");
    const device = (0,useViewport/* default */.Z)();
    const { isDesktop , isSmallScreen  } = (0,useViewport/* default */.Z)();
    const pdpDetails = (0,es/* useSelector */.v9)((state)=>state.pdp);
    const cartRef = (0,react.useRef)(null);
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const cartFlagFullWidth = isListExtend && device.isLargeTabView;
    const { addingCartText , addedCartText , addToCart , colorFinish , inventoryTextVal  } = (0,localization/* getTranslations */.F)(t);
    (0,react.useEffect)(()=>{
        getItemDetails(productId);
    }, [
        productId
    ]);
    (0,react.useEffect)(()=>{
        let timeId;
        if (inventory && counter > inventory) {
            setInventoryWarn(true);
            timeId = setTimeout(()=>{
                setCounter(inventory);
            }, 300);
        }
        return ()=>clearTimeout(timeId);
    }, [
        counter
    ]);
    (0,react.useEffect)(()=>{
        if (variant) {
            setCounter(1);
            setIsAdding("");
            getVarientInfo();
        }
    }, [
        variant
    ]);
    const getVarientInfo = async ()=>{
        const currentVarent = variantList === null || variantList === void 0 ? void 0 : variantList.filter((val)=>val.id === variant)[0];
        if (currentVarent) {
            setLoaded(true);
            const productQuantity = await getInventoryBySku(currentVarent === null || currentVarent === void 0 ? void 0 : currentVarent.id);
            setLoaded(false);
            setItem((prevState)=>{
                var ref, ref1;
                const details = prevState === null || prevState === void 0 ? void 0 : (ref = prevState.data) === null || ref === void 0 ? void 0 : (ref1 = ref.varientDetails) === null || ref1 === void 0 ? void 0 : ref1.filter((val)=>{
                    return (val === null || val === void 0 ? void 0 : val.sku) === (currentVarent === null || currentVarent === void 0 ? void 0 : currentVarent.id);
                })[0];
                return {
                    ...prevState,
                    currentVarent: {
                        ...currentVarent,
                        details
                    }
                };
            });
            setInventory(productQuantity);
            setInventoryWarn(false);
            if (productQuantity && counter > productQuantity) {
                setCounter(productQuantity);
                setInventoryWarn(true);
            }
        }
    };
    const getItemDetails = async (id)=>{
        const entry = partController.actions.get.entryByKey(id);
        setIsAdding("");
        setLoading("loading");
        if (entry === null || entry === void 0 ? void 0 : entry.ctApiPromise) {
            const ctResponse = await entry.ctApiPromise;
            if (ctResponse) {
                var ref, ref1, ref2, ref3;
                setLoaded(true);
                const allSwatch = ctResponse === null || ctResponse === void 0 ? void 0 : (ref = ctResponse.data) === null || ref === void 0 ? void 0 : ref.colorData;
                const currentSwatch = allSwatch === null || allSwatch === void 0 ? void 0 : (ref1 = allSwatch[0]) === null || ref1 === void 0 ? void 0 : ref1.id;
                const productQuantity = await getInventoryBySku(currentSwatch);
                const details = ctResponse === null || ctResponse === void 0 ? void 0 : (ref2 = ctResponse.data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.varientDetails) === null || ref3 === void 0 ? void 0 : ref3.filter((val)=>{
                    return (val === null || val === void 0 ? void 0 : val.sku) === currentSwatch;
                })[0];
                setLoaded(false);
                setInventory(productQuantity);
                setVariantList(allSwatch);
                setVariant(currentSwatch);
                setItem({
                    ...ctResponse,
                    currentVarent: {
                        ...allSwatch[0],
                        details
                    }
                });
                setLoading("success");
            }
        }
    };
    const incrementCounter = ()=>{
        setCounter(counter + 1);
    };
    const decrementCounter = ()=>{
        if (counter > 1) setCounter(counter - 1);
    };
    const handlerCounter = (val)=>{
        const count = Number(val);
        if (count && count >= 1) {
            setCounter(count);
        }
    };
    const handlerCart = (productInfo)=>{
        var ref;
        setLoaded(true);
        setIsAdding("adding");
        const data = [
            {
                sku: productInfo === null || productInfo === void 0 ? void 0 : (ref = productInfo.currentVarent) === null || ref === void 0 ? void 0 : ref.id,
                quantity: counter,
                isBundleProduct: false,
                isBundle: false,
                brand: "kohler"
            }
        ];
        (0,shareCartHelper/* shareaddToCart */.J9)(data, "", (res)=>{
            if (res) {
                updateCartFlag(counter);
                setLoaded(false);
                setIsAdding("done");
                setShowCart(false);
                partsAddToCartEvent(analytics, productInfo);
            }
        });
    };
    const getInventoryBySku = async (sku)=>{
        var ref;
        var ref1;
        const { data: { results: parentProductInventory = []  } = {}  } = (ref1 = await (0,api/* getProductInventory */.o)(sku)) !== null && ref1 !== void 0 ? ref1 : {};
        return parentProductInventory.length ? (ref = parentProductInventory[0]) === null || ref === void 0 ? void 0 : ref.availableQuantity : 0;
    };
    (0,react.useEffect)(()=>{
        const closeAddCart = (event)=>{
            if (cartRef.current && !cartRef.current.contains(event.target)) setShowCart(false);
        };
        document.addEventListener("mousedown", closeAddCart);
        return ()=>document.removeEventListener("mousedown", closeAddCart);
    }, [
        setShowCart
    ]);
    const checkNoswatchfullWidth = cartFlagFullWidth && variantList.length < 1;
    const checWithswatchfullWidth = cartFlagFullWidth && variantList.length > 1;
    const itemStock = (item === null || item === void 0 ? void 0 : (ref = item.currentVarent) === null || ref === void 0 ? void 0 : (ref1 = ref.details) === null || ref1 === void 0 ? void 0 : ref1.discontinued) === false && ((item === null || item === void 0 ? void 0 : (ref2 = item.currentVarent) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.details) === null || ref3 === void 0 ? void 0 : ref3.isStock) === "false" || inventory === 0);
    const itemDiscontinue = item === null || item === void 0 ? void 0 : (ref4 = item.currentVarent) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.details) === null || ref5 === void 0 ? void 0 : ref5.discontinued;
    const showStockMessage = itemStock && variantList.length <= 1;
    const swatchClass = "align-items-center w-100";
    const swatchesCls = checWithswatchfullWidth && !itemStock ? "w-50 align-items-start" : swatchClass;
    const fullscreenClass = checkNoswatchfullWidth || itemDiscontinue ? "w-100 align-items-start" : swatchesCls;
    const getButtonLabel = (isLoad)=>{
        if (isLoad && isAdding === "") {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* LoadingIcon */.Ho, {});
        }
        if (isLoad && isAdding === "adding") {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* LoadingIcon */.Ho, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "adding-label",
                        children: addingCartText
                    })
                ]
            });
        }
        if (!isLoad && isAdding === "done") {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* AddedIcon */.tW, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "adding-label",
                        children: addedCartText
                    })
                ]
            });
        } else {
            return addToCart;
        }
    };
    const updateCartFlag = (quantity)=>{
        const message = {
            quantity,
            status: true
        };
        setCartToast(message);
    };
    let overlaySection;
    if (!isSmallScreen) {
        overlaySection = isListExtend ? "position-overlay-fixed" : "position-overlay-absolute";
    }
    const buttonHandler = ()=>{
        if (!loaded) {
            handlerCart({
                ...item,
                fileTitle: title,
                quantity: counter,
                pdpDetails
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "add-cart-modal ".concat((AddCart_index_module_default()).CartModalViewer),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "soverlay ".concat(overlaySection)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: cartRef,
                className: "popup-cart-section ".concat(overlaySection, "  ").concat(!isDesktop && showCart ? "mobile-snack-overlay" : ""),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "popup-wrappers mobile-dropdown ".concat(loading === "loading" ? "loading-part" : "h-100"),
                    children: loading === "loading" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* AddToCartLoadingIcon */.Qb, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_Container, {
                        fluid: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex-column cart-content-dialogs",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-container",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "".concat(isListExtend ? "main-content" : ""),
                                    children: showStockMessage ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "button-carts notify-it",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NotifyMe, {
                                            item: item,
                                            fromCart: true,
                                            isListExtend: isListExtend,
                                            showStockMessage: showStockMessage
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AddCart_PriceLabel, {
                                                priceInfo: item,
                                                itemStock: itemStock
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "color-content",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "color-content-inner ".concat(checWithswatchfullWidth && !itemDiscontinue ? "d-flex" : ""),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "color-content-text  ".concat(fullscreenClass, "  "),
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                    className: "fs-16 fw-300 text-color",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            className: "fw-400 mr-5",
                                                                            children: colorFinish
                                                                        }),
                                                                        (item === null || item === void 0 ? void 0 : (ref6 = item.currentVarent) === null || ref6 === void 0 ? void 0 : ref6.label) || "N/A"
                                                                    ]
                                                                }),
                                                                variantList.length > 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(v2_SwatchItems, {
                                                                    variantList: variantList,
                                                                    setVariant: setVariant,
                                                                    variant: variant,
                                                                    isListExtend: cartFlagFullWidth
                                                                }) : null
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "d-flex justify-content-center flex-column ".concat(fullscreenClass, " ").concat(checWithswatchfullWidth ? "carts-fullwidth" : ""),
                                                            children: [
                                                                inventoryWarn ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "inventory-warning-section",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* WarnIcon */.e6, {}),
                                                                        " ",
                                                                        inventoryTextVal(inventory)
                                                                    ]
                                                                }) : null,
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "button-carts d-flex flex-row justify-content-center align-items-end mt-3",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "d-flex flex-column processing-div ".concat(loaded ? "processing" : ""),
                                                                        children: [
                                                                            !(item === null || item === void 0 ? void 0 : (ref7 = item.currentVarent) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.details) === null || ref8 === void 0 ? void 0 : ref8.discontinued) && loading === "success" && inventory ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                className: "addtocart-widgets d-flex",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                        className: "counter-widgets d-flex",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                                                className: "decrement-widgets",
                                                                                                onClick: decrementCounter,
                                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* DecIcon */.Nh, {})
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                                                type: "number",
                                                                                                onChange: (e)=>{
                                                                                                    var ref;
                                                                                                    return handlerCounter(e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : ref.value);
                                                                                                },
                                                                                                value: counter
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                                                className: "increment-widgets",
                                                                                                onClick: incrementCounter,
                                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* IncIcon */.M9, {})
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                                                        label: getButtonLabel(loaded),
                                                                                        onClick: buttonHandler,
                                                                                        disabled: loaded,
                                                                                        tag: "button",
                                                                                        className: "fs-18 fw-500 add-to-cart d-flex align-items-center justify-content-center ".concat(isAdding !== "" ? "disabled" : ""),
                                                                                        parentClass: "button-carts"
                                                                                    })
                                                                                ]
                                                                            }) : null,
                                                                            itemStock ? /*#__PURE__*/ (0,jsx_runtime.jsx)(NotifyMe, {
                                                                                showStockMessage: showStockMessage,
                                                                                item: item,
                                                                                fromCart: true,
                                                                                isListExtend: isListExtend,
                                                                                itemStock: itemStock
                                                                            }) : null
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                })
                            })
                        })
                    })
                })
            })
        ]
    });
};
AddCart.propTypes = {
    productId: (prop_types_default()).string.isRequired,
    setShowCart: (prop_types_default()).func.isRequired,
    showCart: (prop_types_default()).bool.isRequired,
    setCartToast: (prop_types_default()).func.isRequired,
    analytics: (prop_types_default()).object.isRequired,
    title: (prop_types_default()).string.isRequired,
    isListExtend: (prop_types_default()).bool.isRequired,
    partController: prop_types_default().shape({
        actions: prop_types_default().shape({
            get: prop_types_default().shape({
                entryByKey: (prop_types_default()).func.isRequired
            })
        })
    })
};
/* harmony default export */ var v2_AddCart = (AddCart);

;// CONCATENATED MODULE: ./components/PartsViewer/v2/GridAndListPanel/index.js











const GridAndListPanel = (props)=>{
    var ref, ref1;
    const { partsList , setIsListExtend , isListExtend , title , limit =6 , showPopup , partController , sku , showCart , setShowCart , showCartPopUp , productId , setCartToast , analytics  } = props;
    const [listView, setlistView] = (0,react.useState)(false);
    const [trigger, callTrigger] = hooks_useTrigger();
    const device = (0,useViewport/* default */.Z)();
    const loadCount = (partsList === null || partsList === void 0 ? void 0 : partsList.length) < limit ? partsList === null || partsList === void 0 ? void 0 : partsList.length : limit;
    const visibleCount = (ref = partController.actions.get.firstEntries()) === null || ref === void 0 ? void 0 : ref.length;
    const totalCount = partsList === null || partsList === void 0 ? void 0 : partsList.length;
    const [visibleData, setVisibleData] = (0,react.useState)(loadCount);
    (0,react.useEffect)(()=>callTrigger(), [
        title
    ]);
    (0,react.useEffect)(()=>{
        if (visibleCount < limit) partController.actions.fetchCTAny(loadCount);
    }, [
        trigger
    ]);
    const scrollToTop = ()=>{
        const ele = document.querySelector(".right-panel");
        if (ele) {
            ele.scrollIntoView({
                behaviour: "smooth"
            });
        }
    };
    const loadMoreitems = (e)=>{
        setVisibleData(visibleData + loadCount);
        partController.actions.fetchCTAny(visibleData);
    };
    const isDesktop = device.isLargeScreen || device.isExtraLargeScreen || device.isMediumScreen;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "product-list-viewer h-100",
        "data-testid": "right-panel-wrapper",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm_Container, {
                fluid: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_Row, {
                        className: "right-panel",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm_Col, {
                            className: "d-flex justify-content-between align-items-center",
                            children: [
                                isDesktop ? /*#__PURE__*/ (0,jsx_runtime.jsx)(GridAndListPanel_ToggleView, {
                                    listView,
                                    setlistView,
                                    device,
                                    title,
                                    sku
                                }) : null,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "d-flex align-items-center justify-content-center",
                                    children: isDesktop ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                        onClick: ()=>{
                                            setIsListExtend((state)=>!state);
                                        },
                                        "data-testid": "expand-button",
                                        className: "expand-button btn-expand border-0 d-flex align-items-center justify-content-center list-view-icons",
                                        children: [
                                            isListExtend ? /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* IconCollapse */.bt, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* IconExpandGrid */.wO, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "tool-tip-custom bottom",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: !isListExtend ? "Expand" : "Exit Expand"
                                                })
                                            })
                                        ]
                                    }) : null
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm_Row, {
                        className: "flex-column gird-content",
                        children: [
                            isDesktop ? /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_Col, {
                                className: "mt-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                    level: 3,
                                    fontSize: 26,
                                    className: "heading-grid",
                                    fontWeight: 300,
                                    children: title
                                })
                            }) : "",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_Col, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "d-flex flex-row align-items-center justify-content-between",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "total_item",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: "total-count fw-400 ".concat(isListExtend ? "full-screen-view" : "small-screen-view"),
                                                children: [
                                                    (partsList === null || partsList === void 0 ? void 0 : partsList.length) || 0,
                                                    " Results"
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(GridAndListPanel_SortDropdown, {
                                            partController,
                                            visibleData,
                                            title,
                                            sku,
                                            setlistView,
                                            listView,
                                            isListExtend
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm_Col, {
                                className: "d-flex align-items-center flex-column",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "list-items ".concat(listView ? "d-flex justify-content-between flex-column" : "thumbnail-items ".concat(device.isDesktop ? "full-screens" : "")),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(GridAndListPanel_ViewController, {
                                                partController,
                                                isListView: listView,
                                                isListExtend,
                                                showPopup,
                                                visibleData,
                                                title,
                                                sku,
                                                showCart,
                                                setShowCart,
                                                showCartPopUp
                                            }),
                                            (ref1 = Array.from({
                                                length: 6
                                            }, (val, index)=>index + 1)) === null || ref1 === void 0 ? void 0 : ref1.map((val)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "card empty-card"
                                                }, val))
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "load-more d-flex align-items-center flex-column w-100",
                                        children: visibleData < totalCount ? /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            onClick: loadMoreitems,
                                            className: "load-more-button fs-18 fw-400 w-100",
                                            children: "Load More"
                                        }) : null
                                    }),
                                    totalCount > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "back-to-top",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                onClick: ()=>scrollToTop(),
                                                className: "mx-2",
                                                children: "Back to Top"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* BackToTop */.zu, {})
                                        ]
                                    }) : null
                                ]
                            })
                        ]
                    })
                ]
            }),
            showCart ? /*#__PURE__*/ (0,jsx_runtime.jsx)(v2_AddCart, {
                productId: productId,
                showCart: showCart,
                setShowCart: setShowCart,
                partController: partController,
                analytics: analytics,
                isListExtend: isListExtend,
                setCartToast: setCartToast
            }) : null
        ]
    });
};
/* harmony default export */ var v2_GridAndListPanel = (GridAndListPanel);

;// CONCATENATED MODULE: ./components/PartsViewer/v2/SelectedFileView/DesktopView/index.js








const DesktopView = (props)=>{
    const { selectedFile , fullscreen , expandHandler , partsList , setIsListExtend , isListExtend , title , showPopup , popupModal , setModal , productId , partController , sku , loading , analytics , setWidthSize , widthSize , showCart , setShowCart , showCartPopUp , setCartToast  } = props;
    if (loading.error) return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorFallBack, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    right: popupModal && fullscreen ? widthSize : 0 + "px",
                    width: popupModal && fullscreen ? "auto" : ""
                },
                className: "".concat(isListExtend ? "" : "fullscreen-extend", " left"),
                children: !(loading === null || loading === void 0 ? void 0 : loading.status) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(v2_PartsDiagramViewer, {
                    expandHandler: expandHandler,
                    fullscreen: fullscreen,
                    showPopup: showPopup,
                    selectedFile: selectedFile,
                    partController: partController,
                    sku: sku,
                    title: title
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* LoaderSpinner */.cK, {})
            }),
            !(loading === null || loading === void 0 ? void 0 : loading.error) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat(isListExtend ? "fullscreen-extend" : "", " fullscreen-right h-100"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v2_GridAndListPanel, {
                    partsList: partsList,
                    setIsListExtend: setIsListExtend,
                    isListExtend: isListExtend,
                    title: title,
                    showPopup: showPopup,
                    partController: partController,
                    sku: sku,
                    showCart: showCart,
                    setShowCart: setShowCart,
                    showCartPopUp: showCartPopUp,
                    productId: productId,
                    analytics: analytics,
                    fullscreen: fullscreen,
                    setWidthSize: setWidthSize,
                    setCartToast: setCartToast
                })
            }) : "",
            popupModal ? /*#__PURE__*/ (0,jsx_runtime.jsx)(v2_DetailPopUp, {
                productId: productId,
                setModal: setModal,
                partController: partController,
                sku: sku,
                title: title,
                analytics: analytics,
                fullscreen: fullscreen,
                setWidthSize: setWidthSize
            }) : ""
        ]
    });
};
DesktopView.propTypes = {
    widthSize: (prop_types_default()).number.isRequired,
    setWidthSize: (prop_types_default()).func.isRequired
};
/* harmony default export */ var SelectedFileView_DesktopView = (DesktopView);

;// CONCATENATED MODULE: ./node_modules/@restart/ui/node_modules/uncontrollable/lib/esm/index.js
function esm_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function esm_toPropertyKey(arg) { var key = esm_toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function esm_toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }

function esm_defaultKey(key) {
  return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
}
function esm_useUncontrolledProp(propValue, defaultValue, handler) {
  const wasPropRef = (0,react.useRef)(propValue !== undefined);
  const [stateValue, setState] = (0,react.useState)(defaultValue);
  const isProp = propValue !== undefined;
  const wasProp = wasPropRef.current;
  wasPropRef.current = isProp;

  /**
   * If a prop switches from controlled to Uncontrolled
   * reset its value to the defaultValue
   */
  if (!isProp && wasProp && stateValue !== defaultValue) {
    setState(defaultValue);
  }
  return [isProp ? propValue : stateValue, (0,react.useCallback)((...args) => {
    const [value, ...rest] = args;
    let returnValue = handler == null ? void 0 : handler(value, ...rest);
    setState(value);
    return returnValue;
  }, [handler])];
}

function esm_useUncontrolled(props, config) {
  return Object.keys(config).reduce((result, fieldName) => {
    const _ref = result,
      _defaultKey = esm_defaultKey(fieldName),
      {
        [_defaultKey]: defaultValue,
        [fieldName]: propsValue
      } = _ref,
      rest = esm_objectWithoutPropertiesLoose(_ref, [_defaultKey, fieldName].map(esm_toPropertyKey));
    const handlerName = config[fieldName];
    const [value, handler] = esm_useUncontrolledProp(propsValue, defaultValue, props[handlerName]);
    return Object.assign({}, rest, {
      [fieldName]: value,
      [handlerName]: handler
    });
  }, props);
}
;// CONCATENATED MODULE: ./node_modules/@react-aria/ssr/dist/SSRProvider.mjs


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // We must avoid a circular dependency with @react-aria/utils, and this useLayoutEffect is
// guarded by a check that it only runs on the client side.
// eslint-disable-next-line rulesdir/useLayoutEffectRule

// Default context value to use in case there is no SSRProvider. This is fine for
// client-only apps. In order to support multiple copies of React Aria potentially
// being on the page at once, the prefix is set to a random number. SSRProvider
// will reset this to zero for consistency between server and client, so in the
// SSR case multiple copies of React Aria is not supported.
const $b5e257d569688ac6$var$defaultContext = {
    prefix: String(Math.round(Math.random() * 10000000000)),
    current: 0
};
const $b5e257d569688ac6$var$SSRContext = /*#__PURE__*/ (0, react).createContext($b5e257d569688ac6$var$defaultContext);
const $b5e257d569688ac6$var$IsSSRContext = /*#__PURE__*/ (0, react).createContext(false);
// This is only used in React < 18.
function $b5e257d569688ac6$var$LegacySSRProvider(props) {
    let cur = (0, $670gB$useContext)($b5e257d569688ac6$var$SSRContext);
    let counter = $b5e257d569688ac6$var$useCounter(cur === $b5e257d569688ac6$var$defaultContext);
    let [isSSR, setIsSSR] = (0, $670gB$useState)(true);
    let value = (0, $670gB$useMemo)(()=>({
            // If this is the first SSRProvider, start with an empty string prefix, otherwise
            // append and increment the counter.
            prefix: cur === $b5e257d569688ac6$var$defaultContext ? '' : `${cur.prefix}-${counter}`,
            current: 0
        }), [
        cur,
        counter
    ]);
    // If on the client, and the component was initially server rendered,
    // then schedule a layout effect to update the component after hydration.
    if (typeof document !== 'undefined') // This if statement technically breaks the rules of hooks, but is safe
    // because the condition never changes after mounting.
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $670gB$useLayoutEffect)(()=>{
        setIsSSR(false);
    }, []);
    return /*#__PURE__*/ (0, $670gB$react).createElement($b5e257d569688ac6$var$SSRContext.Provider, {
        value: value
    }, /*#__PURE__*/ (0, $670gB$react).createElement($b5e257d569688ac6$var$IsSSRContext.Provider, {
        value: isSSR
    }, props.children));
}
let $b5e257d569688ac6$var$warnedAboutSSRProvider = false;
function $b5e257d569688ac6$export$9f8ac96af4b1b2ae(props) {
    if (typeof (0, $670gB$react)['useId'] === 'function') {
        if (false) {}
        return /*#__PURE__*/ (0, $670gB$react).createElement((0, $670gB$react).Fragment, null, props.children);
    }
    return /*#__PURE__*/ (0, $670gB$react).createElement($b5e257d569688ac6$var$LegacySSRProvider, props);
}
let $b5e257d569688ac6$var$canUseDOM = Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
let $b5e257d569688ac6$var$componentIds = new WeakMap();
function $b5e257d569688ac6$var$useCounter(isDisabled = false) {
    let ctx = (0, react.useContext)($b5e257d569688ac6$var$SSRContext);
    let ref = (0, react.useRef)(null);
    // eslint-disable-next-line rulesdir/pure-render
    if (ref.current === null && !isDisabled) {
        var _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner, _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
        // In strict mode, React renders components twice, and the ref will be reset to null on the second render.
        // This means our id counter will be incremented twice instead of once. This is a problem because on the
        // server, components are only rendered once and so ids generated on the server won't match the client.
        // In React 18, useId was introduced to solve this, but it is not available in older versions. So to solve this
        // we need to use some React internals to access the underlying Fiber instance, which is stable between renders.
        // This is exposed as ReactCurrentOwner in development, which is all we need since StrictMode only runs in development.
        // To ensure that we only increment the global counter once, we store the starting id for this component in
        // a weak map associated with the Fiber. On the second render, we reset the global counter to this value.
        // Since React runs the second render immediately after the first, this is safe.
        // @ts-ignore
        let currentOwner = (_React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = (0, react).__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === null || _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED === void 0 ? void 0 : (_React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner = _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner) === null || _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner === void 0 ? void 0 : _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner.current;
        if (currentOwner) {
            let prevComponentValue = $b5e257d569688ac6$var$componentIds.get(currentOwner);
            if (prevComponentValue == null) // On the first render, and first call to useId, store the id and state in our weak map.
            $b5e257d569688ac6$var$componentIds.set(currentOwner, {
                id: ctx.current,
                state: currentOwner.memoizedState
            });
            else if (currentOwner.memoizedState !== prevComponentValue.state) {
                // On the second render, the memoizedState gets reset by React.
                // Reset the counter, and remove from the weak map so we don't
                // do this for subsequent useId calls.
                ctx.current = prevComponentValue.id;
                $b5e257d569688ac6$var$componentIds.delete(currentOwner);
            }
        }
        // eslint-disable-next-line rulesdir/pure-render
        ref.current = ++ctx.current;
    }
    // eslint-disable-next-line rulesdir/pure-render
    return ref.current;
}
function $b5e257d569688ac6$var$useLegacySSRSafeId(defaultId) {
    let ctx = (0, react.useContext)($b5e257d569688ac6$var$SSRContext);
    // If we are rendering in a non-DOM environment, and there's no SSRProvider,
    // provide a warning to hint to the developer to add one.
    if (ctx === $b5e257d569688ac6$var$defaultContext && !$b5e257d569688ac6$var$canUseDOM && "production" !== 'production') {}
    let counter = $b5e257d569688ac6$var$useCounter(!!defaultId);
    let prefix = ctx === $b5e257d569688ac6$var$defaultContext && "production" === 'test' ? 0 : `react-aria${ctx.prefix}`;
    return defaultId || `${prefix}-${counter}`;
}
function $b5e257d569688ac6$var$useModernSSRSafeId(defaultId) {
    let id = (0, react).useId();
    let [didSSR] = (0, react.useState)($b5e257d569688ac6$export$535bd6ca7f90a273());
    let prefix = didSSR || "production" === 'test' ? 'react-aria' : `react-aria${$b5e257d569688ac6$var$defaultContext.prefix}`;
    return defaultId || `${prefix}-${id}`;
}
const $b5e257d569688ac6$export$619500959fc48b26 = typeof (0, react)['useId'] === 'function' ? $b5e257d569688ac6$var$useModernSSRSafeId : $b5e257d569688ac6$var$useLegacySSRSafeId;
function $b5e257d569688ac6$var$getSnapshot() {
    return false;
}
function $b5e257d569688ac6$var$getServerSnapshot() {
    return true;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function $b5e257d569688ac6$var$subscribe(onStoreChange) {
    // noop
    return ()=>{};
}
function $b5e257d569688ac6$export$535bd6ca7f90a273() {
    // In React 18, we can use useSyncExternalStore to detect if we're server rendering or hydrating.
    if (typeof (0, react)['useSyncExternalStore'] === 'function') return (0, react)['useSyncExternalStore']($b5e257d569688ac6$var$subscribe, $b5e257d569688ac6$var$getSnapshot, $b5e257d569688ac6$var$getServerSnapshot);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, react.useContext)($b5e257d569688ac6$var$IsSSRContext);
}



//# sourceMappingURL=SSRProvider.module.js.map

;// CONCATENATED MODULE: ./node_modules/@restart/ui/esm/TabContext.js

const TabContext = /*#__PURE__*/react.createContext(null);
/* harmony default export */ var esm_TabContext = (TabContext);
;// CONCATENATED MODULE: ./node_modules/@restart/ui/esm/SelectableContext.js

const SelectableContext = /*#__PURE__*/react.createContext(null);
const makeEventKey = (eventKey, href = null) => {
  if (eventKey != null) return String(eventKey);
  return href || null;
};
/* harmony default export */ var esm_SelectableContext = (SelectableContext);
;// CONCATENATED MODULE: ./node_modules/@restart/ui/esm/TabPanel.js
const TabPanel_excluded = ["active", "eventKey", "mountOnEnter", "transition", "unmountOnExit", "role", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited"],
  _excluded2 = ["activeKey", "getControlledId", "getControllerId"],
  _excluded3 = ["as"];
function TabPanel_objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }






function useTabPanel(_ref) {
  let {
      active,
      eventKey,
      mountOnEnter,
      transition,
      unmountOnExit,
      role = 'tabpanel',
      onEnter,
      onEntering,
      onEntered,
      onExit,
      onExiting,
      onExited
    } = _ref,
    props = TabPanel_objectWithoutPropertiesLoose(_ref, TabPanel_excluded);
  const context = (0,react.useContext)(esm_TabContext);
  if (!context) return [Object.assign({}, props, {
    role
  }), {
    eventKey,
    isActive: active,
    mountOnEnter,
    transition,
    unmountOnExit,
    onEnter,
    onEntering,
    onEntered,
    onExit,
    onExiting,
    onExited
  }];
  const {
      activeKey,
      getControlledId,
      getControllerId
    } = context,
    rest = TabPanel_objectWithoutPropertiesLoose(context, _excluded2);
  const key = makeEventKey(eventKey);
  return [Object.assign({}, props, {
    role,
    id: getControlledId(eventKey),
    'aria-labelledby': getControllerId(eventKey)
  }), {
    eventKey,
    isActive: active == null && key != null ? makeEventKey(activeKey) === key : active,
    transition: transition || rest.transition,
    mountOnEnter: mountOnEnter != null ? mountOnEnter : rest.mountOnEnter,
    unmountOnExit: unmountOnExit != null ? unmountOnExit : rest.unmountOnExit,
    onEnter,
    onEntering,
    onEntered,
    onExit,
    onExiting,
    onExited
  }];
}
const TabPanel = /*#__PURE__*/react.forwardRef(
// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
(_ref2, ref) => {
  let {
      as: Component = 'div'
    } = _ref2,
    props = TabPanel_objectWithoutPropertiesLoose(_ref2, _excluded3);
  const [tabPanelProps, {
    isActive,
    onEnter,
    onEntering,
    onEntered,
    onExit,
    onExiting,
    onExited,
    mountOnEnter,
    unmountOnExit,
    transition: Transition = esm_NoopTransition
  }] = useTabPanel(props);
  // We provide an empty the TabContext so `<Nav>`s in `<TabPanel>`s don't
  // conflict with the top level one.
  return /*#__PURE__*/(0,jsx_runtime.jsx)(esm_TabContext.Provider, {
    value: null,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(esm_SelectableContext.Provider, {
      value: null,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Transition, {
        in: isActive,
        onEnter: onEnter,
        onEntering: onEntering,
        onEntered: onEntered,
        onExit: onExit,
        onExiting: onExiting,
        onExited: onExited,
        mountOnEnter: mountOnEnter,
        unmountOnExit: unmountOnExit,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Component, Object.assign({}, tabPanelProps, {
          ref: ref,
          hidden: !isActive,
          "aria-hidden": !isActive
        }))
      })
    })
  });
});
TabPanel.displayName = 'TabPanel';
/* harmony default export */ var esm_TabPanel = (TabPanel);
;// CONCATENATED MODULE: ./node_modules/@restart/ui/esm/Tabs.js








const Tabs = props => {
  const {
    id: userId,
    generateChildId: generateCustomChildId,
    onSelect: propsOnSelect,
    activeKey: propsActiveKey,
    defaultActiveKey,
    transition,
    mountOnEnter,
    unmountOnExit,
    children
  } = props;
  const [activeKey, onSelect] = esm_useUncontrolledProp(propsActiveKey, defaultActiveKey, propsOnSelect);
  const id = $b5e257d569688ac6$export$619500959fc48b26(userId);
  const generateChildId = (0,react.useMemo)(() => generateCustomChildId || ((key, type) => id ? `${id}-${type}-${key}` : null), [id, generateCustomChildId]);
  const tabContext = (0,react.useMemo)(() => ({
    onSelect,
    activeKey,
    transition,
    mountOnEnter: mountOnEnter || false,
    unmountOnExit: unmountOnExit || false,
    getControlledId: key => generateChildId(key, 'tabpane'),
    getControllerId: key => generateChildId(key, 'tab')
  }), [onSelect, activeKey, transition, mountOnEnter, unmountOnExit, generateChildId]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(esm_TabContext.Provider, {
    value: tabContext,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(esm_SelectableContext.Provider, {
      value: onSelect || null,
      children: children
    })
  });
};
Tabs.Panel = esm_TabPanel;
/* harmony default export */ var esm_Tabs = (Tabs);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/getTabTransitionComponent.js


function getTabTransitionComponent(transition) {
  if (typeof transition === 'boolean') {
    return transition ? esm_Fade : esm_NoopTransition;
  }
  return transition;
}
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/TabContainer.js



const TabContainer = ({
  transition,
  ...props
}) => /*#__PURE__*/(0,jsx_runtime.jsx)(esm_Tabs, {
  ...props,
  transition: getTabTransitionComponent(transition)
});
TabContainer.displayName = 'TabContainer';
/* harmony default export */ var esm_TabContainer = (TabContainer);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/TabContent.js
"use client";





const TabContent = /*#__PURE__*/react.forwardRef(({
  className,
  bsPrefix,
  as: Component = 'div',
  ...props
}, ref) => {
  bsPrefix = useBootstrapPrefix(bsPrefix, 'tab-content');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    ref: ref,
    className: classnames_default()(className, bsPrefix),
    ...props
  });
});
TabContent.displayName = 'TabContent';
/* harmony default export */ var esm_TabContent = (TabContent);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/TabPane.js
"use client";










const TabPane = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  transition,
  ...props
}, ref) => {
  const [{
    className,
    // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'div',
    ...rest
  }, {
    isActive,
    onEnter,
    onEntering,
    onEntered,
    onExit,
    onExiting,
    onExited,
    mountOnEnter,
    unmountOnExit,
    transition: Transition = esm_Fade
  }] = useTabPanel({
    ...props,
    transition: getTabTransitionComponent(transition)
  });
  const prefix = useBootstrapPrefix(bsPrefix, 'tab-pane');

  // We provide an empty the TabContext so `<Nav>`s in `<TabPanel>`s don't
  // conflict with the top level one.
  return /*#__PURE__*/(0,jsx_runtime.jsx)(esm_TabContext.Provider, {
    value: null,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(esm_SelectableContext.Provider, {
      value: null,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Transition, {
        in: isActive,
        onEnter: onEnter,
        onEntering: onEntering,
        onEntered: onEntered,
        onExit: onExit,
        onExiting: onExiting,
        onExited: onExited,
        mountOnEnter: mountOnEnter,
        unmountOnExit: unmountOnExit,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
          ...rest,
          ref: ref,
          className: classnames_default()(className, prefix, isActive && 'active')
        })
      })
    })
  });
});
TabPane.displayName = 'TabPane';
/* harmony default export */ var esm_TabPane = (TabPane);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/Tab.js




const Tab_propTypes = {
  eventKey: prop_types_default().oneOfType([(prop_types_default()).string, (prop_types_default()).number]),
  /**
   * Content for the tab title.
   */
  title: (prop_types_default()).node.isRequired,
  /**
   * The disabled state of the tab.
   */
  disabled: (prop_types_default()).bool,
  /**
   * Class to pass to the underlying nav link.
   */
  tabClassName: (prop_types_default()).string,
  /**
   * Object containing attributes to pass to underlying nav link.
   */
  tabAttrs: (prop_types_default()).object
};
const Tab = () => {
  throw new Error('ReactBootstrap: The `Tab` component is not meant to be rendered! ' + "It's an abstract component that is only valid as a direct Child of the `Tabs` Component. " + 'For custom tabs components use TabPane and TabsContainer directly');
};
Tab.propTypes = Tab_propTypes;
/* harmony default export */ var esm_Tab = (Object.assign(Tab, {
  Container: esm_TabContainer,
  Content: esm_TabContent,
  Pane: esm_TabPane
}));
;// CONCATENATED MODULE: ./node_modules/@restart/ui/node_modules/@restart/hooks/esm/useForceUpdate.js


/**
 * Returns a function that triggers a component update. the hook equivalent to
 * `this.forceUpdate()` in a class component. In most cases using a state value directly
 * is preferable but may be required in some advanced usages of refs for interop or
 * when direct DOM manipulation is required.
 *
 * ```ts
 * const forceUpdate = useForceUpdate();
 *
 * const updateOnClick = useCallback(() => {
 *  forceUpdate()
 * }, [forceUpdate])
 *
 * return <button type="button" onClick={updateOnClick}>Hi there</button>
 * ```
 */
function useForceUpdate() {
  // The toggling state value is designed to defeat React optimizations for skipping
  // updates when they are strictly equal to the last state value
  const [, dispatch] = (0,react.useReducer)(revision => revision + 1, 0);
  return dispatch;
}
;// CONCATENATED MODULE: ./node_modules/@restart/ui/esm/NavContext.js

const NavContext = /*#__PURE__*/react.createContext(null);
NavContext.displayName = 'NavContext';
/* harmony default export */ var esm_NavContext = (NavContext);
;// CONCATENATED MODULE: ./node_modules/@restart/ui/esm/Button.js
const Button_excluded = ["as", "disabled"];
function Button_objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }


function isTrivialHref(href) {
  return !href || href.trim() === '#';
}
function useButtonProps({
  tagName,
  disabled,
  href,
  target,
  rel,
  role,
  onClick,
  tabIndex = 0,
  type
}) {
  if (!tagName) {
    if (href != null || target != null || rel != null) {
      tagName = 'a';
    } else {
      tagName = 'button';
    }
  }
  const meta = {
    tagName
  };
  if (tagName === 'button') {
    return [{
      type: type || 'button',
      disabled
    }, meta];
  }
  const handleClick = event => {
    if (disabled || tagName === 'a' && isTrivialHref(href)) {
      event.preventDefault();
    }
    if (disabled) {
      event.stopPropagation();
      return;
    }
    onClick == null ? void 0 : onClick(event);
  };
  const handleKeyDown = event => {
    if (event.key === ' ') {
      event.preventDefault();
      handleClick(event);
    }
  };
  if (tagName === 'a') {
    // Ensure there's a href so Enter can trigger anchor button.
    href || (href = '#');
    if (disabled) {
      href = undefined;
    }
  }
  return [{
    role: role != null ? role : 'button',
    // explicitly undefined so that it overrides the props disabled in a spread
    // e.g. <Tag {...props} {...hookProps} />
    disabled: undefined,
    tabIndex: disabled ? undefined : tabIndex,
    href,
    target: tagName === 'a' ? target : undefined,
    'aria-disabled': !disabled ? undefined : disabled,
    rel: tagName === 'a' ? rel : undefined,
    onClick: handleClick,
    onKeyDown: handleKeyDown
  }, meta];
}
const Button_Button = /*#__PURE__*/react.forwardRef((_ref, ref) => {
  let {
      as: asProp,
      disabled
    } = _ref,
    props = Button_objectWithoutPropertiesLoose(_ref, Button_excluded);
  const [buttonProps, {
    tagName: Component
  }] = useButtonProps(Object.assign({
    tagName: asProp,
    disabled
  }, props));
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, Object.assign({}, props, buttonProps, {
    ref: ref
  }));
});
Button_Button.displayName = 'Button';
/* harmony default export */ var esm_Button = (Button_Button);
;// CONCATENATED MODULE: ./node_modules/@restart/ui/esm/NavItem.js
const NavItem_excluded = ["as", "active", "eventKey"];
function NavItem_objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }









function useNavItem({
  key,
  onClick,
  active,
  id,
  role,
  disabled
}) {
  const parentOnSelect = (0,react.useContext)(esm_SelectableContext);
  const navContext = (0,react.useContext)(esm_NavContext);
  const tabContext = (0,react.useContext)(esm_TabContext);
  let isActive = active;
  const props = {
    role
  };
  if (navContext) {
    if (!role && navContext.role === 'tablist') props.role = 'tab';
    const contextControllerId = navContext.getControllerId(key != null ? key : null);
    const contextControlledId = navContext.getControlledId(key != null ? key : null);

    // @ts-ignore
    props[dataAttr('event-key')] = key;
    props.id = contextControllerId || id;
    isActive = active == null && key != null ? navContext.activeKey === key : active;

    /**
     * Simplified scenario for `mountOnEnter`.
     *
     * While it would make sense to keep 'aria-controls' for tabs that have been mounted at least
     * once, it would also complicate the code quite a bit, for very little gain.
     * The following implementation is probably good enough.
     *
     * @see https://github.com/react-restart/ui/pull/40#issuecomment-1009971561
     */
    if (isActive || !(tabContext != null && tabContext.unmountOnExit) && !(tabContext != null && tabContext.mountOnEnter)) props['aria-controls'] = contextControlledId;
  }
  if (props.role === 'tab') {
    props['aria-selected'] = isActive;
    if (!isActive) {
      props.tabIndex = -1;
    }
    if (disabled) {
      props.tabIndex = -1;
      props['aria-disabled'] = true;
    }
  }
  props.onClick = esm_useEventCallback_useEventCallback(e => {
    if (disabled) return;
    onClick == null ? void 0 : onClick(e);
    if (key == null) {
      return;
    }
    if (parentOnSelect && !e.isPropagationStopped()) {
      parentOnSelect(key, e);
    }
  });
  return [props, {
    isActive
  }];
}
const NavItem = /*#__PURE__*/react.forwardRef((_ref, ref) => {
  let {
      as: Component = esm_Button,
      active,
      eventKey
    } = _ref,
    options = NavItem_objectWithoutPropertiesLoose(_ref, NavItem_excluded);
  const [props, meta] = useNavItem(Object.assign({
    key: makeEventKey(eventKey, options.href),
    active
  }, options));

  // @ts-ignore
  props[dataAttr('active')] = meta.isActive;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, Object.assign({}, options, props, {
    ref: ref
  }));
});
NavItem.displayName = 'NavItem';
/* harmony default export */ var esm_NavItem = (NavItem);
;// CONCATENATED MODULE: ./node_modules/@restart/ui/esm/Nav.js
const Nav_excluded = ["as", "onSelect", "activeKey", "role", "onKeyDown"];
function Nav_objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }











// eslint-disable-next-line @typescript-eslint/no-empty-function
const Nav_noop = () => {};
const EVENT_KEY_ATTR = dataAttr('event-key');
const Nav = /*#__PURE__*/react.forwardRef((_ref, ref) => {
  let {
      // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
      as: Component = 'div',
      onSelect,
      activeKey,
      role,
      onKeyDown
    } = _ref,
    props = Nav_objectWithoutPropertiesLoose(_ref, Nav_excluded);
  // A ref and forceUpdate for refocus, b/c we only want to trigger when needed
  // and don't want to reset the set in the effect
  const forceUpdate = useForceUpdate();
  const needsRefocusRef = (0,react.useRef)(false);
  const parentOnSelect = (0,react.useContext)(esm_SelectableContext);
  const tabContext = (0,react.useContext)(esm_TabContext);
  let getControlledId, getControllerId;
  if (tabContext) {
    role = role || 'tablist';
    activeKey = tabContext.activeKey;
    // TODO: do we need to duplicate these?
    getControlledId = tabContext.getControlledId;
    getControllerId = tabContext.getControllerId;
  }
  const listNode = (0,react.useRef)(null);
  const getNextActiveTab = offset => {
    const currentListNode = listNode.current;
    if (!currentListNode) return null;
    const items = qsa(currentListNode, `[${EVENT_KEY_ATTR}]:not([aria-disabled=true])`);
    const activeChild = currentListNode.querySelector('[aria-selected=true]');
    if (!activeChild || activeChild !== document.activeElement) return null;
    const index = items.indexOf(activeChild);
    if (index === -1) return null;
    let nextIndex = index + offset;
    if (nextIndex >= items.length) nextIndex = 0;
    if (nextIndex < 0) nextIndex = items.length - 1;
    return items[nextIndex];
  };
  const handleSelect = (key, event) => {
    if (key == null) return;
    onSelect == null ? void 0 : onSelect(key, event);
    parentOnSelect == null ? void 0 : parentOnSelect(key, event);
  };
  const handleKeyDown = event => {
    onKeyDown == null ? void 0 : onKeyDown(event);
    if (!tabContext) {
      return;
    }
    let nextActiveChild;
    switch (event.key) {
      case 'ArrowLeft':
      case 'ArrowUp':
        nextActiveChild = getNextActiveTab(-1);
        break;
      case 'ArrowRight':
      case 'ArrowDown':
        nextActiveChild = getNextActiveTab(1);
        break;
      default:
        return;
    }
    if (!nextActiveChild) return;
    event.preventDefault();
    handleSelect(nextActiveChild.dataset[dataProp('EventKey')] || null, event);
    needsRefocusRef.current = true;
    forceUpdate();
  };
  (0,react.useEffect)(() => {
    if (listNode.current && needsRefocusRef.current) {
      const activeChild = listNode.current.querySelector(`[${EVENT_KEY_ATTR}][aria-selected=true]`);
      activeChild == null ? void 0 : activeChild.focus();
    }
    needsRefocusRef.current = false;
  });
  const mergedRef = hooks_esm_useMergedRefs(ref, listNode);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(esm_SelectableContext.Provider, {
    value: handleSelect,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(esm_NavContext.Provider, {
      value: {
        role,
        // used by NavLink to determine it's role
        activeKey: makeEventKey(activeKey),
        getControlledId: getControlledId || Nav_noop,
        getControllerId: getControllerId || Nav_noop
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Component, Object.assign({}, props, {
        onKeyDown: handleKeyDown,
        ref: mergedRef,
        role: role
      }))
    })
  });
});
Nav.displayName = 'Nav';
/* harmony default export */ var esm_Nav = (Object.assign(Nav, {
  Item: esm_NavItem
}));
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/NavbarContext.js
"use client";



// TODO: check

const context = /*#__PURE__*/react.createContext(null);
context.displayName = 'NavbarContext';
/* harmony default export */ var NavbarContext = (context);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/CardHeaderContext.js
"use client";


const CardHeaderContext_context = /*#__PURE__*/react.createContext(null);
CardHeaderContext_context.displayName = 'CardHeaderContext';
/* harmony default export */ var CardHeaderContext = (CardHeaderContext_context);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/NavItem.js
"use client";





const NavItem_NavItem = /*#__PURE__*/react.forwardRef(({
  className,
  bsPrefix,
  as: Component = 'div',
  ...props
}, ref) => {
  bsPrefix = useBootstrapPrefix(bsPrefix, 'nav-item');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    ref: ref,
    className: classnames_default()(className, bsPrefix),
    ...props
  });
});
NavItem_NavItem.displayName = 'NavItem';
/* harmony default export */ var react_bootstrap_esm_NavItem = (NavItem_NavItem);
;// CONCATENATED MODULE: ./node_modules/@restart/ui/node_modules/@restart/hooks/esm/useEventListener.js


/**
 * Attaches an event handler outside directly to specified DOM element
 * bypassing the react synthetic event system.
 *
 * @param element The target to listen for events on
 * @param event The DOM event name
 * @param handler An event handler
 * @param capture Whether or not to listen during the capture event phase
 */
function useEventListener_useEventListener(eventTarget, event, listener, capture = false) {
  const handler = useEventCallback(listener);
  useEffect(() => {
    const target = typeof eventTarget === 'function' ? eventTarget() : eventTarget;
    target.addEventListener(event, handler, capture);
    return () => target.removeEventListener(event, handler, capture);
  }, [eventTarget]);
}
;// CONCATENATED MODULE: ./node_modules/@restart/ui/node_modules/@restart/hooks/esm/useGlobalListener.js


/**
 * Attaches an event handler outside directly to the `document`,
 * bypassing the react synthetic event system.
 *
 * ```ts
 * useGlobalListener('keydown', (event) => {
 *  console.log(event.key)
 * })
 * ```
 *
 * @param event The DOM event name
 * @param handler An event handler
 * @param capture Whether or not to listen during the capture event phase
 */
function useGlobalListener(event, handler, capture = false) {
  const documentTarget = useCallback(() => document, []);
  return useEventListener(documentTarget, event, handler, capture);
}
;// CONCATENATED MODULE: ./node_modules/@restart/ui/node_modules/@restart/hooks/esm/useInterval.js



/**
 * Creates a `setInterval` that is properly cleaned up when a component unmounted
 *
 * ```tsx
 *  function Timer() {
 *    const [timer, setTimer] = useState(0)
 *    useInterval(() => setTimer(i => i + 1), 1000)
 *
 *    return <span>{timer} seconds past</span>
 *  }
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 */

/**
 * Creates a pausable `setInterval` that is properly cleaned up when a component unmounted
 *
 * ```tsx
 *  const [paused, setPaused] = useState(false)
 *  const [timer, setTimer] = useState(0)
 *
 *  useInterval(() => setTimer(i => i + 1), 1000, paused)
 *
 *  return (
 *    <span>
 *      {timer} seconds past
 *
 *      <button onClick={() => setPaused(p => !p)}>{paused ? 'Play' : 'Pause' }</button>
 *    </span>
 * )
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 * @param paused Whether or not the interval is currently running
 */

/**
 * Creates a pausable `setInterval` that _fires_ immediately and is
 * properly cleaned up when a component unmounted
 *
 * ```tsx
 *  const [timer, setTimer] = useState(-1)
 *  useInterval(() => setTimer(i => i + 1), 1000, false, true)
 *
 *  // will update to 0 on the first effect
 *  return <span>{timer} seconds past</span>
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 * @param paused Whether or not the interval is currently running
 * @param runImmediately Whether to run the function immediately on mount or unpause
 * rather than waiting for the first interval to elapse
 *

 */

function useInterval(fn, ms, paused = false, runImmediately = false) {
  let handle;
  const fnRef = useCommittedRef(fn);
  // this ref is necessary b/c useEffect will sometimes miss a paused toggle
  // orphaning a setTimeout chain in the aether, so relying on it's refresh logic is not reliable.
  const pausedRef = useCommittedRef(paused);
  const tick = () => {
    if (pausedRef.current) return;
    fnRef.current();
    schedule(); // eslint-disable-line no-use-before-define
  };

  const schedule = () => {
    clearTimeout(handle);
    handle = setTimeout(tick, ms);
  };
  useEffect(() => {
    if (runImmediately) {
      tick();
    } else {
      schedule();
    }
    return () => clearTimeout(handle);
  }, [paused, runImmediately]);
}
/* harmony default export */ var esm_useInterval = ((/* unused pure expression or super */ null && (useInterval)));
;// CONCATENATED MODULE: ./node_modules/@restart/ui/node_modules/@restart/hooks/esm/useRafInterval.js


function useRafInterval(fn, ms, paused = false) {
  let handle;
  let start = new Date().getTime();
  const fnRef = useCommittedRef(fn);
  // this ref is necessary b/c useEffect will sometimes miss a paused toggle
  // orphaning a setTimeout chain in the aether, so relying on it's refresh logic is not reliable.
  const pausedRef = useCommittedRef(paused);
  function loop() {
    const current = new Date().getTime();
    const delta = current - start;
    if (pausedRef.current) return;
    if (delta >= ms && fnRef.current) {
      fnRef.current();
      start = new Date().getTime();
    }
    cancelAnimationFrame(handle);
    handle = requestAnimationFrame(loop);
  }
  useEffect(() => {
    handle = requestAnimationFrame(loop);
    return () => cancelAnimationFrame(handle);
  }, []);
}
/* harmony default export */ var esm_useRafInterval = ((/* unused pure expression or super */ null && (useRafInterval)));
;// CONCATENATED MODULE: ./node_modules/@restart/ui/node_modules/@restart/hooks/esm/useMergeState.js


/**
 * Updates state, partial updates are merged into existing state values
 */

/**
 * Mimics a React class component's state model, of having a single unified
 * `state` object and an updater that merges updates into the existing state, as
 * opposed to replacing it.
 *
 * ```js
 * const [state, setState] = useMergeState({ name: 'Betsy', age: 24 })
 *
 * setState({ name: 'Johan' }) // { name: 'Johan', age: 24 }
 *
 * setState(state => ({ age: state.age + 10 })) // { name: 'Johan', age: 34 }
 * ```
 *
 * @param initialState The initial state object
 */
function useMergeState_useMergeState(initialState) {
  const [state, setState] = useState(initialState);
  const updater = useCallback(update => {
    if (update === null) return;
    if (typeof update === 'function') {
      setState(state => {
        const nextState = update(state);
        return nextState == null ? state : Object.assign({}, state, nextState);
      });
    } else {
      setState(state => Object.assign({}, state, update));
    }
  }, [setState]);
  return [state, updater];
}
;// CONCATENATED MODULE: ./node_modules/@restart/ui/node_modules/@restart/hooks/esm/useMergeStateFromProps.js

function useMergeStateFromProps(props, gDSFP, initialState) {
  const [state, setState] = useMergeState(initialState);
  const nextState = gDSFP(props, state);
  if (nextState !== null) setState(nextState);
  return [state, setState];
}
;// CONCATENATED MODULE: ./node_modules/@restart/ui/node_modules/@restart/hooks/esm/useImage.js

/**
 * Fetch and load an image for programatic use such as in a `<canvas>` element.
 *
 * @param imageOrUrl The `HtmlImageElement` or image url to load
 * @param crossOrigin The `crossorigin` attribute to set
 *
 * ```ts
 * const { image, error } = useImage('/static/kittens.png')
 * const ref = useRef<HTMLCanvasElement>()
 *
 * useEffect(() => {
 *   const ctx = ref.current.getContext('2d')
 *
 *   if (image) {
 *     ctx.drawImage(image, 0, 0)
 *   }
 * }, [ref, image])
 *
 * return (
 *   <>
 *     {error && "there was a problem loading the image"}
 *     <canvas ref={ref} />
 *   </>
 * ```
 */
function useImage(imageOrUrl, crossOrigin) {
  const [state, setState] = useState({
    image: null,
    error: null
  });
  useEffect(() => {
    if (!imageOrUrl) return undefined;
    let image;
    if (typeof imageOrUrl === 'string') {
      image = new Image();
      if (crossOrigin) image.crossOrigin = crossOrigin;
      image.src = imageOrUrl;
    } else {
      image = imageOrUrl;
      if (image.complete && image.naturalHeight > 0) {
        setState({
          image,
          error: null
        });
        return;
      }
    }
    function onLoad() {
      setState({
        image,
        error: null
      });
    }
    function onError(error) {
      setState({
        image,
        error
      });
    }
    image.addEventListener('load', onLoad);
    image.addEventListener('error', onError);
    return () => {
      image.removeEventListener('load', onLoad);
      image.removeEventListener('error', onError);
    };
  }, [imageOrUrl, crossOrigin]);
  return state;
}
;// CONCATENATED MODULE: ./node_modules/@restart/ui/node_modules/@restart/hooks/esm/useResizeObserver.js


const targetMap = new WeakMap();
let resizeObserver;
function getResizeObserver() {
  // eslint-disable-next-line no-return-assign
  return resizeObserver = resizeObserver || new window.ResizeObserver(entries => {
    entries.forEach(entry => {
      const handler = targetMap.get(entry.target);
      if (handler) handler(entry.contentRect);
    });
  });
}

/**
 * Efficiently observe size changes on an element. Depends on the `ResizeObserver` api,
 * and polyfills are needed in older browsers.
 *
 * ```ts
 * const [ref, attachRef] = useCallbackRef(null);
 *
 * const rect = useResizeObserver(ref);
 *
 * return (
 *  <div ref={attachRef}>
 *    {JSON.stringify(rect)}
 *  </div>
 * )
 * ```
 *
 * @param element The DOM element to observe
 */
function useResizeObserver(element) {
  const [rect, setRect] = useState(null);
  useEffect(() => {
    if (!element) return;
    getResizeObserver().observe(element);
    setRect(element.getBoundingClientRect());
    targetMap.set(element, rect => {
      setRect(rect);
    });
    return () => {
      targetMap.delete(element);
    };
  }, [element]);
  return rect;
}
;// CONCATENATED MODULE: ./node_modules/@restart/ui/node_modules/@restart/hooks/esm/index.js














;// CONCATENATED MODULE: ./node_modules/@restart/ui/esm/Anchor.js
const Anchor_excluded = ["onKeyDown"];
function Anchor_objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/anchor-has-content */





function Anchor_isTrivialHref(href) {
  return !href || href.trim() === '#';
}
/**
 * An generic `<a>` component that covers a few A11y cases, ensuring that
 * cases where the `href` is missing or trivial like "#" are treated like buttons.
 */
const Anchor = /*#__PURE__*/react.forwardRef((_ref, ref) => {
  let {
      onKeyDown
    } = _ref,
    props = Anchor_objectWithoutPropertiesLoose(_ref, Anchor_excluded);
  const [buttonProps] = useButtonProps(Object.assign({
    tagName: 'a'
  }, props));
  const handleKeyDown = esm_useEventCallback_useEventCallback(e => {
    buttonProps.onKeyDown(e);
    onKeyDown == null ? void 0 : onKeyDown(e);
  });
  if (Anchor_isTrivialHref(props.href) || props.role === 'button') {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("a", Object.assign({
      ref: ref
    }, props, buttonProps, {
      onKeyDown: handleKeyDown
    }));
  }
  return /*#__PURE__*/(0,jsx_runtime.jsx)("a", Object.assign({
    ref: ref
  }, props, {
    onKeyDown: onKeyDown
  }));
});
Anchor.displayName = 'Anchor';
/* harmony default export */ var esm_Anchor = (Anchor);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/NavLink.js
"use client";








const NavLink = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  className,
  as: Component = esm_Anchor,
  active,
  eventKey,
  disabled = false,
  ...props
}, ref) => {
  bsPrefix = useBootstrapPrefix(bsPrefix, 'nav-link');
  const [navItemProps, meta] = useNavItem({
    key: makeEventKey(eventKey, props.href),
    active,
    disabled,
    ...props
  });
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    ...props,
    ...navItemProps,
    ref: ref,
    disabled: disabled,
    className: classnames_default()(className, bsPrefix, disabled && 'disabled', meta.isActive && 'active')
  });
});
NavLink.displayName = 'NavLink';
/* harmony default export */ var esm_NavLink = (NavLink);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/Nav.js
"use client";












const Nav_Nav = /*#__PURE__*/react.forwardRef((uncontrolledProps, ref) => {
  const {
    as = 'div',
    bsPrefix: initialBsPrefix,
    variant,
    fill = false,
    justify = false,
    navbar,
    navbarScroll,
    className,
    activeKey,
    ...props
  } = useUncontrolled(uncontrolledProps, {
    activeKey: 'onSelect'
  });
  const bsPrefix = useBootstrapPrefix(initialBsPrefix, 'nav');
  let navbarBsPrefix;
  let cardHeaderBsPrefix;
  let isNavbar = false;
  const navbarContext = (0,react.useContext)(NavbarContext);
  const cardHeaderContext = (0,react.useContext)(CardHeaderContext);
  if (navbarContext) {
    navbarBsPrefix = navbarContext.bsPrefix;
    isNavbar = navbar == null ? true : navbar;
  } else if (cardHeaderContext) {
    ({
      cardHeaderBsPrefix
    } = cardHeaderContext);
  }
  return /*#__PURE__*/(0,jsx_runtime.jsx)(esm_Nav, {
    as: as,
    ref: ref,
    activeKey: activeKey,
    className: classnames_default()(className, {
      [bsPrefix]: !isNavbar,
      [`${navbarBsPrefix}-nav`]: isNavbar,
      [`${navbarBsPrefix}-nav-scroll`]: isNavbar && navbarScroll,
      [`${cardHeaderBsPrefix}-${variant}`]: !!cardHeaderBsPrefix,
      [`${bsPrefix}-${variant}`]: !!variant,
      [`${bsPrefix}-fill`]: fill,
      [`${bsPrefix}-justified`]: justify
    }),
    ...props
  });
});
Nav_Nav.displayName = 'Nav';
/* harmony default export */ var react_bootstrap_esm_Nav = (Object.assign(Nav_Nav, {
  Item: react_bootstrap_esm_NavItem,
  Link: esm_NavLink
}));
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/ElementChildren.js


/**
 * Iterates through children that are typically specified as `props.children`,
 * but only maps over children that are "valid elements".
 *
 * The mapFunction provided index will be normalised to the components mapped,
 * so an invalid component would not increase the index.
 *
 */
function map(children, func) {
  let index = 0;
  return react.Children.map(children, child => /*#__PURE__*/react.isValidElement(child) ? func(child, index++) : child);
}

/**
 * Iterates through children that are "valid elements".
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child with the index reflecting the position relative to "valid components".
 */
function forEach(children, func) {
  let index = 0;
  react.Children.forEach(children, child => {
    if ( /*#__PURE__*/react.isValidElement(child)) func(child, index++);
  });
}

/**
 * Finds whether a component's `children` prop includes a React element of the
 * specified type.
 */
function hasChildOfType(children, type) {
  return React.Children.toArray(children).some(child => /*#__PURE__*/React.isValidElement(child) && child.type === type);
}

;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/Tabs.js












function getDefaultActiveKey(children) {
  let defaultActiveKey;
  forEach(children, child => {
    if (defaultActiveKey == null) {
      defaultActiveKey = child.props.eventKey;
    }
  });
  return defaultActiveKey;
}
function renderTab(child) {
  const {
    title,
    eventKey,
    disabled,
    tabClassName,
    tabAttrs,
    id
  } = child.props;
  if (title == null) {
    return null;
  }
  return /*#__PURE__*/(0,jsx_runtime.jsx)(react_bootstrap_esm_NavItem, {
    as: "li",
    role: "presentation",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(esm_NavLink, {
      as: "button",
      type: "button",
      eventKey: eventKey,
      disabled: disabled,
      id: id,
      className: tabClassName,
      ...tabAttrs,
      children: title
    })
  });
}
const Tabs_Tabs = props => {
  const {
    id,
    onSelect,
    transition,
    mountOnEnter = false,
    unmountOnExit = false,
    variant = 'tabs',
    children,
    activeKey = getDefaultActiveKey(children),
    ...controlledProps
  } = useUncontrolled(props, {
    activeKey: 'onSelect'
  });
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(esm_Tabs, {
    id: id,
    activeKey: activeKey,
    onSelect: onSelect,
    transition: getTabTransitionComponent(transition),
    mountOnEnter: mountOnEnter,
    unmountOnExit: unmountOnExit,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(react_bootstrap_esm_Nav, {
      id: id,
      ...controlledProps,
      role: "tablist",
      as: "ul",
      variant: variant,
      children: map(children, renderTab)
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(esm_TabContent, {
      children: map(children, child => {
        const childProps = {
          ...child.props
        };
        delete childProps.title;
        delete childProps.disabled;
        delete childProps.tabClassName;
        delete childProps.tabAttrs;
        return /*#__PURE__*/(0,jsx_runtime.jsx)(esm_TabPane, {
          ...childProps
        });
      })
    })]
  });
};
Tabs_Tabs.displayName = 'Tabs';
/* harmony default export */ var react_bootstrap_esm_Tabs = (Tabs_Tabs);
;// CONCATENATED MODULE: ./components/PartsViewer/v2/SelectedFileView/MobileView/index.js











const MobileView = (props)=>{
    const { expandHandler , partsList , setIsListExtend , isListExtend , title , showPopup , popupModal , setModal , productId , selected , tabsActive , panelState , onClose , partController , sku , prefeedbackController , loading , analytics , setWidthSize , showCart , setShowCart , showCartPopUp , setCartToast  } = props;
    const { isDesktop  } = (0,useViewport/* default */.Z)();
    (0,react.useEffect)(()=>prefeedbackController(false), []);
    const selectionChange = (selection)=>{
        onClose(false);
        prefeedbackController(selection === "parts");
    };
    if (loading.error) return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorFallBack, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mobile-tabs d-flex flex-column w-100 ".concat(tabsActive === "parts" ? "parts-section" : ""),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_bootstrap_esm_Tabs, {
                    defaultActiveKey: "diagram",
                    className: "mobile-view",
                    onSelect: (selection)=>selectionChange(selection),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_Tab, {
                            eventKey: "diagram",
                            title: "Diagram",
                            className: "tab-diagram",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat(isListExtend ? "" : "fullscreen-extend", " left"),
                                children: !(loading === null || loading === void 0 ? void 0 : loading.status) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(v2_PartsDiagramViewer, {
                                    expandHandler: expandHandler,
                                    fullscreen: panelState,
                                    selectedFile: selected,
                                    showPopup: showPopup,
                                    partController: partController,
                                    sku: sku,
                                    title: title
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* LoaderSpinner */.cK, {})
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_Tab, {
                            eventKey: "parts",
                            title: "Parts",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat(isListExtend ? "fullscreen-extend" : "", " fullscreen-right h-100"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v2_GridAndListPanel, {
                                    partsList: partsList,
                                    setIsListExtend: setIsListExtend,
                                    isListExtend: isListExtend,
                                    title: title,
                                    showPopup: showPopup,
                                    partController: partController,
                                    sku: sku,
                                    showCart: showCart,
                                    setShowCart: setShowCart,
                                    showCartPopUp: showCartPopUp,
                                    productId: productId,
                                    analytics: analytics,
                                    setCartToast: setCartToast
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mobile-popup ".concat(!isDesktop && popupModal ? "active" : ""),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v2_DetailPopUp, {
                    productId: productId,
                    setModal: setModal,
                    partController: partController,
                    sku: sku,
                    title: title,
                    analytics: analytics,
                    setWidthSize: setWidthSize
                })
            })
        ]
    });
};
MobileView.propTypes = {
    setWidthSize: (prop_types_default()).func.isRequired
};
/* harmony default export */ var SelectedFileView_MobileView = (MobileView);

;// CONCATENATED MODULE: ./components/PartsViewer/v2/SelectedFileView/index.js







const SelectedFileView = (props)=>{
    const { selectedFile , expandHandler , partsList , setIsListExtend , isListExtend , title , showPopup , popupModal , setModal , productId , selected , tabsActive , panelState , onClose , sku , prefeedbackController , loading , analytics , showCart , setShowCart , showCartPopUp  } = props;
    const [partsState, dispatch] = (0,react.useReducer)(partReducer, {
        parts: []
    });
    const [widthSize, setWidthSize] = (0,react.useState)(0);
    const [cartToast, setCartToast] = (0,react.useState)(null);
    const partsActions = getActions(partsState, dispatch);
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const { cartNotificationText  } = (0,localization/* getTranslations */.F)(t);
    (0,react.useEffect)(()=>partController.actions.initPartsList(selected), [
        selected
    ]);
    let isDesktop;
    const screenWidth = window.innerWidth;
    if (screenWidth > 812) {
        isDesktop = true;
    }
    const partController = {
        state: partsState,
        actions: partsActions
    };
    (0,react.useEffect)(()=>{
        let timeOut;
        if (cartToast === null || cartToast === void 0 ? void 0 : cartToast.status) {
            timeOut = setTimeout(()=>{
                setCartToast(null);
            }, 2000);
        }
        return ()=>{
            clearTimeout(timeOut);
        };
    });
    const value = (cartToast === null || cartToast === void 0 ? void 0 : cartToast.quantity) > 1 ? "Items" : "Item";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !isDesktop ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectedFileView_MobileView, {
                expandHandler: expandHandler,
                panelState: panelState,
                showPopup: showPopup,
                selectedFile: selectedFile,
                partsList: partsList,
                setIsListExtend: setIsListExtend,
                isListExtend: isListExtend,
                title: title,
                productId: productId,
                tabsActive: tabsActive,
                setModal: setModal,
                popupModal: popupModal,
                selected: selected,
                onClose: onClose,
                sku: sku,
                partController: partController,
                prefeedbackController: prefeedbackController,
                loading: loading,
                analytics: analytics,
                setWidthSize: setWidthSize,
                showCart: showCart,
                setShowCart: setShowCart,
                showCartPopUp: showCartPopUp,
                setCartToast: setCartToast
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectedFileView_DesktopView, {
                    expandHandler: expandHandler,
                    fullscreen: panelState,
                    showPopup: showPopup,
                    selectedFile: selectedFile,
                    partsList: partsList,
                    setIsListExtend: setIsListExtend,
                    isListExtend: isListExtend,
                    title: title,
                    productId: productId,
                    setModal: setModal,
                    popupModal: popupModal,
                    selected: selected,
                    partController: partController,
                    sku: sku,
                    loading: loading,
                    analytics: analytics,
                    setWidthSize: setWidthSize,
                    widthSize: widthSize,
                    showCart: showCart,
                    setShowCart: setShowCart,
                    showCartPopUp: showCartPopUp,
                    setCartToast: setCartToast
                })
            }),
            (cartToast === null || cartToast === void 0 ? void 0 : cartToast.status) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "cart-toast-message cart-toast-text",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: cartNotificationText(cartToast === null || cartToast === void 0 ? void 0 : cartToast.quantity, value)
                })
            }) : ""
        ]
    });
};
/* harmony default export */ var v2_SelectedFileView = (SelectedFileView);

;// CONCATENATED MODULE: ./components/PartsViewer/v2/PartViewerModal/index.js







const PartsViewerModal = (props)=>{
    const { files , fileMap , title , sku , skuImage , prefeedbackController , setParts , selectedFile , loading , analytics ={
        page: "na"
    } , setPartsHeight , productId , setShowPrint  } = props;
    const [selected, setSelected] = (0,react.useState)(selectedFile);
    const [selectedPart, setSelectedPart] = (0,react.useState)("");
    const [isListExtend, setIsListExtend] = (0,react.useState)(false);
    const [panelState, setPanelState] = (0,react.useState)(false);
    const device = (0,useViewport/* default */.Z)();
    const [popupModal, setPopupModal] = (0,react.useState)(false);
    const [tabsActive, setTabsActive] = (0,react.useState)("");
    const [showCart, setShowCart] = (0,react.useState)(false);
    let initialIndex;
    const isActive = (item)=>{
        return (item === null || item === void 0 ? void 0 : item.FileName) === (selected === null || selected === void 0 ? void 0 : selected.FileName);
    };
    for(let i = 0; i <= (files === null || files === void 0 ? void 0 : files.length) - 1; i++){
        var ref;
        if (((ref = files[i]) === null || ref === void 0 ? void 0 : ref.FileName) === (selected === null || selected === void 0 ? void 0 : selected.FileName)) {
            initialIndex = i;
        }
    }
    const getFileTitle = (name)=>{
        return (fileMap === null || fileMap === void 0 ? void 0 : fileMap[name]) === undefined ? name === null || name === void 0 ? void 0 : name.replace(/.svg/i, "") : fileMap === null || fileMap === void 0 ? void 0 : fileMap[name];
    };
    const showPopup = function(selectedItem) {
        let popupFlag = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
        const getSelectedItems = selected === null || selected === void 0 ? void 0 : selected.Parts.filter((val)=>{
            return (val === null || val === void 0 ? void 0 : val.Cod) === selectedItem;
        });
        if (getSelectedItems.length !== 0) {
            setPopupModal(popupFlag);
            setSelectedPart(selectedItem);
        } else {
            setPopupModal(false);
        }
    };
    const showCartPopUp = (selectedItem)=>{
        setSelectedPart(selectedItem);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !(loading === null || loading === void 0 ? void 0 : loading.error) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "modal-fullscreen modal-container ".concat(device.isSmallScreen ? "mobile-viewer" : "", "  ").concat(panelState ? "fullscreen-viewer" : ""),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectedFileView_FileSelection, {
                    files: files,
                    getFileTitle: getFileTitle,
                    isActive: isActive,
                    setSelected: setSelected,
                    setPopupModal: setPopupModal,
                    title: title,
                    sku: sku,
                    skuImage: skuImage,
                    setParts: setParts,
                    panelState: panelState,
                    initialIndex: initialIndex,
                    setPartsHeight: setPartsHeight,
                    productId: productId,
                    setShowPrint: setShowPrint
                })
            }) : "",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "parts-modal-wrapper modal_content ".concat(device.isSmallScreen ? "align-items-start" : "", "  ").concat(panelState ? "fullscreen-viewer" : ""),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v2_ErrorBoundary, {
                    FallBackComponent: ErrorFallBack,
                    params: {
                        title: getFileTitle(selected === null || selected === void 0 ? void 0 : selected.FileName)
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v2_SelectedFileView, {
                        expandHandler: ()=>setPanelState((state)=>!state),
                        panelState: panelState,
                        showPopup: showPopup,
                        selectedFile: selected,
                        partsList: selected === null || selected === void 0 ? void 0 : selected.Parts,
                        setIsListExtend: setIsListExtend,
                        isListExtend: isListExtend,
                        title: getFileTitle(selected === null || selected === void 0 ? void 0 : selected.FileName),
                        productId: selectedPart,
                        tabsActive: tabsActive,
                        setModal: setPopupModal,
                        popupModal: popupModal,
                        selected: selected,
                        onClose: setTabsActive,
                        sku: sku,
                        prefeedbackController: prefeedbackController,
                        loading: loading,
                        analytics: analytics,
                        showCart: showCart,
                        setShowCart: setShowCart,
                        showCartPopUp: showCartPopUp
                    })
                }, selected === null || selected === void 0 ? void 0 : selected.FileName)
            })
        ]
    });
};
/* harmony default export */ var PartViewerModal = (PartsViewerModal);

// EXTERNAL MODULE: ./components/PartsViewer/v2/partviewer.module.scss
var partviewer_module = __webpack_require__(22222);
var partviewer_module_default = /*#__PURE__*/__webpack_require__.n(partviewer_module);
// EXTERNAL MODULE: ./utils/index.js
var utils_0 = __webpack_require__(20558);
// EXTERNAL MODULE: ./i18n/usePdpi18n.js
var usePdpi18n = __webpack_require__(58886);
;// CONCATENATED MODULE: ./components/PartsViewer/v2/PartsViewer.jsx













const PartsViewer = (props)=>{
    var ref, ref1, ref2, ref3, ref4, ref5;
    const { page ="" , analyticsCustomData =null , onClose =()=>{} , showModal =false , productId ="" , fileMap =[] , partId ="" , disableCloseBtn =false  } = props;
    const [parts, setParts] = (0,react.useState)("");
    const [partsheight, setPartsHeight] = (0,react.useState)("");
    const [trigger, triggerAction] = hooks_useTrigger();
    const [loading, setLoading] = (0,react.useState)({
        status: true,
        error: false
    });
    const [showPrint, setShowPrint] = (0,react.useState)(false);
    const dispatch = (0,es/* useDispatch */.I0)();
    (0,react.useEffect)(()=>{
        const metaVal = "width=device-width, initial-scale=1.0";
        if (showModal) {
            var ref, ref1;
            (0,utils_0/* updateMetaContent */.uW)("viewport", "".concat(metaVal, ", maximum-scale=1.0, user-scalable=false"));
            (0,helper/* preventBodyScroll */.MVu)(true);
            (ref = document.querySelector("mavenoid-assistant")) === null || ref === void 0 ? void 0 : (ref1 = ref.classList) === null || ref1 === void 0 ? void 0 : ref1.add("mavenoid-remove");
            document.addEventListener("touchmove", handlerViewport, false);
        }
        return ()=>{
            var ref, ref1;
            (ref = document.querySelector("mavenoid-assistant")) === null || ref === void 0 ? void 0 : (ref1 = ref.classList) === null || ref1 === void 0 ? void 0 : ref1.remove("mavenoid-remove");
            document.removeEventListener("touchmove", handlerViewport);
            (0,utils_0/* updateMetaContent */.uW)("viewport", metaVal);
        };
    }, [
        showModal
    ]);
    (0,react.useEffect)(()=>{
        if (productId && fileMap) {
            const obj = {};
            fileMap.forEach((item)=>{
                obj[item.id] = item.title;
            });
            productInfo(obj);
        }
    }, [
        productId
    ]);
    const handlerViewport = (event)=>{
        if ((event === null || event === void 0 ? void 0 : event.scale) !== 1) {
            event.preventDefault();
        }
    };
    const productInfo = async (obj)=>{
        const resp = await dispatch((0,pdpSlice/* getPartList */.gt)({
            productId
        })).unwrap();
        if (resp === null || resp === void 0 ? void 0 : resp.SVGFiles) {
            const { Info , SVGFiles  } = resp;
            const diagramFiles = fileMap.map((val)=>{
                const getfile = SVGFiles === null || SVGFiles === void 0 ? void 0 : SVGFiles.filter((v)=>{
                    return (v === null || v === void 0 ? void 0 : v.FileName) === (val === null || val === void 0 ? void 0 : val.id);
                });
                return {
                    ...getfile === null || getfile === void 0 ? void 0 : getfile[0],
                    ...val
                };
            });
            const activePart = diagramFiles === null || diagramFiles === void 0 ? void 0 : diagramFiles.filter((val)=>val.FileName === partId);
            const selectedFile = activePart.length !== 0 ? activePart[0] : diagramFiles[0];
            const priceList = await getProjectionPartListData(selectedFile === null || selectedFile === void 0 ? void 0 : selectedFile.Parts);
            selectedFile.prices = priceList;
            setParts({
                fileMap: obj,
                partsInfo: {
                    Info,
                    SVGFiles: diagramFiles
                },
                selectedFile
            });
            setLoading({
                status: false,
                error: false
            });
        } else setLoading({
            status: false,
            error: true
        });
    };
    const closeModal = ()=>{
        setParts("");
        setLoading({
            status: true,
            error: false
        });
        (0,helper/* preventBodyScroll */.MVu)(false);
        onClose();
    };
    const getPartDiagramCloseEventInfo = JSON.stringify({
        eventAction: page + ":modal:interactive parts diagram:close",
        eventName: page + ":modal:interactive parts diagram:close",
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "close",
        internalLinkPosition: page,
        internalLinkType: page + ":close",
        internalLinkZoneName: page + ":modal:interactive parts diagram",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    });
    let text1;
    let text2;
    let title;
    if ((parts === null || parts === void 0 ? void 0 : (ref = parts.partsInfo) === null || ref === void 0 ? void 0 : ref.Info) !== undefined) {
        var ref6, ref7, ref8, ref9;
        text1 = parts === null || parts === void 0 ? void 0 : (ref6 = parts.partsInfo) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.Info) === null || ref7 === void 0 ? void 0 : ref7["Product Name"];
        text2 = parts === null || parts === void 0 ? void 0 : (ref8 = parts.partsInfo) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.Info) === null || ref9 === void 0 ? void 0 : ref9["Short Description"];
        title = text1.replace(new RegExp(text2, "g"), "");
    }
    const prefeedbackController = ()=>{};
    const i18nTexts = (0,usePdpi18n/* default */.Z)({}, {}, "");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_bootstrap_esm_Modal, {
        show: showModal,
        closeButtonAnalytics: getPartDiagramCloseEventInfo,
        analyticsCustomData: analyticsCustomData || null,
        className: "partviwer-modal ".concat((partviewer_module_default()).PartDiagramViewer, " "),
        fullscreen: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "partviewer-modal-container part-".concat(partsheight, " ").concat(!parts ? "loading-text" : "", " ").concat(showPrint ? "print-widgets" : "", " ").concat(disableCloseBtn ? "standalone-parts" : ""),
            children: [
                !disableCloseBtn ? /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    className: "close-btns",
                    onClick: closeModal,
                    "aria-label": i18nTexts === null || i18nTexts === void 0 ? void 0 : i18nTexts.servicePartsLabel,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* CloseIcon */.Tw, {})
                }) : null,
                !loading.status ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PartViewerModal, {
                    trigger: trigger,
                    triggerAction: triggerAction,
                    files: parts === null || parts === void 0 ? void 0 : (ref1 = parts.partsInfo) === null || ref1 === void 0 ? void 0 : ref1.SVGFiles,
                    fileMap: parts === null || parts === void 0 ? void 0 : parts.fileMap,
                    prefeedbackController: prefeedbackController,
                    skuImage: parts === null || parts === void 0 ? void 0 : (ref2 = parts.partsInfo) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.Info) === null || ref3 === void 0 ? void 0 : ref3.Thumbnail,
                    title: title,
                    sku: parts === null || parts === void 0 ? void 0 : (ref4 = parts.partsInfo) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.Info) === null || ref5 === void 0 ? void 0 : ref5.Cod,
                    setParts: setParts,
                    selectedFile: parts === null || parts === void 0 ? void 0 : parts.selectedFile,
                    loading: loading,
                    analytics: {
                        page: page
                    },
                    setPartsHeight: setPartsHeight,
                    productId: productId,
                    setShowPrint: setShowPrint
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* LoaderSpinner */.cK, {})
            ]
        })
    });
};
/* harmony default export */ var v2_PartsViewer = (PartsViewer);


/***/ }),

/***/ 7667:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DS": function() { return /* binding */ IconZoomOut; },
/* harmony export */   "Eh": function() { return /* binding */ ImageListViewMobile; },
/* harmony export */   "Gr": function() { return /* binding */ PrintHeader; },
/* harmony export */   "Ho": function() { return /* binding */ LoadingIcon; },
/* harmony export */   "KL": function() { return /* binding */ DownIcon; },
/* harmony export */   "M9": function() { return /* binding */ IncIcon; },
/* harmony export */   "Nh": function() { return /* binding */ DecIcon; },
/* harmony export */   "PL": function() { return /* binding */ GridViewUnSelected; },
/* harmony export */   "Qb": function() { return /* binding */ AddToCartLoadingIcon; },
/* harmony export */   "Tw": function() { return /* binding */ CloseIcon; },
/* harmony export */   "WM": function() { return /* binding */ IconZoomIn; },
/* harmony export */   "Wz": function() { return /* binding */ ImageGridViewMobile; },
/* harmony export */   "bM": function() { return /* binding */ IconClose; },
/* harmony export */   "bt": function() { return /* binding */ IconCollapse; },
/* harmony export */   "cK": function() { return /* binding */ LoaderSpinner; },
/* harmony export */   "e6": function() { return /* binding */ WarnIcon; },
/* harmony export */   "iK": function() { return /* binding */ ResetActive; },
/* harmony export */   "pS": function() { return /* binding */ ListViewSelected; },
/* harmony export */   "qp": function() { return /* binding */ IconExpand; },
/* harmony export */   "rc": function() { return /* binding */ SortByIcon; },
/* harmony export */   "tR": function() { return /* binding */ SortByDropDownIcon; },
/* harmony export */   "tW": function() { return /* binding */ AddedIcon; },
/* harmony export */   "uN": function() { return /* binding */ IconReset; },
/* harmony export */   "wO": function() { return /* binding */ IconExpandGrid; },
/* harmony export */   "xD": function() { return /* binding */ CartCloseIcon; },
/* harmony export */   "zu": function() { return /* binding */ BackToTop; }
/* harmony export */ });
/* unused harmony exports LoadingImage, PlusIcon, MinusIcon, SortIcon, ImageThumbIcon, ImageListIcon, CrossButton, ModalCloseIcon, ExitFullScreenIcon, IconApiError */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _public_images_spinner_svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59001);



const IconReset = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "30",
        height: "30",
        viewBox: "0 0 30 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M14.5625 26.25V24.625C11.9583 24.3958 9.83333 23.4583 8.1875 21.8125C6.54167 20.1667 5.60417 18.0417 5.375 15.4375H3.75V14.5625H5.375C5.60417 11.9583 6.54167 9.83333 8.1875 8.1875C9.83333 6.54167 11.9583 5.60417 14.5625 5.375V3.75H15.4375V5.375C18.0417 5.60417 20.1667 6.54167 21.8125 8.1875C23.4583 9.83333 24.3958 11.9583 24.625 14.5625H26.25V15.4375H24.625C24.3958 18.0417 23.4583 20.1667 21.8125 21.8125C20.1667 23.4583 18.0417 24.3958 15.4375 24.625V26.25H14.5625ZM15 23.75C17.4167 23.75 19.4792 22.8958 21.1875 21.1875C22.8958 19.4792 23.75 17.4167 23.75 15C23.75 12.5833 22.8958 10.5208 21.1875 8.8125C19.4792 7.10417 17.4167 6.25 15 6.25C12.5833 6.25 10.5208 7.10417 8.8125 8.8125C7.10417 10.5208 6.25 12.5833 6.25 15C6.25 17.4167 7.10417 19.4792 8.8125 21.1875C10.5208 22.8958 12.5833 23.75 15 23.75ZM15 18.375C14.0719 18.375 13.2773 18.0445 12.6164 17.3836C11.9555 16.7227 11.625 15.9281 11.625 15C11.625 14.0719 11.9555 13.2773 12.6164 12.6164C13.2773 11.9555 14.0719 11.625 15 11.625C15.9281 11.625 16.7227 11.9555 17.3836 12.6164C18.0445 13.2773 18.375 14.0719 18.375 15C18.375 15.9281 18.0445 16.7227 17.3836 17.3836C16.7227 18.0445 15.9281 18.375 15 18.375Z",
            fill: "#ffffff"
        })
    });
const IconZoomIn = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "30",
        height: "30",
        viewBox: "0 0 30 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M14.5 15.5V25H15.5V15.5H25V14.5H15.5V5H14.5V14.5H5V15.5H14.5Z",
                fill: "#ffffff"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M14.5 15.5V25H15.5V15.5H25V14.5H15.5V5H14.5V14.5H5V15.5H14.5Z",
                fill: "#ffffff"
            })
        ]
    });
const IconZoomOut = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "30",
        height: "30",
        viewBox: "0 0 30 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M5 14.5H25V15.5H5V14.5Z",
                fill: "#ffffff"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M5 14.5H25V15.5H5V14.5Z",
                fill: "#ffffff"
            })
        ]
    });
const IconExpand = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "30",
        height: "30",
        viewBox: "0 0 30 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M12.6985 16.2919L13.4056 16.999L8.46951 21.9341L12.7302 21.9341V22.9341H6.7793L6.7793 16.9832H7.7793L7.77937 21.2101L12.6985 16.2919ZM22.3215 6.76526V12.7162H21.3215L21.3203 8.48826L16.1524 13.6575L15.4453 12.9504L20.6303 7.76426L16.3706 7.76526V6.76526H22.3215Z",
            fill: "#ffffff"
        })
    });
const IconExpandGrid = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "16",
        height: "17",
        viewBox: "0 0 16 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M5.91917 10.2918L6.62628 10.9989L1.69021 15.934L5.95093 15.934V16.934H0L0 10.9831H1L1.00007 15.2099L5.91917 10.2918ZM15.5422 0.765137V6.71606H14.5422L14.541 2.48814L9.37307 7.65737L8.66596 6.95027L13.851 1.76414L9.59131 1.76514V0.765137H15.5422Z",
            fill: "#212121"
        })
    });
const IconCollapse = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M1.35338 17.4951L0.586914 16.7291L6.23617 11.0833H2.49991V10H8.0866V15.5833H7.00263V11.8493L1.35338 17.4951Z",
                fill: "#ffffff"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M10.0879 7.99515V2.41183H11.1719V6.14583L16.8211 0.5L17.5876 1.266L11.9383 6.91183H15.6746V7.99515H10.0879Z",
                fill: "#ffffff"
            })
        ]
    });
const ResetActive = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "30",
        height: "30",
        viewBox: "0 0 30 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M14.5625 26.25V24.625C11.9583 24.3958 9.83333 23.4583 8.1875 21.8125C6.54167 20.1667 5.60417 18.0417 5.375 15.4375H3.75V14.5625H5.375C5.60417 11.9583 6.54167 9.83333 8.1875 8.1875C9.83333 6.54167 11.9583 5.60417 14.5625 5.375V3.75H15.4375V5.375C18.0417 5.60417 20.1667 6.54167 21.8125 8.1875C23.4583 9.83333 24.3958 11.9583 24.625 14.5625H26.25V15.4375H24.625C24.3958 18.0417 23.4583 20.1667 21.8125 21.8125C20.1667 23.4583 18.0417 24.3958 15.4375 24.625V26.25H14.5625ZM15 23.75C17.4167 23.75 19.4792 22.8958 21.1875 21.1875C22.8958 19.4792 23.75 17.4167 23.75 15C23.75 12.5833 22.8958 10.5208 21.1875 8.8125C19.4792 7.10417 17.4167 6.25 15 6.25C12.5833 6.25 10.5208 7.10417 8.8125 8.8125C7.10417 10.5208 6.25 12.5833 6.25 15C6.25 17.4167 7.10417 19.4792 8.8125 21.1875C10.5208 22.8958 12.5833 23.75 15 23.75ZM15 18.375C14.0719 18.375 13.2773 18.0445 12.6164 17.3836C11.9555 16.7227 11.625 15.9281 11.625 15C11.625 14.0719 11.9555 13.2773 12.6164 12.6164C13.2773 11.9555 14.0719 11.625 15 11.625C15.9281 11.625 16.7227 11.9555 17.3836 12.6164C18.0445 13.2773 18.375 14.0719 18.375 15C18.375 15.9281 18.0445 16.7227 17.3836 17.3836C16.7227 18.0445 15.9281 18.375 15 18.375ZM15 17.5C15.6875 17.5 16.276 17.2552 16.7656 16.7656C17.2552 16.276 17.5 15.6875 17.5 15C17.5 14.3125 17.2552 13.724 16.7656 13.2344C16.276 12.7448 15.6875 12.5 15 12.5C14.3125 12.5 13.724 12.7448 13.2344 13.2344C12.7448 13.724 12.5 14.3125 12.5 15C12.5 15.6875 12.7448 16.276 13.2344 16.7656C13.724 17.2552 14.3125 17.5 15 17.5Z",
            fill: "#00BCE5"
        })
    });
const LoadingImage = ()=>/*#__PURE__*/ _jsx("div", {
        className: "loading-spinner",
        children: /*#__PURE__*/ _jsxs("svg", {
            width: "56",
            height: "56",
            viewBox: "0 0 60 60",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ _jsx("circle", {
                    cx: "30",
                    cy: "30",
                    r: "28",
                    stroke: "url(#paint0_linear_952_180)",
                    strokeWidth: "4"
                }),
                /*#__PURE__*/ _jsx("defs", {
                    children: /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint0_linear_952_180",
                        x1: "54.1411",
                        y1: "49.3794",
                        x2: "9.49243",
                        y2: "8.51453",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#1AAA89"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.237209",
                                stopColor: "#08A1A9"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.508047",
                                stopColor: "#1E80B7"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.784094",
                                stopColor: "#693A92"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#D81081"
                            })
                        ]
                    })
                })
            ]
        })
    });
const CloseIcon = ()=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "17",
        height: "30",
        viewBox: "0 0 17 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M7.79376 15.4999L0.369141 22.9245L1.07625 23.6316L8.50087 16.207L15.9255 23.6316L16.6326 22.9245L9.20798 15.4999L16.6326 8.07527L15.9255 7.36816L8.50087 14.7928L1.07625 7.36816L0.369141 8.07527L7.79376 15.4999Z",
                fill: "#494949"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M7.79376 15.4999L0.369141 22.9245L1.07625 23.6316L8.50087 16.207L15.9255 23.6316L16.6326 22.9245L9.20798 15.4999L16.6326 8.07527L15.9255 7.36816L8.50087 14.7928L1.07625 7.36816L0.369141 8.07527L7.79376 15.4999Z",
                fill: "#494949"
            })
        ]
    });
};
const DownIcon = ()=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "16",
        height: "10",
        viewBox: "0 0 16 10",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M15.1504 0L15.8799 0.683941L8.01516 9.07303L0.150391 0.683941L0.879928 0L8.01516 7.61097L15.1504 0Z",
                fill: "#757575"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M15.1504 0L15.8799 0.683941L8.01516 9.07303L0.150391 0.683941L0.879928 0L8.01516 7.61097L15.1504 0Z",
                fill: "#212121"
            })
        ]
    });
};
const PlusIcon = ()=>/*#__PURE__*/ _jsx("svg", {
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M6.25 13.75V7.74995H0.25V6.25H6.25V0.25H7.74995V6.25H13.75V7.74995H7.74995V13.75H6.25Z",
            fill: "#757575"
        })
    });
const MinusIcon = ()=>/*#__PURE__*/ _jsx("svg", {
        width: "14",
        height: "2",
        viewBox: "0 0 14 2",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M0.25 1.74995V0.25H13.75V1.74995H0.25Z",
            fill: "#CCCCCC"
        })
    });
const SortIcon = ()=>/*#__PURE__*/ _jsx("svg", {
        width: "18",
        height: "13",
        viewBox: "0 0 18 13",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M7.23755 12.703V11.203H10.7375V12.703H7.23755ZM3.23755 7.51064V6.01068H14.7375V7.51064H3.23755ZM0.237549 2.31833V0.818359H17.7375V2.31833H0.237549Z",
            fill: "#1C1B1F"
        })
    });
const SortByIcon = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "21",
        height: "30",
        viewBox: "0 0 21 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M15.5 12.5025C14.2917 12.5309 13.2375 11.6876 13 10.5025H0V9.50251H13C13.2366 8.33734 14.2611 7.5 15.45 7.5C16.6389 7.5 17.6634 8.33734 17.9 9.50251H21V10.5025H17.95C17.7159 11.6688 16.6896 12.5067 15.5 12.5025ZM15.5 8.50293C14.6716 8.50293 14 9.1745 14 10.0029C14 10.8314 14.6716 11.5029 15.5 11.5029C16.3284 11.5029 17 10.8314 17 10.0029C17 9.1745 16.3284 8.50293 15.5 8.50293Z",
                fill: "#494949"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M3 19.5278C3.2264 18.3507 4.25636 17.5 5.455 17.5C6.65364 17.5 7.6836 18.3507 7.91 19.5278H21V20.5278H7.95C7.75555 21.7579 6.68544 22.6572 5.44026 22.6371C4.19509 22.617 3.15459 21.6835 3 20.4478H0V19.4478L3 19.5278ZM5.45996 21.5273C6.28839 21.5273 6.95996 20.8558 6.95996 20.0273C6.95996 19.1989 6.28839 18.5273 5.45996 18.5273C4.63153 18.5273 3.95996 19.1989 3.95996 20.0273C3.96517 20.4287 4.13103 20.8113 4.42045 21.0894C4.70987 21.3675 5.0987 21.5181 5.49996 21.5073L5.45996 21.5273Z",
                fill: "#494949"
            })
        ]
    });
const ImageThumbIcon = ()=>/*#__PURE__*/ _jsx("svg", {
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M-0.000244141 6.20115V0.201172H5.99974V6.20115H-0.000244141ZM-0.000244141 13.8011V7.80115H5.99974V13.8011H-0.000244141ZM7.59974 6.20115V0.201172H13.5997V6.20115H7.59974ZM7.59974 13.8011V7.80115H13.5997V13.8011H7.59974Z",
            fill: "#757575"
        })
    });
const ImageListIcon = ()=>/*#__PURE__*/ _jsx("svg", {
        width: "14",
        height: "12",
        viewBox: "0 0 14 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M0.000244141 11.4015V10.2016H14.0002V11.4015H0.000244141ZM0.000244141 8.20152V7.00156H14.0002V8.20152H0.000244141ZM0.000244141 5.00152V3.80156H14.0002V5.00152H0.000244141ZM0.000244141 1.80152V0.601562H14.0002V1.80152H0.000244141Z",
            fill: "#757575"
        })
    });
const CrossButton = ()=>/*#__PURE__*/ _jsxs("svg", {
        width: "22",
        height: "22",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M1.5 1.5L14.5 14.5",
                stroke: "white",
                strokeWidth: "1.5",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14.5 1.5L1.5 14.5",
                stroke: "white",
                strokeWidth: "1.5",
                strokeLinecap: "round"
            })
        ]
    });
const ModalCloseIcon = ()=>{
    return /*#__PURE__*/ _jsx("svg", {
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M1.40002 13.6553L0.346191 12.6015L5.94619 7.00148L0.346191 1.40148L1.40002 0.347656L7.00002 5.94766L12.6 0.347656L13.6538 1.40148L8.05384 7.00148L13.6538 12.6015L12.6 13.6553L7.00002 8.05531L1.40002 13.6553Z",
            fill: "#757575"
        })
    });
};
const ExitFullScreenIcon = ()=>/*#__PURE__*/ _jsx("svg", {
        width: "80",
        height: "80",
        viewBox: "0 0 80 80",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M40 25C48.2843 25 55 31.7157 55 40C55 48.2843 48.2843 55 40 55C31.7157 55 25 48.2843 25 40C25 31.7157 31.7157 25 40 25Z",
            stroke: "#3FC28F",
            "stroke-width": "4",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
        })
    });
const IconApiError = ()=>{
    return /*#__PURE__*/ _jsxs("svg", {
        className: "icon-api-error",
        viewBox: "0 0 168 169",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M0.999695 75.6734C0.999695 116.914 34.4321 150.347 75.6731 150.347C116.914 150.347 150.347 116.914 150.347 75.6734C150.347 34.4324 116.914 1 75.6731 1C34.4321 1 0.999695 34.4324 0.999695 75.6734ZM-0.000305176 75.6734C-0.000305176 117.467 33.8798 151.347 75.6731 151.347C96.8809 151.347 116.051 142.623 129.791 128.567L166.603 168.287L167.337 167.607L130.486 127.847C143.412 114.271 151.347 95.8987 151.347 75.6734C151.347 33.8801 117.466 0 75.6731 0C33.8798 0 -0.000305176 33.8801 -0.000305176 75.6734ZM61.0059 59.2387C61.2988 58.9458 61.7737 58.9458 62.0666 59.2387L77.8234 74.9955L93.5802 59.2387C93.8731 58.9458 94.3479 58.9458 94.6408 59.2387C94.9337 59.5316 94.9337 60.0065 94.6408 60.2994L78.884 76.0562L94.6407 91.8129C94.9336 92.1058 94.9336 92.5806 94.6407 92.8735C94.3478 93.1664 93.873 93.1664 93.5801 92.8735L77.8234 77.1168L62.0667 92.8735C61.7738 93.1664 61.2989 93.1664 61.006 92.8735C60.7131 92.5806 60.7131 92.1058 61.006 91.8129L76.7627 76.0562L61.0059 60.2994C60.713 60.0065 60.713 59.5316 61.0059 59.2387Z",
                fill: "url(#paint0_linear_2074_15327)"
            }),
            /*#__PURE__*/ _jsx("defs", {
                children: /*#__PURE__*/ _jsxs("linearGradient", {
                    id: "paint0_linear_2074_15327",
                    x1: "0.223115",
                    y1: "0",
                    x2: "167.337",
                    y2: "0",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ _jsx("stop", {
                            stopColor: "#1AAA89"
                        }),
                        /*#__PURE__*/ _jsx("stop", {
                            offset: "0.237209",
                            stopColor: "#08A1A9"
                        }),
                        /*#__PURE__*/ _jsx("stop", {
                            offset: "0.508047",
                            stopColor: "#1E80B7"
                        }),
                        /*#__PURE__*/ _jsx("stop", {
                            offset: "0.784094",
                            stopColor: "#693A92"
                        }),
                        /*#__PURE__*/ _jsx("stop", {
                            offset: "1",
                            stopColor: "#D81081"
                        })
                    ]
                })
            })
        ]
    });
};
const ImageGridViewMobile = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "17",
        height: "30",
        viewBox: "0 0 17 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
            id: "grid icons/grid filled",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                id: "Path",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M7 6H0V13H7V6Z",
                        fill: "#212121"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M17 6H10V13H17V6Z",
                        fill: "#212121"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M0 16H7V23H0V16Z",
                        fill: "#212121"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M17 16H10V23H17V16Z",
                        fill: "#212121"
                    })
                ]
            })
        })
    });
const ImageListViewMobile = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "17",
        height: "30",
        viewBox: "0 0 17 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
            id: "grid icons/vertical empty",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                id: "Path",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M-1.74846e-07 10L17 10L17 6L0 6L-1.74846e-07 10ZM16 7L16 9L1 9L1 7L16 7Z",
                        fill: "#212121"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M-7.43094e-07 23L17 23L17 19L-5.68248e-07 19L-7.43094e-07 23ZM16 20L16 22L0.999999 22L0.999999 20L16 20Z",
                        fill: "#212121"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M17 16.5L-4.5897e-07 16.5L-2.84124e-07 12.5L8.5 12.5L17 12.5L17 16.5ZM16 15.5L16 13.5L1 13.5L1 15.5L16 15.5Z",
                        fill: "#212121"
                    })
                ]
            })
        })
    });
const SortByDropDownIcon = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "13",
        height: "30",
        viewBox: "0 0 13 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M12.1814 11L13 11.6448L6.5 18.8179L0 11.6448L0.782276 11L6.5 17.2061L12.1814 11Z",
                fill: "#757575"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M12.1814 11L13 11.6448L6.5 18.8179L0 11.6448L0.782276 11L6.5 17.2061L12.1814 11Z",
                fill: "#494949"
            })
        ]
    });
const IconClose = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "30",
        height: "30",
        viewBox: "0 0 30 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M14.7609 15.4999L7 22.9245L7.73913 23.6316L15.5 16.207L23.2609 23.6316L24 22.9245L16.2391 15.4999L24 8.07527L23.2609 7.36816L15.5 14.7928L7.73913 7.36816L7 8.07527L14.7609 15.4999Z",
                fill: "#757575"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M14.7609 15.4999L7 22.9245L7.73913 23.6316L15.5 16.207L23.2609 23.6316L24 22.9245L16.2391 15.4999L24 8.07527L23.2609 7.36816L15.5 14.7928L7.73913 7.36816L7 8.07527L14.7609 15.4999Z",
                fill: "#757575"
            })
        ]
    });
const IncIcon = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "14",
        height: "30",
        viewBox: "0 0 14 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M6.5 15.4995V21.9995H7.5V15.4995H14V14.4995H7.5V7.99951H6.5V14.4995H0V15.4995H6.5Z",
                fill: "#212121"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M6.5 15.4995V21.9995H7.5V15.4995H14V14.4995H7.5V7.99951H6.5V14.4995H0V15.4995H6.5Z",
                fill: "#212121"
            })
        ]
    });
const DecIcon = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "14",
        height: "30",
        viewBox: "0 0 14 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M0 14.4995H14V15.4995H0V14.4995Z",
                fill: "#757575"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M0 14.4995H14V15.4995H0V14.4995Z",
                fill: "#212121"
            })
        ]
    });
const LoadingIcon = ()=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "28",
        height: "28",
        viewBox: "0 0 28 28",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: "spinner-border loadingIcon"
    });
};
const WarnIcon = ()=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "20px",
        height: "20px",
        viewBox: "0 0 20 20",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
            id: "B4-Cart",
            stroke: "none",
            "stroke-width": "1",
            fill: "none",
            "fill-rule": "evenodd",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                id: "D_Kohler_UI_Batch-4,-Cart-Landing-Out-of-Stock-Promo-Error-ZipCode-1.2",
                transform: "translate(-806.000000, -1190.000000)",
                fill: "#D10000",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                    id: "Cart-Products",
                    transform: "translate(70.000000, 395.000000)",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                        id: "Product-Robern",
                        transform: "translate(0.000000, 644.000000)",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                            id: "03-Buttons/AlertMsg",
                            transform: "translate(731.000000, 146.000000)",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M15.8865,19.128 L15.8865,21 L14.3565,21 L14.3565,19.128 L15.8865,19.128 Z M15.8865,8.148 L15.8865,17.454 L14.3565,17.454 L14.3565,8.148 L15.8865,8.148 Z",
                                    id: "Tool-Tip-Icon"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M15,5 C20.5228475,5 25,9.4771525 25,15 C25,20.5228475 20.5228475,25 15,25 C9.4771525,25 5,20.5228475 5,15 C5,9.4771525 9.4771525,5 15,5 Z M15,5.66666667 C9.84534234,5.66666667 5.66666667,9.84534234 5.66666667,15 C5.66666667,20.1546577 9.84534234,24.3333333 15,24.3333333 C20.1546577,24.3333333 24.3333333,20.1546577 24.3333333,15 C24.3333333,9.84534234 20.1546577,5.66666667 15,5.66666667 Z",
                                    id: "Oval",
                                    "fill-rule": "nonzero"
                                })
                            ]
                        })
                    })
                })
            })
        })
    });
};
const BackToTop = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "10",
        height: "30",
        viewBox: "0 0 10 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M9.95028 9.99955L5.00053 5.0498L0.0507812 9.99955L0.757888 10.7067L4.50053 6.96402V23.9996H5.50053V6.96402L9.24317 10.7067L9.95028 9.99955Z",
            fill: "#212121"
        })
    });
const LoaderSpinner = ()=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "spinner-img d-flex justify-content-center align-items-center h-100",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
            src: _public_images_spinner_svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"].src */ .Z.src,
            alt: "loading"
        })
    });
};
const ListViewSelected = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "17",
        height: "30",
        viewBox: "0 0 17 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M17 10L-1.74846e-07 10L0 6L17 6L17 10Z",
                fill: "#212121"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M17 23L-7.43094e-07 23L-5.68248e-07 19L17 19L17 23Z",
                fill: "#212121"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M-4.5897e-07 16.5L17 16.5L17 12.5L-2.84124e-07 12.5L-4.5897e-07 16.5Z",
                fill: "#212121"
            })
        ]
    });
const GridViewUnSelected = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "17",
        height: "30",
        viewBox: "0 0 17 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M7 6V13H0V6H7ZM6 7H1V12H6V7Z",
                fill: "#212121"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M17 6V13H10V6H17ZM16 7H11V12H16V7Z",
                fill: "#212121"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M7 23V16H0V23H7ZM1 17H6V22H1V17Z",
                fill: "#212121"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M17 16V23H10V16H17ZM16 17H11V22H16V17Z",
                fill: "#212121"
            })
        ]
    });
const CartCloseIcon = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "30",
        height: "30",
        viewBox: "0 0 30 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M14.7609 15.4989L7 22.9235L7.73913 23.6306L15.5 16.206L23.2609 23.6306L24 22.9235L16.2391 15.4989L24 8.07429L23.2609 7.36719L15.5 14.7918L7.73913 7.36719L7 8.07429L14.7609 15.4989Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M14.7609 15.4989L7 22.9235L7.73913 23.6306L15.5 16.206L23.2609 23.6306L24 22.9235L16.2391 15.4989L24 8.07429L23.2609 7.36719L15.5 14.7918L7.73913 7.36719L7 8.07429L14.7609 15.4989Z",
                fill: "white"
            })
        ]
    });
const PrintHeader = (param)=>{
    let { data  } = param;
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlSpace: "preserve",
        width: "100%",
        height: "100%",
        version: "1.0",
        "shape-rendering": "geometricPrecision",
        "text-rendering": "geometricPrecision",
        "image-rendering": "optimizeQuality",
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        viewBox: "0 0 12774 3080",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("font", {
                        id: "FontID0",
                        "horiz-adv-x": "722",
                        "font-variant": "normal",
                        "fill-rule": "nonzero",
                        "font-style": "normal",
                        "font-weight": "700",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("font-face", {
                                "font-family": "Arial"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("missing-glyph", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M0 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xff",
                                "horiz-adv-x": "556",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M6.00675 519.01l145.984 0 124.499 -368.166 121.507 368.166 142.002 0 -182.992 -499.505 -33.0034 -90.1687c-12.171,-30.1687 -23.667,-53.1609 -34.6682,-69.1789 -10.8436,-15.8155 -23.5096,-28.8189 -37.6603,-38.6502 -14.1732,-10.0112 -31.676,-17.6828 -52.5084,-23.1721 -20.6749,-5.51181 -44.162,-8.34646 -70.3262,-8.34646 -26.3442,0 -52.351,2.83465 -77.8403,8.34646l-11.991 106.997c21.4848,-4.16198 40.9899,-6.32171 58.3127,-6.32171 32.0135,0 55.6805,9.31384 71.0011,28.1665 15.3431,18.8301 27.1766,42.8121 35.3431,71.8335l-197.66 520zm115.501 66.9966l0 117.998 117.998 0 0 -117.998 -117.998 0zm210.484 0l0 117.998 118.02 0 0 -117.998 -118.02 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xee",
                                "horiz-adv-x": "277",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M71.991 0l0 519.01 137.008 0 0 -519.01 -137.008 0zm-91.0011 586.007l102.52 144.004 126.322 0 101.17 -144.004 -110.011 0 -56.4904 73.0034 -52.5084 -73.0034 -111.001 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xdd",
                                "horiz-adv-x": "666",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M260.99 0l0 301.327 -262.497 414.668 169.516 0 169.314 -283.487 164.837 283.487 166.344 0 -262.497 -415.658 0 -300.337 -145.017 0zm-1.97975 780.99l67.9865 146.007 153.003 0 -135.006 -146.007 -85.9843 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xcc",
                                "horiz-adv-x": "277",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M68.009 0l0 715.996 144.994 0 0 -715.996 -144.994 0zm171.991 780.99l-86.0067 0 -134.983 146.007 152.981 0 68.009 -146.007z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xbb",
                                "horiz-adv-x": "556",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M242.992 33.9933l127.019 220.832 -127.019 225.174 107.019 0 154.983 -225.174 -154.983 -220.832 -107.019 0zm-191.991 0l126.997 220.832 -126.997 225.174 106.997 0 155.006 -225.174 -155.006 -220.832 -106.997 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xaa",
                                "horiz-adv-x": "370",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M124.004 611.001l-92.0135 19.0101c7.51406,32.4859 22.5197,57.1654 45.1744,73.8133 22.4972,16.8504 56.8279,25.1744 102.677,25.1744 47.829,0 83.8245,-6.32171 108.166,-18.9876 15.9955,-8.18898 27.829,-22.6772 35.658,-43.5096 4.8369,-13.0034 7.33408,-37.9978 7.33408,-75.0056l0 -116.49c0,-33.8358 1.16985,-56.5129 3.32958,-68.1665 2.15973,-11.4961 6.00675,-22.8346 11.676,-33.8358l-93.4983 0c-4.18448,8.50394 -8.009,20 -11.1811,34.6682 -28.6614,-29.1789 -63.667,-43.667 -105.332,-43.667 -36.9854,0 -65.9843,9.83127 -86.8391,29.4938 -20.8324,19.6625 -31.1586,44.9944 -31.1586,75.838 0,22.1597 5.17435,40.8324 15.3431,56.153 10.3262,15.3431 25.3318,27.3341 45.1519,36.1755 14.5107,6.16423 45.1744,13.8358 91.5186,22.8346 25.6468,5.33183 45.9843,10.6637 60.9899,16.1755 0,4.49944 -0.15748,7.82902 -0.494938,9.98875 -0.337458,15.5006 -3.1721,25.6693 -8.68391,30.3262 -7.82902,6.68166 -21.3273,10.0112 -40.4949,10.0112 -16.8279,0 -29.4938,-2.83465 -37.8178,-8.32396 -6.18673,-4.18448 -12.6659,-14.8481 -19.5051,-31.676zm106.997 -75.1631c-7.1766,-4.34196 -17.1654,-7.67154 -30.1687,-10.3487 -35.0056,-7.49156 -55.838,-13.1609 -62.3397,-17.1654 -13.0034,-8.16648 -19.4826,-18.6502 -19.4826,-31.6535 0,-10.1687 4.31946,-19.3476 13.1609,-27.5141 8.66142,-8.16648 20.1575,-12.1485 33.9933,-12.1485 18.8301,0 34.3307,6.81665 46.5017,20.315 12.171,13.5208 18.3352,33.1834 18.3352,58.8526l0 19.6625z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\x99",
                                "horiz-adv-x": "750",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M124.994 0l0 624.994 500 0 0 -624.994 -500 0zm15.9955 15.9955l468.009 0 0 593.003 -468.009 0 0 -593.003z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\x88",
                                "horiz-adv-x": "750",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M124.994 0l0 624.994 500 0 0 -624.994 -500 0zm15.9955 15.9955l468.009 0 0 593.003 -468.009 0 0 -593.003z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "w",
                                "horiz-adv-x": "777",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M168.009 0l-164.004 519.01 133.318 0 97.1879 -340.18 89.4938 340.18 132.328 0 86.1642 -340.18 99.1676 340.18 135.343 0 -166.682 -519.01 -131.654 0 -89.1789 333.836 -87.9865 -333.836 -133.498 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "f",
                                "horiz-adv-x": "333",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M11.991 519.01l76.018 0 0 39.1676c0,43.6445 4.65692,76.333 13.9933,97.8178 9.33633,21.6648 26.5017,39.1676 51.4961,52.6659 25.1744,13.4983 56.8279,20.3375 95.1631,20.3375 39.1676,0 77.6828,-5.82677 115.343,-17.5028l-17.5028 -95.3206c-22.3397,5.15186 -43.8245,7.82902 -64.4994,7.82902 -20.3375,0 -34.8256,-4.67942 -43.667,-13.9933 -8.84139,-9.33633 -13.3408,-27.3341 -13.3408,-54.0157l0 -36.9854 103.015 0 0 -108.009 -103.015 0 0 -411.001 -136.985 0 0 411.001 -76.018 0 0 108.009z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "U",
                                "horiz-adv-x": "722",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M73.0034 715.996l144.994 0 0 -387.987c0,-61.6648 1.84477,-101.507 5.33183,-119.685 6.16423,-29.3138 20.6749,-52.9809 43.667,-70.6637 23.1721,-17.8178 54.6682,-26.6592 94.6682,-26.6592 40.4949,0 71.1586,8.32396 91.8335,25.1744 20.6749,16.8279 33.0034,37.3228 37.1654,61.8223 4.16198,24.4994 6.34421,64.9944 6.34421,121.665l0 396.333 144.994 0 0 -376.49c0,-86.0067 -3.82452,-146.839 -11.676,-182.34 -7.82902,-35.5006 -22.1597,-65.4893 -43.1496,-89.9888 -20.8324,-24.4994 -48.8414,-43.847 -83.847,-58.3352 -35.1631,-14.5107 -80.8324,-21.8448 -137.323,-21.8448 -68.1665,0 -119.843,7.82902 -155.006,23.667 -35.1631,15.838 -62.9921,36.333 -83.5096,61.6648 -20.4949,25.3318 -33.8358,51.676 -40.315,79.5051 -9.51631,40.9899 -14.1732,101.665 -14.1732,181.822l0 382.34z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "D",
                                "horiz-adv-x": "722",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M73.0034 715.996l263.667 0c59.5051,0 104.837,-4.49944 135.996,-13.6558 41.8448,-12.3285 77.8403,-34.3307 107.672,-66.0067 29.9888,-31.4961 52.6659,-70.1687 68.324,-115.996 15.5006,-45.6693 23.3296,-102.16 23.3296,-169.179 0,-58.9876 -7.33408,-109.651 -21.9798,-152.328 -17.8403,-52.171 -43.3521,-94.3307 -76.5129,-126.502 -24.9944,-24.4994 -58.8301,-43.4871 -101.327,-57.1654 -31.8335,-10.1687 -74.3307,-15.1631 -127.672,-15.1631l-271.496 0 0 715.996zm144.994 -120.99l0 -474.016 107.492 0c40.18,0 69.1789,2.33971 87.0191,6.83915 23.4871,5.82677 42.8346,15.838 58.1552,29.8313 15.5006,14.0157 28.009,37.0079 37.6603,68.9989 9.85377,32.0135 14.6682,75.838 14.6682,131.181 0,55.3206 -4.8144,97.6603 -14.6682,127.334 -9.65129,29.6513 -23.3296,52.6659 -40.8324,69.3363 -17.4803,16.4904 -39.6625,27.829 -66.6592,33.6558 -20,4.49944 -59.5051,6.83915 -118.155,6.83915l-64.6794 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "3",
                                "horiz-adv-x": "556",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M37.9978 189.831l133.003 16.1755c4.16198,-34.0157 15.5006,-60 33.9933,-77.9978 18.5152,-17.9978 40.8324,-27.0191 66.9966,-27.0191 28.1665,0 51.8335,10.8436 71.1811,32.351 19.1676,21.4848 28.8189,50.4837 28.8189,87.1541 0,34.5107 -9.15636,62.0022 -27.649,82.1822 -18.5152,20.1575 -41.0124,30.3262 -67.6715,30.3262 -17.5028,0 -38.3352,-3.50956 -62.6772,-10.3262l15.1631 111.316c37.0079,-0.989876 65.1744,7.1766 84.6794,24.342 19.5051,17.0079 29.1564,39.8425 29.1564,68.324 0,24.1845 -7.15411,43.3521 -21.4848,57.8403 -14.3307,14.3307 -33.3408,21.5073 -57.1654,21.5073 -23.5096,0 -43.5096,-8.16648 -60,-24.4994 -16.6704,-16.333 -26.6817,-40.18 -30.3487,-71.4961l-125.984 21.4848c8.8189,43.667 22.0022,78.5152 39.82,104.679 17.6603,25.9843 42.4972,46.5017 74.1732,61.4848 31.6535,14.8481 67.3341,22.3397 106.659,22.3397 67.3341,0 121.35,-21.5073 162.002,-64.6569 33.4983,-35.3431 50.3262,-75.3431 50.3262,-119.843 0,-62.9921 -34.3307,-113.498 -103.15,-151.001 40.9899,-8.84139 73.6558,-28.5039 98.3352,-59.1676 24.4994,-30.6637 36.8279,-67.6715 36.8279,-111.001 0,-62.8346 -22.9921,-116.49 -68.8414,-160.832 -45.8268,-44.342 -102.835,-66.5017 -171.159,-66.5017 -64.6794,0 -118.335,18.6727 -160.832,56.1755 -42.6772,37.3228 -67.3341,86.1642 -74.1732,146.659z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: '"',
                                "horiz-adv-x": "474",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M80.8324 462.002l-25.8268 133.161 0 120.832 148.999 0 0 -120.832 -22.3397 -133.161 -100.832 0zm220.99 0l-25.8268 133.161 0 120.832 148.999 0 0 -120.832 -22.3172 -133.161 -100.855 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xfc",
                                "horiz-adv-x": "610",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M415.006 0l0 77.6603c-19.0101,-27.649 -43.847,-49.6513 -74.6682,-66.1642 -30.8436,-16.333 -63.3296,-24.4994 -97.5028,-24.4994 -35.0056,0 -66.3442,7.67154 -93.9933,23.0146 -27.8515,15.3206 -47.8515,36.9854 -60.18,64.6569 -12.4859,27.829 -18.6502,66.1642 -18.6502,115.163l0 329.179 136.985 0 0 -239.01c0,-73.1609 2.49719,-117.84 7.67154,-134.331 4.99438,-16.5129 14.1732,-29.6738 27.6715,-39.1676 13.3183,-9.67379 30.3262,-14.5107 51.0011,-14.5107 23.4871,0 44.4994,6.50169 63.1496,19.3476 18.6727,12.8234 31.3386,28.8189 38.1777,47.9865 6.83915,19.1676 10.3262,65.8493 10.3262,140.337l0 219.348 137.008 0 0 -519.01 -126.997 0zm-267.514 586.007l0 117.998 117.998 0 0 -117.998 -117.998 0zm210.506 0l0 117.998 117.998 0 0 -117.998 -117.998 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xeb",
                                "horiz-adv-x": "556",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M371.991 164.004l137.008 -23.0146c-17.5028,-50.1462 -45.3318,-88.324 -83.1721,-114.646 -37.9978,-26.1867 -85.4893,-39.3476 -142.317,-39.3476 -90.1687,0 -157.008,29.4938 -200.18,88.5039 -34.1732,47.3341 -51.3386,106.997 -51.3386,179.168 0,86.0067 22.5197,153.498 67.3341,202.16 44.8369,48.8414 101.665,73.1834 170.349,73.1834 76.9854,0 137.818,-25.5118 182.497,-76.5129 44.4994,-51.0011 65.8268,-129.156 63.8245,-234.488l-342.992 0c0.989876,-40.6749 11.991,-72.351 33.1609,-95.0056 21.0124,-22.6772 47.3341,-33.9933 78.6727,-33.9933 21.5073,0 39.5051,5.82677 53.9933,17.4803 14.6682,11.676 25.6693,30.5062 33.1609,56.5129zm8.009 138.988c-0.989876,39.8425 -11.1586,70.1687 -30.6637,90.8436 -19.5051,20.8324 -43.1721,31.1586 -71.1586,31.1586 -29.8538,0 -54.5107,-11.0011 -74.0157,-32.8234 -19.5051,-21.8448 -28.9989,-51.676 -28.6614,-89.1789l204.499 0zm-266.997 283.015l0 117.998 117.998 0 0 -117.998 -117.998 0zm210.506 0l0 117.998 117.998 0 0 -117.998 -117.998 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xda",
                                "horiz-adv-x": "722",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M73.0034 715.996l144.994 0 0 -387.987c0,-61.6648 1.84477,-101.507 5.33183,-119.685 6.16423,-29.3138 20.6749,-52.9809 43.667,-70.6637 23.1721,-17.8178 54.6682,-26.6592 94.6682,-26.6592 40.4949,0 71.1586,8.32396 91.8335,25.1744 20.6749,16.8279 33.0034,37.3228 37.1654,61.8223 4.16198,24.4994 6.34421,64.9944 6.34421,121.665l0 396.333 144.994 0 0 -376.49c0,-86.0067 -3.82452,-146.839 -11.676,-182.34 -7.82902,-35.5006 -22.1597,-65.4893 -43.1496,-89.9888 -20.8324,-24.4994 -48.8414,-43.847 -83.847,-58.3352 -35.1631,-14.5107 -80.8324,-21.8448 -137.323,-21.8448 -68.1665,0 -119.843,7.82902 -155.006,23.667 -35.1631,15.838 -62.9921,36.333 -83.5096,61.6648 -20.4949,25.3318 -33.8358,51.676 -40.315,79.5051 -9.51631,40.9899 -14.1732,101.665 -14.1732,181.822l0 382.34zm202.992 64.9944l68.009 146.007 153.003 0 -135.006 -146.007 -86.0067 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xc9",
                                "horiz-adv-x": "666",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M73.0034 0l0 715.996 529.989 0 0 -120.99 -384.994 0 0 -159.01 357.998 0 0 -120.99 -357.998 0 0 -194.016 399.01 0 0 -120.99 -544.004 0zm197.008 780.99l67.9865 146.007 153.003 0 -135.006 -146.007 -85.9843 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xb8",
                                "horiz-adv-x": "333",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M18.4927 -197.008l0 57.3453c33.6783,-3.50956 64.4994,-5.33183 92.6659,-5.33183 28.9989,0 50.6637,5.15186 64.6794,15.658 10.8211,7.82902 16.153,17.8403 16.153,30.3262 0,11.0011 -4.99438,20.6749 -15.1631,28.8414 -10.1687,8.16648 -25.8268,12.171 -46.9966,12.171 -20.9899,0 -42.3397,-3.32958 -64.342,-9.83127l12.8459 48.5039c25.3318,8.99888 52.6659,13.3183 82.0022,13.3183 40.8324,0 71.6535,-8.99888 92.8234,-26.8166 21.1699,-18.0202 31.8335,-39.8425 31.8335,-65.5118 0,-28.8414 -11.6535,-51.991 -35.1631,-69.9888 -31.6535,-24.4994 -77.0079,-36.6704 -135.996,-36.6704 -42.0022,0 -73.8358,2.65467 -95.3431,7.9865z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xa7",
                                "horiz-adv-x": "556",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M480.99 564.004l-133.993 -13.9933c-1.32733,23.982 -8.32396,42.3172 -20.9899,54.9831 -12.6659,12.6659 -30.3487,19.0101 -52.8459,19.0101 -20.8324,0 -36.8279,-4.67942 -47.829,-13.8358 -10.8211,-9.17885 -16.333,-19.5051 -16.333,-31.1586 0,-16.018 7.49156,-31.1811 22.3397,-45.8493 9.98875,-9.83127 43.1721,-33.0034 99.5051,-69.4938 56.153,-36.4904 93.4983,-62.4972 111.496,-78.1777 28.1665,-23.667 48.324,-47.3116 60.4949,-70.4837 12.171,-23.3296 18.1552,-49.1789 18.1552,-77.5028 0,-30.3262 -7.33408,-58.1777 -22.1597,-83.847 -14.8256,-25.4893 -37.0079,-48.6614 -66.6592,-69.4938 19.82,-18.3352 34.4882,-37.8178 44.162,-58.4927 9.83127,-20.6749 14.6682,-42.4972 14.6682,-65.6693 0,-48.1665 -17.9978,-88.5039 -54.1732,-121.17 -35.9955,-32.4859 -87.829,-48.8414 -155.501,-48.8414 -64.9944,0 -116.985,16.1755 -155.996,48.3465 -39.1676,32.171 -62.1597,75.0056 -69.3363,128.661l134.016 15.9955c5.82677,-29.1564 16.8279,-51.1586 33.1609,-65.8268 16.333,-14.8256 36.9854,-22.1597 62.0022,-22.1597 21.3273,0 38.3352,5.66929 50.8211,16.8279 12.6659,11.3386 19.0101,24.8369 19.0101,40.8324 0,15.3431 -6.00675,28.9989 -17.9978,40.9899 -12.351,12.171 -55.5006,41.8448 -129.674,89.1789 -74.1732,47.4916 -122.34,86.8391 -144.837,117.998 -22.3397,31.3386 -33.4983,66.3442 -33.4983,104.994 0,32.0135 7.33408,61.6648 22.1597,88.9989 14.8481,27.3341 37.6828,49.8313 68.9989,67.5141 -16.333,17.5028 -28.4814,35.3206 -36.8279,53.6558 -8.16648,18.1777 -12.3285,36.8279 -12.3285,55.6805 0,43.982 17.1654,81.1474 51.3386,111.654 34.1507,30.5062 82.3172,45.6693 144.162,45.6693 63.5096,0 113.498,-15.3431 149.989,-45.8268 36.5129,-30.5062 58.0202,-70.1687 64.4994,-119.168zm-122.317 -420.337c14.3307,13.1609 24.9944,25.4893 31.8335,37.5028 6.99663,11.8335 10.4837,23.3296 10.4837,34.3307 0,10.8436 -3.66704,21.8223 -11.1586,33.3408 -7.49156,11.3161 -27.829,29.1564 -61.3273,53.6558l-132.666 96.6704c-11.0011,-6.50169 -20.6749,-15.658 -29.1789,-27.829 -8.48144,-12.0135 -12.6659,-24.8369 -12.6659,-38.5152 0,-32.9809 21.8448,-64.162 65.6693,-93.8133l139.01 -95.3431z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\x96",
                                "horiz-adv-x": "750",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M124.994 0l0 624.994 500 0 0 -624.994 -500 0zm15.9955 15.9955l468.009 0 0 593.003 -468.009 0 0 -593.003z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\x85",
                                "horiz-adv-x": "750",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M124.994 0l0 624.994 500 0 0 -624.994 -500 0zm15.9955 15.9955l468.009 0 0 593.003 -468.009 0 0 -593.003z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "t",
                                "horiz-adv-x": "333",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M308.999 519.01l0 -108.999 -93.9933 0 0 -210.169c0,-42.6772 0.832396,-67.5141 2.65467,-74.5107 1.84477,-6.99663 5.84927,-12.8234 12.351,-17.5028 6.32171,-4.49944 13.9933,-6.83915 23.1496,-6.83915 12.8459,0 31.1811,4.34196 55.3431,13.1834l11.4961 -106.682c-31.8335,-13.6558 -67.829,-20.4949 -108.166,-20.4949 -24.6569,0 -46.8391,4.16198 -66.6592,12.5084 -19.8425,8.32396 -34.3307,19.1676 -43.5096,32.3285 -9.33633,13.3408 -15.658,31.1586 -19.3251,53.8358 -2.83465,15.9955 -4.34196,48.324 -4.34196,97.1654l0 227.177 -62.9921 0 0 108.999 62.9921 0 0 102.992 137.008 80.9899 0 -183.982 93.9933 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "c",
                                "horiz-adv-x": "556",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M524.004 364.994l-135.006 -24.0045c-4.49944,26.8391 -14.8256,47.0191 -31.0011,60.6749 -16.1755,13.4983 -37.0079,20.3375 -62.6547,20.3375 -34.1732,0 -61.5073,-11.8335 -81.8448,-35.5006 -20.3375,-23.667 -30.5062,-63.1721 -30.5062,-118.673 0,-61.6648 10.3487,-105.152 31.0011,-130.664 20.6749,-25.4893 48.3465,-38.1552 83.0146,-38.1552 25.9843,0 47.3341,7.49156 63.8245,22.3172 16.6704,14.8481 28.324,40.3375 35.1631,76.6704l135.006 -22.9921c-13.9933,-62.0022 -40.8324,-108.841 -80.4949,-140.495 -39.6625,-31.676 -92.8459,-47.5141 -159.663,-47.5141 -75.6805,0 -136.175,24.0045 -181.17,71.8335 -45.1744,48.009 -67.6715,114.331 -67.6715,199.168 0,85.8268 22.6547,152.508 67.829,200.337 45.1744,47.829 106.344,71.676 183.51,71.676 62.9921,0 113.161,-13.6783 150.484,-40.8549 37.1654,-27.1541 63.847,-68.4814 80.18,-124.162z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "R",
                                "horiz-adv-x": "722",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M73.0034 0l0 715.996 304.499 0c76.4904,0 132.171,-6.50169 166.839,-19.3251 34.8256,-12.8459 62.4972,-35.6805 83.3296,-68.5039 20.8324,-33.0034 31.3386,-70.5062 31.3386,-112.823 0,-53.8358 -15.6805,-98.1777 -47.1766,-133.183 -31.4961,-34.9831 -78.4927,-56.9854 -141.17,-66.1642 31.1586,-18.1552 56.8279,-38.1552 77.0079,-60 20.3375,-21.8223 47.6715,-60.6524 82.0022,-116.333l87.3341 -139.663 -172.846 0 -103.667 156.333c-37.1654,55.5006 -62.6547,90.5062 -76.4904,104.994 -13.6783,14.3307 -28.1665,24.342 -43.5096,29.6738 -15.5006,5.33183 -39.82,8.009 -73.1609,8.009l-29.3363 0 0 -299.01 -144.994 0zm144.994 413.003l106.997 0c69.3363,0 112.508,2.99213 129.831,8.8189 17.1654,5.84927 30.8436,16.018 40.5174,30.3487 9.83127,14.3307 14.6682,32.3285 14.6682,53.8358 0,24.162 -6.50169,43.4871 -19.3476,58.4927 -12.8234,14.8256 -31.0011,24.162 -54.3307,28.009 -11.8335,1.66479 -46.9966,2.49719 -105.489,2.49719l-112.846 0 0 -182.002z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "A",
                                "horiz-adv-x": "722",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M717.998 0l-156.175 0 -61.8223 162.992 -287.177 0 -59.4826 -162.992 -153.341 0 277.998 715.996 153.161 0 286.839 -715.996zm-264.994 284.004l-99.5051 264.994 -96.6704 -264.994 196.175 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "0",
                                "horiz-adv-x": "556",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M274.511 720c69.3138,0 123.487,-24.8369 162.655,-74.5107 46.5017,-58.6502 69.8313,-156.153 69.8313,-292.148 0,-135.838 -23.4871,-233.498 -70.3262,-292.846 -38.8301,-48.9989 -92.8459,-73.4983 -162.16,-73.4983 -69.6738,0 -125.849,26.8391 -168.504,80.4949 -42.6772,53.6783 -64.0045,149.516 -64.0045,287.177 0,135.163 23.4871,232.508 70.3262,291.834 38.8301,48.9989 92.8459,73.4983 162.182,73.4983zm0 -113.993c-16.333,0 -31.0011,-5.33183 -43.667,-15.9955 -12.8459,-10.5062 -22.8346,-29.5163 -29.8538,-57.0079 -9.31384,-35.5006 -13.9933,-95.5006 -13.9933,-179.663 0,-84.342 4.16198,-142.182 12.5084,-173.678 8.32396,-31.4961 18.8301,-52.4859 31.4961,-62.9921 12.6659,-10.5062 27.1766,-15.6805 43.5096,-15.6805 16.333,0 30.9786,5.35433 43.8245,16.018 12.6659,10.4837 22.6547,29.4938 29.6738,56.9854 9.31384,35.1631 13.9933,95.0056 13.9933,179.348 0,84.162 -4.16198,142.002 -12.5084,173.498 -8.32396,31.4961 -18.8301,52.6659 -31.4961,63.1721 -12.6659,10.6637 -27.1541,15.9955 -43.4871,15.9955z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xf9",
                                "horiz-adv-x": "610",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M415.006 0l0 77.6603c-19.0101,-27.649 -43.847,-49.6513 -74.6682,-66.1642 -30.8436,-16.333 -63.3296,-24.4994 -97.5028,-24.4994 -35.0056,0 -66.3442,7.67154 -93.9933,23.0146 -27.8515,15.3206 -47.8515,36.9854 -60.18,64.6569 -12.4859,27.829 -18.6502,66.1642 -18.6502,115.163l0 329.179 136.985 0 0 -239.01c0,-73.1609 2.49719,-117.84 7.67154,-134.331 4.99438,-16.5129 14.1732,-29.6738 27.6715,-39.1676 13.3183,-9.67379 30.3262,-14.5107 51.0011,-14.5107 23.4871,0 44.4994,6.50169 63.1496,19.3476 18.6727,12.8234 31.3386,28.8189 38.1777,47.9865 6.83915,19.1676 10.3262,65.8493 10.3262,140.337l0 219.348 137.008 0 0 -519.01 -126.997 0zm-21.0124 586.007l-85.9843 0 -135.006 145.984 153.003 0 67.9865 -145.984z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xe8",
                                "horiz-adv-x": "556",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M371.991 164.004l137.008 -23.0146c-17.5028,-50.1462 -45.3318,-88.324 -83.1721,-114.646 -37.9978,-26.1867 -85.4893,-39.3476 -142.317,-39.3476 -90.1687,0 -157.008,29.4938 -200.18,88.5039 -34.1732,47.3341 -51.3386,106.997 -51.3386,179.168 0,86.0067 22.5197,153.498 67.3341,202.16 44.8369,48.8414 101.665,73.1834 170.349,73.1834 76.9854,0 137.818,-25.5118 182.497,-76.5129 44.4994,-51.0011 65.8268,-129.156 63.8245,-234.488l-342.992 0c0.989876,-40.6749 11.991,-72.351 33.1609,-95.0056 21.0124,-22.6772 47.3341,-33.9933 78.6727,-33.9933 21.5073,0 39.5051,5.82677 53.9933,17.4803 14.6682,11.676 25.6693,30.5062 33.1609,56.5129zm8.009 138.988c-0.989876,39.8425 -11.1586,70.1687 -30.6637,90.8436 -19.5051,20.8324 -43.1721,31.1586 -71.1586,31.1586 -29.8538,0 -54.5107,-11.0011 -74.0157,-32.8234 -19.5051,-21.8448 -28.9989,-51.676 -28.6614,-89.1789l204.499 0zm-19.0101 283.015l-85.9843 0 -135.006 145.984 153.003 0 67.9865 -145.984z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xd7",
                                "horiz-adv-x": "584",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M54.5107 204.994l147.829 148.166 -149.336 149.336 91.4961 90.6637 148.661 -148.819 149.336 149.651 87.5141 -89.4938 -148.346 -148.661 149.831 -149.831 -91.0011 -91.0011 -149.651 149.651 -148.346 -148.661 -87.9865 88.9989z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xc6",
                                "horiz-adv-x": "1000",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M-42.0022 0l333.993 715.996 646.007 0 0 -120.99 -353.003 0 0 -159.01 326.007 0 0 -120.99 -326.007 0 0 -194.016 366.997 0 0 -120.99 -511.991 0 0.337458 168.999 -248.166 0 -74.3307 -168.999 -159.843 0zm286.839 293.993l195.658 0 0.494938 314.016 -55.9955 0 -140.157 -314.016z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xb5",
                                "horiz-adv-x": "576",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M53.9933 519.01l137.008 0 0 -235.186c0,-67.829 6.83915,-113.993 20.4949,-138.335 17.1654,-31.6535 42.4972,-47.4916 76.333,-47.4916 18.1777,0 35.3431,5.82677 51.4961,17.6603 16.1755,11.676 28.1665,28.009 36.018,48.8414 7.82902,20.8324 11.6535,60.1575 11.6535,117.84l0 236.67 139.01 0 0 -519.01 -128.999 0 0 62.3397c-9.67379,-18.1777 -18.8301,-32.0135 -27.6715,-41.0124 -8.66142,-9.15636 -20.3375,-17.1654 -35.1631,-24.0045 -14.6682,-6.81665 -28.1665,-10.3262 -40.3375,-10.3262 -22.9921,0 -43.3296,6.34421 -61.1699,19.1676 -12.5084,9.33633 -26.5017,28.1665 -41.6648,56.1755l0 -261.35 -137.008 0 0 718.02z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xa4",
                                "horiz-adv-x": "556",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M86.0067 460l-64.0045 62.9921 80.9899 88.009 66.0067 -66.9966c17.3453,9.49381 34.8256,16.4904 52.6659,21.1699 17.8403,4.49944 35.838,6.81665 54.1732,6.81665 18.4927,0 36.8279,-2.31721 54.8256,-6.81665 17.8403,-4.67942 35.3431,-11.676 52.3285,-21.1699l66.0067 66.0067 81.0124 -83.0146 -64.0045 -64.9944c8.99888,-16.6704 15.8155,-33.8358 20.3375,-51.4961 4.49944,-17.8403 6.65917,-36.1755 6.65917,-55.0056 0,-18.4927 -2.15973,-36.6704 -6.65917,-54.5107 -4.52193,-17.6603 -11.3386,-34.9831 -20.3375,-51.991l64.9944 -64.9944 -80.9899 -84.0045 -67.0191 66.9966c-16.333,-9.15636 -33.3183,-16.153 -51.0011,-20.8324 -17.8178,-4.8369 -36.333,-7.15411 -55.5006,-7.15411 -18.1552,0 -36.153,2.31721 -53.6558,6.81665 -17.6603,4.49944 -34.8256,11.1811 -51.8335,20.18l-62.9921 -64.0045 -84.0045 82.0022 64.0045 64.9944c-9.17885,17.0079 -16.1755,34.3307 -20.8324,52.171 -4.8369,17.8403 -7.1766,35.9955 -7.1766,54.4882 0,18.6727 2.15973,36.6704 6.50169,54.1732 4.34196,17.5028 10.8211,34.1732 19.5051,50.1687zm91.991 -104.499c0,-27.3341 9.67379,-50.5062 28.9989,-69.6738 19.3476,-19.1676 42.4972,-28.8189 69.4938,-28.8189 27.3341,0 50.5062,9.65129 69.6738,28.8189 19.1676,19.1676 28.8414,42.3397 28.8414,69.6738 0,27.3341 -9.67379,50.5062 -28.8414,69.6738 -19.1676,19.1676 -42.3397,28.8189 -69.6738,28.8189 -27.3341,0 -50.4837,-9.65129 -69.6513,-28.8189 -19.1676,-19.1676 -28.8414,-42.3397 -28.8414,-69.6738z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\x93",
                                "horiz-adv-x": "750",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M124.994 0l0 624.994 500 0 0 -624.994 -500 0zm15.9955 15.9955l468.009 0 0 593.003 -468.009 0 0 -593.003z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\x82",
                                "horiz-adv-x": "750",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M124.994 0l0 624.994 500 0 0 -624.994 -500 0zm15.9955 15.9955l468.009 0 0 593.003 -468.009 0 0 -593.003z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "q",
                                "horiz-adv-x": "610",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M411.001 -197.008l0 259.168c-17.9978,-22.9921 -40.3375,-41.3273 -66.9966,-54.8256 -26.8391,-13.4983 -55.6805,-20.3375 -86.6817,-20.3375 -58.9876,0 -107.649,22.1597 -145.827,66.5017 -44.9944,51.8335 -67.4916,122.16 -67.4916,210.844 0,83.4871 21.1699,148.661 63.3296,195.501 42.3397,46.8166 94.8256,70.1687 157.503,70.1687 34.6682,0 64.4994,-7.1766 89.8313,-21.6873 25.3318,-14.3307 47.829,-36.333 67.3341,-65.9843l0 76.6704 126.007 0 0 -716.018 -137.008 0zm4.0045 461.845c0,53.3408 -10.8436,93.1609 -32.3285,119.168 -21.6873,26.0067 -48.6839,38.9876 -81.1699,38.9876 -33.1834,0 -60.8324,-13.3183 -83.1721,-39.82 -22.1597,-26.5017 -33.3408,-68.5039 -33.3408,-126.164 0,-57.1654 10.6637,-98.5152 32.171,-124.004 21.5073,-25.3318 48.009,-37.9978 79.5051,-37.9978 31.4961,0 58.9876,14.1507 82.8346,42.6547 23.667,28.5039 35.5006,71.0011 35.5006,127.177z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "`",
                                "horiz-adv-x": "333",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M242.002 582.002l-86.0067 0 -135.006 146.007 153.003 0 68.009 -146.007z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "O",
                                "horiz-adv-x": "777",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M42.9921 353.656c0,73.0034 11.0011,134.353 32.8459,184.004 16.153,36.5129 38.4927,69.3363 66.6592,98.3352 28.1665,28.9989 59.0101,50.5062 92.5084,64.6794 44.6569,18.8301 96.153,28.324 154.488,28.324 105.669,0 190.011,-32.8234 253.498,-98.3352 63.3521,-65.6693 95.0056,-156.828 95.0056,-273.656 0,-115.838 -31.4961,-206.502 -94.3307,-271.834 -62.8346,-65.5118 -146.997,-98.1777 -252.171,-98.1777 -106.502,0 -191.339,32.5084 -254.173,97.6603 -62.8121,65.0169 -94.3307,154.668 -94.3307,268.999zm148.999 4.8369c0,-81.1699 18.8526,-142.655 56.333,-184.657 37.5028,-41.8448 85.1744,-62.8346 142.835,-62.8346 57.8403,0 105.174,20.8324 142.34,62.3397 37.0079,41.6648 55.5006,103.982 55.5006,187.154 0,82.1822 -17.9978,143.51 -54.1732,183.847 -35.9955,40.4949 -83.8245,60.6524 -143.667,60.6524 -59.6625,0 -107.829,-20.4949 -144.319,-61.3273 -36.5129,-40.9899 -54.8481,-102.677 -54.8481,-185.174z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: ">",
                                "horiz-adv-x": "584",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M46.0067 80.9899l0 138.02 342.497 135.163 -342.497 133.836 0 136.985 491.001 -212.666 0 -117.323 -491.001 -214.016z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "-",
                                "horiz-adv-x": "333",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M55.9955 191.001l0 137.008 270.011 0 0 -137.008 -270.011 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xf6",
                                "horiz-adv-x": "610",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M40 265.827c0,45.6693 11.1586,89.8313 33.6558,132.508 22.5197,42.8346 54.3532,75.3206 95.5006,97.8403 41.1699,22.4972 87.0191,33.8358 137.84,33.8358 78.4927,0 142.677,-25.5118 192.846,-76.5129 50.1687,-51.1586 75.1631,-115.501 75.1631,-193.498 0,-78.6727 -25.3318,-143.825 -75.838,-195.501 -50.6637,-51.676 -114.331,-77.5028 -191.159,-77.5028 -47.5141,0 -92.8459,10.8436 -136.018,32.3285 -42.9921,21.5073 -75.8155,53.0034 -98.3352,94.6682 -22.4972,41.5073 -33.6558,92.171 -33.6558,151.834zm140.99 -7.33408c0,-51.4961 12.171,-91.0011 36.5129,-118.335 24.4994,-27.4916 54.4882,-41.1474 90.3262,-41.1474 35.6805,0 65.6693,13.6558 89.8313,41.1474 24.162,27.3341 36.333,67.1766 36.333,119.348 0,50.8211 -12.171,89.9888 -36.333,117.323 -24.162,27.5141 -54.1507,41.1699 -89.8313,41.1699 -35.838,0 -65.8268,-13.6558 -90.3262,-41.1699 -24.342,-27.3341 -36.5129,-66.8166 -36.5129,-118.335zm-34.4882 327.514l0 117.998 117.998 0 0 -117.998 -117.998 0zm210.506 0l0 117.998 117.998 0 0 -117.998 -117.998 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xe5",
                                "horiz-adv-x": "556",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M173.993 359.01l-123.982 21.9798c13.9933,50.6862 38.1552,88.1665 72.3285,112.508 34.1507,24.342 84.9944,36.5129 152.328,36.5129 61.1699,0 106.839,-7.1766 136.828,-21.6873 29.8313,-14.4882 51.0011,-32.8234 63.1721,-55.1631 12.171,-22.3172 18.3352,-63.1496 18.3352,-122.835l-2.00225 -160c0,-45.4893 2.15973,-79.1676 6.50169,-100.832 4.31946,-21.6648 12.5084,-44.8369 24.4994,-69.4938l-135.996 0c-3.50956,8.99888 -8.009,22.3397 -13.1834,40 -2.15973,8.16648 -3.82452,13.4983 -4.8144,15.9955 -23.3521,-22.9921 -48.3465,-40.1575 -75.0056,-51.6535 -26.6592,-11.5186 -55.0056,-17.3453 -85.1744,-17.3453 -53.1609,0 -95.1631,14.5107 -125.827,43.5096 -30.6637,28.8189 -46.0067,65.4893 -46.0067,109.831 0,29.1564 6.99663,55.3206 21.0124,78.3352 13.9933,22.8346 33.4983,40.4949 58.8301,52.6659 25.1519,12.171 61.4848,22.8346 108.999,31.991 64.0045,12.0135 108.504,23.3296 133.161,33.6783l0 13.8358c0,26.6592 -6.50169,45.6468 -19.5051,57.1654 -13.1609,11.3161 -37.8178,16.9854 -73.9933,16.9854 -24.4994,0 -43.5096,-4.8369 -57.1654,-14.6682 -13.8358,-9.65129 -24.8369,-26.8166 -33.3408,-51.3161zm184.004 -111.001c-17.5028,-5.84927 -45.3318,-12.8459 -83.4871,-21.0124 -38.0202,-8.16648 -63.0146,-16.153 -74.6682,-23.8245 -17.8403,-12.8459 -26.8391,-28.8414 -26.8391,-48.3465 0,-19.3251 7.15411,-35.8155 21.5073,-49.8313 14.3307,-13.9933 32.4859,-20.9899 54.6457,-20.9899 24.6794,0 48.3465,8.16648 70.8436,24.3195 16.4904,12.5084 27.4916,27.5141 32.6659,45.5118 3.50956,11.6535 5.33183,33.9933 5.33183,66.8391l0 27.3341zm13.9933 432.981c0,-26.1642 -9.31384,-48.4814 -27.829,-67.1541 -18.6727,-18.4927 -40.9899,-27.829 -67.1541,-27.829 -26.1642,0 -48.5039,9.33633 -67.1766,27.829 -18.4927,18.6727 -27.829,40.9899 -27.829,67.1541 0,26.1867 9.33633,48.5039 27.829,67.1766 18.6727,18.4927 41.0124,27.829 67.1766,27.829 26.1642,0 48.4814,-9.15636 67.1541,-27.6715 18.5152,-18.3127 27.829,-40.8324 27.829,-67.3341zm-51.991 0c0,12.0135 -4.16198,22.0022 -12.5084,30.5062 -8.48144,8.34646 -18.4927,12.5084 -30.4837,12.5084 -11.8335,0 -22.0022,-4.16198 -30.5062,-12.5084 -8.32396,-8.50394 -12.5084,-18.4927 -12.5084,-30.5062 0,-11.8335 4.18448,-21.9798 12.5084,-30.4837 8.50394,-8.34646 18.6727,-12.5084 30.5062,-12.5084 11.991,0 22.0022,4.16198 30.4837,12.5084 8.34646,8.50394 12.5084,18.6502 12.5084,30.4837z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xd4",
                                "horiz-adv-x": "777",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M42.9921 353.656c0,73.0034 11.0011,134.353 32.8459,184.004 16.153,36.5129 38.4927,69.3363 66.6592,98.3352 28.1665,28.9989 59.0101,50.5062 92.5084,64.6794 44.6569,18.8301 96.153,28.324 154.488,28.324 105.669,0 190.011,-32.8234 253.498,-98.3352 63.3521,-65.6693 95.0056,-156.828 95.0056,-273.656 0,-115.838 -31.4961,-206.502 -94.3307,-271.834 -62.8346,-65.5118 -146.997,-98.1777 -252.171,-98.1777 -106.502,0 -191.339,32.5084 -254.173,97.6603 -62.8121,65.0169 -94.3307,154.668 -94.3307,268.999zm148.999 4.8369c0,-81.1699 18.8526,-142.655 56.333,-184.657 37.5028,-41.8448 85.1744,-62.8346 142.835,-62.8346 57.8403,0 105.174,20.8324 142.34,62.3397 37.0079,41.6648 55.5006,103.982 55.5006,187.154 0,82.1822 -17.9978,143.51 -54.1732,183.847 -35.9955,40.4949 -83.8245,60.6524 -143.667,60.6524 -59.6625,0 -107.829,-20.4949 -144.319,-61.3273 -36.5129,-40.9899 -54.8481,-102.677 -54.8481,-185.174zm35.0056 422.497l102.497 144.004 126.344 0 101.17 -144.004 -110.011 0 -56.4904 73.0034 -52.5084 -73.0034 -111.001 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xc3",
                                "horiz-adv-x": "722",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M717.998 0l-156.175 0 -61.8223 162.992 -287.177 0 -59.4826 -162.992 -153.341 0 277.998 715.996 153.161 0 286.839 -715.996zm-264.994 284.004l-99.5051 264.994 -96.6704 -264.994 196.175 0zm-197.008 495.996l-62.9921 0c-0.337458,7.49156 -0.494938,13.3408 -0.494938,17.5028 0,34.1732 8.32396,60.4949 24.9944,78.8301 16.4904,18.4927 37.9978,27.6715 64.0045,27.6715 11.4961,0 22.0022,-1.16985 31.8335,-3.66704 9.83127,-2.49719 27.649,-9.49381 53.4983,-21.0124 25.9843,-11.4961 46.1642,-17.3228 60.9899,-17.3228 10.3487,0 19.0101,3.32958 26.0067,9.83127 7.15411,6.65917 11.4961,17.6603 13.4983,33.1609l62.9921 0c-0.314961,-44.4994 -8.50394,-76.153 -24.4994,-95.3206 -16.153,-19.1676 -36.8279,-28.6839 -62.1597,-28.6839 -11.1586,0 -22.0022,1.16985 -32.6659,3.50956 -7.49156,2.00225 -26.1642,8.99888 -55.9955,20.8324 -30.0112,11.8335 -51.676,17.6603 -65.3318,17.6603 -10.5062,0 -18.5152,-3.14961 -24.342,-9.65129 -6.00675,-6.34421 -8.99888,-17.5028 -9.33633,-33.3408z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xb2",
                                "horiz-adv-x": "333",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M308.999 433.003l0 -77.9978 -297.008 0c3.66704,27.6715 12.5084,52.4859 26.6817,74.3307 14.1507,21.8223 45.8268,51.991 95.1631,90.8211 37.1654,28.9989 59.5051,48.1665 66.9966,57.6828 10.1687,12.3285 15.1631,24.8369 15.1631,37.6603 0,11.991 -4.16198,21.6648 -12.3285,28.8414 -8.16648,7.15411 -20.4949,10.6637 -37.1654,10.6637 -16.6704,0 -29.1789,-4.0045 -37.3453,-12.0135 -8.16648,-7.82902 -13.1609,-22.4972 -15.1631,-43.982l-91.991 7.82902c4.8369,37.9978 17.1654,65.8268 36.6704,83.4871 25.9843,23.1721 62.8346,34.6682 110.484,34.6682 45.3543,0 80,-10.3262 103.847,-31.1586 24.0045,-20.8324 35.9955,-45.3318 35.9955,-73.6783 0,-17.4803 -3.82452,-34.1507 -11.3386,-49.9888 -7.49156,-15.658 -19.3251,-31.991 -35.658,-48.9989 -8.50394,-8.34646 -30.5062,-26.5017 -66.0067,-54.5107 -18.9876,-14.6682 -32.4859,-25.8268 -40.6524,-33.6558l153.656 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xa1",
                                "horiz-adv-x": "333",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M237.323 519.01l0 -137.008 -136.985 0 0 137.008 136.985 0zm-29.6513 -187.019l35.658 -362.655 0 -168.346 -147.987 0 0 168.346 35.5006 362.655 76.8279 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\x90",
                                "horiz-adv-x": "750",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M124.994 0l0 624.994 500 0 0 -624.994 -500 0zm15.9955 15.9955l468.009 0 0 593.003 -468.009 0 0 -593.003z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\x7f",
                                "horiz-adv-x": "750",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M124.994 0l0 624.994 500 0 0 -624.994 -500 0zm15.9955 15.9955l468.009 0 0 593.003 -468.009 0 0 -593.003z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "n",
                                "horiz-adv-x": "610",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M544.004 0l-137.008 0 0 264.499c0,55.9955 -2.99213,92.171 -8.8189,108.504 -6.00675,16.4904 -15.5006,29.1564 -28.8414,38.3352 -13.3408,9.15636 -29.3363,13.6558 -48.009,13.6558 -24.0045,0 -45.4893,-6.50169 -64.4994,-19.5051 -19.1676,-12.9809 -32.171,-30.3262 -39.1676,-51.6535 -7.15411,-21.5073 -10.6637,-61.1699 -10.6637,-119.168l0 -234.668 -136.985 0 0 519.01 126.997 0 0 -76.1755c45.4893,58.1552 102.655,87.1766 171.834,87.1766 30.3262,0 58.1552,-5.51181 83.3296,-16.3555 25.3318,-10.9786 44.3195,-24.8144 57.1654,-41.6648 13.0034,-16.9854 22.0022,-36.153 26.9966,-57.6603 5.17435,-21.5073 7.67154,-52.171 7.67154,-92.171l0 -322.16z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "]",
                                "horiz-adv-x": "333",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M260.99 715.996l0 -917.998 -242.992 0 0 108.009 113.003 0 0 702.992 -113.003 0 0 106.997 242.992 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "L",
                                "horiz-adv-x": "610",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M77.0079 0l0 710.011 144.994 0 0 -589.021 358.988 0 0 -120.99 -503.982 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: ";",
                                "horiz-adv-x": "333",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M93.9933 382.002l0 137.008 137.008 0 0 -137.008 -137.008 0zm0 -244.994l137.008 0 0 -98.1777c0,-39.6625 -3.32958,-71.1586 -10.1687,-93.9933 -6.83915,-23.0146 -19.8425,-43.667 -38.8301,-61.8448 -19.0101,-18.3352 -43.1721,-32.4859 -72.3285,-42.9921l-26.6817 57.0079c27.5141,9.15636 47.0191,21.8223 58.6727,37.9978 11.4961,16.333 17.6603,37.9978 18.3352,64.9944l-66.0067 0 0 137.008z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "*",
                                "horiz-adv-x": "389",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M119.505 386.007l-73.4983 57.5028c23.4871,26.5017 47.829,51.6535 73.1609,75.8155 10.1687,9.83127 16.4904,16.018 19.0101,18.6727 -8.009,1.32733 -31.3386,6.65917 -69.6738,15.9955 -27.5141,6.83915 -45.6693,11.8335 -54.5107,15.0056l29.5163 86.0067c42.1597,-17.1654 80,-36.1755 113.161,-57.0079 -7.82902,53.1609 -11.676,96.5129 -11.676,130.011l86.0067 0c0,-23.847 -4.34196,-67.6715 -13.1609,-131.181 6.50169,2.49719 20.4949,8.84139 41.8223,19.0101 29.3363,13.3183 56.1755,24.6569 80.8324,34.1732l25.5118 -88.009c-35.9955,-8.16648 -77.5028,-16.1755 -124.837,-24.0045l58.1552 -66.5017c11.676,-13.4983 20.8324,-24.4994 27.6715,-33.0034l-74.4882 -49.4938 -65.0169 109.831c-19.6625,-35.3206 -42.3172,-73.0034 -67.9865,-112.823z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xf3",
                                "horiz-adv-x": "610",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M40 265.827c0,45.6693 11.1586,89.8313 33.6558,132.508 22.5197,42.8346 54.3532,75.3206 95.5006,97.8403 41.1699,22.4972 87.0191,33.8358 137.84,33.8358 78.4927,0 142.677,-25.5118 192.846,-76.5129 50.1687,-51.1586 75.1631,-115.501 75.1631,-193.498 0,-78.6727 -25.3318,-143.825 -75.838,-195.501 -50.6637,-51.676 -114.331,-77.5028 -191.159,-77.5028 -47.5141,0 -92.8459,10.8436 -136.018,32.3285 -42.9921,21.5073 -75.8155,53.0034 -98.3352,94.6682 -22.4972,41.5073 -33.6558,92.171 -33.6558,151.834zm140.99 -7.33408c0,-51.4961 12.171,-91.0011 36.5129,-118.335 24.4994,-27.4916 54.4882,-41.1474 90.3262,-41.1474 35.6805,0 65.6693,13.6558 89.8313,41.1474 24.162,27.3341 36.333,67.1766 36.333,119.348 0,50.8211 -12.171,89.9888 -36.333,117.323 -24.162,27.5141 -54.1507,41.1699 -89.8313,41.1699 -35.838,0 -65.8268,-13.6558 -90.3262,-41.1699 -24.342,-27.3341 -36.5129,-66.8166 -36.5129,-118.335zm64.0045 327.514l68.009 145.984 153.003 0 -135.006 -145.984 -86.0067 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xe2",
                                "horiz-adv-x": "556",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M173.993 359.01l-123.982 21.9798c13.9933,50.6862 38.1552,88.1665 72.3285,112.508 34.1507,24.342 84.9944,36.5129 152.328,36.5129 61.1699,0 106.839,-7.1766 136.828,-21.6873 29.8313,-14.4882 51.0011,-32.8234 63.1721,-55.1631 12.171,-22.3172 18.3352,-63.1496 18.3352,-122.835l-2.00225 -160c0,-45.4893 2.15973,-79.1676 6.50169,-100.832 4.31946,-21.6648 12.5084,-44.8369 24.4994,-69.4938l-135.996 0c-3.50956,8.99888 -8.009,22.3397 -13.1834,40 -2.15973,8.16648 -3.82452,13.4983 -4.8144,15.9955 -23.3521,-22.9921 -48.3465,-40.1575 -75.0056,-51.6535 -26.6592,-11.5186 -55.0056,-17.3453 -85.1744,-17.3453 -53.1609,0 -95.1631,14.5107 -125.827,43.5096 -30.6637,28.8189 -46.0067,65.4893 -46.0067,109.831 0,29.1564 6.99663,55.3206 21.0124,78.3352 13.9933,22.8346 33.4983,40.4949 58.8301,52.6659 25.1519,12.171 61.4848,22.8346 108.999,31.991 64.0045,12.0135 108.504,23.3296 133.161,33.6783l0 13.8358c0,26.6592 -6.50169,45.6468 -19.5051,57.1654 -13.1609,11.3161 -37.8178,16.9854 -73.9933,16.9854 -24.4994,0 -43.5096,-4.8369 -57.1654,-14.6682 -13.8358,-9.65129 -24.8369,-26.8166 -33.3408,-51.3161zm184.004 -111.001c-17.5028,-5.84927 -45.3318,-12.8459 -83.4871,-21.0124 -38.0202,-8.16648 -63.0146,-16.153 -74.6682,-23.8245 -17.8403,-12.8459 -26.8391,-28.8414 -26.8391,-48.3465 0,-19.3251 7.15411,-35.8155 21.5073,-49.8313 14.3307,-13.9933 32.4859,-20.9899 54.6457,-20.9899 24.6794,0 48.3465,8.16648 70.8436,24.3195 16.4904,12.5084 27.4916,27.5141 32.6659,45.5118 3.50956,11.6535 5.33183,33.9933 5.33183,66.8391l0 27.3341zm-235.006 337.998l102.497 144.004 126.344 0 101.17 -144.004 -110.011 0 -56.4904 73.0034 -52.5084 -73.0034 -111.001 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xd1",
                                "horiz-adv-x": "722",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M73.0034 0l0 715.996 140.337 0 294.668 -479.82 0 479.82 133.993 0 0 -715.996 -144.837 0 -290.169 470.664 0 -470.664 -133.993 0zm160.652 780l-62.9921 0c-0.337458,7.49156 -0.494938,13.3408 -0.494938,17.5028 0,34.1732 8.32396,60.4949 24.9944,78.8301 16.5129,18.4927 37.8403,27.6715 64.0045,27.6715 11.3386,0 22.0022,-1.16985 31.8335,-3.66704 9.67379,-2.49719 27.6715,-9.49381 53.4983,-21.0124 26.0067,-11.4961 46.1642,-17.3228 60.8324,-17.3228 10.5062,0 19.1676,3.32958 26.1642,9.83127 6.99663,6.65917 11.4961,17.6603 13.4983,33.1609l63.0146 0c-0.337458,-44.4994 -8.50394,-76.153 -24.6794,-95.3206 -15.9955,-19.1676 -36.6704,-28.6839 -62.0022,-28.6839 -11.1586,0 -22.0022,1.16985 -32.6659,3.50956 -7.49156,2.00225 -26.1642,8.99888 -56.153,20.8324 -29.8313,11.8335 -51.676,17.6603 -65.1744,17.6603 -10.5062,0 -18.6727,-3.14961 -24.4994,-9.65129 -5.82677,-6.34421 -8.84139,-17.5028 -9.17885,-33.3408z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xc0",
                                "horiz-adv-x": "722",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M717.998 0l-156.175 0 -61.8223 162.992 -287.177 0 -59.4826 -162.992 -153.341 0 277.998 715.996 153.161 0 286.839 -715.996zm-264.994 284.004l-99.5051 264.994 -96.6704 -264.994 196.175 0zm-22.0022 496.985l-86.0067 0 -134.983 146.007 152.981 0 68.009 -146.007z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xaf",
                                "horiz-adv-x": "552",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M-8.99888 757.998l0 88.9989 569.989 0 0 -88.9989 -569.989 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\x9e",
                                "horiz-adv-x": "750",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M124.994 0l0 624.994 500 0 0 -624.994 -500 0zm15.9955 15.9955l468.009 0 0 593.003 -468.009 0 0 -593.003z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\x8d",
                                "horiz-adv-x": "750",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M124.994 0l0 624.994 500 0 0 -624.994 -500 0zm15.9955 15.9955l468.009 0 0 593.003 -468.009 0 0 -593.003z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "|",
                                "horiz-adv-x": "279",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M86.9966 -210.011l0 938.02 108.009 0 0 -938.02 -108.009 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "k",
                                "horiz-adv-x": "556",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M66.9966 0l0 715.996 137.008 0 0 -379.82 160.495 182.835 168.999 0 -177.008 -189.674 190.011 -329.336 -148.009 0 -131.001 234.173 -63.4871 -68.009 0 -166.164 -137.008 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "Z",
                                "horiz-adv-x": "610",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M10.0112 0l0 130.011 377.323 464.994 -334.331 0 0 120.99 524.004 0 0 -111.991 -392.013 -483.015 406.997 0 0 -120.99 -581.98 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "I",
                                "horiz-adv-x": "277",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M68.009 0l0 715.996 144.994 0 0 -715.996 -144.994 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "8",
                                "horiz-adv-x": "556",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M160.337 387.177c-35.3431,14.9831 -61.1699,35.5006 -77.1654,61.8223 -16.1755,26.1642 -24.162,55.0056 -24.162,86.1642 0,53.4983 18.6502,97.6603 55.8155,132.508 37.1654,34.8256 90.1687,52.3285 158.673,52.3285 68.009,0 120.675,-17.5028 158.178,-52.3285 37.4803,-34.8481 56.333,-79.0101 56.333,-132.508 0,-33.1609 -8.68391,-62.6547 -26.0067,-88.6614 -17.1654,-25.8268 -41.5073,-45.6693 -72.8459,-59.3251 39.8425,-16.018 70.0112,-39.3476 90.8436,-70.0112 20.6749,-30.8211 31.0011,-66.1642 31.0011,-106.322 0,-66.3442 -20.9899,-120.18 -63.1721,-161.687 -42.0022,-41.4848 -97.9978,-62.1597 -167.987,-62.1597 -65.0169,0 -119.01,17.1654 -162.34,51.4961 -51.0011,40.3375 -76.5129,96.018 -76.5129,166.502 0,38.8301 9.67379,74.5107 28.8414,106.997 19.1676,32.5084 49.3363,57.5028 90.5062,75.1856zm28.6614 137.998c0,-27.3341 7.67154,-48.8414 22.9921,-64.1845 15.5006,-15.3206 36.018,-22.9921 61.5073,-22.9921 26.0067,0 46.6592,7.82902 62.1597,23.3296 15.5006,15.5006 23.3521,37.0079 23.3521,64.342 0,25.8268 -7.67154,46.5017 -23.0146,62.0022 -15.5006,15.5006 -35.838,23.3296 -60.9899,23.3296 -26.3442,0 -47.1766,-7.82902 -62.6772,-23.5096 -15.5006,-15.658 -23.3296,-36.4904 -23.3296,-62.3172zm-13.0034 -306.997c0,-38.1777 9.67379,-67.8515 28.9989,-89.1789 19.3476,-21.3273 43.3296,-31.991 72.171,-31.991 28.324,0 51.676,10.3262 70.1687,30.8211 18.4927,20.4949 27.6715,50.1687 27.6715,88.8414 0,33.8358 -9.33633,60.9899 -28.1665,81.5073 -18.8301,20.4949 -42.6772,30.8211 -71.4961,30.8211 -33.5208,0 -58.3352,-11.676 -74.8481,-35.0056 -16.333,-23.3296 -24.4994,-48.5039 -24.4994,-75.8155z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "'",
                                "horiz-adv-x": "237",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M70.8436 462.002l-25.8493 133.161 0 120.832 148.999 0 0 -120.832 -22.3172 -133.161 -100.832 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xf0",
                                "horiz-adv-x": "610",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M162.497 715.996l142.992 0c18.5152,-14.3307 36.333,-28.8189 53.1834,-43.4871l88.324 43.4871 21.8448 -47.1541 -70.3487 -32.8459c62.4972,-62.9921 107.334,-126.164 134.668,-189.651 27.1766,-63.5096 40.8324,-123.352 40.8324,-179.843 0,-84.162 -24.9944,-151.834 -75.1631,-202.835 -50.1687,-51.1586 -114.826,-76.6704 -194.331,-76.6704 -76.333,0 -139.505,25.3318 -188.999,76.1755 -49.6738,50.6637 -74.5107,116.333 -74.5107,196.985 0,79.1676 26.3442,144.342 79.0101,195.186 43.8245,42.4972 93.3408,63.667 148.324,63.667 17.5028,0 35.3431,-2.67717 53.1834,-7.85152 13.0034,-3.82452 31.4961,-12.4859 55.1631,-25.8268 -12.6659,22.8346 -23.1721,40.4949 -31.676,53.3408 -8.50394,12.8234 -21.6648,30.4837 -39.6625,53.0034l-122.002 -58.1777 -20.8324 46.5017 106.502 50.1687c-32.6659,29.9888 -68.009,58.4927 -106.502,85.8268zm21.5073 -457.323c0,-51.8335 11.8335,-91.4961 35.3206,-118.83 23.5096,-27.1766 52.351,-40.8324 86.5017,-40.8324 34.6682,0 64.342,13.6558 88.6839,41.1474 24.3195,27.3341 36.4904,65.3318 36.4904,113.678 0,48.6614 -12.5084,86.9966 -37.5028,115.006 -24.9944,28.1665 -54.4882,42.1597 -88.6614,42.1597 -33.4983,0 -62.0022,-13.3408 -85.5118,-40 -23.4871,-26.5017 -35.3206,-64.0045 -35.3206,-112.328z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xdf",
                                "horiz-adv-x": "610",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M68.009 0l0 465.489c0,65.1744 5.82677,114.668 17.3228,148.684 11.4961,33.8358 33.9933,61.4848 67.1766,82.8346 33.1609,21.3273 76.333,31.991 129.314,31.991 66.3442,0 116.018,-14.1732 148.841,-42.6547 32.8459,-28.3465 49.3363,-63.667 49.3363,-105.669 0,-28.5039 -8.84139,-59.0101 -26.6592,-91.3386 -17.6828,-32.5084 -27.8515,-52.3285 -30.5062,-59.5051 -2.49719,-7.33408 -3.82452,-13.4983 -3.82452,-18.6727 0,-10.8211 3.982,-22.0022 12.1485,-33.8358 5.33183,-7.49156 24.8369,-28.324 58.6727,-62.6547 33.9933,-34.3307 56.8279,-63.3296 68.5039,-87.1766 11.8335,-23.8245 17.6603,-48.4814 17.6603,-73.9933 0,-47.3341 -16.333,-86.8391 -49.1564,-118.673 -32.6659,-31.8335 -74.1732,-47.829 -124.342,-47.829 -34.6682,0 -66.1642,8.84139 -94.4882,26.5017 -28.3465,17.6603 -49.6738,39.5051 -64.0045,65.5118l95.9955 55.9955c6.83915,-12.5084 14.5107,-22.0022 22.9921,-28.3465 8.50394,-6.50169 17.8403,-9.65129 28.009,-9.65129 13.3408,0 24.6569,4.8144 33.9933,14.4882 9.33633,9.67379 14.0157,21.6648 14.0157,35.9955 0,13.4983 -4.8369,27.0191 -14.6682,40.8324 -5.51181,8.16648 -28.1665,30.8436 -67.5141,68.1665 -55.1631,53.0034 -82.8346,94.6682 -82.8346,125.017 0,19.3251 10.5062,51.1586 31.4961,95.3206 16.5129,34.0157 26.1867,55.5006 29.1789,64.6794 2.83465,9.15636 4.34196,18.6502 4.34196,28.5039 0,14.3307 -5.35433,26.6592 -16.018,36.8279 -10.8211,10.1687 -25.1519,15.1631 -42.9921,15.1631 -16.1755,0 -30.3262,-4.16198 -42.1597,-12.6659 -11.8335,-8.50394 -19.8425,-19.5051 -24.0045,-32.8459 -5.82677,-17.9978 -8.84139,-54.8256 -8.84139,-110.664l0 -465.827 -136.985 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xce",
                                "horiz-adv-x": "277",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M68.009 0l0 715.996 144.994 0 0 -715.996 -144.994 0zm-83.0146 780.99l102.497 144.004 126.344 0 101.17 -144.004 -110.011 0 -56.4904 73.0034 -52.5084 -73.0034 -111.001 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xbd",
                                "horiz-adv-x": "833",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M242.992 355.006l-92.9809 0 0 251.001c-30.6862,-21.1699 -65.6693,-37.1654 -105.017,-48.009l0 75.9955c31.0011,8.84139 59.1676,22.8346 84.342,42.3397 17.6603,13.6783 30.5062,29.8313 38.3352,48.6614l75.3206 0 0 -369.989zm1.50731 -381.012l-77.6603 0 424.162 751.001 77.6603 0 -424.162 -751.001zm564.499 83.0146l0 -77.9978 -295.996 0c3.48706,27.649 12.4859,52.4859 26.8391,74.3307 14.1507,21.8223 45.6468,51.991 94.3307,90.8211 36.9854,28.9989 59.3251,48.1665 66.6592,57.6603 10.1687,12.351 15.1631,24.8369 15.1631,37.6828 0,11.991 -4.0045,21.6648 -11.991,28.8189 -8.16648,7.1766 -20.3375,10.6862 -36.8279,10.6862 -16.018,0 -28.1665,-4.0045 -36.5129,-12.0135 -8.16648,-7.82902 -13.0034,-22.4972 -14.6682,-44.0045l-93.0034 7.85152c4.8369,37.6603 17.1654,65.4893 37.0079,83.4871 25.6693,23.1721 62.1597,34.6682 109.674,34.6682 45.1519,0 79.6625,-10.3262 103.487,-31.1586 23.847,-20.6749 35.838,-45.1744 35.838,-73.4983 0,-17.5028 -3.66704,-34.1732 -11.0011,-49.8313 -7.33408,-15.838 -19.1676,-32.0135 -35.838,-49.0214 -8.50394,-8.32396 -30.3262,-26.4792 -65.8268,-54.4882 -18.4927,-14.5107 -31.8335,-25.8268 -40,-33.9933l152.666 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xac",
                                "horiz-adv-x": "584",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M415.996 182.992l0 215.006 -375.006 0 0 126.007 501.012 0 0 -341.012 -126.007 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\x9b",
                                "horiz-adv-x": "750",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M124.994 0l0 624.994 500 0 0 -624.994 -500 0zm15.9955 15.9955l468.009 0 0 593.003 -468.009 0 0 -593.003z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\x8a",
                                "horiz-adv-x": "750",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M124.994 0l0 624.994 500 0 0 -624.994 -500 0zm15.9955 15.9955l468.009 0 0 593.003 -468.009 0 0 -593.003z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "y",
                                "horiz-adv-x": "556",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M6.00675 519.01l145.984 0 124.499 -368.166 121.507 368.166 142.002 0 -182.992 -499.505 -33.0034 -90.1687c-12.171,-30.1687 -23.667,-53.1609 -34.6682,-69.1789 -10.8436,-15.8155 -23.5096,-28.8189 -37.6603,-38.6502 -14.1732,-10.0112 -31.676,-17.6828 -52.5084,-23.1721 -20.6749,-5.51181 -44.162,-8.34646 -70.3262,-8.34646 -26.3442,0 -52.351,2.83465 -77.8403,8.34646l-11.991 106.997c21.4848,-4.16198 40.9899,-6.32171 58.3127,-6.32171 32.0135,0 55.6805,9.31384 71.0011,28.1665 15.3431,18.8301 27.1766,42.8121 35.3431,71.8335l-197.66 520z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "h",
                                "horiz-adv-x": "610",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M206.997 715.996l0 -265.332c44.4994,52.8459 97.8403,79.3476 159.663,79.3476 31.8335,0 60.5174,-5.84927 86.0067,-17.5028 25.5118,-11.8335 44.6569,-26.6817 57.6603,-45.0169 13.0034,-18.1552 21.8448,-38.3352 26.5017,-60.4949 4.8369,-22.1597 7.1766,-56.4904 7.1766,-102.992l0 -304.004 -137.008 0 0 273.656c0,54.3532 -2.65467,88.8414 -7.82902,103.51 -5.33183,14.6682 -14.6682,26.3442 -28.009,34.8256 -13.3183,8.68391 -29.9888,13.0034 -50.1687,13.0034 -22.9921,0 -43.4871,-5.48931 -61.6648,-16.6704 -18.1552,-11.0011 -31.3161,-27.649 -39.6625,-49.9888 -8.50394,-22.1597 -12.6659,-55.1631 -12.6659,-98.6727l0 -259.663 -136.985 0 0 715.996 136.985 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "W",
                                "horiz-adv-x": "943",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M171.339 0l-168.346 715.996 148.999 0 106.502 -491.834 130.664 491.834 172.351 0 124.994 -500.157 108.999 500.157 145.489 0 -172.486 -715.996 -154.848 0 -141.147 535.343 -142.182 -535.343 -158.988 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "F",
                                "horiz-adv-x": "610",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M73.0034 0l0 715.996 491.991 0 0 -120.99 -346.997 0 0 -170.011 300 0 0 -120.99 -300 0 0 -304.004 -144.994 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "5",
                                "horiz-adv-x": "556",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M44.0045 183.825l136.985 14.1732c4.0045,-31.0011 15.5006,-55.658 34.6682,-73.8358 19.3476,-18.1552 41.5073,-27.1541 66.6817,-27.1541 28.6614,0 53.0034,11.6535 72.8234,35.1631 19.8425,23.4871 29.8313,58.8301 29.8313,106.007 0,44.3195 -9.83127,77.4803 -29.6513,99.6625 -19.685,22.1597 -45.3318,33.1609 -77.0079,33.1609 -39.5051,0 -75.0056,-17.3453 -106.344,-51.991l-111.001 15.9955 70.0112 371.991 362.992 0 0 -127.987 -258.83 0 -21.6648 -121.845c30.5062,15.1631 61.8448,22.8346 93.8358,22.8346 60.9899,0 112.666,-22.1597 155.006,-66.6592 42.4972,-44.342 63.667,-102.002 63.667,-173.003 0,-59.1676 -17.1654,-111.834 -51.3386,-158.335 -46.6592,-63.3296 -111.339,-95.0056 -193.993,-95.0056 -66.1642,0 -120.18,17.8403 -161.845,53.3408 -41.8223,35.658 -66.6592,83.3296 -74.8256,143.487z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "$",
                                "horiz-adv-x": "556",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M237.998 106.997l0 204.162c-63.4871,18.1777 -109.989,45.6693 -139.505,82.4972 -29.6513,37.0079 -44.4994,81.6873 -44.4994,134.353 0,53.3183 16.8504,98.1552 50.3487,134.331 33.4983,36.333 77.9978,57.1654 133.656,62.6547l0 48.009 71.0011 0 0 -48.009c51.991,-6.16423 93.3408,-23.8245 124.162,-53.0034 30.6637,-29.1564 50.3487,-68.1665 58.8301,-116.985l-123.982 -15.9955c-7.67154,38.3127 -27.3341,64.3195 -59.0101,77.9978l0 -190.506c78.4927,-21.0124 131.991,-48.5039 160.337,-82.0022 28.5039,-33.6558 42.6547,-76.8279 42.6547,-129.494 0,-58.8301 -17.8178,-108.346 -53.6558,-148.661 -35.838,-40.3375 -85.5118,-65.3543 -149.336,-75.3431l0 -91.0011 -71.0011 0 0 89.9888c-55.9955,6.83915 -101.507,27.5141 -136.67,62.3397 -35.1631,34.8481 -57.5028,84.162 -67.3341,147.672l126.997 15.0056c5.17435,-26.0067 15.0056,-48.3465 29.3363,-67.1766 14.3307,-18.8301 30.1687,-32.3285 47.6715,-40.8324zm0 512.013c-19.1676,-6.83915 -34.1732,-18.0202 -45.3318,-33.6783 -11.1586,-15.658 -16.6704,-32.8234 -16.6704,-51.676 0,-17.1654 4.99438,-33.1609 15.1631,-47.9865 10.1687,-14.6682 25.8493,-26.6592 46.8391,-35.658l0 168.999zm71.0011 -520c24.4994,5.33183 44.4994,16.9854 59.8425,34.9831 15.5006,17.9978 23.1496,39.1676 23.1496,63.667 0,21.6648 -6.50169,40.5174 -19.4826,56.1755 -12.8459,15.838 -34.0157,27.829 -63.5096,36.333l0 -191.159z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xfe",
                                "horiz-adv-x": "610",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M68.009 715.996l136.985 0 0 -258.335c26.9966,26.9966 51.8335,45.8493 74.5107,56.5129 22.6547,10.4837 48.6614,15.838 77.9978,15.838 60.3375,0 111.496,-23.667 153.498,-71.0011 42.0022,-47.1766 62.9921,-113.183 62.9921,-197.503 0,-86.8391 -21.1699,-154.173 -63.4871,-202.34 -42.3397,-48.1665 -93.6783,-72.171 -154.016,-72.171 -28.6614,0 -54.6682,5.66929 -77.9978,17.1654 -23.1496,11.3386 -47.829,30.8436 -73.4983,58.5152l0 -259.685 -136.985 0 0 913.003zm134.983 -446.502c0,-53.8358 8.50394,-93.8358 25.5118,-119.483 23.8245,-36.6704 55.3206,-55.0056 94.8256,-55.0056 30.3262,0 56.1755,13.0034 77.6603,38.9876 21.3498,26.0067 32.0135,66.9966 32.0135,122.835 0,59.5051 -10.8436,102.34 -32.3285,128.661 -21.5073,26.3442 -48.9989,39.5051 -82.6772,39.5051 -33.0034,0 -60.3375,-12.8234 -82.1597,-38.4927 -21.8448,-25.6693 -32.8459,-64.6794 -32.8459,-117.008z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xed",
                                "horiz-adv-x": "277",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M71.991 0l0 519.01 137.008 0 0 -519.01 -137.008 0zm-22.9921 586.007l68.009 145.984 153.003 0 -135.006 -145.984 -86.0067 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xdc",
                                "horiz-adv-x": "722",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M73.0034 715.996l144.994 0 0 -387.987c0,-61.6648 1.84477,-101.507 5.33183,-119.685 6.16423,-29.3138 20.6749,-52.9809 43.667,-70.6637 23.1721,-17.8178 54.6682,-26.6592 94.6682,-26.6592 40.4949,0 71.1586,8.32396 91.8335,25.1744 20.6749,16.8279 33.0034,37.3228 37.1654,61.8223 4.16198,24.4994 6.34421,64.9944 6.34421,121.665l0 396.333 144.994 0 0 -376.49c0,-86.0067 -3.82452,-146.839 -11.676,-182.34 -7.82902,-35.5006 -22.1597,-65.4893 -43.1496,-89.9888 -20.8324,-24.4994 -48.8414,-43.847 -83.847,-58.3352 -35.1631,-14.5107 -80.8324,-21.8448 -137.323,-21.8448 -68.1665,0 -119.843,7.82902 -155.006,23.667 -35.1631,15.838 -62.9921,36.333 -83.5096,61.6648 -20.4949,25.3318 -33.8358,51.676 -40.315,79.5051 -9.51631,40.9899 -14.1732,101.665 -14.1732,181.822l0 382.34zm126.502 64.9944l0 118.02 117.998 0 0 -118.02 -117.998 0zm210.506 0l0 118.02 117.998 0 0 -118.02 -117.998 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xcb",
                                "horiz-adv-x": "666",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M73.0034 0l0 715.996 529.989 0 0 -120.99 -384.994 0 0 -159.01 357.998 0 0 -120.99 -357.998 0 0 -194.016 399.01 0 0 -120.99 -544.004 0zm115.501 780.99l0 118.02 117.998 0 0 -118.02 -117.998 0zm210.506 0l0 118.02 117.998 0 0 -118.02 -117.998 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xba",
                                "horiz-adv-x": "365",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M13.0034 545.332c0,57.8403 15.3206,102.992 46.0067,135.343 30.6637,32.1485 71.6535,48.324 122.992,48.324 51.0011,0 91.8335,-16.1755 122.655,-48.6614 30.8436,-32.3285 46.3442,-77.3453 46.3442,-135.006 0,-57.6603 -15.3431,-102.655 -46.0067,-135.006 -30.6637,-32.1485 -71.6535,-48.324 -122.992,-48.324 -51.3386,0 -92.3285,15.9955 -122.992,48.1665 -30.6862,31.991 -46.0067,77.1654 -46.0067,135.163zm102.992 -0.832396c0,-35.9955 6.00675,-61.5073 17.9978,-76.6704 12.0135,-15.1631 27.6715,-22.8346 46.8391,-22.8346 19.0101,0 34.6682,7.67154 46.8391,22.8346 12.171,15.1631 18.3352,40.6749 18.3352,76.6704 0,35.9955 -6.16423,61.5073 -18.3352,76.6704 -12.171,15.1631 -27.829,22.8346 -46.8391,22.8346 -19.1676,0 -34.8256,-7.51406 -46.8391,-22.4972 -11.991,-15.0056 -17.9978,-40.6749 -17.9978,-77.0079z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xa9",
                                "horiz-adv-x": "736",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M370.011 730.011c64.162,0 125.647,-16.1755 184.499,-48.3465 58.9876,-32.171 105.332,-78.1552 138.988,-137.998 33.6783,-59.6625 50.5062,-122.16 50.5062,-187.672 0,-65.1519 -16.5129,-127.154 -49.4938,-186.322 -33.1834,-59.0101 -79.1676,-105.017 -138.178,-138.178 -59.1676,-33.0034 -121.17,-49.4938 -186.322,-49.4938 -65.1744,0 -127.177,16.4904 -186.344,49.4938 -59.0101,33.1609 -104.994,79.1676 -138.178,138.178 -32.9809,59.1676 -49.4938,121.17 -49.4938,186.322 0,65.5118 16.8279,128.009 50.5062,187.672 33.6558,59.8425 80,105.827 138.988,137.998 58.8526,32.171 120.337,48.3465 184.522,48.3465zm0 -74.0157c-51.3386,0 -100.675,-12.8234 -148.009,-38.4927 -47.3341,-25.6693 -84.4994,-62.4972 -111.496,-110.506 -26.9966,-47.9865 -40.4949,-98.3352 -40.4949,-151.001 0,-51.991 13.3183,-101.822 39.82,-149.336 26.5017,-47.3341 63.5096,-84.3195 110.844,-110.821 47.4916,-26.5017 97.3228,-39.8425 149.336,-39.8425 51.991,0 101.822,13.3408 149.314,39.8425 47.3341,26.5017 84.342,63.4871 110.844,110.821 26.5017,47.5141 39.8425,97.3453 39.8425,149.336 0,52.3285 -13.5208,102.677 -40.5174,150.664 -26.9966,48.1665 -64.162,85.1744 -111.496,110.844 -47.3341,25.6693 -96.6704,38.4927 -147.987,38.4927zm89.9888 -355.996l79.0101 -26.0067c-12.351,-41.3273 -32.8459,-73.0034 -61.3498,-94.9831 -28.5039,-22.0022 -62.6547,-33.0034 -102.16,-33.0034 -55.658,0 -100.832,18.3352 -135.996,54.8256 -35.0056,36.4904 -52.5084,86.9966 -52.5084,151.159 0,42.1822 7.82902,79.685 23.3296,112.666 15.6805,33.0034 38.1777,57.5028 67.5141,73.8358 29.3363,16.333 62.1597,24.4994 98.4927,24.4994 40,0 73.3408,-9.49381 100.157,-28.6614 26.6817,-18.9876 47.5141,-49.1564 62.5197,-90.3262l-79.0101 -19.0101c-8.99888,23.847 -20.8324,41.1699 -35.1631,51.8335 -14.5107,10.8436 -31.4961,16.1755 -51.3386,16.1755 -29.4938,0 -53.4983,-11.1811 -72.3285,-33.4983 -18.8301,-22.3397 -28.1665,-57.1654 -28.1665,-104.679 0,-47.649 9.15636,-82.6547 27.6715,-105.152 18.3352,-22.4972 40.4949,-33.6783 66.3217,-33.6783 21.6648,0 40.3375,6.50169 56.1755,19.3476 15.838,12.9809 28.1665,34.4882 36.8279,64.6569z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\x98",
                                "horiz-adv-x": "750",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M124.994 0l0 624.994 500 0 0 -624.994 -500 0zm15.9955 15.9955l468.009 0 0 593.003 -468.009 0 0 -593.003z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\x87",
                                "horiz-adv-x": "750",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M124.994 0l0 624.994 500 0 0 -624.994 -500 0zm15.9955 15.9955l468.009 0 0 593.003 -468.009 0 0 -593.003z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "v",
                                "horiz-adv-x": "556",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M214.668 0l-209.179 519.01 144.004 0 97.6828 -264.837 28.324 -88.5039c7.49156,22.4972 12.3285,37.3228 14.1732,44.4994 4.65692,14.6682 9.49381,29.3363 14.8256,44.0045l99.0101 264.837 140.99 0 -206.164 -519.01 -123.667 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "e",
                                "horiz-adv-x": "556",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M371.991 164.004l137.008 -23.0146c-17.5028,-50.1462 -45.3318,-88.324 -83.1721,-114.646 -37.9978,-26.1867 -85.4893,-39.3476 -142.317,-39.3476 -90.1687,0 -157.008,29.4938 -200.18,88.5039 -34.1732,47.3341 -51.3386,106.997 -51.3386,179.168 0,86.0067 22.5197,153.498 67.3341,202.16 44.8369,48.8414 101.665,73.1834 170.349,73.1834 76.9854,0 137.818,-25.5118 182.497,-76.5129 44.4994,-51.0011 65.8268,-129.156 63.8245,-234.488l-342.992 0c0.989876,-40.6749 11.991,-72.351 33.1609,-95.0056 21.0124,-22.6772 47.3341,-33.9933 78.6727,-33.9933 21.5073,0 39.5051,5.82677 53.9933,17.4803 14.6682,11.676 25.6693,30.5062 33.1609,56.5129zm8.009 138.988c-0.989876,39.8425 -11.1586,70.1687 -30.6637,90.8436 -19.5051,20.8324 -43.1721,31.1586 -71.1586,31.1586 -29.8538,0 -54.5107,-11.0011 -74.0157,-32.8234 -19.5051,-21.8448 -28.9989,-51.676 -28.6614,-89.1789l204.499 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "T",
                                "horiz-adv-x": "610",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M233.993 0l0 595.006 -211.991 0 0 120.99 568.009 0 0 -120.99 -211.001 0 0 -595.006 -145.017 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "C",
                                "horiz-adv-x": "722",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M531.001 264.004l140 -43.0146c-21.5073,-78.8301 -57.3453,-137.323 -107.334,-175.658 -50.0112,-38.1552 -113.341,-57.3228 -190.169,-57.3228 -95.1631,0 -173.341,32.4859 -234.668,97.4803 -61.1699,65.0169 -91.8335,153.836 -91.8335,266.682 0,119.168 30.8436,211.834 92.3285,277.84 61.5073,65.9843 142.497,98.9876 242.835,98.9876 87.6715,0 158.83,-26.0067 213.498,-77.8403 32.6659,-30.6637 57.0079,-74.6682 73.3408,-132.148l-142.992 -34.0157c-8.50394,37.0079 -26.1642,66.3442 -53.0034,87.829 -26.9966,21.5073 -59.6625,32.171 -97.9978,32.171 -53.1834,0 -96.333,-18.9876 -129.336,-57.1654 -33.1609,-37.9978 -49.6738,-99.6625 -49.6738,-184.994 0,-90.3262 16.333,-154.826 48.8414,-193.161 32.6659,-38.5152 75.0056,-57.6828 127.154,-57.6828 38.5152,0 71.676,12.171 99.3476,36.6704 27.6715,24.4994 47.6715,62.8346 59.6625,115.343z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "2",
                                "horiz-adv-x": "556",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M506.007 126.997l0 -126.997 -481.012 0c5.17435,48.324 20.8324,93.9933 46.8391,137.165 26.0067,43.1721 77.5028,100.495 154.173,171.991 61.8223,57.6828 99.6625,96.8504 113.656,117.345 18.8301,28.324 28.3465,56.333 28.3465,84.162 0,30.6637 -8.16648,54.1732 -24.6794,70.6637 -16.333,16.5129 -38.9876,24.6794 -67.829,24.6794 -28.6614,0 -51.3386,-8.68391 -68.324,-26.0067 -16.8504,-17.1654 -26.5017,-45.8268 -29.1789,-86.0067l-137.008 13.6783c8.16648,75.658 33.6783,129.989 76.6704,162.992 43.0146,32.8459 96.6704,49.3363 161.17,49.3363 70.6637,0 126.164,-19.1676 166.659,-57.3228 40.3375,-38.1777 60.5174,-85.6693 60.5174,-142.52 0,-32.3285 -5.84927,-62.9921 -17.3453,-92.3285 -11.4961,-29.1564 -29.8313,-59.6625 -55.0056,-91.6535 -16.4904,-21.3498 -46.6592,-51.8335 -89.9888,-91.676 -43.5096,-39.8425 -71.0011,-66.1642 -82.4972,-79.3251 -11.676,-13.0034 -21.0124,-25.8493 -28.1665,-38.1777l273.003 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "!",
                                "horiz-adv-x": "333",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M124.994 184.004l-35.5006 363.825 0 168.166 148.009 0 0 -168.166 -35.0056 -363.825 -77.5028 0zm-29.4938 -184.004l0 137.008 137.008 0 0 -137.008 -137.008 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xfb",
                                "horiz-adv-x": "610",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M415.006 0l0 77.6603c-19.0101,-27.649 -43.847,-49.6513 -74.6682,-66.1642 -30.8436,-16.333 -63.3296,-24.4994 -97.5028,-24.4994 -35.0056,0 -66.3442,7.67154 -93.9933,23.0146 -27.8515,15.3206 -47.8515,36.9854 -60.18,64.6569 -12.4859,27.829 -18.6502,66.1642 -18.6502,115.163l0 329.179 136.985 0 0 -239.01c0,-73.1609 2.49719,-117.84 7.67154,-134.331 4.99438,-16.5129 14.1732,-29.6738 27.6715,-39.1676 13.3183,-9.67379 30.3262,-14.5107 51.0011,-14.5107 23.4871,0 44.4994,6.50169 63.1496,19.3476 18.6727,12.8234 31.3386,28.8189 38.1777,47.9865 6.83915,19.1676 10.3262,65.8493 10.3262,140.337l0 219.348 137.008 0 0 -519.01 -126.997 0zm-268.009 586.007l102.497 144.004 126.344 0 101.17 -144.004 -110.011 0 -56.4904 73.0034 -52.5084 -73.0034 -111.001 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xea",
                                "horiz-adv-x": "556",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M371.991 164.004l137.008 -23.0146c-17.5028,-50.1462 -45.3318,-88.324 -83.1721,-114.646 -37.9978,-26.1867 -85.4893,-39.3476 -142.317,-39.3476 -90.1687,0 -157.008,29.4938 -200.18,88.5039 -34.1732,47.3341 -51.3386,106.997 -51.3386,179.168 0,86.0067 22.5197,153.498 67.3341,202.16 44.8369,48.8414 101.665,73.1834 170.349,73.1834 76.9854,0 137.818,-25.5118 182.497,-76.5129 44.4994,-51.0011 65.8268,-129.156 63.8245,-234.488l-342.992 0c0.989876,-40.6749 11.991,-72.351 33.1609,-95.0056 21.0124,-22.6772 47.3341,-33.9933 78.6727,-33.9933 21.5073,0 39.5051,5.82677 53.9933,17.4803 14.6682,11.676 25.6693,30.5062 33.1609,56.5129zm8.009 138.988c-0.989876,39.8425 -11.1586,70.1687 -30.6637,90.8436 -19.5051,20.8324 -43.1721,31.1586 -71.1586,31.1586 -29.8538,0 -54.5107,-11.0011 -74.0157,-32.8234 -19.5051,-21.8448 -28.9989,-51.676 -28.6614,-89.1789l204.499 0zm-273.003 283.015l102.497 144.004 126.344 0 101.17 -144.004 -110.011 0 -56.4904 73.0034 -52.5084 -73.0034 -111.001 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xd9",
                                "horiz-adv-x": "722",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M73.0034 715.996l144.994 0 0 -387.987c0,-61.6648 1.84477,-101.507 5.33183,-119.685 6.16423,-29.3138 20.6749,-52.9809 43.667,-70.6637 23.1721,-17.8178 54.6682,-26.6592 94.6682,-26.6592 40.4949,0 71.1586,8.32396 91.8335,25.1744 20.6749,16.8279 33.0034,37.3228 37.1654,61.8223 4.16198,24.4994 6.34421,64.9944 6.34421,121.665l0 396.333 144.994 0 0 -376.49c0,-86.0067 -3.82452,-146.839 -11.676,-182.34 -7.82902,-35.5006 -22.1597,-65.4893 -43.1496,-89.9888 -20.8324,-24.4994 -48.8414,-43.847 -83.847,-58.3352 -35.1631,-14.5107 -80.8324,-21.8448 -137.323,-21.8448 -68.1665,0 -119.843,7.82902 -155.006,23.667 -35.1631,15.838 -62.9921,36.333 -83.5096,61.6648 -20.4949,25.3318 -33.8358,51.676 -40.315,79.5051 -9.51631,40.9899 -14.1732,101.665 -14.1732,181.822l0 382.34zm369.989 64.9944l-85.9843 0 -135.006 146.007 153.003 0 67.9865 -146.007z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xc8",
                                "horiz-adv-x": "666",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M73.0034 0l0 715.996 529.989 0 0 -120.99 -384.994 0 0 -159.01 357.998 0 0 -120.99 -357.998 0 0 -194.016 399.01 0 0 -120.99 -544.004 0zm346.997 780.99l-86.0067 0 -134.983 146.007 152.981 0 68.009 -146.007z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xb7",
                                "horiz-adv-x": "333",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M97.9978 280l0 137.008 137.008 0 0 -137.008 -137.008 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xa6",
                                "horiz-adv-x": "279",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M86.9966 342.992l0 385.017 108.009 0 0 -385.017 -108.009 0zm0 -553.003l0 386.007 108.009 0 0 -386.007 -108.009 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\x95",
                                "horiz-adv-x": "750",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M124.994 0l0 624.994 500 0 0 -624.994 -500 0zm15.9955 15.9955l468.009 0 0 593.003 -468.009 0 0 -593.003z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\x84",
                                "horiz-adv-x": "750",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M124.994 0l0 624.994 500 0 0 -624.994 -500 0zm15.9955 15.9955l468.009 0 0 593.003 -468.009 0 0 -593.003z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "s",
                                "horiz-adv-x": "556",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M22.9921 146.007l137.998 20.9899c5.84927,-26.5017 17.6828,-46.6592 35.6805,-60.3375 17.8403,-13.8358 42.9921,-20.6524 75.1631,-20.6524 35.5006,0 62.1597,6.50169 80.1575,19.4826 12.0135,9.17885 18.0202,21.5073 18.0202,36.8504 0,10.3262 -3.35208,18.9876 -9.85377,25.8268 -6.81665,6.50169 -22.1597,12.6659 -45.8268,18.1777 -110.821,24.4994 -180.99,46.8166 -210.664,66.9966 -41.1699,28.1665 -61.6648,67.1541 -61.6648,116.985 0,45.1744 17.8403,83.0146 53.3408,113.678 35.5006,30.6637 90.4837,46.0067 164.994,46.0067 71.0011,0 123.825,-11.676 158.335,-34.8481 34.4882,-23.3296 58.3352,-57.6603 71.3386,-103.172l-129.021 -23.982c-5.48931,20.315 -16.153,35.9955 -31.6535,46.8166 -15.5006,10.8436 -37.6603,16.1755 -66.5017,16.1755 -36.333,0 -62.3397,-4.99438 -78.1777,-15.1631 -10.4837,-7.1766 -15.658,-16.5129 -15.658,-27.829 0,-9.83127 4.49944,-18.1777 13.6783,-25.0169 12.4859,-9.15636 55.3206,-22.0022 128.661,-38.6502 73.3183,-16.6704 124.499,-37.0079 153.498,-61.1699 28.8189,-24.342 43.1721,-58.5152 43.1721,-102.182 0,-47.4916 -19.8425,-88.4814 -59.685,-122.655 -39.6625,-34.1732 -98.4927,-51.3386 -176.49,-51.3386 -70.6637,0 -126.659,14.3307 -168.009,42.8346 -41.1474,28.5039 -68.1665,67.1766 -80.8324,116.175z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "b",
                                "horiz-adv-x": "610",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M66.0067 0l0 715.996 136.985 0 0 -258.335c42.3397,48.1665 92.351,72.351 150.349,72.351 63.1496,0 115.321,-22.8346 156.67,-68.6839 41.3273,-45.8268 61.9798,-111.654 61.9798,-197.503 0,-88.6614 -20.9899,-156.985 -63.1496,-204.994 -42.1822,-47.829 -93.4983,-71.8335 -153.678,-71.8335 -29.6738,0 -58.8301,7.67154 -87.6715,22.8346 -28.8189,15.3431 -53.6558,37.3453 -74.4882,66.3442l0 -76.1755 -126.997 0zm134.983 269.494c0,-53.8358 8.50394,-93.8358 25.5118,-119.483 23.8245,-36.6704 55.3206,-55.0056 94.8256,-55.0056 30.3487,0 56.1755,13.0034 77.6828,38.9876 21.3273,26.0067 31.991,66.9966 31.991,122.835 0,59.5051 -10.8436,102.34 -32.3285,128.661 -21.5073,26.3442 -48.9989,39.5051 -82.6772,39.5051 -33.0034,0 -60.3375,-12.8234 -82.1597,-38.4927 -21.8448,-25.6693 -32.8459,-64.6794 -32.8459,-117.008z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "Q",
                                "horiz-adv-x": "777",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M648.504 90.6637c35.3206,-25.4893 73.8358,-45.6693 115.501,-60.6524l-53.1609 -103.015c-21.6873,6.50169 -43.0146,15.5006 -63.847,26.9966 -4.49944,2.33971 -36.4904,23.5096 -95.9955,63.847 -46.8391,-20.5174 -98.8301,-30.8436 -155.838,-30.8436 -109.989,0 -196.333,32.5084 -258.673,97.3453 -62.3172,64.9944 -93.4983,156.153 -93.4983,273.656 0,117.165 31.3386,208.346 93.8358,273.341 62.4972,65.1519 147.334,97.6603 254.331,97.6603 106.164,0 190.349,-32.5084 252.508,-97.6603 62.1597,-64.9944 93.3408,-155.996 93.3408,-273.161 0,-61.8448 -8.68391,-116.355 -26.0067,-163.352 -13.0034,-35.8155 -33.8358,-70.6637 -62.4972,-104.162zm-115.996 81.3273c18.4927,22.0022 32.3285,48.3465 41.6648,79.3476 9.15636,31.0011 13.8358,66.5017 13.8358,106.659 0,82.8346 -18.1777,144.679 -54.6682,185.669 -36.5129,40.8324 -84.1845,61.3273 -143.015,61.3273 -58.9876,0 -106.817,-20.4949 -143.33,-61.6648 -36.6704,-41.1699 -55.0056,-102.992 -55.0056,-185.669 0,-83.8245 18.3352,-146.659 55.0056,-188.166 36.6704,-41.6648 83.0146,-62.4972 139.01,-62.4972 20.9899,0 40.6524,3.50956 59.1676,10.3262 -29.1789,19.1676 -59.0101,34.0157 -89.1789,44.6794l40.4949 84.0045c47.3341,-16.5129 92.6659,-41.0124 136.018,-74.0157z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "@",
                                "horiz-adv-x": "975",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M867.829 8.99888l104.162 0c-32.4859,-66.5017 -82.4972,-118.493 -149.989,-156.175 -77.0079,-43.1496 -171.159,-64.8144 -282.16,-64.8144 -107.514,0 -200.18,18.1552 -278.335,54.4882 -78.1777,36.5129 -136.333,90.1687 -174.331,161.012 -38.1777,71.0011 -57.1654,148.166 -57.1654,231.834 0,91.6535 21.6648,176.985 64.9944,256.153 43.1721,79.0101 102.497,138.335 177.66,177.998 75.1631,39.6625 161.17,59.5051 257.84,59.5051 82.0022,0 154.983,-15.9955 218.65,-47.829 63.847,-32.0135 112.666,-77.3453 146.344,-136.175 33.6558,-58.8301 50.5062,-122.992 50.5062,-192.666 0,-83.1721 -25.5118,-158.155 -76.6704,-225.332 -64.0045,-84.6569 -146.164,-126.997 -246.344,-126.997 -26.9966,0 -47.3341,4.65692 -60.9899,13.9933 -13.6783,9.51631 -22.6772,23.1721 -27.3341,41.3498 -38.3352,-36.8504 -82.6772,-55.3431 -132.666,-55.3431 -53.9933,0 -98.8301,18.6727 -134.511,55.838 -35.658,37.3228 -53.4983,86.8391 -53.4983,148.661 0,76.4904 21.5073,146.164 64.342,209.336 52.171,76.8279 118.83,115.163 200.157,115.163 57.8403,0 100.675,-22.1597 128.166,-66.5017l12.171 54.5107 128.841 0 -73.8358 -349.674c-4.49944,-22.1597 -6.83915,-36.4904 -6.83915,-42.9921 0,-8.009 1.84477,-14.1732 5.66929,-18.1777 3.66704,-4.16198 8.16648,-6.16423 13.3408,-6.16423 15.658,0 35.8155,9.49381 60.6524,28.324 33.1834,24.6794 60,58.0202 80.5174,99.5051 20.4949,41.6648 30.8211,84.8369 30.8211,129.494 0,80 -28.9989,147.019 -86.8391,200.855 -57.9978,53.8133 -138.83,80.8324 -242.655,80.8324 -88.1665,0 -163.015,-18.0202 -224.342,-54.0157 -61.3273,-36.153 -107.492,-86.8166 -138.493,-152.328 -31.1586,-65.3318 -46.6592,-133.498 -46.6592,-204.342 0,-68.8189 17.3228,-131.316 51.991,-187.829 34.6682,-56.4904 83.3296,-97.6603 146.007,-123.667 62.4972,-25.8268 134.151,-38.8301 214.983,-38.8301 77.6828,0 144.679,11.0011 200.517,32.8459 55.9955,21.8223 101.147,54.4882 135.321,98.1552zm-526.839 200.675c0,-41.3498 8.34646,-71.8335 25.0169,-91.3386 16.8279,-19.5051 37.5028,-29.3363 62.1597,-29.3363 18.4927,0 35.838,4.49944 51.991,13.6783 12.351,6.47919 24.4994,16.8279 36.5129,30.8211 17.3228,19.8425 32.171,48.6614 44.6569,86.8391 12.5084,37.9978 18.6727,73.4983 18.6727,106.502 0,36.6704 -8.50394,64.9944 -25.4893,84.6569 -17.1879,19.6625 -38.6727,29.4938 -64.4994,29.4938 -28.009,0 -53.8358,-10.8211 -77.5028,-32.4859 -23.667,-21.6648 -41.5073,-52.5084 -53.4983,-92.5084 -12.0135,-40 -18.0202,-75.5006 -18.0202,-106.322z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "/",
                                "horiz-adv-x": "277",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M-2.00225 -11.991l177.998 740 103.015 0 -179.01 -740 -102.002 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xf8",
                                "horiz-adv-x": "610",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M462.34 487.492l51.1586 59.0101 53.9933 -44.9944 -52.4859 -60.8324c19.5051,-23.1721 34.8256,-50.6637 46.1642,-82.4972 11.1586,-31.8335 16.8279,-65.1744 16.8279,-100 0,-77.6828 -25.4893,-142.34 -76.6704,-193.836 -51.1586,-51.5186 -115.163,-77.3453 -192.328,-77.3453 -55.9955,0 -106.007,13.9933 -149.989,42.0022l-56.5129 -65.4893 -53.9933 45.9843 57.3228 66.3442c-20.1575,23.667 -35.8155,51.991 -46.9966,84.9944 -11.1586,32.8234 -16.8279,66.5017 -16.8279,100.99 0,78.1777 24.9944,142.34 75.1631,192.688 50.0112,50.3262 114.173,75.5006 192.508,75.5006 57.9978,0 108.999,-14.1732 152.666,-42.5197zm-77.1654 -89.1564c-21.8448,17.8403 -46.6817,26.6592 -74.5107,26.6592 -37.0079,0 -68.5039,-14.1507 -94.1732,-42.6547 -25.6468,-28.5039 -38.4927,-68.3465 -38.4927,-119.843 0,-32.3285 4.67942,-61.5073 13.9933,-87.3341l193.183 223.172zm41.8223 -59.3251l-192.171 -222.34c21.6648,-15.838 46.3442,-23.667 74.1732,-23.667 37.6603,0 69.1789,14.1732 94.6682,42.4972 25.4893,28.324 38.3352,68.009 38.3352,119.01 0,30.8211 -4.99438,58.8301 -15.0056,84.4994z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xe7",
                                "horiz-adv-x": "556",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M524.004 364.994l-135.006 -24.0045c-4.49944,26.8391 -14.8256,47.0191 -31.0011,60.6749 -16.1755,13.4983 -37.0079,20.3375 -62.6547,20.3375 -34.1732,0 -61.5073,-11.8335 -81.8448,-35.5006 -20.3375,-23.667 -30.5062,-63.1721 -30.5062,-118.673 0,-61.6648 10.3487,-105.152 31.0011,-130.664 20.6749,-25.4893 48.3465,-38.1552 83.0146,-38.1552 25.9843,0 47.3341,7.49156 63.8245,22.3172 16.6704,14.8481 28.324,40.3375 35.1631,76.6704l135.006 -22.9921c-13.9933,-62.0022 -40.8324,-108.841 -80.4949,-140.495 -39.6625,-31.676 -92.8459,-47.5141 -159.663,-47.5141 -75.6805,0 -136.175,24.0045 -181.17,71.8335 -45.1744,48.009 -67.6715,114.331 -67.6715,199.168 0,85.8268 22.6547,152.508 67.829,200.337 45.1744,47.829 106.344,71.676 183.51,71.676 62.9921,0 113.161,-13.6783 150.484,-40.8549 37.1654,-27.1541 63.847,-68.4814 80.18,-124.162zm-381.507 -555.996l0 57.3453c33.6783,-3.50956 64.4994,-5.35433 92.6659,-5.35433 28.9989,0 50.6637,5.17435 64.6794,15.6805 10.8211,7.82902 16.153,17.8403 16.153,30.3262 0,11.0011 -4.99438,20.6749 -15.1631,28.8414 -10.1687,8.16648 -25.8268,12.171 -46.9966,12.171 -21.0124,0 -42.3397,-3.35208 -64.342,-9.83127l12.8459 48.4814c25.3318,8.99888 52.6659,13.3408 82.0022,13.3408 40.8324,0 71.6535,-8.99888 92.8234,-26.8391 21.1699,-17.9978 31.8335,-39.82 31.8335,-65.4893 0,-28.8414 -11.676,-52.0135 -35.1631,-70.0112 -31.676,-24.4994 -77.0079,-36.6704 -135.996,-36.6704 -42.0022,0 -73.8358,2.67717 -95.3431,8.009z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xd6",
                                "horiz-adv-x": "777",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M42.9921 353.656c0,73.0034 11.0011,134.353 32.8459,184.004 16.153,36.5129 38.4927,69.3363 66.6592,98.3352 28.1665,28.9989 59.0101,50.5062 92.5084,64.6794 44.6569,18.8301 96.153,28.324 154.488,28.324 105.669,0 190.011,-32.8234 253.498,-98.3352 63.3521,-65.6693 95.0056,-156.828 95.0056,-273.656 0,-115.838 -31.4961,-206.502 -94.3307,-271.834 -62.8346,-65.5118 -146.997,-98.1777 -252.171,-98.1777 -106.502,0 -191.339,32.5084 -254.173,97.6603 -62.8121,65.0169 -94.3307,154.668 -94.3307,268.999zm148.999 4.8369c0,-81.1699 18.8526,-142.655 56.333,-184.657 37.5028,-41.8448 85.1744,-62.8346 142.835,-62.8346 57.8403,0 105.174,20.8324 142.34,62.3397 37.0079,41.6648 55.5006,103.982 55.5006,187.154 0,82.1822 -17.9978,143.51 -54.1732,183.847 -35.9955,40.4949 -83.8245,60.6524 -143.667,60.6524 -59.6625,0 -107.829,-20.4949 -144.319,-61.3273 -36.5129,-40.9899 -54.8481,-102.677 -54.8481,-185.174zm31.0011 422.497l0 118.02 117.998 0 0 -118.02 -117.998 0zm210.506 0l0 118.02 117.998 0 0 -118.02 -117.998 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xc5",
                                "horiz-adv-x": "722",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M717.998 0l-156.175 0 -61.8223 162.992 -287.177 0 -59.4826 -162.992 -153.341 0 277.998 715.996 153.161 0 286.839 -715.996zm-264.994 284.004l-99.5051 264.994 -96.6704 -264.994 196.175 0zm-4.0045 475.006c0,-26.1867 -9.33633,-48.5039 -27.829,-67.1766 -18.6727,-18.4927 -41.0124,-27.829 -67.1766,-27.829 -26.1642,0 -48.5039,9.33633 -67.1541,27.829 -18.5152,18.6727 -27.829,40.9899 -27.829,67.1766 0,26.1642 9.31384,48.4814 27.829,67.1541 18.6502,18.4927 40.9899,27.829 67.1541,27.829 26.1642,0 48.5039,-9.15636 67.1766,-27.649 18.4927,-18.3352 27.829,-40.8549 27.829,-67.3341zm-51.991 0c0,11.991 -4.18448,21.9798 -12.5084,30.4837 -8.50394,8.34646 -18.4927,12.5084 -30.5062,12.5084 -11.8335,0 -22.0022,-4.16198 -30.4837,-12.5084 -8.34646,-8.50394 -12.5084,-18.4927 -12.5084,-30.4837 0,-11.8335 4.16198,-22.0022 12.5084,-30.5062 8.48144,-8.34646 18.6502,-12.5084 30.4837,-12.5084 12.0135,0 22.0022,4.16198 30.5062,12.5084 8.32396,8.50394 12.5084,18.6727 12.5084,30.5062z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xb4",
                                "horiz-adv-x": "333",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M91.0011 582.002l68.009 146.007 152.981 0 -134.983 -146.007 -86.0067 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xa3",
                                "horiz-adv-x": "556",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M488.009 139.01l51.991 -116.018c-18.4927,-9.98875 -40,-18.1552 -64.162,-24.4994 -24.342,-6.32171 -47.829,-9.49381 -70.6637,-9.49381 -29.1789,0 -68.3465,6.99663 -117.165,21.0124 -48.8414,13.9933 -85.0169,20.9899 -108.346,20.9899 -39.82,0 -80.3375,-14.3307 -121.665,-42.9921l-51.991 118.335c36.9854,26.4792 63.4871,54.6457 79.6625,84.4994 16.153,29.8313 24.342,58.1552 24.342,85.3318 0,8.8189 -0.674916,17.9978 -2.00225,27.829l-102.002 0 0 107.987 76.9854 0c-13.3183,38.5152 -20,77.3453 -20,116.67 0,35.5006 9.67379,69.5163 28.9989,101.665 19.5051,32.171 46.8391,56.6704 82.3397,73.4983 35.6805,16.8504 74.3307,25.1744 116.333,25.1744 64.162,0 115.343,-16.1755 153.498,-48.6614 37.9978,-32.5084 61.3273,-79.0101 69.8313,-139.843l-131.991 -19.5051c-6.16423,35.1856 -17.3453,60.5174 -33.6783,75.838 -16.153,15.5006 -36.4904,23.1721 -60.8324,23.1721 -25.8268,0 -47.4916,-8.66142 -64.6569,-26.1642 -17.1654,-17.5028 -25.8268,-39.3251 -25.8268,-65.8268 0,-13.6783 2.31721,-31.8335 6.99663,-54.3532 4.65692,-22.4972 10.5062,-42.9921 17.3228,-61.6648l151.676 0 0 -107.987 -129.494 0c0.989876,-7.1766 1.48481,-14.3307 1.48481,-21.5073 0,-25.6693 -4.8369,-49.4938 -14.6682,-71.1586 -9.65129,-21.8448 -29.8313,-50.5062 -60,-86.0067 17.8403,9.17885 40.3375,13.6783 67.3341,13.6783 11.3386,0 21.6648,-0.674916 30.6637,-2.00225 4.67942,-0.674916 17.8403,-3.84702 40,-9.51631 39.3476,-10.3262 66.0067,-15.5006 80.3375,-15.5006 25.3318,0 58.5152,8.99888 99.3476,27.0191z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\x92",
                                "horiz-adv-x": "750",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M124.994 0l0 624.994 500 0 0 -624.994 -500 0zm15.9955 15.9955l468.009 0 0 593.003 -468.009 0 0 -593.003z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\x81",
                                "horiz-adv-x": "750",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M124.994 0l0 624.994 500 0 0 -624.994 -500 0zm15.9955 15.9955l468.009 0 0 593.003 -468.009 0 0 -593.003z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "p",
                                "horiz-adv-x": "610",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M68.009 519.01l127.987 0 0 -76.1755c16.6704,26.0067 39.0101,46.9966 67.3341,63.1721 28.3465,15.9955 59.8425,24.0045 94.3307,24.0045 60.18,0 111.339,-23.667 153.341,-71.0011 42.0022,-47.1766 62.9921,-113.183 62.9921,-197.503 0,-86.8391 -21.1699,-154.173 -63.4871,-202.34 -42.3397,-48.1665 -93.6783,-72.171 -154.016,-72.171 -28.6614,0 -54.6682,5.66929 -77.9978,17.1654 -23.1496,11.3386 -47.829,30.8436 -73.4983,58.5152l0 -259.685 -136.985 0 0 716.018zm134.983 -251.519c0,-58.4927 11.5186,-101.665 34.6682,-129.651 23.0146,-27.829 51.1811,-41.8448 84.162,-41.8448 31.8335,0 58.3352,12.8459 79.5051,38.5152 21.1699,25.6468 31.676,67.649 31.676,126.164 0,54.6682 -10.8436,95.1631 -32.6659,121.665 -21.6648,26.5017 -48.6614,39.6625 -80.8324,39.6625 -33.4983,0 -61.3273,-13.0034 -83.3296,-39.0101 -22.1822,-25.9843 -33.1834,-64.4994 -33.1834,-115.501z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "_",
                                "horiz-adv-x": "556",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M-8.99888 -197.998l0 88.9989 569.989 0 0 -88.9989 -569.989 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "N",
                                "horiz-adv-x": "722",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M73.0034 0l0 715.996 140.337 0 294.668 -479.82 0 479.82 133.993 0 0 -715.996 -144.837 0 -290.169 470.664 0 -470.664 -133.993 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "=",
                                "horiz-adv-x": "584",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M40.9899 397.008l0 126.997 501.012 0 0 -126.997 -501.012 0zm0 -217.008l0 126.997 501.012 0 0 -126.997 -501.012 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: ",",
                                "horiz-adv-x": "277",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M68.009 137.008l136.985 0 0 -98.1777c0,-39.6625 -3.32958,-71.1586 -10.1687,-93.9933 -6.81665,-23.0146 -19.82,-43.667 -38.8301,-61.8448 -18.9876,-18.3352 -43.1721,-32.4859 -72.3285,-42.9921l-26.6592 57.0079c27.4916,9.15636 46.9966,21.6648 58.6502,37.6603 11.5186,15.838 17.6828,37.6603 18.3352,65.3318l-65.9843 0 0 137.008z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xf5",
                                "horiz-adv-x": "610",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M40 265.827c0,45.6693 11.1586,89.8313 33.6558,132.508 22.5197,42.8346 54.3532,75.3206 95.5006,97.8403 41.1699,22.4972 87.0191,33.8358 137.84,33.8358 78.4927,0 142.677,-25.5118 192.846,-76.5129 50.1687,-51.1586 75.1631,-115.501 75.1631,-193.498 0,-78.6727 -25.3318,-143.825 -75.838,-195.501 -50.6637,-51.676 -114.331,-77.5028 -191.159,-77.5028 -47.5141,0 -92.8459,10.8436 -136.018,32.3285 -42.9921,21.5073 -75.8155,53.0034 -98.3352,94.6682 -22.4972,41.5073 -33.6558,92.171 -33.6558,151.834zm140.99 -7.33408c0,-51.4961 12.171,-91.0011 36.5129,-118.335 24.4994,-27.4916 54.4882,-41.1474 90.3262,-41.1474 35.6805,0 65.6693,13.6558 89.8313,41.1474 24.162,27.3341 36.333,67.1766 36.333,119.348 0,50.8211 -12.171,89.9888 -36.333,117.323 -24.162,27.5141 -54.1507,41.1699 -89.8313,41.1699 -35.838,0 -65.8268,-13.6558 -90.3262,-41.1699 -24.342,-27.3341 -36.5129,-66.8166 -36.5129,-118.335zm33.0034 326.502l-62.9921 0c-0.337458,7.51406 -0.494938,13.3408 -0.494938,17.5028 0,34.1732 8.32396,60.4949 24.9944,78.8301 16.4904,18.5152 37.9978,27.6715 64.0045,27.6715 11.4961,0 22.0022,-1.16985 31.8335,-3.66704 9.83127,-2.49719 27.6715,-9.49381 53.4983,-20.9899 26.0067,-11.5186 46.1642,-17.3453 60.9899,-17.3453 10.3487,0 19.0101,3.32958 26.0067,9.83127 7.1766,6.68166 11.4961,17.6828 13.4983,33.1834l62.9921 0c-0.314961,-44.5219 -8.48144,-76.1755 -24.4994,-95.3431 -16.153,-19.1676 -36.8279,-28.6614 -62.1597,-28.6614 -11.1586,0 -22.0022,1.16985 -32.6659,3.48706 -7.49156,2.00225 -26.1642,8.99888 -55.9955,20.8324 -30.0112,11.8335 -51.676,17.6828 -65.3318,17.6828 -10.5062,0 -18.5152,-3.1721 -24.342,-9.67379 -6.00675,-6.34421 -8.99888,-17.5028 -9.33633,-33.3408z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xe4",
                                "horiz-adv-x": "556",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M173.993 359.01l-123.982 21.9798c13.9933,50.6862 38.1552,88.1665 72.3285,112.508 34.1507,24.342 84.9944,36.5129 152.328,36.5129 61.1699,0 106.839,-7.1766 136.828,-21.6873 29.8313,-14.4882 51.0011,-32.8234 63.1721,-55.1631 12.171,-22.3172 18.3352,-63.1496 18.3352,-122.835l-2.00225 -160c0,-45.4893 2.15973,-79.1676 6.50169,-100.832 4.31946,-21.6648 12.5084,-44.8369 24.4994,-69.4938l-135.996 0c-3.50956,8.99888 -8.009,22.3397 -13.1834,40 -2.15973,8.16648 -3.82452,13.4983 -4.8144,15.9955 -23.3521,-22.9921 -48.3465,-40.1575 -75.0056,-51.6535 -26.6592,-11.5186 -55.0056,-17.3453 -85.1744,-17.3453 -53.1609,0 -95.1631,14.5107 -125.827,43.5096 -30.6637,28.8189 -46.0067,65.4893 -46.0067,109.831 0,29.1564 6.99663,55.3206 21.0124,78.3352 13.9933,22.8346 33.4983,40.4949 58.8301,52.6659 25.1519,12.171 61.4848,22.8346 108.999,31.991 64.0045,12.0135 108.504,23.3296 133.161,33.6783l0 13.8358c0,26.6592 -6.50169,45.6468 -19.5051,57.1654 -13.1609,11.3161 -37.8178,16.9854 -73.9933,16.9854 -24.4994,0 -43.5096,-4.8369 -57.1654,-14.6682 -13.8358,-9.65129 -24.8369,-26.8166 -33.3408,-51.3161zm184.004 -111.001c-17.5028,-5.84927 -45.3318,-12.8459 -83.4871,-21.0124 -38.0202,-8.16648 -63.0146,-16.153 -74.6682,-23.8245 -17.8403,-12.8459 -26.8391,-28.8414 -26.8391,-48.3465 0,-19.3251 7.15411,-35.8155 21.5073,-49.8313 14.3307,-13.9933 32.4859,-20.9899 54.6457,-20.9899 24.6794,0 48.3465,8.16648 70.8436,24.3195 16.4904,12.5084 27.4916,27.5141 32.6659,45.5118 3.50956,11.6535 5.33183,33.9933 5.33183,66.8391l0 27.3341zm-243.487 337.998l0 117.998 117.998 0 0 -117.998 -117.998 0zm210.484 0l0 117.998 117.998 0 0 -117.998 -117.998 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xd3",
                                "horiz-adv-x": "777",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M42.9921 353.656c0,73.0034 11.0011,134.353 32.8459,184.004 16.153,36.5129 38.4927,69.3363 66.6592,98.3352 28.1665,28.9989 59.0101,50.5062 92.5084,64.6794 44.6569,18.8301 96.153,28.324 154.488,28.324 105.669,0 190.011,-32.8234 253.498,-98.3352 63.3521,-65.6693 95.0056,-156.828 95.0056,-273.656 0,-115.838 -31.4961,-206.502 -94.3307,-271.834 -62.8346,-65.5118 -146.997,-98.1777 -252.171,-98.1777 -106.502,0 -191.339,32.5084 -254.173,97.6603 -62.8121,65.0169 -94.3307,154.668 -94.3307,268.999zm148.999 4.8369c0,-81.1699 18.8526,-142.655 56.333,-184.657 37.5028,-41.8448 85.1744,-62.8346 142.835,-62.8346 57.8403,0 105.174,20.8324 142.34,62.3397 37.0079,41.6648 55.5006,103.982 55.5006,187.154 0,82.1822 -17.9978,143.51 -54.1732,183.847 -35.9955,40.4949 -83.8245,60.6524 -143.667,60.6524 -59.6625,0 -107.829,-20.4949 -144.319,-61.3273 -36.5129,-40.9899 -54.8481,-102.677 -54.8481,-185.174zm112.013 422.497l67.9865 146.007 153.003 0 -134.983 -146.007 -86.0067 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xc2",
                                "horiz-adv-x": "722",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M717.998 0l-156.175 0 -61.8223 162.992 -287.177 0 -59.4826 -162.992 -153.341 0 277.998 715.996 153.161 0 286.839 -715.996zm-264.994 284.004l-99.5051 264.994 -96.6704 -264.994 196.175 0zm-257.008 496.985l102.497 144.004 126.344 0 101.17 -144.004 -110.011 0 -56.4904 73.0034 -52.5084 -73.0034 -111.001 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xb1",
                                "horiz-adv-x": "548",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M211.991 173.003l0 186.007 -187.987 0 0 127.987 187.987 0 0 186.007 125.017 0 0 -186.007 187.987 0 0 -127.987 -187.987 0 0 -186.007 -125.017 0zm-187.987 -173.003l0 128.009 500.99 0 0 -128.009 -500.99 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\x8f",
                                "horiz-adv-x": "750",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M124.994 0l0 624.994 500 0 0 -624.994 -500 0zm15.9955 15.9955l468.009 0 0 593.003 -468.009 0 0 -593.003z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "~",
                                "horiz-adv-x": "584",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M31.991 253.003l0 126.997c41.3498,44.0045 89.6738,66.0067 144.679,66.0067 20.4949,0 39.3251,-2.00225 56.6704,-6.00675 17.3228,-4.0045 48.324,-14.8256 93.1609,-32.5084 44.6569,-17.6603 75.1631,-26.5017 91.0011,-26.5017 18.3352,0 39.5051,5.51181 63.3296,16.5129 24.0045,11.0011 47.3341,28.5039 70.1687,52.5084l0 -132.013c-15.0056,-15.5006 -35.9955,-29.9888 -62.8346,-43.667 -26.8391,-13.4983 -54.6682,-20.3375 -83.3296,-20.3375 -16.1755,0 -32.171,1.84477 -47.6715,5.66929 -15.3431,3.84702 -40,13.0034 -73.4983,27.3341 -50.1687,21.3273 -89.4938,32.0135 -118.178,32.0135 -45.6468,0 -90.1462,-22.0022 -133.498,-66.0067z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "m",
                                "horiz-adv-x": "889",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M62.0022 519.01l126.007 0 0 -70.8436c45.1519,54.5107 98.9876,81.8448 161.485,81.8448 33.1834,0 62.0022,-6.83915 86.3442,-20.5174 24.4994,-13.6558 44.4994,-34.3307 60,-62.0022 22.8346,27.6715 47.4916,48.3465 73.8358,62.0022 26.3217,13.6783 54.4882,20.5174 84.4994,20.5174 37.9978,0 70.1687,-7.67154 96.6704,-23.1721 26.3217,-15.5006 45.9843,-38.1777 58.9876,-68.1665 9.49381,-22.0022 14.1732,-57.8403 14.1732,-107.334l0 -331.339 -137.008 0 0 296.175c0,51.4961 -4.65692,84.6569 -14.1732,99.4826 -12.6659,19.5051 -32.3285,29.3363 -58.6502,29.3363 -19.1676,0 -37.3453,-5.82677 -54.3307,-17.5028 -16.8504,-11.8335 -29.1789,-28.9989 -36.6704,-51.4961 -7.51406,-22.6547 -11.1811,-58.3352 -11.1811,-107.154l0 -248.841 -136.985 0 0 284.004c0,50.3262 -2.49719,82.9921 -7.33408,97.5028 -4.8369,14.6682 -12.3285,25.6693 -22.6772,32.8234 -10.1687,7.1766 -24.162,10.6637 -41.6648,10.6637 -21.1699,0 -40.1575,-5.66929 -56.9854,-16.9854 -17.0079,-11.5186 -29.0214,-27.8515 -36.333,-49.3363 -7.33408,-21.5073 -11.0011,-57.1654 -11.0011,-106.839l0 -251.834 -137.008 0 0 519.01z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\\",
                                "horiz-adv-x": "277",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M-2.00225 728.009l102.002 0 179.01 -740 -103.015 0 -177.998 740z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "K",
                                "horiz-adv-x": "722",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M75.0056 0l0 715.996 144.994 0 0 -317.165 292.171 317.165 194.331 0 -270.169 -278.83 284.162 -437.165 -186.997 0 -197.008 336.175 -116.49 -119.685 0 -216.49 -144.994 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: ":",
                                "horiz-adv-x": "333",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M97.9978 382.002l0 137.008 137.008 0 0 -137.008 -137.008 0zm0 -382.002l0 137.008 137.008 0 0 -137.008 -137.008 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: ")",
                                "horiz-adv-x": "333",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M33.0034 -210.011c27.1541,58.0202 46.1642,102.34 57.3228,133.183 11.0011,31.0011 21.3498,66.6592 30.8436,106.997 9.33633,40.3375 16.333,78.6727 20.9899,114.826 4.49944,36.333 6.83915,73.4983 6.83915,111.496 0,77.5028 -8.32396,150.844 -24.9944,220 -16.6704,68.9989 -47.3341,153.003 -92.0135,251.519l93.0034 0c49.3363,-70.0112 87.6715,-144.184 115.006,-222.52 27.3341,-78.4927 40.9899,-157.998 40.9899,-238.65 0,-68.009 -10.8211,-140.832 -32.3285,-218.673 -24.3195,-87.1766 -64.6569,-173.161 -120.652,-258.178l-95.0056 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xf2",
                                "horiz-adv-x": "610",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M40 265.827c0,45.6693 11.1586,89.8313 33.6558,132.508 22.5197,42.8346 54.3532,75.3206 95.5006,97.8403 41.1699,22.4972 87.0191,33.8358 137.84,33.8358 78.4927,0 142.677,-25.5118 192.846,-76.5129 50.1687,-51.1586 75.1631,-115.501 75.1631,-193.498 0,-78.6727 -25.3318,-143.825 -75.838,-195.501 -50.6637,-51.676 -114.331,-77.5028 -191.159,-77.5028 -47.5141,0 -92.8459,10.8436 -136.018,32.3285 -42.9921,21.5073 -75.8155,53.0034 -98.3352,94.6682 -22.4972,41.5073 -33.6558,92.171 -33.6558,151.834zm140.99 -7.33408c0,-51.4961 12.171,-91.0011 36.5129,-118.335 24.4994,-27.4916 54.4882,-41.1474 90.3262,-41.1474 35.6805,0 65.6693,13.6558 89.8313,41.1474 24.162,27.3341 36.333,67.1766 36.333,119.348 0,50.8211 -12.171,89.9888 -36.333,117.323 -24.162,27.5141 -54.1507,41.1699 -89.8313,41.1699 -35.838,0 -65.8268,-13.6558 -90.3262,-41.1699 -24.342,-27.3341 -36.5129,-66.8166 -36.5129,-118.335zm217.008 327.514l-86.0067 0 -134.983 145.984 153.003 0 67.9865 -145.984z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xe1",
                                "horiz-adv-x": "556",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M173.993 359.01l-123.982 21.9798c13.9933,50.6862 38.1552,88.1665 72.3285,112.508 34.1507,24.342 84.9944,36.5129 152.328,36.5129 61.1699,0 106.839,-7.1766 136.828,-21.6873 29.8313,-14.4882 51.0011,-32.8234 63.1721,-55.1631 12.171,-22.3172 18.3352,-63.1496 18.3352,-122.835l-2.00225 -160c0,-45.4893 2.15973,-79.1676 6.50169,-100.832 4.31946,-21.6648 12.5084,-44.8369 24.4994,-69.4938l-135.996 0c-3.50956,8.99888 -8.009,22.3397 -13.1834,40 -2.15973,8.16648 -3.82452,13.4983 -4.8144,15.9955 -23.3521,-22.9921 -48.3465,-40.1575 -75.0056,-51.6535 -26.6592,-11.5186 -55.0056,-17.3453 -85.1744,-17.3453 -53.1609,0 -95.1631,14.5107 -125.827,43.5096 -30.6637,28.8189 -46.0067,65.4893 -46.0067,109.831 0,29.1564 6.99663,55.3206 21.0124,78.3352 13.9933,22.8346 33.4983,40.4949 58.8301,52.6659 25.1519,12.171 61.4848,22.8346 108.999,31.991 64.0045,12.0135 108.504,23.3296 133.161,33.6783l0 13.8358c0,26.6592 -6.50169,45.6468 -19.5051,57.1654 -13.1609,11.3161 -37.8178,16.9854 -73.9933,16.9854 -24.4994,0 -43.5096,-4.8369 -57.1654,-14.6682 -13.8358,-9.65129 -24.8369,-26.8166 -33.3408,-51.3161zm184.004 -111.001c-17.5028,-5.84927 -45.3318,-12.8459 -83.4871,-21.0124 -38.0202,-8.16648 -63.0146,-16.153 -74.6682,-23.8245 -17.8403,-12.8459 -26.8391,-28.8414 -26.8391,-48.3465 0,-19.3251 7.15411,-35.8155 21.5073,-49.8313 14.3307,-13.9933 32.4859,-20.9899 54.6457,-20.9899 24.6794,0 48.3465,8.16648 70.8436,24.3195 16.4904,12.5084 27.4916,27.5141 32.6659,45.5118 3.50956,11.6535 5.33183,33.9933 5.33183,66.8391l0 27.3341zm-168.999 337.998l68.009 145.984 153.003 0 -135.006 -145.984 -86.0067 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xd0",
                                "horiz-adv-x": "722",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M73.0034 715.996l263.667 0c60.4949,0 106.322,-4.65692 137.66,-14.1732 42.3397,-12.6659 78.3352,-35.1631 108.346,-67.1541 29.9888,-31.991 52.4859,-70.8436 67.649,-116.49 15.1631,-45.5118 22.6772,-101.845 22.6772,-169.021 0,-58.8301 -8.34646,-111.991 -25.1744,-159.325 -16.6704,-47.4916 -41.3273,-86.9966 -73.9933,-118.493 -24.9944,-23.847 -58.6727,-42.4972 -101.012,-56.1755 -31.8335,-10.1687 -74.6457,-15.1631 -128.324,-15.1631l-271.496 0 0 313.003 -73.9933 0 0 91.0011 73.9933 0 0 311.991zm144.994 -120.99l0 -191.001 153.003 0 0 -91.0011 -153.003 0 0 -192.013 108.166 0c47.829,0 82.1597,3.84702 103.33,11.676 27.829,9.83127 49.1789,27.6715 63.847,53.6783 20.4949,36.8279 30.6637,92.9809 30.6637,168.481 0,53.6783 -4.34196,95.1856 -12.8459,124.184 -8.66142,29.1564 -21.3273,52.6659 -38.1552,70.6637 -16.6704,17.8178 -38.4927,30.3262 -65.5118,37.5028 -20.6524,5.15186 -62.1597,7.82902 -124.162,7.82902l-65.3318 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xbf",
                                "horiz-adv-x": "610",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M371.991 519.01l0 -137.008 -123.982 0 0 137.008 123.982 0zm-123.982 -184.004l123.982 0c0.674916,-21.5073 1.01237,-34.0157 1.01237,-37.1654 0,-37.1654 -7.1766,-69.3363 -21.1699,-96.1755 -14.1732,-26.9966 -41.8223,-57.1654 -82.8346,-90.8211 -41.1699,-33.6783 -65.6693,-57.1879 -73.8358,-70.5062 -8.16648,-13.3408 -12.171,-28.5039 -12.171,-45.5118 0,-25.1519 10.6637,-47.1541 32.171,-66.1642 21.5073,-19.1676 50.1687,-28.6614 86.3442,-28.6614 34.8256,0 63.667,9.67379 86.8166,29.1564 23.0146,19.3476 39.1676,50.0112 48.6839,91.8335l125.984 -15.9955c-5.48931,-40.8324 -16.9854,-74.6682 -34.6682,-101.822 -23.982,-36.8279 -55.3206,-64.162 -93.9933,-81.6648 -38.4927,-17.6828 -80.9899,-26.5017 -127.672,-26.5017 -78.3352,0 -140.99,20.6524 -187.649,61.8223 -46.6817,41.1699 -70.0112,88.8414 -70.0112,142.835 0,20.8324 4.16198,41.1699 12.5084,61.0124 8.16648,19.6625 21.1699,39.4826 38.9876,59.4826 17.6828,19.8425 45.8493,45.8493 84.4994,77.8403 28.3465,22.8346 46.0067,41.8448 53.0034,57.0079 6.99663,15.1631 10.3262,41.8223 10.0112,80z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xae",
                                "horiz-adv-x": "736",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M370.011 730.011c64.162,0 125.647,-16.018 184.499,-48.189 58.9876,-31.991 105.332,-77.9978 138.988,-137.818 33.6783,-59.8425 50.5062,-122.497 50.5062,-188.009 0,-65.1519 -16.5129,-127.154 -49.4938,-186.322 -33.1834,-59.0101 -79.1676,-105.017 -138.178,-138.178 -59.1676,-33.0034 -121.17,-49.4938 -186.322,-49.4938 -65.1744,0 -127.177,16.4904 -186.344,49.4938 -59.0101,33.1609 -104.994,79.1676 -138.178,138.178 -32.9809,59.1676 -49.4938,121.17 -49.4938,186.322 0,65.5118 16.8279,128.166 50.5062,188.009 33.6558,59.82 80,105.827 138.988,137.818 58.8526,32.171 120.337,48.189 184.522,48.189zm0.314961 -74.0157c-51.4961,0 -100.832,-12.8234 -147.987,-38.4927 -47.1766,-25.6693 -84.342,-62.4972 -111.496,-110.664 -27.1766,-48.009 -40.8324,-98.5152 -40.8324,-151.001 0,-52.3285 13.3183,-102.34 39.82,-149.674 26.5017,-47.4916 63.5096,-84.4994 111.001,-111.159 47.4916,-26.6817 97.3453,-40 149.494,-40 52.351,0 102.182,13.3183 149.516,40 47.4916,26.6592 84.4994,63.667 111.159,111.159 26.6592,47.3341 40,97.3453 40,149.674 0,52.4859 -13.6783,102.992 -40.8324,151.001 -27.1766,48.1665 -64.342,84.9944 -111.676,110.664 -47.4916,25.6693 -96.8279,38.4927 -148.166,38.4927zm-169.336 -500l0 395.996 80.3375 0c75.3431,0 117.683,-0.314961 126.682,-0.989876 26.6592,-2.15973 47.3341,-7.49156 62.1597,-15.838 14.6682,-8.16648 26.9966,-20.8324 37.0079,-37.9978 9.83127,-17.0079 14.8256,-35.9955 14.8256,-56.6704 0,-28.6614 -9.33633,-53.0034 -28.009,-73.3183 -18.6502,-20.3375 -44.8369,-32.8459 -78.4927,-37.8403 11.991,-4.49944 21.3273,-9.49381 27.829,-14.8256 6.50169,-5.35433 15.5006,-15.5006 26.8391,-30.3487 2.99213,-4.0045 12.6659,-20 29.3363,-48.324l46.5017 -79.8425 -100 0 -32.8459 64.4994c-22.1597,43.1721 -40.4949,70.5062 -54.9831,81.6648 -14.6682,11.1811 -33.0034,16.8504 -55.3431,16.8504l-20.8324 0 0 -163.015 -81.0124 0zm81.0124 226.007l32.5084 0c46.3217,0 75.1631,1.82227 86.3217,5.33183 11.1586,3.50956 20,9.67379 26.5017,18.4927 6.50169,8.84139 9.67379,18.8301 9.67379,30.1687 0,10.8436 -3.1721,20.6749 -9.51631,29.1789 -6.32171,8.48144 -15.3206,14.6682 -26.9966,18.3352 -11.6535,3.66704 -40.3375,5.48931 -85.9843,5.48931l-32.5084 0 0 -106.997z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\x9d",
                                "horiz-adv-x": "750",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M124.994 0l0 624.994 500 0 0 -624.994 -500 0zm15.9955 15.9955l468.009 0 0 593.003 -468.009 0 0 -593.003z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\x8c",
                                "horiz-adv-x": "750",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M124.994 0l0 624.994 500 0 0 -624.994 -500 0zm15.9955 15.9955l468.009 0 0 593.003 -468.009 0 0 -593.003z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "{",
                                "horiz-adv-x": "389",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M28.9989 200.99l0 117.008c23.8245,1.32733 41.6648,4.8369 53.8358,10.8436 11.991,5.82677 22.3397,15.658 31.1586,29.4938 8.84139,13.8358 14.8481,31.1586 18.1777,51.991 2.49719,15.6805 3.82452,42.8346 3.82452,81.6648 0,63.1721 3.01462,107.177 8.84139,132.171 5.82677,24.9944 16.333,44.9944 31.6535,60.18 15.3431,15.1631 37.6828,26.9966 66.8391,35.8155 19.8425,5.84927 51.1811,8.84139 93.8358,8.84139l25.8268 0 0 -117.008c-36.333,0 -59.4826,-1.97975 -69.8313,-6.16423 -10.3262,-4.0045 -17.8178,-10.1687 -22.8346,-18.4927 -4.8369,-8.32396 -7.33408,-22.4972 -7.33408,-42.6772 0,-20.4949 -1.32733,-59.4826 -3.982,-116.648 -1.68729,-32.351 -5.84927,-58.3352 -12.6659,-78.5152 -6.83915,-20 -15.5006,-36.4904 -26.1867,-49.4938 -10.4837,-13.0034 -26.6592,-26.5017 -48.4814,-40.4949 19.3251,-11.0011 34.9831,-24.0045 47.3341,-38.8301 12.3285,-14.8481 21.6648,-32.8459 28.1665,-54.0157 6.65917,-21.1699 10.8211,-49.6513 12.8234,-85.1519 2.00225,-54.0157 2.99213,-88.6839 2.99213,-103.667 0,-21.5073 2.67717,-36.5129 7.85152,-45.0169 5.15186,-8.32396 12.9809,-14.8256 23.667,-19.1676 10.4837,-4.49944 33.3183,-6.65917 68.4814,-6.65917l0 -117.008 -25.8268 0c-44.0045,0 -77.6603,3.50956 -101.17,10.5062 -23.3296,6.99663 -43.1721,18.6727 -59.1676,35.0056 -16.153,16.1755 -26.9966,36.333 -32.4859,60.3375 -5.51181,23.8245 -8.34646,61.6648 -8.34646,113.161 0,59.8425 -2.65467,98.8301 -7.82902,116.67 -7.1766,26.1642 -17.9978,44.8369 -32.5084,55.9955 -14.4882,11.3386 -36.6479,17.6603 -66.6592,19.3251z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "j",
                                "horiz-adv-x": "277",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M68.9989 588.999l0 126.997 137.008 0 0 -126.997 -137.008 0zm137.008 -69.9888l0 -502.52c0,-65.9843 -4.34196,-112.666 -13.0034,-139.82 -8.50394,-27.1766 -25.1744,-48.5039 -49.8313,-63.667 -24.4994,-15.3431 -55.838,-23.0146 -94.0157,-23.0146 -13.6558,0 -28.324,1.16985 -44.162,3.66704 -15.838,2.33971 -32.8234,6.00675 -51.0011,11.0011l23.5096 116.67c6.50169,-1.16985 12.6659,-2.31721 18.4927,-3.14961 5.66929,-0.854893 11.0011,-1.16985 15.9955,-1.16985 14.0157,0 25.6693,2.99213 34.6682,8.99888 8.99888,5.98425 15.0056,13.3183 17.8403,21.8223 2.99213,8.50394 4.49944,33.8358 4.49944,76.1755l0 495.006 137.008 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "Y",
                                "horiz-adv-x": "666",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M260.99 0l0 301.327 -262.497 414.668 169.516 0 169.314 -283.487 164.837 283.487 166.344 0 -262.497 -415.658 0 -300.337 -145.017 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "H",
                                "horiz-adv-x": "722",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M73.0034 0l0 715.996 144.994 0 0 -282.002 282.002 0 0 282.002 144.994 0 0 -715.996 -144.994 0 0 313.003 -282.002 0 0 -313.003 -144.994 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "7",
                                "horiz-adv-x": "556",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M42.0022 580l0 126.997 469.989 0 0 -100c-38.8301,-38.1552 -78.1552,-92.8234 -118.335,-164.162 -40,-71.3386 -70.6637,-147.177 -91.6535,-227.492 -21.0124,-80.3375 -31.3386,-152.171 -31.0011,-215.343l-131.991 0c2.31721,99.1676 22.6547,200.337 61.1474,303.51 38.6727,102.992 90.0112,195.321 154.511,276.49l-312.666 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "&",
                                "horiz-adv-x": "722",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M706.007 86.8391l-83.1721 -105.849c-40.6749,19.8425 -79.8425,47.1766 -117.345,82.0022 -28.8189,-25.9843 -59.6625,-45.1519 -92.1485,-57.5028 -32.5084,-12.3285 -71.1811,-18.4927 -116.175,-18.4927 -88.9989,0 -155.996,25.1744 -200.99,75.3431 -34.8481,38.6502 -52.171,83.3296 -52.171,133.836 0,45.9843 13.6558,87.3341 41.1699,123.982 27.3341,36.6704 68.324,68.5039 122.835,95.5006 -24.4994,28.9989 -43.0146,56.6704 -55.3431,83.0146 -12.5084,26.3217 -18.6727,51.1586 -18.6727,74.6682 0,43.3296 17.3453,80.1575 52.0135,110.326 34.4882,30.1687 84.0045,45.3318 147.987,45.3318 61.6648,0 110.011,-15.838 144.837,-47.3341 34.8256,-31.6535 52.171,-70.1687 52.171,-115.838 0,-28.9989 -8.50394,-56.4904 -25.6693,-82.4972 -17.1654,-26.0067 -51.676,-55.5006 -103.667,-88.324l98.4927 -132.508c11.676,20.6749 21.6648,47.829 30.1687,81.1699l124.342 -27.829c-12.3285,-44.0045 -23.1721,-76.333 -32.3285,-96.6704 -8.99888,-20.3375 -18.8301,-37.5028 -29.3363,-51.1586 15.3206,-14.3532 35.1631,-30.0112 59.5051,-47.1766 24.3195,-17.1654 42.1597,-28.5039 53.4983,-33.9933zm-373.498 389.989l36.8279 28.5039c27.1541,21.1699 40.6749,42.1597 40.6749,62.9921 0,17.6828 -6.50169,32.6659 -19.685,45.0169 -13.0034,12.4859 -30.6637,18.6502 -53.0034,18.6502 -21.6648,0 -38.6502,-5.48931 -50.9786,-16.333 -12.171,-11.0011 -18.3352,-23.667 -18.3352,-37.9978 0,-16.9854 10.3262,-37.5028 31.0011,-61.6648l33.4983 -39.1676zm-53.6783 -149.336c-31.3386,-15.9955 -54.8256,-35.3206 -70.5062,-57.8178 -15.5006,-22.4972 -23.3296,-45.5118 -23.3296,-68.8414 0,-29.6738 9.67379,-53.9933 28.9989,-72.6659 19.1676,-18.8301 45.0169,-28.1665 77.5028,-28.1665 21.3273,0 42.0022,4.16198 61.6648,12.6659 19.8425,8.50394 41.3498,22.4972 64.6794,42.1597l-139.01 172.666z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xef",
                                "horiz-adv-x": "277",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M71.991 0l0 519.01 137.008 0 0 -519.01 -137.008 0zm-88.4814 586.007l0 117.998 117.998 0 0 -117.998 -117.998 0zm210.484 0l0 117.998 117.998 0 0 -117.998 -117.998 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xde",
                                "horiz-adv-x": "666",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M73.0034 0l0 715.996 144.994 0 0 -135.006 87.1766 0c87.829,0 145.152,-3.48706 172.148,-10.6637 40.8549,-11.1586 75.0056,-34.6682 102.52,-70.4837 27.4916,-36.018 41.1474,-82.5197 41.1474,-139.348 0,-43.667 -7.9865,-80.3375 -23.8245,-110.326 -15.9955,-30.0112 -36.1755,-53.4983 -60.6749,-70.8436 -24.4994,-17.1654 -49.4938,-28.324 -74.8256,-33.6558 -34.4882,-7.1766 -84.342,-10.6637 -149.674,-10.6637l-93.9933 0 0 -135.006 -144.994 0zm144.994 460l0 -204.004 78.8301 0c53.8358,0 88.009,1.84477 102.677,5.33183 20.1575,5.01687 37.1654,15.6805 51.3386,32.3285 14.1507,16.6704 21.1474,38.6727 21.1474,66.0067 0,22.1597 -5.64679,41.5073 -16.8279,57.9978 -11.1586,16.5129 -24.8369,27.6715 -40.8324,33.4983 -15.9955,5.84927 -58.3352,8.84139 -126.839,8.84139l-69.4938 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xcd",
                                "horiz-adv-x": "277",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M68.009 0l0 715.996 144.994 0 0 -715.996 -144.994 0zm-23.0146 780.99l68.009 146.007 153.003 0 -135.006 -146.007 -86.0067 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xbc",
                                "horiz-adv-x": "833",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M242.992 355.006l-92.9809 0 0 251.001c-30.6862,-21.1699 -65.6693,-37.1654 -105.017,-48.009l0 75.9955c31.0011,8.84139 59.1676,22.8346 84.342,42.3397 17.6603,13.6783 30.5062,29.8313 38.3352,48.6614l75.3206 0 0 -369.989zm1.50731 -381.012l-77.6603 0 422.497 751.001 77.5028 0 -422.34 -751.001zm439.505 5.01687l0 71.991 -175.996 0 0 68.9989 186.817 228.999 76.1755 0 0 -226.997 51.991 0 0 -71.0011 -51.991 0 0 -71.991 -86.9966 0zm0 142.992l0 108.166 -88.1665 -108.166 88.1665 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xab",
                                "horiz-adv-x": "556",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M308.999 480l-126.997 -220.337 126.997 -225.669 -106.997 0 -155.006 225.669 155.006 220.337 106.997 0zm191.001 0l-126.007 -220.337 126.007 -225.669 -106.997 0 -155.006 225.669 155.006 220.337 106.997 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\x9a",
                                "horiz-adv-x": "750",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M124.994 0l0 624.994 500 0 0 -624.994 -500 0zm15.9955 15.9955l468.009 0 0 593.003 -468.009 0 0 -593.003z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\x89",
                                "horiz-adv-x": "750",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M124.994 0l0 624.994 500 0 0 -624.994 -500 0zm15.9955 15.9955l468.009 0 0 593.003 -468.009 0 0 -593.003z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "x",
                                "horiz-adv-x": "556",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M5.48931 0l187.019 267.334 -179.01 251.676 167.334 0 91.676 -142.677 97.3228 142.677 160.675 0 -175.838 -245.849 191.834 -273.161 -167.177 0 -106.817 160.832 -106.344 -160.832 -160.675 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "g",
                                "horiz-adv-x": "610",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M59.0101 -33.0034l156.985 -18.9876c2.67717,-18.5152 8.66142,-31.1811 17.9978,-38.1777 13.1834,-9.83127 33.6783,-14.8256 61.6648,-14.8256 35.838,0 62.6772,5.33183 80.6749,16.153 11.991,7.1766 21.1699,18.6727 27.3341,34.6682 4.16198,11.3386 6.34421,32.5084 6.34421,63.0146l0.652418 75.8155c-41.3273,-56.4904 -93.3408,-84.6569 -155.996,-84.6569 -69.6738,0 -124.994,29.4938 -165.669,88.324 -31.991,46.5017 -48.009,104.499 -48.009,173.678 0,86.9966 21.0124,153.341 62.8346,199.168 41.8448,45.8268 94.0157,68.8414 156.333,68.8414 64.1845,0 117.165,-28.189 158.853,-84.5219l0 73.5208 127.987 0 0 -465.354c0,-61.1474 -4.99438,-106.997 -15.1631,-137.165 -10.0112,-30.3262 -24.162,-53.9933 -42.4972,-71.3161 -18.1777,-17.1654 -42.4972,-30.8436 -73.0034,-40.5174 -30.5062,-9.83127 -68.9989,-14.6682 -115.501,-14.6682 -88.009,0 -150.326,15.1856 -187.177,45.3543 -36.8279,30.3262 -55.1631,68.4814 -55.1631,114.983 0,4.49944 0.179978,10.1687 0.517435,16.6704zm122.992 303.015c0,-55.0056 10.6637,-95.1856 31.8335,-120.675 21.3273,-25.5118 47.6715,-38.3352 78.8301,-38.3352 33.3408,0 61.6648,13.1609 84.6569,39.3251 23.1721,26.1642 34.6682,64.8369 34.6682,116.175 0,53.6558 -11.0011,93.4983 -33.1609,119.505 -22.0022,25.9843 -49.9888,38.9876 -83.8245,38.9876 -32.8459,0 -59.8425,-12.8234 -81.1699,-38.3352 -21.1699,-25.4893 -31.8335,-64.3195 -31.8335,-116.648z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "V",
                                "horiz-adv-x": "666",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M256.175 0l-256.175 715.996 156.67 0 181.822 -529.989 174.511 529.989 153.993 0 -254.668 -715.996 -156.153 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "E",
                                "horiz-adv-x": "666",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M73.0034 0l0 715.996 529.989 0 0 -120.99 -384.994 0 0 -159.01 357.998 0 0 -120.99 -357.998 0 0 -194.016 399.01 0 0 -120.99 -544.004 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "4",
                                "horiz-adv-x": "556",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M311.001 0l0 144.004 -291.991 0 0 119.505 309.651 455.501 115.343 0 0 -455.006 88.9989 0 0 -120 -88.9989 0 0 -144.004 -133.003 0zm0 264.004l0 244.499 -163.667 -244.499 163.667 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "#",
                                "horiz-adv-x": "556",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M75.838 177.998l-66.8391 0 0 108.009 88.8414 0 29.3363 144.004 -118.178 0 0 107.987 140.157 0 38.8526 190.011 110.169 0 -38.6727 -190.011 104.994 0 37.5028 190.011 114.173 0 -38.6727 -190.011 66.5017 0 0 -107.987 -88.3465 0 -29.1564 -144.004 117.503 0 0 -108.009 -139.505 0 -38.4927 -189.989 -110.011 0 37.5028 189.989 -107.492 0 -38.8301 -189.989 -110.169 0 38.8301 189.989zm161.485 252.013l-29.3138 -144.004 106.817 0 28.3465 144.004 -105.849 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xfd",
                                "horiz-adv-x": "556",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M6.00675 519.01l145.984 0 124.499 -368.166 121.507 368.166 142.002 0 -182.992 -499.505 -33.0034 -90.1687c-12.171,-30.1687 -23.667,-53.1609 -34.6682,-69.1789 -10.8436,-15.8155 -23.5096,-28.8189 -37.6603,-38.6502 -14.1732,-10.0112 -31.676,-17.6828 -52.5084,-23.1721 -20.6749,-5.51181 -44.162,-8.34646 -70.3262,-8.34646 -26.3442,0 -52.351,2.83465 -77.8403,8.34646l-11.991 106.997c21.4848,-4.16198 40.9899,-6.32171 58.3127,-6.32171 32.0135,0 55.6805,9.31384 71.0011,28.1665 15.3431,18.8301 27.1766,42.8121 35.3431,71.8335l-197.66 520zm202.002 66.9966l67.9865 145.984 153.003 0 -135.006 -145.984 -85.9843 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xec",
                                "horiz-adv-x": "277",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M71.991 0l0 519.01 137.008 0 0 -519.01 -137.008 0zm164.004 586.007l-85.9843 0 -135.006 145.984 153.003 0 67.9865 -145.984z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xdb",
                                "horiz-adv-x": "722",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M73.0034 715.996l144.994 0 0 -387.987c0,-61.6648 1.84477,-101.507 5.33183,-119.685 6.16423,-29.3138 20.6749,-52.9809 43.667,-70.6637 23.1721,-17.8178 54.6682,-26.6592 94.6682,-26.6592 40.4949,0 71.1586,8.32396 91.8335,25.1744 20.6749,16.8279 33.0034,37.3228 37.1654,61.8223 4.16198,24.4994 6.34421,64.9944 6.34421,121.665l0 396.333 144.994 0 0 -376.49c0,-86.0067 -3.82452,-146.839 -11.676,-182.34 -7.82902,-35.5006 -22.1597,-65.4893 -43.1496,-89.9888 -20.8324,-24.4994 -48.8414,-43.847 -83.847,-58.3352 -35.1631,-14.5107 -80.8324,-21.8448 -137.323,-21.8448 -68.1665,0 -119.843,7.82902 -155.006,23.667 -35.1631,15.838 -62.9921,36.333 -83.5096,61.6648 -20.4949,25.3318 -33.8358,51.676 -40.315,79.5051 -9.51631,40.9899 -14.1732,101.665 -14.1732,181.822l0 382.34zm124.994 64.9944l102.497 144.004 126.344 0 101.17 -144.004 -110.011 0 -56.4904 73.0034 -52.5084 -73.0034 -111.001 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xca",
                                "horiz-adv-x": "666",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M73.0034 0l0 715.996 529.989 0 0 -120.99 -384.994 0 0 -159.01 357.998 0 0 -120.99 -357.998 0 0 -194.016 399.01 0 0 -120.99 -544.004 0zm109.989 780.99l102.497 144.004 126.344 0 101.17 -144.004 -110.011 0 -56.4904 73.0034 -52.5084 -73.0034 -111.001 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xb9",
                                "horiz-adv-x": "333",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M242.002 355.006l-93.0034 0 0 251.001c-30.6637,-21.1699 -65.6693,-37.1654 -104.994,-48.009l0 75.9955c31.0011,8.84139 59.1676,22.8346 84.3195,42.3397 17.6828,13.6783 30.5062,29.8313 38.3352,48.6614l75.3431 0 0 -369.989z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xa8",
                                "horiz-adv-x": "333",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M2.49719 610.011l0 117.998 117.998 0 0 -117.998 -117.998 0zm210.506 0l0 117.998 117.998 0 0 -117.998 -117.998 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\x97",
                                "horiz-adv-x": "750",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M124.994 0l0 624.994 500 0 0 -624.994 -500 0zm15.9955 15.9955l468.009 0 0 593.003 -468.009 0 0 -593.003z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\x86",
                                "horiz-adv-x": "750",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M124.994 0l0 624.994 500 0 0 -624.994 -500 0zm15.9955 15.9955l468.009 0 0 593.003 -468.009 0 0 -593.003z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "u",
                                "horiz-adv-x": "610",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M415.006 0l0 77.6603c-19.0101,-27.649 -43.847,-49.6513 -74.6682,-66.1642 -30.8436,-16.333 -63.3296,-24.4994 -97.5028,-24.4994 -35.0056,0 -66.3442,7.67154 -93.9933,23.0146 -27.8515,15.3206 -47.8515,36.9854 -60.18,64.6569 -12.4859,27.829 -18.6502,66.1642 -18.6502,115.163l0 329.179 136.985 0 0 -239.01c0,-73.1609 2.49719,-117.84 7.67154,-134.331 4.99438,-16.5129 14.1732,-29.6738 27.6715,-39.1676 13.3183,-9.67379 30.3262,-14.5107 51.0011,-14.5107 23.4871,0 44.4994,6.50169 63.1496,19.3476 18.6727,12.8234 31.3386,28.8189 38.1777,47.9865 6.83915,19.1676 10.3262,65.8493 10.3262,140.337l0 219.348 137.008 0 0 -519.01 -126.997 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "d",
                                "horiz-adv-x": "610",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M548.009 0l-127.019 0 0 76.1755c-21.1474,-29.6738 -46.3217,-51.8335 -75.1631,-66.8391 -28.8189,-14.8256 -57.9978,-22.3397 -87.3341,-22.3397 -59.82,0 -111.001,24.0045 -153.656,72.171 -42.4972,48.1665 -63.847,115.163 -63.847,201.327 0,88.009 20.6749,155.006 62.1822,200.832 41.4848,45.8493 93.8358,68.6839 157.165,68.6839 57.9978,0 108.324,-24.1845 150.664,-72.351l0 258.335 137.008 0 0 -715.996zm-366.007 269.494c0,-55.5006 7.67154,-95.658 22.8346,-120.495 22.1597,-35.9955 53.0034,-53.9933 92.6659,-53.9933 31.4961,0 58.3352,13.4983 80.3375,40.4949 22.1597,26.9966 33.1609,67.1766 33.1609,120.832 0,59.8425 -10.6637,102.835 -32.171,129.156 -21.5073,26.3442 -48.8189,39.5051 -82.3397,39.5051 -32.4859,0 -59.6625,-13.0034 -81.6648,-38.9876 -21.8223,-26.0067 -32.8234,-64.8369 -32.8234,-116.513z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "S",
                                "horiz-adv-x": "666",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M35.0056 231.991l140.99 14.0157c8.50394,-47.1766 25.5118,-81.6648 51.3386,-103.847 25.8268,-22.1597 60.6749,-33.1609 104.499,-33.1609 46.3442,0 81.3273,9.83127 104.837,29.4938 23.4871,19.685 35.3206,42.6772 35.3206,68.9989 0,17.0079 -4.99438,31.3386 -14.8256,43.3521 -9.83127,11.8335 -27.1541,22.1597 -51.8335,30.8211 -16.8279,6.00675 -55.1631,16.333 -115.163,31.3386 -77.1654,19.3251 -131.339,42.9921 -162.497,71.1586 -43.847,39.5051 -65.6693,87.6715 -65.6693,144.499 0,36.5129 10.3262,70.8436 30.8211,102.677 20.6749,31.8335 50.3487,55.9955 89.1789,72.6659 38.8301,16.6704 85.4893,24.9944 140.495,24.9944 89.4938,0 157.008,-19.8425 202.16,-59.6625 45.3543,-39.8425 68.9989,-92.8459 71.3386,-159.325l-144.994 -5.01687c-6.16423,37.0079 -19.3251,63.5096 -39.5051,79.6625 -20.1575,16.1755 -50.5062,24.342 -90.8211,24.342 -41.6648,0 -74.3307,-8.66142 -97.8403,-26.0067 -15.1631,-11.1586 -22.8346,-25.9843 -22.8346,-44.6569 0,-17.0079 7.1766,-31.4961 21.5073,-43.5096 18.1552,-15.5006 62.3172,-31.4961 132.486,-48.1665 70.1687,-16.4904 122.002,-33.8358 155.501,-51.4961 33.6783,-17.8403 60,-42.0022 79.0101,-72.8234 18.9876,-30.8436 28.5039,-68.8414 28.5039,-114.016 0,-40.9899 -11.3386,-79.4826 -34.1732,-115.321 -22.8346,-35.838 -55.0056,-62.4972 -96.6704,-79.8425 -41.6648,-17.5028 -93.6558,-26.1642 -155.838,-26.1642 -90.4837,0 -160,20.8324 -208.504,62.6772 -48.4814,41.6648 -77.3228,102.497 -86.8166,182.317z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "B",
                                "horiz-adv-x": "722",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M73.0034 715.996l286.322 0c56.8504,0 99.0101,-2.33971 126.839,-6.99663 28.009,-4.8369 52.8459,-14.6682 74.8256,-29.4938 22.0022,-15.0056 40.3375,-34.8481 55.0056,-59.6625 14.6682,-24.8369 22.0022,-52.8459 22.0022,-83.667 0,-33.3408 -8.99888,-64.1845 -26.9966,-92.0135 -17.9978,-27.9865 -42.4972,-48.8189 -73.3408,-62.8346 43.5096,-12.8234 76.8504,-34.4882 100.337,-65.1519 23.3296,-30.6862 35.0056,-66.6817 35.0056,-108.166 0,-32.6659 -7.51406,-64.342 -22.6772,-95.1856 -15.1631,-30.8211 -35.8155,-55.5006 -62.1597,-73.9933 -26.1642,-18.3352 -58.4927,-29.6738 -97.0079,-33.9933 -23.982,-2.49719 -82.1597,-4.16198 -174.331,-4.8369l-243.825 0 0 715.996zm144.994 -118.988l0 -165.017 94.6682 0c56.1755,0 91.1586,0.832396 104.837,2.51969 24.6569,2.81215 44.162,11.3161 58.3352,25.4893 14.1732,14.1732 21.1699,32.6659 21.1699,55.658 0,22.1822 -6.16423,40 -18.3352,53.8358 -12.171,13.8358 -30.3487,22.1822 -54.3307,25.0169 -14.3307,1.66479 -55.5006,2.49719 -123.352,2.49719l-82.9921 0zm0 -284.004l0 -192.013 133.993 0c52.0135,0 85.1744,1.50731 99.1676,4.34196 21.5073,4.0045 39.0101,13.4983 52.5084,28.6614 13.4983,15.3431 20.3375,35.5006 20.3375,61.0124 0,21.6648 -5.17435,39.82 -15.6805,54.8256 -10.3262,15.0056 -25.4893,26.0067 -45.1519,32.8459 -19.6625,6.81665 -62.4972,10.3262 -128.346,10.3262l-116.828 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "1",
                                "horiz-adv-x": "556",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M393.003 0l-137.008 0 0 518.335c-49.9888,-46.9966 -108.999,-81.8448 -176.985,-104.342l0 125.017c35.8155,11.6535 74.6457,33.8133 116.49,66.6592 42.0022,32.6659 70.6637,70.8211 86.3217,114.331l111.181 0 0 -720z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: " ",
                                "horiz-adv-x": "277"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xfa",
                                "horiz-adv-x": "610",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M415.006 0l0 77.6603c-19.0101,-27.649 -43.847,-49.6513 -74.6682,-66.1642 -30.8436,-16.333 -63.3296,-24.4994 -97.5028,-24.4994 -35.0056,0 -66.3442,7.67154 -93.9933,23.0146 -27.8515,15.3206 -47.8515,36.9854 -60.18,64.6569 -12.4859,27.829 -18.6502,66.1642 -18.6502,115.163l0 329.179 136.985 0 0 -239.01c0,-73.1609 2.49719,-117.84 7.67154,-134.331 4.99438,-16.5129 14.1732,-29.6738 27.6715,-39.1676 13.3183,-9.67379 30.3262,-14.5107 51.0011,-14.5107 23.4871,0 44.4994,6.50169 63.1496,19.3476 18.6727,12.8234 31.3386,28.8189 38.1777,47.9865 6.83915,19.1676 10.3262,65.8493 10.3262,140.337l0 219.348 137.008 0 0 -519.01 -126.997 0zm-181.012 586.007l68.009 145.984 153.003 0 -135.006 -145.984 -86.0067 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xe9",
                                "horiz-adv-x": "556",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M371.991 164.004l137.008 -23.0146c-17.5028,-50.1462 -45.3318,-88.324 -83.1721,-114.646 -37.9978,-26.1867 -85.4893,-39.3476 -142.317,-39.3476 -90.1687,0 -157.008,29.4938 -200.18,88.5039 -34.1732,47.3341 -51.3386,106.997 -51.3386,179.168 0,86.0067 22.5197,153.498 67.3341,202.16 44.8369,48.8414 101.665,73.1834 170.349,73.1834 76.9854,0 137.818,-25.5118 182.497,-76.5129 44.4994,-51.0011 65.8268,-129.156 63.8245,-234.488l-342.992 0c0.989876,-40.6749 11.991,-72.351 33.1609,-95.0056 21.0124,-22.6772 47.3341,-33.9933 78.6727,-33.9933 21.5073,0 39.5051,5.82677 53.9933,17.4803 14.6682,11.676 25.6693,30.5062 33.1609,56.5129zm8.009 138.988c-0.989876,39.8425 -11.1586,70.1687 -30.6637,90.8436 -19.5051,20.8324 -43.1721,31.1586 -71.1586,31.1586 -29.8538,0 -54.5107,-11.0011 -74.0157,-32.8234 -19.5051,-21.8448 -28.9989,-51.676 -28.6614,-89.1789l204.499 0zm-177.008 283.015l68.009 145.984 153.003 0 -135.006 -145.984 -86.0067 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xd8",
                                "horiz-adv-x": "777",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M604.837 663.667l77.6603 86.8391 68.009 -60 -82.0022 -91.8335c21.6648,-29.3363 38.4927,-65.5118 50.5062,-108.346 11.991,-42.8346 17.9978,-88.324 17.9978,-136.67 0,-113.656 -31.5186,-203.33 -94.3307,-268.661 -63.0146,-65.3318 -146.007,-97.9978 -249.336,-97.9978 -89.6738,0 -161.35,20.8324 -215.163,62.6772l-79.685 -89.1789 -68.9989 61.0124 83.847 93.6558c-47.5141,63.5096 -71.3386,146.164 -71.3386,248.009 0,113.003 31.4961,202.16 94.3307,267.672 62.9921,65.4893 146.839,98.1552 251.834,98.1552 86.9966,0 159.325,-21.8223 216.67,-65.3318zm-90.1687 -100.495c-32.8459,27.829 -74.6682,41.8223 -125.174,41.8223 -59.3251,0 -107.154,-20.4949 -143.667,-61.3273 -36.4904,-40.8324 -54.8256,-102.497 -54.8256,-184.837 0,-51.6535 7.1766,-95.9955 21.6648,-132.823l302.002 337.165zm53.4983 -76.8279l-301.507 -337.683c33.6783,-29.8313 74.1732,-44.6569 121.665,-44.6569 58.1777,0 106.007,20.9899 143.51,63.1721 37.5028,42.1597 56.1755,104.994 56.1755,188.481 0,52.8459 -6.68166,96.333 -19.8425,130.686z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xc7",
                                "horiz-adv-x": "722",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M531.001 264.004l140 -43.0146c-21.5073,-78.8301 -57.3453,-137.323 -107.334,-175.658 -50.0112,-38.1552 -113.341,-57.3228 -190.169,-57.3228 -95.1631,0 -173.341,32.4859 -234.668,97.4803 -61.1699,65.0169 -91.8335,153.836 -91.8335,266.682 0,119.168 30.8436,211.834 92.3285,277.84 61.5073,65.9843 142.497,98.9876 242.835,98.9876 87.6715,0 158.83,-26.0067 213.498,-77.8403 32.6659,-30.6637 57.0079,-74.6682 73.3408,-132.148l-142.992 -34.0157c-8.50394,37.0079 -26.1642,66.3442 -53.0034,87.829 -26.9966,21.5073 -59.6625,32.171 -97.9978,32.171 -53.1834,0 -96.333,-18.9876 -129.336,-57.1654 -33.1609,-37.9978 -49.6738,-99.6625 -49.6738,-184.994 0,-90.3262 16.333,-154.826 48.8414,-193.161 32.6659,-38.5152 75.0056,-57.6828 127.154,-57.6828 38.5152,0 71.676,12.171 99.3476,36.6704 27.6715,24.4994 47.6715,62.8346 59.6625,115.343zm-314.511 -455.006l0 57.3453c33.6783,-3.50956 64.4994,-5.35433 92.6659,-5.35433 29.0214,0 50.6862,5.17435 64.6794,15.6805 10.8211,7.82902 16.1755,17.8403 16.1755,30.3262 0,11.0011 -5.01687,20.6749 -15.1856,28.8414 -10.1687,8.16648 -25.8268,12.171 -46.9966,12.171 -20.9899,0 -42.3397,-3.35208 -64.3195,-9.83127l12.8234 48.4814c25.3318,8.99888 52.6659,13.3408 82.0022,13.3408 40.8324,0 71.676,-8.99888 92.8234,-26.8391 21.1699,-17.9978 31.8335,-39.82 31.8335,-65.4893 0,-28.8414 -11.6535,-52.0135 -35.1631,-70.0112 -31.6535,-24.4994 -76.9854,-36.6704 -135.996,-36.6704 -42.0022,0 -73.8358,2.67717 -95.3431,8.009z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xb6",
                                "horiz-adv-x": "556",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M311.001 -195.996l-119.01 0 0 511.001c-61.6648,4.49944 -109.156,24.3195 -142.317,59.5051 -33.1834,35.1631 -49.6738,81.6648 -49.6738,139.483 0,34.1732 6.65917,65.5118 20,94.0157 13.3408,28.324 31.3386,51.0011 53.9933,67.4916 22.4972,16.6704 49.1789,28.1665 79.6625,34.6682 18.3352,3.82452 54.0157,5.82677 107.019,5.82677l291.316 0 0 -126.997 -54.9831 0 0 -784.994 -116.018 0 0 784.994 -69.9888 0 0 -784.994z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xa5",
                                "horiz-adv-x": "556",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M206.007 135.006l-182.002 0 0 106.997 182.002 0 0 58.9876 -182.002 0 0 107.019 128.819 0 -152.823 307.987 150.011 0 94.4882 -209.989c11.8335,-26.1642 22.0022,-48.5039 30.3262,-66.9966 9.17885,20.1575 19.3476,42.4972 30.5062,66.9966l95.658 209.989 150.011 0 -154.331 -307.987 130.326 0 0 -107.019 -184.004 0 0 -58.9876 184.004 0 0 -106.997 -184.004 0 0 -135.006 -136.985 0 0 135.006z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\x94",
                                "horiz-adv-x": "750",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M124.994 0l0 624.994 500 0 0 -624.994 -500 0zm15.9955 15.9955l468.009 0 0 593.003 -468.009 0 0 -593.003z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\x83",
                                "horiz-adv-x": "750",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M124.994 0l0 624.994 500 0 0 -624.994 -500 0zm15.9955 15.9955l468.009 0 0 593.003 -468.009 0 0 -593.003z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "r",
                                "horiz-adv-x": "389",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M202.992 0l-136.985 0 0 519.01 126.997 0 0 -73.6783c21.8223,34.8256 41.5073,57.6603 58.9876,68.5039 17.5028,10.8211 37.3453,16.1755 59.5051,16.1755 31.3386,0 61.5073,-8.68391 90.5062,-25.8493l-42.4972 -119.663c-23.1721,15.0056 -44.6794,22.4972 -64.4994,22.4972 -19.3476,0 -35.6805,-5.33183 -48.9989,-15.838 -13.3408,-10.6637 -23.847,-29.6513 -31.4961,-57.3228 -7.67154,-27.6715 -11.5186,-85.6693 -11.5186,-173.836l0 -160z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "a",
                                "horiz-adv-x": "556",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M173.993 359.01l-123.982 21.9798c13.9933,50.6862 38.1552,88.1665 72.3285,112.508 34.1507,24.342 84.9944,36.5129 152.328,36.5129 61.1699,0 106.839,-7.1766 136.828,-21.6873 29.8313,-14.4882 51.0011,-32.8234 63.1721,-55.1631 12.171,-22.3172 18.3352,-63.1496 18.3352,-122.835l-2.00225 -160c0,-45.4893 2.15973,-79.1676 6.50169,-100.832 4.31946,-21.6648 12.5084,-44.8369 24.4994,-69.4938l-135.996 0c-3.50956,8.99888 -8.009,22.3397 -13.1834,40 -2.15973,8.16648 -3.82452,13.4983 -4.8144,15.9955 -23.3521,-22.9921 -48.3465,-40.1575 -75.0056,-51.6535 -26.6592,-11.5186 -55.0056,-17.3453 -85.1744,-17.3453 -53.1609,0 -95.1631,14.5107 -125.827,43.5096 -30.6637,28.8189 -46.0067,65.4893 -46.0067,109.831 0,29.1564 6.99663,55.3206 21.0124,78.3352 13.9933,22.8346 33.4983,40.4949 58.8301,52.6659 25.1519,12.171 61.4848,22.8346 108.999,31.991 64.0045,12.0135 108.504,23.3296 133.161,33.6783l0 13.8358c0,26.6592 -6.50169,45.6468 -19.5051,57.1654 -13.1609,11.3161 -37.8178,16.9854 -73.9933,16.9854 -24.4994,0 -43.5096,-4.8369 -57.1654,-14.6682 -13.8358,-9.65129 -24.8369,-26.8166 -33.3408,-51.3161zm184.004 -111.001c-17.5028,-5.84927 -45.3318,-12.8459 -83.4871,-21.0124 -38.0202,-8.16648 -63.0146,-16.153 -74.6682,-23.8245 -17.8403,-12.8459 -26.8391,-28.8414 -26.8391,-48.3465 0,-19.3251 7.15411,-35.8155 21.5073,-49.8313 14.3307,-13.9933 32.4859,-20.9899 54.6457,-20.9899 24.6794,0 48.3465,8.16648 70.8436,24.3195 16.4904,12.5084 27.4916,27.5141 32.6659,45.5118 3.50956,11.6535 5.33183,33.9933 5.33183,66.8391l0 27.3341z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "P",
                                "horiz-adv-x": "666",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M73.0034 0l0 715.996 231.834 0c87.829,0 144.994,-3.48706 171.654,-10.6637 41.0124,-10.8211 75.3431,-34.1732 103.015,-70.1687 27.6715,-35.9955 41.4848,-82.4972 41.4848,-139.505 0,-43.982 -7.9865,-80.8324 -23.8245,-110.821 -15.9955,-30.0112 -36.1755,-53.4983 -60.6749,-70.6637 -24.4994,-17.0079 -49.4938,-28.3465 -74.8256,-33.8358 -34.4882,-6.83915 -84.342,-10.3262 -149.674,-10.3262l-93.9933 0 0 -270.011 -144.994 0zm144.994 595.006l0 -204.004 78.8301 0c56.8279,0 94.6682,3.82452 113.836,11.3386 19.1676,7.49156 34.1732,19.1676 44.9944,35.3206 10.8436,15.9955 16.333,34.5107 16.333,55.838 0,26.1642 -7.64904,47.6715 -22.8346,64.6794 -15.3206,16.9854 -34.4882,27.649 -57.9978,31.991 -17.1654,3.1721 -51.6535,4.8369 -103.667,4.8369l-69.4938 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "?",
                                "horiz-adv-x": "610",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M366.997 184.004l-124.994 0c-0.337458,17.9978 -0.494938,28.8189 -0.494938,32.8234 0,40.3375 6.65917,73.4983 20.1575,99.6625 13.3408,26.0067 40,55.3431 80.1575,88.009 40.18,32.5084 64.1845,53.8358 72.0135,64.0045 12.171,15.9955 18.1552,33.6558 18.1552,52.8234 0,26.5017 -10.6637,49.3363 -32.1485,68.1665 -21.3498,19.0101 -50.1687,28.5039 -86.5017,28.5039 -35.0056,0 -64.1845,-9.98875 -87.8515,-29.8313 -23.4871,-20 -39.6625,-50.3262 -48.4814,-91.1586l-126.007 15.9955c3.66704,58.4927 28.5039,107.987 74.6682,148.819 46.1642,40.8549 106.839,61.1699 181.822,61.1699 79.0101,0 141.845,-20.6524 188.504,-61.8223 46.6817,-41.1699 70.0112,-88.9989 70.0112,-143.847 0,-30.1462 -8.50394,-58.9876 -25.6693,-85.9843 -17.1654,-26.9966 -53.6783,-63.847 -109.831,-110.506 -28.9989,-24.0045 -46.9966,-43.5096 -54.0157,-58.1552 -6.99663,-14.6682 -10.1462,-40.8549 -9.49381,-78.6727zm-124.994 -184.004l0 137.008 124.994 0 0 -137.008 -124.994 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: ".",
                                "horiz-adv-x": "277",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M71.0011 0l0 137.008 137.008 0 0 -137.008 -137.008 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xf7",
                                "horiz-adv-x": "548",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M206.007 479.01l0 136.985 136.985 0 0 -136.985 -136.985 0zm-182.002 -190.011l0 128.009 500.99 0 0 -128.009 -500.99 0zm182.002 -198.988l0 136.985 136.985 0 0 -136.985 -136.985 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xe6",
                                "horiz-adv-x": "889",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M700.99 164.004l134.016 -24.0045c-18.5152,-51.0011 -46.6817,-89.1564 -84.4994,-114.668 -37.6828,-25.4893 -85.8493,-38.3352 -144.342,-38.3352 -36.4904,0 -70.1687,6.00675 -100.99,17.8403 -31.0011,11.991 -59.0101,29.9888 -84.0045,53.8358 -23.1721,-20 -53.0034,-36.8504 -89.4938,-50.8436 -36.6704,-13.8358 -74.3532,-20.8324 -113.003,-20.8324 -55.3431,0 -98.3352,14.5107 -129.336,43.3296 -30.8436,28.8414 -46.3442,65.1744 -46.3442,109.179 0,26.3217 5.51181,49.8313 16.333,70.3262 11.0011,20.6749 24.1845,36.6704 39.685,48.1665 15.5006,11.676 37.1654,21.6648 64.8144,30.1687 13.0034,4.16198 51.8335,13.0034 116.513,26.3442 32.3285,6.81665 59.82,13.9933 82.6547,21.4848l0 13.8358c0,25.1744 -6.81665,44.0045 -20.6524,56.5129 -13.6783,12.4859 -35.3431,18.6502 -65.1744,18.6502 -26.1642,0 -46.9966,-5.33183 -62.3397,-16.153 -15.3206,-10.6637 -26.3217,-27.3341 -32.8234,-49.8313l-124.004 23.982c16.333,50.5062 41.8448,87.6715 76.8279,111.339 34.8481,23.847 88.1665,35.6805 159.685,35.6805 33.8133,0 63.982,-4.0045 90.4837,-12.0135 26.5017,-7.9865 49.1789,-19.82 68.009,-35.838 19.82,16.018 41.5073,27.8515 64.9944,35.838 23.667,8.009 48.8414,12.0135 75.838,12.0135 51.991,0 95.9955,-11.0011 131.834,-33.0034 35.9955,-22.0022 64.162,-54.5107 84.8369,-97.3453 20.6524,-42.8346 30.8211,-103.487 30.4837,-181.665l-343.982 0c5.48931,-44.342 17.8178,-76.333 37.1654,-96.1755 19.1676,-19.82 42.6547,-29.8313 70.6637,-29.8313 23.1721,0 42.8346,5.84927 58.9876,17.6828 16.333,11.6535 28.6839,29.8313 37.1654,54.3307zm5.01687 140c-2.00225,28.6614 -5.84927,49.4938 -11.676,62.1597 -8.16648,18.3352 -20.3375,32.6659 -36.8279,43.1721 -16.333,10.5062 -35.6805,15.658 -57.6603,15.658 -19.1676,0 -36.018,-4.49944 -50.5062,-13.4983 -14.5107,-8.99888 -25.8268,-22.4972 -34.3307,-40.3375 -11.3386,-23.8245 -16.5129,-46.3217 -15.5006,-67.1541l206.502 0zm-345.017 -57.0079c-75.1631,-19.82 -115.996,-30.8211 -122.497,-33.1609 -21.6648,-7.1766 -36.9854,-15.838 -45.4893,-25.8268 -8.66142,-10.1687 -13.0034,-22.0022 -13.0034,-35.6805 0,-18.8301 6.99663,-35.0056 21.1699,-48.324 14.1732,-13.3408 32.6659,-20 55.5006,-20 24.0045,0 46.6592,7.67154 67.6715,22.9921 15.658,11.3386 25.6693,25.5118 29.9888,42.6772 4.49944,16.9854 6.65917,49.4938 6.65917,97.3228z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xd5",
                                "horiz-adv-x": "777",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M42.9921 353.656c0,73.0034 11.0011,134.353 32.8459,184.004 16.153,36.5129 38.4927,69.3363 66.6592,98.3352 28.1665,28.9989 59.0101,50.5062 92.5084,64.6794 44.6569,18.8301 96.153,28.324 154.488,28.324 105.669,0 190.011,-32.8234 253.498,-98.3352 63.3521,-65.6693 95.0056,-156.828 95.0056,-273.656 0,-115.838 -31.4961,-206.502 -94.3307,-271.834 -62.8346,-65.5118 -146.997,-98.1777 -252.171,-98.1777 -106.502,0 -191.339,32.5084 -254.173,97.6603 -62.8121,65.0169 -94.3307,154.668 -94.3307,268.999zm148.999 4.8369c0,-81.1699 18.8526,-142.655 56.333,-184.657 37.5028,-41.8448 85.1744,-62.8346 142.835,-62.8346 57.8403,0 105.174,20.8324 142.34,62.3397 37.0079,41.6648 55.5006,103.982 55.5006,187.154 0,82.1822 -17.9978,143.51 -54.1732,183.847 -35.9955,40.4949 -83.8245,60.6524 -143.667,60.6524 -59.6625,0 -107.829,-20.4949 -144.319,-61.3273 -36.5129,-40.9899 -54.8481,-102.677 -54.8481,-185.174zm105.017 421.507l-63.0146 0c-0.337458,7.49156 -0.494938,13.3408 -0.494938,17.5028 0,34.1732 8.32396,60.4949 24.9944,78.8301 16.5129,18.4927 37.9978,27.6715 64.0045,27.6715 11.4961,0 22.0022,-1.16985 31.8335,-3.66704 9.83127,-2.49719 27.6715,-9.49381 53.4983,-21.0124 26.0067,-11.4961 46.1642,-17.3228 61.0124,-17.3228 10.3262,0 18.9876,3.32958 25.9843,9.83127 7.1766,6.65917 11.5186,17.6603 13.4983,33.1609l63.0146 0c-0.337458,-44.4994 -8.50394,-76.153 -24.4994,-95.3206 -16.1755,-19.1676 -36.8279,-28.6839 -62.1822,-28.6839 -11.1586,0 -21.9798,1.16985 -32.6659,3.50956 -7.49156,2.00225 -26.1642,8.99888 -55.9955,20.8324 -29.9888,11.8335 -51.6535,17.6603 -65.3318,17.6603 -10.5062,0 -18.4927,-3.14961 -24.3195,-9.65129 -6.00675,-6.34421 -9.02137,-17.5028 -9.33633,-33.3408z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xc4",
                                "horiz-adv-x": "722",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M717.998 0l-156.175 0 -61.8223 162.992 -287.177 0 -59.4826 -162.992 -153.341 0 277.998 715.996 153.161 0 286.839 -715.996zm-264.994 284.004l-99.5051 264.994 -96.6704 -264.994 196.175 0zm-257.503 496.985l0 118.02 117.998 0 0 -118.02 -117.998 0zm210.506 0l0 118.02 117.998 0 0 -118.02 -117.998 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xb3",
                                "horiz-adv-x": "333",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M20 463.172l90.0112 9.83127c2.49719,-17.9978 8.48144,-31.3386 17.8178,-40 9.33633,-8.66142 21.5073,-13.0034 36.6704,-13.0034 15.658,0 28.324,4.8369 37.9978,14.6682 9.67379,9.67379 14.5107,22.4972 14.5107,37.9978 0,13.9933 -4.67942,25.5118 -13.8358,34.6682 -9.17885,9.15636 -21.1699,13.6558 -35.9955,13.6558 -9.85377,0 -24.4994,-2.49719 -44.1845,-7.33408l11.0011 71.8335c16.8504,-0.314961 30.0112,1.34983 39.5051,5.01687 9.67379,3.66704 16.333,8.32396 20.4949,13.9933 4.0045,5.51181 6.00675,11.8335 6.00675,18.8301 0,9.33633 -3.32958,16.8279 -10.1687,22.8346 -6.83915,5.82677 -16.6704,8.84139 -29.9888,8.84139 -13.1834,0 -23.847,-3.66704 -31.8335,-11.0011 -8.16648,-7.33408 -13.3408,-19.6625 -16.018,-37.0079l-86.9966 12.6659c8.16648,33.6783 20.18,57.6603 35.9955,72.0135 24.6794,22.1597 58.3352,33.3183 101.17,33.3183 40.18,0 72.0135,-9.98875 95.5006,-30.1687 23.5096,-20 35.3431,-42.9921 35.3431,-68.9989 0,-12.171 -3.32958,-23.4871 -10.1687,-33.9933 -9.17885,-14.5107 -21.5073,-26.5017 -37.0079,-35.838 22.0022,-7.82902 38.6727,-19.3251 50.1687,-34.4882 11.3386,-15.1631 17.0079,-32.8459 17.0079,-53.1834 0,-31.0011 -13.6783,-58.3127 -41.0124,-82.3172 -27.3341,-24.0045 -63.1496,-35.9955 -107.649,-35.9955 -41.6648,0 -75.0056,10.3262 -100,30.8211 -25.0169,20.6749 -39.8425,48.009 -44.342,82.3397z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xa2",
                                "horiz-adv-x": "556",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M362.835 396.175l-88.6614 -295.186c7.15411,-1.32733 14.4882,-1.97975 22.0022,-1.97975 25.6468,0 46.8166,7.49156 63.4871,22.3172 16.8279,14.8481 28.5039,40.3375 35.3431,76.6704l135.006 -22.9921c-14.0157,-62.0022 -40.8549,-108.841 -80.5174,-140.495 -39.6625,-31.676 -92.6659,-47.5141 -159.168,-47.5141 -16.153,0 -32.6659,1.16985 -49.3363,3.50956l-56.8279 -187.334 -59.1676 17.8178 56.333 186.839c-45.1519,18.6727 -79.6625,50.3487 -104.004,94.8481 -24.162,44.4994 -36.333,97.1654 -36.333,157.818 0,84.4994 22.6772,150.506 67.8515,197.998 45.1519,47.6715 106.164,71.5186 182.992,71.5186 14.6682,0 29.9888,-1.01237 45.8268,-3.01462l55.3431 184.004 59.1676 -17.8403 -54.3307 -180.337c61.8223,-23.8245 103.487,-72.9809 125.152,-147.829l-134.983 -24.0045c-3.84702,23.0146 -12.351,41.3498 -25.1744,55.1856zm-56.8279 25.1519c-4.18448,0.337458 -8.16648,0.674916 -11.676,0.674916 -34.3307,0 -61.6648,-11.8335 -82.0022,-35.658 -20.1575,-23.847 -30.3262,-63.5096 -30.3262,-119.01 -0.337458,-63.3296 11.8335,-108.661 36.4904,-135.838l87.5141 289.831z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\x91",
                                "horiz-adv-x": "750",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M124.994 0l0 624.994 500 0 0 -624.994 -500 0zm15.9955 15.9955l468.009 0 0 593.003 -468.009 0 0 -593.003z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\x80",
                                "horiz-adv-x": "750",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M124.994 0l0 624.994 500 0 0 -624.994 -500 0zm15.9955 15.9955l468.009 0 0 593.003 -468.009 0 0 -593.003z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "o",
                                "horiz-adv-x": "610",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M40 265.827c0,45.6693 11.1586,89.8313 33.6558,132.508 22.5197,42.8346 54.3532,75.3206 95.5006,97.8403 41.1699,22.4972 87.0191,33.8358 137.84,33.8358 78.4927,0 142.677,-25.5118 192.846,-76.5129 50.1687,-51.1586 75.1631,-115.501 75.1631,-193.498 0,-78.6727 -25.3318,-143.825 -75.838,-195.501 -50.6637,-51.676 -114.331,-77.5028 -191.159,-77.5028 -47.5141,0 -92.8459,10.8436 -136.018,32.3285 -42.9921,21.5073 -75.8155,53.0034 -98.3352,94.6682 -22.4972,41.5073 -33.6558,92.171 -33.6558,151.834zm140.99 -7.33408c0,-51.4961 12.171,-91.0011 36.5129,-118.335 24.4994,-27.4916 54.4882,-41.1474 90.3262,-41.1474 35.6805,0 65.6693,13.6558 89.8313,41.1474 24.162,27.3341 36.333,67.1766 36.333,119.348 0,50.8211 -12.171,89.9888 -36.333,117.323 -24.162,27.5141 -54.1507,41.1699 -89.8313,41.1699 -35.838,0 -65.8268,-13.6558 -90.3262,-41.1699 -24.342,-27.3341 -36.5129,-66.8166 -36.5129,-118.335z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "^",
                                "horiz-adv-x": "584",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M55.9955 337.998l183.172 390.011 108.504 0 178.335 -390.011 -139.01 0 -95.658 238.673 -95.3431 -238.673 -140 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "M",
                                "horiz-adv-x": "833",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M71.0011 0l0 715.996 217.165 0 128.324 -488.324 126.839 488.324 217.66 0 0 -715.996 -133.993 0 -0.494938 563.667 -141.17 -563.667 -139.325 0 -140.517 563.667 -0.494938 -563.667 -133.993 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "<",
                                "horiz-adv-x": "584",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M537.008 82.0022l-491.001 213.341 0 118.155 491.001 212.508 0 -139.01 -342.497 -131.001 342.497 -135.996 0 -137.998z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "+",
                                "horiz-adv-x": "584",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M228.999 102.992l0 186.007 -188.009 0 0 128.009 188.009 0 0 185.984 124.994 0 0 -185.984 188.009 0 0 -128.009 -188.009 0 0 -186.007 -124.994 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xf4",
                                "horiz-adv-x": "610",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M40 265.827c0,45.6693 11.1586,89.8313 33.6558,132.508 22.5197,42.8346 54.3532,75.3206 95.5006,97.8403 41.1699,22.4972 87.0191,33.8358 137.84,33.8358 78.4927,0 142.677,-25.5118 192.846,-76.5129 50.1687,-51.1586 75.1631,-115.501 75.1631,-193.498 0,-78.6727 -25.3318,-143.825 -75.838,-195.501 -50.6637,-51.676 -114.331,-77.5028 -191.159,-77.5028 -47.5141,0 -92.8459,10.8436 -136.018,32.3285 -42.9921,21.5073 -75.8155,53.0034 -98.3352,94.6682 -22.4972,41.5073 -33.6558,92.171 -33.6558,151.834zm140.99 -7.33408c0,-51.4961 12.171,-91.0011 36.5129,-118.335 24.4994,-27.4916 54.4882,-41.1474 90.3262,-41.1474 35.6805,0 65.6693,13.6558 89.8313,41.1474 24.162,27.3341 36.333,67.1766 36.333,119.348 0,50.8211 -12.171,89.9888 -36.333,117.323 -24.162,27.5141 -54.1507,41.1699 -89.8313,41.1699 -35.838,0 -65.8268,-13.6558 -90.3262,-41.1699 -24.342,-27.3341 -36.5129,-66.8166 -36.5129,-118.335zm-36.9854 327.514l102.497 144.004 126.322 0 101.17 -144.004 -109.989 0 -56.5129 73.0034 -52.4859 -73.0034 -111.001 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xe3",
                                "horiz-adv-x": "556",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M173.993 359.01l-123.982 21.9798c13.9933,50.6862 38.1552,88.1665 72.3285,112.508 34.1507,24.342 84.9944,36.5129 152.328,36.5129 61.1699,0 106.839,-7.1766 136.828,-21.6873 29.8313,-14.4882 51.0011,-32.8234 63.1721,-55.1631 12.171,-22.3172 18.3352,-63.1496 18.3352,-122.835l-2.00225 -160c0,-45.4893 2.15973,-79.1676 6.50169,-100.832 4.31946,-21.6648 12.5084,-44.8369 24.4994,-69.4938l-135.996 0c-3.50956,8.99888 -8.009,22.3397 -13.1834,40 -2.15973,8.16648 -3.82452,13.4983 -4.8144,15.9955 -23.3521,-22.9921 -48.3465,-40.1575 -75.0056,-51.6535 -26.6592,-11.5186 -55.0056,-17.3453 -85.1744,-17.3453 -53.1609,0 -95.1631,14.5107 -125.827,43.5096 -30.6637,28.8189 -46.0067,65.4893 -46.0067,109.831 0,29.1564 6.99663,55.3206 21.0124,78.3352 13.9933,22.8346 33.4983,40.4949 58.8301,52.6659 25.1519,12.171 61.4848,22.8346 108.999,31.991 64.0045,12.0135 108.504,23.3296 133.161,33.6783l0 13.8358c0,26.6592 -6.50169,45.6468 -19.5051,57.1654 -13.1609,11.3161 -37.8178,16.9854 -73.9933,16.9854 -24.4994,0 -43.5096,-4.8369 -57.1654,-14.6682 -13.8358,-9.65129 -24.8369,-26.8166 -33.3408,-51.3161zm184.004 -111.001c-17.5028,-5.84927 -45.3318,-12.8459 -83.4871,-21.0124 -38.0202,-8.16648 -63.0146,-16.153 -74.6682,-23.8245 -17.8403,-12.8459 -26.8391,-28.8414 -26.8391,-48.3465 0,-19.3251 7.15411,-35.8155 21.5073,-49.8313 14.3307,-13.9933 32.4859,-20.9899 54.6457,-20.9899 24.6794,0 48.3465,8.16648 70.8436,24.3195 16.4904,12.5084 27.4916,27.5141 32.6659,45.5118 3.50956,11.6535 5.33183,33.9933 5.33183,66.8391l0 27.3341zm-178.988 336.985l-63.0146 0c-0.337458,7.51406 -0.494938,13.3408 -0.494938,17.5028 0,34.1732 8.32396,60.4949 24.9944,78.8301 16.5129,18.5152 37.9978,27.6715 64.0045,27.6715 11.4961,0 22.0022,-1.16985 31.8335,-3.66704 9.83127,-2.49719 27.6715,-9.49381 53.4983,-20.9899 26.0067,-11.5186 46.1642,-17.3453 61.0124,-17.3453 10.3262,0 18.9876,3.32958 25.9843,9.83127 7.1766,6.68166 11.4961,17.6828 13.4983,33.1834l63.0146 0c-0.337458,-44.5219 -8.50394,-76.1755 -24.4994,-95.3431 -16.1755,-19.1676 -36.8504,-28.6614 -62.1822,-28.6614 -11.1586,0 -22.0022,1.16985 -32.6659,3.48706 -7.49156,2.00225 -26.1642,8.99888 -55.9955,20.8324 -29.9888,11.8335 -51.6535,17.6828 -65.3318,17.6828 -10.5062,0 -18.4927,-3.1721 -24.342,-9.67379 -5.98425,-6.34421 -8.99888,-17.5028 -9.31384,-33.3408z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xd2",
                                "horiz-adv-x": "777",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M42.9921 353.656c0,73.0034 11.0011,134.353 32.8459,184.004 16.153,36.5129 38.4927,69.3363 66.6592,98.3352 28.1665,28.9989 59.0101,50.5062 92.5084,64.6794 44.6569,18.8301 96.153,28.324 154.488,28.324 105.669,0 190.011,-32.8234 253.498,-98.3352 63.3521,-65.6693 95.0056,-156.828 95.0056,-273.656 0,-115.838 -31.4961,-206.502 -94.3307,-271.834 -62.8346,-65.5118 -146.997,-98.1777 -252.171,-98.1777 -106.502,0 -191.339,32.5084 -254.173,97.6603 -62.8121,65.0169 -94.3307,154.668 -94.3307,268.999zm148.999 4.8369c0,-81.1699 18.8526,-142.655 56.333,-184.657 37.5028,-41.8448 85.1744,-62.8346 142.835,-62.8346 57.8403,0 105.174,20.8324 142.34,62.3397 37.0079,41.6648 55.5006,103.982 55.5006,187.154 0,82.1822 -17.9978,143.51 -54.1732,183.847 -35.9955,40.4949 -83.8245,60.6524 -143.667,60.6524 -59.6625,0 -107.829,-20.4949 -144.319,-61.3273 -36.5129,-40.9899 -54.8481,-102.677 -54.8481,-185.174zm288.009 422.497l-86.0067 0 -134.983 146.007 152.981 0 68.009 -146.007z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xc1",
                                "horiz-adv-x": "722",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M717.998 0l-156.175 0 -61.8223 162.992 -287.177 0 -59.4826 -162.992 -153.341 0 277.998 715.996 153.161 0 286.839 -715.996zm-264.994 284.004l-99.5051 264.994 -96.6704 -264.994 196.175 0zm-151.001 496.985l68.009 146.007 152.981 0 -134.983 -146.007 -86.0067 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xb0",
                                "horiz-adv-x": "399",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M42.0022 573.498c0,43.1721 15.1631,80 45.4893,110.169 30.5062,30.1687 67.1766,45.3318 110.011,45.3318 42.8346,0 79.5051,-15.1631 109.989,-45.4893 30.3487,-30.5062 45.5118,-67.1766 45.5118,-110.011 0,-42.8346 -15.1631,-79.5051 -45.5118,-109.989 -30.4837,-30.3487 -67.1541,-45.5118 -109.989,-45.5118 -42.8346,0 -79.5051,15.1631 -110.011,45.5118 -30.3262,30.4837 -45.4893,67.1541 -45.4893,109.989zm80.9899 0c0,-20.4949 7.33408,-37.9978 21.8448,-52.6659 14.6682,-14.4882 32.171,-21.8223 52.6659,-21.8223 20.4949,0 37.9978,7.33408 52.6659,21.8223 14.4882,14.6682 21.8223,32.171 21.8223,52.6659 0,20.4949 -7.33408,37.9978 -21.8223,52.6659 -14.6682,14.5107 -32.171,21.8448 -52.6659,21.8448 -20.4949,0 -37.9978,-7.33408 -52.6659,-21.8448 -14.5107,-14.6682 -21.8448,-32.171 -21.8448,-52.6659z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\x9f",
                                "horiz-adv-x": "750",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M124.994 0l0 624.994 500 0 0 -624.994 -500 0zm15.9955 15.9955l468.009 0 0 593.003 -468.009 0 0 -593.003z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\x8e",
                                "horiz-adv-x": "750",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M124.994 0l0 624.994 500 0 0 -624.994 -500 0zm15.9955 15.9955l468.009 0 0 593.003 -468.009 0 0 -593.003z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "}",
                                "horiz-adv-x": "389",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M355.996 200.99c-23.8245,-1.32733 -41.6648,-4.8144 -53.6558,-10.6637 -12.171,-5.98425 -22.4972,-15.8155 -31.1811,-29.6513 -8.48144,-13.8358 -14.6682,-31.1811 -18.3352,-52.0135 -2.49719,-15.658 -3.82452,-42.6547 -3.82452,-81.1699 0,-63.1496 -2.83465,-107.334 -8.50394,-132.486 -5.66929,-25.0169 -16.153,-45.1744 -31.4961,-60.3375 -15.3431,-15.1631 -37.8403,-26.9966 -67.3341,-35.838 -19.8425,-5.82677 -51.1586,-8.84139 -93.8358,-8.84139l-25.8268 0 0 117.008c35.0056,0 57.8403,2.15973 68.6614,6.65917 10.6637,4.34196 18.6727,10.6862 23.667,19.0101 5.17435,8.32396 7.67154,22.3397 7.82902,42.3397 0.179978,19.82 1.50731,57.8178 3.84702,113.836 1.66479,33.9933 5.98425,60.9899 13.1609,81.4848 7.1766,20.3375 16.6704,37.6828 28.5039,51.8335 11.991,14.1732 27.1541,26.5017 45.6693,37.3453 -24.0045,15.658 -41.6648,31.0011 -52.6659,45.8268 -15.3431,21.5073 -25.8493,48.8414 -31.3386,82.1597 -3.50956,22.6772 -6.00675,72.8459 -7.33408,150.349 -0.337458,24.3195 -2.49719,40.6524 -6.65917,48.8189 -4.0045,8.009 -11.3386,14.3307 -22.0022,18.6727 -10.6637,4.49944 -34.3307,6.65917 -71.3386,6.65917l0 117.008 25.8268 0c44.0045,0 77.6603,-3.50956 101.17,-10.3262 23.3296,-6.83915 42.9921,-18.5152 59.0101,-34.8481 15.9955,-16.4904 26.8166,-36.6479 32.4859,-60.6524 5.66929,-23.847 8.50394,-61.6648 8.50394,-113.161 0,-59.5051 2.49719,-98.5152 7.33408,-116.67 7.1766,-26.1642 17.9978,-44.8369 32.6659,-56.018 14.6682,-11.3161 37.0079,-17.6603 66.9966,-19.3251l0 -117.008z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "l",
                                "horiz-adv-x": "277",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M71.991 0l0 715.996 137.008 0 0 -715.996 -137.008 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "[",
                                "horiz-adv-x": "333",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M71.991 -202.002l0 917.998 243.015 0 0 -107.987 -113.003 0 0 -702.002 113.003 0 0 -108.009 -243.015 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "J",
                                "horiz-adv-x": "556",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M330.011 715.996l144.994 0 0 -453.656c0,-59.3476 -5.17435,-105.017 -15.6805,-137.008 -13.9933,-41.6648 -39.3251,-75.1631 -76.153,-100.495 -36.6704,-25.1744 -85.1744,-37.8403 -145.512,-37.8403 -70.6637,0 -124.994,19.6625 -162.992,59.1676 -38.1777,39.5051 -57.3453,97.5028 -57.6603,173.836l136.985 15.9955c1.66479,-40.8324 7.51406,-69.6513 17.8403,-86.5017 15.5006,-25.6693 39.0101,-38.4927 70.6637,-38.4927 31.8335,0 54.5107,9.15636 67.6715,27.6715 13.1609,18.3352 19.8425,56.4904 19.8425,114.488l0 462.835z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "9",
                                "horiz-adv-x": "556",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M46.9966 166.344l133.003 14.6457c3.1721,-27.1541 11.676,-47.3341 25.1744,-60.315 13.4983,-13.1834 31.4961,-19.685 53.6558,-19.685 28.1665,0 52.0135,13.1834 71.676,39.3476 19.6625,26.1642 32.171,80.4949 37.6603,162.655 -34.5107,-40 -77.5028,-60 -129.336,-60 -56.153,0 -104.837,21.6648 -145.669,65.1744 -40.8324,43.5096 -61.1699,100 -61.1699,169.674 0,72.6659 21.5073,131.159 64.6794,175.501 43.1721,44.4994 98.1552,66.6592 164.837,66.6592 72.4859,0 132.148,-28.1665 178.65,-84.342 46.5017,-56.333 69.8538,-148.819 69.8538,-277.818 0,-131.001 -24.1845,-225.669 -72.5084,-283.667 -48.3465,-58.1777 -111.339,-87.1766 -188.999,-87.1766 -55.838,0 -100.832,15.0056 -135.343,44.9944 -34.3307,29.8313 -56.4904,74.6682 -66.1642,134.353zm308.999 300.315c0,44.1845 -10.1687,78.5152 -30.5062,102.835 -20.1575,24.342 -43.667,36.5129 -70.3262,36.5129 -25.3318,0 -46.3217,-10.0112 -62.9921,-30.0112 -16.8279,-20 -25.1744,-52.6659 -25.1744,-97.9978 0,-46.1642 9.17885,-80 27.3341,-101.665 18.1777,-21.5073 40.8324,-32.3285 68.1665,-32.3285 26.3442,0 48.5039,10.3262 66.5017,31.1586 17.9978,20.8324 26.9966,51.3386 26.9966,91.4961z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "(",
                                "horiz-adv-x": "333",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M300 -210.011l-93.9933 0c-50.1687,75.1856 -88.3465,153.183 -114.668,234.353 -26.1642,80.9899 -39.3476,159.325 -39.3476,235.163 0,93.9933 16.1755,182.992 48.3465,266.997 28.1665,72.8234 63.667,140 106.659,201.507l93.9933 0c-44.8144,-98.5152 -75.8155,-182.52 -92.6659,-251.519 -16.8279,-69.1564 -25.3318,-142.497 -25.3318,-220 0,-53.3183 5.01687,-107.987 15.0056,-163.982 10.1687,-55.838 23.8245,-108.999 41.3273,-159.505 11.5186,-33.1609 31.676,-80.8324 60.6749,-143.015z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xf1",
                                "horiz-adv-x": "610",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M544.004 0l-137.008 0 0 264.499c0,55.9955 -2.99213,92.171 -8.8189,108.504 -6.00675,16.4904 -15.5006,29.1564 -28.8414,38.3352 -13.3408,9.15636 -29.3363,13.6558 -48.009,13.6558 -24.0045,0 -45.4893,-6.50169 -64.4994,-19.5051 -19.1676,-12.9809 -32.171,-30.3262 -39.1676,-51.6535 -7.15411,-21.5073 -10.6637,-61.1699 -10.6637,-119.168l0 -234.668 -136.985 0 0 519.01 126.997 0 0 -76.1755c45.4893,58.1552 102.655,87.1766 171.834,87.1766 30.3262,0 58.1552,-5.51181 83.3296,-16.3555 25.3318,-10.9786 44.3195,-24.8144 57.1654,-41.6648 13.0034,-16.9854 22.0022,-36.153 26.9966,-57.6603 5.17435,-21.5073 7.67154,-52.171 7.67154,-92.171l0 -322.16zm-328.009 584.994l-62.9921 0c-0.337458,7.51406 -0.494938,13.3408 -0.494938,17.5028 0,34.1732 8.32396,60.4949 24.9944,78.8301 16.4904,18.5152 37.9978,27.6715 64.0045,27.6715 11.4961,0 22.0022,-1.16985 31.8335,-3.66704 9.83127,-2.49719 27.649,-9.49381 53.4983,-20.9899 25.9843,-11.5186 46.1642,-17.3453 60.9899,-17.3453 10.3487,0 19.0101,3.32958 26.0067,9.83127 7.15411,6.68166 11.4961,17.6828 13.4983,33.1834l62.9921 0c-0.314961,-44.5219 -8.50394,-76.1755 -24.4994,-95.3431 -16.153,-19.1676 -36.8279,-28.6614 -62.1597,-28.6614 -11.1586,0 -22.0022,1.16985 -32.6659,3.48706 -7.49156,2.00225 -26.1642,8.99888 -55.9955,20.8324 -30.0112,11.8335 -51.676,17.6828 -65.3318,17.6828 -10.5062,0 -18.5152,-3.1721 -24.342,-9.67379 -6.00675,-6.34421 -8.99888,-17.5028 -9.33633,-33.3408z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xe0",
                                "horiz-adv-x": "556",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M173.993 359.01l-123.982 21.9798c13.9933,50.6862 38.1552,88.1665 72.3285,112.508 34.1507,24.342 84.9944,36.5129 152.328,36.5129 61.1699,0 106.839,-7.1766 136.828,-21.6873 29.8313,-14.4882 51.0011,-32.8234 63.1721,-55.1631 12.171,-22.3172 18.3352,-63.1496 18.3352,-122.835l-2.00225 -160c0,-45.4893 2.15973,-79.1676 6.50169,-100.832 4.31946,-21.6648 12.5084,-44.8369 24.4994,-69.4938l-135.996 0c-3.50956,8.99888 -8.009,22.3397 -13.1834,40 -2.15973,8.16648 -3.82452,13.4983 -4.8144,15.9955 -23.3521,-22.9921 -48.3465,-40.1575 -75.0056,-51.6535 -26.6592,-11.5186 -55.0056,-17.3453 -85.1744,-17.3453 -53.1609,0 -95.1631,14.5107 -125.827,43.5096 -30.6637,28.8189 -46.0067,65.4893 -46.0067,109.831 0,29.1564 6.99663,55.3206 21.0124,78.3352 13.9933,22.8346 33.4983,40.4949 58.8301,52.6659 25.1519,12.171 61.4848,22.8346 108.999,31.991 64.0045,12.0135 108.504,23.3296 133.161,33.6783l0 13.8358c0,26.6592 -6.50169,45.6468 -19.5051,57.1654 -13.1609,11.3161 -37.8178,16.9854 -73.9933,16.9854 -24.4994,0 -43.5096,-4.8369 -57.1654,-14.6682 -13.8358,-9.65129 -24.8369,-26.8166 -33.3408,-51.3161zm184.004 -111.001c-17.5028,-5.84927 -45.3318,-12.8459 -83.4871,-21.0124 -38.0202,-8.16648 -63.0146,-16.153 -74.6682,-23.8245 -17.8403,-12.8459 -26.8391,-28.8414 -26.8391,-48.3465 0,-19.3251 7.15411,-35.8155 21.5073,-49.8313 14.3307,-13.9933 32.4859,-20.9899 54.6457,-20.9899 24.6794,0 48.3465,8.16648 70.8436,24.3195 16.4904,12.5084 27.4916,27.5141 32.6659,45.5118 3.50956,11.6535 5.33183,33.9933 5.33183,66.8391l0 27.3341zm2.99213 337.998l-85.9843 0 -135.006 145.984 153.003 0 67.9865 -145.984z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xcf",
                                "horiz-adv-x": "277",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M68.009 0l0 715.996 144.994 0 0 -715.996 -144.994 0zm-80.5174 780.99l0 118.02 117.998 0 0 -118.02 -117.998 0zm210.506 0l0 118.02 117.998 0 0 -118.02 -117.998 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xbe",
                                "horiz-adv-x": "833",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M20 463.172l90.0112 9.83127c2.49719,-17.9978 8.48144,-31.3386 17.8178,-40 9.33633,-8.66142 21.5073,-13.0034 36.6704,-13.0034 15.658,0 28.324,4.8369 37.9978,14.6682 9.67379,9.67379 14.5107,22.4972 14.5107,37.9978 0,13.9933 -4.67942,25.5118 -13.8358,34.6682 -9.17885,9.15636 -21.1699,13.6558 -35.9955,13.6558 -9.85377,0 -24.4994,-2.49719 -44.1845,-7.33408l11.0011 71.8335c16.8504,-0.314961 30.0112,1.34983 39.5051,5.01687 9.67379,3.66704 16.333,8.32396 20.4949,13.9933 4.0045,5.51181 6.00675,11.8335 6.00675,18.8301 0,9.33633 -3.32958,16.8279 -10.1687,22.8346 -6.83915,5.82677 -16.6704,8.84139 -29.9888,8.84139 -13.1834,0 -23.847,-3.66704 -31.8335,-11.0011 -8.16648,-7.33408 -13.3408,-19.6625 -16.018,-37.0079l-86.9966 12.6659c8.16648,33.6783 20.18,57.6603 35.9955,72.0135 24.6794,22.1597 58.3352,33.3183 101.17,33.3183 40.18,0 72.0135,-9.98875 95.5006,-30.1687 23.5096,-20 35.3431,-42.9921 35.3431,-68.9989 0,-12.171 -3.32958,-23.4871 -10.1687,-33.9933 -9.17885,-14.5107 -21.5073,-26.5017 -37.0079,-35.838 22.0022,-7.82902 38.6727,-19.3251 50.1687,-34.4882 11.3386,-15.1631 17.0079,-32.8459 17.0079,-53.1834 0,-31.0011 -13.6783,-58.3127 -41.0124,-82.3172 -27.3341,-24.0045 -63.1496,-35.9955 -107.649,-35.9955 -41.6648,0 -75.0056,10.3262 -100,30.8211 -25.0169,20.6749 -39.8425,48.009 -44.342,82.3397zm234.668 -489.179l-77.6603 0 424.499 751.001 77.6603 0 -424.499 -751.001zm430.326 5.01687l0 71.991 -175.996 0 0 68.9989 186.839 228.999 76.153 0 0 -226.997 52.0135 0 0 -71.0011 -52.0135 0 0 -71.991 -86.9966 0zm0 142.992l0 108.166 -88.1665 -108.166 88.1665 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\xad",
                                "horiz-adv-x": "333",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M55.9955 191.001l0 137.008 270.011 0 0 -137.008 -270.011 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\x9c",
                                "horiz-adv-x": "750",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M124.994 0l0 624.994 500 0 0 -624.994 -500 0zm15.9955 15.9955l468.009 0 0 593.003 -468.009 0 0 -593.003z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "\x8b",
                                "horiz-adv-x": "750",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M124.994 0l0 624.994 500 0 0 -624.994 -500 0zm15.9955 15.9955l468.009 0 0 593.003 -468.009 0 0 -593.003z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "z",
                                "horiz-adv-x": "500",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M15.9955 0l0 108.009 194.173 222.497c31.991,36.4904 55.5006,62.1597 70.8211,77.5028 -15.9955,-1.01237 -36.9854,-1.66479 -62.9921,-2.00225l-182.992 -1.01237 0 114.016 428.999 0 0 -97.0079 -198.178 -228.346 -69.8313 -75.658c37.9978,2.00225 61.6648,2.99213 70.8436,2.99213l212.171 0 0 -120.99 -463.015 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "i",
                                "horiz-adv-x": "277",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M71.991 588.999l0 126.997 137.008 0 0 -126.997 -137.008 0zm0 -588.999l0 519.01 137.008 0 0 -519.01 -137.008 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "X",
                                "horiz-adv-x": "666",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M0.494938 0l247.177 373.341 -224.162 342.655 168.819 0 141.012 -213.161 140.99 213.161 169.179 0 -224.679 -342.835 246.659 -373.161 -173.656 0 -158.673 242.497 -158.83 -242.497 -173.836 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "G",
                                "horiz-adv-x": "777",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M406.007 262.992l0 121.012 311.001 0 0 -285.669c-30.1687,-29.4938 -74.0157,-55.3431 -131.519,-77.8403 -57.3228,-22.3172 -115.478,-33.4983 -174.488,-33.4983 -74.8256,0 -140,15.6805 -195.658,47.1766 -55.5006,31.4961 -97.3453,76.6704 -125.332,135.163 -28.009,58.4927 -42.0022,122.34 -42.0022,191.159 0,74.6682 15.658,141.012 46.8166,199.168 31.3386,57.9978 77.0079,102.677 137.165,133.678 46.0067,23.8245 103.015,35.658 171.339,35.658 88.8414,0 158.335,-18.6727 208.346,-55.9955 49.8313,-37.5028 81.9798,-88.9989 96.333,-155.006l-144.004 -26.9966c-10.0112,35.1631 -28.9989,62.9921 -56.8279,83.5096 -27.6715,20.315 -62.3397,30.4837 -104.004,30.4837 -63.0146,0 -113.161,-20 -150.349,-60.1575 -37.1654,-40.18 -55.8155,-99.6625 -55.8155,-178.493 0,-85.1744 18.8301,-149.021 56.4904,-191.519 37.8403,-42.4972 87.1766,-63.8245 148.324,-63.8245 30.1687,0 60.5174,6.00675 90.8436,17.8403 30.5062,11.8335 56.4904,26.3217 78.3352,43.3296l0 90.8211 -164.994 0z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "6",
                                "horiz-adv-x": "556",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M506.997 540.675l-133.003 -14.6682c-3.14961,27.3341 -11.6535,47.4916 -25.3318,60.4949 -13.6558,13.0034 -31.3386,19.5051 -53.1609,19.5051 -28.9989,0 -53.4983,-13.0034 -73.4983,-39.0101 -20,-26.0067 -32.5084,-80.1575 -37.6603,-162.497 34.1507,40.3375 76.4904,60.4949 127.334,60.4949 57.1654,0 106.322,-21.8223 147.154,-65.4893 40.8324,-43.847 61.1699,-100.18 61.1699,-169.336 0,-73.3408 -21.5073,-132.328 -64.4994,-176.67 -42.9921,-44.342 -98.1777,-66.5017 -165.489,-66.5017 -72.171,0 -131.676,28.1665 -178.178,84.4994 -46.5017,56.333 -69.8313,148.504 -69.8313,276.828 0,131.519 24.342,226.344 72.8234,284.499 48.5039,58.1777 111.519,87.1766 188.999,87.1766 54.3532,0 99.3476,-15.3431 135.006,-46.0067 35.6805,-30.4837 58.3352,-74.9831 68.1665,-133.318zm-311.001 -299.685c0,-44.6569 10.3487,-79.1676 30.8436,-103.487 20.4949,-24.342 43.8245,-36.5129 70.3262,-36.5129 25.3318,0 46.5017,10.0112 63.5096,29.8538 16.8279,20 25.3318,52.6659 25.3318,97.9978 0,46.6592 -9.17885,80.8324 -27.3341,102.655 -18.3352,21.6648 -41.0124,32.5084 -68.3465,32.5084 -26.5017,0 -48.6614,-10.3487 -66.9966,-31.1811 -18.1552,-20.6524 -27.3341,-51.3161 -27.3341,-91.8335z"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("glyph", {
                                unicode: "%",
                                "horiz-adv-x": "889",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M42.9921 540.495c0,64.0045 14.1732,111.339 42.3397,142.182 28.1665,30.8211 66.3442,46.3217 114.511,46.3217 49.8313,0 88.8189,-15.3431 116.985,-46.0067 28.1665,-30.6637 42.1822,-78.1552 42.1822,-142.497 0,-64.0045 -14.0157,-111.339 -42.1822,-142.16 -28.1665,-30.8436 -66.5017,-46.3442 -114.668,-46.3442 -49.8313,0 -88.6614,15.3431 -116.828,46.0067 -28.1665,30.6637 -42.3397,78.1777 -42.3397,142.497zm107.019 0c0,-46.1642 5.33183,-77.1654 16.153,-93.0034 8.16648,-11.6535 19.5051,-17.4803 33.8358,-17.4803 14.6682,0 26.1642,5.82677 34.3307,17.4803 10.5062,15.838 15.6805,46.8391 15.6805,93.0034 0,46.1642 -5.17435,77.0079 -15.6805,92.5084 -8.16648,11.991 -19.6625,17.9978 -34.3307,17.9978 -14.3307,0 -25.6693,-5.82677 -33.8358,-17.5028 -10.8211,-15.838 -16.153,-46.8391 -16.153,-93.0034zm154.488 -568.504l-101.507 0 381.17 757.008 99.3476 0 -379.01 -757.008zm221.507 188.841c0,64.162 14.1507,111.676 42.3172,142.677 28.1665,31.0011 66.6817,46.5017 115.501,46.5017 49.1789,0 87.8515,-15.5006 116.018,-46.5017 28.1665,-31.0011 42.1597,-78.5152 42.1597,-142.677 0,-64.6569 -13.9933,-112.328 -42.1597,-143.33 -28.1665,-31.0011 -66.5017,-46.5017 -114.668,-46.5017 -49.8313,0 -88.6839,15.5006 -116.85,46.5017 -28.1665,31.0011 -42.3172,78.6727 -42.3172,143.33zm106.997 -0.337458c0,-46.6592 5.33183,-77.8178 16.153,-93.3183 8.16648,-12.171 19.5051,-18.1777 33.8358,-18.1777 14.6682,0 26.0067,5.82677 33.8358,17.6603 10.8436,15.838 16.1755,47.1766 16.1755,93.8358 0,46.6817 -5.17435,77.9978 -15.6805,93.8358 -8.16648,11.8335 -19.6625,17.6603 -34.3307,17.6603 -14.6682,0 -25.9843,-5.82677 -33.8358,-17.6603 -10.8211,-15.838 -16.153,-47.1541 -16.153,-93.8358z"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                        id: "id0",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                            x: "3601",
                            y: "1252",
                            width: "2439",
                            height: "1828"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                id: "Camada_x0020_1",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("metadata", {
                        id: "CorelCorpID_0Corel-Layer"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        fill: "#FEFEFE",
                        x: "6166",
                        y: "1256",
                        width: "5151",
                        height: "1370"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        fill: "#FEFEFE",
                        width: "3599",
                        height: "991"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        fill: "#221F1F",
                        x: "3600",
                        y: "812",
                        width: "200%",
                        height: "100"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                        transform: "matrix(1 0 0 1 -4226.83 -10394.7)",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("text", {
                            x: "7800",
                            y: "11000",
                            fill: "#221F1F",
                            "font-weight": "bold",
                            "font-size": "500",
                            "font-family": "Arial",
                            id: "prodName",
                            children: data === null || data === void 0 ? void 0 : data["Product Name"]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                        id: "_717381648",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("polygon", {
                                fill: "black",
                                points: "1947,608 1947,106 2085,106 2085,480 2239,480 2239,608 "
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("polygon", {
                                fill: "black",
                                points: "1500,608 1500,106 1637,106 1637,282 1776,282 1776,106 1913,106 1913,608 1776,608 1776,421 1637,421 1637,608 "
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("polygon", {
                                fill: "black",
                                points: "1033,106 835,345 1062,609 880,609 726,429 725,429 725,608 588,608 588,106 725,106 725,256 724,257 855,106 "
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                fill: "black",
                                d: "M959 353c0,-145 116,-262 259,-262 143,0 259,117 259,262 0,145 -116,262 -259,262 -143,0 -259,-117 -259,-262zm259 129c64,0 117,-58 117,-129 0,-71 -52,-129 -117,-129 -64,0 -117,58 -117,129 0,71 52,129 117,129z"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("polygon", {
                                fill: "black",
                                points: "2405,106 2546,106 2546,222 2408,222 2408,301 2535,301 2535,414 2408,414 2408,491 2547,491 2547,608 2406,608 2267,608 2267,106 "
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                fill: "black",
                                d: "M2832 408l143 201 -150 0 -112 -154 0 154 -135 0 0 -502 172 0c151,0 248,190 81,302zm-81 -88c27,0 48,-22 48,-48 0,-27 -22,-48 -48,-48l-39 0 0 97 39 0z"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                fill: "black",
                                d: "M2992 590c0,-17 14,-31 31,-31 17,0 31,14 31,31 0,17 -14,31 -31,31 -17,0 -31,-14 -31,-31zm57 0c0,-14 -12,-26 -26,-26 -14,0 -26,11 -26,26 0,14 12,26 26,26 14,0 26,-12 26,-26zm-12 17l-6 0 -10 -15 -6 0 0 15 -5 0 0 -34 15 0c6,0 12,2 12,9 0,7 -5,9 -11,9l10 15zm-16 -20c4,0 11,1 11,-5 0,-3 -5,-4 -8,-4l-9 0 0 9 6 0 0 0z"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                                "enable-background": "new ",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                        fill: "black",
                                        d: "M759 880c-17,23 -44,32 -70,32 -65,0 -103,-53 -103,-110 0,-63 35,-118 103,-118 47,0 86,21 93,72l-29 0c-6,-33 -32,-48 -65,-48 -53,0 -75,46 -75,92 0,45 26,87 75,87 45,0 71,-31 70,-71l-69 0 0 -24 95 0 0 114 -18 0 -8 -27z"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("polygon", {
                                        fill: "black",
                                        points: "827,690 977,690 977,714 856,714 856,783 969,783 969,808 856,808 856,883 978,883 978,907 827,907 827,690 "
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("polygon", {
                                        fill: "black",
                                        points: "1013,690 1044,690 1158,866 1159,866 1159,690 1186,690 1186,907 1155,907 1041,733 1040,733 1040,907 1013,907 "
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                        fill: "black",
                                        d: "M1407 829c0,55 -31,84 -86,84 -56,0 -89,-26 -89,-84l0 -139 29 0 0 139c0,39 22,59 60,59 37,0 57,-21 57,-59l0 -139 29 0 0 139 0 0z"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("polygon", {
                                        fill: "black",
                                        points: "1454,690 1483,690 1483,907 1454,907 "
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("polygon", {
                                        fill: "black",
                                        points: "1532,690 1562,690 1677,866 1677,866 1677,690 1705,690 1705,907 1673,907 1560,733 1559,733 1559,907 1532,907 "
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("polygon", {
                                        fill: "black",
                                        points: "1752,690 1902,690 1902,714 1781,714 1781,783 1894,783 1894,808 1781,808 1781,883 1903,883 1903,907 1752,907 1752,690 "
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                        fill: "black",
                                        d: "M2022 690l95 0c44,0 67,24 67,64 0,41 -23,65 -67,64l-66 0 0 89 -29 0 0 -217 0 0zm29 104l57 0c33,0 48,-14 48,-40 0,-26 -15,-40 -48,-40l-57 0 0 80z"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                        fill: "black",
                                        d: "M2279 690l32 0 85 217 -32 0 -24 -65 -92 0 -24 65 -30 0 85 -217zm-22 128l74 0 -36 -101 -1 0 -37 101z"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                        fill: "black",
                                        d: "M2417 690l102 0c41,0 66,22 66,57 0,27 -11,48 -38,55l0 1c25,5 30,24 33,45 2,21 1,45 13,60l-32 0c-8,-9 -4,-32 -8,-54 -3,-21 -8,-39 -36,-39l-71 0 0 93 -29 0 0 -217 0 0zm89 100c27,0 50,-7 50,-39 0,-22 -12,-37 -39,-37l-72 0 0 76 60 0 0 0z"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("polygon", {
                                        fill: "black",
                                        points: "2675,714 2603,714 2603,690 2776,690 2776,714 2704,714 2704,907 2675,907 2675,714 "
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                        fill: "black",
                                        d: "M2926 753c-3,-31 -24,-44 -54,-44 -25,0 -49,9 -49,37 0,54 139,16 139,101 0,46 -45,65 -85,65 -49,0 -90,-24 -90,-77l27 0c0,37 30,52 63,52 26,0 55,-8 55,-40 0,-60 -139,-20 -139,-100 0,-44 39,-64 79,-64 44,0 79,21 80,69l-27 0 0 0z"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                        "clip-path": "url(#id0)",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("image", {
                            id: "prodImg",
                            transform: "matrix(0.825998 0 0 0.825998 -3159.78 -6012.29)",
                            x: "7800",
                            y: "8795",
                            width: "2953",
                            height: "2213",
                            xlinkHref: data === null || data === void 0 ? void 0 : data.uri
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("text", {
                        x: "6416",
                        y: "1883",
                        fill: "#606062",
                        "font-weight": "bold",
                        "font-size": "220.234",
                        "font-family": "Arial",
                        id: "prodCod",
                        children: data === null || data === void 0 ? void 0 : data.Cod
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("text", {
                        x: "6407",
                        y: "1607",
                        fill: "#607CA1",
                        "font-weight": "bold",
                        "font-size": "200",
                        "font-family": "Arial",
                        id: "prodDesc",
                        children: data === null || data === void 0 ? void 0 : data["Short Description"]
                    })
                ]
            })
        ]
    });
};
const AddToCartLoadingIcon = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: "spinner-border text-secondary"
    });
const AddedIcon = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "19",
        height: "30",
        viewBox: "0 0 19 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
            id: "Icon",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                id: "Path",
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M15.7853 9L16.5 9.65557L8.09735 20L2.5 15.2495L3.07941 14.4766L7.96677 18.6253L15.7853 9Z",
                fill: "white"
            })
        })
    });


/***/ }),

/***/ 89676:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ getTranslations; }
/* harmony export */ });
const getTranslations = (t)=>{
    return {
        printDiagrams: t("kf.myList.parts.partviewer.printDiagrams"),
        printAllText: t("kf.myList.parts.partviewer.printAllText"),
        printSelectedText: t("kf.myList.parts.partviewer.printSelectedText"),
        mailBody: t("kf.partViewer.emailBody"),
        description: t("kf.orderDetails.label.viewPartsDiagram"),
        mailSubjectTextOne: t("kf.partViewer.emailSubject"),
        mailSubjectTextTwo: t("kf.orderDetails.label.viewPartsDiagram"),
        discontinuedText: t("kf.partViewer.gridView.discontinuedText"),
        addingCartText: t("kf.partViewer.gridView.cart.addingCartText"),
        addedCartText: t("kf.partViewer.gridView.cart.addedCartText"),
        outOfStockText: t("kf.compare.label.outOfStock"),
        addToCart: t("kf.cart.label.addToCart"),
        colorFinish: t("kf.pdp.label.colorOrFinish"),
        addedText: t("kf.partViewer.gridView.cart.addedText"),
        notifyText: t("kf.partViewer.NotifyMe.cart.notifyText"),
        notifySuccessText: t("kf.partViewer.NotifyMe.cart.notifySuccessText"),
        notifyEmailText: t("kf.partViewer.NotifyMe.cart.notifyEmailText"),
        successText: t("kf.partViewer.NotifyMe.cart.successText"),
        notifyOutofStockText: t("kf.partViewer.NotifyMe.cart.notifyOutofStockText"),
        notifyButtonText: t("kf.partViewer.NotifyMe.cart.notifyButtonText"),
        inventoryTextVal: (inventory)=>t("kf.partViewer.addtocart.cart.inventoryText", {
                inventory
            }),
        cartNotificationText: (number, category)=>t("kf.partViewer.gridView.cart.Notification", {
                number,
                category
            }),
        errorText: t("kf.partViewer.pageError.errorText"),
        queryText: t("kf.partViewer.pageError.queryText"),
        contactUsButton: t("kf.partViewer.pageError.contactUsButton")
    };
};


/***/ }),

/***/ 30525:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Eb": function() { return /* binding */ getAnalyticsData; },
/* harmony export */   "I1": function() { return /* binding */ productSuggestionLinkAnalytics; },
/* harmony export */   "ME": function() { return /* binding */ replaceAddToCartDatalayerPush; },
/* harmony export */   "Pt": function() { return /* binding */ getProductInfoAnalytics; },
/* harmony export */   "Qq": function() { return /* binding */ pushAnalyticsToDataLayer; },
/* harmony export */   "fl": function() { return /* binding */ addDataLayerFavGuestUser; },
/* harmony export */   "mw": function() { return /* binding */ addToCompareAnalytics; },
/* harmony export */   "t8": function() { return /* binding */ addDatalayerLocalStoreHrefClick; }
/* harmony export */ });
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96301);
/* harmony import */ var _constants_regex__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49139);


const getAnalyticsData = function(type, url) {
    let needsJSON = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, isBundleProduct = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var ref, ref1, ref2, ref3, ref4, ref5;
    const title = type.toLowerCase().trim();
    let eventAction;
    let internalLinkZoneName;
    let internalLinkType;
    let internalLinkPosition;
    let internalLinkURL;
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    var ref6;
    const pageType = (ref6 = page === null || page === void 0 ? void 0 : (ref = page.category) === null || ref === void 0 ? void 0 : ref.pageType) !== null && ref6 !== void 0 ? ref6 : "pdp";
    if (title === "notify me") {
        var ref7;
        internalLinkZoneName = "".concat(page === null || page === void 0 ? void 0 : (ref7 = page.category) === null || ref7 === void 0 ? void 0 : ref7.pageType, ":modal:availability notification");
        eventAction = "".concat(internalLinkZoneName, ":").concat(title);
    } else if (title === "local store or showroom") {
        var ref8;
        var ref9;
        eventAction = "".concat((ref9 = page === null || page === void 0 ? void 0 : (ref8 = page.category) === null || ref8 === void 0 ? void 0 : ref8.pageType) !== null && ref9 !== void 0 ? ref9 : "pdp", ":").concat(title);
        internalLinkPosition = pageType;
        internalLinkType = "".concat(pageType, ":").concat(title);
        internalLinkZoneName = "".concat(pageType, ":product details");
        internalLinkURL = "n/a";
    } else if (title === "where to buy") {
        internalLinkURL = "".concat(window.location.origin + url);
    }
    const eventInfo = {
        eventAction: eventAction || "".concat(page === null || page === void 0 ? void 0 : (ref1 = page.category) === null || ref1 === void 0 ? void 0 : ref1.pageType, ":product details:").concat(title),
        eventName: eventAction || "".concat(page === null || page === void 0 ? void 0 : (ref2 = page.category) === null || ref2 === void 0 ? void 0 : ref2.pageType, ":product details:").concat(title),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "".concat(title),
        internalLinkPosition: internalLinkPosition || "".concat(page === null || page === void 0 ? void 0 : (ref3 = page.category) === null || ref3 === void 0 ? void 0 : ref3.pageType).concat(isBundleProduct ? ":bundle" : ""),
        internalLinkType: internalLinkType || "".concat(page === null || page === void 0 ? void 0 : (ref4 = page.category) === null || ref4 === void 0 ? void 0 : ref4.pageType, ":").concat(title),
        internalLinkZoneName: internalLinkZoneName || "".concat(page === null || page === void 0 ? void 0 : (ref5 = page.category) === null || ref5 === void 0 ? void 0 : ref5.pageType, ":product details"),
        internalLinkURL: internalLinkURL || "n/a",
        clickInternalLinks: "true"
    };
    if (needsJSON) {
        return eventInfo;
    }
    return JSON.stringify(eventInfo);
};
const replaceAddToCartDatalayerPush = (replaceAddToCartCtaLabel, replaceAddToCartCtaLink, analyticData)=>{
    const eventInfo = getAnalyticsData(replaceAddToCartCtaLabel, replaceAddToCartCtaLink, true);
    const page = window.adobeDataLayer.getState("page");
    analyticData = JSON.parse(analyticData);
    const productInfo = analyticData === null || analyticData === void 0 ? void 0 : analyticData.productInfo;
    window.adobeDataLayer.push({
        event: "cmp:click",
        eventInfo,
        productInfo,
        page
    });
};
const addToCompareAnalytics = (isChecked, analyticData)=>{
    const compareText = "".concat(isChecked ? "remove" : "add to", " compare");
    const eventInfo = {
        eventAction: "pdp:product details:".concat(compareText),
        eventName: "pdp:product details:".concat(compareText),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "".concat(isChecked ? "remove compare" : "compare add"),
        internalLinkPosition: "pdp",
        internalLinkType: "pdp:".concat(compareText),
        internalLinkZoneName: "pdp:product details",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    const page = window.pageObj || {};
    analyticData = JSON.parse(analyticData);
    const productInfo = analyticData === null || analyticData === void 0 ? void 0 : analyticData.productInfo;
    window.adobeDataLayer.push({
        event: "cmp:click",
        eventInfo,
        page,
        productInfo
    });
};
const addDatalayerLocalStoreHrefClick = (type, link, productInfo)=>{
    // Check if the string contains a colon
    let linkName;
    if (type.includes(":")) {
        linkName = type.split(":")[1].trim() // Split and get the phone number
        ;
    }
    const eventInfo = {
        eventAction: "pdp:" + type,
        eventName: "pdp:" + type,
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: linkName || type,
        internalLinkPosition: "pdp",
        internalLinkType: "pdp:".concat(linkName !== undefined ? linkName : type),
        internalLinkZoneName: "pdp:product details",
        internalLinkURL: link || "n/a",
        clickInternalLinks: "true"
    };
    pushAnalyticsObjToDataLayer(eventInfo, productInfo);
};
const pushAnalyticsObjToDataLayer = function() {
    let eventInfo = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, productInfo = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const page = window.pageObj || {};
    const event = "cmp:click";
    window.adobeDataLayer.push({
        event,
        eventInfo,
        page,
        productInfo
    });
};
const addDataLayerFavGuestUser = ()=>{
    var ref, ref1, ref2, ref3;
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const { productInfo  } = page;
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(_constants_index__WEBPACK_IMPORTED_MODULE_0__.PDP_DETAILS, ":").concat(_constants_index__WEBPACK_IMPORTED_MODULE_0__.PDP_GUEST_FAVORITE),
        eventMsg: "n/a",
        eventName: "".concat(_constants_index__WEBPACK_IMPORTED_MODULE_0__.PDP_DETAILS, ":").concat(_constants_index__WEBPACK_IMPORTED_MODULE_0__.PDP_GUEST_FAVORITE),
        eventStatus: "n/a",
        eventType: _constants_index__WEBPACK_IMPORTED_MODULE_0__.PDP_FAVORITE,
        internalLinkName: _constants_index__WEBPACK_IMPORTED_MODULE_0__.PDP_FAVORITE,
        internalLinkPosition: page === null || page === void 0 ? void 0 : (ref = page.category) === null || ref === void 0 ? void 0 : (ref1 = ref.pageType) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase(),
        internalLinkType: "".concat(page === null || page === void 0 ? void 0 : (ref2 = page.category) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.pageType) === null || ref3 === void 0 ? void 0 : ref3.toLowerCase(), ":").concat(_constants_index__WEBPACK_IMPORTED_MODULE_0__.PDP_FAVORITE),
        internalLinkURL: window.location.href,
        internalLinkZoneName: "".concat(_constants_index__WEBPACK_IMPORTED_MODULE_0__.PDP_DETAILS)
    };
    window.adobeDataLayer.push({
        event: "cmp:click",
        eventInfo,
        page,
        productInfo
    });
};
const productSuggestionLinkAnalytics = (eventName, url, analyticData)=>{
    const pageType = window.eventPageType;
    const eventInfo = {
        eventAction: "".concat(pageType, ":product details:").concat(eventName),
        eventName: "".concat(pageType, ":product details:").concat(eventName),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "".concat(eventName),
        internalLinkPosition: "".concat(pageType),
        internalLinkType: "".concat(pageType, ":navigation"),
        internalLinkZoneName: "".concat(pageType, ":product details:").concat(eventName),
        internalLinkURL: "".concat(url),
        clickInternalLinks: "true"
    };
    const page = window.adobeDataLayer.getState("page");
    analyticData = JSON.parse(analyticData);
    const productInfo = analyticData === null || analyticData === void 0 ? void 0 : analyticData.productInfo;
    window.adobeDataLayer.push({
        event: "cmp:click",
        eventInfo,
        page,
        productInfo
    });
};
const sanitizeTextForAnalytics = function() {
    let text = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    const testData = text !== null && text !== void 0 ? text : "";
    return String(testData).replace(_constants_regex__WEBPACK_IMPORTED_MODULE_1__/* .SANITIZE_TEXT_REGEX */ .If, "").toLowerCase().trim();
};
const getProductInfoAnalytics = (data)=>{
    var ref, ref1;
    const { getState =()=>{}  } = window.adobeDataLayer;
    const page = getState().page;
    const customerFacingSKUId = data.customerFacingSKU || data.sku;
    var ref2;
    return {
        productBrand: page === null || page === void 0 ? void 0 : (ref = page.site) === null || ref === void 0 ? void 0 : ref.siteName,
        description: sanitizeTextForAnalytics(data.desc) || "n/a",
        frequency: "n/a",
        globalPromotionPrice: Number(data.discountPrice) ? Number(data.discountPrice) : Number(data.unitPrice),
        isRecommended: "n/a",
        isSendNow: "n/a",
        isSubscription: "n/a",
        priceState: data.discountPercent > 0 || data.discountAmount > 0 ? "percentOff|" + data.discountPercent : "regular price",
        productBasePrice: Number(data.unitPrice) || "n/a",
        productCategory: sanitizeTextForAnalytics(data.category) || "n/a",
        productColor: sanitizeTextForAnalytics(data.color) || "n/a",
        productCoupondiscount: "n/a",
        productID: customerFacingSKUId || "n/a",
        productName: sanitizeTextForAnalytics(data.name) || "n/a",
        productPartnerBuyNow: false,
        productRoom: sanitizeTextForAnalytics(data.category) || "n/a",
        productSalePrice: Number(data.discountPrice) ? Number(data.discountPrice) : Number(data.unitPrice),
        productSaleable: (page === null || page === void 0 ? void 0 : (ref1 = page.productInfo) === null || ref1 === void 0 ? void 0 : ref1.pdpType) === "bundle" || (data === null || data === void 0 ? void 0 : data.isBundleParent) ? "true" : (ref2 = Number(data.productSaleable)) !== null && ref2 !== void 0 ? ref2 : "true",
        productStatus: data.availableQty >= 0 ? "in stock" : "out of stock",
        productSuperSku: data.superSku ? true : false,
        productTileName: sanitizeTextForAnalytics(data.name) || "n/a",
        quantity: data.quantity,
        initialQuantity: data.quantity,
        defaultImageName: data.image || "n/a",
        ratings: "n/a",
        numberOfReviews: "n/a",
        pdpType: data.pdpType,
        productFindingMethod: "n/a",
        productCollectionsName: sanitizeTextForAnalytics(data.productCollectionsName || data.category) || "n/a"
    };
};
const pushAnalyticsToDataLayer = function() {
    let eventInfo = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, productInfo = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const event = "cmp:click";
    window.adobeDataLayer.push({
        event,
        eventInfo,
        page,
        productInfo
    });
};


/***/ }),

/***/ 29885:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SH": function() { return /* binding */ callFavorite; },
/* harmony export */   "YS": function() { return /* binding */ handleProductSuggestion; },
/* harmony export */   "jL": function() { return /* binding */ callNotification; }
/* harmony export */ });
/* unused harmony exports addDatalayerForLocalStoreOrShowroom, isAnchor, isMatchingAnchorText, getAnchorUrl */
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88032);
/* harmony import */ var _store_features_genericSlice__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88751);
/* harmony import */ var _store_features_favoritesSlice__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7737);
/* harmony import */ var _components_ProductDetail_v3_AddToCart_analytics__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30525);
/* harmony import */ var _constants_api__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73350);
/* harmony import */ var _constants_routes__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(64757);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(96301);







const callFavorite = function(e, data) {
    let addFavoriteCallBack = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ()=>{};
    const { isFavorite , favItem =[] , staticTexts: { removeItem ="" , removeItemError ="" , favSuccessMsg ="" , favErrorMsg =""  } = {} , ctProductId ="" , isAuth , toasterContent , sku ="" , ctData  } = data;
    e.preventDefault();
    if (isFavorite) {
        favItem === null || favItem === void 0 ? void 0 : favItem.map((fav)=>{
            var ref, ref1, ref2;
            if (fav.productId === ctProductId && ((ctData === null || ctData === void 0 ? void 0 : (ref = ctData.variants) === null || ref === void 0 ? void 0 : ref.find((vt)=>{
                return vt.sku === sku && (vt === null || vt === void 0 ? void 0 : vt.id) === (fav === null || fav === void 0 ? void 0 : fav.variantId);
            })) || (ctData === null || ctData === void 0 ? void 0 : (ref1 = ctData.masterVariant) === null || ref1 === void 0 ? void 0 : ref1.id) === (fav === null || fav === void 0 ? void 0 : fav.variantId) && (ctData === null || ctData === void 0 ? void 0 : (ref2 = ctData.masterVariant) === null || ref2 === void 0 ? void 0 : ref2.sku) === sku) && isAuth) {
                _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_favoritesSlice__WEBPACK_IMPORTED_MODULE_2__/* .removeItems */ .Er)([
                    fav.id
                ])).unwrap().then((res)=>{
                    _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_1__/* .showToast */ .CF)({
                        message: toasterContent.unfavoriteSuccessMessage || removeItem,
                        isVisible: true
                    }));
                    addFavoriteCallBack(res === null || res === void 0 ? void 0 : res.lineItems);
                }).catch(()=>{
                    _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_1__/* .showToast */ .CF)({
                        message: removeItemError,
                        isVisible: true
                    }));
                });
            }
        });
    } else {
        _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_favoritesSlice__WEBPACK_IMPORTED_MODULE_2__/* .addProduct */ .gK)(sku)).unwrap().then((res)=>{
            _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_1__/* .showToast */ .CF)({
                message: toasterContent.successMessage || favSuccessMsg,
                isVisible: true
            }));
            addFavoriteCallBack(res === null || res === void 0 ? void 0 : res.lineItems);
        }).catch(()=>{
            _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_1__/* .showToast */ .CF)({
                message: favErrorMsg,
                isVisible: true
            }));
        });
    }
    window.keyFocusCallBack = e.target.id;
};
const addDatalayerForLocalStoreOrShowroom = (data)=>{
    const { localStoreOrShowroomRef , productAnalyticsData  } = data;
    if (localStoreOrShowroomRef.current) {
        const localStoreOrShowroomAnchorLink = localStoreOrShowroomRef.current.querySelector("a");
        if (localStoreOrShowroomAnchorLink) {
            localStoreOrShowroomAnchorLink.classList.add("gbh-data-layer");
            localStoreOrShowroomAnchorLink.setAttribute("data-gbh-data-layer", getAnalyticsData("local store or showroom", localStoreOrShowroomAnchorLink.getAttribute("href")));
            localStoreOrShowroomAnchorLink.setAttribute("data-gbh-data-layer-custom", productAnalyticsData.stringProductInfo);
        }
    }
};
const callNotification = (data)=>{
    const { email ="" , sku ="" , callBackNotify  } = data;
    if (email) {
        const body = {
            customer: {
                id: "",
                firstName: "",
                lastName: "",
                email: email
            },
            sku,
            pdpURL: window.location.href
        };
        _constants_api__WEBPACK_IMPORTED_MODULE_4__/* .apim.post */ .TH.post(_constants_routes__WEBPACK_IMPORTED_MODULE_5__/* .CATALOG_NOTIFY_ENDPOINT */ .lY, body).then((res)=>{
            if (res) {
                callBackNotify(true);
            }
        }).catch(()=>{
            callBackNotify(false);
        });
    }
};
const isAnchor = (element)=>{
    return element === null || element === void 0 ? void 0 : element.closest("a");
};
const isMatchingAnchorText = (anchor, text)=>{
    var ref;
    return (anchor === null || anchor === void 0 ? void 0 : (ref = anchor.textContent) === null || ref === void 0 ? void 0 : ref.toLowerCase()) === (text === null || text === void 0 ? void 0 : text.toLowerCase());
};
const getAnchorUrl = (anchor)=>{
    return anchor === null || anchor === void 0 ? void 0 : anchor.getAttribute("href");
};
const handleProductSuggestion = (e, productInfo)=>{
    const anchor = isAnchor(e.target);
    if (!anchor) return;
    if (!isMatchingAnchorText(anchor, _constants_index__WEBPACK_IMPORTED_MODULE_6__.SHOP_TOILET_SEATS)) return;
    const anchorUrl = getAnchorUrl(anchor);
    (0,_components_ProductDetail_v3_AddToCart_analytics__WEBPACK_IMPORTED_MODULE_3__/* .productSuggestionLinkAnalytics */ .I1)(_constants_index__WEBPACK_IMPORTED_MODULE_6__.SHOP_TOILET_SEATS, anchorUrl, productInfo);
};


/***/ }),

/***/ 3155:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AS": function() { return /* binding */ addDataLayerSuperSkuOptionSelected; },
/* harmony export */   "Sg": function() { return /* binding */ getBreadcrumbEventInfo; },
/* harmony export */   "f8": function() { return /* binding */ addBuyBtnAnalytics; },
/* harmony export */   "wQ": function() { return /* binding */ getEventInfo; },
/* harmony export */   "zE": function() { return /* binding */ addShareBtnAnalytics; }
/* harmony export */ });
/* unused harmony exports dataLayerAddToCart, addDataLayerForConfigurationExapandState, getWidgetEventInfo */
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55760);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41609);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96301);



const getEventInfo = function(type) {
    let needsJSON = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, toolTipText = arguments.length > 2 ? arguments[2] : void 0, accordianState = arguments.length > 3 ? arguments[3] : void 0;
    var ref, ref1, ref2;
    let eventAction;
    let eventName;
    let internalLinkType;
    let internalLinkName;
    if (type === "list info mouseover") {
        internalLinkType = "pdp:mouseover";
        internalLinkName = "list";
    } else if (type === "print") {
        internalLinkType = "pdp:print";
    } else if (type === "color selection") {
        internalLinkType = "pdp:color selection";
        internalLinkName = type;
    } else if (type === "select configurations") {
        internalLinkName = accordianState;
    } else if (type.includes("mouseover") && toolTipText) {
        internalLinkName = toolTipText === null || toolTipText === void 0 ? void 0 : toolTipText.toLowerCase();
        const title = type.replace("mouseover", "");
        internalLinkType = "pdp:mouseover:".concat(title);
    } else if (type === "remove") {
        internalLinkType = "pdp:".concat(type);
    } else if (type === "read more") {
        internalLinkType = "pdp:".concat(type);
    } else if (type === "tooltip") {
        internalLinkName = "info tooltip";
        internalLinkType = eventName = eventAction = "pdp:info tooltip";
    } else if (type === _constants__WEBPACK_IMPORTED_MODULE_2__.INSTALL_ITEMS || type === _constants__WEBPACK_IMPORTED_MODULE_2__.INSTALL_ITEMS_EDIT) {
        internalLinkType = eventName = eventAction = "pdp:".concat(type);
    }
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const pageInfoDetails = window === null || window === void 0 ? void 0 : (ref = window.adobeDataLayer) === null || ref === void 0 ? void 0 : ref.getState("page");
    const { productInfo  } = page;
    let internalLinkPositionName = "pdp";
    if ((pageInfoDetails === null || pageInfoDetails === void 0 ? void 0 : (ref1 = pageInfoDetails.pageInfo) === null || ref1 === void 0 ? void 0 : ref1.contentType) && (pageInfoDetails === null || pageInfoDetails === void 0 ? void 0 : (ref2 = pageInfoDetails.pageInfo) === null || ref2 === void 0 ? void 0 : ref2.contentType) === "pdp" && !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_1___default()(productInfo)) {
        if (productInfo.pdpType === "bundle") {
            internalLinkPositionName = "pdp:bundle";
        }
    }
    const eventInfo = {
        eventAction: eventAction || "pdp:product details:" + type + (accordianState ? ":".concat(accordianState) : ""),
        eventName: eventName || "pdp:product details:" + type + (accordianState ? ":".concat(accordianState) : ""),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: internalLinkName || type,
        internalLinkPosition: internalLinkPositionName,
        internalLinkType: internalLinkType || "pdp:navigation",
        internalLinkZoneName: "pdp:product details",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    if (needsJSON) {
        return eventInfo;
    }
    return JSON.stringify(eventInfo);
};
const dataLayerAddToCart = (param, serviceName)=>{
    let { res , productInfo  } = param;
    var ref;
    const { status , message ="n/a"  } = res;
    const isStatus = status === 200;
    const eventInfo = {
        eventAction: "pdp:cross-sell:kohler professional services:add to cart",
        eventName: "pdp:cross-sell:kohler professional services:add to cart",
        eventType: "navigation",
        eventMsg: message === null || message === void 0 ? void 0 : message.toLowerCase(),
        eventStatus: isStatus ? "success" : "failure",
        internalLinkName: "add to cart",
        internalLinkPosition: "pdp",
        internalLinkType: "pdp:".concat(serviceName === null || serviceName === void 0 ? void 0 : serviceName.toLowerCase()),
        internalLinkZoneName: "pdp:cross-sell:kohler professional services",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    page.cart = {
        cartID: res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.id
    };
    window.adobeDataLayer.push({
        event: "cmp:click",
        eventInfo,
        productInfo,
        page
    });
};
const addDataLayerForConfigurationExapandState = (title, accordianState, productInfo)=>{
    const eventInfo = getEventInfo("select configurations", true, null, accordianState);
    eventInfo.internalLinkType = "pdp:".concat(title);
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    window.adobeDataLayer.push({
        event: "cmp:click",
        eventInfo,
        page,
        productInfo
    });
};
const getBreadcrumbEventInfo = function() {
    let internalLinkName = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", link = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    var ref;
    return {
        eventAction: "pdp:breadcrumb",
        eventName: "pdp:breadcrumb",
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .sanitizeTextForAnalytics */ .T68)(internalLinkName),
        internalLinkPosition: "pdp",
        internalLinkType: "pdp:breadcrumb",
        internalLinkZoneName: "pdp:product details",
        internalLinkURL: link ? (((ref = String(link)) === null || ref === void 0 ? void 0 : ref.indexOf("http")) === -1 ? window.location.origin : "") + link : "n/a",
        clickInternalLinks: "true"
    };
};
const getWidgetEventInfo = (retailer, retailBtnName)=>({
        clickInternalLinks: "false",
        eventAction: "pdp:product details:".concat(retailBtnName),
        eventMsg: "n/a",
        eventName: "pdp:product details:".concat(retailBtnName),
        eventStatus: "n/a",
        eventType: "navigation",
        internalLinkName: "".concat(retailer, "-").concat(retailBtnName),
        internalLinkPosition: "pdp",
        internalLinkType: "pdp:".concat(retailBtnName),
        internalLinkURL: "n/a",
        internalLinkZoneName: "pdp:product details"
    });
const updatePrices = (obj, keys, price)=>{
    if (obj) {
        keys.forEach((key)=>{
            if (key in obj) {
                obj[key] = price;
            }
        });
    }
};
const addBuyBtnAnalytics = (e, retailer, productInfo, price)=>{
    var ref;
    e.preventDefault();
    e.stopPropagation();
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const retailBtnName = e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : ref.innerText;
    const eventInfo = getWidgetEventInfo(retailer, retailBtnName.toLowerCase());
    const keys = [
        "productSalePrice",
        "productBasePrice",
        "globalPromotionPrice"
    ];
    updatePrices(page.productInfo, keys, price);
    updatePrices(productInfo, keys, price);
    window.adobeDataLayer.push({
        event: "cmp:click",
        page,
        eventInfo,
        productInfo
    });
};
const addDataLayerSuperSkuOptionSelected = (action, field, productInfo)=>{
    const url = new URL(window.location.href);
    const formatString = (str)=>{
        str = str.toLowerCase();
        str = str.replace(/_/g, " ");
        return str;
    };
    const formatField = formatString(field);
    const formatAction = formatString(action);
    const eventInfo = {
        eventAction: "pdp:".concat(formatField, ":").concat(formatAction),
        eventName: "pdp:".concat(formatField, ":").concat(formatAction),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "".concat(formatAction, ":applied"),
        internalLinkPosition: "pdp",
        internalLinkType: "pdp:product options:".concat(formatField),
        internalLinkZoneName: "pdp:product details",
        internalLinkURL: "".concat(url),
        clickInternalLinks: "true"
    };
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    window.adobeDataLayer.push({
        event: "cmp:click",
        eventInfo,
        productInfo,
        page
    });
};
const addShareBtnAnalytics = (stringProductInfo)=>{
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "pdp:product details:share",
        eventMsg: "n/a",
        eventName: "pdp:product details:share",
        eventStatus: "n/a",
        eventType: "navigation",
        internalLinkName: "share",
        internalLinkPosition: "pdp",
        internalLinkType: "pdp:share",
        internalLinkURL: "n/a",
        internalLinkZoneName: "pdp:product details"
    };
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const { productInfo =""  } = JSON.parse(stringProductInfo);
    window.adobeDataLayer.push({
        event: "cmp:click",
        eventInfo,
        page,
        productInfo
    });
};


/***/ }),

/***/ 14887:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ec": function() { return /* binding */ checkUserZipCode; },
/* harmony export */   "H3": function() { return /* binding */ getInitialSku; },
/* harmony export */   "Jo": function() { return /* binding */ getColorFinishData; },
/* harmony export */   "O1": function() { return /* binding */ getZipCodeJsonFile; },
/* harmony export */   "S8": function() { return /* binding */ getDataSheetUrl; },
/* harmony export */   "WI": function() { return /* binding */ getColorDataObject; },
/* harmony export */   "i8": function() { return /* binding */ initPriceSpider; },
/* harmony export */   "lX": function() { return /* binding */ getTeaserFragments; },
/* harmony export */   "lk": function() { return /* binding */ getShippingLocations; },
/* harmony export */   "tz": function() { return /* binding */ checkProductCategory; },
/* harmony export */   "yS": function() { return /* binding */ getRequireItems; }
/* harmony export */ });
/* unused harmony export getTeaserDetails */
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41609);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _constants_api__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73350);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96301);
/* harmony import */ var _utils_index__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(20558);
/* harmony import */ var _store_index__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(88032);
/* harmony import */ var _store_features_pdpSlice__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(44561);
/* harmony import */ var _components_ProductDetail_v3_analytics__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(3155);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(55760);









const getInitialSku = (data)=>{
    var ref;
    const { productData , setSkuVariantCb , selectedColor  } = data;
    let colors = [];
    if (productData["Color.SKU.Details_ss"]) {
        colors = productData["Color.SKU.Details_ss"].map((color)=>{
            const d = color.split("|");
            return {
                color: d.at(0),
                sku: d[2],
                discontinued: !(d[4] === "false" || Date.parse(d[4]) > Date.now())
            };
        });
    }
    const availableSkus = colors.filter((color)=>!color.discontinued);
    const discontinuedAvailableSkus = colors.filter((color)=>color.discontinued);
    let initSku = "";
    if ((ref = availableSkus[0]) === null || ref === void 0 ? void 0 : ref.sku) {
        var ref1;
        var ref2;
        const { sku: selectedColorSku = ""  } = (ref2 = availableSkus.find((el)=>el.color === selectedColor)) !== null && ref2 !== void 0 ? ref2 : {};
        var ref3;
        initSku = selectedColorSku ? selectedColorSku : (ref3 = (ref1 = availableSkus[0]) === null || ref1 === void 0 ? void 0 : ref1.sku) !== null && ref3 !== void 0 ? ref3 : productData["masterSKU_s"];
    } else {
        var ref4;
        var ref5;
        initSku = ((ref5 = (ref4 = discontinuedAvailableSkus[0]) === null || ref4 === void 0 ? void 0 : ref4.sku) !== null && ref5 !== void 0 ? ref5 : productData["variantList.sku_ss"]) ? productData["variantList.sku_ss"][0] : "";
    }
    setSkuVariantCb && setSkuVariantCb(initSku);
    return initSku;
};
const checkProductCategory = (productCategory, category)=>{
    if (productCategory === category || productCategory === "") {
        return true;
    }
    return false;
};
const getZipCodeJsonFile = (jsonFileUrl, getZipCodeJsonFileCb)=>{
    try {
        if (!lodash_isEmpty__WEBPACK_IMPORTED_MODULE_1___default()(jsonFileUrl)) {
            (0,_constants_api__WEBPACK_IMPORTED_MODULE_2__/* .aemAxiosInstance */ .Gb)({
                url: _constants_index__WEBPACK_IMPORTED_MODULE_3__.GLOBAL_CONFIGURATION_ENDPOINT,
                params: {
                    path: jsonFileUrl
                }
            }).then((response)=>{
                if (response && response.data) {
                    getZipCodeJsonFileCb && getZipCodeJsonFileCb(response.data);
                } else {
                    console.error("API endpoint Url: Error occured while fetching data from Get URL Property");
                }
            });
        } else {
            console.warn("API endpoint Url: Get URL Property not found");
        }
    } catch (error) {
        console.error(error);
    }
};
const getShippingLocations = (statesData, states)=>{
    let resultTxt = "";
    if (statesData && (states === null || states === void 0 ? void 0 : states.length) > 0) {
        states.map((state, i)=>{
            const stateObj = statesData.find((st)=>{
                var ref;
                return state === ((ref = st.value) === null || ref === void 0 ? void 0 : ref.replace(/:US/g, ""));
            });
            if (stateObj === null || stateObj === void 0 ? void 0 : stateObj.text) {
                resultTxt = resultTxt + stateObj.text;
                if (i === states.length - 2) resultTxt += " and ";
                else if (i !== states.length - 1) resultTxt += ", ";
            }
        });
    }
    return resultTxt;
};
const getRequireItems = (items, discountedPrice, price, setInstallReqCb, setSubTotalCb, setPriceListCb, addItemsToCartCb)=>{
    setInstallReqCb(items);
    const cartItemProduct = [];
    const priceListItems = [];
    let requiredItemsPrice = 0;
    let priceLists = 0;
    let baseTotal = 0;
    let subTotalItem = 0;
    if (items.length > 0) {
        items && items.map((list)=>{
            const product = {};
            product.sku = list.skuid;
            product.brand = list.brandName;
            if (list.backorder) {
                product.quantity = 1;
                product.backorder = true;
                cartItemProduct.push(product);
            } else {
                const checkQuantity = lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(list.colorsData.find((requiredItem)=>requiredItem.id === list.skuid), "isOutOfStock", false);
                product.quantity = !checkQuantity ? 1 : 0;
                if (!checkQuantity) {
                    cartItemProduct.push(product);
                }
            }
            if (list === null || list === void 0 ? void 0 : list.priceData) {
                priceLists = lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(list.priceData.find((requiredList)=>requiredList.id === list.skuid), "discountedPrice", 0) > 0 ? lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(list.priceData.find((requiredList)=>requiredList.id === list.skuid), "discountedPrice", 0) : lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(list.priceData.find((requiredList)=>requiredList.id === list.skuid), "price", 0);
                priceListItems.push(priceLists);
                if (priceListItems.length >= 0) {
                    requiredItemsPrice = priceListItems.reduce((acc, item)=>{
                        return parseFloat(acc) + parseFloat(item);
                    }, 0);
                } else {
                    requiredItemsPrice = priceListItems[0];
                }
                baseTotal = discountedPrice > 0 ? discountedPrice : price;
                subTotalItem = baseTotal + requiredItemsPrice;
                setSubTotalCb(subTotalItem);
                setPriceListCb(requiredItemsPrice);
            }
        });
        addItemsToCartCb(cartItemProduct, false);
    } else {
        addItemsToCartCb([], false);
    }
};
const getTeaserFragments = (pageData, pdpData)=>{
    const { masterSKU_s: masterSku = "" , ProductLocalCategory_s: productLocalCategory = "" , BundleID_s: bundleSku = "" , BundleLocalCategory_s: bundleLocalCategory = ""  } = pdpData;
    const isPreviewMode = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_8__/* .getAEMPreviewModeCookie */ .Bq_)();
    const teaserFragmentOrder = getFragmentsOrder(pageData);
    const customerFacingSKU = masterSku || bundleSku;
    const category = productLocalCategory || bundleLocalCategory;
    const pdpXFPaths = getFragmentPaths(pageData);
    if (teaserFragmentOrder === null || teaserFragmentOrder === void 0 ? void 0 : teaserFragmentOrder.length) {
        _store_index__WEBPACK_IMPORTED_MODULE_5__/* .store.dispatch */ .h.dispatch((0,_store_features_pdpSlice__WEBPACK_IMPORTED_MODULE_6__/* .setIsTeaserLoaded */ .ZR)(true));
        const params = {
            skuId: customerFacingSKU,
            category: category,
            isPreviewMode
        };
        if (pdpXFPaths) params.xfPaths = pdpXFPaths;
        if (isPreviewMode) {
            (0,_constants_api__WEBPACK_IMPORTED_MODULE_2__/* .aemPreviewAxiosInstance */ .IT)({
                url: _constants_index__WEBPACK_IMPORTED_MODULE_3__.PDP_TEASER_DETAILS,
                params
            }).then((response)=>{
                const { data  } = response;
                if (data && teaserFragmentOrder.length) getTeaserDetails(data, teaserFragmentOrder);
                else console.error("Preview PDP Teaser Fragments Order Not Found..!");
            }).catch((error)=>{
                console.error("Preview PDP Teaser Fragments Fetching Error..!");
            });
        } else {
            (0,_constants_api__WEBPACK_IMPORTED_MODULE_2__/* .aemAxiosInstance */ .Gb)({
                url: _constants_index__WEBPACK_IMPORTED_MODULE_3__.PDP_TEASER_DETAILS,
                params
            }).then((response)=>{
                const { data  } = response;
                if (data && teaserFragmentOrder.length) getTeaserDetails(data, teaserFragmentOrder);
                else console.error("PDP Teaser Fragments Order Not Found..!");
            }).catch((error)=>{
                console.error("PDP Teaser Fragments Fetching Error..!");
            });
        }
    }
};
const getFragmentsOrder = (pageData)=>{
    const itemOrder = [];
    const teaserFragments = (0,_utils_index__WEBPACK_IMPORTED_MODULE_4__/* .recursiveDataFunction */ .Qe)(pageData, _constants_index__WEBPACK_IMPORTED_MODULE_3__.COMPONENT_TYPES.PRODUCT_DETAILS_EXFPDP);
    if (teaserFragments && teaserFragments.length) {
        const list = lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(teaserFragments[0], "configuredXfPathModels", "");
        list.map((item)=>{
            const itemArray = item && (item === null || item === void 0 ? void 0 : item.path) && item.path.split("/");
            itemOrder.push(itemArray[itemArray.length - 1]);
        });
        return itemOrder;
    }
};
const getFragmentPaths = (pageData)=>{
    const teaserFragments = (0,_utils_index__WEBPACK_IMPORTED_MODULE_4__/* .recursiveDataFunction */ .Qe)(pageData, _constants_index__WEBPACK_IMPORTED_MODULE_3__.COMPONENT_TYPES.PRODUCT_DETAILS_EXFPDP);
    if (teaserFragments && teaserFragments.length) {
        const fragmentPaths = teaserFragments.reduce((paths, fragment)=>{
            const list = lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(fragment, "configuredXfPathModels", "");
            list.forEach((item)=>{
                paths.push(item === null || item === void 0 ? void 0 : item.path);
            });
            return paths;
        }, []);
        return fragmentPaths.join(",");
    }
    return "";
};
const getTeaserDetails = (data, teaserFragmentOrder)=>{
    const teaserDataPromises = [];
    teaserFragmentOrder.forEach(async (item)=>{
        if (data[item]) {
            const teaserDeta = data[item].map(async (url)=>{
                const resData = await (0,_constants_api__WEBPACK_IMPORTED_MODULE_2__/* .aemAxiosInstance */ .Gb)({
                    url: _constants_index__WEBPACK_IMPORTED_MODULE_3__.GLOBAL_CONFIGURATION_ENDPOINT,
                    params: {
                        path: "".concat(url, ".model.json")
                    }
                });
                return resData.data;
            });
            teaserDataPromises.push(...teaserDeta);
        }
    });
    Promise.all(teaserDataPromises).then((response)=>{
        _store_index__WEBPACK_IMPORTED_MODULE_5__/* .store.dispatch */ .h.dispatch((0,_store_features_pdpSlice__WEBPACK_IMPORTED_MODULE_6__/* .setTeaserContent */ .ub)(response));
    }).catch((error)=>{
        _store_index__WEBPACK_IMPORTED_MODULE_5__/* .store.dispatch */ .h.dispatch((0,_store_features_pdpSlice__WEBPACK_IMPORTED_MODULE_6__/* .setTeaserContent */ .ub)([]));
        console.error("PDP Teaser Fragments Data Fetching Error..!");
    });
};
const initPriceSpider = (productInfo)=>{
    const waitTimeForPsWidgetElementsToLoad = 500;
    let psWidgetNode = document.getElementsByClassName("ps-widget")[0];
    // Here reason to use mutation observer instead of react ref is bcoz
    // this ps widget elements are getting fluctuated
    const psWidgetObserver = new MutationObserver(()=>{
        // fired when a mutation occurs
        psWidgetNode.querySelectorAll("div[data-retailer]").forEach((retailerDiv)=>{
            var ref, ref1;
            const btn = retailerDiv.querySelector(".ps-online-buy-button");
            const retailer = (ref = retailerDiv.getAttribute("data-retailer")) === null || ref === void 0 ? void 0 : ref.toLowerCase();
            const priceText = ((ref1 = retailerDiv.querySelector(".ps-price")) === null || ref1 === void 0 ? void 0 : ref1.textContent) || "n/a";
            const price = parseFloat((0,_utils_index__WEBPACK_IMPORTED_MODULE_4__/* .getSanitizedFloatingNumber */ .zj)(priceText)) || "n/a";
            if (btn.getAttribute("attachedEvent") !== "true") {
                btn.addEventListener("click", (e)=>{
                    (0,_components_ProductDetail_v3_analytics__WEBPACK_IMPORTED_MODULE_7__/* .addBuyBtnAnalytics */ .f8)(e, retailer, productInfo, price);
                }, false);
                btn.setAttribute("attachedEvent", "true");
            }
        });
    });
    let psWidgetObserverTimeout;
    const addObserverIfDesiredNodeAvailable = ()=>{
        psWidgetNode = document.getElementsByClassName("ps-widget")[0];
        if (!psWidgetNode) {
            psWidgetObserverTimeout = setTimeout(addObserverIfDesiredNodeAvailable, waitTimeForPsWidgetElementsToLoad);
            return;
        }
        if (psWidgetObserverTimeout) {
            clearTimeout(psWidgetObserverTimeout);
            psWidgetObserverTimeout = undefined;
        }
        const config = {
            subtree: true,
            childList: true
        };
        psWidgetObserver.observe(psWidgetNode, config);
    };
    addObserverIfDesiredNodeAvailable();
};
const getDataSheetUrl = function() {
    let productServices = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], currentSku = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    var ref;
    const currentSkuMasterVariant = (ref = productServices.find((product)=>{
        var ref;
        return (product === null || product === void 0 ? void 0 : (ref = product.masterVariant) === null || ref === void 0 ? void 0 : ref.sku) === currentSku;
    })) !== null && ref !== void 0 ? ref : {};
    const { masterVariant: { attributes =[]  } = {}  } = currentSkuMasterVariant;
    var ref1;
    const { value: productResourceData = []  } = (ref1 = attributes.find((e)=>e.name === "ProductResource")) !== null && ref1 !== void 0 ? ref1 : {};
    var ref2;
    const dataSheet = (ref2 = productResourceData.find((e)=>{
        return e.find((el)=>el.value === "DataSheet");
    })) !== null && ref2 !== void 0 ? ref2 : [];
    var ref3;
    const { value: resourceFullWebURL = ""  } = (ref3 = dataSheet.find((e)=>e.name === "ResourceFullWebURL")) !== null && ref3 !== void 0 ? ref3 : {};
    return resourceFullWebURL;
};
const getColorDataObject = (d)=>{
    return {
        name: d[0],
        swatch: d[1],
        sku: d[2],
        isStock: d[3],
        discontinued: !(d[4] === "false" || Date.parse(d[4]) > Date.now()),
        customerSku: d[5]
    };
};
const getColorFinishData = function() {
    let data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return data["Color.SKU.Details_ss"];
};
const checkUserZipCode = (data)=>{
    const { userZipCode , state , callBack  } = data;
    let availableSkuIdsForService = [];
    const { zipCodeData =[]  } = state;
    for (const zipKey of zipCodeData){
        const key = Object.keys(zipKey)[0];
        for (const zipInnerKey of zipKey[key]){
            const zipcode = Object.keys(zipInnerKey)[0];
            if (zipcode === userZipCode) {
                availableSkuIdsForService = zipInnerKey[zipcode];
                break;
            }
        }
        if (availableSkuIdsForService.length) break;
    }
    const isNearest = availableSkuIdsForService.length;
    callBack && callBack(isNearest);
};


/***/ }),

/***/ 73058:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P0": function() { return /* binding */ getDDMMYYYYDate; },
/* harmony export */   "YU": function() { return /* binding */ submitRegistrationGenericError; },
/* harmony export */   "in": function() { return /* binding */ convertToPhoneNumber; },
/* harmony export */   "pD": function() { return /* binding */ getCountryName; },
/* harmony export */   "qs": function() { return /* binding */ getStateName; }
/* harmony export */ });
/* harmony import */ var _components_RegisterOnlineProduct_v1_RegisterOnlineProductAnalytics__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6570);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55760);


const submitRegistrationGenericError = (productDetails, errorMsg)=>{
    const isShowEvent = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_1__/* .isShowAnalyticsEventLoaded */ .xJ2)();
    if (!isShowEvent) {
        (0,_components_RegisterOnlineProduct_v1_RegisterOnlineProductAnalytics__WEBPACK_IMPORTED_MODULE_0__/* .addReviewRegistrationAnalytics */ .VS)("cmp:click", "failure", productDetails, errorMsg);
    }
};
const convertToPhoneNumber = (text)=>{
    try {
        if (text) {
            const value = text;
            const x = value.replace(/\D/g, "").match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
            const suffix = x[3] ? "-" + x[3] : "";
            return !x[2] ? "(" + x[1] : "(" + x[1] + ") " + x[2] + suffix;
        } else {
            return;
        }
    } catch (error) {
        console.error(error);
    }
};
const getStateName = (stateVal, countryVal, data)=>{
    var ref, ref1;
    let country = {};
    if (data.find((obj)=>obj.name === countryVal)) {
        country = data.find((obj)=>obj.name === countryVal);
    } else {
        var ref2;
        country = (ref2 = data.find((obj)=>obj.code === countryVal)) !== null && ref2 !== void 0 ? ref2 : {};
    }
    if ((ref = country.states) === null || ref === void 0 ? void 0 : ref.find((obj)=>obj.name === stateVal)) return stateVal;
    var ref3;
    const state = (ref3 = (ref1 = country.states) === null || ref1 === void 0 ? void 0 : ref1.find((obj)=>obj.code === stateVal)) !== null && ref3 !== void 0 ? ref3 : {};
    var _name;
    return (_name = state.name) !== null && _name !== void 0 ? _name : "";
};
const getCountryName = (countryVal, data)=>{
    if (data.find((obj)=>obj.name === countryVal)) return countryVal;
    var ref;
    const country = (ref = data.find((obj)=>obj.code === countryVal)) !== null && ref !== void 0 ? ref : {};
    var _name;
    return (_name = country.name) !== null && _name !== void 0 ? _name : "";
};
const getDDMMYYYYDate = (date)=>{
    const todayDate = date.getMonth() + 1 + "/" + date.getDate() + "/" + date.getFullYear();
    return todayDate;
};



/***/ }),

/***/ 6570:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fi": function() { return /* binding */ addReviewRegistrationEventInfo; },
/* harmony export */   "Ki": function() { return /* binding */ selectProdcutEdit; },
/* harmony export */   "TP": function() { return /* binding */ getCheckboxAnalyticsdata; },
/* harmony export */   "VS": function() { return /* binding */ addReviewRegistrationAnalytics; },
/* harmony export */   "jb": function() { return /* binding */ personalInfoEdit; },
/* harmony export */   "m5": function() { return /* binding */ getSelectAllAnalytics; },
/* harmony export */   "wQ": function() { return /* binding */ getEventInfo; },
/* harmony export */   "y": function() { return /* binding */ getReviewProductsBackToMyProductsAnalytics; },
/* harmony export */   "zm": function() { return /* binding */ addRegisterOnlineProductsAnalytics; }
/* harmony export */ });
const addReviewRegistrationAnalytics = (action, status, productData, message)=>{
    const eventInfo = {
        eventAction: "my account:register online kohler products:review and register:submit registration",
        eventName: "my account:register online kohler products:review and register:submit registration",
        eventType: "navigation",
        eventMsg: message || "n/a",
        eventStatus: status || "n/a",
        internalLinkName: "submit registration",
        internalLinkPosition: "register products",
        internalLinkType: "my account:navigation",
        internalLinkZoneName: "my account:register online kohler products:review and register",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    const ProductInfo = [];
    productData === null || productData === void 0 ? void 0 : productData.map((data)=>{
        const obj = {
            productBrand: data.brandName || "n/a",
            productCategory: data.category || "n/a",
            productColor: data.colorValue || "n/a",
            productID: data.customerFacingSKU || "n/a",
            description: data.descriptio || "n/a",
            imgSrc: data.imgSrc || "n/a",
            orderNo: data.orderNo || "n/a",
            productName: data.productName || "n/a",
            purchaseDate: data.purchased || "n/a",
            skuid: data.skuid || "n/a",
            slug: data.slug || "n/a",
            frequency: "n/a",
            isRecommended: "n/a",
            isSendNow: "n/a",
            isSubscription: "n/a",
            productCoupondiscount: "n/a",
            productPartnerBuyNow: "n/a",
            pdpType: "regular finished goods",
            productFindingMethod: "n/a"
        };
        ProductInfo.push(obj);
    });
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = action === "cmp:show" ? window.pageObj : (getState === null || getState === void 0 ? void 0 : getState("page")) || {};
    window.adobeDataLayer.push({
        event: action,
        page,
        eventInfo,
        productInfo: ProductInfo
    });
};
const getReviewProductsBackToMyProductsAnalytics = (isSuccess, myProductsPath)=>{
    const pageName = isSuccess ? "thank you for registering the products" : "top navigation";
    return JSON.stringify({
        eventAction: "my account:register online kohler products:".concat(pageName, ":back to my products"),
        eventName: "my account:register online kohler products:".concat(pageName, ":back to my products"),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "back to my products",
        internalLinkPosition: "register products",
        internalLinkType: "my account:navigation",
        internalLinkZoneName: "my account:register online kohler products:".concat(pageName),
        internalLinkURL: (myProductsPath.indexOf("http") === -1 ? window.location.origin : "") + myProductsPath,
        clickInternalLinks: "true"
    });
};
const personalInfoEdit = JSON.stringify({
    eventAction: "my account:register online kohler products:personal information:edit",
    eventName: "my account:register online kohler products:personal information:edit",
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: "edit",
    internalLinkPosition: "register products",
    internalLinkType: "my account:navigation",
    internalLinkZoneName: "my account:register online kohler products:personal information",
    internalLinkURL: "n/a",
    clickInternalLinks: "true"
});
const selectProdcutEdit = JSON.stringify({
    eventAction: "my account:register online kohler products:select the products you'd like to register:edit",
    eventName: "my account:register online kohler products:select the products you'd like to register:edit",
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: "edit",
    internalLinkPosition: "register products",
    internalLinkType: "my account:navigation",
    internalLinkZoneName: "my account:register online kohler products:select the products you'd like to register",
    internalLinkURL: "n/a",
    clickInternalLinks: "true"
});
const addRegisterOnlineProductsAnalytics = function(action, status, productData, message) {
    let eventText = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "personal information";
    const eventInfo = {
        eventAction: "my account:register online kohler products:".concat(eventText, ":next step"),
        eventName: "my account:register online kohler products:".concat(eventText, ":next step"),
        eventType: "navigation",
        eventMsg: message || "n/a",
        eventStatus: status,
        internalLinkName: "next step",
        internalLinkPosition: "register products",
        internalLinkType: "my account:navigation",
        internalLinkZoneName: "my account:register online kohler products:".concat(eventText),
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    const ProductInfo = [];
    productData === null || productData === void 0 ? void 0 : productData.forEach((data)=>{
        const obj = {
            productBrand: data.brandName,
            productCategory: data.category || "n/a",
            productColor: data.colorValue || "n/a",
            productID: data.customerFacingSKU || "n/a",
            description: data.descriptio || "n/a",
            imgSrc: data.imgSrc || "n/a",
            orderNo: data.orderNo || "n/a",
            productName: data.productName || "n/a",
            purchaseDate: data.purchased || "n/a",
            skuid: data.skuid || "n/a",
            slug: data.slug || "n/a",
            frequency: "n/a",
            isRecommended: "n/a",
            isSendNow: "n/a",
            isSubscription: "n/a",
            productCoupondiscount: "n/a",
            productPartnerBuyNow: "n/a",
            pdpType: "regular finished goods",
            productFindingMethod: "n/a"
        };
        ProductInfo.push(obj);
    });
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = action === "cmp:show" ? window.pageObj : (getState === null || getState === void 0 ? void 0 : getState("page")) || {};
    window.adobeDataLayer.push({
        event: action,
        page,
        eventInfo,
        productInfo: ProductInfo
    });
};
const getCheckboxAnalyticsdata = (isChecked)=>{
    const isCheckedOrUnchecked = isChecked ? "unchecked" : "checked";
    return JSON.stringify({
        eventAction: "my account:register online kohler products:select the products you'd like to register:register:".concat(isCheckedOrUnchecked),
        eventName: "my account:register online kohler products:select the products you'd like to register:register:".concat(isCheckedOrUnchecked),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "register:".concat(isCheckedOrUnchecked),
        internalLinkPosition: "register products",
        internalLinkType: "my account:checkbox",
        internalLinkZoneName: "my account:register online kohler products:select the products you'd like to register",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    });
};
const getSelectAllAnalytics = (productData, data)=>{
    const isSelectOrUnselectAll = productData.length === (data === null || data === void 0 ? void 0 : data.length) ? "select all" : "unselect all";
    return JSON.stringify({
        eventAction: "my account:register online kohler products:select the products you'd like to register:".concat(isSelectOrUnselectAll),
        eventName: "my account:register online kohler products:select the products you'd like to register:".concat(isSelectOrUnselectAll),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "".concat(isSelectOrUnselectAll),
        internalLinkPosition: "register products",
        internalLinkType: "my account:navigation",
        internalLinkZoneName: "my account:register online kohler products:select the products you'd like to register",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    });
};
const getEventInfo = (linkUrl, isForthankYOu)=>{
    const type = isForthankYOu ? "thank you for registering the products" : "product registration summary";
    return JSON.stringify({
        clickInternalLinks: "true",
        eventAction: "my account:register online kohler products:".concat(type, ":review products"),
        eventName: "my account:register online kohler products:".concat(type, ":review products"),
        eventMsg: "n/a",
        eventStatus: "n/a",
        eventType: "navigation",
        internalLinkName: "review products",
        internalLinkPosition: "register products",
        internalLinkType: "my account:navigation",
        internalLinkURL: (linkUrl.indexOf("http") === -1 ? window.location.origin : "") + linkUrl,
        internalLinkZoneName: "my account:register online kohler products:".concat(type)
    });
};
// step reviewInformation
const addReviewRegistrationEventInfo = (type, linkUrl)=>{
    const linkFor = type === null || type === void 0 ? void 0 : type.toLowerCase();
    return {
        eventAction: "my account:register online kohler products:review and register:".concat(linkFor),
        eventName: "my account:register online kohler products:review and register:".concat(linkFor),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: linkFor,
        internalLinkPosition: "register products",
        internalLinkType: "my account:navigation",
        internalLinkZoneName: "my account:register online kohler products:review and register",
        internalLinkURL: linkUrl,
        clickInternalLinks: "false"
    };
};



/***/ }),

/***/ 42346:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _constants_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73350);
/* harmony import */ var _components_core_Button_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7872);
/* harmony import */ var _components_core_Heading_Heading__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22231);
/* harmony import */ var html_react_parser__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25935);
/* harmony import */ var _components_Shared_ErrorBoundary_index_module_scss__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(73712);
/* harmony import */ var _components_Shared_ErrorBoundary_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_components_Shared_ErrorBoundary_index_module_scss__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67294);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(96301);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(55760);
/* harmony import */ var _components_Shared_GlobalPage_GlobalPageHeader__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(75484);
/* harmony import */ var _components_Shared_GlobalPage_GlobalPageFooter__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(10884);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_10__);












const ErrorPage = ()=>{
    const [header, setHeader] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(null);
    const [footer, setFooter] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(null);
    const [dataURL, setDataURL] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)("");
    const [pageData, setPageData] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)({});
    const axiosCall = async ()=>{
        var ref, ref1;
        (0,_constants_api__WEBPACK_IMPORTED_MODULE_1__/* .aemAxiosInstance */ .Gb)({
            url: _constants_index__WEBPACK_IMPORTED_MODULE_6__.GLOBAL_CONFIGURATION_ENDPOINT,
            params: {
                path: "".concat(_constants_index__WEBPACK_IMPORTED_MODULE_6__.headerUrl, ".model.json")
            }
        }).then((res)=>{
            setHeader((0,_utils_helper__WEBPACK_IMPORTED_MODULE_7__/* .filterBackEndJson */ .LjD)(res.data));
        }).catch((err)=>{
            console.error("Failed to get compare attributes JSON file", err);
        });
        (0,_constants_api__WEBPACK_IMPORTED_MODULE_1__/* .aemAxiosInstance */ .Gb)({
            url: _constants_index__WEBPACK_IMPORTED_MODULE_6__.GLOBAL_CONFIGURATION_ENDPOINT,
            params: {
                path: "".concat(_constants_index__WEBPACK_IMPORTED_MODULE_6__.footerUrl, ".model.json")
            }
        }).then((res)=>{
            setFooter((0,_utils_helper__WEBPACK_IMPORTED_MODULE_7__/* .filterBackEndJson */ .LjD)(res.data));
        }).catch((err)=>{
            console.error("Failed to get compare attributes JSON file", err);
        });
        const { data: configData = {}  } = await (0,_constants_api__WEBPACK_IMPORTED_MODULE_1__/* .aemAxiosInstance */ .Gb)({
            url: "".concat(_constants_index__WEBPACK_IMPORTED_MODULE_6__.CORE_GLOBAL_CONFIG_URL),
            method: "GET"
        });
        setDataURL(configData === null || configData === void 0 ? void 0 : (ref = configData.contentFragmentListConfig) === null || ref === void 0 ? void 0 : (ref1 = ref.map) === null || ref1 === void 0 ? void 0 : ref1.pageNotFoundError);
        if (dataURL) {
            (0,_constants_api__WEBPACK_IMPORTED_MODULE_1__/* .aemAxiosInstance */ .Gb)({
                url: _constants_index__WEBPACK_IMPORTED_MODULE_6__.GLOBAL_CONFIGURATION_ENDPOINT,
                params: {
                    path: dataURL
                }
            }).then((res)=>{
                var ref;
                setPageData((ref = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_7__/* .filterBackEndJson */ .LjD)(res)) === null || ref === void 0 ? void 0 : ref.data);
            }).catch((err)=>{
                console.error("Failed to get compare attributes JSON file", err);
            });
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(()=>{
        axiosCall();
    }, [
        dataURL
    ]);
    const { errorTitle ="" , supportNumberAndLabel ="" , previousPageLabel ="" , refreshLabel ="" , homepageLable ="" , homepageLink ="" , errorImage =""  } = pageData || {};
    const homeURL = "".concat(_constants_index__WEBPACK_IMPORTED_MODULE_6__.authorBaseUrl).concat(homepageLink);
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_10__.useRouter)();
    const handlePrev = ()=>{
        document.referrer === "" ? router.push(homeURL) : history.back();
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            header ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Shared_GlobalPage_GlobalPageHeader__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                header: header
            }) : null,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_components_Shared_ErrorBoundary_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().Container),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "subContainer",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "mainSection",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "heading",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_core_Heading_Heading__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                        level: 1,
                                        className: "heading-grid",
                                        children: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(errorTitle)
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "buttonSection",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_core_Button_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                            type: "ghost",
                                            role: "button",
                                            size: "small",
                                            arrowImg: true,
                                            flexible: true,
                                            label: previousPageLabel,
                                            onClick: handlePrev
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_core_Button_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                            type: "ghost",
                                            role: "button",
                                            size: "small",
                                            flexible: true,
                                            label: refreshLabel,
                                            onClick: ()=>window.location.reload()
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_core_Button_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                            type: "ghost",
                                            role: "button",
                                            size: "small",
                                            flexible: true,
                                            label: homepageLable,
                                            onClick: ()=>window.location.href = homeURL
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "paraG",
                                            children: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(supportNumberAndLabel)
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "imageDiv",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: "".concat(_constants_index__WEBPACK_IMPORTED_MODULE_6__.authorBaseUrl).concat(errorImage),
                                alt: "imag"
                            })
                        })
                    ]
                })
            }),
            footer ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Shared_GlobalPage_GlobalPageFooter__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                footer: footer
            }) : null
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (ErrorPage);


/***/ }),

/***/ 10884:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9473);
/* harmony import */ var _components_AemGrid__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66564);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4298);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(55760);
/* harmony import */ var _store_features_genericSlice__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(88751);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96301);








const GlobalPageFooter = (props)=>{
    const { footer , footerScripting  } = props;
    const [scripts, setScripts] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useDispatch */ .I0)();
    const { pageIsInteractive  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_6__/* .selectGenericState */ .Px);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const { pageLevelDetails =[]  } = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__/* .getPageLevelScriptsAndStyles */ .ptY)(footerScripting);
        setScripts(pageLevelDetails["pageScripts"]);
    }, [
        footerScripting
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        (0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__/* .getScriptsAndStyles */ .csL)(footer);
    }, [
        footer
    ]);
    const eventHandler = {
        store: {},
        callbacks: {
            setGlobalScripts: (item)=>{
                dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_6__/* .setGlobalScripts */ .n8)(item));
            },
            setGlobalStyles: (item)=>{
                dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_6__/* .setGlobalStyles */ .cw)(item));
            }
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            pageIsInteractive && scripts.map((script, i)=>{
                if (script.src) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_4___default()), {
                    src: script.src,
                    type: script.type,
                    integrity: script.integrity,
                    id: "footerscript-".concat(i)
                }, "footerscript-".concat(i));
                if (!script.src && script.innerHTML) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_4___default()), {
                    id: "footerscriptHtml-".concat(i),
                    children: "".concat(script.innerHTML)
                }, "footerscriptHtml-".concat(i));
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_AemGrid__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                data: footer,
                count: 0,
                eventHandler: eventHandler,
                fragment: _constants__WEBPACK_IMPORTED_MODULE_7__.FRAGMENT_TYPES.FOOTER
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (GlobalPageFooter);


/***/ }),

/***/ 75484:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ GlobalPage_GlobalPageHeader; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var styled_jsx_style = __webpack_require__(51857);
var style_default = /*#__PURE__*/__webpack_require__.n(styled_jsx_style);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./components/Shared/HeaderNavTabs/utils.js
var utils = __webpack_require__(68446);
;// CONCATENATED MODULE: ./utils/textUtils.js
const sanitizeText = (text)=>{
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    if (!text) return "";
    return (ref6 = (ref5 = (ref4 = (ref3 = (ref2 = (ref1 = (ref = text === null || text === void 0 ? void 0 : text.replace(/<[^>]*>/g, "") // Remove HTML tags
    ) === null || ref === void 0 ? void 0 : ref.replace(/&amp;/g, "&") // Convert &amp; to &
    ) === null || ref1 === void 0 ? void 0 : ref1.replace(/&lt;/g, "<") // Convert &lt; to <
    ) === null || ref2 === void 0 ? void 0 : ref2.replace(/&gt;/g, ">") // Convert &gt; to >
    ) === null || ref3 === void 0 ? void 0 : ref3.replace(/&quot;/g, '"') // Convert &quot; to "
    ) === null || ref4 === void 0 ? void 0 : ref4.replace(/&#039;/g, "'") // Convert &#039; to '
    ) === null || ref5 === void 0 ? void 0 : ref5.replace(/&#39;/g, "'") // Convert &#39; to '
    ) === null || ref6 === void 0 ? void 0 : ref6.trim();
};

;// CONCATENATED MODULE: ./components/DesignSystem/utils/navigationHelper.js
/**
 * Helper functions for navigation mapping
 */ /**
 * Recursively searches an object tree to find an item by name
 * @param {Object} obj - Object tree to search
 * @param {string} name - Name to search for
 * @return {Object|null} Found item or null
 */ 

const findItemByName = (obj, name)=>{
    // Check if obj is null/undefined first
    if (!obj) return {};
    // If we have :items, check them first
    if (obj[":items"]) {
        // Look through each key in :items
        for (const key of Object.keys(obj[":items"])){
            // If key contains our search name
            if (key.includes(name)) {
                return obj[":items"][key];
            }
            // If this item has nested :items, recurse into them
            const result = findItemByName(obj[":items"][key], name);
            if (result) return result;
        }
    }
    // Return empty object instead of null to allow safe property access
    return null;
};
const hasHeaderItems = (header)=>{
    if (header[":items"]) {
        for (const key of Object.keys(header[":items"])){
            if (header[":items"][key][":items"] && Object.keys(header[":items"][key][":items"]).length > 0) {
                return true;
            }
        }
    }
    return false;
};
/**
 * Extracts menu items from a navigation object
 * @param {Object} obj - Navigation object
 * @return {Array} Array of menu items
 */ function getMenuItems(obj) {
    const result = [];
    // Check if object has itemsOrder
    if (obj === null || !obj[":itemsOrder"]) return result;
    // Iterate through itemsOrder
    for (const itemKey of obj[":itemsOrder"]){
        const item = obj[":items"][itemKey];
        // For each item, check its :items
        if (item[":items"]) {
            // Look for keys containing globalnavigation_v3
            for (const key of Object.keys(item[":items"])){
                if (key.includes("globalnavigation_v3")) {
                    var _appliedCssClassNames;
                    result.push({
                        ...item[":items"][key],
                        appliedCssClassNames: (_appliedCssClassNames = item.appliedCssClassNames) !== null && _appliedCssClassNames !== void 0 ? _appliedCssClassNames : ""
                    });
                }
            }
        }
    }
    return result;
}
const checkForBusinessLevelOneArray = (obj)=>{
    if (!(obj === null || obj === void 0 ? void 0 : obj.levelOneNavMulti)) return false;
    return obj.levelOneNavMulti.some((levelOne)=>{
        if (!(levelOne === null || levelOne === void 0 ? void 0 : levelOne.levelTwoNavMulti)) return false;
        // Check if all levelTwo items have empty levelThreeNavMulti arrays
        return levelOne.levelTwoNavMulti.every((levelTwo)=>{
            var ref;
            return (levelTwo === null || levelTwo === void 0 ? void 0 : (ref = levelTwo.levelThreeNavMulti) === null || ref === void 0 ? void 0 : ref.length) === 0;
        });
    });
};
const transformArray = (obj, tabTitle)=>{
    var ref;
    const res = [];
    (ref = obj["levelOneNavMulti"]) === null || ref === void 0 ? void 0 : ref.forEach((item)=>{
        var ref;
        const levelTwoArray = [];
        item === null || item === void 0 ? void 0 : (ref = item.levelTwoNavMulti) === null || ref === void 0 ? void 0 : ref.forEach((levelTwo)=>{
            var ref, ref1, ref2, ref3;
            levelTwoArray.push({
                title: {
                    trackingAttributes: {
                        "data-datalayer-id": "kds-element-navigation",
                        "data-datalayer-data": JSON.stringify({
                            clickInternalLinks: (0,utils/* modifyHref */.L9)(levelTwo.groupLink) ? "true" : "false",
                            internalLinkName: "".concat(tabTitle, " > ").concat(sanitizeText(levelTwo.groupTitle)).toLowerCase(),
                            internalLinkURL: levelTwo.groupLink ? (ref = "".concat(levelTwo.groupLink.indexOf("http") === -1 ?  true && window.location.origin : "").concat((0,utils/* modifyHref */.L9)(levelTwo.groupLink))) === null || ref === void 0 ? void 0 : ref.toLowerCase() : "n/a"
                        })
                    },
                    text: sanitizeText(levelTwo.groupTitle),
                    href: (0,utils/* modifyHref */.L9)(levelTwo.groupLink),
                    target: levelTwo.newTabGroup ? "_blank" : "_self"
                },
                isCTA: (ref1 = levelTwo.groupTitle) === null || ref1 === void 0 ? void 0 : ref1.includes("carrot-icon"),
                items: ((ref2 = levelTwo.levelThreeNavMulti) === null || ref2 === void 0 ? void 0 : ref2.length) > 0 ? (ref3 = levelTwo.levelThreeNavMulti) === null || ref3 === void 0 ? void 0 : ref3.map((levelThree)=>{
                    var ref;
                    return {
                        trackingAttributes: {
                            "data-datalayer-id": "kds-element-navigation",
                            "data-datalayer-data": JSON.stringify({
                                clickInternalLinks: (0,utils/* modifyHref */.L9)(levelThree.link) ? "true" : "false",
                                internalLinkName: (ref = "".concat(tabTitle, " > ").concat(sanitizeText(levelTwo.groupTitle), " > ").concat(sanitizeText(levelThree.label))) === null || ref === void 0 ? void 0 : ref.toLowerCase(),
                                internalLinkURL: levelThree.link ? "".concat(levelThree.link.indexOf("http") === -1 ?  true && window.location.origin : "").concat((0,utils/* modifyHref */.L9)(levelThree.link)).toLowerCase() : "n/a"
                            })
                        },
                        text: sanitizeText(levelThree.label),
                        href: (0,utils/* modifyHref */.L9)(levelThree.link),
                        target: levelThree.newTab ? "_blank" : "_self"
                    };
                }) : undefined
            });
        });
        res.push(levelTwoArray);
    });
    return res;
};
const transformBusinessArray = (obj, tabTitle)=>{
    var ref;
    const res = [];
    (ref = obj["levelOneNavMulti"]) === null || ref === void 0 ? void 0 : ref.forEach((item)=>{
        // Check if this levelOne item has all empty levelThreeNavMulti arrays
        if (checkForBusinessLevelOneArray({
            levelOneNavMulti: [
                item
            ]
        })) {
            var ref;
            // If true, create a simplified structure with just titles and links
            const simplifiedStructure = {
                items: ((ref = item.levelTwoNavMulti) === null || ref === void 0 ? void 0 : ref.map((levelTwo)=>{
                    var ref, ref1;
                    return {
                        title: {
                            text: sanitizeText(levelTwo.groupTitle),
                            href: (0,utils/* modifyHref */.L9)(levelTwo.groupLink),
                            trackingAttributes: {
                                "data-datalayer-id": "kds-element-navigation",
                                "data-datalayer-data": JSON.stringify({
                                    clickInternalLinks: (0,utils/* modifyHref */.L9)(levelTwo.groupLink) ? "true" : "false",
                                    internalLinkName: (ref = "".concat(tabTitle, " > ").concat(sanitizeText(levelTwo.groupTitle))) === null || ref === void 0 ? void 0 : ref.toLowerCase(),
                                    internalLinkURL: levelTwo.groupLink ? (ref1 = "".concat(levelTwo.groupLink.indexOf("http") === -1 ?  true && window.location.origin : "").concat((0,utils/* modifyHref */.L9)(levelTwo.groupLink))) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase() : "n/a"
                                })
                            }
                        },
                        newTabGroup: levelTwo.newTabGroup
                    };
                })) || []
            };
            res.push(simplifiedStructure);
        } else {
            var ref1;
            // If false, keep the existing structure with tracking attributes
            const levelTwoArray = [];
            item === null || item === void 0 ? void 0 : (ref1 = item.levelTwoNavMulti) === null || ref1 === void 0 ? void 0 : ref1.forEach((levelTwo)=>{
                var ref, ref1, ref2, ref3;
                levelTwoArray.push({
                    title: {
                        text: sanitizeText(levelTwo.groupTitle),
                        href: (0,utils/* modifyHref */.L9)(levelTwo.groupLink),
                        target: levelTwo.newTabGroup ? "_blank" : "_self",
                        trackingAttributes: {
                            "data-datalayer-id": "kds-element-navigation",
                            "data-datalayer-data": JSON.stringify({
                                clickInternalLinks: (0,utils/* modifyHref */.L9)(levelTwo.groupLink) ? "true" : "false",
                                internalLinkName: (ref = "".concat(tabTitle, " > ").concat(sanitizeText(levelTwo.groupTitle))) === null || ref === void 0 ? void 0 : ref.toLowerCase(),
                                internalLinkURL: levelTwo.groupLink ? (ref1 = "".concat(levelTwo.groupLink.indexOf("http") === -1 ?  true && window.location.origin : "").concat((0,utils/* modifyHref */.L9)(levelTwo.groupLink))) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase() : "n/a"
                            })
                        }
                    },
                    items: ((ref2 = levelTwo.levelThreeNavMulti) === null || ref2 === void 0 ? void 0 : ref2.length) > 0 ? (ref3 = levelTwo.levelThreeNavMulti) === null || ref3 === void 0 ? void 0 : ref3.map((levelThree)=>{
                        var ref;
                        return {
                            text: sanitizeText(levelThree.label),
                            href: (0,utils/* modifyHref */.L9)(levelThree.link),
                            target: levelThree.newTab ? "_blank" : "_self",
                            trackingAttributes: {
                                "data-datalayer-id": "kds-element-navigation",
                                "data-datalayer-data": JSON.stringify({
                                    clickInternalLinks: (0,utils/* modifyHref */.L9)(levelThree.link) ? "true" : "false",
                                    internalLinkName: "".concat(tabTitle, " > ").concat(sanitizeText(levelTwo.groupTitle), " > ").concat(sanitizeText(levelThree.label)).toLowerCase(),
                                    internalLinkURL: levelThree.link ? (ref = "".concat(levelThree.link.indexOf("http") === -1 ?  true && window.location.origin : "").concat((0,utils/* modifyHref */.L9)(levelThree.link))) === null || ref === void 0 ? void 0 : ref.toLowerCase() : "n/a"
                                })
                            }
                        };
                    }) : undefined
                });
            });
            res.push(levelTwoArray);
        }
    });
    return res;
};
/**
 * Gets panel titles from a navigation object
 * @param {Object} obj - Navigation object
 * @return {Array<string>} Array of panel titles
 */ function getPanelTitles(obj) {
    // Check if object has required properties
    if (obj === null || !obj[":itemsOrder"] || !obj[":items"]) return [];
    // Get an array of titles
    const titles = obj[":itemsOrder"].map((key)=>{
        const item = obj[":items"][key];
        return item["cq:panelTitle"] || "";
    });
    return titles;
}

;// CONCATENATED MODULE: ./components/DesignSystem/utils/promoBannerhelper.js
/**
 * Recursively searches an object tree to find an item by containerId name
 * @param {Object} obj - Object tree to search
 * @param {string} name - Name to search for containerId
 * @return {Object|null} Found item or null
 */ function findItemByContainerId(obj, name) {
    // If we have :items, check them first
    if (obj[":items"]) {
        // Look through each key in :items
        for (const key of Object.keys(obj[":items"])){
            var ref;
            // If item containerId matches with name
            if (((ref = obj[":items"][key]) === null || ref === void 0 ? void 0 : ref.containerId) && obj[":items"][key].containerId === name) {
                return obj[":items"][key];
            }
            // If this item has nested :items, recurse into them
            const result = findItemByContainerId(obj[":items"][key], name);
            if (result) return result;
        }
    }
    return null;
}
/**
 * Extracts and formats promo banner content and CTAs from a container(navigation object).
 *
 * @param {Object} container - The container/navigation object containing promo data.
 * @param {string} name - The name or containerId to locate the promo details.
 * @param {Function} setPromoModal - Callback to trigger modal display for a promo.
 * @return {Array<Object>} - An array of formatted promo banner objects.
 */ function extractPromoBanners(container, name, setPromoModal) {
    var ref, ref1, ref2;
    // Find item by containerId
    const promoDetails = findItemByContainerId(container, name);
    if (!promoDetails) {
        console.error("Promo details not found");
        return [];
    }
    // Extract promo banner items
    const promoBanners = promoDetails === null || promoDetails === void 0 ? void 0 : (ref = promoDetails[":items"]) === null || ref === void 0 ? void 0 : (ref1 = ref["carousel_slick"]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1["carouselComponentProperties"]) === null || ref2 === void 0 ? void 0 : ref2[":items"];
    if (!promoBanners) {
        console.error("Promo banners not found in the expected structure");
        return [];
    }
    // Format the response
    return Object.values(promoBanners).map((banner)=>{
        var ref;
        const content = ((ref = banner.description) === null || ref === void 0 ? void 0 : ref.replace(/<[^>]*>/g, "").trim()) || "";
        const CTAs = (banner.actionItems || []).map((item)=>{
            var ref;
            let ctaObj = {
                text: item.text,
                href: item.ctaLink
            };
            if (item.enablePopup && banner.actionsEnabled) {
                // open popup
                ctaObj = {
                    text: item.text,
                    onClick: ()=>{
                        setPromoModal({
                            show: true,
                            modalContent: {
                                banner: banner,
                                item: item
                            }
                        });
                    }
                };
            } else if (item.isNewTab && !item.enablePopup) {
                // open in new tab
                ctaObj = {
                    text: item.text,
                    onClick: ()=>window.open(item.ctaLink, "_blank")
                };
            }
            ctaObj.trackingAttributes = {
                "data-datalayer-id": "kds-element-navigation",
                "data-datalayer-data": JSON.stringify({
                    clickInternalLinks: item.enablePopup ? "true" : "false",
                    eventAction: item.text,
                    eventName: item.text,
                    internalLinkName: item.text,
                    internalLinkPosition:  true ? "".concat(window.eventPageType, ":promo banner") : 0,
                    internalLinkType: item.enablePopup ? "navigation" : ":",
                    internalLinkURL: item.enablePopup ? "n/a" : item.ctaLink && "object" !== "undefined" ? "".concat(window.location.origin).concat((ref = item.ctaLink) === null || ref === void 0 ? void 0 : ref.split("/content/kohler/us").join("").replace(".html", "")) : "n/a",
                    internalLinkZoneName:  true ? "".concat(window.eventPageType, ":promo details") : 0,
                    eventMsg: "n/a",
                    eventStatus: "n/a",
                    eventType: "promo banner"
                })
            };
            return ctaObj;
        });
        return {
            content,
            CTAs
        };
    });
}

// EXTERNAL MODULE: ./utils/helper.js + 1 modules
var helper = __webpack_require__(55760);
;// CONCATENATED MODULE: ./components/DesignSystem/utils/languageMenuHelper.js


const LANGUAGE_PROPERTY_MAPPINGS = [
    {
        nameKey: "languageOne",
        abbreviationKey: "languageOneAbbreviation",
        linkKey: "languageOneLink"
    },
    {
        nameKey: "languageTwo",
        abbreviationKey: "languageTwoAbbreviation",
        linkKey: "languageTwoLink"
    },
    {
        nameKey: "languageThree",
        abbreviationKey: "languageThreeAbbreviation",
        linkKey: "languageThreeLink"
    }
];
const createLanguageObject = (language, abbreviation, link, width)=>{
    if (!language) return null;
    const sanitizedLink = (0,helper/* removeAndCleanLink */.xEh)(link);
    return {
        text: width < 1024 ? language : abbreviation,
        href: sanitizedLink,
        trackingAttributes: {
            "data-datalayer-id": "kds-element-navigation",
            "data-datalayer-data": JSON.stringify({
                clickInternalLinks: "true",
                eventAction: "language selector",
                eventName: "language selector",
                eventType: "language selector",
                internalLinkName: "language select:".concat(abbreviation.toLowerCase()),
                internalLinkPosition: "languageselector",
                internalLinkType: "homepage:navigation",
                internalLinkURL: sanitizedLink,
                internalLinkZoneName: "home:global header"
            })
        }
    };
};
const mapRegion = function() {
    let regionName = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", items = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], currentCountry = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", width = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
    return {
        name: regionName,
        countries: items.map((item)=>{
            if (!item.countryName && !item.country) return null;
            const country = {
                name: item.countryName || item.country
            };
            const languages = LANGUAGE_PROPERTY_MAPPINGS.map((param)=>{
                let { nameKey , abbreviationKey , linkKey  } = param;
                return createLanguageObject(item[nameKey], item[abbreviationKey], item[linkKey], width);
            }).filter(Boolean);
            if (item.countryLink) {
                country.href = (0,helper/* removeAndCleanLink */.xEh)(item.countryLink);
                country.trackingAttributes = {
                    "data-datalayer-id": "kds-element-navigation",
                    "data-datalayer-data": JSON.stringify({
                        clickInternalLinks: "true",
                        eventAction: "country selector",
                        eventName: "country selector",
                        eventType: "country selector",
                        internalLinkName: "country select:".concat(item.country.toLowerCase()),
                        internalLinkPosition: "global header",
                        internalLinkType: "homepage:navigation",
                        internalLinkURL: "n/a",
                        internalLinkZoneName: "home:global header"
                    })
                };
            }
            if (item.countryName === currentCountry) country.isCurrentCountry = true;
            if (languages.length) country.languages = languages;
            return country;
        }).filter(Boolean),
        trackingAttributes: {
            "data-datalayer-id": "kds-element-navigation",
            "data-datalayer-data": JSON.stringify({
                clickInternalLinks: "true",
                eventAction: "country select:".concat(regionName.toLowerCase()),
                eventName: "country select:".concat(regionName.toLowerCase()),
                eventType: "navigation",
                internalLinkName: regionName.toLowerCase(),
                internalLinkPosition: "countryselector",
                internalLinkType: "global header : navigation",
                internalLinkURL: "n/a",
                internalLinkZoneName: "global header"
            })
        }
    };
};
const getLanguageMenu = (container, width)=>{
    let secondLanguageCTA = {};
    const { country ="" , language ="" , enableLanguageSwitcher , languageLabel ="" , languageUrl =""  } = container || {};
    const currentCountry = "United States" || 0;
    const currentLanguage = language || "EN";
    const countrySelector = findItemByName(container, "countryselector");
    if (!countrySelector) {
        return {
            regions: [],
            languageMenuTitle: undefined,
            languageMenuDescription: undefined,
            currentCountry,
            currentLanguage,
            secondLanguageCTA
        };
    }
    const regionMappings = [
        {
            key: "americasItems",
            name: "Americas"
        },
        {
            key: "africaItems",
            name: "Africa"
        },
        {
            key: "asiaItems",
            name: "Asia"
        },
        {
            key: "oceaniaItems",
            name: "Australasia"
        },
        {
            key: "middleEastItems",
            name: "Middle East"
        },
        {
            key: "europeItems",
            name: "Europe"
        }
    ];
    const regions = regionMappings.filter((region)=>countrySelector[region.key]).map((region)=>mapRegion(region.name, countrySelector[region.key], currentCountry, width));
    if (enableLanguageSwitcher) {
        secondLanguageCTA = {
            text: languageLabel,
            href: (0,helper/* removeAndCleanLink */.xEh)(languageUrl)
        };
    }
    return {
        regions,
        languageMenuTitle: countrySelector.title,
        languageMenuDescription: countrySelector.description,
        currentCountry,
        currentLanguage,
        secondLanguageCTA
    };
};

;// CONCATENATED MODULE: ./components/DesignSystem/utils/brandSwitcherHelper.js
/**
 * Gets panel titles from a navigation object
 * @param {Object} obj - Navigation object
 * @return {Array<string>} Array of panel titles
 */ function getBrandTitles(obj) {
    if (!obj) return null;
    // Check if object has required properties
    if (!obj[":itemsOrder"] || !obj[":items"]) return obj["items"];
    // Get an array of titles
    const titles = obj[":itemsOrder"].map((key)=>{
        const item = obj[":items"][key];
        return item["brand_switcher"] || "";
    });
    return titles;
}
/**
 * Generates an array of brand objects from the given input object.
 *
 * @param {Object} obj - The input object containing brand information.
 * @return {Array} An array of brand objects with text, href, target, and isActive properties.
 */ function getBrandsArray(obj) {
    const brandSwitcherArray = getBrandTitles(obj) || [];
    const brandArray = brandSwitcherArray.map((item)=>{
        var ref, ref1;
        if (!item) return {
            text: "",
            href: "",
            target: "_self",
            isActive: false
        };
        return {
            text: (item === null || item === void 0 ? void 0 : item.brandName) || "",
            href: (item === null || item === void 0 ? void 0 : item.link) || "",
            target: (item === null || item === void 0 ? void 0 : item.linkToNewTab) === "true" ? "_blank" : "_self",
            isActive: (item === null || item === void 0 ? void 0 : item.highlight) || false,
            trackingAttributes: {
                "data-datalayer-id": "kds-element-navigation",
                "data-datalayer-data": JSON.stringify({
                    clickInternalLinks:  true && (item === null || item === void 0 ? void 0 : (ref = item.link) === null || ref === void 0 ? void 0 : ref.includes(window.location.hostname.split(".").slice(1).join("."))),
                    eventAction: "brand sync",
                    eventName: "brand sync",
                    eventType: "click",
                    internalLinkName: "brand sync:".concat(item === null || item === void 0 ? void 0 : (ref1 = item.brandName) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase()),
                    internalLinkPosition: "global header",
                    internalLinkType: "global header:navigation",
                    internalLinkURL: item === null || item === void 0 ? void 0 : item.link,
                    internalLinkZoneName:  true ? "".concat(window === null || window === void 0 ? void 0 : window.eventPageType, ":global header") : 0
                })
            }
        };
    }).filter((item)=>item.text || item.href) // Filter out empty items
    ;
    return brandArray;
}

;// CONCATENATED MODULE: ./components/DesignSystem/utils/utilityHeaderHelper.js

/**
 * Extracts links from an HTML string and modifies the href.
 *
 * @param {string} htmlString - The HTML string to extract links from.
 * @return {Array} An array of link objects with modified href and text.
 */ function extractLinks(htmlString) {
    const linkRegex = /<a\s+(?:[^>]*?\s+)?href="([^"]*)"(?:[^>]*)>(.*?)<\/a>/g;
    const links = [];
    let match;
    while((match = linkRegex.exec(htmlString)) !== null){
        var ref, ref1, ref2, ref3, ref4;
        links.push({
            component: "a",
            href: (0,utils/* modifyHref */.L9)(match[1].replace("/link", "/modified/link")),
            text: match[2] || "",
            trackingAttributes: {
                "data-datalayer-id": "kds-element-navigation",
                "data-datalayer-data": JSON.stringify({
                    clickInternalLinks: "true",
                    eventAction: "my account:".concat((ref = match[2]) === null || ref === void 0 ? void 0 : ref.toLowerCase()),
                    eventName: "my account:".concat((ref1 = match[2]) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase()),
                    eventMsg: "n/a",
                    eventStatus: "n/a",
                    eventType: "global header",
                    internalLinkName: (ref2 = match[2]) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase(),
                    internalLinkPosition: "global header:".concat((ref3 = match[2]) === null || ref3 === void 0 ? void 0 : ref3.toLowerCase()),
                    internalLinkType: "global header:navigation",
                    internalLinkURL: match[1] && "object" !== "undefined" ? "".concat(window.location.origin).concat((ref4 = match[1]) === null || ref4 === void 0 ? void 0 : ref4.split("/content/kohler/us").join("").replace(".html", "")) : "n/a",
                    internalLinkZoneName: "global header"
                })
            }
        });
    }
    return links;
}
/**
 * Returns the cart badge CTA object if the cartLandingPagePath exists and canadaCheck is false, otherwise undefined.
 *
 * @param {string} cartLandingPagePath - The cart landing page URL.
 * @param {number} cartCount - The number of items in the cart.
 * @param {boolean} canadaCheck - If true, the cart icon should not be shown.
 * @return {CartBadgeCTA|undefined} The cart badge CTA object or undefined.
 */ function getCartBadgeCTA() {
    let cartLandingPagePath = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", cartCount = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, canadaCheck = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if (canadaCheck) return null;
    return {
        href: cartLandingPagePath,
        digit: cartCount > 0 && cartCount < 999 ? cartCount : null,
        trackingAttributes: {
            "data-datalayer-id": "kds-element-navigation",
            "data-datalayer-data": JSON.stringify({
                clickInternalLinks: "true",
                eventAction: "cart icon",
                eventMsg: "n/a",
                eventName: "cart icon",
                eventStatus: "n/a",
                eventType: "global header",
                internalLinkName: "cart icon",
                internalLinkPosition: "global header",
                internalLinkType: "global header:navigation",
                internalLinkURL: cartLandingPagePath,
                internalLinkZoneName: "global header"
            })
        }
    };
}

// EXTERNAL MODULE: ./components/Shared/HeaderNavTabs/analytics/constant.js
var constant = __webpack_require__(59187);
;// CONCATENATED MODULE: ./components/DesignSystem/mappers/navigationV2Mapper.js









const mapMainMenuProps = function() {
    let container = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, i18n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, lineItems = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, firstName = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", isAuth = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false, logIndata = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {}, logOutdata = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : {}, onclicksignIN = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : ()=>{}, onClickCreateAccount = arguments.length > 8 && arguments[8] !== void 0 ? arguments[8] : ()=>{}, onClickSignOut = arguments.length > 9 && arguments[9] !== void 0 ? arguments[9] : ()=>{}, favClickHandler = arguments.length > 10 && arguments[10] !== void 0 ? arguments[10] : ()=>{}, cartCount = arguments.length > 11 && arguments[11] !== void 0 ? arguments[11] : 0, themeType = arguments.length > 12 && arguments[12] !== void 0 ? arguments[12] : "light", handleSearchClick = arguments.length > 13 && arguments[13] !== void 0 ? arguments[13] : ()=>{}, showBackground = arguments.length > 14 && arguments[14] !== void 0 ? arguments[14] : false, favoritesPage = arguments.length > 15 && arguments[15] !== void 0 ? arguments[15] : [], favoritesPagePath = arguments.length > 16 && arguments[16] !== void 0 ? arguments[16] : "", cartLandingPagePath = arguments.length > 17 && arguments[17] !== void 0 ? arguments[17] : "", path = arguments.length > 18 && arguments[18] !== void 0 ? arguments[18] : "", setPromoModal = arguments.length > 19 && arguments[19] !== void 0 ? arguments[19] : ()=>{}, canadaCheck = arguments.length > 20 && arguments[20] !== void 0 ? arguments[20] : false, transitionDelay = arguments.length > 21 && arguments[21] !== void 0 ? arguments[21] : "", searchHeader = arguments.length > 22 && arguments[22] !== void 0 ? arguments[22] : "Search", language = arguments.length > 23 && arguments[23] !== void 0 ? arguments[23] : "en", isSaveProductToList = arguments.length > 24 && arguments[24] !== void 0 ? arguments[24] : false, width = arguments.length > 25 && arguments[25] !== void 0 ? arguments[25] : 0;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27;
    const titlesArray = getPanelTitles(findItemByName(container, "tabs"));
    const menuItemsArray = getMenuItems(findItemByName(container, "tabs"));
    const logoData = findItemByName(container, "image");
    const { languageMenuTitle ="" , languageMenuDescription ="" , regions =[] , currentCountry ="" , currentLanguage ="" , secondLanguageCTA ={}  } = getLanguageMenu(findItemByName(container, "utilitynavheader"), width) || {};
    const formattedResponse = extractPromoBanners(container, "promo-details", setPromoModal);
    const brandSwitcherArray = getBrandsArray(findItemByName(container, "brand_switcher"));
    const loggedInCtaArray = extractLinks(logIndata);
    const loggedOutCtaArray = extractLinks(logOutdata);
    const cartBadgeCTA = getCartBadgeCTA(cartLandingPagePath, cartCount, canadaCheck);
    const dataLayerTitle = "find a store";
    var ref28;
    const findStoreLabel = (ref28 = (ref = findItemByName(container, "store")) === null || ref === void 0 ? void 0 : ref.findStore) !== null && ref28 !== void 0 ? ref28 : "Find a Store";
    return {
        promoBanner: {
            mod: formattedResponse.length > 0 ? "slate" : "",
            type: formattedResponse.length > 0 ? "promo" : "",
            content: formattedResponse.length > 0 ? formattedResponse : []
        },
        mainNavigation: (menuItemsArray === null || menuItemsArray === void 0 ? void 0 : menuItemsArray.length) > 0 ? {
            mod: "white",
            brandCTA: (menuItemsArray === null || menuItemsArray === void 0 ? void 0 : menuItemsArray.length) > 0 ? {
                brand: "Kohler Bold",
                href: "/",
                trackingAttributes: {
                    "data-datalayer-id": "kds-element-navigation",
                    "data-datalayer-data": JSON.stringify({
                        clickInternalLinks: (logoData === null || logoData === void 0 ? void 0 : logoData.link) ? "true" : "false",
                        eventAction: "header kohler logo",
                        eventName: "header kohler logo",
                        internalLinkName: "header kohler logo",
                        internalLinkPosition: "global header",
                        internalLinkType: "global header:navigation",
                        internalLinkURL: (logoData === null || logoData === void 0 ? void 0 : logoData.link) && "object" !== "undefined" ? "".concat(window.location.origin).concat(logoData === null || logoData === void 0 ? void 0 : (ref1 = logoData.link) === null || ref1 === void 0 ? void 0 : ref1.split("/content/kohler/us").join("").replace(".html", "")) : "n/a",
                        internalLinkZoneName: "global header"
                    })
                }
            } : {},
            showBackground: showBackground,
            menuItems: menuItemsArray.map((item, index)=>{
                var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11;
                const tabTitle = titlesArray[index];
                return {
                    text: tabTitle,
                    mod: themeType === "light" ? "white" : "charcoal",
                    CTALists: (item === null || item === void 0 ? void 0 : item.navigationMenuType) !== "business" ? transformArray(item, titlesArray[index]) : transformBusinessArray(item, titlesArray[index]),
                    ...((ref = item.firstImagesblock) === null || ref === void 0 ? void 0 : ref.firstImageFileReference) && {
                        images: [
                            {
                                image: {
                                    src: item.firstImagesblock.firstImageFileReference || "",
                                    alt: item.firstImagesblock.altText || "",
                                    "data-mode": "smartcrop",
                                    trackingAttributes: {
                                        "data-datalayer-id": "kds-element-navigation",
                                        "data-datalayer-data": JSON.stringify({
                                            clickInternalLinks: (0,utils/* modifyHref */.L9)(item.firstImagesblock.ctaLink) ? "true" : "false",
                                            internalLinkName: "".concat(tabTitle, " > ").concat(sanitizeText(item === null || item === void 0 ? void 0 : (ref1 = item.firstImagesblock) === null || ref1 === void 0 ? void 0 : ref1.firstImageTitle), " > img_").concat(item === null || item === void 0 ? void 0 : (ref2 = item.firstImagesblock) === null || ref2 === void 0 ? void 0 : ref2.ctaLabel).toLowerCase(),
                                            internalLinkURL: (0,utils/* modifyHref */.L9)(item.firstImagesblock.ctaLink) ? "".concat((0,utils/* modifyHref */.L9)(item.firstImagesblock.ctaLink).indexOf("http") === -1 ?  true && window.location.origin : "").concat((0,utils/* modifyHref */.L9)(item.firstImagesblock.ctaLink)) : "n/a"
                                        })
                                    }
                                },
                                imageOrientation: ((ref3 = item.appliedCssClassNames) === null || ref3 === void 0 ? void 0 : ref3.includes("landscape")) ? "landscape" : "portrait",
                                caption: {
                                    text: item.firstImagesblock.firstImageTitle ? sanitizeText(item.firstImagesblock.firstImageTitle) : ""
                                },
                                multiCTA: item.multiCTA.map((elem, index)=>{
                                    var ref;
                                    return {
                                        text: sanitizeText(elem.ctaLabel),
                                        href: (0,utils/* modifyHref */.L9)(elem.ctaLink),
                                        trackingAttributes: {
                                            "data-datalayer-id": "kds-element-navigation",
                                            "data-datalayer-data": JSON.stringify({
                                                clickInternalLinks: (0,utils/* modifyHref */.L9)(item.firstImagesblock.ctaLink) ? "true" : "false",
                                                internalLinkName: (ref = "".concat(tabTitle, " > ").concat(sanitizeText(elem.ctaLabel))) === null || ref === void 0 ? void 0 : ref.toLowerCase(),
                                                internalLinkURL: (0,utils/* modifyHref */.L9)(elem.ctaLink) ? "".concat((0,utils/* modifyHref */.L9)(elem.ctaLink).indexOf("http") === -1 ?  true && window.location.origin : "").concat((0,utils/* modifyHref */.L9)(elem.ctaLink)) : "n/a"
                                            })
                                        }
                                    };
                                }),
                                CTA: item.firstImagesblock.ctaLabel ? {
                                    text: item.firstImagesblock.ctaLabel,
                                    href: (0,utils/* modifyHref */.L9)(item.firstImagesblock.ctaLink),
                                    trackingAttributes: {
                                        "data-datalayer-id": "kds-element-navigation",
                                        "data-datalayer-data": JSON.stringify({
                                            clickInternalLinks: (0,utils/* modifyHref */.L9)(item.firstImagesblock.ctaLink) ? "true" : "false",
                                            internalLinkName: "".concat(tabTitle, " > ").concat(sanitizeText(item === null || item === void 0 ? void 0 : (ref4 = item.firstImagesblock) === null || ref4 === void 0 ? void 0 : ref4.firstImageTitle), " > img_").concat(item === null || item === void 0 ? void 0 : (ref5 = item.firstImagesblock) === null || ref5 === void 0 ? void 0 : ref5.ctaLabel).toLowerCase(),
                                            internalLinkURL: (0,utils/* modifyHref */.L9)(item.firstImagesblock.ctaLink) ? "".concat((0,utils/* modifyHref */.L9)(item.firstImagesblock.ctaLink).indexOf("http") === -1 ?  true && window.location.origin : "").concat((0,utils/* modifyHref */.L9)(item.firstImagesblock.ctaLink)) : "n/a"
                                        })
                                    }
                                } : undefined
                            },
                            ...((ref6 = item.secondImagesblock) === null || ref6 === void 0 ? void 0 : ref6.secondImageFileReference) ? [
                                {
                                    image: {
                                        src: item.secondImagesblock.secondImageFileReference || "",
                                        alt: item.secondImagesblock.altText || "",
                                        "data-mode": "smartcrop",
                                        trackingAttributes: {
                                            "data-datalayer-id": "kds-element-navigation",
                                            "data-datalayer-data": JSON.stringify({
                                                clickInternalLinks: (0,utils/* modifyHref */.L9)(item.secondImagesblock.ctaLink) ? "true" : "false",
                                                internalLinkName: "".concat(tabTitle, " > ").concat(sanitizeText(item === null || item === void 0 ? void 0 : (ref7 = item.secondImagesblock) === null || ref7 === void 0 ? void 0 : ref7.secondImageTitle), " > img_").concat(item === null || item === void 0 ? void 0 : (ref8 = item.secondImagesblock) === null || ref8 === void 0 ? void 0 : ref8.ctaLabel).toLowerCase(),
                                                internalLinkURL: (0,utils/* modifyHref */.L9)(item.secondImagesblock.ctaLink) ? "".concat((0,utils/* modifyHref */.L9)(item.secondImagesblock.ctaLink).indexOf("http") === -1 ?  true && window.location.origin : "").concat((0,utils/* modifyHref */.L9)(item.secondImagesblock.ctaLink)) : "n/a"
                                            })
                                        }
                                    },
                                    imageOrientation: ((ref9 = item.appliedCssClassNames) === null || ref9 === void 0 ? void 0 : ref9.includes("landscape")) ? "landscape" : "portrait",
                                    caption: {
                                        text: item.secondImagesblock.secondImageTitle ? sanitizeText(item.secondImagesblock.secondImageTitle) : ""
                                    },
                                    CTA: item.secondImagesblock.ctaLabel ? {
                                        text: item.secondImagesblock.ctaLabel,
                                        href: (0,utils/* modifyHref */.L9)(item.secondImagesblock.ctaLink),
                                        trackingAttributes: {
                                            "data-datalayer-id": "kds-element-navigation",
                                            "data-datalayer-data": JSON.stringify({
                                                clickInternalLinks: (0,utils/* modifyHref */.L9)(item.secondImagesblock.ctaLink) ? "true" : "false",
                                                internalLinkName: "".concat(tabTitle, " > ").concat(sanitizeText(item === null || item === void 0 ? void 0 : (ref10 = item.secondImagesblock) === null || ref10 === void 0 ? void 0 : ref10.secondImageTitle), " > img_").concat(item === null || item === void 0 ? void 0 : (ref11 = item.secondImagesblock) === null || ref11 === void 0 ? void 0 : ref11.ctaLabel).toLowerCase(),
                                                internalLinkURL: (0,utils/* modifyHref */.L9)(item.secondImagesblock.ctaLink) ? "".concat((0,utils/* modifyHref */.L9)(item.secondImagesblock.ctaLink).indexOf("http") === -1 ?  true && window.location.origin : "").concat((0,utils/* modifyHref */.L9)(item.secondImagesblock.ctaLink)) : "n/a"
                                            })
                                        }
                                    } : undefined
                                }
                            ] : []
                        ]
                    }
                };
            }),
            showMenuDelay: parseInt(transitionDelay) || 0,
            menuCTA: {
                onClick: ()=>(0,helper/* removeMavenoidChat */.N9B)()
            },
            closeCTA: {
                onClick: ()=>(0,helper/* addMavenoidChat */.dVG)()
            },
            variant: "v2.1",
            searchText: (menuItemsArray === null || menuItemsArray === void 0 ? void 0 : menuItemsArray.length) > 0 ? searchHeader : "",
            searchCTA: (menuItemsArray === null || menuItemsArray === void 0 ? void 0 : menuItemsArray.length) > 0 ? {
                onClick: ()=>{
                    handleSearchClick();
                },
                trackingAttributes: {
                    "data-datalayer-id": "kds-element-navigation",
                    "data-datalayer-data": JSON.stringify({
                        eventAction: "internal search",
                        eventName: "internal search",
                        eventType: "navigation",
                        eventMsg: "n/a",
                        eventStatus: "n/a",
                        internalLinkName: "internal search magnifying glass button",
                        internalLinkPosition: "global header",
                        internalLinkType: "global navigation",
                        internalLinkZoneName: "global header",
                        internalLinkURL: "n/a",
                        clickInternalLinks: "true"
                    })
                }
            } : {}
        } : undefined,
        utilityBar: {
            mod: "charcoal",
            ...path === "/checkout" ? {} : {
                languagePicker: {
                    languagePickerCTA: {
                        onClick: ()=>{},
                        trackingAttributes: {
                            "data-datalayer-id": "kds-element-navigation",
                            "data-datalayer-data": JSON.stringify({
                                clickInternalLinks: "true",
                                eventAction: "country select",
                                eventName: "country select",
                                eventType: "click",
                                internalLinkName: "".concat(currentCountry.toLowerCase(), " - ").concat(currentLanguage.toLowerCase()),
                                internalLinkPosition: "global header",
                                internalLinkType: "global header : navigation",
                                internalLinkURL: "n/a",
                                internalLinkZoneName: "home:global header"
                            })
                        }
                    },
                    location: currentCountry,
                    currentLanguage: currentLanguage,
                    secondLanguageCTA: Object.keys(secondLanguageCTA).length === 0 ? undefined : secondLanguageCTA
                },
                isLoggedIn: isAuth,
                userName: "".concat(firstName),
                userCTA: {
                    trackingAttributes: {
                        "data-datalayer-id": "kds-element-navigation",
                        "data-datalayer-data": !isAuth ? JSON.stringify({
                            clickInternalLinks: "true",
                            eventAction: "sign in start",
                            eventMsg: "n/a",
                            eventName: "sign in start",
                            eventStatus: "n/a",
                            eventType: "global header",
                            internalLinkName: "sign in start",
                            internalLinkPosition: "global header:sign in start",
                            internalLinkType: "global header:navigation",
                            internalLinkURL: "n/a",
                            internalLinkZoneName: "global header"
                        }) : JSON.stringify({
                            clickInternalLinks: "true",
                            eventAction: "global header:your kohler account",
                            eventMsg: "n/a",
                            eventName: "global header:your kohler account",
                            eventStatus: "n/a",
                            eventType: "navigation",
                            internalLinkName: "your kohler account",
                            internalLinkPosition: "global header:my account",
                            internalLinkType: "global header: welcome back to your kohler",
                            internalLinkURL: "n/a",
                            internalLinkZoneName: "global header"
                        })
                    }
                },
                userCTAMobile: {
                    signInCTA: {
                        text: i18n.signIn,
                        onClick: ()=>{
                            onclicksignIN();
                        },
                        component: "button"
                    },
                    signUpCTA: {
                        text: i18n.createAccount,
                        onClick: ()=>{
                            onClickCreateAccount();
                        },
                        component: "button"
                    },
                    accountCTA: {
                        text: "".concat(language === "fr" ? "Bonjour" : "Hi", ", ").concat(firstName),
                        trackingAttributes: {
                            "data-datalayer-id": "kds-element-navigation",
                            "data-datalayer-data": JSON.stringify({
                                clickInternalLinks: "true",
                                eventAction: "global header:your kohler account",
                                eventMsg: "n/a",
                                eventName: "global header:your kohler account",
                                eventStatus: "n/a",
                                eventType: "navigation",
                                internalLinkName: "your kohler account",
                                internalLinkPosition: "global header:my account",
                                internalLinkType: "global header: welcome back to your kohler",
                                internalLinkURL: "n/a",
                                internalLinkZoneName: "global header"
                            })
                        }
                    }
                },
                ...isAuth ? {} : {
                    utilityLinksMobile: [
                        {
                            text: ((ref2 = loggedOutCtaArray[0]) === null || ref2 === void 0 ? void 0 : ref2.text) || "",
                            href: ((ref3 = loggedOutCtaArray[0]) === null || ref3 === void 0 ? void 0 : ref3.href) || "",
                            component: "a",
                            trackingAttributes: {
                                "data-datalayer-id": "kds-element-navigation",
                                "data-datalayer-data": JSON.stringify({
                                    clickInternalLinks: "true",
                                    eventAction: "my account:".concat((ref4 = loggedOutCtaArray[0]) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.text) === null || ref5 === void 0 ? void 0 : ref5.toLowerCase()),
                                    eventName: "my account:".concat((ref6 = loggedOutCtaArray[0]) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.text) === null || ref7 === void 0 ? void 0 : ref7.toLowerCase()),
                                    eventMsg: "n/a",
                                    eventStatus: "n/a",
                                    eventType: "global header",
                                    internalLinkName: (ref8 = loggedOutCtaArray[0]) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.text) === null || ref9 === void 0 ? void 0 : ref9.toLowerCase(),
                                    internalLinkPosition: "global header:".concat((ref10 = loggedOutCtaArray[0]) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.text) === null || ref11 === void 0 ? void 0 : ref11.toLowerCase()),
                                    internalLinkType: "global header:navigation",
                                    internalLinkURL: ((ref12 = loggedOutCtaArray[0]) === null || ref12 === void 0 ? void 0 : ref12.href) && "object" !== "undefined" ? "".concat(window.location.origin).concat((ref13 = loggedOutCtaArray[0]) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.href) === null || ref14 === void 0 ? void 0 : ref14.split("/content/kohler/us").join("").replace(".html", "")) : "n/a",
                                    internalLinkZoneName: "global header"
                                })
                            }
                        }
                    ]
                },
                locationPickerCTA: {
                    text: findStoreLabel,
                    trackingAttributes: {
                        "data-datalayer-id": "kds-element-navigation",
                        "data-datalayer-data": JSON.stringify({
                            eventAction: dataLayerTitle,
                            eventMsg: "n/a",
                            eventName: dataLayerTitle,
                            eventStatus: "n/a",
                            eventType: "".concat(constant/* GLOBAL_HEADER_TEXT */.A),
                            internalLinkName: dataLayerTitle,
                            internalLinkPosition: "".concat(constant/* GLOBAL_HEADER_TEXT */.A, ":").concat(dataLayerTitle),
                            internalLinkType: "".concat(constant/* GLOBAL_HEADER_TEXT */.A, ":navigation"),
                            internalLinkZoneName: "".concat(constant/* GLOBAL_HEADER_TEXT */.A),
                            internalLinkURL: "n/a",
                            clickInternalLinks: "true"
                        })
                    }
                },
                favoritesCTA: {
                    text: language === "fr" ? isSaveProductToList ? "Mes Listes" : "Favoris" : isSaveProductToList ? "My List" : "Favorites",
                    onClick: (e)=>favClickHandler(e, favoritesPagePath),
                    isFilled: isAuth && (lineItems && lineItems.length > 0 || favoritesPage && favoritesPage.length > 0) ? true : false,
                    component: "a",
                    href: isAuth ? favoritesPagePath : ""
                }
            },
            cartBadgeCTA: cartBadgeCTA,
            brands: path === "/checkout" ? [
                {
                    text: "KOHLER",
                    href: "https://www.kohler.com",
                    target: "_blank",
                    isActive: "true"
                }
            ] : brandSwitcherArray
        },
        languageMenu: {
            mod: "charcoal",
            heading: {
                text: languageMenuTitle
            },
            copy: {
                text: sanitizeText(languageMenuDescription)
            },
            currentCounty: currentCountry,
            regions: regions
        },
        ...path === "/checkout" ? {} : {
            loginMenu: {
                mod: "charcoal",
                headingSignIn: {
                    text: "".concat(i18n.welcome, " ").concat(firstName, "!")
                },
                headingSignOut: {
                    text: i18n.title
                },
                isLoggedIn: isAuth,
                userName: "".concat(firstName),
                loggedOutCTAs: [
                    {
                        text: i18n.signIn,
                        onClick: ()=>{
                            onclicksignIN();
                        },
                        component: "button"
                    },
                    {
                        text: i18n.createAccount,
                        onClick: ()=>{
                            onClickCreateAccount();
                        },
                        component: "button"
                    },
                    {
                        text: ((ref15 = loggedOutCtaArray[0]) === null || ref15 === void 0 ? void 0 : ref15.text) || "",
                        href: ((ref16 = loggedOutCtaArray[0]) === null || ref16 === void 0 ? void 0 : ref16.href) || "",
                        component: "a",
                        trackingAttributes: {
                            "data-datalayer-id": "kds-element-navigation",
                            "data-datalayer-data": JSON.stringify({
                                clickInternalLinks: "true",
                                eventAction: "my account:".concat((ref17 = loggedOutCtaArray[0]) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.text) === null || ref18 === void 0 ? void 0 : ref18.toLowerCase()),
                                eventName: "my account:".concat((ref19 = loggedOutCtaArray[0]) === null || ref19 === void 0 ? void 0 : (ref20 = ref19.text) === null || ref20 === void 0 ? void 0 : ref20.toLowerCase()),
                                eventMsg: "n/a",
                                eventStatus: "n/a",
                                eventType: "global header",
                                internalLinkName: (ref21 = loggedOutCtaArray[0]) === null || ref21 === void 0 ? void 0 : (ref22 = ref21.text) === null || ref22 === void 0 ? void 0 : ref22.toLowerCase(),
                                internalLinkPosition: "global header:".concat((ref23 = loggedOutCtaArray[0]) === null || ref23 === void 0 ? void 0 : (ref24 = ref23.text) === null || ref24 === void 0 ? void 0 : ref24.toLowerCase()),
                                internalLinkType: "global header:navigation",
                                internalLinkURL: ((ref25 = loggedOutCtaArray[0]) === null || ref25 === void 0 ? void 0 : ref25.href) && "object" !== "undefined" ? "".concat(window.location.origin).concat((ref26 = loggedOutCtaArray[0]) === null || ref26 === void 0 ? void 0 : (ref27 = ref26.href) === null || ref27 === void 0 ? void 0 : ref27.split("/content/kohler/us").join("").replace(".html", "")) : "n/a",
                                internalLinkZoneName: "global header"
                            })
                        }
                    }
                ],
                loggedInCTAs: loggedInCtaArray,
                signOutCTA: {
                    text: i18n.logout,
                    onClick: ()=>{
                        onClickSignOut();
                    },
                    component: "button"
                }
            }
        }
    };
};

// EXTERNAL MODULE: ./node_modules/next/script.js
var next_script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(next_script);
// EXTERNAL MODULE: ./store/features/genericSlice.js
var genericSlice = __webpack_require__(88751);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/factory/factory.utils.mjs
var factory_utils = __webpack_require__(99347);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Popover/subcomponents/Popover/PopoverTarget/use-merged-ref.mjs
var use_merged_ref = __webpack_require__(68064);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Other/Box/Box.mjs + 1 modules
var Box = __webpack_require__(3253);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/MainMenu.hook.mjs

const useStickyNavigation = function(mainMenuHeight) {
    let isAlwaysSticky = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    const [showStickyNav, setShowStickyNav] = (0,react.useState)(false);
    const [isSticky, setIsSticky] = (0,react.useState)(false);
    const [lastScrollY, setLastScrollY] = (0,react.useState)(0);
    const [scrollDelta, setScrollDelta] = (0,react.useState)(0);
    const [hasHiddenOnce, setHasHiddenOnce] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        const handleScroll = ()=>{
            const scrollY = window.scrollY;
            const isScrollingUp = scrollY < lastScrollY;
            const hasScrolledPastThreshold = scrollY > window.innerHeight * 0.25;
            const hasScrolledPastMainMenu = scrollY > mainMenuHeight + (isAlwaysSticky ? 0 : 120);
            if (!isAlwaysSticky) {
                if (!isScrollingUp) {
                    setScrollDelta((prev)=>prev + (scrollY - lastScrollY));
                } else {
                    setScrollDelta(0);
                }
            }
            if (hasScrolledPastMainMenu) {
                setIsSticky(true);
            } else {
                setIsSticky(false);
            }
            if (isAlwaysSticky) {
                setShowStickyNav(true);
            }
            if (scrollDelta > 100 && !isAlwaysSticky) {
                setShowStickyNav(false);
                setHasHiddenOnce(true);
            }
            if (isScrollingUp && hasScrolledPastThreshold && hasHiddenOnce && !isAlwaysSticky) {
                setShowStickyNav(true);
            }
            setLastScrollY(scrollY);
        };
        window.addEventListener("scroll", handleScroll);
        return ()=>window.removeEventListener("scroll", handleScroll);
    }, [
        lastScrollY,
        mainMenuHeight,
        scrollDelta,
        hasHiddenOnce
    ]);
    return {
        showStickyNav,
        isSticky
    };
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/MainMenu.module.css.mjs
var classes = {
    "mainMenu": "Ru7bK",
    "mainNavigationBarWrapper": "vuxGF",
    "showBackgroundRelative": "y2K8q",
    "fixedNav": "xizDn",
    "showSticky": "qoAOZ"
};


// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Layout/Grid/Grid.mjs + 1 modules
var Grid = __webpack_require__(40697);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Layout/Grid/GridColumn/GridColumn.mjs + 1 modules
var GridColumn = __webpack_require__(57237);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Layout/Flex/Flex.mjs + 2 modules
var Flex = __webpack_require__(54112);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Foundations/BrandLogo/BrandLogo.module.css.mjs
var BrandLogo_module_css_classes = {
    "root": "iUo1k"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Foundations/BrandLogo/icons/AnnSacks.mjs

const AnnSacksLogo = /* @__PURE__ */ /*#__PURE__*/ react.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "100",
    height: "27",
    viewBox: "0 0 100 27",
    fill: "none"
}, /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.34446 26.0693V14.5146H3.44459V26.0693H1.23364V14.4812H0V12.227H1.23364V3.91159C1.23364 1.95797 2.86782 0.355 4.90254 0.355C6.93725 0.355 8.57143 1.94127 8.57143 3.91159V26.0693H6.34446ZM4.8865 2.60917C4.08543 2.60917 3.44457 3.24368 3.44457 4.01176V12.1769H6.34444V4.01176C6.34444 3.24368 5.68756 2.60917 4.8865 2.60917Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.7344 25.9852H62.5827V16.2632H59.7638V25.9852H57.6121V16.2295H56.5112V14.1102H57.6121V8.2568C57.6121 6.42341 59.1967 4.92642 61.1649 4.92642C63.1332 4.92642 64.7178 6.42341 64.7178 8.2568L64.7344 25.9852ZM61.265 7.0794C60.481 7.0794 59.8638 7.66811 59.8638 8.39137V14.0934H62.6828V8.39137C62.6828 7.66811 62.0489 7.0794 61.265 7.0794Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M18.5474 5.01053V17.4238L15.2447 5.01053H13.1431V25.9684H15.3115V13.2692L18.6308 25.9684H20.7158V5.01053H18.5474Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M30.4237 5.01053V17.4238L27.1211 5.01053H25.0194V25.9684H27.1878V13.2692L30.4904 25.9684H32.5754V5.01053H30.4237Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M70.856 15.5063V22.6043C70.856 23.3276 71.4898 23.9163 72.2571 23.9163C73.0411 23.9163 73.6582 23.3276 73.6582 22.6043V18.8198H75.81V22.7389C75.81 24.5723 74.2087 26.0693 72.2571 26.0693C70.2889 26.0693 68.7043 24.5723 68.7043 22.7389V8.27362C68.7043 6.44023 70.2889 4.94325 72.2571 4.94325C74.2254 4.94325 75.81 6.44023 75.81 8.27362V12.2095H73.6749V8.40819C73.6749 7.68492 73.0411 7.09622 72.2738 7.09622C71.4898 7.09622 70.8727 7.68492 70.8727 8.40819L70.856 15.5063Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M89.5877 9.43421C89.5877 11.0321 90.2382 12.4114 91.5726 14.1775C93.9745 17.3397 94.5583 18.1638 94.5583 20.3505V22.6043C94.5583 23.3276 93.9245 23.9163 93.1572 23.9163C92.3733 23.9163 91.7561 23.3276 91.7561 22.6043V19.8122H89.6044V22.7221C89.6044 24.5555 91.2057 26.0525 93.1572 26.0525C95.1255 26.0525 96.7101 24.5555 96.7101 22.7221V20.3505C96.7101 18.147 96.4265 17.4238 95.2923 15.5735C94.8568 14.8546 94.3273 14.1822 93.8114 13.5271C92.7463 12.1746 91.7394 10.896 91.7394 9.43421V8.39136C91.7394 7.6681 92.3733 7.0794 93.1405 7.0794C93.9245 7.0794 94.5417 7.6681 94.5417 8.39136V9.97245H96.6934V8.2568C96.6934 6.42341 95.1088 4.92642 93.1405 4.92642C91.1723 4.92642 89.5877 6.42341 89.5877 8.2568V9.43421Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.4112 25.9515V24.6227H98.9283C99.0784 24.6227 99.1952 24.6564 99.2619 24.7237C99.3286 24.7909 99.362 24.875 99.362 24.9928C99.362 25.0432 99.3453 25.1105 99.3286 25.1442C99.312 25.1946 99.2953 25.2283 99.2619 25.2619C99.2286 25.2955 99.1952 25.3124 99.1618 25.3292C99.1285 25.346 99.0784 25.3628 99.0284 25.3628L99.4287 25.9515H99.2286L98.8616 25.3628H98.578V25.9515H98.4112ZM98.9452 25.2283C98.9848 25.2283 99.0139 25.2177 99.0492 25.205C99.0584 25.2017 99.0682 25.1981 99.0786 25.1946C99.112 25.1778 99.1453 25.161 99.162 25.1274C99.1787 25.0937 99.1954 25.0433 99.1954 24.9928C99.1954 24.9592 99.1954 24.9087 99.162 24.8751C99.1504 24.8516 99.1306 24.8363 99.1141 24.8235C99.1069 24.818 99.1003 24.8129 99.0953 24.8078C99.0619 24.791 99.0286 24.7741 98.9952 24.7741C98.9785 24.7741 98.9577 24.7699 98.9369 24.7657C98.916 24.7615 98.8951 24.7573 98.8784 24.7573H98.5782V25.2283H98.9452Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.844 26.6407C99.4807 26.6407 100 26.1214 100 25.4847C100 24.8481 99.4807 24.3288 98.844 24.3288C98.2073 24.3288 97.6879 24.8481 97.6879 25.4847C97.6879 26.1214 98.2073 26.6407 98.844 26.6407ZM97.8052 25.4512C97.822 24.8816 98.2744 24.446 98.8441 24.4628C99.3802 24.4795 99.8159 24.9151 99.8326 25.4512C99.8494 26.0041 99.4137 26.4732 98.8441 26.4899H98.7938C98.2241 26.4732 97.7885 26.0208 97.8052 25.4512Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M49.3148 2.63343C48.3095 2.63343 47.4885 3.38732 47.4885 4.3255L47.455 5.79978C47.455 7.60959 48.6695 9.19028 49.9535 10.8616C50.5713 11.6656 51.2051 12.4906 51.7276 13.3722C53.0681 15.6506 53.4199 16.5386 53.4199 19.2526V22.4859C53.4199 24.5466 51.5601 26.2219 49.2813 26.2219C47.0026 26.2219 45.1427 24.5466 45.1427 22.4859V18.6159H47.455V22.2681C47.455 23.2063 48.276 23.9602 49.2813 23.9602C50.2867 23.9602 51.1077 23.2063 51.1077 22.2681V19.3196C51.1077 16.6391 50.4207 15.6339 47.522 11.7472C45.9135 9.58599 45.1427 7.84366 45.1427 5.88354V4.09096C45.1427 2.03032 47.0026 0.355 49.2981 0.355C51.5936 0.355 53.4534 2.03032 53.4534 4.09096V6.55367H51.1412V4.3255C51.1412 3.40408 50.3202 2.63343 49.3148 2.63343Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M86.3446 5.28043L84.8533 14.9973C85.7414 15.6004 86.3278 16.5721 86.3111 17.661V26.1549H84.1496V17.7783C84.1496 17.0579 83.5297 16.4715 82.7422 16.4715H81.6866V26.1549H79.5084V5.28043H81.6866V14.3439H82.0887C82.4908 14.3271 82.8092 14.0758 82.8594 13.7575L84.1161 5.28043H86.3446Z",
    fill: "currentColor"
}));


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Foundations/BrandLogo/icons/Kallista.mjs

const KallistaLogo = /* @__PURE__ */ /*#__PURE__*/ react.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "120",
    height: "20",
    viewBox: "0 0 120 20",
    fill: "none"
}, /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 19.0913V1.42895H1.56745V9.70491L9.47533 1.42895H11.5541L3.26383 9.87454L11.9481 19.0913H9.64267L1.56745 10.1274V19.0913H0Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7169 19.0913L20.0385 12.974H27.1958L29.4334 19.0913H31.1688L23.7966 0.389999L16.1038 19.0913H17.7169ZM23.6892 3.76242L26.6812 11.5762H20.577L23.6892 3.76242Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.3636 19.6108V0.909476H37.9742V18.0219H44.1558V19.6108H36.3636Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.3506 19.6108V0.909476H50.9615V18.0219H57.1428V19.6108H49.3506Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.9352 19.0913H66.4936V1.42895H64.9352V19.0913Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.2856 16.0683L75.6446 15.305C75.896 16.2068 76.3294 16.9053 76.9471 17.4018C77.5631 17.8982 78.3028 18.146 79.1678 18.146C80.2592 18.146 81.1113 17.8039 81.724 17.1202C82.3368 16.4362 82.6433 15.4904 82.6433 14.2805C82.6433 13.3971 82.438 12.6623 82.0256 12.0782C81.6134 11.4942 80.728 10.8187 79.3691 10.0515C77.6317 9.07567 76.4756 8.21654 75.9025 7.47374C75.3285 6.73159 75.0415 5.83906 75.0415 4.79548C75.0415 3.49464 75.4571 2.43462 76.289 1.61687C77.1208 0.799281 78.1993 0.389999 79.5251 0.389999C80.3926 0.389999 81.1476 0.583561 81.7903 0.970196C82.433 1.35634 82.9553 1.93523 83.3572 2.70802L82.1128 3.49758C81.8614 2.96349 81.5067 2.55519 81.0474 2.27527C80.5882 1.99503 80.044 1.85491 79.4167 1.85491C78.5687 1.85491 77.8936 2.12114 77.3907 2.65246C76.888 3.18491 76.6374 3.90262 76.6374 4.80689C76.6374 6.09632 77.6342 7.29729 79.6285 8.41141C79.9899 8.61263 80.264 8.76806 80.4531 8.87576C81.9277 9.73326 82.9132 10.5432 83.4096 11.3046C83.9068 12.0658 84.1558 13.0535 84.1558 14.2681C84.1558 15.9078 83.7015 17.2082 82.7961 18.17C81.889 19.1303 80.656 19.6108 79.0967 19.6108C77.9608 19.6108 76.9898 19.3149 76.1831 18.7222C75.3745 18.1302 74.7424 17.2458 74.2856 16.0683Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.2426 19.0913V2.9296H89.3508V1.42895H100.779V2.9296H95.8441V19.0913H94.2426Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.432 19.0913L105.753 12.974H112.91L115.148 19.0913H116.883L109.511 0.389999L101.818 19.0913H103.432ZM109.404 3.76242L112.396 11.5762H106.292L109.404 3.76242Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.747 17.9782V17.6071H118.991C119.115 17.6071 119.249 17.6346 119.249 17.783C119.249 17.967 119.113 17.9782 118.961 17.9782H118.747ZM118.747 18.1322H118.953L119.265 18.6514H119.465L119.129 18.1239C119.302 18.102 119.436 18.0085 119.436 17.7941C119.436 17.5575 119.297 17.4533 119.018 17.4533H118.568V18.6514H118.747V18.1322ZM118.963 19.0913C119.522 19.0913 120 18.6514 120 18.0499C120 17.4533 119.522 17.0134 118.963 17.0134C118.399 17.0134 117.922 17.4533 117.922 18.0499C117.922 18.6514 118.399 19.0913 118.963 19.0913ZM118.129 18.0499C118.129 17.5575 118.494 17.1867 118.963 17.1867C119.427 17.1867 119.794 17.5575 119.794 18.0499C119.794 18.5499 119.427 18.9183 118.963 18.9183C118.494 18.9183 118.129 18.5499 118.129 18.0499Z",
    fill: "currentColor"
}));


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Foundations/BrandLogo/icons/Klafs.mjs

const KlafsLogo = /* @__PURE__ */ /*#__PURE__*/ react.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "82",
    height: "24",
    viewBox: "0 0 82 24",
    fill: "none"
}, /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M10.76 1.51999H15.88L7.80004 10.56L16.36 21.12H11L4.20004 12.32V21.12H0.0400391V1.51999H4.20004V9.75999L10.76 1.51999ZM22.44 17.84H29.4V21.12H18.36V1.51999H22.44V17.84ZM59.8 4.79999V9.11999H66.84V12.48H59.8V21.12H55.72V1.51999H66.92V4.79999H59.8ZM79.32 5.83999C78.52 4.87999 77.56 4.23999 76.12 4.23999C74.76 4.23999 73.56 5.19999 73.56 6.47999C73.56 9.75999 81.96 8.39999 81.96 14.96C81.96 18.88 79.32 21.68 75 21.68C72.04 21.68 69.96 20.08 68.44 17.84L71.08 15.44C71.64 16.96 73.16 18.32 74.92 18.32C76.6 18.32 77.64 16.96 77.64 15.44C77.64 13.44 75.64 12.8 73.96 12.24C71.24 11.2 69.24 9.91999 69.24 6.87999C69.24 3.59999 71.88 0.959991 75.48 0.959991C77.4 0.959991 79.96 1.83999 81.24 3.11999L79.32 5.83999ZM54.36 21.12H49.32L42.44 8.95999L35.4 21.12H30.36L42.2 1.03999C42.2 1.03999 50.2 14.24 54.36 21.12Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M46.92 23.04H37.8L42.2 15.12L46.92 23.04Z",
    fill: "currentColor"
}));


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Foundations/BrandLogo/icons/KlafsSaunaAndSpa.mjs

const KlafsSaunaAndSpaLogo = /* @__PURE__ */ /*#__PURE__*/ react.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "82",
    height: "32",
    viewBox: "0 0 82 32",
    fill: "none"
}, /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M10.76 0.839999H15.88L7.80004 9.88L16.36 20.44H11L4.20004 11.64V20.44H0.0400391V0.839999H4.20004V9.08L10.76 0.839999ZM22.44 17.16H29.4V20.44H18.36V0.839999H22.44V17.16ZM59.8 4.12V8.44H66.84V11.8H59.8V20.44H55.72V0.839999H66.92V4.12H59.8ZM79.32 5.16C78.52 4.2 77.56 3.56 76.12 3.56C74.76 3.56 73.56 4.52 73.56 5.8C73.56 9.08 81.96 7.72 81.96 14.28C81.96 18.2 79.32 21 75 21C72.04 21 69.96 19.4 68.44 17.16L71.08 14.76C71.64 16.28 73.16 17.64 74.92 17.64C76.6 17.64 77.64 16.28 77.64 14.76C77.64 12.76 75.64 12.12 73.96 11.56C71.24 10.52 69.24 9.24 69.24 6.2C69.24 2.92 71.88 0.279999 75.48 0.279999C77.4 0.279999 79.96 1.16 81.24 2.44L79.32 5.16ZM54.36 20.44H49.32L42.44 8.28L35.4 20.44H30.36L42.2 0.359999C42.2 0.359999 50.2 13.56 54.36 20.44Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M46.92 22.36H37.8L42.2 14.44L46.92 22.36Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M1.00004 26.84L2.60004 30.52L4.20004 26.84L5.08004 31.48H4.60004L4.04004 28.52L2.60004 31.64L1.24004 28.52L0.680039 31.48H0.120039L1.00004 26.84ZM6.92004 27.16H7.48004L8.60004 29.08L9.72004 27.16H10.28L8.84004 29.64V31.48H8.36004V29.64L6.92004 27.16ZM17.64 27.96C17.48 27.64 17.24 27.48 16.92 27.48C16.52 27.48 16.2 27.72 16.2 28.12C16.2 28.52 16.6 28.68 16.92 28.84L17.24 29C17.8 29.24 18.28 29.56 18.28 30.2C18.28 31 17.64 31.56 16.92 31.56C16.2 31.56 15.72 31.08 15.56 30.44L16.04 30.28C16.12 30.76 16.44 31.08 16.92 31.08C17.4 31.08 17.8 30.68 17.8 30.2C17.8 29.72 17.4 29.48 17 29.32L16.76 29.24C16.28 29 15.8 28.76 15.8 28.12C15.8 27.48 16.36 27 17 27C17.48 27 17.88 27.24 18.12 27.64L17.64 27.96ZM22.12 28.04L21.4 29.8H22.84L22.12 28.04ZM21.16 30.28L20.6 31.48H20.04L22.04 26.92L24.04 31.48H23.48L23 30.28H21.16ZM26.6 29.72C26.6 30.04 26.6 30.44 26.76 30.68C26.92 30.92 27.32 31.08 27.64 31.08C27.96 31.08 28.28 30.92 28.52 30.68C28.76 30.44 28.76 30.04 28.76 29.64V27.08H29.24V29.88C29.24 30.36 29.24 30.76 28.84 31.08C28.52 31.4 28.12 31.56 27.64 31.56C27.24 31.56 26.84 31.4 26.52 31.08C26.12 30.68 26.12 30.28 26.12 29.8V27.08H26.6V29.72ZM31.72 31.48H32.2V28.12L35.64 31.72V27.16H35.16V30.52L31.72 26.92V31.48ZM39.8 28.04L39.08 29.8H40.52L39.8 28.04ZM38.84 30.28L38.28 31.48H37.72L39.72 26.92L41.72 31.48H41.16L40.68 30.28H38.84ZM48.92 28.04L48.2 29.8H49.64L48.92 28.04ZM48.04 30.28L47.48 31.48H46.92L48.92 26.92L50.92 31.48H50.36L49.88 30.28H48.04ZM53.08 31.48H53.56V28.12L57 31.72V27.16H56.44V30.52L53.08 26.92V31.48ZM60.36 31.08C60.92 31.08 61.32 31 61.72 30.6C62.04 30.28 62.28 29.8 62.28 29.32C62.28 28.84 62.12 28.36 61.72 28.04C61.32 27.72 60.92 27.64 60.36 27.64H60.04V31.08H60.36ZM60.28 27.16C60.92 27.16 61.48 27.24 61.96 27.72C62.44 28.12 62.68 28.76 62.68 29.4C62.68 30.04 62.44 30.6 61.96 31C61.4 31.48 60.92 31.56 60.2 31.56H59.4V27.16H60.28ZM70.28 27.96C70.12 27.64 69.88 27.48 69.56 27.48C69.16 27.48 68.84 27.72 68.84 28.12C68.84 28.52 69.24 28.68 69.56 28.84L69.88 29C70.44 29.24 70.92 29.56 70.92 30.2C70.92 31 70.28 31.56 69.56 31.56C68.84 31.56 68.36 31.08 68.2 30.44L68.68 30.28C68.76 30.76 69.08 31.08 69.56 31.08C70.04 31.08 70.44 30.68 70.44 30.2C70.44 29.72 70.04 29.48 69.64 29.32L69.4 29.24C68.92 29 68.44 28.76 68.44 28.12C68.44 27.48 69 27 69.64 27C70.12 27 70.52 27.24 70.76 27.64L70.28 27.96ZM73.72 29.16H74.04C74.6 29.16 75 29 75 28.36C75 27.64 74.44 27.56 73.88 27.56H73.72V29.16ZM73.24 31.48V27.08H73.96C74.36 27.08 74.76 27.08 75.08 27.32C75.4 27.56 75.56 27.96 75.56 28.28C75.56 28.6 75.4 29 75.16 29.24C74.84 29.48 74.52 29.56 74.12 29.56H73.8V31.48H73.24ZM78.76 28.04L78.04 29.8H79.48L78.76 28.04ZM77.8 30.28L77.32 31.48H76.76L78.76 26.92L80.76 31.48H80.2L79.72 30.28H77.8Z",
    fill: "currentColor"
}));


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Foundations/BrandLogo/icons/Kohler.mjs

const KohlerLogo = /* @__PURE__ */ /*#__PURE__*/ react.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "98",
    height: "22",
    viewBox: "0 0 98 22",
    fill: "none"
}, /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.4246 21.0039V0.938011H58.8226V15.8755L64.8821 15.8759V21.0039H53.4246Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.8363 21.0039V0.938011H41.2343V7.97396H46.6772V0.938011H52.0751V21.0039H46.6772V13.5395H41.2343V21.0039H35.8363Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4953 0.940677L9.69605 10.4966L18.6075 21.0111L11.4631 21.0073L5.40994 13.8491H5.39757L5.39794 21.0039H0V0.938011H5.39757V6.94837L5.35558 6.95332L10.4967 0.940677H17.4953Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.7559 15.9475C27.2873 15.9475 29.3401 13.6431 29.3401 10.8005C29.3401 7.95796 27.2873 5.65352 24.7559 5.65352C22.2241 5.65352 20.1714 7.95796 20.1714 10.8005C20.1714 13.6431 22.2241 15.9475 24.7559 15.9475ZM14.5714 10.8043C14.5714 5.03086 19.1312 0.35 24.7559 0.35C30.3803 0.35 34.9401 5.03086 34.9401 10.8043C34.9401 16.5778 30.3803 21.2587 24.7559 21.2587C19.1312 21.2587 14.5714 16.5778 14.5714 10.8043Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.9492 0.938011V5.56098L71.5295 5.57317L71.51 8.7402H76.5169V13.2322H71.5175L71.5216 16.2945H76.996V21.0039H65.9913V0.938011H76.9492Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.0033 9.45236C86.0537 9.45236 86.9054 8.5871 86.9054 7.51962C86.9054 6.45214 86.0537 5.58688 85.0033 5.58688H83.4739V9.44741L85.0033 9.45236ZM88.1716 12.9854L93.7885 21.0149L87.8946 21.0043L83.4923 14.8439V20.9925H78.2034V0.930394H84.9704C90.9242 0.930394 94.7028 8.51931 88.1716 12.9854Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.4177 19.6858C96.6243 19.6858 96.7412 19.6401 96.7412 19.4025C96.7412 19.2105 96.5028 19.2105 96.3233 19.2105H95.9233V19.6858H96.4177ZM97.0741 20.7636H96.6243L96.2108 19.9688H95.9233V20.7636H95.5095V18.8819H96.4087C96.8357 18.8819 97.1277 18.9596 97.1277 19.4569C97.1277 19.8046 96.9527 19.9459 96.6243 19.9688L97.0741 20.7636ZM97.5775 19.8454C97.5775 19.0323 96.9841 18.4569 96.2198 18.4569C95.442 18.4569 94.8621 19.0323 94.8621 19.8454C94.8621 20.6493 95.442 21.2248 96.2198 21.2248C96.9841 21.2248 97.5775 20.6493 97.5775 19.8454ZM94.4396 19.8454C94.4396 18.8362 95.2261 18.0276 96.2198 18.0276C97.2091 18.0276 98 18.8362 98 19.8454C98 20.8458 97.2091 21.6543 96.2198 21.6543C95.2261 21.6543 94.4396 20.8458 94.4396 19.8454Z",
    fill: "currentColor"
}));


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Foundations/BrandLogo/icons/KohlerBold.mjs

const KohlerBoldLogo = /* @__PURE__ */ /*#__PURE__*/ react.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "98",
    height: "30",
    viewBox: "0 0 98 30",
    fill: "none"
}, /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.9814 5.36964C41.9814 2.40469 39.5681 0 36.5922 0C33.6163 0 31.2029 2.40469 31.2029 5.36964C31.2029 8.33413 33.6163 10.7389 36.5922 10.7389C39.5681 10.7389 41.9814 8.33413 41.9814 5.36964ZM36.5922 0.64506C39.2104 0.64506 41.3338 2.76106 41.3338 5.36964C41.3338 7.97801 39.2104 10.0938 36.5922 10.0938C33.9738 10.0938 31.8504 7.97801 31.8504 5.36964C31.8504 2.76106 33.9738 0.64506 36.5922 0.64506Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.819 10.6262V0.11249H25.5315C25.612 0.111594 25.6926 0.110724 25.7733 0.109634C26.6821 0.0973585 27.6022 0.0849306 28.474 0.346039C30.3015 1.11194 30.5372 4.00614 28.8571 5.06623C29.6825 5.36063 30.5079 5.89079 30.8025 6.77423C31.4215 8.33499 30.331 10.1903 28.7098 10.5142C27.7738 10.663 26.8376 10.6475 25.9016 10.632C25.7782 10.6299 25.6548 10.6279 25.5315 10.6262H24.819ZM25.5315 0.758649V4.85992C25.7873 4.85164 26.048 4.86049 26.3094 4.86936C26.9499 4.8911 27.5941 4.91296 28.1792 4.68328C29.6825 4.09424 29.6529 1.61243 28.1792 0.994175C27.5252 0.768675 26.8367 0.767402 26.1533 0.766138C25.9452 0.765753 25.7375 0.765369 25.5315 0.758649ZM27.3984 10.0024C26.7655 10.0064 26.1125 10.0025 25.5315 9.97978C25.5315 9.57693 25.5289 9.1737 25.5263 8.7703C25.5193 7.68271 25.5123 6.59331 25.5559 5.50784C25.8781 5.5244 26.205 5.52474 26.5332 5.52509C27.376 5.52596 28.2278 5.52685 29.0339 5.80247C30.4194 6.30296 30.6552 8.39387 29.5647 9.30675C28.9729 9.88144 28.198 9.99711 27.3984 10.0024Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M6.21947 0.10524H0V0.766119H2.77086V10.6262H3.48331V0.766119H6.21947V0.10524Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.9556 21.1252C46.9556 16.624 43.3237 12.9745 38.8454 12.9745C34.3669 12.9745 30.735 16.624 30.735 21.1252C30.735 25.6264 34.3669 29.2759 38.8454 29.2759C43.3237 29.2759 46.9556 25.6264 46.9556 21.1252ZM38.8454 17.1184C40.8502 17.1184 42.476 18.9124 42.476 21.1251C42.476 23.3379 40.8502 25.132 38.8454 25.132C36.8405 25.132 35.2146 23.3379 35.2146 21.1251C35.2146 18.9124 36.8405 17.1184 38.8454 17.1184Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M47.5744 13.4455H51.9074V18.908H56.1814V13.4455H60.5144V29.0985H56.1814V23.225H51.9074V29.0985H47.5744V13.4455Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M61.6346 13.4455H65.9676V25.0605H70.7427V29.0985H61.6346V13.4455Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M80.3813 13.4455H71.627V29.0985H80.3813V25.501H75.9599V23.0488H80.3813V19.4512H75.9599V17.043H80.3813V13.4455Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.687 13.4455H81.354V29.0985H85.687V24.485C85.8575 24.7193 86.0281 24.9543 86.1989 25.1895C87.1499 26.4993 88.1081 27.8191 89.1063 29.0985H93.7634L93.6069 28.8782L93.6063 28.8774C92.1856 26.8782 90.7648 24.8788 89.3125 22.9022C90.5211 22.0253 91.6118 20.8854 91.9064 19.3948C92.555 16.852 90.5505 14.1922 88.0745 13.666C87.285 13.52 86.4876 13.4633 85.687 13.4455ZM85.687 20.1183V17.0642C85.8082 17.0709 85.9311 17.0744 86.0544 17.0779C86.6788 17.0955 87.3125 17.1134 87.7799 17.5535C88.3989 18.0796 88.3989 19.1901 87.7503 19.6871C87.3303 20.1257 86.7275 20.12 86.1414 20.1146C85.9876 20.1131 85.8349 20.1117 85.687 20.1183Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M30.2204 16.8629C29.1033 18.2064 27.9856 19.5507 26.8823 20.9049L33.9566 29.0985H28.2381L23.4334 23.491V29.0985H19.1006V13.4455H23.4334V18.0659L27.5399 13.4519H33.0427C32.1089 14.5914 31.1669 15.7244 30.2249 16.8574L30.2216 16.8614L30.2204 16.8629Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M6.77438 10.6262V0.11249H7.48692V4.53234H13.8487V0.11249H14.5612V10.6262H13.8487V5.19322H7.48692V10.6262H6.77438Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M15.6813 0.11249V10.6262H20.7217V9.96546H16.3939V5.19322H20.7217V4.53234H16.3939V0.773369H20.7217V0.11249H15.6813Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M42.6813 0.11249V10.6262H47.6924V9.96546H43.3938V0.11249H42.6813Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.3407 0.11249V10.6262H49.0534V10.6171C50.7516 10.6526 52.5691 10.6442 53.9119 9.48278C56.4467 7.47905 56.3878 3.14752 53.8234 1.2029C52.5017 0.11037 50.7635 0.113101 49.1192 0.115685L49.0534 0.115786V0.11249H48.3407ZM49.0534 9.98494V0.760846L49.1339 0.760809C50.6102 0.76002 52.2918 0.759122 53.4697 1.82159C55.5329 3.44215 55.6509 6.91924 53.735 8.71664C52.535 10.0039 50.6667 10.0421 49.0534 9.98494Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M60.0723 0.11249V10.6262H65.0833V9.96546H60.785V0.11249H60.0723Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M86.4469 10.6262V0.11249H87.1596V4.83971L91.9452 0.11249H92.9559L87.841 5.16619L93.2915 10.6262H92.284L87.1596 5.4907V10.6262H86.4469Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M11.7611 13.3868V23.9005H12.4736V18.4821H15.9034V17.8213H12.4736V14.0476H15.9761V13.3868H11.7611Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.66602 13.2795C8.64188 13.2795 11.0553 15.6843 11.0553 18.649C11.0553 21.6136 8.64188 24.0184 5.66602 24.0184C2.69006 24.0184 0.276681 21.6136 0.276681 18.649C0.276681 15.6843 2.69006 13.2795 5.66602 13.2795ZM10.4077 18.649C10.4077 16.0404 8.28431 13.9246 5.66602 13.9246C3.04754 13.9246 0.92428 16.0404 0.92428 18.649C0.92428 21.2575 3.04754 23.3733 5.66602 23.3733C8.28431 23.3733 10.4077 21.2575 10.4077 18.649Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.9126 0C71.8885 0 74.3021 2.40469 74.3021 5.36964C74.3021 8.33413 71.8885 10.7389 68.9126 10.7389C65.9367 10.7389 63.5234 8.33413 63.5234 5.36964C63.5234 2.40469 65.9367 0 68.9126 0ZM73.6544 5.36964C73.6544 2.76106 71.531 0.64506 68.9126 0.64506C66.2944 0.64506 64.171 2.76106 64.171 5.36964C64.171 7.97801 66.2944 10.0938 68.9126 10.0938C71.531 10.0938 73.6544 7.97801 73.6544 5.36964Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.7566 5.36964C85.7566 2.40469 83.3433 0 80.3674 0C77.3915 0 74.9782 2.40469 74.9782 5.36964C74.9782 8.33413 77.3915 10.7389 80.3674 10.7389C83.3433 10.7389 85.7566 8.33413 85.7566 5.36964ZM80.3674 0.64506C82.9858 0.64506 85.1092 2.76106 85.1092 5.36964C85.1092 7.97801 82.9858 10.0938 80.3674 10.0938C77.749 10.0938 75.6256 7.97801 75.6256 5.36964C75.6256 2.76106 77.749 0.64506 80.3674 0.64506Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.0743 29.2173H96.7662L96.515 28.5551H96.1053V29.2173H95.8138V27.6065H96.515C96.71 27.6065 96.8535 27.6503 96.945 27.7382C97.0368 27.8257 97.0824 27.9392 97.0824 28.0785C97.0824 28.2856 96.9854 28.4278 96.7909 28.5056L97.0743 29.2173ZM96.1053 28.3227H96.4678C96.5726 28.3227 96.6509 28.3009 96.7025 28.2566C96.7536 28.2127 96.7792 28.1519 96.7792 28.0749C96.7792 28.0041 96.7541 27.9469 96.7036 27.9033C96.6531 27.8595 96.5823 27.8377 96.4914 27.8377H96.1053V28.3227Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.5332 27.2889C97.2447 27.0016 96.8463 26.8238 96.4061 26.8238C95.9659 26.8238 95.5672 27.0016 95.279 27.2889C94.9906 27.5762 94.812 27.9734 94.812 28.4118C94.812 28.8504 94.9906 29.2475 95.279 29.5348C95.5672 29.8221 95.9659 30 96.4061 30C96.8463 30 97.2447 29.8221 97.5332 29.5348C97.8216 29.2475 98 28.8504 98 28.4118C98 27.9734 97.8216 27.5762 97.5332 27.2889ZM96.4061 27.1351C96.7598 27.1351 97.0802 27.2781 97.3122 27.5092C97.544 27.7401 97.6875 28.0594 97.6875 28.4118C97.6875 28.7644 97.544 29.0836 97.3122 29.3146C97.0802 29.5456 96.7598 29.6885 96.4061 29.6885C96.0522 29.6885 95.7318 29.5456 95.5 29.3146C95.268 29.0836 95.1247 28.7644 95.1247 28.4118C95.1247 28.0594 95.268 27.7401 95.5 27.5092C95.7318 27.2781 96.0522 27.1351 96.4061 27.1351Z",
    fill: "currentColor"
}));


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Foundations/BrandLogo/icons/Mira.mjs

const MiraLogo = /* @__PURE__ */ /*#__PURE__*/ react.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "80",
    height: "51",
    viewBox: "0 0 80 51",
    fill: "none"
}, /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M44.1386 35.0481C44.1007 35.0665 44.0629 35.0849 44.0061 35.1032C42.3795 35.7644 38.0669 37.0499 34.057 37.0499C29.9335 37.0499 25.0535 35.2501 22.0082 33.9095C21.1192 33.5238 17.1471 31.8894 11.5862 31.8894C7.00878 31.8894 2.6962 33.836 0.426421 35.2501L0.142699 35.4338C-0.0653639 35.5807 -0.103193 35.9847 0.426421 35.7827C2.54488 35.0114 6.25218 34.0564 10.1297 34.0564C14.6504 34.0564 20.4572 36.3704 22.0082 37.0866C23.4268 37.7477 27.607 39.4557 32.6005 39.4557C36.9888 39.4557 42.0958 36.9764 44.0061 35.6174C44.1385 35.5256 44.252 35.4338 44.3466 35.3603C44.5358 35.2318 44.479 34.9379 44.1386 35.0481Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M37.1968 0.154999H42.3984C43.7225 0.154999 45.7274 0.816129 45.387 3.00153L45.2735 3.53411H38.2372C37.4806 3.53411 36.6672 2.68933 36.8375 2.00984C36.932 1.60581 37.1968 0.154999 37.1968 0.154999Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M75.5372 31.9996C75.4994 32.0179 75.4616 32.0363 75.4048 32.0547C73.7781 32.7158 69.4655 34.0013 65.4556 34.0013C61.3322 34.0013 56.4522 32.2016 53.4069 30.861C52.5179 30.4753 48.5458 28.8408 42.9848 28.8408C38.4074 28.8408 34.0948 30.7875 31.8251 32.2016L31.5413 32.3852C31.3333 32.5321 31.2955 32.9362 31.8251 32.7342C33.9435 31.9628 37.6508 31.0079 41.5284 31.0079C46.049 31.0079 51.8559 33.3218 53.4069 34.0381C54.8255 34.6992 59.0057 36.4071 63.9992 36.4071C68.3874 36.4071 73.4944 33.9279 75.4048 32.5689C75.5372 32.477 75.6507 32.3852 75.7453 32.3118C75.9344 32.2016 75.8777 31.8894 75.5372 31.9996Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M29.3285 5.16857H2.96124L2.60186 7.57436L2.58295 7.70291C2.58295 8.47423 3.9259 8.60279 3.60435 10.3842L3.52869 10.8066L1.46697 22.8171L1.35348 23.4966C1.24 24.1027 1.52372 24.5251 2.05334 24.5251C3.20714 24.5434 7.17925 24.5251 7.17925 24.5251C8.10608 24.5251 8.40871 23.8639 8.46546 23.515C8.48437 23.4415 8.54112 23.2028 8.59786 22.8171C9.10856 20.0257 10.8109 10.072 10.8109 10.072H13.232C14.0453 10.072 14.4425 10.2373 14.2156 11.4677L12.2106 22.7988L12.0782 23.4783C11.9647 24.0843 12.2484 24.5067 12.778 24.5067C13.9318 24.5251 18.0553 24.5067 18.0553 24.5067C18.9821 24.5067 19.2847 23.8456 19.3415 23.4783C19.3604 23.4048 19.3982 23.1661 19.455 22.7988C19.9657 19.9522 21.6869 10.0536 21.6869 10.0536H23.9945C24.8079 10.0536 25.3753 10.1087 25.2051 11.284L23.1434 22.7988L23.0299 23.4599C22.9164 24.0659 23.2001 24.4883 23.7297 24.4883C24.8835 24.5067 28.9313 24.4883 28.9313 24.4883C29.8581 24.4883 30.1607 23.8272 30.2175 23.4599C30.2364 23.3864 30.2742 23.1477 30.331 22.7804C30.8606 19.8053 32.9034 8.25386 32.9034 8.25386C33.1493 6.72958 32.7332 5.16857 29.3285 5.16857Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M40.715 5.16857H36.1754L35.7593 7.57436L35.7404 7.68455C35.7404 8.4375 36.7618 8.63952 36.5916 10.1271L36.4781 10.8066L34.3407 22.8171L34.2272 23.4966C34.1137 24.1027 34.3974 24.5251 34.9271 24.5251C36.0809 24.5434 40.28 24.5251 40.28 24.5251C41.2068 24.5251 41.5094 23.8639 41.5662 23.4966C41.5851 23.4232 41.6418 23.1661 41.6986 22.7988C42.2849 19.7869 44.2521 8.34568 44.2521 8.34568L44.271 8.29059C44.498 6.72958 44.1007 5.16857 40.715 5.16857Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M68.0657 44.9102C68.5764 44.9102 69.106 45.0571 69.5032 45.2591L69.8248 44.1389C69.2573 43.9185 68.6332 43.845 68.0279 43.845C66.7038 43.845 65.4555 44.4694 65.4555 45.8835C65.4555 47.6833 67.8198 47.4813 67.8198 48.7117C67.8198 49.4463 67.1578 49.7585 66.4958 49.7585C65.9094 49.7585 65.342 49.5381 64.7934 49.2994L64.4341 50.4564C65.0583 50.6767 65.7392 50.842 66.4012 50.842C67.9144 50.842 69.2384 50.236 69.2384 48.5831C69.2384 46.7099 66.8741 46.7834 66.8741 45.6999C66.9119 45.0938 67.5739 44.9102 68.0657 44.9102ZM58.2678 46.8385H57.7571L58.1354 45.0204H58.7029C59.2703 45.0204 59.8945 45.0204 59.8945 45.7182C59.9134 46.6181 59.0055 46.8385 58.2678 46.8385ZM58.6083 43.9552H56.9627L55.5063 50.6951H56.8871L57.4923 47.8853H58.0219C58.7785 47.8853 58.7407 48.3811 58.892 49.0974L59.2325 50.6767H60.6889L60.0269 47.9588C59.9323 47.5915 59.7054 47.3527 59.3271 47.3343V47.316C60.462 47.2976 61.351 46.6732 61.351 45.5162C61.351 43.9369 59.8756 43.9552 58.6083 43.9552ZM47.1081 50.6951H51.2315L51.4774 49.6299H48.7348L49.132 47.7384H51.5531L51.7801 46.6732H49.359L49.7183 45.002H52.4232L52.6312 43.9369H48.5645L47.1081 50.6951ZM40.7905 49.1341H40.7716L40.7338 43.9552H38.8612L36.5536 49.1341L36.3456 43.9552H34.9648L35.3998 50.6951H37.1211L39.5611 45.2959H39.58L39.6557 50.6951H41.3958L44.687 43.9552H43.2495L40.7905 49.1341ZM26.7747 49.7585C25.7722 49.7585 25.3182 48.9688 25.3182 48.1057C25.3182 46.7467 26.1505 44.9102 27.7582 44.9102C28.7607 44.9102 29.2336 45.6631 29.2336 46.563C29.2525 47.9036 28.3635 49.7585 26.7747 49.7585ZM27.815 43.845C26.6801 43.845 25.7154 44.2674 24.9778 45.0938C24.2779 45.9019 23.8807 46.9303 23.8807 48.0138C23.8807 49.6116 24.9021 50.8237 26.6044 50.8237C27.7582 50.8237 28.8175 50.4747 29.5362 49.685C30.2739 48.877 30.69 47.7935 30.69 46.6916C30.69 44.9102 29.6875 43.845 27.815 43.845ZM18.3954 46.6916H15.596L16.1824 43.9736H14.8016L13.3451 50.7135H14.7259L15.369 47.7567H18.1684L17.5253 50.7135H18.9061L20.3625 43.9736H18.9818L18.3954 46.6916ZM5.64682 45.8835C5.64682 47.6833 8.01117 47.4813 8.01117 48.7117C8.01117 49.4463 7.34915 49.7585 6.68713 49.7585C6.10077 49.7585 5.53333 49.5381 4.9848 49.2994L4.62542 50.4564C5.24961 50.6767 5.93054 50.842 6.59256 50.842C8.10575 50.842 9.42978 50.236 9.42978 48.5831C9.42978 46.7099 7.06543 46.7834 7.06543 45.6999C7.06543 45.1122 7.72745 44.9286 8.21924 44.9286C8.72994 44.9286 9.25955 45.0755 9.65676 45.2775L9.97831 44.1572C9.41087 43.9369 8.78668 43.8634 8.1814 43.8634C6.8952 43.845 5.64682 44.4694 5.64682 45.8835Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M70.9599 18.2994C70.9031 18.9054 70.6383 19.6951 69.2008 19.64H65.3043C64.699 19.64 64.1883 19.5666 64.3775 18.7402L64.491 17.7301C64.491 17.1791 64.7558 16.8302 65.4367 16.8302H71.1679L70.9599 18.2994ZM76.483 5.16857H59.7812C58.5706 5.16857 56.2819 5.22367 55.2984 7.51927C54.9579 5.68279 53.8798 5.24203 52.0261 5.16857H47.3541L46.9191 7.68455C46.9191 8.40077 48.054 8.47423 47.8081 10.0903L45.5951 22.8171L45.4816 23.4966C45.3681 24.1027 45.6518 24.5251 46.1814 24.5251C47.3352 24.5434 51.3073 24.5251 51.3073 24.5251C52.2342 24.5251 52.5368 23.8639 52.5936 23.4966C52.6125 23.4232 52.6692 23.1661 52.726 22.7988C52.8205 22.3029 54.0689 14.9754 54.0689 14.9754C54.2959 13.3042 55.7902 10.1271 60.2162 10.072H71.5462C72.473 10.072 72.3785 10.4209 72.265 11.082L71.9434 12.7532H61.6916C60.5945 12.7532 59.0435 12.8634 58.5328 15.4896L57.4925 21.2378C57.3223 22.2478 57.2844 24.5251 60.2919 24.5251H74.2321C75.3859 24.5251 77.1639 24.4149 77.6935 21.2929L79.9444 8.69461C80.1714 7.1336 79.8309 5.22367 76.483 5.16857Z",
    fill: "currentColor"
}));


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Foundations/BrandLogo/icons/Robern.mjs

const RobernLogo = /* @__PURE__ */ /*#__PURE__*/ react.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "100",
    height: "27",
    viewBox: "0 0 100 27",
    fill: "none"
}, /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.6558 16.4847H30.455V0.0400009H34.1223V8.4595C35.8623 6.97832 38.1234 6.08395 40.5961 6.08395C46.0961 6.08395 50.5493 10.5089 50.5493 15.9741C50.5493 21.4392 46.0961 25.8642 40.5961 25.8642C35.2684 25.8642 30.923 21.7122 30.6558 16.4847ZM34.3484 15.9575C34.3484 19.3918 37.1566 22.1822 40.6128 22.1822C40.6627 22.1822 40.7291 22.1822 40.7624 22.1657C44.2186 22.1327 46.9935 19.3093 46.9437 15.875C46.9104 12.4407 44.069 9.68335 40.6128 9.73288C37.1566 9.73288 34.3484 12.5232 34.3484 15.9575Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M7.75129 7.21288C8.15136 7.21288 8.56809 7.24593 8.96816 7.29552V10.601C8.5756 10.601 7.99438 10.6244 7.80962 10.6318C7.7747 10.6332 7.75394 10.634 7.75129 10.634C5.38423 10.6836 3.6006 12.5843 3.6006 15.0799V26.2193H0V15.0799C0 10.4522 3.18386 7.21288 7.75129 7.21288Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M77.913 7.21288C78.3131 7.21288 78.7298 7.24593 79.1299 7.29552V10.601C78.7373 10.601 78.1561 10.6244 77.9713 10.6318C77.9364 10.6332 77.9157 10.634 77.913 10.634C75.546 10.6836 73.7623 12.5843 73.7623 15.0799V26.2193H70.1617V15.0799C70.1617 10.4522 73.3456 7.21288 77.913 7.21288Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M79.9966 15.0138C79.9966 10.3861 83.1804 7.14677 87.7478 7.14677C92.2986 7.14677 95.4825 10.3696 95.4991 14.9973V26.1698H91.8985V14.9973C91.8985 12.5182 90.0649 10.5679 87.7478 10.5679C85.4141 10.5679 83.5972 12.5182 83.5972 14.9973V26.1863H79.9966V15.0138Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.8109 21.1785C65.9276 21.0793 66.0443 20.9802 66.1443 20.881C66.1443 20.881 66.1443 25.3434 66.1276 25.3269C65.7109 25.5252 65.2942 25.707 64.8774 25.8392C61.2768 27.0127 57.3262 26.0871 54.6591 23.4427C50.7584 19.5753 50.7584 13.3115 54.6591 9.44407C58.5597 5.57667 64.8774 5.57667 68.7781 9.44407C69.0448 9.70851 69.2948 9.98948 69.5282 10.2704L69.5449 10.287L66.1276 13.6751V13.6916L58.193 21.5586C58.3263 21.6578 58.4764 21.7404 58.6264 21.8231C58.6514 21.8396 58.6764 21.852 58.7014 21.8644C58.7264 21.8768 58.7514 21.8892 58.7764 21.9057C58.8186 21.9266 58.8598 21.9476 58.9004 21.9682C59.0202 22.0291 59.1353 22.0877 59.2598 22.1371C59.4098 22.2032 59.5599 22.2693 59.7266 22.3189C59.8433 22.3685 59.9599 22.4015 60.0766 22.4346C60.0933 22.4428 60.1141 22.447 60.135 22.4511C60.1558 22.4552 60.1766 22.4594 60.1933 22.4676C60.2767 22.4842 60.3559 22.5007 60.435 22.5172C60.5142 22.5337 60.5934 22.5503 60.6767 22.5668C60.6934 22.5668 60.7142 22.5709 60.7351 22.5751C60.7559 22.5792 60.7767 22.5833 60.7934 22.5833C60.8517 22.5916 60.9142 22.5999 60.9768 22.6081C61.0393 22.6164 61.1018 22.6246 61.1601 22.6329L61.3268 22.6494C61.5935 22.666 61.8769 22.666 62.1603 22.6494C62.227 22.6329 62.277 22.6329 62.327 22.6329C62.3405 22.6314 62.3542 22.6299 62.368 22.6284C62.5069 22.6133 62.6572 22.5969 62.7937 22.5668H62.8104C62.9176 22.5562 63.018 22.5319 63.1203 22.5071C63.177 22.4933 63.2344 22.4794 63.2938 22.4676L63.4438 22.4181C63.7772 22.3189 64.094 22.2032 64.4107 22.0545C64.5274 22.0049 64.6274 21.9553 64.7441 21.8892C64.7941 21.8561 64.8274 21.8396 64.8607 21.8231L64.8941 21.8065C64.9608 21.7652 65.0233 21.7239 65.0858 21.6826C65.1483 21.6413 65.2108 21.6 65.2775 21.5586L65.3775 21.4925C65.4942 21.4264 65.5942 21.3438 65.6942 21.2611L65.8109 21.1785ZM64.4941 10.8324C62.0771 9.67545 59.1933 10.1713 57.3096 12.0389C55.426 13.9065 54.9426 16.7657 56.1094 19.1456L64.4941 10.8324Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.1497 25.2938H97.783V26.1863H97.4662V24.1038H98.2664C98.7498 24.1038 98.9998 24.2856 98.9998 24.6988C98.9998 25.079 98.7498 25.2442 98.4497 25.2773L99.0498 26.2028H98.6998L98.1497 25.2938ZM97.7831 24.3848V25.0459H98.1498C98.4332 25.0459 98.6665 25.0129 98.6665 24.6988C98.6665 24.4344 98.4332 24.3848 98.2165 24.3848H97.7831Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100 25.1451C100 26.2028 99.1665 26.9631 98.1664 26.9631C97.1662 26.9631 96.3161 26.2028 96.3161 25.1451C96.3161 24.1038 97.1662 23.3436 98.1664 23.3436C99.1499 23.3436 100 24.1038 100 25.1451ZM98.1663 23.6411C97.3328 23.6411 96.6827 24.2856 96.6827 25.1451C96.6827 26.021 97.3328 26.6656 98.1663 26.6491C98.9831 26.6491 99.6332 26.021 99.6332 25.1451C99.6332 24.2856 98.9831 23.6411 98.1663 23.6411Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.2472 15.9741C29.2472 10.5089 24.794 6.08396 19.2939 6.08396C13.7939 6.08396 9.34068 10.5089 9.34068 15.9741C9.34068 21.4392 13.7939 25.8642 19.2939 25.8642C24.794 25.8642 29.2472 21.4392 29.2472 15.9741ZM25.5749 15.9575C25.5749 19.3918 22.7668 22.1822 19.3105 22.1822C15.8543 22.1822 13.0628 19.3918 13.0461 15.9575C13.0461 12.5233 15.8543 9.73289 19.3105 9.73289C22.7668 9.73289 25.5749 12.5233 25.5749 15.9575Z",
    fill: "currentColor"
}));


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Foundations/BrandLogo/icons/Sprig.mjs

const SprigLogo = /* @__PURE__ */ /*#__PURE__*/ react.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "90",
    height: "51",
    viewBox: "0 0 90 51",
    fill: "none"
}, /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M24.4297 43.9801C24.8075 43.9801 25.5423 43.9801 26.0934 44.4062C26.492 44.7106 26.7265 45.2377 26.7265 45.8063C26.7265 46.6792 26.1442 47.0341 25.9605 47.1351C26.41 47.2064 26.6745 47.3993 26.849 47.5613C27.2568 47.9472 27.3389 48.4744 27.3389 48.8293C27.3389 49.2255 27.2268 49.7837 26.7566 50.1995C26.2459 50.6462 25.6232 50.7473 25.0316 50.7473H22.7452V43.9789H24.4297V43.9801ZM24.0727 46.7906H24.4505C24.655 46.7906 25.4811 46.7699 25.4811 45.9074C25.4811 45.2883 25.0016 45.0551 24.4609 45.0551H24.0727V46.7906ZM24.0727 49.6723H24.6446C24.8895 49.6723 25.2569 49.6619 25.5527 49.4897C25.8797 49.2967 25.9709 48.9717 25.9709 48.7087C25.9709 48.495 25.8993 48.1298 25.4707 47.938C25.1853 47.8059 24.8479 47.8059 24.5626 47.8059H24.0727V49.6734V49.6723Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M29.0846 47.6531L26.7473 43.9801H28.3197L29.7789 46.3346L31.2381 43.9801H32.8106L30.4121 47.6531V50.7485H29.0857V47.6531H29.0846Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M10.8556 17.304C6.13833 16.5551 5.24988 15.5019 5.03152 13.508C4.77619 11.1776 6.6178 8.54862 10.2225 8.5693C14.2569 8.59227 15.0622 11.1547 15.8582 14.1501H19.1117L19.077 13.9675C19.0597 13.8721 19.0389 13.7779 19.0135 13.6849C18.0869 10.1589 16.1656 7.09686 10.2721 7.04058C5.45437 6.99464 1.33558 9.73392 1.33558 13.6252C1.33558 17.2167 3.64742 19.7607 9.58241 20.6773C13.5556 21.2906 16.2037 22.2496 16.2071 24.9717C16.2106 27.5157 14.6867 29.7335 10.4859 29.6796C5.34461 29.6129 4.3152 26.335 3.5261 23.2282H0C0 23.2282 0.0196408 23.335 0.0820293 23.6015C1.1357 28.3404 4.51277 31.384 10.4362 31.384C15.8062 31.384 19.8026 28.5907 19.8026 24.5502C19.8026 20.8082 17.2781 18.3503 10.8556 17.3028V17.304Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M35.0635 7.09801C34.9456 7.09801 34.8289 7.10031 34.7146 7.1049C32.2456 7.17841 30.3636 8.03752 28.9783 9.42381C26.9807 11.2224 26.1847 13.4081 26.1847 13.4081V7.64816H22.7233V38.4682H26.1847V24.9602C26.1847 24.9602 27.0627 27.4801 29.4104 29.3637C30.761 30.5077 32.5009 31.2324 34.6152 31.3633C34.6626 31.3668 34.7099 31.3691 34.7573 31.3714C34.8174 31.3748 34.8775 31.3771 34.9375 31.3794C35.0623 31.384 35.1871 31.3863 35.3142 31.3863C41.0331 31.3863 44.4945 27.0976 44.4945 19.268C44.4945 11.4384 41.1833 7.09916 35.0635 7.09916V7.09801ZM33.8596 28.3427C29.1943 28.3427 26.1847 25.0015 26.1847 20.1639V18.4181C26.1847 13.3817 29.1943 10.2393 33.8596 10.2393C38.5249 10.2393 41.0331 13.1313 41.0331 19.2657C41.0331 25.4001 38.6751 28.3415 33.8596 28.3415V28.3427Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M50.8004 13.2496V7.64701H47.4395V30.8361H50.9009V18.9165C50.9009 13.3312 53.2081 11.1363 58.3748 11.1363H59.4782V7.39663H58.525C52.4791 7.39663 50.7992 13.2485 50.7992 13.2485L50.8004 13.2496Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M82.9767 27.2458C80.3679 27.2458 77.5593 27.2952 74.8997 27.2952C73.2441 27.2952 72.3418 26.8966 72.3418 25.8492C72.3418 25.2508 72.6421 24.8017 73.0939 24.1539L73.9465 22.9066C75.1007 23.2557 76.4051 23.4051 77.8597 23.4051C84.2811 23.4051 87.5923 20.8622 87.5923 16.3231C87.5923 11.7841 82.0489 10.1887 82.0489 10.1887C84.206 10.3886 85.2342 10.4874 86.4889 10.4874H89.3484V7.64472H78.2617C72.0414 7.64472 68.3789 10.438 68.3789 15.7236C68.3789 19.005 70.023 21.4927 73.1285 22.6436C73.2325 22.6826 69.4823 24.5949 69.4823 26.7944C69.4823 28.3415 70.4585 29.2282 71.8265 29.66C71.8265 29.66 66.9244 30.626 66.9244 34.1256C66.9244 37.2175 69.5331 39.1619 78.2617 39.1619C86.9903 39.1619 90 37.1175 90 32.6784C90 29.2374 87.5414 27.2423 82.9767 27.2423V27.2458ZM71.5896 15.6765C71.5896 12.5341 73.4959 10.5402 77.8597 10.5402C82.2234 10.5402 84.4821 12.4847 84.4821 15.6765C84.4821 18.8683 82.4753 20.7634 77.9105 20.7634C73.3457 20.7634 71.5896 18.9177 71.5896 15.6765ZM78.3622 36.4227C71.741 36.4227 69.8843 35.4751 69.8843 33.1815C69.8843 31.6849 71.2384 29.9403 74.4491 29.9403H83.0275C85.8373 29.9403 87.0412 31.1876 87.0412 32.7829C87.0412 35.1765 85.4364 36.4238 78.3622 36.4238V36.4227Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M65.2341 7.64701H61.8224V30.8361H65.2341V7.64701Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M65.2341 0H61.8224V3.82351H65.2341V0Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M53.5617 50.7772V43.9364H55.4414V49.0291H57.5534V50.7772H53.5617Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M47.4326 50.7772V43.9364H49.3135V46.3358H51.2105V43.9364H53.0914V50.7772H51.2105V48.2332H49.3135V50.7772H47.4326Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M41.0424 43.9376L38.325 47.1949L41.4294 50.7806L38.9408 50.7783L36.8312 48.3388H36.8277V50.7772H34.9468V43.9364H36.8277V45.9855L36.8127 45.9877L38.6035 43.9376H41.0424Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M40.0234 47.3005C40.0234 45.3319 41.612 43.7366 43.5714 43.7366C45.5309 43.7366 47.1195 45.3319 47.1195 47.3005C47.1195 49.2691 45.5309 50.8645 43.5714 50.8645C41.612 50.8645 40.0234 49.2691 40.0234 47.3005ZM43.5714 49.0544C44.4541 49.0544 45.1681 48.2688 45.1681 47.2994C45.1681 46.33 44.4529 45.5444 43.5714 45.5444C42.6899 45.5444 41.9736 46.33 41.9736 47.2994C41.9736 48.2688 42.6887 49.0544 43.5714 49.0544Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M61.7577 43.9364V45.5123L59.8698 45.5168L59.8629 46.5965H61.6075V48.1275H59.8652L59.8664 49.1715H61.7738V50.7772H57.9393V43.9364H61.7577Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M65.6685 48.0436L67.6256 50.7818L65.5714 50.7783L64.0372 48.6776V50.7737H62.1944V43.9342H64.5524C66.6263 43.9342 67.9434 46.5218 65.6673 48.0436H65.6685ZM64.564 46.8388C64.9302 46.8388 65.2272 46.5436 65.2272 46.1796C65.2272 45.8155 64.9302 45.5203 64.564 45.5203H64.0314V46.8365H64.564V46.8388Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M67.8521 50.3832C67.8521 50.0387 68.1259 49.763 68.4725 49.763C68.8191 49.763 69.0929 50.0387 69.0929 50.3832C69.0929 50.7278 68.8168 51 68.4725 51C68.1282 51 67.8521 50.7243 67.8521 50.3832ZM68.945 50.3832C68.945 50.1064 68.7382 49.91 68.4725 49.91C68.2068 49.91 68 50.1064 68 50.3832C68 50.66 68.2022 50.853 68.4725 50.853C68.7429 50.853 68.945 50.6566 68.945 50.3832ZM68.7694 50.6968H68.6123L68.4679 50.4257H68.3674V50.6968H68.223V50.0547H68.5361C68.6851 50.0547 68.7868 50.0812 68.7868 50.2511C68.7868 50.3694 68.7255 50.4177 68.6112 50.4257L68.7683 50.6968H68.7694ZM68.5407 50.3293C68.6123 50.3293 68.6539 50.3143 68.6539 50.2328C68.6539 50.1673 68.5707 50.1673 68.5083 50.1673H68.3685V50.3293H68.5407Z",
    fill: "currentColor"
}));


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Foundations/BrandLogo/icons/Sterling.mjs

const SterlingLogo = /* @__PURE__ */ /*#__PURE__*/ react.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "120",
    height: "15",
    viewBox: "0 0 120 15",
    fill: "none"
}, /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M11.5161 3.1635C10.4365 2.38491 8.74294 1.92197 7.19758 1.92197C5.63105 1.92197 3.64113 2.36387 3.64113 3.71062C3.64113 4.95613 5.66903 5.6167 7.84937 6.32692C10.3842 7.15261 13.125 8.04541 13.125 10.0025C13.125 12.1068 10.0343 14.0638 5.7369 14.0638C4.06452 14.0638 2.37097 13.8954 0.804435 13.4745L0 11.0125C1.63004 12.0226 3.87399 12.6328 6.03327 12.6328C7.5998 12.6328 9.97077 11.9595 9.97077 10.5917C9.97077 9.1723 7.94657 8.52545 5.7685 7.82942C3.23204 7.01886 0.486895 6.14162 0.486895 3.9C0.486895 1.41693 4.04335 0.470001 7.40927 0.470001C8.78528 0.470001 10.1825 0.617302 11.5161 0.911903V3.1635Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M74.4275 3.45729C74.4472 2.55076 74.4733 1.34737 73.125 1.00278V0.938751H78.75V1.00278C77.4098 1.35056 77.4323 2.59048 77.4486 3.48724C77.4503 3.58099 77.4519 3.67099 77.4519 3.75582V11.268C77.4519 11.3527 77.4503 11.4424 77.4486 11.5357C77.4323 12.4291 77.4101 13.652 78.75 13.9997V14.0638H73.125V13.9997C74.4651 13.6713 74.4427 12.4332 74.4264 11.5366C74.4247 11.4429 74.4231 11.3529 74.4231 11.268V3.75582C74.4231 3.66161 74.4253 3.56102 74.4275 3.45729Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M22.257 11.5366L22.257 2.50025H24.7536C25.6711 2.50025 26.7807 2.58465 27.1434 3.28099H27.2288L28.125 0.938751H28.0396C27.6769 1.06536 27.2288 1.08646 26.7594 1.08646H15.7062C15.6069 1.07418 15.5058 1.06548 15.4039 1.05671C15.1556 1.03533 14.9027 1.01356 14.6607 0.938751H14.5753L13.5938 3.28099H13.6791C14.554 2.71126 15.7916 2.50025 16.9865 2.50025H19.4191V11.2995C19.4191 11.3835 19.4206 11.4725 19.4222 11.565C19.4374 12.4483 19.4583 13.6566 18.2028 14.0004V14.0638H23.708V14.0004C22.2565 13.3972 22.2567 12.6298 22.257 11.5366Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M33.8732 12.4125L37.2192 12.6454C38.9632 12.7724 40.7883 12.349 42.1064 11.4811H42.1875L40.9911 14.0638H30V14.0002C31.2258 13.6706 31.2099 12.4176 31.1985 11.5261C31.1974 11.4445 31.1964 11.3651 31.1964 11.2906V3.83895C31.1964 3.7545 31.1978 3.6655 31.1993 3.5732C31.2135 2.6707 31.2326 1.45378 30 1.10811V1.0446H38.4359C38.5177 1.0446 38.5994 1.04602 38.6805 1.04743C39.0421 1.05372 39.3914 1.05979 39.6729 0.938751H39.7541V3.24621H39.6729C38.8618 2.52645 37.7667 2.46294 36.55 2.46294C35.6172 2.46294 34.7047 2.48411 33.853 2.61113V6.31577H36.9962C37.422 6.31577 37.8479 6.31577 38.152 6.18875H38.2332V8.28452H38.152C37.7407 7.73247 36.7052 7.73336 35.8858 7.73406L33.853 7.73411L33.8732 12.4125Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M54.9929 4.16131C54.9929 2.34729 52.9688 0.960093 49.2614 0.960093L42.6562 0.938751V1.00278C43.9177 1.34737 43.8933 2.55062 43.8749 3.45715C43.8728 3.5612 43.8707 3.66134 43.8707 3.75582V11.268C43.8707 11.3599 43.8728 11.4578 43.8749 11.56C43.8933 12.4546 43.9184 13.6741 42.6562 13.9997V14.0638H47.9403V13.9997C46.6453 13.6706 46.6654 12.4458 46.6802 11.5361C46.6818 11.4431 46.6832 11.3532 46.6832 11.268V2.32595C47.3011 2.26192 47.919 2.1979 48.5582 2.17656C50.4119 2.13387 52.1378 2.96619 52.1378 4.39607C52.1378 6.27412 49.5597 7.02107 47.3438 7.25582L49.9432 10.0302L53.2884 13.0607C54.1193 13.8077 55.0355 14.0638 56.5057 14.0638H59.0625C57.4858 13.3381 55.7386 12.3138 54.5668 11.268L50.5824 7.66131C52.8622 7.29851 54.9929 5.91131 54.9929 4.16131Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M66.9893 12.6339C68.7679 12.7192 70.3242 12.2497 71.6379 11.4174H71.7188L70.3444 14.0638H59.5312V13.9997C60.753 13.6674 60.7371 12.4042 60.7258 11.5054C60.7247 11.4229 60.7237 11.3434 60.7237 11.268V3.75582C60.7237 3.67064 60.7251 3.58086 60.7266 3.48776C60.7407 2.57792 60.7597 1.35126 59.5312 1.00278V0.938751H64.5639V1.00278C63.3666 1.34755 63.3905 2.56909 63.4079 3.46389C63.4099 3.56606 63.4118 3.66397 63.4118 3.75582V12.4418L66.9893 12.6339Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M84.8946 11.3964L84.8946 3.72073L94.0683 12.2774C95.2407 13.4155 96.084 14.0688 97.9763 14.5325V3.4889C97.9763 2.37189 97.9763 1.59209 99.375 1.00198V0.938751H94.6648V1.00198C96.0639 1.58375 96.0637 2.37036 96.0635 3.44259L96.0634 10.9497L86.2727 1.845L85.9025 1.44457C85.6968 1.29704 85.594 1.19166 85.4911 0.959827V0.938751H81.5831V1.00198C82.9817 1.59209 82.9817 2.39297 82.9817 3.4889V11.3501C82.9817 12.4671 82.9817 13.2469 81.5625 13.8581V13.9213H86.2933V13.8581C84.8941 13.2555 84.8943 12.4686 84.8946 11.3964Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M115.084 3.10445C113.991 2.1982 111.949 1.92422 110.299 1.92422C106.113 1.92422 102.917 3.9264 102.917 7.10881C102.917 10.2701 106.361 12.6728 110.588 12.6728C111.826 12.6728 113.104 12.5463 114.321 12.2934V9.4482C114.321 8.54195 114.3 7.57247 113.084 7.21419V7.15096H117.188V7.21419C117.043 7.44602 117.043 7.76215 117.043 8.05721V12.5885C117.043 12.6178 117.043 12.6474 117.043 12.6771C117.041 12.946 117.039 13.2269 117.188 13.4736L117.069 13.4899C114.965 13.7794 112.899 14.0638 110.774 14.0638C103.906 14.0638 99.8438 11.3028 99.8438 7.34064C99.8438 3.10445 104.422 0.470001 110.918 0.470001C112.341 0.470001 113.743 0.596455 115.125 0.807211L115.166 3.10445H115.084Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.723 13.1874H118.887V12.7798H119.011C119.135 12.7798 119.217 12.8206 119.238 12.9632C119.258 13.1059 119.3 13.1874 119.32 13.2282H119.506C119.485 13.1874 119.464 13.1263 119.444 12.9632C119.423 12.8002 119.361 12.7186 119.258 12.6983C119.361 12.6575 119.464 12.576 119.464 12.4333C119.464 12.3314 119.423 12.2499 119.361 12.2091C119.3 12.1684 119.196 12.1276 119.032 12.1276C118.887 12.1276 118.805 12.1276 118.723 12.148V13.1874ZM119.011 12.6167H118.887V12.2499H119.011C119.196 12.2499 119.258 12.3314 119.258 12.4333C119.258 12.576 119.155 12.6167 119.011 12.6167Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120 12.6575C120 12.1276 119.588 11.72 119.073 11.72C118.537 11.72 118.125 12.1276 118.125 12.6575C118.125 13.1874 118.558 13.595 119.073 13.595C119.588 13.595 120 13.1874 120 12.6575ZM118.31 12.6575C118.31 12.2091 118.661 11.8627 119.073 11.8627C119.485 11.8627 119.835 12.2091 119.835 12.6575C119.835 13.1059 119.485 13.4523 119.073 13.4523C118.661 13.4523 118.31 13.1059 118.31 12.6575Z",
    fill: "currentColor"
}));


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Foundations/BrandLogo/icons/StudioKohlerLarge.mjs

const StudioKohlerLargeLogo = /* @__PURE__ */ /*#__PURE__*/ react.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "173",
    height: "22",
    viewBox: "0 0 173 22",
    fill: "none"
}, /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.635 0.35C95.1038 0.35 90.6338 4.9736 90.6338 10.6586C90.6338 16.3557 95.1158 20.9671 100.642 20.9671C106.169 20.9671 110.643 16.3394 110.643 10.6504C110.639 4.95734 106.157 0.35 100.635 0.35ZM105.14 10.6463C105.14 13.4522 103.122 15.7254 100.638 15.7254C98.158 15.7294 96.1363 13.4603 96.1363 10.6504C96.1323 7.85264 98.154 5.57947 100.634 5.57947C103.126 5.5754 105.14 7.84857 105.14 10.6463Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M1.85996 14.2167C1.77623 18.2913 4.63528 19.5397 8.19613 19.5397C10.2338 19.5397 13.336 18.4011 13.336 15.518C13.336 13.2733 11.1589 12.3827 9.34055 11.9395L5.01808 10.8578C2.73323 10.2763 0.639782 9.19458 0.639782 6.08778C0.639782 4.14806 1.86395 0.512618 7.33084 0.512618C11.1908 0.512618 14.5084 2.59059 14.5084 6.66929H12.6582C12.5226 3.67228 10.1301 2.12295 7.35476 2.12295C4.82668 2.12295 2.486 3.12331 2.486 6.05931C2.486 7.9177 3.81783 8.72286 5.42082 9.08072L10.154 10.2722C12.9014 11.0204 15.1862 12.2688 15.1862 15.4854C15.1862 16.8436 14.6439 21.1419 7.76149 21.1419C3.16787 21.1419 -0.205571 19.0355 0.00975459 14.2086H1.85996V14.2167Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M20.4615 6.42532H23.3166V7.89332H20.4615V17.5431C20.4615 18.6817 20.625 19.3446 21.8492 19.43C22.3396 19.43 22.8301 19.4015 23.3166 19.3446V20.841C23.0574 20.841 22.8062 20.8553 22.555 20.8695C22.3038 20.8837 22.0525 20.898 21.7933 20.898C19.5085 20.898 18.719 20.1213 18.7469 17.6814V7.89332H16.2985V6.42532H18.7469V2.12703H20.4615V6.42532Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M34.9763 20.7353H36.5554V6.4253H34.8407V13.9361C34.8407 16.8477 33.5647 19.678 30.6259 19.678C27.9064 19.678 26.9534 18.3198 26.8737 15.7416V6.4253H25.159V15.7172C25.159 19.0762 26.5188 21.1541 30.0796 21.1541C32.1731 21.1541 34.0233 20.0724 34.9205 18.1571H34.9763V20.7353Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.4147 20.7353H50.9938V0.935533H49.2791V9.14578H49.2233C48.5135 7.0922 46.4201 6.01051 44.3545 6.01051C40.0839 6.01051 38.0463 9.50363 38.0463 13.5823C38.0463 17.661 40.0839 21.1541 44.3545 21.1541C46.3962 21.1541 48.6252 19.9057 49.3589 18.0189H49.4147V20.7353ZM49.2788 13.5783C49.2788 16.5428 47.9749 19.678 44.3582 19.678C41.0964 19.678 39.7646 16.5428 39.7646 13.5783C39.7646 10.6138 41.0964 7.47857 44.3582 7.47857C47.9749 7.47857 49.2788 10.6138 49.2788 13.5783Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M53.6861 0.935533H55.4007V3.73735H53.6861V0.935533Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M53.6861 6.4253H55.4007V20.7353H53.6861V6.4253Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.0174 21.1501C68.288 21.1501 70.6526 17.6813 70.6526 13.5783C70.6526 9.47517 68.288 6.00645 64.0174 6.00645C59.7468 6.00645 57.3822 9.4711 57.3822 13.5783C57.3822 17.6854 59.7468 21.1501 64.0174 21.1501ZM64.0177 19.6779C60.7559 19.6779 59.0971 16.5996 59.0971 13.5782C59.0971 10.5568 60.7559 7.47846 64.0177 7.47846C67.2795 7.47846 68.9383 10.5568 68.9383 13.5782C68.9383 16.5996 67.2795 19.6779 64.0177 19.6779Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M128.787 0.919272L128.795 20.6987L140.048 20.6946V15.6359H134.102L134.094 0.915205L128.787 0.919272Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M111.528 20.7069L111.512 0.927442L116.816 0.923376L116.82 7.86488L122.163 7.85674L122.159 0.923376L127.463 0.919309L127.471 20.6987H122.171V13.3424L116.82 13.3506L116.828 20.7028L111.528 20.7069Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M85.8488 10.3658L93.5008 0.939642H86.6303L81.622 6.82175V0.939642L76.3226 0.943708L76.3306 20.7231H81.626L81.622 13.6718H81.634L87.5873 20.7231H94.6054L85.8488 10.3658Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M151.89 0.903043L146.443 0.915243H141.128L141.14 20.6947L151.95 20.6865L151.942 16.0426L146.567 16.0467V13.0334L151.475 13.0212L151.471 8.60091H146.551L146.575 5.47785L151.89 5.46158V0.903043Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.442 20.6865L162.92 12.7731C169.331 8.36505 165.619 0.886771 159.769 0.894904L153.126 0.89897L153.138 20.6743L158.326 20.6703V14.6112L162.644 20.6865H168.442ZM161.676 7.38502C161.676 8.43825 160.834 9.29221 159.806 9.29221L158.302 9.28814V5.48597L159.798 5.48191C160.834 5.48191 161.676 6.3318 161.676 7.38502Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.621 20.7475H171.979L171.337 19.7512C171.712 19.739 172.011 19.5845 172.011 19.1534C172.011 18.6858 171.637 18.5801 171.258 18.5801H170.325L170.329 20.7475H170.624V19.7472H170.983L171.621 20.7475ZM171.078 19.4476C171.349 19.453 171.712 19.4603 171.712 19.1494C171.708 18.9258 171.421 18.8892 171.189 18.8892H170.623V19.4422C170.623 19.4463 170.982 19.4463 170.982 19.4463C171.012 19.4463 171.045 19.4469 171.078 19.4476Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.1 19.678C169.1 18.5719 169.962 17.6977 171.05 17.6977C172.139 17.6977 173 18.5719 173 19.674C173.004 20.776 172.143 21.6543 171.054 21.6543C169.962 21.6543 169.1 20.7841 169.1 19.678ZM172.701 19.674C172.701 18.7468 171.935 18.0026 171.054 18.0026C170.165 18.0026 169.407 18.7468 169.407 19.678C169.407 20.6093 170.165 21.3494 171.062 21.3494C171.943 21.3453 172.701 20.6052 172.701 19.674Z",
    fill: "currentColor"
}));


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Foundations/BrandLogo/icons/StudioKohlerSmall.mjs

const StudioKohlerSmallLogo = /* @__PURE__ */ /*#__PURE__*/ react.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "120",
    height: "15",
    viewBox: "0 0 120 15",
    fill: "none"
}, /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.8043 0.389999C65.968 0.389999 62.8674 3.4753 62.8674 7.26884C62.8674 11.0705 65.9763 14.1477 69.8098 14.1477C73.6434 14.1477 76.7467 11.0597 76.7467 7.26341C76.7439 3.46445 73.6351 0.389999 69.8043 0.389999ZM72.9296 7.26067C72.9296 9.13302 71.53 10.6499 69.8068 10.6499C68.0864 10.6526 66.6841 9.13844 66.6841 7.26338C66.6814 5.39647 68.0837 3.87959 69.8041 3.87959C71.5328 3.87688 72.9296 5.39375 72.9296 7.26067Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M1.29015 9.64316C1.23206 12.3621 3.21522 13.1952 5.68518 13.1952C7.09856 13.1952 9.25043 12.4354 9.25043 10.5115C9.25043 9.01362 7.74025 8.41935 6.47899 8.12357L3.48075 7.40177C1.89588 7.01374 0.44378 6.29193 0.44378 4.21878C0.44378 2.92442 1.29291 0.498513 5.08497 0.498513C7.76237 0.498513 10.0636 1.88513 10.0636 4.60682H8.78023C8.68619 2.60694 7.02664 1.57308 5.10157 1.57308C3.34798 1.57308 1.7244 2.24061 1.7244 4.19979C1.7244 5.43988 2.64821 5.97716 3.7601 6.21595L7.04324 7.01102C8.94895 7.51031 10.5338 8.34337 10.5338 10.4898C10.5338 11.3961 10.1576 14.2643 5.38369 14.2643C2.19737 14.2643 -0.142593 12.8587 0.00676619 9.63773H1.29015V9.64316Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M14.193 4.44402H16.1734V5.42361H14.193V11.8629C14.193 12.6226 14.3064 13.065 15.1555 13.1219C15.4957 13.1219 15.8359 13.1029 16.1734 13.065V14.0635C15.9936 14.0635 15.8193 14.073 15.6451 14.0825C15.4708 14.092 15.2966 14.1015 15.1168 14.1015C13.5319 14.1015 12.9843 13.5832 13.0036 11.9551V5.42361H11.3054V4.44402H13.0036V1.5758H14.193V4.44402Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M24.261 13.993H25.3563V4.44401H24.167V9.45593C24.167 11.3988 23.2819 13.2875 21.2434 13.2875C19.3571 13.2875 18.696 12.3811 18.6407 10.6607V4.44401H17.4514V10.6445C17.4514 12.8858 18.3945 14.2725 20.8645 14.2725C22.3166 14.2725 23.6 13.5507 24.2223 12.2726H24.261V13.993Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.2761 13.993H35.3714V0.780721H34.1821V6.25937H34.1433C33.651 4.88903 32.1989 4.16723 30.7662 4.16723C27.8039 4.16723 26.3905 6.49816 26.3905 9.21985C26.3905 11.9415 27.8039 14.2725 30.7662 14.2725C32.1823 14.2725 33.7285 13.4394 34.2374 12.1803H34.2761V13.993ZM34.1818 9.21717C34.1818 11.1953 33.2774 13.2875 30.7687 13.2875C28.5062 13.2875 27.5824 11.1953 27.5824 9.21717C27.5824 7.239 28.5062 5.14685 30.7687 5.14685C33.2774 5.14685 34.1818 7.239 34.1818 9.21717Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M37.2389 0.780721H38.4283V2.65035H37.2389V0.780721Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M37.2389 4.44401H38.4283V13.993H37.2389V4.44401Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.4051 14.2698C47.3674 14.2698 49.0076 11.9551 49.0076 9.21713C49.0076 6.47917 47.3674 4.16451 44.4051 4.16451C41.4428 4.16451 39.8027 6.47645 39.8027 9.21713C39.8027 11.9578 41.4428 14.2698 44.4051 14.2698ZM44.4053 13.2874C42.1428 13.2874 40.9922 11.2333 40.9922 9.2171C40.9922 7.20093 42.1428 5.14678 44.4053 5.14678C46.6678 5.14678 47.8185 7.20093 47.8185 9.2171C47.8185 11.2333 46.6678 13.2874 44.4053 13.2874Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M89.3319 0.769871L89.3374 13.9686L97.1428 13.9658V10.5902H93.0188L93.0133 0.767157L89.3319 0.769871Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M77.3607 13.974L77.3497 0.775323L81.0283 0.772609L81.0311 5.40463L84.7374 5.3992L84.7347 0.772609L88.4133 0.769896L88.4189 13.9686H84.743V9.05978L81.0311 9.0652L81.0366 13.9713L77.3607 13.974Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M59.5483 7.07346L64.8561 0.783463H60.0904L56.6164 4.70856V0.783463L52.9405 0.786177L52.9461 13.9849H56.6192L56.6164 9.27957H56.6247L60.7542 13.9849H65.6222L59.5483 7.07346Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    d: "M105.357 0.759042L101.579 0.767182H97.8921L97.9004 13.9659L105.399 13.9604L105.393 10.8616L101.665 10.8643V8.85355L105.07 8.84541L105.067 5.89578H101.654L101.67 3.81178L105.357 3.80093V0.759042Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.839 13.9604L113.008 8.67988C117.455 5.73839 114.88 0.748183 110.823 0.75361L106.215 0.756324L106.223 13.9523L109.821 13.9496V9.9064L112.817 13.9604H116.839ZM112.145 5.08443C112.145 5.78724 111.561 6.35708 110.848 6.35708L109.805 6.35437V3.8172L110.842 3.81449C111.561 3.81449 112.145 4.38162 112.145 5.08443Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.043 14.0011H119.292L118.847 13.3363C119.107 13.3282 119.314 13.2251 119.314 12.9374C119.314 12.6254 119.054 12.5548 118.791 12.5548H118.144L118.147 14.0011H118.352V13.3336H118.601L119.043 14.0011ZM118.667 13.1337C118.855 13.1373 119.106 13.1422 119.106 12.9347C119.104 12.7855 118.905 12.7611 118.744 12.7611H118.351V13.1301C118.351 13.1328 118.6 13.1328 118.6 13.1328C118.621 13.1328 118.644 13.1333 118.667 13.1337Z",
    fill: "currentColor"
}), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.295 13.2875C117.295 12.5494 117.892 11.966 118.647 11.966C119.403 11.966 120 12.5494 120 13.2848C120.003 14.0201 119.405 14.6063 118.65 14.6063C117.892 14.6063 117.295 14.0256 117.295 13.2875ZM119.793 13.2848C119.793 12.6661 119.261 12.1695 118.65 12.1695C118.033 12.1695 117.508 12.6661 117.508 13.2875C117.508 13.9089 118.033 14.4027 118.656 14.4027C119.267 14.4 119.793 13.9062 119.793 13.2848Z",
    fill: "currentColor"
}));


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Foundations/BrandLogo/BrandLogo.utils.mjs












const BrandLogoPath = {
    Kohler: KohlerLogo,
    "Kohler Bold": KohlerBoldLogo,
    "Studio Kohler Large": StudioKohlerLargeLogo,
    "Studio Kohler Small": StudioKohlerSmallLogo,
    "Ann Sacks": AnnSacksLogo,
    Sterling: SterlingLogo,
    Kallista: KallistaLogo,
    Robern: RobernLogo,
    Mira: MiraLogo,
    Sprig: SprigLogo,
    Klafs: KlafsLogo,
    "Klafs Sauna and Spa": KlafsSaunaAndSpaLogo
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Foundations/BrandLogo/BrandLogo.mjs




const BrandLogo = (param)=>{
    let { brand , className , ...rest } = param;
    const classNames = (0,clsx/* default */.Z)(BrandLogo_module_css_classes.root, "kohler-brand-logo-root", className);
    const LogoSvg = BrandLogoPath[brand];
    if (!LogoSvg) {
        console.error("Brand logo not found for brand: ".concat(brand));
        return null;
    }
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(LogoSvg.type, {
        ...LogoSvg.props,
        className: classNames,
        ...rest
    });
};


// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Buttons/Link/Link.mjs + 2 modules
var Link = __webpack_require__(3171);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/utils/helpers.mjs
var helpers = __webpack_require__(37892);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Foundations/Typography/Typography.mjs + 2 modules
var Typography = __webpack_require__(72905);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/constants.mjs
var constants = __webpack_require__(94802);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/CartEmptyIcon.mjs


const withoutBoundingBoxWidth = {
    large: 34,
    medium: 25,
    small: 18,
    xSmall: 14
};
const CartEmptyIcon = (param)=>{
    let { size ="medium" , withBoundingBox =true , ...others } = param;
    let iconWidth, iconHeight;
    if (typeof size === "string") {
        iconWidth = withBoundingBox ? constants/* iconSize */.E[size] : withoutBoundingBoxWidth[size];
        iconHeight = constants/* iconSize */.E[size];
    } else {
        iconWidth = size;
        iconHeight = size;
    }
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: iconWidth,
        height: iconHeight,
        viewBox: "0 0 30 30",
        preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
        fill: "none",
        ...others
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.22998 5.79001H6.77605L7.24498 7.78801L26.5559 7.67627L23.2376 20.57H9.22391L5.98398 6.79001H2.22998V5.79001ZM25.263 8.68301L7.47998 8.78501L10.015 19.569H22.462L25.263 8.68301Z",
        fill: "currentColor"
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        d: "M11.27 22.97C11.27 23.5831 10.773 24.08 10.16 24.08C9.54694 24.08 9.04998 23.5831 9.04998 22.97C9.04998 22.357 9.54694 21.86 10.16 21.86C10.773 21.86 11.27 22.357 11.27 22.97Z",
        fill: "currentColor"
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        d: "M22.68 24.08C23.293 24.08 23.79 23.5831 23.79 22.97C23.79 22.357 23.293 21.86 22.68 21.86C22.0669 21.86 21.57 22.357 21.57 22.97C21.57 23.5831 22.0669 24.08 22.68 24.08Z",
        fill: "currentColor"
    }));
};
CartEmptyIcon.iconName = "CartEmptyIcon";


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/DataDisplay/CartBadge/CartBadge.module.css.mjs
var CartBadge_module_css_classes = {
    "cartBadgeRoot": "UEOHe",
    "cartLabelWrapper": "afrHu",
    "cartLabelWrapperLong": "GBKf9",
    "cartLabel": "we-zf"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/CartOneDigitIcon.mjs


const CartOneDigitIcon_withoutBoundingBoxWidth = {
    large: 34,
    medium: 25,
    small: 18,
    xSmall: 15
};
const CartOneDigitIcon = (param)=>{
    let { size ="medium" , withBoundingBox =true , ...others } = param;
    let iconWidth, iconHeight;
    if (typeof size === "string") {
        iconWidth = withBoundingBox ? constants/* iconSize */.E[size] : CartOneDigitIcon_withoutBoundingBoxWidth[size];
        iconHeight = constants/* iconSize */.E[size];
    } else {
        iconWidth = size;
        iconHeight = size;
    }
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: iconWidth,
        height: iconHeight,
        viewBox: "0 0 30 30",
        preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
        fill: "none",
        ...others
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        d: "M2.34009 5.84998H6.88616L10.129 19.6299H22.5529L25.6398 7.73624H26.666L23.3477 20.63H9.33401L6.09409 6.84998H2.34009V5.84998Z",
        fill: "currentColor"
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        d: "M11.3801 23.03C11.3801 23.643 10.8831 24.14 10.2701 24.14C9.65706 24.14 9.1601 23.643 9.1601 23.03C9.1601 22.4169 9.65706 21.92 10.2701 21.92C10.8831 21.92 11.3801 22.4169 11.3801 23.03Z",
        fill: "currentColor"
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        d: "M22.7901 24.14C23.4031 24.14 23.9001 23.643 23.9001 23.03C23.9001 22.4169 23.4031 21.92 22.7901 21.92C22.177 21.92 21.6801 22.4169 21.6801 23.03C21.6801 23.643 22.177 24.14 22.7901 24.14Z",
        fill: "currentColor"
    }));
};
CartOneDigitIcon.iconName = "CartOneDigitIcon";


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/CartTwoDigitIcon.mjs


const CartTwoDigitIcon_withoutBoundingBoxWidth = {
    large: 34,
    medium: 25,
    small: 17,
    xSmall: 14
};
const CartTwoDigitIcon = (param)=>{
    let { size ="medium" , withBoundingBox =true , ...others } = param;
    let iconWidth, iconHeight;
    if (typeof size === "string") {
        iconWidth = withBoundingBox ? constants/* iconSize */.E[size] : CartTwoDigitIcon_withoutBoundingBoxWidth[size];
        iconHeight = constants/* iconSize */.E[size];
    } else {
        iconWidth = size;
        iconHeight = size;
    }
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: iconWidth,
        height: iconHeight,
        viewBox: "0 0 30 30",
        preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
        fill: "none",
        ...others
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        d: "M3.55005 5.84998H8.09612L11.339 19.6299H23.7629L25.4246 13.24H26.4508L24.5577 20.63H10.544L7.30405 6.84998H3.55005V5.84998Z",
        fill: "currentColor"
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        d: "M12.5901 23.03C12.5901 23.643 12.0931 24.14 11.4801 24.14C10.867 24.14 10.3701 23.643 10.3701 23.03C10.3701 22.4169 10.867 21.92 11.4801 21.92C12.0931 21.92 12.5901 22.4169 12.5901 23.03Z",
        fill: "currentColor"
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        d: "M24 24.14C24.6131 24.14 25.11 23.643 25.11 23.03C25.11 22.4169 24.6131 21.92 24 21.92C23.387 21.92 22.89 22.4169 22.89 23.03C22.89 23.643 23.387 24.14 24 24.14Z",
        fill: "currentColor"
    }));
};
CartTwoDigitIcon.iconName = "CartTwoDigitIcon";


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/CartThreeDigitIcon.mjs


const CartThreeDigitIcon_withoutBoundingBoxWidth = {
    large: 34,
    medium: 26,
    small: 17,
    xSmall: 14
};
const CartThreeDigitIcon = (param)=>{
    let { size ="medium" , withBoundingBox =true , ...others } = param;
    let iconWidth, iconHeight;
    if (typeof size === "string") {
        iconWidth = withBoundingBox ? constants/* iconSize */.E[size] : CartThreeDigitIcon_withoutBoundingBoxWidth[size];
        iconHeight = constants/* iconSize */.E[size];
    } else {
        iconWidth = size;
        iconHeight = size;
    }
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: iconWidth,
        height: iconHeight,
        viewBox: "0 0 30 30",
        preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
        fill: "none",
        ...others
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        d: "M3.55005 5.84998H8.09612L11.339 19.6299H23.7629L25.4246 13.24H26.4508L24.5577 20.63H10.544L7.30405 6.84998H3.55005V5.84998Z",
        fill: "currentColor"
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        d: "M12.5901 23.03C12.5901 23.643 12.0931 24.14 11.4801 24.14C10.867 24.14 10.3701 23.643 10.3701 23.03C10.3701 22.4169 10.867 21.92 11.4801 21.92C12.0931 21.92 12.5901 22.4169 12.5901 23.03Z",
        fill: "currentColor"
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        d: "M24 24.14C24.6131 24.14 25.11 23.643 25.11 23.03C25.11 22.4169 24.6131 21.92 24 21.92C23.387 21.92 22.89 22.4169 22.89 23.03C22.89 23.643 23.387 24.14 24 24.14Z",
        fill: "currentColor"
    }));
};
CartThreeDigitIcon.iconName = "CartThreeDigitIcon";


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/CartEmptyBoldIcon.mjs


const CartEmptyBoldIcon_withoutBoundingBoxWidth = {
    large: 34,
    medium: 25,
    small: 18,
    xSmall: 14
};
const CartEmptyBoldIcon = (param)=>{
    let { size ="medium" , withBoundingBox =true , ...others } = param;
    let iconWidth, iconHeight;
    if (typeof size === "string") {
        iconWidth = withBoundingBox ? constants/* iconSize */.E[size] : CartEmptyBoldIcon_withoutBoundingBoxWidth[size];
        iconHeight = constants/* iconSize */.E[size];
    } else {
        iconWidth = size;
        iconHeight = size;
    }
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: iconWidth,
        height: iconHeight,
        viewBox: "0 0 30 30",
        preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
        fill: "none",
        ...others
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.97466 5.54004H1.98047V7.04004H5.78643L9.02636 20.82H23.4319L26.8794 7.42443L7.44332 7.53689L6.97466 5.54004ZM10.2135 19.319L7.79563 9.03324L24.9405 8.9349L22.2687 19.319H10.2135Z",
        fill: "currentColor"
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        d: "M10.1605 21.61C9.40936 21.61 8.80047 22.2189 8.80047 22.97C8.80047 23.7212 9.40936 24.33 10.1605 24.33C10.9116 24.33 11.5205 23.7212 11.5205 22.97C11.5205 22.2189 10.9116 21.61 10.1605 21.61Z",
        fill: "currentColor"
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        d: "M22.6805 21.61C21.9294 21.61 21.3205 22.2189 21.3205 22.97C21.3205 23.7212 21.9294 24.33 22.6805 24.33C23.4316 24.33 24.0405 23.7212 24.0405 22.97C24.0405 22.2189 23.4316 21.61 22.6805 21.61Z",
        fill: "currentColor"
    }));
};
CartEmptyBoldIcon.iconName = "CartEmptyBoldIcon";


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/CartOneDigitBoldIcon.mjs


const CartOneDigitBoldIcon_withoutBoundingBoxWidth = {
    large: 34,
    medium: 25,
    small: 18,
    xSmall: 15
};
const CartOneDigitBoldIcon = (param)=>{
    let { size ="medium" , withBoundingBox =true , ...others } = param;
    let iconWidth, iconHeight;
    if (typeof size === "string") {
        iconWidth = withBoundingBox ? constants/* iconSize */.E[size] : CartOneDigitBoldIcon_withoutBoundingBoxWidth[size];
        iconHeight = constants/* iconSize */.E[size];
    } else {
        iconWidth = size;
        iconHeight = size;
    }
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: iconWidth,
        height: iconHeight,
        viewBox: "0 0 30 30",
        preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
        fill: "none",
        ...others
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        d: "M2.82996 5.8501H7.37603L10.6189 19.63H23.0428L26.1297 7.73636H27.1559L23.8376 20.6301H9.82388L6.58396 6.8501H2.82996V5.8501Z",
        fill: "currentColor"
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        d: "M11.87 23.0301C11.87 23.6431 11.373 24.1401 10.76 24.1401C10.1469 24.1401 9.64996 23.6431 9.64996 23.0301C9.64996 22.4171 10.1469 21.9201 10.76 21.9201C11.373 21.9201 11.87 22.4171 11.87 23.0301Z",
        fill: "currentColor"
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        d: "M23.28 24.1401C23.893 24.1401 24.39 23.6431 24.39 23.0301C24.39 22.4171 23.893 21.9201 23.28 21.9201C22.6669 21.9201 22.17 22.4171 22.17 23.0301C22.17 23.6431 22.6669 24.1401 23.28 24.1401Z",
        fill: "currentColor"
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        d: "M2.82996 5.8501H7.37603L10.6189 19.63H23.0428L26.1297 7.73636H27.1559L23.8376 20.6301H9.82388L6.58396 6.8501H2.82996V5.8501Z",
        stroke: "currentColor",
        strokeWidth: "0.5"
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        d: "M11.87 23.0301C11.87 23.6431 11.373 24.1401 10.76 24.1401C10.1469 24.1401 9.64996 23.6431 9.64996 23.0301C9.64996 22.4171 10.1469 21.9201 10.76 21.9201C11.373 21.9201 11.87 22.4171 11.87 23.0301Z",
        stroke: "currentColor",
        strokeWidth: "0.5"
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        d: "M23.28 24.1401C23.893 24.1401 24.39 23.6431 24.39 23.0301C24.39 22.4171 23.893 21.9201 23.28 21.9201C22.6669 21.9201 22.17 22.4171 22.17 23.0301C22.17 23.6431 22.6669 24.1401 23.28 24.1401Z",
        stroke: "currentColor",
        strokeWidth: "0.5"
    }));
};
CartOneDigitBoldIcon.iconName = "CartOneDigitBoldIcon";


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/CartTwoDigitBoldIcon.mjs


const CartTwoDigitBoldIcon_withoutBoundingBoxWidth = {
    large: 34,
    medium: 23,
    small: 18,
    xSmall: 15
};
const CartTwoDigitBoldIcon = (param)=>{
    let { size ="medium" , withBoundingBox =true , ...others } = param;
    let iconWidth, iconHeight;
    if (typeof size === "string") {
        iconWidth = withBoundingBox ? constants/* iconSize */.E[size] : CartTwoDigitBoldIcon_withoutBoundingBoxWidth[size];
        iconHeight = constants/* iconSize */.E[size];
    } else {
        iconWidth = size;
        iconHeight = size;
    }
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: iconWidth,
        height: iconHeight,
        viewBox: "0 0 30 30",
        preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
        fill: "none",
        ...others
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        d: "M3.5 5.84998H8.04607L11.2889 19.6299H23.7128L25.3746 13.24H26.4008L24.5076 20.63H10.4939L7.254 6.84998H3.5V5.84998Z",
        fill: "currentColor"
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        d: "M12.54 23.03C12.54 23.643 12.043 24.14 11.43 24.14C10.817 24.14 10.32 23.643 10.32 23.03C10.32 22.4169 10.817 21.92 11.43 21.92C12.043 21.92 12.54 22.4169 12.54 23.03Z",
        fill: "currentColor"
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        d: "M23.95 24.14C24.563 24.14 25.06 23.643 25.06 23.03C25.06 22.4169 24.563 21.92 23.95 21.92C23.337 21.92 22.84 22.4169 22.84 23.03C22.84 23.643 23.337 24.14 23.95 24.14Z",
        fill: "currentColor"
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        d: "M3.5 5.84998H8.04607L11.2889 19.6299H23.7128L25.3746 13.24H26.4008L24.5076 20.63H10.4939L7.254 6.84998H3.5V5.84998Z",
        stroke: "currentColor",
        strokeWidth: "0.5"
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        d: "M12.54 23.03C12.54 23.643 12.043 24.14 11.43 24.14C10.817 24.14 10.32 23.643 10.32 23.03C10.32 22.4169 10.817 21.92 11.43 21.92C12.043 21.92 12.54 22.4169 12.54 23.03Z",
        stroke: "currentColor",
        strokeWidth: "0.5"
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        d: "M23.95 24.14C24.563 24.14 25.06 23.643 25.06 23.03C25.06 22.4169 24.563 21.92 23.95 21.92C23.337 21.92 22.84 22.4169 22.84 23.03C22.84 23.643 23.337 24.14 23.95 24.14Z",
        stroke: "currentColor",
        strokeWidth: "0.5"
    }));
};
CartTwoDigitBoldIcon.iconName = "CartTwoDigitBoldIcon";


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/CartThreeDigitBoldIcon.mjs


const CartThreeDigitBoldIcon_withoutBoundingBoxWidth = {
    large: 34,
    medium: 23,
    small: 18,
    xSmall: 15
};
const CartThreeDigitBoldIcon = (param)=>{
    let { size ="medium" , withBoundingBox =true , ...others } = param;
    let iconWidth, iconHeight;
    if (typeof size === "string") {
        iconWidth = withBoundingBox ? constants/* iconSize */.E[size] : CartThreeDigitBoldIcon_withoutBoundingBoxWidth[size];
        iconHeight = constants/* iconSize */.E[size];
    } else {
        iconWidth = size;
        iconHeight = size;
    }
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: iconWidth,
        height: iconHeight,
        viewBox: "0 0 30 30",
        preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
        fill: "none",
        ...others
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        d: "M3.5 5.84998H8.04607L11.2889 19.6299H23.7128L25.3746 13.24H26.4008L24.5076 20.63H10.4939L7.254 6.84998H3.5V5.84998Z",
        fill: "currentColor"
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        d: "M12.54 23.03C12.54 23.643 12.043 24.14 11.43 24.14C10.817 24.14 10.32 23.643 10.32 23.03C10.32 22.4169 10.817 21.92 11.43 21.92C12.043 21.92 12.54 22.4169 12.54 23.03Z",
        fill: "currentColor"
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        d: "M23.95 24.14C24.563 24.14 25.06 23.643 25.06 23.03C25.06 22.4169 24.563 21.92 23.95 21.92C23.337 21.92 22.84 22.4169 22.84 23.03C22.84 23.643 23.337 24.14 23.95 24.14Z",
        fill: "currentColor"
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        d: "M3.5 5.84998H8.04607L11.2889 19.6299H23.7128L25.3746 13.24H26.4008L24.5076 20.63H10.4939L7.254 6.84998H3.5V5.84998Z",
        stroke: "currentColor",
        strokeWidth: "0.5"
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        d: "M12.54 23.03C12.54 23.643 12.043 24.14 11.43 24.14C10.817 24.14 10.32 23.643 10.32 23.03C10.32 22.4169 10.817 21.92 11.43 21.92C12.043 21.92 12.54 22.4169 12.54 23.03Z",
        stroke: "currentColor",
        strokeWidth: "0.5"
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        d: "M23.95 24.14C24.563 24.14 25.06 23.643 25.06 23.03C25.06 22.4169 24.563 21.92 23.95 21.92C23.337 21.92 22.84 22.4169 22.84 23.03C22.84 23.643 23.337 24.14 23.95 24.14Z",
        stroke: "currentColor",
        strokeWidth: "0.5"
    }));
};
CartThreeDigitBoldIcon.iconName = "CartThreeDigitBoldIcon";


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/DataDisplay/CartBadge/CartBadge.utils.mjs

const iconMap = {
    default: {
        0: CartEmptyIcon,
        1: CartOneDigitIcon,
        2: CartTwoDigitIcon,
        3: CartThreeDigitIcon
    },
    bold: {
        0: CartEmptyBoldIcon,
        1: CartOneDigitBoldIcon,
        2: CartTwoDigitBoldIcon,
        3: CartThreeDigitBoldIcon
    }
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/DataDisplay/CartBadge/CartBadge.mjs









const CartBadge = (0,factory_utils/* polymorphicFactory */.bq)((props, ref)=>{
    const { component ="div" , className , digit , thickness ="default" , withBoundingBox =true , ...rest } = props;
    const digitString = digit === null || digit === void 0 ? void 0 : digit.toString();
    const classNames = (0,clsx/* default */.Z)("kohler-cart-badge-root", className, CartBadge_module_css_classes.cartBadgeRoot);
    const Icon = digitString && digitString !== "0" ? iconMap[thickness][digitString.length || 0] : CartEmptyIcon;
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        className: classNames,
        component,
        ref,
        ...rest
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Icon, {
        withBoundingBox
    }), digitString && digitString !== "0" && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        className: (0,clsx/* default */.Z)(CartBadge_module_css_classes.cartLabelWrapper, digitString.length > 2 && CartBadge_module_css_classes.cartLabelWrapperLong)
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        component: "span",
        size: "tag-s",
        className: CartBadge_module_css_classes.cartLabel
    }, digitString)));
});


// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/ArrowDownIcon.mjs
var ArrowDownIcon = __webpack_require__(62281);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/SearchIcon.mjs


const SearchIcon_withoutBoundingBoxWidth = {
    large: 24,
    medium: 18,
    small: 12,
    xSmall: 10
};
const SearchIcon = (param)=>{
    let { size ="medium" , withBoundingBox =true , ...others } = param;
    let iconWidth, iconHeight;
    if (typeof size === "string") {
        iconWidth = withBoundingBox ? constants/* iconSize */.E[size] : SearchIcon_withoutBoundingBoxWidth[size];
        iconHeight = constants/* iconSize */.E[size];
    } else {
        iconWidth = size;
        iconHeight = size;
    }
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: iconWidth,
        height: iconHeight,
        viewBox: "0 0 30 30",
        preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
        fill: "none",
        ...others
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.5312 6C9.37186 6 6 9.37186 6 13.5312C6 17.6906 9.37186 21.0625 13.5312 21.0625C15.431 21.0625 17.1665 20.3591 18.4914 19.1985L23.2558 23.9629L23.9629 23.2558L19.1985 18.4914C20.3591 17.1665 21.0625 15.431 21.0625 13.5312C21.0625 9.37186 17.6906 6 13.5312 6ZM13.5312 7C17.1384 7 20.0625 9.92414 20.0625 13.5312C20.0625 17.1384 17.1384 20.0625 13.5312 20.0625C9.92414 20.0625 7 17.1384 7 13.5312C7 9.92414 9.92414 7 13.5312 7Z",
        fill: "currentColor"
    }));
};
SearchIcon.iconName = "SearchIcon";


// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/MenuIcon.mjs
var MenuIcon = __webpack_require__(24665);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/subcomponents/NavigationItem/NavigationItem.module.css.mjs
var NavigationItem_module_css_classes = {
    "navigationItemUnselected": "A1V04",
    "navigationItemSelectedDefault": "_9rbKG",
    "navigationItemDefault": "-sVSh",
    "navigationItemUniversal": "XUpJy",
    "navigationItemSelectedUniversal": "jBeTl"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/subcomponents/NavigationItem/NavigationItem.mjs




const NavigationItem = (0,factory_utils/* polymorphicFactory */.bq)((props, ref)=>{
    const { component ="a" , text , isSelected =false , variant ="v2.1" , className , ...rest } = props;
    const isUniversal = variant === "universal";
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        component,
        ref,
        size: isSelected ? "navigation-selected" : "navigation-unselected",
        className: (0,clsx/* default */.Z)("kohler-navigation-item-root", NavigationItem_module_css_classes.navigationItem, !isSelected && NavigationItem_module_css_classes.navigationItemUnselected, isUniversal && NavigationItem_module_css_classes.navigationItemUniversal, !isSelected && !isUniversal && NavigationItem_module_css_classes.navigationItemDefault, isSelected && !isUniversal && NavigationItem_module_css_classes.navigationItemSelectedDefault, isSelected && isUniversal && NavigationItem_module_css_classes.navigationItemSelectedUniversal, className),
        ...rest
    }, text);
});


// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/CloseIcon.mjs
var CloseIcon = __webpack_require__(61599);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/ArrowLeftIcon.mjs


const ArrowLeftIcon_withoutBoundingBoxWidth = {
    large: 30,
    medium: 13,
    small: 9,
    xSmall: 8
};
const ArrowLeftIcon = (param)=>{
    let { size ="medium" , withBoundingBox =true , ...others } = param;
    let iconWidth, iconHeight;
    if (typeof size === "string") {
        iconWidth = withBoundingBox ? constants/* iconSize */.E[size] : ArrowLeftIcon_withoutBoundingBoxWidth[size];
        iconHeight = constants/* iconSize */.E[size];
    } else {
        iconWidth = size;
        iconHeight = size;
    }
    const renderIcon = ()=>{
        switch(size){
            case "large":
                return /* @__PURE__ */ /*#__PURE__*/ react.createElement("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: iconWidth,
                    height: iconHeight,
                    viewBox: "0 0 40 40",
                    preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
                    fill: "none",
                    ...others
                }, /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M29 5.73378L28.3455 5L11 20L28.3643 35L28.9812 34.2355L12.5537 20L29 5.73378Z",
                    fill: "currentColor"
                }));
            case "small":
            case "xSmall":
                return /* @__PURE__ */ /*#__PURE__*/ react.createElement("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: iconWidth,
                    height: iconHeight,
                    viewBox: "0 0 20 20",
                    preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
                    fill: "none",
                    ...others
                }, /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M14.533 17.135L13.849 17.8645L5.45996 9.99978L13.849 2.13501L14.533 2.86455L6.92202 9.99978L14.533 17.135Z",
                    fill: "white"
                }), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M14.533 17.135L13.849 17.8645L5.45996 9.99978L13.849 2.13501L14.533 2.86455L6.92202 9.99978L14.533 17.135Z",
                    fill: "currentColor"
                }));
            case "medium":
            default:
                return /* @__PURE__ */ /*#__PURE__*/ react.createElement("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: iconWidth,
                    height: iconHeight,
                    viewBox: "0 0 30 30",
                    preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
                    fill: "none",
                    ...others
                }, /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M21 4.75258L20.3415 4L8.00001 15L20.3604 26L20.9811 25.216L9.45275 15L21 4.75258Z",
                    fill: "currentColor"
                }));
        }
    };
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(react.Fragment, null, renderIcon());
};
ArrowLeftIcon.iconName = "ArrowLeftIcon";


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/ExternalLinkIcon.mjs


const ExternalLinkIcon_withoutBoundingBoxWidth = {
    large: 22,
    medium: 15,
    small: 15,
    xSmall: 13
};
const ExternalLinkIcon = (param)=>{
    let { size ="medium" , withBoundingBox =true , ...others } = param;
    let iconWidth, iconHeight;
    if (typeof size === "string") {
        iconWidth = withBoundingBox ? constants/* iconSize */.E[size] : ExternalLinkIcon_withoutBoundingBoxWidth[size];
        iconHeight = constants/* iconSize */.E[size];
    } else {
        iconWidth = size;
        iconHeight = size;
    }
    const renderIcon = ()=>{
        switch(size){
            case "xSmall":
            case "small":
                return /* @__PURE__ */ /*#__PURE__*/ react.createElement("svg", {
                    width: iconWidth,
                    height: iconHeight,
                    viewBox: "0 0 20 20",
                    fill: "none",
                    preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
                    ...others
                }, /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
                    d: "M17.5 2.4978V9.00231H16.5V4.20941L8.5 12.2094L7.79289 11.5023L15.7824 3.51282L11.0045 3.55614L10.9955 2.55618L17.5 2.4978Z",
                    fill: "currentColor"
                }), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
                    d: "M2.5 17.5023V2.49807L6.67089 2.55019L6.66244 3.55016L3.5 3.50531V16.5023H16.5V13.3356H17.5V17.5023H2.5Z",
                    fill: "currentColor"
                }));
            case "medium":
            case "large":
            default:
                return /* @__PURE__ */ /*#__PURE__*/ react.createElement("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: iconWidth,
                    height: iconHeight,
                    viewBox: "0 0 30 30",
                    preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
                    fill: "none",
                    ...others
                }, /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
                    d: "M22.5 7.49548V14H21.5V9.20709L13.5 17.2071L12.7929 16.5L20.7824 8.5105L16.0045 8.55382L15.9955 7.55386L22.5 7.49548Z",
                    fill: "currentColor"
                }), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
                    d: "M7.5 22.5V7.49575L11.6709 7.54788L11.6624 8.54784L8.5 8.50299V21.5H21.5V18.3333H22.5V22.5H7.5Z",
                    fill: "currentColor"
                }));
        }
    };
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(react.Fragment, null, renderIcon());
};
ExternalLinkIcon.iconName = "ExternalLinkIcon";


// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/ArrowDownBoldIcon.mjs
var ArrowDownBoldIcon = __webpack_require__(60068);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/ArrowRightBoldIcon.mjs
var ArrowRightBoldIcon = __webpack_require__(64260);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/subcomponents/OverlayMenuCategory/OverlayMenuCategory.module.css.mjs
var OverlayMenuCategory_module_css_classes = {
    "overlayMenuCategory": "muZTc",
    "overlayMenuCategoryCTA": "BREK-",
    "overlayMenuCategoryTitle": "Y8ip4",
    "overlayMenuCategoryOpen": "WFLCP",
    "overlayMenuCategoryLinks": "cfjcS",
    "overlayMenuCategoryLinksLink": "EosB-",
    "iconTransitionArrowClosed": "VxcqM",
    "iconTransitionArrowOpen": "-ECJU",
    "overlayMenuCategoryTitleLink": "bGfiv",
    "arrowDownIcon": "GiCqj"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/subcomponents/OverlayMenuCategory/OverlayMenuCategory.mjs





const OverlayMenuCategory = (0,factory_utils/* factory */.d5)((props, ref)=>{
    const { className , title , links , showArrow =true , isExternal , opened =false , onToggle , isCTA =false , ...rest } = props;
    const isOpen = opened;
    const hasNoLinks = !links || links.length === 0;
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        ref,
        className: (0,clsx/* default */.Z)(className, "kohler-overlay-menu-category-root", OverlayMenuCategory_module_css_classes.overlayMenuCategory, isOpen && OverlayMenuCategory_module_css_classes.overlayMenuCategoryOpen, isCTA && OverlayMenuCategory_module_css_classes.overlayMenuCategoryCTA),
        component: "div",
        ...rest
    }, title && (!isCTA ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
    /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        component: hasNoLinks ? "a" : "button",
        target: hasNoLinks && isExternal ? "_blank" : void 0,
        ...(0,helpers/* omitText */.rW)(title),
        onClick: !links ? title.onClick : ()=>{
            if (onToggle) onToggle();
        },
        className: (0,clsx/* default */.Z)(OverlayMenuCategory_module_css_classes.overlayMenuCategoryTitle, hasNoLinks ? OverlayMenuCategory_module_css_classes.overlayMenuCategoryTitleLink : void 0, title.className)
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        component: "span",
        size: "navigation-m",
        textColor: "var(--content-primary)"
    }, title.text, " ", !showArrow && hasNoLinks && isExternal && /* @__PURE__ */ /*#__PURE__*/ react.createElement(ExternalLinkIcon, {
        size: "small",
        withBoundingBox: false
    })), showArrow && !hasNoLinks && /* @__PURE__ */ /*#__PURE__*/ react.createElement(ArrowDownBoldIcon/* ArrowDownBoldIcon */.T, {
        size: "xSmall",
        withBoundingBox: false,
        className: (0,clsx/* default */.Z)(OverlayMenuCategory_module_css_classes.iconTransitionArrowClosed, isOpen && OverlayMenuCategory_module_css_classes.iconTransitionArrowOpen, OverlayMenuCategory_module_css_classes.arrowDownIcon)
    })) : /* @__PURE__ */ /*#__PURE__*/ react.createElement(Link/* Link */.r, {
        size: "small",
        underline: false,
        rightIcon: /* @__PURE__ */ /*#__PURE__*/ react.createElement(ArrowRightBoldIcon/* ArrowRightBoldIcon */.K, {
            size: "small",
            withBoundingBox: false
        }),
        ...(0,helpers/* omitText */.rW)(title)
    }, title.text)), (isOpen || !title) && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        component: "ul",
        direction: "column",
        gap: 15,
        className: OverlayMenuCategory_module_css_classes.overlayMenuCategoryLinks
    }, !hasNoLinks && (links === null || links === void 0 ? void 0 : links.map((link)=>/* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
            key: link.href,
            component: "li"
        }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
            component: "a",
            size: "navigation-s",
            textColor: "var(--content-action-default)",
            ...(0,helpers/* omitText */.rW)(link),
            className: OverlayMenuCategory_module_css_classes.overlayMenuCategoryLinksLink
        }, link.text))))));
});


// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/utils/hooks/use-window-size.mjs + 1 modules
var use_window_size = __webpack_require__(79114);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Layout/AspectRatioKeeper/AspectRatioKeeper.mjs + 2 modules
var AspectRatioKeeper = __webpack_require__(66737);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/DataDisplay/Image/Image.mjs + 2 modules
var Image = __webpack_require__(28879);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/subcomponents/OverlayMenuImage/OverlayMenuImage.module.css.mjs
var OverlayMenuImage_module_css_classes = {
    "overlayMenuImage": "oRy72",
    "overlayMenuImageCTA": "wCyIu",
    "overlayMenuImageWidth": "R1rEa"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/subcomponents/OverlayMenuImage/OverlayMenuImage.utils.mjs
const kohlerUSSmartCropImageSize = {
    1: {
        portrait: {
            general: {
                1023: "340px",
                768: "calc(calc(100vw - 100px * 2) * 0.4755)",
                220: "calc(100vw - 3.0625rem * 2)"
            },
            business: {
                1023: "340px",
                768: "calc(calc(100vw - 100px * 2) * 0.4755)",
                220: "calc(100vw - 3.0625rem * 2)"
            }
        },
        landscape: {
            general: {
                1023: "340px",
                768: "calc(calc(100vw - 100px * 2) * 0.4755)",
                220: "calc(100vw - 3.0625rem * 2)"
            },
            business: {
                1023: "340px",
                768: "calc(calc(100vw - 100px * 2) * 0.4755)",
                220: "calc(100vw - 3.0625rem * 2)"
            }
        }
    },
    2: {
        portrait: {
            general: {
                1600: "340px",
                1440: "305px",
                1023: "250px",
                768: "calc(calc(100vw - 100px * 2) * 0.4755)",
                220: "calc(100vw - 3.0625rem * 2)"
            },
            business: {
                1600: "340px",
                1440: "280px",
                1023: "240px",
                768: "calc(calc(100vw - 100px * 2) * 0.4755)",
                220: "calc(100vw - 3.0625rem * 2)"
            }
        },
        landscape: {
            business: {
                1920: "440px",
                1600: "415px",
                1440: "335px",
                1023: "303px",
                768: "calc(calc(100vw - 100px * 2) * 0.4755)",
                220: "calc(100vw - 3.0625rem * 2)"
            }
        }
    }
};
function getSmartCropWidth(param) {
    let { screenWidth , imagesLength , isSmartCrop , imageOrientation , isBusinessTab  } = param;
    var ref, ref1;
    if (!isSmartCrop) return void 0;
    const layoutTier = imagesLength;
    const context = isBusinessTab ? "business" : "general";
    const orientation = imageOrientation === "portrait" ? "portrait" : "landscape";
    const breakpoints = (ref = kohlerUSSmartCropImageSize[layoutTier]) === null || ref === void 0 ? void 0 : (ref1 = ref[orientation]) === null || ref1 === void 0 ? void 0 : ref1[context];
    if (!breakpoints) return void 0;
    const sortedKeys = Object.keys(breakpoints).map(Number).sort((a, b)=>a - b);
    let selected;
    for (const bp of sortedKeys){
        if (screenWidth >= bp) {
            selected = breakpoints[bp];
        } else {
            break;
        }
    }
    return selected;
}


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/subcomponents/OverlayMenuImage/OverlayMenuImage.mjs
"use client";






const OverlayMenuImage = (0,factory_utils/* factory */.d5)((props, ref)=>{
    const { className , CTA , imagesLength =1 , caption , image , multiCTA , imageOrientation ="landscape" , href , isBusinessTab =true , ...rest } = props;
    const isSmartCrop = (image === null || image === void 0 ? void 0 : image["data-mode"]) === "smartcrop";
    const { width: screenWidth  } = (0,use_window_size/* useWindowSize */.i)();
    const resolvedWidth = getSmartCropWidth({
        screenWidth,
        imagesLength,
        isSmartCrop,
        imageOrientation,
        isBusinessTab
    });
    var ref1, ref2;
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        direction: "column",
        gap: 40,
        ref,
        className: (0,clsx/* default */.Z)(className, "kohler-overlay-menu-image-wrapper", OverlayMenuImage_module_css_classes.overlayMenuImageWrapper),
        width: resolvedWidth,
        ...rest
    }, multiCTA && multiCTA.length > 0 && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        component: "ul",
        direction: "column",
        gap: 20
    }, multiCTA === null || multiCTA === void 0 ? void 0 : multiCTA.map((item)=>/* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
            key: item.text,
            component: "li",
            className: OverlayMenuImage_module_css_classes.overlayMenuCategoryLinksLink
        }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Link/* Link */.r, {
            ...(0,helpers/* omitText */.rW)(item),
            underline: false,
            rightIcon: /* @__PURE__ */ /*#__PURE__*/ react.createElement(ArrowRightBoldIcon/* ArrowRightBoldIcon */.K, {
                withBoundingBox: false,
                size: "xSmall"
            }),
            className: OverlayMenuImage_module_css_classes.overlayMenuCategoryLinksLink,
            size: "small",
            textColor: "var(--content-primary)"
        }, item.text)))), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        className: (0,clsx/* default */.Z)("kohler-overlay-menu-image", OverlayMenuImage_module_css_classes.overlayMenuImage, !isSmartCrop && OverlayMenuImage_module_css_classes.overlayMenuImageWidth)
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(AspectRatioKeeper/* AspectRatioKeeper */.y, {
        component: "a",
        href: (ref2 = (ref1 = CTA === null || CTA === void 0 ? void 0 : CTA.href) !== null && ref1 !== void 0 ? ref1 : href) !== null && ref2 !== void 0 ? ref2 : void 0,
        aspectRatio: isSmartCrop ? "none" : imageOrientation === "landscape" ? "5:4" : "3:4"
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Image/* Image */.E, {
        ...image
    })), (caption || CTA) && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        direction: "column",
        gap: 5
    }, caption && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        size: "label-regular-s",
        textColor: "var(--content-secondary)",
        component: /*#__PURE__*/ (0,react.isValidElement)(caption.text) ? "div" : caption.component || "p",
        ...(0,helpers/* omitText */.rW)(caption)
    }, caption.text), CTA && CTA.text && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Link/* Link */.r, {
        underline: false,
        rightIcon: /* @__PURE__ */ /*#__PURE__*/ react.createElement(ArrowRightBoldIcon/* ArrowRightBoldIcon */.K, {
            withBoundingBox: false,
            size: "xSmall"
        }),
        className: OverlayMenuImage_module_css_classes.overlayMenuImageCTA,
        size: "small",
        textColor: "var(--content-primary)",
        ...(0,helpers/* omitText */.rW)(CTA)
    }, CTA.text))));
});


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/subcomponents/OverlayMenuItem/OverlayMenuItem.module.css.mjs
var OverlayMenuItem_module_css_classes = {
    "overlayMenuItem": "PPy7I"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/subcomponents/OverlayMenuItem/OverlayMenuItem.mjs





const OverlayMenuItem = (0,factory_utils/* polymorphicFactory */.bq)((props, ref)=>{
    const { className , title , showArrow =true , component ="button" , ...rest } = props;
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        ref,
        className: (0,clsx/* default */.Z)(className, "kohler-overlay-menu-item", OverlayMenuItem_module_css_classes.overlayMenuItem),
        component,
        type: component === "button" ? "button" : void 0,
        textColor: "var(--content-primary)",
        ...rest
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        component: "span",
        size: "navigation-l",
        textColor: "var(--content-primary)"
    }, title), " ", showArrow && /* @__PURE__ */ /*#__PURE__*/ react.createElement(ArrowRightBoldIcon/* ArrowRightBoldIcon */.K, {
        size: "xSmall",
        withBoundingBox: false
    }));
});


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/subcomponents/OverlayMenuLinks/OverlayMenuLinks.module.css.mjs
var OverlayMenuLinks_module_css_classes = {
    "overlayMenuLinks": "_4jPFa",
    "overlayMenuCategoryLinksCTA": "hdex4",
    "overlayMenuLinksNoMargin": "_-6Bhq",
    "overlayMenuCategoryLinksLink": "O8QYI",
    "overlayMenuLinksList": "_0Y07-",
    "overlayMenuCategoryLinksTitleLink": "W9te5",
    "overlayMenuCategoryLinksTitleLinkCTA": "cG53K",
    "overlayMenuCategoryLinksLinkComponent": "K29q-"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/subcomponents/OverlayMenuLinks/OverlayMenuLinks.utils.mjs
function omitTextAndTabGroup(obj) {
    const { text: _ , newTabGroup: __ , ...rest } = obj;
    return rest;
}


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/subcomponents/OverlayMenuLinks/OverlayMenuLinks.mjs






const OverlayMenuLinks = (0,factory_utils/* factory */.d5)((props, ref)=>{
    const { className , title , items , CTAs , size ="small" , isCTA =false , newTabGroup =false , ...rest } = props;
    const isSmall = size === "small";
    const titleID = (0,react.useId)();
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        ref,
        direction: "column",
        align: "flex-start",
        className: (0,clsx/* default */.Z)(className, "kohler-overlay-menu-links", OverlayMenuLinks_module_css_classes.overlayMenuLinks, isSmall && !(items === null || items === void 0 ? void 0 : items.length) && title.href && OverlayMenuLinks_module_css_classes.overlayMenuLinksNoMargin),
        ...rest
    }, title && (!isCTA ? /* @__PURE__ */ /*#__PURE__*/ react.createElement(react.Fragment, null, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        component: title.href ? "a" : "span",
        size: isSmall ? "label-medium-m" : "label-regular-s",
        textColor: isSmall ? "var(--content-primary)" : "var(--content-secondary)",
        className: (0,clsx/* default */.Z)(title.href && OverlayMenuLinks_module_css_classes.overlayMenuCategoryLinksTitleLink, newTabGroup && OverlayMenuLinks_module_css_classes.overlayMenuCategoryLinksTitleLinkCTA),
        id: "".concat(title.text, "-").concat(titleID),
        target: title.href ? newTabGroup ? "_blank" : void 0 : void 0,
        ...(0,helpers/* omitText */.rW)(title)
    }, title.text, newTabGroup && /* @__PURE__ */ /*#__PURE__*/ react.createElement(ExternalLinkIcon, {
        size: "small",
        withBoundingBox: false
    }))) : /* @__PURE__ */ /*#__PURE__*/ react.createElement(Link/* Link */.r, {
        size: "small",
        underline: false,
        rightIcon: /* @__PURE__ */ /*#__PURE__*/ react.createElement(ArrowRightBoldIcon/* ArrowRightBoldIcon */.K, {
            size: "small",
            withBoundingBox: false
        }),
        ...(0,helpers/* omitText */.rW)(title)
    }, title.text)), (items === null || items === void 0 ? void 0 : items.length) && (items === null || items === void 0 ? void 0 : items.length) > 0 && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        component: "ul",
        direction: "column",
        gap: 2,
        "aria-labelledby": title && "".concat(title.text, "-").concat(titleID),
        className: OverlayMenuLinks_module_css_classes.overlayMenuLinksList
    }, items === null || items === void 0 ? void 0 : items.map((item)=>{
        if ("href" in item) {
            return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
                key: item.text || item.href,
                component: "li",
                className: OverlayMenuLinks_module_css_classes.overlayMenuCategoryLinksLink
            }, isSmall && item.target !== "_blank" && !item.newTabGroup && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
                component: "a",
                size: "navigation-overlay-item-s",
                textColor: "var(--content-action-default)",
                ...omitTextAndTabGroup(item),
                className: OverlayMenuLinks_module_css_classes.overlayMenuCategoryLinksLink
            }, item.text), (!isSmall || item.target === "_blank" || item.newTabGroup) && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Link/* Link */.r, {
                size: "medium",
                rightIcon: item.target === "_blank" || item.newTabGroup ? /* @__PURE__ */ /*#__PURE__*/ react.createElement(ExternalLinkIcon, {
                    size: "small",
                    withBoundingBox: false
                }) : void 0,
                ...omitTextAndTabGroup(item),
                underline: false,
                className: OverlayMenuLinks_module_css_classes.overlayMenuCategoryLinksLinkComponent
            }, item.text));
        } else {
            var ref;
            var ref1;
            return /* @__PURE__ */ /*#__PURE__*/ react.createElement(OverlayMenuLinks, {
                key: "group-".concat((ref1 = (ref = item.title) === null || ref === void 0 ? void 0 : ref.text) !== null && ref1 !== void 0 ? ref1 : Math.random()),
                ...item
            });
        }
    })), CTAs && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        component: "ul",
        direction: "column",
        gap: isSmall ? 10 : 2,
        marginTop: isSmall ? 10 : 2,
        className: OverlayMenuLinks_module_css_classes.overlayMenuLinksList
    }, CTAs === null || CTAs === void 0 ? void 0 : CTAs.map((link)=>/* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
            key: link.href,
            component: "li",
            className: OverlayMenuLinks_module_css_classes.overlayMenuCategoryLinksCTA
        }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Link/* Link */.r, {
            size: isSmall ? "small" : "medium",
            underline: false,
            rightIcon: isSmall ? /* @__PURE__ */ /*#__PURE__*/ react.createElement(ArrowRightBoldIcon/* ArrowRightBoldIcon */.K, {
                size: "small",
                withBoundingBox: false
            }) : /* @__PURE__ */ /*#__PURE__*/ react.createElement(ExternalLinkIcon, {
                withBoundingBox: false
            }),
            ...(0,helpers/* omitText */.rW)(link)
        }, link.text)))));
});


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Navigation/Tab/Tab.module.css.mjs
var Tab_module_css_classes = {
    "tab": "YhILP",
    "tabHorizontal": "exTIC",
    "tabVertical": "_2ShWU",
    "tabSelected": "fkAYT",
    "horizontalTabBar": "A3jW0",
    "verticalTabBar": "CsShe",
    "verticalTabBarUnselected": "CAUrL",
    "verticalTabBarSelected": "BXqTp"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Navigation/Tab/Tab.utils.mjs

const tabTypeClasses = {
    horizontal: Tab_module_css_classes.tabHorizontal,
    vertical: Tab_module_css_classes.tabVertical
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Navigation/Tab/Tab.mjs

















const Tab = (0,factory_utils/* polymorphicFactory */.bq)((props, ref)=>{
    const { text , component ="button" , isSelected =false , variant ="horizontal" , className , ...rest } = props;
    const isHorizontal = variant === "horizontal";
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        direction: isHorizontal ? "column" : "row"
    }, !isHorizontal && /* @__PURE__ */ /*#__PURE__*/ react.createElement("div", {
        className: (0,clsx/* default */.Z)(Tab_module_css_classes.verticalTabBar, isSelected ? Tab_module_css_classes.verticalTabBarSelected : Tab_module_css_classes.verticalTabBarUnselected)
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        component,
        size: isHorizontal ? "label-medium-l" : "label-medium-m",
        type: component === "button" ? "button" : void 0,
        className: (0,clsx/* default */.Z)(Tab_module_css_classes.tab, className, tabTypeClasses[variant], "kohler-tab-root", (rest["aria-expanded"] || isSelected) && Tab_module_css_classes.tabSelected),
        ref,
        ...rest
    }, text), isSelected && isHorizontal && /* @__PURE__ */ /*#__PURE__*/ react.createElement("div", {
        className: Tab_module_css_classes.horizontalTabBar
    }));
});


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/subcomponents/OverlayMenuTabs/OverlayMenuTabs.module.css.mjs
var OverlayMenuTabs_module_css_classes = {
    "overlayMenuTabs": "uD-Eu"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/subcomponents/OverlayMenuTabs/OverlayMenuTabs.mjs





const OverlayMenuTabs = (0,factory_utils/* factory */.d5)((props, ref)=>{
    const { className , title , CTAs , ...rest } = props;
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        ref,
        direction: "column",
        gap: 10,
        className: (0,clsx/* default */.Z)(className, "kohler-overlay-menu-tabs", OverlayMenuTabs_module_css_classes.overlayMenuTabs),
        ...rest
    }, title && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        component: "span",
        size: "label-medium-m",
        textColor: "var(--content-primary)"
    }, title), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        component: "ul",
        direction: "column",
        gap: 0
    }, CTAs === null || CTAs === void 0 ? void 0 : CTAs.map((link)=>{
        const { hasChildrenList , ...linkProps } = link;
        return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
            component: "li",
            key: link.text
        }, hasChildrenList && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Tab, {
            variant: "vertical",
            id: link.text,
            textColor: "var(--content-action-default)",
            type: "button",
            ...linkProps
        }), !hasChildrenList && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Link/* Link */.r, {
            underline: false,
            rightIcon: /* @__PURE__ */ /*#__PURE__*/ react.createElement(ArrowRightBoldIcon/* ArrowRightBoldIcon */.K, {
                withBoundingBox: false,
                size: "xSmall"
            }),
            className: OverlayMenuTabs_module_css_classes.overlayMenuImageCTA,
            size: "small",
            href: link.href
        }, link.text));
    })));
});


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/subcomponents/OverlayMenu/OverlayMenu.module.css.mjs
var OverlayMenu_module_css_classes = {
    "overlayMenu": "VnLVG",
    "overlayMenuLinkGridMainMobileWrapper": "VZHqR",
    "overlayMenuLinkGridWrapper": "_0joZn",
    "overlayMenuLinkGridMobileWrapper": "QzpWp",
    "overlayMenuLinkGridListsMobile": "s0UqJ",
    "overlayMenuLinkGridLists": "YT28-",
    "overlayMenuLinkGrid": "mQdab",
    "overlayMenuMobileImages": "p73rY",
    "overlayMenuLinkCloseButtonMobile": "ojZqn",
    "overlayMenuLinkLevelOneMobile": "nPytY",
    "arrowLeftIcon": "mjUag"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/subcomponents/OverlayMenu/OverlayMenu.utils.mjs
const isILink = (item)=>"href" in item;
function getSanitizedLanguagePickerCTA(config) {
    const { location , languagePickerCTA , currentLanguage , secondLanguageCTA , ...rest } = config;
    return {
        ...rest
    };
}
function countCTAListsWithItems(data) {
    return (data.CTALists || []).reduce((count, group)=>{
        const groups = Array.isArray(group) ? group : [
            group
        ];
        const hasItems = groups.some((g)=>Array.isArray(g.items) && g.items.length > 0);
        return hasItems ? count + 1 : count;
    }, 0);
}


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/UserIcon.mjs


const UserIcon_withoutBoundingBoxWidth = {
    large: 24,
    medium: 18,
    small: 14,
    xSmall: 11
};
const UserIcon = (param)=>{
    let { size ="medium" , withBoundingBox =true , ...others } = param;
    let iconWidth, iconHeight;
    if (typeof size === "string") {
        iconWidth = withBoundingBox ? constants/* iconSize */.E[size] : UserIcon_withoutBoundingBoxWidth[size];
        iconHeight = constants/* iconSize */.E[size];
    } else {
        iconWidth = size;
        iconHeight = size;
    }
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: iconWidth,
        height: iconHeight,
        viewBox: "0 0 30 30",
        preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
        fill: "none",
        ...others
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15 5.5C12.2386 5.5 10 7.73858 10 10.5C10 13.2614 12.2386 15.5 15 15.5C17.7614 15.5 20 13.2614 20 10.5C20 7.73858 17.7614 5.5 15 5.5ZM15 6.5C17.2091 6.5 19 8.29086 19 10.5C19 12.7091 17.2091 14.5 15 14.5C12.7909 14.5 11 12.7091 11 10.5C11 8.29086 12.7909 6.5 15 6.5Z",
        fill: "currentColor"
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        d: "M23.9951 21.7882C23.8845 19.4012 21.9143 17.5 19.5 17.5H10.5L10.2882 17.5049C7.90124 17.6155 6 19.5857 6 22V25H7V22L7.00518 21.808C7.10487 19.9643 8.63144 18.5 10.5 18.5H19.5L19.692 18.5052C21.5357 18.6049 23 20.1314 23 22V25H24V22L23.9951 21.7882Z",
        fill: "currentColor"
    }));
};
UserIcon.iconName = "UserIcon";


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/LocationIcon.mjs


const LocationIcon_withoutBoundingBoxWidth = {
    large: 27,
    medium: 15,
    small: 10,
    xSmall: 8
};
const LocationIcon = (param)=>{
    let { size ="medium" , withBoundingBox =true , ...others } = param;
    let iconWidth, iconHeight;
    if (typeof size === "string") {
        iconWidth = withBoundingBox ? constants/* iconSize */.E[size] : LocationIcon_withoutBoundingBoxWidth[size];
        iconHeight = constants/* iconSize */.E[size];
    } else {
        iconWidth = size;
        iconHeight = size;
    }
    const renderIcon = ()=>{
        switch(size){
            case "large":
                return /* @__PURE__ */ /*#__PURE__*/ react.createElement("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: iconWidth,
                    height: iconHeight,
                    viewBox: "0 0 40 40",
                    preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
                    fill: "none",
                    ...others
                }, /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M20.0007 10.834C17.6995 10.834 15.834 12.6995 15.834 15.0007C15.834 17.3018 17.6995 19.1673 20.0007 19.1673C22.3018 19.1673 24.1673 17.3018 24.1673 15.0007C24.1673 12.6995 22.3018 10.834 20.0007 10.834ZM16.834 15.0007C16.834 13.2517 18.2517 11.834 20.0007 11.834C21.7496 11.834 23.1673 13.2517 23.1673 15.0007C23.1673 16.7496 21.7496 18.1673 20.0007 18.1673C18.2517 18.1673 16.834 16.7496 16.834 15.0007Z",
                    fill: "currentColor"
                }), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M20 2C12.8525 2 7 7.47319 7 14.2947C7 15.3127 7.23318 16.4956 7.67819 17.8359L7.68126 17.8448L7.94023 18.578L7.94327 18.5863C8.03879 18.8422 8.14149 19.1038 8.25133 19.3711L8.2542 19.378L8.59953 20.1842L8.60233 20.1906C8.97468 21.0275 9.41164 21.9177 9.91266 22.8614L9.91493 22.8656L10.433 23.8193L10.4374 23.8271L10.9987 24.8179L11.0007 24.8215C11.0986 24.9909 11.1982 25.1618 11.2996 25.3343L11.3015 25.3375L11.9277 26.3841L11.9313 26.3901L12.6007 27.4741L12.6024 27.4769C12.7182 27.6616 12.8357 27.8478 12.955 28.0356L12.9566 28.0381L13.6908 29.1783L13.6939 29.183L14.4714 30.3607L14.4743 30.3651L15.295 31.5805L15.2977 31.5845L16.1616 32.8376L16.1629 32.8395C16.3109 33.0521 16.4608 33.2663 16.6124 33.4821L16.6136 33.4838L17.5424 34.7937L17.5436 34.7954C17.7024 35.0174 17.863 35.241 18.0254 35.4662L18.0269 35.4684L20.1315 38.3543L22.2004 35.4581L22.2031 35.4544L23.134 34.1257L24.0248 32.8315L24.0273 32.8278L24.8735 31.5748L24.8762 31.5709L25.68 30.3557L25.6828 30.3513L26.4443 29.1738L26.4473 29.1691L27.1664 28.0291L27.1697 28.0239L27.8465 26.9214L27.8482 26.9186C27.958 26.7371 28.0661 26.557 28.1724 26.3785L28.1742 26.3754L28.7875 25.329L28.7913 25.3224L29.3623 24.3132L29.3664 24.3059L29.895 23.3338L29.8971 23.3299C29.9825 23.1696 30.066 23.0108 30.1478 22.8535L30.1501 22.8491L30.6152 21.9326L30.6176 21.9279C32.1792 18.7695 33 16.2187 33 14.2947C33 7.47319 27.1475 2 20 2ZM8 14.2947C8 8.07983 13.3488 3 20 3C26.6512 3 32 8.07983 32 14.2947C32 15.9782 31.268 18.3559 29.7223 21.4824L29.7212 21.4847L29.2606 22.3921L29.2595 22.3943C29.1799 22.5473 29.0986 22.7018 29.0155 22.8579L29.0144 22.86L28.4899 23.8244L27.9228 24.8267L27.3133 25.8667L27.3125 25.8682C27.2079 26.0438 27.1015 26.2209 26.9934 26.3996L26.9925 26.401L26.319 27.4982L25.6031 28.6331L24.8459 29.804L24.8431 29.8083L24.0448 31.0152L24.0421 31.0192L23.2011 32.2645L23.1986 32.2681L22.3149 33.5519L22.3126 33.5553L21.3867 34.8769L21.384 34.8806L20.1231 36.6457L18.8365 34.8813L18.8357 34.8802C18.6745 34.6567 18.5151 34.4348 18.3575 34.2144L17.4306 32.9071L17.4298 32.9061C17.2795 32.6921 17.1309 32.4797 16.9842 32.2689L16.1237 31.0209L16.121 31.0169L15.3059 29.8098L15.303 29.8055L14.5301 28.6345L13.799 27.4993L13.7982 27.498C13.6806 27.3129 13.5647 27.1293 13.4507 26.9473L13.4498 26.9459L12.784 25.8677L12.1616 24.8273L12.1607 24.8258C12.0612 24.6567 11.9636 24.4892 11.8678 24.3232L11.8667 24.3214L11.3096 23.3381L10.7959 22.3925L10.7948 22.3903C10.3039 21.4656 9.87828 20.5982 9.51737 19.7873L9.17491 18.9877C9.07006 18.7324 8.97231 18.4834 8.88164 18.2407L8.62576 17.5163C8.2014 16.2372 8 15.1676 8 14.2947Z",
                    fill: "currentColor"
                }));
            case "medium":
            case "small":
            case "xSmall":
            default:
                return /* @__PURE__ */ /*#__PURE__*/ react.createElement("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: iconWidth,
                    height: iconHeight,
                    viewBox: "0 0 30 30",
                    preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
                    fill: "none",
                    ...others
                }, /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M14.9422 8.71053C13.5033 8.71053 12.3369 9.87694 12.3369 11.3158C12.3369 12.7546 13.5033 13.9211 14.9422 13.9211C16.381 13.9211 17.5474 12.7546 17.5474 11.3158C17.5474 9.87694 16.381 8.71053 14.9422 8.71053ZM14.9422 9.71053C15.8287 9.71053 16.5474 10.4292 16.5474 11.3158C16.5474 12.2024 15.8287 12.9211 14.9422 12.9211C14.0556 12.9211 13.3369 12.2024 13.3369 11.3158C13.3369 10.4292 14.0556 9.71053 14.9422 9.71053Z",
                    fill: "currentColor"
                }), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M14.9422 4.5C10.8897 4.5 7.6001 7.71675 7.6001 11.6905C7.6001 12.2672 7.72786 12.9542 7.98348 13.7532L8.13559 14.2002C8.19052 14.3529 8.24967 14.5093 8.31306 14.6694L8.51589 15.1609C8.73141 15.6637 8.98498 16.2 9.27661 16.7701L9.58094 17.3515L9.91064 17.9556C9.96771 18.0581 10.0258 18.1616 10.085 18.2661L10.4528 18.9041L10.846 19.565C10.9136 19.677 10.9823 19.79 11.0521 19.9039L11.4833 20.599L11.94 21.317L12.422 22.0579L12.9295 22.8219C13.0161 22.9511 13.1039 23.0814 13.1927 23.2125L13.7383 24.0111C13.8313 24.1462 13.9254 24.2822 14.0206 24.4191L15.017 25.8373L15.9957 24.4153L16.5425 23.6052L17.0643 22.8183L17.5614 22.0545L18.0335 21.3137L18.4808 20.5958L18.9032 19.9008L19.3007 19.2287C19.3649 19.1186 19.428 19.0094 19.4901 18.9012L19.8504 18.2633L20.1857 17.648L20.4962 17.0554C20.5459 16.9585 20.5945 16.8626 20.6422 16.7676L20.9154 16.2089C21.8282 14.2928 22.2843 12.7903 22.2843 11.6905C22.2843 7.71675 18.9947 4.5 14.9422 4.5ZM14.9422 5.5C18.4473 5.5 21.2843 8.27411 21.2843 11.6905L21.2811 11.8356C21.2559 12.4286 21.0789 13.1706 20.7502 14.0595L20.5733 14.5161C20.5417 14.5943 20.509 14.6734 20.4753 14.7536L20.2605 15.2469C20.1847 15.4154 20.1046 15.5879 20.0204 15.7645L19.755 16.3064L19.4644 16.8724L19.1485 17.4627C19.0938 17.563 19.038 17.6644 18.9811 17.7668L18.6274 18.3931L18.2484 19.0435L17.8441 19.7177L17.4146 20.4159L16.9599 21.1379C16.882 21.2602 16.8031 21.3835 16.7231 21.5077L16.2305 22.2653L15.7127 23.0466C15.6243 23.1787 15.5349 23.3119 15.4444 23.4461L15.0081 24.086L14.3101 23.0766L13.7915 22.3109L13.2975 21.5679L12.8283 20.8475L12.3837 20.1499L11.9638 19.4752C11.8958 19.3647 11.8289 19.2551 11.7631 19.1464L11.3802 18.506C11.3184 18.4012 11.2577 18.2974 11.198 18.1945L10.8521 17.5886L10.5309 17.0058C10.4279 16.8154 10.3291 16.6288 10.2344 16.4461L9.96258 15.9096C9.87609 15.7346 9.79372 15.5635 9.71546 15.3963L9.49304 14.9064C9.45803 14.8266 9.42405 14.7479 9.3911 14.6701L9.20573 14.2152L9.04507 13.7837C8.74846 12.9443 8.6001 12.2458 8.6001 11.6905C8.6001 8.27411 11.4371 5.5 14.9422 5.5Z",
                    fill: "currentColor"
                }));
        }
    };
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(react.Fragment, null, renderIcon());
};
LocationIcon.iconName = "LocationIcon";


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/FavoriteNavFilledIcon.mjs


const FavoriteNavFilledIcon_withoutBoundingBoxWidth = {
    large: 32,
    medium: 24,
    small: 18,
    xSmall: 14
};
const FavoriteNavFilledIcon = (param)=>{
    let { size ="medium" , withBoundingBox =true , ...others } = param;
    let iconWidth, iconHeight;
    if (typeof size === "string") {
        iconWidth = withBoundingBox ? constants/* iconSize */.E[size] : FavoriteNavFilledIcon_withoutBoundingBoxWidth[size];
        iconHeight = constants/* iconSize */.E[size];
    } else {
        iconWidth = size;
        iconHeight = size;
    }
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: iconWidth,
        height: iconHeight,
        viewBox: "0 0 30 30",
        preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
        fill: "none",
        ...others
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.6951 7.09156C3.49859 9.29305 3.43021 12.8518 5.53178 15.106L5.68872 15.2692L15.0022 24.6039L24.2843 15.3011L24.4416 15.1385C26.57 12.8563 26.51 9.29736 24.3092 7.09156L24.1233 6.91321C21.8569 4.83246 18.3351 4.89191 16.1404 7.09156L15.0015 8.232L13.8639 7.09156C11.6693 4.89191 8.14741 4.83246 5.88101 6.91321L5.6951 7.09156Z",
        fill: "currentColor"
    }));
};
FavoriteNavFilledIcon.iconName = "FavoriteNavFilledIcon";


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/FavoriteNavIcon.mjs


const FavoriteNavIcon_withoutBoundingBoxWidth = {
    large: 30,
    medium: 23,
    small: 18,
    xSmall: 12
};
const FavoriteNavIcon = (param)=>{
    let { size ="medium" , withBoundingBox =true , ...others } = param;
    let iconWidth, iconHeight;
    if (typeof size === "string") {
        iconWidth = withBoundingBox ? constants/* iconSize */.E[size] : FavoriteNavIcon_withoutBoundingBoxWidth[size];
        iconHeight = constants/* iconSize */.E[size];
    } else {
        iconWidth = size;
        iconHeight = size;
    }
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: iconWidth,
        height: iconHeight,
        viewBox: "0 0 30 30",
        preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
        fill: "none",
        ...others
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.69461 7.09555C3.4981 9.29704 3.42972 12.8558 5.53129 15.11L5.68823 15.2732L15.0017 24.6079L24.2838 15.3051L24.4412 15.1425C26.5695 12.8603 26.5096 9.30135 24.3087 7.09555L24.1228 6.9172C21.8564 4.83646 18.3346 4.89591 16.1399 7.09555L15.001 8.23599L13.8634 7.09555C11.6688 4.89591 8.14693 4.83646 5.88052 6.9172L5.69461 7.09555ZM13.1555 7.80186L15.0017 9.65218L16.8478 7.80186C18.7127 5.93271 21.7359 5.93271 23.6008 7.80186C25.4215 9.62661 25.4711 12.5719 23.7161 14.4539L23.5705 14.6044L15.001 23.191L6.40252 14.5734L6.25733 14.4224C4.52885 12.5683 4.58545 9.62305 6.40252 7.80186C8.26744 5.93271 11.2906 5.93271 13.1555 7.80186Z",
        fill: "currentColor"
    }));
};
FavoriteNavIcon.iconName = "FavoriteNavIcon";


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/subcomponents/UtilityLinks/subcomponents/LanguagePicker/LanguagePicker.module.css.mjs
var LanguagePicker_module_css_classes = {
    "divider": "Ojclf"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/subcomponents/UtilityLinks/subcomponents/LanguagePicker/LanguagePicker.mjs



const LanguagePicker = (param)=>{
    let { location , languagePickerCTA , currentLanguage , secondLanguageCTA , textColor  } = param;
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        gap: 4,
        justify: "center",
        align: "center"
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        size: "overline",
        component: "button",
        type: "button",
        textColor: textColor || "var(--content-perma-white)",
        "aria-label": "pick language",
        ...languagePickerCTA
    }, location, " - ", currentLanguage), secondLanguageCTA && /* @__PURE__ */ /*#__PURE__*/ react.createElement(react.Fragment, null, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        className: LanguagePicker_module_css_classes.divider,
        backgroundColor: textColor
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        size: "overline",
        component: "a",
        ...(0,helpers/* omitText */.rW)(secondLanguageCTA),
        textColor: textColor || "var(--content-perma-white)"
    }, secondLanguageCTA.text)));
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/subcomponents/OverlayMenu/subcomponent/UtilityBarMobile/UtilityBarMobile.module.css.mjs
var UtilityBarMobile_module_css_classes = {
    "utilityBarOverlayMobile": "UM-Eb",
    "userCTAMobileWrapper": "uDuou"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/subcomponents/OverlayMenu/subcomponent/UtilityBarMobile/UtilityBarMobile.mjs







const omitFavoritesCTA = (favoritesCTA)=>{
    const { isFilled =false , ...omitFavoritesCTA2 } = favoritesCTA;
    return {
        isFilled,
        omitFavoritesCTA: omitFavoritesCTA2
    };
};
const UtilityBarMobile = (0,factory_utils/* factory */.d5)((props, ref)=>{
    const { utilityLinks , className , ...rest } = props;
    const { userCTA , locationPickerCTA , favoritesCTA , languagePicker , userName , isLoggedIn , utilityLinksMobile , userCTAMobile  } = utilityLinks || {};
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        className: (0,clsx/* clsx */.W)(UtilityBarMobile_module_css_classes.utilityBarOverlayMobile, className),
        ref,
        ...rest
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        direction: "column",
        gap: 15,
        paddingTop: 20,
        paddingBottom: 30
    }, userCTA && !userCTAMobile && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        component: "button",
        type: "button",
        textColor: "var(--content-primary)",
        "aria-label": isLoggedIn ? "user sign in" : "profile",
        ...userCTA,
        onClick: (e)=>{
            var ref;
            userCTA === null || userCTA === void 0 ? void 0 : (ref = userCTA.onClick) === null || ref === void 0 ? void 0 : ref.call(userCTA, e);
        }
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        gap: 5,
        align: "center",
        component: "span"
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(UserIcon, {
        withBoundingBox: true
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        size: "navigation-s",
        component: "span",
        textColor: "var(--content-primary)"
    }, userCTA.text ? userCTA.text : isLoggedIn && userName ? "Hi, ".concat(userName) : "Sign in / Create Account"))), userCTAMobile && /* @__PURE__ */ /*#__PURE__*/ react.createElement(react.Fragment, null, !isLoggedIn && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        textColor: "var(--content-primary)",
        className: UtilityBarMobile_module_css_classes.userCTAMobileWrapper
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        gap: 5,
        align: "center",
        component: "button",
        type: "button",
        onClick: (e)=>{
            var ref;
            const userCTAOnClick = userCTAMobile === null || userCTAMobile === void 0 ? void 0 : (ref = userCTAMobile.signInCTA) === null || ref === void 0 ? void 0 : ref.onClick;
            if (!userCTAOnClick) {
                var ref1;
                userCTA === null || userCTA === void 0 ? void 0 : (ref1 = userCTA.onClick) === null || ref1 === void 0 ? void 0 : ref1.call(userCTA, e);
            } else {
                userCTAOnClick(e);
            }
        },
        ...(0,helpers/* omitText */.rW)(userCTAMobile.signInCTA)
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(UserIcon, {
        withBoundingBox: true
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        size: "navigation-s",
        component: "div",
        textColor: "var(--content-primary)"
    }, userCTAMobile.signInCTA.text ? userCTAMobile.signInCTA.text : "Sign in ")), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        size: "navigation-s",
        component: "span",
        textColor: "var(--content-primary)"
    }, "/"), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        size: "navigation-s",
        component: "button",
        type: "button",
        textColor: "var(--content-primary)",
        onClick: (e)=>{
            var ref;
            const userCTAOnClick = userCTAMobile === null || userCTAMobile === void 0 ? void 0 : (ref = userCTAMobile.signUpCTA) === null || ref === void 0 ? void 0 : ref.onClick;
            if (!userCTAOnClick) {
                var ref1;
                userCTA === null || userCTA === void 0 ? void 0 : (ref1 = userCTA.onClick) === null || ref1 === void 0 ? void 0 : ref1.call(userCTA, e);
            } else {
                userCTAOnClick(e);
            }
        },
        ...(0,helpers/* omitText */.rW)(userCTAMobile.signUpCTA)
    }, userCTAMobile.signUpCTA.text ? userCTAMobile.signUpCTA.text : "Create Account")), isLoggedIn && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        component: "button",
        type: "button",
        textColor: "var(--content-primary)",
        ...userCTAMobile.accountCTA,
        onClick: (e)=>{
            var ref;
            const userCTAOnClick = userCTAMobile === null || userCTAMobile === void 0 ? void 0 : (ref = userCTAMobile.accountCTA) === null || ref === void 0 ? void 0 : ref.onClick;
            if (!userCTAOnClick) {
                var ref1;
                userCTA === null || userCTA === void 0 ? void 0 : (ref1 = userCTA.onClick) === null || ref1 === void 0 ? void 0 : ref1.call(userCTA, e);
            } else {
                userCTAOnClick(e);
            }
        }
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        gap: 5,
        align: "center",
        component: "span"
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(UserIcon, {
        withBoundingBox: true
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        size: "navigation-s",
        component: "span",
        textColor: "var(--content-primary)"
    }, userCTAMobile.accountCTA.text ? userCTAMobile.accountCTA.text : "Hi, ".concat(userName))))), utilityLinksMobile && utilityLinksMobile.length > 0 && utilityLinksMobile.map((utilityLink)=>{
        return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
            key: utilityLink.text,
            component: "a",
            textColor: "var(--content-primary)",
            ...(0,helpers/* omitText */.rW)(utilityLink),
            className: UtilityBarMobile_module_css_classes.utilityLink
        }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
            size: "navigation-s",
            component: "span",
            textColor: "var(--content-primary)"
        }, utilityLink.text));
    }), locationPickerCTA && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        gap: 5,
        align: "center",
        component: "button",
        ...locationPickerCTA,
        onClick: (e)=>{
            var ref;
            locationPickerCTA === null || locationPickerCTA === void 0 ? void 0 : (ref = locationPickerCTA.onClick) === null || ref === void 0 ? void 0 : ref.call(locationPickerCTA, e);
        }
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(LocationIcon, {
        withBoundingBox: true
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        size: "navigation-s",
        component: "span",
        textColor: "var(--content-primary)"
    }, locationPickerCTA.text || "Find a Store")), favoritesCTA && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        component: "a",
        align: "center",
        gap: 5,
        "aria-label": "see favorites",
        textColor: "var(--content-primary)",
        ...omitFavoritesCTA(favoritesCTA).omitFavoritesCTA
    }, omitFavoritesCTA(favoritesCTA).isFilled ? /* @__PURE__ */ /*#__PURE__*/ react.createElement(FavoriteNavFilledIcon, {
        withBoundingBox: true
    }) : /* @__PURE__ */ /*#__PURE__*/ react.createElement(FavoriteNavIcon, {
        withBoundingBox: true
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        size: "navigation-s",
        component: "span",
        textColor: "var(--content-primary)"
    }, favoritesCTA.text || "Favorites"))), languagePicker && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        paddingBlock: 20,
        borderTop: "1px solid var(--border-tertiary)"
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(LanguagePicker, {
        ...languagePicker,
        languagePickerCTA: {
            ...getSanitizedLanguagePickerCTA(languagePicker),
            className: languagePicker.languagePickerCTA.className,
            onClick: (e)=>{
                var ref;
                if ((languagePicker === null || languagePicker === void 0 ? void 0 : languagePicker.languagePickerCTA) && (languagePicker === null || languagePicker === void 0 ? void 0 : (ref = languagePicker.languagePickerCTA) === null || ref === void 0 ? void 0 : ref.onClick)) {
                    var ref1;
                    languagePicker === null || languagePicker === void 0 ? void 0 : (ref1 = languagePicker.languagePickerCTA) === null || ref1 === void 0 ? void 0 : ref1.onClick(e);
                }
            }
        },
        textColor: "var(--content-primary)"
    })));
});


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/subcomponents/OverlayMenu/OverlayMenu.mjs












const OverlayMenu = (0,factory_utils/* factory */.d5)((props, ref)=>{
    var ref1, ref2, ref3;
    const { className , CTALists , images , mainMenuItems , setIsOpenMobileMenu , isMoreOverlay , utilityLinks , buttonCTA , closeCTA , ...rest } = props;
    const [selectedMobileMenuItem, setSelectedMobileMenuItem] = (0,react.useState)(null);
    const [selectedMoreTab, setSelectedMoreTab] = (0,react.useState)(isMoreOverlay && mainMenuItems ? mainMenuItems[0] : null);
    const CTAListsMobile = mainMenuItems === null || mainMenuItems === void 0 ? void 0 : mainMenuItems.find((val)=>val.text === selectedMobileMenuItem);
    const [openCategoryIndex, setOpenCategoryIndex] = (0,react.useState)(null);
    (0,react.useEffect)(()=>{
        if (isMoreOverlay) {
            setSelectedMoreTab(mainMenuItems ? mainMenuItems[0] : null);
        }
    }, [
        mainMenuItems === null || mainMenuItems === void 0 ? void 0 : mainMenuItems.length
    ]);
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        ref,
        className: (0,clsx/* default */.Z)(className, "kohler-overlay-menu-root", OverlayMenu_module_css_classes.overlayMenu),
        ...rest
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Grid/* Grid */.r, {
        className: OverlayMenu_module_css_classes.overlayMenuLinkGridMainMobileWrapper
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(GridColumn/* GridColumn */.C, {
        className: OverlayMenu_module_css_classes.overlayMenuLinkGridWrapper
    }, (CTALists || isMoreOverlay && mainMenuItems) && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        className: OverlayMenu_module_css_classes.overlayMenuLinkGridLists
    }, isMoreOverlay && /* @__PURE__ */ /*#__PURE__*/ react.createElement(OverlayMenuTabs, {
        className: OverlayMenu_module_css_classes.overlayMenuLinkGrid,
        CTAs: mainMenuItems === null || mainMenuItems === void 0 ? void 0 : mainMenuItems.map((mainMenuItem)=>{
            return {
                text: mainMenuItem.text,
                href: mainMenuItem.href,
                onClick: ()=>setSelectedMoreTab(mainMenuItem),
                isSelected: (selectedMoreTab === null || selectedMoreTab === void 0 ? void 0 : selectedMoreTab.text) === mainMenuItem.text,
                hasChildrenList: !!mainMenuItem.CTALists
            };
        })
    }), (ref1 = (selectedMoreTab === null || selectedMoreTab === void 0 ? void 0 : selectedMoreTab.CTALists) || CTALists) === null || ref1 === void 0 ? void 0 : ref1.map((CTAList, index)=>{
        if (Array.isArray(CTAList)) {
            const overlayMenuLinkGroups = CTAList;
            return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
                direction: "column",
                gap: "40px",
                key: "select-more-tab-cta-index-".concat(index)
            }, overlayMenuLinkGroups.map((overlayMenuLinkGroup, index2)=>{
                var ref;
                /* @__PURE__ */ /*#__PURE__*/ return react.createElement(OverlayMenuLinks, {
                    key: (overlayMenuLinkGroup === null || overlayMenuLinkGroup === void 0 ? void 0 : (ref = overlayMenuLinkGroup.title) === null || ref === void 0 ? void 0 : ref.text) + "overlay-menu-".concat(index2),
                    className: OverlayMenu_module_css_classes.overlayMenuLinkGrid,
                    ...overlayMenuLinkGroup
                });
            }));
        } else {
            var ref;
            const overlayMenuLinkGroup = CTAList;
            return /* @__PURE__ */ /*#__PURE__*/ react.createElement(react.Fragment, {
                key: (overlayMenuLinkGroup === null || overlayMenuLinkGroup === void 0 ? void 0 : (ref = overlayMenuLinkGroup.title) === null || ref === void 0 ? void 0 : ref.text) + "overlay-menu-".concat(index)
            }, isMoreOverlay && index % 3 === 0 && index !== 0 && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
                className: OverlayMenu_module_css_classes.overlayMenuLinkGrid
            }), /* @__PURE__ */ /*#__PURE__*/ react.createElement(OverlayMenuLinks, {
                className: OverlayMenu_module_css_classes.overlayMenuLinkGrid,
                ...overlayMenuLinkGroup
            }));
        }
    })), ((selectedMoreTab === null || selectedMoreTab === void 0 ? void 0 : selectedMoreTab.images) || images) && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        gap: 30
    }, (ref2 = (selectedMoreTab === null || selectedMoreTab === void 0 ? void 0 : selectedMoreTab.images) || images) === null || ref2 === void 0 ? void 0 : ref2.map((image)=>{
        var ref;
        /* @__PURE__ */ /*#__PURE__*/ return react.createElement(OverlayMenuImage, {
            key: image.image.src,
            imagesLength: (ref = (selectedMoreTab === null || selectedMoreTab === void 0 ? void 0 : selectedMoreTab.images) || images) === null || ref === void 0 ? void 0 : ref.length,
            isBusinessTab: ![
                "Bathroom",
                "Collection",
                "Kitchen",
                "Lighting",
                "Wellness"
            ].includes((rest === null || rest === void 0 ? void 0 : rest.text) || ""),
            ...image
        });
    }))), /* @__PURE__ */ /*#__PURE__*/ react.createElement(GridColumn/* GridColumn */.C, {
        className: OverlayMenu_module_css_classes.overlayMenuLinkGridMobileWrapper
    }, mainMenuItems && !selectedMobileMenuItem && /* @__PURE__ */ /*#__PURE__*/ react.createElement(react.Fragment, null, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        component: "button",
        type: "button",
        ...closeCTA,
        onClick: (e)=>{
            if (setIsOpenMobileMenu) {
                setIsOpenMobileMenu(false);
            }
            if (closeCTA && closeCTA.onClick) {
                closeCTA.onClick(e);
            }
        },
        className: (0,clsx/* default */.Z)(OverlayMenu_module_css_classes.overlayMenuLinkCloseButtonMobile, closeCTA === null || closeCTA === void 0 ? void 0 : closeCTA.className)
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(CloseIcon/* CloseIcon */.T, {
        size: "medium",
        withBoundingBox: false
    })), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        className: OverlayMenu_module_css_classes.overlayMenuLinkGridListsMobile
    }, mainMenuItems.map((mainMenuItem, index)=>{
        /* @__PURE__ */ /*#__PURE__*/ return react.createElement(react.Fragment, {
            key: "".concat(mainMenuItem.text, "-mobile-").concat(index)
        }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(OverlayMenuItem, {
            title: mainMenuItem.text,
            component: mainMenuItem.CTALists ? "button" : "a",
            href: mainMenuItem.CTALists ? void 0 : mainMenuItem.href,
            onClick: mainMenuItem.CTALists ? ()=>{
                setSelectedMobileMenuItem(mainMenuItem.text);
                const CTAListsMobileMap = mainMenuItems === null || mainMenuItems === void 0 ? void 0 : mainMenuItems.find((val)=>val.text === mainMenuItem.text);
                setOpenCategoryIndex(CTAListsMobileMap && countCTAListsWithItems(CTAListsMobileMap) === 1 ? 0 : null);
            } : void 0,
            className: mainMenuItem.className
        }));
    }), buttonCTA && /* @__PURE__ */ /*#__PURE__*/ react.createElement(react.Fragment, null, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        type: buttonCTA.onClick ? "button" : void 0,
        component: "href" in buttonCTA && buttonCTA.href ? "a" : "button",
        size: "navigation-l",
        textColor: "var(--content-primary)",
        ...(0,helpers/* omitText */.rW)(buttonCTA)
    }, buttonCTA.text)))), CTAListsMobile && selectedMobileMenuItem && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        direction: "column",
        gap: 30
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        className: OverlayMenu_module_css_classes.overlayMenuLinkLevelOneMobile
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        component: "button",
        type: "button",
        onClick: ()=>{
            if (selectedMobileMenuItem) {
                setSelectedMobileMenuItem(null);
            }
        },
        className: closeCTA === null || closeCTA === void 0 ? void 0 : closeCTA.className
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(ArrowLeftIcon, {
        size: "small",
        withBoundingBox: true,
        className: OverlayMenu_module_css_classes.arrowLeftIcon
    })), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        size: "navigation-overlay-item-s",
        textColor: "var(--content-primary)",
        width: "100%"
    }, selectedMobileMenuItem), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        component: "button",
        type: "button",
        ...closeCTA,
        onClick: ()=>{
            if (setIsOpenMobileMenu) {
                setIsOpenMobileMenu(false);
            }
        },
        className: (0,clsx/* default */.Z)(OverlayMenu_module_css_classes.overlayMenuLinkCloseButtonMobile, closeCTA === null || closeCTA === void 0 ? void 0 : closeCTA.className)
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(CloseIcon/* CloseIcon */.T, {
        size: "medium",
        withBoundingBox: false
    }))), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        direction: "column"
    }, (ref3 = CTAListsMobile.CTALists) === null || ref3 === void 0 ? void 0 : ref3.map((CTAList, index)=>{
        var ref, ref1, ref2, ref3;
        if (Array.isArray(CTAList)) {
            return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
                direction: "column",
                key: "cta-list-array-".concat(index)
            }, CTAList.map((CTAs, subIndex)=>{
                var ref, ref1;
                const flatIndex = index * 100 + subIndex;
                const hasItems = (ref = CTAs.items) === null || ref === void 0 ? void 0 : ref.filter(isILink);
                return /* @__PURE__ */ /*#__PURE__*/ react.createElement(react.Fragment, {
                    key: (CTAs === null || CTAs === void 0 ? void 0 : (ref1 = CTAs.title) === null || ref1 === void 0 ? void 0 : ref1.text) + "overlay-category-".concat(CTAs.title, "-").concat(subIndex)
                }, CTAs.title && /* @__PURE__ */ /*#__PURE__*/ react.createElement(OverlayMenuCategory, {
                    title: CTAs.title,
                    isCTA: CTAs.isCTA,
                    links: hasItems || [],
                    opened: hasItems ? openCategoryIndex === flatIndex : void 0,
                    onToggle: hasItems ? ()=>setOpenCategoryIndex(openCategoryIndex === flatIndex ? null : flatIndex) : void 0,
                    className: CTAs.className
                }));
            }));
        }
        return /* @__PURE__ */ /*#__PURE__*/ react.createElement(react.Fragment, {
            key: (CTAList === null || CTAList === void 0 ? void 0 : (ref = CTAList.title) === null || ref === void 0 ? void 0 : ref.text) || "overlay-category-".concat(CTAList.title)
        }, CTAList.title ? /* @__PURE__ */ /*#__PURE__*/ react.createElement(OverlayMenuCategory, {
            title: CTAList.title,
            isCTA: CTAList.isCTA,
            links: ((ref1 = CTAList.items) === null || ref1 === void 0 ? void 0 : ref1.filter(isILink)) || [],
            opened: ((ref2 = CTAList.items) === null || ref2 === void 0 ? void 0 : ref2.filter(isILink)) && openCategoryIndex === index,
            onToggle: ((ref3 = CTAList.items) === null || ref3 === void 0 ? void 0 : ref3.filter(isILink)) ? ()=>setOpenCategoryIndex(openCategoryIndex === index ? null : index) : void 0
        }) : CTAList.items && CTAList.items.length && CTAList.items.length > 0 && CTAList.items.map((CTAs, index2)=>{
            var ref, ref1;
            /* @__PURE__ */ /*#__PURE__*/ return react.createElement(react.Fragment, {
                key: "".concat((CTAs === null || CTAs === void 0 ? void 0 : (ref = CTAs.title) === null || ref === void 0 ? void 0 : ref.text) || "no-title", "-overlay-category-").concat(index2)
            }, CTAs.title && /* @__PURE__ */ /*#__PURE__*/ react.createElement(OverlayMenuCategory, {
                title: CTAs.title,
                links: (ref1 = CTAs.items) === null || ref1 === void 0 ? void 0 : ref1.filter(isILink),
                showArrow: false,
                isExternal: CTAs.newTabGroup || CTAs.title.target === "_blank"
            }));
        }));
    })), CTAListsMobile.images && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        className: OverlayMenu_module_css_classes.overlayMenuMobileImages
    }, CTAListsMobile.images.map((image)=>{
        var ref;
        /* @__PURE__ */ /*#__PURE__*/ return react.createElement(OverlayMenuImage, {
            key: image.image.src,
            imagesLength: CTAListsMobile === null || CTAListsMobile === void 0 ? void 0 : (ref = CTAListsMobile.images) === null || ref === void 0 ? void 0 : ref.length,
            isBusinessTab: ![
                "Bathroom",
                "Collection",
                "Kitchen",
                "Lighting",
                "Wellness"
            ].includes((rest === null || rest === void 0 ? void 0 : rest.text) || ""),
            ...image
        });
    }))))), mainMenuItems && !selectedMobileMenuItem && /* @__PURE__ */ /*#__PURE__*/ react.createElement(UtilityBarMobile, {
        utilityLinks
    }));
});


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/subcomponents/MainNavigationBar/MainNavigationBar.hooks.mjs


const useResponsiveNav = (menuItems)=>{
    var ref;
    const [visibleItems, setVisibleItems] = (0,react.useState)(menuItems);
    const [overflowItems, setOverflowItems] = (0,react.useState)([]);
    const [isMoreOpen, setIsMoreOpen] = (0,react.useState)(false);
    const navRef = (0,react.useRef)(null);
    const containerRef = (0,react.useRef)(null);
    const moreButtonRef = (0,react.useRef)(null);
    const resizeTimeoutRef = (0,react.useRef)(null);
    const itemWidthsRef = (0,react.useRef)({});
    const windowSize = (0,use_window_size/* useWindowSize */.i)();
    const measureItemWidths = (0,react.useCallback)(()=>{
        if (!navRef.current) return;
        const newWidths = {};
        navRef.current.childNodes.forEach((node)=>{
            const element = node;
            if (element.id) {
                newWidths[element.id] = element.offsetWidth;
            }
        });
        itemWidthsRef.current = newWidths;
    }, []);
    const calculateVisibility = (0,react.useCallback)(()=>{
        var ref, ref1;
        if (!navRef.current || !containerRef.current) return;
        const containerWidth = containerRef.current.clientWidth;
        const moreButtonWidth = ((ref = moreButtonRef.current) === null || ref === void 0 ? void 0 : ref.offsetWidth) ? ((ref1 = moreButtonRef.current) === null || ref1 === void 0 ? void 0 : ref1.offsetWidth) + 15 : 70;
        let totalWidth = 0;
        const newVisibleItems = [];
        const newOverflowItems = [];
        for (const item of menuItems){
            const itemWidth = itemWidthsRef.current[item.text] || 0;
            totalWidth += itemWidth;
            if (totalWidth < containerWidth - moreButtonWidth) {
                newVisibleItems.push(item);
            } else {
                newOverflowItems.push(item);
            }
        }
        setVisibleItems(newVisibleItems);
        setOverflowItems(newOverflowItems);
    }, [
        menuItems
    ]);
    (0,react.useEffect)(()=>{
        if (resizeTimeoutRef.current) clearTimeout(resizeTimeoutRef.current);
        resizeTimeoutRef.current = setTimeout(()=>{
            measureItemWidths();
            calculateVisibility();
        }, 200);
        return ()=>{
            if (resizeTimeoutRef.current) clearTimeout(resizeTimeoutRef.current);
        };
    }, [
        windowSize.width,
        measureItemWidths,
        calculateVisibility,
        (ref = containerRef.current) === null || ref === void 0 ? void 0 : ref.offsetWidth
    ]);
    return {
        visibleItems,
        overflowItems,
        isMoreOpen,
        setIsMoreOpen,
        navRef,
        containerRef,
        moreButtonRef
    };
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/subcomponents/MainNavigationBar/MainNavigationBar.module.css.mjs
var MainNavigationBar_module_css_classes = {
    "mainNavGlobal": "js474",
    "mainNavUniversal": "_6h8rc",
    "navItemUniversal": "_8zpWB",
    "navItemVTwo": "JiWT8",
    "mainNav": "tnml-",
    "utilities": "Kfs6C",
    "brandLogo": "_62R2z",
    "navItem": "fiq1p",
    "mainNavBackground": "ne4QY",
    "mainNavRelative": "_1TdFf",
    "mainNavAtTop": "REGvp",
    "mainNavNotAtTop": "h6Yui",
    "mainNavVisible": "dusox",
    "mainNavFixed": "_5qc7P",
    "mainNavShadow": "j6WZ0",
    "mainNavWrapperDefault": "ILdLx",
    "mainNavWrapperUniversal": "cAdKk",
    "menuItemsVTwo": "RavHP",
    "menuItems": "i59c6",
    "menuItemsUniversal": "oCH4Z",
    "menuIconUniversal": "NRbDy",
    "menuIconVTwo": "WVEWj",
    "menuIconGlobal": "g0R4I",
    "menuIconUniversalUS": "rK-gR",
    "menuLinksVTwo": "k11A0",
    "menuLinks": "_5tXq-",
    "menuLinksWrapper": "e1Vtw",
    "menuLinksUniversal": "_0wrLM",
    "utilitiesDefaultGap": "ncbwH",
    "utilitiesUniversalGap": "YP18S",
    "buttonCTA": "RpRJd",
    "utilitiesMobile": "kEUDE",
    "utilitiesSearch": "PCr8F",
    "utilitiesSearchMobile": "z8Qye",
    "utilitiesSearchIcon": "dZIrv",
    "cartBadge": "_0Wxm-",
    "navigationOverlayMenuWrapper": "uD7ZK",
    "navigationItemWrapper": "_7DmRe",
    "navigationOverlayMenuVisible": "moPVk",
    "mobileOverlayMenu": "KTfSF",
    "navItemUnderline": "GTViv",
    "navItemUnderlineV2": "GS1aX"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/subcomponents/MainNavigationBar/MainNavigationBar.utils.mjs

const mainNavigationBarVariantClasses = {
    "v2.1": MainNavigationBar_module_css_classes.mainNavGlobal,
    universal: MainNavigationBar_module_css_classes.mainNavUniversal
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/subcomponents/MainNavigationBar/MainNavigationBar.mjs
"use client";









const MainNavigationBar = (0,factory_utils/* factory */.d5)((props, ref)=>{
    const { brandCTA , menuItems , showShadow , showDesktopActions =true , searchCTA , menuCTA , searchText ="Search" , buttonCTA , variant ="universal" , utilityLinks , showBackground =false , mod , openMobileMenu , closeCTA , setIsOpenMobileMenu , isStatic , style , showMenuDelay , transitionDuration , isAlwaysSticky , ...rest } = props;
    const isUniversal = variant === "universal";
    const { brand: brandType , ...brandCTAProps } = brandCTA;
    const [activeMenu, setActiveMenu] = (0,react.useState)(null);
    const hoverTimeoutRef = (0,react.useRef)(null);
    const { visibleItems , overflowItems , isMoreOpen , setIsMoreOpen , navRef , containerRef , moreButtonRef  } = useResponsiveNav(menuItems);
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        className: (0,clsx/* default */.Z)(MainNavigationBar_module_css_classes.mainNav, showShadow && MainNavigationBar_module_css_classes.mainNavShadow, mainNavigationBarVariantClasses[variant], showBackground && MainNavigationBar_module_css_classes.mainNavBackground, (isStatic || showBackground) && !isAlwaysSticky && MainNavigationBar_module_css_classes.mainNavRelative, "kohler-main-navigation-bar-root"),
        ref,
        style: {
            "--transition-overlay-duration": typeof transitionDuration === "number" ? "".concat(transitionDuration, "ms") : void 0,
            ...style
        },
        mod,
        ...rest
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Grid/* Grid */.r, null, /* @__PURE__ */ /*#__PURE__*/ react.createElement(GridColumn/* GridColumn */.C, null, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        className: isUniversal ? MainNavigationBar_module_css_classes.mainNavWrapperUniversal : MainNavigationBar_module_css_classes.mainNavWrapperDefault
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        className: (0,clsx/* default */.Z)(isUniversal ? MainNavigationBar_module_css_classes.menuItemsUniversal : MainNavigationBar_module_css_classes.menuItemsVTwo, MainNavigationBar_module_css_classes.menuItems)
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        component: "a",
        className: MainNavigationBar_module_css_classes.brandLogo,
        "aria-label": "".concat(brandType, " logo"),
        ...brandCTAProps
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(BrandLogo, {
        brand: brandType
    })), menuItems && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        ref: containerRef,
        className: MainNavigationBar_module_css_classes.menuLinksWrapper,
        component: "nav"
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        className: (0,clsx/* default */.Z)(isUniversal ? MainNavigationBar_module_css_classes.menuLinksUniversal : MainNavigationBar_module_css_classes.menuLinksVTwo, MainNavigationBar_module_css_classes.menuLinks),
        component: "ul",
        ref: navRef,
        role: "menubar"
    }, visibleItems.map((navItem)=>/* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
            component: "li",
            key: navItem.text,
            id: navItem.text || "nav-item-".concat(navItem.text),
            className: (0,clsx/* default */.Z)(MainNavigationBar_module_css_classes.navigationItemWrapper),
            onMouseEnter: ()=>{
                if (hoverTimeoutRef.current) clearTimeout(hoverTimeoutRef.current);
                hoverTimeoutRef.current = setTimeout(()=>{
                    setActiveMenu(navItem.text);
                }, typeof showMenuDelay === "number" ? showMenuDelay : 0);
            },
            onMouseLeave: ()=>{
                if (hoverTimeoutRef.current) {
                    clearTimeout(hoverTimeoutRef.current);
                    hoverTimeoutRef.current = null;
                }
                setActiveMenu(null);
            },
            tabIndex: 0,
            role: "menuitem",
            "aria-haspopup": !!navItem.CTALists,
            "aria-expanded": activeMenu === navItem.text,
            onKeyDown: (e)=>{
                if ((e.key === "Enter" || e.key === " ") && navItem.CTALists) {
                    e.preventDefault();
                    const navText = navItem.text;
                    setActiveMenu((prev)=>prev === navText ? null : navText);
                }
            }
        }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(NavigationItem, {
            text: navItem.text,
            isSelected: navItem.isSelected,
            href: navItem.href,
            variant,
            className: (0,clsx/* default */.Z)(isUniversal ? MainNavigationBar_module_css_classes.navItemUniversal : MainNavigationBar_module_css_classes.navItemVTwo, MainNavigationBar_module_css_classes.navItem, activeMenu === navItem.text && isUniversal && MainNavigationBar_module_css_classes.navItemUnderline, activeMenu === navItem.text && !isUniversal && MainNavigationBar_module_css_classes.navItemUnderlineV2)
        }), navItem.CTALists && /* @__PURE__ */ /*#__PURE__*/ react.createElement(react.Fragment, null, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
            className: (0,clsx/* default */.Z)(MainNavigationBar_module_css_classes.navigationOverlayMenuWrapper, activeMenu === navItem.text ? MainNavigationBar_module_css_classes.navigationOverlayMenuVisible : MainNavigationBar_module_css_classes.navigationOverlayMenuHidden)
        }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(OverlayMenu, {
            mod: "white",
            ...navItem
        }))))), overflowItems.length > 0 && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        component: "li",
        ref: moreButtonRef,
        className: (0,clsx/* default */.Z)(MainNavigationBar_module_css_classes.navigationItemWrapper, MainNavigationBar_module_css_classes.moreButton),
        onMouseEnter: ()=>setIsMoreOpen(true),
        onMouseLeave: ()=>setIsMoreOpen(false),
        role: "menuitem"
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(NavigationItem, {
        className: (0,clsx/* default */.Z)(isUniversal ? MainNavigationBar_module_css_classes.navItemUniversal : MainNavigationBar_module_css_classes.navItemVTwo, MainNavigationBar_module_css_classes.navItem),
        text: /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
            gap: 5,
            align: "center"
        }, "More ", /* @__PURE__ */ /*#__PURE__*/ react.createElement(ArrowDownIcon/* ArrowDownIcon */.v, {
            size: "xSmall",
            withBoundingBox: false,
            style: {
                flexShrink: 0
            }
        })),
        variant
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        className: (0,clsx/* default */.Z)(MainNavigationBar_module_css_classes.navigationOverlayMenuWrapper, isMoreOpen ? MainNavigationBar_module_css_classes.navigationOverlayMenuVisible : MainNavigationBar_module_css_classes.navigationOverlayMenuHidden)
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(OverlayMenu, {
        mod: "white",
        isMoreOverlay: true,
        mainMenuItems: overflowItems
    }))), overflowItems.map((navItem)=>/* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
            component: "li",
            key: navItem.text,
            id: navItem.text || "nav-item-".concat(navItem.text),
            className: (0,clsx/* default */.Z)(MainNavigationBar_module_css_classes.navigationItemWrapper),
            style: {
                visibility: "hidden",
                opacity: 0
            }
        }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(NavigationItem, {
            text: navItem.text,
            isSelected: navItem.isSelected,
            href: navItem.href,
            variant,
            className: (0,clsx/* default */.Z)(isUniversal ? MainNavigationBar_module_css_classes.navItemUniversal : MainNavigationBar_module_css_classes.navItemVTwo, MainNavigationBar_module_css_classes.navItem, activeMenu === navItem.text && isUniversal && MainNavigationBar_module_css_classes.navItemUnderline, activeMenu === navItem.text && !isUniversal && MainNavigationBar_module_css_classes.navItemUnderlineV2)
        })))))), (showDesktopActions || buttonCTA) && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        className: (0,clsx/* default */.Z)(MainNavigationBar_module_css_classes.utilities, isUniversal ? MainNavigationBar_module_css_classes.utilitiesUniversalGap : MainNavigationBar_module_css_classes.utilitiesDefaultGap)
    }, buttonCTA && /* @__PURE__ */ /*#__PURE__*/ react.createElement(react.Fragment, null, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Link/* Link */.r, {
        type: buttonCTA.onClick ? "button" : void 0,
        component: "href" in buttonCTA && buttonCTA.href ? "a" : "button",
        size: "small",
        ...(0,helpers/* omitText */.rW)(buttonCTA),
        className: (0,clsx/* default */.Z)(MainNavigationBar_module_css_classes.buttonCTA, buttonCTA.className)
    }, buttonCTA.text)), searchCTA && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        component: "button",
        type: "button",
        "aria-label": searchText,
        ...searchCTA,
        className: (0,clsx/* default */.Z)(MainNavigationBar_module_css_classes.utilitiesSearch, searchCTA.className)
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        size: "paragraph-small",
        component: "span"
    }, searchText), /* @__PURE__ */ /*#__PURE__*/ react.createElement(SearchIcon, {
        className: MainNavigationBar_module_css_classes.utilitiesSearchIcon,
        withBoundingBox: false
    })), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        className: MainNavigationBar_module_css_classes.utilitiesMobile,
        gap: 15
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        component: "button",
        type: "button",
        "aria-label": searchText,
        ...searchCTA,
        className: (0,clsx/* default */.Z)(MainNavigationBar_module_css_classes.utilitiesSearchMobile, searchCTA === null || searchCTA === void 0 ? void 0 : searchCTA.className)
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(SearchIcon, {
        className: MainNavigationBar_module_css_classes.utilitiesSearchIcon,
        withBoundingBox: false
    })), (utilityLinks === null || utilityLinks === void 0 ? void 0 : utilityLinks.cartBadgeCTA) && /* @__PURE__ */ /*#__PURE__*/ react.createElement(CartBadge, {
        component: "a",
        "aria-label": "see shopping cart",
        ...utilityLinks === null || utilityLinks === void 0 ? void 0 : utilityLinks.cartBadgeCTA,
        className: (0,clsx/* default */.Z)(MainNavigationBar_module_css_classes.utilityLink, utilityLinks.className)
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        component: "button",
        type: "button",
        "aria-label": "open menu",
        ...menuCTA,
        className: (0,clsx/* default */.Z)(isUniversal ? MainNavigationBar_module_css_classes.menuIconUniversal : MainNavigationBar_module_css_classes.menuIconVTwo, menuCTA === null || menuCTA === void 0 ? void 0 : menuCTA.className),
        onClick: (e)=>{
            if (setIsOpenMobileMenu) {
                setIsOpenMobileMenu(true);
            }
            if (menuCTA === null || menuCTA === void 0 ? void 0 : menuCTA.onClick) {
                menuCTA.onClick(e);
            }
        }
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(MenuIcon/* MenuIcon */.O, {
        size: "medium",
        withBoundingBox: false
    })))), openMobileMenu && /* @__PURE__ */ /*#__PURE__*/ react.createElement(OverlayMenu, {
        mainMenuItems: menuItems,
        className: MainNavigationBar_module_css_classes.mobileOverlayMenu,
        setIsOpenMobileMenu,
        utilityLinks,
        buttonCTA,
        closeCTA
    })))));
});


;// CONCATENATED MODULE: ./node_modules/embla-carousel-reactive-utils/esm/embla-carousel-reactive-utils.esm.js
function isObject(subject) {
  return Object.prototype.toString.call(subject) === '[object Object]';
}
function isRecord(subject) {
  return isObject(subject) || Array.isArray(subject);
}
function canUseDOM() {
  return !!(typeof window !== 'undefined' && window.document && window.document.createElement);
}
function areOptionsEqual(optionsA, optionsB) {
  const optionsAKeys = Object.keys(optionsA);
  const optionsBKeys = Object.keys(optionsB);
  if (optionsAKeys.length !== optionsBKeys.length) return false;
  const breakpointsA = JSON.stringify(Object.keys(optionsA.breakpoints || {}));
  const breakpointsB = JSON.stringify(Object.keys(optionsB.breakpoints || {}));
  if (breakpointsA !== breakpointsB) return false;
  return optionsAKeys.every(key => {
    const valueA = optionsA[key];
    const valueB = optionsB[key];
    if (typeof valueA === 'function') return `${valueA}` === `${valueB}`;
    if (!isRecord(valueA) || !isRecord(valueB)) return valueA === valueB;
    return areOptionsEqual(valueA, valueB);
  });
}
function sortAndMapPluginToOptions(plugins) {
  return plugins.concat().sort((a, b) => a.name > b.name ? 1 : -1).map(plugin => plugin.options);
}
function arePluginsEqual(pluginsA, pluginsB) {
  if (pluginsA.length !== pluginsB.length) return false;
  const optionsA = sortAndMapPluginToOptions(pluginsA);
  const optionsB = sortAndMapPluginToOptions(pluginsB);
  return optionsA.every((optionA, index) => {
    const optionB = optionsB[index];
    return areOptionsEqual(optionA, optionB);
  });
}


//# sourceMappingURL=embla-carousel-reactive-utils.esm.js.map

;// CONCATENATED MODULE: ./node_modules/embla-carousel/esm/embla-carousel.esm.js
function isNumber(subject) {
  return typeof subject === 'number';
}
function isString(subject) {
  return typeof subject === 'string';
}
function isBoolean(subject) {
  return typeof subject === 'boolean';
}
function embla_carousel_esm_isObject(subject) {
  return Object.prototype.toString.call(subject) === '[object Object]';
}
function mathAbs(n) {
  return Math.abs(n);
}
function mathSign(n) {
  return Math.sign(n);
}
function deltaAbs(valueB, valueA) {
  return mathAbs(valueB - valueA);
}
function factorAbs(valueB, valueA) {
  if (valueB === 0 || valueA === 0) return 0;
  if (mathAbs(valueB) <= mathAbs(valueA)) return 0;
  const diff = deltaAbs(mathAbs(valueB), mathAbs(valueA));
  return mathAbs(diff / valueB);
}
function roundToTwoDecimals(num) {
  return Math.round(num * 100) / 100;
}
function arrayKeys(array) {
  return objectKeys(array).map(Number);
}
function arrayLast(array) {
  return array[arrayLastIndex(array)];
}
function arrayLastIndex(array) {
  return Math.max(0, array.length - 1);
}
function arrayIsLastIndex(array, index) {
  return index === arrayLastIndex(array);
}
function arrayFromNumber(n, startAt = 0) {
  return Array.from(Array(n), (_, i) => startAt + i);
}
function objectKeys(object) {
  return Object.keys(object);
}
function objectsMergeDeep(objectA, objectB) {
  return [objectA, objectB].reduce((mergedObjects, currentObject) => {
    objectKeys(currentObject).forEach(key => {
      const valueA = mergedObjects[key];
      const valueB = currentObject[key];
      const areObjects = embla_carousel_esm_isObject(valueA) && embla_carousel_esm_isObject(valueB);
      mergedObjects[key] = areObjects ? objectsMergeDeep(valueA, valueB) : valueB;
    });
    return mergedObjects;
  }, {});
}
function isMouseEvent(evt, ownerWindow) {
  return typeof ownerWindow.MouseEvent !== 'undefined' && evt instanceof ownerWindow.MouseEvent;
}

function Alignment(align, viewSize) {
  const predefined = {
    start,
    center,
    end
  };
  function start() {
    return 0;
  }
  function center(n) {
    return end(n) / 2;
  }
  function end(n) {
    return viewSize - n;
  }
  function measure(n, index) {
    if (isString(align)) return predefined[align](n);
    return align(viewSize, n, index);
  }
  const self = {
    measure
  };
  return self;
}

function EventStore() {
  let listeners = [];
  function add(node, type, handler, options = {
    passive: true
  }) {
    let removeListener;
    if ('addEventListener' in node) {
      node.addEventListener(type, handler, options);
      removeListener = () => node.removeEventListener(type, handler, options);
    } else {
      const legacyMediaQueryList = node;
      legacyMediaQueryList.addListener(handler);
      removeListener = () => legacyMediaQueryList.removeListener(handler);
    }
    listeners.push(removeListener);
    return self;
  }
  function clear() {
    listeners = listeners.filter(remove => remove());
  }
  const self = {
    add,
    clear
  };
  return self;
}

function Animations(ownerDocument, ownerWindow, update, render) {
  const documentVisibleHandler = EventStore();
  const fixedTimeStep = 1000 / 60;
  let lastTimeStamp = null;
  let accumulatedTime = 0;
  let animationId = 0;
  function init() {
    documentVisibleHandler.add(ownerDocument, 'visibilitychange', () => {
      if (ownerDocument.hidden) reset();
    });
  }
  function destroy() {
    stop();
    documentVisibleHandler.clear();
  }
  function animate(timeStamp) {
    if (!animationId) return;
    if (!lastTimeStamp) {
      lastTimeStamp = timeStamp;
      update();
      update();
    }
    const timeElapsed = timeStamp - lastTimeStamp;
    lastTimeStamp = timeStamp;
    accumulatedTime += timeElapsed;
    while (accumulatedTime >= fixedTimeStep) {
      update();
      accumulatedTime -= fixedTimeStep;
    }
    const alpha = accumulatedTime / fixedTimeStep;
    render(alpha);
    if (animationId) {
      animationId = ownerWindow.requestAnimationFrame(animate);
    }
  }
  function start() {
    if (animationId) return;
    animationId = ownerWindow.requestAnimationFrame(animate);
  }
  function stop() {
    ownerWindow.cancelAnimationFrame(animationId);
    lastTimeStamp = null;
    accumulatedTime = 0;
    animationId = 0;
  }
  function reset() {
    lastTimeStamp = null;
    accumulatedTime = 0;
  }
  const self = {
    init,
    destroy,
    start,
    stop,
    update,
    render
  };
  return self;
}

function Axis(axis, contentDirection) {
  const isRightToLeft = contentDirection === 'rtl';
  const isVertical = axis === 'y';
  const scroll = isVertical ? 'y' : 'x';
  const cross = isVertical ? 'x' : 'y';
  const sign = !isVertical && isRightToLeft ? -1 : 1;
  const startEdge = getStartEdge();
  const endEdge = getEndEdge();
  function measureSize(nodeRect) {
    const {
      height,
      width
    } = nodeRect;
    return isVertical ? height : width;
  }
  function getStartEdge() {
    if (isVertical) return 'top';
    return isRightToLeft ? 'right' : 'left';
  }
  function getEndEdge() {
    if (isVertical) return 'bottom';
    return isRightToLeft ? 'left' : 'right';
  }
  function direction(n) {
    return n * sign;
  }
  const self = {
    scroll,
    cross,
    startEdge,
    endEdge,
    measureSize,
    direction
  };
  return self;
}

function Limit(min = 0, max = 0) {
  const length = mathAbs(min - max);
  function reachedMin(n) {
    return n < min;
  }
  function reachedMax(n) {
    return n > max;
  }
  function reachedAny(n) {
    return reachedMin(n) || reachedMax(n);
  }
  function constrain(n) {
    if (!reachedAny(n)) return n;
    return reachedMin(n) ? min : max;
  }
  function removeOffset(n) {
    if (!length) return n;
    return n - length * Math.ceil((n - max) / length);
  }
  const self = {
    length,
    max,
    min,
    constrain,
    reachedAny,
    reachedMax,
    reachedMin,
    removeOffset
  };
  return self;
}

function Counter(max, start, loop) {
  const {
    constrain
  } = Limit(0, max);
  const loopEnd = max + 1;
  let counter = withinLimit(start);
  function withinLimit(n) {
    return !loop ? constrain(n) : mathAbs((loopEnd + n) % loopEnd);
  }
  function get() {
    return counter;
  }
  function set(n) {
    counter = withinLimit(n);
    return self;
  }
  function add(n) {
    return clone().set(get() + n);
  }
  function clone() {
    return Counter(max, get(), loop);
  }
  const self = {
    get,
    set,
    add,
    clone
  };
  return self;
}

function DragHandler(axis, rootNode, ownerDocument, ownerWindow, target, dragTracker, location, animation, scrollTo, scrollBody, scrollTarget, index, eventHandler, percentOfView, dragFree, dragThreshold, skipSnaps, baseFriction, watchDrag) {
  const {
    cross: crossAxis,
    direction
  } = axis;
  const focusNodes = ['INPUT', 'SELECT', 'TEXTAREA'];
  const nonPassiveEvent = {
    passive: false
  };
  const initEvents = EventStore();
  const dragEvents = EventStore();
  const goToNextThreshold = Limit(50, 225).constrain(percentOfView.measure(20));
  const snapForceBoost = {
    mouse: 300,
    touch: 400
  };
  const freeForceBoost = {
    mouse: 500,
    touch: 600
  };
  const baseSpeed = dragFree ? 43 : 25;
  let isMoving = false;
  let startScroll = 0;
  let startCross = 0;
  let pointerIsDown = false;
  let preventScroll = false;
  let preventClick = false;
  let isMouse = false;
  function init(emblaApi) {
    if (!watchDrag) return;
    function downIfAllowed(evt) {
      if (isBoolean(watchDrag) || watchDrag(emblaApi, evt)) down(evt);
    }
    const node = rootNode;
    initEvents.add(node, 'dragstart', evt => evt.preventDefault(), nonPassiveEvent).add(node, 'touchmove', () => undefined, nonPassiveEvent).add(node, 'touchend', () => undefined).add(node, 'touchstart', downIfAllowed).add(node, 'mousedown', downIfAllowed).add(node, 'touchcancel', up).add(node, 'contextmenu', up).add(node, 'click', click, true);
  }
  function destroy() {
    initEvents.clear();
    dragEvents.clear();
  }
  function addDragEvents() {
    const node = isMouse ? ownerDocument : rootNode;
    dragEvents.add(node, 'touchmove', move, nonPassiveEvent).add(node, 'touchend', up).add(node, 'mousemove', move, nonPassiveEvent).add(node, 'mouseup', up);
  }
  function isFocusNode(node) {
    const nodeName = node.nodeName || '';
    return focusNodes.includes(nodeName);
  }
  function forceBoost() {
    const boost = dragFree ? freeForceBoost : snapForceBoost;
    const type = isMouse ? 'mouse' : 'touch';
    return boost[type];
  }
  function allowedForce(force, targetChanged) {
    const next = index.add(mathSign(force) * -1);
    const baseForce = scrollTarget.byDistance(force, !dragFree).distance;
    if (dragFree || mathAbs(force) < goToNextThreshold) return baseForce;
    if (skipSnaps && targetChanged) return baseForce * 0.5;
    return scrollTarget.byIndex(next.get(), 0).distance;
  }
  function down(evt) {
    const isMouseEvt = isMouseEvent(evt, ownerWindow);
    isMouse = isMouseEvt;
    preventClick = dragFree && isMouseEvt && !evt.buttons && isMoving;
    isMoving = deltaAbs(target.get(), location.get()) >= 2;
    if (isMouseEvt && evt.button !== 0) return;
    if (isFocusNode(evt.target)) return;
    pointerIsDown = true;
    dragTracker.pointerDown(evt);
    scrollBody.useFriction(0).useDuration(0);
    target.set(location);
    addDragEvents();
    startScroll = dragTracker.readPoint(evt);
    startCross = dragTracker.readPoint(evt, crossAxis);
    eventHandler.emit('pointerDown');
  }
  function move(evt) {
    const isTouchEvt = !isMouseEvent(evt, ownerWindow);
    if (isTouchEvt && evt.touches.length >= 2) return up(evt);
    const lastScroll = dragTracker.readPoint(evt);
    const lastCross = dragTracker.readPoint(evt, crossAxis);
    const diffScroll = deltaAbs(lastScroll, startScroll);
    const diffCross = deltaAbs(lastCross, startCross);
    if (!preventScroll && !isMouse) {
      if (!evt.cancelable) return up(evt);
      preventScroll = diffScroll > diffCross;
      if (!preventScroll) return up(evt);
    }
    const diff = dragTracker.pointerMove(evt);
    if (diffScroll > dragThreshold) preventClick = true;
    scrollBody.useFriction(0.3).useDuration(0.75);
    animation.start();
    target.add(direction(diff));
    evt.preventDefault();
  }
  function up(evt) {
    const currentLocation = scrollTarget.byDistance(0, false);
    const targetChanged = currentLocation.index !== index.get();
    const rawForce = dragTracker.pointerUp(evt) * forceBoost();
    const force = allowedForce(direction(rawForce), targetChanged);
    const forceFactor = factorAbs(rawForce, force);
    const speed = baseSpeed - 10 * forceFactor;
    const friction = baseFriction + forceFactor / 50;
    preventScroll = false;
    pointerIsDown = false;
    dragEvents.clear();
    scrollBody.useDuration(speed).useFriction(friction);
    scrollTo.distance(force, !dragFree);
    isMouse = false;
    eventHandler.emit('pointerUp');
  }
  function click(evt) {
    if (preventClick) {
      evt.stopPropagation();
      evt.preventDefault();
      preventClick = false;
    }
  }
  function pointerDown() {
    return pointerIsDown;
  }
  const self = {
    init,
    destroy,
    pointerDown
  };
  return self;
}

function DragTracker(axis, ownerWindow) {
  const logInterval = 170;
  let startEvent;
  let lastEvent;
  function readTime(evt) {
    return evt.timeStamp;
  }
  function readPoint(evt, evtAxis) {
    const property = evtAxis || axis.scroll;
    const coord = `client${property === 'x' ? 'X' : 'Y'}`;
    return (isMouseEvent(evt, ownerWindow) ? evt : evt.touches[0])[coord];
  }
  function pointerDown(evt) {
    startEvent = evt;
    lastEvent = evt;
    return readPoint(evt);
  }
  function pointerMove(evt) {
    const diff = readPoint(evt) - readPoint(lastEvent);
    const expired = readTime(evt) - readTime(startEvent) > logInterval;
    lastEvent = evt;
    if (expired) startEvent = evt;
    return diff;
  }
  function pointerUp(evt) {
    if (!startEvent || !lastEvent) return 0;
    const diffDrag = readPoint(lastEvent) - readPoint(startEvent);
    const diffTime = readTime(evt) - readTime(startEvent);
    const expired = readTime(evt) - readTime(lastEvent) > logInterval;
    const force = diffDrag / diffTime;
    const isFlick = diffTime && !expired && mathAbs(force) > 0.1;
    return isFlick ? force : 0;
  }
  const self = {
    pointerDown,
    pointerMove,
    pointerUp,
    readPoint
  };
  return self;
}

function NodeRects() {
  function measure(node) {
    const {
      offsetTop,
      offsetLeft,
      offsetWidth,
      offsetHeight
    } = node;
    const offset = {
      top: offsetTop,
      right: offsetLeft + offsetWidth,
      bottom: offsetTop + offsetHeight,
      left: offsetLeft,
      width: offsetWidth,
      height: offsetHeight
    };
    return offset;
  }
  const self = {
    measure
  };
  return self;
}

function PercentOfView(viewSize) {
  function measure(n) {
    return viewSize * (n / 100);
  }
  const self = {
    measure
  };
  return self;
}

function ResizeHandler(container, eventHandler, ownerWindow, slides, axis, watchResize, nodeRects) {
  const observeNodes = [container].concat(slides);
  let resizeObserver;
  let containerSize;
  let slideSizes = [];
  let destroyed = false;
  function readSize(node) {
    return axis.measureSize(nodeRects.measure(node));
  }
  function init(emblaApi) {
    if (!watchResize) return;
    containerSize = readSize(container);
    slideSizes = slides.map(readSize);
    function defaultCallback(entries) {
      for (const entry of entries) {
        if (destroyed) return;
        const isContainer = entry.target === container;
        const slideIndex = slides.indexOf(entry.target);
        const lastSize = isContainer ? containerSize : slideSizes[slideIndex];
        const newSize = readSize(isContainer ? container : slides[slideIndex]);
        const diffSize = mathAbs(newSize - lastSize);
        if (diffSize >= 0.5) {
          emblaApi.reInit();
          eventHandler.emit('resize');
          break;
        }
      }
    }
    resizeObserver = new ResizeObserver(entries => {
      if (isBoolean(watchResize) || watchResize(emblaApi, entries)) {
        defaultCallback(entries);
      }
    });
    ownerWindow.requestAnimationFrame(() => {
      observeNodes.forEach(node => resizeObserver.observe(node));
    });
  }
  function destroy() {
    destroyed = true;
    if (resizeObserver) resizeObserver.disconnect();
  }
  const self = {
    init,
    destroy
  };
  return self;
}

function ScrollBody(location, offsetLocation, previousLocation, target, baseDuration, baseFriction) {
  let scrollVelocity = 0;
  let scrollDirection = 0;
  let scrollDuration = baseDuration;
  let scrollFriction = baseFriction;
  let rawLocation = location.get();
  let rawLocationPrevious = 0;
  function seek() {
    const displacement = target.get() - location.get();
    const isInstant = !scrollDuration;
    let scrollDistance = 0;
    if (isInstant) {
      scrollVelocity = 0;
      previousLocation.set(target);
      location.set(target);
      scrollDistance = displacement;
    } else {
      previousLocation.set(location);
      scrollVelocity += displacement / scrollDuration;
      scrollVelocity *= scrollFriction;
      rawLocation += scrollVelocity;
      location.add(scrollVelocity);
      scrollDistance = rawLocation - rawLocationPrevious;
    }
    scrollDirection = mathSign(scrollDistance);
    rawLocationPrevious = rawLocation;
    return self;
  }
  function settled() {
    const diff = target.get() - offsetLocation.get();
    return mathAbs(diff) < 0.001;
  }
  function duration() {
    return scrollDuration;
  }
  function direction() {
    return scrollDirection;
  }
  function velocity() {
    return scrollVelocity;
  }
  function useBaseDuration() {
    return useDuration(baseDuration);
  }
  function useBaseFriction() {
    return useFriction(baseFriction);
  }
  function useDuration(n) {
    scrollDuration = n;
    return self;
  }
  function useFriction(n) {
    scrollFriction = n;
    return self;
  }
  const self = {
    direction,
    duration,
    velocity,
    seek,
    settled,
    useBaseFriction,
    useBaseDuration,
    useFriction,
    useDuration
  };
  return self;
}

function ScrollBounds(limit, location, target, scrollBody, percentOfView) {
  const pullBackThreshold = percentOfView.measure(10);
  const edgeOffsetTolerance = percentOfView.measure(50);
  const frictionLimit = Limit(0.1, 0.99);
  let disabled = false;
  function shouldConstrain() {
    if (disabled) return false;
    if (!limit.reachedAny(target.get())) return false;
    if (!limit.reachedAny(location.get())) return false;
    return true;
  }
  function constrain(pointerDown) {
    if (!shouldConstrain()) return;
    const edge = limit.reachedMin(location.get()) ? 'min' : 'max';
    const diffToEdge = mathAbs(limit[edge] - location.get());
    const diffToTarget = target.get() - location.get();
    const friction = frictionLimit.constrain(diffToEdge / edgeOffsetTolerance);
    target.subtract(diffToTarget * friction);
    if (!pointerDown && mathAbs(diffToTarget) < pullBackThreshold) {
      target.set(limit.constrain(target.get()));
      scrollBody.useDuration(25).useBaseFriction();
    }
  }
  function toggleActive(active) {
    disabled = !active;
  }
  const self = {
    shouldConstrain,
    constrain,
    toggleActive
  };
  return self;
}

function ScrollContain(viewSize, contentSize, snapsAligned, containScroll, pixelTolerance) {
  const scrollBounds = Limit(-contentSize + viewSize, 0);
  const snapsBounded = measureBounded();
  const scrollContainLimit = findScrollContainLimit();
  const snapsContained = measureContained();
  function usePixelTolerance(bound, snap) {
    return deltaAbs(bound, snap) <= 1;
  }
  function findScrollContainLimit() {
    const startSnap = snapsBounded[0];
    const endSnap = arrayLast(snapsBounded);
    const min = snapsBounded.lastIndexOf(startSnap);
    const max = snapsBounded.indexOf(endSnap) + 1;
    return Limit(min, max);
  }
  function measureBounded() {
    return snapsAligned.map((snapAligned, index) => {
      const {
        min,
        max
      } = scrollBounds;
      const snap = scrollBounds.constrain(snapAligned);
      const isFirst = !index;
      const isLast = arrayIsLastIndex(snapsAligned, index);
      if (isFirst) return max;
      if (isLast) return min;
      if (usePixelTolerance(min, snap)) return min;
      if (usePixelTolerance(max, snap)) return max;
      return snap;
    }).map(scrollBound => parseFloat(scrollBound.toFixed(3)));
  }
  function measureContained() {
    if (contentSize <= viewSize + pixelTolerance) return [scrollBounds.max];
    if (containScroll === 'keepSnaps') return snapsBounded;
    const {
      min,
      max
    } = scrollContainLimit;
    return snapsBounded.slice(min, max);
  }
  const self = {
    snapsContained,
    scrollContainLimit
  };
  return self;
}

function ScrollLimit(contentSize, scrollSnaps, loop) {
  const max = scrollSnaps[0];
  const min = loop ? max - contentSize : arrayLast(scrollSnaps);
  const limit = Limit(min, max);
  const self = {
    limit
  };
  return self;
}

function ScrollLooper(contentSize, limit, location, vectors) {
  const jointSafety = 0.1;
  const min = limit.min + jointSafety;
  const max = limit.max + jointSafety;
  const {
    reachedMin,
    reachedMax
  } = Limit(min, max);
  function shouldLoop(direction) {
    if (direction === 1) return reachedMax(location.get());
    if (direction === -1) return reachedMin(location.get());
    return false;
  }
  function loop(direction) {
    if (!shouldLoop(direction)) return;
    const loopDistance = contentSize * (direction * -1);
    vectors.forEach(v => v.add(loopDistance));
  }
  const self = {
    loop
  };
  return self;
}

function ScrollProgress(limit) {
  const {
    max,
    length
  } = limit;
  function get(n) {
    const currentLocation = n - max;
    return length ? currentLocation / -length : 0;
  }
  const self = {
    get
  };
  return self;
}

function ScrollSnaps(axis, alignment, containerRect, slideRects, slidesToScroll) {
  const {
    startEdge,
    endEdge
  } = axis;
  const {
    groupSlides
  } = slidesToScroll;
  const alignments = measureSizes().map(alignment.measure);
  const snaps = measureUnaligned();
  const snapsAligned = measureAligned();
  function measureSizes() {
    return groupSlides(slideRects).map(rects => arrayLast(rects)[endEdge] - rects[0][startEdge]).map(mathAbs);
  }
  function measureUnaligned() {
    return slideRects.map(rect => containerRect[startEdge] - rect[startEdge]).map(snap => -mathAbs(snap));
  }
  function measureAligned() {
    return groupSlides(snaps).map(g => g[0]).map((snap, index) => snap + alignments[index]);
  }
  const self = {
    snaps,
    snapsAligned
  };
  return self;
}

function SlideRegistry(containSnaps, containScroll, scrollSnaps, scrollContainLimit, slidesToScroll, slideIndexes) {
  const {
    groupSlides
  } = slidesToScroll;
  const {
    min,
    max
  } = scrollContainLimit;
  const slideRegistry = createSlideRegistry();
  function createSlideRegistry() {
    const groupedSlideIndexes = groupSlides(slideIndexes);
    const doNotContain = !containSnaps || containScroll === 'keepSnaps';
    if (scrollSnaps.length === 1) return [slideIndexes];
    if (doNotContain) return groupedSlideIndexes;
    return groupedSlideIndexes.slice(min, max).map((group, index, groups) => {
      const isFirst = !index;
      const isLast = arrayIsLastIndex(groups, index);
      if (isFirst) {
        const range = arrayLast(groups[0]) + 1;
        return arrayFromNumber(range);
      }
      if (isLast) {
        const range = arrayLastIndex(slideIndexes) - arrayLast(groups)[0] + 1;
        return arrayFromNumber(range, arrayLast(groups)[0]);
      }
      return group;
    });
  }
  const self = {
    slideRegistry
  };
  return self;
}

function ScrollTarget(loop, scrollSnaps, contentSize, limit, targetVector) {
  const {
    reachedAny,
    removeOffset,
    constrain
  } = limit;
  function minDistance(distances) {
    return distances.concat().sort((a, b) => mathAbs(a) - mathAbs(b))[0];
  }
  function findTargetSnap(target) {
    const distance = loop ? removeOffset(target) : constrain(target);
    const ascDiffsToSnaps = scrollSnaps.map((snap, index) => ({
      diff: shortcut(snap - distance, 0),
      index
    })).sort((d1, d2) => mathAbs(d1.diff) - mathAbs(d2.diff));
    const {
      index
    } = ascDiffsToSnaps[0];
    return {
      index,
      distance
    };
  }
  function shortcut(target, direction) {
    const targets = [target, target + contentSize, target - contentSize];
    if (!loop) return target;
    if (!direction) return minDistance(targets);
    const matchingTargets = targets.filter(t => mathSign(t) === direction);
    if (matchingTargets.length) return minDistance(matchingTargets);
    return arrayLast(targets) - contentSize;
  }
  function byIndex(index, direction) {
    const diffToSnap = scrollSnaps[index] - targetVector.get();
    const distance = shortcut(diffToSnap, direction);
    return {
      index,
      distance
    };
  }
  function byDistance(distance, snap) {
    const target = targetVector.get() + distance;
    const {
      index,
      distance: targetSnapDistance
    } = findTargetSnap(target);
    const reachedBound = !loop && reachedAny(target);
    if (!snap || reachedBound) return {
      index,
      distance
    };
    const diffToSnap = scrollSnaps[index] - targetSnapDistance;
    const snapDistance = distance + shortcut(diffToSnap, 0);
    return {
      index,
      distance: snapDistance
    };
  }
  const self = {
    byDistance,
    byIndex,
    shortcut
  };
  return self;
}

function ScrollTo(animation, indexCurrent, indexPrevious, scrollBody, scrollTarget, targetVector, eventHandler) {
  function scrollTo(target) {
    const distanceDiff = target.distance;
    const indexDiff = target.index !== indexCurrent.get();
    targetVector.add(distanceDiff);
    if (distanceDiff) {
      if (scrollBody.duration()) {
        animation.start();
      } else {
        animation.update();
        animation.render(1);
        animation.update();
      }
    }
    if (indexDiff) {
      indexPrevious.set(indexCurrent.get());
      indexCurrent.set(target.index);
      eventHandler.emit('select');
    }
  }
  function distance(n, snap) {
    const target = scrollTarget.byDistance(n, snap);
    scrollTo(target);
  }
  function index(n, direction) {
    const targetIndex = indexCurrent.clone().set(n);
    const target = scrollTarget.byIndex(targetIndex.get(), direction);
    scrollTo(target);
  }
  const self = {
    distance,
    index
  };
  return self;
}

function SlideFocus(root, slides, slideRegistry, scrollTo, scrollBody, eventStore, eventHandler, watchFocus) {
  const focusListenerOptions = {
    passive: true,
    capture: true
  };
  let lastTabPressTime = 0;
  function init(emblaApi) {
    if (!watchFocus) return;
    function defaultCallback(index) {
      const nowTime = new Date().getTime();
      const diffTime = nowTime - lastTabPressTime;
      if (diffTime > 10) return;
      eventHandler.emit('slideFocusStart');
      root.scrollLeft = 0;
      const group = slideRegistry.findIndex(group => group.includes(index));
      if (!isNumber(group)) return;
      scrollBody.useDuration(0);
      scrollTo.index(group, 0);
      eventHandler.emit('slideFocus');
    }
    eventStore.add(document, 'keydown', registerTabPress, false);
    slides.forEach((slide, slideIndex) => {
      eventStore.add(slide, 'focus', evt => {
        if (isBoolean(watchFocus) || watchFocus(emblaApi, evt)) {
          defaultCallback(slideIndex);
        }
      }, focusListenerOptions);
    });
  }
  function registerTabPress(event) {
    if (event.code === 'Tab') lastTabPressTime = new Date().getTime();
  }
  const self = {
    init
  };
  return self;
}

function Vector1D(initialValue) {
  let value = initialValue;
  function get() {
    return value;
  }
  function set(n) {
    value = normalizeInput(n);
  }
  function add(n) {
    value += normalizeInput(n);
  }
  function subtract(n) {
    value -= normalizeInput(n);
  }
  function normalizeInput(n) {
    return isNumber(n) ? n : n.get();
  }
  const self = {
    get,
    set,
    add,
    subtract
  };
  return self;
}

function Translate(axis, container) {
  const translate = axis.scroll === 'x' ? x : y;
  const containerStyle = container.style;
  let previousTarget = null;
  let disabled = false;
  function x(n) {
    return `translate3d(${n}px,0px,0px)`;
  }
  function y(n) {
    return `translate3d(0px,${n}px,0px)`;
  }
  function to(target) {
    if (disabled) return;
    const newTarget = roundToTwoDecimals(axis.direction(target));
    if (newTarget === previousTarget) return;
    containerStyle.transform = translate(newTarget);
    previousTarget = newTarget;
  }
  function toggleActive(active) {
    disabled = !active;
  }
  function clear() {
    if (disabled) return;
    containerStyle.transform = '';
    if (!container.getAttribute('style')) container.removeAttribute('style');
  }
  const self = {
    clear,
    to,
    toggleActive
  };
  return self;
}

function SlideLooper(axis, viewSize, contentSize, slideSizes, slideSizesWithGaps, snaps, scrollSnaps, location, slides) {
  const roundingSafety = 0.5;
  const ascItems = arrayKeys(slideSizesWithGaps);
  const descItems = arrayKeys(slideSizesWithGaps).reverse();
  const loopPoints = startPoints().concat(endPoints());
  function removeSlideSizes(indexes, from) {
    return indexes.reduce((a, i) => {
      return a - slideSizesWithGaps[i];
    }, from);
  }
  function slidesInGap(indexes, gap) {
    return indexes.reduce((a, i) => {
      const remainingGap = removeSlideSizes(a, gap);
      return remainingGap > 0 ? a.concat([i]) : a;
    }, []);
  }
  function findSlideBounds(offset) {
    return snaps.map((snap, index) => ({
      start: snap - slideSizes[index] + roundingSafety + offset,
      end: snap + viewSize - roundingSafety + offset
    }));
  }
  function findLoopPoints(indexes, offset, isEndEdge) {
    const slideBounds = findSlideBounds(offset);
    return indexes.map(index => {
      const initial = isEndEdge ? 0 : -contentSize;
      const altered = isEndEdge ? contentSize : 0;
      const boundEdge = isEndEdge ? 'end' : 'start';
      const loopPoint = slideBounds[index][boundEdge];
      return {
        index,
        loopPoint,
        slideLocation: Vector1D(-1),
        translate: Translate(axis, slides[index]),
        target: () => location.get() > loopPoint ? initial : altered
      };
    });
  }
  function startPoints() {
    const gap = scrollSnaps[0];
    const indexes = slidesInGap(descItems, gap);
    return findLoopPoints(indexes, contentSize, false);
  }
  function endPoints() {
    const gap = viewSize - scrollSnaps[0] - 1;
    const indexes = slidesInGap(ascItems, gap);
    return findLoopPoints(indexes, -contentSize, true);
  }
  function canLoop() {
    return loopPoints.every(({
      index
    }) => {
      const otherIndexes = ascItems.filter(i => i !== index);
      return removeSlideSizes(otherIndexes, viewSize) <= 0.1;
    });
  }
  function loop() {
    loopPoints.forEach(loopPoint => {
      const {
        target,
        translate,
        slideLocation
      } = loopPoint;
      const shiftLocation = target();
      if (shiftLocation === slideLocation.get()) return;
      translate.to(shiftLocation);
      slideLocation.set(shiftLocation);
    });
  }
  function clear() {
    loopPoints.forEach(loopPoint => loopPoint.translate.clear());
  }
  const self = {
    canLoop,
    clear,
    loop,
    loopPoints
  };
  return self;
}

function SlidesHandler(container, eventHandler, watchSlides) {
  let mutationObserver;
  let destroyed = false;
  function init(emblaApi) {
    if (!watchSlides) return;
    function defaultCallback(mutations) {
      for (const mutation of mutations) {
        if (mutation.type === 'childList') {
          emblaApi.reInit();
          eventHandler.emit('slidesChanged');
          break;
        }
      }
    }
    mutationObserver = new MutationObserver(mutations => {
      if (destroyed) return;
      if (isBoolean(watchSlides) || watchSlides(emblaApi, mutations)) {
        defaultCallback(mutations);
      }
    });
    mutationObserver.observe(container, {
      childList: true
    });
  }
  function destroy() {
    if (mutationObserver) mutationObserver.disconnect();
    destroyed = true;
  }
  const self = {
    init,
    destroy
  };
  return self;
}

function SlidesInView(container, slides, eventHandler, threshold) {
  const intersectionEntryMap = {};
  let inViewCache = null;
  let notInViewCache = null;
  let intersectionObserver;
  let destroyed = false;
  function init() {
    intersectionObserver = new IntersectionObserver(entries => {
      if (destroyed) return;
      entries.forEach(entry => {
        const index = slides.indexOf(entry.target);
        intersectionEntryMap[index] = entry;
      });
      inViewCache = null;
      notInViewCache = null;
      eventHandler.emit('slidesInView');
    }, {
      root: container.parentElement,
      threshold
    });
    slides.forEach(slide => intersectionObserver.observe(slide));
  }
  function destroy() {
    if (intersectionObserver) intersectionObserver.disconnect();
    destroyed = true;
  }
  function createInViewList(inView) {
    return objectKeys(intersectionEntryMap).reduce((list, slideIndex) => {
      const index = parseInt(slideIndex);
      const {
        isIntersecting
      } = intersectionEntryMap[index];
      const inViewMatch = inView && isIntersecting;
      const notInViewMatch = !inView && !isIntersecting;
      if (inViewMatch || notInViewMatch) list.push(index);
      return list;
    }, []);
  }
  function get(inView = true) {
    if (inView && inViewCache) return inViewCache;
    if (!inView && notInViewCache) return notInViewCache;
    const slideIndexes = createInViewList(inView);
    if (inView) inViewCache = slideIndexes;
    if (!inView) notInViewCache = slideIndexes;
    return slideIndexes;
  }
  const self = {
    init,
    destroy,
    get
  };
  return self;
}

function SlideSizes(axis, containerRect, slideRects, slides, readEdgeGap, ownerWindow) {
  const {
    measureSize,
    startEdge,
    endEdge
  } = axis;
  const withEdgeGap = slideRects[0] && readEdgeGap;
  const startGap = measureStartGap();
  const endGap = measureEndGap();
  const slideSizes = slideRects.map(measureSize);
  const slideSizesWithGaps = measureWithGaps();
  function measureStartGap() {
    if (!withEdgeGap) return 0;
    const slideRect = slideRects[0];
    return mathAbs(containerRect[startEdge] - slideRect[startEdge]);
  }
  function measureEndGap() {
    if (!withEdgeGap) return 0;
    const style = ownerWindow.getComputedStyle(arrayLast(slides));
    return parseFloat(style.getPropertyValue(`margin-${endEdge}`));
  }
  function measureWithGaps() {
    return slideRects.map((rect, index, rects) => {
      const isFirst = !index;
      const isLast = arrayIsLastIndex(rects, index);
      if (isFirst) return slideSizes[index] + startGap;
      if (isLast) return slideSizes[index] + endGap;
      return rects[index + 1][startEdge] - rect[startEdge];
    }).map(mathAbs);
  }
  const self = {
    slideSizes,
    slideSizesWithGaps,
    startGap,
    endGap
  };
  return self;
}

function SlidesToScroll(axis, viewSize, slidesToScroll, loop, containerRect, slideRects, startGap, endGap, pixelTolerance) {
  const {
    startEdge,
    endEdge,
    direction
  } = axis;
  const groupByNumber = isNumber(slidesToScroll);
  function byNumber(array, groupSize) {
    return arrayKeys(array).filter(i => i % groupSize === 0).map(i => array.slice(i, i + groupSize));
  }
  function bySize(array) {
    if (!array.length) return [];
    return arrayKeys(array).reduce((groups, rectB, index) => {
      const rectA = arrayLast(groups) || 0;
      const isFirst = rectA === 0;
      const isLast = rectB === arrayLastIndex(array);
      const edgeA = containerRect[startEdge] - slideRects[rectA][startEdge];
      const edgeB = containerRect[startEdge] - slideRects[rectB][endEdge];
      const gapA = !loop && isFirst ? direction(startGap) : 0;
      const gapB = !loop && isLast ? direction(endGap) : 0;
      const chunkSize = mathAbs(edgeB - gapB - (edgeA + gapA));
      if (index && chunkSize > viewSize + pixelTolerance) groups.push(rectB);
      if (isLast) groups.push(array.length);
      return groups;
    }, []).map((currentSize, index, groups) => {
      const previousSize = Math.max(groups[index - 1] || 0);
      return array.slice(previousSize, currentSize);
    });
  }
  function groupSlides(array) {
    return groupByNumber ? byNumber(array, slidesToScroll) : bySize(array);
  }
  const self = {
    groupSlides
  };
  return self;
}

function Engine(root, container, slides, ownerDocument, ownerWindow, options, eventHandler) {
  // Options
  const {
    align,
    axis: scrollAxis,
    direction,
    startIndex,
    loop,
    duration,
    dragFree,
    dragThreshold,
    inViewThreshold,
    slidesToScroll: groupSlides,
    skipSnaps,
    containScroll,
    watchResize,
    watchSlides,
    watchDrag,
    watchFocus
  } = options;
  // Measurements
  const pixelTolerance = 2;
  const nodeRects = NodeRects();
  const containerRect = nodeRects.measure(container);
  const slideRects = slides.map(nodeRects.measure);
  const axis = Axis(scrollAxis, direction);
  const viewSize = axis.measureSize(containerRect);
  const percentOfView = PercentOfView(viewSize);
  const alignment = Alignment(align, viewSize);
  const containSnaps = !loop && !!containScroll;
  const readEdgeGap = loop || !!containScroll;
  const {
    slideSizes,
    slideSizesWithGaps,
    startGap,
    endGap
  } = SlideSizes(axis, containerRect, slideRects, slides, readEdgeGap, ownerWindow);
  const slidesToScroll = SlidesToScroll(axis, viewSize, groupSlides, loop, containerRect, slideRects, startGap, endGap, pixelTolerance);
  const {
    snaps,
    snapsAligned
  } = ScrollSnaps(axis, alignment, containerRect, slideRects, slidesToScroll);
  const contentSize = -arrayLast(snaps) + arrayLast(slideSizesWithGaps);
  const {
    snapsContained,
    scrollContainLimit
  } = ScrollContain(viewSize, contentSize, snapsAligned, containScroll, pixelTolerance);
  const scrollSnaps = containSnaps ? snapsContained : snapsAligned;
  const {
    limit
  } = ScrollLimit(contentSize, scrollSnaps, loop);
  // Indexes
  const index = Counter(arrayLastIndex(scrollSnaps), startIndex, loop);
  const indexPrevious = index.clone();
  const slideIndexes = arrayKeys(slides);
  // Animation
  const update = ({
    dragHandler,
    scrollBody,
    scrollBounds,
    options: {
      loop
    }
  }) => {
    if (!loop) scrollBounds.constrain(dragHandler.pointerDown());
    scrollBody.seek();
  };
  const render = ({
    scrollBody,
    translate,
    location,
    offsetLocation,
    previousLocation,
    scrollLooper,
    slideLooper,
    dragHandler,
    animation,
    eventHandler,
    scrollBounds,
    options: {
      loop
    }
  }, alpha) => {
    const shouldSettle = scrollBody.settled();
    const withinBounds = !scrollBounds.shouldConstrain();
    const hasSettled = loop ? shouldSettle : shouldSettle && withinBounds;
    const hasSettledAndIdle = hasSettled && !dragHandler.pointerDown();
    if (hasSettledAndIdle) animation.stop();
    const interpolatedLocation = location.get() * alpha + previousLocation.get() * (1 - alpha);
    offsetLocation.set(interpolatedLocation);
    if (loop) {
      scrollLooper.loop(scrollBody.direction());
      slideLooper.loop();
    }
    translate.to(offsetLocation.get());
    if (hasSettledAndIdle) eventHandler.emit('settle');
    if (!hasSettled) eventHandler.emit('scroll');
  };
  const animation = Animations(ownerDocument, ownerWindow, () => update(engine), alpha => render(engine, alpha));
  // Shared
  const friction = 0.68;
  const startLocation = scrollSnaps[index.get()];
  const location = Vector1D(startLocation);
  const previousLocation = Vector1D(startLocation);
  const offsetLocation = Vector1D(startLocation);
  const target = Vector1D(startLocation);
  const scrollBody = ScrollBody(location, offsetLocation, previousLocation, target, duration, friction);
  const scrollTarget = ScrollTarget(loop, scrollSnaps, contentSize, limit, target);
  const scrollTo = ScrollTo(animation, index, indexPrevious, scrollBody, scrollTarget, target, eventHandler);
  const scrollProgress = ScrollProgress(limit);
  const eventStore = EventStore();
  const slidesInView = SlidesInView(container, slides, eventHandler, inViewThreshold);
  const {
    slideRegistry
  } = SlideRegistry(containSnaps, containScroll, scrollSnaps, scrollContainLimit, slidesToScroll, slideIndexes);
  const slideFocus = SlideFocus(root, slides, slideRegistry, scrollTo, scrollBody, eventStore, eventHandler, watchFocus);
  // Engine
  const engine = {
    ownerDocument,
    ownerWindow,
    eventHandler,
    containerRect,
    slideRects,
    animation,
    axis,
    dragHandler: DragHandler(axis, root, ownerDocument, ownerWindow, target, DragTracker(axis, ownerWindow), location, animation, scrollTo, scrollBody, scrollTarget, index, eventHandler, percentOfView, dragFree, dragThreshold, skipSnaps, friction, watchDrag),
    eventStore,
    percentOfView,
    index,
    indexPrevious,
    limit,
    location,
    offsetLocation,
    previousLocation,
    options,
    resizeHandler: ResizeHandler(container, eventHandler, ownerWindow, slides, axis, watchResize, nodeRects),
    scrollBody,
    scrollBounds: ScrollBounds(limit, offsetLocation, target, scrollBody, percentOfView),
    scrollLooper: ScrollLooper(contentSize, limit, offsetLocation, [location, offsetLocation, previousLocation, target]),
    scrollProgress,
    scrollSnapList: scrollSnaps.map(scrollProgress.get),
    scrollSnaps,
    scrollTarget,
    scrollTo,
    slideLooper: SlideLooper(axis, viewSize, contentSize, slideSizes, slideSizesWithGaps, snaps, scrollSnaps, offsetLocation, slides),
    slideFocus,
    slidesHandler: SlidesHandler(container, eventHandler, watchSlides),
    slidesInView,
    slideIndexes,
    slideRegistry,
    slidesToScroll,
    target,
    translate: Translate(axis, container)
  };
  return engine;
}

function EventHandler() {
  let listeners = {};
  let api;
  function init(emblaApi) {
    api = emblaApi;
  }
  function getListeners(evt) {
    return listeners[evt] || [];
  }
  function emit(evt) {
    getListeners(evt).forEach(e => e(api, evt));
    return self;
  }
  function on(evt, cb) {
    listeners[evt] = getListeners(evt).concat([cb]);
    return self;
  }
  function off(evt, cb) {
    listeners[evt] = getListeners(evt).filter(e => e !== cb);
    return self;
  }
  function clear() {
    listeners = {};
  }
  const self = {
    init,
    emit,
    off,
    on,
    clear
  };
  return self;
}

const defaultOptions = {
  align: 'center',
  axis: 'x',
  container: null,
  slides: null,
  containScroll: 'trimSnaps',
  direction: 'ltr',
  slidesToScroll: 1,
  inViewThreshold: 0,
  breakpoints: {},
  dragFree: false,
  dragThreshold: 10,
  loop: false,
  skipSnaps: false,
  duration: 25,
  startIndex: 0,
  active: true,
  watchDrag: true,
  watchResize: true,
  watchSlides: true,
  watchFocus: true
};

function OptionsHandler(ownerWindow) {
  function mergeOptions(optionsA, optionsB) {
    return objectsMergeDeep(optionsA, optionsB || {});
  }
  function optionsAtMedia(options) {
    const optionsAtMedia = options.breakpoints || {};
    const matchedMediaOptions = objectKeys(optionsAtMedia).filter(media => ownerWindow.matchMedia(media).matches).map(media => optionsAtMedia[media]).reduce((a, mediaOption) => mergeOptions(a, mediaOption), {});
    return mergeOptions(options, matchedMediaOptions);
  }
  function optionsMediaQueries(optionsList) {
    return optionsList.map(options => objectKeys(options.breakpoints || {})).reduce((acc, mediaQueries) => acc.concat(mediaQueries), []).map(ownerWindow.matchMedia);
  }
  const self = {
    mergeOptions,
    optionsAtMedia,
    optionsMediaQueries
  };
  return self;
}

function PluginsHandler(optionsHandler) {
  let activePlugins = [];
  function init(emblaApi, plugins) {
    activePlugins = plugins.filter(({
      options
    }) => optionsHandler.optionsAtMedia(options).active !== false);
    activePlugins.forEach(plugin => plugin.init(emblaApi, optionsHandler));
    return plugins.reduce((map, plugin) => Object.assign(map, {
      [plugin.name]: plugin
    }), {});
  }
  function destroy() {
    activePlugins = activePlugins.filter(plugin => plugin.destroy());
  }
  const self = {
    init,
    destroy
  };
  return self;
}

function EmblaCarousel(root, userOptions, userPlugins) {
  const ownerDocument = root.ownerDocument;
  const ownerWindow = ownerDocument.defaultView;
  const optionsHandler = OptionsHandler(ownerWindow);
  const pluginsHandler = PluginsHandler(optionsHandler);
  const mediaHandlers = EventStore();
  const eventHandler = EventHandler();
  const {
    mergeOptions,
    optionsAtMedia,
    optionsMediaQueries
  } = optionsHandler;
  const {
    on,
    off,
    emit
  } = eventHandler;
  const reInit = reActivate;
  let destroyed = false;
  let engine;
  let optionsBase = mergeOptions(defaultOptions, EmblaCarousel.globalOptions);
  let options = mergeOptions(optionsBase);
  let pluginList = [];
  let pluginApis;
  let container;
  let slides;
  function storeElements() {
    const {
      container: userContainer,
      slides: userSlides
    } = options;
    const customContainer = isString(userContainer) ? root.querySelector(userContainer) : userContainer;
    container = customContainer || root.children[0];
    const customSlides = isString(userSlides) ? container.querySelectorAll(userSlides) : userSlides;
    slides = [].slice.call(customSlides || container.children);
  }
  function createEngine(options) {
    const engine = Engine(root, container, slides, ownerDocument, ownerWindow, options, eventHandler);
    if (options.loop && !engine.slideLooper.canLoop()) {
      const optionsWithoutLoop = Object.assign({}, options, {
        loop: false
      });
      return createEngine(optionsWithoutLoop);
    }
    return engine;
  }
  function activate(withOptions, withPlugins) {
    if (destroyed) return;
    optionsBase = mergeOptions(optionsBase, withOptions);
    options = optionsAtMedia(optionsBase);
    pluginList = withPlugins || pluginList;
    storeElements();
    engine = createEngine(options);
    optionsMediaQueries([optionsBase, ...pluginList.map(({
      options
    }) => options)]).forEach(query => mediaHandlers.add(query, 'change', reActivate));
    if (!options.active) return;
    engine.translate.to(engine.location.get());
    engine.animation.init();
    engine.slidesInView.init();
    engine.slideFocus.init(self);
    engine.eventHandler.init(self);
    engine.resizeHandler.init(self);
    engine.slidesHandler.init(self);
    if (engine.options.loop) engine.slideLooper.loop();
    if (container.offsetParent && slides.length) engine.dragHandler.init(self);
    pluginApis = pluginsHandler.init(self, pluginList);
  }
  function reActivate(withOptions, withPlugins) {
    const startIndex = selectedScrollSnap();
    deActivate();
    activate(mergeOptions({
      startIndex
    }, withOptions), withPlugins);
    eventHandler.emit('reInit');
  }
  function deActivate() {
    engine.dragHandler.destroy();
    engine.eventStore.clear();
    engine.translate.clear();
    engine.slideLooper.clear();
    engine.resizeHandler.destroy();
    engine.slidesHandler.destroy();
    engine.slidesInView.destroy();
    engine.animation.destroy();
    pluginsHandler.destroy();
    mediaHandlers.clear();
  }
  function destroy() {
    if (destroyed) return;
    destroyed = true;
    mediaHandlers.clear();
    deActivate();
    eventHandler.emit('destroy');
    eventHandler.clear();
  }
  function scrollTo(index, jump, direction) {
    if (!options.active || destroyed) return;
    engine.scrollBody.useBaseFriction().useDuration(jump === true ? 0 : options.duration);
    engine.scrollTo.index(index, direction || 0);
  }
  function scrollNext(jump) {
    const next = engine.index.add(1).get();
    scrollTo(next, jump, -1);
  }
  function scrollPrev(jump) {
    const prev = engine.index.add(-1).get();
    scrollTo(prev, jump, 1);
  }
  function canScrollNext() {
    const next = engine.index.add(1).get();
    return next !== selectedScrollSnap();
  }
  function canScrollPrev() {
    const prev = engine.index.add(-1).get();
    return prev !== selectedScrollSnap();
  }
  function scrollSnapList() {
    return engine.scrollSnapList;
  }
  function scrollProgress() {
    return engine.scrollProgress.get(engine.offsetLocation.get());
  }
  function selectedScrollSnap() {
    return engine.index.get();
  }
  function previousScrollSnap() {
    return engine.indexPrevious.get();
  }
  function slidesInView() {
    return engine.slidesInView.get();
  }
  function slidesNotInView() {
    return engine.slidesInView.get(false);
  }
  function plugins() {
    return pluginApis;
  }
  function internalEngine() {
    return engine;
  }
  function rootNode() {
    return root;
  }
  function containerNode() {
    return container;
  }
  function slideNodes() {
    return slides;
  }
  const self = {
    canScrollNext,
    canScrollPrev,
    containerNode,
    internalEngine,
    destroy,
    off,
    on,
    emit,
    plugins,
    previousScrollSnap,
    reInit,
    rootNode,
    scrollNext,
    scrollPrev,
    scrollProgress,
    scrollSnapList,
    scrollTo,
    selectedScrollSnap,
    slideNodes,
    slidesInView,
    slidesNotInView
  };
  activate(userOptions, userPlugins);
  setTimeout(() => eventHandler.emit('init'), 0);
  return self;
}
EmblaCarousel.globalOptions = undefined;


//# sourceMappingURL=embla-carousel.esm.js.map

;// CONCATENATED MODULE: ./node_modules/embla-carousel-react/esm/embla-carousel-react.esm.js




function useEmblaCarousel(options = {}, plugins = []) {
  const storedOptions = (0,react.useRef)(options);
  const storedPlugins = (0,react.useRef)(plugins);
  const [emblaApi, setEmblaApi] = (0,react.useState)();
  const [viewport, setViewport] = (0,react.useState)();
  const reInit = (0,react.useCallback)(() => {
    if (emblaApi) emblaApi.reInit(storedOptions.current, storedPlugins.current);
  }, [emblaApi]);
  (0,react.useEffect)(() => {
    if (areOptionsEqual(storedOptions.current, options)) return;
    storedOptions.current = options;
    reInit();
  }, [options, reInit]);
  (0,react.useEffect)(() => {
    if (arePluginsEqual(storedPlugins.current, plugins)) return;
    storedPlugins.current = plugins;
    reInit();
  }, [plugins, reInit]);
  (0,react.useEffect)(() => {
    if (canUseDOM() && viewport) {
      EmblaCarousel.globalOptions = useEmblaCarousel.globalOptions;
      const newEmblaApi = EmblaCarousel(viewport, storedOptions.current, storedPlugins.current);
      setEmblaApi(newEmblaApi);
      return () => newEmblaApi.destroy();
    } else {
      setEmblaApi(undefined);
    }
  }, [viewport, setEmblaApi]);
  return [setViewport, emblaApi];
}
useEmblaCarousel.globalOptions = undefined;


//# sourceMappingURL=embla-carousel-react.esm.js.map

// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/ArrowRightIcon.mjs
var ArrowRightIcon = __webpack_require__(51782);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Controls/CarouselControl/CarouselControl.module.css.mjs
var CarouselControl_module_css_classes = {
    "root": "GQOKa",
    "carouselControlSizeSmall": "iFBiK",
    "carouselControlSizeLarge": "QyB52",
    "carouselControlVariantIrregular": "ad-WL",
    "carouselControlStateDisabled": "_7f0BS"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Controls/CarouselControl/CarouselControl.utils.mjs

const carouselControlSizeClasses = {
    small: CarouselControl_module_css_classes.carouselControlSizeSmall,
    large: CarouselControl_module_css_classes.carouselControlSizeLarge
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Controls/CarouselControl/CarouselControl.mjs







const CarouselControl = (0,factory_utils/* polymorphicFactory */.bq)((props, ref)=>{
    const { component ="button" , className , size ="large" , direction , variant ="regular" , disabled , ...rest } = props;
    const classNames = (0,clsx/* default */.Z)("kohler-carousel-control-root", className, carouselControlSizeClasses[size], size === "large" && variant === "irregular" && CarouselControl_module_css_classes.carouselControlVariantIrregular, disabled && CarouselControl_module_css_classes.carouselControlStateDisabled, CarouselControl_module_css_classes.root);
    const withBoundingBox = size === "large";
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        className: classNames,
        component,
        ref,
        disabled,
        type: component === "button" ? "button" : void 0,
        "aria-label": rest["aria-label"] || direction === "left" ? "carousel arrow left" : "carousel arrow right",
        ...rest
    }, direction === "left" ? /* @__PURE__ */ /*#__PURE__*/ react.createElement(ArrowLeftIcon, {
        withBoundingBox
    }) : /* @__PURE__ */ /*#__PURE__*/ react.createElement(ArrowRightIcon/* ArrowRightIcon */.L, {
        withBoundingBox
    }));
});


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/SlashIcon.mjs


const SlashIcon_withoutBoundingBoxWidth = {
    large: 11,
    medium: 9,
    small: 6,
    xSmall: 6
};
const SlashIcon = (param)=>{
    let { size ="medium" , withBoundingBox =true , ...others } = param;
    let iconWidth, iconHeight;
    if (typeof size === "string") {
        iconWidth = withBoundingBox ? constants/* iconSize */.E[size] : SlashIcon_withoutBoundingBoxWidth[size];
        iconHeight = constants/* iconSize */.E[size];
    } else {
        iconWidth = size;
        iconHeight = size;
    }
    const renderIcon = ()=>{
        switch(size){
            case "large":
                return /* @__PURE__ */ /*#__PURE__*/ react.createElement("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: iconWidth,
                    height: iconHeight,
                    viewBox: "0 0 40 40",
                    preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
                    fill: "none",
                    ...others
                }, /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M24.5416 5L25.5 5.27708L15.4584 35L14.5 34.7229L24.5416 5Z",
                    fill: "currentColor"
                }));
            case "medium":
            default:
                return /* @__PURE__ */ /*#__PURE__*/ react.createElement("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: iconWidth,
                    height: iconHeight,
                    viewBox: "0 0 30 30",
                    preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
                    fill: "none",
                    ...others
                }, /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M18.6333 3L19.4001 3.22167L11.3669 27L10.6001 26.7783L18.6333 3Z",
                    fill: "currentColor"
                }));
            case "small":
            case "xSmall":
                return /* @__PURE__ */ /*#__PURE__*/ react.createElement("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: iconWidth,
                    height: iconHeight,
                    viewBox: "0 0 20 20",
                    preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
                    fill: "none",
                    ...others
                }, /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M12.4772 1L13 1.16625L7.52279 19L7 18.8338L12.4772 1Z",
                    fill: "currentColor"
                }));
        }
    };
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(react.Fragment, null, renderIcon());
};
SlashIcon.iconName = "SlashIcon";


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/DataDisplay/CarouselCounter/CarouselCounter.module.css.mjs
var CarouselCounter_module_css_classes = {
    "root": "q--tc",
    "currentNumber": "jVnGr",
    "totalNumber": "CKB1C"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/DataDisplay/CarouselCounter/CarouselCounter.mjs








const CarouselCounter = (0,factory_utils/* factory */.d5)((props, ref)=>{
    const { current , total , className , ...rest } = props;
    const classNames = (0,clsx/* default */.Z)("kohler-carousel-counter-root", className, CarouselCounter_module_css_classes.root);
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        className: classNames,
        ref,
        ...rest
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        className: CarouselCounter_module_css_classes.currentNumber,
        component: "span",
        size: "h5"
    }, current), /* @__PURE__ */ /*#__PURE__*/ react.createElement(SlashIcon, {
        size: "large",
        withBoundingBox: true
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        className: CarouselCounter_module_css_classes.totalNumber,
        component: "span",
        size: "h5"
    }, total));
});


// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Popover/subcomponents/create-safe-context.mjs
var create_safe_context = __webpack_require__(19975);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/DataDisplay/Carousel/Carousel.context.mjs

const [CarouselProvider, useCarouselContext] = (0,create_safe_context/* createSafeContext */.R)("Carousel component was not found in tree");


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/DataDisplay/Carousel/Carousel.module.css.mjs
var Carousel_module_css_classes = {
    "root": "ahc8m",
    "viewport": "LLE84",
    "container": "Le96v",
    "controls": "ietvU",
    "control": "ZfMAh",
    "controlLeftHidden": "_5fdcq",
    "controlRightHidden": "pIa3G",
    "indicators": "_0lOqX",
    "indicator": "_1srQJ",
    "slide": "fSTQ-"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/DataDisplay/Carousel/Carousel.mjs
"use client";










const Carousel = (0,factory_utils/* factory */.d5)((props, ref)=>{
    const { className , children , onNextSlide , onPreviousSlide , onSlideChange , orientation ="horizontal" , slideSize ="100%" , getEmblaApi , slideGap =0 , height ="auto" , align ="center" , slidesToScroll =1 , includeGapInSize =true , draggable =true , dragFree =false , loop =true , speed =25 , initialSlide =0 , inViewThreshold =0 , withControls =true , withIndicators =false , skipSnaps =false , containScroll , withKeyboardEvents =true , carouselControlProps , controlsOffset , ...rest } = props;
    const dir = "ltr";
    const [emblaRefElement, embla] = useEmblaCarousel({
        axis: orientation === "horizontal" ? "x" : "y",
        direction: orientation === "horizontal" ? dir : void 0,
        startIndex: initialSlide,
        loop,
        align,
        slidesToScroll,
        watchDrag: draggable,
        dragFree,
        duration: speed,
        inViewThreshold,
        skipSnaps,
        containScroll
    });
    const [selected, setSelected] = (0,react.useState)(0);
    const [slidesCount, setSlidesCount] = (0,react.useState)(0);
    const handleSelect = (0,react.useCallback)(()=>{
        if (!embla) return;
        const slide = embla.selectedScrollSnap();
        setSelected(slide);
        onSlideChange === null || onSlideChange === void 0 ? void 0 : onSlideChange(slide);
    }, [
        embla,
        setSelected
    ]);
    const handlePrevious = (0,react.useCallback)(()=>{
        embla === null || embla === void 0 ? void 0 : embla.scrollPrev();
        onPreviousSlide === null || onPreviousSlide === void 0 ? void 0 : onPreviousSlide();
    }, [
        embla
    ]);
    const handleNext = (0,react.useCallback)(()=>{
        embla === null || embla === void 0 ? void 0 : embla.scrollNext();
        onNextSlide === null || onNextSlide === void 0 ? void 0 : onNextSlide();
    }, [
        embla
    ]);
    const handleKeydown = (0,react.useCallback)((event)=>{
        if (withKeyboardEvents) {
            if (event.key === "ArrowRight") {
                event.preventDefault();
                handleNext();
            }
            if (event.key === "ArrowLeft") {
                event.preventDefault();
                handlePrevious();
            }
        }
    }, [
        embla
    ]);
    (0,react.useEffect)(()=>{
        if (embla) {
            getEmblaApi === null || getEmblaApi === void 0 ? void 0 : getEmblaApi(embla);
            handleSelect();
            setSlidesCount(embla.scrollSnapList().length);
            embla.on("select", handleSelect);
            return ()=>{
                embla.off("select", handleSelect);
            };
        }
        return void 0;
    }, [
        embla,
        slidesToScroll
    ]);
    (0,react.useEffect)(()=>{
        if (embla) {
            embla.reInit();
            setSlidesCount(embla.scrollSnapList().length);
            setSelected((currentSelected)=>(0,helpers/* clamp */.uZ)(currentSelected, 0, react.Children.toArray(children).length - 1));
        }
    }, [
        react.Children.toArray(children).length,
        slidesToScroll
    ]);
    const canScrollPrev = (embla === null || embla === void 0 ? void 0 : embla.canScrollPrev()) || false;
    const canScrollNext = (embla === null || embla === void 0 ? void 0 : embla.canScrollNext()) || false;
    const showLeftControl = embla && (canScrollPrev || loop);
    const showRightControl = embla && (canScrollNext || loop);
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(CarouselProvider, {
        value: {
            orientation
        }
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        ref,
        className: (0,clsx/* default */.Z)(Carousel_module_css_classes.root, className, "kohler-carousel-root"),
        ...rest,
        onKeyDownCapture: handleKeydown,
        style: {
            "--carousel-height": height,
            "--carousel-slide-size": slideSize || void 0,
            "--carousel-slide-gap": slideGap,
            "--carousel-controls-offset": controlsOffset || void 0
        },
        "data-include-gap-in-size": includeGapInSize || void 0
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement("div", {
        className: (0,clsx/* default */.Z)(Carousel_module_css_classes.viewport, "kohler-carousel-content"),
        ref: emblaRefElement
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement("div", {
        className: (0,clsx/* default */.Z)(Carousel_module_css_classes.container, "kohler-carousel-container"),
        "data-orientation": orientation
    }, children)), withIndicators && /* @__PURE__ */ /*#__PURE__*/ react.createElement("div", {
        className: (0,clsx/* default */.Z)(Carousel_module_css_classes.indicators, "kohler-carousel-indicators"),
        "data-orientation": orientation
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(CarouselCounter, {
        total: slidesCount,
        current: selected + 1
    })), withControls && /* @__PURE__ */ /*#__PURE__*/ react.createElement("div", {
        className: (0,clsx/* default */.Z)(Carousel_module_css_classes.controls, "kohler-carousel-controls"),
        "data-orientation": orientation
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(CarouselControl, {
        size: "large",
        direction: "left",
        "data-inactive": !canScrollPrev || void 0,
        tabIndex: canScrollPrev ? 0 : -1,
        onClick: ()=>{
            handlePrevious();
        },
        ...carouselControlProps,
        className: (0,clsx/* default */.Z)(Carousel_module_css_classes.control, !showLeftControl && Carousel_module_css_classes.controlLeftHidden, carouselControlProps === null || carouselControlProps === void 0 ? void 0 : carouselControlProps.className)
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement(CarouselControl, {
        size: "large",
        direction: "right",
        "data-inactive": !canScrollNext || void 0,
        tabIndex: canScrollNext ? 0 : -1,
        onClick: ()=>{
            handleNext();
        },
        ...carouselControlProps,
        className: (0,clsx/* default */.Z)(Carousel_module_css_classes.control, !showRightControl && Carousel_module_css_classes.controlRightHidden, carouselControlProps === null || carouselControlProps === void 0 ? void 0 : carouselControlProps.className)
    }))));
});


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/DataDisplay/Carousel/CarouselSlide/CarouselSlide.mjs






const CarouselSlide = (0,factory_utils/* factory */.d5)((props, ref)=>{
    const { className , ...rest } = props;
    const classNames = (0,clsx/* default */.Z)(Carousel_module_css_classes.slide, className);
    const ctx = useCarouselContext();
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        ref,
        className: classNames,
        ...rest,
        "data-orientation": ctx.orientation
    });
});


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/subcomponents/MessageBanner/subcomponents/PromoBanner/PromoBanner.module.css.mjs
var PromoBanner_module_css_classes = {
    "promoBanner": "zHJqC",
    "promoBannerSlide": "_2gfyC",
    "promoBannerSlideLinks": "_6Tjrr"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/subcomponents/MessageBanner/subcomponents/PromoBanner/PromoBanner.mjs
"use client";




const PromoBanner = (param)=>{
    let { content , carouselControlProps  } = param;
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        className: (0,clsx/* default */.Z)(PromoBanner_module_css_classes.promoBanner, "kohler-promo-banner-root")
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Grid/* Grid */.r, null, /* @__PURE__ */ /*#__PURE__*/ react.createElement(GridColumn/* GridColumn */.C, null, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Carousel, {
        withControls: true,
        includeGapInSize: false,
        slideGap: "20px",
        loop: true,
        carouselControlProps: {
            ...carouselControlProps,
            size: "small"
        }
    }, content.map((message, index)=>/* @__PURE__ */ /*#__PURE__*/ react.createElement(CarouselSlide, {
            key: index,
            className: PromoBanner_module_css_classes.promoBannerSlide
        }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
            size: "label-medium-xs",
            component: "div"
        }, message.content), message.CTAs && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
            className: PromoBanner_module_css_classes.promoBannerSlideLinks
        }, message.CTAs.map((link)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
            /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
                component: "href" in link && link.href ? "a" : "button",
                size: "label-medium-xs",
                textDecoration: "underline",
                textColor: "var(--content-primary)",
                key: link.text,
                ...(0,helpers/* omitText */.rW)(link)
            }, link.text)))))))));
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/subcomponents/MessageBanner/subcomponents/InfoBanner/InfoBanner.module.css.mjs
var InfoBanner_module_css_classes = {
    "infoBanner": "oWmAV",
    "infoBannerContent": "chMq3"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/subcomponents/MessageBanner/subcomponents/InfoBanner/InfoBanner.mjs




const InfoBanner = (param)=>{
    let { content  } = param;
    const { message  } = content;
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        className: (0,clsx/* default */.Z)(InfoBanner_module_css_classes.infoBanner, "kohler-info-banner-root")
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Grid/* Grid */.r, null, /* @__PURE__ */ /*#__PURE__*/ react.createElement(GridColumn/* GridColumn */.C, {
        className: InfoBanner_module_css_classes.infoBannerContent
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        textTransform: "uppercase",
        size: "caption-s",
        component: "div"
    }, message))));
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/subcomponents/MessageBanner/subcomponents/GlobalBanner/GlobalBanner.module.css.mjs
var GlobalBanner_module_css_classes = {
    "globalBanner": "ZYZKS",
    "globalBannerSlide": "CMJQ5",
    "globalBannerSlideContent": "tSCCX"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/subcomponents/MessageBanner/subcomponents/GlobalBanner/GlobalBanner.mjs
"use client";




const GlobalBanner = (param)=>{
    let { content , carouselControlProps  } = param;
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        className: (0,clsx/* default */.Z)(GlobalBanner_module_css_classes.globalBanner, "kohler-global-banner-root")
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Grid/* Grid */.r, null, /* @__PURE__ */ /*#__PURE__*/ react.createElement(GridColumn/* GridColumn */.C, null, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Carousel, {
        withControls: true,
        includeGapInSize: false,
        slideGap: "20px",
        loop: true,
        carouselControlProps: {
            ...carouselControlProps,
            size: "small"
        }
    }, content.map((item, index)=>{
        return /* @__PURE__ */ /*#__PURE__*/ react.createElement(CarouselSlide, {
            key: "global-banner-".concat(index),
            className: GlobalBanner_module_css_classes.globalBannerSlide
        }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
            size: "paragraph-small",
            component: "div",
            textColor: "var(--content-primary)",
            className: GlobalBanner_module_css_classes.globalBannerSlideContent
        }, item.message), item.CTA && // eslint-disable-next-line @typescript-eslint/no-explicit-any
        /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
            size: "label-regular-s",
            textColor: "var(--content-primary)",
            component: "href" in item.CTA && item.CTA.href ? "a" : "button",
            ...(0,helpers/* omitText */.rW)(item.CTA)
        }, item.CTA.text));
    })))));
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/subcomponents/MessageBanner/MessageBanner.mjs






const MessageBanner = (0,factory_utils/* factory */.d5)((props, ref)=>{
    const { className , type , content , mod ="white" , carouselControlProps , ...rest } = props;
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        mod,
        ref,
        className: (0,clsx/* default */.Z)(className, "kohler-message-banner-root"),
        ...rest
    }, type === "promo" && /* @__PURE__ */ /*#__PURE__*/ react.createElement(PromoBanner, {
        content,
        carouselControlProps
    }), type === "info" && /* @__PURE__ */ /*#__PURE__*/ react.createElement(InfoBanner, {
        content
    }), type === "global" && /* @__PURE__ */ /*#__PURE__*/ react.createElement(GlobalBanner, {
        content,
        carouselControlProps
    }));
});


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/TabbedNavigationHorizontal/TabbedNavigationHorizontal.module.css.mjs
var TabbedNavigationHorizontal_module_css_classes = {
    "tabNavigationHorizontal": "VcjZ0",
    "tabNavigationHorizontalCenter": "uBoKP",
    "underline": "yyQEp",
    "underlineNoTransition": "Xh280"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/TabbedNavigationHorizontal/TabbedNavigationHorizontal.mjs
"use client";




const TabbedNavigationHorizontal = (0,factory_utils/* polymorphicFactory */.bq)((props, ref)=>{
    const { mod , tabs , align , component ="div" , initialSelectedTab , onTabClick , className , ...rest } = props;
    const [selectedTab, setSelectedTab] = (0,react.useState)(initialSelectedTab || tabs[0].id || tabs[0].text);
    const [underlineStyle, setUnderlineStyle] = (0,react.useState)({});
    const tabRefs = (0,react.useRef)([]);
    const [isInitialRender, setIsInitialRender] = (0,react.useState)(true);
    (0,react.useEffect)(()=>{
        const selectedTabElement = tabRefs.current.find((tab)=>tab.id === selectedTab);
        if (selectedTabElement) {
            setUnderlineStyle({
                width: "".concat(selectedTabElement.offsetWidth, "px"),
                transform: "translateX(".concat(selectedTabElement.offsetLeft, "px)")
            });
        }
    }, [
        selectedTab
    ]);
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        role: "tablist",
        mod,
        component,
        className: (0,clsx/* default */.Z)("kohler-tabbed-navigation-horizontal-root", className, TabbedNavigationHorizontal_module_css_classes.tabNavigationHorizontal),
        align: "flex-start",
        ref,
        ...rest
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        className: align === "center" && TabbedNavigationHorizontal_module_css_classes.tabNavigationHorizontalCenter
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement("div", {
        style: underlineStyle,
        className: (0,clsx/* default */.Z)(TabbedNavigationHorizontal_module_css_classes.underline, isInitialRender && TabbedNavigationHorizontal_module_css_classes.underlineNoTransition)
    }), tabs.map((param, index)=>{
        let { id , text , ...restTabProps } = param;
        const tabId = id || text;
        return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Tab, {
            role: "tab",
            type: "button",
            id: tabId,
            key: tabId,
            text,
            "aria-selected": selectedTab === tabId,
            "aria-expanded": selectedTab === tabId,
            ref: (el)=>tabRefs.current[index] = el,
            onClick: ()=>{
                if (isInitialRender) {
                    setIsInitialRender(false);
                }
                setSelectedTab(tabId);
                onTabClick === null || onTabClick === void 0 ? void 0 : onTabClick(tabId);
            },
            ...restTabProps
        });
    })));
});


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/ArrowUpIcon.mjs


const ArrowUpIcon_withoutBoundingBoxWidth = {
    large: 30,
    medium: 22,
    small: 16,
    xSmall: 10
};
const ArrowUpIcon = (param)=>{
    let { size ="medium" , withBoundingBox =true , ...others } = param;
    let iconWidth, iconHeight;
    if (typeof size === "string") {
        iconWidth = withBoundingBox ? constants/* iconSize */.E[size] : ArrowUpIcon_withoutBoundingBoxWidth[size];
        iconHeight = constants/* iconSize */.E[size];
    } else {
        iconWidth = size;
        iconHeight = size;
    }
    const renderIcon = ()=>{
        switch(size){
            case "large":
                return /* @__PURE__ */ /*#__PURE__*/ react.createElement("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: iconWidth,
                    height: iconHeight,
                    viewBox: "0 0 40 40",
                    preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
                    fill: "none",
                    ...others
                }, /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M34.2662 29L35 28.3455L20 11L5 28.3643L5.76447 28.9812L20 12.5537L34.2662 29Z",
                    fill: "currentColor"
                }));
            case "medium":
            default:
                return /* @__PURE__ */ /*#__PURE__*/ react.createElement("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: iconWidth,
                    height: iconHeight,
                    viewBox: "0 0 30 30",
                    preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
                    fill: "none",
                    ...others
                }, /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M25.2474 22L26 21.3415L15 9L4 21.3604L4.78404 21.9811L15 10.4528L25.2474 22Z",
                    fill: "currentColor"
                }));
            case "small":
            case "xSmall":
                return /* @__PURE__ */ /*#__PURE__*/ react.createElement("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: iconWidth,
                    height: iconHeight,
                    viewBox: "0 0 20 20",
                    preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
                    fill: "none",
                    ...others
                }, /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M17.135 14.533L17.8645 13.849L9.99978 5.45996L2.13501 13.849L2.86455 14.533L9.99978 6.92202L17.135 14.533Z",
                    fill: "white"
                }), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M17.135 14.533L17.8645 13.849L9.99978 5.45996L2.13501 13.849L2.86455 14.533L9.99978 6.92202L17.135 14.533Z",
                    fill: "currentColor"
                }));
        }
    };
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(react.Fragment, null, renderIcon());
};
ArrowUpIcon.iconName = "ArrowUpIcon";


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/subcomponents/RegionItem/RegionItem.module.css.mjs
var RegionItem_module_css_classes = {
    "regionItem": "_0VTmW",
    "regionItemCountry": "kMwFV",
    "languageMenuContentListLanguageItemLink": "_49wes",
    "regionItemLanguage": "q1jj3",
    "regionItemLanguageDivider": "nY6c7",
    "languageMenuContentListLanguageItemLinkInactive": "aPTcL",
    "regionItemLanguageDividerInactive": "pPWSG",
    "languageMenuContentLanguageList": "BXqRI"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/subcomponents/RegionItem/RegionItem.mjs
"use client";





const RegionItem = (0,factory_utils/* factory */.d5)((props, ref)=>{
    const { name , languages , isCurrentCountry , setSelectedCountry , href , className , mod , ...rest } = props;
    const [selectedRegionName, setSelectedRegionName] = (0,react.useState)(false);
    const { width  } = (0,use_window_size/* useWindowSize */.i)();
    const isSmallSize = width < 1024;
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        className: (0,clsx/* default */.Z)(RegionItem_module_css_classes.regionItem, className),
        mod
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        ref,
        component: languages ? isSmallSize ? "button" : "div" : "a",
        size: isSmallSize ? "navigation-overlay-title" : "navigation-overlay-item-m-regular",
        className: RegionItem_module_css_classes.regionItemCountry,
        textColor: isCurrentCountry && !isSmallSize ? "var(--content-action-inactive)" : "var(--content-action-default)",
        href,
        ...languages ? {
            onClick: ()=>{
                setSelectedCountry === null || setSelectedCountry === void 0 ? void 0 : setSelectedCountry(name);
                setSelectedRegionName(!selectedRegionName);
            }
        } : {
            href
        },
        ...rest
    }, name, " ", languages && isSmallSize ? selectedRegionName ? /* @__PURE__ */ /*#__PURE__*/ react.createElement(ArrowUpIcon, {
        size: "small"
    }) : /* @__PURE__ */ /*#__PURE__*/ react.createElement(ArrowDownIcon/* ArrowDownIcon */.v, {
        size: "small"
    }) : void 0), (selectedRegionName || !isSmallSize) && /* @__PURE__ */ /*#__PURE__*/ react.createElement("ul", {
        className: RegionItem_module_css_classes.languageMenuContentLanguageList
    }, languages === null || languages === void 0 ? void 0 : languages.map((language, index)=>{
        /* @__PURE__ */ /*#__PURE__*/ return react.createElement("li", {
            key: language.text,
            className: (0,clsx/* default */.Z)(RegionItem_module_css_classes.regionItemLanguage, !isSmallSize && index !== (languages === null || languages === void 0 ? void 0 : languages.length) - 1 && RegionItem_module_css_classes.regionItemLanguageDivider, isCurrentCountry && RegionItem_module_css_classes.regionItemLanguageDividerInactive)
        }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
            className: (0,clsx/* default */.Z)(RegionItem_module_css_classes.languageMenuContentListLanguageItemLink, isCurrentCountry && RegionItem_module_css_classes.languageMenuContentListLanguageItemLinkInactive),
            component: language.href ? "a" : "span",
            size: isSmallSize ? "navigation-overlay-title" : "navigation-overlay-item-m-bold",
            ...language
        }, language.text));
    })));
});


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/subcomponents/LanguageMenu/LanguageMenu.module.css.mjs
var LanguageMenu_module_css_classes = {
    "languageMenu": "G0NH7",
    "languageMenuTab": "qKQ8r",
    "languageMenuContentWrapper": "qP9Qm",
    "languageMenuContent": "_-0Fq-",
    "languageMenuContentList": "abjm6",
    "languageMenuContentListItem": "aR--I",
    "languageMenuContentLanguageList": "Pk9s-",
    "languageMenuContentListItemDivider": "_3Czxb",
    "languageMenuContentListLanguageItem": "_7MxtS",
    "languageMenuContentListCurrentItem": "_60Rcx",
    "languageMenuContentListLanguageCurrentItem": "yTS95",
    "languageMenuContentListItemCurrentDivider": "vl-4A",
    "languageMenuContentWrapperMobile": "-ZPAr",
    "languageMenuContentWrapperMobileLevelOne": "_1vOYm",
    "languageMenuContentWrapperMobileLevelTwoItem": "_6GAMw",
    "languageMenuContentListLanguageItemLink": "hiwFd",
    "languageMenuMobileClose": "sTS1m",
    "languageMenuMobileBackText": "cWa86",
    "languageMenuMobileCloseIcon": "_16azj"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/subcomponents/LanguageMenu/LanguageMenu.mjs
"use client";







const LanguageMenu = (0,factory_utils/* factory */.d5)((props, ref)=>{
    const { regions , heading , copy , currentCounty , className , setIsOpenMobileMenu , setMenuOpen , ...rest } = props;
    const [selectedRegionName, setSelectedRegionName] = (0,react.useState)();
    const classNames = (0,clsx/* default */.Z)(className, "kohler-language-menu-root", LanguageMenu_module_css_classes.languageMenu);
    const tabs = regions.map((param)=>{
        let { countries , name , ...rest2 } = param;
        return {
            id: name,
            text: name,
            ...rest2
        };
    });
    const selectedRegion = regions.find((region)=>region.name === selectedRegionName);
    const selectedRegionTabs = selectedRegion || regions[0];
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        component: "div",
        ref,
        className: classNames,
        ...rest
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(TabbedNavigationHorizontal, {
        align: "center",
        initialSelectedTab: tabs[0].id,
        tabs,
        onTabClick: setSelectedRegionName,
        className: LanguageMenu_module_css_classes.languageMenuTab
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Grid/* Grid */.r, {
        className: (0,clsx/* default */.Z)("center-grid", LanguageMenu_module_css_classes.languageMenuContentWrapper)
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        className: LanguageMenu_module_css_classes.languageMenuContent
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        size: "navigation-overlay-title",
        className: LanguageMenu_module_css_classes.languageMenuTitle,
        textColor: "var(--content-primary)"
    }, heading.text), copy && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        className: LanguageMenu_module_css_classes.languageMenuCopy,
        component: /*#__PURE__*/ (0,react.isValidElement)(copy.text) ? "div" : copy.component || "p",
        size: "paragraph-medium",
        textColor: "var(--content-secondary)",
        ...(0,helpers/* omitText */.rW)(copy)
    }, copy.text)), selectedRegionTabs && /* @__PURE__ */ /*#__PURE__*/ react.createElement("ul", {
        className: LanguageMenu_module_css_classes.languageMenuContentList
    }, selectedRegionTabs.countries.map((country)=>{
        const { name , languages , ...rest2 } = country;
        return /* @__PURE__ */ /*#__PURE__*/ react.createElement("li", {
            key: country.name,
            className: (0,clsx/* default */.Z)(LanguageMenu_module_css_classes.languageMenuContentListItem, currentCounty === name && LanguageMenu_module_css_classes.languageMenuContentListCurrentItem)
        }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(RegionItem, {
            name,
            languages,
            ...rest2
        }));
    }))), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Grid/* Grid */.r, {
        className: (0,clsx/* default */.Z)(LanguageMenu_module_css_classes.languageMenuContentWrapperMobile),
        rowGap: 30
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        className: LanguageMenu_module_css_classes.languageMenuMobileClose
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        component: "button",
        type: "button",
        onClick: ()=>{
            setMenuOpen === null || setMenuOpen === void 0 ? void 0 : setMenuOpen(null);
            if (setIsOpenMobileMenu) {
                setIsOpenMobileMenu(false);
            }
        },
        className: LanguageMenu_module_css_classes.languageMenuMobileCloseIcon
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(CloseIcon/* CloseIcon */.T, {
        withBoundingBox: false,
        size: "medium"
    })), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        size: "label-regular-m",
        component: "button",
        type: "button",
        textColor: "var(--content-secondary)",
        className: LanguageMenu_module_css_classes.languageMenuMobileBackText,
        onClick: ()=>{
            return selectedRegionName ? setSelectedRegionName(void 0) : setMenuOpen === null || setMenuOpen === void 0 ? void 0 : setMenuOpen(null);
        }
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(ArrowLeftIcon, {
        withBoundingBox: false,
        size: "small"
    }), " ", selectedRegionName ? "Region" : "Menu")), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        component: "ul",
        className: (0,clsx/* default */.Z)(LanguageMenu_module_css_classes.languageMenuContentWrapperMobileLevelOne)
    }, !selectedRegionName ? /* @__PURE__ */ /*#__PURE__*/ react.createElement(react.Fragment, null, tabs.map((tab)=>/* @__PURE__ */ /*#__PURE__*/ react.createElement("li", {
            key: tab.id
        }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
            size: "navigation-overlay-item-l",
            textColor: "var(--content-action-default)",
            component: "button",
            type: "button",
            ...(0,helpers/* omitText */.rW)(tab),
            onClick: ()=>setSelectedRegionName(tab.id)
        }, tab.text)))) : /* @__PURE__ */ /*#__PURE__*/ react.createElement(react.Fragment, null, selectedRegionTabs.countries.map((region)=>/* @__PURE__ */ /*#__PURE__*/ react.createElement("li", {
            key: region.name
        }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(RegionItem, {
            ...region
        })))))));
});


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/subcomponents/LoginMenu/LoginMenu.module.css.mjs
var LoginMenu_module_css_classes = {
    "loginMenu": "pSbfH",
    "loginMenuContent": "-f9Ib",
    "loginMenuContentList": "g0mn1",
    "loginMenuContentListLastItem": "MJn-B",
    "loginMenuMobileClose": "Ya58B",
    "loginMenuMobileBackText": "Wzpj3",
    "loginMenuMobileCloseIcon": "lOY-R",
    "loginMenuGridGap": "TGjAi"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/subcomponents/LoginMenu/LoginMenu.mjs
"use client";





const LoginMenu = (0,factory_utils/* factory */.d5)((props, ref)=>{
    const { className , headingSignIn , headingSignOut , loggedInCTAs , loggedOutCTAs , signOutCTA , isLoggedIn , setIsOpenMobileMenu , setMenuOpen , ...rest } = props;
    const classNames = (0,clsx/* default */.Z)(className, "kohler-login-menu-root", LoginMenu_module_css_classes.loginMenu);
    const { width  } = (0,use_window_size/* useWindowSize */.i)();
    const isSmallerScreen = width < 1024;
    var _component, _component1;
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        component: "div",
        ref,
        className: classNames,
        ...rest
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Grid/* Grid */.r, {
        className: (0,clsx/* default */.Z)("center-grid", LoginMenu_module_css_classes.loginMenuGridGap)
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        className: LoginMenu_module_css_classes.loginMenuMobileClose
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        component: "button",
        type: "button",
        onClick: ()=>{
            setMenuOpen === null || setMenuOpen === void 0 ? void 0 : setMenuOpen(null);
            if (setIsOpenMobileMenu) {
                setIsOpenMobileMenu(false);
            }
        },
        className: LoginMenu_module_css_classes.loginMenuMobileCloseIcon
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(CloseIcon/* CloseIcon */.T, {
        withBoundingBox: false,
        size: "medium"
    })), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        size: "label-regular-m",
        component: "button",
        type: "button",
        textColor: "var(--content-secondary)",
        className: LoginMenu_module_css_classes.loginMenuMobileBackText,
        onClick: ()=>{
            return setMenuOpen === null || setMenuOpen === void 0 ? void 0 : setMenuOpen(null);
        }
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(ArrowLeftIcon, {
        withBoundingBox: false,
        size: "small"
    }), " Menu")), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        className: LoginMenu_module_css_classes.loginMenuContent
    }, isLoggedIn && headingSignIn && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        size: "navigation-overlay-title",
        textColor: "var(--content-primary)"
    }, headingSignIn.text), !isLoggedIn && headingSignOut && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        size: "navigation-overlay-title",
        textColor: "var(--content-primary)"
    }, headingSignOut.text)), (loggedInCTAs || loggedOutCTAs) && /* @__PURE__ */ /*#__PURE__*/ react.createElement("ul", {
        className: LoginMenu_module_css_classes.loginMenuContentList
    }, isLoggedIn && loggedInCTAs && loggedInCTAs.map((CTA)=>{
        var _component, _component1;
        return /* @__PURE__ */ /*#__PURE__*/ react.createElement("li", {
            key: CTA.text
        }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
            component: "href" in CTA && (CTA === null || CTA === void 0 ? void 0 : CTA.href) ? (_component = CTA.component) !== null && _component !== void 0 ? _component : "a" : (_component1 = CTA.component) !== null && _component1 !== void 0 ? _component1 : "button",
            ...(0,helpers/* omitText */.rW)(CTA),
            size: isSmallerScreen ? "navigation-overlay-item-l" : "h6",
            textColor: "var(--content-action-default)"
        }, CTA.text));
    }), !isLoggedIn && loggedOutCTAs && loggedOutCTAs.map((CTA)=>{
        var _component, _component1;
        return /* @__PURE__ */ /*#__PURE__*/ react.createElement("li", {
            key: CTA.text
        }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
            component: "href" in CTA && (CTA === null || CTA === void 0 ? void 0 : CTA.href) ? (_component = CTA.component) !== null && _component !== void 0 ? _component : "a" : (_component1 = CTA.component) !== null && _component1 !== void 0 ? _component1 : "button",
            ...(0,helpers/* omitText */.rW)(CTA),
            size: isSmallerScreen ? "navigation-overlay-item-l" : "h6",
            textColor: "var(--content-action-default)"
        }, CTA.text));
    }), isLoggedIn && signOutCTA && /* @__PURE__ */ /*#__PURE__*/ react.createElement("li", {
        className: LoginMenu_module_css_classes.loginMenuContentListLastItem
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        component: "href" in signOutCTA && (signOutCTA === null || signOutCTA === void 0 ? void 0 : signOutCTA.href) ? (_component = signOutCTA.component) !== null && _component !== void 0 ? _component : "a" : (_component1 = signOutCTA.component) !== null && _component1 !== void 0 ? _component1 : "button",
        ...(0,helpers/* omitText */.rW)(signOutCTA),
        size: isSmallerScreen ? "label-regular-l" : "label-regular-m",
        textColor: "var(--content-action-default)"
    }, signOutCTA.text || "Sign Out")))));
});


// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Popover/Tooltip/Tooltip.mjs + 2 modules
var Tooltip = __webpack_require__(23293);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Controls/Checkbox/Checkbox.context.mjs
var Checkbox_context = __webpack_require__(75513);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Controls/Checkbox/Checkbox.module.css.mjs
var Checkbox_module_css_classes = {
    "checkboxContainer": "xQrET",
    "checkboxInput": "_0FmnM",
    "checkboxInner": "qhpmx",
    "checkboxLabelWrapper": "WWTn2",
    "checkboxLabel": "eDKHW",
    "checkboxDescription": "iwTEw",
    "checkboxError": "H3go5",
    "checkboxIcon": "GJS7K",
    "checkboxWrapper": "_48FCt"
};


// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Controls/Checkbox/CheckboxIcon.mjs + 2 modules
var CheckboxIcon = __webpack_require__(39805);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Controls/Checkbox/Checkbox.mjs
"use client";










const ConditionalWrapper = (param)=>{
    let { tooltip , className , children , ...rest } = param;
    if (tooltip) {
        return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
            className,
            ...rest
        }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Tooltip/* Tooltip */.u, {
            ...tooltip
        }, children));
    }
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        className,
        ...rest
    }, children);
};
const Checkbox = (0,factory_utils/* factory */.d5)((props, ref)=>{
    const { className , style , id , label , disabled , onChange , indeterminate , checked , tooltip , ...rest } = props;
    const ctx = (0,Checkbox_context/* useCheckboxGroupContext */.J)();
    const inputId = id || (0,react.useId)();
    const contextProps = ctx ? {
        checked: ctx.value.includes(rest.value),
        onChange: (event)=>{
            ctx.onChange(event);
            onChange === null || onChange === void 0 ? void 0 : onChange(event);
        }
    } : {};
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(ConditionalWrapper, {
        className: (0,clsx/* default */.Z)(className, "kohler-checkbox-root", Checkbox_module_css_classes.checkboxWrapper),
        style,
        "data-checked": contextProps.checked || checked || void 0,
        tooltip
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        className: Checkbox_module_css_classes.checkboxContainer
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        className: (0,clsx/* default */.Z)("kohler-checkbox-radio", Checkbox_module_css_classes.checkboxInner)
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        onChange,
        className: (0,clsx/* default */.Z)("kohler-checkbox-radio-input", Checkbox_module_css_classes.checkboxInput),
        component: "input",
        ref,
        id: inputId,
        disabled,
        checked,
        ...rest,
        ...contextProps,
        type: "checkbox"
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement(CheckboxIcon/* CheckboxIcon */.P, {
        "aria-hidden": true,
        className: Checkbox_module_css_classes.checkboxIcon,
        indeterminate
    })), /* @__PURE__ */ /*#__PURE__*/ react.createElement("div", {
        "data-disabled": disabled || void 0,
        className: Checkbox_module_css_classes.checkboxLabelWrapper
    }, label && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        component: "label",
        htmlFor: inputId,
        size: "label-regular-m",
        className: Checkbox_module_css_classes.checkboxLabel,
        "data-disabled": disabled || void 0
    }, label))));
});


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/subcomponents/StoreMenu/StoreMenu.module.css.mjs
var StoreMenu_module_css_classes = {
    "storeMenu": "ZR55Z",
    "storeMenuMainGrid": "w4Fxm",
    "storeMenuMainContent": "gjKP9",
    "storeMenuMainFullContent": "h43x8",
    "storeMenuContentHeading": "lcpCD",
    "storeMenuContentInfoContainer": "uK28n",
    "storeMenuContentInfo": "TjwfC",
    "storeMenuZipContainer": "Z5Gs6",
    "storeMenuContentZipContainerEyebrow": "Yl0kK",
    "storeMenuContentList": "KUq53",
    "storeMenuContentListItemLink": "kQv73",
    "storeMenuMobileClose": "AFsOW",
    "storeMenuMobileBackText": "s3mxI",
    "storeMenuMobileCloseIcon": "_7Rh7F"
};


// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Buttons/Button/Button.mjs + 2 modules
var Button = __webpack_require__(58510);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/subcomponents/StoreMenu/ZipCodeInputField/ZipCodeInputField.module.css.mjs
var ZipCodeInputField_module_css_classes = {
    "inputContainer": "Gg-OE",
    "inputFieldButton": "sRmnm",
    "input": "wjs4T"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/subcomponents/StoreMenu/ZipCodeInputField/ZipCodeInputField.mjs
"use client";




const ZipCodeInputField = (0,factory_utils/* factory */.d5)((props, ref)=>{
    const { handleSubmit , onSubmit , id ="zipcode-input" , label ="Zip Code" , placeholder , CTA , className , inputValue , onInputChange , ...rest } = props;
    const [value, setValue] = (0,react.useState)(null);
    var ref1;
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement("form", {
        className: "waitlist-form",
        onSubmit: (event)=>{
            event.preventDefault();
            onSubmit && onSubmit(event);
            const target = event.target;
            handleSubmit(target.elements[0].value || "");
        },
        onInvalid: (e)=>{
            e.preventDefault();
        },
        ...rest
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement("div", {
        ref,
        className: (0,clsx/* default */.Z)(ZipCodeInputField_module_css_classes.inputContainer, "kohler-input-field-wrapper", className)
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        size: "h4",
        component: "input",
        id,
        type: "text",
        className: (0,clsx/* default */.Z)(ZipCodeInputField_module_css_classes.input),
        placeholder: placeholder || label,
        ref,
        "aria-label": rest["aria-label"],
        autoCapitalize: "off",
        autoCorrect: "off",
        maxLength: 75,
        min: 0,
        value: (ref1 = inputValue !== null && inputValue !== void 0 ? inputValue : value) !== null && ref1 !== void 0 ? ref1 : "",
        onChange: (e)=>{
            if (typeof onInputChange === "function") {
                onInputChange(e);
            } else {
                const newValue = e.target.value;
                setValue(newValue.length === 0 ? null : newValue);
            }
        }
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Button/* Button */.z, {
        variant: "primary",
        size: "small",
        type: "submit",
        disabled: !inputValue && !value,
        className: ZipCodeInputField_module_css_classes.inputFieldButton,
        ...(0,helpers/* omitText */.rW)(CTA || {})
    }, (CTA === null || CTA === void 0 ? void 0 : CTA.text) || "Submit")));
});


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/subcomponents/StoreMenu/StoreMenu.mjs
"use client";






const StoreMenu = (0,factory_utils/* factory */.d5)((props, ref)=>{
    const { className , heading , CTAs , eyebrow , subheading , storeInfo , zipCodeInput , setStoreCTA , setMenuOpen , setIsOpenMobileMenu , ...rest } = props;
    const classNames = (0,clsx/* default */.Z)(className, "kohler-store-menu-root", StoreMenu_module_css_classes.storeMenu);
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        component: "div",
        ref,
        className: classNames,
        ...rest
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Grid/* Grid */.r, {
        className: (0,clsx/* default */.Z)("center-grid", StoreMenu_module_css_classes.storeMenuMainGrid)
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        className: StoreMenu_module_css_classes.storeMenuMobileClose
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        component: "button",
        type: "button",
        onClick: ()=>{
            setMenuOpen === null || setMenuOpen === void 0 ? void 0 : setMenuOpen(null);
            if (setIsOpenMobileMenu) {
                setIsOpenMobileMenu(false);
            }
        },
        className: StoreMenu_module_css_classes.storeMenuMobileCloseIcon
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(CloseIcon/* CloseIcon */.T, {
        withBoundingBox: false,
        size: "medium"
    })), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        size: "label-regular-m",
        component: "button",
        type: "button",
        textColor: "var(--content-secondary)",
        className: StoreMenu_module_css_classes.storeMenuMobileBackText,
        onClick: ()=>{
            return setMenuOpen === null || setMenuOpen === void 0 ? void 0 : setMenuOpen(null);
        }
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(ArrowLeftIcon, {
        withBoundingBox: false,
        size: "small"
    }), " Menu")), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        className: (0,clsx/* default */.Z)(StoreMenu_module_css_classes.storeMenuMainContent, !storeInfo && StoreMenu_module_css_classes.storeMenuMainFullContent)
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        className: StoreMenu_module_css_classes.storeMenuContentHeading
    }, eyebrow && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        size: "label-medium-m",
        textColor: "var(--content-primary)",
        component: /*#__PURE__*/ (0,react.isValidElement)(eyebrow.text) ? "div" : eyebrow.component || "p"
    }, eyebrow.text), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        size: "navigation-overlay-title",
        textColor: "var(--content-primary)"
    }, heading.text), subheading && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        size: "label-regular-m",
        textColor: "var(--content-primary)",
        component: /*#__PURE__*/ (0,react.isValidElement)(subheading.text) ? "div" : subheading.component || "p"
    }, subheading.text)), storeInfo && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        className: StoreMenu_module_css_classes.storeMenuContentInfoContainer
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        className: StoreMenu_module_css_classes.storeMenuContentInfo,
        size: "label-regular-m",
        component: "div"
    }, storeInfo), setStoreCTA && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Checkbox, {
        ...setStoreCTA
    }))), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        className: StoreMenu_module_css_classes.storeMenuZipContainer
    }, zipCodeInput.eyebrow && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        size: "label-medium-m",
        className: StoreMenu_module_css_classes.storeMenuContentZipContainerEyebrow,
        component: /*#__PURE__*/ (0,react.isValidElement)(zipCodeInput.eyebrow.text) ? "div" : zipCodeInput.eyebrow.component || "p"
    }, zipCodeInput.eyebrow.text), /* @__PURE__ */ /*#__PURE__*/ react.createElement(ZipCodeInputField, {
        ...zipCodeInput
    }), CTAs && /* @__PURE__ */ /*#__PURE__*/ react.createElement("ul", {
        className: StoreMenu_module_css_classes.storeMenuContentList
    }, CTAs.map((CTA)=>{
        return /* @__PURE__ */ /*#__PURE__*/ react.createElement("li", {
            key: CTA.text
        }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
            component: CTA.component || "a",
            ...(0,helpers/* omitText */.rW)(CTA),
            className: (0,clsx/* default */.Z)(StoreMenu_module_css_classes.storeMenuContentListItemLink),
            size: "label-regular-m",
            style: {
                textDecoration: "underline"
            }
        }, CTA.text));
    })))));
});


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/subcomponents/UtilityLinks/subcomponents/LocationPickButton/LocationPickButton.module.css.mjs
var LocationPickButton_module_css_classes = {
    "locationPickButtonContainer": "D2D4P"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/subcomponents/UtilityLinks/subcomponents/LocationPickButton/LocationPickButton.mjs





const LocationPickButton = (props)=>{
    const { text , className , ...rest } = props;
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        component: "button",
        type: "button",
        size: "overline",
        className: (0,clsx/* default */.Z)(LocationPickButton_module_css_classes.locationPickButtonContainer, className),
        ...rest
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(LocationIcon, {
        withBoundingBox: false
    }), " ", text);
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/subcomponents/UtilityLinks/UtilityLinks.module.css.mjs
var UtilityLinks_module_css_classes = {
    "utilityLinks": "JYuAi",
    "divider": "gk5hS"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/subcomponents/UtilityLinks/UtilityLinks.mjs
"use client";







const UtilityLinks_omitFavoritesCTA = (favoritesCTA)=>{
    const { isFilled =false , ...omitFavoritesCTA2 } = favoritesCTA;
    return {
        isFilled,
        omitFavoritesCTA: omitFavoritesCTA2
    };
};
const UtilityLinks = (param)=>{
    let { isLoggedIn =false , locationPickerCTA , languagePicker , favoritesCTA , cartBadgeCTA , userName , userCTA , // eslint-disable-next-line @typescript-eslint/no-unused-vars
    utilityLinksMobile , // eslint-disable-next-line @typescript-eslint/no-unused-vars
    userCTAMobile , menuType , className , ...rest } = param;
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        className: (0,clsx/* default */.Z)(UtilityLinks_module_css_classes.utilityLinks, className),
        ...rest
    }, (locationPickerCTA || languagePicker) && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        align: "center",
        gap: 25,
        paddingLeft: 25
    }, locationPickerCTA && /* @__PURE__ */ /*#__PURE__*/ react.createElement(LocationPickButton, {
        "aria-expanded": menuType === "store",
        ...locationPickerCTA
    }), languagePicker && /* @__PURE__ */ /*#__PURE__*/ react.createElement(LanguagePicker, {
        ...languagePicker,
        languagePickerCTA: {
            "aria-expanded": menuType === "language",
            ...languagePicker.languagePickerCTA
        }
    })), (locationPickerCTA || languagePicker) && /* @__PURE__ */ /*#__PURE__*/ react.createElement("div", {
        className: UtilityLinks_module_css_classes.divider
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        className: UtilityLinks_module_css_classes.utilityLink,
        gap: 15,
        align: "center"
    }, userCTA && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        component: "button",
        type: "button",
        display: "flex",
        textColor: "var(--content-primary)",
        "aria-label": isLoggedIn ? "user sign in" : "profile",
        "aria-expanded": menuType === "user",
        ...(0,helpers/* omitText */.rW)(userCTA)
    }, isLoggedIn && userName ? /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        size: "label-medium-xs",
        textColor: "var(--content-primary)"
    }, "Hi, ", userName) : /* @__PURE__ */ /*#__PURE__*/ react.createElement(UserIcon, {
        withBoundingBox: false
    })), favoritesCTA && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        component: "a",
        display: "flex",
        "aria-label": "see favorites",
        textColor: "var(--content-primary)",
        ...UtilityLinks_omitFavoritesCTA(favoritesCTA).omitFavoritesCTA
    }, UtilityLinks_omitFavoritesCTA(favoritesCTA).isFilled ? /* @__PURE__ */ /*#__PURE__*/ react.createElement(FavoriteNavFilledIcon, {
        withBoundingBox: false
    }) : /* @__PURE__ */ /*#__PURE__*/ react.createElement(FavoriteNavIcon, {
        withBoundingBox: false
    })), cartBadgeCTA && /* @__PURE__ */ /*#__PURE__*/ react.createElement(CartBadge, {
        display: "flex",
        textColor: "var(--content-primary)",
        component: "a",
        "aria-label": "see cart",
        ...cartBadgeCTA
    })));
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/subcomponents/UtilityBar/UtilityBar.module.css.mjs
var UtilityBar_module_css_classes = {
    "utilityBar": "PL9MW",
    "utilityBarContent": "_9Smdc",
    "utilityBrands": "xuHNv",
    "utilityBrand": "_02ugQ",
    "utilityBrandActive": "umtRO",
    "menuPositionWrapper": "tvoWJ",
    "menuPositionOverlay": "zNXyE",
    "utilityLinksWrapper": "F3cqT"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/subcomponents/UtilityBar/UtilityBar.mjs








const UtilityBar = (0,factory_utils/* factory */.d5)((props, ref)=>{
    const { brands , mod , loginMenu , storeMenu , languageMenu , menuOpen , setMenuOpen , favoritesCTA , cartBadgeCTA , userCTA , isLoggedIn , languagePicker , locationPickerCTA , userName , utilityLinksMobile , userCTAMobile , setIsOpenMobileMenu , ...rest } = props;
    const utilityLinks = {
        favoritesCTA,
        cartBadgeCTA,
        userCTA,
        isLoggedIn,
        languagePicker,
        locationPickerCTA,
        userName,
        utilityLinksMobile,
        userCTAMobile
    };
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        className: UtilityBar_module_css_classes.utilityBar,
        mod,
        ref,
        ...rest
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Grid/* Grid */.r, null, /* @__PURE__ */ /*#__PURE__*/ react.createElement(GridColumn/* GridColumn */.C, {
        className: UtilityBar_module_css_classes.utilityBarContent
    }, brands && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        component: "ul",
        className: UtilityBar_module_css_classes.utilityBrands
    }, brands.map((brand)=>{
        const { isActive , ...brandProps } = brand;
        return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
            component: "li",
            key: brand.text
        }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
            size: "navigation-brand-switcher",
            component: "a",
            target: "_blank",
            ...(0,helpers/* omitText */.rW)(brandProps),
            className: (0,clsx/* default */.Z)(UtilityBar_module_css_classes.utilityBrand, isActive && UtilityBar_module_css_classes.utilityBrandActive)
        }, brand.text));
    })), /* @__PURE__ */ /*#__PURE__*/ react.createElement(UtilityLinks, {
        ...utilityLinks,
        menuType: menuOpen,
        className: UtilityBar_module_css_classes.utilityLinksWrapper
    }))), menuOpen && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        className: UtilityBar_module_css_classes.menuPositionWrapper
    }, menuOpen === "user" && /* @__PURE__ */ /*#__PURE__*/ react.createElement(LoginMenu, {
        ...loginMenu,
        setMenuOpen,
        setIsOpenMobileMenu
    }), menuOpen === "language" && languageMenu && /* @__PURE__ */ /*#__PURE__*/ react.createElement(LanguageMenu, {
        ...languageMenu,
        setMenuOpen,
        setIsOpenMobileMenu
    }), menuOpen === "store" && storeMenu && /* @__PURE__ */ /*#__PURE__*/ react.createElement(StoreMenu, {
        ...storeMenu,
        setMenuOpen,
        setIsOpenMobileMenu
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        className: UtilityBar_module_css_classes.menuPositionOverlay,
        onClick: ()=>{
            return setMenuOpen === null || setMenuOpen === void 0 ? void 0 : setMenuOpen(null);
        }
    })));
});


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/MainMenu/MainMenu.mjs
"use client";












const MainMenu = (0,factory_utils/* factory */.d5)((props, ref)=>{
    const { className , infoBanner , globalBanner , mainNavigation , utilityBar , promoBanner , storeMenu , loginMenu , languageMenu , mod , style , ...rest } = props;
    const classNames = (0,clsx/* default */.Z)(classes.mainMenu, className, "kohler-main-menu-root");
    const [menuOpen, setMenuOpen] = (0,react.useState)(null);
    const [mainMenuHeight, setMainMenuHeight] = (0,react.useState)(0);
    const [openMobileMenu, setOpenMobileMenu] = (0,react.useState)(false);
    const mainMenuWrapperRef = (0,react.useRef)(null);
    const composeMainMenuWrapperRef = (0,use_merged_ref/* useMergedRef */.Yx)(mainMenuWrapperRef, ref);
    const { showStickyNav , isSticky  } = useStickyNavigation(mainMenuHeight, mainNavigation === null || mainNavigation === void 0 ? void 0 : mainNavigation.isAlwaysSticky);
    const [firstStickyApplied, setFirstStickyApplied] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        if (isSticky && !firstStickyApplied) {
            setFirstStickyApplied(true);
        } else if (!isSticky && firstStickyApplied) {
            setFirstStickyApplied(false);
        }
    }, [
        isSticky,
        firstStickyApplied
    ]);
    const disableTransition = isSticky && !firstStickyApplied;
    const typedUtilityBar = {
        ...utilityBar
    };
    if (typedUtilityBar) {
        if (typedUtilityBar.languagePicker && languageMenu) {
            var ref1, ref2;
            const originalOnClick = utilityBar === null || utilityBar === void 0 ? void 0 : (ref1 = utilityBar.languagePicker) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.languagePickerCTA) === null || ref2 === void 0 ? void 0 : ref2.onClick;
            typedUtilityBar.languagePicker.languagePickerCTA.onClick = (e)=>{
                if (originalOnClick) {
                    originalOnClick(e);
                }
                if (menuOpen === "language") {
                    setMenuOpen(null);
                } else {
                    setMenuOpen("language");
                }
            };
        }
        if (typedUtilityBar.locationPickerCTA && storeMenu) {
            var ref3;
            const originalOnClick1 = utilityBar === null || utilityBar === void 0 ? void 0 : (ref3 = utilityBar.locationPickerCTA) === null || ref3 === void 0 ? void 0 : ref3.onClick;
            typedUtilityBar.locationPickerCTA.onClick = (e)=>{
                if (originalOnClick1) {
                    originalOnClick1(e);
                }
                if (menuOpen === "store") {
                    setMenuOpen(null);
                } else {
                    setMenuOpen("store");
                }
            };
        }
        if (typedUtilityBar && loginMenu) {
            var ref4;
            const originalOnClick2 = utilityBar === null || utilityBar === void 0 ? void 0 : (ref4 = utilityBar.userCTA) === null || ref4 === void 0 ? void 0 : ref4.onClick;
            typedUtilityBar.userCTA = (utilityBar === null || utilityBar === void 0 ? void 0 : utilityBar.userCTA) || {};
            typedUtilityBar.userCTA.onClick = (e)=>{
                if (originalOnClick2) {
                    originalOnClick2(e);
                }
                setMenuOpen(menuOpen === "user" ? null : "user");
            };
        }
    }
    (0,react.useEffect)(()=>{
        if (mainMenuWrapperRef.current) {
            setMainMenuHeight(mainMenuWrapperRef.current.clientHeight);
        }
    }, [
        setMainMenuHeight
    ]);
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        component: "header",
        ref: composeMainMenuWrapperRef,
        ...rest,
        className: classNames,
        mod,
        style: {
            "--main-menu-height": "".concat(mainMenuHeight, "px"),
            ...style
        }
    }, infoBanner && /* @__PURE__ */ /*#__PURE__*/ react.createElement(MessageBanner, {
        type: "info",
        ...infoBanner
    }), globalBanner && /* @__PURE__ */ /*#__PURE__*/ react.createElement(MessageBanner, {
        type: "global",
        ...globalBanner
    }), typedUtilityBar && /* @__PURE__ */ /*#__PURE__*/ react.createElement(UtilityBar, {
        ...typedUtilityBar,
        menuOpen,
        setMenuOpen,
        storeMenu,
        languageMenu,
        loginMenu,
        setIsOpenMobileMenu: setOpenMobileMenu
    }), promoBanner && /* @__PURE__ */ /*#__PURE__*/ react.createElement(MessageBanner, {
        type: "promo",
        ...promoBanner
    }), mainNavigation && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        className: (0,clsx/* default */.Z)(classes.mainNavigationBarWrapper, {
            [classes.fixedNav]: isSticky,
            [classes.showSticky]: showStickyNav,
            [classes.showBackgroundRelative]: mainNavigation.showBackground || mainNavigation.isStatic
        }),
        style: disableTransition ? {
            transitionDuration: "0s"
        } : void 0
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(MainNavigationBar, {
        ...mainNavigation,
        utilityLinks: typedUtilityBar,
        setIsOpenMobileMenu: setOpenMobileMenu,
        openMobileMenu,
        showBackground: isSticky || mainNavigation.showBackground
    })));
});


// EXTERNAL MODULE: ./components/Shared/UtilityWidgets/v1/UtilityWidgets.jsx
var UtilityWidgets = __webpack_require__(55938);
// EXTERNAL MODULE: ./store/features/favoritesSlice.js + 1 modules
var favoritesSlice = __webpack_require__(7737);
// EXTERNAL MODULE: ./i18n/useAuthUtilityNavi18n.js
var useAuthUtilityNavi18n = __webpack_require__(46967);
// EXTERNAL MODULE: ./store/features/authSlice.js
var authSlice = __webpack_require__(24899);
// EXTERNAL MODULE: ./constants/index.js
var constants_0 = __webpack_require__(96301);
// EXTERNAL MODULE: ./constants/api.js
var api = __webpack_require__(73350);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./utils/cart.js
var cart = __webpack_require__(11763);
// EXTERNAL MODULE: ./utils/location.js
var utils_location = __webpack_require__(97433);
// EXTERNAL MODULE: ./constants/routes.js
var routes = __webpack_require__(64757);
// EXTERNAL MODULE: ./constants/config.js
var constants_config = __webpack_require__(19514);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./components/FindStoreUtilNav/analytics.js
var analytics = __webpack_require__(90062);
// EXTERNAL MODULE: ./components/FindStoreUtilNav/v1/localization.js
var localization = __webpack_require__(26977);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/index.js + 15 modules
var dist_es = __webpack_require__(67421);
// EXTERNAL MODULE: ./store/features/locationSlice.js
var locationSlice = __webpack_require__(56608);
// EXTERNAL MODULE: ./components/FindStore/v1/api.js
var v1_api = __webpack_require__(2182);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./components/core/Modal/ZipCodeInfoModal.jsx
var ZipCodeInfoModal = __webpack_require__(96352);
// EXTERNAL MODULE: ./i18n/useFindStorei18n.js
var useFindStorei18n = __webpack_require__(83511);
// EXTERNAL MODULE: ./components/Shared/HeaderNavTabs/analytics/index.js
var HeaderNavTabs_analytics = __webpack_require__(24897);
// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(85518);
// EXTERNAL MODULE: ./hooks/useWindowResize.js
var useWindowResize = __webpack_require__(11859);
;// CONCATENATED MODULE: ./components/Shared/GlobalPage/GlobalPageHeader.jsx




































const configInitialState = {
    browseAllStoreUrl: "",
    brand: "",
    findStores: ""
};
const GlobalPageHeader = (props)=>{
    var ref;
    const { themeType ="" , header ={} , title ="" , description ="" , globalScripting ="" , isPdp =false , imageUrl ="" , email ="" , phone ="" , fullUrl ="" , siteName =""  } = props;
    const { pageIsInteractive , featureFlags ={} , globalConfig: { internationalization: { language ="en"  } = {} , general: { cartLandingPagePath ="" , signInFragment ="" , signUpFragment ="" , navigationHoverTiming ="" , siteName: BrandName = ""  } = {}  } = {}  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const { utilityStoreDetails , utilityData , myStoreId  } = (0,es/* useSelector */.v9)(locationSlice/* locationState */._n);
    const initialState = {
        userCity: "",
        utilityLocation: "",
        utilityData: {},
        utilityStoreDetails: {},
        findStores: "",
        reverseGeo: "",
        myStoreId: typeof Window !== "undefined" ? localStorage.getItem("myStoreId") : 0,
        siteName: "",
        findStoreUrl: "",
        utilityStoreDetailsUrl: ""
    };
    const { data: authorData = {}  } = props;
    const staticTexts = (0,useFindStorei18n/* default */.Z)({
        authorData
    });
    const bodyRef = (0,react.useRef)(null);
    const htmlRef = (0,react.useRef)(null);
    const [metas, setMetas] = (0,react.useState)([]);
    const [styles, setStyles] = (0,react.useState)([]);
    const [scripts, setScripts] = (0,react.useState)([]);
    const [links, setLinks] = (0,react.useState)([]);
    const [logIndata, setLogIndata] = (0,react.useState)([]);
    const [logOutdata, setLogOutdata] = (0,react.useState)([]);
    const [favoritesPagePath, setFavoritesPagePath] = (0,react.useState)("/");
    const [favoritesPage, setFavoritesPage] = (0,react.useState)([]);
    const { MYSQLCONNSTR_ENABLE_SHOPPING_LISTS_V2: isSaveProductToList = false  } = featureFlags;
    const { favorites ={} , saveToListLineItems ={}  } = (0,es/* useSelector */.v9)(favoritesSlice/* selectFavoritesState */.Qx);
    const { lineItems =[]  } = favorites || {};
    const i18n = (0,useAuthUtilityNavi18n/* default */.Z)();
    const router = (0,next_router.useRouter)();
    const cartCount = (0,cart/* getCartCount */.c0)();
    const { user: { firstName =null  } = {} , isAuth =false  } = (0,es/* useSelector */.v9)(authSlice/* selectAuthState */._9);
    const { globalConfig  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const dispatch = (0,es/* useDispatch */.I0)();
    const onclicksignIN = function() {
        let datalayershow = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
        dispatch((0,authSlice/* setAuthModalVisibility */.LY)({
            show: true
        }));
        if (datalayershow) {
            (0,HeaderNavTabs_analytics/* newdatalayerforSignIn */.UY)();
        }
    };
    const onClickCreateAccount = ()=>{
        dispatch((0,authSlice/* setAuthModalVisibility */.LY)({
            show: true,
            active: 1
        }));
        (0,HeaderNavTabs_analytics/* newdataLayerForCreateAccount */.Lz)();
    };
    const [loginFavouriteCallback, setLoginFavouriteCallback] = (0,react.useState)(null);
    const [myListsPagePath, setMyListsPagePath] = (0,react.useState)("/");
    const [configState, setConfigState] = (0,react.useState)(configInitialState);
    // for search panel
    const [showSearchBar, setShowSearchBar] = (0,react.useState)(false);
    const { t  } = (0,dist_es/* useTranslation */.$G)("common");
    const staticText = (0,localization/* getTranslations */.F)(t);
    const [state, setState] = (0,react.useState)(initialState);
    const [zipCodeValue, setZipcodeValue] = (0,react.useState)("");
    const [infoModalErrror, setInfoModalErrror] = (0,react.useState)({});
    const [infoModal, setInfoModal] = (0,react.useState)();
    const [browseAllStoreUrl, setbrowseAllStoreUrl] = (0,react.useState)("");
    const [myStoreUrl, setMyStoreUrl] = (0,react.useState)("/");
    const [optionList, setOptionList] = (0,react.useState)([]);
    const [canadaCheck, setCanadaCheck] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        if (state.utilityStoreDetailsUrl !== "") setUtilityStoreDetailsUrl();
    }, [
        state.utilityStoreDetailsUrl
    ]);
    (0,react.useEffect)(()=>{
        setInitalState();
    }, []);
    (0,react.useEffect)(()=>{
        const iscanadaCheck = (0,helper/* isCanadaSite */.guj)(BrandName);
        setCanadaCheck(iscanadaCheck);
    }, [
        BrandName
    ]);
    const handleGlobalClick = (e)=>{
        const target = e.target.closest('[data-datalayer-id="kds-element-navigation"]');
        if (target) {
            var ref, ref1;
            const rawEventInfo = JSON.parse((target === null || target === void 0 ? void 0 : (ref = target.attributes) === null || ref === void 0 ? void 0 : (ref1 = ref["data-datalayer-data"]) === null || ref1 === void 0 ? void 0 : ref1.nodeValue) || "{}");
            const page = window.pageObj || {};
            // Common attributes to add to all events
            const commonEventInfo = {
                eventAction: rawEventInfo.eventAction || "main dropdown menu",
                eventType: rawEventInfo.eventType || "global header",
                eventName: rawEventInfo.eventName || "main dropdown menu",
                internalLinkPosition: (rawEventInfo === null || rawEventInfo === void 0 ? void 0 : rawEventInfo.internalLinkPosition) || "global header",
                internalLinkZoneName: (rawEventInfo === null || rawEventInfo === void 0 ? void 0 : rawEventInfo.internalLinkZoneName) || "global header",
                internalLinkType: (rawEventInfo === null || rawEventInfo === void 0 ? void 0 : rawEventInfo.internalLinkType) || "global header:navigation"
            };
            // Merge common attributes with specific event info
            let eventInfo = {};
            eventInfo = {
                ...rawEventInfo,
                ...commonEventInfo
            };
            window.adobeDataLayer.push({
                event: "cmp:click",
                page,
                eventInfo
            });
        }
    };
    (0,react.useEffect)(()=>{
        document.addEventListener("click", handleGlobalClick);
        return ()=>document.removeEventListener("click", handleGlobalClick);
    }, []);
    const setInitalState = async ()=>{
        const config = await (0,constants_config/* getConfig */.i)();
        getFindStoreUrl(config).then((url)=>{
            setState({
                ...state,
                findStores: get_default()(config, "apiEndpoints.findStores", ""),
                reverseGeo: get_default()(config, "apiEndpoints.reverseGeo", ""),
                siteName: get_default()(config, "general.siteName", ""),
                utilityStoreDetailsUrl: get_default()(config, "general.storeDetailsServletPath"),
                findStoreUrl: url
            });
        });
    };
    const getFindStoreUrl = async (config)=>{
        const findStoreUrl = await (0,utils_location/* getShortenedUrl */.Pp)(get_default()(config, "general.findStorePagePath", ""));
        return findStoreUrl;
    };
    const setUtilityStoreDetailsUrl = async ()=>{
        const utilityStoreDetails = await (0,utils_location/* getUtilityStoreDetails */.BO)(state);
        dispatch((0,locationSlice/* setUtilityStoreDetails */.Hm)(utilityStoreDetails));
        setState({
            ...state,
            utilityStoreDetails
        });
    };
    const redirect = (zipCodeValue)=>{
        const path = "".concat(state.findStoreUrl, "?q=").concat(zipCodeValue, "&queryAspath=").concat(state.findStoreUrl);
        const asPath = "".concat(state.findStoreUrl, "?q=").concat(zipCodeValue);
        router.push(path, asPath);
    };
    const handleZipCodeUpdate = (value)=>{
        setZipcodeValue(value);
    };
    const headerItemsPresent = hasHeaderItems(header);
    const getGeoLocation = ()=>{
        (0,helper/* getMyLocation */.fPm)().then((getLocation)=>{
            setZipcodeValue(getLocation.zipcode ? Number(getLocation.zipcode) : undefined);
            (0,analytics/* headerFindStoreUseLocationAnalytics */.Pj)({
                eventStatus: "success"
            });
        }).catch((param)=>{
            let { cause  } = param;
            setInfoModalErrror(cause !== null && cause !== void 0 ? cause : {});
            setInfoModal(true);
            var ref;
            (0,analytics/* headerFindStoreUseLocationAnalytics */.Pj)({
                errorMessage: (ref = cause === null || cause === void 0 ? void 0 : cause.message) !== null && ref !== void 0 ? ref : "",
                staticTexts,
                eventStatus: "failure"
            });
        });
    };
    (0,react.useEffect)(()=>{
        (0,constants_config/* getConfig */.i)().then(async (config)=>{
            const { general  } = config;
            var _allStoresPagePath;
            const url = await (0,utils_location/* getShortenedUrl */.Pp)((_allStoresPagePath = general.allStoresPagePath) !== null && _allStoresPagePath !== void 0 ? _allStoresPagePath : "/");
            const findStores = get_default()(config, "apiEndpoints.findStores", "");
            const brand = get_default()(config, "general.siteName", "");
            setConfigState({
                browseAllStoreUrl: url,
                findStores,
                brand
            });
            localStorage.getItem("currentZipCode") && setZipcodeValue(localStorage.getItem("currentZipCode"));
            setbrowseAllStoreUrl(url);
        }).catch((err)=>console.log(err));
    }, []);
    (0,react.useEffect)(()=>{
        if (myStoreId === 0) {
            nearestStoreAddress();
        } else {
            dispatch((0,locationSlice/* setStoreAddress */.wf)(utilityData));
        }
    }, [
        zipCodeValue,
        myStoreId
    ]);
    (0,react.useEffect)(()=>{
        if (zipCodeValue.length > 2) {
            fetchListOfCities();
        }
    }, [
        zipCodeValue
    ]);
    const fetchListOfCities = async ()=>{
        const { findStores , brand  } = configState;
        const responseData = await (0,helper/* getCityList */.vzx)(findStores, brand, zipCodeValue);
        const { data: { d: { results =[]  } = {}  } = {}  } = responseData;
        const cities = results.map((city)=>city.Locality);
        setOptionList([
            ...new Set(cities)
        ]);
    };
    const nearestStoreAddress = async ()=>{
        const { findStores , brand  } = configState;
        const nearestStore = await (0,v1_api/* getFindAStoresResult */.R)(findStores, zipCodeValue, brand, 100, 1, "kohler store", 1);
        if (nearestStore !== undefined) {
            var ref;
            var ref1;
            const nearestStoreData = (ref1 = nearestStore === null || nearestStore === void 0 ? void 0 : (ref = nearestStore.data) === null || ref === void 0 ? void 0 : ref.info[0]) !== null && ref1 !== void 0 ? ref1 : {};
            var ref2;
            const utilityData = {
                ...nearestStoreData,
                EntityID: (ref2 = nearestStoreData === null || nearestStoreData === void 0 ? void 0 : nearestStoreData.BPnumber) !== null && ref2 !== void 0 ? ref2 : null
            };
            dispatch((0,locationSlice/* setStoreAddress */.wf)(utilityData));
        } else {
            const utilityData1 = {};
            dispatch((0,locationSlice/* setStoreAddress */.wf)(utilityData1));
        }
    };
    (0,react.useEffect)(()=>{
        if (!isEmpty_default()(utilityStoreDetails) && (utilityData === null || utilityData === void 0 ? void 0 : utilityData.BPnumber)) {
            (0,utils_location/* getShortenedUrl */.Pp)(utilityStoreDetails[utilityData.BPnumber]).then((myStoreUrl)=>{
                setMyStoreUrl(myStoreUrl);
            });
        }
    }, [
        utilityStoreDetails,
        utilityData
    ]);
    const handleUtilityStoreCheck = (entity)=>{
        localStorage.setItem("myStoreId", entity);
        dispatch((0,locationSlice/* setMyStore */.h9)(entity));
        setState({
            ...state,
            myStoreId: entity
        });
    };
    const pageUrl = fullUrl || ( true ? window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : ref.href : 0);
    (0,react.useEffect)(()=>{
        const { pageLevelDetails =[]  } = (0,helper/* getPageLevelScriptsAndStyles */.ptY)(globalScripting);
        setMetas(pageLevelDetails["metaList"]);
        setStyles(pageLevelDetails["stylesList"]);
        setScripts(pageLevelDetails["pageScripts"]);
        setLinks(pageLevelDetails["linkList"]);
    }, [
        globalScripting
    ]);
    // for search panel
    (0,react.useEffect)(()=>{
        if (true) {
            bodyRef.current = document.body;
            htmlRef.current = document.getElementsByTagName("html")[0];
        }
    }, []);
    const handleSearchClick = ()=>{
        var ref;
        showSearchBar ? (0,helper/* addMavenoidChat */.dVG)() : lib/* isMobile */.tq ? (0,helper/* removeMavenoidChat */.N9B)() : (0,helper/* addMavenoidChat */.dVG)();
        const classNames = [
            "searchbar-open",
            "scroll-lock"
        ];
        classNames.forEach((className)=>{
            var ref, ref1;
            return bodyRef === null || bodyRef === void 0 ? void 0 : (ref = bodyRef.current) === null || ref === void 0 ? void 0 : (ref1 = ref.classList) === null || ref1 === void 0 ? void 0 : ref1.toggle(className);
        });
        classNames.forEach((className)=>{
            var ref, ref1;
            return htmlRef === null || htmlRef === void 0 ? void 0 : (ref = htmlRef.current) === null || ref === void 0 ? void 0 : (ref1 = ref.classList) === null || ref1 === void 0 ? void 0 : ref1.toggle(className);
        });
        setShowSearchBar(!showSearchBar);
        const page = window.pageObj || {};
        const previousPageNameForSearch = page === null || page === void 0 ? void 0 : (ref = page.pageInfo) === null || ref === void 0 ? void 0 : ref.pageName;
        sessionStorage.setItem("previousPageNameForSearch", previousPageNameForSearch);
    };
    (0,react.useEffect)(()=>{
        if (isSaveProductToList) {
            setFavoritesPagePath("/".concat(language).concat(routes/* MY_LISTS_PAGE_PATH */.PN));
        } else {
            (0,constants_config/* getConfig */.i)().then(async (config)=>{
                const myFavPath = get_default()(config, "general.myFavoritesPagePath", "");
                setFavoritesPagePath(await (0,utils_location/* getShortenedUrl */.Pp)(myFavPath !== null && myFavPath !== void 0 ? myFavPath : "/"));
            });
        }
    }, [
        isSaveProductToList
    ]);
    (0,react.useEffect)(()=>{
        if (isAuth) {
            dispatch((0,favoritesSlice/* getFavorites */._l)()).unwrap().then((rsp)=>{
                if (rsp && rsp !== null) {
                    setFavoritesPage(rsp.lineItems);
                } else {
                    setFavoritesPage([]);
                }
            });
            if (isSaveProductToList) {
                dispatch((0,favoritesSlice/* getMyAccountListsWithLineItems */.WQ)()).unwrap().then((res)=>{
                    if (Object.keys(res[1]).length) {
                        setFavoritesPage(Object.keys(res[1]));
                    } else {
                        setFavoritesPage([]);
                    }
                });
            }
        }
    }, [
        isAuth,
        isSaveProductToList
    ]);
    (0,react.useEffect)(()=>{
        if ((favorites === null || favorites === void 0 ? void 0 : favorites.lineItems) && (favorites === null || favorites === void 0 ? void 0 : favorites.lineItems.length) > 0) {
            setFavoritesPage(favorites === null || favorites === void 0 ? void 0 : favorites.lineItems);
        } else {
            setFavoritesPage([]);
        }
    }, [
        favorites
    ]);
    (0,react.useEffect)(()=>{
        if (Object.keys(saveToListLineItems).length && isAuth) {
            setFavoritesPage(Object.keys(saveToListLineItems));
        } else {
            setFavoritesPage([]);
        }
    }, [
        Object.keys(saveToListLineItems).length
    ]);
    const onClickSignOut = ()=>{
        dispatch((0,authSlice/* logout */.kS)());
        (0,HeaderNavTabs_analytics/* dataLayerForSignOut */.Sv)();
    };
    const setPromoModal = (data)=>{
        dispatch((0,genericSlice/* showPromoModal */.Wv)(data));
    };
    (0,react.useEffect)(()=>{
        if (loginFavouriteCallback && isAuth) {
            window.loginFavouriteCallback = null;
            setLoginFavouriteCallback(null);
            window.location.href = myListsPagePath;
        }
    }, [
        loginFavouriteCallback,
        isAuth
    ]);
    const getNavMobileData = async ()=>{
        const result = await (0,api/* aemAxiosInstance */.Gb)({
            url: "".concat(constants_0.GLOBAL_CONFIGURATION_ENDPOINT, "?path=").concat(signInFragment),
            method: "GET"
        });
        const signupdata = await (0,api/* aemAxiosInstance */.Gb)({
            url: "".concat(constants_0.GLOBAL_CONFIGURATION_ENDPOINT, "?path=").concat(signUpFragment),
            method: "GET"
        });
        const loggedOutData = signupdata.data.commonTopics;
        const logIndata = result.data.commonTopics;
        setLogIndata(logIndata);
        setLogOutdata(loggedOutData);
    };
    const favClickHandler = function(e) {
        let path = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
        (0,HeaderNavTabs_analytics/* dataLayerForUtilityClicks */.ue)("favorites", false, favoritesPagePath);
        if (!isAuth) {
            window.loginFavouriteCallback = ()=>{
                setLoginFavouriteCallback(e);
            };
            if (path) setMyListsPagePath(path);
            onclicksignIN(false);
            e.stopPropagation();
            e.preventDefault();
        } else if (path && isAuth) {
            router.push(path);
        }
    };
    const { contentFragmentListConfig: { map: fragmentList = {}  } = {}  } = globalConfig;
    (0,react.useEffect)(()=>{
        if (Object.keys(fragmentList).length) getNavMobileData();
    }, [
        fragmentList
    ]);
    const [width] = (0,useWindowResize/* default */.Z)();
    const navigationProps = mapMainMenuProps(header, i18n, lineItems, firstName, isAuth, logIndata, logOutdata, onclicksignIN, onClickCreateAccount, onClickSignOut, favClickHandler, cartCount, (themeType === null || themeType === void 0 ? void 0 : themeType.includes("light")) ? "light" : "dark", handleSearchClick, !(themeType === null || themeType === void 0 ? void 0 : themeType.includes("transparent")), favoritesPage, favoritesPagePath, cartLandingPagePath, router.asPath, setPromoModal, canadaCheck, navigationHoverTiming, staticTexts.searchHeader, language, isSaveProductToList, width);
    const getStoreAnalytics = (action)=>{
        var ref;
        const href = utilityStoreDetails && utilityStoreDetails[utilityData === null || utilityData === void 0 ? void 0 : utilityData.BPnumber] ? utilityStoreDetails[utilityData === null || utilityData === void 0 ? void 0 : utilityData.BPnumber] : "/";
        const internalLinkName = action === "unset as my store" ? "unset as preferred store" : "store details";
        return JSON.stringify({
            eventAction: "find a store:utility nav:" + action,
            eventName: "find a store:utility nav:" + action,
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName,
            internalLinkPosition: "find a store",
            internalLinkType: "find a store:" + ((ref = (utilityData === null || utilityData === void 0 ? void 0 : utilityData.LocationName) + ", " + (utilityData === null || utilityData === void 0 ? void 0 : utilityData.AddressLine) + (!isEmpty_default()(utilityData === null || utilityData === void 0 ? void 0 : utilityData.AddressLine2) ? ", " + (utilityData === null || utilityData === void 0 ? void 0 : utilityData.AddressLine2) : "") + ", " + (0,helper/* formatPhoneNumber */.unW)(utilityData === null || utilityData === void 0 ? void 0 : utilityData.Phone)) === null || ref === void 0 ? void 0 : ref.toLowerCase()),
            internalLinkZoneName: "find a store:utility nav",
            internalLinkURL:  true ? action === "view store details" ? href.indexOf("http") === -1 ? window.location.origin + href : href : "n/a" : 0,
            clickInternalLinks: "true"
        });
    };
    const viewStoreAnalytics = getStoreAnalytics("view store details");
    const unsetMyStoreAnalytics = getStoreAnalytics("unset as my store");
    const storeMenu = {
        mod: "charcoal",
        eyebrow: {
            text: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    " ",
                    !isEmpty_default()(utilityData && (utilityData === null || utilityData === void 0 ? void 0 : utilityData.EntityID)) ? myStoreId !== 0 ? staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.myStore : staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.closestStore : "",
                    " "
                ]
            })
        },
        heading: {
            text: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    " ",
                    !isEmpty_default()(utilityData && (utilityData === null || utilityData === void 0 ? void 0 : utilityData.EntityID)) ? utilityData === null || utilityData === void 0 ? void 0 : utilityData.LocationName : staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.locationDescription,
                    " "
                ]
            })
        },
        subheading: {
            text: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    " ",
                    !isEmpty_default()(utilityData && (utilityData === null || utilityData === void 0 ? void 0 : utilityData.EntityID)) ? "" : staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.zipCodeContent,
                    " "
                ]
            })
        },
        storeInfo: !isEmpty_default()(utilityData && (utilityData === null || utilityData === void 0 ? void 0 : utilityData.EntityID)) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: utilityData === null || utilityData === void 0 ? void 0 : utilityData.OpenUntil
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: utilityData === null || utilityData === void 0 ? void 0 : utilityData.AddressLine
                        }),
                        !isEmpty_default()(utilityData === null || utilityData === void 0 ? void 0 : utilityData.AddressLine2) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: utilityData === null || utilityData === void 0 ? void 0 : utilityData.AddressLine2
                        }) : "",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: (utilityData === null || utilityData === void 0 ? void 0 : utilityData.Locality) + ", " + (utilityData === null || utilityData === void 0 ? void 0 : utilityData.AdminDistrict) + " " + (utilityData === null || utilityData === void 0 ? void 0 : utilityData.PostalCode)
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: (0,helper/* formatPhoneNumber */.unW)(utilityData === null || utilityData === void 0 ? void 0 : utilityData.Phone)
                }),
                myStoreUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    className: "store-a",
                    href: myStoreUrl,
                    "data-datalayer-id": "kds-element-navigation",
                    "data-datalayer-data": viewStoreAnalytics,
                    children: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.storeDetail
                })
            ]
        }) : undefined,
        setStoreCTA: {
            label: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    " ",
                    !isEmpty_default()(utilityData && (utilityData === null || utilityData === void 0 ? void 0 : utilityData.EntityID)) ? myStoreId === (utilityData === null || utilityData === void 0 ? void 0 : utilityData.EntityID) ? staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.myStore : staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.setAsMyStore : "",
                    " "
                ]
            }),
            onChange: (e)=>{
                /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                    children: [
                        " ",
                        !isEmpty_default()(utilityData && (utilityData === null || utilityData === void 0 ? void 0 : utilityData.EntityID)) ? handleUtilityStoreCheck(e.target.checked ? utilityData === null || utilityData === void 0 ? void 0 : utilityData.EntityID : 0) : "",
                        " "
                    ]
                });
            },
            checked: myStoreId === (utilityData === null || utilityData === void 0 ? void 0 : utilityData.EntityID),
            "data-datalayer-id": "kds-element-navigation",
            "data-datalayer-data": unsetMyStoreAnalytics
        },
        zipCodeInput: {
            eyebrow: {
                text: (staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.NotYourStore) + "?"
            },
            optionList: optionList,
            label: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.enterCityStateZip,
            inputValue: zipCodeValue,
            onInputChange: (e)=>{
                handleZipCodeUpdate(e.target.value);
            },
            handleSubmit: (zipCode)=>{
                redirect(zipCode);
            },
            CTA: {
                text: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.submit,
                trackingAttributes: {
                    "data-datalayer-id": "kds-element-navigation",
                    "data-datalayer-data": JSON.stringify({
                        eventAction: "find a store:utility nav:submit",
                        eventName: "find a store:utility nav:submit",
                        eventType: "navigation",
                        eventMsg: "n/a",
                        eventStatus: "success",
                        internalLinkName: "submit",
                        internalLinkPosition: "find a store",
                        internalLinkType: "find a store:".concat(zipCodeValue !== null && zipCodeValue !== void 0 ? zipCodeValue : ""),
                        internalLinkZoneName: "find a store:utility nav",
                        internalLinkURL: "n/a",
                        clickInternalLinks: "true"
                    })
                }
            }
        },
        CTAs: [
            {
                text: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.userMyLocation,
                onClick: ()=>{
                    getGeoLocation();
                },
                component: "button"
            },
            {
                text: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.viewAllStore,
                href: browseAllStoreUrl,
                trackingAttributes: {
                    "data-datalayer-id": "kds-element-navigation",
                    "data-datalayer-data": JSON.stringify({
                        eventAction: "find a store:utility nav:view all stores",
                        eventName: "find a store:utility nav:view all stores",
                        eventType: "navigation",
                        eventMsg: "n/a",
                        eventStatus: "n/a",
                        internalLinkName: "view all stores",
                        internalLinkPosition: "global header:find a store",
                        internalLinkType: "find a store:navigation",
                        internalLinkZoneName: "find a store:utility nav",
                        internalLinkURL:  true ? "".concat(window.location.origin).concat(browseAllStoreUrl) : 0,
                        clickInternalLinks: "true"
                    })
                },
                component: "a"
            }
        ]
    };
    (0,react.useEffect)(()=>{
        const observer = new MutationObserver(()=>{
            document.querySelectorAll(".kohler-main-menu-root").forEach((root)=>{
                root.querySelectorAll("button").forEach((btn)=>{
                    btn.classList.add("af-icon-button");
                });
            });
        });
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
        return ()=>observer.disconnect();
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    title ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                                children: title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "og:title",
                                content: title
                            })
                        ]
                    }) : null,
                    description ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "description",
                                content: description
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "og:description",
                                content: description
                            })
                        ]
                    }) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:type",
                        content: isPdp ? "product" : "website"
                    }),
                    siteName ? /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:site_name",
                        content: siteName
                    }) : null,
                    pageUrl ? /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:url",
                        content: pageUrl
                    }) : null,
                    imageUrl ? /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image",
                        content: imageUrl
                    }) : null,
                    email ? /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:email",
                        content: email
                    }) : null,
                    phone ? /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:phone_number",
                        content: phone
                    }) : null,
                    metas.map((meta, i)=>{
                        if (meta.name && meta.content) return /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            name: meta.name,
                            content: meta.content
                        }, "meta-".concat(i));
                    }),
                    styles.map((style, i)=>{
                        if (typeof style === "string") return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                            children: (0,jsx_runtime.jsx)((style_default()), {
                                id: style.__hash,
                                children: style
                            })
                        }, "pagestyle-".concat(i, "-").concat((0,helper/* getRandom */.sZz)()));
                    }),
                    links.map((link, i)=>{
                        if (typeof link !== "string") return /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                            rel: link.rel,
                            href: link.href
                        }, "pageLinks-".concat(i));
                    })
                ]
            }),
            pageIsInteractive && scripts.map((script, i)=>{
                if (script.src) return /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                    src: script.src,
                    type: script.type,
                    integrity: script.integrity,
                    id: "headscript-".concat(i)
                }, "headscript-".concat(i));
                if (!script.src && script.innerHTML) return /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                    id: "headscriptHtml-".concat(i),
                    children: "".concat(script.innerHTML)
                }, "headscriptHtml-".concat(i));
            }),
            headerItemsPresent ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MainMenu, {
                ...navigationProps,
                storeMenu: storeMenu
            }) : null,
            infoModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(ZipCodeInfoModal/* default */.Z, {
                handleModalClose: ()=>setInfoModal(false),
                show: infoModal,
                data: infoModalErrror,
                labelledBy: "Geo-Location-error-message",
                className: "message-modal",
                staticTexts: staticTexts,
                dataLayerPosition: "global header",
                label: staticText.continue
            }),
            showSearchBar && /*#__PURE__*/ (0,jsx_runtime.jsx)(UtilityWidgets/* default */.Z, {
                showSearchBar: showSearchBar,
                handleSearchClick: handleSearchClick,
                data: findItemByName(header, "utilitywidgets")
            })
        ]
    });
};
/* harmony default export */ var GlobalPage_GlobalPageHeader = (GlobalPageHeader);


/***/ }),

/***/ 59187:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ GLOBAL_HEADER_TEXT; },
/* harmony export */   "Pv": function() { return /* binding */ GLOBAL_NAVIGATION; },
/* harmony export */   "WC": function() { return /* binding */ MEGA_MENU; },
/* harmony export */   "zl": function() { return /* binding */ MAIN_MENU; }
/* harmony export */ });
const GLOBAL_HEADER_TEXT = "global header";
const MAIN_MENU = "main dropdown menu";
const MEGA_MENU = "mega menu navigation";
const GLOBAL_NAVIGATION = "global navigation";


/***/ }),

/***/ 24897:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Jm": function() { return /* binding */ onclickForSignedFun; },
/* harmony export */   "Lz": function() { return /* binding */ newdataLayerForCreateAccount; },
/* harmony export */   "Ps": function() { return /* binding */ backClickForMobile; },
/* harmony export */   "Sv": function() { return /* binding */ dataLayerForSignOut; },
/* harmony export */   "UY": function() { return /* binding */ newdatalayerforSignIn; },
/* harmony export */   "bL": function() { return /* binding */ l1DatalayerclickMobile; },
/* harmony export */   "hJ": function() { return /* binding */ addAnalyticsOnClose; },
/* harmony export */   "ue": function() { return /* binding */ dataLayerForUtilityClicks; },
/* harmony export */   "w_": function() { return /* binding */ hamburgerMenuDatalayer; },
/* harmony export */   "yp": function() { return /* binding */ servicesAnalyticsClick; },
/* harmony export */   "zw": function() { return /* binding */ closeButtonDatalayer; }
/* harmony export */ });
/* harmony import */ var _constants_regex__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49139);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55760);
/* harmony import */ var _components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59187);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96301);




const addAnalyticsOnClose = ()=>{
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "main dropdown menu:products:close",
        eventMsg: "n/a",
        eventName: "main dropdown menu:products:close",
        eventStatus: "n/a",
        eventType: "navigation",
        internalLinkName: "products > close",
        internalLinkPosition: "global header:products",
        internalLinkType: "global header:navigation",
        internalLinkURL: "".concat(window.origin).concat(location.pathname),
        internalLinkZoneName: "main dropdown menu:products"
    };
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    window.adobeDataLayer.push({
        event: "cmp:click",
        page,
        eventInfo
    });
};
const servicesAnalyticsClick = (data)=>{
    var ref;
    const { text ="" , link ="" , Leveltwo ="" , L1 ="" , imgcheck =""  } = data;
    const textcont = text ? (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .makingTextDatalayerReady */ .S$e)(text) : "";
    const l2DatalayerReady = Leveltwo ? (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .makingTextDatalayerReady */ .S$e)(Leveltwo) : "";
    const l1DatalayerReady = L1 ? (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .makingTextDatalayerReady */ .S$e)(L1) : "";
    const url = link ? "".concat(link.indexOf("http") === -1 ? window.location.origin : "").concat((0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .removeAndCleanLink */ .xEh)(link)) : "n/a";
    let internallink;
    if (L1) {
        internallink = "".concat(l1DatalayerReady, " > ").concat(l2DatalayerReady, " > ").concat(imgcheck ? "img_".concat(textcont) : textcont);
    } else if (imgcheck) {
        internallink = "".concat(l2DatalayerReady, " > img_").concat(textcont);
    } else {
        internallink = "".concat(l2DatalayerReady, " > ").concat(textcont);
    }
    const eventInfo = {
        clickInternalLinks: (url === null || url === void 0 ? void 0 : url.startsWith("/")) || (url === null || url === void 0 ? void 0 : url.includes(window.location.hostname)) || url === null ? "true" : "false",
        eventAction: _components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .MAIN_MENU */ .zl,
        eventName: _components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .MAIN_MENU */ .zl,
        eventType: _components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A,
        internalLinkName: (ref = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .getPureText */ .OM7)(internallink)) === null || ref === void 0 ? void 0 : ref.replace(_constants_regex__WEBPACK_IMPORTED_MODULE_3__/* .PURE_DATA_FOR_STRING_REGEX */ .YN, ""),
        internalLinkPosition: _components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A,
        internalLinkType: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A, ":navigation"),
        internalLinkURL: url,
        internalLinkZoneName: _components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A
    };
    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .pushAnalyticsObjToDataLayer */ .zYT)(eventInfo, "cmp:click");
};
const l1DatalayerclickMobile = function() {
    let L1Name = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    var ref;
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const pageNameDatalayer = page === null || page === void 0 ? void 0 : (ref = page.pageInfo) === null || ref === void 0 ? void 0 : ref.pageName;
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: _components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .MAIN_MENU */ .zl,
        eventName: _components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .MAIN_MENU */ .zl,
        eventType: _components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_NAVIGATION */ .Pv,
        internalLinkName: L1Name === null || L1Name === void 0 ? void 0 : L1Name.toLowerCase(),
        internalLinkPosition: _components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A,
        internalLinkType: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A, ":").concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .MEGA_MENU */ .WC),
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(pageNameDatalayer, ":").concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A)
    };
    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .pushAnalyticsObjToDataLayer */ .zYT)(eventInfo, "cmp:click");
};
const backClickForMobile = function() {
    let L1Name = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A, ":back"),
        eventName: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A, ":back"),
        eventType: "navigation",
        internalLinkName: "".concat(L1Name.toLowerCase(), " > back"),
        internalLinkPosition: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A, ":").concat(L1Name.toLowerCase()),
        internalLinkType: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A, ":").concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .MEGA_MENU */ .WC),
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .MAIN_MENU */ .zl, ":").concat(L1Name.toLowerCase())
    };
    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .pushAnalyticsObjToDataLayer */ .zYT)(eventInfo, "cmp:click");
};
const closeButtonDatalayer = function() {
    let data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "products";
    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .addMavenoidChat */ .dVG)();
    data = data ? data : "products";
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .MAIN_MENU */ .zl, ":").concat(data.toLowerCase(), ":close"),
        eventName: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .MAIN_MENU */ .zl, ":").concat(data.toLowerCase(), ":close"),
        eventType: "navigation",
        internalLinkName: "".concat(data.toLowerCase(), " > close"),
        internalLinkPosition: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A, ":products"),
        internalLinkType: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A, ":").concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .MEGA_MENU */ .WC),
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .MAIN_MENU */ .zl, ":products")
    };
    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .pushAnalyticsObjToDataLayer */ .zYT)(eventInfo, "cmp:click");
};
const hamburgerMenuDatalayer = ()=>{
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "hamburger menu open",
        eventName: "hamburger menu open",
        eventType: _components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_NAVIGATION */ .Pv,
        internalLinkName: "hamburger menu open",
        internalLinkPosition: _components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A,
        internalLinkType: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A, ":open"),
        internalLinkURL: "n/a",
        internalLinkZoneName: _components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A
    };
    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .pushAnalyticsObjToDataLayer */ .zYT)(eventInfo, "cmp:click");
};
const newdatalayerforSignIn = function() {
    let themeChange = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    if (themeChange) {
        const eventInfo = {
            clickInternalLinks: "true",
            eventAction: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A, ":sign in start"),
            eventName: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A, ":sign in start"),
            eventType: "navigation",
            internalLinkName: "sign in start",
            internalLinkPosition: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A, ":sign in start"),
            internalLinkType: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A, ":").concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .MEGA_MENU */ .WC),
            internalLinkURL: "n/a",
            internalLinkZoneName: _components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A
        };
        (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .pushAnalyticsObjToDataLayer */ .zYT)(eventInfo, "cmp:click");
    } else {
        const eventInfo1 = {
            eventName: "my account:sign in",
            eventAction: "my account:sign in",
            internalLinkName: "sign in interaction",
            internalLinkType: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A, ":navigation"),
            internalLinkZoneName: _components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A,
            clickInternalLinks: "true",
            eventType: _components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A,
            internalLinkURL: "n/a",
            internalLinkPosition: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A, ":sign in"),
            eventMsg: "n/a",
            eventStatus: "n/a"
        };
        (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .pushAnalyticsObjToDataLayer */ .zYT)(eventInfo1, "cmp:click");
    }
};
const newdataLayerForCreateAccount = function() {
    let themeChange = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    if (themeChange) {
        const eventInfo = {
            clickInternalLinks: "true",
            eventAction: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A, ":create account"),
            eventName: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A, ":create account"),
            eventType: "navigation",
            internalLinkName: "create account",
            internalLinkPosition: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A, ":create account"),
            internalLinkType: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A, ":").concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .MEGA_MENU */ .WC),
            internalLinkURL: "n/a",
            internalLinkZoneName: _components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A
        };
        (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .pushAnalyticsObjToDataLayer */ .zYT)(eventInfo, "cmp:click");
    } else {
        const eventInfo1 = {
            eventName: "".concat(_constants_index__WEBPACK_IMPORTED_MODULE_1__.MY_ACCOUNT_MODAL, ":").concat(_constants_index__WEBPACK_IMPORTED_MODULE_1__.CREATE_ACCOUNT),
            eventAction: "".concat(_constants_index__WEBPACK_IMPORTED_MODULE_1__.MY_ACCOUNT_MODAL, ":").concat(_constants_index__WEBPACK_IMPORTED_MODULE_1__.CREATE_ACCOUNT),
            internalLinkName: _constants_index__WEBPACK_IMPORTED_MODULE_1__.CREATE_ACCOUNT,
            internalLinkType: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A, ":navigation"),
            internalLinkZoneName: _components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A,
            clickInternalLinks: "true",
            eventType: _components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A,
            internalLinkURL: "n/a",
            internalLinkPosition: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A, ":").concat(_constants_index__WEBPACK_IMPORTED_MODULE_1__.CREATE_ACCOUNT),
            eventMsg: "n/a",
            eventStatus: "n/a"
        };
        (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .pushAnalyticsObjToDataLayer */ .zYT)(eventInfo1, "cmp:click");
    }
};
const onclickForSignedFun = function() {
    let themeChange = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    if (themeChange) {
        const eventInfo = {
            clickInternalLinks: "true",
            eventAction: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A, ":your kohler account"),
            eventName: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A, ":your kohler account"),
            eventType: "navigation",
            internalLinkName: "your kohler account",
            internalLinkPosition: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A, ":my account"),
            internalLinkType: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A, ":").concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .MEGA_MENU */ .WC),
            internalLinkURL: "n/a",
            internalLinkZoneName: _components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A
        };
        (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .pushAnalyticsObjToDataLayer */ .zYT)(eventInfo, "cmp:click");
    }
};
const dataLayerForUtilityClicks = function() {
    let title = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", themeChange = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, url = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
    var ref;
    const dataLayerTitle = title === null || title === void 0 ? void 0 : title.toLowerCase();
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const pageNameDatalayer = page === null || page === void 0 ? void 0 : (ref = page.pageInfo) === null || ref === void 0 ? void 0 : ref.pageName;
    if (themeChange) {
        const eventInfo = {
            clickInternalLinks: "true",
            eventAction: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A, ":").concat(dataLayerTitle),
            eventName: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A, ":").concat(dataLayerTitle),
            eventType: "navigation",
            internalLinkName: "".concat(dataLayerTitle),
            internalLinkPosition: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A, ":").concat(dataLayerTitle),
            internalLinkType: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A, ":").concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .MEGA_MENU */ .WC),
            internalLinkURL: url ? "".concat(url.indexOf("http") === -1 ? window.location.origin : "").concat((0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .removeAndCleanLink */ .xEh)(url)) : "n/a",
            internalLinkZoneName: _components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A
        };
        (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .pushAnalyticsObjToDataLayer */ .zYT)(eventInfo, "cmp:click");
    } else if (dataLayerTitle === "find a store") {
        const eventInfo1 = {
            eventAction: dataLayerTitle,
            eventName: dataLayerTitle,
            eventType: dataLayerTitle,
            internalLinkName: dataLayerTitle,
            internalLinkPosition: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A, ":").concat(dataLayerTitle),
            internalLinkType: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A, ":navigation"),
            internalLinkZoneName: "".concat(pageNameDatalayer).concat(pageNameDatalayer ? ":" : "").concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A),
            internalLinkURL: "n/a",
            clickInternalLinks: "true"
        };
        (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .pushAnalyticsObjToDataLayer */ .zYT)(eventInfo1, "cmp:click");
    } else {
        dataLayerTitle === "favorites";
        const eventInfo2 = {
            eventName: "wishlist icon",
            eventAction: "wishlist icon",
            internalLinkName: "wishlist",
            internalLinkType: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A, ":navigation"),
            internalLinkZoneName: _components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A,
            clickInternalLinks: "true",
            eventType: _components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A,
            internalLinkURL: url ? "".concat(url.indexOf("http") === -1 ? window.location.origin : "").concat((0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .removeAndCleanLink */ .xEh)(url)) : "n/a",
            internalLinkPosition: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A, " wishlist"),
            eventMsg: "n/a",
            eventStatus: "n/a"
        };
        (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .pushAnalyticsObjToDataLayer */ .zYT)(eventInfo2, "cmp:click");
    }
};
const dataLayerForSignOut = ()=>{
    const eventInfo = {
        eventName: "my account:sign out",
        eventAction: "my account:sign out",
        internalLinkName: "sign out",
        internalLinkType: "global header:navigation",
        internalLinkZoneName: "global header",
        clickInternalLinks: "true",
        eventType: "navigation",
        internalLinkURL: window.location.origin + "/en",
        internalLinkPosition: "global header sign out",
        eventMsg: "n/a",
        eventStatus: "n/a"
    };
    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .pushAnalyticsObjToDataLayer */ .zYT)(eventInfo, "cmp:click");
};


/***/ }),

/***/ 68446:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$r": function() { return /* binding */ pureText; },
/* harmony export */   "JI": function() { return /* binding */ checkSingleNonEmptyLevelThreeNavMulti; },
/* harmony export */   "L9": function() { return /* binding */ modifyHref; },
/* harmony export */   "TX": function() { return /* binding */ pureTextWithoutSpace; },
/* harmony export */   "dV": function() { return /* binding */ closestAnchorHref; }
/* harmony export */ });
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96301);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55760);


const checkSingleNonEmptyLevelThreeNavMulti = (data)=>{
    let nonEmptyLevelThreeNavMultiIndex = -1;
    let nonEmptyLevelThreeNavMultiCount = 0;
    for(let i = 0; i < data.length; i++){
        for (const levelTwoNavMulti of data[i].levelTwoNavMulti){
            if (levelTwoNavMulti.levelThreeNavMulti.length >= 1) {
                nonEmptyLevelThreeNavMultiCount++;
                if (nonEmptyLevelThreeNavMultiCount > 1) {
                    return -1 // More than one non-empty levelThreeNavMulti found
                    ;
                } else {
                    nonEmptyLevelThreeNavMultiIndex = i;
                }
            }
        }
    }
    return nonEmptyLevelThreeNavMultiIndex;
};
const modifyHref = (link)=>{
    return link === null || link === void 0 ? void 0 : link.split(_constants_index__WEBPACK_IMPORTED_MODULE_0__.previewContentPrefix).join("").replace(".html", "");
};
const closestAnchorHref = (e)=>{
    return !e.target.closest("a").getAttribute("href");
};
const pureText = (text)=>{
    var ref;
    return (ref = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_1__/* .getPureText */ .OM7)(text)) === null || ref === void 0 ? void 0 : ref.trim();
};
const pureTextWithoutSpace = (text)=>{
    const pureTextTitle = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_1__/* .getPureText */ .OM7)(text).trim().toLowerCase();
    return pureTextTitle.split(" ").join("-").replace("&amp;-", "").replace("&-", "");
};


/***/ }),

/***/ 70914:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _public_images_image_missing_png__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36513);




const ImageWrapper = (props)=>{
    const { src =_public_images_image_missing_png__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z , alt ="" , ...restProps } = props || {};
    const [isError, setIsError] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        if (isError) setIsError(false);
    }, [
        src
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
        ...restProps,
        blurDataURL: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTc1IiBoZWlnaHQ9IjIyOSIgdmlld0JveD0iMCAwIDE3NSAyMjkiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSIxNzUiIGhlaWdodD0iMjI5IiByeD0iMTYiIGZpbGw9IiM4MDgwODAiIGZpbGwtb3BhY2l0eT0iMC41NSIvPgo8L3N2Zz4K",
        src: isError ? _public_images_image_missing_png__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z : src,
        onError: ()=>setIsError(true),
        alt: alt
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ImageWrapper);


/***/ }),

/***/ 13678:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19514);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24400);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(55760);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(41609);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _components_Shared_ProductSocialShare_v1_socialShare_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(76118);
/* harmony import */ var _components_Shared_ProductSocialShare_v1_socialShare_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_components_Shared_ProductSocialShare_v1_socialShare_module_scss__WEBPACK_IMPORTED_MODULE_7__);








const ProductSocialShare = (props)=>{
    const { id ="" , url ="" , componentProp: { assetUrl ="" , url: compUrl = "" , showModal: componentPropShowModal = false  } = {} , disableInstagram =false , showModal =false , onClose =()=>{} , mailBody ="" , mailSubject ="" , isBundleProduct ="" , productInfoParam ={}  } = props;
    const [sites, setSites] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const { t  } = (0,next_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)();
    const origin = window.location.origin;
    const emailBtnRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const copyBtnRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const shareBoxRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const socialShareCopyIconPath = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)("");
    const socialShareEmailIconPath = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)("");
    const [config, setConfig] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({});
    const brandName = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)("");
    const { general ={} , socialMediaConfig: socialMediaConfigs = {}  } = config;
    const { hostUrl =""  } = general;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        (0,_constants_config__WEBPACK_IMPORTED_MODULE_2__/* .getConfig */ .i)().then(async (configData)=>{
            setConfig(configData);
            brandName.current = lodash_get__WEBPACK_IMPORTED_MODULE_5___default()(configData, "general.siteName", "");
            socialShareCopyIconPath.current = lodash_get__WEBPACK_IMPORTED_MODULE_5___default()(configData, "general.socialShareCopyIconPath", "");
            socialShareEmailIconPath.current = lodash_get__WEBPACK_IMPORTED_MODULE_5___default()(configData, "general.socialShareEmailIconPath", "");
        });
    }, []);
    // get component social share link url
    /**
   *
   * @return  {string} the the url
   */ const getLink = ()=>{
        const isFullUrl = /^https?:\/\//i;
        if (url && isFullUrl.test(url)) {
            return url;
        }
        if (url) {
            return "".concat(origin).concat(url);
        } else if (assetUrl && compUrl) {
            // teaser video component link all cases
            if (!isFullUrl.test(compUrl)) {
                const newcompUrl = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_4__/* .getShortenedUrlwithGeneral */ .vu1)(compUrl, general);
                return "".concat(origin).concat(newcompUrl);
            } else {
                return compUrl;
            }
        } else if (assetUrl) {
            return assetUrl;
        } else {
            return (0,_utils_helper__WEBPACK_IMPORTED_MODULE_4__/* .sanitizeUrl */ .Nmg)(window.location.href);
        }
    };
    const link = getLink();
    const brandNameCurrent = brandName.current;
    const i18n = {
        email: t("kf.share.label.email"),
        emailSubject: t("kf.share.label.emailSubject"),
        copyLink: t("kf.share.label.copyLink"),
        copyLinkIndication: t("kf.share.label.copyLinkIndication"),
        yourSharedCartNumber: t("kf.share.label.yourSharedCartNumber", {
            cartNumber: props.sharedCartNum
        }),
        linksCTA: (siteKey)=>t("kf.pdp.label.aria.socialLinksCTA", {
                brandNameCurrent,
                siteKey
            }),
        openNewTabText: t("kf.share.label.openNewTabText")
    };
    const [copyIcon, setCopyIcon] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (socialMediaConfigs.myArrayList) {
            let siteList = [];
            socialMediaConfigs === null || socialMediaConfigs === void 0 ? void 0 : socialMediaConfigs.myArrayList.forEach((socialMediaConfig)=>{
                if (!lodash_isEmpty__WEBPACK_IMPORTED_MODULE_6___default()(socialMediaConfig.map) && socialMediaConfig.map.name) {
                    var _name, _iconPath;
                    const site = {
                        key: (_name = socialMediaConfig.map.name) !== null && _name !== void 0 ? _name : "",
                        icon: (_iconPath = socialMediaConfig.map.iconPath) !== null && _iconPath !== void 0 ? _iconPath : ""
                    };
                    var _redirectUrl;
                    const url = (_redirectUrl = socialMediaConfig.map.redirectUrl) !== null && _redirectUrl !== void 0 ? _redirectUrl : "";
                    if (socialMediaConfig.map.name.toLowerCase().includes("twitter")) {
                        siteList.push({
                            ...site,
                            url: encodeURI(url + link + "&text=".concat(document.title))
                        });
                    } else if (socialMediaConfig.map.name.toLowerCase().includes("pinterest")) {
                        if (props.asset) siteList.push({
                            ...site,
                            url: url + "".concat(origin, "&media=").concat(props.asset.url, "&is_video=").concat(props.asset.isVideo, "$description=").concat(props.asset.description)
                        });
                    } else {
                        siteList.push({
                            ...site,
                            url: url + link
                        });
                    }
                }
            });
            if (disableInstagram && siteList.length) {
                siteList = siteList.filter((site)=>!site.key.toLowerCase().includes("instagram"));
            }
            setSites(siteList);
        }
    }, [
        socialMediaConfigs
    ]);
    const emailLink = (e)=>{
        e.stopPropagation();
        addDataLayer("email a friend", "n/a");
    };
    /**
   *
   * @param {string} e
   */ function socialLinks(e) {
        if (e.target && e.target.hostname && e.target.href) {
            const target = e.target;
            const nodeUrl = target.hostname.replace(/(^www\.)/, "");
            if (!window.excludUrl || window.excludUrl && !window.excludUrl.includes(nodeUrl)) {
                e.stopPropagation();
                e.preventDefault();
                if (window.handleShowModal) window.handleShowModal(target.href, target);
            } else if (target.href) {
                window.open(target.href);
            }
            const key = target.siteKey || nodeUrl || target.hostname;
            try {
                addDataLayer(key.split(".com")[0], target.href);
            // eslint-disable-next-line no-empty
            } catch (ee) {}
        }
    }
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        var ref, ref1, ref2;
        copyBtnRef === null || copyBtnRef === void 0 ? void 0 : (ref = copyBtnRef.current) === null || ref === void 0 ? void 0 : ref.addEventListener("click", copyLink, false);
        shareBoxRef === null || shareBoxRef === void 0 ? void 0 : (ref1 = shareBoxRef.current) === null || ref1 === void 0 ? void 0 : ref1.addEventListener("click", shareBox, false);
        emailBtnRef === null || emailBtnRef === void 0 ? void 0 : (ref2 = emailBtnRef.current) === null || ref2 === void 0 ? void 0 : ref2.addEventListener("click", emailLink, false);
        if (shareBoxRef === null || shareBoxRef === void 0 ? void 0 : shareBoxRef.current) {
            var ref3;
            (ref3 = Array.from(shareBoxRef.current.getElementsByClassName("kf-social-links"))) === null || ref3 === void 0 ? void 0 : ref3.forEach((link)=>{
                link === null || link === void 0 ? void 0 : link.addEventListener("click", socialLinks, false);
            });
        }
        return ()=>{
            var // garbage collection
            ref, ref1, ref2;
            copyBtnRef === null || copyBtnRef === void 0 ? void 0 : (ref = copyBtnRef.current) === null || ref === void 0 ? void 0 : ref.removeEventListener("click", copyLink, false);
            shareBoxRef === null || shareBoxRef === void 0 ? void 0 : (ref1 = shareBoxRef.current) === null || ref1 === void 0 ? void 0 : ref1.removeEventListener("click", shareBox, false);
            emailBtnRef === null || emailBtnRef === void 0 ? void 0 : (ref2 = emailBtnRef.current) === null || ref2 === void 0 ? void 0 : ref2.removeEventListener("click", emailLink, false);
            if (shareBoxRef === null || shareBoxRef === void 0 ? void 0 : shareBoxRef.current) {
                var ref3;
                (ref3 = Array.from(shareBoxRef.current.getElementsByClassName("kf-social-links"))) === null || ref3 === void 0 ? void 0 : ref3.forEach((link)=>{
                    link === null || link === void 0 ? void 0 : link.removeEventListener("click", socialLinks, false);
                });
            }
        };
    }, [
        sites,
        props.showModal
    ]);
    const { internallinkposition , internallinktype , internallinkzonename  } = props.componentProp || {};
    const analyticData = props.analyticData || {
        internalLinkPosition: internallinkposition || "n/a",
        internalLinkType: internallinktype || "n/a",
        internalLinkZoneName: internallinkzonename || "n/a"
    };
    const shareRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const handleClick = (e)=>{
        var ref;
        const selELement = props.iframeId ? document.getElementById(props.iframeId).contentDocument.getElementById(props.id) : document.getElementById(props.id);
        if (props.showModal && !(selELement === null || selELement === void 0 ? void 0 : selELement.contains(e.target))) props.onClose();
        if (((ref = props.componentProp) === null || ref === void 0 ? void 0 : ref.showModal) && window.shareSrcElement !== null && window.shareSrcElement !== undefined && !shareRef.current.contains(e.target)) {
            const shareElems = [
                ...document.getElementsByClassName("share-cmp")
            ];
            shareElems.forEach((el)=>{
                el.style.display = "none";
            });
            window.shareSrcElement = null;
        }
        return true;
    };
    const handleClose = (e)=>{
        if (e.keyCode === 27) {
            props.onClose();
            props.shareBtn.current.focus();
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        var ref;
        const selELement = props.iframeId ? document.getElementById(props.iframeId).contentDocument : document;
        if (props.showModal) {
            selELement.addEventListener("click", handleClick);
            selELement.addEventListener("keydown", handleClose);
            return ()=>{
                selELement.removeEventListener("click", handleClick);
                selELement.removeEventListener("keydown", handleClose);
            };
        }
        if (((ref = props.componentProp) === null || ref === void 0 ? void 0 : ref.showModal) && props.showModal) {
            document.addEventListener("click", handleClick);
        }
    }, [
        props.showModal
    ]);
    const copyLink = (e)=>{
        e.stopPropagation();
        e.preventDefault();
        navigator.clipboard.writeText(link);
        setCopyIcon(true);
        setTimeout(()=>{
            setCopyIcon(false);
        }, 3000);
        addDataLayer("copy link", link !== null && link !== void 0 ? link : "n/a");
    };
    const shareBox = (e)=>{
        e.stopPropagation();
        e.preventDefault();
    };
    const addDataLayer = (siteKey, link)=>{
        const { eventAction ="n/a" , eventName ="n/a" , eventType ="informative" , eventMsg ="n/a" , eventStatus ="n/a" , internalLinkPosition ="n/a" , internalLinkType ="n/a" , internalLinkZoneName ="n/a" , internalLinkURL , custom  } = analyticData;
        let eventInfo = {
            eventAction,
            eventName,
            eventType,
            eventMsg,
            eventStatus,
            internalLinkName: siteKey,
            internalLinkPosition,
            internalLinkType,
            internalLinkZoneName,
            internalLinkURL: link || internalLinkURL || "n/a",
            clickInternalLinks: siteKey === "copy link" || siteKey === "email a friend" ? "true" : "false"
        };
        const page = window.pageObj || {};
        const { pageInfo: { contentType  } , productInfo  } = page;
        const isPdp = contentType === "pdp";
        if (isPdp) {
            eventInfo = {
                eventAction: "pdp:product details:share",
                eventName: "pdp:product details:share",
                eventType: "informative",
                eventMsg: "n/a",
                eventStatus: "n/a",
                internalLinkName: siteKey,
                internalLinkPosition: "pdp".concat(isBundleProduct ? ":bundle" : ""),
                internalLinkType: "pdp:".concat(internalLinkType.split(":")[1] || ""),
                internalLinkZoneName: "pdp:".concat(internalLinkZoneName.split(":")[1] || ""),
                internalLinkURL: link || internalLinkURL || "n/a",
                clickInternalLinks: "true"
            };
        }
        if (window.dataLayerEventType && !isPdp) {
            eventInfo.internalLinkType = window.dataLayerEventType;
        }
        if (window.dataLayerEventZoneName && !isPdp) {
            eventInfo.internalLinkZoneName = window.dataLayerEventZoneName;
            if (eventAction === "n/a") {
                eventInfo.eventAction = window.dataLayerEventZoneName + ":share";
                eventInfo.eventName = window.dataLayerEventZoneName + ":share";
            }
        }
        const dataLayerObj = {
            event: "cmp:click",
            eventInfo,
            page
        };
        if (isPdp) {
            dataLayerObj["productInfo"] = productInfo;
        }
        let customProductInfo;
        if (custom) {
            try {
                customProductInfo = JSON.parse(custom).productInfo;
                dataLayerObj["productInfo"] = customProductInfo;
            } catch (e) {
                console.error(e);
            }
        }
        if (dataLayerObj["productInfo"] === undefined) {
            dataLayerObj["productInfo"] = productInfoParam;
        }
        window.adobeDataLayer.push(dataLayerObj);
    };
    const { linksCTA =()=>{} , openNewTabText ="" , copyLinkIndication ="" , copyLink: staticTextcopyLink = "" , email =""  } = i18n;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_components_Shared_ProductSocialShare_v1_socialShare_module_scss__WEBPACK_IMPORTED_MODULE_7___default().socialShareWrapper),
        children: (showModal !== null && showModal !== void 0 ? showModal : componentPropShowModal) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "social-share",
            id: id,
            ref: shareRef,
            "data-testid": id,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "social-share__box",
                ref: shareBoxRef,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "social-share__sites",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                            role: "list",
                            children: sites.map((param, i)=>{
                                let { url ="" , key ="" , icon =""  } = param;
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                    role: "listitem",
                                    className: "social-share-list",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                        id: "kf-social-links-".concat(i),
                                        rel: "noreferrer",
                                        href: url,
                                        className: "kf-social-links social-share-link",
                                        "aria-label": "".concat(linksCTA(key), " ").concat(openNewTabText),
                                        target: "_blank",
                                        "data-link-type": "social media",
                                        role: "link",
                                        tabIndex: "0",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                            "aria-hidden": "true",
                                            src: "".concat(hostUrl).concat(icon),
                                            alt: key,
                                            className: "social-share__".concat(key),
                                            role: "presentation"
                                        })
                                    })
                                }, i);
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "social-share__actions",
                        role: "list",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                role: "listitem",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    tabIndex: "0",
                                    role: "button",
                                    ref: copyBtnRef,
                                    className: "social-share__cta",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                            className: "social-share__copy-link-icon",
                                            "aria-hidden": true,
                                            src: "".concat(hostUrl).concat(socialShareCopyIconPath.current),
                                            role: "presentation",
                                            alt: ""
                                        }),
                                        copyIcon ? copyLinkIndication : staticTextcopyLink
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                role: "listitem",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                    className: "social-share__cta social-share__email",
                                    "aria-label": "".concat(email, " ").concat(openNewTabText),
                                    onKeyDown: ()=>onClose(),
                                    ref: emailBtnRef,
                                    href: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_4__/* .sanitizeUrl */ .Nmg)("mailto:?body=".concat(mailBody + link).concat(mailSubject ? "&subject=" + mailSubject : "")),
                                    target: "_blank",
                                    rel: "noreferrer",
                                    role: "link",
                                    tabIndex: "0",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                            src: "".concat(hostUrl).concat(socialShareEmailIconPath.current),
                                            role: "presentation",
                                            alt: ""
                                        }),
                                        email
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        }) : null
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ProductSocialShare);


/***/ }),

/***/ 78592:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A4": function() { return /* binding */ quickViewCarouselImageClickAnalytics; },
/* harmony export */   "Av": function() { return /* binding */ quickViewDimensionsAnalytics; },
/* harmony export */   "E$": function() { return /* binding */ quickViewOpenAnalytics; },
/* harmony export */   "I4": function() { return /* binding */ quickViewCloseAnalytics; },
/* harmony export */   "Qe": function() { return /* binding */ quickViewPrevNextCarouselButtonClickAnalytics; },
/* harmony export */   "Ry": function() { return /* binding */ quickViewAddToCartAnalytics; },
/* harmony export */   "SD": function() { return /* binding */ quickViewReviewClickAnalytics; },
/* harmony export */   "_H": function() { return /* binding */ quickViewNotifyMeClickAnalytics; },
/* harmony export */   "cP": function() { return /* binding */ quickViewVaraintClickAnalytics; },
/* harmony export */   "jr": function() { return /* binding */ viewFullDetailsAnalytics; },
/* harmony export */   "qq": function() { return /* binding */ quickViewListPriceAnalytics; },
/* harmony export */   "um": function() { return /* binding */ quickViewDownloadClickAnalytics; }
/* harmony export */ });
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55760);
/* harmony import */ var _components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20443);


const getProductInfo = (data)=>{
    const { brandName , productName , productDesc , skuID , category , pdpType , productPrice , discountedPrice , productImageUrl  } = data;
    const productInfo = {
        category: category,
        description: productDesc,
        frequency: "n/a",
        globalPromotionPrice: discountedPrice > 0 ? Number((discountedPrice - 0).toFixed(2)) : productPrice,
        globalOffer: "n/a",
        globalDiscount: Number(discountedPrice.toFixed(2)),
        isRecommended: "n/a",
        isSendNow: "n/a",
        isSubscription: "n/a",
        priceState: discountedPrice ? "discounted price" : "regular price",
        productBasePrice: Number(productPrice),
        productCategory: category,
        productColor: "default",
        productCoupondiscount: "n/a",
        productCouponCode: "n/a",
        productID: skuID,
        productName: productName || productDesc || category || "n/a",
        productPartnerBuyNow: "n/a",
        productRoom: "product",
        productSalePrice: discountedPrice > 0 ? Number((discountedPrice - 0).toFixed(2)) : productPrice,
        productSaleable: true,
        productStatus: "in stock",
        productSuperSku: false,
        productTileName: productName,
        quantity: 1,
        defaultImageName: productImageUrl || "n/a",
        ratings: "n/a",
        numberOfReviews: "n/a",
        pdpType: pdpType || "regular finished goods & service parts",
        productFindingMethod: "n/a",
        productCollectionsName: productName,
        productBrand: brandName,
        itemType: "product",
        waterSenseProduct: false
    };
    return productInfo;
};
const getEventInfo = function() {
    let upshellmodal = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const pageTypeObj = page.category;
    let pageTypeText = "";
    let pageName = "";
    let recommTitle = "";
    let upshellTitle = "";
    if ((pageTypeObj === null || pageTypeObj === void 0 ? void 0 : pageTypeObj.subCategoryID) === "cart") {
        pageName = "cart";
        pageTypeText = upshellmodal ? "cart preview" : pageName;
        recommTitle = upshellmodal !== true ? ":recommended additions" : "";
        upshellTitle = upshellmodal ? ":our best sellers" : ":recommended additions";
    }
    if ((pageTypeObj === null || pageTypeObj === void 0 ? void 0 : pageTypeObj.pageType) === "pdp") {
        pageName = "pdp";
        pageTypeText = "pdp";
        recommTitle = ":we recommend";
        upshellTitle = ":we recommend";
    }
    return {
        pageTypeText,
        pageName,
        recommTitle,
        upshellTitle
    };
};
const quickViewOpenAnalytics = (data)=>{
    const { productData , productUrl ="" , productImageUrl ="" , upshellmodal =false , recommendationSource ="n/a"  } = data;
    const persona = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .getUserPersona */ .shu)();
    const { CustomerFacingBrand_s: brandName = "" , sku_s: skuID = "" , ProductBrandName_s: productName = "" , ProductDescriptionProductShort_s: productDesc = "" , Product_Category: category = "" , ["priceList.".concat(persona, ".price_d")]: productPrice = 0 , ["priceList.".concat(persona, ".discountedPrice_d")]: discountedPrice = 0  } = productData;
    const productInfo = getProductInfo({
        brandName,
        productName,
        productDesc,
        skuID,
        category,
        productPrice,
        discountedPrice,
        productImageUrl,
        productUrl
    });
    const { pageTypeText , pageName , recommTitle , upshellTitle  } = getEventInfo(upshellmodal);
    const eventInfo = {
        clickInternalLinks: "true",
        curatedRecommendation: recommendationSource,
        eventAction: "".concat(pageTypeText, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .UPSELL_PRODUCT */ .Ey).concat(recommTitle, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW */ .iR),
        eventMsg: "n/a",
        eventName: "".concat(pageTypeText, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .UPSELL_PRODUCT */ .Ey).concat(recommTitle, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW */ .iR),
        eventStatus: "n/a",
        eventType: "navigation",
        internalLinkName: _components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW */ .iR,
        internalLinkPosition: "".concat(pageTypeText, ":upsell"),
        internalLinkType: "".concat(pageName, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW */ .iR),
        internalLinkURL: productUrl || "n/a",
        internalLinkZoneName: "".concat(pageTypeText).concat(upshellTitle, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW */ .iR),
        modalName: _components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0
    };
    pushAnalyticsObjToDataLayer(eventInfo, productInfo);
};
const quickViewCloseAnalytics = (data)=>{
    const { productInfo ={} , upshellmodal =false , recommendationSource ="n/a" , productUrl =""  } = data;
    const { pageTypeText , pageName , upshellTitle  } = getEventInfo(upshellmodal);
    const eventInfo = {
        clickInternalLinks: "true",
        curatedRecommendation: recommendationSource,
        eventAction: "".concat(pageTypeText, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .UPSELL_PRODUCT */ .Ey, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .CLOSE */ .F$),
        eventMsg: "n/a",
        eventName: "".concat(pageTypeText, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .UPSELL_PRODUCT */ .Ey, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .CLOSE */ .F$),
        eventStatus: "n/a",
        eventType: "navigation",
        internalLinkName: _components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .CLOSE */ .F$,
        internalLinkPosition: "".concat(pageTypeText, ":upsell:").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0),
        internalLinkType: "".concat(pageName, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0),
        internalLinkURL: productUrl || "n/a",
        internalLinkZoneName: "".concat(pageTypeText).concat(upshellTitle, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0),
        modalName: _components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0
    };
    pushAnalyticsObjToDataLayer(eventInfo, productInfo);
};
const quickViewAddToCartAnalytics = (data)=>{
    const { productInfo ={} , upshellmodal =false , recommendationSource ="n/a"  } = data;
    const { pageTypeText , pageName , upshellTitle  } = getEventInfo(upshellmodal);
    const eventInfo = {
        clickInternalLinks: "true",
        curatedRecommendation: recommendationSource,
        eventAction: "".concat(pageTypeText, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .UPSELL_PRODUCT */ .Ey, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .ADD_TO_CART */ .G2),
        eventMsg: "n/a",
        eventName: "".concat(pageTypeText, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .UPSELL_PRODUCT */ .Ey, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .ADD_TO_CART */ .G2),
        eventStatus: "n/a",
        eventType: "navigation",
        internalLinkName: _components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .ADD_TO_CART */ .G2,
        internalLinkPosition: "".concat(pageTypeText, ":upsell:").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0),
        internalLinkType: "".concat(pageName, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0),
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(pageTypeText).concat(upshellTitle, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .ADD_TO_CART */ .G2),
        modalName: _components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0
    };
    pushAnalyticsObjToDataLayer(eventInfo, productInfo);
};
const viewFullDetailsAnalytics = (data)=>{
    const { productInfo ={} , upshellmodal =false , recommendationSource ="n/a"  } = data;
    const { pageTypeText , pageName , upshellTitle  } = getEventInfo(upshellmodal);
    const eventInfo = {
        clickInternalLinks: "true",
        curatedRecommendation: recommendationSource,
        eventAction: "".concat(pageTypeText, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .UPSELL_PRODUCT */ .Ey, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .VIEW_FULL_DETAILS */ .YM),
        eventMsg: "n/a",
        eventName: "".concat(pageTypeText, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .UPSELL_PRODUCT */ .Ey, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .VIEW_FULL_DETAILS */ .YM),
        eventStatus: "n/a",
        eventType: "navigation",
        internalLinkName: _components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .VIEW_FULL_DETAILS */ .YM,
        internalLinkPosition: "".concat(pageTypeText, ":upsell:").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0),
        internalLinkType: "".concat(pageName, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0),
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(pageTypeText).concat(upshellTitle, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .VIEW_FULL_DETAILS */ .YM),
        modalName: _components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0
    };
    pushAnalyticsObjToDataLayer(eventInfo, productInfo);
};
const quickViewDimensionsAnalytics = (data)=>{
    const { productInfo ={} , upshellmodal =false , recommendationSource ="n/a" , dimensionsValue ={}  } = data;
    const { pageTypeText , pageName , upshellTitle  } = getEventInfo(upshellmodal);
    const { tooltip ="" , label ="" , value =""  } = dimensionsValue;
    const eventInfo = {
        clickInternalLinks: "true",
        curatedRecommendation: recommendationSource,
        eventAction: "".concat(pageTypeText, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .UPSELL_PRODUCT */ .Ey, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .DIMENSIONS */ .m$, " mouseover"),
        eventMsg: "n/a",
        eventName: "".concat(pageTypeText, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .UPSELL_PRODUCT */ .Ey, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .DIMENSIONS */ .m$, " mouseover"),
        eventStatus: "n/a",
        eventType: "navigation",
        internalLinkName: tooltip,
        internalLinkPosition: "".concat(pageTypeText, ":upsell:").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .DIMENSIONS */ .m$, ":").concat(label.toLowerCase(), " ").concat(value.toLowerCase()),
        internalLinkType: "".concat(pageName, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0),
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(pageTypeText).concat(upshellTitle, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .DIMENSIONS */ .m$),
        modalName: _components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0
    };
    pushAnalyticsObjToDataLayer(eventInfo, productInfo);
};
const quickViewVaraintClickAnalytics = (data)=>{
    const { productInfo ={} , upshellmodal =false , recommendationSource ="n/a" , assetId , label  } = data;
    const { pageTypeText , pageName , upshellTitle  } = getEventInfo(upshellmodal);
    const eventInfo = {
        clickInternalLinks: "true",
        curatedRecommendation: recommendationSource,
        eventAction: "".concat(pageTypeText, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .UPSELL_PRODUCT */ .Ey, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .COLOR_SELECTION */ ._I),
        eventMsg: "n/a",
        eventName: "".concat(pageTypeText, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .UPSELL_PRODUCT */ .Ey, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .COLOR_SELECTION */ ._I),
        eventStatus: "n/a",
        eventType: "navigation",
        imageSequence: 1,
        imageId: assetId,
        imageName: label,
        internalLinkName: _components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .COLOR_SELECTION */ ._I,
        internalLinkPosition: "".concat(pageTypeText, ":upsell:").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0),
        internalLinkType: "".concat(pageName, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0),
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(pageTypeText).concat(upshellTitle, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .COLOR_SELECTION */ ._I),
        modalName: _components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0
    };
    pushAnalyticsObjToDataLayer(eventInfo, productInfo);
};
const quickViewListPriceAnalytics = (data)=>{
    const { productInfo ={} , upshellmodal =false , recommendationSource ="n/a" , listPriceInfo  } = data;
    const { pageTypeText , pageName , upshellTitle  } = getEventInfo(upshellmodal);
    const eventInfo = {
        clickInternalLinks: "true",
        curatedRecommendation: recommendationSource,
        eventAction: "".concat(pageTypeText, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .UPSELL_PRODUCT */ .Ey, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .LIST_PRICE */ .GG, " mouseover"),
        eventMsg: "n/a",
        eventName: "".concat(pageTypeText, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .UPSELL_PRODUCT */ .Ey, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .LIST_PRICE */ .GG, "  mouseover"),
        eventStatus: "n/a",
        eventType: "navigation",
        internalLinkName: listPriceInfo,
        internalLinkPosition: "".concat(pageTypeText, ":upsell:").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .LIST_PRICE */ .GG, " hover"),
        internalLinkType: "".concat(pageName, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0),
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(pageTypeText).concat(upshellTitle, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .LIST_PRICE */ .GG),
        modalName: _components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0
    };
    pushAnalyticsObjToDataLayer(eventInfo, productInfo);
};
const quickViewPrevNextCarouselButtonClickAnalytics = (data)=>{
    const { productInfo ={} , upshellmodal =false , recommendationSource ="n/a" , btnType =""  } = data;
    const { pageTypeText , pageName , upshellTitle  } = getEventInfo(upshellmodal);
    const eventInfo = {
        clickInternalLinks: "true",
        curatedRecommendation: recommendationSource,
        eventAction: "".concat(pageTypeText, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .UPSELL_PRODUCT */ .Ey, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .CAROUSEL_IMAGE */ .cA, ":").concat(btnType),
        eventMsg: "n/a",
        eventName: "".concat(pageTypeText, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .UPSELL_PRODUCT */ .Ey, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .CAROUSEL_IMAGE */ .cA, ":").concat(btnType),
        eventStatus: "n/a",
        eventType: "navigation",
        internalLinkName: "".concat(btnType, " arrow"),
        internalLinkPosition: "".concat(pageTypeText, ":upsell:").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0),
        internalLinkType: "".concat(pageName, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0),
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(pageTypeText).concat(upshellTitle, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .CAROUSEL_IMAGE */ .cA),
        modalName: _components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0
    };
    pushAnalyticsObjToDataLayer(eventInfo, productInfo);
};
const quickViewCarouselImageClickAnalytics = (data)=>{
    const { productInfo ={} , upshellmodal =false , recommendationSource ="n/a" , assetId , imageSequence , resourceType , imageName  } = data;
    const { pageTypeText , pageName , upshellTitle  } = getEventInfo(upshellmodal);
    const eventInfo = {
        clickInternalLinks: "true",
        curatedRecommendation: recommendationSource,
        eventAction: "".concat(pageTypeText, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .UPSELL_PRODUCT */ .Ey, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .CAROUSEL_IMAGE */ .cA, " click"),
        eventMsg: "n/a",
        eventName: "".concat(pageTypeText, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .UPSELL_PRODUCT */ .Ey, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .CAROUSEL_IMAGE */ .cA, " click"),
        eventStatus: "n/a",
        eventType: "navigation",
        internalLinkName: assetId,
        internalLinkPosition: "".concat(pageTypeText, ":upsell:").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0),
        internalLinkType: "".concat(pageName, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0),
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(pageTypeText).concat(upshellTitle, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .CAROUSEL_IMAGE */ .cA),
        modalName: _components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0,
        imageId: assetId,
        imageName: imageName,
        resourceType: resourceType,
        imageSequence: imageSequence
    };
    pushAnalyticsObjToDataLayer(eventInfo, productInfo);
};
const quickViewReviewClickAnalytics = (data)=>{
    const { productInfo ={} , upshellmodal =false , recommendationSource ="n/a"  } = data;
    const { pageTypeText , pageName , upshellTitle  } = getEventInfo(upshellmodal);
    const eventInfo = {
        clickInternalLinks: "true",
        curatedRecommendation: recommendationSource,
        eventAction: "".concat(pageTypeText, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .UPSELL_PRODUCT */ .Ey, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .REVIEW */ .Jd),
        eventMsg: "n/a",
        eventName: "".concat(pageTypeText, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .UPSELL_PRODUCT */ .Ey, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .REVIEW */ .Jd),
        eventStatus: "n/a",
        eventType: "navigation",
        internalLinkName: _components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .REVIEW */ .Jd,
        internalLinkPosition: "".concat(pageTypeText, ":upsell:").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0),
        internalLinkType: "".concat(pageName, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0),
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(pageTypeText).concat(upshellTitle, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .REVIEW */ .Jd),
        modalName: _components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0
    };
    pushAnalyticsObjToDataLayer(eventInfo, productInfo);
};
const quickViewDownloadClickAnalytics = (data)=>{
    var ref;
    const { productInfo ={} , upshellmodal =false , recommendationSource ="n/a" , title ="" , url =""  } = data;
    const { pageTypeText , pageName , upshellTitle  } = getEventInfo(upshellmodal);
    const downloadTitle = ((ref = title.toLowerCase()) === null || ref === void 0 ? void 0 : ref.includes("specifications")) ? _components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .SPEC_SHEET */ .s4 : _components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .GUIDE */ .cd;
    const eventInfo = {
        clickInternalLinks: "true",
        curatedRecommendation: recommendationSource,
        eventAction: "".concat(pageTypeText, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .UPSELL_PRODUCT */ .Ey, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .Download */ .UW, ":").concat(downloadTitle),
        eventMsg: "n/a",
        eventName: "".concat(pageTypeText, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .UPSELL_PRODUCT */ .Ey, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .Download */ .UW, ":").concat(downloadTitle),
        eventStatus: "success",
        eventType: "navigation",
        internalLinkName: "".concat(downloadTitle, " | ").concat(url),
        internalLinkPosition: "".concat(pageTypeText, ":upsell:").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0),
        internalLinkType: "".concat(pageName, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0),
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(pageTypeText).concat(upshellTitle, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .Download */ .UW, "s"),
        modalName: _components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0
    };
    pushAnalyticsObjToDataLayer(eventInfo, productInfo);
};
const quickViewNotifyMeClickAnalytics = (data)=>{
    const { productInfo ={} , upshellmodal =false , recommendationSource ="n/a" , isSuccess , errorMsgQV  } = data;
    const { pageTypeText , pageName , upshellTitle  } = getEventInfo(upshellmodal);
    const eventInfo = {
        clickInternalLinks: "true",
        curatedRecommendation: recommendationSource,
        eventAction: "".concat(pageTypeText, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .UPSELL_PRODUCT */ .Ey, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .NOTIFY */ .mr),
        eventMsg: !isSuccess ? errorMsgQV : "n/a",
        eventName: "".concat(pageTypeText, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .UPSELL_PRODUCT */ .Ey, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .NOTIFY */ .mr),
        eventStatus: isSuccess ? "success" : "failure",
        eventType: "navigation",
        formName: _components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .NOTIFY */ .mr,
        internalLinkName: _components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .NOTIFY */ .mr,
        internalLinkPosition: "".concat(pageTypeText, ":upsell:").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0),
        internalLinkType: "".concat(pageName, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0),
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(pageTypeText).concat(upshellTitle, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0, ":").concat(_components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .NOTIFY */ .mr),
        modalName: _components_Shared_QuickView_constant_js__WEBPACK_IMPORTED_MODULE_1__/* .QUICK_VIEW_MODAL */ .K0
    };
    pushAnalyticsObjToDataLayer(eventInfo, productInfo);
};
const pushAnalyticsObjToDataLayer = function() {
    let eventInfo = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, productInfo = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const event = "cmp:click";
    window.adobeDataLayer.push({
        event,
        eventInfo,
        page,
        productInfo
    });
};


/***/ }),

/***/ 20443:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ey": function() { return /* binding */ UPSELL_PRODUCT; },
/* harmony export */   "F$": function() { return /* binding */ CLOSE; },
/* harmony export */   "G2": function() { return /* binding */ ADD_TO_CART; },
/* harmony export */   "GG": function() { return /* binding */ LIST_PRICE; },
/* harmony export */   "Jd": function() { return /* binding */ REVIEW; },
/* harmony export */   "K0": function() { return /* binding */ QUICK_VIEW_MODAL; },
/* harmony export */   "UW": function() { return /* binding */ Download; },
/* harmony export */   "YM": function() { return /* binding */ VIEW_FULL_DETAILS; },
/* harmony export */   "_I": function() { return /* binding */ COLOR_SELECTION; },
/* harmony export */   "cA": function() { return /* binding */ CAROUSEL_IMAGE; },
/* harmony export */   "cd": function() { return /* binding */ GUIDE; },
/* harmony export */   "iR": function() { return /* binding */ QUICK_VIEW; },
/* harmony export */   "lq": function() { return /* binding */ REVIEW_CONTAINER_ID; },
/* harmony export */   "m$": function() { return /* binding */ DIMENSIONS; },
/* harmony export */   "mr": function() { return /* binding */ NOTIFY; },
/* harmony export */   "s4": function() { return /* binding */ SPEC_SHEET; }
/* harmony export */ });
const UPSELL_PRODUCT = "upsell product";
const QUICK_VIEW = "quick view";
const CLOSE = "close";
const QUICK_VIEW_MODAL = "quick view modal";
const ADD_TO_CART = "add to cart";
const VIEW_FULL_DETAILS = "view full details";
const DIMENSIONS = "dimensions";
const COLOR_SELECTION = "color selection";
const LIST_PRICE = "list price";
const CAROUSEL_IMAGE = "carousel image";
const REVIEW = "write a review";
const Download = "download";
const NOTIFY = "notify me";
const SPEC_SHEET = "specification sheet";
const GUIDE = "installation guide";
const REVIEW_CONTAINER_ID = "#product-review";


/***/ }),

/***/ 55888:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BZ": function() { return /* binding */ getInitialImageData; },
/* harmony export */   "Ne": function() { return /* binding */ getProductInfoQuickView; },
/* harmony export */   "Pq": function() { return /* binding */ handleAddToCart; },
/* harmony export */   "U2": function() { return /* binding */ organizeData; },
/* harmony export */   "lR": function() { return /* binding */ getListValue; },
/* harmony export */   "qt": function() { return /* binding */ preventPopupScroll; },
/* harmony export */   "uS": function() { return /* binding */ handleSpecsDownload; }
/* harmony export */ });
/* unused harmony exports getSlickSettings, getSlickQuickViewPdpThumbnail, addToCartHandler */
/* harmony import */ var _utils_addTocart__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27522);
/* harmony import */ var _components_sharedCart_shareCartHelper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4364);
/* harmony import */ var _utils___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20558);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88032);
/* harmony import */ var _store_features_genericSlice__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(88751);
/* harmony import */ var _store_features_cartSlice__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(46201);
/* harmony import */ var _public_images_image_missing_png__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(36513);







const getSlickSettings = ()=>{
    return {
        dots: false,
        draggable: true,
        touchMove: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        swipeToSlide: true,
        swipe: true,
        arrows: true,
        infinite: false,
        centerMode: false,
        focusOnSelect: false,
        responsive: [
            {
                breakpoint: 1023,
                settings: {
                    dotsClass: "slider-dots",
                    dots: true
                }
            }
        ]
    };
};
const getProductInfoQuickView = (data)=>{
    const { brandName ="" , productName ="" , productDesc ="" , skuID ="" , category , pdpType , productPrice =0 , discountedPrice =0 , productImageUrl , productOnStock , selectedColor , categoryType , waterSenseProduct  } = data;
    const waterSense = (waterSenseProduct === null || waterSenseProduct === void 0 ? void 0 : waterSenseProduct.length) > 0 ? true : false;
    const productInfo = {
        category: categoryType,
        description: productDesc,
        frequency: "n/a",
        globalPromotionPrice: discountedPrice > 0 ? Number((discountedPrice - 0).toFixed(2)) : productPrice,
        globalOffer: "n/a",
        globalDiscount: Number(discountedPrice.toFixed(2)),
        isRecommended: "n/a",
        isSendNow: "n/a",
        isSubscription: "n/a",
        priceState: discountedPrice ? "discounted price" : "regular price",
        productBasePrice: Number(productPrice),
        productCategory: category,
        productColor: selectedColor,
        productCoupondiscount: "n/a",
        productCouponCode: "n/a",
        productID: skuID,
        productName: productName || productDesc || category || "n/a",
        productPartnerBuyNow: "n/a",
        productRoom: "product",
        productSalePrice: discountedPrice > 0 ? Number((discountedPrice - 0).toFixed(2)) : productPrice,
        productSaleable: true,
        productStatus: productOnStock > 0 ? "in stocks" : "out of stock",
        productSuperSku: false,
        productTileName: productName,
        quantity: 1,
        defaultImageName: productImageUrl || "n/a",
        ratings: "n/a",
        numberOfReviews: "n/a",
        pdpType: pdpType || "regular finished goods & service parts",
        productFindingMethod: "n/a",
        productCollectionsName: productName,
        productBrand: brandName,
        itemType: "product",
        waterSenseProduct: waterSense
    };
    return productInfo;
};
const getSlickQuickViewPdpThumbnail = ()=>{
    return {
        dots: false,
        draggable: true,
        touchMove: true,
        slidesToScroll: 1,
        slidesToShow: 8.8,
        centerPadding: "10px",
        swipeToSlide: true,
        vertical: false,
        swipe: true,
        arrows: false,
        infinite: false,
        centerMode: false,
        focusOnSelect: false,
        adaptiveHeight: false,
        responsive: [
            {
                breakpoint: 1025,
                settings: {
                    draggable: true,
                    touchMove: true,
                    slidesToScroll: 1,
                    slidesToShow: 4.8,
                    centerPadding: "10px",
                    vertical: false,
                    swipe: true,
                    centerMode: false,
                    swipeToSlide: true
                }
            },
            {
                breakpoint: 700,
                settings: {
                    slidesToScroll: 1,
                    slidesToShow: 8,
                    centerPadding: "10px",
                    vertical: false,
                    swipe: true,
                    centerMode: false,
                    swipeToSlide: true
                }
            },
            {
                breakpoint: 550,
                settings: {
                    slidesToScroll: 1,
                    slidesToShow: 4.8,
                    centerPadding: "10px",
                    vertical: false,
                    swipe: true,
                    centerMode: false,
                    swipeToSlide: true
                }
            }
        ]
    };
};
const getListValue = function(arrayVal, stringVal) {
    let productData = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    if (productData[arrayVal]) {
        return productData[arrayVal];
    } else if (productData[stringVal]) {
        return [
            productData[stringVal]
        ];
    } else {
        return [];
    }
};
const handleSpecsDownload = function(e, title, link) {
    let productInfo = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
    e.stopPropagation();
    let errMsg;
    const url = link.trim();
    try {
        window.open(url, "_blank");
    } catch (err) {
        errMsg = err.message;
        console.log(errMsg);
    }
};
const organizeData = (data, name, placeHolder, type)=>data.map((item, i)=>{
        let obj = {
            title: name ? name[i] : "".concat(placeHolder, " ").concat(data.length > 1 ? i + 1 : "")
        };
        if (type === "part") {
            obj = {
                ...obj,
                id: item
            };
        } else {
            obj = {
                ...obj,
                type,
                url: item
            };
        }
        return obj;
    });
const getInitialImageData = function() {
    let labledImages = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], productSkuInit = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    const initialImagesData = [];
    if (labledImages.length) {
        var ref, ref1, ref2;
        const index = labledImages.map((item)=>{
            var ref;
            return ((ref = item.split("|")) === null || ref === void 0 ? void 0 : ref.length) ? item.split("|")[0] : "";
        }).indexOf(productSkuInit);
        const assetId = ((ref1 = (ref = labledImages[index]) === null || ref === void 0 ? void 0 : ref.split("|")) === null || ref1 === void 0 ? void 0 : ref1.length) ? labledImages[index].split("|")[1] : "";
        const imageParams = labledImages === null || labledImages === void 0 ? void 0 : (ref2 = labledImages[index]) === null || ref2 === void 0 ? void 0 : ref2.split("|");
        const primaryImage = imageParams[imageParams.length - 1];
        initialImagesData.push({
            label: "",
            assetId,
            url: primaryImage !== null && primaryImage !== void 0 ? primaryImage : _public_images_image_missing_png__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z === null || _public_images_image_missing_png__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z === void 0 ? void 0 : _public_images_image_missing_png__WEBPACK_IMPORTED_MODULE_6__/* ["default"].src */ .Z.src
        });
    } else {
        initialImagesData.push({
            label: "",
            assetId: "",
            url: _public_images_image_missing_png__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z === null || _public_images_image_missing_png__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z === void 0 ? void 0 : _public_images_image_missing_png__WEBPACK_IMPORTED_MODULE_6__/* ["default"].src */ .Z.src
        });
    }
    return initialImagesData;
};
// called when user click on Add To Cart button
const handleAddToCart = async function(e) {
    let selectedSku = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", brandName = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", cb = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : ()=>{};
    var ref, ref1;
    e.preventDefault();
    e.stopPropagation();
    const itemsProjectionApiResponse = await (0,_components_sharedCart_shareCartHelper__WEBPACK_IMPORTED_MODULE_1__/* .getProductsBySku */ .uX)([
        selectedSku
    ]);
    var ref2;
    const variants = (ref2 = itemsProjectionApiResponse === null || itemsProjectionApiResponse === void 0 ? void 0 : (ref = itemsProjectionApiResponse[0]) === null || ref === void 0 ? void 0 : ref.variants) !== null && ref2 !== void 0 ? ref2 : [];
    var ref3;
    variants.push((ref3 = itemsProjectionApiResponse === null || itemsProjectionApiResponse === void 0 ? void 0 : (ref1 = itemsProjectionApiResponse[0]) === null || ref1 === void 0 ? void 0 : ref1.masterVariant) !== null && ref3 !== void 0 ? ref3 : {});
    let isComboSku = false;
    for (const variant of variants){
        if (selectedSku === variant.sku) {
            isComboSku = variant === null || variant === void 0 ? void 0 : variant.attributes.some((attr)=>attr.name === "ComboSKU");
        }
    }
    const payload = [
        {
            sku: selectedSku,
            quantity: 1,
            brand: brandName === null || brandName === void 0 ? void 0 : brandName.toLowerCase(),
            isBundle: isComboSku
        }
    ];
    addToCartHandler(payload, cb);
};
// Api call to dispatch the item to the cart
const addToCartHandler = async function() {
    let items = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], cb = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ()=>{};
    const payload = await (0,_utils_addTocart__WEBPACK_IMPORTED_MODULE_0__/* .addToCartItem */ .q)([
        ...items
    ]);
    const body = {
        actions: payload
    };
    _store__WEBPACK_IMPORTED_MODULE_3__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_5__/* .addToCart */ .Xq)(body)).unwrap().then((res)=>{
        const { payload ={}  } = res;
        if (!(0,_utils___WEBPACK_IMPORTED_MODULE_2__/* .isObjectEmpty */ .nK)(payload)) {
            _store__WEBPACK_IMPORTED_MODULE_3__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_5__/* .setCart */ .RV)(payload));
        }
        cb();
        _store__WEBPACK_IMPORTED_MODULE_3__/* .store.dispatch */ .h.dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_4__/* .showPreviewCart */ .z0)());
    }).catch((err)=>{
        cb();
    });
};
// if quickview modal open prevent scrollbar body top
const preventPopupScroll = function() {
    let isPopupClose = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    const bodyElement = document.body;
    if (isPopupClose) {
        bodyElement.classList.remove("quickview-image-scroll");
    } else {
        bodyElement.classList.remove("modal-open", "scroll-lock");
        document.getElementsByTagName("html")[0].classList.remove("modal-open", "scroll-lock");
        bodyElement.classList.add("quickview-image-scroll");
    }
};


/***/ }),

/***/ 54075:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ UpsellInstallServices_ProductCardForUpsell; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./components/core/Button/Button.jsx + 1 modules
var Button = __webpack_require__(7872);
// EXTERNAL MODULE: ./components/core/Modal/Modal.jsx + 1 modules
var Modal = __webpack_require__(78145);
// EXTERNAL MODULE: ./components/Shared/UpsellInstallServices/ProductCardForUpsell/index.module.scss
var index_module = __webpack_require__(20079);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./hooks/useWindowResize.js
var useWindowResize = __webpack_require__(11859);
// EXTERNAL MODULE: ./utils/index.js
var utils = __webpack_require__(20558);
// EXTERNAL MODULE: ./utils/helper.js + 1 modules
var helper = __webpack_require__(55760);
;// CONCATENATED MODULE: ./components/Shared/UpsellInstallServices/ProductCardForUpsell/analytics/constant.js
const UPSELL = "upsell product";
const ADD_TO_CART = "add to cart";
const PREVIEW = "preview";

;// CONCATENATED MODULE: ./components/Shared/UpsellInstallServices/ProductCardForUpsell/analytics/index.js

const addAnalyticsForAddToCart = (item, productPrice, discountedPrice, productImageUrl)=>{
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const pageload = page.category.subCategoryID === "home" ? "homepage" : page.category.subCategoryID;
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(pageload, " ").concat(PREVIEW, ":").concat(UPSELL, ":").concat(ADD_TO_CART),
        eventMsg: "n/a",
        eventName: "".concat(pageload, " ").concat(PREVIEW, ":").concat(UPSELL, ":").concat(ADD_TO_CART),
        eventStatus: "n/a",
        eventType: "navigation",
        internalLinkName: ADD_TO_CART,
        internalLinkPosition: "".concat(pageload, " ").concat(PREVIEW, ":upsell"),
        internalLinkType: "".concat(pageload, ":").concat(ADD_TO_CART),
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(pageload, " ").concat(PREVIEW, ":our best sellers")
    };
    pushAnalyticsObjToDataLayer(eventInfo, item, productPrice, discountedPrice, productImageUrl);
};
const addClickAnalytics = (data)=>{
    const { item , productPrice , discountedPrice , productImageUrl , productUrl  } = data;
    const { ProductBrandName_s: name = "" , ProductDescriptionProductShort_s: desc = "" , Product_Category: category = ""  } = item;
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "cart preview:upsell product navigation",
        eventMsg: "n/a",
        eventName: "cart preview:upsell product navigation",
        eventStatus: "n/a",
        eventType: "navigation",
        internalLinkName: name || desc || category || "n/a",
        internalLinkPosition: "cart preview:upsell",
        internalLinkType: "cart:upsell navigation",
        internalLinkURL: productUrl || "n/a",
        internalLinkZoneName: "cart preview:our best sellers"
    };
    pushAnalyticsObjToDataLayer(eventInfo, item, productPrice, discountedPrice, productImageUrl);
};
const getproductInfo = (item, productPrice, discountedPrice, productImageUrl)=>{
    const { CustomerFacingBrand_s: brandName = "" , sku_s: skuID = "" , ProductBrandName_s: name = "" , ProductDescriptionProductShort_s: desc = "" , Product_Category: category = ""  } = item;
    const productInfo = {
        description: desc,
        frequency: "n/a",
        globalPromotionPrice: discountedPrice > 0 ? Number((productPrice - 0).toFixed(2)) : 0,
        globalOffer: "n/a",
        globalDiscount: Number(discountedPrice.toFixed(2)),
        isRecommended: "n/a",
        isSendNow: "n/a",
        isSubscription: "n/a",
        priceState: discountedPrice ? "discounted price" : "regular price",
        productBasePrice: Number(productPrice),
        productCategory: category,
        productColor: "default",
        productCoupondiscount: "n/a",
        productCouponCode: "n/a",
        productID: skuID,
        productName: name || desc || category || "n/a",
        productPartnerBuyNow: "n/a",
        productRoom: "service" || 0,
        productSalePrice: Number(productPrice),
        productSaleable: true,
        productStatus: "in stock",
        productSuperSku: false,
        productTileName: name,
        quantity: 1,
        defaultImageName: productImageUrl,
        ratings: "n/a",
        numberOfReviews: "n/a",
        pdpType: "regular finished goods & service parts",
        productFindingMethod: "n/a",
        productCollectionsName: category,
        productBrand: brandName,
        itemType: "service" || 0
    };
    return productInfo;
};
const pushAnalyticsObjToDataLayer = function() {
    let eventInfo = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, item = arguments.length > 1 ? arguments[1] : void 0, productPrice = arguments.length > 2 ? arguments[2] : void 0, discountedPrice = arguments.length > 3 ? arguments[3] : void 0, productImageUrl = arguments.length > 4 ? arguments[4] : void 0;
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const productInfo = getproductInfo(item, productPrice, discountedPrice, productImageUrl);
    const event = "cmp:click";
    window.adobeDataLayer.push({
        event,
        eventInfo,
        page,
        productInfo
    });
};

// EXTERNAL MODULE: ./components/Shared/QuickView/analytics.js
var analytics = __webpack_require__(78592);
// EXTERNAL MODULE: ./components/sharedCart/shareCartHelper.js
var shareCartHelper = __webpack_require__(4364);
// EXTERNAL MODULE: ./components/Shared/Image/index.js
var Image = __webpack_require__(70914);
// EXTERNAL MODULE: ./constants/index.js
var constants = __webpack_require__(96301);
// EXTERNAL MODULE: ./components/Shared/QuickView/utlis.js
var utlis = __webpack_require__(55888);
;// CONCATENATED MODULE: ./components/Shared/UpsellInstallServices/ProductCardForUpsell/ProductCard.jsx















const QuickView = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(2374), __webpack_require__.e(5490)]).then(__webpack_require__.bind(__webpack_require__, 10322)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(10322)
            ]
    }
});
const ProductCard = (param)=>{
    let { persona ="GST" , currencySign ="$" , brand ="kohler" , presetConfigs ="" , rowCols =0 , swatchUrl: baseUrl = "" , outOfStockTitle ="" , addToCart =()=>{} , staticText ={} , productData ={} , quickViewAuthData ={} , quickViewButtonLabel ="" , ...item } = param;
    const [width] = (0,useWindowResize/* default */.Z)();
    const [pdpUrl, setPdpUrl] = (0,react.useState)("");
    const [loading, setLoading] = (0,react.useState)(false);
    const [showQuickViewModal, setShowQuickViewModal] = (0,react.useState)(false);
    const { sku_s: skuId = "" , quantity: productQuantity = 0 , ProductBrandName_s: name = "" , productName_s: productName = "" , ["priceList.".concat(persona, ".price_d")]: productPrice = 0 , ["priceList.".concat(persona, ".discountedPrice_d")]: discountedPrice = 0 , ["productImages.labelWithUrl_ss"]: labledImages = [] , Product_Category: productCategory = "" , slug_s: slug = ""  } = item;
    (0,react.useEffect)(()=>{
        (0,helper/* getPDPUrl */.ir5)(productCategory, slug).then((url)=>setPdpUrl(url));
    }, []);
    const price = Number(productPrice).toLocaleString(undefined, {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2
    });
    const productPresetConfigs = presetConfigs ? JSON.parse(presetConfigs) : {};
    let imgId = "";
    if (labledImages.length) {
        var ref, ref1;
        const index = labledImages.map((item)=>{
            var ref;
            return ((ref = item.split("|")) === null || ref === void 0 ? void 0 : ref.length) ? item.split("|")[0] : "";
        }).indexOf(skuId);
        const assetId = ((ref1 = (ref = labledImages[index]) === null || ref === void 0 ? void 0 : ref.split("|")) === null || ref1 === void 0 ? void 0 : ref1.length) ? labledImages[index].split("|")[1] : "";
        imgId = assetId;
    }
    const handleAddToCartCb = ()=>{
        setLoading(false);
    };
    const handleAddToCart = async (e)=>{
        var ref, ref1;
        e.preventDefault();
        e.stopPropagation();
        setLoading(true);
        const itemsProjectionApiResponse = await (0,shareCartHelper/* getProductsBySku */.uX)([
            skuId
        ]);
        var ref2;
        const variants = (ref2 = itemsProjectionApiResponse === null || itemsProjectionApiResponse === void 0 ? void 0 : (ref = itemsProjectionApiResponse[0]) === null || ref === void 0 ? void 0 : ref.variants) !== null && ref2 !== void 0 ? ref2 : [];
        var ref3;
        variants.push((ref3 = itemsProjectionApiResponse === null || itemsProjectionApiResponse === void 0 ? void 0 : (ref1 = itemsProjectionApiResponse[0]) === null || ref1 === void 0 ? void 0 : ref1.masterVariant) !== null && ref3 !== void 0 ? ref3 : {});
        let isComboSku = false;
        for(let i = 0; i < variants.length; i++){
            if (skuId === variants[i].sku) {
                var ref4;
                isComboSku = ((ref4 = variants[i]) === null || ref4 === void 0 ? void 0 : ref4.attributes.find((attr)=>attr.name === "ComboSKU")) ? true : false;
            }
        }
        const payload = [
            {
                sku: skuId,
                quantity: 1,
                brand: brand === null || brand === void 0 ? void 0 : brand.toLowerCase(),
                isBundle: isComboSku
            }
        ];
        addToCart(payload, handleAddToCartCb);
        addAnalyticsForAddToCart(item, productPrice, discountedPrice, productImageUrl);
    };
    const productImageUrl = (0,utils/* getPresetUrl */.v$)(width, rowCols, baseUrl, imgId, productPresetConfigs);
    const productUrl = "".concat(constants.DOMAIN).concat(pdpUrl).concat(skuId ? "?skuId=" + skuId : "") || "";
    const linkClicked = ()=>{
        addClickAnalytics({
            item,
            productPrice,
            discountedPrice,
            productImageUrl,
            productUrl
        });
    };
    const openQuickViewModal = ()=>{
        (0,analytics/* quickViewOpenAnalytics */.E$)({
            productData,
            productUrl,
            productImageUrl,
            upshellmodal: true
        });
        setShowQuickViewModal(true);
    };
    const closeQuickViewModal = ()=>{
        setShowQuickViewModal(false);
        (0,utlis/* preventPopupScroll */.qt)(true);
    };
    (0,react.useEffect)(()=>{
        if (showQuickViewModal) {
            (0,utlis/* preventPopupScroll */.qt)();
        }
    }, [
        showQuickViewModal
    ]);
    const [productInfo, setProductInfo] = (0,react.useState)({});
    const handleProductInfo = (data)=>{
        setProductInfo(data);
    };
    const handleButtonClosed = ()=>{
        (0,analytics/* quickViewCloseAnalytics */.I4)({
            productInfo,
            upshellmodal: true
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (index_module_default()).curatedProduct,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "curated-product-recommendation__card-list",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: "".concat(pdpUrl).concat(skuId ? "?skuId=" + skuId : ""),
                    onClick: linkClicked,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "curated-product-recommendation__product-card",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "curated-product-recommendation__img",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                    src: productImageUrl,
                                    alt: name,
                                    width: 280,
                                    height: 280
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "curated-product-recommendation__product-name",
                                children: name || productName
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "curated-product-recommendation__product-sku",
                                children: skuId
                            }),
                            discountedPrice > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "curated-product-recommendation__discounted-price",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "price-with-discount",
                                        children: "".concat(currencySign).concat(discountedPrice)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "original-price",
                                        children: "".concat(currencySign).concat(price)
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "curated-product-recommendation__product-price",
                                children: "".concat(currencySign).concat(price)
                            }),
                            !productQuantity ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "curated-product-recommendation__out-of-stock",
                                children: outOfStockTitle
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "cart-quickview-section",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "curated-product-recommendation__add-to-cart".concat(!quickViewButtonLabel ? " upshell-button" : ""),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            role: "button",
                                            label: "Add To Cart",
                                            size: "small",
                                            type: "primary",
                                            flexible: true,
                                            onClick: handleAddToCart,
                                            loading: loading
                                        })
                                    }),
                                    quickViewButtonLabel ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "quick-view-title",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            role: "button",
                                            label: quickViewButtonLabel,
                                            size: "small",
                                            type: "ghost",
                                            ariaLabel: quickViewButtonLabel,
                                            flexible: true,
                                            onClick: (e)=>{
                                                e.preventDefault();
                                                e.stopPropagation();
                                                openQuickViewModal();
                                            }
                                        })
                                    }) : null
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal["default"], {
                showModal: showQuickViewModal,
                onModalClose: closeQuickViewModal,
                className: "quickview-modal",
                isCloseButtonClicked: handleButtonClosed,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(QuickView, {
                    productData: productData,
                    authorData: quickViewAuthData,
                    closeModal: closeQuickViewModal,
                    upshellmodal: true,
                    handleProductInfo: handleProductInfo
                })
            })
        ]
    });
};
/* harmony default export */ var ProductCardForUpsell_ProductCard = (/*#__PURE__*/(0,react.memo)(ProductCard));

// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./constants/config.js
var config = __webpack_require__(19514);
// EXTERNAL MODULE: ./components/Shared/UpsellInstallServices/api.js
var api = __webpack_require__(9670);
// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(85518);
// EXTERNAL MODULE: ./utils/addTocart.js
var addTocart = __webpack_require__(27522);
// EXTERNAL MODULE: ./store/features/cartSlice.js
var cartSlice = __webpack_require__(46201);
// EXTERNAL MODULE: ./store/features/genericSlice.js
var genericSlice = __webpack_require__(88751);
;// CONCATENATED MODULE: ./components/Shared/UpsellInstallServices/ProductCardForUpsell/index.jsx















const ProductCardForUpsell = (param)=>{
    let { authData ={} , staticText ={} , quickViewAuthData ={}  } = param;
    const { skuIds =[] , presetConfigs ="" , swatchUrl ="" , outOfStockTitle ="" , quickViewButtonLabel =""  } = authData;
    const [width] = (0,useWindowResize/* default */.Z)();
    const dispatch = (0,es/* useDispatch */.I0)();
    const rowCols = (0,utils/* getRowCols */.n)(width, lib/* isMobile */.tq, lib/* isTablet */.Em);
    const persona = (0,helper/* getUserPersona */.shu)();
    const [recommendedProductData, setRecommendedProductData] = (0,react.useState)([]);
    const [currency, setCurrencySign] = (0,react.useState)("$");
    const [brand, setBrand] = (0,react.useState)("kohler");
    const callToFetchRecommendedProductData = ()=>{
        (0,config/* getConfig */.i)().then((config)=>{
            if (!isEmpty_default()(config)) {
                const { general: { lwAppName ="" , siteName ="kohler"  } = {} , internationalization: { currencySign ="$"  } = {}  } = config;
                if (skuIds.length) getRecommendedProductData({
                    lwAppName,
                    currencySign,
                    siteName
                });
            }
        });
    };
    (0,react.useEffect)(()=>{
        if (persona) callToFetchRecommendedProductData();
    }, [
        persona
    ]);
    const getRecommendedProductData = (param)=>{
        let { lwAppName ="" , currencySign ="$" , siteName ="kohler"  } = param;
        (0,api/* getProductDataFromSkuIds */.fh)(persona, skuIds, lwAppName).then(async (res)=>{
            const skuidString = skuIds.join(",");
            if (!isEmpty_default()(res) && skuidString) {
                const { data: { response: { docs =[]  } = {}  } = {}  } = res;
                var ref;
                const { data: { results: productInventory = []  } = {}  } = (ref = await (0,api/* getProductInventory */.o)(skuidString)) !== null && ref !== void 0 ? ref : {};
                const updatedDocs = [];
                skuIds.forEach((sku)=>{
                    docs.forEach((item)=>{
                        if (sku === item.sku_s) {
                            const matchItem = productInventory.find((product)=>product.sku === item.sku_s);
                            if (matchItem) {
                                updatedDocs.push({
                                    ...item,
                                    quantity: matchItem === null || matchItem === void 0 ? void 0 : matchItem.availableQuantity
                                });
                            }
                        }
                    });
                });
                setCurrencySign(currencySign);
                setBrand(siteName);
                setRecommendedProductData(updatedDocs);
            }
        });
    };
    const handleAddToCart = async function() {
        let items = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], cb = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ()=>{};
        const payload = await (0,addTocart/* addToCartItem */.q)([
            ...items
        ]);
        const body = {
            actions: payload
        };
        dispatch((0,cartSlice/* addToCart */.Xq)(body)).unwrap().then((res)=>{
            dispatch((0,genericSlice/* showPreviewCart */.z0)());
            const { payload ={}  } = res;
            if (!isEmpty_default()(payload)) {
                dispatch((0,cartSlice/* setCart */.RV)(payload));
            }
            cb();
        }).catch((err)=>{
            cb();
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (index_module_default()).curatedProduct,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "curated-product-recommendation",
            children: recommendedProductData.map((item)=>{
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCardForUpsell_ProductCard, {
                        addToCart: handleAddToCart,
                        ...item,
                        persona: persona,
                        currencySign: currency,
                        brand: brand,
                        presetConfigs: presetConfigs,
                        rowCols: rowCols,
                        swatchUrl: swatchUrl,
                        outOfStockTitle: outOfStockTitle,
                        staticText: staticText,
                        productData: item,
                        quickViewAuthData: quickViewAuthData,
                        quickViewButtonLabel: quickViewButtonLabel
                    })
                }, item.id);
            })
        })
    });
};
/* harmony default export */ var UpsellInstallServices_ProductCardForUpsell = (ProductCardForUpsell);


/***/ }),

/***/ 9670:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q3": function() { return /* binding */ getListOfRequiredSkus; },
/* harmony export */   "U1": function() { return /* binding */ getListOfRequiredAdobeTargetSkus; },
/* harmony export */   "X_": function() { return /* binding */ getZipCodes; },
/* harmony export */   "fh": function() { return /* binding */ getProductDataFromSkuIds; },
/* harmony export */   "o": function() { return /* binding */ getProductInventory; }
/* harmony export */ });
/* harmony import */ var _constants_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73350);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19514);
/* harmony import */ var _utils_ApiUtil__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51666);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96301);
/* harmony import */ var _constants_routes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64757);






const getListOfParamsToFetch = (persona)=>{
    const fl = [
        "id",
        "slug_s",
        "productName_s",
        "masterSKU_s",
        "sku_s",
        "Product_Category",
        "ProductBrandName_s",
        "productImages.url_ss",
        "SKUColorSwatchFilename_ss",
        "ProductDescriptionProductShort_s",
        "priceStartingAt.".concat(persona, "_d"),
        "discountedPriceStartingAt.".concat(persona, "_d"),
        "priceList.".concat(persona, ".saleOffer_s"),
        "Color.SKU.Details_ss",
        "ProductWebFeatures_ss",
        "ProductWebFeatures_s",
        "ProductIsExclusive_s",
        "RegionReleaseforShipment_dt",
        "title_s",
        "ProductNarrativeDescription_s",
        "priceList.".concat(persona, ".finalPrice_d"),
        "CustomerFacingBrand_s",
        "RegionBrandName_s",
        "priceList.".concat(persona, ".discountedPrice_d"),
        "priceList.".concat(persona, ".price_d"),
        "CrossSellRecommendationSKUList_ss",
        "productImages.labelWithUrl_ss",
        "ItemResource.IMGSpinSet.resourceFullWebURL_ss",
        "ItemResource.IMGSpinSet.resourceName_ss",
        "ItemResource.IMGSpinSet.resourceAltText_ss",
        "ItemResource.IMGSpinSet.resourceType_ss",
        "ctProductType_s",
        "RegionIsBackorderable_b",
        "RegionLeadTime_i"
    ];
    return fl.join(",");
};
const getProductDataFromSkuIds = async function() {
    let persona = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "GST", skus = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], lwAppName = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
    var ref;
    if (!skus.length) return;
    const fl = getListOfParamsToFetch(persona);
    const fq = "sku_s:(".concat(skus.map((ele)=>'"'.concat(ele, '"')).join(" "), ")");
    const config = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_1__/* .getConfig */ .i)();
    var ref1;
    const language = (ref1 = config === null || config === void 0 ? void 0 : (ref = config.internationalization) === null || ref === void 0 ? void 0 : ref.language) !== null && ref1 !== void 0 ? ref1 : "en";
    const brand = lwAppName === null || lwAppName === void 0 ? void 0 : lwAppName.toLowerCase();
    var ref2;
    return _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.get */ .TH.get("/search/plp", {
        params: {
            fl,
            q: "*:*",
            fq: [
                fq,
                'language_s:("'.concat(language, '")')
            ],
            collections: brand,
            profilename: "profile_".concat(brand, "_Full_Catalog"),
            rows: (ref2 = skus === null || skus === void 0 ? void 0 : skus.length) !== null && ref2 !== void 0 ? ref2 : 10,
            sessionId: (0,_utils_ApiUtil__WEBPACK_IMPORTED_MODULE_4__/* .getSessionIdObjWithEpoc */ .oq)()
        },
        paramsSerializer: (params)=>{
            return qs__WEBPACK_IMPORTED_MODULE_5___default().stringify(params, {
                arrayFormat: "repeat",
                encode: false
            });
        }
    });
};
const getZipCodes = async (jsonFileUrl)=>await (0,_constants_api__WEBPACK_IMPORTED_MODULE_0__/* .aemAxiosInstance */ .Gb)({
        url: _constants__WEBPACK_IMPORTED_MODULE_2__.GLOBAL_CONFIGURATION_ENDPOINT,
        params: {
            path: jsonFileUrl
        }
    });
const getListOfRequiredSkus = async function() {
    let persona = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "GST", slug = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", sku = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", lwAppName = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "";
    try {
        var ref;
        const fl = getListOfParamsToFetch(persona);
        const config = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_1__/* .getConfig */ .i)();
        var ref1;
        const language = (ref1 = config === null || config === void 0 ? void 0 : (ref = config.internationalization) === null || ref === void 0 ? void 0 : ref.language) !== null && ref1 !== void 0 ? ref1 : "en";
        const fq = 'sku_s:("'.concat(sku, '")');
        return _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.post */ .TH.post("search/pdp/".concat(slug), {
            fl,
            q: "*:*",
            fq: "".concat(fq, ' AND language_s:("').concat(language, '")'),
            collections: lwAppName,
            profilename: "profile_".concat(lwAppName, "_General"),
            sessionId: (0,_utils_ApiUtil__WEBPACK_IMPORTED_MODULE_4__/* .getSessionIdObjWithEpoc */ .oq)()
        });
    } catch (err) {
        return {};
    }
};
const getProductInventory = function() {
    let skus = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.get */ .TH.get("".concat(_constants__WEBPACK_IMPORTED_MODULE_2__.getStockEndPoint, "/?sku=").concat(skus));
};
const getListOfRequiredAdobeTargetSkus = async (payload)=>{
    try {
        var ref, ref1, ref2;
        const res = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.post */ .TH.post("".concat(_constants_routes__WEBPACK_IMPORTED_MODULE_3__/* .ADOBE_TARGET_PRODUCT_RECOMMENDETION_ENDPOINT */ .TE, "?sessionId=").concat((0,_utils_ApiUtil__WEBPACK_IMPORTED_MODULE_4__/* .getSessionId */ .MQ)()), payload);
        var ref3;
        return (ref3 = res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : (ref1 = ref.execute) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.mboxes) === null || ref2 === void 0 ? void 0 : ref2[0]) !== null && ref3 !== void 0 ? ref3 : [];
    } catch (err) {
        return [];
    }
};



/***/ }),

/***/ 55938:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9473);
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19514);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96301);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _store_features_favoritesSlice__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7737);
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(91296);
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(lodash_debounce__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _components_Shared_UtilityWidgets_v1_UtilityWidgets_module_scss__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(84181);
/* harmony import */ var _components_Shared_UtilityWidgets_v1_UtilityWidgets_module_scss__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(_components_Shared_UtilityWidgets_v1_UtilityWidgets_module_scss__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(55760);
/* harmony import */ var _store_features_productListSlice__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(49682);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _store_features_authSlice__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(24899);
/* harmony import */ var _utils_product__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(29843);
/* harmony import */ var _utils___WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(20558);
/* harmony import */ var _hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(2595);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var react_device_detect__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(85518);


















const SearchPanel = next_dynamic__WEBPACK_IMPORTED_MODULE_10___default()(()=>Promise.all(/* import() */[__webpack_require__.e(8787), __webpack_require__.e(1976), __webpack_require__.e(6828), __webpack_require__.e(9562), __webpack_require__.e(3156)]).then(__webpack_require__.bind(__webpack_require__, 46218)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(46218)
            ]
    }
});
const UtilityWidgets = (props)=>{
    var ref;
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_15__.useRouter)();
    let analyticsEventData = {};
    const { columnClassNames , data , showSearchBar , handleSearchClick  } = props;
    const { isAuth  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(_store_features_authSlice__WEBPACK_IMPORTED_MODULE_11__/* .selectAuthState */ ._9);
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useDispatch */ .I0)();
    const persona = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_8__/* .getUserPersona */ .shu)();
    const isSsr = (0,_hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)();
    const currencySign = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)("");
    const currencyCode = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)("");
    const searchPagePath = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)("");
    const knowledgeArticleUrl = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)("");
    // const [showSearchBar, setShowSearchBar] = useState(false)
    const [selectedData, setSelectedData] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({});
    const [searchString, setSearchString] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    var ref1;
    const [searchHistory, setSearchHistory] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)((ref1 = JSON.parse(localStorage.getItem("keyWordList"))) !== null && ref1 !== void 0 ? ref1 : []);
    const [brandName, setBrandName] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("kohler");
    const [prevSearch, setPrevSearch] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [searchTotal, setSearchTotal] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0);
    const [searchProfileTotal, setSearchProfileTotal] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0);
    const [topSuggestedData, setTopSuggestedData] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [isCTAClicked, setIsCTAClicked] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [redirectUrl, setRedirectUrl] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [category, setCategory] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [tilesData, setTilesData] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const [productsLoaded, setProductsLoaded] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [xfLink, setXfLink] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [promoLayout, setPromoLayout] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("one-column");
    const [isGlobalConfigBlank, setIsGlobalConfigBlank] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true);
    const [fusionFullCatalogResponse, setFusioFullCatalognResponse] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const [isSterling, setIsSterling] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [redirectTileToKohelerPLP, setRedirectTileToKohelerPLP] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const selectedFavoritesState = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(_store_features_favoritesSlice__WEBPACK_IMPORTED_MODULE_6__/* .selectFavoritesState */ .Qx);
    const { favorites  } = selectedFavoritesState || {};
    const { lineItems =[]  } = favorites || {};
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (showSearchBar) {
            var ref;
            setSearchHistory((ref = JSON.parse(localStorage.getItem("keyWordList"))) !== null && ref !== void 0 ? ref : []);
        }
    }, [
        showSearchBar
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (isGlobalConfigBlank) {
            (0,_constants_config__WEBPACK_IMPORTED_MODULE_3__/* .getConfig */ .i)().then(async (config)=>{
                let blankConfig = false;
                if (!(config && Object.keys(config).length > 1)) {
                    blankConfig = true;
                    setIsGlobalConfigBlank(true);
                }
                if (!blankConfig) {
                    setIsGlobalConfigBlank(false);
                    const vbrandName = await lodash_get__WEBPACK_IMPORTED_MODULE_5___default()(config, "general.siteName", "");
                    if (vbrandName) {
                        setBrandName(vbrandName);
                    }
                    currencySign.current = lodash_get__WEBPACK_IMPORTED_MODULE_5___default()(config, "internationalization.currencySign", "");
                    currencyCode.current = await lodash_get__WEBPACK_IMPORTED_MODULE_5___default()(config, "internationalization.currencyCode", "");
                    knowledgeArticleUrl.current = await (0,_utils_helper__WEBPACK_IMPORTED_MODULE_8__/* .getShortenedUrl */ .Ppy)(lodash_get__WEBPACK_IMPORTED_MODULE_5___default()(config, "general.knowledgeArticlePath", ""));
                    searchPagePath.current = await (0,_utils_helper__WEBPACK_IMPORTED_MODULE_8__/* .getShortenedUrl */ .Ppy)(lodash_get__WEBPACK_IMPORTED_MODULE_5___default()(config, "general.searchPagePath", ""));
                    setRedirectTileToKohelerPLP(await (0,_utils_helper__WEBPACK_IMPORTED_MODULE_8__/* .getShortenedUrl */ .Ppy)(lodash_get__WEBPACK_IMPORTED_MODULE_5___default()(config, "general.searchPagePath", "")));
                }
            }).catch((error)=>{
                console.log(error);
            });
        }
    }, [
        isSsr,
        isGlobalConfigBlank
    ]);
    const getEventInfoObj = (searchString, status, message, internalLinkURL, eventType, isserachButton, topSuggestedData)=>{
        var ref;
        const currDate = new Date();
        const contentType = window.eventPageType || "";
        const pageName = contentType === "homepage" ? "home" : contentType && contentType.split("-")[0] || "";
        const searchSuggestedTerm = [];
        if (!analyticsEventData.searchString) {
            analyticsEventData.searchString = searchString;
        }
        if (!analyticsEventData.searchTotal) {
            analyticsEventData.searchTotal = searchTotal;
        }
        if (!analyticsEventData.topSuggestedData) {
            analyticsEventData.topSuggestedData = topSuggestedData;
        }
        const searchSuggestions = searchHistory && searchHistory.length ? searchHistory : analyticsEventData.topSuggestedData && analyticsEventData.topSuggestedData.length ? analyticsEventData.topSuggestedData : [];
        if (searchSuggestions === null || searchSuggestions === void 0 ? void 0 : searchSuggestions.length) {
            searchSuggestions.slice(0, 5).map((item)=>{
                searchSuggestedTerm.push((0,_utils_helper__WEBPACK_IMPORTED_MODULE_8__/* .sanitizeTextForAnalytics */ .T68)(item.productName_s || item.keyWord));
            });
        }
        const eventseachName = isserachButton ? "internal search" : "internal automatic search";
        const names = topSuggestedData ? topSuggestedData === null || topSuggestedData === void 0 ? void 0 : topSuggestedData.filter((obj)=>"productName_s" in obj).map(function(obj) {
            return obj["productName_s"];
        }) : null;
        const topsuggestions = names ? (ref = names === null || names === void 0 ? void 0 : names.join("|")) === null || ref === void 0 ? void 0 : ref.toLowerCase() : null;
        const eventInfo = {
            eventName: eventseachName,
            eventAction: eventseachName,
            internalLinkName: "internal search icon",
            internalLinkType: "global header:navigation",
            internalLinkZoneName: "global header",
            clickInternalLinks: "true",
            eventType: "global header",
            internalLinkURL: internalLinkURL ? (internalLinkURL.indexOf("http") === -1 ? window.location.origin : "") + internalLinkURL : "n/a",
            internalLinkPosition: "global header",
            eventMsg: status !== "success" ? message === null || message === void 0 ? void 0 : message.toLowerCase() : "n/a",
            eventStatus: status || "n/a",
            searchTerm: analyticsEventData.searchString,
            searchContentType: pageName ? pageName + " page" : "n/a",
            searchSuggestedTerm: topsuggestions ? topsuggestions : "n/a",
            searchCount: sessionStorage.getItem("searches") ? Number(sessionStorage.getItem("searches")) + 1 : 1,
            searchResult: analyticsEventData.searchTotal,
            internalZoneName: "search:search box",
            pageURL: window.location.href,
            referrer: document.referrer || "n/a",
            previousPage: document.referrer || "n/a",
            timeStamp: currDate.toISOString().split("T")[0] + " " + currDate.toTimeString().split(" ")[0],
            contentType: brandName === null || brandName === void 0 ? void 0 : brandName.toLowerCase()
        };
        if (eventType === null || eventType === void 0 ? void 0 : eventType.type) {
            eventType.term = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_8__/* .sanitizeTextForAnalytics */ .T68)(eventType.term);
            eventType.type = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_8__/* .sanitizeTextForAnalytics */ .T68)(eventType.type);
            eventInfo.eventName = "search:" + eventType.type + ":search term";
            eventInfo.eventAction = "search:" + eventType.type + ":search term";
            eventInfo.internalLinkZoneName = "search:" + eventType.type;
            if (eventType.type === "top suggestions") {
                var ref1;
                eventInfo.searchTerm = (ref1 = analyticsEventData.searchString) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase();
                eventInfo.searchSuggestedTerm = eventType.term;
            } else {
                eventInfo.searchTerm = eventType.term;
            }
            eventInfo.internalLinkName = eventType.term;
            eventInfo.internalZoneName = "search:" + eventType.type;
        }
        analyticsEventData = {};
        return eventInfo;
    };
    const handleSearchAnalyticsEvent = (searchString, status, message, internalLinkURL, eventType, isserachButton, topSuggestedData)=>{
        if (!internalLinkURL) internalLinkURL = redirectUrl;
        const eventInfo = getEventInfoObj(searchString, status, message, internalLinkURL, eventType, isserachButton, topSuggestedData);
        sessionStorage.setItem("searches", eventInfo.searchCount);
        const { adobeDataLayer: { getState  } = {}  } = window;
        const page = getState && getState("page") || {};
        window.adobeDataLayer.push({
            event: "cmp:click",
            page,
            eventInfo
        });
    };
    const handleRedirect = (searchTerm, isAnalyticsClick, analyticsEventType, isserachButton, topSuggestedData)=>{
        setProductsLoaded(false);
        setIsCTAClicked(true);
        if (redirectUrl) {
            isAnalyticsClick && handleSearchAnalyticsEvent(searchTerm, "success", null, null, analyticsEventType);
            window.location.href = redirectUrl;
            setRedirectUrl("");
        } else {
            var ref;
            let history = (ref = JSON.parse(window.localStorage.getItem("keyWordList"))) !== null && ref !== void 0 ? ref : [];
            history = history.filter((item)=>item.keyWord.toLowerCase() !== searchTerm.toLowerCase());
            history.unshift({
                keyWord: searchTerm,
                id: Date.now()
            });
            window.localStorage.setItem("keyWordList", JSON.stringify(history));
            dispatch((0,_store_features_productListSlice__WEBPACK_IMPORTED_MODULE_9__/* .profileBrandSearch */ .R$)([
                searchTerm.trim(),
                brandName.toLowerCase(),
                "sku_s, slug_s, url_s, variantList.sku_ss, Product_Category",
                1,
                ""
            ])).then(async (res)=>{
                if (res.payload) {
                    let redirectLink = "";
                    // redirect if redirect URL is configured in LW for search keyword
                    if (res.payload.fusion && res.payload.fusion.redirect && res.payload.fusion.redirect[0]) {
                        redirectLink = res.payload.fusion.redirect[0];
                        if (isAnalyticsClick) {
                            searchTerm !== searchString // do not fire same events for unchanged search string
                             ? handleSearchAnalyticsEvent(searchTerm, "success", null, redirectLink, analyticsEventType) : handleSearchAnalyticsEvent(searchTerm, "success", null, redirectLink, analyticsEventType, isserachButton, topSuggestedData);
                        }
                        window.location.href = redirectLink;
                    } else if (res.payload.response.numFound === 1 && res.payload.fusion.exactMatch) {
                        const d = res.payload.response.docs[0];
                        if (d.slug_s) {
                            const param = d.sku_s ? "skuId=".concat(d.sku_s) : "";
                            const pdpUrl = await (0,_utils_helper__WEBPACK_IMPORTED_MODULE_8__/* .getPDPUrl */ .ir5)(d.Product_Category, d.slug_s);
                            redirectLink = (0,_utils___WEBPACK_IMPORTED_MODULE_13__/* .getPdpRedirectUrl */ .Om)(pdpUrl, param);
                        } else if (d.url_s) {
                            redirectLink = d.url_s;
                        }
                        isAnalyticsClick && searchTerm !== searchString && // do not fire same events for unchanged search string
                        handleSearchAnalyticsEvent(searchTerm, "success", null, redirectLink, analyticsEventType);
                        window.location.href = redirectLink;
                    } else if (res.payload.fusion.partsCount === 1 && res.payload.fusion.partsExactMatch) {
                        const d1 = res.payload.fusion.partsDocs[0];
                        if (d1.slug_s) {
                            const param1 = d1.sku_s ? "skuId=".concat(d1.sku_s) : "";
                            const pdpUrl1 = await (0,_utils_helper__WEBPACK_IMPORTED_MODULE_8__/* .getPDPUrl */ .ir5)(null, d1.slug_s);
                            redirectLink = (0,_utils___WEBPACK_IMPORTED_MODULE_13__/* .getPdpRedirectUrl */ .Om)(pdpUrl1, param1);
                        } else if (d1.url_s) {
                            redirectLink = d1.url_s;
                        }
                        isAnalyticsClick && searchTerm !== searchString && // do not fire same events for unchanged search string
                        handleSearchAnalyticsEvent(searchTerm, "success", null, redirectLink, analyticsEventType);
                        window.location.href = redirectLink;
                    } else {
                        redirectLink = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_8__/* .sanitizeUrl */ .Nmg)(window.location.origin + (0,_utils_helper__WEBPACK_IMPORTED_MODULE_8__/* .removeAndCleanLink */ .xEh)(searchPagePath.current) + "?keyword=".concat(searchTerm.trim()));
                        if (isAnalyticsClick) {
                            searchTerm !== searchString // do not fire same events for unchanged search string
                             ? handleSearchAnalyticsEvent(searchTerm, "success", null, redirectLink, analyticsEventType) : handleSearchAnalyticsEvent(searchTerm, "success", null, redirectLink, analyticsEventType, isserachButton, topSuggestedData);
                        }
                        window.location.href = redirectLink;
                    }
                }
            // setProductsLoaded(true)
            }).catch((err)=>{
                console.log("Error occured while fetching Search data", err);
                isAnalyticsClick && handleSearchAnalyticsEvent(searchTerm, "failure", "error occured while fetching search data", null, analyticsEventType);
                setProductsLoaded(true);
            });
        }
    };
    const handleDelete = (id)=>{
        var ref;
        let history = (ref = JSON.parse(window.localStorage.getItem("keyWordList"))) !== null && ref !== void 0 ? ref : [];
        history = history.filter((item)=>item.id !== id);
        window.localStorage.setItem("keyWordList", JSON.stringify(history));
        setSearchHistory(history);
    };
    const handleClearAll = ()=>{
        localStorage.removeItem("keyWordList");
        setSearchHistory([]);
    };
    const handleChange = (searchTerm)=>{
        setProductsLoaded(false);
        setSearchString(searchTerm.trim());
    };
    const searchingDebounced = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(lodash_debounce__WEBPACK_IMPORTED_MODULE_7___default()(function() {
        let searchStr = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
        return getData(searchStr);
    }, 300), [
        prevSearch
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (brandName) {
            searchString.length >= 3 ? (setPrevSearch(searchString), searchingDebounced(searchString)) : setSearchTotal(0);
            setProductsLoaded(false);
        }
        return ()=>{
            searchingDebounced.cancel();
        };
    }, [
        searchString,
        brandName,
        searchingDebounced
    ]);
    const executeTypeaheadApi = function() {
        let searchStr = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", brand = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
        dispatch((0,_store_features_productListSlice__WEBPACK_IMPORTED_MODULE_9__/* .profileBrandTypeahead */ .zw)([
            searchStr.trim(),
            brand.toLowerCase()
        ])).unwrap().then((res)=>{
            const { response: { docs =[]  } = {}  } = res;
            docs.length && setTopSuggestedData(docs);
        });
    };
    const getData = function() {
        let searchStr = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
        const { disableParts  } = data;
        if (redirectUrl) setRedirectUrl("");
        if (!isCTAClicked && searchStr.length >= 3) {
            executeTypeaheadApi(searchStr, brandName);
            dispatch((0,_store_features_productListSlice__WEBPACK_IMPORTED_MODULE_9__/* .profileBrandSearch */ .R$)([
                searchStr.trim(),
                brandName.toLowerCase(),
                "sku_s, slug_s, url_s, variantList.sku_ss, Product_Category",
                1,
                ""
            ])).then(async (res)=>{
                if (res.payload) {
                    // get PDP / article URL if only 1 result
                    if (res.payload.response.numFound === 1 && res.payload.fusion.exactMatch) {
                        const d = res.payload.response.docs[0];
                        if (d.slug_s) {
                            const param = d.sku_s ? "skuId=".concat(d.sku_s) : "";
                            const pdpUrl = await (0,_utils_helper__WEBPACK_IMPORTED_MODULE_8__/* .getPDPUrl */ .ir5)(d.Product_Category, d.slug_s);
                            setRedirectUrl((0,_utils___WEBPACK_IMPORTED_MODULE_13__/* .getPdpRedirectUrl */ .Om)(pdpUrl, param));
                        } else if (d.url_s) {
                            setRedirectUrl(d.url_s);
                        }
                    } else if (res.payload.fusion.partsCount === 1 && res.payload.fusion.partsExactMatch) {
                        const d1 = res.payload.fusion.partsDocs[0];
                        if (d1.slug_s) {
                            const param1 = d1.sku_s ? "skuId=".concat(d1.sku_s) : "";
                            const pdpUrl1 = await (0,_utils_helper__WEBPACK_IMPORTED_MODULE_8__/* .getPDPUrl */ .ir5)(null, d1.slug_s);
                            setRedirectUrl((0,_utils___WEBPACK_IMPORTED_MODULE_13__/* .getPdpRedirectUrl */ .Om)(pdpUrl1, param1));
                        }
                    }
                    setSearchProfileTotal(res.payload.response.numFound);
                    let groups = [
                        {
                            key: "products",
                            fq: 'Products:("ct")',
                            count: lodash_get__WEBPACK_IMPORTED_MODULE_5___default()(res.payload, "facet_counts.facet_fields.Products[1]", 0)
                        },
                        {
                            key: "parts",
                            count: lodash_get__WEBPACK_IMPORTED_MODULE_5___default()(res.payload.fusion.partsCount, "res.payload.fusion.partsCount", 0)
                        },
                        {
                            key: "technical",
                            fq: 'Technical:("ct")',
                            count: lodash_get__WEBPACK_IMPORTED_MODULE_5___default()(res.payload, "facet_counts.facet_fields.Technical[1]", 0)
                        },
                        {
                            key: "inspiration",
                            fq: 'Inspiration:("Inspiration")',
                            count: lodash_get__WEBPACK_IMPORTED_MODULE_5___default()(res.payload, "facet_counts.facet_fields.Inspiration[1]", 0)
                        },
                        {
                            key: "resource",
                            fq: 'Resource:("Resource")',
                            count: lodash_get__WEBPACK_IMPORTED_MODULE_5___default()(res.payload, "facet_counts.facet_fields.Resource[1]", 0)
                        },
                        {
                            key: "help",
                            fq: 'Help:("sf")',
                            count: lodash_get__WEBPACK_IMPORTED_MODULE_5___default()(res.payload, "facet_counts.facet_fields.Help[1]", 0)
                        }
                    ];
                    if (disableParts) {
                        groups = groups.filter((arr)=>{
                            return arr.key !== "parts";
                        });
                    }
                    // Calculating the total results
                    let total = 0;
                    const selected = groups.find((group)=>group.count > 0);
                    if (res.payload.fusion.exactMatch || res.payload.fusion.partsExactMatch) {
                        total = selected.key === "parts" ? res.payload.response.numFound : res.payload.fusion.partsCount;
                    } else {
                        groups.forEach((group)=>total += group.count);
                    }
                    analyticsEventData.searchTotal = total;
                    analyticsEventData.redirectUrl = redirectUrl;
                    analyticsEventData.topSuggestedData = {
                        ...topSuggestedData
                    };
                    analyticsEventData.selectedData = selected;
                    analyticsEventData.searchString = searchStr.trim();
                    setSearchTotal(total);
                    setRedirectUrl(redirectUrl);
                    const fullCatalogResponse = lodash_get__WEBPACK_IMPORTED_MODULE_5___default()(res.payload, "fusion.full_catalog_Response", []);
                    if (fullCatalogResponse.length > 0) {
                        setIsSterling(true);
                        setSearchTotal(1);
                        setTopSuggestedData(fullCatalogResponse);
                    }
                    setFusioFullCatalognResponse(fullCatalogResponse);
                    handleSearchAnalyticsEvent(searchStr, "success");
                    setSelectedData(selected);
                }
            }).catch((err)=>{
                setProductsLoaded(true);
                console.error("Error occured while fetching Search data", err);
            });
        } else {
            setSearchTotal(0);
            setCategory("");
            setTilesData([]);
            setRedirectUrl("");
            setTopSuggestedData([]);
            setSearchProfileTotal(0);
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (searchTotal > 0 && selectedData.key) {
            getTilesData(selectedData);
        }
    }, [
        searchTotal,
        selectedData
    ]);
    const getTilesData = (selected)=>{
        const fl = [
            "id",
            "sku_s",
            "slug_s",
            "metaTitle_s",
            "productName_s",
            "masterSKU_s",
            "masterCustomerFacingSKU_s",
            "Product_Category",
            "ProductBrandName_s",
            "productImages.url_ss",
            "displayPriceStartingAt_s",
            "SKUColorSwatchFilename_ss",
            "ProductDescriptionProductShort_s",
            "url_s",
            "urlName_s",
            "title_s",
            "pageTitle_s",
            "eyeBrowText_s",
            "templateType_s",
            "thumbNailImage_s",
            "searchDescription_s",
            "layoutItems.Article_Type__c.value_s",
            "layoutItems.KM_Article_Content__c.value_s",
            "layoutItems.KBNA_3C_Image_Video__c.label_s",
            "layoutItems.KBNA_3C_Image_Video__c.value_s",
            "priceList.".concat(persona, ".price_d"),
            "priceList.".concat(persona, ".finalPrice_d"),
            "priceList.".concat(persona, ".discountedPrice_d"),
            "priceList.".concat(persona, ".saleOffer_s"),
            "priceStartingAt.".concat(persona, "_d"),
            "discountedPriceStartingAt.".concat(persona, "_d"),
            "Color.SKU.Details_ss",
            "Color.".concat(persona, ".Details_ss"),
            "ProductIsExclusive_s",
            "RegionReleaseforShipment_dt",
            "productImages.labelWithUrl_ss",
            "variantList.sku_ss",
            "RegionOnBackOrder_s",
            "RegionBrandName_s",
            "ctId_s",
            "primaryBundleSKU_s"
        ];
        setXfLink("");
        setPromoLayout("one-column");
        setCategory("");
        setTilesData([]);
        dispatch(selected.key === "parts" ? (0,_store_features_productListSlice__WEBPACK_IMPORTED_MODULE_9__/* .profileServicePartsSearch */ .n7)([
            searchString.trim(),
            fl.join(","),
            6
        ]) : (0,_store_features_productListSlice__WEBPACK_IMPORTED_MODULE_9__/* .profileBrandSearch */ .R$)([
            searchString.trim(),
            brandName.toLowerCase(),
            fl.join(","),
            6,
            selected.fq
        ])).then((res)=>{
            var ref;
            if (res.payload && ((ref = res.payload.response) === null || ref === void 0 ? void 0 : ref.docs)) {
                var ref1;
                setCategory(selected.key);
                setTilesData((ref1 = res.payload.response) === null || ref1 === void 0 ? void 0 : ref1.docs);
                if ((fusionFullCatalogResponse === null || fusionFullCatalogResponse === void 0 ? void 0 : fusionFullCatalogResponse.length) > 0) {
                    setTilesData(fusionFullCatalogResponse);
                }
                if (res.payload.fusion && res.payload.fusion.experiment_fragments && res.payload.fusion.experiment_fragments !== undefined) {
                    var ref2, ref3, ref4, ref5;
                    var ref6;
                    setPromoLayout((ref6 = (ref3 = (ref2 = res.payload.fusion) === null || ref2 === void 0 ? void 0 : ref2.experiment_fragments[0]) === null || ref3 === void 0 ? void 0 : ref3.promoLayout_s) !== null && ref6 !== void 0 ? ref6 : "one-column");
                    var ref7;
                    setXfLink((ref7 = (ref5 = (ref4 = res.payload.fusion) === null || ref4 === void 0 ? void 0 : ref4.experiment_fragments[0]) === null || ref5 === void 0 ? void 0 : ref5.url_s) !== null && ref7 !== void 0 ? ref7 : "");
                }
            }
            setProductsLoaded(true);
        });
    };
    const bodyRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(document.body);
    const htmlRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(document.getElementsByTagName("html")[0]);
    const handleToggle = ()=>{
        var ref;
        showSearchBar ? (0,_utils_helper__WEBPACK_IMPORTED_MODULE_8__/* .addMavenoidChat */ .dVG)() : react_device_detect__WEBPACK_IMPORTED_MODULE_16__/* .isMobile */ .tq ? (0,_utils_helper__WEBPACK_IMPORTED_MODULE_8__/* .removeMavenoidChat */ .N9B)() : (0,_utils_helper__WEBPACK_IMPORTED_MODULE_8__/* .addMavenoidChat */ .dVG)();
        setSearchString("");
        setSearchTotal(0);
        const classNames = [
            "searchbar-open",
            "scroll-lock"
        ];
        classNames.map((className)=>{
            var ref, ref1;
            return bodyRef === null || bodyRef === void 0 ? void 0 : (ref = bodyRef.current) === null || ref === void 0 ? void 0 : (ref1 = ref.classList) === null || ref1 === void 0 ? void 0 : ref1.toggle(className);
        });
        classNames.map((className)=>{
            var ref, ref1;
            return htmlRef === null || htmlRef === void 0 ? void 0 : (ref = htmlRef.current) === null || ref === void 0 ? void 0 : (ref1 = ref.classList) === null || ref1 === void 0 ? void 0 : ref1.toggle(className);
        });
        handleSearchClick(!showSearchBar);
        const page = window.pageObj || {};
        const previousPageNameForSearch = page === null || page === void 0 ? void 0 : (ref = page.pageInfo) === null || ref === void 0 ? void 0 : ref.pageName;
        sessionStorage.setItem("previousPageNameForSearch", previousPageNameForSearch);
    };
    const handleLogin = (e)=>{
        e.preventDefault();
        isAuth ? router.push("/en/my-account/my-favorites") : dispatch((0,_store_features_authSlice__WEBPACK_IMPORTED_MODULE_11__/* .setAuthModalVisibility */ .LY)({
            show: true
        }));
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_components_Shared_UtilityWidgets_v1_UtilityWidgets_module_scss__WEBPACK_IMPORTED_MODULE_17___default().utilityWidgetsWrapper),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "utilitywidgets ".concat(columnClassNames ? columnClassNames : ""),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                role: "list",
                className: "utility-widgets",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        role: "listitem",
                        className: "search-widget",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            children: showSearchBar && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SearchPanel, {
                                showSearchBar: showSearchBar,
                                onToggle: handleToggle,
                                onRedirect: handleRedirect,
                                onChange: handleChange,
                                searchString: searchString,
                                brand: brandName,
                                searchTotal: searchTotal,
                                topSuggestedData: topSuggestedData,
                                searchHistory: searchHistory,
                                xfLink: xfLink,
                                category: category,
                                removeFromCompare: _utils_product__WEBPACK_IMPORTED_MODULE_12__/* .removeFromCompareProduct */ .Zj,
                                addToCompare: _utils_product__WEBPACK_IMPORTED_MODULE_12__/* .addToCompareProduct */ .dX,
                                tilesData: tilesData,
                                productsLoaded: productsLoaded,
                                promoLayout: promoLayout,
                                favorites: (ref = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_8__/* .getFavouraties */ .MqV)()) === null || ref === void 0 ? void 0 : ref.lineItems,
                                comparedProducts: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_8__/* .getCompareData */ .p2C)(),
                                currencySign: currencySign.current,
                                knowledgeArticleUrl: knowledgeArticleUrl.current,
                                presetConfigs: data.presetConfigs,
                                onDelete: handleDelete,
                                onClearAll: handleClearAll,
                                isSterling: isSterling,
                                sterlingData: fusionFullCatalogResponse,
                                parent: "Utility Widgets",
                                searchPagePath: redirectTileToKohelerPLP,
                                searchProfileTotal: searchProfileTotal
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        role: "listitem",
                        className: "wishlist-widget d-lg-none",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            "aria-label": "View your wishlist",
                            className: "gbh-data-layer",
                            onClick: handleLogin,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                "aria-hidden": "true",
                                alt: "Wishlist",
                                src: lineItems && lineItems.length > 0 ? _constants__WEBPACK_IMPORTED_MODULE_4__.FULL_FAVORITE_BASE64 : _constants__WEBPACK_IMPORTED_MODULE_4__.EMPTY_FAVORITE_BASE64
                            })
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (UtilityWidgets);


/***/ }),

/***/ 59362:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C2": function() { return /* binding */ addAnalyticsEventForImageTitle; },
/* harmony export */   "I8": function() { return /* binding */ dataLayershopTheRoomPlusButton; },
/* harmony export */   "Xc": function() { return /* binding */ addAnalyticsEventForFavouriteAddRemove; },
/* harmony export */   "dv": function() { return /* binding */ shopRoomhandleProductClick; },
/* harmony export */   "i2": function() { return /* binding */ addAnalyticsEventForPrevNext; },
/* harmony export */   "vf": function() { return /* binding */ closeButtonAnalytics; }
/* harmony export */ });
/* unused harmony export addAnalyticsEventForProductInfo */
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _components_productCard_v3_productCardHelper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38560);


const pushToAdobeDataLayer = (eventInfo, productInfo)=>{
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = (getState === null || getState === void 0 ? void 0 : getState("page")) || {};
    window.adobeDataLayer.push({
        event: "cmp:click",
        eventInfo,
        ...productInfo ? {
            productInfo
        } : {},
        page
    });
};
const dataLayershopTheRoomPlusButton = (cardTitle, url)=>{
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "shop the room:".concat(cardTitle.toLowerCase(), ":room detail card modal open"),
        eventName: "shop the room:".concat(cardTitle.toLowerCase(), ":room detail card modal open"),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "room detail card modal open",
        internalLinkPosition: "shop the room",
        internalLinkType: "shop the room:".concat(cardTitle.toLowerCase(), ":room detail card modal open"),
        internalLinkZoneName: "shop the room:all rooms",
        internalLinkURL: url
    };
    pushToAdobeDataLayer(eventInfo);
};
const addAnalyticsEventForPrevNext = (navigationType)=>{
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "shop the room: room detail card modal:".concat(navigationType.toLowerCase(), " arrow"),
        eventName: "shop the room: room detail card modal:".concat(navigationType.toLowerCase(), " arrow"),
        eventType: "carousel",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "".concat(navigationType.toLowerCase(), " arrow"),
        internalLinkPosition: "shop the room: room detail card modal:carousel",
        internalLinkType: "shop the room: room detail card modal:classic glam room details",
        internalLinkZoneName: "shop the room: room detail card modal: shop products in this room",
        internalLinkURL: "n/a"
    };
    pushToAdobeDataLayer(eventInfo);
};
const addAnalyticsEventForImageTitle = (cardTitle, url)=>{
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "shop the room: room detail card modal:".concat(cardTitle.toLowerCase()),
        eventName: "shop the room: room detail card modal:".concat(cardTitle.toLowerCase()),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "".concat(cardTitle.toLowerCase()),
        internalLinkPosition: "room detail card modal",
        internalLinkType: "shop the room: room detail card modal:".concat(cardTitle.toLowerCase()),
        internalLinkZoneName: "shop the room: room detail card modal",
        internalLinkURL: url
    };
    pushToAdobeDataLayer(eventInfo);
};
const addAnalyticsEventForFavouriteAddRemove = (favouriteType, productInfo)=>{
    const favoriteText = favouriteType ? "add" : "remove";
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "shop the room: room detail card modal: favorite ".concat(favoriteText.toLowerCase()),
        eventMsg: "your item has been ".concat(favoriteText.toLowerCase(), " to your Favorites"),
        eventName: "shop the room: room detail card modal: favorite ".concat(favoriteText.toLowerCase()),
        eventType: "wishlist save",
        eventStatus: "sucess",
        internalLinkName: "favorite ".concat(favoriteText.toLowerCase()),
        internalLinkPosition: "shop the room: room detail card modal",
        internalLinkType: "shop the room: room detail card modal: favorite",
        internalLinkZoneName: "shop the room: room detail card modal",
        internalLinkURL: "n/a"
    };
    pushToAdobeDataLayer(eventInfo, productInfo);
};
const closeButtonAnalytics = ()=>{
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "shop the room: room detail card modal:close button",
        eventName: "shop the room: room detail card modal:close button",
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "close",
        internalLinkPosition: "shop the room: room detail card modal",
        internalLinkType: "shop the room: room detail card modal :close",
        internalLinkZoneName: "shop the room: room detail card modal:navigation",
        internalLinkURL: "n/a"
    };
    pushToAdobeDataLayer(eventInfo);
};
const addAnalyticsEventForProductInfo = (eventInfo, productInfo)=>{
    pushToAdobeDataLayer(eventInfo, productInfo);
};
const shopRoomhandleProductClick = (productInfoParams)=>{
    const { productData , sku , url , cart , config , description , persona  } = productInfoParams;
    const productInfo = (0,_components_productCard_v3_productCardHelper__WEBPACK_IMPORTED_MODULE_1__/* .getProductInfo */ .C)(productData, sku, false, cart, config, description, persona);
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "shop the room: room detail card modal: product navigation",
        eventMsg: "n/a",
        eventName: "shop the room: room detail card modal: product navigation",
        eventStatus: "n/a",
        eventType: "navigation",
        internalLinkName: lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(productData, "RegionBrandName_s", ""),
        internalLinkPosition: "shop the room: room detail card modal",
        internalLinkType: "shop the room: room detail card modal: navigation",
        internalLinkURL: url,
        internalLinkZoneName: "shop the room: room detail card modal"
    };
    addAnalyticsEventForProductInfo(eventInfo, productInfo);
};



/***/ }),

/***/ 75781:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55760);
/* harmony import */ var _components_ShopTheRoomCard_analytics__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59362);





const DynamicImage = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(()=>Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 18377)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(18377)
            ]
    }
});
const Modal = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(()=>Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 78145)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(78145)
            ]
    }
});
const ShopTheRoomCardModalView = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(()=>Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 90746)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(90746)
            ]
    }
});
const ShopTheRoomCard = (props)=>{
    const { cardTitle ="" , cardHoverTitle ="" , ctalink ="" , landingImageLink ="" , modelImageLink ="" , skuIds =[] , presetConfigs ="{}" , altLanding ="" , altModel ="" , linkNewTab =false  } = props;
    const [showModal, setShowModalState] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [isHover, setIsHover] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [link, setLink] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [isImageLoaded, setImageLoaded] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        setImageLoaded(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DynamicImage, {
            imgUrl: landingImageLink,
            alt: altLanding,
            width: "100%",
            style: {
                aspectRatio: "1.333/1"
            }
        }));
    }, [
        landingImageLink
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (ctalink) {
            (0,_utils_helper__WEBPACK_IMPORTED_MODULE_3__/* .getShortenedUrl */ .Ppy)(ctalink).then((link)=>setLink(link));
        }
    }, [
        ctalink
    ]);
    const handleModal = (e)=>{
        e.stopPropagation();
        setShowModalState(!showModal);
        (0,_components_ShopTheRoomCard_analytics__WEBPACK_IMPORTED_MODULE_4__/* .dataLayershopTheRoomPlusButton */ .I8)(cardTitle);
    };
    const handleCloseModal = (e)=>{
        e.stopPropagation();
        setShowModalState(!showModal);
        (0,_components_ShopTheRoomCard_analytics__WEBPACK_IMPORTED_MODULE_4__/* .closeButtonAnalytics */ .vf)();
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "shoptheroomcard",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "shop-the-room-card-container",
            style: isImageLoaded ? {} : {
                height: "66%"
            },
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "shop-the-room-card",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: link,
                            onMouseEnter: ()=>setIsHover(true),
                            onMouseLeave: ()=>setIsHover(false),
                            target: linkNewTab ? "_blank" : "",
                            rel: "noreferrer",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "shop-the-room-card-clip",
                                children: [
                                    isImageLoaded ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                        children: isImageLoaded
                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "product-tile",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "product-list-tile__image wow",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "shimmer-loading__image shimmer"
                                            })
                                        })
                                    }),
                                    isHover ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "shop-the-room-card-hover-text",
                                        children: cardHoverTitle
                                    }) : null
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "plus",
                            onClick: handleModal,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "line line-1"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "line line-2"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "shop-the-room-card-modal",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Modal, {
                        showModal: showModal,
                        onModalClose: handleCloseModal,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ShopTheRoomCardModalView, {
                            skuIds: skuIds,
                            presetConfigs: presetConfigs,
                            imageLink: modelImageLink,
                            cardTitle: cardTitle,
                            ctalink: ctalink,
                            altModel: altModel
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "shop-card-title",
                    children: cardTitle
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (ShopTheRoomCard);


/***/ }),

/***/ 90746:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24400);
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23279);
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash_debounce__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96301);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(55760);
/* harmony import */ var _components_ShopTheRoomCard_analytics__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(59362);
/* harmony import */ var _components_core_Image_DynamicImage__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(18377);
/* harmony import */ var _components_productCard_v3_ProductCard__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(44685);









const ShopTheRoomCardModalView = (param)=>{
    let { skuIds =[] , presetConfigs ="{}" , imageLink ="" , cardTitle ="" , ctalink ="" , isModal =true , altModel ="" , selectedProduct ="" , hotspotClicked =false , setHotspotClicked =()=>{} , invokedFrom ="button" , setInvokedFrom =()=>{} , enableFavorite =false  } = param;
    var ref;
    const { t  } = (0,next_i18next__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)("common");
    const selectedIndex = skuIds.indexOf(selectedProduct);
    const [visibleSkuIdsObj, setVisibleSKuIds] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        currentPageSkus: [
            skuIds[0]
        ],
        visibleQuantity: 1,
        firstIndex: 0,
        isLeftDisabled: true,
        isRightDisabled: false
    });
    const [shopTheRoomLink, setShopTheRoomLink] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const productCardContainerRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const productCardRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    let localVisibleQuantity = visibleSkuIdsObj.visibleQuantity;
    let localInnerWidth = window.innerWidth;
    const staticTexts = {
        title: t("kf.shoptheroom.modal.text")
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        updateVisibleSkuIdsObject(true);
        window.addEventListener("resize", handleOnResize);
        return ()=>{
            window.removeEventListener("resize", handleOnResize);
        };
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (ctalink) {
            (0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__/* .getShortenedUrl */ .Ppy)(ctalink).then((link)=>setShopTheRoomLink(link));
        }
    }, [
        ctalink
    ]);
    const handleOnResize = lodash_debounce__WEBPACK_IMPORTED_MODULE_3___default()(()=>{
        var ref;
        if (((ref = productCardContainerRef.current) === null || ref === void 0 ? void 0 : ref.clientWidth) > productCardRef.current.clientWidth * (localVisibleQuantity + 1)) {
            updateVisibleSkuIdsObject(true);
        } else if (localInnerWidth > window.innerWidth) {
            const difference = localInnerWidth - window.innerWidth;
            difference >= productCardRef.current.clientWidth && updateVisibleSkuIdsObject(false, difference);
        }
        localInnerWidth = window.innerWidth;
    }, _constants__WEBPACK_IMPORTED_MODULE_4__.MIN_DELAY);
    const updateVisibleSkuIdsObject = function(isAddItem) {
        let difference = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
        if (skuIds.length >= visibleSkuIdsObj.currentPageSkus.length) {
            const visibleSkuIdsTemp = [
                ...visibleSkuIdsObj.currentPageSkus
            ];
            let visibleQuantity1 = visibleSkuIdsTemp.length;
            const { isLeftDisabled , isRightDisabled , firstIndex  } = visibleSkuIdsObj;
            const nextSkuIds = skuIds.slice(firstIndex + 1);
            nextSkuIds.forEach((skuId, index)=>{
                var ref, ref1;
                if (((ref = productCardContainerRef.current) === null || ref === void 0 ? void 0 : ref.clientWidth) > ((ref1 = productCardRef.current) === null || ref1 === void 0 ? void 0 : ref1.clientWidth) * (index + 2)) {
                    visibleQuantity1++;
                }
                if (visibleSkuIdsTemp.findIndex((tempSkuId)=>tempSkuId === skuId) !== index) {
                    visibleSkuIdsTemp.push(skuId);
                }
            });
            if (!isAddItem) {
                var ref;
                let index = 1;
                do {
                    visibleQuantity1 = localVisibleQuantity - index;
                }while (difference > ((ref = productCardRef.current) === null || ref === void 0 ? void 0 : ref.clientWidth) * index++);
            }
            localVisibleQuantity = visibleQuantity1 <= 0 ? 1 : visibleQuantity1;
            setVisibleSKuIds({
                currentPageSkus: visibleSkuIdsTemp,
                firstIndex,
                visibleQuantity: localVisibleQuantity,
                isLeftDisabled,
                isRightDisabled
            });
        }
    };
    const handleNextPrev = (param, navigationType)=>{
        let { target: { className =""  } = {}  } = param;
        (0,_components_ShopTheRoomCard_analytics__WEBPACK_IMPORTED_MODULE_6__/* .addAnalyticsEventForPrevNext */ .i2)(navigationType);
        let firstIndex = visibleSkuIdsObj.firstIndex;
        const visibleQuantity = visibleSkuIdsObj.visibleQuantity;
        if (className === "product-card-scroll" && !visibleSkuIdsObj.isLeftDisabled) {
            firstIndex = firstIndex - visibleQuantity;
            firstIndex = firstIndex < 0 ? 0 : firstIndex;
            setVisibleSKuIds((prevObje)=>({
                    firstIndex,
                    currentPageSkus: prevObje.currentPageSkus,
                    visibleQuantity,
                    isLeftDisabled: firstIndex === 0,
                    isRightDisabled: false
                }));
        } else if (className === "product-card-scroll__right" && !visibleSkuIdsObj.isRightDisabled) {
            firstIndex = firstIndex + visibleQuantity;
            let lastIndex = firstIndex + visibleQuantity;
            lastIndex = lastIndex > skuIds.length ? skuIds.length : lastIndex;
            setVisibleSKuIds((prevObje)=>({
                    firstIndex,
                    currentPageSkus: prevObje.currentPageSkus,
                    visibleQuantity,
                    isLeftDisabled: false,
                    isRightDisabled: lastIndex === skuIds.length
                }));
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const noOfLoops = Math.abs(selectedIndex - visibleSkuIdsObj.firstIndex + visibleSkuIdsObj.visibleQuantity - 1) + 1;
        const val = selectedIndex - visibleSkuIdsObj.firstIndex;
        if (val < 0 || val > 3 && invokedFrom !== "button") {
            setInvokedFrom("");
        }
        if (selectedIndex > 0 && invokedFrom !== "button") {
            if (val > 3) {
                for(let i = 0; i < noOfLoops; i++){
                    handleNextPrev({
                        target: {
                            className: "product-card-scroll__right"
                        }
                    }, "right");
                }
                setHotspotClicked(!hotspotClicked);
            } else if (val < 0) {
                for(let i1 = 0; i1 < noOfLoops; i1++){
                    handleNextPrev({
                        target: {
                            className: "product-card-scroll"
                        }
                    }, "left");
                }
                setHotspotClicked(true);
            } else {
                setHotspotClicked(true);
            }
        }
    }, [
        selectedIndex,
        visibleSkuIdsObj.firstIndex,
        visibleSkuIdsObj.visibleQuantity,
        invokedFrom
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            isModal ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "card-modal-image-container",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_core_Image_DynamicImage__WEBPACK_IMPORTED_MODULE_7__["default"], {
                        width: "100%",
                        style: {
                            aspectRatio: "1.333/1"
                        },
                        imgUrl: imageLink,
                        alt: altModel
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "image-title",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: shopTheRoomLink,
                            role: "link",
                            onClick: ()=>(0,_components_ShopTheRoomCard_analytics__WEBPACK_IMPORTED_MODULE_6__/* .addAnalyticsEventForImageTitle */ .C2)(cardTitle),
                            children: cardTitle
                        })
                    })
                ]
            }) : null,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "card-modal-product-card-container",
                ref: productCardContainerRef,
                children: [
                    isModal ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "product-cards-title",
                        children: staticTexts.title
                    }) : null,
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "product-cards-container",
                        children: (visibleSkuIdsObj === null || visibleSkuIdsObj === void 0 ? void 0 : (ref = visibleSkuIdsObj.currentPageSkus) === null || ref === void 0 ? void 0 : ref.length) > 0 ? visibleSkuIdsObj.currentPageSkus.map((skuId, index)=>{
                            const isVisible = visibleSkuIdsObj.firstIndex <= index && index < visibleSkuIdsObj.firstIndex + visibleSkuIdsObj.visibleQuantity;
                            const extraProp = isVisible && visibleSkuIdsObj.firstIndex === index ? {
                                ref: productCardRef
                            } : {};
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "product-card".concat(isVisible ? "" : "__not-display"),
                                ...extraProp,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_productCard_v3_ProductCard__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                    isFavoriteIcon: enableFavorite,
                                    selectedProduct: selectedProduct,
                                    authorData: {
                                        skewId: skuId,
                                        presetConfigs
                                    },
                                    isDefaultProductCard: false,
                                    hotspotClicked: hotspotClicked
                                })
                            }, "".concat(skuId, "-").concat(index));
                        }) : null
                    }),
                    skuIds.length > (visibleSkuIdsObj === null || visibleSkuIdsObj === void 0 ? void 0 : visibleSkuIdsObj.visibleQuantity) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "button-container",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "scroll-wrapper",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    className: "product-card-scroll".concat(visibleSkuIdsObj.isLeftDisabled ? "__button-disable" : ""),
                                    onClick: (e)=>{
                                        setInvokedFrom("button");
                                        handleNextPrev(e, "left");
                                    }
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    className: "product-card-scroll__right".concat(visibleSkuIdsObj.isRightDisabled ? "__button-disable" : ""),
                                    onClick: (e)=>{
                                        setInvokedFrom("button");
                                        handleNextPrev(e, "right");
                                    }
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (ShopTheRoomCardModalView);


/***/ }),

/***/ 49019:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ v1_SocialShare; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 16 modules
var esm = __webpack_require__(24400);
;// CONCATENATED MODULE: ./i18n/useSocialSharei18n.js

const useSocialSharei18n = (shareCartNum, brandName)=>{
    const { t  } = (0,esm/* useTranslation */.$G)();
    const i18n = {
        email: t("kf.share.label.email"),
        emailSubject: t("kf.share.label.emailSubject"),
        copyLink: t("kf.share.label.copyLink"),
        copyLinkIndication: t("kf.share.label.copyLinkIndication"),
        yourSharedCartNumber: t("kf.share.label.yourSharedCartNumber", {
            cartNumber: shareCartNum
        }),
        linksCTA: (siteKey)=>t("kf.pdp.label.aria.socialLinksCTA", {
                brandName: brandName,
                siteKey: siteKey
            }),
        openNewTabText: t("kf.share.label.openNewTabText"),
        shareCartDesc: t("kf.cart.label.shareCartDesc"),
        shareCart: t("kf.cart.label.shareCart"),
        mailSubject: t("kf.share.label.emailSubject"),
        downloadSpecs: t("kf.cart.label.downloadSpecs")
    };
    return i18n;
};
/* harmony default export */ var i18n_useSocialSharei18n = (useSocialSharei18n);

// EXTERNAL MODULE: ./utils/helper.js + 1 modules
var helper = __webpack_require__(55760);
;// CONCATENATED MODULE: ./components/SocialShare/utils.js

// get component social share link url
const getLink = (data)=>{
    const { href , url ="" , assetUrl ="" , compUrl ="" , general  } = data;
    const isFullUrl = /^https?:\/\//i;
    if (url && isFullUrl.test(url)) {
        return url;
    }
    if (url) {
        return "".concat(origin).concat(url);
    } else if (assetUrl && compUrl) {
        // teaser video component link all cases
        if (!isFullUrl.test(compUrl)) {
            const newcompUrl = (0,helper/* getShortenedUrlwithGeneral */.vu1)(compUrl, general);
            return "".concat(origin).concat(newcompUrl);
        } else {
            return compUrl;
        }
    } else if (assetUrl) {
        return assetUrl;
    } else {
        return (0,helper/* sanitizeUrl */.Nmg)(href !== null && href !== void 0 ? href : window.location.href);
    }
};

;// CONCATENATED MODULE: ./components/SocialShare/analytics/index.js
const addDataLayer = (data)=>{
    const { analyticData , siteKey , link  } = data;
    const { eventAction ="n/a" , eventName ="n/a" , eventType ="informative" , eventMsg ="n/a" , eventStatus ="n/a" , internalLinkPosition ="n/a" , internalLinkType ="n/a" , internalLinkZoneName ="n/a" , internalLinkURL , custom  } = analyticData;
    const eventInfo = {
        eventAction,
        eventName,
        eventType,
        eventMsg,
        eventStatus,
        internalLinkName: siteKey,
        internalLinkPosition,
        internalLinkType,
        internalLinkZoneName,
        internalLinkURL: link || internalLinkURL || "n/a",
        clickInternalLinks: siteKey === "copy link" || siteKey === "email" ? "true" : "false"
    };
    if (window.dataLayerEventType) {
        eventInfo.internalLinkType = window.dataLayerEventType;
    }
    if (window.dataLayerEventZoneName) {
        eventInfo.internalLinkZoneName = window.dataLayerEventZoneName;
        if (eventAction === "n/a") {
            eventInfo.eventAction = window.dataLayerEventZoneName + ":share";
            eventInfo.eventName = window.dataLayerEventZoneName + ":share";
        }
    }
    const page = window.pageObj || {};
    let productInfo;
    if (custom) {
        try {
            productInfo = JSON.parse(custom).productInfo;
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
    window.adobeDataLayer.push({
        event: "cmp:click",
        page,
        eventInfo,
        productInfo
    });
};

// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./hooks/useIsSsr.js
var useIsSsr = __webpack_require__(2595);
// EXTERNAL MODULE: ./store/features/genericSlice.js
var genericSlice = __webpack_require__(88751);
;// CONCATENATED MODULE: ./components/SocialShare/v1/SocialShare.jsx










const SocialShare = (props)=>{
    const { url ="" , showModal , componentProp: { assetUrl ="" , url: compUrl = "" , internallinkposition , internallinktype , internallinkzonename , eventaction , eventname , eventType  } = {} , componentProp , id , sharedCartNum , onClose , mailBody , mailSubject , asset , analyticData: analyticPropData , iframeId , shareBtn , shareRef  } = props;
    const isSsr = (0,useIsSsr/* default */.Z)();
    const [sites, setSites] = (0,react.useState)([]);
    const [origin, setOrigin] = (0,react.useState)(null);
    const [href, setHref] = (0,react.useState)(null);
    const emailBtnRef = (0,react.useRef)(null);
    const copyBtnRef = (0,react.useRef)(null);
    const shareBoxRef = (0,react.useRef)(null);
    const { globalConfig ={}  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const { general ={} , socialMediaConfig ={}  } = globalConfig;
    const { socialShareEmailIconPath ="" , socialShareCopyIconPath ="" , hostUrl ="" , siteName =""  } = general;
    (0,react.useEffect)(()=>{
        if (!isSsr) {
            setOrigin(window.location.origin);
            setHref(window.location.href);
        }
    }, [
        isSsr
    ]);
    const link = getLink({
        href,
        url,
        assetUrl,
        compUrl,
        general
    });
    const staticText = i18n_useSocialSharei18n(sharedCartNum, siteName);
    const [copyIcon, setCopyIcon] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        var ref;
        let siteList = [];
        socialMediaConfig === null || socialMediaConfig === void 0 ? void 0 : (ref = socialMediaConfig.myArrayList) === null || ref === void 0 ? void 0 : ref.forEach((mediaConfig)=>{
            if (!isEmpty_default()(mediaConfig.map) && mediaConfig.map.name) {
                var _name, _iconPath;
                const site = {
                    key: (_name = mediaConfig.map.name) !== null && _name !== void 0 ? _name : "",
                    icon: (_iconPath = mediaConfig.map.iconPath) !== null && _iconPath !== void 0 ? _iconPath : ""
                };
                var _redirectUrl;
                const url = (_redirectUrl = mediaConfig.map.redirectUrl) !== null && _redirectUrl !== void 0 ? _redirectUrl : "";
                if (mediaConfig.map.name.toLowerCase().includes("twitter")) {
                    siteList.push({
                        ...site,
                        url: encodeURI(url + link + "&text=".concat(document.title))
                    });
                } else if (mediaConfig.map.name.toLowerCase().includes("pinterest")) {
                    if (asset) siteList.push({
                        ...site,
                        url: url + "".concat(origin, "&media=").concat(asset.url, "&description=").concat(asset.description)
                    });
                } else {
                    siteList.push({
                        ...site,
                        url: url + link
                    });
                }
            }
        });
        if (siteList.length) {
            siteList = siteList.filter((site)=>!site.key.toLowerCase().includes("instagram"));
        }
        setSites(siteList);
    }, [
        socialMediaConfig
    ]);
    const emailLink = (e)=>{
        e.stopPropagation();
        addDataLayer({
            analyticData,
            siteKey: "email",
            link: "n/a"
        });
    };
    const socialLinks = (e)=>{
        const target = e.target;
        const nodeUrl = target.hostname.replace(/(^www\.)/, "");
        if (!window.excludUrl || window.excludUrl && !window.excludUrl.includes(nodeUrl)) {
            e.stopPropagation();
            e.preventDefault();
            if (window.handleShowModal) window.handleShowModal(target.href, target);
        } else if (target.href) {
            window.open(target.href);
        }
        const key = target.siteKey || nodeUrl || target.hostname;
        try {
            addDataLayer({
                analyticData,
                siteKey: key.split(".com")[0],
                link: target.href
            });
        } catch (err) {
            console.log(err);
        }
    };
    (0,react.useEffect)(()=>{
        var ref, ref1, ref2;
        copyBtnRef === null || copyBtnRef === void 0 ? void 0 : (ref = copyBtnRef.current) === null || ref === void 0 ? void 0 : ref.addEventListener("click", copyLink, false);
        shareBoxRef === null || shareBoxRef === void 0 ? void 0 : (ref1 = shareBoxRef.current) === null || ref1 === void 0 ? void 0 : ref1.addEventListener("click", shareBox, false);
        emailBtnRef === null || emailBtnRef === void 0 ? void 0 : (ref2 = emailBtnRef.current) === null || ref2 === void 0 ? void 0 : ref2.addEventListener("click", emailLink, false);
        if (shareBoxRef === null || shareBoxRef === void 0 ? void 0 : shareBoxRef.current) {
            var ref3;
            (ref3 = Array.from(shareBoxRef.current.getElementsByClassName("kf-social-links"))) === null || ref3 === void 0 ? void 0 : ref3.forEach((link)=>{
                link === null || link === void 0 ? void 0 : link.addEventListener("click", socialLinks, false);
            });
        }
        return ()=>{
            var // garbage collection
            ref, ref1, ref2;
            copyBtnRef === null || copyBtnRef === void 0 ? void 0 : (ref = copyBtnRef.current) === null || ref === void 0 ? void 0 : ref.removeEventListener("click", copyLink, false);
            shareBoxRef === null || shareBoxRef === void 0 ? void 0 : (ref1 = shareBoxRef.current) === null || ref1 === void 0 ? void 0 : ref1.removeEventListener("click", shareBox, false);
            emailBtnRef === null || emailBtnRef === void 0 ? void 0 : (ref2 = emailBtnRef.current) === null || ref2 === void 0 ? void 0 : ref2.removeEventListener("click", emailLink, false);
            if (shareBoxRef === null || shareBoxRef === void 0 ? void 0 : shareBoxRef.current) {
                var ref3;
                (ref3 = Array.from(shareBoxRef.current.getElementsByClassName("kf-social-links"))) === null || ref3 === void 0 ? void 0 : ref3.forEach((link)=>{
                    link === null || link === void 0 ? void 0 : link.removeEventListener("click", socialLinks, false);
                });
            }
        };
    }, [
        sites,
        showModal
    ]);
    const analyticData = analyticPropData || {
        internalLinkPosition: internallinkposition || "n/a",
        internalLinkType: internallinktype || "n/a",
        internalLinkZoneName: internallinkzonename || "n/a",
        eventAction: eventaction || "n/a",
        eventName: eventname || "n/a",
        eventType: eventType || "n/a"
    };
    const handleClick = (e)=>{
        var ref;
        const selELement = iframeId ? document.getElementById(iframeId).contentDocument.getElementById(id) : document.getElementById(id);
        if (showModal && !(selELement === null || selELement === void 0 ? void 0 : selELement.contains(e.target)) && !(shareBtn === null || shareBtn === void 0 ? void 0 : (ref = shareBtn.current) === null || ref === void 0 ? void 0 : ref.contains(e.target))) {
            onClose();
        }
        if ((componentProp === null || componentProp === void 0 ? void 0 : componentProp.showModal) && window.shareSrcElement !== null && window.shareSrcElement !== undefined && !shareRef.current.contains(e.target)) {
            const shareElems = [
                ...document.getElementsByClassName("share-cmp")
            ];
            shareElems.forEach((el)=>{
                el.style.display = "none";
            });
            window.shareSrcElement = null;
        }
        return true;
    };
    const handleClose = (e)=>{
        if (e.keyCode === 27) {
            onClose();
            shareBtn.current.focus();
        }
    };
    (0,react.useEffect)(()=>{
        const selELement = iframeId ? document.getElementById(iframeId).contentDocument : document;
        if (showModal) {
            selELement.addEventListener("click", handleClick);
            selELement.addEventListener("keydown", handleClose);
            return ()=>{
                selELement.removeEventListener("click", handleClick);
                selELement.removeEventListener("keydown", handleClose);
            };
        }
        if ((componentProp === null || componentProp === void 0 ? void 0 : componentProp.showModal) && showModal) {
            document.addEventListener("click", handleClick);
        }
    }, [
        showModal
    ]);
    const copyLink = (e)=>{
        e.stopPropagation();
        e.preventDefault();
        navigator.clipboard.writeText(link);
        setCopyIcon(true);
        setTimeout(()=>{
            setCopyIcon(false);
        }, 3000);
        addDataLayer({
            analyticData,
            siteKey: "copy link",
            link: link !== null && link !== void 0 ? link : "n/a"
        });
    };
    const shareBox = (e)=>{
        e.stopPropagation();
        e.preventDefault();
    };
    return (showModal !== null && showModal !== void 0 ? showModal : componentProp === null || componentProp === void 0 ? void 0 : componentProp.showModal) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "social-share",
        id: id,
        ref: shareRef,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "social-share__box",
            ref: shareBoxRef,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "social-share__sites",
                    children: sharedCartNum && sharedCartNum ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "social-share__shared-cart-number",
                        children: staticText.yourSharedCartNumber
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        role: "list",
                        children: sites.map((site, i)=>{
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                role: "listitem",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    id: "kf-social-links-".concat(i),
                                    rel: "noreferrer",
                                    href: site.url,
                                    className: "kf-social-links",
                                    "aria-label": "".concat(staticText.linksCTA(site.key), " ").concat(staticText.openNewTabText),
                                    target: "_blank",
                                    "data-link-type": "social media",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        "aria-hidden": "true",
                                        src: "".concat(hostUrl).concat(site === null || site === void 0 ? void 0 : site.icon),
                                        alt: site.key,
                                        className: "social-share__".concat(site.key)
                                    })
                                })
                            }, i);
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "social-share__actions",
                    role: "list",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            role: "listitem",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                tabIndex: "0",
                                role: "button",
                                ref: copyBtnRef,
                                className: "social-share__cta",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        className: "social-share__copy-link-icon",
                                        "aria-hidden": true,
                                        src: "".concat(hostUrl).concat(socialShareCopyIconPath),
                                        role: "presentation",
                                        alt: ""
                                    }),
                                    copyIcon ? staticText.copyLinkIndication : staticText.copyLink
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            role: "listitem",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                className: "social-share__cta social-share__email",
                                "aria-label": "".concat(staticText.email, " ").concat(staticText.openNewTabText),
                                onKeyDown: ()=>onClose(),
                                ref: emailBtnRef,
                                href: (0,helper/* sanitizeUrl */.Nmg)("mailto:?body=".concat((mailBody ? mailBody : "") + link).concat(mailSubject ? "&subject=" + mailSubject : "")),
                                target: "_blank",
                                rel: "noreferrer",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "".concat(hostUrl).concat(socialShareEmailIconPath),
                                        role: "presentation",
                                        alt: ""
                                    }),
                                    staticText.email
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    }) : null;
};
/* harmony default export */ var v1_SocialShare = (SocialShare);


/***/ }),

/***/ 22006:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55760);
/* harmony import */ var _public_icons_share_svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66773);
/* harmony import */ var _public_icons_download_dark_gray_svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91883);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(19514);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(41609);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(24400);
/* harmony import */ var _utils_location__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(97433);
/* harmony import */ var _utils_index__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(20558);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(9473);
/* harmony import */ var _store_features_cartSlice__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(46201);














const SocialShare = (param)=>{
    let { cartId , analyticEventData , specFiles , mobileView =false , componentProp: { assetUrl ="" , url: compUrl = ""  } = {} , enableDownload =true , videoComp =false  } = param;
    // *****
    const [shareCart, setShareCart] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)({
        show: false,
        id: "",
        url: ""
    });
    const [copyIcon, setCopyIcon] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false);
    const [link, setLink] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)("");
    const [downloading, setDownloading] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false);
    const url = shareCart.url || "";
    const [sites, setSites] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)([]);
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_11__/* .useDispatch */ .I0)();
    const { t  } = (0,next_i18next__WEBPACK_IMPORTED_MODULE_8__/* .useTranslation */ .$G)();
    const origin = window.location.origin;
    const brandName = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)("");
    const [socialMediaConfigs, setSocialMediaConfigs] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)({});
    const emailBtnRef = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)(null);
    const copyBtnRef = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)(null);
    const shareBoxRef = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)(null);
    const shareCartUrl = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)("");
    const socialShareCopyIconPath = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)("");
    const socialShareEmailIconPath = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)("");
    const hostUrlPath = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)("");
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(()=>{
        (0,_constants_config__WEBPACK_IMPORTED_MODULE_5__/* .getConfig */ .i)().then(async (config)=>{
            const socialMediaConfigs = lodash_get__WEBPACK_IMPORTED_MODULE_6___default()(config, "socialMediaConfig", {});
            setSocialMediaConfigs(socialMediaConfigs);
            brandName.current = lodash_get__WEBPACK_IMPORTED_MODULE_6___default()(config, "general?.siteName", "");
            const { general: { hostUrl =""  } = {}  } = config !== null && config !== void 0 ? config : {};
            hostUrlPath.current = hostUrl;
            socialShareCopyIconPath.current = lodash_get__WEBPACK_IMPORTED_MODULE_6___default()(config, "general.socialShareCopyIconPath", "");
            socialShareEmailIconPath.current = lodash_get__WEBPACK_IMPORTED_MODULE_6___default()(config, "general.socialShareEmailIconPath", "");
            shareCartUrl.current = await (0,_utils_location__WEBPACK_IMPORTED_MODULE_9__/* .getShortenedUrl */ .Pp)(lodash_get__WEBPACK_IMPORTED_MODULE_6___default()(config, "general.shareCartPagePath", ""));
        });
        getLink().then((urlLink)=>{
            setLink(urlLink);
        });
    }, []);
    const handleShareCart = ()=>{
        setShareCart({
            ...shareCart,
            show: !shareCart.show
        });
        addDataLayer("share cart", link);
    };
    const handleShareCartCopyLink = (data)=>{
        const { isCopyLink =false , ismail =false  } = data;
        const payload = {
            cartId: cartId
        };
        return dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_12__/* .shareCart */ .Vp)(payload)).unwrap().then((res)=>{
            if (res === null || res === void 0 ? void 0 : res.sharedCartId) {
                const shareUrl = window.location.origin + shareCartUrl.current + "?share-id=".concat(res.sharedCartId);
                if (isCopyLink) {
                    setShareCart({
                        ...shareCart,
                        id: res.sharedCartId,
                        url: shareUrl
                    });
                    navigator.clipboard.writeText(shareUrl);
                    addDataLayer("copy link", shareUrl !== null && shareUrl !== void 0 ? shareUrl : "n/a");
                } else if (ismail) {
                    return "share-id=".concat(res.sharedCartId);
                }
                return shareUrl;
            }
        });
    };
    // get component social share link url
    const getLink = async ()=>{
        const isFullUrl = /^https?:\/\//i;
        if (url && isFullUrl.test(url)) {
            return url;
        }
        if (url) {
            return "".concat(origin).concat(url);
        } else if (assetUrl && compUrl) {
            // teaser video component link all cases
            if (!isFullUrl.test(compUrl)) {
                const newcompUrl = await (0,_utils_location__WEBPACK_IMPORTED_MODULE_9__/* .getShortenedUrl */ .Pp)(compUrl);
                return "".concat(origin).concat(newcompUrl);
            } else {
                return compUrl;
            }
        } else if (assetUrl) {
            return assetUrl;
        } else {
            return (0,_utils_helper__WEBPACK_IMPORTED_MODULE_1__/* .sanitizeUrl */ .Nmg)(window.location.href);
        }
    };
    const i18n = {
        email: t("kf.share.label.email"),
        emailSubject: t("kf.share.label.emailSubject"),
        copyLink: t("kf.share.label.copyLink"),
        copyLinkIndication: t("kf.share.label.copyLinkIndication"),
        yourSharedCartNumber: t("kf.share.label.yourSharedCartNumber", {
            cartNumber: shareCart.id
        }),
        linksCTA: (siteKey)=>t("kf.pdp.label.aria.socialLinksCTA", {
                brandName,
                siteKey
            }),
        openNewTabText: t("kf.share.label.openNewTabText"),
        shareCartDesc: t("kf.cart.label.shareCartDesc"),
        shareCart: t("kf.cart.label.shareCart"),
        mailSubject: t("kf.share.label.emailSubject"),
        downloadSpecs: t("kf.cart.label.downloadSpecs")
    };
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(()=>{
        var ref;
        const siteList = [];
        socialMediaConfigs && (socialMediaConfigs === null || socialMediaConfigs === void 0 ? void 0 : (ref = socialMediaConfigs.myArrayList) === null || ref === void 0 ? void 0 : ref.forEach((socialMediaConfig)=>{
            if (!lodash_isEmpty__WEBPACK_IMPORTED_MODULE_7___default()(socialMediaConfig.map && socialMediaConfig.map.name)) {
                var _name, _iconPath;
                const site = {
                    key: (_name = socialMediaConfig.map.name) !== null && _name !== void 0 ? _name : "",
                    icon: (_iconPath = socialMediaConfig.map.iconPath) !== null && _iconPath !== void 0 ? _iconPath : ""
                };
                var _redirectUrl;
                const url = (_redirectUrl = socialMediaConfig.map.redirectUrl) !== null && _redirectUrl !== void 0 ? _redirectUrl : "";
                if (socialMediaConfig.map.name.toLowerCase().includes("twitter")) {
                    siteList.push({
                        ...site,
                        url: encodeURI(url + link + "&text=".concat(document.title))
                    });
                } else if (socialMediaConfig.map.name.toLowerCase().includes("pinterest")) {
                // if (props.asset)
                //   siteList.push({
                //     ...site,
                //     url:
                //       url +
                //       `${origin}&media=${props.asset.url}&is_video=${props.asset.isVideo}$description=${props.asset.description}`,
                //   })
                } else {
                    siteList.push({
                        ...site,
                        url: url + link
                    });
                }
            }
        }));
        setSites(siteList);
    }, [
        socialMediaConfigs
    ]);
    const emailLink = async (e)=>{
        const firstLink = window.location.origin + shareCartUrl.current;
        const lastLink = await handleShareCartCopyLink({
            ismail: true
        });
        const cartLink = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_1__/* .sanitizeUrl */ .Nmg)("mailto:?body=".concat(firstLink + "%3F" + lastLink).concat(i18n.mailSubject && "&subject=" + i18n.mailSubject));
        window.open(cartLink, "_blank");
        e.stopPropagation();
        addDataLayer("email a friend", "n/a");
    };
    const handleEmailActionKeydown = async (e)=>{
        if (e.keyCode === 13) {
            emailLink(e);
        }
        handleShareCart();
    };
    const socialLinks = (e)=>{
        const target = e.target;
        const nodeUrl = target.hostname.replace(/(^www\.)/, "");
        if (!window.excludUrl || window.excludUrl && !window.excludUrl.includes(nodeUrl)) {
            e.stopPropagation();
            e.preventDefault();
            if (window.handleShowModal) window.handleShowModal(target.href, target);
        } else if (target.href) {
            window.open(target.href);
        }
        const key = target.siteKey || nodeUrl || target.hostname;
        try {
            addDataLayer(key.split(".com")[0], target.href);
        // eslint-disable-next-line no-empty
        } catch (ee) {}
    };
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(()=>{
        var ref, ref1, ref2, ref3;
        copyBtnRef === null || copyBtnRef === void 0 ? void 0 : (ref = copyBtnRef.current) === null || ref === void 0 ? void 0 : ref.addEventListener("click", copyLink, false);
        shareBoxRef === null || shareBoxRef === void 0 ? void 0 : (ref1 = shareBoxRef.current) === null || ref1 === void 0 ? void 0 : ref1.addEventListener("click", shareBox, false);
        emailBtnRef === null || emailBtnRef === void 0 ? void 0 : (ref2 = emailBtnRef.current) === null || ref2 === void 0 ? void 0 : ref2.addEventListener("click", emailLink, false);
        emailBtnRef === null || emailBtnRef === void 0 ? void 0 : (ref3 = emailBtnRef.current) === null || ref3 === void 0 ? void 0 : ref3.addEventListener("keydown", handleEmailActionKeydown, false);
        if (shareBoxRef === null || shareBoxRef === void 0 ? void 0 : shareBoxRef.current) {
            var ref4;
            (ref4 = Array.from(shareBoxRef.current.getElementsByClassName("kf-social-links"))) === null || ref4 === void 0 ? void 0 : ref4.forEach((link)=>{
                link === null || link === void 0 ? void 0 : link.addEventListener("click", socialLinks, false);
            });
        }
        return ()=>{
            var // garbage collection
            ref, ref1, ref2, ref3;
            copyBtnRef === null || copyBtnRef === void 0 ? void 0 : (ref = copyBtnRef.current) === null || ref === void 0 ? void 0 : ref.removeEventListener("click", copyLink, false);
            shareBoxRef === null || shareBoxRef === void 0 ? void 0 : (ref1 = shareBoxRef.current) === null || ref1 === void 0 ? void 0 : ref1.removeEventListener("click", shareBox, false);
            emailBtnRef === null || emailBtnRef === void 0 ? void 0 : (ref2 = emailBtnRef.current) === null || ref2 === void 0 ? void 0 : ref2.removeEventListener("click", emailLink, false);
            emailBtnRef === null || emailBtnRef === void 0 ? void 0 : (ref3 = emailBtnRef.current) === null || ref3 === void 0 ? void 0 : ref3.removeEventListener("keydown", handleEmailActionKeydown, false);
            if (shareBoxRef === null || shareBoxRef === void 0 ? void 0 : shareBoxRef.current) {
                var ref4;
                (ref4 = Array.from(shareBoxRef.current.getElementsByClassName("kf-social-links"))) === null || ref4 === void 0 ? void 0 : ref4.forEach((link)=>{
                    link === null || link === void 0 ? void 0 : link.removeEventListener("click", socialLinks, false);
                });
            }
        };
    }, [
        sites,
        shareCart.show
    ]);
    const analyticData = analyticEventData || {
        internalLinkPosition: "n/a",
        internalLinkType: "n/a",
        internalLinkZoneName: "n/a"
    };
    const copyLink = (e)=>{
        e.stopPropagation();
        e.preventDefault();
        handleShareCartCopyLink({
            isCopyLink: true
        });
        setCopyIcon(true);
        setTimeout(()=>{
            setCopyIcon(false);
        }, 3000);
    };
    const shareBox = (e)=>{
        e.stopPropagation();
        e.preventDefault();
    };
    const handleDownload = async ()=>{
        setDownloading(true);
        await (0,_utils_helper__WEBPACK_IMPORTED_MODULE_1__/* .handleZipDownload */ .G12)(specFiles);
        setDownloading(false);
    };
    const addDataLayer = (siteKey, link)=>{
        var ref;
        const { eventAction ="n/a" , eventName ="n/a" , eventType =siteKey === "share cart" ? "navigation" : "informative" , eventMsg ="n/a" , eventStatus ="n/a" , internalLinkPosition ="n/a" , internalLinkType ="n/a" , internalLinkZoneName ="n/a" , internalLinkURL , videoId ="" , videoName =""  } = analyticData;
        const eventInfo = {
            eventAction,
            eventName,
            eventType,
            eventMsg,
            eventStatus,
            internalLinkName: siteKey,
            internalLinkPosition,
            internalLinkType,
            internalLinkZoneName,
            internalLinkURL: link || internalLinkURL || "n/a",
            clickInternalLinks: siteKey === "copy link" || siteKey === "email a friend" || siteKey === "share cart" ? "true" : "false"
        };
        if (videoId) eventInfo.videoId = videoId;
        if (videoName) eventInfo.videoName = videoName;
        if (window.dataLayerEventType) {
            eventInfo.internalLinkType = window.dataLayerEventType;
        }
        if (window.dataLayerEventZoneName) {
            eventInfo.internalLinkZoneName = window.dataLayerEventZoneName;
            if (eventAction === "n/a") {
                eventInfo.eventAction = window.dataLayerEventZoneName + ":share";
                eventInfo.eventName = window.dataLayerEventZoneName + ":share";
            }
        }
        const page = window.pageObj || {};
        if ((ref = window.adobeDataLayer) === null || ref === void 0 ? void 0 : ref.length) {
            const { page: { cart ={}  } = {}  } = window.adobeDataLayer[0];
            page.cart = cart;
        }
        window.adobeDataLayer.push({
            event: "cmp:click",
            page,
            eventInfo
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_utils_index__WEBPACK_IMPORTED_MODULE_10__/* .ConditionalWrapper */ .M2, {
            condition: enableDownload,
            wrapper: (children)=>{
                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "download-specs".concat(mobileView ? "--mobile" : " d-none d-lg-block"),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            children: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_1__/* .sanitizeInnerHtml */ .KD0)(i18n.shareCartDesc)
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "download-specs".concat(mobileView ? "--mobile" : "", "__cta"),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                    role: "button",
                                    tabIndex: "0",
                                    onClick: ()=>handleShareCart(),
                                    name: "socialShareModelClose",
                                    "aria-expanded": shareCart.show,
                                    "aria-controls": "kf-order-summary",
                                    children: [
                                        i18n.shareCart,
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                            src: _public_icons_share_svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z === null || _public_icons_share_svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z === void 0 ? void 0 : _public_icons_share_svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"].src */ .Z.src,
                                            role: "presentation",
                                            alt: ""
                                        })
                                    ]
                                }),
                                (specFiles === null || specFiles === void 0 ? void 0 : specFiles.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                    role: "button",
                                    tabIndex: "0",
                                    className: "gbh-data-layer",
                                    "data-gbh-data-layer": '{"eventAction":"cart:landing page:download specs","eventName":"cart:landing page:download specs","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"download specs","internalLinkPosition":"cart","internalLinkType":"cart:download","internalLinkZoneName":"cart:landing page:order summary","internalLinkURL":"n/a","clickInternalLinks":"true"}',
                                    onClick: handleDownload,
                                    children: [
                                        i18n.downloadSpecs,
                                        downloading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "loading-spinner"
                                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                            src: _public_icons_download_dark_gray_svg__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z === null || _public_icons_download_dark_gray_svg__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z === void 0 ? void 0 : _public_icons_download_dark_gray_svg__WEBPACK_IMPORTED_MODULE_3__/* ["default"].src */ .Z.src,
                                            role: "presentation",
                                            alt: ""
                                        }),
                                        " "
                                    ]
                                })
                            ]
                        }),
                        children
                    ]
                });
            },
            children: shareCart.show || !enableDownload ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "social-share",
                id: "kf-order-summary",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "social-share__box",
                    ref: shareBoxRef,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "social-share__sites",
                            children: shareCart.id && !videoComp ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "social-share__shared-cart-number",
                                children: i18n.yourSharedCartNumber
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                role: "list",
                                children: sites.map((site, i)=>{
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                        role: "listitem",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            id: "kf-social-links-".concat(i),
                                            rel: "noreferrer",
                                            href: site.url,
                                            className: "kf-social-links",
                                            "aria-label": "".concat(i18n.linksCTA(site.key), " ").concat(i18n.openNewTabText),
                                            target: "_blank",
                                            "data-link-type": "social media",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                "aria-hidden": "true",
                                                src: "".concat("https://web-api.kohler.com/aem/resource?subscription-key=3da4541f545f4dc7841b6ba0606f96fc&resourcepath=").concat(site.icon),
                                                alt: site.key,
                                                className: "social-share__".concat(site.key)
                                            })
                                        })
                                    }, i);
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "social-share__actions",
                            role: "list",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    role: "listitem",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        tabIndex: "0",
                                        role: "button",
                                        ref: copyBtnRef,
                                        className: "social-share__cta",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                className: "social-share__copy-link-icon",
                                                "aria-hidden": true,
                                                src: "".concat(hostUrlPath.current).concat(socialShareCopyIconPath.current),
                                                role: "presentation",
                                                alt: ""
                                            }),
                                            copyIcon ? i18n.copyLinkIndication : i18n.copyLink
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    role: "listitem",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                        tabIndex: "0",
                                        className: "social-share__cta social-share__email",
                                        "aria-label": "".concat(i18n.email, " ").concat(i18n.openNewTabText),
                                        role: "link",
                                        ref: emailBtnRef,
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                src: "".concat(hostUrlPath.current).concat(socialShareEmailIconPath.current),
                                                role: "presentation",
                                                alt: ""
                                            }),
                                            i18n.email
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            }) : null
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SocialShare);


/***/ }),

/***/ 75653:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55760);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19514);
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(91296);
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lodash_debounce__WEBPACK_IMPORTED_MODULE_5__);
/**
 * It is Quantity Selector
 *  @returns {number} the QuantitySelector
 */ 





/**
 * It returns updated Value
 * @param {props} props is the only param.
 * @return {number} the updated Value in the cart
 */ function QuantitySelector(props) {
    const { isPDPQuantitySelector , source , doNotRequiredAnalyticsData , productData , productInfoData , onLoading =()=>{}  } = props || {};
    const [value, setValue] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(props.value);
    const [focusControl, setFocusControl] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const [siteName, setSiteName] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const product = productData && (productData.name || productData.desc) ? productData : {};
    const minusButton = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const addButton = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const qtyInput = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (!props.loading && value !== props.value) {
            setValue(props.value);
        } else if (!props.loading && value === props.value && value !== 1 && focusControl) {
            focusControl.current.focus();
        }
    }, [
        props.value,
        props.loading
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        (0,_constants_config__WEBPACK_IMPORTED_MODULE_4__/* .getConfig */ .i)().then((config)=>{
            setSiteName(lodash_get__WEBPACK_IMPORTED_MODULE_3___default()(config, "general.siteName", ""));
        });
    }, []);
    /**
   * @param {val} val The first number.
   * @param {action} action The second number.
   */ const handleChange = (val, action)=>{
        if (val === "" || parseInt(val) < 1000) {
            if (props.isAddToCart) {
                onLoading();
            }
            if (!action) {
                setFocusControl(qtyInput);
            } else {
                setFocusControl(action === "add" ? addButton : minusButton);
            }
            let fieldValue = val.toString().replace(/\D/, "");
            if (fieldValue.charAt(0) === "0") {
                fieldValue = fieldValue.length === 1 ? 0 : fieldValue.substring(1);
            }
            fieldValue = fieldValue === "" ? value : Number(fieldValue);
            // if (!window.oldValue && window.oldValue !== 0) {
            window.oldValue = Number(props.value);
            // }
            setValue(fieldValue);
            delayedChange(fieldValue, action);
        }
    };
    const handleAddAnalytics = (action, val)=>{
        var ref, ref1, ref2, ref3, ref4;
        const { adobeDataLayer: { getState  } = {}  } = window;
        const page = getState && getState("page") || {};
        if (source !== "cart-preview" && (page === null || page === void 0 ? void 0 : (ref = page.cart) === null || ref === void 0 ? void 0 : (ref1 = ref.item) === null || ref1 === void 0 ? void 0 : ref1.length)) {
            // this is flow of cart page only
            let updatedSku;
            let pdpTypeBundle;
            page.cart.item.forEach((prod)=>{
                var ref, ref1, ref2, ref3, ref4, ref5;
                const productId = (ref = prod.productInfo) === null || ref === void 0 ? void 0 : (ref1 = ref.productID) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase();
                if (productId === ((ref2 = product.customerFacingSKU) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase()) || productId === ((ref3 = product.sku) === null || ref3 === void 0 ? void 0 : ref3.toLowerCase()) || ((ref4 = props.productData) === null || ref4 === void 0 ? void 0 : ref4.isBundleParent) && ((ref5 = props.productData) === null || ref5 === void 0 ? void 0 : ref5.sku)) {
                    var ref6, ref7;
                    if (((ref6 = props.productData) === null || ref6 === void 0 ? void 0 : ref6.isBundleParent) && ((ref7 = props.productData) === null || ref7 === void 0 ? void 0 : ref7.sku)) {
                        var ref8;
                        updatedSku = (ref8 = props.productData) === null || ref8 === void 0 ? void 0 : ref8.sku;
                        pdpTypeBundle = "bundle";
                    } else {
                        const iQty = prod.productInfo.quantity;
                        prod.productInfo = {
                            ...prod.productInfo,
                            quantity: val,
                            initialQuantity: iQty !== null && iQty !== void 0 ? iQty : Number(value)
                        };
                        prod.quantity = val;
                        updatedSku = productId;
                        pdpTypeBundle = prod.productInfo.pdpType;
                    }
                }
            });
            if (pdpTypeBundle === "bundle") {
                var ref5;
                var ref6;
                productInfoData.productInfo = {
                    ...productInfoData.productInfo,
                    quantity: val,
                    initialQuantity: (ref6 = Number((ref5 = productInfoData.productInfo) === null || ref5 === void 0 ? void 0 : ref5.quantity)) !== null && ref6 !== void 0 ? ref6 : Number(value)
                };
                window.adobeDataLayer.push({
                    event: "cmp:click",
                    eventInfo: eventInfo(action),
                    ...productInfoData,
                    page
                });
            } else {
                page.eventInfo = eventInfo(action);
                page.updatedSku = updatedSku;
                window.pageObj = page;
            }
        // wait till api is updating cart details
        } else if (source === "cart-preview" && (page === null || page === void 0 ? void 0 : (ref2 = page.cart) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.item) === null || ref3 === void 0 ? void 0 : ref3.length)) {
            var ref7, ref8;
            // This is flow of cart preview updates
            let customPI;
            if (page === null || page === void 0 ? void 0 : (ref7 = page.cart) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.item) === null || ref8 === void 0 ? void 0 : ref8.length) {
                // update this one too to get updated page state in analytics
                page.cart.item.forEach((prod)=>{
                    var ref, ref1, ref2, ref3;
                    const productId = (ref = prod.productInfo) === null || ref === void 0 ? void 0 : (ref1 = ref.productID) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase();
                    if (productId === ((ref2 = product.customerFacingSKU) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase()) || productId === ((ref3 = product.sku) === null || ref3 === void 0 ? void 0 : ref3.toLowerCase())) {
                        const iQty = prod.productInfo.quantity;
                        prod.productInfo = {
                            ...prod.productInfo,
                            quantity: val,
                            initialQuantity: iQty !== null && iQty !== void 0 ? iQty : Number(value)
                        };
                        prod.quantity = val;
                        customPI = prod.productInfo;
                    }
                });
            }
            if (!doNotRequiredAnalyticsData) {
                window.adobeDataLayer.push({
                    event: "cmp:click",
                    eventInfo: eventInfo(action),
                    productInfo: customPI !== null && customPI !== void 0 ? customPI : productInfo(val),
                    page
                });
            }
        }
        if (source !== "cart-preview" && page && !(window === null || window === void 0 ? void 0 : (ref4 = window.pageObj) === null || ref4 === void 0 ? void 0 : ref4.updatedSku)) {
            page.updatedSku = (productData === null || productData === void 0 ? void 0 : productData.customerFacingSKU) || "true";
            window.pageObj = page;
        }
    };
    const productInfo = (val)=>{
        const customerFacingSKUId = product.customerFacingSKU || product.sku;
        const itemType = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_2__/* .getCartItemType */ .Nth)(product.category, product.businessUnitName);
        const discountPriceProduct = Number(product.discountPrice);
        var _productSaleable, _oldValue;
        return {
            productBrand: siteName === null || siteName === void 0 ? void 0 : siteName.toLowerCase(),
            description: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_2__/* .sanitizeTextForAnalytics */ .T68)(product.desc) || "n/a",
            frequency: "n/a",
            globalPromotionPrice: discountPriceProduct ? discountPriceProduct : Number(product.unitPrice),
            isRecommended: "n/a",
            isSendNow: "n/a",
            isSubscription: "n/a",
            priceState: product.discountPercent > 0 || product.discountAmount > 0 ? "percentOff|" + product.discountPercent : "regular price",
            productBasePrice: Number(product.unitPrice) || "n/a",
            productCategory: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_2__/* .sanitizeTextForAnalytics */ .T68)(product.category) || "n/a",
            productColor: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_2__/* .sanitizeTextForAnalytics */ .T68)(product.color) || "n/a",
            productCoupondiscount: "n/a",
            productID: customerFacingSKUId || "n/a",
            productName: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_2__/* .sanitizeTextForAnalytics */ .T68)(product.name) || "n/a",
            productPartnerBuyNow: false,
            productRoom: (props === null || props === void 0 ? void 0 : props.isBundleParent) || (productData === null || productData === void 0 ? void 0 : productData.pdpType) === "bundle" ? (0,_utils_helper__WEBPACK_IMPORTED_MODULE_2__/* .sanitizeTextForAnalytics */ .T68)(productData.category) : (0,_utils_helper__WEBPACK_IMPORTED_MODULE_2__/* .sanitizeTextForAnalytics */ .T68)(product.productRoom || (itemType === "service" ? itemType : "non-catalog")) || "n/a",
            productSalePrice: Number(product.discountPrice) ? Number(product.discountPrice) : Number(product.unitPrice),
            productSaleable: (_productSaleable = product.productSaleable) !== null && _productSaleable !== void 0 ? _productSaleable : "true",
            productStatus: product.availableQty >= val || product.stock >= val ? "in stock" : "out of stock",
            productSuperSku: product.superSku ? true : false,
            productTileName: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_2__/* .sanitizeTextForAnalytics */ .T68)(product.name) || "n/a",
            quantity: val,
            initialQuantity: (_oldValue = window.oldValue) !== null && _oldValue !== void 0 ? _oldValue : Number(value),
            defaultImageName: product.image || "n/a",
            ratings: "n/a",
            numberOfReviews: "n/a",
            pdpType: (props === null || props === void 0 ? void 0 : props.isBundleParent) || (productData === null || productData === void 0 ? void 0 : productData.pdpType) === "bundle" ? "bundle" : (0,_utils_helper__WEBPACK_IMPORTED_MODULE_2__/* .pdpTypeFormat */ .V4r)({
                businessUnitName: props.businessUnitName,
                ProductIsRetail: props.ProductIsRetail,
                discontinuedProductb: props.discontinuedProductb,
                ProductRequiredAccessoriesGroupsList: props.ProductRequiredAccessoriesGroupsList,
                superSku: props.superSku
            }),
            productFindingMethod: "n/a",
            productCollectionsName: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_2__/* .sanitizeTextForAnalytics */ .T68)(product.productCollectionsName || product.category) || "n/a",
            itemType
        };
    };
    const eventInfo = (action)=>{
        return {
            eventAction: "cart preview:cart update:".concat(action).concat(isPDPQuantitySelector ? " quantity" : ""),
            eventName: "cart preview:cart update:".concat(action).concat(isPDPQuantitySelector ? " quantity" : ""),
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: "cart update",
            internalLinkPosition: "cart".concat((props === null || props === void 0 ? void 0 : props.isBundleParent) || (productData === null || productData === void 0 ? void 0 : productData.pdpType) === "bundle" ? ":bundle" : ""),
            internalLinkType: "cart:".concat(action === "add" ? "addition" : action === "subtract" ? "removal" : "update"),
            internalLinkZoneName: "cart:preview",
            internalLinkURL: "n/a",
            clickInternalLinks: "true"
        };
    };
    const delayedChange = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(lodash_debounce__WEBPACK_IMPORTED_MODULE_5___default()((val, action)=>{
        if (val) {
            if (!action) {
                var _oldValue;
                const oldVal = (_oldValue = window.oldValue) !== null && _oldValue !== void 0 ? _oldValue : value;
                if (val > oldVal) {
                    action = "add";
                } else if (val < oldVal) {
                    action = "subtract";
                }
            }
            handleAddAnalytics(action, val);
            props.onChange(parseInt(val), action);
        }
    }, 1000), [
        props.onChange
    ]);
    /**
   * input value updates her
   */ const handleBlur = ()=>{
        if (!value || parseInt(value) === 0) setValue(props.value);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "quantity-selector no-print ".concat(props.size === "small" ? "small" : ""),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                ref: minusButton,
                onClick: ()=>handleChange(parseInt(value) - 1, "subtract"),
                "aria-disabled": props.loading || !value || value === 1,
                disabled: props.loading || !value || value === 1,
                "data-testid": "decrement-button",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                    className: "plus",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "line-1 line"
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                ref: qtyInput,
                type: "number",
                className: "quantity-selector__count",
                value: parseInt(value),
                onBlur: ()=>handleBlur(),
                onChange: (e)=>handleChange(e.target.value),
                disabled: props.loading,
                "data-testid": "quantity-input"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                ref: addButton,
                onClick: ()=>handleChange(parseInt(value) + 1, "add"),
                "aria-disabled": props.loading,
                disabled: props.loading,
                "data-testid": "increment-button",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                    className: "plus",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "line-1 line"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "line line-2"
                        })
                    ]
                })
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (QuantitySelector);


/***/ }),

/***/ 93284:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "vC": function() { return /* binding */ getMessageStatus; },
  "OA": function() { return /* binding */ getProductsById; },
  "$y": function() { return /* binding */ getProfileData; },
  "Qi": function() { return /* binding */ getShippingDetails; },
  "qy": function() { return /* binding */ getShippingMethods; },
  "bQ": function() { return /* binding */ handleQuantityChange; },
  "B8": function() { return /* binding */ removeCartItem; },
  "nc": function() { return /* binding */ setShippingAddress; },
  "FX": function() { return /* binding */ updateProductDetailToStore; }
});

// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./store/index.js + 4 modules
var store = __webpack_require__(88032);
// EXTERNAL MODULE: ./store/features/cartSlice.js
var cartSlice = __webpack_require__(46201);
// EXTERNAL MODULE: ./store/features/checkoutSlice.js
var checkoutSlice = __webpack_require__(60475);
// EXTERNAL MODULE: ./constants/api.js
var api = __webpack_require__(73350);
// EXTERNAL MODULE: ./utils/helper.js + 1 modules
var helper = __webpack_require__(55760);
// EXTERNAL MODULE: ./utils/cart.js
var cart = __webpack_require__(11763);
;// CONCATENATED MODULE: ./utils/removeCart.js
// import { analyticsCB } from "@/components/cart/cartAnalytics"
const removeFromCart = function() {
    let data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    /**
   * It removeFrom cart for pay load
   */ const { lineItemId ="" , quantity =0 , isBundle =false , isBundleParent =false , sku =""  } = data;
    const bundlePayload = {
        action: "removeBundleItem",
        customLineItemId: lineItemId,
        sku
    };
    const actions = [
        isBundleParent ? bundlePayload : {
            action: isBundle ? "removebundle" : "removeLineItem",
            lineItemId,
            quantity
        }
    ];
    return actions;
};
const setRemoveCartPayload = function() {
    let items = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    /**
   * It removeFrom cart for payload removeBundleItem
   */ const actions = [];
    const allIds = items.filter((item)=>item.id !== "").map((item)=>item.id);
    items.forEach((item)=>{
        const filteredIds = allIds.filter((i)=>i !== item.id);
        // filtering out the combo sku items, to select only parent item if available
        if (!filteredIds.includes(item.bundleParentId) && !item.parentBundleSku && !item.isBundleParent) {
            actions.push({
                action: item.isComboSku || (item === null || item === void 0 ? void 0 : item.bundleParentId) ? "removebundle" : "removeLineItem",
                lineItemId: (item === null || item === void 0 ? void 0 : item.bundleParentId) ? item.bundleParentId : item.id,
                quantity: item.quantity
            });
        } else if (!(item === null || item === void 0 ? void 0 : item.parentBundleSku) && (item === null || item === void 0 ? void 0 : item.isBundleParent)) {
            // else block added for the static bundles only, as we have different payload
            actions.push({
                action: (item === null || item === void 0 ? void 0 : item.isBundleParent) ? "removeBundleItem" : "removeLineItem",
                customLineItemId: item.id,
                sku: item.sku
            });
        }
    });
    return actions;
};

// EXTERNAL MODULE: ./js/helperV2.js
var helperV2 = __webpack_require__(30696);
// EXTERNAL MODULE: ./constants/index.js
var constants = __webpack_require__(96301);
// EXTERNAL MODULE: ./store/features/genericSlice.js
var genericSlice = __webpack_require__(88751);
// EXTERNAL MODULE: ./utils/addTocart.js
var addTocart = __webpack_require__(27522);
;// CONCATENATED MODULE: ./components/cart/cartHelper.js












const setShippingAddress = async (data, cb, needAnalytics, errorCb, expPayPalCallBackErrorMsg)=>{
    var ref;
    var ref1;
    const { user ={}  } = (ref1 = (ref = store/* store.getState */.h.getState()) === null || ref === void 0 ? void 0 : ref.auth) !== null && ref1 !== void 0 ? ref1 : {};
    if (data.postalCode && data.postalCode.trim() !== "") {
        var ref2, ref3, ref4;
        const address = {
            postalCode: (ref2 = data.postalCode) === null || ref2 === void 0 ? void 0 : ref2.trim(),
            state: (ref3 = data.state) === null || ref3 === void 0 ? void 0 : ref3.trim(),
            country: (ref4 = data.country) === null || ref4 === void 0 ? void 0 : ref4.trim()
        };
        if (!(data === null || data === void 0 ? void 0 : data.email)) {
            data.email = user === null || user === void 0 ? void 0 : user.sub;
        }
        const { firstName , lastName , streetName , streetNumber , city , email , phone  } = data;
        if (firstName) address.firstName = firstName.trim();
        if (lastName) address.lastName = lastName.trim();
        if (streetName) address.streetName = streetName.trim();
        if (streetNumber) address.streetNumber = streetNumber.trim();
        if (city) address.city = city.trim();
        if (email) address.email = email.trim().toLowerCase();
        if (phone) address.phone = phone.trim();
        const actions = [
            {
                action: "setShippingAddress",
                address: address
            }
        ];
        if (email) actions.push({
            action: "setCustomerEmail",
            email: email.trim().toLowerCase()
        });
        if (user === null || user === void 0 ? void 0 : user.koc) {
            actions.push({
                action: "setCustomType",
                type: {
                    key: "order",
                    typeId: "type"
                },
                fields: {
                    CSRAssociateId: user === null || user === void 0 ? void 0 : user.koc,
                    orderType: "ISC"
                }
            });
        }
        const payload = {
            actions: actions
        };
        await store/* store.dispatch */.h.dispatch((0,cartSlice/* shipmentUpdate */.NM)(payload)).unwrap().then((res)=>{
            if ((res === null || res === void 0 ? void 0 : res.type) === "Cart" && res.lineItems.length > 0) {
                store/* store.dispatch */.h.dispatch((0,cartSlice/* setCart */.RV)(res));
                const quantityLineItems = res === null || res === void 0 ? void 0 : res.lineItems;
                const payload = (0,helperV2/* getQuantityCount */.PW)(quantityLineItems);
                store/* store.dispatch */.h.dispatch((0,cartSlice/* setCartCount */.oJ)(payload));
                getShippingMethods(expPayPalCallBackErrorMsg);
                cb && cb(address.postalCode, "success");
                needAnalytics && needAnalytics("success");
            } else {
                if (!phone) {
                    cb && cb(address.postalCode, "failure", "no items to ship in cart");
                }
            }
        }).catch((error)=>{
            errorCb && errorCb(error);
            if (!phone) {
                cb && cb(address.postalCode, "failure", "failed to set shipping address.");
            }
        });
    }
};
const getShippingMethods = async (expPayPalCallBackErrorMsg)=>{
    var ref, ref1, ref2, ref3;
    var ref4;
    const cart = (ref4 = (ref = store/* store */.h === null || store/* store */.h === void 0 ? void 0 : store/* store.getState */.h.getState()) === null || ref === void 0 ? void 0 : (ref1 = ref.cart) === null || ref1 === void 0 ? void 0 : ref1.cart) !== null && ref4 !== void 0 ? ref4 : {};
    const lineItemsLength = (cart === null || cart === void 0 ? void 0 : cart.lineItems) ? cart.lineItems.length : 0;
    // const taxedPrice = getState().cart?.cart?.data?.taxedPrice;
    const shippingZip = localStorage.getItem("shippingZip");
    const { taxedPrice ="" , shippingAddress: { postalCode: shippingAddressPostCode = ""  } = {}  } = cart;
    let shippingCost = 0;
    var ref5;
    shippingCost = Number(((ref5 = cart === null || cart === void 0 ? void 0 : (ref2 = cart.shippingTotal) === null || ref2 === void 0 ? void 0 : ref2.centAmount) !== null && ref5 !== void 0 ? ref5 : 0) / 100).toFixed(2);
    let promoCodes = [];
    if ((cart === null || cart === void 0 ? void 0 : (ref3 = cart.customLineItems) === null || ref3 === void 0 ? void 0 : ref3.length) > 0) {
        promoCodes = promoCodes.concat(await (0,helper/* getShippingDiscountPromoCodes */.oH8)(cart));
        promoCodes.filter((item)=>{
            return (item === null || item === void 0 ? void 0 : item.type) === "shipping";
        }).forEach((item)=>{
            shippingCost = Number(shippingCost) + Number(item.discount);
        });
    }
    if (lineItemsLength > 0 && shippingZip && shippingZip.trim() !== "" && shippingAddressPostCode && (!taxedPrice || !shippingCost || shippingCost && shippingCost * 1 === 0)) {
        await store/* store.dispatch */.h.dispatch((0,cartSlice/* shipmentCart */.pw)(expPayPalCallBackErrorMsg)).unwrap().then((response)=>{
            if (response && response["shipping-details"]) {
                updateProductDetailToStore(response);
            } else {
                getShippingDetails().then((response)=>{
                    updateProductDetailToStore(response);
                }).catch((error)=>{
                    console.error(error);
                });
            }
        });
    }
};
const getProfileData = async function() {
    let errorMsg = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    let profile = {};
    try {
        const res = await store/* store.dispatch */.h.dispatch((0,checkoutSlice/* getProfile */.Ai)());
        if (res && res.data) {
            var ref, ref1, ref2, ref3;
            localStorage.setItem("profile-version", (ref = res.data) === null || ref === void 0 ? void 0 : ref.version);
            profile = res.data;
            profile.postalCode = (ref1 = profile === null || profile === void 0 ? void 0 : profile.addresses[0]) === null || ref1 === void 0 ? void 0 : ref1.postalCode;
            const profileAddr = profile === null || profile === void 0 ? void 0 : (ref2 = profile.addresses) === null || ref2 === void 0 ? void 0 : ref2.find((addr)=>{
                var ref, ref1;
                return ((ref = addr.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.label) === "Profile";
            });
            profile.profileAddrId = profileAddr === null || profileAddr === void 0 ? void 0 : profileAddr.id;
            profile.addresses = profile === null || profile === void 0 ? void 0 : (ref3 = profile.addresses) === null || ref3 === void 0 ? void 0 : ref3.filter((addr)=>{
                var ref, ref1;
                return ((ref = addr.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.label) !== "Profile";
            });
            let addresses = profile === null || profile === void 0 ? void 0 : profile.addresses;
            if (profile === null || profile === void 0 ? void 0 : profile.defaultShippingAddressId) {
                const index = addresses.findIndex((item)=>item.id === profile.defaultShippingAddressId);
                addresses = (0,helper/* arrayMove */.RpN)(profile === null || profile === void 0 ? void 0 : profile.addresses, index, 0);
            }
            profile.addresses = addresses;
        }
    } catch (err) {
        errorMsg && store/* store.dispatch */.h.dispatch((0,genericSlice/* showToast */.CF)({
            message: errorMsg,
            isVisible: true
        }));
    }
    return profile;
};
const removeCartItem = async function(data) {
    let cb = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    var ref, ref1;
    const { id ="" , quantity =0 , isComboSku =false , isBundleParent =false , sku  } = data;
    let payload;
    var ref2;
    const { shippingAddress: { postalCode =""  } = {}  } = (ref2 = (ref = store/* store */.h === null || store/* store */.h === void 0 ? void 0 : store/* store.getState */.h.getState()) === null || ref === void 0 ? void 0 : (ref1 = ref.cart) === null || ref1 === void 0 ? void 0 : ref1.cart) !== null && ref2 !== void 0 ? ref2 : {};
    if (!Array.isArray(data)) {
        const payloadData = {
            lineItemId: id,
            quantity,
            isBundle: isComboSku,
            isBundleParent,
            sku
        };
        payload = removeFromCart(payloadData);
    } else {
        payload = setRemoveCartPayload(data);
    }
    payload = payload.reduce((acc, ini)=>{
        if (!acc.filter((item)=>{
            return (item === null || item === void 0 ? void 0 : item.lineItemId) === (ini === null || ini === void 0 ? void 0 : ini.lineItemId);
        }).length) {
            acc.push(ini);
        }
        return acc;
    }, []);
    const body = {
        actions: payload
    };
    await store/* store.dispatch */.h.dispatch((0,cartSlice/* removeFromCartLineItem */.Z5)(body)).unwrap().then((res)=>{
        store/* store.dispatch */.h.dispatch((0,cartSlice/* setCart */.RV)(res));
        const quantityLineItems = res === null || res === void 0 ? void 0 : res.lineItems;
        const payload = (0,helperV2/* getQuantityCount */.PW)(quantityLineItems);
        store/* store.dispatch */.h.dispatch((0,cartSlice/* setCartCount */.oJ)(payload));
        if (res.lineItems.length > 0) {
            if (postalCode) {
                getShippingMethods();
            }
        } else {
            (0,cart/* deleteFromCart */.EI)(cb);
        }
    });
};
const getProductsById = async (ids)=>{
    let query = "";
    ids.forEach((id, i)=>{
        query += '"'.concat(id, '"');
        if (i + 1 !== ids.length) query += ", ";
    });
    try {
        const response = await store/* store.dispatch */.h.dispatch((0,cartSlice/* recentlyViewed */.er)(query)).unwrap().then((res)=>{
            if (res === null || res === void 0 ? void 0 : res.results) {
                return res.results;
            }
        });
        if (response) return response;
    } catch (err) {
        console.error("Failed to fetch product details", err);
    }
    return [];
};
const getShippingDetails = async ()=>{
    try {
        var ref, ref1, ref2;
        const cart = (ref = store/* store */.h === null || store/* store */.h === void 0 ? void 0 : store/* store.getState */.h.getState()) === null || ref === void 0 ? void 0 : (ref1 = ref.cart) === null || ref1 === void 0 ? void 0 : ref1.cart;
        if (!(cart === null || cart === void 0 ? void 0 : cart.id)) {
            console.error("Cart ID is missing");
        }
        const response = await api/* apim.get */.TH.get("".concat(constants.shippingCostEndPoint, "?cartId=").concat(cart.id));
        if (!(response === null || response === void 0 ? void 0 : (ref2 = response.data) === null || ref2 === void 0 ? void 0 : ref2.results)) {
            console.error("Invalid response from shipping API");
        }
        return {
            "shipping-details": {
                results: response.data.results
            },
            shippingCost: true
        };
    } catch (error) {
        console.error(error.message || "Cannot ship to your location");
    }
};
const updateProductDetailToStore = (response)=>{
    var ref;
    const shippingDetails = response && ((ref = response["shipping-details"]) === null || ref === void 0 ? void 0 : ref.results) || [];
    var ref1;
    const validProducts = (ref1 = shippingDetails.filter((item)=>!item.warningMessage)) !== null && ref1 !== void 0 ? ref1 : [];
    var ref2;
    const inValidProducts = (ref2 = shippingDetails.filter((item)=>item.warningMessage)) !== null && ref2 !== void 0 ? ref2 : [];
    store/* store.dispatch */.h.dispatch((0,cartSlice/* setShipping */.YO)(validProducts));
    store/* store.dispatch */.h.dispatch((0,cartSlice/* setNoshipping */.qT)(inValidProducts));
};
const getMessageStatus = (info)=>{
    const { data , email , hideAlerts , i18n , checkoutMode , isMobile , alert ={}  } = info;
    if (data.cancelled || email || !hideAlerts) {
        if (isMobile) {
            if (alert.show) {
                return true;
            } else if (!alert.show && data.outOfStock) {
                return true;
            } else if (!alert.show && !data.outOfStock && data.noShipping) {
                return true;
            } else if (data.category !== "Install Services" && data.category !== "Design Services") {
                if (data.backOrder && data.leadTime && data.quantity > data.availableQty) {
                    return true;
                } else if (!alert.show) {
                    if (data.outOfStock || data.noShipping) {
                        return false;
                    } else {
                        return true;
                    }
                } else {
                    return false;
                }
            } else return false;
        } else {
            return true;
        }
    } else if (!data.cancelled && hideAlerts && data.backOrder && data.leadTime && data.quantity > data.availableQty && i18n.backOrderMssg) {
        return true;
    } else if (!checkoutMode && !isMobile) {
        return true;
    } else {
        return false;
    }
};
const handleAddtoCartResponse = (param)=>{
    let { payload  } = param;
    if (payload) {
        store/* store.dispatch */.h.dispatch((0,cartSlice/* setCart */.RV)(payload));
    }
    store/* store.dispatch */.h.dispatch((0,cartSlice/* setQtyLoading */.LR)(false));
};
const handleQuantityChange = async function() {
    let data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { id ="" , sku ="" , quantity =0 , isComboSku =false , isBundleParent =false , stockCheck , cb  } = data;
    let additionalInfo = {};
    var ref;
    const { cart: { qtyLoading =false , cart: { lineItems =[]  } = {}  } = {}  } = (ref = store/* store */.h === null || store/* store */.h === void 0 ? void 0 : store/* store.getState */.h.getState()) !== null && ref !== void 0 ? ref : {};
    var ref1;
    const cartItem = (ref1 = lineItems.find((item)=>{
        const { custom: { fields: { isBundleChildItem =false  } = {}  } = {} , variant: { sku: variantSku = ""  } = {}  } = item;
        if (isComboSku) {
            if (!isBundleChildItem && variantSku === sku) return item;
        } else if (!isBundleChildItem && variantSku === sku) {
            return item;
        }
    })) !== null && ref1 !== void 0 ? ref1 : {};
    const { custom: { variant: { attributes =[]  } = {} , fields: { roomInfo ="" , isBackOrderable: backorder = false  } = {}  } = {} , quantity: cartQuantity = 0 , id: lineItemId = ""  } = cartItem;
    const brand = get_default()(attributes === null || attributes === void 0 ? void 0 : attributes.find((attr)=>attr.name === "CustomerFacingBrand"), "value", "");
    if (roomInfo) {
        var ref2, ref3;
        const roomInfoObj = JSON.parse(roomInfo["0"]);
        const { productType ="" , soldByBox , soldByUom  } = roomInfoObj;
        const isTrim = productType === "trim";
        const totalPiecesNo = isTrim ? quantity : soldByBox * quantity;
        const totalOverage = soldByUom > 0 && totalPiecesNo > 0 ? totalPiecesNo / soldByUom : 0;
        const overageVal = Number(cartItem === null || cartItem === void 0 ? void 0 : (ref2 = cartItem.custom) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.fields) === null || ref3 === void 0 ? void 0 : ref3.overage);
        const overagePercent = overageVal > 0 ? overageVal / 100 : 0;
        const totalNeeded = Math.floor(totalOverage) / (1 + overagePercent);
        additionalInfo = {
            ...roomInfoObj,
            productType: productType,
            totalNeeded: totalNeeded.toFixed(2),
            totalArea: totalOverage.toFixed(2),
            soldByBox: Number(soldByBox),
            soldByUom: Number(soldByUom),
            customQuantity: quantity,
            overage: overageVal.toString(),
            roomInfo: true
        };
    }
    if (quantity > cartQuantity && !stockCheck) {
        var ref4, ref5;
        if (Object.keys(additionalInfo).length > 0) {
            (0,helper/* recalculateCartRoomInfo */.NxS)(lineItemId, additionalInfo);
            return;
        } else if (cartItem === null || cartItem === void 0 ? void 0 : (ref4 = cartItem.custom) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.fields) === null || ref5 === void 0 ? void 0 : ref5.customQuantity) {
            (0,helper/* recalculateCartRoomInfo */.NxS)(lineItemId, {
                quantity
            });
            return;
        } else {
            const payload = await (0,addTocart/* addToCartItem */.q)([
                {
                    lineItemId: lineItemId,
                    sku,
                    quantity: quantity - cartQuantity,
                    isBundle: isComboSku,
                    backorder,
                    brand: brand === null || brand === void 0 ? void 0 : brand.toLowerCase()
                }
            ]);
            const body = {
                actions: payload
            };
            store/* store.dispatch */.h.dispatch((0,cartSlice/* addToCart */.Xq)(body)).unwrap().then((res)=>{
                handleAddtoCartResponse(res);
                getShippingMethods();
            });
            return;
        }
    }
    // change quantity for bundle
    if (isBundleParent) {
        (0,cart/* getStock */.K5)(sku).then(async (stock)=>{
            const isAvailableQty = quantity <= stock;
            const payload = await (0,addTocart/* addToCartItem */.q)([
                {
                    lineItemId: id,
                    isBundleParent,
                    sku,
                    quantity: isAvailableQty ? quantity : stock
                }
            ]);
            const body = {
                actions: payload
            };
            store/* store.dispatch */.h.dispatch((0,cartSlice/* addToCart */.Xq)(body)).unwrap().then((res)=>{
                handleAddtoCartResponse(res);
                getShippingMethods();
            });
            if (!isAvailableQty) {
                cb(stock);
            }
            store/* store.dispatch */.h.dispatch((0,cartSlice/* setQtyLoading */.LR)(qtyLoading));
        }).catch(()=>{
            store/* store.dispatch */.h.dispatch((0,cartSlice/* setQtyLoading */.LR)(qtyLoading));
        });
    } else if (quantity > cartQuantity) {
        store/* store.dispatch */.h.dispatch((0,cartSlice/* setQtyLoading */.LR)(!qtyLoading));
        // Checking stock
        (0,cart/* getStock */.K5)(sku).then(async (stock)=>{
            var ref, ref1;
            // At first time whenever changes made with input feild
            if (Object.keys(additionalInfo).length > 0) {
                if (quantity <= stock) {
                    (0,helper/* recalculateCartRoomInfo */.NxS)(lineItemId, additionalInfo, cartSlice/* setQtyLoading */.LR);
                    return;
                } else if (quantity > stock) {
                    store/* store.dispatch */.h.dispatch((0,cartSlice/* setQtyLoading */.LR)(false));
                    cb(stock);
                    return;
                }
            } else if (cartItem === null || cartItem === void 0 ? void 0 : (ref = cartItem.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.customQuantity) {
                (0,helper/* recalculateCartRoomInfo */.NxS)(lineItemId, {
                    quantity
                }, cartSlice/* setQtyLoading */.LR);
                return;
            }
            if (quantity > stock) {
                if (stock > cartQuantity) {
                    const payload = await (0,addTocart/* addToCartItem */.q)([
                        {
                            lineItemId: lineItemId,
                            sku,
                            quantity: stock - cartQuantity,
                            isBundle: isComboSku,
                            backorder,
                            brand: brand === null || brand === void 0 ? void 0 : brand.toLowerCase()
                        }
                    ]);
                    const body = {
                        actions: payload
                    };
                    store/* store.dispatch */.h.dispatch((0,cartSlice/* addToCart */.Xq)(body)).unwrap().then((res)=>{
                        cb(stock);
                        handleAddtoCartResponse(res);
                        getShippingMethods();
                    });
                    cb(stock);
                } else if (stock === cartQuantity) {
                    cb(stock);
                    store/* store.dispatch */.h.dispatch((0,cartSlice/* getCart */.dv)());
                } else if (stock > 0) {
                    const payloadData = {
                        lineItemId: lineItemId,
                        quantity: cartQuantity - stock,
                        isBundle: isComboSku,
                        sku
                    };
                    const payload1 = removeFromCart(payloadData);
                    const body1 = {
                        actions: payload1
                    };
                    store/* store.dispatch */.h.dispatch((0,cartSlice/* addToCart */.Xq)(body1)).unwrap().then((res)=>{
                        handleAddtoCartResponse(res);
                        getShippingMethods();
                    });
                } else {
                    cb();
                }
            } else if (cartQuantity !== stock) {
                const payload2 = await (0,addTocart/* addToCartItem */.q)([
                    {
                        lineItemId: lineItemId,
                        sku,
                        quantity: quantity - cartQuantity,
                        isBundle: isComboSku,
                        backorder,
                        brand: brand === null || brand === void 0 ? void 0 : brand.toLowerCase()
                    }
                ]);
                const body2 = {
                    actions: payload2
                };
                store/* store.dispatch */.h.dispatch((0,cartSlice/* addToCart */.Xq)(body2)).unwrap().then((res)=>{
                    handleAddtoCartResponse(res);
                    getShippingMethods();
                });
            }
            store/* store.dispatch */.h.dispatch((0,cartSlice/* setQtyLoading */.LR)(qtyLoading));
        }).catch(()=>{
            store/* store.dispatch */.h.dispatch((0,cartSlice/* setQtyLoading */.LR)(qtyLoading));
        });
    } else if (cartQuantity > quantity) {
        var ref6, ref7;
        store/* store.dispatch */.h.dispatch((0,cartSlice/* setQtyLoading */.LR)(!qtyLoading));
        if (Object.keys(additionalInfo).length > 0) {
            (0,helper/* recalculateCartRoomInfo */.NxS)(lineItemId, additionalInfo, cartSlice/* setQtyLoading */.LR);
            return;
        } else if (cartItem === null || cartItem === void 0 ? void 0 : (ref6 = cartItem.custom) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.fields) === null || ref7 === void 0 ? void 0 : ref7.customQuantity) {
            (0,helper/* recalculateCartRoomInfo */.NxS)(lineItemId, {
                quantity
            }, cartSlice/* setQtyLoading */.LR);
            return;
        }
        const payloadData = {
            lineItemId: lineItemId,
            quantity: cartQuantity - quantity,
            isBundle: isComboSku,
            sku
        };
        const payload1 = removeFromCart(payloadData, true);
        const body1 = {
            actions: payload1
        };
        store/* store.dispatch */.h.dispatch((0,cartSlice/* addToCart */.Xq)(body1)).unwrap().then((res)=>{
            handleAddtoCartResponse(res);
            getShippingMethods();
        });
    }
};


/***/ }),

/***/ 36130:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_core_AutoSuggestion_v1_index_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(56387);
/* harmony import */ var _components_core_AutoSuggestion_v1_index_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_components_core_AutoSuggestion_v1_index_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _constants_regex__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(49139);




const AutoSuggestion = (param)=>{
    let { id , borderValue , placeholderLabel , prefix , suffix , optionList , ariaLabel , selectedValue , iconAnalyticsdata , handleSelect , handleChange , title =""  } = param;
    const [isOpen, setIsOpen] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const getInputVal = (item)=>{
        const value = item.replace(_constants_regex__WEBPACK_IMPORTED_MODULE_2__/* .ZIP_CODE_MATCH_WHITESPACE_REGEX */ .bY, "").match(_constants_regex__WEBPACK_IMPORTED_MODULE_2__/* .ZIP_CODE_DIGIT_REGEX */ .lY);
        const inputVal = value != null ? value[0] : item;
        handleChange(inputVal);
        setIsOpen(true);
    };
    const getSuggestionVal = (item)=>{
        handleSelect(item);
        setIsOpen(false);
    };
    document.addEventListener("click", function(e) {
        var ref;
        if (setIsOpen && !((ref = document.getElementById("".concat(id, "-wrapper"))) === null || ref === void 0 ? void 0 : ref.contains(e.target))) setIsOpen(false);
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_components_core_AutoSuggestion_v1_index_module_scss__WEBPACK_IMPORTED_MODULE_3___default().autoSuggetionWrapper),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "auto-suggestion",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "auto-suggestion__input-container ".concat(borderValue === "bottom" ? "auto-suggestion__border-bottom" : "auto-suggestion__border-all"),
                        children: [
                            prefix !== undefined && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "auto-suggestion__input-field-prefix",
                                children: prefix
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                type: "text",
                                className: "auto-suggestion__input",
                                placeholder: placeholderLabel,
                                value: selectedValue,
                                onChange: (e)=>getInputVal(e.target.value),
                                "aria-label": ariaLabel,
                                onBlur: ()=>setIsOpen(false),
                                title: title
                            }),
                            suffix !== undefined && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "auto-suggestion__input-field-suffix " + (iconAnalyticsdata ? "gbh-data-layer" : ""),
                                "data-gbh-data-layer": iconAnalyticsdata || null,
                                children: suffix
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "auto-suggestion__dropdown ".concat(isOpen ? " active" : ""),
                        children: (optionList === null || optionList === void 0 ? void 0 : optionList.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                            className: "auto-suggestion__dropdown-items",
                            children: optionList.map((item, i)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                    onMouseDown: ()=>getSuggestionVal(item),
                                    className: "auto-suggestion__dropdown-item",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "auto-suggestion__dropdown-item-value",
                                        children: item
                                    })
                                }, i))
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AutoSuggestion);


/***/ }),

/***/ 7872:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Button_Button; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/core/Button/Button.module.scss
var Button_module = __webpack_require__(77529);
var Button_module_default = /*#__PURE__*/__webpack_require__.n(Button_module);
;// CONCATENATED MODULE: ./public/images/backArrow.png
/* harmony default export */ var backArrow = ({"src":"/_next/static/media/backArrow.efb2b3dc.png","height":18,"width":18,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAElBMVEVMaXFISEhISEhISEhISEhHR0d9PL0uAAAABnRSTlMAQVETiRCREjDgAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAJklEQVQImWNgYGBiZgADRiYIzQylGViYGMEAwYBLwRUzMDCxgigAB6cANS8/ZOEAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
// EXTERNAL MODULE: ./components/Shared/Image/index.js
var Image = __webpack_require__(70914);
;// CONCATENATED MODULE: ./components/core/Button/Button.jsx








const Button = /*#__PURE__*/ (0,react.forwardRef)((props, ref)=>{
    const { label , size , arrowImg , image ="" , type , flexible , disabled , onClick , customClass , to , target , className , loading , role , tag , tabIndex =0 , ariaLabel , parentClass , useDefaultClass , testid ="" , icon , iconAlt ="" , iconClass ="" , ...remainingProps } = props;
    const buttonClass = classnames_default()("kf-react-button", "button", className ? className : null, size ? size : "large", type ? type : "primary", flexible ? "flexible" : null, disabled ? "disabled" : null, customClass ? customClass : null, loading ? "loading" : null);
    const ButtonTag = tag === "button" || role === "button" ? "button" : tag === "anchor" ? "a" : (link_default());
    const buttonFullClass = useDefaultClass ? (Button_module_default()).buttonWrapper : (Button_module_default()).buttonWrapper + " " + buttonClass + " " + (parentClass || "");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: buttonFullClass,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonTag, {
            ...remainingProps,
            className: buttonClass,
            onClick: onClick,
            href: to !== null && to !== void 0 ? to : "",
            target: target,
            role: role !== null && role !== void 0 ? role : "",
            tabIndex: tabIndex,
            "aria-label": ariaLabel,
            "aria-disabled": disabled,
            "data-testid": "button".concat(testid ? "-".concat(testid) : ""),
            disabled: disabled,
            ref: ref,
            children: [
                icon ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: iconClass,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                        src: icon,
                        alt: iconAlt
                    })
                }) : null,
                arrowImg && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "arrowImage",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                        src: backArrow,
                        alt: "backArrow "
                    })
                }),
                loading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "loader"
                }),
                image && /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    src: image,
                    alt: label
                }),
                " ",
                label
            ]
        })
    });
});
Button.displayName = "Button";
/* harmony default export */ var Button_Button = (Button);
Button.propTypes = {
    label: (prop_types_default()).string,
    size: (prop_types_default()).string,
    type: (prop_types_default()).string,
    flexible: (prop_types_default()).bool,
    customClass: (prop_types_default()).string,
    onClick: (prop_types_default()).func,
    disabled: (prop_types_default()).bool,
    parentClass: (prop_types_default()).string
};


/***/ }),

/***/ 65764:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Checkbox_Checkbox; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/core/Checkbox/index.module.scss
var index_module = __webpack_require__(43090);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
;// CONCATENATED MODULE: ./public/icons/checkbox-tick.svg
/* harmony default export */ var checkbox_tick = ({"src":"/_next/static/media/checkbox-tick.3804ed83.svg","height":10,"width":12});
// EXTERNAL MODULE: ./constants/config.js
var constants_config = __webpack_require__(19514);
;// CONCATENATED MODULE: ./components/core/Checkbox/Checkbox.jsx







const Checkbox = (props)=>{
    const [config, setConfig] = (0,react.useState)({});
    const { textClassName ="checkbox_default" , inline =false  } = props;
    (0,react.useEffect)(()=>{
        (0,constants_config/* getConfig */.i)().then((config)=>{
            setConfig(config === null || config === void 0 ? void 0 : config.general);
        }).catch((err)=>console.log(err));
    }, []);
    const handleCheck = (e)=>{
        e.target.checked = !props.checked;
        if (e.keyCode === 32 || e.keyCode === 13) {
            props.onChange(e);
            e.preventDefault();
        }
    };
    var _tabIndex, _role, _checkBoxAria, ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((index_module_default()).checkboxWrapper).concat(inline ? " ".concat((index_module_default()).inlineCheckbox) : ""),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
            tabIndex: (_tabIndex = props.tabIndex) !== null && _tabIndex !== void 0 ? _tabIndex : 0,
            "aria-checked": props.checked,
            role: (_role = props.role) !== null && _role !== void 0 ? _role : "checkbox",
            "aria-label": (_checkBoxAria = props.checkBoxAria) !== null && _checkBoxAria !== void 0 ? _checkBoxAria : props.aria,
            htmlFor: props.id,
            className: classnames_default()({
                checkbox: true,
                "checkbox--swatch": props.swatch,
                "checkbox--black": props.type === "black"
            }),
            onKeyDown: handleCheck,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                    "data-gbh-data-layer": props.analyticsData || null,
                    "data-gbh-data-layer-custom": props.analyticsDataCustom || null,
                    className: props.analyticsData ? "gbh-data-layer" : "",
                    type: "checkbox",
                    name: props.id,
                    id: props.id,
                    onChange: (e)=>props.onChange(e),
                    checked: props.checked,
                    disabled: props.disabled,
                    "data-testid": (ref = props === null || props === void 0 ? void 0 : props.dataTestId) !== null && ref !== void 0 ? ref : ""
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "checkbox__border",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "checkbox__marker",
                        children: (checkbox_tick === null || checkbox_tick === void 0 ? void 0 : checkbox_tick.src) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            className: "checkbox__marker-icon",
                            src: checkbox_tick.src,
                            alt: "checkbox-icon",
                            "aria-hidden": true
                        }) : null
                    })
                }),
                (config === null || config === void 0 ? void 0 : config.swatchUrl) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "checkbox__swatch",
                    style: {
                        backgroundImage: 'url("'.concat(config === null || config === void 0 ? void 0 : config.swatchUrl).concat(props === null || props === void 0 ? void 0 : props.swatch, '?$PLPSwatch_Mobile50$")')
                    }
                }) : null,
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: textClassName,
                    children: props.value
                })
            ]
        })
    });
};
/* harmony default export */ var Checkbox_Checkbox = (Checkbox);
Checkbox.protoTypes = {
    textClassName: (prop_types_default()).string,
    checked: (prop_types_default()).bool,
    id: (prop_types_default()).string,
    tabIndex: (prop_types_default()).number,
    role: (prop_types_default()).string,
    checkBoxAria: (prop_types_default()).string,
    aria: (prop_types_default()).string,
    swatch: (prop_types_default()).string,
    type: (prop_types_default()).string,
    analyticsData: (prop_types_default()).object,
    analyticsDataCustom: (prop_types_default()).object,
    disabled: (prop_types_default()).bool,
    value: (prop_types_default()).bool,
    onChange: (prop_types_default()).func
};


/***/ }),

/***/ 32982:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9473);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _store_features_genericSlice__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88751);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96301);
/* harmony import */ var _public_images_swatch_missing_jpeg__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(36562);







const ColorSwatch = (props)=>{
    const { type ="" , id ="" , label ="" , name ="" , value ="" , checked =false , color ="" , colorUrl ="" , initConfig  } = props || {};
    const { globalConfig  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_3__/* .selectGenericState */ .Px);
    const { general: { scene7AccountName ="PAWEB"  } = {}  } = initConfig || globalConfig;
    const swatchUrlName = colorUrl ? colorUrl + "?$PDPSwatch_Desk$" : _public_images_swatch_missing_jpeg__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z;
    const swatchUrl = swatchUrlName.replace("PAWEB", scene7AccountName);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "color-swatch",
        title: label,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                type: type === "selector" ? "radio" : "checkbox",
                id: id,
                name: name,
                value: value,
                checked: checked,
                style: {
                    backgroundColor: color
                },
                onClick: (e)=>!checked && props.onClick(e.target.value),
                onChange: (e)=>props.onChange(e),
                "data-testid": "color-swatch-".concat(id !== null && id !== void 0 ? id : "0")
            }),
            type !== "selector" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                htmlFor: id,
                children: label
            }),
            type === "selector" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                className: "".concat(!colorUrl || colorUrl.includes(_constants_index__WEBPACK_IMPORTED_MODULE_4__.SWATCH_NA) ? "--no-swatch" : ""),
                htmlFor: id,
                children: swatchUrl ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    role: "presentation",
                    src: swatchUrl,
                    alt: "NA"
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    role: "presentation",
                    src: _constants_index__WEBPACK_IMPORTED_MODULE_4__.EMPTY_PIXEL,
                    alt: "EMPTY_PIXEL"
                })
            })
        ]
    });
};
ColorSwatch.defaultProps = {
    type: "",
    label: "",
    id: "",
    name: "",
    value: undefined,
    color: "",
    colorUrl: "",
    checked: undefined,
    defaultChecked: false,
    onClick: ()=>{},
    onChange: ()=>{}
};
ColorSwatch.propTypes = {
    type: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
    label: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
    id: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
    name: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
    value: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string) || (prop_types__WEBPACK_IMPORTED_MODULE_6___default().number),
    color: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
    colorUrl: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
    checked: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().bool),
    defaultChecked: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().bool),
    onClick: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().func),
    onChange: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().func),
    onMouseEnter: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().func)
};
/* harmony default export */ __webpack_exports__["Z"] = (ColorSwatch);


/***/ }),

/***/ 22231:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _constants_regex__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(49139);



const Heading = (props)=>{
    const { level =6 , fontSize , fontWeight , className ="" , children  } = props;
    const Tag = _constants_regex__WEBPACK_IMPORTED_MODULE_2__/* .NUMBER_HEADING_REGEX.test */ .uZ.test("".concat(level)) ? "h" + level : "h6";
    let classes = "";
    classes = (fontSize ? "fs-".concat(fontSize) : "") + " ";
    classes += fontWeight ? "fw-".concat(fontWeight) : "";
    if (!classes) classes = "";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Tag, {
        className: "".concat(classes, " ").concat(className),
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Heading);


/***/ }),

/***/ 15540:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var lodash_escapeRegExp__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3522);
/* harmony import */ var lodash_escapeRegExp__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_escapeRegExp__WEBPACK_IMPORTED_MODULE_2__);



const Highlight = (param)=>{
    let { text ="" , highlight =""  } = param;
    if (!highlight.trim()) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        children: text
    });
    const regex = new RegExp("(".concat(lodash_escapeRegExp__WEBPACK_IMPORTED_MODULE_2___default()(highlight), ")"), "gi");
    const parts = text.split(regex);
    return parts.filter((part)=>part).map((part, i)=>regex.test(part) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
            className: "highlight-text",
            children: part
        }, i) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
            children: part
        }, i));
};
/* harmony default export */ __webpack_exports__["Z"] = (Highlight);


/***/ }),

/***/ 18377:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _hooks_useSmartCrop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83886);
/* harmony import */ var _hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2595);




const DynamicImage = (param)=>{
    let { imgUrl ="" , alt ="" , className ="" , uniqueId ="" , urlModifiers ="" , ...restProps } = param;
    const smartCrop = (0,_hooks_useSmartCrop__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    const isSsr = (0,_hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    const cropedImage = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const imgPlaceholder = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
    const isScene7Img = imgUrl === null || imgUrl === void 0 ? void 0 : imgUrl.includes("scene7");
    const [bgColorImage, setBgColorImage] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (!isSsr && smartCrop.scriptStatus && isScene7Img && window.s7responsiveImage) {
            smartCrop.applySmartCrop(cropedImage.current);
        }
    }, [
        smartCrop.scriptStatus,
        imgUrl,
        window.s7responsiveImage,
        uniqueId,
        isSsr
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (urlModifiers && imgUrl) {
            setBgColorImage((imgUrl === null || imgUrl === void 0 ? void 0 : imgUrl.includes("?")) ? "".concat(imgUrl, "&").concat(urlModifiers) : "".concat(imgUrl, "?").concat(urlModifiers));
        }
    }, [
        imgUrl,
        urlModifiers
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
        ref: cropedImage,
        src: imgPlaceholder,
        "data-src": urlModifiers ? bgColorImage : imgUrl,
        "data-mode": "smartcrop",
        alt: alt,
        className: className,
        ...restProps
    }, uniqueId);
};
/* harmony default export */ __webpack_exports__["default"] = (DynamicImage);


/***/ }),

/***/ 61319:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


const ImagePlaceHolder = (param)=>{
    let { assetID =""  } = param;
    if (!assetID) return null;
    const imgPlaceholder = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
        src: imgPlaceholder,
        "data-src": imgPlaceholder,
        "data-mode": "smartcrop",
        alt: "Image Placeholder",
        className: "fluidimage cmp-image__image image-placeholder"
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ImagePlaceHolder);


/***/ }),

/***/ 3372:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24400);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(55760);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96301);
/* harmony import */ var _components_core_Input_Input_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(21531);
/* harmony import */ var _components_core_Input_Input_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_components_core_Input_Input_module_scss__WEBPACK_IMPORTED_MODULE_6__);







const Input = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)((props, ref)=>{
    var ref1;
    const inputRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const errorRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const { t  } = (0,next_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)();
    var _type;
    const [type, setType] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)((_type = props.type) !== null && _type !== void 0 ? _type : "text");
    const [toggle, setToggle] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [showList, setShowList] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [matchedItem, setMatchedItem] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [selectedListItem, setListItem] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [focus, setFocus] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { showError , errorMessage , id , className ="" , placeholder =""  } = props;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (toggle) setType("text");
        else setType("password");
    }, [
        toggle
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (props === null || props === void 0 ? void 0 : props.focus) {
            inputRef.current.focus();
        }
    }, [
        props === null || props === void 0 ? void 0 : props.focus
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (showError && errorMessage) {
            errorRef.current.focus();
        }
    }, [
        showError,
        errorMessage
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const keyPressEvent = (e)=>{
            const { KEYCODE  } = _constants_index__WEBPACK_IMPORTED_MODULE_5__["default"];
            if (e.keyCode === KEYCODE.TAB && showList) {
                setShowList(false);
            }
        };
        const containerTarget = (e)=>{
            var ref;
            if (showList && !((ref = document.getElementById("".concat(props.id, "-wrapper"))) === null || ref === void 0 ? void 0 : ref.contains(e.target))) setShowList(false);
        };
        window.addEventListener("click", containerTarget);
        document.addEventListener("keydown", keyPressEvent);
        return ()=>{
            document.removeEventListener("keydown", keyPressEvent);
            window.removeEventListener("click", containerTarget);
        };
    }, [
        showList
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        var ref, ref1;
        if (((ref = props.value) === null || ref === void 0 ? void 0 : ref.length) > 0 && ((ref1 = props.suggestions) === null || ref1 === void 0 ? void 0 : ref1.length) > 0) {
            setShowList(true);
            selectListItem();
            setActivedescendant();
        } else setShowList(false);
    }, [
        props.value,
        props.suggestions
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (showList) setActivedescendant();
    }, [
        showList
    ]);
    const selectListItem = ()=>{
        const listItems = [
            ...props.suggestions
        ];
        const firstMatchedItem = listItems.find((item)=>{
            if (item === null || item === void 0 ? void 0 : item.includes(props.value)) return item;
        });
        setMatchedItem(firstMatchedItem);
    };
    var _id;
    const setActivedescendant = ()=>{
        var ref;
        return setListItem((_id = (ref = document.getElementById("".concat(props.id, "-list"))) === null || ref === void 0 ? void 0 : ref.childNodes[0].id) !== null && _id !== void 0 ? _id : "");
    };
    const inputClasses = classnames__WEBPACK_IMPORTED_MODULE_2___default()("input-field__border", props.disabled ? "--disabled" : null, props.showError ? "--with-error" : null, focus ? "--focused" : null);
    const i18n = {
        show: t("kf.auth.label.show"),
        hide: t("kf.auth.label.hide"),
        resultsText: t("kf.input.aria.resultsText")
    };
    const handleClick = ()=>{
        var ref;
        return (ref = document.getElementById(props.id)) === null || ref === void 0 ? void 0 : ref.focus();
    };
    const handleKeyDown = (e)=>{
        if (showList) {
            const { KEYCODE  } = _constants_index__WEBPACK_IMPORTED_MODULE_5__["default"];
            const ele = [
                ...document.getElementById("".concat(props.id, "-list")).childNodes
            ];
            let index = 0;
            const selectedItem = ele.find((item, i)=>{
                if (item.id === selectedListItem) {
                    index = i;
                    return item;
                }
            });
            switch(e.keyCode){
                case KEYCODE.ESC:
                    setShowList(false);
                    break;
                case KEYCODE.UP:
                    e.preventDefault();
                    if (index > 0) ele.forEach((item, i)=>{
                        if (i === index - 1) {
                            item.classList.add("--hover");
                            (0,_utils_helper__WEBPACK_IMPORTED_MODULE_4__/* .smoothScroll */ .ldy)(item);
                            setListItem(item.id);
                        } else item.classList.remove("--hover");
                    });
                    break;
                case KEYCODE.DOWN:
                    e.preventDefault();
                    if (index < ele.length - 1) ele.forEach((item, i)=>{
                        if (i === index + 1) {
                            item.classList.add("--hover");
                            (0,_utils_helper__WEBPACK_IMPORTED_MODULE_4__/* .smoothScroll */ .ldy)(item);
                            setListItem(item.id);
                        } else item.classList.remove("--hover");
                    });
                    break;
                case KEYCODE.SPACE:
                    break;
                case KEYCODE.ENTER:
                    selectedItem.click();
                    break;
                default:
                    break;
            }
        }
    };
    var _ariaRequried;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "".concat((_components_core_Input_Input_module_scss__WEBPACK_IMPORTED_MODULE_6___default().inputFieldWrapper), " ").concat(className),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: " input-field ".concat(props.customClass ? props.customClass : ""),
            id: "".concat(props.id, "-wrapper"),
            onClick: handleClick,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: inputClasses,
                    children: [
                        props.prefix && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "input-field__prefix",
                            children: props.prefix
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "input-field__value",
                            onKeyDown: (e)=>handleKeyDown(e),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                    ref: ref !== null && ref !== void 0 ? ref : inputRef,
                                    id: props.id,
                                    type: props.type === "password" ? type : props.type,
                                    value: props.value,
                                    name: props.name,
                                    autoComplete: props.autoComplete ? "on" : "off",
                                    maxLength: props.maxLength,
                                    disabled: props.disabled,
                                    placeholder: placeholder ? placeholder : props.label.replace(/\*/g, ""),
                                    onChange: props.onChange,
                                    onKeyUp: props.onKeyUp,
                                    onKeyDown: props.onKeyDown,
                                    onKeyPress: handleKeyDown,
                                    onFocus: (e)=>{
                                        setFocus(true);
                                        props.onFocus && props.onFocus(e);
                                    },
                                    onBlur: (e)=>{
                                        setFocus(false);
                                        props.onBlur && props.onBlur(e);
                                    },
                                    max: props.max,
                                    min: props.min,
                                    autoFocus: props.autoFocus,
                                    "aria-required": ((_ariaRequried = props.ariaRequried) !== null && _ariaRequried !== void 0 ? _ariaRequried : props.label.indexOf("*") > 0) ? true : false,
                                    "aria-activedescendant": props.autoComplete ? selectedListItem : "undefined",
                                    "aria-readonly": props.readOnly ? "true" : "false",
                                    "aria-owns": "".concat(props.id, "-list"),
                                    // aria-expanded={props.autoComplete ? showList : "undefined"}
                                    "aria-haspopup": props.autoComplete ? "listbox" : "false",
                                    "data-testid": "input"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                    htmlFor: props.id,
                                    children: props.label
                                })
                            ]
                        }),
                        props.type === "password" && ((ref1 = props.value) === null || ref1 === void 0 ? void 0 : ref1.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "input-field__suffix",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                tabIndex: "0",
                                "aria-label": toggle ? "".concat(i18n.hide, " ").concat(props.label) : "".concat(i18n.show, " ").concat(props.label),
                                role: "button",
                                onClick: ()=>setToggle(!toggle),
                                className: "input-field__toggle",
                                children: toggle ? i18n.hide : i18n.show
                            })
                        }),
                        props.suffix && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "input-field__suffix",
                            children: props.suffix
                        })
                    ]
                }),
                showList && props.suggestions && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                    id: "".concat(props.id, "-list"),
                    className: "input-field__suggestions",
                    role: "listbox",
                    "aria-label": i18n.resultsText,
                    children: props.suggestions.map((item, i)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                            id: "suggestion-list-item-".concat(i),
                            className: "input-field__list-item ".concat(matchedItem === item ? "--hover" : ""),
                            "aria-selected": selectedListItem === item ? "true" : "false",
                            role: "option",
                            onClick: ()=>props.onSelect(item),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "input-field__list-value",
                                children: item
                            })
                        }, i))
                }),
                showError && errorMessage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    ref: errorRef,
                    "aria-live": "polite",
                    role: "alert",
                    id: "".concat(id, "-error"),
                    className: "input-field__error-message",
                    children: errorMessage
                })
            ]
        })
    });
});
Input.displayName = "Input";
Input.defaultProps = {
    label: ""
};
/* harmony default export */ __webpack_exports__["Z"] = (Input);


/***/ }),

/***/ 78145:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Modal_Modal; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./hooks/useWindowResize.js
var useWindowResize = __webpack_require__(11859);
;// CONCATENATED MODULE: ./components/core/FindingModelNumber/v1/analyticsEventType.js
const getEventFor = (type)=>{
    if (type === null || type === void 0 ? void 0 : type.subCategory1.includes("support:contact")) {
        return "support:contact:form";
    }
    if (type === null || type === void 0 ? void 0 : type.subCategory1.includes("support:find a service part")) {
        return "support:find-a-service-part";
    }
    if (type === null || type === void 0 ? void 0 : type.subCategory1.includes("my account:product registration")) {
        return "my account:register offline kohler products:product information";
    }
    var ref;
    return (ref = type === null || type === void 0 ? void 0 : type.subCategory1) !== null && ref !== void 0 ? ref : "";
};


// EXTERNAL MODULE: ./public/icons/close-white.svg
var close_white = __webpack_require__(26693);
// EXTERNAL MODULE: ./public/icons/modal-close.svg
var modal_close = __webpack_require__(55619);
// EXTERNAL MODULE: ./components/core/Modal/Modal.module.scss
var Modal_module = __webpack_require__(43106);
var Modal_module_default = /*#__PURE__*/__webpack_require__.n(Modal_module);
// EXTERNAL MODULE: ./utils/helper.js + 1 modules
var helper = __webpack_require__(55760);
// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(85518);
;// CONCATENATED MODULE: ./components/core/Modal/Modal.jsx









const Modal = (props)=>{
    const modalWindow = (0,react.useRef)(null);
    const [isRendered, setIsRendered] = (0,react.useState)(false);
    const [width, height] = (0,useWindowResize/* default */.Z)();
    const [style, setStyle] = (0,react.useState)({});
    const { className , children , showModal , modalTitle , labelledBy , describedBy , onModalClose , prevActiveElem , hideCloseIcon , closeButtonAnalytics , analyticsCustomData , needAnalyticsOnContentsLink , dataLayer , StickCloseButton , isWhiteCloseIcon =false , isCloseButtonClicked =()=>{}  } = props;
    const waitingTImeForModalContentToLoad = 500;
    const triggerModalClose = (e)=>{
        (0,helper/* preventBodyScroll */.MVu)(false);
        isCloseButtonClicked();
        onModalClose(e);
    };
    const handleKeyPress = (e)=>{
        const focusElements = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
        const focusContent = modalWindow.current.querySelectorAll(focusElements);
        const firstElem = focusContent[0];
        const lastElem = focusContent[focusContent.length - 1];
        if (e.key === "Escape") {
            triggerModalClose();
        }
        if (e.key === "Tab") {
            if (e.shiftKey && (document.activeElement === firstElem || document.activeElement === modalWindow.current)) {
                e.preventDefault();
                lastElem.focus();
            }
            if (!e.shiftKey && document.activeElement === lastElem) {
                e.preventDefault();
                firstElem.focus();
            }
        }
    };
    (0,react.useEffect)(()=>{
        if (width < 577 || lib/* isIOS */.gn && width < 992) {
            setStyle({
                style: {
                    height: height,
                    minHeight: height
                }
            });
        } else {
            setStyle({});
        }
    }, [
        width,
        height
    ]);
    (0,react.useEffect)(()=>{
        if (showModal) {
            (0,helper/* removeMavenoidChat */.N9B)();
            if (!isRendered) {
                setIsRendered(true);
            }
            window.addEventListener("keydown", handleKeyPress);
            window.prevActiveElement = prevActiveElem !== null && prevActiveElem !== void 0 ? prevActiveElem : document.activeElement;
            modalWindow.current.focus();
            if (needAnalyticsOnContentsLink) {
                addAnalyticsForNavigationLinks();
            }
        } else {
            (0,helper/* addMavenoidChat */.dVG)();
            if (!document.getElementsByClassName("show-modal-popup").length) {
                var ref;
                (ref = window.prevActiveElement) === null || ref === void 0 ? void 0 : ref.focus();
                (0,helper/* setFocus */.kWv)(window.keyFocusCallBack);
            }
        }
        (0,helper/* preventBodyScroll */.MVu)(showModal);
        return ()=>{
            window.removeEventListener("keydown", handleKeyPress);
            (0,helper/* preventBodyScroll */.MVu)(false);
        };
    }, [
        showModal
    ]);
    const getNavigationLinksEventInfo = function(link, linkName) {
        let clickInternalLinks = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "true";
        var ref;
        const type = window.adobeDataLayer.length > 1 ? window.adobeDataLayer[1]["page"]["category"] : {};
        const eventFor = getEventFor(type);
        const internalLinkType = (type === null || type === void 0 ? void 0 : (ref = type.subCategory1) === null || ref === void 0 ? void 0 : ref.includes("my account:product registration")) ? "my account:navigation" : "".concat(eventFor, ":navigation");
        return JSON.stringify({
            clickInternalLinks,
            eventAction: "".concat(eventFor, ":modal:where do i find my product model number:").concat(linkName),
            eventMsg: "n/a",
            eventName: "".concat(eventFor, ":modal:where do i find my product model number:").concat(linkName),
            eventStatus: "n/a",
            eventType: "navigation",
            internalLinkName: linkName,
            internalLinkPosition: (type === null || type === void 0 ? void 0 : type.subCategoryID) || "contact us",
            internalLinkType,
            internalLinkURL: link,
            internalLinkZoneName: "".concat(eventFor, ":modal:where do i find my product model number")
        });
    };
    const addAnalyticsForNavigationLinks = ()=>{
        setTimeout(()=>{
            modalWindow.current.querySelectorAll(".description p a").forEach((link)=>{
                link.classList.add("gbh-data-layer");
                const textContent = (link === null || link === void 0 ? void 0 : link.textContent) || (link.querySelector("u") ? link.querySelector("u").textContent : "");
                const clickInternalLinks = (textContent === null || textContent === void 0 ? void 0 : textContent.toLowerCase()) === "learn more" ? "true" : "false";
                const eventInfo = getNavigationLinksEventInfo(link.getAttribute("href"), textContent === null || textContent === void 0 ? void 0 : textContent.toLowerCase(), clickInternalLinks);
                link.setAttribute("data-gbh-data-layer", eventInfo);
            });
            modalWindow.current.querySelectorAll(".description h6 a").forEach((link)=>{
                if (link.textContent === "Learn More") {
                    link.classList.add("gbh-data-layer");
                    const eventInfo = getNavigationLinksEventInfo(link.getAttribute("href"), link.textContent.toLowerCase());
                    link.setAttribute("data-gbh-data-layer", eventInfo);
                }
            });
            modalWindow.current.querySelectorAll(".modal-popup-body a").forEach((link)=>{
                if (link.textContent === "Continue") {
                    link.classList.add("gbh-data-layer");
                    link.setAttribute("data-gbh-data-layer", dataLayer);
                }
            });
        }, waitingTImeForModalContentToLoad);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Modal_module_default()).modalWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "modal-popup ".concat(showModal ? "show-modal-popup" : "", " ").concat(className ? className : ""),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "modal-popup-content",
                role: "dialog",
                "aria-modal": true,
                tabIndex: "-1",
                "aria-labelledby": labelledBy,
                "aria-describedby": describedBy,
                ref: modalWindow,
                ...style,
                children: [
                    !hideCloseIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "close-button-holder ".concat(StickCloseButton ? "stick-close-button" : ""),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "close-button".concat(closeButtonAnalytics ? " gbh-data-layer" : ""),
                            "data-gbh-data-layer": closeButtonAnalytics,
                            "data-gbh-data-layer-custom": analyticsCustomData || null,
                            onClick: triggerModalClose,
                            tabIndex: "0",
                            role: "button",
                            "aria-label": "Click here to close ".concat(modalTitle, " modal window"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: isWhiteCloseIcon ? close_white/* default */.Z === null || close_white/* default */.Z === void 0 ? void 0 : close_white/* default.src */.Z.src : modal_close/* default */.Z === null || modal_close/* default */.Z === void 0 ? void 0 : modal_close/* default.src */.Z.src,
                                "aria-hidden": true,
                                role: "presentation",
                                alt: "close"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "modal-popup-body",
                        children: isRendered && showModal && children
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var Modal_Modal = (Modal);


/***/ }),

/***/ 96352:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55760);
/* harmony import */ var _components_core_Modal_Modal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78145);
/* harmony import */ var _components_core_Button_Button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7872);
/* harmony import */ var _components_FindStore_v1_analytics__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(30167);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(96301);








const ZipCodeInfoModal = (props)=>{
    const { staticTexts: { infoModalTitle ="" , messageZipcode ="" , continue: continueCtaLabel = ""  } = {} , data: { ctaLabel ="" , title ="" , message =""  } = {} , dataLayerPosition =""  } = props;
    const handleModalClose = (e)=>{
        if (props.data.ctaLink) {
            window.open(props.data.ctaLink);
        } else {
            var ref;
            props.handleModalClose();
            let label = ctaLabel ? ctaLabel : continueCtaLabel;
            if ((e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : ref.nodeName) === _constants__WEBPACK_IMPORTED_MODULE_6__.NODE_NAMES.IMG) {
                label = "close";
            }
            (0,_components_FindStore_v1_analytics__WEBPACK_IMPORTED_MODULE_5__/* .zipCodeInfoModalContinueAnalytics */ .CS)(label, dataLayerPosition);
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_core_Modal_Modal__WEBPACK_IMPORTED_MODULE_3__["default"], {
        showModal: props.show,
        className: props.className,
        onModalClose: handleModalClose,
        labelledBy: props.labelledBy,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                id: "taxware-down-title",
                className: "taxware-down__title",
                children: title ? title : infoModalTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "taxware-down__desc",
                children: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_2__/* .sanitizeInnerHtml */ .KD0)(message ? message : messageZipcode)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_core_Button_Button__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                tag: "button",
                customClass: "taxware-down__cta",
                role: "button",
                onClick: handleModalClose,
                flexible: true,
                label: ctaLabel ? ctaLabel : continueCtaLabel,
                useDefaultClass: true
            })
        ]
    });
};
_components_core_Modal_Modal__WEBPACK_IMPORTED_MODULE_3__["default"].propTypes = {
    labelledBy: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string),
    data: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().object)
};
/* harmony default export */ __webpack_exports__["Z"] = (ZipCodeInfoModal);


/***/ }),

/***/ 41600:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ PageLoader_PageLoader; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./public/icons/page-loader.svg
/* harmony default export */ var page_loader = ({"src":"/_next/static/media/page-loader.46514bdc.svg","height":40,"width":40});
// EXTERNAL MODULE: ./components/core/PageLoader/index.module.scss
var index_module = __webpack_require__(20889);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(85518);
;// CONCATENATED MODULE: ./components/core/PageLoader/PageLoader.jsx






const PageLoader = (param)=>{
    let { loading =false , initialLoader =false  } = param;
    (0,react.useEffect)(()=>{
        const htmlElem = document.getElementsByTagName("html")[0];
        if (loading) {
            document.body.style["touch-action"] = "none";
            htmlElem.style["touch-action"] = "none";
        } else {
            document.body.style.removeProperty("touch-action");
            htmlElem.style.removeProperty("touch-action");
        }
        return ()=>{
            document.body.style.removeProperty("touch-action");
            htmlElem.style.removeProperty("touch-action");
        };
    }, [
        loading
    ]);
    const EMPTY_PIXEL = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
    const [src, setSrc] = (0,react.useState)(EMPTY_PIXEL);
    (0,react.useEffect)(()=>{
        if (lib/* isMobile */.tq) {
            setSrc(EMPTY_PIXEL);
        } else {
            setSrc(page_loader.src);
        }
    }, [
        lib/* isMobile */.tq
    ]);
    return loading || initialLoader ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (index_module_default()).pageLoaderWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "page-loader",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                className: "page-loader__spinner",
                src: src,
                alt: "",
                "aria-hidden": "true"
            })
        })
    }) : null;
};
PageLoader.propTypes = {
    loading: (prop_types_default()).bool
};
/* harmony default export */ var PageLoader_PageLoader = (PageLoader);


/***/ }),

/***/ 65131:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);




const RadioButton = (param)=>{
    let { onKeydown , analyticsData , id ="" , name ="" , value =undefined , checked =undefined , onClick =()=>{}  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
        role: "radio",
        onKeyDown: onKeydown,
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()({
            radio: true
        }),
        htmlFor: id,
        "aria-checked": checked,
        tabIndex: checked ? 0 : -1,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                type: "radio",
                className: "radio__input " + (analyticsData ? "gbh-data-layer" : ""),
                "data-gbh-data-layer": analyticsData,
                name: name,
                id: id,
                checked: checked,
                onClick: onClick,
                onChange: onClick
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "radio__custom"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                children: value
            })
        ]
    });
};
RadioButton.propTypes = {
    id: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
    name: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
    value: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string) || (prop_types__WEBPACK_IMPORTED_MODULE_3___default().number),
    checked: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().bool),
    onClick: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().func)
};
/* harmony default export */ __webpack_exports__["Z"] = (RadioButton);


/***/ }),

/***/ 46394:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ReCaptcha_ReCaptcha; },
  "L": function() { return /* binding */ validateRecaptcha; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 16 modules
var esm = __webpack_require__(24400);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./constants/api.js
var api = __webpack_require__(73350);
// EXTERNAL MODULE: ./constants/config.js
var config = __webpack_require__(19514);
// EXTERNAL MODULE: ./utils/helper.js + 1 modules
var helper = __webpack_require__(55760);
// EXTERNAL MODULE: ./store/features/genericSlice.js
var genericSlice = __webpack_require__(88751);
// EXTERNAL MODULE: ./constants/index.js
var constants = __webpack_require__(96301);
;// CONCATENATED MODULE: ./components/core/ReCaptcha/analytics.js


const getInternalLinkURLS = (url)=>{
    return (url === null || url === void 0 ? void 0 : url.startsWith("/")) || (url === null || url === void 0 ? void 0 : url.includes(window.location.hostname)) ? "true" : "false";
};
const setLinkAnalytics = function(linkUrl, type, getAnalyticsData) {
    let eventType = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "navigation";
    if (!getAnalyticsData) return null;
    const { pageTitle ="n/a" , internalLinkPosition ="n/a" , addNoFooterInAttr =false  } = getAnalyticsData;
    if (typeof type !== "string") {
        var ref;
        // this is html content
        const div = document.createElement("div");
        div.innerHTML = type;
        // This contains HTML code so remove some bugs here.
        type = (ref = div.innerText || div.textContent || "") === null || ref === void 0 ? void 0 : ref.toLowerCase();
        type = type.replaceAll("\n", "");
    } else {
        type = type.toLowerCase();
    }
    const isOrderStatusPage = pageTitle === null || pageTitle === void 0 ? void 0 : pageTitle.includes(constants.ORDER_STATUS_PAGE);
    const form = !addNoFooterInAttr ? ":form" : "";
    const formFooter = !addNoFooterInAttr ? ":form:".concat(constants.FRAGMENT_TYPES.FOOTER) : "";
    const eventDetail = isOrderStatusPage ? "".concat(pageTitle, ":").concat(type) : "".concat(pageTitle).concat(formFooter, ":").concat(type);
    const eventLinkType = isOrderStatusPage ? "my account:".concat(type) : "".concat(pageTitle).concat(form, ":").concat(type);
    const prefix = linkUrl && linkUrl.indexOf("http") === -1 ? window.location.origin : "";
    const eventInfo = {
        clickInternalLinks: getInternalLinkURLS(linkUrl),
        eventAction: eventDetail || "n/a",
        eventName: eventDetail || "n/a",
        eventType,
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: type || "n/a",
        internalLinkPosition: internalLinkPosition || "n/a",
        internalLinkType: eventLinkType,
        internalLinkURL: linkUrl ? prefix + linkUrl : "n/a",
        internalLinkZoneName: "".concat(pageTitle).concat(formFooter)
    };
    addAnalyticsForRecaptchLinks(eventInfo, "cmp:click");
};
const addAnalyticsForRecaptchLinks = function(eventInfo) {
    let event = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "cmp:click";
    const page = (0,helper/* getPageInfo */.UMn)();
    window.adobeDataLayer.push({
        event,
        eventInfo,
        page
    });
};


// EXTERNAL MODULE: ./components/core/ReCaptcha/Recaptcha.module.scss
var Recaptcha_module = __webpack_require__(81918);
var Recaptcha_module_default = /*#__PURE__*/__webpack_require__.n(Recaptcha_module);
;// CONCATENATED MODULE: ./components/core/ReCaptcha/ReCaptcha.jsx
/* eslint-disable no-undef */ 









let promiseResolve;
let promiseReject;
const validateRecaptcha = ()=>{
    return new Promise((resolve, reject)=>{
        (0,config/* getConfig */.i)().then((CONFIG)=>{
            try {
                const { isDisableRecaptcha  } = CONFIG.general;
                if (isDisableRecaptcha) {
                    return resolve({
                        success: isDisableRecaptcha
                    });
                }
                const { captcha: { captchaSiteKeyV3 , captchaThreshold  } , general: { siteName  }  } = CONFIG;
                promiseResolve = resolve;
                promiseReject = reject;
                grecaptcha.ready(()=>{
                    grecaptcha.reset();
                    grecaptcha.execute(captchaSiteKeyV3).then(async (token)=>{
                        try {
                            const { data  } = await (0,api/* aemAxiosInstance */.Gb)({
                                url: "/bin/kohler/google/captchaAuth?type=V3&access_token=".concat(token, "&brandName=").concat(siteName.toLowerCase()),
                                method: "GET"
                            });
                            if (data.score < captchaThreshold) {
                                grecaptcha.reset();
                                grecaptcha.execute();
                            } else {
                                return resolve(data);
                            }
                        } catch (error) {
                            reject(error);
                        }
                    }).catch((err1)=>reject(err1));
                });
            } catch (error) {
                reject(error);
            }
        });
    });
};
const ReCaptcha = (props)=>{
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const [links, setLinks] = (0,react.useState)({});
    const [state, setState] = (0,react.useState)({});
    const [i18n, seti18n] = (0,react.useState)({});
    const dispatch = (0,es/* useDispatch */.I0)();
    const { legalPageLinks  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const getTranslations = (t)=>{
        return {
            protectedByGoogle: t("kf.associatemembership.label.protectedByGoogle"),
            privacyPolicyGoogle: t("kf.associatemembership.label.privacyPolicyGoogle"),
            privacyPolicy: t("kf.contactus.label.privacyPolicy"),
            termsOfService: t("kf.contactus.label.termsOfService"),
            and: t("kf.contactus.message.and"),
            apply: t("kf.contactus.message.apply")
        };
    };
    (0,react.useEffect)(()=>{
        seti18n(getTranslations(t));
        (0,config/* getConfig */.i)().then((config)=>{
            const { captcha: { captchaSiteKeyV2 , captchaSiteKeyV3  } , general: { siteName  }  } = config;
            setState({
                captchaSiteKeyV2,
                captchaSiteKeyV3,
                siteName
            });
        });
    }, []);
    (0,react.useEffect)(()=>{
        const { captchaSiteKeyV2 , captchaSiteKeyV3 , siteName  } = state;
        if (captchaSiteKeyV2 && captchaSiteKeyV3 && siteName) {
            loadRecaptcha();
            getLegalPages();
        }
    }, [
        state.captchaSiteKeyV2,
        state.captchaSiteKeyV3,
        state.siteName
    ]);
    (0,react.useEffect)(()=>{
        if (legalPageLinks) {
            const { googlePrivacyPolicy , googleTermsOfService  } = legalPageLinks;
            setLinks({
                googlePrivacyPolicy,
                googleTermsOfService
            });
        }
    }, [
        legalPageLinks
    ]);
    const getLegalPages = async ()=>{
        dispatch((0,genericSlice/* getLegalPageLinks */.go)());
    };
    const loadRecaptcha = ()=>{
        const { captchaSiteKeyV2 , captchaSiteKeyV3  } = state;
        const scriptExist = document.getElementById("recaptcha-key");
        if (!scriptExist) {
            const script = document.createElement("script");
            script.src = "https://www.google.com/recaptcha/api.js?render=".concat(captchaSiteKeyV3);
            script.id = "recaptcha-key";
            script.onload = function onload() {
                grecaptcha.ready(()=>{
                    grecaptcha.render("recaptcha-container", {
                        sitekey: captchaSiteKeyV2,
                        callback: (t)=>verifyToken(t)
                    });
                });
            };
            document.body.appendChild(script);
        } else {
            grecaptcha.ready(()=>{
                grecaptcha.render("recaptcha-container", {
                    sitekey: captchaSiteKeyV2,
                    callback: (t)=>verifyToken(t)
                });
            });
        }
    };
    const verifyToken = async (token)=>{
        const CONFIG = await (0,config/* getConfig */.i)();
        const { isDisableRecaptcha  } = CONFIG.general;
        if (isDisableRecaptcha) {
            promiseResolve({
                success: isDisableRecaptcha
            });
        }
        try {
            const { data  } = await (0,api/* aemAxiosInstance */.Gb)({
                url: "/bin/kohler/google/captchaAuth?type=V2&access_token=".concat(token, "&brandName=").concat(state.siteName.toLowerCase()),
                method: "GET"
            });
            promiseResolve(data);
        } catch (error) {
            promiseReject(err);
        }
    };
    const { getAnalyticsData ={} , isPopupNeededBeforeRedirection =true  } = props;
    const { googlePrivacyPolicy ="n/a" , googleTermsOfService ="n/a"  } = links;
    const { privacyPolicyGoogle ="" , termsOfService =""  } = i18n;
    const handleClickOfLinks = (e, text, url)=>{
        const eventType = isPopupNeededBeforeRedirection ? "navigation" : "informative";
        if (props.addReviewRegistrationEventInfo) {
            const eventReviewInfo = props.addReviewRegistrationEventInfo(text, url, "false");
            addAnalyticsForRecaptchLinks(eventReviewInfo);
        } else {
            setLinkAnalytics(url, text, getAnalyticsData, eventType);
        }
        if (isPopupNeededBeforeRedirection) (0,helper/* getSiteWideModal */.Ure)(e, url);
        else window.open(url);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (Recaptcha_module_default()).reCatichWrapper,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    id: "recaptcha-container",
                    className: "g-recaptcha",
                    "data-size": "invisible"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mt-20 mb-20 recaptcha-links",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "".concat(i18n.protectedByGoogle, " ")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: "gpolicies",
                            href: "#",
                            target: "_blank",
                            rel: "noopener noreferrer",
                            onClick: (e)=>handleClickOfLinks(e, privacyPolicyGoogle, googlePrivacyPolicy),
                            children: privacyPolicyGoogle
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            children: [
                                " ",
                                i18n.and,
                                " "
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: "gpolicies",
                            href: "#",
                            target: "_blank",
                            rel: "noopener noreferrer",
                            onClick: (e)=>handleClickOfLinks(e, termsOfService, googleTermsOfService),
                            children: termsOfService
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            children: [
                                " ",
                                i18n.apply
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var ReCaptcha_ReCaptcha = (ReCaptcha);


/***/ }),

/***/ 1906:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _public_images_image_missing_png__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36513);




const SmartCropImage = (param)=>{
    let { url , altText , smartCrop ={} , handleImgeClick =()=>{}  } = param;
    let s7Image;
    if (true) {
        s7Image = window.s7responsiveImage;
    }
    const pressImg = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const imgPlaceholder = url !== null && url !== void 0 ? url : "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (smartCrop.scriptStatus) {
            smartCrop.applySmartCrop(pressImg.current);
        }
    }, [
        smartCrop.scriptStatus,
        url,
        s7Image
    ]);
    const checkImg = (e)=>{
        e.persist();
        const ele = e.target;
        if (ele.src !== _public_images_image_missing_png__WEBPACK_IMPORTED_MODULE_3__/* ["default"].src */ .Z.src && ele.src === imgPlaceholder) {
            axios__WEBPACK_IMPORTED_MODULE_2___default().head(ele.dataset.src).then((res)=>{
                if (!res) handleImgErr(e);
            }).catch(()=>handleImgErr(e));
        }
    };
    const handleImgErr = (e)=>e.target.src = _public_images_image_missing_png__WEBPACK_IMPORTED_MODULE_3__/* ["default"].src */ .Z.src;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
        ref: pressImg,
        src: url ? imgPlaceholder : _public_images_image_missing_png__WEBPACK_IMPORTED_MODULE_3__/* ["default"].src */ .Z.src,
        "data-src": url,
        "data-mode": "smartcrop",
        onLoad: checkImg,
        onError: handleImgErr,
        alt: altText,
        onClick: handleImgeClick
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SmartCropImage);


/***/ }),

/***/ 53683:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_core_ToolTip_Tooltip_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26075);
/* harmony import */ var _components_core_ToolTip_Tooltip_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_components_core_ToolTip_Tooltip_module_scss__WEBPACK_IMPORTED_MODULE_2__);



const ToolTip = (props)=>{
    const [{ children =null , ...attr }, setAttribute] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        id: props.id,
        role: "tooltip",
        tabIndex: props.setFocus ? 0 : -1,
        "aria-label": props.ariaLabel,
        children: props.message
    });
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        setAttribute({
            ...attr,
            children: props.message
        });
    }, [
        props.message
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        var ref;
        if (props.setFocus) (ref = document.getElementById(props.id)) === null || ref === void 0 ? void 0 : ref.focus();
    }, [
        props.setFocus
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_components_core_ToolTip_Tooltip_module_scss__WEBPACK_IMPORTED_MODULE_2___default().tooltipWrapper),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "tooltip__container",
            role: "alert",
            "aria-live": "polite",
            children: [
                props.label && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "--label",
                            children: "".concat(props.label, ":")
                        }),
                        " "
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    ...attr,
                    children: children
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ToolTip);


/***/ }),

/***/ 27221:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_core_Highlight_Highlight__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15540);
/* harmony import */ var react_number_format__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(57333);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55760);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41609);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(96301);
/* harmony import */ var _components_productCard_v1_analytics__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(76735);









const ProductCardView = (param)=>{
    let { i18n , product , currencySign , presetConfigs , swatchUrl , parent , title , brandName , skuId =""  } = param;
    var ref, ref1, ref2;
    const { COMPONENT  } = _constants_index__WEBPACK_IMPORTED_MODULE_6__["default"];
    const [productCardWidth, setProductCardWidth] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0);
    const [pdpNavigationURL, setPdpNavigationURL] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const productCardRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
    const presetConfigObject = presetConfigs ? JSON.parse(presetConfigs) : {};
    const newTab = false;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        setProductCardWidth(productCardRef.current.clientWidth);
    });
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        (0,_utils_helper__WEBPACK_IMPORTED_MODULE_3__/* .getPDPUrl */ .ir5)(product === null || product === void 0 ? void 0 : product.productCategory, product === null || product === void 0 ? void 0 : product.slug).then((ret)=>setPdpNavigationURL(ret));
    }, [
        product
    ]);
    const formatUrl = (uUrl, iWidth)=>{
        if (!uUrl.includes("data:image")) {
            var ref;
            const sUrlPath = (ref = uUrl.split("?")[0]) === null || ref === void 0 ? void 0 : ref.split("/");
            const sUrlId = sUrlPath[sUrlPath.length - 1];
            let sPreset = "";
            if (iWidth <= 167) {
                var ref1;
                sPreset = (ref1 = presetConfigObject === null || presetConfigObject === void 0 ? void 0 : presetConfigObject.MobileLandscape) !== null && ref1 !== void 0 ? ref1 : "";
            } else if (iWidth <= 458) {
                var ref2;
                sPreset = (ref2 = presetConfigObject === null || presetConfigObject === void 0 ? void 0 : presetConfigObject.Desktop) !== null && ref2 !== void 0 ? ref2 : "";
            } else {
                var ref3;
                sPreset = (ref3 = presetConfigObject === null || presetConfigObject === void 0 ? void 0 : presetConfigObject.MobilePortrait) !== null && ref3 !== void 0 ? ref3 : "";
            }
            if (parent === COMPONENT.PAIRS_WELL_WITH) {
                return "".concat(swatchUrl).concat(presetConfigObject.PotraitCategory, "?&product_src=is{PAWEB/").concat(sUrlId, "}&").concat(sPreset);
            }
            return "".concat(swatchUrl).concat(presetConfigObject.PotraitCategory, "?$product_src=is{PAWEB/").concat(sUrlId, "}&?").concat(sPreset);
        }
        return uUrl;
    };
    const getProductName = ()=>{
        if (!parent && title) {
            return title;
        }
        return product.name || brandName ? product.name || brandName : product.name ? product.name : product.description;
    };
    var _price;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        ref: productCardRef,
        className: "product-card",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
            prefetch: false,
            href: pdpNavigationURL + (skuId ? "?skuId=".concat(skuId) : ""),
            target: newTab ? "_blank" : "_self",
            "aria-label": "".concat(product.name, " ").concat(currencySign + product.price, " ").concat(product === null || product === void 0 ? void 0 : (ref = product.colors) === null || ref === void 0 ? void 0 : ref.length, " ").concat(i18n.ariaLabelColor),
            className: "product-card__link gbh-data-layer",
            "data-gbh-data-layer": (0,_components_productCard_v1_analytics__WEBPACK_IMPORTED_MODULE_7__/* .getMoreInCollectionsInfo */ .VA)(title !== null && title !== void 0 ? title : "", false, pdpNavigationURL, product),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "product-card__img-container",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: lodash_isEmpty__WEBPACK_IMPORTED_MODULE_5___default()(presetConfigs) ? formatUrl(product.images, productCardWidth) : product.images,
                        className: "product-card__img",
                        alt: ""
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "product-card__details",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "product-card__left",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                className: "product-card__name".concat(!parent ? " default" : ""),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_core_Highlight_Highlight__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                    text: getProductName()
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "product-card__right",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                                className: "product-card__price".concat(!parent ? " default" : ""),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_number_format__WEBPACK_IMPORTED_MODULE_8__/* .NumericFormat */ .h3, {
                                    value: product.discountedPrice > 0 ? product.discountedPrice : product.price,
                                    displayType: "text",
                                    thousandSeparator: true,
                                    prefix: currencySign,
                                    decimalScale: 2,
                                    fixedDecimalScale: true
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "product-card__details",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "product-card__left",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "product-card-desc",
                                children: product.name || title || brandName ? product.description : ""
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "product-card__right",
                            children: product.discountedPrice !== product.price && product.discountedPrice > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "product-card__discount-price",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_number_format__WEBPACK_IMPORTED_MODULE_8__/* .NumericFormat */ .h3, {
                                    value: (_price = product.price) !== null && _price !== void 0 ? _price : 0,
                                    displayType: "text",
                                    thousandSeparator: true,
                                    prefix: currencySign,
                                    decimalScale: 2,
                                    fixedDecimalScale: true
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "product-card__details",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "product-card__left",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "product-card__color-text",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                children: (product === null || product === void 0 ? void 0 : (ref1 = product.colors) === null || ref1 === void 0 ? void 0 : ref1.length) > 1 ? "".concat(product === null || product === void 0 ? void 0 : (ref2 = product.colors) === null || ref2 === void 0 ? void 0 : ref2.length, " ").concat(i18n.recentlyViewedColors) : "1 ".concat(i18n.recentlyViewedColor)
                            })
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ProductCardView);


/***/ }),

/***/ 76735:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ag": function() { return /* binding */ getMoreInCollectionSlider; },
/* harmony export */   "VA": function() { return /* binding */ getMoreInCollectionsInfo; },
/* harmony export */   "__": function() { return /* binding */ callDesignServicesAddToCartAnalytics; },
/* harmony export */   "gA": function() { return /* binding */ callInstallServiceAddToCartAnalytics; }
/* harmony export */ });
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55760);
/**
 *
 * @param {Object} resInfo
 * @param {Object} productInfo
 * Kohler Data Layer Tech Spec 2021 - Batch 5 - Installation Services v1
 * Requirement#12 Add to Cart button
 */ 
const callInstallServiceAddToCartAnalytics = (param)=>{
    let { resInfo , productInfo , cartID , eventInfoObj  } = param;
    var ref;
    const { status , message ="n/a"  } = resInfo;
    const isStatus = status === 200;
    const eventInfo = eventInfoObj !== null && eventInfoObj !== void 0 ? eventInfoObj : {
        eventAction: "installer services:already have a product purchase a kohler installation service:add to cart",
        eventName: "installer services:already have a product purchase a kohler installation service:add to cart",
        eventType: "navigation",
        eventMsg: message === null || message === void 0 ? void 0 : message.toLowerCase(),
        eventStatus: isStatus ? "success" : "failure",
        internalLinkName: "add to cart",
        internalLinkPosition: "installer services",
        internalLinkType: "installer services:in-person",
        internalLinkZoneName: "installer services:already have a product purchase a kohler installation service",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    page.cart = {
        cartID
    };
    (ref = window.adobeDataLayer) === null || ref === void 0 ? void 0 : ref.push({
        event: "cmp:click",
        eventInfo,
        productInfo,
        page
    });
};
const callDesignServicesAddToCartAnalytics = (resInfo, productInfo, serviceName, cartID)=>{
    const { status , message ="n/a"  } = resInfo;
    const isStatus = status === 200;
    const eventInfo = {
        eventAction: serviceName + ":virtual bathroom design service:add to cart",
        eventName: serviceName + ":virtual bathroom design service:add to cart",
        eventType: "navigation",
        eventMsg: message === null || message === void 0 ? void 0 : message.toLowerCase(),
        eventStatus: isStatus ? "success" : "failure",
        internalLinkName: "add to cart",
        internalLinkPosition: serviceName,
        internalLinkType: serviceName + ":add to cart",
        internalLinkZoneName: serviceName + ":virtual bathroom design service",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    page.cart = {
        cartID
    };
    window.adobeDataLayer.push({
        event: "cmp:click",
        eventInfo,
        page,
        productInfo
    });
};
const getMoreInCollectionsInfo = function(title, needsJSON) {
    let pdpNavigationURL = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", product = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    var ref;
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const primaryCategory = page === null || page === void 0 ? void 0 : (ref = page.category) === null || ref === void 0 ? void 0 : ref.primaryCategory;
    const type = (title === null || title === void 0 ? void 0 : title.toLowerCase()) === "recently viewed";
    const eventAction = "".concat(primaryCategory, ":").concat((0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .sanitizeTextForAnalytics */ .T68)(title !== null && title !== void 0 ? title : ""), ":product navigation");
    const internalLinkURL = ((pdpNavigationURL === null || pdpNavigationURL === void 0 ? void 0 : pdpNavigationURL.indexOf("http")) === -1 ? window.location.origin : "") + pdpNavigationURL;
    const internalLinkZoneName = "".concat(primaryCategory, ":").concat((0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .sanitizeTextForAnalytics */ .T68)(title !== null && title !== void 0 ? title : ""), ":preview");
    const eventInfo = {
        eventAction,
        eventName: eventAction,
        eventNavigation: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "".concat((0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .sanitizeTextForAnalytics */ .T68)(product === null || product === void 0 ? void 0 : product.name), " "),
        internalLinkPosition: primaryCategory,
        internalLinkType: "".concat(primaryCategory, ":navigation"),
        internalLinkURL,
        internalLinkZoneName,
        clickInternalLinks: "true"
    };
    if (type) {
        eventInfo.eventAction = "pdp:recently viewed:product navigation";
        eventInfo.eventName = "pdp:recently viewed:product navigation";
        eventInfo.internalLinkPosition = "pdp";
        eventInfo.internalLinkType = "pdp:navigation";
        eventInfo.internalLinkZoneName = "pdp:recently:viewed:preview";
    }
    if (needsJSON) {
        return eventInfo;
    }
    return JSON.stringify(eventInfo);
};
const getMoreInCollectionSlider = (title)=>{
    var ref;
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const primaryCategory = page === null || page === void 0 ? void 0 : (ref = page.category) === null || ref === void 0 ? void 0 : ref.primaryCategory;
    const eventAction = "".concat(primaryCategory, ":").concat((0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .sanitizeTextForAnalytics */ .T68)(title !== null && title !== void 0 ? title : ""), ":product slider");
    const internalLinkZoneName = "".concat(primaryCategory, ":").concat((0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .sanitizeTextForAnalytics */ .T68)(title !== null && title !== void 0 ? title : ""), ":preview");
    const eventInfo = {
        eventAction,
        eventName: eventAction,
        eventNavigation: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "slider",
        internalLinkPosition: primaryCategory,
        internalLinkType: "".concat(primaryCategory, ":navigation"),
        internalLinkURL: "n/a",
        internalLinkZoneName,
        clickInternalLinks: "true"
    };
    window.adobeDataLayer.push({
        event: "cmp:click",
        eventInfo,
        page
    });
};


/***/ }),

/***/ 69442:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ productCardAddToCart; }
/* harmony export */ });
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19514);
/* harmony import */ var _store_features_cartSlice__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46201);
/* harmony import */ var _store_features_genericSlice__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88751);
/* harmony import */ var _store_index__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88032);
/* harmony import */ var _utils_cart__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11763);





const productCardAddToCart = async (items, showPreview, message, cb)=>{
    var ref;
    const CONFIG = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_0__/* .getConfig */ .i)();
    var ref1;
    const salesChannels = (ref1 = CONFIG === null || CONFIG === void 0 ? void 0 : (ref = CONFIG.salesChannelConfig) === null || ref === void 0 ? void 0 : ref.map) !== null && ref1 !== void 0 ? ref1 : {};
    const actions = [];
    let userZipCode;
    items.forEach((product)=>{
        var _brand;
        const fields = {
            salesChannel: (_brand = salesChannels[product.brand]) !== null && _brand !== void 0 ? _brand : "KOUS"
        };
        if (product.backorder) fields.isBackOrderable = true;
        actions.push({
            action: product.isBundle ? "addbundle" : "addLineItem",
            sku: product.sku,
            quantity: product.quantity,
            custom: product.additionalInfo ? {
                type: {
                    key: "lineItemShipping"
                },
                fields: {
                    salesChannel: salesChannels[product.brand],
                    roomInfo: product.additionalInfo.roomInfo,
                    customQuantity: product.additionalInfo.customQuantity,
                    overage: product.additionalInfo.overage
                }
            } : {
                type: {
                    key: "lineItemShipping"
                },
                fields: fields
            }
        });
        userZipCode = product === null || product === void 0 ? void 0 : product.userZipCode;
    });
    const body = {
        actions: actions
    };
    if (userZipCode) {
        body.servicesku = true;
        body.zipCode = userZipCode;
    }
    _store_index__WEBPACK_IMPORTED_MODULE_3__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_1__/* .addToCart */ .Xq)(body)).unwrap().then((res)=>{
        if (res) {
            _store_index__WEBPACK_IMPORTED_MODULE_3__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_1__/* .setCart */ .RV)(res));
            const quantityLineItems = res === null || res === void 0 ? void 0 : res.lineItems;
            const payload = (0,_utils_cart__WEBPACK_IMPORTED_MODULE_4__/* .getQuantityCount */ .PW)(quantityLineItems);
            _store_index__WEBPACK_IMPORTED_MODULE_3__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_1__/* .setCartCount */ .oJ)(payload));
            cb && cb({
                status: 200,
                message: "success"
            });
            if (message) {
                _store_index__WEBPACK_IMPORTED_MODULE_3__/* .store.dispatch */ .h.dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_2__/* .showToast */ .CF)(message));
            }
            if (showPreview) _store_index__WEBPACK_IMPORTED_MODULE_3__/* .store.dispatch */ .h.dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_2__/* .showPreviewCart */ .z0)());
        }
    });
};


/***/ }),

/***/ 44685:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9473);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41609);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(24400);
/* harmony import */ var _hooks_useWindowResize__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(11859);
/* harmony import */ var _constants_api__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(73350);
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(19514);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(55760);
/* harmony import */ var _components_productCard_v3_productCardHelper__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(38560);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(20558);
/* harmony import */ var _components_ShopTheRoomCard_analytics__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(59362);
/* harmony import */ var _store_features_favoritesSlice__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(7737);
/* harmony import */ var _store_features_cartSlice__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(46201);
/* harmony import */ var _store_features_authSlice__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(24899);
/* harmony import */ var _store_features_genericSlice__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(88751);
/* harmony import */ var _public_images_image_missing_png__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(36513);
/* harmony import */ var _public_icons_wish_svg__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(29875);
/* harmony import */ var _public_icons_wishlist_gray_filled_svg__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(62084);
/* harmony import */ var _components_productCard_v3_index_module_scss__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(80597);
/* harmony import */ var _components_productCard_v3_index_module_scss__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(_components_productCard_v3_index_module_scss__WEBPACK_IMPORTED_MODULE_21__);






















const ProductCard = (props)=>{
    const { authorData: { skewId ="" , presetConfigs ="{}"  } , isDefaultProductCard =true , isFavoriteIcon =false , selectedProduct ="" , hotspotClicked =false , toasterVar =false  } = props;
    const { t  } = (0,next_i18next__WEBPACK_IMPORTED_MODULE_5__/* .useTranslation */ .$G)("common");
    const [width] = (0,_hooks_useWindowResize__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)();
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useDispatch */ .I0)();
    const { toaster  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_16__/* .selectGenericState */ .Px);
    const { cart  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_14__/* .selectCartState */ .xw);
    const { favorites  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(_store_features_favoritesSlice__WEBPACK_IMPORTED_MODULE_13__/* .selectFavoritesState */ .Qx);
    const { isAuth  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(_store_features_authSlice__WEBPACK_IMPORTED_MODULE_15__/* .selectAuthState */ ._9);
    const [presetConfig] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(JSON.parse(presetConfigs));
    const myRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const [favFilled, setFavFilled] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [productData, setState] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        isLoading: false,
        image: "",
        isFavorite: false
    });
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        var ref;
        if (selectedProduct === skewId) myRef === null || myRef === void 0 ? void 0 : (ref = myRef.current) === null || ref === void 0 ? void 0 : ref.scrollIntoView();
    }, [
        selectedProduct,
        skewId,
        myRef,
        hotspotClicked
    ]);
    const [config, setConfig] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({});
    const [swatchUrl, setSwatchUrl] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [loginFavouriteCallback, setLoginFavouriteCallback] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const [toasterContent, setToasterContent] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        successMessage: "",
        unfavoriteSuccessMessage: ""
    });
    const [pdpUrl, setPdpUrl] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const staticTexts = {
        removeItem: t("kf.favorites.removeItem"),
        removeItemError: t("kf.favorites.removeItemError"),
        favSuccessMsg: t("kf.favorites.success"),
        favErrorMsg: t("kf.favorites.error")
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        (0,_constants_config__WEBPACK_IMPORTED_MODULE_8__/* .getConfig */ .i)().then((config)=>{
            setConfig(config);
            const swatchUrl = lodash_get__WEBPACK_IMPORTED_MODULE_3___default()(config, "general.swatchUrl", "");
            setSwatchUrl(swatchUrl);
        });
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (skewId && !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_4___default()(config)) {
            const persona = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_9__/* .getUserPersona */ .shu)();
            const brandName = lodash_get__WEBPACK_IMPORTED_MODULE_3___default()(config, "general.siteName", "");
            const fl = [
                "id",
                "slug_s",
                "productName_s",
                "masterSKU_s",
                "Product_Category",
                "ProductBrandName_s",
                "productImages.url_ss",
                "SKUColorSwatchFilename_ss",
                "ProductDescriptionProductShort_s",
                "priceList.".concat(persona, ".price_d"),
                "priceList.".concat(persona, ".finalPrice_d"),
                "priceList.".concat(persona, ".discountedPrice_d"),
                "priceList.".concat(persona, ".saleOffer_s"),
                "Color.SKU.Details_ss",
                "ProductWebFeatures_ss",
                "ProductWebFeatures_s",
                "ProductIsExclusive_s",
                "RegionReleaseforShipment_dt",
                "Color.TPR.Details_ss",
                "RegionBrandName_s",
                "metaTitle_s",
                "ctId_s",
                "CustomerFacingBrand_s"
            ];
            setState({
                ...productData,
                isLoading: true
            });
            try {
                var ref;
                var ref1;
                const language = (ref1 = config === null || config === void 0 ? void 0 : (ref = config.internationalization) === null || ref === void 0 ? void 0 : ref.language) !== null && ref1 !== void 0 ? ref1 : "en";
                _constants_api__WEBPACK_IMPORTED_MODULE_7__/* .apim.get */ .TH.get("/search/plp", {
                    params: {
                        fl: fl.join(","),
                        q: "*:*",
                        fq: [
                            'sku_s:("'.concat(skewId, '")'),
                            'language_s:("'.concat(language, '")')
                        ],
                        collections: brandName.toLowerCase(),
                        profilename: "profile_".concat(brandName.toLowerCase(), "_General")
                    },
                    paramsSerializer: (params)=>{
                        return qs__WEBPACK_IMPORTED_MODULE_20___default().stringify(params, {
                            arrayFormat: "repeat",
                            encode: false
                        });
                    }
                }).then((res)=>{
                    if (res && res.data) {
                        var ref;
                        const productData = lodash_get__WEBPACK_IMPORTED_MODULE_3___default()(res.data, "response.docs[0]", {});
                        let imageId = "";
                        if (skewId.includes("-")) {
                            const skewIdPart = skewId.split("-");
                            const selectedVariant = skewIdPart.at(-1);
                            const imageData = productData["Color.TPR.Details_ss"].find((str)=>str.includes("-".concat(selectedVariant))).split("/");
                            imageId = imageData[imageData.length - 1];
                        }
                        const favoriteItem = favorites === null || favorites === void 0 ? void 0 : (ref = favorites.lineItems) === null || ref === void 0 ? void 0 : ref.find((favorite)=>favorite.variant.sku === skewId);
                        const isFavorite = favoriteItem ? true : false;
                        setFavFilled(isFavorite);
                        setState({
                            ...productData,
                            isLoading: false,
                            imageId,
                            currencySign: lodash_get__WEBPACK_IMPORTED_MODULE_3___default()(config, "internationalization.currencySign", ""),
                            isFavorite
                        });
                    } else {
                        // eslint-disable-next-line no-console
                        console.error("Error occured while fetching product data");
                    }
                });
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error("Error occured while fetching product data", err);
            }
        }
    }, [
        config,
        favorites,
        isAuth
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (loginFavouriteCallback && isAuth) {
            handleFavorite(loginFavouriteCallback);
        }
    }, [
        loginFavouriteCallback,
        isAuth
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        setToasterMessage();
    }, [
        toaster
    ]);
    const setToasterMessage = async ()=>{
        if (!lodash_isEmpty__WEBPACK_IMPORTED_MODULE_4___default()(toaster === null || toaster === void 0 ? void 0 : toaster.content)) {
            const { successMessage , unfavoriteSuccessMessage  } = toaster.content;
            setToasterContent({
                successMessage: await (0,_utils_helper__WEBPACK_IMPORTED_MODULE_9__/* .getShortenedUrl */ .Ppy)(successMessage),
                unfavoriteSuccessMessage: await (0,_utils_helper__WEBPACK_IMPORTED_MODULE_9__/* .getShortenedUrl */ .Ppy)(unfavoriteSuccessMessage)
            });
        }
    };
    const handleLogin = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        window.loginFavouriteCallback = ()=>{
            setLoginFavouriteCallback(e);
        };
        dispatch((0,_store_features_authSlice__WEBPACK_IMPORTED_MODULE_15__/* .setAuthModalVisibility */ .LY)({
            show: true
        }));
    };
    const handleFavorite = (e)=>{
        window.preActiveElement = e.target;
        e.stopPropagation();
        e.preventDefault();
        if (productData.isFavorite) {
            var ref;
            const favProduct = favorites === null || favorites === void 0 ? void 0 : (ref = favorites.lineItems) === null || ref === void 0 ? void 0 : ref.find((fav)=>fav.variant.sku === skewId);
            if (favProduct) {
                if (!isAuth) {
                    handleLogin(e);
                } else {
                    dispatch((0,_store_features_favoritesSlice__WEBPACK_IMPORTED_MODULE_13__/* .removeItems */ .Er)({
                        ids: [
                            favProduct.id
                        ]
                    })).unwrap().then(()=>{
                        const productInfo = (0,_components_productCard_v3_productCardHelper__WEBPACK_IMPORTED_MODULE_10__/* .getProductInfo */ .C)(productData, skewId, false, cart, config, description, persona);
                        (0,_components_ShopTheRoomCard_analytics__WEBPACK_IMPORTED_MODULE_12__/* .addAnalyticsEventForFavouriteAddRemove */ .Xc)(false, productInfo);
                        dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_16__/* .showToast */ .CF)({
                            message: toasterContent.unfavoriteSuccessMessage || staticTexts.removeItem,
                            isVisible: true
                        }));
                    }).catch((err)=>{
                        dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_16__/* .showToast */ .CF)({
                            message: staticTexts.removeItemError,
                            isVisible: true
                        }));
                    });
                }
            }
        } else {
            if (!isAuth) {
                handleLogin(e);
            } else {
                dispatch((0,_store_features_favoritesSlice__WEBPACK_IMPORTED_MODULE_13__/* .addProduct */ .gK)(skewId)).unwrap().then(()=>{
                    const productInfo = (0,_components_productCard_v3_productCardHelper__WEBPACK_IMPORTED_MODULE_10__/* .getProductInfo */ .C)(productData, skewId, false, cart, config, description, persona);
                    (0,_components_ShopTheRoomCard_analytics__WEBPACK_IMPORTED_MODULE_12__/* .addAnalyticsEventForFavouriteAddRemove */ .Xc)(true, productInfo);
                    dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_16__/* .showToast */ .CF)({
                        message: toasterContent.successMessage || staticTexts.favSuccessMsg,
                        isVisible: true
                    }));
                }).catch((err)=>{
                    dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_16__/* .showToast */ .CF)({
                        message: staticTexts.favErrorMsg,
                        isVisible: true
                    }));
                });
            }
        }
    };
    const getDescriptionWithElipsis = (isMobile, description)=>{
        const length = isMobile ? 41 : 45;
        if (description.length >= length) {
            if (description.charAt(length) === " ") {
                description = description.slice(0, length) + "...";
            } else {
                description = description.slice(0, length).split(" ");
                description.pop();
                description = description.join(" ") + "...";
            }
        }
        return description;
    };
    const productCategory = lodash_get__WEBPACK_IMPORTED_MODULE_3___default()(productData, "Product_Category", "");
    const slug = lodash_get__WEBPACK_IMPORTED_MODULE_3___default()(productData, "slug_s", "");
    const name = lodash_get__WEBPACK_IMPORTED_MODULE_3___default()(productData, "productName_s", "").split(" ").slice(" ")[0];
    const persona = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_9__/* .getUserPersona */ .shu)();
    var _currencySign;
    const currencySign = (_currencySign = productData.currencySign) !== null && _currencySign !== void 0 ? _currencySign : "";
    const price = Number(lodash_get__WEBPACK_IMPORTED_MODULE_3___default()(productData, "priceList.".concat(persona, ".price_d"), 0)).toLocaleString(undefined, {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2
    });
    let description = lodash_get__WEBPACK_IMPORTED_MODULE_3___default()(productData, "ProductDescriptionProductShort_s", "");
    const isMobile =  true ? window.matchMedia("(max-width: 1038px)").matches : 0;
    description = getDescriptionWithElipsis(isMobile, description);
    const reginalBrandName = lodash_get__WEBPACK_IMPORTED_MODULE_3___default()(productData, "RegionBrandName_s", "");
    const productBrand = lodash_get__WEBPACK_IMPORTED_MODULE_3___default()(productData, "CustomerFacingBrand_s", "");
    const { imageId =""  } = productData;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (!lodash_isEmpty__WEBPACK_IMPORTED_MODULE_4___default()(productData) && slug) {
            (0,_utils_helper__WEBPACK_IMPORTED_MODULE_9__/* .getPDPUrl */ .ir5)(productCategory, slug).then((url)=>setPdpUrl(url));
        }
    }, [
        productData,
        slug
    ]);
    if (productData.isLoading) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "product-card-loader__container",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "filter__inner-container shimmer height-300"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "filter__footer",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "products-per-page width-240 mt60 mb20",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "shimmer-loading__headpara shimmer"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "products-per-page width-100",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "shimmer-loading__para shimmer"
                            })
                        })
                    ]
                })
            ]
        });
    }
    var ref;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        ref: myRef,
        className: (_components_productCard_v3_index_module_scss__WEBPACK_IMPORTED_MODULE_21___default().productCardWrapper),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "inspired-selling-module__card-container",
            style: {
                border: skewId === selectedProduct ? "3px solid var(--Gray-Gray300, #CDCDCD)" : "",
                boxShadow: skewId === selectedProduct ? "0px 0px 20px 0px rgba(0, 0, 0, 0.40)" : "",
                width: toasterVar ? "165px" : "100%"
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                onClick: ()=>(0,_components_ShopTheRoomCard_analytics__WEBPACK_IMPORTED_MODULE_12__/* .shopRoomhandleProductClick */ .dv)({
                        productData: productData,
                        sku: skewId,
                        url: "".concat(pdpUrl).concat(skewId ? "?skuId=" + skewId : "", "}"),
                        cart: cart,
                        config: config,
                        description: description,
                        persona: persona
                    }),
                href: "".concat(pdpUrl).concat(skewId ? "?skuId=" + skewId : ""),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "inspired-selling-module__card",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "image__container",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    className: "product-card__image",
                                    alt: "",
                                    src: (ref = (0,_utils__WEBPACK_IMPORTED_MODULE_11__/* .getPresetUrl */ .v$)(width, 0, swatchUrl, imageId, presetConfig)) !== null && ref !== void 0 ? ref : _public_images_image_missing_png__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z,
                                    onError: (e)=>e.target.src = _public_images_image_missing_png__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z
                                })
                            }),
                            isFavoriteIcon ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "product-tile__share",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    id: "kf-add-to-fav-".concat(skewId),
                                    className: "product-tile__share-icon",
                                    tabIndex: "0",
                                    onClick: handleFavorite,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        role: "presentation",
                                        src: favFilled ? _public_icons_wishlist_gray_filled_svg__WEBPACK_IMPORTED_MODULE_19__/* ["default"].src */ .Z.src : _public_icons_wish_svg__WEBPACK_IMPORTED_MODULE_18__/* ["default"].src */ .Z.src,
                                        alt: ""
                                    })
                                })
                            }) : null
                        ]
                    }),
                    isDefaultProductCard ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "card-text__container",
                        role: "presentation",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "card-details__container",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "card-details__card-title-container",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            style: {
                                                color: toaster ? "#494949" : ""
                                            },
                                            children: name
                                        })
                                    }),
                                    !isMobile ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "card-details__card-price",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            children: "".concat(currencySign).concat(price)
                                        })
                                    }) : null
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "card-details-descriprion__container",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    children: description
                                })
                            }),
                            isMobile && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "card-details__card-price",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    children: "".concat(currencySign).concat(price)
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "shop-the-room-card-details",
                        style: {
                            color: toasterVar ? "#494949" : ""
                        },
                        children: [
                            !toasterVar && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "brand-name",
                                style: {
                                    color: toasterVar ? "#494949" : ""
                                },
                                children: productBrand
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "regional-brand-name",
                                style: {
                                    color: toasterVar ? "#494949" : ""
                                },
                                children: reginalBrandName
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "short-description",
                                style: {
                                    color: toasterVar ? "#494949" : "",
                                    overflow: "hidden",
                                    display: "-webkit-box",
                                    webkitLineClamp: "2",
                                    webkitBoxOrient: "vertical"
                                },
                                children: description
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "price",
                                style: {
                                    color: toasterVar ? "#494949" : ""
                                },
                                children: "".concat(currencySign).concat(price)
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ProductCard);


/***/ }),

/***/ 38560:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ getProductInfo; }
/* harmony export */ });
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55760);


const getProductInfo = function(productData, sku) {
    let needsJSON = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, cart = arguments.length > 3 ? arguments[3] : void 0, config = arguments.length > 4 ? arguments[4] : void 0, description = arguments.length > 5 ? arguments[5] : void 0, persona = arguments.length > 6 ? arguments[6] : void 0;
    var ref;
    const { productCouponCode , productCoupondiscount  } = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_1__/* .getCurrentSkuCouponDiscounts */ .mPk)({
        cart: cart,
        sku: sku
    });
    const colorDetails = lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(productData, "Color.SKU.Details_ss", []);
    var ref1;
    const colorDetail = (ref1 = colorDetails.find((colorDetail)=>colorDetail.includes(sku))) !== null && ref1 !== void 0 ? ref1 : "|";
    const color = colorDetail.split("|")[0];
    const productInfo = {
        productInfo: {
            productBrand: (ref = lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(config, "general.siteName", "")) === null || ref === void 0 ? void 0 : ref.toLowerCase(),
            description: ((0,_utils_helper__WEBPACK_IMPORTED_MODULE_1__/* .sanitizeTextForAnalytics */ .T68)(description) || "n/a").toLowerCase(),
            globalPromotionPrice: Number(lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(productData, "priceList.".concat(persona, ".discountedPrice_d"), 0)).toFixed(2),
            productBasePrice: Number(lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(productData, "priceList.".concat(persona, ".price_d"), 0)).toFixed(2),
            productCategory: ((0,_utils_helper__WEBPACK_IMPORTED_MODULE_1__/* .sanitizeTextForAnalytics */ .T68)(productData["Product_Category"]) || "n/a").toLowerCase(),
            productColor: ((0,_utils_helper__WEBPACK_IMPORTED_MODULE_1__/* .sanitizeTextForAnalytics */ .T68)(color) || "n/a").toLowerCase(),
            productName: ((0,_utils_helper__WEBPACK_IMPORTED_MODULE_1__/* .sanitizeTextForAnalytics */ .T68)(lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(productData, "productName_s", "")) || "n/a").toLowerCase(),
            productFindingMethod: "n/a",
            productCouponCode: productCouponCode.join("|") || "n/a",
            productCoupondiscount: productCoupondiscount,
            frequency: "n/a",
            isRecommended: "n/a",
            isSendNow: "n/a",
            isSubscription: "n/a",
            quantity: "n/a",
            ratings: "n/a",
            numberOfReviews: "n/a"
        }
    };
    if (needsJSON) {
        return productInfo.productInfo;
    }
    return productInfo;
};


/***/ }),

/***/ 29982:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fw": function() { return /* binding */ handleEmptyCartCallback; },
/* harmony export */   "G": function() { return /* binding */ addAllToCartEventInfo; },
/* harmony export */   "HP": function() { return /* binding */ multiFinishAddToCartBundleAnalytics; },
/* harmony export */   "Mw": function() { return /* binding */ continueShopGetEventInfo; },
/* harmony export */   "p1": function() { return /* binding */ getCartItemProductInfo; },
/* harmony export */   "t9": function() { return /* binding */ addMergeEventInfo; }
/* harmony export */ });
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55760);

const emptyCartEventInfo = (status, message)=>({
        eventAction: "cart:landing page:empty cart",
        eventName: "cart:landing page:empty cart",
        eventType: "navigation",
        eventMsg: status === "success" ? "n/a" : message,
        eventStatus: status,
        internalLinkName: "empty cart",
        internalLinkPosition: "cart",
        internalLinkType: "cart:navigation",
        internalLinkZoneName: "cart:landing page:cart items",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    });
const continueShopGetEventInfo = (continueShopUrl)=>{
    return JSON.stringify({
        eventAction: "cart preview:continue shopping",
        eventName: "cart preview:continue shopping",
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "continue shopping",
        internalLinkPosition: "cart",
        internalLinkType: "cart:navigation",
        internalLinkZoneName: "cart:preview",
        internalLinkURL: (continueShopUrl.indexOf("http") === -1 ? window.location.origin : "") + continueShopUrl,
        clickInternalLinks: "true"
    });
};
const addAllToCartEventInfo = (link)=>{
    const eventInfo = {
        eventAction: "cart:share cart landing page:add all to cart",
        eventName: "cart:share cart landing page:add all to cart",
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "add all to cart",
        internalLinkPosition: "share cart",
        internalLinkType: "share cart:navigation",
        internalLinkZoneName: "cart:share cart landing page:order summary",
        internalLinkURL: link,
        clickInternalLinks: "true"
    };
    pushAnalyticsObjToDataLayer(eventInfo);
};
const addMergeEventInfo = (type, link)=>{
    const eventInfo = {
        eventAction: "cart:share cart landing page:add all to cart:".concat(type),
        eventName: "cart:share cart landing page:add all to cart",
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: type,
        internalLinkPosition: "share cart",
        internalLinkType: "share cart:navigation",
        internalLinkZoneName: "cart:share cart landing page:order summary",
        internalLinkURL: link,
        clickInternalLinks: "true"
    };
    pushAnalyticsObjToDataLayer(eventInfo);
};
const pushAnalyticsObjToDataLayer = function() {
    let eventInfo = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const event = "cmp:click";
    window.adobeDataLayer.push({
        event,
        eventInfo,
        page
    });
};
const handleEmptyCartCallback = (status, message, res)=>{
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState ? getState("page") : {};
    if (status === "success" && res) {
        var ref;
        page.cart = {
            cartID: res.id || ((ref = page.cart) === null || ref === void 0 ? void 0 : ref.cartID) || null,
            item: null,
            price: null
        };
    }
    const eventInfo = emptyCartEventInfo(status, message);
    window.adobeDataLayer.push({
        event: "cmp:click",
        eventInfo,
        page
    });
};
const getCartItemProductInfo = function() {
    let siteName = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", data = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const { sku ="" , desc ="" , name ="" , color ="" , image ="" , quantity =0 , category ="" , unitPrice =0 , totalPrice =0 , availableQty =0 , superSku =false , outOfStock =false , discountPercent =0 , ProductIsRetail ="" , businessUnitName ="" , customerFacingSKU ="" , discontinuedProductb ="" , productCollectionsName ="" , ProductRequiredAccessoriesGroupsList =""  } = data;
    return JSON.stringify({
        productInfo: {
            productBrand: siteName.toLowerCase(),
            description: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .sanitizeTextForAnalytics */ .T68)(desc),
            globalPromotionPrice: totalPrice,
            priceState: "".concat(discountPercent > 0 ? "percentOff|".concat(discountPercent) : "regular price"),
            productBasePrice: unitPrice,
            productCategory: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .sanitizeTextForAnalytics */ .T68)(category),
            productColor: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .sanitizeTextForAnalytics */ .T68)(color),
            productID: customerFacingSKU || sku,
            productName: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .sanitizeTextForAnalytics */ .T68)(name),
            productRoom: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .sanitizeTextForAnalytics */ .T68)(category),
            productSalePrice: totalPrice,
            productStatus: outOfStock && availableQty < 1 ? "out of stock" : "in stock",
            productSuperSku: superSku ? true : false,
            productTileName: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .sanitizeTextForAnalytics */ .T68)(name),
            quantity: quantity,
            defaultImageName: image,
            productCollectionsName: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .sanitizeTextForAnalytics */ .T68)(productCollectionsName || category),
            productCoupondiscount: "n/a",
            productPartnerBuyNow: "true",
            productSaleable: "true",
            isRecommended: "true",
            isSendNow: "true",
            isSubscription: "true",
            frequency: "n/a",
            ratings: "n/a",
            numberOfReviews: "n/a",
            pdpType: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .pdpTypeFormat */ .V4r)({
                businessUnitName: businessUnitName,
                ProductIsRetail: ProductIsRetail,
                discontinuedProductb: discontinuedProductb,
                ProductRequiredAccessoriesGroupsList: ProductRequiredAccessoriesGroupsList,
                superSku: superSku
            }),
            productFindingMethod: "n/a"
        }
    });
};
const multiFinishAddToCartBundleAnalytics = function() {
    let previousBundleItems = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], selectedBundlesProdctList = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    if (Object.keys(previousBundleItems).length === 0) {
        const bundlesLists = JSON.stringify(selectedBundlesProdctList);
        localStorage.setItem("bundleItems", bundlesLists);
    } else {
        const isExitingBundleItems = previousBundleItems.find((item)=>{
            return item.bundleId === selectedBundlesProdctList[0].bundleId;
        });
        if (isExitingBundleItems) {
            const newBundleItems = previousBundleItems.map((item)=>{
                var ref;
                if ((item === null || item === void 0 ? void 0 : item.bundleId) === ((ref = selectedBundlesProdctList[0]) === null || ref === void 0 ? void 0 : ref.bundleId)) {
                    const data = {
                        ...item,
                        selectedSkus: [
                            ...item.selectedSkus,
                            ...selectedBundlesProdctList[0].selectedSkus
                        ]
                    };
                    data.selectedSkus = data.selectedSkus.filter((value, index, array)=>array.indexOf(value) === index);
                    return data;
                }
                return item;
            });
            localStorage.setItem("bundleItems", JSON.stringify(newBundleItems));
        } else {
            const newBundleItems1 = [
                ...previousBundleItems,
                ...selectedBundlesProdctList
            ];
            localStorage.setItem("bundleItems", JSON.stringify(newBundleItems1));
        }
    }
};


/***/ }),

/***/ 4364:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J9": function() { return /* binding */ shareaddToCart; },
/* harmony export */   "Ot": function() { return /* binding */ generateCartData; },
/* harmony export */   "al": function() { return /* binding */ deleteCart; },
/* harmony export */   "gO": function() { return /* binding */ getSharedCart; },
/* harmony export */   "kx": function() { return /* binding */ getShareCartaddToCart; },
/* harmony export */   "tH": function() { return /* binding */ handleSharedCartItems; },
/* harmony export */   "uX": function() { return /* binding */ getProductsBySku; }
/* harmony export */ });
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _store_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88032);
/* harmony import */ var _constants_api__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73350);
/* harmony import */ var _store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46201);
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19514);
/* harmony import */ var _utils_cart__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11763);
/* harmony import */ var _store_features_genericSlice__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(88751);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(55760);
/* harmony import */ var _js_helperV2__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(30696);
/* harmony import */ var _components_cart_cartHelper__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(93284);
/* harmony import */ var _constants_routes__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(64757);
/* harmony import */ var _components_sharedCart_analytics__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(29982);










const { shareCartEndPoint  } = __webpack_require__(96301);


const getProductsBySku = async (skus)=>{
    let query = "";
    skus.forEach((sku, i)=>{
        query += '"'.concat(sku, '"');
        if (i + 1 !== skus.length) query += ", ";
    });
    const res = await _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .apim.get */ .TH.get("".concat(_constants_routes__WEBPACK_IMPORTED_MODULE_10__/* .CATALOG_PROJECTION_ENDPOINT */ .E5, "?where=masterVariant(sku in (").concat(query, ")) or variants(sku in (").concat(query, "))"));
    if (res && res.data && res.data.results) return res.data.results;
    return [];
};
const getSharedCart = async (id)=>{
    const { data =false  } = await _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .apim.get */ .TH.get("".concat(shareCartEndPoint, "/").concat(id));
    if (data) {
        const lineitems = data === null || data === void 0 ? void 0 : data.lineitems.map((item)=>{
            return {
                ...item,
                roomInfo: (item === null || item === void 0 ? void 0 : item.roomInfo) ? JSON.stringify(item.roomInfo) : ""
            };
        });
        const sharedCart = {
            ...data,
            lineitems
        };
        return sharedCart;
    }
};
const showToastHandler = (msg)=>_store_index__WEBPACK_IMPORTED_MODULE_1__/* .store.dispatch */ .h.dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_6__/* .showToast */ .CF)({
        message: msg,
        isVisible: true
    }));
const shareaddToCart = async (items, message, callback, clockID)=>{
    var ref, ref1;
    const payload = [];
    const CONFIG = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_4__/* .getConfig */ .i)();
    var ref2;
    const salesChannels = (ref2 = CONFIG === null || CONFIG === void 0 ? void 0 : (ref = CONFIG.salesChannelConfig) === null || ref === void 0 ? void 0 : ref.map) !== null && ref2 !== void 0 ? ref2 : {};
    const selectedBundlesProdctList = items === null || items === void 0 ? void 0 : (ref1 = items[0]) === null || ref1 === void 0 ? void 0 : ref1.selectedBundlesProduct;
    items.forEach(function() {
        let product = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        const { isBundleProduct =false , isBundle =false , sku ="" , quantity =0 , brand =""  } = product;
        var _brand;
        const fields = {
            salesChannel: (_brand = salesChannels[brand]) !== null && _brand !== void 0 ? _brand : "KOUS"
        };
        if (product.backorder) fields.isBackOrderable = true;
        payload.push({
            action: isBundleProduct ? "addBundleItem" : isBundle ? "addbundle" : "addLineItem",
            sku,
            quantity,
            custom: product.additionalInfo ? {
                type: {
                    key: "lineItemShipping"
                },
                fields: {
                    salesChannel: salesChannels[product.brand],
                    roomInfo: product.additionalInfo.roomInfo,
                    customQuantity: product.additionalInfo.customQuantity,
                    overage: product.additionalInfo.overage
                }
            } : {
                type: {
                    key: "lineItemShipping"
                },
                fields: fields
            }
        });
    });
    if (clockID) {
        payload.push({
            action: "setCustomType",
            type: {
                key: "order",
                typeId: "type"
            },
            fields: {
                CSRAssociateId: clockID,
                orderType: "ISC"
            }
        });
    }
    const body = {
        actions: payload
    };
    const bundleLocalStorage = localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem("bundleItems");
    const previousBundleItems = bundleLocalStorage ? JSON.parse(bundleLocalStorage) : [];
    await _store_index__WEBPACK_IMPORTED_MODULE_1__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__/* .addToCart */ .Xq)(body)).unwrap().then((res)=>{
        if (res) {
            // To add analytics to multifinish bundle
            // will remove once the bundle data available to the API
            if ((selectedBundlesProdctList === null || selectedBundlesProdctList === void 0 ? void 0 : selectedBundlesProdctList.length) > 0) {
                (0,_components_sharedCart_analytics__WEBPACK_IMPORTED_MODULE_11__/* .multiFinishAddToCartBundleAnalytics */ .HP)(previousBundleItems, selectedBundlesProdctList);
            }
            _store_index__WEBPACK_IMPORTED_MODULE_1__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__/* .setCart */ .RV)(res));
            const quantityLineItems = res === null || res === void 0 ? void 0 : res.lineItems;
            const payload = (0,_utils_cart__WEBPACK_IMPORTED_MODULE_5__/* .getQuantityCount */ .PW)(quantityLineItems);
            _store_index__WEBPACK_IMPORTED_MODULE_1__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__/* .setCartCount */ .oJ)(payload));
            if (message) {
                showToastHandler(message);
            }
            if (callback) {
                callback({
                    res
                });
            }
        }
    }).catch((err)=>{
        callback(err);
    });
};
const handleSharedCartItems = function() {
    let cartItems = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], products = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], info = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    const { currencyCode ="" , locale ="" , comboSkus: comboSkusArg = [] , productBrands: productBrandsArg = []  } = info;
    let subtotal = 0;
    const specFiles = [];
    const cartData = [];
    const comboSkus = [
        ...comboSkusArg
    ];
    const productBrands = [
        ...productBrandsArg
    ];
    if (products.length > 0) {
        cartItems.filter((item)=>{
            var ref, ref1;
            return !((ref = item.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.bundleParentId);
        }).forEach((item, i)=>{
            var ref;
            let product = {};
            let productVariant = {};
            // Check if product is master variant
            if (products.find((product)=>product.masterVariant.sku === item.sku)) {
                product = products.find((product)=>product.masterVariant.sku === item.sku);
                productVariant = product.masterVariant;
            } else {
                var ref1;
                var ref2;
                product = (ref2 = products.find((product)=>product.variants.find((variant)=>variant.sku === item.sku))) !== null && ref2 !== void 0 ? ref2 : {};
                var ref3;
                productVariant = (ref3 = (ref1 = product.variants) === null || ref1 === void 0 ? void 0 : ref1.find((variant)=>variant.sku === item.sku)) !== null && ref3 !== void 0 ? ref3 : {};
            }
            var _attributes;
            // Get product details
            const attributes = (_attributes = productVariant.attributes) !== null && _attributes !== void 0 ? _attributes : [];
            let priceObj = (ref = productVariant.prices) === null || ref === void 0 ? void 0 : ref.find((price)=>{
                var ref, ref1;
                return price.value.currencyCode === currencyCode && ((ref = price.customerGroup) === null || ref === void 0 ? void 0 : (ref1 = ref.obj) === null || ref1 === void 0 ? void 0 : ref1.key) === (0,_utils_helper__WEBPACK_IMPORTED_MODULE_7__/* .getUserPersona */ .shu)();
            });
            if (!(priceObj === null || priceObj === void 0 ? void 0 : priceObj.value)) {
                var ref4;
                priceObj = (ref4 = productVariant.prices) === null || ref4 === void 0 ? void 0 : ref4.find((price)=>price.value.currencyCode === currencyCode && !price.customerGroup);
            }
            const unitPrice = lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(priceObj, "value.centAmount", 0);
            var ref5, _thumbnailImage;
            cartData[i] = {
                id: (ref5 = product === null || product === void 0 ? void 0 : product.id) !== null && ref5 !== void 0 ? ref5 : "",
                sku: item.sku,
                slug: (product === null || product === void 0 ? void 0 : product.slug) ? product.slug[locale] : "",
                quantity: item.qty,
                image: (_thumbnailImage = item.thumbnailImage) !== null && _thumbnailImage !== void 0 ? _thumbnailImage : "",
                category: lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(attributes.find((attr)=>attr.name === "ProductLocalCategory"), "value", ""),
                brand: lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(attributes.find((attr)=>attr.name === "CustomerFacingBrand"), "value", ""),
                name: lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(attributes.find((attr)=>attr.name === "RegionBrandName"), "value", lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(item, "skuName", "")),
                desc: lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(attributes.find((attr)=>attr.name === "ProductDescriptionProductShort"), "value[".concat(locale, "]"), lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(attributes.find((attr)=>attr.name === "ProductDescriptionProduct"), "value", "")),
                color: lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(attributes.find((attr)=>attr.name === "SKUColorFinishName"), "value[".concat(locale, "]"), ""),
                unitPrice: Number((unitPrice / 100).toFixed(2)),
                totalPrice: Number((unitPrice * item.qty / 100).toFixed(2)),
                customerFacingSKU: (0,_js_helperV2__WEBPACK_IMPORTED_MODULE_8__/* .getAttributeValue */ .kD)(attributes, "CustomerFacingSKU")
            };
            // Check if product is a combo sku
            comboSkus[item.sku] = attributes.findIndex((attr)=>attr.name === "ComboSKU") !== -1;
            productBrands[item.sku] = lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(attributes.find((attr)=>attr.name === "CustomerFacingBrand"), "value", "");
            // Calculate cart subtotal
            subtotal = subtotal + Number((unitPrice * item.qty / 100).toFixed(2));
            // Get spec files for all line items
            const productResources = lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(attributes.find((attr)=>attr.name === "ProductResource"), "value", []);
            if (productResources.length > 0) {
                var ref6;
                const resource = (ref6 = productResources.find((arr)=>arr[1].value === "SpecPDFFileName")) !== null && ref6 !== void 0 ? ref6 : [];
                var ref7;
                const resourceUrl = (ref7 = resource.find((obj)=>obj.name === "ResourceFullWebURL")) !== null && ref7 !== void 0 ? ref7 : {};
                var _value;
                const specFileUrl = (_value = resourceUrl.value) !== null && _value !== void 0 ? _value : "";
                if (specFileUrl) specFiles.push(specFileUrl);
            }
        });
        return {
            cartData,
            specFiles,
            subtotal,
            comboSkus,
            productBrands
        };
    }
};
const getShareCartaddToCart = async function() {
    let items = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], showPreview = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, message = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, callback = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : ()=>{}, taxCalculate = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false, clockID = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : "", isSharedCart = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : false, replaceCart = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : false;
    var ref, ref1;
    const { itemAddedToCart ="" , addToCartErrorMsg =""  } = message;
    const payload = [];
    let userZipCode;
    const CONFIG = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_4__/* .getConfig */ .i)();
    const isAuthenticated = (ref = _store_index__WEBPACK_IMPORTED_MODULE_1__/* .store.getState */ .h.getState()) === null || ref === void 0 ? void 0 : ref.auth.isAuth;
    var ref2;
    const salesChannels = (ref2 = CONFIG === null || CONFIG === void 0 ? void 0 : (ref1 = CONFIG.salesChannelConfig) === null || ref1 === void 0 ? void 0 : ref1.map) !== null && ref2 !== void 0 ? ref2 : {};
    items.forEach((product)=>{
        const { brand ="" , backorder =false , isBundle ="" , sku ="" , quantity ="" , additionalInfo =""  } = product;
        var ref;
        const fields = {
            salesChannel: (ref = salesChannels[brand.toLowerCase()]) !== null && ref !== void 0 ? ref : "KOUS"
        };
        if (backorder) fields.isBackOrderable = true;
        payload.push({
            action: isBundle ? "addbundle" : "addLineItem",
            sku: sku,
            quantity: quantity,
            custom: additionalInfo ? {
                type: {
                    key: "lineItemShipping"
                },
                fields: {
                    salesChannel: salesChannels[brand],
                    roomInfo: additionalInfo.roomInfo,
                    customQuantity: additionalInfo.customQuantity,
                    overage: additionalInfo.overage
                }
            } : {
                type: {
                    key: "lineItemShipping"
                },
                fields: fields
            }
        });
        userZipCode = product === null || product === void 0 ? void 0 : product.userZipCode;
    });
    const { id ="" , version =0 , customerGroup ="" , shippingAddress: { postalCode =""  } = {}  } = await generateCartData({
        replaceCart
    });
    if (taxCalculate && postalCode) payload.push({
        action: "calculateTax"
    });
    if (!isAuthenticated && !customerGroup) {
        payload.push({
            action: "setCustomerGroup",
            customerGroup: {
                key: "GST"
            }
        });
    }
    if (clockID) {
        payload.push({
            action: "setCustomType",
            type: {
                key: "order",
                typeId: "type"
            },
            fields: {
                CSRAssociateId: clockID,
                orderType: "ISC"
            }
        });
    }
    const body = {
        version: version,
        actions: payload,
        cartId: id,
        isSharedCart
    };
    if (userZipCode) {
        body.servicesku = true;
        body.zipCode = userZipCode;
    }
    let atcStatus;
    await _store_index__WEBPACK_IMPORTED_MODULE_1__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__/* .shareCartaddToCart */ ._P)(body)).unwrap().then((res)=>{
        if (res) {
            atcStatus = {
                res
            };
            if (itemAddedToCart) {
                showToastHandler(itemAddedToCart);
            }
            if (showPreview) _store_index__WEBPACK_IMPORTED_MODULE_1__/* .store.dispatch */ .h.dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_6__/* .showPreviewCart */ .z0)());
            if (callback) {
                callback({
                    message: "success",
                    res
                });
            }
            if (taxCalculate && postalCode) {
                _store_index__WEBPACK_IMPORTED_MODULE_1__/* .store.dispatch */ .h.dispatch((0,_components_cart_cartHelper__WEBPACK_IMPORTED_MODULE_9__/* .getShippingMethods */ .qy)());
            }
            if (!isAuthenticated && res.anonymousId) localStorage.setItem("anonymousId", res.anonymousId);
        }
    }).catch(()=>{
        _store_index__WEBPACK_IMPORTED_MODULE_1__/* .store.dispatch */ .h.dispatch(showToastHandler(addToCartErrorMsg));
    });
    return atcStatus;
};
const deleteCart = async (errMsg)=>{
    const errorMsg = "Failed to delete cart";
    try {
        const { id ="" , version =0  } = await generateCartData({
            isNotFromCart: true
        });
        return _store_index__WEBPACK_IMPORTED_MODULE_1__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__/* .shareCartDelete */ .ap)({
            id,
            version
        }));
    } catch (err) {
        console.log(errorMsg, err);
        _store_index__WEBPACK_IMPORTED_MODULE_1__/* .store.dispatch */ .h.dispatch(showToastHandler(errMsg));
    }
};
const generateCartData = async (arg)=>{
    const { replaceCart =false , isNotFromCart =false  } = arg || {};
    const currency = await (0,_utils_helper__WEBPACK_IMPORTED_MODULE_7__/* .getCurrency */ .zC$)();
    const body = {
        currency: currency,
        taxMode: "ExternalAmount"
    };
    let cartData = {};
    if (replaceCart) {
        const { payload  } = await _store_index__WEBPACK_IMPORTED_MODULE_1__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__/* .createCart */ .Bk)(body));
        cartData = payload;
    } else {
        var ref, ref1;
        const { payload: rsp  } = await _store_index__WEBPACK_IMPORTED_MODULE_1__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__/* .getCart */ .dv)(arg));
        cartData = isNotFromCart ? rsp === null || rsp === void 0 ? void 0 : (ref = rsp.data) === null || ref === void 0 ? void 0 : (ref1 = ref.me) === null || ref1 === void 0 ? void 0 : ref1.activeCart : rsp;
    }
    return cartData;
};


/***/ }),

/***/ 73350:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gb": function() { return /* binding */ aemAxiosInstance; },
/* harmony export */   "IT": function() { return /* binding */ aemPreviewAxiosInstance; },
/* harmony export */   "TH": function() { return /* binding */ apim; },
/* harmony export */   "ab": function() { return /* binding */ getAnonymousToken; }
/* harmony export */ });
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96301);
/* harmony import */ var universal_cookie__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(65885);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88032);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _store_features_authSlice__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(24899);
/* harmony import */ var _store_features_cartSlice__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(46201);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(55760);
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(19514);
/* provided dependency */ var Buffer = __webpack_require__(48764)["Buffer"];









const token = "".concat(___WEBPACK_IMPORTED_MODULE_1__.authorPreviewUserName, ":").concat(___WEBPACK_IMPORTED_MODULE_1__.authorPreviewPassword);
const encodedToken = Buffer.from(token).toString("base64");
const aemAxiosInstance = axios__WEBPACK_IMPORTED_MODULE_0___default().create({
    baseURL: ___WEBPACK_IMPORTED_MODULE_1__.authorBaseUrl,
    timeout: 10000,
    headers: {
        "Content-type": "application/json",
        KohlerTarget: "AzureApp"
    }
});
const aemPreviewAxiosInstance = axios__WEBPACK_IMPORTED_MODULE_0___default().create({
    baseURL: ___WEBPACK_IMPORTED_MODULE_1__.authorPreviewBaseUrl,
    timeout: 40000,
    headers: {
        "Content-type": "application/json",
        KohlerTarget: "AzureApp",
        Authorization: "Basic " + encodedToken
    }
});
const apim = axios__WEBPACK_IMPORTED_MODULE_0___default().create({
    timeout: 25000,
    headers: {
        "Content-type": "application/json",
        KohlerTarget: "AzureApp"
    }
});
let validateTokenRequest;
let getAnonymousTokenRequest;
const validateToken = (accessToken, apimHost)=>{
    if (!validateTokenRequest) {
        validateTokenRequest = axios__WEBPACK_IMPORTED_MODULE_0___default().post("".concat(apimHost).concat(___WEBPACK_IMPORTED_MODULE_1__.validateTokenEndPoint), {}, {
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer ".concat(accessToken)
            }
        });
        validateTokenRequest.then(resetValidateTokenRequest, resetValidateTokenRequest);
    }
    return validateTokenRequest;
};
const getAnonymousToken = async (apimHost)=>{
    let gId;
    const token = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_6__/* .getAccessToken */ .hPi)();
    gId = token.gId;
    const cookie = new universal_cookie__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z();
    cookie.get("commerce_gid") && (gId = cookie.get("commerce_gid"));
    if (!getAnonymousTokenRequest) {
        const { apiEndPointData: { map: { channel  }  } = {}  } = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_7__/* .getConfig */ .i)();
        getAnonymousTokenRequest = axios__WEBPACK_IMPORTED_MODULE_0___default().post("".concat(apimHost).concat(___WEBPACK_IMPORTED_MODULE_1__.oktaTokenEndpoint, "?scope=guest").concat(channel ? "&channel=".concat(channel) : ""), null, {
            params: {
                gId: gId
            }
        });
        getAnonymousTokenRequest.then(resetGetAnonymousTokenRequest, resetGetAnonymousTokenRequest);
    }
    return getAnonymousTokenRequest;
};
const resetValidateTokenRequest = ()=>{
    validateTokenRequest = null;
    getAnonymousTokenRequest = null;
};
const resetGetAnonymousTokenRequest = ()=>{
    getAnonymousTokenRequest = null;
    validateTokenRequest = null;
};
apim.interceptors.request.use(async (config)=>{
    var ref, ref1, ref2;
    // set apim baseurl from global config
    const configVal = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_7__/* .getConfig */ .i)();
    const apimHost = configVal === null || configVal === void 0 ? void 0 : (ref = configVal.general) === null || ref === void 0 ? void 0 : ref.apimHost;
    config.baseURL = apimHost;
    const { token: accessToken = ""  } = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_6__/* .getAccessToken */ .hPi)();
    const anonymousId = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_6__/* .getAnonymousId */ .yQL)();
    if (accessToken) {
        config.headers.Authorization = "Bearer ".concat(accessToken);
    } else if (window && window.authAccessToken) {
        config.headers.Authorization = "Bearer ".concat(window.authAccessToken);
        window.authAccessToken = "";
    }
    const getNewToken = ()=>{
        return getAnonymousToken(apimHost).then((res)=>{
            const { data: { access_token: accessToken = ""  } = {}  } = res;
            const payload = {
                accessToken
            };
            _store__WEBPACK_IMPORTED_MODULE_2__/* .store.dispatch */ .h.dispatch((0,_store_features_authSlice__WEBPACK_IMPORTED_MODULE_4__/* .setAuthData */ .A3)(payload));
            config.headers.Authorization = "Bearer ".concat(accessToken);
            return config;
        }).catch((_error)=>{
            return Promise.reject(_error);
        });
    };
    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_6__/* .addPageLoadAnalyticsEvent */ .igK)();
    const revalidateIn = ((ref1 = _store__WEBPACK_IMPORTED_MODULE_2__/* .store.getState */ .h.getState()) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.auth) === null || ref2 === void 0 ? void 0 : ref2.revalidate_in) || "";
    const isAfter = moment__WEBPACK_IMPORTED_MODULE_3___default()().isAfter(revalidateIn);
    if (!accessToken) {
        return getNewToken();
    } else if (anonymousId && isAfter) {
        return validateToken(accessToken, apimHost).then((res)=>{
            var ref;
            if ((ref = res.data) === null || ref === void 0 ? void 0 : ref.valid) {
                _store__WEBPACK_IMPORTED_MODULE_2__/* .store */ .h === null || _store__WEBPACK_IMPORTED_MODULE_2__/* .store */ .h === void 0 ? void 0 : _store__WEBPACK_IMPORTED_MODULE_2__/* .store.dispatch */ .h.dispatch((0,_store_features_authSlice__WEBPACK_IMPORTED_MODULE_4__/* .setRevalidateTime */ .iU)());
                return config;
            } else {
                return getNewToken();
            }
        }).catch(()=>{
            return getAnonymousToken(apimHost).then((res)=>{
                const { data: { access_token: accessToken = ""  } = {}  } = res;
                const payload = {
                    accessToken
                };
                _store__WEBPACK_IMPORTED_MODULE_2__/* .store.dispatch */ .h.dispatch((0,_store_features_authSlice__WEBPACK_IMPORTED_MODULE_4__/* .setAuthData */ .A3)(payload));
                config.headers.Authorization = "Bearer ".concat(accessToken);
                return config;
            }).catch((_error)=>{
                return Promise.reject(_error);
            });
        });
    } else {
        return config;
    }
}, (error)=>{
    return Promise.reject(error);
});
apim.interceptors.response.use(async (res)=>{
    return res;
}, async (error)=>{
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14;
    const originalConfig = error.config;
    if (!((ref = _store__WEBPACK_IMPORTED_MODULE_2__/* .store.getState */ .h.getState()) === null || ref === void 0 ? void 0 : (ref1 = ref.auth) === null || ref1 === void 0 ? void 0 : ref1.isAuth) && (error === null || error === void 0 ? void 0 : (ref2 = error.response) === null || ref2 === void 0 ? void 0 : ref2.status) === 401 && !originalConfig._retry && (error.response.data.message === "JWT not present." || error.response.data.message === "Invalid JWT.")) {
        originalConfig._retry = true;
        const { general: { apimHost  } = {}  } = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_7__/* .getConfig */ .i)();
        return getAnonymousToken(apimHost).then((res)=>{
            const { data: { access_token: accessToken = ""  } = {}  } = res;
            const payload = {
                accessToken
            };
            _store__WEBPACK_IMPORTED_MODULE_2__/* .store.dispatch */ .h.dispatch((0,_store_features_authSlice__WEBPACK_IMPORTED_MODULE_4__/* .setAuthData */ .A3)(payload));
        }).catch((_error)=>{
            return Promise.reject(_error);
        });
    } else if (((error === null || error === void 0 ? void 0 : (ref3 = error.response) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.config) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.url) === null || ref5 === void 0 ? void 0 : ref5.includes(___WEBPACK_IMPORTED_MODULE_1__.shipmentFromCartEndPoint)) || (error === null || error === void 0 ? void 0 : (ref6 = error.response) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.config) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.url) === null || ref8 === void 0 ? void 0 : ref8.includes(___WEBPACK_IMPORTED_MODULE_1__.shippingCostEndPoint))) && (error === null || error === void 0 ? void 0 : (ref9 = error.response) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.data) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.error) === null || ref11 === void 0 ? void 0 : ref11.message) && (error === null || error === void 0 ? void 0 : (ref12 = error.response) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.data) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.error) === null || ref14 === void 0 ? void 0 : ref14.sku)) {
        var ref15, ref16, ref17, ref18;
        const productsArray = [];
        error === null || error === void 0 ? void 0 : (ref15 = error.response) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.data) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.error) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.sku) === null || ref18 === void 0 ? void 0 : ref18.forEach((data)=>{
            productsArray.push({
                sku: data
            });
        });
        await _store__WEBPACK_IMPORTED_MODULE_2__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_5__/* .setNoshipping */ .qT)(productsArray));
    }
    return Promise.reject(error);
});



/***/ }),

/***/ 19514:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ getConfig; },
/* harmony export */   "p": function() { return /* binding */ initConfig; }
/* harmony export */ });
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96301);
/* harmony import */ var _constants_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73350);


/**
 *
 * @return {{initConfig, getConfig}}
 */ function configuration() {
    let _configurationObj = {};
    const initConfig = async ()=>{
        const urlPath = window.location.pathname;
        const path = "".concat(___WEBPACK_IMPORTED_MODULE_0__.GLOBAL_CONFIGURATION_ENDPOINT, "?path=").concat(urlPath, "&caConfig=true");
        var ref;
        _configurationObj = (ref = JSON.parse(localStorage && localStorage.getItem("caConfig-".concat(document.documentElement.lang)))) !== null && ref !== void 0 ? ref : {
            expireTime: 0
        };
        const currentTime = new Date().getTime();
        if (path && currentTime > _configurationObj.expireTime) {
            var ref1;
            await _constants_api__WEBPACK_IMPORTED_MODULE_1__/* .aemAxiosInstance.get */ .Gb.get(path).then((response)=>{
                if (response && response.data) {
                    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
                    const _backendConfig = response.data;
                    if (_backendConfig === null || _backendConfig === void 0 ? void 0 : (ref = _backendConfig.general) === null || ref === void 0 ? void 0 : ref.isPublish) {
                        const getShortenedUrl = (uUrl)=>{
                            var ref;
                            var ref1;
                            const shortUrl = (ref1 = _backendConfig === null || _backendConfig === void 0 ? void 0 : (ref = _backendConfig.general) === null || ref === void 0 ? void 0 : ref.shortendPagePath) !== null && ref1 !== void 0 ? ref1 : "";
                            const shortUrlRegEx = new RegExp(shortUrl, "g");
                            const htmlRegExp = new RegExp(".html", "g");
                            return uUrl.replace(shortUrlRegEx, "").replace(htmlRegExp, "");
                        };
                        const pattern = "^(?!.*json)".concat(_backendConfig.general.shortendPagePath, ".*");
                        for(const link in _backendConfig.general){
                            if (({}).hasOwnProperty.call(_backendConfig.general, link)) {
                                const url = "".concat(_backendConfig.general[link]);
                                if (url.match(pattern)) {
                                    if (link !== "shortendPagePath") _backendConfig.general[link] = getShortenedUrl(_backendConfig.general[link]);
                                }
                            }
                        }
                    }
                    _configurationObj = Object.assign(_configurationObj, _backendConfig);
                    _configurationObj.annsacksPDPConfig = (ref1 = response.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.annsacksPDPConfig) === null || ref2 === void 0 ? void 0 : ref2.map;
                    var ref7;
                    _configurationObj.apiEndpoints = (ref7 = (ref3 = response.data) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.apiEndPointData) === null || ref4 === void 0 ? void 0 : ref4.map) !== null && ref7 !== void 0 ? ref7 : {};
                    var ref8;
                    const assetAccountName = (ref8 = response === null || response === void 0 ? void 0 : (ref5 = response.data) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.general) === null || ref6 === void 0 ? void 0 : ref6.scene7AccountName) !== null && ref8 !== void 0 ? ref8 : null;
                    if (assetAccountName) {
                        _configurationObj.general.swatchUrl = _configurationObj.general.swatchUrl.replace("PAWEB", assetAccountName);
                    }
                } else {
                    console.error("Error occurred while fetching Backend Configuration");
                }
            });
            await _constants_api__WEBPACK_IMPORTED_MODULE_1__/* .aemAxiosInstance.get */ .Gb.get(___WEBPACK_IMPORTED_MODULE_0__.GLOBAL_CONFIGURATION_ENDPOINT + "?path=" + ((ref1 = _configurationObj.general) === null || ref1 === void 0 ? void 0 : ref1.plpServletPath)).then((res)=>{
                var ref;
                _configurationObj.plpServletPath = (ref = res.data) === null || ref === void 0 ? void 0 : ref.pdpURLMapping;
                _configurationObj.expireTime = new Date().getTime() + ___WEBPACK_IMPORTED_MODULE_0__.ADD_10_MINUTES;
                if (localStorage) localStorage.setItem("caConfig-".concat(document.documentElement.lang), JSON.stringify(_configurationObj));
            }).catch((err)=>console.error("Error occurred while fetching PLP Servlet path", err));
        } else {
            console.log("Configuration URL for found");
        }
    };
    const getConfig = async ()=>{
        let configTimer;
        const config = new Promise((resolve)=>{
            if ((_configurationObj === null || _configurationObj === void 0 ? void 0 : _configurationObj.expireTime) === 0) {
                configTimer = setTimeout(()=>resolve(getConfig()), 500);
            } else {
                configTimer && clearTimeout(configTimer);
                resolve(_configurationObj);
            }
        });
        return config;
    };
    return {
        initConfig,
        getConfig
    };
}
const { initConfig , getConfig  } = configuration();


/***/ }),

/***/ 96301:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ADDRESS_SUGGESTION_DEFAULT_COUNTRY": function() { return /* binding */ ADDRESS_SUGGESTION_DEFAULT_COUNTRY; },
/* harmony export */   "ADD_10_MINUTES": function() { return /* binding */ ADD_10_MINUTES; },
/* harmony export */   "AFFIRM_SHOP_URL": function() { return /* binding */ AFFIRM_SHOP_URL; },
/* harmony export */   "API_FAILURE_STATUS": function() { return /* binding */ API_FAILURE_STATUS; },
/* harmony export */   "API_SUCCESS_STATUS": function() { return /* binding */ API_SUCCESS_STATUS; },
/* harmony export */   "ARTICLE_CONTENT_END_POINT": function() { return /* binding */ ARTICLE_CONTENT_END_POINT; },
/* harmony export */   "ARTICLE_IMG_END_POINT": function() { return /* binding */ ARTICLE_IMG_END_POINT; },
/* harmony export */   "BAZAAR_VOICE": function() { return /* binding */ BAZAAR_VOICE; },
/* harmony export */   "BRAND_NAME": function() { return /* binding */ BRAND_NAME; },
/* harmony export */   "BREAD_CRUMB_APP_LD_JSON": function() { return /* binding */ BREAD_CRUMB_APP_LD_JSON; },
/* harmony export */   "BROWSE_ALL_KOHLER_STORES": function() { return /* binding */ BROWSE_ALL_KOHLER_STORES; },
/* harmony export */   "BROWSE_ALL_STORES": function() { return /* binding */ BROWSE_ALL_STORES; },
/* harmony export */   "BROWSE_ALL_STORES_URL": function() { return /* binding */ BROWSE_ALL_STORES_URL; },
/* harmony export */   "BUNDLE_PDP_END_POINT_SUBSCRIPTION_KEY": function() { return /* binding */ BUNDLE_PDP_END_POINT_SUBSCRIPTION_KEY; },
/* harmony export */   "BUYING_GUIDE_ASPATH": function() { return /* binding */ BUYING_GUIDE_ASPATH; },
/* harmony export */   "BV_SCRIPT_URL": function() { return /* binding */ BV_SCRIPT_URL; },
/* harmony export */   "CALL_OUR_TEAM": function() { return /* binding */ CALL_OUR_TEAM; },
/* harmony export */   "CARD_TYPES": function() { return /* binding */ CARD_TYPES; },
/* harmony export */   "CART_URL": function() { return /* binding */ CART_URL; },
/* harmony export */   "CHANGE_ACCOUNT_PASSWORD_ENDPOINT": function() { return /* binding */ CHANGE_ACCOUNT_PASSWORD_ENDPOINT; },
/* harmony export */   "CHECKOUT_PAYMENT": function() { return /* binding */ CHECKOUT_PAYMENT; },
/* harmony export */   "CHECKOUT_URL": function() { return /* binding */ CHECKOUT_URL; },
/* harmony export */   "COMPONENT_TYPES": function() { return /* binding */ COMPONENT_TYPES; },
/* harmony export */   "CONTACT_US_FORM": function() { return /* binding */ CONTACT_US_FORM; },
/* harmony export */   "CONTACT_US_PAGE_URL_US": function() { return /* binding */ CONTACT_US_PAGE_URL_US; },
/* harmony export */   "CONTACT_US_SUPPORT": function() { return /* binding */ CONTACT_US_SUPPORT; },
/* harmony export */   "CONTACT_US_VALIDATE_RECAPTCHA_ENDPOINT": function() { return /* binding */ CONTACT_US_VALIDATE_RECAPTCHA_ENDPOINT; },
/* harmony export */   "CORE_GLOBAL_CONFIG_URL": function() { return /* binding */ CORE_GLOBAL_CONFIG_URL; },
/* harmony export */   "COUNTRY": function() { return /* binding */ COUNTRY; },
/* harmony export */   "CREATE_ACCOUNT": function() { return /* binding */ CREATE_ACCOUNT; },
/* harmony export */   "DEFAULT_CARD_DETAILS_API_PATH": function() { return /* binding */ DEFAULT_CARD_DETAILS_API_PATH; },
/* harmony export */   "DEFAULT_NEWELETTER_POPUP_TRIGGER_TIME": function() { return /* binding */ DEFAULT_NEWELETTER_POPUP_TRIGGER_TIME; },
/* harmony export */   "DEFAULT_PRODUCT_COUNT_PLP": function() { return /* binding */ DEFAULT_PRODUCT_COUNT_PLP; },
/* harmony export */   "DEFAULT_SCROLL": function() { return /* binding */ DEFAULT_SCROLL; },
/* harmony export */   "DEFAULT_STORE_DETAILS_API_PATH": function() { return /* binding */ DEFAULT_STORE_DETAILS_API_PATH; },
/* harmony export */   "DEFAULT_TECHNICAL_SPECT_COUNT": function() { return /* binding */ DEFAULT_TECHNICAL_SPECT_COUNT; },
/* harmony export */   "DELETE_ACCOUNT_ENDPOINT": function() { return /* binding */ DELETE_ACCOUNT_ENDPOINT; },
/* harmony export */   "DESKTOP_WIDTH": function() { return /* binding */ DESKTOP_WIDTH; },
/* harmony export */   "DISABLE_SROLL_PATH": function() { return /* binding */ DISABLE_SROLL_PATH; },
/* harmony export */   "DISCOUNTED_PRICE_FACET_LABEL": function() { return /* binding */ DISCOUNTED_PRICE_FACET_LABEL; },
/* harmony export */   "DOMAIN": function() { return /* binding */ DOMAIN; },
/* harmony export */   "DOWNLOAD_SPINNER": function() { return /* binding */ DOWNLOAD_SPINNER; },
/* harmony export */   "EDIT_PROFILE_ENDPOINT": function() { return /* binding */ EDIT_PROFILE_ENDPOINT; },
/* harmony export */   "EMBED_TYPE_HTML": function() { return /* binding */ EMBED_TYPE_HTML; },
/* harmony export */   "EMBED_TYPE_SCRIPT": function() { return /* binding */ EMBED_TYPE_SCRIPT; },
/* harmony export */   "EMPTY_FAVORITE_BASE64": function() { return /* binding */ EMPTY_FAVORITE_BASE64; },
/* harmony export */   "EMPTY_PIXEL": function() { return /* binding */ EMPTY_PIXEL; },
/* harmony export */   "EXCEPTIONAL_SITENAME": function() { return /* binding */ EXCEPTIONAL_SITENAME; },
/* harmony export */   "EXCLUDE_PAGES": function() { return /* binding */ EXCLUDE_PAGES; },
/* harmony export */   "FAQ_PAGE_DATA_URL": function() { return /* binding */ FAQ_PAGE_DATA_URL; },
/* harmony export */   "FAVORITES_LIST_END_POINT": function() { return /* binding */ FAVORITES_LIST_END_POINT; },
/* harmony export */   "FAVORITES_LIST_LIMIT": function() { return /* binding */ FAVORITES_LIST_LIMIT; },
/* harmony export */   "FEATURE_FLAGS_CHECKOUT_PAYLOAD": function() { return /* binding */ FEATURE_FLAGS_CHECKOUT_PAYLOAD; },
/* harmony export */   "FETCH_PRODUCT_REG_ENDPOINT": function() { return /* binding */ FETCH_PRODUCT_REG_ENDPOINT; },
/* harmony export */   "FINDLOCATIONKEYCODE": function() { return /* binding */ FINDLOCATIONKEYCODE; },
/* harmony export */   "FIND_A_PRO_HASH": function() { return /* binding */ FIND_A_PRO_HASH; },
/* harmony export */   "FIND_A_PRO_PATH": function() { return /* binding */ FIND_A_PRO_PATH; },
/* harmony export */   "FIND_A_STORE": function() { return /* binding */ FIND_A_STORE; },
/* harmony export */   "FIND_MY_ORDERS_ENDPOINT": function() { return /* binding */ FIND_MY_ORDERS_ENDPOINT; },
/* harmony export */   "FIND_MY_ORDERS_V1_ENDPOINT": function() { return /* binding */ FIND_MY_ORDERS_V1_ENDPOINT; },
/* harmony export */   "FIND_STORE_URL": function() { return /* binding */ FIND_STORE_URL; },
/* harmony export */   "FRAGMENT_TYPES": function() { return /* binding */ FRAGMENT_TYPES; },
/* harmony export */   "FRAUD_CHLLENGE_STATUS": function() { return /* binding */ FRAUD_CHLLENGE_STATUS; },
/* harmony export */   "FREIGHT_SHIPPING_TYPES": function() { return /* binding */ FREIGHT_SHIPPING_TYPES; },
/* harmony export */   "FRIENDS_AND_FAMILY_API_URL_ENDPOINT": function() { return /* binding */ FRIENDS_AND_FAMILY_API_URL_ENDPOINT; },
/* harmony export */   "FRIENDS_AND_FAMILY_QUERRY_SELECTOR_URL": function() { return /* binding */ FRIENDS_AND_FAMILY_QUERRY_SELECTOR_URL; },
/* harmony export */   "FULL_FAVORITE_BASE64": function() { return /* binding */ FULL_FAVORITE_BASE64; },
/* harmony export */   "GATED_HASHES": function() { return /* binding */ GATED_HASHES; },
/* harmony export */   "GENERIC_ERROR_MESSAGE": function() { return /* binding */ GENERIC_ERROR_MESSAGE; },
/* harmony export */   "GET_GUEST_TOKEN_ENDPOINT": function() { return /* binding */ GET_GUEST_TOKEN_ENDPOINT; },
/* harmony export */   "GET_ORDER_DETAILS_ENDPOINT": function() { return /* binding */ GET_ORDER_DETAILS_ENDPOINT; },
/* harmony export */   "GET_PROFILE_ENDPOINT": function() { return /* binding */ GET_PROFILE_ENDPOINT; },
/* harmony export */   "GLOBAL_CONFIGURATION_ENDPOINT": function() { return /* binding */ GLOBAL_CONFIGURATION_ENDPOINT; },
/* harmony export */   "GLOBAL_CONFIGURATION_PATH": function() { return /* binding */ GLOBAL_CONFIGURATION_PATH; },
/* harmony export */   "HEADER_NAV_TABS_WRAPPER_ID": function() { return /* binding */ HEADER_NAV_TABS_WRAPPER_ID; },
/* harmony export */   "HELP_AND_FAQ": function() { return /* binding */ HELP_AND_FAQ; },
/* harmony export */   "HELP_AND_FAQ_SUPPORT": function() { return /* binding */ HELP_AND_FAQ_SUPPORT; },
/* harmony export */   "HELP_AND_SUPPORT": function() { return /* binding */ HELP_AND_SUPPORT; },
/* harmony export */   "HELP_FAQ_END_POINT": function() { return /* binding */ HELP_FAQ_END_POINT; },
/* harmony export */   "HELP_SUPPORT": function() { return /* binding */ HELP_SUPPORT; },
/* harmony export */   "HERO_BANNER": function() { return /* binding */ HERO_BANNER; },
/* harmony export */   "HOW_TO_BECOME_A_KPN": function() { return /* binding */ HOW_TO_BECOME_A_KPN; },
/* harmony export */   "INITIAL_SEARCH_TABS_COUNT": function() { return /* binding */ INITIAL_SEARCH_TABS_COUNT; },
/* harmony export */   "INSPIRATION_PAGE_NAME": function() { return /* binding */ INSPIRATION_PAGE_NAME; },
/* harmony export */   "INSTALLATION_SERVICES_ASPATH": function() { return /* binding */ INSTALLATION_SERVICES_ASPATH; },
/* harmony export */   "INSTALLATION_SERVICES_HASH": function() { return /* binding */ INSTALLATION_SERVICES_HASH; },
/* harmony export */   "INSTALLATION_SERVICES_PATH": function() { return /* binding */ INSTALLATION_SERVICES_PATH; },
/* harmony export */   "INSTALL_ITEMS": function() { return /* binding */ INSTALL_ITEMS; },
/* harmony export */   "INSTALL_ITEMS_EDIT": function() { return /* binding */ INSTALL_ITEMS_EDIT; },
/* harmony export */   "IN_REVIEW_ORDER_STATUS": function() { return /* binding */ IN_REVIEW_ORDER_STATUS; },
/* harmony export */   "IS": function() { return /* binding */ IS; },
/* harmony export */   "JOIN_NOW": function() { return /* binding */ JOIN_NOW; },
/* harmony export */   "KEYCODE": function() { return /* binding */ KEYCODE; },
/* harmony export */   "KEY_SPECIFIER_API_URL_ENDPOINT": function() { return /* binding */ KEY_SPECIFIER_API_URL_ENDPOINT; },
/* harmony export */   "KEY_SPECIFIER_QUERRY_SELECTOR_URL": function() { return /* binding */ KEY_SPECIFIER_QUERRY_SELECTOR_URL; },
/* harmony export */   "LITERATURE": function() { return /* binding */ LITERATURE; },
/* harmony export */   "LITERATURE_DATA_URL": function() { return /* binding */ LITERATURE_DATA_URL; },
/* harmony export */   "LOCALE_ENGLISH": function() { return /* binding */ LOCALE_ENGLISH; },
/* harmony export */   "LOCATIONSCONST": function() { return /* binding */ LOCATIONSCONST; },
/* harmony export */   "LOCATIONS_ASPATH": function() { return /* binding */ LOCATIONS_ASPATH; },
/* harmony export */   "LOCATIONS_PATH": function() { return /* binding */ LOCATIONS_PATH; },
/* harmony export */   "LOCATION_API_TRIGGER_INTERVAL": function() { return /* binding */ LOCATION_API_TRIGGER_INTERVAL; },
/* harmony export */   "LW_APP_NAME": function() { return /* binding */ LW_APP_NAME; },
/* harmony export */   "MATTERPORT_ARIA_LABEL": function() { return /* binding */ MATTERPORT_ARIA_LABEL; },
/* harmony export */   "MEMBERSHIP_API_URL_ENDPOINT": function() { return /* binding */ MEMBERSHIP_API_URL_ENDPOINT; },
/* harmony export */   "MEMBERSHIP_QUERRY_SELECTOR_URL": function() { return /* binding */ MEMBERSHIP_QUERRY_SELECTOR_URL; },
/* harmony export */   "MILLISECONDSADAY": function() { return /* binding */ MILLISECONDSADAY; },
/* harmony export */   "MINUTE_MILLISECONDS": function() { return /* binding */ MINUTE_MILLISECONDS; },
/* harmony export */   "MIN_DELAY": function() { return /* binding */ MIN_DELAY; },
/* harmony export */   "ML_API_MODEL_1": function() { return /* binding */ ML_API_MODEL_1; },
/* harmony export */   "ML_API_MODEL_2": function() { return /* binding */ ML_API_MODEL_2; },
/* harmony export */   "MODEL_JSON_EXTENSION": function() { return /* binding */ MODEL_JSON_EXTENSION; },
/* harmony export */   "MONTH_NAMES_EN": function() { return /* binding */ MONTH_NAMES_EN; },
/* harmony export */   "MONTH_NAMES_FR": function() { return /* binding */ MONTH_NAMES_FR; },
/* harmony export */   "MORE_OPTIONS": function() { return /* binding */ MORE_OPTIONS; },
/* harmony export */   "MY_ACCOUNT_MODAL": function() { return /* binding */ MY_ACCOUNT_MODAL; },
/* harmony export */   "MY_ACCOUNT_PATH": function() { return /* binding */ MY_ACCOUNT_PATH; },
/* harmony export */   "MY_FAVORITES_ENDPOINT": function() { return /* binding */ MY_FAVORITES_ENDPOINT; },
/* harmony export */   "MY_LISTS_PATH": function() { return /* binding */ MY_LISTS_PATH; },
/* harmony export */   "MY_LISTS_PATH_FR": function() { return /* binding */ MY_LISTS_PATH_FR; },
/* harmony export */   "MY_PRODUCTS_ENDPOINT": function() { return /* binding */ MY_PRODUCTS_ENDPOINT; },
/* harmony export */   "MY_PRODUCT_PRODUCT_REGISTRATION": function() { return /* binding */ MY_PRODUCT_PRODUCT_REGISTRATION; },
/* harmony export */   "MY_PRODUCT_SEARCH_CATALOG": function() { return /* binding */ MY_PRODUCT_SEARCH_CATALOG; },
/* harmony export */   "MY_SERVICES_ENDPOINT": function() { return /* binding */ MY_SERVICES_ENDPOINT; },
/* harmony export */   "MyFavoritesPageDataUrl": function() { return /* binding */ MyFavoritesPageDataUrl; },
/* harmony export */   "MyListsPageDataUrl": function() { return /* binding */ MyListsPageDataUrl; },
/* harmony export */   "MyProductsPageDataUrl": function() { return /* binding */ MyProductsPageDataUrl; },
/* harmony export */   "MyServicePageDataUrl": function() { return /* binding */ MyServicePageDataUrl; },
/* harmony export */   "NAVIGATION_TYPE": function() { return /* binding */ NAVIGATION_TYPE; },
/* harmony export */   "NODE_NAMES": function() { return /* binding */ NODE_NAMES; },
/* harmony export */   "NS": function() { return /* binding */ NS; },
/* harmony export */   "NUMERIC_REGX": function() { return /* binding */ NUMERIC_REGX; },
/* harmony export */   "ONETRUST_IDENTIFIER": function() { return /* binding */ ONETRUST_IDENTIFIER; },
/* harmony export */   "ORDER_CONFIRMATION": function() { return /* binding */ ORDER_CONFIRMATION; },
/* harmony export */   "ORDER_IN_RECEIVED_STATUS": function() { return /* binding */ ORDER_IN_RECEIVED_STATUS; },
/* harmony export */   "ORDER_STATUS_PAGE": function() { return /* binding */ ORDER_STATUS_PAGE; },
/* harmony export */   "ORDER_THANKYOU": function() { return /* binding */ ORDER_THANKYOU; },
/* harmony export */   "PAGE_TYPES": function() { return /* binding */ PAGE_TYPES; },
/* harmony export */   "PARTS": function() { return /* binding */ PARTS; },
/* harmony export */   "PAYPAL_TYPES": function() { return /* binding */ PAYPAL_TYPES; },
/* harmony export */   "PDP_DEFAULT_IMAGE": function() { return /* binding */ PDP_DEFAULT_IMAGE; },
/* harmony export */   "PDP_DETAILS": function() { return /* binding */ PDP_DETAILS; },
/* harmony export */   "PDP_END_POINT_SUBSCRIPTION_KEY": function() { return /* binding */ PDP_END_POINT_SUBSCRIPTION_KEY; },
/* harmony export */   "PDP_FAVORITE": function() { return /* binding */ PDP_FAVORITE; },
/* harmony export */   "PDP_FEEDBACK": function() { return /* binding */ PDP_FEEDBACK; },
/* harmony export */   "PDP_FIND_ON_DISPLAY": function() { return /* binding */ PDP_FIND_ON_DISPLAY; },
/* harmony export */   "PDP_GUEST_FAVORITE": function() { return /* binding */ PDP_GUEST_FAVORITE; },
/* harmony export */   "PDP_SLIDER_SIZES": function() { return /* binding */ PDP_SLIDER_SIZES; },
/* harmony export */   "PDP_TEASER_DETAILS": function() { return /* binding */ PDP_TEASER_DETAILS; },
/* harmony export */   "PDP_TYPE": function() { return /* binding */ PDP_TYPE; },
/* harmony export */   "PDP_TYPES": function() { return /* binding */ PDP_TYPES; },
/* harmony export */   "PERCENT_OFF": function() { return /* binding */ PERCENT_OFF; },
/* harmony export */   "PLP_END_POINT": function() { return /* binding */ PLP_END_POINT; },
/* harmony export */   "PLP_END_POINT_CLIENT": function() { return /* binding */ PLP_END_POINT_CLIENT; },
/* harmony export */   "PLP_END_POINT_SUBSCRIPTION_KEY": function() { return /* binding */ PLP_END_POINT_SUBSCRIPTION_KEY; },
/* harmony export */   "PLUMBING_SERVICE_PARTS": function() { return /* binding */ PLUMBING_SERVICE_PARTS; },
/* harmony export */   "PRESS_LANDING_URL": function() { return /* binding */ PRESS_LANDING_URL; },
/* harmony export */   "PRESS_ROOM_PATH": function() { return /* binding */ PRESS_ROOM_PATH; },
/* harmony export */   "PRICE_RANGE": function() { return /* binding */ PRICE_RANGE; },
/* harmony export */   "PRICE_RANGE_FRENCH_LOCALE": function() { return /* binding */ PRICE_RANGE_FRENCH_LOCALE; },
/* harmony export */   "PRIVACY_ASPATH": function() { return /* binding */ PRIVACY_ASPATH; },
/* harmony export */   "PRIVACY_COOKIE_CLICKED": function() { return /* binding */ PRIVACY_COOKIE_CLICKED; },
/* harmony export */   "PRODUCTS_PER_PAGE": function() { return /* binding */ PRODUCTS_PER_PAGE; },
/* harmony export */   "PRODUCT_DATA_URL": function() { return /* binding */ PRODUCT_DATA_URL; },
/* harmony export */   "PRODUCT_GLOBALCONFIG_DATA_URL": function() { return /* binding */ PRODUCT_GLOBALCONFIG_DATA_URL; },
/* harmony export */   "PROFILE_END_POINT_CLIENT": function() { return /* binding */ PROFILE_END_POINT_CLIENT; },
/* harmony export */   "PriceRangeFrench": function() { return /* binding */ PriceRangeFrench; },
/* harmony export */   "REGISTER_OFFLINE_PRODUCTS_DATA_URL": function() { return /* binding */ REGISTER_OFFLINE_PRODUCTS_DATA_URL; },
/* harmony export */   "REGISTER_ONLINE_PRODUCTS_DATA_URL": function() { return /* binding */ REGISTER_ONLINE_PRODUCTS_DATA_URL; },
/* harmony export */   "REGULAR_PRICE": function() { return /* binding */ REGULAR_PRICE; },
/* harmony export */   "REMEDY_MODEL_JSON": function() { return /* binding */ REMEDY_MODEL_JSON; },
/* harmony export */   "ROW_COLUMN_MIN_WIDTH": function() { return /* binding */ ROW_COLUMN_MIN_WIDTH; },
/* harmony export */   "SEARCH_INTERNAL_TYPE": function() { return /* binding */ SEARCH_INTERNAL_TYPE; },
/* harmony export */   "SEARCH_PDP_FL": function() { return /* binding */ SEARCH_PDP_FL; },
/* harmony export */   "SEARCH_PLP_ENDPOINT": function() { return /* binding */ SEARCH_PLP_ENDPOINT; },
/* harmony export */   "SEARCH_TABS": function() { return /* binding */ SEARCH_TABS; },
/* harmony export */   "SEAT_TYPES": function() { return /* binding */ SEAT_TYPES; },
/* harmony export */   "SHOP_THE_ROOM": function() { return /* binding */ SHOP_THE_ROOM; },
/* harmony export */   "SHOP_THE_ROOM_CLASSES": function() { return /* binding */ SHOP_THE_ROOM_CLASSES; },
/* harmony export */   "SHOP_TOILET_SEATS": function() { return /* binding */ SHOP_TOILET_SEATS; },
/* harmony export */   "SPLIT_ORDER": function() { return /* binding */ SPLIT_ORDER; },
/* harmony export */   "SSR_PLP_FL": function() { return /* binding */ SSR_PLP_FL; },
/* harmony export */   "STOCKS": function() { return /* binding */ STOCKS; },
/* harmony export */   "STORE_APPOINTMENT_ANCHOR_VALUE": function() { return /* binding */ STORE_APPOINTMENT_ANCHOR_VALUE; },
/* harmony export */   "STORE_APP_LD_JSON": function() { return /* binding */ STORE_APP_LD_JSON; },
/* harmony export */   "STORE_DETAILS_API_ENDPOINT": function() { return /* binding */ STORE_DETAILS_API_ENDPOINT; },
/* harmony export */   "STORE_MAX_DISTANCE": function() { return /* binding */ STORE_MAX_DISTANCE; },
/* harmony export */   "STORE_MIN_DISTANCE": function() { return /* binding */ STORE_MIN_DISTANCE; },
/* harmony export */   "SUCCESS": function() { return /* binding */ SUCCESS; },
/* harmony export */   "SUPPORT_CENTER_PATH": function() { return /* binding */ SUPPORT_CENTER_PATH; },
/* harmony export */   "SWATCH_NA": function() { return /* binding */ SWATCH_NA; },
/* harmony export */   "TABS_NOT_REQUIRED_GRIDICON": function() { return /* binding */ TABS_NOT_REQUIRED_GRIDICON; },
/* harmony export */   "TAB_WIDTH": function() { return /* binding */ TAB_WIDTH; },
/* harmony export */   "TARGETED_DOMAIN_TO_MONITOR": function() { return /* binding */ TARGETED_DOMAIN_TO_MONITOR; },
/* harmony export */   "TEASER_CAPTION_CLASSES": function() { return /* binding */ TEASER_CAPTION_CLASSES; },
/* harmony export */   "TEASER_CAPTION_CLASSES_LIST": function() { return /* binding */ TEASER_CAPTION_CLASSES_LIST; },
/* harmony export */   "TEASER_CLASSES": function() { return /* binding */ TEASER_CLASSES; },
/* harmony export */   "TECHNICAL_SPECIFICATIONS": function() { return /* binding */ TECHNICAL_SPECIFICATIONS; },
/* harmony export */   "TECHNICAL_SPECIFICATION_DATA_URL": function() { return /* binding */ TECHNICAL_SPECIFICATION_DATA_URL; },
/* harmony export */   "TECHNICAL_SPECIFICATION_PATH": function() { return /* binding */ TECHNICAL_SPECIFICATION_PATH; },
/* harmony export */   "TECHNICAL_SPECT_SEARCH_COUNT": function() { return /* binding */ TECHNICAL_SPECT_SEARCH_COUNT; },
/* harmony export */   "TIMEOUT_1500": function() { return /* binding */ TIMEOUT_1500; },
/* harmony export */   "TOAST_MESSAGE_DEFAULT_DURATION": function() { return /* binding */ TOAST_MESSAGE_DEFAULT_DURATION; },
/* harmony export */   "TWO_WAYS_TO_BE_A_KPN": function() { return /* binding */ TWO_WAYS_TO_BE_A_KPN; },
/* harmony export */   "TotalSecsForaDay": function() { return /* binding */ TotalSecsForaDay; },
/* harmony export */   "USER_LIST_DELETE_END_POINT": function() { return /* binding */ USER_LIST_DELETE_END_POINT; },
/* harmony export */   "USER_LIST_PRODUCT_DELETE_POINT": function() { return /* binding */ USER_LIST_PRODUCT_DELETE_POINT; },
/* harmony export */   "UTILITY_CONSTANTS": function() { return /* binding */ UTILITY_CONSTANTS; },
/* harmony export */   "VALID_GLOBA_CONFIG_PATHS": function() { return /* binding */ VALID_GLOBA_CONFIG_PATHS; },
/* harmony export */   "VANITY_REDIRECT_TYPE": function() { return /* binding */ VANITY_REDIRECT_TYPE; },
/* harmony export */   "VIDEO_EVENTS": function() { return /* binding */ VIDEO_EVENTS; },
/* harmony export */   "VISUALICON_ARIA_LABEL": function() { return /* binding */ VISUALICON_ARIA_LABEL; },
/* harmony export */   "ZIP_FILE_DOWNLOAD_ENDPOINT": function() { return /* binding */ ZIP_FILE_DOWNLOAD_ENDPOINT; },
/* harmony export */   "accountSettingsPageDataUrl": function() { return /* binding */ accountSettingsPageDataUrl; },
/* harmony export */   "addAddressEndPoint": function() { return /* binding */ addAddressEndPoint; },
/* harmony export */   "addFavoritesEndPoint": function() { return /* binding */ addFavoritesEndPoint; },
/* harmony export */   "addressSuggestionEndPoint": function() { return /* binding */ addressSuggestionEndPoint; },
/* harmony export */   "annSacksConstants": function() { return /* binding */ annSacksConstants; },
/* harmony export */   "apiBaseUrl": function() { return /* binding */ apiBaseUrl; },
/* harmony export */   "apimSubscriptionKey": function() { return /* binding */ apimSubscriptionKey; },
/* harmony export */   "authorBaseUrl": function() { return /* binding */ authorBaseUrl; },
/* harmony export */   "authorPreviewBaseUrl": function() { return /* binding */ authorPreviewBaseUrl; },
/* harmony export */   "authorPreviewPassword": function() { return /* binding */ authorPreviewPassword; },
/* harmony export */   "authorPreviewUserName": function() { return /* binding */ authorPreviewUserName; },
/* harmony export */   "baseUrl": function() { return /* binding */ baseUrl; },
/* harmony export */   "browseAllStoresURL": function() { return /* binding */ browseAllStoresURL; },
/* harmony export */   "cartDataUrl": function() { return /* binding */ cartDataUrl; },
/* harmony export */   "cartItemsEndPoint": function() { return /* binding */ cartItemsEndPoint; },
/* harmony export */   "cartPage": function() { return /* binding */ cartPage; },
/* harmony export */   "checkSplitOrderEndPoint": function() { return /* binding */ checkSplitOrderEndPoint; },
/* harmony export */   "checkoutDataUrl": function() { return /* binding */ checkoutDataUrl; },
/* harmony export */   "createCartEndPoint": function() { return /* binding */ createCartEndPoint; },
/* harmony export */   "createFavoritesEndPoint": function() { return /* binding */ createFavoritesEndPoint; },
/* harmony export */   "customActivityEvents": function() { return /* binding */ customActivityEvents; },
/* harmony export */   "dataUrl": function() { return /* binding */ dataUrl; },
/* harmony export */   "debounceThresholdCheckUserExists": function() { return /* binding */ debounceThresholdCheckUserExists; },
/* harmony export */   "deleteCartEndPoint": function() { return /* binding */ deleteCartEndPoint; },
/* harmony export */   "dimensionsDataEndPoint": function() { return /* binding */ dimensionsDataEndPoint; },
/* harmony export */   "discountEndPoint": function() { return /* binding */ discountEndPoint; },
/* harmony export */   "dynamicSearch": function() { return /* binding */ dynamicSearch; },
/* harmony export */   "editAddressEndPoint": function() { return /* binding */ editAddressEndPoint; },
/* harmony export */   "emailSubscribeEndPoint": function() { return /* binding */ emailSubscribeEndPoint; },
/* harmony export */   "favoritesEndPoint": function() { return /* binding */ favoritesEndPoint; },
/* harmony export */   "findAllStores": function() { return /* binding */ findAllStores; },
/* harmony export */   "footerUrl": function() { return /* binding */ footerUrl; },
/* harmony export */   "getCartEndPoint": function() { return /* binding */ getCartEndPoint; },
/* harmony export */   "getPdpTooltipEndPoint": function() { return /* binding */ getPdpTooltipEndPoint; },
/* harmony export */   "getStockEndPoint": function() { return /* binding */ getStockEndPoint; },
/* harmony export */   "groupedComponents": function() { return /* binding */ groupedComponents; },
/* harmony export */   "headerUrl": function() { return /* binding */ headerUrl; },
/* harmony export */   "imgPlaceholderData": function() { return /* binding */ imgPlaceholderData; },
/* harmony export */   "inPageSearchEndPoint": function() { return /* binding */ inPageSearchEndPoint; },
/* harmony export */   "isANYPersona": function() { return /* binding */ isANYPersona; },
/* harmony export */   "keyCodes": function() { return /* binding */ keyCodes; },
/* harmony export */   "locationIpEndPoint": function() { return /* binding */ locationIpEndPoint; },
/* harmony export */   "locationZipEndPoint": function() { return /* binding */ locationZipEndPoint; },
/* harmony export */   "loveYourLookDataUrl": function() { return /* binding */ loveYourLookDataUrl; },
/* harmony export */   "maxAppReached": function() { return /* binding */ maxAppReached; },
/* harmony export */   "mergeCartEndPoint": function() { return /* binding */ mergeCartEndPoint; },
/* harmony export */   "missingImage": function() { return /* binding */ missingImage; },
/* harmony export */   "myListContainerBreakPoints": function() { return /* binding */ myListContainerBreakPoints; },
/* harmony export */   "oktaTokenEndpoint": function() { return /* binding */ oktaTokenEndpoint; },
/* harmony export */   "orderConfirmationDataUrl": function() { return /* binding */ orderConfirmationDataUrl; },
/* harmony export */   "orderConstants": function() { return /* binding */ orderConstants; },
/* harmony export */   "orderDetailsPageDataUrl": function() { return /* binding */ orderDetailsPageDataUrl; },
/* harmony export */   "orderHistoryPageDataUrl": function() { return /* binding */ orderHistoryPageDataUrl; },
/* harmony export */   "orderStatusPageDataUrl": function() { return /* binding */ orderStatusPageDataUrl; },
/* harmony export */   "orderSubmitEndPoint": function() { return /* binding */ orderSubmitEndPoint; },
/* harmony export */   "pageNotFoundDataUrl": function() { return /* binding */ pageNotFoundDataUrl; },
/* harmony export */   "pageUrl": function() { return /* binding */ pageUrl; },
/* harmony export */   "payPalPaymentEndPoint": function() { return /* binding */ payPalPaymentEndPoint; },
/* harmony export */   "paymentEndPoint": function() { return /* binding */ paymentEndPoint; },
/* harmony export */   "postOrderNoOfDays": function() { return /* binding */ postOrderNoOfDays; },
/* harmony export */   "previewContentPrefix": function() { return /* binding */ previewContentPrefix; },
/* harmony export */   "publicWebsiteUrl": function() { return /* binding */ publicWebsiteUrl; },
/* harmony export */   "publisherBaseUrl": function() { return /* binding */ publisherBaseUrl; },
/* harmony export */   "queryParamsToPersist": function() { return /* binding */ queryParamsToPersist; },
/* harmony export */   "removeFavoritesEndPoint": function() { return /* binding */ removeFavoritesEndPoint; },
/* harmony export */   "resourceFacetLabels": function() { return /* binding */ resourceFacetLabels; },
/* harmony export */   "searchDataUrl": function() { return /* binding */ searchDataUrl; },
/* harmony export */   "searchPdpEndPoint": function() { return /* binding */ searchPdpEndPoint; },
/* harmony export */   "searchPlpEndPoint": function() { return /* binding */ searchPlpEndPoint; },
/* harmony export */   "searchProfilePlpEndPoint": function() { return /* binding */ searchProfilePlpEndPoint; },
/* harmony export */   "selectors": function() { return /* binding */ selectors; },
/* harmony export */   "shareCartEndPoint": function() { return /* binding */ shareCartEndPoint; },
/* harmony export */   "sharedCartItemsEndPoint": function() { return /* binding */ sharedCartItemsEndPoint; },
/* harmony export */   "sharedCartUrl": function() { return /* binding */ sharedCartUrl; },
/* harmony export */   "shipmentFromCartEndPoint": function() { return /* binding */ shipmentFromCartEndPoint; },
/* harmony export */   "shippingCostEndPoint": function() { return /* binding */ shippingCostEndPoint; },
/* harmony export */   "signupEndPoint": function() { return /* binding */ signupEndPoint; },
/* harmony export */   "skuBypimLookup": function() { return /* binding */ skuBypimLookup; },
/* harmony export */   "staticClasses": function() { return /* binding */ staticClasses; },
/* harmony export */   "stopedByPreviousDiscount": function() { return /* binding */ stopedByPreviousDiscount; },
/* harmony export */   "taxEndPoint": function() { return /* binding */ taxEndPoint; },
/* harmony export */   "tooltip": function() { return /* binding */ tooltip; },
/* harmony export */   "validateTokenEndPoint": function() { return /* binding */ validateTokenEndPoint; }
/* harmony export */ });
/* provided dependency */ var process = __webpack_require__(83454);
const authorBaseUrl = "https://web-api.kohler.com/aem/resource?subscription-key=3da4541f545f4dc7841b6ba0606f96fc&resourcepath=";
const authorPreviewBaseUrl = "https://author-p98453-e956757.adobeaemcloud.com";
const authorPreviewUserName = "decouple-content-api-user";
const authorPreviewPassword = "Kz62dRsVfVX5un@";
const previewContentPrefix = "/content/kohler/us";
const publisherBaseUrl = "http://localhost:4503";
const baseUrl = "/en";
const publicWebsiteUrl = "https://www.kohler.com/en";
const isANYPersona = process.env.NEXT_PUBLIC_ENABLE_ANY_PERSONA === "true" ? true : false;
const dataUrl = "/en.model.json";
const searchDataUrl = "/search.model.json";
const cartDataUrl = "/en/cart.model.json";
const headerUrl = "/content/experience-fragments/kohler/us/en/navigation/header/global-header-experience-fragment/master";
const footerUrl = "/content/experience-fragments/kohler/us/en/navigation/footer/Global-footer-experience-fragment/master";
const pageUrl = "/en/";
const cartPage = pageUrl + "cart";
const checkoutDataUrl = "/en/checkout.model.json";
const sharedCartUrl = "/en/cart/shared-cart.model.json";
const orderConfirmationDataUrl = "/en/orders/order-confirmation.model.json";
const orderDetailsPageDataUrl = "/en/orders/order-details.model.json";
const orderHistoryPageDataUrl = "/en/orders/order-history.model.json";
const orderStatusPageDataUrl = "/en/orders/order-status.model.json";
const PRODUCT_DATA_URL = "/products/product-details.model.json";
const PRODUCT_GLOBALCONFIG_DATA_URL = ".globalconfig.json";
const MyProductsPageDataUrl = "/my-account/my-products.model.json";
const loveYourLookDataUrl = "/en/love-your-look.model.json";
const pageNotFoundDataUrl = "/en/error-handler-pages/404.model.json";
const apiBaseUrl = "https://web-api.kohler.com";
const oktaTokenEndpoint = "/oauth/token";
const getCartEndPoint = "/cart/active?expand=calculation";
const createCartEndPoint = "/cart/create";
const getStockEndPoint = "/catalog/inventory";
const cartItemsEndPoint = "/cart/v2/items";
const sharedCartItemsEndPoint = "/cart/items";
const shippingCostEndPoint = "/checkout/shipping-cost";
const discountEndPoint = "cart/v2/discount?expand=calculation";
const taxEndPoint = "/cart/v2/items?expand=calculation";
const shareCartEndPoint = "/cart/sharedcart";
const mergeCartEndPoint = "/cart/merge?expand=calculation";
const signupEndPoint = "/customer/signup";
const deleteCartEndPoint = "/cart/v2/deleteActiveCart";
const shipmentFromCartEndPoint = "/checkout/v2/assign/shipmentfromcart";
const addAddressEndPoint = "/customer/address";
const addressSuggestionEndPoint = "/maps/address/validate";
const validateTokenEndPoint = "/oauth/token/validate";
const orderSubmitEndPoint = "/checkout/v2/order/submit";
const paymentEndPoint = "/checkout/payment";
const payPalPaymentEndPoint = "/payment/paypal/getToken";
const searchPlpEndPoint = "/search/plp";
const inPageSearchEndPoint = "/search/plp";
const searchProfilePlpEndPoint = "/search/profile";
const checkSplitOrderEndPoint = "/checkout/order-split-check";
const searchPdpEndPoint = "/search/pdp";
const getPdpTooltipEndPoint = "/search/tooltip";
const accountSettingsPageDataUrl = "/my-account/account-settings.model.json";
const MY_PRODUCTS_ENDPOINT = "/shopping-list/MyProducts";
const FETCH_PRODUCT_REG_ENDPOINT = "/crm/fetchproductregistration";
const staticClasses = {
    CONTAINER: "container responsivegrid"
};
const MyServicePageDataUrl = "/my-account/my-services.model.json";
const MyFavoritesPageDataUrl = "/my-account/my-favorites.model.json";
const MyListsPageDataUrl = "/my-account/my-lists.model.json";
const REGISTER_OFFLINE_PRODUCTS_DATA_URL = "/my-account/product-registration/register-offline-product.model.json";
const REGISTER_ONLINE_PRODUCTS_DATA_URL = "/en/my-account/product-registration/register-online-product.model.json";
const FAQ_PAGE_DATA_URL = "/support/help-and-faq";
const browseAllStoresURL = "/en/locations/browse-all-stores.model.json";
const LITERATURE_DATA_URL = "/en/for-professionals/literature.model.json";
const TECHNICAL_SPECIFICATION_DATA_URL = "/en/for-professionals/technical-specifications.model.json";
const PRESS_LANDING_URL = "/en/press-room.model.json";
const FIND_STORE_URL = "en/locations.model.json";
const ARTICLE_CONTENT_END_POINT = "/jcr:content.json";
const ARTICLE_IMG_END_POINT = "/jcr:content/image.json";
const FAVORITES_LIST_END_POINT = "/shopping-list/FavoriteLists";
const USER_LIST_DELETE_END_POINT = "/shopping-list";
const USER_LIST_PRODUCT_DELETE_POINT = "/shopping-list/remove/items";
const FAVORITES_LIST_LIMIT = 499;
const MODEL_JSON_EXTENSION = ".model.json";
const dynamicSearch = "dynamic search";
const dimensionsDataEndPoint = "/search/plp";
const findAllStores = "/maps/store";
const LOOKUP_URL =  true ? "scout" : 0;
const skuBypimLookup = "/".concat(LOOKUP_URL, "/lookup");
const HELP_AND_FAQ_SUPPORT = "/en/support/help-and-faq";
const missingImage = "MissingImage";
const CONSTANTS = {
    DEFAULT_IDLE_TIMEOUT: 172800,
    DEFAULT_VERSION: "v1",
    ERROR_CODES: {
        BAD_REQUEST_ERROR: 400,
        INTERNAL_SERVER_ERROR: 500,
        AUTHENTICATION_ERROR: [
            401,
            403
        ]
    },
    USER_STATE: {
        LOGGED_USER: "logged",
        ANONYMOUS_USER: "anonymous"
    },
    PARENT_COMPONENTS_LIST: {
        ORDER_DETAILS: "OrderDetails"
    },
    PAYMENT: {
        SUCCESS_CODE: "870",
        NUM_YEARS: 16
    },
    ORDER_STATUS_SHIPPED: "Shipped",
    DELETE_INACTIVE_MYFOLDER_AFTER: 30,
    ERROR_MESSAGE: {
        GENERAL: "Something went wrong. Please try again...",
        SESSION_TIMEOUT_MSG: "Your session is expired.. Please login again...",
        SESSION_TIMEOUT_SECURE_PAGE_MSG: "Redirecting to Home Page due to inactivity"
    },
    COLOR_FILE_URL: "https://kohler.scene7.com/is/image/PAWEB/",
    CT_API_URL: "https://api.us-central1.gcp.commercetools.com",
    CT_PROJECT_KEY: "kohler-na-qa-1",
    CT_SALES_CHANNEL: "KOUS",
    REGEX_TEXT: /^[a-z\d\-,'"\s]+$/,
    REGEX_ALPHANUMERIC_SAFE_CHARS: /^[a-z\d\-,'"\s]+$/i,
    REGEX_PASSWORD: new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{11,})"),
    REGEX_EMAIL: /^((?!\.)(?!\-)(?!\_)[a-z0-9]*([\.\-\_]?[a-z0-9\-]*)?[^\-`_.#()+/=!@$%^&*:'"<>])(@(?!\.)(?!\-)(?!\_)[\w-]+)(\.\w+(\.\w+)?[^.\W])$/i,
    KEYCODE: {
        ENTER: 13,
        ESC: 27,
        SPACE: 32,
        UP: 38,
        DOWN: 40,
        TAB: 9
    },
    KEY: {
        ENTER: "Enter",
        ESC: "Escape"
    },
    FF_PERSONA: "US_Kcom_FriendsNFamily:FF",
    KEMP_PERSONA: "US_Kcom_KohlerCoAssociate:KEMP",
    KF_FORCE_RENEW_TOKEN: "kf-okta-force-renew-token",
    KF_UPDATE_MEMBERSHIP: "kf-update-membership",
    CREATE_ACCOUNT_TYPE: {
        HOME_OWNER: "homeowner",
        PROFESSIONAL: "professional"
    },
    UNDEFINED: "undefined",
    COMPONENT: {
        PAIRS_WELL_WITH: "pairsWellWith"
    },
    SLICK: {
        DEFAULT_DELAY: 5000,
        COUNT_OFFSET: 22,
        ARROW_OFFSET: 52
    },
    CURRENCY_SIGN: "$",
    STATUS: {
        OK: 200,
        PAGE_NOT_FOUND: 404,
        INTERNAL_SERVER_ERROR: 500
    },
    REGEX_CONTAINS_LETTER: /[a-z]/i
};
const annSacksConstants = {
    asBrandName: "annsacks",
    asBrandNameWithCase: "AnnSacks",
    asSourceChannel: "asus"
};
const favoritesEndPoint = "/shopping-list/Favorites";
const createFavoritesEndPoint = "/shopping-list/create";
const addFavoritesEndPoint = (id, type)=>{
    return "/shopping-list/add/".concat(id, "?type=").concat(type);
};
const removeFavoritesEndPoint = (id)=>{
    return "/shopping-list/remove/items/".concat(id);
};
const SWATCH_NA = "swatch_NA";
const ADD_10_MINUTES = 600000;
const MINUTE_MILLISECONDS = 60000;
const PRIVACY_COOKIE_CLICKED = "is_privacy_cookie_clicked";
const GLOBAL_CONFIGURATION_PATH = "/bin/kohler/services/globalconfig.kohler.json";
const DOMAIN = "https://www.kohler.com";
const GLOBAL_CONFIGURATION_ENDPOINT = DOMAIN + "/api/globalconfig";
const locationIpEndPoint = "/maps/location/ip/";
const locationZipEndPoint = "/maps/location/zipcode/";
const STORE_MIN_DISTANCE = 64;
const STORE_MAX_DISTANCE = 1000;
const TIMEOUT_1500 = 1500;
const LOCATION_API_TRIGGER_INTERVAL = 1800000 // 30mins
;
const STORE_DETAILS_API_ENDPOINT = DOMAIN + "/api/storedetails";
const DEFAULT_STORE_DETAILS_API_PATH = "/bin/kohler/services/storedetails?path=";
const GET_PROFILE_ENDPOINT = "/customer/me";
const ZIP_FILE_DOWNLOAD_ENDPOINT = "/catalog/zip-file-download";
const SEARCH_PLP_ENDPOINT = "search/plp";
const MY_ACCOUNT_PATH = "/my-account";
// cart Dicount
const stopedByPreviousDiscount = "ApplicationStoppedByPreviousDiscount";
const maxAppReached = "MaxApplicationReached";
const emailSubscribeEndPoint = "/crm/newsletter/subscription";
const TOAST_MESSAGE_DEFAULT_DURATION = 5000 // 5seconds
;
const editAddressEndPoint = "customer/address";
const FIND_MY_ORDERS_V1_ENDPOINT = "/checkout/orders/v1/query";
const FIND_MY_ORDERS_ENDPOINT = "/checkout/orders/query";
const SPLIT_ORDER = "checkout/ordersplit";
const GET_GUEST_TOKEN_ENDPOINT = DOMAIN + "/api/token";
// Membership
const KEY_SPECIFIER_QUERRY_SELECTOR_URL = 'a[href="#KeySpecifier"]';
const KEY_SPECIFIER_API_URL_ENDPOINT = "/membership/assign/persona";
const MEMBERSHIP_API_URL_ENDPOINT = "/membership/kohler-associate/entry";
const MEMBERSHIP_QUERRY_SELECTOR_URL = 'a[href="#AssociateMembership"]';
const FRIENDS_AND_FAMILY_QUERRY_SELECTOR_URL = 'a[href="#FriendsAndFamily"]';
const FRIENDS_AND_FAMILY_API_URL_ENDPOINT = "/membership/assign/persona";
// Store Appointment
const STORE_APPOINTMENT_ANCHOR_VALUE = "#StoreAppointment";
const MORE_OPTIONS = {
    LEARN_MORE: "Learn More",
    EXPLORE_MORE: "Explore More",
    FREE_QUOTE: "Get a FREE Quote",
    FIND_PRO: "Find a Pro",
    INSTALLATION_SERVICES: "Buy Now"
};
const DISABLE_SROLL_PATH = [
    "home-energy/home-generators",
    "buying-guides/bath-tub-buying-guide",
    "services/installation-services"
];
const DEFAULT_SCROLL = {
    scroll: 60,
    backToTop: 20,
    freeQuote: 120,
    findAPro: 120,
    installationServices: 120
};
// order confirmation
const orderConstants = {
    COMPLETED: "Completed",
    CANCELLED: "Cancelled",
    CREDIT_CARD: "CREDIT_CARD",
    PAYPAL: "PP",
    ACI_PAYPAL: "Paypal",
    SHIPPED: "Shipped"
};
const PAYPAL_TYPES = [
    "PP",
    "Paypal",
    "PAYPAL",
    "PayPal",
    "paypal"
];
const CARD_TYPES = [
    "CREDIT_CARD",
    "credit_card",
    "CARD",
    "card"
];
const GET_ORDER_DETAILS_ENDPOINT = "checkout/orders";
const DEFAULT_CARD_DETAILS_API_PATH = "/bin/kohler/services/list?path=/content/kohler";
const MY_SERVICES_ENDPOINT = "/shopping-list/MyServices?lang=" + "en-US";
const MY_FAVORITES_ENDPOINT = "/shopping-list/Favorites";
const COMPONENT_TYPES = {
    AEMFORM: "aemform",
    PRODUCTCARD: "productcard",
    ROOT_CONTAINER: "root",
    CONTAINER: "container",
    VIDEO: "video",
    AUTH_MODAL: "authmodal",
    NEWSLETTER: "newsletter",
    TEASER: "teaser",
    CAROUSEL: "carousel",
    SLICK: "carousel-slick",
    SPACER: "spacer",
    TEXT: "text",
    TAB: "tab",
    BREADCRUMB: "breadcrumb",
    PRODUCTLIST: "productlist",
    SEARCH: "search/v1/search",
    EMBED: "embed",
    BRAND_SWITCHER: "brand-switcher",
    UTILITY_NAV_HEADER: "utilitynavheader",
    UTILITY_WIDGET: "utilitywidget",
    TABS: "tabs",
    IMAGE: "image",
    SITEWIDE_WARNING: "sitewide-warning",
    IMAGEV3: "image/v3/image",
    CAROUSELSLICK: "carousel-slick",
    TOASTER: "toaster/v1/toaster",
    COMPARE_PRODUCTS: "compareproducts",
    MAIN_FOOTER: "mainfooter",
    ADDITIONAL_FOOTER: "additionalfooter",
    NEWSLETTER_SIGNIN: "newslettersignin",
    NEWSLETTER_SIGNUP: "newslettersignup",
    CART_LANDING: "cart-landing",
    CHECKOUT: "checkout",
    ORDER_CONFIRMATION: "orderconfirmation",
    ORDER_STATUS: "orderstatus",
    ORDER_HISTORY: "orderhistory",
    ORDER_DETAILS: "orderdetails",
    SHARED_CART: "sharedcart",
    PAIRS_WELL_WITH: "pairs-well-with",
    HELPSUPPORT: "help-support",
    GLOBAL_NAVIGATION: "globalnavigation",
    PROMOBANNER: "plp-promo-banner",
    ACCOUNT_SETTINGS: "accountsettings",
    MY_SERVICES: "myservices",
    MY_FAVORITES: "myfavorites",
    CHANGE_PASSWORD: "changepassword",
    MY_PRODUCTS: "myproducts",
    PRODUCT_DETAILS: "pdp/v1/pdp",
    PRODUCT_DETAILS_ACCORDION: "accordion",
    PRODUCT_DETAILS_EXFPDP: "exfpdp/v1/exfpdp",
    PRODUCT_DETAILS_REVIEW: "components/review",
    REGISTER_OFFLINE_PRODUCTS: "register-offline-products",
    REGISTER_ONLINE_PRODUCTS: "register-online-products",
    KNOWLEDGE_ARTICLE: "knowledge-article/v1/knowledge-article",
    BROWSE_ALL_STORES: "browseallstores",
    STORE_FILTER: "storefilter",
    LITERATURE: "literature",
    CONTACT_US: "contactus",
    FINDING_MODEL_NUMBER: "finding-model-number",
    TECHNICAL_SPECIFICATION: "technicalspecs",
    PRESS_LANDING: "press-release-landing",
    UPSELL_CONTAINER: "container-up-sell",
    FIND_STORE: "findstore",
    INPAGE_SEARCH: "in-page-search",
    TITLE: "title",
    KEY_SPECIFIER: "key-specifier",
    DYNAMIC_SEARCH: "dynamicsearch",
    ASSOCIATE_MEMBERSHIP: "associate-membership",
    INSPIRE_VIDEO: "inspire-video",
    IMAGE_CLUSTER: "imagecluster",
    SHOP_THE_ROOM_CARD: "shoptheroomcard",
    INSTALL_DESIGN_SERVICES: "v1/installdesignservices",
    PROFESSIONAL_DETAILS: "professional-detail",
    FRIENDS_AND_FAMILY: "friends-family",
    FIND_A_PRO_BY_ZIP: "find-pro-by-zip",
    FIND_A_PRO_RESULTS: "find-a-pro-results",
    LIST: "list",
    STORE_APPOINTMENT: "store-appointment",
    PRODUCTCARD_V3: "productcard-v3",
    SHOP_THE_ROOM_DETAIL: "shoptheroomdetail",
    ROOM_DETAIL: "roomdetail",
    GATED_CONTENT: "gated-content-paths",
    PRODUCT_CARD_V4: "productcard-v4",
    PDP_CURATED_PRODUCTS: "pdp-curated-product",
    SHOP_THE_ROOM_PAGE: "shoptheroomlist",
    NAVIGATION_V3: "v3/globalnavigation",
    Lead_Generation: "leadgenform",
    VISUAL_NAV_FILTER: "visual_nav_filter",
    VISUAL_NAV_APPLIEDCLASS: "visual-nav",
    PRODUCT_SLIDER: "productslider"
};
const FRAGMENT_TYPES = {
    HEADER: "header",
    MAIN: "main",
    FOOTER: "footer"
};
const VIDEO_EVENTS = {
    PLAY: "play",
    PAUSE: "pause",
    ENDED: "ended",
    VIDEO_PLAY: "video play",
    VIDEO_PAUSE: "video pause",
    VIDEO_VIEWED: "video viewed",
    VIDEO_COMPLETE: "video complete",
    VIDEO_CLICK: "videoClick",
    PLAY_VIDEO: "videoPlay",
    PAUSE_VIDEO: "videoPause",
    CLOSE_VIDEO: "videoClose",
    CLOSE: "close"
};
const HERO_BANNER = "hero banner";
const TAB_WIDTH = 768;
const DESKTOP_WIDTH = 1280;
const ROW_COLUMN_MIN_WIDTH = 1025;
// PLP
// sort constants
const KEYCODE = {
    ENTER: 13,
    ESC: 27,
    SPACE: 32,
    UP: 38,
    DOWN: 40,
    TAB: 9
};
// Find a store
const FINDLOCATIONKEYCODE = {
    LEFTARROW: 37,
    RIGHTARROW: 39
};
const LOCATIONSCONST = {
    LocationType: "KOHLER Store",
    paramSpatialFilter: 161,
    status: 200
};
const MILLISECONDSADAY = 86400000;
// press room
const PRESS_ROOM_PATH = "/en/press-room";
// Filter
const queryParamsToPersist = [
    "sort",
    "keyword",
    "tab"
];
const DEFAULT_NEWELETTER_POPUP_TRIGGER_TIME = 9;
const PLP_END_POINT = "/apirequest/search/v1/plp";
const PLP_END_POINT_CLIENT = "/search/v1/plp";
const PLP_END_POINT_SUBSCRIPTION_KEY = "/lw/plp";
const PDP_END_POINT_SUBSCRIPTION_KEY = "/lw/v1/pdp/product";
const BUNDLE_PDP_END_POINT_SUBSCRIPTION_KEY = "/lw/pdp/";
const apimSubscriptionKey = process.env.APIM_SUBSCRIPTION_KEY;
const HELP_FAQ_END_POINT = "/search/plp";
const DEFAULT_PRODUCT_COUNT_PLP = 30;
const DEFAULT_TECHNICAL_SPECT_COUNT = 30;
const TECHNICAL_SPECT_SEARCH_COUNT = 5;
const PROFILE_END_POINT_CLIENT = "/search/v1/profile";
const debounceThresholdCheckUserExists = 500;
const customActivityEvents = [
    "click",
    "keydown"
];
const PAGE_TYPES = {
    CATEGORY_LANDING_PAGE: "category landing page",
    SHARE_CART_LANDING_PAGE: "share cart landing page",
    LOCATION_LANDING_PAGE: "landing:location info"
};
const PRODUCTS_PER_PAGE = [
    30,
    60,
    90
];
const imgPlaceholderData = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
// Account Settings constants
const EDIT_PROFILE_ENDPOINT = "/customer/profile";
const DELETE_ACCOUNT_ENDPOINT = "/customer/account";
const CHANGE_ACCOUNT_PASSWORD_ENDPOINT = "/customer/change_password";
const EMPTY_PIXEL = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
const FULL_FAVORITE_BASE64 = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjNweCIgaGVpZ2h0PSIyMHB4IiB2aWV3Qm94PSIwIDAgMjMgMjAiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+RmF2b3JpdGVzIEJsYWNrIGZpbGxlZCBJY29uPC90aXRsZT4KICAgIDxnIGlkPSJQYWdlLTEiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSJGYXZvcml0ZXMtQmxhY2stZmlsbGVkLUljb24iIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAuNDk5OTcyLCAwLjUwMDAwMCkiIGZpbGw9IiM0OTQ5NDkiIGZpbGwtcnVsZT0ibm9uemVybyI+CiAgICAgICAgICAgIDxwYXRoIGQ9Ik0xLjY5NDYxMTg5LDEuNjk1NTU5NDQgQy0wLjUwMTg5NzgzLDMuODk3MDQ5NDMgLTAuNTcwMjc5NjkxLDcuNDU1ODUwMTEgMS41MzEyODgxMyw5LjcwOTk2MzkgTDEuNjg4MjMwMDEsOS44NzMxOTUyIEwxMS4wMDE3MDE4LDE5LjIwNzkwMTYgTDIwLjI4Mzc4NTQsOS45MDUxNTEyIEwyMC40NDExNTc3LDkuNzQyNTQ2OCBDMjIuNTY5NTIwNiw3LjQ2MDMwODEzIDIyLjUwOTU1NjcsMy45MDEzNjA3OSAyMC4zMDg3NDU0LDEuNjk1NTU5NDQgTDIwLjEyMjgzOTUsMS41MTcyMDk4NyBDMTcuODU2NDMxMywtMC41NjM1MzUwOTUgMTQuMzM0NTc5MiwtMC41MDQwODUyMzkgMTIuMTM5OTEwNiwxLjY5NTU1OTQ0IEwxMS4wMDEwMjgsMi44MzYgTDkuODYzNDQ2NjMsMS42OTU1NTk0NCBDNy42Njg3NzgwNCwtMC41MDQwODUyMzkgNC4xNDY5MjYwMiwtMC41NjM1MzUwOTUgMS44ODA1MTc3NywxLjUxNzIwOTg3IEwxLjY5NDYxMTg5LDEuNjk1NTU5NDQgWiIgaWQ9IkZhdm9yaXRlcy1JY29uIj48L3BhdGg+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4=";
const EMPTY_FAVORITE_BASE64 = "data:image/svg+xml;base64,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";
const TABS_NOT_REQUIRED_GRIDICON = [
    "inspiration",
    "technical",
    "resources",
    "help"
];
// myProducts endPoints
const MY_PRODUCT_SEARCH_CATALOG = "/search/full-catalog";
const MY_PRODUCT_PRODUCT_REGISTRATION = "/crm/product/registration";
const PDP_TEASER_DETAILS = DOMAIN + "/api/pdpTeaserDetails";
const PLUMBING_SERVICE_PARTS = "PlumbingServiceParts";
const PARTS = "parts";
// contact us endpoints
const CONTACT_US_VALIDATE_RECAPTCHA_ENDPOINT = "/crm/webtocase";
const API_SUCCESS_STATUS = "succeeded";
const API_FAILURE_STATUS = "failed";
const PDP_DEFAULT_IMAGE = process.env.PDP_DEFAULT_IMAGE;
const EMBED_TYPE_SCRIPT = "SCRIPT";
const EMBED_TYPE_HTML = "HTML";
const VISUALICON_ARIA_LABEL = "View at 360 degree mode";
const MATTERPORT_ARIA_LABEL = "virtual tour popup";
// tab component constants
const NS = "cmp";
const IS = "tabs";
const keyCodes = {
    END: 35,
    HOME: 36,
    ARROW_LEFT: 37,
    ARROW_UP: 38,
    ARROW_RIGHT: 39,
    ARROW_DOWN: 40
};
const selectors = {
    self: "[data-" + NS + '-is="' + IS + '"]',
    active: {
        tab: "cmp-tabs__tab--active",
        tabpanel: "cmp-tabs__tabpanel--active"
    }
};
// privacy-policy constants
const PRIVACY_ASPATH = "privacy-policy";
// press room constants
const DOWNLOAD_SPINNER = "download-spinner";
const postOrderNoOfDays = 45;
const TotalSecsForaDay = 86400000;
// teasercaption-repositioning constants
const TEASER_CAPTION_CLASSES = ".teaser.img-right-caption-left, .history-module-vertical-image.image-right, .history-module-with-SQR-img.image-left, .img-caption-style-left.img-right-with-number__intend, .img-caption-style-left.img-right-with-number";
// Add conditional wrapper in AEMGRID component for the provided grouped elements.
const groupedComponents = [
    COMPONENT_TYPES === null || COMPONENT_TYPES === void 0 ? void 0 : COMPONENT_TYPES.BREADCRUMB,
    COMPONENT_TYPES === null || COMPONENT_TYPES === void 0 ? void 0 : COMPONENT_TYPES.CAROUSEL
];
const SUCCESS = "success";
// Product support center constants
const SUPPORT_CENTER_PATH = "/en/support/product-support-center";
// my lists constant
const MY_LISTS_PATH = "/en/my-account/my-lists";
// help-and-faq constants
const HELP_AND_FAQ = "help-and-faq";
const resourceFacetLabels = [
    "ResourceNvznId_s",
    "ResourceVntanaProductId_s",
    "ResourceVntanaProductIdList_ss",
    "ResourceNvznIdList_ss",
    "ProductIsExclusive_s"
];
// find a pro constants
const FIND_A_PRO_PATH = "/en/services/find-a-pro";
const FIND_A_PRO_HASH = "#findapro";
// shop the room details page
const SHOP_THE_ROOM = "shop-the-room";
// Installation services constants
const INSTALLATION_SERVICES_HASH = "#InstallService";
const INSTALLATION_SERVICES_PATH = "/en/services/installation-services";
const INSTALLATION_SERVICES_ASPATH = "installation-services";
const BUYING_GUIDE_ASPATH = "buying-guides";
// cart and checkout constants
const CART_URL = "/en/cart";
const CHECKOUT_URL = "/en/checkout";
const COUNTRY = {
    US: "US"
};
// Technical Specifications constants
const TECHNICAL_SPECIFICATION_PATH = "/en/for-professionals/technical-specifications";
// Browse all stores constants
const BROWSE_ALL_STORES = "browse-all-stores";
const BROWSE_ALL_STORES_URL = "/locations/browse-all-stores";
const MY_LISTS_PATH_FR = "/fr/my-account/my-lists";
// Locations constants
const LOCATIONS_PATH = "/en/locations";
const LOCATIONS_ASPATH = "/locations";
// bazaar voice constants
const BAZAAR_VOICE = "bazaarvoice";
// Redirect constants
const VANITY_REDIRECT_TYPE = "Vanity";
// teasercaption-repositioning constants
const TEASER_CAPTION_CLASSES_LIST = [
    "img-right-caption-left",
    "img-right-caption-left mobile-cta-double",
    "mobile-cta-double img-right-caption-left",
    "img-right-caption-left mobile-cta-single",
    "history-module-vertical-image image-right",
    "history-module-with-SQR-img image-left",
    "img-caption-style-left img-right-with-number__intend",
    "img-caption-style-left img-right-with-number"
];
const GATED_HASHES = [
    "#login",
    "#signup",
    "#createaccount",
    "#signin"
];
const FRAUD_CHLLENGE_STATUS = [
    "CHALLENGE",
    "ERROR",
    "DENY"
];
const IN_REVIEW_ORDER_STATUS = [
    "PA_PENDING",
    "ERROR_STATE",
    "FRAUD_HOLD",
    "FRAUD_CANCELLED"
];
const ORDER_IN_RECEIVED_STATUS = [
    "RECEIVED",
    "CREATED"
];
const myListContainerBreakPoints = {
    default: 3,
    1920: 3,
    1440: 3,
    1024: 2,
    812: 2,
    375: 1
};
const MONTH_NAMES_EN = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
];
const MONTH_NAMES_FR = [
    "Janvier",
    "F\xe9vrier",
    "Mars",
    "Avril",
    "Mai",
    "Juin",
    "Juillet",
    "Ao\xfbt",
    "Septembre",
    "Octobre",
    "Novembre",
    "D\xe9cembre"
];
const NODE_NAMES = {
    BUTTON: "BUTTON",
    IMG: "IMG"
};
const ONETRUST_IDENTIFIER = "cookielaw";
const BV_SCRIPT_URL = "https://apps.bazaarvoice.com/deployments/kohler/2021redesign/production/en_US/bv.js";
const LW_APP_NAME = process.env.NEXT_PUBLIC_LW_APP_NAME;
const SEARCH_TABS = {
    PRODUCTS: "Products",
    PARTS: "Parts",
    INSPIRATION: "Inspiration",
    TECHNICAL: "Technical",
    RESOURCES: "Resources",
    HELP: "Help"
};
const INITIAL_SEARCH_TABS_COUNT = {
    [SEARCH_TABS.PRODUCTS]: 0,
    [SEARCH_TABS.PARTS]: 0,
    [SEARCH_TABS.INSPIRATION]: 0,
    [SEARCH_TABS.TECHNICAL]: 0,
    [SEARCH_TABS.RESOURCES]: 0,
    [SEARCH_TABS.HELP]: 0
};

const SEAT_TYPES = [
    "Toilet Seats",
    "Bidet Seats"
];
const EXCLUDE_PAGES = [
    "/checkout"
];
const UTILITY_CONSTANTS = {
    FAVOURITES: "favourite",
    SHARE: "share",
    PRINT: "print",
    DOWNLOAD: "download"
};
const TEASER_CLASSES = [
    "hero-banner-full-bleed-image",
    "hero-video-3-4"
];
const SHOP_THE_ROOM_CLASSES = [
    "shop-the-room"
];
const MIN_DELAY = 100;
/* harmony default export */ __webpack_exports__["default"] = (CONSTANTS);
const ADDRESS_SUGGESTION_DEFAULT_COUNTRY = "USA";
const AFFIRM_SHOP_URL = "https://www.affirm.com/shop/kohler-web";
const FREIGHT_SHIPPING_TYPES = [
    "Freight",
    "Freight Shipping"
];
const SEARCH_PDP_FL = [
    "id",
    "ctId_s",
    "CustomerFacingSKU_s",
    "ProductProductRecommendedAccessories_ss",
    "ProductProductRecommendedAccessories_s",
    "ProductBrandNameDisplay_t",
    "Product_Category",
    "ProductLocalCategory_s",
    "ProductServices_ss",
    "ProductPriceSpiderIncluded_s",
    "SKUIsProjectPack_s",
    "ProductBrandNameDisplay_s",
    "Super_Sku",
    "Collapse_Field_s",
    "Color.SKU.Details_ss",
    "productName_s",
    "RegionBrandName_s",
    "variantList.sku_ss",
    "ProductRequiredAccessoryGroup_s",
    "ProductRequiredAccessoryGroup_ss",
    "ProductYoutubeID_s",
    "productImages.labelWithUrl_ss",
    "CustomerFacingBrand",
    "ProductDescriptionProductShort_s",
    "productRegionAllVariantDiscontinued_b",
    "ProductBrandName_s",
    "RegionOnBackOrder_s",
    "ProductOverallLengthInches_s",
    "ProductOverallWidthInches_s",
    "ProductOverallHeightInches_s",
    "ProductWebFeatures_ss",
    "ProductFreightPolicyType_s",
    "category1_s",
    "RegionReleaseforShipment_dt",
    "ProductIsExclusive_s",
    "priceList.*.finalPrice_d",
    "priceList.*.saleOffer_s",
    "ProductBadgeInfo_s",
    "ProductBadgeInfo_ss",
    "ProductWebFeatures_s",
    "ProductWebTechnology_ss",
    "ProductWebTechnology_s",
    "ProductNarrativeDescription_s",
    "ProductWebMaterial_ss",
    "ProductWebMaterial_s",
    "ProductWebInstallation_ss",
    "ProductWebInstallation_s",
    "ProductCaliforniaProp65WarningDisclaimer_ss",
    "ProductCaliforniaProp65WarningDisclaimer_s",
    "ProductWebHydrotherapy_s",
    "ProductWebHydrotherapy_ss",
    "ProductWebRebates_ss",
    "ProductWebRebates_s",
    "ProductResource.DXFPlanView.resourceFullWebURL_ss",
    "ProductResource.DWGPlanView.resourceFullWebURL_ss",
    "ProductResource.DXFFrontView.resourceFullWebURL_ss",
    "ProductResource.DWGFrontView.resourceFullWebURL_ss",
    "ProductResource.DXFSideView.resourceFullWebURL_ss",
    "ProductResource.DWGSideView.resourceFullWebURL_ss",
    "ProductResource.3DDXFSymbol.resourceFullWebURL_ss",
    "ProductResource.3DDWGSymbol.resourceFullWebURL_ss",
    "ProductResource.3DRevit.resourceFullWebURL_ss",
    "ProductResource.3D3DS.resourceFullWebURL_ss",
    "ProductResource.3DSketchup.resourceFullWebURL_ss",
    "ProductResource.3DOBJ.resourceFullWebURL_ss",
    "ProductResource.CutOutDXF.resourceFullWebURL_ss",
    "ProductResource.SpecPDFFileName.resourceFullWebURL_ss",
    "ProductResource.SpecPDFFileName.resourceTitle_ss",
    "ProductResource.EnvironProdDecl.resourceFullWebURL_ss",
    "ProductResource.EnvironProdDecl.resourceTitle_ss",
    "ProductResource.HomeownersGuide.resourceFullWebURL_ss",
    "ProductResource.HomeownersGuide.resourceTitle_ss",
    "ProductResource.InstallationWithoutSPPDF.resourceFullWebURL_ss",
    "ProductResource.PartsPDFFileName.resourceFullWebURL_ss",
    "ProductResource.InstallationWithoutSPPDF.resourceTitle_ss",
    "SKUDiscontinuedDate_dt",
    "ProductResource.YouTubeInstallVideo.resourceName_ss",
    "ProductResource.YouTubeInstallVideo.resourceTitle_ss",
    "ProductResource.InteractiveSVG.resourceName_ss",
    "ProductResource.InteractiveSVG.resourceTitle_ss",
    "ProductProductNo_s",
    "ctProductType_s",
    "CustomerFacingBrand_s",
    "isCollapsedPDP_b",
    resourceFacetLabels.join(","),
    "CrossSellRecommendationSKUList_ss",
    "primaryBundleSKU_s",
    "bundleSKUList_ss",
    "title_s",
    "features_s",
    "ItemResource.IMGSpinSet.resourceFullWebURL_ss",
    "ItemResource.IMGSpinSet.resourceName_ss",
    "ItemResource.IMGSpinSet.resourceAltText_ss",
    "ItemResource.IMGSpinSet.resourceType_ss"
];
const FEATURE_FLAGS_CHECKOUT_PAYLOAD = [
    "MYSQLCONNSTR_ACI_PAYMENT_FLAG",
    "MYSQLCONNSTR_ACI_GLOBAL_PAYMENT_FLAG",
    "MYSQLCONNSTR_DISABLE_ADD_CART",
    "MYSQLCONNSTR_EXCLUDE_PO_BOX_ADDRESSES",
    "MYSQLCONNSTR_DISABLE_BILLING_CUSTOM_DROPDOWN",
    "MYSQLCONNSTR_ENABLE_PARTS_VIEWER_V2",
    "MYSQLCONNSTR_ENABLE_ORDER_DETAILS_TABS",
    "MYSQLCONNSTR_ENABLE_NARVAR_RETURN",
    "MYSQLCONNSTR_ENABLE_PAYPAL_EXPRESS_CHECKOUT",
    "MYSQLCONNSTR_ENABLE_SHOPPING_LISTS_V2",
    "MYSQLCONNSTR_ENABLE_VISUAL_SEARCH_V1",
    "MYSQLCONNSTR_ENABLE_CONFIGURATOR"
];
const CONTACT_US_PAGE_URL_US = "/en/support/contact";
const CORE_GLOBAL_CONFIG_URL = "/api/globalconfig";
const NUMERIC_REGX = /^[0-9]+$/;
const GENERIC_ERROR_MESSAGE = "Something went wrong. Please try again...";
const EXCEPTIONAL_SITENAME = "kohler";
const STORE_APP_LD_JSON = {
    context: "https://schema.org",
    type: "Store",
    addressType: "PostalAddress",
    geoType: "GeoCoordinates",
    openingHourType: "OpeningHoursSpecification",
    openingDays: {
        monday: "Monday",
        tuesday: "Tuesday",
        wednesday: "Wednesday",
        thursday: "Thursday",
        friday: "Friday",
        saturday: "Saturday",
        sunday: "Sunday"
    }
};
const BREAD_CRUMB_APP_LD_JSON = {
    context: "https://schema.org",
    breadcrumbList: "breadcrumbList",
    listItemType: "ListItem"
};
const PDP_SLIDER_SIZES = {
    largeIpadSize: 1024,
    mobileSize: 767,
    desktopSliderImages: 15,
    smallesIpadSliderImages: 12,
    imageReelTitle: "image reel",
    portateDevice: 812,
    visualNavPlp: 1023
};
const ORDER_THANKYOU = "order:thank you";
const ORDER_CONFIRMATION = "order confirmation";
const VALID_GLOBA_CONFIG_PATHS = "^(?!https?:\\/\\/|www\\.|.*\\.com$).*";
const PriceRangeFrench = "Fourchette de prix";
const ML_API_MODEL_1 = "/pia-qa/model1";
const ML_API_MODEL_2 = "/pia-qa/model2";
const LOCALE_ENGLISH = "en-US";
const PRICE_RANGE = "Price_Range";
const PDP_FIND_ON_DISPLAY = "pdp:find on display";
const PRICE_RANGE_FRENCH_LOCALE = "priceList.ANY.finalPrice_d";
const DISCOUNTED_PRICE_FACET_LABEL = "discountedPriceStartingAt";
const PDP_TYPE = "regular w/ required items";
const PDP_FEEDBACK = "pdp:provide feedback";
const SHOP_TOILET_SEATS = "shop toilet seats";
const ORDER_STATUS_PAGE = "order status";
const LITERATURE = "literature";
const TECHNICAL_SPECIFICATIONS = "technical specs";
const HOW_TO_BECOME_A_KPN = "how to become a kohler partner";
const TWO_WAYS_TO_BE_A_KPN = "two ways to be a kohler partner";
const JOIN_NOW = "Join Now";
const SEARCH_INTERNAL_TYPE = {
    sterlingResults: "view sterling results",
    compare: "compare",
    partsDiagram: "parts diagram",
    serviceParts: "service parts"
};
const INSTALL_ITEMS = "items required for install test";
const INSTALL_ITEMS_EDIT = "edit items required for install";
const MY_ACCOUNT_MODAL = "my account modal section";
const CREATE_ACCOUNT = "create account";
const BRAND_NAME = {
    annSacks: "Ann Sacks",
    sterling: "STERLING",
    homeEnergy: "Home Energy"
};
const BROWSE_ALL_KOHLER_STORES = "browse all kohler stores";
const FIND_A_STORE = "find a store";
const PDP_DETAILS = "pdp:product details";
const PDP_FAVORITE = "favorites";
const PDP_GUEST_FAVORITE = "guest favorites";
const NAVIGATION_TYPE = {
    PRODUCT: "product navigation",
    MEGA_MENU: "mega menu navigation",
    GLOBAL: "global navigation"
};
const CHECKOUT_PAYMENT = "payment & billing";
const HEADER_NAV_TABS_WRAPPER_ID = "header-nav-tabs-wrapper";
const PDP_TYPES = "regular finished goods";
const STOCKS = {
    OUT_OF_STOCK: "out of stock",
    IN_STOCK: "in stock"
};
const PERCENT_OFF = "percentOff|";
const REGULAR_PRICE = "regular price";
const TARGETED_DOMAIN_TO_MONITOR = "kohlermetrics";
const tooltip = "/icons/tooltip-red.svg";
const INSPIRATION_PAGE_NAME = {
    KIPS_BAY_DECORATOR: "kips bay decorator showhouse gallery dallas",
    PROJECT_GALLERY: "project gallery"
};
const CONTACT_US_SUPPORT = "support:contact:form";
const CONTACT_US_FORM = "support:contact";
const HELP_AND_SUPPORT = "help and support";
const HELP_SUPPORT = "help support";
const CALL_OUR_TEAM = "call our team";
const SSR_PLP_FL = [
    "id",
    "masterSKU_s",
    "masterCustomerFacingSKU_s",
    "SKUColorSwatchFilename_ss",
    "SKUColorSwatchFilename_s",
    "ProductDescriptionProductShort_s",
    "ProductBrandName_s",
    "metaTitle_s",
    "productName_s",
    "RegionBrandName_s",
    "productImages.url_s",
    "productImages.url_ss",
    "slug_s",
    "Product_Category",
    "displayPriceStartingAt_s",
    "Tile_Title",
    "Collapse_Title_s",
    "Collapse_Description_s",
    "price*",
    "discountedPrice*",
    "variantList.sku_ss",
    "variantList.sku_s",
    "SKUColorFinishName_s",
    "SKUColorFinishName_ss",
    "SKU.Details_ss",
    "Color.SKU.Details_ss",
    "Color.SKU.Details_s",
    "Color.GST.Details_ss",
    "ProductExclusive_s",
    "RegionReleaseforShipment_dt",
    "productImages.labelWithUrl_ss",
    "productImages.labelWithUrl_s",
    "productImageVariantImages.labelWithUrl_ss",
    "RegionOnBackOrder_s",
    "ProductIsRetail",
    "comboSKUAvailable_b",
    "category1_s",
    "ProductBrandNameDisplay_s",
    "ctId_s",
    "ProductResource.InteractiveSVG.resourceName_ss",
    "ProductProductNo_s",
    "ProductResource.InteractiveSVG.resourceTitle_ss"
];
const REMEDY_MODEL_JSON = "/remedy.model.json";


/***/ }),

/***/ 49139:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AP": function() { return /* binding */ PURE_TEXT_REGEX; },
/* harmony export */   "FU": function() { return /* binding */ SPECIAL_CHAR_REGEX; },
/* harmony export */   "GK": function() { return /* binding */ FILTER_PARAM_REGEX; },
/* harmony export */   "If": function() { return /* binding */ SANITIZE_TEXT_REGEX; },
/* harmony export */   "JY": function() { return /* binding */ VIDEO_ID_REGEX; },
/* harmony export */   "KC": function() { return /* binding */ UNDERSCORE_REPLACE_REGEX; },
/* harmony export */   "L3": function() { return /* binding */ IMAGEID_DATALAYER_REGEX; },
/* harmony export */   "LN": function() { return /* binding */ CAMEL_CASE_REGEX; },
/* harmony export */   "RR": function() { return /* binding */ QUOT_REGEX; },
/* harmony export */   "SA": function() { return /* binding */ SANITIZE_FLOAT_NUMBER_REGEX; },
/* harmony export */   "TT": function() { return /* binding */ TEXT_AREA_LABEL_REGEX; },
/* harmony export */   "Tc": function() { return /* binding */ SANITIZE_NUMBER_REGEX; },
/* harmony export */   "VB": function() { return /* binding */ POSTAL_CODE_US_REGEX; },
/* harmony export */   "Vb": function() { return /* binding */ MEMBERSHIP_CODE_ERROR_REGEX; },
/* harmony export */   "YN": function() { return /* binding */ PURE_DATA_FOR_STRING_REGEX; },
/* harmony export */   "ab": function() { return /* binding */ UPPERCASE_REGEX; },
/* harmony export */   "bY": function() { return /* binding */ ZIP_CODE_MATCH_WHITESPACE_REGEX; },
/* harmony export */   "cH": function() { return /* binding */ SAVE_TO_LIST_NAME_FIELD_REGEX; },
/* harmony export */   "dd": function() { return /* binding */ MEMBERSHIP_VALID_MAIL_ERROR_REGEX; },
/* harmony export */   "dq": function() { return /* binding */ DOUBLE_QUOTE_REGEX; },
/* harmony export */   "ef": function() { return /* binding */ URL_REPLACE_REGEX; },
/* harmony export */   "lY": function() { return /* binding */ ZIP_CODE_DIGIT_REGEX; },
/* harmony export */   "lh": function() { return /* binding */ CAMEL_CASE_REPLACE_PATTERN; },
/* harmony export */   "lj": function() { return /* binding */ NAME_REGEX; },
/* harmony export */   "my": function() { return /* binding */ SPACE_REGEX; },
/* harmony export */   "ny": function() { return /* binding */ VISUAL_NAV_IMAGEID_FOR_DATALAYER; },
/* harmony export */   "ok": function() { return /* binding */ DATA_LAYER_REGEX; },
/* harmony export */   "si": function() { return /* binding */ ALPHABET_WITH_SPACE_REGEX; },
/* harmony export */   "uZ": function() { return /* binding */ NUMBER_HEADING_REGEX; },
/* harmony export */   "ub": function() { return /* binding */ PDP_REGEX; },
/* harmony export */   "wM": function() { return /* binding */ POSTAL_CODE_REGEX; },
/* harmony export */   "wc": function() { return /* binding */ POSTAL_CODE_CA_REGEX; }
/* harmony export */ });
/* unused harmony exports FULL_NAME_REGEX, INCH_SYMBOL_REGEX, SELECT_AFTER_LAST_SLASH_REGEX */
const SANITIZE_TEXT_REGEX = /[^a-zA-Z<>&@.-\d\s:]/g;
const SANITIZE_NUMBER_REGEX = /[^0-9]/g;
const PDP_REGEX = /^([\/]).*.([\-]).([0-9]{2,}).*$/gm;
const URL_REPLACE_REGEX = /\s&\s|\s/g;
const MEMBERSHIP_VALID_MAIL_ERROR_REGEX = /\S+@\S+\.\S+/;
const MEMBERSHIP_CODE_ERROR_REGEX = /@kohler.com\s*$/;
const FULL_NAME_REGEX = /^[a-zA-Z]+ [a-zA-Z]+$/;
const PURE_TEXT_REGEX = /<[^>]*>/g;
const SPECIAL_CHAR_REGEX = /[^a-zA-Zd0-9 ]/g;
const NUMBER_HEADING_REGEX = /^[1-6]$/;
const ALPHABET_WITH_SPACE_REGEX = /^[a-zA-Z ]*$/;
const POSTAL_CODE_US_REGEX = /^([0-9]{5})(?:[-\s]*([0-9]{4}))?$/;
const POSTAL_CODE_CA_REGEX = /^([A-Z][0-9][A-Z])\s*([0-9][A-Z][0-9])$/;
const POSTAL_CODE_REGEX = /^(?:[A-Z0-9]+([- ]?[A-Z0-9]+)*)?$/;
const INCH_SYMBOL_REGEX = /\d$/;
const DATA_LAYER_REGEX = /&amp;/g;
const PURE_DATA_FOR_STRING_REGEX = /(\r\n|\n|\r)/gm;
const SPACE_REGEX = /\s+/g;
const FILTER_PARAM_REGEX = /[\/\\]/g;
const TEXT_AREA_LABEL_REGEX = /\*/g;
const SAVE_TO_LIST_NAME_FIELD_REGEX = /^[a-zA-Z0-9 ]*$/;
const VISUAL_NAV_IMAGEID_FOR_DATALAYER = /([a-zA-Z0-9_]+)\.jpg$/;
const UPPERCASE_REGEX = /(?=.*[A-Z])/;
const ZIP_CODE_MATCH_WHITESPACE_REGEX = /\s/g;
const ZIP_CODE_DIGIT_REGEX = /^\d+$/;
const VIDEO_ID_REGEX = /PAWEB\/|Kohler\//;
const SANITIZE_FLOAT_NUMBER_REGEX = /[^0-9.]/g;
const NAME_REGEX = /^[a-zA-Z-'.]+$/;
const IMAGEID_DATALAYER_REGEX = /PAWEB\/(\w+)_/;
const SELECT_AFTER_LAST_SLASH_REGEX = /\/[^\/]*$/;
const QUOT_REGEX = /&quot;/g;
const DOUBLE_QUOTE_REGEX = /"/g;
const UNDERSCORE_REPLACE_REGEX = /_/g;
const CAMEL_CASE_REGEX = /([a-z])([A-Z])/g;
const CAMEL_CASE_REPLACE_PATTERN = "$1 $2";


/***/ }),

/***/ 64757:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E5": function() { return /* binding */ CATALOG_PROJECTION_ENDPOINT; },
/* harmony export */   "Ht": function() { return /* binding */ FRAUD_DECLINED_MESSAGE_ENDPOINT; },
/* harmony export */   "PN": function() { return /* binding */ MY_LISTS_PAGE_PATH; },
/* harmony export */   "RG": function() { return /* binding */ PRODUCT_BEST_SELLERS; },
/* harmony export */   "Rv": function() { return /* binding */ ACI_PAYMENT_CHECKOUT_ENDPOINT; },
/* harmony export */   "TE": function() { return /* binding */ ADOBE_TARGET_PRODUCT_RECOMMENDETION_ENDPOINT; },
/* harmony export */   "VU": function() { return /* binding */ FEATURE_FLAGS_API_ENDPOINT; },
/* harmony export */   "YZ": function() { return /* binding */ SVG_METADATA_ENDPOINT; },
/* harmony export */   "j0": function() { return /* binding */ CHANGE_PASSWORD_ENDPOINT; },
/* harmony export */   "lY": function() { return /* binding */ CATALOG_NOTIFY_ENDPOINT; },
/* harmony export */   "r5": function() { return /* binding */ SEARCH_FULL_CATALOG; },
/* harmony export */   "zG": function() { return /* binding */ ACI_PAYMENT_CALLBACK_ENDPOINT; }
/* harmony export */ });
/* unused harmony exports CHANGE_PASSWORD_MODEL_DATA_URL, ML_END_POINT, USER_LIST_DELETE_END_POINT, FAVORITES_PAGE_PATH */
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96301);

const ACI_PAYMENT_CHECKOUT_ENDPOINT = "/payment/checkout";
const ACI_PAYMENT_CALLBACK_ENDPOINT = "/payment/checkout/callback";
const FRAUD_DECLINED_MESSAGE_ENDPOINT = "/en/declined";
const CHANGE_PASSWORD_MODEL_DATA_URL = "/en/my-account/change-password.model.json";
const CHANGE_PASSWORD_ENDPOINT = "/customer/change_password";
const CATALOG_NOTIFY_ENDPOINT = "catalog/product/oos/notify";
const CATALOG_PROJECTION_ENDPOINT = "/catalog/product/projection";
const FEATURE_FLAGS_API_ENDPOINT = _constants__WEBPACK_IMPORTED_MODULE_0__.DOMAIN + "/api/featureflags";
const SVG_METADATA_ENDPOINT = "/catalog/svg/metadata";
const ML_END_POINT = "https://api-kohler-int-test.azure-api.net";
const ADOBE_TARGET_PRODUCT_RECOMMENDETION_ENDPOINT = "/catalog/product/recommendation";
const PRODUCT_BEST_SELLERS = "/products/best-sellers";
const USER_LIST_DELETE_END_POINT = "/shopping-list";
const MY_LISTS_PAGE_PATH = "/my-account/my-lists";
const FAVORITES_PAGE_PATH = "/my-account/my-favorites";
const SEARCH_FULL_CATALOG = "/search/full-catalog";


/***/ }),

/***/ 2595:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

const useIsSsr = ()=>{
    // we always start off in "SSR mode", to ensure our initial browser render
    // matches the SSR render
    const [isSsr, setIsSsr] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(true);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        // `useEffect` never runs on the server, so we must be on the client if
        // we hit this block
        setIsSsr(false);
    }, []);
    return isSsr;
};
/* harmony default export */ __webpack_exports__["Z"] = (useIsSsr);


/***/ }),

/***/ 83886:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2595);


const useSmartCrop = ()=>{
    const isSsr = (0,_hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)();
    const [scriptStatus, setScriptStatus] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(!isSsr && window.s7responsiveImage ? true : false);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (!isSsr) {
            loadSmartcrop();
        }
    }, [
        isSsr
    ]);
    const loadSmartcrop = ()=>{
        const scriptExist = document.querySelectorAll("script#smartcrop-react");
        if (scriptExist.length === 0 && !window.s7responsiveImage) {
            const script = document.createElement("script");
            script.src = "/js/responsive-images.js";
            script.id = "smartcrop-react";
            script.onload = function onload() {
                setScriptStatus(true);
            };
            document.body.appendChild(script);
        } else {
            setScriptStatus(true);
        }
    };
    const applySmartCrop = (ele)=>{
        window.s7responsiveImage && window.s7responsiveImage(ele);
    };
    return {
        scriptStatus,
        applySmartCrop
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useSmartCrop);


/***/ }),

/***/ 78770:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ useViewportWidth; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

const useViewport = ()=>{
    const [device, setDevice] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(getValues);
    /**
   * This function does the comparisons for different viewports
   * @return {Object} Object of all the viewport flags
   */ function getValues() {
        const resolution = window.innerWidth;
        const isExtraSmallScreen = resolution <= 375;
        const isSmallScreen = resolution <= 812;
        const isMediumScreen = resolution > 812 && resolution <= 1024;
        const isSmallTabView = resolution < 1024;
        const isLargeTabView = resolution > 1024;
        const isLargeScreen = resolution >= 1024 && resolution < 1920;
        const isExtraLargeScreen = resolution >= 1920;
        return {
            isExtraSmallScreen,
            isSmallScreen,
            isMediumScreen,
            isLargeScreen,
            isExtraLargeScreen,
            isLargeTabView,
            isSmallTabView
        };
    }
    /**
   * Sets updated viewport flag values
   */ function handleWindowResize() {
        setDevice(getValues());
    }
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        handleWindowResize();
        window.addEventListener("resize", handleWindowResize);
        return ()=>{
            window.removeEventListener("resize", handleWindowResize);
        };
    }, []);
    return device;
};
/* harmony default export */ __webpack_exports__["Z"] = (useViewport);
const useViewportWidth = ()=>{
    const [width, setWidth] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0);
    const handleWindowResize = ()=>setWidth(window.innerWidth);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        handleWindowResize();
        window.addEventListener("resize", handleWindowResize);
        return ()=>window.removeEventListener("resize", handleWindowResize);
    }, []);
    return width;
};


/***/ }),

/***/ 30394:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23279);
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_debounce__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2595);



/**
 *
 * @return {{width, height}}
 */ const useWindowDimensions = ()=>{
    const isSsr = (0,_hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    const [windowDimensions, setWindowDimensions] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
        winWidth: 0,
        winHeight: 0
    });
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (isSsr) {
            return;
        }
        const { innerWidth: width , innerHeight: height  } = window;
        /**
     * Set window dimensions on resize
     */ const handleResize = lodash_debounce__WEBPACK_IMPORTED_MODULE_1___default()(()=>{
            setWindowDimensions({
                winWidth: width,
                winHeight: height
            });
        }, 300);
        if (!isSsr) {
            setWindowDimensions({
                winWidth: width,
                winHeight: height
            });
            window.addEventListener("resize", handleResize);
        }
        return ()=>window.removeEventListener("resize", handleResize);
    }, [
        isSsr
    ]);
    return windowDimensions;
};
/* harmony default export */ __webpack_exports__["Z"] = (useWindowDimensions);


/***/ }),

/***/ 11859:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2595);
/* eslint-disable require-jsdoc */ 

const useWindowResize = ()=>{
    const isSsr = (0,_hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)();
    // [1366, 443] [768, 1024] [449, 972]
    // const [size, setSize] = useState([1366, 443])
    const [size, setSize] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([
         true ? window.innerWidth : 0,
         true ? window.innerHeight : 0
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect)(()=>{
        if (isSsr) {
            return;
        }
        setSize([
            window.innerWidth,
            window.innerHeight
        ]);
        function updateSize() {
            setSize([
                window.innerWidth,
                window.innerHeight
            ]);
        }
        if (!isSsr) {
            window.addEventListener("resize", updateSize);
            updateSize();
        }
        return ()=>window.removeEventListener("resize", updateSize);
    }, [
        isSsr
    ]);
    return size;
};
/* harmony default export */ __webpack_exports__["Z"] = (useWindowResize);


/***/ }),

/***/ 46967:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24400);

const useAuthUtilityNavi18n = ()=>{
    const { t  } = (0,next_i18next__WEBPACK_IMPORTED_MODULE_0__/* .useTranslation */ .$G)();
    const i18n = {
        favorites: t("Favorites"),
        signIn: t("Sign In"),
        createAccount: t("Create Account"),
        hi: t("kf.auth.label.hi"),
        title: t("kf.auth.label.bannerMssg"),
        welcome: t("kf.auth.label.welcome"),
        logout: t("kf.auth.label.logout"),
        rightArrowAlt: t("kf.auth.label.rightArrowAlt"),
        leftArrowAlt: t("kf.auth.label.rightArrowAlt"),
        menu: t("kf.auth.label.menu"),
        expanded: t("kf.auth.label.expanded"),
        collapsed: t("kf.auth.label.collapsed"),
        user: t("kf.auth.label.user"),
        storeOperations: t("kf.account.label.storeOperations")
    };
    return i18n;
};
/* harmony default export */ __webpack_exports__["Z"] = (useAuthUtilityNavi18n);


/***/ }),

/***/ 83511:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24400);

const useFindStorei18n = (param)=>{
    let { authorData  } = param;
    const { t  } = (0,next_i18next__WEBPACK_IMPORTED_MODULE_0__/* .useTranslation */ .$G)();
    const i18n = {
        userMyLocation: authorData.userMyLocation ? authorData.userMyLocation : t("kf.findstore.label.userMyLocation"),
        kohlerStores: authorData.kohlerStores ? authorData.kohlerStores : t("kf.findstore.label.kohlerStores"),
        showrooms: authorData.showrooms ? authorData.showrooms : t("kf.findstore.label.showrooms"),
        showroom: authorData.showroom ? authorData.showroom : t("kf.findstore.label.showrooms"),
        kohlerStore: authorData.kohlerStore ? authorData.kohlerStore : t("kf.findstore.label.kohlerStore"),
        annsacksShowroom: authorData.annsacksShowroom ? authorData.annsacksShowroom : t("kf.findstore.label.annsacksShowroom"),
        partsDealer: authorData.partsDealer ? authorData.partsDealer : t("kf.findstore.label.partsDealer"),
        homeCenter: authorData.homeCenter ? authorData.homeCenter : t("kf.findStore.label.homeCenter"),
        genuinePartsDealers: authorData.genuinePartsDealers ? authorData.genuinePartsDealers : t("kf.findstore.label.genuinePartsDealers"),
        kohler: t("kf.findStoreUtilNav.label.kohler"),
        annSacks: authorData.annSacks ? authorData.annSacks : t("kf.findstore.label.annSacks"),
        annSacksText: authorData.annSacksText ? authorData.annSacksText : t("kf.findstore.label.annSacksText"),
        countryPlaceholder: authorData.countryPlaceholder ? authorData.countryPlaceholder : t("kf.findstore.label.countryPlaceholder"),
        locationErrormessage: authorData.locationErrormessage ? authorData.locationErrormessage : t("kf.findstore.label.locationErrormessage"),
        clearAll: t("kf.plp.label.clearAll"),
        viewList: authorData.viewList ? authorData.viewList : t("kf.findstore.label.viewList"),
        viewMap: authorData.viewMap ? authorData.viewMap : t("kf.findstore.label.viewMap"),
        applyFilters: authorData.applyFilters ? authorData.applyFilters : t("kf.findstore.label.applyFilters"),
        filters: t("kf.plp.label.filters"),
        viewStoreDetail: t("kf.findStoreUtilNav.label.viewStoreDetail"),
        storeDetail: t("kf.findStoreUtilNav.label.storeDetail"),
        miles: authorData.miles ? authorData.miles : t("kf.findstore.label.miles"),
        away: authorData.away ? authorData.away : t("kf.findstore.label.away"),
        browseAllStore: authorData.browseAllStore ? authorData.browseAllStore : t("kf.findstore.label.browseAllStore"),
        setAsMyStore: t("kf.findStoreUtilNav.label.setAsMystore"),
        home: authorData.home ? authorData.home : t("kf.findstore.label.home"),
        findStore: authorData.findstore ? authorData.findstore : t("kf.findstore.label.findstore"),
        kohlerStoreImgAlt: t("kf.findstore.label.kohlerStoreImgAlt"),
        viewResults: t("kf.plp.label.viewResults"),
        view: t("kf.plp.label.view"),
        results: t("kf.plp.label.results"),
        filterImgAlt: t("kf.findstore.label.filterImgAlt"),
        myStore: t("kf.findStoreUtilNav.label.myStore"),
        retailStore: authorData.retailStore ? authorData.retailStore : t("kf.findstore.label.retailStore"),
        retailMobileText: t("kf.findstore.label.retailMobileText"),
        infoModalTitle: t("kf.findStoreUtilNav.messageTitleZipcode"),
        ariaLabel: {
            enterZipcode: t("kf.findStoreUtilNav.aria.label.enterZipCode"),
            showFilter: t("kf.findstore.aria.label.showFilter"),
            hideFilter: t("kf.findstore.aria.label.hideFilter"),
            browseAll: t("kf.findstore.aria.label.browseAll"),
            contact: (phone)=>t("kf.findStore.aria.label.contact", {
                    phone
                }),
            mapMarker: t("kf.findstore.aria.label.mapMarker"),
            mapGuidelines: t("kf.findstore.aria.label.mapGuidelines"),
            currentPage: t("kf.pdp.label.aria.currentPage"),
            page: t("kf.pdp.label.aria.page")
        },
        messageZipcode: t("kf.findStoreUtilNav.MessageZipcode"),
        continue: t("kf.checkout.label.continue"),
        expanded: t("kf.productTab.aria.expanded"),
        collapsed: t("kf.productTab.aria.collapsed"),
        submit: t("kf.global.label.submit"),
        NotYourStore: t("kf.findStoreUtilNav.label.NotYourStore"),
        viewAllStore: t("kf.findStoreUtilNav.label.viewAllStore"),
        useLocation: t("kf.findStoreUtilNav.label.useLocation"),
        closestStore: t("kf.findStoreUtilNav.label.closestStore"),
        enterCityStateZip: t("kf.findStoreUtilNav.label.countryPlaceholder"),
        locationDescription: t("kf.findStoreUtilNav.label.locationDescription"),
        zipCodeContent: t("kf.findStoreUtilNav.label.zipCodeContent"),
        KohlerSignatureStore: t("kf.findStoreUtilNav.label.KohlerSignatureStore"),
        BySupplyNew: t("kf.findStoreUtilNav.label.BySupplyNewEnglad"),
        searchHeader: t("kf.search.label.searchHeader"),
        filterTitle: (facetName, facetCount)=>t("kf.plp.ariaLabel.filterTitle", {
                facetName: facetName,
                facetCount: facetCount
            })
    };
    return i18n;
};
/* harmony default export */ __webpack_exports__["Z"] = (useFindStorei18n);


/***/ }),

/***/ 58886:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24400);

const usePdpi18n = (authorData, badgeText, name)=>{
    const { configuratorTitle ="" , configuratorDesc ="" , configuratorButtonLabel ="" , configuratorErrorTitle ="" , configuratorErrorDesc ="" , configuratorErrorButtonLabel =""  } = authorData;
    const { t  } = (0,next_i18next__WEBPACK_IMPORTED_MODULE_0__/* .useTranslation */ .$G)();
    var _listpricelabel, _colorlabel, ref, _professionalService, _installationHelp, _installerArea, _maxProducts, ref1, _superskulabel, _priceFootnoteTitle, _priceFootnote, _colorFootnoteTitle, _colorFootnote, _discontinueProductMsg, _discontinueColorMsg, _onPdpCtaLabel, _colorOrFinish, _outofStockTitle, _welcomeMsg, _notifyEmailTxt, _findLocalStore, _backOrder, _specialOrder, _discontinueColorLabel, _discontinueColorFinishLabel, _modalRightSectionTitle, _modalRightSectionTitle1, _modalRightSectionDesc, _modalRightSectionDesc1, _modalRighttSectionCtaLabel, _modalLeftSectionTitle, _onPdpTooltip, _priceSpiderTitle, _oversizeMsgTitle, _oversizeMsgDesc, _noPriceMsg, _listpricetooltip, _subCopy, _subCopy1, _serviceavailable, _errorMessage, _zipcodevalidationmessage, _zipcodevalidationmessage1, _new, _onSale, _shippingTitle, _shippingDescription, _modalRightSectionNoStockMsg;
    const i18n = {
        home: t("kf.global.label.home"),
        viewLink: t("kf.pdp.label.viewGallery"),
        linkMore: t("kf.pdp.label.morePhotos"),
        moreCollection: t("kf.pdp.label.moreFromCollection"),
        moreCollectionDiscontinued: t("kf.pdp.label.moreFromCollectionDiscontinued"),
        shopText: t("kf.pdp.label.shopAll"),
        listPrice: t("kf.pdp.label.listPrice"),
        refPrice: (_listpricelabel = authorData.listpricelabel) !== null && _listpricelabel !== void 0 ? _listpricelabel : t("kf.pdp.label.refPrice"),
        startingAt: t("kf.pdp.label.startingAt"),
        finish: (_colorlabel = authorData.colorlabel) !== null && _colorlabel !== void 0 ? _colorlabel : t("kf.pdp.label.finish"),
        orderSample: t("kf.pdp.label.orderSample"),
        dimensions: t("kf.pdp.label.dimensions"),
        details: t("kf.pdp.label.details"),
        viewAllSpecs: t("kf.pdp.label.viewAllSpecs"),
        viewMore: t("kf.pdp.label.viewMore"),
        viewGallery: (ref = authorData === null || authorData === void 0 ? void 0 : authorData.viewgalleryctalabel) !== null && ref !== void 0 ? ref : t("kf.pdp.label.viewGallery"),
        length: t("kf.pdp.label.length"),
        width: t("kf.pdp.label.width"),
        height: t("kf.pdp.label.height"),
        smLength: t("kf.pdp.label.smLength"),
        smWidth: t("kf.pdp.label.smWidth"),
        smHeight: t("kf.pdp.label.smHeight"),
        learnMore: t("kf.pdp.label.learnMore"),
        addToCart: t("kf.cart.label.addToCart"),
        addService: t("kf.cart.label.addService"),
        backOrderMssg: (days)=>t("kf.cart.label.backOrderMssg", {
                days
            }),
        print: t("kf.plp.label.print"),
        wishlist: t("kf.pdp.label.wishlist"),
        share: t("kf.plp.label.share"),
        addToCompare: t("kf.compare.label.addToCompare"),
        nearByStoreLink: t("kf.pdp.label.nearByStoreLink"),
        professionalService: (_professionalService = authorData.professionalService) !== null && _professionalService !== void 0 ? _professionalService : t("kf.pdp.label.professionalService"),
        installationHelp: (_installationHelp = authorData.installationHelp) !== null && _installationHelp !== void 0 ? _installationHelp : t("kf.pdp.label.installationHelp"),
        installerArea: (_installerArea = authorData.installerArea) !== null && _installerArea !== void 0 ? _installerArea : t("kf.pdp.label.installerArea"),
        sameCategory: t("kf.compare.validation.sameCategory"),
        maxProduct: (_maxProducts = authorData.maxProducts) !== null && _maxProducts !== void 0 ? _maxProducts : t("kf.compare.validation.maxProducts"),
        sameVariants: (ref1 = authorData === null || authorData === void 0 ? void 0 : authorData.sameVariants) !== null && ref1 !== void 0 ? ref1 : t("kf.compare.validation.sameVariants"),
        itemAdded: t("kf.pdp.label.itemAdded"),
        itemsAdded: t("kf.pdp.label.itemsAdded"),
        yourCart: t("kf.pdp.label.yourCart"),
        selectMoreOptions: t("kf.pdp.label.selectMoreOptions"),
        productOptions: (_superskulabel = authorData.superskulabel) !== null && _superskulabel !== void 0 ? _superskulabel : t("kf.pdp.label.productOptions"),
        priceFootnoteTitle: (_priceFootnoteTitle = authorData.priceFootnoteTitle) !== null && _priceFootnoteTitle !== void 0 ? _priceFootnoteTitle : t("kf.pdp.label.priceFootnoteTitle"),
        priceFootnote: (_priceFootnote = authorData.priceFootnote) !== null && _priceFootnote !== void 0 ? _priceFootnote : t("kf.pdp.label.priceFootnote"),
        colorFootnoteTitle: (_colorFootnoteTitle = authorData.colorFootnoteTitle) !== null && _colorFootnoteTitle !== void 0 ? _colorFootnoteTitle : t("kf.pdp.label.colorFootnoteTitle"),
        colorFootnote: (_colorFootnote = authorData.colorFootnote) !== null && _colorFootnote !== void 0 ? _colorFootnote : t("kf.pdp.label.colorFootnote"),
        discontinueProductMsg: (_discontinueProductMsg = authorData.discontinueProductMsg) !== null && _discontinueProductMsg !== void 0 ? _discontinueProductMsg : t("kf.pdp.label.discontinueProductMsg"),
        discontinueColorMsg: (_discontinueColorMsg = authorData.discontinueColorMsg) !== null && _discontinueColorMsg !== void 0 ? _discontinueColorMsg : t("kf.pdp.label.discontinueColorMsg"),
        itemReqCTA: (_onPdpCtaLabel = authorData.onPdpCtaLabel) !== null && _onPdpCtaLabel !== void 0 ? _onPdpCtaLabel : t("kf.pdp.label.itemReqCTA"),
        editItemReqCTA: authorData.onPdpCtaLabel ? "".concat(t("kf.pdp.label.edit"), " ").concat(authorData.onPdpCtaLabel) : t("kf.pdp.label.editItemReqCTA"),
        colorOrFinish: (_colorOrFinish = authorData.colorOrFinish) !== null && _colorOrFinish !== void 0 ? _colorOrFinish : t("kf.pdp.label.colorOrFinish"),
        outOfStockMsg: authorData.outofStockDesc,
        outOfStock: (_outofStockTitle = authorData.outofStockTitle) !== null && _outofStockTitle !== void 0 ? _outofStockTitle : t("kf.pdp.label.outOfStockMsg"),
        notifyMailCTA: t("kf.pdp.label.notifyMailCTA"),
        emailAddress: t("kf.pdp.label.emailAddress"),
        validEmail: t("kf.pdp.label.validEmail"),
        welcomeMsg: (_welcomeMsg = authorData.welcomeMsg) !== null && _welcomeMsg !== void 0 ? _welcomeMsg : t("kf.pdp.label.welcomeMsg"),
        discontinuedTxt: t("kf.pdp.label.discontinuedTxt"),
        compareTxt: t("kf.pdp.label.compareTxt"),
        favTxt: t("kf.pdp.label.favTxt"),
        projectTxt: t("kf.pdp.label.projectTxt"),
        findItemCTA: t("kf.pdp.label.findItemCTA"),
        availColorCTA: authorData.discontinuePartialCtaLabel ? authorData.discontinuePartialCtaLabel : t("kf.pdp.label.availColorCTA"),
        notifyEmailTxt: (_notifyEmailTxt = authorData.notifyEmailTxt) !== null && _notifyEmailTxt !== void 0 ? _notifyEmailTxt : t("kf.pdp.label.notifyEmailTxt"),
        findLocalStore: (_findLocalStore = authorData.findLocalStore) !== null && _findLocalStore !== void 0 ? _findLocalStore : t("kf.pdp.label.findLocalStore"),
        toCheckAvailability: t("kf.pdp.label.toCheckAvailability"),
        backOrder: (_backOrder = authorData.backOrder) !== null && _backOrder !== void 0 ? _backOrder : t("kf.pdp.label.backOrder"),
        specialOrder: (_specialOrder = authorData.specialOrder) !== null && _specialOrder !== void 0 ? _specialOrder : t("kf.pdp.label.specialOrder"),
        discontinuedColor: (_discontinueColorLabel = authorData.discontinueColorLabel) !== null && _discontinueColorLabel !== void 0 ? _discontinueColorLabel : t("kf.pdp.label.discontinuedColor"),
        discontinuedColorFinish: (_discontinueColorFinishLabel = authorData.discontinueColorFinishLabel) !== null && _discontinueColorFinishLabel !== void 0 ? _discontinueColorFinishLabel : t("kf.pdp.label.discontinuedColorFinish"),
        toolTip: t("kf.pdp.label.toolTip"),
        requiredProductTitle: (_modalRightSectionTitle = authorData.modalRightSectionTitle) !== null && _modalRightSectionTitle !== void 0 ? _modalRightSectionTitle : t("kf.pdp.label.requiredProductTitle"),
        cadRequiredProductTitle: (_modalRightSectionTitle1 = authorData.modalRightSectionTitle) !== null && _modalRightSectionTitle1 !== void 0 ? _modalRightSectionTitle1 : t("kf.pdp.label.cadRequiredProductTitle"),
        requiredProductDescription: (_modalRightSectionDesc = authorData.modalRightSectionDesc) !== null && _modalRightSectionDesc !== void 0 ? _modalRightSectionDesc : t("kf.pdp.label.requiredProductDescription"),
        cadRequiredProductDescription: (_modalRightSectionDesc1 = authorData.modalRightSectionDesc) !== null && _modalRightSectionDesc1 !== void 0 ? _modalRightSectionDesc1 : t("kf.pdp.label.cadRequiredProductDescription"),
        productText: t("kf.pdp.label.productText"),
        includesText: t("kf.pdp.label.includesText"),
        updateText: t("kf.pdp.label.updateText"),
        includeTextCTA: (_modalRighttSectionCtaLabel = authorData.modalRighttSectionCtaLabel) !== null && _modalRighttSectionCtaLabel !== void 0 ? _modalRighttSectionCtaLabel : t("kf.pdp.label.includeTextCTA"),
        title: (_modalLeftSectionTitle = authorData.modalLeftSectionTitle) !== null && _modalLeftSectionTitle !== void 0 ? _modalLeftSectionTitle : t("kf.pdp.label.title"),
        remove: t("kf.pdp.label.remove"),
        tooltipMsg: (_onPdpTooltip = authorData.onPdpTooltip) !== null && _onPdpTooltip !== void 0 ? _onPdpTooltip : t("kf.pdp.label.tooltipMsg"),
        priceSpiderTitle: (_priceSpiderTitle = authorData.priceSpiderTitle) !== null && _priceSpiderTitle !== void 0 ? _priceSpiderTitle : t("kf.pdp.label.priceSpiderTitle"),
        primaryTxt: (_oversizeMsgTitle = authorData.oversizeMsgTitle) !== null && _oversizeMsgTitle !== void 0 ? _oversizeMsgTitle : t("kf.pdp.label.alert.primaryMsg"),
        secondaryTxt: (_oversizeMsgDesc = authorData.oversizeMsgDesc) !== null && _oversizeMsgDesc !== void 0 ? _oversizeMsgDesc : t("kf.pdp.label.alert.secondaryMsg"),
        withoutPriceTxt: (_noPriceMsg = authorData.noPriceMsg) !== null && _noPriceMsg !== void 0 ? _noPriceMsg : t("kf.pdp.label.withoutPriceTxt"),
        projectPackMssg: authorData.projectPackMssg ? authorData.projectPackMssg : t("kf.pdp.label.projectPackMssg"),
        qtyMoreThanStock: t("kf.pdp.label.qtyMoreThanStock"),
        associatePrice: t("kf.pdp.label.associatePrice"),
        friendsFamilyPrice: t("kf.pdp.label.friendsFamilyPrice"),
        listPriceInfo: (_listpricetooltip = authorData.listpricetooltip) !== null && _listpricetooltip !== void 0 ? _listpricetooltip : t("kf.pdp.label.listPriceInfo"),
        favSuccessMsg: t("kf.favorites.success"),
        favErrorMsg: t("kf.favorites.error"),
        installationTitle: t("kf.pdp.label.installationTitle"),
        nearestService: (_subCopy = authorData.subCopy) !== null && _subCopy !== void 0 ? _subCopy : t("kf.pdp.label.nearestService"),
        nearestInPerson: (_subCopy1 = authorData.subCopy) !== null && _subCopy1 !== void 0 ? _subCopy1 : t("kf.pdp.label.nearestInPerson"),
        edit: t("kf.pdp.label.edit"),
        change: t("kf.pdp.label.change"),
        eligibleZipCodeSuccess: (_serviceavailable = authorData.serviceavailable) !== null && _serviceavailable !== void 0 ? _serviceavailable : t("kf.pdp.label.eligibleZipCodeSuccess"),
        eligibleZipCodeError: (_errorMessage = authorData.errorMessage) !== null && _errorMessage !== void 0 ? _errorMessage : t("kf.pdp.label.eligibleZipCodeError"),
        findaPro: t("kf.pdp.label.findaPro"),
        zipcode: t("kf.pdp.label.zipcode"),
        checkAvailability: t("kf.pdp.label.checkAvailability"),
        zipCodeGuidText: t("kf.pdp.label.zipCodeGuidText"),
        update: t("kf.pdp.label.updateBtn"),
        search: t("kf.pdp.label.searchBtn"),
        forText: t("kf.pdp.label.forText"),
        memberShipPrice: t("kf.pdp.label.memberShipPrice"),
        bathroomDesignService: t("kf.pdp.label.bathroomDesignService"),
        maxInventory: t("kf.pdp.label.maxInventory"),
        zipcodeEmptyError: (_zipcodevalidationmessage = authorData.zipcodevalidationmessage) !== null && _zipcodevalidationmessage !== void 0 ? _zipcodevalidationmessage : t("kf.pdp.label.zipcodeEmptyError"),
        validZipcode: (_zipcodevalidationmessage1 = authorData.zipcodevalidationmessage) !== null && _zipcodevalidationmessage1 !== void 0 ? _zipcodevalidationmessage1 : t("kf.pdp.label.validZipcode"),
        percentOff: t("kf.pdp.label.percentOff"),
        serviceItemAdded: t("kf.pdp.label.serviceItemAdded"),
        serviceItemsAdded: t("kf.pdp.label.serviceItemsAdded"),
        serviceParts: t("kf.technical.label.serviceParts"),
        servicePartsLabel: t("kf.pdp.label.aria.serviceParts"),
        outOfStockError: authorData.invalidEmailMessage ? authorData.invalidEmailMessage : t("kf.pdp.error.outOfStock"),
        successTxt: t("kf.pdp.outOfStock.successTxt"),
        successMsg: authorData.outofStockConfirmMsg ? authorData.outofStockConfirmMsg : t("kf.pdp.outOfStock.thankMsg"),
        doneCTA: t("kf.pdp.outOfStock.doneCTA"),
        new: (_new = badgeText.new) !== null && _new !== void 0 ? _new : t("kf.plp.label.new"),
        sale: (_onSale = badgeText.onSale) !== null && _onSale !== void 0 ? _onSale : t("kf.plp.label.onSale"),
        exclusive: t("kf.plp.label.exclusive"),
        newExclusive: t("kf.plp.label.newExclusive"),
        discontinued: badgeText.discontinued ? badgeText.discontinued : t("kf.plp.label.discontinued"),
        shippingTitle: (_shippingTitle = authorData.shippingTitle) !== null && _shippingTitle !== void 0 ? _shippingTitle : t("kf.pdp.label.alert.shippingRestrictions"),
        shippingDescription: (_shippingDescription = authorData.shippingDescription) !== null && _shippingDescription !== void 0 ? _shippingDescription : t("kf.pdp.label.alert.shippingRestrictionsDesc"),
        ariaLabel: {
            serviceAddToCart: t("kf.pdp.aria.label.addServiceToCart"),
            serviceLearnMore: t("kf.pdp.aria.label.serviceLearnMore"),
            designServiceAddToCart: t("kf.pdp.aria.label.addDesignServiceToCart"),
            designServiceLearnMore: t("kf.pdp.aria.label.designServiceLearnMore"),
            closeZoomImageModel: t("kf.pdp.aria.label.closeZoomImageModel"),
            addProductToCart: t("kf.pdp.aria.label.addProductToCart", {
                name
            }),
            addProductService: t("kf.pdp.aria.label.addProductService", {
                name
            }),
            print: t("kf.pdp.label.aria.print", {
                productName: name
            }),
            share: t("kf.pdp.label.aria.share", {
                productName: name
            }),
            currentPage: t("kf.pdp.label.aria.currentPage"),
            page: t("kf.pdp.label.aria.page"),
            breadcrumb: t("kf.pdp.label.aria.breadcrumb")
        },
        outOfStockErr: (_modalRightSectionNoStockMsg = authorData.modalRightSectionNoStockMsg) !== null && _modalRightSectionNoStockMsg !== void 0 ? _modalRightSectionNoStockMsg : t("kf.pdp.label.reqItem.err.outOfStockErrMsg"),
        removeItem: t("kf.favorites.removeItem"),
        removeItemError: t("kf.favorites.removeItemError"),
        backInStock: t("kf.pdp.label.backInStock"),
        notApplicable: t("kf.pdp.label.notApplicable"),
        partNumber: t("kf.pdp.label.partNumber"),
        partName: t("kf.pdp.label.partName"),
        descReadMore: t("kf.pdp.label.descReadMore"),
        productAccordionText: {
            features: t("kf.pdp.label.features"),
            dimensions: t("kf.pdp.label.dimensions"),
            specs: t("kf.pdp.label.specs"),
            addOnServices: t("kf.pdp.label.addOnServices"),
            technologies: t("kf.pdp.label.technology"),
            productDetails: t("kf.pdp.label.productDetails"),
            material: t("kf.pdp.label.material"),
            installation: t("kf.pdp.label.installation"),
            hydrotherapy: t("kf.pdp.label.hydrotherapy"),
            rebates: t("kf.pdp.label.rebates"),
            props65Warning: t("kf.pdp.label.props65Warning"),
            selectAll: t("kf.technical.label.selectAll"),
            download: t("kf.technical.label.download"),
            installationSupport: t("kf.pdp.label.installationSupport"),
            designFiles: t("kf.technical.label.designFiles"),
            technicalInfo: t("kf.technical.label.technicalInfo"),
            file: t("kf.technical.label.file"),
            files: t("kf.technical.label.files"),
            specsSheet: t("kf.technical.label.specsSheet"),
            guides: t("kf.technical.label.guides"),
            installVideo: t("kf.technical.label.installVideo"),
            helpfulLinks: authorData.sectionHeading ? authorData.sectionHeading : t("kf.technical.label.helpfulLinks"),
            envDeclaration: t("kf.technical.label.envDeclaration"),
            installationGuide: t("kf.technical.label.installationGuide"),
            installationVideo: t("kf.technical.label.installationVideo"),
            userGuide: t("kf.technical.label.userGuide"),
            homeOwnerGuide: t("kf.technical.label.homeOwnerGuide"),
            homeOwnerGuideWithoutSPPDF: t("kf.technical.label.homeOwnerGuideWithoutSPPDF"),
            declareLabel: t("kf.technical.label.declareLabel"),
            tearSheet: t("kf.technical.label.tearSheet"),
            quickReference: t("kf.technical.label.quickReference"),
            warranty: t("kf.technical.label.warranty"),
            serviceParts: t("kf.technical.label.serviceParts"),
            twoDplan: t("kf.technical.label.twoDplan"),
            twoDside: t("kf.technical.label.twoDside"),
            twoDfront: t("kf.technical.label.twoDfront"),
            threeDfile: t("kf.technical.label.threeDfile"),
            bimFile: t("kf.technical.label.bimFile"),
            cutoutTemplate: t("kf.technical.label.cutoutTemplate"),
            partsDiagram: t("kf.pdp.label.partsDiagram"),
            installationGuidesSubTitle: t("kf.technical.label.installationGuidesSubTitle"),
            supportSubTitle: t("kf.technical.label.supportSubTitle"),
            icon: t("kf.technical.label.icon"),
            pdf: t("kf.literature.aria.label.pdf"),
            video: t("kf.technical.label.video"),
            viewMore: t("kf.pdp.label.viewMore")
        },
        baseProduct: t("kf.pdp.label.baseProduct"),
        subTotal: t("kf.pdp.label.subTotal"),
        requiredItems: t("kf.pdp.label.requiredItems"),
        requiredItemsProduct: t("kf.pdp.label.productRequiredItem"),
        requiredItemsPrice: t("kf.pdp.label.priceRequiredItem"),
        zipCodes: t("kf.pdp.lable.zipcode"),
        ingredientsLabel: authorData.ingredientsLabel,
        saveToListText: t("kf.saveToList.save.header"),
        savedToListText: t("kf.saveToList.action.saved"),
        currentPriceAriaLabel: t("kf.pdp.label.currentPrice"),
        deleteFromListText: t("kf.myList.page.pdp.deletefromList"),
        configuratorTitle: configuratorTitle,
        configuratorDesc: configuratorDesc,
        configuratorButtonLabel: configuratorButtonLabel,
        configuratorErrorTitle: configuratorErrorTitle,
        configuratorErrorDesc: configuratorErrorDesc,
        configuratorErrorButtonLabel: configuratorErrorButtonLabel
    };
    return i18n;
};
/* harmony default export */ __webpack_exports__["Z"] = (usePdpi18n);


/***/ }),

/***/ 81294:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24400);

const useSearchi18n = (param)=>{
    let { componentProp  } = param;
    const { t  } = (0,next_i18next__WEBPACK_IMPORTED_MODULE_0__/* .useTranslation */ .$G)();
    const i18n = {
        searchPlaceHolder: t("kf.technical.label.searchPlaceHolder"),
        for: t("kf.search.label.for"),
        searchInstead: t("kf.search.label.searchInstead"),
        showing: t("kf.search.label.showing"),
        results: t("kf.search.label.results"),
        resultsCaps: t("kf.search.label.resultsCaps"),
        addToCart: t("kf.compare.label.addToCart"),
        products: t("kf.search.label.products"),
        parts: t("kf.search.label.parts"),
        technical: t("kf.search.label.technical"),
        inspiration: t("kf.search.label.inspiration"),
        resource: t("kf.search.label.resource"),
        help: t("kf.search.label.help"),
        print: t("kf.plp.label.print"),
        share: t("kf.plp.label.share"),
        wishlist: t("kf.plp.label.wishlist"),
        showFilter: t("kf.plp.label.showFilter"),
        hideFilter: t("kf.plp.label.hideFilter"),
        filters: t("kf.plp.label.filters"),
        filterSort: t("kf.plp.label.filterSort"),
        addToCompare: t("kf.plp.label.addToCompare"),
        colors: t("kf.plp.label.colors"),
        color: t("kf.plp.label.color"),
        view: t("kf.plp.label.view"),
        all: t("kf.plp.label.all"),
        sort: t("kf.plp.label.sort"),
        applyFilters: "Apply Filters",
        loadMore: t("kf.plp.label.loadMore"),
        backToTop: t("kf.plp.label.backToTop"),
        showMore: t("kf.plp.label.showMore"),
        showLess: t("kf.plp.label.showLess"),
        clearAll: t("kf.plp.label.clearAll"),
        priceRangeTitle: t("kf.plp.label.priceRangeTitle"),
        priceRangeDesc: t("kf.plp.label.priceRangeDesc"),
        to: t("kf.plp.label.to"),
        minText: t("kf.plp.label.minText"),
        maxText: t("kf.plp.label.maxText"),
        bestSellers: t("kf.plp.label.bestSellers"),
        featured: t("kf.plp.label.featured"),
        onSale: t("kf.plp.label.onSale"),
        relevancy: t("kf.plp.label.relevancy"),
        date: t("kf.plp.label.date"),
        priceDesc: t("kf.plp.label.priceDesc"),
        priceAsc: t("kf.plp.label.priceAsc"),
        atoz: t("kf.plp.label.atoz"),
        ztoa: t("kf.plp.label.ztoa"),
        gridView: t("kf.plp.label.gridView"),
        columnView: t("kf.plp.label.columnView"),
        sameCategory: t("kf.compare.validation.sameCategory"),
        maxProduct: t("kf.compare.validation.maxProducts"),
        errors: {
            validRange: t("kf.plp.error.validRange"),
            minGreaterThanMax: t("kf.plp.error.minGreaterThanMax"),
            maxGreaterThanZero: t("kf.plp.error.maxGreaterThanZero"),
            checkValid: t("kf.error.message.price")
        },
        new: t("kf.plp.label.new"),
        sale: t("kf.plp.label.sale"),
        category: t("kf.technical.label.category"),
        collection: t("kf.technical.label.collection"),
        certifications: t("kf.technical.label.certifications"),
        designFiles: t("kf.technical.label.designFiles"),
        technicalInfo: t("kf.pdp.label.specs"),
        installationSupport: t("kf.pdp.label.installationSupport"),
        addToFolder: t("kf.technical.label.addToFolder"),
        selectAll: t("kf.technical.label.selectAll"),
        download: t("kf.technical.label.download"),
        hideDiscontinued: t("kf.plp.label.hideDiscontinued"),
        file: t("kf.technical.label.file"),
        files: t("kf.technical.label.files"),
        specsSheet: t("kf.technical.label.specsSheet"),
        envDeclaration: t("kf.technical.label.envDeclaration"),
        installationGuide: t("kf.technical.label.installationGuide"),
        userGuide: t("kf.technical.label.userGuide"),
        homeOwnerGuide: t("kf.technical.label.homeOwnerGuide"),
        declareLabel: t("kf.technical.label.declareLabel"),
        tearSheet: t("kf.technical.label.tearSheet"),
        quickReference: t("kf.technical.label.quickReference"),
        warranty: t("kf.technical.label.warranty"),
        serviceParts: t("kf.technical.label.serviceParts"),
        suggestions: t("kf.search.label.suggestions"),
        checkSpelling: t("kf.search.label.checkSpelling"),
        simplerWord: t("kf.search.label.simplerWord"),
        searchSimilar: t("kf.search.label.searchSimilar"),
        popularSearch: t("kf.search.label.trendingSearch"),
        commonTopics: t("kf.search.label.commonTopics"),
        noResults: t("kf.search.label.noResults"),
        loading: t("kf.search.label.loading"),
        twoDplan: t("kf.technical.label.twoDplan"),
        twoDside: t("kf.technical.label.twoDside"),
        twoDfront: t("kf.technical.label.twoDfront"),
        threeDfile: t("kf.technical.label.threeDfile"),
        bimFile: t("kf.technical.label.bimFile"),
        cutoutTemplate: t("kf.technical.label.cutoutTemplate"),
        viewResults: t("kf.plp.label.viewResults"),
        popularSearchText: t("kf.search.label.trendingSearch"),
        exclusive: t("kf.plp.label.exclusive"),
        newExclusive: t("kf.plp.label.newExclusive"),
        favSuccessMsg: t("kf.favorites.success"),
        favErrorMsg: t("kf.favorites.error"),
        searchBrand: t("kf.search.label.searchBrand"),
        brand: t("kf.search.label.brand"),
        items: t("kf.plp.label.items"),
        etc: t("kf.plp.label.etc"),
        sortbyExpanded: t("kf.plp.label.sortbyExpanded"),
        sortbyClosed: t("kf.plp.label.sortbyClosed"),
        selected: t("kf.plp.arialabel.selected"),
        altSort: t("kf.plp.label.img.altSort"),
        discontinuedText: t("kf.pdp.label.discontinuedTxt"),
        partsDiagram: t("kf.pdp.label.partsDiagram"),
        guides: t("kf.technical.label.guides"),
        sortByAria: (count)=>t("kf.plp.label.sortByAria", {
                sortByCount: count
            }),
        ariaLabel: {
            tabs: (count, tabName)=>t("kf.search.aria.label.tabs", {
                    count,
                    tabName
                }),
            loadMore: t("kf.search.aria.label.loadMore"),
            loadMoreArticles: t("kf.search.aria.label.loadMoreArticles"),
            close: t("kf.search.aria.label.clear"),
            addToCompare: (product)=>t("kf.plp.label.aria.addToCompare", {
                    product
                }),
            currentPage: t("kf.pdp.label.aria.currentPage"),
            page: t("kf.pdp.label.aria.page"),
            columnViewSelected: t("kf.productTab.aria.columnViewSelected"),
            columnViewNotSelected: t("kf.productTab.aria.columnViewNotSelected"),
            gridViewSelected: t("kf.productTab.aria.gridViewSelected"),
            gridViewNotSelected: t("kf.productTab.aria.gridViewNotSelected"),
            breadcrumb: t("kf.pdp.label.aria.breadcrumb")
        },
        home: t("kf.technical.label.home"),
        searchResults: t("kf.technical.label.searchResults"),
        searchText: t("kf.search.label.searchText"),
        searchNoResultErrorMessage: (componentProp === null || componentProp === void 0 ? void 0 : componentProp.searchFilterErrorMsg) ? componentProp === null || componentProp === void 0 ? void 0 : componentProp.searchFilterErrorMsg : t("kf.search.label.noResultsMssg"),
        filterTitle: (facetName, facetCount)=>t("kf.plp.ariaLabel.filterTitle", {
                facetName: facetName,
                facetCount: facetCount
            }),
        arialLabelPrint: t("kf.plp.label.aria.print"),
        ariaLabelShare: t("kf.plp.label.aria.share"),
        favorites: t("kf.account.label.favorites"),
        removeItem: t("kf.favorites.removeItem"),
        downloadSuccess: t("kf.PressRoom.label.downloadSuccess"),
        downloadFailure: t("kf.PressRoom.label.downloadFailure")
    };
    return i18n;
};
/* harmony default export */ __webpack_exports__["Z"] = (useSearchi18n);


/***/ }),

/***/ 30696:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "PW": function() { return /* binding */ getQuantityCount; },
/* harmony export */   "a$": function() { return /* binding */ validatePhone; },
/* harmony export */   "in": function() { return /* binding */ convertToPhoneNumber; },
/* harmony export */   "kD": function() { return /* binding */ getAttributeValue; },
/* harmony export */   "oO": function() { return /* binding */ sanitizeText; },
/* harmony export */   "pD": function() { return /* binding */ getCountryName; },
/* harmony export */   "qs": function() { return /* binding */ getStateName; }
/* harmony export */ });
/* unused harmony exports sanitizeDOMString, checkStock, getStateCode, getCountryCode, validateEmail */
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var dompurify__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27856);
/* harmony import */ var dompurify__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(dompurify__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96301);



const sanitizeText = (text)=>text.replace(/<\/?[^>]+(>|$)/g, "");
const checkStock = (backOrder, category)=>{
    if (!category) return false;
    if (backOrder === true || backOrder === "Yes") return false;
    if (category === "Install Services") return false;
    if (category === "Design Services") return false;
    return true;
};
const getQuantityCount = (data)=>{
    var ref;
    const totalCount = (ref = data === null || data === void 0 ? void 0 : data.filter((item)=>{
        var ref, ref1;
        return !((ref = item.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.bundleParentId);
    })) === null || ref === void 0 ? void 0 : ref.reduce(function(accumulator, item) {
        return accumulator + item.quantity;
    }, 0);
    return totalCount;
};
const sanitizeDOMString = (property)=>typeof property === "string" ? DOMPurify.sanitize(property) : property;
const getStateCode = (stateVal, countryVal, data)=>{
    var ref, ref1;
    let country = {};
    if (data.find((obj)=>obj.code === countryVal)) {
        country = data.find((obj)=>obj.code === countryVal);
    } else {
        var ref2;
        country = (ref2 = data.find((obj)=>obj.name === countryVal)) !== null && ref2 !== void 0 ? ref2 : {};
    }
    if ((ref = country.states) === null || ref === void 0 ? void 0 : ref.find((obj)=>obj.code === stateVal)) return stateVal;
    var ref3;
    const state = (ref3 = (ref1 = country.states) === null || ref1 === void 0 ? void 0 : ref1.find((obj)=>obj.name === stateVal)) !== null && ref3 !== void 0 ? ref3 : {};
    var _code;
    return (_code = state.code) !== null && _code !== void 0 ? _code : "";
};
const getCountryCode = (countryVal, data)=>{
    if (data.find((obj)=>obj.code === countryVal)) return countryVal;
    var ref;
    const country = (ref = data.find((obj)=>obj.name === countryVal)) !== null && ref !== void 0 ? ref : {};
    var _code;
    return (_code = country.code) !== null && _code !== void 0 ? _code : "";
};
const getStateName = (stateVal, countryVal, data)=>{
    var ref, ref1;
    let country = {};
    if (data.find((obj)=>obj.name === countryVal)) {
        country = data.find((obj)=>obj.name === countryVal);
    } else {
        var ref2;
        country = (ref2 = data.find((obj)=>obj.code === countryVal)) !== null && ref2 !== void 0 ? ref2 : {};
    }
    if ((ref = country.states) === null || ref === void 0 ? void 0 : ref.find((obj)=>obj.name === stateVal)) return stateVal;
    var ref3;
    const state = (ref3 = (ref1 = country.states) === null || ref1 === void 0 ? void 0 : ref1.find((obj)=>obj.code === stateVal)) !== null && ref3 !== void 0 ? ref3 : {};
    var _name;
    return (_name = state.name) !== null && _name !== void 0 ? _name : "";
};
const getCountryName = (countryVal, data)=>{
    if (data.find((obj)=>obj.name === countryVal)) return countryVal;
    var ref;
    const country = (ref = data.find((obj)=>obj.code === countryVal)) !== null && ref !== void 0 ? ref : {};
    var _name;
    return (_name = country.name) !== null && _name !== void 0 ? _name : "";
};
const convertToPhoneNumber = (text)=>{
    try {
        if (text) {
            const value = text;
            const x = value.replace(/\D/g, "").match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
            return !x[2] ? "(" + x[1] : "(" + x[1] + ") " + x[2] + (x[3] ? "-" + x[3] : "");
        } else {
            return;
        }
    } catch (error) {
        console.error(error);
    }
};
const validateEmail = (email)=>{
    if (CONSTANTS.REGEX_EMAIL.test(email)) return true;
    return false;
};
const validatePhone = (phone)=>{
    phone = phone.replace("(", "");
    phone = phone.replace(")", "");
    phone = phone.replace(" ", "");
    phone = phone.replace("-", "");
    if (/^\d+$/.test(phone) && phone.length > 9) return true;
    return false;
};
const getAttributeValue = (attributes, name)=>lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(attributes.find((attr)=>attr.name === name), "value", "");



/***/ }),

/***/ 91463:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

const HttpBackend = __webpack_require__(78122);
const ChainedBackend = (__webpack_require__(81580)/* ["default"] */ .Z);
const LocalStorageBackend = (__webpack_require__(70660)/* ["default"] */ .Z);
module.exports = {
    backend: {
        backendOptions: [
            {
                expirationTime: 60 * 60 * 1000
            },
            {
                // need to revisit this block to load dictionaryPath from global config -  currently not possible due to incompatability with cjs modules. need to redefine imports and exports in future
                loadPath: async function(lng, ns) {
                    const dictionaryPath = "/content/kohler.i18nDictionary.json";
                    return "/api/locales/".concat(lng, "/").concat(ns, ".json?path=").concat(dictionaryPath);
                }
            }
        ],
        backends:  true ? [
            LocalStorageBackend,
            HttpBackend
        ] : 0
    },
    i18n: {
        locales: [
            "en",
            "fr"
        ],
        defaultLocale: "en"
    },
    ns: [
        "common"
    ],
    serializeConfig: false,
    use:  true ? [
        ChainedBackend
    ] : 0
};


/***/ }),

/***/ 10227:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.getDomainLocale = getDomainLocale;
const basePath =  false || "";
function getDomainLocale(path, locale, locales, domainLocales) {
    if (true) {
        const normalizeLocalePath = (__webpack_require__(72554).normalizeLocalePath);
        const detectDomainLocale = (__webpack_require__(84643).detectDomainLocale);
        const target = locale || normalizeLocalePath(path, locales).detectedLocale;
        const domain = detectDomainLocale(domainLocales, undefined, target);
        if (domain) {
            const proto = "http".concat(domain.http ? "" : "s", "://");
            const finalLocale = target === domain.defaultLocale ? "" : "/".concat(target);
            return "".concat(proto).concat(domain.domain).concat(basePath).concat(finalLocale).concat(path);
        }
        return false;
    } else {}
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=get-domain-locale.js.map


/***/ }),

/***/ 19749:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

"use client";
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "ImageLoaderProps", ({
    enumerable: true,
    get: function() {
        return _imageConfig.ImageLoaderProps;
    }
}));
exports["default"] = Image;
var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);
var _interop_require_wildcard = (__webpack_require__(91598)/* ["default"] */ .Z);
var _object_without_properties_loose = (__webpack_require__(17273)/* ["default"] */ .Z);
var _react = _interop_require_wildcard(__webpack_require__(67294));
var _head = _interop_require_default(__webpack_require__(83121));
var _imageBlurSvg = __webpack_require__(2675);
var _imageConfig = __webpack_require__(10139);
var _imageConfigContext = __webpack_require__(28730);
var _warnOnce = __webpack_require__(57238);
var _imageLoader = _interop_require_default(__webpack_require__(89824));
function Image(_param) {
    var { src , sizes , unoptimized =false , priority =false , loading , className , quality , width , height , fill , style , onLoad , onLoadingComplete , placeholder ="empty" , blurDataURL , layout , objectFit , objectPosition , lazyBoundary , lazyRoot  } = _param, all = _object_without_properties_loose(_param, [
        "src",
        "sizes",
        "unoptimized",
        "priority",
        "loading",
        "className",
        "quality",
        "width",
        "height",
        "fill",
        "style",
        "onLoad",
        "onLoadingComplete",
        "placeholder",
        "blurDataURL",
        "layout",
        "objectFit",
        "objectPosition",
        "lazyBoundary",
        "lazyRoot"
    ]);
    const configContext = (0, _react).useContext(_imageConfigContext.ImageConfigContext);
    const config = (0, _react).useMemo(()=>{
        const c = configEnv || configContext || _imageConfig.imageConfigDefault;
        const allSizes = [
            ...c.deviceSizes,
            ...c.imageSizes
        ].sort((a, b)=>a - b);
        const deviceSizes = c.deviceSizes.sort((a, b)=>a - b);
        return _extends({}, c, {
            allSizes,
            deviceSizes
        });
    }, [
        configContext
    ]);
    let rest = all;
    let loader = rest.loader || _imageLoader.default;
    // Remove property so it's not spread on <img> element
    delete rest.loader;
    if ("__next_img_default" in loader) {
        // This special value indicates that the user
        // didn't define a "loader" prop or config.
        if (config.loader === "custom") {
            throw new Error('Image with src "'.concat(src, '" is missing "loader" prop.') + "\nRead more: https://nextjs.org/docs/messages/next-image-missing-loader");
        }
    } else {
        // The user defined a "loader" prop or config.
        // Since the config object is internal only, we
        // must not pass it to the user-defined "loader".
        const customImageLoader = loader;
        var _tmp;
        _tmp = (obj)=>{
            const { config: _  } = obj, opts = _object_without_properties_loose(obj, [
                "config"
            ]);
            return customImageLoader(opts);
        }, loader = _tmp, _tmp;
    }
    if (layout) {
        if (layout === "fill") {
            fill = true;
        }
        const layoutToStyle = {
            intrinsic: {
                maxWidth: "100%",
                height: "auto"
            },
            responsive: {
                width: "100%",
                height: "auto"
            }
        };
        const layoutToSizes = {
            responsive: "100vw",
            fill: "100vw"
        };
        const layoutStyle = layoutToStyle[layout];
        if (layoutStyle) {
            style = _extends({}, style, layoutStyle);
        }
        const layoutSizes = layoutToSizes[layout];
        if (layoutSizes && !sizes) {
            sizes = layoutSizes;
        }
    }
    let staticSrc = "";
    let widthInt = getInt(width);
    let heightInt = getInt(height);
    let blurWidth;
    let blurHeight;
    if (isStaticImport(src)) {
        const staticImageData = isStaticRequire(src) ? src.default : src;
        if (!staticImageData.src) {
            throw new Error("An object should only be passed to the image component src parameter if it comes from a static image import. It must include src. Received ".concat(JSON.stringify(staticImageData)));
        }
        if (!staticImageData.height || !staticImageData.width) {
            throw new Error("An object should only be passed to the image component src parameter if it comes from a static image import. It must include height and width. Received ".concat(JSON.stringify(staticImageData)));
        }
        blurWidth = staticImageData.blurWidth;
        blurHeight = staticImageData.blurHeight;
        blurDataURL = blurDataURL || staticImageData.blurDataURL;
        staticSrc = staticImageData.src;
        if (!fill) {
            if (!widthInt && !heightInt) {
                widthInt = staticImageData.width;
                heightInt = staticImageData.height;
            } else if (widthInt && !heightInt) {
                const ratio = widthInt / staticImageData.width;
                heightInt = Math.round(staticImageData.height * ratio);
            } else if (!widthInt && heightInt) {
                const ratio1 = heightInt / staticImageData.height;
                widthInt = Math.round(staticImageData.width * ratio1);
            }
        }
    }
    src = typeof src === "string" ? src : staticSrc;
    let isLazy = !priority && (loading === "lazy" || typeof loading === "undefined");
    if (src.startsWith("data:") || src.startsWith("blob:")) {
        // https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/Data_URIs
        unoptimized = true;
        isLazy = false;
    }
    if (config.unoptimized) {
        unoptimized = true;
    }
    const [blurComplete, setBlurComplete] = (0, _react).useState(false);
    const [showAltText, setShowAltText] = (0, _react).useState(false);
    const qualityInt = getInt(quality);
    if (false) {}
    const imgStyle = Object.assign(fill ? {
        position: "absolute",
        height: "100%",
        width: "100%",
        left: 0,
        top: 0,
        right: 0,
        bottom: 0,
        objectFit,
        objectPosition
    } : {}, showAltText ? {} : {
        color: "transparent"
    }, style);
    const blurStyle = placeholder === "blur" && blurDataURL && !blurComplete ? {
        backgroundSize: imgStyle.objectFit || "cover",
        backgroundPosition: imgStyle.objectPosition || "50% 50%",
        backgroundRepeat: "no-repeat",
        backgroundImage: 'url("data:image/svg+xml;charset=utf-8,'.concat((0, _imageBlurSvg).getImageBlurSvg({
            widthInt,
            heightInt,
            blurWidth,
            blurHeight,
            blurDataURL
        }), '")')
    } : {};
    if (false) {}
    const imgAttributes = generateImgAttrs({
        config,
        src,
        unoptimized,
        width: widthInt,
        quality: qualityInt,
        sizes,
        loader
    });
    let srcString = src;
    if (false) {}
    const linkProps = {
        // @ts-expect-error upgrade react types to react 18
        imageSrcSet: imgAttributes.srcSet,
        imageSizes: imgAttributes.sizes,
        crossOrigin: rest.crossOrigin
    };
    const onLoadRef = (0, _react).useRef(onLoad);
    (0, _react).useEffect(()=>{
        onLoadRef.current = onLoad;
    }, [
        onLoad
    ]);
    const onLoadingCompleteRef = (0, _react).useRef(onLoadingComplete);
    (0, _react).useEffect(()=>{
        onLoadingCompleteRef.current = onLoadingComplete;
    }, [
        onLoadingComplete
    ]);
    const imgElementArgs = _extends({
        isLazy,
        imgAttributes,
        heightInt,
        widthInt,
        qualityInt,
        className,
        imgStyle,
        blurStyle,
        loading,
        config,
        fill,
        unoptimized,
        placeholder,
        loader,
        srcString,
        onLoadRef,
        onLoadingCompleteRef,
        setBlurComplete,
        setShowAltText
    }, rest);
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement(ImageElement, Object.assign({}, imgElementArgs)), priority ? // for browsers that do not support `imagesrcset`, and in those cases
    // it would likely cause the incorrect image to be preloaded.
    //
    // https://html.spec.whatwg.org/multipage/semantics.html#attr-link-imagesrcset
    /*#__PURE__*/ _react.default.createElement(_head.default, null, /*#__PURE__*/ _react.default.createElement("link", Object.assign({
        key: "__nimg-" + imgAttributes.src + imgAttributes.srcSet + imgAttributes.sizes,
        rel: "preload",
        as: "image",
        href: imgAttributes.srcSet ? undefined : imgAttributes.src
    }, linkProps))) : null);
}
"use client";
const configEnv = {"deviceSizes":[640,750,828,1080,1200,1920,2048,3840],"imageSizes":[16,32,48,64,96,128,256,384],"path":"/_next/image","loader":"default","dangerouslyAllowSVG":false,"unoptimized":true};
const allImgs = new Map();
let perfObserver;
if (false) {}
const VALID_LOADING_VALUES = (/* unused pure expression or super */ null && ([
    "lazy",
    "eager",
    undefined
]));
function isStaticRequire(src) {
    return src.default !== undefined;
}
function isStaticImageData(src) {
    return src.src !== undefined;
}
function isStaticImport(src) {
    return typeof src === "object" && (isStaticRequire(src) || isStaticImageData(src));
}
function getWidths(param, width, sizes) {
    let { deviceSizes , allSizes  } = param;
    if (sizes) {
        // Find all the "vw" percent sizes used in the sizes prop
        const viewportWidthRe = /(^|\s)(1?\d?\d)vw/g;
        const percentSizes = [];
        for(let match; match = viewportWidthRe.exec(sizes); match){
            percentSizes.push(parseInt(match[2]));
        }
        if (percentSizes.length) {
            const smallestRatio = Math.min(...percentSizes) * 0.01;
            return {
                widths: allSizes.filter((s)=>s >= deviceSizes[0] * smallestRatio),
                kind: "w"
            };
        }
        return {
            widths: allSizes,
            kind: "w"
        };
    }
    if (typeof width !== "number") {
        return {
            widths: deviceSizes,
            kind: "w"
        };
    }
    const widths = [
        ...new Set(// > are actually 3x in the green color, but only 1.5x in the red and
        // > blue colors. Showing a 3x resolution image in the app vs a 2x
        // > resolution image will be visually the same, though the 3x image
        // > takes significantly more data. Even true 3x resolution screens are
        // > wasteful as the human eye cannot see that level of detail without
        // > something like a magnifying glass.
        // https://blog.twitter.com/engineering/en_us/topics/infrastructure/2019/capping-image-fidelity-on-ultra-high-resolution-devices.html
        [
            width,
            width * 2 /*, width * 3*/ 
        ].map((w)=>allSizes.find((p)=>p >= w) || allSizes[allSizes.length - 1]))
    ];
    return {
        widths,
        kind: "x"
    };
}
function generateImgAttrs(param) {
    let { config , src , unoptimized , width , quality , sizes , loader  } = param;
    if (unoptimized) {
        return {
            src,
            srcSet: undefined,
            sizes: undefined
        };
    }
    const { widths , kind  } = getWidths(config, width, sizes);
    const last = widths.length - 1;
    return {
        sizes: !sizes && kind === "w" ? "100vw" : sizes,
        srcSet: widths.map((w, i)=>"".concat(loader({
                config,
                src,
                quality,
                width: w
            }), " ").concat(kind === "w" ? w : i + 1).concat(kind)).join(", "),
        // It's intended to keep `src` the last attribute because React updates
        // attributes in order. If we keep `src` the first one, Safari will
        // immediately start to fetch `src`, before `sizes` and `srcSet` are even
        // updated by React. That causes multiple unnecessary requests if `srcSet`
        // and `sizes` are defined.
        // This bug cannot be reproduced in Chrome or Firefox.
        src: loader({
            config,
            src,
            quality,
            width: widths[last]
        })
    };
}
function getInt(x) {
    if (typeof x === "number" || typeof x === "undefined") {
        return x;
    }
    if (typeof x === "string" && /^[0-9]+$/.test(x)) {
        return parseInt(x, 10);
    }
    return NaN;
}
// See https://stackoverflow.com/q/39777833/266535 for why we use this ref
// handler instead of the img's onLoad attribute.
function handleLoading(img, src, placeholder, onLoadRef, onLoadingCompleteRef, setBlurComplete, unoptimized) {
    if (!img || img["data-loaded-src"] === src) {
        return;
    }
    img["data-loaded-src"] = src;
    const p = "decode" in img ? img.decode() : Promise.resolve();
    p.catch(()=>{}).then(()=>{
        if (!img.parentNode) {
            // Exit early in case of race condition:
            // - onload() is called
            // - decode() is called but incomplete
            // - unmount is called
            // - decode() completes
            return;
        }
        if (placeholder === "blur") {
            setBlurComplete(true);
        }
        if (onLoadRef == null ? void 0 : onLoadRef.current) {
            // Since we don't have the SyntheticEvent here,
            // we must create one with the same shape.
            // See https://reactjs.org/docs/events.html
            const event = new Event("load");
            Object.defineProperty(event, "target", {
                writable: false,
                value: img
            });
            let prevented = false;
            let stopped = false;
            onLoadRef.current(_extends({}, event, {
                nativeEvent: event,
                currentTarget: img,
                target: img,
                isDefaultPrevented: ()=>prevented,
                isPropagationStopped: ()=>stopped,
                persist: ()=>{},
                preventDefault: ()=>{
                    prevented = true;
                    event.preventDefault();
                },
                stopPropagation: ()=>{
                    stopped = true;
                    event.stopPropagation();
                }
            }));
        }
        if (onLoadingCompleteRef == null ? void 0 : onLoadingCompleteRef.current) {
            onLoadingCompleteRef.current(img);
        }
        if (false) {}
    });
}
const ImageElement = (_param)=>{
    var { imgAttributes , heightInt , widthInt , qualityInt , className , imgStyle , blurStyle , isLazy , fill , placeholder , loading , srcString , config , unoptimized , loader , onLoadRef , onLoadingCompleteRef , setBlurComplete , setShowAltText , onLoad , onError  } = _param, rest = _object_without_properties_loose(_param, [
        "imgAttributes",
        "heightInt",
        "widthInt",
        "qualityInt",
        "className",
        "imgStyle",
        "blurStyle",
        "isLazy",
        "fill",
        "placeholder",
        "loading",
        "srcString",
        "config",
        "unoptimized",
        "loader",
        "onLoadRef",
        "onLoadingCompleteRef",
        "setBlurComplete",
        "setShowAltText",
        "onLoad",
        "onError"
    ]);
    loading = isLazy ? "lazy" : loading;
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement("img", Object.assign({}, rest, imgAttributes, {
        width: widthInt,
        height: heightInt,
        decoding: "async",
        "data-nimg": fill ? "fill" : "1",
        className: className,
        // @ts-ignore - TODO: upgrade to `@types/react@17`
        loading: loading,
        style: _extends({}, imgStyle, blurStyle),
        ref: (0, _react).useCallback((img)=>{
            if (!img) {
                return;
            }
            if (onError) {
                // If the image has an error before react hydrates, then the error is lost.
                // The workaround is to wait until the image is mounted which is after hydration,
                // then we set the src again to trigger the error handler (if there was an error).
                // eslint-disable-next-line no-self-assign
                img.src = img.src;
            }
            if (false) {}
            if (img.complete) {
                handleLoading(img, srcString, placeholder, onLoadRef, onLoadingCompleteRef, setBlurComplete, unoptimized);
            }
        }, [
            srcString,
            placeholder,
            onLoadRef,
            onLoadingCompleteRef,
            setBlurComplete,
            onError,
            unoptimized
        ]),
        onLoad: (event)=>{
            const img = event.currentTarget;
            handleLoading(img, srcString, placeholder, onLoadRef, onLoadingCompleteRef, setBlurComplete, unoptimized);
        },
        onError: (event)=>{
            // if the real image fails to load, this will ensure "alt" is visible
            setShowAltText(true);
            if (placeholder === "blur") {
                // If the real image fails to load, this will still remove the placeholder.
                setBlurComplete(true);
            }
            if (onError) {
                onError(event);
            }
        }
    })));
};
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=image.js.map


/***/ }),

/***/ 31551:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

"use client";
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);
var _object_without_properties_loose = (__webpack_require__(17273)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(67294));
var _router = __webpack_require__(41003);
var _addLocale = __webpack_require__(54465);
var _routerContext = __webpack_require__(72692);
var _appRouterContext = __webpack_require__(48245);
var _useIntersection = __webpack_require__(69246);
var _getDomainLocale = __webpack_require__(10227);
var _addBasePath = __webpack_require__(33468);
"use client";
const prefetched = {};
function prefetch(router, href, as, options) {
    if ( false || !router) return;
    if (!(0, _router).isLocalURL(href)) return;
    // Prefetch the JSON page if asked (only in the client)
    // We need to handle a prefetch error here since we may be
    // loading with priority which can reject but we don't
    // want to force navigation since this is only a prefetch
    Promise.resolve(router.prefetch(href, as, options)).catch((err)=>{
        if (false) {}
    });
    const curLocale = options && typeof options.locale !== "undefined" ? options.locale : router && router.locale;
    // Join on an invalid URI character
    prefetched[href + "%" + as + (curLocale ? "%" + curLocale : "")] = true;
}
function isModifiedEvent(event) {
    const { target  } = event.currentTarget;
    return target && target !== "_self" || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.nativeEvent && event.nativeEvent.which === 2;
}
function linkClicked(e, router, href, as, replace, shallow, scroll, locale, isAppRouter, prefetchEnabled) {
    const { nodeName  } = e.currentTarget;
    // anchors inside an svg have a lowercase nodeName
    const isAnchorNodeName = nodeName.toUpperCase() === "A";
    if (isAnchorNodeName && (isModifiedEvent(e) || !(0, _router).isLocalURL(href))) {
        // ignore click for browser’s default behavior
        return;
    }
    e.preventDefault();
    const navigate = ()=>{
        // If the router is an NextRouter instance it will have `beforePopState`
        if ("beforePopState" in router) {
            router[replace ? "replace" : "push"](href, as, {
                shallow,
                locale,
                scroll
            });
        } else {
            // If `beforePopState` doesn't exist on the router it's the AppRouter.
            const method = replace ? "replace" : "push";
            // Apply `as` if it's provided.
            router[method](as || href, {
                forceOptimisticNavigation: !prefetchEnabled
            });
        }
    };
    if (isAppRouter) {
        // @ts-expect-error startTransition exists.
        _react.default.startTransition(navigate);
    } else {
        navigate();
    }
}
/**
 * React Component that enables client-side transitions between routes.
 */ const Link = /*#__PURE__*/ _react.default.forwardRef(function LinkComponent(props, forwardedRef) {
    if (false) {}
    let children;
    const { href: hrefProp , as: asProp , children: childrenProp , prefetch: prefetchProp , passHref , replace , shallow , scroll , locale , onClick , onMouseEnter , onTouchStart , legacyBehavior =Boolean(true) !== true  } = props, restProps = _object_without_properties_loose(props, [
        "href",
        "as",
        "children",
        "prefetch",
        "passHref",
        "replace",
        "shallow",
        "scroll",
        "locale",
        "onClick",
        "onMouseEnter",
        "onTouchStart",
        "legacyBehavior"
    ]);
    children = childrenProp;
    if (legacyBehavior && (typeof children === "string" || typeof children === "number")) {
        children = /*#__PURE__*/ _react.default.createElement("a", null, children);
    }
    const p = prefetchProp !== false;
    let router = _react.default.useContext(_routerContext.RouterContext);
    // TODO-APP: type error. Remove `as any`
    const appRouter = _react.default.useContext(_appRouterContext.AppRouterContext);
    if (appRouter) {
        router = appRouter;
    }
    const { href , as  } = _react.default.useMemo(()=>{
        const [resolvedHref, resolvedAs] = (0, _router).resolveHref(router, hrefProp, true);
        return {
            href: resolvedHref,
            as: asProp ? (0, _router).resolveHref(router, asProp) : resolvedAs || resolvedHref
        };
    }, [
        router,
        hrefProp,
        asProp
    ]);
    const previousHref = _react.default.useRef(href);
    const previousAs = _react.default.useRef(as);
    // This will return the first child, if multiple are provided it will throw an error
    let child;
    if (legacyBehavior) {
        if (false) {} else {
            child = _react.default.Children.only(children);
        }
    } else {
        if (false) { var ref; }
    }
    const childRef = legacyBehavior ? child && typeof child === "object" && child.ref : forwardedRef;
    const [setIntersectionRef, isVisible, resetVisible] = (0, _useIntersection).useIntersection({
        rootMargin: "200px"
    });
    const setRef = _react.default.useCallback((el)=>{
        // Before the link getting observed, check if visible state need to be reset
        if (previousAs.current !== as || previousHref.current !== href) {
            resetVisible();
            previousAs.current = as;
            previousHref.current = href;
        }
        setIntersectionRef(el);
        if (childRef) {
            if (typeof childRef === "function") childRef(el);
            else if (typeof childRef === "object") {
                childRef.current = el;
            }
        }
    }, [
        as,
        childRef,
        href,
        resetVisible,
        setIntersectionRef
    ]);
    _react.default.useEffect(()=>{
        const shouldPrefetch = isVisible && p && (0, _router).isLocalURL(href);
        const curLocale = typeof locale !== "undefined" ? locale : router && router.locale;
        const isPrefetched = prefetched[href + "%" + as + (curLocale ? "%" + curLocale : "")];
        if (shouldPrefetch && !isPrefetched) {
            prefetch(router, href, as, {
                locale: curLocale
            });
        }
    }, [
        as,
        href,
        isVisible,
        locale,
        p,
        router
    ]);
    const childProps = {
        ref: setRef,
        onClick: (e)=>{
            if (false) {}
            if (!legacyBehavior && typeof onClick === "function") {
                onClick(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onClick === "function") {
                child.props.onClick(e);
            }
            if (!e.defaultPrevented) {
                linkClicked(e, router, href, as, replace, shallow, scroll, locale, Boolean(appRouter), p);
            }
        },
        onMouseEnter: (e)=>{
            if (!legacyBehavior && typeof onMouseEnter === "function") {
                onMouseEnter(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onMouseEnter === "function") {
                child.props.onMouseEnter(e);
            }
            // Check for not prefetch disabled in page using appRouter
            if (!(!p && appRouter)) {
                if ((0, _router).isLocalURL(href)) {
                    prefetch(router, href, as, {
                        priority: true
                    });
                }
            }
        },
        onTouchStart: (e)=>{
            if (!legacyBehavior && typeof onTouchStart === "function") {
                onTouchStart(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onTouchStart === "function") {
                child.props.onTouchStart(e);
            }
            // Check for not prefetch disabled in page using appRouter
            if (!(!p && appRouter)) {
                if ((0, _router).isLocalURL(href)) {
                    prefetch(router, href, as, {
                        priority: true
                    });
                }
            }
        }
    };
    // If child is an <a> tag and doesn't have a href attribute, or if the 'passHref' property is
    // defined, we specify the current 'href', so that repetition is not needed by the user
    if (!legacyBehavior || passHref || child.type === "a" && !("href" in child.props)) {
        const curLocale = typeof locale !== "undefined" ? locale : router && router.locale;
        // we only render domain locales if we are currently on a domain locale
        // so that locale links are still visitable in development/preview envs
        const localeDomain = router && router.isLocaleDomain && (0, _getDomainLocale).getDomainLocale(as, curLocale, router.locales, router.domainLocales);
        childProps.href = localeDomain || (0, _addBasePath).addBasePath((0, _addLocale).addLocale(as, curLocale, router && router.defaultLocale));
    }
    return legacyBehavior ? /*#__PURE__*/ _react.default.cloneElement(child, childProps) : /*#__PURE__*/ _react.default.createElement("a", Object.assign({}, restProps, childProps), children);
});
var _default = Link;
exports["default"] = _default;
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=link.js.map


/***/ }),

/***/ 72554:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.normalizeLocalePath = void 0;
const normalizeLocalePath = (pathname, locales)=>{
    if (true) {
        return (__webpack_require__(24769).normalizeLocalePath)(pathname, locales);
    }
    return {
        pathname,
        detectedLocale: undefined
    };
};
exports.normalizeLocalePath = normalizeLocalePath;
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=normalize-locale-path.js.map


/***/ }),

/***/ 69246:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.useIntersection = useIntersection;
var _react = __webpack_require__(67294);
var _requestIdleCallback = __webpack_require__(44686);
const hasIntersectionObserver = typeof IntersectionObserver === "function";
const observers = new Map();
const idList = [];
function createObserver(options) {
    const id = {
        root: options.root || null,
        margin: options.rootMargin || ""
    };
    const existing = idList.find((obj)=>obj.root === id.root && obj.margin === id.margin);
    let instance;
    if (existing) {
        instance = observers.get(existing);
        if (instance) {
            return instance;
        }
    }
    const elements = new Map();
    const observer = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            const callback = elements.get(entry.target);
            const isVisible = entry.isIntersecting || entry.intersectionRatio > 0;
            if (callback && isVisible) {
                callback(isVisible);
            }
        });
    }, options);
    instance = {
        id,
        observer,
        elements
    };
    idList.push(id);
    observers.set(id, instance);
    return instance;
}
function observe(element, callback, options) {
    const { id , observer , elements  } = createObserver(options);
    elements.set(element, callback);
    observer.observe(element);
    return function unobserve() {
        elements.delete(element);
        observer.unobserve(element);
        // Destroy observer when there's nothing left to watch:
        if (elements.size === 0) {
            observer.disconnect();
            observers.delete(id);
            const index = idList.findIndex((obj)=>obj.root === id.root && obj.margin === id.margin);
            if (index > -1) {
                idList.splice(index, 1);
            }
        }
    };
}
function useIntersection(param) {
    let { rootRef , rootMargin , disabled  } = param;
    const isDisabled = disabled || !hasIntersectionObserver;
    const [visible, setVisible] = (0, _react).useState(false);
    const [element, setElement] = (0, _react).useState(null);
    (0, _react).useEffect(()=>{
        if (hasIntersectionObserver) {
            if (isDisabled || visible) return;
            if (element && element.tagName) {
                const unobserve = observe(element, (isVisible)=>isVisible && setVisible(isVisible), {
                    root: rootRef == null ? void 0 : rootRef.current,
                    rootMargin
                });
                return unobserve;
            }
        } else {
            if (!visible) {
                const idleCallback = (0, _requestIdleCallback).requestIdleCallback(()=>setVisible(true));
                return ()=>(0, _requestIdleCallback).cancelIdleCallback(idleCallback);
            }
        }
    }, [
        element,
        isDisabled,
        rootMargin,
        rootRef,
        visible
    ]);
    const resetVisible = (0, _react).useCallback(()=>{
        setVisible(false);
    }, []);
    return [
        setElement,
        visible,
        resetVisible
    ];
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=use-intersection.js.map


/***/ }),

/***/ 48245:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

"use client";
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.TemplateContext = exports.GlobalLayoutRouterContext = exports.LayoutRouterContext = exports.AppRouterContext = void 0;
var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(67294));
"use client";
const AppRouterContext = _react.default.createContext(null);
exports.AppRouterContext = AppRouterContext;
const LayoutRouterContext = _react.default.createContext(null);
exports.LayoutRouterContext = LayoutRouterContext;
const GlobalLayoutRouterContext = _react.default.createContext(null);
exports.GlobalLayoutRouterContext = GlobalLayoutRouterContext;
const TemplateContext = _react.default.createContext(null);
exports.TemplateContext = TemplateContext;
if (false) {} //# sourceMappingURL=app-router-context.js.map


/***/ }),

/***/ 37645:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = dynamic;
exports.noSSR = noSSR;
var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(67294));
var _loadable = _interop_require_default(__webpack_require__(14588));
function dynamic(dynamicOptions, options) {
    let loadableFn = _loadable.default;
    let loadableOptions = (options == null ? void 0 : options.suspense) ? {} : {
        // A loading component is not required, so we default it
        loading: (param)=>{
            let { error , isLoading , pastDelay  } = param;
            if (!pastDelay) return null;
            if (false) {}
            return null;
        }
    };
    // Support for direct import(), eg: dynamic(import('../hello-world'))
    // Note that this is only kept for the edge case where someone is passing in a promise as first argument
    // The react-loadable babel plugin will turn dynamic(import('../hello-world')) into dynamic(() => import('../hello-world'))
    // To make sure we don't execute the import without rendering first
    if (dynamicOptions instanceof Promise) {
        loadableOptions.loader = ()=>dynamicOptions;
    // Support for having import as a function, eg: dynamic(() => import('../hello-world'))
    } else if (typeof dynamicOptions === "function") {
        loadableOptions.loader = dynamicOptions;
    // Support for having first argument being options, eg: dynamic({loader: import('../hello-world')})
    } else if (typeof dynamicOptions === "object") {
        loadableOptions = _extends({}, loadableOptions, dynamicOptions);
    }
    // Support for passing options, eg: dynamic(import('../hello-world'), {loading: () => <p>Loading something</p>})
    loadableOptions = _extends({}, loadableOptions, options);
    if (loadableOptions.suspense) {
        if (false) {}
        delete loadableOptions.ssr;
        delete loadableOptions.loading;
    }
    // coming from build/babel/plugins/react-loadable-plugin.js
    if (loadableOptions.loadableGenerated) {
        loadableOptions = _extends({}, loadableOptions, loadableOptions.loadableGenerated);
        delete loadableOptions.loadableGenerated;
    }
    // support for disabling server side rendering, eg: dynamic(import('../hello-world'), {ssr: false}).
    // skip `ssr` for suspense mode and opt-in React.lazy directly
    if (typeof loadableOptions.ssr === "boolean" && !loadableOptions.suspense) {
        if (!loadableOptions.ssr) {
            delete loadableOptions.ssr;
            return noSSR(loadableFn, loadableOptions);
        }
        delete loadableOptions.ssr;
    }
    return loadableFn(loadableOptions);
}
const isServerSide = "object" === "undefined";
function noSSR(LoadableInitializer, loadableOptions) {
    // Removing webpack and modules means react-loadable won't try preloading
    delete loadableOptions.webpack;
    delete loadableOptions.modules;
    // This check is necessary to prevent react-loadable from initializing on the server
    if (!isServerSide) {
        return LoadableInitializer(loadableOptions);
    }
    const Loading = loadableOptions.loading;
    // This will only be rendered on the server side
    return ()=>/*#__PURE__*/ _react.default.createElement(Loading, {
            error: null,
            isLoading: true,
            pastDelay: false,
            timedOut: false
        });
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=dynamic.js.map


/***/ }),

/***/ 2675:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.getImageBlurSvg = getImageBlurSvg;
function getImageBlurSvg(param) {
    let { widthInt , heightInt , blurWidth , blurHeight , blurDataURL  } = param;
    const std = blurWidth && blurHeight ? "1" : "20";
    const svgWidth = blurWidth || widthInt;
    const svgHeight = blurHeight || heightInt;
    const feComponentTransfer = blurDataURL.startsWith("data:image/jpeg") ? "%3CfeComponentTransfer%3E%3CfeFuncA type='discrete' tableValues='1 1'/%3E%3C/feComponentTransfer%3E%" : "";
    if (svgWidth && svgHeight) {
        return "%3Csvg xmlns='http%3A//www.w3.org/2000/svg' viewBox='0 0 ".concat(svgWidth, " ").concat(svgHeight, "'%3E%3Cfilter id='b' color-interpolation-filters='sRGB'%3E%3CfeGaussianBlur stdDeviation='").concat(std, "'/%3E").concat(feComponentTransfer, "%3C/filter%3E%3Cimage preserveAspectRatio='none' filter='url(%23b)' x='0' y='0' height='100%25' width='100%25' href='").concat(blurDataURL, "'/%3E%3C/svg%3E");
    }
    return "%3Csvg xmlns='http%3A//www.w3.org/2000/svg'%3E%3Cimage style='filter:blur(20px)' x='0' y='0' height='100%25' width='100%25' href='".concat(blurDataURL, "'/%3E%3C/svg%3E");
} //# sourceMappingURL=image-blur-svg.js.map


/***/ }),

/***/ 89824:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
function defaultLoader(param) {
    let { config , src , width , quality  } = param;
    if (false) {}
    if (src.endsWith(".svg") && !config.dangerouslyAllowSVG) {
        // Special case to make svg serve as-is to avoid proxying
        // through the built-in Image Optimization API.
        return src;
    }
    return "".concat(config.path, "?url=").concat(encodeURIComponent(src), "&w=").concat(width, "&q=").concat(quality || 75);
}
// We use this to determine if the import is the default loader
// or a custom loader defined by the user in next.config.js
defaultLoader.__next_img_default = true;
var _default = defaultLoader;
exports["default"] = _default; //# sourceMappingURL=image-loader.js.map


/***/ }),

/***/ 33644:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.LoadableContext = void 0;
var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(67294));
const LoadableContext = _react.default.createContext(null);
exports.LoadableContext = LoadableContext;
if (false) {} //# sourceMappingURL=loadable-context.js.map


/***/ }),

/***/ 14588:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);
var _interop_require_wildcard = (__webpack_require__(91598)/* ["default"] */ .Z);
var _react = _interop_require_wildcard(__webpack_require__(67294));
var _loadableContext = __webpack_require__(33644);
const ALL_INITIALIZERS = [];
const READY_INITIALIZERS = [];
let initialized = false;
function load(loader) {
    let promise = loader();
    let state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then((loaded)=>{
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch((err)=>{
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function createLoadableComponent(loadFn, options) {
    let opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        webpack: null,
        modules: null,
        suspense: false
    }, options);
    if (opts.suspense) {
        opts.lazy = _react.default.lazy(opts.loader);
    }
    /** @type LoadableSubscription */ let subscription = null;
    function init() {
        if (!subscription) {
            const sub = new LoadableSubscription(loadFn, opts);
            subscription = {
                getCurrentValue: sub.getCurrentValue.bind(sub),
                subscribe: sub.subscribe.bind(sub),
                retry: sub.retry.bind(sub),
                promise: sub.promise.bind(sub)
            };
        }
        return subscription.promise();
    }
    // Server only
    if (false) {}
    // Client only
    if (!initialized && "object" !== "undefined") {
        // require.resolveWeak check is needed for environments that don't have it available like Jest
        const moduleIds = opts.webpack && "function" === "function" ? opts.webpack() : opts.modules;
        if (moduleIds) {
            READY_INITIALIZERS.push((ids)=>{
                for (const moduleId of moduleIds){
                    if (ids.indexOf(moduleId) !== -1) {
                        return init();
                    }
                }
            });
        }
    }
    function useLoadableModule() {
        init();
        const context = _react.default.useContext(_loadableContext.LoadableContext);
        if (context && Array.isArray(opts.modules)) {
            opts.modules.forEach((moduleName)=>{
                context(moduleName);
            });
        }
    }
    function LoadableImpl(props, ref) {
        useLoadableModule();
        const state = (0, _react).useSyncExternalStore(subscription.subscribe, subscription.getCurrentValue, subscription.getCurrentValue);
        _react.default.useImperativeHandle(ref, ()=>({
                retry: subscription.retry
            }), []);
        return _react.default.useMemo(()=>{
            if (state.loading || state.error) {
                return _react.default.createElement(opts.loading, {
                    isLoading: state.loading,
                    pastDelay: state.pastDelay,
                    timedOut: state.timedOut,
                    error: state.error,
                    retry: subscription.retry
                });
            } else if (state.loaded) {
                return _react.default.createElement(resolve(state.loaded), props);
            } else {
                return null;
            }
        }, [
            props,
            state
        ]);
    }
    function LazyImpl(props, ref) {
        useLoadableModule();
        return _react.default.createElement(opts.lazy, _extends({}, props, {
            ref
        }));
    }
    const LoadableComponent = opts.suspense ? LazyImpl : LoadableImpl;
    LoadableComponent.preload = ()=>init();
    LoadableComponent.displayName = "LoadableComponent";
    return _react.default.forwardRef(LoadableComponent);
}
class LoadableSubscription {
    promise() {
        return this._res.promise;
    }
    retry() {
        this._clearTimeouts();
        this._res = this._loadFn(this._opts.loader);
        this._state = {
            pastDelay: false,
            timedOut: false
        };
        const { _res: res , _opts: opts  } = this;
        if (res.loading) {
            if (typeof opts.delay === "number") {
                if (opts.delay === 0) {
                    this._state.pastDelay = true;
                } else {
                    this._delay = setTimeout(()=>{
                        this._update({
                            pastDelay: true
                        });
                    }, opts.delay);
                }
            }
            if (typeof opts.timeout === "number") {
                this._timeout = setTimeout(()=>{
                    this._update({
                        timedOut: true
                    });
                }, opts.timeout);
            }
        }
        this._res.promise.then(()=>{
            this._update({});
            this._clearTimeouts();
        }).catch((_err)=>{
            this._update({});
            this._clearTimeouts();
        });
        this._update({});
    }
    _update(partial) {
        this._state = _extends({}, this._state, {
            error: this._res.error,
            loaded: this._res.loaded,
            loading: this._res.loading
        }, partial);
        this._callbacks.forEach((callback)=>callback());
    }
    _clearTimeouts() {
        clearTimeout(this._delay);
        clearTimeout(this._timeout);
    }
    getCurrentValue() {
        return this._state;
    }
    subscribe(callback) {
        this._callbacks.add(callback);
        return ()=>{
            this._callbacks.delete(callback);
        };
    }
    constructor(loadFn, opts){
        this._loadFn = loadFn;
        this._opts = opts;
        this._callbacks = new Set();
        this._delay = null;
        this._timeout = null;
        this.retry();
    }
}
function Loadable(opts) {
    return createLoadableComponent(load, opts);
}
function flushInitializers(initializers, ids) {
    let promises = [];
    while(initializers.length){
        let init = initializers.pop();
        promises.push(init(ids));
    }
    return Promise.all(promises).then(()=>{
        if (initializers.length) {
            return flushInitializers(initializers, ids);
        }
    });
}
Loadable.preloadAll = ()=>{
    return new Promise((resolveInitializers, reject)=>{
        flushInitializers(ALL_INITIALIZERS).then(resolveInitializers, reject);
    });
};
Loadable.preloadReady = function() {
    let ids = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return new Promise((resolvePreload)=>{
        const res = ()=>{
            initialized = true;
            return resolvePreload();
        };
        // We always will resolve, errors should be handled within loading UIs.
        flushInitializers(READY_INITIALIZERS, ids).then(res, res);
    });
};
if (true) {
    window.__NEXT_PRELOADREADY = Loadable.preloadReady;
}
var _default = Loadable;
exports["default"] = _default; //# sourceMappingURL=loadable.js.map


/***/ }),

/***/ 82470:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;
/* provided dependency */ var process = __webpack_require__(83454);
__webpack_require__(2350);
var React = __webpack_require__(67294);
function _interopDefaultLegacy(e) {
    return e && typeof e === "object" && "default" in e ? e : {
        "default": e
    };
}
var React__default = /*#__PURE__*/ _interopDefaultLegacy(React);
/*
Based on Glamor's sheet
https://github.com/threepointone/glamor/blob/667b480d31b3721a905021b26e1290ce92ca2879/src/sheet.js
*/ function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
var isProd = typeof process !== "undefined" && process.env && "production" === "production";
var isString = function(o) {
    return Object.prototype.toString.call(o) === "[object String]";
};
var StyleSheet = /*#__PURE__*/ function() {
    function StyleSheet(param) {
        var ref = param === void 0 ? {} : param, _name = ref.name, name = _name === void 0 ? "stylesheet" : _name, _optimizeForSpeed = ref.optimizeForSpeed, optimizeForSpeed = _optimizeForSpeed === void 0 ? isProd : _optimizeForSpeed;
        invariant$1(isString(name), "`name` must be a string");
        this._name = name;
        this._deletedRulePlaceholder = "#" + name + "-deleted-rule____{}";
        invariant$1(typeof optimizeForSpeed === "boolean", "`optimizeForSpeed` must be a boolean");
        this._optimizeForSpeed = optimizeForSpeed;
        this._serverSheet = undefined;
        this._tags = [];
        this._injected = false;
        this._rulesCount = 0;
        var node =  true && document.querySelector('meta[property="csp-nonce"]');
        this._nonce = node ? node.getAttribute("content") : null;
    }
    var _proto = StyleSheet.prototype;
    _proto.setOptimizeForSpeed = function setOptimizeForSpeed(bool) {
        invariant$1(typeof bool === "boolean", "`setOptimizeForSpeed` accepts a boolean");
        invariant$1(this._rulesCount === 0, "optimizeForSpeed cannot be when rules have already been inserted");
        this.flush();
        this._optimizeForSpeed = bool;
        this.inject();
    };
    _proto.isOptimizeForSpeed = function isOptimizeForSpeed() {
        return this._optimizeForSpeed;
    };
    _proto.inject = function inject() {
        var _this = this;
        invariant$1(!this._injected, "sheet already injected");
        this._injected = true;
        if ( true && this._optimizeForSpeed) {
            this._tags[0] = this.makeStyleTag(this._name);
            this._optimizeForSpeed = "insertRule" in this.getSheet();
            if (!this._optimizeForSpeed) {
                if (!isProd) {
                    console.warn("StyleSheet: optimizeForSpeed mode not supported falling back to standard mode.");
                }
                this.flush();
                this._injected = true;
            }
            return;
        }
        this._serverSheet = {
            cssRules: [],
            insertRule: function(rule, index) {
                if (typeof index === "number") {
                    _this._serverSheet.cssRules[index] = {
                        cssText: rule
                    };
                } else {
                    _this._serverSheet.cssRules.push({
                        cssText: rule
                    });
                }
                return index;
            },
            deleteRule: function(index) {
                _this._serverSheet.cssRules[index] = null;
            }
        };
    };
    _proto.getSheetForTag = function getSheetForTag(tag) {
        if (tag.sheet) {
            return tag.sheet;
        }
        // this weirdness brought to you by firefox
        for(var i = 0; i < document.styleSheets.length; i++){
            if (document.styleSheets[i].ownerNode === tag) {
                return document.styleSheets[i];
            }
        }
    };
    _proto.getSheet = function getSheet() {
        return this.getSheetForTag(this._tags[this._tags.length - 1]);
    };
    _proto.insertRule = function insertRule(rule, index) {
        invariant$1(isString(rule), "`insertRule` accepts only strings");
        if (false) {}
        if (this._optimizeForSpeed) {
            var sheet = this.getSheet();
            if (typeof index !== "number") {
                index = sheet.cssRules.length;
            }
            // this weirdness for perf, and chrome's weird bug
            // https://stackoverflow.com/questions/20007992/chrome-suddenly-stopped-accepting-insertrule
            try {
                sheet.insertRule(rule, index);
            } catch (error) {
                if (!isProd) {
                    console.warn("StyleSheet: illegal rule: \n\n" + rule + "\n\nSee https://stackoverflow.com/q/20007992 for more info");
                }
                return -1;
            }
        } else {
            var insertionPoint = this._tags[index];
            this._tags.push(this.makeStyleTag(this._name, rule, insertionPoint));
        }
        return this._rulesCount++;
    };
    _proto.replaceRule = function replaceRule(index, rule) {
        if (this._optimizeForSpeed || "object" === "undefined") {
            var sheet =  true ? this.getSheet() : 0;
            if (!rule.trim()) {
                rule = this._deletedRulePlaceholder;
            }
            if (!sheet.cssRules[index]) {
                // @TBD Should we throw an error?
                return index;
            }
            sheet.deleteRule(index);
            try {
                sheet.insertRule(rule, index);
            } catch (error) {
                if (!isProd) {
                    console.warn("StyleSheet: illegal rule: \n\n" + rule + "\n\nSee https://stackoverflow.com/q/20007992 for more info");
                }
                // In order to preserve the indices we insert a deleteRulePlaceholder
                sheet.insertRule(this._deletedRulePlaceholder, index);
            }
        } else {
            var tag = this._tags[index];
            invariant$1(tag, "old rule at index `" + index + "` not found");
            tag.textContent = rule;
        }
        return index;
    };
    _proto.deleteRule = function deleteRule(index) {
        if (false) {}
        if (this._optimizeForSpeed) {
            this.replaceRule(index, "");
        } else {
            var tag = this._tags[index];
            invariant$1(tag, "rule at index `" + index + "` not found");
            tag.parentNode.removeChild(tag);
            this._tags[index] = null;
        }
    };
    _proto.flush = function flush() {
        this._injected = false;
        this._rulesCount = 0;
        if (true) {
            this._tags.forEach(function(tag) {
                return tag && tag.parentNode.removeChild(tag);
            });
            this._tags = [];
        } else {}
    };
    _proto.cssRules = function cssRules() {
        var _this = this;
        if (false) {}
        return this._tags.reduce(function(rules, tag) {
            if (tag) {
                rules = rules.concat(Array.prototype.map.call(_this.getSheetForTag(tag).cssRules, function(rule) {
                    return rule.cssText === _this._deletedRulePlaceholder ? null : rule;
                }));
            } else {
                rules.push(null);
            }
            return rules;
        }, []);
    };
    _proto.makeStyleTag = function makeStyleTag(name, cssString, relativeToTag) {
        if (cssString) {
            invariant$1(isString(cssString), "makeStyleTag accepts only strings as second parameter");
        }
        var tag = document.createElement("style");
        if (this._nonce) tag.setAttribute("nonce", this._nonce);
        tag.type = "text/css";
        tag.setAttribute("data-" + name, "");
        if (cssString) {
            tag.appendChild(document.createTextNode(cssString));
        }
        var head = document.head || document.getElementsByTagName("head")[0];
        if (relativeToTag) {
            head.insertBefore(tag, relativeToTag);
        } else {
            head.appendChild(tag);
        }
        return tag;
    };
    _createClass(StyleSheet, [
        {
            key: "length",
            get: function get() {
                return this._rulesCount;
            }
        }
    ]);
    return StyleSheet;
}();
function invariant$1(condition, message) {
    if (!condition) {
        throw new Error("StyleSheet: " + message + ".");
    }
}
function hash(str) {
    var _$hash = 5381, i = str.length;
    while(i){
        _$hash = _$hash * 33 ^ str.charCodeAt(--i);
    }
    /* JavaScript does bitwise operations (like XOR, above) on 32-bit signed
   * integers. Since we want the results to be always positive, convert the
   * signed int to an unsigned by doing an unsigned bitshift. */ return _$hash >>> 0;
}
var stringHash = hash;
var sanitize = function(rule) {
    return rule.replace(/\/style/gi, "\\/style");
};
var cache = {};
/**
 * computeId
 *
 * Compute and memoize a jsx id from a basedId and optionally props.
 */ function computeId(baseId, props) {
    if (!props) {
        return "jsx-" + baseId;
    }
    var propsToString = String(props);
    var key = baseId + propsToString;
    if (!cache[key]) {
        cache[key] = "jsx-" + stringHash(baseId + "-" + propsToString);
    }
    return cache[key];
}
/**
 * computeSelector
 *
 * Compute and memoize dynamic selectors.
 */ function computeSelector(id, css) {
    var selectoPlaceholderRegexp = /__jsx-style-dynamic-selector/g;
    // Sanitize SSR-ed CSS.
    // Client side code doesn't need to be sanitized since we use
    // document.createTextNode (dev) and the CSSOM api sheet.insertRule (prod).
    if (false) {}
    var idcss = id + css;
    if (!cache[idcss]) {
        cache[idcss] = css.replace(selectoPlaceholderRegexp, id);
    }
    return cache[idcss];
}
function mapRulesToStyle(cssRules, options) {
    if (options === void 0) options = {};
    return cssRules.map(function(args) {
        var id = args[0];
        var css = args[1];
        return /*#__PURE__*/ React__default["default"].createElement("style", {
            id: "__" + id,
            // Avoid warnings upon render with a key
            key: "__" + id,
            nonce: options.nonce ? options.nonce : undefined,
            dangerouslySetInnerHTML: {
                __html: css
            }
        });
    });
}
var StyleSheetRegistry = /*#__PURE__*/ function() {
    function StyleSheetRegistry(param) {
        var ref = param === void 0 ? {} : param, _styleSheet = ref.styleSheet, styleSheet = _styleSheet === void 0 ? null : _styleSheet, _optimizeForSpeed = ref.optimizeForSpeed, optimizeForSpeed = _optimizeForSpeed === void 0 ? false : _optimizeForSpeed;
        this._sheet = styleSheet || new StyleSheet({
            name: "styled-jsx",
            optimizeForSpeed: optimizeForSpeed
        });
        this._sheet.inject();
        if (styleSheet && typeof optimizeForSpeed === "boolean") {
            this._sheet.setOptimizeForSpeed(optimizeForSpeed);
            this._optimizeForSpeed = this._sheet.isOptimizeForSpeed();
        }
        this._fromServer = undefined;
        this._indices = {};
        this._instancesCounts = {};
    }
    var _proto = StyleSheetRegistry.prototype;
    _proto.add = function add(props) {
        var _this = this;
        if (undefined === this._optimizeForSpeed) {
            this._optimizeForSpeed = Array.isArray(props.children);
            this._sheet.setOptimizeForSpeed(this._optimizeForSpeed);
            this._optimizeForSpeed = this._sheet.isOptimizeForSpeed();
        }
        if ( true && !this._fromServer) {
            this._fromServer = this.selectFromServer();
            this._instancesCounts = Object.keys(this._fromServer).reduce(function(acc, tagName) {
                acc[tagName] = 0;
                return acc;
            }, {});
        }
        var ref = this.getIdAndRules(props), styleId = ref.styleId, rules = ref.rules;
        // Deduping: just increase the instances count.
        if (styleId in this._instancesCounts) {
            this._instancesCounts[styleId] += 1;
            return;
        }
        var indices = rules.map(function(rule) {
            return _this._sheet.insertRule(rule);
        }) // Filter out invalid rules
        .filter(function(index) {
            return index !== -1;
        });
        this._indices[styleId] = indices;
        this._instancesCounts[styleId] = 1;
    };
    _proto.remove = function remove(props) {
        var _this = this;
        var styleId = this.getIdAndRules(props).styleId;
        invariant(styleId in this._instancesCounts, "styleId: `" + styleId + "` not found");
        this._instancesCounts[styleId] -= 1;
        if (this._instancesCounts[styleId] < 1) {
            var tagFromServer = this._fromServer && this._fromServer[styleId];
            if (tagFromServer) {
                tagFromServer.parentNode.removeChild(tagFromServer);
                delete this._fromServer[styleId];
            } else {
                this._indices[styleId].forEach(function(index) {
                    return _this._sheet.deleteRule(index);
                });
                delete this._indices[styleId];
            }
            delete this._instancesCounts[styleId];
        }
    };
    _proto.update = function update(props, nextProps) {
        this.add(nextProps);
        this.remove(props);
    };
    _proto.flush = function flush() {
        this._sheet.flush();
        this._sheet.inject();
        this._fromServer = undefined;
        this._indices = {};
        this._instancesCounts = {};
    };
    _proto.cssRules = function cssRules() {
        var _this = this;
        var fromServer = this._fromServer ? Object.keys(this._fromServer).map(function(styleId) {
            return [
                styleId,
                _this._fromServer[styleId]
            ];
        }) : [];
        var cssRules = this._sheet.cssRules();
        return fromServer.concat(Object.keys(this._indices).map(function(styleId) {
            return [
                styleId,
                _this._indices[styleId].map(function(index) {
                    return cssRules[index].cssText;
                }).join(_this._optimizeForSpeed ? "" : "\n")
            ];
        }) // filter out empty rules
        .filter(function(rule) {
            return Boolean(rule[1]);
        }));
    };
    _proto.styles = function styles(options) {
        return mapRulesToStyle(this.cssRules(), options);
    };
    _proto.getIdAndRules = function getIdAndRules(props) {
        var css = props.children, dynamic = props.dynamic, id = props.id;
        if (dynamic) {
            var styleId = computeId(id, dynamic);
            return {
                styleId: styleId,
                rules: Array.isArray(css) ? css.map(function(rule) {
                    return computeSelector(styleId, rule);
                }) : [
                    computeSelector(styleId, css)
                ]
            };
        }
        return {
            styleId: computeId(id),
            rules: Array.isArray(css) ? css : [
                css
            ]
        };
    };
    /**
   * selectFromServer
   *
   * Collects style tags from the document with id __jsx-XXX
   */ _proto.selectFromServer = function selectFromServer() {
        var elements = Array.prototype.slice.call(document.querySelectorAll('[id^="__jsx-"]'));
        return elements.reduce(function(acc, element) {
            var id = element.id.slice(2);
            acc[id] = element;
            return acc;
        }, {});
    };
    return StyleSheetRegistry;
}();
function invariant(condition, message) {
    if (!condition) {
        throw new Error("StyleSheetRegistry: " + message + ".");
    }
}
var StyleSheetContext = /*#__PURE__*/ React.createContext(null);
StyleSheetContext.displayName = "StyleSheetContext";
function createStyleRegistry() {
    return new StyleSheetRegistry();
}
function StyleRegistry(param) {
    var configuredRegistry = param.registry, children = param.children;
    var rootRegistry = React.useContext(StyleSheetContext);
    var ref = React.useState(function() {
        return rootRegistry || configuredRegistry || createStyleRegistry();
    }), registry = ref[0];
    return /*#__PURE__*/ React__default["default"].createElement(StyleSheetContext.Provider, {
        value: registry
    }, children);
}
function useStyleRegistry() {
    return React.useContext(StyleSheetContext);
}
// Opt-into the new `useInsertionEffect` API in React 18, fallback to `useLayoutEffect`.
// https://github.com/reactwg/react-18/discussions/110
var useInsertionEffect = React__default["default"].useInsertionEffect || React__default["default"].useLayoutEffect;
var defaultRegistry =  true ? createStyleRegistry() : 0;
function JSXStyle(props) {
    var registry = defaultRegistry ? defaultRegistry : useStyleRegistry();
    // If `registry` does not exist, we do nothing here.
    if (!registry) {
        return null;
    }
    if (false) {}
    useInsertionEffect(function() {
        registry.add(props);
        return function() {
            registry.remove(props);
        };
    // props.children can be string[], will be striped since id is identical
    }, [
        props.id,
        String(props.dynamic)
    ]);
    return null;
}
JSXStyle.dynamic = function(info) {
    return info.map(function(tagInfo) {
        var baseId = tagInfo[0];
        var props = tagInfo[1];
        return computeId(baseId, props);
    }).join(" ");
};
__webpack_unused_export__ = StyleRegistry;
__webpack_unused_export__ = createStyleRegistry;
exports.style = JSXStyle;
__webpack_unused_export__ = useStyleRegistry;


/***/ }),

/***/ 51857:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

module.exports = __webpack_require__(82470).style;


/***/ }),

/***/ 30146:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _app; },
  "reportWebVitals": function() { return /* binding */ reportWebVitals; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var styled_jsx_style = __webpack_require__(51857);
var style_default = /*#__PURE__*/__webpack_require__.n(styled_jsx_style);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(85518);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./node_modules/redux-persist/es/integration/react.js
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

 // eslint-disable-line import/no-unresolved

var PersistGate =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(PersistGate, _PureComponent);

  function PersistGate() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, PersistGate);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(PersistGate)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      bootstrapped: false
    });

    _defineProperty(_assertThisInitialized(_this), "_unsubscribe", void 0);

    _defineProperty(_assertThisInitialized(_this), "handlePersistorState", function () {
      var persistor = _this.props.persistor;

      var _persistor$getState = persistor.getState(),
          bootstrapped = _persistor$getState.bootstrapped;

      if (bootstrapped) {
        if (_this.props.onBeforeLift) {
          Promise.resolve(_this.props.onBeforeLift()).finally(function () {
            return _this.setState({
              bootstrapped: true
            });
          });
        } else {
          _this.setState({
            bootstrapped: true
          });
        }

        _this._unsubscribe && _this._unsubscribe();
      }
    });

    return _this;
  }

  _createClass(PersistGate, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._unsubscribe = this.props.persistor.subscribe(this.handlePersistorState);
      this.handlePersistorState();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._unsubscribe && this._unsubscribe();
    }
  }, {
    key: "render",
    value: function render() {
      if (false) {}

      if (typeof this.props.children === 'function') {
        return this.props.children(this.state.bootstrapped);
      }

      return this.state.bootstrapped ? this.props.children : this.props.loading;
    }
  }]);

  return PersistGate;
}(react.PureComponent);

_defineProperty(PersistGate, "defaultProps", {
  children: null,
  loading: null
});
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 16 modules
var esm = __webpack_require__(24400);
// EXTERNAL MODULE: ./hooks/useIsSsr.js
var useIsSsr = __webpack_require__(2595);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./node_modules/next/script.js
var next_script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(next_script);
// EXTERNAL MODULE: ./store/index.js + 4 modules
var store = __webpack_require__(88032);
// EXTERNAL MODULE: ./store/features/genericSlice.js
var genericSlice = __webpack_require__(88751);
// EXTERNAL MODULE: ./store/features/cartSlice.js
var cartSlice = __webpack_require__(46201);
// EXTERNAL MODULE: ./store/features/compareSlice.js
var compareSlice = __webpack_require__(39915);
// EXTERNAL MODULE: ./constants/config.js
var constants_config = __webpack_require__(19514);
// EXTERNAL MODULE: ./services/auth.service.js
var auth_service = __webpack_require__(77932);
// EXTERNAL MODULE: ./constants/regex.js
var regex = __webpack_require__(49139);
// EXTERNAL MODULE: ./constants/routes.js
var routes = __webpack_require__(64757);
// EXTERNAL MODULE: ./constants/index.js
var constants = __webpack_require__(96301);
// EXTERNAL MODULE: ./utils/helper.js + 1 modules
var helper = __webpack_require__(55760);
// EXTERNAL MODULE: ./utils/index.js
var utils = __webpack_require__(20558);
// EXTERNAL MODULE: ./store/features/locationSlice.js
var locationSlice = __webpack_require__(56608);
// EXTERNAL MODULE: ./store/features/authSlice.js
var authSlice = __webpack_require__(24899);
// EXTERNAL MODULE: ./next-i18next.config.js
var next_i18next_config = __webpack_require__(91463);
var next_i18next_config_default = /*#__PURE__*/__webpack_require__.n(next_i18next_config);
// EXTERNAL MODULE: ./components/core/PageLoader/PageLoader.jsx + 1 modules
var PageLoader = __webpack_require__(41600);
// EXTERNAL MODULE: ./components/Shared/ErrorBoundary/ErrorPage.jsx
var ErrorPage = __webpack_require__(42346);
;// CONCATENATED MODULE: ./components/Shared/ErrorBoundary/index.jsx



/**
 * Class declaration for handling frontend errors
 */ class ErrorBoundary extends react.Component {
    /**
   *
   * @param {*} error
   * @return {boolean}
   */ static getDerivedStateFromError(error) {
        return {
            hasError: true
        };
    }
    /**
   *
   * @param {*} error
   * @param {*} errorInfo
   */ componentDidCatch(error, errorInfo) {
        // You can use your own error logging service here
        console.log({
            error,
            errorInfo
        });
    }
    /**
   *
   * @return {JSX.Element}
   */ render() {
        if (this.state.hasError) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorPage["default"], {});
        }
        return this.props.children;
    }
    /**
   *
   * @param {*} props
   */ constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
}
/* harmony default export */ var Shared_ErrorBoundary = (ErrorBoundary);

;// CONCATENATED MODULE: ./components/Shared/Layout.jsx

const Layout = (param)=>{
    let { children , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
            children: [
                props.show && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "modal-backdrop fade show"
                }),
                children
            ]
        })
    });
};
/* harmony default export */ var Shared_Layout = (Layout);

// EXTERNAL MODULE: ./public/icons/close.svg
var icons_close = __webpack_require__(653);
// EXTERNAL MODULE: ./styles/index.scss
var styles = __webpack_require__(63911);
// EXTERNAL MODULE: ./styles/index_main.scss
var index_main = __webpack_require__(93054);
// EXTERNAL MODULE: ./styles/clientlib-site.min.css
var clientlib_site_min = __webpack_require__(34571);
// EXTERNAL MODULE: ./styles/clientlib-base.min.css
var clientlib_base_min = __webpack_require__(28380);
// EXTERNAL MODULE: ./styles/overrides.scss
var overrides = __webpack_require__(81076);
// EXTERNAL MODULE: ./node_modules/react-datepicker/dist/react-datepicker.css
var react_datepicker = __webpack_require__(95828);
;// CONCATENATED MODULE: ./pages/_app.jsx
/* eslint-disable new-cap */ 
































const AuthModal = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(361), __webpack_require__.e(212)]).then(__webpack_require__.bind(__webpack_require__, 90212)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(90212)
            ]
    },
    ssr: false
});
const CartActionModal = dynamic_default()(()=>__webpack_require__.e(/* import() */ 7409).then(__webpack_require__.bind(__webpack_require__, 27409)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(27409)
            ]
    },
    ssr: false
});
const NewsLetterSignUpOverlay = dynamic_default()(()=>__webpack_require__.e(/* import() */ 9730).then(__webpack_require__.bind(__webpack_require__, 69730)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(69730)
            ]
    },
    ssr: false
});
const CompareProducts = dynamic_default()(()=> true ? __webpack_require__.e(/* import() */ 4310).then(__webpack_require__.bind(__webpack_require__, 75405)) : 0, {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(null /* weak dependency, without id */)
            ]
    },
    ssr: false
});
const PromoModal = dynamic_default()(()=>__webpack_require__.e(/* import() */ 1636).then(__webpack_require__.bind(__webpack_require__, 41636)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(41636)
            ]
    },
    ssr: false
});
const Toaster = dynamic_default()(()=>__webpack_require__.e(/* import() */ 2182).then(__webpack_require__.bind(__webpack_require__, 2025)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(2025)
            ]
    },
    ssr: false
});
const PreviewCart = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(4821), __webpack_require__.e(7435)]).then(__webpack_require__.bind(__webpack_require__, 73369)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(73369)
            ]
    },
    ssr: false
});







if (false) {}
const MyApp = store/* wrapper.withRedux */.YS.withRedux((param)=>{
    let { Component , pageProps  } = param;
    var ref, ref1, ref2;
    const store = (0,es/* useStore */.oR)();
    const dispatch = (0,es/* useDispatch */.I0)();
    const router = (0,next_router.useRouter)();
    const isSsr = (0,useIsSsr/* default */.Z)();
    const { isLoading =false , globalScripts , globalStyles , dataLayerObj , pageIsInteractive , toaster: { isVisible  } , menu: { isOpen  } , previewCart: { showPreview  } , newslettersignup , eventPageType , compareproducts , promoBannerModal , isProductInfo , isPreviewCartInit =false , gatedContentData  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const { utilityLocation =""  } = (0,es/* useSelector */.v9)(locationSlice/* locationState */._n);
    const language = (0,esm/* useTranslation */.$G)();
    const { compare  } = router.query;
    const { comparedProducts  } = (0,es/* useSelector */.v9)(compareSlice/* compareState */.NP);
    const [showCompare, setShowCompare] = (0,react.useState)(false);
    const [previewMode, setPreviewMode] = (0,react.useState)(false);
    const { authModal: { show  } = {} , showCartAction =false  } = (0,es/* useSelector */.v9)(authSlice/* selectAuthState */._9);
    const { cart: cartObj  } = (0,es/* useSelector */.v9)(cartSlice/* selectCartState */.xw);
    const [scriptsLoaded, setScriptsLoaded] = (0,react.useState)(0);
    const [showCampaign, setShowCampaign] = (0,react.useState)(false);
    const isRestricted = constants.EXCLUDE_PAGES.indexOf(router.pathname) >= 0;
    const [pageAlternateLinks] = (0,react.useState)( true ? "en-US:www.kohler.com/en,en-CA:www.kohler.ca/en,fr-CA:www.kohler.ca/fr,x-default:www.kohler.com".split(",").map((item)=>{
        var ref;
        const [lang = "", baseUrl = ""] = (ref = item === null || item === void 0 ? void 0 : item.split(":")) !== null && ref !== void 0 ? ref : [];
        return {
            lang,
            baseUrl
        };
    }) : 0);
    (0,react.useEffect)(()=>{
        var ref, ref1, ref2, ref3;
        (0,utils/* affirmRefresh */.Bq)();
        (0,constants_config/* initConfig */.p)().then(async ()=>{
            const config = await (0,constants_config/* getConfig */.i)();
            dispatch((0,genericSlice/* setGlobalConfig */.Qb)(config));
            await (0,auth_service/* initAuth */.Z5)(config);
        });
        var ref4;
        const authModalData = (ref4 = pageProps === null || pageProps === void 0 ? void 0 : (ref = pageProps.footertmp) === null || ref === void 0 ? void 0 : (ref1 = ref[":items"]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.root) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[":items"]) === null || ref3 === void 0 ? void 0 : ref3.authmodal) !== null && ref4 !== void 0 ? ref4 : {};
        dispatch((0,authSlice/* setAuthModalFormData */.id)(authModalData));
        window.adobeDataLayer = window.adobeDataLayer || [];
        document.body.addEventListener("keypress", helper/* handleEnter */.Bmk);
        (0,helper/* createPersonaCookie */.g45)();
        if ((0,helper/* getAEMPreviewModeCookie */.Bq_)()) {
            setPreviewMode(true);
        } else {
            setPreviewMode(false);
        }
        if (!utilityLocation) checkForLocation();
        // handle sign-in/sign-up using the hashed parameter
        const hashUrl = window.location.hash;
        if (constants.GATED_HASHES.includes(hashUrl.toLowerCase())) {
            let active = 0;
            if (hashUrl.includes("#signup") || hashUrl.includes("#createaccount")) active = 1;
            dispatch((0,authSlice/* setAuthModalVisibility */.LY)({
                show: true,
                active
            }));
        }
        return ()=>document.body.removeEventListener("keypress", helper/* handleEnter */.Bmk);
    }, []);
    (0,react.useEffect)(()=>{
        if (!isEmpty_default()(gatedContentData)) checkForGatedContentPaths();
    }, [
        gatedContentData
    ]);
    const checkForGatedContentPaths = ()=>{
        if (window) {
            var ref;
            const path = (ref = window.location) === null || ref === void 0 ? void 0 : ref.pathname;
            const { gatedContentPathsParameters =[]  } = gatedContentData;
            if (gatedContentPathsParameters.length) {
                var ref1;
                const matchedGatedContent = (ref1 = gatedContentPathsParameters.find((item)=>{
                    const { gatedURL =""  } = item;
                    const securedPath = gatedURL.substring(gatedURL.indexOf(constants.pageUrl), gatedURL.length);
                    return securedPath === path;
                })) !== null && ref1 !== void 0 ? ref1 : {};
                const { gatedURL ="" , landingPageURL =""  } = matchedGatedContent;
                const oktaTokenBrowStorage = localStorage.getItem("okta-token-storage");
                const oktaTokenStorage = oktaTokenBrowStorage ? JSON.parse(oktaTokenBrowStorage) : {};
                const isAnonymous = isEmpty_default()(oktaTokenStorage);
                if (gatedURL && landingPageURL && isAnonymous) {
                    var ref2;
                    const redirectBackUrl = (ref2 = landingPageURL.substring(landingPageURL.indexOf("/en"), landingPageURL.length)) !== null && ref2 !== void 0 ? ref2 : "/en";
                    dispatch((0,authSlice/* setAuthModalVisibility */.LY)({
                        show: true,
                        onCloseHandlation: ()=>handleCloseOfModal(redirectBackUrl)
                    }));
                }
            }
        }
    };
    const handleCloseOfModal = function() {
        let url = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
        window.location.replace(url);
    };
    const checkForLocation = ()=>{
        const currentZipCode = localStorage.getItem("currentZipCode");
        if (currentZipCode) {
            dispatch((0,locationSlice/* setUtilityLocation */.NL)({
                utilityLocation: currentZipCode
            }));
            return;
        }
        (0,helper/* getMyLocation */.fPm)().then((getLocation)=>{
            var _zipcode, _city;
            const details = {
                utilityLocation: (_zipcode = getLocation.zipcode) !== null && _zipcode !== void 0 ? _zipcode : "",
                userCity: (_city = getLocation.city) !== null && _city !== void 0 ? _city : ""
            };
            dispatch((0,locationSlice/* setCityLocation */.OX)(details));
        }).catch((err)=>{
            (0,helper/* getMyLocationByUserIP */.SAL)().then((getLocation)=>{
                var _zipcode, _city;
                const details = {
                    utilityLocation: (_zipcode = getLocation.zipcode) !== null && _zipcode !== void 0 ? _zipcode : "",
                    userCity: (_city = getLocation.city) !== null && _city !== void 0 ? _city : ""
                };
                dispatch((0,locationSlice/* setCityLocation */.OX)(details));
            }).catch((error)=>{
                // eslint-disable-next-line no-console
                console.log(error);
            });
        });
    };
    (0,react.useEffect)(()=>{
        let queueDelay;
        if (cartObj === null || cartObj === void 0 ? void 0 : cartObj.id) {
            (0,helper/* calculateCartData */.DpP)({
                cart: cartObj
            }, true).then(async (res)=>{
                // added timeout for queueing to the callback stack
                // fix for cart not updating to dataLayer sometimes
                const { cart: { itemSkus , ...cartData } = {}  } = res;
                res.cart = await (0,utils/* mapCollapsedSku */.eo)({
                    itemSkus,
                    cart: cartData
                });
                queueDelay = setInterval(()=>{
                    var ref, ref1, ref2, ref3;
                    var ref4;
                    const datalayerLength = (ref4 = window === null || window === void 0 ? void 0 : (ref = window.adobeDataLayer) === null || ref === void 0 ? void 0 : ref.length) !== null && ref4 !== void 0 ? ref4 : 0;
                    if (datalayerLength > 0 && !window.adobeDataLayer[datalayerLength - 1].page.cartInfo) {
                        window.adobeDataLayer.forEach(function(part, index, dataLayer) {
                            if (dataLayer[index].event) {
                                var ref;
                                var ref1;
                                const cartItems = (ref1 = res === null || res === void 0 ? void 0 : (ref = res.cart) === null || ref === void 0 ? void 0 : ref.item) !== null && ref1 !== void 0 ? ref1 : [];
                                var ref2;
                                const cartItemStr = cartItems.map((item)=>{
                                    var ref;
                                    return (ref2 = (ref = item.productInfo) === null || ref === void 0 ? void 0 : ref.productID) !== null && ref2 !== void 0 ? ref2 : "";
                                }).join();
                                dataLayer[index].page.cartInfo = {
                                    cartItems: cartItemStr
                                };
                                dataLayer[index].page.cart = res === null || res === void 0 ? void 0 : res.cart;
                                const pageObj = dataLayer[index].page || window.pageObj;
                                const { category: { pageType =""  } = {}  } = pageObj;
                                const pageObjEvent = window.adobeDataLayer.filter((data)=>{
                                    return data.event === "cmp:show";
                                });
                                if (pageObjEvent && pageObjEvent.length > 0) {
                                    const pageObjEventTmp = {
                                        ...pageObjEvent
                                    };
                                    pageObjEventTmp.page = pageObj;
                                    pageObjEventTmp.event = "cmp:tmpShow";
                                    if ((window === null || window === void 0 ? void 0 : window.productInfo) && pageType === "pdp") {
                                        pageObjEventTmp.productInfo = JSON.parse(window === null || window === void 0 ? void 0 : window.productInfo);
                                        pageObjEventTmp.pageInfo = pageObj.pageInfo;
                                    }
                                    window.adobeDataLayer.push(pageObjEventTmp);
                                    window.adobeDataLayer.pop();
                                }
                            }
                        });
                    }
                    // clear the interval if the cart is added up to cmp:show
                    if ((ref1 = window.adobeDataLayer) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[1]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.page) === null || ref3 === void 0 ? void 0 : ref3.cartInfo) {
                        clearInterval(queueDelay);
                    }
                }, 100);
            });
        }
        return ()=>clearInterval(queueDelay);
    }, [
        cartObj,
        router
    ]);
    (0,react.useEffect)(()=>{
        const onRouterChangeStart = (url)=>{
            dispatch((0,genericSlice/* setPageIsIntercative */.Ys)(false));
            window.referrer = window.location.href;
            concernBanner("remove");
            clearAdobeTargetVideoTimeout();
        };
        const onRouterChangeComplete = (_, urlProp)=>{
            if (window && window.adobeDataLayer) {
                // prevent the dalatalayer events in case of shallow routing from PDP page
                if (!(urlProp === null || urlProp === void 0 ? void 0 : urlProp.shallow)) {
                    window.adobeDataLayer.length = 0;
                    window.datalayerTopLoaded = false;
                    dispatch((0,genericSlice/* setPageObject */.FE)(false));
                }
            }
            alterBodyClass();
            const isPdp = (window === null || window === void 0 ? void 0 : window.eventPageType) === "pdp";
            if (!isPdp) {
                window.datalayerTopLoaded = false;
                window.initDataLayerTop();
            }
            window.isShowAnalyticsEvent = true;
            (0,helper/* addPageLoadAnalyticsEvent */.igK)();
            delete window.referrer;
            dispatch((0,genericSlice/* setPageIsIntercative */.Ys)(true));
            concernBanner("add");
            if (pageIsInteractive) appendAdobeTargetVideoScript();
        };
        const popStateListener = (e)=>{
            const queryString = window.location.search;
            const path = window.location.pathname;
            const urlParams = new URLSearchParams(queryString);
            const hashedUrl = window.location.hash;
            const eventState = e === null || e === void 0 ? void 0 : e.state;
            if (hashedUrl) {
                var ref;
                const hashUrl = (ref = hashedUrl.split("::")[0]) !== null && ref !== void 0 ? ref : "";
                var ref1;
                const redirectionPath = (ref1 = hashedUrl.split("::")[1]) !== null && ref1 !== void 0 ? ref1 : "";
                if (constants.GATED_HASHES.includes(hashUrl.toLowerCase())) {
                    if ((0,helper/* getAnonymousId */.yQL)()) {
                        let active = 0;
                        if (hashUrl.includes("#signup")) active = 1;
                        dispatch((0,authSlice/* setAuthModalVisibility */.LY)({
                            show: true,
                            active
                        }));
                        window.gatedPathRedirection = redirectionPath;
                    } else {
                        window.location.href = redirectionPath;
                    }
                }
                if (hashedUrl === "#newsletter") {
                    setShowCampaign(true);
                }
            }
            if (urlParams.has("back") || urlParams.has("keyword") || path === "/en/support/help-and-faq" || path === constants.MY_LISTS_PATH || path === constants.MY_LISTS_PATH_FR || path === constants.SUPPORT_CENTER_PATH || path === constants.FIND_A_PRO_PATH || path.includes(constants.SHOP_THE_ROOM) || path === constants.INSTALLATION_SERVICES_PATH && (eventState !== null && isEmpty_default()(eventState) || (eventState === null || eventState === void 0 ? void 0 : eventState.previousUrl) === constants.CART_URL || (eventState === null || eventState === void 0 ? void 0 : eventState.previousUrl) === constants.CHECKOUT_URL) || path.includes(constants.TECHNICAL_SPECIFICATION_PATH) || path.includes(constants.LOCATIONS_PATH) || urlParams.has("compare") || regex/* PDP_REGEX.test */.ub.test(path)) {
                router.reload();
            }
        };
        window.addEventListener("popstate", popStateListener);
        router.events.on("routeChangeStart", onRouterChangeStart);
        router.events.on("routeChangeComplete", onRouterChangeComplete);
        return ()=>{
            // concernBanner("remove")
            router.events.off("routeChangeStart", onRouterChangeStart);
            router.events.off("routeChangeComplete", onRouterChangeComplete);
            window.removeEventListener("popstate", popStateListener);
        };
    }, [
        router
    ]);
    const alterBodyClass = ()=>{
        var ref;
        if (pageProps === null || pageProps === void 0 ? void 0 : (ref = pageProps.tmpData) === null || ref === void 0 ? void 0 : ref.cssClassNames) {
            var ref1;
            document.body.className = pageProps === null || pageProps === void 0 ? void 0 : (ref1 = pageProps.tmpData) === null || ref1 === void 0 ? void 0 : ref1.cssClassNames;
        }
    };
    (0,react.useEffect)(()=>{
        if (dataLayerObj) {
            const pageObj = JSON.parse(dataLayerObj);
            const { pageInfo: { pageUrl =""  } = {}  } = pageObj;
            if (pageUrl.includes(".json")) {
                pageObj.pageInfo.pageUrl = window.location.href;
            }
            window.pageObj = pageObj;
            window.eventPageType = eventPageType;
            window.isShowAnalyticsEvent = true;
            const isPdpLoaded = (window === null || window === void 0 ? void 0 : window.eventPageType) === "pdp" && isProductInfo || (window === null || window === void 0 ? void 0 : window.eventPageType) !== "pdp";
            if (window.pageObj && !window.datalayerTopLoaded && isPdpLoaded) {
                const dataLayerEvent = new Event("datalayerTopFired");
                window.dispatchEvent(dataLayerEvent);
            }
        }
    }, [
        dataLayerObj,
        isProductInfo
    ]);
    (0,react.useEffect)(()=>{
        const loadScripts = ()=>{
            dispatch((0,genericSlice/* setPageIsIntercative */.Ys)(true));
        };
        const loadScriptsTimer = setTimeout(loadScripts, 5000);
        const userInteractionEvents = [
            "mouseover",
            "keydown",
            "touchmove",
            "touchstart",
            "scroll",
            "click"
        ];
        const triggerScriptLoader = ()=>{
            loadScripts();
            clearTimeout(loadScriptsTimer);
            userInteractionEvents.forEach(function(event) {
                window.removeEventListener(event, triggerScriptLoader, {
                    passive: true
                });
            });
        };
        userInteractionEvents.forEach(function(event) {
            window.addEventListener(event, triggerScriptLoader, {
                passive: true
            });
        });
        concernBanner("add");
        // setTimeout(ontrustCookie(), 1000)
        return ()=>{
            dispatch((0,genericSlice/* setPageIsIntercative */.Ys)(false));
            concernBanner("remove");
        };
    }, []);
    const concernBanner = (action)=>{
        const oneTrustVal = window.OneTrust || window.OneTrustStub;
        if (oneTrustVal && oneTrustVal.ToggleInfoDisplay) {
            var ref;
            if (action === "add") {
                oneTrustVal.initializeCookiePolicyHtml();
                oneTrustVal.LoadBanner();
            }
            (ref = document.querySelectorAll("#ot-sdk-link")[0]) === null || ref === void 0 ? void 0 : ref.removeEventListener("click", function() {
                oneTrustVal.ToggleInfoDisplay();
            });
            if (action === "add") {
                var ref1;
                (ref1 = document.querySelectorAll("#ot-sdk-link")[0]) === null || ref1 === void 0 ? void 0 : ref1.addEventListener("click", function() {
                    oneTrustVal.ToggleInfoDisplay();
                });
            }
        }
    };
    (0,react.useEffect)(()=>{
        // To remove hide the chat window on openinig menu
        if (lib/* isMobile */.tq) {
            const chatElement = document.getElementsByClassName("embeddedServiceHelpButton");
            if (isOpen && chatElement.length) {
                chatElement.item(0).style.display = "none";
            } else if (chatElement.length) {
                chatElement.item(0).style.display = "block";
            }
        }
    }, [
        isOpen
    ]);
    (0,react.useEffect)(()=>{
        if (compare) {
            setShowCompare(true);
        } else if (comparedProducts && comparedProducts.length > 0) {
            setShowCompare(true);
        } else {
            document.body.classList.remove("compare-open", "scroll-lock", "modal-open");
            setShowCompare(false);
        }
    }, [
        comparedProducts
    ]);
    let adobeTargetVideoTimer;
    let adobeTargetElValidateCount = 0;
    const appendAdobeTargetVideoScript = ()=>{
        adobeTargetElValidateCount += 1;
        const adobeTargetVideoContainer = document.getElementsByClassName("at-element-marker");
        const videoEl = document.getElementsByTagName("video");
        if (adobeTargetVideoTimer) {
            clearTimeout(adobeTargetVideoTimer);
            adobeTargetVideoTimer = undefined;
        }
        if (adobeTargetVideoContainer.length > 0 && videoEl.length > 0) {
            const scriptPath = "/js/video.js";
            let script = document.querySelector('script[src="'.concat(scriptPath, '"]'));
            if (!script) {
                script = document.createElement("script");
                script.src = scriptPath;
                script.defer = true;
                document.body.appendChild(script);
            }
        } else if (adobeTargetElValidateCount <= 10) {
            adobeTargetVideoTimer = setTimeout(()=>{
                appendAdobeTargetVideoScript();
            }, 1000);
        }
    };
    const clearAdobeTargetVideoTimeout = ()=>{
        if (adobeTargetVideoTimer) {
            clearTimeout(adobeTargetVideoTimer);
            adobeTargetVideoTimer = undefined;
            adobeTargetElValidateCount = 0;
        }
    };
    (0,react.useEffect)(()=>{
        if (pageIsInteractive) appendAdobeTargetVideoScript();
        return ()=>{
            clearAdobeTargetVideoTimeout();
        };
    }, [
        pageIsInteractive
    ]);
    const handleModalClose = ()=>{
        if (showCampaign) setShowCampaign(false);
    };
    const getFeatureFlags = async ()=>{
        const { data: featureFlags = {}  } = await axios_default().get(routes/* FEATURE_FLAGS_API_ENDPOINT */.VU);
        dispatch((0,genericSlice/* setFeatureFlagsFeature */.F$)(featureFlags));
    };
    (0,react.useEffect)(()=>{
        getFeatureFlags();
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "viewport",
                        content: "width=device-width, initial-scale=1"
                    }),
                    pageAlternateLinks.length ? pageAlternateLinks.map((param, index)=>/*#__PURE__*/ {
                        let { lang ="" , baseUrl =""  } = param;
                        return (0,jsx_runtime.jsx)("link", {
                            rel: "alternate",
                            hrefLang: lang,
                            href: "https://".concat(baseUrl).concat(lang === "x-default" ? "/en" : "").concat(pageProps.urlPath === "/" ? "" : pageProps.urlPath)
                        }, "page-alterante-link-8csi3-3232k-sae".concat(index, "12"));
                    }) : null,
                    globalStyles.map((style, i)=>{
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                            children: (0,jsx_runtime.jsx)((style_default()), {
                                id: style.__hash,
                                children: style
                            })
                        }, "style-".concat(i, "-").concat((0,helper/* getRandom */.sZz)()));
                    }),
                    previewMode && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "robots",
                        content: "noindex,nofollow"
                    }),
                    ((ref = pageProps.metaContent) === null || ref === void 0 ? void 0 : ref.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "robots",
                        content: pageProps === null || pageProps === void 0 ? void 0 : pageProps.metaContent
                    }) : null,
                    (pageProps === null || pageProps === void 0 ? void 0 : pageProps.canonicalUrl) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: (language === null || language === void 0 ? void 0 : (ref1 = language.i18n) === null || ref1 === void 0 ? void 0 : ref1.language) === "fr" ? pageProps === null || pageProps === void 0 ? void 0 : (ref2 = pageProps.canonicalUrl) === null || ref2 === void 0 ? void 0 : ref2.replace("/en/", "/fr/") : pageProps === null || pageProps === void 0 ? void 0 : pageProps.canonicalUrl
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Provider */.zt, {
                store: store,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(utils/* ConditionalWrapper */.M2, {
                    condition: !isSsr,
                    wrapper: (children)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(PersistGate, {
                            persistor: store.__persistor,
                            loading: /*#__PURE__*/ (0,jsx_runtime.jsx)(PageLoader/* default */.Z, {
                                initialLoader: true
                            }),
                            children: children
                        }),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PageLoader/* default */.Z, {
                            loading: isLoading
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Shared_Layout, {
                            show: promoBannerModal === null || promoBannerModal === void 0 ? void 0 : promoBannerModal.show,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Shared_ErrorBoundary, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "root ".concat(previewMode ? "previewmode" : ""),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, {
                                            ...pageProps
                                        })
                                    }),
                                    show && /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthModal, {}),
                                    showCartAction ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CartActionModal, {}) : null,
                                    isVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)(Toaster, {
                                        message: ""
                                    }),
                                    newslettersignup && /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsLetterSignUpOverlay, {
                                        data: newslettersignup,
                                        showCampaign: showCampaign,
                                        handleModalClose: handleModalClose
                                    }),
                                    (promoBannerModal === null || promoBannerModal === void 0 ? void 0 : promoBannerModal.show) && /*#__PURE__*/ (0,jsx_runtime.jsx)(PromoModal, {
                                        ...promoBannerModal.modalContent
                                    }),
                                    !isRestricted && showCompare && (compareproducts === null || compareproducts === void 0 ? void 0 : compareproducts.content) && /*#__PURE__*/ (0,jsx_runtime.jsx)(CompareProducts, {
                                        compareproducts: compareproducts === null || compareproducts === void 0 ? void 0 : compareproducts.content
                                    }),
                                    showPreview || isPreviewCartInit ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PreviewCart, {}) : null
                                ]
                            })
                        })
                    ]
                })
            }),
            pageIsInteractive && globalScripts.map((script, i)=>{
                if (!script.innerHTML && scriptsLoaded === i) return /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                    onReady: ()=>{
                        setScriptsLoaded(i + 1);
                    },
                    onError: ()=>{
                        setScriptsLoaded(i + 1);
                    },
                    src: script.src,
                    id: "script-".concat(i)
                }, "script-".concat(i));
                if (script.innerHTML && scriptsLoaded === i) return /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                    onReady: ()=>{
                        setScriptsLoaded(i + 1);
                    },
                    onError: ()=>{
                        setScriptsLoaded(i + 1);
                    },
                    id: "innerscript-".concat(i),
                    children: "".concat(script.innerHTML)
                }, "innerscript-".concat(i));
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                type: "module",
                src: "/js/datalayer.js",
                onReady: ()=>{
                    const dataLayerEvent = new Event("datalayerFired");
                    window.dispatchEvent(dataLayerEvent);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                type: "module",
                src: "/js/basic-text-module.js"
            }),
            previewMode && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "topcorner",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    children: [
                        "Decoupled preview mode",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            className: "ml-10 mr-5",
                            onClick: ()=>(0,helper/* closePreview */.xn0)(),
                            src: icons_close/* default.src */.Z.src,
                            alt: "close-icon"
                        })
                    ]
                })
            })
        ]
    });
});
/**
 * function to log webvitals
 * @param {*} metric
 */ function reportWebVitals(metric) {
    console.log("Web Vitals", metric);
}
/* harmony default export */ var _app = ((0,esm/* appWithTranslation */.Jc)(MyApp, (next_i18next_config_default())));


/***/ }),

/***/ 77932:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U_": function() { return /* binding */ authClient; },
/* harmony export */   "Z5": function() { return /* binding */ initAuth; },
/* harmony export */   "c0": function() { return /* binding */ resetPassword; }
/* harmony export */ });
/* harmony import */ var _okta_okta_auth_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(16194);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55760);
/* harmony import */ var _store_features_authSlice__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24899);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88032);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96301);





let authClient;
const initAuth = async (config)=>{
    const { apiEndPointData: { map: { oktaScopes  }  } = {} , general: { homepageUrl ="" , registerNonKohlerProductPath ="" , isPublish  } = {} , commerce: { sessionAuth: { securePagePathList =[]  } = {}  } = {} , apiEndpoints: { oktaClientId ="" , oktaIssuerUrl ="" , oktaLogoutUri =""  } = {}  } = config || {};
    authClient = new _okta_okta_auth_js__WEBPACK_IMPORTED_MODULE_0__/* .OktaAuth */ .snk({
        issuer: oktaIssuerUrl,
        clientId: oktaClientId,
        redirectUri: "https://www.kohler.com",
        postLogoutRedirectUri: oktaLogoutUri,
        scopes: oktaScopes ? oktaScopes.split(",") : [
            "kcom-session",
            "openid",
            "offline_access"
        ],
        tokenManager: {
            autoRenew: true,
            expireEarlySeconds: 120
        }
    });
    authClient.start();
    let prevAuthState = null;
    authClient.authStateManager.subscribe((authState)=>{
        if (authState.isAuthenticated) {
            const payload = {
                accessToken: authState.accessToken.accessToken,
                refreshToken: authState.refreshToken.refreshToken,
                user: authState.accessToken.claims || {},
                isAuth: authState.isAuthenticated
            };
            _store__WEBPACK_IMPORTED_MODULE_3__/* .store.dispatch */ .h.dispatch((0,_store_features_authSlice__WEBPACK_IMPORTED_MODULE_2__/* .postLogin */ .SV)(payload));
        }
        if (prevAuthState && prevAuthState.isAuthenticated !== authState.isAuthenticated) {
            if (document.hidden) window.location.reload();
        }
        prevAuthState = authState;
        (0,_utils_helper__WEBPACK_IMPORTED_MODULE_1__/* .addPageLoadAnalyticsEvent */ .igK)();
    });
    authClient.tokenManager.on("error", async function(err) {
        console.error(err);
        await authClient.signOut({
            clearTokensBeforeRedirect: true
        });
        await authClient.session.close();
    });
    const isLoggedInRedirect = await authClient.isLoginRedirect();
    if (isLoggedInRedirect) {
        const { tokens  } = await authClient.token.parseFromUrl();
        authClient.tokenManager.setTokens(tokens);
        const { accessToken  } = tokens;
        _store__WEBPACK_IMPORTED_MODULE_3__/* .store.dispatch */ .h.dispatch((0,_store_features_authSlice__WEBPACK_IMPORTED_MODULE_2__/* .postLogin */ .SV)(accessToken.claims));
    } else {
        authClient.authStateManager.updateAuthState();
        try {
            const accessToken1 = await authClient.tokenManager.get("accessToken");
            const isSessionExists = await authClient.session.exists();
            if (accessToken1 && !authClient.tokenManager.hasExpired(accessToken1) && isSessionExists) {
                // check  if force renewal requested in previous session
                const userInfo = sessionStorage.getItem(_constants__WEBPACK_IMPORTED_MODULE_4__["default"].KF_UPDATE_MEMBERSHIP);
                console.log("userInfo", userInfo);
                if (localStorage.getItem(_constants__WEBPACK_IMPORTED_MODULE_4__["default"].KF_FORCE_RENEW_TOKEN)) {
                    if (userInfo) {
                        const user = JSON.parse(userInfo);
                        if (user.uid === accessToken1.claims.uid) {
                            const payload = {
                                user: accessToken1.claims
                            };
                            _store__WEBPACK_IMPORTED_MODULE_3__/* .store.dispatch */ .h.dispatch((0,_store_features_authSlice__WEBPACK_IMPORTED_MODULE_2__/* .postLogin */ .SV)(payload));
                            _store__WEBPACK_IMPORTED_MODULE_3__/* .store.dispatch */ .h.dispatch((0,_store_features_authSlice__WEBPACK_IMPORTED_MODULE_2__/* .setPersona */ .nf)(user.persona));
                        }
                    } else {
                        const renwedToken = await authClient.tokenManager.renew("accessToken");
                        const payload1 = {
                            user: renwedToken.claims
                        };
                        _store__WEBPACK_IMPORTED_MODULE_3__/* .store.dispatch */ .h.dispatch((0,_store_features_authSlice__WEBPACK_IMPORTED_MODULE_2__/* .postLogin */ .SV)(payload1));
                        localStorage.removeItem(_constants__WEBPACK_IMPORTED_MODULE_4__["default"].KF_FORCE_RENEW_TOKEN);
                    }
                } else {
                    const payload2 = {
                        user: accessToken1.claims
                    };
                    _store__WEBPACK_IMPORTED_MODULE_3__/* .store.dispatch */ .h.dispatch((0,_store_features_authSlice__WEBPACK_IMPORTED_MODULE_2__/* .postLogin */ .SV)(payload2));
                }
            } else if (isSessionExists) {
                authClient.token.getWithRedirect({
                    responseType: [
                        "id_token",
                        "access_token",
                        "code"
                    ],
                    state: location.href
                }).catch((err)=>{
                    console.error("error in getting token", err);
                });
            } else if (!accessToken1) {
                const isProtected = await (0,_utils_helper__WEBPACK_IMPORTED_MODULE_1__/* .isProtectedUrl */ .GtH)();
                if (isProtected && isPublish) {
                    const redirectAction = {
                        isLoginAction: true,
                        loginCallbackURL: window.location.href
                    };
                    localStorage.setItem("SecurePageRedirect", JSON.stringify(redirectAction));
                    window.location.replace(await (0,_utils_helper__WEBPACK_IMPORTED_MODULE_1__/* .getShortenedUrl */ .Ppy)(homepageUrl));
                    if (window.location.pathname === homepageUrl) {
                        _store__WEBPACK_IMPORTED_MODULE_3__/* .store.dispatch */ .h.dispatch((0,_store_features_authSlice__WEBPACK_IMPORTED_MODULE_2__/* .setAuthModalVisibility */ .LY)({
                            show: true
                        }));
                    }
                } else if (localStorage.getItem("SecurePageRedirect")) {
                    const redirectAction1 = JSON.parse(localStorage.getItem("SecurePageRedirect"));
                    if (redirectAction1.isLoginAction) {
                        window.loginCallback = redirectAction1.loginCallbackURL;
                        localStorage.removeItem("SecurePageRedirect");
                        _store__WEBPACK_IMPORTED_MODULE_3__/* .store.dispatch */ .h.dispatch((0,_store_features_authSlice__WEBPACK_IMPORTED_MODULE_2__/* .setAuthModalVisibility */ .LY)({
                            show: true
                        }));
                    }
                }
            // store?.dispatch(getOktaToken("guest"))
            } else {
                _store__WEBPACK_IMPORTED_MODULE_3__/* .store.dispatch */ .h.dispatch((0,_store_features_authSlice__WEBPACK_IMPORTED_MODULE_2__/* .logout */ .kS)());
            }
        } catch (err) {
            console.error("Okta error while getting access token from token manager", err);
        }
    }
    securePagePathList.forEach((path)=>{
        document.querySelectorAll('a[href="'.concat(path, '"]')).forEach((tag)=>{
            tag.onclick = function(e) {
                e.preventDefault();
                if (registerNonKohlerProductPath === this.href) {
                    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_1__/* .setWindowProps */ .F2_)("signUpConfirmationCTA", "Register Products");
                }
                (0,_utils_helper__WEBPACK_IMPORTED_MODULE_1__/* .isAuthenticated */ .$8e)(this.href);
            };
        });
    });
    document.querySelectorAll('a[href^="#isAuth"]').forEach((link)=>{
        link.addEventListener("click", (e)=>{
            e.preventDefault();
            const url = e.target.href.split("::")[1];
            (0,_utils_helper__WEBPACK_IMPORTED_MODULE_1__/* .isAuthenticated */ .$8e)(url);
        });
    });
    document.querySelectorAll('a[href*="#KPN"]').forEach((link)=>{
        link.addEventListener("click", (e)=>{
            e.preventDefault();
            const link = e.target.href.split("::");
            const id = link[0];
            const url = link[1];
            if (link) {
                _store__WEBPACK_IMPORTED_MODULE_3__/* .store.dispatch */ .h.dispatch((0,_store_features_authSlice__WEBPACK_IMPORTED_MODULE_2__/* .setHideCustomerSignupCTA */ .n$)(true));
                if (id.includes("signIn")) {
                    window.KPNSignIn = true;
                    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_1__/* .isAuthenticated */ .$8e)(url, 0, true);
                } else if (id.includes("createAccount")) {
                    window.KPNSignIn = false;
                    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_1__/* .isAuthenticated */ .$8e)(url, 1, true);
                } else {
                    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_1__/* .isAuthenticated */ .$8e)(url);
                }
            }
        });
    });
};
const resetPassword = function() {
    let recoveryToken = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", newPassword = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", cb = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ()=>{}, errCb = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : ()=>{};
    authClient.verifyRecoveryToken({
        recoveryToken
    }).then(function(transaction) {
        if (transaction.status === "PASSWORD_RESET") {
            transaction.resetPassword({
                newPassword
            }).then(()=>{
                cb();
            }).catch((ex)=>errCb(ex.message));
        } else {
            errCb();
        }
    }).catch(function(ex) {
        errCb(ex.message);
    });
};



/***/ }),

/***/ 13875:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Do": function() { return /* binding */ getSearchPDP; },
/* harmony export */   "HB": function() { return /* binding */ requestForChangePassword; },
/* harmony export */   "He": function() { return /* binding */ getProductByImage; },
/* harmony export */   "vP": function() { return /* binding */ getProjectionData; }
/* harmony export */ });
/* harmony import */ var _constants_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73350);
/* harmony import */ var _constants_routes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64757);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96301);
/* harmony import */ var _utils_ApiUtil__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51666);




const requestForChangePassword = async (data)=>{
    try {
        return await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.post */ .TH.post(_constants_routes__WEBPACK_IMPORTED_MODULE_1__/* .CHANGE_PASSWORD_ENDPOINT */ .j0, data);
    } catch (err) {
        console.error("Failed to reset password", err);
        return err.response;
    }
};
const getProductByImage = async (input)=>{
    try {
        const response = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.post */ .TH.post("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_2__.skuBypimLookup), input, {
            sessionId: (0,_utils_ApiUtil__WEBPACK_IMPORTED_MODULE_3__/* .getSessionIdObjWithEpoc */ .oq)()
        });
        return response;
    } catch (err) {
        return err;
    }
};
const getSearchPDP = async (slug)=>{
    try {
        const response = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.post */ .TH.post("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_2__.searchPdpEndPoint, "/").concat(slug), {
            collections: "service_parts",
            fl: "*",
            profilename: "profile_service_parts_PDP",
            q: "*:*",
            search_type: "product_detail"
        });
        return response;
    } catch (err) {
        return err;
    }
};
const getProjectionData = async (payload)=>{
    const { slug , skus  } = payload;
    let query = "";
    let masterQuery = "";
    if (slug) masterQuery += 'slug(en-US%3D"'.concat(slug, '") or ');
    if (skus.length > 0) {
        skus.forEach((sku, i)=>{
            query += '"'.concat(sku, '"');
            if (i + 1 !== skus.length) query += ", ";
        });
        masterQuery += "masterVariant(sku in (".concat(query, ")) or variants(sku in (").concat(query, "))");
    }
    try {
        const res = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.get */ .TH.get("".concat(_constants_routes__WEBPACK_IMPORTED_MODULE_1__/* .CATALOG_PROJECTION_ENDPOINT */ .E5, "?where=").concat(masterQuery));
        if (res && res.data && res.data.results) return res.data.results;
    } catch (err) {
        return err;
    }
    return [];
};


/***/ }),

/***/ 93014:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h$": function() { return /* binding */ resetAccordion; },
/* harmony export */   "x4": function() { return /* binding */ setLastOpenAccordion; },
/* harmony export */   "xW": function() { return /* binding */ setOpenAccordion; }
/* harmony export */ });
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(77236);

const initialState = {
    openAccordion: null,
    lastOpenAccordion: null
};
const accordionSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__/* .createSlice */ .oM)({
    name: "accordion",
    initialState,
    reducers: {
        setOpenAccordion (state, action) {
            state.openAccordion = action.payload;
        },
        setLastOpenAccordion (state, action) {
            state.lastOpenAccordion = action.payload;
        },
        resetAccordion (state) {
            state.openAccordion = null;
            state.lastOpenAccordion = null;
        }
    }
});
const { setOpenAccordion , setLastOpenAccordion , resetAccordion  } = accordionSlice.actions;
/* harmony default export */ __webpack_exports__["ZP"] = (accordionSlice);


/***/ }),

/***/ 24899:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$t": function() { return /* binding */ setAnonymousId; },
/* harmony export */   "A3": function() { return /* binding */ setAuthData; },
/* harmony export */   "Fc": function() { return /* binding */ setShowProSignup; },
/* harmony export */   "Gb": function() { return /* binding */ authSlice; },
/* harmony export */   "IR": function() { return /* binding */ setShowCartAction; },
/* harmony export */   "IU": function() { return /* binding */ signup; },
/* harmony export */   "LY": function() { return /* binding */ setAuthModalVisibility; },
/* harmony export */   "Mi": function() { return /* binding */ setShowCustomerSignup; },
/* harmony export */   "SV": function() { return /* binding */ postLogin; },
/* harmony export */   "_9": function() { return /* binding */ selectAuthState; },
/* harmony export */   "b4": function() { return /* binding */ setUserName; },
/* harmony export */   "cj": function() { return /* binding */ setShowForgotPassword; },
/* harmony export */   "cs": function() { return /* binding */ getOktaToken; },
/* harmony export */   "gF": function() { return /* binding */ forgotPassword; },
/* harmony export */   "hS": function() { return /* binding */ setAuthModalActiveTab; },
/* harmony export */   "iU": function() { return /* binding */ setRevalidateTime; },
/* harmony export */   "id": function() { return /* binding */ setAuthModalFormData; },
/* harmony export */   "j5": function() { return /* binding */ clearAuthState; },
/* harmony export */   "kS": function() { return /* binding */ logout; },
/* harmony export */   "n$": function() { return /* binding */ setHideCustomerSignupCTA; },
/* harmony export */   "nf": function() { return /* binding */ setPersona; },
/* harmony export */   "vu": function() { return /* binding */ setAuthModalStaticText; },
/* harmony export */   "x4": function() { return /* binding */ login; }
/* harmony export */ });
/* harmony import */ var _constants_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73350);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96301);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(77236);
/* harmony import */ var next_redux_wrapper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28858);
/* harmony import */ var _services_auth_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77932);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(55760);
/* harmony import */ var _utils_cart__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11763);
/* harmony import */ var _store_features_cartSlice__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(46201);
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(19514);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(41609);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_8__);












const initialState = {
    isAuth: false,
    anonymousId: "",
    access_token: "",
    refresh_token: "",
    expires_in: "",
    revalidate_in: "",
    scopes: [],
    token_type: "",
    status: "",
    error: "",
    authModal: {
        show: false,
        staticText: {},
        formData: {},
        active: 0
    },
    showCartAction: false,
    hashedEmail: "",
    customerProspect: "",
    showForgotPassword: false,
    showCustomerSignup: false,
    showProSignup: false,
    hideCustomerSignupCTA: false,
    user: {}
};
const getOktaToken = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_9__/* .createAsyncThunk */ .hg)("auth/getOktaToken", async (type)=>{
    const { gId  } = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_4__/* .getAccessToken */ .hPi)();
    const { apiEndPointData: { map: { channel  }  } = {}  } = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_7__/* .getConfig */ .i)();
    const path = "".concat(_constants_index__WEBPACK_IMPORTED_MODULE_1__.oktaTokenEndpoint, "?scope=").concat(type).concat(channel ? "&channel=".concat(channel) : "");
    const response = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.post */ .TH.post(path, null, {
        params: {
            gId
        }
    });
    return response.data;
});
const login = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_9__/* .createAsyncThunk */ .hg)("auth/login", async (payload, thunkAPI)=>{
    const { username , password , isFirstLogin  } = payload;
    const { cart: { cart: { lineItems =[]  }  }  } = thunkAPI.getState() || {};
    const isCartItems = lineItems.length > 0;
    try {
        const config = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_7__/* .getConfig */ .i)();
        const { apiEndPointData: { map: { brandUsernameExtension  }  } = {}  } = config;
        const usernameWithExtension = brandUsernameExtension ? "".concat(username, ".").concat(brandUsernameExtension) : username;
        const res = await _services_auth_service__WEBPACK_IMPORTED_MODULE_3__/* .authClient.signInWithCredentials */ .U_.signInWithCredentials({
            username: usernameWithExtension,
            password
        });
        if (res.status === "SUCCESS") {
            return _services_auth_service__WEBPACK_IMPORTED_MODULE_3__/* .authClient.token.getWithoutPrompt */ .U_.token.getWithoutPrompt({
                responseType: [
                    "id_token",
                    "access_token"
                ],
                sessionToken: res.sessionToken
            }).then(async function(param) {
                let { tokens  } = param;
                var ref;
                if (!isFirstLogin) {
                    thunkAPI.dispatch(setAuthModalVisibility({
                        show: false
                    }));
                }
                const anonymousId = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_4__/* .getAnonymousId */ .yQL)();
                localStorage.setItem("tempAnonymousId", anonymousId);
                (0,_utils_helper__WEBPACK_IMPORTED_MODULE_4__/* .clearAnonymousToken */ .loo)();
                _services_auth_service__WEBPACK_IMPORTED_MODULE_3__/* .authClient.tokenManager.setTokens */ .U_.tokenManager.setTokens(tokens);
                const payload = {
                    accessToken: tokens.accessToken.accessToken,
                    refreshToken: tokens.refreshToken.refreshToken,
                    user: ((ref = tokens.accessToken) === null || ref === void 0 ? void 0 : ref.claims) || {},
                    isAuth: true
                };
                await thunkAPI.dispatch(postLogin(payload));
                if (!isFirstLogin && isCartItems) {
                    thunkAPI.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_6__/* .getCart */ .dv)()).unwrap().then(function() {
                        let res = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                        const { lineItems =[]  } = res;
                        if (lineItems.length) {
                            thunkAPI.dispatch(setShowCartAction(true));
                        } else {
                            const mergeCartPayload = {
                                anonymousId
                            };
                            if (anonymousId) {
                                thunkAPI.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_6__/* .mergeCart */ .Ii)(mergeCartPayload)).unwrap().then(()=>{
                                    var ref;
                                    thunkAPI.dispatch(setAnonymousId(""));
                                    localStorage.removeItem("tempAnonymousId");
                                    var ref1;
                                    const disableCommerce = (ref1 = config === null || config === void 0 ? void 0 : (ref = config.general) === null || ref === void 0 ? void 0 : ref.disableCommerce) !== null && ref1 !== void 0 ? ref1 : false;
                                    if (!disableCommerce) {
                                        thunkAPI.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_6__/* .getCart */ .dv)());
                                    }
                                });
                            }
                        }
                    });
                }
                // ------------ functionality review start ----------------
                const state = thunkAPI.getState();
                const loginCallback = window.loginCallback;
                const { hideCustomerSignupCTA  } = state.auth;
                if (loginCallback) {
                    if (hideCustomerSignupCTA) {
                        const persona = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_4__/* .getUserPersona */ .shu)();
                        const { general: { homepageUrl =""  } = {}  } = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_7__/* .getConfig */ .i)();
                        if (persona !== "TVS") {
                            window.location.replace(await (0,_utils_helper__WEBPACK_IMPORTED_MODULE_4__/* .getShortenedUrl */ .Ppy)(homepageUrl !== null && homepageUrl !== void 0 ? homepageUrl : "/"));
                        } else window.KPNSignIn ? window.location.replace(loginCallback) : null;
                    } else {
                        if (typeof loginCallback === "function") {
                            loginCallback();
                        } else {
                            window.location.replace(loginCallback);
                        // await authClient.session.setCookieAndRedirect(res.sessionToken)
                        }
                        window.loginCallback = null;
                    }
                }
                // ------------ functionality review end ----------------
                // await authClient.session.setCookieAndRedirect(res.sessionToken)
                return thunkAPI.fulfillWithValue("success");
            }).catch(function(err) {
                return thunkAPI.fulfillWithValue((err === null || err === void 0 ? void 0 : err.errorSummary) || "error");
            });
        } else if (res.status === "LOCKED_OUT") {
            return thunkAPI.fulfillWithValue({
                lockedOut: true
            });
        } else if (res.status === "PASSWORD_EXPIRED") {
            return thunkAPI.fulfillWithValue({
                passwordExpired: true,
                data: res.data
            });
        }
    } catch (err) {
        return thunkAPI.fulfillWithValue((err === null || err === void 0 ? void 0 : err.errorSummary) || "error");
    }
});
const signup = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_9__/* .createAsyncThunk */ .hg)("auth/signup", async (payload, thunkAPI)=>{
    try {
        const response = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.post */ .TH.post("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_1__.signupEndPoint), payload);
        return response.data;
    } catch (err) {
        var ref;
        return thunkAPI.rejectWithValue(err === null || err === void 0 ? void 0 : (ref = err.response) === null || ref === void 0 ? void 0 : ref.data);
    }
});
const forgotPassword = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_9__/* .createAsyncThunk */ .hg)("auth/forgotPassword", async (payload, thunkAPI)=>{
    const { username  } = payload;
    try {
        const CONFIG = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_7__/* .getConfig */ .i)();
        const { apiEndpoints: { oktaChangePasswordUri =""  }  } = CONFIG;
        const { apiEndPointData: { map: { brandUsernameExtension  } = {}  }  } = CONFIG;
        const usernameWithExtension = brandUsernameExtension ? "".concat(username, ".").concat(brandUsernameExtension) : username;
        const response = await _services_auth_service__WEBPACK_IMPORTED_MODULE_3__/* .authClient.forgotPassword */ .U_.forgotPassword({
            username: usernameWithExtension,
            factorType: "EMAIL",
            relayState: oktaChangePasswordUri
        });
        return response.data;
    } catch (err) {
        return thunkAPI.rejectWithValue(err);
    }
});
const logout = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_9__/* .createAsyncThunk */ .hg)("auth/logout", async (payload, thunkAPI)=>{
    try {
        thunkAPI.dispatch(clearAuthState());
        (0,_utils_helper__WEBPACK_IMPORTED_MODULE_4__/* .createPersonaCookie */ .g45)();
        (0,_utils_cart__WEBPACK_IMPORTED_MODULE_5__/* .removeCustomerCartId */ .w$)();
        await _services_auth_service__WEBPACK_IMPORTED_MODULE_3__/* .authClient.signOut */ .U_.signOut({
            clearTokensBeforeRedirect: true
        });
        await _services_auth_service__WEBPACK_IMPORTED_MODULE_3__/* .authClient.session.close */ .U_.session.close();
    } catch (err) {
        var ref;
        return thunkAPI.rejectWithValue(err === null || err === void 0 ? void 0 : (ref = err.response) === null || ref === void 0 ? void 0 : ref.data);
    }
});
const postLogin = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_9__/* .createAsyncThunk */ .hg)("auth/postLogin", async (payload)=>{
    const { user ={}  } = payload;
    if (user === null || user === void 0 ? void 0 : user.sub) {
        // this is email id hashing
        const res = await (0,_utils_helper__WEBPACK_IMPORTED_MODULE_4__/* .shaEncrypt */ .aLl)(user === null || user === void 0 ? void 0 : user.sub);
        (0,_utils_helper__WEBPACK_IMPORTED_MODULE_4__/* .createPersonaCookie */ .g45)();
        return {
            ...payload,
            encryptedEmail: res
        };
    }
});
const authSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_9__/* .createSlice */ .oM)({
    name: "auth",
    initialState,
    reducers: {
        clearAuthState (state, action) {
            (0,_utils_helper__WEBPACK_IMPORTED_MODULE_4__/* .clearAuthToken */ .RnQ)();
            if (window) {
                window.authAccessToken = "";
            }
            state.isAuth = false;
            state.anonymousId = "";
            state.access_token = "";
            state.refresh_token = "";
            state.revalidate_in = "";
            state.user = {};
            state.hashedEmail = "";
            state.customerProspect = "";
            state.auth = {};
            state.hideCustomerSignupCTA = false;
        },
        setAuthData (state, action) {
            const { accessToken ="" , refreshToken ="" , isAuth =false , user ={}  } = action.payload;
            if (accessToken) {
                state.access_token = accessToken;
                if (window) {
                    window.authAccessToken = accessToken;
                }
                if (!isAuth) {
                    localStorage.setItem("okta-anonymous-access-token", accessToken);
                }
            }
            if (refreshToken) {
                state.refresh_token = refreshToken;
                localStorage.setItem("okta-anonymous-refresh-token", refreshToken);
            }
            if (isAuth) state.isAuth = isAuth;
            if (user) state.user = user;
            state.revalidate_in = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_4__/* .revalidateTime */ .uP2)();
        },
        setRevalidateTime (state, action) {
            state.revalidate_in = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_4__/* .revalidateTime */ .uP2)();
        },
        setAuthModalVisibility (state, action) {
            const { show , active =0 , onCloseHandlation =()=>{}  } = action.payload;
            state.authModal = {
                ...state.authModal,
                show: show,
                active: active,
                onCloseHandlation: onCloseHandlation
            };
            state.showCustomerSignup = false;
            state.showProSignup = false;
            state.showForgotPassword = false;
            state.hideCustomerSignupCTA = show ? state.hideCustomerSignupCTA : false;
        },
        setAuthModalActiveTab (state, action) {
            state.authModal = {
                ...state.authModal,
                active: action.payload
            };
        },
        setAuthModalStaticText (state, action) {
            state.authModal = {
                ...state.authModal,
                staticText: action.payload
            };
        },
        setAnonymousId (state, action) {
            const anonymousId = action.payload;
            state.anonymousId = anonymousId;
            localStorage.setItem("anonymousId", anonymousId);
        },
        setShowCartAction (state, action) {
            state.showCartAction = action.payload;
        },
        setShowCustomerSignup (state, action) {
            state.showCustomerSignup = action.payload;
            state.showProSignup = false;
            state.showForgotPassword = false;
            state.authModal = {
                ...state.authModal,
                show: action.payload
            };
        },
        setShowProSignup (state, action) {
            state.showProSignup = action.payload;
            state.showCustomerSignup = false;
            state.showForgotPassword = false;
            state.authModal = {
                ...state.authModal,
                show: action.payload
            };
        },
        setShowForgotPassword (state, action) {
            state.showForgotPassword = action.payload;
            state.showCustomerSignup = false;
            state.showProSignup = false;
            state.authModal = {
                ...state.authModal,
                show: action.payload
            };
        },
        setHideCustomerSignupCTA (state, action) {
            state.hideCustomerSignupCTA = action.payload;
        },
        setPersona (state, action) {
            const { isAuth , user: { uid  }  } = state;
            const { user  } = state;
            if (isAuth) {
                sessionStorage.setItem(_constants_index__WEBPACK_IMPORTED_MODULE_1__["default"].KF_UPDATE_MEMBERSHIP, JSON.stringify({
                    uid
                }));
                localStorage.setItem(_constants_index__WEBPACK_IMPORTED_MODULE_1__["default"].KF_FORCE_RENEW_TOKEN, true);
                state.user = {
                    ...user,
                    persona: [
                        action.payload
                    ]
                };
            }
        },
        setUserName (state, action) {
            const { isAuth , user  } = state;
            var ref;
            const [firstName = "", lastName = ""] = (ref = action === null || action === void 0 ? void 0 : action.payload) !== null && ref !== void 0 ? ref : [];
            if (isAuth) {
                state.user = {
                    ...user,
                    firstName,
                    lastName
                };
            }
        },
        setAuthModalFormData (state, action) {
            state.authModal.formData = action.payload;
        }
    },
    extraReducers (builder) {
        builder.addCase([
            next_redux_wrapper__WEBPACK_IMPORTED_MODULE_2__/* .HYDRATE */ .ju
        ], (state, action)=>{
            return {
                ...state,
                ...action.payload.auth
            };
        }).addCase(getOktaToken.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(getOktaToken.fulfilled, (state, action)=>{
            const { access_token: accessToken = "" , refresh_token: refreshToken = "" , expires_in: expiresIn = "" , scopes =[] , token_type: tokenType = ""  } = action.payload;
            if (state === null || state === void 0 ? void 0 : state.access_token) {
                if (window) {
                    window.authAccessToken = state === null || state === void 0 ? void 0 : state.access_token;
                }
                localStorage.setItem("okta-anonymous-access-token", state === null || state === void 0 ? void 0 : state.access_token);
            } else if (accessToken) {
                state.access_token = accessToken;
                if (window) {
                    window.authAccessToken = accessToken;
                }
                localStorage.setItem("okta-anonymous-access-token", accessToken);
            }
            if (state === null || state === void 0 ? void 0 : state.refresh_token) {
                localStorage.setItem("okta-anonymous-refresh-token", state === null || state === void 0 ? void 0 : state.refresh_token);
            } else if (refreshToken) {
                state.refresh_token = refreshToken;
                localStorage.setItem("okta-anonymous-refresh-token", refreshToken);
            }
            if (expiresIn) state.expires_in = expiresIn;
            if (scopes) state.scopes = scopes;
            if (tokenType) state.token_type = tokenType;
            state.revalidate_in = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_4__/* .revalidateTime */ .uP2)();
            state.status = "succeeded";
            state.error = "";
        }).addCase(getOktaToken.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(login.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(login.rejected, (state, action)=>{
            console.log("LOGIN", action.payload);
        }).addCase(login.fulfilled, (state, action)=>{
            console.log("LOGIN", action.payload);
        }).addCase(signup.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(signup.rejected, (state, action)=>{
            console.log("SIGNUP rejected", action.error);
        }).addCase(signup.fulfilled, (state, action)=>{
            console.log("SIGNUP fulfilled", action.payload);
        }).addCase(postLogin.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(postLogin.fulfilled, (state, action)=>{
            const { payload: { encryptedEmail ="" , accessToken ="" , refreshToken ="" , user ={} , isAuth =""  }  } = action;
            const oldHashedEmail = state.hashedEmail;
            const oldCustomerProspect = state.customerProspect;
            if (accessToken) {
                state.access_token = accessToken;
                if (window) {
                    window.authAccessToken = accessToken;
                }
            }
            if (refreshToken) state.refresh_token = refreshToken;
            if (!lodash_isEmpty__WEBPACK_IMPORTED_MODULE_8___default()(user)) {
                state.user = user;
            }
            if (isAuth !== "") state.isAuth = isAuth;
            if (encryptedEmail) state.hashedEmail = encryptedEmail;
            state.revalidate_in = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_4__/* .revalidateTime */ .uP2)();
            let needsUpdate = false;
            if (oldCustomerProspect && oldHashedEmail === encryptedEmail) {
                // here check if existing customerProspects are outdated
                try {
                    const decryptedCaesar = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_4__/* .caesarDecrypt */ .s80)(encryptedEmail, oldCustomerProspect);
                    const decryptedJSON = JSON.parse(decryptedCaesar);
                    const currDate = new Date().toString();
                    if (decryptedJSON.updatedAt && (0,_utils_helper__WEBPACK_IMPORTED_MODULE_4__/* .hourDifference */ .oC7)(decryptedJSON.updatedAt, currDate) >= 1) {
                        needsUpdate = true;
                    }
                } catch (e) {
                    needsUpdate = true;
                }
            } else {
                needsUpdate = true;
            }
            if (needsUpdate) {
            /**
           * checking 3 conditions here
           *  1. if hashed emails are different
           *  2. if hashed emails are same then check if sync is done 1 hour ago or before that
           *  3. if old customer prospect object is missing from localstorage
           */ // await getPastOrders(true)
            }
        }).addCase(postLogin.rejected, (state, action)=>{
            console.log(action.error);
        }).addCase(logout.fulfilled, (state, action)=>{
            state.cart = {};
        });
    }
});
const { clearAuthState , setAuthData , setRevalidateTime , setAuthModalVisibility , setAuthModalActiveTab , setAuthModalStaticText , setAnonymousId , setShowCustomerSignup , setShowProSignup , setShowForgotPassword , setHideCustomerSignupCTA , setPersona , setUserName , setAuthModalFormData , setShowCartAction  } = authSlice.actions;
const selectAuthState = (state)=>state.auth;
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = (authSlice.reducer);


/***/ }),

/***/ 46201:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Al": function() { return /* binding */ discount; },
/* harmony export */   "Ao": function() { return /* binding */ cartSlice; },
/* harmony export */   "BR": function() { return /* binding */ setPaymetId; },
/* harmony export */   "Bk": function() { return /* binding */ createCart; },
/* harmony export */   "Ii": function() { return /* binding */ mergeCart; },
/* harmony export */   "LR": function() { return /* binding */ setQtyLoading; },
/* harmony export */   "NM": function() { return /* binding */ shipmentUpdate; },
/* harmony export */   "QL": function() { return /* binding */ taxCalculation; },
/* harmony export */   "RV": function() { return /* binding */ setCart; },
/* harmony export */   "Vp": function() { return /* binding */ shareCart; },
/* harmony export */   "Vw": function() { return /* binding */ setNameOnCard; },
/* harmony export */   "Xq": function() { return /* binding */ addToCart; },
/* harmony export */   "YO": function() { return /* binding */ setShipping; },
/* harmony export */   "YZ": function() { return /* binding */ setCardStatus; },
/* harmony export */   "Z5": function() { return /* binding */ removeFromCartLineItem; },
/* harmony export */   "_P": function() { return /* binding */ shareCartaddToCart; },
/* harmony export */   "aN": function() { return /* binding */ orderSubmit; },
/* harmony export */   "al": function() { return /* binding */ deleteCart; },
/* harmony export */   "ap": function() { return /* binding */ shareCartDelete; },
/* harmony export */   "dv": function() { return /* binding */ getCart; },
/* harmony export */   "eM": function() { return /* binding */ setIsPayPalCallback; },
/* harmony export */   "er": function() { return /* binding */ recentlyViewed; },
/* harmony export */   "oJ": function() { return /* binding */ setCartCount; },
/* harmony export */   "pw": function() { return /* binding */ shipmentCart; },
/* harmony export */   "qT": function() { return /* binding */ setNoshipping; },
/* harmony export */   "th": function() { return /* binding */ addresssSuggest; },
/* harmony export */   "w9": function() { return /* binding */ setShowShippingDetails; },
/* harmony export */   "wg": function() { return /* binding */ checkSplitOrder; },
/* harmony export */   "xA": function() { return /* binding */ setCartUrl; },
/* harmony export */   "xw": function() { return /* binding */ selectCartState; }
/* harmony export */ });
/* unused harmony exports shippingCost, addAddress, payment, payPalPayment, increment, decrement, setIsShipmentLoading */
/* harmony import */ var _constants_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73350);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96301);
/* harmony import */ var _constants_routes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64757);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(77236);
/* harmony import */ var next_redux_wrapper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28858);
/* harmony import */ var _utils_cart__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11763);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(88032);
/* harmony import */ var _store_features_authSlice__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(24899);
/* harmony import */ var _store_features_checkoutSlice__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(60475);
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(19514);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(55760);
/* harmony import */ var _utils_payment__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(87864);












const initialState = {
    cart: {
        id: ""
    },
    quantity: 0,
    shipping: {},
    shipment: {},
    cartCount: 0,
    // shpping Items to checkout when product stock available
    shippingItemstoCheckout: [],
    // no items to ship from checkout when product is out of stock
    noShippingItemsInCheckout: [],
    cartUrl: "",
    showShippingDetailsForReview: {
        Parcel: false,
        LTL: false,
        Services: false
    },
    paymentId: "",
    nameOnCard: "",
    status: ""
};
const getCart = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_11__/* .createAsyncThunk */ .hg)("getCart", async function() {
    let payload = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { isNotFromCart ="" , klId =""  } = payload;
    const { cartId =""  } = (0,_utils_cart__WEBPACK_IMPORTED_MODULE_4__/* .getCartIdParams */ .Uo)();
    const url = klId ? "/cart/".concat(klId) // it's for loading customer cart data using KL id
     : "".concat(_constants_index__WEBPACK_IMPORTED_MODULE_1__.getCartEndPoint).concat(isNotFromCart ? "&gfqprofile=refershCartProfile" : "").concat(cartId);
    const { data ={}  } = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.get */ .TH.get(url);
    const { anonymousId =""  } = data;
    _store__WEBPACK_IMPORTED_MODULE_5__/* .store.dispatch */ .h.dispatch((0,_store_features_authSlice__WEBPACK_IMPORTED_MODULE_6__/* .setAnonymousId */ .$t)(anonymousId));
    return data;
});
const createCart = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_11__/* .createAsyncThunk */ .hg)("createCart", async (body, thunkAPI)=>{
    var ref;
    const state = thunkAPI.getState() || {};
    const { user  } = state.auth || {};
    var ref1;
    if (user) body.customerEmail = (ref1 = (ref = user.sub) === null || ref === void 0 ? void 0 : ref.toLowerCase()) !== null && ref1 !== void 0 ? ref1 : "";
    if (user.koc) {
        body.custom = {
            type: {
                key: "order",
                typeId: "type"
            },
            fields: {
                CSRAssociateId: user.koc,
                orderType: "ISC"
            }
        };
    }
    const { data ={}  } = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.post */ .TH.post("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_1__.createCartEndPoint), body);
    const { anonymousId =""  } = data;
    _store__WEBPACK_IMPORTED_MODULE_5__/* .store.dispatch */ .h.dispatch((0,_store_features_authSlice__WEBPACK_IMPORTED_MODULE_6__/* .setAnonymousId */ .$t)(anonymousId));
    return data;
});
const shippingCost = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_11__/* .createAsyncThunk */ .hg)("shippingCost", async (id)=>{
    const response = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.get */ .TH.get("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_1__.shippingCostEndPoint, "?cartId=").concat(id));
    return response.data;
});
const discount = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_11__/* .createAsyncThunk */ .hg)("discount", async (body)=>{
    const { cartId =""  } = (0,_utils_cart__WEBPACK_IMPORTED_MODULE_4__/* .getCartIdParams */ .Uo)();
    const url = "".concat(_constants_index__WEBPACK_IMPORTED_MODULE_1__.discountEndPoint).concat(cartId);
    const response = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.post */ .TH.post(url, body);
    return response.data;
});
const taxCalculation = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_11__/* .createAsyncThunk */ .hg)("tax", async ()=>{
    const { cartId =""  } = (0,_utils_cart__WEBPACK_IMPORTED_MODULE_4__/* .getCartIdParams */ .Uo)();
    const body = {
        actions: [
            {
                action: "calculateTax"
            }
        ]
    };
    const url = "".concat(_constants_index__WEBPACK_IMPORTED_MODULE_1__.taxEndPoint).concat(cartId);
    const response = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.post */ .TH.post(url, body);
    return response.data;
});
const shipmentUpdate = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_11__/* .createAsyncThunk */ .hg)("shipmentUpdate", async (body, thunkAPI)=>{
    try {
        const { cartId =""  } = (0,_utils_cart__WEBPACK_IMPORTED_MODULE_4__/* .getCartIdParams */ .Uo)();
        const url = "".concat(_constants_index__WEBPACK_IMPORTED_MODULE_1__.taxEndPoint).concat(cartId);
        const response = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.post */ .TH.post(url, body);
        return response.data;
    } catch (error) {
        const { response: { data: { isNonDeliverableAddress =false  } = {}  } = {}  } = error;
        return thunkAPI.rejectWithValue({
            isNonDeliverableAddress
        });
    }
});
const shareCart = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_11__/* .createAsyncThunk */ .hg)("sharecart", async (body)=>{
    const response = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.post */ .TH.post("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_1__.shareCartEndPoint), body);
    return response.data;
});
const mergeCart = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_11__/* .createAsyncThunk */ .hg)("cart/merge", async (payload)=>{
    const { data ={}  } = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.post */ .TH.post(_constants_index__WEBPACK_IMPORTED_MODULE_1__.mergeCartEndPoint, payload);
    if (data && data.type === "Cart") {
        _store__WEBPACK_IMPORTED_MODULE_5__/* .store.dispatch */ .h.dispatch((0,_store_features_authSlice__WEBPACK_IMPORTED_MODULE_6__/* .setAnonymousId */ .$t)(""));
    }
    return data;
});
const addToCart = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_11__/* .createAsyncThunk */ .hg)("addToCart", async (body, thunkAPI)=>{
    const persona = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_9__/* .getUserPersona */ .shu)();
    const state = thunkAPI.getState() || {};
    const { cart: { customerGroup  }  } = state.cart;
    if (!customerGroup) {
        const customerGroupData = {};
        customerGroupData["action"] = "setCustomerGroup";
        customerGroupData["customerGroup"] = {
            key: persona
        };
        if (body.actions) {
            body.actions.push(customerGroupData);
        }
    }
    const { cartId =""  } = (0,_utils_cart__WEBPACK_IMPORTED_MODULE_4__/* .getCartIdParams */ .Uo)();
    const url = "".concat(_constants_index__WEBPACK_IMPORTED_MODULE_1__.cartItemsEndPoint, "?expand=calculation").concat(cartId);
    const { data ={}  } = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.post */ .TH.post(url, body);
    const { anonymousId =""  } = data;
    _store__WEBPACK_IMPORTED_MODULE_5__/* .store.dispatch */ .h.dispatch((0,_store_features_authSlice__WEBPACK_IMPORTED_MODULE_6__/* .setAnonymousId */ .$t)(anonymousId));
    return data;
});
const shareCartaddToCart = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_11__/* .createAsyncThunk */ .hg)("shareCartaddToCart", async (body)=>{
    const { cartId ="" , isSharedCart =false , ...restBody } = body;
    const url = "".concat(_constants_index__WEBPACK_IMPORTED_MODULE_1__.sharedCartItemsEndPoint, "?expand=calculation&cartId=").concat(cartId);
    const { data ={}  } = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.post */ .TH.post(url, restBody);
    return {
        data,
        isSharedCart
    };
});
const removeFromCartLineItem = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_11__/* .createAsyncThunk */ .hg)("removeFromCartLineItem", async (body)=>{
    const { cartId =""  } = (0,_utils_cart__WEBPACK_IMPORTED_MODULE_4__/* .getCartIdParams */ .Uo)();
    const url = "".concat(_constants_index__WEBPACK_IMPORTED_MODULE_1__.cartItemsEndPoint, "?expand=calculation").concat(cartId);
    const response = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.post */ .TH.post(url, body);
    return response.data;
});
const deleteCart = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_11__/* .createAsyncThunk */ .hg)("deleteCart", async ()=>{
    const response = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim["delete"] */ .TH["delete"]("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_1__.deleteCartEndPoint));
    return response.data;
});
const shareCartDelete = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_11__/* .createAsyncThunk */ .hg)("shareCartDelete", async (body)=>{
    const { id , version  } = body;
    const response = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim["delete"] */ .TH["delete"]("".concat("/cart/".concat(id, "?cart-versionId=").concat(version)));
    return response.data;
});
const shipmentCart = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_11__/* .createAsyncThunk */ .hg)("shipmentcart", async (body)=>{
    let response;
    const { cartId ="" , cartIdQuery =""  } = (0,_utils_cart__WEBPACK_IMPORTED_MODULE_4__/* .getCartIdParams */ .Uo)();
    const { cart: { cart ={}  }  } = _store__WEBPACK_IMPORTED_MODULE_5__/* .store.getState */ .h.getState() || {};
    _store__WEBPACK_IMPORTED_MODULE_5__/* .store.dispatch */ .h.dispatch(setIsShipmentLoading(true));
    const isXpp = (0,_utils_payment__WEBPACK_IMPORTED_MODULE_10__/* .checkExpPayPal */ .DV)();
    try {
        if (body && (body === null || body === void 0 ? void 0 : body.assign) && (body === null || body === void 0 ? void 0 : body.payload)) {
            const url = "".concat(_constants_index__WEBPACK_IMPORTED_MODULE_1__.shipmentFromCartEndPoint).concat(body.assign ? "?assignshipping=true" : "").concat(cartId);
            response = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.post */ .TH.post(url, body.payload);
        } else {
            const url1 = "".concat(_constants_index__WEBPACK_IMPORTED_MODULE_1__.shipmentFromCartEndPoint).concat(cartIdQuery);
            response = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.post */ .TH.post(url1);
        }
        _store__WEBPACK_IMPORTED_MODULE_5__/* .store.dispatch */ .h.dispatch(setIsShipmentLoading(false));
        _store__WEBPACK_IMPORTED_MODULE_5__/* .store.dispatch */ .h.dispatch((0,_store_features_checkoutSlice__WEBPACK_IMPORTED_MODULE_7__/* .setIsShipmentFromCart */ .ig)(true));
        if (isXpp) {
            _store__WEBPACK_IMPORTED_MODULE_5__/* .store.dispatch */ .h.dispatch((0,_store_features_checkoutSlice__WEBPACK_IMPORTED_MODULE_7__/* .setCheckoutAction */ .BZ)(3));
            _store__WEBPACK_IMPORTED_MODULE_5__/* .store.dispatch */ .h.dispatch((0,_store_features_checkoutSlice__WEBPACK_IMPORTED_MODULE_7__/* .setExpPayPalCheckout */ .gp)(true));
        } else {
            _store__WEBPACK_IMPORTED_MODULE_5__/* .store.dispatch */ .h.dispatch((0,_store_features_checkoutSlice__WEBPACK_IMPORTED_MODULE_7__/* .setCheckoutAction */ .BZ)(1));
        }
        return response.data;
    } catch (error) {
        var ref;
        const { response: { status  } = {}  } = error;
        const shippingDetails = {
            "shipping-details": {
                results: []
            },
            shippingCost: true
        };
        response = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.get */ .TH.get("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_1__.shippingCostEndPoint, "?cartId=").concat(cart === null || cart === void 0 ? void 0 : cart.id));
        shippingDetails["shipping-details"]["results"] = response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : ref.results;
        _store__WEBPACK_IMPORTED_MODULE_5__/* .store.dispatch */ .h.dispatch(setIsShipmentLoading(false));
        _store__WEBPACK_IMPORTED_MODULE_5__/* .store.dispatch */ .h.dispatch((0,_store_features_checkoutSlice__WEBPACK_IMPORTED_MODULE_7__/* .setIsShipmentFromCart */ .ig)(false));
        if (status === 401 || status === 403) {
            _store__WEBPACK_IMPORTED_MODULE_5__/* .store.dispatch */ .h.dispatch((0,_store_features_checkoutSlice__WEBPACK_IMPORTED_MODULE_7__/* .setIsShipmentFromCart */ .ig)(true));
            _store__WEBPACK_IMPORTED_MODULE_5__/* .store.dispatch */ .h.dispatch((0,_store_features_checkoutSlice__WEBPACK_IMPORTED_MODULE_7__/* .setPayPalCallBackErrorMsg */ .SB)(body));
        }
        return shippingDetails;
    }
});
const addresssSuggest = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_11__/* .createAsyncThunk */ .hg)("addresssSuggest", async (addr)=>{
    var ref, ref1;
    const config = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_8__/* .getConfig */ .i)();
    const country = (config === null || config === void 0 ? void 0 : (ref = config.apiEndPointData) === null || ref === void 0 ? void 0 : (ref1 = ref.map) === null || ref1 === void 0 ? void 0 : ref1.experianISOCode) || _constants_index__WEBPACK_IMPORTED_MODULE_1__.ADDRESS_SUGGESTION_DEFAULT_COUNTRY;
    const response = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.get */ .TH.get("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_1__.addressSuggestionEndPoint, "?query=").concat(addr, "&country=").concat(country));
    return response.data;
});
const addAddress = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_11__/* .createAsyncThunk */ .hg)("addAddress", async (body)=>{
    const response = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.post */ .TH.post("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_1__.addAddressEndPoint), body);
    return response.data;
});
const checkSplitOrder = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_11__/* .createAsyncThunk */ .hg)("checkSplitOrder", async (cartId)=>{
    const response = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.get */ .TH.get("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_1__.checkSplitOrderEndPoint, "?cartId=").concat(cartId));
    return response.data;
});
const payment = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_11__/* .createAsyncThunk */ .hg)("payment", async (body)=>{
    const response = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.post */ .TH.post("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_1__.paymentEndPoint), body);
    return response.data;
});
const payPalPayment = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_11__/* .createAsyncThunk */ .hg)("payPalPayment", async (body)=>{
    const response = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.post */ .TH.post("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_1__.payPalPaymentEndPoint), body);
    return response.data;
});
const orderSubmit = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_11__/* .createAsyncThunk */ .hg)("orderSubmit", async (body, thunkAPI)=>{
    const { cartIdQuery =""  } = (0,_utils_cart__WEBPACK_IMPORTED_MODULE_4__/* .getCartIdParams */ .Uo)(true);
    const url = "".concat(_constants_index__WEBPACK_IMPORTED_MODULE_1__.orderSubmitEndPoint).concat(cartIdQuery);
    try {
        const { data , status  } = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.post */ .TH.post(url, body);
        const state = thunkAPI.getState();
        const { auth: { isAuth =false  } = {}  } = state;
        if (status === 201) {
            (0,_utils_cart__WEBPACK_IMPORTED_MODULE_4__/* .removeCustomerCartId */ .w$)();
            if (!isAuth) {
                _store__WEBPACK_IMPORTED_MODULE_5__/* .store.dispatch */ .h.dispatch((0,_store_features_authSlice__WEBPACK_IMPORTED_MODULE_6__/* .clearAuthState */ .j5)());
            }
        }
        return data;
    } catch (error) {
        const { response: { data: data1 = {}  } = {}  } = error;
        return thunkAPI.rejectWithValue(data1);
    }
});
const recentlyViewed = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_11__/* .createAsyncThunk */ .hg)("recentlyViewed", async (query)=>{
    const response = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.get */ .TH.get("".concat(_constants_routes__WEBPACK_IMPORTED_MODULE_2__/* .CATALOG_PROJECTION_ENDPOINT */ .E5, "?where=id in (").concat(query, ")"));
    return response.data;
});
const cartSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_11__/* .createSlice */ .oM)({
    name: "cart",
    initialState,
    reducers: {
        setCart (state, action) {
            state.cart = action.payload;
        },
        setCartCount (state, action) {
            state.cartCount = action.payload;
        },
        setQtyLoading (state, action) {
            state.qtyLoading = action.payload;
        },
        setShipping (state, action) {
            state.shippingItemstoCheckout = action.payload;
        },
        setNoshipping (state, action) {
            var ref;
            const skuIds = action === null || action === void 0 ? void 0 : (ref = action.payload) === null || ref === void 0 ? void 0 : ref.map((item)=>item.sku);
            state.noShippingItemsInCheckout = skuIds || [];
        },
        setShowShippingDetails (state, action) {
            state.showShippingDetailsForReview = action.payload;
        },
        setCartUrl (state, action) {
            state.cartUrl = action.payload;
        },
        setPaymetId (state, action) {
            state.paymentId = action.payload;
        },
        increment (state, action) {
            state.quantity = state.quantity + 1;
        },
        decrement (state, action) {
            state.quantity = state.quantity - 1;
        },
        setNameOnCard (state, action) {
            state.nameOnCard = action.payload;
        },
        setCardStatus (state, action) {
            state.isCartLoading = action.payload;
        },
        setIsPayPalCallback (state, action) {
            state.isPayPalCallback = action.payload;
        },
        setIsShipmentLoading (state, action) {
            state.isShipmentLoading = action.payload;
        }
    },
    extraReducers (builder) {
        builder.addCase([
            next_redux_wrapper__WEBPACK_IMPORTED_MODULE_3__/* .HYDRATE */ .ju
        ], (state, action)=>{
            return {
                ...state,
                ...action.payload.cart
            };
        }).addCase(getCart.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(getCart.fulfilled, (state, action)=>{
            var ref;
            state.cart = action.payload;
            var ref1;
            state.cartCount = (ref1 = (0,_utils_cart__WEBPACK_IMPORTED_MODULE_4__/* .getQuantityCount */ .PW)((ref = action.payload) === null || ref === void 0 ? void 0 : ref.lineItems)) !== null && ref1 !== void 0 ? ref1 : 0;
            state.status = "succeeded";
        }).addCase(getCart.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(createCart.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(createCart.fulfilled, (state, action)=>{
            var ref;
            state.cart = action.payload;
            var ref1;
            state.cartCount = (ref1 = (0,_utils_cart__WEBPACK_IMPORTED_MODULE_4__/* .getQuantityCount */ .PW)((ref = action.payload) === null || ref === void 0 ? void 0 : ref.lineItems)) !== null && ref1 !== void 0 ? ref1 : 0;
            state.status = "succeeded";
        }).addCase(createCart.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(shippingCost.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(shippingCost.fulfilled, (state, action)=>{
            state.shipping = action.payload;
            state.status = "succeeded";
        }).addCase(shippingCost.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(discount.pending, (state)=>{
            state.status = "loading";
        }).addCase(discount.fulfilled, (state, action)=>{
            state.status = "succeeded";
            // after discount this will set cart with updated data
            state.cart = action.payload;
        }).addCase(discount.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(taxCalculation.pending, (state)=>{
            state.status = "loading";
        }).addCase(taxCalculation.fulfilled, (state, action)=>{
            state.status = "succeeded";
            // after tax this will set cart with updated data
            state.cart = action.payload;
        }).addCase(taxCalculation.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(shipmentUpdate.pending, (state)=>{
            state.status = "loading";
        }).addCase(shipmentUpdate.fulfilled, (state, action)=>{
            var ref, ref1;
            state.status = "succeeded";
            // temp
            const activeCart = ((ref = action.payload) === null || ref === void 0 ? void 0 : ref.type) === "Cart" && ((ref1 = action.payload) === null || ref1 === void 0 ? void 0 : ref1.lineItems.length) > 0;
            state.cart = activeCart ? action.payload : state.cart;
        }).addCase(shipmentUpdate.rejected, (state, action)=>{
            var ref;
            state.status = "failed";
            state.error = action.error.message;
            state.isNonDeliverableAddress = (ref = action.payload) === null || ref === void 0 ? void 0 : ref.isNonDeliverableAddress;
        }).addCase(shareCart.pending, (state)=>{
        // state.status = "loading"
        }).addCase(shareCart.fulfilled, (state, action)=>{
        // state.status = "succeeded"
        }).addCase(shareCart.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(addToCart.pending, (state, action)=>{
            // state.status = "loading"
            state.status = "loading";
        }).addCase(addToCart.fulfilled, (state, action)=>{
            var ref;
            state.cart = action.payload;
            var ref1;
            state.cartCount = (ref1 = (0,_utils_cart__WEBPACK_IMPORTED_MODULE_4__/* .getQuantityCount */ .PW)((ref = action.payload) === null || ref === void 0 ? void 0 : ref.lineItems)) !== null && ref1 !== void 0 ? ref1 : 0;
            state.status = "succeeded";
        }).addCase(addToCart.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(deleteCart.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(deleteCart.fulfilled, (state, action)=>{
            // state.cart = { id: action.payload.id, lineItems: [] }
            state.cartCount = 0;
            state.status = "succeeded";
        }).addCase(deleteCart.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(shipmentCart.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(shipmentCart.fulfilled, (state, action)=>{
            var ref;
            if (!((ref = action.payload) === null || ref === void 0 ? void 0 : ref.shippingCost)) {
                state.cart = {
                    ...state.cart,
                    ...action.payload
                };
            }
            state.status = "succeeded";
        }).addCase(shipmentCart.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(addresssSuggest.pending, (state, action)=>{
        // state.status = "loading"
        }).addCase(addresssSuggest.fulfilled, (state, action)=>{
            state.status = "succeeded";
        }).addCase(addresssSuggest.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(addAddress.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(addAddress.fulfilled, (state, action)=>{
            // state.cart = action.payload
            state.status = "succeeded";
        }).addCase(addAddress.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(checkSplitOrder.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(checkSplitOrder.fulfilled, (state, action)=>{
            state.cart = {
                ...state.cart,
                ...action.payload
            };
            state.status = "succeeded";
        }).addCase(checkSplitOrder.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(mergeCart.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(mergeCart.fulfilled, (state, action)=>{
            var ref;
            state.cart = action.payload;
            var ref1;
            state.cartCount = (ref1 = (0,_utils_cart__WEBPACK_IMPORTED_MODULE_4__/* .getQuantityCount */ .PW)((ref = action.payload) === null || ref === void 0 ? void 0 : ref.lineItems)) !== null && ref1 !== void 0 ? ref1 : 0;
            state.status = "succeeded";
        }).addCase(mergeCart.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(payment.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(payment.fulfilled, (state, action)=>{
            state.status = "succeeded";
        }).addCase(payment.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(payPalPayment.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(payPalPayment.fulfilled, (state, action)=>{
            state.status = "succeeded";
        }).addCase(payPalPayment.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(orderSubmit.pending, (state, action)=>{
            state.status = "loading" || 0;
        }).addCase(orderSubmit.fulfilled, (state, action)=>{
            // state.cart = action.payload
            state.status = "succeeded" || 0;
        }).addCase(orderSubmit.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message || "";
        }).addCase(removeFromCartLineItem.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(removeFromCartLineItem.fulfilled, (state, action)=>{
            var ref;
            state.cart = action.payload;
            var ref1;
            state.cartCount = (ref1 = (0,_utils_cart__WEBPACK_IMPORTED_MODULE_4__/* .getQuantityCount */ .PW)((ref = action.payload) === null || ref === void 0 ? void 0 : ref.lineItems)) !== null && ref1 !== void 0 ? ref1 : 0;
            state.status = "succeeded";
        }).addCase(removeFromCartLineItem.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(recentlyViewed.pending, (state)=>{
            state.status = "loading";
        }).addCase(recentlyViewed.fulfilled, (state, action)=>{
            state.status = "succeeded";
        }).addCase(recentlyViewed.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(shareCartaddToCart.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(shareCartaddToCart.fulfilled, (state, action)=>{
            const { data , isSharedCart  } = action.payload;
            if (!isSharedCart) state.cart = data;
            var ref;
            state.cartCount = (ref = (0,_utils_cart__WEBPACK_IMPORTED_MODULE_4__/* .getQuantityCount */ .PW)(data === null || data === void 0 ? void 0 : data.lineItems)) !== null && ref !== void 0 ? ref : 0;
            state.status = "succeeded";
        }).addCase(shareCartaddToCart.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(shareCartDelete.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(shareCartDelete.fulfilled, (state, action)=>{
            state.cart = {
                id: action.payload.id,
                lineItems: []
            };
            state.cartCount = 0;
            state.shippingItemstoCheckout = [];
            state.status = "succeeded";
        }).addCase(shareCartDelete.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        });
    }
});
const { setCart , increment , decrement , setCartCount , setQtyLoading , setCartUrl , setShipping , setNoshipping , setShowShippingDetails , setPaymetId , setNameOnCard , setCardStatus , setIsPayPalCallback , setIsShipmentLoading  } = cartSlice.actions;
const selectCartState = (state)=>state.cart;
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = (cartSlice.reducer);


/***/ }),

/***/ 60475:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ai": function() { return /* binding */ getProfile; },
/* harmony export */   "BZ": function() { return /* binding */ setCheckoutAction; },
/* harmony export */   "Bp": function() { return /* binding */ setIsVerifiedAddress; },
/* harmony export */   "Ds": function() { return /* binding */ setIsInvalidCountryAction; },
/* harmony export */   "Fc": function() { return /* binding */ setPaymentErrorMessageAction; },
/* harmony export */   "I2": function() { return /* binding */ setPaymentMethodNameAction; },
/* harmony export */   "JN": function() { return /* binding */ setCardLastDigit; },
/* harmony export */   "Pk": function() { return /* binding */ setPaymentDisableBtnAction; },
/* harmony export */   "RM": function() { return /* binding */ setPaymentFailedAction; },
/* harmony export */   "SB": function() { return /* binding */ setPayPalCallBackErrorMsg; },
/* harmony export */   "TG": function() { return /* binding */ checkoutState; },
/* harmony export */   "Yb": function() { return /* binding */ editAddress; },
/* harmony export */   "_K": function() { return /* binding */ setDefaultAddress; },
/* harmony export */   "gp": function() { return /* binding */ setExpPayPalCheckout; },
/* harmony export */   "hK": function() { return /* binding */ setIsPaymentInfoAction; },
/* harmony export */   "ig": function() { return /* binding */ setIsShipmentFromCart; },
/* harmony export */   "jJ": function() { return /* binding */ setPlaceOrderCountsAction; },
/* harmony export */   "t5": function() { return /* binding */ setPaymentTechnicalFailedAction; },
/* harmony export */   "vu": function() { return /* binding */ checkoutSlice; },
/* harmony export */   "wC": function() { return /* binding */ setBillingAddress; },
/* harmony export */   "y$": function() { return /* binding */ addAddress; }
/* harmony export */ });
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77236);
/* harmony import */ var _constants_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73350);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96301);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55760);




const initialState = {
    status: "",
    error: "",
    addresses: [],
    isVerifiedAddress: false,
    profileInfo: null,
    profileVersion: null,
    nextDefaultAddressId: null,
    isExpPayPalCheckout: false,
    paymentMethod: "",
    payPalCallBackErrorMsg: "",
    cardLastDigit: "",
    paymentErrorMessage: "",
    paymentMethodName: "",
    placeOrderCounts: 1,
    isShipmentFromCart: false
};
const editAddress = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createAsyncThunk */ .hg)("customer/address/edit", async (payload, thunkAPI)=>{
    let addresses = [];
    const body = {
        actions: [
            {
                action: "changeAddress",
                addressId: payload.id,
                address: payload.address
            }
        ],
        version: payload.version
    };
    try {
        const res = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.post */ .TH.post("".concat(_constants__WEBPACK_IMPORTED_MODULE_1__.editAddressEndPoint), body);
        if (res && res.data) {
            if (res.data.addresses.length > 0) {
                var ref;
                var ref1;
                addresses = (ref1 = (ref = res.data.addresses) === null || ref === void 0 ? void 0 : ref.filter((addr)=>{
                    var ref, ref1;
                    return ((ref = addr.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.label) !== "Profile";
                })) !== null && ref1 !== void 0 ? ref1 : [];
                if (payload.address.setPrimary) {
                    res.data.setPrimary = true;
                    res.data.nextDefaultAddressId = payload.id;
                }
            }
        }
        res.data.addresses = addresses;
        return res.data;
    } catch (error) {
        const { response: { data: { isNonDeliverableAddress =false  } = {}  } = {}  } = error;
        return thunkAPI.rejectWithValue({
            isNonDeliverableAddress
        });
    }
});
const addAddress = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createAsyncThunk */ .hg)("customer/address/add", async (payload, thunkAPI)=>{
    let addresses = [];
    const body = Array.isArray(payload.address) ? {
        version: payload.version,
        actions: payload.data
    } : {
        version: payload.version,
        actions: [
            {
                action: "addAddress",
                address: payload.address
            }
        ]
    };
    try {
        const res = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.post */ .TH.post("".concat(_constants__WEBPACK_IMPORTED_MODULE_1__.editAddressEndPoint), body);
        if (res && res.data) {
            if (res.data.addresses.length > 0) {
                var ref;
                var ref1;
                addresses = (ref1 = (ref = res.data.addresses) === null || ref === void 0 ? void 0 : ref.filter((addr)=>{
                    var ref, ref1;
                    return ((ref = addr.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.label) !== "Profile";
                })) !== null && ref1 !== void 0 ? ref1 : [];
                if (payload.address.setPrimary) {
                    var ref2;
                    const index = addresses.length - 1;
                    res.data.setPrimary = true;
                    res.data.nextDefaultAddressId = (ref2 = addresses[index]) === null || ref2 === void 0 ? void 0 : ref2.id;
                }
            }
        }
        res.data.addresses = addresses;
        return res.data;
    } catch (error) {
        const { response: { data: { isNonDeliverableAddress =false  } = {}  } = {}  } = error;
        return thunkAPI.rejectWithValue({
            isNonDeliverableAddress
        });
    }
});
const setDefaultAddress = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createAsyncThunk */ .hg)("customer/default/address", async (payload)=>{
    const resPayload = {
        addresses: [],
        defaultShippingAddressId: ""
    };
    const body = {
        version: payload.profileVersion,
        actions: [
            {
                action: "setDefaultShippingAddress",
                addressId: payload.id
            }
        ]
    };
    const res = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.post */ .TH.post("".concat(_constants__WEBPACK_IMPORTED_MODULE_1__.editAddressEndPoint), body);
    if (res && res.data) {
        resPayload.version = res.data.version;
        if (res.data.addresses.length > 0) {
            var ref;
            var ref1;
            resPayload.addresses = (ref1 = (ref = res.data.addresses) === null || ref === void 0 ? void 0 : ref.filter((addr)=>{
                var ref, ref1;
                return ((ref = addr.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.label) !== "Profile";
            })) !== null && ref1 !== void 0 ? ref1 : [];
            resPayload.defaultShippingAddressId = res.data.defaultShippingAddressId;
        }
    }
    return resPayload;
});
const getProfile = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createAsyncThunk */ .hg)("customer/me", async ()=>{
    var ref, ref1;
    let profile = {};
    let index = 0;
    let addresses = {};
    const response = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.get */ .TH.get("".concat(_constants__WEBPACK_IMPORTED_MODULE_1__.GET_PROFILE_ENDPOINT));
    profile = response.data;
    const profileAddr = profile === null || profile === void 0 ? void 0 : (ref = profile.addresses) === null || ref === void 0 ? void 0 : ref.find((addr)=>{
        var ref, ref1;
        return ((ref = addr.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.label) === "Profile";
    });
    profile["profileAddrId"] = profileAddr === null || profileAddr === void 0 ? void 0 : profileAddr.id;
    profile["addresses"] = profile === null || profile === void 0 ? void 0 : (ref1 = profile.addresses) === null || ref1 === void 0 ? void 0 : ref1.filter((addr)=>{
        var ref, ref1;
        return ((ref = addr.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.label) !== "Profile";
    });
    addresses = profile === null || profile === void 0 ? void 0 : profile.addresses;
    if (profile === null || profile === void 0 ? void 0 : profile.defaultShippingAddressId) {
        index = addresses.findIndex((item)=>{
            return item.id === (profile === null || profile === void 0 ? void 0 : profile.defaultShippingAddressId);
        });
    }
    if (index !== 0) {
        addresses = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_2__/* .arrayMove */ .RpN)(profile === null || profile === void 0 ? void 0 : profile.addresses, index, 0);
    }
    profile["addresses"] = addresses;
    response["data"] = profile;
    return response.data;
});
const checkoutSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createSlice */ .oM)({
    name: "checkout",
    initialState,
    reducers: {
        setIsPaymentInfoAction (state, action) {
            state.isPaymentInfo = action.payload;
        },
        setPaymentMethodNameAction (state, action) {
            state.paymentMethodName = action.payload;
        },
        setCheckoutAction (state, action) {
            state.checkoutStep = action.payload;
        },
        setPaymentFailedAction (state, action) {
            state.isPaymentFailed = action.payload;
        },
        setIsInvalidCountryAction (state, action) {
            state.isInvalidCountry = action.payload;
        },
        setPaymentTechnicalFailedAction (state, action) {
            state.isPaymentTechnicalErrorFailed = action.payload;
        },
        setPaymentErrorMessageAction (state, action) {
            state.paymentErrorMessage = action.payload;
        },
        setCardLastDigit (state, action) {
            state.cardLastDigit = action.payload;
        },
        setPaymentDisableBtnAction (state, action) {
            state.isPaymentDisableAction = action.payload;
        },
        setPlaceOrderCountsAction (state, action) {
            state.placeOrderCounts = action.payload;
        },
        setBillingAddress (state, action) {
            state.billingAddress = action.payload;
        },
        setExpPayPalCheckout (state, action) {
            state.isExpPayPalCheckout = action.payload;
        },
        setPayPalCallBackErrorMsg: (state, action)=>{
            state.payPalCallBackErrorMsg = action.payload;
        },
        setIsVerifiedAddress: (state, action)=>{
            state.isVerifiedAddress = action.payload;
        },
        setIsShipmentFromCart: (state, action)=>{
            state.isShipmentFromCart = action.payload;
        }
    },
    extraReducers (builder) {
        builder.addCase(editAddress.pending, (state)=>{
            state.status = "loading";
        }).addCase(editAddress.fulfilled, (state, action)=>{
            state.status = "succeeded";
            const { addresses , version , nextDefaultAddressId , setPrimary  } = action.payload;
            state.addresses = addresses;
            state.profileVersion = version;
            if (setPrimary) {
                state.nextDefaultAddressId = nextDefaultAddressId;
            }
        }).addCase(editAddress.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(setDefaultAddress.pending, (state)=>{
            state.status = "loading";
        }).addCase(setDefaultAddress.fulfilled, (state, action)=>{
            state.status = "succeeded";
            const { addresses , version  } = action.payload;
            state.addresses = addresses;
            state.profileVersion = version;
        }).addCase(setDefaultAddress.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(getProfile.pending, (state)=>{
            state.status = "loading";
        }).addCase(getProfile.fulfilled, (state, action)=>{
            state.status = "succeeded";
            state.profileInfo = action.payload;
            state.profileVersion = action.payload.version;
        }).addCase(getProfile.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(addAddress.pending, (state)=>{
            state.status = "loading";
        }).addCase(addAddress.fulfilled, (state, action)=>{
            state.status = "succeeded";
            const { addresses , version , nextDefaultAddressId , setPrimary , defaultShippingAddressId  } = action.payload;
            state.addresses = addresses;
            state.profileVersion = version;
            state.defaultAddressId = defaultShippingAddressId;
            if (setPrimary) {
                state.nextDefaultAddressId = nextDefaultAddressId;
            }
        }).addCase(addAddress.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        });
    }
});
const { setIsPaymentInfoAction , setPaymentMethodNameAction , setCheckoutAction , setPaymentFailedAction , setIsInvalidCountryAction , setBillingAddress , setPaymentErrorMessageAction , setPaymentTechnicalFailedAction , setPaymentDisableBtnAction , setPlaceOrderCountsAction , setCardLastDigit , setExpPayPalCheckout , setPayPalCallBackErrorMsg , setIsVerifiedAddress , setIsShipmentFromCart  } = checkoutSlice.actions;
const checkoutState = (state)=>state.checkout;


/***/ }),

/***/ 39915:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Er": function() { return /* binding */ updateCompareStatus; },
/* harmony export */   "JY": function() { return /* binding */ clearProduct; },
/* harmony export */   "NP": function() { return /* binding */ compareState; },
/* harmony export */   "Oe": function() { return /* binding */ clearAllCompareProducts; },
/* harmony export */   "Sw": function() { return /* binding */ setCompareExpiry; },
/* harmony export */   "qD": function() { return /* binding */ compareSlice; },
/* harmony export */   "rI": function() { return /* binding */ addCompareProducts; }
/* harmony export */ });
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(77236);

const initialState = {
    category: "",
    comparedProducts: [],
    expiresIn: 60,
    isEnable: false,
    compareSectionData: []
};
const compareSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__/* .createSlice */ .oM)({
    name: "compare",
    initialState,
    reducers: {
        clearProduct (state, action) {
            state.comparedProducts.forEach((obj)=>{});
            const products = state.comparedProducts.filter((product)=>product.compareSku !== action.payload);
            const query = products.map((item)=>item.compareSku).join(",");
            const path = "".concat(products.length > 0 ? "?compare=" : "").concat(query.toString());
            if (!query) {
                window.history.replaceState(null, "", window.location.pathname);
            } else {
                window.history.replaceState(window.location.pathname, document.title, path);
            }
            state.category = products.length === 0 ? "" : state.category;
            state.comparedProducts = products;
        },
        setCompareExpiry (state, action) {
            state.expiresIn = action.payload;
        },
        clearAllCompareProducts (state, action) {
            state.category = "";
            state.comparedProducts = [];
        },
        addCompareProducts (state, action) {
            try {
                const { expiresIn  } = state;
                const { productData ={} , backorder =false , compareSku ="" , compareSectionData =[] , slug =""  } = action.payload;
                const product = productData;
                if (product && Object.keys(product).length > 0) {
                    product.compareSku = compareSku || productData.sku_s;
                    product.expiry = Date.now() + expiresIn * 24 * 3600 * 1000;
                    product.backorder = backorder;
                    product.slug = slug;
                    const productsTemp = state.comparedProducts;
                    const prodMain = productsTemp.filter((obj)=>{
                        return obj.compareSku !== productData.sku_s;
                    });
                    prodMain.push(product);
                    state.comparedProducts = prodMain;
                    var _ProductLocalCategory_s;
                    state.category = productData.Product_Category ? productData.Product_Category : (_ProductLocalCategory_s = productData.ProductLocalCategory_s) !== null && _ProductLocalCategory_s !== void 0 ? _ProductLocalCategory_s : "";
                    state.compareSectionData = compareSectionData;
                }
                state.isEnable = false;
            } catch (error) {
                state.isEnable = false;
            }
        },
        updateCompareStatus (state, action) {
            state.isEnable = action.payload;
        }
    }
});
const { setCompareExpiry , clearAllCompareProducts , addCompareProducts , clearProduct , updateCompareStatus  } = compareSlice.actions;
const compareState = (state)=>state.compare;


/***/ }),

/***/ 7737:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "kn": function() { return /* binding */ addListLineItemQuantity; },
  "rA": function() { return /* binding */ addMedia; },
  "gK": function() { return /* binding */ addProduct; },
  "XV": function() { return /* binding */ addProductToList; },
  "Lu": function() { return /* binding */ deleteMultiProductFromList; },
  "D3": function() { return /* binding */ deleteProductFromList; },
  "iF": function() { return /* binding */ deleteUserList; },
  "Du": function() { return /* binding */ editList; },
  "MY": function() { return /* binding */ favoritesSlice; },
  "_l": function() { return /* binding */ getFavorites; },
  "Vb": function() { return /* binding */ getListFirstLineItemsData; },
  "w": function() { return /* binding */ getMyAccountFavorites; },
  "jP": function() { return /* binding */ getMyAccountLists; },
  "WQ": function() { return /* binding */ getMyAccountListsWithLineItems; },
  "Co": function() { return /* binding */ getProductBySlug; },
  "s$": function() { return /* binding */ moveItemsFromList; },
  "tC": function() { return /* binding */ myAccountRemoveItems; },
  "Er": function() { return /* binding */ removeItems; },
  "Qx": function() { return /* binding */ selectFavoritesState; }
});

// UNUSED EXPORTS: createFavorite, default, setFavorites, setLoginFavouriteCallback

// EXTERNAL MODULE: ./constants/api.js
var api = __webpack_require__(73350);
// EXTERNAL MODULE: ./node_modules/@reduxjs/toolkit/dist/redux-toolkit.esm.js + 2 modules
var redux_toolkit_esm = __webpack_require__(77236);
// EXTERNAL MODULE: ./node_modules/next-redux-wrapper/es6/index.js
var es6 = __webpack_require__(28858);
// EXTERNAL MODULE: ./store/index.js + 4 modules
var store = __webpack_require__(88032);
// EXTERNAL MODULE: ./constants/routes.js
var routes = __webpack_require__(64757);
// EXTERNAL MODULE: ./constants/index.js
var constants = __webpack_require__(96301);
// EXTERNAL MODULE: ./utils/helper.js + 1 modules
var helper = __webpack_require__(55760);
// EXTERNAL MODULE: ./constants/regex.js
var regex = __webpack_require__(49139);
;// CONCATENATED MODULE: ./utils/favouritesHelper.js


const addDataLayerFav = function() {
    let msg = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", isSuccess = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, type = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", internalLinkType = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", zone = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "", videoName = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : "", videoId = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : "", imageName = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : "";
    var ref;
    const sharedZoneName = (ref = zone === null || zone === void 0 ? void 0 : zone.replace(regex/* SPECIAL_CHAR_REGEX */.FU, " ")) !== null && ref !== void 0 ? ref : "";
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const { pageInfo: { contentType  }  } = page;
    const sharedInternalLinkType = internalLinkType ? (0,helper/* sanitizeTextForAnalytics */.T68)(internalLinkType) : "teaser";
    const cleanSharedInternalLinkType = (0,helper/* cleanText */.FV)(sharedInternalLinkType);
    const sharedInternalLinkZoneName = sharedZoneName ? (0,helper/* sanitizeTextForAnalytics */.T68)(sharedZoneName) : "teaser";
    const eventPageType = contentType === "locations" ? "locations:kohler stores" : window.eventPageType;
    const isPdp = eventPageType === "pdp";
    const pageType = "".concat(eventPageType, ":").concat(sharedInternalLinkZoneName);
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(pageType, ":favorite ").concat(type),
        eventName: "".concat(pageType, ":favorite ").concat(type),
        eventMsg: msg || "n/a",
        eventStatus: isSuccess ? "success" : "failure",
        eventType: "navigation",
        internalLinkName: "favorite ".concat(type),
        internalLinkPosition: eventPageType,
        internalLinkType: "".concat(eventPageType, ":").concat(cleanSharedInternalLinkType),
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(eventPageType, ":").concat(sharedInternalLinkZoneName)
    };
    if (videoName) eventInfo.videoName = videoName;
    if (videoId) eventInfo.videoId = videoId;
    if (imageName) eventInfo.imageName = imageName;
    const dataLayerObj = {
        event: "cmp:click",
        eventInfo,
        page
    };
    if (isPdp) {
        const { pageInfo: { pageUrl  } , productInfo  } = page;
        const isAdd = type === "add" ? true : type === "remove" ? false : true;
        const eventInfoPdp = {
            clickInternalLinks: "true",
            eventAction: "pdp:product details:favorite ".concat(type),
            eventName: "pdp:product details:favorite ".concat(type),
            eventMsg: isAdd ? "your item has been saved to your favorites." : "item has been removed from your favorites.",
            eventStatus: "success",
            eventType: isAdd ? "wishlist save" : "navigation",
            internalLinkName: "favorite ".concat(type),
            internalLinkPosition: "pdp".concat((productInfo === null || productInfo === void 0 ? void 0 : productInfo.pdpType) === "bundle" ? ":bundle" : ""),
            internalLinkType: "pdp:favorites",
            internalLinkURL: pageUrl || "n/a",
            internalLinkZoneName: "pdp:product details"
        };
        dataLayerObj["productInfo"] = productInfo;
        dataLayerObj["eventInfo"] = eventInfoPdp;
    }
    window.adobeDataLayer.push(dataLayerObj);
    delete window.zoneName;
    delete window.internalLinkType;
};

// EXTERNAL MODULE: ./constants/config.js
var constants_config = __webpack_require__(19514);
// EXTERNAL MODULE: ./utils/ApiUtil.js
var ApiUtil = __webpack_require__(51666);
;// CONCATENATED MODULE: ./store/features/favoritesSlice.js











const initialState = {
    favorites: {},
    status: "",
    fullFavoriteData: {},
    isLoginFavouriteCallback: {
        isCallBack: false,
        callBackAssetID: ""
    },
    saveToListLineItems: {},
    userListItemsSkus: {},
    userLists: []
};
const shoppingListName = "Favorites";
const getFavorites = (0,redux_toolkit_esm/* createAsyncThunk */.hg)("getFavorites", async ()=>{
    const config = await (0,constants_config/* getConfig */.i)();
    const { internationalization: { locale: newLocale = "en-US"  } = {}  } = config;
    const locale = newLocale === "fr-CA" ? "en-CA" : newLocale;
    const response = await api/* apim.get */.TH.get("".concat(constants.favoritesEndPoint, "?lang=").concat(locale));
    var ref;
    const { results  } = (ref = response === null || response === void 0 ? void 0 : response.data) !== null && ref !== void 0 ? ref : {
        results: []
    };
    if (results.length > 0) {
        const getVersion = Math.max(...results.map((i)=>i.version));
        const favoritesData = results.filter((item)=>item.name[locale] === "Favorites" && item.version === getVersion);
        const { textLineItems =[]  } = favoritesData[0];
        if (textLineItems.length > 0) (0,helper/* checkIsFavorite */.GsT)(textLineItems);
        if (favoritesData.length) {
            return favoritesData[0];
        }
    }
    return {};
});
const deleteUserList = (0,redux_toolkit_esm/* createAsyncThunk */.hg)("deleteUserList", async (list)=>{
    const response = await api/* apim.delete */.TH["delete"]("".concat(constants.USER_LIST_DELETE_END_POINT, "/").concat(list === null || list === void 0 ? void 0 : list.id, "?version=").concat(list === null || list === void 0 ? void 0 : list.version));
    return response;
});
const deleteProductFromList = (0,redux_toolkit_esm/* createAsyncThunk */.hg)("deleteProductFromList", async (list)=>{
    const response = await api/* apim.post */.TH.post("".concat(constants.USER_LIST_PRODUCT_DELETE_POINT, "/").concat(list === null || list === void 0 ? void 0 : list.listId), {
        version: list.listVersion,
        actions: [
            {
                action: "removeLineItem",
                lineItemId: list.id
            }
        ]
    });
    return response;
});
const getMyAccountListsWithLineItems = (0,redux_toolkit_esm/* createAsyncThunk */.hg)("getMyAccountListsWithLineItems", async ()=>{
    const config = await (0,constants_config/* getConfig */.i)();
    const { internationalization: { locale: newLocale = "en-US"  } = {}  } = config;
    const locale = newLocale === "fr-CA" ? "en-CA" : newLocale;
    const response = await api/* apim.get */.TH.get("".concat(constants.FAVORITES_LIST_END_POINT, "?lang=").concat(locale, "&limit=").concat(constants.FAVORITES_LIST_LIMIT));
    var ref;
    const { results  } = (ref = response === null || response === void 0 ? void 0 : response.data) !== null && ref !== void 0 ? ref : {
        results: []
    };
    const maxVersionLists = (0,ApiUtil/* getMaxVersionLists */.Lp)(results, locale);
    const listItems = (0,ApiUtil/* getUserListLineItems */.ZV)(maxVersionLists);
    return [
        listItems,
        maxVersionLists
    ];
});
const getMyAccountLists = (0,redux_toolkit_esm/* createAsyncThunk */.hg)("getMyAccountLists", async ()=>{
    const config = await (0,constants_config/* getConfig */.i)();
    const { internationalization: { locale: newLocale = "en-US"  } = {}  } = config;
    const locale = newLocale === "fr-CA" ? "en-CA" : newLocale;
    const response = await api/* apim.get */.TH.get("".concat(constants.FAVORITES_LIST_END_POINT, "?lang=").concat(locale, "&limit=").concat(constants.FAVORITES_LIST_LIMIT));
    var ref;
    const { results  } = (ref = response === null || response === void 0 ? void 0 : response.data) !== null && ref !== void 0 ? ref : {
        results: []
    };
    return (0,ApiUtil/* getMaxVersionLists */.Lp)(results, locale);
});
const getListFirstLineItemsData = (0,redux_toolkit_esm/* createAsyncThunk */.hg)("getListFirstLineItemsData", async function(list) {
    let allItems = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    const { lineItems =[]  } = list;
    if (lineItems.length) {
        var ref, ref1, ref2, ref3;
        const config = await (0,constants_config/* getConfig */.i)();
        const productId = (ref = lineItems[0]) === null || ref === void 0 ? void 0 : ref.productId;
        const productIds = lineItems.map((item)=>item.productId);
        const persona = (0,helper/* getUserPersona */.shu)();
        const fl = (0,helper/* getProductFlgs */.Ezx)(persona);
        var ref4;
        const language = (ref4 = config === null || config === void 0 ? void 0 : (ref1 = config.internationalization) === null || ref1 === void 0 ? void 0 : ref1.language) !== null && ref4 !== void 0 ? ref4 : "en";
        const res = await api/* apim.get */.TH.get("/search/plp", {
            params: {
                q: "*:*",
                fq: 'ctId_s:("'.concat(allItems ? productIds.join('","') : productId, '") && language_s:("').concat(language, '")'),
                rows: allItems ? productIds === null || productIds === void 0 ? void 0 : productIds.length : constants.FAVORITES_LIST_LIMIT,
                fl: fl.join(","),
                collections: "kohler",
                profilename: "profile_kohler_Full_Catalog"
            }
        });
        var ref5;
        const productData = (ref5 = (ref2 = res.data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.response) === null || ref3 === void 0 ? void 0 : ref3.docs) !== null && ref5 !== void 0 ? ref5 : [];
        return productData;
    }
});
const getMyAccountFavorites = (0,redux_toolkit_esm/* createAsyncThunk */.hg)("getMyAccountFavorites", async (query)=>{
    const config = await (0,constants_config/* getConfig */.i)();
    const { internationalization: { locale: newLocale = "en-US"  } = {}  } = config;
    const locale = newLocale === "fr-CA" ? "en-CA" : newLocale;
    const response = await api/* apim.get */.TH.get("".concat(constants.favoritesEndPoint, "?lang=").concat(locale));
    const { results  } = response.data;
    if ((results === null || results === void 0 ? void 0 : results.length) > 0) {
        const getVersion = Math.max(...results.map((i)=>i.version));
        const d = results.filter((i)=>i.name[locale] === "Favorites" && i.version === getVersion)[0];
        if (d) {
            var ref, ref1, ref2, ref3, ref4, ref5;
            const { lineItems =[] , textLineItems =[]  } = d;
            const productIds = lineItems.map((item)=>item.productId);
            const persona = (0,helper/* getUserPersona */.shu)();
            const fl = [
                "masterSKU_s",
                "SKUColorSwatchFilename_ss",
                "ProductDescriptionProductShort_s",
                "ProductBrandName_s",
                "metaTitle_s",
                "productName_s",
                "id",
                "productImages.url_ss",
                "slug_s",
                "Product_Category",
                "displayPriceStartingAt_s",
                "Tile_Title",
                "ProductIsExclusive_s",
                "RegionReleaseforShipment_dt",
                "Color.SKU.Details_ss",
                "productImages.labelWithUrl_ss",
                "variantList.sku_ss",
                "RegionBrandName_s",
                "priceList.".concat(persona, ".discountedPrice_d"),
                "priceList.".concat(persona, ".saleOffer_s"),
                "priceList.".concat(persona, ".finalPrice_d"),
                "priceList.".concat(persona, ".price_d"),
                "Color.".concat(persona, ".Details_ss"),
                "ctId_s",
                "Brand_ss",
                "Country_ss"
            ];
            var ref6;
            const language = (ref6 = config === null || config === void 0 ? void 0 : (ref = config.internationalization) === null || ref === void 0 ? void 0 : ref.language) !== null && ref6 !== void 0 ? ref6 : "en";
            var ref7;
            const canadianPrice = (ref7 = config === null || config === void 0 ? void 0 : (ref1 = config.apiEndPointData) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.map) === null || ref2 === void 0 ? void 0 : ref2.canadianPrice) !== null && ref7 !== void 0 ? ref7 : null;
            var ref8;
            const params = {
                q: "*:*",
                fq: 'ctId_s:("'.concat(productIds.join('","'), '") && language_s:("').concat(language, '")'),
                fl: fl.join(","),
                collections: (ref8 = config === null || config === void 0 ? void 0 : (ref3 = config.general) === null || ref3 === void 0 ? void 0 : ref3.siteName) !== null && ref8 !== void 0 ? ref8 : "Kohler",
                start: 0,
                rows: 50,
                sessionId: (0,ApiUtil/* getSessionIdObjWithEpoc */.oq)()
            };
            // Conditionally add `canadianPrice` if it has a value
            if (canadianPrice) {
                params.CanadianPrice = canadianPrice;
            }
            const res = await api/* apim.get */.TH.get(routes/* SEARCH_FULL_CATALOG */.r5, {
                params
            });
            var ref9;
            const productData = (ref9 = (ref4 = res.data) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.response) === null || ref5 === void 0 ? void 0 : ref5.docs) !== null && ref9 !== void 0 ? ref9 : [];
            if (productData.length > 0) {
                lineItems.forEach((item, index, items)=>{
                    const product = productData.find((product)=>{
                        return product["ctId_s"] === (item === null || item === void 0 ? void 0 : item.productId);
                    });
                    items[index].productData = product;
                });
            }
            let sortLineItems = [];
            if (lineItems.length > 0) {
                sortLineItems = lineItems.sort(function(a, b) {
                    return new Date(b.addedAt) - new Date(a.addedAt);
                });
            }
            let sortTextLineItems = [];
            if (textLineItems.length > 0) {
                sortTextLineItems = textLineItems.sort(function(a, b) {
                    return new Date(b.addedAt) - new Date(a.addedAt);
                });
            }
            return {
                sortProducts: sortLineItems !== null && sortLineItems !== void 0 ? sortLineItems : [],
                sortMedia: sortTextLineItems !== null && sortTextLineItems !== void 0 ? sortTextLineItems : [],
                d
            };
        } else {
            await store/* store.dispatch */.h.dispatch(createFavorite());
        }
    }
    return null;
});
const createFavorite = (0,redux_toolkit_esm/* createAsyncThunk */.hg)("createFavorite", async ()=>{
    const config = await (0,constants_config/* getConfig */.i)();
    const { internationalization: { locale: newLocale = "en-US"  } = {}  } = config;
    const locale = newLocale === "fr-CA" ? "en-CA" : newLocale;
    const response = await api/* apim.post */.TH.post("".concat(constants.createFavoritesEndPoint), {
        name: {
            [locale]: shoppingListName
        }
    });
    var _data;
    return (_data = response.data) !== null && _data !== void 0 ? _data : {};
});
const getProductBySlug = (0,redux_toolkit_esm/* createAsyncThunk */.hg)("list/getProductBySlug", async (payload)=>{
    const { slug , currencyCode , sku , persona  } = payload;
    try {
        let responseProductObject = {};
        const obj = {};
        const { data: { results =[]  } = {}  } = await api/* apim.get */.TH.get("".concat(routes/* CATALOG_PROJECTION_ENDPOINT */.E5, '?where=slug(en-US%3D"').concat(slug, '") or masterVariant(sku in ("').concat(sku, '")) or variants(sku in ("').concat(sku, '"))'));
        var ref;
        responseProductObject = (ref = results[0]) !== null && ref !== void 0 ? ref : {};
        if (responseProductObject === null || responseProductObject === void 0 ? void 0 : responseProductObject.masterVariant) {
            var ref1, ref2;
            let product = {};
            const { masterVariant: { sku: masterSku = ""  } = {} , masterVariant ={} , variants =[]  } = responseProductObject;
            if (sku === masterSku) {
                product = masterVariant;
            } else {
                product = variants.find((variant)=>sku === variant.sku);
            }
            const fixedPromo = product === null || product === void 0 ? void 0 : (ref1 = product.prices) === null || ref1 === void 0 ? void 0 : ref1.find((price)=>{
                var ref, ref1, ref2, ref3, ref4;
                return ((ref = price.value) === null || ref === void 0 ? void 0 : ref.currencyCode) === currencyCode && ((ref1 = price.customerGroup) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.obj) === null || ref2 === void 0 ? void 0 : ref2.key) === persona && ((ref3 = price.custom) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.fields) === null || ref4 === void 0 ? void 0 : ref4.fixedPrice);
            });
            const productPrice = product === null || product === void 0 ? void 0 : (ref2 = product.prices) === null || ref2 === void 0 ? void 0 : ref2.find((price)=>{
                var ref, ref1, ref2;
                return ((ref = price.value) === null || ref === void 0 ? void 0 : ref.currencyCode) === currencyCode && ((ref1 = price.customerGroup) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.obj) === null || ref2 === void 0 ? void 0 : ref2.key) === persona;
            });
            let priceObj = fixedPromo || productPrice;
            if (!(priceObj === null || priceObj === void 0 ? void 0 : priceObj.value)) {
                var ref3;
                priceObj = product === null || product === void 0 ? void 0 : (ref3 = product.prices) === null || ref3 === void 0 ? void 0 : ref3.find((price)=>{
                    var ref;
                    return ((ref = price.value) === null || ref === void 0 ? void 0 : ref.currencyCode) === currencyCode && !price.customerGroup;
                });
            }
            if (priceObj === null || priceObj === void 0 ? void 0 : priceObj.discounted) {
                var ref4, ref5, ref6;
                var ref7;
                obj[sku] = Number((((ref7 = priceObj === null || priceObj === void 0 ? void 0 : (ref4 = priceObj.discounted) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.value) === null || ref5 === void 0 ? void 0 : ref5.centAmount) !== null && ref7 !== void 0 ? ref7 : 0) / 100).toFixed(2));
                var ref8;
                obj["".concat(sku, "-discount")] = Number((((ref8 = priceObj === null || priceObj === void 0 ? void 0 : (ref6 = priceObj.value) === null || ref6 === void 0 ? void 0 : ref6.centAmount) !== null && ref8 !== void 0 ? ref8 : 0) / 100).toFixed(2));
            } else {
                var ref9;
                var ref10;
                obj[sku] = Number((((ref10 = priceObj === null || priceObj === void 0 ? void 0 : (ref9 = priceObj.value) === null || ref9 === void 0 ? void 0 : ref9.centAmount) !== null && ref10 !== void 0 ? ref10 : 0) / 100).toFixed(2));
            }
            return obj;
        } else {
            obj[sku] = 0;
            return obj;
        }
    } catch (err) {
        return err;
    }
});
const addListLineItemQuantity = (0,redux_toolkit_esm/* createAsyncThunk */.hg)("addListLineItemQuantity", async (data)=>{
    const { listId , version , productId , lineItemId , quantity , variantId , action  } = data;
    const actionObject = {
        action: "addLineItem",
        productId: productId,
        variantId: variantId,
        quantity: quantity,
        custom: {
            type: {
                key: "lineItemShoppingList",
                typeId: "type"
            }
        }
    };
    if (action === "subtract") {
        actionObject.action = "removeLineItem";
        actionObject.lineItemId = lineItemId;
    }
    const body = {
        version,
        actions: [
            actionObject
        ]
    };
    const response = await api/* apim.post */.TH.post("".concat((0,constants.addFavoritesEndPoint)(listId, "product")), body);
    return response === null || response === void 0 ? void 0 : response.data;
});
const moveItemsFromList = (0,redux_toolkit_esm/* createAsyncThunk */.hg)("moveItemsFromList", async (data)=>{
    const { list , listData , currentList , productData , selectedItems , productQtyObj  } = data;
    let listId;
    let version;
    if ((list === null || list === void 0 ? void 0 : list.id) && (list === null || list === void 0 ? void 0 : list.version)) {
        listId = list === null || list === void 0 ? void 0 : list.id;
        version = list === null || list === void 0 ? void 0 : list.version;
    } else {
        var ref, ref1;
        const config = await (0,constants_config/* getConfig */.i)();
        const { internationalization: { locale: newLocale = "en-US"  } = {}  } = config;
        const locale = newLocale === "fr-CA" ? "en-CA" : newLocale;
        var ref2;
        const response = await api/* apim.post */.TH.post("".concat(constants.createFavoritesEndPoint), {
            name: {
                [locale]: listData === null || listData === void 0 ? void 0 : listData.name
            },
            project: {
                [locale]: listData === null || listData === void 0 ? void 0 : listData.project
            },
            description: {
                [locale]: listData === null || listData === void 0 ? void 0 : listData.description
            },
            custom: {
                type: {
                    key: "shoppingList"
                },
                fields: {
                    project: (ref2 = listData === null || listData === void 0 ? void 0 : listData.project) !== null && ref2 !== void 0 ? ref2 : ""
                }
            }
        });
        var ref3;
        listId = (ref3 = response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : ref.id) !== null && ref3 !== void 0 ? ref3 : "";
        var ref4;
        version = (ref4 = response === null || response === void 0 ? void 0 : (ref1 = response.data) === null || ref1 === void 0 ? void 0 : ref1.version) !== null && ref4 !== void 0 ? ref4 : "";
    }
    const formattedData = (0,ApiUtil/* getMovieToListAndDeleteFormListItems */.mK)(selectedItems, currentList, productData, productQtyObj);
    const deleteResponse = await api/* apim.post */.TH.post("".concat(constants.USER_LIST_PRODUCT_DELETE_POINT, "/").concat(currentList === null || currentList === void 0 ? void 0 : currentList.id), {
        version: currentList === null || currentList === void 0 ? void 0 : currentList.version,
        actions: formattedData[0]
    });
    const body = {
        version,
        actions: formattedData[1]
    };
    const addResponse = await api/* apim.post */.TH.post("".concat((0,constants.addFavoritesEndPoint)(listId, "product")), body);
    return {
        deleteResponse: deleteResponse === null || deleteResponse === void 0 ? void 0 : deleteResponse.data,
        addResponse: addResponse === null || addResponse === void 0 ? void 0 : addResponse.data
    };
});
const deleteMultiProductFromList = (0,redux_toolkit_esm/* createAsyncThunk */.hg)("deleteMultiProductFromList", async (data)=>{
    const { list , selectedItems  } = data;
    const payload = (0,ApiUtil/* getMultiDeleteItemsPayLoad */._z)(list, selectedItems);
    const deleteResponse = await api/* apim.post */.TH.post("".concat(constants.USER_LIST_PRODUCT_DELETE_POINT, "/").concat(list === null || list === void 0 ? void 0 : list.id), {
        version: list === null || list === void 0 ? void 0 : list.version,
        actions: payload
    });
    return deleteResponse;
});
const addProductToList = (0,redux_toolkit_esm/* createAsyncThunk */.hg)("addProductToList", async (data)=>{
    const { sku , list , listData , createList  } = data;
    let listId;
    let version;
    if ((list === null || list === void 0 ? void 0 : list.id) && (list === null || list === void 0 ? void 0 : list.version)) {
        listId = list === null || list === void 0 ? void 0 : list.id;
        version = list === null || list === void 0 ? void 0 : list.version;
    } else {
        var ref, ref1;
        const config = await (0,constants_config/* getConfig */.i)();
        const { internationalization: { locale: newLocale = "en-US"  } = {}  } = config;
        const locale = newLocale === "fr-CA" ? "en-CA" : newLocale;
        var ref2;
        const response = await api/* apim.post */.TH.post("".concat(constants.createFavoritesEndPoint), {
            name: {
                [locale]: listData === null || listData === void 0 ? void 0 : listData.name
            },
            project: {
                [locale]: listData === null || listData === void 0 ? void 0 : listData.project
            },
            description: {
                [locale]: listData === null || listData === void 0 ? void 0 : listData.description
            },
            custom: {
                type: {
                    key: "shoppingList"
                },
                fields: {
                    project: (ref2 = listData === null || listData === void 0 ? void 0 : listData.project) !== null && ref2 !== void 0 ? ref2 : ""
                }
            }
        });
        var ref3;
        listId = (ref3 = response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : ref.id) !== null && ref3 !== void 0 ? ref3 : "";
        var ref4;
        version = (ref4 = response === null || response === void 0 ? void 0 : (ref1 = response.data) === null || ref1 === void 0 ? void 0 : ref1.version) !== null && ref4 !== void 0 ? ref4 : "";
        if (createList) {
            return response === null || response === void 0 ? void 0 : response.data;
        }
    }
    const body = {
        version,
        actions: [
            {
                action: "addLineItem",
                sku,
                custom: {
                    type: {
                        key: "lineItemShoppingList",
                        typeId: "type"
                    }
                }
            }
        ]
    };
    const response1 = await api/* apim.post */.TH.post("".concat((0,constants.addFavoritesEndPoint)(listId, "product")), body);
    await store/* store.dispatch */.h.dispatch(getMyAccountListsWithLineItems());
    return response1 === null || response1 === void 0 ? void 0 : response1.data;
});
const editList = (0,redux_toolkit_esm/* createAsyncThunk */.hg)("editList", async (data)=>{
    const { list , listData ={}  } = data;
    const config = await (0,constants_config/* getConfig */.i)();
    const { internationalization: { locale: newLocale = "en-US"  } = {}  } = config;
    const locale = newLocale === "fr-CA" ? "en-CA" : newLocale;
    let listId;
    let version;
    if ((list === null || list === void 0 ? void 0 : list.id) && (list === null || list === void 0 ? void 0 : list.version)) {
        listId = list === null || list === void 0 ? void 0 : list.id;
        version = list === null || list === void 0 ? void 0 : list.version;
    }
    const body = {
        version,
        actions: [
            {
                action: "changeName",
                name: {
                    [locale]: listData === null || listData === void 0 ? void 0 : listData.name
                }
            },
            {
                action: "setDescription",
                description: {
                    [locale]: listData === null || listData === void 0 ? void 0 : listData.description
                }
            },
            {
                action: "setCustomType",
                type: {
                    key: "shoppingList"
                },
                fields: {
                    project: listData === null || listData === void 0 ? void 0 : listData.project
                }
            }
        ]
    };
    const response = await api/* apim.post */.TH.post("".concat((0,constants.addFavoritesEndPoint)(listId, "product")), body);
    return response === null || response === void 0 ? void 0 : response.data;
});
const addProduct = (0,redux_toolkit_esm/* createAsyncThunk */.hg)("addProduct", async (sku, thunkAPI)=>{
    await store/* store.dispatch */.h.dispatch(getFavorites());
    const state = thunkAPI.getState();
    let id;
    let version;
    let favorites;
    const isPdp = window.eventPageType === "pdp";
    if ((state === null || state === void 0 ? void 0 : state.favorites.favorites) !== undefined && Object.keys(state === null || state === void 0 ? void 0 : state.favorites.favorites).length > 0) {
        var ref;
        favorites = state === null || state === void 0 ? void 0 : (ref = state.favorites) === null || ref === void 0 ? void 0 : ref.favorites;
        id = favorites === null || favorites === void 0 ? void 0 : favorites.id;
        version = favorites === null || favorites === void 0 ? void 0 : favorites.version;
    } else {
        const favoritesMain = await store/* store.dispatch */.h.dispatch(createFavorite());
        favorites = favoritesMain === null || favoritesMain === void 0 ? void 0 : favoritesMain.payload;
        id = favorites === null || favorites === void 0 ? void 0 : favorites.id;
        version = favorites === null || favorites === void 0 ? void 0 : favorites.version;
    }
    const body = {
        version,
        actions: [
            {
                action: "addLineItem",
                sku,
                custom: {
                    type: {
                        key: "lineItemShoppingList",
                        typeId: "type"
                    }
                }
            }
        ]
    };
    const response = await api/* apim.post */.TH.post("".concat((0,constants.addFavoritesEndPoint)(id, "product")), body);
    if (isPdp && response.data) {
        var _internalLinkType, _zoneName;
        addDataLayerFav("", true, "add", (_internalLinkType = window.internalLinkType) !== null && _internalLinkType !== void 0 ? _internalLinkType : "", (_zoneName = window.zoneName) !== null && _zoneName !== void 0 ? _zoneName : "", "", "");
    }
    return response.data;
});
const removeItems = (0,redux_toolkit_esm/* createAsyncThunk */.hg)("removeItems", async (ids, thunkAPI)=>{
    let isDataLayerNeeded = true;
    let imageName = "";
    let section = "";
    if (!Array.isArray(ids)) {
        isDataLayerNeeded = ids === null || ids === void 0 ? void 0 : ids.isDataLayerNeeded;
        imageName = ids === null || ids === void 0 ? void 0 : ids.imageName;
        section = ids === null || ids === void 0 ? void 0 : ids.section;
        ids = ids.ids;
    }
    try {
        const state = thunkAPI.getState();
        const { id , version , lineItems  } = (state === null || state === void 0 ? void 0 : state.favorites.favorites) || {};
        if (id) {
            const actions = ids.map((pid)=>{
                if (lineItems.find((el)=>el.id === pid)) {
                    return {
                        action: "removeLineItem",
                        lineItemId: pid
                    };
                } else {
                    return {
                        action: "removeTextLineItem",
                        textLineItemId: pid
                    };
                }
            });
            const response = await api/* apim.post */.TH.post("".concat((0,constants.removeFavoritesEndPoint)(id)), {
                version,
                actions
            });
            var _internalLinkType;
            isDataLayerNeeded && addDataLayerFav("", true, "remove", (_internalLinkType = window.internalLinkType) !== null && _internalLinkType !== void 0 ? _internalLinkType : "", section !== null && section !== void 0 ? section : "", "", "", imageName);
            return response.data;
        }
        return {};
    } catch (error) {
        var _internalLinkType1, _zoneName;
        isDataLayerNeeded && addDataLayerFav("", false, "remove", (_internalLinkType1 = window.internalLinkType) !== null && _internalLinkType1 !== void 0 ? _internalLinkType1 : "", (_zoneName = window.zoneName) !== null && _zoneName !== void 0 ? _zoneName : "", "", "");
    }
});
const myAccountRemoveItems = (0,redux_toolkit_esm/* createAsyncThunk */.hg)("myAccountRemoveItems", async (ids, thunkAPI)=>{
    var ref, ref1;
    const state = thunkAPI.getState();
    const { id , version , lineItems  } = (state === null || state === void 0 ? void 0 : (ref = state.favorites) === null || ref === void 0 ? void 0 : (ref1 = ref.fullFavoriteData) === null || ref1 === void 0 ? void 0 : ref1.d) || {};
    if (id) {
        const actions = ids.map((pid)=>{
            if (lineItems.find((el)=>el.id === pid)) {
                return {
                    action: "removeLineItem",
                    lineItemId: pid
                };
            } else {
                return {
                    action: "removeTextLineItem",
                    textLineItemId: pid
                };
            }
        });
        const response = await api/* apim.post */.TH.post("".concat((0,constants.removeFavoritesEndPoint)(id)), {
            version,
            actions
        });
        if (response === null || response === void 0 ? void 0 : response.data) {
            var ref2, ref3, ref4, ref5;
            const { lineItems: lineItems1 = [] , textLineItems =[]  } = (response === null || response === void 0 ? void 0 : response.data) || {};
            const productIds = lineItems1.map((item)=>item.productId);
            const persona = (0,helper/* getUserPersona */.shu)();
            const fl = [
                "masterSKU_s",
                "SKUColorSwatchFilename_ss",
                "ProductDescriptionProductShort_s",
                "ProductBrandName_s",
                "metaTitle_s",
                "productName_s",
                "id",
                "productImages.url_ss",
                "slug_s",
                "Product_Category",
                "displayPriceStartingAt_s",
                "Tile_Title",
                "ProductIsExclusive_s",
                "RegionReleaseforShipment_dt",
                "Color.SKU.Details_ss",
                "productImages.labelWithUrl_ss",
                "variantList.sku_ss",
                "RegionBrandName_s",
                "priceList.".concat(persona, ".discountedPrice_d"),
                "priceList.".concat(persona, ".saleOffer_s"),
                "priceList.".concat(persona, ".finalPrice_d"),
                "priceList.".concat(persona, ".price_d"),
                "Color.".concat(persona, ".Details_ss"),
                "ctId_s",
                "Brand_ss",
                "Country_ss"
            ];
            const config = await (0,constants_config/* getConfig */.i)();
            var ref6;
            const language = (ref6 = config === null || config === void 0 ? void 0 : (ref2 = config.internationalization) === null || ref2 === void 0 ? void 0 : ref2.language) !== null && ref6 !== void 0 ? ref6 : "en";
            var ref7;
            const res = await api/* apim.get */.TH.get("/search/full-catalog", {
                params: {
                    q: "*:*",
                    fq: 'ctId_s:("'.concat(productIds.join('","'), '") && language_s:("').concat(language, '")'),
                    fl: fl.join(","),
                    collections: (ref7 = config === null || config === void 0 ? void 0 : (ref3 = config.general) === null || ref3 === void 0 ? void 0 : ref3.siteName) !== null && ref7 !== void 0 ? ref7 : "Kohler",
                    start: 0,
                    rows: 50,
                    sessionId: (0,ApiUtil/* getSessionIdObjWithEpoc */.oq)()
                }
            });
            var ref8;
            const productData = (ref8 = (ref4 = res.data) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.response) === null || ref5 === void 0 ? void 0 : ref5.docs) !== null && ref8 !== void 0 ? ref8 : [];
            if (productData.length > 0) {
                lineItems1.forEach((item, index, items)=>{
                    const product = productData.find((product)=>{
                        return product["ctId_s"] === (item === null || item === void 0 ? void 0 : item.productId);
                    });
                    items[index].productData = product;
                });
            }
            let sortLineItems = [];
            if (lineItems1.length > 0) {
                sortLineItems = lineItems1.sort(function(a, b) {
                    return new Date(b.addedAt) - new Date(a.addedAt);
                });
            }
            let sortTextLineItems = [];
            if (textLineItems.length > 0) {
                sortTextLineItems = textLineItems.sort(function(a, b) {
                    return new Date(b.addedAt) - new Date(a.addedAt);
                });
            }
            var ref9;
            return {
                sortProducts: sortLineItems !== null && sortLineItems !== void 0 ? sortLineItems : [],
                sortMedia: sortTextLineItems !== null && sortTextLineItems !== void 0 ? sortTextLineItems : [],
                d: (ref9 = response === null || response === void 0 ? void 0 : response.data) !== null && ref9 !== void 0 ? ref9 : {}
            };
        }
    }
    return {};
});
const addMedia = (0,redux_toolkit_esm/* createAsyncThunk */.hg)("addMedia", async (params, thunkAPI)=>{
    const config = await (0,constants_config/* getConfig */.i)();
    const { internationalization: { locale: newLocale = "en-US"  } = {}  } = config;
    const locale = newLocale === "fr-CA" ? "en-CA" : newLocale;
    const { type ="" , name ="" , url ="" , description ="" , articleType ="" , thumbnail ="" , needDataLayerToAdd =true , caption ="" , section ="" , videoName ="" , videoId ="" , errorMessage ="" , successMsg ="" , successCallback =()=>{} , errorCallback =()=>{} , imageName =""  } = params;
    try {
        var ref, ref1, ref2;
        const state = thunkAPI.getState();
        let id;
        let version;
        const fav = await store/* store.dispatch */.h.dispatch(getFavorites());
        let favorites = ((ref1 = Object.keys(state === null || state === void 0 ? void 0 : (ref = state.favorites) === null || ref === void 0 ? void 0 : ref.favorites)) === null || ref1 === void 0 ? void 0 : ref1.length) > 0 ? state === null || state === void 0 ? void 0 : (ref2 = state.favorites) === null || ref2 === void 0 ? void 0 : ref2.favorites : fav === null || fav === void 0 ? void 0 : fav.payload;
        if ((favorites === null || favorites === void 0 ? void 0 : favorites.id) && (favorites === null || favorites === void 0 ? void 0 : favorites.version)) {
            id = favorites === null || favorites === void 0 ? void 0 : favorites.id;
            version = favorites === null || favorites === void 0 ? void 0 : favorites.version;
        } else {
            const favoritesMain = await store/* store.dispatch */.h.dispatch(createFavorite());
            favorites = favoritesMain === null || favoritesMain === void 0 ? void 0 : favoritesMain.payload;
            id = favorites === null || favorites === void 0 ? void 0 : favorites.id;
            version = favorites === null || favorites === void 0 ? void 0 : favorites.version;
        }
        const body = {
            version: version,
            actions: [
                {
                    action: "addTextLineItem",
                    name: {
                        [locale]: name || videoName || ""
                    },
                    description: {
                        [locale]: description
                    },
                    custom: {
                        type: {
                            key: "textLineItemShoppingList",
                            typeId: "type"
                        },
                        fields: {
                            itemType: type,
                            link: url,
                            thumbnail,
                            articleType
                        }
                    }
                }
            ]
        };
        const response = await api/* apim.post */.TH.post("".concat((0,constants.addFavoritesEndPoint)(id, type)), body);
        const { textLineItems =[]  } = response.data;
        if (textLineItems.length > 0) {
            (0,helper/* checkIsFavorite */.GsT)(textLineItems);
            successCallback();
        }
        var _internalLinkType;
        if (needDataLayerToAdd) addDataLayerFav(successMsg, true, "add", (_internalLinkType = window.internalLinkType) !== null && _internalLinkType !== void 0 ? _internalLinkType : caption, section, videoName, videoId, imageName);
        return response.data;
    } catch (error) {
        if (needDataLayerToAdd) addDataLayerFav(errorMessage, false, "add", caption, section, videoName, videoId);
        errorCallback();
    }
});
const favoritesSlice = (0,redux_toolkit_esm/* createSlice */.oM)({
    name: "favorites",
    initialState,
    reducers: {
        setFavorites (state, action) {
            state.favorites = action.payload;
        },
        setLoginFavouriteCallback (state, action) {
            state.isLoginFavouriteCallback = action.payload;
        }
    },
    extraReducers (builder) {
        builder.addCase([
            es6/* HYDRATE */.ju
        ], (state, action)=>{
            return {
                ...state,
                ...action.payload.favorites
            };
        }).addCase(getFavorites.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(getFavorites.fulfilled, (state, action)=>{
            state.favorites = action.payload;
            state.status = "succeeded";
        }).addCase(getFavorites.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(getMyAccountListsWithLineItems.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(getMyAccountListsWithLineItems.fulfilled, (state, action)=>{
            state.saveToListLineItems = action.payload[0][0];
            state.userListItemsSkus = action.payload[0][1];
            state.userLists = action.payload[1];
            state.status = "succeeded";
        }).addCase(getMyAccountListsWithLineItems.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(getMyAccountFavorites.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(getMyAccountFavorites.fulfilled, (state, action)=>{
            state.fullFavoriteData = action.payload;
            state.status = "succeeded";
        }).addCase(getMyAccountFavorites.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(myAccountRemoveItems.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(myAccountRemoveItems.fulfilled, (state, action)=>{
            state.fullFavoriteData = action.payload;
            state.status = "succeeded";
        }).addCase(myAccountRemoveItems.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(addProduct.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(addProduct.fulfilled, (state, action)=>{
            state.favorites = action.payload;
            state.status = "succeeded";
        }).addCase(addProduct.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(createFavorite.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(createFavorite.fulfilled, (state, action)=>{
            state.favorites = action.payload;
            state.status = "succeeded";
        }).addCase(createFavorite.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(addMedia.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(addMedia.fulfilled, (state, action)=>{
            state.favorites = {
                ...state.favorites,
                ...action.payload
            };
            state.status = "succeeded";
        }).addCase(addMedia.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(removeItems.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(removeItems.fulfilled, (state, action)=>{
            state.favorites = action.payload;
            state.status = "succeeded";
        }).addCase(removeItems.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        });
    }
});
const { setFavorites , setLoginFavouriteCallback  } = favoritesSlice.actions;
const selectFavoritesState = (state)=>state.favorites;
/* harmony default export */ var features_favoritesSlice = (favoritesSlice.reducer);


/***/ }),

/***/ 88751:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AN": function() { return /* binding */ hideAppointmentModal; },
/* harmony export */   "AT": function() { return /* binding */ setAuthNav; },
/* harmony export */   "Ai": function() { return /* binding */ getProfile; },
/* harmony export */   "C1": function() { return /* binding */ getCardType; },
/* harmony export */   "CF": function() { return /* binding */ showToast; },
/* harmony export */   "DE": function() { return /* binding */ setAnalyticsScript; },
/* harmony export */   "Dz": function() { return /* binding */ getBusinessList; },
/* harmony export */   "F$": function() { return /* binding */ setFeatureFlagsFeature; },
/* harmony export */   "FE": function() { return /* binding */ setPageObject; },
/* harmony export */   "FV": function() { return /* binding */ setSitewideWarningContent; },
/* harmony export */   "GL": function() { return /* binding */ getplaceOfPurchaseList; },
/* harmony export */   "Ix": function() { return /* binding */ uploadImage; },
/* harmony export */   "JN": function() { return /* binding */ genericSlice; },
/* harmony export */   "J_": function() { return /* binding */ setConsolidatedZipCodes; },
/* harmony export */   "Ji": function() { return /* binding */ setToastContent; },
/* harmony export */   "Jp": function() { return /* binding */ getCountryList; },
/* harmony export */   "K4": function() { return /* binding */ setLoading; },
/* harmony export */   "Ln": function() { return /* binding */ getGenericListPath; },
/* harmony export */   "PE": function() { return /* binding */ hideToast; },
/* harmony export */   "Px": function() { return /* binding */ selectGenericState; },
/* harmony export */   "Qb": function() { return /* binding */ setGlobalConfig; },
/* harmony export */   "RS": function() { return /* binding */ showFindingModelPopup; },
/* harmony export */   "Ro": function() { return /* binding */ removeAddress; },
/* harmony export */   "T": function() { return /* binding */ closeCompareProductView; },
/* harmony export */   "T8": function() { return /* binding */ getAuthMenuFragment; },
/* harmony export */   "UD": function() { return /* binding */ mapStateToCountry; },
/* harmony export */   "Wj": function() { return /* binding */ closeMenu; },
/* harmony export */   "Wv": function() { return /* binding */ showPromoModal; },
/* harmony export */   "X7": function() { return /* binding */ setActiveMainCategory; },
/* harmony export */   "XY": function() { return /* binding */ setBrandLogoImg; },
/* harmony export */   "Yb": function() { return /* binding */ editAddress; },
/* harmony export */   "Ys": function() { return /* binding */ setPageIsIntercative; },
/* harmony export */   "_4": function() { return /* binding */ setShowHalfCompare; },
/* harmony export */   "_K": function() { return /* binding */ setDefaultAddress; },
/* harmony export */   "_W": function() { return /* binding */ hideFindingModelPopup; },
/* harmony export */   "_r": function() { return /* binding */ setSitewideNewsLetterContent; },
/* harmony export */   "a5": function() { return /* binding */ getStoreCountriesList; },
/* harmony export */   "bC": function() { return /* binding */ getAccountBusinessList; },
/* harmony export */   "c0": function() { return /* binding */ resetPassword; },
/* harmony export */   "cw": function() { return /* binding */ setGlobalStyles; },
/* harmony export */   "dN": function() { return /* binding */ setDatalayerPageName; },
/* harmony export */   "e6": function() { return /* binding */ setPreviewCartInit; },
/* harmony export */   "et": function() { return /* binding */ getUserProfile; },
/* harmony export */   "go": function() { return /* binding */ getLegalPageLinks; },
/* harmony export */   "jy": function() { return /* binding */ toggleSiteWideWarning; },
/* harmony export */   "kY": function() { return /* binding */ showAppointmentModal; },
/* harmony export */   "ks": function() { return /* binding */ setGbhDataLayerCustom; },
/* harmony export */   "lK": function() { return /* binding */ getstateList; },
/* harmony export */   "m8": function() { return /* binding */ getCommonList; },
/* harmony export */   "ml": function() { return /* binding */ setSubscribeModalContent; },
/* harmony export */   "n8": function() { return /* binding */ setGlobalScripts; },
/* harmony export */   "p1": function() { return /* binding */ setShowFullCompare; },
/* harmony export */   "qX": function() { return /* binding */ setRegionNav; },
/* harmony export */   "qn": function() { return /* binding */ openMenu; },
/* harmony export */   "rA": function() { return /* binding */ setCompareproductsStaticText; },
/* harmony export */   "s2": function() { return /* binding */ editProfile; },
/* harmony export */   "sZ": function() { return /* binding */ setDataLayerObj; },
/* harmony export */   "su": function() { return /* binding */ setAuthorData; },
/* harmony export */   "t8": function() { return /* binding */ zipDownload; },
/* harmony export */   "tK": function() { return /* binding */ searchPlp; },
/* harmony export */   "tm": function() { return /* binding */ deleteAccount; },
/* harmony export */   "wA": function() { return /* binding */ setGatedContentData; },
/* harmony export */   "x": function() { return /* binding */ hidePreviewCart; },
/* harmony export */   "y$": function() { return /* binding */ addAddress; },
/* harmony export */   "z0": function() { return /* binding */ showPreviewCart; },
/* harmony export */   "zF": function() { return /* binding */ getTrackingList; }
/* harmony export */ });
/* unused harmony exports getOccupationList, setSitewideWarningRendered, setAnalyticsScripts, setCompareExpiry, clearAllCompareProducts, setUpsellInstallationServiceData */
/* harmony import */ var next_redux_wrapper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28858);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41609);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _constants_api__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73350);
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19514);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(77236);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96301);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(55760);
/* harmony import */ var _store_features_cartSlice__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(46201);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(88032);
/* harmony import */ var _utils_ApiUtil__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(51666);












const initialState = {
    isLoading: false,
    datalayerPageName: "",
    eventPageType: "",
    accountTypeListPath: "",
    businessListPath: "",
    countryListPath: "",
    occupationListPath: "",
    commonListPath: "",
    trackingListPath: "",
    stateListPath: "",
    cardTypesPath: "",
    storeCountryListPath: "",
    placeOfPurchaseListPath: "",
    accountTypeList: [],
    businessList: [],
    legalPageLinks: {},
    countryList: [],
    stateList: [],
    stateToCountryList: [],
    placeOfPurchaseList: [],
    cardType: "",
    userMenuFragment: "",
    guestMenuFragment: "",
    status: "",
    error: "",
    subscribeModal: {
        show: false,
        modalContent: {},
        active: 0
    },
    siteWideWarning: {
        isRendered: false
    },
    newslettersignup: {},
    compareproducts: {},
    profile: "",
    brandLogoImg: "",
    globalScripts: [],
    dataLayerObj: "",
    analyticsScript: "",
    globalStyles: [],
    globalConfig: {},
    authorData: {},
    toaster: {
        message: "",
        isVisible: false,
        content: {}
    },
    menu: {
        isOpen: false,
        mainCategoryActive: "",
        isRegionOpen: false,
        isAuthNavOpen: false
    },
    pageIsInteractive: false,
    previewCart: {
        showPreview: false
    },
    promoBannerModal: {
        show: false,
        modalContent: {
            banner: {},
            item: {},
            count: 0
        }
    },
    enableSiteWideWarning: false,
    FindingModelModal: {
        show: false,
        modalContent: {}
    },
    associateMembershipModal: {
        show: false,
        isRetired: false,
        modalContent: {}
    },
    showHalfCompare: false,
    showFullCompare: false,
    isProductInfo: false,
    isPreviewCartInit: false,
    consolidatedZipCodes: [],
    upsellInstallationServiceAuthData: {},
    isShowAppointmentModal: false,
    bpNumber: null,
    gatedContentData: {},
    featureFlags: {}
};
const getGenericListPath = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("generic/getGenericListPath", async function() {
    let { reload =false  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, thunkAPI = arguments.length > 1 ? arguments[1] : void 0;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    const state = thunkAPI.getState();
    var ref10;
    const accountTypeListPath = (ref10 = state === null || state === void 0 ? void 0 : (ref = state.generic) === null || ref === void 0 ? void 0 : ref.accountTypeListPath) !== null && ref10 !== void 0 ? ref10 : "";
    var ref11;
    const businessListPath = (ref11 = state === null || state === void 0 ? void 0 : (ref1 = state.generic) === null || ref1 === void 0 ? void 0 : ref1.businessListPath) !== null && ref11 !== void 0 ? ref11 : "";
    var ref12;
    const countryListPath = (ref12 = state === null || state === void 0 ? void 0 : (ref2 = state.generic) === null || ref2 === void 0 ? void 0 : ref2.countryListPath) !== null && ref12 !== void 0 ? ref12 : "";
    var ref13;
    const occupationListPath = (ref13 = state === null || state === void 0 ? void 0 : (ref3 = state.generic) === null || ref3 === void 0 ? void 0 : ref3.occupationListPath) !== null && ref13 !== void 0 ? ref13 : "";
    var ref14;
    const commonListPath = (ref14 = state === null || state === void 0 ? void 0 : (ref4 = state.generic) === null || ref4 === void 0 ? void 0 : ref4.commonListPath) !== null && ref14 !== void 0 ? ref14 : "";
    var ref15;
    const trackingListPath = (ref15 = state === null || state === void 0 ? void 0 : (ref5 = state.generic) === null || ref5 === void 0 ? void 0 : ref5.trackingListPath) !== null && ref15 !== void 0 ? ref15 : "";
    var ref16;
    const stateListPath = (ref16 = state === null || state === void 0 ? void 0 : (ref6 = state.generic) === null || ref6 === void 0 ? void 0 : ref6.stateListPath) !== null && ref16 !== void 0 ? ref16 : "";
    var ref17;
    const cardTypesPath = (ref17 = state === null || state === void 0 ? void 0 : (ref7 = state.generic) === null || ref7 === void 0 ? void 0 : ref7.cardTypesPath) !== null && ref17 !== void 0 ? ref17 : "";
    var ref18;
    const placeOfPurchaseListPath = (ref18 = state === null || state === void 0 ? void 0 : (ref8 = state.generic) === null || ref8 === void 0 ? void 0 : ref8.placeOfPurchaseListPath) !== null && ref18 !== void 0 ? ref18 : "";
    var ref19;
    const storeCountryListPath = (ref19 = state === null || state === void 0 ? void 0 : (ref9 = state.generic) === null || ref9 === void 0 ? void 0 : ref9.placeOfPurchaseListPath) !== null && ref19 !== void 0 ? ref19 : "";
    let data = {};
    if (accountTypeListPath || businessListPath || countryListPath || occupationListPath || commonListPath || trackingListPath || stateListPath || cardTypesPath || placeOfPurchaseListPath || storeCountryListPath && !reload) {
        data = {
            accountTypeList: accountTypeListPath,
            businessList: businessListPath,
            countryList: countryListPath,
            occupationList: occupationListPath,
            commonList: commonListPath,
            trackingList: trackingListPath,
            stateList: stateListPath,
            cardTypes: cardTypesPath,
            placeOfPurchaseList: placeOfPurchaseListPath,
            storeCountryListPath: storeCountryListPath
        };
        return data;
    }
    const { general  } = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_3__/* .getConfig */ .i)();
    if (general === null || general === void 0 ? void 0 : general.genericListPath) {
        const response = await _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .aemAxiosInstance.get */ .Gb.get(_constants_index__WEBPACK_IMPORTED_MODULE_4__.GLOBAL_CONFIGURATION_ENDPOINT + "?path=" + (general === null || general === void 0 ? void 0 : general.genericListPath));
        return response.data;
    }
    return data;
});
const getCardType = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("generic/cardTypesPath", async function() {
    let { reload =false  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, thunkAPI = arguments.length > 1 ? arguments[1] : void 0;
    var ref;
    const state = thunkAPI.getState();
    const cardTypesPath = state === null || state === void 0 ? void 0 : (ref = state.generic) === null || ref === void 0 ? void 0 : ref.cardTypesPath;
    if (cardTypesPath) {
        const response = await _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .aemAxiosInstance.get */ .Gb.get(_constants_index__WEBPACK_IMPORTED_MODULE_4__.GLOBAL_CONFIGURATION_ENDPOINT + "?path=" + cardTypesPath);
        return response.data;
    }
    return {};
});
const getTrackingList = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("generic/trackingListPath", async function() {
    let { reload =false  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, thunkAPI = arguments.length > 1 ? arguments[1] : void 0;
    var ref;
    const state = thunkAPI.getState();
    const trackingListPath = state === null || state === void 0 ? void 0 : (ref = state.generic) === null || ref === void 0 ? void 0 : ref.trackingListPath;
    if (trackingListPath) {
        const response = await _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .aemAxiosInstance.get */ .Gb.get(_constants_index__WEBPACK_IMPORTED_MODULE_4__.GLOBAL_CONFIGURATION_ENDPOINT + "?path=" + trackingListPath);
        return response.data;
    }
    return {};
});
const getBusinessList = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("generic/getBusinessList", async function() {
    let { reload =false  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, thunkAPI = arguments.length > 1 ? arguments[1] : void 0;
    var ref, ref1;
    const state = thunkAPI.getState();
    const businessList = state === null || state === void 0 ? void 0 : (ref = state.generic) === null || ref === void 0 ? void 0 : ref.businessList;
    if ((businessList === null || businessList === void 0 ? void 0 : businessList.length) > 0 && !reload) return businessList;
    const businessListPath = state === null || state === void 0 ? void 0 : (ref1 = state.generic) === null || ref1 === void 0 ? void 0 : ref1.businessListPath;
    if (businessListPath) {
        const response = await _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .aemAxiosInstance.get */ .Gb.get(_constants_index__WEBPACK_IMPORTED_MODULE_4__.GLOBAL_CONFIGURATION_ENDPOINT + "?path=" + businessListPath);
        return response.data;
    }
    return [];
});
const getAccountBusinessList = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("generic/getAccountBusinessList", async function() {
    let { reload =false  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, thunkAPI = arguments.length > 1 ? arguments[1] : void 0;
    var ref, ref1;
    const state = thunkAPI.getState();
    const accountTypeList = state === null || state === void 0 ? void 0 : (ref = state.generic) === null || ref === void 0 ? void 0 : ref.accountTypeList;
    if ((accountTypeList === null || accountTypeList === void 0 ? void 0 : accountTypeList.length) > 0 && !reload) return accountTypeList;
    const accountTypeListPath = state === null || state === void 0 ? void 0 : (ref1 = state.generic) === null || ref1 === void 0 ? void 0 : ref1.accountTypeListPath;
    if (accountTypeListPath) {
        const response = await _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .aemAxiosInstance.get */ .Gb.get(_constants_index__WEBPACK_IMPORTED_MODULE_4__.GLOBAL_CONFIGURATION_ENDPOINT + "?path=" + accountTypeListPath);
        return response.data;
    }
    return [];
});
const getLegalPageLinks = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("generic/getLegalPageLinks", async function() {
    let { reload =false  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, thunkAPI = arguments.length > 1 ? arguments[1] : void 0;
    var ref;
    const state = thunkAPI.getState();
    const legalPageLinks = state === null || state === void 0 ? void 0 : (ref = state.generic) === null || ref === void 0 ? void 0 : ref.legalPageLinks;
    if (!lodash_isEmpty__WEBPACK_IMPORTED_MODULE_1___default()(legalPageLinks) > 0 && !reload) return legalPageLinks;
    const { general  } = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_3__/* .getConfig */ .i)();
    if (general === null || general === void 0 ? void 0 : general.legalPageListPath) {
        const response = await _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .aemAxiosInstance.get */ .Gb.get(_constants_index__WEBPACK_IMPORTED_MODULE_4__.GLOBAL_CONFIGURATION_ENDPOINT + "?path=" + (general === null || general === void 0 ? void 0 : general.legalPageListPath));
        return response.data;
    }
    return {};
});
const getAuthMenuFragment = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("generic/getAuthMenuFragment", async function() {
    let { reload =false , path , fragmentName  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, thunkAPI = arguments.length > 1 ? arguments[1] : void 0;
    const state = thunkAPI.getState();
    var _fragmentName;
    const fragment = (_fragmentName = state === null || state === void 0 ? void 0 : state.generic[fragmentName]) !== null && _fragmentName !== void 0 ? _fragmentName : "";
    const payload = {};
    if (fragment && !reload) {
        payload[fragmentName] = fragment;
        return payload;
    }
    if (path) {
        const response = await _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .aemAxiosInstance.get */ .Gb.get(_constants_index__WEBPACK_IMPORTED_MODULE_4__.GLOBAL_CONFIGURATION_ENDPOINT + "?path=" + path);
        var ref;
        payload[fragmentName] = (ref = await (0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__/* .getShortenedUrl */ .Ppy)(response.data.commonTopics)) !== null && ref !== void 0 ? ref : "";
        return payload;
    }
    return {};
});
const getProfile = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("getprofile", async ()=>{
    const response = await _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .apim.get */ .TH.get("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_4__.GET_PROFILE_ENDPOINT));
    return response.data;
});
const getOccupationList = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("generic/occupationListPath", async function() {
    let { reload =false  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, thunkAPI = arguments.length > 1 ? arguments[1] : void 0;
    var ref, ref1;
    const state = thunkAPI.getState();
    const occupationList = state === null || state === void 0 ? void 0 : (ref = state.generic) === null || ref === void 0 ? void 0 : ref.occupationList;
    if ((occupationList === null || occupationList === void 0 ? void 0 : occupationList.length) > 0 && !reload) return occupationList;
    const occupationListPath = state === null || state === void 0 ? void 0 : (ref1 = state.generic) === null || ref1 === void 0 ? void 0 : ref1.occupationListPath;
    if (occupationListPath) {
        const response = await _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .aemAxiosInstance.get */ .Gb.get(_constants_index__WEBPACK_IMPORTED_MODULE_4__.GLOBAL_CONFIGURATION_ENDPOINT + "?path=" + occupationListPath);
        return response.data;
    }
    return {};
});
const getCountryList = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("generic/countryListPath", async function() {
    let { reload =false  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, thunkAPI = arguments.length > 1 ? arguments[1] : void 0;
    var ref, ref1;
    const state = thunkAPI.getState();
    const countryList = state === null || state === void 0 ? void 0 : (ref = state.generic) === null || ref === void 0 ? void 0 : ref.countryList;
    if ((countryList === null || countryList === void 0 ? void 0 : countryList.length) > 0 && !reload) return countryList;
    const countryListPath = state === null || state === void 0 ? void 0 : (ref1 = state.generic) === null || ref1 === void 0 ? void 0 : ref1.countryListPath;
    if (countryListPath) {
        const response = await _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .aemAxiosInstance.get */ .Gb.get(_constants_index__WEBPACK_IMPORTED_MODULE_4__.GLOBAL_CONFIGURATION_ENDPOINT + "?path=" + countryListPath);
        return response.data;
    }
    return {};
});
const getstateList = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("generic/stateListPath", async function() {
    let { reload =false  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, thunkAPI = arguments.length > 1 ? arguments[1] : void 0;
    var ref, ref1;
    const state = thunkAPI.getState();
    const stateList = state === null || state === void 0 ? void 0 : (ref = state.generic) === null || ref === void 0 ? void 0 : ref.stateList;
    if ((stateList === null || stateList === void 0 ? void 0 : stateList.length) > 0 && !reload) return stateList;
    const stateListPath = state === null || state === void 0 ? void 0 : (ref1 = state.generic) === null || ref1 === void 0 ? void 0 : ref1.stateListPath;
    if (stateListPath) {
        const response = await _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .aemAxiosInstance.get */ .Gb.get(_constants_index__WEBPACK_IMPORTED_MODULE_4__.GLOBAL_CONFIGURATION_ENDPOINT + "?path=" + stateListPath);
        return response.data;
    }
    return {};
});
const getStoreCountriesList = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("generic/storeCountryListPath", async function() {
    let { reload =false  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, thunkAPI = arguments.length > 1 ? arguments[1] : void 0;
    var ref, ref1;
    const state = thunkAPI.getState();
    const storeCountryList = state === null || state === void 0 ? void 0 : (ref = state.generic) === null || ref === void 0 ? void 0 : ref.storeCountryList;
    if ((storeCountryList === null || storeCountryList === void 0 ? void 0 : storeCountryList.length) > 0 && !reload) return storeCountryList;
    const storeCountryListPath = state === null || state === void 0 ? void 0 : (ref1 = state.generic) === null || ref1 === void 0 ? void 0 : ref1.storeCountryListPath;
    if (storeCountryListPath) {
        const response = await _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .aemAxiosInstance.get */ .Gb.get(_constants_index__WEBPACK_IMPORTED_MODULE_4__.GLOBAL_CONFIGURATION_ENDPOINT + "?path=" + storeCountryListPath);
        return response.data;
    }
    return {};
});
const getplaceOfPurchaseList = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("generic/placeOfPurchaseList", async function() {
    let { reload =false  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, thunkAPI = arguments.length > 1 ? arguments[1] : void 0;
    var ref, ref1;
    const state = thunkAPI.getState();
    const placeOfPurchaseList = state === null || state === void 0 ? void 0 : (ref = state.generic) === null || ref === void 0 ? void 0 : ref.placeOfPurchaseList;
    if ((placeOfPurchaseList === null || placeOfPurchaseList === void 0 ? void 0 : placeOfPurchaseList.length) > 0 && !reload) return placeOfPurchaseList;
    const placeOfPurchaseListPath = state === null || state === void 0 ? void 0 : (ref1 = state.generic) === null || ref1 === void 0 ? void 0 : ref1.placeOfPurchaseListPath;
    if (placeOfPurchaseListPath) {
        var ref2;
        const response = await _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .aemAxiosInstance.get */ .Gb.get(_constants_index__WEBPACK_IMPORTED_MODULE_4__.GLOBAL_CONFIGURATION_ENDPOINT + "?path=" + placeOfPurchaseListPath);
        return (ref2 = response.data) === null || ref2 === void 0 ? void 0 : ref2.map((purchase)=>purchase.value);
    }
    return {};
});
const zipDownload = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("zipDownload", async (payload)=>{
    const response = await _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .apim.post */ .TH.post(_constants_index__WEBPACK_IMPORTED_MODULE_4__.ZIP_FILE_DOWNLOAD_ENDPOINT, payload, {
        responseType: "blob"
    });
    return response;
});
const searchPlp = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("search-plp", async (data)=>{
    const { internationalization: { language ="en"  } = {}  } = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_3__/* .getConfig */ .i)();
    try {
        var ref, ref1, ref2;
        const actions = data.actions;
        const response = await _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .apim.get */ .TH.get(_constants_index__WEBPACK_IMPORTED_MODULE_4__.SEARCH_PLP_ENDPOINT, {
            params: {
                q: "*:*",
                fl: "CustomerFacingBrand_s, RegionOnBackOrder_s",
                fq: [
                    "sku_s:(".concat((ref = actions[0]) === null || ref === void 0 ? void 0 : ref.sku, ")"),
                    'language_s:("'.concat(language, '")')
                ],
                collections: "service_parts",
                profilename: "profile_service_parts_Search",
                sessionId: (0,_utils_ApiUtil__WEBPACK_IMPORTED_MODULE_9__/* .getSessionIdObjWithEpoc */ .oq)()
            },
            paramsSerializer: (params)=>{
                return qs__WEBPACK_IMPORTED_MODULE_10___default().stringify(params, {
                    arrayFormat: "repeat",
                    encode: false
                });
            }
        });
        if (response === null || response === void 0 ? void 0 : (ref1 = response.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.response) === null || ref2 === void 0 ? void 0 : ref2.docs[0]) {
            const newActions = [];
            const newData = {};
            actions.forEach((action)=>{
                action["backorder"] = response.data.response.docs[0]["RegionOnBackOrder_s"] === "Yes";
                action["brand"] = response.data.response.docs[0]["CustomerFacingBrand_s"];
                newActions.push(action);
            });
            newData["actions"] = newActions;
            return _store__WEBPACK_IMPORTED_MODULE_7__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_6__/* .addToCart */ .Xq)(newData));
        }
    } catch (e) {
        return _store__WEBPACK_IMPORTED_MODULE_7__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_6__/* .addToCart */ .Xq)(data));
    }
});
const getUserProfile = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("getuserprofile", async ()=>{
    let profile = {};
    try {
        const res = await _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .apim.get */ .TH.get("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_4__.GET_PROFILE_ENDPOINT));
        if (res && res.data) {
            var ref, ref1, ref2;
            localStorage.setItem("profile-version", res.data.version);
            profile = res.data;
            profile.postalCode = (ref = profile.addresses[0]) === null || ref === void 0 ? void 0 : ref.postalCode;
            const profileAddr = (ref1 = profile.addresses) === null || ref1 === void 0 ? void 0 : ref1.find((addr)=>{
                var ref, ref1;
                return ((ref = addr.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.label) === "Profile";
            });
            profile.profileAddrId = profileAddr.id;
            profile.addresses = (ref2 = profile.addresses) === null || ref2 === void 0 ? void 0 : ref2.filter((addr)=>{
                var ref, ref1;
                return ((ref = addr.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.label) !== "Profile";
            });
            let addresses = profile.addresses;
            if (profile.defaultShippingAddressId) {
                const index = addresses.findIndex((item)=>item.id === profile.defaultShippingAddressId);
                addresses = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__/* .arrayMove */ .RpN)(profile.addresses, index, 0);
            }
            profile.addresses = addresses;
        }
    } catch (err) {
        console.log("Failed to get user profile", err);
    }
    return profile;
});
const editProfile = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("editProfile", async (data, thunkAPI)=>{
    let profile = [];
    let actions = [];
    const oktaTokenStorage = JSON.parse(localStorage.getItem("okta-token-storage"));
    const userType = oktaTokenStorage.accessToken.claims.persona[0].split(":")[1];
    if (userType === "TVS") {
        actions = [
            {
                action: "setFirstName",
                firstName: data.firstName
            },
            {
                action: "setLastName",
                lastName: data.lastName
            },
            {
                action: "setCompanyName",
                companyName: data.businessName
            },
            {
                action: "setCustomField",
                name: "businessType",
                value: data.businessType
            },
            {
                action: "setCustomField",
                name: "businessSubType",
                value: data.businessSubType
            },
            {
                action: "changeAddress",
                addressId: data.addressId,
                address: {
                    postalCode: data.businessZipCode,
                    country: "US",
                    custom: {
                        type: {
                            key: "custom-address"
                        },
                        fields: {
                            label: "Profile"
                        }
                    }
                }
            }
        ];
    } else {
        actions = [
            {
                action: "setFirstName",
                firstName: data.firstName
            },
            {
                action: "setLastName",
                lastName: data.lastName
            }
        ];
    }
    var ref;
    const version = (ref = parseInt(localStorage.getItem("profile-version"))) !== null && ref !== void 0 ? ref : 1;
    try {
        const res = await _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .apim.post */ .TH.post("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_4__.EDIT_PROFILE_ENDPOINT), {
            version: version,
            actions: actions
        });
        if (res) {
            profile = await thunkAPI.dispatch(getUserProfile());
            localStorage.setItem(_constants_index__WEBPACK_IMPORTED_MODULE_4__["default"] === null || _constants_index__WEBPACK_IMPORTED_MODULE_4__["default"] === void 0 ? void 0 : _constants_index__WEBPACK_IMPORTED_MODULE_4__["default"].KF_FORCE_RENEW_TOKEN, true);
        }
    } catch (err) {
        // eslint-disable-next-line no-console
        console.log("Failed to edit profile", err);
    }
    const { payload: response  } = profile;
    return response;
});
const addAddress = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("addAddress", async (data)=>{
    const resPayload = {
        addresses: [],
        defaultShippingAddressId: ""
    };
    var ref;
    const version = (ref = parseInt(localStorage.getItem("profile-version"))) !== null && ref !== void 0 ? ref : 1;
    try {
        const payload = Array.isArray(data) ? {
            version: version,
            actions: data
        } : {
            version: version,
            actions: [
                {
                    action: "addAddress",
                    address: data
                }
            ]
        };
        const res = await _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .apim.post */ .TH.post("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_4__.addAddressEndPoint), payload);
        if (res && (res === null || res === void 0 ? void 0 : res.data)) {
            var ref1, ref2, ref3;
            localStorage.setItem("profile-version", res === null || res === void 0 ? void 0 : (ref1 = res.data) === null || ref1 === void 0 ? void 0 : ref1.version);
            if ((res === null || res === void 0 ? void 0 : (ref2 = res.data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.addresses) === null || ref3 === void 0 ? void 0 : ref3.length) > 0) {
                var ref4, ref5, ref6;
                var ref7;
                resPayload.addresses = (ref7 = res === null || res === void 0 ? void 0 : (ref4 = res.data) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.addresses) === null || ref5 === void 0 ? void 0 : ref5.filter((addr)=>{
                    var ref, ref1;
                    return (addr === null || addr === void 0 ? void 0 : (ref = addr.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.label) !== "Profile";
                })) !== null && ref7 !== void 0 ? ref7 : [];
                resPayload.defaultShippingAddressId = res === null || res === void 0 ? void 0 : (ref6 = res.data) === null || ref6 === void 0 ? void 0 : ref6.defaultShippingAddressId;
            }
        }
    } catch (err) {
        console.log("Failed to add address", err);
        const { response: { data: { error =""  }  } = {}  } = err;
        return {
            error
        };
    }
    return resPayload;
});
const editAddress = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("editAddress", async (payload)=>{
    const resPayload = {
        addresses: [],
        defaultShippingAddressId: ""
    };
    var ref;
    const version = (ref = parseInt(localStorage.getItem("profile-version"))) !== null && ref !== void 0 ? ref : 1;
    try {
        const res = await _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .apim.post */ .TH.post("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_4__.addAddressEndPoint), {
            version: version,
            actions: [
                {
                    action: "changeAddress",
                    addressId: payload === null || payload === void 0 ? void 0 : payload.id,
                    address: payload === null || payload === void 0 ? void 0 : payload.addr
                }
            ]
        });
        if (res && (res === null || res === void 0 ? void 0 : res.data)) {
            var ref1, ref2;
            localStorage.setItem("profile-version", res.data.version);
            if ((res === null || res === void 0 ? void 0 : (ref1 = res.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.addresses) === null || ref2 === void 0 ? void 0 : ref2.length) > 0) {
                var ref3, ref4, ref5;
                var ref6;
                resPayload.addresses = (ref6 = res === null || res === void 0 ? void 0 : (ref3 = res.data) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.addresses) === null || ref4 === void 0 ? void 0 : ref4.filter((addr)=>{
                    var ref, ref1;
                    return (addr === null || addr === void 0 ? void 0 : (ref = addr.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.label) !== "Profile";
                })) !== null && ref6 !== void 0 ? ref6 : [];
                resPayload.defaultShippingAddressId = res === null || res === void 0 ? void 0 : (ref5 = res.data) === null || ref5 === void 0 ? void 0 : ref5.defaultShippingAddressId;
            }
        }
    } catch (err) {
        console.log("Failed to edit address", err);
    }
    return resPayload;
});
const setDefaultAddress = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("setDefaultAddress", async (addressId)=>{
    const resPayload = {
        addresses: [],
        defaultShippingAddressId: ""
    };
    var ref;
    const version = (ref = parseInt(localStorage.getItem("profile-version"))) !== null && ref !== void 0 ? ref : 1;
    try {
        const res = await _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .apim.post */ .TH.post("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_4__.addAddressEndPoint), {
            version: version,
            actions: [
                {
                    action: "setDefaultShippingAddress",
                    addressId: addressId
                }
            ]
        });
        if (res && (res === null || res === void 0 ? void 0 : res.data)) {
            var ref1, ref2, ref3;
            localStorage.setItem("profile-version", res === null || res === void 0 ? void 0 : (ref1 = res.data) === null || ref1 === void 0 ? void 0 : ref1.version);
            if ((res === null || res === void 0 ? void 0 : (ref2 = res.data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.addresses) === null || ref3 === void 0 ? void 0 : ref3.length) > 0) {
                var ref4, ref5, ref6;
                var ref7;
                resPayload.addresses = (ref7 = res === null || res === void 0 ? void 0 : (ref4 = res.data) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.addresses) === null || ref5 === void 0 ? void 0 : ref5.filter((addr)=>{
                    var ref, ref1;
                    return (addr === null || addr === void 0 ? void 0 : (ref = addr.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.label) !== "Profile";
                })) !== null && ref7 !== void 0 ? ref7 : [];
                resPayload.defaultShippingAddressId = res === null || res === void 0 ? void 0 : (ref6 = res.data) === null || ref6 === void 0 ? void 0 : ref6.defaultShippingAddressId;
            }
        }
    } catch (err) {
        console.log("Failed to set default", err);
    }
    return resPayload;
});
const removeAddress = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("removeAddress", async (addressId)=>{
    const resPayload = {
        addresses: [],
        defaultShippingAddressId: ""
    };
    var ref;
    const version = (ref = parseInt(localStorage.getItem("profile-version"))) !== null && ref !== void 0 ? ref : 1;
    try {
        const res = await _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .apim.post */ .TH.post("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_4__.addAddressEndPoint), {
            version: version,
            actions: [
                {
                    action: "removeAddress",
                    addressId: addressId
                }
            ]
        });
        if (res && (res === null || res === void 0 ? void 0 : res.data)) {
            var ref1, ref2, ref3, ref4;
            localStorage.setItem("profile-version", (ref1 = res === null || res === void 0 ? void 0 : res.data.profileDetail) === null || ref1 === void 0 ? void 0 : ref1.version);
            if ((res === null || res === void 0 ? void 0 : (ref2 = res.data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.profileDetail) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.addresses) === null || ref4 === void 0 ? void 0 : ref4.length) > 0) {
                var ref5, ref6, ref7, ref8, ref9;
                var ref10;
                resPayload.addresses = (ref10 = res === null || res === void 0 ? void 0 : (ref5 = res.data) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.profileDetail) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.addresses) === null || ref7 === void 0 ? void 0 : ref7.filter((addr)=>{
                    var ref, ref1;
                    return (addr === null || addr === void 0 ? void 0 : (ref = addr.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.label) !== "Profile";
                })) !== null && ref10 !== void 0 ? ref10 : [];
                resPayload.defaultShippingAddressId = res === null || res === void 0 ? void 0 : (ref8 = res.data) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.profileDetail) === null || ref9 === void 0 ? void 0 : ref9.defaultShippingAddressId;
            }
        }
    } catch (err) {
        console.log("Failed to remove address", err);
    }
    return resPayload;
});
const deleteAccount = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("deleteAccount", async ()=>{
    try {
        const res = await _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .apim["delete"] */ .TH["delete"]("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_4__.DELETE_ACCOUNT_ENDPOINT));
        if (res && res.data) return true;
    } catch (err) {
        console.log("Failed to delete account", err);
    }
});
const resetPassword = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("resetPassword", async (data)=>{
    try {
        return await _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .apim.post */ .TH.post("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_4__.CHANGE_ACCOUNT_PASSWORD_ENDPOINT), data);
    } catch (err) {
        console.log("Failed to reset password", err);
        return err.response;
    }
});
const uploadImage = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("", async (file)=>{
    var ref, ref1;
    const fileName = (ref1 = file === null || file === void 0 ? void 0 : (ref = file.name) === null || ref === void 0 ? void 0 : ref.toLowerCase()) === null || ref1 === void 0 ? void 0 : ref1.replace(/ /g, "-");
    const res = await _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .apim.put */ .TH.put("/crm/asset/upload?fileName=".concat(fileName), file, {
        headers: {
            "Content-Type": file.type
        }
    });
    if (res && res.data) return res.data;
});
const getCommonList = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("generic/getCommonList", async function() {
    let { reload =false  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, thunkAPI = arguments.length > 1 ? arguments[1] : void 0;
    var ref, ref1;
    const state = thunkAPI.getState();
    const commonList = state === null || state === void 0 ? void 0 : (ref = state.generic) === null || ref === void 0 ? void 0 : ref.commonList;
    if ((commonList === null || commonList === void 0 ? void 0 : commonList.length) > 0 && !reload) return commonList;
    const commonListPath = state === null || state === void 0 ? void 0 : (ref1 = state.generic) === null || ref1 === void 0 ? void 0 : ref1.commonListPath;
    if (commonListPath) {
        const response = await _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .aemAxiosInstance.get */ .Gb.get(_constants_index__WEBPACK_IMPORTED_MODULE_4__.GLOBAL_CONFIGURATION_ENDPOINT + "?path=" + commonListPath);
        return response.data;
    }
    return [];
});
const closeCompareProductView = function() {
    let url = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    var ref;
    _store__WEBPACK_IMPORTED_MODULE_7__/* .store.dispatch */ .h.dispatch(setShowHalfCompare(false));
    _store__WEBPACK_IMPORTED_MODULE_7__/* .store.dispatch */ .h.dispatch(setShowFullCompare(true));
    const query = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__/* .getPdpUrlParams */ .ssk)();
    if ((window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : ref.pathname) === _constants_index__WEBPACK_IMPORTED_MODULE_4__.INSTALLATION_SERVICES_PATH) {
        const newUrl = window.location.hash ? "".concat(window.location.pathname).concat(window.location.hash) : window.location.pathname;
        window.history.replaceState({
            previousUrl: url
        }, document.title, newUrl);
    } else if (query) {
        window.history.replaceState(window.location.pathname, document.title, query);
    } else {
        window.history.replaceState({}, document.title, window.location.pathname);
    }
    document.body.classList.remove("compare-open", "scroll-lock", "modal-open");
};
const genericSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createSlice */ .oM)({
    name: "generic",
    initialState,
    reducers: {
        setSubscribeModalContent (state, action) {
            state.subscribeModal = {
                ...state.subscribeModal,
                modalContent: action.payload
            };
        },
        setCompareproductsStaticText (state, action) {
            state.compareproducts = {
                ...state.compareproducts,
                content: action.payload
            };
        },
        setSitewideWarningContent (state, action) {
            state.siteWideWarning = {
                ...state.subscribeModal,
                content: action.payload
            };
        },
        setSitewideNewsLetterContent (state, action) {
            state.newslettersignup = {
                ...state.newslettersignup,
                content: action.payload
            };
        },
        setSitewideWarningRendered (state, action) {
            state.siteWideWarning = {
                ...state.subscribeModal,
                isRendered: action.payload
            };
        },
        setBrandLogoImg (state, action) {
            state.brandLogoImg = action.payload;
        },
        setGlobalScripts (state, action) {
            state.globalScripts = state.globalScripts.concat(action.payload);
        },
        setDataLayerObj (state, action) {
            state.dataLayerObj = action.payload;
        },
        setGlobalStyles (state, action) {
            state.globalStyles = state.globalStyles.concat(action.payload);
        },
        setGlobalConfig (state, action) {
            state.globalConfig = action.payload;
        },
        setAuthorData (state, action) {
            state.authorData = action.payload;
        },
        setLoading (state, action) {
            state.isLoading = action.payload;
        },
        setAnalyticsScript (state, action) {
            state.analyticsScript = action.payload;
        },
        showToast (state, action) {
            state.toaster = {
                ...state.toaster,
                ...action.payload
            };
        },
        hideToast (state, action) {
            state.toaster = {
                ...state.toaster,
                message: "",
                isVisible: false
            };
        },
        setToastContent (state, action) {
            state.toaster = {
                ...state.toaster,
                content: action.payload
            };
        },
        openMenu (state, action) {
            state.menu = {
                ...state.menu,
                isOpen: true
            };
        },
        closeMenu (state, action) {
            state.menu = {
                ...state.menu,
                isOpen: false
            };
        },
        setActiveMainCategory (state, action) {
            state.menu = {
                ...state.menu,
                mainCategoryActive: action.payload.item
            };
        },
        setRegionNav (state, action) {
            state.menu = {
                ...state.menu,
                isRegionOpen: action.payload
            };
        },
        setAuthNav (state, action) {
            state.menu = {
                ...state.menu,
                isAuthNavOpen: action.payload
            };
        },
        setPageIsIntercative (state, action) {
            state.pageIsInteractive = action.payload;
        },
        showPreviewCart (state, action) {
            window.previewCartKeySource = false;
            state.previewCart = {
                ...state.previewCart,
                showPreview: true
            };
        },
        hidePreviewCart (state, action) {
            window.previewCartKeySource = true;
            state.previewCart = {
                ...state.previewCart,
                showPreview: false
            };
        },
        setDatalayerPageName (state, action) {
            let trimmed = action.payload;
            // will remove .model.json from the incoming string
            trimmed = trimmed ? trimmed.replace(".model.json", "") : trimmed;
            state.datalayerPageName = trimmed;
        },
        setGbhDataLayerCustom (state, action) {
            var ref;
            const { datalayerPageName , eventPageType , pageType  } = action.payload;
            if (datalayerPageName) {
                state.datalayerPageName = datalayerPageName;
            } else {
                state.datalayerPageName = "";
            }
            if (eventPageType) {
                state.eventPageType = window.eventPageType = eventPageType;
            } else {
                state.eventPageType = "";
            }
            if (pageType) {
                state.pageType = window.pageType = pageType;
            } else {
                state.pageType = "";
            }
            const { adobeDataLayer: { getState  } = {}  } = window;
            const page = getState && getState("page") || {};
            const content = page === null || page === void 0 ? void 0 : (ref = page.pageInfo) === null || ref === void 0 ? void 0 : ref.contentType;
            if (content === "locations") {
                state.eventPageType = "locations:kohler stores";
            }
        },
        showPromoModal (state, action) {
            state.promoBannerModal = {
                ...action.payload
            };
        },
        mapStateToCountry: (state, action)=>{
            const { countryList , stateList  } = action.payload;
            const stateToCountryList = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__/* .mapStateToCountryHandler */ .oFy)(countryList, stateList);
            state.stateToCountryList = stateToCountryList;
        },
        toggleSiteWideWarning: (state, action)=>{
            state.enableSiteWideWarning = !state.enableSiteWideWarning;
        },
        showFindingModelPopup (state, action) {
            state.FindingModelModal = {
                show: true,
                modalContent: {}
            };
        },
        hideFindingModelPopup (state, action) {
            state.FindingModelModal = {
                show: false,
                modalContent: {}
            };
        },
        setShowHalfCompare (state, action) {
            state.showHalfCompare = action.payload;
        },
        setShowFullCompare (state, action) {
            state.showFullCompare = action.payload;
        },
        setPageObject (state, action) {
            state.isProductInfo = action.payload;
        },
        setPreviewCartInit (state, action) {
            state.isPreviewCartInit = action.payload;
        },
        setConsolidatedZipCodes (state, action) {
            state.consolidatedZipCodes = action.payload;
        },
        setUpsellInstallationServiceData (state, action) {
            state.upsellInstallationServiceAuthData = action.payload;
        },
        showAppointmentModal: (state, action)=>{
            state.isShowAppointmentModal = true;
            state.bpNumber = action.payload;
        },
        hideAppointmentModal: (state)=>{
            state.isShowAppointmentModal = false;
        },
        setGatedContentData: (state, action)=>{
            state.gatedContentData = action.payload;
        },
        setFeatureFlagsFeature: (state, action)=>{
            state.featureFlags = action.payload;
        }
    },
    extraReducers (builder) {
        builder.addCase([
            next_redux_wrapper__WEBPACK_IMPORTED_MODULE_0__/* .HYDRATE */ .ju
        ], (state, action)=>{
            return {
                ...state,
                ...action.payload.generic
            };
        }).addCase(getGenericListPath.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(getGenericListPath.fulfilled, (state, action)=>{
            state.status = "succeeded";
            const data = action.payload;
            for (const key of Object.keys(data)){
                state[key + "Path"] = data[key];
            }
        }).addCase(getGenericListPath.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(getBusinessList.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(getBusinessList.fulfilled, (state, action)=>{
            state.status = "succeeded";
            state.businessList = action.payload;
        }).addCase(getBusinessList.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(getAccountBusinessList.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(getAccountBusinessList.fulfilled, (state, action)=>{
            state.status = "succeeded";
            state.accountTypeList = action.payload;
        }).addCase(getAccountBusinessList.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(getLegalPageLinks.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(getLegalPageLinks.fulfilled, (state, action)=>{
            state.status = "succeeded";
            state.legalPageLinks = action.payload;
        }).addCase(getLegalPageLinks.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(getAuthMenuFragment.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(getAuthMenuFragment.fulfilled, (state, action)=>{
            state.status = "succeeded";
            for(const key in action.payload){
                if (({}).hasOwnProperty.call(action.payload, key)) {
                    state[key] = action.payload[key];
                }
            }
        }).addCase(getAuthMenuFragment.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(getCountryList.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(getCountryList.fulfilled, (state, action)=>{
            state.status = "succeeded";
            state.countryList = action.payload;
        }).addCase(getCountryList.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(getOccupationList.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(getOccupationList.fulfilled, (state, action)=>{
            state.status = "succeeded";
            state.countryList = action.payload;
        }).addCase(getOccupationList.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(getstateList.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(getstateList.fulfilled, (state, action)=>{
            state.status = "succeeded";
            state.stateList = action.payload;
        }).addCase(getStoreCountriesList.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(getStoreCountriesList.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(getStoreCountriesList.fulfilled, (state, action)=>{
            state.status = "succeeded";
            state.stateList = action.payload;
        }).addCase(getstateList.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(getplaceOfPurchaseList.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(getplaceOfPurchaseList.fulfilled, (state, action)=>{
            state.status = "succeeded";
            state.placeOfPurchaseList = action.payload;
        }).addCase(getplaceOfPurchaseList.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(getCardType.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(getCardType.fulfilled, (state, action)=>{
            state.status = "succeeded";
            state.cardType = action.payload;
        }).addCase(getCardType.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        });
    }
});
const { setLoading , setCompareproductsStaticText , setSubscribeModalContent , setSitewideWarningContent , setSitewideWarningRendered , setBrandLogoImg , setGlobalScripts , setGlobalStyles , setGlobalConfig , setAuthorData , setDataLayerObj , setAnalyticsScripts , setCompareExpiry , showToast , clearAllCompareProducts , showPreviewCart , hidePreviewCart , hideToast , openMenu , closeMenu , setActiveMainCategory , setRegionNav , setAuthNav , setAnalyticsScript , setPageIsIntercative , setDatalayerPageName , setGbhDataLayerCustom , setSitewideNewsLetterContent , setToastContent , showPromoModal , mapStateToCountry , toggleSiteWideWarning , showFindingModelPopup , hideFindingModelPopup , setShowHalfCompare , setShowFullCompare , setPageObject , setPreviewCartInit , setConsolidatedZipCodes , setUpsellInstallationServiceData , showAppointmentModal , hideAppointmentModal , setGatedContentData , setFeatureFlagsFeature  } = genericSlice.actions;
const selectGenericState = (state)=>state.generic;
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = (genericSlice.reducer);


/***/ }),

/***/ 49265:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DM": function() { return /* binding */ setLastChangedSelection; },
/* harmony export */   "M0": function() { return /* binding */ resetInvalidSelection; },
/* harmony export */   "VN": function() { return /* binding */ setModalOpen; },
/* harmony export */   "Zh": function() { return /* binding */ setInvalidSelection; },
/* harmony export */   "iP": function() { return /* binding */ setRemovedSelections; },
/* harmony export */   "oT": function() { return /* binding */ setPreviousConfig; },
/* harmony export */   "ot": function() { return /* binding */ setAddedSelections; },
/* harmony export */   "yz": function() { return /* binding */ setCurrentConfig; }
/* harmony export */ });
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(77236);

const initialState = {
    isModalOpen: false,
    attributes: [],
    lastChanged: {
        attribute: "",
        value: "",
        image: null
    },
    removedSelections: [],
    addedSelections: [],
    previousConfig: {},
    currenConfig: {}
};
const invalidSelectionSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__/* .createSlice */ .oM)({
    name: "invalidSelection",
    initialState,
    reducers: {
        setInvalidSelection (state, action) {
            state.attributes = action.payload.attributes;
        },
        setModalOpen (state, action) {
            state.isModalOpen = action.payload;
        },
        setCurrentConfig (state, action) {
            state.currenConfig = action.payload;
        },
        setPreviousConfig (state, action) {
            state.previousConfig = action.payload;
        },
        setLastChangedSelection (state, action) {
            var _image;
            state.lastChanged = {
                attribute: action.payload.attribute,
                value: action.payload.value,
                image: (_image = action.payload.image) !== null && _image !== void 0 ? _image : null
            };
        },
        setRemovedSelections (state, action) {
            state.removedSelections = action.payload;
        },
        setAddedSelections (state, action) {
            state.addedSelections = action.payload;
        },
        resetInvalidSelection (state) {
            state.isModalOpen = false;
            state.attributes = [];
            state.lastChanged = {
                attribute: "",
                value: "",
                image: null
            };
            state.removedSelections = [];
            state.addedSelections = [];
            state.previousConfig = {};
            state.currenConfig = {};
        }
    }
});
const { setInvalidSelection , setModalOpen , resetInvalidSelection , setLastChangedSelection , setRemovedSelections , setAddedSelections , setCurrentConfig , setPreviousConfig  } = invalidSelectionSlice.actions;
/* harmony default export */ __webpack_exports__["ZP"] = (invalidSelectionSlice);


/***/ }),

/***/ 56608:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ey": function() { return /* binding */ setStoreFilter; },
/* harmony export */   "Hm": function() { return /* binding */ setUtilityStoreDetails; },
/* harmony export */   "I_": function() { return /* binding */ setFindAStoreActive; },
/* harmony export */   "NL": function() { return /* binding */ setUtilityLocation; },
/* harmony export */   "OX": function() { return /* binding */ setCityLocation; },
/* harmony export */   "T7": function() { return /* binding */ setFindAStoreShow; },
/* harmony export */   "_n": function() { return /* binding */ locationState; },
/* harmony export */   "h9": function() { return /* binding */ setMyStore; },
/* harmony export */   "tD": function() { return /* binding */ setFindAStoreSearchEvent; },
/* harmony export */   "vM": function() { return /* binding */ locationSlice; },
/* harmony export */   "wf": function() { return /* binding */ setStoreAddress; }
/* harmony export */ });
/* unused harmony export setAPIRecallTime */
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77236);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_0__);


const initialState = {
    userCity: "",
    utilityLocation: "",
    utilityData: {},
    utilityStoreDetails: {},
    myStoreId: 0,
    utilityStoreDetailsUrl: "",
    isLoading: false,
    reCallIn: "",
    browseLocationsStoreFilterData: [],
    findAStoreShow: false,
    findAStoreActive: false,
    findAStoreSearchEvent: false
};
const locationSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_1__/* .createSlice */ .oM)({
    name: "location",
    initialState,
    reducers: {
        setAPIRecallTime (state, action) {
            state.reCallIn = moment__WEBPACK_IMPORTED_MODULE_0___default()().add(1, "m").unix();
        },
        setStoreAddress: (state, action)=>{
            state.utilityData = action.payload;
            state.reCallIn = moment__WEBPACK_IMPORTED_MODULE_0___default()().add(1, "m").unix();
            state.isLoading = false;
        },
        setUtilityStoreDetails: (state, action)=>{
            state.utilityStoreDetails = action.payload;
            state.reCallIn = moment__WEBPACK_IMPORTED_MODULE_0___default()().add(1, "m").unix();
            state.isLoading = false;
        },
        setCityLocation: (state, action)=>{
            const { payload: { userCity ="" , utilityLocation =""  }  } = action;
            state.userCity = userCity;
            state.utilityLocation = utilityLocation;
            state.reCallIn = moment__WEBPACK_IMPORTED_MODULE_0___default()().add(1, "m").unix();
            state.isLoading = false;
            localStorage.setItem("currentZipCode", utilityLocation);
        },
        setUtilityLocation: (state, action)=>{
            const { payload: { utilityLocation =""  } = {}  } = action;
            state.utilityLocation = utilityLocation;
            localStorage.setItem("currentZipCode", utilityLocation);
        },
        setMyStore: (state, action)=>{
            state.myStoreId = action.payload;
        },
        setStoreFilter: (state, action)=>{
            state.browseLocationsStoreFilterData = action.payload;
        },
        setFindAStoreShow: (state, action)=>{
            state.findAStoreShow = action.payload;
        },
        setFindAStoreActive: (state, action)=>{
            state.findAStoreActive = action.payload;
        },
        setFindAStoreSearchEvent: (state, action)=>{
            state.findAStoreSearchEvent = action.payload;
        }
    }
});
const { setStoreAddress , setAPIRecallTime , setUtilityStoreDetails , setCityLocation , setMyStore , setUtilityLocation , setStoreFilter , setFindAStoreActive , setFindAStoreShow , setFindAStoreSearchEvent  } = locationSlice.actions;
const locationState = (state)=>state.location;


/***/ }),

/***/ 3507:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ih": function() { return /* binding */ selectMyAccountState; },
/* harmony export */   "JC": function() { return /* binding */ setOnlineSubmitStatus; },
/* harmony export */   "Ku": function() { return /* binding */ clearSuccess; },
/* harmony export */   "M_": function() { return /* binding */ setInvalidModelNumber; },
/* harmony export */   "N0": function() { return /* binding */ onlineProductSubmitRegistration; },
/* harmony export */   "TN": function() { return /* binding */ setSubmitStatus; },
/* harmony export */   "Tp": function() { return /* binding */ offlineProductSubmitRegistration; },
/* harmony export */   "dM": function() { return /* binding */ clearSuggestion; },
/* harmony export */   "dj": function() { return /* binding */ myProductSlice; },
/* harmony export */   "q5": function() { return /* binding */ getProductsForRegistration; },
/* harmony export */   "u8": function() { return /* binding */ getModelNumberSuggest; }
/* harmony export */ });
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var next_redux_wrapper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28858);
/* harmony import */ var _constants_api__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73350);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(77236);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96301);
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19514);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(55760);
/* harmony import */ var _utils_ApiUtil__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(51666);









const initialState = {
    status: "",
    offlineRegistration: {
        suggestions: [],
        invalidModelNumber: false,
        submitError: false,
        isSuccess: false,
        isDisabled: false
    },
    onlineRegistration: {
        submitError: false,
        isSuccess: false,
        isDisabled: false
    }
};
const getModelNumberSuggest = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)("myProduct/getSuggestion", async (payload)=>{
    const { q , rows , fq , fl , start , skuSearch  } = payload;
    const response = await _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .apim.get */ .TH.get(_constants_index__WEBPACK_IMPORTED_MODULE_3__.MY_PRODUCT_SEARCH_CATALOG, {
        params: {
            q,
            rows,
            fq,
            fl,
            start,
            skuSearch,
            sessionId: (0,_utils_ApiUtil__WEBPACK_IMPORTED_MODULE_7__/* .getSessionIdObjWithEpoc */ .oq)()
        },
        paramsSerializer: (params)=>{
            return qs__WEBPACK_IMPORTED_MODULE_8___default().stringify(params, {
                arrayFormat: "repeat",
                encode: false
            });
        }
    });
    const skuData = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__/* .handleModelNumberSuggestion */ .Gzb)(response.data);
    return skuData;
});
const getProductsForRegistration = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)("myProduct/fetchProducts", async (body)=>{
    var ref;
    const productsData = [];
    const config = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_4__/* .getConfig */ .i)();
    var ref1;
    const locale = (ref1 = config === null || config === void 0 ? void 0 : (ref = config.internationalization) === null || ref === void 0 ? void 0 : ref.locale) !== null && ref1 !== void 0 ? ref1 : "en-US";
    await Promise.all([
        _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .apim.get */ .TH.get("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_3__.MY_PRODUCTS_ENDPOINT, "?lang=").concat(locale)),
        _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .apim.get */ .TH.get("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_3__.FETCH_PRODUCT_REG_ENDPOINT))
    ]).then(async (res)=>{
        var ref, ref1, ref2, ref3;
        if ((ref = res[0]) === null || ref === void 0 ? void 0 : ref.data) productsData[0] = (ref1 = res[0]) === null || ref1 === void 0 ? void 0 : ref1.data;
        if ((ref2 = res[1]) === null || ref2 === void 0 ? void 0 : ref2.data) productsData[1] = (ref3 = res[1]) === null || ref3 === void 0 ? void 0 : ref3.data;
    }).catch((err)=>{
        console.error("Error occured while fetching registered product data", err);
    });
    return productsData;
});
const offlineProductSubmitRegistration = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)("myProduct/offlineRegistration", async (body)=>{
    let message = false;
    const { data ={}  } = await _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .apim.post */ .TH.post(_constants_index__WEBPACK_IMPORTED_MODULE_3__.MY_PRODUCT_PRODUCT_REGISTRATION, body);
    if (data) {
        message = lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(data, "success", "") === "true" ? true : false;
    }
    return message;
});
const onlineProductSubmitRegistration = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)("myProduct/onlineRegistration", async (body)=>{
    let message = false;
    const { data ={}  } = await _constants_api__WEBPACK_IMPORTED_MODULE_2__/* .apim.post */ .TH.post(_constants_index__WEBPACK_IMPORTED_MODULE_3__.MY_PRODUCT_PRODUCT_REGISTRATION, body);
    if (data) {
        message = lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(data, "success", "") === "true" ? true : false;
    }
    return message;
});
const myProductSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createSlice */ .oM)({
    name: "myProduct",
    initialState,
    reducers: {
        clearSuggestion: (state, action)=>{
            state.offlineRegistration = {
                ...state.offlineRegistration,
                suggestions: []
            };
        },
        setInvalidModelNumber: (state, action)=>{
            state.offlineRegistration = {
                ...state.offlineRegistration,
                invalidModelNumber: action.payload
            };
        },
        setSubmitStatus: (state, action)=>{
            const { submitError ="" , isDisabled =false  } = action.payload;
            state.offlineRegistration = {
                ...state.offlineRegistration,
                submitError: submitError,
                isDisabled: isDisabled
            };
        },
        clearSuccess: (state, action)=>{
            state.offlineRegistration = {
                ...state.offlineRegistration,
                isSuccess: false
            };
        },
        setOnlineSubmitStatus: (state, action)=>{
            const { submitError ="" , isDisabled =false  } = action.payload;
            state.onlineRegistration = {
                ...state.onlineRegistration,
                submitError: submitError,
                isDisabled: isDisabled
            };
        }
    },
    extraReducers (builder) {
        builder.addCase([
            next_redux_wrapper__WEBPACK_IMPORTED_MODULE_1__/* .HYDRATE */ .ju
        ], (state, action)=>{
            return {
                ...state,
                ...action.payload
            };
        }).addCase(getModelNumberSuggest.pending, (state, action)=>{
        // state.status = "loading"
        }).addCase(getModelNumberSuggest.fulfilled, (state, action)=>{
            state.status = "succeeded";
            state.offlineRegistration = {
                ...state.offlineRegistration,
                ...action.payload
            };
        }).addCase(getModelNumberSuggest.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(offlineProductSubmitRegistration.pending, (state, action)=>{
            state.offlineRegistration = {
                ...state.offlineRegistration,
                submitError: false,
                isDisabled: true
            };
            state.status = "loading";
        }).addCase(offlineProductSubmitRegistration.fulfilled, (state, action)=>{
            state.status = "succeeded";
            const isSuccess = action.payload;
            if (isSuccess) {
                state.offlineRegistration = {
                    ...state.offlineRegistration,
                    isSuccess: true,
                    isDisabled: false
                };
            }
        }).addCase(offlineProductSubmitRegistration.rejected, (state, action)=>{
            state.offlineRegistration = {
                ...state.offlineRegistration,
                submitError: action.error.message,
                isDisabled: false
            };
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(getProductsForRegistration.pending, (state)=>{
            state.status = "loading";
        }).addCase(getProductsForRegistration.fulfilled, (state, action)=>{
            state.status = "succeeded";
        }).addCase(getProductsForRegistration.rejected, (state, action)=>{
            state.status = "failed";
        }).addCase(onlineProductSubmitRegistration.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(onlineProductSubmitRegistration.fulfilled, (state, action)=>{
            state.status = "succeeded";
        }).addCase(onlineProductSubmitRegistration.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        });
    }
});
const { clearSuggestion , setInvalidModelNumber , setSubmitStatus , clearSuccess , setOnlineSubmitStatus  } = myProductSlice.actions;
const selectMyAccountState = (state)=>state.myProduct;
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = (myProductSlice.reducer);


/***/ }),

/***/ 76977:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Jv": function() { return /* binding */ findOrderByEmail; },
/* harmony export */   "_w": function() { return /* binding */ ordersState; },
/* harmony export */   "co": function() { return /* binding */ getOrder; },
/* harmony export */   "rx": function() { return /* binding */ getPastOrders; },
/* harmony export */   "tI": function() { return /* binding */ getSplitOrder; },
/* harmony export */   "x0": function() { return /* binding */ getOpenOrders; },
/* harmony export */   "zM": function() { return /* binding */ orderSlice; }
/* harmony export */ });
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77236);
/* harmony import */ var _constants_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73350);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96301);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88032);




const initialState = {
    status: "",
    error: "",
    orders: []
};
const findOrderByEmail = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createAsyncThunk */ .hg)("orders/email", async (payload, thunkAPI)=>{
    var ref, ref1;
    const body = {
        email: (ref = payload.email) === null || ref === void 0 ? void 0 : ref.trim().toLowerCase(),
        orderId: (ref1 = payload.orderNo) === null || ref1 === void 0 ? void 0 : ref1.trim().toUpperCase()
    };
    try {
        const state = thunkAPI.getState();
        const { auth: { isAuth =false  } = {}  } = state;
        const isFluent = "enabled" === "enabled";
        const url = isFluent ? _constants__WEBPACK_IMPORTED_MODULE_1__.FIND_MY_ORDERS_V1_ENDPOINT : _constants__WEBPACK_IMPORTED_MODULE_1__.FIND_MY_ORDERS_ENDPOINT;
        if (!isFluent && isAuth) {
            const authData = await _store__WEBPACK_IMPORTED_MODULE_2__/* .store.dispatch */ .h.dispatch(getOrder({
                orderNo: body.orderId
            })).unwrap();
            return {
                results: authData
            };
        } else {
            const { status , data  } = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.post */ .TH.post(url, body);
            if (status === 200) return data;
        }
    } catch (err) {
        return {};
        console.error("Failed to fetch order details", err);
    }
});
const getOrder = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createAsyncThunk */ .hg)("orders/details", async (payload)=>{
    let data = [];
    try {
        const res = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.get */ .TH.get("".concat(_constants__WEBPACK_IMPORTED_MODULE_1__.GET_ORDER_DETAILS_ENDPOINT, '?order-id="').concat(payload.orderNo, '"'));
        if (res && res.data && res.data.results) {
            data = res.data.results;
        }
    } catch (err) {
        // log.error("Failed to fetch order details", err)
        console.error("Failed to fetch order details", err);
    }
    return data;
});
const getOpenOrders = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createAsyncThunk */ .hg)("orders/list/open", async ()=>{
    let data = [];
    try {
        const res = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.get */ .TH.get("".concat(_constants__WEBPACK_IMPORTED_MODULE_1__.GET_ORDER_DETAILS_ENDPOINT, "?state=open"));
        if (res && res.data && res.data.results) {
            data = res.data.results;
        }
    } catch (err) {
        console.error("Failed to fetch open orders", err);
    }
    return data;
});
const getPastOrders = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createAsyncThunk */ .hg)("orders/list/past", async ()=>{
    let data = [];
    try {
        const res = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.get */ .TH.get("".concat(_constants__WEBPACK_IMPORTED_MODULE_1__.GET_ORDER_DETAILS_ENDPOINT, "?state=past"));
        if (res && res.data && res.data.results) {
            data = res.data.results;
        }
    } catch (err) {
        console.error("Failed to fetch past orders", err);
    }
    return data;
});
const getSplitOrder = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createAsyncThunk */ .hg)("orderSplit", async (payload)=>{
    const { email ="" , orderNo =""  } = payload;
    const emailId = email === null || email === void 0 ? void 0 : email.trim().toLowerCase();
    const encodeEmail = encodeURIComponent(emailId);
    const response = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.get */ .TH.get("".concat(_constants__WEBPACK_IMPORTED_MODULE_1__.SPLIT_ORDER, "?parentOrderNumber=").concat(orderNo === null || orderNo === void 0 ? void 0 : orderNo.trim().toUpperCase(), "&email=").concat(encodeEmail));
    return response.data;
});
const orderSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createSlice */ .oM)({
    name: "orders",
    initialState,
    reducers: {},
    extraReducers (builder) {
        builder.addCase(findOrderByEmail.pending, (state)=>{
            state.status = "loading";
        }).addCase(findOrderByEmail.fulfilled, (state, action)=>{
            state.status = "succeeded";
            state.orders = action.payload.addresses;
        }).addCase(findOrderByEmail.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(getSplitOrder.pending, (state)=>{
            state.status = "loading";
        }).addCase(getSplitOrder.fulfilled, (state, action)=>{
            state.status = "succeeded";
        }).addCase(getSplitOrder.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(getOrder.pending, (state)=>{
            state.status = "loading";
        }).addCase(getOrder.fulfilled, (state, action)=>{
            state.status = "succeeded";
        }).addCase(getOrder.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        });
    }
});
const {} = orderSlice.actions;
const ordersState = (state)=>state.orders;


/***/ }),

/***/ 44561:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B$": function() { return /* binding */ getDiscontinuedProductValue; },
/* harmony export */   "BY": function() { return /* binding */ selectPdpState; },
/* harmony export */   "CC": function() { return /* binding */ setProductInfo; },
/* harmony export */   "Co": function() { return /* binding */ getProductBySlug; },
/* harmony export */   "ZR": function() { return /* binding */ setIsTeaserLoaded; },
/* harmony export */   "Zp": function() { return /* binding */ fetchPdpRequiredItems; },
/* harmony export */   "bF": function() { return /* binding */ getProductBySlugAndSku; },
/* harmony export */   "gP": function() { return /* binding */ getReqItemLwData; },
/* harmony export */   "gt": function() { return /* binding */ getPartList; },
/* harmony export */   "n_": function() { return /* binding */ getPdpTooltip; },
/* harmony export */   "ou": function() { return /* binding */ pdpSlice; },
/* harmony export */   "qK": function() { return /* binding */ setPDP; },
/* harmony export */   "ub": function() { return /* binding */ setTeaserContent; },
/* harmony export */   "vM": function() { return /* binding */ setRequiredItemsSkuData; },
/* harmony export */   "ww": function() { return /* binding */ getVariantFields; },
/* harmony export */   "zF": function() { return /* binding */ searchPdp; }
/* harmony export */ });
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _constants_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73350);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96301);
/* harmony import */ var _constants_routes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64757);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(77236);
/* harmony import */ var next_redux_wrapper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(28858);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(55760);
/* harmony import */ var _components_ProductDetail_v3_productDetailsHelper__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14887);
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(19514);
/* harmony import */ var _utils_ApiUtil__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(51666);











const initialState = {
    pdp: {},
    isDiscontinued: false,
    productInfo: {},
    teaserContent: [],
    isTeaserLoaded: false,
    requiredItemsSkuData: []
};
const searchPdp = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("pdp/searchPdp", async (payload, thunkAPI)=>{
    try {
        var ref;
        const { slug , isParts , selectedSku , selectedColor , setSkuVariantCb , getVariantFieldsCb , lwAppName ="" , quickView =false  } = payload;
        const config = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_7__/* .getConfig */ .i)();
        var ref1;
        const language = (ref1 = config === null || config === void 0 ? void 0 : (ref = config.internationalization) === null || ref === void 0 ? void 0 : ref.language) !== null && ref1 !== void 0 ? ref1 : "en";
        const response = await _constants_api__WEBPACK_IMPORTED_MODULE_1__/* .apim.post */ .TH.post("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_2__.searchPdpEndPoint, "/").concat(slug), {
            q: "*:*",
            fl: _constants_index__WEBPACK_IMPORTED_MODULE_2__.SEARCH_PDP_FL.join(","),
            fq: 'language_s:("'.concat(language, '")'),
            collections: isParts ? "service_parts" : lwAppName === null || lwAppName === void 0 ? void 0 : lwAppName.toLowerCase(),
            profilename: isParts ? "profile_service_parts_PDP" : "profile_".concat(lwAppName === null || lwAppName === void 0 ? void 0 : lwAppName.toLowerCase(), "_PDP"),
            search_type: "product_detail",
            sessionId: (0,_utils_ApiUtil__WEBPACK_IMPORTED_MODULE_9__/* .getSessionIdObjWithEpoc */ .oq)()
        });
        const { data: { response: { docs =[]  } = {} , fusion: { BundleSKUDetails: bundleIncludedItems = [] , ProductDimensionAttributes ={} , ProductDimensionAttributesValues ={} , configuratorEnabled =false  } = {}  } = {}  } = response;
        const dimensionData = Object.keys(ProductDimensionAttributes).length && Object.keys(ProductDimensionAttributesValues).length ? {
            ProductDimensionAttributes,
            ProductDimensionAttributesValues
        } : {};
        const productData = docs.at(0);
        const threeSixtyResourceData = {};
        if (productData === null || productData === void 0 ? void 0 : productData["ItemResource.IMGSpinSet.resourceFullWebURL_ss"]) {
            threeSixtyResourceData.resourceFullWebUrl = productData["ItemResource.IMGSpinSet.resourceFullWebURL_ss"];
        }
        if (productData === null || productData === void 0 ? void 0 : productData["ItemResource.IMGSpinSet.resourceAltText_ss"]) {
            threeSixtyResourceData.resourceAltText = productData["ItemResource.IMGSpinSet.resourceAltText_ss"];
        }
        if (productData === null || productData === void 0 ? void 0 : productData["ItemResource.IMGSpinSet.resourceName_ss"]) {
            threeSixtyResourceData.resourceName = productData["ItemResource.IMGSpinSet.resourceName_ss"];
        }
        if (productData === null || productData === void 0 ? void 0 : productData["ItemResource.IMGSpinSet.resourceType_ss"]) {
            threeSixtyResourceData.resourceTypeImg = productData["ItemResource.IMGSpinSet.resourceType_ss"];
        }
        const sku = selectedSku === "" || !productData["variantList.sku_ss"].some((v)=>v === selectedSku) ? (0,_components_ProductDetail_v3_productDetailsHelper__WEBPACK_IMPORTED_MODULE_6__/* .getInitialSku */ .H3)({
            productData,
            setSkuVariantCb,
            selectedColor
        }) : selectedSku;
        const customerFacingSKU = productData["CustomerFacingSKU_s"];
        const fusionQueryId = lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(response.data, "fusion.fusionQueryId");
        if (productData === null || productData === void 0 ? void 0 : productData["variantList.sku_ss"]) {
            getVariantFieldsCb(productData["variantList.sku_ss"]);
        }
        let recommendedAccessories = [];
        if (productData === null || productData === void 0 ? void 0 : productData["ProductProductRecommendedAccessories_ss"]) {
            recommendedAccessories = productData["ProductProductRecommendedAccessories_ss"];
        } else if (productData === null || productData === void 0 ? void 0 : productData["ProductProductRecommendedAccessories_s"]) {
            recommendedAccessories.push(productData["ProductProductRecommendedAccessories_s"]);
        }
        let colors = [];
        if (productData === null || productData === void 0 ? void 0 : productData["Color.SKU.Details_ss"]) {
            colors = productData["Color.SKU.Details_ss"].map((color)=>{
                const d = color.split("|");
                return {
                    sku: d[2],
                    discontinued: !(d[4] === "false" || Date.parse(d[4]) > Date.now())
                };
            });
        }
        (0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__/* .addToRecentlyViewed */ .gP3)(productData["ctId_s"]);
        return {
            bundleIncludedItems,
            productData,
            sku,
            recommendedAccessories,
            colors,
            fusionQueryId,
            customerFacingSKU,
            slug,
            dimensionData,
            threeSixtyResourceData,
            quickView,
            configuratorEnabled
        };
    } catch (err) {
        return err;
    }
});
const getVariantFields = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("pdp/getVariantFields", async (payload)=>{
    try {
        var ref;
        const { skuList =[] , slug , isParts , lwAppName =""  } = payload;
        let skus = "";
        skuList.forEach((s)=>skus += '"'.concat(s, '" '));
        const config = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_7__/* .getConfig */ .i)();
        var ref1;
        const language = (ref1 = config === null || config === void 0 ? void 0 : (ref = config.internationalization) === null || ref === void 0 ? void 0 : ref.language) !== null && ref1 !== void 0 ? ref1 : "en";
        const response = await _constants_api__WEBPACK_IMPORTED_MODULE_1__/* .apim.post */ .TH.post("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_2__.searchPdpEndPoint, "/").concat(slug), {
            q: "*:*",
            fq: "sku_s:(".concat(skus.trim(), '),language_s:("').concat(language, '")'),
            fl: "sku_s,RegionStatesExcluded_ss,RegionSpecialOrder_s",
            collections: isParts ? "service_parts" : lwAppName.toLowerCase(),
            profilename: isParts ? "profile_service_parts_PDP" : "profile_".concat(lwAppName.toLowerCase(), "_PDP"),
            search_type: "product_detail",
            sessionId: (0,_utils_ApiUtil__WEBPACK_IMPORTED_MODULE_9__/* .getSessionIdObjWithEpoc */ .oq)()
        });
        return response.data;
    } catch (err) {
        return err;
    }
});
const getPartList = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("pdp/getPartList", async (payload)=>{
    let parts = {};
    try {
        const { productId  } = payload;
        const response = await _constants_api__WEBPACK_IMPORTED_MODULE_1__/* .apim.get */ .TH.get("".concat(_constants_routes__WEBPACK_IMPORTED_MODULE_3__/* .SVG_METADATA_ENDPOINT */ .YZ, "/").concat(productId));
        if (response && response.data) {
            parts = response.data;
        }
    } catch (err) {
        return err;
    }
    return parts;
});
const getProductBySlug = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("pdp/getProductBySlug", async (payload)=>{
    let product = {};
    try {
        const { slug  } = payload;
        const response = await _constants_api__WEBPACK_IMPORTED_MODULE_1__/* .apim.get */ .TH.get("".concat(_constants_routes__WEBPACK_IMPORTED_MODULE_3__/* .CATALOG_PROJECTION_ENDPOINT */ .E5, '?where=slug(en-US%3D"').concat(slug, '")'));
        if (response && response.data && response.data.results) {
            var ref;
            product = (ref = response.data.results[0]) !== null && ref !== void 0 ? ref : {};
        }
    } catch (err) {
        return err;
    }
    return product;
});
const getProductBySlugAndSku = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("pdp/getProductBySlugAndSku", async (payload)=>{
    const { slug , skus  } = payload;
    let query = "";
    let masterQuery = "";
    if (slug) masterQuery += 'slug(en-US%3D"'.concat(slug, '") or ');
    if (skus.length > 0) {
        skus.forEach((sku, i)=>{
            query += '"'.concat(sku, '"');
            if (i + 1 !== skus.length) query += ", ";
        });
        masterQuery += "masterVariant(sku in (".concat(query, ")) or variants(sku in (").concat(query, "))");
    }
    try {
        const res = await _constants_api__WEBPACK_IMPORTED_MODULE_1__/* .apim.get */ .TH.get("".concat(_constants_routes__WEBPACK_IMPORTED_MODULE_3__/* .CATALOG_PROJECTION_ENDPOINT */ .E5, "?where=").concat(masterQuery));
        if (res && res.data && res.data.results) return res.data.results;
    } catch (err) {
        console.error("Failed to fetch product details", err);
    }
    return [];
});
const getReqItemLwData = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("pdp/getReqItemLwData", async (payload)=>{
    var ref, ref1, ref2;
    const { query , lwAppName =""  } = payload;
    const config = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_7__/* .getConfig */ .i)();
    var ref3;
    const language = (ref3 = config === null || config === void 0 ? void 0 : (ref = config.internationalization) === null || ref === void 0 ? void 0 : ref.language) !== null && ref3 !== void 0 ? ref3 : "en";
    const response = await _constants_api__WEBPACK_IMPORTED_MODULE_1__/* .apim.get */ .TH.get(_constants_index__WEBPACK_IMPORTED_MODULE_2__.searchPlpEndPoint, {
        params: {
            q: "*:*",
            fl: "ctId_s, RegionOnBackOrder_s",
            fq: [
                "ctId_s:(".concat(query.trim(), ")"),
                'masterVariant_b:("true")',
                'language_s:("'.concat(language, '")')
            ],
            collections: lwAppName.toLowerCase(),
            profilename: "profile_".concat(lwAppName.toLowerCase(), "_General"),
            sessionId: (0,_utils_ApiUtil__WEBPACK_IMPORTED_MODULE_9__/* .getSessionIdObjWithEpoc */ .oq)()
        },
        paramsSerializer: (params)=>{
            return qs__WEBPACK_IMPORTED_MODULE_10___default().stringify(params, {
                arrayFormat: "repeat",
                encode: false
            });
        }
    });
    var ref4;
    return (ref4 = response === null || response === void 0 ? void 0 : (ref1 = response.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.response) === null || ref2 === void 0 ? void 0 : ref2.docs) !== null && ref4 !== void 0 ? ref4 : [];
});
const fetchPdpRequiredItems = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("pdp/fetchPdpRequiredItems", async (query)=>{
    try {
        const response = await _constants_api__WEBPACK_IMPORTED_MODULE_1__/* .apim.get */ .TH.get("".concat(_constants_routes__WEBPACK_IMPORTED_MODULE_3__/* .CATALOG_PROJECTION_ENDPOINT */ .E5, "?where=id in (").concat(query, ")"));
        var _results;
        return (_results = response.data.results) !== null && _results !== void 0 ? _results : [];
    } catch (err) {
        return err;
    }
});
const getPdpTooltip = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createAsyncThunk */ .hg)("pdp/getPdpTooltip", async (payload)=>{
    const { brandName  } = payload;
    const response = await _constants_api__WEBPACK_IMPORTED_MODULE_1__/* .apim.get */ .TH.get(_constants_index__WEBPACK_IMPORTED_MODULE_2__.getPdpTooltipEndPoint, {
        params: {
            collection: brandName === null || brandName === void 0 ? void 0 : brandName.toLowerCase()
        }
    });
    return response === null || response === void 0 ? void 0 : response.data;
});
const pdpSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createSlice */ .oM)({
    name: "pdp",
    initialState,
    reducers: {
        setPDP (state, action) {
            state.pdp = {
                ...state.pdp,
                ...action.payload
            };
        },
        getDiscontinuedProductValue (state, action) {
            state.isDiscontinued = action.payload;
        },
        setProductInfo (state, action) {
            state.productInfo = action.payload;
        },
        setTeaserContent (state, action) {
            state.teaserContent = action.payload;
        },
        setIsTeaserLoaded (state, action) {
            state.isTeaserLoaded = action.payload;
        },
        setRequiredItemsSkuData (state, action) {
            state.requiredItemsSkuData = action.payload;
        }
    },
    extraReducers (builder) {
        builder.addCase([
            next_redux_wrapper__WEBPACK_IMPORTED_MODULE_4__/* .HYDRATE */ .ju
        ], (state, action)=>{
            return {
                ...state,
                ...action.payload.pdp
            };
        }).addCase(searchPdp.pending, (state, action)=>{
            state.status = "pending";
        }).addCase(searchPdp.fulfilled, (state, action)=>{
            const { productData ={} , sku ="" , recommendedAccessories =[] , colors =[] , slug ="" , customerFacingSKU ="" , bundleIncludedItems =[] , quickView =false , configuratorEnabled =false  } = action.payload;
            state.status = "succeeded";
            if (!quickView) {
                state.pdp = {
                    sku,
                    slug: slug,
                    recommendedAccessories,
                    productBrand: productData["ProductBrandNameDisplay_t"],
                    productNo: productData["ProductProductNo_s"],
                    data: productData,
                    variants: colors,
                    customerFacingSKU: customerFacingSKU ? customerFacingSKU.replace("K-", "") : "",
                    bundleIncludedItems,
                    configuratorEnabled
                };
            }
        }).addCase(searchPdp.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        }).addCase(getProductBySlugAndSku.pending, (state)=>{
            state.status = "pending";
        }).addCase(getProductBySlugAndSku.fulfilled, (state, action)=>{
            state.status = "succeeded";
            state.productServices = action.payload;
        }).addCase(getProductBySlugAndSku.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.error.message;
        });
    }
});
const { setPDP , getDiscontinuedProductValue , setProductInfo , setTeaserContent , setIsTeaserLoaded , setRequiredItemsSkuData  } = pdpSlice.actions;
const selectPdpState = (state)=>state.pdp;
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = (pdpSlice.reducer);


/***/ }),

/***/ 49682:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bp": function() { return /* binding */ profileBrandTopSearches; },
/* harmony export */   "Li": function() { return /* binding */ setCurrentAppliedfilters; },
/* harmony export */   "R$": function() { return /* binding */ profileBrandSearch; },
/* harmony export */   "Tx": function() { return /* binding */ productListSlice; },
/* harmony export */   "Xp": function() { return /* binding */ getProducts; },
/* harmony export */   "ZZ": function() { return /* binding */ setVisualNavAppliedFilters; },
/* harmony export */   "dM": function() { return /* binding */ clearSuggestion; },
/* harmony export */   "gS": function() { return /* binding */ setPlpData; },
/* harmony export */   "n7": function() { return /* binding */ profileServicePartsSearch; },
/* harmony export */   "rv": function() { return /* binding */ selectProductListState; },
/* harmony export */   "zw": function() { return /* binding */ profileBrandTypeahead; }
/* harmony export */ });
/* unused harmony exports setProfileServicePartsSearch, setProfileBrandTypeahead, setProfileBrandSearch, updatePlpData, updatePlpDataStatus */
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _constants_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73350);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96301);
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19514);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55760);
/* harmony import */ var _utils_product__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29843);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(77236);
/* harmony import */ var next_redux_wrapper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(28858);
/* harmony import */ var _utils_ApiUtil__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(51666);









const initialState = {
    profile_service_parts_Search: {},
    profile_brand_Typeahead: {},
    profile_brand_Search: {},
    profile_brand_Top_Searches: {},
    visualNavAppliedFilters: [],
    visualNavFiltersInitialLoad: false,
    plp: {
        status: "loading-yes",
        error: "",
        initialLoad: true,
        suggestions: [],
        suggestionExactMatch: false,
        currentAppliedfilters: []
    }
};
const profileBrandTypeahead = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)("profileBrandTypeahead", async (query)=>{
    var ref;
    const config = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_2__/* .getConfig */ .i)();
    var ref1;
    const language = (ref1 = config === null || config === void 0 ? void 0 : (ref = config.internationalization) === null || ref === void 0 ? void 0 : ref.language) !== null && ref1 !== void 0 ? ref1 : "en";
    const response = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.get */ .TH.get("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_1__.searchPlpEndPoint, "?rows=10&fl=sku_s,masterCustomerFacingSKU_s,productName_s&collections=").concat(query[1], "&profilename=profile_").concat(query[1], "_Typeahead&q=").concat(query[0], '&start=0&fq=language_s:("').concat(language, '")&sessionId=').concat((0,_utils_ApiUtil__WEBPACK_IMPORTED_MODULE_7__/* .getSessionIdObjWithEpoc */ .oq)()));
    return response.data;
});
const profileServicePartsSearch = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)("profileServicePartsSearch", async (query)=>{
    var ref;
    const config = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_2__/* .getConfig */ .i)();
    var ref1;
    const language = (ref1 = config === null || config === void 0 ? void 0 : (ref = config.internationalization) === null || ref === void 0 ? void 0 : ref.language) !== null && ref1 !== void 0 ? ref1 : "en";
    const response = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.get */ .TH.get("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_1__.searchPlpEndPoint, "?rows=").concat(query[2], "&fl=").concat(query[1], "&collections=service_parts&profilename=profile_service_parts_Search&q=").concat(query[0], '&fq=language_s%3A("').concat(language, '")&sessionId=').concat((0,_utils_ApiUtil__WEBPACK_IMPORTED_MODULE_7__/* .getSessionIdObjWithEpoc */ .oq)()));
    return response.data;
});
const profileBrandSearch = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)("profileBrandSearch", async (query)=>{
    var ref;
    const config = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_2__/* .getConfig */ .i)();
    var ref1;
    const language = (ref1 = config === null || config === void 0 ? void 0 : (ref = config.internationalization) === null || ref === void 0 ? void 0 : ref.language) !== null && ref1 !== void 0 ? ref1 : "en";
    const response = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.get */ .TH.get("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_1__.searchPlpEndPoint, "?rows=").concat(query[3], "&fl=").concat(query[2], "&lw.tagger.debug=true&collections=").concat(query[1], "&profilename=profile_").concat(query[1], "_Search&q=").concat(query[0], "&fq=").concat(query[4], '&fq=language_s:("').concat(language, '")&sessionId=').concat((0,_utils_ApiUtil__WEBPACK_IMPORTED_MODULE_7__/* .getSessionIdObjWithEpoc */ .oq)()).concat(query[3] === 1 ? "&servicePartsSearch=true" : ""));
    return response.data;
});
const profileBrandTopSearches = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)("profileBrandTopSearches", async (brand)=>{
    var ref;
    const config = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_2__/* .getConfig */ .i)();
    var ref1;
    const language = (ref1 = config === null || config === void 0 ? void 0 : (ref = config.internationalization) === null || ref === void 0 ? void 0 : ref.language) !== null && ref1 !== void 0 ? ref1 : "en";
    const response = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.get */ .TH.get("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_1__.searchProfilePlpEndPoint, "?q=*.*&profilename=profile_").concat(brand, "_Top_Searches&collections=").concat(brand, '&fq=language_s:("').concat(language, '")&sessionId=').concat((0,_utils_ApiUtil__WEBPACK_IMPORTED_MODULE_7__/* .getSessionIdObjWithEpoc */ .oq)()));
    return response.data;
});
const getProducts = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)("plp/getProducts", async (payload)=>{
    var ref, ref1, ref2, ref3, ref4, ref5;
    const persona = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_3__/* .getUserPersona */ .shu)();
    const { profileName: profilename , update , query , isFaq , isSuggestion , collections , ...params } = payload;
    const url = isFaq ? _constants_index__WEBPACK_IMPORTED_MODULE_1__.HELP_FAQ_END_POINT : _constants_index__WEBPACK_IMPORTED_MODULE_1__.PLP_END_POINT_CLIENT;
    const config = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_2__/* .getConfig */ .i)();
    var ref6;
    const language = (ref6 = config === null || config === void 0 ? void 0 : (ref = config.internationalization) === null || ref === void 0 ? void 0 : ref.language) !== null && ref6 !== void 0 ? ref6 : "en";
    var ref7;
    const canadianPrice = (ref7 = config === null || config === void 0 ? void 0 : (ref1 = config.apiEndPointData) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.map) === null || ref2 === void 0 ? void 0 : ref2.canadianPrice) !== null && ref7 !== void 0 ? ref7 : null;
    const customParams = {
        ...query,
        ...params,
        persona,
        profilename,
        sessionId: (0,_utils_ApiUtil__WEBPACK_IMPORTED_MODULE_7__/* .getSessionIdObjWithEpoc */ .oq)()
    };
    if (collections) customParams.collections = collections;
    if (canadianPrice) customParams.CanadianPrice = canadianPrice;
    if (!isFaq) {
        if (!customParams.fq) {
            customParams.fq = 'language_s:("'.concat(language, '")');
        } else {
            if (typeof customParams.fq === "string" && customParams.fq.length > 0) {
                customParams.fq = [
                    customParams.fq,
                    'language_s:("'.concat(language, '")')
                ];
            } else if (Array.isArray(customParams.fq)) {
                customParams.fq = [
                    ...customParams.fq,
                    'language_s:("'.concat(language, '")')
                ];
            }
        }
    }
    const response = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.get */ .TH.get(url, {
        params: customParams,
        paramsSerializer: (params)=>{
            return qs__WEBPACK_IMPORTED_MODULE_8___default().stringify(params, {
                arrayFormat: "repeat",
                encode: false
            });
        }
    });
    const data = isSuggestion ? response === null || response === void 0 ? void 0 : (ref3 = response.data) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.response) === null || ref4 === void 0 ? void 0 : ref4.docs : await (0,_utils_product__WEBPACK_IMPORTED_MODULE_4__/* .formatListingData */ .nx)(response.data);
    return {
        data,
        update,
        isSuggestion,
        total: (ref5 = response.data) === null || ref5 === void 0 ? void 0 : ref5.response["numFound"]
    };
});
const productListSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createSlice */ .oM)({
    name: "productList",
    initialState,
    reducers: {
        setProfileServicePartsSearch (state, action) {
            state.profile_service_parts_Search = action.payload;
        },
        setVisualNavAppliedFilters (state, action) {
            state.visualNavAppliedFilters = action.payload;
            state.visualNavFiltersInitialLoad = true;
        },
        setCurrentAppliedfilters (state, action) {
            state.plp = {
                ...state.plp,
                currentAppliedfilters: action.payload
            };
        },
        setProfileBrandTypeahead (state, action) {
            state.profile_brand_Typeahead = action.payload;
        },
        setProfileBrandSearch (state, action) {
            state.profile_brand_Search = action.payload;
        },
        setPlpData (state, action) {
            state.plp = action === null || action === void 0 ? void 0 : action.payload;
            state.plp["status"] = "succeeded";
        },
        updatePlpData (state, action) {
            state.plp = {
                ...state.plp,
                data: [
                    ...state.plp.data,
                    ...action.payload
                ]
            };
        },
        updatePlpDataStatus (state, action) {
            state.plp.status = action.payload;
        },
        clearSuggestion (state) {
            state.plp.suggestions = [];
        }
    },
    extraReducers (builder) {
        builder.addCase([
            next_redux_wrapper__WEBPACK_IMPORTED_MODULE_5__/* .HYDRATE */ .ju
        ], (state, action)=>{
            return {
                ...state,
                ...action.payload
            };
        }).addCase(profileBrandSearch.pending, (state, action)=>{
            state.status = "loading";
        }).addCase(profileBrandSearch.fulfilled, (state, action)=>{
            state.profile_brand_Search = action.payload;
            state.profile_brand_Search.status = "succeeded";
        }).addCase(profileBrandSearch.rejected, (state, action)=>{
            state.profile_brand_Search.status = "failed";
            state.profile_brand_Search.error = action.error.message;
        }).addCase(profileServicePartsSearch.pending, (state, action)=>{
            state.profile_service_parts_Search.status = "loading";
        }).addCase(profileServicePartsSearch.fulfilled, (state, action)=>{
            if (action.payload && action.payload !== "") {
                state.profile_service_parts_Search = action.payload;
                state.profile_service_parts_Search.status = "succeeded";
            }
        }).addCase(profileServicePartsSearch.rejected, (state, action)=>{
            state.profile_service_parts_Search.status = "failed";
            state.profile_service_parts_Search.error = action.error.message;
        }).addCase(profileBrandTopSearches.pending, (state, action)=>{
            state.profile_brand_Top_Searches.status = "loading";
        }).addCase(profileBrandTopSearches.fulfilled, (state, action)=>{
            if (action.payload && action.payload !== "") {
                state.profile_brand_Top_Searches = action.payload;
                state.profile_brand_Top_Searches.status = "succeeded";
            }
        }).addCase(profileBrandTopSearches.rejected, (state, action)=>{
            state.profile_brand_Top_Searches.status = "failed";
            state.profile_brand_Top_Searches.error = action.error.message;
        }).addCase(profileBrandTypeahead.pending, (state, action)=>{
            state.profile_brand_Typeahead.status = "loading";
        }).addCase(profileBrandTypeahead.fulfilled, (state, action)=>{
            state.profile_brand_Typeahead = action.payload;
            state.profile_brand_Typeahead.status = "succeeded";
        }).addCase(profileBrandTypeahead.rejected, (state, action)=>{
            state.profile_brand_Typeahead.status = "failed";
            state.profile_brand_Top_Searches.error = action.error.message;
        }).addCase(getProducts.pending, (state, action)=>{
            if (!state.plp.initialLoad) {
                state.plp.status = "loading";
            }
        }).addCase(getProducts.fulfilled, (state, action)=>{
            const { data , update , isSuggestion ="" , total =0  } = (action === null || action === void 0 ? void 0 : action.payload) || {};
            if (isSuggestion) {
                state.plp = {
                    ...state.plp,
                    suggestions: data,
                    suggestionExactMatch: isSuggestion
                };
            } else if (update) {
                state.plp = {
                    ...state.plp,
                    data: state.plp.data.concat(data.data)
                };
            } else {
                state.plp = data;
            }
            state.plp.initialLoad = false;
            state.plp.status = "succeeded";
            state.plp.total = total;
        }).addCase(getProducts.rejected, (state, action)=>{
            state.plp.status = "failed";
            state.plp.error = action.error.message;
        });
    }
});
const { setProfileServicePartsSearch , setVisualNavAppliedFilters , setCurrentAppliedfilters , setProfileBrandTypeahead , setProfileBrandSearch , setPlpData , updatePlpData , updatePlpDataStatus , clearSuggestion  } = productListSlice.actions;
const selectProductListState = (state)=>state.productList;
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = (productListSlice.reducer);


/***/ }),

/***/ 57879:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ec": function() { return /* binding */ setSearchKeyword; },
/* harmony export */   "Qf": function() { return /* binding */ setSearchFilter; },
/* harmony export */   "iv": function() { return /* binding */ searchSlice; },
/* harmony export */   "kj": function() { return /* binding */ setSearchCount; },
/* harmony export */   "mJ": function() { return /* binding */ fetchSearchServicePartsResults; },
/* harmony export */   "uv": function() { return /* binding */ searchState; },
/* harmony export */   "w$": function() { return /* binding */ fetchSearchAllResults; }
/* harmony export */ });
/* unused harmony exports fetchSearchInspirationResults, getSearchProducts, getProducts */
/* harmony import */ var _constants_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73350);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96301);
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19514);
/* harmony import */ var _utils_product__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29843);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(77236);
/* harmony import */ var next_redux_wrapper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(28858);
/* harmony import */ var _utils_ApiUtil__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(51666);







const fetchSearchInspirationResults = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .createAsyncThunk */ .hg)("search/fetchSearchResults", async (general)=>{
    var ref;
    const config = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_2__/* .getConfig */ .i)();
    var ref1;
    const language = (ref1 = config === null || config === void 0 ? void 0 : (ref = config.internationalization) === null || ref === void 0 ? void 0 : ref.language) !== null && ref1 !== void 0 ? ref1 : "en";
    const { general: { lwAppName =""  } = {}  } = config !== null && config !== void 0 ? config : {};
    const response = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.get */ .TH.get(_constants_index__WEBPACK_IMPORTED_MODULE_1__.searchPlpEndPoint, {
        params: {
            fl: "id",
            fq: [
                'language_s:("'.concat(language, '")')
            ],
            q: "*:*",
            rows: 5,
            profilename: "profile_".concat(lwAppName.toLowerCase(), "_Search"),
            collections: lwAppName.toLowerCase(),
            sessionId: (0,_utils_ApiUtil__WEBPACK_IMPORTED_MODULE_6__/* .getSessionIdObjWithEpoc */ .oq)()
        }
    });
    return response.data;
});
const getSearchProducts = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .createAsyncThunk */ .hg)("search/getProducts", async (payload)=>{
    var ref;
    const { profilename , collections , q , fq , rows , start , fl  } = payload;
    const config = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_2__/* .getConfig */ .i)();
    var ref1;
    const language = (ref1 = config === null || config === void 0 ? void 0 : (ref = config.internationalization) === null || ref === void 0 ? void 0 : ref.language) !== null && ref1 !== void 0 ? ref1 : "en";
    const url = "".concat(_constants_index__WEBPACK_IMPORTED_MODULE_1__.searchPlpEndPoint, "?q=").concat(q, "&fl=").concat(fl).concat(fq ? "&fq=".concat(fq.join("&fq=")) : "").concat(rows ? "&rows=" : "").concat(rows ? rows : "").concat(start >= 0 ? "&start=" : "").concat(start >= 0 ? start : "", "&profilename=").concat(profilename, "&collections=").concat(collections, '&fq=language_s:("').concat(language, '")&sessionId=').concat((0,_utils_ApiUtil__WEBPACK_IMPORTED_MODULE_6__/* .getSessionIdObjWithEpoc */ .oq)());
    const response = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.get */ .TH.get(url);
    return {
        response
    };
});
const initialState = {
    searchDetails: {},
    search: {
        status: "loading",
        error: ""
    },
    servicePartsSearch: {
        status: "loading",
        error: ""
    },
    searchResponse: {
        data: ""
    },
    servicePartsSearchResponse: {
        data: ""
    }
};
const fetchSearchAllResults = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .createAsyncThunk */ .hg)("search/fetchSearchAllResults", async (params)=>{
    var ref, ref1, ref2;
    const config = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_2__/* .getConfig */ .i)();
    var ref3;
    const language = (ref3 = config === null || config === void 0 ? void 0 : (ref = config.internationalization) === null || ref === void 0 ? void 0 : ref.language) !== null && ref3 !== void 0 ? ref3 : "en";
    if (!params.fq) {
        params.fq = 'language_s:("'.concat(language, '")');
    } else {
        if (typeof params.fq === "string" && params.fq.length > 0) {
            params.fq = [
                params.fq,
                'language_s:("'.concat(language, '")')
            ];
        } else if (Array.isArray(params.fq)) {
            params.fq = [
                ...params.fq,
                'language_s:("'.concat(language, '")')
            ];
        }
    }
    var ref4;
    const canadaPrice = (ref4 = config === null || config === void 0 ? void 0 : (ref1 = config.apiEndPointData) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.map) === null || ref2 === void 0 ? void 0 : ref2.canadianPrice) !== null && ref4 !== void 0 ? ref4 : null;
    canadaPrice ? params.CanadianPrice = canadaPrice : null;
    const searchParams = new URLSearchParams(params);
    const url = "".concat(_constants_index__WEBPACK_IMPORTED_MODULE_1__.PLP_END_POINT_CLIENT, "?").concat(searchParams.toString());
    const response = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.get */ .TH.get(url);
    return response.data;
});
const fetchSearchServicePartsResults = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .createAsyncThunk */ .hg)("search/fetchSearchServicePartsResults", async (params)=>{
    var ref, ref1, ref2;
    const config = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_2__/* .getConfig */ .i)();
    var ref3;
    const language = (ref3 = config === null || config === void 0 ? void 0 : (ref = config.internationalization) === null || ref === void 0 ? void 0 : ref.language) !== null && ref3 !== void 0 ? ref3 : "en";
    if (!params.fq) {
        params.fq = 'language_s:("'.concat(language, '")');
    } else {
        if (typeof params.fq === "string" && params.fq.length > 0) {
            params.fq = [
                params.fq,
                'language_s:("'.concat(language, '")')
            ];
        } else if (Array.isArray(params.fq)) {
            params.fq = [
                ...params.fq,
                'language_s:("'.concat(language, '")')
            ];
        }
    }
    var ref4;
    const canadaPrice = (ref4 = config === null || config === void 0 ? void 0 : (ref1 = config.apiEndPointData) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.map) === null || ref2 === void 0 ? void 0 : ref2.canadianPrice) !== null && ref4 !== void 0 ? ref4 : null;
    canadaPrice ? params.CanadianPrice = canadaPrice : null;
    const searchParams = new URLSearchParams({
        ...params,
        sessionId: (0,_utils_ApiUtil__WEBPACK_IMPORTED_MODULE_6__/* .getSessionIdObjWithEpoc */ .oq)()
    });
    const url = "".concat(_constants_index__WEBPACK_IMPORTED_MODULE_1__.PLP_END_POINT_CLIENT, "?").concat(searchParams.toString());
    const response = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.get */ .TH.get(url);
    return response.data;
});
const getProducts = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .createAsyncThunk */ .hg)("plp/getProducts", async (payload)=>{
    const { q , profileName , update , query , collections , displaytype , type  } = payload;
    const { internationalization: { language ="en"  } = {} , apiEndPointData: { map: { canadianPrice =""  } = {}  } = {}  } = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_2__/* .getConfig */ .i)();
    const { fq , rows , start , sort  } = query;
    const url = "".concat(type === "parts" ? _constants_index__WEBPACK_IMPORTED_MODULE_1__.PROFILE_END_POINT_CLIENT : _constants_index__WEBPACK_IMPORTED_MODULE_1__.PLP_END_POINT_CLIENT, "?profilename=").concat(profileName).concat(fq ? "&fq=".concat(fq.join("&fq=")) : "").concat(sort ? "&sort=".concat(sort) : "").concat(q ? "&q=".concat(q) : "").concat(collections ? "&collections=".concat(collections) : "").concat(displaytype ? "&displaytype=".concat(displaytype) : "").concat(rows ? "&rows=" : "").concat(rows ? rows : "").concat(start >= 0 ? "&start=" : "").concat(start >= 0 ? start : "").concat('&fq=language_s:("'.concat(language, '")&sessionId=').concat((0,_utils_ApiUtil__WEBPACK_IMPORTED_MODULE_6__/* .getSessionIdObjWithEpoc */ .oq)())).concat(canadianPrice ? "&CanadianPrice=".concat(canadianPrice) : null);
    const response = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.get */ .TH.get(url);
    const data = await (0,_utils_product__WEBPACK_IMPORTED_MODULE_3__/* .formatListingData */ .nx)(response.data);
    return {
        data,
        update
    };
});
const searchSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .createSlice */ .oM)({
    name: "search",
    initialState,
    reducers: {
        setSearchCount: (state, action)=>{
            state.searchDetails = action.payload;
        },
        setSearchFilter: (state, param)=>{
            let { payload: { key ="" , queries =[]  }  } = param;
            const searchDetails = {
                ...state.searchDetails
            };
            if (key) searchDetails[key] = {
                ...searchDetails[key],
                filters: queries
            };
            state.searchDetails = {
                ...state.searchDetails
            };
            state.searchDetails = searchDetails;
        },
        setSearchKeyword: (state, action)=>{
            state.searchDetails = {
                ...state.searchDetails,
                keyword: action.payload
            };
        }
    },
    extraReducers (builder) {
        builder.addCase([
            next_redux_wrapper__WEBPACK_IMPORTED_MODULE_4__/* .HYDRATE */ .ju
        ], (state, action)=>{
            return {
                ...state,
                ...action.payload
            };
        }).addCase(fetchSearchAllResults.pending, (state, action)=>{
            state.search.status = "loading";
        }).addCase(fetchSearchAllResults.fulfilled, (state, action)=>{
            state.search.status = "succeeded";
            state.search.error = "";
            state.searchResponse.data = action.payload;
        }).addCase(fetchSearchAllResults.rejected, (state, action)=>{
            state.search.status = "failed";
            state.search.error = action.error.message;
        }).addCase(fetchSearchServicePartsResults.pending, (state, action)=>{
            state.servicePartsSearch.status = "loading";
        }).addCase(fetchSearchServicePartsResults.fulfilled, (state, action)=>{
            state.servicePartsSearch.status = "succeeded";
            state.servicePartsSearch.error = "";
            state.servicePartsSearchResponse.data = action.payload;
        }).addCase(fetchSearchServicePartsResults.rejected, (state, action)=>{
            state.servicePartsSearch.status = "failed";
            state.servicePartsSearch.error = action.error.message;
        }).addCase(getSearchProducts.pending, (state, action)=>{
            state.searchDetails.status = "loading";
        }).addCase(getSearchProducts.fulfilled, (state, action)=>{
            state.searchDetails = action.payload;
            state.searchDetails.status = "succeeded";
        }).addCase(getSearchProducts.rejected, (state, action)=>{
            state.searchDetails.status = "failed";
            state.searchDetails.error = action.error.message;
        });
    }
});
const { setSearchCount , setSearchFilter , setSearchKeyword  } = searchSlice.actions;
const searchState = (state)=>state.search;
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = (searchSlice.reducer);


/***/ }),

/***/ 53882:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LG": function() { return /* binding */ shopTheRoomSlice; },
/* harmony export */   "Lg": function() { return /* binding */ shopTheRoomState; },
/* harmony export */   "MK": function() { return /* binding */ laodingStatus; },
/* harmony export */   "Ti": function() { return /* binding */ setRoomList; },
/* harmony export */   "f4": function() { return /* binding */ getFilterShopRoomList; }
/* harmony export */ });
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _constants_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73350);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96301);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(77236);
/* harmony import */ var next_redux_wrapper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28858);
/* harmony import */ var _utils_product__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29843);






const laodingStatus = {
    loading: "loading",
    success: "success",
    rejected: "faiure"
};
const shopTheRoomInitialState = {
    roomList: undefined,
    filterList: undefined,
    facets: undefined,
    facetLabels: undefined,
    fusion: {},
    status: laodingStatus.loading
};
const shopTheRoomSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createSlice */ .oM)({
    name: "shopTheRoomState",
    initialState: shopTheRoomInitialState,
    reducers: {
        setRoomList (state, param) {
            let { payload  } = param;
            var ref, ref1, ref2, ref3;
            var ref4;
            state.roomList = (ref4 = (ref = payload.shopTheRoomData) === null || ref === void 0 ? void 0 : ref.data) !== null && ref4 !== void 0 ? ref4 : [];
            var ref5;
            state.facets = (ref5 = (ref1 = payload.shopTheRoomData) === null || ref1 === void 0 ? void 0 : ref1.facets) !== null && ref5 !== void 0 ? ref5 : {};
            var ref6;
            state.facetLabels = (ref6 = (ref2 = payload.shopTheRoomData) === null || ref2 === void 0 ? void 0 : ref2.facetLabels) !== null && ref6 !== void 0 ? ref6 : {};
            var ref7;
            state.fusion = (ref7 = payload === null || payload === void 0 ? void 0 : (ref3 = payload.shopTheRoomData) === null || ref3 === void 0 ? void 0 : ref3.fusion) !== null && ref7 !== void 0 ? ref7 : {};
            state.status = laodingStatus.success;
        }
    },
    extraReducers (builder) {
        builder.addCase([
            next_redux_wrapper__WEBPACK_IMPORTED_MODULE_2__/* .HYDRATE */ .ju
        ], (state, action)=>{
            return {
                ...state,
                ...action.payload
            };
        }).addCase(getFilterShopRoomList.fulfilled, (state, param)=>{
            let { payload  } = param;
            var _data;
            state.roomList = (_data = payload.data) !== null && _data !== void 0 ? _data : state.roomList;
            var ref;
            state.facets = (ref = payload === null || payload === void 0 ? void 0 : payload.facets) !== null && ref !== void 0 ? ref : state.facets;
            var ref1;
            state.facetLabels = (ref1 = payload === null || payload === void 0 ? void 0 : payload.facetLabels) !== null && ref1 !== void 0 ? ref1 : state.facets;
            var ref2;
            state.fusion = (ref2 = payload === null || payload === void 0 ? void 0 : payload.fusion) !== null && ref2 !== void 0 ? ref2 : state.fusion;
            state.status = laodingStatus.success;
        }).addCase(getFilterShopRoomList.pending, (state)=>{
            state.status = laodingStatus.loading;
        }).addCase(getFilterShopRoomList.rejected, (state)=>{
            state.status = laodingStatus.rejected;
        });
    }
});
const clientShopRoomListFl = [
    "templateName_s",
    "landingFileReference_s",
    "cq_shoptheroomtags_s",
    "productSkuIds_s",
    "modelFileReference_s",
    "cardHoverTitle_s",
    "title_s",
    "cardTitle_s",
    "url_s",
    "strTheme_ss",
    "strColor_ss",
    "strRoom_s",
    "strDesignStyle_s"
];
const getFilterShopRoomList = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createAsyncThunk */ .hg)("shopTheRoomList/getfilterList", async (payLoad)=>{
    const { sort =null , fq =[] , profilename ="Shop_The_Room"  } = payLoad;
    const fl = [
        ...clientShopRoomListFl
    ];
    const params = {
        fl: fl.join(),
        collection: "kohler",
        profilename,
        rows: 30,
        ...fq.length ? {
            fq
        } : {},
        ...sort ? {
            sort
        } : {}
    };
    const response = await _constants_api__WEBPACK_IMPORTED_MODULE_0__/* .apim.get */ .TH.get(_constants_index__WEBPACK_IMPORTED_MODULE_1__.PLP_END_POINT_CLIENT, {
        params,
        paramsSerializer: (params)=>{
            return qs__WEBPACK_IMPORTED_MODULE_5___default().stringify(params, {
                arrayFormat: "repeat",
                encode: false
            });
        }
    });
    const data = await (0,_utils_product__WEBPACK_IMPORTED_MODULE_3__/* .formatListingData */ .nx)(response.data);
    return data;
});
const { setRoomList  } = shopTheRoomSlice.actions;
const shopTheRoomState = (state)=>state.shopTheRoomState;
/* harmony default export */ __webpack_exports__["ZP"] = (shopTheRoomSlice.reducer);


/***/ }),

/***/ 88032:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h": function() { return /* binding */ store; },
  "YS": function() { return /* binding */ wrapper; }
});

// UNUSED EXPORTS: makeStore

// EXTERNAL MODULE: ./node_modules/redux/es/redux.js + 1 modules
var redux = __webpack_require__(45217);
// EXTERNAL MODULE: ./node_modules/@reduxjs/toolkit/dist/redux-toolkit.esm.js + 2 modules
var redux_toolkit_esm = __webpack_require__(77236);
// EXTERNAL MODULE: ./node_modules/next-redux-wrapper/es6/index.js
var es6 = __webpack_require__(28858);
// EXTERNAL MODULE: ./node_modules/redux-persist/lib/storage/createWebStorage.js
var createWebStorage = __webpack_require__(23488);
;// CONCATENATED MODULE: ./store/syncStorage.js

const createNoopStorage = ()=>{
    return {
        getItem (_key) {
            return Promise.resolve(null);
        },
        setItem (_key, value) {
            return Promise.resolve(value);
        },
        removeItem (_key) {
            return Promise.resolve();
        }
    };
};
const storage =  true ? (0,createWebStorage/* default */.Z)("local") : 0;
/* harmony default export */ var syncStorage = (storage);

// EXTERNAL MODULE: ./node_modules/redux-persist/es/index.js + 11 modules
var es = __webpack_require__(97568);
// EXTERNAL MODULE: ./store/features/authSlice.js
var authSlice = __webpack_require__(24899);
// EXTERNAL MODULE: ./store/features/cartSlice.js
var cartSlice = __webpack_require__(46201);
// EXTERNAL MODULE: ./store/features/locationSlice.js
var locationSlice = __webpack_require__(56608);
// EXTERNAL MODULE: ./store/features/genericSlice.js
var genericSlice = __webpack_require__(88751);
// EXTERNAL MODULE: ./store/features/checkoutSlice.js
var checkoutSlice = __webpack_require__(60475);
// EXTERNAL MODULE: ./store/features/productListSlice.js
var productListSlice = __webpack_require__(49682);
// EXTERNAL MODULE: ./store/features/orderSlice.js
var orderSlice = __webpack_require__(76977);
// EXTERNAL MODULE: ./store/features/favoritesSlice.js + 1 modules
var favoritesSlice = __webpack_require__(7737);
// EXTERNAL MODULE: ./store/features/compareSlice.js
var compareSlice = __webpack_require__(39915);
// EXTERNAL MODULE: ./node_modules/redux-persist-transform-filter/dist/index.js
var dist = __webpack_require__(38551);
// EXTERNAL MODULE: ./node_modules/redux-persist/lib/stateReconciler/autoMergeLevel2.js
var autoMergeLevel2 = __webpack_require__(1190);
// EXTERNAL MODULE: ./store/features/searchSlice.js
var searchSlice = __webpack_require__(57879);
// EXTERNAL MODULE: ./store/features/pdpSlice.js
var pdpSlice = __webpack_require__(44561);
// EXTERNAL MODULE: ./store/features/myProductSlice.js
var myProductSlice = __webpack_require__(3507);
;// CONCATENATED MODULE: ./store/features/inspirationSlice.js

const initialState = {
    inspirations: {
        selectedInspiration: {},
        loading: true,
        fq: [],
        data: [],
        total: 0,
        facets: [],
        start: 0,
        colors: {},
        grouped: false
    }
};
const getInspirationDetails = (0,redux_toolkit_esm/* createAsyncThunk */.hg)("inspirations/getInspirationDetails", async ()=>{
// Placeholder Inspiration slice So That It Can Be Overridden For AnnSacks Inspiration Page.
});
const inspirationSlice = (0,redux_toolkit_esm/* createSlice */.oM)({
    name: "inspirations",
    initialState,
    reducers: {},
    extraReducers: ()=>{
    // Placeholder Inspiration slice So That It Can Be Overridden For AnnSacks Inspiration Page.
    }
});
/* harmony default export */ var features_inspirationSlice = (inspirationSlice.reducer);

// EXTERNAL MODULE: ./store/features/shopTheRoomSlice.js
var shopTheRoomSlice = __webpack_require__(53882);
;// CONCATENATED MODULE: ./store/features/asPlpSlice.js

const asPlpSlice_initialState = {
    plp: {
        loaded: false,
        loading: true,
        fq: [],
        data: [],
        total: 0,
        facets: [],
        facetLabels: [],
        start: 0,
        colors: {},
        grouped: false
    }
};
const getProducts = (0,redux_toolkit_esm/* createAsyncThunk */.hg)("asPlp/getProducts", async ()=>{
// Placeholder PLP slice so that it can be overridden for AnnSacks PLP Page.
});
const asPlpSlice = (0,redux_toolkit_esm/* createSlice */.oM)({
    name: "asPlp",
    initialState: asPlpSlice_initialState,
    reducers: {},
    extraReducers: ()=>{
    // Placeholder PLP slice so that it can be overridden for AnnSacks PLP Page.
    }
});
const { startLoading , stopLoading  } = asPlpSlice.actions;
const selectPlpState = (state)=>state.asPlp;
/* harmony default export */ var features_asPlpSlice = (asPlpSlice.reducer);

;// CONCATENATED MODULE: ./store/features/asPdpSlice.js

const asPdpSlice_initialState = {
    asProductDetails: {
        sku: "",
        slug: "",
        variants: [],
        recommendedAccessories: [],
        productBrand: "",
        data: {}
    }
};
const asPdpSlice = (0,redux_toolkit_esm/* createSlice */.oM)({
    name: "asPdp",
    initialState: asPdpSlice_initialState,
    reducers: {},
    extraReducers: ()=>{
    // Placeholder PLP slice so that it can be overridden for AnnSacks PLP Page.
    }
});
const { setAsProductDetails  } = asPdpSlice.actions;
const selectPdpState = (state)=>state.asPdp;
/* harmony default export */ var features_asPdpSlice = (asPdpSlice.reducer);

// EXTERNAL MODULE: ./store/features/accordionSlice.js
var accordionSlice = __webpack_require__(93014);
// EXTERNAL MODULE: ./store/features/invalidSelectionSlice.js
var invalidSelectionSlice = __webpack_require__(49265);
;// CONCATENATED MODULE: ./store/index.js
























const combinedReducer = (0,redux/* combineReducers */.UY)({
    [authSlice/* authSlice.name */.Gb.name]: authSlice/* authSlice.reducer */.Gb.reducer,
    [cartSlice/* cartSlice.name */.Ao.name]: cartSlice/* cartSlice.reducer */.Ao.reducer,
    [locationSlice/* locationSlice.name */.vM.name]: locationSlice/* locationSlice.reducer */.vM.reducer,
    [genericSlice/* genericSlice.name */.JN.name]: genericSlice/* genericSlice.reducer */.JN.reducer,
    [checkoutSlice/* checkoutSlice.name */.vu.name]: checkoutSlice/* checkoutSlice.reducer */.vu.reducer,
    [productListSlice/* productListSlice.name */.Tx.name]: productListSlice/* productListSlice.reducer */.Tx.reducer,
    [orderSlice/* orderSlice.name */.zM.name]: orderSlice/* orderSlice.reducer */.zM.reducer,
    [favoritesSlice/* favoritesSlice.name */.MY.name]: favoritesSlice/* favoritesSlice.reducer */.MY.reducer,
    [inspirationSlice.name]: inspirationSlice.reducer,
    [compareSlice/* compareSlice.name */.qD.name]: compareSlice/* compareSlice.reducer */.qD.reducer,
    [searchSlice/* searchSlice.name */.iv.name]: searchSlice/* searchSlice.reducer */.iv.reducer,
    [pdpSlice/* pdpSlice.name */.ou.name]: pdpSlice/* pdpSlice.reducer */.ou.reducer,
    [myProductSlice/* myProductSlice.name */.dj.name]: myProductSlice/* myProductSlice.reducer */.dj.reducer,
    [shopTheRoomSlice/* shopTheRoomSlice.name */.LG.name]: shopTheRoomSlice/* default */.ZP,
    [asPlpSlice.name]: asPlpSlice.reducer,
    [asPdpSlice.name]: asPdpSlice.reducer,
    [accordionSlice/* default.name */.ZP.name]: accordionSlice/* default.reducer */.ZP.reducer,
    [invalidSelectionSlice/* default.name */.ZP.name]: invalidSelectionSlice/* default.reducer */.ZP.reducer
});
let store;
const makeStore = ()=>{
    const isServer = "object" === "undefined";
    if (isServer) {
        // If it's on server side, create a store
        return (0,redux_toolkit_esm/* configureStore */.xC)({
            reducer: combinedReducer,
            middleware: (getDefaultMiddleware)=>getDefaultMiddleware({
                    serializableCheck: {
                        ignoredActions: [
                            es.FLUSH,
                            es.REHYDRATE,
                            es.PAUSE,
                            es.PERSIST,
                            es.PURGE,
                            es.REGISTER
                        ]
                    }
                })
        });
    } else {
        // If it's on client side, create a store which will persist
        const authSubsetFilter = (0,dist/* default */.ZP)("auth", [
            "anonymousId",
            "access_token",
            "refresh_token",
            "expires_in",
            "revalidate_in",
            "hashedEmail",
            "customerProspect"
        ]);
        const persistConfig = {
            key: "root",
            whitelist: [
                "auth",
                "location",
                "compare"
            ],
            transforms: [
                authSubsetFilter
            ],
            storage: syncStorage,
            stateReconciler: autoMergeLevel2/* default */.Z
        };
        const persistedReducer = (0,es.persistReducer)(persistConfig, combinedReducer);
        store = (0,redux_toolkit_esm/* configureStore */.xC)({
            reducer: persistedReducer,
            middleware: (getDefaultMiddleware)=>getDefaultMiddleware({
                    serializableCheck: {
                        ignoredActions: [
                            es.FLUSH,
                            es.REHYDRATE,
                            es.PAUSE,
                            es.PERSIST,
                            es.PURGE,
                            es.REGISTER
                        ]
                    }
                })
        });
        store.__persistor = (0,es.persistStore)(store);
        return store;
    }
};

const wrapper = (0,es6/* createWrapper */.KV)(makeStore);


/***/ }),

/***/ 51666:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Lp": function() { return /* binding */ getMaxVersionLists; },
/* harmony export */   "MQ": function() { return /* binding */ getSessionId; },
/* harmony export */   "ZV": function() { return /* binding */ getUserListLineItems; },
/* harmony export */   "_z": function() { return /* binding */ getMultiDeleteItemsPayLoad; },
/* harmony export */   "mK": function() { return /* binding */ getMovieToListAndDeleteFormListItems; },
/* harmony export */   "oq": function() { return /* binding */ getSessionIdObjWithEpoc; },
/* harmony export */   "xE": function() { return /* binding */ getTntId; }
/* harmony export */ });
const getSessionIdObjWithEpoc = ()=>{
    var ref;
    const cookies = (ref = document.cookie.split(";")) !== null && ref !== void 0 ? ref : [];
    var ref1;
    let sessionCookie = (ref1 = cookies.find((myCookie)=>myCookie.includes("session#"))) !== null && ref1 !== void 0 ? ref1 : "";
    var ref2;
    sessionCookie = (ref2 = sessionCookie.split("|").find((item)=>item.includes("session"))) !== null && ref2 !== void 0 ? ref2 : "";
    var ref3;
    const sessionCookies = (ref3 = sessionCookie.split("#")) !== null && ref3 !== void 0 ? ref3 : [];
    var ref4;
    const sessionId = (ref4 = sessionCookies[1]) !== null && ref4 !== void 0 ? ref4 : "";
    return sessionId ? "".concat(sessionId, "-").concat(Date.now()) : "";
};
const getSessionId = ()=>{
    var ref;
    const cookies = (ref = document.cookie.split(";")) !== null && ref !== void 0 ? ref : [];
    var ref1;
    let sessionCookie = (ref1 = cookies.find((myCookie)=>myCookie.includes("session#"))) !== null && ref1 !== void 0 ? ref1 : "";
    var ref2;
    sessionCookie = (ref2 = sessionCookie.split("|").find((item)=>item.includes("session"))) !== null && ref2 !== void 0 ? ref2 : "";
    var ref3;
    const sessionCookies = (ref3 = sessionCookie.split("#")) !== null && ref3 !== void 0 ? ref3 : [];
    var ref4;
    return (ref4 = sessionCookies[1]) !== null && ref4 !== void 0 ? ref4 : "";
};
const getTntId = ()=>{
    var ref;
    const cookies = (ref = document.cookie.split(";")) !== null && ref !== void 0 ? ref : [];
    var ref1;
    let tntCookie = decodeURIComponent((ref1 = cookies.find((myCookie)=>myCookie.includes("AMCV_"))) !== null && ref1 !== void 0 ? ref1 : "");
    var ref2;
    tntCookie = (ref2 = tntCookie.split("|")) !== null && ref2 !== void 0 ? ref2 : "";
    var ref3;
    return (ref3 = tntCookie[4]) !== null && ref3 !== void 0 ? ref3 : "";
};
const getUserListLineItems = (results)=>{
    const listItems = {};
    const listItemsSkus = {};
    results.forEach((list)=>{
        list === null || list === void 0 ? void 0 : list.lineItems.forEach((lineItem)=>{
            var ref;
            listItems[lineItem === null || lineItem === void 0 ? void 0 : lineItem.productId] = {
                ...lineItem,
                listName: list === null || list === void 0 ? void 0 : list.name,
                listId: list === null || list === void 0 ? void 0 : list.id,
                listVersion: list === null || list === void 0 ? void 0 : list.version
            };
            listItemsSkus[lineItem === null || lineItem === void 0 ? void 0 : (ref = lineItem.variant) === null || ref === void 0 ? void 0 : ref.sku] = {
                ...lineItem,
                listName: list === null || list === void 0 ? void 0 : list.name,
                listId: list === null || list === void 0 ? void 0 : list.id,
                listVersion: list === null || list === void 0 ? void 0 : list.version
            };
        });
    });
    return [
        listItems,
        listItemsSkus
    ];
};
const getMaxVersionOfList = (listName, lists, locale)=>{
    const versions = [];
    lists.forEach((list)=>{
        if ((list === null || list === void 0 ? void 0 : list.name[locale]) === listName) {
            versions.push(list === null || list === void 0 ? void 0 : list.version);
        }
    });
    return Math.max(...versions);
};
const removeSystemDefinedLists = (userList)=>{
    const systemDefinedListNames = [
        "MyProducts",
        "MyServices",
        "MesServices",
        "Mes produits"
    ];
    return userList.filter((list)=>!systemDefinedListNames.includes(list));
};
const getMaxVersionLists = (result, locale)=>{
    const listNames = [];
    const finalLists = [];
    result.forEach((list)=>{
        listNames.push(list === null || list === void 0 ? void 0 : list.name[locale]);
    });
    const uniqueListNames = removeSystemDefinedLists([
        ...new Set(listNames)
    ]);
    uniqueListNames.forEach((listName)=>{
        const maxVersion = getMaxVersionOfList(listName, result, locale);
        result.forEach((list)=>{
            if (listName && (list === null || list === void 0 ? void 0 : list.name[locale]) === listName && (list === null || list === void 0 ? void 0 : list.version) === maxVersion) {
                finalLists.push(list);
            }
        });
    });
    return finalLists;
};
const getMultiDeleteItemsPayLoad = (list, selectedItems)=>{
    const deletePayLoad = [];
    selectedItems.forEach((productSku)=>{
        list.lineItems.forEach((lineItem)=>{
            var ref;
            if ((lineItem === null || lineItem === void 0 ? void 0 : (ref = lineItem.variant) === null || ref === void 0 ? void 0 : ref.sku) === productSku) {
                deletePayLoad.push({
                    action: "removeLineItem",
                    lineItemId: lineItem.id
                });
            }
        });
    });
    return deletePayLoad;
};
const getMovieToListAndDeleteFormListItems = (selectedItems, currentList, productData, productQtyObj)=>{
    const deleteItemsList = [];
    const addItemsList = [];
    selectedItems.forEach((productSku)=>{
        currentList.lineItems.forEach((lineItem)=>{
            var ref;
            if ((lineItem === null || lineItem === void 0 ? void 0 : (ref = lineItem.variant) === null || ref === void 0 ? void 0 : ref.sku) === productSku) {
                deleteItemsList.push({
                    action: "removeLineItem",
                    lineItemId: lineItem.id
                });
                addItemsList.push({
                    action: "addLineItem",
                    sku: productSku,
                    quantity: productQtyObj[productSku],
                    custom: {
                        type: {
                            key: "lineItemShoppingList",
                            typeId: "type"
                        }
                    }
                });
            }
        });
    });
    return [
        deleteItemsList,
        addItemsList
    ];
};


/***/ }),

/***/ 75227:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$u": function() { return /* binding */ DynamicShopTheRoomList; },
/* harmony export */   "bA": function() { return /* binding */ DynamicStickyNavHeader; },
/* harmony export */   "kO": function() { return /* binding */ DynamicShopTheRoomCard; },
/* harmony export */   "xE": function() { return /* binding */ DynamicFilter; }
/* harmony export */ });
/* unused harmony export DynamicBreadcrumb */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);



const DummyComponent = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {});
const ComponentContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.createContext)([
    {
        Component: DummyComponent,
        componentProps: {}
    }
]);
const DynamicShopTheRoomList = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>Promise.all(/* import() */[__webpack_require__.e(1976), __webpack_require__.e(4417), __webpack_require__.e(6598)]).then(__webpack_require__.bind(__webpack_require__, 6598)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(6598)
            ]
    }
});
const DynamicFilter = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>Promise.all(/* import() */[__webpack_require__.e(361), __webpack_require__.e(772)]).then(__webpack_require__.bind(__webpack_require__, 50772)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(50772)
            ]
    }
});
const DynamicBreadcrumb = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>__webpack_require__.e(/* import() */ 3282).then(__webpack_require__.bind(__webpack_require__, 3282)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(3282)
            ]
    }
});
const DynamicShopTheRoomCard = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 75781)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(75781)
            ]
    }
});
const DynamicStickyNavHeader = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>__webpack_require__.e(/* import() */ 4751).then(__webpack_require__.bind(__webpack_require__, 24751)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(24751)
            ]
    }
});
/* harmony default export */ __webpack_exports__["ZP"] = (ComponentContext);


/***/ }),

/***/ 27522:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ addToCartItem; }
/* harmony export */ });
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19514);
/**
 * It add to cart Utility for pay load
 * @returns the addToCartItem
 */ 
const addToCartItem = async (items)=>{
    var ref;
    let userZipCode;
    const CONFIG = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_0__/* .getConfig */ .i)();
    var ref1;
    const salesChannels = (ref1 = CONFIG === null || CONFIG === void 0 ? void 0 : (ref = CONFIG.salesChannelConfig) === null || ref === void 0 ? void 0 : ref.map) !== null && ref1 !== void 0 ? ref1 : {};
    const actionPayload = actionProduct(items, salesChannels, userZipCode);
    return actionPayload;
};
/**
 *  payload to add to cart.
 * @param {items} items The first param.
 * @param {salesChannels} salesChannels The second param.
 * @param {userZipCode} userZipCode The third param.
 * @return {object} the pay load for add to cart
 */ const actionProduct = (items, salesChannels, userZipCode)=>{
    const actions = [];
    let actionData;
    items.forEach((product)=>{
        const { lineItemId , isBundle =false , isBundleProduct =false , isBundleParent =false , sku ="" , quantity =0 , additionalInfo , brand =""  } = product;
        const { roomInfo ="" , customQuantity =0 , overage =""  } = additionalInfo !== null && additionalInfo !== void 0 ? additionalInfo : {};
        var _brand;
        const fields = {
            salesChannel: (_brand = salesChannels[product.brand]) !== null && _brand !== void 0 ? _brand : "KOUS"
        };
        if (product.backorder) fields.isBackOrderable = true;
        const bundlePayload = {
            action: "changeBundleItemQuantity",
            customLineItemId: lineItemId,
            sku,
            quantity
        };
        const payload = {
            action: isBundleProduct ? "addBundleItem" : isBundle ? "addbundle" : "addLineItem",
            sku,
            quantity,
            custom: additionalInfo ? {
                type: {
                    key: "lineItemShipping"
                },
                fields: {
                    salesChannel: salesChannels[brand],
                    roomInfo,
                    customQuantity,
                    overage
                }
            } : {
                type: {
                    key: "lineItemShipping"
                },
                fields: fields
            }
        };
        actions.push(isBundleParent ? bundlePayload : payload);
        userZipCode = product === null || product === void 0 ? void 0 : product.userZipCode;
        actionData = [
            ...actions
        ];
    });
    return actionData;
};


/***/ }),

/***/ 11763:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EI": function() { return /* binding */ deleteFromCart; },
/* harmony export */   "K5": function() { return /* binding */ getStock; },
/* harmony export */   "NS": function() { return /* binding */ setCartLandingPagePath; },
/* harmony export */   "PW": function() { return /* binding */ getQuantityCount; },
/* harmony export */   "Uo": function() { return /* binding */ getCartIdParams; },
/* harmony export */   "VN": function() { return /* binding */ setCustomerCartId; },
/* harmony export */   "Xw": function() { return /* binding */ getAriaLabel; },
/* harmony export */   "c0": function() { return /* binding */ getCartCount; },
/* harmony export */   "dZ": function() { return /* binding */ getCartLandingPagePath; },
/* harmony export */   "w$": function() { return /* binding */ removeCustomerCartId; }
/* harmony export */ });
/* unused harmony exports getCustomerCartId, getCartPagePath */
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73350);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96301);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88032);
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19514);
/* harmony import */ var _utils_location__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(97433);
/* harmony import */ var _store_features_cartSlice__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(46201);







const getStock = async function(sku) {
    let returnObj = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    let stock = 0;
    let responseObj = {};
    const response = await _constants_api__WEBPACK_IMPORTED_MODULE_1__/* .apim.get */ .TH.get("".concat(_constants_index__WEBPACK_IMPORTED_MODULE_2__.getStockEndPoint, "/?sku=").concat(sku));
    if (response && response.data && response.data.results && response.data.results[0]) {
        var _availableQuantity;
        stock = (_availableQuantity = response.data.results[0].availableQuantity) !== null && _availableQuantity !== void 0 ? _availableQuantity : 0;
        responseObj = response.data.results[0];
    }
    if (returnObj) return responseObj;
    return stock;
};
const getQuantityCount = (data)=>{
    if (!(data && data.length)) return 0;
    const totalCount = data && data.filter((item)=>{
        var ref, ref1;
        return !((ref = item.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.bundleParentId);
    }).reduce((accumulator, item)=>{
        return accumulator + item.quantity;
    }, 0);
    return totalCount;
};
const getCartCount = ()=>{
    var ref;
    var ref1;
    const { cartCount  } = (ref1 = (ref = _store__WEBPACK_IMPORTED_MODULE_3__/* .store */ .h === null || _store__WEBPACK_IMPORTED_MODULE_3__/* .store */ .h === void 0 ? void 0 : _store__WEBPACK_IMPORTED_MODULE_3__/* .store.getState */ .h.getState()) === null || ref === void 0 ? void 0 : ref.cart) !== null && ref1 !== void 0 ? ref1 : 0;
    return cartCount;
};
const getAriaLabel = (t, cartCount)=>{
    const ariaLabel = cartCount > 1 ? t("kf.minicart.aria.label.cartItems", {
        count: cartCount
    }) : t("kf.minicart.aria.label.cartItem", {
        count: cartCount
    });
    return ariaLabel;
};
const setCartLandingPagePath = async ()=>{
    const config = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_4__/* .getConfig */ .i)();
    const cartLandingUrl = await (0,_utils_location__WEBPACK_IMPORTED_MODULE_5__/* .getShortenedUrl */ .Pp)(lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(config, "general.cartLandingPagePath", "/"));
    _store__WEBPACK_IMPORTED_MODULE_3__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_6__/* .setCartUrl */ .xA)(cartLandingUrl));
};
const getCartLandingPagePath = async ()=>{
    const config = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_4__/* .getConfig */ .i)();
    const cartLandingUrl = await (0,_utils_location__WEBPACK_IMPORTED_MODULE_5__/* .getShortenedUrl */ .Pp)(lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(config, "general.cartLandingPagePath", "/"));
    return cartLandingUrl;
};
const getCartPagePath = ()=>{
    let path = "/";
    path = getCartLandingPagePath().then((res)=>{
        return res;
    });
    return path;
};
const getCustomerCartId = ()=>{
    return localStorage.getItem("customerCartId");
};
const setCustomerCartId = (item)=>{
    localStorage.setItem("customerCartId", item);
};
const removeCustomerCartId = ()=>{
    localStorage.removeItem("customerCartId");
};
const getCartIdParams = (isSubmit)=>{
    const { auth: { user: { koc: isIscUser  } = {}  } = {} , cart: { cart: { id =""  } = {}  } = {}  } = _store__WEBPACK_IMPORTED_MODULE_3__/* .store.getState */ .h.getState();
    const customerCartId = getCustomerCartId();
    const cartId = isIscUser && customerCartId ? "&cartId=".concat(customerCartId) : "";
    const cartIdQuery = isIscUser && customerCartId ? "?cartId=".concat(customerCartId) : isSubmit ? "?cartId=".concat(id) : "";
    const activeCartId = isIscUser && customerCartId ? customerCartId : id;
    return {
        cartId,
        cartIdQuery,
        activeCartId
    };
};
const deleteFromCart = async (cb)=>{
    await _store__WEBPACK_IMPORTED_MODULE_3__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_6__/* .deleteCart */ .al)()).unwrap().then((res)=>{
        if (res) {
            cb && cb("success", null, res ? res : {});
            _store__WEBPACK_IMPORTED_MODULE_3__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_6__/* .setCart */ .RV)({
                lineItems: []
            }));
            _store__WEBPACK_IMPORTED_MODULE_3__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_6__/* .setNoshipping */ .qT)([]));
            _store__WEBPACK_IMPORTED_MODULE_3__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_6__/* .setCartCount */ .oJ)(0));
            _store__WEBPACK_IMPORTED_MODULE_3__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_6__/* .setShipping */ .YO)([]));
            const cartPayload = {
                currency: "USD",
                taxMode: "ExternalAmount"
            };
            _store__WEBPACK_IMPORTED_MODULE_3__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_6__/* .createCart */ .Bk)(cartPayload));
        }
    }).catch(()=>{
        cb && cb("failure", "failed to empty your cart.");
    });
};



/***/ }),

/***/ 55760:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "i6z": function() { return /* binding */ addADALink; },
  "dVG": function() { return /* binding */ addMavenoidChat; },
  "iZV": function() { return /* binding */ addMediaToFavorites; },
  "igK": function() { return /* binding */ addPageLoadAnalyticsEvent; },
  "R$3": function() { return /* binding */ addToRecentSearch; },
  "gP3": function() { return /* binding */ addToRecentlyViewed; },
  "QCk": function() { return /* binding */ appendPresetToUrl; },
  "RpN": function() { return /* binding */ arrayMove; },
  "s80": function() { return /* binding */ caesarDecrypt; },
  "DpP": function() { return /* binding */ calculateCartData; },
  "MyB": function() { return /* binding */ capitalizeFirstName; },
  "pJD": function() { return /* binding */ checkAlphabetOnly; },
  "ytv": function() { return /* binding */ checkAlphanumeric; },
  "KzD": function() { return /* binding */ checkCartStock; },
  "Oh7": function() { return /* binding */ checkIfImageExists; },
  "yNA": function() { return /* binding */ checkIfUserExists; },
  "GsT": function() { return /* binding */ checkIsFavorite; },
  "yyd": function() { return /* binding */ checkStock; },
  "FV": function() { return /* binding */ cleanText; },
  "loo": function() { return /* binding */ clearAnonymousToken; },
  "RnQ": function() { return /* binding */ clearAuthToken; },
  "u8D": function() { return /* binding */ closeModalAnalytics; },
  "xn0": function() { return /* binding */ closePreview; },
  "mUs": function() { return /* binding */ convertStringToBoolean; },
  "ZT_": function() { return /* binding */ createIdFromString; },
  "g45": function() { return /* binding */ createPersonaCookie; },
  "pMF": function() { return /* binding */ customSanitizeInnerHtml; },
  "DsO": function() { return /* binding */ debounce; },
  "qOB": function() { return /* binding */ decodeHtmlCharacters; },
  "LY3": function() { return /* binding */ destructureAddress; },
  "vIr": function() { return /* binding */ downloadArticle; },
  "Uni": function() { return /* binding */ extractPhoneNumber; },
  "CZn": function() { return /* binding */ extractScriptsFromDOM; },
  "LjD": function() { return /* binding */ filterBackEndJson; },
  "p6d": function() { return /* binding */ formatDate; },
  "n4H": function() { return /* binding */ formatFacetName; },
  "fSM": function() { return /* binding */ formatOfflineRegisterPropsData; },
  "Oyq": function() { return /* binding */ formatOnlineRegisterPropsData; },
  "unW": function() { return /* binding */ formatPhoneNumber; },
  "NO1": function() { return /* binding */ formatPriceRange; },
  "V08": function() { return /* binding */ formatRegistrationSuveryPropsData; },
  "NpZ": function() { return /* binding */ geMonthNameDayandYear; },
  "Bq_": function() { return /* binding */ getAEMPreviewModeCookie; },
  "hPi": function() { return /* binding */ getAccessToken; },
  "ud4": function() { return /* binding */ getAllFilterQueries; },
  "Szq": function() { return /* binding */ getAnalyticsScript; },
  "Uho": function() { return /* binding */ getAnalyticsUrl; },
  "yQL": function() { return /* binding */ getAnonymousId; },
  "fnA": function() { return /* binding */ getAppliedSortPressKit; },
  "kDl": function() { return /* binding */ getAttributeValue; },
  "A_z": function() { return /* binding */ getAuthShortenedUrl; },
  "FcF": function() { return /* binding */ getBadgeValue; },
  "Nth": function() { return /* binding */ getCartItemType; },
  "Cx9": function() { return /* binding */ getCartItemsAnalyticsData; },
  "vzx": function() { return /* binding */ getCityList; },
  "p2C": function() { return /* binding */ getCompareData; },
  "soW": function() { return /* binding */ getCountryCode; },
  "zC$": function() { return /* binding */ getCurrency; },
  "mPk": function() { return /* binding */ getCurrentSkuCouponDiscounts; },
  "C2G": function() { return /* binding */ getDataLayerObj; },
  "Dgj": function() { return /* binding */ getDefaultProfileAddress; },
  "bZU": function() { return /* binding */ getFacetsFromUrl; },
  "MqV": function() { return /* binding */ getFavouraties; },
  "dhb": function() { return /* binding */ getInternalLinkTypeForFindStore; },
  "Cxt": function() { return /* binding */ getIsNameDuplicate; },
  "Qss": function() { return /* binding */ getIsSystemDefinedName; },
  "pDj": function() { return /* binding */ getLangCode; },
  "OWN": function() { return /* binding */ getLinkFromHref; },
  "ngN": function() { return /* binding */ getLocationByCookies; },
  "fPm": function() { return /* binding */ getMyLocation; },
  "SAL": function() { return /* binding */ getMyLocationByUserIP; },
  "oJS": function() { return /* binding */ getOffsetTop; },
  "ir5": function() { return /* binding */ getPDPUrl; },
  "Aut": function() { return /* binding */ getPDPUrlForProductTile; },
  "Upy": function() { return /* binding */ getPDPUrlWithConfig; },
  "UMn": function() { return /* binding */ getPageInfo; },
  "ptY": function() { return /* binding */ getPageLevelScriptsAndStyles; },
  "LjC": function() { return /* binding */ getParamFromUrl; },
  "VzW": function() { return /* binding */ getPasswordRegExp; },
  "ssk": function() { return /* binding */ getPdpUrlParams; },
  "VvO": function() { return /* binding */ getPdpUrlPath; },
  "v$f": function() { return /* binding */ getPresetUrl; },
  "YHw": function() { return /* binding */ getPriceSortQuery; },
  "N2S": function() { return /* binding */ getProcessedProductInfoBasedOnLineItems; },
  "Ezx": function() { return /* binding */ getProductFlgs; },
  "Gai": function() { return /* binding */ getProductImageUrl; },
  "AEk": function() { return /* binding */ getProductStatus; },
  "OM7": function() { return /* binding */ getPureText; },
  "sKe": function() { return /* binding */ getQuickViewAuth; },
  "sZz": function() { return /* binding */ getRandom; },
  "csL": function() { return /* binding */ getScriptsAndStyles; },
  "g1g": function() { return /* binding */ getSearchDataLayerDetails; },
  "a4K": function() { return /* binding */ getSelectedSort; },
  "oH8": function() { return /* binding */ getShippingDiscountPromoCodes; },
  "Ppy": function() { return /* binding */ getShortenedUrl; },
  "mXk": function() { return /* binding */ getShortenedUrlPath; },
  "vu1": function() { return /* binding */ getShortenedUrlwithGeneral; },
  "Ure": function() { return /* binding */ getSiteWideModal; },
  "aN0": function() { return /* binding */ getSortFromUrl; },
  "KE": function() { return /* binding */ getSortItemBasedOnURL; },
  "jeb": function() { return /* binding */ getStateCode; },
  "m3S": function() { return /* binding */ getSwatchCount; },
  "jGm": function() { return /* binding */ getUpSellAuthData; },
  "L7i": function() { return /* binding */ getUserAnalyticsObject; },
  "$1Y": function() { return /* binding */ getUserCreatedLists; },
  "shu": function() { return /* binding */ getUserPersona; },
  "Bmk": function() { return /* binding */ handleEnter; },
  "Gzb": function() { return /* binding */ handleModelNumberSuggestion; },
  "G12": function() { return /* binding */ handleZipDownload; },
  "Yo6": function() { return /* binding */ hasNumber; },
  "oC7": function() { return /* binding */ hourDifference; },
  "$8e": function() { return /* binding */ isAuthenticated; },
  "guj": function() { return /* binding */ isCanadaSite; },
  "B3G": function() { return /* binding */ isColorFacet; },
  "G_Z": function() { return /* binding */ isElementExcluded; },
  "cLX": function() { return /* binding */ isEmbeddedElement; },
  "fM6": function() { return /* binding */ isEmbeddedStyles; },
  "DVc": function() { return /* binding */ isGuestTokenValid; },
  "YN4": function() { return /* binding */ isPriceZero; },
  "GtH": function() { return /* binding */ isProtectedUrl; },
  "xJ2": function() { return /* binding */ isShowAnalyticsEventLoaded; },
  "l4J": function() { return /* binding */ isUrlIncludeHttp; },
  "ASm": function() { return /* binding */ jsonStringEscape; },
  "S$e": function() { return /* binding */ makingTextDatalayerReady; },
  "oFy": function() { return /* binding */ mapStateToCountryHandler; },
  "UsO": function() { return /* binding */ navigationType; },
  "E9Q": function() { return /* binding */ nbspSanitizeInnerHtml; },
  "U2t": function() { return /* binding */ organizeData; },
  "V4r": function() { return /* binding */ pdpTypeFormat; },
  "MVu": function() { return /* binding */ preventBodyScroll; },
  "aCP": function() { return /* binding */ preventBodyScrollTab; },
  "pHj": function() { return /* binding */ processColorDetails; },
  "idg": function() { return /* binding */ processSwatchData; },
  "zYT": function() { return /* binding */ pushAnalyticsObjToDataLayer; },
  "NxS": function() { return /* binding */ recalculateCartRoomInfo; },
  "xEh": function() { return /* binding */ removeAndCleanLink; },
  "NgF": function() { return /* binding */ removeFavorites; },
  "N9B": function() { return /* binding */ removeMavenoidChat; },
  "FvC": function() { return /* binding */ removeSearchQueryParams; },
  "_Gn": function() { return /* binding */ replaceAndFunction; },
  "CjH": function() { return /* binding */ replaceSearchUrl; },
  "pUm": function() { return /* binding */ resetFilterUrl; },
  "eRK": function() { return /* binding */ resetUrl; },
  "mSA": function() { return /* binding */ retainSearchQueryParams; },
  "uP2": function() { return /* binding */ revalidateTime; },
  "EzU": function() { return /* binding */ sanitizeAndDecodeHtml; },
  "TRt": function() { return /* binding */ sanitizeDOMString; },
  "KD0": function() { return /* binding */ sanitizeInnerHtml; },
  "O0b": function() { return /* binding */ sanitizeObject; },
  "ZUO": function() { return /* binding */ sanitizeProductName; },
  "oOy": function() { return /* binding */ sanitizeText; },
  "pkm": function() { return /* binding */ sanitizeTextArticle; },
  "T68": function() { return /* binding */ sanitizeTextForAnalytics; },
  "Nmg": function() { return /* binding */ sanitizeUrl; },
  "kIi": function() { return /* binding */ scrollToElement; },
  "kWv": function() { return /* binding */ setFocus; },
  "F2_": function() { return /* binding */ setWindowProps; },
  "aLl": function() { return /* binding */ shaEncrypt; },
  "ZTk": function() { return /* binding */ showNewBadge; },
  "ldy": function() { return /* binding */ smoothScroll; },
  "zIK": function() { return /* binding */ sortParameterURL; },
  "TeW": function() { return /* binding */ storeFilterData; },
  "wMR": function() { return /* binding */ toggeleBodyClass; },
  "lj5": function() { return /* binding */ toggeleBodyClassAfterLogin; },
  "wA4": function() { return /* binding */ toggeleBodyScroll; },
  "CQb": function() { return /* binding */ updateAnalyticPageUrl; },
  "OP$": function() { return /* binding */ validateField; },
  "Olw": function() { return /* binding */ validateName; },
  "uo4": function() { return /* binding */ validatePassword; },
  "a$Q": function() { return /* binding */ validatePhone; }
});

// UNUSED EXPORTS: caesarEncrypt, extractStylesFromDOM, formatMultiSelectFacets, generateCanonicalUrl, getAnalyticsFileName, getClienIP, getExactUserPersona, getModelSuggestionSkuListFromData, getParamsFromUrl, getPathFromUrl, getPresetThumbnailUrl, getUser, getUserIP, handleZipcodeSet, hasComponentType, isAuth, isPartsPage, performRedirect, removePathandHtml, updateHeader

// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./node_modules/isomorphic-dompurify/browser.js
var browser = __webpack_require__(29238);
var browser_default = /*#__PURE__*/__webpack_require__.n(browser);
// EXTERNAL MODULE: ./node_modules/html-react-parser/index.mjs
var html_react_parser = __webpack_require__(25935);
// EXTERNAL MODULE: ./node_modules/js-file-download/file-download.js
var file_download = __webpack_require__(35823);
var file_download_default = /*#__PURE__*/__webpack_require__.n(file_download);
// EXTERNAL MODULE: ./node_modules/content-disposition/index.js
var content_disposition = __webpack_require__(67389);
var content_disposition_default = /*#__PURE__*/__webpack_require__.n(content_disposition);
// EXTERNAL MODULE: ./constants/config.js
var constants_config = __webpack_require__(19514);
// EXTERNAL MODULE: ./utils/location.js
var utils_location = __webpack_require__(97433);
// EXTERNAL MODULE: ./utils/index.js
var utils = __webpack_require__(20558);
// EXTERNAL MODULE: ./constants/api.js
var api = __webpack_require__(73350);
// EXTERNAL MODULE: ./constants/index.js
var constants = __webpack_require__(96301);
// EXTERNAL MODULE: ./store/index.js + 4 modules
var store_0 = __webpack_require__(88032);
// EXTERNAL MODULE: ./node_modules/universal-cookie/es6/index.js + 2 modules
var es6 = __webpack_require__(65885);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./store/features/genericSlice.js
var genericSlice = __webpack_require__(88751);
// EXTERNAL MODULE: ./store/features/cartSlice.js
var cartSlice = __webpack_require__(46201);
// EXTERNAL MODULE: ./js/helperV2.js
var helperV2 = __webpack_require__(30696);
// EXTERNAL MODULE: ./store/features/authSlice.js
var authSlice = __webpack_require__(24899);
// EXTERNAL MODULE: ./constants/regex.js
var constants_regex = __webpack_require__(49139);
;// CONCATENATED MODULE: ./public/redirect/redirectmap.json
var redirectmap_namespaceObject = {};
// EXTERNAL MODULE: ./store/features/favoritesSlice.js + 1 modules
var favoritesSlice = __webpack_require__(7737);
// EXTERNAL MODULE: ./public/images/image-missing.png
var image_missing = __webpack_require__(36513);
;// CONCATENATED MODULE: ./utils/helper.js
/* provided dependency */ var Buffer = __webpack_require__(48764)["Buffer"];
/* provided dependency */ var process = __webpack_require__(83454);
























const isServer = "object" === "undefined";
const getMyLocation = ()=>{
    return new Promise((resolve, reject)=>{
        (0,constants_config/* getConfig */.i)().then((CONFIG)=>{
            navigator.geolocation.getCurrentPosition(async (position)=>{
                try {
                    const res = await getCurrentLocationLatLng(position);
                    var _city, _zipcode;
                    resolve({
                        city: (_city = res.city) !== null && _city !== void 0 ? _city : "",
                        zipcode: (_zipcode = res.zipcode) !== null && _zipcode !== void 0 ? _zipcode : ""
                    });
                } catch (e) {
                    const errorCause = {
                        title: get_default()(CONFIG, "general.geoLocationErrorTitle", "").trim(),
                        message: get_default()(CONFIG, "general.geoLocationErrorMessage", "").trim(),
                        ctaLink: get_default()(CONFIG, "general.geoLocationErrorCtaLink", "").trim(),
                        ctaLabel: get_default()(CONFIG, "general.geoLocationErrorCtaLabel", "").trim()
                    };
                    reject(new Error("Location Error", {
                        cause: errorCause
                    }));
                }
            }, (e)=>{
                const errorCause = {
                    title: get_default()(CONFIG, "general.geoLocationErrorTitle", "").trim(),
                    message: get_default()(CONFIG, "general.geoLocationErrorMessage", "").trim(),
                    ctaLink: get_default()(CONFIG, "general.geoLocationErrorCtaLink", "").trim(),
                    ctaLabel: get_default()(CONFIG, "general.geoLocationErrorCtaLabel", "").trim()
                };
                reject(new Error("Location Error", {
                    cause: errorCause
                }));
            });
        });
    });
};
const getMyCity = async (reverseGeo, lat, long)=>{
    const { general  } = await (0,constants_config/* getConfig */.i)();
    var _siteName;
    const siteName = (_siteName = general.siteName) !== null && _siteName !== void 0 ? _siteName : "";
    try {
        const res = await api/* apim.get */.TH.get(reverseGeo, {
            params: {
                $format: "json",
                brand: siteName.toLowerCase(),
                lat: lat,
                long: long
            }
        });
        const response = res.data.resourceSets[0].resources[0].address;
        return {
            city: get_default()(response, "adminDistrict2", ""),
            zipcode: get_default()(response, "postalCode", "")
        };
    } catch (err) {
        // eslint-disable-next-line no-console
        console.error("Fetching City failed", err);
    }
};
const getApiServletPath = async ()=>{
    const CONFIG = await (0,constants_config/* getConfig */.i)();
    const res = CONFIG.apiEndpoints;
    return {
        findStores: get_default()(res, "findStores", ""),
        reverseGeo: get_default()(res, "reverseGeo", ""),
        findStoresBingKey: get_default()(res, "findStoresBingKey", "")
    };
};
const getCurrentLocationLatLng = async (position)=>{
    const getReverseGeo = await getApiServletPath();
    var _reverseGeo;
    const reverseGeoLink = (_reverseGeo = getReverseGeo.reverseGeo) !== null && _reverseGeo !== void 0 ? _reverseGeo : "";
    let getCityData = {};
    try {
        const lat = localStorage.getItem("latitude");
        const lng = localStorage.getItem("longitude");
        const cityData = localStorage.getItem("cityData");
        const locationTimeout = localStorage.getItem("locationTimeout");
        if (parseFloat(lat) === position.coords.latitude && parseFloat(lng) === position.coords.longitude && cityData && locationTimeout && moment_default()().isBefore(moment_default()(locationTimeout))) {
            getCityData = JSON.parse(cityData);
        } else {
            getCityData = await getMyCity(reverseGeoLink, position.coords.latitude, position.coords.longitude);
            const localStorageData = {
                latitude: position.coords.latitude,
                longitude: position.coords.longitude,
                cityData: JSON.stringify(getCityData),
                locationTimeout: moment_default()().add("30", "minutes").toISOString(true)
            };
            setLocalStorageData(localStorageData);
        }
    } catch (err) {
        clearLocalStorageData("latitude", "longitude", "cityData", "locationTimeout");
    }
    return {
        city: get_default()(getCityData, "city", ""),
        zipcode: get_default()(getCityData, "zipcode", "")
    };
};
const clearLocalStorageData = function() {
    for(var _len = arguments.length, keys = new Array(_len), _key = 0; _key < _len; _key++){
        keys[_key] = arguments[_key];
    }
    keys.forEach((key)=>{
        localStorage.removeItem(key);
    });
};
const setLocalStorageData = (localStorageData)=>{
    for (const [key, value] of Object.entries(localStorageData)){
        localStorage.setItem(key, value);
    }
};
const getMyLocationByUserIP = async ()=>{
    const response = await getUserIP();
    var _city, _zipcode;
    return {
        city: (_city = response.city) !== null && _city !== void 0 ? _city : "",
        zipcode: (_zipcode = response.zipcode) !== null && _zipcode !== void 0 ? _zipcode : ""
    };
};
const getUserIP = async ()=>{
    var ref, ref1, ref2, ref3;
    const res = await (0,utils_location/* getLocationUsingIP */.XD)();
    var ref4, ref5;
    return {
        city: (ref4 = res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.C) !== null && ref4 !== void 0 ? ref4 : "",
        zipcode: (ref5 = res === null || res === void 0 ? void 0 : (ref2 = res.data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.data) === null || ref3 === void 0 ? void 0 : ref3.Z) !== null && ref5 !== void 0 ? ref5 : ""
    };
};
const getLocationByCookies = async ()=>{
    var ref;
    const userLocation = ((ref = document.cookie.match("(^|;)\\s*userLocation\\s*=\\s*([^;]+)")) === null || ref === void 0 ? void 0 : ref.pop()) || "";
    let getCityData = {};
    if (userLocation !== "") {
        try {
            const splitLocation = userLocation.split("+");
            const lat = localStorage.getItem("cookiesLatitude");
            const lng = localStorage.getItem("cookiesLongitude");
            const cityData = localStorage.getItem("cookiesCityData");
            const locationTimeout = localStorage.getItem("cookiesLocationTimeout");
            if (parseFloat(lat) === splitLocation[4] && parseFloat(lng) === splitLocation[5] && cityData && locationTimeout && moment_default()().isBefore(moment_default()(locationTimeout))) {
                getCityData = JSON.parse(cityData);
            } else {
                const getReverseGeo = await getApiServletPath();
                var _reverseGeo;
                const reverseGeoLink = (_reverseGeo = getReverseGeo.reverseGeo) !== null && _reverseGeo !== void 0 ? _reverseGeo : "";
                getCityData = await getMyCity(reverseGeoLink, splitLocation[4], splitLocation[5]);
                const localStorageData = {
                    cookiesLatitude: splitLocation[4],
                    cookiesLongitude: splitLocation[5],
                    cookiesCityData: JSON.stringify(getCityData),
                    cookiesLocationTimeout: moment_default()().add("30", "minutes").toISOString(true)
                };
                setLocalStorageData(localStorageData);
            }
        } catch (err) {
            clearLocalStorageData("cookiesLatitude", "cookiesLongitude", "cookiesCityData", "cookiesLocationTimeout");
        }
    }
    return {
        city: get_default()(getCityData, "city", ""),
        zipcode: get_default()(getCityData, "zipcode", "")
    };
};
const sanitizeInnerHtml = function(property) {
    let options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return (0,html_react_parser/* default */.ZP)("".concat(browser_default().sanitize(property, {
        ADD_ATTR: [
            "target"
        ]
    })), options);
};
const customSanitizeInnerHtml = (property)=>(0,html_react_parser/* default */.ZP)("".concat(browser_default().sanitize(property, {
        ADD_ATTR: [
            "target",
            "frameborder",
            "scrolling",
            "allowfullscreen",
            "height",
            "src",
            "width",
            "style",
            "alt",
            "lang",
            "title"
        ],
        ALLOWED_TAGS: [
            "iframe",
            "p",
            "img",
            "a",
            "br",
            "span",
            "ul",
            "ol",
            "li",
            "div",
            "b",
            "h1",
            "h2",
            "h3",
            "h4",
            "h5",
            "h6",
            "strong",
            "button",
            "video",
            "svg",
            "hr"
        ]
    })));
const formatPhoneNumber = (phoneNumberString)=>{
    const cleaned = ("" + phoneNumberString).replace(/\D/g, "");
    const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
        return "(" + match[1] + ") " + match[2] + "-" + match[3];
    }
    return null;
};
const validatePassword = async (password, userData)=>{
    const regexObj = await getPasswordRegExp();
    const regex = new RegExp(regexObj.regex);
    const data = userData.filter((el)=>el.length > 0);
    if (password.length < 10) return false;
    if (!regex.test(password)) return false;
    if (data.some((vl)=>password.toLowerCase().includes(vl.toLowerCase()))) {
        return false;
    }
    if (!constants_regex/* UPPERCASE_REGEX.test */.ab.test(password)) return false;
    return true;
};
const validateField = async (field, value)=>{
    const { regexPattern  } = await (0,constants_config/* getConfig */.i)();
    const pattern = get_default()(regexPattern, "map.".concat(field), "");
    const regex = new RegExp(pattern);
    return !!regex.test(value);
};
const validateName = async (value)=>{
    return constants_regex/* NAME_REGEX.test */.lj.test(value);
};
const addToRecentSearch = (keyword)=>{
    if (keyword && keyword.length > 2) {
        var ref;
        let history1 = (ref = JSON.parse(window.localStorage.getItem("keyWordList"))) !== null && ref !== void 0 ? ref : [];
        history1 = history1.filter((item)=>item.keyWord.toLowerCase() !== keyword.toLowerCase());
        history1.unshift({
            keyWord: keyword,
            id: Date.now()
        });
        window.localStorage.setItem("keyWordList", JSON.stringify(history1));
    }
};
const navigationType = ()=>{
    let result;
    let p;
    if (window.performance.getEntriesByType("navigation")) {
        p = window.performance.getEntriesByType("navigation")[0].type;
        if (p === "navigate") result = 0;
        if (p === "reload") result = 1;
        if (p === "back_forward") result = 2;
        if (p === "prerender") result = 3;
    }
    return result;
};
const getParamFromUrl = function(param) {
    let urlLocation = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    const url = new URL(urlLocation || location.href);
    var ref;
    const appliedSort = (ref = url.searchParams.get(param)) !== null && ref !== void 0 ? ref : "";
    return appliedSort.includes("%2B") ? appliedSort.replaceAll("%2B", "+") : appliedSort.replaceAll(" ", "+");
};
const smoothScroll = (element)=>element.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "nearest"
    });
const getClienIP = (request)=>{
    let ip = "";
    if (!request) return ip;
    if (request.headers["IpAddress"]) {
        ip = request.headers["IpAddress"].split(",")[0];
    } else if (request.headers["true-ip"]) {
        ip = request.headers["true-ip"].split(",")[0];
    } else if (request.headers["x-forwarded-for"]) {
        ip = request.headers["x-forwarded-for"].split(",")[0];
    } else if (request.headers["x-real-ip"]) {
        ip = request.connection.remoteAddress;
    } else {
        ip = request.connection.remoteAddress || "";
    }
    return ip;
};
const isProtectedUrl = async (url)=>{
    const CONFIG = await (0,constants_config/* getConfig */.i)();
    const { commerce: { sessionAuth: { securePagePathList  }  }  } = CONFIG;
    const curUrl = url !== null && url !== void 0 ? url : window.location.pathname;
    return securePagePathList.includes(curUrl);
};
const updateHeader = function(token) {
    let isAuth = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    const authHeader = "Bearer ".concat(token);
    apim.defaults.headers.common["Authorization"] = authHeader;
// if (isAuth) {
//   clearTimeout(refreshTimer)
//   setTimeout(() => {
//     addPageLoadAnalyticsEvent()
//   }, 2000)
//   return
// }
// addPageLoadAnalyticsEvent()
// renewAnonymousTokenBeforeExpiry(token.access_token)
};
// eslint-disable-next-line require-jsdoc
function debounce(func) {
    let timeout = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 300;
    var _this = this;
    let timer;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        clearTimeout(timer);
        timer = setTimeout(()=>{
            // eslint-disable-next-line no-invalid-this
            func.apply(_this, args);
        }, timeout);
    };
}
const shaEncrypt = async (message)=>{
    // encode as UTF-8
    const msgBuffer = new TextEncoder().encode(message);
    // hash the message
    const hashBuffer = await crypto.subtle.digest("SHA-256", msgBuffer);
    // convert ArrayBuffer to Array
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    // convert bytes to hex string
    const hashHex = hashArray.map((b)=>b.toString(16).padStart(2, "0")).join("");
    // return a promise
    return hashHex;
};
const caesarEncrypt = (salt, text)=>{
    const textToChars = (text)=>text.split("").map((c)=>c.charCodeAt(0));
    const byteHex = (n)=>("0" + Number(n).toString(16)).substr(-2);
    const applySaltToChar = (code)=>textToChars(salt).reduce((a, b)=>a ^ b, code);
    return text.split("").map(textToChars).map(applySaltToChar).map(byteHex).join("");
};
const caesarDecrypt = (salt, encoded)=>{
    const textToChars = (text)=>text.split("").map((c)=>c.charCodeAt(0));
    const applySaltToChar = (code)=>textToChars(salt).reduce((a, b)=>a ^ b, code);
    return encoded.match(/.{1,2}/g).map((hex)=>parseInt(hex, 16)).map(applySaltToChar).map((charCode)=>String.fromCharCode(charCode)).join("");
};
const getPasswordRegExp = async ()=>{
    const { regex  } = await (0,constants_config/* getConfig */.i)();
    var _regex, _conditionsList;
    return {
        regex: (_regex = regex.regex) !== null && _regex !== void 0 ? _regex : "",
        passwordMessage: (_conditionsList = regex.conditionsList) !== null && _conditionsList !== void 0 ? _conditionsList : []
    };
};
const getUserAnalyticsObject = function() {
    let data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    const { isFromRegisterUser =false  } = data;
    const hashedEmail = localStorage.getItem("hashedEmail") || ((ref = store_0/* store */.h === null || store_0/* store */.h === void 0 ? void 0 : store_0/* store.getState */.h.getState()) === null || ref === void 0 ? void 0 : (ref1 = ref.auth) === null || ref1 === void 0 ? void 0 : ref1.hashedEmail) || "";
    const customerProspect = localStorage.getItem("customerProspect") || ((ref2 = store_0/* store */.h === null || store_0/* store */.h === void 0 ? void 0 : store_0/* store.getState */.h.getState()) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.auth) === null || ref3 === void 0 ? void 0 : ref3.customerProspect);
    let isCustomerOrProspect = "n/a";
    if (hashedEmail && customerProspect) {
        try {
            const decryptedJSON = JSON.parse(caesarDecrypt(hashedEmail, customerProspect));
            if (decryptedJSON.pastOrders.length) {
                isCustomerOrProspect = "customer";
            } else {
                isCustomerOrProspect = "prospect";
            }
        } catch (es) {
            // eslint-disable-next-line no-console
            console.log("decrypt error: ", es);
        }
    }
    const url = new URL(window.location.href);
    var ref7;
    const encodedEmailId = (ref7 = (ref4 = url.searchParams) === null || ref4 === void 0 ? void 0 : ref4.get("q")) !== null && ref7 !== void 0 ? ref7 : "";
    // this user object should be updated when user log in or out.
    const user = {
        gId: "n/a",
        abTestName: "n/a",
        adBlocker: false,
        authStatus: "anonymous",
        commerceToolsID: "n/a",
        customerProspect: isCustomerOrProspect,
        envName: "development",
        knownStatus: "unknown",
        profileRole: "guest",
        profileType: "n/a",
        returningStatus: "new visitor",
        emailId: hashedEmail || encodedEmailId || "n/a",
        encodedEmailId
    };
    const isOrderConfirmationPage = (window === null || window === void 0 ? void 0 : window.eventPageType) === "orders:order confirmation";
    if (isOrderConfirmationPage) {
        localStorage.removeItem("hashedEmail");
    }
    // fetch okta tokens for both logged in and anonymous users
    const oktaToken = localStorage.getItem("okta-token-storage");
    const anonymousOktaToken = localStorage.getItem("okta-anonymous-access-token") || ((ref5 = store_0/* store */.h === null || store_0/* store */.h === void 0 ? void 0 : store_0/* store.getState */.h.getState()) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.auth) === null || ref6 === void 0 ? void 0 : ref6.access_token);
    if (oktaToken && oktaToken !== "{}") {
        var ref8;
        // user is logged in
        const oktaObject = JSON.parse(oktaToken);
        const claim = (oktaObject === null || oktaObject === void 0 ? void 0 : (ref8 = oktaObject.accessToken) === null || ref8 === void 0 ? void 0 : ref8.claims) || {};
        // user.uId = claim.uid || "n/a";
        if (claim.businessType === "Consumer" || claim.businessType === "homeowner") {
            user.profileRole = "consumer";
            user.profileType = "consumer";
        } else {
            user.profileRole = "professional";
            const businessSubType = (claim === null || claim === void 0 ? void 0 : claim.businessSubType) !== undefined && (claim === null || claim === void 0 ? void 0 : claim.businessSubType) !== null ? "|".concat(claim.businessSubType) : "";
            user.profileType = "".concat(claim.businessType).concat(businessSubType);
        }
        user.commerceToolsID = claim.commercetoolsID || "n/a";
        if (!isFromRegisterUser) {
            user.returningStatus = "returning customer";
        }
        user.authStatus = "logged in";
        user.knownStatus = "known";
    } else if (anonymousOktaToken) {
        // anonymous user
        let oktaObject1;
        try {
            oktaObject1 = JSON.parse(atob(anonymousOktaToken.split(".")[1])) || {};
        } catch (e) {
            // eslint-disable-next-line no-console
            console.warn("Anonymous Okta Token can not be decoded......");
        }
        if (oktaObject1) {
            user.gId = oktaObject1.gId || "n/a";
        }
    }
    return user;
};
const isElementExcluded = (e, classNames)=>{
    const path = e.path || e.composedPath && e.composedPath();
    return path.some((element)=>{
        return classNames.some((className)=>{
            var ref;
            return element === null || element === void 0 ? void 0 : (ref = element.className) === null || ref === void 0 ? void 0 : ref.includes(className);
        });
    });
};
const clearAuthToken = ()=>{
    localStorage.removeItem("customerProspect");
    localStorage.removeItem("okta-cache-storage");
    localStorage.removeItem("okta-anonymous-access-token");
    localStorage.removeItem("anonymousId");
    const cookies = new es6/* default */.Z();
    cookies.remove("commerce_gid", {
        path: "/",
        domain: ".kohler.com"
    });
};
const clearAnonymousToken = ()=>{
    localStorage.removeItem("anonymousId");
    localStorage.removeItem("okta-anonymous-access-token");
    localStorage.removeItem("okta-anonymous-refresh-token");
    localStorage.removeItem("token-revalidate-expiry");
    const cookies = new es6/* default */.Z();
    cookies.remove("commerce_gid", {
        path: "/",
        domain: ".kohler.com"
    });
};
const SAFE_URL_PATTERN = /^(?:(?:https?|mailto|ftp|tel|file|sms):|[^&:/?#]*(?:[/?#]|$))/gi;
/** A pattern that matches safe data URLs. It only matches image, video, and audio types. */ const DATA_URL_PATTERN = /^data:(?:image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp)|video\/(?:mpeg|mp4|ogg|webm)|audio\/(?:mp3|oga|ogg|opus));base64,[a-z0-9+\/]+=*$/i;
const _sanitizeUrl = (url)=>{
    url = String(url);
    if (url === "null" || url.length === 0 || url === "about:blank") return "about:blank";
    if (url.match(SAFE_URL_PATTERN) || url.match(DATA_URL_PATTERN)) return url;
    return "unsafe:".concat(url);
};
const sanitizeUrl = function() {
    let url = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "about:blank";
    return _sanitizeUrl(String(url).trim());
};
const revalidateTime = ()=>moment_default()().add(30, "m").format();
const getPDPUrl = async (category, slug)=>{
    const { plpServletPath , general  } = await (0,constants_config/* getConfig */.i)();
    const pdpUrl = gePDPUrlPageDetails(plpServletPath, general, category, slug);
    return pdpUrl;
};
const getPdpUrlPath = (category, slug)=>{
    const { generic: { globalConfig: { plpServletPath , general ={}  } = {}  } = {}  } = (store_0/* store */.h === null || store_0/* store */.h === void 0 ? void 0 : store_0/* store.getState */.h.getState()) || {};
    const pdpUrl = gePDPUrlPageDetails(plpServletPath, general, category, slug);
    return pdpUrl;
};
const getPDPUrlForProductTile = async (data)=>{
    const { Product_Category: productCategory = "" , ProductLocalCategory_s: productLocalCategory = "" , slug_s: slug  } = data;
    const category = productCategory ? productCategory : productLocalCategory !== null && productLocalCategory !== void 0 ? productLocalCategory : "";
    const { plpServletPath , general  } = await (0,constants_config/* getConfig */.i)();
    return gePDPUrlPageDetails(plpServletPath, general, category, slug);
};
const getPDPUrlWithConfig = (category, slug, plpServletPath, general)=>{
    const pdpUrl = gePDPUrlPageDetails(plpServletPath, general, category, slug);
    return pdpUrl;
};
const gePDPUrlPageDetails = (plpServletPath, general, category, slug)=>{
    const path = plpServletPath === null || plpServletPath === void 0 ? void 0 : plpServletPath.find((i)=>i.categories.includes(category));
    var ref;
    const shortUrl = (ref = general === null || general === void 0 ? void 0 : general.shortendPagePath) !== null && ref !== void 0 ? ref : "";
    if (category === "Design Services") {
        return getShortenedUrlwithGeneral(general.designServiceLandingPath, general);
    }
    if (category === "Install Services") {
        return getShortenedUrlwithGeneral(general.installServiceLandingPath, general);
    }
    if (!category || category === "Service Parts") {
        var ref1;
        return "".concat((ref1 = general.servicePartsLandingPath) === null || ref1 === void 0 ? void 0 : ref1.replace(shortUrl, ""), "/").concat(slug);
    }
    if (path) {
        var ref2;
        return "".concat((ref2 = path.url) === null || ref2 === void 0 ? void 0 : ref2.replace(shortUrl, ""), "/").concat(slug);
    }
    return "".concat(getShortenedUrlwithGeneral(general === null || general === void 0 ? void 0 : general.plpPagePath, general), "/").concat(category === null || category === void 0 ? void 0 : category.replace(constants_regex/* URL_REPLACE_REGEX */.ef, "-").toLowerCase(), "/").concat(slug, ".html");
};
const pdpTypeFormat = function() {
    let data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { businessUnitName ="" , ProductIsRetail ="" , ProductRequiredAccessoriesGroupsList =[] , superSku =""  } = data;
    let pdpType = "";
    if (businessUnitName === "Service Parts") {
        pdpType = "regular part";
    } else if (ProductIsRetail) {
        pdpType = "retail exclusive";
    } else if (ProductRequiredAccessoriesGroupsList.length) {
        pdpType = constants.PDP_TYPE;
    } else if (superSku) {
        pdpType = "super sku";
    } else {
        pdpType = constants.PDP_TYPE;
    }
    return pdpType;
};
const sanitizeTextForAnalytics = function() {
    let text = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    const testData = text !== null && text !== void 0 ? text : "";
    return String(testData).replace(constants_regex/* SANITIZE_TEXT_REGEX */.If, "").toLowerCase().trim();
};
const makingTextDatalayerReady = (text)=>{
    var ref, ref1, ref2;
    return (ref2 = (ref1 = (ref = getPureText(text)) === null || ref === void 0 ? void 0 : ref.toLowerCase()) === null || ref1 === void 0 ? void 0 : ref1.replace(constants_regex/* DATA_LAYER_REGEX */.ok, "&")) === null || ref2 === void 0 ? void 0 : ref2.trim();
};
const getSwatchCount = function() {
    let isPlp = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    if (!isPlp && window.outerWidth < 1330) {
        return 3;
    } else if (isPlp && window.outerWidth < 812) {
        return 5;
    }
    return isPlp ? 7 : 5;
};
const isColorFacet = (f)=>{
    const facet = f.replace(/^\*{2}/, "");
    return !!(facet === "ColorFinish_s" || facet === "SKUColorFinishName_ss");
};
const getCurrentSkuCouponDiscounts = (param)=>{
    let { sku , cart , locale  } = param;
    var ref, ref1;
    // find if cart-discount is applied to this product
    const discountID = [];
    const discountedAmount = [];
    const productCouponCode = [];
    const comparedList = [];
    const codesList = [];
    const globalDiscountNames = [];
    let productCoupondiscount = 0;
    let globalDiscountValues = 0;
    cart === null || cart === void 0 ? void 0 : (ref = cart.lineItems) === null || ref === void 0 ? void 0 : ref.forEach((lineItem)=>{
        const discountSku = get_default()(lineItem, "variant.sku", null);
        // finding discount details in lineItems
        if (discountSku === sku) {
            get_default()(lineItem, "discountedPrice.includedDiscounts", []).forEach((includedDiscount)=>{
                var ref, ref1;
                if ((includedDiscount === null || includedDiscount === void 0 ? void 0 : (ref = includedDiscount.discount) === null || ref === void 0 ? void 0 : ref.typeId) === "cart-discount" && ((ref1 = includedDiscount.discount.obj) === null || ref1 === void 0 ? void 0 : ref1.id)) {
                    discountID.push(includedDiscount.discount.obj.id);
                    discountedAmount.push(Number((includedDiscount.discountedAmount.centAmount / 100).toFixed(2)));
                    codesList.push(includedDiscount.discount.obj.name[locale]);
                }
            });
        }
    });
    if (discountID.length && (cart === null || cart === void 0 ? void 0 : (ref1 = cart.discountCodes) === null || ref1 === void 0 ? void 0 : ref1.length)) {
        // we got discount id from lineItems, now get discount code from discountCodes
        cart === null || cart === void 0 ? void 0 : cart.discountCodes.forEach((discountCode)=>{
            var ref, ref1;
            if (discountCode === null || discountCode === void 0 ? void 0 : (ref = discountCode.discountCode) === null || ref === void 0 ? void 0 : (ref1 = ref.obj) === null || ref1 === void 0 ? void 0 : ref1.code) {
                var ref2;
                (ref2 = discountCode.discountCode.obj.cartDiscounts) === null || ref2 === void 0 ? void 0 : ref2.forEach((cartDiscount)=>{
                    const matchingIndex = discountID.indexOf(cartDiscount.id);
                    if (matchingIndex !== -1 && cartDiscount.typeId === "cart-discount") {
                        // copy discount code of this discountCode object
                        productCouponCode.push(discountCode.discountCode.obj.code);
                        productCoupondiscount += discountedAmount[matchingIndex];
                        comparedList.push(cartDiscount.id);
                    }
                });
            }
        });
    }
    discountID.filter((a)=>!comparedList.includes(a)).forEach((a)=>{
        const matchedIndex = discountID.indexOf(a);
        if (matchedIndex >= 0) {
            globalDiscountNames.push(codesList[matchedIndex]);
            globalDiscountValues += discountedAmount[matchedIndex];
        }
    });
    productCoupondiscount = Number(productCoupondiscount.toFixed(2));
    return {
        productCouponCode,
        productCoupondiscount,
        globalDiscountNames,
        globalDiscountValues
    };
};
const destructureAddress = (addr, siteName)=>{
    const data = {
        address: "",
        city: "",
        state: "",
        zipcode: ""
    };
    var ref;
    data.address = (ref = addr.split(",")[0]) !== null && ref !== void 0 ? ref : "";
    if (siteName === "kohler-canada") {
        var ref1, ref2, ref3;
        var ref4;
        const address = (ref4 = addr.split(",")) !== null && ref4 !== void 0 ? ref4 : "";
        var ref5;
        data.city = (ref5 = (ref1 = address[1]) === null || ref1 === void 0 ? void 0 : ref1.trim()) !== null && ref5 !== void 0 ? ref5 : "";
        var ref6;
        data.state = (ref6 = (ref2 = address[2]) === null || ref2 === void 0 ? void 0 : ref2.trim()) !== null && ref6 !== void 0 ? ref6 : "";
        var ref7;
        data.zipcode = (ref7 = (ref3 = address[3]) === null || ref3 === void 0 ? void 0 : ref3.trim()) !== null && ref7 !== void 0 ? ref7 : "";
    } else {
        var ref8;
        const addrLine2 = (ref8 = addr.split(",")[1]) !== null && ref8 !== void 0 ? ref8 : "";
        const splitAddress = addrLine2.split(" ");
        var ref9;
        const len = (ref9 = splitAddress === null || splitAddress === void 0 ? void 0 : splitAddress.length) !== null && ref9 !== void 0 ? ref9 : 0;
        let addrLine1 = "";
        splitAddress.forEach((item, i)=>{
            if (i < len - 2) addrLine1 = addrLine1 + item + " ";
        });
        if (addrLine2) {
            var ref10;
            data.city = (ref10 = addrLine1 === null || addrLine1 === void 0 ? void 0 : addrLine1.trim()) !== null && ref10 !== void 0 ? ref10 : "";
            var ref11;
            data.state = (ref11 = addrLine2.split(" ")[len - 2]) !== null && ref11 !== void 0 ? ref11 : "";
            var ref12;
            data.zipcode = (ref12 = addrLine2.split(" ")[len - 1]) !== null && ref12 !== void 0 ? ref12 : "";
        }
    }
    return data;
};
const getStateCode = (stateVal, countryVal, data)=>{
    var ref, ref1;
    let country = {};
    if (data.find((obj)=>obj.code === countryVal)) {
        country = data.find((obj)=>obj.code === countryVal);
    } else {
        var ref2;
        country = (ref2 = data.find((obj)=>obj.name === countryVal)) !== null && ref2 !== void 0 ? ref2 : {};
    }
    if ((ref = country.states) === null || ref === void 0 ? void 0 : ref.find((obj)=>obj.code === stateVal)) return stateVal;
    var ref3;
    const state = (ref3 = (ref1 = country.states) === null || ref1 === void 0 ? void 0 : ref1.find((obj)=>obj.name === stateVal)) !== null && ref3 !== void 0 ? ref3 : {};
    var _code;
    return (_code = state.code) !== null && _code !== void 0 ? _code : "";
};
const getCountryCode = (countryVal, data)=>{
    if (data.find((obj)=>obj.code === countryVal)) return countryVal;
    var ref;
    const country = (ref = data.find((obj)=>obj.name === countryVal)) !== null && ref !== void 0 ? ref : {};
    var _code;
    return (_code = country.code) !== null && _code !== void 0 ? _code : "";
};
const extractScriptsFromDOM = (doc, cb)=>{
    const scripts = doc.getElementsByTagName("script");
    for (const script of scripts){
        const scriptItem = {};
        const src = script.getAttribute("src") || "";
        const type = script.getAttribute("type") || "";
        const integrity = script.getAttribute("integrity") || "";
        const charset = script.getAttribute("charset") || "";
        const dataDomainScript = script.getAttribute("data-domain-script") || "";
        if (src) scriptItem.src = src;
        if (charset) scriptItem.charset = charset;
        if (dataDomainScript) scriptItem.dataDomainScript = dataDomainScript;
        if (type) scriptItem.type = type;
        if (integrity) scriptItem.integrity = integrity;
        if (script.innerHTML) scriptItem.innerHTML = script.innerHTML;
        if ("https://www.kohler.com/corporate/include-consent-banner.js" !== src) {
            cb(scriptItem);
        }
    }
};
const extractStylesFromDOM = (doc, cb)=>{
    const styles = doc.getElementsByTagName("style");
    for (const style of styles){
        if (style.innerHTML) cb(style.innerHTML);
    }
};
const extractLinksFromDOM = (doc, cb)=>{
    const links = doc.getElementsByTagName("link");
    for (const link of links){
        cb(link);
    }
};
const extractMetasFromDOM = (doc, cb)=>{
    const metas = doc.getElementsByTagName("meta");
    for (const meta of metas){
        cb(meta);
    }
};
const showNewBadge = (shipmentDate)=>{
    if (shipmentDate) {
        const today = new Date();
        today.setMonth(today.getMonth() - 6);
        if (Date.parse(shipmentDate) > Date.parse(today)) {
            return true;
        }
    }
    return false;
};
const getCompareData = ()=>{
    const { compare  } = store_0/* store.getState */.h.getState();
    return compare;
};
const isAuth = ()=>{
    const { isAuth  } = store.getState();
    return isAuth;
};
const getUser = ()=>{
    const { user  } = store.getState();
    return user;
};
const getFavouraties = ()=>{
    if (!isServer) {
        const { favorites  } = store_0/* store.getState */.h.getState();
        return favorites === null || favorites === void 0 ? void 0 : favorites.favorites;
    }
    return [];
};
const getDataLayerObj = (datalayerObj)=>{
    store_0/* store */.h === null || store_0/* store */.h === void 0 ? void 0 : store_0/* store.dispatch */.h.dispatch((0,genericSlice/* setDataLayerObj */.sZ)(datalayerObj));
};
const getScriptsAndStyles = (jsonData)=>{
    const { generic: { globalScripts =[] , globalStyles =[]  } = {}  } = store_0/* store.getState */.h.getState();
    const scriptsList = [];
    const stylesList = [];
    const dataRecursion = (jsonData)=>{
        jsonData[":itemsOrder"] && jsonData[":itemsOrder"].map((key, index)=>{
            var ref;
            const jsonItem = jsonData[":items"][key];
            if ((ref = jsonItem[":type"]) === null || ref === void 0 ? void 0 : ref.includes(constants.COMPONENT_TYPES.EMBED)) {
                const doc = new DOMParser().parseFromString(jsonItem === null || jsonItem === void 0 ? void 0 : jsonItem.script, "text/html");
                extractScriptsFromDOM(doc, (item)=>{
                    const isExit = globalScripts.some((el)=>JSON.stringify(el) === JSON.stringify(item));
                    !isExit && scriptsList.push(item);
                });
                extractStylesFromDOM(doc, (item)=>{
                    const isExit = globalStyles.some((el)=>el === item);
                    !isExit && stylesList.push(item);
                });
            } else {
                return dataRecursion(jsonItem);
            }
        });
    };
    dataRecursion(jsonData);
    store_0/* store */.h === null || store_0/* store */.h === void 0 ? void 0 : store_0/* store.dispatch */.h.dispatch((0,genericSlice/* setGlobalScripts */.n8)(scriptsList));
    store_0/* store */.h === null || store_0/* store */.h === void 0 ? void 0 : store_0/* store.dispatch */.h.dispatch((0,genericSlice/* setGlobalStyles */.cw)(stylesList));
    return scriptsList;
};
const hasComponentType = (data, type, cb)=>{
    data[":itemsOrder"] && data[":itemsOrder"].map((key)=>{
        const item = data[":items"][key];
        if (item[":type"].includes(type)) {
            cb && cb();
        } else {
            return hasComponentType(item, type, cb);
        }
    });
};
const isShowAnalyticsEventLoaded = ()=>{
    // this function is used to check if cmp:show event is already loaded or not to avoid duplicate show events
    if (window.adobeDataLayer) {
        let isLoaded = false;
        window.adobeDataLayer.forEach((event)=>{
            if ((event === null || event === void 0 ? void 0 : event.event) === "cmp:show") {
                isLoaded = true;
            }
        });
        return isLoaded;
    }
    return false;
};
const handleForOrderconfirmationCall = ()=>{
    var ref;
    if (document.isOrderConfirmation && !(window === null || window === void 0 ? void 0 : (ref = window.pageObj) === null || ref === void 0 ? void 0 : ref.transaction)) {
        return false;
    }
    return true;
};
let pageLoadAnalyticsTimer;
const addPageLoadAnalyticsEvent = ()=>{
    if (window.adobeDataLayer && window.isShowAnalyticsEvent === true && window.pageObj && !isShowAnalyticsEventLoaded() && window.datalayerTopLoaded && handleForOrderconfirmationCall()) {
        // we need to execute cmp:show event here as it is a first time page
        const page = window.pageObj;
        const { category: { pageType ="" , subCategoryID =""  } = {}  } = page;
        if (pageLoadAnalyticsTimer) {
            clearTimeout(pageLoadAnalyticsTimer);
            pageLoadAnalyticsTimer = undefined;
        }
        if (!pageType) {
            pageLoadAnalyticsTimer = setTimeout(()=>addPageLoadAnalyticsEvent(), 500);
            return;
        }
        if (pageType === "pdp" || pageType === "search-results" || pageType === "search" || pageType === "orders" && subCategoryID === "order details") {
            return;
        }
        page.user = localStorage ? getUserAnalyticsObject() : {};
        const otherItems = {};
        if (page.component) {
            otherItems.component = page.component;
        // delete page.component
        }
        if (page.eventInfo) {
            otherItems.eventInfo = page.eventInfo;
        // delete page.eventInfo
        }
        if (page.productInfo) {
            otherItems.productInfo = page.productInfo;
        // delete page.productInfo
        }
        window.adobeDataLayer.push({
            event: "cmp:show",
            page: page,
            ...otherItems
        });
        window.isShowAnalyticsEvent = false;
        delete window.isShowAnalyticsEvent;
    }
};
const handleZipcodeSet = (zipCode, status, message)=>{
    const eventInfo = {
        eventAction: "cart:landing page:order summary:update zip code",
        eventName: "cart:landing page:order summary:update zip code",
        eventMsg: message || "n/a",
        eventStatus: status,
        internalLinkName: "update",
        eventType: "navigation",
        internalLinkPosition: "cart",
        internalLinkType: "cart:" + zipCode,
        internalLinkZoneName: "cart:landing page:order summary",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    const page = window.pageObj || {};
    if (page.cart) {
        page.cart.zipcode = zipCode;
    }
    window.adobeDataLayer.push({
        event: "cmp:click",
        eventInfo,
        page
    });
};
const getAccessToken = ()=>{
    const { auth: { isAuth , access_token: accessToken = ""  } = {}  } = store_0/* store.getState */.h.getState();
    let token = "";
    if (!isAuth && "object" !== "undefined") {
        token = localStorage.getItem("okta-anonymous-access-token");
    }
    if (!token) token = accessToken;
    if (token) {
        const tokenSplit = token.split(".")[1] || null;
        if (tokenSplit) {
            const { gId , exp  } = JSON.parse(Buffer.from(tokenSplit, "base64"));
            return {
                token,
                gId,
                exp
            };
        } else {
            return {};
        }
    }
    return {
        token
    };
};
const getAnonymousId = ()=>{
    var ref, ref1;
    let anonymousId = "";
    if (true) {
        anonymousId = localStorage.getItem("anonymousId");
    }
    if (!anonymousId) anonymousId = (ref = store_0/* store.getState */.h.getState()) === null || ref === void 0 ? void 0 : (ref1 = ref.auth) === null || ref1 === void 0 ? void 0 : ref1.anonymousId;
    return anonymousId;
};
const isAuthenticated = async (ref, activeTab, isKPN)=>{
    const { auth: { isAuth  } = {}  } = store_0/* store.getState */.h.getState();
    const { general  } = await (0,constants_config/* getConfig */.i)();
    if (isAuth) {
        if (typeof ref === "function") {
            ref();
            return;
        }
        if (isKPN) {
            const persona = getExactUserPersona();
            var _homepageUrl;
            if (persona !== "TVS") return window.location.replace(getShortenedUrlwithGeneral((_homepageUrl = general.homepageUrl) !== null && _homepageUrl !== void 0 ? _homepageUrl : "/", general));
        }
        window.location.href = ref;
    } else {
        window.loginCallback = ref;
        store_0/* store.dispatch */.h.dispatch((0,authSlice/* setAuthModalVisibility */.LY)({
            show: true,
            active: !activeTab ? 0 : activeTab
        }));
    }
};
const isGuestTokenValid = ()=>{
    const { auth: { isAuth  } = {}  } = store_0/* store.getState */.h.getState();
    const { exp =""  } = getAccessToken();
    if (!exp) return false;
    if (!isAuth) return moment_default()().isBefore(moment_default().unix(exp).subtract(120, "s"));
    return true;
};
const hourDifference = (date1, date2)=>{
    let diff = (new Date(date2).getTime() - new Date(date1).getTime()) / 1000;
    diff /= 60 * 60;
    return Math.abs(Math.round(diff));
};
const getUserPersona = ()=>{
    if (!isServer) {
        if (process.env.NEXT_PUBLIC_ENABLE_ANY_PERSONA === "true") return "ANY";
        const { auth: { isAuth , user: { persona =[]  } = {}  } = {}  } = store_0/* store.getState */.h.getState();
        if (isAuth) {
            var ref;
            const personaName = (ref = persona.find((e)=>e.includes(":"))) !== null && ref !== void 0 ? ref : "";
            var ref1;
            return (ref1 = personaName.split(":")[1]) !== null && ref1 !== void 0 ? ref1 : "GST";
        }
    }
    if (process.env.NEXT_PUBLIC_ENABLE_ANY_PERSONA === "true") return "ANY";
    return "GST";
};
const getExactUserPersona = ()=>{
    if (!isServer) {
        const { auth: { isAuth , user: { persona =[]  } = {}  } = {}  } = store_0/* store.getState */.h.getState() || {};
        if (isAuth) {
            var ref;
            const personaName = (ref = persona.find((e)=>e.includes(":"))) !== null && ref !== void 0 ? ref : "";
            var ref1;
            return (ref1 = personaName.split(":")[1]) !== null && ref1 !== void 0 ? ref1 : "GST";
        }
    }
    return "GST";
};
const createPersonaCookie = ()=>{
    const cookie = new es6/* default */.Z();
    cookie.set("userPersona", getUserPersona(), {
        path: "/"
    });
};
const getAEMPreviewModeCookie = ()=>{
    const cookie = new es6/* default */.Z();
    if (cookie.get("aem-author-preview-mode") && cookie.get("__token__")) {
        return true;
    } else {
        return false;
    }
};
const closePreview = ()=>{
    const cookie = new es6/* default */.Z();
    sessionStorage.removeItem("aem-author-preview-mode");
    cookie.remove("aem-author-preview-mode", {
        path: "/"
    });
    cookie.remove("__token__", {
        path: "/"
    });
    localStorage.clear();
    sessionStorage.clear();
    window.location.reload();
};
const handleEnter = (e)=>{
    if (e.keyCode === 13) {
        if (e.target.onclick && e.target.tagName !== "BUTTON") {
            e.stopPropagation();
            document.activeElement.click();
        }
    }
};
const setWindowProps = (obj, val)=>{
    if (val) window[obj] = val;
};
const arrayMove = (arr, fromIndex, toIndex)=>{
    const newArr = [
        ...arr
    ];
    const element = newArr.splice(fromIndex, 1)[0];
    newArr.splice(toIndex, 0, element);
    return newArr;
};
const getCurrency = async ()=>{
    const config = await (0,constants_config/* getConfig */.i)();
    const { internationalization: { currencyCode ="USD"  } = {}  } = config;
    return currencyCode;
};
const getAnalyticsScript = (analyticsScript)=>{
    if (analyticsScript) {
        store_0/* store */.h === null || store_0/* store */.h === void 0 ? void 0 : store_0/* store.dispatch */.h.dispatch((0,genericSlice/* setAnalyticsScript */.DE)(analyticsScript));
    } else {
        store_0/* store */.h === null || store_0/* store */.h === void 0 ? void 0 : store_0/* store.dispatch */.h.dispatch((0,genericSlice/* setAnalyticsScript */.DE)(""));
    }
};
const getPageLevelScriptsAndStyles = (scriptsAndStyles)=>{
    const scriptsList = [];
    const stylesList = [];
    const metaList = [];
    const linkList = [];
    let bazaarVoice = null;
    const dataRecursion = (scriptsAndStyles)=>{
        const doc = new DOMParser().parseFromString(scriptsAndStyles, "text/html");
        extractScriptsFromDOM(doc, (item)=>{
            var ref;
            const isBv = item === null || item === void 0 ? void 0 : (ref = item.src) === null || ref === void 0 ? void 0 : ref.includes(constants.BAZAAR_VOICE);
            if (isBv) {
                bazaarVoice = item;
            } else {
                scriptsList.push(item);
            }
        });
        extractStylesFromDOM(doc, (item)=>stylesList.push(item));
        extractMetasFromDOM(doc, (item)=>metaList.push(item));
        extractLinksFromDOM(doc, (item)=>linkList.push(item));
    };
    dataRecursion(scriptsAndStyles);
    const pageLevelDetails = {};
    pageLevelDetails["pageScripts"] = scriptsList;
    pageLevelDetails["stylesList"] = stylesList;
    pageLevelDetails["metaList"] = metaList;
    pageLevelDetails["linkList"] = linkList;
    return {
        pageLevelDetails,
        bazaarVoice
    };
};
const checkStock = (backOrder, category)=>{
    return !(!category || backOrder === true || backOrder === "Yes" || category === "Install Services" || category === "Design Services");
};
const checkCartStock = function() {
    let cart = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { lineItems =[]  } = cart;
    let valid = true;
    lineItems.filter((item)=>{
        var ref, ref1;
        return !((ref = item.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.bundleParentId);
    }).map((item)=>{
        var ref;
        var ref1;
        const attributes = (ref1 = (ref = item.variant) === null || ref === void 0 ? void 0 : ref.attributes) !== null && ref1 !== void 0 ? ref1 : [];
        const cartItem = {
            quantity: get_default()(item, "quantity", 0),
            backOrder: get_default()(item, "custom.fields.isBackOrderable", false),
            category: get_default()(attributes.find((attr)=>attr.name === "ProductLocalCategory"), "value", "")
        };
        if (valid && checkStock(cartItem.backOrder, cartItem.category)) {
            const channels = Object.values(get_default()(item, "variant.availability.channels", {}));
            if (channels.length > 0) {
                const availableQty = get_default()(channels[0], "availableQuantity", 0);
                if (availableQty < cartItem.quantity) {
                    valid = false;
                }
            }
        }
    });
    return valid;
};
const getCartItemsAnalyticsData = async (cartItems)=>{
    const bundleLocalStorage = localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem("bundleItems");
    const bundleItems = bundleLocalStorage ? JSON.parse(bundleLocalStorage) : [];
    // first parameter should be cartItems
    const { general  } = await (0,constants_config/* getConfig */.i)();
    const data = {
        item: [],
        itemSkus: []
    };
    cartItems.forEach((item)=>{
        var ref, ref1;
        const siteWideCoupanCode = [];
        const productCouponCode = [];
        const discountPercents = [];
        let productCoupondiscount = 0;
        let siteWideDiscount = 0;
        let selectedBundles = [];
        if (bundleItems.length) {
            selectedBundles = bundleItems.find((bItem)=>{
                var ref;
                return Array.isArray(bItem === null || bItem === void 0 ? void 0 : bItem.selectedSkus) && (bItem === null || bItem === void 0 ? void 0 : (ref = bItem.selectedSkus) === null || ref === void 0 ? void 0 : ref.includes(item === null || item === void 0 ? void 0 : item.sku));
            });
        }
        const { bundleId =""  } = selectedBundles || {};
        if ((ref = item.discountsList) === null || ref === void 0 ? void 0 : ref.length) {
            item.discountsList.forEach((discountItem)=>{
                if (discountItem.type === "sitewide") {
                    var ref;
                    // always apply sitewide discount first then remaining can be applied
                    siteWideDiscount += Number(item.unitPrice) * (discountItem.percent / 100);
                    siteWideCoupanCode.push((ref = discountItem.code) === null || ref === void 0 ? void 0 : ref.toLowerCase());
                } else {
                    // there can be multiple product coupon codes
                    discountPercents.push(discountItem.percent);
                    productCouponCode.push(discountItem.code);
                }
            });
            if (discountPercents.length) {
                let priceAfterDiscount = Number(item.unitPrice) - siteWideDiscount;
                let temporaryCouponPrice;
                for (const disc of discountPercents){
                    temporaryCouponPrice = Number((priceAfterDiscount * (disc / 100)).toFixed(2));
                    priceAfterDiscount = priceAfterDiscount - temporaryCouponPrice;
                    productCoupondiscount += temporaryCouponPrice;
                }
                productCoupondiscount = Number(productCoupondiscount.toFixed(2));
            }
        }
        const otherItem = {};
        if (item.productUpdated === true || item.productUpdated === false) {
            otherItem.productUpdated = item.productUpdated;
        }
        var ref2;
        const globalDiscount = siteWideDiscount ? siteWideDiscount : (ref2 = item === null || item === void 0 ? void 0 : item.discountAmount) !== null && ref2 !== void 0 ? ref2 : 0;
        const globalPromotionPrice = Number(item.unitPrice) - globalDiscount;
        const itemType = getCartItemType(item.category, item.businessUnitName);
        const discountedPrice = Number(item === null || item === void 0 ? void 0 : item.discountPrice) ? Number(item === null || item === void 0 ? void 0 : item.discountPrice) : Number(item === null || item === void 0 ? void 0 : item.discountUnitPrice);
        const customerFacingSKUId = item.customerFacingSKU || item.sku;
        data.itemSkus.push(item.sku);
        data.item.push({
            productInfo: {
                productBrand: general === null || general === void 0 ? void 0 : (ref1 = general.siteName) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase(),
                productID: customerFacingSKUId,
                description: sanitizeTextForAnalytics(item.desc),
                productCategory: sanitizeTextForAnalytics(item.category),
                productName: sanitizeTextForAnalytics(item.name || item.desc || item.category),
                productColor: sanitizeTextForAnalytics(item.color) || "n/a",
                productRoom: (item === null || item === void 0 ? void 0 : item.isBundleParent) || (item === null || item === void 0 ? void 0 : item.isBundleChildItem) ? sanitizeTextForAnalytics(item.category) : sanitizeTextForAnalytics(item.productRoom || (itemType === "service" ? itemType : "non-catalog")),
                productSaleable: true,
                productStatus: !item.availableQty && item.backOrder ? "back order" : !checkStock(item.backOrder, item.category) || item.availableQty >= item.quantity || itemType === "service" ? "in stock" : "out of stock",
                productPartnerBuyNow: false,
                productBasePrice: Number(item.unitPrice),
                productCouponCode: productCouponCode.join("|") || "n/a",
                productCoupondiscount: productCoupondiscount || 0,
                productSuperSku: Boolean(item.superSku),
                productSalePrice: discountedPrice ? discountedPrice : Number(item.unitPrice),
                globalPromotionPrice: Number(globalPromotionPrice.toFixed(2)),
                defaultImageName: item.image,
                priceState: item.discountPercent > 0 ? "percentOff|" + item.discountPercent : item.discountAmount > 0 ? "priceOff|" + item.discountAmount : "regular price",
                productCollectionsName: sanitizeTextForAnalytics(item.productCollectionsName || item.category),
                productFindingMethod: "n/a",
                productTileName: sanitizeTextForAnalytics(item.name || item.desc),
                quantity: item.quantity,
                globalOffer: siteWideCoupanCode.join("|") || "n/a",
                globalDiscount: Number(globalDiscount.toFixed(2)),
                itemType,
                isSubscription: false,
                isRecommended: false,
                frequency: "n/a",
                isSendNow: "n/a",
                ratings: "n/a",
                numberOfReviews: "n/a",
                pdpType: bundleId || (item === null || item === void 0 ? void 0 : item.isBundleParent) || (item === null || item === void 0 ? void 0 : item.isBundleChildItem) ? "bundle" : "regular finished goods & service parts",
                bundleIds: bundleId ? "K-".concat(bundleId) : "n/a",
                bundleProductColors: bundleId ? sanitizeTextForAnalytics(item === null || item === void 0 ? void 0 : item.color) || "n/a" : "n/a",
                ...otherItem
            },
            quantity: item.quantity
        });
    });
    const isOrderConfirmationPage = (window === null || window === void 0 ? void 0 : window.eventPageType) === "orders:order confirmation";
    if (isOrderConfirmationPage) {
        localStorage.removeItem("bundleItems");
    }
    return data;
};
const getAssociatedServices = (attr)=>{
    var ref;
    const productServices = (ref = attr.find((item)=>item.name === "ProductServices")) !== null && ref !== void 0 ? ref : {};
    const { value =[]  } = productServices;
    return [
        ...value
    ];
};
const getFreightDiscountTotal = function() {
    let codes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    let total = 0;
    codes.forEach((e)=>{
        if (constants.FREIGHT_SHIPPING_TYPES.includes(e.name)) {
            total += Number(e.discount);
        }
    });
    return total;
};
const getCartItemData = function() {
    let data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var ref, ref1, ref2, ref3, ref4;
    const { item ={} , CONFIG ={}  } = data;
    const { internationalization: { locale ="" , currencySign ="$"  } = {}  } = CONFIG;
    const { price: { discounted ={} , value: { centAmount: unitPrice = 0  } = {}  } = {} , discountedPrice ={} , variant: { attributes =[] , sku ="" , images: variantImages = []  } = {} , id ="" , totalPrice: { centAmount: totalPrice = 0  } = {} , productSlug ={} , quantity =0 , custom: { fields: { isBundleChildItem =false , isBundleParent =false , bundleSku ="" , parentBundleSku ="" , bundleParentId ="" , bundleParentProduct ={} , bundleItemPrice: { centAmount: bundleUnitPrice = ""  } = {} , bundleTotalPrice: { centAmount: bundleTotalPrice = ""  } = {}  } = {}  } = {}  } = item;
    const { obj: { masterData: { current: { name: names = {} , description ={} , slug: bundleSlug = {} , masterVariant: { images =[] , attributes: bundleAttributes = []  } = {}  } = {}  } = {}  } = {}  } = bundleParentProduct;
    const { discount: { obj: { value: { money =[]  } = {}  } = {}  } = {}  } = discounted;
    var _locale;
    const bundleName = (_locale = names[locale]) !== null && _locale !== void 0 ? _locale : "";
    var _locale1;
    const bundleDesc = (_locale1 = description[locale]) !== null && _locale1 !== void 0 ? _locale1 : "";
    const regionBrandName = get_default()(attributes.find((attr)=>attr.name === "RegionBrandName"), "value", get_default()(item, "name[".concat(locale, "]"), ""));
    const productDesc = get_default()(attributes.find((attr)=>attr.name === "ProductDescriptionProductShort"), "value[".concat(locale, "]"), get_default()(attributes.find((attr)=>attr.name === "ProductDescriptionProduct"), "value", ""));
    const color = get_default()(attributes.find((attr)=>attr.name === "SKUColorFinishName"), "value[".concat(locale, "]"), "");
    const getShape = get_default()(attributes.find((attr)=>attr.name === "ProductShape"), "value", "");
    let shape;
    if (getShape && getShape[0] && getShape[0][locale]) {
        shape = getShape[0][locale];
    }
    var ref5;
    // Get line item details
    const productSection = (ref5 = get_default()(attributes.find((attr)=>attr.name === "ProductSection"), "value", null)) !== null && ref5 !== void 0 ? ref5 : [];
    let productRoom;
    if (productSection && productSection[0] && productSection[0][locale]) {
        productRoom = productSection[0][locale];
    }
    const getSize = get_default()(attributes.find((attr)=>attr.name === "ProductSize"), "value", "");
    let size;
    if (getSize && getSize[0] && getSize[0][locale]) {
        size = getSize[0][locale];
    }
    let discountedPriceProductLevel = 0;
    if (!isEmpty_default()(money)) {
        discountedPriceProductLevel = (Number(get_default()(money[0], "centAmount", 0)) / 100).toFixed(2);
    }
    // Get line item price
    const { value: { centAmount: discountPriceValue = 0  } = {} , includedDiscounts =[]  } = discountedPrice;
    let discountPrice = 0;
    if (discounted) {
        const { value: { centAmount: dicCentAmount = 0  } = {}  } = discounted;
        discountPrice = (Number(dicCentAmount) / 100).toFixed(2);
    }
    if (discountedPrice) {
        discountPrice = (Number(discountPriceValue) / 100).toFixed(2);
    }
    const name = isBundleParent ? bundleName : regionBrandName;
    const desc = isBundleParent ? bundleDesc : productDesc;
    const discountedPricePerQuantity = (Number(get_default()((ref = includedDiscounts[0]) === null || ref === void 0 ? void 0 : ref.discountedAmount, "centAmount", 0)) / 100).toFixed(2);
    const productSku = isBundleParent ? bundleSku : sku;
    const image = isBundleParent ? (ref1 = images.at(0)) === null || ref1 === void 0 ? void 0 : ref1.url : (ref2 = variantImages.at(0)) === null || ref2 === void 0 ? void 0 : ref2.url;
    const productUnitPrice = (Number(isBundleParent ? bundleUnitPrice : unitPrice) / 100).toFixed(2);
    const productTotalPrice = (Number(isBundleParent ? bundleTotalPrice : totalPrice) / 100).toFixed(2);
    const slug = isBundleParent ? bundleSlug[locale] : productSlug[locale];
    const category = getAttributeValue(isBundleParent ? bundleAttributes : attributes, "ProductLocalCategory");
    return {
        isBundleParent,
        isBundleChildItem,
        id,
        bundleParentId,
        parentBundleSku,
        sku: productSku,
        customerFacingSKU: getAttributeValue(attributes, "CustomerFacingSKU"),
        productRoom,
        slug,
        quantity,
        image,
        category,
        brand: getAttributeValue(attributes, "CustomerFacingBrand"),
        associatedServices: getAssociatedServices(attributes),
        currencySign,
        name,
        desc,
        color,
        size,
        shape,
        unitPrice: productUnitPrice,
        totalPrice: productTotalPrice,
        discountUnitPrice: (Number(get_default()(item, "price.discounted.value.centAmount", 0)) / 100).toFixed(2),
        discountPrice,
        discountedPricePerQuantity,
        discountedPriceProductLevel,
        isComboSku: attributes.some((attr)=>attr.name === "ComboSKU"),
        backOrder: get_default()(item, "custom.fields.isBackOrderable", false),
        businessUnitName: get_default()(attributes.find((attr)=>attr.name === "SPProductBusinessUnit"), "value", ""),
        additionalData: (item === null || item === void 0 ? void 0 : (ref3 = item.custom) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.fields) === null || ref4 === void 0 ? void 0 : ref4.roomInfo) ? get_default()(item, "custom.fields", "") : "",
        discountsList: [],
        productCollectionsName: getAttributeValue(attributes, "ProductBrandNameDisplay") || getAttributeValue(attributes, "ProductBrandNameDisplay_t"),
        addedAt: get_default()(item, "addedAt", "")
    };
};
const getBundleCombineData = (items)=>{
    const bundleChildItems = items.filter((e)=>e.isBundleChildItem);
    const cartItems = items.filter((e)=>!e.isBundleChildItem);
    const data = [];
    cartItems.forEach((e)=>{
        if (e.isBundleParent) {
            const childrens = bundleChildItems.filter((el)=>{
                return el.parentBundleSku === e.sku;
            });
            const isOutOfStock = childrens.some((e)=>e.outOfStock);
            data.push({
                ...e,
                bundleLineItems: childrens,
                bundleItemsCount: childrens.length,
                outOfStock: isOutOfStock
            });
        } else data.push(e);
    });
    return data;
};
const getChildBundleData = (items)=>{
    return items.filter((e)=>!e.isBundleParent);
};
const calculateCartData = async function() {
    let params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, isCart = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    const { cart: cartObject = {} , noShippingItems: noShippingItemsProps = [] , shippingItemstoCheckout =[] , quantityUpdatedFlag  } = params;
    const { shippingTotal: { centAmount: shippingTotal  } = {} , customerGroup: { id: custGroupId = ""  } = {} , customLineItems =[] , billingAddress ={} , promoCode ="" , discountCodes =[] , lineItems =[] , subtotalWithoutDiscount: { centAmount: subtotalWithoutDiscount = 0  } = {} , subtotalWithPromotion: { centAmount: subtotalWithPromotion = 0  } = {} , totalPromo: { centAmount: totalPromo = 0  } = {} , totalTax: { centAmount: totalTax = 0  } = {} , estimatedTotal: { centAmount: estimatedTotalAmount = 0  } = {}  } = cartObject;
    const shippingItemsProps = shippingItemstoCheckout;
    const CONFIG = await (0,constants_config/* getConfig */.i)();
    const { internationalization: { locale ="" , currencyCode: currency = "usd"  } = {} , general: { siteName ="" , lwAppName =""  } = {}  } = CONFIG;
    const brandName = siteName === null || siteName === void 0 ? void 0 : siteName.toLowerCase();
    let voucherDiscount = 0;
    let subtotal = 0;
    let subtotalWithDiscount = 0;
    let totalPromotions = 0;
    let estimatedShipping = 0;
    let estimatedTax = 0;
    let estimatedTotal = 0;
    let promoCodes = [];
    let oldPromoCodes = [];
    let oldDiscountCodes = [];
    const cartItems = [];
    const specFiles = [];
    const outOfStockItems = [];
    const noShippingItems = [];
    let shippingDiscountsList = 0;
    const shippingDiscountsNameList = [];
    const voucherCode = [];
    oldPromoCodes = promoCode;
    oldDiscountCodes = discountCodes;
    if (lineItems.length) {
        // Get discount code details
        if (promoCode === null || promoCode === void 0 ? void 0 : promoCode.length) {
            promoCode.forEach(function() {
                let item = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                const { type ="" , discountedAmount: { centAmount =0  } = {} , name  } = item;
                let discountName;
                if (item.code) {
                    var ref, ref1;
                    if (discountCodes === null || discountCodes === void 0 ? void 0 : discountCodes.length) {
                        const matchedDiscountCode = discountCodes.find((dc)=>{
                            var ref, ref1;
                            return ((ref = dc.discountCode) === null || ref === void 0 ? void 0 : (ref1 = ref.obj) === null || ref1 === void 0 ? void 0 : ref1.code) === item.code;
                        });
                        const { discountCode: { obj: { name: disNames = {}  }  }  } = matchedDiscountCode;
                        const localeName = disNames[locale];
                        if (localeName) {
                            discountName = localeName;
                        }
                    }
                    var ref2;
                    promoCodes.push({
                        code: item.code,
                        discount: (Number(get_default()(item, "discountedAmount.centAmount", 0)) / 100).toFixed(2),
                        id: (ref2 = (ref = discountCodes.find((code)=>code.discountCode.obj.code === item.code)) === null || ref === void 0 ? void 0 : (ref1 = ref.discountCode) === null || ref1 === void 0 ? void 0 : ref1.id) !== null && ref2 !== void 0 ? ref2 : "",
                        type: item.type
                    });
                } else if (type === "product") {
                    const proCode = promoCodes.find((p)=>p.type === "product");
                    if (proCode) {
                        const code = proCode;
                        code.discount = (Number(code.discount) + Number(centAmount) / 100).toFixed(2);
                    } else {
                        promoCodes.unshift({
                            code: "Product Discounts",
                            discount: (Number(centAmount) / 100).toFixed(2),
                            id: "",
                            type: "product",
                            name: discountName
                        });
                    }
                } else {
                    if (promoCodes.find((p)=>p.code === (name || discountName))) {
                        const code1 = promoCodes.find((p)=>p.code === (name || discountName));
                        code1.discount = (Number(code1.discount) + Number(centAmount) / 100).toFixed(2);
                    } else {
                        centAmount && promoCodes.unshift({
                            code: item.name || discountName,
                            discount: (Number(centAmount) / 100).toFixed(2),
                            id: "",
                            type: "no-code"
                        });
                    }
                }
            });
        }
        // Get shipping promotions
        if (customLineItems.length) {
            promoCodes = promoCodes.concat(await getShippingDiscountPromoCodes(cartObject));
        }
        let lineItemsCopy = lineItems !== null && lineItems !== void 0 ? lineItems : [];
        if (isCart) {
            var ref;
            lineItemsCopy = (ref = lineItems === null || lineItems === void 0 ? void 0 : lineItems.filter((item)=>{
                var ref, ref1;
                return !((ref = item.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.bundleParentId);
            })) !== null && ref !== void 0 ? ref : [];
        }
        const parentBundleItems = customLineItems.filter((item)=>{
            var ref;
            return (ref = item.custom) === null || ref === void 0 ? void 0 : ref.fields.isBundleParent;
        });
        lineItemsCopy = [
            ...lineItemsCopy,
            ...parentBundleItems
        ];
        lineItemsCopy.forEach((item, i)=>{
            var ref;
            const { price: { discounted ={}  } = {} , discountedPrice ={} , variant: { availability: { channels =[]  } = {} , attributes =[]  } = {} , custom: { fields: { isBundleParent , bundleParentProduct: { obj: { masterData: { current: { masterVariant: { availability: { channels: bundleChannels = {}  } = {}  } = {}  } = {}  } = {}  } = {}  } = {}  } = {}  } = {}  } = item;
            const { discount: { obj: { value: { permyriad , money =[] , type =""  } = {}  } = {}  } = {}  } = discounted;
            cartItems[i] = getCartItemData({
                item,
                CONFIG,
                custGroupId
            });
            if (quantityUpdatedFlag) {
                var ref1;
                if (quantityUpdatedFlag === ((ref1 = cartItems[i].customerFacingSKU) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase())) {
                    cartItems[i].productUpdated = true;
                } else {
                    cartItems[i].productUpdated = false;
                }
            }
            cartItems[i].superSku = cartItems[i].isComboSku;
            // Get line item discounts
            if (discounted) {
                const isAbs = type === "absolute";
                const isRel = !isAbs;
                if (isAbs) {
                    cartItems[i].discountAmount = Number(money[0].centAmount / 100);
                } else {
                    var ref2, ref3;
                    cartItems[i].discountPercent = Number(permyriad / 100);
                    if ((ref2 = discounted.discount) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.obj) === null || ref3 === void 0 ? void 0 : ref3.name[locale]) {
                        var // sitewide discount
                        ref4;
                        (ref4 = cartItems[i].discountsList) === null || ref4 === void 0 ? void 0 : ref4.push({
                            type: "sitewide",
                            isAbs,
                            isRel,
                            percent: isRel ? cartItems[i].discountPercent : 0,
                            absolute: cartItems[i].discountAmount || 0,
                            code: discounted.discount.obj.name[locale]
                        });
                    }
                }
            }
            const { includedDiscounts =[]  } = discountedPrice;
            if (includedDiscounts === null || includedDiscounts === void 0 ? void 0 : includedDiscounts.length) {
                includedDiscounts.forEach(function() {
                    let includedDiscountItem = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                    const { discount: { obj: { name ={} , value: { permyriad =0 , type ="" , money =[]  }  } = {}  } = {}  } = includedDiscountItem;
                    const isAbs = type === "absolute";
                    const isRel = type === "relative";
                    if (isAbs) {
                        cartItems[i].discountAmount = Number(money[0].centAmount / 100);
                    } else if (isRel) {
                        cartItems[i].discountPercent = Number(permyriad / 100);
                    }
                    if (isAbs || isRel) {
                        const otherDiscount = name[locale];
                        const lineItemDiscountName = promoCode === null || promoCode === void 0 ? void 0 : promoCode.find((p)=>p.type === "order" && p.name === otherDiscount);
                        if (otherDiscount && lineItemDiscountName) {
                            // capture discounts like buy 1 get 1 free. could be like installation service free on design service
                            const matchedOrderDiscount = promoCodes.find((p)=>p.type === "no-code" && p.code === otherDiscount);
                            if (matchedOrderDiscount) {
                                var // sitewide discount
                                ref;
                                (ref = cartItems[i].discountsList) === null || ref === void 0 ? void 0 : ref.push({
                                    type: "sitewide",
                                    percent: isRel ? cartItems[i].discountPercent : 0,
                                    absolute: cartItems[i].discountAmount || 0,
                                    isAbs,
                                    isRel,
                                    code: matchedOrderDiscount.code
                                });
                            }
                        }
                        // find code from discountCode
                        if (discountCodes === null || discountCodes === void 0 ? void 0 : discountCodes.length) {
                            discountCodes.forEach(function() {
                                let disCode = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                                const { discountCode: { obj: { cartDiscounts =[] , code =""  }  } = {}  } = disCode;
                                if (cartDiscounts === null || cartDiscounts === void 0 ? void 0 : cartDiscounts.length) {
                                    cartDiscounts.forEach((discountItem)=>{
                                        if (discountItem.id === includedDiscountItem.discount.obj.id) {
                                            var // All coupon discounts
                                            ref;
                                            (ref = cartItems[i].discountsList) === null || ref === void 0 ? void 0 : ref.push({
                                                type: "cart",
                                                isAbs,
                                                isRel,
                                                percent: cartItems[i].discountPercent || 0,
                                                absolute: cartItems[i].discountAmount || 0,
                                                code
                                            });
                                        }
                                    });
                                }
                            });
                        }
                    }
                });
            }
            var ref5;
            const { availableQuantity =0  } = (ref5 = channels[Object.keys(channels).at(0)]) !== null && ref5 !== void 0 ? ref5 : {};
            var ref6;
            const { availableQuantity: availableQuantityBundle = 0  } = (ref6 = bundleChannels[Object.keys(bundleChannels).at(0)]) !== null && ref6 !== void 0 ? ref6 : {};
            cartItems[i].availableQty = isBundleParent ? availableQuantityBundle : availableQuantity;
            // Check if item is out of stock
            const isProduct = checkStock(cartItems[i].backOrder, cartItems[i].category);
            if (isProduct) {
                if (cartItems[i].availableQty < cartItems[i].quantity) {
                    cartItems[i].outOfStock = true;
                    outOfStockItems.push(cartItems[i]);
                }
            }
            // get lead time if item is back ordered
            if (cartItems[i].backOrder === true) {
                cartItems[i].leadTime = get_default()(attributes.find((attr)=>attr.name === "RegionLeadTime"), "value", 0);
            }
            // Check if all items are avilable for shipping
            const comboSku = get_default()(attributes.find((attr)=>attr.name === "ComboSKU"), "value");
            const childSku = [];
            comboSku === null || comboSku === void 0 ? void 0 : comboSku.forEach((e)=>{
                const sku = e.find((attr)=>attr.name === "sku");
                childSku.push(sku.value);
            });
            if (noShippingItemsProps === null || noShippingItemsProps === void 0 ? void 0 : noShippingItemsProps.find((e)=>{
                return childSku === null || childSku === void 0 ? void 0 : childSku.includes(e);
            })) {
                cartItems[i].noShipping = true;
                noShippingItems.push(cartItems[i]);
            }
            if (noShippingItemsProps === null || noShippingItemsProps === void 0 ? void 0 : noShippingItemsProps.includes((ref = item.variant) === null || ref === void 0 ? void 0 : ref.sku)) {
                cartItems[i].noShipping = true;
                noShippingItems.push(cartItems[i]);
            } else if (shippingItemsProps) {
                var ref7;
                const { warningMessage ="" , parentLineItemId =""  } = (ref7 = shippingItemsProps === null || shippingItemsProps === void 0 ? void 0 : shippingItemsProps.find((shippingItem)=>shippingItem.lineItemId === item.id)) !== null && ref7 !== void 0 ? ref7 : {};
                if (warningMessage) {
                    if (parentLineItemId) {
                        const parentIndex = cartItems.findIndex((c)=>c.id === parentLineItemId);
                        if (parentIndex >= 0 && !cartItems[parentIndex].noShipping) {
                            cartItems[parentIndex].noShipping = true;
                            noShippingItems.push(cartItems[parentIndex]);
                        }
                    } else {
                        cartItems[i].noShipping = true;
                        noShippingItems.push(cartItems[i]);
                    }
                }
            }
            // Get spec files for all line items
            const productResources = get_default()(attributes.find((attr)=>attr.name === "ProductResource"), "value", []);
            if (productResources.length) {
                var ref8;
                const resource = (ref8 = productResources.find((arr)=>arr[1].value === "SpecPDFFileName")) !== null && ref8 !== void 0 ? ref8 : [];
                var ref9;
                const resourceUrl = (ref9 = resource.find((obj)=>obj.name === "ResourceFullWebURL")) !== null && ref9 !== void 0 ? ref9 : {};
                var _value;
                const specFileUrl = (_value = resourceUrl.value) !== null && _value !== void 0 ? _value : "";
                if (specFileUrl) specFiles.push(specFileUrl);
            }
        });
        // Get order summary price amounts
        subtotal = Number(subtotalWithoutDiscount / 100).toFixed(2);
        subtotalWithDiscount = Number(subtotalWithPromotion / 100).toFixed(2);
        totalPromotions = Number(totalPromo / 100).toFixed(2);
        estimatedTax = Number(totalTax / 100).toFixed(2);
        estimatedShipping = Number((shippingTotal !== null && shippingTotal !== void 0 ? shippingTotal : 0) / 100).toFixed(2);
        estimatedTotal = Number(estimatedTotalAmount / 100).toFixed(2);
        // checking shipping related discounts and adding it to price object
        promoCodes.forEach((promo)=>{
            if (promo.type === "shipping" || promo.type === "no-code") {
                shippingDiscountsList += Number(promo.discount);
                shippingDiscountsNameList.push(promo.code);
            }
        });
        // Add shipping promotions to total promotions
        promoCodes.filter((item)=>item.type === "shipping").forEach((item)=>{
            estimatedShipping = Number(estimatedShipping) + Number(item.discount);
        });
    }
    promoCodes.forEach((itm)=>{
        voucherCode.push(itm.code);
        voucherDiscount += Number(itm.discount);
    });
    var _pageObj;
    const page = (_pageObj = window.pageObj) !== null && _pageObj !== void 0 ? _pageObj : {};
    const { category: { subCategoryName =""  } = {}  } = page;
    const cartItemsData = getBundleCombineData(cartItems);
    let analyticsCartItems = [];
    if (subCategoryName === "pdp") {
        analyticsCartItems = await getCartItemsAnalyticsData(cartItemsData);
    } else {
        const cartItemsAllData = getChildBundleData(cartItems);
        analyticsCartItems = await getCartItemsAnalyticsData(cartItemsAllData);
    }
    if (analyticsCartItems === null || analyticsCartItems === void 0 ? void 0 : analyticsCartItems.itemSkus) {
        delete analyticsCartItems.itemSkus;
    }
    const cart = {
        cartID: cartObject === null || cartObject === void 0 ? void 0 : cartObject.id,
        cartNumber: cartObject === null || cartObject === void 0 ? void 0 : cartObject.key,
        price: {
            basePrice: subtotal || 0,
            voucherCode: voucherCode.length ? voucherCode.join("|") : "n/a",
            voucherDiscount: voucherDiscount ? Number(voucherDiscount.toFixed(2)) : 0,
            globalOffer: shippingDiscountsNameList ? shippingDiscountsNameList.join("|") || "n/a" : "n/a",
            globalDiscount: shippingDiscountsList ? Number(shippingDiscountsList.toFixed(2)) : 0,
            currency: currency.toLowerCase(),
            taxRate: estimatedTax || "n/a",
            shipping: estimatedShipping ? Number(estimatedShipping) : "n/a",
            priceWithTax: estimatedTotal || 0,
            cartTotal: subtotal || 0,
            couponCode: "n/a",
            couponDiscount: 0,
            orderCouponCode: "n/a",
            orderCouponDiscount: 0,
            shippingMethod: "ground"
        },
        ...analyticsCartItems
    };
    cartItemsData.forEach((e)=>{
        var ref;
        const matchedItem = analyticsCartItems === null || analyticsCartItems === void 0 ? void 0 : (ref = analyticsCartItems.item) === null || ref === void 0 ? void 0 : ref.find((i)=>i.productInfo.productID === e.customerFacingSKU);
        if (matchedItem) {
            e.customProductInfo = sanitizeDOMString(JSON.stringify(matchedItem));
        }
    });
    cartItemsData.sort((prev, curr)=>{
        return new Date(curr.addedAt) - new Date(prev.addedAt);
    });
    sanitizeObject(cartItemsData);
    sanitizeObject(cart);
    const freightDiscountTotal = getFreightDiscountTotal(promoCodes);
    const shippingAllTotal = (0,utils/* getShippingAllTotal */.hH)(customLineItems, locale);
    return {
        oldPromoCodes,
        oldDiscountCodes,
        cartItems: cartItemsData,
        subtotal,
        subtotalWithDiscount,
        totalPromotions,
        estimatedTax,
        estimatedShipping,
        estimatedTotal,
        shippingTotal: shippingTotal / 100,
        promoCodes,
        specFiles,
        outOfStockItems,
        noShippingItems,
        shippingDiscountsNameList,
        shippingDiscountsList,
        cart,
        freightDiscountTotal,
        shippingAllTotal,
        brandName,
        billingAddress,
        lwAppName
    };
};
const getShippingDiscountPromoCodes = async (cartObject)=>{
    const locale = await (0,constants_config/* getConfig */.i)().then((config)=>get_default()(config, "internationalization.locale", ""));
    const { customLineItems =[] , discountCodes =[]  } = cartObject;
    const promoCodes = [];
    customLineItems.forEach(function() {
        let item = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        const { discountedPrice: { includedDiscounts =[]  } = {}  } = item;
        includedDiscounts.forEach(function() {
            let disc = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            var ref;
            const { discountedAmount: { centAmount: discountedAmountCent = 0  } = {} , discount: { obj: { requiresDiscountCode , id ="" , name: objName = {}  } = {}  } = {}  } = disc;
            const discountedAmount = Number(discountedAmountCent) / 100;
            var _locale;
            const discountName = (_locale = objName[locale]) !== null && _locale !== void 0 ? _locale : "";
            var ref1;
            const name = (ref1 = item === null || item === void 0 ? void 0 : (ref = item.name) === null || ref === void 0 ? void 0 : ref[locale]) !== null && ref1 !== void 0 ? ref1 : "";
            // get shipping promotions with codes
            if (requiresDiscountCode) {
                var ref2;
                var ref3;
                const dicountIdObj = (ref3 = discountCodes === null || discountCodes === void 0 ? void 0 : discountCodes.find((disc)=>{
                    var ref, ref1, ref2;
                    return ((ref2 = (ref = disc.discountCode) === null || ref === void 0 ? void 0 : (ref1 = ref.obj) === null || ref1 === void 0 ? void 0 : ref1.cartDiscounts[0]) === null || ref2 === void 0 ? void 0 : ref2.id) === id;
                })) !== null && ref3 !== void 0 ? ref3 : {};
                var ref4;
                const discountId = (ref4 = (ref2 = dicountIdObj.discountCode) === null || ref2 === void 0 ? void 0 : ref2.id) !== null && ref4 !== void 0 ? ref4 : "";
                if (!promoCodes.find((code)=>code.id === discountId)) {
                    promoCodes.push({
                        code: discountName,
                        discount: discountedAmount.toFixed(2),
                        id: discountId,
                        type: "shipping",
                        name
                    });
                } else {
                    const index = promoCodes.findIndex((code)=>code.id === discountId);
                    promoCodes[index].discount = (Number(promoCodes[index].discount) + discountedAmount).toFixed(2);
                }
            } else {
                if (!promoCodes.find((p)=>p.code === name)) {
                    promoCodes.push({
                        code: discountName,
                        discount: discountedAmount.toFixed(2),
                        id: "",
                        type: "shipping",
                        name
                    });
                } else {
                    const index1 = promoCodes.findIndex((p)=>p.code === name);
                    promoCodes[index1].discount = (Number(promoCodes[index1].discount) + discountedAmount).toFixed(2);
                }
            }
        });
    });
    return promoCodes;
};
const getCartItemType = function() {
    let category = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", businessUnitName = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    if (!category && !businessUnitName) {
        return "n/a";
    }
    category = category.toLowerCase();
    businessUnitName = businessUnitName.toLowerCase();
    if (category === "install services" || category === "design services" || category === "services") {
        return "service";
    }
    if (category === "samples") {
        return "sample";
    }
    if (category === "parts" || category === "service parts" || businessUnitName.indexOf("serviceparts") !== -1 || businessUnitName === "service parts") {
        return "part";
    }
    return "product";
};
const sanitizeDOMString = (property)=>typeof property === "string" ? browser_default().sanitize(property) : property;
const decodeHtmlCharacters = (str)=>{
    return str.replace(/&amp;/g, "&").replace(/&#8217;/g, "'").replace(/&nbsp;/g, " ");
};
const sanitizeAndDecodeHtml = (str)=>{
    const decodeVal = decodeHtmlCharacters(str);
    return sanitizeInnerHtml(decodeVal);
};
const updateObject = (objRef, objKey)=>{
    const copyObject = {
        ...objRef
    };
    copyObject[objKey] = sanitizeDOMString(copyObject[objKey]);
    return copyObject;
};
const sanitizeObject = (obj)=>{
    if (typeof obj === "object" && obj !== null) {
        Object.keys(obj).forEach((objKey)=>{
            if (typeof obj[objKey] === "string") {
                return updateObject(obj, objKey);
            }
            return sanitizeObject(obj[objKey]);
        });
    }
    return obj;
};
const handleZipDownload = async (files, filename, success, err)=>{
    for(let i = 0; i < files.length; i++){
        if (!files[i].includes("http")) {
            files.splice(i, i + 1);
            i--;
        }
    }
    try {
        const payload = {
            files: files
        };
        if (filename) {
            payload.downloadFileName = filename;
        } else {
            const crypto1 = window.crypto || window.msCrypto;
            const array = new Uint32Array(1);
            const rand = crypto1.getRandomValues(array)[0];
            const { general  } = await (0,constants_config/* getConfig */.i)();
            var ref;
            const brandName = (ref = general === null || general === void 0 ? void 0 : general.siteName) !== null && ref !== void 0 ? ref : "";
            const randomId = Math.floor(rand * 10000000).toString(16);
            payload.downloadFileName = "".concat(brandName, "-").concat(randomId);
        }
        const { payload: res  } = await store_0/* store.dispatch */.h.dispatch((0,genericSlice/* zipDownload */.t8)(payload)) || {};
        if (res) {
            let downloadFileName = filename + ".zip";
            if (!filename) {
                const disposition = content_disposition_default().parse(res.headers["content-disposition"]);
                downloadFileName = disposition.parameters.filename;
            }
            file_download_default()(res.data, downloadFileName);
            if (success) success();
        }
    } catch (ex) {
        // temp
        // log.error(ex)
        if (err) err();
    }
};
const isEmbeddedElement = (script)=>{
    if (script) {
        const doc = new DOMParser().parseFromString(script, "text/html");
        if (doc.body.innerHTML) {
            return true;
        }
    }
    return false;
};
const isEmbeddedStyles = (script)=>{
    const stylesList = [];
    if (script) {
        const doc = new DOMParser().parseFromString(script, "text/html");
        extractStylesFromDOM(doc, (item)=>stylesList.push(item));
    }
    const resultVal = {
        styles: stylesList
    };
    return resultVal;
};
const getSiteWideModal = (e, url)=>{
    if ((url === null || url === void 0 ? void 0 : url.indexOf("http")) === 0) {
        e.preventDefault();
        window.handleShowModal(url);
    }
};
const getAttributeValue = (attributes, name)=>{
    var ref;
    const { value =""  } = (ref = attributes.find((attr)=>attr.name === name)) !== null && ref !== void 0 ? ref : {};
    return value;
};
const createIdFromString = (text)=>{
    const testData = text !== null && text !== void 0 ? text : "";
    testData.replace(constants_regex/* SANITIZE_TEXT_REGEX */.If, "").toLowerCase().replace(/ /g, "-").trim();
    return testData;
};
const capitalizeFirstName = (firstname)=>{
    firstname = (firstname === null || firstname === void 0 ? void 0 : firstname.charAt(0).toUpperCase()) + (firstname === null || firstname === void 0 ? void 0 : firstname.slice(1));
    return firstname;
};
const setFocus = (id)=>{
    var ref;
    (ref = document.getElementById(id)) === null || ref === void 0 ? void 0 : ref.focus();
};
const preventBodyScroll = (status)=>{
    if (status) {
        document.body.classList.add("scroll-lock", "modal-open");
        document.getElementsByTagName("html")[0].classList.add("scroll-lock", "modal-open");
    } else {
        document.body.classList.remove("scroll-lock", "modal-open");
        document.getElementsByTagName("html")[0].classList.remove("scroll-lock", "modal-open");
    }
};
const preventBodyScrollTab = (status)=>{
    if (status) {
        document.body.classList.add("gbh-of-scroll");
    } else {
        document.body.classList.remove("gbh-of-scroll");
    }
};
const sanitizeText = (text)=>{
    return text === null || text === void 0 ? void 0 : text.replace(/<\/?[^>]+(>|$)/g, "");
};
// Sort
const getSortFromUrl = ()=>{
    const url = new URL(location.href);
    var ref;
    const appliedSort = (ref = url.searchParams.get("sort")) !== null && ref !== void 0 ? ref : "";
    return appliedSort.includes("%2B") ? appliedSort.replaceAll("%2B", "+") : appliedSort.replaceAll(" ", "+");
};
const getSelectedSort = (text, query)=>{
    switch(query){
        case "bestSeller_l+asc":
            return {
                name: text.bestSellers,
                query: "bestSeller_l+asc"
            };
        case "price+desc":
            return {
                name: text.priceDesc,
                query: "price+desc"
            };
        case "price+asc":
            return {
                name: text.priceAsc,
                query: "price+asc"
            };
        case "CollapseSort_s+asc":
        case "NonCollapseSort_s+asc":
            return {
                name: text.atoz,
                query
            };
        case "CollapseSort_s+desc":
        case "NonCollapseSort_s+desc":
            return {
                name: text.ztoa,
                query
            };
        case "productName_s+asc":
            return {
                name: text.atoz,
                query
            };
        case "productName_s+desc":
            return {
                name: text.ztoa,
                query
            };
        case "title_s+asc":
        case "cardTitle_s+asc":
            return {
                name: text.atoz,
                query
            };
        case "title_s+desc":
        case "cardTitle_s+desc":
            return {
                name: text.ztoa,
                query
            };
        case "new":
            return {
                name: text.newToOld,
                query
            };
        case "old":
            return {
                name: text.oldToNew,
                query
            };
        // Temp Fix AToZ & ZToA
        case "atoz":
            return {
                name: text.AToZ,
                query
            };
        case "ztoa":
            return {
                name: text.ZToA,
                query
            };
    }
    return {
        name: text.featured,
        query: ""
    };
};
const replaceSearchUrl = (searchTerm, param)=>{
    const url = new URL(window.location.href);
    let searchUrl = url.search;
    const searchArray = searchUrl.split("&");
    const index = searchUrl.split("&").findIndex((param)=>param.includes(searchTerm));
    if (param === "" || param === undefined) {
        searchArray.splice(index, 1);
        const urlIndex = searchArray.findIndex((searchParam)=>searchParam.includes("?"));
        searchUrl = searchArray.length !== 0 ? urlIndex === -1 ? "?".concat(searchArray.join("&")) : searchArray.join("&") : searchArray.join("&");
    } else if (index !== -1) {
        searchArray.splice(index, 1, "".concat(searchTerm, "=").concat(param));
        if (!index) {
            searchArray[index] = "?".concat(searchArray[index]);
        }
        searchUrl = searchArray.join("&");
    } else {
        searchUrl = searchUrl ? searchUrl + "&".concat(searchTerm, "=").concat(param) : "?".concat(searchTerm, "=").concat(param);
    }
    history.replaceState(window.location.pathname, document.title, url.pathname + searchUrl);
};
const getPriceSortQuery = ()=>{
    const persona = getUserPersona();
    return "priceList.".concat(persona, ".finalPrice_d");
};
const getSortItemBasedOnURL = (text, defaultItem)=>{
    const urlParams = window.location.search;
    let queryVal = "";
    if (urlParams) {
        const urlQuery = urlParams.replace("?", "").split("&");
        urlQuery.forEach((query, i)=>{
            const isBack = query.split("=")[0] === "back";
            if (isBack) {
                sessionStorage.plpScrollSku = query.split("=")[1];
            }
            queryVal += isBack ? "" : "".concat(i > 0 ? "&" : "").concat(query);
        });
        window.history.replaceState(window.location.pathname, document.title, queryVal.length > 0 ? "?".concat(queryVal.toString()) : window.location.pathname);
    }
    const query = getSortFromUrl();
    const selectedSortItem = query ? getSelectedSort(text, query) : defaultItem || null;
    return selectedSortItem;
};
// *****
const filterBackEndJson = (json)=>{
    const newJson = {};
    for(const k in json){
        if (k !== "allowedComponents") {
            if (typeof json[k] === "object" && !Array.isArray(json[k]) && json[k] !== null) {
                newJson[k] = filterBackEndJson(json[k]);
            } else {
                newJson[k] = json[k];
            }
        }
    }
    return newJson;
};
// Filter
const formatFacetName = (name, filter, facetLabels)=>{
    var ref, ref1;
    let val = facetLabels && facetLabels[name === null || name === void 0 ? void 0 : name.replace(/^\*{2}/, "")] ? facetLabels[name === null || name === void 0 ? void 0 : name.replace(/^\*{2}/, "")] : (ref1 = (ref = name === null || name === void 0 ? void 0 : name.replace(/\./g, "/")) === null || ref === void 0 ? void 0 : ref.replace(/_/g, " ")) === null || ref1 === void 0 ? void 0 : ref1.replace(/^\*{2}/, "");
    if (filter) val += " - ".concat(filter);
    return val;
};
const formatPriceRange = function(filter) {
    let isAnnsacksPlp = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    const values = filter.match(/\d+/g);
    if (Array.isArray(values)) {
        var ref, ref1;
        return isAnnsacksPlp ? "$".concat((ref = Number(values[0])) === null || ref === void 0 ? void 0 : ref.toLocaleString(), " - $").concat((ref1 = Number(values[1])) === null || ref1 === void 0 ? void 0 : ref1.toLocaleString()) : "$".concat(values[0], " - $").concat(values[1]);
    } else {
        return null;
    }
};
const resetFilterUrl = ()=>{
    let searches = location.search.split("&");
    searches = searches.filter((item)=>constants.queryParamsToPersist.filter((param)=>item.includes(param)).length);
    const url = searches.join("&");
    window.history.replaceState({}, document.title, window.location.pathname + (url.includes("?") ? url : url && "?".concat(url)));
};
const getFacetsFromUrl = function() {
    let marketParamValues = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const currFilters = [];
    const url = new URL(window.location.href);
    const urlParams = url.searchParams.get("facets");
    const aMarkettingParameters = marketParamValues === null || marketParamValues === void 0 ? void 0 : marketParamValues.marketParamValues;
    if (urlParams) {
        urlParams.replace("?", "").split(",").forEach((filter)=>{
            if (filter.split(":")[0] !== "title" && filter.split(":")[0] !== "id" && filter.split(":")[0] !== "keyword" && filter.split(":")[0] !== "compare" && filter.split(":")[0] !== "back" && filter.split(":")[0] !== "sort" && filter.split(":")[0] !== "activeTab" && filter.split(":")[0] !== "tab" && filter.split(":")[0] !== "skuSearch" && filter.split(":")[0] !== "service" && !(aMarkettingParameters === null || aMarkettingParameters === void 0 ? void 0 : aMarkettingParameters.includes(filter.split(":")[0]))) {
                const facet = decodeURIComponent(filter.split(":")[0]);
                if (facet === "wcmmode") return;
                const decode = decodeURIComponent(filter);
                const values = decode && decode.split(":")[1].split("|");
                let display = decode && decode.split(":")[1].split("|");
                display = display.map((val)=>val.replace(constants_regex/* FILTER_PARAM_REGEX */.GK, " "));
                const filterName = decode.split(":")[0];
                display = display.map((d)=>d.replace(/\\/g, ""));
                // format price range filter
                if (filterName === "Price_Range") {
                    display = display.map((range)=>formatPriceRange(range));
                }
                // Check if the filter attribute already exists
                let checkFacet = false;
                currFilters.forEach((item)=>{
                    checkFacet = Object.values(item).includes(facet);
                });
                // Add a new filter or add values to existing filter
                if (!checkFacet) {
                    currFilters.push({
                        facet: facet,
                        value: values,
                        display: display
                    });
                } else {
                    currFilters.forEach((fc)=>{
                        if (facet === fc.facet) {
                            fc.value.push(values);
                            fc.display.push(display);
                        }
                    });
                }
            }
        });
    }
    return currFilters.filter((currFilter)=>currFilter.facet !== "sort");
};
const getParamsFromUrl = async ()=>{
    const urlParams = window.location.search;
    const decode = decodeURIComponent(urlParams);
    const value = decode && decode.split("=")[1].split(",");
    return value;
};
const retainSearchQueryParams = (type)=>{
    const search = window.location.search;
    let srpTabDetails = {};
    if (!search.includes("tab=")) {
        srpTabDetails = {
            [type]: search
        };
    } else {
        if (search.includes("tab=".concat(type))) {
            srpTabDetails = {
                [type]: search
            };
        }
    }
    if (sessionStorage.getItem("SRPTabDetails")) {
        srpTabDetails = JSON.parse(sessionStorage.getItem("SRPTabDetails"));
        srpTabDetails[type] = window.location.search;
    }
    sessionStorage.setItem("SRPTabDetails", JSON.stringify(srpTabDetails));
};
const removeSearchQueryParams = ()=>{
    sessionStorage.removeItem("SRPTabDetails");
};
const checkIfUserExists = (email)=>api/* apim.post */.TH.post("/customer/lookup", {
        email
    });
const removeHtmlWithoutHttps = (str)=>{
    const htmlPositions = [];
    const htmlPattern = /.html/g;
    let match;
    let formattedString = str;
    while(match = htmlPattern.exec(str) !== null){
        htmlPositions.push(match.index);
    }
    if (htmlPositions.length) {
        for(let i = 0; i < htmlPositions.length; i++){
            const htmlPostion = formattedString.indexOf(".html");
            const herfStartingPosition = formattedString.lastIndexOf('"', htmlPostion);
            const subStr = formattedString.substring(herfStartingPosition + 1, herfStartingPosition + 6);
            if (!subStr.includes("http")) {
                formattedString = formattedString.slice(0, htmlPostion) + formattedString.slice(htmlPostion + 5);
            }
        }
    }
    return formattedString;
};
const getShortenedUrl = async (uUrl)=>{
    const { general  } = await (0,constants_config/* getConfig */.i)();
    if (general) {
        const { shortendPagePath  } = general;
        const shortUrl = shortendPagePath !== null && shortendPagePath !== void 0 ? shortendPagePath : "";
        const htmlRemovedUrl = removeHtmlWithoutHttps(uUrl);
        const shortUrlRegEx = new RegExp(shortUrl, "g");
        return "".concat(htmlRemovedUrl === null || htmlRemovedUrl === void 0 ? void 0 : htmlRemovedUrl.replace(shortUrlRegEx, ""));
    }
    return "";
};
const getShortenedUrlPath = (uUrl)=>{
    const { generic: { globalConfig: { general ={}  } = {}  } = {}  } = (store_0/* store */.h === null || store_0/* store */.h === void 0 ? void 0 : store_0/* store.getState */.h.getState()) || {};
    const { shortendPagePath =""  } = general;
    if (shortendPagePath) {
        const htmlRemovedUrl = removeHtmlWithoutHttps(uUrl);
        const shortUrlRegEx = new RegExp(shortendPagePath, "g");
        return "".concat(htmlRemovedUrl === null || htmlRemovedUrl === void 0 ? void 0 : htmlRemovedUrl.replace(shortUrlRegEx, ""));
    }
    return "";
};
const getAuthShortenedUrl = async (name)=>{
    const { general ={}  } = await (0,constants_config/* getConfig */.i)();
    const url = general[name];
    if (general) {
        const { shortendPagePath  } = general;
        const shortUrl = shortendPagePath !== null && shortendPagePath !== void 0 ? shortendPagePath : "";
        const htmlRegExp = new RegExp(".html", "g");
        const htmlRemovedUrl = "".concat(url === null || url === void 0 ? void 0 : url.replace(htmlRegExp, ""));
        const shortUrlRegEx = new RegExp(shortUrl, "g");
        return "".concat(htmlRemovedUrl === null || htmlRemovedUrl === void 0 ? void 0 : htmlRemovedUrl.replace(shortUrlRegEx, ""));
    }
    return "";
};
const getShortenedUrlwithGeneral = (uUrl, general)=>{
    if (general) {
        const { shortendPagePath  } = general;
        const shortUrl = shortendPagePath !== null && shortendPagePath !== void 0 ? shortendPagePath : "";
        const htmlRemovedUrl = removeHtmlWithoutHttps(uUrl);
        const shortUrlRegEx = new RegExp(shortUrl, "g");
        return "".concat(htmlRemovedUrl === null || htmlRemovedUrl === void 0 ? void 0 : htmlRemovedUrl.replace(shortUrlRegEx, ""));
    }
    return "";
};
const getFacetField = (facetFields, facetQuery)=>{
    return Array.isArray(facetFields) ? facetFields.find((f)=>f === facetQuery) : facetFields === facetQuery;
};
const getAllFilterQueries = function(componentProps) {
    let fusion = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, marketParamValues = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    let currFilters = [];
    const urlFilters = getFacetsFromUrl(marketParamValues);
    var ref;
    const facetFields = (ref = fusion["facet.field"]) !== null && ref !== void 0 ? ref : [];
    var ref1;
    const facetLabels = (ref1 = fusion === null || fusion === void 0 ? void 0 : fusion.facet_labels) !== null && ref1 !== void 0 ? ref1 : {};
    if (urlFilters.length > 0) {
        urlFilters.forEach((f)=>{
            let facetQuery = f.facet === "Price_Range" ? "Price_Range" : Object.keys(facetLabels).find((key)=>facetLabels[key] === f.facet.replace(/_/g, " "));
            const isValidFacet = getFacetField(facetFields, facetQuery);
            if (isValidFacet) facetQuery = "**".concat(facetQuery);
            if (facetQuery) {
                f.facet = facetQuery;
            }
        });
    }
    // Set pre-selected filters
    if ((urlFilters === null || urlFilters === void 0 ? void 0 : urlFilters.length) === 0 && (componentProps === null || componentProps === void 0 ? void 0 : componentProps.attributeName) && (componentProps === null || componentProps === void 0 ? void 0 : componentProps.attributevalue) && (componentProps === null || componentProps === void 0 ? void 0 : componentProps.attributeName) !== "" && (componentProps === null || componentProps === void 0 ? void 0 : componentProps.attributevalue) !== "") {
        let facetQuery = componentProps === null || componentProps === void 0 ? void 0 : componentProps.attributeName;
        const isValidFacet = getFacetField(facetFields, facetQuery);
        if (isValidFacet) {
            facetQuery = "**".concat(facetQuery);
        }
        currFilters.push({
            facet: facetQuery,
            value: [
                componentProps === null || componentProps === void 0 ? void 0 : componentProps.attributevalue.replace(/"/g, '\\"')
            ],
            display: [
                componentProps === null || componentProps === void 0 ? void 0 : componentProps.attributevalue
            ]
        });
    }
    currFilters = [
        ...currFilters,
        ...urlFilters
    ];
    return currFilters;
};
const convertStringToBoolean = (str)=>{
    if (typeof str === "string") {
        if (str.toLowerCase() === "true") {
            return true;
        } else if (str.toLowerCase() === "false") {
            return false;
        } else {
            return false;
        }
    } else if (typeof str === "boolean") {
        return str;
    } else {
        return false;
    }
};
const resetUrl = ()=>{
    const url = new URL(window.location.href);
    const searchUrl = url.search;
    const searchArray = searchUrl.split("&");
    const searchedUrl = searchArray.length ? searchArray[0] : "";
    history.replaceState(window.location.pathname, document.title, url.pathname + searchedUrl);
};
const formatMultiSelectFacets = (data)=>{
    var ref;
    var ref1;
    const facets = Object.entries((ref1 = (ref = data.facet_counts) === null || ref === void 0 ? void 0 : ref.facet_fields) !== null && ref1 !== void 0 ? ref1 : {}).map((fields)=>({
            [fields[0]]: fields[1]
        }));
    let facetField = data === null || data === void 0 ? void 0 : data.fusion["facet.field"];
    if (facetField) {
        if (typeof facetField === "string") facetField = [
            facetField
        ];
        facetField.forEach((item)=>{
            facets.forEach((filter, index)=>{
                if (filter[item]) {
                    const obj = {
                        ["**".concat(item)]: filter[item]
                    };
                    facets.splice(index, 1, obj);
                }
            });
        });
    }
    const result = Object.assign({}, ...facets);
    return result;
};
const addADALink = (ele, params)=>{
    const a = ele === null || ele === void 0 ? void 0 : ele.getElementsByTagName("a");
    if (a && a.length) {
        for(let i = 0; i < a.length; i++){
            const anchor = a[i];
            if (!anchor.hasAttribute("aria-label")) {
                const innerHtml = anchor.innerHTML;
                anchor.setAttribute("aria-label", anchor.getAttribute("target") === "_blank" ? params.translate("kf.pdp.label.aria.dangerouslyLinkADABlankPage", {
                    innerHtml
                }) : params.translate("kf.pdp.label.aria.dangerouslyLinkADA", {
                    innerHtml
                }));
            }
        }
    }
};
const removeAndCleanLink = (link)=>{
    return link ? link === null || link === void 0 ? void 0 : link.split("/content/kohler/us").join("").replace(".html", "") : link;
};
const mapStateToCountryHandler = function() {
    let countryData = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], stateData = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    const data = [];
    countryData.forEach((country)=>{
        data.push({
            code: country.value,
            name: country.text,
            states: []
        });
    });
    stateData.forEach((state)=>{
        var ref, ref1, ref2;
        const countryCode = (ref = state.value) === null || ref === void 0 ? void 0 : ref.split(":")[1];
        (ref1 = data.find((country)=>country.code === countryCode)) === null || ref1 === void 0 ? void 0 : ref1.states.push({
            code: (ref2 = state.value) === null || ref2 === void 0 ? void 0 : ref2.split(":")[0],
            name: state.text
        });
    });
    return data;
};
const addToRecentlyViewed = (id)=>{
    const { general  } = (0,constants_config/* getConfig */.i)();
    var ref;
    const max = (ref = general === null || general === void 0 ? void 0 : general.recentlyViewedMax) !== null && ref !== void 0 ? ref : 10;
    let items = localStorage.getItem("recently-viewed") ? JSON.parse(localStorage.getItem("recently-viewed")) : [];
    if (id) {
        items = items.filter((i)=>i !== id);
        items.unshift(id);
        const newItems = items.slice(0, max);
        localStorage.setItem("recently-viewed", JSON.stringify(newItems));
    }
};
const getModelSuggestionSkuListFromData = (data)=>{
    const skuList = [];
    data.map((variants)=>{
        var ref;
        const labelList = (ref = variants === null || variants === void 0 ? void 0 : variants.customerFacingSKUList_ss) !== null && ref !== void 0 ? ref : get_default()(variants, "variantList.sku_ss");
        if (Array.isArray(labelList)) {
            labelList.forEach((sku)=>skuList.push(sku));
        } else if (labelList) {
            skuList.push(labelList);
        }
    });
    return skuList;
};
const handleModelNumberSuggestion = (resp)=>{
    const { response: { numFound , docs  }  } = resp;
    if (numFound < 1) {
        return {
            suggestions: [],
            invalidModelNumber: numFound === 0 ? true : false
        };
    } else {
        var ref;
        const skuList = (ref = getModelSuggestionSkuListFromData(docs)) !== null && ref !== void 0 ? ref : [];
        return {
            suggestions: skuList
        };
    }
};
const closeModalAnalytics = (productInfo)=>{
    setTimeout(()=>{
        const modalCloseButtons = document.getElementsByClassName("bv-mbox-close");
        if (!window.modalCloseEventLoaded && (modalCloseButtons === null || modalCloseButtons === void 0 ? void 0 : modalCloseButtons.length)) {
            // this means review contents are loaded
            const modalCloseButton = modalCloseButtons[0];
            const clickEvent = function() {
                const page = window.pageObj || {};
                const eventInfo = {
                    eventAction: "pdp:modal:write a review:close",
                    eventName: "pdp:modal:write a review:close",
                    eventType: "navigation",
                    eventMsg: "n/a",
                    eventStatus: "n/a",
                    internalLinkName: "close",
                    internalLinkPosition: "pdp",
                    internalLinkType: "pdp:close",
                    internalLinkZoneName: "pdp:modal:write a review",
                    internalLinkURL: "n/a",
                    clickInternalLinks: "true"
                };
                window.adobeDataLayer.push({
                    event: "cmp:click",
                    eventInfo,
                    page,
                    productInfo: productInfo ? JSON.parse(productInfo).productInfo : null
                });
                modalCloseButton.removeEventListener("click", clickEvent);
                delete window.checker;
                delete window.modalCloseEventLoaded;
            };
            modalCloseButton.addEventListener("click", clickEvent);
            window.modalCloseEventLoaded = true;
        } else if (!window.modalCloseEventLoaded && (!window.checker || window.checker < 10)) {
            var _checker;
            window.checker = ((_checker = window.checker) !== null && _checker !== void 0 ? _checker : 0) + 1;
            closeModalAnalytics(productInfo);
        }
    }, 2000);
};
const sanitizeTextArticle = (text)=>{
    return text.replace(/<\/?[^>]+(>|$)/g, "").replace(/(\r\n|\n|\r)/gm, "");
};
const cleanText = function() {
    let text = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return text.replace(/<\/?[^>]+(>|$)/g, "");
};
const appendPresetToUrl = function(assetAccountName, swatchUrl, assetId, width) {
    let presetConfigs = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {}, isReel = arguments.length > 5 ? arguments[5] : void 0;
    const { Desktop , MobileLandscape ="" , MobilePortrait ="" , LandscapeCategory  } = presetConfigs;
    let preset = "";
    if (width <= 768) {
        if (width <= 425) {
            if (MobilePortrait) {
                preset = MobilePortrait;
            }
        } else {
            if (MobileLandscape) {
                preset = MobileLandscape;
            }
        }
    } else {
        preset = isReel ? Desktop : MobileLandscape;
    }
    return "".concat(swatchUrl).concat(LandscapeCategory, "?$product_src=is{").concat(assetAccountName, "/").concat(assetId, "}&").concat(preset);
};
const getPresetThumbnailUrl = (assetAccountName, swatchUrl, assetId, presetConfigs)=>{
    const { Thumbnail , LandscapeCategory  } = presetConfigs;
    return "".concat(swatchUrl).concat(LandscapeCategory, "?$product_src=is{").concat(assetAccountName, "/").concat(assetId, "}&").concat(Thumbnail);
};
const checkIsFavorite = (items)=>{
    const page = window.location.origin + window.location.pathname;
    const checkLink = (item)=>{
        let link = {};
        try {
            var ref, ref1;
            link = new URL((ref = item.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.link);
        } catch (err) {
            // eslint-disable-next-line no-console
            console.log(err);
        }
        return link.origin + link.pathname === page ? true : false;
    };
    const isFavorite = (el)=>{
        var ref, ref1, ref2;
        // check if asset url is added to favorites
        if (((ref = el.dataset) === null || ref === void 0 ? void 0 : ref.asset) && items.find((item)=>{
            var ref, ref1;
            return ((ref = item.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.link) === el.dataset.url;
        })) {
            return items.find((item)=>{
                var ref, ref1;
                return ((ref = item.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.link) === el.dataset.url;
            }).id;
        }
        if (((ref1 = el.dataset) === null || ref1 === void 0 ? void 0 : ref1.asset) && items.find((item)=>{
            var ref, ref1;
            return ((ref = item.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.link) === window.location.origin + el.dataset.url;
        })) {
            return items.find((item)=>{
                var ref, ref1;
                return ((ref = item.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.link) === window.location.origin + el.dataset.url;
            }).id;
        }
        // check if current page url is added to favorites
        if (!((ref2 = el.dataset) === null || ref2 === void 0 ? void 0 : ref2.asset) && items.find((item)=>checkLink(item))) {
            return items.find((item)=>checkLink(item)).id;
        }
        return false;
    };
    const favElements = [
        ...document.getElementsByClassName("fav-trigger"),
        ...document.getElementsByClassName("fav-video-trigger")
    ];
    favElements.forEach((elem)=>{
        const id = isFavorite(elem);
        if (id) {
            elem.classList.add("favorite-filled");
            elem.dataset.id = id;
        }
    });
};
const sanitizeProductName = (name)=>name.replace(/®|™/g, "");
/**
 *
 * @param {Boolean} isEnable
 */ const toggeleBodyScroll = (isEnable)=>{
    if (isEnable) {
        document.body.classList.add("remove-scroll");
    } else {
        document.body.classList.remove("remove-scroll");
    }
};
const toggeleBodyClass = (isEnable)=>{
    if (isEnable) {
        document.body.classList.add("add-body-class");
    } else {
        document.body.classList.remove("add-body-class");
    }
};
const toggeleBodyClassAfterLogin = (isEnable)=>{
    if (isEnable) {
        document.body.classList.add("add-body-class-after-login");
    } else {
        document.body.classList.remove("add-body-class-after-login");
    }
};
const formatOfflineRegisterPropsData = (root)=>{
    const result = {};
    if (root && root[":items"]) {
        const handleItems = (items)=>{
            for (const [key, value] of Object.entries(items)){
                if (key === "register_offline_pro") {
                    Object.assign(result, value);
                } else if (value && value[":items"]) {
                    handleItems(value[":items"]);
                }
            }
        };
        handleItems(root[":items"]);
    }
    return result;
};
const formatRegistrationSuveryPropsData = (root)=>{
    const result = {};
    if (root && root[":items"]) {
        const handleItems = (items)=>{
            for (const [key, value] of Object.entries(items)){
                if (key === "medallia_survey_form") {
                    Object.assign(result, value);
                } else if (value && value[":items"]) {
                    handleItems(value[":items"]);
                }
            }
        };
        handleItems(root[":items"]);
    }
    return result;
};
const formatOnlineRegisterPropsData = (root)=>{
    const result = {};
    if (root && root[":items"]) {
        const handleItems = (items)=>{
            for (const [key, value] of Object.entries(items)){
                if (key === "register_online_prod") {
                    Object.assign(result, value);
                } else if (value && value[":items"]) {
                    handleItems(value[":items"]);
                }
            }
        };
        handleItems(root[":items"]);
    }
    return result;
};
const nbspSanitizeInnerHtml = (property)=>{
    const sanitizedHtml = browser_default().sanitize(property).replace(/&nbsp;/g, " ");
    const parsedHtml = (0,html_react_parser/* default */.ZP)(sanitizedHtml);
    return parsedHtml;
};
const getDefaultProfileAddress = (profile)=>{
    const { firstName ="" , lastName ="" , defaultShippingAddressId ="" , addresses =[]  } = profile;
    const prefilledCustomerDetails = {
        firstName: {
            value: firstName
        },
        lastName: {
            value: lastName
        }
    };
    if (addresses.length) {
        const defaultAddress = addresses.find((item)=>item.id === defaultShippingAddressId);
        if (!isEmpty_default()(defaultAddress)) {
            const { city , postalCode , state , streetName  } = defaultAddress;
            prefilledCustomerDetails["city"] = {
                value: city
            };
            prefilledCustomerDetails["address"] = {
                value: streetName
            };
            prefilledCustomerDetails["zipCode"] = {
                value: postalCode
            };
            prefilledCustomerDetails["state"] = {
                value: state
            };
        }
    }
    return prefilledCustomerDetails;
};
const getPathFromUrl = (url)=>{
    return url.split(/[?#]/)[0];
};
const validatePhone = function() {
    let phone = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    phone = phone.replace("(", "");
    phone = phone.replace(")", "");
    phone = phone.replace(" ", "");
    phone = phone.replace("-", "");
    if (/^\d+$/.test(phone) && phone.length > 9) return true;
    return false;
};
const getCityList = (url, brand, searchTerm)=>{
    return api/* apim.get */.TH.get(url, {
        params: {
            $format: "json",
            brand,
            $select: "Locality",
            $filter: "StartsWith(Locality,'".concat(searchTerm, "') eq true")
        }
    });
};
const storeFilterData = (filterData)=>{
    const storeFinalData = {};
    delete filterData["jcr:primaryType"];
    const filterKeys = Object.keys(filterData);
    filterKeys.forEach((element)=>{
        delete filterData[element]["jcr:primaryType"];
        const categoryKeys = filterData[element]["categoryName"];
        const categoryList = filterData[element]["list"];
        delete categoryList["jcr:primaryType"];
        const categoryListValues = Object === null || Object === void 0 ? void 0 : Object.values(filterData[element]["list"]);
        const filteredCategoryValues = Object === null || Object === void 0 ? void 0 : Object.values(categoryListValues);
        const finalFacets = filteredCategoryValues.map((x)=>({
                label: x.displayName,
                query: x.bingName
            }));
        storeFinalData[categoryKeys] = finalFacets;
    });
    return storeFinalData;
};
const checkAlphanumeric = (value)=>{
    const pattern = /^[A-Za-z0-9 ]+$/;
    if (pattern.test(value)) {
        return true;
    }
    return false;
};
const checkAlphabetOnly = (value)=>{
    return constants_regex/* ALPHABET_WITH_SPACE_REGEX.test */.si.test(value);
};
const getRandom = ()=>{
    if (!isServer) {
        const crypto1 = window.crypto || window.msCrypto;
        const array = new Uint32Array(1);
        return crypto1.getRandomValues(array)[0];
    } else {
        return parseInt(new Date().getTime());
    }
};
const getAnalyticsUrl = (url)=>(url.indexOf("http") === -1 ? window.location.origin : "") + url;
const getPageInfo = ()=>{
    const { adobeDataLayer: { getState  } = {}  } = window;
    return getState && getState("page") || {};
};
const formatDate = async (date)=>{
    const { internationalization: { locale: currentLocale  }  } = await (0,constants_config/* getConfig */.i)();
    const d = new Date(date);
    const options = {
        year: "numeric",
        month: "long",
        day: "numeric"
    };
    return d.toLocaleDateString(currentLocale, options);
};
const downloadArticle = async function() {
    let url = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, successCallback = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ()=>{}, downloadSuccess = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", downloadFailure = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "";
    const { target: { classList: targetClassList = {}  } = {}  } = e;
    try {
        targetClassList === null || targetClassList === void 0 ? void 0 : targetClassList.add(constants.DOWNLOAD_SPINNER);
        const { status , data , headers  } = await api/* apim.get */.TH.get("catalog/pdf-file-download?page=".concat(url), {
            responseType: "blob"
        });
        if (status === 200) {
            let filenameVal;
            if (headers["content-disposition"]) {
                const { parameters: { filename =""  } = {}  } = content_disposition_default().parse(headers["content-disposition"]);
                filenameVal = filename;
            } else {
                filenameVal = "zip";
            }
            file_download_default()(data, filenameVal);
            typeof successCallback === "function" && successCallback();
            store_0/* store.dispatch */.h.dispatch((0,genericSlice/* showToast */.CF)({
                message: downloadSuccess,
                isVisible: true
            }));
            targetClassList === null || targetClassList === void 0 ? void 0 : targetClassList.remove(constants.DOWNLOAD_SPINNER);
        } else {
            store_0/* store.dispatch */.h.dispatch((0,genericSlice/* showToast */.CF)({
                message: downloadFailure,
                isVisible: true
            }));
            targetClassList === null || targetClassList === void 0 ? void 0 : targetClassList.remove(constants.DOWNLOAD_SPINNER);
        }
    } catch (ex) {
        targetClassList === null || targetClassList === void 0 ? void 0 : targetClassList.remove(constants.DOWNLOAD_SPINNER);
        store_0/* store.dispatch */.h.dispatch((0,genericSlice/* showToast */.CF)({
            message: downloadFailure,
            isVisible: true
        }));
    }
};
const getAppliedSortPressKit = (i18n, query)=>{
    switch(query){
        case "navTitle_s+asc":
            return i18n.sortByAsc;
        case "navTitle_s+desc":
            return i18n.sortByDesc;
        case "pressReleaseDate_dt+desc":
            return i18n.sortByNewest;
        case "pressReleaseDate_dt+asc":
            return i18n.sortByOldest;
    }
    return null;
};
// Function will scroll to a particular element
const scrollToElement = (element)=>{
    element.current.scrollIntoView({
        behavior: "smooth",
        block: "end",
        inline: "nearest"
    });
};
// function to get offsetTop
const getOffsetTop = (element)=>{
    let offsetTop = 0;
    while(element){
        offsetTop += element.offsetTop;
        element = element.offsetParent;
    }
    return offsetTop;
};
// Function to check part page or not
const isPartsPage = (url)=>{
    const urls = url === null || url === void 0 ? void 0 : url.split("?");
    let isPart = false;
    if ((urls === null || urls === void 0 ? void 0 : urls.length) && urls[1]) {
        isPart = url === null || url === void 0 ? void 0 : url.includes("type=part");
    } else {
        isPart = url === null || url === void 0 ? void 0 : url.includes("/support/");
    }
    return isPart;
};
const getPdpUrlParams = ()=>{
    const url = new URL(window.location.href);
    const searchParams = url.searchParams;
    const skuNumber = searchParams.get("skuNumber");
    const skuId = searchParams.get("skuId");
    if (skuNumber || skuId) {
        skuNumber ? searchParams.set("skuNumber", skuNumber) : searchParams.set("skuId", skuId);
        const query = "?" + searchParams.toString();
        return query;
    }
    return null;
};
const getUpSellDataByRecursion = (data)=>{
    var ref;
    let upSellContainerData = {};
    if ((ref = data[":itemsOrder"]) === null || ref === void 0 ? void 0 : ref.length) {
        let isContainerMatched = false;
        let item = {};
        for(let i = 0; i < data[":itemsOrder"].length; i++){
            var ref1;
            const key = data[":itemsOrder"][i];
            item = data[":items"][key];
            if ((0,utils/* isUpSellContainer */._4)(item)) {
                upSellContainerData = item;
                isContainerMatched = true;
                break;
            }
            if (Object.hasOwn(item, ":itemsOrder") && ((ref1 = item[":itemsOrder"]) === null || ref1 === void 0 ? void 0 : ref1.length)) {
                for(let j = 0; j < item[":itemsOrder"].length; j++){
                    const innerKey = item[":itemsOrder"][j];
                    if (Object.hasOwn(item[":items"][innerKey], ":itemsOrder")) {
                        item = item[":items"][innerKey];
                        if ((0,utils/* isUpSellContainer */._4)(item)) {
                            upSellContainerData = item;
                            isContainerMatched = true;
                            break;
                        }
                    }
                }
                if (isContainerMatched) break;
            }
        }
        if (!isContainerMatched) return getUpSellDataByRecursion(item);
        return upSellContainerData;
    }
    return upSellContainerData;
};
const getUpSellAuthData = function() {
    let data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, isRequireToLookupFullData = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var ref, ref1, ref2, ref3, ref4, ref5;
    let upSellAuthData = {};
    if (isEmpty_default()(data)) return {};
    let upSellContainerData = data;
    if (isRequireToLookupFullData) {
        upSellContainerData = getUpSellDataByRecursion(data);
    }
    const { searchLabelUpSell , zipUpdateLabelUpSell , zipChangeLabelUpSell , zipLabelUpSell , userTitleUpSell  } = upSellContainerData;
    const headerAuthData = {
        searchLabelUpSell,
        zipUpdateLabelUpSell,
        zipChangeLabelUpSell,
        zipLabelUpSell,
        userTitleUpSell
    };
    var ref6;
    const productCard = (ref6 = (ref = upSellContainerData[":items"]) === null || ref === void 0 ? void 0 : (ref1 = ref["container"]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[":items"]) === null || ref2 === void 0 ? void 0 : ref2["productcard_v4"]) !== null && ref6 !== void 0 ? ref6 : {};
    var ref7;
    const serviceData = (ref7 = (ref3 = upSellContainerData[":items"]) === null || ref3 === void 0 ? void 0 : ref3["up_sell_services"]) !== null && ref7 !== void 0 ? ref7 : {};
    const itemsTabs = (ref4 = upSellContainerData[":items"]) === null || ref4 === void 0 ? void 0 : (ref5 = ref4["up_sell_tabs"]) === null || ref5 === void 0 ? void 0 : ref5[":items"];
    const tabs = [];
    const tabsData = {};
    if (!isEmpty_default()(itemsTabs)) {
        for(const tabKey in itemsTabs){
            if (Object.prototype.hasOwnProperty.call(itemsTabs, tabKey)) {
                const panelTitle = itemsTabs[tabKey]["cq:panelTitle"].toLowerCase();
                tabs.push(panelTitle);
                tabsData[panelTitle] = itemsTabs[tabKey][":items"]["up_sell_services"];
            }
        }
    }
    const upSellServiceData = tabsData.length ? tabsData["services"] : serviceData;
    upSellAuthData = {
        headerAuthData,
        tabs,
        tabsData,
        productCard,
        upSellServiceData
    };
    return upSellAuthData;
};
const isUrlIncludeHttp = (url)=>{
    if (url) {
        return url.indexOf("http") !== -1;
    } else {
        return false;
    }
};
const getInternalLinkTypeForFindStore = function(store, city, state, name) {
    let isLocationPage = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
    const storeName = sanitizeTextForAnalytics(store);
    const cityName = sanitizeTextForAnalytics(city);
    const stateName = sanitizeTextForAnalytics(state);
    const micrositeName = sanitizeTextForAnalytics(name);
    if (isLocationPage) return "".concat(storeName, ":").concat(cityName, ":").concat(stateName);
    return "".concat(micrositeName, ":").concat(cityName, ":").concat(stateName);
};
const getProcessedProductInfoBasedOnLineItems = async (lineItems)=>{
    var ref;
    const config = await (0,constants_config/* getConfig */.i)();
    const locale = get_default()(config, "internationalization.locale", "");
    const brandName = (ref = get_default()(config, "general.siteName", "")) === null || ref === void 0 ? void 0 : ref.toLowerCase();
    const currency = get_default()(config, "internationalization.currencyCode", "usd");
    const currencySign = get_default()(config, "internationalization.currencySign", "$");
    const { general: { lwAppName =""  } = {}  } = config !== null && config !== void 0 ? config : {};
    const productItems = lineItems.map((item)=>{
        var ref, ref1, ref2, ref3, ref4, ref5;
        var ref6;
        let discountPrice = (ref6 = item === null || item === void 0 ? void 0 : item.discountPrice) !== null && ref6 !== void 0 ? ref6 : 0;
        if ((ref = item.price) === null || ref === void 0 ? void 0 : ref.discounted) {
            discountPrice = (Number(get_default()(item.price.discounted, "value.centAmount", 0)) / 100).toFixed(2);
        }
        if (item.discountedPrice) {
            discountPrice = (Number(get_default()(item.discountedPrice, "value.centAmount", 0)) / 100).toFixed(2);
        }
        const discountedPricePerQuantity = (Number(get_default()((ref2 = item === null || item === void 0 ? void 0 : (ref1 = item.discountedPrice) === null || ref1 === void 0 ? void 0 : ref1.includedDiscounts[0]) === null || ref2 === void 0 ? void 0 : ref2.discountedAmount, "centAmount", 0)) / 100).toFixed(2);
        var ref7;
        const attributes = (ref7 = (ref3 = item.variant) === null || ref3 === void 0 ? void 0 : ref3.attributes) !== null && ref7 !== void 0 ? ref7 : [];
        const productSection = get_default()(attributes.find((attr)=>attr.name === "ProductSection"), "value", null);
        let productRoom = "";
        if (productSection && productSection[0] && productSection[0][locale]) {
            productRoom = productSection[0][locale];
        }
        return {
            id: get_default()(item, "id", ""),
            sku: get_default()(item, "variant.sku", ""),
            customerFacingSKU: getAttributeValue(attributes, "CustomerFacingSKU"),
            productRoom: productRoom,
            slug: get_default()(item, "productSlug[".concat(locale, "]"), ""),
            quantity: get_default()(item, "quantity", 0),
            image: get_default()(item, "variant.images[0].url", ""),
            category: getAttributeValue(attributes, "ProductLocalCategory"),
            brand: getAttributeValue(attributes, "CustomerFacingBrand"),
            associatedServices: getAssociatedServices(attributes),
            currencySign,
            name: get_default()(attributes.find((attr)=>attr.name === "RegionBrandName"), "value", get_default()(item, "name[".concat(locale, "]"), "")),
            desc: get_default()(attributes.find((attr)=>attr.name === "ProductDescriptionProductShort"), "value[".concat(locale, "]"), get_default()(attributes.find((attr)=>attr.name === "ProductDescriptionProduct"), "value", "")),
            color: get_default()(attributes.find((attr)=>attr.name === "SKUColorFinishName"), "value[".concat(locale, "]"), ""),
            unitPrice: typeof item.unitPrice === "string" ? item.unitPrice : (Number(get_default()(item, "price.value.centAmount", 0)) / 100).toFixed(2),
            totalPrice: typeof item.totalPrice === "string" ? item.totalPrice : (Number(get_default()(item, "totalPrice.centAmount", 0)) / 100).toFixed(2),
            discountPrice: discountPrice,
            discountedPricePerQuantity: discountedPricePerQuantity,
            isComboSku: attributes.find((attr)=>attr.name === "ComboSKU") ? true : false,
            backOrder: get_default()(item, "custom.fields.isBackOrderable", false),
            businessUnitName: get_default()(attributes.find((attr)=>attr.name === "SPProductBusinessUnit"), "value", ""),
            additionalData: brandName === "annsacks" && (item === null || item === void 0 ? void 0 : (ref4 = item.custom) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.fields) === null || ref5 === void 0 ? void 0 : ref5.roomInfo) ? get_default()(item, "custom.fields", "") : "",
            discountsList: [],
            productCollectionsName: getAttributeValue(attributes, "ProductBrandNameDisplay") || getAttributeValue(attributes, "ProductBrandNameDisplay_t"),
            addedAt: get_default()(item, "addedAt", "")
        };
    });
    return {
        productItems,
        brandName,
        currency,
        lwAppName
    };
};
const jsonStringEscape = (jsonString)=>{
    return jsonString.replace(/\n|\t|\r|\&|\'/g, (m)=>{
        switch(m){
            case "\n":
            case "\r":
            case "	":
            case "\b":
            case "\f":
                return "";
            case "&":
                return "&amp;";
            case "'":
                return "&#8217;";
            default:
                return;
        }
    });
};
const replaceAndFunction = (str)=>{
    return str === null || str === void 0 ? void 0 : str.replace("&", "%26");
};
const getBadgeValue = (key, arry)=>{
    const badgeInfo = arry.find((item)=>item.map.Key === key);
    const { map: { Key ="" , Values: { myArrayList: badgeValue = []  } = {}  } = {}  } = badgeInfo;
    var ref;
    return {
        key: Key,
        value: (ref = badgeValue[0]) !== null && ref !== void 0 ? ref : ""
    };
};
const pushAnalyticsObjToDataLayer = async function() {
    let eventInfo = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, event = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "cmp:click", modifiedPageObj = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, customDataLayer = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    var ref, ref1;
    let page = window.pageObj || {};
    if (!isEmpty_default()(modifiedPageObj)) {
        page = modifiedPageObj;
    }
    const cartObj = (ref = store_0/* store */.h === null || store_0/* store */.h === void 0 ? void 0 : store_0/* store.getState */.h.getState()) === null || ref === void 0 ? void 0 : (ref1 = ref.cart) === null || ref1 === void 0 ? void 0 : ref1.cart;
    if (cartObj) {
        const { cart  } = await calculateCartData({
            cart: cartObj
        }, true);
        page.cart = cart;
    }
    const datalayerObj = !isEmpty_default()(eventInfo) ? {
        event,
        eventInfo,
        page
    } : {
        event,
        page
    };
    if (!isEmpty_default()(customDataLayer)) {
        for(const key in customDataLayer){
            if (Object.hasOwn(customDataLayer, key)) {
                datalayerObj[key] = customDataLayer[key];
            }
        }
    }
    window.adobeDataLayer.push(datalayerObj);
};
const removeMavenoidChat = ()=>{
    var ref, ref1;
    return (ref = document.querySelector("mavenoid-assistant")) === null || ref === void 0 ? void 0 : (ref1 = ref.classList) === null || ref1 === void 0 ? void 0 : ref1.add("mavenoid-remove");
};
const addMavenoidChat = ()=>{
    var ref, ref1;
    return (ref = document.querySelector("mavenoid-assistant")) === null || ref === void 0 ? void 0 : (ref1 = ref.classList) === null || ref1 === void 0 ? void 0 : ref1.remove("mavenoid-remove");
};
const hasNumber = (str)=>{
    return /\d/.test(str);
};
const generateCanonicalUrl = (url, locale, host)=>{
    if (url) {
        if ((url === null || url === void 0 ? void 0 : url.includes(".json")) && "object" !== "undefined") {
            return window.location.href;
        }
        var ref;
        const canonicalUrl = (ref = url.split("?")[0]) !== null && ref !== void 0 ? ref : url;
        if (locale === "fr") {
            return "".concat(host === null || host === void 0 ? void 0 : host.substring(0, host.length - 2)).concat(locale).concat(canonicalUrl);
        } else {
            return "".concat(host).concat(canonicalUrl);
        }
    }
    return "";
};
const updateAnalyticPageUrl = (data, url)=>{
    if (data) {
        const parsedData = JSON.parse(data);
        parsedData.pageInfo.pageUrl = url;
        const analyticsData = JSON.stringify(parsedData);
        return analyticsData;
    }
    return "";
};
const sortParameterURL = ()=>{
    const url = new URL(window.location.href);
    var ref;
    const appliedSort = (ref = url.searchParams.get("sort")) !== null && ref !== void 0 ? ref : "";
    return appliedSort === null || appliedSort === void 0 ? void 0 : appliedSort.split(" ").join("+");
};
// Below util helper (removePathandHtml) is created especially when shortened URL is needed from getserversideprops function.
const removePathandHtml = function() {
    let url = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    if (url) {
        const { shortendPagePath =""  } = redirectsData !== null && redirectsData !== void 0 ? redirectsData : {};
        const htmlRemovedUrl = url === null || url === void 0 ? void 0 : url.replace(".html", "");
        const pathRemovedUrl = htmlRemovedUrl === null || htmlRemovedUrl === void 0 ? void 0 : htmlRemovedUrl.replace(shortendPagePath, "");
        return pathRemovedUrl;
    }
    return null;
};
const performRedirect = function() {
    let url = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", locale = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    let redirectUrl;
    let redirectType;
    const urlWithLocale = "/".concat(locale).concat(url);
    Object.keys(redirectsData).forEach((key)=>{
        if (redirectsData[key][url]) {
            redirectUrl = redirectsData[key][url];
            redirectType = key;
        } else if (redirectsData[key][urlWithLocale]) {
            redirectUrl = redirectsData[key][urlWithLocale];
            redirectType = key;
        }
    });
    if (redirectUrl) {
        redirectUrl = removePathandHtml(redirectUrl);
        return {
            redirectUrl,
            url,
            redirectType
        };
    }
    return null;
};
const getPureText = (str)=>{
    return str.replace(constants_regex/* PURE_TEXT_REGEX */.AP, "");
};
const isPriceZero = (price)=>price === "0.00" || price === 0;
const toastMsg = (msg)=>store_0/* store.dispatch */.h.dispatch((0,genericSlice/* showToast */.CF)({
        message: msg,
        isVisible: true
    }));
const addMediaToFavorites = function() {
    let type = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", url = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", successMsg = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", errMsg = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "", internalLinkType = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : "", sharedZoneName = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : "", videoName = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : "", videoId = arguments.length > 8 && arguments[8] !== void 0 ? arguments[8] : "";
    isAuthenticated(()=>store_0/* store.dispatch */.h.dispatch((0,favoritesSlice/* addMedia */.rA)({
            type,
            name,
            url,
            errMsg,
            internalLinkType,
            sharedZoneName,
            videoName,
            videoId,
            successCallback: ()=>toastMsg(successMsg)
        })));
};
const removeFavorites = (ids, favEle, removemsg)=>{
    isAuthenticated(()=>store_0/* store.dispatch */.h.dispatch((0,favoritesSlice/* removeItems */.Er)(ids)).unwrap().then(()=>{
            favEle.current.removeAttribute("data-id");
            favEle.current.classList.remove("favorite-filled");
            toastMsg(removemsg);
        }));
};
const organizeData = function() {
    let data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], placeHolder = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", type = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", idVal = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "";
    return data.map((item, i)=>{
        let obj = {
            title: name.length ? name[i] : "".concat(placeHolder, " ").concat(data.length > 1 ? i + 1 : "")
        };
        if (idVal) {
            obj.id = idVal + "-" + i;
        }
        if (type === "PART") {
            obj = {
                ...obj,
                id: item
            };
        } else {
            obj = {
                ...obj,
                type,
                url: item
            };
        }
        return obj;
    });
};
const getAnalyticsFileName = (file)=>{
    const { actualName ="" , title ="" , type =""  } = file;
    const fileName = actualName || sanitizeTextForAnalytics("".concat(title === null || title === void 0 ? void 0 : title.trim(), ".").concat(type));
    return fileName;
};
const getPresetUrl = function() {
    let width = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, swatchUrl = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", image = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", presetConfigs = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, scene7AccountName = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "";
    const { Desktop ="" , MobileLandscape ="" , MobilePortrait ="" , PotraitCategory =""  } = presetConfigs;
    const assetId = image.split("/").pop();
    const scene7Url = swatchUrl === null || swatchUrl === void 0 ? void 0 : swatchUrl.replace("PAWEB/", "");
    let preset = Desktop;
    if (width >= 1024) {
        preset = Desktop;
    } else if (width < 1024 && width >= 768) {
        preset = MobileLandscape;
    } else if (width < 768) {
        preset = MobilePortrait;
    }
    return "".concat(scene7Url).concat(scene7AccountName, "/").concat(PotraitCategory, "?$product_src=is{").concat(scene7AccountName, "/").concat(assetId, "}&").concat(preset);
};
const recalculateCartRoomInfo = (lineItemId, product)=>{
    const actions = [];
    if (product === null || product === void 0 ? void 0 : product.roomInfo) {
        actions.push({
            action: "setLineItemCustomField",
            lineItemId: lineItemId,
            name: "roomInfo",
            value: [
                '{"productType":"' + (product === null || product === void 0 ? void 0 : product.productType) + '","totalNeeded":"' + (product === null || product === void 0 ? void 0 : product.totalNeeded) + '","totalUserNeeded":"' + (product === null || product === void 0 ? void 0 : product.totalUserNeeded) + '","totalSFUserNeeded":"' + (product === null || product === void 0 ? void 0 : product.totalSFUserNeeded) + '","totalArea":"' + (product === null || product === void 0 ? void 0 : product.totalArea) + '","soldByBox":"' + (product === null || product === void 0 ? void 0 : product.soldByBox) + '","soldByUom":"' + (product === null || product === void 0 ? void 0 : product.soldByUom) + '"}'
            ]
        }, {
            action: "setLineItemCustomField",
            lineItemId: lineItemId,
            name: "customQuantity",
            value: (product === null || product === void 0 ? void 0 : product.soldByBox) ? Number((product === null || product === void 0 ? void 0 : product.customQuantity) * (product === null || product === void 0 ? void 0 : product.soldByBox)) : product === null || product === void 0 ? void 0 : product.customQuantity
        }, {
            action: "setLineItemCustomField",
            lineItemId: lineItemId,
            name: "totalUOM",
            value: "".concat(product === null || product === void 0 ? void 0 : product.totalArea)
        }, {
            action: "setLineItemCustomField",
            lineItemId: lineItemId,
            name: "overage",
            value: product === null || product === void 0 ? void 0 : product.overage
        }, {
            action: "changeLineItemQuantity",
            lineItemId: lineItemId,
            quantity: product === null || product === void 0 ? void 0 : product.customQuantity
        });
    } else {
        actions.push({
            action: "setLineItemCustomField",
            lineItemId: lineItemId,
            name: "customQuantity",
            value: product === null || product === void 0 ? void 0 : product.quantity
        }, {
            action: "changeLineItemQuantity",
            lineItemId: lineItemId,
            quantity: product === null || product === void 0 ? void 0 : product.quantity
        });
    }
    try {
        api/* apim.post */.TH.post("/cart/v2/items?expand=calculation", {
            actions: actions
        }).then((response)=>{
            store_0/* store.dispatch */.h.dispatch((0,cartSlice/* setCart */.RV)(response.data));
            store_0/* store.dispatch */.h.dispatch((0,cartSlice/* setCartCount */.oJ)((0,helperV2/* getQuantityCount */.PW)(response.data.lineItems)));
            store_0/* store.dispatch */.h.dispatch((0,cartSlice/* setQtyLoading */.LR)(false));
        }).catch((err)=>{
            // eslint-disable-next-line no-console
            console.log(err);
        });
    } catch (err) {
        // eslint-disable-next-line no-console
        console.log(err);
    }
};
const checkIfImageExists = (url, callback)=>{
    const img = new Image();
    img.src = url;
    if (img.complete) {
        callback(true);
    } else {
        img.onload = ()=>{
            callback(true);
        };
        img.onerror = ()=>{
            callback(false);
        };
    }
};
const getLinkFromHref = (htmlString)=>{
    let link = htmlString.match(/href="([^"]*)"/);
    link = link ? link[1] : "";
    if ( true && link.indexOf("https") === -1) {
        link = window.location.href + link;
    }
    return link;
};
const isCanadaSite = (siteName)=>siteName && siteName.trim().toLocaleLowerCase() === "kohler-canada";
const getProductStatus = function() {
    let discontinued = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, backorder = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", inStock = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    const productStatus = discontinued ? "discontinued" : backorder === "Yes" ? "backorder" : inStock ? "in stock" : "out of stock";
    return productStatus;
};
const getLangCode = (config)=>{
    var ref, ref1, ref2;
    const locale = config === null || config === void 0 ? void 0 : (ref = config.internationalization) === null || ref === void 0 ? void 0 : (ref1 = ref.locale) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase();
    const languageName = (ref2 = "EN") === null || ref2 === void 0 ? void 0 : ref2.toLowerCase();
    const result = (locale === null || locale === void 0 ? void 0 : locale.includes(languageName)) ? constants.LOCALE_ENGLISH.toLowerCase() : locale;
    return result;
};
const getIsNameDuplicate = (value, listNameValidationList)=>{
    return listNameValidationList.map((name)=>{
        return name === null || name === void 0 ? void 0 : name.toUpperCase();
    }).includes(value === null || value === void 0 ? void 0 : value.toUpperCase());
};
const getIsSystemDefinedName = (value)=>{
    return [
        "MYPRODUCTS",
        "MYSERVICES",
        "MESSERVICES"
    ].includes(value === null || value === void 0 ? void 0 : value.toUpperCase());
};
const geMonthNameDayandYear = function(dateStr) {
    let locale = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "en-US";
    const date = new Date(dateStr);
    const month = locale === "en-US" || locale === "en-CA" ? constants.MONTH_NAMES_EN[date.getMonth()] : constants.MONTH_NAMES_FR[date.getMonth()];
    return "".concat(month, " ").concat(date.getDate(), ", ").concat(date.getFullYear());
};
const getUserCreatedLists = (response, locale, moveOrDeleteFromListName)=>{
    const lists = [];
    const listNames = [];
    response.sort((a, b)=>{
        return new Date(b === null || b === void 0 ? void 0 : b.lastModifiedAt) - new Date(a === null || a === void 0 ? void 0 : a.lastModifiedAt);
    }).forEach((list)=>{
        if ((list === null || list === void 0 ? void 0 : list.name[locale]) !== moveOrDeleteFromListName) {
            lists.push({
                name: list === null || list === void 0 ? void 0 : list.name[locale],
                id: list === null || list === void 0 ? void 0 : list.id,
                version: list === null || list === void 0 ? void 0 : list.version
            });
            listNames.push(list === null || list === void 0 ? void 0 : list.name[locale]);
        }
    });
    return {
        lists: lists,
        listNames: listNames
    };
};
const getProductFlgs = (persona)=>{
    return [
        "masterSKU_s",
        "SKUColorSwatchFilename_ss",
        "ProductDescriptionProductShort_s",
        "ProductBrandName_s",
        "metaTitle_s",
        "productName_s",
        "id",
        "productImages.url_ss",
        "slug_s",
        "Product_Category",
        "displayPriceStartingAt_s",
        "Tile_Title",
        "ProductIsExclusive_s",
        "RegionReleaseforShipment_dt",
        "Color.SKU.Details_ss",
        "productImages.labelWithUrl_ss",
        "variantList.sku_ss",
        "RegionBrandName_s",
        "priceList.".concat(persona, ".discountedPrice_d"),
        "priceList.".concat(persona, ".saleOffer_s"),
        "priceList.".concat(persona, ".finalPrice_d"),
        "priceList.".concat(persona, ".price_d"),
        "Color.".concat(persona, ".Details_ss"),
        "ctId_s",
        "Brand_ss",
        "Country_ss"
    ];
};
const extractPhoneNumber = (htmlString)=>{
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, "text/html");
    const anchor = doc.querySelector('a[href^="tel:"]');
    return anchor ? anchor.getAttribute("href").replace("tel:", "") : null;
};
const getQuickViewAuth = function() {
    let data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var ref, ref1, ref2;
    if (isEmpty_default()(data)) return {};
    var ref3;
    const quickViewAuthData = (ref3 = (ref = data[":items"]) === null || ref === void 0 ? void 0 : (ref1 = ref["root"]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[":items"]) === null || ref2 === void 0 ? void 0 : ref2["pdp_quick_view"]) !== null && ref3 !== void 0 ? ref3 : {};
    return quickViewAuthData;
};
const processColorDetails = function() {
    let colorDetails = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return colorDetails.map((color)=>{
        const [name, swatch, sku, isStock, isDiscontinued, customerFacingSKU] = color.split("|");
        return {
            name,
            swatch,
            sku,
            isStock,
            isDiscontinued,
            customerFacingSKU
        };
    });
};
const processSwatchData = function() {
    let colorProducts = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    const swatchPairs = colorProducts.map((product)=>{
        const swatches = get_default()(product, "swatch", "");
        const swatchNames = get_default()(product, "name", "");
        return [
            swatches,
            swatchNames
        ];
    });
    return swatchPairs.filter((pair)=>pair.every(Boolean));
};
const getProductImageUrl = function() {
    let productVariantImages = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sku = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", fallbackImage = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : image_missing/* default */.Z;
    const variantImages = productVariantImages.filter((img)=>sku === img.split("|")[0]);
    if (!variantImages.length) {
        return fallbackImage;
    }
    const img = variantImages[0].split("|");
    var ref;
    return (ref = img[img.length - 1]) !== null && ref !== void 0 ? ref : fallbackImage;
};
const getSearchDataLayerDetails = (searchResultDataLayerObj)=>{
    if (!searchResultDataLayerObj || typeof searchResultDataLayerObj !== "object" || Object.keys(searchResultDataLayerObj).length === 0) {
        return {};
    }
    const currDate = new Date();
    return {
        searchCount: Number(sessionStorage.getItem("searches")) || 1,
        searchResult: searchResultDataLayerObj === null || searchResultDataLayerObj === void 0 ? void 0 : searchResultDataLayerObj.searchResult,
        searchTerm: searchResultDataLayerObj === null || searchResultDataLayerObj === void 0 ? void 0 : searchResultDataLayerObj.searchTerm,
        searchSuggestedTerm: "n/a",
        timeStamp: (currDate === null || currDate === void 0 ? void 0 : currDate.toISOString().split("T")[0]) + " " + (currDate === null || currDate === void 0 ? void 0 : currDate.toTimeString().split(" ")[0]),
        ...(searchResultDataLayerObj === null || searchResultDataLayerObj === void 0 ? void 0 : searchResultDataLayerObj.searchResultCategoryType) ? {
            searchResultCategory: "".concat(searchResultDataLayerObj === null || searchResultDataLayerObj === void 0 ? void 0 : searchResultDataLayerObj.searchResultCategoryType, ">").concat(searchResultDataLayerObj === null || searchResultDataLayerObj === void 0 ? void 0 : searchResultDataLayerObj.searchResultCategoryTypeCount)
        } : {}
    };
};



/***/ }),

/***/ 20558:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$H": function() { return /* binding */ findStoreUtilNavselectQuery; },
/* harmony export */   "A9": function() { return /* binding */ isHeaderNavV3; },
/* harmony export */   "Ac": function() { return /* binding */ onImageError; },
/* harmony export */   "Ar": function() { return /* binding */ isCheckoutLanding; },
/* harmony export */   "BB": function() { return /* binding */ getPresetThumbnailUrl; },
/* harmony export */   "Be": function() { return /* binding */ isCompareProducts; },
/* harmony export */   "Bq": function() { return /* binding */ affirmRefresh; },
/* harmony export */   "C2": function() { return /* binding */ isCarousel; },
/* harmony export */   "C_": function() { return /* binding */ isNewsLetter; },
/* harmony export */   "DD": function() { return /* binding */ parseToBoolean; },
/* harmony export */   "DN": function() { return /* binding */ isProductcardV3; },
/* harmony export */   "Dx": function() { return /* binding */ isMyproducts; },
/* harmony export */   "EE": function() { return /* binding */ isImageV3; },
/* harmony export */   "Er": function() { return /* binding */ isGatedContent; },
/* harmony export */   "F0": function() { return /* binding */ isAssociateMembership; },
/* harmony export */   "GX": function() { return /* binding */ isPressLanding; },
/* harmony export */   "Gs": function() { return /* binding */ isText; },
/* harmony export */   "Gz": function() { return /* binding */ getShippingData; },
/* harmony export */   "HD": function() { return /* binding */ isString; },
/* harmony export */   "HR": function() { return /* binding */ isTechnicalSpec; },
/* harmony export */   "Hx": function() { return /* binding */ isProductList; },
/* harmony export */   "K0": function() { return /* binding */ isOrderStatus; },
/* harmony export */   "Kn": function() { return /* binding */ isObject; },
/* harmony export */   "L": function() { return /* binding */ isRegisterOnline; },
/* harmony export */   "L8": function() { return /* binding */ isInPageSearch; },
/* harmony export */   "LV": function() { return /* binding */ isProductCardV4; },
/* harmony export */   "Lg": function() { return /* binding */ isDynamicSearch; },
/* harmony export */   "M0": function() { return /* binding */ accordionUniqueId; },
/* harmony export */   "M2": function() { return /* binding */ ConditionalWrapper; },
/* harmony export */   "M6": function() { return /* binding */ getSanitizeNumber; },
/* harmony export */   "MN": function() { return /* binding */ isBrowseAllStores; },
/* harmony export */   "MW": function() { return /* binding */ isSpacer; },
/* harmony export */   "Mc": function() { return /* binding */ isKnowledgeArticle; },
/* harmony export */   "N": function() { return /* binding */ isSearch; },
/* harmony export */   "NF": function() { return /* binding */ getIsSameAddress; },
/* harmony export */   "Nm": function() { return /* binding */ isContainer; },
/* harmony export */   "OL": function() { return /* binding */ isContactUs; },
/* harmony export */   "Om": function() { return /* binding */ getPdpRedirectUrl; },
/* harmony export */   "Or": function() { return /* binding */ isImage; },
/* harmony export */   "Ov": function() { return /* binding */ isStoreFilter; },
/* harmony export */   "P2": function() { return /* binding */ isEmbed; },
/* harmony export */   "Qe": function() { return /* binding */ recursiveDataFunction; },
/* harmony export */   "RU": function() { return /* binding */ isVisualNav; },
/* harmony export */   "S": function() { return /* binding */ isAuthModal; },
/* harmony export */   "Si": function() { return /* binding */ isChangePassword; },
/* harmony export */   "Tg": function() { return /* binding */ formatAddress; },
/* harmony export */   "Tk": function() { return /* binding */ isImageCluster; },
/* harmony export */   "U2": function() { return /* binding */ isFindAProResults; },
/* harmony export */   "U4": function() { return /* binding */ isMyservice; },
/* harmony export */   "Ui": function() { return /* binding */ getBillingAsShippingAddress; },
/* harmony export */   "Uq": function() { return /* binding */ isOrderConfirmation; },
/* harmony export */   "V6": function() { return /* binding */ isProductExfPdp; },
/* harmony export */   "VV": function() { return /* binding */ isPDPCuratedProducts; },
/* harmony export */   "Vw": function() { return /* binding */ handleViewSterlingResults; },
/* harmony export */   "Wt": function() { return /* binding */ isTitle; },
/* harmony export */   "Wv": function() { return /* binding */ isVideo; },
/* harmony export */   "X7": function() { return /* binding */ isRoomDetail; },
/* harmony export */   "Y5": function() { return /* binding */ isProfessionalDetail; },
/* harmony export */   "Z3": function() { return /* binding */ isBreadcrumb; },
/* harmony export */   "ZS": function() { return /* binding */ isHeaderNav; },
/* harmony export */   "_": function() { return /* binding */ isInspireVideo; },
/* harmony export */   "_$": function() { return /* binding */ isOrderHistory; },
/* harmony export */   "_4": function() { return /* binding */ isUpSellContainer; },
/* harmony export */   "_H": function() { return /* binding */ isFindStore; },
/* harmony export */   "_h": function() { return /* binding */ isProductSlider; },
/* harmony export */   "a4": function() { return /* binding */ isValidPostalCode; },
/* harmony export */   "bU": function() { return /* binding */ alterClass; },
/* harmony export */   "bd": function() { return /* binding */ isSlick; },
/* harmony export */   "bu": function() { return /* binding */ isToaster; },
/* harmony export */   "cD": function() { return /* binding */ isBrandHeader; },
/* harmony export */   "ck": function() { return /* binding */ isShopTheRoomCard; },
/* harmony export */   "cl": function() { return /* binding */ isFooter; },
/* harmony export */   "e1": function() { return /* binding */ getOrderDetailsUrl; },
/* harmony export */   "e7": function() { return /* binding */ isPromoBanner; },
/* harmony export */   "ek": function() { return /* binding */ isLiterature; },
/* harmony export */   "eo": function() { return /* binding */ mapCollapsedSku; },
/* harmony export */   "eq": function() { return /* binding */ isProductAccordion; },
/* harmony export */   "f5": function() { return /* binding */ isNewsLetterSignUp; },
/* harmony export */   "fN": function() { return /* binding */ getExtention; },
/* harmony export */   "gd": function() { return /* binding */ isFindAProByZip; },
/* harmony export */   "hH": function() { return /* binding */ getShippingAllTotal; },
/* harmony export */   "hn": function() { return /* binding */ isRegisterOffline; },
/* harmony export */   "iL": function() { return /* binding */ isFindingModelNumber; },
/* harmony export */   "j$": function() { return /* binding */ isTeaser; },
/* harmony export */   "jM": function() { return /* binding */ isFriendsAndFamily; },
/* harmony export */   "jS": function() { return /* binding */ isProductDetails; },
/* harmony export */   "kp": function() { return /* binding */ isInstallDesignServices; },
/* harmony export */   "l1": function() { return /* binding */ isCartLanding; },
/* harmony export */   "mI": function() { return /* binding */ isShopTheRoomLandingPage; },
/* harmony export */   "mg": function() { return /* binding */ isAccountSettings; },
/* harmony export */   "n": function() { return /* binding */ getRowCols; },
/* harmony export */   "nK": function() { return /* binding */ isObjectEmpty; },
/* harmony export */   "np": function() { return /* binding */ isAemForm; },
/* harmony export */   "nq": function() { return /* binding */ isList; },
/* harmony export */   "o4": function() { return /* binding */ getBrandSwitcher; },
/* harmony export */   "oC": function() { return /* binding */ isPairsWellWth; },
/* harmony export */   "oq": function() { return /* binding */ closest; },
/* harmony export */   "ph": function() { return /* binding */ isShopTheRoomDetail; },
/* harmony export */   "po": function() { return /* binding */ isProductcard; },
/* harmony export */   "pv": function() { return /* binding */ isOrderDetails; },
/* harmony export */   "qV": function() { return /* binding */ getPayPalPaymentIdFromParams; },
/* harmony export */   "rp": function() { return /* binding */ getCountryStatesList; },
/* harmony export */   "s3": function() { return /* binding */ isProductReview; },
/* harmony export */   "sL": function() { return /* binding */ isSharedCart; },
/* harmony export */   "uW": function() { return /* binding */ updateMetaContent; },
/* harmony export */   "v$": function() { return /* binding */ getPresetUrl; },
/* harmony export */   "wR": function() { return /* binding */ isTab; },
/* harmony export */   "we": function() { return /* binding */ isMyFavorites; },
/* harmony export */   "wq": function() { return /* binding */ sanitizedTextAndEntities; },
/* harmony export */   "xA": function() { return /* binding */ isStoreAppointment; },
/* harmony export */   "yd": function() { return /* binding */ isSiteWideWarning; },
/* harmony export */   "z9": function() { return /* binding */ isKeySpecifier; },
/* harmony export */   "zK": function() { return /* binding */ isHelpSupport; },
/* harmony export */   "zj": function() { return /* binding */ getSanitizedFloatingNumber; },
/* harmony export */   "zm": function() { return /* binding */ removeExtraSpaces; }
/* harmony export */ });
/* unused harmony exports getUniqueObjectListBy, isLeadGeneration, getSkusQuery, isTeaserContainer, isglobalNavV3 */
/* harmony import */ var _public_images_image_missing_png__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36513);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96301);
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19514);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88032);
/* harmony import */ var _constants_regex__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(49139);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(55760);
/* harmony import */ var _constants_api__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(73350);
/* provided dependency */ var Buffer = __webpack_require__(48764)["Buffer"];








const isContainer = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.CONTAINER);
};
const isProductcard = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.PRODUCTCARD);
};
const isProductcardV3 = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.PRODUCTCARD_V3);
};
const isAuthModal = (item)=>{
    var ref;
    return ((ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.AUTH_MODAL)) && (item === null || item === void 0 ? void 0 : item.hi);
};
const isSiteWideWarning = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.SITEWIDE_WARNING);
};
const isNewsLetter = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.NEWSLETTER);
};
const isNewsLetterSignUp = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.NEWSLETTER_SIGNUP);
};
const isCompareProducts = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.COMPARE_PRODUCTS);
};
const isVideo = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.VIDEO);
};
const isSpacer = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.SPACER);
};
const isImage = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.IMAGE);
};
const isImageV3 = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.IMAGEV3);
};
const isUpSellContainer = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.UPSELL_CONTAINER);
};
const isCartLanding = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.CART_LANDING);
};
const isCheckoutLanding = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.CHECKOUT);
};
const isSharedCart = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.SHARED_CART);
};
const isOrderConfirmation = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.ORDER_CONFIRMATION);
};
const isOrderDetails = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.ORDER_DETAILS);
};
const isOrderHistory = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.ORDER_HISTORY);
};
const isOrderStatus = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.ORDER_STATUS);
};
const isPairsWellWth = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.PAIRS_WELL_WITH);
};
const isCarousel = (item)=>{
    var ref, ref1;
    return ((ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.CAROUSEL)) && !((ref1 = item[":type"]) === null || ref1 === void 0 ? void 0 : ref1.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.CAROUSELSLICK));
};
const isSlick = (item)=>{
    var ref, ref1, ref2;
    return ((ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.SLICK)) && !(item === null || item === void 0 ? void 0 : (ref1 = item.carouselComponentProperties) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.appliedCssClassNames) === null || ref2 === void 0 ? void 0 : ref2.includes("carousel-promo-banner"));
};
const isPromoBanner = (item)=>{
    var ref, ref1, ref2;
    return ((ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.SLICK)) && (item === null || item === void 0 ? void 0 : (ref1 = item.carouselComponentProperties) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.appliedCssClassNames) === null || ref2 === void 0 ? void 0 : ref2.includes("carousel-promo-banner"));
};
const isAemForm = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.AEMFORM);
};
const isTeaser = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.TEASER);
};
const isTeaserContainer = (data)=>{
    const types = [];
    data[":itemsOrder"] && data[":itemsOrder"].forEach((key)=>{
        const type = data[":items"][key][":type"];
        if (type) {
            types.push(type);
        }
    });
    return types.every((a)=>a.includes(COMPONENT_TYPES.TEASER));
};
const isText = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.TEXT);
};
const isTab = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.TAB);
};
const isBrandHeader = (data)=>{
    const types = [];
    data[":itemsOrder"] && data[":itemsOrder"].forEach((key)=>{
        const type = data[":items"][key][":type"];
        if (type) {
            types.push(type);
        }
    });
    return types.find((a)=>a.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.BRAND_SWITCHER)) || types.find((a)=>a.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.UTILITY_NAV_HEADER));
};
const checkNavigationV3 = (obj)=>{
    // Check if the current object has the is_good property
    if (Object.keys(obj).some((key)=>key.includes("globalnavigation_v3"))) {
        return true;
    }
    // Traverse each property of the object
    for(const key in obj){
        if (Object.hasOwn(obj, key)) {
            // Check if the property is an object or an array
            if (typeof obj[key] === "object" && obj[key] !== null) {
                // Recursively check nested objects or arrays
                if (checkNavigationV3(obj[key])) {
                    return true;
                }
            }
        }
    }
    // Return false if no v3 property is found in the object or its nested objects
    return false;
};
const isHeaderNav = (data)=>{
    const types = [];
    const itemsOrders = [];
    data[":itemsOrder"] && data[":itemsOrder"].forEach((key)=>{
        const type = data[":items"][key][":type"];
        if (data[":items"][key][":items"]) {
            itemsOrders.push(checkNavigationV3(data[":items"][key][":items"]));
        }
        if (type) {
            types.push(type);
        }
    });
    return types.find((a)=>a.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.UTILITY_WIDGET)) && types.find((a)=>a.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.TABS)) && types.find((a)=>a.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.IMAGE)) && !itemsOrders.find((a)=>a === true);
};
const isHeaderNavV3 = (data)=>{
    const types = [];
    const itemsOrders = [];
    data[":itemsOrder"] && data[":itemsOrder"].forEach((key)=>{
        const type = data[":items"][key][":type"];
        if (data[":items"][key][":items"]) {
            itemsOrders.push(checkNavigationV3(data[":items"][key][":items"]));
        }
        if (type) {
            types.push(type);
        }
    });
    return types.find((a)=>a.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.TABS)) && types.find((a)=>a.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.IMAGE)) && types.find((a)=>a.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.UTILITY_WIDGET)) && itemsOrders.find((a)=>a === true);
};
const isVisualNav = (data)=>{
    const perviousData = data[":itemsOrder"];
    const appliedclass = data["appliedCssClassNames"];
    return (perviousData === null || perviousData === void 0 ? void 0 : perviousData.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.VISUAL_NAV_FILTER)) || (appliedclass === null || appliedclass === void 0 ? void 0 : appliedclass.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.VISUAL_NAV_APPLIEDCLASS));
};
const isFooter = (data)=>{
    const types = [];
    data[":itemsOrder"] && data[":itemsOrder"].forEach((key)=>{
        const type = data[":items"][key][":type"];
        if (type) {
            types.push(type);
        }
    });
    return types.find((a)=>a.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.MAIN_FOOTER)) || types.find((a)=>a.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.ADDITIONAL_FOOTER)) || types.find((a)=>a.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.NEWSLETTER_SIGNIN));
};
const isEmbed = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.EMBED);
};
const isBreadcrumb = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.BREADCRUMB);
};
const isProductList = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.PRODUCTLIST);
};
const isSearch = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.SEARCH);
};
const isToaster = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.TOASTER);
};
const isHelpSupport = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.HELPSUPPORT);
};
const isProductDetails = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.PRODUCT_DETAILS);
};
const isAccountSettings = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.ACCOUNT_SETTINGS);
};
const isMyservice = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.MY_SERVICES);
};
const isMyFavorites = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.MY_FAVORITES);
};
const isChangePassword = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.CHANGE_PASSWORD);
};
const isMyproducts = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.MY_PRODUCTS);
};
const isProductAccordion = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.PRODUCT_DETAILS_ACCORDION);
};
const isProductReview = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.PRODUCT_DETAILS_REVIEW);
};
const isRegisterOffline = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.REGISTER_OFFLINE_PRODUCTS);
};
const isRegisterOnline = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.REGISTER_ONLINE_PRODUCTS);
};
const isBrowseAllStores = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.BROWSE_ALL_STORES);
};
const isStoreFilter = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.STORE_FILTER);
};
const isProductExfPdp = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.PRODUCT_DETAILS_EXFPDP);
};
const isKnowledgeArticle = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.KNOWLEDGE_ARTICLE);
};
const isLiterature = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.LITERATURE);
};
const isContactUs = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES === null || _constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES === void 0 ? void 0 : _constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.CONTACT_US);
};
const isFindingModelNumber = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES === null || _constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES === void 0 ? void 0 : _constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.FINDING_MODEL_NUMBER);
};
const isTechnicalSpec = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.TECHNICAL_SPECIFICATION);
};
const isPressLanding = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.PRESS_LANDING);
};
const isFindStore = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.FIND_STORE);
};
const isInPageSearch = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.INPAGE_SEARCH);
};
const isTitle = function() {
    let item = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.TITLE);
};
const isKeySpecifier = function() {
    let item = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.KEY_SPECIFIER);
};
const isDynamicSearch = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.DYNAMIC_SEARCH);
};
const isAssociateMembership = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.ASSOCIATE_MEMBERSHIP);
};
const isInspireVideo = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.INSPIRE_VIDEO);
};
const isImageCluster = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.IMAGE_CLUSTER);
};
const isProfessionalDetail = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.PROFESSIONAL_DETAILS);
};
const isRoomDetail = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.ROOM_DETAIL);
};
const isShopTheRoomDetail = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.SHOP_THE_ROOM_DETAIL);
};
const isglobalNavV3 = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(COMPONENT_TYPES.NAVIGATION_V3);
};
const isShopTheRoomCard = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.SHOP_THE_ROOM_CARD);
};
const isFindAProResults = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.FIND_A_PRO_RESULTS);
};
const isFriendsAndFamily = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.FRIENDS_AND_FAMILY);
};
const isList = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.LIST);
};
const isInstallDesignServices = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.INSTALL_DESIGN_SERVICES);
};
const isFindAProByZip = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.FIND_A_PRO_BY_ZIP);
};
const isStoreAppointment = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.STORE_APPOINTMENT);
};
const isGatedContent = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.GATED_CONTENT);
};
const isProductCardV4 = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.PRODUCT_CARD_V4);
};
const isPDPCuratedProducts = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.PDP_CURATED_PRODUCTS);
};
const isShopTheRoomLandingPage = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.SHOP_THE_ROOM_PAGE);
};
const isProductSlider = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_1__.COMPONENT_TYPES.PRODUCT_SLIDER);
};
/**
 *
 * @param {Element} e
 * @param {String} url
 */ const onImageError = (e, url)=>{
    const imgsrc = e.target.src;
    if (imgsrc.includes("&fmt=webp")) {
        e.target.src = imgsrc.replace("&fmt=webp", "");
        return;
    }
    const attr = document.createAttribute("errorsrc");
    attr.value = url;
    e.target.setAttributeNode(attr);
    e.target.src = _public_images_image_missing_png__WEBPACK_IMPORTED_MODULE_0__/* ["default"].src */ .Z.src;
};
/**
 *
 * @param {Number} width
 * @param {Number} rowCols
 * @param {String} swatchUrl
 * @param {String} assetId
 * @param {Object} presetConfigs
 * @param {Boolean} isForInstallationService
 * @return {String} preset url
 */ const getPresetUrl = function() {
    let width = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, rowCols = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, swatchUrl = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", assetId = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", presetConfigs = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {}, isForInstallationService = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : false;
    const { Desktop , MobilePortrait , MobilePortrait1 , MobilePortrait2 , MobileLandscape , MobileLandscape1 , MobileLandscape2 , PotraitCategory  } = presetConfigs;
    let preset = "";
    const mobileBasedCheckPoint = isForInstallationService ? 1023 : 768;
    if (width <= mobileBasedCheckPoint) {
        if (width <= 425) {
            if (rowCols) {
                preset = MobilePortrait2 || MobilePortrait;
                if (rowCols === 1) preset = MobilePortrait1 || MobilePortrait;
            } else if (MobilePortrait) {
                preset = MobilePortrait;
            } else preset = MobilePortrait2;
        } else {
            if (rowCols) {
                if (rowCols === 1) preset = MobileLandscape1 || MobileLandscape;
                else preset = MobileLandscape2 || MobileLandscape;
            } else if (MobileLandscape) {
                preset = MobileLandscape;
            } else preset = MobileLandscape1;
        }
    } else preset = Desktop;
    if (isForInstallationService) {
        return "".concat(swatchUrl).concat(assetId, "?").concat(preset);
    }
    return "".concat(swatchUrl).concat(PotraitCategory, "?$product_src=is{PAWEB/").concat(assetId, "}&").concat(preset);
};
const alterClass = function() {
    let elementClass = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", toAdd = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, toRemove = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    const element = document.getElementsByClassName(elementClass).item(0);
    if (toAdd && element) {
        element.classList.add(toAdd);
    }
    if (toRemove && element) {
        element.classList.remove(toRemove);
    }
};
//  * @param {String} fileName imagename.jpg / imagename
//  * @returns .jpg,.svg / false
const getExtention = (fileName)=>{
    const i = fileName.lastIndexOf(".");
    if (i === -1) return false;
    return fileName.slice(i);
};
/**
 *
 * @param {String} str
 * @param {Number} max
 * @param {Number} min
 * @return {Number}
 */ const accordionUniqueId = (str, max, min)=>{
    if (false) {}
    const crypto = window.crypto || window.msCrypto;
    const array = new Uint32Array(1);
    const randVal = crypto.getRandomValues(array)[0];
    return "".concat(str, "-").concat(Math.floor(randVal * (max - min + 1)) + min);
};
const ConditionalWrapper = (param)=>{
    let { condition , wrapper , children  } = param;
    return condition ? wrapper(children) : children;
};
const closest = (el, fn)=>el && (fn(el) ? el : closest(el.parentNode, fn));
const removeExtraSpaces = function() {
    let string = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return string.replace(/\s+/g, " ").trim();
};
/**
 *
 * @param {String} swatchUrl
 * @param {String} assetId
 * @param {Object} presetConfigs
 * @param {String} assetAccountName
 * @return {String}
 */ const getPresetThumbnailUrl = (swatchUrl, assetId, presetConfigs, assetAccountName)=>{
    const { Thumbnail , LandscapeCategory  } = presetConfigs;
    return "".concat(swatchUrl).concat(LandscapeCategory, "?$product_src=is{").concat(assetAccountName, "/").concat(assetId, "}&").concat(Thumbnail);
};
const recursiveDataFunction = function() {
    let data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, type = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    const results = [];
    if (data && data[":itemsOrder"]) {
        data[":itemsOrder"].map((key)=>{
            var ref;
            const item = data[":items"][key];
            if ((ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(type)) {
                results.push(item);
                return item;
            } else {
                const nestedResults = recursiveDataFunction(item, type);
                results.push(...nestedResults);
            }
        });
    }
    return results;
};
const getRowCols = (width, isMobile, isTablet)=>{
    let rowCols = width < 1024 ? 1 : 3;
    switch(true){
        case width > 1024:
            rowCols = 3;
            break;
        case width < 990 && (isMobile || isTablet) || width < 480:
            rowCols = 2;
            break;
        default:
            rowCols = 2;
    }
    return rowCols;
};
const getBillingAsShippingAddress = (shipping, billing)=>{
    const { billingStreetName ="" , billingAptNo ="" , billingCity ="" , billingStateCode ="" , billingZipcode =""  } = billing;
    const { shippingStreetName ="" , shippingAptNo ="" , shippingCity ="" , shippingStateCode ="" , shippingZipcode =""  } = shipping;
    return billingStreetName.toLowerCase() === shippingStreetName.toLowerCase() && billingAptNo.toLowerCase() === shippingAptNo.toLowerCase() && billingCity.toLowerCase() === shippingCity.toLowerCase() && billingStateCode.toLowerCase() === shippingStateCode.toLowerCase() && billingZipcode.toLowerCase() === shippingZipcode.toLowerCase();
};
const getIsSameAddress = (add1, add2)=>{
    const { streetName: streetName1 = "" , streetNumber: streetNumber1 = "" , city: city1 = "" , state: state1 = "" , postalCode: postalCode1 = ""  } = add1;
    const { streetName: streetName2 = "" , streetNumber: streetNumber2 = "" , city: city2 = "" , state: state2 = "" , postalCode: postalCode2 = ""  } = add2;
    return streetName1.toLowerCase() === streetName2.toLowerCase() && streetNumber1.toLowerCase() === streetNumber2.toLowerCase() && city1.toLowerCase() === city2.toLowerCase() && state1.toLowerCase() === state2.toLowerCase() && postalCode1.toLowerCase() === postalCode2.toLowerCase();
};
const getShippingAllTotal = (customLineItems, locale)=>{
    const shippings = [];
    customLineItems.forEach(function() {
        let item = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        const { custom: { fields: { isBundleParent =false  } = {}  } = {} , name ={} , totalPrice: { centAmount: totalPrice = 0  } = {}  } = item;
        const itemName = name[locale];
        var ref;
        const amount = (ref = totalPrice / 100) !== null && ref !== void 0 ? ref : 0;
        if (isBundleParent) return false;
        if (!shippings.find((el)=>el.name === itemName)) {
            shippings.push({
                total: amount,
                name: itemName
            });
        } else {
            const index = shippings.findIndex((code)=>code.name === itemName);
            shippings[index].total += amount;
        }
    });
    return shippings.filter((e)=>e.name !== "Service");
};
const getShippingData = async (currencySign, freeShipping)=>{
    const { cart: { cart: { customLineItems  } = {}  } = {}  } = _store__WEBPACK_IMPORTED_MODULE_3__/* .store.getState */ .h.getState();
    const { internationalization: { locale  } = {}  } = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_2__/* .getConfig */ .i)();
    const shippingAllTotal = getShippingAllTotal(customLineItems, locale);
    var ref;
    const freightShippingData = (ref = shippingAllTotal.find((el)=>{
        return _constants__WEBPACK_IMPORTED_MODULE_1__.FREIGHT_SHIPPING_TYPES.includes(el === null || el === void 0 ? void 0 : el.name);
    })) !== null && ref !== void 0 ? ref : {};
    var ref1;
    const parcelShippingData = (ref1 = shippingAllTotal.find((el)=>{
        return !_constants__WEBPACK_IMPORTED_MODULE_1__.FREIGHT_SHIPPING_TYPES.includes(el === null || el === void 0 ? void 0 : el.name);
    })) !== null && ref1 !== void 0 ? ref1 : {};
    const { total: freightAmount = ""  } = freightShippingData;
    const { total: parcelAmount = ""  } = parcelShippingData;
    const freightShippingCost = freightAmount > 0 ? "".concat(currencySign).concat(Number(freightAmount).toFixed(2)) : freeShipping;
    const parcelShippingCost = parcelAmount > 0 ? "".concat(currencySign).concat(parcelAmount, ".00") : freeShipping;
    return {
        freightShippingCost,
        parcelShippingCost
    };
};
const getOrderDetailsUrl = async (email, orderNumber)=>{
    const config = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_2__/* .getConfig */ .i)();
    const { general: { orderDetailsPath =""  } = {}  } = config;
    return "".concat(orderDetailsPath, "?orderNumber=").concat(orderNumber, "&q=").concat(Buffer.from(email).toString("base64"));
};
const getPdpRedirectUrl = (pdpUrl, param)=>{
    const isHasQueryParams = pdpUrl.includes("?");
    return "".concat(pdpUrl).concat(isHasQueryParams ? "&" : "?").concat(param);
};
const isObjectEmpty = (object)=>{
    return Object.keys(object).length === 0;
};
/**
 *
 * @param {Array} data Array of Object
 * @param {String} key key name
 * @return {String} preset url
 */ const getUniqueObjectListBy = (data, key)=>{
    return [
        ...new Map(data.map((e)=>[
                e[key],
                e
            ])).values()
    ];
};
const affirmRefresh = ()=>{
    const affirmConfig = {
        public_api_key: "5Y381NQRFL1OD7EG",
        script: "https://cdn1.affirm.com/js/v2/affirm.js",
        session_id: "sID"
    };
    (function(l, g, m, e, a, f, b) {
        let d;
        const c = l[m] || {};
        const h = document.createElement(f);
        const n = document.getElementsByTagName(f)[0];
        const k = function(a, b, c) {
            return function() {
                // eslint-disable-next-line prefer-rest-params
                a[b]._.push([
                    c,
                    arguments
                ]);
            };
        };
        c[e] = k(c, e, "set");
        // eslint-disable-next-line prefer-const
        d = c[e];
        c[a] = {};
        c[a]._ = [];
        d._ = [];
        c[a][b] = k(c, a, b);
        a = 0;
        for(b = "set add save post open empty reset on off trigger ready setProduct".split(" "); a < b.length; a++)d[b[a]] = k(c, e, b[a]);
        a = 0;
        for(b = [
            "get",
            "token",
            "url",
            "items"
        ]; a < b.length; a++)d[b[a]] = function() {};
        h.async = !0;
        h.src = g[f];
        n.parentNode.insertBefore(h, n);
        delete g[f];
        d(g);
        l[m] = c;
    })(window, affirmConfig, "affirm", "checkout", "ui", "script", "ready");
};
const getPayPalPaymentIdFromParams = ()=>{
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get("id");
};
const getBrandSwitcher = function() {
    let headerData = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const headPropsItems = headerData[":items"];
    const headerPropsRoot = headPropsItems === null || headPropsItems === void 0 ? void 0 : headPropsItems.root;
    const headerRootItems = headerPropsRoot[":items"];
    const hedaerPropsContainer = headerRootItems === null || headerRootItems === void 0 ? void 0 : headerRootItems.container_copy_copy;
    const headerContainerItems = hedaerPropsContainer[":items"];
    const headerUtilityWidgets = headerContainerItems === null || headerContainerItems === void 0 ? void 0 : headerContainerItems.brand_switcher;
    var ref;
    return (ref = headerUtilityWidgets === null || headerUtilityWidgets === void 0 ? void 0 : headerUtilityWidgets.items) !== null && ref !== void 0 ? ref : "";
};
const handleViewSterlingResults = function() {
    let brandSwitcher = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], brandName = arguments.length > 1 ? arguments[1] : void 0, sku = arguments.length > 2 ? arguments[2] : void 0;
    const { link  } = brandSwitcher.find((item)=>item.brandName.toLowerCase().replaceAll(" ", "") === brandName.toLowerCase());
    window.open("".concat(link, "/en/search?keyword=").concat(sku), "_blank");
};
const findStoreUtilNavselectQuery = "EntityID,BPnumber,LocationName,AddressLine,AddressLine2,StateLong,AdminDistrict,PostalCode,Latitude,__Distance,Longitude,Phone,OpenUntil,Locality";
const isString = (data)=>{
    return (data === null || data === void 0 ? void 0 : data.constructor.name) === "String";
};
const isObject = (data)=>{
    return (data === null || data === void 0 ? void 0 : data.constructor.name) === "Object";
};
const isValidPostalCode = (postalCode, countryCode)=>{
    let postalCodeRegex;
    switch(countryCode){
        case "US":
            postalCodeRegex = _constants_regex__WEBPACK_IMPORTED_MODULE_6__/* .POSTAL_CODE_US_REGEX */ .VB;
            break;
        case "CA":
            postalCodeRegex = _constants_regex__WEBPACK_IMPORTED_MODULE_6__/* .POSTAL_CODE_CA_REGEX */ .wc;
            break;
        default:
            postalCodeRegex = _constants_regex__WEBPACK_IMPORTED_MODULE_6__/* .POSTAL_CODE_REGEX */ .wM;
    }
    return postalCodeRegex.test(postalCode);
};
const isLeadGeneration = (item)=>{
    var ref;
    return (ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(COMPONENT_TYPES.Lead_Generation);
};
const getSanitizeNumber = (number)=>{
    return number.replace(_constants_regex__WEBPACK_IMPORTED_MODULE_6__/* .SANITIZE_NUMBER_REGEX */ .Tc, "");
};
const updateMetaContent = (metaName, value)=>{
    const metas = document.querySelectorAll("meta");
    const itemList = Array.from(metas).filter((val)=>{
        return (val === null || val === void 0 ? void 0 : val.name) === (metaName === null || metaName === void 0 ? void 0 : metaName.toLowerCase());
    });
    if (itemList && itemList.length !== 0) {
        const lastElement = itemList.at(-1);
        lastElement.setAttribute("content", value);
        return lastElement;
    }
    return false;
};
const parseToBoolean = (inputVal)=>{
    if (inputVal === null || inputVal === undefined) {
        return false;
    }
    if (typeof inputVal === "boolean") {
        return inputVal;
    }
    if (typeof inputVal === "string") {
        return /true/i.test(inputVal);
    }
    return inputVal;
};
/**
 *
 * @return {Object} {
 *  code: 'US',
 *  name: 'United States of America',
 *  states: [{code: 'AL', name: 'Alabama', countryCode: 'US'}]}
 */ const getCountryStatesList = ()=>{
    const { generic: { countryList =[] , stateList =[]  } = {}  } = _store__WEBPACK_IMPORTED_MODULE_3__/* .store.getState */ .h.getState();
    const countriesListData = countryList.map((country)=>{
        return {
            code: country.value,
            name: country.text,
            states: []
        };
    });
    const countries = countriesListData.map((el)=>{
        const states = [];
        stateList.forEach((state)=>{
            const { value =""  } = state;
            const [code, countryCode] = value.split(":");
            if (countryCode === el.code) {
                states.push({
                    code,
                    name: state.text,
                    countryCode
                });
            }
        });
        return {
            ...el,
            states
        };
    });
    return {
        countries
    };
};
const formatAddress = (addr)=>{
    const { countries  } = getCountryStatesList();
    const { fname: { value: firstName = ""  } = {} , lname: { value: lastName = ""  } = {} , address1: { value: streetName = ""  } = {} , zipcode: { value: postalCode = ""  } = {} , city: { value: city = ""  } = {} , state: { value: state = ""  } = {} , country: { value: country = ""  } = {} , email: { value: email = ""  } = {} , phone: { value: phone = ""  } = {} , label: { show: setPrimary = "" , value: label = ""  } = {} , address2: streetNumber = "" , id =""  } = addr;
    const address = {
        firstName,
        lastName,
        streetName,
        streetNumber,
        postalCode,
        city,
        state: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_4__/* .getStateCode */ .jeb)(state, country, countries),
        country: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_4__/* .getCountryCode */ .soW)(country, countries),
        email,
        phone,
        setPrimary,
        custom: {
            type: {
                typeId: "type",
                key: "custom-address"
            },
            fields: {
                label
            }
        },
        id
    };
    return address;
};
const mapCollapsedSku = async function() {
    let data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { itemSkus =[] , cart ={} , item =[] , isLineItems =false  } = data;
    const { generic: { globalConfig: { internationalization: { language ="en"  } = {}  } = {}  } = {}  } = _store__WEBPACK_IMPORTED_MODULE_3__/* .store.getState */ .h.getState() || {};
    const skuQury = getSkusQuery(itemSkus);
    const url = "".concat(_constants__WEBPACK_IMPORTED_MODULE_1__.PLP_END_POINT_CLIENT, "?fq=language_s:(").concat(language, ")&fq=sku_s:(").concat(skuQury, ")&rows=10&start=0&fl=sku_s,isCollapsedPDP_b,masterSKU_s&persona=GST&profilename=Search");
    const { data: { response: { docs: docsData = []  } = {}  } = {}  } = skuQury ? await _constants_api__WEBPACK_IMPORTED_MODULE_5__/* .apim.get */ .TH.get(url) : {};
    if (!docsData.length) {
        if (isLineItems) {
            return item;
        } else if (!cart.item) {
            cart.item = [];
            return cart;
        } else return cart;
    }
    var ref;
    const itemsData = isLineItems ? item : (ref = cart === null || cart === void 0 ? void 0 : cart.item) !== null && ref !== void 0 ? ref : [];
    const cartItemsMaped = itemsData.map((e)=>{
        var ref;
        const { isCollapsedPDP_b: isCollapsedPDP = false  } = (ref = docsData.find((el)=>{
            return "K-".concat(el.sku_s) === e.productInfo.productID;
        })) !== null && ref !== void 0 ? ref : {};
        e.productInfo.productSkuOption = isCollapsedPDP;
        return e;
    });
    cart.item = cartItemsMaped;
    return isLineItems ? cartItemsMaped : cart;
};
/**
 *
 * @param {Array} skus  Array
 * @return {String} '"22972-CP", "32380-CH05-BLL"'
 */ const getSkusQuery = function() {
    let skus = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    let query = "";
    skus.forEach((sku, i)=>{
        query += '"'.concat(sku, '"');
        if (i + 1 !== skus.length) query += ", ";
    });
    return query;
};
/**
 * Returns the fixed value 613.19.
 *
 * @param {number} number
 * @return {number} - Returns the fixed value 613.19.
 */ const getSanitizedFloatingNumber = (number)=>{
    return number.replace(_constants_regex__WEBPACK_IMPORTED_MODULE_6__/* .SANITIZE_FLOAT_NUMBER_REGEX */ .SA, "");
};
/**
 * Returns the pure text value for <h3>Vibrant<sup>®</sup>&nbsp;Polished Nickel</h3>.
 *
 * @param {string} string
 * @return {string} - Returns the pure text without encoding entities (vibrant polished nickel).
 */ const sanitizedTextAndEntities = (str)=>{
    if (!str) return "";
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = str;
    return tempDiv.textContent.replace(_constants_regex__WEBPACK_IMPORTED_MODULE_6__/* .SPACE_REGEX */ .my, " ").trim();
};



/***/ }),

/***/ 97433:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$8": function() { return /* binding */ validateZip; },
/* harmony export */   "BO": function() { return /* binding */ getUtilityStoreDetails; },
/* harmony export */   "OP": function() { return /* binding */ validateField; },
/* harmony export */   "Pp": function() { return /* binding */ getShortenedUrl; },
/* harmony export */   "XD": function() { return /* binding */ getLocationUsingIP; },
/* harmony export */   "e": function() { return /* binding */ getStoreDataById; },
/* harmony export */   "nY": function() { return /* binding */ validateInputField; },
/* harmony export */   "zO": function() { return /* binding */ getStoreDataByDistance; }
/* harmony export */ });
/* unused harmony export getLocationUsingZipcode */
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41609);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96301);
/* harmony import */ var _constants_api__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73350);
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19514);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(20558);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(88032);








// Get location using the public ip address of the client
const getLocationUsingIP = async ()=>{
    try {
        const ip = window === null || window === void 0 ? void 0 : window.sessionStorage["true-ip"];
        if (ip && ip !== "") {
            // {"23.100.225.115"}
            const res = await _constants_api__WEBPACK_IMPORTED_MODULE_3__/* .apim.get */ .TH.get("".concat(_constants__WEBPACK_IMPORTED_MODULE_2__.locationIpEndPoint).concat(ip));
            return res;
        } else {
            return {};
        }
    } catch (err) {
        console.error("Failed to get location using IP address", err);
    }
};
// Get location using the zip code
const getLocationUsingZipcode = async (zip)=>{
    try {
        if (zip && zip !== "") {
            const res = await _constants_api__WEBPACK_IMPORTED_MODULE_3__/* .apim.get */ .TH.get("".concat(_constants__WEBPACK_IMPORTED_MODULE_2__.locationZipEndPoint).concat(zip));
            return res;
        } else {
            return {};
        }
    } catch (err) {
        console.error("Failed to get location using zipcode", err);
    }
};
const validateField = async (field, value)=>{
    const config = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_4__/* .getConfig */ .i)();
    const { regexPattern  } = config;
    const pattern = lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(regexPattern, "map.".concat(field), "");
    const regex = new RegExp(pattern);
    const isValid = regex.test(value) ? true : false;
    return isValid;
};
const validateInputField = (field, value)=>{
    const { generic: { globalConfig: { regexPattern: { map  } = {}  } = {}  } = {}  } = _store__WEBPACK_IMPORTED_MODULE_6__/* .store.getState */ .h.getState();
    const pattern = map[field];
    const regex = new RegExp(pattern);
    const isValid = regex.test(value);
    return isValid;
};
const validateZip = async (zip)=>{
    var ref, ref1, ref2, ref3, ref4;
    const res = await getLocationUsingZipcode(zip);
    if ((res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.resourceSets) && ((ref3 = (ref2 = res === null || res === void 0 ? void 0 : (ref1 = res.data) === null || ref1 === void 0 ? void 0 : ref1.resourceSets[0]) === null || ref2 === void 0 ? void 0 : ref2.resources[0]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.address) === null || ref4 === void 0 ? void 0 : ref4.postalCode) === zip) return true;
    return false;
};
const getShortenedUrl = async (uUrl)=>{
    const config = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_4__/* .getConfig */ .i)();
    const { general  } = config;
    var ref;
    const shortUrl = (ref = general === null || general === void 0 ? void 0 : general.shortendPagePath) !== null && ref !== void 0 ? ref : "";
    const htmlRegExp = new RegExp(".html", "g");
    const htmlRemovedUrl = "".concat(uUrl === null || uUrl === void 0 ? void 0 : uUrl.replace(htmlRegExp, ""));
    const shortUrlRegEx = new RegExp(shortUrl, "g");
    return "".concat(htmlRemovedUrl === null || htmlRemovedUrl === void 0 ? void 0 : htmlRemovedUrl.replace(shortUrlRegEx, ""));
};
const getStoreDataById = (param)=>{
    let { myStoreId , findStores , siteName  } = param;
    return new Promise((resolve, reject)=>{
        const selectQuery = _utils__WEBPACK_IMPORTED_MODULE_5__/* .findStoreUtilNavselectQuery */ .$H;
        if (!lodash_isEmpty__WEBPACK_IMPORTED_MODULE_0___default()(findStores)) {
            _constants_api__WEBPACK_IMPORTED_MODULE_3__/* .apim.get */ .TH.get(findStores, {
                params: {
                    $format: "json",
                    brand: siteName.toLowerCase(),
                    $select: selectQuery,
                    $filter: "EntityID Eq ('".concat(myStoreId, "')")
                }
            }).then((response)=>{
                if (response && response.data) {
                    var ref;
                    resolve((ref = response.data.d.results[0]) !== null && ref !== void 0 ? ref : {});
                } else {
                    reject(new Error("Find a nearest store: Error occured while fetching data from Get URL Property"));
                // log.error(
                //   "Find a nearest store: Error occured while fetching data from Get URL Property"
                // )
                }
            }).catch((err)=>{
                console.log({
                    err
                });
                reject(new Error("Find a nearest store: Error occured while fetching data from Get URL Property"));
            });
        // .catch(err => log.error(err))
        } else {
        // log.error("Find a nearest store: Get API config not found")
        }
    });
};
const getStoreDataByDistance = (param)=>{
    let { utilityDistance =_constants__WEBPACK_IMPORTED_MODULE_2__.STORE_MIN_DISTANCE , findStores , userCity , siteName  } = param;
    return new Promise((resolve, reject)=>{
        // const locationStore = store.getState()?.location || ""
        // console.log({ locationStore })
        const selectQuery = "EntityID,BPnumber,LocationName,AddressLine,AddressLine2,StateLong,AdminDistrict,PostalCode,Latitude,__Distance,Longitude,Phone,OpenUntil,Locality";
        if (!lodash_isEmpty__WEBPACK_IMPORTED_MODULE_0___default()(findStores)) {
            _constants_api__WEBPACK_IMPORTED_MODULE_3__/* .apim.get */ .TH.get(findStores, {
                params: {
                    $format: "json",
                    brand: siteName.toLowerCase(),
                    spatialFilter: "nearby('".concat(userCity, "',").concat(utilityDistance, ")"),
                    $select: selectQuery,
                    $filter: "LocationType Eq ('KOHLER Store')"
                }
            }).then((response)=>{
                if (response && response.data) {
                    if (!lodash_isEmpty__WEBPACK_IMPORTED_MODULE_0___default()(response.data.d.results[0])) {
                        const utilityData = response.data.d.results[0];
                        resolve(utilityData);
                    } else if (utilityDistance === 64) {
                        getStoreDataByDistance({
                            utilityDistance: _constants__WEBPACK_IMPORTED_MODULE_2__.STORE_MAX_DISTANCE,
                            findStores,
                            userCity
                        });
                    }
                } else {
                    reject(new Error("Find a nearest store: Error occured while fetching data from Get URL Property"));
                // log.error(
                //   "Find a nearest store: Error occured while fetching data from Get URL Property"
                // )
                }
            }).catch((err)=>{
                console.log({
                    err
                });
            // log.error(err)
            });
        } else {
        // log.error("Find a nearest store: Get API config not found")
        }
    });
};
const getUtilityStoreDetails = async (param)=>{
    let { utilityStoreDetailsUrl  } = param;
    try {
        const response = await (0,_constants_api__WEBPACK_IMPORTED_MODULE_3__/* .aemAxiosInstance */ .Gb)({
            url: _constants__WEBPACK_IMPORTED_MODULE_2__.STORE_DETAILS_API_ENDPOINT,
            params: {
                path: utilityStoreDetailsUrl
            }
        });
        if (response && response.data) {
            return response.data;
        // this.setState({
        //   utilityStoreDetails: response.data ?? {},
        // })
        } else {
        // log.error(
        //   "Store Details: Error occured while fetching data from Get URL Property"
        // )
        }
    } catch (error) {
    // log.error(error)
    }
};



/***/ }),

/***/ 87864:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DV": function() { return /* binding */ checkExpPayPal; },
/* harmony export */   "Xx": function() { return /* binding */ getAciPayPalPaymentStatus; },
/* harmony export */   "mR": function() { return /* binding */ aciPaymentWidgetsInit; }
/* harmony export */ });
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88032);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55760);
/* harmony import */ var _utils_cart__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11763);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20558);
/* harmony import */ var _constants_routes__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(64757);
/* harmony import */ var _constants_api__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(73350);
/* harmony import */ var _constants___WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(96301);
/* harmony import */ var _store_features_genericSlice__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(88751);
/* harmony import */ var _store_features_cartSlice__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(46201);
/* harmony import */ var _store_features_checkoutSlice__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(60475);










const getAciPayPalPaymentStatus = async (data)=>{
    const { genericError ="" , unverifiedAddressMsg ="" , outOfCountryAddressMsg ="" , expPayPalCallBackErrorMsg: expPayPalAuthorErrorMsg = "" , onNext =()=>{}  } = data || {};
    const isXpp = checkExpPayPal();
    const id = (0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .getPayPalPaymentIdFromParams */ .qV)();
    _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_checkoutSlice__WEBPACK_IMPORTED_MODULE_9__/* .setPaymentFailedAction */ .RM)(false));
    const { generic: { aciPaymentErrorMessagesPath ="" , globalConfig: { general: { checkoutPagePath ="/"  } = {}  } = {}  } = {}  } = _store__WEBPACK_IMPORTED_MODULE_0__/* .store.getState */ .h.getState() || {};
    _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_7__/* .setLoading */ .K4)(true));
    _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_checkoutSlice__WEBPACK_IMPORTED_MODULE_9__/* .setPaymentErrorMessageAction */ .Fc)(""));
    const checkoutUrl = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_1__/* .getShortenedUrlPath */ .mXk)(checkoutPagePath);
    const { activeCartId =""  } = (0,_utils_cart__WEBPACK_IMPORTED_MODULE_2__/* .getCartIdParams */ .Uo)();
    if (!id) {
        window.history.replaceState(null, null, checkoutUrl);
        _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_7__/* .setLoading */ .K4)(false));
        return false;
    }
    const apiUrl = "".concat(_constants_routes__WEBPACK_IMPORTED_MODULE_4__/* .ACI_PAYMENT_CALLBACK_ENDPOINT */ .zG, "?cartId=").concat(activeCartId, "&sessionId=").concat(id, "&pm=").concat(isXpp ? "xpp" : "pp");
    try {
        const { data: data1 = {}  } = await _constants_api__WEBPACK_IMPORTED_MODULE_5__/* .apim.get */ .TH.get(apiUrl);
        const { paymentInfo: { payments =[]  } = {} , isVerifiedAddress =false  } = data1;
        var ref;
        const { id: payPalpaymentId = "" , obj: { paymentMethodInfo: { method =""  } = {}  } = {}  } = (ref = payments[0]) !== null && ref !== void 0 ? ref : {};
        _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_8__/* .setPaymetId */ .BR)(payPalpaymentId));
        _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_checkoutSlice__WEBPACK_IMPORTED_MODULE_9__/* .setIsPaymentInfoAction */ .hK)(true));
        _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_checkoutSlice__WEBPACK_IMPORTED_MODULE_9__/* .setPaymentMethodNameAction */ .I2)(method));
        _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_7__/* .setLoading */ .K4)(false));
        onNext();
        if (isXpp) {
            _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_checkoutSlice__WEBPACK_IMPORTED_MODULE_9__/* .setIsVerifiedAddress */ .Bp)(isVerifiedAddress));
            _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_checkoutSlice__WEBPACK_IMPORTED_MODULE_9__/* .setCheckoutAction */ .BZ)(!isVerifiedAddress ? 0 : 3));
            if (!isVerifiedAddress) {
                _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_checkoutSlice__WEBPACK_IMPORTED_MODULE_9__/* .setPayPalCallBackErrorMsg */ .SB)(unverifiedAddressMsg));
            }
            _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_8__/* .getCart */ .dv)());
        }
        window.history.replaceState(null, null, "".concat(checkoutUrl).concat(isXpp ? "?pm=xpp" : ""));
    } catch (error) {
        const { response: { data: { errorCode , errorDesc ="" , isShipmentFromCart =true  } = {}  } = {}  } = error !== null && error !== void 0 ? error : {};
        _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_checkoutSlice__WEBPACK_IMPORTED_MODULE_9__/* .setPaymentFailedAction */ .RM)(true));
        try {
            const { data: data2 = []  } = await _constants_api__WEBPACK_IMPORTED_MODULE_5__/* .aemAxiosInstance.get */ .Gb.get(_constants___WEBPACK_IMPORTED_MODULE_6__.GLOBAL_CONFIGURATION_ENDPOINT + "?path=" + aciPaymentErrorMessagesPath);
            const { value: errorMsg  } = data2.find((e)=>e.text === errorCode);
            onPayPalCallBackErorr({
                isXpp,
                genericError,
                errorMsg,
                errorDesc,
                expPayPalAuthorErrorMsg,
                outOfCountryAddressMsg,
                unverifiedAddressMsg,
                isShipmentFromCart
            });
            _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_7__/* .setLoading */ .K4)(false));
        } catch (e) {
            onPayPalCallBackErorr({
                isXpp,
                genericError,
                errorDesc,
                expPayPalAuthorErrorMsg,
                outOfCountryAddressMsg,
                unverifiedAddressMsg,
                isShipmentFromCart
            });
        }
        _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_7__/* .setLoading */ .K4)(false));
        window.history.replaceState(null, null, checkoutUrl);
    }
};
const onPayPalCallBackErorr = (data)=>{
    const { isXpp , genericError , errorMsg , errorDesc , expPayPalAuthorErrorMsg , outOfCountryAddressMsg , unverifiedAddressMsg , isShipmentFromCart  } = data;
    const isInvalidCountry = errorDesc === "invalid country";
    _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_checkoutSlice__WEBPACK_IMPORTED_MODULE_9__/* .setIsInvalidCountryAction */ .Ds)(isInvalidCountry));
    const getErrorMessage = ()=>{
        if (isInvalidCountry) {
            return outOfCountryAddressMsg;
        }
        if (!isShipmentFromCart) {
            return unverifiedAddressMsg;
        }
        return errorMsg || expPayPalAuthorErrorMsg;
    };
    if (isXpp) {
        _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_checkoutSlice__WEBPACK_IMPORTED_MODULE_9__/* .setCheckoutAction */ .BZ)(0));
        _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_checkoutSlice__WEBPACK_IMPORTED_MODULE_9__/* .setExpPayPalCheckout */ .gp)(false));
        _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_checkoutSlice__WEBPACK_IMPORTED_MODULE_9__/* .setPayPalCallBackErrorMsg */ .SB)(getErrorMessage()));
    } else {
        _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_checkoutSlice__WEBPACK_IMPORTED_MODULE_9__/* .setCheckoutAction */ .BZ)(2));
        _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_checkoutSlice__WEBPACK_IMPORTED_MODULE_9__/* .setPaymentMethodNameAction */ .I2)("paypal"));
        _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_checkoutSlice__WEBPACK_IMPORTED_MODULE_9__/* .setPaymentErrorMessageAction */ .Fc)(errorMsg || errorDesc || genericError));
    }
};
const checkExpPayPal = ()=>{
    const urlParams = new URLSearchParams(window.location.search);
    const paymentType = urlParams.get("pm");
    return paymentType === "xpp";
};
const aciPaymentWidgetsInit = function() {
    let isInit = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, checkoutId = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    const scriptElem = document.getElementById("aciPaymentWidget");
    if (isInit) {
        const script = document.createElement("script");
        script.src = "".concat("https://eu-prod.oppwa.com/v1/paymentWidgets.js", "?").concat(checkoutId ? "checkoutId=".concat(checkoutId) : "");
        script.id = "aciPaymentWidget";
        document.body.append(script);
    } else {
        scriptElem === null || scriptElem === void 0 ? void 0 : scriptElem.remove();
    }
};


/***/ }),

/***/ 29843:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U9": function() { return /* binding */ getRowsInitialValue; },
/* harmony export */   "Zj": function() { return /* binding */ removeFromCompareProduct; },
/* harmony export */   "dX": function() { return /* binding */ addToCompareProduct; },
/* harmony export */   "nx": function() { return /* binding */ formatListingData; }
/* harmony export */ });
/* unused harmony exports getListFromServer, getListFromClient, getPlpParams, getSearchItems, getProductDetailsFromServer */
/* harmony import */ var react_device_detect__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85518);
/* harmony import */ var _constants_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73350);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96301);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55760);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _store_features_compareSlice__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(39915);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(88032);
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(19514);
/* harmony import */ var _ApiUtil__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(51666);









const isServer = "object" === "undefined";
const addCollectionsToEndPointIfNeeded = function() {
    let url = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", brandName = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    let endPoint = url;
    if ((brandName === null || brandName === void 0 ? void 0 : brandName.toLowerCase()) !== EXCEPTIONAL_SITENAME) endPoint = "".concat(url, "&collections=").concat(brandName === null || brandName === void 0 ? void 0 : brandName.toLowerCase());
    return endPoint;
};
const getListFromServer = async function(profileName, persona) {
    let brandName = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", locale = arguments.length > 3 ? arguments[3] : void 0;
    return new Promise(async (resolve, reject)=>{
        try {
            const url = addCollectionsToEndPointIfNeeded("".concat(apiBaseUrl).concat(PLP_END_POINT_SUBSCRIPTION_KEY, "?profilename=").concat(profileName, "&persona=").concat(persona), brandName);
            aemAxiosInstance.defaults.headers.common["Ocp-Apim-Subscription-Key"] = "".concat(apimSubscriptionKey);
            const { data: content  } = await aemAxiosInstance({
                url,
                params: {
                    fq: 'language_s:("'.concat(locale, '")'),
                    fl: SSR_PLP_FL.join(",")
                }
            });
            resolve(content);
        } catch (error) {
            reject(error);
        }
    });
};
const getListFromClient = async function(profileName, persona, accessToken) {
    let brandName = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "";
    return new Promise(async (resolve, reject)=>{
        try {
            const url = addCollectionsToEndPointIfNeeded("".concat(authorBaseUrl).concat(PLP_END_POINT, "?profilename=").concat(profileName, "&persona=").concat(persona), brandName);
            aemAxiosInstance.defaults.headers.common["Authorization"] = "Bearer ".concat(accessToken);
            const { data: content  } = await aemAxiosInstance({
                url
            });
            resolve(content);
        } catch (error) {
            reject(error);
        }
    });
};
const getPlpParams = (obj, targetKey)=>{
    let result = null;
    for(const key in obj){
        if (Object.hasOwn(obj, key)) {
            if (key === targetKey) {
                return obj[key];
            }
            if (typeof obj[key] === "object" && obj[key] !== null) {
                result = getPlpParams(obj[key], targetKey);
                if (result !== null) {
                    return result;
                }
            }
        }
    }
    return result;
};
const getSearchItems = async function(searchKey, accessToken) {
    let displayName = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "SEARCH";
    return new Promise(async (resolve, reject)=>{
        try {
            aemAxiosInstance.defaults.headers.common["Authorization"] = "Bearer ".concat(accessToken);
            const { data: content  } = await aemAxiosInstance({
                url: "".concat(authorBaseUrl).concat(PLP_END_POINT, "?displayname=").concat(displayName, "&q=").concat(searchKey)
            });
            resolve(content);
        } catch (error) {
            reject(error);
        }
    });
};
const formatListingData = async (data, stripResponse)=>{
    return new Promise((resolve, reject)=>{
        try {
            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
            const persona = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_3__/* .getUserPersona */ .shu)();
            var ref8, ref9;
            const payload = {
                facets: (ref = data.facet_counts) === null || ref === void 0 ? void 0 : ref.facet_fields,
                facetLabels: (ref8 = (ref1 = data.fusion) === null || ref1 === void 0 ? void 0 : ref1.facet_labels) !== null && ref8 !== void 0 ? ref8 : [],
                grouped: ((ref2 = data.fusion) === null || ref2 === void 0 ? void 0 : ref2.isCollapsePLP) === "true" || ((ref3 = data.fusion) === null || ref3 === void 0 ? void 0 : ref3.isCollapsePLP) === true,
                fusion: data.fusion,
                PlpSwatches: (ref9 = (ref4 = data.facet_counts) === null || ref4 === void 0 ? void 0 : ref4.Plp_Swatches) !== null && ref9 !== void 0 ? ref9 : []
            };
            const priceRange = payload.grouped ? (ref5 = data.facet_counts) === null || ref5 === void 0 ? void 0 : ref5.facet_ranges["discountedPriceStartingAt.".concat(persona, "_d")] : (ref6 = data.facet_counts) === null || ref6 === void 0 ? void 0 : ref6.facet_ranges["priceList.".concat(persona, ".finalPrice_d")];
            if (priceRange) {
                const gap = priceRange.gap;
                // eslint-disable-next-line camelcase
                payload.facets.Price_Range = priceRange.counts.map((item)=>typeof item === "string" ? "[".concat(parseInt(item), " TO ").concat(parseInt(item) + gap, "]") : item);
            }
            // mark multiselect
            payload.facets = formatMultiSelectFacets(data);
            var ref10;
            // set color swatches
            payload.colors = (ref10 = (ref7 = data.fusion) === null || ref7 === void 0 ? void 0 : ref7.color_swatch_labels) !== null && ref10 !== void 0 ? ref10 : {};
            if (data.response) {
                var ref11, ref12;
                if (stripResponse && data.response.docs.length > 3) {
                    payload.data = data.response.docs.slice(0, 3);
                } else {
                    payload.data = data.response.docs;
                }
                payload.total = data.response.numFound;
                payload.start = data.response.start;
                if (((ref11 = data.fusion) === null || ref11 === void 0 ? void 0 : ref11.isCollapsePLP) === "true" || ((ref12 = data.fusion) === null || ref12 === void 0 ? void 0 : ref12.isCollapsePLP) === true) {
                    payload.grouped = true;
                }
            } else {
                payload.data = data.grouped[Object.keys(data.grouped)[0]].groups.map((doc)=>doc.doclist.docs[0]);
                payload.total = data.grouped[Object.keys(data.grouped)[0]].groups.length;
                payload.start = 0;
                payload.grouped = true;
            }
            resolve(payload);
        // update
        //   ? dispatch({ type: GET_MORE_PRODUCTS, payload: data.response.docs })
        //   : dispatch({ type: GET_PRODUCTS, payload })
        // dispatch({ type: STOP_LOADING, payload: "plp" })
        } catch (error) {
            reject(error);
        }
    });
};
const formatMultiSelectFacets = (data)=>{
    var ref;
    var ref1;
    const facets = Object.entries((ref1 = (ref = data.facet_counts) === null || ref === void 0 ? void 0 : ref.facet_fields) !== null && ref1 !== void 0 ? ref1 : {}).map((fields)=>({
            [fields[0]]: fields[1]
        }));
    let facetField = data === null || data === void 0 ? void 0 : data.fusion["facet.field"];
    if (facetField) {
        if (typeof facetField === "string") facetField = [
            facetField
        ];
        facetField.forEach((item)=>{
            facets.forEach((filter, index)=>{
                if (filter[item]) {
                    const obj = {
                        ["**".concat(item)]: filter[item]
                    };
                    facets.splice(index, 1, obj);
                }
            });
        });
    }
    const result = Object.assign({}, ...facets);
    return result;
};
const getRowsInitialValue = ()=>{
    let rowsInitialValue = 30;
    if (!isServer) {
        rowsInitialValue = react_device_detect__WEBPACK_IMPORTED_MODULE_0__/* .isMobile */ .tq ? 30 : sessionStorage.rows && JSON.parse(sessionStorage.rows)[window.location.pathname] ? JSON.parse(sessionStorage.rows)[window.location.pathname] : 30;
    }
    return rowsInitialValue;
};
const addToCompareProduct = async function() {
    let sku = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", data = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, lwAppName = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", persona = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "GST", sectionData = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : [], isBackOrder = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : false, slug = arguments.length > 6 ? arguments[6] : void 0;
    try {
        _store__WEBPACK_IMPORTED_MODULE_5__/* .store.dispatch */ .h.dispatch((0,_store_features_compareSlice__WEBPACK_IMPORTED_MODULE_4__/* .updateCompareStatus */ .Er)(true));
        var ref;
        const isBackOrderable = (ref = isBackOrder || (data === null || data === void 0 ? void 0 : data.RegionIsBackOrderable_b)) !== null && ref !== void 0 ? ref : false;
        const category = (data === null || data === void 0 ? void 0 : data.Product_Category) || (data === null || data === void 0 ? void 0 : data.ProductLocalCategory_s) || "";
        const config = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_6__/* .getConfig */ .i)();
        const compareSectionData = await getSectionData(sectionData, config);
        const { fl , categoryData  } = getFieldsFromCategory(compareSectionData, category, persona);
        const productDetails = await fetchProductDetails(sku, lwAppName, fl, config);
        const productData = {
            ...data,
            compareData: productDetails
        };
        _store__WEBPACK_IMPORTED_MODULE_5__/* .store.dispatch */ .h.dispatch((0,_store_features_compareSlice__WEBPACK_IMPORTED_MODULE_4__/* .addCompareProducts */ .rI)({
            productData,
            backorder: isBackOrderable,
            compareSku: sku,
            compareSectionData: categoryData,
            slug
        }));
    } catch (error) {
        console.error("Error adding product to compare:", error);
        _store__WEBPACK_IMPORTED_MODULE_5__/* .store.dispatch */ .h.dispatch((0,_store_features_compareSlice__WEBPACK_IMPORTED_MODULE_4__/* .updateCompareStatus */ .Er)(false));
    }
};
const getSectionData = async function() {
    let sectionData = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], config = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (sectionData.length > 0) {
        return sectionData;
    }
    try {
        var ref, ref1;
        const res = await (0,_constants_api__WEBPACK_IMPORTED_MODULE_1__/* .aemAxiosInstance */ .Gb)({
            url: _constants__WEBPACK_IMPORTED_MODULE_2__.GLOBAL_CONFIGURATION_ENDPOINT,
            params: {
                path: (ref = config.general) === null || ref === void 0 ? void 0 : ref.compareJsonPath
            }
        });
        return (res === null || res === void 0 ? void 0 : (ref1 = res.data) === null || ref1 === void 0 ? void 0 : ref1.data) || [];
    } catch (error) {
        console.error("Failed to get compare attributes JSON file", error);
        return [];
    }
};
const getFieldsFromCategory = (sectionData, category, persona)=>{
    const categoryData = sectionData.find((item)=>item.category === category);
    if (!categoryData) {
        return {
            fl: [],
            categoryData: null
        };
    }
    const compareAttributes = categoryData.sections.flatMap((section)=>section.attributes.map((attribute)=>attribute.lwAttribute));
    const additionalFields = [
        "RegionSoldOnline_s",
        "priceList.".concat(persona, ".finalPrice_d"),
        "CustomerFacingBrand_s",
        "priceList.".concat(persona, ".discountedPrice_d"),
        "priceList.".concat(persona, ".price_d"),
        "ProductBusinessUnit_ss"
    ];
    const fl = [
        ...compareAttributes,
        ...additionalFields
    ];
    return {
        fl,
        categoryData
    };
};
const fetchProductDetails = async (sku, lwAppName, fl, config)=>{
    var ref, ref1, ref2;
    const fq = [
        'sku_s:("'.concat(sku, '")')
    ];
    const res = await getCompareDataWithSku(lwAppName, fl, fq, config);
    return (res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : (ref1 = ref.response) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.docs) === null || ref2 === void 0 ? void 0 : ref2[0]) || {};
};
const getCompareDataWithSku = async function() {
    let lwAppName = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", fl = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", fq = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", config = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    var ref;
    var ref1;
    const language = (ref1 = config === null || config === void 0 ? void 0 : (ref = config.internationalization) === null || ref === void 0 ? void 0 : ref.language) !== null && ref1 !== void 0 ? ref1 : "en";
    return _constants_api__WEBPACK_IMPORTED_MODULE_1__/* .apim.get */ .TH.get(_constants__WEBPACK_IMPORTED_MODULE_2__.searchPlpEndPoint, {
        params: {
            fl: fl.join(","),
            q: "*:*",
            fq: [
                fq.join(" "),
                'language_s:("'.concat(language, '")')
            ],
            collections: lwAppName,
            profilename: "profile_".concat(lwAppName, "_General"),
            sessionId: (0,_ApiUtil__WEBPACK_IMPORTED_MODULE_7__/* .getSessionIdObjWithEpoc */ .oq)()
        },
        paramsSerializer: (params)=>{
            return qs__WEBPACK_IMPORTED_MODULE_8___default().stringify(params, {
                arrayFormat: "repeat",
                encode: false
            });
        }
    });
};
const removeFromCompareProduct = (sku)=>{
    _store__WEBPACK_IMPORTED_MODULE_5__/* .store.dispatch */ .h.dispatch((0,_store_features_compareSlice__WEBPACK_IMPORTED_MODULE_4__/* .clearProduct */ .JY)(sku));
};
const getProductDetailsFromServer = async (profileName, collections, slug, locale)=>{
    return new Promise(async (resolve, reject)=>{
        try {
            aemAxiosInstance.defaults.headers.common["Ocp-Apim-Subscription-Key"] = "".concat(apimSubscriptionKey);
            const response = await aemAxiosInstance({
                url: "".concat(apiBaseUrl).concat(PDP_END_POINT_SUBSCRIPTION_KEY, "?profilename=").concat(profileName, "&collections=").concat(collections, "&slug=").concat(slug, '&fq=language_s:"').concat(locale, '"')
            });
            const { data: { response: { docs =[]  } = {}  } = {}  } = response;
            const { data: { fusion: { masterVariantDataResponse =[]  } = {}  } = {}  } = response;
            resolve(docs[0] ? {
                ...docs[0],
                ...{
                    masterVariantDataResponse
                }
            } : {});
        } catch (error) {
            reject(error);
        }
    });
};



/***/ }),

/***/ 58510:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "z": function() { return /* binding */ Button; }
});

// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/factory/factory.utils.mjs
var factory_utils = __webpack_require__(99347);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Foundations/Typography/Typography.mjs + 2 modules
var Typography = __webpack_require__(72905);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Other/Box/Box.mjs + 1 modules
var Box = __webpack_require__(3253);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Buttons/Button/Button.module.css.mjs
var classes = {
    "buttonRoot": "GckgD",
    "label": "AheTB",
    "sections": "E54xC",
    "buttonSizeLarge": "_0qQpH",
    "buttonSizeMedium": "_0JISY",
    "buttonSizeSmall": "u12Wo",
    "buttonVariantPrimary": "f6Mqv",
    "buttonVariantSecondary": "BG-c7",
    "buttonVariantBrand": "WlIAM",
    "buttonHover": "L-dLx",
    "buttonFullWidth": "-ok9U",
    "iconButton": "iwgFy",
    "iconButtonSizeLarge": "ZBrOP",
    "iconButtonSizeMedium": "jgT9U",
    "iconButtonSizeSmall": "BEaHw"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Buttons/Button/Button.utils.mjs

const buttonSizeClasses = {
    small: classes.buttonSizeSmall,
    medium: classes.buttonSizeMedium,
    large: classes.buttonSizeLarge
};
const buttonVariantClasses = {
    primary: classes.buttonVariantPrimary,
    secondary: classes.buttonVariantSecondary,
    brand: classes.buttonVariantBrand
};
const buttonIconSizeClasses = {
    small: classes.iconButtonSizeSmall,
    medium: classes.iconButtonSizeMedium,
    large: classes.iconButtonSizeLarge
};
const buttonTypographySize = {
    small: "button-s",
    medium: "button-l",
    large: "button-l"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Buttons/Button/Button.mjs








const Button = (0,factory_utils/* polymorphicFactory */.bq)((props, ref)=>{
    const { component ="button" , children , fullWidth , size ="medium" , leftSection , rightSection , disabled , variant ="primary" , className , icon , hasHoverEffect =true , ...rest } = props;
    const classNames = (0,clsx/* default */.Z)(classes.buttonRoot, "kohler-button-root", className, size && !icon ? buttonSizeClasses[size] : buttonIconSizeClasses[size], icon && classes.iconButton, fullWidth && classes.buttonFullWidth, variant && buttonVariantClasses[variant], hasHoverEffect && classes.buttonHover);
    const Icon = icon || void 0;
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        className: classNames,
        component,
        ref,
        type: component === "button" ? "button" : void 0,
        disabled,
        size: buttonTypographySize[size],
        ...rest
    }, leftSection && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        component: "span",
        className: (0,clsx/* default */.Z)("kohler-button-section", classes.sections)
    }, leftSection), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        component: "span",
        className: classes.label
    }, Icon ? /* @__PURE__ */ /*#__PURE__*/ react.createElement(Icon, {
        size: size === "small" ? "small" : "medium",
        withBoundingBox: true
    }) : children), rightSection && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        component: "span",
        className: (0,clsx/* default */.Z)("kohler-button-section", classes.sections)
    }, rightSection));
});



/***/ }),

/***/ 3171:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "r": function() { return /* binding */ Link; }
});

// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/factory/factory.utils.mjs
var factory_utils = __webpack_require__(99347);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Foundations/Typography/Typography.mjs + 2 modules
var Typography = __webpack_require__(72905);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Other/Box/Box.mjs + 1 modules
var Box = __webpack_require__(3253);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Buttons/Link/Link.module.css.mjs
var classes = {
    "root": "ieaVA",
    "linkUnderline": "KQtnJ",
    "icons": "XqqHZ"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Buttons/Link/Link.utils.mjs
const linkSizeText = {
    small: "button-s",
    medium: "button-m",
    large: "button-xl"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Buttons/Link/Link.mjs








const Link = (0,factory_utils/* polymorphicFactory */.bq)((props, ref)=>{
    const { component ="a" , children , size ="medium" , underline =true , className , leftIcon , rightIcon , ...rest } = props;
    const classNames = (0,clsx/* default */.Z)(classes.root, "kohler-text-link-root", className, underline && classes.linkUnderline);
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        className: classNames,
        component,
        ref,
        ...rest,
        size: linkSizeText[size]
    }, leftIcon && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        component: "span",
        className: (0,clsx/* default */.Z)("kohler-text-link-icon", classes.icons)
    }, leftIcon), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        component: "span"
    }, children), rightIcon && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        component: "span",
        className: (0,clsx/* default */.Z)("kohler-text-link-icon", classes.icons)
    }, rightIcon));
});



/***/ }),

/***/ 75513:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ useCheckboxGroupContext; }
/* harmony export */ });
/* unused harmony export CheckboxGroupProvider */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

const CheckboxGroupContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);
const CheckboxGroupProvider = CheckboxGroupContext.Provider;
const useCheckboxGroupContext = ()=>(0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(CheckboxGroupContext);



/***/ }),

/***/ 39805:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "P": function() { return /* binding */ CheckboxIcon; }
});

// UNUSED EXPORTS: CheckIcon

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/constants.mjs
var constants = __webpack_require__(94802);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/CheckmarkIcon.mjs


const withoutBoundingBoxWidth = {
    large: 24,
    medium: 14,
    small: 14,
    xSmall: 12
};
const CheckmarkIcon = (param)=>{
    let { size ="medium" , withBoundingBox =true , ...others } = param;
    let iconWidth, iconHeight;
    if (typeof size === "string") {
        iconWidth = withBoundingBox ? constants/* iconSize */.E[size] : withoutBoundingBoxWidth[size];
        iconHeight = constants/* iconSize */.E[size];
    } else {
        iconWidth = size;
        iconHeight = size;
    }
    const renderIcon = ()=>{
        switch(size){
            case "xSmall":
                return /* @__PURE__ */ /*#__PURE__*/ react.createElement("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: iconWidth,
                    height: iconHeight,
                    viewBox: "0 0 16 16",
                    preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
                    fill: "none",
                    ...others
                }, /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M12.9601 3.27002L13.7127 3.92852L6.03151 12.707L2.30005 8.97556L3.00716 8.26845L5.98216 11.2436L12.9601 3.27002Z",
                    fill: "currentColor"
                }));
            case "small":
                return /* @__PURE__ */ /*#__PURE__*/ react.createElement("svg", {
                    width: iconWidth,
                    height: iconHeight,
                    viewBox: "0 0 20 20",
                    fill: "none",
                    preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
                    ...others
                }, /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M16.2853 4.5L17 5.15557L8.59735 15.5L3 10.7495L3.57941 9.97664L8.46677 14.1253L16.2853 4.5Z",
                    fill: "currentColor"
                }));
            case "medium":
            case "large":
            default:
                return /* @__PURE__ */ /*#__PURE__*/ react.createElement("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: iconWidth,
                    height: iconHeight,
                    viewBox: "0 0 30 30",
                    preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
                    fill: "none",
                    ...others
                }, /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M21.2853 9L22 9.65557L13.5973 20L8 15.2495L8.57941 14.4766L13.4668 18.6253L21.2853 9Z",
                    fill: "currentColor"
                }));
        }
    };
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(react.Fragment, null, renderIcon());
};
CheckmarkIcon.iconName = "CheckmarkIcon";


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/MinusIcon.mjs


const MinusIcon_withoutBoundingBoxWidth = {
    large: 30,
    medium: 20,
    small: 14,
    xSmall: 10
};
const MinusIcon = (param)=>{
    let { size ="medium" , withBoundingBox =true , ...others } = param;
    let iconWidth, iconHeight;
    if (typeof size === "string") {
        iconWidth = withBoundingBox ? constants/* iconSize */.E[size] : MinusIcon_withoutBoundingBoxWidth[size];
        iconHeight = constants/* iconSize */.E[size];
    } else {
        iconWidth = size;
        iconHeight = size;
    }
    const renderIcon = ()=>{
        switch(size){
            case "large":
                return /* @__PURE__ */ /*#__PURE__*/ react.createElement("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: iconWidth,
                    height: iconHeight,
                    viewBox: "0 0 40 40",
                    preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
                    fill: "none",
                    ...others
                }, /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
                    d: "M5 19.5H35V20.5H5V19.5Z",
                    fill: "white"
                }), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
                    d: "M5 19.5H35V20.5H5V19.5Z",
                    fill: "currentColor"
                }));
            case "xSmall":
                return /* @__PURE__ */ /*#__PURE__*/ react.createElement("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: iconWidth,
                    height: iconHeight,
                    viewBox: "0 0 16 16",
                    preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
                    fill: "none",
                    ...others
                }, /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M3 7.5H13V8.5H3V7.5Z",
                    fill: "white"
                }), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M3 7.5H13V8.5H3V7.5Z",
                    fill: "currentColor"
                }));
            case "small":
                return /* @__PURE__ */ /*#__PURE__*/ react.createElement("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: iconWidth,
                    height: iconHeight,
                    viewBox: "0 0 20 20",
                    preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
                    fill: "none",
                    ...others
                }, /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M3 9.5H17V10.5H3V9.5Z",
                    fill: "white"
                }), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M3 9.5H17V10.5H3V9.5Z",
                    fill: "currentColor"
                }));
            case "medium":
            default:
                return /* @__PURE__ */ /*#__PURE__*/ react.createElement("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: iconWidth,
                    height: iconHeight,
                    viewBox: "0 0 30 30",
                    preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
                    fill: "none",
                    ...others
                }, /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
                    d: "M5 14.5H25V15.5H5V14.5Z",
                    fill: "currentColor"
                }), /* @__PURE__ */ /*#__PURE__*/ react.createElement("path", {
                    d: "M5 14.5H25V15.5H5V14.5Z",
                    fill: "currentColor"
                }));
        }
    };
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(react.Fragment, null, renderIcon());
};
MinusIcon.iconName = "MinusIcon";


// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Controls/Checkbox/CheckboxIcon.mjs



function CheckIcon(param) {
    let { ...rest } = param;
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(CheckmarkIcon, {
        size: "xSmall",
        withBoundingBox: true,
        className: (0,clsx/* default */.Z)(rest.className, "kohler-check-icon")
    });
}
function CheckboxIcon(param) {
    let { indeterminate , ...rest } = param;
    if (indeterminate) {
        return /* @__PURE__ */ /*#__PURE__*/ react.createElement(MinusIcon, {
            size: "xSmall",
            withBoundingBox: true,
            className: (0,clsx/* default */.Z)(rest.className, "kohler-check-icon")
        });
    }
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(CheckIcon, {
        ...rest
    });
}



/***/ }),

/***/ 28879:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "E": function() { return /* binding */ Image; }
});

// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/factory/factory.utils.mjs
var factory_utils = __webpack_require__(99347);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Other/Box/Box.mjs + 1 modules
var Box = __webpack_require__(3253);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/DataDisplay/Image/Image.hook.mjs

function useS7SmartCrop(ref) {
    (0,react.useEffect)(()=>{
        const node = ref.current;
        if (!node || node.dataset.mode !== "smartcrop") return;
        const MAX_ATTEMPTS = 3;
        const INTERVAL = 3e3;
        const waitForS7 = ()=>new Promise((resolve, reject)=>{
                let attempts = 0;
                const check = ()=>{
                    if (typeof window.s7responsiveImage === "function") {
                        resolve();
                    } else if (++attempts < MAX_ATTEMPTS) {
                        setTimeout(check, INTERVAL);
                    } else {
                        reject(new Error("s7responsiveImage not available after 3 attempts"));
                    }
                };
                check();
            });
        const applySmartCrop = async ()=>{
            try {
                var ref;
                await waitForS7();
                (ref = window.s7responsiveImage) === null || ref === void 0 ? void 0 : ref.call(window, node);
            } catch (err) {
                console.warn(err.message);
            }
        };
        if (document.readyState === "complete") {
            applySmartCrop();
        } else {
            window.addEventListener("load", applySmartCrop);
            return ()=>window.removeEventListener("load", applySmartCrop);
        }
    }, [
        ref
    ]);
}


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/DataDisplay/Image/SmartCropS7Enhancer.mjs
"use client";


const SmartCropS7Enhancer = (param)=>{
    let { children  } = param;
    const ref = (0,react.useRef)(null);
    useS7SmartCrop(ref);
    return /*#__PURE__*/ react.cloneElement(children, {
        ref
    });
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/DataDisplay/Image/Image.mjs





const Image = (0,factory_utils/* polymorphicFactory */.bq)((props, ref)=>{
    const { component ="img" , src , srcSet , alt , className , width ="100%" , height ="100%" , objectFit ="cover" , position ="relative" , objectPosition ="center" , ...rest } = props;
    const classNames = (0,clsx/* default */.Z)("kohler-image-root", className);
    const isSmartCrop = rest["data-mode"] === "smartcrop";
    const imageElement = /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        className: classNames,
        component,
        ref,
        src,
        srcSet,
        alt,
        position,
        width,
        height,
        objectFit,
        objectPosition,
        ...rest
    });
    return isSmartCrop ? /* @__PURE__ */ /*#__PURE__*/ react.createElement(SmartCropS7Enhancer, null, imageElement) : imageElement;
});



/***/ }),

/***/ 72905:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Typography; }
});

// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/factory/factory.utils.mjs
var factory_utils = __webpack_require__(99347);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Other/Box/Box.mjs + 1 modules
var Box = __webpack_require__(3253);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Foundations/Typography/Typography.module.css.mjs
var classes = {
    "root": "dTpXP",
    "typographySizeH1": "_4VhMK",
    "typographySizeH2": "rhd5n",
    "typographySizeH3": "-XwLj",
    "typographySizeH4": "QtmrM",
    "typographySizeH5": "x-xNT",
    "typographySizeH6": "XCPqO",
    "typographySizeSmall": "_6Ovd0",
    "typographySizeMedium": "zJ-0f",
    "typographySizeLarge": "HDkX-",
    "typographySizeTitleL": "fCgbw",
    "typographySizeTitleM": "_8sPbT",
    "typographySizeTitleS": "vcyFX",
    "typographySizeLabelRegularXL": "jgb0M",
    "typographySizeLabelRegularL": "N6j3c",
    "typographySizeLabelRegularM": "D51Nl",
    "typographySizeLabelRegularS": "B6qqv",
    "typographySizeLabelRegularXS": "h5KJY",
    "typographySizeLabelMediumXL": "S4iBM",
    "typographySizeLabelMediumL": "_3UgoI",
    "typographySizeLabelMediumM": "liVBY",
    "typographySizeLabelMediumS": "bBUuT",
    "typographySizeLabelMediumXS": "Kil4C",
    "typographySizeLabelBoldL": "p1yGT",
    "typographySizeLabelBoldM": "konty",
    "typographySizeLabelBoldS": "_5VBYq",
    "typographySizeButtonXL": "v6t3t",
    "typographySizeButtonL": "UUATQ",
    "typographySizeButtonM": "_358uw",
    "typographySizeButtonS": "faKTj",
    "typographySizeTagM": "OLsuS",
    "typographySizeTagS": "M6Ttk",
    "typographySizeOverline": "bE0N7",
    "typographySizeCaptionM": "VwuCD",
    "typographySizeCaptionS": "_8LxoF",
    "typographySizeDisplayL": "Y-1s4",
    "typographySizeDisplayM": "bLMPG",
    "typographySizeNavigationBrandSwitcher": "TjkF6",
    "typographySizeNavigationOverlayTitle": "hR1uu",
    "typographySizeNavigationOverlayItemL": "Ni38f",
    "typographySizeNavigationOverlayItemM": "kZM2K",
    "typographySizeNavigationOverlayItemS": "_6C-0Q",
    "typographySizeNavigationOverlayItemMRegular": "NyMGn",
    "typographySizeNavigationOverlayItemMBold": "NWnLl",
    "typographySizeNavigationOverlayCategory": "QBa-z",
    "typographySizeNavigationL": "ba4A8",
    "typographySizeNavigationM": "pRuiV",
    "typographySizeNavigationS": "C7jwk",
    "typographySizeNavigationSelected": "_0AmT3",
    "typographySizeNavigationUnselected": "Y5FB-"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Foundations/Typography/Typography.utils.mjs

const typographySizeClasses = {
    "display-l": classes.typographySizeDisplayL,
    "display-m": classes.typographySizeDisplayM,
    "paragraph-small": classes.typographySizeSmall,
    "paragraph-medium": classes.typographySizeMedium,
    "paragraph-large": classes.typographySizeLarge,
    h1: classes.typographySizeH1,
    h2: classes.typographySizeH2,
    h3: classes.typographySizeH3,
    h4: classes.typographySizeH4,
    h5: classes.typographySizeH5,
    h6: classes.typographySizeH6,
    "title-l": classes.typographySizeTitleL,
    "title-m": classes.typographySizeTitleM,
    "title-s": classes.typographySizeTitleS,
    "label-regular-xl": classes.typographySizeLabelRegularXL,
    "label-regular-l": classes.typographySizeLabelRegularL,
    "label-regular-m": classes.typographySizeLabelRegularM,
    "label-regular-s": classes.typographySizeLabelRegularS,
    "label-regular-xs": classes.typographySizeLabelRegularXS,
    "label-medium-xl": classes.typographySizeLabelMediumXL,
    "label-medium-l": classes.typographySizeLabelMediumL,
    "label-medium-m": classes.typographySizeLabelMediumM,
    "label-medium-s": classes.typographySizeLabelMediumS,
    "label-medium-xs": classes.typographySizeLabelMediumXS,
    "label-bold-l": classes.typographySizeLabelBoldL,
    "label-bold-m": classes.typographySizeLabelBoldM,
    "label-bold-s": classes.typographySizeLabelBoldS,
    "button-xl": classes.typographySizeButtonXL,
    "button-l": classes.typographySizeButtonL,
    "button-m": classes.typographySizeButtonM,
    "button-s": classes.typographySizeButtonS,
    "caption-m": classes.typographySizeCaptionM,
    "caption-s": classes.typographySizeCaptionS,
    "tag-m": classes.typographySizeTagM,
    "tag-s": classes.typographySizeTagS,
    overline: classes.typographySizeOverline,
    "navigation-brand-switcher": classes.typographySizeNavigationBrandSwitcher,
    "navigation-overlay-title": classes.typographySizeNavigationOverlayTitle,
    "navigation-overlay-item-l": classes.typographySizeNavigationOverlayItemL,
    "navigation-overlay-item-m": classes.typographySizeNavigationOverlayItemM,
    "navigation-overlay-item-s": classes.typographySizeNavigationOverlayItemS,
    "navigation-overlay-item-m-regular": classes.typographySizeNavigationOverlayItemMRegular,
    "navigation-overlay-item-m-bold": classes.typographySizeNavigationOverlayItemMBold,
    "navigation-overlay-category": classes.typographySizeNavigationOverlayCategory,
    "navigation-l": classes.typographySizeNavigationL,
    "navigation-m": classes.typographySizeNavigationM,
    "navigation-s": classes.typographySizeNavigationS,
    "navigation-selected": classes.typographySizeNavigationSelected,
    "navigation-unselected": classes.typographySizeNavigationUnselected
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Foundations/Typography/Typography.mjs






const Typography = (0,factory_utils/* polymorphicFactory */.bq)((props, ref)=>{
    const { size ="paragraph-medium" , inherit , className , component , children , ...rest } = props;
    const classNames = (0,clsx/* default */.Z)(classes.root, className, size && typographySizeClasses[size], "dsm-typography-".concat(component || "p", "-").concat(size).concat(rest.mod ? "-".concat(rest.mod) : ""));
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        className: classNames,
        component: component || "p",
        ref,
        ...rest,
        ...{
            "data-inherit": inherit || void 0
        }
    }, children);
});



/***/ }),

/***/ 66737:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "y": function() { return /* binding */ AspectRatioKeeper; }
});

// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/factory/factory.utils.mjs
var factory_utils = __webpack_require__(99347);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Other/Box/Box.mjs + 1 modules
var Box = __webpack_require__(3253);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Layout/AspectRatioKeeper/AspectRatioKeeper.module.css.mjs
var classes = {
    "root": "-EXaH",
    "aspectRatio1x1": "Km736",
    "aspectRatio5x4": "egSDT",
    "aspectRatio4x5": "ofN06",
    "aspectRatio4x3": "RDBNy",
    "aspectRatio3x4": "dRjM3",
    "aspectRatio3x2": "bdDj-",
    "aspectRatio2x3": "_5FAWN",
    "aspectRatio16x10": "DiMzB",
    "aspectRatio10x16": "WAT2g",
    "aspectRatioGoldenRatio": "RcNS8",
    "aspectRatioGoldenRatioPortrait": "IjGf8",
    "aspectRatio16x9": "_4-pOd",
    "aspectRatio9x16": "_3NyUO",
    "aspectRatio2x1": "jtYAO",
    "aspectRatio1x2": "sohlM",
    "aspectRatio21x9": "eAurl",
    "aspectRatio9x21": "dVLUC",
    "aspectRatioA4Portrait": "nl69N",
    "aspectRatioA4": "p191Z",
    "aspectRatioLetterPortrait": "AN65t",
    "aspectRatioLetter": "JpKhK",
    "aspectRatioNone": "hShbe"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Layout/AspectRatioKeeper/AspectRatioKeeper.utils.mjs

const aspectRatioKeeperClasses = {
    "1:1": classes.aspectRatio1x1,
    "5:4": classes.aspectRatio5x4,
    "4:5": classes.aspectRatio4x5,
    "4:3": classes.aspectRatio4x3,
    "3:4": classes.aspectRatio3x4,
    "3:2": classes.aspectRatio3x2,
    "2:3": classes.aspectRatio2x3,
    "16:10": classes.aspectRatio16x10,
    "10:16": classes.aspectRatio10x16,
    "Golden ratio": classes.aspectRatioGoldenRatio,
    "Golden ratio Portrait": classes.aspectRatioGoldenRatioPortrait,
    "16:9": classes.aspectRatio16x9,
    "9:16": classes.aspectRatio9x16,
    "2:1": classes.aspectRatio2x1,
    "1:2": classes.aspectRatio1x2,
    "21:9": classes.aspectRatio21x9,
    "9:21": classes.aspectRatio9x21,
    A4: classes.aspectRatioA4,
    "A4 Portrait": classes.aspectRatioA4Portrait,
    Letter: classes.aspectRatioLetter,
    "Letter Portrait": classes.aspectRatioLetterPortrait,
    none: classes.aspectRatioNone
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Layout/AspectRatioKeeper/AspectRatioKeeper.mjs






const AspectRatioKeeper = (0,factory_utils/* polymorphicFactory */.bq)((props, ref)=>{
    const { component ="figure" , className , aspectRatio , ...rest } = props;
    const classNames = (0,clsx/* default */.Z)("kohler-aspect-ratio-keeper-root", className, classes.root, aspectRatio && aspectRatioKeeperClasses[aspectRatio]);
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        className: classNames,
        component,
        ref,
        ...rest
    });
});



/***/ }),

/***/ 54112:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "k": function() { return /* binding */ Flex; }
});

// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/factory/factory.utils.mjs
var factory_utils = __webpack_require__(99347);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Other/Box/Box.mjs + 1 modules
var Box = __webpack_require__(3253);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Other/InlineStyles/InlineStyles.mjs + 1 modules
var InlineStyles = __webpack_require__(36839);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/utils/helpers.mjs
var helpers = __webpack_require__(37892);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/utils/styleProps.mjs + 3 modules
var styleProps = __webpack_require__(4922);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/utils/hooks/hooks.mjs
var hooks = __webpack_require__(55580);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Layout/Flex/Flex.module.css.mjs
var classes = {
    "root": "VBOmU"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Layout/Flex/Flex.utils.mjs
const FLEX_STYLE_PROPS_DATA = {
    gap: {
        type: "spacing",
        property: "gap"
    },
    rowGap: {
        type: "spacing",
        property: "rowGap"
    },
    columnGap: {
        type: "spacing",
        property: "columnGap"
    },
    align: {
        type: "identity",
        property: "alignItems"
    },
    justify: {
        type: "identity",
        property: "justifyContent"
    },
    wrap: {
        type: "identity",
        property: "flexWrap"
    },
    direction: {
        type: "identity",
        property: "flexDirection"
    }
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Layout/Flex/Flex.mjs










const Flex = (0,factory_utils/* polymorphicFactory */.bq)((props, ref)=>{
    const { component ="div" , className , gap , rowGap , columnGap , align , justify , wrap , direction , style , ...rest } = props;
    const responsiveClassName = (0,hooks/* useRandomClassName */.m2)();
    const parsedStyleProps = (0,styleProps/* parseStyleProps */.nM)({
        styleProps: (0,helpers/* removeEmptyProps */.t_)({
            gap,
            rowGap,
            columnGap,
            align,
            justify,
            wrap,
            direction
        }),
        data: FLEX_STYLE_PROPS_DATA
    });
    const classNames = (0,clsx/* default */.Z)(classes.root, className, "kohler-flex-root", parsedStyleProps.hasResponsiveStyles && responsiveClassName);
    const parsedStyles = {
        ...style,
        ...!parsedStyleProps.hasResponsiveStyles ? parsedStyleProps.inlineStyles : {}
    };
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(react.Fragment, null, parsedStyleProps.hasResponsiveStyles && /* @__PURE__ */ /*#__PURE__*/ react.createElement(InlineStyles/* InlineStyles */.f, {
        selector: ".".concat(responsiveClassName),
        styles: parsedStyleProps.styles,
        media: parsedStyleProps.media
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        ref,
        className: classNames,
        style: parsedStyles,
        component,
        ...rest
    }));
});



/***/ }),

/***/ 40697:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "r": function() { return /* binding */ Grid; }
});

// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/factory/factory.utils.mjs
var factory_utils = __webpack_require__(99347);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Other/Box/Box.mjs + 1 modules
var Box = __webpack_require__(3253);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Other/InlineStyles/InlineStyles.mjs + 1 modules
var InlineStyles = __webpack_require__(36839);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/utils/styleProps.mjs + 3 modules
var styleProps = __webpack_require__(4922);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/utils/hooks/hooks.mjs
var hooks = __webpack_require__(55580);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Layout/Grid/Grid.module.css.mjs
var Grid_module_css = __webpack_require__(59293);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Layout/Grid/Grid.utils.mjs
const GRID_STYLE_PROPS_DATA = {
    rowGap: {
        type: "spacing",
        property: "rowGap"
    }
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Layout/Grid/Grid.mjs









const Grid = (0,factory_utils/* polymorphicFactory */.bq)((props, ref)=>{
    const { component ="div" , className , children , rowGap , style , ...rest } = props;
    const responsiveClassName = (0,hooks/* useRandomClassName */.m2)();
    const parsedStyleProps = (0,styleProps/* parseStyleProps */.nM)({
        styleProps: {
            rowGap
        },
        data: GRID_STYLE_PROPS_DATA
    });
    const classNames = (0,clsx/* default */.Z)(Grid_module_css/* default.root */.Z.root, className, "kohler-grid-root", parsedStyleProps.hasResponsiveStyles && responsiveClassName);
    const parsedStyles = {
        ...style,
        ...!parsedStyleProps.hasResponsiveStyles ? parsedStyleProps.inlineStyles : {}
    };
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(react.Fragment, null, parsedStyleProps.hasResponsiveStyles && /* @__PURE__ */ /*#__PURE__*/ react.createElement(InlineStyles/* InlineStyles */.f, {
        selector: ".".concat(responsiveClassName),
        styles: parsedStyleProps.styles,
        media: parsedStyleProps.media
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        component,
        ref,
        className: classNames,
        style: parsedStyles,
        ...rest
    }, children));
});



/***/ }),

/***/ 59293:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ classes; }
/* harmony export */ });
var classes = {
    "root": "q1PW5",
    "grid-column-span-1": "SWyE3",
    "grid-column-span-2": "WNVMt",
    "grid-column-span-3": "gotSY",
    "grid-column-span-4": "TaYy4",
    "grid-column-span-5": "u91x6",
    "grid-column-span-6": "f3lei",
    "grid-column-span-7": "bnN4v",
    "grid-column-span-8": "R3EGs",
    "grid-column-span-9": "YTdka",
    "grid-column-span-10": "Z-lWp",
    "grid-column-span-11": "_43roj",
    "grid-column-span-12": "piArP",
    "grid-column-span-small-1": "X3VQU",
    "grid-column-span-small-2": "EsK93",
    "grid-column-span-small-3": "r3VyK",
    "grid-column-span-small-4": "Ym-VS",
    "grid-column-span-small-5": "kRRm4",
    "grid-column-span-small-6": "_3rkmv",
    "grid-column-full": "Gaelm"
};



/***/ }),

/***/ 57237:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "C": function() { return /* binding */ GridColumn; }
});

// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/factory/factory.utils.mjs
var factory_utils = __webpack_require__(99347);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Other/Box/Box.mjs + 1 modules
var Box = __webpack_require__(3253);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Other/InlineStyles/InlineStyles.mjs + 1 modules
var InlineStyles = __webpack_require__(36839);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/utils/styleProps.mjs + 3 modules
var styleProps = __webpack_require__(4922);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/utils/hooks/hooks.mjs
var hooks = __webpack_require__(55580);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Layout/Grid/Grid.module.css.mjs
var Grid_module_css = __webpack_require__(59293);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Layout/Grid/GridColumn/GridColumn.utils.mjs
const GRID_COLUMN_STYLE_PROPS_DATA = {
    gridColumn: {
        type: "identity",
        property: "gridColumn"
    },
    gridColumnEnd: {
        type: "identity",
        property: "gridColumnEnd"
    },
    gridColumnStart: {
        type: "identity",
        property: "gridColumnStart"
    }
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Layout/Grid/GridColumn/GridColumn.mjs









const GridColumn = (0,factory_utils/* factory */.d5)((props, ref)=>{
    const { className , span , spanSmall , gridColumnStart , gridColumn , gridColumnEnd , fullWidth =true , style , ...rest } = props;
    const responsiveClassName = (0,hooks/* useRandomClassName */.m2)();
    const parsedStyleProps = (0,styleProps/* parseStyleProps */.nM)({
        styleProps: {
            gridColumn,
            gridColumnStart,
            gridColumnEnd
        },
        data: GRID_COLUMN_STYLE_PROPS_DATA
    });
    const parsedStyles = {
        ...style,
        ...!parsedStyleProps.hasResponsiveStyles ? parsedStyleProps.inlineStyles : {}
    };
    const classNames = (0,clsx/* default */.Z)(className, !span && !spanSmall && fullWidth && Grid_module_css/* default.grid-column-full */.Z["grid-column-full"], span && Grid_module_css/* default */.Z["grid-column-span-".concat(span)]);
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(react.Fragment, null, parsedStyleProps.hasResponsiveStyles && /* @__PURE__ */ /*#__PURE__*/ react.createElement(InlineStyles/* InlineStyles */.f, {
        selector: ".".concat(responsiveClassName),
        styles: parsedStyleProps.styles,
        media: parsedStyleProps.media
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        ref,
        className: classNames,
        ...rest,
        style: parsedStyles
    }));
});



/***/ }),

/***/ 38466:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "L": function() { return /* binding */ Spacer; }
});

// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/factory/factory.utils.mjs
var factory_utils = __webpack_require__(99347);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Other/Box/Box.mjs + 1 modules
var Box = __webpack_require__(3253);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Layout/Spacer/Spacer.module.css.mjs
var classes = {
    "root": "x2VyJ",
    "spacerSizeXS": "B90g0",
    "spacerSizeS": "_6SiQS",
    "spacerSizeM": "VkwB2",
    "spacerSizeL": "_9OLrI",
    "spacerSizeXL": "a9aaf"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Layout/Spacer/Spacer.utils.mjs

const spacerSizeClasses = {
    xs: classes.spacerSizeXS,
    s: classes.spacerSizeS,
    m: classes.spacerSizeM,
    l: classes.spacerSizeL,
    xl: classes.spacerSizeXL
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Layout/Spacer/Spacer.mjs






const Spacer = (0,factory_utils/* polymorphicFactory */.bq)((props, ref)=>{
    const { component ="div" , className , size ="xs" , ...rest } = props;
    const classNames = (0,clsx/* default */.Z)("kohler-spacer-root", className, classes.root, spacerSizeClasses[size]);
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        className: classNames,
        component,
        ref,
        ...rest
    });
});



/***/ }),

/***/ 3253:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "x": function() { return /* binding */ Box; }
});

// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/factory/factory.utils.mjs
var factory_utils = __webpack_require__(99347);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/utils/styleProps.mjs + 3 modules
var utils_styleProps = __webpack_require__(4922);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/utils/hooks/hooks.mjs
var hooks = __webpack_require__(55580);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Other/InlineStyles/InlineStyles.mjs + 1 modules
var InlineStyles = __webpack_require__(36839);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/utils/helpers.mjs
var helpers = __webpack_require__(37892);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Other/Box/Box.utils.mjs


const BOX_STYLE_PROPS_DATA = {
    margin: {
        type: "spacing",
        property: "margin"
    },
    marginTop: {
        type: "spacing",
        property: "marginTop"
    },
    marginBottom: {
        type: "spacing",
        property: "marginBottom"
    },
    marginLeft: {
        type: "spacing",
        property: "marginLeft"
    },
    marginRight: {
        type: "spacing",
        property: "marginRight"
    },
    marginInlineStart: {
        type: "spacing",
        property: "marginInlineStart"
    },
    marginInlineEnd: {
        type: "spacing",
        property: "marginInlineEnd"
    },
    marginInline: {
        type: "spacing",
        property: "marginInline"
    },
    marginBlock: {
        type: "spacing",
        property: "marginBlock"
    },
    padding: {
        type: "spacing",
        property: "padding"
    },
    paddingTop: {
        type: "spacing",
        property: "paddingTop"
    },
    paddingBottom: {
        type: "spacing",
        property: "paddingBottom"
    },
    paddingLeft: {
        type: "spacing",
        property: "paddingLeft"
    },
    paddingRight: {
        type: "spacing",
        property: "paddingRight"
    },
    paddingInlineStart: {
        type: "spacing",
        property: "paddingInlineStart"
    },
    paddingInlineEnd: {
        type: "spacing",
        property: "paddingInlineEnd"
    },
    paddingInline: {
        type: "spacing",
        property: "paddingInline"
    },
    paddingBlock: {
        type: "spacing",
        property: "paddingBlock"
    },
    backgroundColor: {
        type: "color",
        property: "background"
    },
    textColor: {
        type: "textColor",
        property: "color"
    },
    opacity: {
        type: "identity",
        property: "opacity"
    },
    width: {
        type: "spacing",
        property: "width"
    },
    minWidth: {
        type: "spacing",
        property: "minWidth"
    },
    maxWidth: {
        type: "spacing",
        property: "maxWidth"
    },
    height: {
        type: "spacing",
        property: "height"
    },
    minHeight: {
        type: "spacing",
        property: "minHeight"
    },
    maxHeight: {
        type: "spacing",
        property: "maxHeight"
    },
    fontFamily: {
        type: "fontFamily",
        property: "fontFamily"
    },
    fontSize: {
        type: "fontSize",
        property: "fontSize"
    },
    fontWeight: {
        type: "identity",
        property: "fontWeight"
    },
    letterSpacing: {
        type: "size",
        property: "letterSpacing"
    },
    textAlign: {
        type: "identity",
        property: "textAlign"
    },
    lineHeight: {
        type: "lineHeight",
        property: "lineHeight"
    },
    fontStyle: {
        type: "identity",
        property: "fontStyle"
    },
    textTransform: {
        type: "identity",
        property: "textTransform"
    },
    textDecoration: {
        type: "identity",
        property: "textDecoration"
    },
    position: {
        type: "identity",
        property: "position"
    },
    display: {
        type: "identity",
        property: "display"
    },
    objectFit: {
        type: "identity",
        property: "objectFit"
    },
    objectPosition: {
        type: "identity",
        property: "objectPosition"
    },
    zIndex: {
        type: "identity",
        property: "zIndex"
    },
    left: {
        type: "spacing",
        property: "left"
    },
    right: {
        type: "spacing",
        property: "right"
    },
    top: {
        type: "spacing",
        property: "top"
    },
    bottom: {
        type: "spacing",
        property: "bottom"
    },
    border: {
        type: "identity",
        property: "border"
    },
    borderTop: {
        type: "identity",
        property: "borderTop"
    },
    borderBottom: {
        type: "identity",
        property: "borderBottom"
    },
    borderRight: {
        type: "identity",
        property: "borderRight"
    },
    borderLeft: {
        type: "identity",
        property: "borderLeft"
    },
    borderRadius: {
        type: "identity",
        property: "borderRadius"
    }
};
function extractStyleProps(others) {
    const { margin , marginTop , marginBottom , marginLeft , marginRight , marginInlineStart , marginInlineEnd , marginInline , marginBlock , padding , paddingTop , paddingBottom , paddingLeft , paddingRight , paddingInlineStart , paddingInlineEnd , paddingInline , paddingBlock , opacity , width , minWidth , maxWidth , height , minHeight , maxHeight , display , textColor , backgroundColor , fontFamily , fontSize , fontWeight , letterSpacing , textAlign , textTransform , position , lineHeight , fontStyle , textDecoration , objectFit , objectPosition , zIndex , left , right , top , bottom , border , borderRight , borderTop , borderLeft , borderBottom , borderRadius , ...rest } = others;
    const styleProps = (0,helpers/* removeEmptyProps */.t_)({
        margin,
        marginTop,
        marginBottom,
        marginLeft,
        marginRight,
        marginInlineStart,
        marginInlineEnd,
        marginInline,
        marginBlock,
        padding,
        paddingTop,
        paddingBottom,
        paddingLeft,
        paddingRight,
        paddingInlineStart,
        paddingInlineEnd,
        paddingInline,
        paddingBlock,
        opacity,
        width,
        minWidth,
        maxWidth,
        height,
        minHeight,
        maxHeight,
        display,
        textColor,
        backgroundColor,
        fontFamily,
        fontSize,
        fontWeight,
        letterSpacing,
        textAlign,
        textTransform,
        position,
        lineHeight,
        fontStyle,
        textDecoration,
        objectFit,
        objectPosition,
        zIndex,
        left,
        right,
        top,
        bottom,
        border,
        borderRight,
        borderTop,
        borderLeft,
        borderBottom,
        borderRadius
    });
    return {
        styleProps,
        rest
    };
}


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Other/Box/Box.mjs







const Box = (0,factory_utils/* createPolymorphicComponent */.Fm)(/*#__PURE__*/ (0,react.forwardRef)((param, ref)=>{
    let { component , className , style , mod , renderRoot , trackingAttributes , ...rest } = param;
    const responsiveClassName = (0,hooks/* useRandomClassName */.m2)();
    const { styleProps , rest: restFiltered  } = extractStyleProps(rest);
    const parsedStyleProps = (0,utils_styleProps/* parseStyleProps */.nM)({
        styleProps,
        data: BOX_STYLE_PROPS_DATA
    });
    const Element = component || "div";
    const props = {
        ref,
        className: (0,clsx/* default */.Z)(mod && "".concat(mod, "-mod"), className, parsedStyleProps.hasResponsiveStyles && responsiveClassName) || void 0,
        style: {
            ...!parsedStyleProps.hasResponsiveStyles ? parsedStyleProps.inlineStyles : {},
            ...style
        },
        ...restFiltered,
        ...trackingAttributes
    };
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(react.Fragment, null, parsedStyleProps.hasResponsiveStyles && /* @__PURE__ */ /*#__PURE__*/ react.createElement(InlineStyles/* InlineStyles */.f, {
        selector: ".".concat(responsiveClassName),
        styles: parsedStyleProps.styles,
        media: parsedStyleProps.media
    }), typeof renderRoot === "function" ? renderRoot(props) : /* @__PURE__ */ /*#__PURE__*/ react.createElement(Element, {
        ...props
    }));
}));



/***/ }),

/***/ 36839:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "f": function() { return /* binding */ InlineStyles; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/utils/helpers.mjs
var helpers = __webpack_require__(37892);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Other/InlineStyles/InlineStyles.utils.mjs


function stylesToString(param) {
    let { selector , styles , media  } = param;
    const baseStyles = styles ? cssObjectToString(styles) : "";
    const mediaQueryStyles = !Array.isArray(media) ? [] : media.map((item)=>"@media ".concat(item.query, "{").concat(selector, "{").concat(cssObjectToString(item.styles), "}}"));
    return "".concat(baseStyles ? "".concat(selector, "{").concat(baseStyles, "}") : "").concat(mediaQueryStyles.join("")).trim();
}
function cssObjectToString(css) {
    return (0,helpers/* keys */.XP)(css).reduce((acc, rule)=>css[rule] !== void 0 ? "".concat(acc).concat((0,helpers/* camelToKebabCase */.Kh)(rule), ":").concat(css[rule], ";") : acc, "").trim();
}


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Other/InlineStyles/InlineStyles.mjs


function InlineStyles(param) {
    let { selector , styles , media  } = param;
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement("style", {
        "data-kohler-styles": "inline",
        dangerouslySetInnerHTML: {
            __html: stylesToString({
                selector,
                styles,
                media
            })
        }
    });
}



/***/ }),

/***/ 23293:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "u": function() { return /* binding */ Tooltip; }
});

// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/factory/factory.utils.mjs
var factory_utils = __webpack_require__(99347);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Foundations/Typography/Typography.mjs + 2 modules
var Typography = __webpack_require__(72905);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Popover/subcomponents/Floating/get-floating-position/get-floating-position.mjs
var get_floating_position = __webpack_require__(86286);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Popover/subcomponents/Floating/FloatingArrow/FloatingArrow.mjs + 1 modules
var FloatingArrow = __webpack_require__(25292);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Popover/subcomponents/Popover/PopoverTarget/use-merged-ref.mjs
var use_merged_ref = __webpack_require__(68064);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Popover/subcomponents/Popover/PopoverTarget/PopoverTarget.utils.mjs
var PopoverTarget_utils = __webpack_require__(60169);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Popover/Tooltip/Tooltip.module.css.mjs
var classes = {
    "tooltip": "MX352",
    "tooltipOpened": "OFydy"
};


// EXTERNAL MODULE: ./node_modules/@floating-ui/react/dist/floating-ui.react.mjs + 1 modules
var floating_ui_react = __webpack_require__(46504);
// EXTERNAL MODULE: ./node_modules/@floating-ui/react-dom/dist/floating-ui.react-dom.mjs
var floating_ui_react_dom = __webpack_require__(1371);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/utils/hooks/hooks.mjs
var hooks = __webpack_require__(55580);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Popover/subcomponents/Floating/use-floating-auto-update.mjs
var use_floating_auto_update = __webpack_require__(96228);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Popover/Tooltip/use-tooltip.mjs





function useTooltip(settings) {
    var ref, ref1, ref2;
    const [uncontrolledOpened, setUncontrolledOpened] = (0,react.useState)(false);
    const controlled = typeof settings.opened === "boolean";
    const opened = controlled ? settings.opened : uncontrolledOpened;
    const uid = (0,react.useId)();
    const onChange = (0,react.useCallback)((_opened)=>{
        setUncontrolledOpened(_opened);
    }, [
        uid
    ]);
    const { x , y , context , refs , update , placement , middlewareData: { arrow: { x: arrowX , y: arrowY  } = {}  }  } = (0,floating_ui_react/* useFloating */.YF)({
        strategy: settings.strategy,
        placement: settings.position,
        open: opened,
        onOpenChange: onChange,
        middleware: [
            (0,floating_ui_react_dom/* offset */.cv)(settings.offset),
            (0,floating_ui_react_dom/* shift */.uY)({
                padding: 8
            }),
            (0,floating_ui_react_dom/* flip */.RR)(),
            (0,floating_ui_react_dom/* arrow */.x7)({
                element: settings.arrowRef,
                padding: settings.arrowOffset
            }),
            ...settings.inline ? [
                (0,floating_ui_react_dom/* inline */.Qo)()
            ] : []
        ]
    });
    const { getReferenceProps , getFloatingProps  } = (0,floating_ui_react/* useInteractions */.NI)([
        (0,floating_ui_react/* useHover */.XI)(context, {
            enabled: (ref = settings.events) === null || ref === void 0 ? void 0 : ref.hover,
            delay: {
                open: settings.openDelay,
                close: settings.closeDelay
            },
            mouseOnly: !((ref1 = settings.events) === null || ref1 === void 0 ? void 0 : ref1.touch)
        }),
        (0,floating_ui_react/* useFocus */.KK)(context, {
            enabled: (ref2 = settings.events) === null || ref2 === void 0 ? void 0 : ref2.focus,
            visibleOnly: true
        }),
        (0,floating_ui_react/* useRole */.qs)(context, {
            role: "tooltip"
        }),
        (0,floating_ui_react/* useDismiss */.bQ)(context, {
            enabled: typeof settings.opened === "undefined"
        })
    ]);
    (0,use_floating_auto_update/* useFloatingAutoUpdate */.L)({
        opened,
        position: settings.position,
        positionDependencies: settings.positionDependencies,
        floating: {
            refs,
            update
        }
    });
    (0,hooks/* useDidUpdate */.lR)(()=>{
        var ref;
        (ref = settings.onPositionChange) === null || ref === void 0 ? void 0 : ref.call(settings, placement);
    }, [
        placement
    ]);
    return {
        x,
        y,
        arrowX,
        arrowY,
        reference: refs.setReference,
        floating: refs.setFloating,
        getFloatingProps,
        getReferenceProps,
        isGroupPhase: false,
        opened,
        placement
    };
}


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Popover/Tooltip/Tooltip.mjs
"use client";















const Tooltip = (0,factory_utils/* factory */.d5)((props, ref)=>{
    const { children , position , refProp ="ref" , label , onPositionChange , opened , className , multiline =true , zIndex , onClick , onMouseEnter , onMouseLeave , inline , offset =5 , ...rest } = props;
    const dir = "ltr";
    const events = {
        hover: true,
        focus: false,
        touch: false
    };
    const arrowSize = 16;
    const arrowRef = (0,react.useRef)(null);
    const withArrow = false;
    const arrowOffset = 5;
    const arrowPosition = "side";
    const tooltip = useTooltip({
        position: (0,get_floating_position/* getFloatingPosition */._)(dir, position),
        closeDelay: void 0,
        openDelay: void 0,
        onPositionChange,
        opened,
        events,
        arrowRef,
        arrowOffset: void 0,
        offset: typeof offset === "number" ? offset + 0 : offset,
        positionDependencies: [
            ...[],
            children
        ],
        inline,
        strategy: void 0
    });
    if (!(0,PopoverTarget_utils/* isElement */.k)(children)) {
        throw new Error("[@kohler/core] Tooltip component children should be an element or a component that accepts ref, fragments, strings, numbers and other primitive values are not supported");
    }
    const targetRef = (0,use_merged_ref/* useMergedRef */.Yx)(tooltip.reference, children.ref, ref);
    var _y, _x;
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(react.Fragment, null, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        component: "div",
        size: "paragraph-small",
        ...rest,
        ...tooltip.getFloatingProps({
            ref: tooltip.floating,
            className: (0,clsx/* default */.Z)(classes.tooltip, tooltip.opened && classes.tooltipOpened, className, "kohler-tooltip-root"),
            style: {
                zIndex,
                top: (_y = tooltip.y) !== null && _y !== void 0 ? _y : 0,
                left: (_x = tooltip.x) !== null && _x !== void 0 ? _x : 0
            }
        }),
        "data-multiline": multiline
    }, label, /* @__PURE__ */ /*#__PURE__*/ react.createElement(FloatingArrow/* FloatingArrow */.Y, {
        ref: arrowRef,
        arrowX: tooltip.arrowX,
        arrowY: tooltip.arrowY,
        visible: withArrow,
        position: tooltip.placement,
        arrowSize,
        arrowOffset,
        arrowRadius: 0,
        arrowPosition
    })), /*#__PURE__*/ (0,react.cloneElement)(children, tooltip.getReferenceProps({
        onClick,
        onMouseEnter,
        onMouseLeave,
        onMouseMove: props.onMouseMove,
        onPointerDown: props.onPointerDown,
        onPointerEnter: props.onPointerEnter,
        [refProp]: targetRef,
        className: (0,clsx/* default */.Z)(children.props.className),
        ...children.props
    })));
});



/***/ }),

/***/ 25292:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Y": function() { return /* binding */ FloatingArrow; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Popover/subcomponents/Floating/FloatingArrow/get-arrow-position-styles.mjs
function horizontalSide(placement, arrowY, arrowOffset, arrowPosition) {
    if (placement === "center" || arrowPosition === "center") {
        return {
            top: arrowY
        };
    }
    if (placement === "end") {
        return {
            bottom: arrowOffset
        };
    }
    if (placement === "start") {
        return {
            top: arrowOffset
        };
    }
    return {};
}
function verticalSide(placement, arrowX, arrowOffset, arrowPosition, dir) {
    if (placement === "center" || arrowPosition === "center") {
        return {
            left: arrowX
        };
    }
    if (placement === "end") {
        return {
            [dir === "ltr" ? "right" : "left"]: arrowOffset
        };
    }
    if (placement === "start") {
        return {
            [dir === "ltr" ? "left" : "right"]: arrowOffset
        };
    }
    return {};
}
const radiusByFloatingSide = {
    bottom: "borderTopLeftRadius",
    left: "borderTopRightRadius",
    right: "borderBottomLeftRadius",
    top: "borderBottomRightRadius"
};
function getArrowPositionStyles(param) {
    let { position , arrowSize , arrowOffset , arrowRadius , arrowPosition , arrowX , arrowY , dir  } = param;
    const [side, placement = "center"] = position.split("-");
    const baseStyles = {
        width: arrowSize,
        height: arrowSize,
        transform: "rotate(45deg)",
        position: "absolute",
        [radiusByFloatingSide[side]]: arrowRadius
    };
    const arrowPlacement = -arrowSize / 2;
    if (side === "left") {
        return {
            ...baseStyles,
            ...horizontalSide(placement, arrowY, arrowOffset, arrowPosition),
            right: arrowPlacement,
            borderLeftColor: "transparent",
            borderBottomColor: "transparent"
        };
    }
    if (side === "right") {
        return {
            ...baseStyles,
            ...horizontalSide(placement, arrowY, arrowOffset, arrowPosition),
            left: arrowPlacement,
            borderRightColor: "transparent",
            borderTopColor: "transparent"
        };
    }
    if (side === "top") {
        return {
            ...baseStyles,
            ...verticalSide(placement, arrowX, arrowOffset, arrowPosition, dir),
            bottom: arrowPlacement,
            borderTopColor: "transparent",
            borderLeftColor: "transparent"
        };
    }
    if (side === "bottom") {
        return {
            ...baseStyles,
            ...verticalSide(placement, arrowX, arrowOffset, arrowPosition, dir),
            top: arrowPlacement,
            borderBottomColor: "transparent",
            borderRightColor: "transparent"
        };
    }
    return {};
}


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Popover/subcomponents/Floating/FloatingArrow/FloatingArrow.mjs


const FloatingArrow = /*#__PURE__*/ (0,react.forwardRef)((param, ref)=>{
    let { position , arrowSize , arrowOffset , arrowRadius , arrowPosition , visible , arrowX , arrowY , style , ...others } = param;
    const dir = "ltr";
    if (!visible) {
        return null;
    }
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement("div", {
        ...others,
        ref,
        style: {
            ...style,
            ...getArrowPositionStyles({
                position,
                arrowSize,
                arrowOffset,
                arrowRadius,
                arrowPosition,
                dir,
                arrowX,
                arrowY
            })
        }
    });
});



/***/ }),

/***/ 86286:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ getFloatingPosition; }
/* harmony export */ });
function getFloatingPosition(dir, position) {
    return position;
}



/***/ }),

/***/ 96228:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ useFloatingAutoUpdate; }
/* harmony export */ });
/* harmony import */ var _floating_ui_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24750);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils_hooks_hooks_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55580);



function useFloatingAutoUpdate(param) {
    let { opened , floating , position , positionDependencies  } = param;
    const [delayedUpdate, setDelayedUpdate] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (floating.refs.reference.current && floating.refs.floating.current) {
            return (0,_floating_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .autoUpdate */ .Me)(floating.refs.reference.current, floating.refs.floating.current, floating.update);
        }
        return void 0;
    }, [
        floating.refs.reference.current,
        floating.refs.floating.current,
        opened,
        delayedUpdate,
        position
    ]);
    (0,_utils_hooks_hooks_mjs__WEBPACK_IMPORTED_MODULE_2__/* .useDidUpdate */ .lR)(()=>{
        floating.update();
    }, positionDependencies);
    (0,_utils_hooks_hooks_mjs__WEBPACK_IMPORTED_MODULE_2__/* .useDidUpdate */ .lR)(()=>{
        setDelayedUpdate((c)=>c + 1);
    }, [
        opened
    ]);
}



/***/ }),

/***/ 60169:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ isElement; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

function isElement(value) {
    if (Array.isArray(value) || value === null) {
        return false;
    }
    if (typeof value === "object") {
        if (value.type === react__WEBPACK_IMPORTED_MODULE_0__.Fragment) {
            return false;
        }
        return true;
    }
    return false;
}



/***/ }),

/***/ 68064:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Yx": function() { return /* binding */ useMergedRef; }
/* harmony export */ });
/* unused harmony exports assignRef, mergeRefs */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

function assignRef(ref, value) {
    if (typeof ref === "function") {
        ref(value);
    } else if (typeof ref === "object" && ref !== null && "current" in ref) {
        ref.current = value;
    }
}
function mergeRefs() {
    for(var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++){
        refs[_key] = arguments[_key];
    }
    return (node)=>{
        refs.forEach((ref)=>assignRef(ref, node));
    };
}
function useMergedRef() {
    for(var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++){
        refs[_key] = arguments[_key];
    }
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(mergeRefs(...refs), refs);
}



/***/ }),

/***/ 19975:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ createSafeContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

function createSafeContext(errorMessage) {
    const Context = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);
    const useSafeContext = ()=>{
        const ctx = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(Context);
        if (ctx === null) {
            throw new Error(errorMessage);
        }
        return ctx;
    };
    const Provider = (param)=>/* @__PURE__ */ /*#__PURE__*/ {
        let { children , value  } = param;
        return react__WEBPACK_IMPORTED_MODULE_0__.createElement(Context.Provider, {
            value
        }, children);
    };
    return [
        Provider,
        useSafeContext
    ];
}



/***/ }),

/***/ 99347:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fm": function() { return /* binding */ createPolymorphicComponent; },
/* harmony export */   "bq": function() { return /* binding */ polymorphicFactory; },
/* harmony export */   "d5": function() { return /* binding */ factory; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

function createPolymorphicComponent(component) {
    return component;
}
function polymorphicFactory(ui) {
    const Component = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(ui);
    return Component;
}
function factory(ui) {
    const Component = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(ui);
    return Component;
}



/***/ }),

/***/ 37892:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ds": function() { return /* binding */ debounce; },
/* harmony export */   "Kh": function() { return /* binding */ camelToKebabCase; },
/* harmony export */   "Q1": function() { return /* binding */ pxToRem; },
/* harmony export */   "XP": function() { return /* binding */ keys; },
/* harmony export */   "kR": function() { return /* binding */ assignRef; },
/* harmony export */   "rW": function() { return /* binding */ omitText; },
/* harmony export */   "t_": function() { return /* binding */ removeEmptyProps; },
/* harmony export */   "uZ": function() { return /* binding */ clamp; }
/* harmony export */ });
function camelToKebabCase(value) {
    return value.replace(/[A-Z]/g, (letter)=>"-".concat(letter.toLowerCase()));
}
function removeEmptyProps(obj) {
    return Object.fromEntries(Object.entries(obj).filter((param)=>{
        let [, v] = param;
        return v != null;
    }));
}
function pxToRem(pxValue) {
    let baseFontSize = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 16;
    if (typeof pxValue === "number") {
        pxValue = pxValue.toString() + "px";
    }
    if (pxValue.endsWith("px")) {
        const px = parseFloat(pxValue);
        const remValue = px / baseFontSize;
        return remValue + "rem";
    }
    return pxValue.toString();
}
function keys(object) {
    return Object.keys(object);
}
function assignRef(ref, value) {
    if (typeof ref === "function") {
        ref(value);
    } else if (typeof ref === "object" && ref !== null && "current" in ref) {
        ref.current = value;
    }
}
function clamp(value, min, max) {
    if (min === void 0 && max === void 0) {
        return value;
    }
    if (min !== void 0 && max === void 0) {
        return Math.max(value, min);
    }
    if (min === void 0 && max !== void 0) {
        return Math.min(value, max);
    }
    return Math.min(Math.max(value, min), max);
}
function isObject(value) {
    const type = typeof value;
    return value != null && (type === "object" || type === "function");
}
function debounce(func, wait, options) {
    let lastArgs;
    let lastThis;
    let maxWait;
    let result;
    let timerId;
    let lastCallTime;
    let lastInvokeTime = 0;
    let leading = false;
    let maxing = false;
    let trailing = true;
    if (typeof func !== "function") {
        throw new TypeError("Expected a function");
    }
    wait = +wait || 0;
    if (isObject(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? Math.max(+options.maxWait || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        const args = lastArgs;
        const thisArg = lastThis;
        lastArgs = lastThis = void 0;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function startTimer(pendingFunc, milliseconds) {
        return setTimeout(pendingFunc, milliseconds);
    }
    function cancelTimer(id) {
        clearTimeout(id);
    }
    function leadingEdge(time) {
        lastInvokeTime = time;
        timerId = startTimer(timerExpired, wait);
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        const timeSinceLastCall = time - (lastCallTime || 0);
        const timeSinceLastInvoke = time - lastInvokeTime;
        const timeWaiting = wait - timeSinceLastCall;
        return maxing ? Math.min(timeWaiting, (maxWait || 0) - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        const timeSinceLastCall = time - (lastCallTime || 0);
        const timeSinceLastInvoke = time - lastInvokeTime;
        return lastCallTime === void 0 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= (maxWait || 0);
    }
    function timerExpired() {
        const time = Date.now();
        if (shouldInvoke(time)) {
            return trailingEdge(time);
        }
        timerId = startTimer(timerExpired, remainingWait(time));
        return void 0;
    }
    function trailingEdge(time) {
        timerId = void 0;
        if (trailing && lastArgs) {
            return invokeFunc(time);
        }
        lastArgs = lastThis = void 0;
        return result;
    }
    function cancel() {
        if (timerId !== void 0) {
            cancelTimer(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = void 0;
    }
    function flush() {
        return timerId === void 0 ? result : trailingEdge(Date.now());
    }
    function pending() {
        return timerId !== void 0;
    }
    const debounced = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        const time = Date.now();
        const isInvoking = shouldInvoke(time);
        lastArgs = args;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === void 0) {
                return leadingEdge(lastCallTime);
            }
            if (maxing) {
                timerId = startTimer(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === void 0) {
            timerId = startTimer(timerExpired, wait);
        }
        return result;
    };
    debounced.cancel = cancel;
    debounced.flush = flush;
    debounced.pending = pending;
    return debounced;
}
function omitText(obj) {
    const { text: _ , ...rest } = obj;
    return rest;
}



/***/ }),

/***/ 55580:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LI": function() { return /* binding */ useIsomorphicLayoutEffect; },
/* harmony export */   "kw": function() { return /* binding */ useUnmount; },
/* harmony export */   "lR": function() { return /* binding */ useDidUpdate; },
/* harmony export */   "m2": function() { return /* binding */ useRandomClassName; },
/* harmony export */   "sm": function() { return /* binding */ useWindowEvent; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

function useRandomClassName() {
    const randomId = Math.random().toString(36).substring(2, 10);
    return "__m__-".concat(randomId);
}
function useWindowEvent(type, listener, options) {
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        window.addEventListener(type, listener, options);
        return ()=>window.removeEventListener(type, listener, options);
    }, [
        type,
        listener
    ]);
}
function useDidUpdate(fn, dependencies) {
    const mounted = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>()=>{
            mounted.current = false;
        }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (mounted.current) {
            return fn();
        }
        mounted.current = true;
        return void 0;
    }, dependencies);
}
const useIsomorphicLayoutEffect =  true ? react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect : 0;
function useUnmount(func) {
    const funcRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(func);
    funcRef.current = func;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>()=>{
            funcRef.current();
        }, []);
}



/***/ }),

/***/ 81985:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ useDebounceCallback; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _helpers_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37892);
/* harmony import */ var _hooks_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55580);



function useDebounceCallback(func) {
    let delay = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 500, options = arguments.length > 2 ? arguments[2] : void 0;
    const debouncedFunc = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    (0,_hooks_mjs__WEBPACK_IMPORTED_MODULE_1__/* .useUnmount */ .kw)(()=>{
        if (debouncedFunc.current) {
            debouncedFunc.current.cancel();
        }
    });
    const debounced = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>{
        const debouncedFuncInstance = (0,_helpers_mjs__WEBPACK_IMPORTED_MODULE_2__/* .debounce */ .Ds)(func, delay, options);
        const wrappedFunc = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            return debouncedFuncInstance(...args);
        };
        wrappedFunc.cancel = ()=>{
            debouncedFuncInstance.cancel();
        };
        wrappedFunc.isPending = ()=>{
            return !!debouncedFunc.current;
        };
        wrappedFunc.flush = ()=>{
            return debouncedFuncInstance.flush();
        };
        return wrappedFunc;
    }, [
        func,
        delay,
        options
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        debouncedFunc.current = (0,_helpers_mjs__WEBPACK_IMPORTED_MODULE_2__/* .debounce */ .Ds)(func, delay, options);
    }, [
        func,
        delay,
        options
    ]);
    return debounced;
}



/***/ }),

/***/ 79114:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "i": function() { return /* binding */ useWindowSize; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/utils/hooks/hooks.mjs
var hooks = __webpack_require__(55580);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/utils/hooks/use-debounce-callback.mjs
var use_debounce_callback = __webpack_require__(81985);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/utils/hooks/use-event-listener.mjs


function useEventListener(eventName, handler, element, options) {
    const savedHandler = (0,react.useRef)(handler);
    (0,hooks/* useIsomorphicLayoutEffect */.LI)(()=>{
        savedHandler.current = handler;
    }, [
        handler
    ]);
    (0,react.useEffect)(()=>{
        var ref;
        const targetElement = (ref = element === null || element === void 0 ? void 0 : element.current) !== null && ref !== void 0 ? ref : window;
        if (!(targetElement && targetElement.addEventListener)) return;
        const listener = (event)=>{
            savedHandler.current(event);
        };
        targetElement.addEventListener(eventName, listener, options);
        return ()=>{
            targetElement.removeEventListener(eventName, listener, options);
        };
    }, [
        eventName,
        element,
        options
    ]);
}


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/utils/hooks/use-window-size.mjs




const IS_SERVER = "object" === "undefined";
function useWindowSize() {
    let options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    let { initializeWithValue =true  } = options;
    if (IS_SERVER) {
        initializeWithValue = false;
    }
    const [windowSize, setWindowSize] = (0,react.useState)(()=>{
        if (initializeWithValue) {
            return {
                width: window.innerWidth,
                height: window.innerHeight
            };
        }
        return {
            width: void 0,
            height: void 0
        };
    });
    const debouncedSetWindowSize = (0,use_debounce_callback/* useDebounceCallback */.S)(setWindowSize, options.debounceDelay);
    function handleSize() {
        const setSize = options.debounceDelay ? debouncedSetWindowSize : setWindowSize;
        setSize({
            width: window.innerWidth,
            height: window.innerHeight
        });
    }
    useEventListener("resize", handleSize);
    (0,hooks/* useIsomorphicLayoutEffect */.LI)(()=>{
        handleSize();
    }, []);
    return windowSize;
}



/***/ }),

/***/ 4922:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "nM": function() { return /* binding */ parseStyleProps; }
});

// UNUSED EXPORTS: cssObjectToString, getBaseValue, getBreakpointKeys, getBreakpointValue, hasResponsiveStyles, stylesToString

;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/constants/breakpoints.mjs
const BREAKPOINTS = {
    xl: 1920,
    l: 1600,
    m: 1024,
    s: 640,
    xs: 320
};


// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/utils/helpers.mjs
var helpers = __webpack_require__(37892);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/utils/mediaQuery.mjs
function replaceMediaQuery(query) {
    return query.replace("(width <", "").replace("px)", "");
}
function sortMediaQueries(param) {
    let { media , ...props } = param;
    const breakpoints = Object.keys(media);
    const sortedMedia = breakpoints.sort((a, b)=>Number(replaceMediaQuery(b)) - Number(replaceMediaQuery(a))).map((query)=>({
            query,
            styles: media[query]
        }));
    return {
        ...props,
        media: sortedMedia
    };
}


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/utils/resolvers.mjs

function colorResolver(color) {
    if (typeof color === "string") return color;
    return color;
}
function fontFamilyResolver(fontFamily) {
    const fontFamilyValues = {
        text: "var(--serif-font-family)"
    };
    if (typeof fontFamily === "string" && fontFamily in fontFamilyValues) {
        return fontFamilyValues[fontFamily];
    }
    return fontFamily;
}
function fontSizeResolver(value) {
    if (typeof value === "number") {
        return (0,helpers/* pxToRem */.Q1)(value);
    }
    if (typeof value === "string") {
        if (value.endsWith("px")) {
            return (0,helpers/* pxToRem */.Q1)(value);
        } else if (value.endsWith("rem")) {
            return value;
        }
    }
    return value;
}
function identityResolver(value) {
    return value;
}
function sizeResolver(value) {
    if (typeof value === "number") {
        return "".concat(value, "px");
    }
    return value;
}
function spacingResolver(value) {
    if (typeof value === "number" || !isNaN(Number(value))) {
        return "".concat(value, "px");
    }
    if (typeof value === "string") {
        return "".concat(value);
    }
    return value;
}
function lineHeightResolver(value) {
    if (typeof value === "number") {
        return "".concat(value, "px");
    }
    if (typeof value === "string") {
        return "".concat(value);
    }
    return value;
}
const resolvers = {
    identity: identityResolver,
    size: sizeResolver,
    spacing: spacingResolver,
    color: colorResolver,
    textColor: colorResolver,
    fontSize: fontSizeResolver,
    lineHeight: lineHeightResolver,
    fontFamily: fontFamilyResolver
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/utils/styleProps.mjs




function stylesToString(param) {
    let { selector , styles , media  } = param;
    const baseStyles = styles ? cssObjectToString(styles) : "";
    const mediaQueryStyles = !Array.isArray(media) ? [] : media.map((item)=>"@media ".concat(item.query, "{").concat(selector, "{").concat(cssObjectToString(item.styles), "}}"));
    return "".concat(baseStyles ? "".concat(selector, "{").concat(baseStyles, "}") : "").concat(mediaQueryStyles.join("")).trim();
}
function cssObjectToString(css) {
    return keys(css).reduce((acc, rule)=>css[rule] !== void 0 ? "".concat(acc).concat(camelToKebabCase(rule), ":").concat(css[rule], ";") : acc, "").trim();
}
function hasResponsiveStyles(styleProp) {
    if (typeof styleProp !== "object" || styleProp === null) {
        return false;
    }
    const breakpoints = Object.keys(styleProp);
    if (breakpoints.length === 1 && breakpoints[0] === "base") {
        return false;
    }
    return true;
}
function getBaseValue(value) {
    if (typeof value === "object" && value !== null) {
        if ("base" in value) {
            return value.base;
        }
        return void 0;
    }
    return value;
}
function getBreakpointKeys(value) {
    if (typeof value === "object" && value !== null) {
        return (0,helpers/* keys */.XP)(value).filter((key)=>key !== "base");
    }
    return [];
}
function getBreakpointValue(value, breakpoint) {
    if (typeof value === "object" && value !== null && breakpoint in value) {
        return value[breakpoint];
    }
    return value;
}
function parseStyleProps(param) {
    let { styleProps , data  } = param;
    return sortMediaQueries((0,helpers/* keys */.XP)(styleProps).reduce((acc, styleProp)=>{
        const propertyData = data[styleProp];
        const properties = Array.isArray(propertyData.property) ? propertyData.property : [
            propertyData.property
        ];
        const baseValue = getBaseValue(styleProps[styleProp]);
        if (!hasResponsiveStyles(styleProps[styleProp])) {
            properties.forEach((property)=>{
                acc.inlineStyles[property] = resolvers[propertyData.type](baseValue);
            });
            return acc;
        }
        acc.hasResponsiveStyles = true;
        const breakpoints = getBreakpointKeys(styleProps[styleProp]);
        if (baseValue !== void 0) {
            acc.styles[styleProp] = baseValue;
        }
        properties.forEach((property)=>{
            if (baseValue) {
                acc.styles[property] = resolvers[propertyData.type](baseValue);
            }
            breakpoints.forEach((breakpoint)=>{
                const bp = "(width < ".concat(BREAKPOINTS[breakpoint], "px)");
                acc.media[bp] = {
                    ...acc.media[bp],
                    [property]: resolvers[propertyData.type](getBreakpointValue(styleProps[styleProp], breakpoint))
                };
            });
        });
        return acc;
    }, {
        hasResponsiveStyles: false,
        inlineStyles: {},
        styles: {},
        media: {}
    }));
}



/***/ }),

/***/ 60068:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ ArrowDownBoldIcon; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _constants_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94802);


const withoutBoundingBoxWidth = {
    large: 30,
    medium: 22,
    small: 16,
    xSmall: 12
};
const ArrowDownBoldIcon = (param)=>{
    let { size ="medium" , withBoundingBox =true , ...others } = param;
    let iconWidth, iconHeight;
    if (typeof size === "string") {
        iconWidth = withBoundingBox ? _constants_mjs__WEBPACK_IMPORTED_MODULE_1__/* .iconSize */ .E[size] : withoutBoundingBoxWidth[size];
        iconHeight = _constants_mjs__WEBPACK_IMPORTED_MODULE_1__/* .iconSize */ .E[size];
    } else {
        iconWidth = size;
        iconHeight = size;
    }
    return /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: iconWidth,
        height: iconHeight,
        viewBox: "0 0 16 16",
        preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
        fill: "none",
        ...others
    }, /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.3703 5L13 5.49483L8 11L3 5.49483L3.60175 5L8 9.76294L12.3703 5Z",
        fill: "currentColor"
    }), /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.3703 5L13 5.49483L8 11L3 5.49483L3.60175 5L8 9.76294L12.3703 5Z",
        fill: "currentColor"
    }), /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.3703 5L13 5.49483L8 11L3 5.49483L3.60175 5L8 9.76294L12.3703 5Z",
        stroke: "currentColor"
    }), /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.3703 5L13 5.49483L8 11L3 5.49483L3.60175 5L8 9.76294L12.3703 5Z",
        stroke: "currentColor"
    }));
};
ArrowDownBoldIcon.iconName = "ArrowDownBoldIcon";



/***/ }),

/***/ 62281:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ ArrowDownIcon; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _constants_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94802);


const withoutBoundingBoxWidth = {
    large: 30,
    medium: 22,
    small: 16,
    xSmall: 10
};
const ArrowDownIcon = (param)=>{
    let { size ="medium" , withBoundingBox =true , ...others } = param;
    let iconWidth, iconHeight;
    if (typeof size === "string") {
        iconWidth = withBoundingBox ? _constants_mjs__WEBPACK_IMPORTED_MODULE_1__/* .iconSize */ .E[size] : withoutBoundingBoxWidth[size];
        iconHeight = _constants_mjs__WEBPACK_IMPORTED_MODULE_1__/* .iconSize */ .E[size];
    } else {
        iconWidth = size;
        iconHeight = size;
    }
    const renderIcon = ()=>{
        switch(size){
            case "large":
                return /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: iconWidth,
                    height: iconHeight,
                    viewBox: "0 0 40 40",
                    preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
                    fill: "none",
                    ...others
                }, /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M34.2662 11L35 11.6545L20 29L5 11.6357L5.76447 11.0188L20 27.4463L34.2662 11Z",
                    fill: "currentColor"
                }));
            case "small":
            case "xSmall":
                return /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: iconWidth,
                    height: iconHeight,
                    viewBox: "0 0 20 20",
                    preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
                    fill: "none",
                    ...others
                }, /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M17.135 5.45996L17.8645 6.1439L9.99978 14.533L2.13501 6.1439L2.86455 5.45996L9.99978 13.0709L17.135 5.45996Z",
                    fill: "white"
                }), /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M17.135 5.45996L17.8645 6.1439L9.99978 14.533L2.13501 6.1439L2.86455 5.45996L9.99978 13.0709L17.135 5.45996Z",
                    fill: "currentColor"
                }));
            case "medium":
            default:
                return /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: iconWidth,
                    height: iconHeight,
                    viewBox: "0 0 30 30",
                    preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
                    fill: "none",
                    ...others
                }, /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M4.75258 9L4 9.6585L15 22L26 9.6396L25.216 9.0189L15 20.5472L4.75258 9Z",
                    fill: "currentColor"
                }));
        }
    };
    return /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, renderIcon());
};
ArrowDownIcon.iconName = "ArrowDownIcon";



/***/ }),

/***/ 64260:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ ArrowRightBoldIcon; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _constants_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94802);


const withoutBoundingBoxWidth = {
    large: 19,
    medium: 16,
    small: 12,
    xSmall: 9
};
const ArrowRightBoldIcon = (param)=>{
    let { size ="medium" , withBoundingBox =true , ...others } = param;
    let iconWidth, iconHeight;
    if (typeof size === "string") {
        iconWidth = withBoundingBox ? _constants_mjs__WEBPACK_IMPORTED_MODULE_1__/* .iconSize */ .E[size] : withoutBoundingBoxWidth[size];
        iconHeight = _constants_mjs__WEBPACK_IMPORTED_MODULE_1__/* .iconSize */ .E[size];
    } else {
        iconWidth = size;
        iconHeight = size;
    }
    return /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: iconWidth,
        height: iconHeight,
        viewBox: "0 0 16 16",
        preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
        fill: "none",
        ...others
    }, /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5 3.62971L5.49483 3L11 8L5.49483 13L5 12.3982L9.76294 8L5 3.62971Z",
        fill: "currentColor"
    }), /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5 3.62971L5.49483 3L11 8L5.49483 13L5 12.3982L9.76294 8L5 3.62971Z",
        fill: "currentColor"
    }), /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5 3.62971L5.49483 3L11 8L5.49483 13L5 12.3982L9.76294 8L5 3.62971Z",
        stroke: "currentColor"
    }), /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5 3.62971L5.49483 3L11 8L5.49483 13L5 12.3982L9.76294 8L5 3.62971Z",
        stroke: "currentColor"
    }));
};
ArrowRightBoldIcon.iconName = "ArrowRightBoldIcon";



/***/ }),

/***/ 51782:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ ArrowRightIcon; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _constants_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94802);


const withoutBoundingBoxWidth = {
    large: 18,
    medium: 13,
    small: 9,
    xSmall: 9
};
const ArrowRightIcon = (param)=>{
    let { size ="medium" , withBoundingBox =true , ...others } = param;
    let iconWidth, iconHeight;
    if (typeof size === "string") {
        iconWidth = withBoundingBox ? _constants_mjs__WEBPACK_IMPORTED_MODULE_1__/* .iconSize */ .E[size] : withoutBoundingBoxWidth[size];
        iconHeight = _constants_mjs__WEBPACK_IMPORTED_MODULE_1__/* .iconSize */ .E[size];
    } else {
        iconWidth = size;
        iconHeight = size;
    }
    const renderIcon = ()=>{
        switch(size){
            case "large":
                return /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: iconWidth,
                    height: iconHeight,
                    viewBox: "0 0 40 40",
                    preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
                    fill: "none",
                    ...others
                }, /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M11 5.73378L11.6545 5L29 20L11.6357 35L11.0188 34.2355L27.4463 20L11 5.73378Z",
                    fill: "currentColor"
                }));
            case "small":
            case "xSmall":
                return /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: iconWidth,
                    height: iconHeight,
                    viewBox: "0 0 20 20",
                    preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
                    fill: "none",
                    ...others
                }, /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M5.45996 17.1399L6.1439 17.8694L14.533 10.0047L6.1439 2.13989L5.45996 2.86943L13.0709 10.0047L5.45996 17.1399Z",
                    fill: "white"
                }), /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M5.45996 17.1399L6.1439 17.8694L14.533 10.0047L6.1439 2.13989L5.45996 2.86943L13.0709 10.0047L5.45996 17.1399Z",
                    fill: "currentColor"
                }));
            case "medium":
            default:
                return /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: iconWidth,
                    height: iconHeight,
                    viewBox: "0 0 30 30",
                    preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
                    fill: "none",
                    ...others
                }, /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M9 25.2474L9.6585 26L22 15L9.63961 4L9.0189 4.78404L20.5472 15L9 25.2474Z",
                    fill: "currentColor"
                }));
        }
    };
    return /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, renderIcon());
};
ArrowRightIcon.iconName = "ArrowRightIcon";



/***/ }),

/***/ 61599:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ CloseIcon; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _constants_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94802);


const withoutBoundingBoxWidth = {
    large: 30,
    medium: 17,
    small: 10,
    xSmall: 10
};
const CloseIcon = (param)=>{
    let { size ="medium" , withBoundingBox =true , ...others } = param;
    let iconWidth, iconHeight;
    if (typeof size === "string") {
        iconWidth = withBoundingBox ? _constants_mjs__WEBPACK_IMPORTED_MODULE_1__/* .iconSize */ .E[size] : withoutBoundingBoxWidth[size];
        iconHeight = _constants_mjs__WEBPACK_IMPORTED_MODULE_1__/* .iconSize */ .E[size];
    } else {
        iconWidth = size;
        iconHeight = size;
    }
    const renderIcon = ()=>{
        switch(size){
            case "large":
                return /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: iconWidth,
                    height: iconHeight,
                    viewBox: "0 0 40 40",
                    preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
                    fill: "none",
                    ...others
                }, /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
                    d: "M20.3521 20.0021L33.7871 6.56709L33.08 5.85999L19.645 19.295L6.91707 6.56709L6.20996 7.2742L18.9379 20.0021L6.20996 32.73L6.91707 33.4371L19.645 20.7092L33.08 34.1443L33.7871 33.4371L20.3521 20.0021Z",
                    fill: "currentColor"
                }));
            case "xSmall":
                return /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: iconWidth,
                    height: iconHeight,
                    viewBox: "0 0 16 16",
                    preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
                    fill: "none",
                    ...others
                }, /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
                    d: "M3.70428 3L12.8599 12.2857L12.1556 13L3 3.71429L3.70428 3Z",
                    fill: "currentColor"
                }), /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
                    d: "M12.2957 3.00001L3.1401 12.2857L3.84438 13L13 3.71429L12.2957 3.00001Z",
                    fill: "currentColor"
                }));
            case "small":
                return /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: iconWidth,
                    height: iconHeight,
                    viewBox: "0 0 20 20",
                    preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
                    fill: "none",
                    ...others
                }, /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
                    d: "M5.70428 5L14.8599 14.2857L14.1556 15L5 5.71429L5.70428 5Z",
                    fill: "currentColor"
                }), /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
                    d: "M14.2957 5.00001L5.1401 14.2857L5.84438 15L15 5.71429L14.2957 5.00001Z",
                    fill: "currentColor"
                }));
            case "medium":
            default:
                return /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: iconWidth,
                    height: iconHeight,
                    viewBox: "0 0 30 30",
                    preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
                    fill: "none",
                    ...others
                }, /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
                    d: "M14.7609 15.4999L7 22.9245L7.73913 23.6316L15.5 16.207L23.2609 23.6316L24 22.9245L16.2391 15.4999L24 8.07527L23.2609 7.36816L15.5 14.7928L7.73913 7.36816L7 8.07527L14.7609 15.4999Z",
                    fill: "currentColor"
                }), /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
                    d: "M14.7609 15.4999L7 22.9245L7.73913 23.6316L15.5 16.207L23.2609 23.6316L24 22.9245L16.2391 15.4999L24 8.07527L23.2609 7.36816L15.5 14.7928L7.73913 7.36816L7 8.07527L14.7609 15.4999Z",
                    fill: "currentColor"
                }));
        }
    };
    return /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, renderIcon());
};
CloseIcon.iconName = "CloseIcon";



/***/ }),

/***/ 24665:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ MenuIcon; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _constants_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94802);


const withoutBoundingBoxWidth = {
    large: 26,
    medium: 20,
    small: 13,
    xSmall: 10
};
const MenuIcon = (param)=>{
    let { size ="medium" , withBoundingBox =true , ...others } = param;
    let iconWidth, iconHeight;
    if (typeof size === "string") {
        iconWidth = withBoundingBox ? _constants_mjs__WEBPACK_IMPORTED_MODULE_1__/* .iconSize */ .E[size] : withoutBoundingBoxWidth[size];
        iconHeight = _constants_mjs__WEBPACK_IMPORTED_MODULE_1__/* .iconSize */ .E[size];
    } else {
        iconWidth = size;
        iconHeight = size;
    }
    return /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: iconWidth,
        height: iconHeight,
        viewBox: "0 0 30 30",
        preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
        fill: "none",
        ...others
    }, /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        d: "M5 7.5H25V8.5H5V7.5Z",
        fill: "currentColor"
    }), /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        d: "M5 14.5H25V15.5H5V14.5Z",
        fill: "currentColor"
    }), /* @__PURE__ */ /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        d: "M25 21.5H5V22.5H25V21.5Z",
        fill: "currentColor"
    }));
};
MenuIcon.iconName = "MenuIcon";



/***/ }),

/***/ 94802:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ iconSize; }
/* harmony export */ });
const iconSize = {
    large: 40,
    medium: 30,
    small: 20,
    xSmall: 16
};



/***/ }),

/***/ 92186:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ChangePassword":"ChangePassword_ChangePassword__EXQIE","ChangePassword_ChangePassword__EXQIE":"ChangePassword_ChangePassword_ChangePassword__EXQIE__0iYCY","wrapper":"ChangePassword_wrapper__b7Otu","Button_buttonWrapper__9Vvy_":"ChangePassword_Button_buttonWrapper__9Vvy___2C3rT","button":"ChangePassword_button__PC3iI","large":"ChangePassword_large__vIg_s","kf-react-button":"ChangePassword_kf-react-button__094_k","Input_inputFieldWrapper__nt6o0":"ChangePassword_Input_inputFieldWrapper__nt6o0__V8Dub","input-field__value":"ChangePassword_input-field__value__RmQ0l","kf-change-re-password-wrapper":"ChangePassword_kf-change-re-password-wrapper__yNcoL"};

/***/ }),

/***/ 50238:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"authUtilityNavWrapper":"AuthUtilityNav_authUtilityNavWrapper__iJgYU"};

/***/ }),

/***/ 43419:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"CarouselSlickVertical":"CarouselSlick_CarouselSlickVertical__Ff6xM"};

/***/ }),

/***/ 19371:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"countrySelectorMain":"CountryUtilNav_countrySelectorMain__0qrTO","fadeout":"CountryUtilNav_fadeout__5AsJW","fadein":"CountryUtilNav_fadein__g_qQo"};

/***/ }),

/***/ 31901:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"dynamicSearchViewWrapper":"DynamicSearch_view_dynamicSearchViewWrapper__QSYex"};

/***/ }),

/***/ 38326:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"promoBannerWrapper":"v1_promoBannerWrapper__J4Pwk"};

/***/ }),

/***/ 62271:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"findAProByZipWrapper":"v1_findAProByZipWrapper__9w7Jq"};

/***/ }),

/***/ 4201:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"findAStoreUtilNavWrapper":"v1_findAStoreUtilNavWrapper__zMdNe","findstore-util-nav__container":"v1_findstore-util-nav__container__jdVZe","findstore-util-nav__link-container":"v1_findstore-util-nav__link-container__3HSN5"};

/***/ }),

/***/ 95816:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"helpSupportWrapper":"v1_helpSupportWrapper__iyvnc"};

/***/ }),

/***/ 2145:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"inPageSearchWrapper":"v1_inPageSearchWrapper__yAfDs"};

/***/ }),

/***/ 16214:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"CartModalViewer":"AddCart_CartModalViewer__w61Q_"};

/***/ }),

/***/ 35423:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"NotifyContianer":"notify_NotifyContianer__Ht64s"};

/***/ }),

/***/ 32353:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"PrintShareWindow":"PrintShareWindow_PrintShareWindow__oorkb"};

/***/ }),

/***/ 36697:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"PrintModal":"PrintWindow_PrintModal__vIytV"};

/***/ }),

/***/ 83000:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"PrintShare":"PrintShare_PrintShare__LiGLM"};

/***/ }),

/***/ 22222:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"PartDiagramViewer":"partviewer_PartDiagramViewer__9cI0v"};

/***/ }),

/***/ 81881:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"roomDetailWrapper":"v1_roomDetailWrapper__hARgi"};

/***/ }),

/***/ 73712:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"genericErrorWrapper":"ErrorBoundary_genericErrorWrapper__L7bus","Container":"ErrorBoundary_Container__YWJpS"};

/***/ }),

/***/ 52498:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"headerNavV3Wrapper":"HeaderNavTabs_headerNavV3Wrapper__HLJt6"};

/***/ }),

/***/ 62582:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NewsletterFooter_wrapper__YlEqt","gbh-footer-news-letter":"NewsletterFooter_gbh-footer-news-letter__J0nKA","form-group":"NewsletterFooter_form-group__RUpge","form-control":"NewsletterFooter_form-control__cT7ti","btn":"NewsletterFooter_btn__VWVsj","fadeInDown":"NewsletterFooter_fadeInDown__DQU3a"};

/***/ }),

/***/ 76118:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"socialShareWrapper":"socialShare_socialShareWrapper__75zX6"};

/***/ }),

/***/ 20079:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"curatedProduct":"ProductCardForUpsell_curatedProduct__p6aK_"};

/***/ }),

/***/ 84181:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"utilityWidgetsWrapper":"UtilityWidgets_utilityWidgetsWrapper__Wz0ZS"};

/***/ }),

/***/ 99701:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ProductWrapper":"VisualNav_ProductWrapper___vAot"};

/***/ }),

/***/ 3738:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"additionalFooterWrapper":"Shared_additionalFooterWrapper__OtCXx","mainFooterWrapper":"Shared_mainFooterWrapper__gUYOZ","utilityNavHeaderWrapper":"Shared_utilityNavHeaderWrapper__F3u85"};

/***/ }),

/***/ 95179:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"shopTheRoomDetailWrapper":"v1_shopTheRoomDetailWrapper__2KLb_"};

/***/ }),

/***/ 98609:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"modalWrapper":"modal_modalWrapper__ny6eQ"};

/***/ }),

/***/ 31201:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"overlayWrapper":"overlay_overlayWrapper__Wlipe"};

/***/ }),

/***/ 72681:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"storeAppointMentWrapper":"v1_storeAppointMentWrapper__u0MDb"};

/***/ }),

/***/ 18682:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"CameraView":"cameraview_CameraView__B9zfz","fade":"cameraview_fade___MpvA"};

/***/ }),

/***/ 53163:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ComingSoonContainer":"comingSoon_ComingSoonContainer__gVWpu"};

/***/ }),

/***/ 16899:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ErrorContainer":"ErrorFallBack_ErrorContainer__akLzn"};

/***/ }),

/***/ 3856:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"LoadingImage":"loadingdata_LoadingImage__2k9_d"};

/***/ }),

/***/ 9527:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"QRCodeWrapper":"QRCode_QRCodeWrapper__WJi_L"};

/***/ }),

/***/ 71964:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"SelectProductCategoryWrapper":"SelectProductCategory_SelectProductCategoryWrapper__NFY_m"};

/***/ }),

/***/ 948:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"UploadImageContainer":"uploadImage_UploadImageContainer__Ho5eB","slideUp":"uploadImage_slideUp__ZusDv","QrWrapper":"uploadImage_QrWrapper__lKL2o"};

/***/ }),

/***/ 26657:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"VisualSearchContainer":"visualsearch_VisualSearchContainer__jm5Jl"};

/***/ }),

/***/ 56387:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"autoSuggetionWrapper":"v1_autoSuggetionWrapper__DHuiH"};

/***/ }),

/***/ 77529:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"buttonWrapper":"Button_buttonWrapper__9Vvy_","load":"Button_load___Y_wM"};

/***/ }),

/***/ 43090:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"checkboxWrapper":"Checkbox_checkboxWrapper__Fv9jK","inlineCheckbox":"Checkbox_inlineCheckbox__s9vUb"};

/***/ }),

/***/ 21531:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"inputFieldWrapper":"Input_inputFieldWrapper__nt6o0"};

/***/ }),

/***/ 43106:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"modalWrapper":"Modal_modalWrapper__asWMh"};

/***/ }),

/***/ 20889:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"pageLoaderWrapper":"PageLoader_pageLoaderWrapper__0QMuD"};

/***/ }),

/***/ 81918:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"reCatichWrapper":"Recaptcha_reCatichWrapper__pIvbo"};

/***/ }),

/***/ 26075:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tooltipWrapper":"Tooltip_tooltipWrapper__2DB1H"};

/***/ }),

/***/ 5417:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"hotspotProductCardWraper":"Hotspot_hotspotProductCardWraper__lT6qX"};

/***/ }),

/***/ 53613:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"productCardWrapper":"v1_productCardWrapper__A0Nig"};

/***/ }),

/***/ 80597:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"productCardWrapper":"v3_productCardWrapper__FIxaK"};

/***/ }),

/***/ 95828:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 28380:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 34571:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 63911:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 93054:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 81076:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 1864:
/***/ (function(module) {

var __dirname = "/";
(function(){"use strict";var e={114:function(e){function assertPath(e){if(typeof e!=="string"){throw new TypeError("Path must be a string. Received "+JSON.stringify(e))}}function normalizeStringPosix(e,r){var t="";var i=0;var n=-1;var a=0;var f;for(var l=0;l<=e.length;++l){if(l<e.length)f=e.charCodeAt(l);else if(f===47)break;else f=47;if(f===47){if(n===l-1||a===1){}else if(n!==l-1&&a===2){if(t.length<2||i!==2||t.charCodeAt(t.length-1)!==46||t.charCodeAt(t.length-2)!==46){if(t.length>2){var s=t.lastIndexOf("/");if(s!==t.length-1){if(s===-1){t="";i=0}else{t=t.slice(0,s);i=t.length-1-t.lastIndexOf("/")}n=l;a=0;continue}}else if(t.length===2||t.length===1){t="";i=0;n=l;a=0;continue}}if(r){if(t.length>0)t+="/..";else t="..";i=2}}else{if(t.length>0)t+="/"+e.slice(n+1,l);else t=e.slice(n+1,l);i=l-n-1}n=l;a=0}else if(f===46&&a!==-1){++a}else{a=-1}}return t}function _format(e,r){var t=r.dir||r.root;var i=r.base||(r.name||"")+(r.ext||"");if(!t){return i}if(t===r.root){return t+i}return t+e+i}var r={resolve:function resolve(){var e="";var r=false;var t;for(var i=arguments.length-1;i>=-1&&!r;i--){var n;if(i>=0)n=arguments[i];else{if(t===undefined)t="";n=t}assertPath(n);if(n.length===0){continue}e=n+"/"+e;r=n.charCodeAt(0)===47}e=normalizeStringPosix(e,!r);if(r){if(e.length>0)return"/"+e;else return"/"}else if(e.length>0){return e}else{return"."}},normalize:function normalize(e){assertPath(e);if(e.length===0)return".";var r=e.charCodeAt(0)===47;var t=e.charCodeAt(e.length-1)===47;e=normalizeStringPosix(e,!r);if(e.length===0&&!r)e=".";if(e.length>0&&t)e+="/";if(r)return"/"+e;return e},isAbsolute:function isAbsolute(e){assertPath(e);return e.length>0&&e.charCodeAt(0)===47},join:function join(){if(arguments.length===0)return".";var e;for(var t=0;t<arguments.length;++t){var i=arguments[t];assertPath(i);if(i.length>0){if(e===undefined)e=i;else e+="/"+i}}if(e===undefined)return".";return r.normalize(e)},relative:function relative(e,t){assertPath(e);assertPath(t);if(e===t)return"";e=r.resolve(e);t=r.resolve(t);if(e===t)return"";var i=1;for(;i<e.length;++i){if(e.charCodeAt(i)!==47)break}var n=e.length;var a=n-i;var f=1;for(;f<t.length;++f){if(t.charCodeAt(f)!==47)break}var l=t.length;var s=l-f;var o=a<s?a:s;var u=-1;var h=0;for(;h<=o;++h){if(h===o){if(s>o){if(t.charCodeAt(f+h)===47){return t.slice(f+h+1)}else if(h===0){return t.slice(f+h)}}else if(a>o){if(e.charCodeAt(i+h)===47){u=h}else if(h===0){u=0}}break}var c=e.charCodeAt(i+h);var v=t.charCodeAt(f+h);if(c!==v)break;else if(c===47)u=h}var g="";for(h=i+u+1;h<=n;++h){if(h===n||e.charCodeAt(h)===47){if(g.length===0)g+="..";else g+="/.."}}if(g.length>0)return g+t.slice(f+u);else{f+=u;if(t.charCodeAt(f)===47)++f;return t.slice(f)}},_makeLong:function _makeLong(e){return e},dirname:function dirname(e){assertPath(e);if(e.length===0)return".";var r=e.charCodeAt(0);var t=r===47;var i=-1;var n=true;for(var a=e.length-1;a>=1;--a){r=e.charCodeAt(a);if(r===47){if(!n){i=a;break}}else{n=false}}if(i===-1)return t?"/":".";if(t&&i===1)return"//";return e.slice(0,i)},basename:function basename(e,r){if(r!==undefined&&typeof r!=="string")throw new TypeError('"ext" argument must be a string');assertPath(e);var t=0;var i=-1;var n=true;var a;if(r!==undefined&&r.length>0&&r.length<=e.length){if(r.length===e.length&&r===e)return"";var f=r.length-1;var l=-1;for(a=e.length-1;a>=0;--a){var s=e.charCodeAt(a);if(s===47){if(!n){t=a+1;break}}else{if(l===-1){n=false;l=a+1}if(f>=0){if(s===r.charCodeAt(f)){if(--f===-1){i=a}}else{f=-1;i=l}}}}if(t===i)i=l;else if(i===-1)i=e.length;return e.slice(t,i)}else{for(a=e.length-1;a>=0;--a){if(e.charCodeAt(a)===47){if(!n){t=a+1;break}}else if(i===-1){n=false;i=a+1}}if(i===-1)return"";return e.slice(t,i)}},extname:function extname(e){assertPath(e);var r=-1;var t=0;var i=-1;var n=true;var a=0;for(var f=e.length-1;f>=0;--f){var l=e.charCodeAt(f);if(l===47){if(!n){t=f+1;break}continue}if(i===-1){n=false;i=f+1}if(l===46){if(r===-1)r=f;else if(a!==1)a=1}else if(r!==-1){a=-1}}if(r===-1||i===-1||a===0||a===1&&r===i-1&&r===t+1){return""}return e.slice(r,i)},format:function format(e){if(e===null||typeof e!=="object"){throw new TypeError('The "pathObject" argument must be of type Object. Received type '+typeof e)}return _format("/",e)},parse:function parse(e){assertPath(e);var r={root:"",dir:"",base:"",ext:"",name:""};if(e.length===0)return r;var t=e.charCodeAt(0);var i=t===47;var n;if(i){r.root="/";n=1}else{n=0}var a=-1;var f=0;var l=-1;var s=true;var o=e.length-1;var u=0;for(;o>=n;--o){t=e.charCodeAt(o);if(t===47){if(!s){f=o+1;break}continue}if(l===-1){s=false;l=o+1}if(t===46){if(a===-1)a=o;else if(u!==1)u=1}else if(a!==-1){u=-1}}if(a===-1||l===-1||u===0||u===1&&a===l-1&&a===f+1){if(l!==-1){if(f===0&&i)r.base=r.name=e.slice(1,l);else r.base=r.name=e.slice(f,l)}}else{if(f===0&&i){r.name=e.slice(1,a);r.base=e.slice(1,l)}else{r.name=e.slice(f,a);r.base=e.slice(f,l)}r.ext=e.slice(a,l)}if(f>0)r.dir=e.slice(0,f-1);else if(i)r.dir="/";return r},sep:"/",delimiter:":",win32:null,posix:null};r.posix=r;e.exports=r}};var r={};function __nccwpck_require__(t){var i=r[t];if(i!==undefined){return i.exports}var n=r[t]={exports:{}};var a=true;try{e[t](n,n.exports,__nccwpck_require__);a=false}finally{if(a)delete r[t]}return n.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var t=__nccwpck_require__(114);module.exports=t})();

/***/ }),

/***/ 77663:
/***/ (function(module) {

var __dirname = "/";
(function(){var e={229:function(e){var t=e.exports={};var r;var n;function defaultSetTimout(){throw new Error("setTimeout has not been defined")}function defaultClearTimeout(){throw new Error("clearTimeout has not been defined")}(function(){try{if(typeof setTimeout==="function"){r=setTimeout}else{r=defaultSetTimout}}catch(e){r=defaultSetTimout}try{if(typeof clearTimeout==="function"){n=clearTimeout}else{n=defaultClearTimeout}}catch(e){n=defaultClearTimeout}})();function runTimeout(e){if(r===setTimeout){return setTimeout(e,0)}if((r===defaultSetTimout||!r)&&setTimeout){r=setTimeout;return setTimeout(e,0)}try{return r(e,0)}catch(t){try{return r.call(null,e,0)}catch(t){return r.call(this,e,0)}}}function runClearTimeout(e){if(n===clearTimeout){return clearTimeout(e)}if((n===defaultClearTimeout||!n)&&clearTimeout){n=clearTimeout;return clearTimeout(e)}try{return n(e)}catch(t){try{return n.call(null,e)}catch(t){return n.call(this,e)}}}var i=[];var o=false;var u;var a=-1;function cleanUpNextTick(){if(!o||!u){return}o=false;if(u.length){i=u.concat(i)}else{a=-1}if(i.length){drainQueue()}}function drainQueue(){if(o){return}var e=runTimeout(cleanUpNextTick);o=true;var t=i.length;while(t){u=i;i=[];while(++a<t){if(u){u[a].run()}}a=-1;t=i.length}u=null;o=false;runClearTimeout(e)}t.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1){for(var r=1;r<arguments.length;r++){t[r-1]=arguments[r]}}i.push(new Item(e,t));if(i.length===1&&!o){runTimeout(drainQueue)}};function Item(e,t){this.fun=e;this.array=t}Item.prototype.run=function(){this.fun.apply(null,this.array)};t.title="browser";t.browser=true;t.env={};t.argv=[];t.version="";t.versions={};function noop(){}t.on=noop;t.addListener=noop;t.once=noop;t.off=noop;t.removeListener=noop;t.removeAllListeners=noop;t.emit=noop;t.prependListener=noop;t.prependOnceListener=noop;t.listeners=function(e){return[]};t.binding=function(e){throw new Error("process.binding is not supported")};t.cwd=function(){return"/"};t.chdir=function(e){throw new Error("process.chdir is not supported")};t.umask=function(){return 0}}};var t={};function __nccwpck_require__(r){var n=t[r];if(n!==undefined){return n.exports}var i=t[r]={exports:{}};var o=true;try{e[r](i,i.exports,__nccwpck_require__);o=false}finally{if(o)delete t[r]}return i.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var r=__nccwpck_require__(229);module.exports=r})();

/***/ }),

/***/ 5152:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(37645)


/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(83121)


/***/ }),

/***/ 25675:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(19749)


/***/ }),

/***/ 41664:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(31551)


/***/ }),

/***/ 11163:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(80880)


/***/ }),

/***/ 4298:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports =
   false
    ? 0
    : __webpack_require__(63573)


/***/ }),

/***/ 70631:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var hasMap = typeof Map === 'function' && Map.prototype;
var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === 'function' ? mapSizeDescriptor.get : null;
var mapForEach = hasMap && Map.prototype.forEach;
var hasSet = typeof Set === 'function' && Set.prototype;
var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === 'function' ? setSizeDescriptor.get : null;
var setForEach = hasSet && Set.prototype.forEach;
var hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
var hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
var hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
var booleanValueOf = Boolean.prototype.valueOf;
var objectToString = Object.prototype.toString;
var functionToString = Function.prototype.toString;
var $match = String.prototype.match;
var $slice = String.prototype.slice;
var $replace = String.prototype.replace;
var $toUpperCase = String.prototype.toUpperCase;
var $toLowerCase = String.prototype.toLowerCase;
var $test = RegExp.prototype.test;
var $concat = Array.prototype.concat;
var $join = Array.prototype.join;
var $arrSlice = Array.prototype.slice;
var $floor = Math.floor;
var bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var gOPS = Object.getOwnPropertySymbols;
var symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
// ie, `has-tostringtag/shams
var toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === hasShammedSymbols ? 'object' : 'symbol')
    ? Symbol.toStringTag
    : null;
var isEnumerable = Object.prototype.propertyIsEnumerable;

var gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || (
    [].__proto__ === Array.prototype // eslint-disable-line no-proto
        ? function (O) {
            return O.__proto__; // eslint-disable-line no-proto
        }
        : null
);

function addNumericSeparator(num, str) {
    if (
        num === Infinity
        || num === -Infinity
        || num !== num
        || (num && num > -1000 && num < 1000)
        || $test.call(/e/, str)
    ) {
        return str;
    }
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === 'number') {
        var int = num < 0 ? -$floor(-num) : $floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $slice.call(str, intStr.length + 1);
            return $replace.call(intStr, sepRegex, '$&_') + '.' + $replace.call($replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
        }
    }
    return $replace.call(str, sepRegex, '$&_');
}

var utilInspect = __webpack_require__(24654);
var inspectCustom = utilInspect.custom;
var inspectSymbol = isSymbol(inspectCustom) ? inspectCustom : null;

var quotes = {
    __proto__: null,
    'double': '"',
    single: "'"
};
var quoteREs = {
    __proto__: null,
    'double': /(["\\])/g,
    single: /(['\\])/g
};

module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};

    if (has(opts, 'quoteStyle') && !has(quotes, opts.quoteStyle)) {
        throw new TypeError('option "quoteStyle" must be "single" or "double"');
    }
    if (
        has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number'
            ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity
            : opts.maxStringLength !== null
        )
    ) {
        throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    }
    var customInspect = has(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') {
        throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    }

    if (
        has(opts, 'indent')
        && opts.indent !== null
        && opts.indent !== '\t'
        && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)
    ) {
        throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    }
    if (has(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') {
        throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    }
    var numericSeparator = opts.numericSeparator;

    if (typeof obj === 'undefined') {
        return 'undefined';
    }
    if (obj === null) {
        return 'null';
    }
    if (typeof obj === 'boolean') {
        return obj ? 'true' : 'false';
    }

    if (typeof obj === 'string') {
        return inspectString(obj, opts);
    }
    if (typeof obj === 'number') {
        if (obj === 0) {
            return Infinity / obj > 0 ? '0' : '-0';
        }
        var str = String(obj);
        return numericSeparator ? addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === 'bigint') {
        var bigIntStr = String(obj) + 'n';
        return numericSeparator ? addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }

    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') { depth = 0; }
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') {
        return isArray(obj) ? '[Array]' : '[Object]';
    }

    var indent = getIndent(opts, depth);

    if (typeof seen === 'undefined') {
        seen = [];
    } else if (indexOf(seen, obj) >= 0) {
        return '[Circular]';
    }

    function inspect(value, from, noIndent) {
        if (from) {
            seen = $arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if (has(opts, 'quoteStyle')) {
                newOpts.quoteStyle = opts.quoteStyle;
            }
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }

    if (typeof obj === 'function' && !isRegExp(obj)) { // in older engines, regexes are callable
        var name = nameOf(obj);
        var keys = arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $join.call(keys, ', ') + ' }' : '');
    }
    if (isSymbol(obj)) {
        var symString = hasShammedSymbols ? $replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : symToString.call(obj);
        return typeof obj === 'object' && !hasShammedSymbols ? markBoxed(symString) : symString;
    }
    if (isElement(obj)) {
        var s = '<' + $toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for (var i = 0; i < attrs.length; i++) {
            s += ' ' + attrs[i].name + '=' + wrapQuotes(quote(attrs[i].value), 'double', opts);
        }
        s += '>';
        if (obj.childNodes && obj.childNodes.length) { s += '...'; }
        s += '</' + $toLowerCase.call(String(obj.nodeName)) + '>';
        return s;
    }
    if (isArray(obj)) {
        if (obj.length === 0) { return '[]'; }
        var xs = arrObjKeys(obj, inspect);
        if (indent && !singleLineValues(xs)) {
            return '[' + indentedJoin(xs, indent) + ']';
        }
        return '[ ' + $join.call(xs, ', ') + ' ]';
    }
    if (isError(obj)) {
        var parts = arrObjKeys(obj, inspect);
        if (!('cause' in Error.prototype) && 'cause' in obj && !isEnumerable.call(obj, 'cause')) {
            return '{ [' + String(obj) + '] ' + $join.call($concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
        }
        if (parts.length === 0) { return '[' + String(obj) + ']'; }
        return '{ [' + String(obj) + '] ' + $join.call(parts, ', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if (inspectSymbol && typeof obj[inspectSymbol] === 'function' && utilInspect) {
            return utilInspect(obj, { depth: maxDepth - depth });
        } else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') {
            return obj.inspect();
        }
    }
    if (isMap(obj)) {
        var mapParts = [];
        if (mapForEach) {
            mapForEach.call(obj, function (value, key) {
                mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
            });
        }
        return collectionOf('Map', mapSize.call(obj), mapParts, indent);
    }
    if (isSet(obj)) {
        var setParts = [];
        if (setForEach) {
            setForEach.call(obj, function (value) {
                setParts.push(inspect(value, obj));
            });
        }
        return collectionOf('Set', setSize.call(obj), setParts, indent);
    }
    if (isWeakMap(obj)) {
        return weakCollectionOf('WeakMap');
    }
    if (isWeakSet(obj)) {
        return weakCollectionOf('WeakSet');
    }
    if (isWeakRef(obj)) {
        return weakCollectionOf('WeakRef');
    }
    if (isNumber(obj)) {
        return markBoxed(inspect(Number(obj)));
    }
    if (isBigInt(obj)) {
        return markBoxed(inspect(bigIntValueOf.call(obj)));
    }
    if (isBoolean(obj)) {
        return markBoxed(booleanValueOf.call(obj));
    }
    if (isString(obj)) {
        return markBoxed(inspect(String(obj)));
    }
    // note: in IE 8, sometimes `global !== window` but both are the prototypes of each other
    /* eslint-env browser */
    if (typeof window !== 'undefined' && obj === window) {
        return '{ [object Window] }';
    }
    if (
        (typeof globalThis !== 'undefined' && obj === globalThis)
        || (typeof __webpack_require__.g !== 'undefined' && obj === __webpack_require__.g)
    ) {
        return '{ [object globalThis] }';
    }
    if (!isDate(obj) && !isRegExp(obj)) {
        var ys = arrObjKeys(obj, inspect);
        var isPlainObject = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && toStringTag && Object(obj) === obj && toStringTag in obj ? $slice.call(toStr(obj), 8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + $join.call($concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
        if (ys.length === 0) { return tag + '{}'; }
        if (indent) {
            return tag + '{' + indentedJoin(ys, indent) + '}';
        }
        return tag + '{ ' + $join.call(ys, ', ') + ' }';
    }
    return String(obj);
};

function wrapQuotes(s, defaultStyle, opts) {
    var style = opts.quoteStyle || defaultStyle;
    var quoteChar = quotes[style];
    return quoteChar + s + quoteChar;
}

function quote(s) {
    return $replace.call(String(s), /"/g, '&quot;');
}

function canTrustToString(obj) {
    return !toStringTag || !(typeof obj === 'object' && (toStringTag in obj || typeof obj[toStringTag] !== 'undefined'));
}
function isArray(obj) { return toStr(obj) === '[object Array]' && canTrustToString(obj); }
function isDate(obj) { return toStr(obj) === '[object Date]' && canTrustToString(obj); }
function isRegExp(obj) { return toStr(obj) === '[object RegExp]' && canTrustToString(obj); }
function isError(obj) { return toStr(obj) === '[object Error]' && canTrustToString(obj); }
function isString(obj) { return toStr(obj) === '[object String]' && canTrustToString(obj); }
function isNumber(obj) { return toStr(obj) === '[object Number]' && canTrustToString(obj); }
function isBoolean(obj) { return toStr(obj) === '[object Boolean]' && canTrustToString(obj); }

// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function isSymbol(obj) {
    if (hasShammedSymbols) {
        return obj && typeof obj === 'object' && obj instanceof Symbol;
    }
    if (typeof obj === 'symbol') {
        return true;
    }
    if (!obj || typeof obj !== 'object' || !symToString) {
        return false;
    }
    try {
        symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}

function isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !bigIntValueOf) {
        return false;
    }
    try {
        bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}

var hasOwn = Object.prototype.hasOwnProperty || function (key) { return key in this; };
function has(obj, key) {
    return hasOwn.call(obj, key);
}

function toStr(obj) {
    return objectToString.call(obj);
}

function nameOf(f) {
    if (f.name) { return f.name; }
    var m = $match.call(functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) { return m[1]; }
    return null;
}

function indexOf(xs, x) {
    if (xs.indexOf) { return xs.indexOf(x); }
    for (var i = 0, l = xs.length; i < l; i++) {
        if (xs[i] === x) { return i; }
    }
    return -1;
}

function isMap(x) {
    if (!mapSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        mapSize.call(x);
        try {
            setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakMap(x) {
    if (!weakMapHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakMapHas.call(x, weakMapHas);
        try {
            weakSetHas.call(x, weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakRef(x) {
    if (!weakRefDeref || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}

function isSet(x) {
    if (!setSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        setSize.call(x);
        try {
            mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakSet(x) {
    if (!weakSetHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakSetHas.call(x, weakSetHas);
        try {
            weakMapHas.call(x, weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isElement(x) {
    if (!x || typeof x !== 'object') { return false; }
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) {
        return true;
    }
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}

function inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return inspectString($slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    var quoteRE = quoteREs[opts.quoteStyle || 'single'];
    quoteRE.lastIndex = 0;
    // eslint-disable-next-line no-control-regex
    var s = $replace.call($replace.call(str, quoteRE, '\\$1'), /[\x00-\x1f]/g, lowbyte);
    return wrapQuotes(s, 'single', opts);
}

function lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) { return '\\' + x; }
    return '\\x' + (n < 0x10 ? '0' : '') + $toUpperCase.call(n.toString(16));
}

function markBoxed(str) {
    return 'Object(' + str + ')';
}

function weakCollectionOf(type) {
    return type + ' { ? }';
}

function collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? indentedJoin(entries, indent) : $join.call(entries, ', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}

function singleLineValues(xs) {
    for (var i = 0; i < xs.length; i++) {
        if (indexOf(xs[i], '\n') >= 0) {
            return false;
        }
    }
    return true;
}

function getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') {
        baseIndent = '\t';
    } else if (typeof opts.indent === 'number' && opts.indent > 0) {
        baseIndent = $join.call(Array(opts.indent + 1), ' ');
    } else {
        return null;
    }
    return {
        base: baseIndent,
        prev: $join.call(Array(depth + 1), baseIndent)
    };
}

function indentedJoin(xs, indent) {
    if (xs.length === 0) { return ''; }
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + $join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}

function arrObjKeys(obj, inspect) {
    var isArr = isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for (var i = 0; i < obj.length; i++) {
            xs[i] = has(obj, i) ? inspect(obj[i], obj) : '';
        }
    }
    var syms = typeof gOPS === 'function' ? gOPS(obj) : [];
    var symMap;
    if (hasShammedSymbols) {
        symMap = {};
        for (var k = 0; k < syms.length; k++) {
            symMap['$' + syms[k]] = syms[k];
        }
    }

    for (var key in obj) { // eslint-disable-line no-restricted-syntax
        if (!has(obj, key)) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (hasShammedSymbols && symMap['$' + key] instanceof Symbol) {
            // this is to prevent shammed Symbols, which are stored as strings, from being included in the string key section
            continue; // eslint-disable-line no-restricted-syntax, no-continue
        } else if ($test.call(/[^\w$]/, key)) {
            xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        } else {
            xs.push(key + ': ' + inspect(obj[key], obj));
        }
    }
    if (typeof gOPS === 'function') {
        for (var j = 0; j < syms.length; j++) {
            if (isEnumerable.call(obj, syms[j])) {
                xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
            }
        }
    }
    return xs;
}


/***/ }),

/***/ 45432:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * OverlayScrollbars
 * https://github.com/KingSora/OverlayScrollbars
 *
 * Version: 1.13.3
 *
 * Copyright KingSora | Rene Haas.
 * https://github.com/KingSora
 *
 * Released under the MIT license.
 * Date: 20.07.2022
 */

(function (global, factory) {
    if (true)
        !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () { return factory(global, global.document, undefined); }).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    else {}
}(typeof window !== 'undefined' ? window : this,
    function (window, document, undefined) {
        'use strict';
        var PLUGINNAME = 'OverlayScrollbars';
        var TYPES = {
            o: 'object',
            f: 'function',
            a: 'array',
            s: 'string',
            b: 'boolean',
            n: 'number',
            u: 'undefined',
            z: 'null'
            //d : 'date',
            //e : 'error',
            //r : 'regexp',
            //y : 'symbol'
        };
        var LEXICON = {
            c: 'class',
            s: 'style',
            i: 'id',
            l: 'length',
            p: 'prototype',
            ti: 'tabindex',
            oH: 'offsetHeight',
            cH: 'clientHeight',
            sH: 'scrollHeight',
            oW: 'offsetWidth',
            cW: 'clientWidth',
            sW: 'scrollWidth',
            hOP: 'hasOwnProperty',
            bCR: 'getBoundingClientRect'
        };
        var VENDORS = (function () {
            //https://developer.mozilla.org/en-US/docs/Glossary/Vendor_Prefix
            var jsCache = {};
            var cssCache = {};
            var cssPrefixes = ['-webkit-', '-moz-', '-o-', '-ms-'];
            var jsPrefixes = ['WebKit', 'Moz', 'O', 'MS'];
            function firstLetterToUpper(str) {
                return str.charAt(0).toUpperCase() + str.slice(1);
            }

            return {
                _cssPrefixes: cssPrefixes,
                _jsPrefixes: jsPrefixes,
                _cssProperty: function (name) {
                    var result = cssCache[name];

                    if (cssCache[LEXICON.hOP](name))
                        return result;

                    var uppercasedName = firstLetterToUpper(name);
                    var elmStyle = document.createElement('div')[LEXICON.s];
                    var resultPossibilities;
                    var i = 0;
                    var v;
                    var currVendorWithoutDashes;

                    for (; i < cssPrefixes.length; i++) {
                        currVendorWithoutDashes = cssPrefixes[i].replace(/-/g, '');
                        resultPossibilities = [
                            name, //transition
                            cssPrefixes[i] + name, //-webkit-transition
                            currVendorWithoutDashes + uppercasedName, //webkitTransition
                            firstLetterToUpper(currVendorWithoutDashes) + uppercasedName //WebkitTransition
                        ];
                        for (v = 0; v < resultPossibilities[LEXICON.l]; v++) {
                            if (elmStyle[resultPossibilities[v]] !== undefined) {
                                result = resultPossibilities[v];
                                break;
                            }
                        }
                    }

                    cssCache[name] = result;
                    return result;
                },
                _cssPropertyValue: function (property, values, suffix) {
                    var name = property + ' ' + values;
                    var result = cssCache[name];

                    if (cssCache[LEXICON.hOP](name))
                        return result;

                    var dummyStyle = document.createElement('div')[LEXICON.s];
                    var possbleValues = values.split(' ');
                    var preparedSuffix = suffix || '';
                    var i = 0;
                    var v = -1;
                    var prop;

                    for (; i < possbleValues[LEXICON.l]; i++) {
                        for (; v < VENDORS._cssPrefixes[LEXICON.l]; v++) {
                            prop = v < 0 ? possbleValues[i] : VENDORS._cssPrefixes[v] + possbleValues[i];
                            dummyStyle.cssText = property + ':' + prop + preparedSuffix;
                            if (dummyStyle[LEXICON.l]) {
                                result = prop;
                                break;
                            }
                        }
                    }

                    cssCache[name] = result;
                    return result;
                },
                _jsAPI: function (name, isInterface, fallback) {
                    var i = 0;
                    var result = jsCache[name];

                    if (!jsCache[LEXICON.hOP](name)) {
                        result = window[name];
                        for (; i < jsPrefixes[LEXICON.l]; i++)
                            result = result || window[(isInterface ? jsPrefixes[i] : jsPrefixes[i].toLowerCase()) + firstLetterToUpper(name)];
                        jsCache[name] = result;
                    }
                    return result || fallback;
                }
            }
        })();
        var COMPATIBILITY = (function () {
            function windowSize(x) {
                return x ? window.innerWidth || document.documentElement[LEXICON.cW] || document.body[LEXICON.cW] : window.innerHeight || document.documentElement[LEXICON.cH] || document.body[LEXICON.cH];
            }
            function bind(func, thisObj) {
                if (typeof func != TYPES.f) {
                    throw "Can't bind function!";
                    // closest thing possible to the ECMAScript 5
                    // internal IsCallable function
                    //throw new TypeError('Function.prototype.bind - what is trying to be bound is not callable');
                }
                var proto = LEXICON.p;
                var aArgs = Array[proto].slice.call(arguments, 2);
                var fNOP = function () { };
                var fBound = function () { return func.apply(this instanceof fNOP ? this : thisObj, aArgs.concat(Array[proto].slice.call(arguments))); };

                if (func[proto])
                    fNOP[proto] = func[proto]; // Function.prototype doesn't have a prototype property
                fBound[proto] = new fNOP();

                return fBound;
            }

            return {
                /**
                 * Gets the current window width.
                 * @returns {Number|number} The current window width in pixel.
                 */
                wW: bind(windowSize, 0, true),

                /**
                 * Gets the current window height.
                 * @returns {Number|number} The current window height in pixel.
                 */
                wH: bind(windowSize, 0),

                /**
                 * Gets the MutationObserver Object or undefined if not supported.
                 * @returns {MutationObserver|*|undefined} The MutationsObserver Object or undefined.
                 */
                mO: bind(VENDORS._jsAPI, 0, 'MutationObserver', true),

                /**
                 * Gets the ResizeObserver Object or undefined if not supported.
                 * @returns {MutationObserver|*|undefined} The ResizeObserver Object or undefined.
                 */
                rO: bind(VENDORS._jsAPI, 0, 'ResizeObserver', true),

                /**
                 * Gets the RequestAnimationFrame method or it's corresponding polyfill.
                 * @returns {*|Function} The RequestAnimationFrame method or it's corresponding polyfill.
                 */
                rAF: bind(VENDORS._jsAPI, 0, 'requestAnimationFrame', false, function (func) { return window.setTimeout(func, 1000 / 60); }),

                /**
                 * Gets the CancelAnimationFrame method or it's corresponding polyfill.
                 * @returns {*|Function} The CancelAnimationFrame method or it's corresponding polyfill.
                 */
                cAF: bind(VENDORS._jsAPI, 0, 'cancelAnimationFrame', false, function (id) { return window.clearTimeout(id); }),

                /**
                 * Gets the current time.
                 * @returns {number} The current time.
                 */
                now: function () {
                    return Date.now && Date.now() || new Date().getTime();
                },

                /**
                 * Stops the propagation of the given event.
                 * @param event The event of which the propagation shall be stoped.
                 */
                stpP: function (event) {
                    if (event.stopPropagation)
                        event.stopPropagation();
                    else
                        event.cancelBubble = true;
                },

                /**
                 * Prevents the default action of the given event.
                 * @param event The event of which the default action shall be prevented.
                 */
                prvD: function (event) {
                    if (event.preventDefault && event.cancelable)
                        event.preventDefault();
                    else
                        event.returnValue = false;
                },

                /**
                 * Gets the pageX and pageY values of the given mouse event.
                 * @param event The mouse event of which the pageX and pageX shall be got.
                 * @returns {{x: number, y: number}} x = pageX value, y = pageY value.
                 */
                page: function (event) {
                    event = event.originalEvent || event;

                    var strPage = 'page';
                    var strClient = 'client';
                    var strX = 'X';
                    var strY = 'Y';
                    var target = event.target || event.srcElement || document;
                    var eventDoc = target.ownerDocument || document;
                    var doc = eventDoc.documentElement;
                    var body = eventDoc.body;

                    //if touch event return return pageX/Y of it
                    if (event.touches !== undefined) {
                        var touch = event.touches[0];
                        return {
                            x: touch[strPage + strX],
                            y: touch[strPage + strY]
                        }
                    }

                    // Calculate pageX/Y if not native supported
                    if (!event[strPage + strX] && event[strClient + strX] && event[strClient + strX] != null) {

                        return {
                            x: event[strClient + strX] +
                                (doc && doc.scrollLeft || body && body.scrollLeft || 0) -
                                (doc && doc.clientLeft || body && body.clientLeft || 0),
                            y: event[strClient + strY] +
                                (doc && doc.scrollTop || body && body.scrollTop || 0) -
                                (doc && doc.clientTop || body && body.clientTop || 0)
                        }
                    }
                    return {
                        x: event[strPage + strX],
                        y: event[strPage + strY]
                    };
                },

                /**
                 * Gets the clicked mouse button of the given mouse event.
                 * @param event The mouse event of which the clicked button shal be got.
                 * @returns {number} The number of the clicked mouse button. (0 : none | 1 : leftButton | 2 : middleButton | 3 : rightButton)
                 */
                mBtn: function (event) {
                    var button = event.button;
                    if (!event.which && button !== undefined)
                        return (button & 1 ? 1 : (button & 2 ? 3 : (button & 4 ? 2 : 0)));
                    else
                        return event.which;
                },

                /**
                 * Checks whether a item is in the given array and returns its index.
                 * @param item The item of which the position in the array shall be determined.
                 * @param arr The array.
                 * @returns {number} The zero based index of the item or -1 if the item isn't in the array.
                 */
                inA: function (item, arr) {
                    for (var i = 0; i < arr[LEXICON.l]; i++)
                        //Sometiems in IE a "SCRIPT70" Permission denied error occurs if HTML elements in a iFrame are compared
                        try {
                            if (arr[i] === item)
                                return i;
                        }
                        catch (e) { }
                    return -1;
                },

                /**
                 * Returns true if the given value is a array.
                 * @param arr The potential array.
                 * @returns {boolean} True if the given value is a array, false otherwise.
                 */
                isA: function (arr) {
                    var def = Array.isArray;
                    return def ? def(arr) : this.type(arr) == TYPES.a;
                },

                /**
                 * Determine the internal JavaScript [[Class]] of the given object.
                 * @param obj The object of which the type shall be determined.
                 * @returns {string} The type of the given object.
                 */
                type: function (obj) {
                    if (obj === undefined)
                        return obj + '';
                    if (obj === null)
                        return obj + '';
                    return Object[LEXICON.p].toString.call(obj).replace(/^\[object (.+)\]$/, '$1').toLowerCase();
                },


                bind: bind

                /**
                 * Gets the vendor-prefixed CSS property by the given name.
                 * For example the given name is "transform" and you're using a old Firefox browser then the returned value would be "-moz-transform".
                 * If the browser doesn't need a vendor-prefix, then the returned string is the given name.
                 * If the browser doesn't support the given property name at all (not even with a vendor-prefix) the returned value is null.
                 * @param propName The unprefixed CSS property name.
                 * @returns {string|null} The vendor-prefixed CSS property or null if the browser doesn't support the given CSS property.

                cssProp: function(propName) {
                    return VENDORS._cssProperty(propName);
                }
                */
            }
        })();


        var MATH = Math;
        var JQUERY = window.jQuery;
        var EASING = (function () {
            var _easingsMath = {
                p: MATH.PI,
                c: MATH.cos,
                s: MATH.sin,
                w: MATH.pow,
                t: MATH.sqrt,
                n: MATH.asin,
                a: MATH.abs,
                o: 1.70158
            };

            /*
             x : current percent (0 - 1),
             t : current time (duration * percent),
             b : start value (from),
             c : end value (to),
             d : duration

             easingName : function(x, t, b, c, d) { return easedValue; }
             */

            return {
                swing: function (x, t, b, c, d) {
                    return 0.5 - _easingsMath.c(x * _easingsMath.p) / 2;
                },
                linear: function (x, t, b, c, d) {
                    return x;
                },
                easeInQuad: function (x, t, b, c, d) {
                    return c * (t /= d) * t + b;
                },
                easeOutQuad: function (x, t, b, c, d) {
                    return -c * (t /= d) * (t - 2) + b;
                },
                easeInOutQuad: function (x, t, b, c, d) {
                    return ((t /= d / 2) < 1) ? c / 2 * t * t + b : -c / 2 * ((--t) * (t - 2) - 1) + b;
                },
                easeInCubic: function (x, t, b, c, d) {
                    return c * (t /= d) * t * t + b;
                },
                easeOutCubic: function (x, t, b, c, d) {
                    return c * ((t = t / d - 1) * t * t + 1) + b;
                },
                easeInOutCubic: function (x, t, b, c, d) {
                    return ((t /= d / 2) < 1) ? c / 2 * t * t * t + b : c / 2 * ((t -= 2) * t * t + 2) + b;
                },
                easeInQuart: function (x, t, b, c, d) {
                    return c * (t /= d) * t * t * t + b;
                },
                easeOutQuart: function (x, t, b, c, d) {
                    return -c * ((t = t / d - 1) * t * t * t - 1) + b;
                },
                easeInOutQuart: function (x, t, b, c, d) {
                    return ((t /= d / 2) < 1) ? c / 2 * t * t * t * t + b : -c / 2 * ((t -= 2) * t * t * t - 2) + b;
                },
                easeInQuint: function (x, t, b, c, d) {
                    return c * (t /= d) * t * t * t * t + b;
                },
                easeOutQuint: function (x, t, b, c, d) {
                    return c * ((t = t / d - 1) * t * t * t * t + 1) + b;
                },
                easeInOutQuint: function (x, t, b, c, d) {
                    return ((t /= d / 2) < 1) ? c / 2 * t * t * t * t * t + b : c / 2 * ((t -= 2) * t * t * t * t + 2) + b;
                },
                easeInSine: function (x, t, b, c, d) {
                    return -c * _easingsMath.c(t / d * (_easingsMath.p / 2)) + c + b;
                },
                easeOutSine: function (x, t, b, c, d) {
                    return c * _easingsMath.s(t / d * (_easingsMath.p / 2)) + b;
                },
                easeInOutSine: function (x, t, b, c, d) {
                    return -c / 2 * (_easingsMath.c(_easingsMath.p * t / d) - 1) + b;
                },
                easeInExpo: function (x, t, b, c, d) {
                    return (t == 0) ? b : c * _easingsMath.w(2, 10 * (t / d - 1)) + b;
                },
                easeOutExpo: function (x, t, b, c, d) {
                    return (t == d) ? b + c : c * (-_easingsMath.w(2, -10 * t / d) + 1) + b;
                },
                easeInOutExpo: function (x, t, b, c, d) {
                    if (t == 0) return b;
                    if (t == d) return b + c;
                    if ((t /= d / 2) < 1) return c / 2 * _easingsMath.w(2, 10 * (t - 1)) + b;
                    return c / 2 * (-_easingsMath.w(2, -10 * --t) + 2) + b;
                },
                easeInCirc: function (x, t, b, c, d) {
                    return -c * (_easingsMath.t(1 - (t /= d) * t) - 1) + b;
                },
                easeOutCirc: function (x, t, b, c, d) {
                    return c * _easingsMath.t(1 - (t = t / d - 1) * t) + b;
                },
                easeInOutCirc: function (x, t, b, c, d) {
                    return ((t /= d / 2) < 1) ? -c / 2 * (_easingsMath.t(1 - t * t) - 1) + b : c / 2 * (_easingsMath.t(1 - (t -= 2) * t) + 1) + b;
                },
                easeInElastic: function (x, t, b, c, d) {
                    var s = _easingsMath.o; var p = 0; var a = c;
                    if (t == 0) return b; if ((t /= d) == 1) return b + c; if (!p) p = d * .3;
                    if (a < _easingsMath.a(c)) { a = c; s = p / 4; }
                    else s = p / (2 * _easingsMath.p) * _easingsMath.n(c / a);
                    return -(a * _easingsMath.w(2, 10 * (t -= 1)) * _easingsMath.s((t * d - s) * (2 * _easingsMath.p) / p)) + b;
                },
                easeOutElastic: function (x, t, b, c, d) {
                    var s = _easingsMath.o; var p = 0; var a = c;
                    if (t == 0) return b;
                    if ((t /= d) == 1) return b + c;
                    if (!p) p = d * .3;
                    if (a < _easingsMath.a(c)) { a = c; s = p / 4; }
                    else s = p / (2 * _easingsMath.p) * _easingsMath.n(c / a);
                    return a * _easingsMath.w(2, -10 * t) * _easingsMath.s((t * d - s) * (2 * _easingsMath.p) / p) + c + b;
                },
                easeInOutElastic: function (x, t, b, c, d) {
                    var s = _easingsMath.o; var p = 0; var a = c;
                    if (t == 0) return b;
                    if ((t /= d / 2) == 2) return b + c;
                    if (!p) p = d * (.3 * 1.5);
                    if (a < _easingsMath.a(c)) { a = c; s = p / 4; }
                    else s = p / (2 * _easingsMath.p) * _easingsMath.n(c / a);
                    if (t < 1) return -.5 * (a * _easingsMath.w(2, 10 * (t -= 1)) * _easingsMath.s((t * d - s) * (2 * _easingsMath.p) / p)) + b;
                    return a * _easingsMath.w(2, -10 * (t -= 1)) * _easingsMath.s((t * d - s) * (2 * _easingsMath.p) / p) * .5 + c + b;
                },
                easeInBack: function (x, t, b, c, d, s) {
                    s = s || _easingsMath.o;
                    return c * (t /= d) * t * ((s + 1) * t - s) + b;
                },
                easeOutBack: function (x, t, b, c, d, s) {
                    s = s || _easingsMath.o;
                    return c * ((t = t / d - 1) * t * ((s + 1) * t + s) + 1) + b;
                },
                easeInOutBack: function (x, t, b, c, d, s) {
                    s = s || _easingsMath.o;
                    return ((t /= d / 2) < 1) ? c / 2 * (t * t * (((s *= (1.525)) + 1) * t - s)) + b : c / 2 * ((t -= 2) * t * (((s *= (1.525)) + 1) * t + s) + 2) + b;
                },
                easeInBounce: function (x, t, b, c, d) {
                    return c - this.easeOutBounce(x, d - t, 0, c, d) + b;
                },
                easeOutBounce: function (x, t, b, c, d) {
                    var o = 7.5625;
                    if ((t /= d) < (1 / 2.75)) {
                        return c * (o * t * t) + b;
                    } else if (t < (2 / 2.75)) {
                        return c * (o * (t -= (1.5 / 2.75)) * t + .75) + b;
                    } else if (t < (2.5 / 2.75)) {
                        return c * (o * (t -= (2.25 / 2.75)) * t + .9375) + b;
                    } else {
                        return c * (o * (t -= (2.625 / 2.75)) * t + .984375) + b;
                    }
                },
                easeInOutBounce: function (x, t, b, c, d) {
                    return (t < d / 2) ? this.easeInBounce(x, t * 2, 0, c, d) * .5 + b : this.easeOutBounce(x, t * 2 - d, 0, c, d) * .5 + c * .5 + b;
                }
            };
            /*
             *
             * TERMS OF USE - EASING EQUATIONS
             * 
             * Open source under the BSD License. 
             * 
             * Copyright Â© 2001 Robert Penner
             * All rights reserved.
             * 
             * Redistribution and use in source and binary forms, with or without modification, 
             * are permitted provided that the following conditions are met:
             * 
             * Redistributions of source code must retain the above copyright notice, this list of 
             * conditions and the following disclaimer.
             * Redistributions in binary form must reproduce the above copyright notice, this list 
             * of conditions and the following disclaimer in the documentation and/or other materials 
             * provided with the distribution.
             * 
             * Neither the name of the author nor the names of contributors may be used to endorse 
             * or promote products derived from this software without specific prior written permission.
             * 
             * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY 
             * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF
             * MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE
             *  COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
             *  EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE
             *  GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED 
             * AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
             *  NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED 
             * OF THE POSSIBILITY OF SUCH DAMAGE. 
             *
             */
        })();
        var FRAMEWORK = (function () {
            var _rnothtmlwhite = (/[^\x20\t\r\n\f]+/g);
            var _strSpace = ' ';
            var _strEmpty = '';
            var _strScrollLeft = 'scrollLeft';
            var _strScrollTop = 'scrollTop';
            var _animations = [];
            var _type = COMPATIBILITY.type;
            var _cssNumber = {
                animationIterationCount: true,
                columnCount: true,
                fillOpacity: true,
                flexGrow: true,
                flexShrink: true,
                fontWeight: true,
                lineHeight: true,
                opacity: true,
                order: true,
                orphans: true,
                widows: true,
                zIndex: true,
                zoom: true
            };

            function extend() {
                var src, copyIsArray, copy, name, options, clone, target = arguments[0] || {},
                    i = 1,
                    length = arguments[LEXICON.l],
                    deep = false;

                // Handle a deep copy situation
                if (_type(target) == TYPES.b) {
                    deep = target;
                    target = arguments[1] || {};
                    // skip the boolean and the target
                    i = 2;
                }

                // Handle case when target is a string or something (possible in deep copy)
                if (_type(target) != TYPES.o && !_type(target) == TYPES.f) {
                    target = {};
                }

                // extend jQuery itself if only one argument is passed
                if (length === i) {
                    target = FakejQuery;
                    --i;
                }

                for (; i < length; i++) {
                    // Only deal with non-null/undefined values
                    if ((options = arguments[i]) != null) {
                        // Extend the base object
                        for (name in options) {
                            src = target[name];
                            copy = options[name];

                            // Prevent never-ending loop
                            if (target === copy) {
                                continue;
                            }

                            // Recurse if we're merging plain objects or arrays
                            if (deep && copy && (isPlainObject(copy) || (copyIsArray = COMPATIBILITY.isA(copy)))) {
                                if (copyIsArray) {
                                    copyIsArray = false;
                                    clone = src && COMPATIBILITY.isA(src) ? src : [];

                                } else {
                                    clone = src && isPlainObject(src) ? src : {};
                                }

                                // Never move original objects, clone them
                                target[name] = extend(deep, clone, copy);

                                // Don't bring in undefined values
                            } else if (copy !== undefined) {
                                target[name] = copy;
                            }
                        }
                    }
                }

                // Return the modified object
                return target;
            };

            function inArray(item, arr, fromIndex) {
                for (var i = fromIndex || 0; i < arr[LEXICON.l]; i++)
                    if (arr[i] === item)
                        return i;
                return -1;
            }

            function isFunction(obj) {
                return _type(obj) == TYPES.f;
            };

            function isEmptyObject(obj) {
                for (var name in obj)
                    return false;
                return true;
            };

            function isPlainObject(obj) {
                if (!obj || _type(obj) != TYPES.o)
                    return false;

                var key;
                var proto = LEXICON.p;
                var hasOwnProperty = Object[proto].hasOwnProperty;
                var hasOwnConstructor = hasOwnProperty.call(obj, 'constructor');
                var hasIsPrototypeOf = obj.constructor && obj.constructor[proto] && hasOwnProperty.call(obj.constructor[proto], 'isPrototypeOf');

                if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) {
                    return false;
                }


                for (key in obj) { /**/ }

                return _type(key) == TYPES.u || hasOwnProperty.call(obj, key);
            };

            function each(obj, callback) {
                var i = 0;

                if (isArrayLike(obj)) {
                    for (; i < obj[LEXICON.l]; i++) {
                        if (callback.call(obj[i], i, obj[i]) === false)
                            break;
                    }
                }
                else {
                    for (i in obj) {
                        if (callback.call(obj[i], i, obj[i]) === false)
                            break;
                    }
                }

                return obj;
            };

            function isArrayLike(obj) {
                var length = !!obj && [LEXICON.l] in obj && obj[LEXICON.l];
                var t = _type(obj);
                return isFunction(t) ? false : (t == TYPES.a || length === 0 || _type(length) == TYPES.n && length > 0 && (length - 1) in obj);
            }

            function stripAndCollapse(value) {
                var tokens = value.match(_rnothtmlwhite) || [];
                return tokens.join(_strSpace);
            }

            function matches(elem, selector) {
                var nodeList = (elem.parentNode || document).querySelectorAll(selector) || [];
                var i = nodeList[LEXICON.l];

                while (i--)
                    if (nodeList[i] == elem)
                        return true;

                return false;
            }

            function insertAdjacentElement(el, strategy, child) {
                if (COMPATIBILITY.isA(child)) {
                    for (var i = 0; i < child[LEXICON.l]; i++)
                        insertAdjacentElement(el, strategy, child[i]);
                }
                else if (_type(child) == TYPES.s)
                    el.insertAdjacentHTML(strategy, child);
                else
                    el.insertAdjacentElement(strategy, child.nodeType ? child : child[0]);
            }

            function setCSSVal(el, prop, val) {
                try {
                    if (el[LEXICON.s][prop] !== undefined)
                        el[LEXICON.s][prop] = parseCSSVal(prop, val);
                } catch (e) { }
            }

            function parseCSSVal(prop, val) {
                if (!_cssNumber[prop.toLowerCase()] && _type(val) == TYPES.n)
                    val += 'px';
                return val;
            }

            function startNextAnimationInQ(animObj, removeFromQ) {
                var index;
                var nextAnim;
                if (removeFromQ !== false)
                    animObj.q.splice(0, 1);
                if (animObj.q[LEXICON.l] > 0) {
                    nextAnim = animObj.q[0];
                    animate(animObj.el, nextAnim.props, nextAnim.duration, nextAnim.easing, nextAnim.complete, true);
                }
                else {
                    index = inArray(animObj, _animations);
                    if (index > -1)
                        _animations.splice(index, 1);
                }
            }

            function setAnimationValue(el, prop, value) {
                if (prop === _strScrollLeft || prop === _strScrollTop)
                    el[prop] = value;
                else
                    setCSSVal(el, prop, value);
            }

            function animate(el, props, options, easing, complete, guaranteedNext) {
                var hasOptions = isPlainObject(options);
                var from = {};
                var to = {};
                var i = 0;
                var key;
                var animObj;
                var start;
                var progress;
                var step;
                var specialEasing;
                var duration;
                if (hasOptions) {
                    easing = options.easing;
                    start = options.start;
                    progress = options.progress;
                    step = options.step;
                    specialEasing = options.specialEasing;
                    complete = options.complete;
                    duration = options.duration;
                }
                else
                    duration = options;
                specialEasing = specialEasing || {};
                duration = duration || 400;
                easing = easing || 'swing';
                guaranteedNext = guaranteedNext || false;

                for (; i < _animations[LEXICON.l]; i++) {
                    if (_animations[i].el === el) {
                        animObj = _animations[i];
                        break;
                    }
                }

                if (!animObj) {
                    animObj = {
                        el: el,
                        q: []
                    };
                    _animations.push(animObj);
                }

                for (key in props) {
                    if (key === _strScrollLeft || key === _strScrollTop)
                        from[key] = el[key];
                    else
                        from[key] = FakejQuery(el).css(key);
                }

                for (key in from) {
                    if (from[key] !== props[key] && props[key] !== undefined)
                        to[key] = props[key];
                }

                if (!isEmptyObject(to)) {
                    var timeNow;
                    var end;
                    var percent;
                    var fromVal;
                    var toVal;
                    var easedVal;
                    var timeStart;
                    var frame;
                    var elapsed;
                    var qPos = guaranteedNext ? 0 : inArray(qObj, animObj.q);
                    var qObj = {
                        props: to,
                        duration: hasOptions ? options : duration,
                        easing: easing,
                        complete: complete
                    };
                    if (qPos === -1) {
                        qPos = animObj.q[LEXICON.l];
                        animObj.q.push(qObj);
                    }

                    if (qPos === 0) {
                        if (duration > 0) {
                            timeStart = COMPATIBILITY.now();
                            frame = function () {
                                timeNow = COMPATIBILITY.now();
                                elapsed = (timeNow - timeStart);
                                end = qObj.stop || elapsed >= duration;
                                percent = 1 - ((MATH.max(0, timeStart + duration - timeNow) / duration) || 0);

                                for (key in to) {
                                    fromVal = parseFloat(from[key]);
                                    toVal = parseFloat(to[key]);
                                    easedVal = (toVal - fromVal) * EASING[specialEasing[key] || easing](percent, percent * duration, 0, 1, duration) + fromVal;
                                    setAnimationValue(el, key, easedVal);
                                    if (isFunction(step)) {
                                        step(easedVal, {
                                            elem: el,
                                            prop: key,
                                            start: fromVal,
                                            now: easedVal,
                                            end: toVal,
                                            pos: percent,
                                            options: {
                                                easing: easing,
                                                speacialEasing: specialEasing,
                                                duration: duration,
                                                complete: complete,
                                                step: step
                                            },
                                            startTime: timeStart
                                        });
                                    }
                                }

                                if (isFunction(progress))
                                    progress({}, percent, MATH.max(0, duration - elapsed));

                                if (end) {
                                    startNextAnimationInQ(animObj);
                                    if (isFunction(complete))
                                        complete();
                                }
                                else
                                    qObj.frame = COMPATIBILITY.rAF()(frame);
                            };
                            qObj.frame = COMPATIBILITY.rAF()(frame);
                        }
                        else {
                            for (key in to)
                                setAnimationValue(el, key, to[key]);
                            startNextAnimationInQ(animObj);
                        }
                    }
                }
                else if (guaranteedNext)
                    startNextAnimationInQ(animObj);
            }

            function stop(el, clearQ, jumpToEnd) {
                var animObj;
                var qObj;
                var key;
                var i = 0;
                for (; i < _animations[LEXICON.l]; i++) {
                    animObj = _animations[i];
                    if (animObj.el === el) {
                        if (animObj.q[LEXICON.l] > 0) {
                            qObj = animObj.q[0];
                            qObj.stop = true;
                            COMPATIBILITY.cAF()(qObj.frame);
                            animObj.q.splice(0, 1);

                            if (jumpToEnd)
                                for (key in qObj.props)
                                    setAnimationValue(el, key, qObj.props[key]);

                            if (clearQ)
                                animObj.q = [];
                            else
                                startNextAnimationInQ(animObj, false);
                        }
                        break;
                    }
                }
            }

            function elementIsVisible(el) {
                return !!(el[LEXICON.oW] || el[LEXICON.oH] || el.getClientRects()[LEXICON.l]);
            }

            function FakejQuery(selector) {
                if (arguments[LEXICON.l] === 0)
                    return this;

                var base = new FakejQuery();
                var elements = selector;
                var i = 0;
                var elms;
                var el;

                if (_type(selector) == TYPES.s) {
                    elements = [];
                    if (selector.charAt(0) === '<') {
                        el = document.createElement('div');
                        el.innerHTML = selector;
                        elms = el.children;
                    }
                    else {
                        elms = document.querySelectorAll(selector);
                    }

                    for (; i < elms[LEXICON.l]; i++)
                        elements.push(elms[i]);
                }

                if (elements) {
                    if (_type(elements) != TYPES.s && (!isArrayLike(elements) || elements === window || elements === elements.self))
                        elements = [elements];

                    for (i = 0; i < elements[LEXICON.l]; i++)
                        base[i] = elements[i];

                    base[LEXICON.l] = elements[LEXICON.l];
                }

                return base;
            };

            FakejQuery[LEXICON.p] = {

                //EVENTS:

                on: function (eventName, handler) {
                    eventName = (eventName || _strEmpty).match(_rnothtmlwhite) || [_strEmpty];

                    var eventNameLength = eventName[LEXICON.l];
                    var i = 0;
                    var el;
                    return this.each(function () {
                        el = this;
                        try {
                            if (el.addEventListener) {
                                for (; i < eventNameLength; i++)
                                    el.addEventListener(eventName[i], handler);
                            }
                            else if (el.detachEvent) {
                                for (; i < eventNameLength; i++)
                                    el.attachEvent('on' + eventName[i], handler);
                            }
                        } catch (e) { }
                    });
                },

                off: function (eventName, handler) {
                    eventName = (eventName || _strEmpty).match(_rnothtmlwhite) || [_strEmpty];

                    var eventNameLength = eventName[LEXICON.l];
                    var i = 0;
                    var el;
                    return this.each(function () {
                        el = this;
                        try {
                            if (el.removeEventListener) {
                                for (; i < eventNameLength; i++)
                                    el.removeEventListener(eventName[i], handler);
                            }
                            else if (el.detachEvent) {
                                for (; i < eventNameLength; i++)
                                    el.detachEvent('on' + eventName[i], handler);
                            }
                        } catch (e) { }
                    });
                },

                one: function (eventName, handler) {
                    eventName = (eventName || _strEmpty).match(_rnothtmlwhite) || [_strEmpty];
                    return this.each(function () {
                        var el = FakejQuery(this);
                        FakejQuery.each(eventName, function (i, oneEventName) {
                            var oneHandler = function (e) {
                                handler.call(this, e);
                                el.off(oneEventName, oneHandler);
                            };
                            el.on(oneEventName, oneHandler);
                        });
                    });
                },

                trigger: function (eventName) {
                    var el;
                    var event;
                    return this.each(function () {
                        el = this;
                        if (document.createEvent) {
                            event = document.createEvent('HTMLEvents');
                            event.initEvent(eventName, true, false);
                            el.dispatchEvent(event);
                        }
                        else {
                            el.fireEvent('on' + eventName);
                        }
                    });
                },

                //DOM NODE INSERTING / REMOVING:

                append: function (child) {
                    return this.each(function () { insertAdjacentElement(this, 'beforeend', child); });
                },

                prepend: function (child) {
                    return this.each(function () { insertAdjacentElement(this, 'afterbegin', child); });
                },

                before: function (child) {
                    return this.each(function () { insertAdjacentElement(this, 'beforebegin', child); });
                },

                after: function (child) {
                    return this.each(function () { insertAdjacentElement(this, 'afterend', child); });
                },

                remove: function () {
                    return this.each(function () {
                        var el = this;
                        var parentNode = el.parentNode;
                        if (parentNode != null)
                            parentNode.removeChild(el);
                    });
                },

                unwrap: function () {
                    var parents = [];
                    var i;
                    var el;
                    var parent;

                    this.each(function () {
                        parent = this.parentNode;
                        if (inArray(parent, parents) === - 1)
                            parents.push(parent);
                    });

                    for (i = 0; i < parents[LEXICON.l]; i++) {
                        el = parents[i];
                        parent = el.parentNode;
                        while (el.firstChild)
                            parent.insertBefore(el.firstChild, el);
                        parent.removeChild(el);
                    }

                    return this;
                },

                wrapAll: function (wrapperHTML) {
                    var i;
                    var nodes = this;
                    var wrapper = FakejQuery(wrapperHTML)[0];
                    var deepest = wrapper;
                    var parent = nodes[0].parentNode;
                    var previousSibling = nodes[0].previousSibling;
                    while (deepest.childNodes[LEXICON.l] > 0)
                        deepest = deepest.childNodes[0];

                    for (i = 0; nodes[LEXICON.l] - i; deepest.firstChild === nodes[0] && i++)
                        deepest.appendChild(nodes[i]);

                    var nextSibling = previousSibling ? previousSibling.nextSibling : parent.firstChild;
                    parent.insertBefore(wrapper, nextSibling);

                    return this;
                },

                wrapInner: function (wrapperHTML) {
                    return this.each(function () {
                        var el = FakejQuery(this);
                        var contents = el.contents();

                        if (contents[LEXICON.l])
                            contents.wrapAll(wrapperHTML);
                        else
                            el.append(wrapperHTML);
                    });
                },

                wrap: function (wrapperHTML) {
                    return this.each(function () { FakejQuery(this).wrapAll(wrapperHTML); });
                },


                //DOM NODE MANIPULATION / INFORMATION:

                css: function (styles, val) {
                    var el;
                    var key;
                    var cptStyle;
                    var getCptStyle = window.getComputedStyle;
                    if (_type(styles) == TYPES.s) {
                        if (val === undefined) {
                            el = this[0];
                            cptStyle = getCptStyle ? getCptStyle(el, null) : el.currentStyle[styles];

                            //https://bugzilla.mozilla.org/show_bug.cgi?id=548397 can be null sometimes if iframe with display: none (firefox only!)
                            return getCptStyle ? cptStyle != null ? cptStyle.getPropertyValue(styles) : el[LEXICON.s][styles] : cptStyle;
                        }
                        else {
                            return this.each(function () {
                                setCSSVal(this, styles, val);
                            });
                        }
                    }
                    else {
                        return this.each(function () {
                            for (key in styles)
                                setCSSVal(this, key, styles[key]);
                        });
                    }
                },

                hasClass: function (className) {
                    var elem, i = 0;
                    var classNamePrepared = _strSpace + className + _strSpace;
                    var classList;

                    while ((elem = this[i++])) {
                        classList = elem.classList;
                        if (classList && classList.contains(className))
                            return true;
                        else if (elem.nodeType === 1 && (_strSpace + stripAndCollapse(elem.className + _strEmpty) + _strSpace).indexOf(classNamePrepared) > -1)
                            return true;
                    }

                    return false;
                },

                addClass: function (className) {
                    var classes;
                    var elem;
                    var cur;
                    var curValue;
                    var clazz;
                    var finalValue;
                    var supportClassList;
                    var elmClassList;
                    var i = 0;
                    var v = 0;

                    if (className) {
                        classes = className.match(_rnothtmlwhite) || [];

                        while ((elem = this[i++])) {
                            elmClassList = elem.classList;
                            if (supportClassList === undefined)
                                supportClassList = elmClassList !== undefined;

                            if (supportClassList) {
                                while ((clazz = classes[v++]))
                                    elmClassList.add(clazz);
                            }
                            else {
                                curValue = elem.className + _strEmpty;
                                cur = elem.nodeType === 1 && (_strSpace + stripAndCollapse(curValue) + _strSpace);

                                if (cur) {
                                    while ((clazz = classes[v++]))
                                        if (cur.indexOf(_strSpace + clazz + _strSpace) < 0)
                                            cur += clazz + _strSpace;

                                    finalValue = stripAndCollapse(cur);
                                    if (curValue !== finalValue)
                                        elem.className = finalValue;
                                }
                            }
                        }
                    }

                    return this;
                },

                removeClass: function (className) {
                    var classes;
                    var elem;
                    var cur;
                    var curValue;
                    var clazz;
                    var finalValue;
                    var supportClassList;
                    var elmClassList;
                    var i = 0;
                    var v = 0;

                    if (className) {
                        classes = className.match(_rnothtmlwhite) || [];

                        while ((elem = this[i++])) {
                            elmClassList = elem.classList;
                            if (supportClassList === undefined)
                                supportClassList = elmClassList !== undefined;

                            if (supportClassList) {
                                while ((clazz = classes[v++]))
                                    elmClassList.remove(clazz);
                            }
                            else {
                                curValue = elem.className + _strEmpty;
                                cur = elem.nodeType === 1 && (_strSpace + stripAndCollapse(curValue) + _strSpace);

                                if (cur) {
                                    while ((clazz = classes[v++]))
                                        while (cur.indexOf(_strSpace + clazz + _strSpace) > -1)
                                            cur = cur.replace(_strSpace + clazz + _strSpace, _strSpace);

                                    finalValue = stripAndCollapse(cur);
                                    if (curValue !== finalValue)
                                        elem.className = finalValue;
                                }
                            }
                        }
                    }

                    return this;
                },

                hide: function () {
                    return this.each(function () { this[LEXICON.s].display = 'none'; });
                },

                show: function () {
                    return this.each(function () { this[LEXICON.s].display = 'block'; });
                },

                attr: function (attrName, value) {
                    var i = 0;
                    var el;
                    while (el = this[i++]) {
                        if (value === undefined)
                            return el.getAttribute(attrName);
                        el.setAttribute(attrName, value);
                    }
                    return this;
                },

                removeAttr: function (attrName) {
                    return this.each(function () { this.removeAttribute(attrName); });
                },

                offset: function () {
                    var el = this[0];
                    var rect = el[LEXICON.bCR]();
                    var scrollLeft = window.pageXOffset || document.documentElement[_strScrollLeft];
                    var scrollTop = window.pageYOffset || document.documentElement[_strScrollTop];
                    return {
                        top: rect.top + scrollTop,
                        left: rect.left + scrollLeft
                    };
                },

                position: function () {
                    var el = this[0];
                    return {
                        top: el.offsetTop,
                        left: el.offsetLeft
                    };
                },

                scrollLeft: function (value) {
                    var i = 0;
                    var el;
                    while (el = this[i++]) {
                        if (value === undefined)
                            return el[_strScrollLeft];
                        el[_strScrollLeft] = value;
                    }
                    return this;
                },

                scrollTop: function (value) {
                    var i = 0;
                    var el;
                    while (el = this[i++]) {
                        if (value === undefined)
                            return el[_strScrollTop];
                        el[_strScrollTop] = value;
                    }
                    return this;
                },

                val: function (value) {
                    var el = this[0];
                    if (!value)
                        return el.value;
                    el.value = value;
                    return this;
                },


                //DOM TRAVERSAL / FILTERING:

                first: function () {
                    return this.eq(0);
                },

                last: function () {
                    return this.eq(-1);
                },

                eq: function (index) {
                    return FakejQuery(this[index >= 0 ? index : this[LEXICON.l] + index]);
                },

                find: function (selector) {
                    var children = [];
                    var i;
                    this.each(function () {
                        var el = this;
                        var ch = el.querySelectorAll(selector);
                        for (i = 0; i < ch[LEXICON.l]; i++)
                            children.push(ch[i]);
                    });
                    return FakejQuery(children);
                },

                children: function (selector) {
                    var children = [];
                    var el;
                    var ch;
                    var i;

                    this.each(function () {
                        ch = this.children;
                        for (i = 0; i < ch[LEXICON.l]; i++) {
                            el = ch[i];
                            if (selector) {
                                if ((el.matches && el.matches(selector)) || matches(el, selector))
                                    children.push(el);
                            }
                            else
                                children.push(el);
                        }
                    });
                    return FakejQuery(children);
                },

                parent: function (selector) {
                    var parents = [];
                    var parent;
                    this.each(function () {
                        parent = this.parentNode;
                        if (selector ? FakejQuery(parent).is(selector) : true)
                            parents.push(parent);
                    });
                    return FakejQuery(parents);
                },

                is: function (selector) {

                    var el;
                    var i;
                    for (i = 0; i < this[LEXICON.l]; i++) {
                        el = this[i];
                        if (selector === ':visible')
                            return elementIsVisible(el);
                        if (selector === ':hidden')
                            return !elementIsVisible(el);
                        if ((el.matches && el.matches(selector)) || matches(el, selector))
                            return true;
                    }
                    return false;
                },

                contents: function () {
                    var contents = [];
                    var childs;
                    var i;

                    this.each(function () {
                        childs = this.childNodes;
                        for (i = 0; i < childs[LEXICON.l]; i++)
                            contents.push(childs[i]);
                    });

                    return FakejQuery(contents);
                },

                each: function (callback) {
                    return each(this, callback);
                },


                //ANIMATION:

                animate: function (props, duration, easing, complete) {
                    return this.each(function () { animate(this, props, duration, easing, complete); });
                },

                stop: function (clearQ, jump) {
                    return this.each(function () { stop(this, clearQ, jump); });
                }
            };

            extend(FakejQuery, {
                extend: extend,
                inArray: inArray,
                isEmptyObject: isEmptyObject,
                isPlainObject: isPlainObject,
                each: each
            });

            return FakejQuery;
        })();
        var INSTANCES = (function () {
            var _targets = [];
            var _instancePropertyString = '__overlayScrollbars__';

            /**
             * Register, unregister or get a certain (or all) instances.
             * Register: Pass the target and the instance.
             * Unregister: Pass the target and null.
             * Get Instance: Pass the target from which the instance shall be got.
             * Get Targets: Pass no arguments.
             * @param target The target to which the instance shall be registered / from which the instance shall be unregistered / the instance shall be got
             * @param instance The instance.
             * @returns {*|void} Returns the instance from the given target.
             */
            return function (target, instance) {
                var argLen = arguments[LEXICON.l];
                if (argLen < 1) {
                    //return all targets
                    return _targets;
                }
                else {
                    if (instance) {
                        //register instance
                        target[_instancePropertyString] = instance;
                        _targets.push(target);
                    }
                    else {
                        var index = COMPATIBILITY.inA(target, _targets);
                        if (index > -1) {
                            if (argLen > 1) {
                                //unregister instance
                                delete target[_instancePropertyString];
                                _targets.splice(index, 1);
                            }
                            else {
                                //get instance from target
                                return _targets[index][_instancePropertyString];
                            }
                        }
                    }
                }
            }
        })();
        var PLUGIN = (function () {
            var _plugin;
            var _pluginsGlobals;
            var _pluginsAutoUpdateLoop;
            var _pluginsExtensions = [];
            var _pluginsOptions = (function () {
                var type = COMPATIBILITY.type;
                var possibleTemplateTypes = [
                    TYPES.b, //boolean
                    TYPES.n, //number
                    TYPES.s, //string
                    TYPES.a, //array
                    TYPES.o, //object
                    TYPES.f, //function
                    TYPES.z  //null
                ];
                var restrictedStringsSplit = ' ';
                var restrictedStringsPossibilitiesSplit = ':';
                var classNameAllowedValues = [TYPES.z, TYPES.s];
                var numberAllowedValues = TYPES.n;
                var booleanNullAllowedValues = [TYPES.z, TYPES.b];
                var booleanTrueTemplate = [true, TYPES.b];
                var booleanFalseTemplate = [false, TYPES.b];
                var callbackTemplate = [null, [TYPES.z, TYPES.f]];
                var updateOnLoadTemplate = [['img'], [TYPES.s, TYPES.a, TYPES.z]];
                var inheritedAttrsTemplate = [['style', 'class'], [TYPES.s, TYPES.a, TYPES.z]];
                var resizeAllowedValues = 'n:none b:both h:horizontal v:vertical';
                var overflowBehaviorAllowedValues = 'v-h:visible-hidden v-s:visible-scroll s:scroll h:hidden';
                var scrollbarsVisibilityAllowedValues = 'v:visible h:hidden a:auto';
                var scrollbarsAutoHideAllowedValues = 'n:never s:scroll l:leave m:move';
                var optionsDefaultsAndTemplate = {
                    className: ['os-theme-dark', classNameAllowedValues],                //null || string
                    resize: ['none', resizeAllowedValues],                               //none || both  || horizontal || vertical || n || b || h || v
                    sizeAutoCapable: booleanTrueTemplate,                                //true || false
                    clipAlways: booleanTrueTemplate,                                     //true || false
                    normalizeRTL: booleanTrueTemplate,                                   //true || false
                    paddingAbsolute: booleanFalseTemplate,                               //true || false
                    autoUpdate: [null, booleanNullAllowedValues],                        //true || false || null
                    autoUpdateInterval: [33, numberAllowedValues],                       //number
                    updateOnLoad: updateOnLoadTemplate,                                  //string || array || null
                    nativeScrollbarsOverlaid: {
                        showNativeScrollbars: booleanFalseTemplate,                      //true || false
                        initialize: booleanTrueTemplate                                  //true || false
                    },
                    overflowBehavior: {
                        x: ['scroll', overflowBehaviorAllowedValues],                    //visible-hidden  || visible-scroll || hidden || scroll || v-h || v-s || h || s
                        y: ['scroll', overflowBehaviorAllowedValues]                     //visible-hidden  || visible-scroll || hidden || scroll || v-h || v-s || h || s
                    },
                    scrollbars: {
                        visibility: ['auto', scrollbarsVisibilityAllowedValues],         //visible || hidden || auto || v || h || a
                        autoHide: ['never', scrollbarsAutoHideAllowedValues],            //never || scroll || leave || move || n || s || l || m
                        autoHideDelay: [800, numberAllowedValues],                       //number
                        dragScrolling: booleanTrueTemplate,                              //true || false
                        clickScrolling: booleanFalseTemplate,                            //true || false
                        touchSupport: booleanTrueTemplate,                               //true || false
                        snapHandle: booleanFalseTemplate                                 //true || false
                    },
                    textarea: {
                        dynWidth: booleanFalseTemplate,                                  //true || false
                        dynHeight: booleanFalseTemplate,                                 //true || false
                        inheritedAttrs: inheritedAttrsTemplate                           //string || array || null
                    },
                    callbacks: {
                        onInitialized: callbackTemplate,                                 //null || function
                        onInitializationWithdrawn: callbackTemplate,                     //null || function
                        onDestroyed: callbackTemplate,                                   //null || function
                        onScrollStart: callbackTemplate,                                 //null || function
                        onScroll: callbackTemplate,                                      //null || function
                        onScrollStop: callbackTemplate,                                  //null || function
                        onOverflowChanged: callbackTemplate,                             //null || function
                        onOverflowAmountChanged: callbackTemplate,                       //null || function
                        onDirectionChanged: callbackTemplate,                            //null || function
                        onContentSizeChanged: callbackTemplate,                          //null || function
                        onHostSizeChanged: callbackTemplate,                             //null || function
                        onUpdated: callbackTemplate                                      //null || function
                    }
                };
                var convert = function (template) {
                    var recursive = function (obj) {
                        var key;
                        var val;
                        var valType;
                        for (key in obj) {
                            if (!obj[LEXICON.hOP](key))
                                continue;
                            val = obj[key];
                            valType = type(val);
                            if (valType == TYPES.a)
                                obj[key] = val[template ? 1 : 0];
                            else if (valType == TYPES.o)
                                obj[key] = recursive(val);
                        }
                        return obj;
                    };
                    return recursive(FRAMEWORK.extend(true, {}, optionsDefaultsAndTemplate));
                };

                return {
                    _defaults: convert(),

                    _template: convert(true),

                    /**
                     * Validates the passed object by the passed template.
                     * @param obj The object which shall be validated.
                     * @param template The template which defines the allowed values and types.
                     * @param writeErrors True if errors shall be logged to the console.
                     * @param diffObj If a object is passed then only valid differences to this object will be returned.
                     * @returns {{}} A object which contains two objects called "default" and "prepared" which contains only the valid properties of the passed original object and discards not different values compared to the passed diffObj.
                     */
                    _validate: function (obj, template, writeErrors, diffObj) {
                        var validatedOptions = {};
                        var validatedOptionsPrepared = {};
                        var objectCopy = FRAMEWORK.extend(true, {}, obj);
                        var inArray = FRAMEWORK.inArray;
                        var isEmptyObj = FRAMEWORK.isEmptyObject;
                        var checkObjectProps = function (data, template, diffData, validatedOptions, validatedOptionsPrepared, prevPropName) {
                            for (var prop in template) {
                                if (template[LEXICON.hOP](prop) && data[LEXICON.hOP](prop)) {
                                    var isValid = false;
                                    var isDiff = false;
                                    var templateValue = template[prop];
                                    var templateValueType = type(templateValue);
                                    var templateIsComplex = templateValueType == TYPES.o;
                                    var templateTypes = !COMPATIBILITY.isA(templateValue) ? [templateValue] : templateValue;
                                    var dataDiffValue = diffData[prop];
                                    var dataValue = data[prop];
                                    var dataValueType = type(dataValue);
                                    var propPrefix = prevPropName ? prevPropName + '.' : '';
                                    var error = "The option \"" + propPrefix + prop + "\" wasn't set, because";
                                    var errorPossibleTypes = [];
                                    var errorRestrictedStrings = [];
                                    var restrictedStringValuesSplit;
                                    var restrictedStringValuesPossibilitiesSplit;
                                    var isRestrictedValue;
                                    var mainPossibility;
                                    var currType;
                                    var i;
                                    var v;
                                    var j;

                                    dataDiffValue = dataDiffValue === undefined ? {} : dataDiffValue;

                                    //if the template has a object as value, it means that the options are complex (verschachtelt)
                                    if (templateIsComplex && dataValueType == TYPES.o) {
                                        validatedOptions[prop] = {};
                                        validatedOptionsPrepared[prop] = {};
                                        checkObjectProps(dataValue, templateValue, dataDiffValue, validatedOptions[prop], validatedOptionsPrepared[prop], propPrefix + prop);
                                        FRAMEWORK.each([data, validatedOptions, validatedOptionsPrepared], function (index, value) {
                                            if (isEmptyObj(value[prop])) {
                                                delete value[prop];
                                            }
                                        });
                                    }
                                    else if (!templateIsComplex) {
                                        for (i = 0; i < templateTypes[LEXICON.l]; i++) {
                                            currType = templateTypes[i];
                                            templateValueType = type(currType);
                                            //if currtype is string and starts with restrictedStringPrefix and end with restrictedStringSuffix
                                            isRestrictedValue = templateValueType == TYPES.s && inArray(currType, possibleTemplateTypes) === -1;
                                            if (isRestrictedValue) {
                                                errorPossibleTypes.push(TYPES.s);

                                                //split it into a array which contains all possible values for example: ["y:yes", "n:no", "m:maybe"]
                                                restrictedStringValuesSplit = currType.split(restrictedStringsSplit);
                                                errorRestrictedStrings = errorRestrictedStrings.concat(restrictedStringValuesSplit);
                                                for (v = 0; v < restrictedStringValuesSplit[LEXICON.l]; v++) {
                                                    //split the possible values into their possibiliteis for example: ["y", "yes"] -> the first is always the mainPossibility
                                                    restrictedStringValuesPossibilitiesSplit = restrictedStringValuesSplit[v].split(restrictedStringsPossibilitiesSplit);
                                                    mainPossibility = restrictedStringValuesPossibilitiesSplit[0];
                                                    for (j = 0; j < restrictedStringValuesPossibilitiesSplit[LEXICON.l]; j++) {
                                                        //if any possibility matches with the dataValue, its valid
                                                        if (dataValue === restrictedStringValuesPossibilitiesSplit[j]) {
                                                            isValid = true;
                                                            break;
                                                        }
                                                    }
                                                    if (isValid)
                                                        break;
                                                }
                                            }
                                            else {
                                                errorPossibleTypes.push(currType);

                                                if (dataValueType === currType) {
                                                    isValid = true;
                                                    break;
                                                }
                                            }
                                        }

                                        if (isValid) {
                                            isDiff = dataValue !== dataDiffValue;

                                            if (isDiff)
                                                validatedOptions[prop] = dataValue;

                                            if (isRestrictedValue ? inArray(dataDiffValue, restrictedStringValuesPossibilitiesSplit) < 0 : isDiff)
                                                validatedOptionsPrepared[prop] = isRestrictedValue ? mainPossibility : dataValue;
                                        }
                                        else if (writeErrors) {
                                            console.warn(error + " it doesn't accept the type [ " + dataValueType.toUpperCase() + " ] with the value of \"" + dataValue + "\".\r\n" +
                                                "Accepted types are: [ " + errorPossibleTypes.join(', ').toUpperCase() + " ]." +
                                                (errorRestrictedStrings[length] > 0 ? "\r\nValid strings are: [ " + errorRestrictedStrings.join(', ').split(restrictedStringsPossibilitiesSplit).join(', ') + " ]." : ''));
                                        }
                                        delete data[prop];
                                    }
                                }
                            }
                        };
                        checkObjectProps(objectCopy, template, diffObj || {}, validatedOptions, validatedOptionsPrepared);

                        //add values which aren't specified in the template to the finished validated object to prevent them from being discarded
                        /*
                        if(keepForeignProps) {
                            FRAMEWORK.extend(true, validatedOptions, objectCopy);
                            FRAMEWORK.extend(true, validatedOptionsPrepared, objectCopy);
                        }
                        */

                        if (!isEmptyObj(objectCopy) && writeErrors)
                            console.warn('The following options are discarded due to invalidity:\r\n' + window.JSON.stringify(objectCopy, null, 2));

                        return {
                            _default: validatedOptions,
                            _prepared: validatedOptionsPrepared
                        };
                    }
                }
            }());

            /**
             * Initializes the object which contains global information about the plugin and each instance of it.
             */
            function initOverlayScrollbarsStatics() {
                if (!_pluginsGlobals)
                    _pluginsGlobals = new OverlayScrollbarsGlobals(_pluginsOptions._defaults);
                if (!_pluginsAutoUpdateLoop)
                    _pluginsAutoUpdateLoop = new OverlayScrollbarsAutoUpdateLoop(_pluginsGlobals);
            }

            /**
             * The global object for the OverlayScrollbars objects. It contains resources which every OverlayScrollbars object needs. This object is initialized only once: if the first OverlayScrollbars object gets initialized.
             * @param defaultOptions
             * @constructor
             */
            function OverlayScrollbarsGlobals(defaultOptions) {
                var _base = this;
                var strOverflow = 'overflow';
                var strHidden = 'hidden';
                var strScroll = 'scroll';
                var bodyElement = FRAMEWORK('body');
                var scrollbarDummyElement = FRAMEWORK('<div id="os-dummy-scrollbar-size"><div></div></div>');
                var scrollbarDummyElement0 = scrollbarDummyElement[0];
                var dummyContainerChild = FRAMEWORK(scrollbarDummyElement.children('div').eq(0));

                bodyElement.append(scrollbarDummyElement);
                scrollbarDummyElement.hide().show(); //fix IE8 bug (incorrect measuring)

                var nativeScrollbarSize = calcNativeScrollbarSize(scrollbarDummyElement0);
                var nativeScrollbarIsOverlaid = {
                    x: nativeScrollbarSize.x === 0,
                    y: nativeScrollbarSize.y === 0
                };
                var msie = (function () {
                    var ua = window.navigator.userAgent;
                    var strIndexOf = 'indexOf';
                    var strSubString = 'substring';
                    var msie = ua[strIndexOf]('MSIE ');
                    var trident = ua[strIndexOf]('Trident/');
                    var edge = ua[strIndexOf]('Edge/');
                    var rv = ua[strIndexOf]('rv:');
                    var result;
                    var parseIntFunc = parseInt;

                    // IE 10 or older => return version number
                    if (msie > 0)
                        result = parseIntFunc(ua[strSubString](msie + 5, ua[strIndexOf]('.', msie)), 10);

                    // IE 11 => return version number
                    else if (trident > 0)
                        result = parseIntFunc(ua[strSubString](rv + 3, ua[strIndexOf]('.', rv)), 10);

                    // Edge (IE 12+) => return version number
                    else if (edge > 0)
                        result = parseIntFunc(ua[strSubString](edge + 5, ua[strIndexOf]('.', edge)), 10);

                    // other browser
                    return result;
                })();

                FRAMEWORK.extend(_base, {
                    defaultOptions: defaultOptions,
                    msie: msie,
                    autoUpdateLoop: false,
                    autoUpdateRecommended: !COMPATIBILITY.mO(),
                    nativeScrollbarSize: nativeScrollbarSize,
                    nativeScrollbarIsOverlaid: nativeScrollbarIsOverlaid,
                    nativeScrollbarStyling: (function () {
                        var result = false;
                        scrollbarDummyElement.addClass('os-viewport-native-scrollbars-invisible');
                        try {
                            result = (scrollbarDummyElement.css('scrollbar-width') === 'none' && (msie > 9 || !msie)) || window.getComputedStyle(scrollbarDummyElement0, '::-webkit-scrollbar').getPropertyValue('display') === 'none';
                        } catch (ex) { }

                        //fix opera bug: scrollbar styles will only appear if overflow value is scroll or auto during the activation of the style.
                        //and set overflow to scroll
                        //scrollbarDummyElement.css(strOverflow, strHidden).hide().css(strOverflow, strScroll).show();
                        //return (scrollbarDummyElement0[LEXICON.oH] - scrollbarDummyElement0[LEXICON.cH]) === 0 && (scrollbarDummyElement0[LEXICON.oW] - scrollbarDummyElement0[LEXICON.cW]) === 0;

                        return result;
                    })(),
                    overlayScrollbarDummySize: { x: 30, y: 30 },
                    cssCalc: VENDORS._cssPropertyValue('width', 'calc', '(1px)') || null,
                    restrictedMeasuring: (function () {
                        //https://bugzilla.mozilla.org/show_bug.cgi?id=1439305
                        //since 1.11.0 always false -> fixed via CSS (hopefully)
                        scrollbarDummyElement.css(strOverflow, strHidden);
                        var scrollSize = {
                            w: scrollbarDummyElement0[LEXICON.sW],
                            h: scrollbarDummyElement0[LEXICON.sH]
                        };
                        scrollbarDummyElement.css(strOverflow, 'visible');
                        var scrollSize2 = {
                            w: scrollbarDummyElement0[LEXICON.sW],
                            h: scrollbarDummyElement0[LEXICON.sH]
                        };
                        return (scrollSize.w - scrollSize2.w) !== 0 || (scrollSize.h - scrollSize2.h) !== 0;
                    })(),
                    rtlScrollBehavior: (function () {
                        scrollbarDummyElement.css({ 'overflow-y': strHidden, 'overflow-x': strScroll, 'direction': 'rtl' }).scrollLeft(0);
                        var dummyContainerOffset = scrollbarDummyElement.offset();
                        var dummyContainerChildOffset = dummyContainerChild.offset();
                        //https://github.com/KingSora/OverlayScrollbars/issues/187
                        scrollbarDummyElement.scrollLeft(-999);
                        var dummyContainerChildOffsetAfterScroll = dummyContainerChild.offset();
                        return {
                            //origin direction = determines if the zero scroll position is on the left or right side
                            //'i' means 'invert' (i === true means that the axis must be inverted to be correct)
                            //true = on the left side
                            //false = on the right side
                            i: dummyContainerOffset.left === dummyContainerChildOffset.left,
                            //negative = determines if the maximum scroll is positive or negative
                            //'n' means 'negate' (n === true means that the axis must be negated to be correct)
                            //true = negative
                            //false = positive
                            n: dummyContainerChildOffset.left !== dummyContainerChildOffsetAfterScroll.left
                        };
                    })(),
                    supportTransform: !!VENDORS._cssProperty('transform'),
                    supportTransition: !!VENDORS._cssProperty('transition'),
                    supportPassiveEvents: (function () {
                        var supportsPassive = false;
                        try {
                            window.addEventListener('test', null, Object.defineProperty({}, 'passive', {
                                get: function () {
                                    supportsPassive = true;
                                }
                            }));
                        } catch (e) { }
                        return supportsPassive;
                    })(),
                    supportResizeObserver: !!COMPATIBILITY.rO(),
                    supportMutationObserver: !!COMPATIBILITY.mO()
                });

                scrollbarDummyElement.removeAttr(LEXICON.s).remove();

                //Catch zoom event:
                (function () {
                    if (nativeScrollbarIsOverlaid.x && nativeScrollbarIsOverlaid.y)
                        return;

                    var abs = MATH.abs;
                    var windowWidth = COMPATIBILITY.wW();
                    var windowHeight = COMPATIBILITY.wH();
                    var windowDpr = getWindowDPR();
                    var onResize = function () {
                        if (INSTANCES().length > 0) {
                            var newW = COMPATIBILITY.wW();
                            var newH = COMPATIBILITY.wH();
                            var deltaW = newW - windowWidth;
                            var deltaH = newH - windowHeight;

                            if (deltaW === 0 && deltaH === 0)
                                return;

                            var deltaWRatio = MATH.round(newW / (windowWidth / 100.0));
                            var deltaHRatio = MATH.round(newH / (windowHeight / 100.0));
                            var absDeltaW = abs(deltaW);
                            var absDeltaH = abs(deltaH);
                            var absDeltaWRatio = abs(deltaWRatio);
                            var absDeltaHRatio = abs(deltaHRatio);
                            var newDPR = getWindowDPR();

                            var deltaIsBigger = absDeltaW > 2 && absDeltaH > 2;
                            var difference = !differenceIsBiggerThanOne(absDeltaWRatio, absDeltaHRatio);
                            var dprChanged = newDPR !== windowDpr && windowDpr > 0;
                            var isZoom = deltaIsBigger && difference && dprChanged;
                            var oldScrollbarSize = _base.nativeScrollbarSize;
                            var newScrollbarSize;

                            if (isZoom) {
                                bodyElement.append(scrollbarDummyElement);
                                newScrollbarSize = _base.nativeScrollbarSize = calcNativeScrollbarSize(scrollbarDummyElement[0]);
                                scrollbarDummyElement.remove();
                                if (oldScrollbarSize.x !== newScrollbarSize.x || oldScrollbarSize.y !== newScrollbarSize.y) {
                                    FRAMEWORK.each(INSTANCES(), function () {
                                        if (INSTANCES(this))
                                            INSTANCES(this).update('zoom');
                                    });
                                }
                            }

                            windowWidth = newW;
                            windowHeight = newH;
                            windowDpr = newDPR;
                        }
                    };

                    function differenceIsBiggerThanOne(valOne, valTwo) {
                        var absValOne = abs(valOne);
                        var absValTwo = abs(valTwo);
                        return !(absValOne === absValTwo || absValOne + 1 === absValTwo || absValOne - 1 === absValTwo);
                    }

                    function getWindowDPR() {
                        var dDPI = window.screen.deviceXDPI || 0;
                        var sDPI = window.screen.logicalXDPI || 1;
                        return window.devicePixelRatio || (dDPI / sDPI);
                    }

                    FRAMEWORK(window).on('resize', onResize);
                })();

                function calcNativeScrollbarSize(measureElement) {
                    return {
                        x: measureElement[LEXICON.oH] - measureElement[LEXICON.cH],
                        y: measureElement[LEXICON.oW] - measureElement[LEXICON.cW]
                    };
                }
            }

            /**
             * The object which manages the auto update loop for all OverlayScrollbars objects. This object is initialized only once: if the first OverlayScrollbars object gets initialized.
             * @constructor
             */
            function OverlayScrollbarsAutoUpdateLoop(globals) {
                var _base = this;
                var _inArray = FRAMEWORK.inArray;
                var _getNow = COMPATIBILITY.now;
                var _strAutoUpdate = 'autoUpdate';
                var _strAutoUpdateInterval = _strAutoUpdate + 'Interval';
                var _strLength = LEXICON.l;
                var _loopingInstances = [];
                var _loopingInstancesIntervalCache = [];
                var _loopIsActive = false;
                var _loopIntervalDefault = 33;
                var _loopInterval = _loopIntervalDefault;
                var _loopTimeOld = _getNow();
                var _loopID;


                /**
                 * The auto update loop which will run every 50 milliseconds or less if the update interval of a instance is lower than 50 milliseconds.
                 */
                var loop = function () {
                    if (_loopingInstances[_strLength] > 0 && _loopIsActive) {
                        _loopID = COMPATIBILITY.rAF()(function () {
                            loop();
                        });
                        var timeNew = _getNow();
                        var timeDelta = timeNew - _loopTimeOld;
                        var lowestInterval;
                        var instance;
                        var instanceOptions;
                        var instanceAutoUpdateAllowed;
                        var instanceAutoUpdateInterval;
                        var now;

                        if (timeDelta > _loopInterval) {
                            _loopTimeOld = timeNew - (timeDelta % _loopInterval);
                            lowestInterval = _loopIntervalDefault;
                            for (var i = 0; i < _loopingInstances[_strLength]; i++) {
                                instance = _loopingInstances[i];
                                if (instance !== undefined) {
                                    instanceOptions = instance.options();
                                    instanceAutoUpdateAllowed = instanceOptions[_strAutoUpdate];
                                    instanceAutoUpdateInterval = MATH.max(1, instanceOptions[_strAutoUpdateInterval]);
                                    now = _getNow();

                                    if ((instanceAutoUpdateAllowed === true || instanceAutoUpdateAllowed === null) && (now - _loopingInstancesIntervalCache[i]) > instanceAutoUpdateInterval) {
                                        instance.update('auto');
                                        _loopingInstancesIntervalCache[i] = new Date(now += instanceAutoUpdateInterval);
                                    }

                                    lowestInterval = MATH.max(1, MATH.min(lowestInterval, instanceAutoUpdateInterval));
                                }
                            }
                            _loopInterval = lowestInterval;
                        }
                    } else {
                        _loopInterval = _loopIntervalDefault;
                    }
                };

                /**
                 * Add OverlayScrollbars instance to the auto update loop. Only successful if the instance isn't already added.
                 * @param instance The instance which shall be updated in a loop automatically.
                 */
                _base.add = function (instance) {
                    if (_inArray(instance, _loopingInstances) === -1) {
                        _loopingInstances.push(instance);
                        _loopingInstancesIntervalCache.push(_getNow());
                        if (_loopingInstances[_strLength] > 0 && !_loopIsActive) {
                            _loopIsActive = true;
                            globals.autoUpdateLoop = _loopIsActive;
                            loop();
                        }
                    }
                };

                /**
                 * Remove OverlayScrollbars instance from the auto update loop. Only successful if the instance was added before.
                 * @param instance The instance which shall be updated in a loop automatically.
                 */
                _base.remove = function (instance) {
                    var index = _inArray(instance, _loopingInstances);
                    if (index > -1) {
                        //remove from loopingInstances list
                        _loopingInstancesIntervalCache.splice(index, 1);
                        _loopingInstances.splice(index, 1);

                        //correct update loop behavior
                        if (_loopingInstances[_strLength] === 0 && _loopIsActive) {
                            _loopIsActive = false;
                            globals.autoUpdateLoop = _loopIsActive;
                            if (_loopID !== undefined) {
                                COMPATIBILITY.cAF()(_loopID);
                                _loopID = -1;
                            }
                        }
                    }
                };
            }

            /**
             * A object which manages the scrollbars visibility of the target element.
             * @param pluginTargetElement The element from which the scrollbars shall be hidden.
             * @param options The custom options.
             * @param extensions The custom extensions.
             * @param globals
             * @param autoUpdateLoop
             * @returns {*}
             * @constructor
             */
            function OverlayScrollbarsInstance(pluginTargetElement, options, extensions, globals, autoUpdateLoop) {
                //shortcuts
                var type = COMPATIBILITY.type;
                var inArray = FRAMEWORK.inArray;
                var each = FRAMEWORK.each;

                //make correct instanceof
                var _base = new _plugin();
                var _frameworkProto = FRAMEWORK[LEXICON.p];

                //if passed element is no HTML element: skip and return
                if (!isHTMLElement(pluginTargetElement))
                    return;

                //if passed element is already initialized: set passed options if there are any and return its instance
                if (INSTANCES(pluginTargetElement)) {
                    var inst = INSTANCES(pluginTargetElement);
                    inst.options(options);
                    return inst;
                }

                //globals:
                var _nativeScrollbarIsOverlaid;
                var _overlayScrollbarDummySize;
                var _rtlScrollBehavior;
                var _autoUpdateRecommended;
                var _msieVersion;
                var _nativeScrollbarStyling;
                var _cssCalc;
                var _nativeScrollbarSize;
                var _supportTransition;
                var _supportTransform;
                var _supportPassiveEvents;
                var _supportResizeObserver;
                var _supportMutationObserver;
                var _restrictedMeasuring;

                //general readonly:
                var _initialized;
                var _destroyed;
                var _isTextarea;
                var _isBody;
                var _documentMixed;
                var _domExists;

                //general:
                var _isBorderBox;
                var _sizeAutoObserverAdded;
                var _paddingX;
                var _paddingY;
                var _borderX;
                var _borderY;
                var _marginX;
                var _marginY;
                var _isRTL;
                var _sleeping;
                var _contentBorderSize = {};
                var _scrollHorizontalInfo = {};
                var _scrollVerticalInfo = {};
                var _viewportSize = {};
                var _nativeScrollbarMinSize = {};

                //naming:	
                var _strMinusHidden = '-hidden';
                var _strMarginMinus = 'margin-';
                var _strPaddingMinus = 'padding-';
                var _strBorderMinus = 'border-';
                var _strTop = 'top';
                var _strRight = 'right';
                var _strBottom = 'bottom';
                var _strLeft = 'left';
                var _strMinMinus = 'min-';
                var _strMaxMinus = 'max-';
                var _strWidth = 'width';
                var _strHeight = 'height';
                var _strFloat = 'float';
                var _strEmpty = '';
                var _strAuto = 'auto';
                var _strSync = 'sync';
                var _strScroll = 'scroll';
                var _strHundredPercent = '100%';
                var _strX = 'x';
                var _strY = 'y';
                var _strDot = '.';
                var _strSpace = ' ';
                var _strScrollbar = 'scrollbar';
                var _strMinusHorizontal = '-horizontal';
                var _strMinusVertical = '-vertical';
                var _strScrollLeft = _strScroll + 'Left';
                var _strScrollTop = _strScroll + 'Top';
                var _strMouseTouchDownEvent = 'mousedown touchstart';
                var _strMouseTouchUpEvent = 'mouseup touchend touchcancel';
                var _strMouseTouchMoveEvent = 'mousemove touchmove';
                var _strMouseEnter = 'mouseenter';
                var _strMouseLeave = 'mouseleave';
                var _strKeyDownEvent = 'keydown';
                var _strKeyUpEvent = 'keyup';
                var _strSelectStartEvent = 'selectstart';
                var _strTransitionEndEvent = 'transitionend webkitTransitionEnd oTransitionEnd';
                var _strResizeObserverProperty = '__overlayScrollbarsRO__';

                //class names:	
                var _cassNamesPrefix = 'os-';
                var _classNameHTMLElement = _cassNamesPrefix + 'html';
                var _classNameHostElement = _cassNamesPrefix + 'host';
                var _classNameHostElementForeign = _classNameHostElement + '-foreign';
                var _classNameHostTextareaElement = _classNameHostElement + '-textarea';
                var _classNameHostScrollbarHorizontalHidden = _classNameHostElement + '-' + _strScrollbar + _strMinusHorizontal + _strMinusHidden;
                var _classNameHostScrollbarVerticalHidden = _classNameHostElement + '-' + _strScrollbar + _strMinusVertical + _strMinusHidden;
                var _classNameHostTransition = _classNameHostElement + '-transition';
                var _classNameHostRTL = _classNameHostElement + '-rtl';
                var _classNameHostResizeDisabled = _classNameHostElement + '-resize-disabled';
                var _classNameHostScrolling = _classNameHostElement + '-scrolling';
                var _classNameHostOverflow = _classNameHostElement + '-overflow';
                var _classNameHostOverflow = _classNameHostElement + '-overflow';
                var _classNameHostOverflowX = _classNameHostOverflow + '-x';
                var _classNameHostOverflowY = _classNameHostOverflow + '-y';
                var _classNameTextareaElement = _cassNamesPrefix + 'textarea';
                var _classNameTextareaCoverElement = _classNameTextareaElement + '-cover';
                var _classNamePaddingElement = _cassNamesPrefix + 'padding';
                var _classNameViewportElement = _cassNamesPrefix + 'viewport';
                var _classNameViewportNativeScrollbarsInvisible = _classNameViewportElement + '-native-scrollbars-invisible';
                var _classNameViewportNativeScrollbarsOverlaid = _classNameViewportElement + '-native-scrollbars-overlaid';
                var _classNameContentElement = _cassNamesPrefix + 'content';
                var _classNameContentArrangeElement = _cassNamesPrefix + 'content-arrange';
                var _classNameContentGlueElement = _cassNamesPrefix + 'content-glue';
                var _classNameSizeAutoObserverElement = _cassNamesPrefix + 'size-auto-observer';
                var _classNameResizeObserverElement = _cassNamesPrefix + 'resize-observer';
                var _classNameResizeObserverItemElement = _cassNamesPrefix + 'resize-observer-item';
                var _classNameResizeObserverItemFinalElement = _classNameResizeObserverItemElement + '-final';
                var _classNameTextInherit = _cassNamesPrefix + 'text-inherit';
                var _classNameScrollbar = _cassNamesPrefix + _strScrollbar;
                var _classNameScrollbarTrack = _classNameScrollbar + '-track';
                var _classNameScrollbarTrackOff = _classNameScrollbarTrack + '-off';
                var _classNameScrollbarHandle = _classNameScrollbar + '-handle';
                var _classNameScrollbarHandleOff = _classNameScrollbarHandle + '-off';
                var _classNameScrollbarUnusable = _classNameScrollbar + '-unusable';
                var _classNameScrollbarAutoHidden = _classNameScrollbar + '-' + _strAuto + _strMinusHidden;
                var _classNameScrollbarCorner = _classNameScrollbar + '-corner';
                var _classNameScrollbarCornerResize = _classNameScrollbarCorner + '-resize';
                var _classNameScrollbarCornerResizeB = _classNameScrollbarCornerResize + '-both';
                var _classNameScrollbarCornerResizeH = _classNameScrollbarCornerResize + _strMinusHorizontal;
                var _classNameScrollbarCornerResizeV = _classNameScrollbarCornerResize + _strMinusVertical;
                var _classNameScrollbarHorizontal = _classNameScrollbar + _strMinusHorizontal;
                var _classNameScrollbarVertical = _classNameScrollbar + _strMinusVertical;
                var _classNameDragging = _cassNamesPrefix + 'dragging';
                var _classNameThemeNone = _cassNamesPrefix + 'theme-none';
                var _classNamesDynamicDestroy = [
                    _classNameViewportNativeScrollbarsInvisible,
                    _classNameViewportNativeScrollbarsOverlaid,
                    _classNameScrollbarTrackOff,
                    _classNameScrollbarHandleOff,
                    _classNameScrollbarUnusable,
                    _classNameScrollbarAutoHidden,
                    _classNameScrollbarCornerResize,
                    _classNameScrollbarCornerResizeB,
                    _classNameScrollbarCornerResizeH,
                    _classNameScrollbarCornerResizeV,
                    _classNameDragging].join(_strSpace);

                //callbacks:	
                var _callbacksInitQeueue = [];

                //attrs viewport shall inherit from target	
                var _viewportAttrsFromTarget = [LEXICON.ti];

                //options:	
                var _defaultOptions;
                var _currentOptions;
                var _currentPreparedOptions;

                //extensions:	
                var _extensions = {};
                var _extensionsPrivateMethods = 'added removed on contract';

                //update	
                var _lastUpdateTime;
                var _swallowedUpdateHints = {};
                var _swallowedUpdateTimeout;
                var _swallowUpdateLag = 42;
                var _updateOnLoadEventName = 'load';
                var _updateOnLoadElms = [];

                //DOM elements:	
                var _windowElement;
                var _documentElement;
                var _htmlElement;
                var _bodyElement;
                var _targetElement;                     //the target element of this OverlayScrollbars object	
                var _hostElement;                       //the host element of this OverlayScrollbars object -> may be the same as targetElement	
                var _sizeAutoObserverElement;           //observes size auto changes	
                var _sizeObserverElement;               //observes size and padding changes	
                var _paddingElement;                    //manages the padding	
                var _viewportElement;                   //is the viewport of our scrollbar model	
                var _contentElement;                    //the element which holds the content	
                var _contentArrangeElement;             //is needed for correct sizing of the content element (only if native scrollbars are overlays)	
                var _contentGlueElement;                //has always the size of the content element	
                var _textareaCoverElement;              //only applied if target is a textarea element. Used for correct size calculation and for prevention of uncontrolled scrolling	
                var _scrollbarCornerElement;
                var _scrollbarHorizontalElement;
                var _scrollbarHorizontalTrackElement;
                var _scrollbarHorizontalHandleElement;
                var _scrollbarVerticalElement;
                var _scrollbarVerticalTrackElement;
                var _scrollbarVerticalHandleElement;
                var _windowElementNative;
                var _documentElementNative;
                var _targetElementNative;
                var _hostElementNative;
                var _sizeAutoObserverElementNative;
                var _sizeObserverElementNative;
                var _paddingElementNative;
                var _viewportElementNative;
                var _contentElementNative;

                //Cache:	
                var _hostSizeCache;
                var _contentScrollSizeCache;
                var _arrangeContentSizeCache;
                var _hasOverflowCache;
                var _hideOverflowCache;
                var _widthAutoCache;
                var _heightAutoCache;
                var _cssBoxSizingCache;
                var _cssPaddingCache;
                var _cssBorderCache;
                var _cssMarginCache;
                var _cssDirectionCache;
                var _cssDirectionDetectedCache;
                var _paddingAbsoluteCache;
                var _clipAlwaysCache;
                var _contentGlueSizeCache;
                var _overflowBehaviorCache;
                var _overflowAmountCache;
                var _ignoreOverlayScrollbarHidingCache;
                var _autoUpdateCache;
                var _sizeAutoCapableCache;
                var _contentElementScrollSizeChangeDetectedCache;
                var _hostElementSizeChangeDetectedCache;
                var _scrollbarsVisibilityCache;
                var _scrollbarsAutoHideCache;
                var _scrollbarsClickScrollingCache;
                var _scrollbarsDragScrollingCache;
                var _resizeCache;
                var _normalizeRTLCache;
                var _classNameCache;
                var _oldClassName;
                var _textareaAutoWrappingCache;
                var _textareaInfoCache;
                var _textareaSizeCache;
                var _textareaDynHeightCache;
                var _textareaDynWidthCache;
                var _bodyMinSizeCache;
                var _updateAutoCache = {};

                //MutationObserver:	
                var _mutationObserverHost;
                var _mutationObserverContent;
                var _mutationObserverHostCallback;
                var _mutationObserverContentCallback;
                var _mutationObserversConnected;
                var _mutationObserverAttrsTextarea = ['wrap', 'cols', 'rows'];
                var _mutationObserverAttrsHost = [LEXICON.i, LEXICON.c, LEXICON.s, 'open'].concat(_viewportAttrsFromTarget);

                //events:	
                var _destroyEvents = [];

                //textarea:	
                var _textareaHasFocus;

                //scrollbars:	
                var _scrollbarsAutoHideTimeoutId;
                var _scrollbarsAutoHideMoveTimeoutId;
                var _scrollbarsAutoHideDelay;
                var _scrollbarsAutoHideNever;
                var _scrollbarsAutoHideScroll;
                var _scrollbarsAutoHideMove;
                var _scrollbarsAutoHideLeave;
                var _scrollbarsHandleHovered;
                var _scrollbarsHandlesDefineScrollPos;

                //resize	
                var _resizeNone;
                var _resizeBoth;
                var _resizeHorizontal;
                var _resizeVertical;


                //==== Event Listener ====//	

                /**	
                 * Adds or removes a event listener from the given element. 	
                 * @param element The element to which the event listener shall be applied or removed.	
                 * @param eventNames The name(s) of the events.	
                 * @param listener The method which shall be called.	
                 * @param remove True if the handler shall be removed, false or undefined if the handler shall be added.	
                 * @param passiveOrOptions The options for the event.
                 */
                function setupResponsiveEventListener(element, eventNames, listener, remove, passiveOrOptions) {
                    var collected = COMPATIBILITY.isA(eventNames) && COMPATIBILITY.isA(listener);
                    var method = remove ? 'removeEventListener' : 'addEventListener';
                    var onOff = remove ? 'off' : 'on';
                    var events = collected ? false : eventNames.split(_strSpace)
                    var i = 0;

                    var passiveOrOptionsIsObj = FRAMEWORK.isPlainObject(passiveOrOptions);
                    var passive = (_supportPassiveEvents && (passiveOrOptionsIsObj ? (passiveOrOptions._passive) : passiveOrOptions)) || false;
                    var capture = passiveOrOptionsIsObj && (passiveOrOptions._capture || false);
                    var nativeParam = _supportPassiveEvents ? {
                        passive: passive,
                        capture: capture,
                    } : capture;

                    if (collected) {
                        for (; i < eventNames[LEXICON.l]; i++)
                            setupResponsiveEventListener(element, eventNames[i], listener[i], remove, passiveOrOptions);
                    }
                    else {
                        for (; i < events[LEXICON.l]; i++) {
                            if(_supportPassiveEvents) {
                                element[0][method](events[i], listener, nativeParam);
                            }
                            else {
                                element[onOff](events[i], listener);
                            }     
                        }
                    }
                }


                function addDestroyEventListener(element, eventNames, listener, passive) {
                    setupResponsiveEventListener(element, eventNames, listener, false, passive);
                    _destroyEvents.push(COMPATIBILITY.bind(setupResponsiveEventListener, 0, element, eventNames, listener, true, passive));
                }

                //==== Resize Observer ====//

                /**
                 * Adds or removes a resize observer from the given element.
                 * @param targetElement The element to which the resize observer shall be added or removed.
                 * @param onElementResizedCallback The callback which is fired every time the resize observer registers a size change or false / undefined if the resizeObserver shall be removed.
                 */
                function setupResizeObserver(targetElement, onElementResizedCallback) {
                    if (targetElement) {
                        var resizeObserver = COMPATIBILITY.rO();
                        var strAnimationStartEvent = 'animationstart mozAnimationStart webkitAnimationStart MSAnimationStart';
                        var strChildNodes = 'childNodes';
                        var constScroll = 3333333;
                        var callback = function () {
                            targetElement[_strScrollTop](constScroll)[_strScrollLeft](_isRTL ? _rtlScrollBehavior.n ? -constScroll : _rtlScrollBehavior.i ? 0 : constScroll : constScroll);
                            onElementResizedCallback();
                        };
                        //add resize observer:
                        if (onElementResizedCallback) {
                            if (_supportResizeObserver) {
                                var element = targetElement.addClass('observed').append(generateDiv(_classNameResizeObserverElement)).contents()[0];
                                var observer = element[_strResizeObserverProperty] = new resizeObserver(callback);
                                observer.observe(element);
                            }
                            else {
                                if (_msieVersion > 9 || !_autoUpdateRecommended) {
                                    targetElement.prepend(
                                        generateDiv(_classNameResizeObserverElement,
                                            generateDiv({ c: _classNameResizeObserverItemElement, dir: 'ltr' },
                                                generateDiv(_classNameResizeObserverItemElement,
                                                    generateDiv(_classNameResizeObserverItemFinalElement)
                                                ) +
                                                generateDiv(_classNameResizeObserverItemElement,
                                                    generateDiv({ c: _classNameResizeObserverItemFinalElement, style: 'width: 200%; height: 200%' })
                                                )
                                            )
                                        )
                                    );

                                    var observerElement = targetElement[0][strChildNodes][0][strChildNodes][0];
                                    var shrinkElement = FRAMEWORK(observerElement[strChildNodes][1]);
                                    var expandElement = FRAMEWORK(observerElement[strChildNodes][0]);
                                    var expandElementChild = FRAMEWORK(expandElement[0][strChildNodes][0]);
                                    var widthCache = observerElement[LEXICON.oW];
                                    var heightCache = observerElement[LEXICON.oH];
                                    var isDirty;
                                    var rAFId;
                                    var currWidth;
                                    var currHeight;
                                    var factor = 2;
                                    var nativeScrollbarSize = globals.nativeScrollbarSize; //care don't make changes to this object!!!
                                    var reset = function () {
                                        /*
                                         var sizeResetWidth = observerElement[LEXICON.oW] + nativeScrollbarSize.x * factor + nativeScrollbarSize.y * factor + _overlayScrollbarDummySize.x + _overlayScrollbarDummySize.y;
                                         var sizeResetHeight = observerElement[LEXICON.oH] + nativeScrollbarSize.x * factor + nativeScrollbarSize.y * factor + _overlayScrollbarDummySize.x + _overlayScrollbarDummySize.y;
                                         var expandChildCSS = {};
                                         expandChildCSS[_strWidth] = sizeResetWidth;
                                         expandChildCSS[_strHeight] = sizeResetHeight;
                                         expandElementChild.css(expandChildCSS);


                                         expandElement[_strScrollLeft](sizeResetWidth)[_strScrollTop](sizeResetHeight);
                                         shrinkElement[_strScrollLeft](sizeResetWidth)[_strScrollTop](sizeResetHeight);
                                         */
                                        expandElement[_strScrollLeft](constScroll)[_strScrollTop](constScroll);
                                        shrinkElement[_strScrollLeft](constScroll)[_strScrollTop](constScroll);
                                    };
                                    var onResized = function () {
                                        rAFId = 0;
                                        if (!isDirty)
                                            return;

                                        widthCache = currWidth;
                                        heightCache = currHeight;
                                        callback();
                                    };
                                    var onScroll = function (event) {
                                        currWidth = observerElement[LEXICON.oW];
                                        currHeight = observerElement[LEXICON.oH];
                                        isDirty = currWidth != widthCache || currHeight != heightCache;

                                        if (event && isDirty && !rAFId) {
                                            COMPATIBILITY.cAF()(rAFId);
                                            rAFId = COMPATIBILITY.rAF()(onResized);
                                        }
                                        else if (!event)
                                            onResized();

                                        reset();
                                        if (event) {
                                            COMPATIBILITY.prvD(event);
                                            COMPATIBILITY.stpP(event);
                                        }
                                        return false;
                                    };
                                    var expandChildCSS = {};
                                    var observerElementCSS = {};

                                    setTopRightBottomLeft(observerElementCSS, _strEmpty, [
                                        -((nativeScrollbarSize.y + 1) * factor),
                                        nativeScrollbarSize.x * -factor,
                                        nativeScrollbarSize.y * -factor,
                                        -((nativeScrollbarSize.x + 1) * factor)
                                    ]);

                                    FRAMEWORK(observerElement).css(observerElementCSS);
                                    expandElement.on(_strScroll, onScroll);
                                    shrinkElement.on(_strScroll, onScroll);
                                    targetElement.on(strAnimationStartEvent, function () {
                                        onScroll(false);
                                    });
                                    //lets assume that the divs will never be that large and a constant value is enough
                                    expandChildCSS[_strWidth] = constScroll;
                                    expandChildCSS[_strHeight] = constScroll;
                                    expandElementChild.css(expandChildCSS);

                                    reset();
                                }
                                else {
                                    var attachEvent = _documentElementNative.attachEvent;
                                    var isIE = _msieVersion !== undefined;
                                    if (attachEvent) {
                                        targetElement.prepend(generateDiv(_classNameResizeObserverElement));
                                        findFirst(targetElement, _strDot + _classNameResizeObserverElement)[0].attachEvent('onresize', callback);
                                    }
                                    else {
                                        var obj = _documentElementNative.createElement(TYPES.o);
                                        obj.setAttribute(LEXICON.ti, '-1');
                                        obj.setAttribute(LEXICON.c, _classNameResizeObserverElement);
                                        obj.onload = function () {
                                            var wnd = this.contentDocument.defaultView;
                                            wnd.addEventListener('resize', callback);
                                            wnd.document.documentElement.style.display = 'none';
                                        };
                                        obj.type = 'text/html';
                                        if (isIE)
                                            targetElement.prepend(obj);
                                        obj.data = 'about:blank';
                                        if (!isIE)
                                            targetElement.prepend(obj);
                                        targetElement.on(strAnimationStartEvent, callback);
                                    }
                                }
                            }

                            if (targetElement[0] === _sizeObserverElementNative) {
                                var directionChanged = function () {
                                    var dir = _hostElement.css('direction');
                                    var css = {};
                                    var scrollLeftValue = 0;
                                    var result = false;
                                    if (dir !== _cssDirectionDetectedCache) {
                                        if (dir === 'ltr') {
                                            css[_strLeft] = 0;
                                            css[_strRight] = _strAuto;
                                            scrollLeftValue = constScroll;
                                        }
                                        else {
                                            css[_strLeft] = _strAuto;
                                            css[_strRight] = 0;
                                            scrollLeftValue = _rtlScrollBehavior.n ? -constScroll : _rtlScrollBehavior.i ? 0 : constScroll;
                                        }
                                        //execution order is important for IE!!!
                                        _sizeObserverElement.children().eq(0).css(css);
                                        _sizeObserverElement[_strScrollLeft](scrollLeftValue)[_strScrollTop](constScroll);
                                        _cssDirectionDetectedCache = dir;
                                        result = true;
                                    }
                                    return result;
                                };
                                directionChanged();
                                addDestroyEventListener(targetElement, _strScroll, function (event) {
                                    if (directionChanged())
                                        update();
                                    COMPATIBILITY.prvD(event);
                                    COMPATIBILITY.stpP(event);
                                    return false;
                                });
                            }
                        }
                        //remove resize observer:
                        else {
                            if (_supportResizeObserver) {
                                var element = targetElement.contents()[0];
                                var resizeObserverObj = element[_strResizeObserverProperty];
                                if (resizeObserverObj) {
                                    resizeObserverObj.disconnect();
                                    delete element[_strResizeObserverProperty];
                                }
                            }
                            else {
                                remove(targetElement.children(_strDot + _classNameResizeObserverElement).eq(0));
                            }
                        }
                    }
                }

                /**
                 * Freezes or unfreezes the given resize observer.
                 * @param targetElement The element to which the target resize observer is applied.
                 * @param freeze True if the resize observer shall be frozen, false otherwise.
                 
                function freezeResizeObserver(targetElement, freeze) {
                    if (targetElement !== undefined) {
                        if(freeze) {
                            if (_supportResizeObserver) {
                                var element = targetElement.contents()[0];
                                element[_strResizeObserverProperty].unobserve(element);
                            }
                            else {
                                targetElement = targetElement.children(_strDot + _classNameResizeObserverElement).eq(0);
                                var w = targetElement.css(_strWidth);
                                var h = targetElement.css(_strHeight);
                                var css = {};
                                css[_strWidth] = w;
                                css[_strHeight] = h;
                                targetElement.css(css);
                            }
                        }
                        else {
                            if (_supportResizeObserver) {
                                var element = targetElement.contents()[0];
                                element[_strResizeObserverProperty].observe(element);
                            }
                            else {
                                var css = { };
                                css[_strHeight] = _strEmpty;
                                css[_strWidth] = _strEmpty;
                                targetElement.children(_strDot + _classNameResizeObserverElement).eq(0).css(css);
                            }
                        }
                    }
                }
                */


                //==== Mutation Observers ====//

                /**
                 * Creates MutationObservers for the host and content Element if they are supported.
                 */
                function createMutationObservers() {
                    if (_supportMutationObserver) {
                        var mutationObserverContentLag = 11;
                        var mutationObserver = COMPATIBILITY.mO();
                        var contentLastUpdate = COMPATIBILITY.now();
                        var mutationTarget;
                        var mutationAttrName;
                        var mutationIsClass;
                        var oldMutationVal;
                        var newClassVal;
                        var hostClassNameRegex;
                        var contentTimeout;
                        var now;
                        var sizeAuto;
                        var action;

                        _mutationObserverHostCallback = function (mutations) {

                            var doUpdate = false;
                            var doUpdateForce = false;
                            var mutation;
                            var mutatedAttrs = [];

                            if (_initialized && !_sleeping) {
                                each(mutations, function () {
                                    mutation = this;
                                    mutationTarget = mutation.target;
                                    mutationAttrName = mutation.attributeName;
                                    mutationIsClass = mutationAttrName === LEXICON.c;
                                    oldMutationVal = mutation.oldValue;
                                    newClassVal = mutationTarget.className;

                                    if (_domExists && mutationIsClass && !doUpdateForce) {
                                        // if old class value contains _classNameHostElementForeign and new class value doesn't
                                        if (oldMutationVal.indexOf(_classNameHostElementForeign) > -1 && newClassVal.indexOf(_classNameHostElementForeign) < 0) {
                                            hostClassNameRegex = createHostClassNameRegExp(true);
                                            _hostElementNative.className = newClassVal.split(_strSpace).concat(oldMutationVal.split(_strSpace).filter(function (name) {
                                                return name.match(hostClassNameRegex);
                                            })).join(_strSpace);
                                            doUpdate = doUpdateForce = true;
                                        }
                                    }

                                    if (!doUpdate) {
                                        doUpdate = mutationIsClass
                                            ? hostClassNamesChanged(oldMutationVal, newClassVal)
                                            : mutationAttrName === LEXICON.s
                                                ? oldMutationVal !== mutationTarget[LEXICON.s].cssText
                                                : true;
                                    }

                                    mutatedAttrs.push(mutationAttrName);
                                });

                                updateViewportAttrsFromTarget(mutatedAttrs);

                                if (doUpdate)
                                    _base.update(doUpdateForce || _strAuto);
                            }
                            return doUpdate;
                        };
                        _mutationObserverContentCallback = function (mutations) {
                            var doUpdate = false;
                            var mutation;

                            if (_initialized && !_sleeping) {
                                each(mutations, function () {
                                    mutation = this;
                                    doUpdate = isUnknownMutation(mutation);
                                    return !doUpdate;
                                });

                                if (doUpdate) {
                                    now = COMPATIBILITY.now();
                                    sizeAuto = (_heightAutoCache || _widthAutoCache);
                                    action = function () {
                                        if (!_destroyed) {
                                            contentLastUpdate = now;

                                            //if cols, rows or wrap attr was changed
                                            if (_isTextarea)
                                                textareaUpdate();

                                            if (sizeAuto)
                                                update();
                                            else
                                                _base.update(_strAuto);
                                        }
                                    };
                                    clearTimeout(contentTimeout);
                                    if (mutationObserverContentLag <= 0 || now - contentLastUpdate > mutationObserverContentLag || !sizeAuto)
                                        action();
                                    else
                                        contentTimeout = setTimeout(action, mutationObserverContentLag);
                                }
                            }
                            return doUpdate;
                        }

                        _mutationObserverHost = new mutationObserver(_mutationObserverHostCallback);
                        _mutationObserverContent = new mutationObserver(_mutationObserverContentCallback);
                    }
                }

                /**
                 * Connects the MutationObservers if they are supported.
                 */
                function connectMutationObservers() {
                    if (_supportMutationObserver && !_mutationObserversConnected) {
                        _mutationObserverHost.observe(_hostElementNative, {
                            attributes: true,
                            attributeOldValue: true,
                            attributeFilter: _mutationObserverAttrsHost
                        });

                        _mutationObserverContent.observe(_isTextarea ? _targetElementNative : _contentElementNative, {
                            attributes: true,
                            attributeOldValue: true,
                            subtree: !_isTextarea,
                            childList: !_isTextarea,
                            characterData: !_isTextarea,
                            attributeFilter: _isTextarea ? _mutationObserverAttrsTextarea : _mutationObserverAttrsHost
                        });

                        _mutationObserversConnected = true;
                    }
                }

                /**
                 * Disconnects the MutationObservers if they are supported.
                 */
                function disconnectMutationObservers() {
                    if (_supportMutationObserver && _mutationObserversConnected) {
                        _mutationObserverHost.disconnect();
                        _mutationObserverContent.disconnect();

                        _mutationObserversConnected = false;
                    }
                }


                //==== Events of elements ====//

                /**
                 * This method gets called every time the host element gets resized. IMPORTANT: Padding changes are detected too!!
                 * It refreshes the hostResizedEventArgs and the hostSizeResizeCache.
                 * If there are any size changes, the update method gets called.
                 */
                function hostOnResized() {
                    if (!_sleeping) {
                        var changed;
                        var hostSize = {
                            w: _sizeObserverElementNative[LEXICON.sW],
                            h: _sizeObserverElementNative[LEXICON.sH]
                        };

                        changed = checkCache(hostSize, _hostElementSizeChangeDetectedCache);
                        _hostElementSizeChangeDetectedCache = hostSize;
                        if (changed)
                            update({ _hostSizeChanged: true });
                    }
                }

                /**
                 * The mouse enter event of the host element. This event is only needed for the autoHide feature.
                 */
                function hostOnMouseEnter() {
                    if (_scrollbarsAutoHideLeave)
                        refreshScrollbarsAutoHide(true);
                }

                /**
                 * The mouse leave event of the host element. This event is only needed for the autoHide feature.
                 */
                function hostOnMouseLeave() {
                    if (_scrollbarsAutoHideLeave && !_bodyElement.hasClass(_classNameDragging))
                        refreshScrollbarsAutoHide(false);
                }

                /**
                 * The mouse move event of the host element. This event is only needed for the autoHide "move" feature.
                 */
                function hostOnMouseMove() {
                    if (_scrollbarsAutoHideMove) {
                        refreshScrollbarsAutoHide(true);
                        clearTimeout(_scrollbarsAutoHideMoveTimeoutId);
                        _scrollbarsAutoHideMoveTimeoutId = setTimeout(function () {
                            if (_scrollbarsAutoHideMove && !_destroyed)
                                refreshScrollbarsAutoHide(false);
                        }, 100);
                    }
                }

                /**
                 * Prevents text from deselection if attached to the document element on the mousedown event of a DOM element.
                 * @param event The select start event.
                 */
                function documentOnSelectStart(event) {
                    COMPATIBILITY.prvD(event);
                    return false;
                }

                /**	
                 * A callback which will be called after a element has loaded.	
                 */
                function updateOnLoadCallback(event) {
					if (!_destroyed) {
						var target = event.target;
						var elm = FRAMEWORK(event.target);
						var index = FRAMEWORK.inArray(target, _updateOnLoadElms);
						if (index > -1) {
							_updateOnLoadElms.splice(index, 1);
						}

						eachUpdateOnLoad(function (i, updateOnLoadSelector) {
							if (elm.is(updateOnLoadSelector)) {
								update({ _contentSizeChanged: true });
							}
						});
					}
                }

                /**
                * Adds or removes mouse & touch events of the host element. (for handling auto-hiding of the scrollbars)
                * @param destroy Indicates whether the events shall be added or removed.
                */
                function setupHostMouseTouchEvents(destroy) {
                    if (!destroy)
                        setupHostMouseTouchEvents(true);

                    setupResponsiveEventListener(_hostElement,
                        _strMouseTouchMoveEvent.split(_strSpace)[0],
                        hostOnMouseMove,
                        (!_scrollbarsAutoHideMove || destroy), true);
                    setupResponsiveEventListener(_hostElement,
                        [_strMouseEnter, _strMouseLeave],
                        [hostOnMouseEnter, hostOnMouseLeave],
                        (!_scrollbarsAutoHideLeave || destroy), true);

                    //if the plugin is initialized and the mouse is over the host element, make the scrollbars visible
                    if (!_initialized && !destroy)
                        _hostElement.one('mouseover', hostOnMouseEnter);
                }


                //==== Update Detection ====//

                /**
                 * Measures the min width and min height of the body element and refreshes the related cache.
                 * @returns {boolean} True if the min width or min height has changed, false otherwise.
                 */
                function bodyMinSizeChanged() {
                    var bodyMinSize = {};
                    if (_isBody && _contentArrangeElement) {
                        bodyMinSize.w = parseToZeroOrNumber(_contentArrangeElement.css(_strMinMinus + _strWidth));
                        bodyMinSize.h = parseToZeroOrNumber(_contentArrangeElement.css(_strMinMinus + _strHeight));
                        bodyMinSize.c = checkCache(bodyMinSize, _bodyMinSizeCache);
                        bodyMinSize.f = true; //flag for "measured at least once"
                    }
                    _bodyMinSizeCache = bodyMinSize;
                    return !!bodyMinSize.c;
                }

                /**
                 * Returns true if the class names really changed (new class without plugin host prefix)
                 * @param oldClassNames The old ClassName string or array.
                 * @param newClassNames The new ClassName string or array.
                 * @returns {boolean} True if the class names has really changed, false otherwise.
                 */
                function hostClassNamesChanged(oldClassNames, newClassNames) {
                    var currClasses = typeof newClassNames == TYPES.s ? newClassNames.split(_strSpace) : [];
                    var oldClasses = typeof oldClassNames == TYPES.s ? oldClassNames.split(_strSpace) : [];
                    var diff = getArrayDifferences(oldClasses, currClasses);

                    // remove none theme from diff list to prevent update
                    var idx = inArray(_classNameThemeNone, diff);
                    var i;
                    var regex;

                    if (idx > -1)
                        diff.splice(idx, 1);

                    if (diff[LEXICON.l] > 0) {
                        regex = createHostClassNameRegExp(true, true);
                        for (i = 0; i < diff.length; i++) {
                            if (!diff[i].match(regex)) {
                                return true;
                            }
                        }
                    }
                    return false;
                }

                /**
                 * Returns true if the given mutation is not from a from the plugin generated element. If the target element is a textarea the mutation is always unknown.
                 * @param mutation The mutation which shall be checked.
                 * @returns {boolean} True if the mutation is from a unknown element, false otherwise.
                 */
                function isUnknownMutation(mutation) {
                    var attributeName = mutation.attributeName;
                    var mutationTarget = mutation.target;
                    var mutationType = mutation.type;
                    var strClosest = 'closest';

                    if (mutationTarget === _contentElementNative)
                        return attributeName === null;
                    if (mutationType === 'attributes' && (attributeName === LEXICON.c || attributeName === LEXICON.s) && !_isTextarea) {
                        //ignore className changes by the plugin	
                        if (attributeName === LEXICON.c && FRAMEWORK(mutationTarget).hasClass(_classNameHostElement))
                            return hostClassNamesChanged(mutation.oldValue, mutationTarget.className);

                        //only do it of browser support it natively	
                        if (typeof mutationTarget[strClosest] != TYPES.f)
                            return true;
                        if (mutationTarget[strClosest](_strDot + _classNameResizeObserverElement) !== null ||
                            mutationTarget[strClosest](_strDot + _classNameScrollbar) !== null ||
                            mutationTarget[strClosest](_strDot + _classNameScrollbarCorner) !== null)
                            return false;
                    }
                    return true;
                }

                /**
                 * Returns true if the content size was changed since the last time this method was called.
                 * @returns {boolean} True if the content size was changed, false otherwise.
                 */
                function updateAutoContentSizeChanged() {
                    if (_sleeping)
                        return false;

                    var contentMeasureElement = getContentMeasureElement();
                    var textareaValueLength = _isTextarea && _widthAutoCache && !_textareaAutoWrappingCache ? _targetElement.val().length : 0;
                    var setCSS = !_mutationObserversConnected && _widthAutoCache && !_isTextarea;
                    var css = {};
                    var float;
                    var bodyMinSizeC;
                    var changed;
                    var contentElementScrollSize;

                    if (setCSS) {
                        float = _contentElement.css(_strFloat);
                        css[_strFloat] = _isRTL ? _strRight : _strLeft;
                        css[_strWidth] = _strAuto;
                        _contentElement.css(css);
                    }
                    contentElementScrollSize = {
                        w: contentMeasureElement[LEXICON.sW] + textareaValueLength,
                        h: contentMeasureElement[LEXICON.sH] + textareaValueLength
                    };
                    if (setCSS) {
                        css[_strFloat] = float;
                        css[_strWidth] = _strHundredPercent;
                        _contentElement.css(css);
                    }

                    bodyMinSizeC = bodyMinSizeChanged();
                    changed = checkCache(contentElementScrollSize, _contentElementScrollSizeChangeDetectedCache);

                    _contentElementScrollSizeChangeDetectedCache = contentElementScrollSize;

                    return changed || bodyMinSizeC;
                }

                /**
                 * Returns true when a attribute which the MutationObserver would observe has changed.  
                 * @returns {boolean} True if one of the attributes which a MutationObserver would observe has changed, false or undefined otherwise.
                 */
                function meaningfulAttrsChanged() {
                    if (_sleeping || _mutationObserversConnected)
                        return;

                    var elem;
                    var curr;
                    var cache;
                    var changedAttrs = [];
                    var checks = [
                        {
                            _elem: _hostElement,
                            _attrs: _mutationObserverAttrsHost.concat(':visible')
                        },
                        {
                            _elem: _isTextarea ? _targetElement : undefined,
                            _attrs: _mutationObserverAttrsTextarea
                        }
                    ];

                    each(checks, function (index, check) {
                        elem = check._elem;
                        if (elem) {
                            each(check._attrs, function (index, attr) {
                                curr = attr.charAt(0) === ':' ? elem.is(attr) : elem.attr(attr);
                                cache = _updateAutoCache[attr];

                                if (checkCache(curr, cache)) {
                                    changedAttrs.push(attr);
                                }

                                _updateAutoCache[attr] = curr;
                            });
                        }
                    });

                    updateViewportAttrsFromTarget(changedAttrs);

                    return changedAttrs[LEXICON.l] > 0;
                }

                /**
                 * Checks is a CSS Property of a child element is affecting the scroll size of the content.
                 * @param propertyName The CSS property name.
                 * @returns {boolean} True if the property is affecting the content scroll size, false otherwise.
                 */
                function isSizeAffectingCSSProperty(propertyName) {
                    if (!_initialized)
                        return true;
                    var flexGrow = 'flex-grow';
                    var flexShrink = 'flex-shrink';
                    var flexBasis = 'flex-basis';
                    var affectingPropsX = [
                        _strWidth,
                        _strMinMinus + _strWidth,
                        _strMaxMinus + _strWidth,
                        _strMarginMinus + _strLeft,
                        _strMarginMinus + _strRight,
                        _strLeft,
                        _strRight,
                        'font-weight',
                        'word-spacing',
                        flexGrow,
                        flexShrink,
                        flexBasis
                    ];
                    var affectingPropsXContentBox = [
                        _strPaddingMinus + _strLeft,
                        _strPaddingMinus + _strRight,
                        _strBorderMinus + _strLeft + _strWidth,
                        _strBorderMinus + _strRight + _strWidth
                    ];
                    var affectingPropsY = [
                        _strHeight,
                        _strMinMinus + _strHeight,
                        _strMaxMinus + _strHeight,
                        _strMarginMinus + _strTop,
                        _strMarginMinus + _strBottom,
                        _strTop,
                        _strBottom,
                        'line-height',
                        flexGrow,
                        flexShrink,
                        flexBasis
                    ];
                    var affectingPropsYContentBox = [
                        _strPaddingMinus + _strTop,
                        _strPaddingMinus + _strBottom,
                        _strBorderMinus + _strTop + _strWidth,
                        _strBorderMinus + _strBottom + _strWidth
                    ];
                    var _strS = 's';
                    var _strVS = 'v-s';
                    var checkX = _overflowBehaviorCache.x === _strS || _overflowBehaviorCache.x === _strVS;
                    var checkY = _overflowBehaviorCache.y === _strS || _overflowBehaviorCache.y === _strVS;
                    var sizeIsAffected = false;
                    var checkPropertyName = function (arr, name) {
                        for (var i = 0; i < arr[LEXICON.l]; i++) {
                            if (arr[i] === name)
                                return true;
                        }
                        return false;
                    };

                    if (checkY) {
                        sizeIsAffected = checkPropertyName(affectingPropsY, propertyName);
                        if (!sizeIsAffected && !_isBorderBox)
                            sizeIsAffected = checkPropertyName(affectingPropsYContentBox, propertyName);
                    }
                    if (checkX && !sizeIsAffected) {
                        sizeIsAffected = checkPropertyName(affectingPropsX, propertyName);
                        if (!sizeIsAffected && !_isBorderBox)
                            sizeIsAffected = checkPropertyName(affectingPropsXContentBox, propertyName);
                    }
                    return sizeIsAffected;
                }


                //==== Update ====//

                /**
                 * Sets the attribute values of the viewport element to the values from the target element.
                 * The value of a attribute is only set if the attribute is whitelisted.
                 * @attrs attrs The array of attributes which shall be set or undefined if all whitelisted shall be set.
                 */
                function updateViewportAttrsFromTarget(attrs) {
                    attrs = attrs || _viewportAttrsFromTarget;
                    each(attrs, function (index, attr) {
                        if (COMPATIBILITY.inA(attr, _viewportAttrsFromTarget) > -1) {
                            var targetAttr = _targetElement.attr(attr);
                            if (type(targetAttr) == TYPES.s) {
                                _viewportElement.attr(attr, targetAttr);
                            }
                            else {
                                _viewportElement.removeAttr(attr);
                            }
                        }
                    });
                }

                /**
                 * Updates the variables and size of the textarea element, and manages the scroll on new line or new character.
                 */
                function textareaUpdate() {
                    if (!_sleeping) {
                        var wrapAttrOff = !_textareaAutoWrappingCache;
                        var minWidth = _viewportSize.w;
                        var minHeight = _viewportSize.h;
                        var css = {};
                        var doMeasure = _widthAutoCache || wrapAttrOff;
                        var origWidth;
                        var width;
                        var origHeight;
                        var height;

                        //reset min size
                        css[_strMinMinus + _strWidth] = _strEmpty;
                        css[_strMinMinus + _strHeight] = _strEmpty;

                        //set width auto
                        css[_strWidth] = _strAuto;
                        _targetElement.css(css);

                        //measure width
                        origWidth = _targetElementNative[LEXICON.oW];
                        width = doMeasure ? MATH.max(origWidth, _targetElementNative[LEXICON.sW] - 1) : 1;
                        /*width += (_widthAutoCache ? _marginX + (!_isBorderBox ? wrapAttrOff ? 0 : _paddingX + _borderX : 0) : 0);*/

                        //set measured width
                        css[_strWidth] = _widthAutoCache ? _strAuto /*width*/ : _strHundredPercent;
                        css[_strMinMinus + _strWidth] = _strHundredPercent;

                        //set height auto
                        css[_strHeight] = _strAuto;
                        _targetElement.css(css);

                        //measure height
                        origHeight = _targetElementNative[LEXICON.oH];
                        height = MATH.max(origHeight, _targetElementNative[LEXICON.sH] - 1);

                        //append correct size values
                        css[_strWidth] = width;
                        css[_strHeight] = height;
                        _textareaCoverElement.css(css);

                        //apply min width / min height to prevent textarea collapsing
                        css[_strMinMinus + _strWidth] = minWidth /*+ (!_isBorderBox && _widthAutoCache ? _paddingX + _borderX : 0)*/;
                        css[_strMinMinus + _strHeight] = minHeight /*+ (!_isBorderBox && _heightAutoCache ? _paddingY + _borderY : 0)*/;
                        _targetElement.css(css);

                        return {
                            _originalWidth: origWidth,
                            _originalHeight: origHeight,
                            _dynamicWidth: width,
                            _dynamicHeight: height
                        };
                    }
                }

                /**
                 * Updates the plugin and DOM to the current options.
                 * This method should only be called if a update is 100% required.
                 * @param updateHints A objects which contains hints for this update:
                 * {
                 *   _hostSizeChanged : boolean,
                 *   _contentSizeChanged : boolean,
                 *   _force : boolean,                             == preventSwallowing
                 *   _changedOptions : { },                        == preventSwallowing && preventSleep
                *  }
                 */
                function update(updateHints) {
                    clearTimeout(_swallowedUpdateTimeout);
                    updateHints = updateHints || {};
                    _swallowedUpdateHints._hostSizeChanged |= updateHints._hostSizeChanged;
                    _swallowedUpdateHints._contentSizeChanged |= updateHints._contentSizeChanged;
                    _swallowedUpdateHints._force |= updateHints._force;

                    var now = COMPATIBILITY.now();
                    var hostSizeChanged = !!_swallowedUpdateHints._hostSizeChanged;
                    var contentSizeChanged = !!_swallowedUpdateHints._contentSizeChanged;
                    var force = !!_swallowedUpdateHints._force;
                    var changedOptions = updateHints._changedOptions;
                    var swallow = _swallowUpdateLag > 0 && _initialized && !_destroyed && !force && !changedOptions && (now - _lastUpdateTime) < _swallowUpdateLag && (!_heightAutoCache && !_widthAutoCache);
                    var displayIsHidden;

                    if (swallow)
                        _swallowedUpdateTimeout = setTimeout(update, _swallowUpdateLag);

                    //abort update due to:
                    //destroyed
                    //swallowing
                    //sleeping
                    //host is hidden or has false display
                    if (_destroyed || swallow || (_sleeping && !changedOptions) || (_initialized && !force && (displayIsHidden = _hostElement.is(':hidden'))) || _hostElement.css('display') === 'inline')
                        return;

                    _lastUpdateTime = now;
                    _swallowedUpdateHints = {};

                    //if scrollbar styling is possible and native scrollbars aren't overlaid the scrollbar styling will be applied which hides the native scrollbars completely.
                    if (_nativeScrollbarStyling && !(_nativeScrollbarIsOverlaid.x && _nativeScrollbarIsOverlaid.y)) {
                        //native scrollbars are hidden, so change the values to zero
                        _nativeScrollbarSize.x = 0;
                        _nativeScrollbarSize.y = 0;
                    }
                    else {
                        //refresh native scrollbar size (in case of zoom)
                        _nativeScrollbarSize = extendDeep({}, globals.nativeScrollbarSize);
                    }

                    // Scrollbar padding is needed for firefox, because firefox hides scrollbar automatically if the size of the div is too small.
                    // The calculation: [scrollbar size +3 *3]
                    // (+3 because of possible decoration e.g. borders, margins etc., but only if native scrollbar is NOT a overlaid scrollbar)
                    // (*3 because (1)increase / (2)decrease -button and (3)resize handle)
                    _nativeScrollbarMinSize = {
                        x: (_nativeScrollbarSize.x + (_nativeScrollbarIsOverlaid.x ? 0 : 3)) * 3,
                        y: (_nativeScrollbarSize.y + (_nativeScrollbarIsOverlaid.y ? 0 : 3)) * 3
                    };

                    changedOptions = changedOptions || {};
                    //freezeResizeObserver(_sizeObserverElement, true);
                    //freezeResizeObserver(_sizeAutoObserverElement, true);

                    var checkCacheAutoForce = function () {
                        return checkCache.apply(this, [].slice.call(arguments).concat([force]));
                    };

                    //save current scroll offset
                    var currScroll = {
                        x: _viewportElement[_strScrollLeft](),
                        y: _viewportElement[_strScrollTop]()
                    };

                    var currentPreparedOptionsScrollbars = _currentPreparedOptions.scrollbars;
                    var currentPreparedOptionsTextarea = _currentPreparedOptions.textarea;

                    //scrollbars visibility:
                    var scrollbarsVisibility = currentPreparedOptionsScrollbars.visibility;
                    var scrollbarsVisibilityChanged = checkCacheAutoForce(scrollbarsVisibility, _scrollbarsVisibilityCache);

                    //scrollbars autoHide:
                    var scrollbarsAutoHide = currentPreparedOptionsScrollbars.autoHide;
                    var scrollbarsAutoHideChanged = checkCacheAutoForce(scrollbarsAutoHide, _scrollbarsAutoHideCache);

                    //scrollbars click scrolling
                    var scrollbarsClickScrolling = currentPreparedOptionsScrollbars.clickScrolling;
                    var scrollbarsClickScrollingChanged = checkCacheAutoForce(scrollbarsClickScrolling, _scrollbarsClickScrollingCache);

                    //scrollbars drag scrolling
                    var scrollbarsDragScrolling = currentPreparedOptionsScrollbars.dragScrolling;
                    var scrollbarsDragScrollingChanged = checkCacheAutoForce(scrollbarsDragScrolling, _scrollbarsDragScrollingCache);

                    //className
                    var className = _currentPreparedOptions.className;
                    var classNameChanged = checkCacheAutoForce(className, _classNameCache);

                    //resize
                    var resize = _currentPreparedOptions.resize;
                    var resizeChanged = checkCacheAutoForce(resize, _resizeCache) && !_isBody; //body can't be resized since the window itself acts as resize possibility.

                    //paddingAbsolute
                    var paddingAbsolute = _currentPreparedOptions.paddingAbsolute;
                    var paddingAbsoluteChanged = checkCacheAutoForce(paddingAbsolute, _paddingAbsoluteCache);

                    //clipAlways
                    var clipAlways = _currentPreparedOptions.clipAlways;
                    var clipAlwaysChanged = checkCacheAutoForce(clipAlways, _clipAlwaysCache);

                    //sizeAutoCapable
                    var sizeAutoCapable = _currentPreparedOptions.sizeAutoCapable && !_isBody; //body can never be size auto, because it shall be always as big as the viewport.
                    var sizeAutoCapableChanged = checkCacheAutoForce(sizeAutoCapable, _sizeAutoCapableCache);

                    //showNativeScrollbars
                    var ignoreOverlayScrollbarHiding = _currentPreparedOptions.nativeScrollbarsOverlaid.showNativeScrollbars;
                    var ignoreOverlayScrollbarHidingChanged = checkCacheAutoForce(ignoreOverlayScrollbarHiding, _ignoreOverlayScrollbarHidingCache);

                    //autoUpdate
                    var autoUpdate = _currentPreparedOptions.autoUpdate;
                    var autoUpdateChanged = checkCacheAutoForce(autoUpdate, _autoUpdateCache);

                    //overflowBehavior
                    var overflowBehavior = _currentPreparedOptions.overflowBehavior;
                    var overflowBehaviorChanged = checkCacheAutoForce(overflowBehavior, _overflowBehaviorCache, force);

                    //dynWidth:
                    var textareaDynWidth = currentPreparedOptionsTextarea.dynWidth;
                    var textareaDynWidthChanged = checkCacheAutoForce(_textareaDynWidthCache, textareaDynWidth);

                    //dynHeight:
                    var textareaDynHeight = currentPreparedOptionsTextarea.dynHeight;
                    var textareaDynHeightChanged = checkCacheAutoForce(_textareaDynHeightCache, textareaDynHeight);

                    //scrollbars visibility
                    _scrollbarsAutoHideNever = scrollbarsAutoHide === 'n';
                    _scrollbarsAutoHideScroll = scrollbarsAutoHide === 's';
                    _scrollbarsAutoHideMove = scrollbarsAutoHide === 'm';
                    _scrollbarsAutoHideLeave = scrollbarsAutoHide === 'l';

                    //scrollbars autoHideDelay
                    _scrollbarsAutoHideDelay = currentPreparedOptionsScrollbars.autoHideDelay;

                    //old className
                    _oldClassName = _classNameCache;

                    //resize
                    _resizeNone = resize === 'n';
                    _resizeBoth = resize === 'b';
                    _resizeHorizontal = resize === 'h';
                    _resizeVertical = resize === 'v';

                    //normalizeRTL
                    _normalizeRTLCache = _currentPreparedOptions.normalizeRTL;

                    //ignore overlay scrollbar hiding
                    ignoreOverlayScrollbarHiding = ignoreOverlayScrollbarHiding && (_nativeScrollbarIsOverlaid.x && _nativeScrollbarIsOverlaid.y);

                    //refresh options cache
                    _scrollbarsVisibilityCache = scrollbarsVisibility;
                    _scrollbarsAutoHideCache = scrollbarsAutoHide;
                    _scrollbarsClickScrollingCache = scrollbarsClickScrolling;
                    _scrollbarsDragScrollingCache = scrollbarsDragScrolling;
                    _classNameCache = className;
                    _resizeCache = resize;
                    _paddingAbsoluteCache = paddingAbsolute;
                    _clipAlwaysCache = clipAlways;
                    _sizeAutoCapableCache = sizeAutoCapable;
                    _ignoreOverlayScrollbarHidingCache = ignoreOverlayScrollbarHiding;
                    _autoUpdateCache = autoUpdate;
                    _overflowBehaviorCache = extendDeep({}, overflowBehavior);
                    _textareaDynWidthCache = textareaDynWidth;
                    _textareaDynHeightCache = textareaDynHeight;
                    _hasOverflowCache = _hasOverflowCache || { x: false, y: false };

                    //set correct class name to the host element
                    if (classNameChanged) {
                        removeClass(_hostElement, _oldClassName + _strSpace + _classNameThemeNone);
                        addClass(_hostElement, className !== undefined && className !== null && className.length > 0 ? className : _classNameThemeNone);
                    }

                    //set correct auto Update
                    if (autoUpdateChanged) {
                        if (autoUpdate === true || (autoUpdate === null && _autoUpdateRecommended)) {
                            disconnectMutationObservers();
                            autoUpdateLoop.add(_base);
                        }
                        else {
                            autoUpdateLoop.remove(_base);
                            connectMutationObservers();
                        }
                    }

                    //activate or deactivate size auto capability
                    if (sizeAutoCapableChanged) {
                        if (sizeAutoCapable) {
                            if (_contentGlueElement) {
                                _contentGlueElement.show();
                            }
                            else {
                                _contentGlueElement = FRAMEWORK(generateDiv(_classNameContentGlueElement));
                                _paddingElement.before(_contentGlueElement);
                            }
                            if (_sizeAutoObserverAdded) {
                                _sizeAutoObserverElement.show();
                            }
                            else {
                                _sizeAutoObserverElement = FRAMEWORK(generateDiv(_classNameSizeAutoObserverElement));
                                _sizeAutoObserverElementNative = _sizeAutoObserverElement[0];

                                _contentGlueElement.before(_sizeAutoObserverElement);
                                var oldSize = { w: -1, h: -1 };
                                setupResizeObserver(_sizeAutoObserverElement, function () {
                                    var newSize = {
                                        w: _sizeAutoObserverElementNative[LEXICON.oW],
                                        h: _sizeAutoObserverElementNative[LEXICON.oH]
                                    };
                                    if (checkCache(newSize, oldSize)) {
                                        if (_initialized && (_heightAutoCache && newSize.h > 0) || (_widthAutoCache && newSize.w > 0)) {
                                            update();
                                        }
                                        else if (_initialized && (!_heightAutoCache && newSize.h === 0) || (!_widthAutoCache && newSize.w === 0)) {
                                            update();
                                        }
                                    }
                                    oldSize = newSize;
                                });
                                _sizeAutoObserverAdded = true;
                                //fix heightAuto detector bug if height is fixed but contentHeight is 0.
                                //the probability this bug will ever happen is very very low, thats why its ok if we use calc which isn't supported in IE8.
                                if (_cssCalc !== null)
                                    _sizeAutoObserverElement.css(_strHeight, _cssCalc + '(100% + 1px)');
                            }
                        }
                        else {
                            if (_sizeAutoObserverAdded)
                                _sizeAutoObserverElement.hide();
                            if (_contentGlueElement)
                                _contentGlueElement.hide();
                        }
                    }

                    //if force, update all resizeObservers too
                    if (force) {
                        _sizeObserverElement.find('*').trigger(_strScroll);
                        if (_sizeAutoObserverAdded)
                            _sizeAutoObserverElement.find('*').trigger(_strScroll);
                    }

                    //display hidden:
                    displayIsHidden = displayIsHidden === undefined ? _hostElement.is(':hidden') : displayIsHidden;

                    //textarea AutoWrapping:
                    var textareaAutoWrapping = _isTextarea ? _targetElement.attr('wrap') !== 'off' : false;
                    var textareaAutoWrappingChanged = checkCacheAutoForce(textareaAutoWrapping, _textareaAutoWrappingCache);

                    //detect direction:
                    var cssDirection = _hostElement.css('direction');
                    var cssDirectionChanged = checkCacheAutoForce(cssDirection, _cssDirectionCache);

                    //detect box-sizing:
                    var boxSizing = _hostElement.css('box-sizing');
                    var boxSizingChanged = checkCacheAutoForce(boxSizing, _cssBoxSizingCache);

                    //detect padding:
                    var padding = getTopRightBottomLeftHost(_strPaddingMinus);

                    //width + height auto detecting var:
                    var sizeAutoObserverElementBCRect;
                    //exception occurs in IE8 sometimes (unknown exception)
                    try {
                        sizeAutoObserverElementBCRect = _sizeAutoObserverAdded ? _sizeAutoObserverElementNative[LEXICON.bCR]() : null;
                    } catch (ex) {
                        return;
                    }

                    _isRTL = cssDirection === 'rtl';
                    _isBorderBox = (boxSizing === 'border-box');
                    var isRTLLeft = _isRTL ? _strLeft : _strRight;
                    var isRTLRight = _isRTL ? _strRight : _strLeft;

                    //detect width auto:
                    var widthAutoResizeDetection = false;
                    var widthAutoObserverDetection = (_sizeAutoObserverAdded && (_hostElement.css(_strFloat) !== 'none' /*|| _isTextarea */)) ? (MATH.round(sizeAutoObserverElementBCRect.right - sizeAutoObserverElementBCRect.left) === 0) && (!paddingAbsolute ? (_hostElementNative[LEXICON.cW] - _paddingX) > 0 : true) : false;
                    if (sizeAutoCapable && !widthAutoObserverDetection) {
                        var tmpCurrHostWidth = _hostElementNative[LEXICON.oW];
                        var tmpCurrContentGlueWidth = _contentGlueElement.css(_strWidth);
                        _contentGlueElement.css(_strWidth, _strAuto);

                        var tmpNewHostWidth = _hostElementNative[LEXICON.oW];
                        _contentGlueElement.css(_strWidth, tmpCurrContentGlueWidth);
                        widthAutoResizeDetection = tmpCurrHostWidth !== tmpNewHostWidth;
                        if (!widthAutoResizeDetection) {
                            _contentGlueElement.css(_strWidth, tmpCurrHostWidth + 1);
                            tmpNewHostWidth = _hostElementNative[LEXICON.oW];
                            _contentGlueElement.css(_strWidth, tmpCurrContentGlueWidth);
                            widthAutoResizeDetection = tmpCurrHostWidth !== tmpNewHostWidth;
                        }
                    }
                    var widthAuto = (widthAutoObserverDetection || widthAutoResizeDetection) && sizeAutoCapable && !displayIsHidden;
                    var widthAutoChanged = checkCacheAutoForce(widthAuto, _widthAutoCache);
                    var wasWidthAuto = !widthAuto && _widthAutoCache;

                    //detect height auto:
                    var heightAuto = _sizeAutoObserverAdded && sizeAutoCapable && !displayIsHidden ? (MATH.round(sizeAutoObserverElementBCRect.bottom - sizeAutoObserverElementBCRect.top) === 0) /* && (!paddingAbsolute && (_msieVersion > 9 || !_msieVersion) ? true : true) */ : false;
                    var heightAutoChanged = checkCacheAutoForce(heightAuto, _heightAutoCache);
                    var wasHeightAuto = !heightAuto && _heightAutoCache;

                    //detect border:
                    //we need the border only if border box and auto size
                    var updateBorderX = (widthAuto && _isBorderBox) || !_isBorderBox;
                    var updateBorderY = (heightAuto && _isBorderBox) || !_isBorderBox;
                    var border = getTopRightBottomLeftHost(_strBorderMinus, '-' + _strWidth, !updateBorderX, !updateBorderY)

                    //detect margin:
                    var margin = getTopRightBottomLeftHost(_strMarginMinus);

                    //vars to apply correct css
                    var contentElementCSS = {};
                    var contentGlueElementCSS = {};

                    //funcs
                    var getHostSize = function () {
                        //has to be clientSize because offsetSize respect borders
                        return {
                            w: _hostElementNative[LEXICON.cW],
                            h: _hostElementNative[LEXICON.cH]
                        };
                    };
                    var getViewportSize = function () {
                        //viewport size is padding container because it never has padding, margin and a border
                        //determine zoom rounding error -> sometimes scrollWidth/Height is smaller than clientWidth/Height
                        //if this happens add the difference to the viewportSize to compensate the rounding error
                        return {
                            w: _paddingElementNative[LEXICON.oW] + MATH.max(0, _contentElementNative[LEXICON.cW] - _contentElementNative[LEXICON.sW]),
                            h: _paddingElementNative[LEXICON.oH] + MATH.max(0, _contentElementNative[LEXICON.cH] - _contentElementNative[LEXICON.sH])
                        };
                    };

                    //set info for padding
                    var paddingAbsoluteX = _paddingX = padding.l + padding.r;
                    var paddingAbsoluteY = _paddingY = padding.t + padding.b;
                    paddingAbsoluteX *= paddingAbsolute ? 1 : 0;
                    paddingAbsoluteY *= paddingAbsolute ? 1 : 0;
                    padding.c = checkCacheAutoForce(padding, _cssPaddingCache);

                    //set info for border
                    _borderX = border.l + border.r;
                    _borderY = border.t + border.b;
                    border.c = checkCacheAutoForce(border, _cssBorderCache);

                    //set info for margin
                    _marginX = margin.l + margin.r;
                    _marginY = margin.t + margin.b;
                    margin.c = checkCacheAutoForce(margin, _cssMarginCache);

                    //refresh cache
                    _textareaAutoWrappingCache = textareaAutoWrapping;
                    _cssDirectionCache = cssDirection;
                    _cssBoxSizingCache = boxSizing;
                    _widthAutoCache = widthAuto;
                    _heightAutoCache = heightAuto;
                    _cssPaddingCache = padding;
                    _cssBorderCache = border;
                    _cssMarginCache = margin;

                    //IEFix direction changed
                    if (cssDirectionChanged && _sizeAutoObserverAdded)
                        _sizeAutoObserverElement.css(_strFloat, isRTLRight);

                    //apply padding:
                    if (padding.c || cssDirectionChanged || paddingAbsoluteChanged || widthAutoChanged || heightAutoChanged || boxSizingChanged || sizeAutoCapableChanged) {
                        var paddingElementCSS = {};
                        var textareaCSS = {};
                        var paddingValues = [padding.t, padding.r, padding.b, padding.l];

                        setTopRightBottomLeft(contentGlueElementCSS, _strMarginMinus, [-padding.t, -padding.r, -padding.b, -padding.l]);
                        if (paddingAbsolute) {
                            setTopRightBottomLeft(paddingElementCSS, _strEmpty, paddingValues);
                            setTopRightBottomLeft(_isTextarea ? textareaCSS : contentElementCSS, _strPaddingMinus);
                        }
                        else {
                            setTopRightBottomLeft(paddingElementCSS, _strEmpty);
                            setTopRightBottomLeft(_isTextarea ? textareaCSS : contentElementCSS, _strPaddingMinus, paddingValues);
                        }

                        _paddingElement.css(paddingElementCSS);
                        _targetElement.css(textareaCSS);
                    }

                    //viewport size is padding container because it never has padding, margin and a border.
                    _viewportSize = getViewportSize();

                    //update Textarea
                    var textareaSize = _isTextarea ? textareaUpdate() : false;
                    var textareaSizeChanged = _isTextarea && checkCacheAutoForce(textareaSize, _textareaSizeCache);
                    var textareaDynOrigSize = _isTextarea && textareaSize ? {
                        w: textareaDynWidth ? textareaSize._dynamicWidth : textareaSize._originalWidth,
                        h: textareaDynHeight ? textareaSize._dynamicHeight : textareaSize._originalHeight
                    } : {};
                    _textareaSizeCache = textareaSize;

                    //fix height auto / width auto in cooperation with current padding & boxSizing behavior:
                    if (heightAuto && (heightAutoChanged || paddingAbsoluteChanged || boxSizingChanged || padding.c || border.c)) {
                        contentElementCSS[_strHeight] = _strAuto;
                    }
                    else if (heightAutoChanged || paddingAbsoluteChanged) {
                        contentElementCSS[_strHeight] = _strHundredPercent;
                    }
                    if (widthAuto && (widthAutoChanged || paddingAbsoluteChanged || boxSizingChanged || padding.c || border.c || cssDirectionChanged)) {
                        contentElementCSS[_strWidth] = _strAuto;
                        contentGlueElementCSS[_strMaxMinus + _strWidth] = _strHundredPercent; //IE Fix
                    }
                    else if (widthAutoChanged || paddingAbsoluteChanged) {
                        contentElementCSS[_strWidth] = _strHundredPercent;
                        contentElementCSS[_strFloat] = _strEmpty;
                        contentGlueElementCSS[_strMaxMinus + _strWidth] = _strEmpty; //IE Fix
                    }
                    if (widthAuto) {
                        //textareaDynOrigSize.w || _strAuto :: doesnt works because applied margin will shift width
                        contentGlueElementCSS[_strWidth] = _strAuto;

                        contentElementCSS[_strWidth] = VENDORS._cssPropertyValue(_strWidth, 'max-content intrinsic') || _strAuto;
                        contentElementCSS[_strFloat] = isRTLRight;
                    }
                    else {
                        contentGlueElementCSS[_strWidth] = _strEmpty;
                    }
                    if (heightAuto) {
                        //textareaDynOrigSize.h || _contentElementNative[LEXICON.cH] :: use for anti scroll jumping
                        contentGlueElementCSS[_strHeight] = textareaDynOrigSize.h || _contentElementNative[LEXICON.cH];
                    }
                    else {
                        contentGlueElementCSS[_strHeight] = _strEmpty;
                    }
                    if (sizeAutoCapable)
                        _contentGlueElement.css(contentGlueElementCSS);
                    _contentElement.css(contentElementCSS);

                    //CHECKPOINT HERE ~
                    contentElementCSS = {};
                    contentGlueElementCSS = {};

                    //if [content(host) client / scroll size, or target element direction, or content(host) max-sizes] changed, or force is true
                    if (hostSizeChanged || contentSizeChanged || textareaSizeChanged || cssDirectionChanged || boxSizingChanged || paddingAbsoluteChanged || widthAutoChanged || widthAuto || heightAutoChanged || heightAuto || ignoreOverlayScrollbarHidingChanged || overflowBehaviorChanged || clipAlwaysChanged || resizeChanged || scrollbarsVisibilityChanged || scrollbarsAutoHideChanged || scrollbarsDragScrollingChanged || scrollbarsClickScrollingChanged || textareaDynWidthChanged || textareaDynHeightChanged || textareaAutoWrappingChanged) {
                        var strOverflow = 'overflow';
                        var strOverflowX = strOverflow + '-x';
                        var strOverflowY = strOverflow + '-y';
                        var strHidden = 'hidden';
                        var strVisible = 'visible';

                        //Reset the viewport (very important for natively overlaid scrollbars and zoom change
                        //don't change the overflow prop as it is very expensive and affects performance !A LOT!
                        if (!_nativeScrollbarStyling) {
                            var viewportElementResetCSS = {};
                            var resetXTmp = _hasOverflowCache.y && _hideOverflowCache.ys && !ignoreOverlayScrollbarHiding ? (_nativeScrollbarIsOverlaid.y ? _viewportElement.css(isRTLLeft) : -_nativeScrollbarSize.y) : 0;
                            var resetBottomTmp = _hasOverflowCache.x && _hideOverflowCache.xs && !ignoreOverlayScrollbarHiding ? (_nativeScrollbarIsOverlaid.x ? _viewportElement.css(_strBottom) : -_nativeScrollbarSize.x) : 0;
                            setTopRightBottomLeft(viewportElementResetCSS, _strEmpty);
                            _viewportElement.css(viewportElementResetCSS);
                        }

                        //measure several sizes:
                        var contentMeasureElement = getContentMeasureElement();
                        //in Firefox content element has to have overflow hidden, else element margins aren't calculated properly, this element prevents this bug, but only if scrollbars aren't overlaid
                        var contentSize = {
                            //use clientSize because natively overlaidScrollbars add borders
                            w: textareaDynOrigSize.w || contentMeasureElement[LEXICON.cW],
                            h: textareaDynOrigSize.h || contentMeasureElement[LEXICON.cH]
                        };
                        var scrollSize = {
                            w: contentMeasureElement[LEXICON.sW],
                            h: contentMeasureElement[LEXICON.sH]
                        };

                        //apply the correct viewport style and measure viewport size
                        if (!_nativeScrollbarStyling) {
                            viewportElementResetCSS[_strBottom] = wasHeightAuto ? _strEmpty : resetBottomTmp;
                            viewportElementResetCSS[isRTLLeft] = wasWidthAuto ? _strEmpty : resetXTmp;
                            _viewportElement.css(viewportElementResetCSS);
                        }
                        _viewportSize = getViewportSize();

                        //measure and correct several sizes
                        var hostSize = getHostSize();
                        var hostAbsoluteRectSize = {
                            w: hostSize.w - _marginX - _borderX - (_isBorderBox ? 0 : _paddingX),
                            h: hostSize.h - _marginY - _borderY - (_isBorderBox ? 0 : _paddingY)
                        };
                        var contentGlueSize = {
                            //client/scrollSize + AbsolutePadding -> because padding is only applied to the paddingElement if its absolute, so you have to add it manually
                            //hostSize is clientSize -> so padding should be added manually, right? FALSE! Because content glue is inside hostElement, so we don't have to worry about padding
                            w: MATH.max((widthAuto ? contentSize.w : scrollSize.w) + paddingAbsoluteX, hostAbsoluteRectSize.w),
                            h: MATH.max((heightAuto ? contentSize.h : scrollSize.h) + paddingAbsoluteY, hostAbsoluteRectSize.h)
                        };
                        contentGlueSize.c = checkCacheAutoForce(contentGlueSize, _contentGlueSizeCache);
                        _contentGlueSizeCache = contentGlueSize;

                        //apply correct contentGlue size
                        if (sizeAutoCapable) {
                            //size contentGlue correctly to make sure the element has correct size if the sizing switches to auto
                            if (contentGlueSize.c || (heightAuto || widthAuto)) {
                                contentGlueElementCSS[_strWidth] = contentGlueSize.w;
                                contentGlueElementCSS[_strHeight] = contentGlueSize.h;

                                //textarea-sizes are already calculated correctly at this point
                                if (!_isTextarea) {
                                    contentSize = {
                                        //use clientSize because natively overlaidScrollbars add borders
                                        w: contentMeasureElement[LEXICON.cW],
                                        h: contentMeasureElement[LEXICON.cH]
                                    };
                                }
                            }
                            var textareaCoverCSS = {};
                            var setContentGlueElementCSSfunction = function (horizontal) {
                                var scrollbarVars = getScrollbarVars(horizontal);
                                var wh = scrollbarVars._w_h;
                                var strWH = scrollbarVars._width_height;
                                var autoSize = horizontal ? widthAuto : heightAuto;
                                var borderSize = horizontal ? _borderX : _borderY;
                                var paddingSize = horizontal ? _paddingX : _paddingY;
                                var marginSize = horizontal ? _marginX : _marginY;
                                var viewportSize = _viewportSize[wh] - borderSize - marginSize - (_isBorderBox ? 0 : paddingSize);

                                //make contentGlue size -1 if element is not auto sized, to make sure that a resize event happens when the element shrinks
                                if (!autoSize || (!autoSize && border.c))
                                    contentGlueElementCSS[strWH] = hostAbsoluteRectSize[wh] - 1;

                                //if size is auto and host is smaller than size as min size, make content glue size -1 to make sure size changes will be detected (this is only needed if padding is 0)
                                if (autoSize && (contentSize[wh] < viewportSize) && (horizontal && _isTextarea ? !textareaAutoWrapping : true)) {
                                    if (_isTextarea)
                                        textareaCoverCSS[strWH] = parseToZeroOrNumber(_textareaCoverElement.css(strWH)) - 1;
                                    contentGlueElementCSS[strWH] -= 1;
                                }

                                //make sure content glue size is at least 1
                                if (contentSize[wh] > 0)
                                    contentGlueElementCSS[strWH] = MATH.max(1, contentGlueElementCSS[strWH]);
                            };
                            setContentGlueElementCSSfunction(true);
                            setContentGlueElementCSSfunction(false);

                            if (_isTextarea)
                                _textareaCoverElement.css(textareaCoverCSS);
                            _contentGlueElement.css(contentGlueElementCSS);
                        }
                        if (widthAuto)
                            contentElementCSS[_strWidth] = _strHundredPercent;
                        if (widthAuto && !_isBorderBox && !_mutationObserversConnected)
                            contentElementCSS[_strFloat] = 'none';

                        //apply and reset content style
                        _contentElement.css(contentElementCSS);
                        contentElementCSS = {};

                        //measure again, but this time all correct sizes:
                        var contentScrollSize = {
                            w: contentMeasureElement[LEXICON.sW],
                            h: contentMeasureElement[LEXICON.sH],
                        };
                        contentScrollSize.c = contentSizeChanged = checkCacheAutoForce(contentScrollSize, _contentScrollSizeCache);
                        _contentScrollSizeCache = contentScrollSize;

                        //refresh viewport size after correct measuring
                        _viewportSize = getViewportSize();

                        hostSize = getHostSize();
                        hostSizeChanged = checkCacheAutoForce(hostSize, _hostSizeCache);
                        _hostSizeCache = hostSize;

                        var hideOverflowForceTextarea = _isTextarea && (_viewportSize.w === 0 || _viewportSize.h === 0);
                        var previousOverflowAmount = _overflowAmountCache;
                        var overflowBehaviorIsVS = {};
                        var overflowBehaviorIsVH = {};
                        var overflowBehaviorIsS = {};
                        var overflowAmount = {};
                        var hasOverflow = {};
                        var hideOverflow = {};
                        var canScroll = {};
                        var viewportRect = _paddingElementNative[LEXICON.bCR]();
                        var setOverflowVariables = function (horizontal) {
                            var scrollbarVars = getScrollbarVars(horizontal);
                            var scrollbarVarsInverted = getScrollbarVars(!horizontal);
                            var xyI = scrollbarVarsInverted._x_y;
                            var xy = scrollbarVars._x_y;
                            var wh = scrollbarVars._w_h;
                            var widthHeight = scrollbarVars._width_height;
                            var scrollMax = _strScroll + scrollbarVars._Left_Top + 'Max';
                            var fractionalOverflowAmount = viewportRect[widthHeight] ? MATH.abs(viewportRect[widthHeight] - _viewportSize[wh]) : 0;
                            var checkFractionalOverflowAmount = previousOverflowAmount && previousOverflowAmount[xy] > 0 && _viewportElementNative[scrollMax] === 0;
                            overflowBehaviorIsVS[xy] = overflowBehavior[xy] === 'v-s';
                            overflowBehaviorIsVH[xy] = overflowBehavior[xy] === 'v-h';
                            overflowBehaviorIsS[xy] = overflowBehavior[xy] === 's';
                            overflowAmount[xy] = MATH.max(0, MATH.round((contentScrollSize[wh] - _viewportSize[wh]) * 100) / 100);
                            overflowAmount[xy] *= (hideOverflowForceTextarea || (checkFractionalOverflowAmount && fractionalOverflowAmount > 0 && fractionalOverflowAmount < 1)) ? 0 : 1;
                            hasOverflow[xy] = overflowAmount[xy] > 0;

                            //hideOverflow:
                            //x || y : true === overflow is hidden by "overflow: scroll" OR "overflow: hidden"
                            //xs || ys : true === overflow is hidden by "overflow: scroll"
                            hideOverflow[xy] = overflowBehaviorIsVS[xy] || overflowBehaviorIsVH[xy] ? (hasOverflow[xyI] && !overflowBehaviorIsVS[xyI] && !overflowBehaviorIsVH[xyI]) : hasOverflow[xy];
                            hideOverflow[xy + 's'] = hideOverflow[xy] ? (overflowBehaviorIsS[xy] || overflowBehaviorIsVS[xy]) : false;

                            canScroll[xy] = hasOverflow[xy] && hideOverflow[xy + 's'];
                        };
                        setOverflowVariables(true);
                        setOverflowVariables(false);

                        overflowAmount.c = checkCacheAutoForce(overflowAmount, _overflowAmountCache);
                        _overflowAmountCache = overflowAmount;
                        hasOverflow.c = checkCacheAutoForce(hasOverflow, _hasOverflowCache);
                        _hasOverflowCache = hasOverflow;
                        hideOverflow.c = checkCacheAutoForce(hideOverflow, _hideOverflowCache);
                        _hideOverflowCache = hideOverflow;

                        //if native scrollbar is overlay at x OR y axis, prepare DOM
                        if (_nativeScrollbarIsOverlaid.x || _nativeScrollbarIsOverlaid.y) {
                            var borderDesign = 'px solid transparent';
                            var contentArrangeElementCSS = {};
                            var arrangeContent = {};
                            var arrangeChanged = force;
                            var setContentElementCSS;

                            if (hasOverflow.x || hasOverflow.y) {
                                arrangeContent.w = _nativeScrollbarIsOverlaid.y && hasOverflow.y ? contentScrollSize.w + _overlayScrollbarDummySize.y : _strEmpty;
                                arrangeContent.h = _nativeScrollbarIsOverlaid.x && hasOverflow.x ? contentScrollSize.h + _overlayScrollbarDummySize.x : _strEmpty;
                                arrangeChanged = checkCacheAutoForce(arrangeContent, _arrangeContentSizeCache);
                                _arrangeContentSizeCache = arrangeContent;
                            }

                            if (hasOverflow.c || hideOverflow.c || contentScrollSize.c || cssDirectionChanged || widthAutoChanged || heightAutoChanged || widthAuto || heightAuto || ignoreOverlayScrollbarHidingChanged) {
                                contentElementCSS[_strMarginMinus + isRTLRight] = contentElementCSS[_strBorderMinus + isRTLRight] = _strEmpty;
                                setContentElementCSS = function (horizontal) {
                                    var scrollbarVars = getScrollbarVars(horizontal);
                                    var scrollbarVarsInverted = getScrollbarVars(!horizontal);
                                    var xy = scrollbarVars._x_y;
                                    var strDirection = horizontal ? _strBottom : isRTLLeft;
                                    var invertedAutoSize = horizontal ? heightAuto : widthAuto;

                                    if (_nativeScrollbarIsOverlaid[xy] && hasOverflow[xy] && hideOverflow[xy + 's']) {
                                        contentElementCSS[_strMarginMinus + strDirection] = invertedAutoSize ? (ignoreOverlayScrollbarHiding ? _strEmpty : _overlayScrollbarDummySize[xy]) : _strEmpty;
                                        contentElementCSS[_strBorderMinus + strDirection] = ((horizontal ? !invertedAutoSize : true) && !ignoreOverlayScrollbarHiding) ? (_overlayScrollbarDummySize[xy] + borderDesign) : _strEmpty;
                                    }
                                    else {
                                        arrangeContent[scrollbarVarsInverted._w_h] =
                                            contentElementCSS[_strMarginMinus + strDirection] =
                                            contentElementCSS[_strBorderMinus + strDirection] = _strEmpty;
                                        arrangeChanged = true;
                                    }
                                };

                                if (_nativeScrollbarStyling) {
                                    addRemoveClass(_viewportElement, _classNameViewportNativeScrollbarsInvisible, !ignoreOverlayScrollbarHiding)
                                }
                                else {
                                    setContentElementCSS(true);
                                    setContentElementCSS(false);
                                }
                            }
                            if (ignoreOverlayScrollbarHiding) {
                                arrangeContent.w = arrangeContent.h = _strEmpty;
                                arrangeChanged = true;
                            }
                            if (arrangeChanged && !_nativeScrollbarStyling) {
                                contentArrangeElementCSS[_strWidth] = hideOverflow.y ? arrangeContent.w : _strEmpty;
                                contentArrangeElementCSS[_strHeight] = hideOverflow.x ? arrangeContent.h : _strEmpty;

                                if (!_contentArrangeElement) {
                                    _contentArrangeElement = FRAMEWORK(generateDiv(_classNameContentArrangeElement));
                                    _viewportElement.prepend(_contentArrangeElement);
                                }
                                _contentArrangeElement.css(contentArrangeElementCSS);
                            }
                            _contentElement.css(contentElementCSS);
                        }

                        var viewportElementCSS = {};
                        var paddingElementCSS = {};
                        var setViewportCSS;
                        if (hostSizeChanged || hasOverflow.c || hideOverflow.c || contentScrollSize.c || overflowBehaviorChanged || boxSizingChanged || ignoreOverlayScrollbarHidingChanged || cssDirectionChanged || clipAlwaysChanged || heightAutoChanged) {
                            viewportElementCSS[isRTLRight] = _strEmpty;
                            setViewportCSS = function (horizontal) {
                                var scrollbarVars = getScrollbarVars(horizontal);
                                var scrollbarVarsInverted = getScrollbarVars(!horizontal);
                                var xy = scrollbarVars._x_y;
                                var XY = scrollbarVars._X_Y;
                                var strDirection = horizontal ? _strBottom : isRTLLeft;

                                var reset = function () {
                                    viewportElementCSS[strDirection] = _strEmpty;
                                    _contentBorderSize[scrollbarVarsInverted._w_h] = 0;
                                };
                                if (hasOverflow[xy] && hideOverflow[xy + 's']) {
                                    viewportElementCSS[strOverflow + XY] = _strScroll;
                                    if (ignoreOverlayScrollbarHiding || _nativeScrollbarStyling) {
                                        reset();
                                    }
                                    else {
                                        viewportElementCSS[strDirection] = -(_nativeScrollbarIsOverlaid[xy] ? _overlayScrollbarDummySize[xy] : _nativeScrollbarSize[xy]);
                                        _contentBorderSize[scrollbarVarsInverted._w_h] = _nativeScrollbarIsOverlaid[xy] ? _overlayScrollbarDummySize[scrollbarVarsInverted._x_y] : 0;
                                    }
                                } else {
                                    viewportElementCSS[strOverflow + XY] = _strEmpty;
                                    reset();
                                }
                            };
                            setViewportCSS(true);
                            setViewportCSS(false);

                            // if the scroll container is too small and if there is any overflow with no overlay scrollbar (and scrollbar styling isn't possible), 
                            // make viewport element greater in size (Firefox hide Scrollbars fix)
                            // because firefox starts hiding scrollbars on too small elements
                            // with this behavior the overflow calculation may be incorrect or the scrollbars would appear suddenly
                            // https://bugzilla.mozilla.org/show_bug.cgi?id=292284
                            if (!_nativeScrollbarStyling
                                && (_viewportSize.h < _nativeScrollbarMinSize.x || _viewportSize.w < _nativeScrollbarMinSize.y)
                                && ((hasOverflow.x && hideOverflow.x && !_nativeScrollbarIsOverlaid.x) || (hasOverflow.y && hideOverflow.y && !_nativeScrollbarIsOverlaid.y))) {
                                viewportElementCSS[_strPaddingMinus + _strTop] = _nativeScrollbarMinSize.x;
                                viewportElementCSS[_strMarginMinus + _strTop] = -_nativeScrollbarMinSize.x;

                                viewportElementCSS[_strPaddingMinus + isRTLRight] = _nativeScrollbarMinSize.y;
                                viewportElementCSS[_strMarginMinus + isRTLRight] = -_nativeScrollbarMinSize.y;
                            }
                            else {
                                viewportElementCSS[_strPaddingMinus + _strTop] =
                                    viewportElementCSS[_strMarginMinus + _strTop] =
                                    viewportElementCSS[_strPaddingMinus + isRTLRight] =
                                    viewportElementCSS[_strMarginMinus + isRTLRight] = _strEmpty;
                            }
                            viewportElementCSS[_strPaddingMinus + isRTLLeft] =
                                viewportElementCSS[_strMarginMinus + isRTLLeft] = _strEmpty;

                            //if there is any overflow (x OR y axis) and this overflow shall be hidden, make overflow hidden, else overflow visible
                            if ((hasOverflow.x && hideOverflow.x) || (hasOverflow.y && hideOverflow.y) || hideOverflowForceTextarea) {
                                //only hide if is Textarea
                                if (_isTextarea && hideOverflowForceTextarea) {
                                    paddingElementCSS[strOverflowX] =
                                        paddingElementCSS[strOverflowY] = strHidden;
                                }
                            }
                            else {
                                if (!clipAlways || (overflowBehaviorIsVH.x || overflowBehaviorIsVS.x || overflowBehaviorIsVH.y || overflowBehaviorIsVS.y)) {
                                    //only un-hide if Textarea
                                    if (_isTextarea) {
                                        paddingElementCSS[strOverflowX] =
                                            paddingElementCSS[strOverflowY] = _strEmpty;
                                    }
                                    viewportElementCSS[strOverflowX] =
                                        viewportElementCSS[strOverflowY] = strVisible;
                                }
                            }

                            _paddingElement.css(paddingElementCSS);
                            _viewportElement.css(viewportElementCSS);
                            viewportElementCSS = {};

                            //force soft redraw in webkit because without the scrollbars will may appear because DOM wont be redrawn under special conditions
                            if ((hasOverflow.c || boxSizingChanged || widthAutoChanged || heightAutoChanged) && !(_nativeScrollbarIsOverlaid.x && _nativeScrollbarIsOverlaid.y)) {
                                var elementStyle = _contentElementNative[LEXICON.s];
                                var dump;
                                elementStyle.webkitTransform = 'scale(1)';
                                elementStyle.display = 'run-in';
                                dump = _contentElementNative[LEXICON.oH];
                                elementStyle.display = _strEmpty; //|| dump; //use dump to prevent it from deletion if minify
                                elementStyle.webkitTransform = _strEmpty;
                            }
                            /*
                            //force hard redraw in webkit if native overlaid scrollbars shall appear
                            if (ignoreOverlayScrollbarHidingChanged && ignoreOverlayScrollbarHiding) {
                                _hostElement.hide();
                                var dump = _hostElementNative[LEXICON.oH];
                                _hostElement.show();
                            }
                            */
                        }

                        //change to direction RTL and width auto Bugfix in Webkit
                        //without this fix, the DOM still thinks the scrollbar is LTR and thus the content is shifted to the left
                        contentElementCSS = {};
                        if (cssDirectionChanged || widthAutoChanged || heightAutoChanged) {
                            if (_isRTL && widthAuto) {
                                var floatTmp = _contentElement.css(_strFloat);
                                var posLeftWithoutFloat = MATH.round(_contentElement.css(_strFloat, _strEmpty).css(_strLeft, _strEmpty).position().left);
                                _contentElement.css(_strFloat, floatTmp);
                                var posLeftWithFloat = MATH.round(_contentElement.position().left);

                                if (posLeftWithoutFloat !== posLeftWithFloat)
                                    contentElementCSS[_strLeft] = posLeftWithoutFloat;
                            }
                            else {
                                contentElementCSS[_strLeft] = _strEmpty;
                            }
                        }
                        _contentElement.css(contentElementCSS);

                        //handle scroll position
                        if (_isTextarea && contentSizeChanged) {
                            var textareaInfo = getTextareaInfo();
                            if (textareaInfo) {
                                var textareaRowsChanged = _textareaInfoCache === undefined ? true : textareaInfo._rows !== _textareaInfoCache._rows;
                                var cursorRow = textareaInfo._cursorRow;
                                var cursorCol = textareaInfo._cursorColumn;
                                var widestRow = textareaInfo._widestRow;
                                var lastRow = textareaInfo._rows;
                                var lastCol = textareaInfo._columns;
                                var cursorPos = textareaInfo._cursorPosition;
                                var cursorMax = textareaInfo._cursorMax;
                                var cursorIsLastPosition = (cursorPos >= cursorMax && _textareaHasFocus);
                                var textareaScrollAmount = {
                                    x: (!textareaAutoWrapping && (cursorCol === lastCol && cursorRow === widestRow)) ? _overflowAmountCache.x : -1,
                                    y: (textareaAutoWrapping ? cursorIsLastPosition || textareaRowsChanged && (previousOverflowAmount ? (currScroll.y === previousOverflowAmount.y) : false) : (cursorIsLastPosition || textareaRowsChanged) && cursorRow === lastRow) ? _overflowAmountCache.y : -1
                                };
                                currScroll.x = textareaScrollAmount.x > -1 ? (_isRTL && _normalizeRTLCache && _rtlScrollBehavior.i ? 0 : textareaScrollAmount.x) : currScroll.x; //if inverted, scroll to 0 -> normalized this means to max scroll offset.
                                currScroll.y = textareaScrollAmount.y > -1 ? textareaScrollAmount.y : currScroll.y;
                            }
                            _textareaInfoCache = textareaInfo;
                        }
                        if (_isRTL && _rtlScrollBehavior.i && _nativeScrollbarIsOverlaid.y && hasOverflow.x && _normalizeRTLCache)
                            currScroll.x += _contentBorderSize.w || 0;
                        if (widthAuto)
                            _hostElement[_strScrollLeft](0);
                        if (heightAuto)
                            _hostElement[_strScrollTop](0);
                        _viewportElement[_strScrollLeft](currScroll.x)[_strScrollTop](currScroll.y);

                        //scrollbars management:
                        var scrollbarsVisibilityVisible = scrollbarsVisibility === 'v';
                        var scrollbarsVisibilityHidden = scrollbarsVisibility === 'h';
                        var scrollbarsVisibilityAuto = scrollbarsVisibility === 'a';
                        var refreshScrollbarsVisibility = function (showX, showY) {
                            showY = showY === undefined ? showX : showY;
                            refreshScrollbarAppearance(true, showX, canScroll.x)
                            refreshScrollbarAppearance(false, showY, canScroll.y)
                        };

                        //manage class name which indicates scrollable overflow
                        addRemoveClass(_hostElement, _classNameHostOverflow, hideOverflow.x || hideOverflow.y);
                        addRemoveClass(_hostElement, _classNameHostOverflowX, hideOverflow.x);
                        addRemoveClass(_hostElement, _classNameHostOverflowY, hideOverflow.y);

                        //add or remove rtl class name for styling purposes except when its body, then the scrollbar stays
                        if (cssDirectionChanged && !_isBody) {
                            addRemoveClass(_hostElement, _classNameHostRTL, _isRTL);
                        }

                        //manage the resize feature (CSS3 resize "polyfill" for this plugin)
                        if (_isBody)
                            addClass(_hostElement, _classNameHostResizeDisabled);
                        if (resizeChanged) {
                            addRemoveClass(_hostElement, _classNameHostResizeDisabled, _resizeNone);
                            addRemoveClass(_scrollbarCornerElement, _classNameScrollbarCornerResize, !_resizeNone);
                            addRemoveClass(_scrollbarCornerElement, _classNameScrollbarCornerResizeB, _resizeBoth);
                            addRemoveClass(_scrollbarCornerElement, _classNameScrollbarCornerResizeH, _resizeHorizontal);
                            addRemoveClass(_scrollbarCornerElement, _classNameScrollbarCornerResizeV, _resizeVertical);
                        }

                        //manage the scrollbars general visibility + the scrollbar interactivity (unusable class name)
                        if (scrollbarsVisibilityChanged || overflowBehaviorChanged || hideOverflow.c || hasOverflow.c || ignoreOverlayScrollbarHidingChanged) {
                            if (ignoreOverlayScrollbarHiding) {
                                if (ignoreOverlayScrollbarHidingChanged) {
                                    removeClass(_hostElement, _classNameHostScrolling);
                                    if (ignoreOverlayScrollbarHiding) {
                                        refreshScrollbarsVisibility(false);
                                    }
                                }
                            }
                            else if (scrollbarsVisibilityAuto) {
                                refreshScrollbarsVisibility(canScroll.x, canScroll.y);
                            }
                            else if (scrollbarsVisibilityVisible) {
                                refreshScrollbarsVisibility(true);
                            }
                            else if (scrollbarsVisibilityHidden) {
                                refreshScrollbarsVisibility(false);
                            }
                        }

                        //manage the scrollbars auto hide feature (auto hide them after specific actions)
                        if (scrollbarsAutoHideChanged || ignoreOverlayScrollbarHidingChanged) {
                            setupHostMouseTouchEvents(!_scrollbarsAutoHideLeave && !_scrollbarsAutoHideMove);
                            refreshScrollbarsAutoHide(_scrollbarsAutoHideNever, !_scrollbarsAutoHideNever);
                        }

                        //manage scrollbars handle length & offset - don't remove!
                        if (hostSizeChanged || overflowAmount.c || heightAutoChanged || widthAutoChanged || resizeChanged || boxSizingChanged || paddingAbsoluteChanged || ignoreOverlayScrollbarHidingChanged || cssDirectionChanged) {
                            refreshScrollbarHandleLength(true);
                            refreshScrollbarHandleOffset(true);
                            refreshScrollbarHandleLength(false);
                            refreshScrollbarHandleOffset(false);
                        }

                        //manage interactivity
                        if (scrollbarsClickScrollingChanged)
                            refreshScrollbarsInteractive(true, scrollbarsClickScrolling);
                        if (scrollbarsDragScrollingChanged)
                            refreshScrollbarsInteractive(false, scrollbarsDragScrolling);

                        //callbacks:
                        dispatchCallback('onDirectionChanged', {
                            isRTL: _isRTL,
                            dir: cssDirection
                        }, cssDirectionChanged);
                        dispatchCallback('onHostSizeChanged', {
                            width: _hostSizeCache.w,
                            height: _hostSizeCache.h
                        }, hostSizeChanged);
                        dispatchCallback('onContentSizeChanged', {
                            width: _contentScrollSizeCache.w,
                            height: _contentScrollSizeCache.h
                        }, contentSizeChanged);
                        dispatchCallback('onOverflowChanged', {
                            x: hasOverflow.x,
                            y: hasOverflow.y,
                            xScrollable: hideOverflow.xs,
                            yScrollable: hideOverflow.ys,
                            clipped: hideOverflow.x || hideOverflow.y
                        }, hasOverflow.c || hideOverflow.c);
                        dispatchCallback('onOverflowAmountChanged', {
                            x: overflowAmount.x,
                            y: overflowAmount.y
                        }, overflowAmount.c);
                    }

                    //fix body min size
                    if (_isBody && _bodyMinSizeCache && (_hasOverflowCache.c || _bodyMinSizeCache.c)) {
                        //its possible that no min size was measured until now, because the content arrange element was just added now, in this case, measure now the min size.
                        if (!_bodyMinSizeCache.f)
                            bodyMinSizeChanged();
                        if (_nativeScrollbarIsOverlaid.y && _hasOverflowCache.x)
                            _contentElement.css(_strMinMinus + _strWidth, _bodyMinSizeCache.w + _overlayScrollbarDummySize.y);
                        if (_nativeScrollbarIsOverlaid.x && _hasOverflowCache.y)
                            _contentElement.css(_strMinMinus + _strHeight, _bodyMinSizeCache.h + _overlayScrollbarDummySize.x);
                        _bodyMinSizeCache.c = false;
                    }

                    if (_initialized && changedOptions.updateOnLoad) {
                        updateElementsOnLoad();
                    }

                    //freezeResizeObserver(_sizeObserverElement, false);
                    //freezeResizeObserver(_sizeAutoObserverElement, false);

                    dispatchCallback('onUpdated', { forced: force });
                }

                /**
                 * Updates the found elements of which the load event shall be handled.
                 */
                function updateElementsOnLoad() {
                    if (!_isTextarea) {
                        eachUpdateOnLoad(function (i, updateOnLoadSelector) {
                            _contentElement.find(updateOnLoadSelector).each(function (i, el) {
                                // if element doesn't have a updateOnLoadCallback applied
                                if (COMPATIBILITY.inA(el, _updateOnLoadElms) < 0) {
                                    _updateOnLoadElms.push(el);
                                    FRAMEWORK(el)
                                        .off(_updateOnLoadEventName, updateOnLoadCallback)
                                        .on(_updateOnLoadEventName, updateOnLoadCallback);
                                }
                            });
                        });
                    }
                }

                //==== Options ====//

                /**
                 * Sets new options but doesn't call the update method.
                 * @param newOptions The object which contains the new options.
                 * @returns {*} A object which contains the changed options.
                 */
                function setOptions(newOptions) {
                    var validatedOpts = _pluginsOptions._validate(newOptions, _pluginsOptions._template, true, _currentOptions)

                    _currentOptions = extendDeep({}, _currentOptions, validatedOpts._default);
                    _currentPreparedOptions = extendDeep({}, _currentPreparedOptions, validatedOpts._prepared);

                    return validatedOpts._prepared;
                }


                //==== Structure ====//

                /**
                 * Builds or destroys the wrapper and helper DOM elements.
                 * @param destroy Indicates whether the DOM shall be build or destroyed.
                 */
                /**
                 * Builds or destroys the wrapper and helper DOM elements.
                 * @param destroy Indicates whether the DOM shall be build or destroyed.
                 */
                function setupStructureDOM(destroy) {
                    var strParent = 'parent';
                    var classNameResizeObserverHost = 'os-resize-observer-host';
                    var classNameTextareaElementFull = _classNameTextareaElement + _strSpace + _classNameTextInherit;
                    var textareaClass = _isTextarea ? _strSpace + _classNameTextInherit : _strEmpty;
                    var adoptAttrs = _currentPreparedOptions.textarea.inheritedAttrs;
                    var adoptAttrsMap = {};
                    var applyAdoptedAttrs = function () {
                        var applyAdoptedAttrsElm = destroy ? _targetElement : _hostElement;
                        each(adoptAttrsMap, function (key, value) {
                            if (type(value) == TYPES.s) {
                                if (key == LEXICON.c)
                                    applyAdoptedAttrsElm.addClass(value);
                                else
                                    applyAdoptedAttrsElm.attr(key, value);
                            }
                        });
                    };
                    var hostElementClassNames = [
                        _classNameHostElement,
                        _classNameHostElementForeign,
                        _classNameHostTextareaElement,
                        _classNameHostResizeDisabled,
                        _classNameHostRTL,
                        _classNameHostScrollbarHorizontalHidden,
                        _classNameHostScrollbarVerticalHidden,
                        _classNameHostTransition,
                        _classNameHostScrolling,
                        _classNameHostOverflow,
                        _classNameHostOverflowX,
                        _classNameHostOverflowY,
                        _classNameThemeNone,
                        _classNameTextareaElement,
                        _classNameTextInherit,
                        _classNameCache].join(_strSpace);
                    var hostElementCSS = {};

                    //get host element as first element, because that's the most upper element and required for the other elements
                    _hostElement = _hostElement || (_isTextarea ? (_domExists ? _targetElement[strParent]()[strParent]()[strParent]()[strParent]() : FRAMEWORK(generateDiv(_classNameHostTextareaElement))) : _targetElement);
                    _contentElement = _contentElement || selectOrGenerateDivByClass(_classNameContentElement + textareaClass);
                    _viewportElement = _viewportElement || selectOrGenerateDivByClass(_classNameViewportElement + textareaClass);
                    _paddingElement = _paddingElement || selectOrGenerateDivByClass(_classNamePaddingElement + textareaClass);
                    _sizeObserverElement = _sizeObserverElement || selectOrGenerateDivByClass(classNameResizeObserverHost);
                    _textareaCoverElement = _textareaCoverElement || (_isTextarea ? selectOrGenerateDivByClass(_classNameTextareaCoverElement) : undefined);

                    //add this class to workaround class changing issues with UI frameworks especially Vue
                    if (_domExists)
                        addClass(_hostElement, _classNameHostElementForeign);

                    //on destroy, remove all generated class names from the host element before collecting the adopted attributes 
                    //to prevent adopting generated class names
                    if (destroy)
                        removeClass(_hostElement, hostElementClassNames);

                    //collect all adopted attributes
                    adoptAttrs = type(adoptAttrs) == TYPES.s ? adoptAttrs.split(_strSpace) : adoptAttrs;
                    if (COMPATIBILITY.isA(adoptAttrs) && _isTextarea) {
                        each(adoptAttrs, function (i, v) {
                            if (type(v) == TYPES.s) {
                                adoptAttrsMap[v] = destroy ? _hostElement.attr(v) : _targetElement.attr(v);
                            }
                        });
                    }

                    if (!destroy) {
                        if (_isTextarea) {
                            if (!_currentPreparedOptions.sizeAutoCapable) {
                                hostElementCSS[_strWidth] = _targetElement.css(_strWidth);
                                hostElementCSS[_strHeight] = _targetElement.css(_strHeight);
                            }

                            if (!_domExists)
                                _targetElement.addClass(_classNameTextInherit).wrap(_hostElement);

                            //jQuery clones elements in wrap functions, so we have to select them again
                            _hostElement = _targetElement[strParent]().css(hostElementCSS);
                        }

                        if (!_domExists) {
                            //add the correct class to the target element
                            addClass(_targetElement, _isTextarea ? classNameTextareaElementFull : _classNameHostElement);

                            //wrap the content into the generated elements to create the required DOM
                            _hostElement.wrapInner(_contentElement)
                                .wrapInner(_viewportElement)
                                .wrapInner(_paddingElement)
                                .prepend(_sizeObserverElement);

                            //jQuery clones elements in wrap functions, so we have to select them again
                            _contentElement = findFirst(_hostElement, _strDot + _classNameContentElement);
                            _viewportElement = findFirst(_hostElement, _strDot + _classNameViewportElement);
                            _paddingElement = findFirst(_hostElement, _strDot + _classNamePaddingElement);

                            if (_isTextarea) {
                                _contentElement.prepend(_textareaCoverElement);
                                applyAdoptedAttrs();
                            }
                        }

                        if (_nativeScrollbarStyling)
                            addClass(_viewportElement, _classNameViewportNativeScrollbarsInvisible);
                        if (_nativeScrollbarIsOverlaid.x && _nativeScrollbarIsOverlaid.y)
                            addClass(_viewportElement, _classNameViewportNativeScrollbarsOverlaid);
                        if (_isBody)
                            addClass(_htmlElement, _classNameHTMLElement);

                        _sizeObserverElementNative = _sizeObserverElement[0];
                        _hostElementNative = _hostElement[0];
                        _paddingElementNative = _paddingElement[0];
                        _viewportElementNative = _viewportElement[0];
                        _contentElementNative = _contentElement[0];

                        updateViewportAttrsFromTarget();
                    }
                    else {
                        if (_domExists && _initialized) {
                            //clear size observer
                            _sizeObserverElement.children().remove();

                            //remove the style property and classes from already generated elements
                            each([_paddingElement, _viewportElement, _contentElement, _textareaCoverElement], function (i, elm) {
                                if (elm) {
                                    removeClass(elm.removeAttr(LEXICON.s), _classNamesDynamicDestroy);
                                }
                            });

                            //add classes to the host element which was removed previously to match the expected DOM
                            addClass(_hostElement, _isTextarea ? _classNameHostTextareaElement : _classNameHostElement);
                        }
                        else {
                            //remove size observer
                            remove(_sizeObserverElement);

                            //unwrap the content to restore DOM
                            _contentElement.contents()
                                .unwrap()
                                .unwrap()
                                .unwrap();

                            if (_isTextarea) {
                                _targetElement.unwrap();
                                remove(_hostElement);
                                remove(_textareaCoverElement);
                                applyAdoptedAttrs();
                            }
                        }

                        if (_isTextarea)
                            _targetElement.removeAttr(LEXICON.s);

                        if (_isBody)
                            removeClass(_htmlElement, _classNameHTMLElement);
                    }
                }

                /**
                 * Adds or removes all wrapper elements interactivity events.
                 * @param destroy Indicates whether the Events shall be added or removed.
                 */
                function setupStructureEvents() {
                    var textareaKeyDownRestrictedKeyCodes = [
                        112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 123,    //F1 to F12
                        33, 34,                                                   //page up, page down
                        37, 38, 39, 40,                                           //left, up, right, down arrows
                        16, 17, 18, 19, 20, 144                                   //Shift, Ctrl, Alt, Pause, CapsLock, NumLock
                    ];
                    var textareaKeyDownKeyCodesList = [];
                    var textareaUpdateIntervalID;
                    var scrollStopTimeoutId;
                    var scrollStopDelay = 175;
                    var strFocus = 'focus';

                    function updateTextarea(doClearInterval) {
                        textareaUpdate();
                        _base.update(_strAuto);
                        if (doClearInterval && _autoUpdateRecommended)
                            clearInterval(textareaUpdateIntervalID);
                    }
                    function textareaOnScroll(event) {
                        _targetElement[_strScrollLeft](_rtlScrollBehavior.i && _normalizeRTLCache ? 9999999 : 0);
                        _targetElement[_strScrollTop](0);
                        COMPATIBILITY.prvD(event);
                        COMPATIBILITY.stpP(event);
                        return false;
                    }
                    function textareaOnDrop(event) {
                        setTimeout(function () {
                            if (!_destroyed)
                                updateTextarea();
                        }, 50);
                    }
                    function textareaOnFocus() {
                        _textareaHasFocus = true;
                        addClass(_hostElement, strFocus);
                    }
                    function textareaOnFocusout() {
                        _textareaHasFocus = false;
                        textareaKeyDownKeyCodesList = [];
                        removeClass(_hostElement, strFocus);
                        updateTextarea(true);
                    }
                    function textareaOnKeyDown(event) {
                        var keyCode = event.keyCode;

                        if (inArray(keyCode, textareaKeyDownRestrictedKeyCodes) < 0) {
                            if (!textareaKeyDownKeyCodesList[LEXICON.l]) {
                                updateTextarea();
                                textareaUpdateIntervalID = setInterval(updateTextarea, 1000 / 60);
                            }
                            if (inArray(keyCode, textareaKeyDownKeyCodesList) < 0)
                                textareaKeyDownKeyCodesList.push(keyCode);
                        }
                    }
                    function textareaOnKeyUp(event) {
                        var keyCode = event.keyCode;
                        var index = inArray(keyCode, textareaKeyDownKeyCodesList);

                        if (inArray(keyCode, textareaKeyDownRestrictedKeyCodes) < 0) {
                            if (index > -1)
                                textareaKeyDownKeyCodesList.splice(index, 1);
                            if (!textareaKeyDownKeyCodesList[LEXICON.l])
                                updateTextarea(true);
                        }
                    }
                    function contentOnTransitionEnd(event) {
                        if (_autoUpdateCache === true)
                            return;
                        event = event.originalEvent || event;
                        if (isSizeAffectingCSSProperty(event.propertyName))
                            _base.update(_strAuto);
                    }
                    function viewportOnScroll(event) {
                        if (!_sleeping) {
                            if (scrollStopTimeoutId !== undefined)
                                clearTimeout(scrollStopTimeoutId);
                            else {
                                if (_scrollbarsAutoHideScroll || _scrollbarsAutoHideMove)
                                    refreshScrollbarsAutoHide(true);

                                if (!nativeOverlayScrollbarsAreActive())
                                    addClass(_hostElement, _classNameHostScrolling);

                                dispatchCallback('onScrollStart', event);
                            }

                            //if a scrollbars handle gets dragged, the mousemove event is responsible for refreshing the handle offset
                            //because if CSS scroll-snap is used, the handle offset gets only refreshed on every snap point
                            //this looks laggy & clunky, it looks much better if the offset refreshes with the mousemove
                            if (!_scrollbarsHandlesDefineScrollPos) {
                                refreshScrollbarHandleOffset(true);
                                refreshScrollbarHandleOffset(false);
                            }
                            dispatchCallback('onScroll', event);

                            scrollStopTimeoutId = setTimeout(function () {
                                if (!_destroyed) {
                                    //OnScrollStop:
                                    clearTimeout(scrollStopTimeoutId);
                                    scrollStopTimeoutId = undefined;

                                    if (_scrollbarsAutoHideScroll || _scrollbarsAutoHideMove)
                                        refreshScrollbarsAutoHide(false);

                                    if (!nativeOverlayScrollbarsAreActive())
                                        removeClass(_hostElement, _classNameHostScrolling);

                                    dispatchCallback('onScrollStop', event);
                                }
                            }, scrollStopDelay);
                        }
                    }


                    if (_isTextarea) {
                        if (_msieVersion > 9 || !_autoUpdateRecommended) {
                            addDestroyEventListener(_targetElement, 'input', updateTextarea);
                        }
                        else {
                            addDestroyEventListener(_targetElement,
                                [_strKeyDownEvent, _strKeyUpEvent],
                                [textareaOnKeyDown, textareaOnKeyUp]);
                        }

                        addDestroyEventListener(_targetElement,
                            [_strScroll, 'drop', strFocus, strFocus + 'out'],
                            [textareaOnScroll, textareaOnDrop, textareaOnFocus, textareaOnFocusout]);
                    }
                    else {
                        addDestroyEventListener(_contentElement, _strTransitionEndEvent, contentOnTransitionEnd);
                    }
                    addDestroyEventListener(_viewportElement, _strScroll, viewportOnScroll, true);
                }


                //==== Scrollbars ====//

                /**
                 * Builds or destroys all scrollbar DOM elements (scrollbar, track, handle)
                 * @param destroy Indicates whether the DOM shall be build or destroyed.
                 */
                function setupScrollbarsDOM(destroy) {
                    var selectOrGenerateScrollbarDOM = function (isHorizontal) {
                        var scrollbarClassName = isHorizontal ? _classNameScrollbarHorizontal : _classNameScrollbarVertical;
                        var scrollbar = selectOrGenerateDivByClass(_classNameScrollbar + _strSpace + scrollbarClassName, true);
                        var track = selectOrGenerateDivByClass(_classNameScrollbarTrack, scrollbar);
                        var handle = selectOrGenerateDivByClass(_classNameScrollbarHandle, scrollbar);

                        if (!_domExists && !destroy) {
                            scrollbar.append(track);
                            track.append(handle);
                        }

                        return {
                            _scrollbar: scrollbar,
                            _track: track,
                            _handle: handle
                        };
                    };
                    function resetScrollbarDOM(isHorizontal) {
                        var scrollbarVars = getScrollbarVars(isHorizontal);
                        var scrollbar = scrollbarVars._scrollbar;
                        var track = scrollbarVars._track;
                        var handle = scrollbarVars._handle;

                        if (_domExists && _initialized) {
                            each([scrollbar, track, handle], function (i, elm) {
                                removeClass(elm.removeAttr(LEXICON.s), _classNamesDynamicDestroy);
                            });
                        }
                        else {
                            remove(scrollbar || selectOrGenerateScrollbarDOM(isHorizontal)._scrollbar);
                        }
                    }
                    var horizontalElements;
                    var verticalElements;

                    if (!destroy) {
                        horizontalElements = selectOrGenerateScrollbarDOM(true);
                        verticalElements = selectOrGenerateScrollbarDOM();

                        _scrollbarHorizontalElement = horizontalElements._scrollbar;
                        _scrollbarHorizontalTrackElement = horizontalElements._track;
                        _scrollbarHorizontalHandleElement = horizontalElements._handle;
                        _scrollbarVerticalElement = verticalElements._scrollbar;
                        _scrollbarVerticalTrackElement = verticalElements._track;
                        _scrollbarVerticalHandleElement = verticalElements._handle;

                        if (!_domExists) {
                            _paddingElement.after(_scrollbarVerticalElement);
                            _paddingElement.after(_scrollbarHorizontalElement);
                        }
                    }
                    else {
                        resetScrollbarDOM(true);
                        resetScrollbarDOM();
                    }
                }

                /**
                 * Initializes all scrollbar interactivity events. (track and handle dragging, clicking, scrolling)
                 * @param isHorizontal True if the target scrollbar is the horizontal scrollbar, false if the target scrollbar is the vertical scrollbar.
                 */
                function setupScrollbarEvents(isHorizontal) {
                    var scrollbarVars = getScrollbarVars(isHorizontal);
                    var scrollbarVarsInfo = scrollbarVars._info;
                    var insideIFrame = _windowElementNative.top !== _windowElementNative;
                    var xy = scrollbarVars._x_y;
                    var XY = scrollbarVars._X_Y;
                    var scroll = _strScroll + scrollbarVars._Left_Top;
                    var strActive = 'active';
                    var strSnapHandle = 'snapHandle';
                    var strClickEvent = 'click';
                    var scrollDurationFactor = 1;
                    var increaseDecreaseScrollAmountKeyCodes = [16, 17]; //shift, ctrl
                    var trackTimeout;
                    var mouseDownScroll;
                    var mouseDownOffset;
                    var mouseDownInvertedScale;

                    function getPointerPosition(event) {
                        return _msieVersion && insideIFrame ? event['screen' + XY] : COMPATIBILITY.page(event)[xy]; //use screen coordinates in EDGE & IE because the page values are incorrect in frames.
                    }
                    function getPreparedScrollbarsOption(name) {
                        return _currentPreparedOptions.scrollbars[name];
                    }
                    function increaseTrackScrollAmount() {
                        scrollDurationFactor = 0.5;
                    }
                    function decreaseTrackScrollAmount() {
                        scrollDurationFactor = 1;
                    }
                    function stopClickEventPropagation(event) {
                        COMPATIBILITY.stpP(event);
                    }
                    function documentKeyDown(event) {
                        if (inArray(event.keyCode, increaseDecreaseScrollAmountKeyCodes) > -1)
                            increaseTrackScrollAmount();
                    }
                    function documentKeyUp(event) {
                        if (inArray(event.keyCode, increaseDecreaseScrollAmountKeyCodes) > -1)
                            decreaseTrackScrollAmount();
                    }
                    function onMouseTouchDownContinue(event) {
                        var originalEvent = event.originalEvent || event;
                        var isTouchEvent = originalEvent.touches !== undefined;
                        return _sleeping || _destroyed || nativeOverlayScrollbarsAreActive() || !_scrollbarsDragScrollingCache || (isTouchEvent && !getPreparedScrollbarsOption('touchSupport')) ? false : COMPATIBILITY.mBtn(event) === 1 || isTouchEvent;
                    }
                    function documentDragMove(event) {
                        if (onMouseTouchDownContinue(event)) {
                            var trackLength = scrollbarVarsInfo._trackLength;
                            var handleLength = scrollbarVarsInfo._handleLength;
                            var scrollRange = scrollbarVarsInfo._maxScroll;
                            var scrollRaw = (getPointerPosition(event) - mouseDownOffset) * mouseDownInvertedScale;
                            var scrollDeltaPercent = scrollRaw / (trackLength - handleLength);
                            var scrollDelta = (scrollRange * scrollDeltaPercent);
                            scrollDelta = isFinite(scrollDelta) ? scrollDelta : 0;
                            if (_isRTL && isHorizontal && !_rtlScrollBehavior.i)
                                scrollDelta *= -1;

                            _viewportElement[scroll](MATH.round(mouseDownScroll + scrollDelta));

                            if (_scrollbarsHandlesDefineScrollPos)
                                refreshScrollbarHandleOffset(isHorizontal, mouseDownScroll + scrollDelta);

                            if (!_supportPassiveEvents)
                                COMPATIBILITY.prvD(event);
                        }
                        else
                            documentMouseTouchUp(event);
                    }
                    function documentMouseTouchUp(event) {
                        event = event || event.originalEvent;

                        setupResponsiveEventListener(_documentElement,
                            [_strMouseTouchMoveEvent, _strMouseTouchUpEvent, _strKeyDownEvent, _strKeyUpEvent, _strSelectStartEvent],
                            [documentDragMove, documentMouseTouchUp, documentKeyDown, documentKeyUp, documentOnSelectStart],
                            true);
                        COMPATIBILITY.rAF()(function() {
                            setupResponsiveEventListener(_documentElement, strClickEvent, stopClickEventPropagation, true, { _capture: true });
                        });
                        
                            
                        if (_scrollbarsHandlesDefineScrollPos)
                            refreshScrollbarHandleOffset(isHorizontal, true);

                        _scrollbarsHandlesDefineScrollPos = false;
                        removeClass(_bodyElement, _classNameDragging);
                        removeClass(scrollbarVars._handle, strActive);
                        removeClass(scrollbarVars._track, strActive);
                        removeClass(scrollbarVars._scrollbar, strActive);

                        mouseDownScroll = undefined;
                        mouseDownOffset = undefined;
                        mouseDownInvertedScale = 1;

                        decreaseTrackScrollAmount();

                        if (trackTimeout !== undefined) {
                            _base.scrollStop();
                            clearTimeout(trackTimeout);
                            trackTimeout = undefined;
                        }

                        if (event) {
                            var rect = _hostElementNative[LEXICON.bCR]();
                            var mouseInsideHost = event.clientX >= rect.left && event.clientX <= rect.right && event.clientY >= rect.top && event.clientY <= rect.bottom;

                            //if mouse is outside host element
                            if (!mouseInsideHost)
                                hostOnMouseLeave();

                            if (_scrollbarsAutoHideScroll || _scrollbarsAutoHideMove)
                                refreshScrollbarsAutoHide(false);
                        }
                    }
                    function onHandleMouseTouchDown(event) {
                        if (onMouseTouchDownContinue(event))
                            onHandleMouseTouchDownAction(event);
                    }
                    function onHandleMouseTouchDownAction(event) {
                        mouseDownScroll = _viewportElement[scroll]();
                        mouseDownScroll = isNaN(mouseDownScroll) ? 0 : mouseDownScroll;
                        if (_isRTL && isHorizontal && !_rtlScrollBehavior.n || !_isRTL)
                            mouseDownScroll = mouseDownScroll < 0 ? 0 : mouseDownScroll;

                        mouseDownInvertedScale = getHostElementInvertedScale()[xy];
                        mouseDownOffset = getPointerPosition(event);

                        _scrollbarsHandlesDefineScrollPos = !getPreparedScrollbarsOption(strSnapHandle);
                        addClass(_bodyElement, _classNameDragging);
                        addClass(scrollbarVars._handle, strActive);
                        addClass(scrollbarVars._scrollbar, strActive);

                        setupResponsiveEventListener(_documentElement,
                            [_strMouseTouchMoveEvent, _strMouseTouchUpEvent, _strSelectStartEvent],
                            [documentDragMove, documentMouseTouchUp, documentOnSelectStart]);
                        COMPATIBILITY.rAF()(function() {
                            setupResponsiveEventListener(_documentElement, strClickEvent, stopClickEventPropagation, false, { _capture: true });
                        });
                        

                        if (_msieVersion || !_documentMixed)
                            COMPATIBILITY.prvD(event);
                        COMPATIBILITY.stpP(event);
                    }
                    function onTrackMouseTouchDown(event) {
                        if (onMouseTouchDownContinue(event)) {
                            var handleToViewportRatio = scrollbarVars._info._handleLength / Math.round(MATH.min(1, _viewportSize[scrollbarVars._w_h] / _contentScrollSizeCache[scrollbarVars._w_h]) * scrollbarVars._info._trackLength);
                            var scrollDistance = MATH.round(_viewportSize[scrollbarVars._w_h] * handleToViewportRatio);
                            var scrollBaseDuration = 270 * handleToViewportRatio;
                            var scrollFirstIterationDelay = 400 * handleToViewportRatio;
                            var trackOffset = scrollbarVars._track.offset()[scrollbarVars._left_top];
                            var ctrlKey = event.ctrlKey;
                            var instantScroll = event.shiftKey;
                            var instantScrollTransition = instantScroll && ctrlKey;
                            var isFirstIteration = true;
                            var easing = 'linear';
                            var decreaseScroll;
                            var finishedCondition;
                            var scrollActionFinsished = function (transition) {
                                if (_scrollbarsHandlesDefineScrollPos)
                                    refreshScrollbarHandleOffset(isHorizontal, transition);
                            };
                            var scrollActionInstantFinished = function () {
                                scrollActionFinsished();
                                onHandleMouseTouchDownAction(event);
                            };
                            var scrollAction = function () {
                                if (!_destroyed) {
                                    var mouseOffset = (mouseDownOffset - trackOffset) * mouseDownInvertedScale;
                                    var handleOffset = scrollbarVarsInfo._handleOffset;
                                    var trackLength = scrollbarVarsInfo._trackLength;
                                    var handleLength = scrollbarVarsInfo._handleLength;
                                    var scrollRange = scrollbarVarsInfo._maxScroll;
                                    var currScroll = scrollbarVarsInfo._currentScroll;
                                    var scrollDuration = scrollBaseDuration * scrollDurationFactor;
                                    var timeoutDelay = isFirstIteration ? MATH.max(scrollFirstIterationDelay, scrollDuration) : scrollDuration;
                                    var instantScrollPosition = scrollRange * ((mouseOffset - (handleLength / 2)) / (trackLength - handleLength)); // 100% * positionPercent
                                    var rtlIsNormal = _isRTL && isHorizontal && ((!_rtlScrollBehavior.i && !_rtlScrollBehavior.n) || _normalizeRTLCache);
                                    var decreaseScrollCondition = rtlIsNormal ? handleOffset < mouseOffset : handleOffset > mouseOffset;
                                    var scrollObj = {};
                                    var animationObj = {
                                        easing: easing,
                                        step: function (now) {
                                            if (_scrollbarsHandlesDefineScrollPos) {
                                                _viewportElement[scroll](now); //https://github.com/jquery/jquery/issues/4340
                                                refreshScrollbarHandleOffset(isHorizontal, now);
                                            }
                                        }
                                    };
                                    instantScrollPosition = isFinite(instantScrollPosition) ? instantScrollPosition : 0;
                                    instantScrollPosition = _isRTL && isHorizontal && !_rtlScrollBehavior.i ? (scrollRange - instantScrollPosition) : instantScrollPosition;

                                    //_base.scrollStop();

                                    if (instantScroll) {
                                        _viewportElement[scroll](instantScrollPosition); //scroll instantly to new position
                                        if (instantScrollTransition) {
                                            //get the scroll position after instant scroll (in case CSS Snap Points are used) to get the correct snapped scroll position
                                            //and the animation stops at the correct point
                                            instantScrollPosition = _viewportElement[scroll]();
                                            //scroll back to the position before instant scrolling so animation can be performed
                                            _viewportElement[scroll](currScroll);

                                            instantScrollPosition = rtlIsNormal && _rtlScrollBehavior.i ? (scrollRange - instantScrollPosition) : instantScrollPosition;
                                            instantScrollPosition = rtlIsNormal && _rtlScrollBehavior.n ? -instantScrollPosition : instantScrollPosition;

                                            scrollObj[xy] = instantScrollPosition;
                                            _base.scroll(scrollObj, extendDeep(animationObj, {
                                                duration: 130,
                                                complete: scrollActionInstantFinished
                                            }));
                                        }
                                        else
                                            scrollActionInstantFinished();
                                    }
                                    else {
                                        decreaseScroll = isFirstIteration ? decreaseScrollCondition : decreaseScroll;
                                        finishedCondition = rtlIsNormal
                                            ? (decreaseScroll ? handleOffset + handleLength >= mouseOffset : handleOffset <= mouseOffset)
                                            : (decreaseScroll ? handleOffset <= mouseOffset : handleOffset + handleLength >= mouseOffset);

                                        if (finishedCondition) {
                                            clearTimeout(trackTimeout);
                                            _base.scrollStop();
                                            trackTimeout = undefined;
                                            scrollActionFinsished(true);
                                        }
                                        else {
                                            trackTimeout = setTimeout(scrollAction, timeoutDelay);

                                            scrollObj[xy] = (decreaseScroll ? '-=' : '+=') + scrollDistance;
                                            _base.scroll(scrollObj, extendDeep(animationObj, {
                                                duration: scrollDuration
                                            }));
                                        }
                                        isFirstIteration = false;
                                    }
                                }
                            };
                            if (ctrlKey)
                                increaseTrackScrollAmount();

                            mouseDownInvertedScale = getHostElementInvertedScale()[xy];
                            mouseDownOffset = COMPATIBILITY.page(event)[xy];

                            _scrollbarsHandlesDefineScrollPos = !getPreparedScrollbarsOption(strSnapHandle);
                            addClass(_bodyElement, _classNameDragging);
                            addClass(scrollbarVars._track, strActive);
                            addClass(scrollbarVars._scrollbar, strActive);

                            setupResponsiveEventListener(_documentElement,
                                [_strMouseTouchUpEvent, _strKeyDownEvent, _strKeyUpEvent, _strSelectStartEvent],
                                [documentMouseTouchUp, documentKeyDown, documentKeyUp, documentOnSelectStart]);

                            scrollAction();
                            COMPATIBILITY.prvD(event);
                            COMPATIBILITY.stpP(event);
                        }
                    }
                    function onTrackMouseTouchEnter(event) {
                        //make sure both scrollbars will stay visible if one scrollbar is hovered if autoHide is "scroll" or "move".
                        _scrollbarsHandleHovered = true;
                        if (_scrollbarsAutoHideScroll || _scrollbarsAutoHideMove)
                            refreshScrollbarsAutoHide(true);
                    }
                    function onTrackMouseTouchLeave(event) {
                        _scrollbarsHandleHovered = false;
                        if (_scrollbarsAutoHideScroll || _scrollbarsAutoHideMove)
                            refreshScrollbarsAutoHide(false);
                    }
                    function onScrollbarMouseTouchDown(event) {
                        COMPATIBILITY.stpP(event);
                    }

                    addDestroyEventListener(scrollbarVars._handle,
                        _strMouseTouchDownEvent,
                        onHandleMouseTouchDown);
                    addDestroyEventListener(scrollbarVars._track,
                        [_strMouseTouchDownEvent, _strMouseEnter, _strMouseLeave],
                        [onTrackMouseTouchDown, onTrackMouseTouchEnter, onTrackMouseTouchLeave]);
                    addDestroyEventListener(scrollbarVars._scrollbar,
                        _strMouseTouchDownEvent,
                        onScrollbarMouseTouchDown);

                    if (_supportTransition) {
                        addDestroyEventListener(scrollbarVars._scrollbar, _strTransitionEndEvent, function (event) {
                            if (event.target !== scrollbarVars._scrollbar[0])
                                return;
                            refreshScrollbarHandleLength(isHorizontal);
                            refreshScrollbarHandleOffset(isHorizontal);
                        });
                    }
                }

                /**
                 * Shows or hides the given scrollbar and applied a class name which indicates if the scrollbar is scrollable or not.
                 * @param isHorizontal True if the horizontal scrollbar is the target, false if the vertical scrollbar is the target.
                 * @param shallBeVisible True if the scrollbar shall be shown, false if hidden.
                 * @param canScroll True if the scrollbar is scrollable, false otherwise.
                 */
                function refreshScrollbarAppearance(isHorizontal, shallBeVisible, canScroll) {
                    var scrollbarHiddenClassName = isHorizontal ? _classNameHostScrollbarHorizontalHidden : _classNameHostScrollbarVerticalHidden;
                    var scrollbarElement = isHorizontal ? _scrollbarHorizontalElement : _scrollbarVerticalElement;

                    addRemoveClass(_hostElement, scrollbarHiddenClassName, !shallBeVisible);
                    addRemoveClass(scrollbarElement, _classNameScrollbarUnusable, !canScroll);
                }

                /**
                 * Autoshows / autohides both scrollbars with.
                 * @param shallBeVisible True if the scrollbars shall be autoshown (only the case if they are hidden by a autohide), false if the shall be auto hidden.
                 * @param delayfree True if the scrollbars shall be hidden without a delay, false or undefined otherwise.
                 */
                function refreshScrollbarsAutoHide(shallBeVisible, delayfree) {
                    clearTimeout(_scrollbarsAutoHideTimeoutId);
                    if (shallBeVisible) {
                        //if(_hasOverflowCache.x && _hideOverflowCache.xs)
                        removeClass(_scrollbarHorizontalElement, _classNameScrollbarAutoHidden);
                        //if(_hasOverflowCache.y && _hideOverflowCache.ys)
                        removeClass(_scrollbarVerticalElement, _classNameScrollbarAutoHidden);
                    }
                    else {
                        var anyActive;
                        var strActive = 'active';
                        var hide = function () {
                            if (!_scrollbarsHandleHovered && !_destroyed) {
                                anyActive = _scrollbarHorizontalHandleElement.hasClass(strActive) || _scrollbarVerticalHandleElement.hasClass(strActive);
                                if (!anyActive && (_scrollbarsAutoHideScroll || _scrollbarsAutoHideMove || _scrollbarsAutoHideLeave))
                                    addClass(_scrollbarHorizontalElement, _classNameScrollbarAutoHidden);
                                if (!anyActive && (_scrollbarsAutoHideScroll || _scrollbarsAutoHideMove || _scrollbarsAutoHideLeave))
                                    addClass(_scrollbarVerticalElement, _classNameScrollbarAutoHidden);
                            }
                        };
                        if (_scrollbarsAutoHideDelay > 0 && delayfree !== true)
                            _scrollbarsAutoHideTimeoutId = setTimeout(hide, _scrollbarsAutoHideDelay);
                        else
                            hide();
                    }
                }

                /**
                 * Refreshes the handle length of the given scrollbar.
                 * @param isHorizontal True if the horizontal scrollbar handle shall be refreshed, false if the vertical one shall be refreshed.
                 */
                function refreshScrollbarHandleLength(isHorizontal) {
                    var handleCSS = {};
                    var scrollbarVars = getScrollbarVars(isHorizontal);
                    var scrollbarVarsInfo = scrollbarVars._info;
                    var digit = 1000000;
                    //get and apply intended handle length
                    var handleRatio = MATH.min(1, _viewportSize[scrollbarVars._w_h] / _contentScrollSizeCache[scrollbarVars._w_h]);
                    handleCSS[scrollbarVars._width_height] = (MATH.floor(handleRatio * 100 * digit) / digit) + '%'; //the last * digit / digit is for flooring to the 4th digit

                    if (!nativeOverlayScrollbarsAreActive())
                        scrollbarVars._handle.css(handleCSS);

                    //measure the handle length to respect min & max length
                    scrollbarVarsInfo._handleLength = scrollbarVars._handle[0]['offset' + scrollbarVars._Width_Height];
                    scrollbarVarsInfo._handleLengthRatio = handleRatio;
                }

                /**
                 * Refreshes the handle offset of the given scrollbar.
                 * @param isHorizontal True if the horizontal scrollbar handle shall be refreshed, false if the vertical one shall be refreshed.
                 * @param scrollOrTransition The scroll position of the given scrollbar axis to which the handle shall be moved or a boolean which indicates whether a transition shall be applied. If undefined or boolean if the current scroll-offset is taken. (if isHorizontal ? scrollLeft : scrollTop)
                 */
                function refreshScrollbarHandleOffset(isHorizontal, scrollOrTransition) {
                    var transition = type(scrollOrTransition) == TYPES.b;
                    var transitionDuration = 250;
                    var isRTLisHorizontal = _isRTL && isHorizontal;
                    var scrollbarVars = getScrollbarVars(isHorizontal);
                    var scrollbarVarsInfo = scrollbarVars._info;
                    var strTranslateBrace = 'translate(';
                    var strTransform = VENDORS._cssProperty('transform');
                    var strTransition = VENDORS._cssProperty('transition');
                    var nativeScroll = isHorizontal ? _viewportElement[_strScrollLeft]() : _viewportElement[_strScrollTop]();
                    var currentScroll = scrollOrTransition === undefined || transition ? nativeScroll : scrollOrTransition;

                    //measure the handle length to respect min & max length
                    var handleLength = scrollbarVarsInfo._handleLength;
                    var trackLength = scrollbarVars._track[0]['offset' + scrollbarVars._Width_Height];
                    var handleTrackDiff = trackLength - handleLength;
                    var handleCSS = {};
                    var transformOffset;
                    var translateValue;

                    //DONT use the variable '_contentScrollSizeCache[scrollbarVars._w_h]' instead of '_viewportElement[0]['scroll' + scrollbarVars._Width_Height]'
                    // because its a bit behind during the small delay when content size updates
                    //(delay = mutationObserverContentLag, if its 0 then this var could be used)
                    var maxScroll = (_viewportElementNative[_strScroll + scrollbarVars._Width_Height] - _viewportElementNative['client' + scrollbarVars._Width_Height]) * (_rtlScrollBehavior.n && isRTLisHorizontal ? -1 : 1); //* -1 if rtl scroll max is negative
                    var getScrollRatio = function (base) {
                        return isNaN(base / maxScroll) ? 0 : MATH.max(0, MATH.min(1, base / maxScroll));
                    };
                    var getHandleOffset = function (scrollRatio) {
                        var offset = handleTrackDiff * scrollRatio;
                        offset = isNaN(offset) ? 0 : offset;
                        offset = (isRTLisHorizontal && !_rtlScrollBehavior.i) ? (trackLength - handleLength - offset) : offset;
                        offset = MATH.max(0, offset);
                        return offset;
                    };
                    var scrollRatio = getScrollRatio(nativeScroll);
                    var unsnappedScrollRatio = getScrollRatio(currentScroll);
                    var handleOffset = getHandleOffset(unsnappedScrollRatio);
                    var snappedHandleOffset = getHandleOffset(scrollRatio);

                    scrollbarVarsInfo._maxScroll = maxScroll;
                    scrollbarVarsInfo._currentScroll = nativeScroll;
                    scrollbarVarsInfo._currentScrollRatio = scrollRatio;

                    if (_supportTransform) {
                        transformOffset = isRTLisHorizontal ? -(trackLength - handleLength - handleOffset) : handleOffset; //in px
                        //transformOffset = (transformOffset / trackLength * 100) * (trackLength / handleLength); //in %
                        translateValue = isHorizontal ? strTranslateBrace + transformOffset + 'px, 0)' : strTranslateBrace + '0, ' + transformOffset + 'px)';

                        handleCSS[strTransform] = translateValue;

                        //apply or clear up transition
                        if (_supportTransition)
                            handleCSS[strTransition] = transition && MATH.abs(handleOffset - scrollbarVarsInfo._handleOffset) > 1 ? getCSSTransitionString(scrollbarVars._handle) + ', ' + (strTransform + _strSpace + transitionDuration + 'ms') : _strEmpty;
                    }
                    else
                        handleCSS[scrollbarVars._left_top] = handleOffset;


                    //only apply css if offset has changed and overflow exists.
                    if (!nativeOverlayScrollbarsAreActive()) {
                        scrollbarVars._handle.css(handleCSS);

                        //clear up transition
                        if (_supportTransform && _supportTransition && transition) {
                            scrollbarVars._handle.one(_strTransitionEndEvent, function () {
                                if (!_destroyed)
                                    scrollbarVars._handle.css(strTransition, _strEmpty);
                            });
                        }
                    }

                    scrollbarVarsInfo._handleOffset = handleOffset;
                    scrollbarVarsInfo._snappedHandleOffset = snappedHandleOffset;
                    scrollbarVarsInfo._trackLength = trackLength;
                }

                /**
                 * Refreshes the interactivity of the given scrollbar element.
                 * @param isTrack True if the track element is the target, false if the handle element is the target.
                 * @param value True for interactivity false for no interactivity.
                 */
                function refreshScrollbarsInteractive(isTrack, value) {
                    var action = value ? 'removeClass' : 'addClass';
                    var element1 = isTrack ? _scrollbarHorizontalTrackElement : _scrollbarHorizontalHandleElement;
                    var element2 = isTrack ? _scrollbarVerticalTrackElement : _scrollbarVerticalHandleElement;
                    var className = isTrack ? _classNameScrollbarTrackOff : _classNameScrollbarHandleOff;

                    element1[action](className);
                    element2[action](className);
                }

                /**
                 * Returns a object which is used for fast access for specific variables.
                 * @param isHorizontal True if the horizontal scrollbar vars shall be accessed, false if the vertical scrollbar vars shall be accessed.
                 * @returns {{wh: string, WH: string, lt: string, _wh: string, _lt: string, t: *, h: *, c: {}, s: *}}
                 */
                function getScrollbarVars(isHorizontal) {
                    return {
                        _width_height: isHorizontal ? _strWidth : _strHeight,
                        _Width_Height: isHorizontal ? 'Width' : 'Height',
                        _left_top: isHorizontal ? _strLeft : _strTop,
                        _Left_Top: isHorizontal ? 'Left' : 'Top',
                        _x_y: isHorizontal ? _strX : _strY,
                        _X_Y: isHorizontal ? 'X' : 'Y',
                        _w_h: isHorizontal ? 'w' : 'h',
                        _l_t: isHorizontal ? 'l' : 't',
                        _track: isHorizontal ? _scrollbarHorizontalTrackElement : _scrollbarVerticalTrackElement,
                        _handle: isHorizontal ? _scrollbarHorizontalHandleElement : _scrollbarVerticalHandleElement,
                        _scrollbar: isHorizontal ? _scrollbarHorizontalElement : _scrollbarVerticalElement,
                        _info: isHorizontal ? _scrollHorizontalInfo : _scrollVerticalInfo
                    };
                }


                //==== Scrollbar Corner ====//

                /**
                 * Builds or destroys the scrollbar corner DOM element.
                 * @param destroy Indicates whether the DOM shall be build or destroyed.
                 */
                function setupScrollbarCornerDOM(destroy) {
                    _scrollbarCornerElement = _scrollbarCornerElement || selectOrGenerateDivByClass(_classNameScrollbarCorner, true);

                    if (!destroy) {
                        if (!_domExists) {
                            _hostElement.append(_scrollbarCornerElement);
                        }
                    }
                    else {
                        if (_domExists && _initialized) {
                            removeClass(_scrollbarCornerElement.removeAttr(LEXICON.s), _classNamesDynamicDestroy);
                        }
                        else {
                            remove(_scrollbarCornerElement);
                        }
                    }
                }

                /**
                 * Initializes all scrollbar corner interactivity events.
                 */
                function setupScrollbarCornerEvents() {
                    var insideIFrame = _windowElementNative.top !== _windowElementNative;
                    var mouseDownPosition = {};
                    var mouseDownSize = {};
                    var mouseDownInvertedScale = {};
                    var reconnectMutationObserver;

                    function documentDragMove(event) {
                        if (onMouseTouchDownContinue(event)) {
                            var pageOffset = getCoordinates(event);
                            var hostElementCSS = {};
                            if (_resizeHorizontal || _resizeBoth)
                                hostElementCSS[_strWidth] = (mouseDownSize.w + (pageOffset.x - mouseDownPosition.x) * mouseDownInvertedScale.x);
                            if (_resizeVertical || _resizeBoth)
                                hostElementCSS[_strHeight] = (mouseDownSize.h + (pageOffset.y - mouseDownPosition.y) * mouseDownInvertedScale.y);
                            _hostElement.css(hostElementCSS);
                            COMPATIBILITY.stpP(event);
                        }
                        else {
                            documentMouseTouchUp(event);
                        }
                    }
                    function documentMouseTouchUp(event) {
                        var eventIsTrusted = event !== undefined;

                        setupResponsiveEventListener(_documentElement,
                            [_strSelectStartEvent, _strMouseTouchMoveEvent, _strMouseTouchUpEvent],
                            [documentOnSelectStart, documentDragMove, documentMouseTouchUp],
                            true);

                        removeClass(_bodyElement, _classNameDragging);
                        if (_scrollbarCornerElement.releaseCapture)
                            _scrollbarCornerElement.releaseCapture();

                        if (eventIsTrusted) {
                            if (reconnectMutationObserver)
                                connectMutationObservers();
                            _base.update(_strAuto);
                        }
                        reconnectMutationObserver = false;
                    }
                    function onMouseTouchDownContinue(event) {
                        var originalEvent = event.originalEvent || event;
                        var isTouchEvent = originalEvent.touches !== undefined;
                        return _sleeping || _destroyed ? false : COMPATIBILITY.mBtn(event) === 1 || isTouchEvent;
                    }
                    function getCoordinates(event) {
                        return _msieVersion && insideIFrame ? { x: event.screenX, y: event.screenY } : COMPATIBILITY.page(event);
                    }

                    addDestroyEventListener(_scrollbarCornerElement, _strMouseTouchDownEvent, function (event) {
                        if (onMouseTouchDownContinue(event) && !_resizeNone) {
                            if (_mutationObserversConnected) {
                                reconnectMutationObserver = true;
                                disconnectMutationObservers();
                            }

                            mouseDownPosition = getCoordinates(event);

                            mouseDownSize.w = _hostElementNative[LEXICON.oW] - (!_isBorderBox ? _paddingX : 0);
                            mouseDownSize.h = _hostElementNative[LEXICON.oH] - (!_isBorderBox ? _paddingY : 0);
                            mouseDownInvertedScale = getHostElementInvertedScale();

                            setupResponsiveEventListener(_documentElement,
                                [_strSelectStartEvent, _strMouseTouchMoveEvent, _strMouseTouchUpEvent],
                                [documentOnSelectStart, documentDragMove, documentMouseTouchUp]);

                            addClass(_bodyElement, _classNameDragging);
                            if (_scrollbarCornerElement.setCapture)
                                _scrollbarCornerElement.setCapture();

                            COMPATIBILITY.prvD(event);
                            COMPATIBILITY.stpP(event);
                        }
                    });
                }


                //==== Utils ====//

                /**
                 * Calls the callback with the given name. The Context of this callback is always _base (this).
                 * @param name The name of the target which shall be called.
                 * @param args The args with which the callback shall be called.
                 * @param dependent Boolean which decides whether the callback shall be fired, undefined is like a "true" value.
                 */
                function dispatchCallback(name, args, dependent) {
                    if (dependent === false)
                        return;
                    if (_initialized) {
                        var callback = _currentPreparedOptions.callbacks[name];
                        var extensionOnName = name;
                        var ext;

                        if (extensionOnName.substr(0, 2) === 'on')
                            extensionOnName = extensionOnName.substr(2, 1).toLowerCase() + extensionOnName.substr(3);

                        if (type(callback) == TYPES.f)
                            callback.call(_base, args);

                        each(_extensions, function () {
                            ext = this;
                            if (type(ext.on) == TYPES.f)
                                ext.on(extensionOnName, args);
                        });
                    }
                    else if (!_destroyed)
                        _callbacksInitQeueue.push({ n: name, a: args });
                }

                /**
                 * Sets the "top, right, bottom, left" properties, with a given prefix, of the given css object.
                 * @param targetCSSObject The css object to which the values shall be applied.
                 * @param prefix The prefix of the "top, right, bottom, left" css properties. (example: 'padding-' is a valid prefix)
                 * @param values A array of values which shall be applied to the "top, right, bottom, left" -properties. The array order is [top, right, bottom, left].
                 * If this argument is undefined the value '' (empty string) will be applied to all properties.
                 */
                function setTopRightBottomLeft(targetCSSObject, prefix, values) {
                    prefix = prefix || _strEmpty;
                    values = values || [_strEmpty, _strEmpty, _strEmpty, _strEmpty];

                    targetCSSObject[prefix + _strTop] = values[0];
                    targetCSSObject[prefix + _strRight] = values[1];
                    targetCSSObject[prefix + _strBottom] = values[2];
                    targetCSSObject[prefix + _strLeft] = values[3];
                }

                /**
                 * Gets the "top, right, bottom, left" CSS properties of the CSS property with the given prefix from the host element.
                 * @param prefix The prefix of the "top, right, bottom, left" css properties. (example: 'padding-' is a valid prefix)
                 * @param suffix The suffix of the "top, right, bottom, left" css properties. (example: 'border-' is a valid prefix with '-width' is a valid suffix)
                 * @param zeroX True if the x axis shall be 0.
                 * @param zeroY True if the y axis shall be 0.
                 * @returns {{}} The object which contains the numbers of the read CSS properties.
                 */
                function getTopRightBottomLeftHost(prefix, suffix, zeroX, zeroY) {
                    suffix = suffix || _strEmpty;
                    prefix = prefix || _strEmpty;
                    return {
                        t: zeroY ? 0 : parseToZeroOrNumber(_hostElement.css(prefix + _strTop + suffix)),
                        r: zeroX ? 0 : parseToZeroOrNumber(_hostElement.css(prefix + _strRight + suffix)),
                        b: zeroY ? 0 : parseToZeroOrNumber(_hostElement.css(prefix + _strBottom + suffix)),
                        l: zeroX ? 0 : parseToZeroOrNumber(_hostElement.css(prefix + _strLeft + suffix))
                    };
                }

                /**
                 * Returns the computed CSS transition string from the given element.
                 * @param element The element from which the transition string shall be returned.
                 * @returns {string} The CSS transition string from the given element.
                 */
                function getCSSTransitionString(element) {
                    var transitionStr = VENDORS._cssProperty('transition');
                    var assembledValue = element.css(transitionStr);
                    if (assembledValue)
                        return assembledValue;
                    var regExpString = '\\s*(' + '([^,(]+(\\(.+?\\))?)+' + ')[\\s,]*';
                    var regExpMain = new RegExp(regExpString);
                    var regExpValidate = new RegExp('^(' + regExpString + ')+$');
                    var properties = 'property duration timing-function delay'.split(' ');
                    var result = [];
                    var strResult;
                    var valueArray;
                    var i = 0;
                    var j;
                    var splitCssStyleByComma = function (str) {
                        strResult = [];
                        if (!str.match(regExpValidate))
                            return str;
                        while (str.match(regExpMain)) {
                            strResult.push(RegExp.$1);
                            str = str.replace(regExpMain, _strEmpty);
                        }

                        return strResult;
                    };
                    for (; i < properties[LEXICON.l]; i++) {
                        valueArray = splitCssStyleByComma(element.css(transitionStr + '-' + properties[i]));
                        for (j = 0; j < valueArray[LEXICON.l]; j++)
                            result[j] = (result[j] ? result[j] + _strSpace : _strEmpty) + valueArray[j];
                    }
                    return result.join(', ');
                }

                /**
                 * Generates a Regular Expression which matches with a string which starts with 'os-host'.
                 * @param {boolean} withCurrClassNameOption The Regular Expression also matches if the string is the current ClassName option (multiple values splitted by space possible).
                 * @param {boolean} withOldClassNameOption The Regular Expression also matches if the string is the old ClassName option (multiple values splitted by space possible).
                 */
                function createHostClassNameRegExp(withCurrClassNameOption, withOldClassNameOption) {
                    var i;
                    var split;
                    var appendix;
                    var appendClasses = function (classes, condition) {
                        appendix = '';
                        if (condition && typeof classes == TYPES.s) {
                            split = classes.split(_strSpace);
                            for (i = 0; i < split[LEXICON.l]; i++)
                                appendix += '|' + split[i] + '$';
                            // split[i].replace(/[.*+?^${}()|[\]\\]/g, '\\$&') for escaping regex characters
                        }
                        return appendix;
                    };

                    return new RegExp(
                        '(^' + _classNameHostElement + '([-_].+|)$)' +
                        appendClasses(_classNameCache, withCurrClassNameOption) +
                        appendClasses(_oldClassName, withOldClassNameOption), 'g');
                }

                /**
                 * Calculates the host-elements inverted scale. (invertedScale = 1 / scale)
                 * @returns {{x: number, y: number}} The scale of the host-element.
                 */
                function getHostElementInvertedScale() {
                    var rect = _paddingElementNative[LEXICON.bCR]();
                    return {
                        x: _supportTransform ? 1 / (MATH.round(rect.width) / _paddingElementNative[LEXICON.oW]) || 1 : 1,
                        y: _supportTransform ? 1 / (MATH.round(rect.height) / _paddingElementNative[LEXICON.oH]) || 1 : 1
                    };
                }

                /**
                 * Checks whether the given object is a HTMLElement.
                 * @param o The object which shall be checked.
                 * @returns {boolean} True the given object is a HTMLElement, false otherwise.
                 */
                function isHTMLElement(o) {
                    var strOwnerDocument = 'ownerDocument';
                    var strHTMLElement = 'HTMLElement';
                    var wnd = o && o[strOwnerDocument] ? (o[strOwnerDocument].parentWindow || window) : window;
                    return (
                        typeof wnd[strHTMLElement] == TYPES.o ? o instanceof wnd[strHTMLElement] : //DOM2
                            o && typeof o == TYPES.o && o !== null && o.nodeType === 1 && typeof o.nodeName == TYPES.s
                    );
                }

                /**
                 * Compares 2 arrays and returns the differences between them as a array.
                 * @param a1 The first array which shall be compared.
                 * @param a2 The second array which shall be compared.
                 * @returns {Array} The differences between the two arrays.
                 */
                function getArrayDifferences(a1, a2) {
                    var a = [];
                    var diff = [];
                    var i;
                    var k;
                    for (i = 0; i < a1.length; i++)
                        a[a1[i]] = true;
                    for (i = 0; i < a2.length; i++) {
                        if (a[a2[i]])
                            delete a[a2[i]];
                        else
                            a[a2[i]] = true;
                    }
                    for (k in a)
                        diff.push(k);
                    return diff;
                }

                /**
                 * Returns Zero or the number to which the value can be parsed.
                 * @param value The value which shall be parsed.
                 * @param toFloat Indicates whether the number shall be parsed to a float.
                 */
                function parseToZeroOrNumber(value, toFloat) {
                    var num = toFloat ? parseFloat(value) : parseInt(value, 10);
                    return isNaN(num) ? 0 : num;
                }

                /**
                 * Gets several information of the textarea and returns them as a object or undefined if the browser doesn't support it.
                 * @returns {{cursorRow: Number, cursorCol, rows: Number, cols: number, wRow: number, pos: number, max : number}} or undefined if not supported.
                 */
                function getTextareaInfo() {
                    //read needed values
                    var textareaCursorPosition = _targetElementNative.selectionStart;
                    if (textareaCursorPosition === undefined)
                        return;

                    var textareaValue = _targetElement.val();
                    var textareaLength = textareaValue[LEXICON.l];
                    var textareaRowSplit = textareaValue.split('\n');
                    var textareaLastRow = textareaRowSplit[LEXICON.l];
                    var textareaCurrentCursorRowSplit = textareaValue.substr(0, textareaCursorPosition).split('\n');
                    var widestRow = 0;
                    var textareaLastCol = 0;
                    var cursorRow = textareaCurrentCursorRowSplit[LEXICON.l];
                    var cursorCol = textareaCurrentCursorRowSplit[textareaCurrentCursorRowSplit[LEXICON.l] - 1][LEXICON.l];
                    var rowCols;
                    var i;

                    //get widest Row and the last column of the textarea
                    for (i = 0; i < textareaRowSplit[LEXICON.l]; i++) {
                        rowCols = textareaRowSplit[i][LEXICON.l];
                        if (rowCols > textareaLastCol) {
                            widestRow = i + 1;
                            textareaLastCol = rowCols;
                        }
                    }

                    return {
                        _cursorRow: cursorRow, //cursorRow
                        _cursorColumn: cursorCol, //cursorCol
                        _rows: textareaLastRow, //rows
                        _columns: textareaLastCol, //cols
                        _widestRow: widestRow, //wRow
                        _cursorPosition: textareaCursorPosition, //pos
                        _cursorMax: textareaLength //max
                    };
                }

                /**
                 * Determines whether native overlay scrollbars are active.
                 * @returns {boolean} True if native overlay scrollbars are active, false otherwise.
                 */
                function nativeOverlayScrollbarsAreActive() {
                    return (_ignoreOverlayScrollbarHidingCache && (_nativeScrollbarIsOverlaid.x && _nativeScrollbarIsOverlaid.y));
                }

                /**
                 * Gets the element which is used to measure the content size.
                 * @returns {*} TextareaCover if target element is textarea else the ContentElement.
                 */
                function getContentMeasureElement() {
                    return _isTextarea ? _textareaCoverElement[0] : _contentElementNative;
                }

                /**
                 * Generates a string which represents a HTML div with the given classes or attributes.
                 * @param classesOrAttrs The class of the div as string or a object which represents the attributes of the div. (The class attribute can also be written as "className".)
                 * @param content The content of the div as string.
                 * @returns {string} The concated string which represents a HTML div and its content.
                 */
                function generateDiv(classesOrAttrs, content) {
                    return '<div ' + (classesOrAttrs ? type(classesOrAttrs) == TYPES.s ?
                        'class="' + classesOrAttrs + '"' :
                        (function () {
                            var key;
                            var attrs = _strEmpty;
                            if (FRAMEWORK.isPlainObject(classesOrAttrs)) {
                                for (key in classesOrAttrs)
                                    attrs += (key === 'c' ? 'class' : key) + '="' + classesOrAttrs[key] + '" ';
                            }
                            return attrs;
                        })() :
                        _strEmpty) +
                        '>' +
                        (content || _strEmpty) +
                        '</div>';
                }

                /**
                 * Selects or generates a div with the given class attribute.
                 * @param className The class names (divided by spaces) of the div which shall be selected or generated.
                 * @param selectParentOrOnlyChildren The parent element from which of the element shall be selected. (if undefined or boolean its hostElement)
                 * If its a boolean it decides whether only the children of the host element shall be selected.
                 * @returns {*} The generated or selected element.
                 */
                function selectOrGenerateDivByClass(className, selectParentOrOnlyChildren) {
                    var onlyChildren = type(selectParentOrOnlyChildren) == TYPES.b;
                    var selectParent = onlyChildren ? _hostElement : (selectParentOrOnlyChildren || _hostElement);

                    return (_domExists && !selectParent[LEXICON.l])
                        ? null
                        : _domExists
                            ? selectParent[onlyChildren ? 'children' : 'find'](_strDot + className.replace(/\s/g, _strDot)).eq(0)
                            : FRAMEWORK(generateDiv(className))
                }

                /**
                 * Gets the value of the given property from the given object.
                 * @param obj The object from which the property value shall be got.
                 * @param path The property of which the value shall be got.
                 * @returns {*} Returns the value of the searched property or undefined of the property wasn't found.
                 */
                function getObjectPropVal(obj, path) {
                    var splits = path.split(_strDot);
                    var i = 0;
                    var val;
                    for (; i < splits.length; i++) {
                        if (!obj[LEXICON.hOP](splits[i]))
                            return;
                        val = obj[splits[i]];
                        if (i < splits.length && type(val) == TYPES.o)
                            obj = val;
                    }
                    return val;
                }

                /**
                 * Sets the value of the given property from the given object.
                 * @param obj The object from which the property value shall be set.
                 * @param path The property of which the value shall be set.
                 * @param val The value of the property which shall be set.
                 */
                function setObjectPropVal(obj, path, val) {
                    var splits = path.split(_strDot);
                    var splitsLength = splits.length;
                    var i = 0;
                    var extendObj = {};
                    var extendObjRoot = extendObj;
                    for (; i < splitsLength; i++)
                        extendObj = extendObj[splits[i]] = i + 1 < splitsLength ? {} : val;
                    FRAMEWORK.extend(obj, extendObjRoot, true);
                }

                /**	
                 * Runs a action for each selector inside the updateOnLoad option.	
                 * @param {Function} action The action for each updateOnLoad selector, the arguments the function takes is the index and the value (the selector).	
                 */
                function eachUpdateOnLoad(action) {
                    var updateOnLoad = _currentPreparedOptions.updateOnLoad;
                    updateOnLoad = type(updateOnLoad) == TYPES.s ? updateOnLoad.split(_strSpace) : updateOnLoad;

                    if (COMPATIBILITY.isA(updateOnLoad) && !_destroyed) {
                        each(updateOnLoad, action);
                    }
                }


                //==== Utils Cache ====//

                /**
                 * Compares two values or objects and returns true if they aren't equal.
                 * @param current The first value or object which shall be compared.
                 * @param cache The second value or object which shall be compared.
                 * @param force If true the returned value is always true.
                 * @returns {boolean} True if both values or objects aren't equal or force is true, false otherwise.
                 */
                function checkCache(current, cache, force) {
                    if (force)
                        return force;
                    if (type(current) == TYPES.o && type(cache) == TYPES.o) {
                        for (var prop in current) {
                            if (prop !== 'c') {
                                if (current[LEXICON.hOP](prop) && cache[LEXICON.hOP](prop)) {
                                    if (checkCache(current[prop], cache[prop]))
                                        return true;
                                }
                                else {
                                    return true;
                                }
                            }
                        }
                    }
                    else {
                        return current !== cache;
                    }
                    return false;
                }


                //==== Shortcuts ====//

                /**
                 * jQuery extend method shortcut with a appended "true" as first argument.
                 */
                function extendDeep() {
                    return FRAMEWORK.extend.apply(this, [true].concat([].slice.call(arguments)));
                }

                /**
                 * jQuery addClass method shortcut.
                 */
                function addClass(el, classes) {
                    return _frameworkProto.addClass.call(el, classes);
                }

                /**
                 * jQuery removeClass method shortcut.
                 */
                function removeClass(el, classes) {
                    return _frameworkProto.removeClass.call(el, classes);
                }

                /**
                 * Adds or removes the given classes dependent on the boolean value. True for add, false for remove.
                 */
                function addRemoveClass(el, classes, doAdd) {
                    return doAdd ? addClass(el, classes) : removeClass(el, classes);
                }

                /**
                 * jQuery remove method shortcut.
                 */
                function remove(el) {
                    return _frameworkProto.remove.call(el);
                }

                /**
                 * Finds the first child element with the given selector of the given element.
                 * @param el The root element from which the selector shall be valid.
                 * @param selector The selector of the searched element.
                 * @returns {*} The first element which is a child of the given element and matches the givens selector.
                 */
                function findFirst(el, selector) {
                    return _frameworkProto.find.call(el, selector).eq(0);
                }


                //==== API ====//

                /**
                 * Puts the instance to sleep. It wont respond to any changes in the DOM and won't update. Scrollbar Interactivity is also disabled as well as the resize handle.
                 * This behavior can be reset by calling the update method.
                 */
                _base.sleep = function () {
                    _sleeping = true;
                };

                /**
                 * Updates the plugin and DOM to the current options.
                 * This method should only be called if a update is 100% required.
                 * @param force True if every property shall be updated and the cache shall be ignored.
                 * !INTERNAL USAGE! : force can be a string "auto", "sync" or "zoom" too
                 * if "auto" then before a real update the content size and host element attributes gets checked, and if they changed only then the update method will be called.
                 * if "sync" then the async update process (MutationObserver or UpdateLoop) gets synchronized and a corresponding update takes place if one was needed due to pending changes.
                 * if "zoom" then a update takes place where it's assumed that content and host size changed
                 * @returns {boolean|undefined} 
                 * If force is "sync" then a boolean is returned which indicates whether a update was needed due to pending changes.
                 * If force is "auto" then a boolean is returned whether a update was needed due to attribute or size changes.
                 * undefined otherwise.
                 */
                _base.update = function (force) {
                    if (_destroyed)
                        return;

                    var attrsChanged;
                    var contentSizeC;
                    var isString = type(force) == TYPES.s;
                    var doUpdateAuto;
                    var mutHost;
                    var mutContent;

                    if (isString) {
                        if (force === _strAuto) {
                            attrsChanged = meaningfulAttrsChanged();
                            contentSizeC = updateAutoContentSizeChanged();
                            doUpdateAuto = attrsChanged || contentSizeC;
                            if (doUpdateAuto) {
                                update({
                                    _contentSizeChanged: contentSizeC,
                                    _changedOptions: _initialized ? undefined : _currentPreparedOptions
                                });
                            }
                        }
                        else if (force === _strSync) {
                            if (_mutationObserversConnected) {
                                mutHost = _mutationObserverHostCallback(_mutationObserverHost.takeRecords());
                                mutContent = _mutationObserverContentCallback(_mutationObserverContent.takeRecords());
                            }
                            else {
                                mutHost = _base.update(_strAuto);
                            }
                        }
                        else if (force === 'zoom') {
                            update({
                                _hostSizeChanged: true,
                                _contentSizeChanged: true
                            });
                        }
                    }
                    else {
                        force = _sleeping || force;
                        _sleeping = false;
                        if (!_base.update(_strSync) || force)
                            update({ _force: force });
                    }

                    updateElementsOnLoad();

                    return doUpdateAuto || mutHost || mutContent;
                };

                /**
                 Gets or sets the current options. The update method will be called automatically if new options were set.
                 * @param newOptions If new options are given, then the new options will be set, if new options aren't given (undefined or a not a plain object) then the current options will be returned.
                 * @param value If new options is a property path string, then this value will be used to set the option to which the property path string leads.
                 * @returns {*}
                 */
                _base.options = function (newOptions, value) {
                    var option = {};
                    var changedOps;

                    //return current options if newOptions are undefined or empty
                    if (FRAMEWORK.isEmptyObject(newOptions) || !FRAMEWORK.isPlainObject(newOptions)) {
                        if (type(newOptions) == TYPES.s) {
                            if (arguments.length > 1) {
                                setObjectPropVal(option, newOptions, value);
                                changedOps = setOptions(option);
                            }
                            else
                                return getObjectPropVal(_currentOptions, newOptions);
                        }
                        else
                            return _currentOptions;
                    }
                    else {
                        changedOps = setOptions(newOptions);
                    }

                    if (!FRAMEWORK.isEmptyObject(changedOps)) {
                        update({ _changedOptions: changedOps });
                    }
                };

                /**
                 * Restore the DOM, disconnects all observers, remove all resize observers and put the instance to sleep.
                 */
                _base.destroy = function () {
                    if (_destroyed)
                        return;

                    //remove this instance from auto update loop
                    autoUpdateLoop.remove(_base);

                    //disconnect all mutation observers
                    disconnectMutationObservers();

                    //remove all resize observers
                    setupResizeObserver(_sizeObserverElement);
                    setupResizeObserver(_sizeAutoObserverElement);

                    //remove all extensions
                    for (var extName in _extensions)
                        _base.removeExt(extName);

                    //remove all 'destroy' events
                    while (_destroyEvents[LEXICON.l] > 0)
                        _destroyEvents.pop()();

                    //remove all events from host element
                    setupHostMouseTouchEvents(true);

                    //remove all helper / detection elements
                    if (_contentGlueElement)
                        remove(_contentGlueElement);
                    if (_contentArrangeElement)
                        remove(_contentArrangeElement);
                    if (_sizeAutoObserverAdded)
                        remove(_sizeAutoObserverElement);

                    //remove all generated DOM
                    setupScrollbarsDOM(true);
                    setupScrollbarCornerDOM(true);
                    setupStructureDOM(true);

                    //remove all generated image load events
                    for (var i = 0; i < _updateOnLoadElms[LEXICON.l]; i++)
                        FRAMEWORK(_updateOnLoadElms[i]).off(_updateOnLoadEventName, updateOnLoadCallback);
                    _updateOnLoadElms = undefined;

                    _destroyed = true;
                    _sleeping = true;

                    //remove this instance from the instances list
                    INSTANCES(pluginTargetElement, 0);
                    dispatchCallback('onDestroyed');

                    //remove all properties and methods
                    //for (var property in _base)
                    //    delete _base[property];
                    //_base = undefined;
                };

                /**
                 * Scrolls to a given position or element.
                 * @param coordinates
                 * 1. Can be "coordinates" which looks like:
                 *    { x : ?, y : ? } OR          Object with x and y properties
                 *    { left : ?, top : ? } OR     Object with left and top properties
                 *    { l : ?, t : ? } OR          Object with l and t properties
                 *    [ ?, ? ] OR                  Array where the first two element are the coordinates (first is x, second is y)
                 *    ?                            A single value which stays for both axis
                 *    A value can be a number, a string or a calculation.
                 *
                 *    Operators:
                 *    [NONE]  The current scroll will be overwritten by the value.
                 *    '+='    The value will be added to the current scroll offset
                 *    '-='    The value will be subtracted from the current scroll offset
                 *    '*='    The current scroll wil be multiplicated by the value.
                 *    '/='    The current scroll wil be divided by the value.
                 *
                 *    Units:
                 *    [NONE]  The value is the final scroll amount.                   final = (value * 1)
                 *    'px'    Same as none
                 *    '%'     The value is dependent on the current scroll value.     final = ((currentScrollValue / 100) * value)
                 *    'vw'    The value is multiplicated by the viewport width.       final = (value * viewportWidth)
                 *    'vh'    The value is multiplicated by the viewport height.      final = (value * viewportHeight)
                 *
                 *    example final values:
                 *    200, '200px', '50%', '1vw', '1vh', '+=200', '/=1vw', '*=2px', '-=5vh', '+=33%', '+= 50% - 2px', '-= 1vw - 50%'
                 *
                 * 2. Can be a HTML or jQuery element:
                 *    The final scroll offset is the offset (without margin) of the given HTML / jQuery element.
                 *
                 * 3. Can be a object with a HTML or jQuery element with additional settings:
                 *    {
                 *      el : [HTMLElement, jQuery element],             MUST be specified, else this object isn't valid.
                 *      scroll : [string, array, object],               Default value is 'always'.
                 *      block : [string, array, object],                Default value is 'begin'.
                 *      margin : [number, boolean, array, object]       Default value is false.
                 *    }
                 *
                 *    Possible scroll settings are:
                 *    'always'      Scrolls always.
                 *    'ifneeded'    Scrolls only if the element isnt fully in view.
                 *    'never'       Scrolls never.
                 *
                 *    Possible block settings are:
                 *    'begin'   Both axis shall be docked to the "begin" edge. - The element will be docked to the top and left edge of the viewport.
                 *    'end'     Both axis shall be docked to the "end" edge. - The element will be docked to the bottom and right edge of the viewport. (If direction is RTL to the bottom and left edge.)
                 *    'center'  Both axis shall be docked to "center". - The element will be centered in the viewport.
                 *    'nearest' The element will be docked to the nearest edge(s).
                 *
                 *    Possible margin settings are: -- The actual margin of the element wont be affect, this option affects only the final scroll offset.
                 *    [BOOLEAN]                                         If true the css margin of the element will be used, if false no margin will be used.
                 *    [NUMBER]                                          The margin will be used for all edges.
                 *
                 * @param duration The duration of the scroll animation, OR a jQuery animation configuration object.
                 * @param easing The animation easing.
                 * @param complete The animation complete callback.
                 * @returns {{
                 *   position: {x: number, y: number},
                 *   ratio: {x: number, y: number},
                 *   max: {x: number, y: number},
                 *   handleOffset: {x: number, y: number},
                 *   handleLength: {x: number, y: number},
                 *   handleLengthRatio: {x: number, y: number}, t
                 *   rackLength: {x: number, y: number},
                 *   isRTL: boolean,
                 *   isRTLNormalized: boolean
                 *  }}
                 */
                _base.scroll = function (coordinates, duration, easing, complete) {
                    if (arguments.length === 0 || coordinates === undefined) {
                        var infoX = _scrollHorizontalInfo;
                        var infoY = _scrollVerticalInfo;
                        var normalizeInvert = _normalizeRTLCache && _isRTL && _rtlScrollBehavior.i;
                        var normalizeNegate = _normalizeRTLCache && _isRTL && _rtlScrollBehavior.n;
                        var scrollX = infoX._currentScroll;
                        var scrollXRatio = infoX._currentScrollRatio;
                        var maxScrollX = infoX._maxScroll;
                        scrollXRatio = normalizeInvert ? 1 - scrollXRatio : scrollXRatio;
                        scrollX = normalizeInvert ? maxScrollX - scrollX : scrollX;
                        scrollX *= normalizeNegate ? -1 : 1;
                        maxScrollX *= normalizeNegate ? -1 : 1;

                        return {
                            position: {
                                x: scrollX,
                                y: infoY._currentScroll
                            },
                            ratio: {
                                x: scrollXRatio,
                                y: infoY._currentScrollRatio
                            },
                            max: {
                                x: maxScrollX,
                                y: infoY._maxScroll
                            },
                            handleOffset: {
                                x: infoX._handleOffset,
                                y: infoY._handleOffset
                            },
                            handleLength: {
                                x: infoX._handleLength,
                                y: infoY._handleLength
                            },
                            handleLengthRatio: {
                                x: infoX._handleLengthRatio,
                                y: infoY._handleLengthRatio
                            },
                            trackLength: {
                                x: infoX._trackLength,
                                y: infoY._trackLength
                            },
                            snappedHandleOffset: {
                                x: infoX._snappedHandleOffset,
                                y: infoY._snappedHandleOffset
                            },
                            isRTL: _isRTL,
                            isRTLNormalized: _normalizeRTLCache
                        };
                    }

                    _base.update(_strSync);

                    var normalizeRTL = _normalizeRTLCache;
                    var coordinatesXAxisProps = [_strX, _strLeft, 'l'];
                    var coordinatesYAxisProps = [_strY, _strTop, 't'];
                    var coordinatesOperators = ['+=', '-=', '*=', '/='];
                    var durationIsObject = type(duration) == TYPES.o;
                    var completeCallback = durationIsObject ? duration.complete : complete;
                    var i;
                    var finalScroll = {};
                    var specialEasing = {};
                    var doScrollLeft;
                    var doScrollTop;
                    var animationOptions;
                    var strEnd = 'end';
                    var strBegin = 'begin';
                    var strCenter = 'center';
                    var strNearest = 'nearest';
                    var strAlways = 'always';
                    var strNever = 'never';
                    var strIfNeeded = 'ifneeded';
                    var strLength = LEXICON.l;
                    var settingsAxis;
                    var settingsScroll;
                    var settingsBlock;
                    var settingsMargin;
                    var finalElement;
                    var elementObjSettingsAxisValues = [_strX, _strY, 'xy', 'yx'];
                    var elementObjSettingsBlockValues = [strBegin, strEnd, strCenter, strNearest];
                    var elementObjSettingsScrollValues = [strAlways, strNever, strIfNeeded];
                    var coordinatesIsElementObj = coordinates[LEXICON.hOP]('el');
                    var possibleElement = coordinatesIsElementObj ? coordinates.el : coordinates;
                    var possibleElementIsJQuery = possibleElement instanceof FRAMEWORK || JQUERY ? possibleElement instanceof JQUERY : false;
                    var possibleElementIsHTMLElement = possibleElementIsJQuery ? false : isHTMLElement(possibleElement);
                    var updateScrollbarInfos = function () {
                        if (doScrollLeft)
                            refreshScrollbarHandleOffset(true);
                        if (doScrollTop)
                            refreshScrollbarHandleOffset(false);
                    };
                    var proxyCompleteCallback = type(completeCallback) != TYPES.f ? undefined : function () {
                        updateScrollbarInfos();
                        completeCallback();
                    };
                    function checkSettingsStringValue(currValue, allowedValues) {
                        for (i = 0; i < allowedValues[strLength]; i++) {
                            if (currValue === allowedValues[i])
                                return true;
                        }
                        return false;
                    }
                    function getRawScroll(isX, coordinates) {
                        var coordinateProps = isX ? coordinatesXAxisProps : coordinatesYAxisProps;
                        coordinates = type(coordinates) == TYPES.s || type(coordinates) == TYPES.n ? [coordinates, coordinates] : coordinates;

                        if (COMPATIBILITY.isA(coordinates))
                            return isX ? coordinates[0] : coordinates[1];
                        else if (type(coordinates) == TYPES.o) {
                            //decides RTL normalization "hack" with .n
                            //normalizeRTL = type(coordinates.n) == TYPES.b ? coordinates.n : normalizeRTL; 
                            for (i = 0; i < coordinateProps[strLength]; i++)
                                if (coordinateProps[i] in coordinates)
                                    return coordinates[coordinateProps[i]];
                        }
                    }
                    function getFinalScroll(isX, rawScroll) {
                        var isString = type(rawScroll) == TYPES.s;
                        var operator;
                        var amount;
                        var scrollInfo = isX ? _scrollHorizontalInfo : _scrollVerticalInfo;
                        var currScroll = scrollInfo._currentScroll;
                        var maxScroll = scrollInfo._maxScroll;
                        var mult = ' * ';
                        var finalValue;
                        var isRTLisX = _isRTL && isX;
                        var normalizeShortcuts = isRTLisX && _rtlScrollBehavior.n && !normalizeRTL;
                        var strReplace = 'replace';
                        var evalFunc = eval;
                        var possibleOperator;
                        if (isString) {
                            //check operator
                            if (rawScroll[strLength] > 2) {
                                possibleOperator = rawScroll.substr(0, 2);
                                if (inArray(possibleOperator, coordinatesOperators) > -1)
                                    operator = possibleOperator;
                            }

                            //calculate units and shortcuts
                            rawScroll = operator ? rawScroll.substr(2) : rawScroll;
                            rawScroll = rawScroll
                            [strReplace](/min/g, 0) //'min' = 0%
                            [strReplace](/</g, 0)   //'<'   = 0%
                            [strReplace](/max/g, (normalizeShortcuts ? '-' : _strEmpty) + _strHundredPercent)    //'max' = 100%
                            [strReplace](/>/g, (normalizeShortcuts ? '-' : _strEmpty) + _strHundredPercent)      //'>'   = 100%
                            [strReplace](/px/g, _strEmpty)
                            [strReplace](/%/g, mult + (maxScroll * (isRTLisX && _rtlScrollBehavior.n ? -1 : 1) / 100.0))
                            [strReplace](/vw/g, mult + _viewportSize.w)
                            [strReplace](/vh/g, mult + _viewportSize.h);
                            amount = parseToZeroOrNumber(isNaN(rawScroll) ? parseToZeroOrNumber(evalFunc(rawScroll), true).toFixed() : rawScroll);
                        }
                        else {
                            amount = rawScroll;
                        }

                        if (amount !== undefined && !isNaN(amount) && type(amount) == TYPES.n) {
                            var normalizeIsRTLisX = normalizeRTL && isRTLisX;
                            var operatorCurrScroll = currScroll * (normalizeIsRTLisX && _rtlScrollBehavior.n ? -1 : 1);
                            var invert = normalizeIsRTLisX && _rtlScrollBehavior.i;
                            var negate = normalizeIsRTLisX && _rtlScrollBehavior.n;
                            operatorCurrScroll = invert ? (maxScroll - operatorCurrScroll) : operatorCurrScroll;
                            switch (operator) {
                                case '+=':
                                    finalValue = operatorCurrScroll + amount;
                                    break;
                                case '-=':
                                    finalValue = operatorCurrScroll - amount;
                                    break;
                                case '*=':
                                    finalValue = operatorCurrScroll * amount;
                                    break;
                                case '/=':
                                    finalValue = operatorCurrScroll / amount;
                                    break;
                                default:
                                    finalValue = amount;
                                    break;
                            }
                            finalValue = invert ? maxScroll - finalValue : finalValue;
                            finalValue *= negate ? -1 : 1;
                            finalValue = isRTLisX && _rtlScrollBehavior.n ? MATH.min(0, MATH.max(maxScroll, finalValue)) : MATH.max(0, MATH.min(maxScroll, finalValue));
                        }
                        return finalValue === currScroll ? undefined : finalValue;
                    }
                    function getPerAxisValue(value, valueInternalType, defaultValue, allowedValues) {
                        var resultDefault = [defaultValue, defaultValue];
                        var valueType = type(value);
                        var valueArrLength;
                        var valueArrItem;

                        //value can be [ string, or array of two strings ]
                        if (valueType == valueInternalType) {
                            value = [value, value];
                        }
                        else if (valueType == TYPES.a) {
                            valueArrLength = value[strLength];
                            if (valueArrLength > 2 || valueArrLength < 1)
                                value = resultDefault;
                            else {
                                if (valueArrLength === 1)
                                    value[1] = defaultValue;
                                for (i = 0; i < valueArrLength; i++) {
                                    valueArrItem = value[i];
                                    if (type(valueArrItem) != valueInternalType || !checkSettingsStringValue(valueArrItem, allowedValues)) {
                                        value = resultDefault;
                                        break;
                                    }
                                }
                            }
                        }
                        else if (valueType == TYPES.o)
                            value = [value[_strX] || defaultValue, value[_strY] || defaultValue];
                        else
                            value = resultDefault;
                        return { x: value[0], y: value[1] };
                    }
                    function generateMargin(marginTopRightBottomLeftArray) {
                        var result = [];
                        var currValue;
                        var currValueType;
                        var valueDirections = [_strTop, _strRight, _strBottom, _strLeft];
                        for (i = 0; i < marginTopRightBottomLeftArray[strLength]; i++) {
                            if (i === valueDirections[strLength])
                                break;
                            currValue = marginTopRightBottomLeftArray[i];
                            currValueType = type(currValue);
                            if (currValueType == TYPES.b)
                                result.push(currValue ? parseToZeroOrNumber(finalElement.css(_strMarginMinus + valueDirections[i])) : 0);
                            else
                                result.push(currValueType == TYPES.n ? currValue : 0);
                        }
                        return result;
                    }

                    if (possibleElementIsJQuery || possibleElementIsHTMLElement) {
                        //get settings
                        var margin = coordinatesIsElementObj ? coordinates.margin : 0;
                        var axis = coordinatesIsElementObj ? coordinates.axis : 0;
                        var scroll = coordinatesIsElementObj ? coordinates.scroll : 0;
                        var block = coordinatesIsElementObj ? coordinates.block : 0;
                        var marginDefault = [0, 0, 0, 0];
                        var marginType = type(margin);
                        var marginLength;
                        finalElement = possibleElementIsJQuery ? possibleElement : FRAMEWORK(possibleElement);

                        if (finalElement[strLength] > 0) {
                            //margin can be [ boolean, number, array of 2, array of 4, object ]
                            if (marginType == TYPES.n || marginType == TYPES.b)
                                margin = generateMargin([margin, margin, margin, margin]);
                            else if (marginType == TYPES.a) {
                                marginLength = margin[strLength];
                                if (marginLength === 2)
                                    margin = generateMargin([margin[0], margin[1], margin[0], margin[1]]);
                                else if (marginLength >= 4)
                                    margin = generateMargin(margin);
                                else
                                    margin = marginDefault;
                            }
                            else if (marginType == TYPES.o)
                                margin = generateMargin([margin[_strTop], margin[_strRight], margin[_strBottom], margin[_strLeft]]);
                            else
                                margin = marginDefault;

                            //block = type(block) === TYPES.b ? block ? [ strNearest, strBegin ] : [ strNearest, strEnd ] : block;
                            settingsAxis = checkSettingsStringValue(axis, elementObjSettingsAxisValues) ? axis : 'xy';
                            settingsScroll = getPerAxisValue(scroll, TYPES.s, strAlways, elementObjSettingsScrollValues);
                            settingsBlock = getPerAxisValue(block, TYPES.s, strBegin, elementObjSettingsBlockValues);
                            settingsMargin = margin;

                            var viewportScroll = {
                                l: _scrollHorizontalInfo._currentScroll,
                                t: _scrollVerticalInfo._currentScroll
                            };
                            // use padding element instead of viewport element because padding element has never padding, margin or position applied.
                            var viewportOffset = _paddingElement.offset();

                            //get coordinates
                            var elementOffset = finalElement.offset();
                            var doNotScroll = {
                                x: settingsScroll.x == strNever || settingsAxis == _strY,
                                y: settingsScroll.y == strNever || settingsAxis == _strX
                            };
                            elementOffset[_strTop] -= settingsMargin[0];
                            elementOffset[_strLeft] -= settingsMargin[3];
                            var elementScrollCoordinates = {
                                x: MATH.round(elementOffset[_strLeft] - viewportOffset[_strLeft] + viewportScroll.l),
                                y: MATH.round(elementOffset[_strTop] - viewportOffset[_strTop] + viewportScroll.t)
                            };
                            if (_isRTL) {
                                if (!_rtlScrollBehavior.n && !_rtlScrollBehavior.i)
                                    elementScrollCoordinates.x = MATH.round(viewportOffset[_strLeft] - elementOffset[_strLeft] + viewportScroll.l);
                                if (_rtlScrollBehavior.n && normalizeRTL)
                                    elementScrollCoordinates.x *= -1;
                                if (_rtlScrollBehavior.i && normalizeRTL)
                                    elementScrollCoordinates.x = MATH.round(viewportOffset[_strLeft] - elementOffset[_strLeft] + (_scrollHorizontalInfo._maxScroll - viewportScroll.l));
                            }

                            //measuring is required
                            if (settingsBlock.x != strBegin || settingsBlock.y != strBegin || settingsScroll.x == strIfNeeded || settingsScroll.y == strIfNeeded || _isRTL) {
                                var measuringElm = finalElement[0];
                                var rawElementSize = _supportTransform ? measuringElm[LEXICON.bCR]() : {
                                    width: measuringElm[LEXICON.oW],
                                    height: measuringElm[LEXICON.oH]
                                };
                                var elementSize = {
                                    w: rawElementSize[_strWidth] + settingsMargin[3] + settingsMargin[1],
                                    h: rawElementSize[_strHeight] + settingsMargin[0] + settingsMargin[2]
                                };
                                var finalizeBlock = function (isX) {
                                    var vars = getScrollbarVars(isX);
                                    var wh = vars._w_h;
                                    var lt = vars._left_top;
                                    var xy = vars._x_y;
                                    var blockIsEnd = settingsBlock[xy] == (isX ? _isRTL ? strBegin : strEnd : strEnd);
                                    var blockIsCenter = settingsBlock[xy] == strCenter;
                                    var blockIsNearest = settingsBlock[xy] == strNearest;
                                    var scrollNever = settingsScroll[xy] == strNever;
                                    var scrollIfNeeded = settingsScroll[xy] == strIfNeeded;
                                    var vpSize = _viewportSize[wh];
                                    var vpOffset = viewportOffset[lt];
                                    var elSize = elementSize[wh];
                                    var elOffset = elementOffset[lt];
                                    var divide = blockIsCenter ? 2 : 1;
                                    var elementCenterOffset = elOffset + (elSize / 2);
                                    var viewportCenterOffset = vpOffset + (vpSize / 2);
                                    var isInView =
                                        elSize <= vpSize
                                        && elOffset >= vpOffset
                                        && elOffset + elSize <= vpOffset + vpSize;

                                    if (scrollNever)
                                        doNotScroll[xy] = true;
                                    else if (!doNotScroll[xy]) {
                                        if (blockIsNearest || scrollIfNeeded) {
                                            doNotScroll[xy] = scrollIfNeeded ? isInView : false;
                                            blockIsEnd = elSize < vpSize ? elementCenterOffset > viewportCenterOffset : elementCenterOffset < viewportCenterOffset;
                                        }
                                        elementScrollCoordinates[xy] -= blockIsEnd || blockIsCenter ? ((vpSize / divide) - (elSize / divide)) * (isX && _isRTL && normalizeRTL ? -1 : 1) : 0;
                                    }
                                };
                                finalizeBlock(true);
                                finalizeBlock(false);
                            }

                            if (doNotScroll.y)
                                delete elementScrollCoordinates.y;
                            if (doNotScroll.x)
                                delete elementScrollCoordinates.x;

                            coordinates = elementScrollCoordinates;
                        }
                    }

                    finalScroll[_strScrollLeft] = getFinalScroll(true, getRawScroll(true, coordinates));
                    finalScroll[_strScrollTop] = getFinalScroll(false, getRawScroll(false, coordinates));
                    doScrollLeft = finalScroll[_strScrollLeft] !== undefined;
                    doScrollTop = finalScroll[_strScrollTop] !== undefined;

                    if ((doScrollLeft || doScrollTop) && (duration > 0 || durationIsObject)) {
                        if (durationIsObject) {
                            duration.complete = proxyCompleteCallback;
                            _viewportElement.animate(finalScroll, duration);
                        }
                        else {
                            animationOptions = {
                                duration: duration,
                                complete: proxyCompleteCallback
                            };
                            if (COMPATIBILITY.isA(easing) || FRAMEWORK.isPlainObject(easing)) {
                                specialEasing[_strScrollLeft] = easing[0] || easing.x;
                                specialEasing[_strScrollTop] = easing[1] || easing.y;
                                animationOptions.specialEasing = specialEasing;
                            }
                            else {
                                animationOptions.easing = easing;
                            }
                            _viewportElement.animate(finalScroll, animationOptions);
                        }
                    }
                    else {
                        if (doScrollLeft)
                            _viewportElement[_strScrollLeft](finalScroll[_strScrollLeft]);
                        if (doScrollTop)
                            _viewportElement[_strScrollTop](finalScroll[_strScrollTop]);
                        updateScrollbarInfos();
                    }
                };

                /**
                 * Stops all scroll animations.
                 * @returns {*} The current OverlayScrollbars instance (for chaining).
                 */
                _base.scrollStop = function (param1, param2, param3) {
                    _viewportElement.stop(param1, param2, param3);
                    return _base;
                };

                /**
                 * Returns all relevant elements.
                 * @param elementName The name of the element which shall be returned.
                 * @returns {{target: *, host: *, padding: *, viewport: *, content: *, scrollbarHorizontal: {scrollbar: *, track: *, handle: *}, scrollbarVertical: {scrollbar: *, track: *, handle: *}, scrollbarCorner: *} | *}
                 */
                _base.getElements = function (elementName) {
                    var obj = {
                        target: _targetElementNative,
                        host: _hostElementNative,
                        padding: _paddingElementNative,
                        viewport: _viewportElementNative,
                        content: _contentElementNative,
                        scrollbarHorizontal: {
                            scrollbar: _scrollbarHorizontalElement[0],
                            track: _scrollbarHorizontalTrackElement[0],
                            handle: _scrollbarHorizontalHandleElement[0]
                        },
                        scrollbarVertical: {
                            scrollbar: _scrollbarVerticalElement[0],
                            track: _scrollbarVerticalTrackElement[0],
                            handle: _scrollbarVerticalHandleElement[0]
                        },
                        scrollbarCorner: _scrollbarCornerElement[0]
                    };
                    return type(elementName) == TYPES.s ? getObjectPropVal(obj, elementName) : obj;
                };

                /**
                 * Returns a object which describes the current state of this instance.
                 * @param stateProperty A specific property from the state object which shall be returned.
                 * @returns {{widthAuto, heightAuto, overflowAmount, hideOverflow, hasOverflow, contentScrollSize, viewportSize, hostSize, autoUpdate} | *}
                 */
                _base.getState = function (stateProperty) {
                    function prepare(obj) {
                        if (!FRAMEWORK.isPlainObject(obj))
                            return obj;
                        var extended = extendDeep({}, obj);
                        var changePropertyName = function (from, to) {
                            if (extended[LEXICON.hOP](from)) {
                                extended[to] = extended[from];
                                delete extended[from];
                            }
                        };
                        changePropertyName('w', _strWidth); //change w to width
                        changePropertyName('h', _strHeight); //change h to height
                        delete extended.c; //delete c (the 'changed' prop)
                        return extended;
                    };
                    var obj = {
                        destroyed: !!prepare(_destroyed),
                        sleeping: !!prepare(_sleeping),
                        autoUpdate: prepare(!_mutationObserversConnected),
                        widthAuto: prepare(_widthAutoCache),
                        heightAuto: prepare(_heightAutoCache),
                        padding: prepare(_cssPaddingCache),
                        overflowAmount: prepare(_overflowAmountCache),
                        hideOverflow: prepare(_hideOverflowCache),
                        hasOverflow: prepare(_hasOverflowCache),
                        contentScrollSize: prepare(_contentScrollSizeCache),
                        viewportSize: prepare(_viewportSize),
                        hostSize: prepare(_hostSizeCache),
                        documentMixed: prepare(_documentMixed)
                    };
                    return type(stateProperty) == TYPES.s ? getObjectPropVal(obj, stateProperty) : obj;
                };

                /**
                 * Gets all or specific extension instance.
                 * @param extName The name of the extension from which the instance shall be got.
                 * @returns {{}} The instance of the extension with the given name or undefined if the instance couldn't be found.
                 */
                _base.ext = function (extName) {
                    var result;
                    var privateMethods = _extensionsPrivateMethods.split(' ');
                    var i = 0;
                    if (type(extName) == TYPES.s) {
                        if (_extensions[LEXICON.hOP](extName)) {
                            result = extendDeep({}, _extensions[extName]);
                            for (; i < privateMethods.length; i++)
                                delete result[privateMethods[i]];
                        }
                    }
                    else {
                        result = {};
                        for (i in _extensions)
                            result[i] = extendDeep({}, _base.ext(i));
                    }
                    return result;
                };

                /**
                 * Adds a extension to this instance.
                 * @param extName The name of the extension which shall be added.
                 * @param extensionOptions The extension options which shall be used.
                 * @returns {{}} The instance of the added extension or undefined if the extension couldn't be added properly.
                 */
                _base.addExt = function (extName, extensionOptions) {
                    var registeredExtensionObj = _plugin.extension(extName);
                    var instance;
                    var instanceAdded;
                    var instanceContract;
                    var contractResult;
                    var contractFulfilled = true;
                    if (registeredExtensionObj) {
                        if (!_extensions[LEXICON.hOP](extName)) {
                            instance = registeredExtensionObj.extensionFactory.call(_base,
                                extendDeep({}, registeredExtensionObj.defaultOptions),
                                FRAMEWORK,
                                COMPATIBILITY);

                            if (instance) {
                                instanceContract = instance.contract;
                                if (type(instanceContract) == TYPES.f) {
                                    contractResult = instanceContract(window);
                                    contractFulfilled = type(contractResult) == TYPES.b ? contractResult : contractFulfilled;
                                }
                                if (contractFulfilled) {
                                    _extensions[extName] = instance;
                                    instanceAdded = instance.added;
                                    if (type(instanceAdded) == TYPES.f)
                                        instanceAdded(extensionOptions);

                                    return _base.ext(extName);
                                }
                            }
                        }
                        else
                            return _base.ext(extName);
                    }
                    else
                        console.warn("A extension with the name \"" + extName + "\" isn't registered.");
                };

                /**
                 * Removes a extension from this instance.
                 * @param extName The name of the extension which shall be removed.
                 * @returns {boolean} True if the extension was removed, false otherwise e.g. if the extension wasn't added before.
                 */
                _base.removeExt = function (extName) {
                    var instance = _extensions[extName];
                    var instanceRemoved;
                    if (instance) {
                        delete _extensions[extName];

                        instanceRemoved = instance.removed;
                        if (type(instanceRemoved) == TYPES.f)
                            instanceRemoved();

                        return true;
                    }
                    return false;
                };

                /**
                 * Constructs the plugin.
                 * @param targetElement The element to which the plugin shall be applied.
                 * @param options The initial options of the plugin.
                 * @param extensions The extension(s) which shall be added right after the initialization.
                 * @returns {boolean} True if the plugin was successfully initialized, false otherwise.
                 */
                function construct(targetElement, options, extensions) {
                    _defaultOptions = globals.defaultOptions;
                    _nativeScrollbarStyling = globals.nativeScrollbarStyling;
                    _nativeScrollbarSize = extendDeep({}, globals.nativeScrollbarSize);
                    _nativeScrollbarIsOverlaid = extendDeep({}, globals.nativeScrollbarIsOverlaid);
                    _overlayScrollbarDummySize = extendDeep({}, globals.overlayScrollbarDummySize);
                    _rtlScrollBehavior = extendDeep({}, globals.rtlScrollBehavior);

                    //parse & set options but don't update
                    setOptions(extendDeep({}, _defaultOptions, options));

                    _cssCalc = globals.cssCalc;
                    _msieVersion = globals.msie;
                    _autoUpdateRecommended = globals.autoUpdateRecommended;
                    _supportTransition = globals.supportTransition;
                    _supportTransform = globals.supportTransform;
                    _supportPassiveEvents = globals.supportPassiveEvents;
                    _supportResizeObserver = globals.supportResizeObserver;
                    _supportMutationObserver = globals.supportMutationObserver;
                    _restrictedMeasuring = globals.restrictedMeasuring;
                    _documentElement = FRAMEWORK(targetElement.ownerDocument);
                    _documentElementNative = _documentElement[0];
                    _windowElement = FRAMEWORK(_documentElementNative.defaultView || _documentElementNative.parentWindow);
                    _windowElementNative = _windowElement[0];
                    _htmlElement = findFirst(_documentElement, 'html');
                    _bodyElement = findFirst(_htmlElement, 'body');
                    _targetElement = FRAMEWORK(targetElement);
                    _targetElementNative = _targetElement[0];
                    _isTextarea = _targetElement.is('textarea');
                    _isBody = _targetElement.is('body');
                    _documentMixed = _documentElementNative !== document;

                    /* On a div Element The if checks only whether:
                     * - the targetElement has the class "os-host"
                     * - the targetElement has a a child with the class "os-padding"
                     * 
                     * If that's the case, its assumed the DOM has already the following structure:
                     * (The ".os-host" element is the targetElement)
                     *
                     *  <div class="os-host">
                     *      <div class="os-resize-observer-host"></div>
                     *      <div class="os-padding">
                     *          <div class="os-viewport">
                     *              <div class="os-content"></div>
                     *          </div>
                     *      </div>
                     *      <div class="os-scrollbar os-scrollbar-horizontal ">
                     *          <div class="os-scrollbar-track">
                     *              <div class="os-scrollbar-handle"></div>
                     *          </div>
                     *      </div>
                     *      <div class="os-scrollbar os-scrollbar-vertical">
                     *          <div class="os-scrollbar-track">
                     *              <div class="os-scrollbar-handle"></div>
                     *          </div>
                     *      </div>
                     *      <div class="os-scrollbar-corner"></div>
                     *  </div>
                     *
                     * =====================================================================================
                     * 
                     * On a Textarea Element The if checks only whether:
                     * - the targetElement has the class "os-textarea" 
                     * - the targetElement is inside a element with the class "os-content" 
                     * 
                     * If that's the case, its assumed the DOM has already the following structure:
                     * (The ".os-textarea" (textarea) element is the targetElement)
                     *
                     *  <div class="os-host-textarea">
                     *      <div class="os-resize-observer-host"></div>
                     *      <div class="os-padding os-text-inherit">
                     *          <div class="os-viewport os-text-inherit">
                     *              <div class="os-content os-text-inherit">
                     *                  <div class="os-textarea-cover"></div>
                     *                  <textarea class="os-textarea os-text-inherit"></textarea>
                     *              </div>
                     *          </div>
                     *      </div>
                     *      <div class="os-scrollbar os-scrollbar-horizontal ">
                     *          <div class="os-scrollbar-track">
                     *              <div class="os-scrollbar-handle"></div>
                     *          </div>
                     *      </div>
                     *      <div class="os-scrollbar os-scrollbar-vertical">
                     *          <div class="os-scrollbar-track">
                     *              <div class="os-scrollbar-handle"></div>
                     *          </div>
                     *      </div>
                     *      <div class="os-scrollbar-corner"></div>
                     *  </div>
                     */
                    _domExists = _isTextarea
                        ? _targetElement.hasClass(_classNameTextareaElement) && _targetElement.parent().hasClass(_classNameContentElement)
                        : _targetElement.hasClass(_classNameHostElement) && _targetElement.children(_strDot + _classNamePaddingElement)[LEXICON.l];

                    var initBodyScroll;
                    var bodyMouseTouchDownListener;

                    //check if the plugin hasn't to be initialized
                    if (_nativeScrollbarIsOverlaid.x && _nativeScrollbarIsOverlaid.y && !_currentPreparedOptions.nativeScrollbarsOverlaid.initialize) {
                        _initialized = true; // workaround so the onInitializationWithdrawn callback below is fired
                        dispatchCallback('onInitializationWithdrawn');
                        if (_domExists) {
                            setupStructureDOM(true);
                            setupScrollbarsDOM(true);
                            setupScrollbarCornerDOM(true);
                        }

                        _initialized = false;
                        _destroyed = true;
                        _sleeping = true;

                        return _base;
                    }

                    if (_isBody) {
                        initBodyScroll = {};
                        initBodyScroll.l = MATH.max(_targetElement[_strScrollLeft](), _htmlElement[_strScrollLeft](), _windowElement[_strScrollLeft]());
                        initBodyScroll.t = MATH.max(_targetElement[_strScrollTop](), _htmlElement[_strScrollTop](), _windowElement[_strScrollTop]());

                        bodyMouseTouchDownListener = function () {
                            _viewportElement.removeAttr(LEXICON.ti);
                            setupResponsiveEventListener(_viewportElement, _strMouseTouchDownEvent, bodyMouseTouchDownListener, true, true);
                        }
                    }

                    //build OverlayScrollbars DOM
                    setupStructureDOM();
                    setupScrollbarsDOM();
                    setupScrollbarCornerDOM();

                    //create OverlayScrollbars events
                    setupStructureEvents();
                    setupScrollbarEvents(true);
                    setupScrollbarEvents(false);
                    setupScrollbarCornerEvents();

                    //create mutation observers
                    createMutationObservers();

                    //build resize observer for the host element
                    setupResizeObserver(_sizeObserverElement, hostOnResized);

                    if (_isBody) {
                        //apply the body scroll to handle it right in the update method
                        _viewportElement[_strScrollLeft](initBodyScroll.l)[_strScrollTop](initBodyScroll.t);

                        //set the focus on the viewport element so you dont have to click on the page to use keyboard keys (up / down / space) for scrolling
                        if (document.activeElement == targetElement && _viewportElementNative.focus) {
                            //set a tabindex to make the viewportElement focusable
                            _viewportElement.attr(LEXICON.ti, '-1');
                            _viewportElementNative.focus();

                            /* the tabindex has to be removed due to;
                             * If you set the tabindex attribute on an <div>, then its child content cannot be scrolled with the arrow keys unless you set tabindex on the content, too
                             * https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/tabindex
                             */
                            setupResponsiveEventListener(_viewportElement, _strMouseTouchDownEvent, bodyMouseTouchDownListener, false, true);
                        }
                    }

                    //update for the first time & initialize cache
                    _base.update(_strAuto);

                    //the plugin is initialized now!
                    _initialized = true;
                    dispatchCallback('onInitialized');

                    //call all callbacks which would fire before the initialized was complete
                    each(_callbacksInitQeueue, function (index, value) { dispatchCallback(value.n, value.a); });
                    _callbacksInitQeueue = [];

                    //add extensions
                    if (type(extensions) == TYPES.s)
                        extensions = [extensions];
                    if (COMPATIBILITY.isA(extensions))
                        each(extensions, function (index, value) { _base.addExt(value); });
                    else if (FRAMEWORK.isPlainObject(extensions))
                        each(extensions, function (key, value) { _base.addExt(key, value); });

                    //add the transition class for transitions AFTER the first update & AFTER the applied extensions (for preventing unwanted transitions)
                    setTimeout(function () {
                        if (_supportTransition && !_destroyed)
                            addClass(_hostElement, _classNameHostTransition);
                    }, 333);

                    return _base;
                }

                if (_plugin.valid(construct(pluginTargetElement, options, extensions))) {
                    INSTANCES(pluginTargetElement, _base);
                }

                return _base;
            }

            /**
             * Initializes a new OverlayScrollbarsInstance object or changes options if already initialized or returns the current instance.
             * @param pluginTargetElements The elements to which the Plugin shall be initialized.
             * @param options The custom options with which the plugin shall be initialized.
             * @param extensions The extension(s) which shall be added right after initialization.
             * @returns {*}
             */
            _plugin = window[PLUGINNAME] = function (pluginTargetElements, options, extensions) {
                if (arguments[LEXICON.l] === 0)
                    return this;

                var arr = [];
                var optsIsPlainObj = FRAMEWORK.isPlainObject(options);
                var inst;
                var result;

                //pluginTargetElements is null or undefined
                if (!pluginTargetElements)
                    return optsIsPlainObj || !options ? result : arr;

                /*
                   pluginTargetElements will be converted to:
                   1. A jQueryElement Array
                   2. A HTMLElement Array
                   3. A Array with a single HTML Element
                   so pluginTargetElements is always a array.
                */
                pluginTargetElements = pluginTargetElements[LEXICON.l] != undefined ? pluginTargetElements : [pluginTargetElements[0] || pluginTargetElements];
                initOverlayScrollbarsStatics();

                if (pluginTargetElements[LEXICON.l] > 0) {
                    if (optsIsPlainObj) {
                        FRAMEWORK.each(pluginTargetElements, function (i, v) {
                            inst = v;
                            if (inst !== undefined)
                                arr.push(OverlayScrollbarsInstance(inst, options, extensions, _pluginsGlobals, _pluginsAutoUpdateLoop));
                        });
                    }
                    else {
                        FRAMEWORK.each(pluginTargetElements, function (i, v) {
                            inst = INSTANCES(v);
                            if ((options === '!' && _plugin.valid(inst)) || (COMPATIBILITY.type(options) == TYPES.f && options(v, inst)))
                                arr.push(inst);
                            else if (options === undefined)
                                arr.push(inst);
                        });
                    }
                    result = arr[LEXICON.l] === 1 ? arr[0] : arr;
                }
                return result;
            };

            /**
             * Returns a object which contains global information about the plugin and each instance of it.
             * The returned object is just a copy, that means that changes to the returned object won't have any effect to the original object.
             */
            _plugin.globals = function () {
                initOverlayScrollbarsStatics();
                var globals = FRAMEWORK.extend(true, {}, _pluginsGlobals);
                delete globals['msie'];
                return globals;
            };

            /**
             * Gets or Sets the default options for each new plugin initialization.
             * @param newDefaultOptions The object with which the default options shall be extended.
             */
            _plugin.defaultOptions = function (newDefaultOptions) {
                initOverlayScrollbarsStatics();
                var currDefaultOptions = _pluginsGlobals.defaultOptions;
                if (newDefaultOptions === undefined)
                    return FRAMEWORK.extend(true, {}, currDefaultOptions);

                //set the new default options
                _pluginsGlobals.defaultOptions = FRAMEWORK.extend(true, {}, currDefaultOptions, _pluginsOptions._validate(newDefaultOptions, _pluginsOptions._template, true, currDefaultOptions)._default);
            };

            /**
             * Checks whether the passed instance is a non-destroyed OverlayScrollbars instance.
             * @param osInstance The potential OverlayScrollbars instance which shall be checked.
             * @returns {boolean} True if the passed value is a non-destroyed OverlayScrollbars instance, false otherwise.
             */
            _plugin.valid = function (osInstance) {
                return osInstance instanceof _plugin && !osInstance.getState().destroyed;
            };

            /**
             * Registers, Unregisters or returns a extension.
             * Register: Pass the name and the extension. (defaultOptions is optional)
             * Unregister: Pass the name and anything except a function as extension parameter.
             * Get extension: Pass the name of the extension which shall be got.
             * Get all extensions: Pass no arguments.
             * @param extensionName The name of the extension which shall be registered, unregistered or returned.
             * @param extension A function which generates the instance of the extension or anything other to remove a already registered extension.
             * @param defaultOptions The default options which shall be used for the registered extension.
             */
            _plugin.extension = function (extensionName, extension, defaultOptions) {
                var extNameTypeString = COMPATIBILITY.type(extensionName) == TYPES.s;
                var argLen = arguments[LEXICON.l];
                var i = 0;
                if (argLen < 1 || !extNameTypeString) {
                    //return a copy of all extension objects
                    return FRAMEWORK.extend(true, { length: _pluginsExtensions[LEXICON.l] }, _pluginsExtensions);
                }
                else if (extNameTypeString) {
                    if (COMPATIBILITY.type(extension) == TYPES.f) {
                        //register extension
                        _pluginsExtensions.push({
                            name: extensionName,
                            extensionFactory: extension,
                            defaultOptions: defaultOptions
                        });
                    }
                    else {
                        for (; i < _pluginsExtensions[LEXICON.l]; i++) {
                            if (_pluginsExtensions[i].name === extensionName) {
                                if (argLen > 1)
                                    _pluginsExtensions.splice(i, 1); //remove extension
                                else
                                    return FRAMEWORK.extend(true, {}, _pluginsExtensions[i]); //return extension with the given name
                            }
                        }
                    }
                }
            };

            return _plugin;
        })();

        if (JQUERY && JQUERY.fn) {
            /**
             * The jQuery initialization interface.
             * @param options The initial options for the construction of the plugin. To initialize the plugin, this option has to be a object! If it isn't a object, the instance(s) are returned and the plugin wont be initialized.
             * @param extensions The extension(s) which shall be added right after initialization.
             * @returns {*} After initialization it returns the jQuery element array, else it returns the instance(s) of the elements which are selected.
             */
            JQUERY.fn.overlayScrollbars = function (options, extensions) {
                var _elements = this;
                if (JQUERY.isPlainObject(options)) {
                    JQUERY.each(_elements, function () { PLUGIN(this, options, extensions); });
                    return _elements;
                }
                else
                    return PLUGIN(_elements, options);
            };
        }
        return PLUGIN;
    }
));

/***/ }),

/***/ 80341:
/***/ (function(module) {

"use strict";


class CancelError extends Error {
	constructor(reason) {
		super(reason || 'Promise was canceled');
		this.name = 'CancelError';
	}

	get isCanceled() {
		return true;
	}
}

class PCancelable {
	static fn(userFn) {
		return (...arguments_) => {
			return new PCancelable((resolve, reject, onCancel) => {
				arguments_.push(onCancel);
				// eslint-disable-next-line promise/prefer-await-to-then
				userFn(...arguments_).then(resolve, reject);
			});
		};
	}

	constructor(executor) {
		this._cancelHandlers = [];
		this._isPending = true;
		this._isCanceled = false;
		this._rejectOnCancel = true;

		this._promise = new Promise((resolve, reject) => {
			this._reject = reject;

			const onResolve = value => {
				if (!this._isCanceled || !onCancel.shouldReject) {
					this._isPending = false;
					resolve(value);
				}
			};

			const onReject = error => {
				this._isPending = false;
				reject(error);
			};

			const onCancel = handler => {
				if (!this._isPending) {
					throw new Error('The `onCancel` handler was attached after the promise settled.');
				}

				this._cancelHandlers.push(handler);
			};

			Object.defineProperties(onCancel, {
				shouldReject: {
					get: () => this._rejectOnCancel,
					set: boolean => {
						this._rejectOnCancel = boolean;
					}
				}
			});

			return executor(onResolve, onReject, onCancel);
		});
	}

	then(onFulfilled, onRejected) {
		// eslint-disable-next-line promise/prefer-await-to-then
		return this._promise.then(onFulfilled, onRejected);
	}

	catch(onRejected) {
		return this._promise.catch(onRejected);
	}

	finally(onFinally) {
		return this._promise.finally(onFinally);
	}

	cancel(reason) {
		if (!this._isPending || this._isCanceled) {
			return;
		}

		this._isCanceled = true;

		if (this._cancelHandlers.length > 0) {
			try {
				for (const handler of this._cancelHandlers) {
					handler();
				}
			} catch (error) {
				this._reject(error);
				return;
			}
		}

		if (this._rejectOnCancel) {
			this._reject(new CancelError(reason));
		}
	}

	get isCanceled() {
		return this._isCanceled;
	}
}

Object.setPrototypeOf(PCancelable.prototype, Promise.prototype);

module.exports = PCancelable;
module.exports.CancelError = CancelError;


/***/ }),

/***/ 92703:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(50414);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ 45697:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) { var throwOnDirectAccess, ReactIs; } else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(92703)();
}


/***/ }),

/***/ 50414:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ 3655:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var mode = __webpack_require__(32792);

function QR8bitByte(data) {
	this.mode = mode.MODE_8BIT_BYTE;
	this.data = data;
}

QR8bitByte.prototype = {

	getLength : function(buffer) {
		return this.data.length;
	},
	
	write : function(buffer) {
		for (var i = 0; i < this.data.length; i++) {
			// not JIS ...
			buffer.put(this.data.charCodeAt(i), 8);
		}
	}
};

module.exports = QR8bitByte;



/***/ }),

/***/ 27321:
/***/ (function(module) {

function QRBitBuffer() {
	this.buffer = new Array();
	this.length = 0;
}

QRBitBuffer.prototype = {

	get : function(index) {
		var bufIndex = Math.floor(index / 8);
		return ( (this.buffer[bufIndex] >>> (7 - index % 8) ) & 1) == 1;
	},
	
	put : function(num, length) {
		for (var i = 0; i < length; i++) {
			this.putBit( ( (num >>> (length - i - 1) ) & 1) == 1);
		}
	},
	
	getLengthInBits : function() {
		return this.length;
	},
	
	putBit : function(bit) {
	
		var bufIndex = Math.floor(this.length / 8);
		if (this.buffer.length <= bufIndex) {
			this.buffer.push(0);
		}
	
		if (bit) {
			this.buffer[bufIndex] |= (0x80 >>> (this.length % 8) );
		}
	
		this.length++;
	}
};

module.exports = QRBitBuffer;


/***/ }),

/***/ 49381:
/***/ (function(module) {

module.exports = {
	L : 1,
	M : 0,
	Q : 3,
	H : 2
};



/***/ }),

/***/ 32832:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var math = __webpack_require__(11518);

function QRPolynomial(num, shift) {

	if (num.length == undefined) {
		throw new Error(num.length + "/" + shift);
	}

	var offset = 0;

	while (offset < num.length && num[offset] == 0) {
		offset++;
	}

	this.num = new Array(num.length - offset + shift);
	for (var i = 0; i < num.length - offset; i++) {
		this.num[i] = num[i + offset];
	}
}

QRPolynomial.prototype = {

	get : function(index) {
		return this.num[index];
	},
	
	getLength : function() {
		return this.num.length;
	},
	
	multiply : function(e) {
	
		var num = new Array(this.getLength() + e.getLength() - 1);
	
		for (var i = 0; i < this.getLength(); i++) {
			for (var j = 0; j < e.getLength(); j++) {
				num[i + j] ^= math.gexp(math.glog(this.get(i) ) + math.glog(e.get(j) ) );
			}
		}
	
		return new QRPolynomial(num, 0);
	},
	
	mod : function(e) {
	
		if (this.getLength() - e.getLength() < 0) {
			return this;
		}
	
		var ratio = math.glog(this.get(0) ) - math.glog(e.get(0) );
	
		var num = new Array(this.getLength() );
		
		for (var i = 0; i < this.getLength(); i++) {
			num[i] = this.get(i);
		}
		
		for (var i = 0; i < e.getLength(); i++) {
			num[i] ^= math.gexp(math.glog(e.get(i) ) + ratio);
		}
	
		// recursive call
		return new QRPolynomial(num, 0).mod(e);
	}
};

module.exports = QRPolynomial;


/***/ }),

/***/ 14450:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var BitByte = __webpack_require__(3655);
var RSBlock = __webpack_require__(17611);
var BitBuffer = __webpack_require__(27321);
var util = __webpack_require__(93160);
var Polynomial = __webpack_require__(32832);

function QRCode(typeNumber, errorCorrectLevel) {
	this.typeNumber = typeNumber;
	this.errorCorrectLevel = errorCorrectLevel;
	this.modules = null;
	this.moduleCount = 0;
	this.dataCache = null;
	this.dataList = [];
}

// for client side minification
var proto = QRCode.prototype;

proto.addData = function(data) {
	var newData = new BitByte(data);
	this.dataList.push(newData);
	this.dataCache = null;
};

proto.isDark = function(row, col) {
	if (row < 0 || this.moduleCount <= row || col < 0 || this.moduleCount <= col) {
		throw new Error(row + "," + col);
	}
	return this.modules[row][col];
};

proto.getModuleCount = function() {
	return this.moduleCount;
};

proto.make = function() {
	// Calculate automatically typeNumber if provided is < 1
	if (this.typeNumber < 1 ){
		var typeNumber = 1;
		for (typeNumber = 1; typeNumber < 40; typeNumber++) {
			var rsBlocks = RSBlock.getRSBlocks(typeNumber, this.errorCorrectLevel);

			var buffer = new BitBuffer();
			var totalDataCount = 0;
			for (var i = 0; i < rsBlocks.length; i++) {
				totalDataCount += rsBlocks[i].dataCount;
			}

			for (var i = 0; i < this.dataList.length; i++) {
				var data = this.dataList[i];
				buffer.put(data.mode, 4);
				buffer.put(data.getLength(), util.getLengthInBits(data.mode, typeNumber) );
				data.write(buffer);
			}
			if (buffer.getLengthInBits() <= totalDataCount * 8)
				break;
		}
		this.typeNumber = typeNumber;
	}
	this.makeImpl(false, this.getBestMaskPattern() );
};

proto.makeImpl = function(test, maskPattern) {
	
	this.moduleCount = this.typeNumber * 4 + 17;
	this.modules = new Array(this.moduleCount);
	
	for (var row = 0; row < this.moduleCount; row++) {
		
		this.modules[row] = new Array(this.moduleCount);
		
		for (var col = 0; col < this.moduleCount; col++) {
			this.modules[row][col] = null;//(col + row) % 3;
		}
	}

	this.setupPositionProbePattern(0, 0);
	this.setupPositionProbePattern(this.moduleCount - 7, 0);
	this.setupPositionProbePattern(0, this.moduleCount - 7);
	this.setupPositionAdjustPattern();
	this.setupTimingPattern();
	this.setupTypeInfo(test, maskPattern);
	
	if (this.typeNumber >= 7) {
		this.setupTypeNumber(test);
	}

	if (this.dataCache == null) {
		this.dataCache = QRCode.createData(this.typeNumber, this.errorCorrectLevel, this.dataList);
	}

	this.mapData(this.dataCache, maskPattern);
};

proto.setupPositionProbePattern = function(row, col)  {
	
	for (var r = -1; r <= 7; r++) {
		
		if (row + r <= -1 || this.moduleCount <= row + r) continue;
		
		for (var c = -1; c <= 7; c++) {
			
			if (col + c <= -1 || this.moduleCount <= col + c) continue;
			
			if ( (0 <= r && r <= 6 && (c == 0 || c == 6) )
					|| (0 <= c && c <= 6 && (r == 0 || r == 6) )
					|| (2 <= r && r <= 4 && 2 <= c && c <= 4) ) {
				this.modules[row + r][col + c] = true;
			} else {
				this.modules[row + r][col + c] = false;
			}
		}		
	}		
};

proto.getBestMaskPattern = function() {

	var minLostPoint = 0;
	var pattern = 0;

	for (var i = 0; i < 8; i++) {
		
		this.makeImpl(true, i);

		var lostPoint = util.getLostPoint(this);

		if (i == 0 || minLostPoint >  lostPoint) {
			minLostPoint = lostPoint;
			pattern = i;
		}
	}

	return pattern;
};

proto.createMovieClip = function(target_mc, instance_name, depth) {

	var qr_mc = target_mc.createEmptyMovieClip(instance_name, depth);
	var cs = 1;

	this.make();

	for (var row = 0; row < this.modules.length; row++) {
		
		var y = row * cs;
		
		for (var col = 0; col < this.modules[row].length; col++) {

			var x = col * cs;
			var dark = this.modules[row][col];
		
			if (dark) {
				qr_mc.beginFill(0, 100);
				qr_mc.moveTo(x, y);
				qr_mc.lineTo(x + cs, y);
				qr_mc.lineTo(x + cs, y + cs);
				qr_mc.lineTo(x, y + cs);
				qr_mc.endFill();
			}
		}
	}
	
	return qr_mc;
};

proto.setupTimingPattern = function() {
	
	for (var r = 8; r < this.moduleCount - 8; r++) {
		if (this.modules[r][6] != null) {
			continue;
		}
		this.modules[r][6] = (r % 2 == 0);
	}

	for (var c = 8; c < this.moduleCount - 8; c++) {
		if (this.modules[6][c] != null) {
			continue;
		}
		this.modules[6][c] = (c % 2 == 0);
	}
};

proto.setupPositionAdjustPattern = function() {

	var pos = util.getPatternPosition(this.typeNumber);
	
	for (var i = 0; i < pos.length; i++) {
	
		for (var j = 0; j < pos.length; j++) {
		
			var row = pos[i];
			var col = pos[j];
			
			if (this.modules[row][col] != null) {
				continue;
			}
			
			for (var r = -2; r <= 2; r++) {
			
				for (var c = -2; c <= 2; c++) {
				
					if (r == -2 || r == 2 || c == -2 || c == 2
							|| (r == 0 && c == 0) ) {
						this.modules[row + r][col + c] = true;
					} else {
						this.modules[row + r][col + c] = false;
					}
				}
			}
		}
	}
};

proto.setupTypeNumber = function(test) {

	var bits = util.getBCHTypeNumber(this.typeNumber);

	for (var i = 0; i < 18; i++) {
		var mod = (!test && ( (bits >> i) & 1) == 1);
		this.modules[Math.floor(i / 3)][i % 3 + this.moduleCount - 8 - 3] = mod;
	}

	for (var i = 0; i < 18; i++) {
		var mod = (!test && ( (bits >> i) & 1) == 1);
		this.modules[i % 3 + this.moduleCount - 8 - 3][Math.floor(i / 3)] = mod;
	}
};

proto.setupTypeInfo = function(test, maskPattern) {

	var data = (this.errorCorrectLevel << 3) | maskPattern;
	var bits = util.getBCHTypeInfo(data);

	// vertical		
	for (var i = 0; i < 15; i++) {

		var mod = (!test && ( (bits >> i) & 1) == 1);

		if (i < 6) {
			this.modules[i][8] = mod;
		} else if (i < 8) {
			this.modules[i + 1][8] = mod;
		} else {
			this.modules[this.moduleCount - 15 + i][8] = mod;
		}
	}

	// horizontal
	for (var i = 0; i < 15; i++) {

		var mod = (!test && ( (bits >> i) & 1) == 1);
		
		if (i < 8) {
			this.modules[8][this.moduleCount - i - 1] = mod;
		} else if (i < 9) {
			this.modules[8][15 - i - 1 + 1] = mod;
		} else {
			this.modules[8][15 - i - 1] = mod;
		}
	}

	// fixed module
	this.modules[this.moduleCount - 8][8] = (!test);
};

proto.mapData = function(data, maskPattern) {
	
	var inc = -1;
	var row = this.moduleCount - 1;
	var bitIndex = 7;
	var byteIndex = 0;
	
	for (var col = this.moduleCount - 1; col > 0; col -= 2) {

		if (col == 6) col--;

		while (true) {

			for (var c = 0; c < 2; c++) {
				
				if (this.modules[row][col - c] == null) {
					
					var dark = false;

					if (byteIndex < data.length) {
						dark = ( ( (data[byteIndex] >>> bitIndex) & 1) == 1);
					}

					var mask = util.getMask(maskPattern, row, col - c);

					if (mask) {
						dark = !dark;
					}
					
					this.modules[row][col - c] = dark;
					bitIndex--;

					if (bitIndex == -1) {
						byteIndex++;
						bitIndex = 7;
					}
				}
			}
							
			row += inc;

			if (row < 0 || this.moduleCount <= row) {
				row -= inc;
				inc = -inc;
				break;
			}
		}
	}
};

QRCode.PAD0 = 0xEC;
QRCode.PAD1 = 0x11;

QRCode.createData = function(typeNumber, errorCorrectLevel, dataList) {
	
	var rsBlocks = RSBlock.getRSBlocks(typeNumber, errorCorrectLevel);
	
	var buffer = new BitBuffer();
	
	for (var i = 0; i < dataList.length; i++) {
		var data = dataList[i];
		buffer.put(data.mode, 4);
		buffer.put(data.getLength(), util.getLengthInBits(data.mode, typeNumber) );
		data.write(buffer);
	}

	// calc num max data.
	var totalDataCount = 0;
	for (var i = 0; i < rsBlocks.length; i++) {
		totalDataCount += rsBlocks[i].dataCount;
	}

	if (buffer.getLengthInBits() > totalDataCount * 8) {
		throw new Error("code length overflow. ("
			+ buffer.getLengthInBits()
			+ ">"
			+  totalDataCount * 8
			+ ")");
	}

	// end code
	if (buffer.getLengthInBits() + 4 <= totalDataCount * 8) {
		buffer.put(0, 4);
	}

	// padding
	while (buffer.getLengthInBits() % 8 != 0) {
		buffer.putBit(false);
	}

	// padding
	while (true) {
		
		if (buffer.getLengthInBits() >= totalDataCount * 8) {
			break;
		}
		buffer.put(QRCode.PAD0, 8);
		
		if (buffer.getLengthInBits() >= totalDataCount * 8) {
			break;
		}
		buffer.put(QRCode.PAD1, 8);
	}

	return QRCode.createBytes(buffer, rsBlocks);
};

QRCode.createBytes = function(buffer, rsBlocks) {

	var offset = 0;
	
	var maxDcCount = 0;
	var maxEcCount = 0;
	
	var dcdata = new Array(rsBlocks.length);
	var ecdata = new Array(rsBlocks.length);
	
	for (var r = 0; r < rsBlocks.length; r++) {

		var dcCount = rsBlocks[r].dataCount;
		var ecCount = rsBlocks[r].totalCount - dcCount;

		maxDcCount = Math.max(maxDcCount, dcCount);
		maxEcCount = Math.max(maxEcCount, ecCount);
		
		dcdata[r] = new Array(dcCount);
		
		for (var i = 0; i < dcdata[r].length; i++) {
			dcdata[r][i] = 0xff & buffer.buffer[i + offset];
		}
		offset += dcCount;
		
		var rsPoly = util.getErrorCorrectPolynomial(ecCount);
		var rawPoly = new Polynomial(dcdata[r], rsPoly.getLength() - 1);

		var modPoly = rawPoly.mod(rsPoly);
		ecdata[r] = new Array(rsPoly.getLength() - 1);
		for (var i = 0; i < ecdata[r].length; i++) {
            var modIndex = i + modPoly.getLength() - ecdata[r].length;
			ecdata[r][i] = (modIndex >= 0)? modPoly.get(modIndex) : 0;
		}

	}
	
	var totalCodeCount = 0;
	for (var i = 0; i < rsBlocks.length; i++) {
		totalCodeCount += rsBlocks[i].totalCount;
	}

	var data = new Array(totalCodeCount);
	var index = 0;

	for (var i = 0; i < maxDcCount; i++) {
		for (var r = 0; r < rsBlocks.length; r++) {
			if (i < dcdata[r].length) {
				data[index++] = dcdata[r][i];
			}
		}
	}

	for (var i = 0; i < maxEcCount; i++) {
		for (var r = 0; r < rsBlocks.length; r++) {
			if (i < ecdata[r].length) {
				data[index++] = ecdata[r][i];
			}
		}
	}

	return data;
};

module.exports = QRCode;



/***/ }),

/***/ 17611:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// ErrorCorrectLevel
var ECL = __webpack_require__(49381);

function QRRSBlock(totalCount, dataCount) {
	this.totalCount = totalCount;
	this.dataCount  = dataCount;
}

QRRSBlock.RS_BLOCK_TABLE = [

	// L
	// M
	// Q
	// H

	// 1
	[1, 26, 19],
	[1, 26, 16],
	[1, 26, 13],
	[1, 26, 9],
	
	// 2
	[1, 44, 34],
	[1, 44, 28],
	[1, 44, 22],
	[1, 44, 16],

	// 3
	[1, 70, 55],
	[1, 70, 44],
	[2, 35, 17],
	[2, 35, 13],

	// 4		
	[1, 100, 80],
	[2, 50, 32],
	[2, 50, 24],
	[4, 25, 9],
	
	// 5
	[1, 134, 108],
	[2, 67, 43],
	[2, 33, 15, 2, 34, 16],
	[2, 33, 11, 2, 34, 12],
	
	// 6
	[2, 86, 68],
	[4, 43, 27],
	[4, 43, 19],
	[4, 43, 15],
	
	// 7		
	[2, 98, 78],
	[4, 49, 31],
	[2, 32, 14, 4, 33, 15],
	[4, 39, 13, 1, 40, 14],
	
	// 8
	[2, 121, 97],
	[2, 60, 38, 2, 61, 39],
	[4, 40, 18, 2, 41, 19],
	[4, 40, 14, 2, 41, 15],
	
	// 9
	[2, 146, 116],
	[3, 58, 36, 2, 59, 37],
	[4, 36, 16, 4, 37, 17],
	[4, 36, 12, 4, 37, 13],
	
	// 10		
	[2, 86, 68, 2, 87, 69],
	[4, 69, 43, 1, 70, 44],
	[6, 43, 19, 2, 44, 20],
	[6, 43, 15, 2, 44, 16],

	// 11
	[4, 101, 81],
	[1, 80, 50, 4, 81, 51],
	[4, 50, 22, 4, 51, 23],
	[3, 36, 12, 8, 37, 13],

	// 12
	[2, 116, 92, 2, 117, 93],
	[6, 58, 36, 2, 59, 37],
	[4, 46, 20, 6, 47, 21],
	[7, 42, 14, 4, 43, 15],

	// 13
	[4, 133, 107],
	[8, 59, 37, 1, 60, 38],
	[8, 44, 20, 4, 45, 21],
	[12, 33, 11, 4, 34, 12],

	// 14
	[3, 145, 115, 1, 146, 116],
	[4, 64, 40, 5, 65, 41],
	[11, 36, 16, 5, 37, 17],
	[11, 36, 12, 5, 37, 13],

	// 15
	[5, 109, 87, 1, 110, 88],
	[5, 65, 41, 5, 66, 42],
	[5, 54, 24, 7, 55, 25],
	[11, 36, 12],

	// 16
	[5, 122, 98, 1, 123, 99],
	[7, 73, 45, 3, 74, 46],
	[15, 43, 19, 2, 44, 20],
	[3, 45, 15, 13, 46, 16],

	// 17
	[1, 135, 107, 5, 136, 108],
	[10, 74, 46, 1, 75, 47],
	[1, 50, 22, 15, 51, 23],
	[2, 42, 14, 17, 43, 15],

	// 18
	[5, 150, 120, 1, 151, 121],
	[9, 69, 43, 4, 70, 44],
	[17, 50, 22, 1, 51, 23],
	[2, 42, 14, 19, 43, 15],

	// 19
	[3, 141, 113, 4, 142, 114],
	[3, 70, 44, 11, 71, 45],
	[17, 47, 21, 4, 48, 22],
	[9, 39, 13, 16, 40, 14],

	// 20
	[3, 135, 107, 5, 136, 108],
	[3, 67, 41, 13, 68, 42],
	[15, 54, 24, 5, 55, 25],
	[15, 43, 15, 10, 44, 16],

	// 21
	[4, 144, 116, 4, 145, 117],
	[17, 68, 42],
	[17, 50, 22, 6, 51, 23],
	[19, 46, 16, 6, 47, 17],

	// 22
	[2, 139, 111, 7, 140, 112],
	[17, 74, 46],
	[7, 54, 24, 16, 55, 25],
	[34, 37, 13],

	// 23
	[4, 151, 121, 5, 152, 122],
	[4, 75, 47, 14, 76, 48],
	[11, 54, 24, 14, 55, 25],
	[16, 45, 15, 14, 46, 16],

	// 24
	[6, 147, 117, 4, 148, 118],
	[6, 73, 45, 14, 74, 46],
	[11, 54, 24, 16, 55, 25],
	[30, 46, 16, 2, 47, 17],

	// 25
	[8, 132, 106, 4, 133, 107],
	[8, 75, 47, 13, 76, 48],
	[7, 54, 24, 22, 55, 25],
	[22, 45, 15, 13, 46, 16],

	// 26
	[10, 142, 114, 2, 143, 115],
	[19, 74, 46, 4, 75, 47],
	[28, 50, 22, 6, 51, 23],
	[33, 46, 16, 4, 47, 17],

	// 27
	[8, 152, 122, 4, 153, 123],
	[22, 73, 45, 3, 74, 46],
	[8, 53, 23, 26, 54, 24],
	[12, 45, 15, 28, 46, 16],

	// 28
	[3, 147, 117, 10, 148, 118],
	[3, 73, 45, 23, 74, 46],
	[4, 54, 24, 31, 55, 25],
	[11, 45, 15, 31, 46, 16],

	// 29
	[7, 146, 116, 7, 147, 117],
	[21, 73, 45, 7, 74, 46],
	[1, 53, 23, 37, 54, 24],
	[19, 45, 15, 26, 46, 16],

	// 30
	[5, 145, 115, 10, 146, 116],
	[19, 75, 47, 10, 76, 48],
	[15, 54, 24, 25, 55, 25],
	[23, 45, 15, 25, 46, 16],

	// 31
	[13, 145, 115, 3, 146, 116],
	[2, 74, 46, 29, 75, 47],
	[42, 54, 24, 1, 55, 25],
	[23, 45, 15, 28, 46, 16],

	// 32
	[17, 145, 115],
	[10, 74, 46, 23, 75, 47],
	[10, 54, 24, 35, 55, 25],
	[19, 45, 15, 35, 46, 16],

	// 33
	[17, 145, 115, 1, 146, 116],
	[14, 74, 46, 21, 75, 47],
	[29, 54, 24, 19, 55, 25],
	[11, 45, 15, 46, 46, 16],

	// 34
	[13, 145, 115, 6, 146, 116],
	[14, 74, 46, 23, 75, 47],
	[44, 54, 24, 7, 55, 25],
	[59, 46, 16, 1, 47, 17],

	// 35
	[12, 151, 121, 7, 152, 122],
	[12, 75, 47, 26, 76, 48],
	[39, 54, 24, 14, 55, 25],
	[22, 45, 15, 41, 46, 16],

	// 36
	[6, 151, 121, 14, 152, 122],
	[6, 75, 47, 34, 76, 48],
	[46, 54, 24, 10, 55, 25],
	[2, 45, 15, 64, 46, 16],

	// 37
	[17, 152, 122, 4, 153, 123],
	[29, 74, 46, 14, 75, 47],
	[49, 54, 24, 10, 55, 25],
	[24, 45, 15, 46, 46, 16],

	// 38
	[4, 152, 122, 18, 153, 123],
	[13, 74, 46, 32, 75, 47],
	[48, 54, 24, 14, 55, 25],
	[42, 45, 15, 32, 46, 16],

	// 39
	[20, 147, 117, 4, 148, 118],
	[40, 75, 47, 7, 76, 48],
	[43, 54, 24, 22, 55, 25],
	[10, 45, 15, 67, 46, 16],

	// 40
	[19, 148, 118, 6, 149, 119],
	[18, 75, 47, 31, 76, 48],
	[34, 54, 24, 34, 55, 25],
	[20, 45, 15, 61, 46, 16]
];

QRRSBlock.getRSBlocks = function(typeNumber, errorCorrectLevel) {
	
	var rsBlock = QRRSBlock.getRsBlockTable(typeNumber, errorCorrectLevel);
	
	if (rsBlock == undefined) {
		throw new Error("bad rs block @ typeNumber:" + typeNumber + "/errorCorrectLevel:" + errorCorrectLevel);
	}

	var length = rsBlock.length / 3;
	
	var list = new Array();
	
	for (var i = 0; i < length; i++) {

		var count = rsBlock[i * 3 + 0];
		var totalCount = rsBlock[i * 3 + 1];
		var dataCount  = rsBlock[i * 3 + 2];

		for (var j = 0; j < count; j++) {
			list.push(new QRRSBlock(totalCount, dataCount) );	
		}
	}
	
	return list;
}

QRRSBlock.getRsBlockTable = function(typeNumber, errorCorrectLevel) {

	switch(errorCorrectLevel) {
	case ECL.L :
		return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 0];
	case ECL.M :
		return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 1];
	case ECL.Q :
		return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 2];
	case ECL.H :
		return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 3];
	default :
		return undefined;
	}
}

module.exports = QRRSBlock;


/***/ }),

/***/ 11518:
/***/ (function(module) {

var QRMath = {

	glog : function(n) {
	
		if (n < 1) {
			throw new Error("glog(" + n + ")");
		}
		
		return QRMath.LOG_TABLE[n];
	},
	
	gexp : function(n) {
	
		while (n < 0) {
			n += 255;
		}
	
		while (n >= 256) {
			n -= 255;
		}
	
		return QRMath.EXP_TABLE[n];
	},
	
	EXP_TABLE : new Array(256),
	
	LOG_TABLE : new Array(256)

};
	
for (var i = 0; i < 8; i++) {
	QRMath.EXP_TABLE[i] = 1 << i;
}
for (var i = 8; i < 256; i++) {
	QRMath.EXP_TABLE[i] = QRMath.EXP_TABLE[i - 4]
		^ QRMath.EXP_TABLE[i - 5]
		^ QRMath.EXP_TABLE[i - 6]
		^ QRMath.EXP_TABLE[i - 8];
}
for (var i = 0; i < 255; i++) {
	QRMath.LOG_TABLE[QRMath.EXP_TABLE[i] ] = i;
}

module.exports = QRMath;


/***/ }),

/***/ 32792:
/***/ (function(module) {

module.exports = {
	MODE_NUMBER :		1 << 0,
	MODE_ALPHA_NUM : 	1 << 1,
	MODE_8BIT_BYTE : 	1 << 2,
	MODE_KANJI :		1 << 3
};


/***/ }),

/***/ 93160:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Mode = __webpack_require__(32792);
var Polynomial = __webpack_require__(32832);
var math = __webpack_require__(11518);

var QRMaskPattern = {
	PATTERN000 : 0,
	PATTERN001 : 1,
	PATTERN010 : 2,
	PATTERN011 : 3,
	PATTERN100 : 4,
	PATTERN101 : 5,
	PATTERN110 : 6,
	PATTERN111 : 7
};

var QRUtil = {

    PATTERN_POSITION_TABLE : [
	    [],
	    [6, 18],
	    [6, 22],
	    [6, 26],
	    [6, 30],
	    [6, 34],
	    [6, 22, 38],
	    [6, 24, 42],
	    [6, 26, 46],
	    [6, 28, 50],
	    [6, 30, 54],		
	    [6, 32, 58],
	    [6, 34, 62],
	    [6, 26, 46, 66],
	    [6, 26, 48, 70],
	    [6, 26, 50, 74],
	    [6, 30, 54, 78],
	    [6, 30, 56, 82],
	    [6, 30, 58, 86],
	    [6, 34, 62, 90],
	    [6, 28, 50, 72, 94],
	    [6, 26, 50, 74, 98],
	    [6, 30, 54, 78, 102],
	    [6, 28, 54, 80, 106],
	    [6, 32, 58, 84, 110],
	    [6, 30, 58, 86, 114],
	    [6, 34, 62, 90, 118],
	    [6, 26, 50, 74, 98, 122],
	    [6, 30, 54, 78, 102, 126],
	    [6, 26, 52, 78, 104, 130],
	    [6, 30, 56, 82, 108, 134],
	    [6, 34, 60, 86, 112, 138],
	    [6, 30, 58, 86, 114, 142],
	    [6, 34, 62, 90, 118, 146],
	    [6, 30, 54, 78, 102, 126, 150],
	    [6, 24, 50, 76, 102, 128, 154],
	    [6, 28, 54, 80, 106, 132, 158],
	    [6, 32, 58, 84, 110, 136, 162],
	    [6, 26, 54, 82, 110, 138, 166],
	    [6, 30, 58, 86, 114, 142, 170]
    ],

    G15 : (1 << 10) | (1 << 8) | (1 << 5) | (1 << 4) | (1 << 2) | (1 << 1) | (1 << 0),
    G18 : (1 << 12) | (1 << 11) | (1 << 10) | (1 << 9) | (1 << 8) | (1 << 5) | (1 << 2) | (1 << 0),
    G15_MASK : (1 << 14) | (1 << 12) | (1 << 10)	| (1 << 4) | (1 << 1),

    getBCHTypeInfo : function(data) {
	    var d = data << 10;
	    while (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G15) >= 0) {
		    d ^= (QRUtil.G15 << (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G15) ) ); 	
	    }
	    return ( (data << 10) | d) ^ QRUtil.G15_MASK;
    },

    getBCHTypeNumber : function(data) {
	    var d = data << 12;
	    while (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G18) >= 0) {
		    d ^= (QRUtil.G18 << (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G18) ) ); 	
	    }
	    return (data << 12) | d;
    },

    getBCHDigit : function(data) {

	    var digit = 0;

	    while (data != 0) {
		    digit++;
		    data >>>= 1;
	    }

	    return digit;
    },

    getPatternPosition : function(typeNumber) {
	    return QRUtil.PATTERN_POSITION_TABLE[typeNumber - 1];
    },

    getMask : function(maskPattern, i, j) {
	    
	    switch (maskPattern) {
		    
	    case QRMaskPattern.PATTERN000 : return (i + j) % 2 == 0;
	    case QRMaskPattern.PATTERN001 : return i % 2 == 0;
	    case QRMaskPattern.PATTERN010 : return j % 3 == 0;
	    case QRMaskPattern.PATTERN011 : return (i + j) % 3 == 0;
	    case QRMaskPattern.PATTERN100 : return (Math.floor(i / 2) + Math.floor(j / 3) ) % 2 == 0;
	    case QRMaskPattern.PATTERN101 : return (i * j) % 2 + (i * j) % 3 == 0;
	    case QRMaskPattern.PATTERN110 : return ( (i * j) % 2 + (i * j) % 3) % 2 == 0;
	    case QRMaskPattern.PATTERN111 : return ( (i * j) % 3 + (i + j) % 2) % 2 == 0;

	    default :
		    throw new Error("bad maskPattern:" + maskPattern);
	    }
    },

    getErrorCorrectPolynomial : function(errorCorrectLength) {

	    var a = new Polynomial([1], 0);

	    for (var i = 0; i < errorCorrectLength; i++) {
		    a = a.multiply(new Polynomial([1, math.gexp(i)], 0) );
	    }

	    return a;
    },

    getLengthInBits : function(mode, type) {

	    if (1 <= type && type < 10) {

		    // 1 - 9

		    switch(mode) {
		    case Mode.MODE_NUMBER 	: return 10;
		    case Mode.MODE_ALPHA_NUM 	: return 9;
		    case Mode.MODE_8BIT_BYTE	: return 8;
		    case Mode.MODE_KANJI  	: return 8;
		    default :
			    throw new Error("mode:" + mode);
		    }

	    } else if (type < 27) {

		    // 10 - 26

		    switch(mode) {
		    case Mode.MODE_NUMBER 	: return 12;
		    case Mode.MODE_ALPHA_NUM 	: return 11;
		    case Mode.MODE_8BIT_BYTE	: return 16;
		    case Mode.MODE_KANJI  	: return 10;
		    default :
			    throw new Error("mode:" + mode);
		    }

	    } else if (type < 41) {

		    // 27 - 40

		    switch(mode) {
		    case Mode.MODE_NUMBER 	: return 14;
		    case Mode.MODE_ALPHA_NUM	: return 13;
		    case Mode.MODE_8BIT_BYTE	: return 16;
		    case Mode.MODE_KANJI  	: return 12;
		    default :
			    throw new Error("mode:" + mode);
		    }

	    } else {
		    throw new Error("type:" + type);
	    }
    },

    getLostPoint : function(qrCode) {
	    
	    var moduleCount = qrCode.getModuleCount();
	    
	    var lostPoint = 0;
	    
	    // LEVEL1
	    
	    for (var row = 0; row < moduleCount; row++) {

		    for (var col = 0; col < moduleCount; col++) {

			    var sameCount = 0;
			    var dark = qrCode.isDark(row, col);

				for (var r = -1; r <= 1; r++) {

				    if (row + r < 0 || moduleCount <= row + r) {
					    continue;
				    }

				    for (var c = -1; c <= 1; c++) {

					    if (col + c < 0 || moduleCount <= col + c) {
						    continue;
					    }

					    if (r == 0 && c == 0) {
						    continue;
					    }

					    if (dark == qrCode.isDark(row + r, col + c) ) {
						    sameCount++;
					    }
				    }
			    }

			    if (sameCount > 5) {
				    lostPoint += (3 + sameCount - 5);
			    }
		    }
	    }

	    // LEVEL2

	    for (var row = 0; row < moduleCount - 1; row++) {
		    for (var col = 0; col < moduleCount - 1; col++) {
			    var count = 0;
			    if (qrCode.isDark(row,     col    ) ) count++;
			    if (qrCode.isDark(row + 1, col    ) ) count++;
			    if (qrCode.isDark(row,     col + 1) ) count++;
			    if (qrCode.isDark(row + 1, col + 1) ) count++;
			    if (count == 0 || count == 4) {
				    lostPoint += 3;
			    }
		    }
	    }

	    // LEVEL3

	    for (var row = 0; row < moduleCount; row++) {
		    for (var col = 0; col < moduleCount - 6; col++) {
			    if (qrCode.isDark(row, col)
					    && !qrCode.isDark(row, col + 1)
					    &&  qrCode.isDark(row, col + 2)
					    &&  qrCode.isDark(row, col + 3)
					    &&  qrCode.isDark(row, col + 4)
					    && !qrCode.isDark(row, col + 5)
					    &&  qrCode.isDark(row, col + 6) ) {
				    lostPoint += 40;
			    }
		    }
	    }

	    for (var col = 0; col < moduleCount; col++) {
		    for (var row = 0; row < moduleCount - 6; row++) {
			    if (qrCode.isDark(row, col)
					    && !qrCode.isDark(row + 1, col)
					    &&  qrCode.isDark(row + 2, col)
					    &&  qrCode.isDark(row + 3, col)
					    &&  qrCode.isDark(row + 4, col)
					    && !qrCode.isDark(row + 5, col)
					    &&  qrCode.isDark(row + 6, col) ) {
				    lostPoint += 40;
			    }
		    }
	    }

	    // LEVEL4
	    
	    var darkCount = 0;

	    for (var col = 0; col < moduleCount; col++) {
		    for (var row = 0; row < moduleCount; row++) {
			    if (qrCode.isDark(row, col) ) {
				    darkCount++;
			    }
		    }
	    }
	    
	    var ratio = Math.abs(100 * darkCount / moduleCount / moduleCount - 50) / 5;
	    lostPoint += ratio * 10;

	    return lostPoint;		
    }
};

module.exports = QRUtil;


/***/ }),

/***/ 55798:
/***/ (function(module) {

"use strict";


var replace = String.prototype.replace;
var percentTwenties = /%20/g;

var Format = {
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};

module.exports = {
    'default': Format.RFC3986,
    formatters: {
        RFC1738: function (value) {
            return replace.call(value, percentTwenties, '+');
        },
        RFC3986: function (value) {
            return String(value);
        }
    },
    RFC1738: Format.RFC1738,
    RFC3986: Format.RFC3986
};


/***/ }),

/***/ 80129:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var stringify = __webpack_require__(58261);
var parse = __webpack_require__(55235);
var formats = __webpack_require__(55798);

module.exports = {
    formats: formats,
    parse: parse,
    stringify: stringify
};


/***/ }),

/***/ 55235:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(12769);

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var defaults = {
    allowDots: false,
    allowEmptyArrays: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    comma: false,
    decodeDotInKeys: false,
    decoder: utils.decode,
    delimiter: '&',
    depth: 5,
    duplicates: 'combine',
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictDepth: false,
    strictNullHandling: false,
    throwOnLimitExceeded: false
};

var interpretNumericEntities = function (str) {
    return str.replace(/&#(\d+);/g, function ($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};

var parseArrayValue = function (val, options, currentArrayLength) {
    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) {
        return val.split(',');
    }

    if (options.throwOnLimitExceeded && currentArrayLength >= options.arrayLimit) {
        throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
    }

    return val;
};

// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')

// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')

var parseValues = function parseQueryStringValues(str, options) {
    var obj = { __proto__: null };

    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    cleanStr = cleanStr.replace(/%5B/gi, '[').replace(/%5D/gi, ']');

    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(
        options.delimiter,
        options.throwOnLimitExceeded ? limit + 1 : limit
    );

    if (options.throwOnLimitExceeded && parts.length > limit) {
        throw new RangeError('Parameter limit exceeded. Only ' + limit + ' parameter' + (limit === 1 ? '' : 's') + ' allowed.');
    }

    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;

    var charset = options.charset;
    if (options.charsetSentinel) {
        for (i = 0; i < parts.length; ++i) {
            if (parts[i].indexOf('utf8=') === 0) {
                if (parts[i] === charsetSentinel) {
                    charset = 'utf-8';
                } else if (parts[i] === isoSentinel) {
                    charset = 'iso-8859-1';
                }
                skipIndex = i;
                i = parts.length; // The eslint settings do not allow break;
            }
        }
    }

    for (i = 0; i < parts.length; ++i) {
        if (i === skipIndex) {
            continue;
        }
        var part = parts[i];

        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;

        var key;
        var val;
        if (pos === -1) {
            key = options.decoder(part, defaults.decoder, charset, 'key');
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), defaults.decoder, charset, 'key');

            val = utils.maybeMap(
                parseArrayValue(
                    part.slice(pos + 1),
                    options,
                    isArray(obj[key]) ? obj[key].length : 0
                ),
                function (encodedVal) {
                    return options.decoder(encodedVal, defaults.decoder, charset, 'value');
                }
            );
        }

        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') {
            val = interpretNumericEntities(String(val));
        }

        if (part.indexOf('[]=') > -1) {
            val = isArray(val) ? [val] : val;
        }

        var existing = has.call(obj, key);
        if (existing && options.duplicates === 'combine') {
            obj[key] = utils.combine(obj[key], val);
        } else if (!existing || options.duplicates === 'last') {
            obj[key] = val;
        }
    }

    return obj;
};

var parseObject = function (chain, val, options, valuesParsed) {
    var currentArrayLength = 0;
    if (chain.length > 0 && chain[chain.length - 1] === '[]') {
        var parentKey = chain.slice(0, -1).join('');
        currentArrayLength = Array.isArray(val) && val[parentKey] ? val[parentKey].length : 0;
    }

    var leaf = valuesParsed ? val : parseArrayValue(val, options, currentArrayLength);

    for (var i = chain.length - 1; i >= 0; --i) {
        var obj;
        var root = chain[i];

        if (root === '[]' && options.parseArrays) {
            obj = options.allowEmptyArrays && (leaf === '' || (options.strictNullHandling && leaf === null))
                ? []
                : utils.combine([], leaf);
        } else {
            obj = options.plainObjects ? { __proto__: null } : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var decodedRoot = options.decodeDotInKeys ? cleanRoot.replace(/%2E/g, '.') : cleanRoot;
            var index = parseInt(decodedRoot, 10);
            if (!options.parseArrays && decodedRoot === '') {
                obj = { 0: leaf };
            } else if (
                !isNaN(index)
                && root !== decodedRoot
                && String(index) === decodedRoot
                && index >= 0
                && (options.parseArrays && index <= options.arrayLimit)
            ) {
                obj = [];
                obj[index] = leaf;
            } else if (decodedRoot !== '__proto__') {
                obj[decodedRoot] = leaf;
            }
        }

        leaf = obj;
    }

    return leaf;
};

var parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) {
        return;
    }

    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;

    // The regex chunks

    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;

    // Get the parent

    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;

    // Stash the parent if it exists

    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) {
                return;
            }
        }

        keys.push(parent);
    }

    // Loop through children appending to the array until we hit depth

    var i = 0;
    while (options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth) {
        i += 1;
        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) {
                return;
            }
        }
        keys.push(segment[1]);
    }

    // If there's a remainder, check strictDepth option for throw, else just add whatever is left

    if (segment) {
        if (options.strictDepth === true) {
            throw new RangeError('Input depth exceeded depth option of ' + options.depth + ' and strictDepth is true');
        }
        keys.push('[' + key.slice(segment.index) + ']');
    }

    return parseObject(keys, val, options, valuesParsed);
};

var normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') {
        throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    }

    if (typeof opts.decodeDotInKeys !== 'undefined' && typeof opts.decodeDotInKeys !== 'boolean') {
        throw new TypeError('`decodeDotInKeys` option can only be `true` or `false`, when provided');
    }

    if (opts.decoder !== null && typeof opts.decoder !== 'undefined' && typeof opts.decoder !== 'function') {
        throw new TypeError('Decoder has to be a function.');
    }

    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }

    if (typeof opts.throwOnLimitExceeded !== 'undefined' && typeof opts.throwOnLimitExceeded !== 'boolean') {
        throw new TypeError('`throwOnLimitExceeded` option must be a boolean');
    }

    var charset = typeof opts.charset === 'undefined' ? defaults.charset : opts.charset;

    var duplicates = typeof opts.duplicates === 'undefined' ? defaults.duplicates : opts.duplicates;

    if (duplicates !== 'combine' && duplicates !== 'first' && duplicates !== 'last') {
        throw new TypeError('The duplicates option must be either combine, first, or last');
    }

    var allowDots = typeof opts.allowDots === 'undefined' ? opts.decodeDotInKeys === true ? true : defaults.allowDots : !!opts.allowDots;

    return {
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : defaults.allowEmptyArrays,
        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === 'boolean' ? opts.allowSparse : defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        comma: typeof opts.comma === 'boolean' ? opts.comma : defaults.comma,
        decodeDotInKeys: typeof opts.decodeDotInKeys === 'boolean' ? opts.decodeDotInKeys : defaults.decodeDotInKeys,
        decoder: typeof opts.decoder === 'function' ? opts.decoder : defaults.decoder,
        delimiter: typeof opts.delimiter === 'string' || utils.isRegExp(opts.delimiter) ? opts.delimiter : defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: (typeof opts.depth === 'number' || opts.depth === false) ? +opts.depth : defaults.depth,
        duplicates: duplicates,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : defaults.plainObjects,
        strictDepth: typeof opts.strictDepth === 'boolean' ? !!opts.strictDepth : defaults.strictDepth,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling,
        throwOnLimitExceeded: typeof opts.throwOnLimitExceeded === 'boolean' ? opts.throwOnLimitExceeded : false
    };
};

module.exports = function (str, opts) {
    var options = normalizeParseOptions(opts);

    if (str === '' || str === null || typeof str === 'undefined') {
        return options.plainObjects ? { __proto__: null } : {};
    }

    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
    var obj = options.plainObjects ? { __proto__: null } : {};

    // Iterate over the keys and setup the new object

    var keys = Object.keys(tempObj);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var newObj = parseKeys(key, tempObj[key], options, typeof str === 'string');
        obj = utils.merge(obj, newObj, options);
    }

    if (options.allowSparse === true) {
        return obj;
    }

    return utils.compact(obj);
};


/***/ }),

/***/ 58261:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var getSideChannel = __webpack_require__(37478);
var utils = __webpack_require__(12769);
var formats = __webpack_require__(55798);
var has = Object.prototype.hasOwnProperty;

var arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + '[]';
    },
    comma: 'comma',
    indices: function indices(prefix, key) {
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};

var isArray = Array.isArray;
var push = Array.prototype.push;
var pushToArray = function (arr, valueOrArray) {
    push.apply(arr, isArray(valueOrArray) ? valueOrArray : [valueOrArray]);
};

var toISO = Date.prototype.toISOString;

var defaultFormat = formats['default'];
var defaults = {
    addQueryPrefix: false,
    allowDots: false,
    allowEmptyArrays: false,
    arrayFormat: 'indices',
    charset: 'utf-8',
    charsetSentinel: false,
    commaRoundTrip: false,
    delimiter: '&',
    encode: true,
    encodeDotInKeys: false,
    encoder: utils.encode,
    encodeValuesOnly: false,
    filter: void undefined,
    format: defaultFormat,
    formatter: formats.formatters[defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};

var isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === 'string'
        || typeof v === 'number'
        || typeof v === 'boolean'
        || typeof v === 'symbol'
        || typeof v === 'bigint';
};

var sentinel = {};

var stringify = function stringify(
    object,
    prefix,
    generateArrayPrefix,
    commaRoundTrip,
    allowEmptyArrays,
    strictNullHandling,
    skipNulls,
    encodeDotInKeys,
    encoder,
    filter,
    sort,
    allowDots,
    serializeDate,
    format,
    formatter,
    encodeValuesOnly,
    charset,
    sideChannel
) {
    var obj = object;

    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while ((tmpSc = tmpSc.get(sentinel)) !== void undefined && !findFlag) {
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== 'undefined') {
            if (pos === step) {
                throw new RangeError('Cyclic object value');
            } else {
                findFlag = true; // Break while
            }
        }
        if (typeof tmpSc.get(sentinel) === 'undefined') {
            step = 0;
        }
    }

    if (typeof filter === 'function') {
        obj = filter(prefix, obj);
    } else if (obj instanceof Date) {
        obj = serializeDate(obj);
    } else if (generateArrayPrefix === 'comma' && isArray(obj)) {
        obj = utils.maybeMap(obj, function (value) {
            if (value instanceof Date) {
                return serializeDate(value);
            }
            return value;
        });
    }

    if (obj === null) {
        if (strictNullHandling) {
            return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder, charset, 'key', format) : prefix;
        }

        obj = '';
    }

    if (isNonNullishPrimitive(obj) || utils.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder, charset, 'key', format);
            return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults.encoder, charset, 'value', format))];
        }
        return [formatter(prefix) + '=' + formatter(String(obj))];
    }

    var values = [];

    if (typeof obj === 'undefined') {
        return values;
    }

    var objKeys;
    if (generateArrayPrefix === 'comma' && isArray(obj)) {
        // we need to join elements in
        if (encodeValuesOnly && encoder) {
            obj = utils.maybeMap(obj, encoder);
        }
        objKeys = [{ value: obj.length > 0 ? obj.join(',') || null : void undefined }];
    } else if (isArray(filter)) {
        objKeys = filter;
    } else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }

    var encodedPrefix = encodeDotInKeys ? String(prefix).replace(/\./g, '%2E') : String(prefix);

    var adjustedPrefix = commaRoundTrip && isArray(obj) && obj.length === 1 ? encodedPrefix + '[]' : encodedPrefix;

    if (allowEmptyArrays && isArray(obj) && obj.length === 0) {
        return adjustedPrefix + '[]';
    }

    for (var j = 0; j < objKeys.length; ++j) {
        var key = objKeys[j];
        var value = typeof key === 'object' && key && typeof key.value !== 'undefined'
            ? key.value
            : obj[key];

        if (skipNulls && value === null) {
            continue;
        }

        var encodedKey = allowDots && encodeDotInKeys ? String(key).replace(/\./g, '%2E') : String(key);
        var keyPrefix = isArray(obj)
            ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(adjustedPrefix, encodedKey) : adjustedPrefix
            : adjustedPrefix + (allowDots ? '.' + encodedKey : '[' + encodedKey + ']');

        sideChannel.set(object, step);
        var valueSideChannel = getSideChannel();
        valueSideChannel.set(sentinel, sideChannel);
        pushToArray(values, stringify(
            value,
            keyPrefix,
            generateArrayPrefix,
            commaRoundTrip,
            allowEmptyArrays,
            strictNullHandling,
            skipNulls,
            encodeDotInKeys,
            generateArrayPrefix === 'comma' && encodeValuesOnly && isArray(obj) ? null : encoder,
            filter,
            sort,
            allowDots,
            serializeDate,
            format,
            formatter,
            encodeValuesOnly,
            charset,
            valueSideChannel
        ));
    }

    return values;
};

var normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') {
        throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    }

    if (typeof opts.encodeDotInKeys !== 'undefined' && typeof opts.encodeDotInKeys !== 'boolean') {
        throw new TypeError('`encodeDotInKeys` option can only be `true` or `false`, when provided');
    }

    if (opts.encoder !== null && typeof opts.encoder !== 'undefined' && typeof opts.encoder !== 'function') {
        throw new TypeError('Encoder has to be a function.');
    }

    var charset = opts.charset || defaults.charset;
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }

    var format = formats['default'];
    if (typeof opts.format !== 'undefined') {
        if (!has.call(formats.formatters, opts.format)) {
            throw new TypeError('Unknown format option provided.');
        }
        format = opts.format;
    }
    var formatter = formats.formatters[format];

    var filter = defaults.filter;
    if (typeof opts.filter === 'function' || isArray(opts.filter)) {
        filter = opts.filter;
    }

    var arrayFormat;
    if (opts.arrayFormat in arrayPrefixGenerators) {
        arrayFormat = opts.arrayFormat;
    } else if ('indices' in opts) {
        arrayFormat = opts.indices ? 'indices' : 'repeat';
    } else {
        arrayFormat = defaults.arrayFormat;
    }

    if ('commaRoundTrip' in opts && typeof opts.commaRoundTrip !== 'boolean') {
        throw new TypeError('`commaRoundTrip` must be a boolean, or absent');
    }

    var allowDots = typeof opts.allowDots === 'undefined' ? opts.encodeDotInKeys === true ? true : defaults.allowDots : !!opts.allowDots;

    return {
        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : defaults.addQueryPrefix,
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : defaults.allowEmptyArrays,
        arrayFormat: arrayFormat,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        commaRoundTrip: !!opts.commaRoundTrip,
        delimiter: typeof opts.delimiter === 'undefined' ? defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === 'boolean' ? opts.encode : defaults.encode,
        encodeDotInKeys: typeof opts.encodeDotInKeys === 'boolean' ? opts.encodeDotInKeys : defaults.encodeDotInKeys,
        encoder: typeof opts.encoder === 'function' ? opts.encoder : defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : defaults.skipNulls,
        sort: typeof opts.sort === 'function' ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

module.exports = function (object, opts) {
    var obj = object;
    var options = normalizeStringifyOptions(opts);

    var objKeys;
    var filter;

    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if (isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }

    var keys = [];

    if (typeof obj !== 'object' || obj === null) {
        return '';
    }

    var generateArrayPrefix = arrayPrefixGenerators[options.arrayFormat];
    var commaRoundTrip = generateArrayPrefix === 'comma' && options.commaRoundTrip;

    if (!objKeys) {
        objKeys = Object.keys(obj);
    }

    if (options.sort) {
        objKeys.sort(options.sort);
    }

    var sideChannel = getSideChannel();
    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];
        var value = obj[key];

        if (options.skipNulls && value === null) {
            continue;
        }
        pushToArray(keys, stringify(
            value,
            key,
            generateArrayPrefix,
            commaRoundTrip,
            options.allowEmptyArrays,
            options.strictNullHandling,
            options.skipNulls,
            options.encodeDotInKeys,
            options.encode ? options.encoder : null,
            options.filter,
            options.sort,
            options.allowDots,
            options.serializeDate,
            options.format,
            options.formatter,
            options.encodeValuesOnly,
            options.charset,
            sideChannel
        ));
    }

    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';

    if (options.charsetSentinel) {
        if (options.charset === 'iso-8859-1') {
            // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
            prefix += 'utf8=%26%2310003%3B&';
        } else {
            // encodeURIComponent('✓')
            prefix += 'utf8=%E2%9C%93&';
        }
    }

    return joined.length > 0 ? prefix + joined : '';
};


/***/ }),

/***/ 12769:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var formats = __webpack_require__(55798);

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var hexTable = (function () {
    var array = [];
    for (var i = 0; i < 256; ++i) {
        array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
    }

    return array;
}());

var compactQueue = function compactQueue(queue) {
    while (queue.length > 1) {
        var item = queue.pop();
        var obj = item.obj[item.prop];

        if (isArray(obj)) {
            var compacted = [];

            for (var j = 0; j < obj.length; ++j) {
                if (typeof obj[j] !== 'undefined') {
                    compacted.push(obj[j]);
                }
            }

            item.obj[item.prop] = compacted;
        }
    }
};

var arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? { __proto__: null } : {};
    for (var i = 0; i < source.length; ++i) {
        if (typeof source[i] !== 'undefined') {
            obj[i] = source[i];
        }
    }

    return obj;
};

var merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */
    if (!source) {
        return target;
    }

    if (typeof source !== 'object' && typeof source !== 'function') {
        if (isArray(target)) {
            target.push(source);
        } else if (target && typeof target === 'object') {
            if (
                (options && (options.plainObjects || options.allowPrototypes))
                || !has.call(Object.prototype, source)
            ) {
                target[source] = true;
            }
        } else {
            return [target, source];
        }

        return target;
    }

    if (!target || typeof target !== 'object') {
        return [target].concat(source);
    }

    var mergeTarget = target;
    if (isArray(target) && !isArray(source)) {
        mergeTarget = arrayToObject(target, options);
    }

    if (isArray(target) && isArray(source)) {
        source.forEach(function (item, i) {
            if (has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') {
                    target[i] = merge(targetItem, item, options);
                } else {
                    target.push(item);
                }
            } else {
                target[i] = item;
            }
        });
        return target;
    }

    return Object.keys(source).reduce(function (acc, key) {
        var value = source[key];

        if (has.call(acc, key)) {
            acc[key] = merge(acc[key], value, options);
        } else {
            acc[key] = value;
        }
        return acc;
    }, mergeTarget);
};

var assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function (acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};

var decode = function (str, defaultDecoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') {
        // unescape never throws, no try...catch needed:
        return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    }
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};

var limit = 1024;

/* eslint operator-linebreak: [2, "before"] */

var encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) {
        return str;
    }

    var string = str;
    if (typeof str === 'symbol') {
        string = Symbol.prototype.toString.call(str);
    } else if (typeof str !== 'string') {
        string = String(str);
    }

    if (charset === 'iso-8859-1') {
        return escape(string).replace(/%u[0-9a-f]{4}/gi, function ($0) {
            return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
        });
    }

    var out = '';
    for (var j = 0; j < string.length; j += limit) {
        var segment = string.length >= limit ? string.slice(j, j + limit) : string;
        var arr = [];

        for (var i = 0; i < segment.length; ++i) {
            var c = segment.charCodeAt(i);
            if (
                c === 0x2D // -
                || c === 0x2E // .
                || c === 0x5F // _
                || c === 0x7E // ~
                || (c >= 0x30 && c <= 0x39) // 0-9
                || (c >= 0x41 && c <= 0x5A) // a-z
                || (c >= 0x61 && c <= 0x7A) // A-Z
                || (format === formats.RFC1738 && (c === 0x28 || c === 0x29)) // ( )
            ) {
                arr[arr.length] = segment.charAt(i);
                continue;
            }

            if (c < 0x80) {
                arr[arr.length] = hexTable[c];
                continue;
            }

            if (c < 0x800) {
                arr[arr.length] = hexTable[0xC0 | (c >> 6)]
                    + hexTable[0x80 | (c & 0x3F)];
                continue;
            }

            if (c < 0xD800 || c >= 0xE000) {
                arr[arr.length] = hexTable[0xE0 | (c >> 12)]
                    + hexTable[0x80 | ((c >> 6) & 0x3F)]
                    + hexTable[0x80 | (c & 0x3F)];
                continue;
            }

            i += 1;
            c = 0x10000 + (((c & 0x3FF) << 10) | (segment.charCodeAt(i) & 0x3FF));

            arr[arr.length] = hexTable[0xF0 | (c >> 18)]
                + hexTable[0x80 | ((c >> 12) & 0x3F)]
                + hexTable[0x80 | ((c >> 6) & 0x3F)]
                + hexTable[0x80 | (c & 0x3F)];
        }

        out += arr.join('');
    }

    return out;
};

var compact = function compact(value) {
    var queue = [{ obj: { o: value }, prop: 'o' }];
    var refs = [];

    for (var i = 0; i < queue.length; ++i) {
        var item = queue[i];
        var obj = item.obj[item.prop];

        var keys = Object.keys(obj);
        for (var j = 0; j < keys.length; ++j) {
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue.push({ obj: obj, prop: key });
                refs.push(val);
            }
        }
    }

    compactQueue(queue);

    return value;
};

var isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};

var isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== 'object') {
        return false;
    }

    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};

var combine = function combine(a, b) {
    return [].concat(a, b);
};

var maybeMap = function maybeMap(val, fn) {
    if (isArray(val)) {
        var mapped = [];
        for (var i = 0; i < val.length; i += 1) {
            mapped.push(fn(val[i]));
        }
        return mapped;
    }
    return fn(val);
};

module.exports = {
    arrayToObject: arrayToObject,
    assign: assign,
    combine: combine,
    compact: compact,
    decode: decode,
    encode: encode,
    isBuffer: isBuffer,
    isRegExp: isRegExp,
    maybeMap: maybeMap,
    merge: merge
};


/***/ }),

/***/ 97893:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

!function(e,t){if(true)module.exports=t(__webpack_require__(67294));else { var r, n; }}(this,(function(e){return function(e){var t={};function n(r){if(t[r])return t[r].exports;var o=t[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,n),o.l=!0,o.exports}return n.m=e,n.c=t,n.d=function(e,t,r){n.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:r})},n.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},n.t=function(e,t){if(1&t&&(e=n(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(n.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var o in e)n.d(r,o,function(t){return e[t]}.bind(null,o));return r},n.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return n.d(t,"a",t),t},n.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},n.p="",n(n.s=4)}([function(e,t,n){e.exports=n(2)()},function(t,n){t.exports=e},function(e,t,n){"use strict";var r=n(3);function o(){}function i(){}i.resetWarningCache=o,e.exports=function(){function e(e,t,n,o,i,s){if(s!==r){var a=new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");throw a.name="Invariant Violation",a}}function t(){return e}e.isRequired=e;var n={array:e,bigint:e,bool:e,func:e,number:e,object:e,string:e,symbol:e,any:e,arrayOf:t,element:e,elementType:e,instanceOf:t,node:e,objectOf:t,oneOf:t,oneOfType:t,shape:t,exact:t,checkPropTypes:i,resetWarningCache:o};return n.PropTypes=n,n}},function(e,t,n){"use strict";e.exports="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED"},function(e,t,n){"use strict";n.r(t);var r=n(1),o=n.n(r),i=n(0),s=n.n(i),a=function(e){return 0!==e};function l(){return(l=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e}).apply(this,arguments)}function c(e){return(c="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function p(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}function u(e,t){return(u=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(e,t){return e.__proto__=t,e})(e,t)}function g(e){var t=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var n,r=d(e);if(t){var o=d(this).constructor;n=Reflect.construct(r,arguments,o)}else n=r.apply(this,arguments);return f(this,n)}}function f(e,t){if(t&&("object"===c(t)||"function"==typeof t))return t;if(void 0!==t)throw new TypeError("Derived constructors may only return object or undefined");return h(e)}function h(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}function d(e){return(d=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function b(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}var m=function(e){!function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),Object.defineProperty(e,"prototype",{writable:!1}),t&&u(e,t)}(s,e);var t,n,r,i=g(s);function s(e){var t;return function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,s),b(h(t=i.call(this,e)),"continueOpenCollapsible",(function(){var e=h(t).innerRef;t.setState({height:e.scrollHeight,transition:"height ".concat(t.props.transitionTime,"ms ").concat(t.props.easing),isClosed:!1,hasBeenOpened:!0,inTransition:a(e.scrollHeight),shouldOpenOnNextCycle:!1})})),b(h(t),"handleTriggerClick",(function(e){t.props.triggerDisabled||t.state.inTransition||(e.preventDefault(),t.props.handleTriggerClick?t.props.handleTriggerClick(t.props.accordionPosition):!0===t.state.isClosed?(t.openCollapsible(),t.props.onOpening(),t.props.onTriggerOpening()):(t.closeCollapsible(),t.props.onClosing(),t.props.onTriggerClosing()))})),b(h(t),"handleTransitionEnd",(function(e){e.target===t.innerRef&&(t.state.isClosed?(t.setState({inTransition:!1}),t.props.onClose()):(t.setState({height:"auto",overflow:t.props.overflowWhenOpen,inTransition:!1}),t.props.onOpen()))})),b(h(t),"setInnerRef",(function(e){return t.innerRef=e})),t.timeout=void 0,t.contentId=e.contentElementId||"collapsible-content-".concat(Date.now()),t.triggerId=e.triggerElementProps.id||"collapsible-trigger-".concat(Date.now()),e.open?t.state={isClosed:!1,shouldSwitchAutoOnNextCycle:!1,height:"auto",transition:"none",hasBeenOpened:!0,overflow:e.overflowWhenOpen,inTransition:!1}:t.state={isClosed:!0,shouldSwitchAutoOnNextCycle:!1,height:0,transition:"height ".concat(e.transitionTime,"ms ").concat(e.easing),hasBeenOpened:!1,overflow:"hidden",inTransition:!1},t}return t=s,(n=[{key:"componentDidUpdate",value:function(e,t){var n=this;this.state.shouldOpenOnNextCycle&&this.continueOpenCollapsible(),"auto"!==t.height&&0!==t.height||!0!==this.state.shouldSwitchAutoOnNextCycle||(window.clearTimeout(this.timeout),this.timeout=window.setTimeout((function(){n.setState({height:0,overflow:"hidden",isClosed:!0,shouldSwitchAutoOnNextCycle:!1})}),50)),e.open!==this.props.open&&(!0===this.props.open?(this.openCollapsible(),this.props.onOpening()):(this.closeCollapsible(),this.props.onClosing()))}},{key:"componentWillUnmount",value:function(){window.clearTimeout(this.timeout)}},{key:"closeCollapsible",value:function(){var e=this.innerRef;this.setState({shouldSwitchAutoOnNextCycle:!0,height:e.scrollHeight,transition:"height ".concat(this.props.transitionCloseTime?this.props.transitionCloseTime:this.props.transitionTime,"ms ").concat(this.props.easing),inTransition:a(e.scrollHeight)})}},{key:"openCollapsible",value:function(){this.setState({inTransition:a(this.innerRef.scrollHeight),shouldOpenOnNextCycle:!0})}},{key:"renderNonClickableTriggerElement",value:function(){var e=this.props,t=e.triggerSibling,n=e.classParentString;if(!t)return null;switch(c(t)){case"string":return o.a.createElement("span",{className:"".concat(n,"__trigger-sibling")},t);case"function":return t();case"object":return t;default:return null}}},{key:"render",value:function(){var e=this,t={height:this.state.height,WebkitTransition:this.state.transition,msTransition:this.state.transition,transition:this.state.transition,overflow:this.state.overflow},n=this.state.isClosed?"is-closed":"is-open",r=this.props.triggerDisabled?"is-disabled":"",i=!1===this.state.isClosed&&void 0!==this.props.triggerWhenOpen?this.props.triggerWhenOpen:this.props.trigger,s=this.props.contentContainerTagName,a=this.props.triggerTagName,c=this.props.lazyRender&&!this.state.hasBeenOpened&&this.state.isClosed&&!this.state.inTransition?null:this.props.children,p=this.props,u=p.classParentString,g=p.contentOuterClassName,f=p.contentInnerClassName,h="".concat(u,"__trigger ").concat(n," ").concat(r," ").concat(this.state.isClosed?this.props.triggerClassName:this.props.triggerOpenedClassName),d="".concat(u," ").concat(this.state.isClosed?this.props.className:this.props.openedClassName),b="".concat(u,"__contentOuter ").concat(g),m="".concat(u,"__contentInner ").concat(f);return o.a.createElement(s,l({className:d.trim()},this.props.containerElementProps),o.a.createElement(a,l({id:this.triggerId,className:h.trim(),onClick:this.handleTriggerClick,style:this.props.triggerStyle&&this.props.triggerStyle,onKeyPress:function(t){var n=t.key;(" "===n&&"button"!==e.props.triggerTagName.toLowerCase()||"Enter"===n)&&e.handleTriggerClick(t)},tabIndex:this.props.tabIndex&&this.props.tabIndex,"aria-expanded":!this.state.isClosed,"aria-disabled":this.props.triggerDisabled,"aria-controls":this.contentId,role:"button"},this.props.triggerElementProps),i),this.renderNonClickableTriggerElement(),o.a.createElement("div",{id:this.contentId,className:b.trim(),style:t,onTransitionEnd:this.handleTransitionEnd,ref:this.setInnerRef,hidden:this.props.contentHiddenWhenClosed&&this.state.isClosed&&!this.state.inTransition,role:"region","aria-labelledby":this.triggerId},o.a.createElement("div",{className:m.trim()},c)))}}])&&p(t.prototype,n),r&&p(t,r),Object.defineProperty(t,"prototype",{writable:!1}),s}(r.Component);m.propTypes={transitionTime:s.a.number,transitionCloseTime:s.a.number,triggerTagName:s.a.string,easing:s.a.string,open:s.a.bool,containerElementProps:s.a.object,triggerElementProps:s.a.object,contentElementId:s.a.string,classParentString:s.a.string,className:s.a.string,openedClassName:s.a.string,triggerStyle:s.a.object,triggerClassName:s.a.string,triggerOpenedClassName:s.a.string,contentOuterClassName:s.a.string,contentInnerClassName:s.a.string,accordionPosition:s.a.oneOfType([s.a.string,s.a.number]),handleTriggerClick:s.a.func,onOpen:s.a.func,onClose:s.a.func,onOpening:s.a.func,onClosing:s.a.func,onTriggerOpening:s.a.func,onTriggerClosing:s.a.func,trigger:s.a.oneOfType([s.a.string,s.a.element]),triggerWhenOpen:s.a.oneOfType([s.a.string,s.a.element]),triggerDisabled:s.a.bool,lazyRender:s.a.bool,overflowWhenOpen:s.a.oneOf(["hidden","visible","auto","scroll","inherit","initial","unset"]),contentHiddenWhenClosed:s.a.bool,triggerSibling:s.a.oneOfType([s.a.string,s.a.element,s.a.func]),tabIndex:s.a.number,contentContainerTagName:s.a.string,children:s.a.oneOfType([s.a.string,s.a.element])},m.defaultProps={transitionTime:400,transitionCloseTime:null,triggerTagName:"span",easing:"linear",open:!1,classParentString:"Collapsible",triggerDisabled:!1,lazyRender:!1,overflowWhenOpen:"hidden",contentHiddenWhenClosed:!1,openedClassName:"",triggerStyle:null,triggerClassName:"",triggerOpenedClassName:"",contentOuterClassName:"",contentInnerClassName:"",className:"",triggerSibling:null,onOpen:function(){},onClose:function(){},onOpening:function(){},onClosing:function(){},onTriggerOpening:function(){},onTriggerClosing:function(){},tabIndex:null,contentContainerTagName:"div",triggerElementProps:{}};t.default=m}])}));

/***/ }),

/***/ 85518:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({ value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = __webpack_require__(67294);
var React__default = _interopDefault(React);

var UAParser = __webpack_require__(60335);

var ClientUAInstance = new UAParser();
var browser = ClientUAInstance.getBrowser();
var cpu = ClientUAInstance.getCPU();
var device = ClientUAInstance.getDevice();
var engine = ClientUAInstance.getEngine();
var os = ClientUAInstance.getOS();
var ua = ClientUAInstance.getUA();
var setUa = function setUa(userAgentString) {
  return ClientUAInstance.setUA(userAgentString);
};
var parseUserAgent = function parseUserAgent(userAgent) {
  if (!userAgent) {
    console.error('No userAgent string was provided');
    return;
  }

  var UserAgentInstance = new UAParser(userAgent);
  return {
    UA: UserAgentInstance,
    browser: UserAgentInstance.getBrowser(),
    cpu: UserAgentInstance.getCPU(),
    device: UserAgentInstance.getDevice(),
    engine: UserAgentInstance.getEngine(),
    os: UserAgentInstance.getOS(),
    ua: UserAgentInstance.getUA(),
    setUserAgent: function setUserAgent(userAgentString) {
      return UserAgentInstance.setUA(userAgentString);
    }
  };
};

var UAHelper = /*#__PURE__*/Object.freeze({
  ClientUAInstance: ClientUAInstance,
  browser: browser,
  cpu: cpu,
  device: device,
  engine: engine,
  os: os,
  ua: ua,
  setUa: setUa,
  parseUserAgent: parseUserAgent
});

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var DeviceTypes = {
  Mobile: 'mobile',
  Tablet: 'tablet',
  SmartTv: 'smarttv',
  Console: 'console',
  Wearable: 'wearable',
  Embedded: 'embedded',
  Browser: undefined
};
var BrowserTypes = {
  Chrome: 'Chrome',
  Firefox: 'Firefox',
  Opera: 'Opera',
  Yandex: 'Yandex',
  Safari: 'Safari',
  InternetExplorer: 'Internet Explorer',
  Edge: 'Edge',
  Chromium: 'Chromium',
  Ie: 'IE',
  MobileSafari: 'Mobile Safari',
  EdgeChromium: 'Edge Chromium',
  MIUI: 'MIUI Browser',
  SamsungBrowser: 'Samsung Browser'
};
var OsTypes = {
  IOS: 'iOS',
  Android: 'Android',
  WindowsPhone: 'Windows Phone',
  Windows: 'Windows',
  MAC_OS: 'Mac OS'
};
var InitialDeviceTypes = {
  isMobile: false,
  isTablet: false,
  isBrowser: false,
  isSmartTV: false,
  isConsole: false,
  isWearable: false
};

var checkDeviceType = function checkDeviceType(type) {
  switch (type) {
    case DeviceTypes.Mobile:
      return {
        isMobile: true
      };

    case DeviceTypes.Tablet:
      return {
        isTablet: true
      };

    case DeviceTypes.SmartTv:
      return {
        isSmartTV: true
      };

    case DeviceTypes.Console:
      return {
        isConsole: true
      };

    case DeviceTypes.Wearable:
      return {
        isWearable: true
      };

    case DeviceTypes.Browser:
      return {
        isBrowser: true
      };

    case DeviceTypes.Embedded:
      return {
        isEmbedded: true
      };

    default:
      return InitialDeviceTypes;
  }
};
var setUserAgent = function setUserAgent(userAgent) {
  return setUa(userAgent);
};
var setDefaults = function setDefaults(p) {
  var d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'none';
  return p ? p : d;
};
var getNavigatorInstance = function getNavigatorInstance() {
  if (typeof window !== 'undefined') {
    if (window.navigator || navigator) {
      return window.navigator || navigator;
    }
  }

  return false;
};
var isIOS13Check = function isIOS13Check(type) {
  var nav = getNavigatorInstance();
  return nav && nav.platform && (nav.platform.indexOf(type) !== -1 || nav.platform === 'MacIntel' && nav.maxTouchPoints > 1 && !window.MSStream);
};

var browserPayload = function browserPayload(isBrowser, browser, engine, os, ua) {
  return {
    isBrowser: isBrowser,
    browserMajorVersion: setDefaults(browser.major),
    browserFullVersion: setDefaults(browser.version),
    browserName: setDefaults(browser.name),
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};
var mobilePayload = function mobilePayload(type, device, os, ua) {
  return _objectSpread2({}, type, {
    vendor: setDefaults(device.vendor),
    model: setDefaults(device.model),
    os: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    ua: setDefaults(ua)
  });
};
var smartTvPayload = function smartTvPayload(isSmartTV, engine, os, ua) {
  return {
    isSmartTV: isSmartTV,
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};
var consolePayload = function consolePayload(isConsole, engine, os, ua) {
  return {
    isConsole: isConsole,
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};
var wearablePayload = function wearablePayload(isWearable, engine, os, ua) {
  return {
    isWearable: isWearable,
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};
var embeddedPayload = function embeddedPayload(isEmbedded, device, engine, os, ua) {
  return {
    isEmbedded: isEmbedded,
    vendor: setDefaults(device.vendor),
    model: setDefaults(device.model),
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};

function deviceDetect(userAgent) {
  var _ref = userAgent ? parseUserAgent(userAgent) : UAHelper,
      device = _ref.device,
      browser = _ref.browser,
      engine = _ref.engine,
      os = _ref.os,
      ua = _ref.ua;

  var type = checkDeviceType(device.type);
  var isBrowser = type.isBrowser,
      isMobile = type.isMobile,
      isTablet = type.isTablet,
      isSmartTV = type.isSmartTV,
      isConsole = type.isConsole,
      isWearable = type.isWearable,
      isEmbedded = type.isEmbedded;

  if (isBrowser) {
    return browserPayload(isBrowser, browser, engine, os, ua);
  }

  if (isSmartTV) {
    return smartTvPayload(isSmartTV, engine, os, ua);
  }

  if (isConsole) {
    return consolePayload(isConsole, engine, os, ua);
  }

  if (isMobile) {
    return mobilePayload(type, device, os, ua);
  }

  if (isTablet) {
    return mobilePayload(type, device, os, ua);
  }

  if (isWearable) {
    return wearablePayload(isWearable, engine, os, ua);
  }

  if (isEmbedded) {
    return embeddedPayload(isEmbedded, device, engine, os, ua);
  }
}

var isMobileType = function isMobileType(_ref) {
  var type = _ref.type;
  return type === DeviceTypes.Mobile;
};
var isTabletType = function isTabletType(_ref2) {
  var type = _ref2.type;
  return type === DeviceTypes.Tablet;
};
var isMobileAndTabletType = function isMobileAndTabletType(_ref3) {
  var type = _ref3.type;
  return type === DeviceTypes.Mobile || type === DeviceTypes.Tablet;
};
var isSmartTVType = function isSmartTVType(_ref4) {
  var type = _ref4.type;
  return type === DeviceTypes.SmartTv;
};
var isBrowserType = function isBrowserType(_ref5) {
  var type = _ref5.type;
  return type === DeviceTypes.Browser;
};
var isWearableType = function isWearableType(_ref6) {
  var type = _ref6.type;
  return type === DeviceTypes.Wearable;
};
var isConsoleType = function isConsoleType(_ref7) {
  var type = _ref7.type;
  return type === DeviceTypes.Console;
};
var isEmbeddedType = function isEmbeddedType(_ref8) {
  var type = _ref8.type;
  return type === DeviceTypes.Embedded;
};
var getMobileVendor = function getMobileVendor(_ref9) {
  var vendor = _ref9.vendor;
  return setDefaults(vendor);
};
var getMobileModel = function getMobileModel(_ref10) {
  var model = _ref10.model;
  return setDefaults(model);
};
var getDeviceType = function getDeviceType(_ref11) {
  var type = _ref11.type;
  return setDefaults(type, 'browser');
}; // os types

var isAndroidType = function isAndroidType(_ref12) {
  var name = _ref12.name;
  return name === OsTypes.Android;
};
var isWindowsType = function isWindowsType(_ref13) {
  var name = _ref13.name;
  return name === OsTypes.Windows;
};
var isMacOsType = function isMacOsType(_ref14) {
  var name = _ref14.name;
  return name === OsTypes.MAC_OS;
};
var isWinPhoneType = function isWinPhoneType(_ref15) {
  var name = _ref15.name;
  return name === OsTypes.WindowsPhone;
};
var isIOSType = function isIOSType(_ref16) {
  var name = _ref16.name;
  return name === OsTypes.IOS;
};
var getOsVersion = function getOsVersion(_ref17) {
  var version = _ref17.version;
  return setDefaults(version);
};
var getOsName = function getOsName(_ref18) {
  var name = _ref18.name;
  return setDefaults(name);
}; // browser types

var isChromeType = function isChromeType(_ref19) {
  var name = _ref19.name;
  return name === BrowserTypes.Chrome;
};
var isFirefoxType = function isFirefoxType(_ref20) {
  var name = _ref20.name;
  return name === BrowserTypes.Firefox;
};
var isChromiumType = function isChromiumType(_ref21) {
  var name = _ref21.name;
  return name === BrowserTypes.Chromium;
};
var isEdgeType = function isEdgeType(_ref22) {
  var name = _ref22.name;
  return name === BrowserTypes.Edge;
};
var isYandexType = function isYandexType(_ref23) {
  var name = _ref23.name;
  return name === BrowserTypes.Yandex;
};
var isSafariType = function isSafariType(_ref24) {
  var name = _ref24.name;
  return name === BrowserTypes.Safari || name === BrowserTypes.MobileSafari;
};
var isMobileSafariType = function isMobileSafariType(_ref25) {
  var name = _ref25.name;
  return name === BrowserTypes.MobileSafari;
};
var isOperaType = function isOperaType(_ref26) {
  var name = _ref26.name;
  return name === BrowserTypes.Opera;
};
var isIEType = function isIEType(_ref27) {
  var name = _ref27.name;
  return name === BrowserTypes.InternetExplorer || name === BrowserTypes.Ie;
};
var isMIUIType = function isMIUIType(_ref28) {
  var name = _ref28.name;
  return name === BrowserTypes.MIUI;
};
var isSamsungBrowserType = function isSamsungBrowserType(_ref29) {
  var name = _ref29.name;
  return name === BrowserTypes.SamsungBrowser;
};
var getBrowserFullVersion = function getBrowserFullVersion(_ref30) {
  var version = _ref30.version;
  return setDefaults(version);
};
var getBrowserVersion = function getBrowserVersion(_ref31) {
  var major = _ref31.major;
  return setDefaults(major);
};
var getBrowserName = function getBrowserName(_ref32) {
  var name = _ref32.name;
  return setDefaults(name);
}; // engine types

var getEngineName = function getEngineName(_ref33) {
  var name = _ref33.name;
  return setDefaults(name);
};
var getEngineVersion = function getEngineVersion(_ref34) {
  var version = _ref34.version;
  return setDefaults(version);
};
var isElectronType = function isElectronType() {
  var nav = getNavigatorInstance();
  var ua = nav && nav.userAgent && nav.userAgent.toLowerCase();
  return typeof ua === 'string' ? /electron/.test(ua) : false;
};
var isEdgeChromiumType = function isEdgeChromiumType(ua) {
  return typeof ua === 'string' && ua.indexOf('Edg/') !== -1;
};
var getIOS13 = function getIOS13() {
  var nav = getNavigatorInstance();
  return nav && (/iPad|iPhone|iPod/.test(nav.platform) || nav.platform === 'MacIntel' && nav.maxTouchPoints > 1) && !window.MSStream;
};
var getIPad13 = function getIPad13() {
  return isIOS13Check('iPad');
};
var getIphone13 = function getIphone13() {
  return isIOS13Check('iPhone');
};
var getIPod13 = function getIPod13() {
  return isIOS13Check('iPod');
};
var getUseragent = function getUseragent(userAg) {
  return setDefaults(userAg);
};

function buildSelectorsObject(options) {
  var _ref = options ? options : UAHelper,
      device = _ref.device,
      browser = _ref.browser,
      os = _ref.os,
      engine = _ref.engine,
      ua = _ref.ua;

  return {
    isSmartTV: isSmartTVType(device),
    isConsole: isConsoleType(device),
    isWearable: isWearableType(device),
    isEmbedded: isEmbeddedType(device),
    isMobileSafari: isMobileSafariType(browser) || getIPad13(),
    isChromium: isChromiumType(browser),
    isMobile: isMobileAndTabletType(device) || getIPad13(),
    isMobileOnly: isMobileType(device),
    isTablet: isTabletType(device) || getIPad13(),
    isBrowser: isBrowserType(device),
    isDesktop: isBrowserType(device),
    isAndroid: isAndroidType(os),
    isWinPhone: isWinPhoneType(os),
    isIOS: isIOSType(os) || getIPad13(),
    isChrome: isChromeType(browser),
    isFirefox: isFirefoxType(browser),
    isSafari: isSafariType(browser),
    isOpera: isOperaType(browser),
    isIE: isIEType(browser),
    osVersion: getOsVersion(os),
    osName: getOsName(os),
    fullBrowserVersion: getBrowserFullVersion(browser),
    browserVersion: getBrowserVersion(browser),
    browserName: getBrowserName(browser),
    mobileVendor: getMobileVendor(device),
    mobileModel: getMobileModel(device),
    engineName: getEngineName(engine),
    engineVersion: getEngineVersion(engine),
    getUA: getUseragent(ua),
    isEdge: isEdgeType(browser) || isEdgeChromiumType(ua),
    isYandex: isYandexType(browser),
    deviceType: getDeviceType(device),
    isIOS13: getIOS13(),
    isIPad13: getIPad13(),
    isIPhone13: getIphone13(),
    isIPod13: getIPod13(),
    isElectron: isElectronType(),
    isEdgeChromium: isEdgeChromiumType(ua),
    isLegacyEdge: isEdgeType(browser) && !isEdgeChromiumType(ua),
    isWindows: isWindowsType(os),
    isMacOs: isMacOsType(os),
    isMIUI: isMIUIType(browser),
    isSamsungBrowser: isSamsungBrowserType(browser)
  };
}

var isSmartTV = isSmartTVType(device);
var isConsole = isConsoleType(device);
var isWearable = isWearableType(device);
var isEmbedded = isEmbeddedType(device);
var isMobileSafari = isMobileSafariType(browser) || getIPad13();
var isChromium = isChromiumType(browser);
var isMobile = isMobileAndTabletType(device) || getIPad13();
var isMobileOnly = isMobileType(device);
var isTablet = isTabletType(device) || getIPad13();
var isBrowser = isBrowserType(device);
var isDesktop = isBrowserType(device);
var isAndroid = isAndroidType(os);
var isWinPhone = isWinPhoneType(os);
var isIOS = isIOSType(os) || getIPad13();
var isChrome = isChromeType(browser);
var isFirefox = isFirefoxType(browser);
var isSafari = isSafariType(browser);
var isOpera = isOperaType(browser);
var isIE = isIEType(browser);
var osVersion = getOsVersion(os);
var osName = getOsName(os);
var fullBrowserVersion = getBrowserFullVersion(browser);
var browserVersion = getBrowserVersion(browser);
var browserName = getBrowserName(browser);
var mobileVendor = getMobileVendor(device);
var mobileModel = getMobileModel(device);
var engineName = getEngineName(engine);
var engineVersion = getEngineVersion(engine);
var getUA = getUseragent(ua);
var isEdge = isEdgeType(browser) || isEdgeChromiumType(ua);
var isYandex = isYandexType(browser);
var deviceType = getDeviceType(device);
var isIOS13 = getIOS13();
var isIPad13 = getIPad13();
var isIPhone13 = getIphone13();
var isIPod13 = getIPod13();
var isElectron = isElectronType();
var isEdgeChromium = isEdgeChromiumType(ua);
var isLegacyEdge = isEdgeType(browser) && !isEdgeChromiumType(ua);
var isWindows = isWindowsType(os);
var isMacOs = isMacOsType(os);
var isMIUI = isMIUIType(browser);
var isSamsungBrowser = isSamsungBrowserType(browser);
var getSelectorsByUserAgent = function getSelectorsByUserAgent(userAgent) {
  if (!userAgent || typeof userAgent !== 'string') {
    console.error('No valid user agent string was provided');
    return;
  }

  var _UAHelper$parseUserAg = parseUserAgent(userAgent),
      device = _UAHelper$parseUserAg.device,
      browser = _UAHelper$parseUserAg.browser,
      os = _UAHelper$parseUserAg.os,
      engine = _UAHelper$parseUserAg.engine,
      ua = _UAHelper$parseUserAg.ua;

  return buildSelectorsObject({
    device: device,
    browser: browser,
    os: os,
    engine: engine,
    ua: ua
  });
};

var AndroidView = function AndroidView(_ref) {
  var renderWithFragment = _ref.renderWithFragment,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["renderWithFragment", "children"]);

  return isAndroid ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var BrowserView = function BrowserView(_ref2) {
  var renderWithFragment = _ref2.renderWithFragment,
      children = _ref2.children,
      props = _objectWithoutProperties(_ref2, ["renderWithFragment", "children"]);

  return isBrowser ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var IEView = function IEView(_ref3) {
  var renderWithFragment = _ref3.renderWithFragment,
      children = _ref3.children,
      props = _objectWithoutProperties(_ref3, ["renderWithFragment", "children"]);

  return isIE ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var IOSView = function IOSView(_ref4) {
  var renderWithFragment = _ref4.renderWithFragment,
      children = _ref4.children,
      props = _objectWithoutProperties(_ref4, ["renderWithFragment", "children"]);

  return isIOS ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var MobileView = function MobileView(_ref5) {
  var renderWithFragment = _ref5.renderWithFragment,
      children = _ref5.children,
      props = _objectWithoutProperties(_ref5, ["renderWithFragment", "children"]);

  return isMobile ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var TabletView = function TabletView(_ref6) {
  var renderWithFragment = _ref6.renderWithFragment,
      children = _ref6.children,
      props = _objectWithoutProperties(_ref6, ["renderWithFragment", "children"]);

  return isTablet ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var WinPhoneView = function WinPhoneView(_ref7) {
  var renderWithFragment = _ref7.renderWithFragment,
      children = _ref7.children,
      props = _objectWithoutProperties(_ref7, ["renderWithFragment", "children"]);

  return isWinPhone ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var MobileOnlyView = function MobileOnlyView(_ref8) {
  var renderWithFragment = _ref8.renderWithFragment,
      children = _ref8.children,
      viewClassName = _ref8.viewClassName,
      style = _ref8.style,
      props = _objectWithoutProperties(_ref8, ["renderWithFragment", "children", "viewClassName", "style"]);

  return isMobileOnly ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var SmartTVView = function SmartTVView(_ref9) {
  var renderWithFragment = _ref9.renderWithFragment,
      children = _ref9.children,
      props = _objectWithoutProperties(_ref9, ["renderWithFragment", "children"]);

  return isSmartTV ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var ConsoleView = function ConsoleView(_ref10) {
  var renderWithFragment = _ref10.renderWithFragment,
      children = _ref10.children,
      props = _objectWithoutProperties(_ref10, ["renderWithFragment", "children"]);

  return isConsole ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var WearableView = function WearableView(_ref11) {
  var renderWithFragment = _ref11.renderWithFragment,
      children = _ref11.children,
      props = _objectWithoutProperties(_ref11, ["renderWithFragment", "children"]);

  return isWearable ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var CustomView = function CustomView(_ref12) {
  var renderWithFragment = _ref12.renderWithFragment,
      children = _ref12.children,
      viewClassName = _ref12.viewClassName,
      style = _ref12.style,
      condition = _ref12.condition,
      props = _objectWithoutProperties(_ref12, ["renderWithFragment", "children", "viewClassName", "style", "condition"]);

  return condition ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};

function withOrientationChange(WrappedComponent) {
  return /*#__PURE__*/function (_React$Component) {
    _inherits(_class, _React$Component);

    function _class(props) {
      var _this;

      _classCallCheck(this, _class);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(_class).call(this, props));
      _this.isEventListenerAdded = false;
      _this.handleOrientationChange = _this.handleOrientationChange.bind(_assertThisInitialized(_this));
      _this.onOrientationChange = _this.onOrientationChange.bind(_assertThisInitialized(_this));
      _this.onPageLoad = _this.onPageLoad.bind(_assertThisInitialized(_this));
      _this.state = {
        isLandscape: false,
        isPortrait: false
      };
      return _this;
    }

    _createClass(_class, [{
      key: "handleOrientationChange",
      value: function handleOrientationChange() {
        if (!this.isEventListenerAdded) {
          this.isEventListenerAdded = true;
        }

        var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
        this.setState({
          isPortrait: orientation === 0,
          isLandscape: orientation === 90
        });
      }
    }, {
      key: "onOrientationChange",
      value: function onOrientationChange() {
        this.handleOrientationChange();
      }
    }, {
      key: "onPageLoad",
      value: function onPageLoad() {
        this.handleOrientationChange();
      }
    }, {
      key: "componentDidMount",
      value: function componentDidMount() {
        if ((typeof window === "undefined" ? "undefined" : _typeof(window)) !== undefined && isMobile) {
          if (!this.isEventListenerAdded) {
            this.handleOrientationChange();
            window.addEventListener("load", this.onPageLoad, false);
          } else {
            window.removeEventListener("load", this.onPageLoad, false);
          }

          window.addEventListener("resize", this.onOrientationChange, false);
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        window.removeEventListener("resize", this.onOrientationChange, false);
      }
    }, {
      key: "render",
      value: function render() {
        return React__default.createElement(WrappedComponent, _extends({}, this.props, {
          isLandscape: this.state.isLandscape,
          isPortrait: this.state.isPortrait
        }));
      }
    }]);

    return _class;
  }(React__default.Component);
}

function useMobileOrientation() {
  var _useState = React.useState(function () {
    var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
    return {
      isPortrait: orientation === 0,
      isLandscape: orientation === 90,
      orientation: orientation === 0 ? 'portrait' : 'landscape'
    };
  }),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var handleOrientationChange = React.useCallback(function () {
    var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
    var next = {
      isPortrait: orientation === 0,
      isLandscape: orientation === 90,
      orientation: orientation === 0 ? 'portrait' : 'landscape'
    };
    state.orientation !== next.orientation && setState(next);
  }, [state.orientation]);
  React.useEffect(function () {
    if ((typeof window === "undefined" ? "undefined" : _typeof(window)) !== undefined && isMobile) {
      handleOrientationChange();
      window.addEventListener("load", handleOrientationChange, false);
      window.addEventListener("resize", handleOrientationChange, false);
    }

    return function () {
      window.removeEventListener("resize", handleOrientationChange, false);
      window.removeEventListener("load", handleOrientationChange, false);
    };
  }, [handleOrientationChange]);
  return state;
}

function useDeviceData(userAgent) {
  var hookUserAgent = userAgent ? userAgent : window.navigator.userAgent;
  return parseUserAgent(hookUserAgent);
}

function useDeviceSelectors(userAgent) {
  var hookUserAgent = userAgent ? userAgent : window.navigator.userAgent;
  var deviceData = useDeviceData(hookUserAgent);
  var selectors = buildSelectorsObject(deviceData);
  return [selectors, deviceData];
}

__webpack_unused_export__ = AndroidView;
__webpack_unused_export__ = BrowserTypes;
exports.I3 = BrowserView;
__webpack_unused_export__ = ConsoleView;
__webpack_unused_export__ = CustomView;
__webpack_unused_export__ = IEView;
__webpack_unused_export__ = IOSView;
__webpack_unused_export__ = MobileOnlyView;
__webpack_unused_export__ = MobileView;
__webpack_unused_export__ = OsTypes;
__webpack_unused_export__ = SmartTVView;
__webpack_unused_export__ = TabletView;
__webpack_unused_export__ = WearableView;
__webpack_unused_export__ = WinPhoneView;
__webpack_unused_export__ = browserName;
__webpack_unused_export__ = browserVersion;
__webpack_unused_export__ = deviceDetect;
__webpack_unused_export__ = deviceType;
__webpack_unused_export__ = engineName;
__webpack_unused_export__ = engineVersion;
__webpack_unused_export__ = fullBrowserVersion;
__webpack_unused_export__ = getSelectorsByUserAgent;
__webpack_unused_export__ = getUA;
__webpack_unused_export__ = isAndroid;
__webpack_unused_export__ = isBrowser;
__webpack_unused_export__ = isChrome;
__webpack_unused_export__ = isChromium;
__webpack_unused_export__ = isConsole;
__webpack_unused_export__ = isDesktop;
__webpack_unused_export__ = isEdge;
__webpack_unused_export__ = isEdgeChromium;
__webpack_unused_export__ = isElectron;
__webpack_unused_export__ = isEmbedded;
__webpack_unused_export__ = isFirefox;
__webpack_unused_export__ = isIE;
exports.gn = isIOS;
__webpack_unused_export__ = isIOS13;
__webpack_unused_export__ = isIPad13;
__webpack_unused_export__ = isIPhone13;
__webpack_unused_export__ = isIPod13;
__webpack_unused_export__ = isLegacyEdge;
__webpack_unused_export__ = isMIUI;
__webpack_unused_export__ = isMacOs;
exports.tq = isMobile;
__webpack_unused_export__ = isMobileOnly;
__webpack_unused_export__ = isMobileSafari;
__webpack_unused_export__ = isOpera;
exports.G6 = isSafari;
__webpack_unused_export__ = isSamsungBrowser;
__webpack_unused_export__ = isSmartTV;
exports.Em = isTablet;
__webpack_unused_export__ = isWearable;
__webpack_unused_export__ = isWinPhone;
__webpack_unused_export__ = isWindows;
__webpack_unused_export__ = isYandex;
__webpack_unused_export__ = mobileModel;
__webpack_unused_export__ = mobileVendor;
__webpack_unused_export__ = osName;
__webpack_unused_export__ = osVersion;
__webpack_unused_export__ = parseUserAgent;
__webpack_unused_export__ = setUserAgent;
__webpack_unused_export__ = useDeviceData;
__webpack_unused_export__ = useDeviceSelectors;
__webpack_unused_export__ = useMobileOrientation;
exports.Qe = withOrientationChange;


/***/ }),

/***/ 60335:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/* UAParser.js v1.0.40
   Copyright © 2012-2024 Faisal Salman <f@faisalman.com>
   MIT License */
(function(window,undefined){"use strict";var LIBVERSION="1.0.40",EMPTY="",UNKNOWN="?",FUNC_TYPE="function",UNDEF_TYPE="undefined",OBJ_TYPE="object",STR_TYPE="string",MAJOR="major",MODEL="model",NAME="name",TYPE="type",VENDOR="vendor",VERSION="version",ARCHITECTURE="architecture",CONSOLE="console",MOBILE="mobile",TABLET="tablet",SMARTTV="smarttv",WEARABLE="wearable",EMBEDDED="embedded",UA_MAX_LENGTH=500;var AMAZON="Amazon",APPLE="Apple",ASUS="ASUS",BLACKBERRY="BlackBerry",BROWSER="Browser",CHROME="Chrome",EDGE="Edge",FIREFOX="Firefox",GOOGLE="Google",HUAWEI="Huawei",LG="LG",MICROSOFT="Microsoft",MOTOROLA="Motorola",OPERA="Opera",SAMSUNG="Samsung",SHARP="Sharp",SONY="Sony",XIAOMI="Xiaomi",ZEBRA="Zebra",FACEBOOK="Facebook",CHROMIUM_OS="Chromium OS",MAC_OS="Mac OS",SUFFIX_BROWSER=" Browser";var extend=function(regexes,extensions){var mergedRegexes={};for(var i in regexes){if(extensions[i]&&extensions[i].length%2===0){mergedRegexes[i]=extensions[i].concat(regexes[i])}else{mergedRegexes[i]=regexes[i]}}return mergedRegexes},enumerize=function(arr){var enums={};for(var i=0;i<arr.length;i++){enums[arr[i].toUpperCase()]=arr[i]}return enums},has=function(str1,str2){return typeof str1===STR_TYPE?lowerize(str2).indexOf(lowerize(str1))!==-1:false},lowerize=function(str){return str.toLowerCase()},majorize=function(version){return typeof version===STR_TYPE?version.replace(/[^\d\.]/g,EMPTY).split(".")[0]:undefined},trim=function(str,len){if(typeof str===STR_TYPE){str=str.replace(/^\s\s*/,EMPTY);return typeof len===UNDEF_TYPE?str:str.substring(0,UA_MAX_LENGTH)}};var rgxMapper=function(ua,arrays){var i=0,j,k,p,q,matches,match;while(i<arrays.length&&!matches){var regex=arrays[i],props=arrays[i+1];j=k=0;while(j<regex.length&&!matches){if(!regex[j]){break}matches=regex[j++].exec(ua);if(!!matches){for(p=0;p<props.length;p++){match=matches[++k];q=props[p];if(typeof q===OBJ_TYPE&&q.length>0){if(q.length===2){if(typeof q[1]==FUNC_TYPE){this[q[0]]=q[1].call(this,match)}else{this[q[0]]=q[1]}}else if(q.length===3){if(typeof q[1]===FUNC_TYPE&&!(q[1].exec&&q[1].test)){this[q[0]]=match?q[1].call(this,match,q[2]):undefined}else{this[q[0]]=match?match.replace(q[1],q[2]):undefined}}else if(q.length===4){this[q[0]]=match?q[3].call(this,match.replace(q[1],q[2])):undefined}}else{this[q]=match?match:undefined}}}}i+=2}},strMapper=function(str,map){for(var i in map){if(typeof map[i]===OBJ_TYPE&&map[i].length>0){for(var j=0;j<map[i].length;j++){if(has(map[i][j],str)){return i===UNKNOWN?undefined:i}}}else if(has(map[i],str)){return i===UNKNOWN?undefined:i}}return map.hasOwnProperty("*")?map["*"]:str};var oldSafariMap={"1.0":"/8",1.2:"/1",1.3:"/3","2.0":"/412","2.0.2":"/416","2.0.3":"/417","2.0.4":"/419","?":"/"},windowsVersionMap={ME:"4.90","NT 3.11":"NT3.51","NT 4.0":"NT4.0",2e3:"NT 5.0",XP:["NT 5.1","NT 5.2"],Vista:"NT 6.0",7:"NT 6.1",8:"NT 6.2",8.1:"NT 6.3",10:["NT 6.4","NT 10.0"],RT:"ARM"};var regexes={browser:[[/\b(?:crmo|crios)\/([\w\.]+)/i],[VERSION,[NAME,"Chrome"]],[/edg(?:e|ios|a)?\/([\w\.]+)/i],[VERSION,[NAME,"Edge"]],[/(opera mini)\/([-\w\.]+)/i,/(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,/(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i],[NAME,VERSION],[/opios[\/ ]+([\w\.]+)/i],[VERSION,[NAME,OPERA+" Mini"]],[/\bop(?:rg)?x\/([\w\.]+)/i],[VERSION,[NAME,OPERA+" GX"]],[/\bopr\/([\w\.]+)/i],[VERSION,[NAME,OPERA]],[/\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i],[VERSION,[NAME,"Baidu"]],[/\b(?:mxbrowser|mxios|myie2)\/?([-\w\.]*)\b/i],[VERSION,[NAME,"Maxthon"]],[/(kindle)\/([\w\.]+)/i,/(lunascape|maxthon|netfront|jasmine|blazer|sleipnir)[\/ ]?([\w\.]*)/i,/(avant|iemobile|slim(?:browser|boat|jet))[\/ ]?([\d\.]*)/i,/(?:ms|\()(ie) ([\w\.]+)/i,/(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|duckduckgo|klar|helio|(?=comodo_)?dragon)\/([-\w\.]+)/i,/(heytap|ovi|115)browser\/([\d\.]+)/i,/(weibo)__([\d\.]+)/i],[NAME,VERSION],[/quark(?:pc)?\/([-\w\.]+)/i],[VERSION,[NAME,"Quark"]],[/\bddg\/([\w\.]+)/i],[VERSION,[NAME,"DuckDuckGo"]],[/(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i],[VERSION,[NAME,"UC"+BROWSER]],[/microm.+\bqbcore\/([\w\.]+)/i,/\bqbcore\/([\w\.]+).+microm/i,/micromessenger\/([\w\.]+)/i],[VERSION,[NAME,"WeChat"]],[/konqueror\/([\w\.]+)/i],[VERSION,[NAME,"Konqueror"]],[/trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i],[VERSION,[NAME,"IE"]],[/ya(?:search)?browser\/([\w\.]+)/i],[VERSION,[NAME,"Yandex"]],[/slbrowser\/([\w\.]+)/i],[VERSION,[NAME,"Smart Lenovo "+BROWSER]],[/(avast|avg)\/([\w\.]+)/i],[[NAME,/(.+)/,"$1 Secure "+BROWSER],VERSION],[/\bfocus\/([\w\.]+)/i],[VERSION,[NAME,FIREFOX+" Focus"]],[/\bopt\/([\w\.]+)/i],[VERSION,[NAME,OPERA+" Touch"]],[/coc_coc\w+\/([\w\.]+)/i],[VERSION,[NAME,"Coc Coc"]],[/dolfin\/([\w\.]+)/i],[VERSION,[NAME,"Dolphin"]],[/coast\/([\w\.]+)/i],[VERSION,[NAME,OPERA+" Coast"]],[/miuibrowser\/([\w\.]+)/i],[VERSION,[NAME,"MIUI"+SUFFIX_BROWSER]],[/fxios\/([\w\.-]+)/i],[VERSION,[NAME,FIREFOX]],[/\bqihoobrowser\/?([\w\.]*)/i],[VERSION,[NAME,"360"]],[/\b(qq)\/([\w\.]+)/i],[[NAME,/(.+)/,"$1Browser"],VERSION],[/(oculus|sailfish|huawei|vivo|pico)browser\/([\w\.]+)/i],[[NAME,/(.+)/,"$1"+SUFFIX_BROWSER],VERSION],[/samsungbrowser\/([\w\.]+)/i],[VERSION,[NAME,SAMSUNG+" Internet"]],[/metasr[\/ ]?([\d\.]+)/i],[VERSION,[NAME,"Sogou Explorer"]],[/(sogou)mo\w+\/([\d\.]+)/i],[[NAME,"Sogou Mobile"],VERSION],[/(electron)\/([\w\.]+) safari/i,/(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,/m?(qqbrowser|2345(?=browser|chrome|explorer))\w*[\/ ]?v?([\w\.]+)/i],[NAME,VERSION],[/(lbbrowser|rekonq)/i,/\[(linkedin)app\]/i],[NAME],[/ome\/([\w\.]+) \w* ?(iron) saf/i,/ome\/([\w\.]+).+qihu (360)[es]e/i],[VERSION,NAME],[/((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i],[[NAME,FACEBOOK],VERSION],[/(Klarna)\/([\w\.]+)/i,/(kakao(?:talk|story))[\/ ]([\w\.]+)/i,/(naver)\(.*?(\d+\.[\w\.]+).*\)/i,/safari (line)\/([\w\.]+)/i,/\b(line)\/([\w\.]+)\/iab/i,/(alipay)client\/([\w\.]+)/i,/(twitter)(?:and| f.+e\/([\w\.]+))/i,/(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i],[NAME,VERSION],[/\bgsa\/([\w\.]+) .*safari\//i],[VERSION,[NAME,"GSA"]],[/musical_ly(?:.+app_?version\/|_)([\w\.]+)/i],[VERSION,[NAME,"TikTok"]],[/headlesschrome(?:\/([\w\.]+)| )/i],[VERSION,[NAME,CHROME+" Headless"]],[/ wv\).+(chrome)\/([\w\.]+)/i],[[NAME,CHROME+" WebView"],VERSION],[/droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i],[VERSION,[NAME,"Android "+BROWSER]],[/(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i],[NAME,VERSION],[/version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i],[VERSION,[NAME,"Mobile Safari"]],[/version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i],[VERSION,NAME],[/webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i],[NAME,[VERSION,strMapper,oldSafariMap]],[/(webkit|khtml)\/([\w\.]+)/i],[NAME,VERSION],[/(navigator|netscape\d?)\/([-\w\.]+)/i],[[NAME,"Netscape"],VERSION],[/(wolvic|librewolf)\/([\w\.]+)/i],[NAME,VERSION],[/mobile vr; rv:([\w\.]+)\).+firefox/i],[VERSION,[NAME,FIREFOX+" Reality"]],[/ekiohf.+(flow)\/([\w\.]+)/i,/(swiftfox)/i,/(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror)[\/ ]?([\w\.\+]+)/i,/(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,/(firefox)\/([\w\.]+)/i,/(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,/(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,/(links) \(([\w\.]+)/i],[NAME,[VERSION,/_/g,"."]],[/(cobalt)\/([\w\.]+)/i],[NAME,[VERSION,/master.|lts./,""]]],cpu:[[/(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i],[[ARCHITECTURE,"amd64"]],[/(ia32(?=;))/i],[[ARCHITECTURE,lowerize]],[/((?:i[346]|x)86)[;\)]/i],[[ARCHITECTURE,"ia32"]],[/\b(aarch64|arm(v?8e?l?|_?64))\b/i],[[ARCHITECTURE,"arm64"]],[/\b(arm(?:v[67])?ht?n?[fl]p?)\b/i],[[ARCHITECTURE,"armhf"]],[/windows (ce|mobile); ppc;/i],[[ARCHITECTURE,"arm"]],[/((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i],[[ARCHITECTURE,/ower/,EMPTY,lowerize]],[/(sun4\w)[;\)]/i],[[ARCHITECTURE,"sparc"]],[/((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i],[[ARCHITECTURE,lowerize]]],device:[[/\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i],[MODEL,[VENDOR,SAMSUNG],[TYPE,TABLET]],[/\b((?:s[cgp]h|gt|sm)-(?![lr])\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,/samsung[- ]((?!sm-[lr])[-\w]+)/i,/sec-(sgh\w+)/i],[MODEL,[VENDOR,SAMSUNG],[TYPE,MOBILE]],[/(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i],[MODEL,[VENDOR,APPLE],[TYPE,MOBILE]],[/\((ipad);[-\w\),; ]+apple/i,/applecoremedia\/[\w\.]+ \((ipad)/i,/\b(ipad)\d\d?,\d\d?[;\]].+ios/i],[MODEL,[VENDOR,APPLE],[TYPE,TABLET]],[/(macintosh);/i],[MODEL,[VENDOR,APPLE]],[/\b(sh-?[altvz]?\d\d[a-ekm]?)/i],[MODEL,[VENDOR,SHARP],[TYPE,MOBILE]],[/(?:honor)([-\w ]+)[;\)]/i],[MODEL,[VENDOR,"Honor"],[TYPE,MOBILE]],[/\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i],[MODEL,[VENDOR,HUAWEI],[TYPE,TABLET]],[/(?:huawei)([-\w ]+)[;\)]/i,/\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i],[MODEL,[VENDOR,HUAWEI],[TYPE,MOBILE]],[/\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,/\b; (\w+) build\/hm\1/i,/\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,/\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,/oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i,/\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite|pro)?)(?: bui|\))/i],[[MODEL,/_/g," "],[VENDOR,XIAOMI],[TYPE,MOBILE]],[/oid[^\)]+; (2\d{4}(283|rpbf)[cgl])( bui|\))/i,/\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i],[[MODEL,/_/g," "],[VENDOR,XIAOMI],[TYPE,TABLET]],[/; (\w+) bui.+ oppo/i,/\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i],[MODEL,[VENDOR,"OPPO"],[TYPE,MOBILE]],[/\b(opd2\d{3}a?) bui/i],[MODEL,[VENDOR,"OPPO"],[TYPE,TABLET]],[/vivo (\w+)(?: bui|\))/i,/\b(v[12]\d{3}\w?[at])(?: bui|;)/i],[MODEL,[VENDOR,"Vivo"],[TYPE,MOBILE]],[/\b(rmx[1-3]\d{3})(?: bui|;|\))/i],[MODEL,[VENDOR,"Realme"],[TYPE,MOBILE]],[/\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,/\bmot(?:orola)?[- ](\w*)/i,/((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i],[MODEL,[VENDOR,MOTOROLA],[TYPE,MOBILE]],[/\b(mz60\d|xoom[2 ]{0,2}) build\//i],[MODEL,[VENDOR,MOTOROLA],[TYPE,TABLET]],[/((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i],[MODEL,[VENDOR,LG],[TYPE,TABLET]],[/(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,/\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,/\blg-?([\d\w]+) bui/i],[MODEL,[VENDOR,LG],[TYPE,MOBILE]],[/(ideatab[-\w ]+)/i,/lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i],[MODEL,[VENDOR,"Lenovo"],[TYPE,TABLET]],[/(?:maemo|nokia).*(n900|lumia \d+)/i,/nokia[-_ ]?([-\w\.]*)/i],[[MODEL,/_/g," "],[VENDOR,"Nokia"],[TYPE,MOBILE]],[/(pixel c)\b/i],[MODEL,[VENDOR,GOOGLE],[TYPE,TABLET]],[/droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i],[MODEL,[VENDOR,GOOGLE],[TYPE,MOBILE]],[/droid.+; (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i],[MODEL,[VENDOR,SONY],[TYPE,MOBILE]],[/sony tablet [ps]/i,/\b(?:sony)?sgp\w+(?: bui|\))/i],[[MODEL,"Xperia Tablet"],[VENDOR,SONY],[TYPE,TABLET]],[/ (kb2005|in20[12]5|be20[12][59])\b/i,/(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i],[MODEL,[VENDOR,"OnePlus"],[TYPE,MOBILE]],[/(alexa)webm/i,/(kf[a-z]{2}wi|aeo(?!bc)\w\w)( bui|\))/i,/(kf[a-z]+)( bui|\)).+silk\//i],[MODEL,[VENDOR,AMAZON],[TYPE,TABLET]],[/((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i],[[MODEL,/(.+)/g,"Fire Phone $1"],[VENDOR,AMAZON],[TYPE,MOBILE]],[/(playbook);[-\w\),; ]+(rim)/i],[MODEL,VENDOR,[TYPE,TABLET]],[/\b((?:bb[a-f]|st[hv])100-\d)/i,/\(bb10; (\w+)/i],[MODEL,[VENDOR,BLACKBERRY],[TYPE,MOBILE]],[/(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i],[MODEL,[VENDOR,ASUS],[TYPE,TABLET]],[/ (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i],[MODEL,[VENDOR,ASUS],[TYPE,MOBILE]],[/(nexus 9)/i],[MODEL,[VENDOR,"HTC"],[TYPE,TABLET]],[/(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,/(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,/(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i],[VENDOR,[MODEL,/_/g," "],[TYPE,MOBILE]],[/droid [\w\.]+; ((?:8[14]9[16]|9(?:0(?:48|60|8[01])|1(?:3[27]|66)|2(?:6[69]|9[56])|466))[gqswx])\w*(\)| bui)/i],[MODEL,[VENDOR,"TCL"],[TYPE,TABLET]],[/(itel) ((\w+))/i],[[VENDOR,lowerize],MODEL,[TYPE,strMapper,{tablet:["p10001l","w7001"],"*":"mobile"}]],[/droid.+; ([ab][1-7]-?[0178a]\d\d?)/i],[MODEL,[VENDOR,"Acer"],[TYPE,TABLET]],[/droid.+; (m[1-5] note) bui/i,/\bmz-([-\w]{2,})/i],[MODEL,[VENDOR,"Meizu"],[TYPE,MOBILE]],[/; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i],[MODEL,[VENDOR,"Ulefone"],[TYPE,MOBILE]],[/; (energy ?\w+)(?: bui|\))/i,/; energizer ([\w ]+)(?: bui|\))/i],[MODEL,[VENDOR,"Energizer"],[TYPE,MOBILE]],[/; cat (b35);/i,/; (b15q?|s22 flip|s48c|s62 pro)(?: bui|\))/i],[MODEL,[VENDOR,"Cat"],[TYPE,MOBILE]],[/((?:new )?andromax[\w- ]+)(?: bui|\))/i],[MODEL,[VENDOR,"Smartfren"],[TYPE,MOBILE]],[/droid.+; (a(?:015|06[35]|142p?))/i],[MODEL,[VENDOR,"Nothing"],[TYPE,MOBILE]],[/(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron|infinix|tecno|micromax|advan)[-_ ]?([-\w]*)/i,/; (imo) ((?!tab)[\w ]+?)(?: bui|\))/i,/(hp) ([\w ]+\w)/i,/(asus)-?(\w+)/i,/(microsoft); (lumia[\w ]+)/i,/(lenovo)[-_ ]?([-\w]+)/i,/(jolla)/i,/(oppo) ?([\w ]+) bui/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/(imo) (tab \w+)/i,/(kobo)\s(ereader|touch)/i,/(archos) (gamepad2?)/i,/(hp).+(touchpad(?!.+tablet)|tablet)/i,/(kindle)\/([\w\.]+)/i,/(nook)[\w ]+build\/(\w+)/i,/(dell) (strea[kpr\d ]*[\dko])/i,/(le[- ]+pan)[- ]+(\w{1,9}) bui/i,/(trinity)[- ]*(t\d{3}) bui/i,/(gigaset)[- ]+(q\w{1,9}) bui/i,/(vodafone) ([\w ]+)(?:\)| bui)/i],[VENDOR,MODEL,[TYPE,TABLET]],[/(surface duo)/i],[MODEL,[VENDOR,MICROSOFT],[TYPE,TABLET]],[/droid [\d\.]+; (fp\du?)(?: b|\))/i],[MODEL,[VENDOR,"Fairphone"],[TYPE,MOBILE]],[/(u304aa)/i],[MODEL,[VENDOR,"AT&T"],[TYPE,MOBILE]],[/\bsie-(\w*)/i],[MODEL,[VENDOR,"Siemens"],[TYPE,MOBILE]],[/\b(rct\w+) b/i],[MODEL,[VENDOR,"RCA"],[TYPE,TABLET]],[/\b(venue[\d ]{2,7}) b/i],[MODEL,[VENDOR,"Dell"],[TYPE,TABLET]],[/\b(q(?:mv|ta)\w+) b/i],[MODEL,[VENDOR,"Verizon"],[TYPE,TABLET]],[/\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i],[MODEL,[VENDOR,"Barnes & Noble"],[TYPE,TABLET]],[/\b(tm\d{3}\w+) b/i],[MODEL,[VENDOR,"NuVision"],[TYPE,TABLET]],[/\b(k88) b/i],[MODEL,[VENDOR,"ZTE"],[TYPE,TABLET]],[/\b(nx\d{3}j) b/i],[MODEL,[VENDOR,"ZTE"],[TYPE,MOBILE]],[/\b(gen\d{3}) b.+49h/i],[MODEL,[VENDOR,"Swiss"],[TYPE,MOBILE]],[/\b(zur\d{3}) b/i],[MODEL,[VENDOR,"Swiss"],[TYPE,TABLET]],[/\b((zeki)?tb.*\b) b/i],[MODEL,[VENDOR,"Zeki"],[TYPE,TABLET]],[/\b([yr]\d{2}) b/i,/\b(dragon[- ]+touch |dt)(\w{5}) b/i],[[VENDOR,"Dragon Touch"],MODEL,[TYPE,TABLET]],[/\b(ns-?\w{0,9}) b/i],[MODEL,[VENDOR,"Insignia"],[TYPE,TABLET]],[/\b((nxa|next)-?\w{0,9}) b/i],[MODEL,[VENDOR,"NextBook"],[TYPE,TABLET]],[/\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i],[[VENDOR,"Voice"],MODEL,[TYPE,MOBILE]],[/\b(lvtel\-)?(v1[12]) b/i],[[VENDOR,"LvTel"],MODEL,[TYPE,MOBILE]],[/\b(ph-1) /i],[MODEL,[VENDOR,"Essential"],[TYPE,MOBILE]],[/\b(v(100md|700na|7011|917g).*\b) b/i],[MODEL,[VENDOR,"Envizen"],[TYPE,TABLET]],[/\b(trio[-\w\. ]+) b/i],[MODEL,[VENDOR,"MachSpeed"],[TYPE,TABLET]],[/\btu_(1491) b/i],[MODEL,[VENDOR,"Rotor"],[TYPE,TABLET]],[/(shield[\w ]+) b/i],[MODEL,[VENDOR,"Nvidia"],[TYPE,TABLET]],[/(sprint) (\w+)/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/(kin\.[onetw]{3})/i],[[MODEL,/\./g," "],[VENDOR,MICROSOFT],[TYPE,MOBILE]],[/droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i],[MODEL,[VENDOR,ZEBRA],[TYPE,TABLET]],[/droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i],[MODEL,[VENDOR,ZEBRA],[TYPE,MOBILE]],[/smart-tv.+(samsung)/i],[VENDOR,[TYPE,SMARTTV]],[/hbbtv.+maple;(\d+)/i],[[MODEL,/^/,"SmartTV"],[VENDOR,SAMSUNG],[TYPE,SMARTTV]],[/(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i],[[VENDOR,LG],[TYPE,SMARTTV]],[/(apple) ?tv/i],[VENDOR,[MODEL,APPLE+" TV"],[TYPE,SMARTTV]],[/crkey/i],[[MODEL,CHROME+"cast"],[VENDOR,GOOGLE],[TYPE,SMARTTV]],[/droid.+aft(\w+)( bui|\))/i],[MODEL,[VENDOR,AMAZON],[TYPE,SMARTTV]],[/\(dtv[\);].+(aquos)/i,/(aquos-tv[\w ]+)\)/i],[MODEL,[VENDOR,SHARP],[TYPE,SMARTTV]],[/(bravia[\w ]+)( bui|\))/i],[MODEL,[VENDOR,SONY],[TYPE,SMARTTV]],[/(mitv-\w{5}) bui/i],[MODEL,[VENDOR,XIAOMI],[TYPE,SMARTTV]],[/Hbbtv.*(technisat) (.*);/i],[VENDOR,MODEL,[TYPE,SMARTTV]],[/\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,/hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i],[[VENDOR,trim],[MODEL,trim],[TYPE,SMARTTV]],[/\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i],[[TYPE,SMARTTV]],[/(ouya)/i,/(nintendo) ([wids3utch]+)/i],[VENDOR,MODEL,[TYPE,CONSOLE]],[/droid.+; (shield) bui/i],[MODEL,[VENDOR,"Nvidia"],[TYPE,CONSOLE]],[/(playstation [345portablevi]+)/i],[MODEL,[VENDOR,SONY],[TYPE,CONSOLE]],[/\b(xbox(?: one)?(?!; xbox))[\); ]/i],[MODEL,[VENDOR,MICROSOFT],[TYPE,CONSOLE]],[/\b(sm-[lr]\d\d[05][fnuw]?s?)\b/i],[MODEL,[VENDOR,SAMSUNG],[TYPE,WEARABLE]],[/((pebble))app/i],[VENDOR,MODEL,[TYPE,WEARABLE]],[/(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i],[MODEL,[VENDOR,APPLE],[TYPE,WEARABLE]],[/droid.+; (glass) \d/i],[MODEL,[VENDOR,GOOGLE],[TYPE,WEARABLE]],[/droid.+; (wt63?0{2,3})\)/i],[MODEL,[VENDOR,ZEBRA],[TYPE,WEARABLE]],[/droid.+; (glass) \d/i],[MODEL,[VENDOR,GOOGLE],[TYPE,WEARABLE]],[/(pico) (4|neo3(?: link|pro)?)/i],[VENDOR,MODEL,[TYPE,WEARABLE]],[/; (quest( \d| pro)?)/i],[MODEL,[VENDOR,FACEBOOK],[TYPE,WEARABLE]],[/(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i],[VENDOR,[TYPE,EMBEDDED]],[/(aeobc)\b/i],[MODEL,[VENDOR,AMAZON],[TYPE,EMBEDDED]],[/droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i],[MODEL,[TYPE,MOBILE]],[/droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i],[MODEL,[TYPE,TABLET]],[/\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i],[[TYPE,TABLET]],[/(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i],[[TYPE,MOBILE]],[/(android[-\w\. ]{0,9});.+buil/i],[MODEL,[VENDOR,"Generic"]]],engine:[[/windows.+ edge\/([\w\.]+)/i],[VERSION,[NAME,EDGE+"HTML"]],[/(arkweb)\/([\w\.]+)/i],[NAME,VERSION],[/webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i],[VERSION,[NAME,"Blink"]],[/(presto)\/([\w\.]+)/i,/(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna|servo)\/([\w\.]+)/i,/ekioh(flow)\/([\w\.]+)/i,/(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,/(icab)[\/ ]([23]\.[\d\.]+)/i,/\b(libweb)/i],[NAME,VERSION],[/rv\:([\w\.]{1,9})\b.+(gecko)/i],[VERSION,NAME]],os:[[/microsoft (windows) (vista|xp)/i],[NAME,VERSION],[/(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i],[NAME,[VERSION,strMapper,windowsVersionMap]],[/windows nt 6\.2; (arm)/i,/windows[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i,/(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i],[[VERSION,strMapper,windowsVersionMap],[NAME,"Windows"]],[/ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,/(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i,/cfnetwork\/.+darwin/i],[[VERSION,/_/g,"."],[NAME,"iOS"]],[/(mac os x) ?([\w\. ]*)/i,/(macintosh|mac_powerpc\b)(?!.+haiku)/i],[[NAME,MAC_OS],[VERSION,/_/g,"."]],[/droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i],[VERSION,NAME],[/(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish|openharmony)[-\/ ]?([\w\.]*)/i,/(blackberry)\w*\/([\w\.]*)/i,/(tizen|kaios)[\/ ]([\w\.]+)/i,/\((series40);/i],[NAME,VERSION],[/\(bb(10);/i],[VERSION,[NAME,BLACKBERRY]],[/(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i],[VERSION,[NAME,"Symbian"]],[/mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i],[VERSION,[NAME,FIREFOX+" OS"]],[/web0s;.+rt(tv)/i,/\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i],[VERSION,[NAME,"webOS"]],[/watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i],[VERSION,[NAME,"watchOS"]],[/crkey\/([\d\.]+)/i],[VERSION,[NAME,CHROME+"cast"]],[/(cros) [\w]+(?:\)| ([\w\.]+)\b)/i],[[NAME,CHROMIUM_OS],VERSION],[/panasonic;(viera)/i,/(netrange)mmh/i,/(nettv)\/(\d+\.[\w\.]+)/i,/(nintendo|playstation) ([wids345portablevuch]+)/i,/(xbox); +xbox ([^\);]+)/i,/\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,/(mint)[\/\(\) ]?(\w*)/i,/(mageia|vectorlinux)[; ]/i,/([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,/(hurd|linux) ?([\w\.]*)/i,/(gnu) ?([\w\.]*)/i,/\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,/(haiku) (\w+)/i],[NAME,VERSION],[/(sunos) ?([\w\.\d]*)/i],[[NAME,"Solaris"],VERSION],[/((?:open)?solaris)[-\/ ]?([\w\.]*)/i,/(aix) ((\d)(?=\.|\)| )[\w\.])*/i,/\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,/(unix) ?([\w\.]*)/i],[NAME,VERSION]]};var UAParser=function(ua,extensions){if(typeof ua===OBJ_TYPE){extensions=ua;ua=undefined}if(!(this instanceof UAParser)){return new UAParser(ua,extensions).getResult()}var _navigator=typeof window!==UNDEF_TYPE&&window.navigator?window.navigator:undefined;var _ua=ua||(_navigator&&_navigator.userAgent?_navigator.userAgent:EMPTY);var _uach=_navigator&&_navigator.userAgentData?_navigator.userAgentData:undefined;var _rgxmap=extensions?extend(regexes,extensions):regexes;var _isSelfNav=_navigator&&_navigator.userAgent==_ua;this.getBrowser=function(){var _browser={};_browser[NAME]=undefined;_browser[VERSION]=undefined;rgxMapper.call(_browser,_ua,_rgxmap.browser);_browser[MAJOR]=majorize(_browser[VERSION]);if(_isSelfNav&&_navigator&&_navigator.brave&&typeof _navigator.brave.isBrave==FUNC_TYPE){_browser[NAME]="Brave"}return _browser};this.getCPU=function(){var _cpu={};_cpu[ARCHITECTURE]=undefined;rgxMapper.call(_cpu,_ua,_rgxmap.cpu);return _cpu};this.getDevice=function(){var _device={};_device[VENDOR]=undefined;_device[MODEL]=undefined;_device[TYPE]=undefined;rgxMapper.call(_device,_ua,_rgxmap.device);if(_isSelfNav&&!_device[TYPE]&&_uach&&_uach.mobile){_device[TYPE]=MOBILE}if(_isSelfNav&&_device[MODEL]=="Macintosh"&&_navigator&&typeof _navigator.standalone!==UNDEF_TYPE&&_navigator.maxTouchPoints&&_navigator.maxTouchPoints>2){_device[MODEL]="iPad";_device[TYPE]=TABLET}return _device};this.getEngine=function(){var _engine={};_engine[NAME]=undefined;_engine[VERSION]=undefined;rgxMapper.call(_engine,_ua,_rgxmap.engine);return _engine};this.getOS=function(){var _os={};_os[NAME]=undefined;_os[VERSION]=undefined;rgxMapper.call(_os,_ua,_rgxmap.os);if(_isSelfNav&&!_os[NAME]&&_uach&&_uach.platform&&_uach.platform!="Unknown"){_os[NAME]=_uach.platform.replace(/chrome os/i,CHROMIUM_OS).replace(/macos/i,MAC_OS)}return _os};this.getResult=function(){return{ua:this.getUA(),browser:this.getBrowser(),engine:this.getEngine(),os:this.getOS(),device:this.getDevice(),cpu:this.getCPU()}};this.getUA=function(){return _ua};this.setUA=function(ua){_ua=typeof ua===STR_TYPE&&ua.length>UA_MAX_LENGTH?trim(ua,UA_MAX_LENGTH):ua;return this};this.setUA(_ua);return this};UAParser.VERSION=LIBVERSION;UAParser.BROWSER=enumerize([NAME,VERSION,MAJOR]);UAParser.CPU=enumerize([ARCHITECTURE]);UAParser.DEVICE=enumerize([MODEL,VENDOR,TYPE,CONSOLE,MOBILE,SMARTTV,TABLET,WEARABLE,EMBEDDED]);UAParser.ENGINE=UAParser.OS=enumerize([NAME,VERSION]);if(typeof exports!==UNDEF_TYPE){if("object"!==UNDEF_TYPE&&module.exports){exports=module.exports=UAParser}exports.UAParser=UAParser}else{if("function"===FUNC_TYPE&&__webpack_require__.amdO){!(__WEBPACK_AMD_DEFINE_RESULT__ = (function(){return UAParser}).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))}else if(typeof window!==UNDEF_TYPE){window.UAParser=UAParser}}var $=typeof window!==UNDEF_TYPE&&(window.jQuery||window.Zepto);if($&&!$.ua){var parser=new UAParser;$.ua=parser.getResult();$.ua.get=function(){return parser.getUA()};$.ua.set=function(ua){parser.setUA(ua);var result=parser.getResult();for(var prop in result){$.ua[prop]=result[prop]}}}})(typeof window==="object"?window:this);

/***/ }),

/***/ 68901:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "uI": function() { return /* binding */ useDropzone; }
});

// UNUSED EXPORTS: ErrorCode, default

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./node_modules/tslib/tslib.es6.mjs
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol, Iterator */

var extendStatics = function(d, b) {
  extendStatics = Object.setPrototypeOf ||
      ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
      function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
  return extendStatics(d, b);
};

function __extends(d, b) {
  if (typeof b !== "function" && b !== null)
      throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
  extendStatics(d, b);
  function __() { this.constructor = d; }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
  __assign = Object.assign || function __assign(t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
      return t;
  }
  return __assign.apply(this, arguments);
}

function __rest(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
      t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
      for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
          if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
              t[p[i]] = s[p[i]];
      }
  return t;
}

function __decorate(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
  return function (target, key) { decorator(target, key, paramIndex); }
}

function __esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
  function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
  var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
  var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
  var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
  var _, done = false;
  for (var i = decorators.length - 1; i >= 0; i--) {
      var context = {};
      for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
      for (var p in contextIn.access) context.access[p] = contextIn.access[p];
      context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
      var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
      if (kind === "accessor") {
          if (result === void 0) continue;
          if (result === null || typeof result !== "object") throw new TypeError("Object expected");
          if (_ = accept(result.get)) descriptor.get = _;
          if (_ = accept(result.set)) descriptor.set = _;
          if (_ = accept(result.init)) initializers.unshift(_);
      }
      else if (_ = accept(result)) {
          if (kind === "field") initializers.unshift(_);
          else descriptor[key] = _;
      }
  }
  if (target) Object.defineProperty(target, contextIn.name, descriptor);
  done = true;
};

function __runInitializers(thisArg, initializers, value) {
  var useValue = arguments.length > 2;
  for (var i = 0; i < initializers.length; i++) {
      value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
  }
  return useValue ? value : void 0;
};

function __propKey(x) {
  return typeof x === "symbol" ? x : "".concat(x);
};

function __setFunctionName(f, name, prefix) {
  if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
  return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};

function __metadata(metadataKey, metadataValue) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
  return new (P || (P = Promise))(function (resolve, reject) {
      function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
      function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
      function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}

function __generator(thisArg, body) {
  var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
  return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
  function verb(n) { return function (v) { return step([n, v]); }; }
  function step(op) {
      if (f) throw new TypeError("Generator is already executing.");
      while (g && (g = 0, op[0] && (_ = 0)), _) try {
          if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
          if (y = 0, t) op = [op[0] & 2, t.value];
          switch (op[0]) {
              case 0: case 1: t = op; break;
              case 4: _.label++; return { value: op[1], done: false };
              case 5: _.label++; y = op[1]; op = [0]; continue;
              case 7: op = _.ops.pop(); _.trys.pop(); continue;
              default:
                  if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                  if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                  if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                  if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                  if (t[2]) _.ops.pop();
                  _.trys.pop(); continue;
          }
          op = body.call(thisArg, _);
      } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
      if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
  }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
  }
  Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

function __exportStar(m, o) {
  for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
      next: function () {
          if (o && i >= o.length) o = void 0;
          return { value: o && o[i++], done: !o };
      }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
      while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  }
  catch (error) { e = { error: error }; }
  finally {
      try {
          if (r && !r.done && (m = i["return"])) m.call(i);
      }
      finally { if (e) throw e.error; }
  }
  return ar;
}

/** @deprecated */
function __spread() {
  for (var ar = [], i = 0; i < arguments.length; i++)
      ar = ar.concat(__read(arguments[i]));
  return ar;
}

/** @deprecated */
function __spreadArrays() {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
  for (var r = Array(s), k = 0, i = 0; i < il; i++)
      for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
          r[k] = a[j];
  return r;
}

function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
      if (ar || !(i in from)) {
          if (!ar) ar = Array.prototype.slice.call(from, 0, i);
          ar[i] = from[i];
      }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}

function __await(v) {
  return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var g = generator.apply(thisArg, _arguments || []), i, q = [];
  return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function () { return this; }, i;
  function awaitReturn(f) { return function (v) { return Promise.resolve(v).then(f, reject); }; }
  function verb(n, f) { if (g[n]) { i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; if (f) i[n] = f(i[n]); } }
  function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
  function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
  function fulfill(value) { resume("next", value); }
  function reject(value) { resume("throw", value); }
  function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
  var i, p;
  return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
  function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: false } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var m = o[Symbol.asyncIterator], i;
  return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
  function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
  function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
  if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
  return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
  Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
  o["default"] = v;
};

var ownKeys = function(o) {
  ownKeys = Object.getOwnPropertyNames || function (o) {
    var ar = [];
    for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
    return ar;
  };
  return ownKeys(o);
};

function __importStar(mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
  __setModuleDefault(result, mod);
  return result;
}

function __importDefault(mod) {
  return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
  if (kind === "m") throw new TypeError("Private method is not writable");
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

function __classPrivateFieldIn(state, receiver) {
  if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
  return typeof state === "function" ? receiver === state : state.has(receiver);
}

function __addDisposableResource(env, value, async) {
  if (value !== null && value !== void 0) {
    if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
    var dispose, inner;
    if (async) {
      if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
      dispose = value[Symbol.asyncDispose];
    }
    if (dispose === void 0) {
      if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
      dispose = value[Symbol.dispose];
      if (async) inner = dispose;
    }
    if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
    if (inner) dispose = function() { try { inner.call(this); } catch (e) { return Promise.reject(e); } };
    env.stack.push({ value: value, dispose: dispose, async: async });
  }
  else if (async) {
    env.stack.push({ async: true });
  }
  return value;
}

var _SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

function __disposeResources(env) {
  function fail(e) {
    env.error = env.hasError ? new _SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
    env.hasError = true;
  }
  var r, s = 0;
  function next() {
    while (r = env.stack.pop()) {
      try {
        if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
        if (r.dispose) {
          var result = r.dispose.call(r.value);
          if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) { fail(e); return next(); });
        }
        else s |= 1;
      }
      catch (e) {
        fail(e);
      }
    }
    if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
    if (env.hasError) throw env.error;
  }
  return next();
}

function __rewriteRelativeImportExtension(path, preserveJsx) {
  if (typeof path === "string" && /^\.\.?\//.test(path)) {
      return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function (m, tsx, d, ext, cm) {
          return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : (d + ext + "." + cm.toLowerCase() + "js");
      });
  }
  return path;
}

/* harmony default export */ var tslib_es6 = ({
  __extends,
  __assign,
  __rest,
  __decorate,
  __param,
  __esDecorate,
  __runInitializers,
  __propKey,
  __setFunctionName,
  __metadata,
  __awaiter,
  __generator,
  __createBinding,
  __exportStar,
  __values,
  __read,
  __spread,
  __spreadArrays,
  __spreadArray,
  __await,
  __asyncGenerator,
  __asyncDelegator,
  __asyncValues,
  __makeTemplateObject,
  __importStar,
  __importDefault,
  __classPrivateFieldGet,
  __classPrivateFieldSet,
  __classPrivateFieldIn,
  __addDisposableResource,
  __disposeResources,
  __rewriteRelativeImportExtension,
});

;// CONCATENATED MODULE: ./node_modules/file-selector/dist/es5/file.js
var COMMON_MIME_TYPES = new Map([
    // https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types
    ['aac', 'audio/aac'],
    ['abw', 'application/x-abiword'],
    ['arc', 'application/x-freearc'],
    ['avif', 'image/avif'],
    ['avi', 'video/x-msvideo'],
    ['azw', 'application/vnd.amazon.ebook'],
    ['bin', 'application/octet-stream'],
    ['bmp', 'image/bmp'],
    ['bz', 'application/x-bzip'],
    ['bz2', 'application/x-bzip2'],
    ['cda', 'application/x-cdf'],
    ['csh', 'application/x-csh'],
    ['css', 'text/css'],
    ['csv', 'text/csv'],
    ['doc', 'application/msword'],
    ['docx', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'],
    ['eot', 'application/vnd.ms-fontobject'],
    ['epub', 'application/epub+zip'],
    ['gz', 'application/gzip'],
    ['gif', 'image/gif'],
    ['htm', 'text/html'],
    ['html', 'text/html'],
    ['ico', 'image/vnd.microsoft.icon'],
    ['ics', 'text/calendar'],
    ['jar', 'application/java-archive'],
    ['jpeg', 'image/jpeg'],
    ['jpg', 'image/jpeg'],
    ['js', 'text/javascript'],
    ['json', 'application/json'],
    ['jsonld', 'application/ld+json'],
    ['mid', 'audio/midi'],
    ['midi', 'audio/midi'],
    ['mjs', 'text/javascript'],
    ['mp3', 'audio/mpeg'],
    ['mp4', 'video/mp4'],
    ['mpeg', 'video/mpeg'],
    ['mpkg', 'application/vnd.apple.installer+xml'],
    ['odp', 'application/vnd.oasis.opendocument.presentation'],
    ['ods', 'application/vnd.oasis.opendocument.spreadsheet'],
    ['odt', 'application/vnd.oasis.opendocument.text'],
    ['oga', 'audio/ogg'],
    ['ogv', 'video/ogg'],
    ['ogx', 'application/ogg'],
    ['opus', 'audio/opus'],
    ['otf', 'font/otf'],
    ['png', 'image/png'],
    ['pdf', 'application/pdf'],
    ['php', 'application/x-httpd-php'],
    ['ppt', 'application/vnd.ms-powerpoint'],
    ['pptx', 'application/vnd.openxmlformats-officedocument.presentationml.presentation'],
    ['rar', 'application/vnd.rar'],
    ['rtf', 'application/rtf'],
    ['sh', 'application/x-sh'],
    ['svg', 'image/svg+xml'],
    ['swf', 'application/x-shockwave-flash'],
    ['tar', 'application/x-tar'],
    ['tif', 'image/tiff'],
    ['tiff', 'image/tiff'],
    ['ts', 'video/mp2t'],
    ['ttf', 'font/ttf'],
    ['txt', 'text/plain'],
    ['vsd', 'application/vnd.visio'],
    ['wav', 'audio/wav'],
    ['weba', 'audio/webm'],
    ['webm', 'video/webm'],
    ['webp', 'image/webp'],
    ['woff', 'font/woff'],
    ['woff2', 'font/woff2'],
    ['xhtml', 'application/xhtml+xml'],
    ['xls', 'application/vnd.ms-excel'],
    ['xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'],
    ['xml', 'application/xml'],
    ['xul', 'application/vnd.mozilla.xul+xml'],
    ['zip', 'application/zip'],
    ['7z', 'application/x-7z-compressed'],
    // Others
    ['mkv', 'video/x-matroska'],
    ['mov', 'video/quicktime'],
    ['msg', 'application/vnd.ms-outlook']
]);
function toFileWithPath(file, path) {
    var f = withMimeType(file);
    if (typeof f.path !== 'string') { // on electron, path is already set to the absolute path
        var webkitRelativePath = file.webkitRelativePath;
        Object.defineProperty(f, 'path', {
            value: typeof path === 'string'
                ? path
                // If <input webkitdirectory> is set,
                // the File will have a {webkitRelativePath} property
                // https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement/webkitdirectory
                : typeof webkitRelativePath === 'string' && webkitRelativePath.length > 0
                    ? webkitRelativePath
                    : file.name,
            writable: false,
            configurable: false,
            enumerable: true
        });
    }
    return f;
}
function withMimeType(file) {
    var name = file.name;
    var hasExtension = name && name.lastIndexOf('.') !== -1;
    if (hasExtension && !file.type) {
        var ext = name.split('.')
            .pop().toLowerCase();
        var type = COMMON_MIME_TYPES.get(ext);
        if (type) {
            Object.defineProperty(file, 'type', {
                value: type,
                writable: false,
                configurable: false,
                enumerable: true
            });
        }
    }
    return file;
}
//# sourceMappingURL=file.js.map
;// CONCATENATED MODULE: ./node_modules/file-selector/dist/es5/file-selector.js


var FILES_TO_IGNORE = [
    // Thumbnail cache files for macOS and Windows
    '.DS_Store',
    'Thumbs.db' // Windows
];
/**
 * Convert a DragEvent's DataTrasfer object to a list of File objects
 * NOTE: If some of the items are folders,
 * everything will be flattened and placed in the same list but the paths will be kept as a {path} property.
 *
 * EXPERIMENTAL: A list of https://developer.mozilla.org/en-US/docs/Web/API/FileSystemHandle objects can also be passed as an arg
 * and a list of File objects will be returned.
 *
 * @param evt
 */
function fromEvent(evt) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (isObject(evt) && isDataTransfer(evt)) {
                return [2 /*return*/, getDataTransferFiles(evt.dataTransfer, evt.type)];
            }
            else if (isChangeEvt(evt)) {
                return [2 /*return*/, getInputFiles(evt)];
            }
            else if (Array.isArray(evt) && evt.every(function (item) { return 'getFile' in item && typeof item.getFile === 'function'; })) {
                return [2 /*return*/, getFsHandleFiles(evt)];
            }
            return [2 /*return*/, []];
        });
    });
}
function isDataTransfer(value) {
    return isObject(value.dataTransfer);
}
function isChangeEvt(value) {
    return isObject(value) && isObject(value.target);
}
function isObject(v) {
    return typeof v === 'object' && v !== null;
}
function getInputFiles(evt) {
    return fromList(evt.target.files).map(function (file) { return toFileWithPath(file); });
}
// Ee expect each handle to be https://developer.mozilla.org/en-US/docs/Web/API/FileSystemFileHandle
function getFsHandleFiles(handles) {
    return __awaiter(this, void 0, void 0, function () {
        var files;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Promise.all(handles.map(function (h) { return h.getFile(); }))];
                case 1:
                    files = _a.sent();
                    return [2 /*return*/, files.map(function (file) { return toFileWithPath(file); })];
            }
        });
    });
}
function getDataTransferFiles(dt, type) {
    return __awaiter(this, void 0, void 0, function () {
        var items, files;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (dt === null) {
                        return [2 /*return*/, []];
                    }
                    if (!dt.items) return [3 /*break*/, 2];
                    items = fromList(dt.items)
                        .filter(function (item) { return item.kind === 'file'; });
                    // According to https://html.spec.whatwg.org/multipage/dnd.html#dndevents,
                    // only 'dragstart' and 'drop' has access to the data (source node)
                    if (type !== 'drop') {
                        return [2 /*return*/, items];
                    }
                    return [4 /*yield*/, Promise.all(items.map(toFilePromises))];
                case 1:
                    files = _a.sent();
                    return [2 /*return*/, noIgnoredFiles(flatten(files))];
                case 2: return [2 /*return*/, noIgnoredFiles(fromList(dt.files)
                        .map(function (file) { return toFileWithPath(file); }))];
            }
        });
    });
}
function noIgnoredFiles(files) {
    return files.filter(function (file) { return FILES_TO_IGNORE.indexOf(file.name) === -1; });
}
// IE11 does not support Array.from()
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/from#Browser_compatibility
// https://developer.mozilla.org/en-US/docs/Web/API/FileList
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItemList
function fromList(items) {
    if (items === null) {
        return [];
    }
    var files = [];
    // tslint:disable: prefer-for-of
    for (var i = 0; i < items.length; i++) {
        var file = items[i];
        files.push(file);
    }
    return files;
}
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItem
function toFilePromises(item) {
    if (typeof item.webkitGetAsEntry !== 'function') {
        return fromDataTransferItem(item);
    }
    var entry = item.webkitGetAsEntry();
    // Safari supports dropping an image node from a different window and can be retrieved using
    // the DataTransferItem.getAsFile() API
    // NOTE: FileSystemEntry.file() throws if trying to get the file
    if (entry && entry.isDirectory) {
        return fromDirEntry(entry);
    }
    return fromDataTransferItem(item);
}
function flatten(items) {
    return items.reduce(function (acc, files) { return __spread(acc, (Array.isArray(files) ? flatten(files) : [files])); }, []);
}
function fromDataTransferItem(item) {
    var file = item.getAsFile();
    if (!file) {
        return Promise.reject(item + " is not a File");
    }
    var fwp = toFileWithPath(file);
    return Promise.resolve(fwp);
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemEntry
function fromEntry(entry) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, entry.isDirectory ? fromDirEntry(entry) : fromFileEntry(entry)];
        });
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry
function fromDirEntry(entry) {
    var reader = entry.createReader();
    return new Promise(function (resolve, reject) {
        var entries = [];
        function readEntries() {
            var _this = this;
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry/createReader
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryReader/readEntries
            reader.readEntries(function (batch) { return __awaiter(_this, void 0, void 0, function () {
                var files, err_1, items;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!!batch.length) return [3 /*break*/, 5];
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, Promise.all(entries)];
                        case 2:
                            files = _a.sent();
                            resolve(files);
                            return [3 /*break*/, 4];
                        case 3:
                            err_1 = _a.sent();
                            reject(err_1);
                            return [3 /*break*/, 4];
                        case 4: return [3 /*break*/, 6];
                        case 5:
                            items = Promise.all(batch.map(fromEntry));
                            entries.push(items);
                            // Continue reading
                            readEntries();
                            _a.label = 6;
                        case 6: return [2 /*return*/];
                    }
                });
            }); }, function (err) {
                reject(err);
            });
        }
        readEntries();
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemFileEntry
function fromFileEntry(entry) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve, reject) {
                    entry.file(function (file) {
                        var fwp = toFileWithPath(file, entry.fullPath);
                        resolve(fwp);
                    }, function (err) {
                        reject(err);
                    });
                })];
        });
    });
}
//# sourceMappingURL=file-selector.js.map
;// CONCATENATED MODULE: ./node_modules/file-selector/dist/es5/index.js

//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ./node_modules/attr-accept/dist/es/index.js
var es = __webpack_require__(58363);
;// CONCATENATED MODULE: ./node_modules/react-dropzone/dist/es/utils/index.js
function utils_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? utils_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : utils_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

 // Error codes

var FILE_INVALID_TYPE = 'file-invalid-type';
var FILE_TOO_LARGE = 'file-too-large';
var FILE_TOO_SMALL = 'file-too-small';
var TOO_MANY_FILES = 'too-many-files';
var ErrorCode = {
  FileInvalidType: FILE_INVALID_TYPE,
  FileTooLarge: FILE_TOO_LARGE,
  FileTooSmall: FILE_TOO_SMALL,
  TooManyFiles: TOO_MANY_FILES
}; // File Errors

var getInvalidTypeRejectionErr = function getInvalidTypeRejectionErr(accept) {
  accept = Array.isArray(accept) && accept.length === 1 ? accept[0] : accept;
  var messageSuffix = Array.isArray(accept) ? "one of ".concat(accept.join(', ')) : accept;
  return {
    code: FILE_INVALID_TYPE,
    message: "File type must be ".concat(messageSuffix)
  };
};
var getTooLargeRejectionErr = function getTooLargeRejectionErr(maxSize) {
  return {
    code: FILE_TOO_LARGE,
    message: "File is larger than ".concat(maxSize, " ").concat(maxSize === 1 ? 'byte' : 'bytes')
  };
};
var getTooSmallRejectionErr = function getTooSmallRejectionErr(minSize) {
  return {
    code: FILE_TOO_SMALL,
    message: "File is smaller than ".concat(minSize, " ").concat(minSize === 1 ? 'byte' : 'bytes')
  };
};
var TOO_MANY_FILES_REJECTION = {
  code: TOO_MANY_FILES,
  message: 'Too many files'
}; // Firefox versions prior to 53 return a bogus MIME type for every file drag, so dragovers with
// that MIME type will always be accepted

function fileAccepted(file, accept) {
  var isAcceptable = file.type === 'application/x-moz-file' || (0,es/* default */.Z)(file, accept);
  return [isAcceptable, isAcceptable ? null : getInvalidTypeRejectionErr(accept)];
}
function fileMatchSize(file, minSize, maxSize) {
  if (isDefined(file.size)) {
    if (isDefined(minSize) && isDefined(maxSize)) {
      if (file.size > maxSize) return [false, getTooLargeRejectionErr(maxSize)];
      if (file.size < minSize) return [false, getTooSmallRejectionErr(minSize)];
    } else if (isDefined(minSize) && file.size < minSize) return [false, getTooSmallRejectionErr(minSize)];else if (isDefined(maxSize) && file.size > maxSize) return [false, getTooLargeRejectionErr(maxSize)];
  }

  return [true, null];
}

function isDefined(value) {
  return value !== undefined && value !== null;
}

function allFilesAccepted(_ref) {
  var files = _ref.files,
      accept = _ref.accept,
      minSize = _ref.minSize,
      maxSize = _ref.maxSize,
      multiple = _ref.multiple,
      maxFiles = _ref.maxFiles;

  if (!multiple && files.length > 1 || multiple && maxFiles >= 1 && files.length > maxFiles) {
    return false;
  }

  return files.every(function (file) {
    var _fileAccepted = fileAccepted(file, accept),
        _fileAccepted2 = _slicedToArray(_fileAccepted, 1),
        accepted = _fileAccepted2[0];

    var _fileMatchSize = fileMatchSize(file, minSize, maxSize),
        _fileMatchSize2 = _slicedToArray(_fileMatchSize, 1),
        sizeMatch = _fileMatchSize2[0];

    return accepted && sizeMatch;
  });
} // React's synthetic events has event.isPropagationStopped,
// but to remain compatibility with other libs (Preact) fall back
// to check event.cancelBubble

function isPropagationStopped(event) {
  if (typeof event.isPropagationStopped === 'function') {
    return event.isPropagationStopped();
  } else if (typeof event.cancelBubble !== 'undefined') {
    return event.cancelBubble;
  }

  return false;
}
function isEvtWithFiles(event) {
  if (!event.dataTransfer) {
    return !!event.target && !!event.target.files;
  } // https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/types
  // https://developer.mozilla.org/en-US/docs/Web/API/HTML_Drag_and_Drop_API/Recommended_drag_types#file


  return Array.prototype.some.call(event.dataTransfer.types, function (type) {
    return type === 'Files' || type === 'application/x-moz-file';
  });
}
function isKindFile(item) {
  return _typeof(item) === 'object' && item !== null && item.kind === 'file';
} // allow the entire document to be a drag target

function onDocumentDragOver(event) {
  event.preventDefault();
}

function isIe(userAgent) {
  return userAgent.indexOf('MSIE') !== -1 || userAgent.indexOf('Trident/') !== -1;
}

function isEdge(userAgent) {
  return userAgent.indexOf('Edge/') !== -1;
}

function isIeOrEdge() {
  var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator.userAgent;
  return isIe(userAgent) || isEdge(userAgent);
}
/**
 * This is intended to be used to compose event handlers
 * They are executed in order until one of them calls `event.isPropagationStopped()`.
 * Note that the check is done on the first invoke too,
 * meaning that if propagation was stopped before invoking the fns,
 * no handlers will be executed.
 *
 * @param {Function} fns the event hanlder functions
 * @return {Function} the event handler to add to an element
 */

function composeEventHandlers() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return function (event) {
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    return fns.some(function (fn) {
      if (!isPropagationStopped(event) && fn) {
        fn.apply(void 0, [event].concat(args));
      }

      return isPropagationStopped(event);
    });
  };
}
/**
 * canUseFileSystemAccessAPI checks if the [File System Access API](https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API)
 * is supported by the browser.
 * @returns {boolean}
 */

function canUseFileSystemAccessAPI() {
  return 'showOpenFilePicker' in window;
}
/**
 * filePickerOptionsTypes returns the {types} option for https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker
 * based on the accept attr (see https://github.com/react-dropzone/attr-accept)
 * E.g: converts ['image/*', 'text/*'] to {'image/*': [], 'text/*': []}
 * @param {string|string[]} accept
 */

function filePickerOptionsTypes(accept) {
  accept = typeof accept === 'string' ? accept.split(',') : accept;
  return [{
    description: 'everything',
    // TODO: Need to handle filtering more elegantly than this!
    accept: Array.isArray(accept) // Accept just MIME types as per spec
    // NOTE: accept can be https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/file#unique_file_type_specifiers
    ? accept.filter(function (item) {
      return item === 'audio/*' || item === 'video/*' || item === 'image/*' || item === 'text/*' || /\w+\/[-+.\w]+/g.test(item);
    }).reduce(function (a, b) {
      return _objectSpread(_objectSpread({}, a), {}, _defineProperty({}, b, []));
    }, {}) : {}
  }];
}
;// CONCATENATED MODULE: ./node_modules/react-dropzone/dist/es/index.js
var _excluded = ["children"],
    _excluded2 = ["open"],
    _excluded3 = ["refKey", "role", "onKeyDown", "onFocus", "onBlur", "onClick", "onDragEnter", "onDragOver", "onDragLeave", "onDrop"],
    _excluded4 = ["refKey", "onChange", "onClick"];

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || es_unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return es_arrayLikeToArray(arr); }

function es_slicedToArray(arr, i) { return es_arrayWithHoles(arr) || es_iterableToArrayLimit(arr, i) || es_unsupportedIterableToArray(arr, i) || es_nonIterableRest(); }

function es_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function es_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return es_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return es_arrayLikeToArray(o, minLen); }

function es_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function es_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function es_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function es_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function es_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? es_ownKeys(Object(source), !0).forEach(function (key) { es_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : es_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function es_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/* eslint prefer-template: 0 */




/**
 * Convenience wrapper component for the `useDropzone` hook
 *
 * ```jsx
 * <Dropzone>
 *   {({getRootProps, getInputProps}) => (
 *     <div {...getRootProps()}>
 *       <input {...getInputProps()} />
 *       <p>Drag 'n' drop some files here, or click to select files</p>
 *     </div>
 *   )}
 * </Dropzone>
 * ```
 */

var Dropzone = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      params = _objectWithoutProperties(_ref, _excluded);

  var _useDropzone = useDropzone(params),
      open = _useDropzone.open,
      props = _objectWithoutProperties(_useDropzone, _excluded2);

  (0,react.useImperativeHandle)(ref, function () {
    return {
      open: open
    };
  }, [open]); // TODO: Figure out why react-styleguidist cannot create docs if we don't return a jsx element

  return /*#__PURE__*/react.createElement(react.Fragment, null, children(es_objectSpread(es_objectSpread({}, props), {}, {
    open: open
  })));
});
Dropzone.displayName = 'Dropzone'; // Add default props for react-docgen

var defaultProps = {
  disabled: false,
  getFilesFromEvent: fromEvent,
  maxSize: Infinity,
  minSize: 0,
  multiple: true,
  maxFiles: 0,
  preventDropOnDocument: true,
  noClick: false,
  noKeyboard: false,
  noDrag: false,
  noDragEventsBubbling: false,
  validator: null,
  useFsAccessApi: false
};
Dropzone.defaultProps = defaultProps;
Dropzone.propTypes = {
  /**
   * Render function that exposes the dropzone state and prop getter fns
   *
   * @param {object} params
   * @param {Function} params.getRootProps Returns the props you should apply to the root drop container you render
   * @param {Function} params.getInputProps Returns the props you should apply to hidden file input you render
   * @param {Function} params.open Open the native file selection dialog
   * @param {boolean} params.isFocused Dropzone area is in focus
   * @param {boolean} params.isFileDialogActive File dialog is opened
   * @param {boolean} params.isDragActive Active drag is in progress
   * @param {boolean} params.isDragAccept Dragged files are accepted
   * @param {boolean} params.isDragReject Some dragged files are rejected
   * @param {File[]} params.draggedFiles Files in active drag
   * @param {File[]} params.acceptedFiles Accepted files
   * @param {FileRejection[]} params.fileRejections Rejected files and why they were rejected
   */
  children: (prop_types_default()).func,

  /**
   * Set accepted file types.
   * See https://github.com/okonet/attr-accept for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all.
   * See: https://github.com/react-dropzone/react-dropzone/issues/276
   */
  accept: prop_types_default().oneOfType([(prop_types_default()).string, prop_types_default().arrayOf((prop_types_default()).string)]),

  /**
   * Allow drag 'n' drop (or selection from the file dialog) of multiple files
   */
  multiple: (prop_types_default()).bool,

  /**
   * If false, allow dropped items to take over the current browser window
   */
  preventDropOnDocument: (prop_types_default()).bool,

  /**
   * If true, disables click to open the native file selection dialog
   */
  noClick: (prop_types_default()).bool,

  /**
   * If true, disables SPACE/ENTER to open the native file selection dialog.
   * Note that it also stops tracking the focus state.
   */
  noKeyboard: (prop_types_default()).bool,

  /**
   * If true, disables drag 'n' drop
   */
  noDrag: (prop_types_default()).bool,

  /**
   * If true, stops drag event propagation to parents
   */
  noDragEventsBubbling: (prop_types_default()).bool,

  /**
   * Minimum file size (in bytes)
   */
  minSize: (prop_types_default()).number,

  /**
   * Maximum file size (in bytes)
   */
  maxSize: (prop_types_default()).number,

  /**
   * Maximum accepted number of files
   * The default value is 0 which means there is no limitation to how many files are accepted.
   */
  maxFiles: (prop_types_default()).number,

  /**
   * Enable/disable the dropzone
   */
  disabled: (prop_types_default()).bool,

  /**
   * Use this to provide a custom file aggregator
   *
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  getFilesFromEvent: (prop_types_default()).func,

  /**
   * Cb for when closing the file dialog with no selection
   */
  onFileDialogCancel: (prop_types_default()).func,

  /**
   * Cb for when opening the file dialog
   */
  onFileDialogOpen: (prop_types_default()).func,

  /**
   * Set to true to use the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API
   * to open the file picker instead of using an `<input type="file">` click event.
   */
  useFsAccessApi: (prop_types_default()).bool,

  /**
   * Cb for when the `dragenter` event occurs.
   *
   * @param {DragEvent} event
   */
  onDragEnter: (prop_types_default()).func,

  /**
   * Cb for when the `dragleave` event occurs
   *
   * @param {DragEvent} event
   */
  onDragLeave: (prop_types_default()).func,

  /**
   * Cb for when the `dragover` event occurs
   *
   * @param {DragEvent} event
   */
  onDragOver: (prop_types_default()).func,

  /**
   * Cb for when the `drop` event occurs.
   * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
   *
   * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
   * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
   * If `multiple` is set to false and additional files are dropped,
   * all files besides the first will be rejected.
   * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
   *
   * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
   * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
   *
   * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
   * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
   *
   * ```js
   * function onDrop(acceptedFiles) {
   *   const req = request.post('/upload')
   *   acceptedFiles.forEach(file => {
   *     req.attach(file.name, file)
   *   })
   *   req.end(callback)
   * }
   * ```
   *
   * @param {File[]} acceptedFiles
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  onDrop: (prop_types_default()).func,

  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are accepted, this callback is not invoked.
   *
   * @param {File[]} files
   * @param {(DragEvent|Event)} event
   */
  onDropAccepted: (prop_types_default()).func,

  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are rejected, this callback is not invoked.
   *
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event
   */
  onDropRejected: (prop_types_default()).func,

  /**
   * Custom validation function
   * @param {File} file
   * @returns {FileError|FileError[]}
   */
  validator: (prop_types_default()).func
};
/* harmony default export */ var dist_es = ((/* unused pure expression or super */ null && (Dropzone)));
/**
 * A function that is invoked for the `dragenter`,
 * `dragover` and `dragleave` events.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dragCb
 * @param {DragEvent} event
 */

/**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dropCb
 * @param {File[]} acceptedFiles List of accepted files
 * @param {FileRejection[]} fileRejections List of rejected files and why they were rejected
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */

/**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are files (such as link, text, etc.).
 *
 * @callback dropAcceptedCb
 * @param {File[]} files List of accepted files that meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */

/**
 * A function that is invoked for the `drop` or input change event.
 *
 * @callback dropRejectedCb
 * @param {File[]} files List of rejected files that do not meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */

/**
 * A function that is used aggregate files,
 * in a asynchronous fashion, from drag or input change events.
 *
 * @callback getFilesFromEvent
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 * @returns {(File[]|Promise<File[]>)}
 */

/**
 * An object with the current dropzone state and some helper functions.
 *
 * @typedef {object} DropzoneState
 * @property {Function} getRootProps Returns the props you should apply to the root drop container you render
 * @property {Function} getInputProps Returns the props you should apply to hidden file input you render
 * @property {Function} open Open the native file selection dialog
 * @property {boolean} isFocused Dropzone area is in focus
 * @property {boolean} isFileDialogActive File dialog is opened
 * @property {boolean} isDragActive Active drag is in progress
 * @property {boolean} isDragAccept Dragged files are accepted
 * @property {boolean} isDragReject Some dragged files are rejected
 * @property {File[]} draggedFiles Files in active drag
 * @property {File[]} acceptedFiles Accepted files
 * @property {FileRejection[]} fileRejections Rejected files and why they were rejected
 */

var initialState = {
  isFocused: false,
  isFileDialogActive: false,
  isDragActive: false,
  isDragAccept: false,
  isDragReject: false,
  draggedFiles: [],
  acceptedFiles: [],
  fileRejections: []
};
/**
 * A React hook that creates a drag 'n' drop area.
 *
 * ```jsx
 * function MyDropzone(props) {
 *   const {getRootProps, getInputProps} = useDropzone({
 *     onDrop: acceptedFiles => {
 *       // do something with the File objects, e.g. upload to some server
 *     }
 *   });
 *   return (
 *     <div {...getRootProps()}>
 *       <input {...getInputProps()} />
 *       <p>Drag and drop some files here, or click to select files</p>
 *     </div>
 *   )
 * }
 * ```
 *
 * @function useDropzone
 *
 * @param {object} props
 * @param {string|string[]} [props.accept] Set accepted file types.
 * See https://github.com/okonet/attr-accept for more information.
 * Keep in mind that mime type determination is not reliable across platforms. CSV files,
 * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
 * Windows. In some cases there might not be a mime type set at all.
 * See: https://github.com/react-dropzone/react-dropzone/issues/276
 * @param {boolean} [props.multiple=true] Allow drag 'n' drop (or selection from the file dialog) of multiple files
 * @param {boolean} [props.preventDropOnDocument=true] If false, allow dropped items to take over the current browser window
 * @param {boolean} [props.noClick=false] If true, disables click to open the native file selection dialog
 * @param {boolean} [props.noKeyboard=false] If true, disables SPACE/ENTER to open the native file selection dialog.
 * Note that it also stops tracking the focus state.
 * @param {boolean} [props.noDrag=false] If true, disables drag 'n' drop
 * @param {boolean} [props.noDragEventsBubbling=false] If true, stops drag event propagation to parents
 * @param {number} [props.minSize=0] Minimum file size (in bytes)
 * @param {number} [props.maxSize=Infinity] Maximum file size (in bytes)
 * @param {boolean} [props.disabled=false] Enable/disable the dropzone
 * @param {getFilesFromEvent} [props.getFilesFromEvent] Use this to provide a custom file aggregator
 * @param {Function} [props.onFileDialogCancel] Cb for when closing the file dialog with no selection
 * @param {boolean} [props.useFsAccessApi] Set to true to use the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API
 * to open the file picker instead of using an `<input type="file">` click event.
 * @param {Function} [props.onFileDialogOpen] Cb for when opening the file dialog
 * @param {dragCb} [props.onDragEnter] Cb for when the `dragenter` event occurs.
 * @param {dragCb} [props.onDragLeave] Cb for when the `dragleave` event occurs
 * @param {dragCb} [props.onDragOver] Cb for when the `dragover` event occurs
 * @param {dropCb} [props.onDrop] Cb for when the `drop` event occurs.
 * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
 *
 * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
 * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
 * If `multiple` is set to false and additional files are dropped,
 * all files besides the first will be rejected.
 * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
 *
 * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
 * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
 *
 * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
 * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
 *
 * ```js
 * function onDrop(acceptedFiles) {
 *   const req = request.post('/upload')
 *   acceptedFiles.forEach(file => {
 *     req.attach(file.name, file)
 *   })
 *   req.end(callback)
 * }
 * ```
 * @param {dropAcceptedCb} [props.onDropAccepted]
 * @param {dropRejectedCb} [props.onDropRejected]
 *
 * @returns {DropzoneState}
 */

function useDropzone() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _defaultProps$options = es_objectSpread(es_objectSpread({}, defaultProps), options),
      accept = _defaultProps$options.accept,
      disabled = _defaultProps$options.disabled,
      getFilesFromEvent = _defaultProps$options.getFilesFromEvent,
      maxSize = _defaultProps$options.maxSize,
      minSize = _defaultProps$options.minSize,
      multiple = _defaultProps$options.multiple,
      maxFiles = _defaultProps$options.maxFiles,
      onDragEnter = _defaultProps$options.onDragEnter,
      onDragLeave = _defaultProps$options.onDragLeave,
      onDragOver = _defaultProps$options.onDragOver,
      onDrop = _defaultProps$options.onDrop,
      onDropAccepted = _defaultProps$options.onDropAccepted,
      onDropRejected = _defaultProps$options.onDropRejected,
      onFileDialogCancel = _defaultProps$options.onFileDialogCancel,
      onFileDialogOpen = _defaultProps$options.onFileDialogOpen,
      useFsAccessApi = _defaultProps$options.useFsAccessApi,
      preventDropOnDocument = _defaultProps$options.preventDropOnDocument,
      noClick = _defaultProps$options.noClick,
      noKeyboard = _defaultProps$options.noKeyboard,
      noDrag = _defaultProps$options.noDrag,
      noDragEventsBubbling = _defaultProps$options.noDragEventsBubbling,
      validator = _defaultProps$options.validator;

  var onFileDialogOpenCb = (0,react.useMemo)(function () {
    return typeof onFileDialogOpen === 'function' ? onFileDialogOpen : noop;
  }, [onFileDialogOpen]);
  var onFileDialogCancelCb = (0,react.useMemo)(function () {
    return typeof onFileDialogCancel === 'function' ? onFileDialogCancel : noop;
  }, [onFileDialogCancel]);
  var rootRef = (0,react.useRef)(null);
  var inputRef = (0,react.useRef)(null);

  var _useReducer = (0,react.useReducer)(reducer, initialState),
      _useReducer2 = es_slicedToArray(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  var isFocused = state.isFocused,
      isFileDialogActive = state.isFileDialogActive,
      draggedFiles = state.draggedFiles; // Update file dialog active state when the window is focused on

  var onWindowFocus = function onWindowFocus() {
    // Execute the timeout only if the file dialog is opened in the browser
    if (isFileDialogActive) {
      setTimeout(function () {
        if (inputRef.current) {
          var files = inputRef.current.files;

          if (!files.length) {
            dispatch({
              type: 'closeDialog'
            });
            onFileDialogCancelCb();
          }
        }
      }, 300);
    }
  };

  (0,react.useEffect)(function () {
    if (useFsAccessApi && canUseFileSystemAccessAPI()) {
      return function () {};
    }

    window.addEventListener('focus', onWindowFocus, false);
    return function () {
      window.removeEventListener('focus', onWindowFocus, false);
    };
  }, [inputRef, isFileDialogActive, onFileDialogCancelCb, useFsAccessApi]);
  var dragTargetsRef = (0,react.useRef)([]);

  var onDocumentDrop = function onDocumentDrop(event) {
    if (rootRef.current && rootRef.current.contains(event.target)) {
      // If we intercepted an event for our instance, let it propagate down to the instance's onDrop handler
      return;
    }

    event.preventDefault();
    dragTargetsRef.current = [];
  };

  (0,react.useEffect)(function () {
    if (preventDropOnDocument) {
      document.addEventListener('dragover', onDocumentDragOver, false);
      document.addEventListener('drop', onDocumentDrop, false);
    }

    return function () {
      if (preventDropOnDocument) {
        document.removeEventListener('dragover', onDocumentDragOver);
        document.removeEventListener('drop', onDocumentDrop);
      }
    };
  }, [rootRef, preventDropOnDocument]);
  var onDragEnterCb = (0,react.useCallback)(function (event) {
    event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done

    event.persist();
    stopPropagation(event);
    dragTargetsRef.current = [].concat(_toConsumableArray(dragTargetsRef.current), [event.target]);

    if (isEvtWithFiles(event)) {
      Promise.resolve(getFilesFromEvent(event)).then(function (draggedFiles) {
        if (isPropagationStopped(event) && !noDragEventsBubbling) {
          return;
        }

        dispatch({
          draggedFiles: draggedFiles,
          isDragActive: true,
          type: 'setDraggedFiles'
        });

        if (onDragEnter) {
          onDragEnter(event);
        }
      });
    }
  }, [getFilesFromEvent, onDragEnter, noDragEventsBubbling]);
  var onDragOverCb = (0,react.useCallback)(function (event) {
    event.preventDefault();
    event.persist();
    stopPropagation(event);
    var hasFiles = isEvtWithFiles(event);

    if (hasFiles && event.dataTransfer) {
      try {
        event.dataTransfer.dropEffect = 'copy';
      } catch (_unused) {}
      /* eslint-disable-line no-empty */

    }

    if (hasFiles && onDragOver) {
      onDragOver(event);
    }

    return false;
  }, [onDragOver, noDragEventsBubbling]);
  var onDragLeaveCb = (0,react.useCallback)(function (event) {
    event.preventDefault();
    event.persist();
    stopPropagation(event); // Only deactivate once the dropzone and all children have been left

    var targets = dragTargetsRef.current.filter(function (target) {
      return rootRef.current && rootRef.current.contains(target);
    }); // Make sure to remove a target present multiple times only once
    // (Firefox may fire dragenter/dragleave multiple times on the same element)

    var targetIdx = targets.indexOf(event.target);

    if (targetIdx !== -1) {
      targets.splice(targetIdx, 1);
    }

    dragTargetsRef.current = targets;

    if (targets.length > 0) {
      return;
    }

    dispatch({
      isDragActive: false,
      type: 'setDraggedFiles',
      draggedFiles: []
    });

    if (isEvtWithFiles(event) && onDragLeave) {
      onDragLeave(event);
    }
  }, [rootRef, onDragLeave, noDragEventsBubbling]);
  var setFiles = (0,react.useCallback)(function (files, event) {
    var acceptedFiles = [];
    var fileRejections = [];
    files.forEach(function (file) {
      var _fileAccepted = fileAccepted(file, accept),
          _fileAccepted2 = es_slicedToArray(_fileAccepted, 2),
          accepted = _fileAccepted2[0],
          acceptError = _fileAccepted2[1];

      var _fileMatchSize = fileMatchSize(file, minSize, maxSize),
          _fileMatchSize2 = es_slicedToArray(_fileMatchSize, 2),
          sizeMatch = _fileMatchSize2[0],
          sizeError = _fileMatchSize2[1];

      var customErrors = validator ? validator(file) : null;

      if (accepted && sizeMatch && !customErrors) {
        acceptedFiles.push(file);
      } else {
        var errors = [acceptError, sizeError];

        if (customErrors) {
          errors = errors.concat(customErrors);
        }

        fileRejections.push({
          file: file,
          errors: errors.filter(function (e) {
            return e;
          })
        });
      }
    });

    if (!multiple && acceptedFiles.length > 1 || multiple && maxFiles >= 1 && acceptedFiles.length > maxFiles) {
      // Reject everything and empty accepted files
      acceptedFiles.forEach(function (file) {
        fileRejections.push({
          file: file,
          errors: [TOO_MANY_FILES_REJECTION]
        });
      });
      acceptedFiles.splice(0);
    }

    dispatch({
      acceptedFiles: acceptedFiles,
      fileRejections: fileRejections,
      type: 'setFiles'
    });

    if (onDrop) {
      onDrop(acceptedFiles, fileRejections, event);
    }

    if (fileRejections.length > 0 && onDropRejected) {
      onDropRejected(fileRejections, event);
    }

    if (acceptedFiles.length > 0 && onDropAccepted) {
      onDropAccepted(acceptedFiles, event);
    }
  }, [dispatch, multiple, accept, minSize, maxSize, maxFiles, onDrop, onDropAccepted, onDropRejected, validator]);
  var onDropCb = (0,react.useCallback)(function (event) {
    event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done

    event.persist();
    stopPropagation(event);
    dragTargetsRef.current = [];

    if (isEvtWithFiles(event)) {
      Promise.resolve(getFilesFromEvent(event)).then(function (files) {
        if (isPropagationStopped(event) && !noDragEventsBubbling) {
          return;
        }

        setFiles(files, event);
      });
    }

    dispatch({
      type: 'reset'
    });
  }, [getFilesFromEvent, setFiles, noDragEventsBubbling]); // Fn for opening the file dialog programmatically

  var openFileDialog = (0,react.useCallback)(function () {
    if (useFsAccessApi && canUseFileSystemAccessAPI()) {
      dispatch({
        type: 'openDialog'
      });
      onFileDialogOpenCb(); // https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker

      var opts = {
        multiple: multiple,
        types: filePickerOptionsTypes(accept)
      };
      window.showOpenFilePicker(opts).then(function (handles) {
        return getFilesFromEvent(handles);
      }).then(function (files) {
        return setFiles(files, null);
      }).catch(function (e) {
        return onFileDialogCancelCb(e);
      }).finally(function () {
        return dispatch({
          type: 'closeDialog'
        });
      });
      return;
    }

    if (inputRef.current) {
      dispatch({
        type: 'openDialog'
      });
      onFileDialogOpenCb();
      inputRef.current.value = null;
      inputRef.current.click();
    }
  }, [dispatch, onFileDialogOpenCb, onFileDialogCancelCb, useFsAccessApi, setFiles, accept, multiple]); // Cb to open the file dialog when SPACE/ENTER occurs on the dropzone

  var onKeyDownCb = (0,react.useCallback)(function (event) {
    // Ignore keyboard events bubbling up the DOM tree
    if (!rootRef.current || !rootRef.current.isEqualNode(event.target)) {
      return;
    }

    if (event.keyCode === 32 || event.keyCode === 13) {
      event.preventDefault();
      openFileDialog();
    }
  }, [rootRef, inputRef, openFileDialog]); // Update focus state for the dropzone

  var onFocusCb = (0,react.useCallback)(function () {
    dispatch({
      type: 'focus'
    });
  }, []);
  var onBlurCb = (0,react.useCallback)(function () {
    dispatch({
      type: 'blur'
    });
  }, []); // Cb to open the file dialog when click occurs on the dropzone

  var onClickCb = (0,react.useCallback)(function () {
    if (noClick) {
      return;
    } // In IE11/Edge the file-browser dialog is blocking, therefore, use setTimeout()
    // to ensure React can handle state changes
    // See: https://github.com/react-dropzone/react-dropzone/issues/450


    if (isIeOrEdge()) {
      setTimeout(openFileDialog, 0);
    } else {
      openFileDialog();
    }
  }, [inputRef, noClick, openFileDialog]);

  var composeHandler = function composeHandler(fn) {
    return disabled ? null : fn;
  };

  var composeKeyboardHandler = function composeKeyboardHandler(fn) {
    return noKeyboard ? null : composeHandler(fn);
  };

  var composeDragHandler = function composeDragHandler(fn) {
    return noDrag ? null : composeHandler(fn);
  };

  var stopPropagation = function stopPropagation(event) {
    if (noDragEventsBubbling) {
      event.stopPropagation();
    }
  };

  var getRootProps = (0,react.useMemo)(function () {
    return function () {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref2$refKey = _ref2.refKey,
          refKey = _ref2$refKey === void 0 ? 'ref' : _ref2$refKey,
          role = _ref2.role,
          onKeyDown = _ref2.onKeyDown,
          onFocus = _ref2.onFocus,
          onBlur = _ref2.onBlur,
          onClick = _ref2.onClick,
          onDragEnter = _ref2.onDragEnter,
          onDragOver = _ref2.onDragOver,
          onDragLeave = _ref2.onDragLeave,
          onDrop = _ref2.onDrop,
          rest = _objectWithoutProperties(_ref2, _excluded3);

      return es_objectSpread(es_objectSpread(es_defineProperty({
        onKeyDown: composeKeyboardHandler(composeEventHandlers(onKeyDown, onKeyDownCb)),
        onFocus: composeKeyboardHandler(composeEventHandlers(onFocus, onFocusCb)),
        onBlur: composeKeyboardHandler(composeEventHandlers(onBlur, onBlurCb)),
        onClick: composeHandler(composeEventHandlers(onClick, onClickCb)),
        onDragEnter: composeDragHandler(composeEventHandlers(onDragEnter, onDragEnterCb)),
        onDragOver: composeDragHandler(composeEventHandlers(onDragOver, onDragOverCb)),
        onDragLeave: composeDragHandler(composeEventHandlers(onDragLeave, onDragLeaveCb)),
        onDrop: composeDragHandler(composeEventHandlers(onDrop, onDropCb)),
        role: typeof role === 'string' && role !== '' ? role : 'button'
      }, refKey, rootRef), !disabled && !noKeyboard ? {
        tabIndex: 0
      } : {}), rest);
    };
  }, [rootRef, onKeyDownCb, onFocusCb, onBlurCb, onClickCb, onDragEnterCb, onDragOverCb, onDragLeaveCb, onDropCb, noKeyboard, noDrag, disabled]);
  var onInputElementClick = (0,react.useCallback)(function (event) {
    event.stopPropagation();
  }, []);
  var getInputProps = (0,react.useMemo)(function () {
    return function () {
      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref3$refKey = _ref3.refKey,
          refKey = _ref3$refKey === void 0 ? 'ref' : _ref3$refKey,
          onChange = _ref3.onChange,
          onClick = _ref3.onClick,
          rest = _objectWithoutProperties(_ref3, _excluded4);

      var inputProps = es_defineProperty({
        accept: accept,
        multiple: multiple,
        type: 'file',
        style: {
          display: 'none'
        },
        onChange: composeHandler(composeEventHandlers(onChange, onDropCb)),
        onClick: composeHandler(composeEventHandlers(onClick, onInputElementClick)),
        autoComplete: 'off',
        tabIndex: -1
      }, refKey, inputRef);

      return es_objectSpread(es_objectSpread({}, inputProps), rest);
    };
  }, [inputRef, accept, multiple, onDropCb, disabled]);
  var fileCount = draggedFiles.length;
  var isDragAccept = fileCount > 0 && allFilesAccepted({
    files: draggedFiles,
    accept: accept,
    minSize: minSize,
    maxSize: maxSize,
    multiple: multiple,
    maxFiles: maxFiles
  });
  var isDragReject = fileCount > 0 && !isDragAccept;
  return es_objectSpread(es_objectSpread({}, state), {}, {
    isDragAccept: isDragAccept,
    isDragReject: isDragReject,
    isFocused: isFocused && !disabled,
    getRootProps: getRootProps,
    getInputProps: getInputProps,
    rootRef: rootRef,
    inputRef: inputRef,
    open: composeHandler(openFileDialog)
  });
}

function reducer(state, action) {
  /* istanbul ignore next */
  switch (action.type) {
    case 'focus':
      return es_objectSpread(es_objectSpread({}, state), {}, {
        isFocused: true
      });

    case 'blur':
      return es_objectSpread(es_objectSpread({}, state), {}, {
        isFocused: false
      });

    case 'openDialog':
      return es_objectSpread(es_objectSpread({}, initialState), {}, {
        isFileDialogActive: true
      });

    case 'closeDialog':
      return es_objectSpread(es_objectSpread({}, state), {}, {
        isFileDialogActive: false
      });

    case 'setDraggedFiles':
      /* eslint no-case-declarations: 0 */
      var isDragActive = action.isDragActive,
          draggedFiles = action.draggedFiles;
      return es_objectSpread(es_objectSpread({}, state), {}, {
        draggedFiles: draggedFiles,
        isDragActive: isDragActive
      });

    case 'setFiles':
      return es_objectSpread(es_objectSpread({}, state), {}, {
        acceptedFiles: action.acceptedFiles,
        fileRejections: action.fileRejections
      });

    case 'reset':
      return es_objectSpread({}, initialState);

    default:
      return state;
  }
}

function noop() {}



/***/ }),

/***/ 69921:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b=Symbol.for("react.element"),c=Symbol.for("react.portal"),d=Symbol.for("react.fragment"),e=Symbol.for("react.strict_mode"),f=Symbol.for("react.profiler"),g=Symbol.for("react.provider"),h=Symbol.for("react.context"),k=Symbol.for("react.server_context"),l=Symbol.for("react.forward_ref"),m=Symbol.for("react.suspense"),n=Symbol.for("react.suspense_list"),p=Symbol.for("react.memo"),q=Symbol.for("react.lazy"),t=Symbol.for("react.offscreen"),u;u=Symbol.for("react.module.reference");
function v(a){if("object"===typeof a&&null!==a){var r=a.$$typeof;switch(r){case b:switch(a=a.type,a){case d:case f:case e:case m:case n:return a;default:switch(a=a&&a.$$typeof,a){case k:case h:case l:case q:case p:case g:return a;default:return r}}case c:return r}}}__webpack_unused_export__=h;__webpack_unused_export__=g;__webpack_unused_export__=b;__webpack_unused_export__=l;__webpack_unused_export__=d;__webpack_unused_export__=q;__webpack_unused_export__=p;__webpack_unused_export__=c;__webpack_unused_export__=f;__webpack_unused_export__=e;__webpack_unused_export__=m;
__webpack_unused_export__=n;__webpack_unused_export__=function(){return!1};__webpack_unused_export__=function(){return!1};__webpack_unused_export__=function(a){return v(a)===h};__webpack_unused_export__=function(a){return v(a)===g};__webpack_unused_export__=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===b};__webpack_unused_export__=function(a){return v(a)===l};__webpack_unused_export__=function(a){return v(a)===d};__webpack_unused_export__=function(a){return v(a)===q};__webpack_unused_export__=function(a){return v(a)===p};
__webpack_unused_export__=function(a){return v(a)===c};__webpack_unused_export__=function(a){return v(a)===f};__webpack_unused_export__=function(a){return v(a)===e};__webpack_unused_export__=function(a){return v(a)===m};__webpack_unused_export__=function(a){return v(a)===n};
__webpack_unused_export__=function(a){return"string"===typeof a||"function"===typeof a||a===d||a===f||a===e||a===m||a===n||a===t||"object"===typeof a&&null!==a&&(a.$$typeof===q||a.$$typeof===p||a.$$typeof===g||a.$$typeof===h||a.$$typeof===l||a.$$typeof===u||void 0!==a.getModuleId)?!0:!1};__webpack_unused_export__=v;


/***/ }),

/***/ 59864:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  /* unused reexport */ __webpack_require__(69921);
} else {}


/***/ }),

/***/ 57333:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h3": function() { return /* binding */ NumericFormat; }
/* harmony export */ });
/* unused harmony exports NumberFormatBase, PatternFormat, getNumericCaretBoundary, getPatternCaretBoundary, numericFormatter, patternFormatter, removeNumericFormat, removePatternFormat, useNumericFormat, usePatternFormat */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/**
 * react-number-format - 5.4.4
 * Author : Sudhanshu Yadav
 * Copyright (c) 2016, 2025 to Sudhanshu Yadav, released under the MIT license.
 * https://github.com/s-yadav/react-number-format
 */



/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) { if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        { t[p] = s[p]; } }
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        { for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                { t[p[i]] = s[p[i]]; }
        } }
    return t;
}

var SourceType;
(function (SourceType) {
    SourceType["event"] = "event";
    SourceType["props"] = "prop";
})(SourceType || (SourceType = {}));

// basic noop function
function noop() { }
function memoizeOnce(cb) {
    var lastArgs;
    var lastValue = undefined;
    return function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        if (lastArgs &&
            args.length === lastArgs.length &&
            args.every(function (value, index) { return value === lastArgs[index]; })) {
            return lastValue;
        }
        lastArgs = args;
        lastValue = cb.apply(void 0, args);
        return lastValue;
    };
}
function charIsNumber(char) {
    return !!(char || '').match(/\d/);
}
function isNil(val) {
    return val === null || val === undefined;
}
function isNanValue(val) {
    return typeof val === 'number' && isNaN(val);
}
function isNotValidValue(val) {
    return isNil(val) || isNanValue(val) || (typeof val === 'number' && !isFinite(val));
}
function escapeRegExp(str) {
    return str.replace(/[-[\]/{}()*+?.\\^$|]/g, '\\$&');
}
function getThousandsGroupRegex(thousandsGroupStyle) {
    switch (thousandsGroupStyle) {
        case 'lakh':
            return /(\d+?)(?=(\d\d)+(\d)(?!\d))(\.\d+)?/g;
        case 'wan':
            return /(\d)(?=(\d{4})+(?!\d))/g;
        case 'thousand':
        default:
            return /(\d)(?=(\d{3})+(?!\d))/g;
    }
}
function applyThousandSeparator(str, thousandSeparator, thousandsGroupStyle) {
    var thousandsGroupRegex = getThousandsGroupRegex(thousandsGroupStyle);
    var index = str.search(/[1-9]/);
    index = index === -1 ? str.length : index;
    return (str.substring(0, index) +
        str.substring(index, str.length).replace(thousandsGroupRegex, '$1' + thousandSeparator));
}
function usePersistentCallback(cb) {
    var callbackRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(cb);
    // keep the callback ref upto date
    callbackRef.current = cb;
    /**
     * initialize a persistent callback which never changes
     * through out the component lifecycle
     */
    var persistentCbRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        return callbackRef.current.apply(callbackRef, args);
    });
    return persistentCbRef.current;
}
//spilt a float number into different parts beforeDecimal, afterDecimal, and negation
function splitDecimal(numStr, allowNegative) {
    if ( allowNegative === void 0 ) allowNegative = true;

    var hasNegation = numStr[0] === '-';
    var addNegation = hasNegation && allowNegative;
    numStr = numStr.replace('-', '');
    var parts = numStr.split('.');
    var beforeDecimal = parts[0];
    var afterDecimal = parts[1] || '';
    return {
        beforeDecimal: beforeDecimal,
        afterDecimal: afterDecimal,
        hasNegation: hasNegation,
        addNegation: addNegation,
    };
}
function fixLeadingZero(numStr) {
    if (!numStr)
        { return numStr; }
    var isNegative = numStr[0] === '-';
    if (isNegative)
        { numStr = numStr.substring(1, numStr.length); }
    var parts = numStr.split('.');
    var beforeDecimal = parts[0].replace(/^0+/, '') || '0';
    var afterDecimal = parts[1] || '';
    return ("" + (isNegative ? '-' : '') + beforeDecimal + (afterDecimal ? ("." + afterDecimal) : ''));
}
/**
 * limit decimal numbers to given scale
 * Not used .fixedTo because that will break with big numbers
 */
function limitToScale(numStr, scale, fixedDecimalScale) {
    var str = '';
    var filler = fixedDecimalScale ? '0' : '';
    for (var i = 0; i <= scale - 1; i++) {
        str += numStr[i] || filler;
    }
    return str;
}
function repeat(str, count) {
    return Array(count + 1).join(str);
}
function toNumericString(num) {
    var _num = num + ''; // typecast number to string
    // store the sign and remove it from the number.
    var sign = _num[0] === '-' ? '-' : '';
    if (sign)
        { _num = _num.substring(1); }
    // split the number into cofficient and exponent
    var ref = _num.split(/[eE]/g);
    var coefficient = ref[0];
    var exponent = ref[1];
    // covert exponent to number;
    exponent = Number(exponent);
    // if there is no exponent part or its 0, return the coffiecient with sign
    if (!exponent)
        { return sign + coefficient; }
    coefficient = coefficient.replace('.', '');
    /**
     * for scientific notation the current decimal index will be after first number (index 0)
     * So effective decimal index will always be 1 + exponent value
     */
    var decimalIndex = 1 + exponent;
    var coffiecientLn = coefficient.length;
    if (decimalIndex < 0) {
        // if decimal index is less then 0 add preceding 0s
        // add 1 as join will have
        coefficient = '0.' + repeat('0', Math.abs(decimalIndex)) + coefficient;
    }
    else if (decimalIndex >= coffiecientLn) {
        // if decimal index is less then 0 add leading 0s
        coefficient = coefficient + repeat('0', decimalIndex - coffiecientLn);
    }
    else {
        // else add decimal point at proper index
        coefficient =
            (coefficient.substring(0, decimalIndex) || '0') + '.' + coefficient.substring(decimalIndex);
    }
    return sign + coefficient;
}
/**
 * This method is required to round prop value to given scale.
 * Not used .round or .fixedTo because that will break with big numbers
 */
function roundToPrecision(numStr, scale, fixedDecimalScale) {
    //if number is empty don't do anything return empty string
    if (['', '-'].indexOf(numStr) !== -1)
        { return numStr; }
    var shouldHaveDecimalSeparator = (numStr.indexOf('.') !== -1 || fixedDecimalScale) && scale;
    var ref = splitDecimal(numStr);
    var beforeDecimal = ref.beforeDecimal;
    var afterDecimal = ref.afterDecimal;
    var hasNegation = ref.hasNegation;
    var floatValue = parseFloat(("0." + (afterDecimal || '0')));
    var floatValueStr = afterDecimal.length <= scale ? ("0." + afterDecimal) : floatValue.toFixed(scale);
    var roundedDecimalParts = floatValueStr.split('.');
    var intPart = beforeDecimal;
    // if we have cary over from rounding decimal part, add that on before decimal
    if (beforeDecimal && Number(roundedDecimalParts[0])) {
        intPart = beforeDecimal
            .split('')
            .reverse()
            .reduce(function (roundedStr, current, idx) {
            if (roundedStr.length > idx) {
                return ((Number(roundedStr[0]) + Number(current)).toString() +
                    roundedStr.substring(1, roundedStr.length));
            }
            return current + roundedStr;
        }, roundedDecimalParts[0]);
    }
    var decimalPart = limitToScale(roundedDecimalParts[1] || '', scale, fixedDecimalScale);
    var negation = hasNegation ? '-' : '';
    var decimalSeparator = shouldHaveDecimalSeparator ? '.' : '';
    return ("" + negation + intPart + decimalSeparator + decimalPart);
}
/** set the caret positon in an input field **/
function setCaretPosition(el, caretPos) {
    el.value = el.value;
    // ^ this is used to not only get 'focus', but
    // to make sure we don't have it everything -selected-
    // (it causes an issue in chrome, and having it doesn't hurt any other browser)
    if (el !== null) {
        /* @ts-ignore */
        if (el.createTextRange) {
            /* @ts-ignore */
            var range = el.createTextRange();
            range.move('character', caretPos);
            range.select();
            return true;
        }
        // (el.selectionStart === 0 added for Firefox bug)
        if (el.selectionStart || el.selectionStart === 0) {
            el.focus();
            el.setSelectionRange(caretPos, caretPos);
            return true;
        }
        // fail city, fortunately this never happens (as far as I've tested) :)
        el.focus();
        return false;
    }
}
/**
 * TODO: remove dependency of findChangeRange, findChangedRangeFromCaretPositions is better way to find what is changed
 * currently this is mostly required by test and isCharacterSame util
 * Given previous value and newValue it returns the index
 * start - end to which values have changed.
 * This function makes assumption about only consecutive
 * characters are changed which is correct assumption for caret input.
 */
var findChangeRange = memoizeOnce(function (prevValue, newValue) {
    var i = 0, j = 0;
    var prevLength = prevValue.length;
    var newLength = newValue.length;
    while (prevValue[i] === newValue[i] && i < prevLength)
        { i++; }
    //check what has been changed from last
    while (prevValue[prevLength - 1 - j] === newValue[newLength - 1 - j] &&
        newLength - j > i &&
        prevLength - j > i) {
        j++;
    }
    return {
        from: { start: i, end: prevLength - j },
        to: { start: i, end: newLength - j },
    };
});
var findChangedRangeFromCaretPositions = function (lastCaretPositions, currentCaretPosition) {
    var startPosition = Math.min(lastCaretPositions.selectionStart, currentCaretPosition);
    return {
        from: { start: startPosition, end: lastCaretPositions.selectionEnd },
        to: { start: startPosition, end: currentCaretPosition },
    };
};
/*
  Returns a number whose value is limited to the given range
*/
function clamp(num, min, max) {
    return Math.min(Math.max(num, min), max);
}
function geInputCaretPosition(el) {
    /*Max of selectionStart and selectionEnd is taken for the patch of pixel and other mobile device caret bug*/
    return Math.max(el.selectionStart, el.selectionEnd);
}
function addInputMode() {
    return (typeof navigator !== 'undefined' &&
        !(navigator.platform && /iPhone|iPod/.test(navigator.platform)));
}
function getDefaultChangeMeta(value) {
    return {
        from: {
            start: 0,
            end: 0,
        },
        to: {
            start: 0,
            end: value.length,
        },
        lastValue: '',
    };
}
function getMaskAtIndex(mask, index) {
    if ( mask === void 0 ) mask = ' ';

    if (typeof mask === 'string') {
        return mask;
    }
    return mask[index] || ' ';
}
function defaultIsCharacterSame(ref) {
    var currentValue = ref.currentValue;
    var formattedValue = ref.formattedValue;
    var currentValueIndex = ref.currentValueIndex;
    var formattedValueIndex = ref.formattedValueIndex;

    return currentValue[currentValueIndex] === formattedValue[formattedValueIndex];
}
function getCaretPosition(newFormattedValue, lastFormattedValue, curValue, curCaretPos, boundary, isValidInputCharacter, 
/**
 * format function can change the character, the caret engine relies on mapping old value and new value
 * In such case if character is changed, parent can tell which chars are equivalent
 * Some example, all allowedDecimalCharacters are updated to decimalCharacters, 2nd case if user is coverting
 * number to different numeric system.
 */
isCharacterSame) {
    if ( isCharacterSame === void 0 ) isCharacterSame = defaultIsCharacterSame;

    /**
     * if something got inserted on empty value, add the formatted character before the current value,
     * This is to avoid the case where typed character is present on format characters
     */
    var firstAllowedPosition = boundary.findIndex(function (b) { return b; });
    var prefixFormat = newFormattedValue.slice(0, firstAllowedPosition);
    if (!lastFormattedValue && !curValue.startsWith(prefixFormat)) {
        lastFormattedValue = prefixFormat;
        curValue = prefixFormat + curValue;
        curCaretPos = curCaretPos + prefixFormat.length;
    }
    var curValLn = curValue.length;
    var formattedValueLn = newFormattedValue.length;
    // create index map
    var addedIndexMap = {};
    var indexMap = new Array(curValLn);
    for (var i = 0; i < curValLn; i++) {
        indexMap[i] = -1;
        for (var j = 0, jLn = formattedValueLn; j < jLn; j++) {
            var isCharSame = isCharacterSame({
                currentValue: curValue,
                lastValue: lastFormattedValue,
                formattedValue: newFormattedValue,
                currentValueIndex: i,
                formattedValueIndex: j,
            });
            if (isCharSame && addedIndexMap[j] !== true) {
                indexMap[i] = j;
                addedIndexMap[j] = true;
                break;
            }
        }
    }
    /**
     * For current caret position find closest characters (left and right side)
     * which are properly mapped to formatted value.
     * The idea is that the new caret position will exist always in the boundary of
     * that mapped index
     */
    var pos = curCaretPos;
    while (pos < curValLn && (indexMap[pos] === -1 || !isValidInputCharacter(curValue[pos]))) {
        pos++;
    }
    // if the caret position is on last keep the endIndex as last for formatted value
    var endIndex = pos === curValLn || indexMap[pos] === -1 ? formattedValueLn : indexMap[pos];
    pos = curCaretPos - 1;
    while (pos > 0 && indexMap[pos] === -1)
        { pos--; }
    var startIndex = pos === -1 || indexMap[pos] === -1 ? 0 : indexMap[pos] + 1;
    /**
     * case where a char is added on suffix and removed from middle, example 2sq345 becoming $2,345 sq
     * there is still a mapping but the order of start index and end index is changed
     */
    if (startIndex > endIndex)
        { return endIndex; }
    /**
     * given the current caret position if it closer to startIndex
     * keep the new caret position on start index or keep it closer to endIndex
     */
    return curCaretPos - startIndex < endIndex - curCaretPos ? startIndex : endIndex;
}
/* This keeps the caret within typing area so people can't type in between prefix or suffix or format characters */
function getCaretPosInBoundary(value, caretPos, boundary, direction) {
    var valLn = value.length;
    // clamp caret position to [0, value.length]
    caretPos = clamp(caretPos, 0, valLn);
    if (direction === 'left') {
        while (caretPos >= 0 && !boundary[caretPos])
            { caretPos--; }
        // if we don't find any suitable caret position on left, set it on first allowed position
        if (caretPos === -1)
            { caretPos = boundary.indexOf(true); }
    }
    else {
        while (caretPos <= valLn && !boundary[caretPos])
            { caretPos++; }
        // if we don't find any suitable caret position on right, set it on last allowed position
        if (caretPos > valLn)
            { caretPos = boundary.lastIndexOf(true); }
    }
    // if we still don't find caret position, set it at the end of value
    if (caretPos === -1)
        { caretPos = valLn; }
    return caretPos;
}
function caretUnknownFormatBoundary(formattedValue) {
    var boundaryAry = Array.from({ length: formattedValue.length + 1 }).map(function () { return true; });
    for (var i = 0, ln = boundaryAry.length; i < ln; i++) {
        // consider caret to be in boundary if it is before or after numeric value
        boundaryAry[i] = Boolean(charIsNumber(formattedValue[i]) || charIsNumber(formattedValue[i - 1]));
    }
    return boundaryAry;
}
function useInternalValues(value, defaultValue, valueIsNumericString, format, removeFormatting, onValueChange) {
    if ( onValueChange === void 0 ) onValueChange = noop;

    var getValues = usePersistentCallback(function (value, valueIsNumericString) {
        var formattedValue, numAsString;
        if (isNotValidValue(value)) {
            numAsString = '';
            formattedValue = '';
        }
        else if (typeof value === 'number' || valueIsNumericString) {
            numAsString = typeof value === 'number' ? toNumericString(value) : value;
            formattedValue = format(numAsString);
        }
        else {
            numAsString = removeFormatting(value, undefined);
            formattedValue = format(numAsString);
        }
        return { formattedValue: formattedValue, numAsString: numAsString };
    });
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(function () {
        return getValues(isNil(value) ? defaultValue : value, valueIsNumericString);
    });
    var values = ref[0];
    var setValues = ref[1];
    var _onValueChange = function (newValues, sourceInfo) {
        if (newValues.formattedValue !== values.formattedValue) {
            setValues({
                formattedValue: newValues.formattedValue,
                numAsString: newValues.value,
            });
        }
        // call parent on value change if only if formatted value is changed
        onValueChange(newValues, sourceInfo);
    };
    // if value is switch from controlled to uncontrolled, use the internal state's value to format with new props
    var _value = value;
    var _valueIsNumericString = valueIsNumericString;
    if (isNil(value)) {
        _value = values.numAsString;
        _valueIsNumericString = true;
    }
    var newValues = getValues(_value, _valueIsNumericString);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
        setValues(newValues);
    }, [newValues.formattedValue]);
    return [values, _onValueChange];
}

function defaultRemoveFormatting(value) {
    return value.replace(/[^0-9]/g, '');
}
function defaultFormat(value) {
    return value;
}
function NumberFormatBase(props) {
    var type = props.type; if ( type === void 0 ) type = 'text';
    var displayType = props.displayType; if ( displayType === void 0 ) displayType = 'input';
    var customInput = props.customInput;
    var renderText = props.renderText;
    var getInputRef = props.getInputRef;
    var format = props.format; if ( format === void 0 ) format = defaultFormat;
    var removeFormatting = props.removeFormatting; if ( removeFormatting === void 0 ) removeFormatting = defaultRemoveFormatting;
    var defaultValue = props.defaultValue;
    var valueIsNumericString = props.valueIsNumericString;
    var onValueChange = props.onValueChange;
    var isAllowed = props.isAllowed;
    var onChange = props.onChange; if ( onChange === void 0 ) onChange = noop;
    var onKeyDown = props.onKeyDown; if ( onKeyDown === void 0 ) onKeyDown = noop;
    var onMouseUp = props.onMouseUp; if ( onMouseUp === void 0 ) onMouseUp = noop;
    var onFocus = props.onFocus; if ( onFocus === void 0 ) onFocus = noop;
    var onBlur = props.onBlur; if ( onBlur === void 0 ) onBlur = noop;
    var propValue = props.value;
    var getCaretBoundary = props.getCaretBoundary; if ( getCaretBoundary === void 0 ) getCaretBoundary = caretUnknownFormatBoundary;
    var isValidInputCharacter = props.isValidInputCharacter; if ( isValidInputCharacter === void 0 ) isValidInputCharacter = charIsNumber;
    var isCharacterSame = props.isCharacterSame;
    var otherProps = __rest(props, ["type", "displayType", "customInput", "renderText", "getInputRef", "format", "removeFormatting", "defaultValue", "valueIsNumericString", "onValueChange", "isAllowed", "onChange", "onKeyDown", "onMouseUp", "onFocus", "onBlur", "value", "getCaretBoundary", "isValidInputCharacter", "isCharacterSame"]);
    var ref = useInternalValues(propValue, defaultValue, Boolean(valueIsNumericString), format, removeFormatting, onValueChange);
    var ref_0 = ref[0];
    var formattedValue = ref_0.formattedValue;
    var numAsString = ref_0.numAsString;
    var onFormattedValueChange = ref[1];
    var caretPositionBeforeChange = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    var lastUpdatedValue = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({ formattedValue: formattedValue, numAsString: numAsString });
    var _onValueChange = function (values, source) {
        lastUpdatedValue.current = { formattedValue: values.formattedValue, numAsString: values.value };
        onFormattedValueChange(values, source);
    };
    var ref$1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
    var mounted = ref$1[0];
    var setMounted = ref$1[1];
    var focusedElm = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var timeout = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({
        setCaretTimeout: null,
        focusTimeout: null,
    });
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        setMounted(true);
        return function () {
            clearTimeout(timeout.current.setCaretTimeout);
            clearTimeout(timeout.current.focusTimeout);
        };
    }, []);
    var _format = format;
    var getValueObject = function (formattedValue, numAsString) {
        var floatValue = parseFloat(numAsString);
        return {
            formattedValue: formattedValue,
            value: numAsString,
            floatValue: isNaN(floatValue) ? undefined : floatValue,
        };
    };
    var setPatchedCaretPosition = function (el, caretPos, currentValue) {
        // don't reset the caret position when the whole input content is selected
        if (el.selectionStart === 0 && el.selectionEnd === el.value.length)
            { return; }
        /* setting caret position within timeout of 0ms is required for mobile chrome,
        otherwise browser resets the caret position after we set it
        We are also setting it without timeout so that in normal browser we don't see the flickering */
        setCaretPosition(el, caretPos);
        timeout.current.setCaretTimeout = setTimeout(function () {
            if (el.value === currentValue && el.selectionStart !== caretPos) {
                setCaretPosition(el, caretPos);
            }
        }, 0);
    };
    /* This keeps the caret within typing area so people can't type in between prefix or suffix */
    var correctCaretPosition = function (value, caretPos, direction) {
        return getCaretPosInBoundary(value, caretPos, getCaretBoundary(value), direction);
    };
    var getNewCaretPosition = function (inputValue, newFormattedValue, caretPos) {
        var caretBoundary = getCaretBoundary(newFormattedValue);
        var updatedCaretPos = getCaretPosition(newFormattedValue, formattedValue, inputValue, caretPos, caretBoundary, isValidInputCharacter, isCharacterSame);
        //correct caret position if its outside of editable area
        updatedCaretPos = getCaretPosInBoundary(newFormattedValue, updatedCaretPos, caretBoundary);
        return updatedCaretPos;
    };
    var updateValueAndCaretPosition = function (params) {
        var newFormattedValue = params.formattedValue; if ( newFormattedValue === void 0 ) newFormattedValue = '';
        var input = params.input;
        var source = params.source;
        var event = params.event;
        var numAsString = params.numAsString;
        var caretPos;
        if (input) {
            var inputValue = params.inputValue || input.value;
            var currentCaretPosition = geInputCaretPosition(input);
            /**
             * set the value imperatively, this is required for IE fix
             * This is also required as if new caret position is beyond the previous value.
             * Caret position will not be set correctly
             */
            input.value = newFormattedValue;
            //get the caret position
            caretPos = getNewCaretPosition(inputValue, newFormattedValue, currentCaretPosition);
            //set caret position imperatively
            if (caretPos !== undefined) {
                setPatchedCaretPosition(input, caretPos, newFormattedValue);
            }
        }
        if (newFormattedValue !== formattedValue) {
            // trigger onValueChange synchronously, so parent is updated along with the number format. Fix for #277, #287
            _onValueChange(getValueObject(newFormattedValue, numAsString), { event: event, source: source });
        }
    };
    /**
     * if the formatted value is not synced to parent, or if the formatted value is different from last synced value sync it
     * if the formatting props is removed, in which case last formatted value will be different from the numeric string value
     * in such case we need to inform the parent.
     */
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        var ref = lastUpdatedValue.current;
        var lastFormattedValue = ref.formattedValue;
        var lastNumAsString = ref.numAsString;
        if (formattedValue !== lastFormattedValue || numAsString !== lastNumAsString) {
            _onValueChange(getValueObject(formattedValue, numAsString), {
                event: undefined,
                source: SourceType.props,
            });
        }
    }, [formattedValue, numAsString]);
    // also if formatted value is changed from the props, we need to update the caret position
    // keep the last caret position if element is focused
    var currentCaretPosition = focusedElm.current
        ? geInputCaretPosition(focusedElm.current)
        : undefined;
    // needed to prevent warning with useLayoutEffect on server
    var useIsomorphicLayoutEffect = typeof window !== 'undefined' ? react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect : react__WEBPACK_IMPORTED_MODULE_0__.useEffect;
    useIsomorphicLayoutEffect(function () {
        var input = focusedElm.current;
        if (formattedValue !== lastUpdatedValue.current.formattedValue && input) {
            var caretPos = getNewCaretPosition(lastUpdatedValue.current.formattedValue, formattedValue, currentCaretPosition);
            /**
             * set the value imperatively, as we set the caret position as well imperatively.
             * This is to keep value and caret position in sync
             */
            input.value = formattedValue;
            setPatchedCaretPosition(input, caretPos, formattedValue);
        }
    }, [formattedValue]);
    var formatInputValue = function (inputValue, event, source) {
        var input = event.target;
        var changeRange = caretPositionBeforeChange.current
            ? findChangedRangeFromCaretPositions(caretPositionBeforeChange.current, input.selectionEnd)
            : findChangeRange(formattedValue, inputValue);
        var changeMeta = Object.assign(Object.assign({}, changeRange), { lastValue: formattedValue });
        var _numAsString = removeFormatting(inputValue, changeMeta);
        var _formattedValue = _format(_numAsString);
        // formatting can remove some of the number chars, so we need to fine number string again
        _numAsString = removeFormatting(_formattedValue, undefined);
        if (isAllowed && !isAllowed(getValueObject(_formattedValue, _numAsString))) {
            //reset the caret position
            var input$1 = event.target;
            var currentCaretPosition = geInputCaretPosition(input$1);
            var caretPos = getNewCaretPosition(inputValue, formattedValue, currentCaretPosition);
            input$1.value = formattedValue;
            setPatchedCaretPosition(input$1, caretPos, formattedValue);
            return false;
        }
        updateValueAndCaretPosition({
            formattedValue: _formattedValue,
            numAsString: _numAsString,
            inputValue: inputValue,
            event: event,
            source: source,
            input: event.target,
        });
        return true;
    };
    var setCaretPositionInfoBeforeChange = function (el, endOffset) {
        if ( endOffset === void 0 ) endOffset = 0;

        var selectionStart = el.selectionStart;
        var selectionEnd = el.selectionEnd;
        caretPositionBeforeChange.current = { selectionStart: selectionStart, selectionEnd: selectionEnd + endOffset };
    };
    var _onChange = function (e) {
        var el = e.target;
        var inputValue = el.value;
        var changed = formatInputValue(inputValue, e, SourceType.event);
        if (changed)
            { onChange(e); }
        // reset the position, as we have already handled the caret position
        caretPositionBeforeChange.current = undefined;
    };
    var _onKeyDown = function (e) {
        var el = e.target;
        var key = e.key;
        var selectionStart = el.selectionStart;
        var selectionEnd = el.selectionEnd;
        var value = el.value; if ( value === void 0 ) value = '';
        var expectedCaretPosition;
        //Handle backspace and delete against non numerical/decimal characters or arrow keys
        if (key === 'ArrowLeft' || key === 'Backspace') {
            expectedCaretPosition = Math.max(selectionStart - 1, 0);
        }
        else if (key === 'ArrowRight') {
            expectedCaretPosition = Math.min(selectionStart + 1, value.length);
        }
        else if (key === 'Delete') {
            expectedCaretPosition = selectionStart;
        }
        // if key is delete and text is not selected keep the end offset to 1, as it deletes one character
        // this is required as selection is not changed on delete case, which changes the change range calculation
        var endOffset = 0;
        if (key === 'Delete' && selectionStart === selectionEnd) {
            endOffset = 1;
        }
        var isArrowKey = key === 'ArrowLeft' || key === 'ArrowRight';
        //if expectedCaretPosition is not set it means we don't want to Handle keyDown
        // also if multiple characters are selected don't handle
        if (expectedCaretPosition === undefined || (selectionStart !== selectionEnd && !isArrowKey)) {
            onKeyDown(e);
            // keep information of what was the caret position before keyDown
            // set it after onKeyDown, in case parent updates the position manually
            setCaretPositionInfoBeforeChange(el, endOffset);
            return;
        }
        var newCaretPosition = expectedCaretPosition;
        if (isArrowKey) {
            var direction = key === 'ArrowLeft' ? 'left' : 'right';
            newCaretPosition = correctCaretPosition(value, expectedCaretPosition, direction);
            // arrow left or right only moves the caret, so no need to handle the event, if we are handling it manually
            if (newCaretPosition !== expectedCaretPosition) {
                e.preventDefault();
            }
        }
        else if (key === 'Delete' && !isValidInputCharacter(value[expectedCaretPosition])) {
            // in case of delete go to closest caret boundary on the right side
            newCaretPosition = correctCaretPosition(value, expectedCaretPosition, 'right');
        }
        else if (key === 'Backspace' && !isValidInputCharacter(value[expectedCaretPosition])) {
            // in case of backspace go to closest caret boundary on the left side
            newCaretPosition = correctCaretPosition(value, expectedCaretPosition, 'left');
        }
        if (newCaretPosition !== expectedCaretPosition) {
            setPatchedCaretPosition(el, newCaretPosition, value);
        }
        onKeyDown(e);
        setCaretPositionInfoBeforeChange(el, endOffset);
    };
    /** required to handle the caret position when click anywhere within the input **/
    var _onMouseUp = function (e) {
        var el = e.target;
        /**
         * NOTE: we have to give default value for value as in case when custom input is provided
         * value can come as undefined when nothing is provided on value prop.
         */
        var correctCaretPositionIfRequired = function () {
            var selectionStart = el.selectionStart;
            var selectionEnd = el.selectionEnd;
            var value = el.value; if ( value === void 0 ) value = '';
            if (selectionStart === selectionEnd) {
                var caretPosition = correctCaretPosition(value, selectionStart);
                if (caretPosition !== selectionStart) {
                    setPatchedCaretPosition(el, caretPosition, value);
                }
            }
        };
        correctCaretPositionIfRequired();
        // try to correct after selection has updated by browser
        // this case is required when user clicks on some position while a text is selected on input
        requestAnimationFrame(function () {
            correctCaretPositionIfRequired();
        });
        onMouseUp(e);
        setCaretPositionInfoBeforeChange(el);
    };
    var _onFocus = function (e) {
        // Workaround Chrome and Safari bug https://bugs.chromium.org/p/chromium/issues/detail?id=779328
        // (onFocus event target selectionStart is always 0 before setTimeout)
        if (e.persist)
            { e.persist(); }
        var el = e.target;
        var currentTarget = e.currentTarget;
        focusedElm.current = el;
        timeout.current.focusTimeout = setTimeout(function () {
            var selectionStart = el.selectionStart;
            var selectionEnd = el.selectionEnd;
            var value = el.value; if ( value === void 0 ) value = '';
            var caretPosition = correctCaretPosition(value, selectionStart);
            //setPatchedCaretPosition only when everything is not selected on focus (while tabbing into the field)
            if (caretPosition !== selectionStart &&
                !(selectionStart === 0 && selectionEnd === value.length)) {
                setPatchedCaretPosition(el, caretPosition, value);
            }
            onFocus(Object.assign(Object.assign({}, e), { currentTarget: currentTarget }));
        }, 0);
    };
    var _onBlur = function (e) {
        focusedElm.current = null;
        clearTimeout(timeout.current.focusTimeout);
        clearTimeout(timeout.current.setCaretTimeout);
        onBlur(e);
    };
    // add input mode on element based on format prop and device once the component is mounted
    var inputMode = mounted && addInputMode() ? 'numeric' : undefined;
    var inputProps = Object.assign({ inputMode: inputMode }, otherProps, {
        type: type,
        value: formattedValue,
        onChange: _onChange,
        onKeyDown: _onKeyDown,
        onMouseUp: _onMouseUp,
        onFocus: _onFocus,
        onBlur: _onBlur,
    });
    if (displayType === 'text') {
        return renderText ? (react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, renderText(formattedValue, otherProps) || null)) : (react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", Object.assign({}, otherProps, { ref: getInputRef }), formattedValue));
    }
    else if (customInput) {
        var CustomInput = customInput;
        /* @ts-ignore */
        return react__WEBPACK_IMPORTED_MODULE_0__.createElement(CustomInput, Object.assign({}, inputProps, { ref: getInputRef }));
    }
    return react__WEBPACK_IMPORTED_MODULE_0__.createElement("input", Object.assign({}, inputProps, { ref: getInputRef }));
}

function format(numStr, props) {
    var decimalScale = props.decimalScale;
    var fixedDecimalScale = props.fixedDecimalScale;
    var prefix = props.prefix; if ( prefix === void 0 ) prefix = '';
    var suffix = props.suffix; if ( suffix === void 0 ) suffix = '';
    var allowNegative = props.allowNegative;
    var thousandsGroupStyle = props.thousandsGroupStyle; if ( thousandsGroupStyle === void 0 ) thousandsGroupStyle = 'thousand';
    // don't apply formatting on empty string or '-'
    if (numStr === '' || numStr === '-') {
        return numStr;
    }
    var ref = getSeparators(props);
    var thousandSeparator = ref.thousandSeparator;
    var decimalSeparator = ref.decimalSeparator;
    /**
     * Keep the decimal separator
     * when decimalScale is not defined or non zero and the numStr has decimal in it
     * Or if decimalScale is > 0 and fixeDecimalScale is true (even if numStr has no decimal)
     */
    var hasDecimalSeparator = (decimalScale !== 0 && numStr.indexOf('.') !== -1) || (decimalScale && fixedDecimalScale);
    var ref$1 = splitDecimal(numStr, allowNegative);
    var beforeDecimal = ref$1.beforeDecimal;
    var afterDecimal = ref$1.afterDecimal;
    var addNegation = ref$1.addNegation; // eslint-disable-line prefer-const
    //apply decimal precision if its defined
    if (decimalScale !== undefined) {
        afterDecimal = limitToScale(afterDecimal, decimalScale, !!fixedDecimalScale);
    }
    if (thousandSeparator) {
        beforeDecimal = applyThousandSeparator(beforeDecimal, thousandSeparator, thousandsGroupStyle);
    }
    //add prefix and suffix when there is a number present
    if (prefix)
        { beforeDecimal = prefix + beforeDecimal; }
    if (suffix)
        { afterDecimal = afterDecimal + suffix; }
    //restore negation sign
    if (addNegation)
        { beforeDecimal = '-' + beforeDecimal; }
    numStr = beforeDecimal + ((hasDecimalSeparator && decimalSeparator) || '') + afterDecimal;
    return numStr;
}
function getSeparators(props) {
    var decimalSeparator = props.decimalSeparator; if ( decimalSeparator === void 0 ) decimalSeparator = '.';
    var thousandSeparator = props.thousandSeparator;
    var allowedDecimalSeparators = props.allowedDecimalSeparators;
    if (thousandSeparator === true) {
        thousandSeparator = ',';
    }
    if (!allowedDecimalSeparators) {
        allowedDecimalSeparators = [decimalSeparator, '.'];
    }
    return {
        decimalSeparator: decimalSeparator,
        thousandSeparator: thousandSeparator,
        allowedDecimalSeparators: allowedDecimalSeparators,
    };
}
function handleNegation(value, allowNegative) {
    if ( value === void 0 ) value = '';

    var negationRegex = new RegExp('(-)');
    var doubleNegationRegex = new RegExp('(-)(.)*(-)');
    // Check number has '-' value
    var hasNegation = negationRegex.test(value);
    // Check number has 2 or more '-' values
    var removeNegation = doubleNegationRegex.test(value);
    //remove negation
    value = value.replace(/-/g, '');
    if (hasNegation && !removeNegation && allowNegative) {
        value = '-' + value;
    }
    return value;
}
function getNumberRegex(decimalSeparator, global) {
    return new RegExp(("(^-)|[0-9]|" + (escapeRegExp(decimalSeparator))), global ? 'g' : undefined);
}
function isNumericString(val, prefix, suffix) {
    // for empty value we can always treat it as numeric string
    if (val === '')
        { return true; }
    return (!(prefix === null || prefix === void 0 ? void 0 : prefix.match(/\d/)) && !(suffix === null || suffix === void 0 ? void 0 : suffix.match(/\d/)) && typeof val === 'string' && !isNaN(Number(val)));
}
function removeFormatting(value, changeMeta, props) {
    var assign;

    if ( changeMeta === void 0 ) changeMeta = getDefaultChangeMeta(value);
    var allowNegative = props.allowNegative;
    var prefix = props.prefix; if ( prefix === void 0 ) prefix = '';
    var suffix = props.suffix; if ( suffix === void 0 ) suffix = '';
    var decimalScale = props.decimalScale;
    var from = changeMeta.from;
    var to = changeMeta.to;
    var start = to.start;
    var end = to.end;
    var ref = getSeparators(props);
    var allowedDecimalSeparators = ref.allowedDecimalSeparators;
    var decimalSeparator = ref.decimalSeparator;
    var isBeforeDecimalSeparator = value[end] === decimalSeparator;
    /**
     * If only a number is added on empty input which matches with the prefix or suffix,
     * then don't remove it, just return the same
     */
    if (charIsNumber(value) &&
        (value === prefix || value === suffix) &&
        changeMeta.lastValue === '') {
        return value;
    }
    /** Check for any allowed decimal separator is added in the numeric format and replace it with decimal separator */
    if (end - start === 1 && allowedDecimalSeparators.indexOf(value[start]) !== -1) {
        var separator = decimalScale === 0 ? '' : decimalSeparator;
        value = value.substring(0, start) + separator + value.substring(start + 1, value.length);
    }
    var stripNegation = function (value, start, end) {
        /**
         * if prefix starts with - we don't allow negative number to avoid confusion
         * if suffix starts with - and the value length is same as suffix length, then the - sign is from the suffix
         * In other cases, if the value starts with - then it is a negation
         */
        var hasNegation = false;
        var hasDoubleNegation = false;
        if (prefix.startsWith('-')) {
            hasNegation = false;
        }
        else if (value.startsWith('--')) {
            hasNegation = false;
            hasDoubleNegation = true;
        }
        else if (suffix.startsWith('-') && value.length === suffix.length) {
            hasNegation = false;
        }
        else if (value[0] === '-') {
            hasNegation = true;
        }
        var charsToRemove = hasNegation ? 1 : 0;
        if (hasDoubleNegation)
            { charsToRemove = 2; }
        // remove negation/double negation from start to simplify prefix logic as negation comes before prefix
        if (charsToRemove) {
            value = value.substring(charsToRemove);
            // account for the removal of the negation for start and end index
            start -= charsToRemove;
            end -= charsToRemove;
        }
        return { value: value, start: start, end: end, hasNegation: hasNegation };
    };
    var toMetadata = stripNegation(value, start, end);
    var hasNegation = toMetadata.hasNegation;
    ((assign = toMetadata, value = assign.value, start = assign.start, end = assign.end));
    var ref$1 = stripNegation(changeMeta.lastValue, from.start, from.end);
    var fromStart = ref$1.start;
    var fromEnd = ref$1.end;
    var lastValue = ref$1.value;
    // if only prefix and suffix part is updated reset the value to last value
    // if the changed range is from suffix in the updated value, and the the suffix starts with the same characters, allow the change
    var updatedSuffixPart = value.substring(start, end);
    if (value.length &&
        lastValue.length &&
        (fromStart > lastValue.length - suffix.length || fromEnd < prefix.length) &&
        !(updatedSuffixPart && suffix.startsWith(updatedSuffixPart))) {
        value = lastValue;
    }
    /**
     * remove prefix
     * Remove whole prefix part if its present on the value
     * If the prefix is partially deleted (in which case change start index will be less the prefix length)
     * Remove only partial part of prefix.
     */
    var startIndex = 0;
    if (value.startsWith(prefix))
        { startIndex += prefix.length; }
    else if (start < prefix.length)
        { startIndex = start; }
    value = value.substring(startIndex);
    // account for deleted prefix for end
    end -= startIndex;
    /**
     * Remove suffix
     * Remove whole suffix part if its present on the value
     * If the suffix is partially deleted (in which case change end index will be greater than the suffixStartIndex)
     * remove the partial part of suffix
     */
    var endIndex = value.length;
    var suffixStartIndex = value.length - suffix.length;
    if (value.endsWith(suffix))
        { endIndex = suffixStartIndex; }
    // if the suffix is removed from the end
    else if (end > suffixStartIndex)
        { endIndex = end; }
    // if the suffix is removed from start
    else if (end > value.length - suffix.length)
        { endIndex = end; }
    value = value.substring(0, endIndex);
    // add the negation back and handle for double negation
    value = handleNegation(hasNegation ? ("-" + value) : value, allowNegative);
    // remove non numeric characters
    value = (value.match(getNumberRegex(decimalSeparator, true)) || []).join('');
    // replace the decimalSeparator with ., and only keep the first separator, ignore following ones
    var firstIndex = value.indexOf(decimalSeparator);
    value = value.replace(new RegExp(escapeRegExp(decimalSeparator), 'g'), function (match, index) {
        return index === firstIndex ? '.' : '';
    });
    //check if beforeDecimal got deleted and there is nothing after decimal,
    //clear all numbers in such case while keeping the - sign
    var ref$2 = splitDecimal(value, allowNegative);
    var beforeDecimal = ref$2.beforeDecimal;
    var afterDecimal = ref$2.afterDecimal;
    var addNegation = ref$2.addNegation; // eslint-disable-line prefer-const
    //clear only if something got deleted before decimal (cursor is before decimal)
    if (to.end - to.start < from.end - from.start &&
        beforeDecimal === '' &&
        isBeforeDecimalSeparator &&
        !parseFloat(afterDecimal)) {
        value = addNegation ? '-' : '';
    }
    return value;
}
function getCaretBoundary(formattedValue, props) {
    var prefix = props.prefix; if ( prefix === void 0 ) prefix = '';
    var suffix = props.suffix; if ( suffix === void 0 ) suffix = '';
    var boundaryAry = Array.from({ length: formattedValue.length + 1 }).map(function () { return true; });
    var hasNegation = formattedValue[0] === '-';
    // fill for prefix and negation
    boundaryAry.fill(false, 0, prefix.length + (hasNegation ? 1 : 0));
    // fill for suffix
    var valLn = formattedValue.length;
    boundaryAry.fill(false, valLn - suffix.length + 1, valLn + 1);
    return boundaryAry;
}
function validateAndUpdateProps(props) {
    var ref = getSeparators(props);
    var thousandSeparator = ref.thousandSeparator;
    var decimalSeparator = ref.decimalSeparator;
    // eslint-disable-next-line prefer-const
    var prefix = props.prefix; if ( prefix === void 0 ) prefix = '';
    var allowNegative = props.allowNegative; if ( allowNegative === void 0 ) allowNegative = true;
    if (thousandSeparator === decimalSeparator) {
        throw new Error(("\n        Decimal separator can't be same as thousand separator.\n        thousandSeparator: " + thousandSeparator + " (thousandSeparator = {true} is same as thousandSeparator = \",\")\n        decimalSeparator: " + decimalSeparator + " (default value for decimalSeparator is .)\n     "));
    }
    if (prefix.startsWith('-') && allowNegative) {
        // TODO: throw error in next major version
        console.error(("\n      Prefix can't start with '-' when allowNegative is true.\n      prefix: " + prefix + "\n      allowNegative: " + allowNegative + "\n    "));
        allowNegative = false;
    }
    return Object.assign(Object.assign({}, props), { allowNegative: allowNegative });
}
function useNumericFormat(props) {
    // validate props
    props = validateAndUpdateProps(props);
    var _decimalSeparator = props.decimalSeparator;
    var _allowedDecimalSeparators = props.allowedDecimalSeparators;
    var thousandsGroupStyle = props.thousandsGroupStyle;
    var suffix = props.suffix;
    var allowNegative = props.allowNegative;
    var allowLeadingZeros = props.allowLeadingZeros;
    var onKeyDown = props.onKeyDown; if ( onKeyDown === void 0 ) onKeyDown = noop;
    var onBlur = props.onBlur; if ( onBlur === void 0 ) onBlur = noop;
    var thousandSeparator = props.thousandSeparator;
    var decimalScale = props.decimalScale;
    var fixedDecimalScale = props.fixedDecimalScale;
    var prefix = props.prefix; if ( prefix === void 0 ) prefix = '';
    var defaultValue = props.defaultValue;
    var value = props.value;
    var valueIsNumericString = props.valueIsNumericString;
    var onValueChange = props.onValueChange;
    var restProps = __rest(props, ["decimalSeparator", "allowedDecimalSeparators", "thousandsGroupStyle", "suffix", "allowNegative", "allowLeadingZeros", "onKeyDown", "onBlur", "thousandSeparator", "decimalScale", "fixedDecimalScale", "prefix", "defaultValue", "value", "valueIsNumericString", "onValueChange"]);
    // get derived decimalSeparator and allowedDecimalSeparators
    var ref = getSeparators(props);
    var decimalSeparator = ref.decimalSeparator;
    var allowedDecimalSeparators = ref.allowedDecimalSeparators;
    var _format = function (numStr) { return format(numStr, props); };
    var _removeFormatting = function (inputValue, changeMeta) { return removeFormatting(inputValue, changeMeta, props); };
    var _value = isNil(value) ? defaultValue : value;
    // try to figure out isValueNumericString based on format prop and value
    var _valueIsNumericString = valueIsNumericString !== null && valueIsNumericString !== void 0 ? valueIsNumericString : isNumericString(_value, prefix, suffix);
    if (!isNil(value)) {
        _valueIsNumericString = _valueIsNumericString || typeof value === 'number';
    }
    else if (!isNil(defaultValue)) {
        _valueIsNumericString = _valueIsNumericString || typeof defaultValue === 'number';
    }
    var roundIncomingValueToPrecision = function (value) {
        if (isNotValidValue(value))
            { return value; }
        if (typeof value === 'number') {
            value = toNumericString(value);
        }
        /**
         * only round numeric or float string values coming through props,
         * we don't need to do it for onChange events, as we want to prevent typing there
         */
        if (_valueIsNumericString && typeof decimalScale === 'number') {
            return roundToPrecision(value, decimalScale, Boolean(fixedDecimalScale));
        }
        return value;
    };
    var ref$1 = useInternalValues(roundIncomingValueToPrecision(value), roundIncomingValueToPrecision(defaultValue), Boolean(_valueIsNumericString), _format, _removeFormatting, onValueChange);
    var ref$1_0 = ref$1[0];
    var numAsString = ref$1_0.numAsString;
    var formattedValue = ref$1_0.formattedValue;
    var _onValueChange = ref$1[1];
    var _onKeyDown = function (e) {
        var el = e.target;
        var key = e.key;
        var selectionStart = el.selectionStart;
        var selectionEnd = el.selectionEnd;
        var value = el.value; if ( value === void 0 ) value = '';
        // if user tries to delete partial prefix then ignore it
        if ((key === 'Backspace' || key === 'Delete') && selectionEnd < prefix.length) {
            e.preventDefault();
            return;
        }
        // if multiple characters are selected and user hits backspace, no need to handle anything manually
        if (selectionStart !== selectionEnd) {
            onKeyDown(e);
            return;
        }
        // if user hits backspace, while the cursor is before prefix, and the input has negation, remove the negation
        if (key === 'Backspace' &&
            value[0] === '-' &&
            selectionStart === prefix.length + 1 &&
            allowNegative) {
            // bring the cursor to after negation
            setCaretPosition(el, 1);
        }
        // don't allow user to delete decimal separator when decimalScale and fixedDecimalScale is set
        if (decimalScale && fixedDecimalScale) {
            if (key === 'Backspace' && value[selectionStart - 1] === decimalSeparator) {
                setCaretPosition(el, selectionStart - 1);
                e.preventDefault();
            }
            else if (key === 'Delete' && value[selectionStart] === decimalSeparator) {
                e.preventDefault();
            }
        }
        // if user presses the allowed decimal separator before the separator, move the cursor after the separator
        if ((allowedDecimalSeparators === null || allowedDecimalSeparators === void 0 ? void 0 : allowedDecimalSeparators.includes(key)) && value[selectionStart] === decimalSeparator) {
            setCaretPosition(el, selectionStart + 1);
        }
        var _thousandSeparator = thousandSeparator === true ? ',' : thousandSeparator;
        // move cursor when delete or backspace is pressed before/after thousand separator
        if (key === 'Backspace' && value[selectionStart - 1] === _thousandSeparator) {
            setCaretPosition(el, selectionStart - 1);
        }
        if (key === 'Delete' && value[selectionStart] === _thousandSeparator) {
            setCaretPosition(el, selectionStart + 1);
        }
        onKeyDown(e);
    };
    var _onBlur = function (e) {
        var _value = numAsString;
        // if there no no numeric value, clear the input
        if (!_value.match(/\d/g)) {
            _value = '';
        }
        // clear leading 0s
        if (!allowLeadingZeros) {
            _value = fixLeadingZero(_value);
        }
        // apply fixedDecimalScale on blur event
        if (fixedDecimalScale && decimalScale) {
            _value = roundToPrecision(_value, decimalScale, fixedDecimalScale);
        }
        if (_value !== numAsString) {
            var formattedValue = format(_value, props);
            _onValueChange({
                formattedValue: formattedValue,
                value: _value,
                floatValue: parseFloat(_value),
            }, {
                event: e,
                source: SourceType.event,
            });
        }
        onBlur(e);
    };
    var isValidInputCharacter = function (inputChar) {
        if (inputChar === decimalSeparator)
            { return true; }
        return charIsNumber(inputChar);
    };
    var isCharacterSame = function (ref) {
        var currentValue = ref.currentValue;
        var lastValue = ref.lastValue;
        var formattedValue = ref.formattedValue;
        var currentValueIndex = ref.currentValueIndex;
        var formattedValueIndex = ref.formattedValueIndex;

        var curChar = currentValue[currentValueIndex];
        var newChar = formattedValue[formattedValueIndex];
        /**
         * NOTE: as thousand separator and allowedDecimalSeparators can be same, we need to check on
         * typed range if we have typed any character from allowedDecimalSeparators, in that case we
         * consider different characters like , and . same within the range of updated value.
         */
        var typedRange = findChangeRange(lastValue, currentValue);
        var to = typedRange.to;
        // handle corner case where if we user types a decimal separator with fixedDecimalScale
        // and pass back float value the cursor jumps. #851
        var getDecimalSeparatorIndex = function (value) {
            return _removeFormatting(value).indexOf('.') + prefix.length;
        };
        if (value === 0 &&
            fixedDecimalScale &&
            decimalScale &&
            currentValue[to.start] === decimalSeparator &&
            getDecimalSeparatorIndex(currentValue) < currentValueIndex &&
            getDecimalSeparatorIndex(formattedValue) > formattedValueIndex) {
            return false;
        }
        if (currentValueIndex >= to.start &&
            currentValueIndex < to.end &&
            allowedDecimalSeparators &&
            allowedDecimalSeparators.includes(curChar) &&
            newChar === decimalSeparator) {
            return true;
        }
        return curChar === newChar;
    };
    return Object.assign(Object.assign({}, restProps), { value: formattedValue, valueIsNumericString: false, isValidInputCharacter: isValidInputCharacter,
        isCharacterSame: isCharacterSame, onValueChange: _onValueChange, format: _format, removeFormatting: _removeFormatting, getCaretBoundary: function (formattedValue) { return getCaretBoundary(formattedValue, props); }, onKeyDown: _onKeyDown, onBlur: _onBlur });
}
function NumericFormat(props) {
    var numericFormatProps = useNumericFormat(props);
    return react__WEBPACK_IMPORTED_MODULE_0__.createElement(NumberFormatBase, Object.assign({}, numericFormatProps));
}

function format$1(numStr, props) {
    var format = props.format;
    var allowEmptyFormatting = props.allowEmptyFormatting;
    var mask = props.mask;
    var patternChar = props.patternChar; if ( patternChar === void 0 ) patternChar = '#';
    if (numStr === '' && !allowEmptyFormatting)
        { return ''; }
    var hashCount = 0;
    var formattedNumberAry = format.split('');
    for (var i = 0, ln = format.length; i < ln; i++) {
        if (format[i] === patternChar) {
            formattedNumberAry[i] = numStr[hashCount] || getMaskAtIndex(mask, hashCount);
            hashCount += 1;
        }
    }
    return formattedNumberAry.join('');
}
function removeFormatting$1(value, changeMeta, props) {
    if ( changeMeta === void 0 ) changeMeta = getDefaultChangeMeta(value);

    var format = props.format;
    var patternChar = props.patternChar; if ( patternChar === void 0 ) patternChar = '#';
    var from = changeMeta.from;
    var to = changeMeta.to;
    var lastValue = changeMeta.lastValue; if ( lastValue === void 0 ) lastValue = '';
    var isNumericSlot = function (caretPos) { return format[caretPos] === patternChar; };
    var removeFormatChar = function (string, startIndex) {
        var str = '';
        for (var i = 0; i < string.length; i++) {
            if (isNumericSlot(startIndex + i) && charIsNumber(string[i])) {
                str += string[i];
            }
        }
        return str;
    };
    var extractNumbers = function (str) { return str.replace(/[^0-9]/g, ''); };
    // if format doesn't have any number, remove all the non numeric characters
    if (!format.match(/\d/)) {
        return extractNumbers(value);
    }
    /**
     * if user paste the whole formatted text in an empty input or doing select all and paste, check if matches to the pattern
     * and remove the format characters, if there is a mismatch on the pattern, do plane number extract
     */
    if ((lastValue === '' || from.end - from.start === lastValue.length) &&
        value.length === format.length) {
        var str = '';
        for (var i = 0; i < value.length; i++) {
            if (isNumericSlot(i)) {
                if (charIsNumber(value[i])) {
                    str += value[i];
                }
            }
            else if (value[i] !== format[i]) {
                // if there is a mismatch on the pattern, do plane number extract
                return extractNumbers(value);
            }
        }
        return str;
    }
    /**
     * For partial change,
     * where ever there is a change on the input, we can break the number in three parts
     * 1st: left part which is unchanged
     * 2nd: middle part which is changed
     * 3rd: right part which is unchanged
     *
     * The first and third section will be same as last value, only the middle part will change
     * We can consider on the change part all the new characters are non format characters.
     * And on the first and last section it can have partial format characters.
     *
     * We pick first and last section from the lastValue (as that has 1-1 mapping with format)
     * and middle one from the update value.
     */
    var firstSection = lastValue.substring(0, from.start);
    var middleSection = value.substring(to.start, to.end);
    var lastSection = lastValue.substring(from.end);
    return ("" + (removeFormatChar(firstSection, 0)) + (extractNumbers(middleSection)) + (removeFormatChar(lastSection, from.end)));
}
function getCaretBoundary$1(formattedValue, props) {
    var format = props.format;
    var mask = props.mask;
    var patternChar = props.patternChar; if ( patternChar === void 0 ) patternChar = '#';
    var boundaryAry = Array.from({ length: formattedValue.length + 1 }).map(function () { return true; });
    var hashCount = 0;
    var firstEmptySlot = -1;
    var maskAndIndexMap = {};
    format.split('').forEach(function (char, index) {
        var maskAtIndex = undefined;
        if (char === patternChar) {
            hashCount++;
            maskAtIndex = getMaskAtIndex(mask, hashCount - 1);
            if (firstEmptySlot === -1 && formattedValue[index] === maskAtIndex) {
                firstEmptySlot = index;
            }
        }
        maskAndIndexMap[index] = maskAtIndex;
    });
    var isPosAllowed = function (pos) {
        // the position is allowed if the position is not masked and valid number area
        return format[pos] === patternChar && formattedValue[pos] !== maskAndIndexMap[pos];
    };
    for (var i = 0, ln = boundaryAry.length; i < ln; i++) {
        // consider caret to be in boundary if it is before or after numeric value
        // Note: on pattern based format its denoted by patternCharacter
        // we should also allow user to put cursor on first empty slot
        boundaryAry[i] = i === firstEmptySlot || isPosAllowed(i) || isPosAllowed(i - 1);
    }
    // the first patternChar position is always allowed
    boundaryAry[format.indexOf(patternChar)] = true;
    return boundaryAry;
}
function validateProps(props) {
    var mask = props.mask;
    if (mask) {
        var maskAsStr = mask === 'string' ? mask : mask.toString();
        if (maskAsStr.match(/\d/g)) {
            throw new Error(("Mask " + mask + " should not contain numeric character;"));
        }
    }
}
function isNumericString$1(val, format) {
    //we can treat empty string as numeric string
    if (val === '')
        { return true; }
    return !(format === null || format === void 0 ? void 0 : format.match(/\d/)) && typeof val === 'string' && (!!val.match(/^\d+$/) || val === '');
}
function usePatternFormat(props) {
    var mask = props.mask;
    var allowEmptyFormatting = props.allowEmptyFormatting;
    var formatProp = props.format;
    var inputMode = props.inputMode; if ( inputMode === void 0 ) inputMode = 'numeric';
    var onKeyDown = props.onKeyDown; if ( onKeyDown === void 0 ) onKeyDown = noop;
    var patternChar = props.patternChar; if ( patternChar === void 0 ) patternChar = '#';
    var value = props.value;
    var defaultValue = props.defaultValue;
    var valueIsNumericString = props.valueIsNumericString;
    var restProps = __rest(props, ["mask", "allowEmptyFormatting", "format", "inputMode", "onKeyDown", "patternChar", "value", "defaultValue", "valueIsNumericString"]);
    // validate props
    validateProps(props);
    var _getCaretBoundary = function (formattedValue) {
        return getCaretBoundary$1(formattedValue, props);
    };
    var _onKeyDown = function (e) {
        var key = e.key;
        var el = e.target;
        var selectionStart = el.selectionStart;
        var selectionEnd = el.selectionEnd;
        var value = el.value;
        // if multiple characters are selected and user hits backspace, no need to handle anything manually
        if (selectionStart !== selectionEnd) {
            onKeyDown(e);
            return;
        }
        // bring the cursor to closest numeric section
        var caretPos = selectionStart;
        // if backspace is pressed after the format characters, bring it to numeric section
        // if delete is pressed before the format characters, bring it to numeric section
        if (key === 'Backspace' || key === 'Delete') {
            var direction = 'right';
            if (key === 'Backspace') {
                while (caretPos > 0 && formatProp[caretPos - 1] !== patternChar) {
                    caretPos--;
                }
                direction = 'left';
            }
            else {
                var formatLn = formatProp.length;
                while (caretPos < formatLn && formatProp[caretPos] !== patternChar) {
                    caretPos++;
                }
                direction = 'right';
            }
            caretPos = getCaretPosInBoundary(value, caretPos, _getCaretBoundary(value), direction);
        }
        else if (formatProp[caretPos] !== patternChar &&
            key !== 'ArrowLeft' &&
            key !== 'ArrowRight') {
            // if user is typing on format character position, bring user to next allowed caret position
            caretPos = getCaretPosInBoundary(value, caretPos + 1, _getCaretBoundary(value), 'right');
        }
        // if we changing caret position, set the caret position
        if (caretPos !== selectionStart) {
            setCaretPosition(el, caretPos);
        }
        onKeyDown(e);
    };
    // try to figure out isValueNumericString based on format prop and value
    var _value = isNil(value) ? defaultValue : value;
    var isValueNumericString = valueIsNumericString !== null && valueIsNumericString !== void 0 ? valueIsNumericString : isNumericString$1(_value, formatProp);
    var _props = Object.assign(Object.assign({}, props), { valueIsNumericString: isValueNumericString });
    return Object.assign(Object.assign({}, restProps), { value: value,
        defaultValue: defaultValue, valueIsNumericString: isValueNumericString, inputMode: inputMode, format: function (numStr) { return format$1(numStr, _props); }, removeFormatting: function (inputValue, changeMeta) { return removeFormatting$1(inputValue, changeMeta, _props); }, getCaretBoundary: _getCaretBoundary, onKeyDown: _onKeyDown });
}
function PatternFormat(props) {
    var patternFormatProps = usePatternFormat(props);
    return React.createElement(NumberFormatBase, Object.assign({}, patternFormatProps));
}




/***/ }),

/***/ 83:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({ value: true }));

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// A reserved attribute.
// It is handled by React separately and shouldn't be written to the DOM.
var RESERVED = 0; // A simple string attribute.
// Attributes that aren't in the filter are presumed to have this type.

var STRING = 1; // A string attribute that accepts booleans in React. In HTML, these are called
// "enumerated" attributes with "true" and "false" as possible values.
// When true, it should be set to a "true" string.
// When false, it should be set to a "false" string.

var BOOLEANISH_STRING = 2; // A real boolean attribute.
// When true, it should be present (set either to an empty string or its name).
// When false, it should be omitted.

var BOOLEAN = 3; // An attribute that can be used as a flag as well as with a value.
// When true, it should be present (set either to an empty string or its name).
// When false, it should be omitted.
// For any other value, should be present with that value.

var OVERLOADED_BOOLEAN = 4; // An attribute that must be numeric or parse as a numeric.
// When falsy, it should be removed.

var NUMERIC = 5; // An attribute that must be positive numeric or parse as a positive numeric.
// When falsy, it should be removed.

var POSITIVE_NUMERIC = 6;
function getPropertyInfo(name) {
  return properties.hasOwnProperty(name) ? properties[name] : null;
}

function PropertyInfoRecord(name, type, mustUseProperty, attributeName, attributeNamespace, sanitizeURL, removeEmptyString) {
  this.acceptsBooleans = type === BOOLEANISH_STRING || type === BOOLEAN || type === OVERLOADED_BOOLEAN;
  this.attributeName = attributeName;
  this.attributeNamespace = attributeNamespace;
  this.mustUseProperty = mustUseProperty;
  this.propertyName = name;
  this.type = type;
  this.sanitizeURL = sanitizeURL;
  this.removeEmptyString = removeEmptyString;
} // When adding attributes to this list, be sure to also add them to
// the `possibleStandardNames` module to ensure casing and incorrect
// name warnings.


var properties = {}; // These props are reserved by React. They shouldn't be written to the DOM.

var reservedProps = ['children', 'dangerouslySetInnerHTML', // TODO: This prevents the assignment of defaultValue to regular
// elements (not just inputs). Now that ReactDOMInput assigns to the
// defaultValue property -- do we need this?
'defaultValue', 'defaultChecked', 'innerHTML', 'suppressContentEditableWarning', 'suppressHydrationWarning', 'style'];
reservedProps.forEach(function (name) {
  properties[name] = new PropertyInfoRecord(name, RESERVED, false, // mustUseProperty
  name, // attributeName
  null, // attributeNamespace
  false, // sanitizeURL
  false);
}); // A few React string attributes have a different name.
// This is a mapping from React prop names to the attribute names.

[['acceptCharset', 'accept-charset'], ['className', 'class'], ['htmlFor', 'for'], ['httpEquiv', 'http-equiv']].forEach(function (_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      name = _ref2[0],
      attributeName = _ref2[1];

  properties[name] = new PropertyInfoRecord(name, STRING, false, // mustUseProperty
  attributeName, // attributeName
  null, // attributeNamespace
  false, // sanitizeURL
  false);
}); // These are "enumerated" HTML attributes that accept "true" and "false".
// In React, we let users pass `true` and `false` even though technically
// these aren't boolean attributes (they are coerced to strings).

['contentEditable', 'draggable', 'spellCheck', 'value'].forEach(function (name) {
  properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false, // mustUseProperty
  name.toLowerCase(), // attributeName
  null, // attributeNamespace
  false, // sanitizeURL
  false);
}); // These are "enumerated" SVG attributes that accept "true" and "false".
// In React, we let users pass `true` and `false` even though technically
// these aren't boolean attributes (they are coerced to strings).
// Since these are SVG attributes, their attribute names are case-sensitive.

['autoReverse', 'externalResourcesRequired', 'focusable', 'preserveAlpha'].forEach(function (name) {
  properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false, // mustUseProperty
  name, // attributeName
  null, // attributeNamespace
  false, // sanitizeURL
  false);
}); // These are HTML boolean attributes.

['allowFullScreen', 'async', // Note: there is a special case that prevents it from being written to the DOM
// on the client side because the browsers are inconsistent. Instead we call focus().
'autoFocus', 'autoPlay', 'controls', 'default', 'defer', 'disabled', 'disablePictureInPicture', 'disableRemotePlayback', 'formNoValidate', 'hidden', 'loop', 'noModule', 'noValidate', 'open', 'playsInline', 'readOnly', 'required', 'reversed', 'scoped', 'seamless', // Microdata
'itemScope'].forEach(function (name) {
  properties[name] = new PropertyInfoRecord(name, BOOLEAN, false, // mustUseProperty
  name.toLowerCase(), // attributeName
  null, // attributeNamespace
  false, // sanitizeURL
  false);
}); // These are the few React props that we set as DOM properties
// rather than attributes. These are all booleans.

['checked', // Note: `option.selected` is not updated if `select.multiple` is
// disabled with `removeAttribute`. We have special logic for handling this.
'multiple', 'muted', 'selected' // NOTE: if you add a camelCased prop to this list,
// you'll need to set attributeName to name.toLowerCase()
// instead in the assignment below.
].forEach(function (name) {
  properties[name] = new PropertyInfoRecord(name, BOOLEAN, true, // mustUseProperty
  name, // attributeName
  null, // attributeNamespace
  false, // sanitizeURL
  false);
}); // These are HTML attributes that are "overloaded booleans": they behave like
// booleans, but can also accept a string value.

['capture', 'download' // NOTE: if you add a camelCased prop to this list,
// you'll need to set attributeName to name.toLowerCase()
// instead in the assignment below.
].forEach(function (name) {
  properties[name] = new PropertyInfoRecord(name, OVERLOADED_BOOLEAN, false, // mustUseProperty
  name, // attributeName
  null, // attributeNamespace
  false, // sanitizeURL
  false);
}); // These are HTML attributes that must be positive numbers.

['cols', 'rows', 'size', 'span' // NOTE: if you add a camelCased prop to this list,
// you'll need to set attributeName to name.toLowerCase()
// instead in the assignment below.
].forEach(function (name) {
  properties[name] = new PropertyInfoRecord(name, POSITIVE_NUMERIC, false, // mustUseProperty
  name, // attributeName
  null, // attributeNamespace
  false, // sanitizeURL
  false);
}); // These are HTML attributes that must be numbers.

['rowSpan', 'start'].forEach(function (name) {
  properties[name] = new PropertyInfoRecord(name, NUMERIC, false, // mustUseProperty
  name.toLowerCase(), // attributeName
  null, // attributeNamespace
  false, // sanitizeURL
  false);
});
var CAMELIZE = /[\-\:]([a-z])/g;

var capitalize = function capitalize(token) {
  return token[1].toUpperCase();
}; // This is a list of all SVG attributes that need special casing, namespacing,
// or boolean value assignment. Regular attributes that just accept strings
// and have the same names are omitted, just like in the HTML attribute filter.
// Some of these attributes can be hard to find. This list was created by
// scraping the MDN documentation.


['accent-height', 'alignment-baseline', 'arabic-form', 'baseline-shift', 'cap-height', 'clip-path', 'clip-rule', 'color-interpolation', 'color-interpolation-filters', 'color-profile', 'color-rendering', 'dominant-baseline', 'enable-background', 'fill-opacity', 'fill-rule', 'flood-color', 'flood-opacity', 'font-family', 'font-size', 'font-size-adjust', 'font-stretch', 'font-style', 'font-variant', 'font-weight', 'glyph-name', 'glyph-orientation-horizontal', 'glyph-orientation-vertical', 'horiz-adv-x', 'horiz-origin-x', 'image-rendering', 'letter-spacing', 'lighting-color', 'marker-end', 'marker-mid', 'marker-start', 'overline-position', 'overline-thickness', 'paint-order', 'panose-1', 'pointer-events', 'rendering-intent', 'shape-rendering', 'stop-color', 'stop-opacity', 'strikethrough-position', 'strikethrough-thickness', 'stroke-dasharray', 'stroke-dashoffset', 'stroke-linecap', 'stroke-linejoin', 'stroke-miterlimit', 'stroke-opacity', 'stroke-width', 'text-anchor', 'text-decoration', 'text-rendering', 'underline-position', 'underline-thickness', 'unicode-bidi', 'unicode-range', 'units-per-em', 'v-alphabetic', 'v-hanging', 'v-ideographic', 'v-mathematical', 'vector-effect', 'vert-adv-y', 'vert-origin-x', 'vert-origin-y', 'word-spacing', 'writing-mode', 'xmlns:xlink', 'x-height' // NOTE: if you add a camelCased prop to this list,
// you'll need to set attributeName to name.toLowerCase()
// instead in the assignment below.
].forEach(function (attributeName) {
  var name = attributeName.replace(CAMELIZE, capitalize);
  properties[name] = new PropertyInfoRecord(name, STRING, false, // mustUseProperty
  attributeName, null, // attributeNamespace
  false, // sanitizeURL
  false);
}); // String SVG attributes with the xlink namespace.

['xlink:actuate', 'xlink:arcrole', 'xlink:role', 'xlink:show', 'xlink:title', 'xlink:type' // NOTE: if you add a camelCased prop to this list,
// you'll need to set attributeName to name.toLowerCase()
// instead in the assignment below.
].forEach(function (attributeName) {
  var name = attributeName.replace(CAMELIZE, capitalize);
  properties[name] = new PropertyInfoRecord(name, STRING, false, // mustUseProperty
  attributeName, 'http://www.w3.org/1999/xlink', false, // sanitizeURL
  false);
}); // String SVG attributes with the xml namespace.

['xml:base', 'xml:lang', 'xml:space' // NOTE: if you add a camelCased prop to this list,
// you'll need to set attributeName to name.toLowerCase()
// instead in the assignment below.
].forEach(function (attributeName) {
  var name = attributeName.replace(CAMELIZE, capitalize);
  properties[name] = new PropertyInfoRecord(name, STRING, false, // mustUseProperty
  attributeName, 'http://www.w3.org/XML/1998/namespace', false, // sanitizeURL
  false);
}); // These attribute exists both in HTML and SVG.
// The attribute name is case-sensitive in SVG so we can't just use
// the React name like we do for attributes that exist only in HTML.

['tabIndex', 'crossOrigin'].forEach(function (attributeName) {
  properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false, // mustUseProperty
  attributeName.toLowerCase(), // attributeName
  null, // attributeNamespace
  false, // sanitizeURL
  false);
}); // These attributes accept URLs. These must not allow javascript: URLS.
// These will also need to accept Trusted Types object in the future.

var xlinkHref = 'xlinkHref';
properties[xlinkHref] = new PropertyInfoRecord('xlinkHref', STRING, false, // mustUseProperty
'xlink:href', 'http://www.w3.org/1999/xlink', true, // sanitizeURL
false);
['src', 'href', 'action', 'formAction'].forEach(function (attributeName) {
  properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false, // mustUseProperty
  attributeName.toLowerCase(), // attributeName
  null, // attributeNamespace
  true, // sanitizeURL
  true);
});

var _require = __webpack_require__(78229),
    CAMELCASE = _require.CAMELCASE,
    SAME = _require.SAME,
    possibleStandardNamesOptimized = _require.possibleStandardNames;

var ATTRIBUTE_NAME_START_CHAR = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD";
var ATTRIBUTE_NAME_CHAR = ATTRIBUTE_NAME_START_CHAR + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040";
/**
 * Checks whether a property name is a custom attribute.
 *
 * @see {@link https://github.com/facebook/react/blob/15-stable/src/renderers/dom/shared/HTMLDOMPropertyConfig.js#L23-L25}
 *
 * @param {string}
 * @return {boolean}
 */

var isCustomAttribute = RegExp.prototype.test.bind( // eslint-disable-next-line no-misleading-character-class
new RegExp('^(data|aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$'));
var possibleStandardNames = Object.keys(possibleStandardNamesOptimized).reduce(function (accumulator, standardName) {
  var propName = possibleStandardNamesOptimized[standardName];

  if (propName === SAME) {
    accumulator[standardName] = standardName;
  } else if (propName === CAMELCASE) {
    accumulator[standardName.toLowerCase()] = standardName;
  } else {
    accumulator[standardName] = propName;
  }

  return accumulator;
}, {});

exports.BOOLEAN = BOOLEAN;
exports.BOOLEANISH_STRING = BOOLEANISH_STRING;
exports.NUMERIC = NUMERIC;
exports.OVERLOADED_BOOLEAN = OVERLOADED_BOOLEAN;
exports.POSITIVE_NUMERIC = POSITIVE_NUMERIC;
exports.RESERVED = RESERVED;
exports.STRING = STRING;
exports.getPropertyInfo = getPropertyInfo;
exports.isCustomAttribute = isCustomAttribute;
exports.possibleStandardNames = possibleStandardNames;


/***/ }),

/***/ 78229:
/***/ (function(__unused_webpack_module, exports) {

// An attribute in which the DOM/SVG standard name is the same as the React prop name (e.g., 'accept').
var SAME = 0;
exports.SAME = SAME;

// An attribute in which the React prop name is the camelcased version of the DOM/SVG standard name (e.g., 'acceptCharset').
var CAMELCASE = 1;
exports.CAMELCASE = CAMELCASE;

exports.possibleStandardNames = {
  accept: 0,
  acceptCharset: 1,
  'accept-charset': 'acceptCharset',
  accessKey: 1,
  action: 0,
  allowFullScreen: 1,
  alt: 0,
  as: 0,
  async: 0,
  autoCapitalize: 1,
  autoComplete: 1,
  autoCorrect: 1,
  autoFocus: 1,
  autoPlay: 1,
  autoSave: 1,
  capture: 0,
  cellPadding: 1,
  cellSpacing: 1,
  challenge: 0,
  charSet: 1,
  checked: 0,
  children: 0,
  cite: 0,
  class: 'className',
  classID: 1,
  className: 1,
  cols: 0,
  colSpan: 1,
  content: 0,
  contentEditable: 1,
  contextMenu: 1,
  controls: 0,
  controlsList: 1,
  coords: 0,
  crossOrigin: 1,
  dangerouslySetInnerHTML: 1,
  data: 0,
  dateTime: 1,
  default: 0,
  defaultChecked: 1,
  defaultValue: 1,
  defer: 0,
  dir: 0,
  disabled: 0,
  disablePictureInPicture: 1,
  disableRemotePlayback: 1,
  download: 0,
  draggable: 0,
  encType: 1,
  enterKeyHint: 1,
  for: 'htmlFor',
  form: 0,
  formMethod: 1,
  formAction: 1,
  formEncType: 1,
  formNoValidate: 1,
  formTarget: 1,
  frameBorder: 1,
  headers: 0,
  height: 0,
  hidden: 0,
  high: 0,
  href: 0,
  hrefLang: 1,
  htmlFor: 1,
  httpEquiv: 1,
  'http-equiv': 'httpEquiv',
  icon: 0,
  id: 0,
  innerHTML: 1,
  inputMode: 1,
  integrity: 0,
  is: 0,
  itemID: 1,
  itemProp: 1,
  itemRef: 1,
  itemScope: 1,
  itemType: 1,
  keyParams: 1,
  keyType: 1,
  kind: 0,
  label: 0,
  lang: 0,
  list: 0,
  loop: 0,
  low: 0,
  manifest: 0,
  marginWidth: 1,
  marginHeight: 1,
  max: 0,
  maxLength: 1,
  media: 0,
  mediaGroup: 1,
  method: 0,
  min: 0,
  minLength: 1,
  multiple: 0,
  muted: 0,
  name: 0,
  noModule: 1,
  nonce: 0,
  noValidate: 1,
  open: 0,
  optimum: 0,
  pattern: 0,
  placeholder: 0,
  playsInline: 1,
  poster: 0,
  preload: 0,
  profile: 0,
  radioGroup: 1,
  readOnly: 1,
  referrerPolicy: 1,
  rel: 0,
  required: 0,
  reversed: 0,
  role: 0,
  rows: 0,
  rowSpan: 1,
  sandbox: 0,
  scope: 0,
  scoped: 0,
  scrolling: 0,
  seamless: 0,
  selected: 0,
  shape: 0,
  size: 0,
  sizes: 0,
  span: 0,
  spellCheck: 1,
  src: 0,
  srcDoc: 1,
  srcLang: 1,
  srcSet: 1,
  start: 0,
  step: 0,
  style: 0,
  summary: 0,
  tabIndex: 1,
  target: 0,
  title: 0,
  type: 0,
  useMap: 1,
  value: 0,
  width: 0,
  wmode: 0,
  wrap: 0,
  about: 0,
  accentHeight: 1,
  'accent-height': 'accentHeight',
  accumulate: 0,
  additive: 0,
  alignmentBaseline: 1,
  'alignment-baseline': 'alignmentBaseline',
  allowReorder: 1,
  alphabetic: 0,
  amplitude: 0,
  arabicForm: 1,
  'arabic-form': 'arabicForm',
  ascent: 0,
  attributeName: 1,
  attributeType: 1,
  autoReverse: 1,
  azimuth: 0,
  baseFrequency: 1,
  baselineShift: 1,
  'baseline-shift': 'baselineShift',
  baseProfile: 1,
  bbox: 0,
  begin: 0,
  bias: 0,
  by: 0,
  calcMode: 1,
  capHeight: 1,
  'cap-height': 'capHeight',
  clip: 0,
  clipPath: 1,
  'clip-path': 'clipPath',
  clipPathUnits: 1,
  clipRule: 1,
  'clip-rule': 'clipRule',
  color: 0,
  colorInterpolation: 1,
  'color-interpolation': 'colorInterpolation',
  colorInterpolationFilters: 1,
  'color-interpolation-filters': 'colorInterpolationFilters',
  colorProfile: 1,
  'color-profile': 'colorProfile',
  colorRendering: 1,
  'color-rendering': 'colorRendering',
  contentScriptType: 1,
  contentStyleType: 1,
  cursor: 0,
  cx: 0,
  cy: 0,
  d: 0,
  datatype: 0,
  decelerate: 0,
  descent: 0,
  diffuseConstant: 1,
  direction: 0,
  display: 0,
  divisor: 0,
  dominantBaseline: 1,
  'dominant-baseline': 'dominantBaseline',
  dur: 0,
  dx: 0,
  dy: 0,
  edgeMode: 1,
  elevation: 0,
  enableBackground: 1,
  'enable-background': 'enableBackground',
  end: 0,
  exponent: 0,
  externalResourcesRequired: 1,
  fill: 0,
  fillOpacity: 1,
  'fill-opacity': 'fillOpacity',
  fillRule: 1,
  'fill-rule': 'fillRule',
  filter: 0,
  filterRes: 1,
  filterUnits: 1,
  floodOpacity: 1,
  'flood-opacity': 'floodOpacity',
  floodColor: 1,
  'flood-color': 'floodColor',
  focusable: 0,
  fontFamily: 1,
  'font-family': 'fontFamily',
  fontSize: 1,
  'font-size': 'fontSize',
  fontSizeAdjust: 1,
  'font-size-adjust': 'fontSizeAdjust',
  fontStretch: 1,
  'font-stretch': 'fontStretch',
  fontStyle: 1,
  'font-style': 'fontStyle',
  fontVariant: 1,
  'font-variant': 'fontVariant',
  fontWeight: 1,
  'font-weight': 'fontWeight',
  format: 0,
  from: 0,
  fx: 0,
  fy: 0,
  g1: 0,
  g2: 0,
  glyphName: 1,
  'glyph-name': 'glyphName',
  glyphOrientationHorizontal: 1,
  'glyph-orientation-horizontal': 'glyphOrientationHorizontal',
  glyphOrientationVertical: 1,
  'glyph-orientation-vertical': 'glyphOrientationVertical',
  glyphRef: 1,
  gradientTransform: 1,
  gradientUnits: 1,
  hanging: 0,
  horizAdvX: 1,
  'horiz-adv-x': 'horizAdvX',
  horizOriginX: 1,
  'horiz-origin-x': 'horizOriginX',
  ideographic: 0,
  imageRendering: 1,
  'image-rendering': 'imageRendering',
  in2: 0,
  in: 0,
  inlist: 0,
  intercept: 0,
  k1: 0,
  k2: 0,
  k3: 0,
  k4: 0,
  k: 0,
  kernelMatrix: 1,
  kernelUnitLength: 1,
  kerning: 0,
  keyPoints: 1,
  keySplines: 1,
  keyTimes: 1,
  lengthAdjust: 1,
  letterSpacing: 1,
  'letter-spacing': 'letterSpacing',
  lightingColor: 1,
  'lighting-color': 'lightingColor',
  limitingConeAngle: 1,
  local: 0,
  markerEnd: 1,
  'marker-end': 'markerEnd',
  markerHeight: 1,
  markerMid: 1,
  'marker-mid': 'markerMid',
  markerStart: 1,
  'marker-start': 'markerStart',
  markerUnits: 1,
  markerWidth: 1,
  mask: 0,
  maskContentUnits: 1,
  maskUnits: 1,
  mathematical: 0,
  mode: 0,
  numOctaves: 1,
  offset: 0,
  opacity: 0,
  operator: 0,
  order: 0,
  orient: 0,
  orientation: 0,
  origin: 0,
  overflow: 0,
  overlinePosition: 1,
  'overline-position': 'overlinePosition',
  overlineThickness: 1,
  'overline-thickness': 'overlineThickness',
  paintOrder: 1,
  'paint-order': 'paintOrder',
  panose1: 0,
  'panose-1': 'panose1',
  pathLength: 1,
  patternContentUnits: 1,
  patternTransform: 1,
  patternUnits: 1,
  pointerEvents: 1,
  'pointer-events': 'pointerEvents',
  points: 0,
  pointsAtX: 1,
  pointsAtY: 1,
  pointsAtZ: 1,
  prefix: 0,
  preserveAlpha: 1,
  preserveAspectRatio: 1,
  primitiveUnits: 1,
  property: 0,
  r: 0,
  radius: 0,
  refX: 1,
  refY: 1,
  renderingIntent: 1,
  'rendering-intent': 'renderingIntent',
  repeatCount: 1,
  repeatDur: 1,
  requiredExtensions: 1,
  requiredFeatures: 1,
  resource: 0,
  restart: 0,
  result: 0,
  results: 0,
  rotate: 0,
  rx: 0,
  ry: 0,
  scale: 0,
  security: 0,
  seed: 0,
  shapeRendering: 1,
  'shape-rendering': 'shapeRendering',
  slope: 0,
  spacing: 0,
  specularConstant: 1,
  specularExponent: 1,
  speed: 0,
  spreadMethod: 1,
  startOffset: 1,
  stdDeviation: 1,
  stemh: 0,
  stemv: 0,
  stitchTiles: 1,
  stopColor: 1,
  'stop-color': 'stopColor',
  stopOpacity: 1,
  'stop-opacity': 'stopOpacity',
  strikethroughPosition: 1,
  'strikethrough-position': 'strikethroughPosition',
  strikethroughThickness: 1,
  'strikethrough-thickness': 'strikethroughThickness',
  string: 0,
  stroke: 0,
  strokeDasharray: 1,
  'stroke-dasharray': 'strokeDasharray',
  strokeDashoffset: 1,
  'stroke-dashoffset': 'strokeDashoffset',
  strokeLinecap: 1,
  'stroke-linecap': 'strokeLinecap',
  strokeLinejoin: 1,
  'stroke-linejoin': 'strokeLinejoin',
  strokeMiterlimit: 1,
  'stroke-miterlimit': 'strokeMiterlimit',
  strokeWidth: 1,
  'stroke-width': 'strokeWidth',
  strokeOpacity: 1,
  'stroke-opacity': 'strokeOpacity',
  suppressContentEditableWarning: 1,
  suppressHydrationWarning: 1,
  surfaceScale: 1,
  systemLanguage: 1,
  tableValues: 1,
  targetX: 1,
  targetY: 1,
  textAnchor: 1,
  'text-anchor': 'textAnchor',
  textDecoration: 1,
  'text-decoration': 'textDecoration',
  textLength: 1,
  textRendering: 1,
  'text-rendering': 'textRendering',
  to: 0,
  transform: 0,
  typeof: 0,
  u1: 0,
  u2: 0,
  underlinePosition: 1,
  'underline-position': 'underlinePosition',
  underlineThickness: 1,
  'underline-thickness': 'underlineThickness',
  unicode: 0,
  unicodeBidi: 1,
  'unicode-bidi': 'unicodeBidi',
  unicodeRange: 1,
  'unicode-range': 'unicodeRange',
  unitsPerEm: 1,
  'units-per-em': 'unitsPerEm',
  unselectable: 0,
  vAlphabetic: 1,
  'v-alphabetic': 'vAlphabetic',
  values: 0,
  vectorEffect: 1,
  'vector-effect': 'vectorEffect',
  version: 0,
  vertAdvY: 1,
  'vert-adv-y': 'vertAdvY',
  vertOriginX: 1,
  'vert-origin-x': 'vertOriginX',
  vertOriginY: 1,
  'vert-origin-y': 'vertOriginY',
  vHanging: 1,
  'v-hanging': 'vHanging',
  vIdeographic: 1,
  'v-ideographic': 'vIdeographic',
  viewBox: 1,
  viewTarget: 1,
  visibility: 0,
  vMathematical: 1,
  'v-mathematical': 'vMathematical',
  vocab: 0,
  widths: 0,
  wordSpacing: 1,
  'word-spacing': 'wordSpacing',
  writingMode: 1,
  'writing-mode': 'writingMode',
  x1: 0,
  x2: 0,
  x: 0,
  xChannelSelector: 1,
  xHeight: 1,
  'x-height': 'xHeight',
  xlinkActuate: 1,
  'xlink:actuate': 'xlinkActuate',
  xlinkArcrole: 1,
  'xlink:arcrole': 'xlinkArcrole',
  xlinkHref: 1,
  'xlink:href': 'xlinkHref',
  xlinkRole: 1,
  'xlink:role': 'xlinkRole',
  xlinkShow: 1,
  'xlink:show': 'xlinkShow',
  xlinkTitle: 1,
  'xlink:title': 'xlinkTitle',
  xlinkType: 1,
  'xlink:type': 'xlinkType',
  xmlBase: 1,
  'xml:base': 'xmlBase',
  xmlLang: 1,
  'xml:lang': 'xmlLang',
  xmlns: 0,
  'xml:space': 'xmlSpace',
  xmlnsXlink: 1,
  'xmlns:xlink': 'xmlnsXlink',
  xmlSpace: 1,
  y1: 0,
  y2: 0,
  y: 0,
  yChannelSelector: 1,
  z: 0,
  zoomAndPan: 1
};


/***/ }),

/***/ 88632:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(45697);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(67294);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var propTypes = {
  bgColor: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]).isRequired,
  bgD: _propTypes2.default.string.isRequired,
  fgColor: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]).isRequired,
  fgD: _propTypes2.default.string.isRequired,
  size: _propTypes2.default.number.isRequired,
  title: _propTypes2.default.string,
  viewBoxSize: _propTypes2.default.number.isRequired,
  xmlns: _propTypes2.default.string
};

var QRCodeSvg = (0, _react.forwardRef)(function (_ref, ref) {
  var bgColor = _ref.bgColor,
      bgD = _ref.bgD,
      fgD = _ref.fgD,
      fgColor = _ref.fgColor,
      size = _ref.size,
      title = _ref.title,
      viewBoxSize = _ref.viewBoxSize,
      _ref$xmlns = _ref.xmlns,
      xmlns = _ref$xmlns === undefined ? "http://www.w3.org/2000/svg" : _ref$xmlns,
      props = _objectWithoutProperties(_ref, ["bgColor", "bgD", "fgD", "fgColor", "size", "title", "viewBoxSize", "xmlns"]);

  return _react2.default.createElement(
    "svg",
    _extends({}, props, { height: size, ref: ref, viewBox: "0 0 " + viewBoxSize + " " + viewBoxSize, width: size, xmlns: xmlns }),
    title ? _react2.default.createElement(
      "title",
      null,
      title
    ) : null,
    _react2.default.createElement("path", { d: bgD, fill: bgColor }),
    _react2.default.createElement("path", { d: fgD, fill: fgColor })
  );
});

QRCodeSvg.displayName = "QRCodeSvg";
QRCodeSvg.propTypes = propTypes;

exports["default"] = QRCodeSvg;

/***/ }),

/***/ 1653:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});
exports.s_ = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(45697);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ErrorCorrectLevel = __webpack_require__(49381);

var _ErrorCorrectLevel2 = _interopRequireDefault(_ErrorCorrectLevel);

var _QRCode = __webpack_require__(14450);

var _QRCode2 = _interopRequireDefault(_QRCode);

var _react = __webpack_require__(67294);

var _react2 = _interopRequireDefault(_react);

var _QRCodeSvg = __webpack_require__(88632);

var _QRCodeSvg2 = _interopRequireDefault(_QRCodeSvg);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
// A `qr.js` doesn't handle error level of zero (M) so we need to do it right, thus the deep require.


var propTypes = {
  bgColor: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]),
  fgColor: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]),
  level: _propTypes2.default.string,
  size: _propTypes2.default.number,
  value: _propTypes2.default.string.isRequired
};

var QRCode = (0, _react.forwardRef)(function (_ref, ref) {
  var _ref$bgColor = _ref.bgColor,
      bgColor = _ref$bgColor === undefined ? "#FFFFFF" : _ref$bgColor,
      _ref$fgColor = _ref.fgColor,
      fgColor = _ref$fgColor === undefined ? "#000000" : _ref$fgColor,
      _ref$level = _ref.level,
      level = _ref$level === undefined ? "L" : _ref$level,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? 256 : _ref$size,
      value = _ref.value,
      props = _objectWithoutProperties(_ref, ["bgColor", "fgColor", "level", "size", "value"]);

  // Use type === -1 to automatically pick the best type.
  var qrcode = new _QRCode2.default(-1, _ErrorCorrectLevel2.default[level]);
  qrcode.addData(value);
  qrcode.make();
  var cells = qrcode.modules;
  return _react2.default.createElement(_QRCodeSvg2.default, _extends({}, props, {
    bgColor: bgColor,
    bgD: cells.map(function (row, rowIndex) {
      return row.map(function (cell, cellIndex) {
        return !cell ? "M " + cellIndex + " " + rowIndex + " l 1 0 0 1 -1 0 Z" : "";
      }).join(" ");
    }).join(" "),
    fgColor: fgColor,
    fgD: cells.map(function (row, rowIndex) {
      return row.map(function (cell, cellIndex) {
        return cell ? "M " + cellIndex + " " + rowIndex + " l 1 0 0 1 -1 0 Z" : "";
      }).join(" ");
    }).join(" "),
    ref: ref,
    size: size,
    viewBoxSize: cells.length
  }));
});

exports.s_ = QRCode;
QRCode.displayName = "QRCode";
QRCode.propTypes = propTypes;

__webpack_unused_export__ = QRCode;

/***/ }),

/***/ 9473:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "zt": function() { return /* reexport */ components_Provider; },
  "I0": function() { return /* reexport */ useDispatch; },
  "v9": function() { return /* reexport */ useSelector; },
  "oR": function() { return /* reexport */ useStore_useStore; }
});

// UNUSED EXPORTS: ReactReduxContext, batch, connect, createDispatchHook, createSelectorHook, createStoreHook, shallowEqual

// EXTERNAL MODULE: ./node_modules/react-redux/node_modules/use-sync-external-store/shim/index.js
var shim = __webpack_require__(17540);
// EXTERNAL MODULE: ./node_modules/react-redux/node_modules/use-sync-external-store/shim/with-selector.js
var with_selector = __webpack_require__(36786);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
;// CONCATENATED MODULE: ./node_modules/react-redux/es/utils/reactBatchedUpdates.js

;// CONCATENATED MODULE: ./node_modules/react-redux/es/utils/batch.js
// Default to a dummy "batch" implementation that just runs the callback
function defaultNoopBatch(callback) {
  callback();
}

let batch = defaultNoopBatch; // Allow injecting another batching function later

const setBatch = newBatch => batch = newBatch; // Supply a getter just to skip dealing with ESM bindings

const getBatch = () => batch;
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/react-redux/es/components/Context.js

const ContextKey = Symbol.for(`react-redux-context`);
const gT = typeof globalThis !== "undefined" ? globalThis :
/* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */
{};

function getContext() {
  var _gT$ContextKey;

  if (!react.createContext) return {};
  const contextMap = (_gT$ContextKey = gT[ContextKey]) != null ? _gT$ContextKey : gT[ContextKey] = new Map();
  let realContext = contextMap.get(react.createContext);

  if (!realContext) {
    realContext = react.createContext(null);

    if (false) {}

    contextMap.set(react.createContext, realContext);
  }

  return realContext;
}

const Context_ReactReduxContext = /*#__PURE__*/getContext();
/* harmony default export */ var Context = ((/* unused pure expression or super */ null && (Context_ReactReduxContext)));
;// CONCATENATED MODULE: ./node_modules/react-redux/es/hooks/useReduxContext.js



/**
 * Hook factory, which creates a `useReduxContext` hook bound to a given context. This is a low-level
 * hook that you should usually not need to call directly.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useReduxContext` hook bound to the specified context.
 */
function createReduxContextHook(context = Context_ReactReduxContext) {
  return function useReduxContext() {
    const contextValue = (0,react.useContext)(context);

    if (false) {}

    return contextValue;
  };
}
/**
 * A hook to access the value of the `ReactReduxContext`. This is a low-level
 * hook that you should usually not need to call directly.
 *
 * @returns {any} the value of the `ReactReduxContext`
 *
 * @example
 *
 * import React from 'react'
 * import { useReduxContext } from 'react-redux'
 *
 * export const CounterComponent = () => {
 *   const { store } = useReduxContext()
 *   return <div>{store.getState()}</div>
 * }
 */

const useReduxContext_useReduxContext = /*#__PURE__*/createReduxContextHook();
;// CONCATENATED MODULE: ./node_modules/react-redux/es/utils/useSyncExternalStore.js
const useSyncExternalStore_notInitialized = () => {
  throw new Error('uSES not initialized!');
};
;// CONCATENATED MODULE: ./node_modules/react-redux/es/hooks/useSelector.js




let useSyncExternalStoreWithSelector = useSyncExternalStore_notInitialized;
const initializeUseSelector = fn => {
  useSyncExternalStoreWithSelector = fn;
};

const refEquality = (a, b) => a === b;
/**
 * Hook factory, which creates a `useSelector` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useSelector` hook bound to the specified context.
 */


function createSelectorHook(context = Context_ReactReduxContext) {
  const useReduxContext = context === Context_ReactReduxContext ? useReduxContext_useReduxContext : createReduxContextHook(context);
  return function useSelector(selector, equalityFnOrOptions = {}) {
    const {
      equalityFn = refEquality,
      stabilityCheck = undefined,
      noopCheck = undefined
    } = typeof equalityFnOrOptions === 'function' ? {
      equalityFn: equalityFnOrOptions
    } : equalityFnOrOptions;

    if (false) {}

    const {
      store,
      subscription,
      getServerState,
      stabilityCheck: globalStabilityCheck,
      noopCheck: globalNoopCheck
    } = useReduxContext();
    const firstRun = (0,react.useRef)(true);
    const wrappedSelector = (0,react.useCallback)({
      [selector.name](state) {
        const selected = selector(state);

        if (false) {}

        return selected;
      }

    }[selector.name], [selector, globalStabilityCheck, stabilityCheck]);
    const selectedState = useSyncExternalStoreWithSelector(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
    (0,react.useDebugValue)(selectedState);
    return selectedState;
  };
}
/**
 * A hook to access the redux store's state. This hook takes a selector function
 * as an argument. The selector is called with the store state.
 *
 * This hook takes an optional equality comparison function as the second parameter
 * that allows you to customize the way the selected state is compared to determine
 * whether the component needs to be re-rendered.
 *
 * @param {Function} selector the selector function
 * @param {Function=} equalityFn the function that will be used to determine equality
 *
 * @returns {any} the selected state
 *
 * @example
 *
 * import React from 'react'
 * import { useSelector } from 'react-redux'
 *
 * export const CounterComponent = () => {
 *   const counter = useSelector(state => state.counter)
 *   return <div>{counter}</div>
 * }
 */

const useSelector = /*#__PURE__*/createSelectorHook();
// EXTERNAL MODULE: ./node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(8679);
// EXTERNAL MODULE: ./node_modules/react-is/index.js
var react_is = __webpack_require__(59864);
;// CONCATENATED MODULE: ./node_modules/react-redux/es/utils/Subscription.js
 // encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants

function createListenerCollection() {
  const batch = getBatch();
  let first = null;
  let last = null;
  return {
    clear() {
      first = null;
      last = null;
    },

    notify() {
      batch(() => {
        let listener = first;

        while (listener) {
          listener.callback();
          listener = listener.next;
        }
      });
    },

    get() {
      let listeners = [];
      let listener = first;

      while (listener) {
        listeners.push(listener);
        listener = listener.next;
      }

      return listeners;
    },

    subscribe(callback) {
      let isSubscribed = true;
      let listener = last = {
        callback,
        next: null,
        prev: last
      };

      if (listener.prev) {
        listener.prev.next = listener;
      } else {
        first = listener;
      }

      return function unsubscribe() {
        if (!isSubscribed || first === null) return;
        isSubscribed = false;

        if (listener.next) {
          listener.next.prev = listener.prev;
        } else {
          last = listener.prev;
        }

        if (listener.prev) {
          listener.prev.next = listener.next;
        } else {
          first = listener.next;
        }
      };
    }

  };
}

const nullListeners = {
  notify() {},

  get: () => []
};
function Subscription_createSubscription(store, parentSub) {
  let unsubscribe;
  let listeners = nullListeners; // Reasons to keep the subscription active

  let subscriptionsAmount = 0; // Is this specific subscription subscribed (or only nested ones?)

  let selfSubscribed = false;

  function addNestedSub(listener) {
    trySubscribe();
    const cleanupListener = listeners.subscribe(listener); // cleanup nested sub

    let removed = false;
    return () => {
      if (!removed) {
        removed = true;
        cleanupListener();
        tryUnsubscribe();
      }
    };
  }

  function notifyNestedSubs() {
    listeners.notify();
  }

  function handleChangeWrapper() {
    if (subscription.onStateChange) {
      subscription.onStateChange();
    }
  }

  function isSubscribed() {
    return selfSubscribed;
  }

  function trySubscribe() {
    subscriptionsAmount++;

    if (!unsubscribe) {
      unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
      listeners = createListenerCollection();
    }
  }

  function tryUnsubscribe() {
    subscriptionsAmount--;

    if (unsubscribe && subscriptionsAmount === 0) {
      unsubscribe();
      unsubscribe = undefined;
      listeners.clear();
      listeners = nullListeners;
    }
  }

  function trySubscribeSelf() {
    if (!selfSubscribed) {
      selfSubscribed = true;
      trySubscribe();
    }
  }

  function tryUnsubscribeSelf() {
    if (selfSubscribed) {
      selfSubscribed = false;
      tryUnsubscribe();
    }
  }

  const subscription = {
    addNestedSub,
    notifyNestedSubs,
    handleChangeWrapper,
    isSubscribed,
    trySubscribe: trySubscribeSelf,
    tryUnsubscribe: tryUnsubscribeSelf,
    getListeners: () => listeners
  };
  return subscription;
}
;// CONCATENATED MODULE: ./node_modules/react-redux/es/utils/useIsomorphicLayoutEffect.js
 // React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser. We need useLayoutEffect to ensure the store
// subscription callback always has the selector from the latest render commit
// available, otherwise a store update may happen between render and the effect,
// which may cause missed updates; we also must ensure the store subscription
// is created synchronously, otherwise a store update may occur before the
// subscription is created and an inconsistent state may be observed
// Matches logic in React's `shared/ExecutionEnvironment` file

const canUseDOM = !!(typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined');
const useIsomorphicLayoutEffect_useIsomorphicLayoutEffect = canUseDOM ? react.useLayoutEffect : react.useEffect;
;// CONCATENATED MODULE: ./node_modules/react-redux/es/components/connect.js


const _excluded = (/* unused pure expression or super */ null && (["reactReduxForwardedRef"]));

/* eslint-disable valid-jsdoc, @typescript-eslint/no-unused-vars */













let useSyncExternalStore = (/* unused pure expression or super */ null && (notInitialized));
const initializeConnect = fn => {
  useSyncExternalStore = fn;
}; // Define some constant arrays just to avoid re-creating these

const EMPTY_ARRAY = (/* unused pure expression or super */ null && ([null, 0]));
const NO_SUBSCRIPTION_ARRAY = (/* unused pure expression or super */ null && ([null, null])); // Attempts to stringify whatever not-really-a-component value we were given
// for logging in an error message

const stringifyComponent = Comp => {
  try {
    return JSON.stringify(Comp);
  } catch (err) {
    return String(Comp);
  }
};

// This is "just" a `useLayoutEffect`, but with two modifications:
// - we need to fall back to `useEffect` in SSR to avoid annoying warnings
// - we extract this to a separate function to avoid closing over values
//   and causing memory leaks
function useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
  useIsomorphicLayoutEffect(() => effectFunc(...effectArgs), dependencies);
} // Effect callback, extracted: assign the latest props values to refs for later usage


function captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, // actualChildProps: unknown,
childPropsFromStoreUpdate, notifyNestedSubs) {
  // We want to capture the wrapper props and child props we used for later comparisons
  lastWrapperProps.current = wrapperProps;
  renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update

  if (childPropsFromStoreUpdate.current) {
    childPropsFromStoreUpdate.current = null;
    notifyNestedSubs();
  }
} // Effect callback, extracted: subscribe to the Redux store or nearest connected ancestor,
// check for updates after dispatched actions, and trigger re-renders.


function subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, // forceComponentUpdateDispatch: React.Dispatch<any>,
additionalSubscribeListener) {
  // If we're not subscribed to the store, nothing to do here
  if (!shouldHandleStateChanges) return () => {}; // Capture values for checking if and when this component unmounts

  let didUnsubscribe = false;
  let lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component

  const checkForUpdates = () => {
    if (didUnsubscribe || !isMounted.current) {
      // Don't run stale listeners.
      // Redux doesn't guarantee unsubscriptions happen until next dispatch.
      return;
    } // TODO We're currently calling getState ourselves here, rather than letting `uSES` do it


    const latestStoreState = store.getState();
    let newChildProps, error;

    try {
      // Actually run the selector with the most recent store state and wrapper props
      // to determine what the child props should be
      newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
    } catch (e) {
      error = e;
      lastThrownError = e;
    }

    if (!error) {
      lastThrownError = null;
    } // If the child props haven't changed, nothing to do here - cascade the subscription update


    if (newChildProps === lastChildProps.current) {
      if (!renderIsScheduled.current) {
        notifyNestedSubs();
      }
    } else {
      // Save references to the new child props.  Note that we track the "child props from store update"
      // as a ref instead of a useState/useReducer because we need a way to determine if that value has
      // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
      // forcing another re-render, which we don't want.
      lastChildProps.current = newChildProps;
      childPropsFromStoreUpdate.current = newChildProps;
      renderIsScheduled.current = true; // TODO This is hacky and not how `uSES` is meant to be used
      // Trigger the React `useSyncExternalStore` subscriber

      additionalSubscribeListener();
    }
  }; // Actually subscribe to the nearest connected ancestor (or store)


  subscription.onStateChange = checkForUpdates;
  subscription.trySubscribe(); // Pull data from the store after first render in case the store has
  // changed since we began.

  checkForUpdates();

  const unsubscribeWrapper = () => {
    didUnsubscribe = true;
    subscription.tryUnsubscribe();
    subscription.onStateChange = null;

    if (lastThrownError) {
      // It's possible that we caught an error due to a bad mapState function, but the
      // parent re-rendered without this component and we're about to unmount.
      // This shouldn't happen as long as we do top-down subscriptions correctly, but
      // if we ever do those wrong, this throw will surface the error in our tests.
      // In that case, throw the error from here so it doesn't get lost.
      throw lastThrownError;
    }
  };

  return unsubscribeWrapper;
} // Reducer initial state creation for our update reducer


const initStateUpdates = () => EMPTY_ARRAY;

function strictEqual(a, b) {
  return a === b;
}
/**
 * Infers the type of props that a connector will inject into a component.
 */


let hasWarnedAboutDeprecatedPureOption = false;
/**
 * Connects a React component to a Redux store.
 *
 * - Without arguments, just wraps the component, without changing the behavior / props
 *
 * - If 2 params are passed (3rd param, mergeProps, is skipped), default behavior
 * is to override ownProps (as stated in the docs), so what remains is everything that's
 * not a state or dispatch prop
 *
 * - When 3rd param is passed, we don't know if ownProps propagate and whether they
 * should be valid component props, because it depends on mergeProps implementation.
 * As such, it is the user's responsibility to extend ownProps interface from state or
 * dispatch props or both when applicable
 *
 * @param mapStateToProps A function that extracts values from state
 * @param mapDispatchToProps Setup for dispatching actions
 * @param mergeProps Optional callback to merge state and dispatch props together
 * @param options Options for configuring the connection
 *
 */

function connect(mapStateToProps, mapDispatchToProps, mergeProps, {
  // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
  // @ts-ignore
  pure,
  areStatesEqual = strictEqual,
  areOwnPropsEqual = shallowEqual,
  areStatePropsEqual = shallowEqual,
  areMergedPropsEqual = shallowEqual,
  // use React's forwardRef to expose a ref of the wrapped component
  forwardRef = false,
  // the context consumer to use
  context = ReactReduxContext
} = {}) {
  if (false) {}

  const Context = context;
  const initMapStateToProps = mapStateToPropsFactory(mapStateToProps);
  const initMapDispatchToProps = mapDispatchToPropsFactory(mapDispatchToProps);
  const initMergeProps = mergePropsFactory(mergeProps);
  const shouldHandleStateChanges = Boolean(mapStateToProps);

  const wrapWithConnect = WrappedComponent => {
    if (false) {}

    const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    const displayName = `Connect(${wrappedComponentName})`;
    const selectorFactoryOptions = {
      shouldHandleStateChanges,
      displayName,
      wrappedComponentName,
      WrappedComponent,
      // @ts-ignore
      initMapStateToProps,
      // @ts-ignore
      initMapDispatchToProps,
      initMergeProps,
      areStatesEqual,
      areStatePropsEqual,
      areOwnPropsEqual,
      areMergedPropsEqual
    };

    function ConnectFunction(props) {
      const [propsContext, reactReduxForwardedRef, wrapperProps] = React.useMemo(() => {
        // Distinguish between actual "data" props that were passed to the wrapper component,
        // and values needed to control behavior (forwarded refs, alternate context instances).
        // To maintain the wrapperProps object reference, memoize this destructuring.
        const {
          reactReduxForwardedRef
        } = props,
              wrapperProps = _objectWithoutPropertiesLoose(props, _excluded);

        return [props.context, reactReduxForwardedRef, wrapperProps];
      }, [props]);
      const ContextToUse = React.useMemo(() => {
        // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
        // Memoize the check that determines which context instance we should use.
        return propsContext && propsContext.Consumer && // @ts-ignore
        isContextConsumer( /*#__PURE__*/React.createElement(propsContext.Consumer, null)) ? propsContext : Context;
      }, [propsContext, Context]); // Retrieve the store and ancestor subscription via context, if available

      const contextValue = React.useContext(ContextToUse); // The store _must_ exist as either a prop or in context.
      // We'll check to see if it _looks_ like a Redux store first.
      // This allows us to pass through a `store` prop that is just a plain value.

      const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
      const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);

      if (false) {} // Based on the previous check, one of these must be true


      const store = didStoreComeFromProps ? props.store : contextValue.store;
      const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
      const childPropsSelector = React.useMemo(() => {
        // The child props selector needs the store reference as an input.
        // Re-create this selector whenever the store changes.
        return defaultSelectorFactory(store.dispatch, selectorFactoryOptions);
      }, [store]);
      const [subscription, notifyNestedSubs] = React.useMemo(() => {
        if (!shouldHandleStateChanges) return NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.

        const subscription = createSubscription(store, didStoreComeFromProps ? undefined : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
        // the middle of the notification loop, where `subscription` will then be null. This can
        // probably be avoided if Subscription's listeners logic is changed to not call listeners
        // that have been unsubscribed in the  middle of the notification loop.

        const notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
        return [subscription, notifyNestedSubs];
      }, [store, didStoreComeFromProps, contextValue]); // Determine what {store, subscription} value should be put into nested context, if necessary,
      // and memoize that value to avoid unnecessary context updates.

      const overriddenContextValue = React.useMemo(() => {
        if (didStoreComeFromProps) {
          // This component is directly subscribed to a store from props.
          // We don't want descendants reading from this store - pass down whatever
          // the existing context value is from the nearest connected ancestor.
          return contextValue;
        } // Otherwise, put this component's subscription instance into context, so that
        // connected descendants won't update until after this component is done


        return _extends({}, contextValue, {
          subscription
        });
      }, [didStoreComeFromProps, contextValue, subscription]); // Set up refs to coordinate values between the subscription effect and the render logic

      const lastChildProps = React.useRef();
      const lastWrapperProps = React.useRef(wrapperProps);
      const childPropsFromStoreUpdate = React.useRef();
      const renderIsScheduled = React.useRef(false);
      const isProcessingDispatch = React.useRef(false);
      const isMounted = React.useRef(false);
      const latestSubscriptionCallbackError = React.useRef();
      useIsomorphicLayoutEffect(() => {
        isMounted.current = true;
        return () => {
          isMounted.current = false;
        };
      }, []);
      const actualChildPropsSelector = React.useMemo(() => {
        const selector = () => {
          // Tricky logic here:
          // - This render may have been triggered by a Redux store update that produced new child props
          // - However, we may have gotten new wrapper props after that
          // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
          // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
          // So, we'll use the child props from store update only if the wrapper props are the same as last time.
          if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) {
            return childPropsFromStoreUpdate.current;
          } // TODO We're reading the store directly in render() here. Bad idea?
          // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
          // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
          // to determine what the child props should be.


          return childPropsSelector(store.getState(), wrapperProps);
        };

        return selector;
      }, [store, wrapperProps]); // We need this to execute synchronously every time we re-render. However, React warns
      // about useLayoutEffect in SSR, so we try to detect environment and fall back to
      // just useEffect instead to avoid the warning, since neither will run anyway.

      const subscribeForReact = React.useMemo(() => {
        const subscribe = reactListener => {
          if (!subscription) {
            return () => {};
          }

          return subscribeUpdates(shouldHandleStateChanges, store, subscription, // @ts-ignore
          childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
        };

        return subscribe;
      }, [subscription]);
      useIsomorphicLayoutEffectWithArgs(captureWrapperProps, [lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs]);
      let actualChildProps;

      try {
        actualChildProps = useSyncExternalStore( // TODO We're passing through a big wrapper that does a bunch of extra side effects besides subscribing
        subscribeForReact, // TODO This is incredibly hacky. We've already processed the store update and calculated new child props,
        // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
        actualChildPropsSelector, getServerState ? () => childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
      } catch (err) {
        if (latestSubscriptionCallbackError.current) {
          ;
          err.message += `\nThe error may be correlated with this previous error:\n${latestSubscriptionCallbackError.current.stack}\n\n`;
        }

        throw err;
      }

      useIsomorphicLayoutEffect(() => {
        latestSubscriptionCallbackError.current = undefined;
        childPropsFromStoreUpdate.current = undefined;
        lastChildProps.current = actualChildProps;
      }); // Now that all that's done, we can finally try to actually render the child component.
      // We memoize the elements for the rendered child component as an optimization.

      const renderedWrappedComponent = React.useMemo(() => {
        return (
          /*#__PURE__*/
          // @ts-ignore
          React.createElement(WrappedComponent, _extends({}, actualChildProps, {
            ref: reactReduxForwardedRef
          }))
        );
      }, [reactReduxForwardedRef, WrappedComponent, actualChildProps]); // If React sees the exact same element reference as last time, it bails out of re-rendering
      // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.

      const renderedChild = React.useMemo(() => {
        if (shouldHandleStateChanges) {
          // If this component is subscribed to store updates, we need to pass its own
          // subscription instance down to our descendants. That means rendering the same
          // Context instance, and putting a different value into the context.
          return /*#__PURE__*/React.createElement(ContextToUse.Provider, {
            value: overriddenContextValue
          }, renderedWrappedComponent);
        }

        return renderedWrappedComponent;
      }, [ContextToUse, renderedWrappedComponent, overriddenContextValue]);
      return renderedChild;
    }

    const _Connect = React.memo(ConnectFunction);

    // Add a hacky cast to get the right output type
    const Connect = _Connect;
    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = ConnectFunction.displayName = displayName;

    if (forwardRef) {
      const _forwarded = React.forwardRef(function forwardConnectRef(props, ref) {
        // @ts-ignore
        return /*#__PURE__*/React.createElement(Connect, _extends({}, props, {
          reactReduxForwardedRef: ref
        }));
      });

      const forwarded = _forwarded;
      forwarded.displayName = displayName;
      forwarded.WrappedComponent = WrappedComponent;
      return hoistStatics(forwarded, WrappedComponent);
    }

    return hoistStatics(Connect, WrappedComponent);
  };

  return wrapWithConnect;
}

/* harmony default export */ var components_connect = ((/* unused pure expression or super */ null && (connect)));
;// CONCATENATED MODULE: ./node_modules/react-redux/es/components/Provider.js





function Provider({
  store,
  context,
  children,
  serverState,
  stabilityCheck = 'once',
  noopCheck = 'once'
}) {
  const contextValue = react.useMemo(() => {
    const subscription = Subscription_createSubscription(store);
    return {
      store,
      subscription,
      getServerState: serverState ? () => serverState : undefined,
      stabilityCheck,
      noopCheck
    };
  }, [store, serverState, stabilityCheck, noopCheck]);
  const previousState = react.useMemo(() => store.getState(), [store]);
  useIsomorphicLayoutEffect_useIsomorphicLayoutEffect(() => {
    const {
      subscription
    } = contextValue;
    subscription.onStateChange = subscription.notifyNestedSubs;
    subscription.trySubscribe();

    if (previousState !== store.getState()) {
      subscription.notifyNestedSubs();
    }

    return () => {
      subscription.tryUnsubscribe();
      subscription.onStateChange = undefined;
    };
  }, [contextValue, previousState]);
  const Context = context || Context_ReactReduxContext; // @ts-ignore 'AnyAction' is assignable to the constraint of type 'A', but 'A' could be instantiated with a different subtype

  return /*#__PURE__*/react.createElement(Context.Provider, {
    value: contextValue
  }, children);
}

/* harmony default export */ var components_Provider = (Provider);
;// CONCATENATED MODULE: ./node_modules/react-redux/es/hooks/useStore.js


/**
 * Hook factory, which creates a `useStore` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useStore` hook bound to the specified context.
 */

function createStoreHook(context = Context_ReactReduxContext) {
  const useReduxContext = // @ts-ignore
  context === Context_ReactReduxContext ? useReduxContext_useReduxContext : // @ts-ignore
  createReduxContextHook(context);
  return function useStore() {
    const {
      store
    } = useReduxContext(); // @ts-ignore

    return store;
  };
}
/**
 * A hook to access the redux store.
 *
 * @returns {any} the redux store
 *
 * @example
 *
 * import React from 'react'
 * import { useStore } from 'react-redux'
 *
 * export const ExampleComponent = () => {
 *   const store = useStore()
 *   return <div>{store.getState()}</div>
 * }
 */

const useStore_useStore = /*#__PURE__*/createStoreHook();
;// CONCATENATED MODULE: ./node_modules/react-redux/es/hooks/useDispatch.js


/**
 * Hook factory, which creates a `useDispatch` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useDispatch` hook bound to the specified context.
 */

function createDispatchHook(context = Context_ReactReduxContext) {
  const useStore = // @ts-ignore
  context === Context_ReactReduxContext ? useStore_useStore : createStoreHook(context);
  return function useDispatch() {
    const store = useStore(); // @ts-ignore

    return store.dispatch;
  };
}
/**
 * A hook to access the redux `dispatch` function.
 *
 * @returns {any|function} redux store's `dispatch` function
 *
 * @example
 *
 * import React, { useCallback } from 'react'
 * import { useDispatch } from 'react-redux'
 *
 * export const CounterComponent = ({ value }) => {
 *   const dispatch = useDispatch()
 *   const increaseCounter = useCallback(() => dispatch({ type: 'increase-counter' }), [])
 *   return (
 *     <div>
 *       <span>{value}</span>
 *       <button onClick={increaseCounter}>Increase counter</button>
 *     </div>
 *   )
 * }
 */

const useDispatch = /*#__PURE__*/createDispatchHook();
;// CONCATENATED MODULE: ./node_modules/react-redux/es/exports.js









;// CONCATENATED MODULE: ./node_modules/react-redux/es/index.js
// The primary entry point assumes we're working with standard ReactDOM/RN, but
// older versions that do not include `useSyncExternalStore` (React 16.9 - 17.x).
// Because of that, the useSyncExternalStore compat shim is needed.






initializeUseSelector(with_selector.useSyncExternalStoreWithSelector);
initializeConnect(shim.useSyncExternalStore); // Enable batched updates in our subscriptions for use
// with standard React renderers (ReactDOM, React Native)

setBatch(react_dom.unstable_batchedUpdates);



/***/ }),

/***/ 44937:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */


var React = __webpack_require__(67294);
function is(x, y) {
  return (x === y && (0 !== x || 1 / x === 1 / y)) || (x !== x && y !== y);
}
var objectIs = "function" === typeof Object.is ? Object.is : is,
  useState = React.useState,
  useEffect = React.useEffect,
  useLayoutEffect = React.useLayoutEffect,
  useDebugValue = React.useDebugValue;
function useSyncExternalStore$2(subscribe, getSnapshot) {
  var value = getSnapshot(),
    _useState = useState({ inst: { value: value, getSnapshot: getSnapshot } }),
    inst = _useState[0].inst,
    forceUpdate = _useState[1];
  useLayoutEffect(
    function () {
      inst.value = value;
      inst.getSnapshot = getSnapshot;
      checkIfSnapshotChanged(inst) && forceUpdate({ inst: inst });
    },
    [subscribe, value, getSnapshot]
  );
  useEffect(
    function () {
      checkIfSnapshotChanged(inst) && forceUpdate({ inst: inst });
      return subscribe(function () {
        checkIfSnapshotChanged(inst) && forceUpdate({ inst: inst });
      });
    },
    [subscribe]
  );
  useDebugValue(value);
  return value;
}
function checkIfSnapshotChanged(inst) {
  var latestGetSnapshot = inst.getSnapshot;
  inst = inst.value;
  try {
    var nextValue = latestGetSnapshot();
    return !objectIs(inst, nextValue);
  } catch (error) {
    return !0;
  }
}
function useSyncExternalStore$1(subscribe, getSnapshot) {
  return getSnapshot();
}
var shim =
  "undefined" === typeof window ||
  "undefined" === typeof window.document ||
  "undefined" === typeof window.document.createElement
    ? useSyncExternalStore$1
    : useSyncExternalStore$2;
exports.useSyncExternalStore =
  void 0 !== React.useSyncExternalStore ? React.useSyncExternalStore : shim;


/***/ }),

/***/ 78069:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */


var React = __webpack_require__(67294),
  shim = __webpack_require__(17540);
function is(x, y) {
  return (x === y && (0 !== x || 1 / x === 1 / y)) || (x !== x && y !== y);
}
var objectIs = "function" === typeof Object.is ? Object.is : is,
  useSyncExternalStore = shim.useSyncExternalStore,
  useRef = React.useRef,
  useEffect = React.useEffect,
  useMemo = React.useMemo,
  useDebugValue = React.useDebugValue;
exports.useSyncExternalStoreWithSelector = function (
  subscribe,
  getSnapshot,
  getServerSnapshot,
  selector,
  isEqual
) {
  var instRef = useRef(null);
  if (null === instRef.current) {
    var inst = { hasValue: !1, value: null };
    instRef.current = inst;
  } else inst = instRef.current;
  instRef = useMemo(
    function () {
      function memoizedSelector(nextSnapshot) {
        if (!hasMemo) {
          hasMemo = !0;
          memoizedSnapshot = nextSnapshot;
          nextSnapshot = selector(nextSnapshot);
          if (void 0 !== isEqual && inst.hasValue) {
            var currentSelection = inst.value;
            if (isEqual(currentSelection, nextSnapshot))
              return (memoizedSelection = currentSelection);
          }
          return (memoizedSelection = nextSnapshot);
        }
        currentSelection = memoizedSelection;
        if (objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
        var nextSelection = selector(nextSnapshot);
        if (void 0 !== isEqual && isEqual(currentSelection, nextSelection))
          return (memoizedSnapshot = nextSnapshot), currentSelection;
        memoizedSnapshot = nextSnapshot;
        return (memoizedSelection = nextSelection);
      }
      var hasMemo = !1,
        memoizedSnapshot,
        memoizedSelection,
        maybeGetServerSnapshot =
          void 0 === getServerSnapshot ? null : getServerSnapshot;
      return [
        function () {
          return memoizedSelector(getSnapshot());
        },
        null === maybeGetServerSnapshot
          ? void 0
          : function () {
              return memoizedSelector(maybeGetServerSnapshot());
            }
      ];
    },
    [getSnapshot, getServerSnapshot, selector, isEqual]
  );
  var value = useSyncExternalStore(subscribe, instRef[0], instRef[1]);
  useEffect(
    function () {
      inst.hasValue = !0;
      inst.value = value;
    },
    [value]
  );
  useDebugValue(value);
  return value;
};


/***/ }),

/***/ 17540:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(44937);
} else {}


/***/ }),

/***/ 36786:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(78069);
} else {}


/***/ }),

/***/ 48477:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(67294);

var _react2 = _interopRequireDefault(_react);

var _scrollLink = __webpack_require__(31093);

var _scrollLink2 = _interopRequireDefault(_scrollLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ButtonElement = function (_React$Component) {
  _inherits(ButtonElement, _React$Component);

  function ButtonElement() {
    _classCallCheck(this, ButtonElement);

    return _possibleConstructorReturn(this, (ButtonElement.__proto__ || Object.getPrototypeOf(ButtonElement)).apply(this, arguments));
  }

  _createClass(ButtonElement, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'button',
        this.props,
        this.props.children
      );
    }
  }]);

  return ButtonElement;
}(_react2.default.Component);

;

exports["default"] = (0, _scrollLink2.default)(ButtonElement);

/***/ }),

/***/ 35343:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(67294);

var _react2 = _interopRequireDefault(_react);

var _scrollElement = __webpack_require__(18000);

var _scrollElement2 = _interopRequireDefault(_scrollElement);

var _propTypes = __webpack_require__(45697);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ElementWrapper = function (_React$Component) {
  _inherits(ElementWrapper, _React$Component);

  function ElementWrapper() {
    _classCallCheck(this, ElementWrapper);

    return _possibleConstructorReturn(this, (ElementWrapper.__proto__ || Object.getPrototypeOf(ElementWrapper)).apply(this, arguments));
  }

  _createClass(ElementWrapper, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      // Remove `parentBindings` and `name` from props
      var newProps = _extends({}, this.props);
      delete newProps.name;
      if (newProps.parentBindings) {
        delete newProps.parentBindings;
      }

      return _react2.default.createElement(
        'div',
        _extends({}, newProps, { ref: function ref(el) {
            _this2.props.parentBindings.domNode = el;
          } }),
        this.props.children
      );
    }
  }]);

  return ElementWrapper;
}(_react2.default.Component);

;

ElementWrapper.propTypes = {
  name: _propTypes2.default.string,
  id: _propTypes2.default.string
};

exports["default"] = (0, _scrollElement2.default)(ElementWrapper);

/***/ }),

/***/ 68939:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _react = __webpack_require__(67294);

var _react2 = _interopRequireDefault(_react);

var _scrollLink = __webpack_require__(31093);

var _scrollLink2 = _interopRequireDefault(_scrollLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LinkElement = function (_React$Component) {
  _inherits(LinkElement, _React$Component);

  function LinkElement() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, LinkElement);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LinkElement.__proto__ || Object.getPrototypeOf(LinkElement)).call.apply(_ref, [this].concat(args))), _this), _this.render = function () {
      return _react2.default.createElement(
        'a',
        _this.props,
        _this.props.children
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  return LinkElement;
}(_react2.default.Component);

;

exports["default"] = (0, _scrollLink2.default)(LinkElement);

/***/ }),

/***/ 66261:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});
__webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = exports.OK = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = undefined;

var _Link = __webpack_require__(68939);

var _Link2 = _interopRequireDefault(_Link);

var _Button = __webpack_require__(48477);

var _Button2 = _interopRequireDefault(_Button);

var _Element = __webpack_require__(35343);

var _Element2 = _interopRequireDefault(_Element);

var _scroller = __webpack_require__(82628);

var _scroller2 = _interopRequireDefault(_scroller);

var _scrollEvents = __webpack_require__(64592);

var _scrollEvents2 = _interopRequireDefault(_scrollEvents);

var _scrollSpy = __webpack_require__(87606);

var _scrollSpy2 = _interopRequireDefault(_scrollSpy);

var _animateScroll = __webpack_require__(53200);

var _animateScroll2 = _interopRequireDefault(_animateScroll);

var _scrollLink = __webpack_require__(31093);

var _scrollLink2 = _interopRequireDefault(_scrollLink);

var _scrollElement = __webpack_require__(18000);

var _scrollElement2 = _interopRequireDefault(_scrollElement);

var _Helpers = __webpack_require__(98482);

var _Helpers2 = _interopRequireDefault(_Helpers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_unused_export__ = _Link2.default;
__webpack_unused_export__ = _Button2.default;
__webpack_unused_export__ = _Element2.default;
exports.OK = _scroller2.default;
__webpack_unused_export__ = _scrollEvents2.default;
__webpack_unused_export__ = _scrollSpy2.default;
__webpack_unused_export__ = _animateScroll2.default;
__webpack_unused_export__ = _scrollLink2.default;
__webpack_unused_export__ = _scrollElement2.default;
__webpack_unused_export__ = _Helpers2.default;
exports.ZP = { Link: _Link2.default, Button: _Button2.default, Element: _Element2.default, scroller: _scroller2.default, Events: _scrollEvents2.default, scrollSpy: _scrollSpy2.default, animateScroll: _animateScroll2.default, ScrollLink: _scrollLink2.default, ScrollElement: _scrollElement2.default, Helpers: _Helpers2.default };

/***/ }),

/***/ 98482:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


/* DEPRECATED */

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(67294);
var ReactDOM = __webpack_require__(73935);

var utils = __webpack_require__(54259);
var scrollSpy = __webpack_require__(87606);
var defaultScroller = __webpack_require__(82628);
var PropTypes = __webpack_require__(45697);
var scrollHash = __webpack_require__(29678);

var protoTypes = {
  to: PropTypes.string.isRequired,
  containerId: PropTypes.string,
  container: PropTypes.object,
  activeClass: PropTypes.string,
  spy: PropTypes.bool,
  smooth: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  offset: PropTypes.number,
  delay: PropTypes.number,
  isDynamic: PropTypes.bool,
  onClick: PropTypes.func,
  duration: PropTypes.oneOfType([PropTypes.number, PropTypes.func]),
  absolute: PropTypes.bool,
  onSetActive: PropTypes.func,
  onSetInactive: PropTypes.func,
  ignoreCancelEvents: PropTypes.bool,
  hashSpy: PropTypes.bool,
  spyThrottle: PropTypes.number
};

var Helpers = {
  Scroll: function Scroll(Component, customScroller) {

    console.warn("Helpers.Scroll is deprecated since v1.7.0");

    var scroller = customScroller || defaultScroller;

    var Scroll = function (_React$Component) {
      _inherits(Scroll, _React$Component);

      function Scroll(props) {
        _classCallCheck(this, Scroll);

        var _this = _possibleConstructorReturn(this, (Scroll.__proto__ || Object.getPrototypeOf(Scroll)).call(this, props));

        _initialiseProps.call(_this);

        _this.state = {
          active: false
        };
        return _this;
      }

      _createClass(Scroll, [{
        key: 'getScrollSpyContainer',
        value: function getScrollSpyContainer() {
          var containerId = this.props.containerId;
          var container = this.props.container;

          if (containerId) {
            return document.getElementById(containerId);
          }

          if (container && container.nodeType) {
            return container;
          }

          return document;
        }
      }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
          if (this.props.spy || this.props.hashSpy) {
            var scrollSpyContainer = this.getScrollSpyContainer();

            if (!scrollSpy.isMounted(scrollSpyContainer)) {
              scrollSpy.mount(scrollSpyContainer, this.props.spyThrottle);
            }

            if (this.props.hashSpy) {
              if (!scrollHash.isMounted()) {
                scrollHash.mount(scroller);
              }
              scrollHash.mapContainer(this.props.to, scrollSpyContainer);
            }

            if (this.props.spy) {
              scrollSpy.addStateHandler(this.stateHandler);
            }

            scrollSpy.addSpyHandler(this.spyHandler, scrollSpyContainer);

            this.setState({
              container: scrollSpyContainer
            });
          }
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          scrollSpy.unmount(this.stateHandler, this.spyHandler);
        }
      }, {
        key: 'render',
        value: function render() {
          var className = "";

          if (this.state && this.state.active) {
            className = ((this.props.className || "") + " " + (this.props.activeClass || "active")).trim();
          } else {
            className = this.props.className;
          }

          var props = _extends({}, this.props);

          for (var prop in protoTypes) {
            if (props.hasOwnProperty(prop)) {
              delete props[prop];
            }
          }

          props.className = className;
          props.onClick = this.handleClick;

          return React.createElement(Component, props);
        }
      }]);

      return Scroll;
    }(React.Component);

    var _initialiseProps = function _initialiseProps() {
      var _this2 = this;

      this.scrollTo = function (to, props) {
        scroller.scrollTo(to, _extends({}, _this2.state, props));
      };

      this.handleClick = function (event) {

        /*
         * give the posibility to override onClick
         */

        if (_this2.props.onClick) {
          _this2.props.onClick(event);
        }

        /*
         * dont bubble the navigation
         */

        if (event.stopPropagation) event.stopPropagation();
        if (event.preventDefault) event.preventDefault();

        /*
         * do the magic!
         */
        _this2.scrollTo(_this2.props.to, _this2.props);
      };

      this.stateHandler = function () {
        if (scroller.getActiveLink() !== _this2.props.to) {
          if (_this2.state !== null && _this2.state.active && _this2.props.onSetInactive) {
            _this2.props.onSetInactive();
          }
          _this2.setState({ active: false });
        }
      };

      this.spyHandler = function (y) {

        var scrollSpyContainer = _this2.getScrollSpyContainer();

        if (scrollHash.isMounted() && !scrollHash.isInitialized()) {
          return;
        }

        var to = _this2.props.to;
        var element = null;
        var elemTopBound = 0;
        var elemBottomBound = 0;
        var containerTop = 0;

        if (scrollSpyContainer.getBoundingClientRect) {
          var containerCords = scrollSpyContainer.getBoundingClientRect();
          containerTop = containerCords.top;
        }

        if (!element || _this2.props.isDynamic) {
          element = scroller.get(to);
          if (!element) {
            return;
          }

          var cords = element.getBoundingClientRect();
          elemTopBound = cords.top - containerTop + y;
          elemBottomBound = elemTopBound + cords.height;
        }

        var offsetY = y - _this2.props.offset;
        var isInside = offsetY >= Math.floor(elemTopBound) && offsetY < Math.floor(elemBottomBound);
        var isOutside = offsetY < Math.floor(elemTopBound) || offsetY >= Math.floor(elemBottomBound);
        var activeLink = scroller.getActiveLink();

        if (isOutside) {
          if (to === activeLink) {
            scroller.setActiveLink(void 0);
          }

          if (_this2.props.hashSpy && scrollHash.getHash() === to) {
            scrollHash.changeHash();
          }

          if (_this2.props.spy && _this2.state.active) {
            _this2.setState({ active: false });
            _this2.props.onSetInactive && _this2.props.onSetInactive();
          }

          return scrollSpy.updateStates();
        }

        if (isInside && activeLink !== to) {
          scroller.setActiveLink(to);

          _this2.props.hashSpy && scrollHash.changeHash(to);

          if (_this2.props.spy) {
            _this2.setState({ active: true });
            _this2.props.onSetActive && _this2.props.onSetActive(to);
          }
          return scrollSpy.updateStates();
        }
      };
    };

    ;

    Scroll.propTypes = protoTypes;

    Scroll.defaultProps = { offset: 0 };

    return Scroll;
  },
  Element: function Element(Component) {

    console.warn("Helpers.Element is deprecated since v1.7.0");

    var Element = function (_React$Component2) {
      _inherits(Element, _React$Component2);

      function Element(props) {
        _classCallCheck(this, Element);

        var _this3 = _possibleConstructorReturn(this, (Element.__proto__ || Object.getPrototypeOf(Element)).call(this, props));

        _this3.childBindings = {
          domNode: null
        };
        return _this3;
      }

      _createClass(Element, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          if (typeof window === 'undefined') {
            return false;
          }
          this.registerElems(this.props.name);
        }
      }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
          if (this.props.name !== prevProps.name) {
            this.registerElems(this.props.name);
          }
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          if (typeof window === 'undefined') {
            return false;
          }
          defaultScroller.unregister(this.props.name);
        }
      }, {
        key: 'registerElems',
        value: function registerElems(name) {
          defaultScroller.register(name, this.childBindings.domNode);
        }
      }, {
        key: 'render',
        value: function render() {
          return React.createElement(Component, _extends({}, this.props, { parentBindings: this.childBindings }));
        }
      }]);

      return Element;
    }(React.Component);

    ;

    Element.propTypes = {
      name: PropTypes.string,
      id: PropTypes.string
    };

    return Element;
  }
};

module.exports = Helpers;

/***/ }),

/***/ 53200:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = __webpack_require__(54259);

var _utils2 = _interopRequireDefault(_utils);

var _smooth = __webpack_require__(89765);

var _smooth2 = _interopRequireDefault(_smooth);

var _cancelEvents = __webpack_require__(50140);

var _cancelEvents2 = _interopRequireDefault(_cancelEvents);

var _scrollEvents = __webpack_require__(64592);

var _scrollEvents2 = _interopRequireDefault(_scrollEvents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * Gets the easing type from the smooth prop within options.
 */
var getAnimationType = function getAnimationType(options) {
  return _smooth2.default[options.smooth] || _smooth2.default.defaultEasing;
};
/*
 * Function helper
 */
var functionWrapper = function functionWrapper(value) {
  return typeof value === 'function' ? value : function () {
    return value;
  };
};
/*
 * Wraps window properties to allow server side rendering
 */
var currentWindowProperties = function currentWindowProperties() {
  if (typeof window !== 'undefined') {
    return window.requestAnimationFrame || window.webkitRequestAnimationFrame;
  }
};

/*
 * Helper function to never extend 60fps on the webpage.
 */
var requestAnimationFrameHelper = function () {
  return currentWindowProperties() || function (callback, element, delay) {
    window.setTimeout(callback, delay || 1000 / 60, new Date().getTime());
  };
}();

var makeData = function makeData() {
  return {
    currentPosition: 0,
    startPosition: 0,
    targetPosition: 0,
    progress: 0,
    duration: 0,
    cancel: false,

    target: null,
    containerElement: null,
    to: null,
    start: null,
    delta: null,
    percent: null,
    delayTimeout: null
  };
};

var currentPositionX = function currentPositionX(options) {
  var containerElement = options.data.containerElement;
  if (containerElement && containerElement !== document && containerElement !== document.body) {
    return containerElement.scrollLeft;
  } else {
    var supportPageOffset = window.pageXOffset !== undefined;
    var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
    return supportPageOffset ? window.pageXOffset : isCSS1Compat ? document.documentElement.scrollLeft : document.body.scrollLeft;
  }
};

var currentPositionY = function currentPositionY(options) {
  var containerElement = options.data.containerElement;
  if (containerElement && containerElement !== document && containerElement !== document.body) {
    return containerElement.scrollTop;
  } else {
    var supportPageOffset = window.pageXOffset !== undefined;
    var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
    return supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop;
  }
};

var scrollContainerWidth = function scrollContainerWidth(options) {
  var containerElement = options.data.containerElement;
  if (containerElement && containerElement !== document && containerElement !== document.body) {
    return containerElement.scrollWidth - containerElement.offsetWidth;
  } else {
    var body = document.body;
    var html = document.documentElement;

    return Math.max(body.scrollWidth, body.offsetWidth, html.clientWidth, html.scrollWidth, html.offsetWidth);
  }
};

var scrollContainerHeight = function scrollContainerHeight(options) {
  var containerElement = options.data.containerElement;
  if (containerElement && containerElement !== document && containerElement !== document.body) {
    return containerElement.scrollHeight - containerElement.offsetHeight;
  } else {
    var body = document.body;
    var html = document.documentElement;

    return Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
  }
};

var animateScroll = function animateScroll(easing, options, timestamp) {
  var data = options.data;

  // Cancel on specific events
  if (!options.ignoreCancelEvents && data.cancel) {
    if (_scrollEvents2.default.registered['end']) {
      _scrollEvents2.default.registered['end'](data.to, data.target, data.currentPositionY);
    }
    return;
  };

  data.delta = Math.round(data.targetPosition - data.startPosition);

  if (data.start === null) {
    data.start = timestamp;
  }

  data.progress = timestamp - data.start;

  data.percent = data.progress >= data.duration ? 1 : easing(data.progress / data.duration);

  data.currentPosition = data.startPosition + Math.ceil(data.delta * data.percent);

  if (data.containerElement && data.containerElement !== document && data.containerElement !== document.body) {
    if (options.horizontal) {
      data.containerElement.scrollLeft = data.currentPosition;
    } else {
      data.containerElement.scrollTop = data.currentPosition;
    }
  } else {
    if (options.horizontal) {
      window.scrollTo(data.currentPosition, 0);
    } else {
      window.scrollTo(0, data.currentPosition);
    }
  }

  if (data.percent < 1) {
    var easedAnimate = animateScroll.bind(null, easing, options);
    requestAnimationFrameHelper.call(window, easedAnimate);
    return;
  }

  if (_scrollEvents2.default.registered['end']) {
    _scrollEvents2.default.registered['end'](data.to, data.target, data.currentPosition);
  }
};

var setContainer = function setContainer(options) {
  options.data.containerElement = !options ? null : options.containerId ? document.getElementById(options.containerId) : options.container && options.container.nodeType ? options.container : document;
};

var animateTopScroll = function animateTopScroll(scrollOffset, options, to, target) {
  options.data = options.data || makeData();

  window.clearTimeout(options.data.delayTimeout);

  var setCancel = function setCancel() {
    options.data.cancel = true;
  };
  _cancelEvents2.default.subscribe(setCancel);

  setContainer(options);

  options.data.start = null;
  options.data.cancel = false;
  options.data.startPosition = options.horizontal ? currentPositionX(options) : currentPositionY(options);
  options.data.targetPosition = options.absolute ? scrollOffset : scrollOffset + options.data.startPosition;

  if (options.data.startPosition === options.data.targetPosition) {
    if (_scrollEvents2.default.registered['end']) {
      _scrollEvents2.default.registered['end'](options.data.to, options.data.target, options.data.currentPosition);
    }
    return;
  }

  options.data.delta = Math.round(options.data.targetPosition - options.data.startPosition);

  options.data.duration = functionWrapper(options.duration)(options.data.delta);
  options.data.duration = isNaN(parseFloat(options.data.duration)) ? 1000 : parseFloat(options.data.duration);
  options.data.to = to;
  options.data.target = target;

  var easing = getAnimationType(options);
  var easedAnimate = animateScroll.bind(null, easing, options);

  if (options && options.delay > 0) {
    options.data.delayTimeout = window.setTimeout(function () {
      if (_scrollEvents2.default.registered['begin']) {
        _scrollEvents2.default.registered['begin'](options.data.to, options.data.target);
      }
      requestAnimationFrameHelper.call(window, easedAnimate);
    }, options.delay);
    return;
  }

  if (_scrollEvents2.default.registered['begin']) {
    _scrollEvents2.default.registered['begin'](options.data.to, options.data.target);
  }
  requestAnimationFrameHelper.call(window, easedAnimate);
};

var proceedOptions = function proceedOptions(options) {
  options = _extends({}, options);
  options.data = options.data || makeData();
  options.absolute = true;
  return options;
};

var scrollToTop = function scrollToTop(options) {
  animateTopScroll(0, proceedOptions(options));
};

var scrollTo = function scrollTo(toPosition, options) {
  animateTopScroll(toPosition, proceedOptions(options));
};

var scrollToBottom = function scrollToBottom(options) {
  options = proceedOptions(options);
  setContainer(options);
  animateTopScroll(options.horizontal ? scrollContainerWidth(options) : scrollContainerHeight(options), options);
};

var scrollMore = function scrollMore(toPosition, options) {
  options = proceedOptions(options);
  setContainer(options);
  var currentPosition = options.horizontal ? currentPositionX(options) : currentPositionY(options);
  animateTopScroll(toPosition + currentPosition, options);
};

exports["default"] = {
  animateTopScroll: animateTopScroll,
  getAnimationType: getAnimationType,
  scrollToTop: scrollToTop,
  scrollToBottom: scrollToBottom,
  scrollTo: scrollTo,
  scrollMore: scrollMore
};

/***/ }),

/***/ 50140:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _passiveEventListeners = __webpack_require__(55236);

var events = ['mousedown', 'wheel', 'touchmove', 'keydown'];

exports["default"] = {
  subscribe: function subscribe(cancelEvent) {
    return typeof document !== 'undefined' && events.forEach(function (event) {
      return (0, _passiveEventListeners.addPassiveEventListener)(document, event, cancelEvent);
    });
  }
};

/***/ }),

/***/ 55236:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
/*
 * Tell the browser that the event listener won't prevent a scroll.
 * Allowing the browser to continue scrolling without having to
 * to wait for the listener to return.
 */
var addPassiveEventListener = exports.addPassiveEventListener = function addPassiveEventListener(target, eventName, listener) {
  var listenerName = listener.name;
  if (!listenerName) {
    listenerName = eventName;
    console.warn('Listener must be a named function.');
  }

  if (!attachedListeners.has(eventName)) attachedListeners.set(eventName, new Set());
  var listeners = attachedListeners.get(eventName);
  if (listeners.has(listenerName)) return;

  var supportsPassiveOption = function () {
    var supportsPassiveOption = false;
    try {
      var opts = Object.defineProperty({}, 'passive', {
        get: function get() {
          supportsPassiveOption = true;
        }
      });
      window.addEventListener('test', null, opts);
    } catch (e) {}
    return supportsPassiveOption;
  }();
  target.addEventListener(eventName, listener, supportsPassiveOption ? { passive: true } : false);
  listeners.add(listenerName);
};

var removePassiveEventListener = exports.removePassiveEventListener = function removePassiveEventListener(target, eventName, listener) {
  target.removeEventListener(eventName, listener);
  attachedListeners.get(eventName).delete(listener.name || eventName);
};

var attachedListeners = new Map();

/***/ }),

/***/ 18000:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(67294);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(73935);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _scroller = __webpack_require__(82628);

var _scroller2 = _interopRequireDefault(_scroller);

var _propTypes = __webpack_require__(45697);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

exports["default"] = function (Component) {
  var Element = function (_React$Component) {
    _inherits(Element, _React$Component);

    function Element(props) {
      _classCallCheck(this, Element);

      var _this = _possibleConstructorReturn(this, (Element.__proto__ || Object.getPrototypeOf(Element)).call(this, props));

      _this.childBindings = {
        domNode: null
      };
      return _this;
    }

    _createClass(Element, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        if (typeof window === 'undefined') {
          return false;
        }
        this.registerElems(this.props.name);
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps) {
        if (this.props.name !== prevProps.name) {
          this.registerElems(this.props.name);
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (typeof window === 'undefined') {
          return false;
        }
        _scroller2.default.unregister(this.props.name);
      }
    }, {
      key: 'registerElems',
      value: function registerElems(name) {
        _scroller2.default.register(name, this.childBindings.domNode);
      }
    }, {
      key: 'render',
      value: function render() {
        return _react2.default.createElement(Component, _extends({}, this.props, { parentBindings: this.childBindings }));
      }
    }]);

    return Element;
  }(_react2.default.Component);

  ;

  Element.propTypes = {
    name: _propTypes2.default.string,
    id: _propTypes2.default.string
  };

  return Element;
};

/***/ }),

/***/ 64592:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
	value: true
}));

var Events = {
	registered: {},
	scrollEvent: {
		register: function register(evtName, callback) {
			Events.registered[evtName] = callback;
		},
		remove: function remove(evtName) {
			Events.registered[evtName] = null;
		}
	}
};

exports["default"] = Events;

/***/ }),

/***/ 29678:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _passiveEventListeners = __webpack_require__(55236);

var _utils = __webpack_require__(54259);

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var scrollHash = {
  mountFlag: false,
  initialized: false,
  scroller: null,
  containers: {},

  mount: function mount(scroller) {
    this.scroller = scroller;

    this.handleHashChange = this.handleHashChange.bind(this);
    window.addEventListener('hashchange', this.handleHashChange);

    this.initStateFromHash();
    this.mountFlag = true;
  },
  mapContainer: function mapContainer(to, container) {
    this.containers[to] = container;
  },
  isMounted: function isMounted() {
    return this.mountFlag;
  },
  isInitialized: function isInitialized() {
    return this.initialized;
  },
  initStateFromHash: function initStateFromHash() {
    var _this = this;

    var hash = this.getHash();
    if (hash) {
      window.setTimeout(function () {
        _this.scrollTo(hash, true);
        _this.initialized = true;
      }, 10);
    } else {
      this.initialized = true;
    }
  },
  scrollTo: function scrollTo(to, isInit) {
    var scroller = this.scroller;
    var element = scroller.get(to);
    if (element && (isInit || to !== scroller.getActiveLink())) {
      var container = this.containers[to] || document;
      scroller.scrollTo(to, { container: container });
    }
  },
  getHash: function getHash() {
    return _utils2.default.getHash();
  },
  changeHash: function changeHash(to, saveHashHistory) {
    if (this.isInitialized() && _utils2.default.getHash() !== to) {
      _utils2.default.updateHash(to, saveHashHistory);
    }
  },
  handleHashChange: function handleHashChange() {
    this.scrollTo(this.getHash());
  },
  unmount: function unmount() {
    this.scroller = null;
    this.containers = null;
    window.removeEventListener('hashchange', this.handleHashChange);
  }
};

exports["default"] = scrollHash;

/***/ }),

/***/ 31093:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(67294);

var _react2 = _interopRequireDefault(_react);

var _scrollSpy = __webpack_require__(87606);

var _scrollSpy2 = _interopRequireDefault(_scrollSpy);

var _scroller = __webpack_require__(82628);

var _scroller2 = _interopRequireDefault(_scroller);

var _propTypes = __webpack_require__(45697);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _scrollHash = __webpack_require__(29678);

var _scrollHash2 = _interopRequireDefault(_scrollHash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var protoTypes = {
  to: _propTypes2.default.string.isRequired,
  containerId: _propTypes2.default.string,
  container: _propTypes2.default.object,
  activeClass: _propTypes2.default.string,
  activeStyle: _propTypes2.default.object,
  spy: _propTypes2.default.bool,
  horizontal: _propTypes2.default.bool,
  smooth: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.string]),
  offset: _propTypes2.default.number,
  delay: _propTypes2.default.number,
  isDynamic: _propTypes2.default.bool,
  onClick: _propTypes2.default.func,
  duration: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.func]),
  absolute: _propTypes2.default.bool,
  onSetActive: _propTypes2.default.func,
  onSetInactive: _propTypes2.default.func,
  ignoreCancelEvents: _propTypes2.default.bool,
  hashSpy: _propTypes2.default.bool,
  saveHashHistory: _propTypes2.default.bool,
  spyThrottle: _propTypes2.default.number
};

exports["default"] = function (Component, customScroller) {
  var scroller = customScroller || _scroller2.default;

  var Link = function (_React$PureComponent) {
    _inherits(Link, _React$PureComponent);

    function Link(props) {
      _classCallCheck(this, Link);

      var _this = _possibleConstructorReturn(this, (Link.__proto__ || Object.getPrototypeOf(Link)).call(this, props));

      _initialiseProps.call(_this);

      _this.state = {
        active: false
      };
      _this.beforeUnmountCallbacks = [];
      return _this;
    }

    _createClass(Link, [{
      key: "getScrollSpyContainer",
      value: function getScrollSpyContainer() {
        var containerId = this.props.containerId;
        var container = this.props.container;

        if (containerId && !container) {
          return document.getElementById(containerId);
        }

        if (container && container.nodeType) {
          return container;
        }

        return document;
      }
    }, {
      key: "componentDidMount",
      value: function componentDidMount() {
        if (this.props.spy || this.props.hashSpy) {
          var scrollSpyContainer = this.getScrollSpyContainer();

          if (!_scrollSpy2.default.isMounted(scrollSpyContainer)) {
            var fn = _scrollSpy2.default.mount(scrollSpyContainer, this.props.spyThrottle);
            this.beforeUnmountCallbacks.push(fn);
          }

          if (this.props.hashSpy) {
            if (!_scrollHash2.default.isMounted()) {
              _scrollHash2.default.mount(scroller);
            }
            _scrollHash2.default.mapContainer(this.props.to, scrollSpyContainer);
          }

          _scrollSpy2.default.addSpyHandler(this.spyHandler, scrollSpyContainer);

          this.setState({
            container: scrollSpyContainer
          });
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        _scrollSpy2.default.unmount(this.stateHandler, this.spyHandler);
        this.beforeUnmountCallbacks.forEach(function (fn) {
          return fn();
        });
      }
    }, {
      key: "render",
      value: function render() {
        var className = "";

        if (this.state && this.state.active) {
          className = ((this.props.className || "") + " " + (this.props.activeClass || "active")).trim();
        } else {
          className = this.props.className;
        }

        var style = {};

        if (this.state && this.state.active) {
          style = _extends({}, this.props.style, this.props.activeStyle);
        } else {
          style = _extends({}, this.props.style);
        }

        var props = _extends({}, this.props);

        for (var prop in protoTypes) {
          if (props.hasOwnProperty(prop)) {
            delete props[prop];
          }
        }

        props.className = className;
        props.style = style;
        props.onClick = this.handleClick;

        return _react2.default.createElement(Component, props);
      }
    }]);

    return Link;
  }(_react2.default.PureComponent);

  var _initialiseProps = function _initialiseProps() {
    var _this2 = this;

    this.scrollTo = function (to, props) {
      scroller.scrollTo(to, _extends({}, _this2.state, props));
    };

    this.handleClick = function (event) {
      /*
       * give the posibility to override onClick
       */

      if (_this2.props.onClick) {
        _this2.props.onClick(event);
      }

      /*
       * dont bubble the navigation
       */

      if (event.stopPropagation) event.stopPropagation();
      if (event.preventDefault) event.preventDefault();

      /*
       * do the magic!
       */
      _this2.scrollTo(_this2.props.to, _this2.props);
    };

    this.spyHandler = function (x, y) {
      var scrollSpyContainer = _this2.getScrollSpyContainer();

      if (_scrollHash2.default.isMounted() && !_scrollHash2.default.isInitialized()) {
        return;
      }

      var horizontal = _this2.props.horizontal;

      var to = _this2.props.to;
      var element = null;
      var isInside = void 0;
      var isOutside = void 0;

      if (horizontal) {
        var elemLeftBound = 0;
        var elemRightBound = 0;
        var containerLeft = 0;

        if (scrollSpyContainer.getBoundingClientRect) {
          var containerCords = scrollSpyContainer.getBoundingClientRect();
          containerLeft = containerCords.left;
        }

        if (!element || _this2.props.isDynamic) {
          element = scroller.get(to);
          if (!element) {
            return;
          }

          var cords = element.getBoundingClientRect();
          elemLeftBound = cords.left - containerLeft + x;
          elemRightBound = elemLeftBound + cords.width;
        }

        var offsetX = x - _this2.props.offset;
        isInside = offsetX >= Math.floor(elemLeftBound) && offsetX < Math.floor(elemRightBound);
        isOutside = offsetX < Math.floor(elemLeftBound) || offsetX >= Math.floor(elemRightBound);
      } else {
        var elemTopBound = 0;
        var elemBottomBound = 0;
        var containerTop = 0;

        if (scrollSpyContainer.getBoundingClientRect) {
          var _containerCords = scrollSpyContainer.getBoundingClientRect();
          containerTop = _containerCords.top;
        }

        if (!element || _this2.props.isDynamic) {
          element = scroller.get(to);
          if (!element) {
            return;
          }

          var _cords = element.getBoundingClientRect();

          elemTopBound = _cords.top - containerTop + y;
          elemBottomBound = elemTopBound + _cords.height;
        }

        var offsetY = y - _this2.props.offset;

        isInside = offsetY >= Math.floor(elemTopBound) && offsetY < Math.floor(elemBottomBound);
        isOutside = offsetY < Math.floor(elemTopBound) || offsetY >= Math.floor(elemBottomBound);
      }

      var activeLink = scroller.getActiveLink();

      if (isOutside) {
        if (to === activeLink) {
          scroller.setActiveLink(void 0);
        }

        if (_this2.props.hashSpy && _scrollHash2.default.getHash() === to) {
          var _props$saveHashHistor = _this2.props.saveHashHistory,
              saveHashHistory = _props$saveHashHistor === undefined ? false : _props$saveHashHistor;

          _scrollHash2.default.changeHash("", saveHashHistory);
        }

        if (_this2.props.spy && _this2.state.active) {
          _this2.setState({ active: false });
          _this2.props.onSetInactive && _this2.props.onSetInactive(to, element);
        }
      }

      if (isInside && (activeLink !== to || _this2.state.active === false)) {
        scroller.setActiveLink(to);

        var _props$saveHashHistor2 = _this2.props.saveHashHistory,
            _saveHashHistory = _props$saveHashHistor2 === undefined ? false : _props$saveHashHistor2;

        _this2.props.hashSpy && _scrollHash2.default.changeHash(to, _saveHashHistory);

        if (_this2.props.spy) {
          _this2.setState({ active: true });
          _this2.props.onSetActive && _this2.props.onSetActive(to, element);
        }
      }
    };
  };

  Link.propTypes = protoTypes;

  Link.defaultProps = { offset: 0 };

  return Link;
};

/***/ }),

/***/ 87606:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _lodash = __webpack_require__(93096);

var _lodash2 = _interopRequireDefault(_lodash);

var _passiveEventListeners = __webpack_require__(55236);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// The eventHandler will execute at a rate of 15fps by default
var eventThrottler = function eventThrottler(eventHandler) {
  var throttleAmount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 66;
  return (0, _lodash2.default)(eventHandler, throttleAmount);
};

var scrollSpy = {

  spyCallbacks: [],
  spySetState: [],
  scrollSpyContainers: [],

  mount: function mount(scrollSpyContainer, throttle) {
    if (scrollSpyContainer) {
      var eventHandler = eventThrottler(function (event) {
        scrollSpy.scrollHandler(scrollSpyContainer);
      }, throttle);
      scrollSpy.scrollSpyContainers.push(scrollSpyContainer);
      (0, _passiveEventListeners.addPassiveEventListener)(scrollSpyContainer, 'scroll', eventHandler);
      return function () {
        (0, _passiveEventListeners.removePassiveEventListener)(scrollSpyContainer, 'scroll', eventHandler);
        scrollSpy.scrollSpyContainers.splice(scrollSpy.scrollSpyContainers.indexOf(scrollSpyContainer), 1);
      };
    }
    return function () {};
  },
  isMounted: function isMounted(scrollSpyContainer) {
    return scrollSpy.scrollSpyContainers.indexOf(scrollSpyContainer) !== -1;
  },
  currentPositionX: function currentPositionX(scrollSpyContainer) {
    if (scrollSpyContainer === document) {
      var supportPageOffset = window.scrollY !== undefined;
      var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
      return supportPageOffset ? window.scrollX : isCSS1Compat ? document.documentElement.scrollLeft : document.body.scrollLeft;
    } else {
      return scrollSpyContainer.scrollLeft;
    }
  },
  currentPositionY: function currentPositionY(scrollSpyContainer) {
    if (scrollSpyContainer === document) {
      var supportPageOffset = window.scrollX !== undefined;
      var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
      return supportPageOffset ? window.scrollY : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop;
    } else {
      return scrollSpyContainer.scrollTop;
    }
  },
  scrollHandler: function scrollHandler(scrollSpyContainer) {
    var callbacks = scrollSpy.scrollSpyContainers[scrollSpy.scrollSpyContainers.indexOf(scrollSpyContainer)].spyCallbacks || [];
    callbacks.forEach(function (c) {
      return c(scrollSpy.currentPositionX(scrollSpyContainer), scrollSpy.currentPositionY(scrollSpyContainer));
    });
  },
  addStateHandler: function addStateHandler(handler) {
    scrollSpy.spySetState.push(handler);
  },
  addSpyHandler: function addSpyHandler(handler, scrollSpyContainer) {
    var container = scrollSpy.scrollSpyContainers[scrollSpy.scrollSpyContainers.indexOf(scrollSpyContainer)];

    if (!container.spyCallbacks) {
      container.spyCallbacks = [];
    }

    container.spyCallbacks.push(handler);
  },
  updateStates: function updateStates() {
    scrollSpy.spySetState.forEach(function (s) {
      return s();
    });
  },
  unmount: function unmount(stateHandler, spyHandler) {
    scrollSpy.scrollSpyContainers.forEach(function (c) {
      return c.spyCallbacks && c.spyCallbacks.length && c.spyCallbacks.indexOf(spyHandler) > -1 && c.spyCallbacks.splice(c.spyCallbacks.indexOf(spyHandler), 1);
    });

    if (scrollSpy.spySetState && scrollSpy.spySetState.length && scrollSpy.spySetState.indexOf(stateHandler) > -1) {
      scrollSpy.spySetState.splice(scrollSpy.spySetState.indexOf(stateHandler), 1);
    }

    document.removeEventListener('scroll', scrollSpy.scrollHandler);
  },


  update: function update() {
    return scrollSpy.scrollSpyContainers.forEach(function (c) {
      return scrollSpy.scrollHandler(c);
    });
  }
};

exports["default"] = scrollSpy;

/***/ }),

/***/ 82628:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = __webpack_require__(54259);

var _utils2 = _interopRequireDefault(_utils);

var _animateScroll = __webpack_require__(53200);

var _animateScroll2 = _interopRequireDefault(_animateScroll);

var _scrollEvents = __webpack_require__(64592);

var _scrollEvents2 = _interopRequireDefault(_scrollEvents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __mapped = {};
var __activeLink = void 0;

exports["default"] = {

  unmount: function unmount() {
    __mapped = {};
  },

  register: function register(name, element) {
    __mapped[name] = element;
  },

  unregister: function unregister(name) {
    delete __mapped[name];
  },

  get: function get(name) {
    return __mapped[name] || document.getElementById(name) || document.getElementsByName(name)[0] || document.getElementsByClassName(name)[0];
  },

  setActiveLink: function setActiveLink(link) {
    return __activeLink = link;
  },

  getActiveLink: function getActiveLink() {
    return __activeLink;
  },

  scrollTo: function scrollTo(to, props) {

    var target = this.get(to);

    if (!target) {
      console.warn("target Element not found");
      return;
    }

    props = _extends({}, props, { absolute: false });

    var containerId = props.containerId;
    var container = props.container;

    var containerElement = void 0;
    if (containerId) {
      containerElement = document.getElementById(containerId);
    } else if (container && container.nodeType) {
      containerElement = container;
    } else {
      containerElement = document;
    }

    props.absolute = true;

    var horizontal = props.horizontal;
    var scrollOffset = _utils2.default.scrollOffset(containerElement, target, horizontal) + (props.offset || 0);

    /*
     * if animate is not provided just scroll into the view
     */
    if (!props.smooth) {
      if (_scrollEvents2.default.registered['begin']) {
        _scrollEvents2.default.registered['begin'](to, target);
      }

      if (containerElement === document) {
        if (props.horizontal) {
          window.scrollTo(scrollOffset, 0);
        } else {
          window.scrollTo(0, scrollOffset);
        }
      } else {
        containerElement.scrollTop = scrollOffset;
      }

      if (_scrollEvents2.default.registered['end']) {
        _scrollEvents2.default.registered['end'](to, target);
      }

      return;
    }

    /*
     * Animate scrolling
     */

    _animateScroll2.default.animateTopScroll(scrollOffset, props, to, target);
  }
};

/***/ }),

/***/ 89765:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = {
  /*
   * https://github.com/oblador/angular-scroll (duScrollDefaultEasing)
   */
  defaultEasing: function defaultEasing(x) {
    if (x < 0.5) {
      return Math.pow(x * 2, 2) / 2;
    }
    return 1 - Math.pow((1 - x) * 2, 2) / 2;
  },
  /*
   * https://gist.github.com/gre/1650294
   */
  // no easing, no acceleration
  linear: function linear(x) {
    return x;
  },
  // accelerating from zero velocity
  easeInQuad: function easeInQuad(x) {
    return x * x;
  },
  // decelerating to zero velocity
  easeOutQuad: function easeOutQuad(x) {
    return x * (2 - x);
  },
  // acceleration until halfway, then deceleration
  easeInOutQuad: function easeInOutQuad(x) {
    return x < .5 ? 2 * x * x : -1 + (4 - 2 * x) * x;
  },
  // accelerating from zero velocity 
  easeInCubic: function easeInCubic(x) {
    return x * x * x;
  },
  // decelerating to zero velocity π
  easeOutCubic: function easeOutCubic(x) {
    return --x * x * x + 1;
  },
  // acceleration until halfway, then deceleration 
  easeInOutCubic: function easeInOutCubic(x) {
    return x < .5 ? 4 * x * x * x : (x - 1) * (2 * x - 2) * (2 * x - 2) + 1;
  },
  // accelerating from zero velocity 
  easeInQuart: function easeInQuart(x) {
    return x * x * x * x;
  },
  // decelerating to zero velocity 
  easeOutQuart: function easeOutQuart(x) {
    return 1 - --x * x * x * x;
  },
  // acceleration until halfway, then deceleration
  easeInOutQuart: function easeInOutQuart(x) {
    return x < .5 ? 8 * x * x * x * x : 1 - 8 * --x * x * x * x;
  },
  // accelerating from zero velocity
  easeInQuint: function easeInQuint(x) {
    return x * x * x * x * x;
  },
  // decelerating to zero velocity
  easeOutQuint: function easeOutQuint(x) {
    return 1 + --x * x * x * x * x;
  },
  // acceleration until halfway, then deceleration 
  easeInOutQuint: function easeInOutQuint(x) {
    return x < .5 ? 16 * x * x * x * x * x : 1 + 16 * --x * x * x * x * x;
  }
};

/***/ }),

/***/ 54259:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
var updateHash = function updateHash(hash, historyUpdate) {
  var hashVal = hash.indexOf("#") === 0 ? hash.substring(1) : hash;
  var hashToUpdate = hashVal ? "#" + hashVal : "";
  var curLoc = window && window.location;
  var urlToPush = hashToUpdate ? curLoc.pathname + curLoc.search + hashToUpdate : curLoc.pathname + curLoc.search;
  historyUpdate ? history.pushState(history.state, "", urlToPush) : history.replaceState(history.state, "", urlToPush);
};

var getHash = function getHash() {
  return window.location.hash.replace(/^#/, "");
};

var filterElementInContainer = function filterElementInContainer(container) {
  return function (element) {
    return container.contains ? container != element && container.contains(element) : !!(container.compareDocumentPosition(element) & 16);
  };
};

var isPositioned = function isPositioned(element) {
  return getComputedStyle(element).position !== "static";
};

var getElementOffsetInfoUntil = function getElementOffsetInfoUntil(element, predicate) {
  var offsetTop = element.offsetTop;
  var currentOffsetParent = element.offsetParent;

  while (currentOffsetParent && !predicate(currentOffsetParent)) {
    offsetTop += currentOffsetParent.offsetTop;
    currentOffsetParent = currentOffsetParent.offsetParent;
  }

  return { offsetTop: offsetTop, offsetParent: currentOffsetParent };
};

var scrollOffset = function scrollOffset(c, t, horizontal) {
  if (horizontal) {
    return c === document ? t.getBoundingClientRect().left + (window.scrollX || window.pageXOffset) : getComputedStyle(c).position !== "static" ? t.offsetLeft : t.offsetLeft - c.offsetLeft;
  } else {
    if (c === document) {
      return t.getBoundingClientRect().top + (window.scrollY || window.pageYOffset);
    }

    // The offsetParent of an element, according to MDN, is its nearest positioned
    // (an element whose position is anything other than static) ancestor. The offsetTop
    // of an element is taken with respect to its offsetParent which may not neccessarily
    // be its parentElement except the parent itself is positioned.

    // So if containerElement is positioned, then it must be an offsetParent somewhere
    // If it happens that targetElement is a descendant of the containerElement, and there
    // is not intermediate positioned element between the two of them, i.e.
    // targetElement"s offsetParent is the same as the containerElement, then the
    // distance between the two will be the offsetTop of the targetElement.
    // If, on the other hand, there are intermediate positioned elements between the
    // two entities, the distance between the targetElement and the containerElement
    // will be the accumulation of the offsetTop of the element and that of its
    // subsequent offsetParent until the containerElement is reached, since it
    // will also be an offsetParent at some point due to the fact that it is positioned.

    // If the containerElement is not positioned, then it can"t be an offsetParent,
    // which means that the offsetTop of the targetElement would not be with respect to it.
    // However, if the two of them happen to have the same offsetParent, then
    // the distance between them will be the difference between their offsetTop
    // since they are both taken with respect to the same entity.
    // The last resort would be to accumulate their offsetTop until a common
    // offsetParent is reached (usually the document) and taking the difference
    // between the accumulated offsetTops

    if (isPositioned(c)) {
      if (t.offsetParent !== c) {
        var isContainerElementOrDocument = function isContainerElementOrDocument(e) {
          return e === c || e === document;
        };

        var _getElementOffsetInfo = getElementOffsetInfoUntil(t, isContainerElementOrDocument),
            offsetTop = _getElementOffsetInfo.offsetTop,
            offsetParent = _getElementOffsetInfo.offsetParent;

        if (offsetParent !== c) {
          throw new Error("Seems containerElement is not an ancestor of the Element");
        }

        return offsetTop;
      }

      return t.offsetTop;
    }

    if (t.offsetParent === c.offsetParent) {
      return t.offsetTop - c.offsetTop;
    }

    var isDocument = function isDocument(e) {
      return e === document;
    };
    return getElementOffsetInfoUntil(t, isDocument).offsetTop - getElementOffsetInfoUntil(c, isDocument).offsetTop;
  }
};

exports["default"] = {
  updateHash: updateHash,
  getHash: getHash,
  filterElementInContainer: filterElementInContainer,
  scrollOffset: scrollOffset
};

/***/ }),

/***/ 8205:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.PrevArrow = exports.NextArrow = void 0;

var _react = _interopRequireDefault(__webpack_require__(67294));

var _classnames = _interopRequireDefault(__webpack_require__(93967));

var _innerSliderUtils = __webpack_require__(15518);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var PrevArrow = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(PrevArrow, _React$PureComponent);

  var _super = _createSuper(PrevArrow);

  function PrevArrow() {
    _classCallCheck(this, PrevArrow);

    return _super.apply(this, arguments);
  }

  _createClass(PrevArrow, [{
    key: "clickHandler",
    value: function clickHandler(options, e) {
      if (e) {
        e.preventDefault();
      }

      this.props.clickHandler(options, e);
    }
  }, {
    key: "render",
    value: function render() {
      var prevClasses = {
        "slick-arrow": true,
        "slick-prev": true
      };
      var prevHandler = this.clickHandler.bind(this, {
        message: "previous"
      });

      if (!this.props.infinite && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.slidesToShow)) {
        prevClasses["slick-disabled"] = true;
        prevHandler = null;
      }

      var prevArrowProps = {
        key: "0",
        "data-role": "none",
        className: (0, _classnames["default"])(prevClasses),
        style: {
          display: "block"
        },
        onClick: prevHandler
      };
      var customProps = {
        currentSlide: this.props.currentSlide,
        slideCount: this.props.slideCount
      };
      var prevArrow;

      if (this.props.prevArrow) {
        prevArrow = /*#__PURE__*/_react["default"].cloneElement(this.props.prevArrow, _objectSpread(_objectSpread({}, prevArrowProps), customProps));
      } else {
        prevArrow = /*#__PURE__*/_react["default"].createElement("button", _extends({
          key: "0",
          type: "button"
        }, prevArrowProps), " ", "Previous");
      }

      return prevArrow;
    }
  }]);

  return PrevArrow;
}(_react["default"].PureComponent);

exports.PrevArrow = PrevArrow;

var NextArrow = /*#__PURE__*/function (_React$PureComponent2) {
  _inherits(NextArrow, _React$PureComponent2);

  var _super2 = _createSuper(NextArrow);

  function NextArrow() {
    _classCallCheck(this, NextArrow);

    return _super2.apply(this, arguments);
  }

  _createClass(NextArrow, [{
    key: "clickHandler",
    value: function clickHandler(options, e) {
      if (e) {
        e.preventDefault();
      }

      this.props.clickHandler(options, e);
    }
  }, {
    key: "render",
    value: function render() {
      var nextClasses = {
        "slick-arrow": true,
        "slick-next": true
      };
      var nextHandler = this.clickHandler.bind(this, {
        message: "next"
      });

      if (!(0, _innerSliderUtils.canGoNext)(this.props)) {
        nextClasses["slick-disabled"] = true;
        nextHandler = null;
      }

      var nextArrowProps = {
        key: "1",
        "data-role": "none",
        className: (0, _classnames["default"])(nextClasses),
        style: {
          display: "block"
        },
        onClick: nextHandler
      };
      var customProps = {
        currentSlide: this.props.currentSlide,
        slideCount: this.props.slideCount
      };
      var nextArrow;

      if (this.props.nextArrow) {
        nextArrow = /*#__PURE__*/_react["default"].cloneElement(this.props.nextArrow, _objectSpread(_objectSpread({}, nextArrowProps), customProps));
      } else {
        nextArrow = /*#__PURE__*/_react["default"].createElement("button", _extends({
          key: "1",
          type: "button"
        }, nextArrowProps), " ", "Next");
      }

      return nextArrow;
    }
  }]);

  return NextArrow;
}(_react["default"].PureComponent);

exports.NextArrow = NextArrow;

/***/ }),

/***/ 23492:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(67294));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var defaultProps = {
  accessibility: true,
  adaptiveHeight: false,
  afterChange: null,
  appendDots: function appendDots(dots) {
    return /*#__PURE__*/_react["default"].createElement("ul", {
      style: {
        display: "block"
      }
    }, dots);
  },
  arrows: true,
  autoplay: false,
  autoplaySpeed: 3000,
  beforeChange: null,
  centerMode: false,
  centerPadding: "50px",
  className: "",
  cssEase: "ease",
  customPaging: function customPaging(i) {
    return /*#__PURE__*/_react["default"].createElement("button", null, i + 1);
  },
  dots: false,
  dotsClass: "slick-dots",
  draggable: true,
  easing: "linear",
  edgeFriction: 0.35,
  fade: false,
  focusOnSelect: false,
  infinite: true,
  initialSlide: 0,
  lazyLoad: null,
  nextArrow: null,
  onEdge: null,
  onInit: null,
  onLazyLoadError: null,
  onReInit: null,
  pauseOnDotsHover: false,
  pauseOnFocus: false,
  pauseOnHover: true,
  prevArrow: null,
  responsive: null,
  rows: 1,
  rtl: false,
  slide: "div",
  slidesPerRow: 1,
  slidesToScroll: 1,
  slidesToShow: 1,
  speed: 500,
  swipe: true,
  swipeEvent: null,
  swipeToSlide: false,
  touchMove: true,
  touchThreshold: 5,
  useCSS: true,
  useTransform: true,
  variableWidth: false,
  vertical: false,
  waitForAnimate: true
};
var _default = defaultProps;
exports["default"] = _default;

/***/ }),

/***/ 16329:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.Dots = void 0;

var _react = _interopRequireDefault(__webpack_require__(67294));

var _classnames = _interopRequireDefault(__webpack_require__(93967));

var _innerSliderUtils = __webpack_require__(15518);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var getDotCount = function getDotCount(spec) {
  var dots;

  if (spec.infinite) {
    dots = Math.ceil(spec.slideCount / spec.slidesToScroll);
  } else {
    dots = Math.ceil((spec.slideCount - spec.slidesToShow) / spec.slidesToScroll) + 1;
  }

  return dots;
};

var Dots = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Dots, _React$PureComponent);

  var _super = _createSuper(Dots);

  function Dots() {
    _classCallCheck(this, Dots);

    return _super.apply(this, arguments);
  }

  _createClass(Dots, [{
    key: "clickHandler",
    value: function clickHandler(options, e) {
      // In Autoplay the focus stays on clicked button even after transition
      // to next slide. That only goes away by click somewhere outside
      e.preventDefault();
      this.props.clickHandler(options);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          onMouseEnter = _this$props.onMouseEnter,
          onMouseOver = _this$props.onMouseOver,
          onMouseLeave = _this$props.onMouseLeave,
          infinite = _this$props.infinite,
          slidesToScroll = _this$props.slidesToScroll,
          slidesToShow = _this$props.slidesToShow,
          slideCount = _this$props.slideCount,
          currentSlide = _this$props.currentSlide;
      var dotCount = getDotCount({
        slideCount: slideCount,
        slidesToScroll: slidesToScroll,
        slidesToShow: slidesToShow,
        infinite: infinite
      });
      var mouseEvents = {
        onMouseEnter: onMouseEnter,
        onMouseOver: onMouseOver,
        onMouseLeave: onMouseLeave
      };
      var dots = [];

      for (var i = 0; i < dotCount; i++) {
        var _rightBound = (i + 1) * slidesToScroll - 1;

        var rightBound = infinite ? _rightBound : (0, _innerSliderUtils.clamp)(_rightBound, 0, slideCount - 1);

        var _leftBound = rightBound - (slidesToScroll - 1);

        var leftBound = infinite ? _leftBound : (0, _innerSliderUtils.clamp)(_leftBound, 0, slideCount - 1);
        var className = (0, _classnames["default"])({
          "slick-active": infinite ? currentSlide >= leftBound && currentSlide <= rightBound : currentSlide === leftBound
        });
        var dotOptions = {
          message: "dots",
          index: i,
          slidesToScroll: slidesToScroll,
          currentSlide: currentSlide
        };
        var onClick = this.clickHandler.bind(this, dotOptions);
        dots = dots.concat( /*#__PURE__*/_react["default"].createElement("li", {
          key: i,
          className: className
        }, /*#__PURE__*/_react["default"].cloneElement(this.props.customPaging(i), {
          onClick: onClick
        })));
      }

      return /*#__PURE__*/_react["default"].cloneElement(this.props.appendDots(dots), _objectSpread({
        className: this.props.dotsClass
      }, mouseEvents));
    }
  }]);

  return Dots;
}(_react["default"].PureComponent);

exports.Dots = Dots;

/***/ }),

/***/ 46066:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var _slider = _interopRequireDefault(__webpack_require__(5798));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = _slider["default"];
exports.Z = _default;

/***/ }),

/***/ 46948:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var initialState = {
  animating: false,
  autoplaying: null,
  currentDirection: 0,
  currentLeft: null,
  currentSlide: 0,
  direction: 1,
  dragging: false,
  edgeDragged: false,
  initialized: false,
  lazyLoadedList: [],
  listHeight: null,
  listWidth: null,
  scrolling: false,
  slideCount: null,
  slideHeight: null,
  slideWidth: null,
  swipeLeft: null,
  swiped: false,
  // used by swipeEvent. differentites between touch and swipe.
  swiping: false,
  touchObject: {
    startX: 0,
    startY: 0,
    curX: 0,
    curY: 0
  },
  trackStyle: {},
  trackWidth: 0,
  targetSlide: 0
};
var _default = initialState;
exports["default"] = _default;

/***/ }),

/***/ 58517:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.InnerSlider = void 0;

var _react = _interopRequireDefault(__webpack_require__(67294));

var _initialState = _interopRequireDefault(__webpack_require__(46948));

var _lodash = _interopRequireDefault(__webpack_require__(91296));

var _classnames = _interopRequireDefault(__webpack_require__(93967));

var _innerSliderUtils = __webpack_require__(15518);

var _track = __webpack_require__(64740);

var _dots = __webpack_require__(16329);

var _arrows = __webpack_require__(8205);

var _resizeObserverPolyfill = _interopRequireDefault(__webpack_require__(91033));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var InnerSlider = /*#__PURE__*/function (_React$Component) {
  _inherits(InnerSlider, _React$Component);

  var _super = _createSuper(InnerSlider);

  function InnerSlider(props) {
    var _this;

    _classCallCheck(this, InnerSlider);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "listRefHandler", function (ref) {
      return _this.list = ref;
    });

    _defineProperty(_assertThisInitialized(_this), "trackRefHandler", function (ref) {
      return _this.track = ref;
    });

    _defineProperty(_assertThisInitialized(_this), "adaptHeight", function () {
      if (_this.props.adaptiveHeight && _this.list) {
        var elem = _this.list.querySelector("[data-index=\"".concat(_this.state.currentSlide, "\"]"));

        _this.list.style.height = (0, _innerSliderUtils.getHeight)(elem) + "px";
      }
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      _this.props.onInit && _this.props.onInit();

      if (_this.props.lazyLoad) {
        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_objectSpread(_objectSpread({}, _this.props), _this.state));

        if (slidesToLoad.length > 0) {
          _this.setState(function (prevState) {
            return {
              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
            };
          });

          if (_this.props.onLazyLoad) {
            _this.props.onLazyLoad(slidesToLoad);
          }
        }
      }

      var spec = _objectSpread({
        listRef: _this.list,
        trackRef: _this.track
      }, _this.props);

      _this.updateState(spec, true, function () {
        _this.adaptHeight();

        _this.props.autoplay && _this.autoPlay("update");
      });

      if (_this.props.lazyLoad === "progressive") {
        _this.lazyLoadTimer = setInterval(_this.progressiveLazyLoad, 1000);
      }

      _this.ro = new _resizeObserverPolyfill["default"](function () {
        if (_this.state.animating) {
          _this.onWindowResized(false); // don't set trackStyle hence don't break animation


          _this.callbackTimers.push(setTimeout(function () {
            return _this.onWindowResized();
          }, _this.props.speed));
        } else {
          _this.onWindowResized();
        }
      });

      _this.ro.observe(_this.list);

      document.querySelectorAll && Array.prototype.forEach.call(document.querySelectorAll(".slick-slide"), function (slide) {
        slide.onfocus = _this.props.pauseOnFocus ? _this.onSlideFocus : null;
        slide.onblur = _this.props.pauseOnFocus ? _this.onSlideBlur : null;
      });

      if (window.addEventListener) {
        window.addEventListener("resize", _this.onWindowResized);
      } else {
        window.attachEvent("onresize", _this.onWindowResized);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      if (_this.animationEndCallback) {
        clearTimeout(_this.animationEndCallback);
      }

      if (_this.lazyLoadTimer) {
        clearInterval(_this.lazyLoadTimer);
      }

      if (_this.callbackTimers.length) {
        _this.callbackTimers.forEach(function (timer) {
          return clearTimeout(timer);
        });

        _this.callbackTimers = [];
      }

      if (window.addEventListener) {
        window.removeEventListener("resize", _this.onWindowResized);
      } else {
        window.detachEvent("onresize", _this.onWindowResized);
      }

      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
      }

      _this.ro.disconnect();
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function (prevProps) {
      _this.checkImagesLoad();

      _this.props.onReInit && _this.props.onReInit();

      if (_this.props.lazyLoad) {
        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_objectSpread(_objectSpread({}, _this.props), _this.state));

        if (slidesToLoad.length > 0) {
          _this.setState(function (prevState) {
            return {
              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
            };
          });

          if (_this.props.onLazyLoad) {
            _this.props.onLazyLoad(slidesToLoad);
          }
        }
      } // if (this.props.onLazyLoad) {
      //   this.props.onLazyLoad([leftMostSlide])
      // }


      _this.adaptHeight();

      var spec = _objectSpread(_objectSpread({
        listRef: _this.list,
        trackRef: _this.track
      }, _this.props), _this.state);

      var setTrackStyle = _this.didPropsChange(prevProps);

      setTrackStyle && _this.updateState(spec, setTrackStyle, function () {
        if (_this.state.currentSlide >= _react["default"].Children.count(_this.props.children)) {
          _this.changeSlide({
            message: "index",
            index: _react["default"].Children.count(_this.props.children) - _this.props.slidesToShow,
            currentSlide: _this.state.currentSlide
          });
        }

        if (_this.props.autoplay) {
          _this.autoPlay("update");
        } else {
          _this.pause("paused");
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onWindowResized", function (setTrackStyle) {
      if (_this.debouncedResize) _this.debouncedResize.cancel();
      _this.debouncedResize = (0, _lodash["default"])(function () {
        return _this.resizeWindow(setTrackStyle);
      }, 50);

      _this.debouncedResize();
    });

    _defineProperty(_assertThisInitialized(_this), "resizeWindow", function () {
      var setTrackStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var isTrackMounted = Boolean(_this.track && _this.track.node); // prevent warning: setting state on unmounted component (server side rendering)

      if (!isTrackMounted) return;

      var spec = _objectSpread(_objectSpread({
        listRef: _this.list,
        trackRef: _this.track
      }, _this.props), _this.state);

      _this.updateState(spec, setTrackStyle, function () {
        if (_this.props.autoplay) _this.autoPlay("update");else _this.pause("paused");
      }); // animating state should be cleared while resizing, otherwise autoplay stops working


      _this.setState({
        animating: false
      });

      clearTimeout(_this.animationEndCallback);
      delete _this.animationEndCallback;
    });

    _defineProperty(_assertThisInitialized(_this), "updateState", function (spec, setTrackStyle, callback) {
      var updatedState = (0, _innerSliderUtils.initializedState)(spec);
      spec = _objectSpread(_objectSpread(_objectSpread({}, spec), updatedState), {}, {
        slideIndex: updatedState.currentSlide
      });
      var targetLeft = (0, _innerSliderUtils.getTrackLeft)(spec);
      spec = _objectSpread(_objectSpread({}, spec), {}, {
        left: targetLeft
      });
      var trackStyle = (0, _innerSliderUtils.getTrackCSS)(spec);

      if (setTrackStyle || _react["default"].Children.count(_this.props.children) !== _react["default"].Children.count(spec.children)) {
        updatedState["trackStyle"] = trackStyle;
      }

      _this.setState(updatedState, callback);
    });

    _defineProperty(_assertThisInitialized(_this), "ssrInit", function () {
      if (_this.props.variableWidth) {
        var _trackWidth = 0,
            _trackLeft = 0;
        var childrenWidths = [];
        var preClones = (0, _innerSliderUtils.getPreClones)(_objectSpread(_objectSpread(_objectSpread({}, _this.props), _this.state), {}, {
          slideCount: _this.props.children.length
        }));
        var postClones = (0, _innerSliderUtils.getPostClones)(_objectSpread(_objectSpread(_objectSpread({}, _this.props), _this.state), {}, {
          slideCount: _this.props.children.length
        }));

        _this.props.children.forEach(function (child) {
          childrenWidths.push(child.props.style.width);
          _trackWidth += child.props.style.width;
        });

        for (var i = 0; i < preClones; i++) {
          _trackLeft += childrenWidths[childrenWidths.length - 1 - i];
          _trackWidth += childrenWidths[childrenWidths.length - 1 - i];
        }

        for (var _i = 0; _i < postClones; _i++) {
          _trackWidth += childrenWidths[_i];
        }

        for (var _i2 = 0; _i2 < _this.state.currentSlide; _i2++) {
          _trackLeft += childrenWidths[_i2];
        }

        var _trackStyle = {
          width: _trackWidth + "px",
          left: -_trackLeft + "px"
        };

        if (_this.props.centerMode) {
          var currentWidth = "".concat(childrenWidths[_this.state.currentSlide], "px");
          _trackStyle.left = "calc(".concat(_trackStyle.left, " + (100% - ").concat(currentWidth, ") / 2 ) ");
        }

        return {
          trackStyle: _trackStyle
        };
      }

      var childrenCount = _react["default"].Children.count(_this.props.children);

      var spec = _objectSpread(_objectSpread(_objectSpread({}, _this.props), _this.state), {}, {
        slideCount: childrenCount
      });

      var slideCount = (0, _innerSliderUtils.getPreClones)(spec) + (0, _innerSliderUtils.getPostClones)(spec) + childrenCount;
      var trackWidth = 100 / _this.props.slidesToShow * slideCount;
      var slideWidth = 100 / slideCount;
      var trackLeft = -slideWidth * ((0, _innerSliderUtils.getPreClones)(spec) + _this.state.currentSlide) * trackWidth / 100;

      if (_this.props.centerMode) {
        trackLeft += (100 - slideWidth * trackWidth / 100) / 2;
      }

      var trackStyle = {
        width: trackWidth + "%",
        left: trackLeft + "%"
      };
      return {
        slideWidth: slideWidth + "%",
        trackStyle: trackStyle
      };
    });

    _defineProperty(_assertThisInitialized(_this), "checkImagesLoad", function () {
      var images = _this.list && _this.list.querySelectorAll && _this.list.querySelectorAll(".slick-slide img") || [];
      var imagesCount = images.length,
          loadedCount = 0;
      Array.prototype.forEach.call(images, function (image) {
        var handler = function handler() {
          return ++loadedCount && loadedCount >= imagesCount && _this.onWindowResized();
        };

        if (!image.onclick) {
          image.onclick = function () {
            return image.parentNode.focus();
          };
        } else {
          var prevClickHandler = image.onclick;

          image.onclick = function () {
            prevClickHandler();
            image.parentNode.focus();
          };
        }

        if (!image.onload) {
          if (_this.props.lazyLoad) {
            image.onload = function () {
              _this.adaptHeight();

              _this.callbackTimers.push(setTimeout(_this.onWindowResized, _this.props.speed));
            };
          } else {
            image.onload = handler;

            image.onerror = function () {
              handler();
              _this.props.onLazyLoadError && _this.props.onLazyLoadError();
            };
          }
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "progressiveLazyLoad", function () {
      var slidesToLoad = [];

      var spec = _objectSpread(_objectSpread({}, _this.props), _this.state);

      for (var index = _this.state.currentSlide; index < _this.state.slideCount + (0, _innerSliderUtils.getPostClones)(spec); index++) {
        if (_this.state.lazyLoadedList.indexOf(index) < 0) {
          slidesToLoad.push(index);
          break;
        }
      }

      for (var _index = _this.state.currentSlide - 1; _index >= -(0, _innerSliderUtils.getPreClones)(spec); _index--) {
        if (_this.state.lazyLoadedList.indexOf(_index) < 0) {
          slidesToLoad.push(_index);
          break;
        }
      }

      if (slidesToLoad.length > 0) {
        _this.setState(function (state) {
          return {
            lazyLoadedList: state.lazyLoadedList.concat(slidesToLoad)
          };
        });

        if (_this.props.onLazyLoad) {
          _this.props.onLazyLoad(slidesToLoad);
        }
      } else {
        if (_this.lazyLoadTimer) {
          clearInterval(_this.lazyLoadTimer);
          delete _this.lazyLoadTimer;
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "slideHandler", function (index) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var _this$props = _this.props,
          asNavFor = _this$props.asNavFor,
          beforeChange = _this$props.beforeChange,
          onLazyLoad = _this$props.onLazyLoad,
          speed = _this$props.speed,
          afterChange = _this$props.afterChange; // capture currentslide before state is updated

      var currentSlide = _this.state.currentSlide;

      var _slideHandler = (0, _innerSliderUtils.slideHandler)(_objectSpread(_objectSpread(_objectSpread({
        index: index
      }, _this.props), _this.state), {}, {
        trackRef: _this.track,
        useCSS: _this.props.useCSS && !dontAnimate
      })),
          state = _slideHandler.state,
          nextState = _slideHandler.nextState;

      if (!state) return;
      beforeChange && beforeChange(currentSlide, state.currentSlide);
      var slidesToLoad = state.lazyLoadedList.filter(function (value) {
        return _this.state.lazyLoadedList.indexOf(value) < 0;
      });
      onLazyLoad && slidesToLoad.length > 0 && onLazyLoad(slidesToLoad);

      if (!_this.props.waitForAnimate && _this.animationEndCallback) {
        clearTimeout(_this.animationEndCallback);
        afterChange && afterChange(currentSlide);
        delete _this.animationEndCallback;
      }

      _this.setState(state, function () {
        // asNavForIndex check is to avoid recursive calls of slideHandler in waitForAnimate=false mode
        if (asNavFor && _this.asNavForIndex !== index) {
          _this.asNavForIndex = index;
          asNavFor.innerSlider.slideHandler(index);
        }

        if (!nextState) return;
        _this.animationEndCallback = setTimeout(function () {
          var animating = nextState.animating,
              firstBatch = _objectWithoutProperties(nextState, ["animating"]);

          _this.setState(firstBatch, function () {
            _this.callbackTimers.push(setTimeout(function () {
              return _this.setState({
                animating: animating
              });
            }, 10));

            afterChange && afterChange(state.currentSlide);
            delete _this.animationEndCallback;
          });
        }, speed);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "changeSlide", function (options) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var spec = _objectSpread(_objectSpread({}, _this.props), _this.state);

      var targetSlide = (0, _innerSliderUtils.changeSlide)(spec, options);
      if (targetSlide !== 0 && !targetSlide) return;

      if (dontAnimate === true) {
        _this.slideHandler(targetSlide, dontAnimate);
      } else {
        _this.slideHandler(targetSlide);
      }

      _this.props.autoplay && _this.autoPlay("update");

      if (_this.props.focusOnSelect) {
        var nodes = _this.list.querySelectorAll(".slick-current");

        nodes[0] && nodes[0].focus();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "clickHandler", function (e) {
      if (_this.clickable === false) {
        e.stopPropagation();
        e.preventDefault();
      }

      _this.clickable = true;
    });

    _defineProperty(_assertThisInitialized(_this), "keyHandler", function (e) {
      var dir = (0, _innerSliderUtils.keyHandler)(e, _this.props.accessibility, _this.props.rtl);
      dir !== "" && _this.changeSlide({
        message: dir
      });
    });

    _defineProperty(_assertThisInitialized(_this), "selectHandler", function (options) {
      _this.changeSlide(options);
    });

    _defineProperty(_assertThisInitialized(_this), "disableBodyScroll", function () {
      var preventDefault = function preventDefault(e) {
        e = e || window.event;
        if (e.preventDefault) e.preventDefault();
        e.returnValue = false;
      };

      window.ontouchmove = preventDefault;
    });

    _defineProperty(_assertThisInitialized(_this), "enableBodyScroll", function () {
      window.ontouchmove = null;
    });

    _defineProperty(_assertThisInitialized(_this), "swipeStart", function (e) {
      if (_this.props.verticalSwiping) {
        _this.disableBodyScroll();
      }

      var state = (0, _innerSliderUtils.swipeStart)(e, _this.props.swipe, _this.props.draggable);
      state !== "" && _this.setState(state);
    });

    _defineProperty(_assertThisInitialized(_this), "swipeMove", function (e) {
      var state = (0, _innerSliderUtils.swipeMove)(e, _objectSpread(_objectSpread(_objectSpread({}, _this.props), _this.state), {}, {
        trackRef: _this.track,
        listRef: _this.list,
        slideIndex: _this.state.currentSlide
      }));
      if (!state) return;

      if (state["swiping"]) {
        _this.clickable = false;
      }

      _this.setState(state);
    });

    _defineProperty(_assertThisInitialized(_this), "swipeEnd", function (e) {
      var state = (0, _innerSliderUtils.swipeEnd)(e, _objectSpread(_objectSpread(_objectSpread({}, _this.props), _this.state), {}, {
        trackRef: _this.track,
        listRef: _this.list,
        slideIndex: _this.state.currentSlide
      }));
      if (!state) return;
      var triggerSlideHandler = state["triggerSlideHandler"];
      delete state["triggerSlideHandler"];

      _this.setState(state);

      if (triggerSlideHandler === undefined) return;

      _this.slideHandler(triggerSlideHandler);

      if (_this.props.verticalSwiping) {
        _this.enableBodyScroll();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "touchEnd", function (e) {
      _this.swipeEnd(e);

      _this.clickable = true;
    });

    _defineProperty(_assertThisInitialized(_this), "slickPrev", function () {
      // this and fellow methods are wrapped in setTimeout
      // to make sure initialize setState has happened before
      // any of such methods are called
      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({
          message: "previous"
        });
      }, 0));
    });

    _defineProperty(_assertThisInitialized(_this), "slickNext", function () {
      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({
          message: "next"
        });
      }, 0));
    });

    _defineProperty(_assertThisInitialized(_this), "slickGoTo", function (slide) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      slide = Number(slide);
      if (isNaN(slide)) return "";

      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({
          message: "index",
          index: slide,
          currentSlide: _this.state.currentSlide
        }, dontAnimate);
      }, 0));
    });

    _defineProperty(_assertThisInitialized(_this), "play", function () {
      var nextIndex;

      if (_this.props.rtl) {
        nextIndex = _this.state.currentSlide - _this.props.slidesToScroll;
      } else {
        if ((0, _innerSliderUtils.canGoNext)(_objectSpread(_objectSpread({}, _this.props), _this.state))) {
          nextIndex = _this.state.currentSlide + _this.props.slidesToScroll;
        } else {
          return false;
        }
      }

      _this.slideHandler(nextIndex);
    });

    _defineProperty(_assertThisInitialized(_this), "autoPlay", function (playType) {
      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
      }

      var autoplaying = _this.state.autoplaying;

      if (playType === "update") {
        if (autoplaying === "hovered" || autoplaying === "focused" || autoplaying === "paused") {
          return;
        }
      } else if (playType === "leave") {
        if (autoplaying === "paused" || autoplaying === "focused") {
          return;
        }
      } else if (playType === "blur") {
        if (autoplaying === "paused" || autoplaying === "hovered") {
          return;
        }
      }

      _this.autoplayTimer = setInterval(_this.play, _this.props.autoplaySpeed + 50);

      _this.setState({
        autoplaying: "playing"
      });
    });

    _defineProperty(_assertThisInitialized(_this), "pause", function (pauseType) {
      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
        _this.autoplayTimer = null;
      }

      var autoplaying = _this.state.autoplaying;

      if (pauseType === "paused") {
        _this.setState({
          autoplaying: "paused"
        });
      } else if (pauseType === "focused") {
        if (autoplaying === "hovered" || autoplaying === "playing") {
          _this.setState({
            autoplaying: "focused"
          });
        }
      } else {
        // pauseType  is 'hovered'
        if (autoplaying === "playing") {
          _this.setState({
            autoplaying: "hovered"
          });
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onDotsOver", function () {
      return _this.props.autoplay && _this.pause("hovered");
    });

    _defineProperty(_assertThisInitialized(_this), "onDotsLeave", function () {
      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
    });

    _defineProperty(_assertThisInitialized(_this), "onTrackOver", function () {
      return _this.props.autoplay && _this.pause("hovered");
    });

    _defineProperty(_assertThisInitialized(_this), "onTrackLeave", function () {
      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
    });

    _defineProperty(_assertThisInitialized(_this), "onSlideFocus", function () {
      return _this.props.autoplay && _this.pause("focused");
    });

    _defineProperty(_assertThisInitialized(_this), "onSlideBlur", function () {
      return _this.props.autoplay && _this.state.autoplaying === "focused" && _this.autoPlay("blur");
    });

    _defineProperty(_assertThisInitialized(_this), "render", function () {
      var className = (0, _classnames["default"])("slick-slider", _this.props.className, {
        "slick-vertical": _this.props.vertical,
        "slick-initialized": true
      });

      var spec = _objectSpread(_objectSpread({}, _this.props), _this.state);

      var trackProps = (0, _innerSliderUtils.extractObject)(spec, ["fade", "cssEase", "speed", "infinite", "centerMode", "focusOnSelect", "currentSlide", "lazyLoad", "lazyLoadedList", "rtl", "slideWidth", "slideHeight", "listHeight", "vertical", "slidesToShow", "slidesToScroll", "slideCount", "trackStyle", "variableWidth", "unslick", "centerPadding", "targetSlide", "useCSS"]);
      var pauseOnHover = _this.props.pauseOnHover;
      trackProps = _objectSpread(_objectSpread({}, trackProps), {}, {
        onMouseEnter: pauseOnHover ? _this.onTrackOver : null,
        onMouseLeave: pauseOnHover ? _this.onTrackLeave : null,
        onMouseOver: pauseOnHover ? _this.onTrackOver : null,
        focusOnSelect: _this.props.focusOnSelect && _this.clickable ? _this.selectHandler : null
      });
      var dots;

      if (_this.props.dots === true && _this.state.slideCount >= _this.props.slidesToShow) {
        var dotProps = (0, _innerSliderUtils.extractObject)(spec, ["dotsClass", "slideCount", "slidesToShow", "currentSlide", "slidesToScroll", "clickHandler", "children", "customPaging", "infinite", "appendDots"]);
        var pauseOnDotsHover = _this.props.pauseOnDotsHover;
        dotProps = _objectSpread(_objectSpread({}, dotProps), {}, {
          clickHandler: _this.changeSlide,
          onMouseEnter: pauseOnDotsHover ? _this.onDotsLeave : null,
          onMouseOver: pauseOnDotsHover ? _this.onDotsOver : null,
          onMouseLeave: pauseOnDotsHover ? _this.onDotsLeave : null
        });
        dots = /*#__PURE__*/_react["default"].createElement(_dots.Dots, dotProps);
      }

      var prevArrow, nextArrow;
      var arrowProps = (0, _innerSliderUtils.extractObject)(spec, ["infinite", "centerMode", "currentSlide", "slideCount", "slidesToShow", "prevArrow", "nextArrow"]);
      arrowProps.clickHandler = _this.changeSlide;

      if (_this.props.arrows) {
        prevArrow = /*#__PURE__*/_react["default"].createElement(_arrows.PrevArrow, arrowProps);
        nextArrow = /*#__PURE__*/_react["default"].createElement(_arrows.NextArrow, arrowProps);
      }

      var verticalHeightStyle = null;

      if (_this.props.vertical) {
        verticalHeightStyle = {
          height: _this.state.listHeight
        };
      }

      var centerPaddingStyle = null;

      if (_this.props.vertical === false) {
        if (_this.props.centerMode === true) {
          centerPaddingStyle = {
            padding: "0px " + _this.props.centerPadding
          };
        }
      } else {
        if (_this.props.centerMode === true) {
          centerPaddingStyle = {
            padding: _this.props.centerPadding + " 0px"
          };
        }
      }

      var listStyle = _objectSpread(_objectSpread({}, verticalHeightStyle), centerPaddingStyle);

      var touchMove = _this.props.touchMove;
      var listProps = {
        className: "slick-list",
        style: listStyle,
        onClick: _this.clickHandler,
        onMouseDown: touchMove ? _this.swipeStart : null,
        onMouseMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
        onMouseUp: touchMove ? _this.swipeEnd : null,
        onMouseLeave: _this.state.dragging && touchMove ? _this.swipeEnd : null,
        onTouchStart: touchMove ? _this.swipeStart : null,
        onTouchMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
        onTouchEnd: touchMove ? _this.touchEnd : null,
        onTouchCancel: _this.state.dragging && touchMove ? _this.swipeEnd : null,
        onKeyDown: _this.props.accessibility ? _this.keyHandler : null
      };
      var innerSliderProps = {
        className: className,
        dir: "ltr",
        style: _this.props.style
      };

      if (_this.props.unslick) {
        listProps = {
          className: "slick-list"
        };
        innerSliderProps = {
          className: className
        };
      }

      return /*#__PURE__*/_react["default"].createElement("div", innerSliderProps, !_this.props.unslick ? prevArrow : "", /*#__PURE__*/_react["default"].createElement("div", _extends({
        ref: _this.listRefHandler
      }, listProps), /*#__PURE__*/_react["default"].createElement(_track.Track, _extends({
        ref: _this.trackRefHandler
      }, trackProps), _this.props.children)), !_this.props.unslick ? nextArrow : "", !_this.props.unslick ? dots : "");
    });

    _this.list = null;
    _this.track = null;
    _this.state = _objectSpread(_objectSpread({}, _initialState["default"]), {}, {
      currentSlide: _this.props.initialSlide,
      slideCount: _react["default"].Children.count(_this.props.children)
    });
    _this.callbackTimers = [];
    _this.clickable = true;
    _this.debouncedResize = null;

    var ssrState = _this.ssrInit();

    _this.state = _objectSpread(_objectSpread({}, _this.state), ssrState);
    return _this;
  }

  _createClass(InnerSlider, [{
    key: "didPropsChange",
    value: function didPropsChange(prevProps) {
      var setTrackStyle = false;

      for (var _i3 = 0, _Object$keys = Object.keys(this.props); _i3 < _Object$keys.length; _i3++) {
        var key = _Object$keys[_i3];

        if (!prevProps.hasOwnProperty(key)) {
          setTrackStyle = true;
          break;
        }

        if (_typeof(prevProps[key]) === "object" || typeof prevProps[key] === "function") {
          continue;
        }

        if (prevProps[key] !== this.props[key]) {
          setTrackStyle = true;
          break;
        }
      }

      return setTrackStyle || _react["default"].Children.count(this.props.children) !== _react["default"].Children.count(prevProps.children);
    }
  }]);

  return InnerSlider;
}(_react["default"].Component);

exports.InnerSlider = InnerSlider;

/***/ }),

/***/ 5798:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(67294));

var _innerSlider = __webpack_require__(58517);

var _json2mq = _interopRequireDefault(__webpack_require__(80973));

var _defaultProps = _interopRequireDefault(__webpack_require__(23492));

var _innerSliderUtils = __webpack_require__(15518);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var enquire = (0, _innerSliderUtils.canUseDOM)() && __webpack_require__(24974);

var Slider = /*#__PURE__*/function (_React$Component) {
  _inherits(Slider, _React$Component);

  var _super = _createSuper(Slider);

  function Slider(props) {
    var _this;

    _classCallCheck(this, Slider);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "innerSliderRefHandler", function (ref) {
      return _this.innerSlider = ref;
    });

    _defineProperty(_assertThisInitialized(_this), "slickPrev", function () {
      return _this.innerSlider.slickPrev();
    });

    _defineProperty(_assertThisInitialized(_this), "slickNext", function () {
      return _this.innerSlider.slickNext();
    });

    _defineProperty(_assertThisInitialized(_this), "slickGoTo", function (slide) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return _this.innerSlider.slickGoTo(slide, dontAnimate);
    });

    _defineProperty(_assertThisInitialized(_this), "slickPause", function () {
      return _this.innerSlider.pause("paused");
    });

    _defineProperty(_assertThisInitialized(_this), "slickPlay", function () {
      return _this.innerSlider.autoPlay("play");
    });

    _this.state = {
      breakpoint: null
    };
    _this._responsiveMediaHandlers = [];
    return _this;
  }

  _createClass(Slider, [{
    key: "media",
    value: function media(query, handler) {
      // javascript handler for  css media query
      enquire.register(query, handler);

      this._responsiveMediaHandlers.push({
        query: query,
        handler: handler
      });
    } // handles responsive breakpoints

  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      // performance monitoring
      //if (process.env.NODE_ENV !== 'production') {
      //const { whyDidYouUpdate } = require('why-did-you-update')
      //whyDidYouUpdate(React)
      //}
      if (this.props.responsive) {
        var breakpoints = this.props.responsive.map(function (breakpt) {
          return breakpt.breakpoint;
        }); // sort them in increasing order of their numerical value

        breakpoints.sort(function (x, y) {
          return x - y;
        });
        breakpoints.forEach(function (breakpoint, index) {
          // media query for each breakpoint
          var bQuery;

          if (index === 0) {
            bQuery = (0, _json2mq["default"])({
              minWidth: 0,
              maxWidth: breakpoint
            });
          } else {
            bQuery = (0, _json2mq["default"])({
              minWidth: breakpoints[index - 1] + 1,
              maxWidth: breakpoint
            });
          } // when not using server side rendering


          (0, _innerSliderUtils.canUseDOM)() && _this2.media(bQuery, function () {
            _this2.setState({
              breakpoint: breakpoint
            });
          });
        }); // Register media query for full screen. Need to support resize from small to large
        // convert javascript object to media query string

        var query = (0, _json2mq["default"])({
          minWidth: breakpoints.slice(-1)[0]
        });
        (0, _innerSliderUtils.canUseDOM)() && this.media(query, function () {
          _this2.setState({
            breakpoint: null
          });
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._responsiveMediaHandlers.forEach(function (obj) {
        enquire.unregister(obj.query, obj.handler);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var settings;
      var newProps;

      if (this.state.breakpoint) {
        newProps = this.props.responsive.filter(function (resp) {
          return resp.breakpoint === _this3.state.breakpoint;
        });
        settings = newProps[0].settings === "unslick" ? "unslick" : _objectSpread(_objectSpread(_objectSpread({}, _defaultProps["default"]), this.props), newProps[0].settings);
      } else {
        settings = _objectSpread(_objectSpread({}, _defaultProps["default"]), this.props);
      } // force scrolling by one if centerMode is on


      if (settings.centerMode) {
        if (settings.slidesToScroll > 1 && "production" !== "production") {}

        settings.slidesToScroll = 1;
      } // force showing one slide and scrolling by one if the fade mode is on


      if (settings.fade) {
        if (settings.slidesToShow > 1 && "production" !== "production") {}

        if (settings.slidesToScroll > 1 && "production" !== "production") {}

        settings.slidesToShow = 1;
        settings.slidesToScroll = 1;
      } // makes sure that children is an array, even when there is only 1 child


      var children = _react["default"].Children.toArray(this.props.children); // Children may contain false or null, so we should filter them
      // children may also contain string filled with spaces (in certain cases where we use jsx strings)


      children = children.filter(function (child) {
        if (typeof child === "string") {
          return !!child.trim();
        }

        return !!child;
      }); // rows and slidesPerRow logic is handled here

      if (settings.variableWidth && (settings.rows > 1 || settings.slidesPerRow > 1)) {
        console.warn("variableWidth is not supported in case of rows > 1 or slidesPerRow > 1");
        settings.variableWidth = false;
      }

      var newChildren = [];
      var currentWidth = null;

      for (var i = 0; i < children.length; i += settings.rows * settings.slidesPerRow) {
        var newSlide = [];

        for (var j = i; j < i + settings.rows * settings.slidesPerRow; j += settings.slidesPerRow) {
          var row = [];

          for (var k = j; k < j + settings.slidesPerRow; k += 1) {
            if (settings.variableWidth && children[k].props.style) {
              currentWidth = children[k].props.style.width;
            }

            if (k >= children.length) break;
            row.push( /*#__PURE__*/_react["default"].cloneElement(children[k], {
              key: 100 * i + 10 * j + k,
              tabIndex: -1,
              style: {
                width: "".concat(100 / settings.slidesPerRow, "%"),
                display: "inline-block"
              }
            }));
          }

          newSlide.push( /*#__PURE__*/_react["default"].createElement("div", {
            key: 10 * i + j
          }, row));
        }

        if (settings.variableWidth) {
          newChildren.push( /*#__PURE__*/_react["default"].createElement("div", {
            key: i,
            style: {
              width: currentWidth
            }
          }, newSlide));
        } else {
          newChildren.push( /*#__PURE__*/_react["default"].createElement("div", {
            key: i
          }, newSlide));
        }
      }

      if (settings === "unslick") {
        var className = "regular slider " + (this.props.className || "");
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: className
        }, children);
      } else if (newChildren.length <= settings.slidesToShow) {
        settings.unslick = true;
      }

      return /*#__PURE__*/_react["default"].createElement(_innerSlider.InnerSlider, _extends({
        style: this.props.style,
        ref: this.innerSliderRefHandler
      }, settings), newChildren);
    }
  }]);

  return Slider;
}(_react["default"].Component);

exports["default"] = Slider;

/***/ }),

/***/ 64740:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.Track = void 0;

var _react = _interopRequireDefault(__webpack_require__(67294));

var _classnames = _interopRequireDefault(__webpack_require__(93967));

var _innerSliderUtils = __webpack_require__(15518);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// given specifications/props for a slide, fetch all the classes that need to be applied to the slide
var getSlideClasses = function getSlideClasses(spec) {
  var slickActive, slickCenter, slickCloned;
  var centerOffset, index;

  if (spec.rtl) {
    index = spec.slideCount - 1 - spec.index;
  } else {
    index = spec.index;
  }

  slickCloned = index < 0 || index >= spec.slideCount;

  if (spec.centerMode) {
    centerOffset = Math.floor(spec.slidesToShow / 2);
    slickCenter = (index - spec.currentSlide) % spec.slideCount === 0;

    if (index > spec.currentSlide - centerOffset - 1 && index <= spec.currentSlide + centerOffset) {
      slickActive = true;
    }
  } else {
    slickActive = spec.currentSlide <= index && index < spec.currentSlide + spec.slidesToShow;
  }

  var focusedSlide;

  if (spec.targetSlide < 0) {
    focusedSlide = spec.targetSlide + spec.slideCount;
  } else if (spec.targetSlide >= spec.slideCount) {
    focusedSlide = spec.targetSlide - spec.slideCount;
  } else {
    focusedSlide = spec.targetSlide;
  }

  var slickCurrent = index === focusedSlide;
  return {
    "slick-slide cmp-carousel-slick__item": true,
    "slick-active cmp-carousel-slick__item--active": slickActive,
    "slick-center": slickCenter,
    "slick-cloned": slickCloned,
    "slick-current": slickCurrent // dubious in case of RTL

  };
};

var getSlideStyle = function getSlideStyle(spec) {
  var style = {};

  if (spec.variableWidth === undefined || spec.variableWidth === false) {
    style.width = spec.slideWidth;
  }

  if (spec.fade) {
    style.position = "relative";

    if (spec.vertical) {
      style.top = -spec.index * parseInt(spec.slideHeight);
    } else {
      style.left = -spec.index * parseInt(spec.slideWidth);
    }

    style.opacity = spec.currentSlide === spec.index ? 1 : 0;

    if (spec.useCSS) {
      style.transition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
    }
  }

  return style;
};

var getKey = function getKey(child, fallbackKey) {
  return child.key || fallbackKey;
};

var renderSlides = function renderSlides(spec) {
  var key;
  var slides = [];
  var preCloneSlides = [];
  var postCloneSlides = [];

  var childrenCount = _react["default"].Children.count(spec.children);

  var startIndex = (0, _innerSliderUtils.lazyStartIndex)(spec);
  var endIndex = (0, _innerSliderUtils.lazyEndIndex)(spec);

  _react["default"].Children.forEach(spec.children, function (elem, index) {
    var child;
    var childOnClickOptions = {
      message: "children",
      index: index,
      slidesToScroll: spec.slidesToScroll,
      currentSlide: spec.currentSlide
    }; // in case of lazyLoad, whether or not we want to fetch the slide

    if (!spec.lazyLoad || spec.lazyLoad && spec.lazyLoadedList.indexOf(index) >= 0) {
      child = elem;
    } else {
      child = /*#__PURE__*/_react["default"].createElement("div", null);
    }

    var childStyle = getSlideStyle(_objectSpread(_objectSpread({}, spec), {}, {
      index: index
    }));
    var slideClass = child.props.className || "";
    var slideClasses = getSlideClasses(_objectSpread(_objectSpread({}, spec), {}, {
      index: index
    })); // push a cloned element of the desired slide

    slides.push( /*#__PURE__*/_react["default"].cloneElement(child, {
      key: "original" + getKey(child, index),
      "data-index": index,
      className: (0, _classnames["default"])(slideClasses, slideClass),
      tabIndex: "-1",
      "aria-hidden": !slideClasses["slick-active"],
      style: _objectSpread(_objectSpread({
        outline: "none"
      }, child.props.style || {}), childStyle),
      onClick: function onClick(e) {
        child.props && child.props.onClick && child.props.onClick(e);

        if (spec.focusOnSelect) {
          spec.focusOnSelect(childOnClickOptions);
        }
      }
    })); // if slide needs to be precloned or postcloned

    if (spec.infinite && spec.fade === false) {
      var preCloneNo = childrenCount - index;

      if (preCloneNo <= (0, _innerSliderUtils.getPreClones)(spec) && childrenCount !== spec.slidesToShow) {
        key = -preCloneNo;

        if (key >= startIndex) {
          child = elem;
        }

        slideClasses = getSlideClasses(_objectSpread(_objectSpread({}, spec), {}, {
          index: key
        }));
        preCloneSlides.push( /*#__PURE__*/_react["default"].cloneElement(child, {
          key: "precloned" + getKey(child, key),
          "data-index": key,
          tabIndex: "-1",
          className: (0, _classnames["default"])(slideClasses, slideClass),
          "aria-hidden": !slideClasses["slick-active"],
          style: _objectSpread(_objectSpread({}, child.props.style || {}), childStyle),
          onClick: function onClick(e) {
            child.props && child.props.onClick && child.props.onClick(e);

            if (spec.focusOnSelect) {
              spec.focusOnSelect(childOnClickOptions);
            }
          }
        }));
      }

      if (childrenCount !== spec.slidesToShow) {
        key = childrenCount + index;

        if (key < endIndex) {
          child = elem;
        }

        slideClasses = getSlideClasses(_objectSpread(_objectSpread({}, spec), {}, {
          index: key
        }));
        postCloneSlides.push( /*#__PURE__*/_react["default"].cloneElement(child, {
          key: "postcloned" + getKey(child, key),
          "data-index": key,
          tabIndex: "-1",
          className: (0, _classnames["default"])(slideClasses, slideClass),
          "aria-hidden": !slideClasses["slick-active"],
          style: _objectSpread(_objectSpread({}, child.props.style || {}), childStyle),
          onClick: function onClick(e) {
            child.props && child.props.onClick && child.props.onClick(e);

            if (spec.focusOnSelect) {
              spec.focusOnSelect(childOnClickOptions);
            }
          }
        }));
      }
    }
  });

  if (spec.rtl) {
    return preCloneSlides.concat(slides, postCloneSlides).reverse();
  } else {
    return preCloneSlides.concat(slides, postCloneSlides);
  }
};

var Track = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Track, _React$PureComponent);

  var _super = _createSuper(Track);

  function Track() {
    var _this;

    _classCallCheck(this, Track);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "node", null);

    _defineProperty(_assertThisInitialized(_this), "handleRef", function (ref) {
      _this.node = ref;
    });

    return _this;
  }

  _createClass(Track, [{
    key: "render",
    value: function render() {
      var slides = renderSlides(this.props);
      var _this$props = this.props,
          onMouseEnter = _this$props.onMouseEnter,
          onMouseOver = _this$props.onMouseOver,
          onMouseLeave = _this$props.onMouseLeave;
      var mouseEvents = {
        onMouseEnter: onMouseEnter,
        onMouseOver: onMouseOver,
        onMouseLeave: onMouseLeave
      };
      return /*#__PURE__*/_react["default"].createElement("div", _extends({
        ref: this.handleRef,
        className: "slick-track",
        style: this.props.trackStyle
      }, mouseEvents), slides);
    }
  }]);

  return Track;
}(_react["default"].PureComponent);

exports.Track = Track;

/***/ }),

/***/ 15518:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.checkSpecKeys = exports.checkNavigable = exports.changeSlide = exports.canUseDOM = exports.canGoNext = void 0;
exports.clamp = clamp;
exports.swipeStart = exports.swipeMove = exports.swipeEnd = exports.slidesOnRight = exports.slidesOnLeft = exports.slideHandler = exports.siblingDirection = exports.safePreventDefault = exports.lazyStartIndex = exports.lazySlidesOnRight = exports.lazySlidesOnLeft = exports.lazyEndIndex = exports.keyHandler = exports.initializedState = exports.getWidth = exports.getTrackLeft = exports.getTrackCSS = exports.getTrackAnimateCSS = exports.getTotalSlides = exports.getSwipeDirection = exports.getSlideCount = exports.getRequiredLazySlides = exports.getPreClones = exports.getPostClones = exports.getOnDemandLazySlides = exports.getNavigableIndexes = exports.getHeight = exports.extractObject = void 0;

var _react = _interopRequireDefault(__webpack_require__(67294));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function clamp(number, lowerBound, upperBound) {
  return Math.max(lowerBound, Math.min(number, upperBound));
}

var safePreventDefault = function safePreventDefault(event) {
  var passiveEvents = ["onTouchStart", "onTouchMove", "onWheel"];

  if (!passiveEvents.includes(event._reactName)) {
    event.preventDefault();
  }
};

exports.safePreventDefault = safePreventDefault;

var getOnDemandLazySlides = function getOnDemandLazySlides(spec) {
  var onDemandSlides = [];
  var startIndex = lazyStartIndex(spec);
  var endIndex = lazyEndIndex(spec);

  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
    if (spec.lazyLoadedList.indexOf(slideIndex) < 0) {
      onDemandSlides.push(slideIndex);
    }
  }

  return onDemandSlides;
}; // return list of slides that need to be present


exports.getOnDemandLazySlides = getOnDemandLazySlides;

var getRequiredLazySlides = function getRequiredLazySlides(spec) {
  var requiredSlides = [];
  var startIndex = lazyStartIndex(spec);
  var endIndex = lazyEndIndex(spec);

  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
    requiredSlides.push(slideIndex);
  }

  return requiredSlides;
}; // startIndex that needs to be present


exports.getRequiredLazySlides = getRequiredLazySlides;

var lazyStartIndex = function lazyStartIndex(spec) {
  return spec.currentSlide - lazySlidesOnLeft(spec);
};

exports.lazyStartIndex = lazyStartIndex;

var lazyEndIndex = function lazyEndIndex(spec) {
  return spec.currentSlide + lazySlidesOnRight(spec);
};

exports.lazyEndIndex = lazyEndIndex;

var lazySlidesOnLeft = function lazySlidesOnLeft(spec) {
  return spec.centerMode ? Math.floor(spec.slidesToShow / 2) + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : 0;
};

exports.lazySlidesOnLeft = lazySlidesOnLeft;

var lazySlidesOnRight = function lazySlidesOnRight(spec) {
  return spec.centerMode ? Math.floor((spec.slidesToShow - 1) / 2) + 1 + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : spec.slidesToShow;
}; // get width of an element


exports.lazySlidesOnRight = lazySlidesOnRight;

var getWidth = function getWidth(elem) {
  return elem && elem.offsetWidth || 0;
};

exports.getWidth = getWidth;

var getHeight = function getHeight(elem) {
  return elem && elem.offsetHeight || 0;
};

exports.getHeight = getHeight;

var getSwipeDirection = function getSwipeDirection(touchObject) {
  var verticalSwiping = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var xDist, yDist, r, swipeAngle;
  xDist = touchObject.startX - touchObject.curX;
  yDist = touchObject.startY - touchObject.curY;
  r = Math.atan2(yDist, xDist);
  swipeAngle = Math.round(r * 180 / Math.PI);

  if (swipeAngle < 0) {
    swipeAngle = 360 - Math.abs(swipeAngle);
  }

  if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) {
    return "left";
  }

  if (swipeAngle >= 135 && swipeAngle <= 225) {
    return "right";
  }

  if (verticalSwiping === true) {
    if (swipeAngle >= 35 && swipeAngle <= 135) {
      return "up";
    } else {
      return "down";
    }
  }

  return "vertical";
}; // whether or not we can go next


exports.getSwipeDirection = getSwipeDirection;

var canGoNext = function canGoNext(spec) {
  var canGo = true;

  if (!spec.infinite) {
    if (spec.centerMode && spec.currentSlide >= spec.slideCount - 1) {
      canGo = false;
    } else if (spec.slideCount <= spec.slidesToShow || spec.currentSlide >= spec.slideCount - spec.slidesToShow) {
      canGo = false;
    }
  }

  return canGo;
}; // given an object and a list of keys, return new object with given keys


exports.canGoNext = canGoNext;

var extractObject = function extractObject(spec, keys) {
  var newObject = {};
  keys.forEach(function (key) {
    return newObject[key] = spec[key];
  });
  return newObject;
}; // get initialized state


exports.extractObject = extractObject;

var initializedState = function initializedState(spec) {
  // spec also contains listRef, trackRef
  var slideCount = _react["default"].Children.count(spec.children);

  var listNode = spec.listRef;
  var listWidth = Math.ceil(getWidth(listNode));
  var trackNode = spec.trackRef && spec.trackRef.node;
  var trackWidth = Math.ceil(getWidth(trackNode));
  var slideWidth;

  if (!spec.vertical) {
    var centerPaddingAdj = spec.centerMode && parseInt(spec.centerPadding) * 2;

    if (typeof spec.centerPadding === "string" && spec.centerPadding.slice(-1) === "%") {
      centerPaddingAdj *= listWidth / 100;
    }

    slideWidth = Math.ceil((listWidth - centerPaddingAdj) / spec.slidesToShow);
  } else {
    slideWidth = listWidth;
  }

  var slideHeight = listNode && getHeight(listNode.querySelector('[data-index="0"]'));
  var listHeight = slideHeight * spec.slidesToShow;
  var currentSlide = spec.currentSlide === undefined ? spec.initialSlide : spec.currentSlide;

  if (spec.rtl && spec.currentSlide === undefined) {
    currentSlide = slideCount - 1 - spec.initialSlide;
  }

  var lazyLoadedList = spec.lazyLoadedList || [];
  var slidesToLoad = getOnDemandLazySlides(_objectSpread(_objectSpread({}, spec), {}, {
    currentSlide: currentSlide,
    lazyLoadedList: lazyLoadedList
  }));
  lazyLoadedList = lazyLoadedList.concat(slidesToLoad);
  var state = {
    slideCount: slideCount,
    slideWidth: slideWidth,
    listWidth: listWidth,
    trackWidth: trackWidth,
    currentSlide: currentSlide,
    slideHeight: slideHeight,
    listHeight: listHeight,
    lazyLoadedList: lazyLoadedList
  };

  if (spec.autoplaying === null && spec.autoplay) {
    state["autoplaying"] = "playing";
  }

  return state;
};

exports.initializedState = initializedState;

var slideHandler = function slideHandler(spec) {
  var waitForAnimate = spec.waitForAnimate,
      animating = spec.animating,
      fade = spec.fade,
      infinite = spec.infinite,
      index = spec.index,
      slideCount = spec.slideCount,
      lazyLoad = spec.lazyLoad,
      currentSlide = spec.currentSlide,
      centerMode = spec.centerMode,
      slidesToScroll = spec.slidesToScroll,
      slidesToShow = spec.slidesToShow,
      useCSS = spec.useCSS;
  var lazyLoadedList = spec.lazyLoadedList;
  if (waitForAnimate && animating) return {};
  var animationSlide = index,
      finalSlide,
      animationLeft,
      finalLeft;
  var state = {},
      nextState = {};
  var targetSlide = infinite ? index : clamp(index, 0, slideCount - 1);

  if (fade) {
    if (!infinite && (index < 0 || index >= slideCount)) return {};

    if (index < 0) {
      animationSlide = index + slideCount;
    } else if (index >= slideCount) {
      animationSlide = index - slideCount;
    }

    if (lazyLoad && lazyLoadedList.indexOf(animationSlide) < 0) {
      lazyLoadedList = lazyLoadedList.concat(animationSlide);
    }

    state = {
      animating: true,
      currentSlide: animationSlide,
      lazyLoadedList: lazyLoadedList,
      targetSlide: animationSlide
    };
    nextState = {
      animating: false,
      targetSlide: animationSlide
    };
  } else {
    finalSlide = animationSlide;

    if (animationSlide < 0) {
      finalSlide = animationSlide + slideCount;
      if (!infinite) finalSlide = 0;else if (slideCount % slidesToScroll !== 0) finalSlide = slideCount - slideCount % slidesToScroll;
    } else if (!canGoNext(spec) && animationSlide > currentSlide) {
      animationSlide = finalSlide = currentSlide;
    } else if (centerMode && animationSlide >= slideCount) {
      animationSlide = infinite ? slideCount : slideCount - 1;
      finalSlide = infinite ? 0 : slideCount - 1;
    } else if (animationSlide >= slideCount) {
      finalSlide = animationSlide - slideCount;
      if (!infinite) finalSlide = slideCount - slidesToShow;else if (slideCount % slidesToScroll !== 0) finalSlide = 0;
    }

    if (!infinite && animationSlide + slidesToShow >= slideCount) {
      finalSlide = slideCount - slidesToShow;
    }

    animationLeft = getTrackLeft(_objectSpread(_objectSpread({}, spec), {}, {
      slideIndex: animationSlide
    }));
    finalLeft = getTrackLeft(_objectSpread(_objectSpread({}, spec), {}, {
      slideIndex: finalSlide
    }));

    if (!infinite) {
      if (animationLeft === finalLeft) animationSlide = finalSlide;
      animationLeft = finalLeft;
    }

    if (lazyLoad) {
      lazyLoadedList = lazyLoadedList.concat(getOnDemandLazySlides(_objectSpread(_objectSpread({}, spec), {}, {
        currentSlide: animationSlide
      })));
    }

    if (!useCSS) {
      state = {
        currentSlide: finalSlide,
        trackStyle: getTrackCSS(_objectSpread(_objectSpread({}, spec), {}, {
          left: finalLeft
        })),
        lazyLoadedList: lazyLoadedList,
        targetSlide: targetSlide
      };
    } else {
      state = {
        animating: true,
        currentSlide: finalSlide,
        trackStyle: getTrackAnimateCSS(_objectSpread(_objectSpread({}, spec), {}, {
          left: animationLeft
        })),
        lazyLoadedList: lazyLoadedList,
        targetSlide: targetSlide
      };
      nextState = {
        animating: false,
        currentSlide: finalSlide,
        trackStyle: getTrackCSS(_objectSpread(_objectSpread({}, spec), {}, {
          left: finalLeft
        })),
        swipeLeft: null,
        targetSlide: targetSlide
      };
    }
  }

  return {
    state: state,
    nextState: nextState
  };
};

exports.slideHandler = slideHandler;

var changeSlide = function changeSlide(spec, options) {
  var indexOffset, previousInt, slideOffset, unevenOffset, targetSlide;
  var slidesToScroll = spec.slidesToScroll,
      slidesToShow = spec.slidesToShow,
      slideCount = spec.slideCount,
      currentSlide = spec.currentSlide,
      previousTargetSlide = spec.targetSlide,
      lazyLoad = spec.lazyLoad,
      infinite = spec.infinite;
  unevenOffset = slideCount % slidesToScroll !== 0;
  indexOffset = unevenOffset ? 0 : (slideCount - currentSlide) % slidesToScroll;

  if (options.message === "previous") {
    slideOffset = indexOffset === 0 ? slidesToScroll : slidesToShow - indexOffset;
    targetSlide = currentSlide - slideOffset;

    if (lazyLoad && !infinite) {
      previousInt = currentSlide - slideOffset;
      targetSlide = previousInt === -1 ? slideCount - 1 : previousInt;
    }

    if (!infinite) {
      targetSlide = previousTargetSlide - slidesToScroll;
    }
  } else if (options.message === "next") {
    slideOffset = indexOffset === 0 ? slidesToScroll : indexOffset;
    targetSlide = currentSlide + slideOffset;

    if (lazyLoad && !infinite) {
      targetSlide = (currentSlide + slidesToScroll) % slideCount + indexOffset;
    }

    if (!infinite) {
      targetSlide = previousTargetSlide + slidesToScroll;
    }
  } else if (options.message === "dots") {
    // Click on dots
    targetSlide = options.index * options.slidesToScroll;
  } else if (options.message === "children") {
    // Click on the slides
    targetSlide = options.index;

    if (infinite) {
      var direction = siblingDirection(_objectSpread(_objectSpread({}, spec), {}, {
        targetSlide: targetSlide
      }));

      if (targetSlide > options.currentSlide && direction === "left") {
        targetSlide = targetSlide - slideCount;
      } else if (targetSlide < options.currentSlide && direction === "right") {
        targetSlide = targetSlide + slideCount;
      }
    }
  } else if (options.message === "index") {
    targetSlide = Number(options.index);
  }

  return targetSlide;
};

exports.changeSlide = changeSlide;

var keyHandler = function keyHandler(e, accessibility, rtl) {
  if (e.target.tagName.match("TEXTAREA|INPUT|SELECT") || !accessibility) return "";
  if (e.keyCode === 37) return rtl ? "next" : "previous";
  if (e.keyCode === 39) return rtl ? "previous" : "next";
  return "";
};

exports.keyHandler = keyHandler;

var swipeStart = function swipeStart(e, swipe, draggable) {
  e.target.tagName === "IMG" && safePreventDefault(e);
  if (!swipe || !draggable && e.type.indexOf("mouse") !== -1) return "";
  return {
    dragging: true,
    touchObject: {
      startX: e.touches ? e.touches[0].pageX : e.clientX,
      startY: e.touches ? e.touches[0].pageY : e.clientY,
      curX: e.touches ? e.touches[0].pageX : e.clientX,
      curY: e.touches ? e.touches[0].pageY : e.clientY
    }
  };
};

exports.swipeStart = swipeStart;

var swipeMove = function swipeMove(e, spec) {
  // spec also contains, trackRef and slideIndex
  var scrolling = spec.scrolling,
      animating = spec.animating,
      vertical = spec.vertical,
      swipeToSlide = spec.swipeToSlide,
      verticalSwiping = spec.verticalSwiping,
      rtl = spec.rtl,
      currentSlide = spec.currentSlide,
      edgeFriction = spec.edgeFriction,
      edgeDragged = spec.edgeDragged,
      onEdge = spec.onEdge,
      swiped = spec.swiped,
      swiping = spec.swiping,
      slideCount = spec.slideCount,
      slidesToScroll = spec.slidesToScroll,
      infinite = spec.infinite,
      touchObject = spec.touchObject,
      swipeEvent = spec.swipeEvent,
      listHeight = spec.listHeight,
      listWidth = spec.listWidth;
  if (scrolling) return;
  if (animating) return safePreventDefault(e);
  if (vertical && swipeToSlide && verticalSwiping) safePreventDefault(e);
  var swipeLeft,
      state = {};
  var curLeft = getTrackLeft(spec);
  touchObject.curX = e.touches ? e.touches[0].pageX : e.clientX;
  touchObject.curY = e.touches ? e.touches[0].pageY : e.clientY;
  touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curX - touchObject.startX, 2)));
  var verticalSwipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curY - touchObject.startY, 2)));

  if (!verticalSwiping && !swiping && verticalSwipeLength > 10) {
    return {
      scrolling: true
    };
  }

  if (verticalSwiping) touchObject.swipeLength = verticalSwipeLength;
  var positionOffset = (!rtl ? 1 : -1) * (touchObject.curX > touchObject.startX ? 1 : -1);
  if (verticalSwiping) positionOffset = touchObject.curY > touchObject.startY ? 1 : -1;
  var dotCount = Math.ceil(slideCount / slidesToScroll);
  var swipeDirection = getSwipeDirection(spec.touchObject, verticalSwiping);
  var touchSwipeLength = touchObject.swipeLength;

  if (!infinite) {
    if (currentSlide === 0 && (swipeDirection === "right" || swipeDirection === "down") || currentSlide + 1 >= dotCount && (swipeDirection === "left" || swipeDirection === "up") || !canGoNext(spec) && (swipeDirection === "left" || swipeDirection === "up")) {
      touchSwipeLength = touchObject.swipeLength * edgeFriction;

      if (edgeDragged === false && onEdge) {
        onEdge(swipeDirection);
        state["edgeDragged"] = true;
      }
    }
  }

  if (!swiped && swipeEvent) {
    swipeEvent(swipeDirection);
    state["swiped"] = true;
  }

  if (!vertical) {
    if (!rtl) {
      swipeLeft = curLeft + touchSwipeLength * positionOffset;
    } else {
      swipeLeft = curLeft - touchSwipeLength * positionOffset;
    }
  } else {
    swipeLeft = curLeft + touchSwipeLength * (listHeight / listWidth) * positionOffset;
  }

  if (verticalSwiping) {
    swipeLeft = curLeft + touchSwipeLength * positionOffset;
  }

  state = _objectSpread(_objectSpread({}, state), {}, {
    touchObject: touchObject,
    swipeLeft: swipeLeft,
    trackStyle: getTrackCSS(_objectSpread(_objectSpread({}, spec), {}, {
      left: swipeLeft
    }))
  });

  if (Math.abs(touchObject.curX - touchObject.startX) < Math.abs(touchObject.curY - touchObject.startY) * 0.8) {
    return state;
  }

  if (touchObject.swipeLength > 10) {
    state["swiping"] = true;
    safePreventDefault(e);
  }

  return state;
};

exports.swipeMove = swipeMove;

var swipeEnd = function swipeEnd(e, spec) {
  var dragging = spec.dragging,
      swipe = spec.swipe,
      touchObject = spec.touchObject,
      listWidth = spec.listWidth,
      touchThreshold = spec.touchThreshold,
      verticalSwiping = spec.verticalSwiping,
      listHeight = spec.listHeight,
      swipeToSlide = spec.swipeToSlide,
      scrolling = spec.scrolling,
      onSwipe = spec.onSwipe,
      targetSlide = spec.targetSlide,
      currentSlide = spec.currentSlide,
      infinite = spec.infinite;

  if (!dragging) {
    if (swipe) safePreventDefault(e);
    return {};
  }

  var minSwipe = verticalSwiping ? listHeight / touchThreshold : listWidth / touchThreshold;
  var swipeDirection = getSwipeDirection(touchObject, verticalSwiping); // reset the state of touch related state variables.

  var state = {
    dragging: false,
    edgeDragged: false,
    scrolling: false,
    swiping: false,
    swiped: false,
    swipeLeft: null,
    touchObject: {}
  };

  if (scrolling) {
    return state;
  }

  if (!touchObject.swipeLength) {
    return state;
  }

  if (touchObject.swipeLength > minSwipe) {
    safePreventDefault(e);

    if (onSwipe) {
      onSwipe(swipeDirection);
    }

    var slideCount, newSlide;
    var activeSlide = infinite ? currentSlide : targetSlide;

    switch (swipeDirection) {
      case "left":
      case "up":
        newSlide = activeSlide + getSlideCount(spec);
        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
        state["currentDirection"] = 0;
        break;

      case "right":
      case "down":
        newSlide = activeSlide - getSlideCount(spec);
        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
        state["currentDirection"] = 1;
        break;

      default:
        slideCount = activeSlide;
    }

    state["triggerSlideHandler"] = slideCount;
  } else {
    // Adjust the track back to it's original position.
    var currentLeft = getTrackLeft(spec);
    state["trackStyle"] = getTrackAnimateCSS(_objectSpread(_objectSpread({}, spec), {}, {
      left: currentLeft
    }));
  }

  return state;
};

exports.swipeEnd = swipeEnd;

var getNavigableIndexes = function getNavigableIndexes(spec) {
  var max = spec.infinite ? spec.slideCount * 2 : spec.slideCount;
  var breakpoint = spec.infinite ? spec.slidesToShow * -1 : 0;
  var counter = spec.infinite ? spec.slidesToShow * -1 : 0;
  var indexes = [];

  while (breakpoint < max) {
    indexes.push(breakpoint);
    breakpoint = counter + spec.slidesToScroll;
    counter += Math.min(spec.slidesToScroll, spec.slidesToShow);
  }

  return indexes;
};

exports.getNavigableIndexes = getNavigableIndexes;

var checkNavigable = function checkNavigable(spec, index) {
  var navigables = getNavigableIndexes(spec);
  var prevNavigable = 0;

  if (index > navigables[navigables.length - 1]) {
    index = navigables[navigables.length - 1];
  } else {
    for (var n in navigables) {
      if (index < navigables[n]) {
        index = prevNavigable;
        break;
      }

      prevNavigable = navigables[n];
    }
  }

  return index;
};

exports.checkNavigable = checkNavigable;

var getSlideCount = function getSlideCount(spec) {
  var centerOffset = spec.centerMode ? spec.slideWidth * Math.floor(spec.slidesToShow / 2) : 0;

  if (spec.swipeToSlide) {
    var swipedSlide;
    var slickList = spec.listRef;
    var slides = slickList.querySelectorAll && slickList.querySelectorAll(".slick-slide") || [];
    Array.from(slides).every(function (slide) {
      if (!spec.vertical) {
        if (slide.offsetLeft - centerOffset + getWidth(slide) / 2 > spec.swipeLeft * -1) {
          swipedSlide = slide;
          return false;
        }
      } else {
        if (slide.offsetTop + getHeight(slide) / 2 > spec.swipeLeft * -1) {
          swipedSlide = slide;
          return false;
        }
      }

      return true;
    });

    if (!swipedSlide) {
      return 0;
    }

    var currentIndex = spec.rtl === true ? spec.slideCount - spec.currentSlide : spec.currentSlide;
    var slidesTraversed = Math.abs(swipedSlide.dataset.index - currentIndex) || 1;
    return slidesTraversed;
  } else {
    return spec.slidesToScroll;
  }
};

exports.getSlideCount = getSlideCount;

var checkSpecKeys = function checkSpecKeys(spec, keysArray) {
  return keysArray.reduce(function (value, key) {
    return value && spec.hasOwnProperty(key);
  }, true) ? null : console.error("Keys Missing:", spec);
};

exports.checkSpecKeys = checkSpecKeys;

var getTrackCSS = function getTrackCSS(spec) {
  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth"]);
  var trackWidth, trackHeight;
  var trackChildren = spec.slideCount + 2 * spec.slidesToShow;

  if (!spec.vertical) {
    trackWidth = getTotalSlides(spec) * spec.slideWidth;
  } else {
    trackHeight = trackChildren * spec.slideHeight;
  }

  var style = {
    opacity: 1,
    transition: "",
    WebkitTransition: ""
  };

  if (spec.useTransform) {
    var WebkitTransform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
    var transform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
    var msTransform = !spec.vertical ? "translateX(" + spec.left + "px)" : "translateY(" + spec.left + "px)";
    style = _objectSpread(_objectSpread({}, style), {}, {
      WebkitTransform: WebkitTransform,
      transform: transform,
      msTransform: msTransform
    });
  } else {
    if (spec.vertical) {
      style["top"] = spec.left;
    } else {
      style["left"] = spec.left;
    }
  }

  if (spec.fade) style = {
    opacity: 1
  };
  if (trackWidth) style.width = trackWidth;
  if (trackHeight) style.height = trackHeight; // Fallback for IE8

  if (window && !window.addEventListener && window.attachEvent) {
    if (!spec.vertical) {
      style.marginLeft = spec.left + "px";
    } else {
      style.marginTop = spec.left + "px";
    }
  }

  return style;
};

exports.getTrackCSS = getTrackCSS;

var getTrackAnimateCSS = function getTrackAnimateCSS(spec) {
  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth", "speed", "cssEase"]);
  var style = getTrackCSS(spec); // useCSS is true by default so it can be undefined

  if (spec.useTransform) {
    style.WebkitTransition = "-webkit-transform " + spec.speed + "ms " + spec.cssEase;
    style.transition = "transform " + spec.speed + "ms " + spec.cssEase;
  } else {
    if (spec.vertical) {
      style.transition = "top " + spec.speed + "ms " + spec.cssEase;
    } else {
      style.transition = "left " + spec.speed + "ms " + spec.cssEase;
    }
  }

  return style;
};

exports.getTrackAnimateCSS = getTrackAnimateCSS;

var getTrackLeft = function getTrackLeft(spec) {
  if (spec.unslick) {
    return 0;
  }

  checkSpecKeys(spec, ["slideIndex", "trackRef", "infinite", "centerMode", "slideCount", "slidesToShow", "slidesToScroll", "slideWidth", "listWidth", "variableWidth", "slideHeight"]);
  var slideIndex = spec.slideIndex,
      trackRef = spec.trackRef,
      infinite = spec.infinite,
      centerMode = spec.centerMode,
      slideCount = spec.slideCount,
      slidesToShow = spec.slidesToShow,
      slidesToScroll = spec.slidesToScroll,
      slideWidth = spec.slideWidth,
      listWidth = spec.listWidth,
      variableWidth = spec.variableWidth,
      slideHeight = spec.slideHeight,
      fade = spec.fade,
      vertical = spec.vertical;
  var slideOffset = 0;
  var targetLeft;
  var targetSlide;
  var verticalOffset = 0;

  if (fade || spec.slideCount === 1) {
    return 0;
  }

  var slidesToOffset = 0;

  if (infinite) {
    slidesToOffset = -getPreClones(spec); // bring active slide to the beginning of visual area
    // if next scroll doesn't have enough children, just reach till the end of original slides instead of shifting slidesToScroll children

    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
      slidesToOffset = -(slideIndex > slideCount ? slidesToShow - (slideIndex - slideCount) : slideCount % slidesToScroll);
    } // shift current slide to center of the frame


    if (centerMode) {
      slidesToOffset += parseInt(slidesToShow / 2);
    }
  } else {
    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
      slidesToOffset = slidesToShow - slideCount % slidesToScroll;
    }

    if (centerMode) {
      slidesToOffset = parseInt(slidesToShow / 2);
    }
  }

  slideOffset = slidesToOffset * slideWidth;
  verticalOffset = slidesToOffset * slideHeight;

  if (!vertical) {
    targetLeft = slideIndex * slideWidth * -1 + slideOffset;
  } else {
    targetLeft = slideIndex * slideHeight * -1 + verticalOffset;
  }

  if (variableWidth === true) {
    var targetSlideIndex;
    var trackElem = trackRef && trackRef.node;
    targetSlideIndex = slideIndex + getPreClones(spec);
    targetSlide = trackElem && trackElem.childNodes[targetSlideIndex];
    targetLeft = targetSlide ? targetSlide.offsetLeft * -1 : 0;

    if (centerMode === true) {
      targetSlideIndex = infinite ? slideIndex + getPreClones(spec) : slideIndex;
      targetSlide = trackElem && trackElem.children[targetSlideIndex];
      targetLeft = 0;

      for (var slide = 0; slide < targetSlideIndex; slide++) {
        targetLeft -= trackElem && trackElem.children[slide] && trackElem.children[slide].offsetWidth;
      }

      targetLeft -= parseInt(spec.centerPadding);
      targetLeft += targetSlide && (listWidth - targetSlide.offsetWidth) / 2;
    }
  }

  return targetLeft;
};

exports.getTrackLeft = getTrackLeft;

var getPreClones = function getPreClones(spec) {
  if (spec.unslick || !spec.infinite) {
    return 0;
  }

  if (spec.variableWidth) {
    return spec.slideCount;
  }

  return spec.slidesToShow + (spec.centerMode ? 1 : 0);
};

exports.getPreClones = getPreClones;

var getPostClones = function getPostClones(spec) {
  if (spec.unslick || !spec.infinite) {
    return 0;
  }

  return spec.slideCount;
};

exports.getPostClones = getPostClones;

var getTotalSlides = function getTotalSlides(spec) {
  return spec.slideCount === 1 ? 1 : getPreClones(spec) + spec.slideCount + getPostClones(spec);
};

exports.getTotalSlides = getTotalSlides;

var siblingDirection = function siblingDirection(spec) {
  if (spec.targetSlide > spec.currentSlide) {
    if (spec.targetSlide > spec.currentSlide + slidesOnRight(spec)) {
      return "left";
    }

    return "right";
  } else {
    if (spec.targetSlide < spec.currentSlide - slidesOnLeft(spec)) {
      return "right";
    }

    return "left";
  }
};

exports.siblingDirection = siblingDirection;

var slidesOnRight = function slidesOnRight(_ref) {
  var slidesToShow = _ref.slidesToShow,
      centerMode = _ref.centerMode,
      rtl = _ref.rtl,
      centerPadding = _ref.centerPadding;

  // returns no of slides on the right of active slide
  if (centerMode) {
    var right = (slidesToShow - 1) / 2 + 1;
    if (parseInt(centerPadding) > 0) right += 1;
    if (rtl && slidesToShow % 2 === 0) right += 1;
    return right;
  }

  if (rtl) {
    return 0;
  }

  return slidesToShow - 1;
};

exports.slidesOnRight = slidesOnRight;

var slidesOnLeft = function slidesOnLeft(_ref2) {
  var slidesToShow = _ref2.slidesToShow,
      centerMode = _ref2.centerMode,
      rtl = _ref2.rtl,
      centerPadding = _ref2.centerPadding;

  // returns no of slides on the left of active slide
  if (centerMode) {
    var left = (slidesToShow - 1) / 2 + 1;
    if (parseInt(centerPadding) > 0) left += 1;
    if (!rtl && slidesToShow % 2 === 0) left += 1;
    return left;
  }

  if (rtl) {
    return slidesToShow - 1;
  }

  return 0;
};

exports.slidesOnLeft = slidesOnLeft;

var canUseDOM = function canUseDOM() {
  return !!(typeof window !== "undefined" && window.document && window.document.createElement);
};

exports.canUseDOM = canUseDOM;

/***/ }),

/***/ 59162:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.defaultProps = void 0;
const react_1 = __importDefault(__webpack_require__(67294));
const render_props_version_1 = __importDefault(__webpack_require__(13854));
exports.defaultProps = Object.assign(Object.assign({}, render_props_version_1.default.defaultProps), { stickyClassName: 'sticky', wrapperClassName: '', stickyStyle: {} });
function Sticky(props) {
    const _a = Object.assign(Object.assign({}, exports.defaultProps), props), { 
    // props for StickyRenderProp
    mode, onFixedToggle, hideOnBoundaryHit, offsetTransforms, disabled, boundaryElement, scrollElement, bottomOffset, topOffset, positionRecheckInterval, children, isIOSFixEnabled, dontUpdateHolderHeightWhenSticky, 
    // own props
    wrapperClassName, stickyClassName, stickyStyle } = _a, 
    // rest of the props that we will forward to wrapper
    rest = __rest(_a, ["mode", "onFixedToggle", "hideOnBoundaryHit", "offsetTransforms", "disabled", "boundaryElement", "scrollElement", "bottomOffset", "topOffset", "positionRecheckInterval", "children", "isIOSFixEnabled", "dontUpdateHolderHeightWhenSticky", "wrapperClassName", "stickyClassName", "stickyStyle"]);
    return react_1.default.createElement(render_props_version_1.default, { mode: mode, onFixedToggle: onFixedToggle, hideOnBoundaryHit: hideOnBoundaryHit, offsetTransforms: offsetTransforms, disabled: disabled, boundaryElement: boundaryElement, scrollElement: scrollElement, bottomOffset: bottomOffset, topOffset: topOffset, positionRecheckInterval: positionRecheckInterval, isIOSFixEnabled: isIOSFixEnabled, dontUpdateHolderHeightWhenSticky: dontUpdateHolderHeightWhenSticky }, ({ isFixed, wrapperStyles, wrapperRef, holderStyles, holderRef }) => (react_1.default.createElement("div", Object.assign({}, rest, { ref: holderRef, style: holderStyles }),
        react_1.default.createElement("div", Object.assign({}, rest, { className: `${wrapperClassName} ${isFixed ? stickyClassName : ''}`, style: isFixed ? Object.assign(Object.assign({}, wrapperStyles), stickyStyle) : wrapperStyles, ref: wrapperRef }), children))));
}
exports["default"] = Sticky;


/***/ }),

/***/ 22442:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

// @flow strict
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.unlisten = exports.listen = void 0;
const elementsWithListeners = [];
const registeredListeners = [];
function createListener(el) {
    return ({
        el,
        callbacks: {},
        realCallbacks: {},
        realListenersCnt: 0
    });
}
function addCallback(listener, event, cb) {
    if (listener.callbacks[event]) {
        if (listener.callbacks[event].indexOf(cb) === -1) {
            listener.callbacks[event].push(cb);
        }
        return;
    }
    listener.callbacks[event] = [cb];
    listener.realCallbacks[event] = (e) => {
        for (let i = 0, l = listener.callbacks[event].length; i < l; i += 1) {
            listener.callbacks[event][i](e);
        }
    };
    listener.el.addEventListener(event, listener.realCallbacks[event]);
    listener.realListenersCnt += 1;
}
function removeCallback(listener, event, cb) {
    if (!listener.callbacks[event]) {
        return;
    }
    const idx = listener.callbacks[event].indexOf(cb);
    if (idx === -1) {
        return;
    }
    listener.callbacks[event].splice(idx, 1);
    if (listener.callbacks[event].length > 0) {
        return;
    }
    // no more listeners, lets clean up
    listener.el.removeEventListener(event, listener.realCallbacks[event]);
    delete listener.callbacks[event];
    delete listener.realCallbacks[event];
    listener.realListenersCnt -= 1;
}
function addListener(el, event, cb) {
    let idx = elementsWithListeners.indexOf(el);
    if (idx === -1) {
        idx = elementsWithListeners.length;
        elementsWithListeners.push(el);
        registeredListeners.push(createListener(el));
    }
    const listener = registeredListeners[idx];
    addCallback(listener, event, cb);
}
function removeListener(el, event, cb) {
    const idx = elementsWithListeners.indexOf(el);
    if (idx === -1) {
        return;
    }
    const listener = registeredListeners[idx];
    removeCallback(listener, event, cb);
    if (listener.realListenersCnt > 0) {
        return;
    }
    // no more listeners lets clean up
    elementsWithListeners.splice(idx, 1);
    registeredListeners.splice(idx, 1);
}
/**
 * Subscribe cb to events list
 * @param  {HTMLListenable}   el       target element
 * @param  {Array}         events   array of event names
 * @param  {Function} cb   callback that should be called
 */
function listen(el, events, cb) {
    for (let i = 0, l = events.length; i < l; i += 1) {
        addListener(el, events[i], cb);
    }
}
exports.listen = listen;
/**
 * Unsubscribe cb from events list
 * @param  {HTMLListenable}   el       target element
 * @param  {Array}         events   array of event names
 * @param  {Function} cb   callback that should be unsubscribed
 */
function unlisten(el, events, cb) {
    for (let i = 0, l = events.length; i < l; i += 1) {
        removeListener(el, events[i], cb);
    }
}
exports.unlisten = unlisten;


/***/ }),

/***/ 92771:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

// @flow strict
Object.defineProperty(exports, "__esModule", ({ value: true }));
const basicSelectors = {};
if (typeof document !== 'undefined') {
    basicSelectors.body = document.body;
    basicSelectors.window = window;
    basicSelectors.document = document;
}
const matchesMethodName = (() => {
    if (typeof document !== 'undefined' && document.body) {
        const body = document.body;
        return typeof (body.matches) === 'function' ? 'matches' :
            typeof (body.webkitMatchesSelector) === 'function' ? 'webkitMatchesSelector' : //webkit
                // @ts-expect-error - ts doesn't like vendors, so do I, but we have to support such case
                typeof (body.mozMatchesSelector) === 'function' ? 'mozMatchesSelector' : //mozilla
                    // @ts-expect-error - ts doesn't like vendors, so do I, but we have to support such case
                    typeof (body.msMatchesSelector) === 'function' ? 'msMatchesSelector' : //ie
                        // @ts-expect-error - ts doesn't like vendors, so do I, but we have to support such case
                        typeof (body.oMatchesSelector) === 'function' ? 'oMatchesSelector' : //old opera
                            null;
    }
    return null;
})();
function find(selector, el) {
    if (!selector) {
        return null;
    }
    // eslint-disable-next-line no-prototype-builtins
    if (basicSelectors.hasOwnProperty(selector)) {
        return basicSelectors[selector];
    }
    // select by id
    if (selector[0] === '#') {
        return document.getElementById(selector.slice(1));
    }
    if (matchesMethodName === null) {
        return null;
    }
    let temp = el;
    // eslint-disable-next-line no-cond-assign
    while (temp = temp.parentElement) {
        // @ts-expect-error - ts does not approve it, but it works fine :)
        if (temp[matchesMethodName](selector)) {
            return temp || null;
        }
    }
    // nothing has been found :(
    return null;
}
exports["default"] = find;


/***/ }),

/***/ 81738:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

// @flow strict
Object.defineProperty(exports, "__esModule", ({ value: true }));
function getClosestTransformedParent(el) {
    do {
        const style = window.getComputedStyle(el);
        if (style.transform !== 'none' || style.webkitTransform !== 'none')
            return el;
        // @ts-expect-error - this is fine we don't need a new variable
        el = el.parentElement || el.parentNode;
    } while (el !== null && el.nodeType === 1);
    return null;
}
exports["default"] = getClosestTransformedParent;


/***/ }),

/***/ 61596:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

// @flow strict
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.isIntersecting = exports.getRect = exports.infiniteRect = void 0;
exports.infiniteRect = { top: -Infinity, bottom: Infinity, height: Infinity, left: -Infinity, right: Infinity, width: Infinity };
function getRect(el) {
    if (el && ('getBoundingClientRect' in el) && typeof (el.getBoundingClientRect) === 'function') {
        return el.getBoundingClientRect();
    }
    if (el === window || el === document) {
        return {
            top: 0,
            left: 0,
            bottom: window.innerHeight,
            height: window.innerHeight,
            width: window.innerWidth,
            right: window.innerWidth
        };
    }
    return { top: 0, left: 0, right: 0, bottom: 0, width: 0, height: 0 };
}
exports.getRect = getRect;
function isIntersecting(r1, r2, topOffset, bottomOffset) {
    const r1Top = r1.top + topOffset, r1Bottom = r1.bottom + bottomOffset;
    return (r1Top >= r2.top && r1Top <= r2.bottom)
        || (r1Bottom >= r2.top && r1Bottom <= r2.bottom)
        || (r1Bottom >= r2.bottom && r1Top <= r2.top);
}
exports.isIntersecting = isIntersecting;


/***/ }),

/***/ 75198:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.RenderPropSticky = void 0;
const render_props_version_1 = __importDefault(__webpack_require__(13854));
exports.RenderPropSticky = render_props_version_1.default;
const basic_version_1 = __importDefault(__webpack_require__(59162));
exports["default"] = basic_version_1.default;


/***/ }),

/***/ 13854:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

// @flow strict
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const react_1 = __webpack_require__(67294);
const events_1 = __webpack_require__(22442);
const find_1 = __importDefault(__webpack_require__(92771));
const getClosestTransformedParent_1 = __importDefault(__webpack_require__(81738));
const rect_1 = __webpack_require__(61596);
const buildTopStyles = (container, props) => {
    const { bottomOffset, hideOnBoundaryHit } = props;
    const { top, height, width, boundaryBottom } = container;
    // above boundary
    if (hideOnBoundaryHit || (top + height + bottomOffset < boundaryBottom)) {
        return { top: `${top}px`, width: `${width}px`, position: 'fixed' };
    }
    // reaching boundary
    if (!hideOnBoundaryHit && boundaryBottom > 0) {
        return { top: `${boundaryBottom - height - bottomOffset}px`, width: `${width}px`, position: 'fixed' };
    }
    // below boundary
    return { width: `${width}px`, bottom: `${bottomOffset}px`, position: 'absolute' };
};
const buildBottomStyles = (container, props) => {
    const { bottomOffset, hideOnBoundaryHit } = props;
    const { bottom, height, width, boundaryTop } = container;
    if (hideOnBoundaryHit || (bottom - height - bottomOffset > boundaryTop)) {
        return { width: `${width}px`, top: `${bottom - height}px`, position: 'fixed' };
    }
    return { width: `${width}px`, top: `${bottomOffset}px`, position: 'absolute' };
};
const buildStickyStyle = (mode, props, container) => (mode === 'top' ? buildTopStyles : buildBottomStyles)(container, props);
const isEqual = (obj1, obj2) => {
    const styles1 = obj1.wrapperStyles;
    const styles2 = obj2.wrapperStyles;
    if (obj1.isFixed !== obj2.isFixed ||
        obj1.height !== obj2.height ||
        (!styles1 && styles2) ||
        (styles1 && !styles2)) {
        return false;
    }
    if (!styles2) {
        return true;
    }
    for (const field in styles1) {
        // @ts-expect-error - ts doesn't like that `field` is a string
        // eslint-disable-next-line no-prototype-builtins
        if (styles1.hasOwnProperty(field) && styles1[field] !== styles2[field]) {
            return false;
        }
    }
    return true;
};
class Sticky extends react_1.Component {
    constructor() {
        super(...arguments);
        this.holderEl = null;
        this.wrapperEl = null;
        this.el = null;
        this.scrollEl = null;
        this.boundaryEl = null;
        this.disabled = false;
        this.checkPositionIntervalId = null;
        this.lastMinHeight = null;
        this.state = {
            isFixed: false,
            wrapperStyles: undefined,
            holderStyles: undefined,
            height: 0
        };
        this.holderRef = (holderEl) => {
            if (holderEl === this.holderEl) {
                return;
            }
            this.holderEl = holderEl;
        };
        this.wrapperRef = (wrapperEl) => {
            if (wrapperEl === this.wrapperEl) {
                return;
            }
            this.wrapperEl = wrapperEl;
            this.updateScrollEl();
            this.updateBoundaryEl();
        };
        this.checkPosition = () => {
            const { holderEl, wrapperEl, boundaryEl, scrollEl, disabled } = this;
            if (!scrollEl || !holderEl || !wrapperEl) {
                console.error("Missing required elements:", {
                    scrollEl,
                    holderEl,
                    wrapperEl
                });
                return;
            }
            const { mode, onFixedToggle, offsetTransforms, isIOSFixEnabled, dontUpdateHolderHeightWhenSticky } = this.props;
            if (disabled) {
                if (this.state.isFixed) {
                    this.setState({ isFixed: false, wrapperStyles: {} });
                }
                return;
            }
            if (!holderEl.getBoundingClientRect || !wrapperEl.getBoundingClientRect) {
                return;
            }
            const holderRect = holderEl.getBoundingClientRect();
            const wrapperRect = wrapperEl.getBoundingClientRect();
            const boundaryRect = boundaryEl ? (0, rect_1.getRect)(boundaryEl) : rect_1.infiniteRect;
            const scrollRect = (0, rect_1.getRect)(scrollEl);
            const isFixed = this.isFixed(holderRect, wrapperRect, boundaryRect, scrollRect);
            let offsets = null;
            if (offsetTransforms && isFixed && scrollEl instanceof HTMLElement) {
                const closestTransformedParent = (0, getClosestTransformedParent_1.default)(scrollEl);
                if (closestTransformedParent) {
                    offsets = (0, rect_1.getRect)(closestTransformedParent);
                }
            }
            const minHeight = this.state.isFixed && dontUpdateHolderHeightWhenSticky && this.lastMinHeight ? this.lastMinHeight : wrapperRect.height;
            this.lastMinHeight = minHeight;
            // To ensure that this component becomes sticky immediately on mobile devices instead
            // of disappearing until the scroll event completes, we add `transform: translateZ(0)`
            // to 'kick' rendering of this element to the GPU
            // @see http://stackoverflow.com/questions/32875046
            const iosRenderingFixStyles = isIOSFixEnabled ? {
                transform: 'translateZ(0)',
                WebkitTransform: 'translateZ(0)'
            } : undefined;
            const newState = {
                isFixed,
                height: wrapperRect.height,
                holderStyles: { minHeight: `${minHeight}px` },
                wrapperStyles: isFixed ? Object.assign(Object.assign({}, iosRenderingFixStyles), buildStickyStyle(mode, this.props, {
                    boundaryTop: mode === 'bottom' ? boundaryRect.top : 0,
                    boundaryBottom: mode === 'top' ? boundaryRect.bottom : 0,
                    top: mode === 'top' ? scrollRect.top - (offsets ? offsets.top : 0) : 0,
                    bottom: mode === 'bottom' ? scrollRect.bottom - (offsets ? offsets.bottom : 0) : 0,
                    width: holderRect.width,
                    height: wrapperRect.height
                })) : iosRenderingFixStyles
            };
            if (isFixed !== this.state.isFixed && onFixedToggle && typeof onFixedToggle === 'function') {
                onFixedToggle(isFixed);
            }
            if (!isEqual(this.state, newState)) {
                this.setState(newState);
            }
        };
    }
    isFixed(holderRect, wrapperRect, boundaryRect, scrollRect) {
        const { hideOnBoundaryHit, bottomOffset, topOffset, mode } = this.props;
        if (this.disabled) {
            return false;
        }
        if (hideOnBoundaryHit && boundaryRect && !(0, rect_1.isIntersecting)(boundaryRect, scrollRect, topOffset, bottomOffset)) {
            return false;
        }
        const hideOffset = hideOnBoundaryHit ? wrapperRect.height + bottomOffset : 0;
        if (mode === 'top') {
            return (holderRect.top + topOffset < scrollRect.top)
                && (scrollRect.top + hideOffset <= boundaryRect.bottom);
        }
        return (holderRect.bottom - topOffset > scrollRect.bottom)
            && (scrollRect.bottom - hideOffset >= boundaryRect.top);
    }
    updateScrollEl() {
        if (!this.wrapperEl) {
            return;
        }
        if (this.scrollEl) {
            (0, events_1.unlisten)(this.scrollEl, ['scroll'], this.checkPosition);
            this.scrollEl = null;
        }
        const { scrollElement } = this.props;
        if (typeof scrollElement === 'string') {
            this.scrollEl = (0, find_1.default)(scrollElement, this.wrapperEl);
        }
        else {
            this.scrollEl = scrollElement;
        }
        if (this.scrollEl) {
            (0, events_1.listen)(this.scrollEl, ['scroll'], this.checkPosition);
        }
        else {
            console.error('Cannot find scrollElement ' + (typeof scrollElement === 'string' ? scrollElement : 'unknown'));
        }
    }
    updateBoundaryEl() {
        if (!this.wrapperEl) {
            return;
        }
        const { boundaryElement } = this.props;
        this.boundaryEl = (0, find_1.default)(boundaryElement, this.wrapperEl);
        if (this.boundaryEl === window || this.boundaryEl === document) {
            // such objects can't be used as boundary
            // and in fact there is no point in such a case
            this.boundaryEl = null;
        }
    }
    initialize() {
        const { positionRecheckInterval, disabled } = this.props;
        this.disabled = disabled;
        // we should always listen to window events because they will affect the layout of the whole page
        (0, events_1.listen)(window, ['scroll', 'resize', 'pageshow', 'load'], this.checkPosition);
        this.checkPosition();
        if (positionRecheckInterval) {
            this.checkPositionIntervalId = setInterval(this.checkPosition, positionRecheckInterval);
        }
    }
    componentDidUpdate({ scrollElement, boundaryElement, disabled }) {
        if (scrollElement !== this.props.scrollElement || this.scrollEl === null) {
            this.updateScrollEl();
        }
        if (boundaryElement !== this.props.boundaryElement || this.boundaryEl === null) {
            this.updateBoundaryEl();
        }
        if (disabled !== this.props.disabled) {
            this.disabled = this.props.disabled;
            this.checkPosition();
        }
    }
    componentDidMount() {
        this.initialize();
        if (this.wrapperEl === null) {
            console.error("Wrapper element is missing, please make sure that you have assigned refs correctly");
        }
    }
    componentWillUnmount() {
        if (this.scrollEl) {
            (0, events_1.unlisten)(this.scrollEl, ['scroll'], this.checkPosition);
        }
        (0, events_1.unlisten)(window, ['scroll', 'resize', 'pageshow', 'load'], this.checkPosition);
        this.boundaryEl = null;
        this.scrollEl = null;
        if (this.checkPositionIntervalId) {
            clearInterval(this.checkPositionIntervalId);
        }
    }
    render() {
        const { holderRef, wrapperRef } = this;
        const { isFixed, wrapperStyles, holderStyles } = this.state;
        return this.props.children({
            holderRef,
            wrapperRef,
            isFixed,
            wrapperStyles,
            holderStyles
        });
    }
}
Sticky.defaultProps = {
    mode: 'top',
    topOffset: 0,
    bottomOffset: 0,
    isIOSFixEnabled: true,
    offsetTransforms: true,
    disabled: false,
    onFixedToggle: undefined,
    boundaryElement: undefined,
    hideOnBoundaryHit: true,
    scrollElement: 'window',
    dontUpdateHolderHeightWhenSticky: false,
};
exports["default"] = Sticky;


/***/ }),

/***/ 38551:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
	value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

__webpack_unused_export__ = createFilter;
__webpack_unused_export__ = createWhitelistFilter;
__webpack_unused_export__ = createBlacklistFilter;
__webpack_unused_export__ = persistFilter;

var _reduxPersist = __webpack_require__(97568);

var _lodash = __webpack_require__(29208);

var _lodash2 = _interopRequireDefault(_lodash);

var _lodash3 = __webpack_require__(31468);

var _lodash4 = _interopRequireDefault(_lodash3);

var _lodash5 = __webpack_require__(96633);

var _lodash6 = _interopRequireDefault(_lodash5);

var _lodash7 = __webpack_require__(16040);

var _lodash8 = _interopRequireDefault(_lodash7);

var _lodash9 = __webpack_require__(99245);

var _lodash10 = _interopRequireDefault(_lodash9);

var _lodash11 = __webpack_require__(60790);

var _lodash12 = _interopRequireDefault(_lodash11);

var _lodash13 = __webpack_require__(83465);

var _lodash14 = _interopRequireDefault(_lodash13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createFilter(reducerName, inboundPaths, outboundPaths) {
	var transformType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'whitelist';

	return (0, _reduxPersist.createTransform)(
	// inbound
	function (inboundState, key) {
		return inboundPaths ? persistFilter(inboundState, inboundPaths, transformType) : inboundState;
	},

	// outbound
	function (outboundState, key) {
		return outboundPaths ? persistFilter(outboundState, outboundPaths, transformType) : outboundState;
	}, { 'whitelist': [reducerName] });
};

function createWhitelistFilter(reducerName, inboundPaths, outboundPaths) {
	return createFilter(reducerName, inboundPaths, outboundPaths, 'whitelist');
}

function createBlacklistFilter(reducerName, inboundPaths, outboundPaths) {
	return createFilter(reducerName, inboundPaths, outboundPaths, 'blacklist');
}

function filterObject(_ref, state) {
	var path = _ref.path,
	    _ref$filterFunction = _ref.filterFunction,
	    filterFunction = _ref$filterFunction === undefined ? function () {
		return true;
	} : _ref$filterFunction;

	var value = (0, _lodash2.default)(state, path, state);

	if (value instanceof Array) {
		return value.filter(filterFunction);
	}

	return (0, _lodash8.default)(value, filterFunction);
}

function persistFilter(state) {
	var paths = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	var transformType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'whitelist';

	var subset = {};

	// support only one key
	if (typeof paths === 'string') {
		paths = [paths];
	}

	if (transformType === 'whitelist') {
		paths.forEach(function (path) {
			if ((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && !(path instanceof Array)) {
				var value = filterObject(path, state);

				if (!(0, _lodash10.default)(value)) {
					(0, _lodash4.default)(subset, path.path, value);
				}
			} else {
				var _value = (0, _lodash2.default)(state, path);

				if (typeof _value !== 'undefined') {
					(0, _lodash4.default)(subset, path, _value);
				}
			}
		});
	} else if (transformType === 'blacklist') {
		subset = (0, _lodash14.default)(state);
		paths.forEach(function (path) {
			if ((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && !(path instanceof Array)) {
				var value = filterObject(path, state);

				if (!(0, _lodash10.default)(value)) {
					if (value instanceof Array) {
						(0, _lodash4.default)(subset, path.path, (0, _lodash2.default)(subset, path.path, subset).filter(function (x) {
							return false;
						}));
					} else {
						(0, _lodash12.default)(value, function (value, key) {
							(0, _lodash6.default)(subset, path.path + '[' + key + ']');
						});
					}
				} else {
					subset = value;
				}
			} else {
				var _value2 = (0, _lodash2.default)(state, path);

				if (typeof _value2 !== 'undefined') {
					(0, _lodash6.default)(subset, path);
				}
			}
		});
	} else {
		subset = state;
	}

	return subset;
}

exports.ZP = createFilter;


/***/ }),

/***/ 97568:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "DEFAULT_VERSION": function() { return /* reexport */ DEFAULT_VERSION; },
  "FLUSH": function() { return /* reexport */ FLUSH; },
  "KEY_PREFIX": function() { return /* reexport */ KEY_PREFIX; },
  "PAUSE": function() { return /* reexport */ PAUSE; },
  "PERSIST": function() { return /* reexport */ PERSIST; },
  "PURGE": function() { return /* reexport */ PURGE; },
  "REGISTER": function() { return /* reexport */ REGISTER; },
  "REHYDRATE": function() { return /* reexport */ REHYDRATE; },
  "createMigrate": function() { return /* reexport */ createMigrate; },
  "createPersistoid": function() { return /* reexport */ createPersistoid; },
  "createTransform": function() { return /* reexport */ createTransform; },
  "getStoredState": function() { return /* reexport */ getStoredState_getStoredState; },
  "persistCombineReducers": function() { return /* reexport */ persistCombineReducers; },
  "persistReducer": function() { return /* reexport */ persistReducer; },
  "persistStore": function() { return /* reexport */ persistStore; },
  "purgeStoredState": function() { return /* reexport */ purgeStoredState; }
});

;// CONCATENATED MODULE: ./node_modules/redux-persist/es/constants.js
var KEY_PREFIX = 'persist:';
var FLUSH = 'persist/FLUSH';
var REHYDRATE = 'persist/REHYDRATE';
var PAUSE = 'persist/PAUSE';
var PERSIST = 'persist/PERSIST';
var PURGE = 'persist/PURGE';
var REGISTER = 'persist/REGISTER';
var DEFAULT_VERSION = -1;
;// CONCATENATED MODULE: ./node_modules/redux-persist/es/stateReconciler/autoMergeLevel1.js
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
  autoMergeLevel1: 
    - merges 1 level of substate
    - skips substate if already modified
*/
function autoMergeLevel1(inboundState, originalState, reducedState, _ref) {
  var debug = _ref.debug;

  var newState = _objectSpread({}, reducedState); // only rehydrate if inboundState exists and is an object


  if (inboundState && _typeof(inboundState) === 'object') {
    Object.keys(inboundState).forEach(function (key) {
      // ignore _persist data
      if (key === '_persist') return; // if reducer modifies substate, skip auto rehydration

      if (originalState[key] !== reducedState[key]) {
        if (false) {}
        return;
      } // otherwise hard set the new value


      newState[key] = inboundState[key];
    });
  }

  if (false) {}
  return newState;
}
;// CONCATENATED MODULE: ./node_modules/redux-persist/es/createPersistoid.js

// @TODO remove once flow < 0.63 support is no longer required.
function createPersistoid(config) {
  // defaults
  var blacklist = config.blacklist || null;
  var whitelist = config.whitelist || null;
  var transforms = config.transforms || [];
  var throttle = config.throttle || 0;
  var storageKey = "".concat(config.keyPrefix !== undefined ? config.keyPrefix : KEY_PREFIX).concat(config.key);
  var storage = config.storage;
  var serialize;

  if (config.serialize === false) {
    serialize = function serialize(x) {
      return x;
    };
  } else if (typeof config.serialize === 'function') {
    serialize = config.serialize;
  } else {
    serialize = defaultSerialize;
  }

  var writeFailHandler = config.writeFailHandler || null; // initialize stateful values

  var lastState = {};
  var stagedState = {};
  var keysToProcess = [];
  var timeIterator = null;
  var writePromise = null;

  var update = function update(state) {
    // add any changed keys to the queue
    Object.keys(state).forEach(function (key) {
      if (!passWhitelistBlacklist(key)) return; // is keyspace ignored? noop

      if (lastState[key] === state[key]) return; // value unchanged? noop

      if (keysToProcess.indexOf(key) !== -1) return; // is key already queued? noop

      keysToProcess.push(key); // add key to queue
    }); //if any key is missing in the new state which was present in the lastState,
    //add it for processing too

    Object.keys(lastState).forEach(function (key) {
      if (state[key] === undefined && passWhitelistBlacklist(key) && keysToProcess.indexOf(key) === -1 && lastState[key] !== undefined) {
        keysToProcess.push(key);
      }
    }); // start the time iterator if not running (read: throttle)

    if (timeIterator === null) {
      timeIterator = setInterval(processNextKey, throttle);
    }

    lastState = state;
  };

  function processNextKey() {
    if (keysToProcess.length === 0) {
      if (timeIterator) clearInterval(timeIterator);
      timeIterator = null;
      return;
    }

    var key = keysToProcess.shift();
    var endState = transforms.reduce(function (subState, transformer) {
      return transformer.in(subState, key, lastState);
    }, lastState[key]);

    if (endState !== undefined) {
      try {
        stagedState[key] = serialize(endState);
      } catch (err) {
        console.error('redux-persist/createPersistoid: error serializing state', err);
      }
    } else {
      //if the endState is undefined, no need to persist the existing serialized content
      delete stagedState[key];
    }

    if (keysToProcess.length === 0) {
      writeStagedState();
    }
  }

  function writeStagedState() {
    // cleanup any removed keys just before write.
    Object.keys(stagedState).forEach(function (key) {
      if (lastState[key] === undefined) {
        delete stagedState[key];
      }
    });
    writePromise = storage.setItem(storageKey, serialize(stagedState)).catch(onWriteFail);
  }

  function passWhitelistBlacklist(key) {
    if (whitelist && whitelist.indexOf(key) === -1 && key !== '_persist') return false;
    if (blacklist && blacklist.indexOf(key) !== -1) return false;
    return true;
  }

  function onWriteFail(err) {
    // @TODO add fail handlers (typically storage full)
    if (writeFailHandler) writeFailHandler(err);

    if (err && "production" !== 'production') {}
  }

  var flush = function flush() {
    while (keysToProcess.length !== 0) {
      processNextKey();
    }

    return writePromise || Promise.resolve();
  }; // return `persistoid`


  return {
    update: update,
    flush: flush
  };
} // @NOTE in the future this may be exposed via config

function defaultSerialize(data) {
  return JSON.stringify(data);
}
;// CONCATENATED MODULE: ./node_modules/redux-persist/es/getStoredState.js

function getStoredState_getStoredState(config) {
  var transforms = config.transforms || [];
  var storageKey = "".concat(config.keyPrefix !== undefined ? config.keyPrefix : KEY_PREFIX).concat(config.key);
  var storage = config.storage;
  var debug = config.debug;
  var deserialize;

  if (config.deserialize === false) {
    deserialize = function deserialize(x) {
      return x;
    };
  } else if (typeof config.deserialize === 'function') {
    deserialize = config.deserialize;
  } else {
    deserialize = defaultDeserialize;
  }

  return storage.getItem(storageKey).then(function (serialized) {
    if (!serialized) return undefined;else {
      try {
        var state = {};
        var rawState = deserialize(serialized);
        Object.keys(rawState).forEach(function (key) {
          state[key] = transforms.reduceRight(function (subState, transformer) {
            return transformer.out(subState, key, rawState);
          }, deserialize(rawState[key]));
        });
        return state;
      } catch (err) {
        if (false) {}
        throw err;
      }
    }
  });
}

function defaultDeserialize(serial) {
  return JSON.parse(serial);
}
;// CONCATENATED MODULE: ./node_modules/redux-persist/es/purgeStoredState.js

function purgeStoredState(config) {
  var storage = config.storage;
  var storageKey = "".concat(config.keyPrefix !== undefined ? config.keyPrefix : KEY_PREFIX).concat(config.key);
  return storage.removeItem(storageKey, warnIfRemoveError);
}

function warnIfRemoveError(err) {
  if (err && "production" !== 'production') {}
}
;// CONCATENATED MODULE: ./node_modules/redux-persist/es/persistReducer.js
function persistReducer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function persistReducer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { persistReducer_ownKeys(source, true).forEach(function (key) { persistReducer_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { persistReducer_ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function persistReducer_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }






var DEFAULT_TIMEOUT = 5000;
/*
  @TODO add validation / handling for:
  - persisting a reducer which has nested _persist
  - handling actions that fire before reydrate is called
*/

function persistReducer(config, baseReducer) {
  if (false) {}

  var version = config.version !== undefined ? config.version : DEFAULT_VERSION;
  var debug = config.debug || false;
  var stateReconciler = config.stateReconciler === undefined ? autoMergeLevel1 : config.stateReconciler;
  var getStoredState = config.getStoredState || getStoredState_getStoredState;
  var timeout = config.timeout !== undefined ? config.timeout : DEFAULT_TIMEOUT;
  var _persistoid = null;
  var _purge = false;
  var _paused = true;

  var conditionalUpdate = function conditionalUpdate(state) {
    // update the persistoid only if we are rehydrated and not paused
    state._persist.rehydrated && _persistoid && !_paused && _persistoid.update(state);
    return state;
  };

  return function (state, action) {
    var _ref = state || {},
        _persist = _ref._persist,
        rest = _objectWithoutProperties(_ref, ["_persist"]); // $FlowIgnore need to update State type


    var restState = rest;

    if (action.type === PERSIST) {
      var _sealed = false;

      var _rehydrate = function _rehydrate(payload, err) {
        // dev warning if we are already sealed
        if (false) {} // only rehydrate if we are not already sealed

        if (!_sealed) {
          action.rehydrate(config.key, payload, err);
          _sealed = true;
        }
      };

      timeout && setTimeout(function () {
        !_sealed && _rehydrate(undefined, new Error("redux-persist: persist timed out for persist key \"".concat(config.key, "\"")));
      }, timeout); // @NOTE PERSIST resumes if paused.

      _paused = false; // @NOTE only ever create persistoid once, ensure we call it at least once, even if _persist has already been set

      if (!_persistoid) _persistoid = createPersistoid(config); // @NOTE PERSIST can be called multiple times, noop after the first

      if (_persist) {
        // We still need to call the base reducer because there might be nested
        // uses of persistReducer which need to be aware of the PERSIST action
        return persistReducer_objectSpread({}, baseReducer(restState, action), {
          _persist: _persist
        });
      }

      if (typeof action.rehydrate !== 'function' || typeof action.register !== 'function') throw new Error('redux-persist: either rehydrate or register is not a function on the PERSIST action. This can happen if the action is being replayed. This is an unexplored use case, please open an issue and we will figure out a resolution.');
      action.register(config.key);
      getStoredState(config).then(function (restoredState) {
        var migrate = config.migrate || function (s, v) {
          return Promise.resolve(s);
        };

        migrate(restoredState, version).then(function (migratedState) {
          _rehydrate(migratedState);
        }, function (migrateErr) {
          if (false) {}

          _rehydrate(undefined, migrateErr);
        });
      }, function (err) {
        _rehydrate(undefined, err);
      });
      return persistReducer_objectSpread({}, baseReducer(restState, action), {
        _persist: {
          version: version,
          rehydrated: false
        }
      });
    } else if (action.type === PURGE) {
      _purge = true;
      action.result(purgeStoredState(config));
      return persistReducer_objectSpread({}, baseReducer(restState, action), {
        _persist: _persist
      });
    } else if (action.type === FLUSH) {
      action.result(_persistoid && _persistoid.flush());
      return persistReducer_objectSpread({}, baseReducer(restState, action), {
        _persist: _persist
      });
    } else if (action.type === PAUSE) {
      _paused = true;
    } else if (action.type === REHYDRATE) {
      // noop on restState if purging
      if (_purge) return persistReducer_objectSpread({}, restState, {
        _persist: persistReducer_objectSpread({}, _persist, {
          rehydrated: true
        }) // @NOTE if key does not match, will continue to default else below

      });

      if (action.key === config.key) {
        var reducedState = baseReducer(restState, action);
        var inboundState = action.payload; // only reconcile state if stateReconciler and inboundState are both defined

        var reconciledRest = stateReconciler !== false && inboundState !== undefined ? stateReconciler(inboundState, state, reducedState, config) : reducedState;

        var _newState = persistReducer_objectSpread({}, reconciledRest, {
          _persist: persistReducer_objectSpread({}, _persist, {
            rehydrated: true
          })
        });

        return conditionalUpdate(_newState);
      }
    } // if we have not already handled PERSIST, straight passthrough


    if (!_persist) return baseReducer(state, action); // run base reducer:
    // is state modified ? return original : return updated

    var newState = baseReducer(restState, action);
    if (newState === restState) return state;
    return conditionalUpdate(persistReducer_objectSpread({}, newState, {
      _persist: _persist
    }));
  };
}
// EXTERNAL MODULE: ./node_modules/redux/es/redux.js + 1 modules
var redux = __webpack_require__(45217);
;// CONCATENATED MODULE: ./node_modules/redux-persist/es/stateReconciler/autoMergeLevel2.js
function autoMergeLevel2_typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { autoMergeLevel2_typeof = function _typeof(obj) { return typeof obj; }; } else { autoMergeLevel2_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return autoMergeLevel2_typeof(obj); }

function autoMergeLevel2_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function autoMergeLevel2_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { autoMergeLevel2_ownKeys(source, true).forEach(function (key) { autoMergeLevel2_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { autoMergeLevel2_ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function autoMergeLevel2_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
  autoMergeLevel2: 
    - merges 2 level of substate
    - skips substate if already modified
    - this is essentially redux-perist v4 behavior
*/
function autoMergeLevel2(inboundState, originalState, reducedState, _ref) {
  var debug = _ref.debug;

  var newState = autoMergeLevel2_objectSpread({}, reducedState); // only rehydrate if inboundState exists and is an object


  if (inboundState && autoMergeLevel2_typeof(inboundState) === 'object') {
    Object.keys(inboundState).forEach(function (key) {
      // ignore _persist data
      if (key === '_persist') return; // if reducer modifies substate, skip auto rehydration

      if (originalState[key] !== reducedState[key]) {
        if (false) {}
        return;
      }

      if (isPlainEnoughObject(reducedState[key])) {
        // if object is plain enough shallow merge the new values (hence "Level2")
        newState[key] = autoMergeLevel2_objectSpread({}, newState[key], {}, inboundState[key]);
        return;
      } // otherwise hard set


      newState[key] = inboundState[key];
    });
  }

  if (false) {}
  return newState;
}

function isPlainEnoughObject(o) {
  return o !== null && !Array.isArray(o) && autoMergeLevel2_typeof(o) === 'object';
}
;// CONCATENATED MODULE: ./node_modules/redux-persist/es/persistCombineReducers.js



// combineReducers + persistReducer with stateReconciler defaulted to autoMergeLevel2
function persistCombineReducers(config, reducers) {
  config.stateReconciler = config.stateReconciler === undefined ? autoMergeLevel2 : config.stateReconciler;
  return persistReducer(config, (0,redux/* combineReducers */.UY)(reducers));
}
;// CONCATENATED MODULE: ./node_modules/redux-persist/es/persistStore.js
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function persistStore_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function persistStore_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { persistStore_ownKeys(source, true).forEach(function (key) { persistStore_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { persistStore_ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function persistStore_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var initialState = {
  registry: [],
  bootstrapped: false
};

var persistorReducer = function persistorReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case REGISTER:
      return persistStore_objectSpread({}, state, {
        registry: [].concat(_toConsumableArray(state.registry), [action.key])
      });

    case REHYDRATE:
      var firstIndex = state.registry.indexOf(action.key);

      var registry = _toConsumableArray(state.registry);

      registry.splice(firstIndex, 1);
      return persistStore_objectSpread({}, state, {
        registry: registry,
        bootstrapped: registry.length === 0
      });

    default:
      return state;
  }
};

function persistStore(store, options, cb) {
  // help catch incorrect usage of passing PersistConfig in as PersistorOptions
  if (false) { var bannedKeys, optionsToTest; }

  var boostrappedCb = cb || false;

  var _pStore = (0,redux/* createStore */.MT)(persistorReducer, initialState, options && options.enhancer ? options.enhancer : undefined);

  var register = function register(key) {
    _pStore.dispatch({
      type: REGISTER,
      key: key
    });
  };

  var rehydrate = function rehydrate(key, payload, err) {
    var rehydrateAction = {
      type: REHYDRATE,
      payload: payload,
      err: err,
      key: key // dispatch to `store` to rehydrate and `persistor` to track result

    };
    store.dispatch(rehydrateAction);

    _pStore.dispatch(rehydrateAction);

    if (boostrappedCb && persistor.getState().bootstrapped) {
      boostrappedCb();
      boostrappedCb = false;
    }
  };

  var persistor = persistStore_objectSpread({}, _pStore, {
    purge: function purge() {
      var results = [];
      store.dispatch({
        type: PURGE,
        result: function result(purgeResult) {
          results.push(purgeResult);
        }
      });
      return Promise.all(results);
    },
    flush: function flush() {
      var results = [];
      store.dispatch({
        type: FLUSH,
        result: function result(flushResult) {
          results.push(flushResult);
        }
      });
      return Promise.all(results);
    },
    pause: function pause() {
      store.dispatch({
        type: PAUSE
      });
    },
    persist: function persist() {
      store.dispatch({
        type: PERSIST,
        register: register,
        rehydrate: rehydrate
      });
    }
  });

  if (!(options && options.manualPersist)) {
    persistor.persist();
  }

  return persistor;
}
;// CONCATENATED MODULE: ./node_modules/redux-persist/es/createMigrate.js

function createMigrate(migrations, config) {
  var _ref = config || {},
      debug = _ref.debug;

  return function (state, currentVersion) {
    if (!state) {
      if (false) {}
      return Promise.resolve(undefined);
    }

    var inboundVersion = state._persist && state._persist.version !== undefined ? state._persist.version : DEFAULT_VERSION;

    if (inboundVersion === currentVersion) {
      if (false) {}
      return Promise.resolve(state);
    }

    if (inboundVersion > currentVersion) {
      if (false) {}
      return Promise.resolve(state);
    }

    var migrationKeys = Object.keys(migrations).map(function (ver) {
      return parseInt(ver);
    }).filter(function (key) {
      return currentVersion >= key && key > inboundVersion;
    }).sort(function (a, b) {
      return a - b;
    });
    if (false) {}

    try {
      var migratedState = migrationKeys.reduce(function (state, versionKey) {
        if (false) {}
        return migrations[versionKey](state);
      }, state);
      return Promise.resolve(migratedState);
    } catch (err) {
      return Promise.reject(err);
    }
  };
}
;// CONCATENATED MODULE: ./node_modules/redux-persist/es/createTransform.js
function createTransform( // @NOTE inbound: transform state coming from redux on its way to being serialized and stored
inbound, // @NOTE outbound: transform state coming from storage, on its way to be rehydrated into redux
outbound) {
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var whitelist = config.whitelist || null;
  var blacklist = config.blacklist || null;

  function whitelistBlacklistCheck(key) {
    if (whitelist && whitelist.indexOf(key) === -1) return true;
    if (blacklist && blacklist.indexOf(key) !== -1) return true;
    return false;
  }

  return {
    in: function _in(state, key, fullState) {
      return !whitelistBlacklistCheck(key) && inbound ? inbound(state, key, fullState) : state;
    },
    out: function out(state, key, fullState) {
      return !whitelistBlacklistCheck(key) && outbound ? outbound(state, key, fullState) : state;
    }
  };
}
;// CONCATENATED MODULE: ./node_modules/redux-persist/es/index.js










/***/ }),

/***/ 1190:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = true;
exports.Z = autoMergeLevel2;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
  autoMergeLevel2: 
    - merges 2 level of substate
    - skips substate if already modified
    - this is essentially redux-perist v4 behavior
*/
function autoMergeLevel2(inboundState, originalState, reducedState, _ref) {
  var debug = _ref.debug;

  var newState = _objectSpread({}, reducedState); // only rehydrate if inboundState exists and is an object


  if (inboundState && _typeof(inboundState) === 'object') {
    Object.keys(inboundState).forEach(function (key) {
      // ignore _persist data
      if (key === '_persist') return; // if reducer modifies substate, skip auto rehydration

      if (originalState[key] !== reducedState[key]) {
        if (false) {}
        return;
      }

      if (isPlainEnoughObject(reducedState[key])) {
        // if object is plain enough shallow merge the new values (hence "Level2")
        newState[key] = _objectSpread({}, newState[key], {}, inboundState[key]);
        return;
      } // otherwise hard set


      newState[key] = inboundState[key];
    });
  }

  if (false) {}
  return newState;
}

function isPlainEnoughObject(o) {
  return o !== null && !Array.isArray(o) && _typeof(o) === 'object';
}

/***/ }),

/***/ 23488:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = true;
exports.Z = createWebStorage;

var _getStorage = _interopRequireDefault(__webpack_require__(77290));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createWebStorage(type) {
  var storage = (0, _getStorage.default)(type);
  return {
    getItem: function getItem(key) {
      return new Promise(function (resolve, reject) {
        resolve(storage.getItem(key));
      });
    },
    setItem: function setItem(key, item) {
      return new Promise(function (resolve, reject) {
        resolve(storage.setItem(key, item));
      });
    },
    removeItem: function removeItem(key) {
      return new Promise(function (resolve, reject) {
        resolve(storage.removeItem(key));
      });
    }
  };
}

/***/ }),

/***/ 77290:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


exports.__esModule = true;
exports["default"] = getStorage;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function noop() {}

var noopStorage = {
  getItem: noop,
  setItem: noop,
  removeItem: noop
};

function hasStorage(storageType) {
  if ((typeof self === "undefined" ? "undefined" : _typeof(self)) !== 'object' || !(storageType in self)) {
    return false;
  }

  try {
    var storage = self[storageType];
    var testKey = "redux-persist ".concat(storageType, " test");
    storage.setItem(testKey, 'test');
    storage.getItem(testKey);
    storage.removeItem(testKey);
  } catch (e) {
    if (false) {}
    return false;
  }

  return true;
}

function getStorage(type) {
  var storageType = "".concat(type, "Storage");
  if (hasStorage(storageType)) return self[storageType];else {
    if (false) {}

    return noopStorage;
  }
}

/***/ }),

/***/ 45217:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "md": function() { return /* binding */ applyMiddleware; },
  "UY": function() { return /* binding */ combineReducers; },
  "qC": function() { return /* binding */ compose; },
  "MT": function() { return /* binding */ createStore; }
});

// UNUSED EXPORTS: __DO_NOT_USE__ActionTypes, bindActionCreators, legacy_createStore

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(4942);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js

function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      (0,defineProperty/* default */.Z)(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}

;// CONCATENATED MODULE: ./node_modules/redux/es/redux.js


/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */
function formatProdErrorMessage(code) {
  return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + 'use the non-minified dev environment for full errors. ';
}

// Inlined version of the `symbol-observable` polyfill
var $$observable = (function () {
  return typeof Symbol === 'function' && Symbol.observable || '@@observable';
})();

/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var randomString = function randomString() {
  return Math.random().toString(36).substring(7).split('').join('.');
};

var ActionTypes = {
  INIT: "@@redux/INIT" + randomString(),
  REPLACE: "@@redux/REPLACE" + randomString(),
  PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
    return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
  }
};

/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = obj;

  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(obj) === proto;
}

// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function miniKindOf(val) {
  if (val === void 0) return 'undefined';
  if (val === null) return 'null';
  var type = typeof val;

  switch (type) {
    case 'boolean':
    case 'string':
    case 'number':
    case 'symbol':
    case 'function':
      {
        return type;
      }
  }

  if (Array.isArray(val)) return 'array';
  if (isDate(val)) return 'date';
  if (isError(val)) return 'error';
  var constructorName = ctorName(val);

  switch (constructorName) {
    case 'Symbol':
    case 'Promise':
    case 'WeakMap':
    case 'WeakSet':
    case 'Map':
    case 'Set':
      return constructorName;
  } // other


  return type.slice(8, -1).toLowerCase().replace(/\s/g, '');
}

function ctorName(val) {
  return typeof val.constructor === 'function' ? val.constructor.name : null;
}

function isError(val) {
  return val instanceof Error || typeof val.message === 'string' && val.constructor && typeof val.constructor.stackTraceLimit === 'number';
}

function isDate(val) {
  if (val instanceof Date) return true;
  return typeof val.toDateString === 'function' && typeof val.getDate === 'function' && typeof val.setDate === 'function';
}

function kindOf(val) {
  var typeOfVal = typeof val;

  if (false) {}

  return typeOfVal;
}

/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */

function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') {
    throw new Error( true ? formatProdErrorMessage(0) : 0);
  }

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error( true ? formatProdErrorMessage(1) : 0);
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error( true ? formatProdErrorMessage(2) : 0);
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;
  /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }
  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */


  function getState() {
    if (isDispatching) {
      throw new Error( true ? formatProdErrorMessage(3) : 0);
    }

    return currentState;
  }
  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */


  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error( true ? formatProdErrorMessage(4) : 0);
    }

    if (isDispatching) {
      throw new Error( true ? formatProdErrorMessage(5) : 0);
    }

    var isSubscribed = true;
    ensureCanMutateNextListeners();
    nextListeners.push(listener);
    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      if (isDispatching) {
        throw new Error( true ? formatProdErrorMessage(6) : 0);
      }

      isSubscribed = false;
      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
      currentListeners = null;
    };
  }
  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */


  function dispatch(action) {
    if (!isPlainObject(action)) {
      throw new Error( true ? formatProdErrorMessage(7) : 0);
    }

    if (typeof action.type === 'undefined') {
      throw new Error( true ? formatProdErrorMessage(8) : 0);
    }

    if (isDispatching) {
      throw new Error( true ? formatProdErrorMessage(9) : 0);
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;

    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }
  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */


  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error( true ? formatProdErrorMessage(10) : 0);
    }

    currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
    // Any reducers that existed in both the new and old rootReducer
    // will receive the previous state. This effectively populates
    // the new state tree with any relevant data from the old one.

    dispatch({
      type: ActionTypes.REPLACE
    });
  }
  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */


  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object' || observer === null) {
          throw new Error( true ? formatProdErrorMessage(11) : 0);
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return {
          unsubscribe: unsubscribe
        };
      }
    }, _ref[$$observable] = function () {
      return this;
    }, _ref;
  } // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.


  dispatch({
    type: ActionTypes.INIT
  });
  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */

var legacy_createStore = (/* unused pure expression or super */ null && (createStore));

/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
  } catch (e) {} // eslint-disable-line no-empty

}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!isPlainObject(inputState)) {
    return "The " + argumentName + " has unexpected type of \"" + kindOf(inputState) + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });
  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });
  if (action && action.type === ActionTypes.REPLACE) return;

  if (unexpectedKeys.length > 0) {
    return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, {
      type: ActionTypes.INIT
    });

    if (typeof initialState === 'undefined') {
      throw new Error( true ? formatProdErrorMessage(12) : 0);
    }

    if (typeof reducer(undefined, {
      type: ActionTypes.PROBE_UNKNOWN_ACTION()
    }) === 'undefined') {
      throw new Error( true ? formatProdErrorMessage(13) : 0);
    }
  });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */


function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};

  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {}

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }

  var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
  // keys multiple times.

  var unexpectedKeyCache;

  if (false) {}

  var shapeAssertionError;

  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination(state, action) {
    if (state === void 0) {
      state = {};
    }

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) { var warningMessage; }

    var hasChanged = false;
    var nextState = {};

    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);

      if (typeof nextStateForKey === 'undefined') {
        var actionType = action && action.type;
        throw new Error( true ? formatProdErrorMessage(14) : 0);
      }

      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }

    hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
    return hasChanged ? nextState : state;
  };
}

function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(this, arguments));
  };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */


function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error( true ? formatProdErrorMessage(16) : 0);
  }

  var boundActionCreators = {};

  for (var key in actionCreators) {
    var actionCreator = actionCreators[key];

    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }

  return boundActionCreators;
}

/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */
function compose() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(void 0, arguments));
    };
  });
}

/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */

function applyMiddleware() {
  for (var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function () {
      var store = createStore.apply(void 0, arguments);

      var _dispatch = function dispatch() {
        throw new Error( true ? formatProdErrorMessage(15) : 0);
      };

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch() {
          return _dispatch.apply(void 0, arguments);
        }
      };
      var chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = compose.apply(void 0, chain)(store.dispatch);
      return _objectSpread2(_objectSpread2({}, store), {}, {
        dispatch: _dispatch
      });
    };
  };
}




/***/ }),

/***/ 91033:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */
/* eslint-disable require-jsdoc, valid-jsdoc */
var MapShim = (function () {
    if (typeof Map !== 'undefined') {
        return Map;
    }
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */
    function getIndex(arr, key) {
        var result = -1;
        arr.some(function (entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ (function () {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */
            get: function () {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */
        class_1.prototype.get = function (key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */
        class_1.prototype.set = function (key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) {
                this.__entries__[index][1] = value;
            }
            else {
                this.__entries__.push([key, value]);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.delete = function (key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) {
                entries.splice(index, 1);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.has = function (key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */
        class_1.prototype.clear = function () {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */
        class_1.prototype.forEach = function (callback, ctx) {
            if (ctx === void 0) { ctx = null; }
            for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }());
})();

/**
 * Detects whether window and document objects are available in current environment.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;

// Returns global object of a current environment.
var global$1 = (function () {
    if (typeof __webpack_require__.g !== 'undefined' && __webpack_require__.g.Math === Math) {
        return __webpack_require__.g;
    }
    if (typeof self !== 'undefined' && self.Math === Math) {
        return self;
    }
    if (typeof window !== 'undefined' && window.Math === Math) {
        return window;
    }
    // eslint-disable-next-line no-new-func
    return Function('return this')();
})();

/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */
var requestAnimationFrame$1 = (function () {
    if (typeof requestAnimationFrame === 'function') {
        // It's required to use a bounded function because IE sometimes throws
        // an "Invalid calling object" error if rAF is invoked without the global
        // object on the left hand side.
        return requestAnimationFrame.bind(global$1);
    }
    return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
})();

// Defines minimum timeout before adding a trailing call.
var trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */
function throttle (callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */
    function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) {
            proxy();
        }
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */
    function timeoutCallback() {
        requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */
    function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < trailingTimeout) {
                return;
            }
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        }
        else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}

// Minimum delay before invoking the update of observers.
var REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
// Check if MutationObserver is available.
var mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */
var ResizeObserverController = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */
    function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */
        this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */
        this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */
        this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */
        this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */
    ResizeObserverController.prototype.addObserver = function (observer) {
        if (!~this.observers_.indexOf(observer)) {
            this.observers_.push(observer);
        }
        // Add listeners if they haven't been added yet.
        if (!this.connected_) {
            this.connect_();
        }
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */
    ResizeObserverController.prototype.removeObserver = function (observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) {
            observers.splice(index, 1);
        }
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) {
            this.disconnect_();
        }
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */
    ResizeObserverController.prototype.refresh = function () {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) {
            this.refresh();
        }
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */
    ResizeObserverController.prototype.updateObservers_ = function () {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function (observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.connect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!isBrowser || this.connected_) {
            return;
        }
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if (mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        }
        else {
            document.addEventListener('DOMSubtreeModified', this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.disconnect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!isBrowser || !this.connected_) {
            return;
        }
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) {
            this.mutationsObserver_.disconnect();
        }
        if (this.mutationEventsAdded_) {
            document.removeEventListener('DOMSubtreeModified', this.refresh);
        }
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */
    ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = transitionKeys.some(function (key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) {
            this.refresh();
        }
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */
    ResizeObserverController.getInstance = function () {
        if (!this.instance_) {
            this.instance_ = new ResizeObserverController();
        }
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */
    ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}());

/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */
var defineConfigurable = (function (target, props) {
    for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
});

/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */
var getWindowOf = (function (target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || global$1;
});

// Placeholder of an empty content rectangle.
var emptyRect = createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */
function toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */
function getBordersSize(styles) {
    var positions = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        positions[_i - 1] = arguments[_i];
    }
    return positions.reduce(function (size, position) {
        var value = styles['border-' + position + '-width'];
        return size + toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */
function getPaddings(styles) {
    var positions = ['top', 'right', 'bottom', 'left'];
    var paddings = {};
    for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */
function getSVGContentRect(target) {
    var bbox = target.getBBox();
    return createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */
function getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) {
        return emptyRect;
    }
    var styles = getWindowOf(target).getComputedStyle(target);
    var paddings = getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = toFloat(styles.width), height = toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) {
            width -= getBordersSize(styles, 'left', 'right') + horizPad;
        }
        if (Math.round(height + vertPad) !== clientHeight) {
            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
        }
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) {
            width -= vertScrollbar;
        }
        if (Math.abs(horizScrollbar) !== 1) {
            height -= horizScrollbar;
        }
    }
    return createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
var isSVGGraphicsElement = (function () {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') {
        return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
    }
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
        typeof target.getBBox === 'function'); };
})();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
function isDocumentElement(target) {
    return target === getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */
function getContentRect(target) {
    if (!isBrowser) {
        return emptyRect;
    }
    if (isSVGGraphicsElement(target)) {
        return getSVGContentRect(target);
    }
    return getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */
function createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    defineConfigurable(rect, {
        x: x, y: y, width: width, height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */
function createRectInit(x, y, width, height) {
    return { x: x, y: y, width: width, height: height };
}

/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */
var ResizeObservation = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */
    function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */
        this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */
        this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */
        this.contentRect_ = createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */
    ResizeObservation.prototype.isActive = function () {
        var rect = getContentRect(this.target);
        this.contentRect_ = rect;
        return (rect.width !== this.broadcastWidth ||
            rect.height !== this.broadcastHeight);
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */
    ResizeObservation.prototype.broadcastRect = function () {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}());

var ResizeObserverEntry = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */
    function ResizeObserverEntry(target, rectInit) {
        var contentRect = createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        defineConfigurable(this, { target: target, contentRect: contentRect });
    }
    return ResizeObserverEntry;
}());

var ResizeObserverSPI = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */
    function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */
        this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */
        this.observations_ = new MapShim();
        if (typeof callback !== 'function') {
            throw new TypeError('The callback provided as parameter 1 is not a function.');
        }
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.observe = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) {
            return;
        }
        observations.set(target, new ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.unobserve = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) {
            return;
        }
        observations.delete(target);
        if (!observations.size) {
            this.controller_.removeObserver(this);
        }
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.disconnect = function () {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.gatherActive = function () {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function (observation) {
            if (observation.isActive()) {
                _this.activeObservations_.push(observation);
            }
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.broadcastActive = function () {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) {
            return;
        }
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function (observation) {
            return new ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.clearActive = function () {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */
    ResizeObserverSPI.prototype.hasActive = function () {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}());

// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */
var ResizeObserver = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */
    function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) {
            throw new TypeError('Cannot call a class as a function.');
        }
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        var controller = ResizeObserverController.getInstance();
        var observer = new ResizeObserverSPI(callback, controller, this);
        observers.set(this, observer);
    }
    return ResizeObserver;
}());
// Expose public methods of ResizeObserver.
[
    'observe',
    'unobserve',
    'disconnect'
].forEach(function (method) {
    ResizeObserver.prototype[method] = function () {
        var _a;
        return (_a = observers.get(this))[method].apply(_a, arguments);
    };
});

var index = (function () {
    // Export existing implementation if available.
    if (typeof global$1.ResizeObserver !== 'undefined') {
        return global$1.ResizeObserver;
    }
    return ResizeObserver;
})();

/* harmony default export */ __webpack_exports__["default"] = (index);


/***/ }),

/***/ 89509:
/***/ (function(module, exports, __webpack_require__) {

/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
/* eslint-disable node/no-deprecated-api */
var buffer = __webpack_require__(48764)
var Buffer = buffer.Buffer

// alternative to using Object.keys for old browsers
function copyProps (src, dst) {
  for (var key in src) {
    dst[key] = src[key]
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports)
  exports.Buffer = SafeBuffer
}

function SafeBuffer (arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.prototype = Object.create(Buffer.prototype)

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer)

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number')
  }
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  var buf = Buffer(size)
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
  } else {
    buf.fill(0)
  }
  return buf
}

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return Buffer(size)
}

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return buffer.SlowBuffer(size)
}


/***/ }),

/***/ 35747:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var inspect = __webpack_require__(70631);

var $TypeError = __webpack_require__(14453);

/*
* This function traverses the list returning the node corresponding to the given key.
*
* That node is also moved to the head of the list, so that if it's accessed again we don't need to traverse the whole list.
* By doing so, all the recently used nodes can be accessed relatively quickly.
*/
/** @type {import('./list.d.ts').listGetNode} */
// eslint-disable-next-line consistent-return
var listGetNode = function (list, key, isDelete) {
	/** @type {typeof list | NonNullable<(typeof list)['next']>} */
	var prev = list;
	/** @type {(typeof list)['next']} */
	var curr;
	// eslint-disable-next-line eqeqeq
	for (; (curr = prev.next) != null; prev = curr) {
		if (curr.key === key) {
			prev.next = curr.next;
			if (!isDelete) {
				// eslint-disable-next-line no-extra-parens
				curr.next = /** @type {NonNullable<typeof list.next>} */ (list.next);
				list.next = curr; // eslint-disable-line no-param-reassign
			}
			return curr;
		}
	}
};

/** @type {import('./list.d.ts').listGet} */
var listGet = function (objects, key) {
	if (!objects) {
		return void undefined;
	}
	var node = listGetNode(objects, key);
	return node && node.value;
};
/** @type {import('./list.d.ts').listSet} */
var listSet = function (objects, key, value) {
	var node = listGetNode(objects, key);
	if (node) {
		node.value = value;
	} else {
		// Prepend the new node to the beginning of the list
		objects.next = /** @type {import('./list.d.ts').ListNode<typeof value, typeof key>} */ ({ // eslint-disable-line no-param-reassign, no-extra-parens
			key: key,
			next: objects.next,
			value: value
		});
	}
};
/** @type {import('./list.d.ts').listHas} */
var listHas = function (objects, key) {
	if (!objects) {
		return false;
	}
	return !!listGetNode(objects, key);
};
/** @type {import('./list.d.ts').listDelete} */
// eslint-disable-next-line consistent-return
var listDelete = function (objects, key) {
	if (objects) {
		return listGetNode(objects, key, true);
	}
};

/** @type {import('.')} */
module.exports = function getSideChannelList() {
	/** @typedef {ReturnType<typeof getSideChannelList>} Channel */
	/** @typedef {Parameters<Channel['get']>[0]} K */
	/** @typedef {Parameters<Channel['set']>[1]} V */

	/** @type {import('./list.d.ts').RootNode<V, K> | undefined} */ var $o;

	/** @type {Channel} */
	var channel = {
		assert: function (key) {
			if (!channel.has(key)) {
				throw new $TypeError('Side channel does not contain ' + inspect(key));
			}
		},
		'delete': function (key) {
			var root = $o && $o.next;
			var deletedNode = listDelete($o, key);
			if (deletedNode && root && root === deletedNode) {
				$o = void undefined;
			}
			return !!deletedNode;
		},
		get: function (key) {
			return listGet($o, key);
		},
		has: function (key) {
			return listHas($o, key);
		},
		set: function (key, value) {
			if (!$o) {
				// Initialize the linked list as an empty node, so that we don't have to special-case handling of the first node: we can always refer to it as (previous node).next, instead of something like (list).head
				$o = {
					next: void undefined
				};
			}
			// eslint-disable-next-line no-extra-parens
			listSet(/** @type {NonNullable<typeof $o>} */ ($o), key, value);
		}
	};
	// @ts-expect-error TODO: figure out why this is erroring
	return channel;
};


/***/ }),

/***/ 23595:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(40210);
var callBound = __webpack_require__(17379);
var inspect = __webpack_require__(70631);

var $TypeError = __webpack_require__(14453);
var $Map = GetIntrinsic('%Map%', true);

/** @type {<K, V>(thisArg: Map<K, V>, key: K) => V} */
var $mapGet = callBound('Map.prototype.get', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K, value: V) => void} */
var $mapSet = callBound('Map.prototype.set', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */
var $mapHas = callBound('Map.prototype.has', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */
var $mapDelete = callBound('Map.prototype.delete', true);
/** @type {<K, V>(thisArg: Map<K, V>) => number} */
var $mapSize = callBound('Map.prototype.size', true);

/** @type {import('.')} */
module.exports = !!$Map && /** @type {Exclude<import('.'), false>} */ function getSideChannelMap() {
	/** @typedef {ReturnType<typeof getSideChannelMap>} Channel */
	/** @typedef {Parameters<Channel['get']>[0]} K */
	/** @typedef {Parameters<Channel['set']>[1]} V */

	/** @type {Map<K, V> | undefined} */ var $m;

	/** @type {Channel} */
	var channel = {
		assert: function (key) {
			if (!channel.has(key)) {
				throw new $TypeError('Side channel does not contain ' + inspect(key));
			}
		},
		'delete': function (key) {
			if ($m) {
				var result = $mapDelete($m, key);
				if ($mapSize($m) === 0) {
					$m = void undefined;
				}
				return result;
			}
			return false;
		},
		get: function (key) { // eslint-disable-line consistent-return
			if ($m) {
				return $mapGet($m, key);
			}
		},
		has: function (key) {
			if ($m) {
				return $mapHas($m, key);
			}
			return false;
		},
		set: function (key, value) {
			if (!$m) {
				// @ts-expect-error TS can't handle narrowing a variable inside a closure
				$m = new $Map();
			}
			$mapSet($m, key, value);
		}
	};

	// @ts-expect-error TODO: figure out why TS is erroring here
	return channel;
};


/***/ }),

/***/ 69034:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(40210);
var callBound = __webpack_require__(17379);
var inspect = __webpack_require__(70631);
var getSideChannelMap = __webpack_require__(23595);

var $TypeError = __webpack_require__(14453);
var $WeakMap = GetIntrinsic('%WeakMap%', true);

/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => V} */
var $weakMapGet = callBound('WeakMap.prototype.get', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K, value: V) => void} */
var $weakMapSet = callBound('WeakMap.prototype.set', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */
var $weakMapHas = callBound('WeakMap.prototype.has', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */
var $weakMapDelete = callBound('WeakMap.prototype.delete', true);

/** @type {import('.')} */
module.exports = $WeakMap
	? /** @type {Exclude<import('.'), false>} */ function getSideChannelWeakMap() {
		/** @typedef {ReturnType<typeof getSideChannelWeakMap>} Channel */
		/** @typedef {Parameters<Channel['get']>[0]} K */
		/** @typedef {Parameters<Channel['set']>[1]} V */

		/** @type {WeakMap<K & object, V> | undefined} */ var $wm;
		/** @type {Channel | undefined} */ var $m;

		/** @type {Channel} */
		var channel = {
			assert: function (key) {
				if (!channel.has(key)) {
					throw new $TypeError('Side channel does not contain ' + inspect(key));
				}
			},
			'delete': function (key) {
				if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
					if ($wm) {
						return $weakMapDelete($wm, key);
					}
				} else if (getSideChannelMap) {
					if ($m) {
						return $m['delete'](key);
					}
				}
				return false;
			},
			get: function (key) {
				if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
					if ($wm) {
						return $weakMapGet($wm, key);
					}
				}
				return $m && $m.get(key);
			},
			has: function (key) {
				if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
					if ($wm) {
						return $weakMapHas($wm, key);
					}
				}
				return !!$m && $m.has(key);
			},
			set: function (key, value) {
				if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
					if (!$wm) {
						$wm = new $WeakMap();
					}
					$weakMapSet($wm, key, value);
				} else if (getSideChannelMap) {
					if (!$m) {
						$m = getSideChannelMap();
					}
					// eslint-disable-next-line no-extra-parens
					/** @type {NonNullable<typeof $m>} */ ($m).set(key, value);
				}
			}
		};

		// @ts-expect-error TODO: figure out why this is erroring
		return channel;
	}
	: getSideChannelMap;


/***/ }),

/***/ 37478:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var $TypeError = __webpack_require__(14453);
var inspect = __webpack_require__(70631);
var getSideChannelList = __webpack_require__(35747);
var getSideChannelMap = __webpack_require__(23595);
var getSideChannelWeakMap = __webpack_require__(69034);

var makeChannel = getSideChannelWeakMap || getSideChannelMap || getSideChannelList;

/** @type {import('.')} */
module.exports = function getSideChannel() {
	/** @typedef {ReturnType<typeof getSideChannel>} Channel */

	/** @type {Channel | undefined} */ var $channelData;

	/** @type {Channel} */
	var channel = {
		assert: function (key) {
			if (!channel.has(key)) {
				throw new $TypeError('Side channel does not contain ' + inspect(key));
			}
		},
		'delete': function (key) {
			return !!$channelData && $channelData['delete'](key);
		},
		get: function (key) {
			return $channelData && $channelData.get(key);
		},
		has: function (key) {
			return !!$channelData && $channelData.has(key);
		},
		set: function (key, value) {
			if (!$channelData) {
				$channelData = makeChannel();
			}

			$channelData.set(key, value);
		}
	};
	// @ts-expect-error TODO: figure out why this is erroring
	return channel;
};


/***/ }),

/***/ 71169:
/***/ (function(module) {

var camel2hyphen = function (str) {
  return str
          .replace(/[A-Z]/g, function (match) {
            return '-' + match.toLowerCase();
          })
          .toLowerCase();
};

module.exports = camel2hyphen;

/***/ }),

/***/ 41476:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var style_to_object_1 = __importDefault(__webpack_require__(57848));
var utilities_1 = __webpack_require__(26678);
function StyleToJS(style, options) {
    var output = {};
    if (!style || typeof style !== 'string') {
        return output;
    }
    (0, style_to_object_1["default"])(style, function (property, value) {
        if (property && value) {
            output[(0, utilities_1.camelCase)(property, options)] = value;
        }
    });
    return output;
}
exports["default"] = StyleToJS;


/***/ }),

/***/ 26678:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

exports.__esModule = true;
exports.camelCase = void 0;
var CUSTOM_PROPERTY_REGEX = /^--[a-zA-Z0-9-]+$/;
var HYPHEN_REGEX = /-([a-z])/g;
var NO_HYPHEN_REGEX = /^[^-]+$/;
var VENDOR_PREFIX_REGEX = /^-(webkit|moz|ms|o|khtml)-/;
var MS_VENDOR_PREFIX_REGEX = /^-(ms)-/;
var skipCamelCase = function (property) {
    return !property ||
        NO_HYPHEN_REGEX.test(property) ||
        CUSTOM_PROPERTY_REGEX.test(property);
};
var capitalize = function (match, character) {
    return character.toUpperCase();
};
var trimHyphen = function (match, prefix) { return "".concat(prefix, "-"); };
var camelCase = function (property, options) {
    if (options === void 0) { options = {}; }
    if (skipCamelCase(property)) {
        return property;
    }
    property = property.toLowerCase();
    if (options.reactCompat) {
        property = property.replace(MS_VENDOR_PREFIX_REGEX, trimHyphen);
    }
    else {
        property = property.replace(VENDOR_PREFIX_REGEX, trimHyphen);
    }
    return property.replace(HYPHEN_REGEX, capitalize);
};
exports.camelCase = camelCase;


/***/ }),

/***/ 57848:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parse = __webpack_require__(18139);

/**
 * Parses inline style to object.
 *
 * @example
 * // returns { 'line-height': '42' }
 * StyleToObject('line-height: 42;');
 *
 * @param  {String}      style      - The inline style.
 * @param  {Function}    [iterator] - The iterator function.
 * @return {null|Object}
 */
function StyleToObject(style, iterator) {
  var output = null;
  if (!style || typeof style !== 'string') {
    return output;
  }

  var declaration;
  var declarations = parse(style);
  var hasIterator = typeof iterator === 'function';
  var property;
  var value;

  for (var i = 0, len = declarations.length; i < len; i++) {
    declaration = declarations[i];
    property = declaration.property;
    value = declaration.value;

    if (hasIterator) {
      iterator(property, value, declaration);
    } else if (value) {
      output || (output = {});
      output[property] = value;
    }
  }

  return output;
}

module.exports = StyleToObject;
module.exports["default"] = StyleToObject; // ESM support


/***/ }),

/***/ 74279:
/***/ (function(module) {

function E () {
  // Keep this empty so it's easier to inherit from
  // (via https://github.com/lipsmack from https://github.com/scottcorgan/tiny-emitter/issues/3)
}

E.prototype = {
  on: function (name, callback, ctx) {
    var e = this.e || (this.e = {});

    (e[name] || (e[name] = [])).push({
      fn: callback,
      ctx: ctx
    });

    return this;
  },

  once: function (name, callback, ctx) {
    var self = this;
    function listener () {
      self.off(name, listener);
      callback.apply(ctx, arguments);
    };

    listener._ = callback
    return this.on(name, listener, ctx);
  },

  emit: function (name) {
    var data = [].slice.call(arguments, 1);
    var evtArr = ((this.e || (this.e = {}))[name] || []).slice();
    var i = 0;
    var len = evtArr.length;

    for (i; i < len; i++) {
      evtArr[i].fn.apply(evtArr[i].ctx, data);
    }

    return this;
  },

  off: function (name, callback) {
    var e = this.e || (this.e = {});
    var evts = e[name];
    var liveEvents = [];

    if (evts && callback) {
      for (var i = 0, len = evts.length; i < len; i++) {
        if (evts[i].fn !== callback && evts[i].fn._ !== callback)
          liveEvents.push(evts[i]);
      }
    }

    // Remove event from queue to prevent memory leak
    // Suggested by https://github.com/lazd
    // Ref: https://github.com/scottcorgan/tiny-emitter/commit/c6ebfaa9bc973b33d110a84a307742b7cf94c953#commitcomment-5024910

    (liveEvents.length)
      ? e[name] = liveEvents
      : delete e[name];

    return this;
  }
};

module.exports = E;


/***/ }),

/***/ 65885:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ es6; }
});

// EXTERNAL MODULE: ./node_modules/cookie/index.js
var cookie = __webpack_require__(76489);
;// CONCATENATED MODULE: ./node_modules/universal-cookie/es6/utils.js

function hasDocumentCookie() {
    // Can we get/set cookies on document.cookie?
    return typeof document === 'object' && typeof document.cookie === 'string';
}
function cleanCookies() {
    document.cookie.split(';').forEach(function (c) {
        document.cookie = c
            .replace(/^ +/, '')
            .replace(/=.*/, '=;expires=' + new Date().toUTCString() + ';path=/');
    });
}
function parseCookies(cookies, options) {
    if (typeof cookies === 'string') {
        return cookie/* parse */.Q(cookies, options);
    }
    else if (typeof cookies === 'object' && cookies !== null) {
        return cookies;
    }
    else {
        return {};
    }
}
function isParsingCookie(value, doNotParse) {
    if (typeof doNotParse === 'undefined') {
        // We guess if the cookie start with { or [, it has been serialized
        doNotParse =
            !value || (value[0] !== '{' && value[0] !== '[' && value[0] !== '"');
    }
    return !doNotParse;
}
function readCookie(value, options) {
    if (options === void 0) { options = {}; }
    var cleanValue = cleanupCookieValue(value);
    if (isParsingCookie(cleanValue, options.doNotParse)) {
        try {
            return JSON.parse(cleanValue);
        }
        catch (e) {
            // At least we tried
        }
    }
    // Ignore clean value if we failed the deserialization
    // It is not relevant anymore to trim those values
    return value;
}
function cleanupCookieValue(value) {
    // express prepend j: before serializing a cookie
    if (value && value[0] === 'j' && value[1] === ':') {
        return value.substr(2);
    }
    return value;
}

;// CONCATENATED MODULE: ./node_modules/universal-cookie/es6/Cookies.js
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};


var Cookies = /** @class */ (function () {
    function Cookies(cookies, options) {
        var _this = this;
        this.changeListeners = [];
        this.HAS_DOCUMENT_COOKIE = false;
        this.cookies = parseCookies(cookies, options);
        new Promise(function () {
            _this.HAS_DOCUMENT_COOKIE = hasDocumentCookie();
        }).catch(function () { });
    }
    Cookies.prototype._updateBrowserValues = function (parseOptions) {
        if (!this.HAS_DOCUMENT_COOKIE) {
            return;
        }
        this.cookies = cookie/* parse */.Q(document.cookie, parseOptions);
    };
    Cookies.prototype._emitChange = function (params) {
        for (var i = 0; i < this.changeListeners.length; ++i) {
            this.changeListeners[i](params);
        }
    };
    Cookies.prototype.get = function (name, options, parseOptions) {
        if (options === void 0) { options = {}; }
        this._updateBrowserValues(parseOptions);
        return readCookie(this.cookies[name], options);
    };
    Cookies.prototype.getAll = function (options, parseOptions) {
        if (options === void 0) { options = {}; }
        this._updateBrowserValues(parseOptions);
        var result = {};
        for (var name_1 in this.cookies) {
            result[name_1] = readCookie(this.cookies[name_1], options);
        }
        return result;
    };
    Cookies.prototype.set = function (name, value, options) {
        var _a;
        if (typeof value === 'object') {
            value = JSON.stringify(value);
        }
        this.cookies = __assign(__assign({}, this.cookies), (_a = {}, _a[name] = value, _a));
        if (this.HAS_DOCUMENT_COOKIE) {
            document.cookie = cookie/* serialize */.q(name, value, options);
        }
        this._emitChange({ name: name, value: value, options: options });
    };
    Cookies.prototype.remove = function (name, options) {
        var finalOptions = (options = __assign(__assign({}, options), { expires: new Date(1970, 1, 1, 0, 0, 1), maxAge: 0 }));
        this.cookies = __assign({}, this.cookies);
        delete this.cookies[name];
        if (this.HAS_DOCUMENT_COOKIE) {
            document.cookie = cookie/* serialize */.q(name, '', finalOptions);
        }
        this._emitChange({ name: name, value: undefined, options: options });
    };
    Cookies.prototype.addChangeListener = function (callback) {
        this.changeListeners.push(callback);
    };
    Cookies.prototype.removeChangeListener = function (callback) {
        var idx = this.changeListeners.indexOf(callback);
        if (idx >= 0) {
            this.changeListeners.splice(idx, 1);
        }
    };
    return Cookies;
}());
/* harmony default export */ var es6_Cookies = (Cookies);

;// CONCATENATED MODULE: ./node_modules/universal-cookie/es6/index.js

/* harmony default export */ var es6 = (es6_Cookies);


/***/ }),

/***/ 71739:
/***/ (function(module) {

/**
 * This file automatically generated from `pre-publish.js`.
 * Do not manually edit.
 */

module.exports = {
  "area": true,
  "base": true,
  "br": true,
  "col": true,
  "embed": true,
  "hr": true,
  "img": true,
  "input": true,
  "link": true,
  "meta": true,
  "param": true,
  "source": true,
  "track": true,
  "wbr": true
};


/***/ }),

/***/ 42473:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),

/***/ 24654:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 199:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 93967:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = '';

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (arg) {
				classes = appendClass(classes, parseValue(arg));
			}
		}

		return classes;
	}

	function parseValue (arg) {
		if (typeof arg === 'string' || typeof arg === 'number') {
			return arg;
		}

		if (typeof arg !== 'object') {
			return '';
		}

		if (Array.isArray(arg)) {
			return classNames.apply(null, arg);
		}

		if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
			return arg.toString();
		}

		var classes = '';

		for (var key in arg) {
			if (hasOwn.call(arg, key) && arg[key]) {
				classes = appendClass(classes, key);
			}
		}

		return classes;
	}

	function appendClass (value, newClass) {
		if (!newClass) {
			return value;
		}
	
		if (value) {
			return value + ' ' + newClass;
		}
	
		return value + newClass;
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 7638:
/***/ (function(module, exports, __webpack_require__) {

var fetchApi = typeof fetch === 'function' ? fetch : undefined
if (typeof __webpack_require__.g !== 'undefined' && __webpack_require__.g.fetch) {
  fetchApi = __webpack_require__.g.fetch
} else if (typeof window !== 'undefined' && window.fetch) {
  fetchApi = window.fetch
}

if ( true && typeof window === 'undefined') {
  var f = fetchApi || __webpack_require__(54098)
  if (f.default) f = f.default
  exports["default"] = f
  module.exports = exports.default
}


/***/ }),

/***/ 78122:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _utils = __webpack_require__(58144);
var _request = _interopRequireDefault(__webpack_require__(93183));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var getDefaults = function getDefaults() {
  return {
    loadPath: '/locales/{{lng}}/{{ns}}.json',
    addPath: '/locales/add/{{lng}}/{{ns}}',
    parse: function parse(data) {
      return JSON.parse(data);
    },
    stringify: JSON.stringify,
    parsePayload: function parsePayload(namespace, key, fallbackValue) {
      return _defineProperty({}, key, fallbackValue || '');
    },
    parseLoadPayload: function parseLoadPayload(languages, namespaces) {
      return undefined;
    },
    request: _request.default,
    reloadInterval: typeof window !== 'undefined' ? false : 60 * 60 * 1000,
    customHeaders: {},
    queryStringParams: {},
    crossDomain: false,
    withCredentials: false,
    overrideMimeType: false,
    requestOptions: {
      mode: 'cors',
      credentials: 'same-origin',
      cache: 'default'
    }
  };
};
var Backend = function () {
  function Backend(services) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var allOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    _classCallCheck(this, Backend);
    this.services = services;
    this.options = options;
    this.allOptions = allOptions;
    this.type = 'backend';
    this.init(services, options, allOptions);
  }
  return _createClass(Backend, [{
    key: "init",
    value: function init(services) {
      var _this = this;
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var allOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      this.services = services;
      this.options = _objectSpread(_objectSpread(_objectSpread({}, getDefaults()), this.options || {}), options);
      this.allOptions = allOptions;
      if (this.services && this.options.reloadInterval) {
        var timer = setInterval(function () {
          return _this.reload();
        }, this.options.reloadInterval);
        if (_typeof(timer) === 'object' && typeof timer.unref === 'function') timer.unref();
      }
    }
  }, {
    key: "readMulti",
    value: function readMulti(languages, namespaces, callback) {
      this._readAny(languages, languages, namespaces, namespaces, callback);
    }
  }, {
    key: "read",
    value: function read(language, namespace, callback) {
      this._readAny([language], language, [namespace], namespace, callback);
    }
  }, {
    key: "_readAny",
    value: function _readAny(languages, loadUrlLanguages, namespaces, loadUrlNamespaces, callback) {
      var _this2 = this;
      var loadPath = this.options.loadPath;
      if (typeof this.options.loadPath === 'function') {
        loadPath = this.options.loadPath(languages, namespaces);
      }
      loadPath = (0, _utils.makePromise)(loadPath);
      loadPath.then(function (resolvedLoadPath) {
        if (!resolvedLoadPath) return callback(null, {});
        var url = _this2.services.interpolator.interpolate(resolvedLoadPath, {
          lng: languages.join('+'),
          ns: namespaces.join('+')
        });
        _this2.loadUrl(url, callback, loadUrlLanguages, loadUrlNamespaces);
      });
    }
  }, {
    key: "loadUrl",
    value: function loadUrl(url, callback, languages, namespaces) {
      var _this3 = this;
      var lng = typeof languages === 'string' ? [languages] : languages;
      var ns = typeof namespaces === 'string' ? [namespaces] : namespaces;
      var payload = this.options.parseLoadPayload(lng, ns);
      this.options.request(this.options, url, payload, function (err, res) {
        if (res && (res.status >= 500 && res.status < 600 || !res.status)) return callback('failed loading ' + url + '; status code: ' + res.status, true);
        if (res && res.status >= 400 && res.status < 500) return callback('failed loading ' + url + '; status code: ' + res.status, false);
        if (!res && err && err.message) {
          var errorMessage = err.message.toLowerCase();
          var isNetworkError = ['failed', 'fetch', 'network', 'load'].find(function (term) {
            return errorMessage.indexOf(term) > -1;
          });
          if (isNetworkError) {
            return callback('failed loading ' + url + ': ' + err.message, true);
          }
        }
        if (err) return callback(err, false);
        var ret, parseErr;
        try {
          if (typeof res.data === 'string') {
            ret = _this3.options.parse(res.data, languages, namespaces);
          } else {
            ret = res.data;
          }
        } catch (e) {
          parseErr = 'failed parsing ' + url + ' to json';
        }
        if (parseErr) return callback(parseErr, false);
        callback(null, ret);
      });
    }
  }, {
    key: "create",
    value: function create(languages, namespace, key, fallbackValue, callback) {
      var _this4 = this;
      if (!this.options.addPath) return;
      if (typeof languages === 'string') languages = [languages];
      var payload = this.options.parsePayload(namespace, key, fallbackValue);
      var finished = 0;
      var dataArray = [];
      var resArray = [];
      languages.forEach(function (lng) {
        var addPath = _this4.options.addPath;
        if (typeof _this4.options.addPath === 'function') {
          addPath = _this4.options.addPath(lng, namespace);
        }
        var url = _this4.services.interpolator.interpolate(addPath, {
          lng: lng,
          ns: namespace
        });
        _this4.options.request(_this4.options, url, payload, function (data, res) {
          finished += 1;
          dataArray.push(data);
          resArray.push(res);
          if (finished === languages.length) {
            if (typeof callback === 'function') callback(dataArray, resArray);
          }
        });
      });
    }
  }, {
    key: "reload",
    value: function reload() {
      var _this5 = this;
      var _this$services = this.services,
        backendConnector = _this$services.backendConnector,
        languageUtils = _this$services.languageUtils,
        logger = _this$services.logger;
      var currentLanguage = backendConnector.language;
      if (currentLanguage && currentLanguage.toLowerCase() === 'cimode') return;
      var toLoad = [];
      var append = function append(lng) {
        var lngs = languageUtils.toResolveHierarchy(lng);
        lngs.forEach(function (l) {
          if (toLoad.indexOf(l) < 0) toLoad.push(l);
        });
      };
      append(currentLanguage);
      if (this.allOptions.preload) this.allOptions.preload.forEach(function (l) {
        return append(l);
      });
      toLoad.forEach(function (lng) {
        _this5.allOptions.ns.forEach(function (ns) {
          backendConnector.read(lng, ns, 'read', null, null, function (err, data) {
            if (err) logger.warn("loading namespace ".concat(ns, " for language ").concat(lng, " failed"), err);
            if (!err && data) logger.log("loaded namespace ".concat(ns, " for language ").concat(lng), data);
            backendConnector.loaded("".concat(lng, "|").concat(ns), err, data);
          });
        });
      });
    }
  }]);
}();
Backend.type = 'backend';
var _default = exports["default"] = Backend;
module.exports = exports.default;

/***/ }),

/***/ 93183:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _utils = __webpack_require__(58144);
var fetchNode = _interopRequireWildcard(__webpack_require__(7638));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var fetchApi = typeof fetch === 'function' ? fetch : undefined;
if (typeof __webpack_require__.g !== 'undefined' && __webpack_require__.g.fetch) {
  fetchApi = __webpack_require__.g.fetch;
} else if (typeof window !== 'undefined' && window.fetch) {
  fetchApi = window.fetch;
}
var XmlHttpRequestApi;
if ((0, _utils.hasXMLHttpRequest)()) {
  if (typeof __webpack_require__.g !== 'undefined' && __webpack_require__.g.XMLHttpRequest) {
    XmlHttpRequestApi = __webpack_require__.g.XMLHttpRequest;
  } else if (typeof window !== 'undefined' && window.XMLHttpRequest) {
    XmlHttpRequestApi = window.XMLHttpRequest;
  }
}
var ActiveXObjectApi;
if (typeof ActiveXObject === 'function') {
  if (typeof __webpack_require__.g !== 'undefined' && __webpack_require__.g.ActiveXObject) {
    ActiveXObjectApi = __webpack_require__.g.ActiveXObject;
  } else if (typeof window !== 'undefined' && window.ActiveXObject) {
    ActiveXObjectApi = window.ActiveXObject;
  }
}
if (!fetchApi && fetchNode && !XmlHttpRequestApi && !ActiveXObjectApi) fetchApi = fetchNode.default || fetchNode;
if (typeof fetchApi !== 'function') fetchApi = undefined;
var addQueryString = function addQueryString(url, params) {
  if (params && _typeof(params) === 'object') {
    var queryString = '';
    for (var paramName in params) {
      queryString += '&' + encodeURIComponent(paramName) + '=' + encodeURIComponent(params[paramName]);
    }
    if (!queryString) return url;
    url = url + (url.indexOf('?') !== -1 ? '&' : '?') + queryString.slice(1);
  }
  return url;
};
var fetchIt = function fetchIt(url, fetchOptions, callback, altFetch) {
  var resolver = function resolver(response) {
    if (!response.ok) return callback(response.statusText || 'Error', {
      status: response.status
    });
    response.text().then(function (data) {
      callback(null, {
        status: response.status,
        data: data
      });
    }).catch(callback);
  };
  if (altFetch) {
    var altResponse = altFetch(url, fetchOptions);
    if (altResponse instanceof Promise) {
      altResponse.then(resolver).catch(callback);
      return;
    }
  }
  if (typeof fetch === 'function') {
    fetch(url, fetchOptions).then(resolver).catch(callback);
  } else {
    fetchApi(url, fetchOptions).then(resolver).catch(callback);
  }
};
var omitFetchOptions = false;
var requestWithFetch = function requestWithFetch(options, url, payload, callback) {
  if (options.queryStringParams) {
    url = addQueryString(url, options.queryStringParams);
  }
  var headers = _objectSpread({}, typeof options.customHeaders === 'function' ? options.customHeaders() : options.customHeaders);
  if (typeof window === 'undefined' && typeof __webpack_require__.g !== 'undefined' && typeof __webpack_require__.g.process !== 'undefined' && __webpack_require__.g.process.versions && __webpack_require__.g.process.versions.node) {
    headers['User-Agent'] = "i18next-http-backend (node/".concat(__webpack_require__.g.process.version, "; ").concat(__webpack_require__.g.process.platform, " ").concat(__webpack_require__.g.process.arch, ")");
  }
  if (payload) headers['Content-Type'] = 'application/json';
  var reqOptions = typeof options.requestOptions === 'function' ? options.requestOptions(payload) : options.requestOptions;
  var fetchOptions = _objectSpread({
    method: payload ? 'POST' : 'GET',
    body: payload ? options.stringify(payload) : undefined,
    headers: headers
  }, omitFetchOptions ? {} : reqOptions);
  var altFetch = typeof options.alternateFetch === 'function' && options.alternateFetch.length >= 1 ? options.alternateFetch : undefined;
  try {
    fetchIt(url, fetchOptions, callback, altFetch);
  } catch (e) {
    if (!reqOptions || Object.keys(reqOptions).length === 0 || !e.message || e.message.indexOf('not implemented') < 0) {
      return callback(e);
    }
    try {
      Object.keys(reqOptions).forEach(function (opt) {
        delete fetchOptions[opt];
      });
      fetchIt(url, fetchOptions, callback, altFetch);
      omitFetchOptions = true;
    } catch (err) {
      callback(err);
    }
  }
};
var requestWithXmlHttpRequest = function requestWithXmlHttpRequest(options, url, payload, callback) {
  if (payload && _typeof(payload) === 'object') {
    payload = addQueryString('', payload).slice(1);
  }
  if (options.queryStringParams) {
    url = addQueryString(url, options.queryStringParams);
  }
  try {
    var x;
    if (XmlHttpRequestApi) {
      x = new XmlHttpRequestApi();
    } else {
      x = new ActiveXObjectApi('MSXML2.XMLHTTP.3.0');
    }
    x.open(payload ? 'POST' : 'GET', url, 1);
    if (!options.crossDomain) {
      x.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    }
    x.withCredentials = !!options.withCredentials;
    if (payload) {
      x.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
    }
    if (x.overrideMimeType) {
      x.overrideMimeType('application/json');
    }
    var h = options.customHeaders;
    h = typeof h === 'function' ? h() : h;
    if (h) {
      for (var i in h) {
        x.setRequestHeader(i, h[i]);
      }
    }
    x.onreadystatechange = function () {
      x.readyState > 3 && callback(x.status >= 400 ? x.statusText : null, {
        status: x.status,
        data: x.responseText
      });
    };
    x.send(payload);
  } catch (e) {
    console && console.log(e);
  }
};
var request = function request(options, url, payload, callback) {
  if (typeof payload === 'function') {
    callback = payload;
    payload = undefined;
  }
  callback = callback || function () {};
  if (fetchApi && url.indexOf('file:') !== 0) {
    return requestWithFetch(options, url, payload, callback);
  }
  if ((0, _utils.hasXMLHttpRequest)() || typeof ActiveXObject === 'function') {
    return requestWithXmlHttpRequest(options, url, payload, callback);
  }
  callback(new Error('No fetch and no xhr implementation found!'));
};
var _default = exports["default"] = request;
module.exports = exports.default;

/***/ }),

/***/ 58144:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.defaults = defaults;
exports.hasXMLHttpRequest = hasXMLHttpRequest;
exports.makePromise = makePromise;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var arr = [];
var each = arr.forEach;
var slice = arr.slice;
function defaults(obj) {
  each.call(slice.call(arguments, 1), function (source) {
    if (source) {
      for (var prop in source) {
        if (obj[prop] === undefined) obj[prop] = source[prop];
      }
    }
  });
  return obj;
}
function hasXMLHttpRequest() {
  return typeof XMLHttpRequest === 'function' || (typeof XMLHttpRequest === "undefined" ? "undefined" : _typeof(XMLHttpRequest)) === 'object';
}
function isPromise(maybePromise) {
  return !!maybePromise && typeof maybePromise.then === 'function';
}
function makePromise(maybePromise) {
  if (isPromise(maybePromise)) {
    return maybePromise;
  }
  return Promise.resolve(maybePromise);
}

/***/ }),

/***/ 30907:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}


/***/ }),

/***/ 83878:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayWithHoles; }
/* harmony export */ });
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}


/***/ }),

/***/ 97326:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _assertThisInitialized; }
/* harmony export */ });
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}


/***/ }),

/***/ 15671:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _classCallCheck; }
/* harmony export */ });
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}


/***/ }),

/***/ 43144:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _createClass; }
/* harmony export */ });
/* harmony import */ var _toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83997);

function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0,_toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}


/***/ }),

/***/ 4942:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _defineProperty; }
/* harmony export */ });
/* harmony import */ var _toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83997);

function _defineProperty(e, r, t) {
  return (r = (0,_toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}


/***/ }),

/***/ 87462:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _extends; }
/* harmony export */ });
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}


/***/ }),

/***/ 61120:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _getPrototypeOf; }
/* harmony export */ });
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}


/***/ }),

/***/ 60136:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _inherits; }
/* harmony export */ });
/* harmony import */ var _setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89611);

function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && (0,_setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(t, e);
}


/***/ }),

/***/ 25267:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _nonIterableRest; }
/* harmony export */ });
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


/***/ }),

/***/ 45987:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectWithoutProperties; }
/* harmony export */ });
/* harmony import */ var _objectWithoutPropertiesLoose_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63366);

function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = (0,_objectWithoutPropertiesLoose_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}


/***/ }),

/***/ 63366:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectWithoutPropertiesLoose; }
/* harmony export */ });
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}


/***/ }),

/***/ 82963:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _possibleConstructorReturn; }
/* harmony export */ });
/* harmony import */ var _typeof_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71002);
/* harmony import */ var _assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97326);


function _possibleConstructorReturn(t, e) {
  if (e && ("object" == (0,_typeof_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return (0,_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(t);
}


/***/ }),

/***/ 89611:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _setPrototypeOf; }
/* harmony export */ });
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}


/***/ }),

/***/ 97685:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _slicedToArray; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js
var arrayWithHoles = __webpack_require__(83878);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(40181);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableRest.js
var nonIterableRest = __webpack_require__(25267);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js




function _slicedToArray(r, e) {
  return (0,arrayWithHoles/* default */.Z)(r) || _iterableToArrayLimit(r, e) || (0,unsupportedIterableToArray/* default */.Z)(r, e) || (0,nonIterableRest/* default */.Z)();
}


/***/ }),

/***/ 83997:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ toPropertyKey; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(71002);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toPrimitive.js

function toPrimitive(t, r) {
  if ("object" != (0,esm_typeof/* default */.Z)(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != (0,esm_typeof/* default */.Z)(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}

;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toPropertyKey.js


function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == (0,esm_typeof/* default */.Z)(i) ? i : i + "";
}


/***/ }),

/***/ 71002:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _typeof; }
/* harmony export */ });
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}


/***/ }),

/***/ 40181:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30907);

function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(r, a) : void 0;
  }
}


/***/ }),

/***/ 24750:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "x7": function() { return /* binding */ floating_ui_dom_arrow; },
  "Me": function() { return /* binding */ autoUpdate; },
  "oo": function() { return /* binding */ floating_ui_dom_computePosition; },
  "RR": function() { return /* binding */ floating_ui_dom_flip; },
  "Qo": function() { return /* binding */ floating_ui_dom_inline; },
  "dr": function() { return /* binding */ floating_ui_dom_limitShift; },
  "cv": function() { return /* binding */ floating_ui_dom_offset; },
  "uY": function() { return /* binding */ floating_ui_dom_shift; },
  "dp": function() { return /* binding */ floating_ui_dom_size; }
});

// UNUSED EXPORTS: autoPlacement, detectOverflow, getOverflowAncestors, hide, platform

;// CONCATENATED MODULE: ./node_modules/@floating-ui/utils/dist/floating-ui.utils.mjs
/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */

const floating_ui_utils_sides = (/* unused pure expression or super */ null && (['top', 'right', 'bottom', 'left']));
const alignments = (/* unused pure expression or super */ null && (['start', 'end']));
const floating_ui_utils_placements = /*#__PURE__*/(/* unused pure expression or super */ null && (floating_ui_utils_sides.reduce((acc, side) => acc.concat(side, side + "-" + alignments[0], side + "-" + alignments[1]), [])));
const min = Math.min;
const max = Math.max;
const round = Math.round;
const floor = Math.floor;
const createCoords = v => ({
  x: v,
  y: v
});
const oppositeSideMap = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom'
};
const oppositeAlignmentMap = {
  start: 'end',
  end: 'start'
};
function clamp(start, value, end) {
  return max(start, min(value, end));
}
function floating_ui_utils_evaluate(value, param) {
  return typeof value === 'function' ? value(param) : value;
}
function floating_ui_utils_getSide(placement) {
  return placement.split('-')[0];
}
function floating_ui_utils_getAlignment(placement) {
  return placement.split('-')[1];
}
function getOppositeAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}
function getAxisLength(axis) {
  return axis === 'y' ? 'height' : 'width';
}
function getSideAxis(placement) {
  return ['top', 'bottom'].includes(floating_ui_utils_getSide(placement)) ? 'y' : 'x';
}
function getAlignmentAxis(placement) {
  return getOppositeAxis(getSideAxis(placement));
}
function floating_ui_utils_getAlignmentSides(placement, rects, rtl) {
  if (rtl === void 0) {
    rtl = false;
  }
  const alignment = floating_ui_utils_getAlignment(placement);
  const alignmentAxis = getAlignmentAxis(placement);
  const length = getAxisLength(alignmentAxis);
  let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
  if (rects.reference[length] > rects.floating[length]) {
    mainAlignmentSide = getOppositePlacement(mainAlignmentSide);
  }
  return [mainAlignmentSide, getOppositePlacement(mainAlignmentSide)];
}
function getExpandedPlacements(placement) {
  const oppositePlacement = getOppositePlacement(placement);
  return [floating_ui_utils_getOppositeAlignmentPlacement(placement), oppositePlacement, floating_ui_utils_getOppositeAlignmentPlacement(oppositePlacement)];
}
function floating_ui_utils_getOppositeAlignmentPlacement(placement) {
  return placement.replace(/start|end/g, alignment => oppositeAlignmentMap[alignment]);
}
function getSideList(side, isStart, rtl) {
  const lr = ['left', 'right'];
  const rl = ['right', 'left'];
  const tb = ['top', 'bottom'];
  const bt = ['bottom', 'top'];
  switch (side) {
    case 'top':
    case 'bottom':
      if (rtl) return isStart ? rl : lr;
      return isStart ? lr : rl;
    case 'left':
    case 'right':
      return isStart ? tb : bt;
    default:
      return [];
  }
}
function getOppositeAxisPlacements(placement, flipAlignment, direction, rtl) {
  const alignment = floating_ui_utils_getAlignment(placement);
  let list = getSideList(floating_ui_utils_getSide(placement), direction === 'start', rtl);
  if (alignment) {
    list = list.map(side => side + "-" + alignment);
    if (flipAlignment) {
      list = list.concat(list.map(floating_ui_utils_getOppositeAlignmentPlacement));
    }
  }
  return list;
}
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, side => oppositeSideMap[side]);
}
function expandPaddingObject(padding) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...padding
  };
}
function getPaddingObject(padding) {
  return typeof padding !== 'number' ? expandPaddingObject(padding) : {
    top: padding,
    right: padding,
    bottom: padding,
    left: padding
  };
}
function rectToClientRect(rect) {
  const {
    x,
    y,
    width,
    height
  } = rect;
  return {
    width,
    height,
    top: y,
    left: x,
    right: x + width,
    bottom: y + height,
    x,
    y
  };
}



;// CONCATENATED MODULE: ./node_modules/@floating-ui/core/dist/floating-ui.core.mjs



function computeCoordsFromPlacement(_ref, placement, rtl) {
  let {
    reference,
    floating
  } = _ref;
  const sideAxis = getSideAxis(placement);
  const alignmentAxis = getAlignmentAxis(placement);
  const alignLength = getAxisLength(alignmentAxis);
  const side = floating_ui_utils_getSide(placement);
  const isVertical = sideAxis === 'y';
  const commonX = reference.x + reference.width / 2 - floating.width / 2;
  const commonY = reference.y + reference.height / 2 - floating.height / 2;
  const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
  let coords;
  switch (side) {
    case 'top':
      coords = {
        x: commonX,
        y: reference.y - floating.height
      };
      break;
    case 'bottom':
      coords = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;
    case 'right':
      coords = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;
    case 'left':
      coords = {
        x: reference.x - floating.width,
        y: commonY
      };
      break;
    default:
      coords = {
        x: reference.x,
        y: reference.y
      };
  }
  switch (floating_ui_utils_getAlignment(placement)) {
    case 'start':
      coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
      break;
    case 'end':
      coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
      break;
  }
  return coords;
}

/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */
const computePosition = async (reference, floating, config) => {
  const {
    placement = 'bottom',
    strategy = 'absolute',
    middleware = [],
    platform
  } = config;
  const validMiddleware = middleware.filter(Boolean);
  const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
  let rects = await platform.getElementRects({
    reference,
    floating,
    strategy
  });
  let {
    x,
    y
  } = computeCoordsFromPlacement(rects, placement, rtl);
  let statefulPlacement = placement;
  let middlewareData = {};
  let resetCount = 0;
  for (let i = 0; i < validMiddleware.length; i++) {
    const {
      name,
      fn
    } = validMiddleware[i];
    const {
      x: nextX,
      y: nextY,
      data,
      reset
    } = await fn({
      x,
      y,
      initialPlacement: placement,
      placement: statefulPlacement,
      strategy,
      middlewareData,
      rects,
      platform,
      elements: {
        reference,
        floating
      }
    });
    x = nextX != null ? nextX : x;
    y = nextY != null ? nextY : y;
    middlewareData = {
      ...middlewareData,
      [name]: {
        ...middlewareData[name],
        ...data
      }
    };
    if (reset && resetCount <= 50) {
      resetCount++;
      if (typeof reset === 'object') {
        if (reset.placement) {
          statefulPlacement = reset.placement;
        }
        if (reset.rects) {
          rects = reset.rects === true ? await platform.getElementRects({
            reference,
            floating,
            strategy
          }) : reset.rects;
        }
        ({
          x,
          y
        } = computeCoordsFromPlacement(rects, statefulPlacement, rtl));
      }
      i = -1;
    }
  }
  return {
    x,
    y,
    placement: statefulPlacement,
    strategy,
    middlewareData
  };
};

/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */
async function detectOverflow(state, options) {
  var _await$platform$isEle;
  if (options === void 0) {
    options = {};
  }
  const {
    x,
    y,
    platform,
    rects,
    elements,
    strategy
  } = state;
  const {
    boundary = 'clippingAncestors',
    rootBoundary = 'viewport',
    elementContext = 'floating',
    altBoundary = false,
    padding = 0
  } = floating_ui_utils_evaluate(options, state);
  const paddingObject = getPaddingObject(padding);
  const altContext = elementContext === 'floating' ? 'reference' : 'floating';
  const element = elements[altBoundary ? altContext : elementContext];
  const clippingClientRect = rectToClientRect(await platform.getClippingRect({
    element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || (await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating))),
    boundary,
    rootBoundary,
    strategy
  }));
  const rect = elementContext === 'floating' ? {
    x,
    y,
    width: rects.floating.width,
    height: rects.floating.height
  } : rects.reference;
  const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
  const offsetScale = (await (platform.isElement == null ? void 0 : platform.isElement(offsetParent))) ? (await (platform.getScale == null ? void 0 : platform.getScale(offsetParent))) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  };
  const elementClientRect = rectToClientRect(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements,
    rect,
    offsetParent,
    strategy
  }) : rect);
  return {
    top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
    bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
    left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
    right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
  };
}

/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */
const arrow = options => ({
  name: 'arrow',
  options,
  async fn(state) {
    const {
      x,
      y,
      placement,
      rects,
      platform,
      elements,
      middlewareData
    } = state;
    // Since `element` is required, we don't Partial<> the type.
    const {
      element,
      padding = 0
    } = floating_ui_utils_evaluate(options, state) || {};
    if (element == null) {
      return {};
    }
    const paddingObject = getPaddingObject(padding);
    const coords = {
      x,
      y
    };
    const axis = getAlignmentAxis(placement);
    const length = getAxisLength(axis);
    const arrowDimensions = await platform.getDimensions(element);
    const isYAxis = axis === 'y';
    const minProp = isYAxis ? 'top' : 'left';
    const maxProp = isYAxis ? 'bottom' : 'right';
    const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
    const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
    const startDiff = coords[axis] - rects.reference[axis];
    const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
    let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;

    // DOM platform can return `window` as the `offsetParent`.
    if (!clientSize || !(await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent)))) {
      clientSize = elements.floating[clientProp] || rects.floating[length];
    }
    const centerToReference = endDiff / 2 - startDiff / 2;

    // If the padding is large enough that it causes the arrow to no longer be
    // centered, modify the padding so that it is centered.
    const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
    const minPadding = min(paddingObject[minProp], largestPossiblePadding);
    const maxPadding = min(paddingObject[maxProp], largestPossiblePadding);

    // Make sure the arrow doesn't overflow the floating element if the center
    // point is outside the floating element's bounds.
    const min$1 = minPadding;
    const max = clientSize - arrowDimensions[length] - maxPadding;
    const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
    const offset = clamp(min$1, center, max);

    // If the reference is small enough that the arrow's padding causes it to
    // to point to nothing for an aligned placement, adjust the offset of the
    // floating element itself. To ensure `shift()` continues to take action,
    // a single reset is performed when this is true.
    const shouldAddOffset = !middlewareData.arrow && floating_ui_utils_getAlignment(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
    const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
    return {
      [axis]: coords[axis] + alignmentOffset,
      data: {
        [axis]: offset,
        centerOffset: center - offset - alignmentOffset,
        ...(shouldAddOffset && {
          alignmentOffset
        })
      },
      reset: shouldAddOffset
    };
  }
});

function getPlacementList(alignment, autoAlignment, allowedPlacements) {
  const allowedPlacementsSortedByAlignment = alignment ? [...allowedPlacements.filter(placement => getAlignment(placement) === alignment), ...allowedPlacements.filter(placement => getAlignment(placement) !== alignment)] : allowedPlacements.filter(placement => getSide(placement) === placement);
  return allowedPlacementsSortedByAlignment.filter(placement => {
    if (alignment) {
      return getAlignment(placement) === alignment || (autoAlignment ? getOppositeAlignmentPlacement(placement) !== placement : false);
    }
    return true;
  });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */
const autoPlacement = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'autoPlacement',
    options,
    async fn(state) {
      var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
      const {
        rects,
        middlewareData,
        placement,
        platform,
        elements
      } = state;
      const {
        crossAxis = false,
        alignment,
        allowedPlacements = placements,
        autoAlignment = true,
        ...detectOverflowOptions
      } = evaluate(options, state);
      const placements$1 = alignment !== undefined || allowedPlacements === placements ? getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
      const overflow = await detectOverflow(state, detectOverflowOptions);
      const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
      const currentPlacement = placements$1[currentIndex];
      if (currentPlacement == null) {
        return {};
      }
      const alignmentSides = getAlignmentSides(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));

      // Make `computeCoords` start from the right place.
      if (placement !== currentPlacement) {
        return {
          reset: {
            placement: placements$1[0]
          }
        };
      }
      const currentOverflows = [overflow[getSide(currentPlacement)], overflow[alignmentSides[0]], overflow[alignmentSides[1]]];
      const allOverflows = [...(((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || []), {
        placement: currentPlacement,
        overflows: currentOverflows
      }];
      const nextPlacement = placements$1[currentIndex + 1];

      // There are more placements to check.
      if (nextPlacement) {
        return {
          data: {
            index: currentIndex + 1,
            overflows: allOverflows
          },
          reset: {
            placement: nextPlacement
          }
        };
      }
      const placementsSortedByMostSpace = allOverflows.map(d => {
        const alignment = getAlignment(d.placement);
        return [d.placement, alignment && crossAxis ?
        // Check along the mainAxis and main crossAxis side.
        d.overflows.slice(0, 2).reduce((acc, v) => acc + v, 0) :
        // Check only the mainAxis.
        d.overflows[0], d.overflows];
      }).sort((a, b) => a[1] - b[1]);
      const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter(d => d[2].slice(0,
      // Aligned placements should not check their opposite crossAxis
      // side.
      getAlignment(d[0]) ? 2 : 3).every(v => v <= 0));
      const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
      if (resetPlacement !== placement) {
        return {
          data: {
            index: currentIndex + 1,
            overflows: allOverflows
          },
          reset: {
            placement: resetPlacement
          }
        };
      }
      return {};
    }
  };
};

/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */
const flip = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'flip',
    options,
    async fn(state) {
      var _middlewareData$arrow, _middlewareData$flip;
      const {
        placement,
        middlewareData,
        rects,
        initialPlacement,
        platform,
        elements
      } = state;
      const {
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = true,
        fallbackPlacements: specifiedFallbackPlacements,
        fallbackStrategy = 'bestFit',
        fallbackAxisSideDirection = 'none',
        flipAlignment = true,
        ...detectOverflowOptions
      } = floating_ui_utils_evaluate(options, state);

      // If a reset by the arrow was caused due to an alignment offset being
      // added, we should skip any logic now since `flip()` has already done its
      // work.
      // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
      if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) {
        return {};
      }
      const side = floating_ui_utils_getSide(placement);
      const initialSideAxis = getSideAxis(initialPlacement);
      const isBasePlacement = floating_ui_utils_getSide(initialPlacement) === initialPlacement;
      const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
      const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [getOppositePlacement(initialPlacement)] : getExpandedPlacements(initialPlacement));
      const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
      if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) {
        fallbackPlacements.push(...getOppositeAxisPlacements(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
      }
      const placements = [initialPlacement, ...fallbackPlacements];
      const overflow = await detectOverflow(state, detectOverflowOptions);
      const overflows = [];
      let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
      if (checkMainAxis) {
        overflows.push(overflow[side]);
      }
      if (checkCrossAxis) {
        const sides = floating_ui_utils_getAlignmentSides(placement, rects, rtl);
        overflows.push(overflow[sides[0]], overflow[sides[1]]);
      }
      overflowsData = [...overflowsData, {
        placement,
        overflows
      }];

      // One or more sides is overflowing.
      if (!overflows.every(side => side <= 0)) {
        var _middlewareData$flip2, _overflowsData$filter;
        const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
        const nextPlacement = placements[nextIndex];
        if (nextPlacement) {
          const ignoreCrossAxisOverflow = checkCrossAxis === 'alignment' ? initialSideAxis !== getSideAxis(nextPlacement) : false;
          if (!ignoreCrossAxisOverflow ||
          // We leave the current main axis only if every placement on that axis
          // overflows the main axis.
          overflowsData.every(d => d.overflows[0] > 0 && getSideAxis(d.placement) === initialSideAxis)) {
            // Try next placement and re-run the lifecycle.
            return {
              data: {
                index: nextIndex,
                overflows: overflowsData
              },
              reset: {
                placement: nextPlacement
              }
            };
          }
        }

        // First, find the candidates that fit on the mainAxis side of overflow,
        // then find the placement that fits the best on the main crossAxis side.
        let resetPlacement = (_overflowsData$filter = overflowsData.filter(d => d.overflows[0] <= 0).sort((a, b) => a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;

        // Otherwise fallback.
        if (!resetPlacement) {
          switch (fallbackStrategy) {
            case 'bestFit':
              {
                var _overflowsData$filter2;
                const placement = (_overflowsData$filter2 = overflowsData.filter(d => {
                  if (hasFallbackAxisSideDirection) {
                    const currentSideAxis = getSideAxis(d.placement);
                    return currentSideAxis === initialSideAxis ||
                    // Create a bias to the `y` side axis due to horizontal
                    // reading directions favoring greater width.
                    currentSideAxis === 'y';
                  }
                  return true;
                }).map(d => [d.placement, d.overflows.filter(overflow => overflow > 0).reduce((acc, overflow) => acc + overflow, 0)]).sort((a, b) => a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                if (placement) {
                  resetPlacement = placement;
                }
                break;
              }
            case 'initialPlacement':
              resetPlacement = initialPlacement;
              break;
          }
        }
        if (placement !== resetPlacement) {
          return {
            reset: {
              placement: resetPlacement
            }
          };
        }
      }
      return {};
    }
  };
};

function getSideOffsets(overflow, rect) {
  return {
    top: overflow.top - rect.height,
    right: overflow.right - rect.width,
    bottom: overflow.bottom - rect.height,
    left: overflow.left - rect.width
  };
}
function isAnySideFullyClipped(overflow) {
  return sides.some(side => overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */
const hide = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'hide',
    options,
    async fn(state) {
      const {
        rects
      } = state;
      const {
        strategy = 'referenceHidden',
        ...detectOverflowOptions
      } = evaluate(options, state);
      switch (strategy) {
        case 'referenceHidden':
          {
            const overflow = await detectOverflow(state, {
              ...detectOverflowOptions,
              elementContext: 'reference'
            });
            const offsets = getSideOffsets(overflow, rects.reference);
            return {
              data: {
                referenceHiddenOffsets: offsets,
                referenceHidden: isAnySideFullyClipped(offsets)
              }
            };
          }
        case 'escaped':
          {
            const overflow = await detectOverflow(state, {
              ...detectOverflowOptions,
              altBoundary: true
            });
            const offsets = getSideOffsets(overflow, rects.floating);
            return {
              data: {
                escapedOffsets: offsets,
                escaped: isAnySideFullyClipped(offsets)
              }
            };
          }
        default:
          {
            return {};
          }
      }
    }
  };
};

function getBoundingRect(rects) {
  const minX = min(...rects.map(rect => rect.left));
  const minY = min(...rects.map(rect => rect.top));
  const maxX = max(...rects.map(rect => rect.right));
  const maxY = max(...rects.map(rect => rect.bottom));
  return {
    x: minX,
    y: minY,
    width: maxX - minX,
    height: maxY - minY
  };
}
function getRectsByLine(rects) {
  const sortedRects = rects.slice().sort((a, b) => a.y - b.y);
  const groups = [];
  let prevRect = null;
  for (let i = 0; i < sortedRects.length; i++) {
    const rect = sortedRects[i];
    if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) {
      groups.push([rect]);
    } else {
      groups[groups.length - 1].push(rect);
    }
    prevRect = rect;
  }
  return groups.map(rect => rectToClientRect(getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */
const inline = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'inline',
    options,
    async fn(state) {
      const {
        placement,
        elements,
        rects,
        platform,
        strategy
      } = state;
      // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
      // ClientRect's bounds, despite the event listener being triggered. A
      // padding of 2 seems to handle this issue.
      const {
        padding = 2,
        x,
        y
      } = floating_ui_utils_evaluate(options, state);
      const nativeClientRects = Array.from((await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference))) || []);
      const clientRects = getRectsByLine(nativeClientRects);
      const fallback = rectToClientRect(getBoundingRect(nativeClientRects));
      const paddingObject = getPaddingObject(padding);
      function getBoundingClientRect() {
        // There are two rects and they are disjoined.
        if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) {
          // Find the first rect in which the point is fully inside.
          return clientRects.find(rect => x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
        }

        // There are 2 or more connected rects.
        if (clientRects.length >= 2) {
          if (getSideAxis(placement) === 'y') {
            const firstRect = clientRects[0];
            const lastRect = clientRects[clientRects.length - 1];
            const isTop = floating_ui_utils_getSide(placement) === 'top';
            const top = firstRect.top;
            const bottom = lastRect.bottom;
            const left = isTop ? firstRect.left : lastRect.left;
            const right = isTop ? firstRect.right : lastRect.right;
            const width = right - left;
            const height = bottom - top;
            return {
              top,
              bottom,
              left,
              right,
              width,
              height,
              x: left,
              y: top
            };
          }
          const isLeftSide = floating_ui_utils_getSide(placement) === 'left';
          const maxRight = max(...clientRects.map(rect => rect.right));
          const minLeft = min(...clientRects.map(rect => rect.left));
          const measureRects = clientRects.filter(rect => isLeftSide ? rect.left === minLeft : rect.right === maxRight);
          const top = measureRects[0].top;
          const bottom = measureRects[measureRects.length - 1].bottom;
          const left = minLeft;
          const right = maxRight;
          const width = right - left;
          const height = bottom - top;
          return {
            top,
            bottom,
            left,
            right,
            width,
            height,
            x: left,
            y: top
          };
        }
        return fallback;
      }
      const resetRects = await platform.getElementRects({
        reference: {
          getBoundingClientRect
        },
        floating: elements.floating,
        strategy
      });
      if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) {
        return {
          reset: {
            rects: resetRects
          }
        };
      }
      return {};
    }
  };
};

// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.

async function convertValueToCoords(state, options) {
  const {
    placement,
    platform,
    elements
  } = state;
  const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
  const side = floating_ui_utils_getSide(placement);
  const alignment = floating_ui_utils_getAlignment(placement);
  const isVertical = getSideAxis(placement) === 'y';
  const mainAxisMulti = ['left', 'top'].includes(side) ? -1 : 1;
  const crossAxisMulti = rtl && isVertical ? -1 : 1;
  const rawValue = floating_ui_utils_evaluate(options, state);

  // eslint-disable-next-line prefer-const
  let {
    mainAxis,
    crossAxis,
    alignmentAxis
  } = typeof rawValue === 'number' ? {
    mainAxis: rawValue,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: rawValue.mainAxis || 0,
    crossAxis: rawValue.crossAxis || 0,
    alignmentAxis: rawValue.alignmentAxis
  };
  if (alignment && typeof alignmentAxis === 'number') {
    crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
  }
  return isVertical ? {
    x: crossAxis * crossAxisMulti,
    y: mainAxis * mainAxisMulti
  } : {
    x: mainAxis * mainAxisMulti,
    y: crossAxis * crossAxisMulti
  };
}

/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */
const offset = function (options) {
  if (options === void 0) {
    options = 0;
  }
  return {
    name: 'offset',
    options,
    async fn(state) {
      var _middlewareData$offse, _middlewareData$arrow;
      const {
        x,
        y,
        placement,
        middlewareData
      } = state;
      const diffCoords = await convertValueToCoords(state, options);

      // If the placement is the same and the arrow caused an alignment offset
      // then we don't need to change the positioning coordinates.
      if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) {
        return {};
      }
      return {
        x: x + diffCoords.x,
        y: y + diffCoords.y,
        data: {
          ...diffCoords,
          placement
        }
      };
    }
  };
};

/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */
const shift = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'shift',
    options,
    async fn(state) {
      const {
        x,
        y,
        placement
      } = state;
      const {
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = false,
        limiter = {
          fn: _ref => {
            let {
              x,
              y
            } = _ref;
            return {
              x,
              y
            };
          }
        },
        ...detectOverflowOptions
      } = floating_ui_utils_evaluate(options, state);
      const coords = {
        x,
        y
      };
      const overflow = await detectOverflow(state, detectOverflowOptions);
      const crossAxis = getSideAxis(floating_ui_utils_getSide(placement));
      const mainAxis = getOppositeAxis(crossAxis);
      let mainAxisCoord = coords[mainAxis];
      let crossAxisCoord = coords[crossAxis];
      if (checkMainAxis) {
        const minSide = mainAxis === 'y' ? 'top' : 'left';
        const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
        const min = mainAxisCoord + overflow[minSide];
        const max = mainAxisCoord - overflow[maxSide];
        mainAxisCoord = clamp(min, mainAxisCoord, max);
      }
      if (checkCrossAxis) {
        const minSide = crossAxis === 'y' ? 'top' : 'left';
        const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
        const min = crossAxisCoord + overflow[minSide];
        const max = crossAxisCoord - overflow[maxSide];
        crossAxisCoord = clamp(min, crossAxisCoord, max);
      }
      const limitedCoords = limiter.fn({
        ...state,
        [mainAxis]: mainAxisCoord,
        [crossAxis]: crossAxisCoord
      });
      return {
        ...limitedCoords,
        data: {
          x: limitedCoords.x - x,
          y: limitedCoords.y - y,
          enabled: {
            [mainAxis]: checkMainAxis,
            [crossAxis]: checkCrossAxis
          }
        }
      };
    }
  };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */
const limitShift = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    options,
    fn(state) {
      const {
        x,
        y,
        placement,
        rects,
        middlewareData
      } = state;
      const {
        offset = 0,
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = true
      } = floating_ui_utils_evaluate(options, state);
      const coords = {
        x,
        y
      };
      const crossAxis = getSideAxis(placement);
      const mainAxis = getOppositeAxis(crossAxis);
      let mainAxisCoord = coords[mainAxis];
      let crossAxisCoord = coords[crossAxis];
      const rawOffset = floating_ui_utils_evaluate(offset, state);
      const computedOffset = typeof rawOffset === 'number' ? {
        mainAxis: rawOffset,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...rawOffset
      };
      if (checkMainAxis) {
        const len = mainAxis === 'y' ? 'height' : 'width';
        const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
        const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
        if (mainAxisCoord < limitMin) {
          mainAxisCoord = limitMin;
        } else if (mainAxisCoord > limitMax) {
          mainAxisCoord = limitMax;
        }
      }
      if (checkCrossAxis) {
        var _middlewareData$offse, _middlewareData$offse2;
        const len = mainAxis === 'y' ? 'width' : 'height';
        const isOriginSide = ['top', 'left'].includes(floating_ui_utils_getSide(placement));
        const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
        const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
        if (crossAxisCoord < limitMin) {
          crossAxisCoord = limitMin;
        } else if (crossAxisCoord > limitMax) {
          crossAxisCoord = limitMax;
        }
      }
      return {
        [mainAxis]: mainAxisCoord,
        [crossAxis]: crossAxisCoord
      };
    }
  };
};

/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */
const size = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'size',
    options,
    async fn(state) {
      var _state$middlewareData, _state$middlewareData2;
      const {
        placement,
        rects,
        platform,
        elements
      } = state;
      const {
        apply = () => {},
        ...detectOverflowOptions
      } = floating_ui_utils_evaluate(options, state);
      const overflow = await detectOverflow(state, detectOverflowOptions);
      const side = floating_ui_utils_getSide(placement);
      const alignment = floating_ui_utils_getAlignment(placement);
      const isYAxis = getSideAxis(placement) === 'y';
      const {
        width,
        height
      } = rects.floating;
      let heightSide;
      let widthSide;
      if (side === 'top' || side === 'bottom') {
        heightSide = side;
        widthSide = alignment === ((await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating))) ? 'start' : 'end') ? 'left' : 'right';
      } else {
        widthSide = side;
        heightSide = alignment === 'end' ? 'top' : 'bottom';
      }
      const maximumClippingHeight = height - overflow.top - overflow.bottom;
      const maximumClippingWidth = width - overflow.left - overflow.right;
      const overflowAvailableHeight = min(height - overflow[heightSide], maximumClippingHeight);
      const overflowAvailableWidth = min(width - overflow[widthSide], maximumClippingWidth);
      const noShift = !state.middlewareData.shift;
      let availableHeight = overflowAvailableHeight;
      let availableWidth = overflowAvailableWidth;
      if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) {
        availableWidth = maximumClippingWidth;
      }
      if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) {
        availableHeight = maximumClippingHeight;
      }
      if (noShift && !alignment) {
        const xMin = max(overflow.left, 0);
        const xMax = max(overflow.right, 0);
        const yMin = max(overflow.top, 0);
        const yMax = max(overflow.bottom, 0);
        if (isYAxis) {
          availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : max(overflow.left, overflow.right));
        } else {
          availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : max(overflow.top, overflow.bottom));
        }
      }
      await apply({
        ...state,
        availableWidth,
        availableHeight
      });
      const nextDimensions = await platform.getDimensions(elements.floating);
      if (width !== nextDimensions.width || height !== nextDimensions.height) {
        return {
          reset: {
            rects: true
          }
        };
      }
      return {};
    }
  };
};



// EXTERNAL MODULE: ./node_modules/@floating-ui/utils/dist/floating-ui.utils.dom.mjs
var floating_ui_utils_dom = __webpack_require__(37317);
;// CONCATENATED MODULE: ./node_modules/@floating-ui/dom/dist/floating-ui.dom.mjs





function getCssDimensions(element) {
  const css = (0,floating_ui_utils_dom/* getComputedStyle */.Dx)(element);
  // In testing environments, the `width` and `height` properties are empty
  // strings for SVG elements, returning NaN. Fallback to `0` in this case.
  let width = parseFloat(css.width) || 0;
  let height = parseFloat(css.height) || 0;
  const hasOffset = (0,floating_ui_utils_dom/* isHTMLElement */.Re)(element);
  const offsetWidth = hasOffset ? element.offsetWidth : width;
  const offsetHeight = hasOffset ? element.offsetHeight : height;
  const shouldFallback = round(width) !== offsetWidth || round(height) !== offsetHeight;
  if (shouldFallback) {
    width = offsetWidth;
    height = offsetHeight;
  }
  return {
    width,
    height,
    $: shouldFallback
  };
}

function unwrapElement(element) {
  return !(0,floating_ui_utils_dom/* isElement */.kK)(element) ? element.contextElement : element;
}

function getScale(element) {
  const domElement = unwrapElement(element);
  if (!(0,floating_ui_utils_dom/* isHTMLElement */.Re)(domElement)) {
    return createCoords(1);
  }
  const rect = domElement.getBoundingClientRect();
  const {
    width,
    height,
    $
  } = getCssDimensions(domElement);
  let x = ($ ? round(rect.width) : rect.width) / width;
  let y = ($ ? round(rect.height) : rect.height) / height;

  // 0, NaN, or Infinity should always fallback to 1.

  if (!x || !Number.isFinite(x)) {
    x = 1;
  }
  if (!y || !Number.isFinite(y)) {
    y = 1;
  }
  return {
    x,
    y
  };
}

const noOffsets = /*#__PURE__*/createCoords(0);
function getVisualOffsets(element) {
  const win = (0,floating_ui_utils_dom/* getWindow */.Jj)(element);
  if (!(0,floating_ui_utils_dom/* isWebKit */.Pf)() || !win.visualViewport) {
    return noOffsets;
  }
  return {
    x: win.visualViewport.offsetLeft,
    y: win.visualViewport.offsetTop
  };
}
function shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
  if (isFixed === void 0) {
    isFixed = false;
  }
  if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0,floating_ui_utils_dom/* getWindow */.Jj)(element)) {
    return false;
  }
  return isFixed;
}

function getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
  if (includeScale === void 0) {
    includeScale = false;
  }
  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }
  const clientRect = element.getBoundingClientRect();
  const domElement = unwrapElement(element);
  let scale = createCoords(1);
  if (includeScale) {
    if (offsetParent) {
      if ((0,floating_ui_utils_dom/* isElement */.kK)(offsetParent)) {
        scale = getScale(offsetParent);
      }
    } else {
      scale = getScale(element);
    }
  }
  const visualOffsets = shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? getVisualOffsets(domElement) : createCoords(0);
  let x = (clientRect.left + visualOffsets.x) / scale.x;
  let y = (clientRect.top + visualOffsets.y) / scale.y;
  let width = clientRect.width / scale.x;
  let height = clientRect.height / scale.y;
  if (domElement) {
    const win = (0,floating_ui_utils_dom/* getWindow */.Jj)(domElement);
    const offsetWin = offsetParent && (0,floating_ui_utils_dom/* isElement */.kK)(offsetParent) ? (0,floating_ui_utils_dom/* getWindow */.Jj)(offsetParent) : offsetParent;
    let currentWin = win;
    let currentIFrame = (0,floating_ui_utils_dom/* getFrameElement */.wK)(currentWin);
    while (currentIFrame && offsetParent && offsetWin !== currentWin) {
      const iframeScale = getScale(currentIFrame);
      const iframeRect = currentIFrame.getBoundingClientRect();
      const css = (0,floating_ui_utils_dom/* getComputedStyle */.Dx)(currentIFrame);
      const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
      const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
      x *= iframeScale.x;
      y *= iframeScale.y;
      width *= iframeScale.x;
      height *= iframeScale.y;
      x += left;
      y += top;
      currentWin = (0,floating_ui_utils_dom/* getWindow */.Jj)(currentIFrame);
      currentIFrame = (0,floating_ui_utils_dom/* getFrameElement */.wK)(currentWin);
    }
  }
  return rectToClientRect({
    width,
    height,
    x,
    y
  });
}

// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function getWindowScrollBarX(element, rect) {
  const leftScroll = (0,floating_ui_utils_dom/* getNodeScroll */.Lw)(element).scrollLeft;
  if (!rect) {
    return getBoundingClientRect((0,floating_ui_utils_dom/* getDocumentElement */.tF)(element)).left + leftScroll;
  }
  return rect.left + leftScroll;
}

function getHTMLOffset(documentElement, scroll, ignoreScrollbarX) {
  if (ignoreScrollbarX === void 0) {
    ignoreScrollbarX = false;
  }
  const htmlRect = documentElement.getBoundingClientRect();
  const x = htmlRect.left + scroll.scrollLeft - (ignoreScrollbarX ? 0 :
  // RTL <body> scrollbar.
  getWindowScrollBarX(documentElement, htmlRect));
  const y = htmlRect.top + scroll.scrollTop;
  return {
    x,
    y
  };
}

function convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
  let {
    elements,
    rect,
    offsetParent,
    strategy
  } = _ref;
  const isFixed = strategy === 'fixed';
  const documentElement = (0,floating_ui_utils_dom/* getDocumentElement */.tF)(offsetParent);
  const topLayer = elements ? (0,floating_ui_utils_dom/* isTopLayer */.tR)(elements.floating) : false;
  if (offsetParent === documentElement || topLayer && isFixed) {
    return rect;
  }
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  let scale = createCoords(1);
  const offsets = createCoords(0);
  const isOffsetParentAnElement = (0,floating_ui_utils_dom/* isHTMLElement */.Re)(offsetParent);
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if ((0,floating_ui_utils_dom/* getNodeName */.wk)(offsetParent) !== 'body' || (0,floating_ui_utils_dom/* isOverflowElement */.ao)(documentElement)) {
      scroll = (0,floating_ui_utils_dom/* getNodeScroll */.Lw)(offsetParent);
    }
    if ((0,floating_ui_utils_dom/* isHTMLElement */.Re)(offsetParent)) {
      const offsetRect = getBoundingClientRect(offsetParent);
      scale = getScale(offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    }
  }
  const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? getHTMLOffset(documentElement, scroll, true) : createCoords(0);
  return {
    width: rect.width * scale.x,
    height: rect.height * scale.y,
    x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
    y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
  };
}

function getClientRects(element) {
  return Array.from(element.getClientRects());
}

// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function getDocumentRect(element) {
  const html = (0,floating_ui_utils_dom/* getDocumentElement */.tF)(element);
  const scroll = (0,floating_ui_utils_dom/* getNodeScroll */.Lw)(element);
  const body = element.ownerDocument.body;
  const width = max(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
  const height = max(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
  let x = -scroll.scrollLeft + getWindowScrollBarX(element);
  const y = -scroll.scrollTop;
  if ((0,floating_ui_utils_dom/* getComputedStyle */.Dx)(body).direction === 'rtl') {
    x += max(html.clientWidth, body.clientWidth) - width;
  }
  return {
    width,
    height,
    x,
    y
  };
}

function getViewportRect(element, strategy) {
  const win = (0,floating_ui_utils_dom/* getWindow */.Jj)(element);
  const html = (0,floating_ui_utils_dom/* getDocumentElement */.tF)(element);
  const visualViewport = win.visualViewport;
  let width = html.clientWidth;
  let height = html.clientHeight;
  let x = 0;
  let y = 0;
  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    const visualViewportBased = (0,floating_ui_utils_dom/* isWebKit */.Pf)();
    if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }
  return {
    width,
    height,
    x,
    y
  };
}

// Returns the inner client rect, subtracting scrollbars if present.
function getInnerBoundingClientRect(element, strategy) {
  const clientRect = getBoundingClientRect(element, true, strategy === 'fixed');
  const top = clientRect.top + element.clientTop;
  const left = clientRect.left + element.clientLeft;
  const scale = (0,floating_ui_utils_dom/* isHTMLElement */.Re)(element) ? getScale(element) : createCoords(1);
  const width = element.clientWidth * scale.x;
  const height = element.clientHeight * scale.y;
  const x = left * scale.x;
  const y = top * scale.y;
  return {
    width,
    height,
    x,
    y
  };
}
function getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
  let rect;
  if (clippingAncestor === 'viewport') {
    rect = getViewportRect(element, strategy);
  } else if (clippingAncestor === 'document') {
    rect = getDocumentRect((0,floating_ui_utils_dom/* getDocumentElement */.tF)(element));
  } else if ((0,floating_ui_utils_dom/* isElement */.kK)(clippingAncestor)) {
    rect = getInnerBoundingClientRect(clippingAncestor, strategy);
  } else {
    const visualOffsets = getVisualOffsets(element);
    rect = {
      x: clippingAncestor.x - visualOffsets.x,
      y: clippingAncestor.y - visualOffsets.y,
      width: clippingAncestor.width,
      height: clippingAncestor.height
    };
  }
  return rectToClientRect(rect);
}
function hasFixedPositionAncestor(element, stopNode) {
  const parentNode = (0,floating_ui_utils_dom/* getParentNode */.Ow)(element);
  if (parentNode === stopNode || !(0,floating_ui_utils_dom/* isElement */.kK)(parentNode) || (0,floating_ui_utils_dom/* isLastTraversableNode */.Py)(parentNode)) {
    return false;
  }
  return (0,floating_ui_utils_dom/* getComputedStyle */.Dx)(parentNode).position === 'fixed' || hasFixedPositionAncestor(parentNode, stopNode);
}

// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function getClippingElementAncestors(element, cache) {
  const cachedResult = cache.get(element);
  if (cachedResult) {
    return cachedResult;
  }
  let result = (0,floating_ui_utils_dom/* getOverflowAncestors */.Kx)(element, [], false).filter(el => (0,floating_ui_utils_dom/* isElement */.kK)(el) && (0,floating_ui_utils_dom/* getNodeName */.wk)(el) !== 'body');
  let currentContainingBlockComputedStyle = null;
  const elementIsFixed = (0,floating_ui_utils_dom/* getComputedStyle */.Dx)(element).position === 'fixed';
  let currentNode = elementIsFixed ? (0,floating_ui_utils_dom/* getParentNode */.Ow)(element) : element;

  // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
  while ((0,floating_ui_utils_dom/* isElement */.kK)(currentNode) && !(0,floating_ui_utils_dom/* isLastTraversableNode */.Py)(currentNode)) {
    const computedStyle = (0,floating_ui_utils_dom/* getComputedStyle */.Dx)(currentNode);
    const currentNodeIsContaining = (0,floating_ui_utils_dom/* isContainingBlock */.hT)(currentNode);
    if (!currentNodeIsContaining && computedStyle.position === 'fixed') {
      currentContainingBlockComputedStyle = null;
    }
    const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && ['absolute', 'fixed'].includes(currentContainingBlockComputedStyle.position) || (0,floating_ui_utils_dom/* isOverflowElement */.ao)(currentNode) && !currentNodeIsContaining && hasFixedPositionAncestor(element, currentNode);
    if (shouldDropCurrentNode) {
      // Drop non-containing blocks.
      result = result.filter(ancestor => ancestor !== currentNode);
    } else {
      // Record last containing block for next iteration.
      currentContainingBlockComputedStyle = computedStyle;
    }
    currentNode = (0,floating_ui_utils_dom/* getParentNode */.Ow)(currentNode);
  }
  cache.set(element, result);
  return result;
}

// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function getClippingRect(_ref) {
  let {
    element,
    boundary,
    rootBoundary,
    strategy
  } = _ref;
  const elementClippingAncestors = boundary === 'clippingAncestors' ? (0,floating_ui_utils_dom/* isTopLayer */.tR)(element) ? [] : getClippingElementAncestors(element, this._c) : [].concat(boundary);
  const clippingAncestors = [...elementClippingAncestors, rootBoundary];
  const firstClippingAncestor = clippingAncestors[0];
  const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor) => {
    const rect = getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
    accRect.top = max(rect.top, accRect.top);
    accRect.right = min(rect.right, accRect.right);
    accRect.bottom = min(rect.bottom, accRect.bottom);
    accRect.left = max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
  return {
    width: clippingRect.right - clippingRect.left,
    height: clippingRect.bottom - clippingRect.top,
    x: clippingRect.left,
    y: clippingRect.top
  };
}

function getDimensions(element) {
  const {
    width,
    height
  } = getCssDimensions(element);
  return {
    width,
    height
  };
}

function getRectRelativeToOffsetParent(element, offsetParent, strategy) {
  const isOffsetParentAnElement = (0,floating_ui_utils_dom/* isHTMLElement */.Re)(offsetParent);
  const documentElement = (0,floating_ui_utils_dom/* getDocumentElement */.tF)(offsetParent);
  const isFixed = strategy === 'fixed';
  const rect = getBoundingClientRect(element, true, isFixed, offsetParent);
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const offsets = createCoords(0);

  // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
  // Firefox with layout.scrollbar.side = 3 in about:config to test this.
  function setLeftRTLScrollbarOffset() {
    offsets.x = getWindowScrollBarX(documentElement);
  }
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if ((0,floating_ui_utils_dom/* getNodeName */.wk)(offsetParent) !== 'body' || (0,floating_ui_utils_dom/* isOverflowElement */.ao)(documentElement)) {
      scroll = (0,floating_ui_utils_dom/* getNodeScroll */.Lw)(offsetParent);
    }
    if (isOffsetParentAnElement) {
      const offsetRect = getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    } else if (documentElement) {
      setLeftRTLScrollbarOffset();
    }
  }
  if (isFixed && !isOffsetParentAnElement && documentElement) {
    setLeftRTLScrollbarOffset();
  }
  const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? getHTMLOffset(documentElement, scroll) : createCoords(0);
  const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
  const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
  return {
    x,
    y,
    width: rect.width,
    height: rect.height
  };
}

function isStaticPositioned(element) {
  return (0,floating_ui_utils_dom/* getComputedStyle */.Dx)(element).position === 'static';
}

function getTrueOffsetParent(element, polyfill) {
  if (!(0,floating_ui_utils_dom/* isHTMLElement */.Re)(element) || (0,floating_ui_utils_dom/* getComputedStyle */.Dx)(element).position === 'fixed') {
    return null;
  }
  if (polyfill) {
    return polyfill(element);
  }
  let rawOffsetParent = element.offsetParent;

  // Firefox returns the <html> element as the offsetParent if it's non-static,
  // while Chrome and Safari return the <body> element. The <body> element must
  // be used to perform the correct calculations even if the <html> element is
  // non-static.
  if ((0,floating_ui_utils_dom/* getDocumentElement */.tF)(element) === rawOffsetParent) {
    rawOffsetParent = rawOffsetParent.ownerDocument.body;
  }
  return rawOffsetParent;
}

// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function getOffsetParent(element, polyfill) {
  const win = (0,floating_ui_utils_dom/* getWindow */.Jj)(element);
  if ((0,floating_ui_utils_dom/* isTopLayer */.tR)(element)) {
    return win;
  }
  if (!(0,floating_ui_utils_dom/* isHTMLElement */.Re)(element)) {
    let svgOffsetParent = (0,floating_ui_utils_dom/* getParentNode */.Ow)(element);
    while (svgOffsetParent && !(0,floating_ui_utils_dom/* isLastTraversableNode */.Py)(svgOffsetParent)) {
      if ((0,floating_ui_utils_dom/* isElement */.kK)(svgOffsetParent) && !isStaticPositioned(svgOffsetParent)) {
        return svgOffsetParent;
      }
      svgOffsetParent = (0,floating_ui_utils_dom/* getParentNode */.Ow)(svgOffsetParent);
    }
    return win;
  }
  let offsetParent = getTrueOffsetParent(element, polyfill);
  while (offsetParent && (0,floating_ui_utils_dom/* isTableElement */.Ze)(offsetParent) && isStaticPositioned(offsetParent)) {
    offsetParent = getTrueOffsetParent(offsetParent, polyfill);
  }
  if (offsetParent && (0,floating_ui_utils_dom/* isLastTraversableNode */.Py)(offsetParent) && isStaticPositioned(offsetParent) && !(0,floating_ui_utils_dom/* isContainingBlock */.hT)(offsetParent)) {
    return win;
  }
  return offsetParent || (0,floating_ui_utils_dom/* getContainingBlock */.gQ)(element) || win;
}

const getElementRects = async function (data) {
  const getOffsetParentFn = this.getOffsetParent || getOffsetParent;
  const getDimensionsFn = this.getDimensions;
  const floatingDimensions = await getDimensionsFn(data.floating);
  return {
    reference: getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
    floating: {
      x: 0,
      y: 0,
      width: floatingDimensions.width,
      height: floatingDimensions.height
    }
  };
};

function isRTL(element) {
  return (0,floating_ui_utils_dom/* getComputedStyle */.Dx)(element).direction === 'rtl';
}

const platform = {
  convertOffsetParentRelativeRectToViewportRelativeRect,
  getDocumentElement: floating_ui_utils_dom/* getDocumentElement */.tF,
  getClippingRect,
  getOffsetParent,
  getElementRects,
  getClientRects,
  getDimensions,
  getScale,
  isElement: floating_ui_utils_dom/* isElement */.kK,
  isRTL
};

function rectsAreEqual(a, b) {
  return a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height;
}

// https://samthor.au/2021/observing-dom/
function observeMove(element, onMove) {
  let io = null;
  let timeoutId;
  const root = (0,floating_ui_utils_dom/* getDocumentElement */.tF)(element);
  function cleanup() {
    var _io;
    clearTimeout(timeoutId);
    (_io = io) == null || _io.disconnect();
    io = null;
  }
  function refresh(skip, threshold) {
    if (skip === void 0) {
      skip = false;
    }
    if (threshold === void 0) {
      threshold = 1;
    }
    cleanup();
    const elementRectForRootMargin = element.getBoundingClientRect();
    const {
      left,
      top,
      width,
      height
    } = elementRectForRootMargin;
    if (!skip) {
      onMove();
    }
    if (!width || !height) {
      return;
    }
    const insetTop = floor(top);
    const insetRight = floor(root.clientWidth - (left + width));
    const insetBottom = floor(root.clientHeight - (top + height));
    const insetLeft = floor(left);
    const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
    const options = {
      rootMargin,
      threshold: max(0, min(1, threshold)) || 1
    };
    let isFirstUpdate = true;
    function handleObserve(entries) {
      const ratio = entries[0].intersectionRatio;
      if (ratio !== threshold) {
        if (!isFirstUpdate) {
          return refresh();
        }
        if (!ratio) {
          // If the reference is clipped, the ratio is 0. Throttle the refresh
          // to prevent an infinite loop of updates.
          timeoutId = setTimeout(() => {
            refresh(false, 1e-7);
          }, 1000);
        } else {
          refresh(false, ratio);
        }
      }
      if (ratio === 1 && !rectsAreEqual(elementRectForRootMargin, element.getBoundingClientRect())) {
        // It's possible that even though the ratio is reported as 1, the
        // element is not actually fully within the IntersectionObserver's root
        // area anymore. This can happen under performance constraints. This may
        // be a bug in the browser's IntersectionObserver implementation. To
        // work around this, we compare the element's bounding rect now with
        // what it was at the time we created the IntersectionObserver. If they
        // are not equal then the element moved, so we refresh.
        refresh();
      }
      isFirstUpdate = false;
    }

    // Older browsers don't support a `document` as the root and will throw an
    // error.
    try {
      io = new IntersectionObserver(handleObserve, {
        ...options,
        // Handle <iframe>s
        root: root.ownerDocument
      });
    } catch (_e) {
      io = new IntersectionObserver(handleObserve, options);
    }
    io.observe(element);
  }
  refresh(true);
  return cleanup;
}

/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */
function autoUpdate(reference, floating, update, options) {
  if (options === void 0) {
    options = {};
  }
  const {
    ancestorScroll = true,
    ancestorResize = true,
    elementResize = typeof ResizeObserver === 'function',
    layoutShift = typeof IntersectionObserver === 'function',
    animationFrame = false
  } = options;
  const referenceEl = unwrapElement(reference);
  const ancestors = ancestorScroll || ancestorResize ? [...(referenceEl ? (0,floating_ui_utils_dom/* getOverflowAncestors */.Kx)(referenceEl) : []), ...(0,floating_ui_utils_dom/* getOverflowAncestors */.Kx)(floating)] : [];
  ancestors.forEach(ancestor => {
    ancestorScroll && ancestor.addEventListener('scroll', update, {
      passive: true
    });
    ancestorResize && ancestor.addEventListener('resize', update);
  });
  const cleanupIo = referenceEl && layoutShift ? observeMove(referenceEl, update) : null;
  let reobserveFrame = -1;
  let resizeObserver = null;
  if (elementResize) {
    resizeObserver = new ResizeObserver(_ref => {
      let [firstEntry] = _ref;
      if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
        // Prevent update loops when using the `size` middleware.
        // https://github.com/floating-ui/floating-ui/issues/1740
        resizeObserver.unobserve(floating);
        cancelAnimationFrame(reobserveFrame);
        reobserveFrame = requestAnimationFrame(() => {
          var _resizeObserver;
          (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
        });
      }
      update();
    });
    if (referenceEl && !animationFrame) {
      resizeObserver.observe(referenceEl);
    }
    resizeObserver.observe(floating);
  }
  let frameId;
  let prevRefRect = animationFrame ? getBoundingClientRect(reference) : null;
  if (animationFrame) {
    frameLoop();
  }
  function frameLoop() {
    const nextRefRect = getBoundingClientRect(reference);
    if (prevRefRect && !rectsAreEqual(prevRefRect, nextRefRect)) {
      update();
    }
    prevRefRect = nextRefRect;
    frameId = requestAnimationFrame(frameLoop);
  }
  update();
  return () => {
    var _resizeObserver2;
    ancestors.forEach(ancestor => {
      ancestorScroll && ancestor.removeEventListener('scroll', update);
      ancestorResize && ancestor.removeEventListener('resize', update);
    });
    cleanupIo == null || cleanupIo();
    (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
    resizeObserver = null;
    if (animationFrame) {
      cancelAnimationFrame(frameId);
    }
  };
}

/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */
const floating_ui_dom_detectOverflow = (/* unused pure expression or super */ null && (detectOverflow$1));

/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */
const floating_ui_dom_offset = offset;

/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */
const floating_ui_dom_autoPlacement = (/* unused pure expression or super */ null && (autoPlacement$1));

/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */
const floating_ui_dom_shift = shift;

/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */
const floating_ui_dom_flip = flip;

/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */
const floating_ui_dom_size = size;

/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */
const floating_ui_dom_hide = (/* unused pure expression or super */ null && (hide$1));

/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */
const floating_ui_dom_arrow = arrow;

/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */
const floating_ui_dom_inline = inline;

/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */
const floating_ui_dom_limitShift = limitShift;

/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */
const floating_ui_dom_computePosition = (reference, floating, options) => {
  // This caches the expensive `getClippingElementAncestors` function so that
  // multiple lifecycle resets re-use the same result. It only lives for a
  // single call. If other functions become expensive, we can add them as well.
  const cache = new Map();
  const mergedOptions = {
    platform,
    ...options
  };
  const platformWithCache = {
    ...mergedOptions.platform,
    _c: cache
  };
  return computePosition(reference, floating, {
    ...mergedOptions,
    platform: platformWithCache
  });
};




/***/ }),

/***/ 1371:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Qo": function() { return /* binding */ inline; },
/* harmony export */   "RR": function() { return /* binding */ flip; },
/* harmony export */   "YF": function() { return /* binding */ useFloating; },
/* harmony export */   "cv": function() { return /* binding */ offset; },
/* harmony export */   "dp": function() { return /* binding */ size; },
/* harmony export */   "dr": function() { return /* binding */ limitShift; },
/* harmony export */   "uY": function() { return /* binding */ shift; },
/* harmony export */   "x7": function() { return /* binding */ arrow; }
/* harmony export */ });
/* unused harmony exports autoPlacement, hide */
/* harmony import */ var _floating_ui_dom__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24750);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73935);






var isClient = typeof document !== 'undefined';

var noop = function noop() {};
var index = isClient ? react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect : noop;

// Fork of `fast-deep-equal` that only does the comparisons we need and compares
// functions
function deepEqual(a, b) {
  if (a === b) {
    return true;
  }
  if (typeof a !== typeof b) {
    return false;
  }
  if (typeof a === 'function' && a.toString() === b.toString()) {
    return true;
  }
  let length;
  let i;
  let keys;
  if (a && b && typeof a === 'object') {
    if (Array.isArray(a)) {
      length = a.length;
      if (length !== b.length) return false;
      for (i = length; i-- !== 0;) {
        if (!deepEqual(a[i], b[i])) {
          return false;
        }
      }
      return true;
    }
    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) {
      return false;
    }
    for (i = length; i-- !== 0;) {
      if (!{}.hasOwnProperty.call(b, keys[i])) {
        return false;
      }
    }
    for (i = length; i-- !== 0;) {
      const key = keys[i];
      if (key === '_owner' && a.$$typeof) {
        continue;
      }
      if (!deepEqual(a[key], b[key])) {
        return false;
      }
    }
    return true;
  }
  return a !== a && b !== b;
}

function getDPR(element) {
  if (typeof window === 'undefined') {
    return 1;
  }
  const win = element.ownerDocument.defaultView || window;
  return win.devicePixelRatio || 1;
}

function roundByDPR(element, value) {
  const dpr = getDPR(element);
  return Math.round(value * dpr) / dpr;
}

function useLatestRef(value) {
  const ref = react__WEBPACK_IMPORTED_MODULE_0__.useRef(value);
  index(() => {
    ref.current = value;
  });
  return ref;
}

/**
 * Provides data to position a floating element.
 * @see https://floating-ui.com/docs/useFloating
 */
function useFloating(options) {
  if (options === void 0) {
    options = {};
  }
  const {
    placement = 'bottom',
    strategy = 'absolute',
    middleware = [],
    platform,
    elements: {
      reference: externalReference,
      floating: externalFloating
    } = {},
    transform = true,
    whileElementsMounted,
    open
  } = options;
  const [data, setData] = react__WEBPACK_IMPORTED_MODULE_0__.useState({
    x: 0,
    y: 0,
    strategy,
    placement,
    middlewareData: {},
    isPositioned: false
  });
  const [latestMiddleware, setLatestMiddleware] = react__WEBPACK_IMPORTED_MODULE_0__.useState(middleware);
  if (!deepEqual(latestMiddleware, middleware)) {
    setLatestMiddleware(middleware);
  }
  const [_reference, _setReference] = react__WEBPACK_IMPORTED_MODULE_0__.useState(null);
  const [_floating, _setFloating] = react__WEBPACK_IMPORTED_MODULE_0__.useState(null);
  const setReference = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(node => {
    if (node !== referenceRef.current) {
      referenceRef.current = node;
      _setReference(node);
    }
  }, []);
  const setFloating = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(node => {
    if (node !== floatingRef.current) {
      floatingRef.current = node;
      _setFloating(node);
    }
  }, []);
  const referenceEl = externalReference || _reference;
  const floatingEl = externalFloating || _floating;
  const referenceRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef(null);
  const floatingRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef(null);
  const dataRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef(data);
  const hasWhileElementsMounted = whileElementsMounted != null;
  const whileElementsMountedRef = useLatestRef(whileElementsMounted);
  const platformRef = useLatestRef(platform);
  const openRef = useLatestRef(open);
  const update = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(() => {
    if (!referenceRef.current || !floatingRef.current) {
      return;
    }
    const config = {
      placement,
      strategy,
      middleware: latestMiddleware
    };
    if (platformRef.current) {
      config.platform = platformRef.current;
    }
    (0,_floating_ui_dom__WEBPACK_IMPORTED_MODULE_2__/* .computePosition */ .oo)(referenceRef.current, floatingRef.current, config).then(data => {
      const fullData = {
        ...data,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: openRef.current !== false
      };
      if (isMountedRef.current && !deepEqual(dataRef.current, fullData)) {
        dataRef.current = fullData;
        react_dom__WEBPACK_IMPORTED_MODULE_1__.flushSync(() => {
          setData(fullData);
        });
      }
    });
  }, [latestMiddleware, placement, strategy, platformRef, openRef]);
  index(() => {
    if (open === false && dataRef.current.isPositioned) {
      dataRef.current.isPositioned = false;
      setData(data => ({
        ...data,
        isPositioned: false
      }));
    }
  }, [open]);
  const isMountedRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef(false);
  index(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);
  index(() => {
    if (referenceEl) referenceRef.current = referenceEl;
    if (floatingEl) floatingRef.current = floatingEl;
    if (referenceEl && floatingEl) {
      if (whileElementsMountedRef.current) {
        return whileElementsMountedRef.current(referenceEl, floatingEl, update);
      }
      update();
    }
  }, [referenceEl, floatingEl, update, whileElementsMountedRef, hasWhileElementsMounted]);
  const refs = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => ({
    reference: referenceRef,
    floating: floatingRef,
    setReference,
    setFloating
  }), [setReference, setFloating]);
  const elements = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => ({
    reference: referenceEl,
    floating: floatingEl
  }), [referenceEl, floatingEl]);
  const floatingStyles = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => {
    const initialStyles = {
      position: strategy,
      left: 0,
      top: 0
    };
    if (!elements.floating) {
      return initialStyles;
    }
    const x = roundByDPR(elements.floating, data.x);
    const y = roundByDPR(elements.floating, data.y);
    if (transform) {
      return {
        ...initialStyles,
        transform: "translate(" + x + "px, " + y + "px)",
        ...(getDPR(elements.floating) >= 1.5 && {
          willChange: 'transform'
        })
      };
    }
    return {
      position: strategy,
      left: x,
      top: y
    };
  }, [strategy, transform, elements.floating, data.x, data.y]);
  return react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => ({
    ...data,
    update,
    refs,
    elements,
    floatingStyles
  }), [data, update, refs, elements, floatingStyles]);
}

/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */
const arrow$1 = options => {
  function isRef(value) {
    return {}.hasOwnProperty.call(value, 'current');
  }
  return {
    name: 'arrow',
    options,
    fn(state) {
      const {
        element,
        padding
      } = typeof options === 'function' ? options(state) : options;
      if (element && isRef(element)) {
        if (element.current != null) {
          return (0,_floating_ui_dom__WEBPACK_IMPORTED_MODULE_2__/* .arrow */ .x7)({
            element: element.current,
            padding
          }).fn(state);
        }
        return {};
      }
      if (element) {
        return (0,_floating_ui_dom__WEBPACK_IMPORTED_MODULE_2__/* .arrow */ .x7)({
          element,
          padding
        }).fn(state);
      }
      return {};
    }
  };
};

/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */
const offset = (options, deps) => ({
  ...(0,_floating_ui_dom__WEBPACK_IMPORTED_MODULE_2__/* .offset */ .cv)(options),
  options: [options, deps]
});

/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */
const shift = (options, deps) => ({
  ...(0,_floating_ui_dom__WEBPACK_IMPORTED_MODULE_2__/* .shift */ .uY)(options),
  options: [options, deps]
});

/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */
const limitShift = (options, deps) => ({
  ...(0,_floating_ui_dom__WEBPACK_IMPORTED_MODULE_2__/* .limitShift */ .dr)(options),
  options: [options, deps]
});

/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */
const flip = (options, deps) => ({
  ...(0,_floating_ui_dom__WEBPACK_IMPORTED_MODULE_2__/* .flip */ .RR)(options),
  options: [options, deps]
});

/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */
const size = (options, deps) => ({
  ...(0,_floating_ui_dom__WEBPACK_IMPORTED_MODULE_2__/* .size */ .dp)(options),
  options: [options, deps]
});

/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */
const autoPlacement = (options, deps) => ({
  ...autoPlacement$1(options),
  options: [options, deps]
});

/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */
const hide = (options, deps) => ({
  ...hide$1(options),
  options: [options, deps]
});

/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */
const inline = (options, deps) => ({
  ...(0,_floating_ui_dom__WEBPACK_IMPORTED_MODULE_2__/* .inline */ .Qo)(options),
  options: [options, deps]
});

/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */
const arrow = (options, deps) => ({
  ...arrow$1(options),
  options: [options, deps]
});




/***/ }),

/***/ 46504:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "bQ": function() { return /* binding */ useDismiss; },
  "YF": function() { return /* binding */ useFloating; },
  "KK": function() { return /* binding */ useFocus; },
  "XI": function() { return /* binding */ useHover; },
  "NI": function() { return /* binding */ useInteractions; },
  "qs": function() { return /* binding */ useRole; }
});

// UNUSED EXPORTS: Composite, CompositeItem, FloatingArrow, FloatingDelayGroup, FloatingFocusManager, FloatingList, FloatingNode, FloatingOverlay, FloatingPortal, FloatingTree, arrow, autoPlacement, autoUpdate, computePosition, detectOverflow, flip, getOverflowAncestors, hide, inline, inner, limitShift, offset, platform, safePolygon, shift, size, useClick, useClientPoint, useDelayGroup, useDelayGroupContext, useFloatingNodeId, useFloatingParentNodeId, useFloatingPortalNode, useFloatingRootContext, useFloatingTree, useId, useInnerOffset, useListItem, useListNavigation, useMergeRefs, useTransitionStatus, useTransitionStyles, useTypeahead

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
var react_namespaceObject = /*#__PURE__*/__webpack_require__.t(react, 2);
// EXTERNAL MODULE: ./node_modules/@floating-ui/utils/dist/floating-ui.utils.dom.mjs
var floating_ui_utils_dom = __webpack_require__(37317);
;// CONCATENATED MODULE: ./node_modules/@floating-ui/react/dist/floating-ui.react.utils.mjs


function floating_ui_react_utils_activeElement(doc) {
  let activeElement = doc.activeElement;
  while (((_activeElement = activeElement) == null || (_activeElement = _activeElement.shadowRoot) == null ? void 0 : _activeElement.activeElement) != null) {
    var _activeElement;
    activeElement = activeElement.shadowRoot.activeElement;
  }
  return activeElement;
}
function floating_ui_react_utils_contains(parent, child) {
  if (!parent || !child) {
    return false;
  }
  const rootNode = child.getRootNode == null ? void 0 : child.getRootNode();

  // First, attempt with faster native method
  if (parent.contains(child)) {
    return true;
  }

  // then fallback to custom implementation with Shadow DOM support
  if (rootNode && (0,floating_ui_utils_dom/* isShadowRoot */.Zq)(rootNode)) {
    let next = child;
    while (next) {
      if (parent === next) {
        return true;
      }
      // @ts-ignore
      next = next.parentNode || next.host;
    }
  }

  // Give up, the result is false
  return false;
}
// Avoid Chrome DevTools blue warning.
function floating_ui_react_utils_getPlatform() {
  const uaData = navigator.userAgentData;
  if (uaData != null && uaData.platform) {
    return uaData.platform;
  }
  return navigator.platform;
}
function floating_ui_react_utils_getUserAgent() {
  const uaData = navigator.userAgentData;
  if (uaData && Array.isArray(uaData.brands)) {
    return uaData.brands.map(_ref => {
      let {
        brand,
        version
      } = _ref;
      return brand + "/" + version;
    }).join(' ');
  }
  return navigator.userAgent;
}

// License: https://github.com/adobe/react-spectrum/blob/b35d5c02fe900badccd0cf1a8f23bb593419f238/packages/@react-aria/utils/src/isVirtualEvent.ts
function floating_ui_react_utils_isVirtualClick(event) {
  // FIXME: Firefox is now emitting a deprecation warning for `mozInputSource`.
  // Try to find a workaround for this. `react-aria` source still has the check.
  if (event.mozInputSource === 0 && event.isTrusted) {
    return true;
  }
  if (isAndroid() && event.pointerType) {
    return event.type === 'click' && event.buttons === 1;
  }
  return event.detail === 0 && !event.pointerType;
}
function floating_ui_react_utils_isVirtualPointerEvent(event) {
  if (isJSDOM()) return false;
  return !isAndroid() && event.width === 0 && event.height === 0 || isAndroid() && event.width === 1 && event.height === 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === 'mouse' ||
  // iOS VoiceOver returns 0.333• for width/height.
  event.width < 1 && event.height < 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === 'touch';
}
function floating_ui_react_utils_isSafari() {
  // Chrome DevTools does not complain about navigator.vendor
  return /apple/i.test(navigator.vendor);
}
function isAndroid() {
  const re = /android/i;
  return re.test(floating_ui_react_utils_getPlatform()) || re.test(floating_ui_react_utils_getUserAgent());
}
function floating_ui_react_utils_isMac() {
  return floating_ui_react_utils_getPlatform().toLowerCase().startsWith('mac') && !navigator.maxTouchPoints;
}
function isJSDOM() {
  return floating_ui_react_utils_getUserAgent().includes('jsdom/');
}
function floating_ui_react_utils_isMouseLikePointerType(pointerType, strict) {
  // On some Linux machines with Chromium, mouse inputs return a `pointerType`
  // of "pen": https://github.com/floating-ui/floating-ui/issues/2015
  const values = ['mouse', 'pen'];
  if (!strict) {
    values.push('', undefined);
  }
  return values.includes(pointerType);
}
function isReactEvent(event) {
  return 'nativeEvent' in event;
}
function isRootElement(element) {
  return element.matches('html,body');
}
function floating_ui_react_utils_getDocument(node) {
  return (node == null ? void 0 : node.ownerDocument) || document;
}
function isEventTargetWithin(event, node) {
  if (node == null) {
    return false;
  }
  if ('composedPath' in event) {
    return event.composedPath().includes(node);
  }

  // TS thinks `event` is of type never as it assumes all browsers support composedPath, but browsers without shadow dom don't
  const e = event;
  return e.target != null && node.contains(e.target);
}
function floating_ui_react_utils_getTarget(event) {
  if ('composedPath' in event) {
    return event.composedPath()[0];
  }

  // TS thinks `event` is of type never as it assumes all browsers support
  // `composedPath()`, but browsers without shadow DOM don't.
  return event.target;
}
const TYPEABLE_SELECTOR = "input:not([type='hidden']):not([disabled])," + "[contenteditable]:not([contenteditable='false']),textarea:not([disabled])";
function floating_ui_react_utils_isTypeableElement(element) {
  return (0,floating_ui_utils_dom/* isHTMLElement */.Re)(element) && element.matches(TYPEABLE_SELECTOR);
}
function floating_ui_react_utils_stopEvent(event) {
  event.preventDefault();
  event.stopPropagation();
}
function floating_ui_react_utils_isTypeableCombobox(element) {
  if (!element) return false;
  return element.getAttribute('role') === 'combobox' && floating_ui_react_utils_isTypeableElement(element);
}



// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
// EXTERNAL MODULE: ./node_modules/@floating-ui/react-dom/dist/floating-ui.react-dom.mjs
var floating_ui_react_dom = __webpack_require__(1371);
;// CONCATENATED MODULE: ./node_modules/@floating-ui/react/dist/floating-ui.react.mjs










/**
 * Merges an array of refs into a single memoized callback ref or `null`.
 * @see https://floating-ui.com/docs/react-utils#usemergerefs
 */
function useMergeRefs(refs) {
  return React.useMemo(() => {
    if (refs.every(ref => ref == null)) {
      return null;
    }
    return value => {
      refs.forEach(ref => {
        if (typeof ref === 'function') {
          ref(value);
        } else if (ref != null) {
          ref.current = value;
        }
      });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, refs);
}

// https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379
const SafeReact = {
  ...react_namespaceObject
};

const useInsertionEffect = SafeReact.useInsertionEffect;
const useSafeInsertionEffect = useInsertionEffect || (fn => fn());
function useEffectEvent(callback) {
  const ref = react.useRef(() => {
    if (false) {}
  });
  useSafeInsertionEffect(() => {
    ref.current = callback;
  });
  return react.useCallback(function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return ref.current == null ? void 0 : ref.current(...args);
  }, []);
}

const ARROW_UP = 'ArrowUp';
const ARROW_DOWN = 'ArrowDown';
const ARROW_LEFT = 'ArrowLeft';
const ARROW_RIGHT = 'ArrowRight';
function isDifferentRow(index, cols, prevRow) {
  return Math.floor(index / cols) !== prevRow;
}
function isIndexOutOfBounds(listRef, index) {
  return index < 0 || index >= listRef.current.length;
}
function getMinIndex(listRef, disabledIndices) {
  return findNonDisabledIndex(listRef, {
    disabledIndices
  });
}
function getMaxIndex(listRef, disabledIndices) {
  return findNonDisabledIndex(listRef, {
    decrement: true,
    startingIndex: listRef.current.length,
    disabledIndices
  });
}
function findNonDisabledIndex(listRef, _temp) {
  let {
    startingIndex = -1,
    decrement = false,
    disabledIndices,
    amount = 1
  } = _temp === void 0 ? {} : _temp;
  const list = listRef.current;
  let index = startingIndex;
  do {
    index += decrement ? -amount : amount;
  } while (index >= 0 && index <= list.length - 1 && isDisabled(list, index, disabledIndices));
  return index;
}
function getGridNavigatedIndex(elementsRef, _ref) {
  let {
    event,
    orientation,
    loop,
    rtl,
    cols,
    disabledIndices,
    minIndex,
    maxIndex,
    prevIndex,
    stopEvent: stop = false
  } = _ref;
  let nextIndex = prevIndex;
  if (event.key === ARROW_UP) {
    stop && stopEvent(event);
    if (prevIndex === -1) {
      nextIndex = maxIndex;
    } else {
      nextIndex = findNonDisabledIndex(elementsRef, {
        startingIndex: nextIndex,
        amount: cols,
        decrement: true,
        disabledIndices
      });
      if (loop && (prevIndex - cols < minIndex || nextIndex < 0)) {
        const col = prevIndex % cols;
        const maxCol = maxIndex % cols;
        const offset = maxIndex - (maxCol - col);
        if (maxCol === col) {
          nextIndex = maxIndex;
        } else {
          nextIndex = maxCol > col ? offset : offset - cols;
        }
      }
    }
    if (isIndexOutOfBounds(elementsRef, nextIndex)) {
      nextIndex = prevIndex;
    }
  }
  if (event.key === ARROW_DOWN) {
    stop && stopEvent(event);
    if (prevIndex === -1) {
      nextIndex = minIndex;
    } else {
      nextIndex = findNonDisabledIndex(elementsRef, {
        startingIndex: prevIndex,
        amount: cols,
        disabledIndices
      });
      if (loop && prevIndex + cols > maxIndex) {
        nextIndex = findNonDisabledIndex(elementsRef, {
          startingIndex: prevIndex % cols - cols,
          amount: cols,
          disabledIndices
        });
      }
    }
    if (isIndexOutOfBounds(elementsRef, nextIndex)) {
      nextIndex = prevIndex;
    }
  }

  // Remains on the same row/column.
  if (orientation === 'both') {
    const prevRow = floor(prevIndex / cols);
    if (event.key === (rtl ? ARROW_LEFT : ARROW_RIGHT)) {
      stop && stopEvent(event);
      if (prevIndex % cols !== cols - 1) {
        nextIndex = findNonDisabledIndex(elementsRef, {
          startingIndex: prevIndex,
          disabledIndices
        });
        if (loop && isDifferentRow(nextIndex, cols, prevRow)) {
          nextIndex = findNonDisabledIndex(elementsRef, {
            startingIndex: prevIndex - prevIndex % cols - 1,
            disabledIndices
          });
        }
      } else if (loop) {
        nextIndex = findNonDisabledIndex(elementsRef, {
          startingIndex: prevIndex - prevIndex % cols - 1,
          disabledIndices
        });
      }
      if (isDifferentRow(nextIndex, cols, prevRow)) {
        nextIndex = prevIndex;
      }
    }
    if (event.key === (rtl ? ARROW_RIGHT : ARROW_LEFT)) {
      stop && stopEvent(event);
      if (prevIndex % cols !== 0) {
        nextIndex = findNonDisabledIndex(elementsRef, {
          startingIndex: prevIndex,
          decrement: true,
          disabledIndices
        });
        if (loop && isDifferentRow(nextIndex, cols, prevRow)) {
          nextIndex = findNonDisabledIndex(elementsRef, {
            startingIndex: prevIndex + (cols - prevIndex % cols),
            decrement: true,
            disabledIndices
          });
        }
      } else if (loop) {
        nextIndex = findNonDisabledIndex(elementsRef, {
          startingIndex: prevIndex + (cols - prevIndex % cols),
          decrement: true,
          disabledIndices
        });
      }
      if (isDifferentRow(nextIndex, cols, prevRow)) {
        nextIndex = prevIndex;
      }
    }
    const lastRow = floor(maxIndex / cols) === prevRow;
    if (isIndexOutOfBounds(elementsRef, nextIndex)) {
      if (loop && lastRow) {
        nextIndex = event.key === (rtl ? ARROW_RIGHT : ARROW_LEFT) ? maxIndex : findNonDisabledIndex(elementsRef, {
          startingIndex: prevIndex - prevIndex % cols - 1,
          disabledIndices
        });
      } else {
        nextIndex = prevIndex;
      }
    }
  }
  return nextIndex;
}

/** For each cell index, gets the item index that occupies that cell */
function buildCellMap(sizes, cols, dense) {
  const cellMap = [];
  let startIndex = 0;
  sizes.forEach((_ref2, index) => {
    let {
      width,
      height
    } = _ref2;
    if (width > cols) {
      if (false) {}
    }
    let itemPlaced = false;
    if (dense) {
      startIndex = 0;
    }
    while (!itemPlaced) {
      const targetCells = [];
      for (let i = 0; i < width; i++) {
        for (let j = 0; j < height; j++) {
          targetCells.push(startIndex + i + j * cols);
        }
      }
      if (startIndex % cols + width <= cols && targetCells.every(cell => cellMap[cell] == null)) {
        targetCells.forEach(cell => {
          cellMap[cell] = index;
        });
        itemPlaced = true;
      } else {
        startIndex++;
      }
    }
  });

  // convert into a non-sparse array
  return [...cellMap];
}

/** Gets cell index of an item's corner or -1 when index is -1. */
function getCellIndexOfCorner(index, sizes, cellMap, cols, corner) {
  if (index === -1) return -1;
  const firstCellIndex = cellMap.indexOf(index);
  const sizeItem = sizes[index];
  switch (corner) {
    case 'tl':
      return firstCellIndex;
    case 'tr':
      if (!sizeItem) {
        return firstCellIndex;
      }
      return firstCellIndex + sizeItem.width - 1;
    case 'bl':
      if (!sizeItem) {
        return firstCellIndex;
      }
      return firstCellIndex + (sizeItem.height - 1) * cols;
    case 'br':
      return cellMap.lastIndexOf(index);
  }
}

/** Gets all cell indices that correspond to the specified indices */
function getCellIndices(indices, cellMap) {
  return cellMap.flatMap((index, cellIndex) => indices.includes(index) ? [cellIndex] : []);
}
function isDisabled(list, index, disabledIndices) {
  if (disabledIndices) {
    return disabledIndices.includes(index);
  }
  const element = list[index];
  return element == null || element.hasAttribute('disabled') || element.getAttribute('aria-disabled') === 'true';
}

var index = typeof document !== 'undefined' ? react.useLayoutEffect : react.useEffect;

function sortByDocumentPosition(a, b) {
  const position = a.compareDocumentPosition(b);
  if (position & Node.DOCUMENT_POSITION_FOLLOWING || position & Node.DOCUMENT_POSITION_CONTAINED_BY) {
    return -1;
  }
  if (position & Node.DOCUMENT_POSITION_PRECEDING || position & Node.DOCUMENT_POSITION_CONTAINS) {
    return 1;
  }
  return 0;
}
function areMapsEqual(map1, map2) {
  if (map1.size !== map2.size) {
    return false;
  }
  for (const [key, value] of map1.entries()) {
    if (value !== map2.get(key)) {
      return false;
    }
  }
  return true;
}
const FloatingListContext = /*#__PURE__*/react.createContext({
  register: () => {},
  unregister: () => {},
  map: /*#__PURE__*/new Map(),
  elementsRef: {
    current: []
  }
});
/**
 * Provides context for a list of items within the floating element.
 * @see https://floating-ui.com/docs/FloatingList
 */
function FloatingList(props) {
  const {
    children,
    elementsRef,
    labelsRef
  } = props;
  const [map, setMap] = React.useState(() => new Map());
  const register = React.useCallback(node => {
    setMap(prevMap => new Map(prevMap).set(node, null));
  }, []);
  const unregister = React.useCallback(node => {
    setMap(prevMap => {
      const map = new Map(prevMap);
      map.delete(node);
      return map;
    });
  }, []);
  index(() => {
    const newMap = new Map(map);
    const nodes = Array.from(newMap.keys()).sort(sortByDocumentPosition);
    nodes.forEach((node, index) => {
      newMap.set(node, index);
    });
    if (!areMapsEqual(map, newMap)) {
      setMap(newMap);
    }
  }, [map]);
  return /*#__PURE__*/React.createElement(FloatingListContext.Provider, {
    value: React.useMemo(() => ({
      register,
      unregister,
      map,
      elementsRef,
      labelsRef
    }), [register, unregister, map, elementsRef, labelsRef])
  }, children);
}
/**
 * Used to register a list item and its index (DOM position) in the
 * `FloatingList`.
 * @see https://floating-ui.com/docs/FloatingList#uselistitem
 */
function useListItem(props) {
  if (props === void 0) {
    props = {};
  }
  const {
    label
  } = props;
  const {
    register,
    unregister,
    map,
    elementsRef,
    labelsRef
  } = React.useContext(FloatingListContext);
  const [index$1, setIndex] = React.useState(null);
  const componentRef = React.useRef(null);
  const ref = React.useCallback(node => {
    componentRef.current = node;
    if (index$1 !== null) {
      elementsRef.current[index$1] = node;
      if (labelsRef) {
        var _node$textContent;
        const isLabelDefined = label !== undefined;
        labelsRef.current[index$1] = isLabelDefined ? label : (_node$textContent = node == null ? void 0 : node.textContent) != null ? _node$textContent : null;
      }
    }
  }, [index$1, elementsRef, labelsRef, label]);
  index(() => {
    const node = componentRef.current;
    if (node) {
      register(node);
      return () => {
        unregister(node);
      };
    }
  }, [register, unregister]);
  index(() => {
    const index = componentRef.current ? map.get(componentRef.current) : null;
    if (index != null) {
      setIndex(index);
    }
  }, [map]);
  return React.useMemo(() => ({
    ref,
    index: index$1 == null ? -1 : index$1
  }), [index$1, ref]);
}

function renderJsx(render, computedProps) {
  if (typeof render === 'function') {
    return render(computedProps);
  }
  if (render) {
    return /*#__PURE__*/React.cloneElement(render, computedProps);
  }
  return /*#__PURE__*/React.createElement("div", computedProps);
}
const CompositeContext = /*#__PURE__*/react.createContext({
  activeIndex: 0,
  onNavigate: () => {}
});
const horizontalKeys = [ARROW_LEFT, ARROW_RIGHT];
const verticalKeys = [ARROW_UP, ARROW_DOWN];
const allKeys = [...horizontalKeys, ...verticalKeys];

/**
 * Creates a single tab stop whose items are navigated by arrow keys, which
 * provides list navigation outside of floating element contexts.
 *
 * This is useful to enable navigation of a list of items that aren’t part of a
 * floating element. A menubar is an example of a composite, with each reference
 * element being an item.
 * @see https://floating-ui.com/docs/Composite
 */
const Composite = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Composite(props, forwardedRef) {
  const {
    render,
    orientation = 'both',
    loop = true,
    rtl = false,
    cols = 1,
    disabledIndices,
    activeIndex: externalActiveIndex,
    onNavigate: externalSetActiveIndex,
    itemSizes,
    dense = false,
    ...domProps
  } = props;
  const [internalActiveIndex, internalSetActiveIndex] = React.useState(0);
  const activeIndex = externalActiveIndex != null ? externalActiveIndex : internalActiveIndex;
  const onNavigate = useEffectEvent(externalSetActiveIndex != null ? externalSetActiveIndex : internalSetActiveIndex);
  const elementsRef = React.useRef([]);
  const renderElementProps = render && typeof render !== 'function' ? render.props : {};
  const contextValue = React.useMemo(() => ({
    activeIndex,
    onNavigate
  }), [activeIndex, onNavigate]);
  const isGrid = cols > 1;
  function handleKeyDown(event) {
    if (!allKeys.includes(event.key)) return;
    let nextIndex = activeIndex;
    const minIndex = getMinIndex(elementsRef, disabledIndices);
    const maxIndex = getMaxIndex(elementsRef, disabledIndices);
    const horizontalEndKey = rtl ? ARROW_LEFT : ARROW_RIGHT;
    const horizontalStartKey = rtl ? ARROW_RIGHT : ARROW_LEFT;
    if (isGrid) {
      const sizes = itemSizes || Array.from({
        length: elementsRef.current.length
      }, () => ({
        width: 1,
        height: 1
      }));
      // To calculate movements on the grid, we use hypothetical cell indices
      // as if every item was 1x1, then convert back to real indices.
      const cellMap = buildCellMap(sizes, cols, dense);
      const minGridIndex = cellMap.findIndex(index => index != null && !isDisabled(elementsRef.current, index, disabledIndices));
      // last enabled index
      const maxGridIndex = cellMap.reduce((foundIndex, index, cellIndex) => index != null && !isDisabled(elementsRef.current, index, disabledIndices) ? cellIndex : foundIndex, -1);
      const maybeNextIndex = cellMap[getGridNavigatedIndex({
        current: cellMap.map(itemIndex => itemIndex ? elementsRef.current[itemIndex] : null)
      }, {
        event,
        orientation,
        loop,
        rtl,
        cols,
        // treat undefined (empty grid spaces) as disabled indices so we
        // don't end up in them
        disabledIndices: getCellIndices([...(disabledIndices || elementsRef.current.map((_, index) => isDisabled(elementsRef.current, index) ? index : undefined)), undefined], cellMap),
        minIndex: minGridIndex,
        maxIndex: maxGridIndex,
        prevIndex: getCellIndexOfCorner(activeIndex > maxIndex ? minIndex : activeIndex, sizes, cellMap, cols,
        // use a corner matching the edge closest to the direction we're
        // moving in so we don't end up in the same item. Prefer
        // top/left over bottom/right.
        event.key === ARROW_DOWN ? 'bl' : event.key === horizontalEndKey ? 'tr' : 'tl')
      })];
      if (maybeNextIndex != null) {
        nextIndex = maybeNextIndex;
      }
    }
    const toEndKeys = {
      horizontal: [horizontalEndKey],
      vertical: [ARROW_DOWN],
      both: [horizontalEndKey, ARROW_DOWN]
    }[orientation];
    const toStartKeys = {
      horizontal: [horizontalStartKey],
      vertical: [ARROW_UP],
      both: [horizontalStartKey, ARROW_UP]
    }[orientation];
    const preventedKeys = isGrid ? allKeys : {
      horizontal: horizontalKeys,
      vertical: verticalKeys,
      both: allKeys
    }[orientation];
    if (nextIndex === activeIndex && [...toEndKeys, ...toStartKeys].includes(event.key)) {
      if (loop && nextIndex === maxIndex && toEndKeys.includes(event.key)) {
        nextIndex = minIndex;
      } else if (loop && nextIndex === minIndex && toStartKeys.includes(event.key)) {
        nextIndex = maxIndex;
      } else {
        nextIndex = findNonDisabledIndex(elementsRef, {
          startingIndex: nextIndex,
          decrement: toStartKeys.includes(event.key),
          disabledIndices
        });
      }
    }
    if (nextIndex !== activeIndex && !isIndexOutOfBounds(elementsRef, nextIndex)) {
      var _elementsRef$current$;
      event.stopPropagation();
      if (preventedKeys.includes(event.key)) {
        event.preventDefault();
      }
      onNavigate(nextIndex);
      (_elementsRef$current$ = elementsRef.current[nextIndex]) == null || _elementsRef$current$.focus();
    }
  }
  const computedProps = {
    ...domProps,
    ...renderElementProps,
    ref: forwardedRef,
    'aria-orientation': orientation === 'both' ? undefined : orientation,
    onKeyDown(e) {
      domProps.onKeyDown == null || domProps.onKeyDown(e);
      renderElementProps.onKeyDown == null || renderElementProps.onKeyDown(e);
      handleKeyDown(e);
    }
  };
  return /*#__PURE__*/React.createElement(CompositeContext.Provider, {
    value: contextValue
  }, /*#__PURE__*/React.createElement(FloatingList, {
    elementsRef: elementsRef
  }, renderJsx(render, computedProps)));
})));
/**
 * @see https://floating-ui.com/docs/Composite
 */
const CompositeItem = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function CompositeItem(props, forwardedRef) {
  const {
    render,
    ...domProps
  } = props;
  const renderElementProps = render && typeof render !== 'function' ? render.props : {};
  const {
    activeIndex,
    onNavigate
  } = React.useContext(CompositeContext);
  const {
    ref,
    index
  } = useListItem();
  const mergedRef = useMergeRefs([ref, forwardedRef, renderElementProps.ref]);
  const isActive = activeIndex === index;
  const computedProps = {
    ...domProps,
    ...renderElementProps,
    ref: mergedRef,
    tabIndex: isActive ? 0 : -1,
    'data-active': isActive ? '' : undefined,
    onFocus(e) {
      domProps.onFocus == null || domProps.onFocus(e);
      renderElementProps.onFocus == null || renderElementProps.onFocus(e);
      onNavigate(index);
    }
  };
  return renderJsx(render, computedProps);
})));

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

let serverHandoffComplete = false;
let count = 0;
const genId = () => // Ensure the id is unique with multiple independent versions of Floating UI
// on <React 18
"floating-ui-" + Math.random().toString(36).slice(2, 6) + count++;
function useFloatingId() {
  const [id, setId] = react.useState(() => serverHandoffComplete ? genId() : undefined);
  index(() => {
    if (id == null) {
      setId(genId());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  react.useEffect(() => {
    serverHandoffComplete = true;
  }, []);
  return id;
}
const useReactId = SafeReact.useId;

/**
 * Uses React 18's built-in `useId()` when available, or falls back to a
 * slightly less performant (requiring a double render) implementation for
 * earlier React versions.
 * @see https://floating-ui.com/docs/react-utils#useid
 */
const useId = useReactId || useFloatingId;

let devMessageSet;
if (false) {}
function warn() {
  var _devMessageSet;
  for (var _len = arguments.length, messages = new Array(_len), _key = 0; _key < _len; _key++) {
    messages[_key] = arguments[_key];
  }
  const message = "Floating UI: " + messages.join(' ');
  if (!((_devMessageSet = devMessageSet) != null && _devMessageSet.has(message))) {
    var _devMessageSet2;
    (_devMessageSet2 = devMessageSet) == null || _devMessageSet2.add(message);
    console.warn(message);
  }
}
function error() {
  var _devMessageSet3;
  for (var _len2 = arguments.length, messages = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    messages[_key2] = arguments[_key2];
  }
  const message = "Floating UI: " + messages.join(' ');
  if (!((_devMessageSet3 = devMessageSet) != null && _devMessageSet3.has(message))) {
    var _devMessageSet4;
    (_devMessageSet4 = devMessageSet) == null || _devMessageSet4.add(message);
    console.error(message);
  }
}

/**
 * Renders a pointing arrow triangle.
 * @see https://floating-ui.com/docs/FloatingArrow
 */
const FloatingArrow = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function FloatingArrow(props, ref) {
  const {
    context: {
      placement,
      elements: {
        floating
      },
      middlewareData: {
        arrow,
        shift
      }
    },
    width = 14,
    height = 7,
    tipRadius = 0,
    strokeWidth = 0,
    staticOffset,
    stroke,
    d,
    style: {
      transform,
      ...restStyle
    } = {},
    ...rest
  } = props;
  if (false) {}
  const clipPathId = useId();
  const [isRTL, setIsRTL] = React.useState(false);

  // https://github.com/floating-ui/floating-ui/issues/2932
  index(() => {
    if (!floating) return;
    const isRTL = getComputedStyle(floating).direction === 'rtl';
    if (isRTL) {
      setIsRTL(true);
    }
  }, [floating]);
  if (!floating) {
    return null;
  }
  const [side, alignment] = placement.split('-');
  const isVerticalSide = side === 'top' || side === 'bottom';
  let computedStaticOffset = staticOffset;
  if (isVerticalSide && shift != null && shift.x || !isVerticalSide && shift != null && shift.y) {
    computedStaticOffset = null;
  }

  // Strokes must be double the border width, this ensures the stroke's width
  // works as you'd expect.
  const computedStrokeWidth = strokeWidth * 2;
  const halfStrokeWidth = computedStrokeWidth / 2;
  const svgX = width / 2 * (tipRadius / -8 + 1);
  const svgY = height / 2 * tipRadius / 4;
  const isCustomShape = !!d;
  const yOffsetProp = computedStaticOffset && alignment === 'end' ? 'bottom' : 'top';
  let xOffsetProp = computedStaticOffset && alignment === 'end' ? 'right' : 'left';
  if (computedStaticOffset && isRTL) {
    xOffsetProp = alignment === 'end' ? 'left' : 'right';
  }
  const arrowX = (arrow == null ? void 0 : arrow.x) != null ? computedStaticOffset || arrow.x : '';
  const arrowY = (arrow == null ? void 0 : arrow.y) != null ? computedStaticOffset || arrow.y : '';
  const dValue = d || 'M0,0' + (" H" + width) + (" L" + (width - svgX) + "," + (height - svgY)) + (" Q" + width / 2 + "," + height + " " + svgX + "," + (height - svgY)) + ' Z';
  const rotation = {
    top: isCustomShape ? 'rotate(180deg)' : '',
    left: isCustomShape ? 'rotate(90deg)' : 'rotate(-90deg)',
    bottom: isCustomShape ? '' : 'rotate(180deg)',
    right: isCustomShape ? 'rotate(-90deg)' : 'rotate(90deg)'
  }[side];
  return /*#__PURE__*/React.createElement("svg", _extends({}, rest, {
    "aria-hidden": true,
    ref: ref,
    width: isCustomShape ? width : width + computedStrokeWidth,
    height: width,
    viewBox: "0 0 " + width + " " + (height > width ? height : width),
    style: {
      position: 'absolute',
      pointerEvents: 'none',
      [xOffsetProp]: arrowX,
      [yOffsetProp]: arrowY,
      [side]: isVerticalSide || isCustomShape ? '100%' : "calc(100% - " + computedStrokeWidth / 2 + "px)",
      transform: [rotation, transform].filter(t => !!t).join(' '),
      ...restStyle
    }
  }), computedStrokeWidth > 0 && /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#" + clipPathId + ")",
    fill: "none",
    stroke: stroke
    // Account for the stroke on the fill path rendered below.
    ,
    strokeWidth: computedStrokeWidth + (d ? 0 : 1),
    d: dValue
  }), /*#__PURE__*/React.createElement("path", {
    stroke: computedStrokeWidth && !d ? rest.fill : 'none',
    d: dValue
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: clipPathId
  }, /*#__PURE__*/React.createElement("rect", {
    x: -halfStrokeWidth,
    y: halfStrokeWidth * (isCustomShape ? -1 : 1),
    width: width + computedStrokeWidth,
    height: width
  })));
})));

function createPubSub() {
  const map = new Map();
  return {
    emit(event, data) {
      var _map$get;
      (_map$get = map.get(event)) == null || _map$get.forEach(handler => handler(data));
    },
    on(event, listener) {
      map.set(event, [...(map.get(event) || []), listener]);
    },
    off(event, listener) {
      var _map$get2;
      map.set(event, ((_map$get2 = map.get(event)) == null ? void 0 : _map$get2.filter(l => l !== listener)) || []);
    }
  };
}

const FloatingNodeContext = /*#__PURE__*/react.createContext(null);
const FloatingTreeContext = /*#__PURE__*/react.createContext(null);

/**
 * Returns the parent node id for nested floating elements, if available.
 * Returns `null` for top-level floating elements.
 */
const useFloatingParentNodeId = () => {
  var _React$useContext;
  return ((_React$useContext = react.useContext(FloatingNodeContext)) == null ? void 0 : _React$useContext.id) || null;
};

/**
 * Returns the nearest floating tree context, if available.
 */
const useFloatingTree = () => react.useContext(FloatingTreeContext);

/**
 * Registers a node into the `FloatingTree`, returning its id.
 * @see https://floating-ui.com/docs/FloatingTree
 */
function useFloatingNodeId(customParentId) {
  const id = useId();
  const tree = useFloatingTree();
  const reactParentId = useFloatingParentNodeId();
  const parentId = customParentId || reactParentId;
  index(() => {
    const node = {
      id,
      parentId
    };
    tree == null || tree.addNode(node);
    return () => {
      tree == null || tree.removeNode(node);
    };
  }, [tree, id, parentId]);
  return id;
}
/**
 * Provides parent node context for nested floating elements.
 * @see https://floating-ui.com/docs/FloatingTree
 */
function FloatingNode(props) {
  const {
    children,
    id
  } = props;
  const parentId = useFloatingParentNodeId();
  return /*#__PURE__*/React.createElement(FloatingNodeContext.Provider, {
    value: React.useMemo(() => ({
      id,
      parentId
    }), [id, parentId])
  }, children);
}
/**
 * Provides context for nested floating elements when they are not children of
 * each other on the DOM.
 * This is not necessary in all cases, except when there must be explicit communication between parent and child floating elements. It is necessary for:
 * - The `bubbles` option in the `useDismiss()` Hook
 * - Nested virtual list navigation
 * - Nested floating elements that each open on hover
 * - Custom communication between parent and child floating elements
 * @see https://floating-ui.com/docs/FloatingTree
 */
function FloatingTree(props) {
  const {
    children
  } = props;
  const nodesRef = React.useRef([]);
  const addNode = React.useCallback(node => {
    nodesRef.current = [...nodesRef.current, node];
  }, []);
  const removeNode = React.useCallback(node => {
    nodesRef.current = nodesRef.current.filter(n => n !== node);
  }, []);
  const events = React.useState(() => createPubSub())[0];
  return /*#__PURE__*/React.createElement(FloatingTreeContext.Provider, {
    value: React.useMemo(() => ({
      nodesRef,
      addNode,
      removeNode,
      events
    }), [addNode, removeNode, events])
  }, children);
}

function createAttribute(name) {
  return "data-floating-ui-" + name;
}

function useLatestRef(value) {
  const ref = (0,react.useRef)(value);
  index(() => {
    ref.current = value;
  });
  return ref;
}

const safePolygonIdentifier = /*#__PURE__*/createAttribute('safe-polygon');
function getDelay(value, prop, pointerType) {
  if (pointerType && !floating_ui_react_utils_isMouseLikePointerType(pointerType)) {
    return 0;
  }
  if (typeof value === 'number') {
    return value;
  }
  return value == null ? void 0 : value[prop];
}
/**
 * Opens the floating element while hovering over the reference element, like
 * CSS `:hover`.
 * @see https://floating-ui.com/docs/useHover
 */
function useHover(context, props) {
  if (props === void 0) {
    props = {};
  }
  const {
    open,
    onOpenChange,
    dataRef,
    events,
    elements
  } = context;
  const {
    enabled = true,
    delay = 0,
    handleClose = null,
    mouseOnly = false,
    restMs = 0,
    move = true
  } = props;
  const tree = useFloatingTree();
  const parentId = useFloatingParentNodeId();
  const handleCloseRef = useLatestRef(handleClose);
  const delayRef = useLatestRef(delay);
  const openRef = useLatestRef(open);
  const pointerTypeRef = react.useRef();
  const timeoutRef = react.useRef(-1);
  const handlerRef = react.useRef();
  const restTimeoutRef = react.useRef(-1);
  const blockMouseMoveRef = react.useRef(true);
  const performedPointerEventsMutationRef = react.useRef(false);
  const unbindMouseMoveRef = react.useRef(() => {});
  const restTimeoutPendingRef = react.useRef(false);
  const isHoverOpen = react.useCallback(() => {
    var _dataRef$current$open;
    const type = (_dataRef$current$open = dataRef.current.openEvent) == null ? void 0 : _dataRef$current$open.type;
    return (type == null ? void 0 : type.includes('mouse')) && type !== 'mousedown';
  }, [dataRef]);

  // When closing before opening, clear the delay timeouts to cancel it
  // from showing.
  react.useEffect(() => {
    if (!enabled) return;
    function onOpenChange(_ref) {
      let {
        open
      } = _ref;
      if (!open) {
        clearTimeout(timeoutRef.current);
        clearTimeout(restTimeoutRef.current);
        blockMouseMoveRef.current = true;
        restTimeoutPendingRef.current = false;
      }
    }
    events.on('openchange', onOpenChange);
    return () => {
      events.off('openchange', onOpenChange);
    };
  }, [enabled, events]);
  react.useEffect(() => {
    if (!enabled) return;
    if (!handleCloseRef.current) return;
    if (!open) return;
    function onLeave(event) {
      if (isHoverOpen()) {
        onOpenChange(false, event, 'hover');
      }
    }
    const html = floating_ui_react_utils_getDocument(elements.floating).documentElement;
    html.addEventListener('mouseleave', onLeave);
    return () => {
      html.removeEventListener('mouseleave', onLeave);
    };
  }, [elements.floating, open, onOpenChange, enabled, handleCloseRef, isHoverOpen]);
  const closeWithDelay = react.useCallback(function (event, runElseBranch, reason) {
    if (runElseBranch === void 0) {
      runElseBranch = true;
    }
    if (reason === void 0) {
      reason = 'hover';
    }
    const closeDelay = getDelay(delayRef.current, 'close', pointerTypeRef.current);
    if (closeDelay && !handlerRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = window.setTimeout(() => onOpenChange(false, event, reason), closeDelay);
    } else if (runElseBranch) {
      clearTimeout(timeoutRef.current);
      onOpenChange(false, event, reason);
    }
  }, [delayRef, onOpenChange]);
  const cleanupMouseMoveHandler = useEffectEvent(() => {
    unbindMouseMoveRef.current();
    handlerRef.current = undefined;
  });
  const clearPointerEvents = useEffectEvent(() => {
    if (performedPointerEventsMutationRef.current) {
      const body = floating_ui_react_utils_getDocument(elements.floating).body;
      body.style.pointerEvents = '';
      body.removeAttribute(safePolygonIdentifier);
      performedPointerEventsMutationRef.current = false;
    }
  });
  const isClickLikeOpenEvent = useEffectEvent(() => {
    return dataRef.current.openEvent ? ['click', 'mousedown'].includes(dataRef.current.openEvent.type) : false;
  });

  // Registering the mouse events on the reference directly to bypass React's
  // delegation system. If the cursor was on a disabled element and then entered
  // the reference (no gap), `mouseenter` doesn't fire in the delegation system.
  react.useEffect(() => {
    if (!enabled) return;
    function onMouseEnter(event) {
      clearTimeout(timeoutRef.current);
      blockMouseMoveRef.current = false;
      if (mouseOnly && !floating_ui_react_utils_isMouseLikePointerType(pointerTypeRef.current) || restMs > 0 && !getDelay(delayRef.current, 'open')) {
        return;
      }
      const openDelay = getDelay(delayRef.current, 'open', pointerTypeRef.current);
      if (openDelay) {
        timeoutRef.current = window.setTimeout(() => {
          if (!openRef.current) {
            onOpenChange(true, event, 'hover');
          }
        }, openDelay);
      } else if (!open) {
        onOpenChange(true, event, 'hover');
      }
    }
    function onMouseLeave(event) {
      if (isClickLikeOpenEvent()) return;
      unbindMouseMoveRef.current();
      const doc = floating_ui_react_utils_getDocument(elements.floating);
      clearTimeout(restTimeoutRef.current);
      restTimeoutPendingRef.current = false;
      if (handleCloseRef.current && dataRef.current.floatingContext) {
        // Prevent clearing `onScrollMouseLeave` timeout.
        if (!open) {
          clearTimeout(timeoutRef.current);
        }
        handlerRef.current = handleCloseRef.current({
          ...dataRef.current.floatingContext,
          tree,
          x: event.clientX,
          y: event.clientY,
          onClose() {
            clearPointerEvents();
            cleanupMouseMoveHandler();
            if (!isClickLikeOpenEvent()) {
              closeWithDelay(event, true, 'safe-polygon');
            }
          }
        });
        const handler = handlerRef.current;
        doc.addEventListener('mousemove', handler);
        unbindMouseMoveRef.current = () => {
          doc.removeEventListener('mousemove', handler);
        };
        return;
      }

      // Allow interactivity without `safePolygon` on touch devices. With a
      // pointer, a short close delay is an alternative, so it should work
      // consistently.
      const shouldClose = pointerTypeRef.current === 'touch' ? !floating_ui_react_utils_contains(elements.floating, event.relatedTarget) : true;
      if (shouldClose) {
        closeWithDelay(event);
      }
    }

    // Ensure the floating element closes after scrolling even if the pointer
    // did not move.
    // https://github.com/floating-ui/floating-ui/discussions/1692
    function onScrollMouseLeave(event) {
      if (isClickLikeOpenEvent()) return;
      if (!dataRef.current.floatingContext) return;
      handleCloseRef.current == null || handleCloseRef.current({
        ...dataRef.current.floatingContext,
        tree,
        x: event.clientX,
        y: event.clientY,
        onClose() {
          clearPointerEvents();
          cleanupMouseMoveHandler();
          if (!isClickLikeOpenEvent()) {
            closeWithDelay(event);
          }
        }
      })(event);
    }
    if ((0,floating_ui_utils_dom/* isElement */.kK)(elements.domReference)) {
      var _elements$floating;
      const ref = elements.domReference;
      open && ref.addEventListener('mouseleave', onScrollMouseLeave);
      (_elements$floating = elements.floating) == null || _elements$floating.addEventListener('mouseleave', onScrollMouseLeave);
      move && ref.addEventListener('mousemove', onMouseEnter, {
        once: true
      });
      ref.addEventListener('mouseenter', onMouseEnter);
      ref.addEventListener('mouseleave', onMouseLeave);
      return () => {
        var _elements$floating2;
        open && ref.removeEventListener('mouseleave', onScrollMouseLeave);
        (_elements$floating2 = elements.floating) == null || _elements$floating2.removeEventListener('mouseleave', onScrollMouseLeave);
        move && ref.removeEventListener('mousemove', onMouseEnter);
        ref.removeEventListener('mouseenter', onMouseEnter);
        ref.removeEventListener('mouseleave', onMouseLeave);
      };
    }
  }, [elements, enabled, context, mouseOnly, restMs, move, closeWithDelay, cleanupMouseMoveHandler, clearPointerEvents, onOpenChange, open, openRef, tree, delayRef, handleCloseRef, dataRef, isClickLikeOpenEvent]);

  // Block pointer-events of every element other than the reference and floating
  // while the floating element is open and has a `handleClose` handler. Also
  // handles nested floating elements.
  // https://github.com/floating-ui/floating-ui/issues/1722
  index(() => {
    var _handleCloseRef$curre;
    if (!enabled) return;
    if (open && (_handleCloseRef$curre = handleCloseRef.current) != null && _handleCloseRef$curre.__options.blockPointerEvents && isHoverOpen()) {
      performedPointerEventsMutationRef.current = true;
      const floatingEl = elements.floating;
      if ((0,floating_ui_utils_dom/* isElement */.kK)(elements.domReference) && floatingEl) {
        var _tree$nodesRef$curren;
        const body = floating_ui_react_utils_getDocument(elements.floating).body;
        body.setAttribute(safePolygonIdentifier, '');
        const ref = elements.domReference;
        const parentFloating = tree == null || (_tree$nodesRef$curren = tree.nodesRef.current.find(node => node.id === parentId)) == null || (_tree$nodesRef$curren = _tree$nodesRef$curren.context) == null ? void 0 : _tree$nodesRef$curren.elements.floating;
        if (parentFloating) {
          parentFloating.style.pointerEvents = '';
        }
        body.style.pointerEvents = 'none';
        ref.style.pointerEvents = 'auto';
        floatingEl.style.pointerEvents = 'auto';
        return () => {
          body.style.pointerEvents = '';
          ref.style.pointerEvents = '';
          floatingEl.style.pointerEvents = '';
        };
      }
    }
  }, [enabled, open, parentId, elements, tree, handleCloseRef, isHoverOpen]);
  index(() => {
    if (!open) {
      pointerTypeRef.current = undefined;
      restTimeoutPendingRef.current = false;
      cleanupMouseMoveHandler();
      clearPointerEvents();
    }
  }, [open, cleanupMouseMoveHandler, clearPointerEvents]);
  react.useEffect(() => {
    return () => {
      cleanupMouseMoveHandler();
      clearTimeout(timeoutRef.current);
      clearTimeout(restTimeoutRef.current);
      clearPointerEvents();
    };
  }, [enabled, elements.domReference, cleanupMouseMoveHandler, clearPointerEvents]);
  const reference = react.useMemo(() => {
    function setPointerRef(event) {
      pointerTypeRef.current = event.pointerType;
    }
    return {
      onPointerDown: setPointerRef,
      onPointerEnter: setPointerRef,
      onMouseMove(event) {
        const {
          nativeEvent
        } = event;
        function handleMouseMove() {
          if (!blockMouseMoveRef.current && !openRef.current) {
            onOpenChange(true, nativeEvent, 'hover');
          }
        }
        if (mouseOnly && !floating_ui_react_utils_isMouseLikePointerType(pointerTypeRef.current)) {
          return;
        }
        if (open || restMs === 0) {
          return;
        }

        // Ignore insignificant movements to account for tremors.
        if (restTimeoutPendingRef.current && event.movementX ** 2 + event.movementY ** 2 < 2) {
          return;
        }
        clearTimeout(restTimeoutRef.current);
        if (pointerTypeRef.current === 'touch') {
          handleMouseMove();
        } else {
          restTimeoutPendingRef.current = true;
          restTimeoutRef.current = window.setTimeout(handleMouseMove, restMs);
        }
      }
    };
  }, [mouseOnly, onOpenChange, open, openRef, restMs]);
  const floating = react.useMemo(() => ({
    onMouseEnter() {
      clearTimeout(timeoutRef.current);
    },
    onMouseLeave(event) {
      if (!isClickLikeOpenEvent()) {
        closeWithDelay(event.nativeEvent, false);
      }
    }
  }), [closeWithDelay, isClickLikeOpenEvent]);
  return react.useMemo(() => enabled ? {
    reference,
    floating
  } : {}, [enabled, reference, floating]);
}

const NOOP = () => {};
const FloatingDelayGroupContext = /*#__PURE__*/react.createContext({
  delay: 0,
  initialDelay: 0,
  timeoutMs: 0,
  currentId: null,
  setCurrentId: NOOP,
  setState: NOOP,
  isInstantPhase: false
});

/**
 * @deprecated
 * Use the return value of `useDelayGroup()` instead.
 */
const useDelayGroupContext = () => React.useContext(FloatingDelayGroupContext);
/**
 * Provides context for a group of floating elements that should share a
 * `delay`.
 * @see https://floating-ui.com/docs/FloatingDelayGroup
 */
function FloatingDelayGroup(props) {
  const {
    children,
    delay,
    timeoutMs = 0
  } = props;
  const [state, setState] = React.useReducer((prev, next) => ({
    ...prev,
    ...next
  }), {
    delay,
    timeoutMs,
    initialDelay: delay,
    currentId: null,
    isInstantPhase: false
  });
  const initialCurrentIdRef = React.useRef(null);
  const setCurrentId = React.useCallback(currentId => {
    setState({
      currentId
    });
  }, []);
  index(() => {
    if (state.currentId) {
      if (initialCurrentIdRef.current === null) {
        initialCurrentIdRef.current = state.currentId;
      } else if (!state.isInstantPhase) {
        setState({
          isInstantPhase: true
        });
      }
    } else {
      if (state.isInstantPhase) {
        setState({
          isInstantPhase: false
        });
      }
      initialCurrentIdRef.current = null;
    }
  }, [state.currentId, state.isInstantPhase]);
  return /*#__PURE__*/React.createElement(FloatingDelayGroupContext.Provider, {
    value: React.useMemo(() => ({
      ...state,
      setState,
      setCurrentId
    }), [state, setCurrentId])
  }, children);
}
/**
 * Enables grouping when called inside a component that's a child of a
 * `FloatingDelayGroup`.
 * @see https://floating-ui.com/docs/FloatingDelayGroup
 */
function useDelayGroup(context, options) {
  if (options === void 0) {
    options = {};
  }
  const {
    open,
    onOpenChange,
    floatingId
  } = context;
  const {
    id: optionId,
    enabled = true
  } = options;
  const id = optionId != null ? optionId : floatingId;
  const groupContext = useDelayGroupContext();
  const {
    currentId,
    setCurrentId,
    initialDelay,
    setState,
    timeoutMs
  } = groupContext;
  index(() => {
    if (!enabled) return;
    if (!currentId) return;
    setState({
      delay: {
        open: 1,
        close: getDelay(initialDelay, 'close')
      }
    });
    if (currentId !== id) {
      onOpenChange(false);
    }
  }, [enabled, id, onOpenChange, setState, currentId, initialDelay]);
  index(() => {
    function unset() {
      onOpenChange(false);
      setState({
        delay: initialDelay,
        currentId: null
      });
    }
    if (!enabled) return;
    if (!currentId) return;
    if (!open && currentId === id) {
      if (timeoutMs) {
        const timeout = window.setTimeout(unset, timeoutMs);
        return () => {
          clearTimeout(timeout);
        };
      }
      unset();
    }
  }, [enabled, open, setState, currentId, id, onOpenChange, initialDelay, timeoutMs]);
  index(() => {
    if (!enabled) return;
    if (setCurrentId === NOOP || !open) return;
    setCurrentId(id);
  }, [enabled, open, setCurrentId, id]);
  return groupContext;
}

let rafId = 0;
function enqueueFocus(el, options) {
  if (options === void 0) {
    options = {};
  }
  const {
    preventScroll = false,
    cancelPrevious = true,
    sync = false
  } = options;
  cancelPrevious && cancelAnimationFrame(rafId);
  const exec = () => el == null ? void 0 : el.focus({
    preventScroll
  });
  if (sync) {
    exec();
  } else {
    rafId = requestAnimationFrame(exec);
  }
}

function getAncestors(nodes, id) {
  var _nodes$find;
  let allAncestors = [];
  let currentParentId = (_nodes$find = nodes.find(node => node.id === id)) == null ? void 0 : _nodes$find.parentId;
  while (currentParentId) {
    const currentNode = nodes.find(node => node.id === currentParentId);
    currentParentId = currentNode == null ? void 0 : currentNode.parentId;
    if (currentNode) {
      allAncestors = allAncestors.concat(currentNode);
    }
  }
  return allAncestors;
}

function getChildren(nodes, id) {
  let allChildren = nodes.filter(node => {
    var _node$context;
    return node.parentId === id && ((_node$context = node.context) == null ? void 0 : _node$context.open);
  });
  let currentChildren = allChildren;
  while (currentChildren.length) {
    currentChildren = nodes.filter(node => {
      var _currentChildren;
      return (_currentChildren = currentChildren) == null ? void 0 : _currentChildren.some(n => {
        var _node$context2;
        return node.parentId === n.id && ((_node$context2 = node.context) == null ? void 0 : _node$context2.open);
      });
    });
    allChildren = allChildren.concat(currentChildren);
  }
  return allChildren;
}
function getDeepestNode(nodes, id) {
  let deepestNodeId;
  let maxDepth = -1;
  function findDeepest(nodeId, depth) {
    if (depth > maxDepth) {
      deepestNodeId = nodeId;
      maxDepth = depth;
    }
    const children = getChildren(nodes, nodeId);
    children.forEach(child => {
      findDeepest(child.id, depth + 1);
    });
  }
  findDeepest(id, 0);
  return nodes.find(node => node.id === deepestNodeId);
}

// Modified to add conditional `aria-hidden` support:
// https://github.com/theKashey/aria-hidden/blob/9220c8f4a4fd35f63bee5510a9f41a37264382d4/src/index.ts
let counterMap = /*#__PURE__*/new WeakMap();
let uncontrolledElementsSet = /*#__PURE__*/new WeakSet();
let markerMap = {};
let lockCount$1 = 0;
const supportsInert = () => typeof HTMLElement !== 'undefined' && 'inert' in HTMLElement.prototype;
const unwrapHost = node => node && (node.host || unwrapHost(node.parentNode));
const correctElements = (parent, targets) => targets.map(target => {
  if (parent.contains(target)) {
    return target;
  }
  const correctedTarget = unwrapHost(target);
  if (parent.contains(correctedTarget)) {
    return correctedTarget;
  }
  return null;
}).filter(x => x != null);
function applyAttributeToOthers(uncorrectedAvoidElements, body, ariaHidden, inert) {
  const markerName = 'data-floating-ui-inert';
  const controlAttribute = inert ? 'inert' : ariaHidden ? 'aria-hidden' : null;
  const avoidElements = correctElements(body, uncorrectedAvoidElements);
  const elementsToKeep = new Set();
  const elementsToStop = new Set(avoidElements);
  const hiddenElements = [];
  if (!markerMap[markerName]) {
    markerMap[markerName] = new WeakMap();
  }
  const markerCounter = markerMap[markerName];
  avoidElements.forEach(keep);
  deep(body);
  elementsToKeep.clear();
  function keep(el) {
    if (!el || elementsToKeep.has(el)) {
      return;
    }
    elementsToKeep.add(el);
    el.parentNode && keep(el.parentNode);
  }
  function deep(parent) {
    if (!parent || elementsToStop.has(parent)) {
      return;
    }
    [].forEach.call(parent.children, node => {
      if (getNodeName(node) === 'script') return;
      if (elementsToKeep.has(node)) {
        deep(node);
      } else {
        const attr = controlAttribute ? node.getAttribute(controlAttribute) : null;
        const alreadyHidden = attr !== null && attr !== 'false';
        const counterValue = (counterMap.get(node) || 0) + 1;
        const markerValue = (markerCounter.get(node) || 0) + 1;
        counterMap.set(node, counterValue);
        markerCounter.set(node, markerValue);
        hiddenElements.push(node);
        if (counterValue === 1 && alreadyHidden) {
          uncontrolledElementsSet.add(node);
        }
        if (markerValue === 1) {
          node.setAttribute(markerName, '');
        }
        if (!alreadyHidden && controlAttribute) {
          node.setAttribute(controlAttribute, 'true');
        }
      }
    });
  }
  lockCount$1++;
  return () => {
    hiddenElements.forEach(element => {
      const counterValue = (counterMap.get(element) || 0) - 1;
      const markerValue = (markerCounter.get(element) || 0) - 1;
      counterMap.set(element, counterValue);
      markerCounter.set(element, markerValue);
      if (!counterValue) {
        if (!uncontrolledElementsSet.has(element) && controlAttribute) {
          element.removeAttribute(controlAttribute);
        }
        uncontrolledElementsSet.delete(element);
      }
      if (!markerValue) {
        element.removeAttribute(markerName);
      }
    });
    lockCount$1--;
    if (!lockCount$1) {
      counterMap = new WeakMap();
      counterMap = new WeakMap();
      uncontrolledElementsSet = new WeakSet();
      markerMap = {};
    }
  };
}
function markOthers(avoidElements, ariaHidden, inert) {
  if (ariaHidden === void 0) {
    ariaHidden = false;
  }
  if (inert === void 0) {
    inert = false;
  }
  const body = getDocument(avoidElements[0]).body;
  return applyAttributeToOthers(avoidElements.concat(Array.from(body.querySelectorAll('[aria-live]'))), body, ariaHidden, inert);
}

const getTabbableOptions = () => ({
  getShadowRoot: true,
  displayCheck:
  // JSDOM does not support the `tabbable` library. To solve this we can
  // check if `ResizeObserver` is a real function (not polyfilled), which
  // determines if the current environment is JSDOM-like.
  typeof ResizeObserver === 'function' && ResizeObserver.toString().includes('[native code]') ? 'full' : 'none'
});
function getTabbableIn(container, direction) {
  const allTabbable = tabbable(container, getTabbableOptions());
  if (direction === 'prev') {
    allTabbable.reverse();
  }
  const activeIndex = allTabbable.indexOf(activeElement(getDocument(container)));
  const nextTabbableElements = allTabbable.slice(activeIndex + 1);
  return nextTabbableElements[0];
}
function getNextTabbable() {
  return getTabbableIn(document.body, 'next');
}
function getPreviousTabbable() {
  return getTabbableIn(document.body, 'prev');
}
function isOutsideEvent(event, container) {
  const containerElement = container || event.currentTarget;
  const relatedTarget = event.relatedTarget;
  return !relatedTarget || !contains(containerElement, relatedTarget);
}
function disableFocusInside(container) {
  const tabbableElements = tabbable(container, getTabbableOptions());
  tabbableElements.forEach(element => {
    element.dataset.tabindex = element.getAttribute('tabindex') || '';
    element.setAttribute('tabindex', '-1');
  });
}
function enableFocusInside(container) {
  const elements = container.querySelectorAll('[data-tabindex]');
  elements.forEach(element => {
    const tabindex = element.dataset.tabindex;
    delete element.dataset.tabindex;
    if (tabindex) {
      element.setAttribute('tabindex', tabindex);
    } else {
      element.removeAttribute('tabindex');
    }
  });
}

// See Diego Haz's Sandbox for making this logic work well on Safari/iOS:
// https://codesandbox.io/s/tabbable-portal-f4tng?file=/src/FocusTrap.tsx

const HIDDEN_STYLES = {
  border: 0,
  clip: 'rect(0 0 0 0)',
  height: '1px',
  margin: '-1px',
  overflow: 'hidden',
  padding: 0,
  position: 'fixed',
  whiteSpace: 'nowrap',
  width: '1px',
  top: 0,
  left: 0
};
let timeoutId;
function setActiveElementOnTab(event) {
  if (event.key === 'Tab') {
    event.target;
    clearTimeout(timeoutId);
  }
}
const FocusGuard = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function FocusGuard(props, ref) {
  const [role, setRole] = React.useState();
  index(() => {
    if (isSafari()) {
      // Unlike other screen readers such as NVDA and JAWS, the virtual cursor
      // on VoiceOver does trigger the onFocus event, so we can use the focus
      // trap element. On Safari, only buttons trigger the onFocus event.
      // NB: "group" role in the Sandbox no longer appears to work, must be a
      // button role.
      setRole('button');
    }
    document.addEventListener('keydown', setActiveElementOnTab);
    return () => {
      document.removeEventListener('keydown', setActiveElementOnTab);
    };
  }, []);
  const restProps = {
    ref,
    tabIndex: 0,
    // Role is only for VoiceOver
    role,
    'aria-hidden': role ? undefined : true,
    [createAttribute('focus-guard')]: '',
    style: HIDDEN_STYLES
  };
  return /*#__PURE__*/React.createElement("span", _extends({}, props, restProps));
})));

const PortalContext = /*#__PURE__*/(/* unused pure expression or super */ null && (React.createContext(null)));
const attr = /*#__PURE__*/(/* unused pure expression or super */ null && (createAttribute('portal')));
/**
 * @see https://floating-ui.com/docs/FloatingPortal#usefloatingportalnode
 */
function useFloatingPortalNode(props) {
  if (props === void 0) {
    props = {};
  }
  const {
    id,
    root
  } = props;
  const uniqueId = useId();
  const portalContext = usePortalContext();
  const [portalNode, setPortalNode] = React.useState(null);
  const portalNodeRef = React.useRef(null);
  index(() => {
    return () => {
      portalNode == null || portalNode.remove();
      // Allow the subsequent layout effects to create a new node on updates.
      // The portal node will still be cleaned up on unmount.
      // https://github.com/floating-ui/floating-ui/issues/2454
      queueMicrotask(() => {
        portalNodeRef.current = null;
      });
    };
  }, [portalNode]);
  index(() => {
    // Wait for the uniqueId to be generated before creating the portal node in
    // React <18 (using `useFloatingId` instead of the native `useId`).
    // https://github.com/floating-ui/floating-ui/issues/2778
    if (!uniqueId) return;
    if (portalNodeRef.current) return;
    const existingIdRoot = id ? document.getElementById(id) : null;
    if (!existingIdRoot) return;
    const subRoot = document.createElement('div');
    subRoot.id = uniqueId;
    subRoot.setAttribute(attr, '');
    existingIdRoot.appendChild(subRoot);
    portalNodeRef.current = subRoot;
    setPortalNode(subRoot);
  }, [id, uniqueId]);
  index(() => {
    // Wait for the root to exist before creating the portal node. The root must
    // be stored in state, not a ref, for this to work reactively.
    if (root === null) return;
    if (!uniqueId) return;
    if (portalNodeRef.current) return;
    let container = root || (portalContext == null ? void 0 : portalContext.portalNode);
    if (container && !isElement(container)) container = container.current;
    container = container || document.body;
    let idWrapper = null;
    if (id) {
      idWrapper = document.createElement('div');
      idWrapper.id = id;
      container.appendChild(idWrapper);
    }
    const subRoot = document.createElement('div');
    subRoot.id = uniqueId;
    subRoot.setAttribute(attr, '');
    container = idWrapper || container;
    container.appendChild(subRoot);
    portalNodeRef.current = subRoot;
    setPortalNode(subRoot);
  }, [id, root, uniqueId, portalContext]);
  return portalNode;
}
/**
 * Portals the floating element into a given container element — by default,
 * outside of the app root and into the body.
 * This is necessary to ensure the floating element can appear outside any
 * potential parent containers that cause clipping (such as `overflow: hidden`),
 * while retaining its location in the React tree.
 * @see https://floating-ui.com/docs/FloatingPortal
 */
function FloatingPortal(props) {
  const {
    children,
    id,
    root,
    preserveTabOrder = true
  } = props;
  const portalNode = useFloatingPortalNode({
    id,
    root
  });
  const [focusManagerState, setFocusManagerState] = React.useState(null);
  const beforeOutsideRef = React.useRef(null);
  const afterOutsideRef = React.useRef(null);
  const beforeInsideRef = React.useRef(null);
  const afterInsideRef = React.useRef(null);
  const modal = focusManagerState == null ? void 0 : focusManagerState.modal;
  const open = focusManagerState == null ? void 0 : focusManagerState.open;
  const shouldRenderGuards =
  // The FocusManager and therefore floating element are currently open/
  // rendered.
  !!focusManagerState &&
  // Guards are only for non-modal focus management.
  !focusManagerState.modal &&
  // Don't render if unmount is transitioning.
  focusManagerState.open && preserveTabOrder && !!(root || portalNode);

  // https://codesandbox.io/s/tabbable-portal-f4tng?file=/src/TabbablePortal.tsx
  React.useEffect(() => {
    if (!portalNode || !preserveTabOrder || modal) {
      return;
    }

    // Make sure elements inside the portal element are tabbable only when the
    // portal has already been focused, either by tabbing into a focus trap
    // element outside or using the mouse.
    function onFocus(event) {
      if (portalNode && isOutsideEvent(event)) {
        const focusing = event.type === 'focusin';
        const manageFocus = focusing ? enableFocusInside : disableFocusInside;
        manageFocus(portalNode);
      }
    }
    // Listen to the event on the capture phase so they run before the focus
    // trap elements onFocus prop is called.
    portalNode.addEventListener('focusin', onFocus, true);
    portalNode.addEventListener('focusout', onFocus, true);
    return () => {
      portalNode.removeEventListener('focusin', onFocus, true);
      portalNode.removeEventListener('focusout', onFocus, true);
    };
  }, [portalNode, preserveTabOrder, modal]);
  React.useEffect(() => {
    if (!portalNode) return;
    if (open) return;
    enableFocusInside(portalNode);
  }, [open, portalNode]);
  return /*#__PURE__*/React.createElement(PortalContext.Provider, {
    value: React.useMemo(() => ({
      preserveTabOrder,
      beforeOutsideRef,
      afterOutsideRef,
      beforeInsideRef,
      afterInsideRef,
      portalNode,
      setFocusManagerState
    }), [preserveTabOrder, portalNode])
  }, shouldRenderGuards && portalNode && /*#__PURE__*/React.createElement(FocusGuard, {
    "data-type": "outside",
    ref: beforeOutsideRef,
    onFocus: event => {
      if (isOutsideEvent(event, portalNode)) {
        var _beforeInsideRef$curr;
        (_beforeInsideRef$curr = beforeInsideRef.current) == null || _beforeInsideRef$curr.focus();
      } else {
        const prevTabbable = getPreviousTabbable() || (focusManagerState == null ? void 0 : focusManagerState.refs.domReference.current);
        prevTabbable == null || prevTabbable.focus();
      }
    }
  }), shouldRenderGuards && portalNode && /*#__PURE__*/React.createElement("span", {
    "aria-owns": portalNode.id,
    style: HIDDEN_STYLES
  }), portalNode && /*#__PURE__*/ReactDOM.createPortal(children, portalNode), shouldRenderGuards && portalNode && /*#__PURE__*/React.createElement(FocusGuard, {
    "data-type": "outside",
    ref: afterOutsideRef,
    onFocus: event => {
      if (isOutsideEvent(event, portalNode)) {
        var _afterInsideRef$curre;
        (_afterInsideRef$curre = afterInsideRef.current) == null || _afterInsideRef$curre.focus();
      } else {
        const nextTabbable = getNextTabbable() || (focusManagerState == null ? void 0 : focusManagerState.refs.domReference.current);
        nextTabbable == null || nextTabbable.focus();
        (focusManagerState == null ? void 0 : focusManagerState.closeOnFocusOut) && (focusManagerState == null ? void 0 : focusManagerState.onOpenChange(false, event.nativeEvent, 'focus-out'));
      }
    }
  }));
}
const usePortalContext = () => React.useContext(PortalContext);

const FOCUSABLE_ATTRIBUTE = 'data-floating-ui-focusable';
function getFloatingFocusElement(floatingElement) {
  if (!floatingElement) {
    return null;
  }
  // Try to find the element that has `{...getFloatingProps()}` spread on it.
  // This indicates the floating element is acting as a positioning wrapper, and
  // so focus should be managed on the child element with the event handlers and
  // aria props.
  return floatingElement.hasAttribute(FOCUSABLE_ATTRIBUTE) ? floatingElement : floatingElement.querySelector("[" + FOCUSABLE_ATTRIBUTE + "]") || floatingElement;
}

const LIST_LIMIT = 20;
let previouslyFocusedElements = (/* unused pure expression or super */ null && ([]));
function addPreviouslyFocusedElement(element) {
  previouslyFocusedElements = previouslyFocusedElements.filter(el => el.isConnected);
  let tabbableEl = element;
  if (!tabbableEl || getNodeName(tabbableEl) === 'body') return;
  if (!isTabbable(tabbableEl, getTabbableOptions())) {
    const tabbableChild = tabbable(tabbableEl, getTabbableOptions())[0];
    if (tabbableChild) {
      tabbableEl = tabbableChild;
    }
  }
  previouslyFocusedElements.push(tabbableEl);
  if (previouslyFocusedElements.length > LIST_LIMIT) {
    previouslyFocusedElements = previouslyFocusedElements.slice(-LIST_LIMIT);
  }
}
function getPreviouslyFocusedElement() {
  return previouslyFocusedElements.slice().reverse().find(el => el.isConnected);
}
const VisuallyHiddenDismiss = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function VisuallyHiddenDismiss(props, ref) {
  return /*#__PURE__*/React.createElement("button", _extends({}, props, {
    type: "button",
    ref: ref,
    tabIndex: -1,
    style: HIDDEN_STYLES
  }));
})));
/**
 * Provides focus management for the floating element.
 * @see https://floating-ui.com/docs/FloatingFocusManager
 */
function FloatingFocusManager(props) {
  const {
    context,
    children,
    disabled = false,
    order = ['content'],
    guards: _guards = true,
    initialFocus = 0,
    returnFocus = true,
    restoreFocus = false,
    modal = true,
    visuallyHiddenDismiss = false,
    closeOnFocusOut = true
  } = props;
  const {
    open,
    refs,
    nodeId,
    onOpenChange,
    events,
    dataRef,
    floatingId,
    elements: {
      domReference,
      floating
    }
  } = context;
  const ignoreInitialFocus = typeof initialFocus === 'number' && initialFocus < 0;
  // If the reference is a combobox and is typeable (e.g. input/textarea),
  // there are different focus semantics. The guards should not be rendered, but
  // aria-hidden should be applied to all nodes still. Further, the visually
  // hidden dismiss button should only appear at the end of the list, not the
  // start.
  const isUntrappedTypeableCombobox = isTypeableCombobox(domReference) && ignoreInitialFocus;

  // Force the guards to be rendered if the `inert` attribute is not supported.
  const guards = supportsInert() ? _guards : true;
  const orderRef = useLatestRef(order);
  const initialFocusRef = useLatestRef(initialFocus);
  const returnFocusRef = useLatestRef(returnFocus);
  const tree = useFloatingTree();
  const portalContext = usePortalContext();
  const startDismissButtonRef = React.useRef(null);
  const endDismissButtonRef = React.useRef(null);
  const preventReturnFocusRef = React.useRef(false);
  const isPointerDownRef = React.useRef(false);
  const tabbableIndexRef = React.useRef(-1);
  const isInsidePortal = portalContext != null;
  const floatingFocusElement = getFloatingFocusElement(floating);
  const getTabbableContent = useEffectEvent(function (container) {
    if (container === void 0) {
      container = floatingFocusElement;
    }
    return container ? tabbable(container, getTabbableOptions()) : [];
  });
  const getTabbableElements = useEffectEvent(container => {
    const content = getTabbableContent(container);
    return orderRef.current.map(type => {
      if (domReference && type === 'reference') {
        return domReference;
      }
      if (floatingFocusElement && type === 'floating') {
        return floatingFocusElement;
      }
      return content;
    }).filter(Boolean).flat();
  });
  React.useEffect(() => {
    if (disabled) return;
    if (!modal) return;
    function onKeyDown(event) {
      if (event.key === 'Tab') {
        // The focus guards have nothing to focus, so we need to stop the event.
        if (contains(floatingFocusElement, activeElement(getDocument(floatingFocusElement))) && getTabbableContent().length === 0 && !isUntrappedTypeableCombobox) {
          stopEvent(event);
        }
        const els = getTabbableElements();
        const target = getTarget(event);
        if (orderRef.current[0] === 'reference' && target === domReference) {
          stopEvent(event);
          if (event.shiftKey) {
            enqueueFocus(els[els.length - 1]);
          } else {
            enqueueFocus(els[1]);
          }
        }
        if (orderRef.current[1] === 'floating' && target === floatingFocusElement && event.shiftKey) {
          stopEvent(event);
          enqueueFocus(els[0]);
        }
      }
    }
    const doc = getDocument(floatingFocusElement);
    doc.addEventListener('keydown', onKeyDown);
    return () => {
      doc.removeEventListener('keydown', onKeyDown);
    };
  }, [disabled, domReference, floatingFocusElement, modal, orderRef, isUntrappedTypeableCombobox, getTabbableContent, getTabbableElements]);
  React.useEffect(() => {
    if (disabled) return;
    if (!floating) return;
    function handleFocusIn(event) {
      const target = getTarget(event);
      const tabbableContent = getTabbableContent();
      const tabbableIndex = tabbableContent.indexOf(target);
      if (tabbableIndex !== -1) {
        tabbableIndexRef.current = tabbableIndex;
      }
    }
    floating.addEventListener('focusin', handleFocusIn);
    return () => {
      floating.removeEventListener('focusin', handleFocusIn);
    };
  }, [disabled, floating, getTabbableContent]);
  React.useEffect(() => {
    if (disabled) return;
    if (!closeOnFocusOut) return;

    // In Safari, buttons lose focus when pressing them.
    function handlePointerDown() {
      isPointerDownRef.current = true;
      setTimeout(() => {
        isPointerDownRef.current = false;
      });
    }
    function handleFocusOutside(event) {
      const relatedTarget = event.relatedTarget;
      queueMicrotask(() => {
        const movedToUnrelatedNode = !(contains(domReference, relatedTarget) || contains(floating, relatedTarget) || contains(relatedTarget, floating) || contains(portalContext == null ? void 0 : portalContext.portalNode, relatedTarget) || relatedTarget != null && relatedTarget.hasAttribute(createAttribute('focus-guard')) || tree && (getChildren(tree.nodesRef.current, nodeId).find(node => {
          var _node$context, _node$context2;
          return contains((_node$context = node.context) == null ? void 0 : _node$context.elements.floating, relatedTarget) || contains((_node$context2 = node.context) == null ? void 0 : _node$context2.elements.domReference, relatedTarget);
        }) || getAncestors(tree.nodesRef.current, nodeId).find(node => {
          var _node$context3, _node$context4;
          return ((_node$context3 = node.context) == null ? void 0 : _node$context3.elements.floating) === relatedTarget || ((_node$context4 = node.context) == null ? void 0 : _node$context4.elements.domReference) === relatedTarget;
        })));

        // Restore focus to the previous tabbable element index to prevent
        // focus from being lost outside the floating tree.
        if (restoreFocus && movedToUnrelatedNode && activeElement(getDocument(floatingFocusElement)) === getDocument(floatingFocusElement).body) {
          // Let `FloatingPortal` effect knows that focus is still inside the
          // floating tree.
          if (isHTMLElement(floatingFocusElement)) {
            floatingFocusElement.focus();
          }
          const prevTabbableIndex = tabbableIndexRef.current;
          const tabbableContent = getTabbableContent();
          const nodeToFocus = tabbableContent[prevTabbableIndex] || tabbableContent[tabbableContent.length - 1] || floatingFocusElement;
          if (isHTMLElement(nodeToFocus)) {
            nodeToFocus.focus();
          }
        }

        // Focus did not move inside the floating tree, and there are no tabbable
        // portal guards to handle closing.
        if ((isUntrappedTypeableCombobox ? true : !modal) && relatedTarget && movedToUnrelatedNode && !isPointerDownRef.current &&
        // Fix React 18 Strict Mode returnFocus due to double rendering.
        relatedTarget !== getPreviouslyFocusedElement()) {
          preventReturnFocusRef.current = true;
          onOpenChange(false, event, 'focus-out');
        }
      });
    }
    if (floating && isHTMLElement(domReference)) {
      domReference.addEventListener('focusout', handleFocusOutside);
      domReference.addEventListener('pointerdown', handlePointerDown);
      floating.addEventListener('focusout', handleFocusOutside);
      return () => {
        domReference.removeEventListener('focusout', handleFocusOutside);
        domReference.removeEventListener('pointerdown', handlePointerDown);
        floating.removeEventListener('focusout', handleFocusOutside);
      };
    }
  }, [disabled, domReference, floating, floatingFocusElement, modal, nodeId, tree, portalContext, onOpenChange, closeOnFocusOut, restoreFocus, getTabbableContent, isUntrappedTypeableCombobox]);
  React.useEffect(() => {
    var _portalContext$portal;
    if (disabled) return;

    // Don't hide portals nested within the parent portal.
    const portalNodes = Array.from((portalContext == null || (_portalContext$portal = portalContext.portalNode) == null ? void 0 : _portalContext$portal.querySelectorAll("[" + createAttribute('portal') + "]")) || []);
    if (floating) {
      const insideElements = [floating, ...portalNodes, startDismissButtonRef.current, endDismissButtonRef.current, orderRef.current.includes('reference') || isUntrappedTypeableCombobox ? domReference : null].filter(x => x != null);
      const cleanup = modal || isUntrappedTypeableCombobox ? markOthers(insideElements, guards, !guards) : markOthers(insideElements);
      return () => {
        cleanup();
      };
    }
  }, [disabled, domReference, floating, modal, orderRef, portalContext, isUntrappedTypeableCombobox, guards]);
  index(() => {
    if (disabled || !isHTMLElement(floatingFocusElement)) return;
    const doc = getDocument(floatingFocusElement);
    const previouslyFocusedElement = activeElement(doc);

    // Wait for any layout effect state setters to execute to set `tabIndex`.
    queueMicrotask(() => {
      const focusableElements = getTabbableElements(floatingFocusElement);
      const initialFocusValue = initialFocusRef.current;
      const elToFocus = (typeof initialFocusValue === 'number' ? focusableElements[initialFocusValue] : initialFocusValue.current) || floatingFocusElement;
      const focusAlreadyInsideFloatingEl = contains(floatingFocusElement, previouslyFocusedElement);
      if (!ignoreInitialFocus && !focusAlreadyInsideFloatingEl && open) {
        enqueueFocus(elToFocus, {
          preventScroll: elToFocus === floatingFocusElement
        });
      }
    });
  }, [disabled, open, floatingFocusElement, ignoreInitialFocus, getTabbableElements, initialFocusRef]);
  index(() => {
    if (disabled || !floatingFocusElement) return;
    let preventReturnFocusScroll = false;
    const doc = getDocument(floatingFocusElement);
    const previouslyFocusedElement = activeElement(doc);
    const contextData = dataRef.current;
    let openEvent = contextData.openEvent;
    addPreviouslyFocusedElement(previouslyFocusedElement);

    // Dismissing via outside press should always ignore `returnFocus` to
    // prevent unwanted scrolling.
    function onOpenChange(_ref) {
      let {
        open,
        reason,
        event,
        nested
      } = _ref;
      if (open) {
        openEvent = event;
      }
      if (reason === 'escape-key' && refs.domReference.current) {
        addPreviouslyFocusedElement(refs.domReference.current);
      }
      if (reason === 'hover' && event.type === 'mouseleave') {
        preventReturnFocusRef.current = true;
      }
      if (reason !== 'outside-press') return;
      if (nested) {
        preventReturnFocusRef.current = false;
        preventReturnFocusScroll = true;
      } else {
        preventReturnFocusRef.current = !(isVirtualClick(event) || isVirtualPointerEvent(event));
      }
    }
    events.on('openchange', onOpenChange);
    const fallbackEl = doc.createElement('span');
    fallbackEl.setAttribute('tabindex', '-1');
    fallbackEl.setAttribute('aria-hidden', 'true');
    Object.assign(fallbackEl.style, HIDDEN_STYLES);
    if (isInsidePortal && domReference) {
      domReference.insertAdjacentElement('afterend', fallbackEl);
    }
    function getReturnElement() {
      if (typeof returnFocusRef.current === 'boolean') {
        return getPreviouslyFocusedElement() || fallbackEl;
      }
      return returnFocusRef.current.current || fallbackEl;
    }
    return () => {
      events.off('openchange', onOpenChange);
      const activeEl = activeElement(doc);
      const isFocusInsideFloatingTree = contains(floating, activeEl) || tree && getChildren(tree.nodesRef.current, nodeId).some(node => {
        var _node$context5;
        return contains((_node$context5 = node.context) == null ? void 0 : _node$context5.elements.floating, activeEl);
      });
      const shouldFocusReference = isFocusInsideFloatingTree || openEvent && ['click', 'mousedown'].includes(openEvent.type);
      if (shouldFocusReference && refs.domReference.current) {
        addPreviouslyFocusedElement(refs.domReference.current);
      }
      const returnElement = getReturnElement();
      queueMicrotask(() => {
        if (
        // eslint-disable-next-line react-hooks/exhaustive-deps
        returnFocusRef.current && !preventReturnFocusRef.current && isHTMLElement(returnElement) && (
        // If the focus moved somewhere else after mount, avoid returning focus
        // since it likely entered a different element which should be
        // respected: https://github.com/floating-ui/floating-ui/issues/2607
        returnElement !== activeEl && activeEl !== doc.body ? isFocusInsideFloatingTree : true)) {
          returnElement.focus({
            preventScroll: preventReturnFocusScroll
          });
        }
        fallbackEl.remove();
      });
    };
  }, [disabled, floating, floatingFocusElement, returnFocusRef, dataRef, refs, events, tree, nodeId, isInsidePortal, domReference]);
  React.useEffect(() => {
    // The `returnFocus` cleanup behavior is inside a microtask; ensure we
    // wait for it to complete before resetting the flag.
    queueMicrotask(() => {
      preventReturnFocusRef.current = false;
    });
  }, [disabled]);

  // Synchronize the `context` & `modal` value to the FloatingPortal context.
  // It will decide whether or not it needs to render its own guards.
  index(() => {
    if (disabled) return;
    if (!portalContext) return;
    portalContext.setFocusManagerState({
      modal,
      closeOnFocusOut,
      open,
      onOpenChange,
      refs
    });
    return () => {
      portalContext.setFocusManagerState(null);
    };
  }, [disabled, portalContext, modal, open, onOpenChange, refs, closeOnFocusOut]);
  index(() => {
    if (disabled) return;
    if (!floatingFocusElement) return;
    if (typeof MutationObserver !== 'function') return;
    if (ignoreInitialFocus) return;
    const handleMutation = () => {
      const tabIndex = floatingFocusElement.getAttribute('tabindex');
      const tabbableContent = getTabbableContent();
      const activeEl = activeElement(getDocument(floating));
      const tabbableIndex = tabbableContent.indexOf(activeEl);
      if (tabbableIndex !== -1) {
        tabbableIndexRef.current = tabbableIndex;
      }
      if (orderRef.current.includes('floating') || activeEl !== refs.domReference.current && tabbableContent.length === 0) {
        if (tabIndex !== '0') {
          floatingFocusElement.setAttribute('tabindex', '0');
        }
      } else if (tabIndex !== '-1') {
        floatingFocusElement.setAttribute('tabindex', '-1');
      }
    };
    handleMutation();
    const observer = new MutationObserver(handleMutation);
    observer.observe(floatingFocusElement, {
      childList: true,
      subtree: true,
      attributes: true
    });
    return () => {
      observer.disconnect();
    };
  }, [disabled, floating, floatingFocusElement, refs, orderRef, getTabbableContent, ignoreInitialFocus]);
  function renderDismissButton(location) {
    if (disabled || !visuallyHiddenDismiss || !modal) {
      return null;
    }
    return /*#__PURE__*/React.createElement(VisuallyHiddenDismiss, {
      ref: location === 'start' ? startDismissButtonRef : endDismissButtonRef,
      onClick: event => onOpenChange(false, event.nativeEvent)
    }, typeof visuallyHiddenDismiss === 'string' ? visuallyHiddenDismiss : 'Dismiss');
  }
  const shouldRenderGuards = !disabled && guards && (modal ? !isUntrappedTypeableCombobox : true) && (isInsidePortal || modal);
  return /*#__PURE__*/React.createElement(React.Fragment, null, shouldRenderGuards && /*#__PURE__*/React.createElement(FocusGuard, {
    "data-type": "inside",
    ref: portalContext == null ? void 0 : portalContext.beforeInsideRef,
    onFocus: event => {
      if (modal) {
        const els = getTabbableElements();
        enqueueFocus(order[0] === 'reference' ? els[0] : els[els.length - 1]);
      } else if (portalContext != null && portalContext.preserveTabOrder && portalContext.portalNode) {
        preventReturnFocusRef.current = false;
        if (isOutsideEvent(event, portalContext.portalNode)) {
          const nextTabbable = getNextTabbable() || domReference;
          nextTabbable == null || nextTabbable.focus();
        } else {
          var _portalContext$before;
          (_portalContext$before = portalContext.beforeOutsideRef.current) == null || _portalContext$before.focus();
        }
      }
    }
  }), !isUntrappedTypeableCombobox && renderDismissButton('start'), children, renderDismissButton('end'), shouldRenderGuards && /*#__PURE__*/React.createElement(FocusGuard, {
    "data-type": "inside",
    ref: portalContext == null ? void 0 : portalContext.afterInsideRef,
    onFocus: event => {
      if (modal) {
        enqueueFocus(getTabbableElements()[0]);
      } else if (portalContext != null && portalContext.preserveTabOrder && portalContext.portalNode) {
        if (closeOnFocusOut) {
          preventReturnFocusRef.current = true;
        }
        if (isOutsideEvent(event, portalContext.portalNode)) {
          const prevTabbable = getPreviousTabbable() || domReference;
          prevTabbable == null || prevTabbable.focus();
        } else {
          var _portalContext$afterO;
          (_portalContext$afterO = portalContext.afterOutsideRef.current) == null || _portalContext$afterO.focus();
        }
      }
    }
  }));
}

let lockCount = 0;
function enableScrollLock() {
  const isIOS = /iP(hone|ad|od)|iOS/.test(getPlatform());
  const bodyStyle = document.body.style;
  // RTL <body> scrollbar
  const scrollbarX = Math.round(document.documentElement.getBoundingClientRect().left) + document.documentElement.scrollLeft;
  const paddingProp = scrollbarX ? 'paddingLeft' : 'paddingRight';
  const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
  const scrollX = bodyStyle.left ? parseFloat(bodyStyle.left) : window.scrollX;
  const scrollY = bodyStyle.top ? parseFloat(bodyStyle.top) : window.scrollY;
  bodyStyle.overflow = 'hidden';
  if (scrollbarWidth) {
    bodyStyle[paddingProp] = scrollbarWidth + "px";
  }

  // Only iOS doesn't respect `overflow: hidden` on document.body, and this
  // technique has fewer side effects.
  if (isIOS) {
    var _window$visualViewpor, _window$visualViewpor2;
    // iOS 12 does not support `visualViewport`.
    const offsetLeft = ((_window$visualViewpor = window.visualViewport) == null ? void 0 : _window$visualViewpor.offsetLeft) || 0;
    const offsetTop = ((_window$visualViewpor2 = window.visualViewport) == null ? void 0 : _window$visualViewpor2.offsetTop) || 0;
    Object.assign(bodyStyle, {
      position: 'fixed',
      top: -(scrollY - Math.floor(offsetTop)) + "px",
      left: -(scrollX - Math.floor(offsetLeft)) + "px",
      right: '0'
    });
  }
  return () => {
    Object.assign(bodyStyle, {
      overflow: '',
      [paddingProp]: ''
    });
    if (isIOS) {
      Object.assign(bodyStyle, {
        position: '',
        top: '',
        left: '',
        right: ''
      });
      window.scrollTo(scrollX, scrollY);
    }
  };
}
let cleanup = () => {};

/**
 * Provides base styling for a fixed overlay element to dim content or block
 * pointer events behind a floating element.
 * It's a regular `<div>`, so it can be styled via any CSS solution you prefer.
 * @see https://floating-ui.com/docs/FloatingOverlay
 */
const FloatingOverlay = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function FloatingOverlay(props, ref) {
  const {
    lockScroll = false,
    ...rest
  } = props;
  index(() => {
    if (!lockScroll) return;
    lockCount++;
    if (lockCount === 1) {
      cleanup = enableScrollLock();
    }
    return () => {
      lockCount--;
      if (lockCount === 0) {
        cleanup();
      }
    };
  }, [lockScroll]);
  return /*#__PURE__*/React.createElement("div", _extends({
    ref: ref
  }, rest, {
    style: {
      position: 'fixed',
      overflow: 'auto',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      ...rest.style
    }
  }));
})));

function isButtonTarget(event) {
  return isHTMLElement(event.target) && event.target.tagName === 'BUTTON';
}
function isSpaceIgnored(element) {
  return isTypeableElement(element);
}
/**
 * Opens or closes the floating element when clicking the reference element.
 * @see https://floating-ui.com/docs/useClick
 */
function useClick(context, props) {
  if (props === void 0) {
    props = {};
  }
  const {
    open,
    onOpenChange,
    dataRef,
    elements: {
      domReference
    }
  } = context;
  const {
    enabled = true,
    event: eventOption = 'click',
    toggle = true,
    ignoreMouse = false,
    keyboardHandlers = true,
    stickIfOpen = true
  } = props;
  const pointerTypeRef = React.useRef();
  const didKeyDownRef = React.useRef(false);
  const reference = React.useMemo(() => ({
    onPointerDown(event) {
      pointerTypeRef.current = event.pointerType;
    },
    onMouseDown(event) {
      const pointerType = pointerTypeRef.current;

      // Ignore all buttons except for the "main" button.
      // https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/button
      if (event.button !== 0) return;
      if (eventOption === 'click') return;
      if (isMouseLikePointerType(pointerType, true) && ignoreMouse) return;
      if (open && toggle && (dataRef.current.openEvent && stickIfOpen ? dataRef.current.openEvent.type === 'mousedown' : true)) {
        onOpenChange(false, event.nativeEvent, 'click');
      } else {
        // Prevent stealing focus from the floating element
        event.preventDefault();
        onOpenChange(true, event.nativeEvent, 'click');
      }
    },
    onClick(event) {
      const pointerType = pointerTypeRef.current;
      if (eventOption === 'mousedown' && pointerTypeRef.current) {
        pointerTypeRef.current = undefined;
        return;
      }
      if (isMouseLikePointerType(pointerType, true) && ignoreMouse) return;
      if (open && toggle && (dataRef.current.openEvent && stickIfOpen ? dataRef.current.openEvent.type === 'click' : true)) {
        onOpenChange(false, event.nativeEvent, 'click');
      } else {
        onOpenChange(true, event.nativeEvent, 'click');
      }
    },
    onKeyDown(event) {
      pointerTypeRef.current = undefined;
      if (event.defaultPrevented || !keyboardHandlers || isButtonTarget(event)) {
        return;
      }
      if (event.key === ' ' && !isSpaceIgnored(domReference)) {
        // Prevent scrolling
        event.preventDefault();
        didKeyDownRef.current = true;
      }
      if (event.key === 'Enter') {
        if (open && toggle) {
          onOpenChange(false, event.nativeEvent, 'click');
        } else {
          onOpenChange(true, event.nativeEvent, 'click');
        }
      }
    },
    onKeyUp(event) {
      if (event.defaultPrevented || !keyboardHandlers || isButtonTarget(event) || isSpaceIgnored(domReference)) {
        return;
      }
      if (event.key === ' ' && didKeyDownRef.current) {
        didKeyDownRef.current = false;
        if (open && toggle) {
          onOpenChange(false, event.nativeEvent, 'click');
        } else {
          onOpenChange(true, event.nativeEvent, 'click');
        }
      }
    }
  }), [dataRef, domReference, eventOption, ignoreMouse, keyboardHandlers, onOpenChange, open, stickIfOpen, toggle]);
  return React.useMemo(() => enabled ? {
    reference
  } : {}, [enabled, reference]);
}

function createVirtualElement(domElement, data) {
  let offsetX = null;
  let offsetY = null;
  let isAutoUpdateEvent = false;
  return {
    contextElement: domElement || undefined,
    getBoundingClientRect() {
      var _data$dataRef$current;
      const domRect = (domElement == null ? void 0 : domElement.getBoundingClientRect()) || {
        width: 0,
        height: 0,
        x: 0,
        y: 0
      };
      const isXAxis = data.axis === 'x' || data.axis === 'both';
      const isYAxis = data.axis === 'y' || data.axis === 'both';
      const canTrackCursorOnAutoUpdate = ['mouseenter', 'mousemove'].includes(((_data$dataRef$current = data.dataRef.current.openEvent) == null ? void 0 : _data$dataRef$current.type) || '') && data.pointerType !== 'touch';
      let width = domRect.width;
      let height = domRect.height;
      let x = domRect.x;
      let y = domRect.y;
      if (offsetX == null && data.x && isXAxis) {
        offsetX = domRect.x - data.x;
      }
      if (offsetY == null && data.y && isYAxis) {
        offsetY = domRect.y - data.y;
      }
      x -= offsetX || 0;
      y -= offsetY || 0;
      width = 0;
      height = 0;
      if (!isAutoUpdateEvent || canTrackCursorOnAutoUpdate) {
        width = data.axis === 'y' ? domRect.width : 0;
        height = data.axis === 'x' ? domRect.height : 0;
        x = isXAxis && data.x != null ? data.x : x;
        y = isYAxis && data.y != null ? data.y : y;
      } else if (isAutoUpdateEvent && !canTrackCursorOnAutoUpdate) {
        height = data.axis === 'x' ? domRect.height : height;
        width = data.axis === 'y' ? domRect.width : width;
      }
      isAutoUpdateEvent = true;
      return {
        width,
        height,
        x,
        y,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x
      };
    }
  };
}
function isMouseBasedEvent(event) {
  return event != null && event.clientX != null;
}
/**
 * Positions the floating element relative to a client point (in the viewport),
 * such as the mouse position. By default, it follows the mouse cursor.
 * @see https://floating-ui.com/docs/useClientPoint
 */
function useClientPoint(context, props) {
  if (props === void 0) {
    props = {};
  }
  const {
    open,
    dataRef,
    elements: {
      floating,
      domReference
    },
    refs
  } = context;
  const {
    enabled = true,
    axis = 'both',
    x = null,
    y = null
  } = props;
  const initialRef = React.useRef(false);
  const cleanupListenerRef = React.useRef(null);
  const [pointerType, setPointerType] = React.useState();
  const [reactive, setReactive] = React.useState([]);
  const setReference = useEffectEvent((x, y) => {
    if (initialRef.current) return;

    // Prevent setting if the open event was not a mouse-like one
    // (e.g. focus to open, then hover over the reference element).
    // Only apply if the event exists.
    if (dataRef.current.openEvent && !isMouseBasedEvent(dataRef.current.openEvent)) {
      return;
    }
    refs.setPositionReference(createVirtualElement(domReference, {
      x,
      y,
      axis,
      dataRef,
      pointerType
    }));
  });
  const handleReferenceEnterOrMove = useEffectEvent(event => {
    if (x != null || y != null) return;
    if (!open) {
      setReference(event.clientX, event.clientY);
    } else if (!cleanupListenerRef.current) {
      // If there's no cleanup, there's no listener, but we want to ensure
      // we add the listener if the cursor landed on the floating element and
      // then back on the reference (i.e. it's interactive).
      setReactive([]);
    }
  });

  // If the pointer is a mouse-like pointer, we want to continue following the
  // mouse even if the floating element is transitioning out. On touch
  // devices, this is undesirable because the floating element will move to
  // the dismissal touch point.
  const openCheck = isMouseLikePointerType(pointerType) ? floating : open;
  const addListener = React.useCallback(() => {
    // Explicitly specified `x`/`y` coordinates shouldn't add a listener.
    if (!openCheck || !enabled || x != null || y != null) return;
    const win = getWindow(floating);
    function handleMouseMove(event) {
      const target = getTarget(event);
      if (!contains(floating, target)) {
        setReference(event.clientX, event.clientY);
      } else {
        win.removeEventListener('mousemove', handleMouseMove);
        cleanupListenerRef.current = null;
      }
    }
    if (!dataRef.current.openEvent || isMouseBasedEvent(dataRef.current.openEvent)) {
      win.addEventListener('mousemove', handleMouseMove);
      const cleanup = () => {
        win.removeEventListener('mousemove', handleMouseMove);
        cleanupListenerRef.current = null;
      };
      cleanupListenerRef.current = cleanup;
      return cleanup;
    }
    refs.setPositionReference(domReference);
  }, [openCheck, enabled, x, y, floating, dataRef, refs, domReference, setReference]);
  React.useEffect(() => {
    return addListener();
  }, [addListener, reactive]);
  React.useEffect(() => {
    if (enabled && !floating) {
      initialRef.current = false;
    }
  }, [enabled, floating]);
  React.useEffect(() => {
    if (!enabled && open) {
      initialRef.current = true;
    }
  }, [enabled, open]);
  index(() => {
    if (enabled && (x != null || y != null)) {
      initialRef.current = false;
      setReference(x, y);
    }
  }, [enabled, x, y, setReference]);
  const reference = React.useMemo(() => {
    function setPointerTypeRef(_ref) {
      let {
        pointerType
      } = _ref;
      setPointerType(pointerType);
    }
    return {
      onPointerDown: setPointerTypeRef,
      onPointerEnter: setPointerTypeRef,
      onMouseMove: handleReferenceEnterOrMove,
      onMouseEnter: handleReferenceEnterOrMove
    };
  }, [handleReferenceEnterOrMove]);
  return React.useMemo(() => enabled ? {
    reference
  } : {}, [enabled, reference]);
}

const bubbleHandlerKeys = {
  pointerdown: 'onPointerDown',
  mousedown: 'onMouseDown',
  click: 'onClick'
};
const captureHandlerKeys = {
  pointerdown: 'onPointerDownCapture',
  mousedown: 'onMouseDownCapture',
  click: 'onClickCapture'
};
const normalizeProp = normalizable => {
  var _normalizable$escapeK, _normalizable$outside;
  return {
    escapeKey: typeof normalizable === 'boolean' ? normalizable : (_normalizable$escapeK = normalizable == null ? void 0 : normalizable.escapeKey) != null ? _normalizable$escapeK : false,
    outsidePress: typeof normalizable === 'boolean' ? normalizable : (_normalizable$outside = normalizable == null ? void 0 : normalizable.outsidePress) != null ? _normalizable$outside : true
  };
};
/**
 * Closes the floating element when a dismissal is requested — by default, when
 * the user presses the `escape` key or outside of the floating element.
 * @see https://floating-ui.com/docs/useDismiss
 */
function useDismiss(context, props) {
  if (props === void 0) {
    props = {};
  }
  const {
    open,
    onOpenChange,
    elements,
    dataRef
  } = context;
  const {
    enabled = true,
    escapeKey = true,
    outsidePress: unstable_outsidePress = true,
    outsidePressEvent = 'pointerdown',
    referencePress = false,
    referencePressEvent = 'pointerdown',
    ancestorScroll = false,
    bubbles,
    capture
  } = props;
  const tree = useFloatingTree();
  const outsidePressFn = useEffectEvent(typeof unstable_outsidePress === 'function' ? unstable_outsidePress : () => false);
  const outsidePress = typeof unstable_outsidePress === 'function' ? outsidePressFn : unstable_outsidePress;
  const insideReactTreeRef = react.useRef(false);
  const endedOrStartedInsideRef = react.useRef(false);
  const {
    escapeKey: escapeKeyBubbles,
    outsidePress: outsidePressBubbles
  } = normalizeProp(bubbles);
  const {
    escapeKey: escapeKeyCapture,
    outsidePress: outsidePressCapture
  } = normalizeProp(capture);
  const isComposingRef = react.useRef(false);
  const closeOnEscapeKeyDown = useEffectEvent(event => {
    var _dataRef$current$floa;
    if (!open || !enabled || !escapeKey || event.key !== 'Escape') {
      return;
    }

    // Wait until IME is settled. Pressing `Escape` while composing should
    // close the compose menu, but not the floating element.
    if (isComposingRef.current) {
      return;
    }
    const nodeId = (_dataRef$current$floa = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa.nodeId;
    const children = tree ? getChildren(tree.nodesRef.current, nodeId) : [];
    if (!escapeKeyBubbles) {
      event.stopPropagation();
      if (children.length > 0) {
        let shouldDismiss = true;
        children.forEach(child => {
          var _child$context;
          if ((_child$context = child.context) != null && _child$context.open && !child.context.dataRef.current.__escapeKeyBubbles) {
            shouldDismiss = false;
            return;
          }
        });
        if (!shouldDismiss) {
          return;
        }
      }
    }
    onOpenChange(false, isReactEvent(event) ? event.nativeEvent : event, 'escape-key');
  });
  const closeOnEscapeKeyDownCapture = useEffectEvent(event => {
    var _getTarget2;
    const callback = () => {
      var _getTarget;
      closeOnEscapeKeyDown(event);
      (_getTarget = floating_ui_react_utils_getTarget(event)) == null || _getTarget.removeEventListener('keydown', callback);
    };
    (_getTarget2 = floating_ui_react_utils_getTarget(event)) == null || _getTarget2.addEventListener('keydown', callback);
  });
  const closeOnPressOutside = useEffectEvent(event => {
    var _dataRef$current$floa2;
    // Given developers can stop the propagation of the synthetic event,
    // we can only be confident with a positive value.
    const insideReactTree = insideReactTreeRef.current;
    insideReactTreeRef.current = false;

    // When click outside is lazy (`click` event), handle dragging.
    // Don't close if:
    // - The click started inside the floating element.
    // - The click ended inside the floating element.
    const endedOrStartedInside = endedOrStartedInsideRef.current;
    endedOrStartedInsideRef.current = false;
    if (outsidePressEvent === 'click' && endedOrStartedInside) {
      return;
    }
    if (insideReactTree) {
      return;
    }
    if (typeof outsidePress === 'function' && !outsidePress(event)) {
      return;
    }
    const target = floating_ui_react_utils_getTarget(event);
    const inertSelector = "[" + createAttribute('inert') + "]";
    const markers = floating_ui_react_utils_getDocument(elements.floating).querySelectorAll(inertSelector);
    let targetRootAncestor = (0,floating_ui_utils_dom/* isElement */.kK)(target) ? target : null;
    while (targetRootAncestor && !(0,floating_ui_utils_dom/* isLastTraversableNode */.Py)(targetRootAncestor)) {
      const nextParent = (0,floating_ui_utils_dom/* getParentNode */.Ow)(targetRootAncestor);
      if ((0,floating_ui_utils_dom/* isLastTraversableNode */.Py)(nextParent) || !(0,floating_ui_utils_dom/* isElement */.kK)(nextParent)) {
        break;
      }
      targetRootAncestor = nextParent;
    }

    // Check if the click occurred on a third-party element injected after the
    // floating element rendered.
    if (markers.length && (0,floating_ui_utils_dom/* isElement */.kK)(target) && !isRootElement(target) &&
    // Clicked on a direct ancestor (e.g. FloatingOverlay).
    !floating_ui_react_utils_contains(target, elements.floating) &&
    // If the target root element contains none of the markers, then the
    // element was injected after the floating element rendered.
    Array.from(markers).every(marker => !floating_ui_react_utils_contains(targetRootAncestor, marker))) {
      return;
    }

    // Check if the click occurred on the scrollbar
    if ((0,floating_ui_utils_dom/* isHTMLElement */.Re)(target) && floating) {
      // In Firefox, `target.scrollWidth > target.clientWidth` for inline
      // elements.
      const canScrollX = target.clientWidth > 0 && target.scrollWidth > target.clientWidth;
      const canScrollY = target.clientHeight > 0 && target.scrollHeight > target.clientHeight;
      let xCond = canScrollY && event.offsetX > target.clientWidth;

      // In some browsers it is possible to change the <body> (or window)
      // scrollbar to the left side, but is very rare and is difficult to
      // check for. Plus, for modal dialogs with backdrops, it is more
      // important that the backdrop is checked but not so much the window.
      if (canScrollY) {
        const isRTL = (0,floating_ui_utils_dom/* getComputedStyle */.Dx)(target).direction === 'rtl';
        if (isRTL) {
          xCond = event.offsetX <= target.offsetWidth - target.clientWidth;
        }
      }
      if (xCond || canScrollX && event.offsetY > target.clientHeight) {
        return;
      }
    }
    const nodeId = (_dataRef$current$floa2 = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa2.nodeId;
    const targetIsInsideChildren = tree && getChildren(tree.nodesRef.current, nodeId).some(node => {
      var _node$context;
      return isEventTargetWithin(event, (_node$context = node.context) == null ? void 0 : _node$context.elements.floating);
    });
    if (isEventTargetWithin(event, elements.floating) || isEventTargetWithin(event, elements.domReference) || targetIsInsideChildren) {
      return;
    }
    const children = tree ? getChildren(tree.nodesRef.current, nodeId) : [];
    if (children.length > 0) {
      let shouldDismiss = true;
      children.forEach(child => {
        var _child$context2;
        if ((_child$context2 = child.context) != null && _child$context2.open && !child.context.dataRef.current.__outsidePressBubbles) {
          shouldDismiss = false;
          return;
        }
      });
      if (!shouldDismiss) {
        return;
      }
    }
    onOpenChange(false, event, 'outside-press');
  });
  const closeOnPressOutsideCapture = useEffectEvent(event => {
    var _getTarget4;
    const callback = () => {
      var _getTarget3;
      closeOnPressOutside(event);
      (_getTarget3 = floating_ui_react_utils_getTarget(event)) == null || _getTarget3.removeEventListener(outsidePressEvent, callback);
    };
    (_getTarget4 = floating_ui_react_utils_getTarget(event)) == null || _getTarget4.addEventListener(outsidePressEvent, callback);
  });
  react.useEffect(() => {
    if (!open || !enabled) {
      return;
    }
    dataRef.current.__escapeKeyBubbles = escapeKeyBubbles;
    dataRef.current.__outsidePressBubbles = outsidePressBubbles;
    let compositionTimeout = -1;
    function onScroll(event) {
      onOpenChange(false, event, 'ancestor-scroll');
    }
    function handleCompositionStart() {
      window.clearTimeout(compositionTimeout);
      isComposingRef.current = true;
    }
    function handleCompositionEnd() {
      // Safari fires `compositionend` before `keydown`, so we need to wait
      // until the next tick to set `isComposing` to `false`.
      // https://bugs.webkit.org/show_bug.cgi?id=165004
      compositionTimeout = window.setTimeout(() => {
        isComposingRef.current = false;
      },
      // 0ms or 1ms don't work in Safari. 5ms appears to consistently work.
      // Only apply to WebKit for the test to remain 0ms.
      (0,floating_ui_utils_dom/* isWebKit */.Pf)() ? 5 : 0);
    }
    const doc = floating_ui_react_utils_getDocument(elements.floating);
    if (escapeKey) {
      doc.addEventListener('keydown', escapeKeyCapture ? closeOnEscapeKeyDownCapture : closeOnEscapeKeyDown, escapeKeyCapture);
      doc.addEventListener('compositionstart', handleCompositionStart);
      doc.addEventListener('compositionend', handleCompositionEnd);
    }
    outsidePress && doc.addEventListener(outsidePressEvent, outsidePressCapture ? closeOnPressOutsideCapture : closeOnPressOutside, outsidePressCapture);
    let ancestors = [];
    if (ancestorScroll) {
      if ((0,floating_ui_utils_dom/* isElement */.kK)(elements.domReference)) {
        ancestors = (0,floating_ui_utils_dom/* getOverflowAncestors */.Kx)(elements.domReference);
      }
      if ((0,floating_ui_utils_dom/* isElement */.kK)(elements.floating)) {
        ancestors = ancestors.concat((0,floating_ui_utils_dom/* getOverflowAncestors */.Kx)(elements.floating));
      }
      if (!(0,floating_ui_utils_dom/* isElement */.kK)(elements.reference) && elements.reference && elements.reference.contextElement) {
        ancestors = ancestors.concat((0,floating_ui_utils_dom/* getOverflowAncestors */.Kx)(elements.reference.contextElement));
      }
    }

    // Ignore the visual viewport for scrolling dismissal (allow pinch-zoom)
    ancestors = ancestors.filter(ancestor => {
      var _doc$defaultView;
      return ancestor !== ((_doc$defaultView = doc.defaultView) == null ? void 0 : _doc$defaultView.visualViewport);
    });
    ancestors.forEach(ancestor => {
      ancestor.addEventListener('scroll', onScroll, {
        passive: true
      });
    });
    return () => {
      if (escapeKey) {
        doc.removeEventListener('keydown', escapeKeyCapture ? closeOnEscapeKeyDownCapture : closeOnEscapeKeyDown, escapeKeyCapture);
        doc.removeEventListener('compositionstart', handleCompositionStart);
        doc.removeEventListener('compositionend', handleCompositionEnd);
      }
      outsidePress && doc.removeEventListener(outsidePressEvent, outsidePressCapture ? closeOnPressOutsideCapture : closeOnPressOutside, outsidePressCapture);
      ancestors.forEach(ancestor => {
        ancestor.removeEventListener('scroll', onScroll);
      });
      window.clearTimeout(compositionTimeout);
    };
  }, [dataRef, elements, escapeKey, outsidePress, outsidePressEvent, open, onOpenChange, ancestorScroll, enabled, escapeKeyBubbles, outsidePressBubbles, closeOnEscapeKeyDown, escapeKeyCapture, closeOnEscapeKeyDownCapture, closeOnPressOutside, outsidePressCapture, closeOnPressOutsideCapture]);
  react.useEffect(() => {
    insideReactTreeRef.current = false;
  }, [outsidePress, outsidePressEvent]);
  const reference = react.useMemo(() => ({
    onKeyDown: closeOnEscapeKeyDown,
    [bubbleHandlerKeys[referencePressEvent]]: event => {
      if (referencePress) {
        onOpenChange(false, event.nativeEvent, 'reference-press');
      }
    }
  }), [closeOnEscapeKeyDown, onOpenChange, referencePress, referencePressEvent]);
  const floating = react.useMemo(() => ({
    onKeyDown: closeOnEscapeKeyDown,
    onMouseDown() {
      endedOrStartedInsideRef.current = true;
    },
    onMouseUp() {
      endedOrStartedInsideRef.current = true;
    },
    [captureHandlerKeys[outsidePressEvent]]: () => {
      insideReactTreeRef.current = true;
    }
  }), [closeOnEscapeKeyDown, outsidePressEvent]);
  return react.useMemo(() => enabled ? {
    reference,
    floating
  } : {}, [enabled, reference, floating]);
}

function useFloatingRootContext(options) {
  const {
    open = false,
    onOpenChange: onOpenChangeProp,
    elements: elementsProp
  } = options;
  const floatingId = useId();
  const dataRef = react.useRef({});
  const [events] = react.useState(() => createPubSub());
  const nested = useFloatingParentNodeId() != null;
  if (false) {}
  const [positionReference, setPositionReference] = react.useState(elementsProp.reference);
  const onOpenChange = useEffectEvent((open, event, reason) => {
    dataRef.current.openEvent = open ? event : undefined;
    events.emit('openchange', {
      open,
      event,
      reason,
      nested
    });
    onOpenChangeProp == null || onOpenChangeProp(open, event, reason);
  });
  const refs = react.useMemo(() => ({
    setPositionReference
  }), []);
  const elements = react.useMemo(() => ({
    reference: positionReference || elementsProp.reference || null,
    floating: elementsProp.floating || null,
    domReference: elementsProp.reference
  }), [positionReference, elementsProp.reference, elementsProp.floating]);
  return react.useMemo(() => ({
    dataRef,
    open,
    onOpenChange,
    elements,
    events,
    floatingId,
    refs
  }), [open, onOpenChange, elements, events, floatingId, refs]);
}

/**
 * Provides data to position a floating element and context to add interactions.
 * @see https://floating-ui.com/docs/useFloating
 */
function useFloating(options) {
  if (options === void 0) {
    options = {};
  }
  const {
    nodeId
  } = options;
  const internalRootContext = useFloatingRootContext({
    ...options,
    elements: {
      reference: null,
      floating: null,
      ...options.elements
    }
  });
  const rootContext = options.rootContext || internalRootContext;
  const computedElements = rootContext.elements;
  const [_domReference, setDomReference] = react.useState(null);
  const [positionReference, _setPositionReference] = react.useState(null);
  const optionDomReference = computedElements == null ? void 0 : computedElements.domReference;
  const domReference = optionDomReference || _domReference;
  const domReferenceRef = react.useRef(null);
  const tree = useFloatingTree();
  index(() => {
    if (domReference) {
      domReferenceRef.current = domReference;
    }
  }, [domReference]);
  const position = (0,floating_ui_react_dom/* useFloating */.YF)({
    ...options,
    elements: {
      ...computedElements,
      ...(positionReference && {
        reference: positionReference
      })
    }
  });
  const setPositionReference = react.useCallback(node => {
    const computedPositionReference = (0,floating_ui_utils_dom/* isElement */.kK)(node) ? {
      getBoundingClientRect: () => node.getBoundingClientRect(),
      contextElement: node
    } : node;
    // Store the positionReference in state if the DOM reference is specified externally via the
    // `elements.reference` option. This ensures that it won't be overridden on future renders.
    _setPositionReference(computedPositionReference);
    position.refs.setReference(computedPositionReference);
  }, [position.refs]);
  const setReference = react.useCallback(node => {
    if ((0,floating_ui_utils_dom/* isElement */.kK)(node) || node === null) {
      domReferenceRef.current = node;
      setDomReference(node);
    }

    // Backwards-compatibility for passing a virtual element to `reference`
    // after it has set the DOM reference.
    if ((0,floating_ui_utils_dom/* isElement */.kK)(position.refs.reference.current) || position.refs.reference.current === null ||
    // Don't allow setting virtual elements using the old technique back to
    // `null` to support `positionReference` + an unstable `reference`
    // callback ref.
    node !== null && !(0,floating_ui_utils_dom/* isElement */.kK)(node)) {
      position.refs.setReference(node);
    }
  }, [position.refs]);
  const refs = react.useMemo(() => ({
    ...position.refs,
    setReference,
    setPositionReference,
    domReference: domReferenceRef
  }), [position.refs, setReference, setPositionReference]);
  const elements = react.useMemo(() => ({
    ...position.elements,
    domReference: domReference
  }), [position.elements, domReference]);
  const context = react.useMemo(() => ({
    ...position,
    ...rootContext,
    refs,
    elements,
    nodeId
  }), [position, refs, elements, nodeId, rootContext]);
  index(() => {
    rootContext.dataRef.current.floatingContext = context;
    const node = tree == null ? void 0 : tree.nodesRef.current.find(node => node.id === nodeId);
    if (node) {
      node.context = context;
    }
  });
  return react.useMemo(() => ({
    ...position,
    context,
    refs,
    elements
  }), [position, refs, elements, context]);
}

/**
 * Opens the floating element while the reference element has focus, like CSS
 * `:focus`.
 * @see https://floating-ui.com/docs/useFocus
 */
function useFocus(context, props) {
  if (props === void 0) {
    props = {};
  }
  const {
    open,
    onOpenChange,
    events,
    dataRef,
    elements
  } = context;
  const {
    enabled = true,
    visibleOnly = true
  } = props;
  const blockFocusRef = react.useRef(false);
  const timeoutRef = react.useRef();
  const keyboardModalityRef = react.useRef(true);
  react.useEffect(() => {
    if (!enabled) return;
    const win = (0,floating_ui_utils_dom/* getWindow */.Jj)(elements.domReference);

    // If the reference was focused and the user left the tab/window, and the
    // floating element was not open, the focus should be blocked when they
    // return to the tab/window.
    function onBlur() {
      if (!open && (0,floating_ui_utils_dom/* isHTMLElement */.Re)(elements.domReference) && elements.domReference === floating_ui_react_utils_activeElement(floating_ui_react_utils_getDocument(elements.domReference))) {
        blockFocusRef.current = true;
      }
    }
    function onKeyDown() {
      keyboardModalityRef.current = true;
    }
    win.addEventListener('blur', onBlur);
    win.addEventListener('keydown', onKeyDown, true);
    return () => {
      win.removeEventListener('blur', onBlur);
      win.removeEventListener('keydown', onKeyDown, true);
    };
  }, [elements.domReference, open, enabled]);
  react.useEffect(() => {
    if (!enabled) return;
    function onOpenChange(_ref) {
      let {
        reason
      } = _ref;
      if (reason === 'reference-press' || reason === 'escape-key') {
        blockFocusRef.current = true;
      }
    }
    events.on('openchange', onOpenChange);
    return () => {
      events.off('openchange', onOpenChange);
    };
  }, [events, enabled]);
  react.useEffect(() => {
    return () => {
      clearTimeout(timeoutRef.current);
    };
  }, []);
  const reference = react.useMemo(() => ({
    onPointerDown(event) {
      if (floating_ui_react_utils_isVirtualPointerEvent(event.nativeEvent)) return;
      keyboardModalityRef.current = false;
    },
    onMouseLeave() {
      blockFocusRef.current = false;
    },
    onFocus(event) {
      if (blockFocusRef.current) return;
      const target = floating_ui_react_utils_getTarget(event.nativeEvent);
      if (visibleOnly && (0,floating_ui_utils_dom/* isElement */.kK)(target)) {
        try {
          // Mac Safari unreliably matches `:focus-visible` on the reference
          // if focus was outside the page initially - use the fallback
          // instead.
          if (floating_ui_react_utils_isSafari() && floating_ui_react_utils_isMac()) throw Error();
          if (!target.matches(':focus-visible')) return;
        } catch (e) {
          // Old browsers will throw an error when using `:focus-visible`.
          if (!keyboardModalityRef.current && !floating_ui_react_utils_isTypeableElement(target)) {
            return;
          }
        }
      }
      onOpenChange(true, event.nativeEvent, 'focus');
    },
    onBlur(event) {
      blockFocusRef.current = false;
      const relatedTarget = event.relatedTarget;
      const nativeEvent = event.nativeEvent;

      // Hit the non-modal focus management portal guard. Focus will be
      // moved into the floating element immediately after.
      const movedToFocusGuard = (0,floating_ui_utils_dom/* isElement */.kK)(relatedTarget) && relatedTarget.hasAttribute(createAttribute('focus-guard')) && relatedTarget.getAttribute('data-type') === 'outside';

      // Wait for the window blur listener to fire.
      timeoutRef.current = window.setTimeout(() => {
        var _dataRef$current$floa;
        const activeEl = floating_ui_react_utils_activeElement(elements.domReference ? elements.domReference.ownerDocument : document);

        // Focus left the page, keep it open.
        if (!relatedTarget && activeEl === elements.domReference) return;

        // When focusing the reference element (e.g. regular click), then
        // clicking into the floating element, prevent it from hiding.
        // Note: it must be focusable, e.g. `tabindex="-1"`.
        // We can not rely on relatedTarget to point to the correct element
        // as it will only point to the shadow host of the newly focused element
        // and not the element that actually has received focus if it is located
        // inside a shadow root.
        if (floating_ui_react_utils_contains((_dataRef$current$floa = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa.refs.floating.current, activeEl) || floating_ui_react_utils_contains(elements.domReference, activeEl) || movedToFocusGuard) {
          return;
        }
        onOpenChange(false, nativeEvent, 'focus');
      });
    }
  }), [dataRef, elements.domReference, onOpenChange, visibleOnly]);
  return react.useMemo(() => enabled ? {
    reference
  } : {}, [enabled, reference]);
}

const ACTIVE_KEY = 'active';
const SELECTED_KEY = 'selected';
function mergeProps(userProps, propsList, elementKey) {
  const map = new Map();
  const isItem = elementKey === 'item';
  let domUserProps = userProps;
  if (isItem && userProps) {
    const {
      [ACTIVE_KEY]: _,
      [SELECTED_KEY]: __,
      ...validProps
    } = userProps;
    domUserProps = validProps;
  }
  return {
    ...(elementKey === 'floating' && {
      tabIndex: -1,
      [FOCUSABLE_ATTRIBUTE]: ''
    }),
    ...domUserProps,
    ...propsList.map(value => {
      const propsOrGetProps = value ? value[elementKey] : null;
      if (typeof propsOrGetProps === 'function') {
        return userProps ? propsOrGetProps(userProps) : null;
      }
      return propsOrGetProps;
    }).concat(userProps).reduce((acc, props) => {
      if (!props) {
        return acc;
      }
      Object.entries(props).forEach(_ref => {
        let [key, value] = _ref;
        if (isItem && [ACTIVE_KEY, SELECTED_KEY].includes(key)) {
          return;
        }
        if (key.indexOf('on') === 0) {
          if (!map.has(key)) {
            map.set(key, []);
          }
          if (typeof value === 'function') {
            var _map$get;
            (_map$get = map.get(key)) == null || _map$get.push(value);
            acc[key] = function () {
              var _map$get2;
              for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
              }
              return (_map$get2 = map.get(key)) == null ? void 0 : _map$get2.map(fn => fn(...args)).find(val => val !== undefined);
            };
          }
        } else {
          acc[key] = value;
        }
      });
      return acc;
    }, {})
  };
}
/**
 * Merges an array of interaction hooks' props into prop getters, allowing
 * event handler functions to be composed together without overwriting one
 * another.
 * @see https://floating-ui.com/docs/useInteractions
 */
function useInteractions(propsList) {
  if (propsList === void 0) {
    propsList = [];
  }
  const referenceDeps = propsList.map(key => key == null ? void 0 : key.reference);
  const floatingDeps = propsList.map(key => key == null ? void 0 : key.floating);
  const itemDeps = propsList.map(key => key == null ? void 0 : key.item);
  const getReferenceProps = react.useCallback(userProps => mergeProps(userProps, propsList, 'reference'),
  // eslint-disable-next-line react-hooks/exhaustive-deps
  referenceDeps);
  const getFloatingProps = react.useCallback(userProps => mergeProps(userProps, propsList, 'floating'),
  // eslint-disable-next-line react-hooks/exhaustive-deps
  floatingDeps);
  const getItemProps = react.useCallback(userProps => mergeProps(userProps, propsList, 'item'),
  // eslint-disable-next-line react-hooks/exhaustive-deps
  itemDeps);
  return react.useMemo(() => ({
    getReferenceProps,
    getFloatingProps,
    getItemProps
  }), [getReferenceProps, getFloatingProps, getItemProps]);
}

let isPreventScrollSupported = false;
function doSwitch(orientation, vertical, horizontal) {
  switch (orientation) {
    case 'vertical':
      return vertical;
    case 'horizontal':
      return horizontal;
    default:
      return vertical || horizontal;
  }
}
function isMainOrientationKey(key, orientation) {
  const vertical = key === ARROW_UP || key === ARROW_DOWN;
  const horizontal = key === ARROW_LEFT || key === ARROW_RIGHT;
  return doSwitch(orientation, vertical, horizontal);
}
function isMainOrientationToEndKey(key, orientation, rtl) {
  const vertical = key === ARROW_DOWN;
  const horizontal = rtl ? key === ARROW_LEFT : key === ARROW_RIGHT;
  return doSwitch(orientation, vertical, horizontal) || key === 'Enter' || key === ' ' || key === '';
}
function isCrossOrientationOpenKey(key, orientation, rtl) {
  const vertical = rtl ? key === ARROW_LEFT : key === ARROW_RIGHT;
  const horizontal = key === ARROW_DOWN;
  return doSwitch(orientation, vertical, horizontal);
}
function isCrossOrientationCloseKey(key, orientation, rtl) {
  const vertical = rtl ? key === ARROW_RIGHT : key === ARROW_LEFT;
  const horizontal = key === ARROW_UP;
  return doSwitch(orientation, vertical, horizontal);
}
/**
 * Adds arrow key-based navigation of a list of items, either using real DOM
 * focus or virtual focus.
 * @see https://floating-ui.com/docs/useListNavigation
 */
function useListNavigation(context, props) {
  const {
    open,
    onOpenChange,
    elements
  } = context;
  const {
    listRef,
    activeIndex,
    onNavigate: unstable_onNavigate = () => {},
    enabled = true,
    selectedIndex = null,
    allowEscape = false,
    loop = false,
    nested = false,
    rtl = false,
    virtual = false,
    focusItemOnOpen = 'auto',
    focusItemOnHover = true,
    openOnArrowKeyDown = true,
    disabledIndices = undefined,
    orientation = 'vertical',
    cols = 1,
    scrollItemIntoView = true,
    virtualItemRef,
    itemSizes,
    dense = false
  } = props;
  if (false) {}
  const floatingFocusElement = getFloatingFocusElement(elements.floating);
  const floatingFocusElementRef = useLatestRef(floatingFocusElement);
  const parentId = useFloatingParentNodeId();
  const tree = useFloatingTree();
  const onNavigate = useEffectEvent(unstable_onNavigate);
  const typeableComboboxReference = isTypeableCombobox(elements.domReference);
  const focusItemOnOpenRef = React.useRef(focusItemOnOpen);
  const indexRef = React.useRef(selectedIndex != null ? selectedIndex : -1);
  const keyRef = React.useRef(null);
  const isPointerModalityRef = React.useRef(true);
  const previousOnNavigateRef = React.useRef(onNavigate);
  const previousMountedRef = React.useRef(!!elements.floating);
  const previousOpenRef = React.useRef(open);
  const forceSyncFocus = React.useRef(false);
  const forceScrollIntoViewRef = React.useRef(false);
  const disabledIndicesRef = useLatestRef(disabledIndices);
  const latestOpenRef = useLatestRef(open);
  const scrollItemIntoViewRef = useLatestRef(scrollItemIntoView);
  const selectedIndexRef = useLatestRef(selectedIndex);
  const [activeId, setActiveId] = React.useState();
  const [virtualId, setVirtualId] = React.useState();
  const focusItem = useEffectEvent(function (listRef, indexRef, forceScrollIntoView) {
    if (forceScrollIntoView === void 0) {
      forceScrollIntoView = false;
    }
    function runFocus(item) {
      if (virtual) {
        setActiveId(item.id);
        tree == null || tree.events.emit('virtualfocus', item);
        if (virtualItemRef) {
          virtualItemRef.current = item;
        }
      } else {
        enqueueFocus(item, {
          preventScroll: true,
          // Mac Safari does not move the virtual cursor unless the focus call
          // is sync. However, for the very first focus call, we need to wait
          // for the position to be ready in order to prevent unwanted
          // scrolling. This means the virtual cursor will not move to the first
          // item when first opening the floating element, but will on
          // subsequent calls. `preventScroll` is supported in modern Safari,
          // so we can use that instead.
          // iOS Safari must be async or the first item will not be focused.
          sync: isMac() && isSafari() ? isPreventScrollSupported || forceSyncFocus.current : false
        });
      }
    }
    const initialItem = listRef.current[indexRef.current];
    if (initialItem) {
      runFocus(initialItem);
    }
    requestAnimationFrame(() => {
      const waitedItem = listRef.current[indexRef.current] || initialItem;
      if (!waitedItem) return;
      if (!initialItem) {
        runFocus(waitedItem);
      }
      const scrollIntoViewOptions = scrollItemIntoViewRef.current;
      const shouldScrollIntoView = scrollIntoViewOptions && item && (forceScrollIntoView || !isPointerModalityRef.current);
      if (shouldScrollIntoView) {
        // JSDOM doesn't support `.scrollIntoView()` but it's widely supported
        // by all browsers.
        waitedItem.scrollIntoView == null || waitedItem.scrollIntoView(typeof scrollIntoViewOptions === 'boolean' ? {
          block: 'nearest',
          inline: 'nearest'
        } : scrollIntoViewOptions);
      }
    });
  });
  index(() => {
    document.createElement('div').focus({
      get preventScroll() {
        isPreventScrollSupported = true;
        return false;
      }
    });
  }, []);

  // Sync `selectedIndex` to be the `activeIndex` upon opening the floating
  // element. Also, reset `activeIndex` upon closing the floating element.
  index(() => {
    if (!enabled) return;
    if (open && elements.floating) {
      if (focusItemOnOpenRef.current && selectedIndex != null) {
        // Regardless of the pointer modality, we want to ensure the selected
        // item comes into view when the floating element is opened.
        forceScrollIntoViewRef.current = true;
        indexRef.current = selectedIndex;
        onNavigate(selectedIndex);
      }
    } else if (previousMountedRef.current) {
      // Since the user can specify `onNavigate` conditionally
      // (onNavigate: open ? setActiveIndex : setSelectedIndex),
      // we store and call the previous function.
      indexRef.current = -1;
      previousOnNavigateRef.current(null);
    }
  }, [enabled, open, elements.floating, selectedIndex, onNavigate]);

  // Sync `activeIndex` to be the focused item while the floating element is
  // open.
  index(() => {
    if (!enabled) return;
    if (open && elements.floating) {
      if (activeIndex == null) {
        forceSyncFocus.current = false;
        if (selectedIndexRef.current != null) {
          return;
        }

        // Reset while the floating element was open (e.g. the list changed).
        if (previousMountedRef.current) {
          indexRef.current = -1;
          focusItem(listRef, indexRef);
        }

        // Initial sync.
        if ((!previousOpenRef.current || !previousMountedRef.current) && focusItemOnOpenRef.current && (keyRef.current != null || focusItemOnOpenRef.current === true && keyRef.current == null)) {
          let runs = 0;
          const waitForListPopulated = () => {
            if (listRef.current[0] == null) {
              // Avoid letting the browser paint if possible on the first try,
              // otherwise use rAF. Don't try more than twice, since something
              // is wrong otherwise.
              if (runs < 2) {
                const scheduler = runs ? requestAnimationFrame : queueMicrotask;
                scheduler(waitForListPopulated);
              }
              runs++;
            } else {
              indexRef.current = keyRef.current == null || isMainOrientationToEndKey(keyRef.current, orientation, rtl) || nested ? getMinIndex(listRef, disabledIndicesRef.current) : getMaxIndex(listRef, disabledIndicesRef.current);
              keyRef.current = null;
              onNavigate(indexRef.current);
            }
          };
          waitForListPopulated();
        }
      } else if (!isIndexOutOfBounds(listRef, activeIndex)) {
        indexRef.current = activeIndex;
        focusItem(listRef, indexRef, forceScrollIntoViewRef.current);
        forceScrollIntoViewRef.current = false;
      }
    }
  }, [enabled, open, elements.floating, activeIndex, selectedIndexRef, nested, listRef, orientation, rtl, onNavigate, focusItem, disabledIndicesRef]);

  // Ensure the parent floating element has focus when a nested child closes
  // to allow arrow key navigation to work after the pointer leaves the child.
  index(() => {
    var _nodes$find;
    if (!enabled || elements.floating || !tree || virtual || !previousMountedRef.current) {
      return;
    }
    const nodes = tree.nodesRef.current;
    const parent = (_nodes$find = nodes.find(node => node.id === parentId)) == null || (_nodes$find = _nodes$find.context) == null ? void 0 : _nodes$find.elements.floating;
    const activeEl = activeElement(getDocument(elements.floating));
    const treeContainsActiveEl = nodes.some(node => node.context && contains(node.context.elements.floating, activeEl));
    if (parent && !treeContainsActiveEl && isPointerModalityRef.current) {
      parent.focus({
        preventScroll: true
      });
    }
  }, [enabled, elements.floating, tree, parentId, virtual]);
  index(() => {
    if (!enabled) return;
    if (!tree) return;
    if (!virtual) return;
    if (parentId) return;
    function handleVirtualFocus(item) {
      setVirtualId(item.id);
      if (virtualItemRef) {
        virtualItemRef.current = item;
      }
    }
    tree.events.on('virtualfocus', handleVirtualFocus);
    return () => {
      tree.events.off('virtualfocus', handleVirtualFocus);
    };
  }, [enabled, tree, virtual, parentId, virtualItemRef]);
  index(() => {
    previousOnNavigateRef.current = onNavigate;
    previousMountedRef.current = !!elements.floating;
  });
  index(() => {
    if (!open) {
      keyRef.current = null;
    }
  }, [open]);
  index(() => {
    previousOpenRef.current = open;
  }, [open]);
  const hasActiveIndex = activeIndex != null;
  const item = React.useMemo(() => {
    function syncCurrentTarget(currentTarget) {
      if (!open) return;
      const index = listRef.current.indexOf(currentTarget);
      if (index !== -1) {
        onNavigate(index);
      }
    }
    const props = {
      onFocus(_ref) {
        let {
          currentTarget
        } = _ref;
        syncCurrentTarget(currentTarget);
      },
      onClick: _ref2 => {
        let {
          currentTarget
        } = _ref2;
        return currentTarget.focus({
          preventScroll: true
        });
      },
      // Safari
      ...(focusItemOnHover && {
        onMouseMove(_ref3) {
          let {
            currentTarget
          } = _ref3;
          syncCurrentTarget(currentTarget);
        },
        onPointerLeave(_ref4) {
          let {
            pointerType
          } = _ref4;
          if (!isPointerModalityRef.current || pointerType === 'touch') {
            return;
          }
          indexRef.current = -1;
          focusItem(listRef, indexRef);
          onNavigate(null);
          if (!virtual) {
            enqueueFocus(floatingFocusElementRef.current, {
              preventScroll: true
            });
          }
        }
      })
    };
    return props;
  }, [open, floatingFocusElementRef, focusItem, focusItemOnHover, listRef, onNavigate, virtual]);
  const commonOnKeyDown = useEffectEvent(event => {
    isPointerModalityRef.current = false;
    forceSyncFocus.current = true;

    // When composing a character, Chrome fires ArrowDown twice. Firefox/Safari
    // don't appear to suffer from this. `event.isComposing` is avoided due to
    // Safari not supporting it properly (although it's not needed in the first
    // place for Safari, just avoiding any possible issues).
    if (event.which === 229) {
      return;
    }

    // If the floating element is animating out, ignore navigation. Otherwise,
    // the `activeIndex` gets set to 0 despite not being open so the next time
    // the user ArrowDowns, the first item won't be focused.
    if (!latestOpenRef.current && event.currentTarget === floatingFocusElementRef.current) {
      return;
    }
    if (nested && isCrossOrientationCloseKey(event.key, orientation, rtl)) {
      stopEvent(event);
      onOpenChange(false, event.nativeEvent, 'list-navigation');
      if (isHTMLElement(elements.domReference)) {
        if (virtual) {
          tree == null || tree.events.emit('virtualfocus', elements.domReference);
        } else {
          elements.domReference.focus();
        }
      }
      return;
    }
    const currentIndex = indexRef.current;
    const minIndex = getMinIndex(listRef, disabledIndices);
    const maxIndex = getMaxIndex(listRef, disabledIndices);
    if (!typeableComboboxReference) {
      if (event.key === 'Home') {
        stopEvent(event);
        indexRef.current = minIndex;
        onNavigate(indexRef.current);
      }
      if (event.key === 'End') {
        stopEvent(event);
        indexRef.current = maxIndex;
        onNavigate(indexRef.current);
      }
    }

    // Grid navigation.
    if (cols > 1) {
      const sizes = itemSizes || Array.from({
        length: listRef.current.length
      }, () => ({
        width: 1,
        height: 1
      }));
      // To calculate movements on the grid, we use hypothetical cell indices
      // as if every item was 1x1, then convert back to real indices.
      const cellMap = buildCellMap(sizes, cols, dense);
      const minGridIndex = cellMap.findIndex(index => index != null && !isDisabled(listRef.current, index, disabledIndices));
      // last enabled index
      const maxGridIndex = cellMap.reduce((foundIndex, index, cellIndex) => index != null && !isDisabled(listRef.current, index, disabledIndices) ? cellIndex : foundIndex, -1);
      const index = cellMap[getGridNavigatedIndex({
        current: cellMap.map(itemIndex => itemIndex != null ? listRef.current[itemIndex] : null)
      }, {
        event,
        orientation,
        loop,
        rtl,
        cols,
        // treat undefined (empty grid spaces) as disabled indices so we
        // don't end up in them
        disabledIndices: getCellIndices([...(disabledIndices || listRef.current.map((_, index) => isDisabled(listRef.current, index) ? index : undefined)), undefined], cellMap),
        minIndex: minGridIndex,
        maxIndex: maxGridIndex,
        prevIndex: getCellIndexOfCorner(indexRef.current > maxIndex ? minIndex : indexRef.current, sizes, cellMap, cols,
        // use a corner matching the edge closest to the direction
        // we're moving in so we don't end up in the same item. Prefer
        // top/left over bottom/right.
        event.key === ARROW_DOWN ? 'bl' : event.key === (rtl ? ARROW_LEFT : ARROW_RIGHT) ? 'tr' : 'tl'),
        stopEvent: true
      })];
      if (index != null) {
        indexRef.current = index;
        onNavigate(indexRef.current);
      }
      if (orientation === 'both') {
        return;
      }
    }
    if (isMainOrientationKey(event.key, orientation)) {
      stopEvent(event);

      // Reset the index if no item is focused.
      if (open && !virtual && activeElement(event.currentTarget.ownerDocument) === event.currentTarget) {
        indexRef.current = isMainOrientationToEndKey(event.key, orientation, rtl) ? minIndex : maxIndex;
        onNavigate(indexRef.current);
        return;
      }
      if (isMainOrientationToEndKey(event.key, orientation, rtl)) {
        if (loop) {
          indexRef.current = currentIndex >= maxIndex ? allowEscape && currentIndex !== listRef.current.length ? -1 : minIndex : findNonDisabledIndex(listRef, {
            startingIndex: currentIndex,
            disabledIndices
          });
        } else {
          indexRef.current = Math.min(maxIndex, findNonDisabledIndex(listRef, {
            startingIndex: currentIndex,
            disabledIndices
          }));
        }
      } else {
        if (loop) {
          indexRef.current = currentIndex <= minIndex ? allowEscape && currentIndex !== -1 ? listRef.current.length : maxIndex : findNonDisabledIndex(listRef, {
            startingIndex: currentIndex,
            decrement: true,
            disabledIndices
          });
        } else {
          indexRef.current = Math.max(minIndex, findNonDisabledIndex(listRef, {
            startingIndex: currentIndex,
            decrement: true,
            disabledIndices
          }));
        }
      }
      if (isIndexOutOfBounds(listRef, indexRef.current)) {
        onNavigate(null);
      } else {
        onNavigate(indexRef.current);
      }
    }
  });
  const ariaActiveDescendantProp = React.useMemo(() => {
    return virtual && open && hasActiveIndex && {
      'aria-activedescendant': virtualId || activeId
    };
  }, [virtual, open, hasActiveIndex, virtualId, activeId]);
  const floating = React.useMemo(() => {
    return {
      'aria-orientation': orientation === 'both' ? undefined : orientation,
      ...(!isTypeableCombobox(elements.domReference) && ariaActiveDescendantProp),
      onKeyDown: commonOnKeyDown,
      onPointerMove() {
        isPointerModalityRef.current = true;
      }
    };
  }, [ariaActiveDescendantProp, commonOnKeyDown, elements.domReference, orientation]);
  const reference = React.useMemo(() => {
    function checkVirtualMouse(event) {
      if (focusItemOnOpen === 'auto' && isVirtualClick(event.nativeEvent)) {
        focusItemOnOpenRef.current = true;
      }
    }
    function checkVirtualPointer(event) {
      // `pointerdown` fires first, reset the state then perform the checks.
      focusItemOnOpenRef.current = focusItemOnOpen;
      if (focusItemOnOpen === 'auto' && isVirtualPointerEvent(event.nativeEvent)) {
        focusItemOnOpenRef.current = true;
      }
    }
    return {
      ...ariaActiveDescendantProp,
      onKeyDown(event) {
        isPointerModalityRef.current = false;
        const isArrowKey = event.key.startsWith('Arrow');
        const isHomeOrEndKey = ['Home', 'End'].includes(event.key);
        const isMoveKey = isArrowKey || isHomeOrEndKey;
        const isCrossOpenKey = isCrossOrientationOpenKey(event.key, orientation, rtl);
        const isCrossCloseKey = isCrossOrientationCloseKey(event.key, orientation, rtl);
        const isMainKey = isMainOrientationKey(event.key, orientation);
        const isNavigationKey = (nested ? isCrossOpenKey : isMainKey) || event.key === 'Enter' || event.key.trim() === '';
        if (virtual && open) {
          const rootNode = tree == null ? void 0 : tree.nodesRef.current.find(node => node.parentId == null);
          const deepestNode = tree && rootNode ? getDeepestNode(tree.nodesRef.current, rootNode.id) : null;
          if (isMoveKey && deepestNode && virtualItemRef) {
            const eventObject = new KeyboardEvent('keydown', {
              key: event.key,
              bubbles: true
            });
            if (isCrossOpenKey || isCrossCloseKey) {
              var _deepestNode$context, _deepestNode$context2;
              const isCurrentTarget = ((_deepestNode$context = deepestNode.context) == null ? void 0 : _deepestNode$context.elements.domReference) === event.currentTarget;
              const dispatchItem = isCrossCloseKey && !isCurrentTarget ? (_deepestNode$context2 = deepestNode.context) == null ? void 0 : _deepestNode$context2.elements.domReference : isCrossOpenKey ? listRef.current.find(item => (item == null ? void 0 : item.id) === activeId) : null;
              if (dispatchItem) {
                stopEvent(event);
                dispatchItem.dispatchEvent(eventObject);
                setVirtualId(undefined);
              }
            }
            if ((isMainKey || isHomeOrEndKey) && deepestNode.context) {
              if (deepestNode.context.open && deepestNode.parentId && event.currentTarget !== deepestNode.context.elements.domReference) {
                var _deepestNode$context$;
                stopEvent(event);
                (_deepestNode$context$ = deepestNode.context.elements.domReference) == null || _deepestNode$context$.dispatchEvent(eventObject);
                return;
              }
            }
          }
          return commonOnKeyDown(event);
        }

        // If a floating element should not open on arrow key down, avoid
        // setting `activeIndex` while it's closed.
        if (!open && !openOnArrowKeyDown && isArrowKey) {
          return;
        }
        if (isNavigationKey) {
          keyRef.current = nested && isMainKey ? null : event.key;
        }
        if (nested) {
          if (isCrossOpenKey) {
            stopEvent(event);
            if (open) {
              indexRef.current = getMinIndex(listRef, disabledIndicesRef.current);
              onNavigate(indexRef.current);
            } else {
              onOpenChange(true, event.nativeEvent, 'list-navigation');
            }
          }
          return;
        }
        if (isMainKey) {
          if (selectedIndex != null) {
            indexRef.current = selectedIndex;
          }
          stopEvent(event);
          if (!open && openOnArrowKeyDown) {
            onOpenChange(true, event.nativeEvent, 'list-navigation');
          } else {
            commonOnKeyDown(event);
          }
          if (open) {
            onNavigate(indexRef.current);
          }
        }
      },
      onFocus() {
        if (open && !virtual) {
          onNavigate(null);
        }
      },
      onPointerDown: checkVirtualPointer,
      onMouseDown: checkVirtualMouse,
      onClick: checkVirtualMouse
    };
  }, [activeId, ariaActiveDescendantProp, commonOnKeyDown, disabledIndicesRef, focusItemOnOpen, listRef, nested, onNavigate, onOpenChange, open, openOnArrowKeyDown, orientation, rtl, selectedIndex, tree, virtual, virtualItemRef]);
  return React.useMemo(() => enabled ? {
    reference,
    floating,
    item
  } : {}, [enabled, reference, floating, item]);
}

const componentRoleToAriaRoleMap = /*#__PURE__*/new Map([['select', 'listbox'], ['combobox', 'listbox'], ['label', false]]);

/**
 * Adds base screen reader props to the reference and floating elements for a
 * given floating element `role`.
 * @see https://floating-ui.com/docs/useRole
 */
function useRole(context, props) {
  var _componentRoleToAriaR;
  if (props === void 0) {
    props = {};
  }
  const {
    open,
    floatingId
  } = context;
  const {
    enabled = true,
    role = 'dialog'
  } = props;
  const ariaRole = (_componentRoleToAriaR = componentRoleToAriaRoleMap.get(role)) != null ? _componentRoleToAriaR : role;
  const referenceId = useId();
  const parentId = useFloatingParentNodeId();
  const isNested = parentId != null;
  const reference = react.useMemo(() => {
    if (ariaRole === 'tooltip' || role === 'label') {
      return {
        ["aria-" + (role === 'label' ? 'labelledby' : 'describedby')]: open ? floatingId : undefined
      };
    }
    return {
      'aria-expanded': open ? 'true' : 'false',
      'aria-haspopup': ariaRole === 'alertdialog' ? 'dialog' : ariaRole,
      'aria-controls': open ? floatingId : undefined,
      ...(ariaRole === 'listbox' && {
        role: 'combobox'
      }),
      ...(ariaRole === 'menu' && {
        id: referenceId
      }),
      ...(ariaRole === 'menu' && isNested && {
        role: 'menuitem'
      }),
      ...(role === 'select' && {
        'aria-autocomplete': 'none'
      }),
      ...(role === 'combobox' && {
        'aria-autocomplete': 'list'
      })
    };
  }, [ariaRole, floatingId, isNested, open, referenceId, role]);
  const floating = react.useMemo(() => {
    const floatingProps = {
      id: floatingId,
      ...(ariaRole && {
        role: ariaRole
      })
    };
    if (ariaRole === 'tooltip' || role === 'label') {
      return floatingProps;
    }
    return {
      ...floatingProps,
      ...(ariaRole === 'menu' && {
        'aria-labelledby': referenceId
      })
    };
  }, [ariaRole, floatingId, referenceId, role]);
  const item = react.useCallback(_ref => {
    let {
      active,
      selected
    } = _ref;
    const commonProps = {
      role: 'option',
      ...(active && {
        id: floatingId + "-option"
      })
    };

    // For `menu`, we are unable to tell if the item is a `menuitemradio`
    // or `menuitemcheckbox`. For backwards-compatibility reasons, also
    // avoid defaulting to `menuitem` as it may overwrite custom role props.
    switch (role) {
      case 'select':
        return {
          ...commonProps,
          'aria-selected': active && selected
        };
      case 'combobox':
        {
          return {
            ...commonProps,
            ...(active && {
              'aria-selected': true
            })
          };
        }
    }
    return {};
  }, [floatingId, role]);
  return react.useMemo(() => enabled ? {
    reference,
    floating,
    item
  } : {}, [enabled, reference, floating, item]);
}

// Converts a JS style key like `backgroundColor` to a CSS transition-property
// like `background-color`.
const camelCaseToKebabCase = str => str.replace(/[A-Z]+(?![a-z])|[A-Z]/g, ($, ofs) => (ofs ? '-' : '') + $.toLowerCase());
function execWithArgsOrReturn(valueOrFn, args) {
  return typeof valueOrFn === 'function' ? valueOrFn(args) : valueOrFn;
}
function useDelayUnmount(open, durationMs) {
  const [isMounted, setIsMounted] = React.useState(open);
  if (open && !isMounted) {
    setIsMounted(true);
  }
  React.useEffect(() => {
    if (!open && isMounted) {
      const timeout = setTimeout(() => setIsMounted(false), durationMs);
      return () => clearTimeout(timeout);
    }
  }, [open, isMounted, durationMs]);
  return isMounted;
}
/**
 * Provides a status string to apply CSS transitions to a floating element,
 * correctly handling placement-aware transitions.
 * @see https://floating-ui.com/docs/useTransition#usetransitionstatus
 */
function useTransitionStatus(context, props) {
  if (props === void 0) {
    props = {};
  }
  const {
    open,
    elements: {
      floating
    }
  } = context;
  const {
    duration = 250
  } = props;
  const isNumberDuration = typeof duration === 'number';
  const closeDuration = (isNumberDuration ? duration : duration.close) || 0;
  const [status, setStatus] = React.useState('unmounted');
  const isMounted = useDelayUnmount(open, closeDuration);
  if (!isMounted && status === 'close') {
    setStatus('unmounted');
  }
  index(() => {
    if (!floating) return;
    if (open) {
      setStatus('initial');
      const frame = requestAnimationFrame(() => {
        setStatus('open');
      });
      return () => {
        cancelAnimationFrame(frame);
      };
    }
    setStatus('close');
  }, [open, floating]);
  return {
    isMounted,
    status
  };
}
/**
 * Provides styles to apply CSS transitions to a floating element, correctly
 * handling placement-aware transitions. Wrapper around `useTransitionStatus`.
 * @see https://floating-ui.com/docs/useTransition#usetransitionstyles
 */
function useTransitionStyles(context, props) {
  if (props === void 0) {
    props = {};
  }
  const {
    initial: unstable_initial = {
      opacity: 0
    },
    open: unstable_open,
    close: unstable_close,
    common: unstable_common,
    duration = 250
  } = props;
  const placement = context.placement;
  const side = placement.split('-')[0];
  const fnArgs = React.useMemo(() => ({
    side,
    placement
  }), [side, placement]);
  const isNumberDuration = typeof duration === 'number';
  const openDuration = (isNumberDuration ? duration : duration.open) || 0;
  const closeDuration = (isNumberDuration ? duration : duration.close) || 0;
  const [styles, setStyles] = React.useState(() => ({
    ...execWithArgsOrReturn(unstable_common, fnArgs),
    ...execWithArgsOrReturn(unstable_initial, fnArgs)
  }));
  const {
    isMounted,
    status
  } = useTransitionStatus(context, {
    duration
  });
  const initialRef = useLatestRef(unstable_initial);
  const openRef = useLatestRef(unstable_open);
  const closeRef = useLatestRef(unstable_close);
  const commonRef = useLatestRef(unstable_common);
  index(() => {
    const initialStyles = execWithArgsOrReturn(initialRef.current, fnArgs);
    const closeStyles = execWithArgsOrReturn(closeRef.current, fnArgs);
    const commonStyles = execWithArgsOrReturn(commonRef.current, fnArgs);
    const openStyles = execWithArgsOrReturn(openRef.current, fnArgs) || Object.keys(initialStyles).reduce((acc, key) => {
      acc[key] = '';
      return acc;
    }, {});
    if (status === 'initial') {
      setStyles(styles => ({
        transitionProperty: styles.transitionProperty,
        ...commonStyles,
        ...initialStyles
      }));
    }
    if (status === 'open') {
      setStyles({
        transitionProperty: Object.keys(openStyles).map(camelCaseToKebabCase).join(','),
        transitionDuration: openDuration + "ms",
        ...commonStyles,
        ...openStyles
      });
    }
    if (status === 'close') {
      const styles = closeStyles || initialStyles;
      setStyles({
        transitionProperty: Object.keys(styles).map(camelCaseToKebabCase).join(','),
        transitionDuration: closeDuration + "ms",
        ...commonStyles,
        ...styles
      });
    }
  }, [closeDuration, closeRef, initialRef, openRef, commonRef, openDuration, status, fnArgs]);
  return {
    isMounted,
    styles
  };
}

/**
 * Provides a matching callback that can be used to focus an item as the user
 * types, often used in tandem with `useListNavigation()`.
 * @see https://floating-ui.com/docs/useTypeahead
 */
function useTypeahead(context, props) {
  var _ref;
  const {
    open,
    dataRef
  } = context;
  const {
    listRef,
    activeIndex,
    onMatch: unstable_onMatch,
    onTypingChange: unstable_onTypingChange,
    enabled = true,
    findMatch = null,
    resetMs = 750,
    ignoreKeys = [],
    selectedIndex = null
  } = props;
  const timeoutIdRef = React.useRef();
  const stringRef = React.useRef('');
  const prevIndexRef = React.useRef((_ref = selectedIndex != null ? selectedIndex : activeIndex) != null ? _ref : -1);
  const matchIndexRef = React.useRef(null);
  const onMatch = useEffectEvent(unstable_onMatch);
  const onTypingChange = useEffectEvent(unstable_onTypingChange);
  const findMatchRef = useLatestRef(findMatch);
  const ignoreKeysRef = useLatestRef(ignoreKeys);
  index(() => {
    if (open) {
      clearTimeout(timeoutIdRef.current);
      matchIndexRef.current = null;
      stringRef.current = '';
    }
  }, [open]);
  index(() => {
    // Sync arrow key navigation but not typeahead navigation.
    if (open && stringRef.current === '') {
      var _ref2;
      prevIndexRef.current = (_ref2 = selectedIndex != null ? selectedIndex : activeIndex) != null ? _ref2 : -1;
    }
  }, [open, selectedIndex, activeIndex]);
  const setTypingChange = useEffectEvent(value => {
    if (value) {
      if (!dataRef.current.typing) {
        dataRef.current.typing = value;
        onTypingChange(value);
      }
    } else {
      if (dataRef.current.typing) {
        dataRef.current.typing = value;
        onTypingChange(value);
      }
    }
  });
  const onKeyDown = useEffectEvent(event => {
    function getMatchingIndex(list, orderedList, string) {
      const str = findMatchRef.current ? findMatchRef.current(orderedList, string) : orderedList.find(text => (text == null ? void 0 : text.toLocaleLowerCase().indexOf(string.toLocaleLowerCase())) === 0);
      return str ? list.indexOf(str) : -1;
    }
    const listContent = listRef.current;
    if (stringRef.current.length > 0 && stringRef.current[0] !== ' ') {
      if (getMatchingIndex(listContent, listContent, stringRef.current) === -1) {
        setTypingChange(false);
      } else if (event.key === ' ') {
        stopEvent(event);
      }
    }
    if (listContent == null || ignoreKeysRef.current.includes(event.key) ||
    // Character key.
    event.key.length !== 1 ||
    // Modifier key.
    event.ctrlKey || event.metaKey || event.altKey) {
      return;
    }
    if (open && event.key !== ' ') {
      stopEvent(event);
      setTypingChange(true);
    }

    // Bail out if the list contains a word like "llama" or "aaron". TODO:
    // allow it in this case, too.
    const allowRapidSuccessionOfFirstLetter = listContent.every(text => {
      var _text$, _text$2;
      return text ? ((_text$ = text[0]) == null ? void 0 : _text$.toLocaleLowerCase()) !== ((_text$2 = text[1]) == null ? void 0 : _text$2.toLocaleLowerCase()) : true;
    });

    // Allows the user to cycle through items that start with the same letter
    // in rapid succession.
    if (allowRapidSuccessionOfFirstLetter && stringRef.current === event.key) {
      stringRef.current = '';
      prevIndexRef.current = matchIndexRef.current;
    }
    stringRef.current += event.key;
    clearTimeout(timeoutIdRef.current);
    timeoutIdRef.current = setTimeout(() => {
      stringRef.current = '';
      prevIndexRef.current = matchIndexRef.current;
      setTypingChange(false);
    }, resetMs);
    const prevIndex = prevIndexRef.current;
    const index = getMatchingIndex(listContent, [...listContent.slice((prevIndex || 0) + 1), ...listContent.slice(0, (prevIndex || 0) + 1)], stringRef.current);
    if (index !== -1) {
      onMatch(index);
      matchIndexRef.current = index;
    } else if (event.key !== ' ') {
      stringRef.current = '';
      setTypingChange(false);
    }
  });
  const reference = React.useMemo(() => ({
    onKeyDown
  }), [onKeyDown]);
  const floating = React.useMemo(() => {
    return {
      onKeyDown,
      onKeyUp(event) {
        if (event.key === ' ') {
          setTypingChange(false);
        }
      }
    };
  }, [onKeyDown, setTypingChange]);
  return React.useMemo(() => enabled ? {
    reference,
    floating
  } : {}, [enabled, reference, floating]);
}

function getArgsWithCustomFloatingHeight(state, height) {
  return {
    ...state,
    rects: {
      ...state.rects,
      floating: {
        ...state.rects.floating,
        height
      }
    }
  };
}
/**
 * Positions the floating element such that an inner element inside of it is
 * anchored to the reference element.
 * @see https://floating-ui.com/docs/inner
 */
const inner = props => ({
  name: 'inner',
  options: props,
  async fn(state) {
    const {
      listRef,
      overflowRef,
      onFallbackChange,
      offset: innerOffset = 0,
      index = 0,
      minItemsVisible = 4,
      referenceOverflowThreshold = 0,
      scrollRef,
      ...detectOverflowOptions
    } = evaluate(props, state);
    const {
      rects,
      elements: {
        floating
      }
    } = state;
    const item = listRef.current[index];
    const scrollEl = (scrollRef == null ? void 0 : scrollRef.current) || floating;

    // Valid combinations:
    // 1. Floating element is the scrollRef and has a border (default)
    // 2. Floating element is not the scrollRef, floating element has a border
    // 3. Floating element is not the scrollRef, scrollRef has a border
    // Floating > {...getFloatingProps()} wrapper > scrollRef > items is not
    // allowed as VoiceOver doesn't work.
    const clientTop = floating.clientTop || scrollEl.clientTop;
    const floatingIsBordered = floating.clientTop !== 0;
    const scrollElIsBordered = scrollEl.clientTop !== 0;
    const floatingIsScrollEl = floating === scrollEl;
    if (false) {}
    if (!item) {
      return {};
    }
    const nextArgs = {
      ...state,
      ...(await offset(-item.offsetTop - floating.clientTop - rects.reference.height / 2 - item.offsetHeight / 2 - innerOffset).fn(state))
    };
    const overflow = await detectOverflow(getArgsWithCustomFloatingHeight(nextArgs, scrollEl.scrollHeight + clientTop + floating.clientTop), detectOverflowOptions);
    const refOverflow = await detectOverflow(nextArgs, {
      ...detectOverflowOptions,
      elementContext: 'reference'
    });
    const diffY = max(0, overflow.top);
    const nextY = nextArgs.y + diffY;
    const isScrollable = scrollEl.scrollHeight > scrollEl.clientHeight;
    const rounder = isScrollable ? v => v : round;
    const maxHeight = rounder(max(0, scrollEl.scrollHeight + (floatingIsBordered && floatingIsScrollEl || scrollElIsBordered ? clientTop * 2 : 0) - diffY - max(0, overflow.bottom)));
    scrollEl.style.maxHeight = maxHeight + "px";
    scrollEl.scrollTop = diffY;

    // There is not enough space, fallback to standard anchored positioning
    if (onFallbackChange) {
      const shouldFallback = scrollEl.offsetHeight < item.offsetHeight * min(minItemsVisible, listRef.current.length) - 1 || refOverflow.top >= -referenceOverflowThreshold || refOverflow.bottom >= -referenceOverflowThreshold;
      ReactDOM.flushSync(() => onFallbackChange(shouldFallback));
    }
    if (overflowRef) {
      overflowRef.current = await detectOverflow(getArgsWithCustomFloatingHeight({
        ...nextArgs,
        y: nextY
      }, scrollEl.offsetHeight + clientTop + floating.clientTop), detectOverflowOptions);
    }
    return {
      y: nextY
    };
  }
});
/**
 * Changes the `inner` middleware's `offset` upon a `wheel` event to
 * expand the floating element's height, revealing more list items.
 * @see https://floating-ui.com/docs/inner
 */
function useInnerOffset(context, props) {
  const {
    open,
    elements
  } = context;
  const {
    enabled = true,
    overflowRef,
    scrollRef,
    onChange: unstable_onChange
  } = props;
  const onChange = useEffectEvent(unstable_onChange);
  const controlledScrollingRef = React.useRef(false);
  const prevScrollTopRef = React.useRef(null);
  const initialOverflowRef = React.useRef(null);
  React.useEffect(() => {
    if (!enabled) return;
    function onWheel(e) {
      if (e.ctrlKey || !el || overflowRef.current == null) {
        return;
      }
      const dY = e.deltaY;
      const isAtTop = overflowRef.current.top >= -0.5;
      const isAtBottom = overflowRef.current.bottom >= -0.5;
      const remainingScroll = el.scrollHeight - el.clientHeight;
      const sign = dY < 0 ? -1 : 1;
      const method = dY < 0 ? 'max' : 'min';
      if (el.scrollHeight <= el.clientHeight) {
        return;
      }
      if (!isAtTop && dY > 0 || !isAtBottom && dY < 0) {
        e.preventDefault();
        ReactDOM.flushSync(() => {
          onChange(d => d + Math[method](dY, remainingScroll * sign));
        });
      } else if (/firefox/i.test(getUserAgent())) {
        // Needed to propagate scrolling during momentum scrolling phase once
        // it gets limited by the boundary. UX improvement, not critical.
        el.scrollTop += dY;
      }
    }
    const el = (scrollRef == null ? void 0 : scrollRef.current) || elements.floating;
    if (open && el) {
      el.addEventListener('wheel', onWheel);

      // Wait for the position to be ready.
      requestAnimationFrame(() => {
        prevScrollTopRef.current = el.scrollTop;
        if (overflowRef.current != null) {
          initialOverflowRef.current = {
            ...overflowRef.current
          };
        }
      });
      return () => {
        prevScrollTopRef.current = null;
        initialOverflowRef.current = null;
        el.removeEventListener('wheel', onWheel);
      };
    }
  }, [enabled, open, elements.floating, overflowRef, scrollRef, onChange]);
  const floating = React.useMemo(() => ({
    onKeyDown() {
      controlledScrollingRef.current = true;
    },
    onWheel() {
      controlledScrollingRef.current = false;
    },
    onPointerMove() {
      controlledScrollingRef.current = false;
    },
    onScroll() {
      const el = (scrollRef == null ? void 0 : scrollRef.current) || elements.floating;
      if (!overflowRef.current || !el || !controlledScrollingRef.current) {
        return;
      }
      if (prevScrollTopRef.current !== null) {
        const scrollDiff = el.scrollTop - prevScrollTopRef.current;
        if (overflowRef.current.bottom < -0.5 && scrollDiff < -1 || overflowRef.current.top < -0.5 && scrollDiff > 1) {
          ReactDOM.flushSync(() => onChange(d => d + scrollDiff));
        }
      }

      // [Firefox] Wait for the height change to have been applied.
      requestAnimationFrame(() => {
        prevScrollTopRef.current = el.scrollTop;
      });
    }
  }), [elements.floating, onChange, overflowRef, scrollRef]);
  return React.useMemo(() => enabled ? {
    floating
  } : {}, [enabled, floating]);
}

function isPointInPolygon(point, polygon) {
  const [x, y] = point;
  let isInside = false;
  const length = polygon.length;
  for (let i = 0, j = length - 1; i < length; j = i++) {
    const [xi, yi] = polygon[i] || [0, 0];
    const [xj, yj] = polygon[j] || [0, 0];
    const intersect = yi >= y !== yj >= y && x <= (xj - xi) * (y - yi) / (yj - yi) + xi;
    if (intersect) {
      isInside = !isInside;
    }
  }
  return isInside;
}
function isInside(point, rect) {
  return point[0] >= rect.x && point[0] <= rect.x + rect.width && point[1] >= rect.y && point[1] <= rect.y + rect.height;
}
/**
 * Generates a safe polygon area that the user can traverse without closing the
 * floating element once leaving the reference element.
 * @see https://floating-ui.com/docs/useHover#safepolygon
 */
function safePolygon(options) {
  if (options === void 0) {
    options = {};
  }
  const {
    buffer = 0.5,
    blockPointerEvents = false,
    requireIntent = true
  } = options;
  let timeoutId;
  let hasLanded = false;
  let lastX = null;
  let lastY = null;
  let lastCursorTime = performance.now();
  function getCursorSpeed(x, y) {
    const currentTime = performance.now();
    const elapsedTime = currentTime - lastCursorTime;
    if (lastX === null || lastY === null || elapsedTime === 0) {
      lastX = x;
      lastY = y;
      lastCursorTime = currentTime;
      return null;
    }
    const deltaX = x - lastX;
    const deltaY = y - lastY;
    const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
    const speed = distance / elapsedTime; // px / ms

    lastX = x;
    lastY = y;
    lastCursorTime = currentTime;
    return speed;
  }
  const fn = _ref => {
    let {
      x,
      y,
      placement,
      elements,
      onClose,
      nodeId,
      tree
    } = _ref;
    return function onMouseMove(event) {
      function close() {
        clearTimeout(timeoutId);
        onClose();
      }
      clearTimeout(timeoutId);
      if (!elements.domReference || !elements.floating || placement == null || x == null || y == null) {
        return;
      }
      const {
        clientX,
        clientY
      } = event;
      const clientPoint = [clientX, clientY];
      const target = getTarget(event);
      const isLeave = event.type === 'mouseleave';
      const isOverFloatingEl = contains(elements.floating, target);
      const isOverReferenceEl = contains(elements.domReference, target);
      const refRect = elements.domReference.getBoundingClientRect();
      const rect = elements.floating.getBoundingClientRect();
      const side = placement.split('-')[0];
      const cursorLeaveFromRight = x > rect.right - rect.width / 2;
      const cursorLeaveFromBottom = y > rect.bottom - rect.height / 2;
      const isOverReferenceRect = isInside(clientPoint, refRect);
      const isFloatingWider = rect.width > refRect.width;
      const isFloatingTaller = rect.height > refRect.height;
      const left = (isFloatingWider ? refRect : rect).left;
      const right = (isFloatingWider ? refRect : rect).right;
      const top = (isFloatingTaller ? refRect : rect).top;
      const bottom = (isFloatingTaller ? refRect : rect).bottom;
      if (isOverFloatingEl) {
        hasLanded = true;
        if (!isLeave) {
          return;
        }
      }
      if (isOverReferenceEl) {
        hasLanded = false;
      }
      if (isOverReferenceEl && !isLeave) {
        hasLanded = true;
        return;
      }

      // Prevent overlapping floating element from being stuck in an open-close
      // loop: https://github.com/floating-ui/floating-ui/issues/1910
      if (isLeave && isElement(event.relatedTarget) && contains(elements.floating, event.relatedTarget)) {
        return;
      }

      // If any nested child is open, abort.
      if (tree && getChildren(tree.nodesRef.current, nodeId).some(_ref2 => {
        let {
          context
        } = _ref2;
        return context == null ? void 0 : context.open;
      })) {
        return;
      }

      // If the pointer is leaving from the opposite side, the "buffer" logic
      // creates a point where the floating element remains open, but should be
      // ignored.
      // A constant of 1 handles floating point rounding errors.
      if (side === 'top' && y >= refRect.bottom - 1 || side === 'bottom' && y <= refRect.top + 1 || side === 'left' && x >= refRect.right - 1 || side === 'right' && x <= refRect.left + 1) {
        return close();
      }

      // Ignore when the cursor is within the rectangular trough between the
      // two elements. Since the triangle is created from the cursor point,
      // which can start beyond the ref element's edge, traversing back and
      // forth from the ref to the floating element can cause it to close. This
      // ensures it always remains open in that case.
      let rectPoly = [];
      switch (side) {
        case 'top':
          rectPoly = [[left, refRect.top + 1], [left, rect.bottom - 1], [right, rect.bottom - 1], [right, refRect.top + 1]];
          break;
        case 'bottom':
          rectPoly = [[left, rect.top + 1], [left, refRect.bottom - 1], [right, refRect.bottom - 1], [right, rect.top + 1]];
          break;
        case 'left':
          rectPoly = [[rect.right - 1, bottom], [rect.right - 1, top], [refRect.left + 1, top], [refRect.left + 1, bottom]];
          break;
        case 'right':
          rectPoly = [[refRect.right - 1, bottom], [refRect.right - 1, top], [rect.left + 1, top], [rect.left + 1, bottom]];
          break;
      }
      function getPolygon(_ref3) {
        let [x, y] = _ref3;
        switch (side) {
          case 'top':
            {
              const cursorPointOne = [isFloatingWider ? x + buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4, y + buffer + 1];
              const cursorPointTwo = [isFloatingWider ? x - buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4, y + buffer + 1];
              const commonPoints = [[rect.left, cursorLeaveFromRight ? rect.bottom - buffer : isFloatingWider ? rect.bottom - buffer : rect.top], [rect.right, cursorLeaveFromRight ? isFloatingWider ? rect.bottom - buffer : rect.top : rect.bottom - buffer]];
              return [cursorPointOne, cursorPointTwo, ...commonPoints];
            }
          case 'bottom':
            {
              const cursorPointOne = [isFloatingWider ? x + buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4, y - buffer];
              const cursorPointTwo = [isFloatingWider ? x - buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4, y - buffer];
              const commonPoints = [[rect.left, cursorLeaveFromRight ? rect.top + buffer : isFloatingWider ? rect.top + buffer : rect.bottom], [rect.right, cursorLeaveFromRight ? isFloatingWider ? rect.top + buffer : rect.bottom : rect.top + buffer]];
              return [cursorPointOne, cursorPointTwo, ...commonPoints];
            }
          case 'left':
            {
              const cursorPointOne = [x + buffer + 1, isFloatingTaller ? y + buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4];
              const cursorPointTwo = [x + buffer + 1, isFloatingTaller ? y - buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4];
              const commonPoints = [[cursorLeaveFromBottom ? rect.right - buffer : isFloatingTaller ? rect.right - buffer : rect.left, rect.top], [cursorLeaveFromBottom ? isFloatingTaller ? rect.right - buffer : rect.left : rect.right - buffer, rect.bottom]];
              return [...commonPoints, cursorPointOne, cursorPointTwo];
            }
          case 'right':
            {
              const cursorPointOne = [x - buffer, isFloatingTaller ? y + buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4];
              const cursorPointTwo = [x - buffer, isFloatingTaller ? y - buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4];
              const commonPoints = [[cursorLeaveFromBottom ? rect.left + buffer : isFloatingTaller ? rect.left + buffer : rect.right, rect.top], [cursorLeaveFromBottom ? isFloatingTaller ? rect.left + buffer : rect.right : rect.left + buffer, rect.bottom]];
              return [cursorPointOne, cursorPointTwo, ...commonPoints];
            }
        }
      }
      if (isPointInPolygon([clientX, clientY], rectPoly)) {
        return;
      }
      if (hasLanded && !isOverReferenceRect) {
        return close();
      }
      if (!isLeave && requireIntent) {
        const cursorSpeed = getCursorSpeed(event.clientX, event.clientY);
        const cursorSpeedThreshold = 0.1;
        if (cursorSpeed !== null && cursorSpeed < cursorSpeedThreshold) {
          return close();
        }
      }
      if (!isPointInPolygon([clientX, clientY], getPolygon([x, y]))) {
        close();
      } else if (!hasLanded && requireIntent) {
        timeoutId = window.setTimeout(close, 40);
      }
    };
  };
  fn.__options = {
    blockPointerEvents
  };
  return fn;
}




/***/ }),

/***/ 37317:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dx": function() { return /* binding */ getComputedStyle; },
/* harmony export */   "Jj": function() { return /* binding */ getWindow; },
/* harmony export */   "Kx": function() { return /* binding */ getOverflowAncestors; },
/* harmony export */   "Lw": function() { return /* binding */ getNodeScroll; },
/* harmony export */   "Ow": function() { return /* binding */ getParentNode; },
/* harmony export */   "Pf": function() { return /* binding */ isWebKit; },
/* harmony export */   "Py": function() { return /* binding */ isLastTraversableNode; },
/* harmony export */   "Re": function() { return /* binding */ isHTMLElement; },
/* harmony export */   "Ze": function() { return /* binding */ isTableElement; },
/* harmony export */   "Zq": function() { return /* binding */ isShadowRoot; },
/* harmony export */   "ao": function() { return /* binding */ isOverflowElement; },
/* harmony export */   "gQ": function() { return /* binding */ getContainingBlock; },
/* harmony export */   "hT": function() { return /* binding */ isContainingBlock; },
/* harmony export */   "kK": function() { return /* binding */ isElement; },
/* harmony export */   "tF": function() { return /* binding */ getDocumentElement; },
/* harmony export */   "tR": function() { return /* binding */ isTopLayer; },
/* harmony export */   "wK": function() { return /* binding */ getFrameElement; },
/* harmony export */   "wk": function() { return /* binding */ getNodeName; }
/* harmony export */ });
/* unused harmony exports getNearestOverflowAncestor, isNode */
function hasWindow() {
  return typeof window !== 'undefined';
}
function getNodeName(node) {
  if (isNode(node)) {
    return (node.nodeName || '').toLowerCase();
  }
  // Mocked nodes in testing environments may not be instances of Node. By
  // returning `#document` an infinite loop won't occur.
  // https://github.com/floating-ui/floating-ui/issues/2317
  return '#document';
}
function getWindow(node) {
  var _node$ownerDocument;
  return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function getDocumentElement(node) {
  var _ref;
  return (_ref = (isNode(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function isNode(value) {
  if (!hasWindow()) {
    return false;
  }
  return value instanceof Node || value instanceof getWindow(value).Node;
}
function isElement(value) {
  if (!hasWindow()) {
    return false;
  }
  return value instanceof Element || value instanceof getWindow(value).Element;
}
function isHTMLElement(value) {
  if (!hasWindow()) {
    return false;
  }
  return value instanceof HTMLElement || value instanceof getWindow(value).HTMLElement;
}
function isShadowRoot(value) {
  if (!hasWindow() || typeof ShadowRoot === 'undefined') {
    return false;
  }
  return value instanceof ShadowRoot || value instanceof getWindow(value).ShadowRoot;
}
function isOverflowElement(element) {
  const {
    overflow,
    overflowX,
    overflowY,
    display
  } = getComputedStyle(element);
  return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && !['inline', 'contents'].includes(display);
}
function isTableElement(element) {
  return ['table', 'td', 'th'].includes(getNodeName(element));
}
function isTopLayer(element) {
  return [':popover-open', ':modal'].some(selector => {
    try {
      return element.matches(selector);
    } catch (e) {
      return false;
    }
  });
}
function isContainingBlock(elementOrCss) {
  const webkit = isWebKit();
  const css = isElement(elementOrCss) ? getComputedStyle(elementOrCss) : elementOrCss;

  // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
  // https://drafts.csswg.org/css-transforms-2/#individual-transforms
  return ['transform', 'translate', 'scale', 'rotate', 'perspective'].some(value => css[value] ? css[value] !== 'none' : false) || (css.containerType ? css.containerType !== 'normal' : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== 'none' : false) || !webkit && (css.filter ? css.filter !== 'none' : false) || ['transform', 'translate', 'scale', 'rotate', 'perspective', 'filter'].some(value => (css.willChange || '').includes(value)) || ['paint', 'layout', 'strict', 'content'].some(value => (css.contain || '').includes(value));
}
function getContainingBlock(element) {
  let currentNode = getParentNode(element);
  while (isHTMLElement(currentNode) && !isLastTraversableNode(currentNode)) {
    if (isContainingBlock(currentNode)) {
      return currentNode;
    } else if (isTopLayer(currentNode)) {
      return null;
    }
    currentNode = getParentNode(currentNode);
  }
  return null;
}
function isWebKit() {
  if (typeof CSS === 'undefined' || !CSS.supports) return false;
  return CSS.supports('-webkit-backdrop-filter', 'none');
}
function isLastTraversableNode(node) {
  return ['html', 'body', '#document'].includes(getNodeName(node));
}
function getComputedStyle(element) {
  return getWindow(element).getComputedStyle(element);
}
function getNodeScroll(element) {
  if (isElement(element)) {
    return {
      scrollLeft: element.scrollLeft,
      scrollTop: element.scrollTop
    };
  }
  return {
    scrollLeft: element.scrollX,
    scrollTop: element.scrollY
  };
}
function getParentNode(node) {
  if (getNodeName(node) === 'html') {
    return node;
  }
  const result =
  // Step into the shadow DOM of the parent of a slotted node.
  node.assignedSlot ||
  // DOM Element detected.
  node.parentNode ||
  // ShadowRoot detected.
  isShadowRoot(node) && node.host ||
  // Fallback.
  getDocumentElement(node);
  return isShadowRoot(result) ? result.host : result;
}
function getNearestOverflowAncestor(node) {
  const parentNode = getParentNode(node);
  if (isLastTraversableNode(parentNode)) {
    return node.ownerDocument ? node.ownerDocument.body : node.body;
  }
  if (isHTMLElement(parentNode) && isOverflowElement(parentNode)) {
    return parentNode;
  }
  return getNearestOverflowAncestor(parentNode);
}
function getOverflowAncestors(node, list, traverseIframes) {
  var _node$ownerDocument2;
  if (list === void 0) {
    list = [];
  }
  if (traverseIframes === void 0) {
    traverseIframes = true;
  }
  const scrollableAncestor = getNearestOverflowAncestor(node);
  const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
  const win = getWindow(scrollableAncestor);
  if (isBody) {
    const frameElement = getFrameElement(win);
    return list.concat(win, win.visualViewport || [], isOverflowElement(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? getOverflowAncestors(frameElement) : []);
  }
  return list.concat(scrollableAncestor, getOverflowAncestors(scrollableAncestor, [], traverseIframes));
}
function getFrameElement(win) {
  return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}




/***/ }),

/***/ 16194:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "snk": function() { return /* reexport */ OktaAuth; }
});

// UNUSED EXPORTS: ACCESS_TOKEN_STORAGE_KEY, AuthApiError, AuthPollStopError, AuthSdkError, AuthStateManager, AuthTransaction, AuthenticatorKey, BaseTransaction, CACHE_STORAGE_NAME, DEFAULT_CACHE_DURATION, DEFAULT_CODE_CHALLENGE_METHOD, DEFAULT_MAX_CLOCK_SKEW, DEFAULT_POLLING_DELAY, EVENT_ADDED, EVENT_ERROR, EVENT_EXPIRED, EVENT_REMOVED, EVENT_RENEWED, EVENT_SET_STORAGE, EmailChallengeTransaction, EmailRole, EmailStatusTransaction, EmailTransaction, IDX_API_VERSION, IDX_RESPONSE_STORAGE_NAME, ID_TOKEN_STORAGE_KEY, INITIAL_AUTH_STATE, IdxFeature, IdxStatus, MAX_VERIFIER_LENGTH, MIN_VERIFIER_LENGTH, OAuthError, ORIGINAL_URI_STORAGE_NAME, PKCE_STORAGE_NAME, PhoneTransaction, ProfileSchemaTransaction, ProfileTransaction, REDIRECT_NONCE_COOKIE_NAME, REDIRECT_OAUTH_PARAMS_NAME, REDIRECT_STATE_COOKIE_NAME, REFERRER_PATH_STORAGE_KEY, REFRESH_TOKEN_STORAGE_KEY, SHARED_TRANSACTION_STORAGE_NAME, STATE_TOKEN_KEY_NAME, Status, StorageManager, TOKEN_STORAGE_NAME, TRANSACTION_STORAGE_NAME, TokenManager, addEmail, addListener, addPhone, addPostMessageListener, addStateToken, assertPKCESupport, authenticate, bind, buildAuthorizeParams, canProceed, cancel, clearTransactionMeta, clone, convertTokenParamsToOAuthParams, createOAuthMeta, createTransactionMeta, crypto, decodeToken, delay, deleteEmail, deletePhone, deprecate, deprecateWrap, exchangeCodeForTokens, extend, find, genRandomString, generateNonce, generateState, getConsole, getDefaultTokenParams, getEmail, getEmailChallenge, getEmails, getHashOrSearch, getKey, getLink, getNativeConsole, getOAuthBaseUrl, getOAuthDomain, getOAuthUrls, getPhone, getPhones, getPollFn, getProfile, getProfileSchema, getSavedTransactionMeta, getStateToken, getToken, getTransactionMeta, getUserInfo, getWellKnown, getWithPopup, getWithRedirect, getWithoutPrompt, handleEmailVerifyCallback, handleInteractionCodeRedirect, handleOAuthResponse, hasAuthorizationCode, hasErrorInUrl, hasInteractionCode, hasSavedInteractionHandle, hasTokensInHash, interact, introspect, introspectAuthn, isAbsoluteUrl, isAccessToken, isAuthApiError, isAuthenticator, isAuthorizationCodeError, isCodeFlow, isCustomAuthTransactionMeta, isEmailVerifyCallback, isEmailVerifyCallbackError, isFunction, isIDToken, isIdxTransactionMeta, isInteractionRequired, isInteractionRequiredError, isLocalStorageAvailable, isLoginRedirect, isNumber, isOAuthError, isOAuthTransactionMeta, isObject, isPKCETransactionMeta, isPromise, isRedirectUri, isRefreshToken, isRefreshTokenError, isRefreshTokenInvalidError, isSameRefreshToken, isString, isToken, isTransactionMeta, isTransactionMetaValid, isTransactionMetaValidForFlow, isTransactionMetaValidForOptions, isoToUTCString, loadFrame, loadPopup, omit, parseEmailVerifyCallback, parseFromUrl, pkce, poll, postRefreshToken, postToTokenEndpoint, postToTransaction, preparePKCE, prepareTokenParams, proceed, recoverPassword, register, removeListener, removeNils, removeTrailingSlash, renewToken, renewTokens, renewTokensWithRefresh, resumeTransaction, revokeToken, saveTransactionMeta, sendEmailChallenge, sendPhoneChallenge, split2, startTransaction, toAbsoluteUrl, toQueryString, toRelativeUrl, transactionExists, transactionStatus, transactionStep, unlockAccount, updateProfile, urlParamsToObject, validateClaims, validateCodeChallengeMethod, validateToken, verifyEmailChallenge, verifyPhoneChallenge, verifyToken, warn

// NAMESPACE OBJECT: ./node_modules/@okta/okta-auth-js/esm/browser/crypto/index.js
var crypto_namespaceObject = {};
__webpack_require__.r(crypto_namespaceObject);
__webpack_require__.d(crypto_namespaceObject, {
  "atob": function() { return a; },
  "base64ToBase64Url": function() { return base64ToBase64Url; },
  "base64UrlDecode": function() { return base64UrlDecode; },
  "base64UrlToBase64": function() { return base64UrlToBase64; },
  "base64UrlToBuffer": function() { return base64UrlToBuffer; },
  "base64UrlToString": function() { return base64UrlToString; },
  "btoa": function() { return b; },
  "bufferToBase64Url": function() { return bufferToBase64Url; },
  "getOidcHash": function() { return getOidcHash; },
  "stringToBase64Url": function() { return stringToBase64Url; },
  "stringToBuffer": function() { return stringToBuffer; },
  "verifyToken": function() { return verifyToken; },
  "webcrypto": function() { return c; }
});

// NAMESPACE OBJECT: ./node_modules/@okta/okta-auth-js/esm/browser/constants.js
var constants_namespaceObject = {};
__webpack_require__.r(constants_namespaceObject);
__webpack_require__.d(constants_namespaceObject, {
  "ACCESS_TOKEN_STORAGE_KEY": function() { return ACCESS_TOKEN_STORAGE_KEY; },
  "CACHE_STORAGE_NAME": function() { return CACHE_STORAGE_NAME; },
  "DEFAULT_CACHE_DURATION": function() { return DEFAULT_CACHE_DURATION; },
  "DEFAULT_CODE_CHALLENGE_METHOD": function() { return DEFAULT_CODE_CHALLENGE_METHOD; },
  "DEFAULT_MAX_CLOCK_SKEW": function() { return DEFAULT_MAX_CLOCK_SKEW; },
  "DEFAULT_POLLING_DELAY": function() { return DEFAULT_POLLING_DELAY; },
  "IDX_API_VERSION": function() { return IDX_API_VERSION; },
  "IDX_RESPONSE_STORAGE_NAME": function() { return IDX_RESPONSE_STORAGE_NAME; },
  "ID_TOKEN_STORAGE_KEY": function() { return ID_TOKEN_STORAGE_KEY; },
  "MAX_VERIFIER_LENGTH": function() { return MAX_VERIFIER_LENGTH; },
  "MIN_VERIFIER_LENGTH": function() { return MIN_VERIFIER_LENGTH; },
  "ORIGINAL_URI_STORAGE_NAME": function() { return ORIGINAL_URI_STORAGE_NAME; },
  "PKCE_STORAGE_NAME": function() { return PKCE_STORAGE_NAME; },
  "REDIRECT_NONCE_COOKIE_NAME": function() { return REDIRECT_NONCE_COOKIE_NAME; },
  "REDIRECT_OAUTH_PARAMS_NAME": function() { return REDIRECT_OAUTH_PARAMS_NAME; },
  "REDIRECT_STATE_COOKIE_NAME": function() { return REDIRECT_STATE_COOKIE_NAME; },
  "REFERRER_PATH_STORAGE_KEY": function() { return REFERRER_PATH_STORAGE_KEY; },
  "REFRESH_TOKEN_STORAGE_KEY": function() { return REFRESH_TOKEN_STORAGE_KEY; },
  "SHARED_TRANSACTION_STORAGE_NAME": function() { return SHARED_TRANSACTION_STORAGE_NAME; },
  "STATE_TOKEN_KEY_NAME": function() { return STATE_TOKEN_KEY_NAME; },
  "TOKEN_STORAGE_NAME": function() { return TOKEN_STORAGE_NAME; },
  "TRANSACTION_STORAGE_NAME": function() { return TRANSACTION_STORAGE_NAME; }
});

// NAMESPACE OBJECT: ./node_modules/@okta/okta-auth-js/esm/browser/features.js
var features_namespaceObject = {};
__webpack_require__.r(features_namespaceObject);
__webpack_require__.d(features_namespaceObject, {
  "getUserAgent": function() { return getUserAgent; },
  "hasTextEncoder": function() { return hasTextEncoder; },
  "isBrowser": function() { return isBrowser; },
  "isFingerprintSupported": function() { return isFingerprintSupported; },
  "isHTTPS": function() { return isHTTPS; },
  "isIE11OrLess": function() { return isIE11OrLess; },
  "isLocalhost": function() { return isLocalhost; },
  "isPKCESupported": function() { return isPKCESupported; },
  "isPopupPostMessageSupported": function() { return isPopupPostMessageSupported; },
  "isTokenVerifySupported": function() { return isTokenVerifySupported; }
});

// NAMESPACE OBJECT: ./node_modules/@okta/okta-auth-js/esm/browser/crypto/webauthn.js
var webauthn_namespaceObject = {};
__webpack_require__.r(webauthn_namespaceObject);
__webpack_require__.d(webauthn_namespaceObject, {
  "buildCredentialCreationOptions": function() { return buildCredentialCreationOptions; },
  "buildCredentialRequestOptions": function() { return buildCredentialRequestOptions; },
  "getAssertion": function() { return getAssertion; },
  "getAttestation": function() { return getAttestation; }
});

// NAMESPACE OBJECT: ./node_modules/@okta/okta-auth-js/esm/browser/idx/remediators/index.js
var remediators_namespaceObject = {};
__webpack_require__.r(remediators_namespaceObject);
__webpack_require__.d(remediators_namespaceObject, {
  "AuthenticatorEnrollmentData": function() { return AuthenticatorEnrollmentData; },
  "AuthenticatorVerificationData": function() { return AuthenticatorVerificationData; },
  "ChallengeAuthenticator": function() { return ChallengeAuthenticator; },
  "ChallengePoll": function() { return ChallengePoll; },
  "EnrollAuthenticator": function() { return EnrollAuthenticator; },
  "EnrollPoll": function() { return EnrollPoll; },
  "EnrollProfile": function() { return EnrollProfile; },
  "EnrollmentChannelData": function() { return EnrollmentChannelData; },
  "GenericRemediator": function() { return GenericRemediator; },
  "Identify": function() { return Identify; },
  "ReEnrollAuthenticator": function() { return ReEnrollAuthenticator; },
  "RedirectIdp": function() { return RedirectIdp; },
  "Remediator": function() { return Remediator; },
  "ResetAuthenticator": function() { return ResetAuthenticator; },
  "SelectAuthenticatorAuthenticate": function() { return SelectAuthenticatorAuthenticate; },
  "SelectAuthenticatorEnroll": function() { return SelectAuthenticatorEnroll; },
  "SelectAuthenticatorUnlockAccount": function() { return SelectAuthenticatorUnlockAccount; },
  "SelectEnrollProfile": function() { return SelectEnrollProfile; },
  "SelectEnrollmentChannel": function() { return SelectEnrollmentChannel; },
  "Skip": function() { return Skip; }
});

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/errors/CustomError.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */

class CustomError extends Error {
    constructor(message) {
        super(message);
        Object.setPrototypeOf(this, new.target.prototype);
    }
}


//# sourceMappingURL=CustomError.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/errors/AuthSdkError.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



class AuthSdkError_AuthSdkError extends CustomError {
    constructor(msg, xhr) {
        super(msg);
        this.name = 'AuthSdkError';
        this.errorCode = 'INTERNAL';
        this.errorSummary = msg;
        this.errorLink = 'INTERNAL';
        this.errorId = 'INTERNAL';
        this.errorCauses = [];
        if (xhr) {
            this.xhr = xhr;
        }
    }
}


//# sourceMappingURL=AuthSdkError.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/crypto/browser.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */

const a = function (str) { return atob(str); };
const b = function (str) { return btoa(str); };
const c = typeof crypto === 'undefined' ? null : crypto;


//# sourceMappingURL=browser.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/crypto/base64.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */




function stringToBase64Url(str) {
    var b64 = b(str);
    return base64ToBase64Url(b64);
}
function base64ToBase64Url(b64) {
    return b64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}
function base64UrlToBase64(b64u) {
    return b64u.replace(/-/g, '+').replace(/_/g, '/');
}
function base64UrlToString(b64u) {
    var b64 = base64UrlToBase64(b64u);
    switch (b64.length % 4) {
        case 0:
            break;
        case 2:
            b64 += '==';
            break;
        case 3:
            b64 += '=';
            break;
        default:
            throw new AuthSdkError_AuthSdkError('Not a valid Base64Url');
    }
    var utf8 = a(b64);
    try {
        return decodeURIComponent(escape(utf8));
    }
    catch (e) {
        return utf8;
    }
}
function stringToBuffer(str) {
    var buffer = new Uint8Array(str.length);
    for (var i = 0; i < str.length; i++) {
        buffer[i] = str.charCodeAt(i);
    }
    return buffer;
}
function base64UrlDecode(str) {
    return a(base64UrlToBase64(str));
}
function base64UrlToBuffer(b64u) {
    return Uint8Array.from(base64UrlDecode(b64u), (c) => c.charCodeAt(0));
}
function bufferToBase64Url(bin) {
    return b(new Uint8Array(bin).reduce((s, byte) => s + String.fromCharCode(byte), ''));
}


//# sourceMappingURL=base64.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/crypto/oidcHash.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */




function getOidcHash(str) {
    var buffer = new TextEncoder().encode(str);
    return c.subtle.digest('SHA-256', buffer).then(function (arrayBuffer) {
        var intBuffer = new Uint8Array(arrayBuffer);
        var firstHalf = intBuffer.slice(0, 16);
        var hash = String.fromCharCode.apply(null, firstHalf);
        var b64u = stringToBase64Url(hash);
        return b64u;
    });
}


//# sourceMappingURL=oidcHash.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/util/object.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */

function bind(fn, ctx) {
    var additionalArgs = Array.prototype.slice.call(arguments, 2);
    return function () {
        var args = Array.prototype.slice.call(arguments);
        args = additionalArgs.concat(args);
        return fn.apply(ctx, args);
    };
}
function extend() {
    var obj1 = arguments[0];
    var objArray = [].slice.call(arguments, 1);
    objArray.forEach(function (obj) {
        for (var prop in obj) {
            if (Object.prototype.hasOwnProperty.call(obj, prop) && obj[prop] !== undefined) {
                obj1[prop] = obj[prop];
            }
        }
    });
    return obj1;
}
function removeNils(obj) {
    var cleaned = {};
    for (var prop in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, prop)) {
            var value = obj[prop];
            if (value !== null && value !== undefined) {
                cleaned[prop] = value;
            }
        }
    }
    return cleaned;
}
function clone(obj) {
    if (obj) {
        var str = JSON.stringify(obj);
        if (str) {
            return JSON.parse(str);
        }
    }
    return obj;
}
function omit(obj, ...props) {
    var newobj = {};
    for (var p in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, p) && props.indexOf(p) == -1) {
            newobj[p] = obj[p];
        }
    }
    return clone(newobj);
}
function find(collection, searchParams) {
    var c = collection.length;
    while (c--) {
        var item = collection[c];
        var found = true;
        for (var prop in searchParams) {
            if (!Object.prototype.hasOwnProperty.call(searchParams, prop)) {
                continue;
            }
            if (item[prop] !== searchParams[prop]) {
                found = false;
                break;
            }
        }
        if (found) {
            return item;
        }
    }
}
function getLink(obj, linkName, altName) {
    if (!obj || !obj._links) {
        return;
    }
    var link = clone(obj._links[linkName]);
    if (link && link.name && altName) {
        if (link.name === altName) {
            return link;
        }
    }
    else {
        return link;
    }
}


//# sourceMappingURL=object.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/crypto/verifyToken.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */





function verifyToken(idToken, key) {
    key = clone(key);
    var format = 'jwk';
    var algo = {
        name: 'RSASSA-PKCS1-v1_5',
        hash: { name: 'SHA-256' }
    };
    var extractable = true;
    var usages = ['verify'];
    delete key.use;
    return c.subtle.importKey(format, key, algo, extractable, usages)
        .then(function (cryptoKey) {
        var jwt = idToken.split('.');
        var payload = stringToBuffer(jwt[0] + '.' + jwt[1]);
        var b64Signature = base64UrlDecode(jwt[2]);
        var signature = stringToBuffer(b64Signature);
        return c.subtle.verify(algo, cryptoKey, signature, payload);
    });
}


//# sourceMappingURL=verifyToken.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/crypto/index.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */





//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/_virtual/_tslib.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}


//# sourceMappingURL=_tslib.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/constants.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */

const STATE_TOKEN_KEY_NAME = 'oktaStateToken';
const DEFAULT_POLLING_DELAY = 500;
const DEFAULT_MAX_CLOCK_SKEW = 300;
const DEFAULT_CACHE_DURATION = 86400;
const REDIRECT_OAUTH_PARAMS_NAME = 'okta-oauth-redirect-params';
const REDIRECT_STATE_COOKIE_NAME = 'okta-oauth-state';
const REDIRECT_NONCE_COOKIE_NAME = 'okta-oauth-nonce';
const TOKEN_STORAGE_NAME = 'okta-token-storage';
const CACHE_STORAGE_NAME = 'okta-cache-storage';
const PKCE_STORAGE_NAME = 'okta-pkce-storage';
const TRANSACTION_STORAGE_NAME = 'okta-transaction-storage';
const SHARED_TRANSACTION_STORAGE_NAME = 'okta-shared-transaction-storage';
const ORIGINAL_URI_STORAGE_NAME = 'okta-original-uri-storage';
const IDX_RESPONSE_STORAGE_NAME = 'okta-idx-response-storage';
const ACCESS_TOKEN_STORAGE_KEY = 'accessToken';
const ID_TOKEN_STORAGE_KEY = 'idToken';
const REFRESH_TOKEN_STORAGE_KEY = 'refreshToken';
const REFERRER_PATH_STORAGE_KEY = 'referrerPath';
const MIN_VERIFIER_LENGTH = 43;
const MAX_VERIFIER_LENGTH = 128;
const DEFAULT_CODE_CHALLENGE_METHOD = 'S256';
const IDX_API_VERSION = '1.0.0';


//# sourceMappingURL=constants.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/util/types.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */

function isString(obj) {
    return Object.prototype.toString.call(obj) === '[object String]';
}
function isObject(obj) {
    return Object.prototype.toString.call(obj) === '[object Object]';
}
function isNumber(obj) {
    return Object.prototype.toString.call(obj) === '[object Number]';
}
function isFunction(fn) {
    return !!fn && {}.toString.call(fn) === '[object Function]';
}
function isPromise(obj) {
    return obj && obj.finally && (typeof obj.finally === 'function');
}


//# sourceMappingURL=types.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/util/url.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */

function isAbsoluteUrl(url) {
    return /^[a-z][a-z0-9+.-]*:/i.test(url);
}
function toAbsoluteUrl(url = '', baseUrl) {
    if (isAbsoluteUrl(url)) {
        return url;
    }
    baseUrl = removeTrailingSlash(baseUrl);
    return url[0] === '/' ? `${baseUrl}${url}` : `${baseUrl}/${url}`;
}
function toRelativeUrl(url = '', baseUrl) {
    if (isAbsoluteUrl(url)) {
        url = url.substring(baseUrl.length);
    }
    return url[0] === '/' ? url : `/${url}`;
}
function toQueryString(obj) {
    var str = [];
    if (obj !== null) {
        for (var key in obj) {
            if (Object.prototype.hasOwnProperty.call(obj, key) &&
                obj[key] !== undefined &&
                obj[key] !== null) {
                str.push(key + '=' + encodeURIComponent(obj[key]));
            }
        }
    }
    if (str.length) {
        return '?' + str.join('&');
    }
    else {
        return '';
    }
}
function removeTrailingSlash(path) {
    if (!path) {
        return;
    }
    var trimmed = path.replace(/^\s+|\s+$/gm, '');
    trimmed = trimmed.replace(/\/+$/, '');
    return trimmed;
}


//# sourceMappingURL=url.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/errors/AuthApiError.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



class AuthApiError_AuthApiError extends CustomError {
    constructor(err, xhr, meta) {
        const message = err.errorSummary;
        super(message);
        this.name = 'AuthApiError';
        this.errorSummary = err.errorSummary;
        this.errorCode = err.errorCode;
        this.errorLink = err.errorLink;
        this.errorId = err.errorId;
        this.errorCauses = err.errorCauses;
        if (xhr) {
            this.xhr = xhr;
        }
        if (meta) {
            this.meta = meta;
        }
    }
}


//# sourceMappingURL=AuthApiError.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/errors/OAuthError.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



class OAuthError extends CustomError {
    constructor(errorCode, summary) {
        super(summary);
        this.name = 'OAuthError';
        this.errorCode = errorCode;
        this.errorSummary = summary;
        this.error = errorCode;
        this.error_description = summary;
    }
}


//# sourceMappingURL=OAuthError.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/http/request.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */








function request_httpRequest(sdk, options) {
    options = options || {};
    if (sdk.options.httpRequestInterceptors) {
        for (const interceptor of sdk.options.httpRequestInterceptors) {
            interceptor(options);
        }
    }
    var url = options.url, method = options.method, args = options.args, saveAuthnState = options.saveAuthnState, accessToken = options.accessToken, withCredentials = options.withCredentials === true,
    storageUtil = sdk.options.storageUtil, storage = storageUtil.storage, httpCache = sdk.storageManager.getHttpCache(sdk.options.cookies);
    if (options.cacheResponse) {
        var cacheContents = httpCache.getStorage();
        var cachedResponse = cacheContents[url];
        if (cachedResponse && Date.now() / 1000 < cachedResponse.expiresAt) {
            return Promise.resolve(cachedResponse.response);
        }
    }
    var oktaUserAgentHeader = sdk._oktaUserAgent.getHttpHeader();
    var headers = Object.assign({ 'Accept': 'application/json', 'Content-Type': 'application/json' }, oktaUserAgentHeader);
    Object.assign(headers, sdk.options.headers, options.headers);
    headers = removeNils(headers);
    if (accessToken && isString(accessToken)) {
        headers['Authorization'] = 'Bearer ' + accessToken;
    }
    var ajaxOptions = {
        headers,
        data: args || undefined,
        withCredentials
    };
    var err, res;
    return sdk.options.httpRequestClient(method, url, ajaxOptions)
        .then(function (resp) {
        res = resp.responseText;
        if (res && isString(res)) {
            res = JSON.parse(res);
            if (res && typeof res === 'object' && !res.headers) {
                if (Array.isArray(res)) {
                    res.forEach(item => {
                        item.headers = resp.headers;
                    });
                }
                else {
                    res.headers = resp.headers;
                }
            }
        }
        if (saveAuthnState) {
            if (!res.stateToken) {
                storage.delete(STATE_TOKEN_KEY_NAME);
            }
        }
        if (res && res.stateToken && res.expiresAt) {
            storage.set(STATE_TOKEN_KEY_NAME, res.stateToken, res.expiresAt, sdk.options.cookies);
        }
        if (res && options.cacheResponse) {
            httpCache.updateStorage(url, {
                expiresAt: Math.floor(Date.now() / 1000) + DEFAULT_CACHE_DURATION,
                response: res
            });
        }
        return res;
    })
        .catch(function (resp) {
        var serverErr = resp.responseText || {};
        if (isString(serverErr)) {
            try {
                serverErr = JSON.parse(serverErr);
            }
            catch (e) {
                serverErr = {
                    errorSummary: 'Unknown error'
                };
            }
        }
        if (resp.status >= 500) {
            serverErr.errorSummary = 'Unknown error';
        }
        if (sdk.options.transformErrorXHR) {
            resp = sdk.options.transformErrorXHR(clone(resp));
        }
        if (serverErr.error && serverErr.error_description) {
            err = new OAuthError(serverErr.error, serverErr.error_description);
        }
        else {
            err = new AuthApiError_AuthApiError(serverErr, resp);
        }
        if (err.errorCode === 'E0000011') {
            storage.delete(STATE_TOKEN_KEY_NAME);
        }
        throw err;
    });
}
function get(sdk, url, options) {
    url = isAbsoluteUrl(url) ? url : sdk.getIssuerOrigin() + url;
    var getOptions = {
        url: url,
        method: 'GET'
    };
    Object.assign(getOptions, options);
    return request_httpRequest(sdk, getOptions);
}
function post(sdk, url, args, options) {
    url = isAbsoluteUrl(url) ? url : sdk.getIssuerOrigin() + url;
    var postOptions = {
        url: url,
        method: 'POST',
        args: args,
        saveAuthnState: true
    };
    Object.assign(postOptions, options);
    return request_httpRequest(sdk, postOptions);
}


//# sourceMappingURL=request.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/tx/util.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */

function addStateToken(res, options) {
    var builtArgs = {};
    Object.assign(builtArgs, options);
    if (!builtArgs.stateToken && res.stateToken) {
        builtArgs.stateToken = res.stateToken;
    }
    return builtArgs;
}
function getStateToken(res) {
    return addStateToken(res);
}


//# sourceMappingURL=util.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/tx/api.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */






function transactionStatus(sdk, args) {
    args = addStateToken(sdk, args);
    return post(sdk, sdk.getIssuerOrigin() + '/api/v1/authn', args, { withCredentials: true });
}
function resumeTransaction(sdk, args) {
    if (!args || !args.stateToken) {
        var stateToken = sdk.tx.exists._get(STATE_TOKEN_KEY_NAME);
        if (stateToken) {
            args = {
                stateToken: stateToken
            };
        }
        else {
            return Promise.reject(new AuthSdkError_AuthSdkError('No transaction to resume'));
        }
    }
    return sdk.tx.status(args)
        .then(function (res) {
        return sdk.tx.createTransaction(res);
    });
}
function introspectAuthn(sdk, args) {
    if (!args || !args.stateToken) {
        var stateToken = sdk.tx.exists._get(STATE_TOKEN_KEY_NAME);
        if (stateToken) {
            args = {
                stateToken: stateToken
            };
        }
        else {
            return Promise.reject(new AuthSdkError_AuthSdkError('No transaction to evaluate'));
        }
    }
    return transactionStep(sdk, args)
        .then(function (res) {
        return sdk.tx.createTransaction(res);
    });
}
function transactionStep(sdk, args) {
    args = addStateToken(sdk, args);
    return post(sdk, sdk.getIssuerOrigin() + '/api/v1/authn/introspect', args, { withCredentials: true });
}
function transactionExists(sdk) {
    return !!sdk.tx.exists._get(STATE_TOKEN_KEY_NAME);
}
function postToTransaction(sdk, url, args, options) {
    options = Object.assign({ withCredentials: true }, options);
    return post(sdk, url, args, options)
        .then(function (res) {
        return sdk.tx.createTransaction(res);
    });
}


//# sourceMappingURL=api.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/util/misc.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */

function isoToUTCString(str) {
    var parts = str.match(/\d+/g), isoTime = Date.UTC(parts[0], parts[1] - 1, parts[2], parts[3], parts[4], parts[5]), isoDate = new Date(isoTime);
    return isoDate.toUTCString();
}
function genRandomString(length) {
    var randomCharset = 'abcdefghijklnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    var random = '';
    for (var c = 0, cl = randomCharset.length; c < length; ++c) {
        random += randomCharset[Math.floor(Math.random() * cl)];
    }
    return random;
}
function delay(ms) {
    return new Promise(function (resolve) {
        setTimeout(resolve, ms);
    });
}
function split2(str, delim) {
    const parts = str.split(delim);
    return [
        parts[0],
        parts.splice(1, parts.length).join(delim),
    ];
}


//# sourceMappingURL=misc.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/errors/AuthPollStopError.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



class AuthPollStopError extends CustomError {
    constructor() {
        const message = 'The poll was stopped by the sdk';
        super(message);
    }
}


//# sourceMappingURL=AuthPollStopError.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/tx/poll.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */











function getPollFn(sdk, res, ref) {
    return function (options) {
        var delay$1;
        var rememberDevice;
        var autoPush;
        var transactionCallBack;
        if (isNumber(options)) {
            delay$1 = options;
        }
        else if (isObject(options)) {
            options = options;
            delay$1 = options.delay;
            rememberDevice = options.rememberDevice;
            autoPush = options.autoPush;
            transactionCallBack = options.transactionCallBack;
        }
        if (!delay$1 && delay$1 !== 0) {
            delay$1 = DEFAULT_POLLING_DELAY;
        }
        var pollLink = getLink(res, 'next', 'poll');
        function pollFn() {
            var opts = {};
            if (typeof autoPush === 'function') {
                try {
                    opts.autoPush = !!autoPush();
                }
                catch (e) {
                    return Promise.reject(new AuthSdkError_AuthSdkError('AutoPush resulted in an error.'));
                }
            }
            else if (autoPush !== undefined && autoPush !== null) {
                opts.autoPush = !!autoPush;
            }
            if (typeof rememberDevice === 'function') {
                try {
                    opts.rememberDevice = !!rememberDevice();
                }
                catch (e) {
                    return Promise.reject(new AuthSdkError_AuthSdkError('RememberDevice resulted in an error.'));
                }
            }
            else if (rememberDevice !== undefined && rememberDevice !== null) {
                opts.rememberDevice = !!rememberDevice;
            }
            var href = pollLink.href + toQueryString(opts);
            return post(sdk, href, getStateToken(res), {
                saveAuthnState: false,
                withCredentials: true
            });
        }
        ref.isPolling = true;
        var retryCount = 0;
        var recursivePoll = function () {
            if (!ref.isPolling) {
                return Promise.reject(new AuthPollStopError());
            }
            return pollFn()
                .then(function (pollRes) {
                retryCount = 0;
                if (pollRes.factorResult && pollRes.factorResult === 'WAITING') {
                    if (!ref.isPolling) {
                        throw new AuthPollStopError();
                    }
                    if (typeof transactionCallBack === 'function') {
                        transactionCallBack(pollRes);
                    }
                    return delay(delay$1).then(recursivePoll);
                }
                else {
                    ref.isPolling = false;
                    return sdk.tx.createTransaction(pollRes);
                }
            })
                .catch(function (err) {
                if (err.xhr &&
                    (err.xhr.status === 0 || err.xhr.status === 429) &&
                    retryCount <= 4) {
                    var delayLength = Math.pow(2, retryCount) * 1000;
                    retryCount++;
                    return delay(delayLength)
                        .then(recursivePoll);
                }
                throw err;
            });
        };
        return recursivePoll()
            .catch(function (err) {
            ref.isPolling = false;
            throw err;
        });
    };
}


//# sourceMappingURL=poll.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/tx/AuthTransaction.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */










class AuthTransaction {
    constructor(sdk, res = null) {
        this.data = undefined;
        this.status = undefined;
        if (res) {
            this.data = res;
            if (this.data.interactionHandle) {
                this.status = res.status;
                return;
            }
            Object.assign(this, flattenEmbedded(sdk, res, res, {}));
            delete this.stateToken;
            if (res.status === 'RECOVERY_CHALLENGE' && !res._links) {
                this.cancel = function () {
                    return Promise.resolve(sdk.tx.createTransaction());
                };
            }
        }
    }
}
function link2fn(sdk, res, obj, link, ref) {
    if (Array.isArray(link)) {
        return function (name, opts) {
            if (!name) {
                throw new AuthSdkError_AuthSdkError('Must provide a link name');
            }
            var lk = find(link, { name: name });
            if (!lk) {
                throw new AuthSdkError_AuthSdkError('No link found for that name');
            }
            return link2fn(sdk, res, obj, lk, ref)(opts);
        };
    }
    else if (link.hints &&
        link.hints.allow &&
        link.hints.allow.length === 1) {
        var method = link.hints.allow[0];
        switch (method) {
            case 'GET':
                return function () {
                    return get(sdk, link.href, { withCredentials: true });
                };
            case 'POST':
                return function (opts) {
                    if (ref && ref.isPolling) {
                        ref.isPolling = false;
                    }
                    var data = addStateToken(res, opts);
                    if (res.status === 'MFA_ENROLL' || res.status === 'FACTOR_ENROLL') {
                        Object.assign(data, {
                            factorType: obj.factorType,
                            provider: obj.provider
                        });
                    }
                    var params = {};
                    var autoPush = data.autoPush;
                    if (autoPush !== undefined) {
                        if (typeof autoPush === 'function') {
                            try {
                                params.autoPush = !!autoPush();
                            }
                            catch (e) {
                                return Promise.reject(new AuthSdkError_AuthSdkError('AutoPush resulted in an error.'));
                            }
                        }
                        else if (autoPush !== null) {
                            params.autoPush = !!autoPush;
                        }
                        data = omit(data, 'autoPush');
                    }
                    var rememberDevice = data.rememberDevice;
                    if (rememberDevice !== undefined) {
                        if (typeof rememberDevice === 'function') {
                            try {
                                params.rememberDevice = !!rememberDevice();
                            }
                            catch (e) {
                                return Promise.reject(new AuthSdkError_AuthSdkError('RememberDevice resulted in an error.'));
                            }
                        }
                        else if (rememberDevice !== null) {
                            params.rememberDevice = !!rememberDevice;
                        }
                        data = omit(data, 'rememberDevice');
                    }
                    else if (data.profile &&
                        data.profile.updatePhone !== undefined) {
                        if (data.profile.updatePhone) {
                            params.updatePhone = true;
                        }
                        data.profile = omit(data.profile, 'updatePhone');
                    }
                    var href = link.href + toQueryString(params);
                    return postToTransaction(sdk, href, data);
                };
        }
    }
}
function links2fns(sdk, res, obj, ref) {
    var fns = {};
    for (var linkName in obj._links) {
        if (!Object.prototype.hasOwnProperty.call(obj._links, linkName)) {
            continue;
        }
        var link = obj._links[linkName];
        if (linkName === 'next') {
            linkName = link.name;
        }
        if (link.type) {
            fns[linkName] = link;
            continue;
        }
        switch (linkName) {
            case 'poll':
                fns.poll = getPollFn(sdk, res, ref);
                break;
            default:
                var fn = link2fn(sdk, res, obj, link, ref);
                if (fn) {
                    fns[linkName] = fn;
                }
        }
    }
    return fns;
}
function flattenEmbedded(sdk, res, obj, ref) {
    obj = obj || res;
    obj = clone(obj);
    if (Array.isArray(obj)) {
        var objArr = [];
        for (var o = 0, ol = obj.length; o < ol; o++) {
            objArr.push(flattenEmbedded(sdk, res, obj[o], ref));
        }
        return objArr;
    }
    var embedded = obj._embedded || {};
    for (var key in embedded) {
        if (!Object.prototype.hasOwnProperty.call(embedded, key)) {
            continue;
        }
        if (isObject(embedded[key]) || Array.isArray(embedded[key])) {
            embedded[key] = flattenEmbedded(sdk, res, embedded[key], ref);
        }
    }
    var fns = links2fns(sdk, res, obj, ref);
    Object.assign(embedded, fns);
    obj = omit(obj, '_embedded', '_links');
    Object.assign(obj, embedded);
    return obj;
}


//# sourceMappingURL=AuthTransaction.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/http/headers.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */

function setRequestHeader(authClient, headerName, headerValue) {
    authClient.options.headers = authClient.options.headers || {};
    authClient.options.headers[headerName] = headerValue;
}


//# sourceMappingURL=headers.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/util/pkce.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */





function dec2hex(dec) {
    return ('0' + dec.toString(16)).substr(-2);
}
function getRandomString(length) {
    var a = new Uint8Array(Math.ceil(length / 2));
    c.getRandomValues(a);
    var str = Array.from(a, dec2hex).join('');
    return str.slice(0, length);
}
function generateVerifier(prefix) {
    var verifier = prefix || '';
    if (verifier.length < MIN_VERIFIER_LENGTH) {
        verifier = verifier + getRandomString(MIN_VERIFIER_LENGTH - verifier.length);
    }
    return encodeURIComponent(verifier).slice(0, MAX_VERIFIER_LENGTH);
}
function computeChallenge(str) {
    var buffer = new TextEncoder().encode(str);
    return c.subtle.digest('SHA-256', buffer).then(function (arrayBuffer) {
        var hash = String.fromCharCode.apply(null, new Uint8Array(arrayBuffer));
        var b64u = stringToBase64Url(hash);
        return b64u;
    });
}
var PKCE = {
    DEFAULT_CODE_CHALLENGE_METHOD: DEFAULT_CODE_CHALLENGE_METHOD,
    generateVerifier,
    computeChallenge
};


//# sourceMappingURL=pkce.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/session.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */





function sessionExists(sdk) {
    return sdk.session.get()
        .then(function (res) {
        if (res.status === 'ACTIVE') {
            return true;
        }
        return false;
    })
        .catch(function () {
        return false;
    });
}
function getSession(sdk) {
    return get(sdk, '/api/v1/sessions/me', { withCredentials: true })
        .then(function (session) {
        var res = omit(session, '_links');
        res.refresh = function () {
            return post(sdk, getLink(session, 'refresh').href, {}, { withCredentials: true });
        };
        res.user = function () {
            return get(sdk, getLink(session, 'user').href, { withCredentials: true });
        };
        return res;
    })
        .catch(function () {
        return { status: 'INACTIVE' };
    });
}
function closeSession(sdk) {
    return request_httpRequest(sdk, {
        url: sdk.getIssuerOrigin() + '/api/v1/sessions/me',
        method: 'DELETE',
        withCredentials: true
    });
}
function refreshSession(sdk) {
    return post(sdk, '/api/v1/sessions/me/lifecycle/refresh', {}, { withCredentials: true });
}
function setCookieAndRedirect(sdk, sessionToken, redirectUrl) {
    redirectUrl = redirectUrl || window.location.href;
    window.location.assign(sdk.getIssuerOrigin() + '/login/sessionCookieRedirect' +
        toQueryString({
            checkAccountSetupComplete: true,
            token: sessionToken,
            redirectUrl: redirectUrl
        }));
}


//# sourceMappingURL=session.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/util/oauth.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */





function generateState() {
    return genRandomString(64);
}
function generateNonce() {
    return genRandomString(64);
}
function getIssuer(sdk, options = {}) {
    const issuer = removeTrailingSlash(options.issuer) || sdk.options.issuer;
    return issuer;
}
function getOAuthBaseUrl(sdk, options = {}) {
    const issuer = getIssuer(sdk, options);
    const baseUrl = issuer.indexOf('/oauth2') > 0 ? issuer : issuer + '/oauth2';
    return baseUrl;
}
function getOAuthDomain(sdk, options = {}) {
    const issuer = getIssuer(sdk, options);
    const domain = issuer.split('/oauth2')[0];
    return domain;
}
function getOAuthUrls(sdk, options) {
    if (arguments.length > 2) {
        throw new AuthSdkError_AuthSdkError('As of version 3.0, "getOAuthUrls" takes only a single set of options');
    }
    options = options || {};
    var authorizeUrl = removeTrailingSlash(options.authorizeUrl) || sdk.options.authorizeUrl;
    var issuer = getIssuer(sdk, options);
    var userinfoUrl = removeTrailingSlash(options.userinfoUrl) || sdk.options.userinfoUrl;
    var tokenUrl = removeTrailingSlash(options.tokenUrl) || sdk.options.tokenUrl;
    var logoutUrl = removeTrailingSlash(options.logoutUrl) || sdk.options.logoutUrl;
    var revokeUrl = removeTrailingSlash(options.revokeUrl) || sdk.options.revokeUrl;
    var baseUrl = getOAuthBaseUrl(sdk, options);
    authorizeUrl = authorizeUrl || baseUrl + '/v1/authorize';
    userinfoUrl = userinfoUrl || baseUrl + '/v1/userinfo';
    tokenUrl = tokenUrl || baseUrl + '/v1/token';
    revokeUrl = revokeUrl || baseUrl + '/v1/revoke';
    logoutUrl = logoutUrl || baseUrl + '/v1/logout';
    return {
        issuer: issuer,
        authorizeUrl: authorizeUrl,
        userinfoUrl: userinfoUrl,
        tokenUrl: tokenUrl,
        revokeUrl: revokeUrl,
        logoutUrl: logoutUrl
    };
}


//# sourceMappingURL=oauth.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/features.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



const isWindowsPhone = /windows phone|iemobile|wpdesktop/i;
function isBrowser() {
    return typeof document !== 'undefined' && typeof window !== 'undefined';
}
function isIE11OrLess() {
    if (!isBrowser()) {
        return false;
    }
    const documentMode = document.documentMode;
    return !!documentMode && documentMode <= 11;
}
function getUserAgent() {
    return navigator.userAgent;
}
function isFingerprintSupported() {
    const agent = getUserAgent();
    return agent && !isWindowsPhone.test(agent);
}
function isPopupPostMessageSupported() {
    if (!isBrowser()) {
        return false;
    }
    const documentMode = document.documentMode;
    var isIE8or9 = documentMode && documentMode < 10;
    if (typeof window.postMessage !== 'undefined' && !isIE8or9) {
        return true;
    }
    return false;
}
function isTokenVerifySupported() {
    return typeof c !== 'undefined'
        && c !== null
        && typeof c.subtle !== 'undefined'
        && typeof Uint8Array !== 'undefined';
}
function hasTextEncoder() {
    return typeof TextEncoder !== 'undefined';
}
function isPKCESupported() {
    return isTokenVerifySupported() && hasTextEncoder();
}
function isHTTPS() {
    if (!isBrowser()) {
        return false;
    }
    return window.location.protocol === 'https:';
}
function isLocalhost() {
    return isBrowser() && window.location.hostname === 'localhost';
}


//# sourceMappingURL=features.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/errors/index.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */






function errors_isAuthApiError(obj) {
    return (obj instanceof AuthApiError_AuthApiError);
}
function isOAuthError(obj) {
    return (obj instanceof OAuthError);
}


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/util/errors.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



function isInteractionRequiredError(error) {
    if (error.name !== 'OAuthError') {
        return false;
    }
    const oauthError = error;
    return (oauthError.errorCode === 'interaction_required');
}
function isAuthorizationCodeError(sdk, error) {
    if (error.name !== 'AuthApiError') {
        return false;
    }
    const authApiError = error;
    const errorResponse = authApiError.xhr;
    const responseJSON = errorResponse === null || errorResponse === void 0 ? void 0 : errorResponse.responseJSON;
    return sdk.options.pkce && ((responseJSON === null || responseJSON === void 0 ? void 0 : responseJSON.error) === 'invalid_grant');
}
function isRefreshTokenInvalidError(error) {
    return isOAuthError(error) &&
        error.errorCode === 'invalid_grant' &&
        error.errorSummary === 'The refresh token is invalid or expired.';
}


//# sourceMappingURL=errors.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/util/loginRedirect.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */

function hasTokensInHash(hash) {
    return /((id|access)_token=)/i.test(hash);
}
function hasAuthorizationCode(hashOrSearch) {
    return /(code=)/i.test(hashOrSearch);
}
function hasInteractionCode(hashOrSearch) {
    return /(interaction_code=)/i.test(hashOrSearch);
}
function hasErrorInUrl(hashOrSearch) {
    return /(error=)/i.test(hashOrSearch) || /(error_description)/i.test(hashOrSearch);
}
function isRedirectUri(uri, sdk) {
    var authParams = sdk.options;
    if (!uri || !authParams.redirectUri) {
        return false;
    }
    return uri.indexOf(authParams.redirectUri) === 0;
}
function isCodeFlow(options) {
    return options.pkce || options.responseType === 'code' || options.responseMode === 'query';
}
function getHashOrSearch(options) {
    var codeFlow = isCodeFlow(options);
    var useQuery = codeFlow && options.responseMode !== 'fragment';
    return useQuery ? window.location.search : window.location.hash;
}
function isLoginRedirect(sdk) {
    if (!isRedirectUri(window.location.href, sdk)) {
        return false;
    }
    var codeFlow = isCodeFlow(sdk.options);
    var hashOrSearch = getHashOrSearch(sdk.options);
    if (hasErrorInUrl(hashOrSearch)) {
        return true;
    }
    if (codeFlow) {
        var hasCode = hasAuthorizationCode(hashOrSearch) || hasInteractionCode(hashOrSearch);
        return hasCode;
    }
    return hasTokensInHash(window.location.hash);
}
function isInteractionRequired(sdk, hashOrSearch) {
    if (!hashOrSearch) {
        if (!isLoginRedirect(sdk)) {
            return false;
        }
        hashOrSearch = getHashOrSearch(sdk.options);
    }
    return /(error=interaction_required)/i.test(hashOrSearch);
}


//# sourceMappingURL=loginRedirect.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/endpoints/well-known.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */





function getWellKnown(sdk, issuer) {
    var authServerUri = (issuer || sdk.options.issuer);
    return get(sdk, authServerUri + '/.well-known/openid-configuration', {
        cacheResponse: true
    });
}
function getKey(sdk, issuer, kid) {
    var httpCache = sdk.storageManager.getHttpCache(sdk.options.cookies);
    return getWellKnown(sdk, issuer)
        .then(function (wellKnown) {
        var jwksUri = wellKnown['jwks_uri'];
        var cacheContents = httpCache.getStorage();
        var cachedResponse = cacheContents[jwksUri];
        if (cachedResponse && Date.now() / 1000 < cachedResponse.expiresAt) {
            var cachedKey = find(cachedResponse.response.keys, {
                kid: kid
            });
            if (cachedKey) {
                return cachedKey;
            }
        }
        httpCache.clearStorage(jwksUri);
        return get(sdk, jwksUri, {
            cacheResponse: true
        })
            .then(function (res) {
            var key = find(res.keys, {
                kid: kid
            });
            if (key) {
                return key;
            }
            throw new AuthSdkError_AuthSdkError('The key id, ' + kid + ', was not found in the server\'s keys');
        });
    });
}


//# sourceMappingURL=well-known.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/util/defaultTokenParams.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */





function getDefaultTokenParams(sdk) {
    const { pkce, clientId, redirectUri, responseType, responseMode, scopes, state, ignoreSignature } = sdk.options;
    const defaultRedirectUri = isBrowser() ? window.location.href : undefined;
    return removeNils({
        pkce,
        clientId,
        redirectUri: redirectUri || defaultRedirectUri,
        responseType: responseType || ['token', 'id_token'],
        responseMode,
        state: state || generateState(),
        nonce: generateNonce(),
        scopes: scopes || ['openid', 'email'],
        ignoreSignature
    });
}


//# sourceMappingURL=defaultTokenParams.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/util/prepareTokenParams.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */







function assertPKCESupport(sdk) {
    if (!sdk.features.isPKCESupported()) {
        var errorMessage = 'PKCE requires a modern browser with encryption support running in a secure context.';
        if (!sdk.features.isHTTPS()) {
            errorMessage += '\nThe current page is not being served with HTTPS protocol. PKCE requires secure HTTPS protocol.';
        }
        if (!sdk.features.hasTextEncoder()) {
            errorMessage += '\n"TextEncoder" is not defined. To use PKCE, you may need to include a polyfill/shim for this browser.';
        }
        throw new AuthSdkError_AuthSdkError(errorMessage);
    }
}
async function validateCodeChallengeMethod(sdk, codeChallengeMethod) {
    codeChallengeMethod = codeChallengeMethod || sdk.options.codeChallengeMethod || DEFAULT_CODE_CHALLENGE_METHOD;
    const wellKnownResponse = await getWellKnown(sdk);
    var methods = wellKnownResponse['code_challenge_methods_supported'] || [];
    if (methods.indexOf(codeChallengeMethod) === -1) {
        throw new AuthSdkError_AuthSdkError('Invalid code_challenge_method');
    }
    return codeChallengeMethod;
}
async function preparePKCE(sdk, tokenParams) {
    let { codeVerifier, codeChallenge, codeChallengeMethod } = tokenParams;
    codeChallenge = codeChallenge || sdk.options.codeChallenge;
    if (!codeChallenge) {
        assertPKCESupport(sdk);
        codeVerifier = codeVerifier || PKCE.generateVerifier();
        codeChallenge = await PKCE.computeChallenge(codeVerifier);
    }
    codeChallengeMethod = await validateCodeChallengeMethod(sdk, codeChallengeMethod);
    tokenParams = Object.assign(Object.assign({}, tokenParams), { responseType: 'code',
        codeVerifier,
        codeChallenge,
        codeChallengeMethod });
    return tokenParams;
}
async function prepareTokenParams(sdk, tokenParams = {}) {
    const defaults = getDefaultTokenParams(sdk);
    tokenParams = Object.assign(Object.assign({}, defaults), tokenParams);
    if (tokenParams.pkce === false) {
        return tokenParams;
    }
    return preparePKCE(sdk, tokenParams);
}


//# sourceMappingURL=prepareTokenParams.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/types/api.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */

var IdxStatus;
(function (IdxStatus) {
    IdxStatus["SUCCESS"] = "SUCCESS";
    IdxStatus["PENDING"] = "PENDING";
    IdxStatus["FAILURE"] = "FAILURE";
    IdxStatus["TERMINAL"] = "TERMINAL";
    IdxStatus["CANCELED"] = "CANCELED";
})(IdxStatus || (IdxStatus = {}));
var AuthenticatorKey;
(function (AuthenticatorKey) {
    AuthenticatorKey["OKTA_PASSWORD"] = "okta_password";
    AuthenticatorKey["OKTA_EMAIL"] = "okta_email";
    AuthenticatorKey["PHONE_NUMBER"] = "phone_number";
    AuthenticatorKey["GOOGLE_AUTHENTICATOR"] = "google_otp";
    AuthenticatorKey["SECURITY_QUESTION"] = "security_question";
    AuthenticatorKey["OKTA_VERIFY"] = "okta_verify";
    AuthenticatorKey["WEBAUTHN"] = "webauthn";
})(AuthenticatorKey || (AuthenticatorKey = {}));
var IdxFeature;
(function (IdxFeature) {
    IdxFeature["PASSWORD_RECOVERY"] = "recover-password";
    IdxFeature["REGISTRATION"] = "enroll-profile";
    IdxFeature["SOCIAL_IDP"] = "redirect-idp";
    IdxFeature["ACCOUNT_UNLOCK"] = "unlock-account";
})(IdxFeature || (IdxFeature = {}));
function isAuthenticator(obj) {
    return obj && (obj.key || obj.id);
}


//# sourceMappingURL=api.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/myaccount/types.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */

var EmailRole;
(function (EmailRole) {
    EmailRole["PRIMARY"] = "PRIMARY";
    EmailRole["SECONDARY"] = "SECONDARY";
})(EmailRole || (EmailRole = {}));
var Status;
(function (Status) {
    Status["VERIFIED"] = "VERIFIED";
    Status["UNVERIFIED"] = "UNVERIFIED";
})(Status || (Status = {}));


//# sourceMappingURL=types.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/decodeToken.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */




function decodeToken(token) {
    var jwt = token.split('.');
    var decodedToken;
    try {
        decodedToken = {
            header: JSON.parse(base64UrlToString(jwt[0])),
            payload: JSON.parse(base64UrlToString(jwt[1])),
            signature: jwt[2]
        };
    }
    catch (e) {
        throw new AuthSdkError_AuthSdkError('Malformed token');
    }
    return decodedToken;
}


//# sourceMappingURL=decodeToken.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/revokeToken.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */







async function revokeToken(sdk, token) {
    let accessToken = '';
    let refreshToken = '';
    if (token) {
        accessToken = token.accessToken;
        refreshToken = token.refreshToken;
    }
    if (!accessToken && !refreshToken) {
        throw new AuthSdkError_AuthSdkError('A valid access or refresh token object is required');
    }
    var clientId = sdk.options.clientId;
    var clientSecret = sdk.options.clientSecret;
    if (!clientId) {
        throw new AuthSdkError_AuthSdkError('A clientId must be specified in the OktaAuth constructor to revoke a token');
    }
    var revokeUrl = getOAuthUrls(sdk).revokeUrl;
    var args = toQueryString({
        token_type_hint: refreshToken ? 'refresh_token' : 'access_token',
        token: refreshToken || accessToken,
    }).slice(1);
    var creds = clientSecret ? b(`${clientId}:${clientSecret}`) : b(clientId);
    return post(sdk, revokeUrl, args, {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Authorization': 'Basic ' + creds
        }
    });
}


//# sourceMappingURL=revokeToken.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/types/Token.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */

function isToken(obj) {
    if (obj &&
        (obj.accessToken || obj.idToken || obj.refreshToken) &&
        Array.isArray(obj.scopes)) {
        return true;
    }
    return false;
}
function isAccessToken(obj) {
    return obj && obj.accessToken;
}
function isIDToken(obj) {
    return obj && obj.idToken;
}
function isRefreshToken(obj) {
    return obj && obj.refreshToken;
}


//# sourceMappingURL=Token.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/util/browser.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



function addListener(eventTarget, name, fn) {
    if (eventTarget.addEventListener) {
        eventTarget.addEventListener(name, fn);
    }
    else {
        eventTarget.attachEvent('on' + name, fn);
    }
}
function removeListener(eventTarget, name, fn) {
    if (eventTarget.removeEventListener) {
        eventTarget.removeEventListener(name, fn);
    }
    else {
        eventTarget.detachEvent('on' + name, fn);
    }
}
function loadFrame(src) {
    var iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    iframe.src = src;
    return document.body.appendChild(iframe);
}
function loadPopup(src, options) {
    var title = options.popupTitle || 'External Identity Provider User Authentication';
    var appearance = 'toolbar=no, scrollbars=yes, resizable=yes, ' +
        'top=100, left=500, width=600, height=600';
    return window.open(src, title, appearance);
}
function addPostMessageListener(sdk, timeout, state) {
    var responseHandler;
    var timeoutId;
    var msgReceivedOrTimeout = new Promise(function (resolve, reject) {
        responseHandler = function responseHandler(e) {
            if (!e.data || e.data.state !== state) {
                return;
            }
            if (e.origin !== sdk.getIssuerOrigin()) {
                return reject(new AuthSdkError_AuthSdkError('The request does not match client configuration'));
            }
            resolve(e.data);
        };
        addListener(window, 'message', responseHandler);
        timeoutId = setTimeout(function () {
            reject(new AuthSdkError_AuthSdkError('OAuth flow timed out'));
        }, timeout || 120000);
    });
    return msgReceivedOrTimeout
        .finally(function () {
        clearTimeout(timeoutId);
        removeListener(window, 'message', responseHandler);
    });
}


//# sourceMappingURL=browser.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/endpoints/authorize.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */






function convertTokenParamsToOAuthParams(tokenParams) {
    if (!tokenParams.clientId) {
        throw new AuthSdkError_AuthSdkError('A clientId must be specified in the OktaAuth constructor to get a token');
    }
    if (isString(tokenParams.responseType) && tokenParams.responseType.indexOf(' ') !== -1) {
        throw new AuthSdkError_AuthSdkError('Multiple OAuth responseTypes must be defined as an array');
    }
    var oauthParams = {
        'client_id': tokenParams.clientId,
        'code_challenge': tokenParams.codeChallenge,
        'code_challenge_method': tokenParams.codeChallengeMethod,
        'display': tokenParams.display,
        'idp': tokenParams.idp,
        'idp_scope': tokenParams.idpScope,
        'login_hint': tokenParams.loginHint,
        'max_age': tokenParams.maxAge,
        'nonce': tokenParams.nonce,
        'prompt': tokenParams.prompt,
        'redirect_uri': tokenParams.redirectUri,
        'response_mode': tokenParams.responseMode,
        'response_type': tokenParams.responseType,
        'sessionToken': tokenParams.sessionToken,
        'state': tokenParams.state,
    };
    oauthParams = removeNils(oauthParams);
    ['idp_scope', 'response_type'].forEach(function (mayBeArray) {
        if (Array.isArray(oauthParams[mayBeArray])) {
            oauthParams[mayBeArray] = oauthParams[mayBeArray].join(' ');
        }
    });
    if (tokenParams.responseType.indexOf('id_token') !== -1 &&
        tokenParams.scopes.indexOf('openid') === -1) {
        throw new AuthSdkError_AuthSdkError('openid scope must be specified in the scopes argument when requesting an id_token');
    }
    else {
        oauthParams.scope = tokenParams.scopes.join(' ');
    }
    return oauthParams;
}
function buildAuthorizeParams(tokenParams) {
    var oauthQueryParams = convertTokenParamsToOAuthParams(tokenParams);
    return toQueryString(Object.assign(Object.assign({}, oauthQueryParams), (tokenParams.extraParams && Object.assign({}, tokenParams.extraParams))));
}


//# sourceMappingURL=authorize.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/util/validateClaims.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



function validateClaims(sdk, claims, validationParams) {
    var aud = validationParams.clientId;
    var iss = validationParams.issuer;
    var nonce = validationParams.nonce;
    if (!claims || !iss || !aud) {
        throw new AuthSdkError_AuthSdkError('The jwt, iss, and aud arguments are all required');
    }
    if (nonce && claims.nonce !== nonce) {
        throw new AuthSdkError_AuthSdkError('OAuth flow response nonce doesn\'t match request nonce');
    }
    var now = Math.floor(Date.now() / 1000);
    if (claims.iss !== iss) {
        throw new AuthSdkError_AuthSdkError('The issuer [' + claims.iss + '] ' +
            'does not match [' + iss + ']');
    }
    if (claims.aud !== aud) {
        throw new AuthSdkError_AuthSdkError('The audience [' + claims.aud + '] ' +
            'does not match [' + aud + ']');
    }
    if (claims.iat > claims.exp) {
        throw new AuthSdkError_AuthSdkError('The JWT expired before it was issued');
    }
    if (!sdk.options.ignoreLifetime) {
        if ((now - sdk.options.maxClockSkew) > claims.exp) {
            throw new AuthSdkError_AuthSdkError('The JWT expired and is no longer valid');
        }
        if (claims.iat > (now + sdk.options.maxClockSkew)) {
            throw new AuthSdkError_AuthSdkError('The JWT was issued in the future');
        }
    }
}


//# sourceMappingURL=validateClaims.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/verifyToken.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */










async function verifyToken_verifyToken(sdk, token, validationParams) {
    if (!token || !token.idToken) {
        throw new AuthSdkError_AuthSdkError('Only idTokens may be verified');
    }
    var jwt = decodeToken(token.idToken);
    const configuredIssuer = (validationParams === null || validationParams === void 0 ? void 0 : validationParams.issuer) || sdk.options.issuer;
    const { issuer } = await getWellKnown(sdk, configuredIssuer);
    var validationOptions = Object.assign({
        clientId: sdk.options.clientId,
        ignoreSignature: sdk.options.ignoreSignature
    }, validationParams, {
        issuer
    });
    validateClaims(sdk, jwt.payload, validationOptions);
    if (validationOptions.ignoreSignature == true || !sdk.features.isTokenVerifySupported()) {
        return token;
    }
    const key = await getKey(sdk, token.issuer, jwt.header.kid);
    const valid = await verifyToken(token.idToken, key);
    if (!valid) {
        throw new AuthSdkError_AuthSdkError('The token signature is not valid');
    }
    if (validationParams && validationParams.accessToken && token.claims.at_hash) {
        const hash = await getOidcHash(validationParams.accessToken);
        if (hash !== token.claims.at_hash) {
            throw new AuthSdkError_AuthSdkError('Token hash verification failed');
        }
    }
    return token;
}


//# sourceMappingURL=verifyToken.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/handleOAuthResponse.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */










function validateResponse(res, oauthParams) {
    if (res['error'] && res['error_description']) {
        throw new OAuthError(res['error'], res['error_description']);
    }
    if (res.state !== oauthParams.state) {
        throw new AuthSdkError_AuthSdkError('OAuth flow response state doesn\'t match request state');
    }
}
async function handleOAuthResponse(sdk, tokenParams, res, urls) {
    var pkce = sdk.options.pkce !== false;
    if (pkce && (res.code || res.interaction_code)) {
        return sdk.token.exchangeCodeForTokens(Object.assign({}, tokenParams, {
            authorizationCode: res.code,
            interactionCode: res.interaction_code
        }), urls);
    }
    tokenParams = tokenParams || getDefaultTokenParams(sdk);
    urls = urls || getOAuthUrls(sdk, tokenParams);
    var responseType = tokenParams.responseType || [];
    if (!Array.isArray(responseType)) {
        responseType = [responseType];
    }
    var scopes;
    if (res.scope) {
        scopes = res.scope.split(' ');
    }
    else {
        scopes = clone(tokenParams.scopes);
    }
    var clientId = tokenParams.clientId || sdk.options.clientId;
    validateResponse(res, tokenParams);
    var tokenDict = {};
    var expiresIn = res.expires_in;
    var tokenType = res.token_type;
    var accessToken = res.access_token;
    var idToken = res.id_token;
    var refreshToken = res.refresh_token;
    var now = Math.floor(Date.now() / 1000);
    if (accessToken) {
        var accessJwt = sdk.token.decode(accessToken);
        tokenDict.accessToken = {
            accessToken: accessToken,
            claims: accessJwt.payload,
            expiresAt: Number(expiresIn) + now,
            tokenType: tokenType,
            scopes: scopes,
            authorizeUrl: urls.authorizeUrl,
            userinfoUrl: urls.userinfoUrl
        };
    }
    if (refreshToken) {
        tokenDict.refreshToken = {
            refreshToken: refreshToken,
            expiresAt: Number(expiresIn) + now,
            scopes: scopes,
            tokenUrl: urls.tokenUrl,
            authorizeUrl: urls.authorizeUrl,
            issuer: urls.issuer,
        };
    }
    if (idToken) {
        var idJwt = sdk.token.decode(idToken);
        var idTokenObj = {
            idToken: idToken,
            claims: idJwt.payload,
            expiresAt: idJwt.payload.exp - idJwt.payload.iat + now,
            scopes: scopes,
            authorizeUrl: urls.authorizeUrl,
            issuer: urls.issuer,
            clientId: clientId
        };
        var validationParams = {
            clientId: clientId,
            issuer: urls.issuer,
            nonce: tokenParams.nonce,
            accessToken: accessToken
        };
        if (tokenParams.ignoreSignature !== undefined) {
            validationParams.ignoreSignature = tokenParams.ignoreSignature;
        }
        await verifyToken_verifyToken(sdk, idTokenObj, validationParams);
        tokenDict.idToken = idTokenObj;
    }
    if (responseType.indexOf('token') !== -1 && !tokenDict.accessToken) {
        throw new AuthSdkError_AuthSdkError('Unable to parse OAuth flow response: response type "token" was requested but "access_token" was not returned.');
    }
    if (responseType.indexOf('id_token') !== -1 && !tokenDict.idToken) {
        throw new AuthSdkError_AuthSdkError('Unable to parse OAuth flow response: response type "id_token" was requested but "id_token" was not returned.');
    }
    return {
        tokens: tokenDict,
        state: res.state,
        code: res.code
    };
}


//# sourceMappingURL=handleOAuthResponse.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/getToken.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */










function getToken(sdk, options) {
    if (arguments.length > 2) {
        return Promise.reject(new AuthSdkError_AuthSdkError('As of version 3.0, "getToken" takes only a single set of options'));
    }
    options = options || {};
    const popupWindow = options.popupWindow;
    options.popupWindow = undefined;
    return prepareTokenParams(sdk, options)
        .then(function (tokenParams) {
        var sessionTokenOverrides = {
            prompt: 'none',
            responseMode: 'okta_post_message',
            display: null
        };
        var idpOverrides = {
            display: 'popup'
        };
        if (options.sessionToken) {
            Object.assign(tokenParams, sessionTokenOverrides);
        }
        else if (options.idp) {
            Object.assign(tokenParams, idpOverrides);
        }
        var requestUrl, endpoint, urls;
        urls = getOAuthUrls(sdk, tokenParams);
        endpoint = options.codeVerifier ? urls.tokenUrl : urls.authorizeUrl;
        requestUrl = endpoint + buildAuthorizeParams(tokenParams);
        var flowType;
        if (tokenParams.sessionToken || tokenParams.display === null) {
            flowType = 'IFRAME';
        }
        else if (tokenParams.display === 'popup') {
            flowType = 'POPUP';
        }
        else {
            flowType = 'IMPLICIT';
        }
        switch (flowType) {
            case 'IFRAME':
                var iframePromise = addPostMessageListener(sdk, options.timeout, tokenParams.state);
                var iframeEl = loadFrame(requestUrl);
                return iframePromise
                    .then(function (res) {
                    return handleOAuthResponse(sdk, tokenParams, res, urls);
                })
                    .finally(function () {
                    var _a;
                    if (document.body.contains(iframeEl)) {
                        (_a = iframeEl.parentElement) === null || _a === void 0 ? void 0 : _a.removeChild(iframeEl);
                    }
                });
            case 'POPUP':
                var oauthPromise;
                if (tokenParams.responseMode === 'okta_post_message') {
                    if (!sdk.features.isPopupPostMessageSupported()) {
                        throw new AuthSdkError_AuthSdkError('This browser doesn\'t have full postMessage support');
                    }
                    oauthPromise = addPostMessageListener(sdk, options.timeout, tokenParams.state);
                }
                if (popupWindow) {
                    popupWindow.location.assign(requestUrl);
                }
                var popupPromise = new Promise(function (resolve, reject) {
                    var closePoller = setInterval(function () {
                        if (!popupWindow || popupWindow.closed) {
                            clearInterval(closePoller);
                            reject(new AuthSdkError_AuthSdkError('Unable to parse OAuth flow response'));
                        }
                    }, 100);
                    oauthPromise
                        .then(function (res) {
                        clearInterval(closePoller);
                        resolve(res);
                    })
                        .catch(function (err) {
                        clearInterval(closePoller);
                        reject(err);
                    });
                });
                return popupPromise
                    .then(function (res) {
                    return handleOAuthResponse(sdk, tokenParams, res, urls);
                })
                    .finally(function () {
                    if (popupWindow && !popupWindow.closed) {
                        popupWindow.close();
                    }
                });
            default:
                throw new AuthSdkError_AuthSdkError('The full page redirect flow is not supported');
        }
    });
}


//# sourceMappingURL=getToken.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/getWithoutPrompt.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */





function getWithoutPrompt(sdk, options) {
    if (arguments.length > 2) {
        return Promise.reject(new AuthSdkError_AuthSdkError('As of version 3.0, "getWithoutPrompt" takes only a single set of options'));
    }
    options = clone(options) || {};
    Object.assign(options, {
        prompt: 'none',
        responseMode: 'okta_post_message',
        display: null
    });
    return getToken(sdk, options);
}


//# sourceMappingURL=getWithoutPrompt.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/util/refreshToken.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



function isSameRefreshToken(a, b) {
    return (a.refreshToken === b.refreshToken);
}
function isRefreshTokenError(err) {
    if (!isAuthApiError(err)) {
        return false;
    }
    if (!err.xhr || !err.xhr.responseJSON) {
        return false;
    }
    const { responseJSON } = err.xhr;
    if (responseJSON.error === 'invalid_grant') {
        return true;
    }
    return false;
}


//# sourceMappingURL=refreshToken.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/endpoints/token.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */






function validateOptions(options) {
    if (!options.clientId) {
        throw new AuthSdkError_AuthSdkError('A clientId must be specified in the OktaAuth constructor to get a token');
    }
    if (!options.redirectUri) {
        throw new AuthSdkError_AuthSdkError('The redirectUri passed to /authorize must also be passed to /token');
    }
    if (!options.authorizationCode && !options.interactionCode) {
        throw new AuthSdkError_AuthSdkError('An authorization code (returned from /authorize) must be passed to /token');
    }
    if (!options.codeVerifier) {
        throw new AuthSdkError_AuthSdkError('The "codeVerifier" (generated and saved by your app) must be passed to /token');
    }
}
function getPostData(sdk, options) {
    var params = removeNils({
        'client_id': options.clientId,
        'redirect_uri': options.redirectUri,
        'grant_type': options.interactionCode ? 'interaction_code' : 'authorization_code',
        'code_verifier': options.codeVerifier
    });
    if (options.interactionCode) {
        params['interaction_code'] = options.interactionCode;
    }
    else if (options.authorizationCode) {
        params.code = options.authorizationCode;
    }
    const { clientSecret } = sdk.options;
    if (clientSecret) {
        params['client_secret'] = clientSecret;
    }
    return toQueryString(params).slice(1);
}
function postToTokenEndpoint(sdk, options, urls) {
    validateOptions(options);
    var data = getPostData(sdk, options);
    const headers = {
        'Content-Type': 'application/x-www-form-urlencoded'
    };
    return request_httpRequest(sdk, {
        url: urls.tokenUrl,
        method: 'POST',
        args: data,
        headers
    });
}
function postRefreshToken(sdk, options, refreshToken) {
    return request_httpRequest(sdk, {
        url: refreshToken.tokenUrl,
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        args: Object.entries({
            client_id: options.clientId,
            grant_type: 'refresh_token',
            scope: refreshToken.scopes.join(' '),
            refresh_token: refreshToken.refreshToken,
        }).map(function ([name, value]) {
            return name + '=' + encodeURIComponent(value);
        }).join('&'),
    });
}


//# sourceMappingURL=token.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/renewTokensWithRefresh.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */








async function renewTokensWithRefresh(sdk, tokenParams, refreshTokenObject) {
    const { clientId } = sdk.options;
    if (!clientId) {
        throw new AuthSdkError_AuthSdkError('A clientId must be specified in the OktaAuth constructor to renew tokens');
    }
    try {
        const renewTokenParams = Object.assign({}, tokenParams, {
            clientId,
        });
        const tokenResponse = await postRefreshToken(sdk, renewTokenParams, refreshTokenObject);
        const urls = getOAuthUrls(sdk, tokenParams);
        const { tokens } = await handleOAuthResponse(sdk, renewTokenParams, tokenResponse, urls);
        const { refreshToken } = tokens;
        if (refreshToken && !isSameRefreshToken(refreshToken, refreshTokenObject)) {
            sdk.tokenManager.updateRefreshToken(refreshToken);
        }
        return tokens;
    }
    catch (err) {
        if (isRefreshTokenInvalidError(err)) {
            sdk.tokenManager.removeRefreshToken();
        }
        throw err;
    }
}


//# sourceMappingURL=renewTokensWithRefresh.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/renewToken.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */








function throwInvalidTokenError() {
    throw new AuthSdkError_AuthSdkError('Renew must be passed a token with an array of scopes and an accessToken or idToken');
}
function getSingleToken(originalToken, tokens) {
    if (isIDToken(originalToken)) {
        return tokens.idToken;
    }
    if (isAccessToken(originalToken)) {
        return tokens.accessToken;
    }
    throwInvalidTokenError();
}
async function renewToken(sdk, token) {
    if (!isIDToken(token) && !isAccessToken(token)) {
        throwInvalidTokenError();
    }
    let tokens = sdk.tokenManager.getTokensSync();
    if (tokens.refreshToken) {
        tokens = await renewTokensWithRefresh(sdk, {
            scopes: token.scopes,
        }, tokens.refreshToken);
        return getSingleToken(token, tokens);
    }
    var responseType;
    if (sdk.options.pkce) {
        responseType = 'code';
    }
    else if (isAccessToken(token)) {
        responseType = 'token';
    }
    else {
        responseType = 'id_token';
    }
    const { scopes, authorizeUrl, userinfoUrl, issuer } = token;
    return getWithoutPrompt(sdk, {
        responseType,
        scopes,
        authorizeUrl,
        userinfoUrl,
        issuer
    })
        .then(function (res) {
        return getSingleToken(token, res.tokens);
    });
}


//# sourceMappingURL=renewToken.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/renewTokens.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */








async function renewTokens(sdk, options) {
    const tokens = sdk.tokenManager.getTokensSync();
    if (tokens.refreshToken) {
        return renewTokensWithRefresh(sdk, options || {}, tokens.refreshToken);
    }
    if (!tokens.accessToken && !tokens.idToken) {
        throw new AuthSdkError_AuthSdkError('renewTokens() was called but there is no existing token');
    }
    const accessToken = tokens.accessToken || {};
    const idToken = tokens.idToken || {};
    const scopes = accessToken.scopes || idToken.scopes;
    if (!scopes) {
        throw new AuthSdkError_AuthSdkError('renewTokens: invalid tokens: could not read scopes');
    }
    const authorizeUrl = accessToken.authorizeUrl || idToken.authorizeUrl;
    if (!authorizeUrl) {
        throw new AuthSdkError_AuthSdkError('renewTokens: invalid tokens: could not read authorizeUrl');
    }
    const userinfoUrl = accessToken.userinfoUrl || sdk.options.userinfoUrl;
    const issuer = idToken.issuer || sdk.options.issuer;
    options = Object.assign({
        scopes,
        authorizeUrl,
        userinfoUrl,
        issuer
    }, options);
    if (sdk.options.pkce) {
        options.responseType = 'code';
    }
    else {
        const { responseType } = getDefaultTokenParams(sdk);
        options.responseType = responseType;
    }
    return getWithoutPrompt(sdk, options)
        .then(res => res.tokens);
}


//# sourceMappingURL=renewTokens.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/getUserInfo.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */









async function getUserInfo(sdk, accessTokenObject, idTokenObject) {
    if (!accessTokenObject) {
        accessTokenObject = (await sdk.tokenManager.getTokens()).accessToken;
    }
    if (!idTokenObject) {
        idTokenObject = (await sdk.tokenManager.getTokens()).idToken;
    }
    if (!accessTokenObject || !isAccessToken(accessTokenObject)) {
        return Promise.reject(new AuthSdkError_AuthSdkError('getUserInfo requires an access token object'));
    }
    if (!idTokenObject || !isIDToken(idTokenObject)) {
        return Promise.reject(new AuthSdkError_AuthSdkError('getUserInfo requires an ID token object'));
    }
    return request_httpRequest(sdk, {
        url: accessTokenObject.userinfoUrl,
        method: 'GET',
        accessToken: accessTokenObject.accessToken
    })
        .then(userInfo => {
        if (userInfo.sub === idTokenObject.claims.sub) {
            return userInfo;
        }
        return Promise.reject(new AuthSdkError_AuthSdkError('getUserInfo request was rejected due to token mismatch'));
    })
        .catch(function (err) {
        if (err.xhr && (err.xhr.status === 401 || err.xhr.status === 403)) {
            var authenticateHeader;
            if (err.xhr.headers && isFunction(err.xhr.headers.get) && err.xhr.headers.get('WWW-Authenticate')) {
                authenticateHeader = err.xhr.headers.get('WWW-Authenticate');
            }
            else if (isFunction(err.xhr.getResponseHeader)) {
                authenticateHeader = err.xhr.getResponseHeader('WWW-Authenticate');
            }
            if (authenticateHeader) {
                var errorMatches = authenticateHeader.match(/error="(.*?)"/) || [];
                var errorDescriptionMatches = authenticateHeader.match(/error_description="(.*?)"/) || [];
                var error = errorMatches[1];
                var errorDescription = errorDescriptionMatches[1];
                if (error && errorDescription) {
                    err = new OAuthError(error, errorDescription);
                }
            }
        }
        throw err;
    });
}


//# sourceMappingURL=getUserInfo.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/exchangeCodeForTokens.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */









function exchangeCodeForTokens(sdk, tokenParams, urls) {
    urls = urls || getOAuthUrls(sdk, tokenParams);
    tokenParams = Object.assign({}, getDefaultTokenParams(sdk), clone(tokenParams));
    const { authorizationCode, interactionCode, codeVerifier, clientId, redirectUri, scopes, ignoreSignature, state } = tokenParams;
    var getTokenOptions = {
        clientId,
        redirectUri,
        authorizationCode,
        interactionCode,
        codeVerifier,
    };
    return postToTokenEndpoint(sdk, getTokenOptions, urls)
        .then((response) => {
        const responseType = ['token'];
        if (scopes.indexOf('openid') !== -1) {
            responseType.push('id_token');
        }
        const handleResponseOptions = {
            clientId,
            redirectUri,
            scopes,
            responseType,
            ignoreSignature,
        };
        return handleOAuthResponse(sdk, handleResponseOptions, response, urls)
            .then((response) => {
            response.code = authorizationCode;
            response.state = state;
            return response;
        });
    })
        .finally(() => {
        sdk.transactionManager.clear();
    });
}


//# sourceMappingURL=exchangeCodeForTokens.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/getWithPopup.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */








function getWithPopup(sdk, options) {
    if (arguments.length > 2) {
        return Promise.reject(new AuthSdkError_AuthSdkError('As of version 3.0, "getWithPopup" takes only a single set of options'));
    }
    const popupWindow = loadPopup('/', options);
    options = clone(options) || {};
    Object.assign(options, {
        display: 'popup',
        responseMode: 'okta_post_message',
        popupWindow
    });
    return getToken(sdk, options);
}


//# sourceMappingURL=getWithPopup.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/util/oauthMeta.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



function createOAuthMeta(sdk, tokenParams) {
    const issuer = sdk.options.issuer;
    const urls = getOAuthUrls(sdk, tokenParams);
    const oauthMeta = {
        issuer,
        urls,
        clientId: tokenParams.clientId,
        redirectUri: tokenParams.redirectUri,
        responseType: tokenParams.responseType,
        responseMode: tokenParams.responseMode,
        scopes: tokenParams.scopes,
        state: tokenParams.state,
        nonce: tokenParams.nonce,
        ignoreSignature: tokenParams.ignoreSignature,
    };
    if (tokenParams.pkce === false) {
        return oauthMeta;
    }
    const pkceMeta = Object.assign(Object.assign({}, oauthMeta), { codeVerifier: tokenParams.codeVerifier, codeChallengeMethod: tokenParams.codeChallengeMethod, codeChallenge: tokenParams.codeChallenge });
    return pkceMeta;
}


//# sourceMappingURL=oauthMeta.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/getWithRedirect.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */









async function getWithRedirect(sdk, options) {
    if (arguments.length > 2) {
        return Promise.reject(new AuthSdkError_AuthSdkError('As of version 3.0, "getWithRedirect" takes only a single set of options'));
    }
    options = clone(options) || {};
    const tokenParams = await prepareTokenParams(sdk, options);
    const meta = createOAuthMeta(sdk, tokenParams);
    const requestUrl = meta.urls.authorizeUrl + buildAuthorizeParams(tokenParams);
    sdk.transactionManager.save(meta, { oauth: true });
    sdk.token.getWithRedirect._setLocation(requestUrl);
}


//# sourceMappingURL=getWithRedirect.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/util/urlParams.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */

function urlParamsToObject(hashOrSearch) {
    var plus2space = /\+/g;
    var paramSplit = /([^&=]+)=?([^&]*)/g;
    var fragment = hashOrSearch || '';
    if (fragment.charAt(0) === '#' && fragment.charAt(1) === '/') {
        fragment = fragment.substring(2);
    }
    if (fragment.charAt(0) === '#' || fragment.charAt(0) === '?') {
        fragment = fragment.substring(1);
    }
    var obj = {};
    var param;
    while (true) {
        param = paramSplit.exec(fragment);
        if (!param) {
            break;
        }
        var key = param[1];
        var value = param[2];
        if (key === 'id_token' || key === 'access_token' || key === 'code') {
            obj[key] = value;
        }
        else {
            obj[key] = decodeURIComponent(value.replace(plus2space, ' '));
        }
    }
    return obj;
}


//# sourceMappingURL=urlParams.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/parseFromUrl.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */









function removeHash(sdk) {
    var nativeHistory = sdk.token.parseFromUrl._getHistory();
    var nativeDoc = sdk.token.parseFromUrl._getDocument();
    var nativeLoc = sdk.token.parseFromUrl._getLocation();
    if (nativeHistory && nativeHistory.replaceState) {
        nativeHistory.replaceState(null, nativeDoc.title, nativeLoc.pathname + nativeLoc.search);
    }
    else {
        nativeLoc.hash = '';
    }
}
function removeSearch(sdk) {
    var nativeHistory = sdk.token.parseFromUrl._getHistory();
    var nativeDoc = sdk.token.parseFromUrl._getDocument();
    var nativeLoc = sdk.token.parseFromUrl._getLocation();
    if (nativeHistory && nativeHistory.replaceState) {
        nativeHistory.replaceState(null, nativeDoc.title, nativeLoc.pathname + nativeLoc.hash);
    }
    else {
        nativeLoc.search = '';
    }
}
function getResponseMode(sdk) {
    var defaultResponseMode = sdk.options.pkce ? 'query' : 'fragment';
    var responseMode = sdk.options.responseMode || defaultResponseMode;
    return responseMode;
}
function parseOAuthResponseFromUrl(sdk, options) {
    options = options || {};
    if (isString(options)) {
        options = { url: options };
    }
    else {
        options = options;
    }
    var url = options.url;
    var responseMode = options.responseMode || getResponseMode(sdk);
    var nativeLoc = sdk.token.parseFromUrl._getLocation();
    var paramStr;
    if (responseMode === 'query') {
        paramStr = url ? url.substring(url.indexOf('?')) : nativeLoc.search;
    }
    else {
        paramStr = url ? url.substring(url.indexOf('#')) : nativeLoc.hash;
    }
    if (!paramStr) {
        throw new AuthSdkError_AuthSdkError('Unable to parse a token from the url');
    }
    return urlParamsToObject(paramStr);
}
function cleanOAuthResponseFromUrl(sdk, options) {
    const responseMode = options.responseMode || getResponseMode(sdk);
    responseMode === 'query' ? removeSearch(sdk) : removeHash(sdk);
}
async function parseFromUrl(sdk, options) {
    options = options || {};
    if (isString(options)) {
        options = { url: options };
    }
    else {
        options = options;
    }
    const res = parseOAuthResponseFromUrl(sdk, options);
    const state = res.state;
    const oauthParams = sdk.transactionManager.load({
        oauth: true,
        pkce: sdk.options.pkce,
        state
    });
    if (!oauthParams) {
        return Promise.reject(new AuthSdkError_AuthSdkError('Unable to retrieve OAuth redirect params from storage'));
    }
    const urls = oauthParams.urls;
    delete oauthParams.urls;
    if (!options.url) {
        cleanOAuthResponseFromUrl(sdk, options);
    }
    return handleOAuthResponse(sdk, oauthParams, res, urls)
        .catch(err => {
        if (!isInteractionRequiredError(err)) {
            sdk.transactionManager.clear({
                state
            });
        }
        throw err;
    })
        .then(res => {
        sdk.transactionManager.clear({
            state
        });
        return res;
    });
}


//# sourceMappingURL=parseFromUrl.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/crypto/webauthn.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



const getEnrolledCredentials = (authenticatorEnrollments = []) => {
    const credentials = [];
    authenticatorEnrollments.forEach((enrollement) => {
        if (enrollement.key === 'webauthn') {
            credentials.push({
                type: 'public-key',
                id: base64UrlToBuffer(enrollement.credentialId),
            });
        }
    });
    return credentials;
};
const buildCredentialCreationOptions = (activationData, authenticatorEnrollments) => {
    return {
        publicKey: {
            rp: activationData.rp,
            user: {
                id: base64UrlToBuffer(activationData.user.id),
                name: activationData.user.name,
                displayName: activationData.user.displayName
            },
            challenge: base64UrlToBuffer(activationData.challenge),
            pubKeyCredParams: activationData.pubKeyCredParams,
            attestation: activationData.attestation,
            authenticatorSelection: activationData.authenticatorSelection,
            excludeCredentials: getEnrolledCredentials(authenticatorEnrollments),
        }
    };
};
const buildCredentialRequestOptions = (challengeData, authenticatorEnrollments) => {
    return {
        publicKey: {
            challenge: base64UrlToBuffer(challengeData.challenge),
            userVerification: challengeData.userVerification,
            allowCredentials: getEnrolledCredentials(authenticatorEnrollments),
        }
    };
};
const getAttestation = (credential) => {
    const response = credential.response;
    const id = credential.id;
    const clientData = bufferToBase64Url(response.clientDataJSON);
    const attestation = bufferToBase64Url(response.attestationObject);
    return {
        id,
        clientData,
        attestation
    };
};
const getAssertion = (credential) => {
    const response = credential.response;
    const id = credential.id;
    const clientData = bufferToBase64Url(response.clientDataJSON);
    const authenticatorData = bufferToBase64Url(response.authenticatorData);
    const signatureData = bufferToBase64Url(response.signature);
    return {
        id,
        clientData,
        authenticatorData,
        signatureData
    };
};


//# sourceMappingURL=webauthn.js.map

;// CONCATENATED MODULE: ./node_modules/js-cookie/dist/js.cookie.mjs
/*! js-cookie v3.0.5 | MIT */
/* eslint-disable no-var */
function js_cookie_assign (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      target[key] = source[key];
    }
  }
  return target
}
/* eslint-enable no-var */

/* eslint-disable no-var */
var defaultConverter = {
  read: function (value) {
    if (value[0] === '"') {
      value = value.slice(1, -1);
    }
    return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent)
  },
  write: function (value) {
    return encodeURIComponent(value).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    )
  }
};
/* eslint-enable no-var */

/* eslint-disable no-var */

function init (converter, defaultAttributes) {
  function set (name, value, attributes) {
    if (typeof document === 'undefined') {
      return
    }

    attributes = js_cookie_assign({}, defaultAttributes, attributes);

    if (typeof attributes.expires === 'number') {
      attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
    }
    if (attributes.expires) {
      attributes.expires = attributes.expires.toUTCString();
    }

    name = encodeURIComponent(name)
      .replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent)
      .replace(/[()]/g, escape);

    var stringifiedAttributes = '';
    for (var attributeName in attributes) {
      if (!attributes[attributeName]) {
        continue
      }

      stringifiedAttributes += '; ' + attributeName;

      if (attributes[attributeName] === true) {
        continue
      }

      // Considers RFC 6265 section 5.2:
      // ...
      // 3.  If the remaining unparsed-attributes contains a %x3B (";")
      //     character:
      // Consume the characters of the unparsed-attributes up to,
      // not including, the first %x3B (";") character.
      // ...
      stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
    }

    return (document.cookie =
      name + '=' + converter.write(value, name) + stringifiedAttributes)
  }

  function get (name) {
    if (typeof document === 'undefined' || (arguments.length && !name)) {
      return
    }

    // To prevent the for loop in the first place assign an empty array
    // in case there are no cookies at all.
    var cookies = document.cookie ? document.cookie.split('; ') : [];
    var jar = {};
    for (var i = 0; i < cookies.length; i++) {
      var parts = cookies[i].split('=');
      var value = parts.slice(1).join('=');

      try {
        var found = decodeURIComponent(parts[0]);
        jar[found] = converter.read(value, found);

        if (name === found) {
          break
        }
      } catch (e) {}
    }

    return name ? jar[name] : jar
  }

  return Object.create(
    {
      set,
      get,
      remove: function (name, attributes) {
        set(
          name,
          '',
          js_cookie_assign({}, attributes, {
            expires: -1
          })
        );
      },
      withAttributes: function (attributes) {
        return init(this.converter, js_cookie_assign({}, this.attributes, attributes))
      },
      withConverter: function (converter) {
        return init(js_cookie_assign({}, this.converter, converter), this.attributes)
      }
    },
    {
      attributes: { value: Object.freeze(defaultAttributes) },
      converter: { value: Object.freeze(converter) }
    }
  )
}

var api = init(defaultConverter, { path: '/' });
/* eslint-enable no-var */



;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/util/console.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */

function getNativeConsole() {
    if (typeof window !== 'undefined') {
        return window.console;
    }
    else if (typeof console !== 'undefined') {
        return console;
    }
    else {
        return undefined;
    }
}
function getConsole() {
    var nativeConsole = getNativeConsole();
    if (nativeConsole && nativeConsole.log) {
        return nativeConsole;
    }
    return {
        log: function () { },
        warn: function () { },
        group: function () { },
        groupEnd: function () { }
    };
}
function warn(text) {
    getConsole().warn('[okta-auth-sdk] WARN: ' + text);
}
function deprecate(text) {
    getConsole().warn('[okta-auth-sdk] DEPRECATION: ' + text);
}
function deprecateWrap(text, fn) {
    return function () {
        deprecate(text);
        return fn.apply(null, arguments);
    };
}


//# sourceMappingURL=console.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/browser/browserStorage.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */






var storageUtil = {
    getHttpCache() {
        return null;
    },
    getPKCEStorage() {
        return null;
    },
    browserHasLocalStorage: function () {
        try {
            var storage = this.getLocalStorage();
            return this.testStorage(storage);
        }
        catch (e) {
            return false;
        }
    },
    browserHasSessionStorage: function () {
        try {
            var storage = this.getSessionStorage();
            return this.testStorage(storage);
        }
        catch (e) {
            return false;
        }
    },
    testStorageType: function (storageType) {
        var supported = false;
        switch (storageType) {
            case 'sessionStorage':
                supported = this.browserHasSessionStorage();
                break;
            case 'localStorage':
                supported = this.browserHasLocalStorage();
                break;
            case 'cookie':
            case 'memory':
                supported = true;
                break;
            default:
                supported = false;
                break;
        }
        return supported;
    },
    getStorageByType: function (storageType, options) {
        let storageProvider;
        switch (storageType) {
            case 'sessionStorage':
                storageProvider = this.getSessionStorage();
                break;
            case 'localStorage':
                storageProvider = this.getLocalStorage();
                break;
            case 'cookie':
                storageProvider = this.getCookieStorage(options);
                break;
            case 'memory':
                storageProvider = this.getInMemoryStorage();
                break;
            default:
                throw new AuthSdkError_AuthSdkError(`Unrecognized storage option: ${storageType}`);
        }
        return storageProvider;
    },
    findStorageType: function (types) {
        let curType;
        let nextType;
        types = types.slice();
        curType = types.shift();
        nextType = types.length ? types[0] : null;
        if (!nextType) {
            return curType;
        }
        if (this.testStorageType(curType)) {
            return curType;
        }
        warn(`This browser doesn't support ${curType}. Switching to ${nextType}.`);
        return this.findStorageType(types);
    },
    getLocalStorage: function () {
        if (isIE11OrLess() && !window.onstorage) {
            window.onstorage = function () { };
        }
        return localStorage;
    },
    getSessionStorage: function () {
        return sessionStorage;
    },
    getCookieStorage: function (options) {
        const secure = options.secure;
        const sameSite = options.sameSite;
        const sessionCookie = options.sessionCookie;
        if (typeof secure === 'undefined' || typeof sameSite === 'undefined') {
            throw new AuthSdkError_AuthSdkError('getCookieStorage: "secure" and "sameSite" options must be provided');
        }
        const storage = {
            getItem: this.storage.get,
            setItem: (key, value, expiresAt = '2200-01-01T00:00:00.000Z') => {
                expiresAt = (sessionCookie ? null : expiresAt);
                this.storage.set(key, value, expiresAt, {
                    secure: secure,
                    sameSite: sameSite,
                });
            },
            removeItem: (key) => {
                this.storage.delete(key);
            },
            isSharedStorage: () => true
        };
        if (!options.useSeparateCookies) {
            return storage;
        }
        return {
            getItem: function (key) {
                var data = storage.getItem();
                var value = {};
                Object.keys(data).forEach(k => {
                    if (k.indexOf(key) === 0) {
                        value[k.replace(`${key}_`, '')] = JSON.parse(data[k]);
                    }
                });
                return JSON.stringify(value);
            },
            setItem: function (key, value) {
                var existingValues = JSON.parse(this.getItem(key));
                value = JSON.parse(value);
                Object.keys(value).forEach(k => {
                    var storageKey = key + '_' + k;
                    var valueToStore = JSON.stringify(value[k]);
                    storage.setItem(storageKey, valueToStore);
                    delete existingValues[k];
                });
                Object.keys(existingValues).forEach(k => {
                    storage.removeItem(key + '_' + k);
                });
            },
            removeItem: function (key) {
                var existingValues = JSON.parse(this.getItem(key));
                Object.keys(existingValues).forEach(k => {
                    storage.removeItem(key + '_' + k);
                });
            },
            isSharedStorage: () => true
        };
    },
    inMemoryStore: {},
    getInMemoryStorage: function () {
        return {
            getItem: (key) => {
                return this.inMemoryStore[key];
            },
            setItem: (key, value) => {
                this.inMemoryStore[key] = value;
            },
            isSharedStorage: () => false
        };
    },
    testStorage: function (storage) {
        var key = 'okta-test-storage';
        try {
            storage.setItem(key, key);
            storage.removeItem(key);
            return true;
        }
        catch (e) {
            return false;
        }
    },
    storage: {
        set: function (name, value, expiresAt, options) {
            const { sameSite, secure } = options;
            if (typeof secure === 'undefined' || typeof sameSite === 'undefined') {
                throw new AuthSdkError_AuthSdkError('storage.set: "secure" and "sameSite" options must be provided');
            }
            var cookieOptions = {
                path: options.path || '/',
                secure,
                sameSite
            };
            if (!!(Date.parse(expiresAt))) {
                cookieOptions.expires = new Date(expiresAt);
            }
            api.set(name, value, cookieOptions);
            return this.get(name);
        },
        get: function (name) {
            if (!arguments.length) {
                return api.get();
            }
            return api.get(name);
        },
        delete: function (name) {
            return api.remove(name, { path: '/' });
        }
    }
};


//# sourceMappingURL=browserStorage.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/oidc/util/validateToken.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */






function validateToken(token, type) {
    if (!isIDToken(token) && !isAccessToken(token) && !isRefreshToken(token)) {
        throw new AuthSdkError_AuthSdkError('Token must be an Object with scopes, expiresAt, and one of: an idToken, accessToken, or refreshToken property');
    }
    if (type === 'accessToken' && !isAccessToken(token)) {
        throw new AuthSdkError_AuthSdkError('invalid accessToken');
    }
    if (type === 'idToken' && !isIDToken(token)) {
        throw new AuthSdkError_AuthSdkError('invalid idToken');
    }
    if (type === 'refreshToken' && !isRefreshToken(token)) {
        throw new AuthSdkError_AuthSdkError('invalid refreshToken');
    }
}


//# sourceMappingURL=validateToken.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/clock.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */

class SdkClock {
    constructor(localOffset) {
        this.localOffset = parseInt(localOffset || 0);
    }
    static create( ) {
        var localOffset = 0;
        return new SdkClock(localOffset);
    }
    now() {
        var now = (Date.now() + this.localOffset) / 1000;
        return now;
    }
}


//# sourceMappingURL=clock.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/types/TokenManager.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */

const EVENT_EXPIRED = 'expired';
const EVENT_RENEWED = 'renewed';
const EVENT_ADDED = 'added';
const EVENT_REMOVED = 'removed';
const EVENT_ERROR = 'error';
const EVENT_SET_STORAGE = 'set_storage';


//# sourceMappingURL=TokenManager.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/TokenManager.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */












const DEFAULT_OPTIONS = {
    autoRenew: true,
    autoRemove: true,
    syncStorage: true,
    clearPendingRemoveTokens: true,
    storage: undefined,
    expireEarlySeconds: 30,
    storageKey: TOKEN_STORAGE_NAME
};
function defaultState() {
    return {
        expireTimeouts: {},
        renewPromise: null
    };
}
class TokenManager {
    constructor(sdk, options = {}) {
        this.sdk = sdk;
        this.emitter = sdk.emitter;
        if (!this.emitter) {
            throw new AuthSdkError_AuthSdkError('Emitter should be initialized before TokenManager');
        }
        options = Object.assign({}, DEFAULT_OPTIONS, removeNils(options));
        if (!isLocalhost()) {
            options.expireEarlySeconds = DEFAULT_OPTIONS.expireEarlySeconds;
        }
        this.options = options;
        const storageOptions = removeNils({
            storageKey: options.storageKey,
            secure: options.secure,
        });
        if (typeof options.storage === 'object') {
            storageOptions.storageProvider = options.storage;
        }
        else if (options.storage) {
            storageOptions.storageType = options.storage;
        }
        this.storage = sdk.storageManager.getTokenStorage(Object.assign(Object.assign({}, storageOptions), { useSeparateCookies: true }));
        this.clock = SdkClock.create( );
        this.state = defaultState();
    }
    on(event, handler, context) {
        if (context) {
            this.emitter.on(event, handler, context);
        }
        else {
            this.emitter.on(event, handler);
        }
    }
    off(event, handler) {
        if (handler) {
            this.emitter.off(event, handler);
        }
        else {
            this.emitter.off(event);
        }
    }
    hasSharedStorage() {
        return this.storage.isSharedStorage();
    }
    start() {
        if (this.options.clearPendingRemoveTokens) {
            this.clearPendingRemoveTokens();
        }
        this.setExpireEventTimeoutAll();
    }
    stop() {
        this.clearExpireEventTimeoutAll();
    }
    getOptions() {
        return clone(this.options);
    }
    getExpireTime(token) {
        const expireEarlySeconds = this.options.expireEarlySeconds || 0;
        var expireTime = token.expiresAt - expireEarlySeconds;
        return expireTime;
    }
    hasExpired(token) {
        var expireTime = this.getExpireTime(token);
        return expireTime <= this.clock.now();
    }
    emitExpired(key, token) {
        this.emitter.emit(EVENT_EXPIRED, key, token);
    }
    emitRenewed(key, freshToken, oldToken) {
        this.emitter.emit(EVENT_RENEWED, key, freshToken, oldToken);
    }
    emitAdded(key, token) {
        this.emitter.emit(EVENT_ADDED, key, token);
    }
    emitRemoved(key, token) {
        this.emitter.emit(EVENT_REMOVED, key, token);
    }
    emitError(error) {
        this.emitter.emit(EVENT_ERROR, error);
    }
    clearExpireEventTimeout(key) {
        clearTimeout(this.state.expireTimeouts[key]);
        delete this.state.expireTimeouts[key];
        this.state.renewPromise = null;
    }
    clearExpireEventTimeoutAll() {
        var expireTimeouts = this.state.expireTimeouts;
        for (var key in expireTimeouts) {
            if (!Object.prototype.hasOwnProperty.call(expireTimeouts, key)) {
                continue;
            }
            this.clearExpireEventTimeout(key);
        }
    }
    setExpireEventTimeout(key, token) {
        if (isRefreshToken(token)) {
            return;
        }
        var expireTime = this.getExpireTime(token);
        var expireEventWait = Math.max(expireTime - this.clock.now(), 0) * 1000;
        this.clearExpireEventTimeout(key);
        var expireEventTimeout = setTimeout(() => {
            this.emitExpired(key, token);
        }, expireEventWait);
        this.state.expireTimeouts[key] = expireEventTimeout;
    }
    setExpireEventTimeoutAll() {
        var tokenStorage = this.storage.getStorage();
        for (var key in tokenStorage) {
            if (!Object.prototype.hasOwnProperty.call(tokenStorage, key)) {
                continue;
            }
            var token = tokenStorage[key];
            this.setExpireEventTimeout(key, token);
        }
    }
    resetExpireEventTimeoutAll() {
        this.clearExpireEventTimeoutAll();
        this.setExpireEventTimeoutAll();
    }
    add(key, token) {
        var tokenStorage = this.storage.getStorage();
        validateToken(token);
        tokenStorage[key] = token;
        this.storage.setStorage(tokenStorage);
        this.emitSetStorageEvent();
        this.emitAdded(key, token);
        this.setExpireEventTimeout(key, token);
    }
    getSync(key) {
        var tokenStorage = this.storage.getStorage();
        return tokenStorage[key];
    }
    async get(key) {
        return this.getSync(key);
    }
    getTokensSync() {
        const tokens = {};
        const tokenStorage = this.storage.getStorage();
        Object.keys(tokenStorage).forEach(key => {
            const token = tokenStorage[key];
            if (isAccessToken(token)) {
                tokens.accessToken = token;
            }
            else if (isIDToken(token)) {
                tokens.idToken = token;
            }
            else if (isRefreshToken(token)) {
                tokens.refreshToken = token;
            }
        });
        return tokens;
    }
    async getTokens() {
        return this.getTokensSync();
    }
    getStorageKeyByType(type) {
        const tokenStorage = this.storage.getStorage();
        const key = Object.keys(tokenStorage).filter(key => {
            const token = tokenStorage[key];
            return (isAccessToken(token) && type === 'accessToken')
                || (isIDToken(token) && type === 'idToken')
                || (isRefreshToken(token) && type === 'refreshToken');
        })[0];
        return key;
    }
    getTokenType(token) {
        if (isAccessToken(token)) {
            return 'accessToken';
        }
        if (isIDToken(token)) {
            return 'idToken';
        }
        if (isRefreshToken(token)) {
            return 'refreshToken';
        }
        throw new AuthSdkError_AuthSdkError('Unknown token type');
    }
    emitSetStorageEvent() {
        if (isIE11OrLess()) {
            const storage = this.storage.getStorage();
            this.emitter.emit(EVENT_SET_STORAGE, storage);
        }
    }
    getStorage() {
        return this.storage;
    }
    setTokens(tokens,
    accessTokenCb, idTokenCb, refreshTokenCb) {
        const handleTokenCallback = (key, token) => {
            const type = this.getTokenType(token);
            if (type === 'accessToken') {
                accessTokenCb && accessTokenCb(key, token);
            }
            else if (type === 'idToken') {
                idTokenCb && idTokenCb(key, token);
            }
            else if (type === 'refreshToken') {
                refreshTokenCb && refreshTokenCb(key, token);
            }
        };
        const handleAdded = (key, token) => {
            this.emitAdded(key, token);
            this.setExpireEventTimeout(key, token);
            handleTokenCallback(key, token);
        };
        const handleRenewed = (key, token, oldToken) => {
            this.emitRenewed(key, token, oldToken);
            this.clearExpireEventTimeout(key);
            this.setExpireEventTimeout(key, token);
            handleTokenCallback(key, token);
        };
        const handleRemoved = (key, token) => {
            this.clearExpireEventTimeout(key);
            this.emitRemoved(key, token);
            handleTokenCallback(key, token);
        };
        const types = ['idToken', 'accessToken', 'refreshToken'];
        const existingTokens = this.getTokensSync();
        types.forEach((type) => {
            const token = tokens[type];
            if (token) {
                validateToken(token, type);
            }
        });
        const storage = types.reduce((storage, type) => {
            const token = tokens[type];
            if (token) {
                const storageKey = this.getStorageKeyByType(type) || type;
                storage[storageKey] = token;
            }
            return storage;
        }, {});
        this.storage.setStorage(storage);
        this.emitSetStorageEvent();
        types.forEach(type => {
            const newToken = tokens[type];
            const existingToken = existingTokens[type];
            const storageKey = this.getStorageKeyByType(type) || type;
            if (newToken && existingToken) {
                handleRemoved(storageKey, existingToken);
                handleAdded(storageKey, newToken);
                handleRenewed(storageKey, newToken, existingToken);
            }
            else if (newToken) {
                handleAdded(storageKey, newToken);
            }
            else if (existingToken) {
                handleRemoved(storageKey, existingToken);
            }
        });
    }
    remove(key) {
        this.clearExpireEventTimeout(key);
        var tokenStorage = this.storage.getStorage();
        var removedToken = tokenStorage[key];
        delete tokenStorage[key];
        this.storage.setStorage(tokenStorage);
        this.emitSetStorageEvent();
        this.emitRemoved(key, removedToken);
    }
    async renewToken(token) {
        var _a;
        return (_a = this.sdk.token) === null || _a === void 0 ? void 0 : _a.renew(token);
    }
    validateToken(token) {
        return validateToken(token);
    }
    renew(key) {
        if (this.state.renewPromise) {
            return this.state.renewPromise;
        }
        try {
            var token = this.getSync(key);
            if (!token) {
                throw new AuthSdkError_AuthSdkError('The tokenManager has no token for the key: ' + key);
            }
        }
        catch (e) {
            return Promise.reject(e);
        }
        this.clearExpireEventTimeout(key);
        this.state.renewPromise = this.sdk.token.renewTokens()
            .then(tokens => {
            this.setTokens(tokens);
            const tokenType = this.getTokenType(token);
            return tokens[tokenType];
        })
            .catch(err => {
            this.remove(key);
            err.tokenKey = key;
            this.emitError(err);
            throw err;
        })
            .finally(() => {
            this.state.renewPromise = null;
        });
        return this.state.renewPromise;
    }
    clear() {
        const tokens = this.getTokensSync();
        this.clearExpireEventTimeoutAll();
        this.storage.clearStorage();
        this.emitSetStorageEvent();
        Object.keys(tokens).forEach(key => {
            this.emitRemoved(key, tokens[key]);
        });
    }
    clearPendingRemoveTokens() {
        const tokenStorage = this.storage.getStorage();
        const removedTokens = {};
        Object.keys(tokenStorage).forEach(key => {
            if (tokenStorage[key].pendingRemove) {
                removedTokens[key] = tokenStorage[key];
                delete tokenStorage[key];
            }
        });
        this.storage.setStorage(tokenStorage);
        this.emitSetStorageEvent();
        Object.keys(removedTokens).forEach(key => {
            this.clearExpireEventTimeout(key);
            this.emitRemoved(key, removedTokens[key]);
        });
    }
    updateRefreshToken(token) {
        const key = this.getStorageKeyByType('refreshToken') || REFRESH_TOKEN_STORAGE_KEY;
        var tokenStorage = this.storage.getStorage();
        validateToken(token);
        tokenStorage[key] = token;
        this.storage.setStorage(tokenStorage);
        this.emitSetStorageEvent();
    }
    removeRefreshToken() {
        const key = this.getStorageKeyByType('refreshToken') || REFRESH_TOKEN_STORAGE_KEY;
        this.remove(key);
    }
    addPendingRemoveFlags() {
        const tokens = this.getTokensSync();
        Object.keys(tokens).forEach(key => {
            tokens[key].pendingRemove = true;
        });
        this.setTokens(tokens);
    }
}


//# sourceMappingURL=TokenManager.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/services/AutoRenewService.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */







class AutoRenewService {
    constructor(tokenManager, options = {}) {
        this.started = false;
        this.tokenManager = tokenManager;
        this.options = options;
        this.renewTimeQueue = [];
        this.onTokenExpiredHandler = this.onTokenExpiredHandler.bind(this);
    }
    shouldThrottleRenew() {
        let res = false;
        this.renewTimeQueue.push(Date.now());
        if (this.renewTimeQueue.length >= 10) {
            const firstTime = this.renewTimeQueue.shift();
            const lastTime = this.renewTimeQueue[this.renewTimeQueue.length - 1];
            res = (lastTime - firstTime) < 30 * 1000;
        }
        return res;
    }
    requiresLeadership() {
        return !!this.options.syncStorage && isBrowser();
    }
    onTokenExpiredHandler(key) {
        if (this.options.autoRenew) {
            if (this.shouldThrottleRenew()) {
                const error = new AuthSdkError_AuthSdkError('Too many token renew requests');
                this.tokenManager.emitError(error);
            }
            else {
                this.tokenManager.renew(key).catch(() => { });
            }
        }
        else if (this.options.autoRemove) {
            this.tokenManager.remove(key);
        }
    }
    canStart() {
        return (!!this.options.autoRenew || !!this.options.autoRemove);
    }
    async start() {
        if (this.canStart()) {
            await this.stop();
            this.tokenManager.on(EVENT_EXPIRED, this.onTokenExpiredHandler);
            this.started = true;
        }
    }
    async stop() {
        if (this.started) {
            this.tokenManager.off(EVENT_EXPIRED, this.onTokenExpiredHandler);
            this.renewTimeQueue = [];
            this.started = false;
        }
    }
    isStarted() {
        return this.started;
    }
}


//# sourceMappingURL=AutoRenewService.js.map

;// CONCATENATED MODULE: ./node_modules/broadcast-channel/dist/esbrowser/util.js
/**
 * returns true if the given object is a promise
 */
function util_isPromise(obj) {
  if (obj && typeof obj.then === 'function') {
    return true;
  } else {
    return false;
  }
}
var util_PROMISE_RESOLVED_FALSE = Promise.resolve(false);
var PROMISE_RESOLVED_TRUE = Promise.resolve(true);
var PROMISE_RESOLVED_VOID = Promise.resolve();
function sleep(time, resolveWith) {
  if (!time) time = 0;
  return new Promise(function (res) {
    return setTimeout(function () {
      return res(resolveWith);
    }, time);
  });
}
function randomInt(min, max) {
  return Math.floor(Math.random() * (max - min + 1) + min);
}
/**
 * https://stackoverflow.com/a/8084248
 */

function randomToken() {
  return Math.random().toString(36).substring(2);
}
var lastMs = 0;
var additional = 0;
/**
 * returns the current time in micro-seconds,
 * WARNING: This is a pseudo-function
 * Performance.now is not reliable in webworkers, so we just make sure to never return the same time.
 * This is enough in browsers, and this function will not be used in nodejs.
 * The main reason for this hack is to ensure that BroadcastChannel behaves equal to production when it is used in fast-running unit tests.
 */

function microSeconds() {
  var ms = new Date().getTime();

  if (ms === lastMs) {
    additional++;
    return ms * 1000 + additional;
  } else {
    lastMs = ms;
    additional = 0;
    return ms * 1000;
  }
}
;// CONCATENATED MODULE: ./node_modules/broadcast-channel/dist/esbrowser/methods/native.js

var native_microSeconds = microSeconds;
var type = 'native';
function create(channelName) {
  var state = {
    messagesCallback: null,
    bc: new BroadcastChannel(channelName),
    subFns: [] // subscriberFunctions

  };

  state.bc.onmessage = function (msg) {
    if (state.messagesCallback) {
      state.messagesCallback(msg.data);
    }
  };

  return state;
}
function native_close(channelState) {
  channelState.bc.close();
  channelState.subFns = [];
}
function postMessage(channelState, messageJson) {
  try {
    channelState.bc.postMessage(messageJson, false);
    return PROMISE_RESOLVED_VOID;
  } catch (err) {
    return Promise.reject(err);
  }
}
function onMessage(channelState, fn) {
  channelState.messagesCallback = fn;
}
function canBeUsed() {
  if (typeof window === 'undefined') {
    return false;
  }

  if (typeof BroadcastChannel === 'function') {
    if (BroadcastChannel._pubkey) {
      throw new Error('BroadcastChannel: Do not overwrite window.BroadcastChannel with this module, this is not a polyfill');
    }

    return true;
  } else {
    return false;
  }
}
function averageResponseTime() {
  return 150;
}
/* harmony default export */ var methods_native = ({
  create: create,
  close: native_close,
  onMessage: onMessage,
  postMessage: postMessage,
  canBeUsed: canBeUsed,
  type: type,
  averageResponseTime: averageResponseTime,
  microSeconds: native_microSeconds
});
;// CONCATENATED MODULE: ./node_modules/oblivious-set/dist/es/index.js
/**
 * this is a set which automatically forgets
 * a given entry when a new entry is set and the ttl
 * of the old one is over
 */
var ObliviousSet = /** @class */ (function () {
    function ObliviousSet(ttl) {
        this.ttl = ttl;
        this.map = new Map();
        /**
         * Creating calls to setTimeout() is expensive,
         * so we only do that if there is not timeout already open.
         */
        this._to = false;
    }
    ObliviousSet.prototype.has = function (value) {
        return this.map.has(value);
    };
    ObliviousSet.prototype.add = function (value) {
        var _this = this;
        this.map.set(value, now());
        /**
         * When a new value is added,
         * start the cleanup at the next tick
         * to not block the cpu for more important stuff
         * that might happen.
         */
        if (!this._to) {
            this._to = true;
            setTimeout(function () {
                _this._to = false;
                removeTooOldValues(_this);
            }, 0);
        }
    };
    ObliviousSet.prototype.clear = function () {
        this.map.clear();
    };
    return ObliviousSet;
}());

/**
 * Removes all entries from the set
 * where the TTL has expired
 */
function removeTooOldValues(obliviousSet) {
    var olderThen = now() - obliviousSet.ttl;
    var iterator = obliviousSet.map[Symbol.iterator]();
    /**
     * Because we can assume the new values are added at the bottom,
     * we start from the top and stop as soon as we reach a non-too-old value.
     */
    while (true) {
        var next = iterator.next().value;
        if (!next) {
            return; // no more elements
        }
        var value = next[0];
        var time = next[1];
        if (time < olderThen) {
            obliviousSet.map.delete(value);
        }
        else {
            // We reached a value that is not old enough
            return;
        }
    }
}
function now() {
    return new Date().getTime();
}
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/broadcast-channel/dist/esbrowser/options.js
function options_fillOptionsWithDefaults() {
  var originalOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var options = JSON.parse(JSON.stringify(originalOptions)); // main

  if (typeof options.webWorkerSupport === 'undefined') options.webWorkerSupport = true; // indexed-db

  if (!options.idb) options.idb = {}; //  after this time the messages get deleted

  if (!options.idb.ttl) options.idb.ttl = 1000 * 45;
  if (!options.idb.fallbackInterval) options.idb.fallbackInterval = 150; //  handles abrupt db onclose events.

  if (originalOptions.idb && typeof originalOptions.idb.onclose === 'function') options.idb.onclose = originalOptions.idb.onclose; // localstorage

  if (!options.localstorage) options.localstorage = {};
  if (!options.localstorage.removeTimeout) options.localstorage.removeTimeout = 1000 * 60; // custom methods

  if (originalOptions.methods) options.methods = originalOptions.methods; // node

  if (!options.node) options.node = {};
  if (!options.node.ttl) options.node.ttl = 1000 * 60 * 2; // 2 minutes;

  /**
   * On linux use 'ulimit -Hn' to get the limit of open files.
   * On ubuntu this was 4096 for me, so we use half of that as maxParallelWrites default.
   */

  if (!options.node.maxParallelWrites) options.node.maxParallelWrites = 2048;
  if (typeof options.node.useFastPath === 'undefined') options.node.useFastPath = true;
  return options;
}
;// CONCATENATED MODULE: ./node_modules/broadcast-channel/dist/esbrowser/methods/indexed-db.js
/**
 * this method uses indexeddb to store the messages
 * There is currently no observerAPI for idb
 * @link https://github.com/w3c/IndexedDB/issues/51
 * 
 * When working on this, ensure to use these performance optimizations:
 * @link https://rxdb.info/slow-indexeddb.html
 */

var indexed_db_microSeconds = microSeconds;


var DB_PREFIX = 'pubkey.broadcast-channel-0-';
var OBJECT_STORE_ID = 'messages';
/**
 * Use relaxed durability for faster performance on all transactions.
 * @link https://nolanlawson.com/2021/08/22/speeding-up-indexeddb-reads-and-writes/
 */

var TRANSACTION_SETTINGS = {
  durability: 'relaxed'
};
var indexed_db_type = 'idb';
function getIdb() {
  if (typeof indexedDB !== 'undefined') return indexedDB;

  if (typeof window !== 'undefined') {
    if (typeof window.mozIndexedDB !== 'undefined') return window.mozIndexedDB;
    if (typeof window.webkitIndexedDB !== 'undefined') return window.webkitIndexedDB;
    if (typeof window.msIndexedDB !== 'undefined') return window.msIndexedDB;
  }

  return false;
}
/**
 * If possible, we should explicitly commit IndexedDB transactions
 * for better performance.
 * @link https://nolanlawson.com/2021/08/22/speeding-up-indexeddb-reads-and-writes/
 */

function commitIndexedDBTransaction(tx) {
  if (tx.commit) {
    tx.commit();
  }
}
function createDatabase(channelName) {
  var IndexedDB = getIdb(); // create table

  var dbName = DB_PREFIX + channelName;
  /**
   * All IndexedDB databases are opened without version
   * because it is a bit faster, especially on firefox
   * @link http://nparashuram.com/IndexedDB/perf/#Open%20Database%20with%20version
   */

  var openRequest = IndexedDB.open(dbName);

  openRequest.onupgradeneeded = function (ev) {
    var db = ev.target.result;
    db.createObjectStore(OBJECT_STORE_ID, {
      keyPath: 'id',
      autoIncrement: true
    });
  };

  var dbPromise = new Promise(function (res, rej) {
    openRequest.onerror = function (ev) {
      return rej(ev);
    };

    openRequest.onsuccess = function () {
      res(openRequest.result);
    };
  });
  return dbPromise;
}
/**
 * writes the new message to the database
 * so other readers can find it
 */

function writeMessage(db, readerUuid, messageJson) {
  var time = new Date().getTime();
  var writeObject = {
    uuid: readerUuid,
    time: time,
    data: messageJson
  };
  var tx = db.transaction([OBJECT_STORE_ID], 'readwrite', TRANSACTION_SETTINGS);
  return new Promise(function (res, rej) {
    tx.oncomplete = function () {
      return res();
    };

    tx.onerror = function (ev) {
      return rej(ev);
    };

    var objectStore = tx.objectStore(OBJECT_STORE_ID);
    objectStore.add(writeObject);
    commitIndexedDBTransaction(tx);
  });
}
function getAllMessages(db) {
  var tx = db.transaction(OBJECT_STORE_ID, 'readonly', TRANSACTION_SETTINGS);
  var objectStore = tx.objectStore(OBJECT_STORE_ID);
  var ret = [];
  return new Promise(function (res) {
    objectStore.openCursor().onsuccess = function (ev) {
      var cursor = ev.target.result;

      if (cursor) {
        ret.push(cursor.value); //alert("Name for SSN " + cursor.key + " is " + cursor.value.name);

        cursor["continue"]();
      } else {
        commitIndexedDBTransaction(tx);
        res(ret);
      }
    };
  });
}
function getMessagesHigherThan(db, lastCursorId) {
  var tx = db.transaction(OBJECT_STORE_ID, 'readonly', TRANSACTION_SETTINGS);
  var objectStore = tx.objectStore(OBJECT_STORE_ID);
  var ret = [];
  var keyRangeValue = IDBKeyRange.bound(lastCursorId + 1, Infinity);
  /**
   * Optimization shortcut,
   * if getAll() can be used, do not use a cursor.
   * @link https://rxdb.info/slow-indexeddb.html
   */

  if (objectStore.getAll) {
    var getAllRequest = objectStore.getAll(keyRangeValue);
    return new Promise(function (res, rej) {
      getAllRequest.onerror = function (err) {
        return rej(err);
      };

      getAllRequest.onsuccess = function (e) {
        res(e.target.result);
      };
    });
  }

  function openCursor() {
    // Occasionally Safari will fail on IDBKeyRange.bound, this
    // catches that error, having it open the cursor to the first
    // item. When it gets data it will advance to the desired key.
    try {
      keyRangeValue = IDBKeyRange.bound(lastCursorId + 1, Infinity);
      return objectStore.openCursor(keyRangeValue);
    } catch (e) {
      return objectStore.openCursor();
    }
  }

  return new Promise(function (res, rej) {
    var openCursorRequest = openCursor();

    openCursorRequest.onerror = function (err) {
      return rej(err);
    };

    openCursorRequest.onsuccess = function (ev) {
      var cursor = ev.target.result;

      if (cursor) {
        if (cursor.value.id < lastCursorId + 1) {
          cursor["continue"](lastCursorId + 1);
        } else {
          ret.push(cursor.value);
          cursor["continue"]();
        }
      } else {
        commitIndexedDBTransaction(tx);
        res(ret);
      }
    };
  });
}
function removeMessagesById(db, ids) {
  var tx = db.transaction([OBJECT_STORE_ID], 'readwrite', TRANSACTION_SETTINGS);
  var objectStore = tx.objectStore(OBJECT_STORE_ID);
  return Promise.all(ids.map(function (id) {
    var deleteRequest = objectStore["delete"](id);
    return new Promise(function (res) {
      deleteRequest.onsuccess = function () {
        return res();
      };
    });
  }));
}
function getOldMessages(db, ttl) {
  var olderThen = new Date().getTime() - ttl;
  var tx = db.transaction(OBJECT_STORE_ID, 'readonly', TRANSACTION_SETTINGS);
  var objectStore = tx.objectStore(OBJECT_STORE_ID);
  var ret = [];
  return new Promise(function (res) {
    objectStore.openCursor().onsuccess = function (ev) {
      var cursor = ev.target.result;

      if (cursor) {
        var msgObk = cursor.value;

        if (msgObk.time < olderThen) {
          ret.push(msgObk); //alert("Name for SSN " + cursor.key + " is " + cursor.value.name);

          cursor["continue"]();
        } else {
          // no more old messages,
          commitIndexedDBTransaction(tx);
          res(ret);
          return;
        }
      } else {
        res(ret);
      }
    };
  });
}
function cleanOldMessages(db, ttl) {
  return getOldMessages(db, ttl).then(function (tooOld) {
    return removeMessagesById(db, tooOld.map(function (msg) {
      return msg.id;
    }));
  });
}
function indexed_db_create(channelName, options) {
  options = options_fillOptionsWithDefaults(options);
  return createDatabase(channelName).then(function (db) {
    var state = {
      closed: false,
      lastCursorId: 0,
      channelName: channelName,
      options: options,
      uuid: randomToken(),

      /**
       * emittedMessagesIds
       * contains all messages that have been emitted before
       * @type {ObliviousSet}
       */
      eMIs: new ObliviousSet(options.idb.ttl * 2),
      // ensures we do not read messages in parrallel
      writeBlockPromise: PROMISE_RESOLVED_VOID,
      messagesCallback: null,
      readQueuePromises: [],
      db: db
    };
    /**
     * Handle abrupt closes that do not originate from db.close().
     * This could happen, for example, if the underlying storage is
     * removed or if the user clears the database in the browser's
     * history preferences.
     */

    db.onclose = function () {
      state.closed = true;
      if (options.idb.onclose) options.idb.onclose();
    };
    /**
     * if service-workers are used,
     * we have no 'storage'-event if they post a message,
     * therefore we also have to set an interval
     */


    _readLoop(state);

    return state;
  });
}

function _readLoop(state) {
  if (state.closed) return;
  readNewMessages(state).then(function () {
    return sleep(state.options.idb.fallbackInterval);
  }).then(function () {
    return _readLoop(state);
  });
}

function _filterMessage(msgObj, state) {
  if (msgObj.uuid === state.uuid) return false; // send by own

  if (state.eMIs.has(msgObj.id)) return false; // already emitted

  if (msgObj.data.time < state.messagesCallbackTime) return false; // older then onMessageCallback

  return true;
}
/**
 * reads all new messages from the database and emits them
 */


function readNewMessages(state) {
  // channel already closed
  if (state.closed) return PROMISE_RESOLVED_VOID; // if no one is listening, we do not need to scan for new messages

  if (!state.messagesCallback) return PROMISE_RESOLVED_VOID;
  return getMessagesHigherThan(state.db, state.lastCursorId).then(function (newerMessages) {
    var useMessages = newerMessages
    /**
     * there is a bug in iOS where the msgObj can be undefined some times
     * so we filter them out
     * @link https://github.com/pubkey/broadcast-channel/issues/19
     */
    .filter(function (msgObj) {
      return !!msgObj;
    }).map(function (msgObj) {
      if (msgObj.id > state.lastCursorId) {
        state.lastCursorId = msgObj.id;
      }

      return msgObj;
    }).filter(function (msgObj) {
      return _filterMessage(msgObj, state);
    }).sort(function (msgObjA, msgObjB) {
      return msgObjA.time - msgObjB.time;
    }); // sort by time

    useMessages.forEach(function (msgObj) {
      if (state.messagesCallback) {
        state.eMIs.add(msgObj.id);
        state.messagesCallback(msgObj.data);
      }
    });
    return PROMISE_RESOLVED_VOID;
  });
}

function indexed_db_close(channelState) {
  channelState.closed = true;
  channelState.db.close();
}
function indexed_db_postMessage(channelState, messageJson) {
  channelState.writeBlockPromise = channelState.writeBlockPromise.then(function () {
    return writeMessage(channelState.db, channelState.uuid, messageJson);
  }).then(function () {
    if (randomInt(0, 10) === 0) {
      /* await (do not await) */
      cleanOldMessages(channelState.db, channelState.options.idb.ttl);
    }
  });
  return channelState.writeBlockPromise;
}
function indexed_db_onMessage(channelState, fn, time) {
  channelState.messagesCallbackTime = time;
  channelState.messagesCallback = fn;
  readNewMessages(channelState);
}
function indexed_db_canBeUsed() {
  var idb = getIdb();

  if (!idb) {
    return false;
  }

  return true;
}
function indexed_db_averageResponseTime(options) {
  return options.idb.fallbackInterval * 2;
}
/* harmony default export */ var indexed_db = ({
  create: indexed_db_create,
  close: indexed_db_close,
  onMessage: indexed_db_onMessage,
  postMessage: indexed_db_postMessage,
  canBeUsed: indexed_db_canBeUsed,
  type: indexed_db_type,
  averageResponseTime: indexed_db_averageResponseTime,
  microSeconds: indexed_db_microSeconds
});
;// CONCATENATED MODULE: ./node_modules/broadcast-channel/dist/esbrowser/methods/localstorage.js
/**
 * A localStorage-only method which uses localstorage and its 'storage'-event
 * This does not work inside of webworkers because they have no access to locastorage
 * This is basically implemented to support IE9 or your grandmothers toaster.
 * @link https://caniuse.com/#feat=namevalue-storage
 * @link https://caniuse.com/#feat=indexeddb
 */



var localstorage_microSeconds = microSeconds;
var KEY_PREFIX = 'pubkey.broadcastChannel-';
var localstorage_type = 'localstorage';
/**
 * copied from crosstab
 * @link https://github.com/tejacques/crosstab/blob/master/src/crosstab.js#L32
 */

function getLocalStorage() {
  var localStorage;
  if (typeof window === 'undefined') return null;

  try {
    localStorage = window.localStorage;
    localStorage = window['ie8-eventlistener/storage'] || window.localStorage;
  } catch (e) {// New versions of Firefox throw a Security exception
    // if cookies are disabled. See
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1028153
  }

  return localStorage;
}
function storageKey(channelName) {
  return KEY_PREFIX + channelName;
}
/**
* writes the new message to the storage
* and fires the storage-event so other readers can find it
*/

function localstorage_postMessage(channelState, messageJson) {
  return new Promise(function (res) {
    sleep().then(function () {
      var key = storageKey(channelState.channelName);
      var writeObj = {
        token: randomToken(),
        time: new Date().getTime(),
        data: messageJson,
        uuid: channelState.uuid
      };
      var value = JSON.stringify(writeObj);
      getLocalStorage().setItem(key, value);
      /**
       * StorageEvent does not fire the 'storage' event
       * in the window that changes the state of the local storage.
       * So we fire it manually
       */

      var ev = document.createEvent('Event');
      ev.initEvent('storage', true, true);
      ev.key = key;
      ev.newValue = value;
      window.dispatchEvent(ev);
      res();
    });
  });
}
function addStorageEventListener(channelName, fn) {
  var key = storageKey(channelName);

  var listener = function listener(ev) {
    if (ev.key === key) {
      fn(JSON.parse(ev.newValue));
    }
  };

  window.addEventListener('storage', listener);
  return listener;
}
function removeStorageEventListener(listener) {
  window.removeEventListener('storage', listener);
}
function localstorage_create(channelName, options) {
  options = options_fillOptionsWithDefaults(options);

  if (!localstorage_canBeUsed()) {
    throw new Error('BroadcastChannel: localstorage cannot be used');
  }

  var uuid = randomToken();
  /**
   * eMIs
   * contains all messages that have been emitted before
   * @type {ObliviousSet}
   */

  var eMIs = new ObliviousSet(options.localstorage.removeTimeout);
  var state = {
    channelName: channelName,
    uuid: uuid,
    eMIs: eMIs // emittedMessagesIds

  };
  state.listener = addStorageEventListener(channelName, function (msgObj) {
    if (!state.messagesCallback) return; // no listener

    if (msgObj.uuid === uuid) return; // own message

    if (!msgObj.token || eMIs.has(msgObj.token)) return; // already emitted

    if (msgObj.data.time && msgObj.data.time < state.messagesCallbackTime) return; // too old

    eMIs.add(msgObj.token);
    state.messagesCallback(msgObj.data);
  });
  return state;
}
function localstorage_close(channelState) {
  removeStorageEventListener(channelState.listener);
}
function localstorage_onMessage(channelState, fn, time) {
  channelState.messagesCallbackTime = time;
  channelState.messagesCallback = fn;
}
function localstorage_canBeUsed() {
  var ls = getLocalStorage();
  if (!ls) return false;

  try {
    var key = '__broadcastchannel_check';
    ls.setItem(key, 'works');
    ls.removeItem(key);
  } catch (e) {
    // Safari 10 in private mode will not allow write access to local
    // storage and fail with a QuotaExceededError. See
    // https://developer.mozilla.org/en-US/docs/Web/API/Web_Storage_API#Private_Browsing_Incognito_modes
    return false;
  }

  return true;
}
function localstorage_averageResponseTime() {
  var defaultTime = 120;
  var userAgent = navigator.userAgent.toLowerCase();

  if (userAgent.includes('safari') && !userAgent.includes('chrome')) {
    // safari is much slower so this time is higher
    return defaultTime * 2;
  }

  return defaultTime;
}
/* harmony default export */ var localstorage = ({
  create: localstorage_create,
  close: localstorage_close,
  onMessage: localstorage_onMessage,
  postMessage: localstorage_postMessage,
  canBeUsed: localstorage_canBeUsed,
  type: localstorage_type,
  averageResponseTime: localstorage_averageResponseTime,
  microSeconds: localstorage_microSeconds
});
;// CONCATENATED MODULE: ./node_modules/broadcast-channel/dist/esbrowser/methods/simulate.js

var simulate_microSeconds = microSeconds;
var simulate_type = 'simulate';
var SIMULATE_CHANNELS = new Set();
function simulate_create(channelName) {
  var state = {
    name: channelName,
    messagesCallback: null
  };
  SIMULATE_CHANNELS.add(state);
  return state;
}
function simulate_close(channelState) {
  SIMULATE_CHANNELS["delete"](channelState);
}
function simulate_postMessage(channelState, messageJson) {
  return new Promise(function (res) {
    return setTimeout(function () {
      var channelArray = Array.from(SIMULATE_CHANNELS);
      channelArray.filter(function (channel) {
        return channel.name === channelState.name;
      }).filter(function (channel) {
        return channel !== channelState;
      }).filter(function (channel) {
        return !!channel.messagesCallback;
      }).forEach(function (channel) {
        return channel.messagesCallback(messageJson);
      });
      res();
    }, 5);
  });
}
function simulate_onMessage(channelState, fn) {
  channelState.messagesCallback = fn;
}
function simulate_canBeUsed() {
  return true;
}
function simulate_averageResponseTime() {
  return 5;
}
/* harmony default export */ var simulate = ({
  create: simulate_create,
  close: simulate_close,
  onMessage: simulate_onMessage,
  postMessage: simulate_postMessage,
  canBeUsed: simulate_canBeUsed,
  type: simulate_type,
  averageResponseTime: simulate_averageResponseTime,
  microSeconds: simulate_microSeconds
});
;// CONCATENATED MODULE: ./node_modules/broadcast-channel/dist/esbrowser/method-chooser.js



 // the line below will be removed from es5/browser builds


var METHODS = [methods_native, // fastest
indexed_db, localstorage];
function method_chooser_chooseMethod(options) {
  var chooseMethods = [].concat(options.methods, METHODS).filter(Boolean); // the line below will be removed from es5/browser builds


  if (options.type) {
    if (options.type === 'simulate') {
      // only use simulate-method if directly chosen
      return simulate;
    }

    var ret = chooseMethods.find(function (m) {
      return m.type === options.type;
    });
    if (!ret) throw new Error('method-type ' + options.type + ' not found');else return ret;
  }
  /**
   * if no webworker support is needed,
   * remove idb from the list so that localstorage is been chosen
   */


  if (!options.webWorkerSupport) {
    chooseMethods = chooseMethods.filter(function (m) {
      return m.type !== 'idb';
    });
  }

  var useMethod = chooseMethods.find(function (method) {
    return method.canBeUsed();
  });
  if (!useMethod) throw new Error("No useable method found in " + JSON.stringify(METHODS.map(function (m) {
    return m.type;
  })));else return useMethod;
}
;// CONCATENATED MODULE: ./node_modules/broadcast-channel/dist/esbrowser/broadcast-channel.js



/**
 * Contains all open channels,
 * used in tests to ensure everything is closed.
 */

var OPEN_BROADCAST_CHANNELS = new Set();
var lastId = 0;
var broadcast_channel_BroadcastChannel = function BroadcastChannel(name, options) {
  // identifier of the channel to debug stuff
  this.id = lastId++;
  OPEN_BROADCAST_CHANNELS.add(this);
  this.name = name;

  if (ENFORCED_OPTIONS) {
    options = ENFORCED_OPTIONS;
  }

  this.options = options_fillOptionsWithDefaults(options);
  this.method = method_chooser_chooseMethod(this.options); // isListening

  this._iL = false;
  /**
   * _onMessageListener
   * setting onmessage twice,
   * will overwrite the first listener
   */

  this._onML = null;
  /**
   * _addEventListeners
   */

  this._addEL = {
    message: [],
    internal: []
  };
  /**
   * Unsend message promises
   * where the sending is still in progress
   * @type {Set<Promise>}
   */

  this._uMP = new Set();
  /**
   * _beforeClose
   * array of promises that will be awaited
   * before the channel is closed
   */

  this._befC = [];
  /**
   * _preparePromise
   */

  this._prepP = null;

  _prepareChannel(this);
}; // STATICS

/**
 * used to identify if someone overwrites
 * window.BroadcastChannel with this
 * See methods/native.js
 */

broadcast_channel_BroadcastChannel._pubkey = true;
/**
 * clears the tmp-folder if is node
 * @return {Promise<boolean>} true if has run, false if not node
 */

function clearNodeFolder(options) {
  options = fillOptionsWithDefaults(options);
  var method = chooseMethod(options);

  if (method.type === 'node') {
    return method.clearNodeFolder().then(function () {
      return true;
    });
  } else {
    return PROMISE_RESOLVED_FALSE;
  }
}
/**
 * if set, this method is enforced,
 * no mather what the options are
 */

var ENFORCED_OPTIONS;
function enforceOptions(options) {
  ENFORCED_OPTIONS = options;
} // PROTOTYPE

broadcast_channel_BroadcastChannel.prototype = {
  postMessage: function postMessage(msg) {
    if (this.closed) {
      throw new Error('BroadcastChannel.postMessage(): ' + 'Cannot post message after channel has closed ' +
      /**
       * In the past when this error appeared, it was realy hard to debug.
       * So now we log the msg together with the error so it at least
       * gives some clue about where in your application this happens.
       */
      JSON.stringify(msg));
    }

    return _post(this, 'message', msg);
  },
  postInternal: function postInternal(msg) {
    return _post(this, 'internal', msg);
  },

  set onmessage(fn) {
    var time = this.method.microSeconds();
    var listenObj = {
      time: time,
      fn: fn
    };

    _removeListenerObject(this, 'message', this._onML);

    if (fn && typeof fn === 'function') {
      this._onML = listenObj;

      _addListenerObject(this, 'message', listenObj);
    } else {
      this._onML = null;
    }
  },

  addEventListener: function addEventListener(type, fn) {
    var time = this.method.microSeconds();
    var listenObj = {
      time: time,
      fn: fn
    };

    _addListenerObject(this, type, listenObj);
  },
  removeEventListener: function removeEventListener(type, fn) {
    var obj = this._addEL[type].find(function (obj) {
      return obj.fn === fn;
    });

    _removeListenerObject(this, type, obj);
  },
  close: function close() {
    var _this = this;

    if (this.closed) {
      return;
    }

    OPEN_BROADCAST_CHANNELS["delete"](this);
    this.closed = true;
    var awaitPrepare = this._prepP ? this._prepP : PROMISE_RESOLVED_VOID;
    this._onML = null;
    this._addEL.message = [];
    return awaitPrepare // wait until all current sending are processed
    .then(function () {
      return Promise.all(Array.from(_this._uMP));
    }) // run before-close hooks
    .then(function () {
      return Promise.all(_this._befC.map(function (fn) {
        return fn();
      }));
    }) // close the channel
    .then(function () {
      return _this.method.close(_this._state);
    });
  },

  get type() {
    return this.method.type;
  },

  get isClosed() {
    return this.closed;
  }

};
/**
 * Post a message over the channel
 * @returns {Promise} that resolved when the message sending is done
 */

function _post(broadcastChannel, type, msg) {
  var time = broadcastChannel.method.microSeconds();
  var msgObj = {
    time: time,
    type: type,
    data: msg
  };
  var awaitPrepare = broadcastChannel._prepP ? broadcastChannel._prepP : PROMISE_RESOLVED_VOID;
  return awaitPrepare.then(function () {
    var sendPromise = broadcastChannel.method.postMessage(broadcastChannel._state, msgObj); // add/remove to unsend messages list

    broadcastChannel._uMP.add(sendPromise);

    sendPromise["catch"]().then(function () {
      return broadcastChannel._uMP["delete"](sendPromise);
    });
    return sendPromise;
  });
}

function _prepareChannel(channel) {
  var maybePromise = channel.method.create(channel.name, channel.options);

  if (util_isPromise(maybePromise)) {
    channel._prepP = maybePromise;
    maybePromise.then(function (s) {
      // used in tests to simulate slow runtime

      /*if (channel.options.prepareDelay) {
           await new Promise(res => setTimeout(res, this.options.prepareDelay));
      }*/
      channel._state = s;
    });
  } else {
    channel._state = maybePromise;
  }
}

function _hasMessageListeners(channel) {
  if (channel._addEL.message.length > 0) return true;
  if (channel._addEL.internal.length > 0) return true;
  return false;
}

function _addListenerObject(channel, type, obj) {
  channel._addEL[type].push(obj);

  _startListening(channel);
}

function _removeListenerObject(channel, type, obj) {
  channel._addEL[type] = channel._addEL[type].filter(function (o) {
    return o !== obj;
  });

  _stopListening(channel);
}

function _startListening(channel) {
  if (!channel._iL && _hasMessageListeners(channel)) {
    // someone is listening, start subscribing
    var listenerFn = function listenerFn(msgObj) {
      channel._addEL[msgObj.type].forEach(function (listenerObject) {
        /**
         * Getting the current time in JavaScript has no good precision.
         * So instead of only listening to events that happend 'after' the listener
         * was added, we also listen to events that happended 100ms before it.
         * This ensures that when another process, like a WebWorker, sends events
         * we do not miss them out because their timestamp is a bit off compared to the main process.
         * Not doing this would make messages missing when we send data directly after subscribing and awaiting a response.
         * @link https://johnresig.com/blog/accuracy-of-javascript-time/
         */
        var hundredMsInMicro = 100 * 1000;
        var minMessageTime = listenerObject.time - hundredMsInMicro;

        if (msgObj.time >= minMessageTime) {
          listenerObject.fn(msgObj.data);
        }
      });
    };

    var time = channel.method.microSeconds();

    if (channel._prepP) {
      channel._prepP.then(function () {
        channel._iL = true;
        channel.method.onMessage(channel._state, listenerFn, time);
      });
    } else {
      channel._iL = true;
      channel.method.onMessage(channel._state, listenerFn, time);
    }
  }
}

function _stopListening(channel) {
  if (channel._iL && !_hasMessageListeners(channel)) {
    // noone is listening, stop subscribing
    channel._iL = false;
    var time = channel.method.microSeconds();
    channel.method.onMessage(channel._state, null, time);
  }
}
// EXTERNAL MODULE: ./node_modules/detect-node/browser.js
var browser = __webpack_require__(25643);
var browser_default = /*#__PURE__*/__webpack_require__.n(browser);
;// CONCATENATED MODULE: ./node_modules/unload/dist/es/browser.js
/* global WorkerGlobalScope */
function add(fn) {
  if (typeof WorkerGlobalScope === 'function' && self instanceof WorkerGlobalScope) {// this is run inside of a webworker
  } else {
    /**
     * if we are on react-native, there is no window.addEventListener
     * @link https://github.com/pubkey/unload/issues/6
     */
    if (typeof window.addEventListener !== 'function') return;
    /**
     * for normal browser-windows, we use the beforeunload-event
     */

    window.addEventListener('beforeunload', function () {
      fn();
    }, true);
    /**
     * for iframes, we have to use the unload-event
     * @link https://stackoverflow.com/q/47533670/3443137
     */

    window.addEventListener('unload', function () {
      fn();
    }, true);
  }
  /**
   * TODO add fallback for safari-mobile
   * @link https://stackoverflow.com/a/26193516/3443137
   */

}

/* harmony default export */ var es_browser = ({
  add: add
});
// EXTERNAL MODULE: ./node.js (ignored)
var node_ignored_ = __webpack_require__(199);
var node_ignored_default = /*#__PURE__*/__webpack_require__.n(node_ignored_);
;// CONCATENATED MODULE: ./node_modules/unload/dist/es/index.js



var USE_METHOD = (browser_default()) ? (node_ignored_default()) : es_browser;
var LISTENERS = new Set();
var startedListening = false;

function startListening() {
  if (startedListening) return;
  startedListening = true;
  USE_METHOD.add(runAll);
}

function es_add(fn) {
  startListening();
  if (typeof fn !== 'function') throw new Error('Listener is no function');
  LISTENERS.add(fn);
  var addReturn = {
    remove: function remove() {
      return LISTENERS["delete"](fn);
    },
    run: function run() {
      LISTENERS["delete"](fn);
      return fn();
    }
  };
  return addReturn;
}
function runAll() {
  var promises = [];
  LISTENERS.forEach(function (fn) {
    promises.push(fn());
    LISTENERS["delete"](fn);
  });
  return Promise.all(promises);
}
function removeAll() {
  LISTENERS.clear();
}
function getSize() {
  return LISTENERS.size;
}
;// CONCATENATED MODULE: ./node_modules/broadcast-channel/dist/esbrowser/leader-election.js



var LeaderElection = function LeaderElection(broadcastChannel, options) {
  var _this = this;

  this.broadcastChannel = broadcastChannel;
  this._options = options;
  this.isLeader = false;
  this.hasLeader = false;
  this.isDead = false;
  this.token = randomToken();
  /**
   * Apply Queue,
   * used to ensure we do not run applyOnce()
   * in parallel.
   */

  this._aplQ = PROMISE_RESOLVED_VOID; // amount of unfinished applyOnce() calls

  this._aplQC = 0; // things to clean up

  this._unl = []; // _unloads

  this._lstns = []; // _listeners

  this._dpL = function () {}; // onduplicate listener


  this._dpLC = false; // true when onduplicate called

  /**
   * Even when the own instance is not applying,
   * we still listen to messages to ensure the hasLeader flag
   * is set correctly.
   */

  var hasLeaderListener = function hasLeaderListener(msg) {
    if (msg.context === 'leader') {
      if (msg.action === 'death') {
        _this.hasLeader = false;
      }

      if (msg.action === 'tell') {
        _this.hasLeader = true;
      }
    }
  };

  this.broadcastChannel.addEventListener('internal', hasLeaderListener);

  this._lstns.push(hasLeaderListener);
};

LeaderElection.prototype = {
  /**
   * Returns true if the instance is leader,
   * false if not.
   * @async
   */
  applyOnce: function applyOnce( // true if the applyOnce() call came from the fallbackInterval cycle
  isFromFallbackInterval) {
    var _this2 = this;

    if (this.isLeader) {
      return sleep(0, true);
    }

    if (this.isDead) {
      return sleep(0, false);
    }
    /**
     * Already applying more then once,
     * -> wait for the apply queue to be finished.
     */


    if (this._aplQC > 1) {
      return this._aplQ;
    }
    /**
     * Add a new apply-run
     */


    var applyRun = function applyRun() {
      /**
       * Optimization shortcuts.
       * Directly return if a previous run
       * has already elected a leader.
       */
      if (_this2.isLeader) {
        return PROMISE_RESOLVED_TRUE;
      }

      var stopCriteria = false;
      var stopCriteriaPromiseResolve;
      /**
       * Resolves when a stop criteria is reached.
       * Uses as a performance shortcut so we do not
       * have to await the responseTime when it is already clear
       * that the election failed.
       */

      var stopCriteriaPromise = new Promise(function (res) {
        stopCriteriaPromiseResolve = function stopCriteriaPromiseResolve() {
          stopCriteria = true;
          res();
        };
      });
      var recieved = [];

      var handleMessage = function handleMessage(msg) {
        if (msg.context === 'leader' && msg.token != _this2.token) {
          recieved.push(msg);

          if (msg.action === 'apply') {
            // other is applying
            if (msg.token > _this2.token) {
              /**
               * other has higher token
               * -> stop applying and let other become leader.
               */
              stopCriteriaPromiseResolve();
            }
          }

          if (msg.action === 'tell') {
            // other is already leader
            stopCriteriaPromiseResolve();
            _this2.hasLeader = true;
          }
        }
      };

      _this2.broadcastChannel.addEventListener('internal', handleMessage);
      /**
       * If the applyOnce() call came from the fallbackInterval,
       * we can assume that the election runs in the background and
       * not critical process is waiting for it.
       * When this is true, we give the other intances
       * more time to answer to messages in the election cycle.
       * This makes it less likely to elect duplicate leaders.
       * But also it takes longer which is not a problem because we anyway
       * run in the background.
       */


      var waitForAnswerTime = isFromFallbackInterval ? _this2._options.responseTime * 4 : _this2._options.responseTime;

      var applyPromise = _sendMessage(_this2, 'apply') // send out that this one is applying
      .then(function () {
        return Promise.race([sleep(waitForAnswerTime), stopCriteriaPromise.then(function () {
          return Promise.reject(new Error());
        })]);
      }) // send again in case another instance was just created
      .then(function () {
        return _sendMessage(_this2, 'apply');
      }) // let others time to respond
      .then(function () {
        return Promise.race([sleep(waitForAnswerTime), stopCriteriaPromise.then(function () {
          return Promise.reject(new Error());
        })]);
      })["catch"](function () {}).then(function () {
        _this2.broadcastChannel.removeEventListener('internal', handleMessage);

        if (!stopCriteria) {
          // no stop criteria -> own is leader
          return beLeader(_this2).then(function () {
            return true;
          });
        } else {
          // other is leader
          return false;
        }
      });

      return applyPromise;
    };

    this._aplQC = this._aplQC + 1;
    this._aplQ = this._aplQ.then(function () {
      return applyRun();
    }).then(function () {
      _this2._aplQC = _this2._aplQC - 1;
    });
    return this._aplQ.then(function () {
      return _this2.isLeader;
    });
  },
  awaitLeadership: function awaitLeadership() {
    if (
    /* _awaitLeadershipPromise */
    !this._aLP) {
      this._aLP = _awaitLeadershipOnce(this);
    }

    return this._aLP;
  },

  set onduplicate(fn) {
    this._dpL = fn;
  },

  die: function die() {
    var _this3 = this;

    this._lstns.forEach(function (listener) {
      return _this3.broadcastChannel.removeEventListener('internal', listener);
    });

    this._lstns = [];

    this._unl.forEach(function (uFn) {
      return uFn.remove();
    });

    this._unl = [];

    if (this.isLeader) {
      this.hasLeader = false;
      this.isLeader = false;
    }

    this.isDead = true;
    return _sendMessage(this, 'death');
  }
};
/**
 * @param leaderElector {LeaderElector}
 */

function _awaitLeadershipOnce(leaderElector) {
  if (leaderElector.isLeader) {
    return PROMISE_RESOLVED_VOID;
  }

  return new Promise(function (res) {
    var resolved = false;

    function finish() {
      if (resolved) {
        return;
      }

      resolved = true;
      leaderElector.broadcastChannel.removeEventListener('internal', whenDeathListener);
      res(true);
    } // try once now


    leaderElector.applyOnce().then(function () {
      if (leaderElector.isLeader) {
        finish();
      }
    });
    /**
     * Try on fallbackInterval
     * @recursive
     */

    var tryOnFallBack = function tryOnFallBack() {
      return sleep(leaderElector._options.fallbackInterval).then(function () {
        if (leaderElector.isDead || resolved) {
          return;
        }

        if (leaderElector.isLeader) {
          finish();
        } else {
          return leaderElector.applyOnce(true).then(function () {
            if (leaderElector.isLeader) {
              finish();
            } else {
              tryOnFallBack();
            }
          });
        }
      });
    };

    tryOnFallBack(); // try when other leader dies

    var whenDeathListener = function whenDeathListener(msg) {
      if (msg.context === 'leader' && msg.action === 'death') {
        leaderElector.hasLeader = false;
        leaderElector.applyOnce().then(function () {
          if (leaderElector.isLeader) {
            finish();
          }
        });
      }
    };

    leaderElector.broadcastChannel.addEventListener('internal', whenDeathListener);

    leaderElector._lstns.push(whenDeathListener);
  });
}
/**
 * sends and internal message over the broadcast-channel
 */


function _sendMessage(leaderElector, action) {
  var msgJson = {
    context: 'leader',
    action: action,
    token: leaderElector.token
  };
  return leaderElector.broadcastChannel.postInternal(msgJson);
}

function beLeader(leaderElector) {
  leaderElector.isLeader = true;
  leaderElector.hasLeader = true;
  var unloadFn = es_add(function () {
    return leaderElector.die();
  });

  leaderElector._unl.push(unloadFn);

  var isLeaderListener = function isLeaderListener(msg) {
    if (msg.context === 'leader' && msg.action === 'apply') {
      _sendMessage(leaderElector, 'tell');
    }

    if (msg.context === 'leader' && msg.action === 'tell' && !leaderElector._dpLC) {
      /**
       * another instance is also leader!
       * This can happen on rare events
       * like when the CPU is at 100% for long time
       * or the tabs are open very long and the browser throttles them.
       * @link https://github.com/pubkey/broadcast-channel/issues/414
       * @link https://github.com/pubkey/broadcast-channel/issues/385
       */
      leaderElector._dpLC = true;

      leaderElector._dpL(); // message the lib user so the app can handle the problem


      _sendMessage(leaderElector, 'tell'); // ensure other leader also knows the problem

    }
  };

  leaderElector.broadcastChannel.addEventListener('internal', isLeaderListener);

  leaderElector._lstns.push(isLeaderListener);

  return _sendMessage(leaderElector, 'tell');
}

function leader_election_fillOptionsWithDefaults(options, channel) {
  if (!options) options = {};
  options = JSON.parse(JSON.stringify(options));

  if (!options.fallbackInterval) {
    options.fallbackInterval = 3000;
  }

  if (!options.responseTime) {
    options.responseTime = channel.method.averageResponseTime(channel.options);
  }

  return options;
}

function createLeaderElection(channel, options) {
  if (channel._leaderElector) {
    throw new Error('BroadcastChannel already has a leader-elector');
  }

  options = leader_election_fillOptionsWithDefaults(options, channel);
  var elector = new LeaderElection(channel, options);

  channel._befC.push(function () {
    return elector.die();
  });

  channel._leaderElector = elector;
  return elector;
}
;// CONCATENATED MODULE: ./node_modules/broadcast-channel/dist/esbrowser/index.js


;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/services/SyncStorageService.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */







class SyncStorageService {
    constructor(tokenManager, options = {}) {
        this.started = false;
        this.enablePostMessage = true;
        this.tokenManager = tokenManager;
        this.options = options;
        this.onTokenAddedHandler = this.onTokenAddedHandler.bind(this);
        this.onTokenRemovedHandler = this.onTokenRemovedHandler.bind(this);
        this.onTokenRenewedHandler = this.onTokenRenewedHandler.bind(this);
        this.onSetStorageHandler = this.onSetStorageHandler.bind(this);
        this.onSyncMessageHandler = this.onSyncMessageHandler.bind(this);
    }
    requiresLeadership() {
        return false;
    }
    isStarted() {
        return this.started;
    }
    canStart() {
        return !!this.options.syncStorage && isBrowser() && this.tokenManager.hasSharedStorage();
    }
    async start() {
        if (this.canStart()) {
            await this.stop();
            const { syncChannelName } = this.options;
            this.channel = new broadcast_channel_BroadcastChannel(syncChannelName);
            this.tokenManager.on(EVENT_ADDED, this.onTokenAddedHandler);
            this.tokenManager.on(EVENT_REMOVED, this.onTokenRemovedHandler);
            this.tokenManager.on(EVENT_RENEWED, this.onTokenRenewedHandler);
            this.tokenManager.on(EVENT_SET_STORAGE, this.onSetStorageHandler);
            this.channel.addEventListener('message', this.onSyncMessageHandler);
            this.started = true;
        }
    }
    async stop() {
        var _a, _b;
        if (this.started) {
            this.tokenManager.off(EVENT_ADDED, this.onTokenAddedHandler);
            this.tokenManager.off(EVENT_REMOVED, this.onTokenRemovedHandler);
            this.tokenManager.off(EVENT_RENEWED, this.onTokenRenewedHandler);
            this.tokenManager.off(EVENT_SET_STORAGE, this.onSetStorageHandler);
            (_a = this.channel) === null || _a === void 0 ? void 0 : _a.removeEventListener('message', this.onSyncMessageHandler);
            await ((_b = this.channel) === null || _b === void 0 ? void 0 : _b.close());
            this.channel = undefined;
            this.started = false;
        }
    }
    onTokenAddedHandler(key, token) {
        var _a;
        if (!this.enablePostMessage) {
            return;
        }
        (_a = this.channel) === null || _a === void 0 ? void 0 : _a.postMessage({
            type: EVENT_ADDED,
            key,
            token
        });
    }
    onTokenRemovedHandler(key, token) {
        var _a;
        if (!this.enablePostMessage) {
            return;
        }
        (_a = this.channel) === null || _a === void 0 ? void 0 : _a.postMessage({
            type: EVENT_REMOVED,
            key,
            token
        });
    }
    onTokenRenewedHandler(key, token, oldToken) {
        var _a;
        if (!this.enablePostMessage) {
            return;
        }
        (_a = this.channel) === null || _a === void 0 ? void 0 : _a.postMessage({
            type: EVENT_RENEWED,
            key,
            token,
            oldToken
        });
    }
    onSetStorageHandler(storage) {
        var _a;
        (_a = this.channel) === null || _a === void 0 ? void 0 : _a.postMessage({
            type: EVENT_SET_STORAGE,
            storage
        });
    }
    onSyncMessageHandler(msg) {
        this.enablePostMessage = false;
        switch (msg.type) {
            case EVENT_SET_STORAGE:
                this.tokenManager.getStorage().setStorage(msg.storage);
                break;
            case EVENT_ADDED:
                this.tokenManager.emitAdded(msg.key, msg.token);
                this.tokenManager.setExpireEventTimeout(msg.key, msg.token);
                break;
            case EVENT_REMOVED:
                this.tokenManager.clearExpireEventTimeout(msg.key);
                this.tokenManager.emitRemoved(msg.key, msg.token);
                break;
            case EVENT_RENEWED:
                this.tokenManager.emitRenewed(msg.key, msg.token, msg.oldToken);
                break;
        }
        this.enablePostMessage = true;
    }
}


//# sourceMappingURL=SyncStorageService.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/services/LeaderElectionService.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */




class LeaderElectionService {
    constructor(options = {}) {
        this.started = false;
        this.options = options;
        this.onLeaderDuplicate = this.onLeaderDuplicate.bind(this);
        this.onLeader = this.onLeader.bind(this);
    }
    onLeaderDuplicate() {
    }
    async onLeader() {
        var _a, _b;
        await ((_b = (_a = this.options).onLeader) === null || _b === void 0 ? void 0 : _b.call(_a));
    }
    isLeader() {
        var _a;
        return !!((_a = this.elector) === null || _a === void 0 ? void 0 : _a.isLeader);
    }
    hasLeader() {
        var _a;
        return !!((_a = this.elector) === null || _a === void 0 ? void 0 : _a.hasLeader);
    }
    async start() {
        await this.stop();
        if (this.canStart()) {
            const { electionChannelName } = this.options;
            this.channel = new broadcast_channel_BroadcastChannel(electionChannelName);
            this.elector = createLeaderElection(this.channel);
            this.elector.onduplicate = this.onLeaderDuplicate;
            this.elector.awaitLeadership().then(this.onLeader);
            this.started = true;
        }
    }
    async stop() {
        if (this.started) {
            if (this.elector) {
                await this.elector.die();
                this.elector = undefined;
            }
            if (this.channel) {
                this.channel.postInternal = () => Promise.resolve();
                await this.channel.close();
                this.channel = undefined;
            }
            this.started = false;
        }
    }
    requiresLeadership() {
        return false;
    }
    isStarted() {
        return this.started;
    }
    canStart() {
        return isBrowser();
    }
}


//# sourceMappingURL=LeaderElectionService.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/ServiceManager.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */






const AUTO_RENEW = 'autoRenew';
const SYNC_STORAGE = 'syncStorage';
const LEADER_ELECTION = 'leaderElection';
class ServiceManager {
    constructor(sdk, options = {}) {
        this.sdk = sdk;
        this.onLeader = this.onLeader.bind(this);
        const { autoRenew, autoRemove, syncStorage } = sdk.tokenManager.getOptions();
        options.electionChannelName = options.electionChannelName || options.broadcastChannelName;
        this.options = Object.assign({}, ServiceManager.defaultOptions, { autoRenew, autoRemove, syncStorage }, {
            electionChannelName: `${sdk.options.clientId}-election`,
            syncChannelName: `${sdk.options.clientId}-sync`,
        }, removeNils(options));
        this.started = false;
        this.services = new Map();
        ServiceManager.knownServices.forEach(name => {
            const svc = this.createService(name);
            if (svc) {
                this.services.set(name, svc);
            }
        });
    }
    async onLeader() {
        if (this.started) {
            await this.startServices();
        }
    }
    isLeader() {
        var _a;
        return (_a = this.getService(LEADER_ELECTION)) === null || _a === void 0 ? void 0 : _a.isLeader();
    }
    isLeaderRequired() {
        return [...this.services.values()].some(srv => srv.canStart() && srv.requiresLeadership());
    }
    async start() {
        if (this.started) {
            return;
        }
        await this.startServices();
        this.started = true;
    }
    async stop() {
        await this.stopServices();
        this.started = false;
    }
    getService(name) {
        return this.services.get(name);
    }
    async startServices() {
        for (const [name, srv] of this.services.entries()) {
            if (this.canStartService(name, srv)) {
                await srv.start();
            }
        }
    }
    async stopServices() {
        for (const srv of this.services.values()) {
            await srv.stop();
        }
    }
    canStartService(name, srv) {
        let canStart = srv.canStart() && !srv.isStarted();
        if (name === LEADER_ELECTION) {
            canStart && (canStart = this.isLeaderRequired());
        }
        else if (srv.requiresLeadership()) {
            canStart && (canStart = this.isLeader());
        }
        return canStart;
    }
    createService(name) {
        const tokenManager = this.sdk.tokenManager;
        let service;
        switch (name) {
            case LEADER_ELECTION:
                service = new LeaderElectionService(Object.assign(Object.assign({}, this.options), { onLeader: this.onLeader }));
                break;
            case AUTO_RENEW:
                service = new AutoRenewService(tokenManager, Object.assign({}, this.options));
                break;
            case SYNC_STORAGE:
                service = new SyncStorageService(tokenManager, Object.assign({}, this.options));
                break;
            default:
                throw new Error(`Unknown service ${name}`);
        }
        return service;
    }
}
ServiceManager.knownServices = [AUTO_RENEW, SYNC_STORAGE, LEADER_ELECTION];
ServiceManager.defaultOptions = {
    autoRenew: true,
    autoRemove: true,
    syncStorage: true
};


//# sourceMappingURL=ServiceManager.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/PromiseQueue.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */




class PromiseQueue {
    constructor(options = { quiet: false }) {
        this.queue = [];
        this.running = false;
        this.options = options;
    }
    push(method, thisObject, ...args) {
        return new Promise((resolve, reject) => {
            if (this.queue.length > 0) {
                if (this.options.quiet !== false) {
                    warn('Async method is being called but another async method is already running. ' +
                        'The new method will be delayed until the previous method completes.');
                }
            }
            this.queue.push({
                method,
                thisObject,
                args,
                resolve,
                reject
            });
            this.run();
        });
    }
    run() {
        if (this.running) {
            return;
        }
        if (this.queue.length === 0) {
            return;
        }
        this.running = true;
        var queueItem = this.queue.shift();
        var res = queueItem.method.apply(queueItem.thisObject, queueItem.args);
        if (isPromise(res)) {
            res.then(queueItem.resolve, queueItem.reject).finally(() => {
                this.running = false;
                this.run();
            });
        }
        else {
            queueItem.resolve(res);
            this.running = false;
            this.run();
        }
    }
}


//# sourceMappingURL=PromiseQueue.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/browser/fingerprint.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */







function fingerprint(sdk, options) {
    options = options || {};
    if (!isFingerprintSupported()) {
        return Promise.reject(new AuthSdkError_AuthSdkError('Fingerprinting is not supported on this device'));
    }
    var timeout;
    var iframe;
    var listener;
    var promise = new Promise(function (resolve, reject) {
        iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        listener = function listener(e) {
            if (!e || !e.data || e.origin !== sdk.getIssuerOrigin()) {
                return;
            }
            try {
                var msg = JSON.parse(e.data);
            }
            catch (err) {
                return;
            }
            if (!msg) {
                return;
            }
            if (msg.type === 'FingerprintAvailable') {
                return resolve(msg.fingerprint);
            }
            if (msg.type === 'FingerprintServiceReady') {
                e.source.postMessage(JSON.stringify({
                    type: 'GetFingerprint'
                }), e.origin);
            }
        };
        addListener(window, 'message', listener);
        iframe.src = sdk.getIssuerOrigin() + '/auth/services/devicefingerprint';
        document.body.appendChild(iframe);
        timeout = setTimeout(function () {
            reject(new AuthSdkError_AuthSdkError('Fingerprinting timed out'));
        }, (options === null || options === void 0 ? void 0 : options.timeout) || 15000);
    });
    return promise.finally(function () {
        clearTimeout(timeout);
        removeListener(window, 'message', listener);
        if (document.body.contains(iframe)) {
            iframe.parentElement.removeChild(iframe);
        }
    });
}


//# sourceMappingURL=fingerprint.js.map

// EXTERNAL MODULE: ./node_modules/p-cancelable/index.js
var p_cancelable = __webpack_require__(80341);
;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/AuthStateManager.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */









const INITIAL_AUTH_STATE = null;
const DEFAULT_PENDING = {
    updateAuthStatePromise: null,
    canceledTimes: 0
};
const EVENT_AUTH_STATE_CHANGE = 'authStateChange';
const MAX_PROMISE_CANCEL_TIMES = 10;
const isSameAuthState = (prevState, state) => {
    if (!prevState) {
        return false;
    }
    return prevState.isAuthenticated === state.isAuthenticated
        && JSON.stringify(prevState.idToken) === JSON.stringify(state.idToken)
        && JSON.stringify(prevState.accessToken) === JSON.stringify(state.accessToken)
        && prevState.error === state.error;
};
class AuthStateManager {
    constructor(sdk) {
        if (!sdk.emitter) {
            throw new AuthSdkError_AuthSdkError('Emitter should be initialized before AuthStateManager');
        }
        this._sdk = sdk;
        this._pending = Object.assign({}, DEFAULT_PENDING);
        this._authState = INITIAL_AUTH_STATE;
        this._logOptions = {};
        this._prevAuthState = null;
        this._transformQueue = new PromiseQueue({
            quiet: true
        });
        sdk.tokenManager.on(EVENT_ADDED, (key, token) => {
            this._setLogOptions({ event: EVENT_ADDED, key, token });
            this.updateAuthState();
        });
        sdk.tokenManager.on(EVENT_REMOVED, (key, token) => {
            this._setLogOptions({ event: EVENT_REMOVED, key, token });
            this.updateAuthState();
        });
    }
    _setLogOptions(options) {
        this._logOptions = options;
    }
    getAuthState() {
        return this._authState;
    }
    getPreviousAuthState() {
        return this._prevAuthState;
    }
    async updateAuthState() {
        const { transformAuthState, devMode } = this._sdk.options;
        const log = (status) => {
            const { event, key, token } = this._logOptions;
            getConsole().group(`OKTA-AUTH-JS:updateAuthState: Event:${event} Status:${status}`);
            getConsole().log(key, token);
            getConsole().log('Current authState', this._authState);
            getConsole().groupEnd();
            this._logOptions = {};
        };
        const emitAuthStateChange = (authState) => {
            if (isSameAuthState(this._authState, authState)) {
                devMode && log('unchanged');
                return;
            }
            this._prevAuthState = this._authState;
            this._authState = authState;
            this._sdk.emitter.emit(EVENT_AUTH_STATE_CHANGE, Object.assign({}, authState));
            devMode && log('emitted');
        };
        const finalPromise = (origPromise) => {
            return this._pending.updateAuthStatePromise.then(() => {
                const curPromise = this._pending.updateAuthStatePromise;
                if (curPromise && curPromise !== origPromise) {
                    return finalPromise(curPromise);
                }
                return this.getAuthState();
            });
        };
        if (this._pending.updateAuthStatePromise) {
            if (this._pending.canceledTimes >= MAX_PROMISE_CANCEL_TIMES) {
                devMode && log('terminated');
                return finalPromise(this._pending.updateAuthStatePromise);
            }
            else {
                this._pending.updateAuthStatePromise.cancel();
            }
        }
        const cancelablePromise = new p_cancelable((resolve, _, onCancel) => {
            onCancel.shouldReject = false;
            onCancel(() => {
                this._pending.updateAuthStatePromise = null;
                this._pending.canceledTimes = this._pending.canceledTimes + 1;
                devMode && log('canceled');
            });
            const emitAndResolve = (authState) => {
                if (cancelablePromise.isCanceled) {
                    resolve();
                    return;
                }
                emitAuthStateChange(authState);
                resolve();
                this._pending = Object.assign({}, DEFAULT_PENDING);
            };
            this._sdk.isAuthenticated()
                .then(() => {
                if (cancelablePromise.isCanceled) {
                    resolve();
                    return;
                }
                const { accessToken, idToken, refreshToken } = this._sdk.tokenManager.getTokensSync();
                const authState = {
                    accessToken,
                    idToken,
                    refreshToken,
                    isAuthenticated: !!(accessToken && idToken)
                };
                const promise = transformAuthState
                    ? this._transformQueue.push(transformAuthState, null, this._sdk, authState)
                    : Promise.resolve(authState);
                promise
                    .then(authState => emitAndResolve(authState))
                    .catch(error => emitAndResolve({
                    accessToken,
                    idToken,
                    refreshToken,
                    isAuthenticated: false,
                    error
                }));
            });
        });
        this._pending.updateAuthStatePromise = cancelablePromise;
        return finalPromise(cancelablePromise);
    }
    subscribe(handler) {
        this._sdk.emitter.on(EVENT_AUTH_STATE_CHANGE, handler);
    }
    unsubscribe(handler) {
        this._sdk.emitter.off(EVENT_AUTH_STATE_CHANGE, handler);
    }
}


//# sourceMappingURL=AuthStateManager.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/util/storage.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */

function isLocalStorageAvailable() {
    const test = 'test';
    try {
        localStorage.setItem(test, test);
        localStorage.removeItem(test);
        return true;
    }
    catch (_a) {
        return false;
    }
}


//# sourceMappingURL=storage.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/SavedObject.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */




class SavedObject {
    constructor(storage, storageName) {
        if (!storage) {
            throw new AuthSdkError_AuthSdkError('"storage" is required');
        }
        if (typeof storageName !== 'string' || !storageName.length) {
            throw new AuthSdkError_AuthSdkError('"storageName" is required');
        }
        this.storageName = storageName;
        this.storageProvider = storage;
    }
    getItem(key) {
        return this.getStorage()[key];
    }
    setItem(key, value) {
        return this.updateStorage(key, value);
    }
    removeItem(key) {
        return this.clearStorage(key);
    }
    isSharedStorage() {
        var _a, _b;
        return isLocalStorageAvailable() && this.storageProvider === localStorage
            || !!((_b = (_a = this.storageProvider).isSharedStorage) === null || _b === void 0 ? void 0 : _b.call(_a));
    }
    getStorage() {
        var storageString = this.storageProvider.getItem(this.storageName);
        storageString = storageString || '{}';
        try {
            return JSON.parse(storageString);
        }
        catch (e) {
            throw new AuthSdkError_AuthSdkError('Unable to parse storage string: ' + this.storageName);
        }
    }
    setStorage(obj) {
        try {
            var storageString = obj ? JSON.stringify(obj) : '{}';
            this.storageProvider.setItem(this.storageName, storageString);
        }
        catch (e) {
            throw new AuthSdkError_AuthSdkError('Unable to set storage: ' + this.storageName);
        }
    }
    clearStorage(key) {
        if (!key) {
            if (this.storageProvider.removeItem) {
                this.storageProvider.removeItem(this.storageName);
            }
            else {
                this.setStorage();
            }
            return;
        }
        var obj = this.getStorage();
        delete obj[key];
        this.setStorage(obj);
    }
    updateStorage(key, value) {
        var obj = this.getStorage();
        obj[key] = value;
        this.setStorage(obj);
    }
}


//# sourceMappingURL=SavedObject.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/StorageManager.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */







function logServerSideMemoryStorageWarning(options) {
    if (!isBrowser() && !options.storageProvider && !options.storageProvider) {
        warn('Memory storage can only support simple single user use case on server side, please provide custom storageProvider or storageKey if advanced scenarios need to be supported.');
    }
}
class StorageManager {
    constructor(storageManagerOptions, cookieOptions, storageUtil) {
        this.storageManagerOptions = storageManagerOptions;
        this.cookieOptions = cookieOptions;
        this.storageUtil = storageUtil;
    }
    getOptionsForSection(sectionName, overrideOptions) {
        return Object.assign({}, this.storageManagerOptions[sectionName], overrideOptions);
    }
    getStorage(options) {
        options = Object.assign({}, this.cookieOptions, options);
        if (options.storageProvider) {
            return options.storageProvider;
        }
        let { storageType, storageTypes } = options;
        if (storageType === 'sessionStorage') {
            options.sessionCookie = true;
        }
        if (storageType && storageTypes) {
            const idx = storageTypes.indexOf(storageType);
            if (idx >= 0) {
                storageTypes = storageTypes.slice(idx);
                storageType = undefined;
            }
        }
        if (!storageType) {
            storageType = this.storageUtil.findStorageType(storageTypes);
        }
        return this.storageUtil.getStorageByType(storageType, options);
    }
    getTransactionStorage(options) {
        options = this.getOptionsForSection('transaction', options);
        logServerSideMemoryStorageWarning(options);
        const storage = this.getStorage(options);
        const storageKey = options.storageKey || TRANSACTION_STORAGE_NAME;
        return new SavedObject(storage, storageKey);
    }
    getSharedTansactionStorage(options) {
        options = this.getOptionsForSection('shared-transaction', options);
        logServerSideMemoryStorageWarning(options);
        const storage = this.getStorage(options);
        const storageKey = options.storageKey || SHARED_TRANSACTION_STORAGE_NAME;
        return new SavedObject(storage, storageKey);
    }
    getOriginalUriStorage(options) {
        options = this.getOptionsForSection('original-uri', options);
        logServerSideMemoryStorageWarning(options);
        const storage = this.getStorage(options);
        const storageKey = options.storageKey || ORIGINAL_URI_STORAGE_NAME;
        return new SavedObject(storage, storageKey);
    }
    getIdxResponseStorage(options) {
        let storage;
        if (isBrowser()) {
            try {
                storage = this.storageUtil.getStorageByType('memory', options);
            }
            catch (e) {
                warn('No response storage found, you may want to provide custom implementation for intermediate idx responses to optimize the network traffic');
            }
        }
        else {
            const transactionStorage = this.getTransactionStorage(options);
            if (transactionStorage) {
                storage = {
                    getItem: (key) => {
                        const transaction = transactionStorage.getStorage();
                        if (transaction && transaction[key]) {
                            return transaction[key];
                        }
                        return null;
                    },
                    setItem: (key, val) => {
                        const transaction = transactionStorage.getStorage();
                        if (!transaction) {
                            throw new AuthSdkError_AuthSdkError('Transaction has been cleared, failed to save idxState');
                        }
                        transaction[key] = val;
                        transactionStorage.setStorage(transaction);
                    },
                    removeItem: (key) => {
                        const transaction = transactionStorage.getStorage();
                        if (!transaction) {
                            return;
                        }
                        delete transaction[key];
                        transactionStorage.setStorage(transaction);
                    }
                };
            }
        }
        if (!storage) {
            return null;
        }
        return new SavedObject(storage, IDX_RESPONSE_STORAGE_NAME);
    }
    getTokenStorage(options) {
        options = this.getOptionsForSection('token', options);
        logServerSideMemoryStorageWarning(options);
        const storage = this.getStorage(options);
        const storageKey = options.storageKey || TOKEN_STORAGE_NAME;
        return new SavedObject(storage, storageKey);
    }
    getHttpCache(options) {
        options = this.getOptionsForSection('cache', options);
        const storage = this.getStorage(options);
        const storageKey = options.storageKey || CACHE_STORAGE_NAME;
        return new SavedObject(storage, storageKey);
    }
    getLegacyPKCEStorage(options) {
        options = this.getOptionsForSection('legacy-pkce', options);
        const storage = this.getStorage(options);
        const storageKey = options.storageKey || PKCE_STORAGE_NAME;
        return new SavedObject(storage, storageKey);
    }
    getLegacyOAuthParamsStorage(options) {
        options = this.getOptionsForSection('legacy-oauth-params', options);
        const storage = this.getStorage(options);
        const storageKey = options.storageKey || REDIRECT_OAUTH_PARAMS_NAME;
        return new SavedObject(storage, storageKey);
    }
}


//# sourceMappingURL=StorageManager.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/types/Transaction.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */

function isObjectWithProperties(obj) {
    if (!obj || typeof obj !== 'object' || Object.values(obj).length === 0) {
        return false;
    }
    return true;
}
function isOAuthTransactionMeta(obj) {
    if (!isObjectWithProperties(obj)) {
        return false;
    }
    return !!obj.redirectUri || !!obj.responseType;
}
function isPKCETransactionMeta(obj) {
    if (!isOAuthTransactionMeta(obj)) {
        return false;
    }
    return !!obj.codeVerifier;
}
function isIdxTransactionMeta(obj) {
    if (!isPKCETransactionMeta(obj)) {
        return false;
    }
    return !!obj.interactionHandle;
}
function isCustomAuthTransactionMeta(obj) {
    if (!isObjectWithProperties(obj)) {
        return false;
    }
    const isAllStringValues = Object.values(obj).find((value) => (typeof value !== 'string')) === undefined;
    return isAllStringValues;
}
function isTransactionMeta(obj) {
    if (isOAuthTransactionMeta(obj) || isCustomAuthTransactionMeta(obj)) {
        return true;
    }
    return false;
}


//# sourceMappingURL=Transaction.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/types/idx-js.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */

function isRawIdxResponse(obj) {
    return obj && obj.version;
}
function isIdxResponse(obj) {
    return obj && isRawIdxResponse(obj.rawIdxState);
}


//# sourceMappingURL=idx-js.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/util/sharedStorage.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */





const MAX_ENTRY_LIFETIME = 30 * 60 * 1000;
function pruneSharedStorage(storageManager) {
    const sharedStorage = storageManager.getSharedTansactionStorage();
    const entries = sharedStorage.getStorage();
    Object.keys(entries).forEach(state => {
        const entry = entries[state];
        const age = Date.now() - entry.dateCreated;
        if (age > MAX_ENTRY_LIFETIME) {
            delete entries[state];
        }
    });
    sharedStorage.setStorage(entries);
}
function saveTransactionToSharedStorage(storageManager, state, meta) {
    const sharedStorage = storageManager.getSharedTansactionStorage();
    const entries = sharedStorage.getStorage();
    entries[state] = {
        dateCreated: Date.now(),
        transaction: meta
    };
    sharedStorage.setStorage(entries);
}
function loadTransactionFromSharedStorage(storageManager, state) {
    const sharedStorage = storageManager.getSharedTansactionStorage();
    const entries = sharedStorage.getStorage();
    const entry = entries[state];
    if (entry && entry.transaction && isTransactionMeta(entry.transaction)) {
        return entry.transaction;
    }
    return null;
}
function clearTransactionFromSharedStorage(storageManager, state) {
    const sharedStorage = storageManager.getSharedTansactionStorage();
    const entries = sharedStorage.getStorage();
    delete entries[state];
    sharedStorage.setStorage(entries);
}


//# sourceMappingURL=sharedStorage.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/TransactionManager.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */










class TransactionManager {
    constructor(options) {
        this.storageManager = options.storageManager;
        this.legacyWidgetSupport = options.legacyWidgetSupport === false ? false : true;
        this.saveNonceCookie = options.saveNonceCookie === false ? false : true;
        this.saveStateCookie = options.saveStateCookie === false ? false : true;
        this.saveParamsCookie = options.saveParamsCookie === false ? false : true;
        this.enableSharedStorage = options.enableSharedStorage === false ? false : true;
        this.saveLastResponse = options.saveLastResponse === false ? false : true;
        this.options = options;
    }
    clear(options = {}) {
        const transactionStorage = this.storageManager.getTransactionStorage();
        const meta = transactionStorage.getStorage();
        transactionStorage.clearStorage();
        if (this.enableSharedStorage && options.clearSharedStorage !== false) {
            const state = options.state || (meta === null || meta === void 0 ? void 0 : meta.state);
            if (state) {
                clearTransactionFromSharedStorage(this.storageManager, state);
            }
        }
        if (options.clearIdxResponse !== false) {
            this.clearIdxResponse();
        }
        if (!this.legacyWidgetSupport) {
            return;
        }
        if (options.oauth) {
            this.clearLegacyOAuthParams();
        }
        if (options.pkce) {
            this.clearLegacyPKCE();
        }
    }
    save(meta, options = {}) {
        let storage = this.storageManager.getTransactionStorage();
        const obj = storage.getStorage();
        if (isTransactionMeta(obj) && !options.muteWarning) {
            warn('a saved auth transaction exists in storage. This may indicate another auth flow is already in progress.');
        }
        storage.setStorage(meta);
        if (this.enableSharedStorage && meta.state) {
            saveTransactionToSharedStorage(this.storageManager, meta.state, meta);
        }
        if (!options.oauth) {
            return;
        }
        if (this.saveNonceCookie || this.saveStateCookie || this.saveParamsCookie) {
            const cookieStorage = this.storageManager.getStorage({ storageType: 'cookie' });
            if (this.saveParamsCookie) {
                const { responseType, state, nonce, scopes, clientId, urls, ignoreSignature } = meta;
                const oauthParams = {
                    responseType,
                    state,
                    nonce,
                    scopes,
                    clientId,
                    urls,
                    ignoreSignature
                };
                cookieStorage.setItem(REDIRECT_OAUTH_PARAMS_NAME, JSON.stringify(oauthParams), null);
            }
            if (this.saveNonceCookie && meta.nonce) {
                cookieStorage.setItem(REDIRECT_NONCE_COOKIE_NAME, meta.nonce, null);
            }
            if (this.saveStateCookie && meta.state) {
                cookieStorage.setItem(REDIRECT_STATE_COOKIE_NAME, meta.state, null);
            }
        }
    }
    exists(options = {}) {
        try {
            const meta = this.load(options);
            return !!meta;
        }
        catch (_a) {
            return false;
        }
    }
    load(options = {}) {
        let meta;
        if (this.enableSharedStorage && options.state) {
            pruneSharedStorage(this.storageManager);
            meta = loadTransactionFromSharedStorage(this.storageManager, options.state);
            if (isTransactionMeta(meta)) {
                return meta;
            }
        }
        let storage = this.storageManager.getTransactionStorage();
        meta = storage.getStorage();
        if (isTransactionMeta(meta)) {
            return meta;
        }
        if (!this.legacyWidgetSupport) {
            return null;
        }
        if (options.oauth) {
            try {
                const oauthParams = this.loadLegacyOAuthParams();
                Object.assign(meta, oauthParams);
            }
            finally {
                this.clearLegacyOAuthParams();
            }
        }
        if (options.pkce) {
            try {
                const pkceMeta = this.loadLegacyPKCE();
                Object.assign(meta, pkceMeta);
            }
            finally {
                this.clearLegacyPKCE();
            }
        }
        if (isTransactionMeta(meta)) {
            return meta;
        }
        return null;
    }
    clearLegacyPKCE() {
        let storage;
        if (this.storageManager.storageUtil.testStorageType('localStorage')) {
            storage = this.storageManager.getLegacyPKCEStorage({ storageType: 'localStorage' });
            storage.clearStorage();
        }
        if (this.storageManager.storageUtil.testStorageType('sessionStorage')) {
            storage = this.storageManager.getLegacyPKCEStorage({ storageType: 'sessionStorage' });
            storage.clearStorage();
        }
    }
    loadLegacyPKCE() {
        let storage;
        let obj;
        if (this.storageManager.storageUtil.testStorageType('localStorage')) {
            storage = this.storageManager.getLegacyPKCEStorage({ storageType: 'localStorage' });
            obj = storage.getStorage();
            if (obj && obj.codeVerifier) {
                return obj;
            }
        }
        if (this.storageManager.storageUtil.testStorageType('sessionStorage')) {
            storage = this.storageManager.getLegacyPKCEStorage({ storageType: 'sessionStorage' });
            obj = storage.getStorage();
            if (obj && obj.codeVerifier) {
                return obj;
            }
        }
        throw new AuthSdkError_AuthSdkError('Could not load PKCE codeVerifier from storage. This may indicate the auth flow has already completed or multiple auth flows are executing concurrently.', undefined);
    }
    clearLegacyOAuthParams() {
        let storage;
        if (this.storageManager.storageUtil.testStorageType('sessionStorage')) {
            storage = this.storageManager.getLegacyOAuthParamsStorage({ storageType: 'sessionStorage' });
            storage.clearStorage();
        }
        if (this.storageManager.storageUtil.testStorageType('cookie')) {
            storage = this.storageManager.getLegacyOAuthParamsStorage({ storageType: 'cookie' });
            storage.clearStorage();
        }
    }
    loadLegacyOAuthParams() {
        let storage;
        let oauthParams;
        if (this.storageManager.storageUtil.testStorageType('sessionStorage')) {
            storage = this.storageManager.getLegacyOAuthParamsStorage({ storageType: 'sessionStorage' });
            oauthParams = storage.getStorage();
        }
        if (isOAuthTransactionMeta(oauthParams)) {
            return oauthParams;
        }
        if (this.storageManager.storageUtil.testStorageType('cookie')) {
            storage = this.storageManager.getLegacyOAuthParamsStorage({ storageType: 'cookie' });
            oauthParams = storage.getStorage();
        }
        if (isOAuthTransactionMeta(oauthParams)) {
            return oauthParams;
        }
        throw new AuthSdkError_AuthSdkError('Unable to retrieve OAuth redirect params from storage');
    }
    saveIdxResponse(data) {
        if (!this.saveLastResponse) {
            return;
        }
        const storage = this.storageManager.getIdxResponseStorage();
        if (!storage) {
            return;
        }
        storage.setStorage(data);
    }
    loadIdxResponse(options) {
        if (!this.saveLastResponse) {
            return null;
        }
        const storage = this.storageManager.getIdxResponseStorage();
        if (!storage) {
            return null;
        }
        const storedValue = storage.getStorage();
        if (!storedValue || !isRawIdxResponse(storedValue.rawIdxResponse)) {
            return null;
        }
        if (options) {
            const { stateHandle, interactionHandle } = options;
            if (stateHandle && storedValue.stateHandle !== stateHandle) {
                return null;
            }
            if (interactionHandle && storedValue.interactionHandle !== interactionHandle) {
                return null;
            }
        }
        return storedValue;
    }
    clearIdxResponse() {
        if (!this.saveLastResponse) {
            return;
        }
        const storage = this.storageManager.getIdxResponseStorage();
        storage === null || storage === void 0 ? void 0 : storage.clearStorage();
    }
}


//# sourceMappingURL=TransactionManager.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/builderUtil.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



function assertValidConfig(args) {
    args = args || {};
    var scopes = args.scopes;
    if (scopes && !Array.isArray(scopes)) {
        throw new AuthSdkError_AuthSdkError('scopes must be a array of strings. ' +
            'Required usage: new OktaAuth({scopes: ["openid", "email"]})');
    }
    var issuer = args.issuer;
    if (!issuer) {
        throw new AuthSdkError_AuthSdkError('No issuer passed to constructor. ' +
            'Required usage: new OktaAuth({issuer: "https://{yourOktaDomain}.com/oauth2/{authServerId}"})');
    }
    var isUrlRegex = new RegExp('^http?s?://.+');
    if (!isUrlRegex.test(issuer)) {
        throw new AuthSdkError_AuthSdkError('Issuer must be a valid URL. ' +
            'Required usage: new OktaAuth({issuer: "https://{yourOktaDomain}.com/oauth2/{authServerId}"})');
    }
    if (issuer.indexOf('-admin.') !== -1) {
        throw new AuthSdkError_AuthSdkError('Issuer URL passed to constructor contains "-admin" in subdomain. ' +
            'Required usage: new OktaAuth({issuer: "https://{yourOktaDomain}.com})');
    }
}


//# sourceMappingURL=builderUtil.js.map

// EXTERNAL MODULE: ./node_modules/@okta/okta-auth-js/node_modules/cross-fetch/dist/browser-ponyfill.js
var browser_ponyfill = __webpack_require__(44642);
;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/fetch/fetchRequest.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



const appJsonContentTypeRegex = /application\/\w*\+?json/;
function readData(response) {
    if (response.headers.get('Content-Type') &&
        response.headers.get('Content-Type').toLowerCase().indexOf('application/json') >= 0) {
        return response.json()
            .catch(e => {
            return {
                error: e,
                errorSummary: 'Could not parse server response'
            };
        });
    }
    else {
        return response.text();
    }
}
function formatResult(status, data, response) {
    const isObject = typeof data === 'object';
    const headers = {};
    for (const pair of response.headers.entries()) {
        headers[pair[0]] = pair[1];
    }
    const result = {
        responseText: isObject ? JSON.stringify(data) : data,
        status: status,
        headers
    };
    if (isObject) {
        result.responseType = 'json';
        result.responseJSON = data;
    }
    return result;
}
function fetchRequest(method, url, args) {
    var body = args.data;
    var headers = args.headers || {};
    var contentType = (headers['Content-Type'] || headers['content-type'] || '');
    if (body && typeof body !== 'string') {
        if (appJsonContentTypeRegex.test(contentType)) {
            body = JSON.stringify(body);
        }
        else if (contentType === 'application/x-www-form-urlencoded') {
            body = Object.entries(body)
                .map(([param, value]) => `${param}=${encodeURIComponent(value)}`)
                .join('&');
        }
    }
    var fetch = window.fetch || browser_ponyfill;
    var fetchPromise = fetch(url, {
        method: method,
        headers: args.headers,
        body: body,
        credentials: args.withCredentials ? 'include' : 'omit'
    });
    if (!fetchPromise.finally) {
        fetchPromise = Promise.resolve(fetchPromise);
    }
    return fetchPromise.then(function (response) {
        var error = !response.ok;
        var status = response.status;
        return readData(response)
            .then(data => {
            return formatResult(status, data, response);
        })
            .then(result => {
            var _a;
            if (error || ((_a = result.responseJSON) === null || _a === void 0 ? void 0 : _a.error)) {
                throw result;
            }
            return result;
        });
    });
}


//# sourceMappingURL=fetchRequest.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/options/browser.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */




function getStorage() {
    const storageUtil$1 = Object.assign({}, storageUtil, {
        inMemoryStore: {}
    });
    return storageUtil$1;
}
const STORAGE_MANAGER_OPTIONS = {
    token: {
        storageTypes: [
            'localStorage',
            'sessionStorage',
            'cookie'
        ]
    },
    cache: {
        storageTypes: [
            'localStorage',
            'sessionStorage',
            'cookie'
        ]
    },
    transaction: {
        storageTypes: [
            'sessionStorage',
            'localStorage',
            'cookie'
        ]
    },
    'shared-transaction': {
        storageTypes: [
            'localStorage'
        ]
    },
    'original-uri': {
        storageTypes: [
            'localStorage'
        ]
    }
};
const enableSharedStorage = true;
function getCookieSettings(args = {}, isHTTPS) {
    var cookieSettings = args.cookies || {};
    if (typeof cookieSettings.secure === 'undefined') {
        cookieSettings.secure = isHTTPS;
    }
    if (typeof cookieSettings.sameSite === 'undefined') {
        cookieSettings.sameSite = cookieSettings.secure ? 'none' : 'lax';
    }
    if (cookieSettings.secure && !isHTTPS) {
        warn('The current page is not being served with the HTTPS protocol.\n' +
            'For security reasons, we strongly recommend using HTTPS.\n' +
            'If you cannot use HTTPS, set "cookies.secure" option to false.');
        cookieSettings.secure = false;
    }
    if (cookieSettings.sameSite === 'none' && !cookieSettings.secure) {
        cookieSettings.sameSite = 'lax';
    }
    return cookieSettings;
}


//# sourceMappingURL=browser.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/options/index.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */








function getDefaultOptions() {
    const options = {
        devMode: false,
        httpRequestClient: fetchRequest,
        storageUtil: getStorage(),
        storageManager: STORAGE_MANAGER_OPTIONS,
        transactionManager: {
            enableSharedStorage: enableSharedStorage
        }
    };
    return options;
}
function mergeOptions(options, args) {
    return Object.assign({}, options, removeNils(args), {
        storageManager: Object.assign({}, options.storageManager, args.storageManager),
        transactionManager: Object.assign({}, options.transactionManager, args.transactionManager),
    });
}
function buildOptions(args = {}) {
    var _a, _b;
    assertValidConfig(args);
    args = mergeOptions(getDefaultOptions(), args);
    return removeNils({
        issuer: removeTrailingSlash(args.issuer),
        tokenUrl: removeTrailingSlash(args.tokenUrl),
        authorizeUrl: removeTrailingSlash(args.authorizeUrl),
        userinfoUrl: removeTrailingSlash(args.userinfoUrl),
        revokeUrl: removeTrailingSlash(args.revokeUrl),
        logoutUrl: removeTrailingSlash(args.logoutUrl),
        clientId: args.clientId,
        redirectUri: args.redirectUri,
        state: args.state,
        scopes: args.scopes,
        postLogoutRedirectUri: args.postLogoutRedirectUri,
        responseMode: args.responseMode,
        responseType: args.responseType,
        pkce: args.pkce === false ? false : true,
        useInteractionCodeFlow: args.useInteractionCodeFlow,
        httpRequestClient: args.httpRequestClient,
        httpRequestInterceptors: args.httpRequestInterceptors,
        transformErrorXHR: args.transformErrorXHR,
        transformAuthState: args.transformAuthState,
        restoreOriginalUri: args.restoreOriginalUri,
        storageUtil: args.storageUtil,
        headers: args.headers,
        devMode: !!args.devMode,
        storageManager: args.storageManager,
        transactionManager: args.transactionManager,
        cookies: getCookieSettings(args, isHTTPS()),
        flow: args.flow,
        codeChallenge: args.codeChallenge,
        codeChallengeMethod: args.codeChallengeMethod,
        recoveryToken: args.recoveryToken,
        activationToken: args.activationToken,
        idx: {
            useGenericRemediator: !!((_a = args.idx) === null || _a === void 0 ? void 0 : _a.useGenericRemediator),
            exchangeCodeForTokens: ((_b = args.idx) === null || _b === void 0 ? void 0 : _b.exchangeCodeForTokens) !== false
        },
        ignoreSignature: !!args.ignoreSignature,
        clientSecret: args.clientSecret,
        setLocation: args.setLocation
    });
}


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/transactionMeta.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */







async function createTransactionMeta(authClient, options = {}) {
    const tokenParams = await authClient.token.prepareTokenParams(options);
    const pkceMeta = createOAuthMeta(authClient, tokenParams);
    let { flow = 'default', withCredentials = true, activationToken = undefined, recoveryToken = undefined, maxAge = undefined, } = Object.assign(Object.assign({}, authClient.options), options);
    const meta = Object.assign(Object.assign({}, pkceMeta), { flow,
        withCredentials,
        activationToken,
        recoveryToken,
        maxAge });
    return meta;
}
function hasSavedInteractionHandle(authClient, options) {
    const savedMeta = getSavedTransactionMeta(authClient, options);
    if (savedMeta === null || savedMeta === void 0 ? void 0 : savedMeta.interactionHandle) {
        return true;
    }
    return false;
}
function getSavedTransactionMeta(authClient, options) {
    options = removeNils(options);
    options = Object.assign(Object.assign({}, authClient.options), options);
    let savedMeta;
    try {
        savedMeta = authClient.transactionManager.load(options);
    }
    catch (e) {
    }
    if (!savedMeta) {
        return;
    }
    if (isTransactionMetaValid(savedMeta, options)) {
        return savedMeta;
    }
    warn('Saved transaction meta does not match the current configuration. ' +
        'This may indicate that two apps are sharing a storage key.');
}
async function getTransactionMeta(authClient, options) {
    options = removeNils(options);
    options = Object.assign(Object.assign({}, authClient.options), options);
    const validExistingMeta = getSavedTransactionMeta(authClient, options);
    if (validExistingMeta) {
        return validExistingMeta;
    }
    return createTransactionMeta(authClient, options);
}
function saveTransactionMeta(authClient, meta) {
    authClient.transactionManager.save(meta, { muteWarning: true });
}
function clearTransactionMeta(authClient) {
    authClient.transactionManager.clear();
}
function isTransactionMetaValid(meta, options = {}) {
    const keys = [
        'issuer',
        'clientId',
        'redirectUri',
        'state',
        'codeChallenge',
        'codeChallengeMethod',
        'activationToken',
        'recoveryToken'
    ];
    if (isTransactionMetaValidForOptions(meta, options, keys) === false) {
        return false;
    }
    const { flow } = options;
    if (isTransactionMetaValidForFlow(meta, flow) === false) {
        return false;
    }
    return true;
}
function isTransactionMetaValidForFlow(meta, flow) {
    const shouldValidateFlow = flow && flow !== 'default' && flow !== 'proceed';
    if (shouldValidateFlow) {
        if (flow !== meta.flow) {
            return false;
        }
    }
    return true;
}
function isTransactionMetaValidForOptions(meta, options, keys) {
    const mismatch = keys.some(key => {
        const value = options[key];
        if (value && value !== meta[key]) {
            return true;
        }
    });
    return !mismatch;
}


//# sourceMappingURL=transactionMeta.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/interact.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */








function getResponse(meta) {
    return {
        meta,
        interactionHandle: meta.interactionHandle,
        state: meta.state
    };
}
async function interact(authClient, options = {}) {
    options = removeNils(options);
    let meta = getSavedTransactionMeta(authClient, options);
    if (meta === null || meta === void 0 ? void 0 : meta.interactionHandle) {
        return getResponse(meta);
    }
    meta = await createTransactionMeta(authClient, Object.assign(Object.assign({}, meta), options));
    const baseUrl = getOAuthBaseUrl(authClient);
    let { clientId, redirectUri, state, scopes, withCredentials, codeChallenge, codeChallengeMethod, activationToken, recoveryToken, maxAge, nonce } = meta;
    const clientSecret = options.clientSecret || authClient.options.clientSecret;
    withCredentials = withCredentials !== null && withCredentials !== void 0 ? withCredentials : true;
    const url = `${baseUrl}/v1/interact`;
    const params = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({ client_id: clientId, scope: scopes.join(' '), redirect_uri: redirectUri, code_challenge: codeChallenge, code_challenge_method: codeChallengeMethod, state }, (activationToken && { activation_token: activationToken })), (recoveryToken && { recovery_token: recoveryToken })), (clientSecret && { client_secret: clientSecret })), (maxAge && { max_age: maxAge })), (nonce && { nonce }));
    const headers = {
        'Content-Type': 'application/x-www-form-urlencoded',
    };
    const resp = await request_httpRequest(authClient, {
        method: 'POST',
        url,
        headers,
        withCredentials,
        args: params
    });
    const interactionHandle = resp.interaction_handle;
    const newMeta = Object.assign(Object.assign({}, meta), { interactionHandle,
        withCredentials,
        state,
        scopes,
        recoveryToken,
        activationToken });
    saveTransactionMeta(authClient, newMeta);
    return getResponse(newMeta);
}


//# sourceMappingURL=interact.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/idxState/v1/actionParser.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */

const isFieldMutable = function isFieldMutable(field) {
    return (field.mutable !== false);
};
const divideSingleActionParamsByMutability = function divideSingleActionParamsByMutability(action) {
    var _a, _b;
    const defaultParamsForAction = {};
    const neededParamsForAction = [];
    const immutableParamsForAction = {};
    if (!action.value) {
        neededParamsForAction.push(action);
        return { defaultParamsForAction, neededParamsForAction, immutableParamsForAction };
    }
    for (let field of action.value) {
        if (isFieldMutable(field)) {
            neededParamsForAction.push(field);
            if ((_a = field.value) !== null && _a !== void 0 ? _a : false) {
                defaultParamsForAction[field.name] = field.value;
            }
        }
        else {
            immutableParamsForAction[field.name] = (_b = field.value) !== null && _b !== void 0 ? _b : '';
        }
    }
    return { defaultParamsForAction, neededParamsForAction, immutableParamsForAction };
};
const divideActionParamsByMutability = function divideActionParamsByMutability(actionList) {
    actionList = Array.isArray(actionList) ? actionList : [actionList];
    const neededParams = [];
    const defaultParams = {};
    const immutableParams = {};
    for (let action of actionList) {
        const { defaultParamsForAction, neededParamsForAction, immutableParamsForAction } = divideSingleActionParamsByMutability(action);
        neededParams.push(neededParamsForAction);
        defaultParams[action.name] = defaultParamsForAction;
        immutableParams[action.name] = immutableParamsForAction;
    }
    return { defaultParams, neededParams, immutableParams };
};


//# sourceMappingURL=actionParser.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/idxState/v1/generateIdxAction.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */





const generateDirectFetch = function generateDirectFetch(authClient, { actionDefinition, defaultParamsForAction = {}, immutableParamsForAction = {}, toPersist = {} }) {
    const target = actionDefinition.href;
    return async function (params = {}) {
        var _a;
        const headers = {
            'Content-Type': 'application/json',
            'Accept': actionDefinition.accepts || 'application/ion+json',
        };
        const body = JSON.stringify(Object.assign(Object.assign(Object.assign({}, defaultParamsForAction), params), immutableParamsForAction));
        try {
            const response = await request_httpRequest(authClient, {
                url: target,
                method: actionDefinition.method,
                headers,
                args: body,
                withCredentials: (_a = toPersist === null || toPersist === void 0 ? void 0 : toPersist.withCredentials) !== null && _a !== void 0 ? _a : true
            });
            return authClient.idx.makeIdxResponse(Object.assign({}, response), toPersist, true);
        }
        catch (err) {
            if (!(err instanceof AuthApiError_AuthApiError) || !(err === null || err === void 0 ? void 0 : err.xhr)) {
                throw err;
            }
            const response = err.xhr;
            const payload = response.responseJSON || JSON.parse(response.responseText);
            const wwwAuthHeader = response.headers['WWW-Authenticate'] || response.headers['www-authenticate'];
            const idxResponse = authClient.idx.makeIdxResponse(Object.assign({}, payload), toPersist, false);
            if (response.status === 401 && wwwAuthHeader === 'Oktadevicejwt realm="Okta Device"') {
                idxResponse.stepUp = true;
            }
            throw idxResponse;
        }
    };
};
const generateIdxAction = function generateIdxAction(authClient, actionDefinition, toPersist) {
    const generator = generateDirectFetch;
    const { defaultParams, neededParams, immutableParams } = divideActionParamsByMutability(actionDefinition);
    const action = generator(authClient, {
        actionDefinition,
        defaultParamsForAction: defaultParams[actionDefinition.name],
        immutableParamsForAction: immutableParams[actionDefinition.name],
        toPersist
    });
    action.neededParams = neededParams;
    return action;
};


//# sourceMappingURL=generateIdxAction.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/idxState/v1/remediationParser.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



const generateRemediationFunctions = function generateRemediationFunctions(authClient, remediationValue, toPersist = {}) {
    return Object.fromEntries(remediationValue.map(remediation => {
        return [
            remediation.name,
            generateIdxAction(authClient, remediation, toPersist),
        ];
    }));
};


//# sourceMappingURL=remediationParser.js.map

;// CONCATENATED MODULE: ./node_modules/jsonpath-plus/dist/index-browser-esm.js
function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };

  return _wrapNativeSuper(Class);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];

  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;

      var F = function () {};

      return {
        s: F,
        n: function () {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function (e) {
          throw e;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function () {
      it = it.call(o);
    },
    n: function () {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function (e) {
      didErr = true;
      err = e;
    },
    f: function () {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

var hasOwnProp = Object.prototype.hasOwnProperty;
/**
* @typedef {null|boolean|number|string|PlainObject|GenericArray} JSONObject
*/

/**
 * Copies array and then pushes item into it.
 * @param {GenericArray} arr Array to copy and into which to push
 * @param {any} item Array item to add (to end)
 * @returns {GenericArray} Copy of the original array
 */

function push(arr, item) {
  arr = arr.slice();
  arr.push(item);
  return arr;
}
/**
 * Copies array and then unshifts item into it.
 * @param {any} item Array item to add (to beginning)
 * @param {GenericArray} arr Array to copy and into which to unshift
 * @returns {GenericArray} Copy of the original array
 */


function unshift(item, arr) {
  arr = arr.slice();
  arr.unshift(item);
  return arr;
}
/**
 * Caught when JSONPath is used without `new` but rethrown if with `new`
 * @extends Error
 */


var NewError = /*#__PURE__*/function (_Error) {
  _inherits(NewError, _Error);

  var _super = _createSuper(NewError);

  /**
   * @param {any} value The evaluated scalar value
   */
  function NewError(value) {
    var _this;

    _classCallCheck(this, NewError);

    _this = _super.call(this, 'JSONPath should not be called with "new" (it prevents return ' + 'of (unwrapped) scalar values)');
    _this.avoidNew = true;
    _this.value = value;
    _this.name = 'NewError';
    return _this;
  }

  return NewError;
}( /*#__PURE__*/_wrapNativeSuper(Error));
/**
* @typedef {PlainObject} ReturnObject
* @property {string} path
* @property {JSONObject} value
* @property {PlainObject|GenericArray} parent
* @property {string} parentProperty
*/

/**
* @callback JSONPathCallback
* @param {string|PlainObject} preferredOutput
* @param {"value"|"property"} type
* @param {ReturnObject} fullRetObj
* @returns {void}
*/

/**
* @callback OtherTypeCallback
* @param {JSONObject} val
* @param {string} path
* @param {PlainObject|GenericArray} parent
* @param {string} parentPropName
* @returns {boolean}
*/

/* eslint-disable max-len -- Can make multiline type after https://github.com/syavorsky/comment-parser/issues/109 */

/**
 * @typedef {PlainObject} JSONPathOptions
 * @property {JSON} json
 * @property {string|string[]} path
 * @property {"value"|"path"|"pointer"|"parent"|"parentProperty"|"all"} [resultType="value"]
 * @property {boolean} [flatten=false]
 * @property {boolean} [wrap=true]
 * @property {PlainObject} [sandbox={}]
 * @property {boolean} [preventEval=false]
 * @property {PlainObject|GenericArray|null} [parent=null]
 * @property {string|null} [parentProperty=null]
 * @property {JSONPathCallback} [callback]
 * @property {OtherTypeCallback} [otherTypeCallback] Defaults to
 *   function which throws on encountering `@other`
 * @property {boolean} [autostart=true]
 */

/* eslint-enable max-len -- Can make multiline type after https://github.com/syavorsky/comment-parser/issues/109 */

/**
 * @param {string|JSONPathOptions} opts If a string, will be treated as `expr`
 * @param {string} [expr] JSON path to evaluate
 * @param {JSON} [obj] JSON object to evaluate against
 * @param {JSONPathCallback} [callback] Passed 3 arguments: 1) desired payload
 *     per `resultType`, 2) `"value"|"property"`, 3) Full returned object with
 *     all payloads
 * @param {OtherTypeCallback} [otherTypeCallback] If `@other()` is at the end
 *   of one's query, this will be invoked with the value of the item, its
 *   path, its parent, and its parent's property name, and it should return
 *   a boolean indicating whether the supplied value belongs to the "other"
 *   type or not (or it may handle transformations and return `false`).
 * @returns {JSONPath}
 * @class
 */


function JSONPath(opts, expr, obj, callback, otherTypeCallback) {
  // eslint-disable-next-line no-restricted-syntax
  if (!(this instanceof JSONPath)) {
    try {
      return new JSONPath(opts, expr, obj, callback, otherTypeCallback);
    } catch (e) {
      if (!e.avoidNew) {
        throw e;
      }

      return e.value;
    }
  }

  if (typeof opts === 'string') {
    otherTypeCallback = callback;
    callback = obj;
    obj = expr;
    expr = opts;
    opts = null;
  }

  var optObj = opts && _typeof(opts) === 'object';
  opts = opts || {};
  this.json = opts.json || obj;
  this.path = opts.path || expr;
  this.resultType = opts.resultType || 'value';
  this.flatten = opts.flatten || false;
  this.wrap = hasOwnProp.call(opts, 'wrap') ? opts.wrap : true;
  this.sandbox = opts.sandbox || {};
  this.preventEval = opts.preventEval || false;
  this.parent = opts.parent || null;
  this.parentProperty = opts.parentProperty || null;
  this.callback = opts.callback || callback || null;

  this.otherTypeCallback = opts.otherTypeCallback || otherTypeCallback || function () {
    throw new TypeError('You must supply an otherTypeCallback callback option ' + 'with the @other() operator.');
  };

  if (opts.autostart !== false) {
    var args = {
      path: optObj ? opts.path : expr
    };

    if (!optObj) {
      args.json = obj;
    } else if ('json' in opts) {
      args.json = opts.json;
    }

    var ret = this.evaluate(args);

    if (!ret || _typeof(ret) !== 'object') {
      throw new NewError(ret);
    }

    return ret;
  }
} // PUBLIC METHODS


JSONPath.prototype.evaluate = function (expr, json, callback, otherTypeCallback) {
  var _this2 = this;

  var currParent = this.parent,
      currParentProperty = this.parentProperty;
  var flatten = this.flatten,
      wrap = this.wrap;
  this.currResultType = this.resultType;
  this.currPreventEval = this.preventEval;
  this.currSandbox = this.sandbox;
  callback = callback || this.callback;
  this.currOtherTypeCallback = otherTypeCallback || this.otherTypeCallback;
  json = json || this.json;
  expr = expr || this.path;

  if (expr && _typeof(expr) === 'object' && !Array.isArray(expr)) {
    if (!expr.path && expr.path !== '') {
      throw new TypeError('You must supply a "path" property when providing an object ' + 'argument to JSONPath.evaluate().');
    }

    if (!hasOwnProp.call(expr, 'json')) {
      throw new TypeError('You must supply a "json" property when providing an object ' + 'argument to JSONPath.evaluate().');
    }

    var _expr = expr;
    json = _expr.json;
    flatten = hasOwnProp.call(expr, 'flatten') ? expr.flatten : flatten;
    this.currResultType = hasOwnProp.call(expr, 'resultType') ? expr.resultType : this.currResultType;
    this.currSandbox = hasOwnProp.call(expr, 'sandbox') ? expr.sandbox : this.currSandbox;
    wrap = hasOwnProp.call(expr, 'wrap') ? expr.wrap : wrap;
    this.currPreventEval = hasOwnProp.call(expr, 'preventEval') ? expr.preventEval : this.currPreventEval;
    callback = hasOwnProp.call(expr, 'callback') ? expr.callback : callback;
    this.currOtherTypeCallback = hasOwnProp.call(expr, 'otherTypeCallback') ? expr.otherTypeCallback : this.currOtherTypeCallback;
    currParent = hasOwnProp.call(expr, 'parent') ? expr.parent : currParent;
    currParentProperty = hasOwnProp.call(expr, 'parentProperty') ? expr.parentProperty : currParentProperty;
    expr = expr.path;
  }

  currParent = currParent || null;
  currParentProperty = currParentProperty || null;

  if (Array.isArray(expr)) {
    expr = JSONPath.toPathString(expr);
  }

  if (!expr && expr !== '' || !json) {
    return undefined;
  }

  var exprList = JSONPath.toPathArray(expr);

  if (exprList[0] === '$' && exprList.length > 1) {
    exprList.shift();
  }

  this._hasParentSelector = null;

  var result = this._trace(exprList, json, ['$'], currParent, currParentProperty, callback).filter(function (ea) {
    return ea && !ea.isParentSelector;
  });

  if (!result.length) {
    return wrap ? [] : undefined;
  }

  if (!wrap && result.length === 1 && !result[0].hasArrExpr) {
    return this._getPreferredOutput(result[0]);
  }

  return result.reduce(function (rslt, ea) {
    var valOrPath = _this2._getPreferredOutput(ea);

    if (flatten && Array.isArray(valOrPath)) {
      rslt = rslt.concat(valOrPath);
    } else {
      rslt.push(valOrPath);
    }

    return rslt;
  }, []);
}; // PRIVATE METHODS


JSONPath.prototype._getPreferredOutput = function (ea) {
  var resultType = this.currResultType;

  switch (resultType) {
    case 'all':
      {
        var path = Array.isArray(ea.path) ? ea.path : JSONPath.toPathArray(ea.path);
        ea.pointer = JSONPath.toPointer(path);
        ea.path = typeof ea.path === 'string' ? ea.path : JSONPath.toPathString(ea.path);
        return ea;
      }

    case 'value':
    case 'parent':
    case 'parentProperty':
      return ea[resultType];

    case 'path':
      return JSONPath.toPathString(ea[resultType]);

    case 'pointer':
      return JSONPath.toPointer(ea.path);

    default:
      throw new TypeError('Unknown result type');
  }
};

JSONPath.prototype._handleCallback = function (fullRetObj, callback, type) {
  if (callback) {
    var preferredOutput = this._getPreferredOutput(fullRetObj);

    fullRetObj.path = typeof fullRetObj.path === 'string' ? fullRetObj.path : JSONPath.toPathString(fullRetObj.path); // eslint-disable-next-line node/callback-return

    callback(preferredOutput, type, fullRetObj);
  }
};
/**
 *
 * @param {string} expr
 * @param {JSONObject} val
 * @param {string} path
 * @param {PlainObject|GenericArray} parent
 * @param {string} parentPropName
 * @param {JSONPathCallback} callback
 * @param {boolean} hasArrExpr
 * @param {boolean} literalPriority
 * @returns {ReturnObject|ReturnObject[]}
 */


JSONPath.prototype._trace = function (expr, val, path, parent, parentPropName, callback, hasArrExpr, literalPriority) {
  var _this3 = this;

  // No expr to follow? return path and value as the result of
  //  this trace branch
  var retObj;

  if (!expr.length) {
    retObj = {
      path: path,
      value: val,
      parent: parent,
      parentProperty: parentPropName,
      hasArrExpr: hasArrExpr
    };

    this._handleCallback(retObj, callback, 'value');

    return retObj;
  }

  var loc = expr[0],
      x = expr.slice(1); // We need to gather the return value of recursive trace calls in order to
  // do the parent sel computation.

  var ret = [];
  /**
   *
   * @param {ReturnObject|ReturnObject[]} elems
   * @returns {void}
   */

  function addRet(elems) {
    if (Array.isArray(elems)) {
      // This was causing excessive stack size in Node (with or
      //  without Babel) against our performance test:
      //  `ret.push(...elems);`
      elems.forEach(function (t) {
        ret.push(t);
      });
    } else {
      ret.push(elems);
    }
  }

  if ((typeof loc !== 'string' || literalPriority) && val && hasOwnProp.call(val, loc)) {
    // simple case--directly follow property
    addRet(this._trace(x, val[loc], push(path, loc), val, loc, callback, hasArrExpr)); // eslint-disable-next-line unicorn/prefer-switch -- Part of larger `if`
  } else if (loc === '*') {
    // all child properties
    this._walk(loc, x, val, path, parent, parentPropName, callback, function (m, l, _x, v, p, par, pr, cb) {
      addRet(_this3._trace(unshift(m, _x), v, p, par, pr, cb, true, true));
    });
  } else if (loc === '..') {
    // all descendent parent properties
    // Check remaining expression with val's immediate children
    addRet(this._trace(x, val, path, parent, parentPropName, callback, hasArrExpr));

    this._walk(loc, x, val, path, parent, parentPropName, callback, function (m, l, _x, v, p, par, pr, cb) {
      // We don't join m and x here because we only want parents,
      //   not scalar values
      if (_typeof(v[m]) === 'object') {
        // Keep going with recursive descent on val's
        //   object children
        addRet(_this3._trace(unshift(l, _x), v[m], push(p, m), v, m, cb, true));
      }
    }); // The parent sel computation is handled in the frame above using the
    // ancestor object of val

  } else if (loc === '^') {
    // This is not a final endpoint, so we do not invoke the callback here
    this._hasParentSelector = true;
    return {
      path: path.slice(0, -1),
      expr: x,
      isParentSelector: true
    };
  } else if (loc === '~') {
    // property name
    retObj = {
      path: push(path, loc),
      value: parentPropName,
      parent: parent,
      parentProperty: null
    };

    this._handleCallback(retObj, callback, 'property');

    return retObj;
  } else if (loc === '$') {
    // root only
    addRet(this._trace(x, val, path, null, null, callback, hasArrExpr));
  } else if (/^(\x2D?[0-9]*):(\x2D?[0-9]*):?([0-9]*)$/.test(loc)) {
    // [start:end:step]  Python slice syntax
    addRet(this._slice(loc, x, val, path, parent, parentPropName, callback));
  } else if (loc.indexOf('?(') === 0) {
    // [?(expr)] (filtering)
    if (this.currPreventEval) {
      throw new Error('Eval [?(expr)] prevented in JSONPath expression.');
    }

    this._walk(loc, x, val, path, parent, parentPropName, callback, function (m, l, _x, v, p, par, pr, cb) {
      if (_this3._eval(l.replace(/^\?\(((?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*?)\)$/, '$1'), v[m], m, p, par, pr)) {
        addRet(_this3._trace(unshift(m, _x), v, p, par, pr, cb, true));
      }
    });
  } else if (loc[0] === '(') {
    // [(expr)] (dynamic property/index)
    if (this.currPreventEval) {
      throw new Error('Eval [(expr)] prevented in JSONPath expression.');
    } // As this will resolve to a property name (but we don't know it
    //  yet), property and parent information is relative to the
    //  parent of the property to which this expression will resolve


    addRet(this._trace(unshift(this._eval(loc, val, path[path.length - 1], path.slice(0, -1), parent, parentPropName), x), val, path, parent, parentPropName, callback, hasArrExpr));
  } else if (loc[0] === '@') {
    // value type: @boolean(), etc.
    var addType = false;
    var valueType = loc.slice(1, -2);

    switch (valueType) {
      case 'scalar':
        if (!val || !['object', 'function'].includes(_typeof(val))) {
          addType = true;
        }

        break;

      case 'boolean':
      case 'string':
      case 'undefined':
      case 'function':
        // eslint-disable-next-line valid-typeof
        if (_typeof(val) === valueType) {
          addType = true;
        }

        break;

      case 'integer':
        if (Number.isFinite(val) && !(val % 1)) {
          addType = true;
        }

        break;

      case 'number':
        if (Number.isFinite(val)) {
          addType = true;
        }

        break;

      case 'nonFinite':
        if (typeof val === 'number' && !Number.isFinite(val)) {
          addType = true;
        }

        break;

      case 'object':
        // eslint-disable-next-line valid-typeof
        if (val && _typeof(val) === valueType) {
          addType = true;
        }

        break;

      case 'array':
        if (Array.isArray(val)) {
          addType = true;
        }

        break;

      case 'other':
        addType = this.currOtherTypeCallback(val, path, parent, parentPropName);
        break;

      case 'null':
        if (val === null) {
          addType = true;
        }

        break;

      /* c8 ignore next 2 */

      default:
        throw new TypeError('Unknown value type ' + valueType);
    }

    if (addType) {
      retObj = {
        path: path,
        value: val,
        parent: parent,
        parentProperty: parentPropName
      };

      this._handleCallback(retObj, callback, 'value');

      return retObj;
    } // `-escaped property

  } else if (loc[0] === '`' && val && hasOwnProp.call(val, loc.slice(1))) {
    var locProp = loc.slice(1);
    addRet(this._trace(x, val[locProp], push(path, locProp), val, locProp, callback, hasArrExpr, true));
  } else if (loc.includes(',')) {
    // [name1,name2,...]
    var parts = loc.split(',');

    var _iterator = _createForOfIteratorHelper(parts),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var part = _step.value;
        addRet(this._trace(unshift(part, x), val, path, parent, parentPropName, callback, true));
      } // simple case--directly follow property

    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  } else if (!literalPriority && val && hasOwnProp.call(val, loc)) {
    addRet(this._trace(x, val[loc], push(path, loc), val, loc, callback, hasArrExpr, true));
  } // We check the resulting values for parent selections. For parent
  // selections we discard the value object and continue the trace with the
  // current val object


  if (this._hasParentSelector) {
    for (var t = 0; t < ret.length; t++) {
      var rett = ret[t];

      if (rett && rett.isParentSelector) {
        var tmp = this._trace(rett.expr, val, rett.path, parent, parentPropName, callback, hasArrExpr);

        if (Array.isArray(tmp)) {
          ret[t] = tmp[0];
          var tl = tmp.length;

          for (var tt = 1; tt < tl; tt++) {
            t++;
            ret.splice(t, 0, tmp[tt]);
          }
        } else {
          ret[t] = tmp;
        }
      }
    }
  }

  return ret;
};

JSONPath.prototype._walk = function (loc, expr, val, path, parent, parentPropName, callback, f) {
  if (Array.isArray(val)) {
    var n = val.length;

    for (var i = 0; i < n; i++) {
      f(i, loc, expr, val, path, parent, parentPropName, callback);
    }
  } else if (val && _typeof(val) === 'object') {
    Object.keys(val).forEach(function (m) {
      f(m, loc, expr, val, path, parent, parentPropName, callback);
    });
  }
};

JSONPath.prototype._slice = function (loc, expr, val, path, parent, parentPropName, callback) {
  if (!Array.isArray(val)) {
    return undefined;
  }

  var len = val.length,
      parts = loc.split(':'),
      step = parts[2] && Number.parseInt(parts[2]) || 1;
  var start = parts[0] && Number.parseInt(parts[0]) || 0,
      end = parts[1] && Number.parseInt(parts[1]) || len;
  start = start < 0 ? Math.max(0, start + len) : Math.min(len, start);
  end = end < 0 ? Math.max(0, end + len) : Math.min(len, end);
  var ret = [];

  for (var i = start; i < end; i += step) {
    var tmp = this._trace(unshift(i, expr), val, path, parent, parentPropName, callback, true); // Should only be possible to be an array here since first part of
    //   ``unshift(i, expr)` passed in above would not be empty, nor `~`,
    //     nor begin with `@` (as could return objects)
    // This was causing excessive stack size in Node (with or
    //  without Babel) against our performance test: `ret.push(...tmp);`


    tmp.forEach(function (t) {
      ret.push(t);
    });
  }

  return ret;
};

JSONPath.prototype._eval = function (code, _v, _vname, path, parent, parentPropName) {
  if (code.includes('@parentProperty')) {
    this.currSandbox._$_parentProperty = parentPropName;
    code = code.replace(/@parentProperty/g, '_$_parentProperty');
  }

  if (code.includes('@parent')) {
    this.currSandbox._$_parent = parent;
    code = code.replace(/@parent/g, '_$_parent');
  }

  if (code.includes('@property')) {
    this.currSandbox._$_property = _vname;
    code = code.replace(/@property/g, '_$_property');
  }

  if (code.includes('@path')) {
    this.currSandbox._$_path = JSONPath.toPathString(path.concat([_vname]));
    code = code.replace(/@path/g, '_$_path');
  }

  if (code.includes('@root')) {
    this.currSandbox._$_root = this.json;
    code = code.replace(/@root/g, '_$_root');
  }

  if (/@([\t-\r \)\.\[\xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF])/.test(code)) {
    this.currSandbox._$_v = _v;
    code = code.replace(/@([\t-\r \)\.\[\xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF])/g, '_$_v$1');
  }

  try {
    return this.vm.runInNewContext(code, this.currSandbox);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log(e);
    throw new Error('jsonPath: ' + e.message + ': ' + code);
  }
}; // PUBLIC CLASS PROPERTIES AND METHODS
// Could store the cache object itself


JSONPath.cache = {};
/**
 * @param {string[]} pathArr Array to convert
 * @returns {string} The path string
 */

JSONPath.toPathString = function (pathArr) {
  var x = pathArr,
      n = x.length;
  var p = '$';

  for (var i = 1; i < n; i++) {
    if (!/^(~|\^|@(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*?\(\))$/.test(x[i])) {
      p += /^[\*0-9]+$/.test(x[i]) ? '[' + x[i] + ']' : "['" + x[i] + "']";
    }
  }

  return p;
};
/**
 * @param {string} pointer JSON Path
 * @returns {string} JSON Pointer
 */


JSONPath.toPointer = function (pointer) {
  var x = pointer,
      n = x.length;
  var p = '';

  for (var i = 1; i < n; i++) {
    if (!/^(~|\^|@(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*?\(\))$/.test(x[i])) {
      p += '/' + x[i].toString().replace(/~/g, '~0').replace(/\//g, '~1');
    }
  }

  return p;
};
/**
 * @param {string} expr Expression to convert
 * @returns {string[]}
 */


JSONPath.toPathArray = function (expr) {
  var cache = JSONPath.cache;

  if (cache[expr]) {
    return cache[expr].concat();
  }

  var subx = [];
  var normalized = expr // Properties
  .replace(/@(?:null|boolean|number|string|integer|undefined|nonFinite|scalar|array|object|function|other)\(\)/g, ';$&;') // Parenthetical evaluations (filtering and otherwise), directly
  //   within brackets or single quotes
  .replace(/['\[](\??\((?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*?\))['\]]/g, function ($0, $1) {
    return '[#' + (subx.push($1) - 1) + ']';
  }) // Escape periods and tildes within properties
  .replace(/\[["']((?:(?!['\]])[\s\S])*)["']\]/g, function ($0, prop) {
    return "['" + prop.replace(/\./g, '%@%').replace(/~/g, '%%@@%%') + "']";
  }) // Properties operator
  .replace(/~/g, ';~;') // Split by property boundaries
  .replace(/["']?\.["']?(?!(?:(?!\[)[\s\S])*\])|\[["']?/g, ';') // Reinsert periods within properties
  .replace(/%@%/g, '.') // Reinsert tildes within properties
  .replace(/%%@@%%/g, '~') // Parent
  .replace(/(?:;)?(\^+)(?:;)?/g, function ($0, ups) {
    return ';' + ups.split('').join(';') + ';';
  }) // Descendents
  .replace(/;;;|;;/g, ';..;') // Remove trailing
  .replace(/;$|'?\]|'$/g, '');
  var exprList = normalized.split(';').map(function (exp) {
    var match = exp.match(/#([0-9]+)/);
    return !match || !match[1] ? exp : subx[match[1]];
  });
  cache[expr] = exprList;
  return cache[expr].concat();
};

/**
* @callback ConditionCallback
* @param {any} item
* @returns {boolean}
*/

/**
 * Copy items out of one array into another.
 * @param {GenericArray} source Array with items to copy
 * @param {GenericArray} target Array to which to copy
 * @param {ConditionCallback} conditionCb Callback passed the current item;
 *     will move item if evaluates to `true`
 * @returns {void}
 */

var moveToAnotherArray = function moveToAnotherArray(source, target, conditionCb) {
  var il = source.length;

  for (var i = 0; i < il; i++) {
    var item = source[i];

    if (conditionCb(item)) {
      target.push(source.splice(i--, 1)[0]);
    }
  }
};

JSONPath.prototype.vm = {
  /**
   * @param {string} expr Expression to evaluate
   * @param {PlainObject} context Object whose items will be added
   *   to evaluation
   * @returns {any} Result of evaluated code
   */
  runInNewContext: function runInNewContext(expr, context) {
    var keys = Object.keys(context);
    var funcs = [];
    moveToAnotherArray(keys, funcs, function (key) {
      return typeof context[key] === 'function';
    });
    var values = keys.map(function (vr, i) {
      return context[vr];
    });
    var funcString = funcs.reduce(function (s, func) {
      var fString = context[func].toString();

      if (!/function/.test(fString)) {
        fString = 'function ' + fString;
      }

      return 'var ' + func + '=' + fString + ';' + s;
    }, '');
    expr = funcString + expr; // Mitigate http://perfectionkills.com/global-eval-what-are-the-options/#new_function

    if (!/(["'])use strict\1/.test(expr) && !keys.includes('arguments')) {
      expr = 'var arguments = undefined;' + expr;
    } // Remove last semi so `return` will be inserted before
    //  the previous one instead, allowing for the return
    //  of a bare ending expression


    expr = expr.replace(/;[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*$/, ''); // Insert `return`

    var lastStatementEnd = expr.lastIndexOf(';');
    var code = lastStatementEnd > -1 ? expr.slice(0, lastStatementEnd + 1) + ' return ' + expr.slice(lastStatementEnd + 1) : ' return ' + expr; // eslint-disable-next-line no-new-func

    return _construct(Function, _toConsumableArray(keys).concat([code])).apply(void 0, _toConsumableArray(values));
  }
};



;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/idxState/v1/idxResponseParser.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */






const SKIP_FIELDS = Object.fromEntries([
    'remediation',
    'context',
].map((field) => [field, !!'skip this field']));
const parseNonRemediations = function parseNonRemediations(authClient, idxResponse, toPersist = {}) {
    const actions = {};
    const context = {};
    Object.keys(idxResponse)
        .filter(field => !SKIP_FIELDS[field])
        .forEach(field => {
        const fieldIsObject = typeof idxResponse[field] === 'object' && !!idxResponse[field];
        if (!fieldIsObject) {
            context[field] = idxResponse[field];
            return;
        }
        if (idxResponse[field].rel) {
            actions[idxResponse[field].name] = generateIdxAction(authClient, idxResponse[field], toPersist);
            return;
        }
        const _a = idxResponse[field], { value: fieldValue, type } = _a, info = __rest(_a, ["value", "type"]);
        context[field] = Object.assign({ type }, info);
        if (type !== 'object') {
            context[field].value = fieldValue;
            return;
        }
        context[field].value = {};
        Object.entries(fieldValue)
            .forEach(([subField, value]) => {
            if (value.rel) {
                actions[`${field}-${subField.name || subField}`] = generateIdxAction(authClient, value, toPersist);
            }
            else {
                context[field].value[subField] = value;
            }
        });
    });
    return { context, actions };
};
const expandRelatesTo = (idxResponse, value) => {
    Object.keys(value).forEach(k => {
        if (k === 'relatesTo') {
            const query = Array.isArray(value[k]) ? value[k][0] : value[k];
            if (typeof query === 'string') {
                const result = JSONPath({ path: query, json: idxResponse })[0];
                if (result) {
                    value[k] = result;
                    return;
                }
            }
        }
        if (Array.isArray(value[k])) {
            value[k].forEach(innerValue => expandRelatesTo(idxResponse, innerValue));
        }
    });
};
const convertRemediationAction = (authClient, remediation, toPersist) => {
    if (remediation.rel) {
        const remediationActions = generateRemediationFunctions(authClient, [remediation], toPersist);
        const actionFn = remediationActions[remediation.name];
        return Object.assign(Object.assign({}, remediation), { action: actionFn });
    }
    return remediation;
};
const parseIdxResponse = function parseIdxResponse(authClient, idxResponse, toPersist = {}) {
    var _a;
    const remediationData = ((_a = idxResponse.remediation) === null || _a === void 0 ? void 0 : _a.value) || [];
    remediationData.forEach(remediation => expandRelatesTo(idxResponse, remediation));
    const remediations = remediationData.map(remediation => convertRemediationAction(authClient, remediation, toPersist));
    const { context, actions } = parseNonRemediations(authClient, idxResponse, toPersist);
    return {
        remediations,
        context,
        actions,
    };
};


//# sourceMappingURL=idxResponseParser.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/idxState/v1/makeIdxState.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



function makeIdxState(authClient, idxResponse, toPersist, requestDidSucceed) {
    var _a, _b, _c;
    const rawIdxResponse = idxResponse;
    const { remediations, context, actions } = parseIdxResponse(authClient, idxResponse, toPersist);
    const neededToProceed = [...remediations];
    const proceed = async function (remediationChoice, paramsFromUser = {}) {
        const remediationChoiceObject = remediations.find((remediation) => remediation.name === remediationChoice);
        if (!remediationChoiceObject) {
            return Promise.reject(`Unknown remediation choice: [${remediationChoice}]`);
        }
        const actionFn = remediationChoiceObject.action;
        if (typeof actionFn !== 'function') {
            return Promise.reject(`Current remediation cannot make form submit action: [${remediationChoice}]`);
        }
        return remediationChoiceObject.action(paramsFromUser);
    };
    const findCode = item => item.name === 'interaction_code';
    const interactionCode = (_c = (_b = (_a = rawIdxResponse.successWithInteractionCode) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.find(findCode)) === null || _c === void 0 ? void 0 : _c.value;
    return {
        proceed,
        neededToProceed,
        actions,
        context,
        rawIdxState: rawIdxResponse,
        interactionCode,
        toPersist,
        requestDidSucceed,
    };
}


//# sourceMappingURL=makeIdxState.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/idxState/v1/parsers.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



var v1 = {
    makeIdxState: makeIdxState,
};


//# sourceMappingURL=parsers.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/idxState/index.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */




const parsersForVersion = function parsersForVersion(version) {
    switch (version) {
        case '1.0.0':
            return v1;
        case undefined:
        case null:
            throw new Error('Api version is required');
        default:
            throw new Error(`Unknown api version: ${version}.  Use an exact semver version.`);
    }
};
function validateVersionConfig(version) {
    if (!version) {
        throw new Error('version is required');
    }
    const cleanVersion = (version !== null && version !== void 0 ? version : '').replace(/[^0-9a-zA-Z._-]/, '');
    if (cleanVersion !== version || !version) {
        throw new Error('invalid version supplied - version is required and uses semver syntax');
    }
    parsersForVersion(version);
}
function idxState_makeIdxState(authClient, rawIdxResponse, toPersist, requestDidSucceed) {
    var _a;
    const version = (_a = rawIdxResponse === null || rawIdxResponse === void 0 ? void 0 : rawIdxResponse.version) !== null && _a !== void 0 ? _a : IDX_API_VERSION;
    validateVersionConfig(version);
    const { makeIdxState } = parsersForVersion(version);
    return makeIdxState(authClient, rawIdxResponse, toPersist, requestDidSucceed);
}


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/introspect.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */










async function introspect(authClient, options = {}) {
    var _a;
    let rawIdxResponse;
    let requestDidSucceed;
    const savedIdxResponse = authClient.transactionManager.loadIdxResponse(options);
    if (savedIdxResponse) {
        rawIdxResponse = savedIdxResponse.rawIdxResponse;
        requestDidSucceed = savedIdxResponse.requestDidSucceed;
    }
    if (!rawIdxResponse) {
        const version = options.version || IDX_API_VERSION;
        const domain = getOAuthDomain(authClient);
        const { interactionHandle, stateHandle } = options;
        const withCredentials = (_a = options.withCredentials) !== null && _a !== void 0 ? _a : true;
        try {
            requestDidSucceed = true;
            validateVersionConfig(version);
            const url = `${domain}/idp/idx/introspect`;
            const body = stateHandle ? { stateToken: stateHandle } : { interactionHandle };
            const headers = {
                'Content-Type': `application/ion+json; okta-version=${version}`,
                Accept: `application/ion+json; okta-version=${version}`,
            };
            rawIdxResponse = await request_httpRequest(authClient, {
                method: 'POST',
                url,
                headers,
                withCredentials,
                args: body
            });
        }
        catch (err) {
            if (errors_isAuthApiError(err) && err.xhr && isRawIdxResponse(err.xhr.responseJSON)) {
                rawIdxResponse = err.xhr.responseJSON;
                requestDidSucceed = false;
            }
            else {
                throw err;
            }
        }
    }
    const { withCredentials } = options;
    return idxState_makeIdxState(authClient, rawIdxResponse, { withCredentials }, requestDidSucceed);
}


//# sourceMappingURL=introspect.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/remediators/util.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */

function getAllValues(idxRemediation) {
    var _a;
    return (_a = idxRemediation.value) === null || _a === void 0 ? void 0 : _a.map(r => r.name);
}
function getRequiredValues(idxRemediation) {
    var _a;
    return (_a = idxRemediation.value) === null || _a === void 0 ? void 0 : _a.reduce((required, cur) => {
        if (cur.required) {
            required.push(cur.name);
        }
        return required;
    }, []);
}
function titleCase(str) {
    return str.charAt(0).toUpperCase() + str.substring(1);
}
function getAuthenticatorFromRemediation(remediation) {
    return remediation.value.find(({ name }) => name === 'authenticator');
}


//# sourceMappingURL=util.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/authenticator/util.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



function formatAuthenticator(incoming) {
    let authenticator;
    if (isAuthenticator(incoming)) {
        authenticator = incoming;
    }
    else if (typeof incoming === 'string') {
        authenticator = {
            key: incoming
        };
    }
    else {
        throw new Error('Invalid format for authenticator');
    }
    return authenticator;
}
function compareAuthenticators(auth1, auth2) {
    if (!auth1 || !auth2) {
        return false;
    }
    if (auth1.id && auth2.id) {
        return (auth1.id === auth2.id);
    }
    if (auth1.key && auth2.key) {
        return (auth1.key === auth2.key);
    }
    return false;
}
function findMatchedOption(authenticators, options) {
    let option;
    for (let authenticator of authenticators) {
        option = options
            .find(({ relatesTo }) => relatesTo.key === authenticator.key);
        if (option) {
            break;
        }
    }
    return option;
}


//# sourceMappingURL=util.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/remediators/Base/Remediator.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */




class Remediator {
    constructor(remediation, values = {}, options = {}) {
        this.values = Object.assign({}, values);
        this.options = Object.assign({}, options);
        this.formatAuthenticators();
        this.remediation = remediation;
    }
    formatAuthenticators() {
        this.values.authenticators = (this.values.authenticators || []);
        this.values.authenticators = this.values.authenticators.map(authenticator => {
            return formatAuthenticator(authenticator);
        });
        if (this.values.authenticator) {
            const authenticator = formatAuthenticator(this.values.authenticator);
            const hasAuthenticatorInList = this.values.authenticators.some(existing => {
                return compareAuthenticators(authenticator, existing);
            });
            if (!hasAuthenticatorInList) {
                this.values.authenticators.push(authenticator);
            }
        }
        this.values.authenticatorsData = this.values.authenticators.reduce((acc, authenticator) => {
            if (typeof authenticator === 'object' && Object.keys(authenticator).length > 1) {
                acc.push(authenticator);
            }
            return acc;
        }, this.values.authenticatorsData || []);
    }
    getName() {
        return this.remediation.name;
    }
    canRemediate() {
        const required = getRequiredValues(this.remediation);
        const needed = required.find((key) => !this.hasData(key));
        if (needed) {
            return false;
        }
        return true;
    }
    getData(key) {
        if (!key) {
            let allValues = getAllValues(this.remediation);
            let res = allValues.reduce((data, key) => {
                data[key] = this.getData(key);
                return data;
            }, {});
            return res;
        }
        if (typeof this[`map${titleCase(key)}`] === 'function') {
            const val = this[`map${titleCase(key)}`](this.remediation.value.find(({ name }) => name === key));
            if (val) {
                return val;
            }
        }
        if (this.map && this.map[key]) {
            const entry = this.map[key];
            for (let i = 0; i < entry.length; i++) {
                let val = this.values[entry[i]];
                if (val) {
                    return val;
                }
            }
        }
        return this.values[key];
    }
    hasData(key
    ) {
        return !!this.getData(key);
    }
    getNextStep(_authClient, _context) {
        const name = this.getName();
        const inputs = this.getInputs();
        const authenticator = this.getAuthenticator();
        const type = authenticator === null || authenticator === void 0 ? void 0 : authenticator.type;
        return Object.assign(Object.assign({ name,
            inputs }, (type && { type })), (authenticator && { authenticator }));
    }
    getInputs() {
        const inputs = [];
        const inputsFromRemediation = this.remediation.value || [];
        inputsFromRemediation.forEach(inputFromRemediation => {
            let input;
            let { name, type, visible, messages } = inputFromRemediation;
            if (visible === false) {
                return;
            }
            if (typeof this[`getInput${titleCase(name)}`] === 'function') {
                input = this[`getInput${titleCase(name)}`](inputFromRemediation);
            }
            else if (type !== 'object') {
                let alias;
                const aliases = (this.map ? this.map[name] : null) || [];
                if (aliases.length === 1) {
                    alias = aliases[0];
                }
                else {
                    alias = aliases.find(name => Object.keys(this.values).includes(name));
                }
                if (alias) {
                    input = Object.assign(Object.assign({}, inputFromRemediation), { name: alias });
                }
            }
            if (!input) {
                input = inputFromRemediation;
            }
            if (Array.isArray(input)) {
                input.forEach(i => inputs.push(i));
            }
            else {
                if (messages) {
                    input.messages = messages;
                }
                inputs.push(input);
            }
        });
        return inputs;
    }
    static getMessages(remediation) {
        var _a, _b;
        if (!remediation.value) {
            return;
        }
        return (_b = (_a = remediation.value[0]) === null || _a === void 0 ? void 0 : _a.form) === null || _b === void 0 ? void 0 : _b.value.reduce((messages, field) => {
            if (field.messages) {
                messages = [...messages, ...field.messages.value];
            }
            return messages;
        }, []);
    }
    getValuesAfterProceed() {
        const inputsFromRemediation = this.remediation.value || [];
        const inputsFromRemediator = this.getInputs();
        const inputs = [
            ...inputsFromRemediation,
            ...inputsFromRemediator
        ];
        for (const input of inputs) {
            delete this.values[input.name];
        }
        return this.values;
    }
    getAuthenticator() {
        var _a, _b;
        const relatesTo = (_a = this.remediation.relatesTo) === null || _a === void 0 ? void 0 : _a.value;
        if (!relatesTo) {
            return;
        }
        const authenticatorFromRemediation = getAuthenticatorFromRemediation(this.remediation);
        if (!authenticatorFromRemediation) {
            return relatesTo;
        }
        const id = authenticatorFromRemediation.form.value
            .find(({ name }) => name === 'id').value;
        const enrollmentId = (_b = authenticatorFromRemediation.form.value
            .find(({ name }) => name === 'enrollmentId')) === null || _b === void 0 ? void 0 : _b.value;
        return Object.assign(Object.assign({}, relatesTo), { id,
            enrollmentId });
    }
}


//# sourceMappingURL=Remediator.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/authenticator/Authenticator.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */

class Authenticator {
    constructor(authenticator) {
        this.meta = authenticator;
    }
}


//# sourceMappingURL=Authenticator.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/authenticator/VerificationCodeAuthenticator.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



class VerificationCodeAuthenticator extends Authenticator {
    canVerify(values) {
        return !!(values.credentials || values.verificationCode || values.otp);
    }
    mapCredentials(values) {
        const { credentials, verificationCode, otp } = values;
        if (!credentials && !verificationCode && !otp) {
            return;
        }
        return credentials || { passcode: verificationCode || otp };
    }
    getInputs(idxRemediationValue) {
        var _a;
        return Object.assign(Object.assign({}, (_a = idxRemediationValue.form) === null || _a === void 0 ? void 0 : _a.value[0]), { name: 'verificationCode', type: 'string', required: idxRemediationValue.required });
    }
}


//# sourceMappingURL=VerificationCodeAuthenticator.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/authenticator/OktaVerifyTotp.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



class OktaVerifyTotp extends VerificationCodeAuthenticator {
    mapCredentials(values) {
        const { verificationCode } = values;
        if (!verificationCode) {
            return;
        }
        return { totp: verificationCode };
    }
}


//# sourceMappingURL=OktaVerifyTotp.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/authenticator/OktaPassword.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



class OktaPassword extends Authenticator {
    canVerify(values) {
        return !!(values.credentials || values.password || values.passcode);
    }
    mapCredentials(values) {
        const { credentials, password, passcode } = values;
        if (!credentials && !password && !passcode) {
            return;
        }
        return credentials || { passcode: passcode || password };
    }
    getInputs(idxRemediationValue) {
        var _a;
        return Object.assign(Object.assign({}, (_a = idxRemediationValue.form) === null || _a === void 0 ? void 0 : _a.value[0]), { name: 'password', type: 'string', required: idxRemediationValue.required });
    }
}


//# sourceMappingURL=OktaPassword.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/authenticator/SecurityQuestionEnrollment.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



class SecurityQuestionEnrollment extends Authenticator {
    canVerify(values) {
        const { credentials } = values;
        if (credentials && credentials.questionKey && credentials.answer) {
            return true;
        }
        const { questionKey, question, answer } = values;
        return !!(questionKey && answer) || !!(question && answer);
    }
    mapCredentials(values) {
        const { questionKey, question, answer } = values;
        if (!answer || (!questionKey && !question)) {
            return;
        }
        return {
            questionKey: question ? 'custom' : questionKey,
            question,
            answer
        };
    }
    getInputs() {
        return [
            { name: 'questionKey', type: 'string', required: true },
            { name: 'question', type: 'string', label: 'Create a security question' },
            { name: 'answer', type: 'string', label: 'Answer', required: true },
        ];
    }
}


//# sourceMappingURL=SecurityQuestionEnrollment.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/authenticator/SecurityQuestionVerification.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



class SecurityQuestionVerification extends Authenticator {
    canVerify(values) {
        const { credentials } = values;
        if (credentials && credentials.answer) {
            return true;
        }
        const { answer } = values;
        return !!answer;
    }
    mapCredentials(values) {
        const { answer } = values;
        if (!answer) {
            return;
        }
        return {
            questionKey: this.meta.contextualData.enrolledQuestion.questionKey,
            answer
        };
    }
    getInputs() {
        return [
            { name: 'answer', type: 'string', label: 'Answer', required: true }
        ];
    }
}


//# sourceMappingURL=SecurityQuestionVerification.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/authenticator/WebauthnEnrollment.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



class WebauthnEnrollment extends Authenticator {
    canVerify(values) {
        const { credentials } = values;
        const obj = credentials || values;
        const { clientData, attestation } = obj;
        return !!(clientData && attestation);
    }
    mapCredentials(values) {
        const { credentials, clientData, attestation } = values;
        if (!credentials && !clientData && !attestation) {
            return;
        }
        return credentials || ({
            clientData,
            attestation
        });
    }
    getInputs() {
        return [
            { name: 'clientData', type: 'string', required: true, visible: false, label: 'Client Data' },
            { name: 'attestation', type: 'string', required: true, visible: false, label: 'Attestation' },
        ];
    }
}


//# sourceMappingURL=WebauthnEnrollment.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/authenticator/WebauthnVerification.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



class WebauthnVerification extends Authenticator {
    canVerify(values) {
        const { credentials } = values;
        const obj = credentials || values;
        const { clientData, authenticatorData, signatureData } = obj;
        return !!(clientData && authenticatorData && signatureData);
    }
    mapCredentials(values) {
        const { credentials, authenticatorData, clientData, signatureData } = values;
        if (!credentials && !authenticatorData && !clientData && !signatureData) {
            return;
        }
        return credentials || ({
            authenticatorData,
            clientData,
            signatureData
        });
    }
    getInputs() {
        return [
            { name: 'authenticatorData', type: 'string', label: 'Authenticator Data', required: true, visible: false },
            { name: 'clientData', type: 'string', label: 'Client Data', required: true, visible: false },
            { name: 'signatureData', type: 'string', label: 'Signature Data', required: true, visible: false },
        ];
    }
}


//# sourceMappingURL=WebauthnVerification.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/authenticator/getAuthenticator.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */










function getAuthenticator(remediation) {
    var _a, _b;
    const relatesTo = remediation.relatesTo;
    const value = (relatesTo === null || relatesTo === void 0 ? void 0 : relatesTo.value) || {};
    switch (value.key) {
        case AuthenticatorKey.OKTA_PASSWORD:
            return new OktaPassword(value);
        case AuthenticatorKey.SECURITY_QUESTION:
            if ((_a = value.contextualData) === null || _a === void 0 ? void 0 : _a.enrolledQuestion) {
                return new SecurityQuestionVerification(value);
            }
            else {
                return new SecurityQuestionEnrollment(value);
            }
        case AuthenticatorKey.OKTA_VERIFY:
            return new OktaVerifyTotp(value);
        case AuthenticatorKey.WEBAUTHN:
            if ((_b = value.contextualData) === null || _b === void 0 ? void 0 : _b.challengeData) {
                return new WebauthnVerification(value);
            }
            else {
                return new WebauthnEnrollment(value);
            }
        default:
            return new VerificationCodeAuthenticator(value);
    }
}


//# sourceMappingURL=getAuthenticator.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/remediators/Base/VerifyAuthenticator.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */




class VerifyAuthenticator extends Remediator {
    constructor(remediation, values = {}) {
        super(remediation, values);
        this.authenticator = getAuthenticator(remediation);
    }
    getNextStep(authClient, context) {
        var _a;
        const nextStep = super.getNextStep(authClient, context);
        const authenticatorEnrollments = (_a = context === null || context === void 0 ? void 0 : context.authenticatorEnrollments) === null || _a === void 0 ? void 0 : _a.value;
        return Object.assign(Object.assign({}, nextStep), { authenticatorEnrollments });
    }
    canRemediate() {
        return this.authenticator.canVerify(this.values);
    }
    mapCredentials() {
        return this.authenticator.mapCredentials(this.values);
    }
    getInputCredentials(input) {
        return this.authenticator.getInputs(input);
    }
    getValuesAfterProceed() {
        this.values = super.getValuesAfterProceed();
        let trimmedValues = Object.keys(this.values).filter(valueKey => valueKey !== 'credentials');
        return trimmedValues.reduce((values, valueKey) => (Object.assign(Object.assign({}, values), { [valueKey]: this.values[valueKey] })), {});
    }
}


//# sourceMappingURL=VerifyAuthenticator.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/remediators/EnrollAuthenticator.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



class EnrollAuthenticator extends VerifyAuthenticator {
}
EnrollAuthenticator.remediationName = 'enroll-authenticator';


//# sourceMappingURL=EnrollAuthenticator.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/remediators/EnrollPoll.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



class EnrollPoll extends Remediator {
    canRemediate() {
        return !!this.values.startPolling || this.options.step === 'enroll-poll';
    }
    getNextStep(authClient, context) {
        const common = super.getNextStep(authClient, context);
        let authenticator = this.getAuthenticator();
        if (!authenticator && (context === null || context === void 0 ? void 0 : context.currentAuthenticator)) {
            authenticator = context.currentAuthenticator.value;
        }
        return Object.assign(Object.assign({}, common), { authenticator, poll: {
                required: true,
                refresh: this.remediation.refresh
            } });
    }
    getValuesAfterProceed() {
        let trimmedValues = Object.keys(this.values).filter(valueKey => valueKey !== 'startPolling');
        return trimmedValues.reduce((values, valueKey) => (Object.assign(Object.assign({}, values), { [valueKey]: this.values[valueKey] })), {});
    }
}
EnrollPoll.remediationName = 'enroll-poll';


//# sourceMappingURL=EnrollPoll.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/remediators/SelectEnrollmentChannel.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */




class SelectEnrollmentChannel extends Remediator {
    canRemediate() {
        if (this.values.channel) {
            return true;
        }
        if (this.values.authenticator) {
            const { id, channel } = this.values.authenticator;
            if (!!id && !!channel) {
                return true;
            }
        }
        return false;
    }
    getNextStep(authClient, context) {
        const common = super.getNextStep(authClient, context);
        const options = this.getChannels();
        const authenticator = context.currentAuthenticator.value;
        return Object.assign(Object.assign(Object.assign({}, common), (options && { options })), { authenticator });
    }
    getChannels() {
        var _a;
        const authenticator = getAuthenticatorFromRemediation(this.remediation);
        const remediationValue = authenticator.value;
        return (_a = remediationValue.form.value.find(({ name }) => name === 'channel')) === null || _a === void 0 ? void 0 : _a.options;
    }
    getData() {
        var _a;
        const remediationValue = this.remediation.value[0].value;
        return {
            authenticator: {
                id: remediationValue.form.value[0].value,
                channel: ((_a = this.values.authenticator) === null || _a === void 0 ? void 0 : _a.channel) || this.values.channel,
            },
            stateHandle: this.values.stateHandle,
        };
    }
    getValuesAfterProceed() {
        this.values = super.getValuesAfterProceed();
        delete this.values.authenticators;
        const filterKey = this.values.channel ? 'channel' : 'authenticator';
        let trimmedValues = Object.keys(this.values).filter(valueKey => valueKey !== filterKey);
        return trimmedValues.reduce((values, valueKey) => (Object.assign(Object.assign({}, values), { [valueKey]: this.values[valueKey] })), {});
    }
}
SelectEnrollmentChannel.remediationName = 'select-enrollment-channel';


//# sourceMappingURL=SelectEnrollmentChannel.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/remediators/EnrollmentChannelData.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



class EnrollmentChannelData extends Remediator {
    getInputEmail() {
        return [
            { name: 'email', type: 'string', required: true, label: 'Email' },
        ];
    }
    getInputPhoneNumber() {
        return [
            { name: 'phoneNumber', type: 'string', required: true, label: 'Phone Number' },
        ];
    }
    canRemediate() {
        return Boolean(this.values.email || this.values.phoneNumber);
    }
    getNextStep(authClient, context) {
        const common = super.getNextStep(authClient, context);
        const authenticator = context.currentAuthenticator.value;
        return Object.assign(Object.assign({}, common), { authenticator });
    }
    getData() {
        return {
            stateHandle: this.values.stateHandle,
            email: this.values.email,
            phoneNumber: this.values.phoneNumber
        };
    }
    getValuesAfterProceed() {
        let trimmedValues = Object.keys(this.values).filter(valueKey => !['email', 'phoneNumber'].includes(valueKey));
        return trimmedValues.reduce((values, valueKey) => (Object.assign(Object.assign({}, values), { [valueKey]: this.values[valueKey] })), {});
    }
}
EnrollmentChannelData.remediationName = 'enrollment-channel-data';


//# sourceMappingURL=EnrollmentChannelData.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/remediators/ChallengeAuthenticator.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



class ChallengeAuthenticator extends VerifyAuthenticator {
}
ChallengeAuthenticator.remediationName = 'challenge-authenticator';


//# sourceMappingURL=ChallengeAuthenticator.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/remediators/ChallengePoll.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



class ChallengePoll extends EnrollPoll {
    canRemediate() {
        return !!this.values.startPolling || this.options.step === 'challenge-poll';
    }
}
ChallengePoll.remediationName = 'challenge-poll';


//# sourceMappingURL=ChallengePoll.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/remediators/ResetAuthenticator.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



class ResetAuthenticator extends VerifyAuthenticator {
}
ResetAuthenticator.remediationName = 'reset-authenticator';


//# sourceMappingURL=ResetAuthenticator.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/remediators/EnrollProfile.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */





class EnrollProfile extends Remediator {
    constructor(remediation, values = {}, options = {}) {
        super(remediation, values, options);
        this.authenticator = null;
        const credentials = this.getCredentialsFromRemediation();
        if (credentials) {
            this.authenticator = this.authenticator = new OktaPassword({});
        }
    }
    canRemediate() {
        if (this.authenticator && !this.authenticator.canVerify(this.values)) {
            return false;
        }
        const userProfileFromValues = this.getData().userProfile;
        if (!userProfileFromValues) {
            return false;
        }
        const userProfileFromRemediation = this.remediation.value.find(({ name }) => name === 'userProfile');
        return userProfileFromRemediation.form.value.reduce((canRemediate, curr) => {
            if (curr.required) {
                canRemediate = canRemediate && !!userProfileFromValues[curr.name];
            }
            return canRemediate;
        }, true);
    }
    getCredentialsFromRemediation() {
        return this.remediation.value.find(({ name }) => name === 'credentials');
    }
    mapUserProfile({ form: { value: profileAttributes } }) {
        const attributeNames = profileAttributes.map(({ name }) => name);
        const data = attributeNames.reduce((attributeValues, attributeName) => (this.values[attributeName] ? Object.assign(Object.assign({}, attributeValues), { [attributeName]: this.values[attributeName] }) : attributeValues), {});
        if (Object.keys(data).length === 0) {
            return;
        }
        return data;
    }
    mapCredentials() {
        const val = this.authenticator && this.authenticator.mapCredentials(this.values);
        if (!val) {
            return;
        }
        return val;
    }
    getInputUserProfile(input) {
        return [...input.form.value];
    }
    getInputCredentials(input) {
        return [...input.form.value];
    }
    getErrorMessages(errorRemediation) {
        return errorRemediation.value[0].form.value.reduce((errors, field) => {
            if (field.messages) {
                errors.push(field.messages.value[0].message);
            }
            return errors;
        }, []);
    }
}
EnrollProfile.remediationName = 'enroll-profile';


//# sourceMappingURL=EnrollProfile.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/remediators/Identify.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



class Identify extends Remediator {
    constructor() {
        super(...arguments);
        this.map = {
            'identifier': ['username']
        };
    }
    canRemediate() {
        const { identifier } = this.getData();
        return !!identifier;
    }
    mapCredentials() {
        const { credentials, password } = this.values;
        if (!credentials && !password) {
            return;
        }
        return credentials || { passcode: password };
    }
    getInputCredentials(input) {
        return Object.assign(Object.assign({}, input.form.value[0]), { name: 'password', required: input.required });
    }
}
Identify.remediationName = 'identify';


//# sourceMappingURL=Identify.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/remediators/ReEnrollAuthenticator.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



class ReEnrollAuthenticator extends Remediator {
    mapCredentials() {
        const { newPassword } = this.values;
        if (!newPassword) {
            return;
        }
        return {
            passcode: newPassword,
        };
    }
    getInputCredentials(input) {
        const challengeType = this.getAuthenticator().type;
        const name = challengeType === 'password' ? 'newPassword' : 'verificationCode';
        return Object.assign(Object.assign({}, input.form.value[0]), { name });
    }
}
ReEnrollAuthenticator.remediationName = 'reenroll-authenticator';


//# sourceMappingURL=ReEnrollAuthenticator.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/remediators/RedirectIdp.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



class RedirectIdp extends Remediator {
    canRemediate() {
        return false;
    }
    getNextStep() {
        const { name, type, idp, href } = this.remediation;
        return {
            name,
            type,
            idp,
            href
        };
    }
}
RedirectIdp.remediationName = 'redirect-idp';


//# sourceMappingURL=RedirectIdp.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/remediators/Base/SelectAuthenticator.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */






class SelectAuthenticator extends Remediator {
    findMatchedOption(authenticators, options) {
        let option;
        for (let authenticator of authenticators) {
            option = options
                .find(({ relatesTo }) => relatesTo.key === authenticator.key);
            if (option) {
                break;
            }
        }
        return option;
    }
    canRemediate() {
        const { authenticators, authenticator } = this.values;
        const authenticatorFromRemediation = getAuthenticatorFromRemediation(this.remediation);
        const { options } = authenticatorFromRemediation;
        if (!authenticators || !authenticators.length) {
            return false;
        }
        if (isAuthenticator(authenticator) && authenticator.id) {
            return true;
        }
        const matchedOption = this.findMatchedOption(authenticators, options);
        if (matchedOption) {
            return true;
        }
        return false;
    }
    getNextStep(authClient) {
        const common = super.getNextStep(authClient);
        const authenticatorFromRemediation = getAuthenticatorFromRemediation(this.remediation);
        const options = authenticatorFromRemediation.options.map(option => {
            const { label, relatesTo } = option;
            const key = relatesTo.key;
            return { label, value: key };
        });
        return Object.assign(Object.assign({}, common), { options });
    }
    mapAuthenticator(remediationValue) {
        const { authenticators, authenticator } = this.values;
        if (isAuthenticator(authenticator) && authenticator.id) {
            this.selectedAuthenticator = authenticator;
            return authenticator;
        }
        const { options } = remediationValue;
        const selectedOption = findMatchedOption(authenticators, options);
        this.selectedAuthenticator = selectedOption.relatesTo;
        this.selectedOption = selectedOption;
        return {
            id: selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.value.form.value.find(({ name }) => name === 'id').value
        };
    }
    getInputAuthenticator(remediation) {
        const options = remediation.options.map(({ label, relatesTo }) => {
            return {
                label,
                value: relatesTo.key
            };
        });
        return { name: 'authenticator', type: 'string', options };
    }
    getValuesAfterProceed() {
        this.values = super.getValuesAfterProceed();
        const authenticators = this.values.authenticators
            .filter(authenticator => {
            return compareAuthenticators(authenticator, this.selectedAuthenticator) !== true;
        });
        return Object.assign(Object.assign({}, this.values), { authenticators });
    }
}


//# sourceMappingURL=SelectAuthenticator.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/remediators/SelectAuthenticatorAuthenticate.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */





class SelectAuthenticatorAuthenticate extends SelectAuthenticator {
    constructor(remediation, values = {}, options = {}) {
        var _a;
        super(remediation, values, options);
        const isRecoveryFlow = this.options.flow === 'recoverPassword';
        const hasPasswordInOptions = (_a = getAuthenticatorFromRemediation(remediation)
            .options) === null || _a === void 0 ? void 0 : _a.some(({ relatesTo }) => (relatesTo === null || relatesTo === void 0 ? void 0 : relatesTo.key) === AuthenticatorKey.OKTA_PASSWORD);
        if (hasPasswordInOptions && (isRecoveryFlow || this.values.password)) {
            this.values.authenticators = [
                ...this.values.authenticators || [],
                { key: AuthenticatorKey.OKTA_PASSWORD }
            ];
        }
    }
}
SelectAuthenticatorAuthenticate.remediationName = 'select-authenticator-authenticate';


//# sourceMappingURL=SelectAuthenticatorAuthenticate.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/remediators/SelectAuthenticatorEnroll.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



class SelectAuthenticatorEnroll extends SelectAuthenticator {
}
SelectAuthenticatorEnroll.remediationName = 'select-authenticator-enroll';


//# sourceMappingURL=SelectAuthenticatorEnroll.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/remediators/SelectAuthenticatorUnlockAccount.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



class SelectAuthenticatorUnlockAccount extends SelectAuthenticator {
    constructor() {
        super(...arguments);
        this.map = {
            identifier: ['username']
        };
    }
    canRemediate() {
        const identifier = this.getData('identifier');
        return !!identifier && super.canRemediate();
    }
    mapAuthenticator(remediationValue) {
        var _a, _b, _c;
        const authenticatorMap = super.mapAuthenticator(remediationValue);
        const methodTypeOption = (_a = this.selectedOption) === null || _a === void 0 ? void 0 : _a.value.form.value.find(({ name }) => name === 'methodType');
        const methodTypeValue = this.values.methodType ||
            (methodTypeOption === null || methodTypeOption === void 0 ? void 0 : methodTypeOption.value) || ((_c = (_b = methodTypeOption === null || methodTypeOption === void 0 ? void 0 : methodTypeOption.options) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.value);
        if (methodTypeValue) {
            return Object.assign(Object.assign({}, authenticatorMap), { methodType: methodTypeValue });
        }
        return authenticatorMap;
    }
    getInputUsername() {
        return { name: 'username', type: 'string' };
    }
}
SelectAuthenticatorUnlockAccount.remediationName = 'select-authenticator-unlock-account';


//# sourceMappingURL=SelectAuthenticatorUnlockAccount.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/remediators/SelectEnrollProfile.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



class SelectEnrollProfile extends Remediator {
    canRemediate() {
        return true;
    }
}
SelectEnrollProfile.remediationName = 'select-enroll-profile';


//# sourceMappingURL=SelectEnrollProfile.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/remediators/Base/AuthenticatorData.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */





class AuthenticatorData extends Remediator {
    constructor(remediation, values = {}) {
        super(remediation, values);
        this.authenticator = this.getAuthenticator();
        this.formatAuthenticatorData();
    }
    formatAuthenticatorData() {
        const authenticatorData = this.getAuthenticatorData();
        if (authenticatorData) {
            this.values.authenticatorsData = this.values.authenticatorsData.map(data => {
                if (compareAuthenticators(this.authenticator, data)) {
                    return this.mapAuthenticatorDataFromValues(data);
                }
                return data;
            });
        }
        else {
            const data = this.mapAuthenticatorDataFromValues();
            if (data) {
                this.values.authenticatorsData.push(data);
            }
        }
    }
    getAuthenticatorData() {
        return this.values.authenticatorsData
            .find((data) => compareAuthenticators(this.authenticator, data));
    }
    canRemediate() {
        return this.values.authenticatorsData
            .some(data => compareAuthenticators(this.authenticator, data));
    }
    getNextStep(authClient) {
        const common = super.getNextStep(authClient);
        const options = this.getMethodTypes();
        return Object.assign(Object.assign({}, common), (options && { options }));
    }
    mapAuthenticatorDataFromValues(authenticatorData) {
        let { methodType, authenticator } = this.values;
        if (!methodType && isAuthenticator(authenticator)) {
            methodType = authenticator === null || authenticator === void 0 ? void 0 : authenticator.methodType;
        }
        const { id, enrollmentId } = this.authenticator;
        const data = Object.assign(Object.assign({ id,
            enrollmentId }, (authenticatorData && authenticatorData)), (methodType && { methodType }));
        return data.methodType ? data : null;
    }
    getAuthenticatorFromRemediation() {
        const authenticator = this.remediation.value
            .find(({ name }) => name === 'authenticator');
        return authenticator;
    }
    getMethodTypes() {
        var _a;
        const authenticator = this.getAuthenticatorFromRemediation();
        return (_a = authenticator.form.value.find(({ name }) => name === 'methodType')) === null || _a === void 0 ? void 0 : _a.options;
    }
    getValuesAfterProceed() {
        this.values = super.getValuesAfterProceed();
        const authenticatorsData = this.values.authenticatorsData
            .filter(data => compareAuthenticators(this.authenticator, data) !== true);
        return Object.assign(Object.assign({}, this.values), { authenticatorsData });
    }
}


//# sourceMappingURL=AuthenticatorData.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/remediators/AuthenticatorVerificationData.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */




class AuthenticatorVerificationData extends AuthenticatorData {
    constructor(remediation, values = {}, options = {}) {
        super(remediation, values);
        this.shouldProceedWithEmailAuthenticator = options.shouldProceedWithEmailAuthenticator !== false
            && this.authenticator.methods.length === 1
            && this.authenticator.methods[0].type === 'email';
    }
    canRemediate() {
        if (this.shouldProceedWithEmailAuthenticator !== false) {
            return true;
        }
        return super.canRemediate();
    }
    mapAuthenticator() {
        var _a;
        if (this.shouldProceedWithEmailAuthenticator !== false) {
            const authenticatorFromRemediation = this.getAuthenticatorFromRemediation();
            return (_a = authenticatorFromRemediation.form) === null || _a === void 0 ? void 0 : _a.value.reduce((acc, curr) => {
                if (curr.value) {
                    acc[curr.name] = curr.value;
                }
                else if (curr.options) {
                    acc[curr.name] = curr.options[0].value;
                }
                else {
                    throw new AuthSdkError_AuthSdkError(`Unsupported authenticator data type: ${curr}`);
                }
                return acc;
            }, {});
        }
        return this.getAuthenticatorData();
    }
    getInputAuthenticator() {
        const authenticator = this.getAuthenticatorFromRemediation();
        const methodType = authenticator.form.value.find(({ name }) => name === 'methodType');
        if (methodType && methodType.options) {
            return {
                name: 'methodType',
                type: 'string',
                required: true,
                options: methodType.options
            };
        }
        const inputs = [...authenticator.form.value];
        return inputs;
    }
    getValuesAfterProceed() {
        this.values = super.getValuesAfterProceed();
        let trimmedValues = Object.keys(this.values).filter(valueKey => valueKey !== 'authenticator');
        return trimmedValues.reduce((values, valueKey) => (Object.assign(Object.assign({}, values), { [valueKey]: this.values[valueKey] })), {});
    }
}
AuthenticatorVerificationData.remediationName = 'authenticator-verification-data';


//# sourceMappingURL=AuthenticatorVerificationData.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/remediators/AuthenticatorEnrollmentData.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */




class AuthenticatorEnrollmentData extends AuthenticatorData {
    mapAuthenticator() {
        const authenticatorData = this.getAuthenticatorData();
        const authenticatorFromRemediation = getAuthenticatorFromRemediation(this.remediation);
        return {
            id: authenticatorFromRemediation.form.value
                .find(({ name }) => name === 'id').value,
            methodType: authenticatorData.methodType,
            phoneNumber: authenticatorData.phoneNumber,
        };
    }
    getInputAuthenticator(remediation) {
        return [
            { name: 'methodType', type: 'string' },
            { name: 'phoneNumber', label: 'Phone Number', type: 'string' }
        ].map(item => {
            const value = remediation.form.value.find(val => val.name === item.name);
            return Object.assign(Object.assign({}, value), item);
        });
    }
    mapAuthenticatorDataFromValues(data) {
        data = super.mapAuthenticatorDataFromValues(data);
        const { phoneNumber } = this.values;
        if (!data && !phoneNumber) {
            return;
        }
        return Object.assign(Object.assign({}, (data && data)), (phoneNumber && { phoneNumber }));
    }
}
AuthenticatorEnrollmentData.remediationName = 'authenticator-enrollment-data';


//# sourceMappingURL=AuthenticatorEnrollmentData.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/remediators/Skip.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



class Skip extends Remediator {
    canRemediate() {
        return !!this.values.skip || this.options.step === 'skip';
    }
}
Skip.remediationName = 'skip';


//# sourceMappingURL=Skip.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/remediators/GenericRemediator/util.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */

function unwrapFormValue(remediation) {
    if (Array.isArray(remediation)) {
        return remediation
            .map(item => {
            if (typeof item === 'string' || typeof item === 'number' || typeof item === 'boolean') {
                return item;
            }
            return unwrapFormValue(item);
        });
    }
    const res = {};
    for (const [key, value] of Object.entries(remediation)) {
        if (value === null || typeof value === 'undefined') {
            continue;
        }
        if (typeof value === 'object') {
            const formKeys = Object.keys(value);
            if (['value', 'form'].includes(key)
                && formKeys.length === 1
                && ['value', 'form'].includes(formKeys[0])) {
                const unwrappedForm = unwrapFormValue(value);
                Object.entries(unwrappedForm).forEach(([key, value]) => {
                    res[key] = value;
                });
            }
            else {
                res[key] = unwrapFormValue(value);
            }
        }
        else {
            res[key] = value;
        }
    }
    return res;
}


//# sourceMappingURL=util.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/remediators/GenericRemediator/GenericRemediator.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */





class GenericRemediator extends Remediator {
    canRemediate() {
        if (typeof this.remediation.action !== 'function') {
            return false;
        }
        if (this.remediation.name === 'poll' || this.remediation.name.endsWith('-poll')) {
            return true;
        }
        if (this.options.step) {
            return true;
        }
        return false;
    }
    getData() {
        const data = this.getInputs().reduce((acc, { name }) => {
            acc[name] = this.values[name];
            return acc;
        }, {});
        return data;
    }
    getNextStep(authClient, _context) {
        const name = this.getName();
        const inputs = this.getInputs();
        const _a = this.remediation, {
        href, method, rel, accepts, produces,
        value,
        action } = _a, rest = __rest(_a, ["href", "method", "rel", "accepts", "produces", "value", "action"]);
        if (action) {
            return Object.assign(Object.assign(Object.assign({}, rest), (!!inputs.length && { inputs })), { action: async (params) => {
                    return authClient.idx.proceed(Object.assign({ step: name }, params));
                } });
        }
        return Object.assign({}, this.remediation);
    }
    getInputs() {
        return (this.remediation.value || [])
            .filter(({ name }) => name !== 'stateHandle')
            .map(unwrapFormValue)
            .map(input => {
            input.type = input.type || 'string';
            return input;
        });
    }
}


//# sourceMappingURL=GenericRemediator.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/remediators/index.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */





















//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/util.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */









function isTerminalResponse(idxResponse) {
    const { neededToProceed, interactionCode } = idxResponse;
    return !neededToProceed.length && !interactionCode;
}
function canSkipFn(idxResponse) {
    return idxResponse.neededToProceed.some(({ name }) => name === 'skip');
}
function canResendFn(idxResponse) {
    return Object.keys(idxResponse.actions).some(actionName => actionName.includes('resend'));
}
function getMessagesFromIdxRemediationValue(value) {
    if (!value || !Array.isArray(value)) {
        return;
    }
    return value.reduce((messages, value) => {
        if (value.messages) {
            messages = [...messages, ...value.messages.value];
        }
        if (value.form) {
            const messagesFromForm = getMessagesFromIdxRemediationValue(value.form.value) || [];
            messages = [...messages, ...messagesFromForm];
        }
        if (value.options) {
            let optionValues = [];
            value.options.forEach(option => {
                if (!option.value || typeof option.value === 'string') {
                    return;
                }
                optionValues = [...optionValues, option.value];
            });
            const messagesFromOptions = getMessagesFromIdxRemediationValue(optionValues) || [];
            messages = [...messages, ...messagesFromOptions];
        }
        return messages;
    }, []);
}
function getMessagesFromResponse(idxResponse, options) {
    var _a;
    let messages = [];
    const { rawIdxState, neededToProceed } = idxResponse;
    const globalMessages = (_a = rawIdxState.messages) === null || _a === void 0 ? void 0 : _a.value.map(message => message);
    if (globalMessages) {
        messages = [...messages, ...globalMessages];
    }
    if (!options.useGenericRemediator) {
        for (let remediation of neededToProceed) {
            const fieldMessages = getMessagesFromIdxRemediationValue(remediation.value);
            if (fieldMessages) {
                messages = [...messages, ...fieldMessages];
            }
        }
    }
    const seen = {};
    messages = messages.reduce((filtered, message) => {
        var _a;
        const key = (_a = message.i18n) === null || _a === void 0 ? void 0 : _a.key;
        if (key && seen[key]) {
            return filtered;
        }
        seen[key] = message;
        filtered = [...filtered, message];
        return filtered;
    }, []);
    return messages;
}
function getEnabledFeatures(idxResponse) {
    const res = [];
    const { actions, neededToProceed } = idxResponse;
    if (actions['currentAuthenticator-recover']) {
        res.push(IdxFeature.PASSWORD_RECOVERY);
    }
    if (neededToProceed.some(({ name }) => name === 'select-enroll-profile')) {
        res.push(IdxFeature.REGISTRATION);
    }
    if (neededToProceed.some(({ name }) => name === 'redirect-idp')) {
        res.push(IdxFeature.SOCIAL_IDP);
    }
    if (neededToProceed.some(({ name }) => name === 'unlock-account')) {
        res.push(IdxFeature.ACCOUNT_UNLOCK);
    }
    return res;
}
function getAvailableSteps(authClient, idxResponse, useGenericRemediator) {
    var _a;
    const res = [];
    const remediatorMap = Object.values(remediators_namespaceObject)
        .reduce((map, remediatorClass) => {
        if (remediatorClass.remediationName) {
            map[remediatorClass.remediationName] = remediatorClass;
        }
        return map;
    }, {});
    for (let remediation of idxResponse.neededToProceed) {
        const T = getRemediatorClass(remediation, { useGenericRemediator, remediators: remediatorMap });
        if (T) {
            const remediator = new T(remediation);
            res.push(remediator.getNextStep(authClient, idxResponse.context));
        }
    }
    for (const [name] of Object.entries((idxResponse.actions || {}))) {
        let stepObj = {
            name,
            action: async (params) => {
                return authClient.idx.proceed({
                    actions: [{ name, params }]
                });
            }
        };
        if (name.startsWith('currentAuthenticator')) {
            const [part1, part2] = split2(name, '-');
            const actionObj = idxResponse.rawIdxState[part1].value[part2];
            const rest = __rest(actionObj, ["href", "method", "rel", "accepts", "produces"]);
            const value = (_a = actionObj.value) === null || _a === void 0 ? void 0 : _a.filter(item => item.name !== 'stateHandle');
            stepObj = Object.assign(Object.assign(Object.assign({}, rest), (value && { value })), stepObj);
        }
        res.push(stepObj);
    }
    return res;
}
function filterValuesForRemediation(idxResponse, remediationName, values) {
    const remediations = idxResponse.neededToProceed || [];
    const remediation = remediations.find(r => r.name === remediationName);
    if (!remediation) {
        warn(`filterValuesForRemediation: "${remediationName}" did not match any remediations`);
        return values;
    }
    const valuesForRemediation = remediation.value.reduce((res, entry) => {
        const { name, value } = entry;
        if (name === 'stateHandle') {
            res[name] = value;
        }
        else {
            res[name] = values[name];
        }
        return res;
    }, {});
    return valuesForRemediation;
}
function getRemediatorClass(remediation, options) {
    const { useGenericRemediator, remediators } = options;
    if (!remediation) {
        return undefined;
    }
    if (useGenericRemediator) {
        return GenericRemediator;
    }
    return remediators[remediation.name];
}
function getRemediator(idxRemediations, values, options) {
    const remediators = options.remediators;
    const useGenericRemediator = options.useGenericRemediator;
    let remediator;
    if (options.step) {
        const remediation = idxRemediations.find(({ name }) => name === options.step);
        if (remediation) {
            const T = getRemediatorClass(remediation, options);
            return T ? new T(remediation, values, options) : undefined;
        }
        else {
            warn(`step "${options.step}" did not match any remediations`);
            return;
        }
    }
    const remediatorCandidates = [];
    if (useGenericRemediator) {
        remediatorCandidates.push(new GenericRemediator(idxRemediations[0], values, options));
    }
    else {
        for (let remediation of idxRemediations) {
            const isRemeditionInFlow = Object.keys(remediators).includes(remediation.name);
            if (!isRemeditionInFlow) {
                continue;
            }
            const T = getRemediatorClass(remediation, options);
            remediator = new T(remediation, values, options);
            if (remediator.canRemediate()) {
                return remediator;
            }
            remediatorCandidates.push(remediator);
        }
    }
    return remediatorCandidates[0];
}
function getNextStep(authClient, remediator, idxResponse) {
    const nextStep = remediator.getNextStep(authClient, idxResponse.context);
    const canSkip = canSkipFn(idxResponse);
    const canResend = canResendFn(idxResponse);
    return Object.assign(Object.assign(Object.assign({}, nextStep), (canSkip && { canSkip })), (canResend && { canResend }));
}
function handleIdxError(authClient, e, options = {}) {
    let idxResponse = isIdxResponse(e) ? e : null;
    if (!idxResponse) {
        throw e;
    }
    idxResponse = Object.assign(Object.assign({}, idxResponse), { requestDidSucceed: false });
    const terminal = isTerminalResponse(idxResponse);
    const messages = getMessagesFromResponse(idxResponse, options);
    if (terminal) {
        return { idxResponse, terminal, messages };
    }
    else {
        const remediator = getRemediator(idxResponse.neededToProceed, {}, options);
        const nextStep = remediator && getNextStep(authClient, remediator, idxResponse);
        return Object.assign({ idxResponse,
            messages }, (nextStep && { nextStep }));
    }
}


//# sourceMappingURL=util.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/remediate.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */




function getActionFromValues(values, idxResponse) {
    return Object.keys(idxResponse.actions).find(action => !!values.resend && action.includes('-resend'));
}
function removeActionFromValues(values) {
    return Object.assign(Object.assign({}, values), { resend: undefined });
}
function removeActionFromOptions(options, actionName) {
    let actions = options.actions || [];
    actions = actions.filter(entry => {
        if (typeof entry === 'string') {
            return entry !== actionName;
        }
        return entry.name !== actionName;
    });
    return Object.assign(Object.assign({}, options), { actions });
}
async function remediate(authClient, idxResponse, values, options) {
    let { neededToProceed, interactionCode } = idxResponse;
    const { flow } = options;
    if (interactionCode) {
        return { idxResponse };
    }
    const remediator = getRemediator(neededToProceed, values, options);
    const actionFromValues = getActionFromValues(values, idxResponse);
    const actionFromOptions = options.actions || [];
    const actions = [
        ...actionFromOptions,
        ...(actionFromValues && [actionFromValues] || []),
    ];
    if (actions) {
        for (let action of actions) {
            let params = {};
            if (typeof action !== 'string') {
                params = action.params || {};
                action = action.name;
            }
            let valuesWithoutExecutedAction = removeActionFromValues(values);
            let optionsWithoutExecutedAction = removeActionFromOptions(options, action);
            if (typeof idxResponse.actions[action] === 'function') {
                try {
                    idxResponse = await idxResponse.actions[action](params);
                    idxResponse = Object.assign(Object.assign({}, idxResponse), { requestDidSucceed: true });
                }
                catch (e) {
                    return handleIdxError(authClient, e, options);
                }
                if (action === 'cancel') {
                    return { idxResponse, canceled: true };
                }
                return remediate(authClient, idxResponse, valuesWithoutExecutedAction, optionsWithoutExecutedAction);
            }
            const remediationAction = neededToProceed.find(({ name }) => name === action);
            if (remediationAction) {
                try {
                    idxResponse = await idxResponse.proceed(action, params);
                    idxResponse = Object.assign(Object.assign({}, idxResponse), { requestDidSucceed: true });
                }
                catch (e) {
                    return handleIdxError(authClient, e, options);
                }
                return remediate(authClient, idxResponse, values, optionsWithoutExecutedAction);
            }
        }
    }
    const terminal = isTerminalResponse(idxResponse);
    if (terminal) {
        return { idxResponse, terminal };
    }
    if (!remediator) {
        if (options.step) {
            values = filterValuesForRemediation(idxResponse, options.step, values);
            try {
                idxResponse = await idxResponse.proceed(options.step, values);
                idxResponse = Object.assign(Object.assign({}, idxResponse), { requestDidSucceed: true });
                return { idxResponse };
            }
            catch (e) {
                return handleIdxError(authClient, e, options);
            }
        }
        if (flow === 'default') {
            return { idxResponse };
        }
        throw new AuthSdkError_AuthSdkError(`
      No remediation can match current flow, check policy settings in your org.
      Remediations: [${neededToProceed.reduce((acc, curr) => acc ? acc + ' ,' + curr.name : curr.name, '')}]
    `);
    }
    if (!remediator.canRemediate()) {
        const nextStep = getNextStep(authClient, remediator, idxResponse);
        return {
            idxResponse,
            nextStep,
        };
    }
    const name = remediator.getName();
    const data = remediator.getData();
    try {
        idxResponse = await idxResponse.proceed(name, data);
        idxResponse = Object.assign(Object.assign({}, idxResponse), { requestDidSucceed: true });
        values = remediator.getValuesAfterProceed();
        options = Object.assign(Object.assign({}, options), { step: undefined });
        if (options.useGenericRemediator && !idxResponse.interactionCode && !isTerminalResponse(idxResponse)) {
            const gr = getRemediator(idxResponse.neededToProceed, values, options);
            const nextStep = getNextStep(authClient, gr, idxResponse);
            return {
                idxResponse,
                nextStep,
            };
        }
        return remediate(authClient, idxResponse, values, options);
    }
    catch (e) {
        return handleIdxError(authClient, e, options);
    }
}


//# sourceMappingURL=remediate.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/flow/AuthenticationFlow.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */





















const AuthenticationFlow = {
    'identify': Identify,
    'select-authenticator-authenticate': SelectAuthenticatorAuthenticate,
    'select-authenticator-enroll': SelectAuthenticatorEnroll,
    'authenticator-enrollment-data': AuthenticatorEnrollmentData,
    'authenticator-verification-data': AuthenticatorVerificationData,
    'enroll-authenticator': EnrollAuthenticator,
    'challenge-authenticator': ChallengeAuthenticator,
    'challenge-poll': ChallengePoll,
    'reenroll-authenticator': ReEnrollAuthenticator,
    'enroll-poll': EnrollPoll,
    'select-enrollment-channel': SelectEnrollmentChannel,
    'enrollment-channel-data': EnrollmentChannelData,
    'redirect-idp': RedirectIdp,
    'skip': Skip,
};


//# sourceMappingURL=AuthenticationFlow.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/flow/PasswordRecoveryFlow.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */





















const PasswordRecoveryFlow = {
    'identify': Identify,
    'identify-recovery': Identify,
    'select-authenticator-authenticate': SelectAuthenticatorAuthenticate,
    'select-authenticator-enroll': SelectAuthenticatorEnroll,
    'challenge-authenticator': ChallengeAuthenticator,
    'authenticator-verification-data': AuthenticatorVerificationData,
    'authenticator-enrollment-data': AuthenticatorEnrollmentData,
    'reset-authenticator': ResetAuthenticator,
    'reenroll-authenticator': ReEnrollAuthenticator,
    'enroll-poll': EnrollPoll,
};


//# sourceMappingURL=PasswordRecoveryFlow.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/flow/RegistrationFlow.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */





















const RegistrationFlow = {
    'select-enroll-profile': SelectEnrollProfile,
    'enroll-profile': EnrollProfile,
    'authenticator-enrollment-data': AuthenticatorEnrollmentData,
    'select-authenticator-enroll': SelectAuthenticatorEnroll,
    'enroll-poll': EnrollPoll,
    'select-enrollment-channel': SelectEnrollmentChannel,
    'enrollment-channel-data': EnrollmentChannelData,
    'enroll-authenticator': EnrollAuthenticator,
    'skip': Skip,
};


//# sourceMappingURL=RegistrationFlow.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/flow/AccountUnlockFlow.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */





















const AccountUnlockFlow = {
    'identify': Identify,
    'select-authenticator-unlock-account': SelectAuthenticatorUnlockAccount,
    'select-authenticator-authenticate': SelectAuthenticatorAuthenticate,
    'challenge-authenticator': ChallengeAuthenticator,
    'challenge-poll': ChallengePoll,
    'authenticator-verification-data': AuthenticatorVerificationData,
};


//# sourceMappingURL=AccountUnlockFlow.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/flow/FlowSpecification.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */






function getFlowSpecification(oktaAuth, flow = 'default') {
    let remediators, actions, withCredentials = true;
    switch (flow) {
        case 'register':
        case 'signup':
        case 'enrollProfile':
            remediators = RegistrationFlow;
            withCredentials = false;
            break;
        case 'recoverPassword':
        case 'resetPassword':
            remediators = PasswordRecoveryFlow;
            actions = [
                'currentAuthenticator-recover',
                'currentAuthenticatorEnrollment-recover'
            ];
            withCredentials = false;
            break;
        case 'unlockAccount':
            remediators = AccountUnlockFlow;
            withCredentials = false;
            actions = [
                'unlock-account'
            ];
            break;
        case 'authenticate':
        case 'login':
        case 'signin':
            remediators = AuthenticationFlow;
            break;
        default:
            remediators = AuthenticationFlow;
            break;
    }
    return { flow, remediators, actions, withCredentials };
}


//# sourceMappingURL=FlowSpecification.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/run.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */





























function initializeValues(options) {
    const knownOptions = [
        'flow',
        'remediators',
        'actions',
        'withCredentials',
        'step',
        'useGenericRemediator',
        'exchangeCodeForTokens',
        'shouldProceedWithEmailAuthenticator'
    ];
    const values = Object.assign({}, options);
    knownOptions.forEach(option => {
        delete values[option];
    });
    return values;
}
function initializeData(authClient, data) {
    let { options } = data;
    options = Object.assign(Object.assign({}, authClient.options.idx), options);
    let { flow, withCredentials, remediators, actions, } = options;
    const status = IdxStatus.PENDING;
    flow = flow || authClient.idx.getFlow() || 'default';
    if (flow) {
        authClient.idx.setFlow(flow);
        const flowSpec = getFlowSpecification(authClient, flow);
        withCredentials = (typeof withCredentials !== 'undefined') ? withCredentials : flowSpec.withCredentials;
        remediators = remediators || flowSpec.remediators;
        actions = actions || flowSpec.actions;
    }
    return Object.assign(Object.assign({}, data), { options: Object.assign(Object.assign({}, options), { flow,
            withCredentials,
            remediators,
            actions }), status });
}
async function getDataFromIntrospect(authClient, data) {
    const { options } = data;
    const { stateHandle, withCredentials, version, state, scopes, recoveryToken, activationToken, maxAge, nonce, } = options;
    let idxResponse;
    let meta = getSavedTransactionMeta(authClient, { state, recoveryToken, activationToken });
    if (stateHandle) {
        idxResponse = await introspect(authClient, { withCredentials, version, stateHandle });
    }
    else {
        let interactionHandle = meta === null || meta === void 0 ? void 0 : meta.interactionHandle;
        if (!interactionHandle) {
            authClient.transactionManager.clear();
            const interactResponse = await interact(authClient, {
                withCredentials,
                state,
                scopes,
                activationToken,
                recoveryToken,
                maxAge,
                nonce,
            });
            interactionHandle = interactResponse.interactionHandle;
            meta = interactResponse.meta;
        }
        idxResponse = await introspect(authClient, { withCredentials, version, interactionHandle });
    }
    return Object.assign(Object.assign({}, data), { idxResponse, meta });
}
async function getDataFromRemediate(authClient, data) {
    let { idxResponse, options, values } = data;
    const { autoRemediate, remediators, actions, flow, step, shouldProceedWithEmailAuthenticator,
    useGenericRemediator, } = options;
    const shouldRemediate = (autoRemediate !== false && (remediators || actions || step));
    if (!shouldRemediate) {
        return data;
    }
    values = Object.assign(Object.assign({}, values), { stateHandle: idxResponse.rawIdxState.stateHandle });
    const { idxResponse: idxResponseFromRemediation, nextStep, canceled, } = await remediate(authClient, idxResponse, values, {
        remediators,
        actions,
        flow,
        step,
        shouldProceedWithEmailAuthenticator,
        useGenericRemediator,
    });
    idxResponse = idxResponseFromRemediation;
    return Object.assign(Object.assign({}, data), { idxResponse, nextStep, canceled });
}
async function getTokens(authClient, data) {
    let { meta, idxResponse } = data;
    const { interactionCode } = idxResponse;
    const { clientId, codeVerifier, ignoreSignature, redirectUri, urls, scopes, } = meta;
    const tokenResponse = await authClient.token.exchangeCodeForTokens({
        interactionCode,
        clientId,
        codeVerifier,
        ignoreSignature,
        redirectUri,
        scopes
    }, urls);
    return tokenResponse.tokens;
}
async function finalizeData(authClient, data) {
    let { options, idxResponse, canceled, status, } = data;
    const { exchangeCodeForTokens } = options;
    let shouldSaveResponse = false;
    let shouldClearTransaction = false;
    let clearSharedStorage = true;
    let interactionCode;
    let tokens;
    let enabledFeatures;
    let availableSteps;
    let messages;
    let terminal;
    if (idxResponse) {
        shouldSaveResponse = !!(idxResponse.requestDidSucceed || idxResponse.stepUp);
        enabledFeatures = getEnabledFeatures(idxResponse);
        availableSteps = getAvailableSteps(authClient, idxResponse, options.useGenericRemediator);
        messages = getMessagesFromResponse(idxResponse, options);
        terminal = isTerminalResponse(idxResponse);
    }
    if (terminal) {
        status = IdxStatus.TERMINAL;
        const hasActions = Object.keys(idxResponse.actions).length > 0;
        const hasErrors = !!messages.find(msg => msg.class === 'ERROR');
        const isTerminalSuccess = !hasActions && !hasErrors && idxResponse.requestDidSucceed === true;
        if (isTerminalSuccess) {
            shouldClearTransaction = true;
        }
        else {
            shouldSaveResponse = shouldSaveResponse && hasActions;
        }
        clearSharedStorage = false;
    }
    else if (canceled) {
        status = IdxStatus.CANCELED;
        shouldClearTransaction = true;
    }
    else if (idxResponse === null || idxResponse === void 0 ? void 0 : idxResponse.interactionCode) {
        interactionCode = idxResponse.interactionCode;
        if (exchangeCodeForTokens === false) {
            status = IdxStatus.SUCCESS;
            shouldClearTransaction = false;
        }
        else {
            tokens = await getTokens(authClient, data);
            status = IdxStatus.SUCCESS;
            shouldClearTransaction = true;
        }
    }
    return Object.assign(Object.assign({}, data), { status,
        interactionCode,
        tokens,
        shouldSaveResponse,
        shouldClearTransaction,
        clearSharedStorage,
        enabledFeatures,
        availableSteps,
        messages,
        terminal });
}
function handleError(err, data) {
    let { error, status, shouldClearTransaction } = data;
    if (isIdxResponse(err)) {
        error = err;
        status = IdxStatus.FAILURE;
        shouldClearTransaction = true;
    }
    else {
        throw err;
    }
    return Object.assign(Object.assign({}, data), { error, status, shouldClearTransaction });
}
async function run(authClient, options = {}) {
    var _a;
    let data = {
        options,
        values: initializeValues(options)
    };
    data = initializeData(authClient, data);
    try {
        data = await getDataFromIntrospect(authClient, data);
        data = await getDataFromRemediate(authClient, data);
    }
    catch (err) {
        data = handleError(err, data);
    }
    data = await finalizeData(authClient, data);
    const { idxResponse, meta, shouldSaveResponse, shouldClearTransaction, clearSharedStorage, status, enabledFeatures, availableSteps, tokens, nextStep, messages, error, interactionCode } = data;
    if (shouldClearTransaction) {
        authClient.transactionManager.clear({ clearSharedStorage });
    }
    else {
        saveTransactionMeta(authClient, Object.assign({}, meta));
        if (shouldSaveResponse) {
            const { rawIdxState: rawIdxResponse, requestDidSucceed } = idxResponse;
            authClient.transactionManager.saveIdxResponse({
                rawIdxResponse,
                requestDidSucceed,
                stateHandle: (_a = idxResponse.context) === null || _a === void 0 ? void 0 : _a.stateHandle,
                interactionHandle: meta === null || meta === void 0 ? void 0 : meta.interactionHandle
            });
        }
    }
    const { actions, context, neededToProceed, proceed, rawIdxState, requestDidSucceed, stepUp } = idxResponse || {};
    return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({ status: status }, (meta && { meta })), (enabledFeatures && { enabledFeatures })), (availableSteps && { availableSteps })), (tokens && { tokens })), (nextStep && { nextStep })), (messages && messages.length && { messages })), (error && { error })), (stepUp && { stepUp })), { interactionCode,
        actions: actions, context: context, neededToProceed: neededToProceed, proceed: proceed, rawIdxState: rawIdxState, requestDidSucceed });
}


//# sourceMappingURL=run.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/authenticate.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */





async function authenticate(authClient, options = {}) {
    if (options.password && !options.authenticator) {
        options.authenticator = AuthenticatorKey.OKTA_PASSWORD;
    }
    return run(authClient, Object.assign(Object.assign({}, options), { flow: 'authenticate' }));
}


//# sourceMappingURL=authenticate.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/cancel.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */























async function cancel(authClient, options) {
    const meta = authClient.transactionManager.load();
    const flowSpec = getFlowSpecification(authClient, meta.flow);
    return run(authClient, Object.assign(Object.assign(Object.assign({}, options), flowSpec), { actions: ['cancel'] }));
}


//# sourceMappingURL=cancel.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/emailVerify.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */




class EmailVerifyCallbackError extends CustomError {
    constructor(state, otp) {
        super(`Enter the OTP code in the originating client: ${otp}`);
        this.name = 'EmailVerifyCallbackError';
        this.state = state;
        this.otp = otp;
    }
}
function isEmailVerifyCallbackError(error) {
    return (error.name === 'EmailVerifyCallbackError');
}
function isEmailVerifyCallback(urlPath) {
    return /(otp=)/i.test(urlPath) && /(state=)/i.test(urlPath);
}
function parseEmailVerifyCallback(urlPath) {
    return urlParamsToObject(urlPath);
}
async function handleEmailVerifyCallback(authClient, search) {
    if (isEmailVerifyCallback(search)) {
        const { state, otp } = parseEmailVerifyCallback(search);
        if (authClient.idx.canProceed({ state })) {
            return await authClient.idx.proceed({ state, otp });
        }
        else {
            throw new EmailVerifyCallbackError(state, otp);
        }
    }
}


//# sourceMappingURL=emailVerify.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/proceed.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */





function canProceed(authClient, options = {}) {
    const meta = getSavedTransactionMeta(authClient, options);
    return !!(meta || options.stateHandle);
}
async function proceed(authClient, options = {}) {
    if (!canProceed(authClient, options)) {
        throw new AuthSdkError_AuthSdkError('Unable to proceed: saved transaction could not be loaded');
    }
    let { flow, state } = options;
    if (!flow) {
        const meta = getSavedTransactionMeta(authClient, { state });
        flow = meta === null || meta === void 0 ? void 0 : meta.flow;
    }
    return run(authClient, Object.assign(Object.assign({}, options), { flow }));
}


//# sourceMappingURL=proceed.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/poll.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */





async function poll(authClient, options = {}) {
    var _a;
    let transaction = await proceed(authClient, {
        startPolling: true
    });
    const meta = getSavedTransactionMeta(authClient);
    let availablePollingRemeditaions = (_a = meta === null || meta === void 0 ? void 0 : meta.remediations) === null || _a === void 0 ? void 0 : _a.find(remediation => remediation.includes('poll'));
    if (!(availablePollingRemeditaions === null || availablePollingRemeditaions === void 0 ? void 0 : availablePollingRemeditaions.length)) {
        warn('No polling remediations available at the current IDX flow stage');
    }
    if (Number.isInteger(options.refresh)) {
        return new Promise(function (resolve, reject) {
            setTimeout(async function () {
                var _a, _b;
                try {
                    const refresh = (_b = (_a = transaction.nextStep) === null || _a === void 0 ? void 0 : _a.poll) === null || _b === void 0 ? void 0 : _b.refresh;
                    if (refresh) {
                        resolve(poll(authClient, {
                            refresh
                        }));
                    }
                    else {
                        resolve(transaction);
                    }
                }
                catch (err) {
                    reject(err);
                }
            }, options.refresh);
        });
    }
    return transaction;
}


//# sourceMappingURL=poll.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/startTransaction.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



async function startTransaction(authClient, options = {}) {
    authClient.transactionManager.clear();
    return run(authClient, Object.assign({ exchangeCodeForTokens: false }, options));
}


//# sourceMappingURL=startTransaction.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/register.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */








async function register(authClient, options = {}) {
    if (!hasSavedInteractionHandle(authClient)) {
        const { enabledFeatures, availableSteps } = await startTransaction(authClient, Object.assign(Object.assign({}, options), { flow: 'register', autoRemediate: false }));
        if (!options.activationToken && enabledFeatures && !enabledFeatures.includes(IdxFeature.REGISTRATION)) {
            const error = new AuthSdkError_AuthSdkError('Registration is not supported based on your current org configuration.');
            throw error;
        }
        if (options.activationToken && (availableSteps === null || availableSteps === void 0 ? void 0 : availableSteps.some(({ name }) => name === 'identify'))) {
            const error = new AuthSdkError_AuthSdkError('activationToken is not supported based on your current org configuration.');
            throw error;
        }
    }
    return run(authClient, Object.assign(Object.assign({}, options), { flow: 'register' }));
}


//# sourceMappingURL=register.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/recoverPassword.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */























async function recoverPassword(authClient, options = {}) {
    const flowSpec = getFlowSpecification(authClient, 'recoverPassword');
    return run(authClient, Object.assign(Object.assign({}, options), flowSpec));
}


//# sourceMappingURL=recoverPassword.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/handleInteractionCodeRedirect.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */




async function handleInteractionCodeRedirect(authClient, url) {
    const meta = authClient.transactionManager.load();
    if (!meta) {
        throw new AuthSdkError_AuthSdkError('No transaction data was found in storage');
    }
    const { codeVerifier, state: savedState } = meta;
    const { searchParams
     } = new URL(url);
    const state = searchParams.get('state');
    const interactionCode = searchParams.get('interaction_code');
    const error = searchParams.get('error');
    if (error) {
        throw new OAuthError(error, searchParams.get('error_description'));
    }
    if (state !== savedState) {
        throw new AuthSdkError_AuthSdkError('State in redirect uri does not match with transaction state');
    }
    if (!interactionCode) {
        throw new AuthSdkError_AuthSdkError('Unable to parse interaction_code from the url');
    }
    const { tokens } = await authClient.token.exchangeCodeForTokens({ interactionCode, codeVerifier });
    authClient.tokenManager.setTokens(tokens);
}


//# sourceMappingURL=handleInteractionCodeRedirect.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/idx/unlockAccount.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */








async function unlockAccount(authClient, options = {}) {
    options.flow = 'unlockAccount';
    if (!hasSavedInteractionHandle(authClient)) {
        const { enabledFeatures } = await startTransaction(authClient, Object.assign(Object.assign({}, options), { autoRemediate: false }));
        if (enabledFeatures && !enabledFeatures.includes(IdxFeature.ACCOUNT_UNLOCK)) {
            throw new AuthSdkError_AuthSdkError('Self Service Account Unlock is not supported based on your current org configuration.');
        }
    }
    return run(authClient, Object.assign({}, options));
}


//# sourceMappingURL=unlockAccount.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/OktaUserAgent.js
/* provided dependency */ var process = __webpack_require__(83454);
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



class OktaUserAgent {
    constructor() {
        this.environments = [`okta-auth-js/${"6.9.0"}`];
    }
    addEnvironment(env) {
        this.environments.push(env);
    }
    getHttpHeader() {
        this.maybeAddNodeEnvironment();
        return { 'X-Okta-User-Agent-Extended': this.environments.join(' ') };
    }
    getVersion() {
        return "6.9.0";
    }
    maybeAddNodeEnvironment() {
        if (isBrowser() || !process || !process.versions) {
            return;
        }
        const { node: version } = process.versions;
        this.environments.push(`nodejs/${version}`);
    }
}


//# sourceMappingURL=OktaUserAgent.js.map

// EXTERNAL MODULE: ./node_modules/tiny-emitter/index.js
var tiny_emitter = __webpack_require__(74279);
;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/OktaAuth.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */




























































class OktaAuth {
    constructor(args) {
        this.features = features_namespaceObject;
        const options = this.options = buildOptions(args);
        this.storageManager = new StorageManager(options.storageManager, options.cookies, options.storageUtil);
        this.transactionManager = new TransactionManager(Object.assign({
            storageManager: this.storageManager,
        }, options.transactionManager));
        this._oktaUserAgent = new OktaUserAgent();
        this.tx = {
            status: transactionStatus.bind(null, this),
            resume: resumeTransaction.bind(null, this),
            exists: Object.assign(transactionExists.bind(null, this), {
                _get: (name) => {
                    const storage = options.storageUtil.storage;
                    return storage.get(name);
                }
            }),
            introspect: introspectAuthn.bind(null, this),
            createTransaction: (res) => {
                return new AuthTransaction(this, res);
            },
            postToTransaction: (url, args, options) => {
                return postToTransaction(this, url, args, options);
            }
        };
        this.pkce = {
            DEFAULT_CODE_CHALLENGE_METHOD: PKCE.DEFAULT_CODE_CHALLENGE_METHOD,
            generateVerifier: PKCE.generateVerifier,
            computeChallenge: PKCE.computeChallenge
        };
        Object.assign(this.options.storageUtil || {}, {
            getPKCEStorage: this.storageManager.getLegacyPKCEStorage.bind(this.storageManager),
            getHttpCache: this.storageManager.getHttpCache.bind(this.storageManager),
        });
        this._pending = { handleLogin: false };
        if (isBrowser()) {
            this.options = Object.assign(this.options, {
                redirectUri: toAbsoluteUrl(args.redirectUri, window.location.origin),
            });
        }
        if (!args.maxClockSkew && args.maxClockSkew !== 0) {
            this.options.maxClockSkew = DEFAULT_MAX_CLOCK_SKEW;
        }
        else {
            this.options.maxClockSkew = args.maxClockSkew;
        }
        this.options.ignoreLifetime = !!args.ignoreLifetime;
        this.session = {
            close: closeSession.bind(null, this),
            exists: sessionExists.bind(null, this),
            get: getSession.bind(null, this),
            refresh: refreshSession.bind(null, this),
            setCookieAndRedirect: setCookieAndRedirect.bind(null, this)
        };
        this._tokenQueue = new PromiseQueue();
        const useQueue = (method) => {
            return PromiseQueue.prototype.push.bind(this._tokenQueue, method, null);
        };
        const getWithRedirectFn = useQueue(getWithRedirect.bind(null, this));
        const getWithRedirectApi = Object.assign(getWithRedirectFn, {
            _setLocation: function (url) {
                if (options.setLocation) {
                    options.setLocation(url);
                }
                else {
                    window.location = url;
                }
            }
        });
        const parseFromUrlFn = useQueue(parseFromUrl.bind(null, this));
        const parseFromUrlApi = Object.assign(parseFromUrlFn, {
            _getHistory: function () {
                return window.history;
            },
            _getLocation: function () {
                return window.location;
            },
            _getDocument: function () {
                return window.document;
            }
        });
        this.token = {
            prepareTokenParams: prepareTokenParams.bind(null, this),
            exchangeCodeForTokens: exchangeCodeForTokens.bind(null, this),
            getWithoutPrompt: getWithoutPrompt.bind(null, this),
            getWithPopup: getWithPopup.bind(null, this),
            getWithRedirect: getWithRedirectApi,
            parseFromUrl: parseFromUrlApi,
            decode: decodeToken,
            revoke: revokeToken.bind(null, this),
            renew: renewToken.bind(null, this),
            renewTokensWithRefresh: renewTokensWithRefresh.bind(null, this),
            renewTokens: renewTokens.bind(null, this),
            getUserInfo: (accessTokenObject, idTokenObject) => {
                return getUserInfo(this, accessTokenObject, idTokenObject);
            },
            verify: verifyToken_verifyToken.bind(null, this),
            isLoginRedirect: isLoginRedirect.bind(null, this)
        };
        const toWrap = [
            'getWithoutPrompt',
            'getWithPopup',
            'revoke',
            'renew',
            'renewTokensWithRefresh',
            'renewTokens'
        ];
        toWrap.forEach(key => {
            this.token[key] = useQueue(this.token[key]);
        });
        const boundStartTransaction = startTransaction.bind(null, this);
        this.idx = {
            interact: interact.bind(null, this),
            introspect: introspect.bind(null, this),
            makeIdxResponse: idxState_makeIdxState.bind(null, this),
            authenticate: authenticate.bind(null, this),
            register: register.bind(null, this),
            start: boundStartTransaction,
            startTransaction: boundStartTransaction,
            poll: poll.bind(null, this),
            proceed: proceed.bind(null, this),
            cancel: cancel.bind(null, this),
            recoverPassword: recoverPassword.bind(null, this),
            handleInteractionCodeRedirect: handleInteractionCodeRedirect.bind(null, this),
            isInteractionRequired: isInteractionRequired.bind(null, this),
            isInteractionRequiredError: isInteractionRequiredError,
            handleEmailVerifyCallback: handleEmailVerifyCallback.bind(null, this),
            isEmailVerifyCallback: isEmailVerifyCallback,
            parseEmailVerifyCallback: parseEmailVerifyCallback,
            isEmailVerifyCallbackError: isEmailVerifyCallbackError,
            getSavedTransactionMeta: getSavedTransactionMeta.bind(null, this),
            createTransactionMeta: createTransactionMeta.bind(null, this),
            getTransactionMeta: getTransactionMeta.bind(null, this),
            saveTransactionMeta: saveTransactionMeta.bind(null, this),
            clearTransactionMeta: clearTransactionMeta.bind(null, this),
            isTransactionMetaValid: isTransactionMetaValid,
            setFlow: (flow) => {
                this.options.flow = flow;
            },
            getFlow: () => {
                return this.options.flow;
            },
            canProceed: canProceed.bind(null, this),
            unlockAccount: unlockAccount.bind(null, this),
        };
        this.http = {
            setRequestHeader: setRequestHeader.bind(null, this)
        };
        this.fingerprint = fingerprint.bind(null, this);
        this.emitter = new tiny_emitter();
        this.tokenManager = new TokenManager(this, args.tokenManager);
        this.authStateManager = new AuthStateManager(this);
        this.serviceManager = new ServiceManager(this, args.services);
    }
    async start() {
        await this.serviceManager.start();
        this.tokenManager.start();
        if (!this.token.isLoginRedirect()) {
            await this.authStateManager.updateAuthState();
        }
    }
    async stop() {
        this.tokenManager.stop();
        await this.serviceManager.stop();
    }
    setHeaders(headers) {
        this.options.headers = Object.assign({}, this.options.headers, headers);
    }
    async signIn(opts) {
        return this.signInWithCredentials(opts);
    }
    async signInWithCredentials(opts) {
        opts = clone(opts || {});
        const _postToTransaction = (options) => {
            delete opts.sendFingerprint;
            return postToTransaction(this, '/api/v1/authn', opts, options);
        };
        if (!opts.sendFingerprint) {
            return _postToTransaction();
        }
        return this.fingerprint()
            .then(function (fingerprint) {
            return _postToTransaction({
                headers: {
                    'X-Device-Fingerprint': fingerprint
                }
            });
        });
    }
    async signInWithRedirect(opts = {}) {
        const { originalUri } = opts, additionalParams = __rest(opts, ["originalUri"]);
        if (this._pending.handleLogin) {
            return;
        }
        this._pending.handleLogin = true;
        try {
            if (originalUri) {
                this.setOriginalUri(originalUri);
            }
            const params = Object.assign({
                scopes: this.options.scopes || ['openid', 'email', 'profile']
            }, additionalParams);
            await this.token.getWithRedirect(params);
        }
        finally {
            this._pending.handleLogin = false;
        }
    }
    closeSession() {
        return this.session.close()
            .then(async () => {
            this.tokenManager.clear();
        })
            .catch(function (e) {
            if (e.name === 'AuthApiError' && e.errorCode === 'E0000007') {
                return null;
            }
            throw e;
        });
    }
    async revokeAccessToken(accessToken) {
        if (!accessToken) {
            accessToken = (await this.tokenManager.getTokens()).accessToken;
            const accessTokenKey = this.tokenManager.getStorageKeyByType('accessToken');
            this.tokenManager.remove(accessTokenKey);
        }
        if (!accessToken) {
            return Promise.resolve(null);
        }
        return this.token.revoke(accessToken);
    }
    async revokeRefreshToken(refreshToken) {
        if (!refreshToken) {
            refreshToken = (await this.tokenManager.getTokens()).refreshToken;
            const refreshTokenKey = this.tokenManager.getStorageKeyByType('refreshToken');
            this.tokenManager.remove(refreshTokenKey);
        }
        if (!refreshToken) {
            return Promise.resolve(null);
        }
        return this.token.revoke(refreshToken);
    }
    getSignOutRedirectUrl(options = {}) {
        let { idToken, postLogoutRedirectUri, state, } = options;
        if (!idToken) {
            idToken = this.tokenManager.getTokensSync().idToken;
        }
        if (!idToken) {
            return '';
        }
        if (!postLogoutRedirectUri) {
            postLogoutRedirectUri = this.options.postLogoutRedirectUri;
        }
        const logoutUrl = getOAuthUrls(this).logoutUrl;
        const idTokenHint = idToken.idToken;
        let logoutUri = logoutUrl + '?id_token_hint=' + encodeURIComponent(idTokenHint);
        if (postLogoutRedirectUri) {
            logoutUri += '&post_logout_redirect_uri=' + encodeURIComponent(postLogoutRedirectUri);
        }
        if (state) {
            logoutUri += '&state=' + encodeURIComponent(state);
        }
        return logoutUri;
    }
    async signOut(options) {
        options = Object.assign({}, options);
        var defaultUri = window.location.origin;
        var currentUri = window.location.href;
        var postLogoutRedirectUri = options.postLogoutRedirectUri
            || this.options.postLogoutRedirectUri
            || defaultUri;
        var accessToken = options.accessToken;
        var refreshToken = options.refreshToken;
        var revokeAccessToken = options.revokeAccessToken !== false;
        var revokeRefreshToken = options.revokeRefreshToken !== false;
        if (revokeRefreshToken && typeof refreshToken === 'undefined') {
            refreshToken = this.tokenManager.getTokensSync().refreshToken;
        }
        if (revokeAccessToken && typeof accessToken === 'undefined') {
            accessToken = this.tokenManager.getTokensSync().accessToken;
        }
        if (!options.idToken) {
            options.idToken = this.tokenManager.getTokensSync().idToken;
        }
        if (revokeRefreshToken && refreshToken) {
            await this.revokeRefreshToken(refreshToken);
        }
        if (revokeAccessToken && accessToken) {
            await this.revokeAccessToken(accessToken);
        }
        const logoutUri = this.getSignOutRedirectUrl(Object.assign(Object.assign({}, options), { postLogoutRedirectUri }));
        if (!logoutUri) {
            return this.closeSession()
                .then(function () {
                if (postLogoutRedirectUri === currentUri) {
                    window.location.reload();
                }
                else {
                    window.location.assign(postLogoutRedirectUri);
                }
            });
        }
        else {
            if (options.clearTokensBeforeRedirect) {
                this.tokenManager.clear();
            }
            else {
                this.tokenManager.addPendingRemoveFlags();
            }
            window.location.assign(logoutUri);
        }
    }
    webfinger(opts) {
        var url = '/.well-known/webfinger' + toQueryString(opts);
        var options = {
            headers: {
                'Accept': 'application/jrd+json'
            }
        };
        return get(this, url, options);
    }
    async isAuthenticated(options = {}) {
        const { autoRenew, autoRemove } = this.tokenManager.getOptions();
        const shouldRenew = options.onExpiredToken ? options.onExpiredToken === 'renew' : autoRenew;
        const shouldRemove = options.onExpiredToken ? options.onExpiredToken === 'remove' : autoRemove;
        let { accessToken } = this.tokenManager.getTokensSync();
        if (accessToken && this.tokenManager.hasExpired(accessToken)) {
            accessToken = undefined;
            if (shouldRenew) {
                try {
                    accessToken = await this.tokenManager.renew('accessToken');
                }
                catch (_a) {
                }
            }
            else if (shouldRemove) {
                this.tokenManager.remove('accessToken');
            }
        }
        let { idToken } = this.tokenManager.getTokensSync();
        if (idToken && this.tokenManager.hasExpired(idToken)) {
            idToken = undefined;
            if (shouldRenew) {
                try {
                    idToken = await this.tokenManager.renew('idToken');
                }
                catch (_b) {
                }
            }
            else if (shouldRemove) {
                this.tokenManager.remove('idToken');
            }
        }
        return !!(accessToken && idToken);
    }
    async getUser() {
        const { idToken, accessToken } = this.tokenManager.getTokensSync();
        return this.token.getUserInfo(accessToken, idToken);
    }
    getIdToken() {
        const { idToken } = this.tokenManager.getTokensSync();
        return idToken ? idToken.idToken : undefined;
    }
    getAccessToken() {
        const { accessToken } = this.tokenManager.getTokensSync();
        return accessToken ? accessToken.accessToken : undefined;
    }
    getRefreshToken() {
        const { refreshToken } = this.tokenManager.getTokensSync();
        return refreshToken ? refreshToken.refreshToken : undefined;
    }
    async storeTokensFromRedirect() {
        const { tokens } = await this.token.parseFromUrl();
        this.tokenManager.setTokens(tokens);
    }
    setOriginalUri(originalUri, state) {
        const sessionStorage = storageUtil.getSessionStorage();
        sessionStorage.setItem(REFERRER_PATH_STORAGE_KEY, originalUri);
        state = state || this.options.state;
        if (state) {
            const sharedStorage = this.storageManager.getOriginalUriStorage();
            sharedStorage.setItem(state, originalUri);
        }
    }
    getOriginalUri(state) {
        state = state || this.options.state;
        if (state) {
            const sharedStorage = this.storageManager.getOriginalUriStorage();
            const originalUri = sharedStorage.getItem(state);
            if (originalUri) {
                return originalUri;
            }
        }
        const storage = storageUtil.getSessionStorage();
        return storage ? storage.getItem(REFERRER_PATH_STORAGE_KEY) || undefined : undefined;
    }
    removeOriginalUri(state) {
        const storage = storageUtil.getSessionStorage();
        storage.removeItem(REFERRER_PATH_STORAGE_KEY);
        state = state || this.options.state;
        if (state) {
            const sharedStorage = this.storageManager.getOriginalUriStorage();
            sharedStorage.removeItem && sharedStorage.removeItem(state);
        }
    }
    isLoginRedirect() {
        return isLoginRedirect(this);
    }
    async handleLoginRedirect(tokens, originalUri) {
        let state = this.options.state;
        if (tokens) {
            this.tokenManager.setTokens(tokens);
            originalUri = originalUri || this.getOriginalUri(this.options.state);
        }
        else if (this.isLoginRedirect()) {
            try {
                const oAuthResponse = await parseOAuthResponseFromUrl(this, {});
                state = oAuthResponse.state;
                originalUri = originalUri || this.getOriginalUri(state);
                await this.storeTokensFromRedirect();
            }
            catch (e) {
                await this.authStateManager.updateAuthState();
                throw e;
            }
        }
        else {
            return;
        }
        await this.authStateManager.updateAuthState();
        this.removeOriginalUri(state);
        const { restoreOriginalUri } = this.options;
        if (restoreOriginalUri) {
            await restoreOriginalUri(this, originalUri);
        }
        else if (originalUri) {
            window.location.replace(originalUri);
        }
    }
    isPKCE() {
        return !!this.options.pkce;
    }
    hasResponseType(responseType) {
        let hasResponseType = false;
        if (Array.isArray(this.options.responseType) && this.options.responseType.length) {
            hasResponseType = this.options.responseType.indexOf(responseType) >= 0;
        }
        else {
            hasResponseType = this.options.responseType === responseType;
        }
        return hasResponseType;
    }
    isAuthorizationCodeFlow() {
        return this.hasResponseType('code');
    }
    getIssuerOrigin() {
        return this.options.issuer.split('/oauth2/')[0];
    }
    forgotPassword(opts) {
        return postToTransaction(this, '/api/v1/authn/recovery/password', opts);
    }
    unlockAccount(opts) {
        return postToTransaction(this, '/api/v1/authn/recovery/unlock', opts);
    }
    verifyRecoveryToken(opts) {
        return postToTransaction(this, '/api/v1/authn/recovery/token', opts);
    }
    async invokeApiMethod(options) {
        if (!options.accessToken) {
            const accessToken = (await this.tokenManager.getTokens()).accessToken;
            options.accessToken = accessToken === null || accessToken === void 0 ? void 0 : accessToken.accessToken;
        }
        return request_httpRequest(this, options);
    }
}
OktaAuth.features = features_namespaceObject;
OktaAuth.crypto = crypto_namespaceObject;
OktaAuth.webauthn = webauthn_namespaceObject;
OktaAuth.features = OktaAuth.prototype.features = features_namespaceObject;
Object.assign(OktaAuth, {
    constants: constants_namespaceObject
});


//# sourceMappingURL=OktaAuth.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/myaccount/transactions/EmailTransaction.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */




class EmailTransaction_EmailTransaction extends (/* unused pure expression or super */ null && (BaseTransaction)) {
    constructor(oktaAuth, options) {
        super(oktaAuth, options);
        const { accessToken, res } = options;
        const { id, profile, roles, status, _links } = res;
        this.id = id;
        this.profile = profile;
        this.roles = roles;
        this.status = status;
        this.get = async () => {
            const fn = generateRequestFnFromLinks({
                oktaAuth,
                accessToken,
                methodName: 'get',
                links: _links,
                transactionClassName: 'EmailTransaction'
            });
            return await fn();
        };
        this.delete = async () => {
            const fn = generateRequestFnFromLinks({
                oktaAuth,
                accessToken,
                methodName: 'delete',
                links: _links
            });
            return await fn();
        };
        this.challenge = async () => {
            const fn = generateRequestFnFromLinks({
                oktaAuth,
                accessToken,
                methodName: 'challenge',
                links: _links,
                transactionClassName: 'EmailChallengeTransaction'
            });
            return await fn();
        };
        if (_links.poll) {
            this.poll = async () => {
                const fn = generateRequestFnFromLinks({
                    oktaAuth,
                    accessToken,
                    methodName: 'poll',
                    links: _links,
                    transactionClassName: 'EmailStatusTransaction'
                });
                return await fn();
            };
        }
        if (_links.verify) {
            this.verify = async (payload) => {
                const fn = generateRequestFnFromLinks({
                    oktaAuth,
                    accessToken,
                    methodName: 'verify',
                    links: _links,
                });
                return await fn(payload);
            };
        }
    }
}


//# sourceMappingURL=EmailTransaction.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/myaccount/transactions/EmailChallengeTransaction.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */




class EmailChallengeTransaction_EmailChallengeTransaction extends (/* unused pure expression or super */ null && (BaseTransaction)) {
    constructor(oktaAuth, options) {
        super(oktaAuth, options);
        const { accessToken, res } = options;
        const { id, expiresAt, profile, status, _links } = res;
        this.id = id;
        this.expiresAt = expiresAt;
        this.profile = profile;
        this.status = status;
        this.poll = async () => {
            const fn = generateRequestFnFromLinks({
                oktaAuth,
                accessToken,
                methodName: 'poll',
                links: _links,
                transactionClassName: 'EmailStatusTransaction'
            });
            return await fn();
        };
        this.verify = async (payload) => {
            const fn = generateRequestFnFromLinks({
                oktaAuth,
                accessToken,
                methodName: 'verify',
                links: _links,
            });
            return await fn(payload);
        };
    }
}


//# sourceMappingURL=EmailChallengeTransaction.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/myaccount/transactions/PhoneTransaction.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */




class PhoneTransaction_PhoneTransaction extends (/* unused pure expression or super */ null && (BaseTransaction)) {
    constructor(oktaAuth, options) {
        super(oktaAuth, options);
        const { res, accessToken } = options;
        const { id, profile, status, _links } = res;
        this.id = id;
        this.profile = profile;
        this.status = status;
        this.get = async () => {
            const fn = generateRequestFnFromLinks({
                oktaAuth,
                accessToken,
                methodName: 'get',
                links: _links,
                transactionClassName: 'PhoneTransaction'
            });
            return await fn();
        };
        this.delete = async () => {
            const fn = generateRequestFnFromLinks({
                oktaAuth,
                accessToken,
                methodName: 'delete',
                links: _links
            });
            return await fn();
        };
        this.challenge = async (payload) => {
            const fn = generateRequestFnFromLinks({
                oktaAuth,
                accessToken,
                methodName: 'challenge',
                links: _links
            });
            return await fn(payload);
        };
        if (_links.verify) {
            this.verify = async (payload) => {
                const fn = generateRequestFnFromLinks({
                    oktaAuth,
                    accessToken,
                    methodName: 'verify',
                    links: _links
                });
                return await fn(payload);
            };
        }
    }
}


//# sourceMappingURL=PhoneTransaction.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/myaccount/request.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */












const parseInsufficientAuthenticationError = (header) => {
    if (!header) {
        throw new AuthSdkError('Missing header string');
    }
    return header
        .split(',')
        .map(part => part.trim())
        .map(part => part.split('='))
        .reduce((acc, curr) => {
        acc[curr[0]] = curr[1].replace(/^"(.*)"$/, '$1');
        return acc;
    }, {});
};
async function request_sendRequest(oktaAuth, options) {
    var _a, _b;
    const { accessToken: accessTokenObj, idToken: idTokenObj } = oktaAuth.tokenManager.getTokensSync();
    const idToken = idTokenObj === null || idTokenObj === void 0 ? void 0 : idTokenObj.idToken;
    const accessToken = options.accessToken || (accessTokenObj === null || accessTokenObj === void 0 ? void 0 : accessTokenObj.accessToken);
    const { issuer } = oktaAuth.options;
    const { url, method, payload } = options;
    const requestUrl = url.startsWith(issuer) ? url : `${issuer}${url}`;
    if (!accessToken) {
        throw new AuthSdkError('AccessToken is required to request MyAccount API endpoints.');
    }
    let res;
    try {
        res = await httpRequest(oktaAuth, Object.assign({ headers: { 'Accept': '*/*;okta-version=1.0.0' }, accessToken, url: requestUrl, method }, (payload && { args: payload })));
    }
    catch (err) {
        const errorResp = err.xhr;
        if (idToken && (errorResp === null || errorResp === void 0 ? void 0 : errorResp.status) === 403 && !!((_a = errorResp === null || errorResp === void 0 ? void 0 : errorResp.headers) === null || _a === void 0 ? void 0 : _a['www-authenticate'])) {
            const { error,
            error_description,
            max_age } = parseInsufficientAuthenticationError((_b = errorResp === null || errorResp === void 0 ? void 0 : errorResp.headers) === null || _b === void 0 ? void 0 : _b['www-authenticate']);
            if (error === 'insufficient_authentication_context') {
                const insufficientAuthenticationError = new AuthApiError({
                    errorSummary: error,
                    errorCauses: [{ errorSummary: error_description }]
                }, errorResp,
                { max_age: +max_age });
                throw insufficientAuthenticationError;
            }
            else {
                throw err;
            }
        }
        else {
            throw err;
        }
    }
    const map = {
        EmailTransaction,
        EmailStatusTransaction,
        EmailChallengeTransaction,
        ProfileTransaction,
        ProfileSchemaTransaction,
        PhoneTransaction
    };
    const TransactionClass = map[options.transactionClassName] || BaseTransaction;
    if (Array.isArray(res)) {
        return res.map(item => new TransactionClass(oktaAuth, {
            res: item,
            accessToken
        }));
    }
    return new TransactionClass(oktaAuth, {
        res,
        accessToken
    });
}
function request_generateRequestFnFromLinks({ oktaAuth, accessToken, methodName, links, transactionClassName }) {
    for (const method of ['GET', 'POST', 'PUT', 'DELETE']) {
        if (method.toLowerCase() === methodName) {
            const link = links.self;
            return (async (payload) => request_sendRequest(oktaAuth, {
                accessToken,
                url: link.href,
                method,
                payload,
                transactionClassName
            }));
        }
    }
    const link = links[methodName];
    if (!link) {
        throw new AuthSdkError(`No link is found with methodName: ${methodName}`);
    }
    return (async (payload) => request_sendRequest(oktaAuth, {
        accessToken,
        url: link.href,
        method: link.hints.allow[0],
        payload,
        transactionClassName
    }));
}


//# sourceMappingURL=request.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/myaccount/profileApi.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



const getProfile = async (oktaAuth, options) => {
    const transaction = await sendRequest(oktaAuth, {
        url: '/idp/myaccount/profile',
        method: 'GET',
        accessToken: options === null || options === void 0 ? void 0 : options.accessToken,
        transactionClassName: 'ProfileTransaction'
    });
    return transaction;
};
const updateProfile = async (oktaAuth, options) => {
    const { payload, accessToken } = options;
    const transaction = await sendRequest(oktaAuth, {
        url: '/idp/myaccount/profile',
        method: 'PUT',
        payload,
        accessToken,
        transactionClassName: 'ProfileTransaction'
    });
    return transaction;
};
const getProfileSchema = async (oktaAuth, options) => {
    const transaction = await sendRequest(oktaAuth, {
        url: '/idp/myaccount/profile/schema',
        method: 'GET',
        accessToken: options === null || options === void 0 ? void 0 : options.accessToken,
        transactionClassName: 'ProfileSchemaTransaction'
    });
    return transaction;
};


//# sourceMappingURL=profileApi.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/myaccount/emailApi.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



const getEmails = async (oktaAuth, options) => {
    const transaction = await sendRequest(oktaAuth, {
        url: '/idp/myaccount/emails',
        method: 'GET',
        accessToken: options === null || options === void 0 ? void 0 : options.accessToken,
        transactionClassName: 'EmailTransaction'
    });
    return transaction;
};
const getEmail = async (oktaAuth, options) => {
    const { id, accessToken } = options;
    const transaction = await sendRequest(oktaAuth, {
        url: `/idp/myaccount/emails/${id}`,
        method: 'GET',
        accessToken,
        transactionClassName: 'EmailTransaction'
    });
    return transaction;
};
const addEmail = async (oktaAuth, options) => {
    const { accessToken, payload } = options;
    const transaction = await sendRequest(oktaAuth, {
        url: '/idp/myaccount/emails',
        method: 'POST',
        payload,
        accessToken,
        transactionClassName: 'EmailTransaction'
    });
    return transaction;
};
const deleteEmail = async (oktaAuth, options) => {
    const { id, accessToken } = options;
    const transaction = await sendRequest(oktaAuth, {
        url: `/idp/myaccount/emails/${id}`,
        method: 'DELETE',
        accessToken
    });
    return transaction;
};
const sendEmailChallenge = async (oktaAuth, options) => {
    const { id, accessToken } = options;
    const transaction = await sendRequest(oktaAuth, {
        url: `/idp/myaccount/emails/${id}/challenge`,
        method: 'POST',
        accessToken,
        transactionClassName: 'EmailChallengeTransaction'
    });
    return transaction;
};
const getEmailChallenge = async (oktaAuth, options) => {
    const { emailId, challengeId, accessToken } = options;
    const transaction = await sendRequest(oktaAuth, {
        url: `/idp/myaccount/emails/${emailId}/challenge/${challengeId}`,
        method: 'POST',
        accessToken,
        transactionClassName: 'EmailChallengeTransaction'
    });
    return transaction;
};
const verifyEmailChallenge = async (oktaAuth, options) => {
    const { emailId, challengeId, payload, accessToken } = options;
    const transaction = await sendRequest(oktaAuth, {
        url: `/idp/myaccount/emails/${emailId}/challenge/${challengeId}/verify`,
        method: 'POST',
        payload,
        accessToken
    });
    return transaction;
};


//# sourceMappingURL=emailApi.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/myaccount/phoneApi.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */



const getPhones = async (oktaAuth, options) => {
    const transaction = await sendRequest(oktaAuth, {
        url: '/idp/myaccount/phones',
        method: 'GET',
        accessToken: options === null || options === void 0 ? void 0 : options.accessToken,
        transactionClassName: 'PhoneTransaction'
    });
    return transaction;
};
const getPhone = async (oktaAuth, options) => {
    const { accessToken, id } = options;
    const transaction = await sendRequest(oktaAuth, {
        url: `/idp/myaccount/phones/${id}`,
        method: 'GET',
        accessToken,
        transactionClassName: 'PhoneTransaction'
    });
    return transaction;
};
const addPhone = async (oktaAuth, options) => {
    const { accessToken, payload } = options;
    const transaction = await sendRequest(oktaAuth, {
        url: '/idp/myaccount/phones',
        method: 'POST',
        payload,
        accessToken,
        transactionClassName: 'PhoneTransaction'
    });
    return transaction;
};
const deletePhone = async (oktaAuth, options) => {
    const { id, accessToken } = options;
    const transaction = await sendRequest(oktaAuth, {
        url: `/idp/myaccount/phones/${id}`,
        method: 'DELETE',
        accessToken,
    });
    return transaction;
};
const sendPhoneChallenge = async (oktaAuth, options) => {
    const { accessToken, id, payload } = options;
    const transaction = await sendRequest(oktaAuth, {
        url: `/idp/myaccount/phones/${id}/challenge`,
        method: 'POST',
        payload,
        accessToken
    });
    return transaction;
};
const verifyPhoneChallenge = async (oktaAuth, options) => {
    const { id, payload, accessToken } = options;
    const transaction = await sendRequest(oktaAuth, {
        url: `/idp/myaccount/phones/${id}/verify`,
        method: 'POST',
        payload,
        accessToken
    });
    return transaction;
};


//# sourceMappingURL=phoneApi.js.map

;// CONCATENATED MODULE: ./node_modules/@okta/okta-auth-js/esm/browser/index.js
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */
















































































//# sourceMappingURL=index.js.map


/***/ }),

/***/ 90512:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ clsx; }
/* harmony export */ });
function r(e){var t,f,n="";if("string"==typeof e||"number"==typeof e)n+=e;else if("object"==typeof e)if(Array.isArray(e)){var o=e.length;for(t=0;t<o;t++)e[t]&&(f=r(e[t]))&&(n&&(n+=" "),n+=f)}else for(f in e)e[f]&&(n&&(n+=" "),n+=f);return n}function clsx(){for(var e,t,f=0,n="",o=arguments.length;f<o;f++)(e=arguments[f])&&(t=r(e))&&(n&&(n+=" "),n+=t);return n}/* harmony default export */ __webpack_exports__["Z"] = (clsx);

/***/ }),

/***/ 25935:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "du": function() { return /* binding */ domToReact; }
/* harmony export */ });
/* unused harmony exports htmlToDOM, attributesToProps, Comment, Element, ProcessingInstruction, Text */
/* harmony import */ var _index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30488);


var domToReact = _index_js__WEBPACK_IMPORTED_MODULE_0__.domToReact;
var htmlToDOM = _index_js__WEBPACK_IMPORTED_MODULE_0__.htmlToDOM;
var attributesToProps = _index_js__WEBPACK_IMPORTED_MODULE_0__.attributesToProps;

// domhandler
var Comment = _index_js__WEBPACK_IMPORTED_MODULE_0__.Comment;
var Element = _index_js__WEBPACK_IMPORTED_MODULE_0__.Element;
var ProcessingInstruction = _index_js__WEBPACK_IMPORTED_MODULE_0__.ProcessingInstruction;
var Text = _index_js__WEBPACK_IMPORTED_MODULE_0__.Text;

/* harmony default export */ __webpack_exports__["ZP"] = (_index_js__WEBPACK_IMPORTED_MODULE_0__);


/***/ }),

/***/ 67421:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$G": function() { return /* reexport */ useTranslation_useTranslation; },
  "Zh": function() { return /* reexport */ withTranslation; }
});

// UNUSED EXPORTS: I18nContext, I18nextProvider, Trans, TransWithoutContext, Translation, composeInitialProps, date, getDefaults, getI18n, getInitialProps, initReactI18next, number, plural, select, selectOrdinal, setDefaults, setI18n, time, useSSR, withSSR

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/void-elements/index.js
var void_elements = __webpack_require__(71739);
var void_elements_default = /*#__PURE__*/__webpack_require__.n(void_elements);
;// CONCATENATED MODULE: ./node_modules/html-parse-stringify/dist/html-parse-stringify.module.js
var t=/\s([^'"/\s><]+?)[\s/>]|([^\s=]+)=\s?(".*?"|'.*?')/g;function n(n){var r={type:"tag",name:"",voidElement:!1,attrs:{},children:[]},i=n.match(/<\/?([^\s]+?)[/\s>]/);if(i&&(r.name=i[1],((void_elements_default())[i[1]]||"/"===n.charAt(n.length-2))&&(r.voidElement=!0),r.name.startsWith("!--"))){var s=n.indexOf("--\x3e");return{type:"comment",comment:-1!==s?n.slice(4,s):""}}for(var a=new RegExp(t),c=null;null!==(c=a.exec(n));)if(c[0].trim())if(c[1]){var o=c[1].trim(),l=[o,""];o.indexOf("=")>-1&&(l=o.split("=")),r.attrs[l[0]]=l[1],a.lastIndex--}else c[2]&&(r.attrs[c[2]]=c[3].trim().substring(1,c[3].length-1));return r}var r=/<[a-zA-Z0-9\-\!\/](?:"[^"]*"|'[^']*'|[^'">])*>/g,i=/^\s*$/,s=Object.create(null);function a(e,t){switch(t.type){case"text":return e+t.content;case"tag":return e+="<"+t.name+(t.attrs?function(e){var t=[];for(var n in e)t.push(n+'="'+e[n]+'"');return t.length?" "+t.join(" "):""}(t.attrs):"")+(t.voidElement?"/>":">"),t.voidElement?e:e+t.children.reduce(a,"")+"</"+t.name+">";case"comment":return e+"\x3c!--"+t.comment+"--\x3e"}}var c={parse:function(e,t){t||(t={}),t.components||(t.components=s);var a,c=[],o=[],l=-1,m=!1;if(0!==e.indexOf("<")){var u=e.indexOf("<");c.push({type:"text",content:-1===u?e:e.substring(0,u)})}return e.replace(r,function(r,s){if(m){if(r!=="</"+a.name+">")return;m=!1}var u,f="/"!==r.charAt(1),h=r.startsWith("\x3c!--"),p=s+r.length,d=e.charAt(p);if(h){var v=n(r);return l<0?(c.push(v),c):((u=o[l]).children.push(v),c)}if(f&&(l++,"tag"===(a=n(r)).type&&t.components[a.name]&&(a.type="component",m=!0),a.voidElement||m||!d||"<"===d||a.children.push({type:"text",content:e.slice(p,e.indexOf("<",p))}),0===l&&c.push(a),(u=o[l-1])&&u.children.push(a),o[l]=a),(!f||a.voidElement)&&(l>-1&&(a.voidElement||a.name===r.slice(2,-1))&&(l--,a=-1===l?c:o[l]),!m&&"<"!==d&&d)){u=-1===l?c:o[l].children;var x=e.indexOf("<",p),g=e.slice(p,-1===x?void 0:x);i.test(g)&&(g=" "),(x>-1&&l+u.length>=0||" "!==g)&&u.push({type:"text",content:g})}}),c},stringify:function(e){return e.reduce(function(e,t){return e+a("",t)},"")}};/* harmony default export */ var html_parse_stringify_module = ((/* unused pure expression or super */ null && (c)));
//# sourceMappingURL=html-parse-stringify.module.js.map

;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/utils.js
function utils_warn() {
  if (console && console.warn) {
    var _console;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (typeof args[0] === 'string') args[0] = "react-i18next:: ".concat(args[0]);

    (_console = console).warn.apply(_console, args);
  }
}
var alreadyWarned = {};
function utils_warnOnce() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  if (typeof args[0] === 'string' && alreadyWarned[args[0]]) return;
  if (typeof args[0] === 'string') alreadyWarned[args[0]] = new Date();
  utils_warn.apply(void 0, args);
}

var loadedClb = function loadedClb(i18n, cb) {
  return function () {
    if (i18n.isInitialized) {
      cb();
    } else {
      var initialized = function initialized() {
        setTimeout(function () {
          i18n.off('initialized', initialized);
        }, 0);
        cb();
      };

      i18n.on('initialized', initialized);
    }
  };
};

function loadNamespaces(i18n, ns, cb) {
  i18n.loadNamespaces(ns, loadedClb(i18n, cb));
}
function loadLanguages(i18n, lng, ns, cb) {
  if (typeof ns === 'string') ns = [ns];
  ns.forEach(function (n) {
    if (i18n.options.ns.indexOf(n) < 0) i18n.options.ns.push(n);
  });
  i18n.loadLanguages(lng, loadedClb(i18n, cb));
}

function oldI18nextHasLoadedNamespace(ns, i18n) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var lng = i18n.languages[0];
  var fallbackLng = i18n.options ? i18n.options.fallbackLng : false;
  var lastLng = i18n.languages[i18n.languages.length - 1];
  if (lng.toLowerCase() === 'cimode') return true;

  var loadNotPending = function loadNotPending(l, n) {
    var loadState = i18n.services.backendConnector.state["".concat(l, "|").concat(n)];
    return loadState === -1 || loadState === 2;
  };

  if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18n.services.backendConnector.backend && i18n.isLanguageChangingTo && !loadNotPending(i18n.isLanguageChangingTo, ns)) return false;
  if (i18n.hasResourceBundle(lng, ns)) return true;
  if (!i18n.services.backendConnector.backend || i18n.options.resources && !i18n.options.partialBundledLanguages) return true;
  if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
  return false;
}

function hasLoadedNamespace(ns, i18n) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (!i18n.languages || !i18n.languages.length) {
    utils_warnOnce('i18n.languages were undefined or empty', i18n.languages);
    return true;
  }

  var isNewerI18next = i18n.options.ignoreJSONStructure !== undefined;

  if (!isNewerI18next) {
    return oldI18nextHasLoadedNamespace(ns, i18n, options);
  }

  return i18n.hasLoadedNamespace(ns, {
    lng: options.lng,
    precheck: function precheck(i18nInstance, loadNotPending) {
      if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18nInstance.services.backendConnector.backend && i18nInstance.isLanguageChangingTo && !loadNotPending(i18nInstance.isLanguageChangingTo, ns)) return false;
    }
  });
}
function utils_getDisplayName(Component) {
  return Component.displayName || Component.name || (typeof Component === 'string' && Component.length > 0 ? Component : 'Unknown');
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(4942);
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/unescape.js
var matchHtmlEntity = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g;
var htmlEntities = {
  '&amp;': '&',
  '&#38;': '&',
  '&lt;': '<',
  '&#60;': '<',
  '&gt;': '>',
  '&#62;': '>',
  '&apos;': "'",
  '&#39;': "'",
  '&quot;': '"',
  '&#34;': '"',
  '&nbsp;': ' ',
  '&#160;': ' ',
  '&copy;': '©',
  '&#169;': '©',
  '&reg;': '®',
  '&#174;': '®',
  '&hellip;': '…',
  '&#8230;': '…',
  '&#x2F;': '/',
  '&#47;': '/'
};

var unescapeHtmlEntity = function unescapeHtmlEntity(m) {
  return htmlEntities[m];
};

var unescape_unescape = function unescape(text) {
  return text.replace(matchHtmlEntity, unescapeHtmlEntity);
};
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/defaults.js


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }


var defaultOptions = {
  bindI18n: 'languageChanged',
  bindI18nStore: '',
  transEmptyNodeValue: '',
  transSupportBasicHtmlNodes: true,
  transWrapTextNodes: '',
  transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p'],
  useSuspense: true,
  unescape: unescape_unescape
};
function setDefaults() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  defaultOptions = _objectSpread(_objectSpread({}, defaultOptions), options);
}
function defaults_getDefaults() {
  return defaultOptions;
}
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/TransWithoutContext.js



var _excluded = (/* unused pure expression or super */ null && (["format"])),
    _excluded2 = (/* unused pure expression or super */ null && (["children", "count", "parent", "i18nKey", "context", "tOptions", "values", "defaults", "components", "ns", "i18n", "t", "shouldUnescape"]));

function TransWithoutContext_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function TransWithoutContext_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { TransWithoutContext_ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { TransWithoutContext_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







function hasChildren(node, checkLength) {
  if (!node) return false;
  var base = node.props ? node.props.children : node.children;
  if (checkLength) return base.length > 0;
  return !!base;
}

function getChildren(node) {
  if (!node) return [];
  return node.props ? node.props.children : node.children;
}

function hasValidReactChildren(children) {
  if (Object.prototype.toString.call(children) !== '[object Array]') return false;
  return children.every(function (child) {
    return isValidElement(child);
  });
}

function getAsArray(data) {
  return Array.isArray(data) ? data : [data];
}

function mergeProps(source, target) {
  var newTarget = TransWithoutContext_objectSpread({}, target);

  newTarget.props = Object.assign(source.props, target.props);
  return newTarget;
}

function nodesToString(children, i18nOptions) {
  if (!children) return '';
  var stringNode = '';
  var childrenArray = getAsArray(children);
  var keepArray = i18nOptions.transSupportBasicHtmlNodes && i18nOptions.transKeepBasicHtmlNodesFor ? i18nOptions.transKeepBasicHtmlNodesFor : [];
  childrenArray.forEach(function (child, childIndex) {
    if (typeof child === 'string') {
      stringNode += "".concat(child);
    } else if (isValidElement(child)) {
      var childPropsCount = Object.keys(child.props).length;
      var shouldKeepChild = keepArray.indexOf(child.type) > -1;
      var childChildren = child.props.children;

      if (!childChildren && shouldKeepChild && childPropsCount === 0) {
        stringNode += "<".concat(child.type, "/>");
      } else if (!childChildren && (!shouldKeepChild || childPropsCount !== 0)) {
        stringNode += "<".concat(childIndex, "></").concat(childIndex, ">");
      } else if (child.props.i18nIsDynamicList) {
        stringNode += "<".concat(childIndex, "></").concat(childIndex, ">");
      } else if (shouldKeepChild && childPropsCount === 1 && typeof childChildren === 'string') {
        stringNode += "<".concat(child.type, ">").concat(childChildren, "</").concat(child.type, ">");
      } else {
        var content = nodesToString(childChildren, i18nOptions);
        stringNode += "<".concat(childIndex, ">").concat(content, "</").concat(childIndex, ">");
      }
    } else if (child === null) {
      warn("Trans: the passed in value is invalid - seems you passed in a null child.");
    } else if (_typeof(child) === 'object') {
      var format = child.format,
          clone = _objectWithoutProperties(child, _excluded);

      var keys = Object.keys(clone);

      if (keys.length === 1) {
        var value = format ? "".concat(keys[0], ", ").concat(format) : keys[0];
        stringNode += "{{".concat(value, "}}");
      } else {
        warn("react-i18next: the passed in object contained more than one variable - the object should look like {{ value, format }} where format is optional.", child);
      }
    } else {
      warn("Trans: the passed in value is invalid - seems you passed in a variable like {number} - please pass in variables for interpolation as full objects like {{number}}.", child);
    }
  });
  return stringNode;
}

function renderNodes(children, targetString, i18n, i18nOptions, combinedTOpts, shouldUnescape) {
  if (targetString === '') return [];
  var keepArray = i18nOptions.transKeepBasicHtmlNodesFor || [];
  var emptyChildrenButNeedsHandling = targetString && new RegExp(keepArray.join('|')).test(targetString);
  if (!children && !emptyChildrenButNeedsHandling) return [targetString];
  var data = {};

  function getData(childs) {
    var childrenArray = getAsArray(childs);
    childrenArray.forEach(function (child) {
      if (typeof child === 'string') return;
      if (hasChildren(child)) getData(getChildren(child));else if (_typeof(child) === 'object' && !isValidElement(child)) Object.assign(data, child);
    });
  }

  getData(children);
  var ast = HTML.parse("<0>".concat(targetString, "</0>"));

  var opts = TransWithoutContext_objectSpread(TransWithoutContext_objectSpread({}, data), combinedTOpts);

  function renderInner(child, node, rootReactNode) {
    var childs = getChildren(child);
    var mappedChildren = mapAST(childs, node.children, rootReactNode);
    return hasValidReactChildren(childs) && mappedChildren.length === 0 ? childs : mappedChildren;
  }

  function pushTranslatedJSX(child, inner, mem, i, isVoid) {
    if (child.dummy) child.children = inner;
    mem.push(cloneElement(child, TransWithoutContext_objectSpread(TransWithoutContext_objectSpread({}, child.props), {}, {
      key: i
    }), isVoid ? undefined : inner));
  }

  function mapAST(reactNode, astNode, rootReactNode) {
    var reactNodes = getAsArray(reactNode);
    var astNodes = getAsArray(astNode);
    return astNodes.reduce(function (mem, node, i) {
      var translationContent = node.children && node.children[0] && node.children[0].content && i18n.services.interpolator.interpolate(node.children[0].content, opts, i18n.language);

      if (node.type === 'tag') {
        var tmp = reactNodes[parseInt(node.name, 10)];
        if (!tmp && rootReactNode.length === 1 && rootReactNode[0][node.name]) tmp = rootReactNode[0][node.name];
        if (!tmp) tmp = {};
        var child = Object.keys(node.attrs).length !== 0 ? mergeProps({
          props: node.attrs
        }, tmp) : tmp;
        var isElement = isValidElement(child);
        var isValidTranslationWithChildren = isElement && hasChildren(node, true) && !node.voidElement;
        var isEmptyTransWithHTML = emptyChildrenButNeedsHandling && _typeof(child) === 'object' && child.dummy && !isElement;
        var isKnownComponent = _typeof(children) === 'object' && children !== null && Object.hasOwnProperty.call(children, node.name);

        if (typeof child === 'string') {
          var value = i18n.services.interpolator.interpolate(child, opts, i18n.language);
          mem.push(value);
        } else if (hasChildren(child) || isValidTranslationWithChildren) {
            var inner = renderInner(child, node, rootReactNode);
            pushTranslatedJSX(child, inner, mem, i);
          } else if (isEmptyTransWithHTML) {
          var _inner = mapAST(reactNodes, node.children, rootReactNode);

          mem.push(cloneElement(child, TransWithoutContext_objectSpread(TransWithoutContext_objectSpread({}, child.props), {}, {
            key: i
          }), _inner));
        } else if (Number.isNaN(parseFloat(node.name))) {
          if (isKnownComponent) {
            var _inner2 = renderInner(child, node, rootReactNode);

            pushTranslatedJSX(child, _inner2, mem, i, node.voidElement);
          } else if (i18nOptions.transSupportBasicHtmlNodes && keepArray.indexOf(node.name) > -1) {
            if (node.voidElement) {
              mem.push(createElement(node.name, {
                key: "".concat(node.name, "-").concat(i)
              }));
            } else {
              var _inner3 = mapAST(reactNodes, node.children, rootReactNode);

              mem.push(createElement(node.name, {
                key: "".concat(node.name, "-").concat(i)
              }, _inner3));
            }
          } else if (node.voidElement) {
            mem.push("<".concat(node.name, " />"));
          } else {
            var _inner4 = mapAST(reactNodes, node.children, rootReactNode);

            mem.push("<".concat(node.name, ">").concat(_inner4, "</").concat(node.name, ">"));
          }
        } else if (_typeof(child) === 'object' && !isElement) {
          var content = node.children[0] ? translationContent : null;
          if (content) mem.push(content);
        } else if (node.children.length === 1 && translationContent) {
          mem.push(cloneElement(child, TransWithoutContext_objectSpread(TransWithoutContext_objectSpread({}, child.props), {}, {
            key: i
          }), translationContent));
        } else {
          mem.push(cloneElement(child, TransWithoutContext_objectSpread(TransWithoutContext_objectSpread({}, child.props), {}, {
            key: i
          })));
        }
      } else if (node.type === 'text') {
        var wrapTextNodes = i18nOptions.transWrapTextNodes;

        var _content = shouldUnescape ? i18nOptions.unescape(i18n.services.interpolator.interpolate(node.content, opts, i18n.language)) : i18n.services.interpolator.interpolate(node.content, opts, i18n.language);

        if (wrapTextNodes) {
          mem.push(createElement(wrapTextNodes, {
            key: "".concat(node.name, "-").concat(i)
          }, _content));
        } else {
          mem.push(_content);
        }
      }

      return mem;
    }, []);
  }

  var result = mapAST([{
    dummy: true,
    children: children || []
  }], ast, getAsArray(children || []));
  return getChildren(result[0]);
}

function Trans(_ref) {
  var children = _ref.children,
      count = _ref.count,
      parent = _ref.parent,
      i18nKey = _ref.i18nKey,
      context = _ref.context,
      _ref$tOptions = _ref.tOptions,
      tOptions = _ref$tOptions === void 0 ? {} : _ref$tOptions,
      values = _ref.values,
      defaults = _ref.defaults,
      components = _ref.components,
      ns = _ref.ns,
      i18nFromProps = _ref.i18n,
      tFromProps = _ref.t,
      shouldUnescape = _ref.shouldUnescape,
      additionalProps = _objectWithoutProperties(_ref, _excluded2);

  var i18n = i18nFromProps || getI18n();

  if (!i18n) {
    warnOnce('You will need to pass in an i18next instance by using i18nextReactModule');
    return children;
  }

  var t = tFromProps || i18n.t.bind(i18n) || function (k) {
    return k;
  };

  if (context) tOptions.context = context;

  var reactI18nextOptions = TransWithoutContext_objectSpread(TransWithoutContext_objectSpread({}, getDefaults()), i18n.options && i18n.options.react);

  var namespaces = ns || t.ns || i18n.options && i18n.options.defaultNS;
  namespaces = typeof namespaces === 'string' ? [namespaces] : namespaces || ['translation'];
  var defaultValue = defaults || nodesToString(children, reactI18nextOptions) || reactI18nextOptions.transEmptyNodeValue || i18nKey;
  var hashTransKey = reactI18nextOptions.hashTransKey;
  var key = i18nKey || (hashTransKey ? hashTransKey(defaultValue) : defaultValue);
  var interpolationOverride = values ? tOptions.interpolation : {
    interpolation: TransWithoutContext_objectSpread(TransWithoutContext_objectSpread({}, tOptions.interpolation), {}, {
      prefix: '#$?',
      suffix: '?$#'
    })
  };

  var combinedTOpts = TransWithoutContext_objectSpread(TransWithoutContext_objectSpread(TransWithoutContext_objectSpread(TransWithoutContext_objectSpread({}, tOptions), {}, {
    count: count
  }, values), interpolationOverride), {}, {
    defaultValue: defaultValue,
    ns: namespaces
  });

  var translation = key ? t(key, combinedTOpts) : defaultValue;
  var content = renderNodes(components || children, translation, i18n, reactI18nextOptions, combinedTOpts, shouldUnescape);
  var useAsParent = parent !== undefined ? parent : reactI18nextOptions.defaultTransParent;
  return useAsParent ? createElement(useAsParent, additionalProps, content) : content;
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(15671);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(43144);
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/i18nInstance.js
var i18nInstance;
function setI18n(instance) {
  i18nInstance = instance;
}
function i18nInstance_getI18n() {
  return i18nInstance;
}
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/initReactI18next.js


var initReactI18next = {
  type: '3rdParty',
  init: function init(instance) {
    setDefaults(instance.options.react);
    setI18n(instance);
  }
};
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/context.js




function context_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function context_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { context_ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { context_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






var context_I18nContext = (0,react.createContext)();
var ReportNamespaces = function () {
  function ReportNamespaces() {
    (0,classCallCheck/* default */.Z)(this, ReportNamespaces);

    this.usedNamespaces = {};
  }

  (0,createClass/* default */.Z)(ReportNamespaces, [{
    key: "addUsedNamespaces",
    value: function addUsedNamespaces(namespaces) {
      var _this = this;

      namespaces.forEach(function (ns) {
        if (!_this.usedNamespaces[ns]) _this.usedNamespaces[ns] = true;
      });
    }
  }, {
    key: "getUsedNamespaces",
    value: function getUsedNamespaces() {
      return Object.keys(this.usedNamespaces);
    }
  }]);

  return ReportNamespaces;
}();
function context_composeInitialProps(ForComponent) {
  return function (ctx) {
    return new Promise(function (resolve) {
      var i18nInitialProps = getInitialProps();

      if (ForComponent.getInitialProps) {
        ForComponent.getInitialProps(ctx).then(function (componentsInitialProps) {
          resolve(context_objectSpread(context_objectSpread({}, componentsInitialProps), i18nInitialProps));
        });
      } else {
        resolve(i18nInitialProps);
      }
    });
  };
}
function getInitialProps() {
  var i18n = getI18n();
  var namespaces = i18n.reportNamespaces ? i18n.reportNamespaces.getUsedNamespaces() : [];
  var ret = {};
  var initialI18nStore = {};
  i18n.languages.forEach(function (l) {
    initialI18nStore[l] = {};
    namespaces.forEach(function (ns) {
      initialI18nStore[l][ns] = i18n.getResourceBundle(l, ns) || {};
    });
  });
  ret.initialI18nStore = initialI18nStore;
  ret.initialLanguage = i18n.language;
  return ret;
}
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/Trans.js


var Trans_excluded = (/* unused pure expression or super */ null && (["children", "count", "parent", "i18nKey", "context", "tOptions", "values", "defaults", "components", "ns", "i18n", "t", "shouldUnescape"]));

function Trans_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function Trans_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Trans_ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Trans_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





function Trans_Trans(_ref) {
  var children = _ref.children,
      count = _ref.count,
      parent = _ref.parent,
      i18nKey = _ref.i18nKey,
      context = _ref.context,
      _ref$tOptions = _ref.tOptions,
      tOptions = _ref$tOptions === void 0 ? {} : _ref$tOptions,
      values = _ref.values,
      defaults = _ref.defaults,
      components = _ref.components,
      ns = _ref.ns,
      i18nFromProps = _ref.i18n,
      tFromProps = _ref.t,
      shouldUnescape = _ref.shouldUnescape,
      additionalProps = _objectWithoutProperties(_ref, Trans_excluded);

  var _ref2 = useContext(I18nContext) || {},
      i18nFromContext = _ref2.i18n,
      defaultNSFromContext = _ref2.defaultNS;

  var i18n = i18nFromProps || i18nFromContext || getI18n();
  var t = tFromProps || i18n && i18n.t.bind(i18n);
  return TransWithoutContext(Trans_objectSpread({
    children: children,
    count: count,
    parent: parent,
    i18nKey: i18nKey,
    context: context,
    tOptions: tOptions,
    values: values,
    defaults: defaults,
    components: components,
    ns: ns || t && t.ns || defaultNSFromContext || i18n && i18n.options && i18n.options.defaultNS,
    i18n: i18n,
    t: tFromProps,
    shouldUnescape: shouldUnescape
  }, additionalProps));
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(97685);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(71002);
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js




function useTranslation_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function useTranslation_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { useTranslation_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { useTranslation_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var usePrevious = function usePrevious(value, ignore) {
  var ref = (0,react.useRef)();
  (0,react.useEffect)(function () {
    ref.current = ignore ? ref.current : value;
  }, [value, ignore]);
  return ref.current;
};

function useTranslation_useTranslation(ns) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var i18nFromProps = props.i18n;

  var _ref = (0,react.useContext)(context_I18nContext) || {},
      i18nFromContext = _ref.i18n,
      defaultNSFromContext = _ref.defaultNS;

  var i18n = i18nFromProps || i18nFromContext || i18nInstance_getI18n();
  if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new ReportNamespaces();

  if (!i18n) {
    utils_warnOnce('You will need to pass in an i18next instance by using initReactI18next');

    var notReadyT = function notReadyT(k, optsOrDefaultValue) {
      if (typeof optsOrDefaultValue === 'string') return optsOrDefaultValue;
      if (optsOrDefaultValue && (0,esm_typeof/* default */.Z)(optsOrDefaultValue) === 'object' && typeof optsOrDefaultValue.defaultValue === 'string') return optsOrDefaultValue.defaultValue;
      return Array.isArray(k) ? k[k.length - 1] : k;
    };

    var retNotReady = [notReadyT, {}, false];
    retNotReady.t = notReadyT;
    retNotReady.i18n = {};
    retNotReady.ready = false;
    return retNotReady;
  }

  if (i18n.options.react && i18n.options.react.wait !== undefined) utils_warnOnce('It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.');

  var i18nOptions = useTranslation_objectSpread(useTranslation_objectSpread(useTranslation_objectSpread({}, defaults_getDefaults()), i18n.options.react), props);

  var useSuspense = i18nOptions.useSuspense,
      keyPrefix = i18nOptions.keyPrefix;
  var namespaces = ns || defaultNSFromContext || i18n.options && i18n.options.defaultNS;
  namespaces = typeof namespaces === 'string' ? [namespaces] : namespaces || ['translation'];
  if (i18n.reportNamespaces.addUsedNamespaces) i18n.reportNamespaces.addUsedNamespaces(namespaces);
  var ready = (i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every(function (n) {
    return hasLoadedNamespace(n, i18n, i18nOptions);
  });

  function getT() {
    return i18n.getFixedT(props.lng || null, i18nOptions.nsMode === 'fallback' ? namespaces : namespaces[0], keyPrefix);
  }

  var _useState = (0,react.useState)(getT),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      t = _useState2[0],
      setT = _useState2[1];

  var joinedNS = namespaces.join();
  if (props.lng) joinedNS = "".concat(props.lng).concat(joinedNS);
  var previousJoinedNS = usePrevious(joinedNS);
  var isMounted = (0,react.useRef)(true);
  (0,react.useEffect)(function () {
    var bindI18n = i18nOptions.bindI18n,
        bindI18nStore = i18nOptions.bindI18nStore;
    isMounted.current = true;

    if (!ready && !useSuspense) {
      if (props.lng) {
        loadLanguages(i18n, props.lng, namespaces, function () {
          if (isMounted.current) setT(getT);
        });
      } else {
        loadNamespaces(i18n, namespaces, function () {
          if (isMounted.current) setT(getT);
        });
      }
    }

    if (ready && previousJoinedNS && previousJoinedNS !== joinedNS && isMounted.current) {
      setT(getT);
    }

    function boundReset() {
      if (isMounted.current) setT(getT);
    }

    if (bindI18n && i18n) i18n.on(bindI18n, boundReset);
    if (bindI18nStore && i18n) i18n.store.on(bindI18nStore, boundReset);
    return function () {
      isMounted.current = false;
      if (bindI18n && i18n) bindI18n.split(' ').forEach(function (e) {
        return i18n.off(e, boundReset);
      });
      if (bindI18nStore && i18n) bindI18nStore.split(' ').forEach(function (e) {
        return i18n.store.off(e, boundReset);
      });
    };
  }, [i18n, joinedNS]);
  var isInitial = (0,react.useRef)(true);
  (0,react.useEffect)(function () {
    if (isMounted.current && !isInitial.current) {
      setT(getT);
    }

    isInitial.current = false;
  }, [i18n, keyPrefix]);
  var ret = [t, i18n, ready];
  ret.t = t;
  ret.i18n = i18n;
  ret.ready = ready;
  if (ready) return ret;
  if (!ready && !useSuspense) return ret;
  throw new Promise(function (resolve) {
    if (props.lng) {
      loadLanguages(i18n, props.lng, namespaces, function () {
        return resolve();
      });
    } else {
      loadNamespaces(i18n, namespaces, function () {
        return resolve();
      });
    }
  });
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(45987);
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/withTranslation.js



var withTranslation_excluded = ["forwardedRef"];

function withTranslation_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function withTranslation_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { withTranslation_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { withTranslation_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




function withTranslation(ns) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function Extend(WrappedComponent) {
    function I18nextWithTranslation(_ref) {
      var forwardedRef = _ref.forwardedRef,
          rest = (0,objectWithoutProperties/* default */.Z)(_ref, withTranslation_excluded);

      var _useTranslation = useTranslation_useTranslation(ns, withTranslation_objectSpread(withTranslation_objectSpread({}, rest), {}, {
        keyPrefix: options.keyPrefix
      })),
          _useTranslation2 = (0,slicedToArray/* default */.Z)(_useTranslation, 3),
          t = _useTranslation2[0],
          i18n = _useTranslation2[1],
          ready = _useTranslation2[2];

      var passDownProps = withTranslation_objectSpread(withTranslation_objectSpread({}, rest), {}, {
        t: t,
        i18n: i18n,
        tReady: ready
      });

      if (options.withRef && forwardedRef) {
        passDownProps.ref = forwardedRef;
      } else if (!options.withRef && forwardedRef) {
        passDownProps.forwardedRef = forwardedRef;
      }

      return (0,react.createElement)(WrappedComponent, passDownProps);
    }

    I18nextWithTranslation.displayName = "withI18nextTranslation(".concat(utils_getDisplayName(WrappedComponent), ")");
    I18nextWithTranslation.WrappedComponent = WrappedComponent;

    var forwardRef = function forwardRef(props, ref) {
      return (0,react.createElement)(I18nextWithTranslation, Object.assign({}, props, {
        forwardedRef: ref
      }));
    };

    return options.withRef ? (0,react.forwardRef)(forwardRef) : I18nextWithTranslation;
  };
}
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/Translation.js


var Translation_excluded = (/* unused pure expression or super */ null && (["ns", "children"]));

function Translation(props) {
  var ns = props.ns,
      children = props.children,
      options = _objectWithoutProperties(props, Translation_excluded);

  var _useTranslation = useTranslation(ns, options),
      _useTranslation2 = _slicedToArray(_useTranslation, 3),
      t = _useTranslation2[0],
      i18n = _useTranslation2[1],
      ready = _useTranslation2[2];

  return children(t, {
    i18n: i18n,
    lng: i18n.language
  }, ready);
}
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/I18nextProvider.js


function I18nextProvider(_ref) {
  var i18n = _ref.i18n,
      defaultNS = _ref.defaultNS,
      children = _ref.children;
  var value = useMemo(function () {
    return {
      i18n: i18n,
      defaultNS: defaultNS
    };
  }, [i18n, defaultNS]);
  return createElement(I18nContext.Provider, {
    value: value
  }, children);
}
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/useSSR.js


function useSSR_useSSR(initialI18nStore, initialLanguage) {
  var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var i18nFromProps = props.i18n;

  var _ref = useContext(I18nContext) || {},
      i18nFromContext = _ref.i18n;

  var i18n = i18nFromProps || i18nFromContext || getI18n();
  if (i18n.options && i18n.options.isClone) return;

  if (initialI18nStore && !i18n.initializedStoreOnce) {
    i18n.services.resourceStore.data = initialI18nStore;
    i18n.options.ns = Object.values(initialI18nStore).reduce(function (mem, lngResources) {
      Object.keys(lngResources).forEach(function (ns) {
        if (mem.indexOf(ns) < 0) mem.push(ns);
      });
      return mem;
    }, i18n.options.ns);
    i18n.initializedStoreOnce = true;
    i18n.isInitialized = true;
  }

  if (initialLanguage && !i18n.initializedLanguageOnce) {
    i18n.changeLanguage(initialLanguage);
    i18n.initializedLanguageOnce = true;
  }
}
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/withSSR.js


var withSSR_excluded = (/* unused pure expression or super */ null && (["initialI18nStore", "initialLanguage"]));

function withSSR_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function withSSR_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { withSSR_ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { withSSR_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





function withSSR() {
  return function Extend(WrappedComponent) {
    function I18nextWithSSR(_ref) {
      var initialI18nStore = _ref.initialI18nStore,
          initialLanguage = _ref.initialLanguage,
          rest = _objectWithoutProperties(_ref, withSSR_excluded);

      useSSR(initialI18nStore, initialLanguage);
      return createElement(WrappedComponent, withSSR_objectSpread({}, rest));
    }

    I18nextWithSSR.getInitialProps = composeInitialProps(WrappedComponent);
    I18nextWithSSR.displayName = "withI18nextSSR(".concat(getDisplayName(WrappedComponent), ")");
    I18nextWithSSR.WrappedComponent = WrappedComponent;
    return I18nextWithSSR;
  };
}
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/index.js












var date = function date() {
  return '';
};
var time = function time() {
  return '';
};
var number = function number() {
  return '';
};
var es_select = function select() {
  return '';
};
var plural = function plural() {
  return '';
};
var selectOrdinal = function selectOrdinal() {
  return '';
};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,179], function() { return __webpack_exec__(23837), __webpack_exec__(80880); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);